(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e34"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e34"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyxfS", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ef70c7655f3af47b$export$ffb0004e005737fa; }, function (v) { return $ef70c7655f3af47b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ef70c7655f3af47b$export$34b9dba7ce09269b; }, function (v) { return $ef70c7655f3af47b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ef70c7655f3af47b$export$25062201e9e25d76; }, function (v) { return $ef70c7655f3af47b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef70c7655f3af47b$export$ffb0004e005737fa;
var $ef70c7655f3af47b$export$34b9dba7ce09269b;
var $ef70c7655f3af47b$export$25062201e9e25d76;
'use strict';

var $hAGkE = parcelRequire("hAGkE");
var $ef70c7655f3af47b$var$k = Symbol["for"]("react.element"), $ef70c7655f3af47b$var$l = Symbol["for"]("react.fragment"), $ef70c7655f3af47b$var$m = Object.prototype.hasOwnProperty, $ef70c7655f3af47b$var$n = $hAGkE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ef70c7655f3af47b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ef70c7655f3af47b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ef70c7655f3af47b$var$m.call(a, b) && !$ef70c7655f3af47b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ef70c7655f3af47b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ef70c7655f3af47b$var$n.current
    };
}
$ef70c7655f3af47b$export$ffb0004e005737fa = $ef70c7655f3af47b$var$l;
$ef70c7655f3af47b$export$34b9dba7ce09269b = $ef70c7655f3af47b$var$q;
$ef70c7655f3af47b$export$25062201e9e25d76 = $ef70c7655f3af47b$var$q;

});
parcelRegister("hAGkE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6W2Eq"));

});
parcelRegister("6W2Eq", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $014d958980a9cacd$export$dca3b0875bd9a954; }, function (v) { return $014d958980a9cacd$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $014d958980a9cacd$export$16fa2f45be04daa8; }, function (v) { return $014d958980a9cacd$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $014d958980a9cacd$export$ffb0004e005737fa; }, function (v) { return $014d958980a9cacd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $014d958980a9cacd$export$e2c29f18771995cb; }, function (v) { return $014d958980a9cacd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $014d958980a9cacd$export$221d75b3f55bb0bd; }, function (v) { return $014d958980a9cacd$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $014d958980a9cacd$export$5f8d39834fd61797; }, function (v) { return $014d958980a9cacd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $014d958980a9cacd$export$74bf444e3cd11ea5; }, function (v) { return $014d958980a9cacd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $014d958980a9cacd$export$ae55be85d98224ed; }, function (v) { return $014d958980a9cacd$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $014d958980a9cacd$export$3ba232387fd5d6dd; }, function (v) { return $014d958980a9cacd$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $014d958980a9cacd$export$e530037191fcd5d7; }, function (v) { return $014d958980a9cacd$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $014d958980a9cacd$export$fd42f52fd3ae1109; }, function (v) { return $014d958980a9cacd$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $014d958980a9cacd$export$c8a8987d4410bf2d; }, function (v) { return $014d958980a9cacd$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $014d958980a9cacd$export$d38cd72104c1f0e9; }, function (v) { return $014d958980a9cacd$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $014d958980a9cacd$export$7d1e3a5e95ceca43; }, function (v) { return $014d958980a9cacd$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $014d958980a9cacd$export$257a8862b851cb5b; }, function (v) { return $014d958980a9cacd$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $014d958980a9cacd$export$a8257692ac88316c; }, function (v) { return $014d958980a9cacd$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $014d958980a9cacd$export$488013bae63b21da; }, function (v) { return $014d958980a9cacd$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $014d958980a9cacd$export$7c73462e0d25e514; }, function (v) { return $014d958980a9cacd$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $014d958980a9cacd$export$7568632d0d33d16d; }, function (v) { return $014d958980a9cacd$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $014d958980a9cacd$export$88948ce120ea2619; }, function (v) { return $014d958980a9cacd$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $014d958980a9cacd$export$35808ee640e87ca7; }, function (v) { return $014d958980a9cacd$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $014d958980a9cacd$export$fae74005e78b1a27; }, function (v) { return $014d958980a9cacd$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $014d958980a9cacd$export$dc8fbce3eb94dc1e; }, function (v) { return $014d958980a9cacd$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $014d958980a9cacd$export$6a7bc4e911dc01cf; }, function (v) { return $014d958980a9cacd$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $014d958980a9cacd$export$6d9c69b0de29b591; }, function (v) { return $014d958980a9cacd$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $014d958980a9cacd$export$f680877a34711e37; }, function (v) { return $014d958980a9cacd$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $014d958980a9cacd$export$d5a552a76deda3c2; }, function (v) { return $014d958980a9cacd$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $014d958980a9cacd$export$aaabe4eda9ed9969; }, function (v) { return $014d958980a9cacd$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $014d958980a9cacd$export$e5c5a5f917a5871c; }, function (v) { return $014d958980a9cacd$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $014d958980a9cacd$export$1538c33de8887b59; }, function (v) { return $014d958980a9cacd$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $014d958980a9cacd$export$13e3392192263954; }, function (v) { return $014d958980a9cacd$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $014d958980a9cacd$export$b8f5890fc79d6aca; }, function (v) { return $014d958980a9cacd$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $014d958980a9cacd$export$60241385465d0a34; }, function (v) { return $014d958980a9cacd$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $014d958980a9cacd$export$306c0aa65ff9ec16; }, function (v) { return $014d958980a9cacd$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $014d958980a9cacd$export$7b286972b8d8ccbf; }, function (v) { return $014d958980a9cacd$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $014d958980a9cacd$export$83d89fbfd8236492; }, function (v) { return $014d958980a9cacd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2xTNA = parcelRequire("2xTNA");
var $014d958980a9cacd$export$dca3b0875bd9a954;
var $014d958980a9cacd$export$16fa2f45be04daa8;
var $014d958980a9cacd$export$ffb0004e005737fa;
var $014d958980a9cacd$export$e2c29f18771995cb;
var $014d958980a9cacd$export$221d75b3f55bb0bd;
var $014d958980a9cacd$export$5f8d39834fd61797;
var $014d958980a9cacd$export$74bf444e3cd11ea5;
var $014d958980a9cacd$export$ae55be85d98224ed;
var $014d958980a9cacd$export$3ba232387fd5d6dd;
var $014d958980a9cacd$export$e530037191fcd5d7;
var $014d958980a9cacd$export$fd42f52fd3ae1109;
var $014d958980a9cacd$export$c8a8987d4410bf2d;
var $014d958980a9cacd$export$d38cd72104c1f0e9;
var $014d958980a9cacd$export$7d1e3a5e95ceca43;
var $014d958980a9cacd$export$257a8862b851cb5b;
var $014d958980a9cacd$export$a8257692ac88316c;
var $014d958980a9cacd$export$488013bae63b21da;
var $014d958980a9cacd$export$7c73462e0d25e514;
var $014d958980a9cacd$export$7568632d0d33d16d;
var $014d958980a9cacd$export$88948ce120ea2619;
var $014d958980a9cacd$export$35808ee640e87ca7;
var $014d958980a9cacd$export$fae74005e78b1a27;
var $014d958980a9cacd$export$dc8fbce3eb94dc1e;
var $014d958980a9cacd$export$6a7bc4e911dc01cf;
var $014d958980a9cacd$export$6d9c69b0de29b591;
var $014d958980a9cacd$export$f680877a34711e37;
var $014d958980a9cacd$export$d5a552a76deda3c2;
var $014d958980a9cacd$export$aaabe4eda9ed9969;
var $014d958980a9cacd$export$e5c5a5f917a5871c;
var $014d958980a9cacd$export$1538c33de8887b59;
var $014d958980a9cacd$export$13e3392192263954;
var $014d958980a9cacd$export$b8f5890fc79d6aca;
var $014d958980a9cacd$export$60241385465d0a34;
var $014d958980a9cacd$export$306c0aa65ff9ec16;
var $014d958980a9cacd$export$7b286972b8d8ccbf;
var $014d958980a9cacd$export$83d89fbfd8236492;
'use strict';
var $014d958980a9cacd$var$l = Symbol["for"]("react.element"), $014d958980a9cacd$var$n = Symbol["for"]("react.portal"), $014d958980a9cacd$var$p = Symbol["for"]("react.fragment"), $014d958980a9cacd$var$q = Symbol["for"]("react.strict_mode"), $014d958980a9cacd$var$r = Symbol["for"]("react.profiler"), $014d958980a9cacd$var$t = Symbol["for"]("react.provider"), $014d958980a9cacd$var$u = Symbol["for"]("react.context"), $014d958980a9cacd$var$v = Symbol["for"]("react.forward_ref"), $014d958980a9cacd$var$w = Symbol["for"]("react.suspense"), $014d958980a9cacd$var$x = Symbol["for"]("react.memo"), $014d958980a9cacd$var$y = Symbol["for"]("react.lazy"), $014d958980a9cacd$var$z = Symbol.iterator;
function $014d958980a9cacd$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a))) return null;
    a = $014d958980a9cacd$var$z && a[$014d958980a9cacd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $014d958980a9cacd$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $014d958980a9cacd$var$C = Object.assign, $014d958980a9cacd$var$D = {};
function $014d958980a9cacd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $014d958980a9cacd$var$D;
    this.updater = e || $014d958980a9cacd$var$B;
}
$014d958980a9cacd$var$E.prototype.isReactComponent = {};
$014d958980a9cacd$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$014d958980a9cacd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $014d958980a9cacd$var$F() {}
$014d958980a9cacd$var$F.prototype = $014d958980a9cacd$var$E.prototype;
function $014d958980a9cacd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $014d958980a9cacd$var$D;
    this.updater = e || $014d958980a9cacd$var$B;
}
var $014d958980a9cacd$var$H = $014d958980a9cacd$var$G.prototype = new $014d958980a9cacd$var$F;
$014d958980a9cacd$var$H.constructor = $014d958980a9cacd$var$G;
$014d958980a9cacd$var$C($014d958980a9cacd$var$H, $014d958980a9cacd$var$E.prototype);
$014d958980a9cacd$var$H.isPureReactComponent = !0;
var $014d958980a9cacd$var$I = Array.isArray, $014d958980a9cacd$var$J = Object.prototype.hasOwnProperty, $014d958980a9cacd$var$K = {
    current: null
}, $014d958980a9cacd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $014d958980a9cacd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$014d958980a9cacd$var$J.call(b, d) && !$014d958980a9cacd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $014d958980a9cacd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $014d958980a9cacd$var$K.current
    };
}
function $014d958980a9cacd$var$N(a, b) {
    return {
        $$typeof: $014d958980a9cacd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $014d958980a9cacd$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && a.$$typeof === $014d958980a9cacd$var$l;
}
function $014d958980a9cacd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $014d958980a9cacd$var$P = /\/+/g;
function $014d958980a9cacd$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && null != a.key ? $014d958980a9cacd$var$escape("" + a.key) : b.toString(36);
}
function $014d958980a9cacd$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $014d958980a9cacd$var$l:
                case $014d958980a9cacd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $014d958980a9cacd$var$Q(h, 0) : d, $014d958980a9cacd$var$I(c) ? (e = "", null != a && (e = a.replace($014d958980a9cacd$var$P, "$&/") + "/"), $014d958980a9cacd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($014d958980a9cacd$var$O(c) && (c = $014d958980a9cacd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($014d958980a9cacd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($014d958980a9cacd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $014d958980a9cacd$var$Q(k, g);
        h += $014d958980a9cacd$var$R(k, b, e, f, c);
    }
    else if (f = $014d958980a9cacd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $014d958980a9cacd$var$Q(k, g++), h += $014d958980a9cacd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $014d958980a9cacd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $014d958980a9cacd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $014d958980a9cacd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result["default"];
    throw a._result;
}
var $014d958980a9cacd$var$U = {
    current: null
}, $014d958980a9cacd$var$V = {
    transition: null
}, $014d958980a9cacd$var$W = {
    ReactCurrentDispatcher: $014d958980a9cacd$var$U,
    ReactCurrentBatchConfig: $014d958980a9cacd$var$V,
    ReactCurrentOwner: $014d958980a9cacd$var$K
};
function $014d958980a9cacd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$014d958980a9cacd$export$dca3b0875bd9a954 = {
    map: $014d958980a9cacd$var$S,
    forEach: function forEach(a, b, e) {
        $014d958980a9cacd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $014d958980a9cacd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $014d958980a9cacd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$014d958980a9cacd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$014d958980a9cacd$export$16fa2f45be04daa8 = $014d958980a9cacd$var$E;
$014d958980a9cacd$export$ffb0004e005737fa = $014d958980a9cacd$var$p;
$014d958980a9cacd$export$e2c29f18771995cb = $014d958980a9cacd$var$r;
$014d958980a9cacd$export$221d75b3f55bb0bd = $014d958980a9cacd$var$G;
$014d958980a9cacd$export$5f8d39834fd61797 = $014d958980a9cacd$var$q;
$014d958980a9cacd$export$74bf444e3cd11ea5 = $014d958980a9cacd$var$w;
$014d958980a9cacd$export$ae55be85d98224ed = $014d958980a9cacd$var$W;
$014d958980a9cacd$export$3ba232387fd5d6dd = $014d958980a9cacd$var$X;
$014d958980a9cacd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $014d958980a9cacd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $014d958980a9cacd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$014d958980a9cacd$var$J.call(b, f) && !$014d958980a9cacd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $014d958980a9cacd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$014d958980a9cacd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $014d958980a9cacd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $014d958980a9cacd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$014d958980a9cacd$export$c8a8987d4410bf2d = $014d958980a9cacd$var$M;
$014d958980a9cacd$export$d38cd72104c1f0e9 = function(a) {
    var b = $014d958980a9cacd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$014d958980a9cacd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$014d958980a9cacd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $014d958980a9cacd$var$v,
        render: a
    };
};
$014d958980a9cacd$export$a8257692ac88316c = $014d958980a9cacd$var$O;
$014d958980a9cacd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $014d958980a9cacd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $014d958980a9cacd$var$T
    };
};
$014d958980a9cacd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $014d958980a9cacd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$014d958980a9cacd$export$7568632d0d33d16d = function(a) {
    var b = $014d958980a9cacd$var$V.transition;
    $014d958980a9cacd$var$V.transition = {};
    try {
        a();
    } finally{
        $014d958980a9cacd$var$V.transition = b;
    }
};
$014d958980a9cacd$export$88948ce120ea2619 = $014d958980a9cacd$var$X;
$014d958980a9cacd$export$35808ee640e87ca7 = function(a, b) {
    return $014d958980a9cacd$var$U.current.useCallback(a, b);
};
$014d958980a9cacd$export$fae74005e78b1a27 = function(a) {
    return $014d958980a9cacd$var$U.current.useContext(a);
};
$014d958980a9cacd$export$dc8fbce3eb94dc1e = function() {};
$014d958980a9cacd$export$6a7bc4e911dc01cf = function(a) {
    return $014d958980a9cacd$var$U.current.useDeferredValue(a);
};
$014d958980a9cacd$export$6d9c69b0de29b591 = function(a, b) {
    return $014d958980a9cacd$var$U.current.useEffect(a, b);
};
$014d958980a9cacd$export$f680877a34711e37 = function() {
    return $014d958980a9cacd$var$U.current.useId();
};
$014d958980a9cacd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $014d958980a9cacd$var$U.current.useImperativeHandle(a, b, e);
};
$014d958980a9cacd$export$aaabe4eda9ed9969 = function(a, b) {
    return $014d958980a9cacd$var$U.current.useInsertionEffect(a, b);
};
$014d958980a9cacd$export$e5c5a5f917a5871c = function(a, b) {
    return $014d958980a9cacd$var$U.current.useLayoutEffect(a, b);
};
$014d958980a9cacd$export$1538c33de8887b59 = function(a, b) {
    return $014d958980a9cacd$var$U.current.useMemo(a, b);
};
$014d958980a9cacd$export$13e3392192263954 = function(a, b, e) {
    return $014d958980a9cacd$var$U.current.useReducer(a, b, e);
};
$014d958980a9cacd$export$b8f5890fc79d6aca = function(a) {
    return $014d958980a9cacd$var$U.current.useRef(a);
};
$014d958980a9cacd$export$60241385465d0a34 = function(a) {
    return $014d958980a9cacd$var$U.current.useState(a);
};
$014d958980a9cacd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $014d958980a9cacd$var$U.current.useSyncExternalStore(a, b, e);
};
$014d958980a9cacd$export$7b286972b8d8ccbf = function() {
    return $014d958980a9cacd$var$U.current.useTransition();
};
$014d958980a9cacd$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("2xTNA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1da9f250c262e397$export$71511d61b312f219; });
function $1da9f250c262e397$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("aFmG0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7c3f52cf960380f5$export$ae55be85d98224ed; }, function (v) { return $7c3f52cf960380f5$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $7c3f52cf960380f5$export$d39a5bbd09211389; }, function (v) { return $7c3f52cf960380f5$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $7c3f52cf960380f5$export$882461b6382ed46c; }, function (v) { return $7c3f52cf960380f5$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $7c3f52cf960380f5$export$466bfc07425424d5; }, function (v) { return $7c3f52cf960380f5$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $7c3f52cf960380f5$export$cd75ccfd720a3cd4; }, function (v) { return $7c3f52cf960380f5$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $7c3f52cf960380f5$export$fa8d919ba61d84db; }, function (v) { return $7c3f52cf960380f5$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $7c3f52cf960380f5$export$757ceba2d55c277e; }, function (v) { return $7c3f52cf960380f5$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $7c3f52cf960380f5$export$b3890eb0ae9dca99; }, function (v) { return $7c3f52cf960380f5$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $7c3f52cf960380f5$export$502457920280e6be; }, function (v) { return $7c3f52cf960380f5$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $7c3f52cf960380f5$export$c78a37762a8d58e1; }, function (v) { return $7c3f52cf960380f5$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $7c3f52cf960380f5$export$dc54d992c10e8a18; }, function (v) { return $7c3f52cf960380f5$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $7c3f52cf960380f5$export$83d89fbfd8236492; }, function (v) { return $7c3f52cf960380f5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $2xTNA = parcelRequire("2xTNA");
var $7c3f52cf960380f5$export$ae55be85d98224ed;
var $7c3f52cf960380f5$export$d39a5bbd09211389;
var $7c3f52cf960380f5$export$882461b6382ed46c;
var $7c3f52cf960380f5$export$466bfc07425424d5;
var $7c3f52cf960380f5$export$cd75ccfd720a3cd4;
var $7c3f52cf960380f5$export$fa8d919ba61d84db;
var $7c3f52cf960380f5$export$757ceba2d55c277e;
var $7c3f52cf960380f5$export$b3890eb0ae9dca99;
var $7c3f52cf960380f5$export$502457920280e6be;
var $7c3f52cf960380f5$export$c78a37762a8d58e1;
var $7c3f52cf960380f5$export$dc54d992c10e8a18;
var $7c3f52cf960380f5$export$83d89fbfd8236492;
'use strict';

var $hAGkE = parcelRequire("hAGkE");

var $gIYIQ = parcelRequire("gIYIQ");
function $7c3f52cf960380f5$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $7c3f52cf960380f5$var$da = new Set, $7c3f52cf960380f5$var$ea = {};
function $7c3f52cf960380f5$var$fa(a, b) {
    $7c3f52cf960380f5$var$ha(a, b);
    $7c3f52cf960380f5$var$ha(a + "Capture", b);
}
function $7c3f52cf960380f5$var$ha(a, b) {
    $7c3f52cf960380f5$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$7c3f52cf960380f5$var$da.add(b[a]);
}
var $7c3f52cf960380f5$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $7c3f52cf960380f5$var$ja = Object.prototype.hasOwnProperty, $7c3f52cf960380f5$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $7c3f52cf960380f5$var$la = {}, $7c3f52cf960380f5$var$ma = {};
function $7c3f52cf960380f5$var$oa(a) {
    if ($7c3f52cf960380f5$var$ja.call($7c3f52cf960380f5$var$ma, a)) return !0;
    if ($7c3f52cf960380f5$var$ja.call($7c3f52cf960380f5$var$la, a)) return !1;
    if ($7c3f52cf960380f5$var$ka.test(a)) return $7c3f52cf960380f5$var$ma[a] = !0;
    $7c3f52cf960380f5$var$la[a] = !0;
    return !1;
}
function $7c3f52cf960380f5$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $2xTNA._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $7c3f52cf960380f5$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $7c3f52cf960380f5$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $7c3f52cf960380f5$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $7c3f52cf960380f5$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $7c3f52cf960380f5$var$z[b] = new $7c3f52cf960380f5$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $7c3f52cf960380f5$var$ra = /[\-:]([a-z])/g;
function $7c3f52cf960380f5$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($7c3f52cf960380f5$var$ra, $7c3f52cf960380f5$var$sa);
    $7c3f52cf960380f5$var$z[b] = new $7c3f52cf960380f5$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($7c3f52cf960380f5$var$ra, $7c3f52cf960380f5$var$sa);
    $7c3f52cf960380f5$var$z[b] = new $7c3f52cf960380f5$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($7c3f52cf960380f5$var$ra, $7c3f52cf960380f5$var$sa);
    $7c3f52cf960380f5$var$z[b] = new $7c3f52cf960380f5$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$7c3f52cf960380f5$var$z.xlinkHref = new $7c3f52cf960380f5$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $7c3f52cf960380f5$var$z[a] = new $7c3f52cf960380f5$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $7c3f52cf960380f5$var$ta(a, b, c, d) {
    var e = $7c3f52cf960380f5$var$z.hasOwnProperty(b) ? $7c3f52cf960380f5$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $7c3f52cf960380f5$var$qa(b, c, e, d) && (c = null), d || null === e ? $7c3f52cf960380f5$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $7c3f52cf960380f5$var$ua = $hAGkE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $7c3f52cf960380f5$var$va = Symbol["for"]("react.element"), $7c3f52cf960380f5$var$wa = Symbol["for"]("react.portal"), $7c3f52cf960380f5$var$ya = Symbol["for"]("react.fragment"), $7c3f52cf960380f5$var$za = Symbol["for"]("react.strict_mode"), $7c3f52cf960380f5$var$Aa = Symbol["for"]("react.profiler"), $7c3f52cf960380f5$var$Ba = Symbol["for"]("react.provider"), $7c3f52cf960380f5$var$Ca = Symbol["for"]("react.context"), $7c3f52cf960380f5$var$Da = Symbol["for"]("react.forward_ref"), $7c3f52cf960380f5$var$Ea = Symbol["for"]("react.suspense"), $7c3f52cf960380f5$var$Fa = Symbol["for"]("react.suspense_list"), $7c3f52cf960380f5$var$Ga = Symbol["for"]("react.memo"), $7c3f52cf960380f5$var$Ha = Symbol["for"]("react.lazy");
Symbol["for"]("react.scope");
Symbol["for"]("react.debug_trace_mode");
var $7c3f52cf960380f5$var$Ia = Symbol["for"]("react.offscreen");
Symbol["for"]("react.legacy_hidden");
Symbol["for"]("react.cache");
Symbol["for"]("react.tracing_marker");
var $7c3f52cf960380f5$var$Ja = Symbol.iterator;
function $7c3f52cf960380f5$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a))) return null;
    a = $7c3f52cf960380f5$var$Ja && a[$7c3f52cf960380f5$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7c3f52cf960380f5$var$A = Object.assign, $7c3f52cf960380f5$var$La;
function $7c3f52cf960380f5$var$Ma(a) {
    if (void 0 === $7c3f52cf960380f5$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $7c3f52cf960380f5$var$La = b && b[1] || "";
    }
    return "\n" + $7c3f52cf960380f5$var$La + a;
}
var $7c3f52cf960380f5$var$Na = !1;
function $7c3f52cf960380f5$var$Oa(a, b) {
    if (!a || $7c3f52cf960380f5$var$Na) return "";
    $7c3f52cf960380f5$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $2xTNA._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $7c3f52cf960380f5$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $7c3f52cf960380f5$var$Ma(a) : "";
}
function $7c3f52cf960380f5$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $7c3f52cf960380f5$var$Ma(a.type);
        case 16:
            return $7c3f52cf960380f5$var$Ma("Lazy");
        case 13:
            return $7c3f52cf960380f5$var$Ma("Suspense");
        case 19:
            return $7c3f52cf960380f5$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $7c3f52cf960380f5$var$Oa(a.type, !1), a;
        case 11:
            return a = $7c3f52cf960380f5$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $7c3f52cf960380f5$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $7c3f52cf960380f5$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $7c3f52cf960380f5$var$ya:
            return "Fragment";
        case $7c3f52cf960380f5$var$wa:
            return "Portal";
        case $7c3f52cf960380f5$var$Aa:
            return "Profiler";
        case $7c3f52cf960380f5$var$za:
            return "StrictMode";
        case $7c3f52cf960380f5$var$Ea:
            return "Suspense";
        case $7c3f52cf960380f5$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a))) switch(a.$$typeof){
        case $7c3f52cf960380f5$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $7c3f52cf960380f5$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $7c3f52cf960380f5$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $7c3f52cf960380f5$var$Ga:
            return b = a.displayName || null, null !== b ? b : $7c3f52cf960380f5$var$Qa(a.type) || "Memo";
        case $7c3f52cf960380f5$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $7c3f52cf960380f5$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $7c3f52cf960380f5$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $7c3f52cf960380f5$var$Qa(b);
        case 8:
            return b === $7c3f52cf960380f5$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $7c3f52cf960380f5$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $7c3f52cf960380f5$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $7c3f52cf960380f5$var$Ua(a) {
    var b = $7c3f52cf960380f5$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $7c3f52cf960380f5$var$Va(a) {
    a._valueTracker || (a._valueTracker = $7c3f52cf960380f5$var$Ua(a));
}
function $7c3f52cf960380f5$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $7c3f52cf960380f5$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $7c3f52cf960380f5$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $7c3f52cf960380f5$var$Ya(a, b) {
    var c = b.checked;
    return $7c3f52cf960380f5$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $7c3f52cf960380f5$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $7c3f52cf960380f5$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $7c3f52cf960380f5$var$ab(a, b) {
    b = b.checked;
    null != b && $7c3f52cf960380f5$var$ta(a, "checked", b, !1);
}
function $7c3f52cf960380f5$var$bb(a, b) {
    $7c3f52cf960380f5$var$ab(a, b);
    var c = $7c3f52cf960380f5$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $7c3f52cf960380f5$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $7c3f52cf960380f5$var$cb(a, b.type, $7c3f52cf960380f5$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $7c3f52cf960380f5$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $7c3f52cf960380f5$var$cb(a, b, c) {
    if ("number" !== b || $7c3f52cf960380f5$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $7c3f52cf960380f5$var$eb = Array.isArray;
function $7c3f52cf960380f5$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $7c3f52cf960380f5$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $7c3f52cf960380f5$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($7c3f52cf960380f5$var$p(91));
    return $7c3f52cf960380f5$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $7c3f52cf960380f5$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($7c3f52cf960380f5$var$p(92));
            if ($7c3f52cf960380f5$var$eb(c)) {
                if (1 < c.length) throw Error($7c3f52cf960380f5$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $7c3f52cf960380f5$var$Sa(c)
    };
}
function $7c3f52cf960380f5$var$ib(a, b) {
    var c = $7c3f52cf960380f5$var$Sa(b.value), d = $7c3f52cf960380f5$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $7c3f52cf960380f5$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $7c3f52cf960380f5$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $7c3f52cf960380f5$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $7c3f52cf960380f5$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $7c3f52cf960380f5$var$mb, $7c3f52cf960380f5$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $7c3f52cf960380f5$var$mb = $7c3f52cf960380f5$var$mb || document.createElement("div");
        $7c3f52cf960380f5$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $7c3f52cf960380f5$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $7c3f52cf960380f5$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $7c3f52cf960380f5$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $7c3f52cf960380f5$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($7c3f52cf960380f5$var$pb).forEach(function(a) {
    $7c3f52cf960380f5$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $7c3f52cf960380f5$var$pb[b] = $7c3f52cf960380f5$var$pb[a];
    });
});
function $7c3f52cf960380f5$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $7c3f52cf960380f5$var$pb.hasOwnProperty(a) && $7c3f52cf960380f5$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $7c3f52cf960380f5$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $7c3f52cf960380f5$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $7c3f52cf960380f5$var$tb = $7c3f52cf960380f5$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $7c3f52cf960380f5$var$ub(a, b) {
    if (b) {
        if ($7c3f52cf960380f5$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($7c3f52cf960380f5$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($7c3f52cf960380f5$var$p(60));
            if ("object" !== (0, $2xTNA._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($7c3f52cf960380f5$var$p(61));
        }
        if (null != b.style && "object" !== (0, $2xTNA._)(b.style)) throw Error($7c3f52cf960380f5$var$p(62));
    }
}
function $7c3f52cf960380f5$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $7c3f52cf960380f5$var$wb = null;
function $7c3f52cf960380f5$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $7c3f52cf960380f5$var$yb = null, $7c3f52cf960380f5$var$zb = null, $7c3f52cf960380f5$var$Ab = null;
function $7c3f52cf960380f5$var$Bb(a) {
    if (a = $7c3f52cf960380f5$var$Cb(a)) {
        if ("function" !== typeof $7c3f52cf960380f5$var$yb) throw Error($7c3f52cf960380f5$var$p(280));
        var b = a.stateNode;
        b && (b = $7c3f52cf960380f5$var$Db(b), $7c3f52cf960380f5$var$yb(a.stateNode, a.type, b));
    }
}
function $7c3f52cf960380f5$var$Eb(a) {
    $7c3f52cf960380f5$var$zb ? $7c3f52cf960380f5$var$Ab ? $7c3f52cf960380f5$var$Ab.push(a) : $7c3f52cf960380f5$var$Ab = [
        a
    ] : $7c3f52cf960380f5$var$zb = a;
}
function $7c3f52cf960380f5$var$Fb() {
    if ($7c3f52cf960380f5$var$zb) {
        var a = $7c3f52cf960380f5$var$zb, b = $7c3f52cf960380f5$var$Ab;
        $7c3f52cf960380f5$var$Ab = $7c3f52cf960380f5$var$zb = null;
        $7c3f52cf960380f5$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$7c3f52cf960380f5$var$Bb(b[a]);
    }
}
function $7c3f52cf960380f5$var$Gb(a, b) {
    return a(b);
}
function $7c3f52cf960380f5$var$Hb() {}
var $7c3f52cf960380f5$var$Ib = !1;
function $7c3f52cf960380f5$var$Jb(a, b, c) {
    if ($7c3f52cf960380f5$var$Ib) return a(b, c);
    $7c3f52cf960380f5$var$Ib = !0;
    try {
        return $7c3f52cf960380f5$var$Gb(a, b, c);
    } finally{
        if ($7c3f52cf960380f5$var$Ib = !1, null !== $7c3f52cf960380f5$var$zb || null !== $7c3f52cf960380f5$var$Ab) $7c3f52cf960380f5$var$Hb(), $7c3f52cf960380f5$var$Fb();
    }
}
function $7c3f52cf960380f5$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $7c3f52cf960380f5$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($7c3f52cf960380f5$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $2xTNA._)(c)));
    return c;
}
var $7c3f52cf960380f5$var$Lb = !1;
if ($7c3f52cf960380f5$var$ia) try {
    var $7c3f52cf960380f5$var$Mb = {};
    Object.defineProperty($7c3f52cf960380f5$var$Mb, "passive", {
        get: function get() {
            $7c3f52cf960380f5$var$Lb = !0;
        }
    });
    window.addEventListener("test", $7c3f52cf960380f5$var$Mb, $7c3f52cf960380f5$var$Mb);
    window.removeEventListener("test", $7c3f52cf960380f5$var$Mb, $7c3f52cf960380f5$var$Mb);
} catch (a) {
    $7c3f52cf960380f5$var$Lb = !1;
}
function $7c3f52cf960380f5$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $7c3f52cf960380f5$var$Ob = !1, $7c3f52cf960380f5$var$Pb = null, $7c3f52cf960380f5$var$Qb = !1, $7c3f52cf960380f5$var$Rb = null, $7c3f52cf960380f5$var$Sb = {
    onError: function onError(a) {
        $7c3f52cf960380f5$var$Ob = !0;
        $7c3f52cf960380f5$var$Pb = a;
    }
};
function $7c3f52cf960380f5$var$Tb(a, b, c, d, e, f, g, h, k) {
    $7c3f52cf960380f5$var$Ob = !1;
    $7c3f52cf960380f5$var$Pb = null;
    $7c3f52cf960380f5$var$Nb.apply($7c3f52cf960380f5$var$Sb, arguments);
}
function $7c3f52cf960380f5$var$Ub(a, b, c, d, e, f, g, h, k) {
    $7c3f52cf960380f5$var$Tb.apply(this, arguments);
    if ($7c3f52cf960380f5$var$Ob) {
        if ($7c3f52cf960380f5$var$Ob) {
            var l = $7c3f52cf960380f5$var$Pb;
            $7c3f52cf960380f5$var$Ob = !1;
            $7c3f52cf960380f5$var$Pb = null;
        } else throw Error($7c3f52cf960380f5$var$p(198));
        $7c3f52cf960380f5$var$Qb || ($7c3f52cf960380f5$var$Qb = !0, $7c3f52cf960380f5$var$Rb = l);
    }
}
function $7c3f52cf960380f5$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b["return"];)b = b["return"];
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $7c3f52cf960380f5$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $7c3f52cf960380f5$var$Xb(a) {
    if ($7c3f52cf960380f5$var$Vb(a) !== a) throw Error($7c3f52cf960380f5$var$p(188));
}
function $7c3f52cf960380f5$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $7c3f52cf960380f5$var$Vb(a);
        if (null === b) throw Error($7c3f52cf960380f5$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c["return"];
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e["return"];
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $7c3f52cf960380f5$var$Xb(e), a;
                if (f === d) return $7c3f52cf960380f5$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($7c3f52cf960380f5$var$p(188));
        }
        if (c["return"] !== d["return"]) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($7c3f52cf960380f5$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($7c3f52cf960380f5$var$p(190));
    }
    if (3 !== c.tag) throw Error($7c3f52cf960380f5$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $7c3f52cf960380f5$var$Zb(a) {
    a = $7c3f52cf960380f5$var$Yb(a);
    return null !== a ? $7c3f52cf960380f5$var$$b(a) : null;
}
function $7c3f52cf960380f5$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $7c3f52cf960380f5$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $7c3f52cf960380f5$var$ac = $gIYIQ.unstable_scheduleCallback, $7c3f52cf960380f5$var$bc = $gIYIQ.unstable_cancelCallback, $7c3f52cf960380f5$var$cc = $gIYIQ.unstable_shouldYield, $7c3f52cf960380f5$var$dc = $gIYIQ.unstable_requestPaint, $7c3f52cf960380f5$var$B = $gIYIQ.unstable_now, $7c3f52cf960380f5$var$ec = $gIYIQ.unstable_getCurrentPriorityLevel, $7c3f52cf960380f5$var$fc = $gIYIQ.unstable_ImmediatePriority, $7c3f52cf960380f5$var$gc = $gIYIQ.unstable_UserBlockingPriority, $7c3f52cf960380f5$var$hc = $gIYIQ.unstable_NormalPriority, $7c3f52cf960380f5$var$ic = $gIYIQ.unstable_LowPriority, $7c3f52cf960380f5$var$jc = $gIYIQ.unstable_IdlePriority, $7c3f52cf960380f5$var$kc = null, $7c3f52cf960380f5$var$lc = null;
function $7c3f52cf960380f5$var$mc(a) {
    if ($7c3f52cf960380f5$var$lc && "function" === typeof $7c3f52cf960380f5$var$lc.onCommitFiberRoot) try {
        $7c3f52cf960380f5$var$lc.onCommitFiberRoot($7c3f52cf960380f5$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $7c3f52cf960380f5$var$oc = Math.clz32 ? Math.clz32 : $7c3f52cf960380f5$var$nc, $7c3f52cf960380f5$var$pc = Math.log, $7c3f52cf960380f5$var$qc = Math.LN2;
function $7c3f52cf960380f5$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($7c3f52cf960380f5$var$pc(a) / $7c3f52cf960380f5$var$qc | 0) | 0;
}
var $7c3f52cf960380f5$var$rc = 64, $7c3f52cf960380f5$var$sc = 4194304;
function $7c3f52cf960380f5$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $7c3f52cf960380f5$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $7c3f52cf960380f5$var$tc(h) : (f &= g, 0 !== f && (d = $7c3f52cf960380f5$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $7c3f52cf960380f5$var$tc(g) : 0 !== f && (d = $7c3f52cf960380f5$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $7c3f52cf960380f5$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $7c3f52cf960380f5$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $7c3f52cf960380f5$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $7c3f52cf960380f5$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $7c3f52cf960380f5$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $7c3f52cf960380f5$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $7c3f52cf960380f5$var$yc() {
    var a = $7c3f52cf960380f5$var$rc;
    $7c3f52cf960380f5$var$rc <<= 1;
    0 === ($7c3f52cf960380f5$var$rc & 4194240) && ($7c3f52cf960380f5$var$rc = 64);
    return a;
}
function $7c3f52cf960380f5$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $7c3f52cf960380f5$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $7c3f52cf960380f5$var$oc(b);
    a[b] = c;
}
function $7c3f52cf960380f5$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $7c3f52cf960380f5$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $7c3f52cf960380f5$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $7c3f52cf960380f5$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $7c3f52cf960380f5$var$C = 0;
function $7c3f52cf960380f5$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $7c3f52cf960380f5$var$Ec, $7c3f52cf960380f5$var$Fc, $7c3f52cf960380f5$var$Gc, $7c3f52cf960380f5$var$Hc, $7c3f52cf960380f5$var$Ic, $7c3f52cf960380f5$var$Jc = !1, $7c3f52cf960380f5$var$Kc = [], $7c3f52cf960380f5$var$Lc = null, $7c3f52cf960380f5$var$Mc = null, $7c3f52cf960380f5$var$Nc = null, $7c3f52cf960380f5$var$Oc = new Map, $7c3f52cf960380f5$var$Pc = new Map, $7c3f52cf960380f5$var$Qc = [], $7c3f52cf960380f5$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $7c3f52cf960380f5$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $7c3f52cf960380f5$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $7c3f52cf960380f5$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $7c3f52cf960380f5$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $7c3f52cf960380f5$var$Oc["delete"](b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $7c3f52cf960380f5$var$Pc["delete"](b.pointerId);
    }
}
function $7c3f52cf960380f5$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $7c3f52cf960380f5$var$Cb(b), null !== b && $7c3f52cf960380f5$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $7c3f52cf960380f5$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $7c3f52cf960380f5$var$Lc = $7c3f52cf960380f5$var$Tc($7c3f52cf960380f5$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $7c3f52cf960380f5$var$Mc = $7c3f52cf960380f5$var$Tc($7c3f52cf960380f5$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $7c3f52cf960380f5$var$Nc = $7c3f52cf960380f5$var$Tc($7c3f52cf960380f5$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $7c3f52cf960380f5$var$Oc.set(f, $7c3f52cf960380f5$var$Tc($7c3f52cf960380f5$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $7c3f52cf960380f5$var$Pc.set(f, $7c3f52cf960380f5$var$Tc($7c3f52cf960380f5$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $7c3f52cf960380f5$var$Vc(a) {
    var b = $7c3f52cf960380f5$var$Wc(a.target);
    if (null !== b) {
        var c = $7c3f52cf960380f5$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $7c3f52cf960380f5$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $7c3f52cf960380f5$var$Ic(a.priority, function() {
                        $7c3f52cf960380f5$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $7c3f52cf960380f5$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $7c3f52cf960380f5$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $7c3f52cf960380f5$var$wb = d;
            c.target.dispatchEvent(d);
            $7c3f52cf960380f5$var$wb = null;
        } else return b = $7c3f52cf960380f5$var$Cb(c), null !== b && $7c3f52cf960380f5$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $7c3f52cf960380f5$var$Zc(a, b, c) {
    $7c3f52cf960380f5$var$Xc(a) && c["delete"](b);
}
function $7c3f52cf960380f5$var$$c() {
    $7c3f52cf960380f5$var$Jc = !1;
    null !== $7c3f52cf960380f5$var$Lc && $7c3f52cf960380f5$var$Xc($7c3f52cf960380f5$var$Lc) && ($7c3f52cf960380f5$var$Lc = null);
    null !== $7c3f52cf960380f5$var$Mc && $7c3f52cf960380f5$var$Xc($7c3f52cf960380f5$var$Mc) && ($7c3f52cf960380f5$var$Mc = null);
    null !== $7c3f52cf960380f5$var$Nc && $7c3f52cf960380f5$var$Xc($7c3f52cf960380f5$var$Nc) && ($7c3f52cf960380f5$var$Nc = null);
    $7c3f52cf960380f5$var$Oc.forEach($7c3f52cf960380f5$var$Zc);
    $7c3f52cf960380f5$var$Pc.forEach($7c3f52cf960380f5$var$Zc);
}
function $7c3f52cf960380f5$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $7c3f52cf960380f5$var$Jc || ($7c3f52cf960380f5$var$Jc = !0, $gIYIQ.unstable_scheduleCallback($gIYIQ.unstable_NormalPriority, $7c3f52cf960380f5$var$$c)));
}
function $7c3f52cf960380f5$var$bd(a) {
    function b(b) {
        return $7c3f52cf960380f5$var$ad(b, a);
    }
    if (0 < $7c3f52cf960380f5$var$Kc.length) {
        $7c3f52cf960380f5$var$ad($7c3f52cf960380f5$var$Kc[0], a);
        for(var c = 1; c < $7c3f52cf960380f5$var$Kc.length; c++){
            var d = $7c3f52cf960380f5$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $7c3f52cf960380f5$var$Lc && $7c3f52cf960380f5$var$ad($7c3f52cf960380f5$var$Lc, a);
    null !== $7c3f52cf960380f5$var$Mc && $7c3f52cf960380f5$var$ad($7c3f52cf960380f5$var$Mc, a);
    null !== $7c3f52cf960380f5$var$Nc && $7c3f52cf960380f5$var$ad($7c3f52cf960380f5$var$Nc, a);
    $7c3f52cf960380f5$var$Oc.forEach(b);
    $7c3f52cf960380f5$var$Pc.forEach(b);
    for(c = 0; c < $7c3f52cf960380f5$var$Qc.length; c++)d = $7c3f52cf960380f5$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $7c3f52cf960380f5$var$Qc.length && (c = $7c3f52cf960380f5$var$Qc[0], null === c.blockedOn);)$7c3f52cf960380f5$var$Vc(c), null === c.blockedOn && $7c3f52cf960380f5$var$Qc.shift();
}
var $7c3f52cf960380f5$var$cd = $7c3f52cf960380f5$var$ua.ReactCurrentBatchConfig, $7c3f52cf960380f5$var$dd = !0;
function $7c3f52cf960380f5$var$ed(a, b, c, d) {
    var e = $7c3f52cf960380f5$var$C, f = $7c3f52cf960380f5$var$cd.transition;
    $7c3f52cf960380f5$var$cd.transition = null;
    try {
        $7c3f52cf960380f5$var$C = 1, $7c3f52cf960380f5$var$fd(a, b, c, d);
    } finally{
        $7c3f52cf960380f5$var$C = e, $7c3f52cf960380f5$var$cd.transition = f;
    }
}
function $7c3f52cf960380f5$var$gd(a, b, c, d) {
    var e = $7c3f52cf960380f5$var$C, f = $7c3f52cf960380f5$var$cd.transition;
    $7c3f52cf960380f5$var$cd.transition = null;
    try {
        $7c3f52cf960380f5$var$C = 4, $7c3f52cf960380f5$var$fd(a, b, c, d);
    } finally{
        $7c3f52cf960380f5$var$C = e, $7c3f52cf960380f5$var$cd.transition = f;
    }
}
function $7c3f52cf960380f5$var$fd(a, b, c, d) {
    if ($7c3f52cf960380f5$var$dd) {
        var e = $7c3f52cf960380f5$var$Yc(a, b, c, d);
        if (null === e) $7c3f52cf960380f5$var$hd(a, b, d, $7c3f52cf960380f5$var$id, c), $7c3f52cf960380f5$var$Sc(a, d);
        else if ($7c3f52cf960380f5$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($7c3f52cf960380f5$var$Sc(a, d), b & 4 && -1 < $7c3f52cf960380f5$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $7c3f52cf960380f5$var$Cb(e);
                null !== f && $7c3f52cf960380f5$var$Ec(f);
                f = $7c3f52cf960380f5$var$Yc(a, b, c, d);
                null === f && $7c3f52cf960380f5$var$hd(a, b, d, $7c3f52cf960380f5$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $7c3f52cf960380f5$var$hd(a, b, d, null, c);
    }
}
var $7c3f52cf960380f5$var$id = null;
function $7c3f52cf960380f5$var$Yc(a, b, c, d) {
    $7c3f52cf960380f5$var$id = null;
    a = $7c3f52cf960380f5$var$xb(d);
    a = $7c3f52cf960380f5$var$Wc(a);
    if (null !== a) {
        if (b = $7c3f52cf960380f5$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $7c3f52cf960380f5$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $7c3f52cf960380f5$var$id = a;
    return null;
}
function $7c3f52cf960380f5$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($7c3f52cf960380f5$var$ec()){
                case $7c3f52cf960380f5$var$fc:
                    return 1;
                case $7c3f52cf960380f5$var$gc:
                    return 4;
                case $7c3f52cf960380f5$var$hc:
                case $7c3f52cf960380f5$var$ic:
                    return 16;
                case $7c3f52cf960380f5$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $7c3f52cf960380f5$var$kd = null, $7c3f52cf960380f5$var$ld = null, $7c3f52cf960380f5$var$md = null;
function $7c3f52cf960380f5$var$nd() {
    if ($7c3f52cf960380f5$var$md) return $7c3f52cf960380f5$var$md;
    var a, b = $7c3f52cf960380f5$var$ld, c = b.length, d, e = "value" in $7c3f52cf960380f5$var$kd ? $7c3f52cf960380f5$var$kd.value : $7c3f52cf960380f5$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $7c3f52cf960380f5$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $7c3f52cf960380f5$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $7c3f52cf960380f5$var$pd() {
    return !0;
}
function $7c3f52cf960380f5$var$qd() {
    return !1;
}
function $7c3f52cf960380f5$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $7c3f52cf960380f5$var$pd : $7c3f52cf960380f5$var$qd;
        this.isPropagationStopped = $7c3f52cf960380f5$var$qd;
        return this;
    }
    $7c3f52cf960380f5$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $2xTNA._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $7c3f52cf960380f5$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $2xTNA._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $7c3f52cf960380f5$var$pd);
        },
        persist: function persist() {},
        isPersistent: $7c3f52cf960380f5$var$pd
    });
    return b;
}
var $7c3f52cf960380f5$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $7c3f52cf960380f5$var$td = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$sd), $7c3f52cf960380f5$var$ud = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$sd, {
    view: 0,
    detail: 0
}), $7c3f52cf960380f5$var$vd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$ud), $7c3f52cf960380f5$var$wd, $7c3f52cf960380f5$var$xd, $7c3f52cf960380f5$var$yd, $7c3f52cf960380f5$var$Ad = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $7c3f52cf960380f5$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $7c3f52cf960380f5$var$yd && ($7c3f52cf960380f5$var$yd && "mousemove" === a.type ? ($7c3f52cf960380f5$var$wd = a.screenX - $7c3f52cf960380f5$var$yd.screenX, $7c3f52cf960380f5$var$xd = a.screenY - $7c3f52cf960380f5$var$yd.screenY) : $7c3f52cf960380f5$var$xd = $7c3f52cf960380f5$var$wd = 0, $7c3f52cf960380f5$var$yd = a);
        return $7c3f52cf960380f5$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $7c3f52cf960380f5$var$xd;
    }
}), $7c3f52cf960380f5$var$Bd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Ad), $7c3f52cf960380f5$var$Cd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$Ad, {
    dataTransfer: 0
}), $7c3f52cf960380f5$var$Dd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Cd), $7c3f52cf960380f5$var$Ed = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$ud, {
    relatedTarget: 0
}), $7c3f52cf960380f5$var$Fd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Ed), $7c3f52cf960380f5$var$Gd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7c3f52cf960380f5$var$Hd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Gd), $7c3f52cf960380f5$var$Id = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $7c3f52cf960380f5$var$Jd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Id), $7c3f52cf960380f5$var$Kd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$sd, {
    data: 0
}), $7c3f52cf960380f5$var$Ld = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Kd), $7c3f52cf960380f5$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $7c3f52cf960380f5$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $7c3f52cf960380f5$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $7c3f52cf960380f5$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $7c3f52cf960380f5$var$Od[a]) ? !!b[a] : !1;
}
function $7c3f52cf960380f5$var$zd() {
    return $7c3f52cf960380f5$var$Pd;
}
var $7c3f52cf960380f5$var$Qd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $7c3f52cf960380f5$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $7c3f52cf960380f5$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $7c3f52cf960380f5$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $7c3f52cf960380f5$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $7c3f52cf960380f5$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $7c3f52cf960380f5$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $7c3f52cf960380f5$var$Rd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Qd), $7c3f52cf960380f5$var$Sd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $7c3f52cf960380f5$var$Td = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Sd), $7c3f52cf960380f5$var$Ud = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $7c3f52cf960380f5$var$zd
}), $7c3f52cf960380f5$var$Vd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Ud), $7c3f52cf960380f5$var$Wd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7c3f52cf960380f5$var$Xd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Wd), $7c3f52cf960380f5$var$Yd = $7c3f52cf960380f5$var$A({}, $7c3f52cf960380f5$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $7c3f52cf960380f5$var$Zd = $7c3f52cf960380f5$var$rd($7c3f52cf960380f5$var$Yd), $7c3f52cf960380f5$var$$d = [
    9,
    13,
    27,
    32
], $7c3f52cf960380f5$var$ae = $7c3f52cf960380f5$var$ia && "CompositionEvent" in window, $7c3f52cf960380f5$var$be = null;
$7c3f52cf960380f5$var$ia && "documentMode" in document && ($7c3f52cf960380f5$var$be = document.documentMode);
var $7c3f52cf960380f5$var$ce = $7c3f52cf960380f5$var$ia && "TextEvent" in window && !$7c3f52cf960380f5$var$be, $7c3f52cf960380f5$var$de = $7c3f52cf960380f5$var$ia && (!$7c3f52cf960380f5$var$ae || $7c3f52cf960380f5$var$be && 8 < $7c3f52cf960380f5$var$be && 11 >= $7c3f52cf960380f5$var$be), $7c3f52cf960380f5$var$ee = String.fromCharCode(32), $7c3f52cf960380f5$var$fe = !1;
function $7c3f52cf960380f5$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $7c3f52cf960380f5$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $7c3f52cf960380f5$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && "data" in a ? a.data : null;
}
var $7c3f52cf960380f5$var$ie = !1;
function $7c3f52cf960380f5$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $7c3f52cf960380f5$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $7c3f52cf960380f5$var$fe = !0;
            return $7c3f52cf960380f5$var$ee;
        case "textInput":
            return a = b.data, a === $7c3f52cf960380f5$var$ee && $7c3f52cf960380f5$var$fe ? null : a;
        default:
            return null;
    }
}
function $7c3f52cf960380f5$var$ke(a, b) {
    if ($7c3f52cf960380f5$var$ie) return "compositionend" === a || !$7c3f52cf960380f5$var$ae && $7c3f52cf960380f5$var$ge(a, b) ? (a = $7c3f52cf960380f5$var$nd(), $7c3f52cf960380f5$var$md = $7c3f52cf960380f5$var$ld = $7c3f52cf960380f5$var$kd = null, $7c3f52cf960380f5$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b["char"] && 1 < b["char"].length) return b["char"];
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $7c3f52cf960380f5$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $7c3f52cf960380f5$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $7c3f52cf960380f5$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$7c3f52cf960380f5$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $7c3f52cf960380f5$var$ne(a, b, c, d) {
    $7c3f52cf960380f5$var$Eb(d);
    b = $7c3f52cf960380f5$var$oe(b, "onChange");
    0 < b.length && (c = new $7c3f52cf960380f5$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $7c3f52cf960380f5$var$pe = null, $7c3f52cf960380f5$var$qe = null;
function $7c3f52cf960380f5$var$re(a) {
    $7c3f52cf960380f5$var$se(a, 0);
}
function $7c3f52cf960380f5$var$te(a) {
    var b = $7c3f52cf960380f5$var$ue(a);
    if ($7c3f52cf960380f5$var$Wa(b)) return a;
}
function $7c3f52cf960380f5$var$ve(a, b) {
    if ("change" === a) return b;
}
var $7c3f52cf960380f5$var$we = !1;
if ($7c3f52cf960380f5$var$ia) {
    var $7c3f52cf960380f5$var$xe;
    if ($7c3f52cf960380f5$var$ia) {
        var $7c3f52cf960380f5$var$ye = "oninput" in document;
        if (!$7c3f52cf960380f5$var$ye) {
            var $7c3f52cf960380f5$var$ze = document.createElement("div");
            $7c3f52cf960380f5$var$ze.setAttribute("oninput", "return;");
            $7c3f52cf960380f5$var$ye = "function" === typeof $7c3f52cf960380f5$var$ze.oninput;
        }
        $7c3f52cf960380f5$var$xe = $7c3f52cf960380f5$var$ye;
    } else $7c3f52cf960380f5$var$xe = !1;
    $7c3f52cf960380f5$var$we = $7c3f52cf960380f5$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $7c3f52cf960380f5$var$Ae() {
    $7c3f52cf960380f5$var$pe && ($7c3f52cf960380f5$var$pe.detachEvent("onpropertychange", $7c3f52cf960380f5$var$Be), $7c3f52cf960380f5$var$qe = $7c3f52cf960380f5$var$pe = null);
}
function $7c3f52cf960380f5$var$Be(a) {
    if ("value" === a.propertyName && $7c3f52cf960380f5$var$te($7c3f52cf960380f5$var$qe)) {
        var b = [];
        $7c3f52cf960380f5$var$ne(b, $7c3f52cf960380f5$var$qe, a, $7c3f52cf960380f5$var$xb(a));
        $7c3f52cf960380f5$var$Jb($7c3f52cf960380f5$var$re, b);
    }
}
function $7c3f52cf960380f5$var$Ce(a, b, c) {
    "focusin" === a ? ($7c3f52cf960380f5$var$Ae(), $7c3f52cf960380f5$var$pe = b, $7c3f52cf960380f5$var$qe = c, $7c3f52cf960380f5$var$pe.attachEvent("onpropertychange", $7c3f52cf960380f5$var$Be)) : "focusout" === a && $7c3f52cf960380f5$var$Ae();
}
function $7c3f52cf960380f5$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $7c3f52cf960380f5$var$te($7c3f52cf960380f5$var$qe);
}
function $7c3f52cf960380f5$var$Ee(a, b) {
    if ("click" === a) return $7c3f52cf960380f5$var$te(b);
}
function $7c3f52cf960380f5$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $7c3f52cf960380f5$var$te(b);
}
function $7c3f52cf960380f5$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7c3f52cf960380f5$var$He = "function" === typeof Object.is ? Object.is : $7c3f52cf960380f5$var$Ge;
function $7c3f52cf960380f5$var$Ie(a, b) {
    if ($7c3f52cf960380f5$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $2xTNA._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$7c3f52cf960380f5$var$ja.call(b, e) || !$7c3f52cf960380f5$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $7c3f52cf960380f5$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $7c3f52cf960380f5$var$Ke(a, b) {
    var c = $7c3f52cf960380f5$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $7c3f52cf960380f5$var$Je(c);
    }
}
function $7c3f52cf960380f5$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $7c3f52cf960380f5$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $7c3f52cf960380f5$var$Me() {
    for(var a = window, b = $7c3f52cf960380f5$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $7c3f52cf960380f5$var$Xa(a.document);
    }
    return b;
}
function $7c3f52cf960380f5$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $7c3f52cf960380f5$var$Oe(a) {
    var b = $7c3f52cf960380f5$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $7c3f52cf960380f5$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $7c3f52cf960380f5$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $7c3f52cf960380f5$var$Ke(c, f);
                var g = $7c3f52cf960380f5$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $7c3f52cf960380f5$var$Pe = $7c3f52cf960380f5$var$ia && "documentMode" in document && 11 >= document.documentMode, $7c3f52cf960380f5$var$Qe = null, $7c3f52cf960380f5$var$Re = null, $7c3f52cf960380f5$var$Se = null, $7c3f52cf960380f5$var$Te = !1;
function $7c3f52cf960380f5$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $7c3f52cf960380f5$var$Te || null == $7c3f52cf960380f5$var$Qe || $7c3f52cf960380f5$var$Qe !== $7c3f52cf960380f5$var$Xa(d) || (d = $7c3f52cf960380f5$var$Qe, "selectionStart" in d && $7c3f52cf960380f5$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $7c3f52cf960380f5$var$Se && $7c3f52cf960380f5$var$Ie($7c3f52cf960380f5$var$Se, d) || ($7c3f52cf960380f5$var$Se = d, d = $7c3f52cf960380f5$var$oe($7c3f52cf960380f5$var$Re, "onSelect"), 0 < d.length && (b = new $7c3f52cf960380f5$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $7c3f52cf960380f5$var$Qe)));
}
function $7c3f52cf960380f5$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $7c3f52cf960380f5$var$We = {
    animationend: $7c3f52cf960380f5$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $7c3f52cf960380f5$var$Ve("Animation", "AnimationIteration"),
    animationstart: $7c3f52cf960380f5$var$Ve("Animation", "AnimationStart"),
    transitionend: $7c3f52cf960380f5$var$Ve("Transition", "TransitionEnd")
}, $7c3f52cf960380f5$var$Xe = {}, $7c3f52cf960380f5$var$Ye = {};
$7c3f52cf960380f5$var$ia && ($7c3f52cf960380f5$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $7c3f52cf960380f5$var$We.animationend.animation, delete $7c3f52cf960380f5$var$We.animationiteration.animation, delete $7c3f52cf960380f5$var$We.animationstart.animation), "TransitionEvent" in window || delete $7c3f52cf960380f5$var$We.transitionend.transition);
function $7c3f52cf960380f5$var$Ze(a) {
    if ($7c3f52cf960380f5$var$Xe[a]) return $7c3f52cf960380f5$var$Xe[a];
    if (!$7c3f52cf960380f5$var$We[a]) return a;
    var b = $7c3f52cf960380f5$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $7c3f52cf960380f5$var$Ye) return $7c3f52cf960380f5$var$Xe[a] = b[c];
    return a;
}
var $7c3f52cf960380f5$var$$e = $7c3f52cf960380f5$var$Ze("animationend"), $7c3f52cf960380f5$var$af = $7c3f52cf960380f5$var$Ze("animationiteration"), $7c3f52cf960380f5$var$bf = $7c3f52cf960380f5$var$Ze("animationstart"), $7c3f52cf960380f5$var$cf = $7c3f52cf960380f5$var$Ze("transitionend"), $7c3f52cf960380f5$var$df = new Map, $7c3f52cf960380f5$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $7c3f52cf960380f5$var$ff(a, b) {
    $7c3f52cf960380f5$var$df.set(a, b);
    $7c3f52cf960380f5$var$fa(b, [
        a
    ]);
}
for(var $7c3f52cf960380f5$var$gf = 0; $7c3f52cf960380f5$var$gf < $7c3f52cf960380f5$var$ef.length; $7c3f52cf960380f5$var$gf++){
    var $7c3f52cf960380f5$var$hf = $7c3f52cf960380f5$var$ef[$7c3f52cf960380f5$var$gf], $7c3f52cf960380f5$var$jf = $7c3f52cf960380f5$var$hf.toLowerCase(), $7c3f52cf960380f5$var$kf = $7c3f52cf960380f5$var$hf[0].toUpperCase() + $7c3f52cf960380f5$var$hf.slice(1);
    $7c3f52cf960380f5$var$ff($7c3f52cf960380f5$var$jf, "on" + $7c3f52cf960380f5$var$kf);
}
$7c3f52cf960380f5$var$ff($7c3f52cf960380f5$var$$e, "onAnimationEnd");
$7c3f52cf960380f5$var$ff($7c3f52cf960380f5$var$af, "onAnimationIteration");
$7c3f52cf960380f5$var$ff($7c3f52cf960380f5$var$bf, "onAnimationStart");
$7c3f52cf960380f5$var$ff("dblclick", "onDoubleClick");
$7c3f52cf960380f5$var$ff("focusin", "onFocus");
$7c3f52cf960380f5$var$ff("focusout", "onBlur");
$7c3f52cf960380f5$var$ff($7c3f52cf960380f5$var$cf, "onTransitionEnd");
$7c3f52cf960380f5$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$7c3f52cf960380f5$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$7c3f52cf960380f5$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$7c3f52cf960380f5$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$7c3f52cf960380f5$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$7c3f52cf960380f5$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$7c3f52cf960380f5$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$7c3f52cf960380f5$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$7c3f52cf960380f5$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$7c3f52cf960380f5$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $7c3f52cf960380f5$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $7c3f52cf960380f5$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($7c3f52cf960380f5$var$lf));
function $7c3f52cf960380f5$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $7c3f52cf960380f5$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $7c3f52cf960380f5$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7c3f52cf960380f5$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7c3f52cf960380f5$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($7c3f52cf960380f5$var$Qb) throw a = $7c3f52cf960380f5$var$Rb, $7c3f52cf960380f5$var$Qb = !1, $7c3f52cf960380f5$var$Rb = null, a;
}
function $7c3f52cf960380f5$var$D(a, b) {
    var c = b[$7c3f52cf960380f5$var$of];
    void 0 === c && (c = b[$7c3f52cf960380f5$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($7c3f52cf960380f5$var$pf(b, a, 2, !1), c.add(d));
}
function $7c3f52cf960380f5$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $7c3f52cf960380f5$var$pf(c, a, d, b);
}
var $7c3f52cf960380f5$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $7c3f52cf960380f5$var$sf(a) {
    if (!a[$7c3f52cf960380f5$var$rf]) {
        a[$7c3f52cf960380f5$var$rf] = !0;
        $7c3f52cf960380f5$var$da.forEach(function(b) {
            "selectionchange" !== b && ($7c3f52cf960380f5$var$mf.has(b) || $7c3f52cf960380f5$var$qf(b, !1, a), $7c3f52cf960380f5$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$7c3f52cf960380f5$var$rf] || (b[$7c3f52cf960380f5$var$rf] = !0, $7c3f52cf960380f5$var$qf("selectionchange", !1, b));
    }
}
function $7c3f52cf960380f5$var$pf(a, b, c, d) {
    switch($7c3f52cf960380f5$var$jd(b)){
        case 1:
            var e = $7c3f52cf960380f5$var$ed;
            break;
        case 4:
            e = $7c3f52cf960380f5$var$gd;
            break;
        default:
            e = $7c3f52cf960380f5$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$7c3f52cf960380f5$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $7c3f52cf960380f5$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d["return"]; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g["return"];
            }
            for(; null !== h;){
                g = $7c3f52cf960380f5$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d["return"];
    }
    $7c3f52cf960380f5$var$Jb(function() {
        var _$d = f, _$e = $7c3f52cf960380f5$var$xb(c), g = [];
        a: {
            var h = $7c3f52cf960380f5$var$df.get(a);
            if (void 0 !== h) {
                var k = $7c3f52cf960380f5$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $7c3f52cf960380f5$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $7c3f52cf960380f5$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $7c3f52cf960380f5$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $7c3f52cf960380f5$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $7c3f52cf960380f5$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $7c3f52cf960380f5$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $7c3f52cf960380f5$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $7c3f52cf960380f5$var$Vd;
                        break;
                    case $7c3f52cf960380f5$var$$e:
                    case $7c3f52cf960380f5$var$af:
                    case $7c3f52cf960380f5$var$bf:
                        k = $7c3f52cf960380f5$var$Hd;
                        break;
                    case $7c3f52cf960380f5$var$cf:
                        k = $7c3f52cf960380f5$var$Xd;
                        break;
                    case "scroll":
                        k = $7c3f52cf960380f5$var$vd;
                        break;
                    case "wheel":
                        k = $7c3f52cf960380f5$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $7c3f52cf960380f5$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $7c3f52cf960380f5$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $7c3f52cf960380f5$var$Kb(w, x), null != F && t.push($7c3f52cf960380f5$var$tf(w, F, u))));
                    if (J) break;
                    w = w["return"];
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $7c3f52cf960380f5$var$wb && (n = c.relatedTarget || c.fromElement) && ($7c3f52cf960380f5$var$Wc(n) || n[$7c3f52cf960380f5$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $7c3f52cf960380f5$var$Wc(n) : null, null !== n && (J = $7c3f52cf960380f5$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $7c3f52cf960380f5$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $7c3f52cf960380f5$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $7c3f52cf960380f5$var$ue(k);
                        u = null == n ? h : $7c3f52cf960380f5$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $7c3f52cf960380f5$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $7c3f52cf960380f5$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $7c3f52cf960380f5$var$vf(F))u++;
                            for(; 0 < w - u;)t = $7c3f52cf960380f5$var$vf(t), w--;
                            for(; 0 < u - w;)x = $7c3f52cf960380f5$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $7c3f52cf960380f5$var$vf(t);
                                x = $7c3f52cf960380f5$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $7c3f52cf960380f5$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $7c3f52cf960380f5$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $7c3f52cf960380f5$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $7c3f52cf960380f5$var$ve;
                else if ($7c3f52cf960380f5$var$me(h)) {
                    if ($7c3f52cf960380f5$var$we) na = $7c3f52cf960380f5$var$Fe;
                    else {
                        na = $7c3f52cf960380f5$var$De;
                        var xa = $7c3f52cf960380f5$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $7c3f52cf960380f5$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $7c3f52cf960380f5$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $7c3f52cf960380f5$var$cb(h, "number", h.value);
            }
            xa = _$d ? $7c3f52cf960380f5$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($7c3f52cf960380f5$var$me(xa) || "true" === xa.contentEditable) $7c3f52cf960380f5$var$Qe = xa, $7c3f52cf960380f5$var$Re = _$d, $7c3f52cf960380f5$var$Se = null;
                    break;
                case "focusout":
                    $7c3f52cf960380f5$var$Se = $7c3f52cf960380f5$var$Re = $7c3f52cf960380f5$var$Qe = null;
                    break;
                case "mousedown":
                    $7c3f52cf960380f5$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $7c3f52cf960380f5$var$Te = !1;
                    $7c3f52cf960380f5$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($7c3f52cf960380f5$var$Pe) break;
                case "keydown":
                case "keyup":
                    $7c3f52cf960380f5$var$Ue(g, c, _$e);
            }
            var $a;
            if ($7c3f52cf960380f5$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $7c3f52cf960380f5$var$ie ? $7c3f52cf960380f5$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($7c3f52cf960380f5$var$de && "ko" !== c.locale && ($7c3f52cf960380f5$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $7c3f52cf960380f5$var$ie && ($a = $7c3f52cf960380f5$var$nd()) : ($7c3f52cf960380f5$var$kd = _$e, $7c3f52cf960380f5$var$ld = "value" in $7c3f52cf960380f5$var$kd ? $7c3f52cf960380f5$var$kd.value : $7c3f52cf960380f5$var$kd.textContent, $7c3f52cf960380f5$var$ie = !0)), xa = $7c3f52cf960380f5$var$oe(_$d, ba), 0 < xa.length && (ba = new $7c3f52cf960380f5$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $7c3f52cf960380f5$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $7c3f52cf960380f5$var$ce ? $7c3f52cf960380f5$var$je(a, c) : $7c3f52cf960380f5$var$ke(a, c)) _$d = $7c3f52cf960380f5$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $7c3f52cf960380f5$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $7c3f52cf960380f5$var$se(g, b);
    });
}
function $7c3f52cf960380f5$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $7c3f52cf960380f5$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $7c3f52cf960380f5$var$Kb(a, c), null != f && d.unshift($7c3f52cf960380f5$var$tf(a, f, e)), f = $7c3f52cf960380f5$var$Kb(a, b), null != f && d.push($7c3f52cf960380f5$var$tf(a, f, e)));
        a = a["return"];
    }
    return d;
}
function $7c3f52cf960380f5$var$vf(a) {
    if (null === a) return null;
    do a = a["return"];
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $7c3f52cf960380f5$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $7c3f52cf960380f5$var$Kb(c, f), null != k && g.unshift($7c3f52cf960380f5$var$tf(c, k, h))) : e || (k = $7c3f52cf960380f5$var$Kb(c, f), null != k && g.push($7c3f52cf960380f5$var$tf(c, k, h))));
        c = c["return"];
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $7c3f52cf960380f5$var$xf = /\r\n?/g, $7c3f52cf960380f5$var$yf = /\u0000|\uFFFD/g;
function $7c3f52cf960380f5$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($7c3f52cf960380f5$var$xf, "\n").replace($7c3f52cf960380f5$var$yf, "");
}
function $7c3f52cf960380f5$var$Af(a, b, c) {
    b = $7c3f52cf960380f5$var$zf(b);
    if ($7c3f52cf960380f5$var$zf(a) !== b && c) throw Error($7c3f52cf960380f5$var$p(425));
}
function $7c3f52cf960380f5$var$Bf() {}
var $7c3f52cf960380f5$var$Cf = null, $7c3f52cf960380f5$var$Df = null;
function $7c3f52cf960380f5$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $2xTNA._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $7c3f52cf960380f5$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $7c3f52cf960380f5$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $7c3f52cf960380f5$var$Hf = "function" === typeof Promise ? Promise : void 0, $7c3f52cf960380f5$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $7c3f52cf960380f5$var$Hf ? function Jf(a) {
    return $7c3f52cf960380f5$var$Hf.resolve(null).then(a)["catch"]($7c3f52cf960380f5$var$If);
} : $7c3f52cf960380f5$var$Ff;
function $7c3f52cf960380f5$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $7c3f52cf960380f5$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $7c3f52cf960380f5$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $7c3f52cf960380f5$var$bd(b);
}
function $7c3f52cf960380f5$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $7c3f52cf960380f5$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $7c3f52cf960380f5$var$Nf = Math.random().toString(36).slice(2), $7c3f52cf960380f5$var$Of = "__reactFiber$" + $7c3f52cf960380f5$var$Nf, $7c3f52cf960380f5$var$Pf = "__reactProps$" + $7c3f52cf960380f5$var$Nf, $7c3f52cf960380f5$var$uf = "__reactContainer$" + $7c3f52cf960380f5$var$Nf, $7c3f52cf960380f5$var$of = "__reactEvents$" + $7c3f52cf960380f5$var$Nf, $7c3f52cf960380f5$var$Qf = "__reactListeners$" + $7c3f52cf960380f5$var$Nf, $7c3f52cf960380f5$var$Rf = "__reactHandles$" + $7c3f52cf960380f5$var$Nf;
function $7c3f52cf960380f5$var$Wc(a) {
    var b = a[$7c3f52cf960380f5$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$7c3f52cf960380f5$var$uf] || c[$7c3f52cf960380f5$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $7c3f52cf960380f5$var$Mf(a); null !== a;){
                if (c = a[$7c3f52cf960380f5$var$Of]) return c;
                a = $7c3f52cf960380f5$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $7c3f52cf960380f5$var$Cb(a) {
    a = a[$7c3f52cf960380f5$var$Of] || a[$7c3f52cf960380f5$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $7c3f52cf960380f5$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($7c3f52cf960380f5$var$p(33));
}
function $7c3f52cf960380f5$var$Db(a) {
    return a[$7c3f52cf960380f5$var$Pf] || null;
}
var $7c3f52cf960380f5$var$Sf = [], $7c3f52cf960380f5$var$Tf = -1;
function $7c3f52cf960380f5$var$Uf(a) {
    return {
        current: a
    };
}
function $7c3f52cf960380f5$var$E(a) {
    0 > $7c3f52cf960380f5$var$Tf || (a.current = $7c3f52cf960380f5$var$Sf[$7c3f52cf960380f5$var$Tf], $7c3f52cf960380f5$var$Sf[$7c3f52cf960380f5$var$Tf] = null, $7c3f52cf960380f5$var$Tf--);
}
function $7c3f52cf960380f5$var$G(a, b) {
    $7c3f52cf960380f5$var$Tf++;
    $7c3f52cf960380f5$var$Sf[$7c3f52cf960380f5$var$Tf] = a.current;
    a.current = b;
}
var $7c3f52cf960380f5$var$Vf = {}, $7c3f52cf960380f5$var$H = $7c3f52cf960380f5$var$Uf($7c3f52cf960380f5$var$Vf), $7c3f52cf960380f5$var$Wf = $7c3f52cf960380f5$var$Uf(!1), $7c3f52cf960380f5$var$Xf = $7c3f52cf960380f5$var$Vf;
function $7c3f52cf960380f5$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $7c3f52cf960380f5$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $7c3f52cf960380f5$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $7c3f52cf960380f5$var$$f() {
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wf);
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$H);
}
function $7c3f52cf960380f5$var$ag(a, b, c) {
    if ($7c3f52cf960380f5$var$H.current !== $7c3f52cf960380f5$var$Vf) throw Error($7c3f52cf960380f5$var$p(168));
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$H, b);
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$Wf, c);
}
function $7c3f52cf960380f5$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($7c3f52cf960380f5$var$p(108, $7c3f52cf960380f5$var$Ra(a) || "Unknown", e));
    return $7c3f52cf960380f5$var$A({}, c, d);
}
function $7c3f52cf960380f5$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $7c3f52cf960380f5$var$Vf;
    $7c3f52cf960380f5$var$Xf = $7c3f52cf960380f5$var$H.current;
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$H, a);
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$Wf, $7c3f52cf960380f5$var$Wf.current);
    return !0;
}
function $7c3f52cf960380f5$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($7c3f52cf960380f5$var$p(169));
    c ? (a = $7c3f52cf960380f5$var$bg(a, b, $7c3f52cf960380f5$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wf), $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$H), $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$H, a)) : $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wf);
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$Wf, c);
}
var $7c3f52cf960380f5$var$eg = null, $7c3f52cf960380f5$var$fg = !1, $7c3f52cf960380f5$var$gg = !1;
function $7c3f52cf960380f5$var$hg(a) {
    null === $7c3f52cf960380f5$var$eg ? $7c3f52cf960380f5$var$eg = [
        a
    ] : $7c3f52cf960380f5$var$eg.push(a);
}
function $7c3f52cf960380f5$var$ig(a) {
    $7c3f52cf960380f5$var$fg = !0;
    $7c3f52cf960380f5$var$hg(a);
}
function $7c3f52cf960380f5$var$jg() {
    if (!$7c3f52cf960380f5$var$gg && null !== $7c3f52cf960380f5$var$eg) {
        $7c3f52cf960380f5$var$gg = !0;
        var a = 0, b = $7c3f52cf960380f5$var$C;
        try {
            var c = $7c3f52cf960380f5$var$eg;
            for($7c3f52cf960380f5$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $7c3f52cf960380f5$var$eg = null;
            $7c3f52cf960380f5$var$fg = !1;
        } catch (e) {
            throw null !== $7c3f52cf960380f5$var$eg && ($7c3f52cf960380f5$var$eg = $7c3f52cf960380f5$var$eg.slice(a + 1)), $7c3f52cf960380f5$var$ac($7c3f52cf960380f5$var$fc, $7c3f52cf960380f5$var$jg), e;
        } finally{
            $7c3f52cf960380f5$var$C = b, $7c3f52cf960380f5$var$gg = !1;
        }
    }
    return null;
}
var $7c3f52cf960380f5$var$kg = [], $7c3f52cf960380f5$var$lg = 0, $7c3f52cf960380f5$var$mg = null, $7c3f52cf960380f5$var$ng = 0, $7c3f52cf960380f5$var$og = [], $7c3f52cf960380f5$var$pg = 0, $7c3f52cf960380f5$var$qg = null, $7c3f52cf960380f5$var$rg = 1, $7c3f52cf960380f5$var$sg = "";
function $7c3f52cf960380f5$var$tg(a, b) {
    $7c3f52cf960380f5$var$kg[$7c3f52cf960380f5$var$lg++] = $7c3f52cf960380f5$var$ng;
    $7c3f52cf960380f5$var$kg[$7c3f52cf960380f5$var$lg++] = $7c3f52cf960380f5$var$mg;
    $7c3f52cf960380f5$var$mg = a;
    $7c3f52cf960380f5$var$ng = b;
}
function $7c3f52cf960380f5$var$ug(a, b, c) {
    $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg++] = $7c3f52cf960380f5$var$rg;
    $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg++] = $7c3f52cf960380f5$var$sg;
    $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg++] = $7c3f52cf960380f5$var$qg;
    $7c3f52cf960380f5$var$qg = a;
    var d = $7c3f52cf960380f5$var$rg;
    a = $7c3f52cf960380f5$var$sg;
    var e = 32 - $7c3f52cf960380f5$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $7c3f52cf960380f5$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $7c3f52cf960380f5$var$rg = 1 << 32 - $7c3f52cf960380f5$var$oc(b) + e | c << e | d;
        $7c3f52cf960380f5$var$sg = f + a;
    } else $7c3f52cf960380f5$var$rg = 1 << f | c << e | d, $7c3f52cf960380f5$var$sg = a;
}
function $7c3f52cf960380f5$var$vg(a) {
    null !== a["return"] && ($7c3f52cf960380f5$var$tg(a, 1), $7c3f52cf960380f5$var$ug(a, 1, 0));
}
function $7c3f52cf960380f5$var$wg(a) {
    for(; a === $7c3f52cf960380f5$var$mg;)$7c3f52cf960380f5$var$mg = $7c3f52cf960380f5$var$kg[--$7c3f52cf960380f5$var$lg], $7c3f52cf960380f5$var$kg[$7c3f52cf960380f5$var$lg] = null, $7c3f52cf960380f5$var$ng = $7c3f52cf960380f5$var$kg[--$7c3f52cf960380f5$var$lg], $7c3f52cf960380f5$var$kg[$7c3f52cf960380f5$var$lg] = null;
    for(; a === $7c3f52cf960380f5$var$qg;)$7c3f52cf960380f5$var$qg = $7c3f52cf960380f5$var$og[--$7c3f52cf960380f5$var$pg], $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg] = null, $7c3f52cf960380f5$var$sg = $7c3f52cf960380f5$var$og[--$7c3f52cf960380f5$var$pg], $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg] = null, $7c3f52cf960380f5$var$rg = $7c3f52cf960380f5$var$og[--$7c3f52cf960380f5$var$pg], $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg] = null;
}
var $7c3f52cf960380f5$var$xg = null, $7c3f52cf960380f5$var$yg = null, $7c3f52cf960380f5$var$I = !1, $7c3f52cf960380f5$var$zg = null;
function $7c3f52cf960380f5$var$Ag(a, b) {
    var c = $7c3f52cf960380f5$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $7c3f52cf960380f5$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $7c3f52cf960380f5$var$xg = a, $7c3f52cf960380f5$var$yg = $7c3f52cf960380f5$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $7c3f52cf960380f5$var$xg = a, $7c3f52cf960380f5$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $7c3f52cf960380f5$var$qg ? {
                id: $7c3f52cf960380f5$var$rg,
                overflow: $7c3f52cf960380f5$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $7c3f52cf960380f5$var$Bg(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, $7c3f52cf960380f5$var$xg = a, $7c3f52cf960380f5$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $7c3f52cf960380f5$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $7c3f52cf960380f5$var$Eg(a) {
    if ($7c3f52cf960380f5$var$I) {
        var b = $7c3f52cf960380f5$var$yg;
        if (b) {
            var c = b;
            if (!$7c3f52cf960380f5$var$Cg(a, b)) {
                if ($7c3f52cf960380f5$var$Dg(a)) throw Error($7c3f52cf960380f5$var$p(418));
                b = $7c3f52cf960380f5$var$Lf(c.nextSibling);
                var d = $7c3f52cf960380f5$var$xg;
                b && $7c3f52cf960380f5$var$Cg(a, b) ? $7c3f52cf960380f5$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $7c3f52cf960380f5$var$I = !1, $7c3f52cf960380f5$var$xg = a);
            }
        } else {
            if ($7c3f52cf960380f5$var$Dg(a)) throw Error($7c3f52cf960380f5$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $7c3f52cf960380f5$var$I = !1;
            $7c3f52cf960380f5$var$xg = a;
        }
    }
}
function $7c3f52cf960380f5$var$Fg(a) {
    for(a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a["return"];
    $7c3f52cf960380f5$var$xg = a;
}
function $7c3f52cf960380f5$var$Gg(a) {
    if (a !== $7c3f52cf960380f5$var$xg) return !1;
    if (!$7c3f52cf960380f5$var$I) return $7c3f52cf960380f5$var$Fg(a), $7c3f52cf960380f5$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$7c3f52cf960380f5$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $7c3f52cf960380f5$var$yg)) {
        if ($7c3f52cf960380f5$var$Dg(a)) throw $7c3f52cf960380f5$var$Hg(), Error($7c3f52cf960380f5$var$p(418));
        for(; b;)$7c3f52cf960380f5$var$Ag(a, b), b = $7c3f52cf960380f5$var$Lf(b.nextSibling);
    }
    $7c3f52cf960380f5$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($7c3f52cf960380f5$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $7c3f52cf960380f5$var$yg = $7c3f52cf960380f5$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $7c3f52cf960380f5$var$yg = null;
        }
    } else $7c3f52cf960380f5$var$yg = $7c3f52cf960380f5$var$xg ? $7c3f52cf960380f5$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $7c3f52cf960380f5$var$Hg() {
    for(var a = $7c3f52cf960380f5$var$yg; a;)a = $7c3f52cf960380f5$var$Lf(a.nextSibling);
}
function $7c3f52cf960380f5$var$Ig() {
    $7c3f52cf960380f5$var$yg = $7c3f52cf960380f5$var$xg = null;
    $7c3f52cf960380f5$var$I = !1;
}
function $7c3f52cf960380f5$var$Jg(a) {
    null === $7c3f52cf960380f5$var$zg ? $7c3f52cf960380f5$var$zg = [
        a
    ] : $7c3f52cf960380f5$var$zg.push(a);
}
var $7c3f52cf960380f5$var$Kg = $7c3f52cf960380f5$var$ua.ReactCurrentBatchConfig;
function $7c3f52cf960380f5$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($7c3f52cf960380f5$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($7c3f52cf960380f5$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($7c3f52cf960380f5$var$p(284));
        if (!c._owner) throw Error($7c3f52cf960380f5$var$p(290, a));
    }
    return a;
}
function $7c3f52cf960380f5$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($7c3f52cf960380f5$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $7c3f52cf960380f5$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $7c3f52cf960380f5$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $7c3f52cf960380f5$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $7c3f52cf960380f5$var$Qg(c, a.mode, d), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $7c3f52cf960380f5$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $2xTNA._)(f)) && null !== f && f.$$typeof === $7c3f52cf960380f5$var$Ha && $7c3f52cf960380f5$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $7c3f52cf960380f5$var$Lg(a, b, c), d["return"] = a, d;
        d = $7c3f52cf960380f5$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $7c3f52cf960380f5$var$Lg(a, b, c);
        d["return"] = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $7c3f52cf960380f5$var$Sg(c, a.mode, d), b["return"] = a, b;
        b = e(b, c.children || []);
        b["return"] = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $7c3f52cf960380f5$var$Tg(c, a.mode, d, f), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $7c3f52cf960380f5$var$Qg("" + b, a.mode, c), b["return"] = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $2xTNA._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $7c3f52cf960380f5$var$va:
                    return c = $7c3f52cf960380f5$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $7c3f52cf960380f5$var$Lg(a, null, b), c["return"] = a, c;
                case $7c3f52cf960380f5$var$wa:
                    return b = $7c3f52cf960380f5$var$Sg(b, a.mode, c), b["return"] = a, b;
                case $7c3f52cf960380f5$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($7c3f52cf960380f5$var$eb(b) || $7c3f52cf960380f5$var$Ka(b)) return b = $7c3f52cf960380f5$var$Tg(b, a.mode, c, null), b["return"] = a, b;
            $7c3f52cf960380f5$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $2xTNA._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $7c3f52cf960380f5$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $7c3f52cf960380f5$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $7c3f52cf960380f5$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($7c3f52cf960380f5$var$eb(c) || $7c3f52cf960380f5$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $7c3f52cf960380f5$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $2xTNA._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $7c3f52cf960380f5$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $7c3f52cf960380f5$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $7c3f52cf960380f5$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($7c3f52cf960380f5$var$eb(d) || $7c3f52cf960380f5$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $7c3f52cf960380f5$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $7c3f52cf960380f5$var$I && $7c3f52cf960380f5$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $7c3f52cf960380f5$var$I && $7c3f52cf960380f5$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u["delete"](null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $7c3f52cf960380f5$var$I && $7c3f52cf960380f5$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $7c3f52cf960380f5$var$Ka(h);
        if ("function" !== typeof l) throw Error($7c3f52cf960380f5$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($7c3f52cf960380f5$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $7c3f52cf960380f5$var$I && $7c3f52cf960380f5$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $7c3f52cf960380f5$var$I && $7c3f52cf960380f5$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m["delete"](null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $7c3f52cf960380f5$var$I && $7c3f52cf960380f5$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $2xTNA._)(f)) && null !== f && f.type === $7c3f52cf960380f5$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $2xTNA._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $7c3f52cf960380f5$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $7c3f52cf960380f5$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $2xTNA._)(k)) && null !== k && k.$$typeof === $7c3f52cf960380f5$var$Ha && $7c3f52cf960380f5$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $7c3f52cf960380f5$var$Lg(a, l, f);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $7c3f52cf960380f5$var$ya ? (d = $7c3f52cf960380f5$var$Tg(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = $7c3f52cf960380f5$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $7c3f52cf960380f5$var$Lg(a, d, f), h["return"] = a, a = h);
                    }
                    return g(a);
                case $7c3f52cf960380f5$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $7c3f52cf960380f5$var$Sg(f, a.mode, h);
                        d["return"] = a;
                        a = d;
                    }
                    return g(a);
                case $7c3f52cf960380f5$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($7c3f52cf960380f5$var$eb(f)) return n(a, d, f, h);
            if ($7c3f52cf960380f5$var$Ka(f)) return t(a, d, f, h);
            $7c3f52cf960380f5$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = $7c3f52cf960380f5$var$Qg(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $7c3f52cf960380f5$var$Ug = $7c3f52cf960380f5$var$Og(!0), $7c3f52cf960380f5$var$Vg = $7c3f52cf960380f5$var$Og(!1), $7c3f52cf960380f5$var$Wg = $7c3f52cf960380f5$var$Uf(null), $7c3f52cf960380f5$var$Xg = null, $7c3f52cf960380f5$var$Yg = null, $7c3f52cf960380f5$var$Zg = null;
function $7c3f52cf960380f5$var$$g() {
    $7c3f52cf960380f5$var$Zg = $7c3f52cf960380f5$var$Yg = $7c3f52cf960380f5$var$Xg = null;
}
function $7c3f52cf960380f5$var$ah(a) {
    var b = $7c3f52cf960380f5$var$Wg.current;
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wg);
    a._currentValue = b;
}
function $7c3f52cf960380f5$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a["return"];
    }
}
function $7c3f52cf960380f5$var$ch(a, b) {
    $7c3f52cf960380f5$var$Xg = a;
    $7c3f52cf960380f5$var$Zg = $7c3f52cf960380f5$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($7c3f52cf960380f5$var$dh = !0), a.firstContext = null);
}
function $7c3f52cf960380f5$var$eh(a) {
    var b = a._currentValue;
    if ($7c3f52cf960380f5$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $7c3f52cf960380f5$var$Yg) {
            if (null === $7c3f52cf960380f5$var$Xg) throw Error($7c3f52cf960380f5$var$p(308));
            $7c3f52cf960380f5$var$Yg = a;
            $7c3f52cf960380f5$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $7c3f52cf960380f5$var$Yg = $7c3f52cf960380f5$var$Yg.next = a;
    }
    return b;
}
var $7c3f52cf960380f5$var$fh = null;
function $7c3f52cf960380f5$var$gh(a) {
    null === $7c3f52cf960380f5$var$fh ? $7c3f52cf960380f5$var$fh = [
        a
    ] : $7c3f52cf960380f5$var$fh.push(a);
}
function $7c3f52cf960380f5$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $7c3f52cf960380f5$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $7c3f52cf960380f5$var$ih(a, d);
}
function $7c3f52cf960380f5$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a["return"]; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
    return 3 === c.tag ? c.stateNode : null;
}
var $7c3f52cf960380f5$var$jh = !1;
function $7c3f52cf960380f5$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $7c3f52cf960380f5$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $7c3f52cf960380f5$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $7c3f52cf960380f5$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($7c3f52cf960380f5$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $7c3f52cf960380f5$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $7c3f52cf960380f5$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $7c3f52cf960380f5$var$ih(a, c);
}
function $7c3f52cf960380f5$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7c3f52cf960380f5$var$Cc(a, c);
    }
}
function $7c3f52cf960380f5$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $7c3f52cf960380f5$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $7c3f52cf960380f5$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $7c3f52cf960380f5$var$A({}, q, r);
                            break a;
                        case 2:
                            $7c3f52cf960380f5$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $7c3f52cf960380f5$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $7c3f52cf960380f5$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($7c3f52cf960380f5$var$p(191, e));
            e.call(d);
        }
    }
}
var $7c3f52cf960380f5$var$th = {}, $7c3f52cf960380f5$var$uh = $7c3f52cf960380f5$var$Uf($7c3f52cf960380f5$var$th), $7c3f52cf960380f5$var$vh = $7c3f52cf960380f5$var$Uf($7c3f52cf960380f5$var$th), $7c3f52cf960380f5$var$wh = $7c3f52cf960380f5$var$Uf($7c3f52cf960380f5$var$th);
function $7c3f52cf960380f5$var$xh(a) {
    if (a === $7c3f52cf960380f5$var$th) throw Error($7c3f52cf960380f5$var$p(174));
    return a;
}
function $7c3f52cf960380f5$var$yh(a, b) {
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$wh, b);
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$vh, a);
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$uh, $7c3f52cf960380f5$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $7c3f52cf960380f5$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $7c3f52cf960380f5$var$lb(b, a);
    }
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$uh);
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$uh, b);
}
function $7c3f52cf960380f5$var$zh() {
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$uh);
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$vh);
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$wh);
}
function $7c3f52cf960380f5$var$Ah(a) {
    $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$wh.current);
    var b = $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$uh.current);
    var c = $7c3f52cf960380f5$var$lb(b, a.type);
    b !== c && ($7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$vh, a), $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$uh, c));
}
function $7c3f52cf960380f5$var$Bh(a) {
    $7c3f52cf960380f5$var$vh.current === a && ($7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$uh), $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$vh));
}
var $7c3f52cf960380f5$var$L = $7c3f52cf960380f5$var$Uf(0);
function $7c3f52cf960380f5$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child["return"] = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b["return"] || b["return"] === a) return null;
            b = b["return"];
        }
        b.sibling["return"] = b["return"];
        b = b.sibling;
    }
    return null;
}
var $7c3f52cf960380f5$var$Dh = [];
function $7c3f52cf960380f5$var$Eh() {
    for(var a = 0; a < $7c3f52cf960380f5$var$Dh.length; a++)$7c3f52cf960380f5$var$Dh[a]._workInProgressVersionPrimary = null;
    $7c3f52cf960380f5$var$Dh.length = 0;
}
var $7c3f52cf960380f5$var$Fh = $7c3f52cf960380f5$var$ua.ReactCurrentDispatcher, $7c3f52cf960380f5$var$Gh = $7c3f52cf960380f5$var$ua.ReactCurrentBatchConfig, $7c3f52cf960380f5$var$Hh = 0, $7c3f52cf960380f5$var$M = null, $7c3f52cf960380f5$var$N = null, $7c3f52cf960380f5$var$O = null, $7c3f52cf960380f5$var$Ih = !1, $7c3f52cf960380f5$var$Jh = !1, $7c3f52cf960380f5$var$Kh = 0, $7c3f52cf960380f5$var$Lh = 0;
function $7c3f52cf960380f5$var$P() {
    throw Error($7c3f52cf960380f5$var$p(321));
}
function $7c3f52cf960380f5$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$7c3f52cf960380f5$var$He(a[c], b[c])) return !1;
    return !0;
}
function $7c3f52cf960380f5$var$Nh(a, b, c, d, e, f) {
    $7c3f52cf960380f5$var$Hh = f;
    $7c3f52cf960380f5$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $7c3f52cf960380f5$var$Fh.current = null === a || null === a.memoizedState ? $7c3f52cf960380f5$var$Oh : $7c3f52cf960380f5$var$Ph;
    a = c(d, e);
    if ($7c3f52cf960380f5$var$Jh) {
        f = 0;
        do {
            $7c3f52cf960380f5$var$Jh = !1;
            $7c3f52cf960380f5$var$Kh = 0;
            if (25 <= f) throw Error($7c3f52cf960380f5$var$p(301));
            f += 1;
            $7c3f52cf960380f5$var$O = $7c3f52cf960380f5$var$N = null;
            b.updateQueue = null;
            $7c3f52cf960380f5$var$Fh.current = $7c3f52cf960380f5$var$Qh;
            a = c(d, e);
        }while ($7c3f52cf960380f5$var$Jh);
    }
    $7c3f52cf960380f5$var$Fh.current = $7c3f52cf960380f5$var$Rh;
    b = null !== $7c3f52cf960380f5$var$N && null !== $7c3f52cf960380f5$var$N.next;
    $7c3f52cf960380f5$var$Hh = 0;
    $7c3f52cf960380f5$var$O = $7c3f52cf960380f5$var$N = $7c3f52cf960380f5$var$M = null;
    $7c3f52cf960380f5$var$Ih = !1;
    if (b) throw Error($7c3f52cf960380f5$var$p(300));
    return a;
}
function $7c3f52cf960380f5$var$Sh() {
    var a = 0 !== $7c3f52cf960380f5$var$Kh;
    $7c3f52cf960380f5$var$Kh = 0;
    return a;
}
function $7c3f52cf960380f5$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $7c3f52cf960380f5$var$O ? $7c3f52cf960380f5$var$M.memoizedState = $7c3f52cf960380f5$var$O = a : $7c3f52cf960380f5$var$O = $7c3f52cf960380f5$var$O.next = a;
    return $7c3f52cf960380f5$var$O;
}
function $7c3f52cf960380f5$var$Uh() {
    if (null === $7c3f52cf960380f5$var$N) {
        var a = $7c3f52cf960380f5$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $7c3f52cf960380f5$var$N.next;
    var b = null === $7c3f52cf960380f5$var$O ? $7c3f52cf960380f5$var$M.memoizedState : $7c3f52cf960380f5$var$O.next;
    if (null !== b) $7c3f52cf960380f5$var$O = b, $7c3f52cf960380f5$var$N = a;
    else {
        if (null === a) throw Error($7c3f52cf960380f5$var$p(310));
        $7c3f52cf960380f5$var$N = a;
        a = {
            memoizedState: $7c3f52cf960380f5$var$N.memoizedState,
            baseState: $7c3f52cf960380f5$var$N.baseState,
            baseQueue: $7c3f52cf960380f5$var$N.baseQueue,
            queue: $7c3f52cf960380f5$var$N.queue,
            next: null
        };
        null === $7c3f52cf960380f5$var$O ? $7c3f52cf960380f5$var$M.memoizedState = $7c3f52cf960380f5$var$O = a : $7c3f52cf960380f5$var$O = $7c3f52cf960380f5$var$O.next = a;
    }
    return $7c3f52cf960380f5$var$O;
}
function $7c3f52cf960380f5$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $7c3f52cf960380f5$var$Wh(a) {
    var b = $7c3f52cf960380f5$var$Uh(), c = b.queue;
    if (null === c) throw Error($7c3f52cf960380f5$var$p(311));
    c.lastRenderedReducer = a;
    var d = $7c3f52cf960380f5$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($7c3f52cf960380f5$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $7c3f52cf960380f5$var$M.lanes |= m;
                $7c3f52cf960380f5$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $7c3f52cf960380f5$var$He(d, b.memoizedState) || ($7c3f52cf960380f5$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $7c3f52cf960380f5$var$M.lanes |= f, $7c3f52cf960380f5$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $7c3f52cf960380f5$var$Xh(a) {
    var b = $7c3f52cf960380f5$var$Uh(), c = b.queue;
    if (null === c) throw Error($7c3f52cf960380f5$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $7c3f52cf960380f5$var$He(f, b.memoizedState) || ($7c3f52cf960380f5$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $7c3f52cf960380f5$var$Yh() {}
function $7c3f52cf960380f5$var$Zh(a, b) {
    var c = $7c3f52cf960380f5$var$M, d = $7c3f52cf960380f5$var$Uh(), e = b(), f = !$7c3f52cf960380f5$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $7c3f52cf960380f5$var$dh = !0);
    d = d.queue;
    $7c3f52cf960380f5$var$$h($7c3f52cf960380f5$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $7c3f52cf960380f5$var$O && $7c3f52cf960380f5$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $7c3f52cf960380f5$var$bi(9, $7c3f52cf960380f5$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $7c3f52cf960380f5$var$Q) throw Error($7c3f52cf960380f5$var$p(349));
        0 !== ($7c3f52cf960380f5$var$Hh & 30) || $7c3f52cf960380f5$var$di(c, b, e);
    }
    return e;
}
function $7c3f52cf960380f5$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $7c3f52cf960380f5$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7c3f52cf960380f5$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $7c3f52cf960380f5$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $7c3f52cf960380f5$var$ei(b) && $7c3f52cf960380f5$var$fi(a);
}
function $7c3f52cf960380f5$var$ai(a, b, c) {
    return c(function() {
        $7c3f52cf960380f5$var$ei(b) && $7c3f52cf960380f5$var$fi(a);
    });
}
function $7c3f52cf960380f5$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$7c3f52cf960380f5$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $7c3f52cf960380f5$var$fi(a) {
    var b = $7c3f52cf960380f5$var$ih(a, 1);
    null !== b && $7c3f52cf960380f5$var$gi(b, a, 1, -1);
}
function $7c3f52cf960380f5$var$hi(a) {
    var b = $7c3f52cf960380f5$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $7c3f52cf960380f5$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $7c3f52cf960380f5$var$ii.bind(null, $7c3f52cf960380f5$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $7c3f52cf960380f5$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $7c3f52cf960380f5$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7c3f52cf960380f5$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $7c3f52cf960380f5$var$ji() {
    return $7c3f52cf960380f5$var$Uh().memoizedState;
}
function $7c3f52cf960380f5$var$ki(a, b, c, d) {
    var e = $7c3f52cf960380f5$var$Th();
    $7c3f52cf960380f5$var$M.flags |= a;
    e.memoizedState = $7c3f52cf960380f5$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $7c3f52cf960380f5$var$li(a, b, c, d) {
    var e = $7c3f52cf960380f5$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $7c3f52cf960380f5$var$N) {
        var g = $7c3f52cf960380f5$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $7c3f52cf960380f5$var$Mh(d, g.deps)) {
            e.memoizedState = $7c3f52cf960380f5$var$bi(b, c, f, d);
            return;
        }
    }
    $7c3f52cf960380f5$var$M.flags |= a;
    e.memoizedState = $7c3f52cf960380f5$var$bi(1 | b, c, f, d);
}
function $7c3f52cf960380f5$var$mi(a, b) {
    return $7c3f52cf960380f5$var$ki(8390656, 8, a, b);
}
function $7c3f52cf960380f5$var$$h(a, b) {
    return $7c3f52cf960380f5$var$li(2048, 8, a, b);
}
function $7c3f52cf960380f5$var$ni(a, b) {
    return $7c3f52cf960380f5$var$li(4, 2, a, b);
}
function $7c3f52cf960380f5$var$oi(a, b) {
    return $7c3f52cf960380f5$var$li(4, 4, a, b);
}
function $7c3f52cf960380f5$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $7c3f52cf960380f5$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $7c3f52cf960380f5$var$li(4, 4, $7c3f52cf960380f5$var$pi.bind(null, b, a), c);
}
function $7c3f52cf960380f5$var$ri() {}
function $7c3f52cf960380f5$var$si(a, b) {
    var c = $7c3f52cf960380f5$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7c3f52cf960380f5$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7c3f52cf960380f5$var$ti(a, b) {
    var c = $7c3f52cf960380f5$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7c3f52cf960380f5$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7c3f52cf960380f5$var$ui(a, b, c) {
    if (0 === ($7c3f52cf960380f5$var$Hh & 21)) return a.baseState && (a.baseState = !1, $7c3f52cf960380f5$var$dh = !0), a.memoizedState = c;
    $7c3f52cf960380f5$var$He(c, b) || (c = $7c3f52cf960380f5$var$yc(), $7c3f52cf960380f5$var$M.lanes |= c, $7c3f52cf960380f5$var$rh |= c, a.baseState = !0);
    return b;
}
function $7c3f52cf960380f5$var$vi(a, b) {
    var c = $7c3f52cf960380f5$var$C;
    $7c3f52cf960380f5$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $7c3f52cf960380f5$var$Gh.transition;
    $7c3f52cf960380f5$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $7c3f52cf960380f5$var$C = c, $7c3f52cf960380f5$var$Gh.transition = d;
    }
}
function $7c3f52cf960380f5$var$wi() {
    return $7c3f52cf960380f5$var$Uh().memoizedState;
}
function $7c3f52cf960380f5$var$xi(a, b, c) {
    var d = $7c3f52cf960380f5$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7c3f52cf960380f5$var$zi(a)) $7c3f52cf960380f5$var$Ai(b, c);
    else if (c = $7c3f52cf960380f5$var$hh(a, b, c, d), null !== c) {
        var e = $7c3f52cf960380f5$var$R();
        $7c3f52cf960380f5$var$gi(c, a, d, e);
        $7c3f52cf960380f5$var$Bi(c, b, d);
    }
}
function $7c3f52cf960380f5$var$ii(a, b, c) {
    var d = $7c3f52cf960380f5$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7c3f52cf960380f5$var$zi(a)) $7c3f52cf960380f5$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($7c3f52cf960380f5$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $7c3f52cf960380f5$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $7c3f52cf960380f5$var$hh(a, b, e, d);
        null !== c && (e = $7c3f52cf960380f5$var$R(), $7c3f52cf960380f5$var$gi(c, a, d, e), $7c3f52cf960380f5$var$Bi(c, b, d));
    }
}
function $7c3f52cf960380f5$var$zi(a) {
    var b = a.alternate;
    return a === $7c3f52cf960380f5$var$M || null !== b && b === $7c3f52cf960380f5$var$M;
}
function $7c3f52cf960380f5$var$Ai(a, b) {
    $7c3f52cf960380f5$var$Jh = $7c3f52cf960380f5$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $7c3f52cf960380f5$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7c3f52cf960380f5$var$Cc(a, c);
    }
}
var $7c3f52cf960380f5$var$Rh = {
    readContext: $7c3f52cf960380f5$var$eh,
    useCallback: $7c3f52cf960380f5$var$P,
    useContext: $7c3f52cf960380f5$var$P,
    useEffect: $7c3f52cf960380f5$var$P,
    useImperativeHandle: $7c3f52cf960380f5$var$P,
    useInsertionEffect: $7c3f52cf960380f5$var$P,
    useLayoutEffect: $7c3f52cf960380f5$var$P,
    useMemo: $7c3f52cf960380f5$var$P,
    useReducer: $7c3f52cf960380f5$var$P,
    useRef: $7c3f52cf960380f5$var$P,
    useState: $7c3f52cf960380f5$var$P,
    useDebugValue: $7c3f52cf960380f5$var$P,
    useDeferredValue: $7c3f52cf960380f5$var$P,
    useTransition: $7c3f52cf960380f5$var$P,
    useMutableSource: $7c3f52cf960380f5$var$P,
    useSyncExternalStore: $7c3f52cf960380f5$var$P,
    useId: $7c3f52cf960380f5$var$P,
    unstable_isNewReconciler: !1
}, $7c3f52cf960380f5$var$Oh = {
    readContext: $7c3f52cf960380f5$var$eh,
    useCallback: function useCallback(a, b) {
        $7c3f52cf960380f5$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $7c3f52cf960380f5$var$eh,
    useEffect: $7c3f52cf960380f5$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $7c3f52cf960380f5$var$ki(4194308, 4, $7c3f52cf960380f5$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $7c3f52cf960380f5$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $7c3f52cf960380f5$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $7c3f52cf960380f5$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $7c3f52cf960380f5$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $7c3f52cf960380f5$var$xi.bind(null, $7c3f52cf960380f5$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $7c3f52cf960380f5$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $7c3f52cf960380f5$var$hi,
    useDebugValue: $7c3f52cf960380f5$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $7c3f52cf960380f5$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $7c3f52cf960380f5$var$hi(!1), b = a[0];
        a = $7c3f52cf960380f5$var$vi.bind(null, a[1]);
        $7c3f52cf960380f5$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $7c3f52cf960380f5$var$M, e = $7c3f52cf960380f5$var$Th();
        if ($7c3f52cf960380f5$var$I) {
            if (void 0 === c) throw Error($7c3f52cf960380f5$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $7c3f52cf960380f5$var$Q) throw Error($7c3f52cf960380f5$var$p(349));
            0 !== ($7c3f52cf960380f5$var$Hh & 30) || $7c3f52cf960380f5$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $7c3f52cf960380f5$var$mi($7c3f52cf960380f5$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $7c3f52cf960380f5$var$bi(9, $7c3f52cf960380f5$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $7c3f52cf960380f5$var$Th(), b = $7c3f52cf960380f5$var$Q.identifierPrefix;
        if ($7c3f52cf960380f5$var$I) {
            var c = $7c3f52cf960380f5$var$sg;
            var d = $7c3f52cf960380f5$var$rg;
            c = (d & ~(1 << 32 - $7c3f52cf960380f5$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $7c3f52cf960380f5$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $7c3f52cf960380f5$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $7c3f52cf960380f5$var$Ph = {
    readContext: $7c3f52cf960380f5$var$eh,
    useCallback: $7c3f52cf960380f5$var$si,
    useContext: $7c3f52cf960380f5$var$eh,
    useEffect: $7c3f52cf960380f5$var$$h,
    useImperativeHandle: $7c3f52cf960380f5$var$qi,
    useInsertionEffect: $7c3f52cf960380f5$var$ni,
    useLayoutEffect: $7c3f52cf960380f5$var$oi,
    useMemo: $7c3f52cf960380f5$var$ti,
    useReducer: $7c3f52cf960380f5$var$Wh,
    useRef: $7c3f52cf960380f5$var$ji,
    useState: function useState() {
        return $7c3f52cf960380f5$var$Wh($7c3f52cf960380f5$var$Vh);
    },
    useDebugValue: $7c3f52cf960380f5$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $7c3f52cf960380f5$var$Uh();
        return $7c3f52cf960380f5$var$ui(b, $7c3f52cf960380f5$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $7c3f52cf960380f5$var$Wh($7c3f52cf960380f5$var$Vh)[0], b = $7c3f52cf960380f5$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7c3f52cf960380f5$var$Yh,
    useSyncExternalStore: $7c3f52cf960380f5$var$Zh,
    useId: $7c3f52cf960380f5$var$wi,
    unstable_isNewReconciler: !1
}, $7c3f52cf960380f5$var$Qh = {
    readContext: $7c3f52cf960380f5$var$eh,
    useCallback: $7c3f52cf960380f5$var$si,
    useContext: $7c3f52cf960380f5$var$eh,
    useEffect: $7c3f52cf960380f5$var$$h,
    useImperativeHandle: $7c3f52cf960380f5$var$qi,
    useInsertionEffect: $7c3f52cf960380f5$var$ni,
    useLayoutEffect: $7c3f52cf960380f5$var$oi,
    useMemo: $7c3f52cf960380f5$var$ti,
    useReducer: $7c3f52cf960380f5$var$Xh,
    useRef: $7c3f52cf960380f5$var$ji,
    useState: function useState() {
        return $7c3f52cf960380f5$var$Xh($7c3f52cf960380f5$var$Vh);
    },
    useDebugValue: $7c3f52cf960380f5$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $7c3f52cf960380f5$var$Uh();
        return null === $7c3f52cf960380f5$var$N ? b.memoizedState = a : $7c3f52cf960380f5$var$ui(b, $7c3f52cf960380f5$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $7c3f52cf960380f5$var$Xh($7c3f52cf960380f5$var$Vh)[0], b = $7c3f52cf960380f5$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7c3f52cf960380f5$var$Yh,
    useSyncExternalStore: $7c3f52cf960380f5$var$Zh,
    useId: $7c3f52cf960380f5$var$wi,
    unstable_isNewReconciler: !1
};
function $7c3f52cf960380f5$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $7c3f52cf960380f5$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $7c3f52cf960380f5$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $7c3f52cf960380f5$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $7c3f52cf960380f5$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $7c3f52cf960380f5$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $7c3f52cf960380f5$var$R(), e = $7c3f52cf960380f5$var$yi(a), f = $7c3f52cf960380f5$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7c3f52cf960380f5$var$nh(a, f, e);
        null !== b && ($7c3f52cf960380f5$var$gi(b, a, e, d), $7c3f52cf960380f5$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $7c3f52cf960380f5$var$R(), e = $7c3f52cf960380f5$var$yi(a), f = $7c3f52cf960380f5$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7c3f52cf960380f5$var$nh(a, f, e);
        null !== b && ($7c3f52cf960380f5$var$gi(b, a, e, d), $7c3f52cf960380f5$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $7c3f52cf960380f5$var$R(), d = $7c3f52cf960380f5$var$yi(a), e = $7c3f52cf960380f5$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $7c3f52cf960380f5$var$nh(a, e, d);
        null !== b && ($7c3f52cf960380f5$var$gi(b, a, d, c), $7c3f52cf960380f5$var$oh(b, a, d));
    }
};
function $7c3f52cf960380f5$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$7c3f52cf960380f5$var$Ie(c, d) || !$7c3f52cf960380f5$var$Ie(e, f) : !0;
}
function $7c3f52cf960380f5$var$Gi(a, b, c) {
    var d = !1, e = $7c3f52cf960380f5$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $2xTNA._)(f)) && null !== f ? f = $7c3f52cf960380f5$var$eh(f) : (e = $7c3f52cf960380f5$var$Zf(b) ? $7c3f52cf960380f5$var$Xf : $7c3f52cf960380f5$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $7c3f52cf960380f5$var$Yf(a, e) : $7c3f52cf960380f5$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $7c3f52cf960380f5$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $7c3f52cf960380f5$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $7c3f52cf960380f5$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $7c3f52cf960380f5$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $7c3f52cf960380f5$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $2xTNA._)(f)) && null !== f ? e.context = $7c3f52cf960380f5$var$eh(f) : (f = $7c3f52cf960380f5$var$Zf(b) ? $7c3f52cf960380f5$var$Xf : $7c3f52cf960380f5$var$H.current, e.context = $7c3f52cf960380f5$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($7c3f52cf960380f5$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $7c3f52cf960380f5$var$Ei.enqueueReplaceState(e, e.state, null), $7c3f52cf960380f5$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $7c3f52cf960380f5$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $7c3f52cf960380f5$var$Pa(d), d = d["return"];
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $7c3f52cf960380f5$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $7c3f52cf960380f5$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $7c3f52cf960380f5$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $7c3f52cf960380f5$var$Ni(a, b, c) {
    c = $7c3f52cf960380f5$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $7c3f52cf960380f5$var$Oi || ($7c3f52cf960380f5$var$Oi = !0, $7c3f52cf960380f5$var$Pi = d);
        $7c3f52cf960380f5$var$Li(a, b);
    };
    return c;
}
function $7c3f52cf960380f5$var$Qi(a, b, c) {
    c = $7c3f52cf960380f5$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $7c3f52cf960380f5$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $7c3f52cf960380f5$var$Li(a, b);
        "function" !== typeof d && (null === $7c3f52cf960380f5$var$Ri ? $7c3f52cf960380f5$var$Ri = new Set([
            this
        ]) : $7c3f52cf960380f5$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $7c3f52cf960380f5$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $7c3f52cf960380f5$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $7c3f52cf960380f5$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $7c3f52cf960380f5$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a["return"];
    }while (null !== a);
    return null;
}
function $7c3f52cf960380f5$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $7c3f52cf960380f5$var$mh(-1, 1), b.tag = 2, $7c3f52cf960380f5$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $7c3f52cf960380f5$var$Wi = $7c3f52cf960380f5$var$ua.ReactCurrentOwner, $7c3f52cf960380f5$var$dh = !1;
function $7c3f52cf960380f5$var$Xi(a, b, c, d) {
    b.child = null === a ? $7c3f52cf960380f5$var$Vg(b, null, c, d) : $7c3f52cf960380f5$var$Ug(b, a.child, c, d);
}
function $7c3f52cf960380f5$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $7c3f52cf960380f5$var$ch(b, e);
    d = $7c3f52cf960380f5$var$Nh(a, b, c, d, f, e);
    c = $7c3f52cf960380f5$var$Sh();
    if (null !== a && !$7c3f52cf960380f5$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7c3f52cf960380f5$var$Zi(a, b, e);
    $7c3f52cf960380f5$var$I && c && $7c3f52cf960380f5$var$vg(b);
    b.flags |= 1;
    $7c3f52cf960380f5$var$Xi(a, b, d, e);
    return b.child;
}
function $7c3f52cf960380f5$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$7c3f52cf960380f5$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $7c3f52cf960380f5$var$bj(a, b, f, d, e);
        a = $7c3f52cf960380f5$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a["return"] = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $7c3f52cf960380f5$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $7c3f52cf960380f5$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $7c3f52cf960380f5$var$Pg(f, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
}
function $7c3f52cf960380f5$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($7c3f52cf960380f5$var$Ie(f, d) && a.ref === b.ref) {
            if ($7c3f52cf960380f5$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($7c3f52cf960380f5$var$dh = !0);
            else return b.lanes = a.lanes, $7c3f52cf960380f5$var$Zi(a, b, e);
        }
    }
    return $7c3f52cf960380f5$var$cj(a, b, c, d, e);
}
function $7c3f52cf960380f5$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$ej, $7c3f52cf960380f5$var$fj), $7c3f52cf960380f5$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$ej, $7c3f52cf960380f5$var$fj), $7c3f52cf960380f5$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$ej, $7c3f52cf960380f5$var$fj);
            $7c3f52cf960380f5$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$ej, $7c3f52cf960380f5$var$fj), $7c3f52cf960380f5$var$fj |= d;
    $7c3f52cf960380f5$var$Xi(a, b, e, c);
    return b.child;
}
function $7c3f52cf960380f5$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $7c3f52cf960380f5$var$cj(a, b, c, d, e) {
    var f = $7c3f52cf960380f5$var$Zf(c) ? $7c3f52cf960380f5$var$Xf : $7c3f52cf960380f5$var$H.current;
    f = $7c3f52cf960380f5$var$Yf(b, f);
    $7c3f52cf960380f5$var$ch(b, e);
    c = $7c3f52cf960380f5$var$Nh(a, b, c, d, f, e);
    d = $7c3f52cf960380f5$var$Sh();
    if (null !== a && !$7c3f52cf960380f5$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7c3f52cf960380f5$var$Zi(a, b, e);
    $7c3f52cf960380f5$var$I && d && $7c3f52cf960380f5$var$vg(b);
    b.flags |= 1;
    $7c3f52cf960380f5$var$Xi(a, b, c, e);
    return b.child;
}
function $7c3f52cf960380f5$var$hj(a, b, c, d, e) {
    if ($7c3f52cf960380f5$var$Zf(c)) {
        var f = !0;
        $7c3f52cf960380f5$var$cg(b);
    } else f = !1;
    $7c3f52cf960380f5$var$ch(b, e);
    if (null === b.stateNode) $7c3f52cf960380f5$var$ij(a, b), $7c3f52cf960380f5$var$Gi(b, c, d), $7c3f52cf960380f5$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $2xTNA._)(l)) && null !== l ? l = $7c3f52cf960380f5$var$eh(l) : (l = $7c3f52cf960380f5$var$Zf(c) ? $7c3f52cf960380f5$var$Xf : $7c3f52cf960380f5$var$H.current, l = $7c3f52cf960380f5$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $7c3f52cf960380f5$var$Hi(b, g, d, l);
        $7c3f52cf960380f5$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $7c3f52cf960380f5$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $7c3f52cf960380f5$var$Wf.current || $7c3f52cf960380f5$var$jh ? ("function" === typeof m && ($7c3f52cf960380f5$var$Di(b, c, m, d), k = b.memoizedState), (h = $7c3f52cf960380f5$var$jh || $7c3f52cf960380f5$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $7c3f52cf960380f5$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $7c3f52cf960380f5$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $2xTNA._)(k)) && null !== k ? k = $7c3f52cf960380f5$var$eh(k) : (k = $7c3f52cf960380f5$var$Zf(c) ? $7c3f52cf960380f5$var$Xf : $7c3f52cf960380f5$var$H.current, k = $7c3f52cf960380f5$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $7c3f52cf960380f5$var$Hi(b, g, d, k);
        $7c3f52cf960380f5$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $7c3f52cf960380f5$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $7c3f52cf960380f5$var$Wf.current || $7c3f52cf960380f5$var$jh ? ("function" === typeof y && ($7c3f52cf960380f5$var$Di(b, c, y, d), n = b.memoizedState), (l = $7c3f52cf960380f5$var$jh || $7c3f52cf960380f5$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $7c3f52cf960380f5$var$jj(a, b, c, d, f, e);
}
function $7c3f52cf960380f5$var$jj(a, b, c, d, e, f) {
    $7c3f52cf960380f5$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $7c3f52cf960380f5$var$dg(b, c, !1), $7c3f52cf960380f5$var$Zi(a, b, f);
    d = b.stateNode;
    $7c3f52cf960380f5$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $7c3f52cf960380f5$var$Ug(b, a.child, null, f), b.child = $7c3f52cf960380f5$var$Ug(b, null, h, f)) : $7c3f52cf960380f5$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $7c3f52cf960380f5$var$dg(b, c, !0);
    return b.child;
}
function $7c3f52cf960380f5$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $7c3f52cf960380f5$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $7c3f52cf960380f5$var$ag(a, b.context, !1);
    $7c3f52cf960380f5$var$yh(a, b.containerInfo);
}
function $7c3f52cf960380f5$var$lj(a, b, c, d, e) {
    $7c3f52cf960380f5$var$Ig();
    $7c3f52cf960380f5$var$Jg(e);
    b.flags |= 256;
    $7c3f52cf960380f5$var$Xi(a, b, c, d);
    return b.child;
}
var $7c3f52cf960380f5$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $7c3f52cf960380f5$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $7c3f52cf960380f5$var$oj(a, b, c) {
    var d = b.pendingProps, e = $7c3f52cf960380f5$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, e & 1);
    if (null === a) {
        $7c3f52cf960380f5$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $7c3f52cf960380f5$var$pj(g, d, 0, null), a = $7c3f52cf960380f5$var$Tg(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = $7c3f52cf960380f5$var$nj(c), b.memoizedState = $7c3f52cf960380f5$var$mj, a) : $7c3f52cf960380f5$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $7c3f52cf960380f5$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $7c3f52cf960380f5$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $7c3f52cf960380f5$var$Pg(h, f) : (f = $7c3f52cf960380f5$var$Tg(f, g, c, null), f.flags |= 2);
        f["return"] = b;
        d["return"] = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $7c3f52cf960380f5$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $7c3f52cf960380f5$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $7c3f52cf960380f5$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d["return"] = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $7c3f52cf960380f5$var$qj(a, b) {
    b = $7c3f52cf960380f5$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b["return"] = a;
    return a.child = b;
}
function $7c3f52cf960380f5$var$sj(a, b, c, d) {
    null !== d && $7c3f52cf960380f5$var$Jg(d);
    $7c3f52cf960380f5$var$Ug(b, a.child, null, c);
    a = $7c3f52cf960380f5$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $7c3f52cf960380f5$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $7c3f52cf960380f5$var$Ki(Error($7c3f52cf960380f5$var$p(422))), $7c3f52cf960380f5$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $7c3f52cf960380f5$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $7c3f52cf960380f5$var$Tg(f, e, g, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $7c3f52cf960380f5$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $7c3f52cf960380f5$var$nj(g);
        b.memoizedState = $7c3f52cf960380f5$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $7c3f52cf960380f5$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($7c3f52cf960380f5$var$p(419));
        d = $7c3f52cf960380f5$var$Ki(f, d, void 0);
        return $7c3f52cf960380f5$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($7c3f52cf960380f5$var$dh || h) {
        d = $7c3f52cf960380f5$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $7c3f52cf960380f5$var$ih(a, e), $7c3f52cf960380f5$var$gi(d, a, e, -1));
        }
        $7c3f52cf960380f5$var$tj();
        d = $7c3f52cf960380f5$var$Ki(Error($7c3f52cf960380f5$var$p(421)));
        return $7c3f52cf960380f5$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $7c3f52cf960380f5$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $7c3f52cf960380f5$var$yg = $7c3f52cf960380f5$var$Lf(e.nextSibling);
    $7c3f52cf960380f5$var$xg = b;
    $7c3f52cf960380f5$var$I = !0;
    $7c3f52cf960380f5$var$zg = null;
    null !== a && ($7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg++] = $7c3f52cf960380f5$var$rg, $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg++] = $7c3f52cf960380f5$var$sg, $7c3f52cf960380f5$var$og[$7c3f52cf960380f5$var$pg++] = $7c3f52cf960380f5$var$qg, $7c3f52cf960380f5$var$rg = a.id, $7c3f52cf960380f5$var$sg = a.overflow, $7c3f52cf960380f5$var$qg = b);
    b = $7c3f52cf960380f5$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $7c3f52cf960380f5$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $7c3f52cf960380f5$var$bh(a["return"], b, c);
}
function $7c3f52cf960380f5$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $7c3f52cf960380f5$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $7c3f52cf960380f5$var$Xi(a, b, d.children, c);
    d = $7c3f52cf960380f5$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $7c3f52cf960380f5$var$vj(a, c, b);
            else if (19 === a.tag) $7c3f52cf960380f5$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child["return"] = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a["return"] || a["return"] === b) break a;
                a = a["return"];
            }
            a.sibling["return"] = a["return"];
            a = a.sibling;
        }
        d &= 1;
    }
    $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $7c3f52cf960380f5$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $7c3f52cf960380f5$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $7c3f52cf960380f5$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $7c3f52cf960380f5$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $7c3f52cf960380f5$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $7c3f52cf960380f5$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $7c3f52cf960380f5$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $7c3f52cf960380f5$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($7c3f52cf960380f5$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $7c3f52cf960380f5$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c["return"] = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $7c3f52cf960380f5$var$Pg(a, a.pendingProps), c["return"] = b;
        c.sibling = null;
    }
    return b.child;
}
function $7c3f52cf960380f5$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $7c3f52cf960380f5$var$kj(b);
            $7c3f52cf960380f5$var$Ig();
            break;
        case 5:
            $7c3f52cf960380f5$var$Ah(b);
            break;
        case 1:
            $7c3f52cf960380f5$var$Zf(b.type) && $7c3f52cf960380f5$var$cg(b);
            break;
        case 4:
            $7c3f52cf960380f5$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, $7c3f52cf960380f5$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $7c3f52cf960380f5$var$oj(a, b, c);
                $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, $7c3f52cf960380f5$var$L.current & 1);
                a = $7c3f52cf960380f5$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, $7c3f52cf960380f5$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $7c3f52cf960380f5$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, $7c3f52cf960380f5$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $7c3f52cf960380f5$var$dj(a, b, c);
    }
    return $7c3f52cf960380f5$var$Zi(a, b, c);
}
var $7c3f52cf960380f5$var$zj, $7c3f52cf960380f5$var$Aj, $7c3f52cf960380f5$var$Bj, $7c3f52cf960380f5$var$Cj;
$7c3f52cf960380f5$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child["return"] = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c["return"] || c["return"] === b) return;
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        c = c.sibling;
    }
};
$7c3f52cf960380f5$var$Aj = function Aj() {};
$7c3f52cf960380f5$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $7c3f52cf960380f5$var$Ya(a, e);
                d = $7c3f52cf960380f5$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $7c3f52cf960380f5$var$A({}, e, {
                    value: void 0
                });
                d = $7c3f52cf960380f5$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $7c3f52cf960380f5$var$gb(a, e);
                d = $7c3f52cf960380f5$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $7c3f52cf960380f5$var$Bf);
        }
        $7c3f52cf960380f5$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($7c3f52cf960380f5$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($7c3f52cf960380f5$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $7c3f52cf960380f5$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$7c3f52cf960380f5$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $7c3f52cf960380f5$var$Dj(a, b) {
    if (!$7c3f52cf960380f5$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $7c3f52cf960380f5$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $7c3f52cf960380f5$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $7c3f52cf960380f5$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $7c3f52cf960380f5$var$S(b), null;
        case 1:
            return $7c3f52cf960380f5$var$Zf(b.type) && $7c3f52cf960380f5$var$$f(), $7c3f52cf960380f5$var$S(b), null;
        case 3:
            d = b.stateNode;
            $7c3f52cf960380f5$var$zh();
            $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wf);
            $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$H);
            $7c3f52cf960380f5$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $7c3f52cf960380f5$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $7c3f52cf960380f5$var$zg && ($7c3f52cf960380f5$var$Fj($7c3f52cf960380f5$var$zg), $7c3f52cf960380f5$var$zg = null));
            $7c3f52cf960380f5$var$Aj(a, b);
            $7c3f52cf960380f5$var$S(b);
            return null;
        case 5:
            $7c3f52cf960380f5$var$Bh(b);
            var e = $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $7c3f52cf960380f5$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($7c3f52cf960380f5$var$p(166));
                    $7c3f52cf960380f5$var$S(b);
                    return null;
                }
                a = $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$uh.current);
                if ($7c3f52cf960380f5$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$7c3f52cf960380f5$var$Of] = b;
                    d[$7c3f52cf960380f5$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $7c3f52cf960380f5$var$D("cancel", d);
                            $7c3f52cf960380f5$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $7c3f52cf960380f5$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $7c3f52cf960380f5$var$lf.length; e++)$7c3f52cf960380f5$var$D($7c3f52cf960380f5$var$lf[e], d);
                            break;
                        case "source":
                            $7c3f52cf960380f5$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $7c3f52cf960380f5$var$D("error", d);
                            $7c3f52cf960380f5$var$D("load", d);
                            break;
                        case "details":
                            $7c3f52cf960380f5$var$D("toggle", d);
                            break;
                        case "input":
                            $7c3f52cf960380f5$var$Za(d, f);
                            $7c3f52cf960380f5$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $7c3f52cf960380f5$var$D("invalid", d);
                            break;
                        case "textarea":
                            $7c3f52cf960380f5$var$hb(d, f), $7c3f52cf960380f5$var$D("invalid", d);
                    }
                    $7c3f52cf960380f5$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $7c3f52cf960380f5$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $7c3f52cf960380f5$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $7c3f52cf960380f5$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $7c3f52cf960380f5$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $7c3f52cf960380f5$var$Va(d);
                            $7c3f52cf960380f5$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $7c3f52cf960380f5$var$Va(d);
                            $7c3f52cf960380f5$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $7c3f52cf960380f5$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $7c3f52cf960380f5$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$7c3f52cf960380f5$var$Of] = b;
                    a[$7c3f52cf960380f5$var$Pf] = d;
                    $7c3f52cf960380f5$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $7c3f52cf960380f5$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $7c3f52cf960380f5$var$D("cancel", a);
                                $7c3f52cf960380f5$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $7c3f52cf960380f5$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $7c3f52cf960380f5$var$lf.length; e++)$7c3f52cf960380f5$var$D($7c3f52cf960380f5$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $7c3f52cf960380f5$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $7c3f52cf960380f5$var$D("error", a);
                                $7c3f52cf960380f5$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $7c3f52cf960380f5$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $7c3f52cf960380f5$var$Za(a, d);
                                e = $7c3f52cf960380f5$var$Ya(a, d);
                                $7c3f52cf960380f5$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $7c3f52cf960380f5$var$A({}, d, {
                                    value: void 0
                                });
                                $7c3f52cf960380f5$var$D("invalid", a);
                                break;
                            case "textarea":
                                $7c3f52cf960380f5$var$hb(a, d);
                                e = $7c3f52cf960380f5$var$gb(a, d);
                                $7c3f52cf960380f5$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $7c3f52cf960380f5$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $7c3f52cf960380f5$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $7c3f52cf960380f5$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $7c3f52cf960380f5$var$ob(a, k) : "number" === typeof k && $7c3f52cf960380f5$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($7c3f52cf960380f5$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $7c3f52cf960380f5$var$D("scroll", a) : null != k && $7c3f52cf960380f5$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $7c3f52cf960380f5$var$Va(a);
                                $7c3f52cf960380f5$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $7c3f52cf960380f5$var$Va(a);
                                $7c3f52cf960380f5$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $7c3f52cf960380f5$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $7c3f52cf960380f5$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $7c3f52cf960380f5$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $7c3f52cf960380f5$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $7c3f52cf960380f5$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $7c3f52cf960380f5$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($7c3f52cf960380f5$var$p(166));
                c = $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$wh.current);
                $7c3f52cf960380f5$var$xh($7c3f52cf960380f5$var$uh.current);
                if ($7c3f52cf960380f5$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$7c3f52cf960380f5$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $7c3f52cf960380f5$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $7c3f52cf960380f5$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $7c3f52cf960380f5$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$7c3f52cf960380f5$var$Of] = b, b.stateNode = d;
            }
            $7c3f52cf960380f5$var$S(b);
            return null;
        case 13:
            $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($7c3f52cf960380f5$var$I && null !== $7c3f52cf960380f5$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $7c3f52cf960380f5$var$Hg(), $7c3f52cf960380f5$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $7c3f52cf960380f5$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($7c3f52cf960380f5$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($7c3f52cf960380f5$var$p(317));
                        f[$7c3f52cf960380f5$var$Of] = b;
                    } else $7c3f52cf960380f5$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $7c3f52cf960380f5$var$S(b);
                    f = !1;
                } else null !== $7c3f52cf960380f5$var$zg && ($7c3f52cf960380f5$var$Fj($7c3f52cf960380f5$var$zg), $7c3f52cf960380f5$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($7c3f52cf960380f5$var$L.current & 1) ? 0 === $7c3f52cf960380f5$var$T && ($7c3f52cf960380f5$var$T = 3) : $7c3f52cf960380f5$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $7c3f52cf960380f5$var$S(b);
            return null;
        case 4:
            return $7c3f52cf960380f5$var$zh(), $7c3f52cf960380f5$var$Aj(a, b), null === a && $7c3f52cf960380f5$var$sf(b.stateNode.containerInfo), $7c3f52cf960380f5$var$S(b), null;
        case 10:
            return $7c3f52cf960380f5$var$ah(b.type._context), $7c3f52cf960380f5$var$S(b), null;
        case 17:
            return $7c3f52cf960380f5$var$Zf(b.type) && $7c3f52cf960380f5$var$$f(), $7c3f52cf960380f5$var$S(b), null;
        case 19:
            $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$L);
            f = b.memoizedState;
            if (null === f) return $7c3f52cf960380f5$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $7c3f52cf960380f5$var$Dj(f, !1);
                else {
                    if (0 !== $7c3f52cf960380f5$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $7c3f52cf960380f5$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $7c3f52cf960380f5$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, $7c3f52cf960380f5$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $7c3f52cf960380f5$var$B() > $7c3f52cf960380f5$var$Gj && (b.flags |= 128, d = !0, $7c3f52cf960380f5$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $7c3f52cf960380f5$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $7c3f52cf960380f5$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$7c3f52cf960380f5$var$I) return $7c3f52cf960380f5$var$S(b), null;
                    } else 2 * $7c3f52cf960380f5$var$B() - f.renderingStartTime > $7c3f52cf960380f5$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $7c3f52cf960380f5$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $7c3f52cf960380f5$var$B(), b.sibling = null, c = $7c3f52cf960380f5$var$L.current, $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$L, d ? c & 1 | 2 : c & 1), b;
            $7c3f52cf960380f5$var$S(b);
            return null;
        case 22:
        case 23:
            return $7c3f52cf960380f5$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($7c3f52cf960380f5$var$fj & 1073741824) && ($7c3f52cf960380f5$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $7c3f52cf960380f5$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($7c3f52cf960380f5$var$p(156, b.tag));
}
function $7c3f52cf960380f5$var$Ij(a, b) {
    $7c3f52cf960380f5$var$wg(b);
    switch(b.tag){
        case 1:
            return $7c3f52cf960380f5$var$Zf(b.type) && $7c3f52cf960380f5$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $7c3f52cf960380f5$var$zh(), $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wf), $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$H), $7c3f52cf960380f5$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $7c3f52cf960380f5$var$Bh(b), null;
        case 13:
            $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($7c3f52cf960380f5$var$p(340));
                $7c3f52cf960380f5$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$L), null;
        case 4:
            return $7c3f52cf960380f5$var$zh(), null;
        case 10:
            return $7c3f52cf960380f5$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $7c3f52cf960380f5$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $7c3f52cf960380f5$var$Jj = !1, $7c3f52cf960380f5$var$U = !1, $7c3f52cf960380f5$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $7c3f52cf960380f5$var$V = null;
function $7c3f52cf960380f5$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $7c3f52cf960380f5$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $7c3f52cf960380f5$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $7c3f52cf960380f5$var$W(a, b, d);
    }
}
var $7c3f52cf960380f5$var$Nj = !1;
function $7c3f52cf960380f5$var$Oj(a, b) {
    $7c3f52cf960380f5$var$Cf = $7c3f52cf960380f5$var$dd;
    a = $7c3f52cf960380f5$var$Me();
    if ($7c3f52cf960380f5$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $7c3f52cf960380f5$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $7c3f52cf960380f5$var$dd = !1;
    for($7c3f52cf960380f5$var$V = b; null !== $7c3f52cf960380f5$var$V;)if (b = $7c3f52cf960380f5$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, $7c3f52cf960380f5$var$V = a;
    else for(; null !== $7c3f52cf960380f5$var$V;){
        b = $7c3f52cf960380f5$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $7c3f52cf960380f5$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($7c3f52cf960380f5$var$p(163));
            }
        } catch (F) {
            $7c3f52cf960380f5$var$W(b, b["return"], F);
        }
        a = b.sibling;
        if (null !== a) {
            a["return"] = b["return"];
            $7c3f52cf960380f5$var$V = a;
            break;
        }
        $7c3f52cf960380f5$var$V = b["return"];
    }
    n = $7c3f52cf960380f5$var$Nj;
    $7c3f52cf960380f5$var$Nj = !1;
    return n;
}
function $7c3f52cf960380f5$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $7c3f52cf960380f5$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $7c3f52cf960380f5$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $7c3f52cf960380f5$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $7c3f52cf960380f5$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $7c3f52cf960380f5$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$7c3f52cf960380f5$var$Of], delete b[$7c3f52cf960380f5$var$Pf], delete b[$7c3f52cf960380f5$var$of], delete b[$7c3f52cf960380f5$var$Qf], delete b[$7c3f52cf960380f5$var$Rf]));
    a.stateNode = null;
    a["return"] = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $7c3f52cf960380f5$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $7c3f52cf960380f5$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a["return"] || $7c3f52cf960380f5$var$Tj(a["return"])) return null;
            a = a["return"];
        }
        a.sibling["return"] = a["return"];
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child["return"] = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $7c3f52cf960380f5$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $7c3f52cf960380f5$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($7c3f52cf960380f5$var$Vj(a, b, c), a = a.sibling; null !== a;)$7c3f52cf960380f5$var$Vj(a, b, c), a = a.sibling;
}
function $7c3f52cf960380f5$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($7c3f52cf960380f5$var$Wj(a, b, c), a = a.sibling; null !== a;)$7c3f52cf960380f5$var$Wj(a, b, c), a = a.sibling;
}
var $7c3f52cf960380f5$var$X = null, $7c3f52cf960380f5$var$Xj = !1;
function $7c3f52cf960380f5$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$7c3f52cf960380f5$var$Zj(a, b, c), c = c.sibling;
}
function $7c3f52cf960380f5$var$Zj(a, b, c) {
    if ($7c3f52cf960380f5$var$lc && "function" === typeof $7c3f52cf960380f5$var$lc.onCommitFiberUnmount) try {
        $7c3f52cf960380f5$var$lc.onCommitFiberUnmount($7c3f52cf960380f5$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $7c3f52cf960380f5$var$U || $7c3f52cf960380f5$var$Lj(c, b);
        case 6:
            var d = $7c3f52cf960380f5$var$X, e = $7c3f52cf960380f5$var$Xj;
            $7c3f52cf960380f5$var$X = null;
            $7c3f52cf960380f5$var$Yj(a, b, c);
            $7c3f52cf960380f5$var$X = d;
            $7c3f52cf960380f5$var$Xj = e;
            null !== $7c3f52cf960380f5$var$X && ($7c3f52cf960380f5$var$Xj ? (a = $7c3f52cf960380f5$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $7c3f52cf960380f5$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $7c3f52cf960380f5$var$X && ($7c3f52cf960380f5$var$Xj ? (a = $7c3f52cf960380f5$var$X, c = c.stateNode, 8 === a.nodeType ? $7c3f52cf960380f5$var$Kf(a.parentNode, c) : 1 === a.nodeType && $7c3f52cf960380f5$var$Kf(a, c), $7c3f52cf960380f5$var$bd(a)) : $7c3f52cf960380f5$var$Kf($7c3f52cf960380f5$var$X, c.stateNode));
            break;
        case 4:
            d = $7c3f52cf960380f5$var$X;
            e = $7c3f52cf960380f5$var$Xj;
            $7c3f52cf960380f5$var$X = c.stateNode.containerInfo;
            $7c3f52cf960380f5$var$Xj = !0;
            $7c3f52cf960380f5$var$Yj(a, b, c);
            $7c3f52cf960380f5$var$X = d;
            $7c3f52cf960380f5$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$7c3f52cf960380f5$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $7c3f52cf960380f5$var$Mj(c, b, g) : 0 !== (f & 4) && $7c3f52cf960380f5$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $7c3f52cf960380f5$var$Yj(a, b, c);
            break;
        case 1:
            if (!$7c3f52cf960380f5$var$U && ($7c3f52cf960380f5$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $7c3f52cf960380f5$var$W(c, b, h);
            }
            $7c3f52cf960380f5$var$Yj(a, b, c);
            break;
        case 21:
            $7c3f52cf960380f5$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($7c3f52cf960380f5$var$U = (d = $7c3f52cf960380f5$var$U) || null !== c.memoizedState, $7c3f52cf960380f5$var$Yj(a, b, c), $7c3f52cf960380f5$var$U = d) : $7c3f52cf960380f5$var$Yj(a, b, c);
            break;
        default:
            $7c3f52cf960380f5$var$Yj(a, b, c);
    }
}
function $7c3f52cf960380f5$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $7c3f52cf960380f5$var$Kj);
        b.forEach(function(b) {
            var d = $7c3f52cf960380f5$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $7c3f52cf960380f5$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $7c3f52cf960380f5$var$X = h.stateNode;
                        $7c3f52cf960380f5$var$Xj = !1;
                        break a;
                    case 3:
                        $7c3f52cf960380f5$var$X = h.stateNode.containerInfo;
                        $7c3f52cf960380f5$var$Xj = !0;
                        break a;
                    case 4:
                        $7c3f52cf960380f5$var$X = h.stateNode.containerInfo;
                        $7c3f52cf960380f5$var$Xj = !0;
                        break a;
                }
                h = h["return"];
            }
            if (null === $7c3f52cf960380f5$var$X) throw Error($7c3f52cf960380f5$var$p(160));
            $7c3f52cf960380f5$var$Zj(f, g, e);
            $7c3f52cf960380f5$var$X = null;
            $7c3f52cf960380f5$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k["return"] = null);
            e["return"] = null;
        } catch (l) {
            $7c3f52cf960380f5$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$7c3f52cf960380f5$var$dk(b, a), b = b.sibling;
}
function $7c3f52cf960380f5$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            if (d & 4) {
                try {
                    $7c3f52cf960380f5$var$Pj(3, a, a["return"]), $7c3f52cf960380f5$var$Qj(3, a);
                } catch (t) {
                    $7c3f52cf960380f5$var$W(a, a["return"], t);
                }
                try {
                    $7c3f52cf960380f5$var$Pj(5, a, a["return"]);
                } catch (t) {
                    $7c3f52cf960380f5$var$W(a, a["return"], t);
                }
            }
            break;
        case 1:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            d & 512 && null !== c && $7c3f52cf960380f5$var$Lj(c, c["return"]);
            break;
        case 5:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            d & 512 && null !== c && $7c3f52cf960380f5$var$Lj(c, c["return"]);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $7c3f52cf960380f5$var$ob(e, "");
                } catch (t) {
                    $7c3f52cf960380f5$var$W(a, a["return"], t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $7c3f52cf960380f5$var$ab(e, f);
                    $7c3f52cf960380f5$var$vb(h, g);
                    var l = $7c3f52cf960380f5$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $7c3f52cf960380f5$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $7c3f52cf960380f5$var$nb(e, q) : "children" === m ? $7c3f52cf960380f5$var$ob(e, q) : $7c3f52cf960380f5$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $7c3f52cf960380f5$var$bb(e, f);
                            break;
                        case "textarea":
                            $7c3f52cf960380f5$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $7c3f52cf960380f5$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $7c3f52cf960380f5$var$fb(e, !!f.multiple, f.defaultValue, !0) : $7c3f52cf960380f5$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$7c3f52cf960380f5$var$Pf] = f;
                } catch (t) {
                    $7c3f52cf960380f5$var$W(a, a["return"], t);
                }
            }
            break;
        case 6:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($7c3f52cf960380f5$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $7c3f52cf960380f5$var$W(a, a["return"], t);
                }
            }
            break;
        case 3:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $7c3f52cf960380f5$var$bd(b.containerInfo);
            } catch (t) {
                $7c3f52cf960380f5$var$W(a, a["return"], t);
            }
            break;
        case 4:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            break;
        case 13:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($7c3f52cf960380f5$var$fk = $7c3f52cf960380f5$var$B()));
            d & 4 && $7c3f52cf960380f5$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($7c3f52cf960380f5$var$U = (l = $7c3f52cf960380f5$var$U) || m, $7c3f52cf960380f5$var$ck(b, a), $7c3f52cf960380f5$var$U = l) : $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($7c3f52cf960380f5$var$V = a, m = a.child; null !== m;){
                    for(q = $7c3f52cf960380f5$var$V = m; null !== $7c3f52cf960380f5$var$V;){
                        r = $7c3f52cf960380f5$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $7c3f52cf960380f5$var$Pj(4, r, r["return"]);
                                break;
                            case 1:
                                $7c3f52cf960380f5$var$Lj(r, r["return"]);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r["return"];
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $7c3f52cf960380f5$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $7c3f52cf960380f5$var$Lj(r, r["return"]);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $7c3f52cf960380f5$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y["return"] = r, $7c3f52cf960380f5$var$V = y) : $7c3f52cf960380f5$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $7c3f52cf960380f5$var$rb("display", g));
                            } catch (t) {
                                $7c3f52cf960380f5$var$W(a, a["return"], t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $7c3f52cf960380f5$var$W(a, a["return"], t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child["return"] = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q["return"] || q["return"] === a) break a;
                        m === q && (m = null);
                        q = q["return"];
                    }
                    m === q && (m = null);
                    q.sibling["return"] = q["return"];
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $7c3f52cf960380f5$var$ck(b, a);
            $7c3f52cf960380f5$var$ek(a);
            d & 4 && $7c3f52cf960380f5$var$ak(a);
            break;
        case 21:
            break;
        default:
            $7c3f52cf960380f5$var$ck(b, a), $7c3f52cf960380f5$var$ek(a);
    }
}
function $7c3f52cf960380f5$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a["return"]; null !== c;){
                    if ($7c3f52cf960380f5$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c["return"];
                }
                throw Error($7c3f52cf960380f5$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($7c3f52cf960380f5$var$ob(e, ""), d.flags &= -33);
                    var f = $7c3f52cf960380f5$var$Uj(a);
                    $7c3f52cf960380f5$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $7c3f52cf960380f5$var$Uj(a);
                    $7c3f52cf960380f5$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($7c3f52cf960380f5$var$p(161));
            }
        } catch (k) {
            $7c3f52cf960380f5$var$W(a, a["return"], k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $7c3f52cf960380f5$var$hk(a, b, c) {
    $7c3f52cf960380f5$var$V = a;
    $7c3f52cf960380f5$var$ik(a, b, c);
}
function $7c3f52cf960380f5$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $7c3f52cf960380f5$var$V;){
        var e = $7c3f52cf960380f5$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $7c3f52cf960380f5$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $7c3f52cf960380f5$var$U;
                h = $7c3f52cf960380f5$var$Jj;
                var l = $7c3f52cf960380f5$var$U;
                $7c3f52cf960380f5$var$Jj = g;
                if (($7c3f52cf960380f5$var$U = k) && !l) for($7c3f52cf960380f5$var$V = e; null !== $7c3f52cf960380f5$var$V;)g = $7c3f52cf960380f5$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $7c3f52cf960380f5$var$jk(e) : null !== k ? (k["return"] = g, $7c3f52cf960380f5$var$V = k) : $7c3f52cf960380f5$var$jk(e);
                for(; null !== f;)$7c3f52cf960380f5$var$V = f, $7c3f52cf960380f5$var$ik(f, b, c), f = f.sibling;
                $7c3f52cf960380f5$var$V = e;
                $7c3f52cf960380f5$var$Jj = h;
                $7c3f52cf960380f5$var$U = l;
            }
            $7c3f52cf960380f5$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, $7c3f52cf960380f5$var$V = f) : $7c3f52cf960380f5$var$kk(a, b, c);
    }
}
function $7c3f52cf960380f5$var$kk(a) {
    for(; null !== $7c3f52cf960380f5$var$V;){
        var b = $7c3f52cf960380f5$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $7c3f52cf960380f5$var$U || $7c3f52cf960380f5$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$7c3f52cf960380f5$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $7c3f52cf960380f5$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $7c3f52cf960380f5$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $7c3f52cf960380f5$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $7c3f52cf960380f5$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($7c3f52cf960380f5$var$p(163));
                }
                $7c3f52cf960380f5$var$U || b.flags & 512 && $7c3f52cf960380f5$var$Rj(b);
            } catch (r) {
                $7c3f52cf960380f5$var$W(b, b["return"], r);
            }
        }
        if (b === a) {
            $7c3f52cf960380f5$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $7c3f52cf960380f5$var$V = c;
            break;
        }
        $7c3f52cf960380f5$var$V = b["return"];
    }
}
function $7c3f52cf960380f5$var$gk(a) {
    for(; null !== $7c3f52cf960380f5$var$V;){
        var b = $7c3f52cf960380f5$var$V;
        if (b === a) {
            $7c3f52cf960380f5$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $7c3f52cf960380f5$var$V = c;
            break;
        }
        $7c3f52cf960380f5$var$V = b["return"];
    }
}
function $7c3f52cf960380f5$var$jk(a) {
    for(; null !== $7c3f52cf960380f5$var$V;){
        var b = $7c3f52cf960380f5$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b["return"];
                    try {
                        $7c3f52cf960380f5$var$Qj(4, b);
                    } catch (k) {
                        $7c3f52cf960380f5$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b["return"];
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $7c3f52cf960380f5$var$W(b, e, k);
                        }
                    }
                    var f = b["return"];
                    try {
                        $7c3f52cf960380f5$var$Rj(b);
                    } catch (k) {
                        $7c3f52cf960380f5$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b["return"];
                    try {
                        $7c3f52cf960380f5$var$Rj(b);
                    } catch (k) {
                        $7c3f52cf960380f5$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $7c3f52cf960380f5$var$W(b, b["return"], k);
        }
        if (b === a) {
            $7c3f52cf960380f5$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h["return"] = b["return"];
            $7c3f52cf960380f5$var$V = h;
            break;
        }
        $7c3f52cf960380f5$var$V = b["return"];
    }
}
var $7c3f52cf960380f5$var$lk = Math.ceil, $7c3f52cf960380f5$var$mk = $7c3f52cf960380f5$var$ua.ReactCurrentDispatcher, $7c3f52cf960380f5$var$nk = $7c3f52cf960380f5$var$ua.ReactCurrentOwner, $7c3f52cf960380f5$var$ok = $7c3f52cf960380f5$var$ua.ReactCurrentBatchConfig, $7c3f52cf960380f5$var$K = 0, $7c3f52cf960380f5$var$Q = null, $7c3f52cf960380f5$var$Y = null, $7c3f52cf960380f5$var$Z = 0, $7c3f52cf960380f5$var$fj = 0, $7c3f52cf960380f5$var$ej = $7c3f52cf960380f5$var$Uf(0), $7c3f52cf960380f5$var$T = 0, $7c3f52cf960380f5$var$pk = null, $7c3f52cf960380f5$var$rh = 0, $7c3f52cf960380f5$var$qk = 0, $7c3f52cf960380f5$var$rk = 0, $7c3f52cf960380f5$var$sk = null, $7c3f52cf960380f5$var$tk = null, $7c3f52cf960380f5$var$fk = 0, $7c3f52cf960380f5$var$Gj = Infinity, $7c3f52cf960380f5$var$uk = null, $7c3f52cf960380f5$var$Oi = !1, $7c3f52cf960380f5$var$Pi = null, $7c3f52cf960380f5$var$Ri = null, $7c3f52cf960380f5$var$vk = !1, $7c3f52cf960380f5$var$wk = null, $7c3f52cf960380f5$var$xk = 0, $7c3f52cf960380f5$var$yk = 0, $7c3f52cf960380f5$var$zk = null, $7c3f52cf960380f5$var$Ak = -1, $7c3f52cf960380f5$var$Bk = 0;
function $7c3f52cf960380f5$var$R() {
    return 0 !== ($7c3f52cf960380f5$var$K & 6) ? $7c3f52cf960380f5$var$B() : -1 !== $7c3f52cf960380f5$var$Ak ? $7c3f52cf960380f5$var$Ak : $7c3f52cf960380f5$var$Ak = $7c3f52cf960380f5$var$B();
}
function $7c3f52cf960380f5$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($7c3f52cf960380f5$var$K & 2) && 0 !== $7c3f52cf960380f5$var$Z) return $7c3f52cf960380f5$var$Z & -$7c3f52cf960380f5$var$Z;
    if (null !== $7c3f52cf960380f5$var$Kg.transition) return 0 === $7c3f52cf960380f5$var$Bk && ($7c3f52cf960380f5$var$Bk = $7c3f52cf960380f5$var$yc()), $7c3f52cf960380f5$var$Bk;
    a = $7c3f52cf960380f5$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $7c3f52cf960380f5$var$jd(a.type);
    return a;
}
function $7c3f52cf960380f5$var$gi(a, b, c, d) {
    if (50 < $7c3f52cf960380f5$var$yk) throw $7c3f52cf960380f5$var$yk = 0, $7c3f52cf960380f5$var$zk = null, Error($7c3f52cf960380f5$var$p(185));
    $7c3f52cf960380f5$var$Ac(a, c, d);
    if (0 === ($7c3f52cf960380f5$var$K & 2) || a !== $7c3f52cf960380f5$var$Q) a === $7c3f52cf960380f5$var$Q && (0 === ($7c3f52cf960380f5$var$K & 2) && ($7c3f52cf960380f5$var$qk |= c), 4 === $7c3f52cf960380f5$var$T && $7c3f52cf960380f5$var$Ck(a, $7c3f52cf960380f5$var$Z)), $7c3f52cf960380f5$var$Dk(a, d), 1 === c && 0 === $7c3f52cf960380f5$var$K && 0 === (b.mode & 1) && ($7c3f52cf960380f5$var$Gj = $7c3f52cf960380f5$var$B() + 500, $7c3f52cf960380f5$var$fg && $7c3f52cf960380f5$var$jg());
}
function $7c3f52cf960380f5$var$Dk(a, b) {
    var c = a.callbackNode;
    $7c3f52cf960380f5$var$wc(a, b);
    var d = $7c3f52cf960380f5$var$uc(a, a === $7c3f52cf960380f5$var$Q ? $7c3f52cf960380f5$var$Z : 0);
    if (0 === d) null !== c && $7c3f52cf960380f5$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $7c3f52cf960380f5$var$bc(c);
        if (1 === b) 0 === a.tag ? $7c3f52cf960380f5$var$ig($7c3f52cf960380f5$var$Ek.bind(null, a)) : $7c3f52cf960380f5$var$hg($7c3f52cf960380f5$var$Ek.bind(null, a)), $7c3f52cf960380f5$var$Jf(function() {
            0 === ($7c3f52cf960380f5$var$K & 6) && $7c3f52cf960380f5$var$jg();
        }), c = null;
        else {
            switch($7c3f52cf960380f5$var$Dc(d)){
                case 1:
                    c = $7c3f52cf960380f5$var$fc;
                    break;
                case 4:
                    c = $7c3f52cf960380f5$var$gc;
                    break;
                case 16:
                    c = $7c3f52cf960380f5$var$hc;
                    break;
                case 536870912:
                    c = $7c3f52cf960380f5$var$jc;
                    break;
                default:
                    c = $7c3f52cf960380f5$var$hc;
            }
            c = $7c3f52cf960380f5$var$Fk(c, $7c3f52cf960380f5$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $7c3f52cf960380f5$var$Gk(a, b) {
    $7c3f52cf960380f5$var$Ak = -1;
    $7c3f52cf960380f5$var$Bk = 0;
    if (0 !== ($7c3f52cf960380f5$var$K & 6)) throw Error($7c3f52cf960380f5$var$p(327));
    var c = a.callbackNode;
    if ($7c3f52cf960380f5$var$Hk() && a.callbackNode !== c) return null;
    var d = $7c3f52cf960380f5$var$uc(a, a === $7c3f52cf960380f5$var$Q ? $7c3f52cf960380f5$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $7c3f52cf960380f5$var$Ik(a, d);
    else {
        b = d;
        var e = $7c3f52cf960380f5$var$K;
        $7c3f52cf960380f5$var$K |= 2;
        var f = $7c3f52cf960380f5$var$Jk();
        if ($7c3f52cf960380f5$var$Q !== a || $7c3f52cf960380f5$var$Z !== b) $7c3f52cf960380f5$var$uk = null, $7c3f52cf960380f5$var$Gj = $7c3f52cf960380f5$var$B() + 500, $7c3f52cf960380f5$var$Kk(a, b);
        for(;;)try {
            $7c3f52cf960380f5$var$Lk();
            break;
        } catch (h) {
            $7c3f52cf960380f5$var$Mk(a, h);
        }
        $7c3f52cf960380f5$var$$g();
        $7c3f52cf960380f5$var$mk.current = f;
        $7c3f52cf960380f5$var$K = e;
        null !== $7c3f52cf960380f5$var$Y ? b = 0 : ($7c3f52cf960380f5$var$Q = null, $7c3f52cf960380f5$var$Z = 0, b = $7c3f52cf960380f5$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $7c3f52cf960380f5$var$xc(a), 0 !== e && (d = e, b = $7c3f52cf960380f5$var$Nk(a, e)));
        if (1 === b) throw c = $7c3f52cf960380f5$var$pk, $7c3f52cf960380f5$var$Kk(a, 0), $7c3f52cf960380f5$var$Ck(a, d), $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B()), c;
        if (6 === b) $7c3f52cf960380f5$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$7c3f52cf960380f5$var$Ok(e) && (b = $7c3f52cf960380f5$var$Ik(a, d), 2 === b && (f = $7c3f52cf960380f5$var$xc(a), 0 !== f && (d = f, b = $7c3f52cf960380f5$var$Nk(a, f))), 1 === b)) throw c = $7c3f52cf960380f5$var$pk, $7c3f52cf960380f5$var$Kk(a, 0), $7c3f52cf960380f5$var$Ck(a, d), $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($7c3f52cf960380f5$var$p(345));
                case 2:
                    $7c3f52cf960380f5$var$Pk(a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk);
                    break;
                case 3:
                    $7c3f52cf960380f5$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $7c3f52cf960380f5$var$fk + 500 - $7c3f52cf960380f5$var$B(), 10 < b)) {
                        if (0 !== $7c3f52cf960380f5$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $7c3f52cf960380f5$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $7c3f52cf960380f5$var$Ff($7c3f52cf960380f5$var$Pk.bind(null, a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk), b);
                        break;
                    }
                    $7c3f52cf960380f5$var$Pk(a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk);
                    break;
                case 4:
                    $7c3f52cf960380f5$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $7c3f52cf960380f5$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $7c3f52cf960380f5$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $7c3f52cf960380f5$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $7c3f52cf960380f5$var$Ff($7c3f52cf960380f5$var$Pk.bind(null, a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk), d);
                        break;
                    }
                    $7c3f52cf960380f5$var$Pk(a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk);
                    break;
                case 5:
                    $7c3f52cf960380f5$var$Pk(a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk);
                    break;
                default:
                    throw Error($7c3f52cf960380f5$var$p(329));
            }
        }
    }
    $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B());
    return a.callbackNode === c ? $7c3f52cf960380f5$var$Gk.bind(null, a) : null;
}
function $7c3f52cf960380f5$var$Nk(a, b) {
    var c = $7c3f52cf960380f5$var$sk;
    a.current.memoizedState.isDehydrated && ($7c3f52cf960380f5$var$Kk(a, b).flags |= 256);
    a = $7c3f52cf960380f5$var$Ik(a, b);
    2 !== a && (b = $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$tk = c, null !== b && $7c3f52cf960380f5$var$Fj(b));
    return a;
}
function $7c3f52cf960380f5$var$Fj(a) {
    null === $7c3f52cf960380f5$var$tk ? $7c3f52cf960380f5$var$tk = a : $7c3f52cf960380f5$var$tk.push.apply($7c3f52cf960380f5$var$tk, a);
}
function $7c3f52cf960380f5$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$7c3f52cf960380f5$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b["return"] || b["return"] === a) return !0;
                b = b["return"];
            }
            b.sibling["return"] = b["return"];
            b = b.sibling;
        }
    }
    return !0;
}
function $7c3f52cf960380f5$var$Ck(a, b) {
    b &= ~$7c3f52cf960380f5$var$rk;
    b &= ~$7c3f52cf960380f5$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $7c3f52cf960380f5$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $7c3f52cf960380f5$var$Ek(a) {
    if (0 !== ($7c3f52cf960380f5$var$K & 6)) throw Error($7c3f52cf960380f5$var$p(327));
    $7c3f52cf960380f5$var$Hk();
    var b = $7c3f52cf960380f5$var$uc(a, 0);
    if (0 === (b & 1)) return $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B()), null;
    var c = $7c3f52cf960380f5$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $7c3f52cf960380f5$var$xc(a);
        0 !== d && (b = d, c = $7c3f52cf960380f5$var$Nk(a, d));
    }
    if (1 === c) throw c = $7c3f52cf960380f5$var$pk, $7c3f52cf960380f5$var$Kk(a, 0), $7c3f52cf960380f5$var$Ck(a, b), $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B()), c;
    if (6 === c) throw Error($7c3f52cf960380f5$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $7c3f52cf960380f5$var$Pk(a, $7c3f52cf960380f5$var$tk, $7c3f52cf960380f5$var$uk);
    $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B());
    return null;
}
function $7c3f52cf960380f5$var$Qk(a, b) {
    var c = $7c3f52cf960380f5$var$K;
    $7c3f52cf960380f5$var$K |= 1;
    try {
        return a(b);
    } finally{
        $7c3f52cf960380f5$var$K = c, 0 === $7c3f52cf960380f5$var$K && ($7c3f52cf960380f5$var$Gj = $7c3f52cf960380f5$var$B() + 500, $7c3f52cf960380f5$var$fg && $7c3f52cf960380f5$var$jg());
    }
}
function $7c3f52cf960380f5$var$Rk(a) {
    null !== $7c3f52cf960380f5$var$wk && 0 === $7c3f52cf960380f5$var$wk.tag && 0 === ($7c3f52cf960380f5$var$K & 6) && $7c3f52cf960380f5$var$Hk();
    var b = $7c3f52cf960380f5$var$K;
    $7c3f52cf960380f5$var$K |= 1;
    var c = $7c3f52cf960380f5$var$ok.transition, d = $7c3f52cf960380f5$var$C;
    try {
        if ($7c3f52cf960380f5$var$ok.transition = null, $7c3f52cf960380f5$var$C = 1, a) return a();
    } finally{
        $7c3f52cf960380f5$var$C = d, $7c3f52cf960380f5$var$ok.transition = c, $7c3f52cf960380f5$var$K = b, 0 === ($7c3f52cf960380f5$var$K & 6) && $7c3f52cf960380f5$var$jg();
    }
}
function $7c3f52cf960380f5$var$Hj() {
    $7c3f52cf960380f5$var$fj = $7c3f52cf960380f5$var$ej.current;
    $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$ej);
}
function $7c3f52cf960380f5$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $7c3f52cf960380f5$var$Gf(c));
    if (null !== $7c3f52cf960380f5$var$Y) for(c = $7c3f52cf960380f5$var$Y["return"]; null !== c;){
        var d = c;
        $7c3f52cf960380f5$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $7c3f52cf960380f5$var$$f();
                break;
            case 3:
                $7c3f52cf960380f5$var$zh();
                $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$Wf);
                $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$H);
                $7c3f52cf960380f5$var$Eh();
                break;
            case 5:
                $7c3f52cf960380f5$var$Bh(d);
                break;
            case 4:
                $7c3f52cf960380f5$var$zh();
                break;
            case 13:
                $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$L);
                break;
            case 19:
                $7c3f52cf960380f5$var$E($7c3f52cf960380f5$var$L);
                break;
            case 10:
                $7c3f52cf960380f5$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $7c3f52cf960380f5$var$Hj();
        }
        c = c["return"];
    }
    $7c3f52cf960380f5$var$Q = a;
    $7c3f52cf960380f5$var$Y = a = $7c3f52cf960380f5$var$Pg(a.current, null);
    $7c3f52cf960380f5$var$Z = $7c3f52cf960380f5$var$fj = b;
    $7c3f52cf960380f5$var$T = 0;
    $7c3f52cf960380f5$var$pk = null;
    $7c3f52cf960380f5$var$rk = $7c3f52cf960380f5$var$qk = $7c3f52cf960380f5$var$rh = 0;
    $7c3f52cf960380f5$var$tk = $7c3f52cf960380f5$var$sk = null;
    if (null !== $7c3f52cf960380f5$var$fh) {
        for(b = 0; b < $7c3f52cf960380f5$var$fh.length; b++)if (c = $7c3f52cf960380f5$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $7c3f52cf960380f5$var$fh = null;
    }
    return a;
}
function $7c3f52cf960380f5$var$Mk(a, b) {
    do {
        var c = $7c3f52cf960380f5$var$Y;
        try {
            $7c3f52cf960380f5$var$$g();
            $7c3f52cf960380f5$var$Fh.current = $7c3f52cf960380f5$var$Rh;
            if ($7c3f52cf960380f5$var$Ih) {
                for(var d = $7c3f52cf960380f5$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $7c3f52cf960380f5$var$Ih = !1;
            }
            $7c3f52cf960380f5$var$Hh = 0;
            $7c3f52cf960380f5$var$O = $7c3f52cf960380f5$var$N = $7c3f52cf960380f5$var$M = null;
            $7c3f52cf960380f5$var$Jh = !1;
            $7c3f52cf960380f5$var$Kh = 0;
            $7c3f52cf960380f5$var$nk.current = null;
            if (null === c || null === c["return"]) {
                $7c3f52cf960380f5$var$T = 1;
                $7c3f52cf960380f5$var$pk = b;
                $7c3f52cf960380f5$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c["return"], h = c, k = b;
                b = $7c3f52cf960380f5$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $2xTNA._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $7c3f52cf960380f5$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $7c3f52cf960380f5$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $7c3f52cf960380f5$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $7c3f52cf960380f5$var$Si(f, l, b);
                            $7c3f52cf960380f5$var$tj();
                            break a;
                        }
                        k = Error($7c3f52cf960380f5$var$p(426));
                    }
                } else if ($7c3f52cf960380f5$var$I && h.mode & 1) {
                    var J = $7c3f52cf960380f5$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $7c3f52cf960380f5$var$Vi(J, g, h, f, b);
                        $7c3f52cf960380f5$var$Jg($7c3f52cf960380f5$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $7c3f52cf960380f5$var$Ji(k, h);
                4 !== $7c3f52cf960380f5$var$T && ($7c3f52cf960380f5$var$T = 2);
                null === $7c3f52cf960380f5$var$sk ? $7c3f52cf960380f5$var$sk = [
                    f
                ] : $7c3f52cf960380f5$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $7c3f52cf960380f5$var$Ni(f, k, b);
                            $7c3f52cf960380f5$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $7c3f52cf960380f5$var$Ri || !$7c3f52cf960380f5$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $7c3f52cf960380f5$var$Qi(f, h, b);
                                $7c3f52cf960380f5$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f["return"];
                }while (null !== f);
            }
            $7c3f52cf960380f5$var$Sk(c);
        } catch (na) {
            b = na;
            $7c3f52cf960380f5$var$Y === c && null !== c && ($7c3f52cf960380f5$var$Y = c = c["return"]);
            continue;
        }
        break;
    }while (1);
}
function $7c3f52cf960380f5$var$Jk() {
    var a = $7c3f52cf960380f5$var$mk.current;
    $7c3f52cf960380f5$var$mk.current = $7c3f52cf960380f5$var$Rh;
    return null === a ? $7c3f52cf960380f5$var$Rh : a;
}
function $7c3f52cf960380f5$var$tj() {
    if (0 === $7c3f52cf960380f5$var$T || 3 === $7c3f52cf960380f5$var$T || 2 === $7c3f52cf960380f5$var$T) $7c3f52cf960380f5$var$T = 4;
    null === $7c3f52cf960380f5$var$Q || 0 === ($7c3f52cf960380f5$var$rh & 268435455) && 0 === ($7c3f52cf960380f5$var$qk & 268435455) || $7c3f52cf960380f5$var$Ck($7c3f52cf960380f5$var$Q, $7c3f52cf960380f5$var$Z);
}
function $7c3f52cf960380f5$var$Ik(a, b) {
    var c = $7c3f52cf960380f5$var$K;
    $7c3f52cf960380f5$var$K |= 2;
    var d = $7c3f52cf960380f5$var$Jk();
    if ($7c3f52cf960380f5$var$Q !== a || $7c3f52cf960380f5$var$Z !== b) $7c3f52cf960380f5$var$uk = null, $7c3f52cf960380f5$var$Kk(a, b);
    for(;;)try {
        $7c3f52cf960380f5$var$Tk();
        break;
    } catch (e) {
        $7c3f52cf960380f5$var$Mk(a, e);
    }
    $7c3f52cf960380f5$var$$g();
    $7c3f52cf960380f5$var$K = c;
    $7c3f52cf960380f5$var$mk.current = d;
    if (null !== $7c3f52cf960380f5$var$Y) throw Error($7c3f52cf960380f5$var$p(261));
    $7c3f52cf960380f5$var$Q = null;
    $7c3f52cf960380f5$var$Z = 0;
    return $7c3f52cf960380f5$var$T;
}
function $7c3f52cf960380f5$var$Tk() {
    for(; null !== $7c3f52cf960380f5$var$Y;)$7c3f52cf960380f5$var$Uk($7c3f52cf960380f5$var$Y);
}
function $7c3f52cf960380f5$var$Lk() {
    for(; null !== $7c3f52cf960380f5$var$Y && !$7c3f52cf960380f5$var$cc();)$7c3f52cf960380f5$var$Uk($7c3f52cf960380f5$var$Y);
}
function $7c3f52cf960380f5$var$Uk(a) {
    var b = $7c3f52cf960380f5$var$Vk(a.alternate, a, $7c3f52cf960380f5$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $7c3f52cf960380f5$var$Sk(a) : $7c3f52cf960380f5$var$Y = b;
    $7c3f52cf960380f5$var$nk.current = null;
}
function $7c3f52cf960380f5$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b["return"];
        if (0 === (b.flags & 32768)) {
            if (c = $7c3f52cf960380f5$var$Ej(c, b, $7c3f52cf960380f5$var$fj), null !== c) {
                $7c3f52cf960380f5$var$Y = c;
                return;
            }
        } else {
            c = $7c3f52cf960380f5$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $7c3f52cf960380f5$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $7c3f52cf960380f5$var$T = 6;
                $7c3f52cf960380f5$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $7c3f52cf960380f5$var$Y = b;
            return;
        }
        $7c3f52cf960380f5$var$Y = b = a;
    }while (null !== b);
    0 === $7c3f52cf960380f5$var$T && ($7c3f52cf960380f5$var$T = 5);
}
function $7c3f52cf960380f5$var$Pk(a, b, c) {
    var d = $7c3f52cf960380f5$var$C, e = $7c3f52cf960380f5$var$ok.transition;
    try {
        $7c3f52cf960380f5$var$ok.transition = null, $7c3f52cf960380f5$var$C = 1, $7c3f52cf960380f5$var$Wk(a, b, c, d);
    } finally{
        $7c3f52cf960380f5$var$ok.transition = e, $7c3f52cf960380f5$var$C = d;
    }
    return null;
}
function $7c3f52cf960380f5$var$Wk(a, b, c, d) {
    do $7c3f52cf960380f5$var$Hk();
    while (null !== $7c3f52cf960380f5$var$wk);
    if (0 !== ($7c3f52cf960380f5$var$K & 6)) throw Error($7c3f52cf960380f5$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($7c3f52cf960380f5$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $7c3f52cf960380f5$var$Bc(a, f);
    a === $7c3f52cf960380f5$var$Q && ($7c3f52cf960380f5$var$Y = $7c3f52cf960380f5$var$Q = null, $7c3f52cf960380f5$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $7c3f52cf960380f5$var$vk || ($7c3f52cf960380f5$var$vk = !0, $7c3f52cf960380f5$var$Fk($7c3f52cf960380f5$var$hc, function() {
        $7c3f52cf960380f5$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $7c3f52cf960380f5$var$ok.transition;
        $7c3f52cf960380f5$var$ok.transition = null;
        var g = $7c3f52cf960380f5$var$C;
        $7c3f52cf960380f5$var$C = 1;
        var h = $7c3f52cf960380f5$var$K;
        $7c3f52cf960380f5$var$K |= 4;
        $7c3f52cf960380f5$var$nk.current = null;
        $7c3f52cf960380f5$var$Oj(a, c);
        $7c3f52cf960380f5$var$dk(c, a);
        $7c3f52cf960380f5$var$Oe($7c3f52cf960380f5$var$Df);
        $7c3f52cf960380f5$var$dd = !!$7c3f52cf960380f5$var$Cf;
        $7c3f52cf960380f5$var$Df = $7c3f52cf960380f5$var$Cf = null;
        a.current = c;
        $7c3f52cf960380f5$var$hk(c, a, e);
        $7c3f52cf960380f5$var$dc();
        $7c3f52cf960380f5$var$K = h;
        $7c3f52cf960380f5$var$C = g;
        $7c3f52cf960380f5$var$ok.transition = f;
    } else a.current = c;
    $7c3f52cf960380f5$var$vk && ($7c3f52cf960380f5$var$vk = !1, $7c3f52cf960380f5$var$wk = a, $7c3f52cf960380f5$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($7c3f52cf960380f5$var$Ri = null);
    $7c3f52cf960380f5$var$mc(c.stateNode, d);
    $7c3f52cf960380f5$var$Dk(a, $7c3f52cf960380f5$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($7c3f52cf960380f5$var$Oi) throw $7c3f52cf960380f5$var$Oi = !1, a = $7c3f52cf960380f5$var$Pi, $7c3f52cf960380f5$var$Pi = null, a;
    0 !== ($7c3f52cf960380f5$var$xk & 1) && 0 !== a.tag && $7c3f52cf960380f5$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $7c3f52cf960380f5$var$zk ? $7c3f52cf960380f5$var$yk++ : ($7c3f52cf960380f5$var$yk = 0, $7c3f52cf960380f5$var$zk = a) : $7c3f52cf960380f5$var$yk = 0;
    $7c3f52cf960380f5$var$jg();
    return null;
}
function $7c3f52cf960380f5$var$Hk() {
    if (null !== $7c3f52cf960380f5$var$wk) {
        var a = $7c3f52cf960380f5$var$Dc($7c3f52cf960380f5$var$xk), b = $7c3f52cf960380f5$var$ok.transition, c = $7c3f52cf960380f5$var$C;
        try {
            $7c3f52cf960380f5$var$ok.transition = null;
            $7c3f52cf960380f5$var$C = 16 > a ? 16 : a;
            if (null === $7c3f52cf960380f5$var$wk) var d = !1;
            else {
                a = $7c3f52cf960380f5$var$wk;
                $7c3f52cf960380f5$var$wk = null;
                $7c3f52cf960380f5$var$xk = 0;
                if (0 !== ($7c3f52cf960380f5$var$K & 6)) throw Error($7c3f52cf960380f5$var$p(331));
                var e = $7c3f52cf960380f5$var$K;
                $7c3f52cf960380f5$var$K |= 4;
                for($7c3f52cf960380f5$var$V = a.current; null !== $7c3f52cf960380f5$var$V;){
                    var f = $7c3f52cf960380f5$var$V, g = f.child;
                    if (0 !== ($7c3f52cf960380f5$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($7c3f52cf960380f5$var$V = l; null !== $7c3f52cf960380f5$var$V;){
                                    var m = $7c3f52cf960380f5$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $7c3f52cf960380f5$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q["return"] = m, $7c3f52cf960380f5$var$V = q;
                                    else for(; null !== $7c3f52cf960380f5$var$V;){
                                        m = $7c3f52cf960380f5$var$V;
                                        var r = m.sibling, y = m["return"];
                                        $7c3f52cf960380f5$var$Sj(m);
                                        if (m === l) {
                                            $7c3f52cf960380f5$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r["return"] = y;
                                            $7c3f52cf960380f5$var$V = r;
                                            break;
                                        }
                                        $7c3f52cf960380f5$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $7c3f52cf960380f5$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, $7c3f52cf960380f5$var$V = g;
                    else b: for(; null !== $7c3f52cf960380f5$var$V;){
                        f = $7c3f52cf960380f5$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $7c3f52cf960380f5$var$Pj(9, f, f["return"]);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x["return"] = f["return"];
                            $7c3f52cf960380f5$var$V = x;
                            break b;
                        }
                        $7c3f52cf960380f5$var$V = f["return"];
                    }
                }
                var w = a.current;
                for($7c3f52cf960380f5$var$V = w; null !== $7c3f52cf960380f5$var$V;){
                    g = $7c3f52cf960380f5$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u["return"] = g, $7c3f52cf960380f5$var$V = u;
                    else b: for(g = w; null !== $7c3f52cf960380f5$var$V;){
                        h = $7c3f52cf960380f5$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $7c3f52cf960380f5$var$Qj(9, h);
                            }
                        } catch (na) {
                            $7c3f52cf960380f5$var$W(h, h["return"], na);
                        }
                        if (h === g) {
                            $7c3f52cf960380f5$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F["return"] = h["return"];
                            $7c3f52cf960380f5$var$V = F;
                            break b;
                        }
                        $7c3f52cf960380f5$var$V = h["return"];
                    }
                }
                $7c3f52cf960380f5$var$K = e;
                $7c3f52cf960380f5$var$jg();
                if ($7c3f52cf960380f5$var$lc && "function" === typeof $7c3f52cf960380f5$var$lc.onPostCommitFiberRoot) try {
                    $7c3f52cf960380f5$var$lc.onPostCommitFiberRoot($7c3f52cf960380f5$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $7c3f52cf960380f5$var$C = c, $7c3f52cf960380f5$var$ok.transition = b;
        }
    }
    return !1;
}
function $7c3f52cf960380f5$var$Xk(a, b, c) {
    b = $7c3f52cf960380f5$var$Ji(c, b);
    b = $7c3f52cf960380f5$var$Ni(a, b, 1);
    a = $7c3f52cf960380f5$var$nh(a, b, 1);
    b = $7c3f52cf960380f5$var$R();
    null !== a && ($7c3f52cf960380f5$var$Ac(a, 1, b), $7c3f52cf960380f5$var$Dk(a, b));
}
function $7c3f52cf960380f5$var$W(a, b, c) {
    if (3 === a.tag) $7c3f52cf960380f5$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $7c3f52cf960380f5$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $7c3f52cf960380f5$var$Ri || !$7c3f52cf960380f5$var$Ri.has(d))) {
                a = $7c3f52cf960380f5$var$Ji(c, a);
                a = $7c3f52cf960380f5$var$Qi(b, a, 1);
                b = $7c3f52cf960380f5$var$nh(b, a, 1);
                a = $7c3f52cf960380f5$var$R();
                null !== b && ($7c3f52cf960380f5$var$Ac(b, 1, a), $7c3f52cf960380f5$var$Dk(b, a));
                break;
            }
        }
        b = b["return"];
    }
}
function $7c3f52cf960380f5$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    b = $7c3f52cf960380f5$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $7c3f52cf960380f5$var$Q === a && ($7c3f52cf960380f5$var$Z & c) === c && (4 === $7c3f52cf960380f5$var$T || 3 === $7c3f52cf960380f5$var$T && ($7c3f52cf960380f5$var$Z & 130023424) === $7c3f52cf960380f5$var$Z && 500 > $7c3f52cf960380f5$var$B() - $7c3f52cf960380f5$var$fk ? $7c3f52cf960380f5$var$Kk(a, 0) : $7c3f52cf960380f5$var$rk |= c);
    $7c3f52cf960380f5$var$Dk(a, b);
}
function $7c3f52cf960380f5$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $7c3f52cf960380f5$var$sc, $7c3f52cf960380f5$var$sc <<= 1, 0 === ($7c3f52cf960380f5$var$sc & 130023424) && ($7c3f52cf960380f5$var$sc = 4194304)));
    var c = $7c3f52cf960380f5$var$R();
    a = $7c3f52cf960380f5$var$ih(a, b);
    null !== a && ($7c3f52cf960380f5$var$Ac(a, b, c), $7c3f52cf960380f5$var$Dk(a, c));
}
function $7c3f52cf960380f5$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $7c3f52cf960380f5$var$Yk(a, c);
}
function $7c3f52cf960380f5$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($7c3f52cf960380f5$var$p(314));
    }
    null !== d && d["delete"](b);
    $7c3f52cf960380f5$var$Yk(a, c);
}
var $7c3f52cf960380f5$var$Vk;
$7c3f52cf960380f5$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $7c3f52cf960380f5$var$Wf.current) $7c3f52cf960380f5$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $7c3f52cf960380f5$var$dh = !1, $7c3f52cf960380f5$var$yj(a, b, c);
            $7c3f52cf960380f5$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $7c3f52cf960380f5$var$dh = !1, $7c3f52cf960380f5$var$I && 0 !== (b.flags & 1048576) && $7c3f52cf960380f5$var$ug(b, $7c3f52cf960380f5$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $7c3f52cf960380f5$var$ij(a, b);
            a = b.pendingProps;
            var e = $7c3f52cf960380f5$var$Yf(b, $7c3f52cf960380f5$var$H.current);
            $7c3f52cf960380f5$var$ch(b, c);
            e = $7c3f52cf960380f5$var$Nh(null, b, d, a, e, c);
            var f = $7c3f52cf960380f5$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $2xTNA._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $7c3f52cf960380f5$var$Zf(d) ? (f = !0, $7c3f52cf960380f5$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $7c3f52cf960380f5$var$kh(b), e.updater = $7c3f52cf960380f5$var$Ei, b.stateNode = e, e._reactInternals = b, $7c3f52cf960380f5$var$Ii(b, d, a, c), b = $7c3f52cf960380f5$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $7c3f52cf960380f5$var$I && f && $7c3f52cf960380f5$var$vg(b), $7c3f52cf960380f5$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $7c3f52cf960380f5$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $7c3f52cf960380f5$var$Zk(d);
                a = $7c3f52cf960380f5$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $7c3f52cf960380f5$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $7c3f52cf960380f5$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $7c3f52cf960380f5$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $7c3f52cf960380f5$var$$i(null, b, d, $7c3f52cf960380f5$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($7c3f52cf960380f5$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7c3f52cf960380f5$var$Ci(d, e), $7c3f52cf960380f5$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7c3f52cf960380f5$var$Ci(d, e), $7c3f52cf960380f5$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $7c3f52cf960380f5$var$kj(b);
                if (null === a) throw Error($7c3f52cf960380f5$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $7c3f52cf960380f5$var$lh(a, b);
                $7c3f52cf960380f5$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $7c3f52cf960380f5$var$Ji(Error($7c3f52cf960380f5$var$p(423)), b);
                        b = $7c3f52cf960380f5$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $7c3f52cf960380f5$var$Ji(Error($7c3f52cf960380f5$var$p(424)), b);
                        b = $7c3f52cf960380f5$var$lj(a, b, d, c, e);
                        break a;
                    } else for($7c3f52cf960380f5$var$yg = $7c3f52cf960380f5$var$Lf(b.stateNode.containerInfo.firstChild), $7c3f52cf960380f5$var$xg = b, $7c3f52cf960380f5$var$I = !0, $7c3f52cf960380f5$var$zg = null, c = $7c3f52cf960380f5$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $7c3f52cf960380f5$var$Ig();
                    if (d === e) {
                        b = $7c3f52cf960380f5$var$Zi(a, b, c);
                        break a;
                    }
                    $7c3f52cf960380f5$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $7c3f52cf960380f5$var$Ah(b), null === a && $7c3f52cf960380f5$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $7c3f52cf960380f5$var$Ef(d, e) ? g = null : null !== f && $7c3f52cf960380f5$var$Ef(d, f) && (b.flags |= 32), $7c3f52cf960380f5$var$gj(a, b), $7c3f52cf960380f5$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $7c3f52cf960380f5$var$Eg(b), null;
        case 13:
            return $7c3f52cf960380f5$var$oj(a, b, c);
        case 4:
            return $7c3f52cf960380f5$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $7c3f52cf960380f5$var$Ug(b, null, d, c) : $7c3f52cf960380f5$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7c3f52cf960380f5$var$Ci(d, e), $7c3f52cf960380f5$var$Yi(a, b, d, e, c);
        case 7:
            return $7c3f52cf960380f5$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $7c3f52cf960380f5$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $7c3f52cf960380f5$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $7c3f52cf960380f5$var$G($7c3f52cf960380f5$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($7c3f52cf960380f5$var$He(f.value, g)) {
                        if (f.children === e.children && !$7c3f52cf960380f5$var$Wf.current) {
                            b = $7c3f52cf960380f5$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f["return"] = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $7c3f52cf960380f5$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $7c3f52cf960380f5$var$bh(f["return"], c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f["return"];
                            if (null === g) throw Error($7c3f52cf960380f5$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $7c3f52cf960380f5$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g["return"] = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f["return"] = g["return"];
                                g = f;
                                break;
                            }
                            g = g["return"];
                        }
                        f = g;
                    }
                }
                $7c3f52cf960380f5$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $7c3f52cf960380f5$var$ch(b, c), e = $7c3f52cf960380f5$var$eh(e), d = d(e), b.flags |= 1, $7c3f52cf960380f5$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $7c3f52cf960380f5$var$Ci(d, b.pendingProps), e = $7c3f52cf960380f5$var$Ci(d.type, e), $7c3f52cf960380f5$var$$i(a, b, d, e, c);
        case 15:
            return $7c3f52cf960380f5$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7c3f52cf960380f5$var$Ci(d, e), $7c3f52cf960380f5$var$ij(a, b), b.tag = 1, $7c3f52cf960380f5$var$Zf(d) ? (a = !0, $7c3f52cf960380f5$var$cg(b)) : a = !1, $7c3f52cf960380f5$var$ch(b, c), $7c3f52cf960380f5$var$Gi(b, d, e), $7c3f52cf960380f5$var$Ii(b, d, e, c), $7c3f52cf960380f5$var$jj(null, b, d, !0, a, c);
        case 19:
            return $7c3f52cf960380f5$var$xj(a, b, c);
        case 22:
            return $7c3f52cf960380f5$var$dj(a, b, c);
    }
    throw Error($7c3f52cf960380f5$var$p(156, b.tag));
};
function $7c3f52cf960380f5$var$Fk(a, b) {
    return $7c3f52cf960380f5$var$ac(a, b);
}
function $7c3f52cf960380f5$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $7c3f52cf960380f5$var$Bg(a, b, c, d) {
    return new $7c3f52cf960380f5$var$$k(a, b, c, d);
}
function $7c3f52cf960380f5$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $7c3f52cf960380f5$var$Zk(a) {
    if ("function" === typeof a) return $7c3f52cf960380f5$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $7c3f52cf960380f5$var$Da) return 11;
        if (a === $7c3f52cf960380f5$var$Ga) return 14;
    }
    return 2;
}
function $7c3f52cf960380f5$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $7c3f52cf960380f5$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $7c3f52cf960380f5$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $7c3f52cf960380f5$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $7c3f52cf960380f5$var$ya:
            return $7c3f52cf960380f5$var$Tg(c.children, e, f, b);
        case $7c3f52cf960380f5$var$za:
            g = 8;
            e |= 8;
            break;
        case $7c3f52cf960380f5$var$Aa:
            return a = $7c3f52cf960380f5$var$Bg(12, c, b, e | 2), a.elementType = $7c3f52cf960380f5$var$Aa, a.lanes = f, a;
        case $7c3f52cf960380f5$var$Ea:
            return a = $7c3f52cf960380f5$var$Bg(13, c, b, e), a.elementType = $7c3f52cf960380f5$var$Ea, a.lanes = f, a;
        case $7c3f52cf960380f5$var$Fa:
            return a = $7c3f52cf960380f5$var$Bg(19, c, b, e), a.elementType = $7c3f52cf960380f5$var$Fa, a.lanes = f, a;
        case $7c3f52cf960380f5$var$Ia:
            return $7c3f52cf960380f5$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a) switch(a.$$typeof){
                case $7c3f52cf960380f5$var$Ba:
                    g = 10;
                    break a;
                case $7c3f52cf960380f5$var$Ca:
                    g = 9;
                    break a;
                case $7c3f52cf960380f5$var$Da:
                    g = 11;
                    break a;
                case $7c3f52cf960380f5$var$Ga:
                    g = 14;
                    break a;
                case $7c3f52cf960380f5$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($7c3f52cf960380f5$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a), ""));
    }
    b = $7c3f52cf960380f5$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $7c3f52cf960380f5$var$Tg(a, b, c, d) {
    a = $7c3f52cf960380f5$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $7c3f52cf960380f5$var$pj(a, b, c, d) {
    a = $7c3f52cf960380f5$var$Bg(22, a, d, b);
    a.elementType = $7c3f52cf960380f5$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $7c3f52cf960380f5$var$Qg(a, b, c) {
    a = $7c3f52cf960380f5$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $7c3f52cf960380f5$var$Sg(a, b, c) {
    b = $7c3f52cf960380f5$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $7c3f52cf960380f5$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $7c3f52cf960380f5$var$zc(0);
    this.expirationTimes = $7c3f52cf960380f5$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $7c3f52cf960380f5$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $7c3f52cf960380f5$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $7c3f52cf960380f5$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $7c3f52cf960380f5$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $7c3f52cf960380f5$var$kh(f);
    return a;
}
function $7c3f52cf960380f5$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $7c3f52cf960380f5$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $7c3f52cf960380f5$var$dl(a) {
    if (!a) return $7c3f52cf960380f5$var$Vf;
    a = a._reactInternals;
    a: {
        if ($7c3f52cf960380f5$var$Vb(a) !== a || 1 !== a.tag) throw Error($7c3f52cf960380f5$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($7c3f52cf960380f5$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b["return"];
        }while (null !== b);
        throw Error($7c3f52cf960380f5$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($7c3f52cf960380f5$var$Zf(c)) return $7c3f52cf960380f5$var$bg(a, c, b);
    }
    return b;
}
function $7c3f52cf960380f5$var$el(a, b, c, d, e, f, g, h, k) {
    a = $7c3f52cf960380f5$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $7c3f52cf960380f5$var$dl(null);
    c = a.current;
    d = $7c3f52cf960380f5$var$R();
    e = $7c3f52cf960380f5$var$yi(c);
    f = $7c3f52cf960380f5$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $7c3f52cf960380f5$var$nh(c, f, e);
    a.current.lanes = e;
    $7c3f52cf960380f5$var$Ac(a, e, d);
    $7c3f52cf960380f5$var$Dk(a, d);
    return a;
}
function $7c3f52cf960380f5$var$fl(a, b, c, d) {
    var e = b.current, f = $7c3f52cf960380f5$var$R(), g = $7c3f52cf960380f5$var$yi(e);
    c = $7c3f52cf960380f5$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $7c3f52cf960380f5$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $7c3f52cf960380f5$var$nh(e, b, g);
    null !== a && ($7c3f52cf960380f5$var$gi(a, e, g, f), $7c3f52cf960380f5$var$oh(a, e, g));
    return g;
}
function $7c3f52cf960380f5$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $7c3f52cf960380f5$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $7c3f52cf960380f5$var$il(a, b) {
    $7c3f52cf960380f5$var$hl(a, b);
    (a = a.alternate) && $7c3f52cf960380f5$var$hl(a, b);
}
function $7c3f52cf960380f5$var$jl() {
    return null;
}
var $7c3f52cf960380f5$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $7c3f52cf960380f5$var$ll(a) {
    this._internalRoot = a;
}
$7c3f52cf960380f5$var$ml.prototype.render = $7c3f52cf960380f5$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($7c3f52cf960380f5$var$p(409));
    $7c3f52cf960380f5$var$fl(a, b, null, null);
};
$7c3f52cf960380f5$var$ml.prototype.unmount = $7c3f52cf960380f5$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $7c3f52cf960380f5$var$Rk(function() {
            $7c3f52cf960380f5$var$fl(null, a, null, null);
        });
        b[$7c3f52cf960380f5$var$uf] = null;
    }
};
function $7c3f52cf960380f5$var$ml(a) {
    this._internalRoot = a;
}
$7c3f52cf960380f5$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $7c3f52cf960380f5$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $7c3f52cf960380f5$var$Qc.length && 0 !== b && b < $7c3f52cf960380f5$var$Qc[c].priority; c++);
        $7c3f52cf960380f5$var$Qc.splice(c, 0, a);
        0 === c && $7c3f52cf960380f5$var$Vc(a);
    }
};
function $7c3f52cf960380f5$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $7c3f52cf960380f5$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $7c3f52cf960380f5$var$pl() {}
function $7c3f52cf960380f5$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $7c3f52cf960380f5$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $7c3f52cf960380f5$var$el(b, d, a, 0, null, !1, !1, "", $7c3f52cf960380f5$var$pl);
        a._reactRootContainer = g;
        a[$7c3f52cf960380f5$var$uf] = g.current;
        $7c3f52cf960380f5$var$sf(8 === a.nodeType ? a.parentNode : a);
        $7c3f52cf960380f5$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $7c3f52cf960380f5$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $7c3f52cf960380f5$var$bl(a, 0, !1, null, null, !1, !1, "", $7c3f52cf960380f5$var$pl);
    a._reactRootContainer = k;
    a[$7c3f52cf960380f5$var$uf] = k.current;
    $7c3f52cf960380f5$var$sf(8 === a.nodeType ? a.parentNode : a);
    $7c3f52cf960380f5$var$Rk(function() {
        $7c3f52cf960380f5$var$fl(b, k, c, d);
    });
    return k;
}
function $7c3f52cf960380f5$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $7c3f52cf960380f5$var$gl(g);
                h.call(_$a);
            };
        }
        $7c3f52cf960380f5$var$fl(b, g, a, e);
    } else g = $7c3f52cf960380f5$var$ql(c, b, a, e, d);
    return $7c3f52cf960380f5$var$gl(g);
}
$7c3f52cf960380f5$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $7c3f52cf960380f5$var$tc(b.pendingLanes);
                0 !== c && ($7c3f52cf960380f5$var$Cc(b, c | 1), $7c3f52cf960380f5$var$Dk(b, $7c3f52cf960380f5$var$B()), 0 === ($7c3f52cf960380f5$var$K & 6) && ($7c3f52cf960380f5$var$Gj = $7c3f52cf960380f5$var$B() + 500, $7c3f52cf960380f5$var$jg()));
            }
            break;
        case 13:
            $7c3f52cf960380f5$var$Rk(function() {
                var b = $7c3f52cf960380f5$var$ih(a, 1);
                if (null !== b) {
                    var c = $7c3f52cf960380f5$var$R();
                    $7c3f52cf960380f5$var$gi(b, a, 1, c);
                }
            }), $7c3f52cf960380f5$var$il(a, 1);
    }
};
$7c3f52cf960380f5$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $7c3f52cf960380f5$var$ih(a, 134217728);
        if (null !== b) {
            var c = $7c3f52cf960380f5$var$R();
            $7c3f52cf960380f5$var$gi(b, a, 134217728, c);
        }
        $7c3f52cf960380f5$var$il(a, 134217728);
    }
};
$7c3f52cf960380f5$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $7c3f52cf960380f5$var$yi(a), c = $7c3f52cf960380f5$var$ih(a, b);
        if (null !== c) {
            var d = $7c3f52cf960380f5$var$R();
            $7c3f52cf960380f5$var$gi(c, a, b, d);
        }
        $7c3f52cf960380f5$var$il(a, b);
    }
};
$7c3f52cf960380f5$var$Hc = function Hc() {
    return $7c3f52cf960380f5$var$C;
};
$7c3f52cf960380f5$var$Ic = function Ic(a, b) {
    var c = $7c3f52cf960380f5$var$C;
    try {
        return $7c3f52cf960380f5$var$C = a, b();
    } finally{
        $7c3f52cf960380f5$var$C = c;
    }
};
$7c3f52cf960380f5$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $7c3f52cf960380f5$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $7c3f52cf960380f5$var$Db(d);
                        if (!e) throw Error($7c3f52cf960380f5$var$p(90));
                        $7c3f52cf960380f5$var$Wa(d);
                        $7c3f52cf960380f5$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $7c3f52cf960380f5$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $7c3f52cf960380f5$var$fb(a, !!c.multiple, b, !1);
    }
};
$7c3f52cf960380f5$var$Gb = $7c3f52cf960380f5$var$Qk;
$7c3f52cf960380f5$var$Hb = $7c3f52cf960380f5$var$Rk;
var $7c3f52cf960380f5$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $7c3f52cf960380f5$var$Cb,
        $7c3f52cf960380f5$var$ue,
        $7c3f52cf960380f5$var$Db,
        $7c3f52cf960380f5$var$Eb,
        $7c3f52cf960380f5$var$Fb,
        $7c3f52cf960380f5$var$Qk
    ]
}, $7c3f52cf960380f5$var$tl = {
    findFiberByHostInstance: $7c3f52cf960380f5$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $7c3f52cf960380f5$var$ul = {
    bundleType: $7c3f52cf960380f5$var$tl.bundleType,
    version: $7c3f52cf960380f5$var$tl.version,
    rendererPackageName: $7c3f52cf960380f5$var$tl.rendererPackageName,
    rendererConfig: $7c3f52cf960380f5$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $7c3f52cf960380f5$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $7c3f52cf960380f5$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $7c3f52cf960380f5$var$tl.findFiberByHostInstance || $7c3f52cf960380f5$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $7c3f52cf960380f5$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$7c3f52cf960380f5$var$vl.isDisabled && $7c3f52cf960380f5$var$vl.supportsFiber) try {
        $7c3f52cf960380f5$var$kc = $7c3f52cf960380f5$var$vl.inject($7c3f52cf960380f5$var$ul), $7c3f52cf960380f5$var$lc = $7c3f52cf960380f5$var$vl;
    } catch (a) {}
}
$7c3f52cf960380f5$export$ae55be85d98224ed = $7c3f52cf960380f5$var$sl;
$7c3f52cf960380f5$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$7c3f52cf960380f5$var$nl(b)) throw Error($7c3f52cf960380f5$var$p(200));
    return $7c3f52cf960380f5$var$cl(a, b, null, c);
};
$7c3f52cf960380f5$export$882461b6382ed46c = function(a, b) {
    if (!$7c3f52cf960380f5$var$nl(a)) throw Error($7c3f52cf960380f5$var$p(299));
    var c = !1, d = "", e = $7c3f52cf960380f5$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $7c3f52cf960380f5$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$7c3f52cf960380f5$var$uf] = b.current;
    $7c3f52cf960380f5$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $7c3f52cf960380f5$var$ll(b);
};
$7c3f52cf960380f5$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($7c3f52cf960380f5$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($7c3f52cf960380f5$var$p(268, a));
    }
    a = $7c3f52cf960380f5$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$7c3f52cf960380f5$export$cd75ccfd720a3cd4 = function(a) {
    return $7c3f52cf960380f5$var$Rk(a);
};
$7c3f52cf960380f5$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$7c3f52cf960380f5$var$ol(b)) throw Error($7c3f52cf960380f5$var$p(200));
    return $7c3f52cf960380f5$var$rl(null, a, b, !0, c);
};
$7c3f52cf960380f5$export$757ceba2d55c277e = function(a, b, c) {
    if (!$7c3f52cf960380f5$var$nl(a)) throw Error($7c3f52cf960380f5$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $7c3f52cf960380f5$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $7c3f52cf960380f5$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$7c3f52cf960380f5$var$uf] = b.current;
    $7c3f52cf960380f5$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $7c3f52cf960380f5$var$ml(b);
};
$7c3f52cf960380f5$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$7c3f52cf960380f5$var$ol(b)) throw Error($7c3f52cf960380f5$var$p(200));
    return $7c3f52cf960380f5$var$rl(null, a, b, !1, c);
};
$7c3f52cf960380f5$export$502457920280e6be = function(a) {
    if (!$7c3f52cf960380f5$var$ol(a)) throw Error($7c3f52cf960380f5$var$p(40));
    return a._reactRootContainer ? ($7c3f52cf960380f5$var$Rk(function() {
        $7c3f52cf960380f5$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$7c3f52cf960380f5$var$uf] = null;
        });
    }), !0) : !1;
};
$7c3f52cf960380f5$export$c78a37762a8d58e1 = $7c3f52cf960380f5$var$Qk;
$7c3f52cf960380f5$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$7c3f52cf960380f5$var$ol(c)) throw Error($7c3f52cf960380f5$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($7c3f52cf960380f5$var$p(38));
    return $7c3f52cf960380f5$var$rl(a, b, c, !1, d);
};
$7c3f52cf960380f5$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("gIYIQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ju0TA"));

});
parcelRegister("ju0TA", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e2f18379f5d5753a$export$c4744153514ff05d; }, function (v) { return $e2f18379f5d5753a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e2f18379f5d5753a$export$3e506c1ccc9cc1a7; }, function (v) { return $e2f18379f5d5753a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e2f18379f5d5753a$export$e26fe2ed2fa76875; }, function (v) { return $e2f18379f5d5753a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e2f18379f5d5753a$export$502329bbf4b505b1; }, function (v) { return $e2f18379f5d5753a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e2f18379f5d5753a$export$6e3807111c4874c4; }, function (v) { return $e2f18379f5d5753a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e2f18379f5d5753a$export$c27134553091fb3a; }, function (v) { return $e2f18379f5d5753a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e2f18379f5d5753a$export$33ee1acdc04fd2a2; }, function (v) { return $e2f18379f5d5753a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e2f18379f5d5753a$export$b00a404bbd5edef2; }, function (v) { return $e2f18379f5d5753a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e2f18379f5d5753a$export$8352ce38b91d0c62; }, function (v) { return $e2f18379f5d5753a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e2f18379f5d5753a$export$d66a1c1c77bd778b; }, function (v) { return $e2f18379f5d5753a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e2f18379f5d5753a$export$d3dfb8e4810cb555; }, function (v) { return $e2f18379f5d5753a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e2f18379f5d5753a$export$839f9183b0465a69; }, function (v) { return $e2f18379f5d5753a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e2f18379f5d5753a$export$72fdf0e06517287b; }, function (v) { return $e2f18379f5d5753a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e2f18379f5d5753a$export$4b844e58a3e414b4; }, function (v) { return $e2f18379f5d5753a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e2f18379f5d5753a$export$816d2913ae6b83b1; }, function (v) { return $e2f18379f5d5753a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e2f18379f5d5753a$export$61bcfe829111a1d0; }, function (v) { return $e2f18379f5d5753a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e2f18379f5d5753a$export$7ee8c9beb337bc3f; }, function (v) { return $e2f18379f5d5753a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e2f18379f5d5753a$export$b5836b71941fa3ed; }, function (v) { return $e2f18379f5d5753a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e2f18379f5d5753a$export$cf845f2c119da08a; }, function (v) { return $e2f18379f5d5753a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2xTNA = parcelRequire("2xTNA");
var $e2f18379f5d5753a$export$c4744153514ff05d;
var $e2f18379f5d5753a$export$3e506c1ccc9cc1a7;
var $e2f18379f5d5753a$export$e26fe2ed2fa76875;
var $e2f18379f5d5753a$export$502329bbf4b505b1;
var $e2f18379f5d5753a$export$6e3807111c4874c4;
var $e2f18379f5d5753a$export$c27134553091fb3a;
var $e2f18379f5d5753a$export$33ee1acdc04fd2a2;
var $e2f18379f5d5753a$export$b00a404bbd5edef2;
var $e2f18379f5d5753a$export$8352ce38b91d0c62;
var $e2f18379f5d5753a$export$d66a1c1c77bd778b;
var $e2f18379f5d5753a$export$d3dfb8e4810cb555;
var $e2f18379f5d5753a$export$839f9183b0465a69;
var $e2f18379f5d5753a$export$72fdf0e06517287b;
var $e2f18379f5d5753a$export$4b844e58a3e414b4;
var $e2f18379f5d5753a$export$816d2913ae6b83b1;
var $e2f18379f5d5753a$export$61bcfe829111a1d0;
var $e2f18379f5d5753a$export$7ee8c9beb337bc3f;
var $e2f18379f5d5753a$export$b5836b71941fa3ed;
var $e2f18379f5d5753a$export$cf845f2c119da08a;
'use strict';
function $e2f18379f5d5753a$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e2f18379f5d5753a$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e2f18379f5d5753a$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e2f18379f5d5753a$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e2f18379f5d5753a$var$g(C, c)) n < e && 0 > $e2f18379f5d5753a$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e2f18379f5d5753a$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e2f18379f5d5753a$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $2xTNA._)(performance)) && "function" === typeof performance.now) {
    var $e2f18379f5d5753a$var$l = performance;
    $e2f18379f5d5753a$export$c4744153514ff05d = function() {
        return $e2f18379f5d5753a$var$l.now();
    };
} else {
    var $e2f18379f5d5753a$var$p = Date, $e2f18379f5d5753a$var$q = $e2f18379f5d5753a$var$p.now();
    $e2f18379f5d5753a$export$c4744153514ff05d = function() {
        return $e2f18379f5d5753a$var$p.now() - $e2f18379f5d5753a$var$q;
    };
}
var $e2f18379f5d5753a$var$r = [], $e2f18379f5d5753a$var$t = [], $e2f18379f5d5753a$var$u = 1, $e2f18379f5d5753a$var$v = null, $e2f18379f5d5753a$var$y = 3, $e2f18379f5d5753a$var$z = !1, $e2f18379f5d5753a$var$A = !1, $e2f18379f5d5753a$var$B = !1, $e2f18379f5d5753a$var$D = "function" === typeof setTimeout ? setTimeout : null, $e2f18379f5d5753a$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e2f18379f5d5753a$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e2f18379f5d5753a$var$G(a) {
    for(var b = $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$t); null !== b;){
        if (null === b.callback) $e2f18379f5d5753a$var$k($e2f18379f5d5753a$var$t);
        else if (b.startTime <= a) $e2f18379f5d5753a$var$k($e2f18379f5d5753a$var$t), b.sortIndex = b.expirationTime, $e2f18379f5d5753a$var$f($e2f18379f5d5753a$var$r, b);
        else break;
        b = $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$t);
    }
}
function $e2f18379f5d5753a$var$H(a) {
    $e2f18379f5d5753a$var$B = !1;
    $e2f18379f5d5753a$var$G(a);
    if (!$e2f18379f5d5753a$var$A) {
        if (null !== $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$r)) $e2f18379f5d5753a$var$A = !0, $e2f18379f5d5753a$var$I($e2f18379f5d5753a$var$J);
        else {
            var b = $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$t);
            null !== b && $e2f18379f5d5753a$var$K($e2f18379f5d5753a$var$H, b.startTime - a);
        }
    }
}
function $e2f18379f5d5753a$var$J(a, b) {
    $e2f18379f5d5753a$var$A = !1;
    $e2f18379f5d5753a$var$B && ($e2f18379f5d5753a$var$B = !1, $e2f18379f5d5753a$var$E($e2f18379f5d5753a$var$L), $e2f18379f5d5753a$var$L = -1);
    $e2f18379f5d5753a$var$z = !0;
    var c = $e2f18379f5d5753a$var$y;
    try {
        $e2f18379f5d5753a$var$G(b);
        for($e2f18379f5d5753a$var$v = $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$r); null !== $e2f18379f5d5753a$var$v && (!($e2f18379f5d5753a$var$v.expirationTime > b) || a && !$e2f18379f5d5753a$var$M());){
            var d = $e2f18379f5d5753a$var$v.callback;
            if ("function" === typeof d) {
                $e2f18379f5d5753a$var$v.callback = null;
                $e2f18379f5d5753a$var$y = $e2f18379f5d5753a$var$v.priorityLevel;
                var e = d($e2f18379f5d5753a$var$v.expirationTime <= b);
                b = $e2f18379f5d5753a$export$c4744153514ff05d();
                "function" === typeof e ? $e2f18379f5d5753a$var$v.callback = e : $e2f18379f5d5753a$var$v === $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$r) && $e2f18379f5d5753a$var$k($e2f18379f5d5753a$var$r);
                $e2f18379f5d5753a$var$G(b);
            } else $e2f18379f5d5753a$var$k($e2f18379f5d5753a$var$r);
            $e2f18379f5d5753a$var$v = $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$r);
        }
        if (null !== $e2f18379f5d5753a$var$v) var w = !0;
        else {
            var m = $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$t);
            null !== m && $e2f18379f5d5753a$var$K($e2f18379f5d5753a$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e2f18379f5d5753a$var$v = null, $e2f18379f5d5753a$var$y = c, $e2f18379f5d5753a$var$z = !1;
    }
}
var $e2f18379f5d5753a$var$N = !1, $e2f18379f5d5753a$var$O = null, $e2f18379f5d5753a$var$L = -1, $e2f18379f5d5753a$var$P = 5, $e2f18379f5d5753a$var$Q = -1;
function $e2f18379f5d5753a$var$M() {
    return $e2f18379f5d5753a$export$c4744153514ff05d() - $e2f18379f5d5753a$var$Q < $e2f18379f5d5753a$var$P ? !1 : !0;
}
function $e2f18379f5d5753a$var$R() {
    if (null !== $e2f18379f5d5753a$var$O) {
        var a = $e2f18379f5d5753a$export$c4744153514ff05d();
        $e2f18379f5d5753a$var$Q = a;
        var b = !0;
        try {
            b = $e2f18379f5d5753a$var$O(!0, a);
        } finally{
            b ? $e2f18379f5d5753a$var$S() : ($e2f18379f5d5753a$var$N = !1, $e2f18379f5d5753a$var$O = null);
        }
    } else $e2f18379f5d5753a$var$N = !1;
}
var $e2f18379f5d5753a$var$S;
if ("function" === typeof $e2f18379f5d5753a$var$F) $e2f18379f5d5753a$var$S = function S() {
    $e2f18379f5d5753a$var$F($e2f18379f5d5753a$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e2f18379f5d5753a$var$T = new MessageChannel, $e2f18379f5d5753a$var$U = $e2f18379f5d5753a$var$T.port2;
    $e2f18379f5d5753a$var$T.port1.onmessage = $e2f18379f5d5753a$var$R;
    $e2f18379f5d5753a$var$S = function S() {
        $e2f18379f5d5753a$var$U.postMessage(null);
    };
} else $e2f18379f5d5753a$var$S = function S() {
    $e2f18379f5d5753a$var$D($e2f18379f5d5753a$var$R, 0);
};
function $e2f18379f5d5753a$var$I(a) {
    $e2f18379f5d5753a$var$O = a;
    $e2f18379f5d5753a$var$N || ($e2f18379f5d5753a$var$N = !0, $e2f18379f5d5753a$var$S());
}
function $e2f18379f5d5753a$var$K(a, b) {
    $e2f18379f5d5753a$var$L = $e2f18379f5d5753a$var$D(function() {
        a($e2f18379f5d5753a$export$c4744153514ff05d());
    }, b);
}
$e2f18379f5d5753a$export$3e506c1ccc9cc1a7 = 5;
$e2f18379f5d5753a$export$e26fe2ed2fa76875 = 1;
$e2f18379f5d5753a$export$502329bbf4b505b1 = 4;
$e2f18379f5d5753a$export$6e3807111c4874c4 = 3;
$e2f18379f5d5753a$export$c27134553091fb3a = null;
$e2f18379f5d5753a$export$33ee1acdc04fd2a2 = 2;
$e2f18379f5d5753a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e2f18379f5d5753a$export$8352ce38b91d0c62 = function() {
    $e2f18379f5d5753a$var$A || $e2f18379f5d5753a$var$z || ($e2f18379f5d5753a$var$A = !0, $e2f18379f5d5753a$var$I($e2f18379f5d5753a$var$J));
};
$e2f18379f5d5753a$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e2f18379f5d5753a$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e2f18379f5d5753a$export$d3dfb8e4810cb555 = function() {
    return $e2f18379f5d5753a$var$y;
};
$e2f18379f5d5753a$export$839f9183b0465a69 = function() {
    return $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$r);
};
$e2f18379f5d5753a$export$72fdf0e06517287b = function(a) {
    switch($e2f18379f5d5753a$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e2f18379f5d5753a$var$y;
    }
    var c = $e2f18379f5d5753a$var$y;
    $e2f18379f5d5753a$var$y = b;
    try {
        return a();
    } finally{
        $e2f18379f5d5753a$var$y = c;
    }
};
$e2f18379f5d5753a$export$4b844e58a3e414b4 = function() {};
$e2f18379f5d5753a$export$816d2913ae6b83b1 = function() {};
$e2f18379f5d5753a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e2f18379f5d5753a$var$y;
    $e2f18379f5d5753a$var$y = a;
    try {
        return b();
    } finally{
        $e2f18379f5d5753a$var$y = c;
    }
};
$e2f18379f5d5753a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e2f18379f5d5753a$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $2xTNA._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e2f18379f5d5753a$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e2f18379f5d5753a$var$f($e2f18379f5d5753a$var$t, a), null === $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$r) && a === $e2f18379f5d5753a$var$h($e2f18379f5d5753a$var$t) && ($e2f18379f5d5753a$var$B ? ($e2f18379f5d5753a$var$E($e2f18379f5d5753a$var$L), $e2f18379f5d5753a$var$L = -1) : $e2f18379f5d5753a$var$B = !0, $e2f18379f5d5753a$var$K($e2f18379f5d5753a$var$H, c - d))) : (a.sortIndex = e, $e2f18379f5d5753a$var$f($e2f18379f5d5753a$var$r, a), $e2f18379f5d5753a$var$A || $e2f18379f5d5753a$var$z || ($e2f18379f5d5753a$var$A = !0, $e2f18379f5d5753a$var$I($e2f18379f5d5753a$var$J)));
    return a;
};
$e2f18379f5d5753a$export$b5836b71941fa3ed = $e2f18379f5d5753a$var$M;
$e2f18379f5d5753a$export$cf845f2c119da08a = function(a) {
    var b = $e2f18379f5d5753a$var$y;
    return function() {
        var c = $e2f18379f5d5753a$var$y;
        $e2f18379f5d5753a$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e2f18379f5d5753a$var$y = c;
        }
    };
};

});



parcelRegister("2ppU9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $jxHvY = parcelRequire("jxHvY");
function $1c1202abebfcbef4$var$emptyFunction() {}
function $1c1202abebfcbef4$var$emptyFunctionWithReset() {}
$1c1202abebfcbef4$var$emptyFunctionWithReset.resetWarningCache = $1c1202abebfcbef4$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jxHvY) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1c1202abebfcbef4$var$emptyFunctionWithReset,
        resetWarningCache: $1c1202abebfcbef4$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jxHvY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $e3a2da83b10a313e$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $e3a2da83b10a313e$var$ReactPropTypesSecret;

});


parcelRegister("8uHhA", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $62f2b31c5e830915$export$2b8d127b894957b9; }, function (v) { return $62f2b31c5e830915$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $62f2b31c5e830915$export$cea3a54a6425200c; }, function (v) { return $62f2b31c5e830915$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $62f2b31c5e830915$export$a7c73072b1a182ae; }, function (v) { return $62f2b31c5e830915$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $62f2b31c5e830915$export$9f27bc3417b4524d; }, function (v) { return $62f2b31c5e830915$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $62f2b31c5e830915$export$db77ccec0bb4ccac; }, function (v) { return $62f2b31c5e830915$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $62f2b31c5e830915$export$8392c0c9d3dcbd35; }, function (v) { return $62f2b31c5e830915$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $62f2b31c5e830915$export$ffb0004e005737fa; }, function (v) { return $62f2b31c5e830915$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $62f2b31c5e830915$export$b624eff549462981; }, function (v) { return $62f2b31c5e830915$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $62f2b31c5e830915$export$7897aa7841a5380c; }, function (v) { return $62f2b31c5e830915$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $62f2b31c5e830915$export$602eac185826482c; }, function (v) { return $62f2b31c5e830915$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $62f2b31c5e830915$export$e2c29f18771995cb; }, function (v) { return $62f2b31c5e830915$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $62f2b31c5e830915$export$5f8d39834fd61797; }, function (v) { return $62f2b31c5e830915$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $62f2b31c5e830915$export$74bf444e3cd11ea5; }, function (v) { return $62f2b31c5e830915$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $62f2b31c5e830915$export$92387174baf9b227; }, function (v) { return $62f2b31c5e830915$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $62f2b31c5e830915$export$ec112efeb987d9c6; }, function (v) { return $62f2b31c5e830915$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $62f2b31c5e830915$export$b706b080d889d2c9; }, function (v) { return $62f2b31c5e830915$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $62f2b31c5e830915$export$5be5a87408f70ddc; }, function (v) { return $62f2b31c5e830915$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $62f2b31c5e830915$export$45a5e7f76e0caa8d; }, function (v) { return $62f2b31c5e830915$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $62f2b31c5e830915$export$455c2e768291efa6; }, function (v) { return $62f2b31c5e830915$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $62f2b31c5e830915$export$9522e17588c12572; }, function (v) { return $62f2b31c5e830915$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $62f2b31c5e830915$export$2110ac352bb060b9; }, function (v) { return $62f2b31c5e830915$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $62f2b31c5e830915$export$56885ab8b9c456ab; }, function (v) { return $62f2b31c5e830915$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $62f2b31c5e830915$export$d927fcb6adf8f9de; }, function (v) { return $62f2b31c5e830915$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $62f2b31c5e830915$export$b82d16f27459e05a; }, function (v) { return $62f2b31c5e830915$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $62f2b31c5e830915$export$522c17b4f5e123e8; }, function (v) { return $62f2b31c5e830915$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $62f2b31c5e830915$export$1aabd8a0274ecfd6; }, function (v) { return $62f2b31c5e830915$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $62f2b31c5e830915$export$9b621391a187a31a; }, function (v) { return $62f2b31c5e830915$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $62f2b31c5e830915$export$f5bbd400c2f4426f; }, function (v) { return $62f2b31c5e830915$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2xTNA = parcelRequire("2xTNA");
var $62f2b31c5e830915$export$2b8d127b894957b9;
var $62f2b31c5e830915$export$cea3a54a6425200c;
var $62f2b31c5e830915$export$a7c73072b1a182ae;
var $62f2b31c5e830915$export$9f27bc3417b4524d;
var $62f2b31c5e830915$export$db77ccec0bb4ccac;
var $62f2b31c5e830915$export$8392c0c9d3dcbd35;
var $62f2b31c5e830915$export$ffb0004e005737fa;
var $62f2b31c5e830915$export$b624eff549462981;
var $62f2b31c5e830915$export$7897aa7841a5380c;
var $62f2b31c5e830915$export$602eac185826482c;
var $62f2b31c5e830915$export$e2c29f18771995cb;
var $62f2b31c5e830915$export$5f8d39834fd61797;
var $62f2b31c5e830915$export$74bf444e3cd11ea5;
var $62f2b31c5e830915$export$92387174baf9b227;
var $62f2b31c5e830915$export$ec112efeb987d9c6;
var $62f2b31c5e830915$export$b706b080d889d2c9;
var $62f2b31c5e830915$export$5be5a87408f70ddc;
var $62f2b31c5e830915$export$45a5e7f76e0caa8d;
var $62f2b31c5e830915$export$455c2e768291efa6;
var $62f2b31c5e830915$export$9522e17588c12572;
var $62f2b31c5e830915$export$2110ac352bb060b9;
var $62f2b31c5e830915$export$56885ab8b9c456ab;
var $62f2b31c5e830915$export$d927fcb6adf8f9de;
var $62f2b31c5e830915$export$b82d16f27459e05a;
var $62f2b31c5e830915$export$522c17b4f5e123e8;
var $62f2b31c5e830915$export$1aabd8a0274ecfd6;
var $62f2b31c5e830915$export$9b621391a187a31a;
var $62f2b31c5e830915$export$f5bbd400c2f4426f;
'use strict';
var $62f2b31c5e830915$var$b = "function" === typeof Symbol && Symbol["for"], $62f2b31c5e830915$var$c = $62f2b31c5e830915$var$b ? Symbol["for"]("react.element") : 60103, $62f2b31c5e830915$var$d = $62f2b31c5e830915$var$b ? Symbol["for"]("react.portal") : 60106, $62f2b31c5e830915$var$e = $62f2b31c5e830915$var$b ? Symbol["for"]("react.fragment") : 60107, $62f2b31c5e830915$var$f = $62f2b31c5e830915$var$b ? Symbol["for"]("react.strict_mode") : 60108, $62f2b31c5e830915$var$g = $62f2b31c5e830915$var$b ? Symbol["for"]("react.profiler") : 60114, $62f2b31c5e830915$var$h = $62f2b31c5e830915$var$b ? Symbol["for"]("react.provider") : 60109, $62f2b31c5e830915$var$k = $62f2b31c5e830915$var$b ? Symbol["for"]("react.context") : 60110, $62f2b31c5e830915$var$l = $62f2b31c5e830915$var$b ? Symbol["for"]("react.async_mode") : 60111, $62f2b31c5e830915$var$m = $62f2b31c5e830915$var$b ? Symbol["for"]("react.concurrent_mode") : 60111, $62f2b31c5e830915$var$n = $62f2b31c5e830915$var$b ? Symbol["for"]("react.forward_ref") : 60112, $62f2b31c5e830915$var$p = $62f2b31c5e830915$var$b ? Symbol["for"]("react.suspense") : 60113, $62f2b31c5e830915$var$q = $62f2b31c5e830915$var$b ? Symbol["for"]("react.suspense_list") : 60120, $62f2b31c5e830915$var$r = $62f2b31c5e830915$var$b ? Symbol["for"]("react.memo") : 60115, $62f2b31c5e830915$var$t = $62f2b31c5e830915$var$b ? Symbol["for"]("react.lazy") : 60116, $62f2b31c5e830915$var$v = $62f2b31c5e830915$var$b ? Symbol["for"]("react.block") : 60121, $62f2b31c5e830915$var$w = $62f2b31c5e830915$var$b ? Symbol["for"]("react.fundamental") : 60117, $62f2b31c5e830915$var$x = $62f2b31c5e830915$var$b ? Symbol["for"]("react.responder") : 60118, $62f2b31c5e830915$var$y = $62f2b31c5e830915$var$b ? Symbol["for"]("react.scope") : 60119;
function $62f2b31c5e830915$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $62f2b31c5e830915$var$c:
                switch(a = a.type, a){
                    case $62f2b31c5e830915$var$l:
                    case $62f2b31c5e830915$var$m:
                    case $62f2b31c5e830915$var$e:
                    case $62f2b31c5e830915$var$g:
                    case $62f2b31c5e830915$var$f:
                    case $62f2b31c5e830915$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $62f2b31c5e830915$var$k:
                            case $62f2b31c5e830915$var$n:
                            case $62f2b31c5e830915$var$t:
                            case $62f2b31c5e830915$var$r:
                            case $62f2b31c5e830915$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $62f2b31c5e830915$var$d:
                return u;
        }
    }
}
function $62f2b31c5e830915$var$A(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$m;
}
$62f2b31c5e830915$export$2b8d127b894957b9 = $62f2b31c5e830915$var$l;
$62f2b31c5e830915$export$cea3a54a6425200c = $62f2b31c5e830915$var$m;
$62f2b31c5e830915$export$a7c73072b1a182ae = $62f2b31c5e830915$var$k;
$62f2b31c5e830915$export$9f27bc3417b4524d = $62f2b31c5e830915$var$h;
$62f2b31c5e830915$export$db77ccec0bb4ccac = $62f2b31c5e830915$var$c;
$62f2b31c5e830915$export$8392c0c9d3dcbd35 = $62f2b31c5e830915$var$n;
$62f2b31c5e830915$export$ffb0004e005737fa = $62f2b31c5e830915$var$e;
$62f2b31c5e830915$export$b624eff549462981 = $62f2b31c5e830915$var$t;
$62f2b31c5e830915$export$7897aa7841a5380c = $62f2b31c5e830915$var$r;
$62f2b31c5e830915$export$602eac185826482c = $62f2b31c5e830915$var$d;
$62f2b31c5e830915$export$e2c29f18771995cb = $62f2b31c5e830915$var$g;
$62f2b31c5e830915$export$5f8d39834fd61797 = $62f2b31c5e830915$var$f;
$62f2b31c5e830915$export$74bf444e3cd11ea5 = $62f2b31c5e830915$var$p;
$62f2b31c5e830915$export$92387174baf9b227 = function(a) {
    return $62f2b31c5e830915$var$A(a) || $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$l;
};
$62f2b31c5e830915$export$ec112efeb987d9c6 = $62f2b31c5e830915$var$A;
$62f2b31c5e830915$export$b706b080d889d2c9 = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$k;
};
$62f2b31c5e830915$export$5be5a87408f70ddc = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$h;
};
$62f2b31c5e830915$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && a.$$typeof === $62f2b31c5e830915$var$c;
};
$62f2b31c5e830915$export$455c2e768291efa6 = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$n;
};
$62f2b31c5e830915$export$9522e17588c12572 = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$e;
};
$62f2b31c5e830915$export$2110ac352bb060b9 = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$t;
};
$62f2b31c5e830915$export$56885ab8b9c456ab = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$r;
};
$62f2b31c5e830915$export$d927fcb6adf8f9de = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$d;
};
$62f2b31c5e830915$export$b82d16f27459e05a = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$g;
};
$62f2b31c5e830915$export$522c17b4f5e123e8 = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$f;
};
$62f2b31c5e830915$export$1aabd8a0274ecfd6 = function(a) {
    return $62f2b31c5e830915$var$z(a) === $62f2b31c5e830915$var$p;
};
$62f2b31c5e830915$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $62f2b31c5e830915$var$e || a === $62f2b31c5e830915$var$m || a === $62f2b31c5e830915$var$g || a === $62f2b31c5e830915$var$f || a === $62f2b31c5e830915$var$p || a === $62f2b31c5e830915$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && (a.$$typeof === $62f2b31c5e830915$var$t || a.$$typeof === $62f2b31c5e830915$var$r || a.$$typeof === $62f2b31c5e830915$var$h || a.$$typeof === $62f2b31c5e830915$var$k || a.$$typeof === $62f2b31c5e830915$var$n || a.$$typeof === $62f2b31c5e830915$var$w || a.$$typeof === $62f2b31c5e830915$var$x || a.$$typeof === $62f2b31c5e830915$var$y || a.$$typeof === $62f2b31c5e830915$var$v);
};
$62f2b31c5e830915$export$f5bbd400c2f4426f = $62f2b31c5e830915$var$z;

});

parcelRegister("b9uOG", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $81e870799af0fd9e$export$2b8d127b894957b9; }, function (v) { return $81e870799af0fd9e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $81e870799af0fd9e$export$cea3a54a6425200c; }, function (v) { return $81e870799af0fd9e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $81e870799af0fd9e$export$a7c73072b1a182ae; }, function (v) { return $81e870799af0fd9e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $81e870799af0fd9e$export$9f27bc3417b4524d; }, function (v) { return $81e870799af0fd9e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $81e870799af0fd9e$export$db77ccec0bb4ccac; }, function (v) { return $81e870799af0fd9e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $81e870799af0fd9e$export$8392c0c9d3dcbd35; }, function (v) { return $81e870799af0fd9e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $81e870799af0fd9e$export$ffb0004e005737fa; }, function (v) { return $81e870799af0fd9e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $81e870799af0fd9e$export$b624eff549462981; }, function (v) { return $81e870799af0fd9e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $81e870799af0fd9e$export$7897aa7841a5380c; }, function (v) { return $81e870799af0fd9e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $81e870799af0fd9e$export$602eac185826482c; }, function (v) { return $81e870799af0fd9e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $81e870799af0fd9e$export$e2c29f18771995cb; }, function (v) { return $81e870799af0fd9e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $81e870799af0fd9e$export$5f8d39834fd61797; }, function (v) { return $81e870799af0fd9e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $81e870799af0fd9e$export$74bf444e3cd11ea5; }, function (v) { return $81e870799af0fd9e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $81e870799af0fd9e$export$92387174baf9b227; }, function (v) { return $81e870799af0fd9e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $81e870799af0fd9e$export$ec112efeb987d9c6; }, function (v) { return $81e870799af0fd9e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $81e870799af0fd9e$export$b706b080d889d2c9; }, function (v) { return $81e870799af0fd9e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $81e870799af0fd9e$export$5be5a87408f70ddc; }, function (v) { return $81e870799af0fd9e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $81e870799af0fd9e$export$45a5e7f76e0caa8d; }, function (v) { return $81e870799af0fd9e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $81e870799af0fd9e$export$455c2e768291efa6; }, function (v) { return $81e870799af0fd9e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $81e870799af0fd9e$export$9522e17588c12572; }, function (v) { return $81e870799af0fd9e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $81e870799af0fd9e$export$2110ac352bb060b9; }, function (v) { return $81e870799af0fd9e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $81e870799af0fd9e$export$56885ab8b9c456ab; }, function (v) { return $81e870799af0fd9e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $81e870799af0fd9e$export$d927fcb6adf8f9de; }, function (v) { return $81e870799af0fd9e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $81e870799af0fd9e$export$b82d16f27459e05a; }, function (v) { return $81e870799af0fd9e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $81e870799af0fd9e$export$522c17b4f5e123e8; }, function (v) { return $81e870799af0fd9e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $81e870799af0fd9e$export$1aabd8a0274ecfd6; }, function (v) { return $81e870799af0fd9e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $81e870799af0fd9e$export$9b621391a187a31a; }, function (v) { return $81e870799af0fd9e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $81e870799af0fd9e$export$f5bbd400c2f4426f; }, function (v) { return $81e870799af0fd9e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2xTNA = parcelRequire("2xTNA");
var $81e870799af0fd9e$export$2b8d127b894957b9;
var $81e870799af0fd9e$export$cea3a54a6425200c;
var $81e870799af0fd9e$export$a7c73072b1a182ae;
var $81e870799af0fd9e$export$9f27bc3417b4524d;
var $81e870799af0fd9e$export$db77ccec0bb4ccac;
var $81e870799af0fd9e$export$8392c0c9d3dcbd35;
var $81e870799af0fd9e$export$ffb0004e005737fa;
var $81e870799af0fd9e$export$b624eff549462981;
var $81e870799af0fd9e$export$7897aa7841a5380c;
var $81e870799af0fd9e$export$602eac185826482c;
var $81e870799af0fd9e$export$e2c29f18771995cb;
var $81e870799af0fd9e$export$5f8d39834fd61797;
var $81e870799af0fd9e$export$74bf444e3cd11ea5;
var $81e870799af0fd9e$export$92387174baf9b227;
var $81e870799af0fd9e$export$ec112efeb987d9c6;
var $81e870799af0fd9e$export$b706b080d889d2c9;
var $81e870799af0fd9e$export$5be5a87408f70ddc;
var $81e870799af0fd9e$export$45a5e7f76e0caa8d;
var $81e870799af0fd9e$export$455c2e768291efa6;
var $81e870799af0fd9e$export$9522e17588c12572;
var $81e870799af0fd9e$export$2110ac352bb060b9;
var $81e870799af0fd9e$export$56885ab8b9c456ab;
var $81e870799af0fd9e$export$d927fcb6adf8f9de;
var $81e870799af0fd9e$export$b82d16f27459e05a;
var $81e870799af0fd9e$export$522c17b4f5e123e8;
var $81e870799af0fd9e$export$1aabd8a0274ecfd6;
var $81e870799af0fd9e$export$9b621391a187a31a;
var $81e870799af0fd9e$export$f5bbd400c2f4426f;
'use strict';
var $81e870799af0fd9e$var$b = "function" === typeof Symbol && Symbol["for"], $81e870799af0fd9e$var$c = $81e870799af0fd9e$var$b ? Symbol["for"]("react.element") : 60103, $81e870799af0fd9e$var$d = $81e870799af0fd9e$var$b ? Symbol["for"]("react.portal") : 60106, $81e870799af0fd9e$var$e = $81e870799af0fd9e$var$b ? Symbol["for"]("react.fragment") : 60107, $81e870799af0fd9e$var$f = $81e870799af0fd9e$var$b ? Symbol["for"]("react.strict_mode") : 60108, $81e870799af0fd9e$var$g = $81e870799af0fd9e$var$b ? Symbol["for"]("react.profiler") : 60114, $81e870799af0fd9e$var$h = $81e870799af0fd9e$var$b ? Symbol["for"]("react.provider") : 60109, $81e870799af0fd9e$var$k = $81e870799af0fd9e$var$b ? Symbol["for"]("react.context") : 60110, $81e870799af0fd9e$var$l = $81e870799af0fd9e$var$b ? Symbol["for"]("react.async_mode") : 60111, $81e870799af0fd9e$var$m = $81e870799af0fd9e$var$b ? Symbol["for"]("react.concurrent_mode") : 60111, $81e870799af0fd9e$var$n = $81e870799af0fd9e$var$b ? Symbol["for"]("react.forward_ref") : 60112, $81e870799af0fd9e$var$p = $81e870799af0fd9e$var$b ? Symbol["for"]("react.suspense") : 60113, $81e870799af0fd9e$var$q = $81e870799af0fd9e$var$b ? Symbol["for"]("react.suspense_list") : 60120, $81e870799af0fd9e$var$r = $81e870799af0fd9e$var$b ? Symbol["for"]("react.memo") : 60115, $81e870799af0fd9e$var$t = $81e870799af0fd9e$var$b ? Symbol["for"]("react.lazy") : 60116, $81e870799af0fd9e$var$v = $81e870799af0fd9e$var$b ? Symbol["for"]("react.block") : 60121, $81e870799af0fd9e$var$w = $81e870799af0fd9e$var$b ? Symbol["for"]("react.fundamental") : 60117, $81e870799af0fd9e$var$x = $81e870799af0fd9e$var$b ? Symbol["for"]("react.responder") : 60118, $81e870799af0fd9e$var$y = $81e870799af0fd9e$var$b ? Symbol["for"]("react.scope") : 60119;
function $81e870799af0fd9e$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $81e870799af0fd9e$var$c:
                switch(a = a.type, a){
                    case $81e870799af0fd9e$var$l:
                    case $81e870799af0fd9e$var$m:
                    case $81e870799af0fd9e$var$e:
                    case $81e870799af0fd9e$var$g:
                    case $81e870799af0fd9e$var$f:
                    case $81e870799af0fd9e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $81e870799af0fd9e$var$k:
                            case $81e870799af0fd9e$var$n:
                            case $81e870799af0fd9e$var$t:
                            case $81e870799af0fd9e$var$r:
                            case $81e870799af0fd9e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $81e870799af0fd9e$var$d:
                return u;
        }
    }
}
function $81e870799af0fd9e$var$A(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$m;
}
$81e870799af0fd9e$export$2b8d127b894957b9 = $81e870799af0fd9e$var$l;
$81e870799af0fd9e$export$cea3a54a6425200c = $81e870799af0fd9e$var$m;
$81e870799af0fd9e$export$a7c73072b1a182ae = $81e870799af0fd9e$var$k;
$81e870799af0fd9e$export$9f27bc3417b4524d = $81e870799af0fd9e$var$h;
$81e870799af0fd9e$export$db77ccec0bb4ccac = $81e870799af0fd9e$var$c;
$81e870799af0fd9e$export$8392c0c9d3dcbd35 = $81e870799af0fd9e$var$n;
$81e870799af0fd9e$export$ffb0004e005737fa = $81e870799af0fd9e$var$e;
$81e870799af0fd9e$export$b624eff549462981 = $81e870799af0fd9e$var$t;
$81e870799af0fd9e$export$7897aa7841a5380c = $81e870799af0fd9e$var$r;
$81e870799af0fd9e$export$602eac185826482c = $81e870799af0fd9e$var$d;
$81e870799af0fd9e$export$e2c29f18771995cb = $81e870799af0fd9e$var$g;
$81e870799af0fd9e$export$5f8d39834fd61797 = $81e870799af0fd9e$var$f;
$81e870799af0fd9e$export$74bf444e3cd11ea5 = $81e870799af0fd9e$var$p;
$81e870799af0fd9e$export$92387174baf9b227 = function(a) {
    return $81e870799af0fd9e$var$A(a) || $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$l;
};
$81e870799af0fd9e$export$ec112efeb987d9c6 = $81e870799af0fd9e$var$A;
$81e870799af0fd9e$export$b706b080d889d2c9 = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$k;
};
$81e870799af0fd9e$export$5be5a87408f70ddc = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$h;
};
$81e870799af0fd9e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && a.$$typeof === $81e870799af0fd9e$var$c;
};
$81e870799af0fd9e$export$455c2e768291efa6 = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$n;
};
$81e870799af0fd9e$export$9522e17588c12572 = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$e;
};
$81e870799af0fd9e$export$2110ac352bb060b9 = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$t;
};
$81e870799af0fd9e$export$56885ab8b9c456ab = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$r;
};
$81e870799af0fd9e$export$d927fcb6adf8f9de = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$d;
};
$81e870799af0fd9e$export$b82d16f27459e05a = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$g;
};
$81e870799af0fd9e$export$522c17b4f5e123e8 = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$f;
};
$81e870799af0fd9e$export$1aabd8a0274ecfd6 = function(a) {
    return $81e870799af0fd9e$var$z(a) === $81e870799af0fd9e$var$p;
};
$81e870799af0fd9e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $81e870799af0fd9e$var$e || a === $81e870799af0fd9e$var$m || a === $81e870799af0fd9e$var$g || a === $81e870799af0fd9e$var$f || a === $81e870799af0fd9e$var$p || a === $81e870799af0fd9e$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && (a.$$typeof === $81e870799af0fd9e$var$t || a.$$typeof === $81e870799af0fd9e$var$r || a.$$typeof === $81e870799af0fd9e$var$h || a.$$typeof === $81e870799af0fd9e$var$k || a.$$typeof === $81e870799af0fd9e$var$n || a.$$typeof === $81e870799af0fd9e$var$w || a.$$typeof === $81e870799af0fd9e$var$x || a.$$typeof === $81e870799af0fd9e$var$y || a.$$typeof === $81e870799af0fd9e$var$v);
};
$81e870799af0fd9e$export$f5bbd400c2f4426f = $81e870799af0fd9e$var$z;

});

parcelRegister("8fOd9", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return getMainCarrier; });
$parcel$export(module.exports, "getCurrentHub", function () { return getCurrentHub; });
$parcel$export(module.exports, "getIsolationScope", function () { return getIsolationScope; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return runWithAsyncContext; });

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $gVncj = parcelRequire("gVncj");
var $fzAJT = parcelRequire("fzAJT");
var $lVfPx = parcelRequire("lVfPx");
var $8lokx = parcelRequire("8lokx");
var $jYvOn = parcelRequire("jYvOn");

var $dwOTU = parcelRequire("dwOTU");

var $7Ui5X = parcelRequire("7Ui5X");

var $cogIK = parcelRequire("cogIK");

var $6TUUw = parcelRequire("6TUUw");

var $kyZym = parcelRequire("kyZym");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var API_VERSION = parseFloat((0, $kyZym.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
var Hub = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client, scope, isolationScope) {
        var _version = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : API_VERSION;
        (0, $6WLcG._)(this, Hub);
        this._version = _version;
        var assignedScope;
        if (!scope) {
            assignedScope = new (0, $cogIK.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        var assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $cogIK.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    (0, $dbIwN._)(Hub, [
        {
            /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ key: "bindClient",
            value: function bindClient(client) {
                // eslint-disable-next-line deprecation/deprecation
                var top = this.getStackTop();
                top.client = client;
                top.scope.setClient(client);
                // eslint-disable-next-line deprecation/deprecation
                if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
                client.setupIntegrations();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "pushScope",
            value: function pushScope() {
                // We want to clone the content of prev scope
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.getScope().clone();
                // eslint-disable-next-line deprecation/deprecation
                this.getStack().push({
                    // eslint-disable-next-line deprecation/deprecation
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "popScope",
            value: function popScope() {
                // eslint-disable-next-line deprecation/deprecation
                if (this.getStack().length <= 1) return false;
                // eslint-disable-next-line deprecation/deprecation
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    // eslint-disable-next-line deprecation/deprecation
                    this.popScope();
                    throw e;
                }
                if ((0, $8lokx.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
                return maybePromiseResult.then(function(res) {
                    // eslint-disable-next-line deprecation/deprecation
                    _this.popScope();
                    return res;
                }, function(e) {
                    // eslint-disable-next-line deprecation/deprecation
                    _this.popScope();
                    throw e;
                });
                // eslint-disable-next-line deprecation/deprecation
                this.popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ key: "getClient",
            value: function getClient() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ key: "getScope",
            value: function getScope() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $jYvOn.uuid4)();
                var syntheticException = new Error('Sentry syntheticException');
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureException(exception, (0, $7XD9P._)((0, $hRCmZ._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $jYvOn.uuid4)();
                var syntheticException = new Error(message);
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureMessage(message, level, (0, $7XD9P._)((0, $hRCmZ._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, $jYvOn.uuid4)();
                if (!event.type) this._lastEventId = eventId;
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureEvent(event, (0, $7XD9P._)((0, $hRCmZ._)({}, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (!client) return;
                var _ref = client.getOptions && client.getOptions() || {}, _ref_beforeBreadcrumb = _ref.beforeBreadcrumb, beforeBreadcrumb = _ref_beforeBreadcrumb === void 0 ? null : _ref_beforeBreadcrumb, _ref_maxBreadcrumbs = _ref.maxBreadcrumbs, maxBreadcrumbs = _ref_maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _ref_maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = (0, $fzAJT.dateTimestampInSeconds)();
                var mergedBreadcrumb = (0, $hRCmZ._)({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? (0, $gVncj.consoleSandbox)(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
                // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
                // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
                // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
                // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
                // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
                // the event processing pipeline.
                // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ key: "setUser",
            value: function setUser(user) {
                // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setUser(user);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ key: "setTags",
            value: function setTags(tags) {
                // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTags(tags);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ key: "setExtras",
            value: function setExtras(extras) {
                // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtras(extras);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTag(key, value);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtra(key, extra);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setContext(name, context);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ key: "configureScope",
            value: function configureScope(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (client) callback(scope);
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "run",
            value: function run(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var oldHub = makeMain(this);
                try {
                    callback(this);
                } finally{
                    // eslint-disable-next-line deprecation/deprecation
                    makeMain(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                if (!client) return null;
                try {
                    // eslint-disable-next-line deprecation/deprecation
                    return client.getIntegration(integration);
                } catch (_oO) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Cannot retrieve integration ".concat(integration.id, " from the current Hub"));
                    return null;
                }
            }
        },
        {
            /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
                if ((0, $7Ui5X.DEBUG_BUILD) && !result) {
                    // eslint-disable-next-line deprecation/deprecation
                    var client = this.getClient();
                    if (!client) (0, $gVncj.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
                    else (0, $gVncj.logger).warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n");
                }
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod('traceHeaders');
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ key: "captureSession",
            value: function captureSession() {
                var endSession = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // both send the update and pull the session from the scope
                if (endSession) // eslint-disable-next-line deprecation/deprecation
                return this.endSession();
                // only send the update
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ key: "endSession",
            value: function endSession() {
                // eslint-disable-next-line deprecation/deprecation
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) (0, $6TUUw.closeSession)(session);
                this._sendSessionUpdate();
                // the session is over; take it off of the scope
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ key: "startSession",
            value: function startSession(context) {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var _ref = client && client.getOptions() || {}, release = _ref.release, _ref_environment = _ref.environment, environment = _ref_environment === void 0 ? (0, $dwOTU.DEFAULT_ENVIRONMENT) : _ref_environment;
                // Will fetch userAgent if called from browser sdk
                var userAgent = ((0, $lVfPx.GLOBAL_OBJ).navigator || {}).userAgent;
                var session = (0, $6TUUw.makeSession)((0, $hRCmZ._)({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                // End existing session if there's one
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === 'ok') (0, $6TUUw.updateSession)(currentSession, {
                    status: 'exited'
                });
                // eslint-disable-next-line deprecation/deprecation
                this.endSession();
                // Afterwards we set the new session on the scope
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) client.captureSession(session);
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = getMainCarrier();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Extension method ".concat(method, " couldn't be found, doing nothing."));
            }
        }
    ]);
    return Hub;
}();
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    (0, $lVfPx.GLOBAL_OBJ).__SENTRY__ = (0, $lVfPx.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $lVfPx.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function getIsolationScope() {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)) // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(registry, new Hub());
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalHub();
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        var client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        var scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        var isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function runWithAsyncContext(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $lVfPx.getGlobalSingleton)('hub', function() {
        return new Hub();
    }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("6WLcG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $50ecc682c22a3d08$export$71511d61b312f219; });
function $50ecc682c22a3d08$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dbIwN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $999ed7c4b694c57f$export$71511d61b312f219; });
function $999ed7c4b694c57f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $999ed7c4b694c57f$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $999ed7c4b694c57f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $999ed7c4b694c57f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hRCmZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d0152653f43f6984$export$71511d61b312f219; });

var $8c6ug = parcelRequire("8c6ug");
function $d0152653f43f6984$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $8c6ug._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("8c6ug", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5f7479edc8aace72$export$71511d61b312f219; });
function $5f7479edc8aace72$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("7XD9P", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5cbc6af6a352f23a$export$71511d61b312f219; });
function $5cbc6af6a352f23a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5cbc6af6a352f23a$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $5cbc6af6a352f23a$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("gVncj", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $c523f6c3b560f539$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $c523f6c3b560f539$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $c523f6c3b560f539$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $c523f6c3b560f539$export$af88d00dbe7f521; });

var $bOqL7 = parcelRequire("bOqL7");

var $84Gbr = parcelRequire("84Gbr");

var $lVfPx = parcelRequire("lVfPx");
/** Prefix for logging strings */ var $c523f6c3b560f539$var$PREFIX = 'Sentry Logger ';
var $c523f6c3b560f539$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ var $c523f6c3b560f539$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c523f6c3b560f539$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $lVfPx.GLOBAL_OBJ))) return callback();
    var console = (0, $lVfPx.GLOBAL_OBJ).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys($c523f6c3b560f539$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = $c523f6c3b560f539$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c523f6c3b560f539$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        },
        isEnabled: function() {
            return enabled;
        }
    };
    if (0, $84Gbr.DEBUG_BUILD) $c523f6c3b560f539$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (enabled) $c523f6c3b560f539$export$cda52e2a8927a2ca(function() {
                var _GLOBAL_OBJ_console;
                (_GLOBAL_OBJ_console = (0, $lVfPx.GLOBAL_OBJ).console)[name].apply(_GLOBAL_OBJ_console, [
                    "".concat($c523f6c3b560f539$var$PREFIX, "[").concat(name, "]:")
                ].concat((0, $bOqL7._)(args)));
            });
        };
    });
    else $c523f6c3b560f539$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
var $c523f6c3b560f539$export$af88d00dbe7f521 = $c523f6c3b560f539$var$makeLogger();

});
parcelRegister("bOqL7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89991f0475d7846b$export$71511d61b312f219; });

var $a6JTZ = parcelRequire("a6JTZ");

var $7f9QD = parcelRequire("7f9QD");

var $6dklq = parcelRequire("6dklq");

var $dFREI = parcelRequire("dFREI");
function $89991f0475d7846b$export$71511d61b312f219(arr) {
    return (0, $a6JTZ._)(arr) || (0, $7f9QD._)(arr) || (0, $dFREI._)(arr) || (0, $6dklq._)();
}

});
parcelRegister("a6JTZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $75be121e04264f8e$export$71511d61b312f219; });

var $6jKex = parcelRequire("6jKex");
function $75be121e04264f8e$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $6jKex._)(arr);
}

});
parcelRegister("6jKex", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $499861734f08ee91$export$71511d61b312f219; });
function $499861734f08ee91$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("7f9QD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $546192baeedccc27$export$71511d61b312f219; });
function $546192baeedccc27$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("6dklq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4863bcf607f6ed82$export$71511d61b312f219; });
function $4863bcf607f6ed82$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("dFREI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9f48b997d7a29721$export$71511d61b312f219; });

var $6jKex = parcelRequire("6jKex");
function $9f48b997d7a29721$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6jKex._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6jKex._)(o, minLen);
}

});


parcelRegister("84Gbr", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $5e0f6b33d0ebae8f$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var $5e0f6b33d0ebae8f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("lVfPx", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $ff5b336e535cd403$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $ff5b336e535cd403$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $ff5b336e535cd403$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ 
var $2xTNA = parcelRequire("2xTNA");
function $ff5b336e535cd403$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ var $ff5b336e535cd403$export$f1a6cdb1459e81d1 = (typeof globalThis === "undefined" ? "undefined" : (0, $2xTNA._)(globalThis)) == 'object' && $ff5b336e535cd403$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
(typeof window === "undefined" ? "undefined" : (0, $2xTNA._)(window)) == 'object' && $ff5b336e535cd403$var$isGlobalObj(window) || (typeof self === "undefined" ? "undefined" : (0, $2xTNA._)(self)) == 'object' && $ff5b336e535cd403$var$isGlobalObj(self) || (typeof $parcel$global === "undefined" ? "undefined" : (0, $2xTNA._)($parcel$global)) == 'object' && $ff5b336e535cd403$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $ff5b336e535cd403$export$256479dc0cea61c4() {
    return $ff5b336e535cd403$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $ff5b336e535cd403$export$7e223ec222791509(name, creator, obj) {
    var gbl = obj || $ff5b336e535cd403$export$f1a6cdb1459e81d1;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("fzAJT", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $b5669f8ef78d0d9d$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $b5669f8ef78d0d9d$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $b5669f8ef78d0d9d$export$baf075a948ffc0bf; });

var $lVfPx = parcelRequire("lVfPx");
var $b5669f8ef78d0d9d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $b5669f8ef78d0d9d$export$7740643b9eeaf0c4() {
    return Date.now() / $b5669f8ef78d0d9d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b5669f8ef78d0d9d$var$createUnixTimestampInSecondsFunc() {
    var performance = (0, $lVfPx.GLOBAL_OBJ).performance;
    if (!performance || !performance.now) return $b5669f8ef78d0d9d$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    var approxStartingTimeOrigin = Date.now() - performance.now();
    var timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / $b5669f8ef78d0d9d$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var $b5669f8ef78d0d9d$export$ee52dced521e3e18 = $b5669f8ef78d0d9d$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ var $b5669f8ef78d0d9d$export$c5907b5a8838db13 = $b5669f8ef78d0d9d$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ var $b5669f8ef78d0d9d$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var $b5669f8ef78d0d9d$export$baf075a948ffc0bf = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $lVfPx.GLOBAL_OBJ).performance;
    if (!performance || !performance.now) {
        $b5669f8ef78d0d9d$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $b5669f8ef78d0d9d$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $b5669f8ef78d0d9d$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $b5669f8ef78d0d9d$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
}();

});

parcelRegister("8lokx", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $61332863b78a82ef$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $61332863b78a82ef$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $61332863b78a82ef$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $61332863b78a82ef$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $61332863b78a82ef$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $61332863b78a82ef$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $61332863b78a82ef$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $61332863b78a82ef$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $61332863b78a82ef$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $61332863b78a82ef$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $61332863b78a82ef$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $61332863b78a82ef$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $61332863b78a82ef$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $61332863b78a82ef$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $61332863b78a82ef$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $61332863b78a82ef$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method

var $2xTNA = parcelRequire("2xTNA");
var $61332863b78a82ef$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$e6127cc7fe7395c3(wat) {
    switch($61332863b78a82ef$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $61332863b78a82ef$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$var$isBuiltin(wat, className) {
    return $61332863b78a82ef$var$objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$9f9636d330b71954(wat) {
    return $61332863b78a82ef$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$ef9e2056653f0c8e(wat) {
    return $61332863b78a82ef$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$12e869b2a583f783(wat) {
    return $61332863b78a82ef$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$844ec244b1367d54(wat) {
    return $61332863b78a82ef$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$dbcbffa59149b824(wat) {
    return (typeof wat === "undefined" ? "undefined" : (0, $2xTNA._)(wat)) === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$c3825b437cbdea5c(wat) {
    return wat === null || $61332863b78a82ef$export$dbcbffa59149b824(wat) || (typeof wat === "undefined" ? "undefined" : (0, $2xTNA._)(wat)) !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$53b83ca8eaab0383(wat) {
    return $61332863b78a82ef$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $61332863b78a82ef$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $61332863b78a82ef$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$49841c62b9eff15(wat) {
    return $61332863b78a82ef$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $61332863b78a82ef$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$bc2894c7158efbac(wat) {
    return $61332863b78a82ef$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $61332863b78a82ef$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!((typeof wat === "undefined" ? "undefined" : (0, $2xTNA._)(wat)) === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("jYvOn", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $e8ac4c06db8fd173$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $e8ac4c06db8fd173$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $e8ac4c06db8fd173$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $e8ac4c06db8fd173$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $e8ac4c06db8fd173$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $e8ac4c06db8fd173$export$3131421a7d01b4fb; });

var $hRCmZ = parcelRequire("hRCmZ");

var $8yexE = parcelRequire("8yexE");

var $gj3Le = parcelRequire("gj3Le");

var $lVfPx = parcelRequire("lVfPx");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $e8ac4c06db8fd173$export$19f53698e68b2496() {
    var gbl = (0, $lVfPx.GLOBAL_OBJ);
    var crypto = gbl.crypto || gbl.msCrypto;
    var getRandomByte = function() {
        return Math.random() * 16;
    };
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = function() {
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            var typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function $e8ac4c06db8fd173$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $e8ac4c06db8fd173$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $e8ac4c06db8fd173$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return "".concat(firstException.type, ": ").concat(firstException.value);
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $e8ac4c06db8fd173$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $e8ac4c06db8fd173$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $e8ac4c06db8fd173$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $hRCmZ._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $hRCmZ._)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $e8ac4c06db8fd173$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $e8ac4c06db8fd173$export$d364f2020ab30578(input) {
    var match = input.match($e8ac4c06db8fd173$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $e8ac4c06db8fd173$export$ec2291bfc64632f0(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $gj3Le.snipLine)(line, 0);
    });
    frame.context_line = (0, $gj3Le.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $gj3Le.snipLine)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $e8ac4c06db8fd173$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $8yexE.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $e8ac4c06db8fd173$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("8yexE", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $639cc76184b1a549$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $639cc76184b1a549$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $639cc76184b1a549$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $639cc76184b1a549$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $639cc76184b1a549$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $639cc76184b1a549$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $639cc76184b1a549$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $639cc76184b1a549$export$d25f2688db1bb433; });

var $hRCmZ = parcelRequire("hRCmZ");

var $2xTNA = parcelRequire("2xTNA");

var $dHjQX = parcelRequire("dHjQX");

var $84Gbr = parcelRequire("84Gbr");

var $8lokx = parcelRequire("8lokx");

var $gVncj = parcelRequire("gVncj");

var $gj3Le = parcelRequire("gj3Le");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $639cc76184b1a549$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $639cc76184b1a549$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $639cc76184b1a549$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $84Gbr.DEBUG_BUILD) && (0, $gVncj.logger).log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $639cc76184b1a549$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $639cc76184b1a549$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $639cc76184b1a549$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $639cc76184b1a549$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key]));
    }).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $639cc76184b1a549$export$62ff257738bf57f5(value) {
    if ((0, $8lokx.isError)(value)) return (0, $hRCmZ._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $639cc76184b1a549$var$getOwnProperties(value));
    else if ((0, $8lokx.isEvent)(value)) {
        var newObj = (0, $hRCmZ._)({
            type: value.type,
            target: $639cc76184b1a549$var$serializeEventTarget(value.target),
            currentTarget: $639cc76184b1a549$var$serializeEventTarget(value.currentTarget)
        }, $639cc76184b1a549$var$getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, $8lokx.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $639cc76184b1a549$var$serializeEventTarget(target) {
    try {
        return (0, $8lokx.isElement)(target) ? (0, $dHjQX.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $639cc76184b1a549$var$getOwnProperties(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj)) === 'object' && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $639cc76184b1a549$export$b0244d5063c0b61b(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys($639cc76184b1a549$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $gj3Le.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $gj3Le.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $639cc76184b1a549$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $639cc76184b1a549$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $639cc76184b1a549$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($639cc76184b1a549$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== 'undefined') returnValue[key] = $639cc76184b1a549$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== undefined) return memoVal1;
        var returnValue1 = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push($639cc76184b1a549$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
function $639cc76184b1a549$var$isPojo(input) {
    if (!(0, $8lokx.isPlainObject)(input)) return false;
    try {
        var name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $639cc76184b1a549$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : (0, $2xTNA._)(wat)) === 'symbol' || (typeof wat === "undefined" ? "undefined" : (0, $2xTNA._)(wat)) === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $8lokx.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("dHjQX", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $9f8eb0eec619d6fa$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $9f8eb0eec619d6fa$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $9f8eb0eec619d6fa$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $9f8eb0eec619d6fa$export$26727cfcc4d7e0fc; });

var $8lokx = parcelRequire("8lokx");

var $lVfPx = parcelRequire("lVfPx");
// eslint-disable-next-line deprecation/deprecation
var $9f8eb0eec619d6fa$var$WINDOW = (0, $lVfPx.getGlobalObject)();
var $9f8eb0eec619d6fa$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9f8eb0eec619d6fa$export$5647df6b7814ac86(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || $9f8eb0eec619d6fa$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $9f8eb0eec619d6fa$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9f8eb0eec619d6fa$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($9f8eb0eec619d6fa$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        if (elem.id) out.push("#".concat(elem.id));
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $8lokx.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(".".concat(classes[i]));
        }
    }
    var allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[".concat(key, '="').concat(attr, '"]'));
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $9f8eb0eec619d6fa$export$1cfafeee2987818b() {
    try {
        return $9f8eb0eec619d6fa$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9f8eb0eec619d6fa$export$c660c1f3ab49225c(selector) {
    if ($9f8eb0eec619d6fa$var$WINDOW.document && $9f8eb0eec619d6fa$var$WINDOW.document.querySelector) return $9f8eb0eec619d6fa$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $9f8eb0eec619d6fa$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$9f8eb0eec619d6fa$var$WINDOW.HTMLElement) return null;
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("gj3Le", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $bdf1567b7dc91045$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $bdf1567b7dc91045$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $bdf1567b7dc91045$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $bdf1567b7dc91045$export$a7a5ec66062ea5d; });

var $8lokx = parcelRequire("8lokx");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $bdf1567b7dc91045$export$6a506b36fdea397d(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $bdf1567b7dc91045$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} ".concat(newLine);
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bdf1567b7dc91045$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $8lokx.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $bdf1567b7dc91045$export$cdded5b28a5f8c6d(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, $8lokx.isString)(value)) return false;
    if ((0, $8lokx.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $8lokx.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $bdf1567b7dc91045$export$a7a5ec66062ea5d(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return $bdf1567b7dc91045$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch);
    });
}

});



parcelRegister("dwOTU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $9d95bf5b326e6429$export$849dbeeeda01ae98; });
var $9d95bf5b326e6429$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("7Ui5X", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $5c1bccaa51266d2e$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var $5c1bccaa51266d2e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("cogIK", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $9054b253ad1f2ca9$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $9054b253ad1f2ca9$export$aa55d5ab8e05984f; });

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $bOqL7 = parcelRequire("bOqL7");

var $fzAJT = parcelRequire("fzAJT");
var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");
var $jYvOn = parcelRequire("jYvOn");

var $1DzcS = parcelRequire("1DzcS");

var $6TUUw = parcelRequire("6TUUw");

var $k0TL7 = parcelRequire("k0TL7");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var $9054b253ad1f2ca9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ var $9054b253ad1f2ca9$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $9054b253ad1f2ca9$export$775b6bb06e53a214 = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, $6WLcG._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $9054b253ad1f2ca9$var$generatePropagationContext();
    }
    (0, $dbIwN._)(Scope, [
        {
            /**
   * Clone this scope instance.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0, $bOqL7._)(this._breadcrumbs);
                newScope._tags = (0, $hRCmZ._)({}, this._tags);
                newScope._extra = (0, $hRCmZ._)({}, this._extra);
                newScope._contexts = (0, $hRCmZ._)({}, this._contexts);
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._span = this._span;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0, $bOqL7._)(this._eventProcessors);
                newScope._requestSession = this._requestSession;
                newScope._attachments = (0, $bOqL7._)(this._attachments);
                newScope._sdkProcessingMetadata = (0, $hRCmZ._)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0, $hRCmZ._)({}, this._propagationContext);
                newScope._client = this._client;
                return newScope;
            }
        },
        {
            /** Update the client on the scope. */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    segment: undefined,
                    username: undefined
                };
                if (this._session) (0, $6TUUw.updateSession)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, $hRCmZ._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = (0, $7XD9P._)((0, $hRCmZ._)({}, this._tags), (0, $8c6ug._)({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, $hRCmZ._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, $7XD9P._)((0, $hRCmZ._)({}, this._extra), (0, $8c6ug._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(// eslint-disable-next-line deprecation/deprecation
            level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope for future events.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ key: "getTransaction",
            value: function getTransaction() {
                // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
                // have a pointer to the currently-active transaction.
                var span = this._span;
                // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
                // Also, this method will be removed anyway.
                // eslint-disable-next-line deprecation/deprecation
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                var scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
                if (scopeToMerge instanceof Scope) {
                    var scopeData = scopeToMerge.getScopeData();
                    this._tags = (0, $hRCmZ._)({}, this._tags, scopeData.tags);
                    this._extra = (0, $hRCmZ._)({}, this._extra, scopeData.extra);
                    this._contexts = (0, $hRCmZ._)({}, this._contexts, scopeData.contexts);
                    if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
                    if (scopeData.level) this._level = scopeData.level;
                    if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
                    if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
                    if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
                } else if ((0, $8lokx.isPlainObject)(scopeToMerge)) {
                    var scopeContext = captureContext;
                    this._tags = (0, $hRCmZ._)({}, this._tags, scopeContext.tags);
                    this._extra = (0, $hRCmZ._)({}, this._extra, scopeContext.extra);
                    this._contexts = (0, $hRCmZ._)({}, this._contexts, scopeContext.contexts);
                    if (scopeContext.user) this._user = scopeContext.user;
                    if (scopeContext.level) this._level = scopeContext.level;
                    if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
                    if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
                    if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._requestSession = undefined;
                this._span = undefined;
                this._session = undefined;
                this._notifyScopeListeners();
                this._attachments = [];
                this._propagationContext = $9054b253ad1f2ca9$var$generatePropagationContext();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $9054b253ad1f2ca9$var$DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, $hRCmZ._)({
                    timestamp: (0, $fzAJT.dateTimestampInSeconds)()
                }, breadcrumb);
                var breadcrumbs = this._breadcrumbs;
                breadcrumbs.push(mergedBreadcrumb);
                this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ key: "getAttachments",
            value: function getAttachments() {
                var data = this.getScopeData();
                return data.attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "getScopeData",
            value: function getScopeData() {
                var _this = this, _breadcrumbs = _this._breadcrumbs, _attachments = _this._attachments, _contexts = _this._contexts, _tags = _this._tags, _extra = _this._extra, _user = _this._user, _level = _this._level, _fingerprint = _this._fingerprint, _eventProcessors = _this._eventProcessors, _propagationContext = _this._propagationContext, _sdkProcessingMetadata = _this._sdkProcessingMetadata, _transactionName = _this._transactionName, _span = _this._span;
                return {
                    breadcrumbs: _breadcrumbs,
                    attachments: _attachments,
                    contexts: _contexts,
                    tags: _tags,
                    extra: _extra,
                    user: _user,
                    level: _level,
                    fingerprint: _fingerprint || [],
                    eventProcessors: _eventProcessors,
                    propagationContext: _propagationContext,
                    sdkProcessingMetadata: _sdkProcessingMetadata,
                    transactionName: _transactionName,
                    span: _span
                };
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, additionalEventProcessors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                (0, $k0TL7.applyScopeDataToEvent)(event, this.getScopeData());
                // TODO (v8): Update this order to be: Global > Client > Scope
                var eventProcessors = (0, $bOqL7._)(additionalEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
                (0, $bOqL7._)((0, $1DzcS.getGlobalEventProcessors)()), (0, $bOqL7._)(this._eventProcessors));
                return (0, $1DzcS.notifyEventProcessors)(eventProcessors, event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, $hRCmZ._)({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, $jYvOn.uuid4)();
                if (!this._client) {
                    (0, $gVncj.logger).warn('No client configured on scope - will not capture exception!');
                    return eventId;
                }
                var syntheticException = new Error('Sentry syntheticException');
                this._client.captureException(exception, (0, $7XD9P._)((0, $hRCmZ._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, $jYvOn.uuid4)();
                if (!this._client) {
                    (0, $gVncj.logger).warn('No client configured on scope - will not capture message!');
                    return eventId;
                }
                var syntheticException = new Error(message);
                this._client.captureMessage(message, level, (0, $7XD9P._)((0, $hRCmZ._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, $jYvOn.uuid4)();
                if (!this._client) {
                    (0, $gVncj.logger).warn('No client configured on scope - will not capture event!');
                    return eventId;
                }
                this._client.captureEvent(event, (0, $7XD9P._)((0, $hRCmZ._)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ function clone(scope) {
                return scope ? scope.clone() : new Scope();
            }
        }
    ]);
    return Scope;
}();
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $9054b253ad1f2ca9$export$aa55d5ab8e05984f() {
    if (!$9054b253ad1f2ca9$var$globalScope) $9054b253ad1f2ca9$var$globalScope = new $9054b253ad1f2ca9$export$775b6bb06e53a214();
    return $9054b253ad1f2ca9$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $9054b253ad1f2ca9$export$c83048efd17527d6(scope) {
    $9054b253ad1f2ca9$var$globalScope = scope;
}
function $9054b253ad1f2ca9$var$generatePropagationContext() {
    return {
        traceId: (0, $jYvOn.uuid4)(),
        spanId: (0, $jYvOn.uuid4)().substring(16)
    };
}

});
parcelRegister("1DzcS", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $1314be4b032ea97f$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $1314be4b032ea97f$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $1314be4b032ea97f$export$bf2a096c3e883e79; });

var $hRCmZ = parcelRequire("hRCmZ");

var $lVfPx = parcelRequire("lVfPx");
var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");
var $gXCgb = parcelRequire("gXCgb");

var $7Ui5X = parcelRequire("7Ui5X");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $1314be4b032ea97f$export$3c4238858b85e8ac() {
    return (0, $lVfPx.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $1314be4b032ea97f$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $1314be4b032ea97f$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $1314be4b032ea97f$export$bf2a096c3e883e79(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return new (0, $gXCgb.SyncPromise)(function(resolve, reject) {
        var processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            var result = processor((0, $hRCmZ._)({}, event), hint);
            (0, $7Ui5X.DEBUG_BUILD) && processor.id && result === null && (0, $gVncj.logger).log('Event processor "'.concat(processor.id, '" dropped event'));
            if ((0, $8lokx.isThenable)(result)) result.then(function(_final) {
                return $1314be4b032ea97f$export$bf2a096c3e883e79(processors, _final, hint, index + 1).then(resolve);
            }).then(null, reject);
            else $1314be4b032ea97f$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("gXCgb", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $c58fd5a81507ff13$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $c58fd5a81507ff13$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $c58fd5a81507ff13$export$78e43115b553f358; });

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8lokx = parcelRequire("8lokx");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $c58fd5a81507ff13$var$States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c58fd5a81507ff13$var$States || ($c58fd5a81507ff13$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c58fd5a81507ff13$export$1fda8aa4d135f8aa(value) {
    return new $c58fd5a81507ff13$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c58fd5a81507ff13$export$78e43115b553f358(reason) {
    return new $c58fd5a81507ff13$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $c58fd5a81507ff13$export$6f292d4960313241 = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0, $6WLcG._)(this, SyncPromise);
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        this._state = $c58fd5a81507ff13$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    (0, $dbIwN._)(SyncPromise, [
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                            // TODO: FIXME
                            resolve(result);
                            else try {
                                resolve(onfulfilled(result));
                            } catch (e) {
                                reject(e);
                            }
                        },
                        function(reason) {
                            if (!onrejected) reject(reason);
                            else try {
                                resolve(onrejected(reason));
                            } catch (e) {
                                reject(e);
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) onfinally();
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) onfinally();
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init",
            value: function __init() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult($c58fd5a81507ff13$var$States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult($c58fd5a81507ff13$var$States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== $c58fd5a81507ff13$var$States.PENDING) return;
                    if ((0, $8lokx.isThenable)(value)) {
                        value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === $c58fd5a81507ff13$var$States.PENDING) return;
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) return;
                        if (_this._state === $c58fd5a81507ff13$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler[1](_this._value);
                        if (_this._state === $c58fd5a81507ff13$var$States.REJECTED) handler[2](_this._value);
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return SyncPromise;
}();

});


parcelRegister("6TUUw", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $5064066321ee2fe9$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $5064066321ee2fe9$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $5064066321ee2fe9$export$56521d9ba90f62ee; });

var $8yexE = parcelRequire("8yexE");
var $fzAJT = parcelRequire("fzAJT");
var $jYvOn = parcelRequire("jYvOn");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $5064066321ee2fe9$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, $fzAJT.timestampInSeconds)();
    var session = {
        sid: (0, $jYvOn.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return $5064066321ee2fe9$var$sessionToJSON(session);
        }
    };
    if (context) $5064066321ee2fe9$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $5064066321ee2fe9$export$531818e825e774db(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $fzAJT.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $jYvOn.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = "".concat(context.did);
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $5064066321ee2fe9$export$56521d9ba90f62ee(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $5064066321ee2fe9$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $5064066321ee2fe9$var$sessionToJSON(session) {
    return (0, $8yexE.dropUndefinedKeys)({
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? "".concat(session.did) : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("k0TL7", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $e91f0f4b0c8ec912$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $e91f0f4b0c8ec912$export$25ac7e259a513db4; });

var $hRCmZ = parcelRequire("hRCmZ");

var $bOqL7 = parcelRequire("bOqL7");

var $jYvOn = parcelRequire("jYvOn");
var $8yexE = parcelRequire("8yexE");

var $dYxb4 = parcelRequire("dYxb4");

var $lG8Hn = parcelRequire("lG8Hn");

var $6hfta = parcelRequire("6hfta");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $e91f0f4b0c8ec912$export$43988bc651a80216(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    // Apply general data
    $e91f0f4b0c8ec912$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $e91f0f4b0c8ec912$var$applySpanToEvent(event, span);
    $e91f0f4b0c8ec912$var$applyFingerprintToEvent(event, fingerprint);
    $e91f0f4b0c8ec912$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $e91f0f4b0c8ec912$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $e91f0f4b0c8ec912$export$25ac7e259a513db4(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, // eslint-disable-next-line deprecation/deprecation
    transactionName = mergeData.transactionName, span = mergeData.span;
    $e91f0f4b0c8ec912$export$b1a120a2871faa46(data, 'extra', extra);
    $e91f0f4b0c8ec912$export$b1a120a2871faa46(data, 'tags', tags);
    $e91f0f4b0c8ec912$export$b1a120a2871faa46(data, 'user', user);
    $e91f0f4b0c8ec912$export$b1a120a2871faa46(data, 'contexts', contexts);
    $e91f0f4b0c8ec912$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = (0, $bOqL7._)(data.breadcrumbs).concat((0, $bOqL7._)(breadcrumbs));
    if (fingerprint.length) data.fingerprint = (0, $bOqL7._)(data.fingerprint).concat((0, $bOqL7._)(fingerprint));
    if (eventProcessors.length) data.eventProcessors = (0, $bOqL7._)(data.eventProcessors).concat((0, $bOqL7._)(eventProcessors));
    if (attachments.length) data.attachments = (0, $bOqL7._)(data.attachments).concat((0, $bOqL7._)(attachments));
    data.propagationContext = (0, $hRCmZ._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $e91f0f4b0c8ec912$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = (0, $hRCmZ._)({}, data[prop]);
        for(var key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $e91f0f4b0c8ec912$var$applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, // eslint-disable-next-line deprecation/deprecation
    transactionName = data.transactionName;
    var cleanedExtra = (0, $8yexE.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = (0, $hRCmZ._)({}, cleanedExtra, event.extra);
    var cleanedTags = (0, $8yexE.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = (0, $hRCmZ._)({}, cleanedTags, event.tags);
    var cleanedUser = (0, $8yexE.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = (0, $hRCmZ._)({}, cleanedUser, event.user);
    var cleanedContexts = (0, $8yexE.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = (0, $hRCmZ._)({}, cleanedContexts, event.contexts);
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $e91f0f4b0c8ec912$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0, $bOqL7._)(event.breadcrumbs || []).concat((0, $bOqL7._)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $e91f0f4b0c8ec912$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $hRCmZ._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $e91f0f4b0c8ec912$var$applySpanToEvent(event, span) {
    event.contexts = (0, $hRCmZ._)({
        trace: (0, $6hfta.spanToTraceContext)(span)
    }, event.contexts);
    var rootSpan = (0, $lG8Hn.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = (0, $hRCmZ._)({
            dynamicSamplingContext: (0, $dYxb4.getDynamicSamplingContextFromSpan)(span)
        }, event.sdkProcessingMetadata);
        var transactionName = (0, $6hfta.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = (0, $hRCmZ._)({
            transaction: transactionName
        }, event.tags);
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $e91f0f4b0c8ec912$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $jYvOn.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("dYxb4", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $a2ca9d5966980eb0$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $a2ca9d5966980eb0$export$a117f995597e25df; });

var $8yexE = parcelRequire("8yexE");

var $dwOTU = parcelRequire("dwOTU");

var $cCIJH = parcelRequire("cCIJH");

var $lG8Hn = parcelRequire("lG8Hn");

var $6hfta = parcelRequire("6hfta");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $a2ca9d5966980eb0$export$366bad00d6815eed(trace_id, client, scope) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    var _ref1 = scope && scope.getUser() || {}, user_segment = _ref1.segment;
    var dsc = (0, $8yexE.dropUndefinedKeys)({
        environment: options.environment || (0, $dwOTU.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $a2ca9d5966980eb0$export$a117f995597e25df(span) {
    var client = (0, $cCIJH.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    var dsc = $a2ca9d5966980eb0$export$366bad00d6815eed((0, $6hfta.spanToJSON)(span).trace_id || '', client, (0, $cCIJH.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    var txn = (0, $lG8Hn.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    var v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    var _txn_metadata = txn.metadata, maybeSampleRate = _txn_metadata.sampleRate, source = _txn_metadata.source;
    if (maybeSampleRate != null) dsc.sample_rate = "".concat(maybeSampleRate);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var jsonSpan = (0, $6hfta.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $6hfta.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("cCIJH", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $930bbc5106fff8b3$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $930bbc5106fff8b3$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $930bbc5106fff8b3$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $930bbc5106fff8b3$export$efda9a273d7a036d; });
$parcel$export(module.exports, "withScope", function () { return $930bbc5106fff8b3$export$ec58d9285c204497; });
$parcel$export(module.exports, "getCurrentScope", function () { return $930bbc5106fff8b3$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $930bbc5106fff8b3$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "startSession", function () { return $930bbc5106fff8b3$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $930bbc5106fff8b3$export$667e7b4d445d566b; });

var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");

var $lVfPx = parcelRequire("lVfPx");
var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");
var $fzAJT = parcelRequire("fzAJT");
var $jYvOn = parcelRequire("jYvOn");

var $dwOTU = parcelRequire("dwOTU");

var $7Ui5X = parcelRequire("7Ui5X");

var $8fOd9 = parcelRequire("8fOd9");

var $6TUUw = parcelRequire("6TUUw");

var $1wdOb = parcelRequire("1wdOb");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $930bbc5106fff8b3$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().captureException(exception, (0, $1wdOb.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $930bbc5106fff8b3$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $930bbc5106fff8b3$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $930bbc5106fff8b3$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $930bbc5106fff8b3$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8fOd9.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $930bbc5106fff8b3$export$ec58d9285c204497() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, $8fOd9.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, $6mdMa._)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(function() {
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $930bbc5106fff8b3$export$9a4fed82c350c2bd(callback) {
    return (0, $8fOd9.runWithAsyncContext)(function() {
        return callback((0, $8fOd9.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $930bbc5106fff8b3$export$e57ac09b143d92a2(span, callback) {
    return $930bbc5106fff8b3$export$ec58d9285c204497(function(scope) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $930bbc5106fff8b3$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().startTransaction((0, $hRCmZ._)({}, context), customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $930bbc5106fff8b3$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    var scope = $930bbc5106fff8b3$export$c7be4b0125a10cba();
    var client = $930bbc5106fff8b3$export$6bb76d6eba7e258c();
    if (!client) (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $jYvOn.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $930bbc5106fff8b3$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    var checkInId = $930bbc5106fff8b3$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    var now = (0, $fzAJT.timestampInSeconds)();
    function finishCheckIn(status) {
        $930bbc5106fff8b3$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $fzAJT.timestampInSeconds)() - now
        });
    }
    var maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $8lokx.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(function() {
        finishCheckIn('ok');
    }, function() {
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $930bbc5106fff8b3$export$4909b86c8034bf73(timeout) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var client;
        return (0, $dMrZK.__generator)(this, function(_state) {
            client = $930bbc5106fff8b3$export$6bb76d6eba7e258c();
            if (client) return [
                2,
                client.flush(timeout)
            ];
            (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Cannot flush events. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $930bbc5106fff8b3$export$8360e631d277ea4d(timeout) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var client;
        return (0, $dMrZK.__generator)(this, function(_state) {
            client = $930bbc5106fff8b3$export$6bb76d6eba7e258c();
            if (client) return [
                2,
                client.close(timeout)
            ];
            (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Cannot flush events and disable SDK. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $930bbc5106fff8b3$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $930bbc5106fff8b3$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $930bbc5106fff8b3$export$3f95c6f800b78024() {
    return !!$930bbc5106fff8b3$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $930bbc5106fff8b3$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8fOd9.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $930bbc5106fff8b3$export$c0d84948cecf78d8(context) {
    var client = $930bbc5106fff8b3$export$6bb76d6eba7e258c();
    var isolationScope = (0, $8fOd9.getIsolationScope)();
    var currentScope = $930bbc5106fff8b3$export$c7be4b0125a10cba();
    var _ref = client && client.getOptions() || {}, release = _ref.release, _ref_environment = _ref.environment, environment = _ref_environment === void 0 ? (0, $dwOTU.DEFAULT_ENVIRONMENT) : _ref_environment;
    // Will fetch userAgent if called from browser sdk
    var userAgent = ((0, $lVfPx.GLOBAL_OBJ).navigator || {}).userAgent;
    var session = (0, $6TUUw.makeSession)((0, $hRCmZ._)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    var currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $6TUUw.updateSession)(currentSession, {
        status: 'exited'
    });
    $930bbc5106fff8b3$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $930bbc5106fff8b3$export$17a5be43989a0bc1() {
    var isolationScope = (0, $8fOd9.getIsolationScope)();
    var currentScope = $930bbc5106fff8b3$export$c7be4b0125a10cba();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $6TUUw.closeSession)(session);
    $930bbc5106fff8b3$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $930bbc5106fff8b3$var$_sendSessionUpdate() {
    var isolationScope = (0, $8fOd9.getIsolationScope)();
    var currentScope = $930bbc5106fff8b3$export$c7be4b0125a10cba();
    var client = $930bbc5106fff8b3$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $930bbc5106fff8b3$export$667e7b4d445d566b() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // both send the update and pull the session from the scope
    if (end) {
        $930bbc5106fff8b3$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $930bbc5106fff8b3$var$_sendSessionUpdate();
}

});
parcelRegister("iNemB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dae7f1e337e739c1$export$71511d61b312f219; });
function $dae7f1e337e739c1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $dae7f1e337e739c1$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $dae7f1e337e739c1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $dae7f1e337e739c1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("6mdMa", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4a0f7bbe8b173339$export$71511d61b312f219; });

var $dsRPj = parcelRequire("dsRPj");

var $cdogA = parcelRequire("cdogA");

var $3pJb0 = parcelRequire("3pJb0");

var $dFREI = parcelRequire("dFREI");
function $4a0f7bbe8b173339$export$71511d61b312f219(arr, i) {
    return (0, $dsRPj._)(arr) || (0, $cdogA._)(arr, i) || (0, $dFREI._)(arr, i) || (0, $3pJb0._)();
}

});
parcelRegister("dsRPj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9cd7a4be26a31ac5$export$71511d61b312f219; });
function $9cd7a4be26a31ac5$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("cdogA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8e4985c2f905bb97$export$71511d61b312f219; });
function $8e4985c2f905bb97$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("3pJb0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $27c6bfffd80336ae$export$71511d61b312f219; });
function $27c6bfffd80336ae$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dMrZK", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $a085793ee13ac643$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $a085793ee13ac643$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $a085793ee13ac643$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArray", function () { return $a085793ee13ac643$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $2xTNA = parcelRequire("2xTNA");
var $a085793ee13ac643$var$extendStatics = function extendStatics1(d, b) {
    $a085793ee13ac643$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a085793ee13ac643$var$extendStatics(d, b);
};
function $a085793ee13ac643$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a085793ee13ac643$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a085793ee13ac643$export$18ce0697a983be9b = function __assign1() {
    $a085793ee13ac643$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a085793ee13ac643$export$18ce0697a983be9b.apply(this, arguments);
};
function $a085793ee13ac643$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a085793ee13ac643$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2xTNA._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a085793ee13ac643$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a085793ee13ac643$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $2xTNA._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a085793ee13ac643$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a085793ee13ac643$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2xTNA._)(x)) === "symbol" ? x : "".concat(x);
}
function $a085793ee13ac643$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2xTNA._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a085793ee13ac643$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2xTNA._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a085793ee13ac643$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a085793ee13ac643$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a085793ee13ac643$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a085793ee13ac643$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a085793ee13ac643$export$45d3717a4c69092e(o, m, p);
}
function $a085793ee13ac643$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a085793ee13ac643$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a085793ee13ac643$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a085793ee13ac643$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a085793ee13ac643$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a085793ee13ac643$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a085793ee13ac643$export$10c90e4f7922046c(v) {
    return this instanceof $a085793ee13ac643$export$10c90e4f7922046c ? (this.v = v, this) : new $a085793ee13ac643$export$10c90e4f7922046c(v);
}
function $a085793ee13ac643$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a085793ee13ac643$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a085793ee13ac643$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a085793ee13ac643$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a085793ee13ac643$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a085793ee13ac643$export$19a8beecd37a4c45 === "function" ? $a085793ee13ac643$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a085793ee13ac643$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a085793ee13ac643$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a085793ee13ac643$var$ownKeys = function ownKeys1(o) {
    $a085793ee13ac643$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a085793ee13ac643$var$ownKeys(o);
};
function $a085793ee13ac643$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a085793ee13ac643$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a085793ee13ac643$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a085793ee13ac643$var$__setModuleDefault(result, mod);
    return result;
}
function $a085793ee13ac643$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $a085793ee13ac643$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a085793ee13ac643$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a085793ee13ac643$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $2xTNA._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a085793ee13ac643$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a085793ee13ac643$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a085793ee13ac643$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a085793ee13ac643$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a085793ee13ac643$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a085793ee13ac643$export$2e2bcd8739ae039 = {
    __extends: $a085793ee13ac643$export$a8ba968b8961cb8a,
    __assign: $a085793ee13ac643$export$18ce0697a983be9b,
    __rest: $a085793ee13ac643$export$3c9a16f847548506,
    __decorate: $a085793ee13ac643$export$29e00dfd3077644b,
    __param: $a085793ee13ac643$export$d5ad3fd78186038f,
    __esDecorate: $a085793ee13ac643$export$3a84e1ae4e97e9b0,
    __runInitializers: $a085793ee13ac643$export$d831c04e792af3d,
    __propKey: $a085793ee13ac643$export$6a2a36740a146cb8,
    __setFunctionName: $a085793ee13ac643$export$d1a06452d3489bc7,
    __metadata: $a085793ee13ac643$export$f1db080c865becb9,
    __awaiter: $a085793ee13ac643$export$1050f835b63b671e,
    __generator: $a085793ee13ac643$export$67ebef60e6f28a6,
    __createBinding: $a085793ee13ac643$export$45d3717a4c69092e,
    __exportStar: $a085793ee13ac643$export$f33643c0debef087,
    __values: $a085793ee13ac643$export$19a8beecd37a4c45,
    __read: $a085793ee13ac643$export$8d051b38c9118094,
    __spread: $a085793ee13ac643$export$afc72e2116322959,
    __spreadArrays: $a085793ee13ac643$export$6388937ca91ccae8,
    __spreadArray: $a085793ee13ac643$export$1216008129fb82ed,
    __await: $a085793ee13ac643$export$10c90e4f7922046c,
    __asyncGenerator: $a085793ee13ac643$export$e427f37a30a4de9b,
    __asyncDelegator: $a085793ee13ac643$export$bbd80228419bb833,
    __asyncValues: $a085793ee13ac643$export$e3b29a3d6162315f,
    __makeTemplateObject: $a085793ee13ac643$export$4fb47efe1390b86f,
    __importStar: $a085793ee13ac643$export$c21735bcef00d192,
    __importDefault: $a085793ee13ac643$export$da59b14a69baef04,
    __classPrivateFieldGet: $a085793ee13ac643$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a085793ee13ac643$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a085793ee13ac643$export$81fdc39f203e4e04,
    __addDisposableResource: $a085793ee13ac643$export$88ac25d8e944e405,
    __disposeResources: $a085793ee13ac643$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a085793ee13ac643$export$889dfb5d17574b0b
};

});

parcelRegister("1wdOb", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $11b37dae0f7f06fe$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $11b37dae0f7f06fe$export$76b5f966996d1653; });

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $bOqL7 = parcelRequire("bOqL7");

var $jYvOn = parcelRequire("jYvOn");
var $fzAJT = parcelRequire("fzAJT");
var $lVfPx = parcelRequire("lVfPx");
var $gCPnr = parcelRequire("gCPnr");
var $gj3Le = parcelRequire("gj3Le");

var $dwOTU = parcelRequire("dwOTU");

var $1DzcS = parcelRequire("1DzcS");

var $cogIK = parcelRequire("cogIK");

var $k0TL7 = parcelRequire("k0TL7");

var $6hfta = parcelRequire("6hfta");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $11b37dae0f7f06fe$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    var _options_normalizeDepth = options.normalizeDepth, normalizeDepth = _options_normalizeDepth === void 0 ? 3 : _options_normalizeDepth, _options_normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _options_normalizeMaxBreadth === void 0 ? 1000 : _options_normalizeMaxBreadth;
    var prepared = (0, $7XD9P._)((0, $hRCmZ._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $jYvOn.uuid4)(),
        timestamp: event.timestamp || (0, $fzAJT.dateTimestampInSeconds)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    $11b37dae0f7f06fe$var$applyClientOptions(prepared, options);
    $11b37dae0f7f06fe$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $11b37dae0f7f06fe$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = $11b37dae0f7f06fe$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $jYvOn.addExceptionMechanism)(prepared, hint.mechanism);
    var clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    var data = (0, $cogIK.getGlobalScope)().getScopeData();
    if (isolationScope) {
        var isolationData = isolationScope.getScopeData();
        (0, $k0TL7.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        var finalScopeData = finalScope.getScopeData();
        (0, $k0TL7.mergeScopeData)(data, finalScopeData);
    }
    var attachments = (0, $bOqL7._)(hint.attachments || []).concat((0, $bOqL7._)(data.attachments));
    if (attachments.length) hint.attachments = attachments;
    (0, $k0TL7.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    var eventProcessors = (0, $bOqL7._)(clientEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
    (0, $bOqL7._)((0, $1DzcS.getGlobalEventProcessors)()), // Run scope event processors _after_ all other processors
    (0, $bOqL7._)(data.eventProcessors));
    var result = (0, $1DzcS.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $11b37dae0f7f06fe$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $11b37dae0f7f06fe$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $11b37dae0f7f06fe$var$applyClientOptions(event, options) {
    var environment = options.environment, release = options.release, dist = options.dist, _options_maxValueLength = options.maxValueLength, maxValueLength = _options_maxValueLength === void 0 ? 250 : _options_maxValueLength;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $dwOTU.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $gj3Le.truncate)(event.message, maxValueLength);
    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $gj3Le.truncate)(exception.value, maxValueLength);
    var request = event.request;
    if (request && request.url) request.url = (0, $gj3Le.truncate)(request.url, maxValueLength);
}
var $11b37dae0f7f06fe$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $11b37dae0f7f06fe$export$63042efc86f043e7(event, stackParser) {
    var debugIdMap = (0, $lVfPx.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = $11b37dae0f7f06fe$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $11b37dae0f7f06fe$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $11b37dae0f7f06fe$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach(function(filename) {
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $11b37dae0f7f06fe$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0, $bOqL7._)(event.sdk.integrations || []).concat((0, $bOqL7._)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $11b37dae0f7f06fe$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    var normalized = (0, $hRCmZ._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0, $hRCmZ._)({}, b, b.data && {
                data: (0, $gCPnr.normalize)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0, $gCPnr.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $gCPnr.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $gCPnr.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $gCPnr.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map(function(span) {
        var data = (0, $6hfta.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $gCPnr.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $11b37dae0f7f06fe$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    var finalScope = scope ? scope.clone() : new (0, $cogIK.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $11b37dae0f7f06fe$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($11b37dae0f7f06fe$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($11b37dae0f7f06fe$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $11b37dae0f7f06fe$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $cogIK.Scope) || typeof hint === 'function';
}
var $11b37dae0f7f06fe$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $11b37dae0f7f06fe$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return $11b37dae0f7f06fe$var$captureContextKeys.includes(key);
    });
}

});
parcelRegister("gCPnr", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $c1a80c5e2ef7006b$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $c1a80c5e2ef7006b$export$23fbbb20bed71033; });

var $6mdMa = parcelRequire("6mdMa");

var $2xTNA = parcelRequire("2xTNA");

var $8lokx = parcelRequire("8lokx");

var $dDBaz = parcelRequire("dDBaz");

var $8yexE = parcelRequire("8yexE");

var $dRvnI = parcelRequire("dRvnI");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c1a80c5e2ef7006b$export$a3295358bff77e(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return $c1a80c5e2ef7006b$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function $c1a80c5e2ef7006b$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = $c1a80c5e2ef7006b$export$a3295358bff77e(object, depth);
    if ($c1a80c5e2ef7006b$var$jsonSize(normalized) > maxSize) return $c1a80c5e2ef7006b$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $c1a80c5e2ef7006b$export$588732934346abbf(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $dDBaz.memoBuilder)();
    var _memo = (0, $6mdMa._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) && !(0, $8lokx.isNaN)(value)) return value;
    var stringified = $c1a80c5e2ef7006b$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $c1a80c5e2ef7006b$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $8yexE.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $c1a80c5e2ef7006b$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $c1a80c5e2ef7006b$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $8lokx.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $8lokx.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return "[Function: ".concat((0, $dRvnI.getFunctionName)(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'symbol') return "[".concat(String(value), "]");
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'bigint') return "[BigInt: ".concat(String(value), "]");
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = $c1a80c5e2ef7006b$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return "[HTMLElement: ".concat(objName, "]");
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function $c1a80c5e2ef7006b$var$getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $c1a80c5e2ef7006b$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c1a80c5e2ef7006b$var$jsonSize(value) {
    return $c1a80c5e2ef7006b$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $c1a80c5e2ef7006b$export$472b29734be05be3(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), 'ig'), 'app:///');
}

});
parcelRegister("dDBaz", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $9edbbff89bb1b991$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $9edbbff89bb1b991$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner["delete"](obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("dRvnI", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $a1789155d97e8cd8$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $a1789155d97e8cd8$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $a1789155d97e8cd8$export$aad197c7121a6651; });

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $bOqL7 = parcelRequire("bOqL7");

var $bciGD = parcelRequire("bciGD");
var $a1789155d97e8cd8$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
var $a1789155d97e8cd8$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var $a1789155d97e8cd8$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $a1789155d97e8cd8$export$a5739666fb2d03d4() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var frames = [];
        var lines = stack.split('\n');
        for(var i = skipFirst; i < lines.length; i++){
            var line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = $a1789155d97e8cd8$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($a1789155d97e8cd8$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= $a1789155d97e8cd8$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $a1789155d97e8cd8$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $a1789155d97e8cd8$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $a1789155d97e8cd8$export$a5739666fb2d03d4.apply(void 0, (0, $bOqL7._)(stackParser));
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $a1789155d97e8cd8$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1]["function"] || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($a1789155d97e8cd8$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1]["function"] || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($a1789155d97e8cd8$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1]["function"] || '')) localStack.pop();
    }
    return localStack.slice(0, $a1789155d97e8cd8$var$STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, $7XD9P._)((0, $hRCmZ._)({}, frame), {
            filename: frame.filename || localStack[localStack.length - 1].filename,
            "function": frame["function"] || '?'
        });
    });
}
var $a1789155d97e8cd8$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $a1789155d97e8cd8$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $a1789155d97e8cd8$var$defaultFunctionName;
        return fn.name || $a1789155d97e8cd8$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $a1789155d97e8cd8$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $a1789155d97e8cd8$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $bciGD.node)(getModule)
    ];
}

});
parcelRegister("bciGD", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $826f4f7a4c8cc413$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $826f4f7a4c8cc413$export$1de92f38f4de99a8(filename) {
    var isNative = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $826f4f7a4c8cc413$export$35059013cd4a06db(getModule) {
    var FILENAME_MATCH = /^\s*[-]{4,}$/;
    var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return function(line) {
        var lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            var object;
            var method;
            var functionName;
            var typeName;
            var methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                var methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    var objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? "".concat(typeName, ".").concat(methodName) : methodName;
            }
            var filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            var isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                "function": functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $826f4f7a4c8cc413$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});



parcelRegister("6hfta", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $4920548574d1ef04$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $4920548574d1ef04$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $4920548574d1ef04$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $4920548574d1ef04$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $4920548574d1ef04$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $4920548574d1ef04$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $4920548574d1ef04$export$3f7581298f56c6d7; });

var $8yexE = parcelRequire("8yexE");
var $iAzzt = parcelRequire("iAzzt");
var $fzAJT = parcelRequire("fzAJT");
// These are aligned with OpenTelemetry trace flags
var $4920548574d1ef04$export$208d5b368507fb8b = 0x0;
var $4920548574d1ef04$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $4920548574d1ef04$export$46c6fbd1d265ebf0(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = $4920548574d1ef04$export$92d8c23565496537(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, tags = _spanToJSON.tags, origin = _spanToJSON.origin;
    return (0, $8yexE.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $4920548574d1ef04$export$7e9f8ae9e4a328ab(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = $4920548574d1ef04$export$5caecac1caaf3a71(span);
    return (0, $iAzzt.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $4920548574d1ef04$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $4920548574d1ef04$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $4920548574d1ef04$var$ensureTimestampInSeconds(input.getTime());
    return (0, $fzAJT.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $4920548574d1ef04$var$ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $4920548574d1ef04$export$92d8c23565496537(span) {
    if ($4920548574d1ef04$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $4920548574d1ef04$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $4920548574d1ef04$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $4920548574d1ef04$export$eb571cd9b5d98de8);
}

});
parcelRegister("iAzzt", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $d8872e7e179b192e$export$394a210812ba3012; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $d8872e7e179b192e$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $d8872e7e179b192e$export$ca5c066532785b6e; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $d8872e7e179b192e$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $d8872e7e179b192e$export$f35d907436da45cf; });

var $6xWsf = parcelRequire("6xWsf");

var $jYvOn = parcelRequire("jYvOn");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var $d8872e7e179b192e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $d8872e7e179b192e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    var matches = traceparent.match($d8872e7e179b192e$export$394a210812ba3012);
    if (!matches) return undefined;
    var parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $d8872e7e179b192e$export$ca5c066532785b6e(sentryTrace, baggage) {
    var traceparentData = $d8872e7e179b192e$export$8e9a29865c0a1226(sentryTrace);
    var dynamicSamplingContext = (0, $6xWsf.baggageHeaderToDynamicSamplingContext)(baggage);
    var _ref = traceparentData || {}, traceId = _ref.traceId, parentSpanId = _ref.parentSpanId, parentSampled = _ref.parentSampled;
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $jYvOn.uuid4)(),
            spanId: (0, $jYvOn.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $jYvOn.uuid4)(),
            parentSpanId: parentSpanId || (0, $jYvOn.uuid4)().substring(16),
            spanId: (0, $jYvOn.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $d8872e7e179b192e$export$261f383d16a93e39(sentryTrace, baggage) {
    var traceparentData = $d8872e7e179b192e$export$8e9a29865c0a1226(sentryTrace);
    var dynamicSamplingContext = (0, $6xWsf.baggageHeaderToDynamicSamplingContext)(baggage);
    var _ref = traceparentData || {}, traceId = _ref.traceId, parentSpanId = _ref.parentSpanId, parentSampled = _ref.parentSampled;
    if (!traceparentData) return {
        traceId: traceId || (0, $jYvOn.uuid4)(),
        spanId: (0, $jYvOn.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $jYvOn.uuid4)(),
        parentSpanId: parentSpanId || (0, $jYvOn.uuid4)().substring(16),
        spanId: (0, $jYvOn.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $d8872e7e179b192e$export$f35d907436da45cf() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $jYvOn.uuid4)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $jYvOn.uuid4)().substring(16), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}

});
parcelRegister("6xWsf", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $4c432b06558f6afb$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $4c432b06558f6afb$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $4c432b06558f6afb$export$56766feef403f365; });

var $6mdMa = parcelRequire("6mdMa");

var $84Gbr = parcelRequire("84Gbr");

var $8lokx = parcelRequire("8lokx");

var $gVncj = parcelRequire("gVncj");
var $4c432b06558f6afb$export$9ca9946bd449ac06 = 'baggage';
var $4c432b06558f6afb$export$6e69537d67fa20f = 'sentry-';
var $4c432b06558f6afb$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var $4c432b06558f6afb$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $4c432b06558f6afb$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $8lokx.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    var baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = $4c432b06558f6afb$var$baggageHeaderToObject(curr);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(currBaggageObject)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                acc[key] = currBaggageObject[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $4c432b06558f6afb$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, $6mdMa._)(param, 2), key = _param[0], value = _param[1];
        if (key.match($4c432b06558f6afb$export$eb0401070c617ea5)) {
            var nonPrefixedKey = key.slice($4c432b06558f6afb$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $4c432b06558f6afb$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, $6mdMa._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc["".concat($4c432b06558f6afb$export$6e69537d67fa20f).concat(dscKey)] = dscValue;
        return acc;
    }, {});
    return $4c432b06558f6afb$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $4c432b06558f6afb$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map(function(baggageEntry) {
        return baggageEntry.split('=').map(function(keyOrValue) {
            return decodeURIComponent(keyOrValue.trim());
        });
    }).reduce(function(acc, param) {
        var _param = (0, $6mdMa._)(param, 2), key = _param[0], value = _param[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $4c432b06558f6afb$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, $6mdMa._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > $4c432b06558f6afb$export$bdd844ddb2def819) {
            (0, $84Gbr.DEBUG_BUILD) && (0, $gVncj.logger).warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});





parcelRegister("lG8Hn", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $fc844490fbde59f4$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $fc844490fbde59f4$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});




parcelRegister("kyZym", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $ef86bacd4d866ce2$export$31499a9cd224b78c; });
var $ef86bacd4d866ce2$export$31499a9cd224b78c = '7.120.4';

});


parcelRegister("1SuQJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $15e2c3a9f8d3fd13$export$a7c73072b1a182ae; }, function (v) { return $15e2c3a9f8d3fd13$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $15e2c3a9f8d3fd13$export$9f27bc3417b4524d; }, function (v) { return $15e2c3a9f8d3fd13$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $15e2c3a9f8d3fd13$export$db77ccec0bb4ccac; }, function (v) { return $15e2c3a9f8d3fd13$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $15e2c3a9f8d3fd13$export$8392c0c9d3dcbd35; }, function (v) { return $15e2c3a9f8d3fd13$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $15e2c3a9f8d3fd13$export$ffb0004e005737fa; }, function (v) { return $15e2c3a9f8d3fd13$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $15e2c3a9f8d3fd13$export$b624eff549462981; }, function (v) { return $15e2c3a9f8d3fd13$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $15e2c3a9f8d3fd13$export$7897aa7841a5380c; }, function (v) { return $15e2c3a9f8d3fd13$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $15e2c3a9f8d3fd13$export$602eac185826482c; }, function (v) { return $15e2c3a9f8d3fd13$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $15e2c3a9f8d3fd13$export$e2c29f18771995cb; }, function (v) { return $15e2c3a9f8d3fd13$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $15e2c3a9f8d3fd13$export$5f8d39834fd61797; }, function (v) { return $15e2c3a9f8d3fd13$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $15e2c3a9f8d3fd13$export$74bf444e3cd11ea5; }, function (v) { return $15e2c3a9f8d3fd13$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $15e2c3a9f8d3fd13$export$92387174baf9b227; }, function (v) { return $15e2c3a9f8d3fd13$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $15e2c3a9f8d3fd13$export$ec112efeb987d9c6; }, function (v) { return $15e2c3a9f8d3fd13$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $15e2c3a9f8d3fd13$export$b706b080d889d2c9; }, function (v) { return $15e2c3a9f8d3fd13$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $15e2c3a9f8d3fd13$export$5be5a87408f70ddc; }, function (v) { return $15e2c3a9f8d3fd13$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $15e2c3a9f8d3fd13$export$45a5e7f76e0caa8d; }, function (v) { return $15e2c3a9f8d3fd13$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $15e2c3a9f8d3fd13$export$455c2e768291efa6; }, function (v) { return $15e2c3a9f8d3fd13$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $15e2c3a9f8d3fd13$export$9522e17588c12572; }, function (v) { return $15e2c3a9f8d3fd13$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $15e2c3a9f8d3fd13$export$2110ac352bb060b9; }, function (v) { return $15e2c3a9f8d3fd13$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $15e2c3a9f8d3fd13$export$56885ab8b9c456ab; }, function (v) { return $15e2c3a9f8d3fd13$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $15e2c3a9f8d3fd13$export$d927fcb6adf8f9de; }, function (v) { return $15e2c3a9f8d3fd13$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $15e2c3a9f8d3fd13$export$b82d16f27459e05a; }, function (v) { return $15e2c3a9f8d3fd13$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $15e2c3a9f8d3fd13$export$522c17b4f5e123e8; }, function (v) { return $15e2c3a9f8d3fd13$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $15e2c3a9f8d3fd13$export$1aabd8a0274ecfd6; }, function (v) { return $15e2c3a9f8d3fd13$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $15e2c3a9f8d3fd13$export$9b621391a187a31a; }, function (v) { return $15e2c3a9f8d3fd13$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $15e2c3a9f8d3fd13$export$f5bbd400c2f4426f; }, function (v) { return $15e2c3a9f8d3fd13$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2xTNA = parcelRequire("2xTNA");
var $15e2c3a9f8d3fd13$export$a7c73072b1a182ae;
var $15e2c3a9f8d3fd13$export$9f27bc3417b4524d;
var $15e2c3a9f8d3fd13$export$db77ccec0bb4ccac;
var $15e2c3a9f8d3fd13$export$8392c0c9d3dcbd35;
var $15e2c3a9f8d3fd13$export$ffb0004e005737fa;
var $15e2c3a9f8d3fd13$export$b624eff549462981;
var $15e2c3a9f8d3fd13$export$7897aa7841a5380c;
var $15e2c3a9f8d3fd13$export$602eac185826482c;
var $15e2c3a9f8d3fd13$export$e2c29f18771995cb;
var $15e2c3a9f8d3fd13$export$5f8d39834fd61797;
var $15e2c3a9f8d3fd13$export$74bf444e3cd11ea5;
var $15e2c3a9f8d3fd13$export$92387174baf9b227;
var $15e2c3a9f8d3fd13$export$ec112efeb987d9c6;
var $15e2c3a9f8d3fd13$export$b706b080d889d2c9;
var $15e2c3a9f8d3fd13$export$5be5a87408f70ddc;
var $15e2c3a9f8d3fd13$export$45a5e7f76e0caa8d;
var $15e2c3a9f8d3fd13$export$455c2e768291efa6;
var $15e2c3a9f8d3fd13$export$9522e17588c12572;
var $15e2c3a9f8d3fd13$export$2110ac352bb060b9;
var $15e2c3a9f8d3fd13$export$56885ab8b9c456ab;
var $15e2c3a9f8d3fd13$export$d927fcb6adf8f9de;
var $15e2c3a9f8d3fd13$export$b82d16f27459e05a;
var $15e2c3a9f8d3fd13$export$522c17b4f5e123e8;
var $15e2c3a9f8d3fd13$export$1aabd8a0274ecfd6;
var $15e2c3a9f8d3fd13$export$9b621391a187a31a;
var $15e2c3a9f8d3fd13$export$f5bbd400c2f4426f;
'use strict';
var $15e2c3a9f8d3fd13$var$b = 60103, $15e2c3a9f8d3fd13$var$c = 60106, $15e2c3a9f8d3fd13$var$d = 60107, $15e2c3a9f8d3fd13$var$e = 60108, $15e2c3a9f8d3fd13$var$f = 60114, $15e2c3a9f8d3fd13$var$g = 60109, $15e2c3a9f8d3fd13$var$h = 60110, $15e2c3a9f8d3fd13$var$k = 60112, $15e2c3a9f8d3fd13$var$l = 60113, $15e2c3a9f8d3fd13$var$m = 60120, $15e2c3a9f8d3fd13$var$n = 60115, $15e2c3a9f8d3fd13$var$p = 60116, $15e2c3a9f8d3fd13$var$q = 60121, $15e2c3a9f8d3fd13$var$r = 60122, $15e2c3a9f8d3fd13$var$u = 60117, $15e2c3a9f8d3fd13$var$v = 60129, $15e2c3a9f8d3fd13$var$w = 60131;
if ("function" === typeof Symbol && Symbol["for"]) {
    var $15e2c3a9f8d3fd13$var$x = Symbol["for"];
    $15e2c3a9f8d3fd13$var$b = $15e2c3a9f8d3fd13$var$x("react.element");
    $15e2c3a9f8d3fd13$var$c = $15e2c3a9f8d3fd13$var$x("react.portal");
    $15e2c3a9f8d3fd13$var$d = $15e2c3a9f8d3fd13$var$x("react.fragment");
    $15e2c3a9f8d3fd13$var$e = $15e2c3a9f8d3fd13$var$x("react.strict_mode");
    $15e2c3a9f8d3fd13$var$f = $15e2c3a9f8d3fd13$var$x("react.profiler");
    $15e2c3a9f8d3fd13$var$g = $15e2c3a9f8d3fd13$var$x("react.provider");
    $15e2c3a9f8d3fd13$var$h = $15e2c3a9f8d3fd13$var$x("react.context");
    $15e2c3a9f8d3fd13$var$k = $15e2c3a9f8d3fd13$var$x("react.forward_ref");
    $15e2c3a9f8d3fd13$var$l = $15e2c3a9f8d3fd13$var$x("react.suspense");
    $15e2c3a9f8d3fd13$var$m = $15e2c3a9f8d3fd13$var$x("react.suspense_list");
    $15e2c3a9f8d3fd13$var$n = $15e2c3a9f8d3fd13$var$x("react.memo");
    $15e2c3a9f8d3fd13$var$p = $15e2c3a9f8d3fd13$var$x("react.lazy");
    $15e2c3a9f8d3fd13$var$q = $15e2c3a9f8d3fd13$var$x("react.block");
    $15e2c3a9f8d3fd13$var$r = $15e2c3a9f8d3fd13$var$x("react.server.block");
    $15e2c3a9f8d3fd13$var$u = $15e2c3a9f8d3fd13$var$x("react.fundamental");
    $15e2c3a9f8d3fd13$var$v = $15e2c3a9f8d3fd13$var$x("react.debug_trace_mode");
    $15e2c3a9f8d3fd13$var$w = $15e2c3a9f8d3fd13$var$x("react.legacy_hidden");
}
function $15e2c3a9f8d3fd13$var$y(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $15e2c3a9f8d3fd13$var$b:
                switch(a = a.type, a){
                    case $15e2c3a9f8d3fd13$var$d:
                    case $15e2c3a9f8d3fd13$var$f:
                    case $15e2c3a9f8d3fd13$var$e:
                    case $15e2c3a9f8d3fd13$var$l:
                    case $15e2c3a9f8d3fd13$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $15e2c3a9f8d3fd13$var$h:
                            case $15e2c3a9f8d3fd13$var$k:
                            case $15e2c3a9f8d3fd13$var$p:
                            case $15e2c3a9f8d3fd13$var$n:
                            case $15e2c3a9f8d3fd13$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $15e2c3a9f8d3fd13$var$c:
                return t;
        }
    }
}
var $15e2c3a9f8d3fd13$var$z = $15e2c3a9f8d3fd13$var$g, $15e2c3a9f8d3fd13$var$A = $15e2c3a9f8d3fd13$var$b, $15e2c3a9f8d3fd13$var$B = $15e2c3a9f8d3fd13$var$k, $15e2c3a9f8d3fd13$var$C = $15e2c3a9f8d3fd13$var$d, $15e2c3a9f8d3fd13$var$D = $15e2c3a9f8d3fd13$var$p, $15e2c3a9f8d3fd13$var$E = $15e2c3a9f8d3fd13$var$n, $15e2c3a9f8d3fd13$var$F = $15e2c3a9f8d3fd13$var$c, $15e2c3a9f8d3fd13$var$G = $15e2c3a9f8d3fd13$var$f, $15e2c3a9f8d3fd13$var$H = $15e2c3a9f8d3fd13$var$e, $15e2c3a9f8d3fd13$var$I = $15e2c3a9f8d3fd13$var$l;
$15e2c3a9f8d3fd13$export$a7c73072b1a182ae = $15e2c3a9f8d3fd13$var$h;
$15e2c3a9f8d3fd13$export$9f27bc3417b4524d = $15e2c3a9f8d3fd13$var$z;
$15e2c3a9f8d3fd13$export$db77ccec0bb4ccac = $15e2c3a9f8d3fd13$var$A;
$15e2c3a9f8d3fd13$export$8392c0c9d3dcbd35 = $15e2c3a9f8d3fd13$var$B;
$15e2c3a9f8d3fd13$export$ffb0004e005737fa = $15e2c3a9f8d3fd13$var$C;
$15e2c3a9f8d3fd13$export$b624eff549462981 = $15e2c3a9f8d3fd13$var$D;
$15e2c3a9f8d3fd13$export$7897aa7841a5380c = $15e2c3a9f8d3fd13$var$E;
$15e2c3a9f8d3fd13$export$602eac185826482c = $15e2c3a9f8d3fd13$var$F;
$15e2c3a9f8d3fd13$export$e2c29f18771995cb = $15e2c3a9f8d3fd13$var$G;
$15e2c3a9f8d3fd13$export$5f8d39834fd61797 = $15e2c3a9f8d3fd13$var$H;
$15e2c3a9f8d3fd13$export$74bf444e3cd11ea5 = $15e2c3a9f8d3fd13$var$I;
$15e2c3a9f8d3fd13$export$92387174baf9b227 = function() {
    return !1;
};
$15e2c3a9f8d3fd13$export$ec112efeb987d9c6 = function() {
    return !1;
};
$15e2c3a9f8d3fd13$export$b706b080d889d2c9 = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$h;
};
$15e2c3a9f8d3fd13$export$5be5a87408f70ddc = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$g;
};
$15e2c3a9f8d3fd13$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && a.$$typeof === $15e2c3a9f8d3fd13$var$b;
};
$15e2c3a9f8d3fd13$export$455c2e768291efa6 = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$k;
};
$15e2c3a9f8d3fd13$export$9522e17588c12572 = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$d;
};
$15e2c3a9f8d3fd13$export$2110ac352bb060b9 = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$p;
};
$15e2c3a9f8d3fd13$export$56885ab8b9c456ab = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$n;
};
$15e2c3a9f8d3fd13$export$d927fcb6adf8f9de = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$c;
};
$15e2c3a9f8d3fd13$export$b82d16f27459e05a = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$f;
};
$15e2c3a9f8d3fd13$export$522c17b4f5e123e8 = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$e;
};
$15e2c3a9f8d3fd13$export$1aabd8a0274ecfd6 = function(a) {
    return $15e2c3a9f8d3fd13$var$y(a) === $15e2c3a9f8d3fd13$var$l;
};
$15e2c3a9f8d3fd13$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $15e2c3a9f8d3fd13$var$d || a === $15e2c3a9f8d3fd13$var$f || a === $15e2c3a9f8d3fd13$var$v || a === $15e2c3a9f8d3fd13$var$e || a === $15e2c3a9f8d3fd13$var$l || a === $15e2c3a9f8d3fd13$var$m || a === $15e2c3a9f8d3fd13$var$w || "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && (a.$$typeof === $15e2c3a9f8d3fd13$var$p || a.$$typeof === $15e2c3a9f8d3fd13$var$n || a.$$typeof === $15e2c3a9f8d3fd13$var$g || a.$$typeof === $15e2c3a9f8d3fd13$var$h || a.$$typeof === $15e2c3a9f8d3fd13$var$k || a.$$typeof === $15e2c3a9f8d3fd13$var$u || a.$$typeof === $15e2c3a9f8d3fd13$var$q || a[0] === $15e2c3a9f8d3fd13$var$r) ? !0 : !1;
};
$15e2c3a9f8d3fd13$export$f5bbd400c2f4426f = $15e2c3a9f8d3fd13$var$y;

});

parcelRegister("9eJQB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $6b98fc2f1c872c98$var$_gtag = $6b98fc2f1c872c98$var$_interopRequireDefault((parcelRequire("9Ob7T")));

var $6b98fc2f1c872c98$var$_format = $6b98fc2f1c872c98$var$_interopRequireDefault((parcelRequire("eANjr")));
var $6b98fc2f1c872c98$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $6b98fc2f1c872c98$var$_excluded2 = [
    "title",
    "location"
], $6b98fc2f1c872c98$var$_excluded3 = [
    "page",
    "hitType"
];
function $6b98fc2f1c872c98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6b98fc2f1c872c98$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6b98fc2f1c872c98$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6b98fc2f1c872c98$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6b98fc2f1c872c98$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6b98fc2f1c872c98$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6b98fc2f1c872c98$var$_typeof(obj);
}
function $6b98fc2f1c872c98$var$_toConsumableArray(arr) {
    return $6b98fc2f1c872c98$var$_arrayWithoutHoles(arr) || $6b98fc2f1c872c98$var$_iterableToArray(arr) || $6b98fc2f1c872c98$var$_unsupportedIterableToArray(arr) || $6b98fc2f1c872c98$var$_nonIterableSpread();
}
function $6b98fc2f1c872c98$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b98fc2f1c872c98$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6b98fc2f1c872c98$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6b98fc2f1c872c98$var$_arrayLikeToArray(arr);
}
function $6b98fc2f1c872c98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6b98fc2f1c872c98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6b98fc2f1c872c98$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6b98fc2f1c872c98$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6b98fc2f1c872c98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6b98fc2f1c872c98$var$_slicedToArray(arr, i) {
    return $6b98fc2f1c872c98$var$_arrayWithHoles(arr) || $6b98fc2f1c872c98$var$_iterableToArrayLimit(arr, i) || $6b98fc2f1c872c98$var$_unsupportedIterableToArray(arr, i) || $6b98fc2f1c872c98$var$_nonIterableRest();
}
function $6b98fc2f1c872c98$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b98fc2f1c872c98$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6b98fc2f1c872c98$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6b98fc2f1c872c98$var$_arrayLikeToArray(o, minLen);
}
function $6b98fc2f1c872c98$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6b98fc2f1c872c98$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $6b98fc2f1c872c98$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6b98fc2f1c872c98$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6b98fc2f1c872c98$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6b98fc2f1c872c98$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6b98fc2f1c872c98$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6b98fc2f1c872c98$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6b98fc2f1c872c98$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6b98fc2f1c872c98$var$_defineProperty(obj, key, value) {
    key = $6b98fc2f1c872c98$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6b98fc2f1c872c98$var$_toPropertyKey(arg) {
    var key = $6b98fc2f1c872c98$var$_toPrimitive(arg, "string");
    return $6b98fc2f1c872c98$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6b98fc2f1c872c98$var$_toPrimitive(input, hint) {
    if ($6b98fc2f1c872c98$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6b98fc2f1c872c98$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $6b98fc2f1c872c98$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $6b98fc2f1c872c98$var$_classCallCheck(this, GA4);
        $6b98fc2f1c872c98$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $6b98fc2f1c872c98$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $6b98fc2f1c872c98$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread({}, _this._toGtagOptions($6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $6b98fc2f1c872c98$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $6b98fc2f1c872c98$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($6b98fc2f1c872c98$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $6b98fc2f1c872c98$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $6b98fc2f1c872c98$var$_objectWithoutProperties(_args$, $6b98fc2f1c872c98$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $6b98fc2f1c872c98$var$_objectWithoutProperties(_this$_toGtagOptions, $6b98fc2f1c872c98$var$_excluded2);
                _this._gtag("event", "page_view", $6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread($6b98fc2f1c872c98$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $6b98fc2f1c872c98$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $6b98fc2f1c872c98$var$_objectWithoutProperties(_args$2, $6b98fc2f1c872c98$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $6b98fc2f1c872c98$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $6b98fc2f1c872c98$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $6b98fc2f1c872c98$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $6b98fc2f1c872c98$var$_format["default"])(category),
                    eventAction: (0, $6b98fc2f1c872c98$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $6b98fc2f1c872c98$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $6b98fc2f1c872c98$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $6b98fc2f1c872c98$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $6b98fc2f1c872c98$var$GA4;
var $6b98fc2f1c872c98$var$_default = new $6b98fc2f1c872c98$var$GA4();
module.exports["default"] = $6b98fc2f1c872c98$var$_default;

});
parcelRegister("9Ob7T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $72416a023de98059$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $72416a023de98059$var$_default = $72416a023de98059$var$gtag;
module.exports["default"] = $72416a023de98059$var$_default;

});

parcelRegister("eANjr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a9faaded21a99ee7$var$format;
var $a9faaded21a99ee7$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $a9faaded21a99ee7$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($a9faaded21a99ee7$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $a9faaded21a99ee7$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $a9faaded21a99ee7$var$redacted = "REDACTED (Potential Email Address)";
function $a9faaded21a99ee7$var$redactEmail(string) {
    if ($a9faaded21a99ee7$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $a9faaded21a99ee7$var$redacted;
    }
    return string;
}
function $a9faaded21a99ee7$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $a9faaded21a99ee7$var$toTitleCase(s);
    if (redactingEmail) _str = $a9faaded21a99ee7$var$redactEmail(_str);
    return _str;
}

});


parcelRegister("eBpJ9", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $aa187a4bf09e7a41$export$306c0aa65ff9ec16; }, function (v) { return $aa187a4bf09e7a41$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa187a4bf09e7a41$export$306c0aa65ff9ec16;
"use strict";

var $hAGkE = parcelRequire("hAGkE");
function $aa187a4bf09e7a41$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $aa187a4bf09e7a41$var$objectIs = "function" === typeof Object.is ? Object.is : $aa187a4bf09e7a41$var$is, $aa187a4bf09e7a41$var$useState = $hAGkE.useState, $aa187a4bf09e7a41$var$useEffect = $hAGkE.useEffect, $aa187a4bf09e7a41$var$useLayoutEffect = $hAGkE.useLayoutEffect, $aa187a4bf09e7a41$var$useDebugValue = $hAGkE.useDebugValue;
function $aa187a4bf09e7a41$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $aa187a4bf09e7a41$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $aa187a4bf09e7a41$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $aa187a4bf09e7a41$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $aa187a4bf09e7a41$var$useEffect(function() {
        $aa187a4bf09e7a41$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $aa187a4bf09e7a41$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $aa187a4bf09e7a41$var$useDebugValue(value);
    return value;
}
function $aa187a4bf09e7a41$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$aa187a4bf09e7a41$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $aa187a4bf09e7a41$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $aa187a4bf09e7a41$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $aa187a4bf09e7a41$var$useSyncExternalStore$1 : $aa187a4bf09e7a41$var$useSyncExternalStore$2;
$aa187a4bf09e7a41$export$306c0aa65ff9ec16 = void 0 !== $hAGkE.useSyncExternalStore ? $hAGkE.useSyncExternalStore : $aa187a4bf09e7a41$var$shim;

});

parcelRegister("eo1P1", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $4YJci = parcelRequire("4YJci");

var $5M2Y4 = parcelRequire("5M2Y4");

var $PhbCf = parcelRequire("PhbCf");

var $2lSP3 = parcelRequire("2lSP3");

var $aIG4d = parcelRequire("aIG4d");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $a794b85e941f8474$var$createInstance(defaultConfig) {
    var context = new $5M2Y4(defaultConfig);
    var instance = $4YJci($5M2Y4.prototype.request, context);
    // Copy axios.prototype to instance
    $gpr5J.extend(instance, $5M2Y4.prototype, context);
    // Copy context to instance
    $gpr5J.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $a794b85e941f8474$var$createInstance($PhbCf(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $a794b85e941f8474$var$axios = $a794b85e941f8474$var$createInstance($2lSP3);
// Expose Axios class to allow class inheritance
$a794b85e941f8474$var$axios.Axios = $5M2Y4;

// Expose Cancel & CancelToken
$a794b85e941f8474$var$axios.CanceledError = (parcelRequire("b0lYG"));

$a794b85e941f8474$var$axios.CancelToken = (parcelRequire("kfvPz"));

$a794b85e941f8474$var$axios.isCancel = (parcelRequire("1b8FS"));

$a794b85e941f8474$var$axios.VERSION = (parcelRequire("kHrOz")).version;

$a794b85e941f8474$var$axios.toFormData = (parcelRequire("k7vrg"));

// Expose AxiosError class
$a794b85e941f8474$var$axios.AxiosError = (parcelRequire("jk00O"));
// alias for CanceledError for backward compatibility
$a794b85e941f8474$var$axios.Cancel = $a794b85e941f8474$var$axios.CanceledError;
// Expose all/spread
$a794b85e941f8474$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$a794b85e941f8474$var$axios.spread = (parcelRequire("5Ecwk"));

// Expose isAxiosError
$a794b85e941f8474$var$axios.isAxiosError = (parcelRequire("iCDZK"));
$a794b85e941f8474$var$axios.formToJSON = function(thing) {
    return $aIG4d($gpr5J.isHTMLForm(thing) ? new FormData(thing) : thing);
};
module.exports = $a794b85e941f8474$var$axios;
// Allow use of default import syntax in TypeScript
module.exports["default"] = $a794b85e941f8474$var$axios;

});
parcelRegister("gpr5J", function(module, exports) {

var $2xTNA = parcelRequire("2xTNA");
'use strict';

var $4YJci = parcelRequire("4YJci");
// utils is a library of generic helper functions non-specific to axios
var $bf23feeeaa2c9e9e$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $bf23feeeaa2c9e9e$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $bf23feeeaa2c9e9e$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $bf23feeeaa2c9e9e$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $bf23feeeaa2c9e9e$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isBuffer(val) {
    return val !== null && !$bf23feeeaa2c9e9e$var$isUndefined(val) && val.constructor !== null && !$bf23feeeaa2c9e9e$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $bf23feeeaa2c9e9e$var$isArrayBuffer = $bf23feeeaa2c9e9e$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $bf23feeeaa2c9e9e$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isObject(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $2xTNA._)(val)) === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isPlainObject(val) {
    if ($bf23feeeaa2c9e9e$var$kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isEmptyObject(val) {
    if (!$bf23feeeaa2c9e9e$var$isPlainObject(val)) return false;
    for(var key in val){
        if (Object.prototype.hasOwnProperty.call(val, key)) return false;
    }
    return true;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $bf23feeeaa2c9e9e$var$isDate = $bf23feeeaa2c9e9e$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $bf23feeeaa2c9e9e$var$isFile = $bf23feeeaa2c9e9e$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $bf23feeeaa2c9e9e$var$isBlob = $bf23feeeaa2c9e9e$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $bf23feeeaa2c9e9e$var$isFileList = $bf23feeeaa2c9e9e$var$kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isFunction(val) {
    return $bf23feeeaa2c9e9e$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isStream(val) {
    return $bf23feeeaa2c9e9e$var$isObject(val) && $bf23feeeaa2c9e9e$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $bf23feeeaa2c9e9e$var$isFormData(thing) {
    var pattern = '[object FormData]';
    if (!thing) return false;
    if (typeof FormData === 'function' && thing instanceof FormData) return true;
    // Reject non-objects (strings, numbers, booleans) up front — Object.getPrototypeOf
    // throws a TypeError on primitives in ES5 environments.
    if (!$bf23feeeaa2c9e9e$var$isObject(thing)) return false;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = Object.getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$bf23feeeaa2c9e9e$var$isFunction(thing.append)) return false;
    return $bf23feeeaa2c9e9e$var$toString.call(thing) === pattern || $bf23feeeaa2c9e9e$var$isFunction(thing.toString) && thing.toString() === pattern;
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $bf23feeeaa2c9e9e$var$isURLSearchParams = $bf23feeeaa2c9e9e$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $bf23feeeaa2c9e9e$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $bf23feeeaa2c9e9e$var$isStandardBrowserEnv() {
    var product;
    if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $bf23feeeaa2c9e9e$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($bf23feeeaa2c9e9e$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $bf23feeeaa2c9e9e$var$merge() {
    var result = Object.create(null);
    function assignValue(val, key) {
        var target;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        target = Object.prototype.hasOwnProperty.call(result, key) ? result[key] : undefined;
        if ($bf23feeeaa2c9e9e$var$isPlainObject(target) && $bf23feeeaa2c9e9e$var$isPlainObject(val)) result[key] = $bf23feeeaa2c9e9e$var$merge(target, val);
        else if ($bf23feeeaa2c9e9e$var$isPlainObject(val)) result[key] = $bf23feeeaa2c9e9e$var$merge({}, val);
        else if ($bf23feeeaa2c9e9e$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$bf23feeeaa2c9e9e$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $bf23feeeaa2c9e9e$var$extend(a, b, thisArg) {
    $bf23feeeaa2c9e9e$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $4YJci(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $bf23feeeaa2c9e9e$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
}
function $bf23feeeaa2c9e9e$var$defineOwnProperty(target, key, value) {
    var descriptor = Object.create(null);
    descriptor.value = value;
    descriptor.writable = true;
    descriptor.enumerable = true;
    descriptor.configurable = true;
    Object.defineProperty(target, key, descriptor);
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $bf23feeeaa2c9e9e$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    if (Object.prototype.hasOwnProperty.call(constructor.prototype, 'constructor')) constructor.prototype.constructor = constructor;
    else $bf23feeeaa2c9e9e$var$defineOwnProperty(constructor.prototype, 'constructor', constructor);
    if (props) {
        var keys = Object.keys(props);
        if (Object.getOwnPropertySymbols) keys = keys.concat(Object.getOwnPropertySymbols(props).filter(function(key) {
            return Object.prototype.propertyIsEnumerable.call(props, key);
        }));
        keys.forEach(function(key) {
            var value = props[key];
            if (Object.prototype.hasOwnProperty.call(constructor.prototype, key)) constructor.prototype[key] = value;
            else // Assignment would invoke an inherited setter or fail on a read-only
            // property installed by another library, such as Error.prototype.toJSON.
            $bf23feeeaa2c9e9e$var$defineOwnProperty(constructor.prototype, key, value);
        });
    }
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */ function $bf23feeeaa2c9e9e$var$toFlatObject(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $bf23feeeaa2c9e9e$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */ function $bf23feeeaa2c9e9e$var$toArray(thing) {
    if (!thing) return null;
    if ($bf23feeeaa2c9e9e$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$bf23feeeaa2c9e9e$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $bf23feeeaa2c9e9e$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
function $bf23feeeaa2c9e9e$var$forEachEntry(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
}
function $bf23feeeaa2c9e9e$var$matchAll(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
}
var $bf23feeeaa2c9e9e$var$isHTMLForm = $bf23feeeaa2c9e9e$var$kindOfTest('HTMLFormElement');
var $bf23feeeaa2c9e9e$var$hasOwnProperty = function resolver(_hasOwnProperty) {
    return function(obj, prop) {
        return _hasOwnProperty.call(obj, prop);
    };
}(Object.prototype.hasOwnProperty);
module.exports = {
    isArray: $bf23feeeaa2c9e9e$var$isArray,
    isArrayBuffer: $bf23feeeaa2c9e9e$var$isArrayBuffer,
    isBuffer: $bf23feeeaa2c9e9e$var$isBuffer,
    isFormData: $bf23feeeaa2c9e9e$var$isFormData,
    isArrayBufferView: $bf23feeeaa2c9e9e$var$isArrayBufferView,
    isString: $bf23feeeaa2c9e9e$var$isString,
    isNumber: $bf23feeeaa2c9e9e$var$isNumber,
    isObject: $bf23feeeaa2c9e9e$var$isObject,
    isPlainObject: $bf23feeeaa2c9e9e$var$isPlainObject,
    isEmptyObject: $bf23feeeaa2c9e9e$var$isEmptyObject,
    isUndefined: $bf23feeeaa2c9e9e$var$isUndefined,
    isDate: $bf23feeeaa2c9e9e$var$isDate,
    isFile: $bf23feeeaa2c9e9e$var$isFile,
    isBlob: $bf23feeeaa2c9e9e$var$isBlob,
    isFunction: $bf23feeeaa2c9e9e$var$isFunction,
    isStream: $bf23feeeaa2c9e9e$var$isStream,
    isURLSearchParams: $bf23feeeaa2c9e9e$var$isURLSearchParams,
    isStandardBrowserEnv: $bf23feeeaa2c9e9e$var$isStandardBrowserEnv,
    forEach: $bf23feeeaa2c9e9e$var$forEach,
    merge: $bf23feeeaa2c9e9e$var$merge,
    extend: $bf23feeeaa2c9e9e$var$extend,
    trim: $bf23feeeaa2c9e9e$var$trim,
    stripBOM: $bf23feeeaa2c9e9e$var$stripBOM,
    inherits: $bf23feeeaa2c9e9e$var$inherits,
    toFlatObject: $bf23feeeaa2c9e9e$var$toFlatObject,
    kindOf: $bf23feeeaa2c9e9e$var$kindOf,
    kindOfTest: $bf23feeeaa2c9e9e$var$kindOfTest,
    endsWith: $bf23feeeaa2c9e9e$var$endsWith,
    toArray: $bf23feeeaa2c9e9e$var$toArray,
    isTypedArray: $bf23feeeaa2c9e9e$var$isTypedArray,
    isFileList: $bf23feeeaa2c9e9e$var$isFileList,
    forEachEntry: $bf23feeeaa2c9e9e$var$forEachEntry,
    matchAll: $bf23feeeaa2c9e9e$var$matchAll,
    isHTMLForm: $bf23feeeaa2c9e9e$var$isHTMLForm,
    hasOwnProperty: $bf23feeeaa2c9e9e$var$hasOwnProperty
};

});
parcelRegister("4YJci", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
};

});


parcelRegister("5M2Y4", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $gVvIV = parcelRequire("gVvIV");

var $8QUZt = parcelRequire("8QUZt");

var $1LOoN = parcelRequire("1LOoN");

var $PhbCf = parcelRequire("PhbCf");

var $6sGBK = parcelRequire("6sGBK");

var $aKRmY = parcelRequire("aKRmY");
var $4343bcc993043524$var$validators = $aKRmY.validators;
function $4343bcc993043524$var$captureCallerStack(boundary) {
    var caller = {};
    try {
        if (Error.captureStackTrace) Error.captureStackTrace(caller, boundary);
        else caller = new Error();
    } catch (e) {
    // Stack hooks must not prevent a request from being sent.
    }
    return caller;
}
function $4343bcc993043524$var$attachCallerStack(promise, caller) {
    if (!caller) return promise;
    return promise.then(null, function onRequestRejected(error) {
        try {
            if (error instanceof Error || Object.prototype.toString.call(error) === '[object Error]') {
                // Capture at dispatch time, but only format the stack on failure.
                // Capturing in this callback would lose callers using .then/.catch.
                var stack = caller.stack;
                if (typeof stack === 'string') {
                    var newline = stack.indexOf('\n');
                    stack = newline === -1 ? '' : stack.slice(newline + 1);
                    var original = error.stack;
                    if (stack && (original === undefined || original === null || original === '')) error.stack = stack;
                    else if (stack && typeof original === 'string' && original.indexOf(stack) === -1) error.stack = original + '\n' + stack;
                }
            }
        } catch (e) {
        // Frozen errors and custom stack accessors must retain their rejection.
        }
        return Promise.reject(error);
    });
}
function $4343bcc993043524$var$dispatchAfterRecovery(config) {
    return function dispatchRecoveredRequest() {
        return $1LOoN(config);
    };
}
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $4343bcc993043524$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $8QUZt(),
        response: new $8QUZt()
    };
}
/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */ $4343bcc993043524$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $PhbCf(this.defaults, config);
    var caller = config.captureCallerStack === true ? $4343bcc993043524$var$captureCallerStack(request) : null;
    // Set config.method. The merged config is null-prototype, but instance
    // defaults may be an ordinary object, so the fallback is read as an own
    // property to keep an inherited value from choosing the request method.
    if (config.method) config.method = config.method.toLowerCase();
    else if ($gpr5J.hasOwnProperty(this.defaults, 'method') && this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $aKRmY.assertOptions(transitional, {
        silentJSONParsing: $4343bcc993043524$var$validators.transitional($4343bcc993043524$var$validators["boolean"]),
        forcedJSONParsing: $4343bcc993043524$var$validators.transitional($4343bcc993043524$var$validators["boolean"]),
        clarifyTimeoutError: $4343bcc993043524$var$validators.transitional($4343bcc993043524$var$validators["boolean"])
    }, false);
    var paramsSerializer = config.paramsSerializer;
    if (paramsSerializer != null) {
        if ($gpr5J.isFunction(paramsSerializer)) config.paramsSerializer = {
            serialize: paramsSerializer
        };
        else $aKRmY.assertOptions(paramsSerializer, {
            encode: $4343bcc993043524$var$validators["function"],
            serialize: $4343bcc993043524$var$validators["function"]
        }, true);
    }
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $1LOoN,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return $4343bcc993043524$var$attachCallerStack(promise, caller);
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
        } catch (error) {
            if (!onRejected) {
                promise = Promise.reject(error);
                break;
            }
            try {
                var recovery = onRejected(error);
                if (recovery && typeof recovery.then === 'function') promise = Promise.resolve(recovery).then($4343bcc993043524$var$dispatchAfterRecovery(newConfig));
            } catch (rejectedError) {
                promise = Promise.reject(rejectedError);
            }
            break;
        }
    }
    if (!promise) try {
        promise = $1LOoN(newConfig);
    } catch (error) {
        // Dispatch errors, including pre-aborted signals, still go through the
        // response interceptors registered below.
        promise = Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return $4343bcc993043524$var$attachCallerStack(promise, caller);
};
$4343bcc993043524$var$Axios.prototype.getUri = function getUri(config) {
    config = $PhbCf(this.defaults, config);
    var fullPath = $6sGBK(config.baseURL, config.url, config.allowAbsoluteUrls);
    return $gVvIV(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$gpr5J.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $4343bcc993043524$var$Axios.prototype[method] = function(url, config) {
        var requestConfig = config || {};
        return this.request($PhbCf(requestConfig, {
            method: method,
            url: url,
            data: $gpr5J.hasOwnProperty(requestConfig, 'data') ? requestConfig.data : undefined
        }));
    };
});
$gpr5J.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($PhbCf(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $4343bcc993043524$var$Axios.prototype[method] = generateHTTPMethod();
    $4343bcc993043524$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = $4343bcc993043524$var$Axios;

});
parcelRegister("gVvIV", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $lJu7B = parcelRequire("lJu7B");
function $c52a93dd405b86de$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
    var _encode = $c52a93dd405b86de$var$encode;
    var serializeFn;
    if (options) {
        if ($gpr5J.isFunction(options)) serializeFn = options;
        else {
            _encode = $gpr5J.hasOwnProperty(options, 'encode') && options.encode || $c52a93dd405b86de$var$encode;
            serializeFn = $gpr5J.hasOwnProperty(options, 'serialize') ? options.serialize : undefined;
        }
    }
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = $gpr5J.isURLSearchParams(params) ? params.toString() : new $lJu7B(params, options).toString(_encode);
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});
parcelRegister("lJu7B", function(module, exports) {
'use strict';

var $k7vrg = parcelRequire("k7vrg");
function $fd252a7937a7b2b3$var$encode(str) {
    // Do not map `%00` back to a raw null byte: that reversed
    // the safe percent-encoding from encodeURIComponent and enabled null byte injection.
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
function $fd252a7937a7b2b3$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && $k7vrg(params, this, options);
}
var $fd252a7937a7b2b3$var$prototype = $fd252a7937a7b2b3$var$AxiosURLSearchParams.prototype;
$fd252a7937a7b2b3$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$fd252a7937a7b2b3$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $fd252a7937a7b2b3$var$encode);
    } : $fd252a7937a7b2b3$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
module.exports = $fd252a7937a7b2b3$var$AxiosURLSearchParams;

});
parcelRegister("k7vrg", function(module, exports) {

var $2xTNA = parcelRequire("2xTNA");

var $4jtOI = parcelRequire("4jtOI");
var $ea5cd92e60186f26$require$Buffer = $4jtOI.Buffer;
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $jk00O = parcelRequire("jk00O");

var $NoeJ2 = parcelRequire("NoeJ2");
function $ea5cd92e60186f26$var$isVisitable(thing) {
    return $gpr5J.isPlainObject(thing) || $gpr5J.isArray(thing);
}
function $ea5cd92e60186f26$var$removeBrackets(key) {
    return $gpr5J.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
function $ea5cd92e60186f26$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $ea5cd92e60186f26$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
function $ea5cd92e60186f26$var$isFlatArray(arr) {
    return $gpr5J.isArray(arr) && !arr.some($ea5cd92e60186f26$var$isVisitable);
}
var $ea5cd92e60186f26$var$predicates = $gpr5J.toFlatObject($gpr5J, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
function $ea5cd92e60186f26$var$isSpecCompliant(thing) {
    return thing && $gpr5J.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}
var $ea5cd92e60186f26$var$UNSAFE_OPTION_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
// Materialises the serializer options onto a null-prototype object. Reading the
// options from a plain object let a polluted Object.prototype supply a visitor,
// a depth limit, a Blob implementation or key-format flags that the caller never
// asked for, and also let a polluted key mask an option the caller did set.
// Only own, defined properties of the caller's options are carried over.
function $ea5cd92e60186f26$var$toFormDataOptions(source) {
    var options = Object.create(null);
    options.metaTokens = true;
    options.dots = false;
    options.indexes = false;
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (source == null) return options;
    var names = Object.getOwnPropertyNames(source);
    for(var i = 0; i < names.length; i++){
        var name = names[i];
        if ($ea5cd92e60186f26$var$UNSAFE_OPTION_KEYS.indexOf(name) !== -1 || $gpr5J.isUndefined(source[name])) continue;
        options[name] = source[name];
    }
    return options;
}
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/ function $ea5cd92e60186f26$var$toFormData(obj, formData, options) {
    if (!$gpr5J.isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ($NoeJ2 || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = $ea5cd92e60186f26$var$toFormDataOptions(options);
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    var useBlob = _Blob && $ea5cd92e60186f26$var$isSpecCompliant(formData);
    if (!$gpr5J.isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ($gpr5J.isDate(value)) return value.toISOString();
        if (!useBlob && $gpr5J.isBlob(value)) throw new $jk00O('Blob is not supported. Use a Buffer instead.');
        if ($gpr5J.isArrayBuffer(value) || $gpr5J.isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $ea5cd92e60186f26$require$Buffer.from(value);
        return value;
    }
    var stack = [];
    function assertValueDepth(value, depth) {
        if (depth > maxDepth) throw new $jk00O('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $jk00O.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (!$gpr5J.isObject(value) || stack.indexOf(value) !== -1) return;
        stack.push(value);
        $gpr5J.forEach(value, function each(el) {
            assertValueDepth(el, depth + 1);
        });
        stack.pop();
    }
    /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'object') {
            if ($gpr5J.endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                assertValueDepth(value, 1);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ($gpr5J.isArray(value) && $ea5cd92e60186f26$var$isFlatArray(value) || $gpr5J.isFileList(value) || $gpr5J.endsWith(key, '[]') && (arr = $gpr5J.toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $ea5cd92e60186f26$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !($gpr5J.isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $ea5cd92e60186f26$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($ea5cd92e60186f26$var$isVisitable(value)) return true;
        formData.append($ea5cd92e60186f26$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var exposedHelpers = Object.assign($ea5cd92e60186f26$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $ea5cd92e60186f26$var$isVisitable
    });
    function build(value, path, depth) {
        if ($gpr5J.isUndefined(value)) return;
        // eslint-disable-next-line no-param-reassign
        depth = depth || 0;
        if (depth > maxDepth) throw new $jk00O('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $jk00O.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        $gpr5J.forEach(value, function each(el, key) {
            var result = !($gpr5J.isUndefined(el) || el === null) && visitor.call(formData, el, $gpr5J.isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!$gpr5J.isObject(obj)) throw new TypeError('data must be an object');
    build(obj, null, 0);
    return formData;
}
module.exports = $ea5cd92e60186f26$var$toFormData;

});
parcelRegister("4jtOI", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $324010cc34647149$export$a143d493d941bafc; }, function (v) { return $324010cc34647149$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $324010cc34647149$export$f99ded8fe4b79145; }, function (v) { return $324010cc34647149$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $2xTNA = parcelRequire("2xTNA");
var $324010cc34647149$export$a143d493d941bafc;
var $324010cc34647149$export$e4cf37d7f6fb9e0a;
var $324010cc34647149$export$f99ded8fe4b79145;
var $324010cc34647149$export$599f31c3813fae4d;
'use strict';

var $l8GTL = parcelRequire("l8GTL");

var $lw9OJ = parcelRequire("lw9OJ");
var $324010cc34647149$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$324010cc34647149$export$a143d493d941bafc = $324010cc34647149$var$Buffer;
$324010cc34647149$export$e4cf37d7f6fb9e0a = $324010cc34647149$var$SlowBuffer;
$324010cc34647149$export$f99ded8fe4b79145 = 50;
var $324010cc34647149$var$K_MAX_LENGTH = 0x7fffffff;
$324010cc34647149$export$599f31c3813fae4d = $324010cc34647149$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $324010cc34647149$var$Buffer.TYPED_ARRAY_SUPPORT = $324010cc34647149$var$typedArraySupport();
if (!$324010cc34647149$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $324010cc34647149$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($324010cc34647149$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$324010cc34647149$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($324010cc34647149$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$324010cc34647149$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $324010cc34647149$var$createBuffer(length) {
    if (length > $324010cc34647149$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $324010cc34647149$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $324010cc34647149$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $324010cc34647149$var$allocUnsafe(arg);
    }
    return $324010cc34647149$var$from(arg, encodingOrOffset, length);
}
$324010cc34647149$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $324010cc34647149$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $324010cc34647149$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $324010cc34647149$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)));
    if ($324010cc34647149$var$isInstance(value, ArrayBuffer) || value && $324010cc34647149$var$isInstance(value.buffer, ArrayBuffer)) return $324010cc34647149$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($324010cc34647149$var$isInstance(value, SharedArrayBuffer) || value && $324010cc34647149$var$isInstance(value.buffer, SharedArrayBuffer))) return $324010cc34647149$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $324010cc34647149$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $324010cc34647149$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $324010cc34647149$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $324010cc34647149$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $324010cc34647149$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($324010cc34647149$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($324010cc34647149$var$Buffer, Uint8Array);
function $324010cc34647149$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $324010cc34647149$var$alloc(size, fill, encoding) {
    $324010cc34647149$var$assertSize(size);
    if (size <= 0) return $324010cc34647149$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $324010cc34647149$var$createBuffer(size).fill(fill, encoding) : $324010cc34647149$var$createBuffer(size).fill(fill);
    return $324010cc34647149$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $324010cc34647149$var$Buffer.alloc = function(size, fill, encoding) {
    return $324010cc34647149$var$alloc(size, fill, encoding);
};
function $324010cc34647149$var$allocUnsafe(size) {
    $324010cc34647149$var$assertSize(size);
    return $324010cc34647149$var$createBuffer(size < 0 ? 0 : $324010cc34647149$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $324010cc34647149$var$Buffer.allocUnsafe = function(size) {
    return $324010cc34647149$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $324010cc34647149$var$Buffer.allocUnsafeSlow = function(size) {
    return $324010cc34647149$var$allocUnsafe(size);
};
function $324010cc34647149$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$324010cc34647149$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $324010cc34647149$var$byteLength(string, encoding) | 0;
    var buf = $324010cc34647149$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $324010cc34647149$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $324010cc34647149$var$checked(array.length) | 0;
    var buf = $324010cc34647149$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $324010cc34647149$var$fromArrayView(arrayView) {
    if ($324010cc34647149$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $324010cc34647149$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $324010cc34647149$var$fromArrayLike(arrayView);
}
function $324010cc34647149$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $324010cc34647149$var$Buffer.prototype);
    return buf;
}
function $324010cc34647149$var$fromObject(obj) {
    if ($324010cc34647149$var$Buffer.isBuffer(obj)) {
        var len = $324010cc34647149$var$checked(obj.length) | 0;
        var buf = $324010cc34647149$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $324010cc34647149$var$numberIsNaN(obj.length)) return $324010cc34647149$var$createBuffer(0);
        return $324010cc34647149$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $324010cc34647149$var$fromArrayLike(obj.data);
}
function $324010cc34647149$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $324010cc34647149$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $324010cc34647149$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $324010cc34647149$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $324010cc34647149$var$Buffer.alloc(+length);
}
$324010cc34647149$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $324010cc34647149$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$324010cc34647149$var$Buffer.compare = function compare(a, b) {
    if ($324010cc34647149$var$isInstance(a, Uint8Array)) a = $324010cc34647149$var$Buffer.from(a, a.offset, a.byteLength);
    if ($324010cc34647149$var$isInstance(b, Uint8Array)) b = $324010cc34647149$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$324010cc34647149$var$Buffer.isBuffer(a) || !$324010cc34647149$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$324010cc34647149$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$324010cc34647149$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $324010cc34647149$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $324010cc34647149$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($324010cc34647149$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $324010cc34647149$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$324010cc34647149$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $324010cc34647149$var$byteLength(string, encoding) {
    if ($324010cc34647149$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $324010cc34647149$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $2xTNA._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $324010cc34647149$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $324010cc34647149$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $324010cc34647149$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$324010cc34647149$var$Buffer.byteLength = $324010cc34647149$var$byteLength;
function $324010cc34647149$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $324010cc34647149$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $324010cc34647149$var$utf8Slice(this, start, end);
        case 'ascii':
            return $324010cc34647149$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $324010cc34647149$var$latin1Slice(this, start, end);
        case 'base64':
            return $324010cc34647149$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $324010cc34647149$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$324010cc34647149$var$Buffer.prototype._isBuffer = true;
function $324010cc34647149$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$324010cc34647149$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$324010cc34647149$var$swap(this, i, i + 1);
    return this;
};
$324010cc34647149$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $324010cc34647149$var$swap(this, i, i + 3);
        $324010cc34647149$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$324010cc34647149$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $324010cc34647149$var$swap(this, i, i + 7);
        $324010cc34647149$var$swap(this, i + 1, i + 6);
        $324010cc34647149$var$swap(this, i + 2, i + 5);
        $324010cc34647149$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$324010cc34647149$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $324010cc34647149$var$utf8Slice(this, 0, length);
    return $324010cc34647149$var$slowToString.apply(this, arguments);
};
$324010cc34647149$var$Buffer.prototype.toLocaleString = $324010cc34647149$var$Buffer.prototype.toString;
$324010cc34647149$var$Buffer.prototype.equals = function equals(b) {
    if (!$324010cc34647149$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $324010cc34647149$var$Buffer.compare(this, b) === 0;
};
$324010cc34647149$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $324010cc34647149$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($324010cc34647149$var$customInspectSymbol) $324010cc34647149$var$Buffer.prototype[$324010cc34647149$var$customInspectSymbol] = $324010cc34647149$var$Buffer.prototype.inspect;
$324010cc34647149$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($324010cc34647149$var$isInstance(target, Uint8Array)) target = $324010cc34647149$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$324010cc34647149$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $2xTNA._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $324010cc34647149$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($324010cc34647149$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $324010cc34647149$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($324010cc34647149$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $324010cc34647149$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $324010cc34647149$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $324010cc34647149$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$324010cc34647149$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$324010cc34647149$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $324010cc34647149$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$324010cc34647149$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $324010cc34647149$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $324010cc34647149$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($324010cc34647149$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $324010cc34647149$var$utf8Write(buf, string, offset, length) {
    return $324010cc34647149$var$blitBuffer($324010cc34647149$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $324010cc34647149$var$asciiWrite(buf, string, offset, length) {
    return $324010cc34647149$var$blitBuffer($324010cc34647149$var$asciiToBytes(string), buf, offset, length);
}
function $324010cc34647149$var$base64Write(buf, string, offset, length) {
    return $324010cc34647149$var$blitBuffer($324010cc34647149$var$base64ToBytes(string), buf, offset, length);
}
function $324010cc34647149$var$ucs2Write(buf, string, offset, length) {
    return $324010cc34647149$var$blitBuffer($324010cc34647149$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$324010cc34647149$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $324010cc34647149$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $324010cc34647149$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $324010cc34647149$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $324010cc34647149$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $324010cc34647149$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$324010cc34647149$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $324010cc34647149$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $l8GTL.fromByteArray(buf);
    else return $l8GTL.fromByteArray(buf.slice(start, end));
}
function $324010cc34647149$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $324010cc34647149$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $324010cc34647149$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $324010cc34647149$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $324010cc34647149$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $324010cc34647149$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $324010cc34647149$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $324010cc34647149$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $324010cc34647149$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $324010cc34647149$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $324010cc34647149$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$324010cc34647149$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $324010cc34647149$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $324010cc34647149$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$324010cc34647149$var$Buffer.prototype.readUintLE = $324010cc34647149$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$324010cc34647149$var$Buffer.prototype.readUintBE = $324010cc34647149$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$324010cc34647149$var$Buffer.prototype.readUint8 = $324010cc34647149$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$324010cc34647149$var$Buffer.prototype.readUint16LE = $324010cc34647149$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$324010cc34647149$var$Buffer.prototype.readUint16BE = $324010cc34647149$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$324010cc34647149$var$Buffer.prototype.readUint32LE = $324010cc34647149$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$324010cc34647149$var$Buffer.prototype.readUint32BE = $324010cc34647149$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$324010cc34647149$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$324010cc34647149$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$324010cc34647149$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$324010cc34647149$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$324010cc34647149$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$324010cc34647149$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$324010cc34647149$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$324010cc34647149$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 4, this.length);
    return $lw9OJ.read(this, offset, true, 23, 4);
};
$324010cc34647149$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 4, this.length);
    return $lw9OJ.read(this, offset, false, 23, 4);
};
$324010cc34647149$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 8, this.length);
    return $lw9OJ.read(this, offset, true, 52, 8);
};
$324010cc34647149$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkOffset(offset, 8, this.length);
    return $lw9OJ.read(this, offset, false, 52, 8);
};
function $324010cc34647149$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$324010cc34647149$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$324010cc34647149$var$Buffer.prototype.writeUintLE = $324010cc34647149$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $324010cc34647149$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$324010cc34647149$var$Buffer.prototype.writeUintBE = $324010cc34647149$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $324010cc34647149$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$324010cc34647149$var$Buffer.prototype.writeUint8 = $324010cc34647149$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$324010cc34647149$var$Buffer.prototype.writeUint16LE = $324010cc34647149$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$324010cc34647149$var$Buffer.prototype.writeUint16BE = $324010cc34647149$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$324010cc34647149$var$Buffer.prototype.writeUint32LE = $324010cc34647149$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$324010cc34647149$var$Buffer.prototype.writeUint32BE = $324010cc34647149$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$324010cc34647149$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $324010cc34647149$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$324010cc34647149$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $324010cc34647149$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$324010cc34647149$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$324010cc34647149$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$324010cc34647149$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$324010cc34647149$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$324010cc34647149$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $324010cc34647149$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $324010cc34647149$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lw9OJ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$324010cc34647149$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $324010cc34647149$var$writeFloat(this, value, offset, true, noAssert);
};
$324010cc34647149$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $324010cc34647149$var$writeFloat(this, value, offset, false, noAssert);
};
function $324010cc34647149$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $324010cc34647149$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lw9OJ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$324010cc34647149$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $324010cc34647149$var$writeDouble(this, value, offset, true, noAssert);
};
$324010cc34647149$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $324010cc34647149$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$324010cc34647149$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$324010cc34647149$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$324010cc34647149$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$324010cc34647149$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $324010cc34647149$var$Buffer.isBuffer(val) ? val : $324010cc34647149$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $324010cc34647149$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $324010cc34647149$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($324010cc34647149$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $324010cc34647149$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $324010cc34647149$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $324010cc34647149$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $324010cc34647149$var$base64ToBytes(str) {
    return $l8GTL.toByteArray($324010cc34647149$var$base64clean(str));
}
function $324010cc34647149$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $324010cc34647149$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $324010cc34647149$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $324010cc34647149$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("l8GTL", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $f63b9f11eb9e5615$export$d622b2ad8d90c771; }, function (v) { return $f63b9f11eb9e5615$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $f63b9f11eb9e5615$export$6100ba28696e12de; }, function (v) { return $f63b9f11eb9e5615$export$6100ba28696e12de = v; });
var $f63b9f11eb9e5615$export$a48f0734ac7c2329;
var $f63b9f11eb9e5615$export$d622b2ad8d90c771;
var $f63b9f11eb9e5615$export$6100ba28696e12de;
'use strict';
$f63b9f11eb9e5615$export$a48f0734ac7c2329 = $f63b9f11eb9e5615$var$byteLength;
$f63b9f11eb9e5615$export$d622b2ad8d90c771 = $f63b9f11eb9e5615$var$toByteArray;
$f63b9f11eb9e5615$export$6100ba28696e12de = $f63b9f11eb9e5615$var$fromByteArray;
var $f63b9f11eb9e5615$var$lookup = [];
var $f63b9f11eb9e5615$var$revLookup = [];
var $f63b9f11eb9e5615$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $f63b9f11eb9e5615$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $f63b9f11eb9e5615$var$i = 0, $f63b9f11eb9e5615$var$len = $f63b9f11eb9e5615$var$code.length; $f63b9f11eb9e5615$var$i < $f63b9f11eb9e5615$var$len; ++$f63b9f11eb9e5615$var$i){
    $f63b9f11eb9e5615$var$lookup[$f63b9f11eb9e5615$var$i] = $f63b9f11eb9e5615$var$code[$f63b9f11eb9e5615$var$i];
    $f63b9f11eb9e5615$var$revLookup[$f63b9f11eb9e5615$var$code.charCodeAt($f63b9f11eb9e5615$var$i)] = $f63b9f11eb9e5615$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$f63b9f11eb9e5615$var$revLookup['-'.charCodeAt(0)] = 62;
$f63b9f11eb9e5615$var$revLookup['_'.charCodeAt(0)] = 63;
function $f63b9f11eb9e5615$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $f63b9f11eb9e5615$var$byteLength(b64) {
    var lens = $f63b9f11eb9e5615$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f63b9f11eb9e5615$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f63b9f11eb9e5615$var$toByteArray(b64) {
    var tmp;
    var lens = $f63b9f11eb9e5615$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $f63b9f11eb9e5615$var$Arr($f63b9f11eb9e5615$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i)] << 18 | $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i)] << 2 | $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i)] << 10 | $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $f63b9f11eb9e5615$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $f63b9f11eb9e5615$var$tripletToBase64(num) {
    return $f63b9f11eb9e5615$var$lookup[num >> 18 & 0x3F] + $f63b9f11eb9e5615$var$lookup[num >> 12 & 0x3F] + $f63b9f11eb9e5615$var$lookup[num >> 6 & 0x3F] + $f63b9f11eb9e5615$var$lookup[num & 0x3F];
}
function $f63b9f11eb9e5615$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($f63b9f11eb9e5615$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $f63b9f11eb9e5615$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($f63b9f11eb9e5615$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($f63b9f11eb9e5615$var$lookup[tmp >> 2] + $f63b9f11eb9e5615$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($f63b9f11eb9e5615$var$lookup[tmp >> 10] + $f63b9f11eb9e5615$var$lookup[tmp >> 4 & 0x3F] + $f63b9f11eb9e5615$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("lw9OJ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $faa433a654a26159$export$aafa59e2e03f2942; }, function (v) { return $faa433a654a26159$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $faa433a654a26159$export$68d8715fc104d294; }, function (v) { return $faa433a654a26159$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $faa433a654a26159$export$aafa59e2e03f2942;
var $faa433a654a26159$export$68d8715fc104d294;
$faa433a654a26159$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$faa433a654a26159$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("jk00O", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $9uxdc = parcelRequire("9uxdc");
var $e10fe4fc4cd80666$var$REDACTED_VALUE = '[REDACTED ****]';
function $e10fe4fc4cd80666$var$makeValueDescriptor(value) {
    var descriptor = Object.create(null);
    descriptor.value = value;
    return descriptor;
}
function $e10fe4fc4cd80666$var$getRedactKeys(config) {
    // An empty array is treated as "no override" so an upstream `redact: []` cannot
    // silently disable redaction. To opt out, pass non-string values or unset keys.
    var override = config && $gpr5J.isArray(config.redact) && config.redact.length ? config.redact : null;
    var redact = override || $9uxdc;
    var keys = {};
    $gpr5J.forEach(redact, function eachRedactKey(key) {
        if (typeof key === 'string') keys[key.toLowerCase()] = true;
    });
    return keys;
}
function $e10fe4fc4cd80666$var$shouldRedact(key, keys) {
    return typeof key === 'string' && keys[key.toLowerCase()];
}
var $e10fe4fc4cd80666$var$CIRCULAR_VALUE = '[Circular]';
function $e10fe4fc4cd80666$var$serializeConfigValue(value, keys, key, seen) {
    var result;
    if ($e10fe4fc4cd80666$var$shouldRedact(key, keys)) return $e10fe4fc4cd80666$var$REDACTED_VALUE;
    if ($gpr5J.isArray(value)) {
        if (seen.indexOf(value) !== -1) return $e10fe4fc4cd80666$var$CIRCULAR_VALUE;
        seen.push(value);
        result = [];
        $gpr5J.forEach(value, function eachArrayValue(item, index) {
            result[index] = $e10fe4fc4cd80666$var$serializeConfigValue(item, keys, index, seen);
        });
        seen.pop();
        return result;
    }
    if ($gpr5J.isPlainObject(value)) {
        if (seen.indexOf(value) !== -1) return $e10fe4fc4cd80666$var$CIRCULAR_VALUE;
        seen.push(value);
        result = {};
        $gpr5J.forEach(value, function eachObjectValue(item, itemKey) {
            result[itemKey] = $e10fe4fc4cd80666$var$serializeConfigValue(item, keys, itemKey, seen);
        });
        seen.pop();
        return result;
    }
    return value;
}
function $e10fe4fc4cd80666$var$serializeConfig(config) {
    if (!config) return config;
    return $e10fe4fc4cd80666$var$serializeConfigValue(config, $e10fe4fc4cd80666$var$getRedactKeys(config), undefined, []);
}
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $e10fe4fc4cd80666$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$gpr5J.inherits($e10fe4fc4cd80666$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: $e10fe4fc4cd80666$var$serializeConfig(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $e10fe4fc4cd80666$var$prototype = $e10fe4fc4cd80666$var$AxiosError.prototype;
var $e10fe4fc4cd80666$var$descriptors = Object.create(null);
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL',
    'ERR_FORM_DATA_DEPTH_EXCEEDED'
].forEach(function(code) {
    $e10fe4fc4cd80666$var$descriptors[code] = $e10fe4fc4cd80666$var$makeValueDescriptor(code);
});
Object.defineProperties($e10fe4fc4cd80666$var$AxiosError, $e10fe4fc4cd80666$var$descriptors);
Object.defineProperty($e10fe4fc4cd80666$var$prototype, 'isAxiosError', $e10fe4fc4cd80666$var$makeValueDescriptor(true));
// eslint-disable-next-line func-names
$e10fe4fc4cd80666$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($e10fe4fc4cd80666$var$prototype);
    $gpr5J.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $e10fe4fc4cd80666$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $e10fe4fc4cd80666$var$AxiosError;

});
parcelRegister("9uxdc", function(module, exports) {
'use strict';
module.exports = [
    'authorization',
    'proxy-authorization',
    'cookie',
    'set-cookie',
    'x-api-key',
    'password'
];

});


parcelRegister("NoeJ2", function(module, exports) {
// eslint-disable-next-line strict

module.exports = (parcelRequire("iZcXh"));

});
parcelRegister("iZcXh", function(module, exports) {

var $2xTNA = parcelRequire("2xTNA");
'use strict';
/* eslint-env browser */ module.exports = (typeof self === "undefined" ? "undefined" : (0, $2xTNA._)(self)) === 'object' ? self.FormData : window.FormData;

});





parcelRegister("8QUZt", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
function $671f6330636d9c9b$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $671f6330636d9c9b$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $671f6330636d9c9b$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Clear all interceptors from the stack
 */ $671f6330636d9c9b$var$InterceptorManager.prototype.clear = function clear() {
    if (this.handlers) this.handlers = [];
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $671f6330636d9c9b$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gpr5J.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $671f6330636d9c9b$var$InterceptorManager;

});

parcelRegister("1LOoN", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $jIeOl = parcelRequire("jIeOl");

var $1b8FS = parcelRequire("1b8FS");

var $2lSP3 = parcelRequire("2lSP3");

var $gaw91 = parcelRequire("gaw91");

var $2kvfh = parcelRequire("2kvfh");

var $8Cdc7 = parcelRequire("8Cdc7");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $14a1466b73a6772c$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw $gaw91(config.signal, config);
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $14a1466b73a6772c$var$throwIfCancellationRequested(config);
    // Ensure headers exist. A request interceptor may return a replacement config
    // that inherits from Object.prototype, so only an own headers value is used.
    config.headers = $gpr5J.hasOwnProperty(config, 'headers') && config.headers || {};
    // Transform request data
    config.data = $jIeOl.call(config, config.data, config.headers, null, config.transformRequest);
    $2kvfh(config.headers, 'Accept');
    $2kvfh(config.headers, 'Content-Type');
    // Flatten headers
    var commonHeaders = $gpr5J.hasOwnProperty(config.headers, 'common') && config.headers.common ? config.headers.common : {};
    var methodHeaders = config.method && $gpr5J.hasOwnProperty(config.headers, config.method) && config.headers[config.method] ? config.headers[config.method] : {};
    config.headers = $gpr5J.merge(commonHeaders, methodHeaders, config.headers);
    $gpr5J.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    $gpr5J.forEach(config.headers, function sanitizeHeaderConfigValue(value, header) {
        config.headers[header] = $8Cdc7(value);
    });
    var adapter = config.adapter || $2lSP3.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $14a1466b73a6772c$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $jIeOl.call(config, response.data, response.headers, response.status, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$1b8FS(reason)) {
            $14a1466b73a6772c$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $jIeOl.call(config, reason.response.data, reason.response.headers, reason.response.status, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("jIeOl", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $2lSP3 = parcelRequire("2lSP3");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, status, fns) {
    var context = this || $2lSP3;
    /*eslint no-param-reassign:0*/ $gpr5J.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers, status);
    });
    return data;
};

});
parcelRegister("2lSP3", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $2kvfh = parcelRequire("2kvfh");

var $jk00O = parcelRequire("jk00O");

var $dT46f = parcelRequire("dT46f");

var $k7vrg = parcelRequire("k7vrg");

var $8mm5x = parcelRequire("8mm5x");

var $hqXaE = parcelRequire("hqXaE");

var $aIG4d = parcelRequire("aIG4d");

var $9uxdc = parcelRequire("9uxdc");
var $1b68118442a99110$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $1b68118442a99110$var$setContentTypeIfUnset(headers, value) {
    if (!$gpr5J.isUndefined(headers) && $gpr5J.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $1b68118442a99110$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("cqDy0"));
    return adapter;
}
function $1b68118442a99110$var$stringifySafely(rawValue, parser, encoder) {
    if ($gpr5J.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gpr5J.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $1b68118442a99110$var$defaults = {
    transitional: $dT46f,
    adapter: $1b68118442a99110$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $2kvfh(headers, 'Accept');
            $2kvfh(headers, 'Content-Type');
            var contentType = headers && headers['Content-Type'] || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = $gpr5J.isObject(data);
            if (isObjectPayload && $gpr5J.isHTMLForm(data)) data = new FormData(data);
            var isFormData = $gpr5J.isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify($aIG4d(data)) : data;
            if ($gpr5J.isArrayBuffer(data) || $gpr5J.isBuffer(data) || $gpr5J.isStream(data) || $gpr5J.isFile(data) || $gpr5J.isBlob(data)) return data;
            if ($gpr5J.isArrayBufferView(data)) return data.buffer;
            if ($gpr5J.isURLSearchParams(data)) {
                $1b68118442a99110$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $gpr5J.hasOwnProperty(this, 'formSerializer') ? this.formSerializer : undefined;
                var envOption = $gpr5J.hasOwnProperty(this, 'env') ? this.env : undefined;
                if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) return $8mm5x(data, formSerializer).toString();
                if ((isFileList = $gpr5J.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = envOption && envOption.FormData;
                    return $k7vrg(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                $1b68118442a99110$var$setContentTypeIfUnset(headers, 'application/json');
                return $1b68118442a99110$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $1b68118442a99110$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if (data && $gpr5J.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw $jk00O.from(e, $jk00O.ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    redact: $9uxdc.slice(),
    env: {
        FormData: $hqXaE.classes.FormData,
        Blob: $hqXaE.classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*'
        }
    }
};
$gpr5J.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $1b68118442a99110$var$defaults.headers[method] = {};
});
$gpr5J.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $1b68118442a99110$var$defaults.headers[method] = $gpr5J.merge($1b68118442a99110$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $1b68118442a99110$var$defaults;

});
parcelRegister("2kvfh", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gpr5J.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("dT46f", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("8mm5x", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $k7vrg = parcelRequire("k7vrg");

var $hqXaE = parcelRequire("hqXaE");
module.exports = function toURLEncodedForm(data, options) {
    return $k7vrg(data, new $hqXaE.classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ($hqXaE.isNode && $gpr5J.isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
};

});
parcelRegister("hqXaE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4Wy6W"));

});
parcelRegister("4Wy6W", function(module, exports) {
'use strict';


module.exports = {
    isBrowser: true,
    classes: {
        URLSearchParams: (parcelRequire("hVdaV")),
        FormData: (parcelRequire("dKSRf")),
        Blob: Blob
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("hVdaV", function(module, exports) {
'use strict';

var $lJu7B = parcelRequire("lJu7B");
module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : $lJu7B;

});

parcelRegister("dKSRf", function(module, exports) {
'use strict';
module.exports = FormData;

});




parcelRegister("aIG4d", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $jk00O = parcelRequire("jk00O");
var $7cdea50eaeb46088$var$MAX_FORM_DATA_TO_JSON_DEPTH = 100;
function $7cdea50eaeb46088$var$assertPathDepth(path) {
    var depth = path.length - 1;
    if (depth > $7cdea50eaeb46088$var$MAX_FORM_DATA_TO_JSON_DEPTH) throw new $jk00O('Maximum object depth of ' + $7cdea50eaeb46088$var$MAX_FORM_DATA_TO_JSON_DEPTH + ' exceeded (got ' + depth + ' levels)', $jk00O.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function $7cdea50eaeb46088$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return $gpr5J.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
function $7cdea50eaeb46088$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
function $7cdea50eaeb46088$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && $gpr5J.isArray(target) ? target.length : name;
        if (isLast) {
            if ($gpr5J.hasOwnProperty(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !$gpr5J.isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && $gpr5J.isArray(target[name])) target[name] = $7cdea50eaeb46088$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ($gpr5J.isFormData(formData) && $gpr5J.isFunction(formData.entries)) {
        var obj = {};
        $gpr5J.forEachEntry(formData, function(name, value) {
            var path = $7cdea50eaeb46088$var$parsePropPath(name);
            $7cdea50eaeb46088$var$assertPathDepth(path);
            buildPath(path, value, obj, 0);
        });
        return obj;
    }
    return null;
}
module.exports = $7cdea50eaeb46088$var$formDataToJSON;

});

parcelRegister("cqDy0", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");

var $fG07c = parcelRequire("fG07c");

var $epw0n = parcelRequire("epw0n");

var $gVvIV = parcelRequire("gVvIV");

var $6sGBK = parcelRequire("6sGBK");

var $kRQ96 = parcelRequire("kRQ96");

var $1jzDJ = parcelRequire("1jzDJ");

var $dT46f = parcelRequire("dT46f");

var $jk00O = parcelRequire("jk00O");

var $gaw91 = parcelRequire("gaw91");

var $bqOH5 = parcelRequire("bqOH5");

var $hqXaE = parcelRequire("hqXaE");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        // Guard against prototype pollution: only honor own properties.
        var withXSRFToken = $gpr5J.hasOwnProperty(config, 'withXSRFToken') ? config.withXSRFToken : undefined;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($gpr5J.isFormData(requestData) && $gpr5J.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        var configAuth = $gpr5J.hasOwnProperty(config, 'auth') ? config.auth : undefined;
        if (configAuth) {
            var username = $gpr5J.hasOwnProperty(configAuth, 'username') ? configAuth.username || '' : '';
            var password = $gpr5J.hasOwnProperty(configAuth, 'password') && configAuth.password ? unescape(encodeURIComponent(configAuth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $6sGBK(config.baseURL, config.url, config.allowAbsoluteUrls);
        request.open(config.method.toUpperCase(), $gVvIV(fullPath, config.params, $gpr5J.hasOwnProperty(config, 'paramsSerializer') ? config.paramsSerializer : undefined), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $kRQ96(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $fG07c(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $jk00O('Request aborted', $jk00O.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $jk00O('Network Error', $jk00O.ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $dT46f;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $jk00O(timeoutErrorMessage, transitional.clarifyTimeoutError ? $jk00O.ETIMEDOUT : $jk00O.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gpr5J.isStandardBrowserEnv()) {
            // Add xsrf header
            if ($gpr5J.isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(config);
            // Strict boolean check: only `true` short-circuits the same-origin guard.
            if (withXSRFToken === true || withXSRFToken !== false && $1jzDJ(fullPath)) {
                // Add xsrf header
                var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && $epw0n.read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $gpr5J.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gpr5J.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function onCanceled(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? $gaw91(config.signal, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        // false, 0 (zero number), and '' (empty string) are valid JSON values
        if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') requestData = null;
        var protocol = $bqOH5(fullPath);
        if (protocol && $hqXaE.protocols.indexOf(protocol) === -1) {
            reject(new $jk00O('Unsupported protocol ' + protocol + ':', $jk00O.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("fG07c", function(module, exports) {
'use strict';

var $jk00O = parcelRequire("jk00O");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $jk00O('Request failed with status code ' + response.status, [
        $jk00O.ERR_BAD_REQUEST,
        $jk00O.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("epw0n", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
module.exports = $gpr5J.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($gpr5J.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($gpr5J.isString(path)) cookie.push('path=' + path);
            if ($gpr5J.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var nameEQ = name + '=';
            var cookies = document.cookie.split(';');
            var cookie;
            for(var i = 0; i < cookies.length; i++){
                cookie = cookies[i];
                while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
                if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
            }
            return null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("6sGBK", function(module, exports) {
'use strict';

var $hEuB4 = parcelRequire("hEuB4");

var $l7LMR = parcelRequire("l7LMR");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @param {boolean} allowAbsoluteUrls Set to true to allow absolute URLs
 *
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeURL = !$hEuB4(requestedURL);
    if (baseURL && (isRelativeURL || allowAbsoluteUrls === false)) return $l7LMR(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("hEuB4", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("l7LMR", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("kRQ96", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $f31134f0765e714d$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gpr5J.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $gpr5J.trim(line.slice(0, i)).toLowerCase();
        val = $gpr5J.trim(line.slice(i + 1));
        if (key) {
            if (parsed[key] && $f31134f0765e714d$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("1jzDJ", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
module.exports = $gpr5J.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */ return function isURLSameOrigin(requestURL) {
        var parsed = $gpr5J.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("gaw91", function(module, exports) {
'use strict';

var $b0lYG = parcelRequire("b0lYG");
module.exports = function fromSignal(signal, config, request) {
    var error = new $b0lYG(null, config, request);
    if (signal) try {
        var reason = signal.reason;
        if (reason !== undefined) error.reason = reason;
    } catch (e) {
    // A custom signal getter must not prevent cancellation.
    }
    return error;
};

});
parcelRegister("b0lYG", function(module, exports) {
'use strict';

var $jk00O = parcelRequire("jk00O");

var $gpr5J = parcelRequire("gpr5J");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */ function $8030be1d0d7944b8$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $jk00O.call(this, message == null ? 'canceled' : message, $jk00O.ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
$gpr5J.inherits($8030be1d0d7944b8$var$CanceledError, $jk00O, {
    __CANCEL__: true
});
module.exports = $8030be1d0d7944b8$var$CanceledError;

});


parcelRegister("bqOH5", function(module, exports) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

});




parcelRegister("1b8FS", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("8Cdc7", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
var $645c1b7d96ac9067$var$INVALID_HEADER_VALUE_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
var $645c1b7d96ac9067$var$BOUNDARY_WHITESPACE_RE = /^[\x09\x20]+|[\x09\x20]+$/g;
function $645c1b7d96ac9067$var$sanitizeHeaderValue(value) {
    if (value === false || value == null) return value;
    if ($gpr5J.isArray(value)) return value.map($645c1b7d96ac9067$var$sanitizeHeaderValue);
    return String(value).replace($645c1b7d96ac9067$var$INVALID_HEADER_VALUE_RE, '').replace($645c1b7d96ac9067$var$BOUNDARY_WHITESPACE_RE, '');
}
module.exports = $645c1b7d96ac9067$var$sanitizeHeaderValue;

});


parcelRegister("PhbCf", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so a polluted Object.prototype cannot leak
    // values (e.g. transport, adapter) into the returned config via inheritance.
    var config = Object.create(null);
    function getOwn(source, prop) {
        return $gpr5J.hasOwnProperty(source, prop) ? source[prop] : undefined;
    }
    function hasOwn(source, prop) {
        return $gpr5J.hasOwnProperty(source, prop);
    }
    function getMergedValue(target, source) {
        if ($gpr5J.isPlainObject(target) && $gpr5J.isPlainObject(source)) return $gpr5J.merge(target, source);
        else if ($gpr5J.isEmptyObject(source)) return $gpr5J.merge({}, target);
        else if ($gpr5J.isPlainObject(source)) return $gpr5J.merge({}, source);
        else if ($gpr5J.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (hasOwn(config2, prop) && !$gpr5J.isUndefined(config2[prop])) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop) && !$gpr5J.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (hasOwn(config2, prop) && !$gpr5J.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (hasOwn(config2, prop) && !$gpr5J.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (hasOwn(config1, prop) && !$gpr5J.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    function defaultToConfig2Reference(prop) {
        var value = getOwn(config2, prop);
        return $gpr5J.isUndefined(value) ? getOwn(config1, prop) : value;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (hasOwn(config2, prop)) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop)) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        // Signals are live objects; cloning them snapshots getters and reasons.
        signal: defaultToConfig2Reference,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys
    };
    $gpr5J.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = $gpr5J.hasOwnProperty(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var configValue = merge(prop);
        $gpr5J.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("aKRmY", function(module, exports) {

var $2xTNA = parcelRequire("2xTNA");
'use strict';

var $kHrOz = parcelRequire("kHrOz");
var $7d479956655f213e$require$VERSION = $kHrOz.version;

var $jk00O = parcelRequire("jk00O");
var $7d479956655f213e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $7d479956655f213e$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $2xTNA._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $7d479956655f213e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $7d479956655f213e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $7d479956655f213e$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $jk00O(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $jk00O.ERR_DEPRECATED);
        if (version && !$7d479956655f213e$var$deprecatedWarnings[opt]) {
            $7d479956655f213e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $7d479956655f213e$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $2xTNA._)(options)) !== 'object') throw new $jk00O('options must be an object', $jk00O.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $jk00O('option ' + opt + ' must be ' + result, $jk00O.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $jk00O('Unknown option ' + opt, $jk00O.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $7d479956655f213e$var$assertOptions,
    validators: $7d479956655f213e$var$validators
};

});
parcelRegister("kHrOz", function(module, exports) {
module.exports = {
    version: "0.34.0"
};

});



parcelRegister("kfvPz", function(module, exports) {
'use strict';

var $b0lYG = parcelRequire("b0lYG");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $ebdde64c472871d0$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i = token._listeners.length;
        while(i-- > 0)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message, config, request) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $b0lYG(message, config, request);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $ebdde64c472871d0$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $ebdde64c472871d0$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $ebdde64c472871d0$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $ebdde64c472871d0$var$CancelToken.source = function source() {
    var cancel;
    var token = new $ebdde64c472871d0$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $ebdde64c472871d0$var$CancelToken;

});

parcelRegister("5Ecwk", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("iCDZK", function(module, exports) {
'use strict';

var $gpr5J = parcelRequire("gpr5J");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $gpr5J.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("fqT2i", function(module, exports) {

$parcel$export(module.exports, "Filestack", function () { return Pr; });
$parcel$export(module.exports, "PickerDisplayMode", function () { return Ur; });
/*! For license information please see filestack.esm.js.LICENSE.txt */ 
var $2xTNA = parcelRequire("2xTNA");
var t, e, r = {
    15: function(t) {
        t.exports = EvalError;
    },
    157: function(t) {
        t.exports = Error;
    },
    377: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = "undefined" != typeof Symbol && Symbol, i = r(4379);
        t.exports = function() {
            return "function" == typeof _$o && "function" == typeof Symbol && "symbol" === n(_$o("foo")) && "symbol" === n(Symbol("bar")) && i();
        };
    },
    395: function(t, e, r) {
        var U = function U(t, e) {
            return t.set(e[0], e[1]), t;
        };
        var q = function q(t, e) {
            return t.add(e), t;
        };
        var G = function G(t, e, r, n) {
            var _$o = -1, i = t ? t.length : 0;
            for(n && i && (r = t[++_$o]); ++_$o < i;)r = e(r, t[_$o], _$o, t);
            return r;
        };
        var $ = function $(t) {
            var _$e = !1;
            if (null != t && "function" != typeof t.toString) try {
                _$e = !!(t + "");
            } catch (t) {}
            return _$e;
        };
        var Z = function Z(t) {
            var _$e = -1, _$r = Array(t.size);
            return t.forEach(function(t, n) {
                _$r[++_$e] = [
                    n,
                    t
                ];
            }), _$r;
        };
        var V = function V(t, e) {
            return function(r) {
                return t(e(r));
            };
        };
        var H = function H(t) {
            var _$e = -1, _$r = Array(t.size);
            return t.forEach(function(t) {
                _$r[++_$e] = t;
            }), _$r;
        };
        var Ft = function Ft(t) {
            var _$e = -1, _$r = t ? t.length : 0;
            for(this.clear(); ++_$e < _$r;){
                var _$n = t[_$e];
                this.set(_$n[0], _$n[1]);
            }
        };
        var _t = function _t(t) {
            var _$e = -1, _$r = t ? t.length : 0;
            for(this.clear(); ++_$e < _$r;){
                var _$n = t[_$e];
                this.set(_$n[0], _$n[1]);
            }
        };
        var Pt = function Pt(t) {
            var _$e = -1, _$r = t ? t.length : 0;
            for(this.clear(); ++_$e < _$r;){
                var _$n = t[_$e];
                this.set(_$n[0], _$n[1]);
            }
        };
        var At = function At(t) {
            this.__data__ = new _t(t);
        };
        var Tt = function Tt(t, e, r) {
            var _$n = t[e];
            et.call(t, e) && Gt(_$n, r) && (void 0 !== r || e in t) || (t[e] = r);
        };
        var Dt = function Dt(t, e) {
            for(var _$r = t.length; _$r--;)if (Gt(t[_$r][0], e)) return _$r;
            return -1;
        };
        var Ct = function Ct(t) {
            var _$e = new t.constructor(t.byteLength);
            return new at(_$e).set(new at(t)), _$e;
        };
        var It = function It(t, e, r, n) {
            r || (r = {});
            for(var _$o = -1, i = e.length; ++_$o < i;){
                var a = e[_$o], c = n ? n(r[a], t[a], a, r, t) : void 0;
                Tt(r, a, void 0 === c ? t[a] : c);
            }
            return r;
        };
        var zt = function zt(t, e) {
            var _$r, _$o, i = t.__data__;
            return ("string" == (_$o = n(_$r = e)) || "number" == _$o || "symbol" == _$o || "boolean" == _$o ? "__proto__" !== _$r : null === _$r) ? i["string" == typeof e ? "string" : "hash"] : i.map;
        };
        var Nt = function Nt(t, e) {
            var _$r = function(t, e) {
                return null == t ? void 0 : t[e];
            }(t, e);
            return function(t) {
                var _$e;
                return !(!Yt(t) || (_$e = t, X && X in _$e)) && (Ht(t) || $(t) ? nt : D).test(qt(t));
            }(_$r) ? _$r : void 0;
        };
        var Bt = function Bt(t, e) {
            return !!(e = null == e ? i : e) && ("number" == typeof t || L.test(t)) && t > -1 && t % 1 == 0 && t < e;
        };
        var Ut = function Ut(t) {
            var _$e = t && t.constructor;
            return t === ("function" == typeof _$e && _$e.prototype || Q);
        };
        var qt = function qt(t) {
            if (null != t) {
                try {
                    return tt.call(t);
                } catch (t) {}
                try {
                    return t + "";
                } catch (t) {}
            }
            return "";
        };
        var Gt = function Gt(t, e) {
            return t === e || t != t && e != e;
        };
        var Zt = function Zt(t) {
            return null != t && function(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= i;
            }(t.length) && !Ht(t);
        };
        var Ht = function Ht(t) {
            var _$e = Yt(t) ? rt.call(t) : "";
            return _$e == u || _$e == p;
        };
        var Yt = function Yt(t) {
            var _$e = n(t);
            return !!t && ("object" == _$e || "function" == _$e);
        };
        var Wt = function Wt(t) {
            return Zt(t) ? function(t, e) {
                var _$r = $t(t) || function(t) {
                    return function(t) {
                        return function(t) {
                            return !!t && "object" == n(t);
                        }(t) && Zt(t);
                    }(t) && et.call(t, "callee") && (!ut.call(t, "callee") || rt.call(t) == a);
                }(t) ? function(t, e) {
                    for(var _$r = -1, _$n = Array(t); ++_$r < t;)_$n[_$r] = e(_$r);
                    return _$n;
                }(t.length, String) : [], _$o = _$r.length, i = !!_$o;
                for(var c in t)!e && !et.call(t, c) || i && ("length" == c || Bt(c, _$o)) || _$r.push(c);
                return _$r;
            }(t) : function(t) {
                if (!Ut(t)) return ht(t);
                var _$e = [];
                for(var _$r in Object(t))et.call(t, _$r) && "constructor" != _$r && _$e.push(_$r);
                return _$e;
            }(t);
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        t = r.nmd(t);
        var _$o = "__lodash_hash_undefined__", i = 9007199254740991, a = "[object Arguments]", c = "[object Boolean]", s = "[object Date]", u = "[object Function]", p = "[object GeneratorFunction]", l = "[object Map]", f = "[object Number]", h = "[object Object]", d = "[object Promise]", m = "[object RegExp]", y = "[object Set]", v = "[object String]", _$g = "[object Symbol]", b = "[object WeakMap]", x = "[object ArrayBuffer]", w = "[object DataView]", k = "[object Float32Array]", S = "[object Float64Array]", E = "[object Int8Array]", O = "[object Int16Array]", j = "[object Int32Array]", F = "[object Uint8Array]", _ = "[object Uint8ClampedArray]", P = "[object Uint16Array]", A = "[object Uint32Array]", T = /\w*$/, D = /^\[object .+?Constructor\]$/, L = /^(?:0|[1-9]\d*)$/, C = {};
        C[a] = C["[object Array]"] = C[x] = C[w] = C[c] = C[s] = C[k] = C[S] = C[E] = C[O] = C[j] = C[l] = C[f] = C[h] = C[m] = C[y] = C[v] = C[_$g] = C[F] = C[_] = C[P] = C[A] = !0, C["[object Error]"] = C[u] = C[b] = !1;
        var I = "object" == (void 0 === r.g ? "undefined" : n(r.g)) && r.g && r.g.Object === Object && r.g, z = "object" == ("undefined" == typeof self ? "undefined" : n(self)) && self && self.Object === Object && self, N = I || z || Function("return this")(), R = "object" == n(e) && e && !e.nodeType && e, M = R && "object" == n(t) && t && !t.nodeType && t, B = M && M.exports === R;
        var Y, W = Array.prototype, K = Function.prototype, Q = Object.prototype, J = N["__core-js_shared__"], X = (Y = /[^.]+$/.exec(J && J.keys && J.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Y : "", tt = K.toString, et = Q.hasOwnProperty, rt = Q.toString, nt = RegExp("^" + tt.call(et).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ot = B ? N.Buffer : void 0, it = N.Symbol, at = N.Uint8Array, ct = V(Object.getPrototypeOf, Object), st = Object.create, ut = Q.propertyIsEnumerable, pt = W.splice, lt = Object.getOwnPropertySymbols, ft = ot ? ot.isBuffer : void 0, ht = V(Object.keys, Object), dt = Nt(N, "DataView"), mt = Nt(N, "Map"), yt = Nt(N, "Promise"), vt = Nt(N, "Set"), gt = Nt(N, "WeakMap"), bt = Nt(Object, "create"), xt = qt(dt), wt = qt(mt), kt = qt(yt), St = qt(vt), Et = qt(gt), Ot = it ? it.prototype : void 0, jt = Ot ? Ot.valueOf : void 0;
        function Lt(t, e, r, n, o, i, d) {
            var b;
            if (n && (b = i ? n(t, o, i, d) : n(t)), void 0 !== b) return b;
            if (!Yt(t)) return t;
            var D = $t(t);
            if (D) {
                if (b = function(t) {
                    var _$e = t.length, _$r = t.constructor(_$e);
                    return _$e && "string" == typeof t[0] && et.call(t, "index") && (_$r.index = t.index, _$r.input = t.input), _$r;
                }(t), !e) return function(t, e) {
                    var _$r = -1, _$n = t.length;
                    for(e || (e = Array(_$n)); ++_$r < _$n;)e[_$r] = t[_$r];
                    return e;
                }(t, b);
            } else {
                var L = Mt(t), I = L == u || L == p;
                if (Vt(t)) return function(t, e) {
                    if (e) return t.slice();
                    var _$r = new t.constructor(t.length);
                    return t.copy(_$r), _$r;
                }(t, e);
                if (L == h || L == a || I && !i) {
                    if ($(t)) return i ? t : {};
                    if (b = function(t) {
                        var _$e;
                        return "function" != typeof t.constructor || Ut(t) ? {} : Yt(_$e = ct(t)) ? st(_$e) : {};
                    }(I ? {} : t), !e) return function(t, e) {
                        return It(t, Rt(t), e);
                    }(t, function(t, e) {
                        return t && It(e, Wt(e), t);
                    }(b, t));
                } else {
                    if (!C[L]) return i ? t : {};
                    b = function(t, e, r, n) {
                        var _$o, _$i = t.constructor;
                        switch(e){
                            case x:
                                return Ct(t);
                            case c:
                            case s:
                                return new _$i(+t);
                            case w:
                                return function(t, e) {
                                    var _$r = e ? Ct(t.buffer) : t.buffer;
                                    return new t.constructor(_$r, t.byteOffset, t.byteLength);
                                }(t, n);
                            case k:
                            case S:
                            case E:
                            case O:
                            case j:
                            case F:
                            case _:
                            case P:
                            case A:
                                return function(t, e) {
                                    var _$r = e ? Ct(t.buffer) : t.buffer;
                                    return new t.constructor(_$r, t.byteOffset, t.length);
                                }(t, n);
                            case l:
                                return function(t, e, r) {
                                    return G(e ? r(Z(t), !0) : Z(t), U, new t.constructor);
                                }(t, n, r);
                            case f:
                            case v:
                                return new _$i(t);
                            case m:
                                return function(t) {
                                    var _$e = new t.constructor(t.source, T.exec(t));
                                    return _$e.lastIndex = t.lastIndex, _$e;
                                }(t);
                            case y:
                                return function(t, e, r) {
                                    return G(e ? r(H(t), !0) : H(t), q, new t.constructor);
                                }(t, n, r);
                            case _$g:
                                return _$o = t, jt ? Object(jt.call(_$o)) : {};
                        }
                    }(t, L, Lt, e);
                }
            }
            d || (d = new At);
            var z = d.get(t);
            if (z) return z;
            if (d.set(t, b), !D) var N = r ? function(t) {
                return function(t, e, r) {
                    var _$n = e(t);
                    return $t(t) ? _$n : function(t, e) {
                        for(var _$r = -1, _$n = e.length, _$o = t.length; ++_$r < _$n;)t[_$o + _$r] = e[_$r];
                        return t;
                    }(_$n, r(t));
                }(t, Wt, Rt);
            }(t) : Wt(t);
            return function(t, e) {
                for(var _$r = -1, _$n = t ? t.length : 0; ++_$r < _$n && !1 !== e(t[_$r], _$r););
            }(N || t, function(o, i) {
                N && (o = t[i = o]), Tt(b, i, Lt(o, e, r, n, i, t, d));
            }), b;
        }
        Ft.prototype.clear = function() {
            this.__data__ = bt ? bt(null) : {};
        }, Ft.prototype["delete"] = function(t) {
            return this.has(t) && delete this.__data__[t];
        }, Ft.prototype.get = function(t) {
            var _$e = this.__data__;
            if (bt) {
                var _$r = _$e[t];
                return _$r === _$o ? void 0 : _$r;
            }
            return et.call(_$e, t) ? _$e[t] : void 0;
        }, Ft.prototype.has = function(t) {
            var _$e = this.__data__;
            return bt ? void 0 !== _$e[t] : et.call(_$e, t);
        }, Ft.prototype.set = function(t, e) {
            return this.__data__[t] = bt && void 0 === e ? _$o : e, this;
        }, _t.prototype.clear = function() {
            this.__data__ = [];
        }, _t.prototype["delete"] = function(t) {
            var _$e = this.__data__, _$r = Dt(_$e, t);
            return !(_$r < 0 || (_$r == _$e.length - 1 ? _$e.pop() : pt.call(_$e, _$r, 1), 0));
        }, _t.prototype.get = function(t) {
            var _$e = this.__data__, _$r = Dt(_$e, t);
            return _$r < 0 ? void 0 : _$e[_$r][1];
        }, _t.prototype.has = function(t) {
            return Dt(this.__data__, t) > -1;
        }, _t.prototype.set = function(t, e) {
            var _$r = this.__data__, _$n = Dt(_$r, t);
            return _$n < 0 ? _$r.push([
                t,
                e
            ]) : _$r[_$n][1] = e, this;
        }, Pt.prototype.clear = function() {
            this.__data__ = {
                hash: new Ft,
                map: new (mt || _t),
                string: new Ft
            };
        }, Pt.prototype["delete"] = function(t) {
            return zt(this, t)["delete"](t);
        }, Pt.prototype.get = function(t) {
            return zt(this, t).get(t);
        }, Pt.prototype.has = function(t) {
            return zt(this, t).has(t);
        }, Pt.prototype.set = function(t, e) {
            return zt(this, t).set(t, e), this;
        }, At.prototype.clear = function() {
            this.__data__ = new _t;
        }, At.prototype["delete"] = function(t) {
            return this.__data__["delete"](t);
        }, At.prototype.get = function(t) {
            return this.__data__.get(t);
        }, At.prototype.has = function(t) {
            return this.__data__.has(t);
        }, At.prototype.set = function(t, e) {
            var _$r = this.__data__;
            if (_$r instanceof _t) {
                var _$n = _$r.__data__;
                if (!mt || _$n.length < 199) return _$n.push([
                    t,
                    e
                ]), this;
                _$r = this.__data__ = new Pt(_$n);
            }
            return _$r.set(t, e), this;
        };
        var Rt = lt ? V(lt, Object) : function Rt() {
            return [];
        }, Mt = function Mt(t) {
            return rt.call(t);
        };
        (dt && Mt(new dt(new ArrayBuffer(1))) != w || mt && Mt(new mt) != l || yt && Mt(yt.resolve()) != d || vt && Mt(new vt) != y || gt && Mt(new gt) != b) && (Mt = function Mt(t) {
            var _$e = rt.call(t), _$r = _$e == h ? t.constructor : void 0, _$n = _$r ? qt(_$r) : void 0;
            if (_$n) switch(_$n){
                case xt:
                    return w;
                case wt:
                    return l;
                case kt:
                    return d;
                case St:
                    return y;
                case Et:
                    return b;
            }
            return _$e;
        });
        var $t = Array.isArray;
        var Vt = ft || function() {
            return !1;
        };
        t.exports = function(t) {
            return Lt(t, !0, !0);
        };
    },
    428: function(t, e, r) {
        var h = function h(t) {
            var e = "string" == typeof t ? t : t.$ref;
            return "string" == typeof e && e;
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(1837), i = r(6234), a = r(1371), c = r(5605).S, s = a.ValidatorResult, u = a.ValidatorResultError, p = a.SchemaError, l = a.SchemaContext, f = function t() {
            this.customFormats = Object.create(t.prototype.customFormats), this.schemas = {}, this.unresolvedRefs = [], this.types = Object.create(d), this.attributes = Object.create(i.validators);
        };
        f.prototype.customFormats = {}, f.prototype.schemas = null, f.prototype.types = null, f.prototype.attributes = null, f.prototype.unresolvedRefs = null, f.prototype.addSchema = function(t, e) {
            var _$r = this;
            if (!t) return null;
            var n = c(e || "/", t), _$o = e || t.$id || t.id;
            for(var i in n.id)this.schemas[i] = n.id[i];
            for(var i in n.ref)this.unresolvedRefs.push(i);
            return this.unresolvedRefs = this.unresolvedRefs.filter(function(t) {
                return void 0 === _$r.schemas[t];
            }), this.schemas[_$o];
        }, f.prototype.addSubSchemaArray = function(t, e) {
            if (Array.isArray(e)) for(var _$r = 0; _$r < e.length; _$r++)this.addSubSchema(t, e[_$r]);
        }, f.prototype.addSubSchemaObject = function(t, e) {
            if (e && "object" == n(e)) for(var _$r in e)this.addSubSchema(t, e[_$r]);
        }, f.prototype.setSchemas = function(t) {
            this.schemas = t;
        }, f.prototype.getSchema = function(t) {
            return this.schemas[t];
        }, f.prototype.validate = function(t, e, r, i) {
            if ("boolean" != typeof e && "object" !== n(e) || null === e) throw new p("Expected `schema` to be an object or boolean");
            r || (r = {});
            var a, f = e.$id || e.id, h = _$o.resolve(r.base || "/", f || "");
            if (!i) {
                (i = new l(e, r, [], h, Object.create(this.schemas))).schemas[h] || (i.schemas[h] = e);
                var d = c(h, e);
                for(var m in d.id){
                    var y = d.id[m];
                    i.schemas[m] = y;
                }
            }
            if (r.required && void 0 === t) return (a = new s(t, e, r, i)).addError("is required, but is undefined"), a;
            if (!(a = this.validateSchema(t, e, r, i))) throw new Error("Result undefined");
            if (r.throwAll && a.errors.length) throw new u(a);
            return a;
        }, f.prototype.validateSchema = function(t, e, r, n) {
            var _$o = new s(t, e, r, n);
            if ("boolean" == typeof e) !0 === e ? e = {} : !1 === e && (e = {
                type: []
            });
            else if (!e) throw new Error("schema is undefined");
            if (e["extends"]) {
                if (Array.isArray(e["extends"])) {
                    var c = {
                        schema: e,
                        ctx: n
                    };
                    e["extends"].forEach(this.schemaTraverser.bind(this, c)), e = c.schema, c.schema = null, c.ctx = null, c = null;
                } else e = a.deepMerge(e, this.superResolve(e["extends"], n));
            }
            var u = h(e);
            if (u) {
                var f = this.resolve(e, u, n), d = new l(f.subschema, r, n.path, f.switchSchema, n.schemas);
                return this.validateSchema(t, f.subschema, r, d);
            }
            var m = r && r.skipAttributes || [];
            for(var y in e)if (!i.ignoreProperties[y] && m.indexOf(y) < 0) {
                var v = null, _$g = this.attributes[y];
                if (_$g) v = _$g.call(this, t, e, r, n);
                else if (!1 === r.allowUnknownAttributes) throw new p("Unsupported attribute: " + y, e);
                v && _$o.importErrors(v);
            }
            if ("function" == typeof r.rewrite) {
                var b = r.rewrite.call(this, t, e, r, n);
                _$o.instance = b;
            }
            return _$o;
        }, f.prototype.schemaTraverser = function(t, e) {
            t.schema = a.deepMerge(t.schema, this.superResolve(e, t.ctx));
        }, f.prototype.superResolve = function(t, e) {
            var _$r = h(t);
            return _$r ? this.resolve(t, _$r, e).subschema : t;
        }, f.prototype.resolve = function(t, e, r) {
            if (e = r.resolve(e), r.schemas[e]) return {
                subschema: r.schemas[e],
                switchSchema: e
            };
            var n = _$o.parse(e), i = n && n.hash, c = i && i.length && e.substr(0, e.length - i.length);
            if (!c || !r.schemas[c]) throw new p("no such schema <" + e + ">", t);
            var s = a.objectGetPath(r.schemas[c], i.substr(1));
            if (void 0 === s) throw new p("no such schema " + i + " located in <" + c + ">", t);
            return {
                subschema: s,
                switchSchema: e
            };
        }, f.prototype.testType = function(t, e, r, o, i) {
            if (void 0 !== i) {
                if (null === i) throw new p('Unexpected null in "type" keyword');
                if ("function" == typeof this.types[i]) return this.types[i].call(this, t);
                if (i && "object" == n(i)) {
                    var a = this.validateSchema(t, i, r, o);
                    return void 0 === a || !(a && a.errors.length);
                }
                return !0;
            }
        };
        var d = f.prototype.types = {};
        d.string = function(t) {
            return "string" == typeof t;
        }, d.number = function(t) {
            return "number" == typeof t && isFinite(t);
        }, d.integer = function(t) {
            return "number" == typeof t && t % 1 == 0;
        }, d["boolean"] = function(t) {
            return "boolean" == typeof t;
        }, d.array = function(t) {
            return Array.isArray(t);
        }, d["null"] = function(t) {
            return null === t;
        }, d.date = function(t) {
            return t instanceof Date;
        }, d.any = function(t) {
            return !0;
        }, d.object = function(t) {
            return t && "object" === n(t) && !Array.isArray(t) && !(t instanceof Date);
        }, t.exports = f;
    },
    830: function(t, e, r) {
        var f = function f(t, e) {
            for(var _$r = [], n = e.exec(t); n;){
                var _$o = [];
                _$o.startIndex = e.lastIndex - n[0].length;
                for(var i = n.length, a = 0; a < i; a++)_$o.push(n[a]);
                _$r.push(_$o), n = e.exec(t);
            }
            return _$r;
        };
        var m = function m(t, e) {
            e = Object.assign({}, d, e);
            var _$r = [], n = !1, _$o = !1;
            "\ufeff" === t[0] && (t = t.substr(1));
            for(var i = 0; i < t.length; i++)if ("<" === t[i] && "?" === t[i + 1]) {
                if ((i = v(t, i += 2)).err) return i;
            } else {
                if ("<" !== t[i]) {
                    if (y(t[i])) continue;
                    return O("InvalidChar", "char '" + t[i] + "' is not expected.", F(t, i));
                }
                var a = i;
                if ("!" === t[++i]) {
                    i = _$g(t, i);
                    continue;
                }
                var c = !1;
                "/" === t[i] && (c = !0, i++);
                for(var s = ""; i < t.length && ">" !== t[i] && " " !== t[i] && "\t" !== t[i] && "\n" !== t[i] && "\r" !== t[i]; i++)s += t[i];
                if ("/" === (s = s.trim())[s.length - 1] && (s = s.substring(0, s.length - 1), i--), !h(s)) return O("InvalidTag", 0 === s.trim().length ? "Invalid space after '<'." : "Tag '" + s + "' is an invalid name.", F(t, i));
                var u = w(t, i);
                if (!1 === u) return O("InvalidAttr", "Attributes for '" + s + "' have open quote.", F(t, i));
                var p = u.value;
                if (i = u.index, "/" === p[p.length - 1]) {
                    var l = i - p.length, f = S(p = p.substring(0, p.length - 1), e);
                    if (!0 !== f) return O(f.err.code, f.err.msg, F(t, l + f.err.line));
                    n = !0;
                } else if (c) {
                    if (!u.tagClosed) return O("InvalidTag", "Closing tag '" + s + "' doesn't have proper closing.", F(t, i));
                    if (p.trim().length > 0) return O("InvalidTag", "Closing tag '" + s + "' can't have attributes or invalid starting.", F(t, a));
                    if (0 === _$r.length) return O("InvalidTag", "Closing tag '" + s + "' has not been opened.", F(t, a));
                    var m = _$r.pop();
                    if (s !== m.tagName) {
                        var b = F(t, m.tagStartPos);
                        return O("InvalidTag", "Expected closing tag '" + m.tagName + "' (opened in line " + b.line + ", col " + b.col + ") instead of closing tag '" + s + "'.", F(t, a));
                    }
                    0 == _$r.length && (_$o = !0);
                } else {
                    var x = S(p, e);
                    if (!0 !== x) return O(x.err.code, x.err.msg, F(t, i - p.length + x.err.line));
                    if (!0 === _$o) return O("InvalidXml", "Multiple possible root nodes found.", F(t, i));
                    -1 !== e.unpairedTags.indexOf(s) || _$r.push({
                        tagName: s,
                        tagStartPos: a
                    }), n = !0;
                }
                for(i++; i < t.length; i++)if ("<" === t[i]) {
                    if ("!" === t[i + 1]) {
                        i = _$g(t, ++i);
                        continue;
                    }
                    if ("?" !== t[i + 1]) break;
                    if ((i = v(t, ++i)).err) return i;
                } else if ("&" === t[i]) {
                    var k = E(t, i);
                    if (-1 == k) return O("InvalidChar", "char '&' is not expected.", F(t, i));
                    i = k;
                } else if (!0 === _$o && !y(t[i])) return O("InvalidXml", "Extra text at the end", F(t, i));
                "<" === t[i] && i--;
            }
            return n ? 1 == _$r.length ? O("InvalidTag", "Unclosed tag '" + _$r[0].tagName + "'.", F(t, _$r[0].tagStartPos)) : !(_$r.length > 0) || O("InvalidXml", "Invalid '" + JSON.stringify(_$r.map(function(t) {
                return t.tagName;
            }), null, 4).replace(/\r?\n/g, "") + "' found.", {
                line: 1,
                col: 1
            }) : O("InvalidXml", "Start tag expected.", 1);
        };
        var y = function y(t) {
            return " " === t || "\t" === t || "\n" === t || "\r" === t;
        };
        var v = function v(t, e) {
            for(var _$r = e; e < t.length; e++)if ("?" != t[e] && " " != t[e]) ;
            else {
                var n = t.substr(_$r, e - _$r);
                if (e > 5 && "xml" === n) return O("InvalidXml", "XML declaration allowed only at the start of the document.", F(t, e));
                if ("?" == t[e] && ">" == t[e + 1]) {
                    e++;
                    break;
                }
            }
            return e;
        };
        var _$g = function _$g(t, e) {
            if (t.length > e + 5 && "-" === t[e + 1] && "-" === t[e + 2]) {
                for(e += 3; e < t.length; e++)if ("-" === t[e] && "-" === t[e + 1] && ">" === t[e + 2]) {
                    e += 2;
                    break;
                }
            } else if (t.length > e + 8 && "D" === t[e + 1] && "O" === t[e + 2] && "C" === t[e + 3] && "T" === t[e + 4] && "Y" === t[e + 5] && "P" === t[e + 6] && "E" === t[e + 7]) {
                var _$r = 1;
                for(e += 8; e < t.length; e++)if ("<" === t[e]) _$r++;
                else if (">" === t[e] && 0 == --_$r) break;
            } else if (t.length > e + 9 && "[" === t[e + 1] && "C" === t[e + 2] && "D" === t[e + 3] && "A" === t[e + 4] && "T" === t[e + 5] && "A" === t[e + 6] && "[" === t[e + 7]) {
                for(e += 8; e < t.length; e++)if ("]" === t[e] && "]" === t[e + 1] && ">" === t[e + 2]) {
                    e += 2;
                    break;
                }
            }
            return e;
        };
        var w = function w(t, e) {
            for(var _$r = "", n = "", _$o = !1; e < t.length; e++){
                if (t[e] === b || t[e] === x) "" === n ? n = t[e] : n !== t[e] || (n = "");
                else if (">" === t[e] && "" === n) {
                    _$o = !0;
                    break;
                }
                _$r += t[e];
            }
            return "" === n && {
                value: _$r,
                index: e,
                tagClosed: _$o
            };
        };
        var S = function S(t, e) {
            for(var _$r = f(t, k), n = {}, _$o = 0; _$o < _$r.length; _$o++){
                if (0 === _$r[_$o][1].length) return O("InvalidAttr", "Attribute '" + _$r[_$o][2] + "' has no space in starting.", _(_$r[_$o]));
                if (void 0 !== _$r[_$o][3] && void 0 === _$r[_$o][4]) return O("InvalidAttr", "Attribute '" + _$r[_$o][2] + "' is without value.", _(_$r[_$o]));
                if (void 0 === _$r[_$o][3] && !e.allowBooleanAttributes) return O("InvalidAttr", "boolean attribute '" + _$r[_$o][2] + "' is not allowed.", _(_$r[_$o]));
                var i = _$r[_$o][2];
                if (!j(i)) return O("InvalidAttr", "Attribute '" + i + "' is an invalid name.", _(_$r[_$o]));
                if (n.hasOwnProperty(i)) return O("InvalidAttr", "Attribute '" + i + "' is repeated.", _(_$r[_$o]));
                n[i] = 1;
            }
            return !0;
        };
        var E = function E(t, e) {
            if (";" === t[++e]) return -1;
            if ("#" === t[e]) return function(t, e) {
                var _$r = /\d/;
                for("x" === t[e] && (e++, _$r = /[\da-fA-F]/); e < t.length; e++){
                    if (";" === t[e]) return e;
                    if (!t[e].match(_$r)) break;
                }
                return -1;
            }(t, ++e);
            for(var _$r = 0; e < t.length; e++, _$r++)if (!(t[e].match(/\w/) && _$r < 20)) {
                if (";" === t[e]) break;
                return -1;
            }
            return e;
        };
        var O = function O(t, e, r) {
            return {
                err: {
                    code: t,
                    msg: e,
                    line: r.line || r,
                    col: r.col
                }
            };
        };
        var j = function j(t) {
            return h(t);
        };
        var F = function F(t, e) {
            var _$r = t.substring(0, e).split(/\r?\n/);
            return {
                line: _$r.length,
                col: _$r[_$r.length - 1].length + 1
            };
        };
        var _ = function _(t) {
            return t.startIndex + t[1].length;
        };
        var z = function z(t, e, r) {
            return (e = R(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        };
        var N = function N(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, R(n.key), n);
            }
        };
        var R = function R(t) {
            var _$e = function(t) {
                if ("object" != I(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != I(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == I(_$e) ? _$e : String(_$e);
        };
        var U = function U(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var _$r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != _$r) {
                    var n, _$o, i, a, c = [], s = !0, u = !1;
                    try {
                        if (i = (_$r = _$r.call(t)).next, 0 === e) {
                            if (Object(_$r) !== _$r) return;
                            s = !1;
                        } else for(; !(s = (n = i.call(_$r)).done) && (c.push(n.value), c.length !== e); s = !0);
                    } catch (t) {
                        u = !0, _$o = t;
                    } finally{
                        try {
                            if (!s && null != _$r["return"] && (a = _$r["return"](), Object(a) !== a)) return;
                        } finally{
                            if (u) throw _$o;
                        }
                    }
                    return c;
                }
            }(t, e) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return q(t, e);
                    var _$r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? q(t, e) : void 0;
                }
            }(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var q = function q(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var G = function G(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, $(n.key), n);
            }
        };
        var $ = function $(t) {
            var _$e = function(t) {
                if ("object" != B(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != B(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == B(_$e) ? _$e : String(_$e);
        };
        var H = function H(t, e, r) {
            for(var n = 0; n < e.length; n++)if (e[n] !== t[r + n + 1]) return !1;
            return !0;
        };
        var Y = function Y(t) {
            if (h(t)) return t;
            throw new Error("Invalid entity name ".concat(t));
        };
        var X = function X(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var tt = function tt(t, e, r) {
            return (e = ot(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        };
        var rt = function rt(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, ot(n.key), n);
            }
        };
        var nt = function nt(t, e, r) {
            return e && rt(t.prototype, e), r && rt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        };
        var ot = function ot(t) {
            var _$e = function(t) {
                if ("object" != et(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != et(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == et(_$e) ? _$e : String(_$e);
        };
        var at = function at(t) {
            for(var _$e = Object.keys(t), _$r = 0; _$r < _$e.length; _$r++){
                var n = _$e[_$r], _$o = n.replace(/[.\-+*:]/g, "\\.");
                this.lastEntities[n] = {
                    regex: new RegExp("&" + _$o + ";", "g"),
                    val: t[n]
                };
            }
        };
        var ct = function ct(t, e, r, n, o, i, a) {
            if (void 0 !== t && (this.options.trimValues && !n && (t = t.trim()), t.length > 0)) {
                a || (t = this.replaceEntitiesValue(t, e, r));
                var c = this.options.tagValueProcessor(e, t, r, o, i);
                return null == c ? t : et(c) !== et(t) || c !== t ? c : this.options.trimValues || t.trim() === t ? bt(t, this.options.parseTagValue, this.options.numberParseOptions) : t;
            }
        };
        var st = function st(t) {
            if (this.options.removeNSPrefix) {
                var _$e = t.split(":"), _$r = "/" === t.charAt(0) ? "/" : "";
                if ("xmlns" === _$e[0]) return "";
                2 === _$e.length && (t = _$r + _$e[1]);
            }
            return t;
        };
        var pt = function pt(t, e, r) {
            if (!0 !== this.options.ignoreAttributes && "string" == typeof t) {
                for(var n = f(t, ut), _$o = n.length, i = {}, a = 0; a < _$o; a++){
                    var c = this.resolveNameSpace(n[a][1]);
                    if (!this.ignoreAttributesFn(c, e)) {
                        var s = n[a][4], u = this.options.attributeNamePrefix + c;
                        if (c.length) {
                            if (this.options.transformAttributeName && (u = this.options.transformAttributeName(u)), "__proto__" === u && (u = "#__proto__"), void 0 !== s) {
                                this.options.trimValues && (s = s.trim()), s = this.replaceEntitiesValue(s, r, e);
                                var p = this.options.attributeValueProcessor(c, s, e);
                                null == p ? i[u] = s : et(p) !== et(s) || p !== s ? i[u] = p : i[u] = bt(s, this.options.parseAttributeValue, this.options.numberParseOptions);
                            } else this.options.allowBooleanAttributes && (i[u] = !0);
                        }
                    }
                }
                if (!Object.keys(i).length) return;
                if (this.options.attributesGroupName) {
                    var l = {};
                    return l[this.options.attributesGroupName] = i, l;
                }
                return i;
            }
        };
        var ft = function ft(t, e, r, n) {
            this.options.captureMetaData || (n = void 0);
            var _$o = this.options.updateTag(e.tagname, r, e[":@"]);
            !1 === _$o || ("string" == typeof _$o ? (e.tagname = _$o, t.addChild(e, n)) : t.addChild(e, n));
        };
        var dt = function dt(t, e, r, n) {
            return t && (void 0 === n && (n = 0 === e.child.length), void 0 !== (t = this.parseTextData(t, e.tagname, r, !1, !!e[":@"] && 0 !== Object.keys(e[":@"]).length, n)) && "" !== t && e.add(this.options.textNodeName, t), t = ""), t;
        };
        var mt = function mt(t, e, r, n) {
            return !(!e || !e.has(n)) || !(!t || !t.has(r));
        };
        var yt = function yt(t, e, r, n) {
            var _$o = t.indexOf(e, r);
            if (-1 === _$o) throw new Error(n);
            return _$o + e.length - 1;
        };
        var vt = function vt(t, e, r) {
            var n = function(t, e) {
                for(var _$r, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ">", _$o = "", i = e; i < t.length; i++){
                    var a = t[i];
                    if (_$r) a === _$r && (_$r = "");
                    else if ('"' === a || "'" === a) _$r = a;
                    else if (a === n[0]) {
                        if (!n[1]) return {
                            data: _$o,
                            index: i
                        };
                        if (t[i + 1] === n[1]) return {
                            data: _$o,
                            index: i
                        };
                    } else "\t" === a && (a = " ");
                    _$o += a;
                }
            }(t, e + 1, arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ">");
            if (n) {
                var _$o = n.data, i = n.index, a = _$o.search(/\s/), c = _$o, s = !0;
                -1 !== a && (c = _$o.substring(0, a), _$o = _$o.substring(a + 1).trimStart());
                var u = c;
                if (r) {
                    var p = c.indexOf(":");
                    -1 !== p && (s = (c = c.substr(p + 1)) !== n.data.substr(p + 1));
                }
                return {
                    tagName: c,
                    tagExp: _$o,
                    closeIndex: i,
                    attrExpPresent: s,
                    rawTagName: u
                };
            }
        };
        var gt = function gt(t, e, r) {
            for(var n = r, _$o = 1; r < t.length; r++)if ("<" === t[r]) {
                if ("/" === t[r + 1]) {
                    var i = yt(t, ">", r, "".concat(e, " is not closed"));
                    if (t.substring(r + 2, i).trim() === e && 0 == --_$o) return {
                        tagContent: t.substring(n, r),
                        i: i
                    };
                    r = i;
                } else if ("?" === t[r + 1]) r = yt(t, "?>", r + 1, "StopNode is not closed.");
                else if ("!--" === t.substr(r + 1, 3)) r = yt(t, "--\x3e", r + 3, "StopNode is not closed.");
                else if ("![" === t.substr(r + 1, 2)) r = yt(t, "]]>", r, "StopNode is not closed.") - 2;
                else {
                    var a = vt(t, r, ">");
                    a && ((a && a.tagName) === e && "/" !== a.tagExp[a.tagExp.length - 1] && _$o++, r = a.closeIndex);
                }
            }
        };
        var bt = function bt(t, e, r) {
            if (e && "string" == typeof t) {
                var n = t.trim();
                return "true" === n || "false" !== n && function(t) {
                    var _$e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (_$e = Object.assign({}, Q, _$e), !t || "string" != typeof t) return t;
                    var _$r = t.trim();
                    if (void 0 !== _$e.skipLike && _$e.skipLike.test(_$r)) return t;
                    if ("0" === t) return 0;
                    if (_$e.hex && W.test(_$r)) return function(t) {
                        if (parseInt) return parseInt(t, 16);
                        if (Number.parseInt) return Number.parseInt(t, 16);
                        if (window && window.parseInt) return window.parseInt(t, 16);
                        throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
                    }(_$r);
                    if (_$r.includes("e") || _$r.includes("E")) return function(t, e, r) {
                        if (!r.eNotation) return t;
                        var n = e.match(J);
                        if (n) {
                            var _$o = n[1] || "", i = -1 === n[3].indexOf("e") ? "E" : "e", a = n[2], c = _$o ? t[a.length + 1] === i : t[a.length] === i;
                            return a.length > 1 && c ? t : 1 !== a.length || !n[3].startsWith(".".concat(i)) && n[3][0] !== i ? r.leadingZeros && !c ? (e = (n[1] || "") + n[3], Number(e)) : t : Number(e);
                        }
                        return t;
                    }(t, _$r, _$e);
                    var n, _$o = K.exec(_$r);
                    if (_$o) {
                        var i = _$o[1] || "", a = _$o[2], c = (n = _$o[3]) && -1 !== n.indexOf(".") ? ("." === (n = n.replace(/0+$/, "")) ? n = "0" : "." === n[0] ? n = "0" + n : "." === n[n.length - 1] && (n = n.substring(0, n.length - 1)), n) : n, s = i ? "." === t[a.length + 1] : "." === t[a.length];
                        if (!_$e.leadingZeros && (a.length > 1 || 1 === a.length && !s)) return t;
                        var u = Number(_$r), p = String(u);
                        if (0 === u) return u;
                        if (-1 !== p.search(/[eE]/)) return _$e.eNotation ? u : t;
                        if (-1 !== _$r.indexOf(".")) return "0" === p || p === c || p === "".concat(i).concat(c) ? u : t;
                        var l = a ? c : _$r;
                        return a ? l === p || i + l === p ? u : t : l === p || l === i + p ? u : t;
                    }
                    return t;
                }(t, r);
            }
            return function(t) {
                return void 0 !== t;
            }(t) ? t : "";
        };
        var xt = function xt(t, e, r) {
            var n = Number.parseInt(t, e);
            return n >= 0 && n <= 1114111 ? String.fromCodePoint(n) : r + t + ";";
        };
        var kt = function kt(t, e) {
            return St(t, e);
        };
        var Et = function Et(t) {
            for(var _$e = Object.keys(t), _$r = 0; _$r < _$e.length; _$r++){
                var n = _$e[_$r];
                if (":@" !== n) return n;
            }
        };
        var Ot = function Ot(t, e, r, n) {
            if (e) for(var _$o = Object.keys(e), i = _$o.length, a = 0; a < i; a++){
                var c = _$o[a];
                n.isArray(c, r + "." + c, !0, !0) ? t[c] = [
                    e[c]
                ] : t[c] = e[c];
            }
        };
        var jt = function jt(t, e) {
            var _$r = e.textNodeName, n = Object.keys(t).length;
            return 0 === n || !(1 !== n || !t[_$r] && "boolean" != typeof t[_$r] && 0 !== t[_$r]);
        };
        var _t = function _t(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Pt(n.key), n);
            }
        };
        var Pt = function Pt(t) {
            var _$e = function(t) {
                if ("object" != Ft(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != Ft(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == Ft(_$e) ? _$e : String(_$e);
        };
        r.d(e, {
            D6: function() {
                return zt;
            },
            qg: function() {
                return i;
            },
            xp: function() {
                return It;
            },
            cN: function() {
                return Lt;
            },
            Sc: function() {
                return Rt.S;
            }
        });
        var n = r(3186), _$o = [
            "expires",
            "from",
            "host",
            "if-modified-since",
            "if-unmodified-since",
            "age",
            "authorization",
            "content-length",
            "content-type",
            "etag",
            "last-modified",
            "location",
            "max-forwards",
            "proxy-authorization",
            "referer",
            "retry-after",
            "user-agent"
        ], i = function i(t) {
            var _$e, _$r, i, a = {};
            return t ? (t.split("\n").forEach(function(t) {
                i = t.indexOf(":"), _$e = (0, n.Bq)(t.substr(0, i)).toLowerCase(), _$r = (0, n.Bq)(t.substr(i + 1)), _$e && (a[_$e] && _$o.indexOf(_$e) >= 0 || (a[_$e] = "set-cookie" === _$e ? (a[_$e] ? a[_$e] : []).concat([
                    _$r
                ]) : a[_$e] ? a[_$e] + ", " + _$r : _$r));
            }), a) : a;
        }, a = function a(t, e, r, n) {
            void 0 === n && (n = !1);
            var _$o = c(e);
            return t || (t = {}), void 0 === (t = JSON.parse(JSON.stringify(t)))[e] && void 0 === t[_$o] ? t[_$o] = r : n && (delete t[e], t[_$o] = r), t;
        }, c = function c(t) {
            return ({
                "content-md5": "Content-MD5",
                dnt: "DNT",
                etag: "ETag",
                "last-event-id": "Last-Event-ID",
                tcn: "TCN",
                te: "TE",
                "www-authenticate": "WWW-Authenticate",
                "x-dnsprefetch-control": "X-DNSPrefetch-Control"
            })[t.toLowerCase()] || t.split("-").map(function(t) {
                return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
            }).join("-");
        }, s = r(1635), u = r(6947), p = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", l = new RegExp("^[" + p + "][" + p + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$");
        var h = function h(t) {
            return !(null == l.exec(t));
        }, d = {
            allowBooleanAttributes: !1,
            unpairedTags: []
        };
        var b = '"', x = "'";
        var k = new RegExp("(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['\"])(([\\s\\S])*?)\\5)?", "g");
        var P = {
            validate: m
        };
        function A(t) {
            return A = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function A(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, A(t);
        }
        var T = {
            preserveOrder: !1,
            attributeNamePrefix: "@_",
            attributesGroupName: !1,
            textNodeName: "#text",
            ignoreAttributes: !0,
            removeNSPrefix: !1,
            allowBooleanAttributes: !1,
            parseTagValue: !0,
            parseAttributeValue: !1,
            trimValues: !0,
            cdataPropName: !1,
            numberParseOptions: {
                hex: !0,
                leadingZeros: !0,
                eNotation: !0
            },
            tagValueProcessor: function tagValueProcessor(t, e) {
                return e;
            },
            attributeValueProcessor: function attributeValueProcessor(t, e) {
                return e;
            },
            stopNodes: [],
            alwaysCreateTextNode: !1,
            isArray: function isArray() {
                return !1;
            },
            commentPropName: !1,
            unpairedTags: [],
            processEntities: !0,
            htmlEntities: !1,
            ignoreDeclaration: !1,
            ignorePiTags: !1,
            transformTagName: !1,
            transformAttributeName: !1,
            updateTag: function updateTag(t, e, r) {
                return t;
            },
            captureMetaData: !1
        };
        function D(t) {
            var _$e, _$r, n, _$o, i, a;
            return "boolean" == typeof t ? {
                enabled: t,
                maxEntitySize: 1e4,
                maxExpansionDepth: 10,
                maxTotalExpansions: 1e3,
                maxExpandedLength: 1e5,
                allowedTags: null,
                tagFilter: null
            } : "object" === A(t) && null !== t ? {
                enabled: !1 !== t.enabled,
                maxEntitySize: null !== (_$e = t.maxEntitySize) && void 0 !== _$e ? _$e : 1e4,
                maxExpansionDepth: null !== (_$r = t.maxExpansionDepth) && void 0 !== _$r ? _$r : 10,
                maxTotalExpansions: null !== (n = t.maxTotalExpansions) && void 0 !== n ? n : 1e3,
                maxExpandedLength: null !== (_$o = t.maxExpandedLength) && void 0 !== _$o ? _$o : 1e5,
                allowedTags: null !== (i = t.allowedTags) && void 0 !== i ? i : null,
                tagFilter: null !== (a = t.tagFilter) && void 0 !== a ? a : null
            } : D(!0);
        }
        var L, C = function C(t) {
            var _$e = Object.assign({}, T, t);
            return _$e.processEntities = D(_$e.processEntities), _$e;
        };
        function I(t) {
            return I = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function I(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, I(t);
        }
        L = "function" != typeof Symbol ? "@@xmlMetadata" : Symbol("XML Node Metadata");
        var M = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.tagname = e, this.child = [], this[":@"] = {};
            }
            var _$e, _$r, n;
            return _$e = t, n = [
                {
                    key: "getMetaDataSymbol",
                    value: function value() {
                        return L;
                    }
                }
            ], _$r = [
                {
                    key: "add",
                    value: function value(t, e) {
                        "__proto__" === t && (t = "#__proto__"), this.child.push(z({}, t, e));
                    }
                },
                {
                    key: "addChild",
                    value: function value(t, e) {
                        "__proto__" === t.tagname && (t.tagname = "#__proto__"), t[":@"] && Object.keys(t[":@"]).length > 0 ? this.child.push(z(z({}, t.tagname, t.child), ":@", t[":@"])) : this.child.push(z({}, t.tagname, t.child)), void 0 !== e && (this.child[this.child.length - 1][L] = {
                            startIndex: e
                        });
                    }
                }
            ], N(_$e.prototype, _$r), n && N(_$e, n), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        function B(t) {
            return B = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function B(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, B(t);
        }
        var Z = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.suppressValidationErr = !e, this.options = e;
            }
            var _$e, _$r;
            return _$e = t, _$r = [
                {
                    key: "readDocType",
                    value: function value(t, e) {
                        var _$r = {};
                        if ("O" !== t[e + 3] || "C" !== t[e + 4] || "T" !== t[e + 5] || "Y" !== t[e + 6] || "P" !== t[e + 7] || "E" !== t[e + 8]) throw new Error("Invalid Tag instead of DOCTYPE");
                        e += 9;
                        for(var n = 1, _$o = !1, i = !1; e < t.length; e++)if ("<" !== t[e] || i) {
                            if (">" === t[e]) {
                                if (i ? "-" === t[e - 1] && "-" === t[e - 2] && (i = !1, n--) : n--, 0 === n) break;
                            } else "[" === t[e] ? _$o = !0 : t[e];
                        } else {
                            if (_$o && H(t, "!ENTITY", e)) {
                                e += 7;
                                var a = void 0, c = void 0, s = U(this.readEntityExp(t, e + 1, this.suppressValidationErr), 3);
                                if (a = s[0], c = s[1], e = s[2], -1 === c.indexOf("&")) {
                                    var u = a.replace(/[.\-+*:]/g, "\\.");
                                    _$r[a] = {
                                        regx: RegExp("&".concat(u, ";"), "g"),
                                        val: c
                                    };
                                }
                            } else if (_$o && H(t, "!ELEMENT", e)) e += 8, e = this.readElementExp(t, e + 1).index;
                            else if (_$o && H(t, "!ATTLIST", e)) e += 8;
                            else if (_$o && H(t, "!NOTATION", e)) e += 9, e = this.readNotationExp(t, e + 1, this.suppressValidationErr).index;
                            else {
                                if (!H(t, "!--", e)) throw new Error("Invalid DOCTYPE");
                                i = !0;
                            }
                            n++;
                        }
                        if (0 !== n) throw new Error("Unclosed DOCTYPE");
                        return {
                            entities: _$r,
                            i: e
                        };
                    }
                },
                {
                    key: "readEntityExp",
                    value: function value(t, e) {
                        e = V(t, e);
                        for(var _$r = ""; e < t.length && !/\s/.test(t[e]) && '"' !== t[e] && "'" !== t[e];)_$r += t[e], e++;
                        if (Y(_$r), e = V(t, e), !this.suppressValidationErr) {
                            if ("SYSTEM" === t.substring(e, e + 6).toUpperCase()) throw new Error("External entities are not supported");
                            if ("%" === t[e]) throw new Error("Parameter entities are not supported");
                        }
                        var n, _$o = U(this.readIdentifierVal(t, e, "entity"), 2);
                        if (e = _$o[0], n = _$o[1], !1 !== this.options.enabled && this.options.maxEntitySize && n.length > this.options.maxEntitySize) throw new Error('Entity "'.concat(_$r, '" size (').concat(n.length, ") exceeds maximum allowed size (").concat(this.options.maxEntitySize, ")"));
                        return [
                            _$r,
                            n,
                            --e
                        ];
                    }
                },
                {
                    key: "readNotationExp",
                    value: function value(t, e) {
                        e = V(t, e);
                        for(var _$r = ""; e < t.length && !/\s/.test(t[e]);)_$r += t[e], e++;
                        !this.suppressValidationErr && Y(_$r), e = V(t, e);
                        var n = t.substring(e, e + 6).toUpperCase();
                        if (!this.suppressValidationErr && "SYSTEM" !== n && "PUBLIC" !== n) throw new Error('Expected SYSTEM or PUBLIC, found "'.concat(n, '"'));
                        e += n.length, e = V(t, e);
                        var _$o = null, i = null;
                        if ("PUBLIC" === n) {
                            var a = U(this.readIdentifierVal(t, e, "publicIdentifier"), 2);
                            if (e = a[0], _$o = a[1], '"' === t[e = V(t, e)] || "'" === t[e]) {
                                var c = U(this.readIdentifierVal(t, e, "systemIdentifier"), 2);
                                e = c[0], i = c[1];
                            }
                        } else if ("SYSTEM" === n) {
                            var s = U(this.readIdentifierVal(t, e, "systemIdentifier"), 2);
                            if (e = s[0], i = s[1], !this.suppressValidationErr && !i) throw new Error("Missing mandatory system identifier for SYSTEM notation");
                        }
                        return {
                            notationName: _$r,
                            publicIdentifier: _$o,
                            systemIdentifier: i,
                            index: --e
                        };
                    }
                },
                {
                    key: "readIdentifierVal",
                    value: function value(t, e, r) {
                        var n = "", _$o = t[e];
                        if ('"' !== _$o && "'" !== _$o) throw new Error('Expected quoted string, found "'.concat(_$o, '"'));
                        for(e++; e < t.length && t[e] !== _$o;)n += t[e], e++;
                        if (t[e] !== _$o) throw new Error("Unterminated ".concat(r, " value"));
                        return [
                            ++e,
                            n
                        ];
                    }
                },
                {
                    key: "readElementExp",
                    value: function value(t, e) {
                        e = V(t, e);
                        for(var _$r = ""; e < t.length && !/\s/.test(t[e]);)_$r += t[e], e++;
                        if (!this.suppressValidationErr && !h(_$r)) throw new Error('Invalid element name: "'.concat(_$r, '"'));
                        var n = "";
                        if ("E" === t[e = V(t, e)] && H(t, "MPTY", e)) e += 4;
                        else if ("A" === t[e] && H(t, "NY", e)) e += 2;
                        else if ("(" === t[e]) {
                            for(e++; e < t.length && ")" !== t[e];)n += t[e], e++;
                            if (")" !== t[e]) throw new Error("Unterminated content model");
                        } else if (!this.suppressValidationErr) throw new Error('Invalid Element Expression, found "'.concat(t[e], '"'));
                        return {
                            elementName: _$r,
                            contentModel: n.trim(),
                            index: e
                        };
                    }
                },
                {
                    key: "readAttlistExp",
                    value: function value(t, e) {
                        e = V(t, e);
                        for(var _$r = ""; e < t.length && !/\s/.test(t[e]);)_$r += t[e], e++;
                        Y(_$r), e = V(t, e);
                        for(var n = ""; e < t.length && !/\s/.test(t[e]);)n += t[e], e++;
                        if (!Y(n)) throw new Error('Invalid attribute name: "'.concat(n, '"'));
                        e = V(t, e);
                        var _$o = "";
                        if ("NOTATION" === t.substring(e, e + 8).toUpperCase()) {
                            if (_$o = "NOTATION", "(" !== t[e = V(t, e += 8)]) throw new Error("Expected '(', found \"".concat(t[e], '"'));
                            e++;
                            for(var i = []; e < t.length && ")" !== t[e];){
                                for(var a = ""; e < t.length && "|" !== t[e] && ")" !== t[e];)a += t[e], e++;
                                if (!Y(a = a.trim())) throw new Error('Invalid notation name: "'.concat(a, '"'));
                                i.push(a), "|" === t[e] && (e++, e = V(t, e));
                            }
                            if (")" !== t[e]) throw new Error("Unterminated list of notations");
                            e++, _$o += " (" + i.join("|") + ")";
                        } else {
                            for(; e < t.length && !/\s/.test(t[e]);)_$o += t[e], e++;
                            if (!this.suppressValidationErr && ![
                                "CDATA",
                                "ID",
                                "IDREF",
                                "IDREFS",
                                "ENTITY",
                                "ENTITIES",
                                "NMTOKEN",
                                "NMTOKENS"
                            ].includes(_$o.toUpperCase())) throw new Error('Invalid attribute type: "'.concat(_$o, '"'));
                        }
                        e = V(t, e);
                        var c = "";
                        if ("#REQUIRED" === t.substring(e, e + 8).toUpperCase()) c = "#REQUIRED", e += 8;
                        else if ("#IMPLIED" === t.substring(e, e + 7).toUpperCase()) c = "#IMPLIED", e += 7;
                        else {
                            var s = U(this.readIdentifierVal(t, e, "ATTLIST"), 2);
                            e = s[0], c = s[1];
                        }
                        return {
                            elementName: _$r,
                            attributeName: n,
                            attributeType: _$o,
                            defaultValue: c,
                            index: e
                        };
                    }
                }
            ], G(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }(), V = function V(t, e) {
            for(; e < t.length && /\s/.test(t[e]);)e++;
            return e;
        };
        var W = /^[-+]?0x[a-fA-F0-9]+$/, K = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/, Q = {
            hex: !0,
            leadingZeros: !0,
            decimalPoint: ".",
            eNotation: !0
        };
        var J = /^([-+])?(0*)(\d*(\.\d*)?[eE][-\+]?\d+)$/;
        function et(t) {
            return et = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function et(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, et(t);
        }
        var it = nt(function t(e) {
            var _$r;
            if (function(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.options = e, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = {
                apos: {
                    regex: /&(apos|#39|#x27);/g,
                    val: "'"
                },
                gt: {
                    regex: /&(gt|#62|#x3E);/g,
                    val: ">"
                },
                lt: {
                    regex: /&(lt|#60|#x3C);/g,
                    val: "<"
                },
                quot: {
                    regex: /&(quot|#34|#x22);/g,
                    val: '"'
                }
            }, this.ampEntity = {
                regex: /&(amp|#38|#x26);/g,
                val: "&"
            }, this.htmlEntities = {
                space: {
                    regex: /&(nbsp|#160);/g,
                    val: " "
                },
                cent: {
                    regex: /&(cent|#162);/g,
                    val: "\xa2"
                },
                pound: {
                    regex: /&(pound|#163);/g,
                    val: "\xa3"
                },
                yen: {
                    regex: /&(yen|#165);/g,
                    val: "\xa5"
                },
                euro: {
                    regex: /&(euro|#8364);/g,
                    val: "\u20AC"
                },
                copyright: {
                    regex: /&(copy|#169);/g,
                    val: "\xa9"
                },
                reg: {
                    regex: /&(reg|#174);/g,
                    val: "\xae"
                },
                inr: {
                    regex: /&(inr|#8377);/g,
                    val: "\u20B9"
                },
                num_dec: {
                    regex: /&#([0-9]{1,7});/g,
                    val: function val(t, e) {
                        return xt(e, 10, "&#");
                    }
                },
                num_hex: {
                    regex: /&#x([0-9a-fA-F]{1,6});/g,
                    val: function val(t, e) {
                        return xt(e, 16, "&#x");
                    }
                }
            }, this.addExternalEntities = at, this.parseXml = lt, this.parseTextData = ct, this.resolveNameSpace = st, this.buildAttributesMap = pt, this.isItStopNode = mt, this.replaceEntitiesValue = ht, this.readStopNodeData = gt, this.saveTextToParentTag = dt, this.addChild = ft, this.ignoreAttributesFn = "function" == typeof (_$r = this.options.ignoreAttributes) ? _$r : Array.isArray(_$r) ? function(t) {
                var _$e, n = function(t, e) {
                    var _$r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (!_$r) {
                        if (Array.isArray(t) || (_$r = function(t, e) {
                            if (t) {
                                if ("string" == typeof t) return X(t, e);
                                var _$r = Object.prototype.toString.call(t).slice(8, -1);
                                return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? X(t, e) : void 0;
                            }
                        }(t)) || e && t && "number" == typeof t.length) {
                            _$r && (t = _$r);
                            var n = 0, _$o = function o() {};
                            return {
                                s: _$o,
                                n: function n1() {
                                    return n >= t.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: t[n++]
                                    };
                                },
                                e: function e(t) {
                                    throw t;
                                },
                                f: _$o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, c = !1;
                    return {
                        s: function s() {
                            _$r = _$r.call(t);
                        },
                        n: function n() {
                            var _$t = _$r.next();
                            return a = _$t.done, _$t;
                        },
                        e: function e(t) {
                            c = !0, i = t;
                        },
                        f: function f() {
                            try {
                                a || null == _$r["return"] || _$r["return"]();
                            } finally{
                                if (c) throw i;
                            }
                        }
                    };
                }(_$r);
                try {
                    for(n.s(); !(_$e = n.n()).done;){
                        var _$o = _$e.value;
                        if ("string" == typeof _$o && t === _$o) return !0;
                        if (_$o instanceof RegExp && _$o.test(t)) return !0;
                    }
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
            } : function() {
                return !1;
            }, this.entityExpansionCount = 0, this.currentExpandedLength = 0, this.options.stopNodes && this.options.stopNodes.length > 0) {
                this.stopNodesExact = new Set, this.stopNodesWildcard = new Set;
                for(var n = 0; n < this.options.stopNodes.length; n++){
                    var _$o = this.options.stopNodes[n];
                    "string" == typeof _$o && (_$o.startsWith("*.") ? this.stopNodesWildcard.add(_$o.substring(2)) : this.stopNodesExact.add(_$o));
                }
            }
        });
        var ut = new RegExp("([^\\s=]+)\\s*(=\\s*(['\"])([\\s\\S]*?)\\3)?", "gm");
        var lt = function lt(t) {
            t = t.replace(/\r\n?/g, "\n");
            var _$e = new M("!xml"), _$r = _$e, n = "", _$o = "";
            this.entityExpansionCount = 0, this.currentExpandedLength = 0;
            for(var i = new Z(this.options.processEntities), a = 0; a < t.length; a++)if ("<" === t[a]) {
                if ("/" === t[a + 1]) {
                    var c = yt(t, ">", a, "Closing Tag is not closed."), s = t.substring(a + 2, c).trim();
                    if (this.options.removeNSPrefix) {
                        var u = s.indexOf(":");
                        -1 !== u && (s = s.substr(u + 1));
                    }
                    this.options.transformTagName && (s = this.options.transformTagName(s)), _$r && (n = this.saveTextToParentTag(n, _$r, _$o));
                    var p = _$o.substring(_$o.lastIndexOf(".") + 1);
                    if (s && -1 !== this.options.unpairedTags.indexOf(s)) throw new Error("Unpaired tag can not be used as closing tag: </".concat(s, ">"));
                    var l = 0;
                    p && -1 !== this.options.unpairedTags.indexOf(p) ? (l = _$o.lastIndexOf(".", _$o.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : l = _$o.lastIndexOf("."), _$o = _$o.substring(0, l), _$r = this.tagsNodeStack.pop(), n = "", a = c;
                } else if ("?" === t[a + 1]) {
                    var f = vt(t, a, !1, "?>");
                    if (!f) throw new Error("Pi Tag is not closed.");
                    if (n = this.saveTextToParentTag(n, _$r, _$o), this.options.ignoreDeclaration && "?xml" === f.tagName || this.options.ignorePiTags) ;
                    else {
                        var h = new M(f.tagName);
                        h.add(this.options.textNodeName, ""), f.tagName !== f.tagExp && f.attrExpPresent && (h[":@"] = this.buildAttributesMap(f.tagExp, _$o, f.tagName)), this.addChild(_$r, h, _$o, a);
                    }
                    a = f.closeIndex + 1;
                } else if ("!--" === t.substr(a + 1, 3)) {
                    var d = yt(t, "--\x3e", a + 4, "Comment is not closed.");
                    if (this.options.commentPropName) {
                        var m = t.substring(a + 4, d - 2);
                        n = this.saveTextToParentTag(n, _$r, _$o), _$r.add(this.options.commentPropName, [
                            tt({}, this.options.textNodeName, m)
                        ]);
                    }
                    a = d;
                } else if ("!D" === t.substr(a + 1, 2)) {
                    var y = i.readDocType(t, a);
                    this.docTypeEntities = y.entities, a = y.i;
                } else if ("![" === t.substr(a + 1, 2)) {
                    var v = yt(t, "]]>", a, "CDATA is not closed.") - 2, _$g = t.substring(a + 9, v);
                    n = this.saveTextToParentTag(n, _$r, _$o);
                    var b = this.parseTextData(_$g, _$r.tagname, _$o, !0, !1, !0, !0);
                    null == b && (b = ""), this.options.cdataPropName ? _$r.add(this.options.cdataPropName, [
                        tt({}, this.options.textNodeName, _$g)
                    ]) : _$r.add(this.options.textNodeName, b), a = v + 2;
                } else {
                    var x = vt(t, a, this.options.removeNSPrefix), w = x.tagName, k = x.rawTagName, S = x.tagExp, E = x.attrExpPresent, O = x.closeIndex;
                    if (this.options.transformTagName) {
                        var j = this.options.transformTagName(w);
                        S === w && (S = j), w = j;
                    }
                    _$r && n && "!xml" !== _$r.tagname && (n = this.saveTextToParentTag(n, _$r, _$o, !1));
                    var F = _$r;
                    F && -1 !== this.options.unpairedTags.indexOf(F.tagname) && (_$r = this.tagsNodeStack.pop(), _$o = _$o.substring(0, _$o.lastIndexOf("."))), w !== _$e.tagname && (_$o += _$o ? "." + w : w);
                    var _ = a;
                    if (this.isItStopNode(this.stopNodesExact, this.stopNodesWildcard, _$o, w)) {
                        var P = "";
                        if (S.length > 0 && S.lastIndexOf("/") === S.length - 1) "/" === w[w.length - 1] ? (w = w.substr(0, w.length - 1), _$o = _$o.substr(0, _$o.length - 1), S = w) : S = S.substr(0, S.length - 1), a = x.closeIndex;
                        else if (-1 !== this.options.unpairedTags.indexOf(w)) a = x.closeIndex;
                        else {
                            var A = this.readStopNodeData(t, k, O + 1);
                            if (!A) throw new Error("Unexpected end of ".concat(k));
                            a = A.i, P = A.tagContent;
                        }
                        var T = new M(w);
                        w !== S && E && (T[":@"] = this.buildAttributesMap(S, _$o, w)), P && (P = this.parseTextData(P, w, _$o, !0, E, !0, !0)), _$o = _$o.substr(0, _$o.lastIndexOf(".")), T.add(this.options.textNodeName, P), this.addChild(_$r, T, _$o, _);
                    } else {
                        if (S.length > 0 && S.lastIndexOf("/") === S.length - 1) {
                            if ("/" === w[w.length - 1] ? (w = w.substr(0, w.length - 1), _$o = _$o.substr(0, _$o.length - 1), S = w) : S = S.substr(0, S.length - 1), this.options.transformTagName) {
                                var D = this.options.transformTagName(w);
                                S === w && (S = D), w = D;
                            }
                            var L = new M(w);
                            w !== S && E && (L[":@"] = this.buildAttributesMap(S, _$o, w)), this.addChild(_$r, L, _$o, _), _$o = _$o.substr(0, _$o.lastIndexOf("."));
                        } else {
                            var C = new M(w);
                            this.tagsNodeStack.push(_$r), w !== S && E && (C[":@"] = this.buildAttributesMap(S, _$o, w)), this.addChild(_$r, C, _$o, _), _$r = C;
                        }
                        n = "", a = O;
                    }
                }
            } else n += t[a];
            return _$e.child;
        };
        var ht = function ht(t, e, r) {
            if (-1 === t.indexOf("&")) return t;
            var n = this.options.processEntities;
            if (!n.enabled) return t;
            if (n.allowedTags && !n.allowedTags.includes(e)) return t;
            if (n.tagFilter && !n.tagFilter(e, r)) return t;
            for(var _$o in this.docTypeEntities){
                var i = this.docTypeEntities[_$o], a = t.match(i.regx);
                if (a) {
                    if (this.entityExpansionCount += a.length, n.maxTotalExpansions && this.entityExpansionCount > n.maxTotalExpansions) throw new Error("Entity expansion limit exceeded: ".concat(this.entityExpansionCount, " > ").concat(n.maxTotalExpansions));
                    var c = t.length;
                    if (t = t.replace(i.regx, i.val), n.maxExpandedLength && (this.currentExpandedLength += t.length - c, this.currentExpandedLength > n.maxExpandedLength)) throw new Error("Total expanded content size exceeded: ".concat(this.currentExpandedLength, " > ").concat(n.maxExpandedLength));
                }
            }
            if (-1 === t.indexOf("&")) return t;
            for(var s in this.lastEntities){
                var u = this.lastEntities[s];
                t = t.replace(u.regex, u.val);
            }
            if (-1 === t.indexOf("&")) return t;
            if (this.options.htmlEntities) for(var p in this.htmlEntities){
                var l = this.htmlEntities[p];
                t = t.replace(l.regex, l.val);
            }
            return t.replace(this.ampEntity.regex, this.ampEntity.val);
        };
        var wt = M.getMetaDataSymbol();
        function St(t, e, r) {
            for(var n, _$o = {}, i = 0; i < t.length; i++){
                var a, c = t[i], s = Et(c);
                if (a = void 0 === r ? s : r + "." + s, s === e.textNodeName) void 0 === n ? n = c[s] : n += "" + c[s];
                else {
                    if (void 0 === s) continue;
                    if (c[s]) {
                        var u = St(c[s], e, a), p = jt(u, e);
                        void 0 !== c[wt] && (u[wt] = c[wt]), c[":@"] ? Ot(u, c[":@"], a, e) : 1 !== Object.keys(u).length || void 0 === u[e.textNodeName] || e.alwaysCreateTextNode ? 0 === Object.keys(u).length && (e.alwaysCreateTextNode ? u[e.textNodeName] = "" : u = "") : u = u[e.textNodeName], void 0 !== _$o[s] && _$o.hasOwnProperty(s) ? (Array.isArray(_$o[s]) || (_$o[s] = [
                            _$o[s]
                        ]), _$o[s].push(u)) : e.isArray(s, a, p) ? _$o[s] = [
                            u
                        ] : _$o[s] = u;
                    }
                }
            }
            return "string" == typeof n ? n.length > 0 && (_$o[e.textNodeName] = n) : void 0 !== n && (_$o[e.textNodeName] = n), _$o;
        }
        function Ft(t) {
            return Ft = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function Ft(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, Ft(t);
        }
        var At = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.externalEntities = {}, this.options = C(e);
            }
            var _$e, _$r, n;
            return _$e = t, n = [
                {
                    key: "getMetaDataSymbol",
                    value: function value() {
                        return M.getMetaDataSymbol();
                    }
                }
            ], _$r = [
                {
                    key: "parse",
                    value: function value(t, e) {
                        if ("string" != typeof t && t.toString) t = t.toString();
                        else if ("string" != typeof t) throw new Error("XML data is accepted in String or Bytes[] form.");
                        if (e) {
                            !0 === e && (e = {});
                            var _$r = m(t, e);
                            if (!0 !== _$r) throw Error("".concat(_$r.err.msg, ":").concat(_$r.err.line, ":").concat(_$r.err.col));
                        }
                        var n = new it(this.options);
                        n.addExternalEntities(this.externalEntities);
                        var _$o = n.parseXml(t);
                        return this.options.preserveOrder || void 0 === _$o ? _$o : kt(_$o, this.options);
                    }
                },
                {
                    key: "addEntity",
                    value: function value(t, e) {
                        if (-1 !== e.indexOf("&")) throw new Error("Entity value can't have '&'");
                        if (-1 !== t.indexOf("&") || -1 !== t.indexOf(";")) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
                        if ("&" === e) throw new Error("An entity with value '&' is not permitted");
                        this.externalEntities[t] = e;
                    }
                }
            ], _t(_$e.prototype, _$r), n && _t(_$e, n), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }(), Tt = r(1227), Dt = r.n(Tt)()("fs:request:data"), Lt = function Lt(t) {
            return t = Ct(t), (0, n.V1)(t.data) || (t.data, 0) || (t.data, 0) || (0, n.fo)(t.data) || (0, n.qf)(t.data) || (0, n.mw)(t.data) || ((0, n.OU)(t.data) ? (t.headers = a(t.headers, "content-type", "application/x-www-form-urlencoded;charset=utf-8"), t.data = t.data.toString()) : (0, n.Gv)(t.data) && (t.headers = a(t.headers, "content-type", "application/json", !0), t.data = JSON.stringify(t.data))), t;
        }, Ct = function Ct(t) {
            return t.filestackHeaders ? (t.headers = a(t.headers, "filestack-source", (0, u.getVersion)()), t.headers = a(t.headers, "filestack-trace-id", "".concat(Math.floor(Date.now() / 1e3), "-").concat((0, u.uniqueId)())), t.headers = a(t.headers, "filestack-trace-span", "jssdk-".concat((0, u.uniqueId)())), t) : t;
        }, It = function It(t) {
            return (0, s.sH)(void 0, void 0, void 0, function() {
                var _$e, _$r;
                return (0, s.YH)(this, function(n) {
                    if (!t.headers || !t.headers["content-type"]) return [
                        2,
                        Promise.resolve(t)
                    ];
                    if (_$e = t.headers["content-type"], /application\/json/.test(_$e)) try {
                        t.data = JSON.parse(t.data);
                    } catch (e) {
                        Dt("Cannot parse response %O - %O", t.data, t.headers);
                    }
                    else /text\/(plain|html)/.test(_$e) ? t.data : /application\/xml/.test(_$e) && (_$r = t.data, t.data, !0 === P.validate(_$r) && (t.data = new At({
                        ignoreDeclaration: !0,
                        ignoreAttributes: !0,
                        trimValues: !0
                    }).parse(_$r)));
                    return [
                        2,
                        Promise.resolve(t)
                    ];
                });
            });
        }, zt = function zt(t, e) {
            if (!e) return t;
            var _$r = Nt(e), n = t.indexOf("#");
            return -1 !== n && (t = t.slice(0, n)), t + (-1 === t.indexOf("?") ? "?" : "&") + _$r;
        }, Nt = function Nt(t) {
            return Object.keys(t).filter(function(e) {
                return e && void 0 !== t[e];
            }).map(function(e) {
                return "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(t[e]));
            }).join("&");
        }, Rt = r(6854);
    },
    863: function(t, e, r) {
        var n = Function.prototype.call, _$o = Object.prototype.hasOwnProperty, i = r(5465);
        t.exports = i.call(n, _$o);
    },
    1226: function(t) {
        t.exports = SyntaxError;
    },
    1227: function(t, e, r) {
        var n;
        e.formatArgs = function(e) {
            if (e[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + e[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), this.useColors) {
                var _$r = "color: " + this.color;
                e.splice(1, 0, _$r, "color: inherit");
                var n = 0, _$o = 0;
                e[0].replace(/%[a-zA-Z%]/g, function(t) {
                    "%%" !== t && (n++, "%c" === t && (_$o = n));
                }), e.splice(_$o, 0, _$r);
            }
        }, e.save = function(t) {
            try {
                t ? e.storage.setItem("debug", t) : e.storage.removeItem("debug");
            } catch (t) {}
        }, e.load = function() {
            var _$t;
            try {
                _$t = e.storage.getItem("debug") || e.storage.getItem("DEBUG");
            } catch (t) {}
            return _$t, _$t;
        }, e.useColors = function() {
            var _$t;
            return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type && !window.process.__nwjs) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && (_$t = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(_$t[1], 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
        }, e.storage = function() {
            try {
                return localStorage;
            } catch (t) {}
        }(), e.destroy = (n = !1, function() {
            n || (n = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
        }), e.colors = [
            "#0000CC",
            "#0000FF",
            "#0033CC",
            "#0033FF",
            "#0066CC",
            "#0066FF",
            "#0099CC",
            "#0099FF",
            "#00CC00",
            "#00CC33",
            "#00CC66",
            "#00CC99",
            "#00CCCC",
            "#00CCFF",
            "#3300CC",
            "#3300FF",
            "#3333CC",
            "#3333FF",
            "#3366CC",
            "#3366FF",
            "#3399CC",
            "#3399FF",
            "#33CC00",
            "#33CC33",
            "#33CC66",
            "#33CC99",
            "#33CCCC",
            "#33CCFF",
            "#6600CC",
            "#6600FF",
            "#6633CC",
            "#6633FF",
            "#66CC00",
            "#66CC33",
            "#9900CC",
            "#9900FF",
            "#9933CC",
            "#9933FF",
            "#99CC00",
            "#99CC33",
            "#CC0000",
            "#CC0033",
            "#CC0066",
            "#CC0099",
            "#CC00CC",
            "#CC00FF",
            "#CC3300",
            "#CC3333",
            "#CC3366",
            "#CC3399",
            "#CC33CC",
            "#CC33FF",
            "#CC6600",
            "#CC6633",
            "#CC9900",
            "#CC9933",
            "#CCCC00",
            "#CCCC33",
            "#FF0000",
            "#FF0033",
            "#FF0066",
            "#FF0099",
            "#FF00CC",
            "#FF00FF",
            "#FF3300",
            "#FF3333",
            "#FF3366",
            "#FF3399",
            "#FF33CC",
            "#FF33FF",
            "#FF6600",
            "#FF6633",
            "#FF9900",
            "#FF9933",
            "#FFCC00",
            "#FFCC33"
        ], e.log = console.debug || console.log || function() {}, t.exports = r(8630)(e), t.exports.formatters.j = function(t) {
            try {
                return JSON.stringify(t);
            } catch (t) {
                return "[UnexpectedJSONParseError]: " + t.message;
            }
        };
    },
    1304: function() {},
    1310: function(t) {
        var n = function n() {};
        var _$o = function _$o(t, e, r) {
            this.fn = t, this.context = e, this.once = r || !1;
        };
        var i = function i(t, e, n, _i, a) {
            if ("function" != typeof n) throw new TypeError("The listener must be a function");
            var c = new _$o(n, _i || t, a), s = r ? r + e : e;
            return t._events[s] ? t._events[s].fn ? t._events[s] = [
                t._events[s],
                c
            ] : t._events[s].push(c) : (t._events[s] = c, t._eventsCount++), t;
        };
        var a = function a(t, e) {
            0 == --t._eventsCount ? t._events = new n : delete t._events[e];
        };
        var c = function c() {
            this._events = new n, this._eventsCount = 0;
        };
        var e = Object.prototype.hasOwnProperty, r = "~";
        Object.create && (n.prototype = Object.create(null), (new n).__proto__ || (r = !1)), c.prototype.eventNames = function() {
            var _$t, n, _$o = [];
            if (0 === this._eventsCount) return _$o;
            for(n in _$t = this._events)e.call(_$t, n) && _$o.push(r ? n.slice(1) : n);
            return Object.getOwnPropertySymbols ? _$o.concat(Object.getOwnPropertySymbols(_$t)) : _$o;
        }, c.prototype.listeners = function(t) {
            var e = r ? r + t : t, n = this._events[e];
            if (!n) return [];
            if (n.fn) return [
                n.fn
            ];
            for(var _$o = 0, i = n.length, a = new Array(i); _$o < i; _$o++)a[_$o] = n[_$o].fn;
            return a;
        }, c.prototype.listenerCount = function(t) {
            var e = r ? r + t : t, n = this._events[e];
            return n ? n.fn ? 1 : n.length : 0;
        }, c.prototype.emit = function(t, e, n, o, i, a) {
            var c = r ? r + t : t;
            if (!this._events[c]) return !1;
            var s, u, p = this._events[c], l = arguments.length;
            if (p.fn) {
                switch(p.once && this.removeListener(t, p.fn, void 0, !0), l){
                    case 1:
                        return p.fn.call(p.context), !0;
                    case 2:
                        return p.fn.call(p.context, e), !0;
                    case 3:
                        return p.fn.call(p.context, e, n), !0;
                    case 4:
                        return p.fn.call(p.context, e, n, o), !0;
                    case 5:
                        return p.fn.call(p.context, e, n, o, i), !0;
                    case 6:
                        return p.fn.call(p.context, e, n, o, i, a), !0;
                }
                for(u = 1, s = new Array(l - 1); u < l; u++)s[u - 1] = arguments[u];
                p.fn.apply(p.context, s);
            } else {
                var f, h = p.length;
                for(u = 0; u < h; u++)switch(p[u].once && this.removeListener(t, p[u].fn, void 0, !0), l){
                    case 1:
                        p[u].fn.call(p[u].context);
                        break;
                    case 2:
                        p[u].fn.call(p[u].context, e);
                        break;
                    case 3:
                        p[u].fn.call(p[u].context, e, n);
                        break;
                    case 4:
                        p[u].fn.call(p[u].context, e, n, o);
                        break;
                    default:
                        if (!s) for(f = 1, s = new Array(l - 1); f < l; f++)s[f - 1] = arguments[f];
                        p[u].fn.apply(p[u].context, s);
                }
            }
            return !0;
        }, c.prototype.on = function(t, e, r) {
            return i(this, t, e, r, !1);
        }, c.prototype.once = function(t, e, r) {
            return i(this, t, e, r, !0);
        }, c.prototype.removeListener = function(t, e, n, o) {
            var i = r ? r + t : t;
            if (!this._events[i]) return this;
            if (!e) return a(this, i), this;
            var c = this._events[i];
            if (c.fn) c.fn !== e || o && !c.once || n && c.context !== n || a(this, i);
            else {
                for(var s = 0, u = [], p = c.length; s < p; s++)(c[s].fn !== e || o && !c[s].once || n && c[s].context !== n) && u.push(c[s]);
                u.length ? this._events[i] = 1 === u.length ? u[0] : u : a(this, i);
            }
            return this;
        }, c.prototype.removeAllListeners = function(t) {
            var e;
            return t ? (e = r ? r + t : t, this._events[e] && a(this, e)) : (this._events = new n, this._eventsCount = 0), this;
        }, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, t.exports = c;
    },
    1371: function(t, e, r) {
        var c = function c(t, e) {
            return e + ": " + t.toString() + "\n";
        };
        var h = function h(t, e, r, o) {
            "object" === n(r) ? e[o] = y(t[o], r) : -1 === t.indexOf(r) && e.push(r);
        };
        var d = function d(t, e, r) {
            e[r] = t[r];
        };
        var m = function m(t, e, r, o) {
            "object" === n(e[o]) && e[o] && t[o] ? r[o] = y(t[o], e[o]) : r[o] = e[o];
        };
        var y = function y(t, e) {
            var _$r = Array.isArray(e), _$o = _$r && [] || {};
            return _$r ? (t = t || [], _$o = _$o.concat(t), e.forEach(h.bind(null, t, _$o))) : (t && "object" === n(t) && Object.keys(t).forEach(d.bind(null, t, _$o)), Object.keys(e).forEach(m.bind(null, t, e, _$o))), _$o;
        };
        var v = function v(t) {
            return "/" + encodeURIComponent(t).replace(/~/g, "%7E");
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(1837), i = e.ValidationError = function i(t, e, r, n, o, i) {
            if (Array.isArray(n) ? (this.path = n, this.property = n.reduce(function(t, e) {
                return t + f(e);
            }, "instance")) : void 0 !== n && (this.property = n), t && (this.message = t), r) {
                var a = r.$id || r.id;
                this.schema = a || r;
            }
            void 0 !== e && (this.instance = e), this.name = o, this.argument = i, this.stack = this.toString();
        };
        i.prototype.toString = function() {
            return this.property + " " + this.message;
        };
        var a = e.ValidatorResult = function a(t, e, r, n) {
            this.instance = t, this.schema = e, this.options = r, this.path = n.path, this.propertyPath = n.propertyPath, this.errors = [], this.throwError = r && r.throwError, this.throwFirst = r && r.throwFirst, this.throwAll = r && r.throwAll, this.disableFormat = r && !0 === r.disableFormat;
        };
        function s(t) {
            Error.captureStackTrace && Error.captureStackTrace(this, s), this.instance = t.instance, this.schema = t.schema, this.options = t.options, this.errors = t.errors;
        }
        a.prototype.addError = function(t) {
            var _$e;
            if ("string" == typeof t) _$e = new i(t, this.instance, this.schema, this.path);
            else {
                if (!t) throw new Error("Missing error detail");
                if (!t.message) throw new Error("Missing error message");
                if (!t.name) throw new Error("Missing validator type");
                _$e = new i(t.message, this.instance, this.schema, this.path, t.name, t.argument);
            }
            if (this.errors.push(_$e), this.throwFirst) throw new s(this);
            if (this.throwError) throw _$e;
            return _$e;
        }, a.prototype.importErrors = function(t) {
            "string" == typeof t || t && t.validatorType ? this.addError(t) : t && t.errors && (this.errors = this.errors.concat(t.errors));
        }, a.prototype.toString = function(t) {
            return this.errors.map(c).join("");
        }, Object.defineProperty(a.prototype, "valid", {
            get: function get() {
                return !this.errors.length;
            }
        }), t.exports.ValidatorResultError = s, s.prototype = new Error, s.prototype.constructor = s, s.prototype.name = "Validation Error";
        var u = e.SchemaError = function t(e, r) {
            this.message = e, this.schema = r, Error.call(this, e), Error.captureStackTrace(this, t);
        };
        u.prototype = Object.create(Error.prototype, {
            constructor: {
                value: u,
                enumerable: !1
            },
            name: {
                value: "SchemaError",
                enumerable: !1
            }
        });
        var p = e.SchemaContext = function p(t, e, r, n, o) {
            this.schema = t, this.options = e, Array.isArray(r) ? (this.path = r, this.propertyPath = r.reduce(function(t, e) {
                return t + f(e);
            }, "instance")) : this.propertyPath = r, this.base = n, this.schemas = o;
        };
        p.prototype.resolve = function(t) {
            return _$o.resolve(this.base, t);
        }, p.prototype.makeChild = function(t, e) {
            var _$r = void 0 === e ? this.path : this.path.concat([
                e
            ]), n = t.$id || t.id, i = _$o.resolve(this.base, n || ""), a = new p(t, this.options, _$r, i, Object.create(this.schemas));
            return n && !a.schemas[i] && (a.schemas[i] = t), a;
        };
        var l = e.FORMAT_REGEXPS = {
            "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,
            date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,
            time: /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,
            duration: /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i,
            email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
            "idn-email": /^("(?:(?:[!#-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\t -\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*"|(?:[!#-'\*\+\x2D\/-9=\?A-Z\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:\.?(?:[!#-'\*\+\x2D\/-9=\?A-Z\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*)@((?:[!#-'\*\+\x2D\/-9=\?A-Z\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:\.?(?:[!#-'\*\+\x2D\/-9=\?A-Z\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*|\[(?:[!-Z\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\])$/,
            "ip-address": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            ipv6: /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,
            uri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/,
            "uri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/,
            iri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/,
            "iri-reference": /^(((([A-Za-z][\+\x2D\.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:(?:[!\$&-\.0-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|[\/\?])|\?)(%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*|([A-Za-z][\+\x2D\.0-9A-Za-z]*:?)?)|([A-Za-z][\+\x2D\.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|(?:[!\$&-\.0-9;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+|(\[(([Vv][0-9A-Fa-f]+\.(?:[!\$&-\.0-;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)?|[\.0-:A-Fa-f]+)\])?)(:[0-9]*)?[\/\?]|(?:[!\$&-\.0-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*|(\/((%[0-9A-Fa-f]{2}|(?:[!\$&-\.0-9;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+|(\[(([Vv][0-9A-Fa-f]+\.(?:[!\$&-\.0-;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)?|[\.0-:A-Fa-f]+)\])?)(:[0-9]*)?)?))#(%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*|(([A-Za-z][\+\x2D\.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|(?:[!\$&-\.0-9;=@_~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|[A-Za-z][\+\x2D\.0-9A-Za-z]*(?:[!\$&-\*,;=@_~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(%[0-9A-Fa-f]{2}|(?:[!\$&-\.0-9;=@-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*((([\/\?](%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*)?#|[\/\?])(%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*)?|([A-Za-z][\+\x2D\.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:(?:[!\$&-\.0-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|[\/\?])|\?)(%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*|([A-Za-z][\+\x2D\.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|(?:[!\$&-\.0-9;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+|(\[(([Vv][0-9A-Fa-f]+\.(?:[!\$&-\.0-;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)?|[\.0-:A-Fa-f]+)\])?)(:[0-9]*)?[\/\?]|(?:[!\$&-\.0-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(%[0-9A-Fa-f]{2}|(?:[!\$&-;=\?-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*|\/((%[0-9A-Fa-f]{2}|(?:[!\$&-\.0-9;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+(:[0-9]*)?|(\[(([Vv][0-9A-Fa-f]+\.(?:[!\$&-\.0-;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)?|[\.0-:A-Fa-f]+)\])?:[0-9]*|\[(([Vv][0-9A-Fa-f]+\.(?:[!\$&-\.0-;=A-Z_a-z~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)?|[\.0-:A-Fa-f]+)\])?)?|[A-Za-z][\+\x2D\.0-9A-Za-z]*:?)?$/,
            uuid: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
            "uri-template": /(%[0-9a-f]{2}|[!#\$&\(-;=\?@\[\]_a-z~\u017F\u212A]|\{[!#&\+,\.\/;=\?@\|]?(%[0-9a-f]{2}|[0-9_a-z\u017F\u212A])(\.?(%[0-9a-f]{2}|[0-9_a-z\u017F\u212A]))*(:[1-9][0-9]{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z\u017F\u212A])(\.?(%[0-9a-f]{2}|[0-9_a-z\u017F\u212A]))*(:[1-9][0-9]{0,3}|\*)?)*\})*/i,
            "json-pointer": /^(\/([\0-\.0-@\[-\}\x7F\u017F\u212A]|~[01])*)*$/i,
            "relative-json-pointer": /^[0-9]+(#|(\/([\0-\.0-@\[-\}\x7F\u017F\u212A]|~[01])*)*)$/i,
            hostname: /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
            "host-name": /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
            "utc-millisec": function(t) {
                return "string" == typeof t && parseFloat(t) === parseInt(t, 10) && !isNaN(t);
            },
            regex: function regex(t) {
                var _$e = !0;
                try {
                    new RegExp(t);
                } catch (t) {
                    _$e = !1;
                }
                return _$e;
            },
            style: /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/,
            color: /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,
            phone: /^\+(?:[0-9] ?){6,14}[0-9]$/,
            alpha: /^[a-zA-Z]+$/,
            alphanumeric: /^[a-zA-Z0-9]+$/
        };
        l.regexp = l.regex, l.pattern = l.regex, l.ipv4 = l["ip-address"], e.isFormat = function(t, e, r) {
            if ("string" == typeof t && void 0 !== l[e]) {
                if (l[e] instanceof RegExp) return l[e].test(t);
                if ("function" == typeof l[e]) return l[e](t);
            } else if (r && r.customFormats && "function" == typeof r.customFormats[e]) return r.customFormats[e](t);
            return !0;
        };
        var f = e.makeSuffix = function f(t) {
            return (t = t.toString()).match(/[.\s\[\]]/) || t.match(/^[\d]/) ? t.match(/^\d+$/) ? "[" + t + "]" : "[" + JSON.stringify(t) + "]" : "." + t;
        };
        e.deepCompareStrict = function t(e, r) {
            if (n(e) !== n(r)) return !1;
            if (Array.isArray(e)) return !!Array.isArray(r) && e.length === r.length && e.every(function(n, o) {
                return t(e[o], r[o]);
            });
            if ("object" === n(e)) {
                if (!e || !r) return e === r;
                var _$o = Object.keys(e), i = Object.keys(r);
                return _$o.length === i.length && _$o.every(function(n) {
                    return t(e[n], r[n]);
                });
            }
            return e === r;
        }, t.exports.deepMerge = y, e.objectGetPath = function(t, e) {
            for(var _$r, n = e.split("/").slice(1); "string" == typeof (_$r = n.shift());){
                var _$o = decodeURIComponent(_$r.replace(/~0/, "~").replace(/~1/g, "/"));
                if (!(_$o in t)) return;
                t = t[_$o];
            }
            return t;
        }, e.encodePath = function(t) {
            return t.map(v).join("");
        }, e.getDecimalPlaces = function(t) {
            var _$e = 0;
            if (isNaN(t)) return _$e;
            "number" != typeof t && (t = Number(t));
            var _$r = t.toString().split("e");
            if (2 === _$r.length) {
                if ("-" !== _$r[1][0]) return _$e;
                _$e = Number(_$r[1].slice(1));
            }
            var n = _$r[0].split(".");
            return 2 === n.length && (_$e += n[1].length), _$e;
        }, e.isSchema = function(t) {
            return "object" === n(t) && t || "boolean" == typeof t;
        };
    },
    1622: function(t) {
        t.exports = "undefined" != typeof Reflect && Reflect.getPrototypeOf || null;
    },
    1635: function(t, e, r) {
        var _$o = function _$o(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
                this.constructor = t;
            }
            n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
        };
        var a = function a(t, e, r, n) {
            return new (r || (r = Promise))(function(o, i) {
                function a(t) {
                    try {
                        s(n.next(t));
                    } catch (t) {
                        i(t);
                    }
                }
                function c(t) {
                    try {
                        s(n["throw"](t));
                    } catch (t) {
                        i(t);
                    }
                }
                function s(t) {
                    var _$e;
                    t.done ? o(t.value) : (_$e = t.value, _$e instanceof r ? _$e : new r(function(t) {
                        t(_$e);
                    })).then(a, c);
                }
                s((n = n.apply(t, e || [])).next());
            });
        };
        var c = function c(t, e) {
            var _$r, n, _$o, i, a = {
                label: 0,
                sent: function sent() {
                    if (1 & _$o[0]) throw _$o[1];
                    return _$o[1];
                },
                trys: [],
                ops: []
            };
            return i = {
                next: c(0),
                "throw": c(1),
                "return": c(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                return this;
            }), i;
            function c(c) {
                return function(s) {
                    return function(c) {
                        if (_$r) throw new TypeError("Generator is already executing.");
                        for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                            if (_$r = 1, n && (_$o = 2 & c[0] ? n["return"] : c[0] ? n["throw"] || ((_$o = n["return"]) && _$o.call(n), 0) : n.next) && !(_$o = _$o.call(n, c[1])).done) return _$o;
                            switch(n = 0, _$o && (c = [
                                2 & c[0],
                                _$o.value
                            ]), c[0]){
                                case 0:
                                case 1:
                                    _$o = c;
                                    break;
                                case 4:
                                    return a.label++, {
                                        value: c[1],
                                        done: !1
                                    };
                                case 5:
                                    a.label++, n = c[1], c = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    c = a.ops.pop(), a.trys.pop();
                                    continue;
                                default:
                                    if (!((_$o = (_$o = a.trys).length > 0 && _$o[_$o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                        a = 0;
                                        continue;
                                    }
                                    if (3 === c[0] && (!_$o || c[1] > _$o[0] && c[1] < _$o[3])) {
                                        a.label = c[1];
                                        break;
                                    }
                                    if (6 === c[0] && a.label < _$o[1]) {
                                        a.label = _$o[1], _$o = c;
                                        break;
                                    }
                                    if (_$o && a.label < _$o[2]) {
                                        a.label = _$o[2], a.ops.push(c);
                                        break;
                                    }
                                    _$o[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                            }
                            c = e.call(t, a);
                        } catch (t) {
                            c = [
                                6,
                                t
                            ], n = 0;
                        } finally{
                            _$r = _$o = 0;
                        }
                        if (5 & c[0]) throw c[1];
                        return {
                            value: c[0] ? c[1] : void 0,
                            done: !0
                        };
                    }([
                        c,
                        s
                    ]);
                };
            }
        };
        r.d(e, {
            C6: function() {
                return _$o;
            },
            Cl: function() {
                return i;
            },
            YH: function() {
                return c;
            },
            sH: function() {
                return a;
            }
        });
        var n = function n1(t, e) {
            return n = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(t, e) {
                t.__proto__ = e;
            } || function(t, e) {
                for(var _$r in e)Object.prototype.hasOwnProperty.call(e, _$r) && (t[_$r] = e[_$r]);
            }, n(t, e);
        };
        var i = function i1() {
            return i = Object.assign || function(t) {
                for(var _$e, _$r = 1, n = arguments.length; _$r < n; _$r++)for(var _$o in _$e = arguments[_$r])Object.prototype.hasOwnProperty.call(_$e, _$o) && (t[_$o] = _$e[_$o]);
                return t;
            }, i.apply(this, arguments);
        };
        Object.create, Object.create, "function" == typeof SuppressedError && SuppressedError;
    },
    1837: function(t, e, r) {
        var i = function i() {
            this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
        };
        var b = function b(t, e, r) {
            if (t && "object" === n(t) && t instanceof i) return t;
            var _$o = new i;
            return _$o.parse(t, e, r), _$o;
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(5417);
        var a = /^([a-z0-9.+-]+:)/i, c = /:[0-9]*$/, s = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, u = [
            "{",
            "}",
            "|",
            "\\",
            "^",
            "`"
        ].concat([
            "<",
            ">",
            '"',
            "`",
            " ",
            "\r",
            "\n",
            "\t"
        ]), p = [
            "'"
        ].concat(u), l = [
            "%",
            "/",
            "?",
            ";",
            "#"
        ].concat(p), f = [
            "/",
            "?",
            "#"
        ], h = /^[+a-z0-9A-Z_-]{0,63}$/, d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, m = {
            javascript: !0,
            "javascript:": !0
        }, y = {
            javascript: !0,
            "javascript:": !0
        }, v = {
            http: !0,
            https: !0,
            ftp: !0,
            gopher: !0,
            file: !0,
            "http:": !0,
            "https:": !0,
            "ftp:": !0,
            "gopher:": !0,
            "file:": !0
        }, _$g = r(3988);
        i.prototype.parse = function(t, e, r) {
            if ("string" != typeof t) throw new TypeError("Parameter 'url' must be a string, not " + n(t));
            var i = t.indexOf("?"), c = -1 !== i && i < t.indexOf("#") ? "?" : "#", u = t.split(c);
            u[0] = u[0].replace(/\\/g, "/");
            var b = t = u.join(c);
            if (b = b.trim(), !r && 1 === t.split("#").length) {
                var x = s.exec(b);
                if (x) return this.path = b, this.href = b, this.pathname = x[1], x[2] ? (this.search = x[2], this.query = e ? _$g.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
            }
            var w = a.exec(b);
            if (w) {
                var k = (w = w[0]).toLowerCase();
                this.protocol = k, b = b.substr(w.length);
            }
            if (r || w || b.match(/^\/\/[^@/]+@[^@/]+/)) {
                var S = "//" === b.substr(0, 2);
                !S || w && y[w] || (b = b.substr(2), this.slashes = !0);
            }
            if (!y[w] && (S || w && !v[w])) {
                for(var E, O, j = -1, F = 0; F < f.length; F++)-1 !== (_ = b.indexOf(f[F])) && (-1 === j || _ < j) && (j = _);
                for(-1 !== (O = -1 === j ? b.lastIndexOf("@") : b.lastIndexOf("@", j)) && (E = b.slice(0, O), b = b.slice(O + 1), this.auth = decodeURIComponent(E)), j = -1, F = 0; F < l.length; F++){
                    var _;
                    -1 !== (_ = b.indexOf(l[F])) && (-1 === j || _ < j) && (j = _);
                }
                -1 === j && (j = b.length), this.host = b.slice(0, j), b = b.slice(j), this.parseHost(), this.hostname = this.hostname || "";
                var P = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                if (!P) for(var A = this.hostname.split(/\./), T = (F = 0, A.length); F < T; F++){
                    var D = A[F];
                    if (D && !D.match(h)) {
                        for(var L = "", C = 0, I = D.length; C < I; C++)D.charCodeAt(C) > 127 ? L += "x" : L += D[C];
                        if (!L.match(h)) {
                            var z = A.slice(0, F), N = A.slice(F + 1), R = D.match(d);
                            R && (z.push(R[1]), N.unshift(R[2])), N.length && (b = "/" + N.join(".") + b), this.hostname = z.join(".");
                            break;
                        }
                    }
                }
                this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), P || (this.hostname = _$o.toASCII(this.hostname));
                var M = this.port ? ":" + this.port : "", B = this.hostname || "";
                this.host = B + M, this.href += this.host, P && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== b[0] && (b = "/" + b));
            }
            if (!m[k]) for(F = 0, T = p.length; F < T; F++){
                var U = p[F];
                if (-1 !== b.indexOf(U)) {
                    var q = encodeURIComponent(U);
                    q === U && (q = escape(U)), b = b.split(U).join(q);
                }
            }
            var G = b.indexOf("#");
            -1 !== G && (this.hash = b.substr(G), b = b.slice(0, G));
            var $ = b.indexOf("?");
            if (-1 !== $ ? (this.search = b.substr($), this.query = b.substr($ + 1), e && (this.query = _$g.parse(this.query)), b = b.slice(0, $)) : e && (this.search = "", this.query = {}), b && (this.pathname = b), v[k] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                M = this.pathname || "";
                var Z = this.search || "";
                this.path = M + Z;
            }
            return this.href = this.format(), this;
        }, i.prototype.format = function() {
            var t = this.auth || "";
            t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
            var _$e = this.protocol || "", _$r = this.pathname || "", _$o = this.hash || "", i = !1, a = "";
            this.host ? i = t + this.host : this.hostname && (i = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && "object" === n(this.query) && Object.keys(this.query).length && (a = _$g.stringify(this.query, {
                arrayFormat: "repeat",
                addQueryPrefix: !1
            }));
            var c = this.search || a && "?" + a || "";
            return _$e && ":" !== _$e.substr(-1) && (_$e += ":"), this.slashes || (!_$e || v[_$e]) && !1 !== i ? (i = "//" + (i || ""), _$r && "/" !== _$r.charAt(0) && (_$r = "/" + _$r)) : i || (i = ""), _$o && "#" !== _$o.charAt(0) && (_$o = "#" + _$o), c && "?" !== c.charAt(0) && (c = "?" + c), _$e + i + (_$r = _$r.replace(/[?#]/g, function(t) {
                return encodeURIComponent(t);
            })) + (c = c.replace("#", "%23")) + _$o;
        }, i.prototype.resolve = function(t) {
            return this.resolveObject(b(t, !1, !0)).format();
        }, i.prototype.resolveObject = function(t) {
            if ("string" == typeof t) {
                var _$e = new i;
                _$e.parse(t, !1, !0), t = _$e;
            }
            for(var _$r = new i, n = Object.keys(this), _$o = 0; _$o < n.length; _$o++){
                var a = n[_$o];
                _$r[a] = this[a];
            }
            if (_$r.hash = t.hash, "" === t.href) return _$r.href = _$r.format(), _$r;
            if (t.slashes && !t.protocol) {
                for(var c = Object.keys(t), s = 0; s < c.length; s++){
                    var u = c[s];
                    "protocol" !== u && (_$r[u] = t[u]);
                }
                return v[_$r.protocol] && _$r.hostname && !_$r.pathname && (_$r.pathname = "/", _$r.path = _$r.pathname), _$r.href = _$r.format(), _$r;
            }
            if (t.protocol && t.protocol !== _$r.protocol) {
                if (!v[t.protocol]) {
                    for(var p = Object.keys(t), l = 0; l < p.length; l++){
                        var f = p[l];
                        _$r[f] = t[f];
                    }
                    return _$r.href = _$r.format(), _$r;
                }
                if (_$r.protocol = t.protocol, t.host || y[t.protocol]) _$r.pathname = t.pathname;
                else {
                    for(var h = (t.pathname || "").split("/"); h.length && !(t.host = h.shift()););
                    t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== h[0] && h.unshift(""), h.length < 2 && h.unshift(""), _$r.pathname = h.join("/");
                }
                if (_$r.search = t.search, _$r.query = t.query, _$r.host = t.host || "", _$r.auth = t.auth, _$r.hostname = t.hostname || t.host, _$r.port = t.port, _$r.pathname || _$r.search) {
                    var d = _$r.pathname || "", m = _$r.search || "";
                    _$r.path = d + m;
                }
                return _$r.slashes = _$r.slashes || t.slashes, _$r.href = _$r.format(), _$r;
            }
            var _$g = _$r.pathname && "/" === _$r.pathname.charAt(0), b = t.host || t.pathname && "/" === t.pathname.charAt(0), x = b || _$g || _$r.host && t.pathname, w = x, k = _$r.pathname && _$r.pathname.split("/") || [], S = (h = t.pathname && t.pathname.split("/") || [], _$r.protocol && !v[_$r.protocol]);
            if (S && (_$r.hostname = "", _$r.port = null, _$r.host && ("" === k[0] ? k[0] = _$r.host : k.unshift(_$r.host)), _$r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === h[0] ? h[0] = t.host : h.unshift(t.host)), t.host = null), x = x && ("" === h[0] || "" === k[0])), b) _$r.host = t.host || "" === t.host ? t.host : _$r.host, _$r.hostname = t.hostname || "" === t.hostname ? t.hostname : _$r.hostname, _$r.search = t.search, _$r.query = t.query, k = h;
            else if (h.length) k || (k = []), k.pop(), k = k.concat(h), _$r.search = t.search, _$r.query = t.query;
            else if (null != t.search) return S && (_$r.host = k.shift(), _$r.hostname = _$r.host, (_ = !!(_$r.host && _$r.host.indexOf("@") > 0) && _$r.host.split("@")) && (_$r.auth = _.shift(), _$r.hostname = _.shift(), _$r.host = _$r.hostname)), _$r.search = t.search, _$r.query = t.query, null === _$r.pathname && null === _$r.search || (_$r.path = (_$r.pathname ? _$r.pathname : "") + (_$r.search ? _$r.search : "")), _$r.href = _$r.format(), _$r;
            if (!k.length) return _$r.pathname = null, _$r.search ? _$r.path = "/" + _$r.search : _$r.path = null, _$r.href = _$r.format(), _$r;
            for(var E = k.slice(-1)[0], O = (_$r.host || t.host || k.length > 1) && ("." === E || ".." === E) || "" === E, j = 0, F = k.length; F >= 0; F--)"." === (E = k[F]) ? k.splice(F, 1) : ".." === E ? (k.splice(F, 1), j++) : j && (k.splice(F, 1), j--);
            if (!x && !w) for(; j--; j)k.unshift("..");
            !x || "" === k[0] || k[0] && "/" === k[0].charAt(0) || k.unshift(""), O && "/" !== k.join("/").substr(-1) && k.push("");
            var _, P = "" === k[0] || k[0] && "/" === k[0].charAt(0);
            return S && (_$r.hostname = P ? "" : k.length ? k.shift() : "", _$r.host = _$r.hostname, (_ = !!(_$r.host && _$r.host.indexOf("@") > 0) && _$r.host.split("@")) && (_$r.auth = _.shift(), _$r.hostname = _.shift(), _$r.host = _$r.hostname)), (x = x || _$r.host && k.length) && !P && k.unshift(""), k.length > 0 ? _$r.pathname = k.join("/") : (_$r.pathname = null, _$r.path = null), null === _$r.pathname && null === _$r.search || (_$r.path = (_$r.pathname ? _$r.pathname : "") + (_$r.search ? _$r.search : "")), _$r.auth = t.auth || _$r.auth, _$r.slashes = _$r.slashes || t.slashes, _$r.href = _$r.format(), _$r;
        }, i.prototype.parseHost = function() {
            var t = this.host, _$e = c.exec(t);
            _$e && (":" !== (_$e = _$e[0]) && (this.port = _$e.substr(1)), t = t.substr(0, t.length - _$e.length)), t && (this.hostname = t);
        }, e.parse = b, e.resolve = function(t, e) {
            return b(t, !1, !0).resolve(e);
        }, e.resolveObject = function(t, e) {
            return t ? b(t, !1, !0).resolveObject(e) : e;
        }, e.format = function(t) {
            return "string" == typeof t && (t = b(t)), t instanceof i ? t.format() : i.prototype.format.call(t);
        }, e.Url = i;
    },
    1953: function(t) {
        t.exports = TypeError;
    },
    1978: function(t, e, r) {
        var n = r(5465), _$o = r(7052), i = r(5118), a = r(2069);
        t.exports = a || n.call(i, _$o);
    },
    2069: function(t) {
        t.exports = "undefined" != typeof Reflect && Reflect && Reflect.apply;
    },
    2104: function(t) {
        t.exports = RangeError;
    },
    2593: function(t, e, r) {
        var n, _$o, i;
        function a(t) {
            return a = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function a(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, a(t);
        }
        i = function i(t) {
            var _$e = [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "a",
                "b",
                "c",
                "d",
                "e",
                "f"
            ];
            function r(t, e) {
                var _$r = t[0], n = t[1], _$o = t[2], _$i = t[3];
                n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$o | ~n & _$i) + e[0] - 680876936 | 0) << 7 | _$r >>> 25) + n | 0) & n | ~_$r & _$o) + e[1] - 389564586 | 0) << 12 | _$i >>> 20) + _$r | 0) & _$r | ~_$i & n) + e[2] + 606105819 | 0) << 17 | _$o >>> 15) + _$i | 0) & _$i | ~_$o & _$r) + e[3] - 1044525330 | 0) << 22 | n >>> 10) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$o | ~n & _$i) + e[4] - 176418897 | 0) << 7 | _$r >>> 25) + n | 0) & n | ~_$r & _$o) + e[5] + 1200080426 | 0) << 12 | _$i >>> 20) + _$r | 0) & _$r | ~_$i & n) + e[6] - 1473231341 | 0) << 17 | _$o >>> 15) + _$i | 0) & _$i | ~_$o & _$r) + e[7] - 45705983 | 0) << 22 | n >>> 10) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$o | ~n & _$i) + e[8] + 1770035416 | 0) << 7 | _$r >>> 25) + n | 0) & n | ~_$r & _$o) + e[9] - 1958414417 | 0) << 12 | _$i >>> 20) + _$r | 0) & _$r | ~_$i & n) + e[10] - 42063 | 0) << 17 | _$o >>> 15) + _$i | 0) & _$i | ~_$o & _$r) + e[11] - 1990404162 | 0) << 22 | n >>> 10) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$o | ~n & _$i) + e[12] + 1804603682 | 0) << 7 | _$r >>> 25) + n | 0) & n | ~_$r & _$o) + e[13] - 40341101 | 0) << 12 | _$i >>> 20) + _$r | 0) & _$r | ~_$i & n) + e[14] - 1502002290 | 0) << 17 | _$o >>> 15) + _$i | 0) & _$i | ~_$o & _$r) + e[15] + 1236535329 | 0) << 22 | n >>> 10) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$i | _$o & ~_$i) + e[1] - 165796510 | 0) << 5 | _$r >>> 27) + n | 0) & _$o | n & ~_$o) + e[6] - 1069501632 | 0) << 9 | _$i >>> 23) + _$r | 0) & n | _$r & ~n) + e[11] + 643717713 | 0) << 14 | _$o >>> 18) + _$i | 0) & _$r | _$i & ~_$r) + e[0] - 373897302 | 0) << 20 | n >>> 12) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$i | _$o & ~_$i) + e[5] - 701558691 | 0) << 5 | _$r >>> 27) + n | 0) & _$o | n & ~_$o) + e[10] + 38016083 | 0) << 9 | _$i >>> 23) + _$r | 0) & n | _$r & ~n) + e[15] - 660478335 | 0) << 14 | _$o >>> 18) + _$i | 0) & _$r | _$i & ~_$r) + e[4] - 405537848 | 0) << 20 | n >>> 12) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$i | _$o & ~_$i) + e[9] + 568446438 | 0) << 5 | _$r >>> 27) + n | 0) & _$o | n & ~_$o) + e[14] - 1019803690 | 0) << 9 | _$i >>> 23) + _$r | 0) & n | _$r & ~n) + e[3] - 187363961 | 0) << 14 | _$o >>> 18) + _$i | 0) & _$r | _$i & ~_$r) + e[8] + 1163531501 | 0) << 20 | n >>> 12) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n & _$i | _$o & ~_$i) + e[13] - 1444681467 | 0) << 5 | _$r >>> 27) + n | 0) & _$o | n & ~_$o) + e[2] - 51403784 | 0) << 9 | _$i >>> 23) + _$r | 0) & n | _$r & ~n) + e[7] + 1735328473 | 0) << 14 | _$o >>> 18) + _$i | 0) & _$r | _$i & ~_$r) + e[12] - 1926607734 | 0) << 20 | n >>> 12) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n ^ _$o ^ _$i) + e[5] - 378558 | 0) << 4 | _$r >>> 28) + n | 0) ^ n ^ _$o) + e[8] - 2022574463 | 0) << 11 | _$i >>> 21) + _$r | 0) ^ _$r ^ n) + e[11] + 1839030562 | 0) << 16 | _$o >>> 16) + _$i | 0) ^ _$i ^ _$r) + e[14] - 35309556 | 0) << 23 | n >>> 9) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n ^ _$o ^ _$i) + e[1] - 1530992060 | 0) << 4 | _$r >>> 28) + n | 0) ^ n ^ _$o) + e[4] + 1272893353 | 0) << 11 | _$i >>> 21) + _$r | 0) ^ _$r ^ n) + e[7] - 155497632 | 0) << 16 | _$o >>> 16) + _$i | 0) ^ _$i ^ _$r) + e[10] - 1094730640 | 0) << 23 | n >>> 9) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n ^ _$o ^ _$i) + e[13] + 681279174 | 0) << 4 | _$r >>> 28) + n | 0) ^ n ^ _$o) + e[0] - 358537222 | 0) << 11 | _$i >>> 21) + _$r | 0) ^ _$r ^ n) + e[3] - 722521979 | 0) << 16 | _$o >>> 16) + _$i | 0) ^ _$i ^ _$r) + e[6] + 76029189 | 0) << 23 | n >>> 9) + _$o | 0, n = ((n += ((_$o = ((_$o += ((_$i = ((_$i += ((_$r = ((_$r += (n ^ _$o ^ _$i) + e[9] - 640364487 | 0) << 4 | _$r >>> 28) + n | 0) ^ n ^ _$o) + e[12] - 421815835 | 0) << 11 | _$i >>> 21) + _$r | 0) ^ _$r ^ n) + e[15] + 530742520 | 0) << 16 | _$o >>> 16) + _$i | 0) ^ _$i ^ _$r) + e[2] - 995338651 | 0) << 23 | n >>> 9) + _$o | 0, n = ((n += ((_$i = ((_$i += (n ^ ((_$r = ((_$r += (_$o ^ (n | ~_$i)) + e[0] - 198630844 | 0) << 6 | _$r >>> 26) + n | 0) | ~_$o)) + e[7] + 1126891415 | 0) << 10 | _$i >>> 22) + _$r | 0) ^ ((_$o = ((_$o += (_$r ^ (_$i | ~n)) + e[14] - 1416354905 | 0) << 15 | _$o >>> 17) + _$i | 0) | ~_$r)) + e[5] - 57434055 | 0) << 21 | n >>> 11) + _$o | 0, n = ((n += ((_$i = ((_$i += (n ^ ((_$r = ((_$r += (_$o ^ (n | ~_$i)) + e[12] + 1700485571 | 0) << 6 | _$r >>> 26) + n | 0) | ~_$o)) + e[3] - 1894986606 | 0) << 10 | _$i >>> 22) + _$r | 0) ^ ((_$o = ((_$o += (_$r ^ (_$i | ~n)) + e[10] - 1051523 | 0) << 15 | _$o >>> 17) + _$i | 0) | ~_$r)) + e[1] - 2054922799 | 0) << 21 | n >>> 11) + _$o | 0, n = ((n += ((_$i = ((_$i += (n ^ ((_$r = ((_$r += (_$o ^ (n | ~_$i)) + e[8] + 1873313359 | 0) << 6 | _$r >>> 26) + n | 0) | ~_$o)) + e[15] - 30611744 | 0) << 10 | _$i >>> 22) + _$r | 0) ^ ((_$o = ((_$o += (_$r ^ (_$i | ~n)) + e[6] - 1560198380 | 0) << 15 | _$o >>> 17) + _$i | 0) | ~_$r)) + e[13] + 1309151649 | 0) << 21 | n >>> 11) + _$o | 0, n = ((n += ((_$i = ((_$i += (n ^ ((_$r = ((_$r += (_$o ^ (n | ~_$i)) + e[4] - 145523070 | 0) << 6 | _$r >>> 26) + n | 0) | ~_$o)) + e[11] - 1120210379 | 0) << 10 | _$i >>> 22) + _$r | 0) ^ ((_$o = ((_$o += (_$r ^ (_$i | ~n)) + e[2] + 718787259 | 0) << 15 | _$o >>> 17) + _$i | 0) | ~_$r)) + e[9] - 343485551 | 0) << 21 | n >>> 11) + _$o | 0, t[0] = _$r + t[0] | 0, t[1] = n + t[1] | 0, t[2] = _$o + t[2] | 0, t[3] = _$i + t[3] | 0;
            }
            function n(t) {
                var _$e, _$r = [];
                for(_$e = 0; _$e < 64; _$e += 4)_$r[_$e >> 2] = t.charCodeAt(_$e) + (t.charCodeAt(_$e + 1) << 8) + (t.charCodeAt(_$e + 2) << 16) + (t.charCodeAt(_$e + 3) << 24);
                return _$r;
            }
            function o(t) {
                var _$e, _$r = [];
                for(_$e = 0; _$e < 64; _$e += 4)_$r[_$e >> 2] = t[_$e] + (t[_$e + 1] << 8) + (t[_$e + 2] << 16) + (t[_$e + 3] << 24);
                return _$r;
            }
            function i(t) {
                var _$e, _$o, _$i, _$a, _$c, s, u = t.length, _$p = [
                    1732584193,
                    -271733879,
                    -1732584194,
                    271733878
                ];
                for(_$e = 64; _$e <= u; _$e += 64)r(_$p, n(t.substring(_$e - 64, _$e)));
                for(_$o = (t = t.substring(_$e - 64)).length, _$i = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ], _$e = 0; _$e < _$o; _$e += 1)_$i[_$e >> 2] |= t.charCodeAt(_$e) << (_$e % 4 << 3);
                if (_$i[_$e >> 2] |= 128 << (_$e % 4 << 3), _$e > 55) for(r(_$p, _$i), _$e = 0; _$e < 16; _$e += 1)_$i[_$e] = 0;
                return _$a = (_$a = 8 * u).toString(16).match(/(.*?)(.{0,8})$/), _$c = parseInt(_$a[2], 16), s = parseInt(_$a[1], 16) || 0, _$i[14] = _$c, _$i[15] = s, r(_$p, _$i), _$p;
            }
            function a(t) {
                var _$r, n = "";
                for(_$r = 0; _$r < 4; _$r += 1)n += _$e[t >> 8 * _$r + 4 & 15] + _$e[t >> 8 * _$r & 15];
                return n;
            }
            function c(t) {
                var _$e;
                for(_$e = 0; _$e < t.length; _$e += 1)t[_$e] = a(t[_$e]);
                return t.join("");
            }
            function s(t) {
                return /[\u0080-\uFFFF]/.test(t) && (t = unescape(encodeURIComponent(t))), t;
            }
            function u(t) {
                var _$e, _$r = [], n = t.length;
                for(_$e = 0; _$e < n - 1; _$e += 2)_$r.push(parseInt(t.substr(_$e, 2), 16));
                return String.fromCharCode.apply(String, _$r);
            }
            function p() {
                this.reset();
            }
            return c(i("hello")), "undefined" == typeof ArrayBuffer || ArrayBuffer.prototype.slice || function() {
                function e(t, e) {
                    return (t = 0 | t || 0) < 0 ? Math.max(t + e, 0) : Math.min(t, e);
                }
                ArrayBuffer.prototype.slice = function(r, n) {
                    var _$o, _$i, _$a, _$c, s = this.byteLength, u = e(r, s), _$p = s;
                    return n !== t && (_$p = e(n, s)), u > _$p ? new ArrayBuffer(0) : (_$o = _$p - u, _$i = new ArrayBuffer(_$o), _$a = new Uint8Array(_$i), _$c = new Uint8Array(this, u, _$o), _$a.set(_$c), _$i);
                };
            }(), p.prototype.append = function(t) {
                return this.appendBinary(s(t)), this;
            }, p.prototype.appendBinary = function(t) {
                this._buff += t, this._length += t.length;
                var _$e, _$o = this._buff.length;
                for(_$e = 64; _$e <= _$o; _$e += 64)r(this._hash, n(this._buff.substring(_$e - 64, _$e)));
                return this._buff = this._buff.substring(_$e - 64), this;
            }, p.prototype.end = function(t) {
                var _$e, _$r, n = this._buff, _$o = n.length, _$i = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(_$e = 0; _$e < _$o; _$e += 1)_$i[_$e >> 2] |= n.charCodeAt(_$e) << (_$e % 4 << 3);
                return this._finish(_$i, _$o), _$r = c(this._hash), t && (_$r = u(_$r)), this.reset(), _$r;
            }, p.prototype.reset = function() {
                return this._buff = "", this._length = 0, this._hash = [
                    1732584193,
                    -271733879,
                    -1732584194,
                    271733878
                ], this;
            }, p.prototype.getState = function() {
                return {
                    buff: this._buff,
                    length: this._length,
                    hash: this._hash.slice()
                };
            }, p.prototype.setState = function(t) {
                return this._buff = t.buff, this._length = t.length, this._hash = t.hash, this;
            }, p.prototype.destroy = function() {
                delete this._hash, delete this._buff, delete this._length;
            }, p.prototype._finish = function(t, e) {
                var n, _$o, _$i, _$a = e;
                if (t[_$a >> 2] |= 128 << (_$a % 4 << 3), _$a > 55) for(r(this._hash, t), _$a = 0; _$a < 16; _$a += 1)t[_$a] = 0;
                n = (n = 8 * this._length).toString(16).match(/(.*?)(.{0,8})$/), _$o = parseInt(n[2], 16), _$i = parseInt(n[1], 16) || 0, t[14] = _$o, t[15] = _$i, r(this._hash, t);
            }, p.hash = function(t, e) {
                return p.hashBinary(s(t), e);
            }, p.hashBinary = function(t, e) {
                var _$r = c(i(t));
                return e ? u(_$r) : _$r;
            }, p.ArrayBuffer = function() {
                this.reset();
            }, p.ArrayBuffer.prototype.append = function(t) {
                var _$e, n, _$i, _$a, _$c = (n = this._buff.buffer, _$i = t, (_$a = new Uint8Array(n.byteLength + _$i.byteLength)).set(new Uint8Array(n)), _$a.set(new Uint8Array(_$i), n.byteLength), _$a), s = _$c.length;
                for(this._length += t.byteLength, _$e = 64; _$e <= s; _$e += 64)r(this._hash, o(_$c.subarray(_$e - 64, _$e)));
                return this._buff = _$e - 64 < s ? new Uint8Array(_$c.buffer.slice(_$e - 64)) : new Uint8Array(0), this;
            }, p.ArrayBuffer.prototype.end = function(t) {
                var _$e, _$r, n = this._buff, _$o = n.length, _$i = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(_$e = 0; _$e < _$o; _$e += 1)_$i[_$e >> 2] |= n[_$e] << (_$e % 4 << 3);
                return this._finish(_$i, _$o), _$r = c(this._hash), t && (_$r = u(_$r)), this.reset(), _$r;
            }, p.ArrayBuffer.prototype.reset = function() {
                return this._buff = new Uint8Array(0), this._length = 0, this._hash = [
                    1732584193,
                    -271733879,
                    -1732584194,
                    271733878
                ], this;
            }, p.ArrayBuffer.prototype.getState = function() {
                var _$t, _$e = p.prototype.getState.call(this);
                return _$e.buff = (_$t = _$e.buff, String.fromCharCode.apply(null, new Uint8Array(_$t))), _$e;
            }, p.ArrayBuffer.prototype.setState = function(t) {
                return t.buff = function(t) {
                    var _$e, _$r = t.length, n = new ArrayBuffer(_$r), _$o = new Uint8Array(n);
                    for(_$e = 0; _$e < _$r; _$e += 1)_$o[_$e] = t.charCodeAt(_$e);
                    return _$o;
                }(t.buff), p.prototype.setState.call(this, t);
            }, p.ArrayBuffer.prototype.destroy = p.prototype.destroy, p.ArrayBuffer.prototype._finish = p.prototype._finish, p.ArrayBuffer.hash = function(t, e) {
                var n = c(function(t) {
                    var _$e, n, _$i, _$a, _$c, s, _$u = t.length, _$p = [
                        1732584193,
                        -271733879,
                        -1732584194,
                        271733878
                    ];
                    for(_$e = 64; _$e <= _$u; _$e += 64)r(_$p, o(t.subarray(_$e - 64, _$e)));
                    for(n = (t = _$e - 64 < _$u ? t.subarray(_$e - 64) : new Uint8Array(0)).length, _$i = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], _$e = 0; _$e < n; _$e += 1)_$i[_$e >> 2] |= t[_$e] << (_$e % 4 << 3);
                    if (_$i[_$e >> 2] |= 128 << (_$e % 4 << 3), _$e > 55) for(r(_$p, _$i), _$e = 0; _$e < 16; _$e += 1)_$i[_$e] = 0;
                    return _$a = (_$a = 8 * _$u).toString(16).match(/(.*?)(.{0,8})$/), _$c = parseInt(_$a[2], 16), s = parseInt(_$a[1], 16) || 0, _$i[14] = _$c, _$i[15] = s, r(_$p, _$i), _$p;
                }(new Uint8Array(t)));
                return e ? u(n) : n;
            }, p;
        }, "object" === a(e) ? t.exports = i() : void 0 === (_$o = "function" == typeof (n = i) ? n.call(e, r, e, t) : n) || (t.exports = _$o);
    },
    2629: function(t, e, r) {
        var n = r(8657), _$o = r(1953), i = function i(t, e, r) {
            for(var n, _$o = t; null != (n = _$o.next); _$o = n)if (n.key === e) return _$o.next = n.next, r || (n.next = t.next, t.next = n), n;
        };
        t.exports = function() {
            var _$t, e = {
                assert: function assert(t) {
                    if (!e.has(t)) throw new _$o("Side channel does not contain " + n(t));
                },
                "delete": function _delete(e) {
                    var _$r = _$t && _$t.next, n = function(t, e) {
                        if (t) return i(t, e, !0);
                    }(_$t, e);
                    return n && _$r && _$r === n && (_$t = void 0), !!n;
                },
                get: function get(e) {
                    return function(t, e) {
                        if (t) {
                            var _$r = i(t, e);
                            return _$r && _$r.value;
                        }
                    }(_$t, e);
                },
                has: function has(e) {
                    return function(t, e) {
                        return !!t && !!i(t, e);
                    }(_$t, e);
                },
                set: function set(e, r) {
                    _$t || (_$t = {
                        next: void 0
                    }), function(t, e, r) {
                        var n = i(t, e);
                        n ? n.value = r : t.next = {
                            key: e,
                            next: t.next,
                            value: r
                        };
                    }(_$t, e, r);
                }
            };
            return e;
        };
    },
    2634: function() {},
    2703: function(t) {
        var e = Object.prototype.toString, r = Math.max, n = function n(t, e) {
            for(var r = [], n = 0; n < t.length; n += 1)r[n] = t[n];
            for(var _$o = 0; _$o < e.length; _$o += 1)r[_$o + t.length] = e[_$o];
            return r;
        };
        t.exports = function(t) {
            var _$o = this;
            if ("function" != typeof _$o || "[object Function]" !== e.apply(_$o)) throw new TypeError("Function.prototype.bind called on incompatible " + _$o);
            for(var i, a = function(t) {
                for(var e = [], r = 1, n = 0; r < t.length; r += 1, n += 1)e[n] = t[r];
                return e;
            }(arguments), c = r(0, _$o.length - a.length), s = [], u = 0; u < c; u++)s[u] = "$" + u;
            if (i = Function("binder", "return function (" + function(t) {
                for(var e = "", r = 0; r < t.length; r += 1)e += t[r], r + 1 < t.length && (e += ",");
                return e;
            }(s) + "){ return binder.apply(this,arguments); }")(function() {
                if (this instanceof i) {
                    var e = _$o.apply(this, n(a, arguments));
                    return Object(e) === e ? e : this;
                }
                return _$o.apply(t, n(a, arguments));
            }), _$o.prototype) {
                var p = function p() {};
                p.prototype = _$o.prototype, i.prototype = new p, p.prototype = null;
            }
            return i;
        };
    },
    3186: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        r.d(e, {
            Bq: function() {
                return p;
            },
            Gv: function() {
                return i;
            },
            OU: function() {
                return s;
            },
            V1: function() {
                return u;
            },
            fo: function() {
                return a;
            },
            mw: function() {
                return _$o;
            },
            qf: function() {
                return c;
            }
        });
        var _$o = function o(t) {
            return "[object ArrayBuffer]" === Object.prototype.toString.call(t);
        }, i = function i(t) {
            return null !== t && "object" === n(t);
        }, a = function a(t) {
            return "[object File]" === Object.prototype.toString.call(t);
        }, c = function c(t) {
            return "[object Blob]" === Object.prototype.toString.call(t);
        }, s = function s(t) {
            return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
        }, u = function u(t) {
            return "undefined" != typeof FormData && t instanceof FormData;
        }, p = function p(t) {
            return t.replace(/^\s*/, "").replace(/\s*$/, "");
        };
    },
    3190: function(t, e, r) {
        var n = r(8299), _$o = r(9472), i = _$o([
            n("%String.prototype.indexOf%")
        ]);
        t.exports = function(t, e) {
            var _$r = n(t, !!e);
            return "function" == typeof _$r && i(t, ".prototype.") > -1 ? _$o([
                _$r
            ]) : _$r;
        };
    },
    3221: function(t, e, r) {
        var n = r(8299), _$o = r(3190), i = r(8657), a = r(1953), c = n("%Map%", !0), s = _$o("Map.prototype.get", !0), u = _$o("Map.prototype.set", !0), p = _$o("Map.prototype.has", !0), l = _$o("Map.prototype.delete", !0), f = _$o("Map.prototype.size", !0);
        t.exports = !!c && function() {
            var _$t, e = {
                assert: function assert(t) {
                    if (!e.has(t)) throw new a("Side channel does not contain " + i(t));
                },
                "delete": function _delete(e) {
                    if (_$t) {
                        var _$r = l(_$t, e);
                        return 0 === f(_$t) && (_$t = void 0), _$r;
                    }
                    return !1;
                },
                get: function get(e) {
                    if (_$t) return s(_$t, e);
                },
                has: function has(e) {
                    return !!_$t && p(_$t, e);
                },
                set: function set(e, r) {
                    _$t || (_$t = new c), u(_$t, e, r);
                }
            };
            return e;
        };
    },
    3284: function(t, e, r) {
        var _$o = function _$o(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, i(n.key), n);
            }
        };
        var i = function i(t) {
            var _$e = function(t) {
                if ("object" != n(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != n(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == n(_$e) ? _$e : String(_$e);
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var a = r(8796), c = function() {
            function t() {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this._queue = [];
            }
            var _$e, _$r;
            return _$e = t, _$r = [
                {
                    key: "enqueue",
                    value: function value(t, e) {
                        var _$r = {
                            priority: (e = Object.assign({
                                priority: 0
                            }, e)).priority,
                            run: t
                        };
                        if (this.size && this._queue[this.size - 1].priority >= e.priority) this._queue.push(_$r);
                        else {
                            var n = a["default"](this._queue, _$r, function(t, e) {
                                return e.priority - t.priority;
                            });
                            this._queue.splice(n, 0, _$r);
                        }
                    }
                },
                {
                    key: "dequeue",
                    value: function value() {
                        var _$t = this._queue.shift();
                        return null == _$t ? void 0 : _$t.run;
                    }
                },
                {
                    key: "filter",
                    value: function value(t) {
                        return this._queue.filter(function(e) {
                            return e.priority === t.priority;
                        }).map(function(t) {
                            return t.run;
                        });
                    }
                },
                {
                    key: "size",
                    get: function get() {
                        return this._queue.length;
                    }
                }
            ], _$o(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        e["default"] = c;
    },
    3441: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(8299), i = r(3190), a = r(8657), c = r(3221), s = r(1953), u = _$o("%WeakMap%", !0), p = i("WeakMap.prototype.get", !0), l = i("WeakMap.prototype.set", !0), f = i("WeakMap.prototype.has", !0), h = i("WeakMap.prototype.delete", !0);
        t.exports = u ? function() {
            var _$t, e, _$r = {
                assert: function assert(t) {
                    if (!_$r.has(t)) throw new s("Side channel does not contain " + a(t));
                },
                "delete": function _delete(r) {
                    if (u && r && ("object" === n(r) || "function" == typeof r)) {
                        if (_$t) return h(_$t, r);
                    } else if (c && e) return e["delete"](r);
                    return !1;
                },
                get: function get(r) {
                    return u && r && ("object" === n(r) || "function" == typeof r) && _$t ? p(_$t, r) : e && e.get(r);
                },
                has: function has(r) {
                    return u && r && ("object" === n(r) || "function" == typeof r) && _$t ? f(_$t, r) : !!e && e.has(r);
                },
                set: function set(r, o) {
                    u && r && ("object" === n(r) || "function" == typeof r) ? (_$t || (_$t = new u), l(_$t, r, o)) : c && (e || (e = c()), e.set(r, o));
                }
            };
            return _$r;
        } : c;
    },
    3574: function(t, e, r) {
        r.d(e, {
            U: function() {
                return l;
            }
        });
        var n = r(1635), _$o = r(1227), i = r.n(_$o), a = r(3186), c = r(5934), s = r(9653), u = r(830), p = i()("fs:request:xhr"), l = function() {
            function t() {}
            return t.prototype.request = function(t) {
                var _$e = this;
                void 0 === t.filestackHeaders && (t.filestackHeaders = !0), (t = (0, u.cN)(t)).headers = t.headers || {};
                var _$r = t.data, _$o = t.headers;
                a.V1(_$r) && delete _$o["Content-Type"];
                var i = new XMLHttpRequest;
                if (t.blobResponse && (i.responseType = "blob"), t.auth) {
                    if (!t.auth.username || 0 === t.auth.username.length || !t.auth.password || 0 === t.auth.password.length) return Promise.reject(new s.d("Basic auth: username and password are required ".concat(t.auth), t));
                    _$o.Authorization = "Basic " + btoa(unescape(encodeURIComponent("".concat(t.auth.username, ":").concat(t.auth.password)))), p("Set request authorization to %s", t.auth.username + t.auth.password);
                }
                var l = t.url.trim();
                return /^http(s)?:\/\//.test(l) || (l = "https://".concat(l)), l = (0, u.D6)(l, t.params), p("Starting request to %s with options %O", l, t), i.open(t.method.toUpperCase(), l, !0), i.timeout = t.timeout, new Promise(function(a, f) {
                    var h;
                    if (t.cancelToken && (h = function h(e) {
                        return i && (i.abort(), i = null), p("Request canceled by user %s, config: %O", e, t), f(new s.d("Request aborted. Reason: ".concat(e), t, null, s.E.ABORTED));
                    }, t.cancelToken.once("cancel", h)), i.onreadystatechange = function() {
                        return (0, n.sH)(_$e, void 0, void 0, function() {
                            var _$e, _$r, _$o;
                            return (0, n.YH)(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return i && 4 === i.readyState && (0 !== i.status || i.responseURL) ? (_$e = (0, u.qg)(i.getAllResponseHeaders()), _$r = i.response, _$o = {
                                            data: _$r,
                                            status: i.status,
                                            statusText: i.statusText,
                                            headers: _$e,
                                            config: t
                                        }, i = null, [
                                            4,
                                            (0, u.xp)(_$o)
                                        ]) : [
                                            2
                                        ];
                                    case 1:
                                        return 500 <= (_$o = n.sent()).status && _$o.status <= 599 ? (p("Server error(5xx) - %O", _$o), [
                                            2,
                                            f(new s.d("Server error ".concat(l), t, _$o, s.E.SERVER))
                                        ]) : 400 <= _$o.status && _$o.status <= 499 ? (p("Request error(4xx) - %O", _$o), [
                                            2,
                                            f(new s.d("Request error ".concat(l), t, _$o, s.E.REQUEST))
                                        ]) : (t.cancelToken && (t.cancelToken.removeListener("cancel", h), h = null), [
                                            2,
                                            a(_$o)
                                        ]);
                                }
                            });
                        });
                    }, i.onabort = function() {
                        i && (i = null, f(new s.d("Request aborted", t, null, s.E.ABORTED)));
                    }, i.onerror = function(e) {
                        i = null, p("Request error! %O", e), f(new s.d("Network Error", t, null, s.E.NETWORK));
                    }, i.ontimeout = function() {
                        i = null, p("Request timed out. %O", t), f(new s.d("Request timeout", t, null, s.E.TIMEOUT));
                    }, "setRequestHeader" in i && _$o && Object.keys(_$o).length) for(var d in _$o)void 0 !== _$o[d] && (p("Set request header %s to %s", d, _$o[d]), i.setRequestHeader(d, _$o[d]));
                    "function" == typeof t.onProgress && [
                        c.j.POST,
                        c.j.PUT
                    ].indexOf(t.method) > -1 && (i.upload ? (p("Bind to upload progress event"), i.upload.addEventListener("progress", t.onProgress)) : (p("Bind to progress event"), i.addEventListener("progress", t.onProgress))), void 0 === _$r && (_$r = null), i.send(_$r);
                });
            }, t;
        }();
    },
    3581: function(t, e, r) {
        var n = r(5759);
        if (n) try {
            n([], "length");
        } catch (t) {
            n = null;
        }
        t.exports = n;
    },
    3772: function(t, e, r) {
        var _$o = function _$o(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var i = function i(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, i) {
                    var a = t.apply(_$e, _$r);
                    function c(t) {
                        _$o(a, n, i, c, s, "next", t);
                    }
                    function s(t) {
                        _$o(a, n, i, c, s, "throw", t);
                    }
                    c(void 0);
                });
            };
        };
        var c = function c(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, s(n.key), n);
            }
        };
        var s = function s(t) {
            var _$e = function(t) {
                if ("object" != a(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != a(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == a(_$e) ? _$e : String(_$e);
        };
        function n() {
            n = function n() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, _$o = _$r.hasOwnProperty, i = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, c = "function" == typeof Symbol ? Symbol : {}, s = c.iterator || "@@iterator", u = c.asyncIterator || "@@asyncIterator", p = c.toStringTag || "@@toStringTag";
            function l(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                l({}, "");
            } catch (t) {
                l = function l(t, e, r) {
                    return t[e] = r;
                };
            }
            function f(t, e, r, n) {
                var _$o = e && e.prototype instanceof b ? e : b, a = Object.create(_$o.prototype), c = new D(n || []);
                return i(a, "_invoke", {
                    value: _(t, r, c)
                }), a;
            }
            function h(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = f;
            var d = "suspendedStart", m = "suspendedYield", y = "executing", v = "completed", _$g = {};
            function b() {}
            function x() {}
            function w() {}
            var k = {};
            l(k, s, function() {
                return this;
            });
            var S = Object.getPrototypeOf, E = S && S(S(L([])));
            E && E !== _$r && _$o.call(E, s) && (k = E);
            var O = w.prototype = b.prototype = Object.create(k);
            function j(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    l(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function F(t, e) {
                function r(n, i, c, s) {
                    var u = h(t[n], t, i);
                    if ("throw" !== u.type) {
                        var p = u.arg, _$l = p.value;
                        return _$l && "object" == a(_$l) && _$o.call(_$l, "__await") ? e.resolve(_$l.__await).then(function(t) {
                            r("next", t, c, s);
                        }, function(t) {
                            r("throw", t, c, s);
                        }) : e.resolve(_$l).then(function(t) {
                            p.value = t, c(p);
                        }, function(t) {
                            return r("throw", t, c, s);
                        });
                    }
                    s(u.arg);
                }
                var _$n;
                i(this, "_invoke", {
                    value: function value(t, o) {
                        function i() {
                            return new e(function(e, n) {
                                r(t, o, e, n);
                            });
                        }
                        return _$n = _$n ? _$n.then(i, i) : i();
                    }
                });
            }
            function _(e, r, n) {
                var _$o = d;
                return function(i, a) {
                    if (_$o === y) throw new Error("Generator is already running");
                    if (_$o === v) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = P(c, n);
                            if (s) {
                                if (s === _$g) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === d) throw _$o = v, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = y;
                        var u = h(e, r, n);
                        if ("normal" === u.type) {
                            if (_$o = n.done ? v : m, u.arg === _$g) continue;
                            return {
                                value: u.arg,
                                done: n.done
                            };
                        }
                        "throw" === u.type && (_$o = v, n.method = "throw", n.arg = u.arg);
                    }
                };
            }
            function P(e, r) {
                var _$n = r.method, _$o = e.iterator[_$n];
                if (_$o === t) return r.delegate = null, "throw" === _$n && e.iterator["return"] && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method) || "return" !== _$n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + _$n + "' method")), _$g;
                var i = h(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, _$g;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, _$g) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, _$g);
            }
            function A(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function T(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function D(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(A, this), this.reset(!0);
            }
            function L(e) {
                if (e || "" === e) {
                    var _$r = e[s];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$n = -1, i = function r() {
                            for(; ++_$n < e.length;)if (_$o.call(e, _$n)) return r.value = e[_$n], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(a(e) + " is not iterable");
            }
            return x.prototype = w, i(O, "constructor", {
                value: w,
                configurable: !0
            }), i(w, "constructor", {
                value: x,
                configurable: !0
            }), x.displayName = l(w, p, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === x || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, l(t, p, "GeneratorFunction")), t.prototype = Object.create(O), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, j(F.prototype), l(F.prototype, u, function() {
                return this;
            }), _$e.AsyncIterator = F, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new F(f(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, j(O), l(O, p, "Generator"), l(O, s, function() {
                return this;
            }), l(O, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var _$n in _$e)_$r.push(_$n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var _$n = _$r.pop();
                        if (_$n in _$e) return t.value = _$n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = L, D.prototype = {
                constructor: D,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(T), !e) for(var _$r in this)"t" === _$r.charAt(0) && _$o.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function n(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return n("end");
                        if (a.tryLoc <= this.prev) {
                            var s = _$o.call(a, "catchLoc"), u = _$o.call(a, "finallyLoc");
                            if (s && u) {
                                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                            } else {
                                if (!u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$n = this.tryEntries[_$r];
                        if (_$n.tryLoc <= this.prev && _$o.call(_$n, "finallyLoc") && this.prev < _$n.finallyLoc) {
                            var i = _$n;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, _$g) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), _$g;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), T(_$r), _$g;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var _$n = _$r.completion;
                            if ("throw" === _$n.type) {
                                var _$o = _$n.arg;
                                T(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: L(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), _$g;
                }
            }, _$e;
        }
        function a(t) {
            return a = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function a(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, a(t);
        }
        function u(t, e) {
            return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function u(t, e) {
                return t.__proto__ = e, t;
            }, u(t, e);
        }
        function p(t) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function p(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, p(t);
        }
        var l = r(1310), f = r(4419), h = r(3284), d = function d() {}, m = new f.TimeoutError, y = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && u(t, e);
            }(x, t);
            var _$e, _$r, _$o, s, l, y, v, _$g, b = (v = x, _$g = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function b() {
                var _$t, _$e = p(v);
                if (_$g) {
                    var _$r = p(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === a(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function x(t) {
                var _$e, _$r, _$n, _$o, i;
                if (function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, x), (_$e = b.call(this))._intervalCount = 0, _$e._intervalEnd = 0, _$e._pendingCount = 0, _$e._resolveEmpty = d, _$e._resolveIdle = d, !("number" == typeof (t = Object.assign({
                    carryoverConcurrencyCount: !1,
                    intervalCap: 1 / 0,
                    interval: 0,
                    concurrency: 1 / 0,
                    autoStart: !0,
                    queueClass: h["default"]
                }, t)).intervalCap && t.intervalCap >= 1)) throw new TypeError("Expected `intervalCap` to be a number from 1 and up, got `".concat(null !== (_$n = null === (_$r = t.intervalCap) || void 0 === _$r ? void 0 : _$r.toString()) && void 0 !== _$n ? _$n : "", "` (").concat(a(t.intervalCap), ")"));
                if (void 0 === t.interval || !(Number.isFinite(t.interval) && t.interval >= 0)) throw new TypeError("Expected `interval` to be a finite number >= 0, got `".concat(null !== (i = null === (_$o = t.interval) || void 0 === _$o ? void 0 : _$o.toString()) && void 0 !== i ? i : "", "` (").concat(a(t.interval), ")"));
                return _$e._carryoverConcurrencyCount = t.carryoverConcurrencyCount, _$e._isIntervalIgnored = t.intervalCap === 1 / 0 || 0 === t.interval, _$e._intervalCap = t.intervalCap, _$e._interval = t.interval, _$e._queue = new t.queueClass, _$e._queueClass = t.queueClass, _$e.concurrency = t.concurrency, _$e._timeout = t.timeout, _$e._throwOnTimeout = !0 === t.throwOnTimeout, _$e._isPaused = !1 === t.autoStart, _$e;
            }
            return _$e = x, _$r = [
                {
                    key: "_doesIntervalAllowAnother",
                    get: function get() {
                        return this._isIntervalIgnored || this._intervalCount < this._intervalCap;
                    }
                },
                {
                    key: "_doesConcurrentAllowAnother",
                    get: function get() {
                        return this._pendingCount < this._concurrency;
                    }
                },
                {
                    key: "_next",
                    value: function value() {
                        this._pendingCount--, this._tryToStartAnother(), this.emit("next");
                    }
                },
                {
                    key: "_resolvePromises",
                    value: function value() {
                        this._resolveEmpty(), this._resolveEmpty = d, 0 === this._pendingCount && (this._resolveIdle(), this._resolveIdle = d, this.emit("idle"));
                    }
                },
                {
                    key: "_onResumeInterval",
                    value: function value() {
                        this._onInterval(), this._initializeIntervalIfNeeded(), this._timeoutId = void 0;
                    }
                },
                {
                    key: "_isIntervalPaused",
                    value: function value() {
                        var _$t = this, _$e = Date.now();
                        if (void 0 === this._intervalId) {
                            var _$r = this._intervalEnd - _$e;
                            if (!(_$r < 0)) return void 0 === this._timeoutId && (this._timeoutId = setTimeout(function() {
                                _$t._onResumeInterval();
                            }, _$r)), !0;
                            this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;
                        }
                        return !1;
                    }
                },
                {
                    key: "_tryToStartAnother",
                    value: function value() {
                        if (0 === this._queue.size) return this._intervalId && clearInterval(this._intervalId), this._intervalId = void 0, this._resolvePromises(), !1;
                        if (!this._isPaused) {
                            var _$t = !this._isIntervalPaused();
                            if (this._doesIntervalAllowAnother && this._doesConcurrentAllowAnother) {
                                var _$e = this._queue.dequeue();
                                return !!_$e && (this.emit("active"), _$e(), _$t && this._initializeIntervalIfNeeded(), !0);
                            }
                        }
                        return !1;
                    }
                },
                {
                    key: "_initializeIntervalIfNeeded",
                    value: function value() {
                        var _$t = this;
                        this._isIntervalIgnored || void 0 !== this._intervalId || (this._intervalId = setInterval(function() {
                            _$t._onInterval();
                        }, this._interval), this._intervalEnd = Date.now() + this._interval);
                    }
                },
                {
                    key: "_onInterval",
                    value: function value() {
                        0 === this._intervalCount && 0 === this._pendingCount && this._intervalId && (clearInterval(this._intervalId), this._intervalId = void 0), this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0, this._processQueue();
                    }
                },
                {
                    key: "_processQueue",
                    value: function value() {
                        for(; this._tryToStartAnother(););
                    }
                },
                {
                    key: "concurrency",
                    get: function get() {
                        return this._concurrency;
                    },
                    set: function set(t) {
                        if (!("number" == typeof t && t >= 1)) throw new TypeError("Expected `concurrency` to be a number from 1 and up, got `".concat(t, "` (").concat(a(t), ")"));
                        this._concurrency = t, this._processQueue();
                    }
                },
                {
                    key: "add",
                    value: (y = i(n().mark(function t(e) {
                        var _$r, _$o = this, a = arguments;
                        return n().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return _$r = a.length > 1 && void 0 !== a[1] ? a[1] : {}, t.abrupt("return", new Promise(function(t, a) {
                                        var c = function() {
                                            var c = i(n().mark(function i() {
                                                var c;
                                                return n().wrap(function(n) {
                                                    for(;;)switch(n.prev = n.next){
                                                        case 0:
                                                            return _$o._pendingCount++, _$o._intervalCount++, n.prev = 2, c = void 0 === _$o._timeout && void 0 === _$r.timeout ? e() : f["default"](Promise.resolve(e()), void 0 === _$r.timeout ? _$o._timeout : _$r.timeout, function() {
                                                                (void 0 === _$r.throwOnTimeout ? _$o._throwOnTimeout : _$r.throwOnTimeout) && a(m);
                                                            }), n.t0 = t, n.next = 7, c;
                                                        case 7:
                                                            n.t1 = n.sent, (0, n.t0)(n.t1), n.next = 14;
                                                            break;
                                                        case 11:
                                                            n.prev = 11, n.t2 = n["catch"](2), a(n.t2);
                                                        case 14:
                                                            _$o._next();
                                                        case 15:
                                                        case "end":
                                                            return n.stop();
                                                    }
                                                }, i, null, [
                                                    [
                                                        2,
                                                        11
                                                    ]
                                                ]);
                                            }));
                                            return function() {
                                                return c.apply(this, arguments);
                                            };
                                        }();
                                        _$o._queue.enqueue(c, _$r), _$o._tryToStartAnother(), _$o.emit("add");
                                    }));
                                case 2:
                                case "end":
                                    return t.stop();
                            }
                        }, t);
                    })), function(t) {
                        return y.apply(this, arguments);
                    })
                },
                {
                    key: "addAll",
                    value: (l = i(n().mark(function t(e, r) {
                        var _$o = this;
                        return n().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.abrupt("return", Promise.all(e.map(function() {
                                        var _$t = i(n().mark(function t(e) {
                                            return n().wrap(function(t) {
                                                for(;;)switch(t.prev = t.next){
                                                    case 0:
                                                        return t.abrupt("return", _$o.add(e, r));
                                                    case 1:
                                                    case "end":
                                                        return t.stop();
                                                }
                                            }, t);
                                        }));
                                        return function(e) {
                                            return _$t.apply(this, arguments);
                                        };
                                    }())));
                                case 1:
                                case "end":
                                    return t.stop();
                            }
                        }, t);
                    })), function(t, e) {
                        return l.apply(this, arguments);
                    })
                },
                {
                    key: "start",
                    value: function value() {
                        return this._isPaused ? (this._isPaused = !1, this._processQueue(), this) : this;
                    }
                },
                {
                    key: "pause",
                    value: function value() {
                        this._isPaused = !0;
                    }
                },
                {
                    key: "clear",
                    value: function value() {
                        this._queue = new this._queueClass;
                    }
                },
                {
                    key: "onEmpty",
                    value: (s = i(n().mark(function t() {
                        var _$e = this;
                        return n().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (0 !== this._queue.size) {
                                        t.next = 2;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 2:
                                    return t.abrupt("return", new Promise(function(t) {
                                        var _$r = _$e._resolveEmpty;
                                        _$e._resolveEmpty = function() {
                                            _$r(), t();
                                        };
                                    }));
                                case 3:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return s.apply(this, arguments);
                    })
                },
                {
                    key: "onIdle",
                    value: (_$o = i(n().mark(function t() {
                        var _$e = this;
                        return n().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (0 !== this._pendingCount || 0 !== this._queue.size) {
                                        t.next = 2;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 2:
                                    return t.abrupt("return", new Promise(function(t) {
                                        var _$r = _$e._resolveIdle;
                                        _$e._resolveIdle = function() {
                                            _$r(), t();
                                        };
                                    }));
                                case 3:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "size",
                    get: function get() {
                        return this._queue.size;
                    }
                },
                {
                    key: "sizeBy",
                    value: function value(t) {
                        return this._queue.filter(t).length;
                    }
                },
                {
                    key: "pending",
                    get: function get() {
                        return this._pendingCount;
                    }
                },
                {
                    key: "isPaused",
                    get: function get() {
                        return this._isPaused;
                    }
                },
                {
                    key: "timeout",
                    get: function get() {
                        return this._timeout;
                    },
                    set: function set(t) {
                        this._timeout = t;
                    }
                }
            ], _$r && c(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), x;
        }(l);
        e.A = y;
    },
    3988: function(t, e, r) {
        var n = r(6889), _$o = r(9367), i = r(9292);
        t.exports = {
            formats: i,
            parse: _$o,
            stringify: n
        };
    },
    4218: function(t) {
        t.exports = Math.floor;
    },
    4282: function(t, e, r) {
        t.exports.Validator = r(428);
        r(1371).ValidatorResult, r(1371).ValidatorResultError, r(1371).ValidationError, r(1371).SchemaError, r(5605), r(5605).S;
    },
    4379: function(t) {
        function e(t) {
            return e = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function e(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, e(t);
        }
        t.exports = function() {
            if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
            if ("symbol" === e(Symbol.iterator)) return !0;
            var _$t = {}, r = Symbol("test"), n = Object(r);
            if ("string" == typeof r) return !1;
            if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
            if ("[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
            for(var _$o in _$t[r] = 42, _$t)return !1;
            if ("function" == typeof Object.keys && 0 !== Object.keys(_$t).length) return !1;
            if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(_$t).length) return !1;
            var i = Object.getOwnPropertySymbols(_$t);
            if (1 !== i.length || i[0] !== r) return !1;
            if (!Object.prototype.propertyIsEnumerable.call(_$t, r)) return !1;
            if ("function" == typeof Object.getOwnPropertyDescriptor) {
                var a = Object.getOwnPropertyDescriptor(_$t, r);
                if (42 !== a.value || !0 !== a.enumerable) return !1;
            }
            return !0;
        };
    },
    4419: function(t, e, r) {
        var a = function a() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        function o(t) {
            var e = "function" == typeof Map ? new Map : void 0;
            return o = function o(t) {
                if (null === t || !function(t) {
                    try {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    } catch (e) {
                        return "function" == typeof t;
                    }
                }(t)) return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, r);
                }
                function r() {
                    return i(t, arguments, s(this).constructor);
                }
                return r.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: r,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), c(r, t);
            }, o(t);
        }
        function i(t, e, r) {
            return i = a() ? Reflect.construct.bind() : function i(t, e, r) {
                var n = [
                    null
                ];
                n.push.apply(n, e);
                var _$o = new (Function.bind.apply(t, n));
                return r && c(_$o, r.prototype), _$o;
            }, i.apply(null, arguments);
        }
        function c(t, e) {
            return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function c(t, e) {
                return t.__proto__ = e, t;
            }, c(t, e);
        }
        function s(t) {
            return s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function s(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, s(t);
        }
        var u = r(9927), p = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && c(t, e);
            }(u, t);
            var e, _$r, _$o, i = (_$r = u, _$o = a(), function i() {
                var _$t, e = s(_$r);
                if (_$o) {
                    var i = s(this).constructor;
                    _$t = Reflect.construct(e, arguments, i);
                } else _$t = e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === n(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function u(t) {
                var e;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (e = i.call(this, t)).name = "TimeoutError", e;
            }
            return e = u, Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }(o(Error)), l = function l(t, e, r) {
            return new Promise(function(n, o) {
                if ("number" != typeof e || e < 0) throw new TypeError("Expected `milliseconds` to be a positive number");
                if (e !== 1 / 0) {
                    var i = setTimeout(function() {
                        if ("function" != typeof r) {
                            var i = "string" == typeof r ? r : "Promise timed out after ".concat(e, " milliseconds"), a = r instanceof Error ? r : new p(i);
                            "function" == typeof t.cancel && t.cancel(), o(a);
                        } else try {
                            n(r());
                        } catch (t) {
                            o(t);
                        }
                    }, e);
                    u(t.then(n, o), function() {
                        clearTimeout(i);
                    });
                } else n(t);
            });
        };
        t.exports = l, t.exports["default"] = l, t.exports.TimeoutError = p;
    },
    4509: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(9292), i = Object.prototype.hasOwnProperty, a = Array.isArray, c = function() {
            for(var _$t = [], e = 0; e < 256; ++e)_$t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
            return _$t;
        }(), s = function s(t, e) {
            for(var _$r = e && e.plainObjects ? {
                __proto__: null
            } : {}, n = 0; n < t.length; ++n)void 0 !== t[n] && (_$r[n] = t[n]);
            return _$r;
        }, u = 1024;
        t.exports = {
            arrayToObject: s,
            assign: function assign(t, e) {
                return Object.keys(e).reduce(function(t, r) {
                    return t[r] = e[r], t;
                }, t);
            },
            combine: function combine(t, e) {
                return [].concat(t, e);
            },
            compact: function compact(t) {
                for(var e = [
                    {
                        obj: {
                            o: t
                        },
                        prop: "o"
                    }
                ], _$r = [], _$o = 0; _$o < e.length; ++_$o)for(var i = e[_$o], c = i.obj[i.prop], s = Object.keys(c), u = 0; u < s.length; ++u){
                    var p = s[u], l = c[p];
                    "object" === n(l) && null !== l && -1 === _$r.indexOf(l) && (e.push({
                        obj: c,
                        prop: p
                    }), _$r.push(l));
                }
                return function(t) {
                    for(; t.length > 1;){
                        var e = t.pop(), _$r = e.obj[e.prop];
                        if (a(_$r)) {
                            for(var _$n = [], _$o = 0; _$o < _$r.length; ++_$o)void 0 !== _$r[_$o] && _$n.push(_$r[_$o]);
                            e.obj[e.prop] = _$n;
                        }
                    }
                }(e), t;
            },
            decode: function decode(t, e, r) {
                var n = t.replace(/\+/g, " ");
                if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
                try {
                    return decodeURIComponent(n);
                } catch (t) {
                    return n;
                }
            },
            encode: function encode(t, e, r, i, a) {
                if (0 === t.length) return t;
                var s = t;
                if ("symbol" === n(t) ? s = Symbol.prototype.toString.call(t) : "string" != typeof t && (s = String(t)), "iso-8859-1" === r) return escape(s).replace(/%u[0-9a-f]{4}/gi, function(t) {
                    return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
                });
                for(var p = "", l = 0; l < s.length; l += u){
                    for(var f = s.length >= u ? s.slice(l, l + u) : s, h = [], d = 0; d < f.length; ++d){
                        var m = f.charCodeAt(d);
                        45 === m || 46 === m || 95 === m || 126 === m || m >= 48 && m <= 57 || m >= 65 && m <= 90 || m >= 97 && m <= 122 || a === _$o.RFC1738 && (40 === m || 41 === m) ? h[h.length] = f.charAt(d) : m < 128 ? h[h.length] = c[m] : m < 2048 ? h[h.length] = c[192 | m >> 6] + c[128 | 63 & m] : m < 55296 || m >= 57344 ? h[h.length] = c[224 | m >> 12] + c[128 | m >> 6 & 63] + c[128 | 63 & m] : (d += 1, m = 65536 + ((1023 & m) << 10 | 1023 & f.charCodeAt(d)), h[h.length] = c[240 | m >> 18] + c[128 | m >> 12 & 63] + c[128 | m >> 6 & 63] + c[128 | 63 & m]);
                    }
                    p += h.join("");
                }
                return p;
            },
            isBuffer: function isBuffer(t) {
                return !(!t || "object" !== n(t) || !(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t)));
            },
            isRegExp: function isRegExp(t) {
                return "[object RegExp]" === Object.prototype.toString.call(t);
            },
            maybeMap: function maybeMap(t, e) {
                if (a(t)) {
                    for(var _$r = [], n = 0; n < t.length; n += 1)_$r.push(e(t[n]));
                    return _$r;
                }
                return e(t);
            },
            merge: function t(e, r, o) {
                if (!r) return e;
                if ("object" !== n(r) && "function" != typeof r) {
                    if (a(e)) e.push(r);
                    else {
                        if (!e || "object" !== n(e)) return [
                            e,
                            r
                        ];
                        (o && (o.plainObjects || o.allowPrototypes) || !i.call(Object.prototype, r)) && (e[r] = !0);
                    }
                    return e;
                }
                if (!e || "object" !== n(e)) return [
                    e
                ].concat(r);
                var c = e;
                return a(e) && !a(r) && (c = s(e, o)), a(e) && a(r) ? (r.forEach(function(r, a) {
                    if (i.call(e, a)) {
                        var c = e[a];
                        c && "object" === n(c) && r && "object" === n(r) ? e[a] = t(c, r, o) : e.push(r);
                    } else e[a] = r;
                }), e) : Object.keys(r).reduce(function(e, n) {
                    var a = r[n];
                    return i.call(e, n) ? e[n] = t(e[n], a, o) : e[n] = a, e;
                }, c);
            }
        };
    },
    4940: function(t) {
        t.exports = Math.abs;
    },
    5049: function(t) {
        var e = Object.defineProperty || !1;
        if (e) try {
            e({}, "a", {
                value: 1
            });
        } catch (t) {
            e = !1;
        }
        t.exports = e;
    },
    5118: function(t) {
        t.exports = Function.prototype.call;
    },
    5417: function(t, e, r) {
        var n;
        function o(t) {
            return o = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function o(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, o(t);
        }
        t = r.nmd(t), function(i) {
            var a = "object" == o(e) && e && !e.nodeType && e, c = "object" == o(t) && t && !t.nodeType && t, s = "object" == (void 0 === r.g ? "undefined" : o(r.g)) && r.g;
            s.global !== s && s.window !== s && s.self !== s || (i = s);
            var u, p, l = 2147483647, f = 36, h = /^xn--/, d = /[^\x20-\x7E]/, m = /[\x2E\u3002\uFF0E\uFF61]/g, y = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
            }, v = Math.floor, _$g = String.fromCharCode;
            function b(t) {
                throw new RangeError(y[t]);
            }
            function x(t, e) {
                for(var _$r = t.length, n = []; _$r--;)n[_$r] = e(t[_$r]);
                return n;
            }
            function w(t, e) {
                var _$r = t.split("@"), n = "";
                return _$r.length > 1 && (n = _$r[0] + "@", t = _$r[1]), n + x((t = t.replace(m, ".")).split("."), e).join(".");
            }
            function k(t) {
                for(var _$e, _$r, n = [], _$o = 0, _$i = t.length; _$o < _$i;)(_$e = t.charCodeAt(_$o++)) >= 55296 && _$e <= 56319 && _$o < _$i ? 56320 == (64512 & (_$r = t.charCodeAt(_$o++))) ? n.push(((1023 & _$e) << 10) + (1023 & _$r) + 65536) : (n.push(_$e), _$o--) : n.push(_$e);
                return n;
            }
            function S(t) {
                return x(t, function(t) {
                    var _$e = "";
                    return t > 65535 && (_$e += _$g((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), _$e + _$g(t);
                }).join("");
            }
            function E(t, e) {
                return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
            }
            function O(t, e, r) {
                var n = 0;
                for(t = r ? v(t / 700) : t >> 1, t += v(t / e); t > 455; n += f)t = v(t / 35);
                return v(n + 36 * t / (t + 38));
            }
            function j(t) {
                var _$e, _$r, n, _$o, _$i, a, c, s, u, p, h, d = [], m = t.length, y = 0, _$g = 128, x = 72;
                for((_$r = t.lastIndexOf("-")) < 0 && (_$r = 0), n = 0; n < _$r; ++n)t.charCodeAt(n) >= 128 && b("not-basic"), d.push(t.charCodeAt(n));
                for(_$o = _$r > 0 ? _$r + 1 : 0; _$o < m;){
                    for(_$i = y, a = 1, c = f; _$o >= m && b("invalid-input"), ((s = (h = t.charCodeAt(_$o++)) - 48 < 10 ? h - 22 : h - 65 < 26 ? h - 65 : h - 97 < 26 ? h - 97 : f) >= f || s > v((l - y) / a)) && b("overflow"), y += s * a, !(s < (u = c <= x ? 1 : c >= x + 26 ? 26 : c - x)); c += f)a > v(l / (p = f - u)) && b("overflow"), a *= p;
                    x = O(y - _$i, _$e = d.length + 1, 0 == _$i), v(y / _$e) > l - _$g && b("overflow"), _$g += v(y / _$e), y %= _$e, d.splice(y++, 0, _$g);
                }
                return S(d);
            }
            function F(t) {
                var _$e, _$r, n, _$o, _$i, a, c, s, u, p, h, d, m, y, x, w = [];
                for(d = (t = k(t)).length, _$e = 128, _$r = 0, _$i = 72, a = 0; a < d; ++a)(h = t[a]) < 128 && w.push(_$g(h));
                for(n = _$o = w.length, _$o && w.push("-"); n < d;){
                    for(c = l, a = 0; a < d; ++a)(h = t[a]) >= _$e && h < c && (c = h);
                    for(c - _$e > v((l - _$r) / (m = n + 1)) && b("overflow"), _$r += (c - _$e) * m, _$e = c, a = 0; a < d; ++a)if ((h = t[a]) < _$e && ++_$r > l && b("overflow"), h == _$e) {
                        for(s = _$r, u = f; !(s < (p = u <= _$i ? 1 : u >= _$i + 26 ? 26 : u - _$i)); u += f)x = s - p, y = f - p, w.push(_$g(E(p + x % y, 0))), s = v(x / y);
                        w.push(_$g(E(s, 0))), _$i = O(_$r, m, n == _$o), _$r = 0, ++n;
                    }
                    ++_$r, ++_$e;
                }
                return w.join("");
            }
            if (u = {
                version: "1.4.1",
                ucs2: {
                    decode: k,
                    encode: S
                },
                decode: j,
                encode: F,
                toASCII: function toASCII(t) {
                    return w(t, function(t) {
                        return d.test(t) ? "xn--" + F(t) : t;
                    });
                },
                toUnicode: function toUnicode(t) {
                    return w(t, function(t) {
                        return h.test(t) ? j(t.slice(4).toLowerCase()) : t;
                    });
                }
            }, "object" == o(r.amdO) && r.amdO) void 0 === (n = (function() {
                return u;
            }).call(e, r, e, t)) || (t.exports = n);
            else if (a && c) {
                if (t.exports == a) c.exports = u;
                else for(p in u)u.hasOwnProperty(p) && (a[p] = u[p]);
            } else i.punycode = u;
        }(this);
    },
    5465: function(t, e, r) {
        var n = r(2703);
        t.exports = Function.prototype.bind || n;
    },
    5586: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(1622), i = r(9302), a = r(8950);
        t.exports = _$o ? function(t) {
            return _$o(t);
        } : i ? function(t) {
            if (!t || "object" !== n(t) && "function" != typeof t) throw new TypeError("getProto: not an object");
            return i(t);
        } : a ? function(t) {
            return a(t);
        } : null;
    },
    5605: function(t, e, r) {
        var a = function a(t, e) {
            this.id = t, this.ref = e;
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(1837), i = r(1371);
        t.exports.S = function(t, e) {
            function r(t, e) {
                if (e && "object" == n(e)) {
                    if (e.$ref) {
                        var a = _$o.resolve(t, e.$ref);
                        p[a] = p[a] ? p[a] + 1 : 0;
                    } else {
                        var l = e.$id || e.id, f = l ? _$o.resolve(t, l) : t;
                        if (f) {
                            if (f.indexOf("#") < 0 && (f += "#"), u[f]) {
                                if (!i.deepCompareStrict(u[f], e)) throw new Error("Schema <" + f + "> already exists with different definition");
                                return u[f];
                            }
                            u[f] = e, "#" == f[f.length - 1] && (u[f.substring(0, f.length - 1)] = e);
                        }
                        c(f + "/items", Array.isArray(e.items) ? e.items : [
                            e.items
                        ]), c(f + "/extends", Array.isArray(e["extends"]) ? e["extends"] : [
                            e["extends"]
                        ]), r(f + "/additionalItems", e.additionalItems), s(f + "/properties", e.properties), r(f + "/additionalProperties", e.additionalProperties), s(f + "/definitions", e.definitions), s(f + "/patternProperties", e.patternProperties), s(f + "/dependencies", e.dependencies), c(f + "/disallow", e.disallow), c(f + "/allOf", e.allOf), c(f + "/anyOf", e.anyOf), c(f + "/oneOf", e.oneOf), r(f + "/not", e.not);
                    }
                }
            }
            function c(t, e) {
                if (Array.isArray(e)) for(var n = 0; n < e.length; n++)r(t + "/" + n, e[n]);
            }
            function s(t, e) {
                if (e && "object" == n(e)) for(var _$o in e)r(t + "/" + _$o, e[_$o]);
            }
            var u = {}, p = {};
            return r(t, e), new a(u, p);
        };
    },
    5759: function(t) {
        t.exports = Object.getOwnPropertyDescriptor;
    },
    5934: function(t, e, r) {
        var n;
        r.d(e, {
            j: function() {
                return n;
            }
        }), function(t) {
            t.GET = "GET", t.DELETE = "DELETE", t.HEAD = "HEAD", t.PURGE = "PURGE", t.OPTIONS = "OPTIONS", t.POST = "POST", t.PUT = "PUT", t.PATH = "PATH";
        }(n || (n = {}));
    },
    6076: function(t) {
        t.exports = ReferenceError;
    },
    6114: function(t) {
        t.exports = Math.pow;
    },
    6234: function(t, e, r) {
        var s = function s(t, e, r, n, o) {
            var i = e.throwError, a = e.throwAll;
            e.throwError = !1, e.throwAll = !1;
            var c = this.validateSchema(t, o, e, r);
            return e.throwError = i, e.throwAll = a, !c.valid && n instanceof Function && n(c), c.valid;
        };
        var u = function u(t, e) {
            if (Object.hasOwnProperty.call(t, e)) return t[e];
            if (e in t) {
                for(; t = Object.getPrototypeOf(t);)if (Object.propertyIsEnumerable.call(t, e)) return t[e];
            }
        };
        var p = function p(t, e, r, n, o, i) {
            if (this.types.object(t) && (!e.properties || void 0 === e.properties[o])) {
                if (!1 === e.additionalProperties) i.addError({
                    name: "additionalProperties",
                    argument: o,
                    message: "is not allowed to have the additional property " + JSON.stringify(o)
                });
                else {
                    var a = e.additionalProperties || {};
                    "function" == typeof r.preValidateProperty && r.preValidateProperty(t, o, a, r, n);
                    var c = this.validateSchema(t[o], a, r, n.makeChild(a, o));
                    c.instance !== i.instance[o] && (i.instance[o] = c.instance), i.importErrors(c);
                }
            }
        };
        var f = function f(t, e, r) {
            var _$o, i = r.length;
            for(_$o = e + 1; _$o < i; _$o++)if (n.deepCompareStrict(t, r[_$o])) return !1;
            return !0;
        };
        var n = r(1371), _$o = n.ValidatorResult, i = n.SchemaError, a = {
            ignoreProperties: {
                id: !0,
                "default": !0,
                description: !0,
                title: !0,
                additionalItems: !0,
                then: !0,
                "else": !0,
                $schema: !0,
                $ref: !0,
                "extends": !0
            }
        }, c = a.validators = {};
        c.type = function(t, e, r, n) {
            if (void 0 === t) return null;
            var i = new _$o(t, e, r, n), a = Array.isArray(e.type) ? e.type : [
                e.type
            ];
            if (!a.some(this.testType.bind(this, t, e, r, n))) {
                var c = a.map(function(t) {
                    if (t) {
                        var _$e = t.$id || t.id;
                        return _$e ? "<" + _$e + ">" : t + "";
                    }
                });
                i.addError({
                    name: "type",
                    argument: c,
                    message: "is not of a type(s) " + c
                });
            }
            return i;
        }, c.anyOf = function(t, e, r, n) {
            if (void 0 === t) return null;
            var a = new _$o(t, e, r, n), c = new _$o(t, e, r, n);
            if (!Array.isArray(e.anyOf)) throw new i("anyOf must be an array");
            if (!e.anyOf.some(s.bind(this, t, r, n, function(t) {
                c.importErrors(t);
            }))) {
                var u = e.anyOf.map(function(t, e) {
                    var _$r = t.$id || t.id;
                    return _$r ? "<" + _$r + ">" : t.title && JSON.stringify(t.title) || t.$ref && "<" + t.$ref + ">" || "[subschema " + e + "]";
                });
                r.nestedErrors && a.importErrors(c), a.addError({
                    name: "anyOf",
                    argument: u,
                    message: "is not any of " + u.join(",")
                });
            }
            return a;
        }, c.allOf = function(t, e, r, n) {
            if (void 0 === t) return null;
            if (!Array.isArray(e.allOf)) throw new i("allOf must be an array");
            var a = new _$o(t, e, r, n), c = this;
            return e.allOf.forEach(function(e, o) {
                var i = c.validateSchema(t, e, r, n);
                if (!i.valid) {
                    var s = e.$id || e.id || e.title && JSON.stringify(e.title) || e.$ref && "<" + e.$ref + ">" || "[subschema " + o + "]";
                    a.addError({
                        name: "allOf",
                        argument: {
                            id: s,
                            length: i.errors.length,
                            valid: i
                        },
                        message: "does not match allOf schema " + s + " with " + i.errors.length + " error[s]:"
                    }), a.importErrors(i);
                }
            }), a;
        }, c.oneOf = function(t, e, r, n) {
            if (void 0 === t) return null;
            if (!Array.isArray(e.oneOf)) throw new i("oneOf must be an array");
            var a = new _$o(t, e, r, n), c = new _$o(t, e, r, n), u = e.oneOf.filter(s.bind(this, t, r, n, function(t) {
                c.importErrors(t);
            })).length, p = e.oneOf.map(function(t, e) {
                return t.$id || t.id || t.title && JSON.stringify(t.title) || t.$ref && "<" + t.$ref + ">" || "[subschema " + e + "]";
            });
            return 1 !== u && (r.nestedErrors && a.importErrors(c), a.addError({
                name: "oneOf",
                argument: p,
                message: "is not exactly one from " + p.join(",")
            })), a;
        }, c["if"] = function(t, e, r, i) {
            if (void 0 === t) return null;
            if (!n.isSchema(e["if"])) throw new Error('Expected "if" keyword to be a schema');
            var a, c = s.call(this, t, r, i, null, e["if"]), u = new _$o(t, e, r, i);
            if (c) {
                if (void 0 === e.then) return;
                if (!n.isSchema(e.then)) throw new Error('Expected "then" keyword to be a schema');
                a = this.validateSchema(t, e.then, r, i.makeChild(e.then)), u.importErrors(a);
            } else {
                if (void 0 === e["else"]) return;
                if (!n.isSchema(e["else"])) throw new Error('Expected "else" keyword to be a schema');
                a = this.validateSchema(t, e["else"], r, i.makeChild(e["else"])), u.importErrors(a);
            }
            return u;
        }, c.propertyNames = function(t, e, r, a) {
            if (this.types.object(t)) {
                var c = new _$o(t, e, r, a), s = void 0 !== e.propertyNames ? e.propertyNames : {};
                if (!n.isSchema(s)) throw new i('Expected "propertyNames" to be a schema (object or boolean)');
                for(var p in t)if (void 0 !== u(t, p)) {
                    var l = this.validateSchema(p, s, r, a.makeChild(s));
                    c.importErrors(l);
                }
                return c;
            }
        }, c.properties = function(t, e, r, n) {
            if (this.types.object(t)) {
                var a = new _$o(t, e, r, n), c = e.properties || {};
                for(var s in c){
                    var p = c[s];
                    if (void 0 !== p) {
                        if (null === p) throw new i('Unexpected null, expected schema in "properties"');
                        "function" == typeof r.preValidateProperty && r.preValidateProperty(t, s, p, r, n);
                        var l = u(t, s), f = this.validateSchema(l, p, r, n.makeChild(p, s));
                        f.instance !== a.instance[s] && (a.instance[s] = f.instance), a.importErrors(f);
                    }
                }
                return a;
            }
        }, c.patternProperties = function(t, e, r, n) {
            if (this.types.object(t)) {
                var a = new _$o(t, e, r, n), c = e.patternProperties || {};
                for(var s in t){
                    var u = !0;
                    for(var l in c){
                        var f = c[l];
                        if (void 0 !== f) {
                            if (null === f) throw new i('Unexpected null, expected schema in "patternProperties"');
                            try {
                                var h = new RegExp(l, "u");
                            } catch (t) {
                                h = new RegExp(l);
                            }
                            if (h.test(s)) {
                                u = !1, "function" == typeof r.preValidateProperty && r.preValidateProperty(t, s, f, r, n);
                                var d = this.validateSchema(t[s], f, r, n.makeChild(f, s));
                                d.instance !== a.instance[s] && (a.instance[s] = d.instance), a.importErrors(d);
                            }
                        }
                    }
                    u && p.call(this, t, e, r, n, s, a);
                }
                return a;
            }
        }, c.additionalProperties = function(t, e, r, n) {
            if (this.types.object(t)) {
                if (e.patternProperties) return null;
                var i = new _$o(t, e, r, n);
                for(var a in t)p.call(this, t, e, r, n, a, i);
                return i;
            }
        }, c.minProperties = function(t, e, r, n) {
            if (this.types.object(t)) {
                var i = new _$o(t, e, r, n);
                return Object.keys(t).length >= e.minProperties || i.addError({
                    name: "minProperties",
                    argument: e.minProperties,
                    message: "does not meet minimum property length of " + e.minProperties
                }), i;
            }
        }, c.maxProperties = function(t, e, r, n) {
            if (this.types.object(t)) {
                var i = new _$o(t, e, r, n);
                return Object.keys(t).length <= e.maxProperties || i.addError({
                    name: "maxProperties",
                    argument: e.maxProperties,
                    message: "does not meet maximum property length of " + e.maxProperties
                }), i;
            }
        }, c.items = function(t, e, r, n) {
            var i = this;
            if (this.types.array(t) && void 0 !== e.items) {
                var a = new _$o(t, e, r, n);
                return t.every(function(t, o) {
                    if (Array.isArray(e.items)) var c = void 0 === e.items[o] ? e.additionalItems : e.items[o];
                    else c = e.items;
                    if (void 0 === c) return !0;
                    if (!1 === c) return a.addError({
                        name: "items",
                        message: "additionalItems not permitted"
                    }), !1;
                    var s = i.validateSchema(t, c, r, n.makeChild(c, o));
                    return s.instance !== a.instance[o] && (a.instance[o] = s.instance), a.importErrors(s), !0;
                }), a;
            }
        }, c.contains = function(t, e, r, i) {
            var a = this;
            if (this.types.array(t) && void 0 !== e.contains) {
                if (!n.isSchema(e.contains)) throw new Error('Expected "contains" keyword to be a schema');
                var c = new _$o(t, e, r, i);
                return !1 === t.some(function(t, n) {
                    return 0 === a.validateSchema(t, e.contains, r, i.makeChild(e.contains, n)).errors.length;
                }) && c.addError({
                    name: "contains",
                    argument: e.contains,
                    message: "must contain an item matching given schema"
                }), c;
            }
        }, c.minimum = function(t, e, r, n) {
            if (this.types.number(t)) {
                var i = new _$o(t, e, r, n);
                return e.exclusiveMinimum && !0 === e.exclusiveMinimum ? t > e.minimum || i.addError({
                    name: "minimum",
                    argument: e.minimum,
                    message: "must be greater than " + e.minimum
                }) : t >= e.minimum || i.addError({
                    name: "minimum",
                    argument: e.minimum,
                    message: "must be greater than or equal to " + e.minimum
                }), i;
            }
        }, c.maximum = function(t, e, r, n) {
            if (this.types.number(t)) {
                var i = new _$o(t, e, r, n);
                return e.exclusiveMaximum && !0 === e.exclusiveMaximum ? t < e.maximum || i.addError({
                    name: "maximum",
                    argument: e.maximum,
                    message: "must be less than " + e.maximum
                }) : t <= e.maximum || i.addError({
                    name: "maximum",
                    argument: e.maximum,
                    message: "must be less than or equal to " + e.maximum
                }), i;
            }
        }, c.exclusiveMinimum = function(t, e, r, n) {
            if ("boolean" != typeof e.exclusiveMinimum && this.types.number(t)) {
                var i = new _$o(t, e, r, n);
                return t > e.exclusiveMinimum || i.addError({
                    name: "exclusiveMinimum",
                    argument: e.exclusiveMinimum,
                    message: "must be strictly greater than " + e.exclusiveMinimum
                }), i;
            }
        }, c.exclusiveMaximum = function(t, e, r, n) {
            if ("boolean" != typeof e.exclusiveMaximum && this.types.number(t)) {
                var i = new _$o(t, e, r, n);
                return t < e.exclusiveMaximum || i.addError({
                    name: "exclusiveMaximum",
                    argument: e.exclusiveMaximum,
                    message: "must be strictly less than " + e.exclusiveMaximum
                }), i;
            }
        };
        var l = function l(t, e, r, a, c, s) {
            if (this.types.number(t)) {
                var u = e[c];
                if (0 == u) throw new i(c + " cannot be zero");
                var p = new _$o(t, e, r, a), l = n.getDecimalPlaces(t), f = n.getDecimalPlaces(u), h = Math.max(l, f), d = Math.pow(10, h);
                return Math.round(t * d) % Math.round(u * d) != 0 && p.addError({
                    name: c,
                    argument: u,
                    message: s + JSON.stringify(u)
                }), p;
            }
        };
        c.multipleOf = function(t, e, r, n) {
            return l.call(this, t, e, r, n, "multipleOf", "is not a multiple of (divisible by) ");
        }, c.divisibleBy = function(t, e, r, n) {
            return l.call(this, t, e, r, n, "divisibleBy", "is not divisible by (multiple of) ");
        }, c.required = function(t, e, r, n) {
            var i = new _$o(t, e, r, n);
            return void 0 === t && !0 === e.required ? i.addError({
                name: "required",
                message: "is required"
            }) : this.types.object(t) && Array.isArray(e.required) && e.required.forEach(function(e) {
                void 0 === u(t, e) && i.addError({
                    name: "required",
                    argument: e,
                    message: "requires property " + JSON.stringify(e)
                });
            }), i;
        }, c.pattern = function(t, e, r, n) {
            if (this.types.string(t)) {
                var i = new _$o(t, e, r, n), a = e.pattern;
                try {
                    var c = new RegExp(a, "u");
                } catch (t) {
                    c = new RegExp(a);
                }
                return t.match(c) || i.addError({
                    name: "pattern",
                    argument: e.pattern,
                    message: "does not match pattern " + JSON.stringify(e.pattern.toString())
                }), i;
            }
        }, c.format = function(t, e, r, i) {
            if (void 0 !== t) {
                var a = new _$o(t, e, r, i);
                return a.disableFormat || n.isFormat(t, e.format, this) || a.addError({
                    name: "format",
                    argument: e.format,
                    message: "does not conform to the " + JSON.stringify(e.format) + " format"
                }), a;
            }
        }, c.minLength = function(t, e, r, n) {
            if (this.types.string(t)) {
                var i = new _$o(t, e, r, n), a = t.match(/[\uDC00-\uDFFF]/g);
                return t.length - (a ? a.length : 0) >= e.minLength || i.addError({
                    name: "minLength",
                    argument: e.minLength,
                    message: "does not meet minimum length of " + e.minLength
                }), i;
            }
        }, c.maxLength = function(t, e, r, n) {
            if (this.types.string(t)) {
                var i = new _$o(t, e, r, n), a = t.match(/[\uDC00-\uDFFF]/g);
                return t.length - (a ? a.length : 0) <= e.maxLength || i.addError({
                    name: "maxLength",
                    argument: e.maxLength,
                    message: "does not meet maximum length of " + e.maxLength
                }), i;
            }
        }, c.minItems = function(t, e, r, n) {
            if (this.types.array(t)) {
                var i = new _$o(t, e, r, n);
                return t.length >= e.minItems || i.addError({
                    name: "minItems",
                    argument: e.minItems,
                    message: "does not meet minimum length of " + e.minItems
                }), i;
            }
        }, c.maxItems = function(t, e, r, n) {
            if (this.types.array(t)) {
                var i = new _$o(t, e, r, n);
                return t.length <= e.maxItems || i.addError({
                    name: "maxItems",
                    argument: e.maxItems,
                    message: "does not meet maximum length of " + e.maxItems
                }), i;
            }
        }, c.uniqueItems = function(t, e, r, n) {
            if (!0 === e.uniqueItems && this.types.array(t)) {
                var i = new _$o(t, e, r, n);
                return t.every(f) || i.addError({
                    name: "uniqueItems",
                    message: "contains duplicate item"
                }), i;
            }
        }, c.dependencies = function(t, e, r, n) {
            if (this.types.object(t)) {
                var i = new _$o(t, e, r, n);
                for(var a in e.dependencies)if (void 0 !== t[a]) {
                    var c = e.dependencies[a], s = n.makeChild(c, a);
                    if ("string" == typeof c && (c = [
                        c
                    ]), Array.isArray(c)) c.forEach(function(e) {
                        void 0 === t[e] && i.addError({
                            name: "dependencies",
                            argument: s.propertyPath,
                            message: "property " + e + " not found, required by " + s.propertyPath
                        });
                    });
                    else {
                        var u = this.validateSchema(t, c, r, s);
                        i.instance !== u.instance && (i.instance = u.instance), u && u.errors.length && (i.addError({
                            name: "dependencies",
                            argument: s.propertyPath,
                            message: "does not meet dependency required by " + s.propertyPath
                        }), i.importErrors(u));
                    }
                }
                return i;
            }
        }, c["enum"] = function(t, e, r, a) {
            if (void 0 === t) return null;
            if (!Array.isArray(e["enum"])) throw new i("enum expects an array", e);
            var c = new _$o(t, e, r, a);
            return e["enum"].some(n.deepCompareStrict.bind(null, t)) || c.addError({
                name: "enum",
                argument: e["enum"],
                message: "is not one of enum values: " + e["enum"].map(String).join(",")
            }), c;
        }, c["const"] = function(t, e, r, i) {
            if (void 0 === t) return null;
            var a = new _$o(t, e, r, i);
            return n.deepCompareStrict(e["const"], t) || a.addError({
                name: "const",
                argument: e["const"],
                message: "does not exactly match expected constant: " + e["const"]
            }), a;
        }, c.not = c.disallow = function(t, e, r, n) {
            var i = this;
            if (void 0 === t) return null;
            var a = new _$o(t, e, r, n), c = e.not || e.disallow;
            return c ? (Array.isArray(c) || (c = [
                c
            ]), c.forEach(function(o) {
                if (i.testType(t, e, r, n, o)) {
                    var c = o && (o.$id || o.id) || o;
                    a.addError({
                        name: "not",
                        argument: c,
                        message: "is of prohibited type " + c
                    });
                }
            }), a) : null;
        }, t.exports = a;
    },
    6274: function(t) {
        var n = function n() {};
        var _$o = function _$o(t, e, r) {
            this.fn = t, this.context = e, this.once = r || !1;
        };
        var i = function i(t, e, n, _i, a) {
            if ("function" != typeof n) throw new TypeError("The listener must be a function");
            var c = new _$o(n, _i || t, a), s = r ? r + e : e;
            return t._events[s] ? t._events[s].fn ? t._events[s] = [
                t._events[s],
                c
            ] : t._events[s].push(c) : (t._events[s] = c, t._eventsCount++), t;
        };
        var a = function a(t, e) {
            0 == --t._eventsCount ? t._events = new n : delete t._events[e];
        };
        var c = function c() {
            this._events = new n, this._eventsCount = 0;
        };
        var e = Object.prototype.hasOwnProperty, r = "~";
        Object.create && (n.prototype = Object.create(null), (new n).__proto__ || (r = !1)), c.prototype.eventNames = function() {
            var _$t, n, _$o = [];
            if (0 === this._eventsCount) return _$o;
            for(n in _$t = this._events)e.call(_$t, n) && _$o.push(r ? n.slice(1) : n);
            return Object.getOwnPropertySymbols ? _$o.concat(Object.getOwnPropertySymbols(_$t)) : _$o;
        }, c.prototype.listeners = function(t) {
            var e = r ? r + t : t, n = this._events[e];
            if (!n) return [];
            if (n.fn) return [
                n.fn
            ];
            for(var _$o = 0, i = n.length, a = new Array(i); _$o < i; _$o++)a[_$o] = n[_$o].fn;
            return a;
        }, c.prototype.listenerCount = function(t) {
            var e = r ? r + t : t, n = this._events[e];
            return n ? n.fn ? 1 : n.length : 0;
        }, c.prototype.emit = function(t, e, n, o, i, a) {
            var c = r ? r + t : t;
            if (!this._events[c]) return !1;
            var s, u, p = this._events[c], l = arguments.length;
            if (p.fn) {
                switch(p.once && this.removeListener(t, p.fn, void 0, !0), l){
                    case 1:
                        return p.fn.call(p.context), !0;
                    case 2:
                        return p.fn.call(p.context, e), !0;
                    case 3:
                        return p.fn.call(p.context, e, n), !0;
                    case 4:
                        return p.fn.call(p.context, e, n, o), !0;
                    case 5:
                        return p.fn.call(p.context, e, n, o, i), !0;
                    case 6:
                        return p.fn.call(p.context, e, n, o, i, a), !0;
                }
                for(u = 1, s = new Array(l - 1); u < l; u++)s[u - 1] = arguments[u];
                p.fn.apply(p.context, s);
            } else {
                var f, h = p.length;
                for(u = 0; u < h; u++)switch(p[u].once && this.removeListener(t, p[u].fn, void 0, !0), l){
                    case 1:
                        p[u].fn.call(p[u].context);
                        break;
                    case 2:
                        p[u].fn.call(p[u].context, e);
                        break;
                    case 3:
                        p[u].fn.call(p[u].context, e, n);
                        break;
                    case 4:
                        p[u].fn.call(p[u].context, e, n, o);
                        break;
                    default:
                        if (!s) for(f = 1, s = new Array(l - 1); f < l; f++)s[f - 1] = arguments[f];
                        p[u].fn.apply(p[u].context, s);
                }
            }
            return !0;
        }, c.prototype.on = function(t, e, r) {
            return i(this, t, e, r, !1);
        }, c.prototype.once = function(t, e, r) {
            return i(this, t, e, r, !0);
        }, c.prototype.removeListener = function(t, e, n, o) {
            var i = r ? r + t : t;
            if (!this._events[i]) return this;
            if (!e) return a(this, i), this;
            var c = this._events[i];
            if (c.fn) c.fn !== e || o && !c.once || n && c.context !== n || a(this, i);
            else {
                for(var s = 0, u = [], p = c.length; s < p; s++)(c[s].fn !== e || o && !c[s].once || n && c[s].context !== n) && u.push(c[s]);
                u.length ? this._events[i] = 1 === u.length ? u[0] : u : a(this, i);
            }
            return this;
        }, c.prototype.removeAllListeners = function(t) {
            var e;
            return t ? (e = r ? r + t : t, this._events[e] && a(this, e)) : (this._events = new n, this._eventsCount = 0), this;
        }, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, t.exports = c;
    },
    6402: function(t, e, r) {
        var n = r(1953), _$o = r(8657), i = r(2629), a = r(3221), c = r(3441) || a || i;
        t.exports = function() {
            var _$t, e = {
                assert: function assert(t) {
                    if (!e.has(t)) throw new n("Side channel does not contain " + _$o(t));
                },
                "delete": function _delete(e) {
                    return !!_$t && _$t["delete"](e);
                },
                get: function get(e) {
                    return _$t && _$t.get(e);
                },
                has: function has(e) {
                    return !!_$t && _$t.has(e);
                },
                set: function set(e, r) {
                    _$t || (_$t = c()), _$t.set(e, r);
                }
            };
            return e;
        };
    },
    6681: function(t) {
        t.exports = Number.isNaN || function(t) {
            return t != t;
        };
    },
    6773: function(t, e) {
        e.L = function(t, e, r, n, o) {
            var i, a, c = 8 * o - n - 1, s = (1 << c) - 1, u = s >> 1, p = -7, l = r ? o - 1 : 0, f = r ? -1 : 1, h = t[e + l];
            for(l += f, i = h & (1 << -p) - 1, h >>= -p, p += c; p > 0; i = 256 * i + t[e + l], l += f, p -= 8);
            for(a = i & (1 << -p) - 1, i >>= -p, p += n; p > 0; a = 256 * a + t[e + l], l += f, p -= 8);
            if (0 === i) i = 1 - u;
            else {
                if (i === s) return a ? NaN : 1 / 0 * (h ? -1 : 1);
                a += Math.pow(2, n), i -= u;
            }
            return (h ? -1 : 1) * a * Math.pow(2, i - n);
        }, e.M = function(t, e, r, n, o, i) {
            var a, c, s, u = 8 * i - o - 1, p = (1 << u) - 1, l = p >> 1, f = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : i - 1, d = n ? 1 : -1, m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
            for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (c = isNaN(e) ? 1 : 0, a = p) : (a = Math.floor(Math.log(e) / Math.LN2), e * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), (e += a + l >= 1 ? f / s : f * Math.pow(2, 1 - l)) * s >= 2 && (a++, s /= 2), a + l >= p ? (c = 0, a = p) : a + l >= 1 ? (c = (e * s - 1) * Math.pow(2, o), a += l) : (c = e * Math.pow(2, l - 1) * Math.pow(2, o), a = 0)); o >= 8; t[r + h] = 255 & c, h += d, c /= 256, o -= 8);
            for(a = a << o | c, u += o; u > 0; t[r + h] = 255 & a, h += d, a /= 256, u -= 8);
            t[r + h - d] |= 128 * m;
        };
    },
    6854: function(t, e, r) {
        r.d(e, {
            S: function() {
                return a;
            }
        });
        var n = r(9653), _$o = r(1227), i = r.n(_$o)()("fs:request:shouldRetry"), a = function a(t) {
            switch(i("Checking error for retry. Code: %n, type: %s", t.response ? t.response.status : "Malformed response", t.code), t.code){
                case n.E.NETWORK:
                case n.E.SERVER:
                case n.E.TIMEOUT:
                    return !0;
                case n.E.ABORTED:
                    return !1;
            }
            return !!t.response && 500 <= t.response.status && t.response.status <= 599;
        };
    },
    6889: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = r(6402), i = r(4509), a = r(9292), c = Object.prototype.hasOwnProperty, s = {
            brackets: function brackets(t) {
                return t + "[]";
            },
            comma: "comma",
            indices: function indices(t, e) {
                return t + "[" + e + "]";
            },
            repeat: function repeat(t) {
                return t;
            }
        }, u = Array.isArray, p = Array.prototype.push, l = function l(t, e) {
            p.apply(t, u(e) ? e : [
                e
            ]);
        }, f = Date.prototype.toISOString, h = a["default"], d = {
            addQueryPrefix: !1,
            allowDots: !1,
            allowEmptyArrays: !1,
            arrayFormat: "indices",
            charset: "utf-8",
            charsetSentinel: !1,
            commaRoundTrip: !1,
            delimiter: "&",
            encode: !0,
            encodeDotInKeys: !1,
            encoder: i.encode,
            encodeValuesOnly: !1,
            filter: void 0,
            format: h,
            formatter: a.formatters[h],
            indices: !1,
            serializeDate: function serializeDate(t) {
                return f.call(t);
            },
            skipNulls: !1,
            strictNullHandling: !1
        }, m = {}, y = function t(e, r, a, c, s, p, f, h, y, v, g, b, x, w, k, S, E, O) {
            for(var j = e, F = O, _ = 0, P = !1; void 0 !== (F = F.get(m)) && !P;){
                var A = F.get(e);
                if (_ += 1, void 0 !== A) {
                    if (A === _) throw new RangeError("Cyclic object value");
                    P = !0;
                }
                void 0 === F.get(m) && (_ = 0);
            }
            if ("function" == typeof v ? j = v(r, j) : j instanceof Date ? j = x(j) : "comma" === a && u(j) && (j = i.maybeMap(j, function(t) {
                return t instanceof Date ? x(t) : t;
            })), null === j) {
                if (p) return y && !S ? y(r, d.encoder, E, "key", w) : r;
                j = "";
            }
            if (function(t) {
                return "string" == typeof t || "number" == typeof t || "boolean" == typeof t || "symbol" === n(t) || "bigint" == (typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t));
            }(j) || i.isBuffer(j)) return y ? [
                k(S ? r : y(r, d.encoder, E, "key", w)) + "=" + k(y(j, d.encoder, E, "value", w))
            ] : [
                k(r) + "=" + k(String(j))
            ];
            var T, D = [];
            if (void 0 === j) return D;
            if ("comma" === a && u(j)) S && y && (j = i.maybeMap(j, y)), T = [
                {
                    value: j.length > 0 ? j.join(",") || null : void 0
                }
            ];
            else if (u(v)) T = v;
            else {
                var L = Object.keys(j);
                T = g ? L.sort(g) : L;
            }
            var C = h ? String(r).replace(/\./g, "%2E") : String(r), I = c && u(j) && 1 === j.length ? C + "[]" : C;
            if (s && u(j) && 0 === j.length) return I + "[]";
            for(var z = 0; z < T.length; ++z){
                var N = T[z], R = "object" === n(N) && N && void 0 !== N.value ? N.value : j[N];
                if (!f || null !== R) {
                    var M = b && h ? String(N).replace(/\./g, "%2E") : String(N), B = u(j) ? "function" == typeof a ? a(I, M) : I : I + (b ? "." + M : "[" + M + "]");
                    O.set(e, _);
                    var U = _$o();
                    U.set(m, O), l(D, t(R, B, a, c, s, p, f, h, "comma" === a && S && u(j) ? null : y, v, g, b, x, w, k, S, E, U));
                }
            }
            return D;
        };
        t.exports = function(t, e) {
            var _$r, i = t, p = function(t) {
                if (!t) return d;
                if (void 0 !== t.allowEmptyArrays && "boolean" != typeof t.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
                if (void 0 !== t.encodeDotInKeys && "boolean" != typeof t.encodeDotInKeys) throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
                if (null !== t.encoder && void 0 !== t.encoder && "function" != typeof t.encoder) throw new TypeError("Encoder has to be a function.");
                var _$e = t.charset || d.charset;
                if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                var _$r = a["default"];
                if (void 0 !== t.format) {
                    if (!c.call(a.formatters, t.format)) throw new TypeError("Unknown format option provided.");
                    _$r = t.format;
                }
                var _$n, _$o = a.formatters[_$r], i = d.filter;
                if (("function" == typeof t.filter || u(t.filter)) && (i = t.filter), _$n = t.arrayFormat in s ? t.arrayFormat : "indices" in t ? t.indices ? "indices" : "repeat" : d.arrayFormat, "commaRoundTrip" in t && "boolean" != typeof t.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
                var p = void 0 === t.allowDots ? !0 === t.encodeDotInKeys || d.allowDots : !!t.allowDots;
                return {
                    addQueryPrefix: "boolean" == typeof t.addQueryPrefix ? t.addQueryPrefix : d.addQueryPrefix,
                    allowDots: p,
                    allowEmptyArrays: "boolean" == typeof t.allowEmptyArrays ? !!t.allowEmptyArrays : d.allowEmptyArrays,
                    arrayFormat: _$n,
                    charset: _$e,
                    charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : d.charsetSentinel,
                    commaRoundTrip: !!t.commaRoundTrip,
                    delimiter: void 0 === t.delimiter ? d.delimiter : t.delimiter,
                    encode: "boolean" == typeof t.encode ? t.encode : d.encode,
                    encodeDotInKeys: "boolean" == typeof t.encodeDotInKeys ? t.encodeDotInKeys : d.encodeDotInKeys,
                    encoder: "function" == typeof t.encoder ? t.encoder : d.encoder,
                    encodeValuesOnly: "boolean" == typeof t.encodeValuesOnly ? t.encodeValuesOnly : d.encodeValuesOnly,
                    filter: i,
                    format: _$r,
                    formatter: _$o,
                    serializeDate: "function" == typeof t.serializeDate ? t.serializeDate : d.serializeDate,
                    skipNulls: "boolean" == typeof t.skipNulls ? t.skipNulls : d.skipNulls,
                    sort: "function" == typeof t.sort ? t.sort : null,
                    strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : d.strictNullHandling
                };
            }(e);
            "function" == typeof p.filter ? i = (0, p.filter)("", i) : u(p.filter) && (_$r = p.filter);
            var f = [];
            if ("object" !== n(i) || null === i) return "";
            var h = s[p.arrayFormat], m = "comma" === h && p.commaRoundTrip;
            _$r || (_$r = Object.keys(i)), p.sort && _$r.sort(p.sort);
            for(var v = _$o(), _$g = 0; _$g < _$r.length; ++_$g){
                var b = _$r[_$g], x = i[b];
                p.skipNulls && null === x || l(f, y(x, b, h, m, p.allowEmptyArrays, p.strictNullHandling, p.skipNulls, p.encodeDotInKeys, p.encode ? p.encoder : null, p.filter, p.sort, p.allowDots, p.serializeDate, p.format, p.formatter, p.encodeValuesOnly, p.charset, v));
            }
            var w = f.join(p.delimiter), k = !0 === p.addQueryPrefix ? "?" : "";
            return p.charsetSentinel && ("iso-8859-1" === p.charset ? k += "utf8=%26%2310003%3B&" : k += "utf8=%E2%9C%93&"), w.length > 0 ? k + w : "";
        };
    },
    6947: function(t, e, r) {
        var c = function c(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var v = function v(t, e) {
            0 !== e.length && (t.push(String.fromCharCode.apply(null, e)), e.length = 0);
        };
        var _$g = function _$g(t, e, r) {
            e.push(r), e.length >= m && v(t, e);
        };
        var b = function b(t, e, r) {
            r <= 65535 ? _$g(t, e, r) : (_$g(t, e, 55296 + ((r -= 65536) >> 10)), _$g(t, e, 56320 + (1023 & r)));
        };
        var w = function w(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, k(n.key), n);
            }
        };
        var k = function k(t) {
            var _$e = function(t) {
                if ("object" != x(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != x(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == x(_$e) ? _$e : String(_$e);
        };
        var S = function S(t) {
            return new DataView(t.buffer, t.byteOffset);
        };
        var q = function q(t, e) {
            var _$r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!_$r) {
                if (Array.isArray(t) || (_$r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return G(t, e);
                        var _$r = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? G(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    _$r && (t = _$r);
                    var n = 0, _$o = function o() {};
                    return {
                        s: _$o,
                        n: function n1() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function e(t) {
                            throw t;
                        },
                        f: _$o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, c = !1;
            return {
                s: function s() {
                    _$r = _$r.call(t);
                },
                n: function n() {
                    var _$t = _$r.next();
                    return a = _$t.done, _$t;
                },
                e: function e(t) {
                    c = !0, i = t;
                },
                f: function f() {
                    try {
                        a || null == _$r["return"] || _$r["return"]();
                    } finally{
                        if (c) throw i;
                    }
                }
            };
        };
        var G = function G(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var Z = function Z(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var V = function V(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        Z(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        Z(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var H = function H(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Y(n.key), n);
            }
        };
        var Y = function Y(t) {
            var _$e = function(t) {
                if ("object" != U(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != U(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == U(_$e) ? _$e : String(_$e);
        };
        var W = function W(t) {
            var _$e = new Uint8Array(F.len);
            return F.put(_$e, 0, t), _$e;
        };
        var et = function et(t, e) {
            var _$r = t.length, n = e.length;
            if (n > _$r) return -1;
            for(var _$o = 0; _$o <= _$r - n; _$o++){
                for(var i = !0, a = 0; a < n; a++)if (t[_$o + a] !== e[a]) {
                    i = !1;
                    break;
                }
                if (i) return _$o;
            }
            return -1;
        };
        var rt = function rt(t) {
            var _$e, _$r = t.reduce(function(t, e) {
                return t + e.length;
            }, 0), n = new Uint8Array(_$r), _$o = 0, i = q(t);
            try {
                for(i.s(); !(_$e = i.n()).done;){
                    var a = _$e.value;
                    n.set(a, _$o), _$o += a.length;
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
            return n;
        };
        var it = function it(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var at = function at(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, ct(n.key), n);
            }
        };
        var ct = function ct(t) {
            var _$e = function(t) {
                if ("object" != nt(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != nt(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == nt(_$e) ? _$e : String(_$e);
        };
        var ut = function ut(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var ft = function ft(t) {
            return function(t, e, r) {
                return !!t && (t.constructor === e || lt.call(t) === r);
            }(t, Uint8Array, "[object Uint8Array]");
        };
        var ht = function ht(t) {
            if (!ft(t)) throw new TypeError("Expected `Uint8Array`, got `".concat(pt(t), "`"));
        };
        var dt = function dt(t, e) {
            var _$r;
            if (0 === t.length) return new Uint8Array(0);
            null !== (_$r = e) && void 0 !== _$r || (e = t.reduce(function(t, e) {
                return t + e.length;
            }, 0));
            var n, _$o = new Uint8Array(e), i = 0, a = function(t, e) {
                var _$r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (!_$r) {
                    if (Array.isArray(t) || (_$r = function(t, e) {
                        if (t) {
                            if ("string" == typeof t) return ut(t, e);
                            var _$r = Object.prototype.toString.call(t).slice(8, -1);
                            return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? ut(t, e) : void 0;
                        }
                    }(t)) || e && t && "number" == typeof t.length) {
                        _$r && (t = _$r);
                        var n = 0, _$o = function o() {};
                        return {
                            s: _$o,
                            n: function n1() {
                                return n >= t.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: t[n++]
                                };
                            },
                            e: function e(t) {
                                throw t;
                            },
                            f: _$o
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var i, a = !0, c = !1;
                return {
                    s: function s() {
                        _$r = _$r.call(t);
                    },
                    n: function n() {
                        var _$t = _$r.next();
                        return a = _$t.done, _$t;
                    },
                    e: function e(t) {
                        c = !0, i = t;
                    },
                    f: function f() {
                        try {
                            a || null == _$r["return"] || _$r["return"]();
                        } finally{
                            if (c) throw i;
                        }
                    }
                };
            }(t);
            try {
                for(a.s(); !(n = a.n()).done;){
                    var c = n.value;
                    ht(c), _$o.set(c, i), i += c.length;
                }
            } catch (t) {
                a.e(t);
            } finally{
                a.f();
            }
            return _$o;
        };
        var mt = function mt(t) {
            var _$e = t.byteLength;
            return 6 === _$e ? t.getUint16(0) * Math.pow(2, 32) + t.getUint32(2) : 5 === _$e ? t.getUint8(0) * Math.pow(2, 32) + t.getUint32(1) : 4 === _$e ? t.getUint32(0) : 3 === _$e ? t.getUint8(0) * Math.pow(2, 16) + t.getUint16(1) : 2 === _$e ? t.getUint16(0) : 1 === _$e ? t.getUint8(0) : void 0;
        };
        var yt = function yt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var vt = function vt(t) {
            var _$e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, _$r = Number.parseInt(new T(6).get(t, 148).replace(/\0(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF])*$/, "").trim(), 8);
            if (Number.isNaN(_$r)) return !1;
            for(var n = 256, _$o = _$e; _$o < _$e + 148; _$o++)n += t[_$o];
            for(var i = _$e + 156; i < _$e + 512; i++)n += t[i];
            return _$r === n;
        };
        var wt = function wt(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var _$r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != _$r) {
                    var n, _$o, i, a, c = [], s = !0, u = !1;
                    try {
                        if (i = (_$r = _$r.call(t)).next, 0 === e) {
                            if (Object(_$r) !== _$r) return;
                            s = !1;
                        } else for(; !(s = (n = i.call(_$r)).done) && (c.push(n.value), c.length !== e); s = !0);
                    } catch (t) {
                        u = !0, _$o = t;
                    } finally{
                        try {
                            if (!s && null != _$r["return"] && (a = _$r["return"](), Object(a) !== a)) return;
                        } finally{
                            if (u) throw _$o;
                        }
                    }
                    return c;
                }
            }(t, e) || kt(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var kt = function kt(t, e) {
            if (t) {
                if ("string" == typeof t) return St(t, e);
                var _$r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? St(t, e) : void 0;
            }
        };
        var St = function St(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var Et = function Et(t, e) {
            var _$r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), _$r.push.apply(_$r, n);
            }
            return _$r;
        };
        var Ot = function Ot(t) {
            for(var _$e = 1; _$e < arguments.length; _$e++){
                var _$r = null != arguments[_$e] ? arguments[_$e] : {};
                _$e % 2 ? Et(Object(_$r), !0).forEach(function(e) {
                    var n, _$o, i;
                    n = t, _$o = e, i = _$r[e], (_$o = _t(_$o)) in n ? Object.defineProperty(n, _$o, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : n[_$o] = i;
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(_$r)) : Et(Object(_$r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(_$r, e));
                });
            }
            return t;
        };
        var jt = function jt(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var Ft = function Ft(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        jt(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        jt(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var _t = function _t(t) {
            var _$e = function(t) {
                if ("object" != bt(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != bt(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == bt(_$e) ? _$e : String(_$e);
        };
        var Tt = function Tt() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        };
        var zt = function zt(t, e, r) {
            if (!Number.isFinite(t) || t < 0 || t > e) throw new It("".concat(r, " has invalid size ").concat(t, " (maximum ").concat(e, " bytes)"));
            return t;
        };
        var Nt = function Nt(t, e) {
            return Rt.apply(this, arguments);
        };
        var Mt = function Mt(t, e, r) {
            return Bt.apply(this, arguments);
        };
        var Ut = function Ut(t, e, r) {
            r = Ot({
                offset: 0
            }, r);
            var n, _$o = function(t) {
                var _$e = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (!_$e) {
                    if (Array.isArray(t) || (_$e = kt(t))) {
                        _$e && (t = _$e);
                        var _$r = 0, n = function n() {};
                        return {
                            s: n,
                            n: function n() {
                                return _$r >= t.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: t[_$r++]
                                };
                            },
                            e: function e(t) {
                                throw t;
                            },
                            f: n
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var _$o, i = !0, a = !1;
                return {
                    s: function s() {
                        _$e = _$e.call(t);
                    },
                    n: function n() {
                        var _$t = _$e.next();
                        return i = _$t.done, _$t;
                    },
                    e: function e(t) {
                        a = !0, _$o = t;
                    },
                    f: function f() {
                        try {
                            i || null == _$e["return"] || _$e["return"]();
                        } finally{
                            if (a) throw _$o;
                        }
                    }
                };
            }(e.entries());
            try {
                for(_$o.s(); !(n = _$o.n()).done;){
                    var i = wt(n.value, 2), a = i[0], c = i[1];
                    if (r.mask) {
                        if (c !== (r.mask[a] & t[a + r.offset])) return !1;
                    } else if (c !== t[a + r.offset]) return !1;
                }
            } catch (t) {
                _$o.e(t);
            } finally{
                _$o.f();
            }
            return !0;
        };
        var qt = function qt(t) {
            var _$e = t.fileInfo.size;
            return !Number.isFinite(_$e) || _$e === Number.MAX_SAFE_INTEGER;
        };
        var Gt = function Gt(t, e, r) {
            return qt(t) && t.position - e > r;
        };
        var Vt = function Vt(t, e) {
            var _$r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!_$r) {
                if (Array.isArray(t) || (_$r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return Ht(t, e);
                        var _$r = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? Ht(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    _$r && (t = _$r);
                    var n = 0, _$o = function o() {};
                    return {
                        s: _$o,
                        n: function n1() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function e(t) {
                            throw t;
                        },
                        f: _$o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, c = !1;
            return {
                s: function s() {
                    _$r = _$r.call(t);
                },
                n: function n() {
                    var _$t = _$r.next();
                    return a = _$t.done, _$t;
                },
                e: function e(t) {
                    c = !0, i = t;
                },
                f: function f() {
                    try {
                        a || null == _$r["return"] || _$r["return"]();
                    } finally{
                        if (c) throw i;
                    }
                }
            };
        };
        var Ht = function Ht(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var Yt = function Yt(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var Wt = function Wt(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        Yt(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        Yt(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var re = function re(t) {
            return ne.apply(this, arguments);
        };
        var oe = function oe(t, e) {
            var _$r, n = new Uint8Array(e), _$o = 0, i = Vt(t);
            try {
                for(i.s(); !(_$r = i.n()).done;){
                    var a = _$r.value;
                    n.set(a, _$o), _$o += a.length;
                }
            } catch (t) {
                i.e(t);
            } finally{
                i.f();
            }
            return n;
        };
        var ie = function ie(t) {
            if (t instanceof D.d1) return !0;
            if (t instanceof It) return !0;
            if (!(t instanceof Error)) return !1;
            if (Xt.has(t.message)) return !0;
            if (ee.has(t.code)) return !0;
            var _$e, _$r = Vt(te);
            try {
                for(_$r.s(); !(_$e = _$r.n()).done;){
                    var n = _$e.value;
                    if (t.message.startsWith(n)) return !0;
                }
            } catch (t) {
                _$r.e(t);
            } finally{
                _$r.f();
            }
            return !1;
        };
        var ae = function ae(t) {
            for(var _$e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Kt, _$r = 0, n = [
                t.compressedSize,
                t.uncompressedSize
            ]; _$r < n.length; _$r++){
                var _$o = n[_$r];
                if (!Number.isFinite(_$o) || _$o < 0 || _$o > _$e) return !1;
            }
            return !0;
        };
        var ce = function ce(t, e) {
            "Index/Document.iwa" === e && (t.hasDocumentEntry = !0), e.startsWith("Index/MasterSlide") && (t.hasMasterSlideEntry = !0), e.startsWith("Index/Tables/") && (t.hasTablesEntry = !0), "Index/CalculationEngine.iwa" === e && (t.hasCalculationEngineEntry = !0);
        };
        var se = function se(t) {
            if (t.hasDocumentEntry) return t.hasMasterSlideEntry ? {
                ext: "key",
                mime: "application/vnd.apple.keynote"
            } : t.hasTablesEntry ? {
                ext: "numbers",
                mime: "application/vnd.apple.numbers"
            } : {
                ext: "pages",
                mime: "application/vnd.apple.pages"
            };
        };
        var ue = function ue(t) {
            switch(t = t.toLowerCase()){
                case "application/epub+zip":
                    return {
                        ext: "epub",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.text":
                    return {
                        ext: "odt",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.text-template":
                    return {
                        ext: "ott",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.spreadsheet":
                    return {
                        ext: "ods",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.spreadsheet-template":
                    return {
                        ext: "ots",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.presentation":
                    return {
                        ext: "odp",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.presentation-template":
                    return {
                        ext: "otp",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.graphics":
                    return {
                        ext: "odg",
                        mime: t
                    };
                case "application/vnd.oasis.opendocument.graphics-template":
                    return {
                        ext: "otg",
                        mime: t
                    };
                case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
                    return {
                        ext: "ppsx",
                        mime: t
                    };
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return {
                        ext: "xlsx",
                        mime: t
                    };
                case "application/vnd.ms-excel.sheet.macroenabled":
                    return {
                        ext: "xlsm",
                        mime: "application/vnd.ms-excel.sheet.macroenabled.12"
                    };
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
                    return {
                        ext: "xltx",
                        mime: t
                    };
                case "application/vnd.ms-excel.template.macroenabled":
                    return {
                        ext: "xltm",
                        mime: "application/vnd.ms-excel.template.macroenabled.12"
                    };
                case "application/vnd.ms-powerpoint.slideshow.macroenabled":
                    return {
                        ext: "ppsm",
                        mime: "application/vnd.ms-powerpoint.slideshow.macroenabled.12"
                    };
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    return {
                        ext: "docx",
                        mime: t
                    };
                case "application/vnd.ms-word.document.macroenabled":
                    return {
                        ext: "docm",
                        mime: "application/vnd.ms-word.document.macroenabled.12"
                    };
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
                    return {
                        ext: "dotx",
                        mime: t
                    };
                case "application/vnd.ms-word.template.macroenabledtemplate":
                    return {
                        ext: "dotm",
                        mime: "application/vnd.ms-word.template.macroenabled.12"
                    };
                case "application/vnd.openxmlformats-officedocument.presentationml.template":
                    return {
                        ext: "potx",
                        mime: t
                    };
                case "application/vnd.ms-powerpoint.template.macroenabled":
                    return {
                        ext: "potm",
                        mime: "application/vnd.ms-powerpoint.template.macroenabled.12"
                    };
                case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                    return {
                        ext: "pptx",
                        mime: t
                    };
                case "application/vnd.ms-powerpoint.presentation.macroenabled":
                    return {
                        ext: "pptm",
                        mime: "application/vnd.ms-powerpoint.presentation.macroenabled.12"
                    };
                case "application/vnd.ms-visio.drawing":
                    return {
                        ext: "vsdx",
                        mime: "application/vnd.visio"
                    };
                case "application/vnd.ms-package.3dmanufacturing-3dmodel+xml":
                    return {
                        ext: "3mf",
                        mime: "model/3mf"
                    };
            }
        };
        var pe = function pe(t, e) {
            e.startsWith("word/") && (t.hasWordDirectory = !0), e.startsWith("ppt/") && (t.hasPresentationDirectory = !0), e.startsWith("xl/") && (t.hasSpreadsheetDirectory = !0), e.startsWith("3D/") && e.endsWith(".model") && (t.hasThreeDimensionalModelEntry = !0);
        };
        var le = function le(t) {
            return t.hasWordDirectory ? {
                ext: "docx",
                mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            } : t.hasPresentationDirectory ? {
                ext: "pptx",
                mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
            } : t.hasSpreadsheetDirectory ? {
                ext: "xlsx",
                mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            } : t.hasThreeDimensionalModelEntry ? {
                ext: "3mf",
                mime: "model/3mf"
            } : void 0;
        };
        var fe = function fe(t) {
            if (t.hasContentTypesEntry && !t.hasUnparseableContentTypes && !t.isParsingContentTypes && !t.hasParsedContentTypesEntry) return le(t);
        };
        var he = function he(t) {
            var _$e = t.indexOf('.main+xml"');
            if (-1 === _$e) {
                var _$r = "application/vnd.ms-package.3dmanufacturing-3dmodel+xml";
                return t.includes('ContentType="'.concat(_$r, '"')) ? _$r : void 0;
            }
            var n = t.slice(0, _$e), _$o = n.lastIndexOf('"');
            return n.slice(_$o + 1);
        };
        var me = function me(t, e) {
            if (t.length < 16) return -1;
            for(var _$r = t.length - 16, n = 0; n <= _$r; n++)if (F.get(t, n) === de && F.get(t, n + 8) === e + n) return n;
            return -1;
        };
        var ye = function ye(t) {
            return ve.apply(this, arguments);
        };
        var ge = function ge(t, e) {
            return be.apply(this, arguments);
        };
        var xe = function xe(t) {
            return we.apply(this, arguments);
        };
        var Ee = function Ee(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var Oe = function Oe(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        Ee(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        Ee(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var Fe = function Fe(t) {
            return _e.apply(this, arguments);
        };
        var Te = function Te(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var De = function De(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        Te(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        Te(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var Le = function Le(t) {
            return Ce.apply(this, arguments);
        };
        var Ne = function Ne(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var Re = function Re(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        Ne(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        Ne(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var Ue = function Ue(t) {
            return qe.apply(this, arguments);
        };
        var Ge = function Ge(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var _$r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != _$r) {
                    var n, _$o, i, a, c = [], s = !0, u = !1;
                    try {
                        if (i = (_$r = _$r.call(t)).next, 0 === e) {
                            if (Object(_$r) !== _$r) return;
                            s = !1;
                        } else for(; !(s = (n = i.call(_$r)).done) && (c.push(n.value), c.length !== e); s = !0);
                    } catch (t) {
                        u = !0, _$o = t;
                    } finally{
                        try {
                            if (!s && null != _$r["return"] && (a = _$r["return"](), Object(a) !== a)) return;
                        } finally{
                            if (u) throw _$o;
                        }
                    }
                    return c;
                }
            }(t, e) || Ve(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var Ze = function Ze(t, e) {
            var _$r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!_$r) {
                if (Array.isArray(t) || (_$r = Ve(t)) || e && t && "number" == typeof t.length) {
                    _$r && (t = _$r);
                    var n = 0, _$o = function o() {};
                    return {
                        s: _$o,
                        n: function n1() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function e(t) {
                            throw t;
                        },
                        f: _$o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, c = !1;
            return {
                s: function s() {
                    _$r = _$r.call(t);
                },
                n: function n() {
                    var _$t = _$r.next();
                    return a = _$t.done, _$t;
                },
                e: function e(t) {
                    c = !0, i = t;
                },
                f: function f() {
                    try {
                        a || null == _$r["return"] || _$r["return"]();
                    } finally{
                        if (c) throw i;
                    }
                }
            };
        };
        var Ve = function Ve(t, e) {
            if (t) {
                if ("string" == typeof t) return He(t, e);
                var _$r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? He(t, e) : void 0;
            }
        };
        var He = function He(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var _$r = 0, n = new Array(e); _$r < e; _$r++)n[_$r] = t[_$r];
            return n;
        };
        var Ye = function Ye(t, e) {
            var _$r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), _$r.push.apply(_$r, n);
            }
            return _$r;
        };
        var We = function We(t) {
            for(var _$e = 1; _$e < arguments.length; _$e++){
                var _$r = null != arguments[_$e] ? arguments[_$e] : {};
                _$e % 2 ? Ye(Object(_$r), !0).forEach(function(e) {
                    Qe(t, e, _$r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(_$r)) : Ye(Object(_$r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(_$r, e));
                });
            }
            return t;
        };
        var Ke = function Ke(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Je(n.key), n);
            }
        };
        var Qe = function Qe(t, e, r) {
            return (e = Je(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        };
        var Je = function Je(t) {
            var _$e = function(t) {
                if ("object" != $e(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != $e(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == $e(_$e) ? _$e : String(_$e);
        };
        var tr = function tr(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var er = function er(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        tr(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        tr(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var ar = function ar(t) {
            return Number.isFinite(t) ? Math.max(1, Math.trunc(t)) : rr;
        };
        var cr = function cr(t) {
            return Number.isFinite(t) ? Math.max(0, t) : Number.MAX_SAFE_INTEGER;
        };
        var sr = function sr(t, e) {
            return void 0 === e ? t.read() : (e.throwIfAborted(), Promise.race([
                t.read(),
                new Promise(function(r, n) {
                    e.addEventListener("abort", function() {
                        n(e.reason), t.cancel(e.reason)["catch"](function() {});
                    }, {
                        once: !0
                    });
                })
            ]));
        };
        var ur = function ur(t, e) {
            var _$r = t.getReader(), n = 0, _$o = !1, i = !1, a = function() {
                var _$t = er(Xe().mark(function t(e) {
                    return Xe().wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                if (!_$o && !i) {
                                    t.next = 2;
                                    break;
                                }
                                return t.abrupt("return");
                            case 2:
                                return i = !0, t.next = 5, _$r.cancel(e);
                            case 5:
                            case "end":
                                return t.stop();
                        }
                    }, t);
                }));
                return function(e) {
                    return _$t.apply(this, arguments);
                };
            }();
            return new ReadableStream({
                pull: function pull(t) {
                    return er(Xe().mark(function i() {
                        var c, s, u, p;
                        return Xe().wrap(function(i) {
                            for(;;)switch(i.prev = i.next){
                                case 0:
                                    if (!(n >= e)) {
                                        i.next = 5;
                                        break;
                                    }
                                    return t.close(), i.next = 4, a();
                                case 4:
                                    return i.abrupt("return");
                                case 5:
                                    return i.next = 7, _$r.read();
                                case 7:
                                    if (c = i.sent, s = c.done, u = c.value, !s && u) {
                                        i.next = 14;
                                        break;
                                    }
                                    return _$o = !0, t.close(), i.abrupt("return");
                                case 14:
                                    if (p = e - n, !(u.length > p)) {
                                        i.next = 22;
                                        break;
                                    }
                                    return t.enqueue(u.subarray(0, p)), n += p, t.close(), i.next = 21, a();
                                case 21:
                                    return i.abrupt("return");
                                case 22:
                                    t.enqueue(u), n += u.length;
                                case 24:
                                case "end":
                                    return i.stop();
                            }
                        }, i);
                    }))();
                },
                cancel: function cancel(t) {
                    return er(Xe().mark(function e() {
                        return Xe().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return e.next = 2, a(t);
                                case 2:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }))();
                }
            });
        };
        var pr = function pr(t, e) {
            return lr.apply(this, arguments);
        };
        r.r(e), r.d(e, {
            b64: function() {
                return vr;
            },
            cleanUpCallbacks: function() {
                return Ar;
            },
            extensionToMime: function() {
                return Fr;
            },
            filterObject: function() {
                return Pr;
            },
            getMimetype: function() {
                return jr;
            },
            getVersion: function() {
                return gr;
            },
            isFacebook: function() {
                return xr;
            },
            isMobile: function() {
                return br;
            },
            md5: function() {
                return yr;
            },
            removeEmpty: function() {
                return Sr;
            },
            resolveCdnUrl: function() {
                return wr;
            },
            resolveHost: function() {
                return kr;
            },
            sanitizeName: function() {
                return _r;
            },
            uniqueId: function() {
                return Or;
            },
            uniqueTime: function() {
                return Er;
            }
        });
        var n, _$o, i = r(1635), a = {
            "application/andrew-inset": [
                "ez"
            ],
            "application/applixware": [
                "aw"
            ],
            "application/atom+xml": [
                "atom"
            ],
            "application/atomcat+xml": [
                "atomcat"
            ],
            "application/atomsvc+xml": [
                "atomsvc"
            ],
            "application/bdoc": [
                "bdoc"
            ],
            "application/ccxml+xml": [
                "ccxml"
            ],
            "application/cdmi-capability": [
                "cdmia"
            ],
            "application/cdmi-container": [
                "cdmic"
            ],
            "application/cdmi-domain": [
                "cdmid"
            ],
            "application/cdmi-object": [
                "cdmio"
            ],
            "application/cdmi-queue": [
                "cdmiq"
            ],
            "application/cu-seeme": [
                "cu"
            ],
            "application/dash+xml": [
                "mpd"
            ],
            "application/davmount+xml": [
                "davmount"
            ],
            "application/docbook+xml": [
                "dbk"
            ],
            "application/dssc+der": [
                "dssc"
            ],
            "application/dssc+xml": [
                "xdssc"
            ],
            "application/ecmascript": [
                "ecma",
                "es"
            ],
            "application/emma+xml": [
                "emma"
            ],
            "application/epub+zip": [
                "epub"
            ],
            "application/exi": [
                "exi"
            ],
            "application/font-tdpfr": [
                "pfr"
            ],
            "application/geo+json": [
                "geojson"
            ],
            "application/gml+xml": [
                "gml"
            ],
            "application/gpx+xml": [
                "gpx"
            ],
            "application/gxf": [
                "gxf"
            ],
            "application/gzip": [
                "gz"
            ],
            "application/hjson": [
                "hjson"
            ],
            "application/hyperstudio": [
                "stk"
            ],
            "application/inkml+xml": [
                "ink",
                "inkml"
            ],
            "application/ipfix": [
                "ipfix"
            ],
            "application/java-archive": [
                "jar",
                "war",
                "ear"
            ],
            "application/java-serialized-object": [
                "ser"
            ],
            "application/java-vm": [
                "class"
            ],
            "application/javascript": [
                "js",
                "mjs"
            ],
            "application/json": [
                "json",
                "map"
            ],
            "application/json5": [
                "json5"
            ],
            "application/jsonml+json": [
                "jsonml"
            ],
            "application/ld+json": [
                "jsonld"
            ],
            "application/lost+xml": [
                "lostxml"
            ],
            "application/mac-binhex40": [
                "hqx"
            ],
            "application/mac-compactpro": [
                "cpt"
            ],
            "application/mads+xml": [
                "mads"
            ],
            "application/manifest+json": [
                "webmanifest"
            ],
            "application/marc": [
                "mrc"
            ],
            "application/marcxml+xml": [
                "mrcx"
            ],
            "application/mathematica": [
                "ma",
                "nb",
                "mb"
            ],
            "application/mathml+xml": [
                "mathml"
            ],
            "application/mbox": [
                "mbox"
            ],
            "application/mediaservercontrol+xml": [
                "mscml"
            ],
            "application/metalink+xml": [
                "metalink"
            ],
            "application/metalink4+xml": [
                "meta4"
            ],
            "application/mets+xml": [
                "mets"
            ],
            "application/mods+xml": [
                "mods"
            ],
            "application/mp21": [
                "m21",
                "mp21"
            ],
            "application/mp4": [
                "mp4s",
                "m4p"
            ],
            "application/msword": [
                "doc",
                "dot"
            ],
            "application/mxf": [
                "mxf"
            ],
            "application/n-quads": [
                "nq"
            ],
            "application/n-triples": [
                "nt"
            ],
            "application/octet-stream": [
                "bin",
                "dms",
                "tdms",
                "lrf",
                "mar",
                "so",
                "dist",
                "distz",
                "pkg",
                "bpk",
                "dump",
                "elc",
                "deploy",
                "exe",
                "dll",
                "deb",
                "dmg",
                "iso",
                "msp",
                "buffer",
                "psdata",
                "indt",
                "hpd",
                "mxd",
                "indd",
                "vsm",
                "hpt"
            ],
            "application/oda": [
                "oda"
            ],
            "application/oebps-package+xml": [
                "opf"
            ],
            "application/ogg": [
                "ogx"
            ],
            "application/omdoc+xml": [
                "omdoc"
            ],
            "application/onenote": [
                "onetoc",
                "onetoc2",
                "onetmp",
                "onepkg"
            ],
            "application/oxps": [
                "oxps"
            ],
            "application/patch-ops-error+xml": [
                "xer"
            ],
            "application/pdf": [
                "pdf"
            ],
            "application/pgp-encrypted": [
                "pgp"
            ],
            "application/pgp-signature": [
                "asc",
                "sig"
            ],
            "application/pics-rules": [
                "prf"
            ],
            "application/pkcs10": [
                "p10"
            ],
            "application/pkcs7-mime": [
                "p7m",
                "p7c"
            ],
            "application/pkcs7-signature": [
                "p7s"
            ],
            "application/pkcs8": [
                "p8"
            ],
            "application/pkix-attr-cert": [
                "ac"
            ],
            "application/pkix-cert": [
                "cer"
            ],
            "application/pkix-crl": [
                "crl"
            ],
            "application/pkix-pkipath": [
                "pkipath"
            ],
            "application/pkixcmp": [
                "pki"
            ],
            "application/pls+xml": [
                "pls"
            ],
            "application/postscript": [
                "ai",
                "eps",
                "ps"
            ],
            "application/pskc+xml": [
                "pskcxml"
            ],
            "application/raml+yaml": [
                "raml"
            ],
            "application/rdf+xml": [
                "rdf",
                "owl"
            ],
            "application/reginfo+xml": [
                "rif"
            ],
            "application/relax-ng-compact-syntax": [
                "rnc"
            ],
            "application/resource-lists+xml": [
                "rl"
            ],
            "application/resource-lists-diff+xml": [
                "rld"
            ],
            "application/rls-services+xml": [
                "rs"
            ],
            "application/rpki-ghostbusters": [
                "gbr"
            ],
            "application/rpki-manifest": [
                "mft"
            ],
            "application/rpki-roa": [
                "roa"
            ],
            "application/rsd+xml": [
                "rsd"
            ],
            "application/rss+xml": [
                "rss"
            ],
            "application/rtf": [
                "rtf"
            ],
            "application/sbml+xml": [
                "sbml"
            ],
            "application/scvp-cv-request": [
                "scq"
            ],
            "application/scvp-cv-response": [
                "scs"
            ],
            "application/scvp-vp-request": [
                "spq"
            ],
            "application/scvp-vp-response": [
                "spp"
            ],
            "application/sdp": [
                "sdp"
            ],
            "application/set-payment-initiation": [
                "setpay"
            ],
            "application/set-registration-initiation": [
                "setreg"
            ],
            "application/shf+xml": [
                "shf"
            ],
            "application/sieve": [
                "siv",
                "sieve"
            ],
            "application/smil+xml": [
                "smi",
                "smil"
            ],
            "application/sparql-query": [
                "rq"
            ],
            "application/sparql-results+xml": [
                "srx"
            ],
            "application/srgs": [
                "gram"
            ],
            "application/srgs+xml": [
                "grxml"
            ],
            "application/sru+xml": [
                "sru"
            ],
            "application/ssdl+xml": [
                "ssdl"
            ],
            "application/ssml+xml": [
                "ssml"
            ],
            "application/tei+xml": [
                "tei",
                "teicorpus"
            ],
            "application/thraud+xml": [
                "tfi"
            ],
            "application/timestamped-data": [
                "tsd"
            ],
            "application/voicexml+xml": [
                "vxml"
            ],
            "application/wasm": [
                "wasm"
            ],
            "application/widget": [
                "wgt"
            ],
            "application/winhlp": [
                "hlp"
            ],
            "application/wsdl+xml": [
                "wsdl"
            ],
            "application/wspolicy+xml": [
                "wspolicy"
            ],
            "application/xaml+xml": [
                "xaml"
            ],
            "application/xcap-diff+xml": [
                "xdf"
            ],
            "application/xenc+xml": [
                "xenc"
            ],
            "application/xhtml+xml": [
                "xhtml",
                "xht"
            ],
            "application/xml": [
                "xml",
                "xsl",
                "xsd",
                "rng"
            ],
            "application/xml-dtd": [
                "dtd"
            ],
            "application/xop+xml": [
                "xop"
            ],
            "application/xproc+xml": [
                "xpl"
            ],
            "application/xslt+xml": [
                "xslt"
            ],
            "application/xspf+xml": [
                "xspf"
            ],
            "application/xv+xml": [
                "mxml",
                "xhvml",
                "xvml",
                "xvm"
            ],
            "application/yang": [
                "yang"
            ],
            "application/yin+xml": [
                "yin"
            ],
            "application/zip": [
                "zip"
            ],
            "audio/3gpp": [
                "*3gpp"
            ],
            "audio/adpcm": [
                "adp"
            ],
            "audio/basic": [
                "au",
                "snd"
            ],
            "audio/midi": [
                "mid",
                "midi",
                "kar",
                "rmi"
            ],
            "audio/mp3": [
                "*mp3"
            ],
            "audio/mp4": [
                "m4a",
                "mp4a"
            ],
            "audio/mpeg": [
                "mpga",
                "mp2",
                "mp2a",
                "mp3",
                "m2a",
                "m3a"
            ],
            "audio/ogg": [
                "oga",
                "ogg",
                "spx"
            ],
            "audio/s3m": [
                "s3m"
            ],
            "audio/silk": [
                "sil"
            ],
            "audio/wav": [
                "wav"
            ],
            "audio/wave": [
                "*wav"
            ],
            "audio/webm": [
                "weba"
            ],
            "audio/xm": [
                "xm"
            ],
            "font/collection": [
                "ttc"
            ],
            "font/otf": [
                "otf"
            ],
            "font/ttf": [
                "ttf"
            ],
            "font/woff": [
                "woff"
            ],
            "font/woff2": [
                "woff2"
            ],
            "image/aces": [
                "exr"
            ],
            "image/apng": [
                "apng"
            ],
            "image/bmp": [
                "bmp"
            ],
            "image/cgm": [
                "cgm"
            ],
            "image/dicom-rle": [
                "drle"
            ],
            "image/emf": [
                "emf"
            ],
            "image/fits": [
                "fits"
            ],
            "image/g3fax": [
                "g3"
            ],
            "image/gif": [
                "gif"
            ],
            "image/heic": [
                "heic"
            ],
            "image/heic-sequence": [
                "heics"
            ],
            "image/heif": [
                "heif"
            ],
            "image/heif-sequence": [
                "heifs"
            ],
            "image/ief": [
                "ief"
            ],
            "image/jls": [
                "jls"
            ],
            "image/jp2": [
                "jp2",
                "jpg2"
            ],
            "image/jpeg": [
                "jpeg",
                "jpg",
                "jpe"
            ],
            "image/jpg": [
                "jpeg",
                "jpg",
                "jpe"
            ],
            "image/jpm": [
                "jpm"
            ],
            "image/jpx": [
                "jpx",
                "jpf"
            ],
            "image/jxr": [
                "jxr"
            ],
            "image/ktx": [
                "ktx"
            ],
            "image/png": [
                "png"
            ],
            "image/sgi": [
                "sgi"
            ],
            "image/svg+xml": [
                "svg",
                "svgz"
            ],
            "image/t38": [
                "t38"
            ],
            "image/tiff": [
                "tif",
                "tiff"
            ],
            "image/tiff-fx": [
                "tfx"
            ],
            "image/webp": [
                "webp"
            ],
            "image/wmf": [
                "wmf"
            ],
            "message/disposition-notification": [
                "disposition-notification"
            ],
            "message/global": [
                "u8msg"
            ],
            "message/global-delivery-status": [
                "u8dsn"
            ],
            "message/global-disposition-notification": [
                "u8mdn"
            ],
            "message/global-headers": [
                "u8hdr"
            ],
            "message/rfc822": [
                "eml",
                "mime"
            ],
            "model/3mf": [
                "3mf"
            ],
            "model/gltf+json": [
                "gltf"
            ],
            "model/gltf-binary": [
                "glb"
            ],
            "model/iges": [
                "igs",
                "iges"
            ],
            "model/mesh": [
                "msh",
                "mesh",
                "silo"
            ],
            "model/stl": [
                "stl"
            ],
            "model/vrml": [
                "wrl",
                "vrml"
            ],
            "model/x3d+binary": [
                "*x3db",
                "x3dbz"
            ],
            "model/x3d+fastinfoset": [
                "x3db"
            ],
            "model/x3d+vrml": [
                "*x3dv",
                "x3dvz"
            ],
            "model/x3d+xml": [
                "x3d",
                "x3dz"
            ],
            "model/x3d-vrml": [
                "x3dv"
            ],
            "text/cache-manifest": [
                "appcache",
                "manifest"
            ],
            "text/calendar": [
                "ics",
                "ifb"
            ],
            "text/coffeescript": [
                "coffee",
                "litcoffee"
            ],
            "text/css": [
                "css"
            ],
            "text/csv": [
                "csv"
            ],
            "text/html": [
                "html",
                "htm",
                "shtml"
            ],
            "text/jade": [
                "jade"
            ],
            "text/jsx": [
                "jsx"
            ],
            "text/less": [
                "less"
            ],
            "text/markdown": [
                "markdown",
                "md"
            ],
            "text/mathml": [
                "mml"
            ],
            "text/mdx": [
                "mdx"
            ],
            "text/n3": [
                "n3"
            ],
            "text/plain": [
                "txt",
                "text",
                "conf",
                "def",
                "list",
                "log",
                "in",
                "ini"
            ],
            "text/richtext": [
                "rtx"
            ],
            "application/font-ttf": "ttf",
            "application/vnd.ms-fontobject": "eot",
            "application/font-otf": "otf",
            "text/rtf": [
                "*rtf"
            ],
            "text/sgml": [
                "sgml",
                "sgm"
            ],
            "text/shex": [
                "shex"
            ],
            "text/slim": [
                "slim",
                "slm"
            ],
            "text/stylus": [
                "stylus",
                "styl"
            ],
            "text/tab-separated-values": [
                "tsv"
            ],
            "text/troff": [
                "t",
                "tr",
                "roff",
                "man",
                "me",
                "ms"
            ],
            "text/turtle": [
                "ttl"
            ],
            "text/uri-list": [
                "uri",
                "uris",
                "urls"
            ],
            "text/vcard": [
                "vcard",
                "vcr"
            ],
            "text/vtt": [
                "vtt"
            ],
            "text/xml": [
                "*xml"
            ],
            "text/yaml": [
                "yaml",
                "yml"
            ],
            "video/3gpp": [
                "3gp",
                "3gpp"
            ],
            "video/3gpp2": [
                "3g2"
            ],
            "video/h261": [
                "h261"
            ],
            "video/h263": [
                "h263"
            ],
            "video/h264": [
                "h264"
            ],
            "video/jpeg": [
                "jpgv"
            ],
            "video/jpm": [
                "*jpm",
                "jpgm"
            ],
            "video/mj2": [
                "mj2",
                "mjp2"
            ],
            "video/mp2t": [
                "ts"
            ],
            "video/mp4": [
                "mp4",
                "mp4v",
                "mpg4"
            ],
            "video/mpeg": [
                "mpeg",
                "mpg",
                "mpe",
                "m1v",
                "m2v"
            ],
            "video/ogg": [
                "ogv"
            ],
            "video/quicktime": [
                "qt",
                "mov"
            ],
            "video/webm": [
                "webm"
            ],
            "application/prs.cww": [
                "cww"
            ],
            "application/vnd.3gpp.pic-bw-large": [
                "plb"
            ],
            "application/vnd.3gpp.pic-bw-small": [
                "psb"
            ],
            "application/vnd.3gpp.pic-bw-var": [
                "pvb"
            ],
            "application/vnd.3gpp2.tcap": [
                "tcap"
            ],
            "application/vnd.3m.post-it-notes": [
                "pwn"
            ],
            "application/vnd.accpac.simply.aso": [
                "aso"
            ],
            "application/vnd.accpac.simply.imp": [
                "imp"
            ],
            "application/vnd.acucobol": [
                "acu"
            ],
            "application/vnd.acucorp": [
                "atc",
                "acutc"
            ],
            "application/vnd.adobe.air-application-installer-package+zip": [
                "air"
            ],
            "application/vnd.adobe.formscentral.fcdt": [
                "fcdt"
            ],
            "application/vnd.adobe.fxp": [
                "fxp",
                "fxpl"
            ],
            "application/vnd.adobe.xdp+xml": [
                "xdp"
            ],
            "application/vnd.adobe.xfdf": [
                "xfdf"
            ],
            "application/vnd.ahead.space": [
                "ahead"
            ],
            "application/vnd.airzip.filesecure.azf": [
                "azf"
            ],
            "application/vnd.airzip.filesecure.azs": [
                "azs"
            ],
            "application/vnd.amazon.ebook": [
                "azw"
            ],
            "application/vnd.americandynamics.acc": [
                "acc"
            ],
            "application/vnd.amiga.ami": [
                "ami"
            ],
            "application/vnd.android.package-archive": [
                "apk"
            ],
            "application/vnd.anser-web-certificate-issue-initiation": [
                "cii"
            ],
            "application/vnd.anser-web-funds-transfer-initiation": [
                "fti"
            ],
            "application/vnd.antix.game-component": [
                "atx"
            ],
            "application/vnd.apple.installer+xml": [
                "mpkg"
            ],
            "application/vnd.apple.keynote": [
                "keynote",
                "key"
            ],
            "application/vnd.apple.mpegurl": [
                "m3u8"
            ],
            "application/vnd.apple.numbers": [
                "numbers"
            ],
            "application/vnd.apple.pages": [
                "pages"
            ],
            "application/vnd.apple.key": [
                "key"
            ],
            "application/vnd.apple.pkpass": [
                "pkpass"
            ],
            "application/vnd.aristanetworks.swi": [
                "swi"
            ],
            "application/vnd.astraea-software.iota": [
                "iota"
            ],
            "application/vnd.audiograph": [
                "aep"
            ],
            "application/vnd.blueice.multipass": [
                "mpm"
            ],
            "application/vnd.bmi": [
                "bmi"
            ],
            "application/vnd.businessobjects": [
                "rep"
            ],
            "application/vnd.chemdraw+xml": [
                "cdxml"
            ],
            "application/vnd.chipnuts.karaoke-mmd": [
                "mmd"
            ],
            "application/vnd.cinderella": [
                "cdy"
            ],
            "application/vnd.citationstyles.style+xml": [
                "csl"
            ],
            "application/vnd.claymore": [
                "cla"
            ],
            "application/vnd.cloanto.rp9": [
                "rp9"
            ],
            "application/vnd.clonk.c4group": [
                "c4g",
                "c4d",
                "c4f",
                "c4p",
                "c4u"
            ],
            "application/vnd.cluetrust.cartomobile-config": [
                "c11amc"
            ],
            "application/vnd.cluetrust.cartomobile-config-pkg": [
                "c11amz"
            ],
            "application/vnd.commonspace": [
                "csp"
            ],
            "application/vnd.contact.cmsg": [
                "cdbcmsg"
            ],
            "application/vnd.cosmocaller": [
                "cmc"
            ],
            "application/vnd.crick.clicker": [
                "clkx"
            ],
            "application/vnd.crick.clicker.keyboard": [
                "clkk"
            ],
            "application/vnd.crick.clicker.palette": [
                "clkp"
            ],
            "application/vnd.crick.clicker.template": [
                "clkt"
            ],
            "application/vnd.crick.clicker.wordbank": [
                "clkw"
            ],
            "application/vnd.criticaltools.wbs+xml": [
                "wbs"
            ],
            "application/vnd.ctc-posml": [
                "pml"
            ],
            "application/vnd.cups-ppd": [
                "ppd"
            ],
            "application/vnd.curl.car": [
                "car"
            ],
            "application/vnd.curl.pcurl": [
                "pcurl"
            ],
            "application/vnd.dart": [
                "dart"
            ],
            "application/vnd.data-vision.rdz": [
                "rdz"
            ],
            "application/vnd.dece.data": [
                "uvf",
                "uvvf",
                "uvd",
                "uvvd"
            ],
            "application/vnd.dece.ttml+xml": [
                "uvt",
                "uvvt"
            ],
            "application/vnd.dece.unspecified": [
                "uvx",
                "uvvx"
            ],
            "application/vnd.dece.zip": [
                "uvz",
                "uvvz"
            ],
            "application/vnd.denovo.fcselayout-link": [
                "fe_launch"
            ],
            "application/vnd.dna": [
                "dna"
            ],
            "application/vnd.dolby.mlp": [
                "mlp"
            ],
            "application/vnd.dpgraph": [
                "dpg"
            ],
            "application/vnd.dreamfactory": [
                "dfac"
            ],
            "application/vnd.ds-keypoint": [
                "kpxx"
            ],
            "application/vnd.dvb.ait": [
                "ait"
            ],
            "application/vnd.dvb.service": [
                "svc"
            ],
            "application/vnd.dynageo": [
                "geo"
            ],
            "application/vnd.ecowin.chart": [
                "mag"
            ],
            "application/vnd.enliven": [
                "nml"
            ],
            "application/vnd.epson.esf": [
                "esf"
            ],
            "application/vnd.epson.msf": [
                "msf"
            ],
            "application/vnd.epson.quickanime": [
                "qam"
            ],
            "application/vnd.epson.salt": [
                "slt"
            ],
            "application/vnd.epson.ssf": [
                "ssf"
            ],
            "application/vnd.eszigno3+xml": [
                "es3",
                "et3"
            ],
            "application/vnd.ezpix-album": [
                "ez2"
            ],
            "application/vnd.ezpix-package": [
                "ez3"
            ],
            "application/vnd.fdf": [
                "fdf"
            ],
            "application/vnd.fdsn.mseed": [
                "mseed"
            ],
            "application/vnd.fdsn.seed": [
                "seed",
                "dataless"
            ],
            "application/vnd.flographit": [
                "gph"
            ],
            "application/vnd.fluxtime.clip": [
                "ftc"
            ],
            "application/vnd.framemaker": [
                "fm",
                "frame",
                "maker",
                "book"
            ],
            "application/vnd.frogans.fnc": [
                "fnc"
            ],
            "application/vnd.frogans.ltf": [
                "ltf"
            ],
            "application/vnd.fsc.weblaunch": [
                "fsc"
            ],
            "application/vnd.fujitsu.oasys": [
                "oas"
            ],
            "application/vnd.fujitsu.oasys2": [
                "oa2"
            ],
            "application/vnd.fujitsu.oasys3": [
                "oa3"
            ],
            "application/vnd.fujitsu.oasysgp": [
                "fg5"
            ],
            "application/vnd.fujitsu.oasysprs": [
                "bh2"
            ],
            "application/vnd.fujixerox.ddd": [
                "ddd"
            ],
            "application/vnd.fujixerox.docuworks": [
                "xdw"
            ],
            "application/vnd.fujixerox.docuworks.binder": [
                "xbd"
            ],
            "application/vnd.fuzzysheet": [
                "fzs"
            ],
            "application/vnd.genomatix.tuxedo": [
                "txd"
            ],
            "application/vnd.geogebra.file": [
                "ggb"
            ],
            "application/vnd.geogebra.tool": [
                "ggt"
            ],
            "application/vnd.geometry-explorer": [
                "gex",
                "gre"
            ],
            "application/vnd.geonext": [
                "gxt"
            ],
            "application/vnd.geoplan": [
                "g2w"
            ],
            "application/vnd.geospace": [
                "g3w"
            ],
            "application/vnd.gmx": [
                "gmx"
            ],
            "application/vnd.google-apps.document": [
                "gdoc"
            ],
            "application/vnd.google-apps.presentation": [
                "gslides"
            ],
            "application/vnd.google-apps.spreadsheet": [
                "gsheet"
            ],
            "application/vnd.google-earth.kml+xml": [
                "kml"
            ],
            "application/vnd.google-earth.kmz": [
                "kmz"
            ],
            "application/vnd.grafeq": [
                "gqf",
                "gqs"
            ],
            "application/vnd.groove-account": [
                "gac"
            ],
            "application/vnd.groove-help": [
                "ghf"
            ],
            "application/vnd.groove-identity-message": [
                "gim"
            ],
            "application/vnd.groove-injector": [
                "grv"
            ],
            "application/vnd.groove-tool-message": [
                "gtm"
            ],
            "application/vnd.groove-tool-template": [
                "tpl"
            ],
            "application/vnd.groove-vcard": [
                "vcg"
            ],
            "application/vnd.hal+xml": [
                "hal"
            ],
            "application/vnd.handheld-entertainment+xml": [
                "zmm"
            ],
            "application/vnd.hbci": [
                "hbci"
            ],
            "application/vnd.hhe.lesson-player": [
                "les"
            ],
            "application/vnd.hp-hpgl": [
                "hpgl"
            ],
            "application/vnd.hp-hpid": [
                "hpid"
            ],
            "application/vnd.hp-hps": [
                "hps"
            ],
            "application/vnd.hp-jlyt": [
                "jlt"
            ],
            "application/vnd.hp-pcl": [
                "pcl"
            ],
            "application/vnd.hp-pclxl": [
                "pclxl"
            ],
            "application/vnd.hydrostatix.sof-data": [
                "sfd-hdstx"
            ],
            "application/vnd.ibm.minipay": [
                "mpy"
            ],
            "application/vnd.ibm.modcap": [
                "afp",
                "listafp",
                "list3820"
            ],
            "application/vnd.ibm.rights-management": [
                "irm"
            ],
            "application/vnd.ibm.secure-container": [
                "sc"
            ],
            "application/vnd.iccprofile": [
                "icc",
                "icm"
            ],
            "application/vnd.igloader": [
                "igl"
            ],
            "application/vnd.immervision-ivp": [
                "ivp"
            ],
            "application/vnd.immervision-ivu": [
                "ivu"
            ],
            "application/vnd.insors.igm": [
                "igm"
            ],
            "application/vnd.intercon.formnet": [
                "xpw",
                "xpx"
            ],
            "application/vnd.intergeo": [
                "i2g"
            ],
            "application/vnd.intu.qbo": [
                "qbo"
            ],
            "application/vnd.intu.qfx": [
                "qfx"
            ],
            "application/vnd.ipunplugged.rcprofile": [
                "rcprofile"
            ],
            "application/vnd.irepository.package+xml": [
                "irp"
            ],
            "application/vnd.is-xpr": [
                "xpr"
            ],
            "application/vnd.isac.fcs": [
                "fcs"
            ],
            "application/vnd.jam": [
                "jam"
            ],
            "application/vnd.jcp.javame.midlet-rms": [
                "rms"
            ],
            "application/vnd.jisp": [
                "jisp"
            ],
            "application/vnd.joost.joda-archive": [
                "joda"
            ],
            "application/vnd.kahootz": [
                "ktz",
                "ktr"
            ],
            "application/vnd.kde.karbon": [
                "karbon"
            ],
            "application/vnd.kde.kchart": [
                "chrt"
            ],
            "application/vnd.kde.kformula": [
                "kfo"
            ],
            "application/vnd.kde.kivio": [
                "flw"
            ],
            "application/vnd.kde.kontour": [
                "kon"
            ],
            "application/vnd.kde.kpresenter": [
                "kpr",
                "kpt"
            ],
            "application/vnd.kde.kspread": [
                "ksp"
            ],
            "application/vnd.kde.kword": [
                "kwd",
                "kwt"
            ],
            "application/vnd.kenameaapp": [
                "htke"
            ],
            "application/vnd.kidspiration": [
                "kia"
            ],
            "application/vnd.kinar": [
                "kne",
                "knp"
            ],
            "application/vnd.koan": [
                "skp",
                "skd",
                "skt",
                "skm"
            ],
            "application/vnd.kodak-descriptor": [
                "sse"
            ],
            "application/vnd.las.las+xml": [
                "lasxml"
            ],
            "application/vnd.llamagraphics.life-balance.desktop": [
                "lbd"
            ],
            "application/vnd.llamagraphics.life-balance.exchange+xml": [
                "lbe"
            ],
            "application/vnd.lotus-1-2-3": [
                "123"
            ],
            "application/vnd.lotus-approach": [
                "apr"
            ],
            "application/vnd.lotus-freelance": [
                "pre"
            ],
            "application/vnd.lotus-notes": [
                "nsf"
            ],
            "application/vnd.lotus-organizer": [
                "org"
            ],
            "application/vnd.lotus-screencam": [
                "scm"
            ],
            "application/vnd.lotus-wordpro": [
                "lwp"
            ],
            "application/vnd.macports.portpkg": [
                "portpkg"
            ],
            "application/vnd.mcd": [
                "mcd"
            ],
            "application/vnd.medcalcdata": [
                "mc1"
            ],
            "application/vnd.mediastation.cdkey": [
                "cdkey"
            ],
            "application/vnd.mfer": [
                "mwf"
            ],
            "application/vnd.mfmp": [
                "mfm"
            ],
            "application/vnd.micrografx.flo": [
                "flo"
            ],
            "application/vnd.micrografx.igx": [
                "igx"
            ],
            "application/vnd.mif": [
                "mif"
            ],
            "application/vnd.mobius.daf": [
                "daf"
            ],
            "application/vnd.mobius.dis": [
                "dis"
            ],
            "application/vnd.mobius.mbk": [
                "mbk"
            ],
            "application/vnd.mobius.mqy": [
                "mqy"
            ],
            "application/vnd.mobius.msl": [
                "msl"
            ],
            "application/vnd.mobius.plc": [
                "plc"
            ],
            "application/vnd.mobius.txf": [
                "txf"
            ],
            "application/vnd.mophun.application": [
                "mpn"
            ],
            "application/vnd.mophun.certificate": [
                "mpc"
            ],
            "application/vnd.mozilla.xul+xml": [
                "xul"
            ],
            "application/vnd.ms-artgalry": [
                "cil"
            ],
            "application/vnd.ms-cab-compressed": [
                "cab"
            ],
            "application/vnd.ms-excel": [
                "xls",
                "xlm",
                "xla",
                "xlc",
                "xlt",
                "xlw"
            ],
            "application/vnd.ms-excel.addin.macroenabled.12": [
                "xlam"
            ],
            "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
                "xlsb"
            ],
            "application/vnd.ms-excel.sheet.macroenabled.12": [
                "xlsm"
            ],
            "application/vnd.ms-excel.template.macroenabled.12": [
                "xltm"
            ],
            "application/vnd.ms-htmlhelp": [
                "chm"
            ],
            "application/vnd.ms-ims": [
                "ims"
            ],
            "application/vnd.ms-lrm": [
                "lrm"
            ],
            "application/vnd.ms-officetheme": [
                "thmx"
            ],
            "application/vnd.ms-outlook": [
                "msg"
            ],
            "application/vnd.ms-pki.seccat": [
                "cat"
            ],
            "application/vnd.ms-pki.stl": [
                "*stl"
            ],
            "application/vnd.ms-powerpoint": [
                "ppt",
                "pps",
                "pot"
            ],
            "application/vnd.ms-powerpoint.addin.macroenabled.12": [
                "ppam"
            ],
            "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
                "pptm"
            ],
            "application/vnd.ms-powerpoint.slide.macroenabled.12": [
                "sldm"
            ],
            "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
                "ppsm"
            ],
            "application/vnd.ms-powerpoint.template.macroenabled.12": [
                "potm"
            ],
            "application/vnd.ms-project": [
                "mpp",
                "mpt"
            ],
            "application/vnd.ms-word.document.macroenabled.12": [
                "docm"
            ],
            "application/vnd.ms-word.template.macroenabled.12": [
                "dotm"
            ],
            "application/vnd.ms-works": [
                "wps",
                "wks",
                "wcm",
                "wdb"
            ],
            "application/vnd.ms-wpl": [
                "wpl"
            ],
            "application/vnd.ms-xpsdocument": [
                "xps"
            ],
            "application/vnd.mseq": [
                "mseq"
            ],
            "application/vnd.musician": [
                "mus"
            ],
            "application/vnd.muvee.style": [
                "msty"
            ],
            "application/vnd.mynfc": [
                "taglet"
            ],
            "application/vnd.neurolanguage.nlu": [
                "nlu"
            ],
            "application/vnd.nitf": [
                "ntf",
                "nitf"
            ],
            "application/vnd.noblenet-directory": [
                "nnd"
            ],
            "application/vnd.noblenet-sealer": [
                "nns"
            ],
            "application/vnd.noblenet-web": [
                "nnw"
            ],
            "application/vnd.nokia.n-gage.data": [
                "ngdat"
            ],
            "application/vnd.nokia.n-gage.symbian.install": [
                "n-gage"
            ],
            "application/vnd.nokia.radio-preset": [
                "rpst"
            ],
            "application/vnd.nokia.radio-presets": [
                "rpss"
            ],
            "application/vnd.novadigm.edm": [
                "edm"
            ],
            "application/vnd.novadigm.edx": [
                "edx"
            ],
            "application/vnd.novadigm.ext": [
                "ext"
            ],
            "application/vnd.oasis.opendocument.chart": [
                "odc"
            ],
            "application/vnd.oasis.opendocument.chart-template": [
                "otc"
            ],
            "application/vnd.oasis.opendocument.database": [
                "odb"
            ],
            "application/vnd.oasis.opendocument.formula": [
                "odf"
            ],
            "application/vnd.oasis.opendocument.formula-template": [
                "odft"
            ],
            "application/vnd.oasis.opendocument.graphics": [
                "odg"
            ],
            "application/vnd.oasis.opendocument.graphics-template": [
                "otg"
            ],
            "application/vnd.oasis.opendocument.image": [
                "odi"
            ],
            "application/vnd.oasis.opendocument.image-template": [
                "oti"
            ],
            "application/vnd.oasis.opendocument.presentation": [
                "odp"
            ],
            "application/vnd.oasis.opendocument.presentation-template": [
                "otp"
            ],
            "application/vnd.oasis.opendocument.spreadsheet": [
                "ods"
            ],
            "application/vnd.oasis.opendocument.spreadsheet-template": [
                "ots"
            ],
            "application/vnd.oasis.opendocument.text": [
                "odt"
            ],
            "application/vnd.oasis.opendocument.text-master": [
                "odm"
            ],
            "application/vnd.oasis.opendocument.text-template": [
                "ott"
            ],
            "application/vnd.oasis.opendocument.text-web": [
                "oth"
            ],
            "application/vnd.olpc-sugar": [
                "xo"
            ],
            "application/vnd.oma.dd2+xml": [
                "dd2"
            ],
            "application/vnd.openofficeorg.extension": [
                "oxt"
            ],
            "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
                "pptx"
            ],
            "application/vnd.openxmlformats-officedocument.presentationml.slide": [
                "sldx"
            ],
            "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
                "ppsx"
            ],
            "application/vnd.openxmlformats-officedocument.presentationml.template": [
                "potx"
            ],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
                "xlsx"
            ],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
                "xltx"
            ],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
                "docx"
            ],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
                "dotx"
            ],
            "application/vnd.osgeo.mapguide.package": [
                "mgp"
            ],
            "application/vnd.osgi.dp": [
                "dp"
            ],
            "application/vnd.osgi.subsystem": [
                "esa"
            ],
            "application/vnd.palm": [
                "pdb",
                "pqa",
                "oprc"
            ],
            "application/vnd.pawaafile": [
                "paw"
            ],
            "application/vnd.pg.format": [
                "str"
            ],
            "application/vnd.pg.osasli": [
                "ei6"
            ],
            "application/vnd.picsel": [
                "efif"
            ],
            "application/vnd.pmi.widget": [
                "wg"
            ],
            "application/vnd.pocketlearn": [
                "plf"
            ],
            "application/vnd.powerbuilder6": [
                "pbd"
            ],
            "application/vnd.previewsystems.box": [
                "box"
            ],
            "application/vnd.proteus.magazine": [
                "mgz"
            ],
            "application/vnd.publishare-delta-tree": [
                "qps"
            ],
            "application/vnd.pvi.ptid1": [
                "ptid"
            ],
            "application/vnd.quark.quarkxpress": [
                "qxd",
                "qxt",
                "qwd",
                "qwt",
                "qxl",
                "qxb"
            ],
            "application/vnd.realvnc.bed": [
                "bed"
            ],
            "application/vnd.recordare.musicxml": [
                "mxl"
            ],
            "application/vnd.recordare.musicxml+xml": [
                "musicxml"
            ],
            "application/vnd.rig.cryptonote": [
                "cryptonote"
            ],
            "application/vnd.rim.cod": [
                "cod"
            ],
            "application/vnd.rn-realmedia": [
                "rm"
            ],
            "application/vnd.rn-realmedia-vbr": [
                "rmvb"
            ],
            "application/vnd.route66.link66+xml": [
                "link66"
            ],
            "application/vnd.sailingtracker.track": [
                "st"
            ],
            "application/vnd.seemail": [
                "see"
            ],
            "application/vnd.sema": [
                "sema"
            ],
            "application/vnd.semd": [
                "semd"
            ],
            "application/vnd.semf": [
                "semf"
            ],
            "application/vnd.shana.informed.formdata": [
                "ifm"
            ],
            "application/vnd.shana.informed.formtemplate": [
                "itp"
            ],
            "application/vnd.shana.informed.interchange": [
                "iif"
            ],
            "application/vnd.shana.informed.package": [
                "ipk"
            ],
            "application/vnd.simtech-mindmapper": [
                "twd",
                "twds"
            ],
            "application/vnd.smaf": [
                "mmf"
            ],
            "application/vnd.smart.teacher": [
                "teacher"
            ],
            "application/vnd.solent.sdkm+xml": [
                "sdkm",
                "sdkd"
            ],
            "application/vnd.spotfire.dxp": [
                "dxp"
            ],
            "application/vnd.spotfire.sfs": [
                "sfs"
            ],
            "application/vnd.stardivision.calc": [
                "sdc"
            ],
            "application/vnd.stardivision.draw": [
                "sda"
            ],
            "application/vnd.stardivision.impress": [
                "sdd"
            ],
            "application/vnd.stardivision.math": [
                "smf"
            ],
            "application/vnd.stardivision.writer": [
                "sdw",
                "vor"
            ],
            "application/vnd.stardivision.writer-global": [
                "sgl"
            ],
            "application/vnd.stepmania.package": [
                "smzip"
            ],
            "application/vnd.stepmania.stepchart": [
                "sm"
            ],
            "application/vnd.sun.wadl+xml": [
                "wadl"
            ],
            "application/vnd.sun.xml.calc": [
                "sxc"
            ],
            "application/vnd.sun.xml.calc.template": [
                "stc"
            ],
            "application/vnd.sun.xml.draw": [
                "sxd"
            ],
            "application/vnd.sun.xml.draw.template": [
                "std"
            ],
            "application/vnd.sun.xml.impress": [
                "sxi"
            ],
            "application/vnd.sun.xml.impress.template": [
                "sti"
            ],
            "application/vnd.sun.xml.math": [
                "sxm"
            ],
            "application/vnd.sun.xml.writer": [
                "sxw"
            ],
            "application/vnd.sun.xml.writer.global": [
                "sxg"
            ],
            "application/vnd.sun.xml.writer.template": [
                "stw"
            ],
            "application/vnd.sus-calendar": [
                "sus",
                "susp"
            ],
            "application/vnd.svd": [
                "svd"
            ],
            "application/vnd.symbian.install": [
                "sis",
                "sisx"
            ],
            "application/vnd.syncml+xml": [
                "xsm"
            ],
            "application/vnd.syncml.dm+wbxml": [
                "bdm"
            ],
            "application/vnd.syncml.dm+xml": [
                "xdm"
            ],
            "application/vnd.tao.intent-module-archive": [
                "tao"
            ],
            "application/vnd.tcpdump.pcap": [
                "pcap",
                "cap",
                "dmp"
            ],
            "application/vnd.tmobile-livetv": [
                "tmo"
            ],
            "application/vnd.trid.tpt": [
                "tpt"
            ],
            "application/vnd.triscape.mxs": [
                "mxs"
            ],
            "application/vnd.trueapp": [
                "tra"
            ],
            "application/vnd.ufdl": [
                "ufd",
                "ufdl"
            ],
            "application/vnd.uiq.theme": [
                "utz"
            ],
            "application/vnd.umajin": [
                "umj"
            ],
            "application/vnd.unity": [
                "unityweb"
            ],
            "application/vnd.uoml+xml": [
                "uoml"
            ],
            "application/vnd.vcx": [
                "vcx"
            ],
            "application/vnd.visio": [
                "vsd",
                "vst",
                "vss",
                "vsw"
            ],
            "application/vnd.ms-visio.drawing.main+xml": [
                "vsdx"
            ],
            "application/vnd.visionary": [
                "vis"
            ],
            "application/vnd.vsf": [
                "vsf"
            ],
            "application/vnd.wap.wbxml": [
                "wbxml"
            ],
            "application/vnd.wap.wmlc": [
                "wmlc"
            ],
            "application/vnd.wap.wmlscriptc": [
                "wmlsc"
            ],
            "application/vnd.webturbo": [
                "wtb"
            ],
            "application/vnd.wolfram.player": [
                "nbp"
            ],
            "application/vnd.wordperfect": [
                "wpd"
            ],
            "application/vnd.wqd": [
                "wqd"
            ],
            "application/vnd.wt.stf": [
                "stf"
            ],
            "application/vnd.xara": [
                "xar"
            ],
            "application/vnd.xfdl": [
                "xfdl"
            ],
            "application/vnd.yamaha.hv-dic": [
                "hvd"
            ],
            "application/vnd.yamaha.hv-script": [
                "hvs"
            ],
            "application/vnd.yamaha.hv-voice": [
                "hvp"
            ],
            "application/vnd.yamaha.openscoreformat": [
                "osf"
            ],
            "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
                "osfpvg"
            ],
            "application/vnd.yamaha.smaf-audio": [
                "saf"
            ],
            "application/vnd.yamaha.smaf-phrase": [
                "spf"
            ],
            "application/vnd.yellowriver-custom-menu": [
                "cmp"
            ],
            "application/vnd.zul": [
                "zir",
                "zirz"
            ],
            "application/vnd.zzazz.deck+xml": [
                "zaz"
            ],
            "application/x-7z-compressed": [
                "7z"
            ],
            "application/x-abiword": [
                "abw"
            ],
            "application/x-ace-compressed": [
                "ace"
            ],
            "application/x-apple-diskimage": [
                "*dmg"
            ],
            "application/x-arj": [
                "arj"
            ],
            "application/x-authorware-bin": [
                "aab",
                "x32",
                "u32",
                "vox"
            ],
            "application/x-authorware-map": [
                "aam"
            ],
            "application/x-authorware-seg": [
                "aas"
            ],
            "application/x-bcpio": [
                "bcpio"
            ],
            "application/x-bdoc": [
                "*bdoc"
            ],
            "application/x-bittorrent": [
                "torrent"
            ],
            "application/x-blorb": [
                "blb",
                "blorb"
            ],
            "application/x-bzip": [
                "bz"
            ],
            "application/x-bzip2": [
                "bz2",
                "boz"
            ],
            "application/x-cbr": [
                "cbr",
                "cba",
                "cbt",
                "cbz",
                "cb7"
            ],
            "application/x-cdlink": [
                "vcd"
            ],
            "application/x-cfs-compressed": [
                "cfs"
            ],
            "application/x-chat": [
                "chat"
            ],
            "application/x-chess-pgn": [
                "pgn"
            ],
            "application/x-chrome-extension": [
                "crx"
            ],
            "application/x-cocoa": [
                "cco"
            ],
            "application/x-conference": [
                "nsc"
            ],
            "application/x-cpio": [
                "cpio"
            ],
            "application/x-csh": [
                "csh"
            ],
            "application/x-debian-package": [
                "*deb",
                "udeb"
            ],
            "application/x-dgc-compressed": [
                "dgc"
            ],
            "application/x-director": [
                "dir",
                "dcr",
                "dxr",
                "cst",
                "cct",
                "cxt",
                "w3d",
                "fgd",
                "swa"
            ],
            "application/x-doom": [
                "wad"
            ],
            "application/x-dtbncx+xml": [
                "ncx"
            ],
            "application/x-dtbook+xml": [
                "dtb"
            ],
            "application/x-dtbresource+xml": [
                "res"
            ],
            "application/x-dvi": [
                "dvi"
            ],
            "application/x-envoy": [
                "evy"
            ],
            "application/x-eva": [
                "eva"
            ],
            "application/x-font-bdf": [
                "bdf"
            ],
            "application/x-font-ghostscript": [
                "gsf"
            ],
            "application/x-font-linux-psf": [
                "psf"
            ],
            "application/x-font-pcf": [
                "pcf"
            ],
            "application/x-font-snf": [
                "snf"
            ],
            "application/x-font-type1": [
                "pfa",
                "pfb",
                "pfm",
                "afm"
            ],
            "application/x-freearc": [
                "arc"
            ],
            "application/x-futuresplash": [
                "spl"
            ],
            "application/x-gca-compressed": [
                "gca"
            ],
            "application/x-glulx": [
                "ulx"
            ],
            "application/x-gnumeric": [
                "gnumeric"
            ],
            "application/x-gramps-xml": [
                "gramps"
            ],
            "application/x-gtar": [
                "gtar"
            ],
            "application/x-hdf": [
                "hdf"
            ],
            "application/x-httpd-php": [
                "php"
            ],
            "application/x-install-instructions": [
                "install"
            ],
            "application/x-iso9660-image": [
                "*iso"
            ],
            "application/x-java-archive-diff": [
                "jardiff"
            ],
            "application/x-java-jnlp-file": [
                "jnlp"
            ],
            "application/x-latex": [
                "latex"
            ],
            "application/x-lua-bytecode": [
                "luac"
            ],
            "application/x-lzh-compressed": [
                "lzh",
                "lha"
            ],
            "application/x-makeself": [
                "run"
            ],
            "application/x-mie": [
                "mie"
            ],
            "application/x-mobipocket-ebook": [
                "prc",
                "mobi"
            ],
            "application/x-ms-application": [
                "application"
            ],
            "application/x-ms-shortcut": [
                "lnk"
            ],
            "application/x-ms-wmd": [
                "wmd"
            ],
            "application/x-ms-wmz": [
                "wmz"
            ],
            "application/x-ms-xbap": [
                "xbap"
            ],
            "application/x-msaccess": [
                "mdb"
            ],
            "application/x-msbinder": [
                "obd"
            ],
            "application/x-mscardfile": [
                "crd"
            ],
            "application/x-msclip": [
                "clp"
            ],
            "application/x-msdos-program": [
                "*exe"
            ],
            "application/x-msdownload": [
                "*exe",
                "*dll",
                "com",
                "bat",
                "*msi"
            ],
            "application/x-msmediaview": [
                "mvb",
                "m13",
                "m14"
            ],
            "application/x-msmetafile": [
                "*wmf",
                "*wmz",
                "*emf",
                "emz"
            ],
            "application/x-msmoney": [
                "mny"
            ],
            "application/x-mspublisher": [
                "pub"
            ],
            "application/x-msschedule": [
                "scd"
            ],
            "application/x-msterminal": [
                "trm"
            ],
            "application/x-mswrite": [
                "wri"
            ],
            "application/x-netcdf": [
                "nc",
                "cdf"
            ],
            "application/x-ns-proxy-autoconfig": [
                "pac"
            ],
            "application/x-nzb": [
                "nzb"
            ],
            "application/x-perl": [
                "pl",
                "pm"
            ],
            "application/x-pilot": [
                "*prc",
                "*pdb"
            ],
            "application/x-pkcs12": [
                "p12",
                "pfx"
            ],
            "application/x-pkcs7-certificates": [
                "p7b",
                "spc"
            ],
            "application/x-pkcs7-certreqresp": [
                "p7r"
            ],
            "application/x-rar-compressed": [
                "rar"
            ],
            "application/x-redhat-package-manager": [
                "rpm"
            ],
            "application/x-research-info-systems": [
                "ris"
            ],
            "application/x-sea": [
                "sea"
            ],
            "application/x-sh": [
                "sh"
            ],
            "application/x-shar": [
                "shar"
            ],
            "application/x-shockwave-flash": [
                "swf"
            ],
            "application/x-silverlight-app": [
                "xap"
            ],
            "application/x-sql": [
                "sql"
            ],
            "application/x-stuffit": [
                "sit"
            ],
            "application/x-stuffitx": [
                "sitx"
            ],
            "application/x-subrip": [
                "srt"
            ],
            "application/x-sv4cpio": [
                "sv4cpio"
            ],
            "application/x-sv4crc": [
                "sv4crc"
            ],
            "application/x-t3vm-image": [
                "t3"
            ],
            "application/x-tads": [
                "gam"
            ],
            "application/x-tar": [
                "tar"
            ],
            "application/x-tcl": [
                "tcl",
                "tk"
            ],
            "application/x-tex": [
                "tex"
            ],
            "application/x-tex-tfm": [
                "tfm"
            ],
            "application/x-texinfo": [
                "texinfo",
                "texi"
            ],
            "application/x-tgif": [
                "obj"
            ],
            "application/x-ustar": [
                "ustar"
            ],
            "application/x-virtualbox-hdd": [
                "hdd"
            ],
            "application/x-virtualbox-ova": [
                "ova"
            ],
            "application/x-virtualbox-ovf": [
                "ovf"
            ],
            "application/x-virtualbox-vbox": [
                "vbox"
            ],
            "application/x-virtualbox-vbox-extpack": [
                "vbox-extpack"
            ],
            "application/x-virtualbox-vdi": [
                "vdi"
            ],
            "application/x-virtualbox-vhd": [
                "vhd"
            ],
            "application/x-virtualbox-vmdk": [
                "vmdk"
            ],
            "application/x-wais-source": [
                "src"
            ],
            "application/x-web-app-manifest+json": [
                "webapp"
            ],
            "application/x-x509-ca-cert": [
                "der",
                "crt",
                "pem"
            ],
            "application/x-xfig": [
                "fig"
            ],
            "application/x-xliff+xml": [
                "xlf"
            ],
            "application/x-xpinstall": [
                "xpi"
            ],
            "application/x-xz": [
                "xz"
            ],
            "application/x-zmachine": [
                "z1",
                "z2",
                "z3",
                "z4",
                "z5",
                "z6",
                "z7",
                "z8"
            ],
            "audio/vnd.dece.audio": [
                "uva",
                "uvva"
            ],
            "audio/vnd.digital-winds": [
                "eol"
            ],
            "audio/vnd.dra": [
                "dra"
            ],
            "audio/vnd.dts": [
                "dts"
            ],
            "audio/vnd.dts.hd": [
                "dtshd"
            ],
            "audio/vnd.lucent.voice": [
                "lvp"
            ],
            "audio/vnd.ms-playready.media.pya": [
                "pya"
            ],
            "audio/vnd.nuera.ecelp4800": [
                "ecelp4800"
            ],
            "audio/vnd.nuera.ecelp7470": [
                "ecelp7470"
            ],
            "audio/vnd.nuera.ecelp9600": [
                "ecelp9600"
            ],
            "audio/vnd.rip": [
                "rip"
            ],
            "audio/x-aac": [
                "aac"
            ],
            "audio/x-aiff": [
                "aif",
                "aiff",
                "aifc"
            ],
            "audio/x-caf": [
                "caf"
            ],
            "audio/x-flac": [
                "flac"
            ],
            "audio/x-m4a": [
                "*m4a"
            ],
            "audio/x-matroska": [
                "mka"
            ],
            "audio/x-mpegurl": [
                "m3u"
            ],
            "audio/x-ms-wax": [
                "wax"
            ],
            "audio/x-ms-wma": [
                "wma"
            ],
            "audio/x-pn-realaudio": [
                "ram",
                "ra"
            ],
            "audio/x-pn-realaudio-plugin": [
                "rmp"
            ],
            "audio/x-realaudio": [
                "*ra"
            ],
            "audio/x-wav": [
                "*wav"
            ],
            "chemical/x-cdx": [
                "cdx"
            ],
            "chemical/x-cif": [
                "cif"
            ],
            "chemical/x-cmdf": [
                "cmdf"
            ],
            "chemical/x-cml": [
                "cml"
            ],
            "chemical/x-csml": [
                "csml"
            ],
            "chemical/x-xyz": [
                "xyz"
            ],
            "image/prs.btif": [
                "btif"
            ],
            "image/prs.pti": [
                "pti"
            ],
            "image/vnd.adobe.photoshop": [
                "psd"
            ],
            "image/vnd.airzip.accelerator.azv": [
                "azv"
            ],
            "image/vnd.dece.graphic": [
                "uvi",
                "uvvi",
                "uvg",
                "uvvg"
            ],
            "image/vnd.djvu": [
                "djvu",
                "djv"
            ],
            "image/vnd.dvb.subtitle": [
                "*sub"
            ],
            "image/vnd.dwg": [
                "dwg"
            ],
            "image/vnd.dxf": [
                "dxf"
            ],
            "image/vnd.fastbidsheet": [
                "fbs"
            ],
            "image/vnd.fpx": [
                "fpx"
            ],
            "image/vnd.fst": [
                "fst"
            ],
            "image/vnd.fujixerox.edmics-mmr": [
                "mmr"
            ],
            "image/vnd.fujixerox.edmics-rlc": [
                "rlc"
            ],
            "image/vnd.microsoft.icon": [
                "ico"
            ],
            "image/vnd.ms-modi": [
                "mdi"
            ],
            "image/vnd.ms-photo": [
                "wdp"
            ],
            "image/vnd.net-fpx": [
                "npx"
            ],
            "image/vnd.tencent.tap": [
                "tap"
            ],
            "image/vnd.valve.source.texture": [
                "vtf"
            ],
            "image/vnd.wap.wbmp": [
                "wbmp"
            ],
            "image/vnd.xiff": [
                "xif"
            ],
            "image/vnd.zbrush.pcx": [
                "pcx"
            ],
            "image/x-3ds": [
                "3ds"
            ],
            "image/x-cmu-raster": [
                "ras"
            ],
            "image/x-cmx": [
                "cmx"
            ],
            "image/x-freehand": [
                "fh",
                "fhc",
                "fh4",
                "fh5",
                "fh7"
            ],
            "image/x-icon": [
                "*ico"
            ],
            "image/x-jng": [
                "jng"
            ],
            "image/x-mrsid-image": [
                "sid"
            ],
            "image/x-ms-bmp": [
                "*bmp"
            ],
            "image/x-pcx": [
                "*pcx"
            ],
            "image/x-pict": [
                "pic",
                "pct"
            ],
            "image/x-portable-anymap": [
                "pnm"
            ],
            "image/x-portable-bitmap": [
                "pbm"
            ],
            "image/x-portable-graymap": [
                "pgm"
            ],
            "image/x-portable-pixmap": [
                "ppm"
            ],
            "image/x-rgb": [
                "rgb"
            ],
            "image/x-tga": [
                "tga"
            ],
            "image/x-xbitmap": [
                "xbm"
            ],
            "image/x-xpixmap": [
                "xpm"
            ],
            "image/x-xwindowdump": [
                "xwd"
            ],
            "message/vnd.wfa.wsc": [
                "wsc"
            ],
            "model/vnd.collada+xml": [
                "dae"
            ],
            "model/vnd.dwf": [
                "dwf"
            ],
            "model/vnd.gdl": [
                "gdl"
            ],
            "model/vnd.gtw": [
                "gtw"
            ],
            "model/vnd.mts": [
                "mts"
            ],
            "model/vnd.opengex": [
                "ogex"
            ],
            "model/vnd.parasolid.transmit.binary": [
                "x_b"
            ],
            "model/vnd.parasolid.transmit.text": [
                "x_t"
            ],
            "model/vnd.usdz+zip": [
                "usdz"
            ],
            "model/vnd.valve.source.compiled-map": [
                "bsp"
            ],
            "model/vnd.vtu": [
                "vtu"
            ],
            "text/prs.lines.tag": [
                "dsc"
            ],
            "text/vnd.curl": [
                "curl"
            ],
            "text/vnd.curl.dcurl": [
                "dcurl"
            ],
            "text/vnd.curl.mcurl": [
                "mcurl"
            ],
            "text/vnd.curl.scurl": [
                "scurl"
            ],
            "text/vnd.dvb.subtitle": [
                "sub"
            ],
            "text/vnd.fly": [
                "fly"
            ],
            "text/vnd.fmi.flexstor": [
                "flx"
            ],
            "text/vnd.graphviz": [
                "gv"
            ],
            "text/vnd.in3d.3dml": [
                "3dml"
            ],
            "text/vnd.in3d.spot": [
                "spot"
            ],
            "text/vnd.sun.j2me.app-descriptor": [
                "jad"
            ],
            "text/vnd.wap.wml": [
                "wml"
            ],
            "text/vnd.wap.wmlscript": [
                "wmls"
            ],
            "text/x-asm": [
                "s",
                "asm"
            ],
            "text/x-c": [
                "c",
                "cc",
                "cxx",
                "cpp",
                "h",
                "hh",
                "dic"
            ],
            "text/x-component": [
                "htc"
            ],
            "text/x-fortran": [
                "f",
                "for",
                "f77",
                "f90"
            ],
            "text/x-handlebars-template": [
                "hbs"
            ],
            "text/x-java-source": [
                "java"
            ],
            "text/x-lua": [
                "lua"
            ],
            "text/x-markdown": [
                "mkd"
            ],
            "text/x-nfo": [
                "nfo"
            ],
            "text/x-opml": [
                "opml"
            ],
            "text/x-org": [
                "*org"
            ],
            "text/x-pascal": [
                "p",
                "pas"
            ],
            "text/x-processing": [
                "pde"
            ],
            "text/x-sass": [
                "sass"
            ],
            "text/x-scss": [
                "scss"
            ],
            "text/x-setext": [
                "etx"
            ],
            "text/x-sfv": [
                "sfv"
            ],
            "text/x-suse-ymp": [
                "ymp"
            ],
            "text/x-uuencode": [
                "uu"
            ],
            "text/x-vcalendar": [
                "vcs"
            ],
            "text/x-vcard": [
                "vcf"
            ],
            "video/vnd.dece.hd": [
                "uvh",
                "uvvh"
            ],
            "video/vnd.dece.mobile": [
                "uvm",
                "uvvm"
            ],
            "video/vnd.dece.pd": [
                "uvp",
                "uvvp"
            ],
            "video/vnd.dece.sd": [
                "uvs",
                "uvvs"
            ],
            "video/vnd.dece.video": [
                "uvv",
                "uvvv"
            ],
            "video/vnd.dvb.file": [
                "dvb"
            ],
            "video/vnd.fvt": [
                "fvt"
            ],
            "video/vnd.mpegurl": [
                "mxu",
                "m4u"
            ],
            "video/vnd.ms-playready.media.pyv": [
                "pyv"
            ],
            "video/vnd.uvvu.mp4": [
                "uvu",
                "uvvu"
            ],
            "video/vnd.vivo": [
                "viv"
            ],
            "video/x-f4v": [
                "f4v"
            ],
            "video/x-fli": [
                "fli"
            ],
            "video/x-flv": [
                "flv"
            ],
            "video/x-m4v": [
                "m4v"
            ],
            "video/x-matroska": [
                "mkv",
                "mk3d",
                "mks"
            ],
            "video/x-mng": [
                "mng"
            ],
            "video/x-ms-asf": [
                "asf",
                "asx"
            ],
            "video/x-ms-vob": [
                "vob"
            ],
            "video/x-ms-wm": [
                "wm"
            ],
            "video/x-ms-wmv": [
                "wmv"
            ],
            "video/x-ms-wmx": [
                "wmx"
            ],
            "video/x-ms-wvx": [
                "wvx"
            ],
            "video/vnd.avi": [
                "avi"
            ],
            "video/x-msvideo": [
                "avi"
            ],
            "video/avi": [
                "avi"
            ],
            "video/x-sgi-movie": [
                "movie"
            ],
            "video/x-smv": [
                "smv"
            ],
            "x-conference/x-cooltalk": [
                "ice"
            ],
            "application/x-msi": "msi",
            "application/x-ms": "ms",
            "application/vnd.geo+json": "geojson",
            "application/vnd.debian.binary-package": "deb",
            "application/font-woff": "woff",
            "application/font-woff2": "woff2",
            "application/x-font-ttf": [
                "ttc",
                "ttf"
            ],
            "font/opentype": "otf",
            "application/x-bb-appworld": "bbaw",
            "application/x-cd-image": "iso",
            "application/x-opera-extension": "oex",
            "application/x-ms-dos-executable": "exe",
            "text/vnd.rim.location.xloc": "xloc",
            "application/x-desktop": "desktop",
            "application/x-typescript": "ts",
            "application/x-java-archive": "jar",
            "application/x-sharedlib": "so",
            "image/avif": "avif"
        };
        r(6773);
        for(var s, u = {
            128: "\u20AC",
            130: "\u201A",
            131: "\u0192",
            132: "\u201E",
            133: "\u2026",
            134: "\u2020",
            135: "\u2021",
            136: "\u02C6",
            137: "\u2030",
            138: "\u0160",
            139: "\u2039",
            140: "\u0152",
            142: "\u017D",
            145: "\u2018",
            146: "\u2019",
            147: "\u201C",
            148: "\u201D",
            149: "\u2022",
            150: "\u2013",
            151: "\u2014",
            152: "\u02DC",
            153: "\u2122",
            154: "\u0161",
            155: "\u203A",
            156: "\u0153",
            158: "\u017E",
            159: "\u0178"
        }, p = {}, l = 0, f = Object.entries(u); l < f.length; l++){
            var h = (n = f[l], _$o = 2, function(t) {
                if (Array.isArray(t)) return t;
            }(n) || function(t, e) {
                var _$r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != _$r) {
                    var n, _$o, i, a, c = [], s = !0, u = !1;
                    try {
                        if (i = (_$r = _$r.call(t)).next, 0 === e) {
                            if (Object(_$r) !== _$r) return;
                            s = !1;
                        } else for(; !(s = (n = i.call(_$r)).done) && (c.push(n.value), c.length !== e); s = !0);
                    } catch (t) {
                        u = !0, _$o = t;
                    } finally{
                        try {
                            if (!s && null != _$r["return"] && (a = _$r["return"](), Object(a) !== a)) return;
                        } finally{
                            if (u) throw _$o;
                        }
                    }
                    return c;
                }
            }(n, _$o) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return c(t, e);
                    var _$r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? c(t, e) : void 0;
                }
            }(n, _$o) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()), d = h[0];
            p[h[1]] = Number.parseInt(d, 10);
        }
        var m = 32768, y = 65533;
        function x(t) {
            return x = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function x(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, x(t);
        }
        var E = {
            len: 1,
            get: function get(t, e) {
                return S(t).getUint8(e);
            },
            put: function put(t, e, r) {
                return S(t).setUint8(e, r), e + 1;
            }
        }, O = {
            len: 2,
            get: function get(t, e) {
                return S(t).getUint16(e, !0);
            },
            put: function put(t, e, r) {
                return S(t).setUint16(e, r, !0), e + 2;
            }
        }, j = {
            len: 2,
            get: function get(t, e) {
                return S(t).getUint16(e);
            },
            put: function put(t, e, r) {
                return S(t).setUint16(e, r), e + 2;
            }
        }, F = {
            len: 4,
            get: function get(t, e) {
                return S(t).getUint32(e, !0);
            },
            put: function put(t, e, r) {
                return S(t).setUint32(e, r, !0), e + 4;
            }
        }, _ = {
            len: 4,
            get: function get(t, e) {
                return S(t).getUint32(e);
            },
            put: function put(t, e, r) {
                return S(t).setUint32(e, r), e + 4;
            }
        }, P = {
            len: 4,
            get: function get(t, e) {
                return S(t).getInt32(e);
            },
            put: function put(t, e, r) {
                return S(t).setInt32(e, r), e + 4;
            }
        }, A = {
            len: 8,
            get: function get(t, e) {
                return S(t).getBigUint64(e, !0);
            },
            put: function put(t, e, r) {
                return S(t).setBigUint64(e, r, !0), e + 8;
            }
        }, T = function() {
            function t(e, r) {
                (function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, t), this.len = e, this.encoding = r;
            }
            var _$e, _$r, n;
            return _$e = t, _$r = [
                {
                    key: "get",
                    value: function value(t) {
                        var _$e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                        return function(t) {
                            var _$e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "utf-8";
                            switch(_$e.toLowerCase()){
                                case "utf-8":
                                case "utf8":
                                    var _$r = function() {
                                        if (void 0 !== globalThis.TextDecoder) return null != s ? s : s = new globalThis.TextDecoder("utf-8");
                                    }();
                                    return _$r ? _$r.decode(t) : function(t) {
                                        var _$e = [], _$r = [], n = 0;
                                        for(t.length >= 3 && 239 === t[0] && 187 === t[1] && 191 === t[2] && (n = 3); n < t.length;){
                                            var _$o = t[n];
                                            if (_$o <= 127) _$g(_$e, _$r, _$o), n++;
                                            else if (_$o < 194 || _$o > 244) _$g(_$e, _$r, y), n++;
                                            else if (_$o <= 223) {
                                                if (n + 1 >= t.length) {
                                                    _$g(_$e, _$r, y), n++;
                                                    continue;
                                                }
                                                var i = t[n + 1];
                                                if (128 != (192 & i)) {
                                                    _$g(_$e, _$r, y), n++;
                                                    continue;
                                                }
                                                _$g(_$e, _$r, (31 & _$o) << 6 | 63 & i), n += 2;
                                            } else if (_$o <= 239) {
                                                if (n + 2 >= t.length) {
                                                    _$g(_$e, _$r, y), n++;
                                                    continue;
                                                }
                                                var a = t[n + 1], c = t[n + 2];
                                                if (128 != (192 & a) || 128 != (192 & c) || 224 === _$o && a < 160 || 237 === _$o && a >= 160) {
                                                    _$g(_$e, _$r, y), n++;
                                                    continue;
                                                }
                                                _$g(_$e, _$r, (15 & _$o) << 12 | (63 & a) << 6 | 63 & c), n += 3;
                                            } else if (n + 3 >= t.length) _$g(_$e, _$r, y), n++;
                                            else {
                                                var s = t[n + 1], u = t[n + 2], p = t[n + 3];
                                                128 != (192 & s) || 128 != (192 & u) || 128 != (192 & p) || 240 === _$o && s < 144 || 244 === _$o && s > 143 ? (_$g(_$e, _$r, y), n++) : (b(_$e, _$r, (7 & _$o) << 18 | (63 & s) << 12 | (63 & u) << 6 | 63 & p), n += 4);
                                            }
                                        }
                                        return v(_$e, _$r), _$e.join("");
                                    }(t);
                                case "utf-16le":
                                    return function(t) {
                                        for(var _$e = [], _$r = [], n = t.length, _$o = 0; _$o + 1 < n;){
                                            var i = t[_$o] | t[_$o + 1] << 8;
                                            if (_$o += 2, i >= 55296 && i <= 56319) {
                                                if (_$o + 1 < n) {
                                                    var a = t[_$o] | t[_$o + 1] << 8;
                                                    a >= 56320 && a <= 57343 ? (_$g(_$e, _$r, i), _$g(_$e, _$r, a), _$o += 2) : _$g(_$e, _$r, y);
                                                } else _$g(_$e, _$r, y);
                                            } else _$g(_$e, _$r, i >= 56320 && i <= 57343 ? y : i);
                                        }
                                        return _$o < n && _$g(_$e, _$r, y), v(_$e, _$r), _$e.join("");
                                    }(t);
                                case "us-ascii":
                                case "ascii":
                                    return function(t) {
                                        for(var _$e = [], _$r = 0; _$r < t.length; _$r += m){
                                            for(var n = Math.min(t.length, _$r + m), _$o = new Array(n - _$r), i = _$r, a = 0; i < n; i++, a++)_$o[a] = 127 & t[i];
                                            _$e.push(String.fromCharCode.apply(null, _$o));
                                        }
                                        return _$e.join("");
                                    }(t);
                                case "latin1":
                                case "iso-8859-1":
                                    return function(t) {
                                        for(var _$e = [], _$r = 0; _$r < t.length; _$r += m){
                                            for(var n = Math.min(t.length, _$r + m), _$o = new Array(n - _$r), i = _$r, a = 0; i < n; i++, a++)_$o[a] = t[i];
                                            _$e.push(String.fromCharCode.apply(null, _$o));
                                        }
                                        return _$e.join("");
                                    }(t);
                                case "windows-1252":
                                    return function(t) {
                                        for(var _$e = [], _$r = "", n = 0; n < t.length; n++){
                                            var _$o = t[n], i = _$o >= 128 && _$o <= 159 ? u[_$o] : void 0;
                                            (_$r += null != i ? i : String.fromCharCode(_$o)).length >= m && (_$e.push(_$r), _$r = "");
                                        }
                                        return _$r && _$e.push(_$r), _$e.join("");
                                    }(t);
                                default:
                                    throw new RangeError("Encoding '".concat(_$e, "' not supported"));
                            }
                        }(t.subarray(_$e, _$e + this.len), this.encoding);
                    }
                }
            ], _$r && w(_$e.prototype, _$r), n && w(_$e, n), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }(), D = r(7680), L = r(9971), C = r(1227), I = 67324752, z = 33639248, N = {
            get: function get(t) {
                return {
                    signature: F.get(t, 0),
                    compressedSize: F.get(t, 8),
                    uncompressedSize: F.get(t, 12)
                };
            },
            len: 16
        }, R = {
            get: function get(t) {
                var _$e = O.get(t, 6);
                return {
                    signature: F.get(t, 0),
                    minVersion: O.get(t, 4),
                    dataDescriptor: !!(8 & _$e),
                    compressedMethod: O.get(t, 8),
                    compressedSize: F.get(t, 18),
                    uncompressedSize: F.get(t, 22),
                    filenameLength: O.get(t, 26),
                    extraFieldLength: O.get(t, 28),
                    filename: null
                };
            },
            len: 30
        }, M = {
            get: function get(t) {
                return {
                    signature: F.get(t, 0),
                    nrOfThisDisk: O.get(t, 4),
                    nrOfThisDiskWithTheStart: O.get(t, 6),
                    nrOfEntriesOnThisDisk: O.get(t, 8),
                    nrOfEntriesOfSize: O.get(t, 10),
                    sizeOfCd: F.get(t, 12),
                    offsetOfStartOfCd: F.get(t, 16),
                    zipFileCommentLength: O.get(t, 20)
                };
            },
            len: 22
        }, B = {
            get: function get(t) {
                var _$e = O.get(t, 8);
                return {
                    signature: F.get(t, 0),
                    minVersion: O.get(t, 6),
                    dataDescriptor: !!(8 & _$e),
                    compressedMethod: O.get(t, 10),
                    compressedSize: F.get(t, 20),
                    uncompressedSize: F.get(t, 24),
                    filenameLength: O.get(t, 28),
                    extraFieldLength: O.get(t, 30),
                    fileCommentLength: O.get(t, 32),
                    relativeOffsetOfLocalHeader: F.get(t, 42),
                    filename: null
                };
            },
            len: 46
        };
        function U(t) {
            return U = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function U(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, U(t);
        }
        function $() {
            $ = function $() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == U(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(U(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        var K = C("tokenizer:inflate"), Q = 262144, J = W(134695760), X = W(101010256), tt = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.tokenizer = e, this.syncBuffer = new Uint8Array(Q);
            }
            var _$e, _$r, n, _$o, i, a, c, s, u, p, l;
            return _$e = t, _$r = [
                {
                    key: "isZip",
                    value: (l = V($().mark(function t() {
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.peekSignature();
                                case 2:
                                    return t.t0 = t.sent, t.t1 = I, t.abrupt("return", t.t0 === t.t1);
                                case 5:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return l.apply(this, arguments);
                    })
                },
                {
                    key: "peekSignature",
                    value: function value() {
                        return this.tokenizer.peekToken(F);
                    }
                },
                {
                    key: "findEndOfCentralDirectoryLocator",
                    value: (p = V($().mark(function t() {
                        var _$e, _$r, n, _$o;
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return _$e = this.tokenizer, _$r = Math.min(16384, _$e.fileInfo.size), n = this.syncBuffer.subarray(0, _$r), t.next = 5, this.tokenizer.readBuffer(n, {
                                        position: _$e.fileInfo.size - _$r
                                    });
                                case 5:
                                    _$o = n.length - 4;
                                case 6:
                                    if (!(_$o >= 0)) {
                                        t.next = 12;
                                        break;
                                    }
                                    if (n[_$o] !== X[0] || n[_$o + 1] !== X[1] || n[_$o + 2] !== X[2] || n[_$o + 3] !== X[3]) {
                                        t.next = 9;
                                        break;
                                    }
                                    return t.abrupt("return", _$e.fileInfo.size - _$r + _$o);
                                case 9:
                                    _$o--, t.next = 6;
                                    break;
                                case 12:
                                    return t.abrupt("return", -1);
                                case 13:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return p.apply(this, arguments);
                    })
                },
                {
                    key: "readCentralDirectory",
                    value: (u = V($().mark(function t() {
                        var _$e, _$r, n, _$o, i, a;
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (this.tokenizer.supportsRandomAccess()) {
                                        t.next = 3;
                                        break;
                                    }
                                    return K("Cannot reading central-directory without random-read support"), t.abrupt("return");
                                case 3:
                                    return K("Reading central-directory..."), _$e = this.tokenizer.position, t.next = 7, this.findEndOfCentralDirectoryLocator();
                                case 7:
                                    if (!((_$r = t.sent) > 0)) {
                                        t.next = 36;
                                        break;
                                    }
                                    return K("Central-directory 32-bit signature found"), t.next = 12, this.tokenizer.readToken(M, _$r);
                                case 12:
                                    n = t.sent, _$o = [], this.tokenizer.setPosition(n.offsetOfStartOfCd), i = 0;
                                case 16:
                                    if (!(i < n.nrOfEntriesOfSize)) {
                                        t.next = 34;
                                        break;
                                    }
                                    return t.next = 19, this.tokenizer.readToken(B);
                                case 19:
                                    if ((a = t.sent).signature === z) {
                                        t.next = 22;
                                        break;
                                    }
                                    throw new Error("Expected Central-File-Header signature");
                                case 22:
                                    return t.next = 24, this.tokenizer.readToken(new T(a.filenameLength, "utf-8"));
                                case 24:
                                    return a.filename = t.sent, t.next = 27, this.tokenizer.ignore(a.extraFieldLength);
                                case 27:
                                    return t.next = 29, this.tokenizer.ignore(a.fileCommentLength);
                                case 29:
                                    _$o.push(a), K("Add central-directory file-entry: n=".concat(i + 1, "/").concat(_$o.length, ": filename=").concat(_$o[i].filename));
                                case 31:
                                    ++i, t.next = 16;
                                    break;
                                case 34:
                                    return this.tokenizer.setPosition(_$e), t.abrupt("return", _$o);
                                case 36:
                                    this.tokenizer.setPosition(_$e);
                                case 37:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return u.apply(this, arguments);
                    })
                },
                {
                    key: "unzip",
                    value: (s = V($().mark(function t(e) {
                        var _$r, n, _$o, i, a, c, s, u, p, l;
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.readCentralDirectory();
                                case 2:
                                    if (!(_$r = t.sent)) {
                                        t.next = 5;
                                        break;
                                    }
                                    return t.abrupt("return", this.iterateOverCentralDirectory(_$r, e));
                                case 5:
                                    n = !1;
                                case 6:
                                    return t.next = 8, this.readLocalFileHeader();
                                case 8:
                                    if (_$o = t.sent) {
                                        t.next = 11;
                                        break;
                                    }
                                    return t.abrupt("break", 64);
                                case 11:
                                    return i = e(_$o), n = !!i.stop, a = void 0, t.next = 16, this.tokenizer.ignore(_$o.extraFieldLength);
                                case 16:
                                    if (!_$o.dataDescriptor || 0 !== _$o.compressedSize) {
                                        t.next = 44;
                                        break;
                                    }
                                    c = [], s = Q, K("Compressed-file-size unknown, scanning for next data-descriptor-signature...."), u = -1;
                                case 21:
                                    if (!(u < 0 && s === Q)) {
                                        t.next = 38;
                                        break;
                                    }
                                    return t.next = 24, this.tokenizer.peekBuffer(this.syncBuffer, {
                                        mayBeLess: !0
                                    });
                                case 24:
                                    if (s = t.sent, u = et(this.syncBuffer.subarray(0, s), J), p = u >= 0 ? u : s, !i.handler) {
                                        t.next = 34;
                                        break;
                                    }
                                    return l = new Uint8Array(p), t.next = 31, this.tokenizer.readBuffer(l);
                                case 31:
                                    c.push(l), t.next = 36;
                                    break;
                                case 34:
                                    return t.next = 36, this.tokenizer.ignore(p);
                                case 36:
                                    t.next = 21;
                                    break;
                                case 38:
                                    if (K("Found data-descriptor-signature at pos=".concat(this.tokenizer.position)), !i.handler) {
                                        t.next = 42;
                                        break;
                                    }
                                    return t.next = 42, this.inflate(_$o, rt(c), i.handler);
                                case 42:
                                    t.next = 56;
                                    break;
                                case 44:
                                    if (!i.handler) {
                                        t.next = 53;
                                        break;
                                    }
                                    return K("Reading compressed-file-data: ".concat(_$o.compressedSize, " bytes")), a = new Uint8Array(_$o.compressedSize), t.next = 49, this.tokenizer.readBuffer(a);
                                case 49:
                                    return t.next = 51, this.inflate(_$o, a, i.handler);
                                case 51:
                                    t.next = 56;
                                    break;
                                case 53:
                                    return K("Ignoring compressed-file-data: ".concat(_$o.compressedSize, " bytes")), t.next = 56, this.tokenizer.ignore(_$o.compressedSize);
                                case 56:
                                    if (K("Reading data-descriptor at pos=".concat(this.tokenizer.position)), !_$o.dataDescriptor) {
                                        t.next = 63;
                                        break;
                                    }
                                    return t.next = 60, this.tokenizer.readToken(N);
                                case 60:
                                    if (134695760 === t.sent.signature) {
                                        t.next = 63;
                                        break;
                                    }
                                    throw new Error("Expected data-descriptor-signature at position ".concat(this.tokenizer.position - N.len));
                                case 63:
                                    if (!n) {
                                        t.next = 6;
                                        break;
                                    }
                                case 64:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return s.apply(this, arguments);
                    })
                },
                {
                    key: "iterateOverCentralDirectory",
                    value: (c = V($().mark(function t(e, r) {
                        var n, _$o, i, a, c, s;
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    n = q(e), t.prev = 1, n.s();
                                case 3:
                                    if ((_$o = n.n()).done) {
                                        t.next = 23;
                                        break;
                                    }
                                    if (i = _$o.value, !(a = r(i)).handler) {
                                        t.next = 19;
                                        break;
                                    }
                                    return this.tokenizer.setPosition(i.relativeOffsetOfLocalHeader), t.next = 10, this.readLocalFileHeader();
                                case 10:
                                    if (!(c = t.sent)) {
                                        t.next = 19;
                                        break;
                                    }
                                    return t.next = 14, this.tokenizer.ignore(c.extraFieldLength);
                                case 14:
                                    return s = new Uint8Array(i.compressedSize), t.next = 17, this.tokenizer.readBuffer(s);
                                case 17:
                                    return t.next = 19, this.inflate(c, s, a.handler);
                                case 19:
                                    if (!a.stop) {
                                        t.next = 21;
                                        break;
                                    }
                                    return t.abrupt("break", 23);
                                case 21:
                                    t.next = 3;
                                    break;
                                case 23:
                                    t.next = 28;
                                    break;
                                case 25:
                                    t.prev = 25, t.t0 = t["catch"](1), n.e(t.t0);
                                case 28:
                                    return t.prev = 28, n.f(), t.finish(28);
                                case 31:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this, [
                            [
                                1,
                                25,
                                28,
                                31
                            ]
                        ]);
                    })), function(t, e) {
                        return c.apply(this, arguments);
                    })
                },
                {
                    key: "inflate",
                    value: (a = V($().mark(function e(r, n, o) {
                        var i;
                        return $().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    if (0 !== r.compressedMethod) {
                                        e.next = 2;
                                        break;
                                    }
                                    return e.abrupt("return", o(n));
                                case 2:
                                    if (8 === r.compressedMethod) {
                                        e.next = 4;
                                        break;
                                    }
                                    throw new Error("Unsupported ZIP compression method: ".concat(r.compressedMethod));
                                case 4:
                                    return K("Decompress filename=".concat(r.filename, ", compressed-size=").concat(n.length)), e.next = 7, t.decompressDeflateRaw(n);
                                case 7:
                                    return i = e.sent, e.abrupt("return", o(i));
                                case 9:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    })), function(t, e, r) {
                        return a.apply(this, arguments);
                    })
                },
                {
                    key: "readLocalFileHeader",
                    value: (i = V($().mark(function t() {
                        var _$e, _$r;
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.tokenizer.peekToken(F);
                                case 2:
                                    if ((_$e = t.sent) !== I) {
                                        t.next = 11;
                                        break;
                                    }
                                    return t.next = 6, this.tokenizer.readToken(R);
                                case 6:
                                    return _$r = t.sent, t.next = 9, this.tokenizer.readToken(new T(_$r.filenameLength, "utf-8"));
                                case 9:
                                    return _$r.filename = t.sent, t.abrupt("return", _$r);
                                case 11:
                                    if (_$e !== z) {
                                        t.next = 13;
                                        break;
                                    }
                                    return t.abrupt("return", !1);
                                case 13:
                                    if (3759263696 !== _$e) {
                                        t.next = 15;
                                        break;
                                    }
                                    throw new Error("Encrypted ZIP");
                                case 15:
                                    throw new Error("Unexpected signature");
                                case 16:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return i.apply(this, arguments);
                    })
                }
            ], n = [
                {
                    key: "decompressDeflateRaw",
                    value: (_$o = V($().mark(function t(e) {
                        var _$r, n, _$o, i, a, c;
                        return $().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return _$r = new ReadableStream({
                                        start: function start(t) {
                                            t.enqueue(e), t.close();
                                        }
                                    }), n = new DecompressionStream("deflate-raw"), _$o = _$r.pipeThrough(n), t.prev = 3, i = new Response(_$o), t.next = 7, i.arrayBuffer();
                                case 7:
                                    return a = t.sent, t.abrupt("return", new Uint8Array(a));
                                case 11:
                                    throw t.prev = 11, t.t0 = t["catch"](3), c = t.t0 instanceof Error ? "Failed to deflate ZIP entry: ".concat(t.t0.message) : "Unknown decompression error in ZIP entry", new TypeError(c);
                                case 15:
                                case "end":
                                    return t.stop();
                            }
                        }, t, null, [
                            [
                                3,
                                11
                            ]
                        ]);
                    })), function(t) {
                        return _$o.apply(this, arguments);
                    })
                }
            ], _$r && H(_$e.prototype, _$r), n && H(_$e, n), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        function nt(t) {
            return nt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function nt(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, nt(t);
        }
        function ot() {
            ot = function ot() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == nt(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(nt(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        var st = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.tokenizer = e;
            }
            var _$e, _$r;
            return _$e = t, _$r = [
                {
                    key: "inflate",
                    value: function value() {
                        var _$t = this.tokenizer;
                        return new ReadableStream({
                            pull: function pull(e) {
                                var _$r;
                                return (_$r = ot().mark(function r() {
                                    var n, _$o;
                                    return ot().wrap(function(r) {
                                        for(;;)switch(r.prev = r.next){
                                            case 0:
                                                return n = new Uint8Array(1024), r.next = 3, _$t.readBuffer(n, {
                                                    mayBeLess: !0
                                                });
                                            case 3:
                                                if (0 !== (_$o = r.sent)) {
                                                    r.next = 7;
                                                    break;
                                                }
                                                return e.close(), r.abrupt("return");
                                            case 7:
                                                e.enqueue(n.subarray(0, _$o));
                                            case 8:
                                            case "end":
                                                return r.stop();
                                        }
                                    }, r);
                                }), function() {
                                    var _$t = this, _$e = arguments;
                                    return new Promise(function(n, o) {
                                        var i = _$r.apply(_$t, _$e);
                                        function a(t) {
                                            it(i, n, o, a, c, "next", t);
                                        }
                                        function c(t) {
                                            it(i, n, o, a, c, "throw", t);
                                        }
                                        a(void 0);
                                    });
                                })();
                            }
                        }).pipeThrough(new DecompressionStream("gzip"));
                    }
                }
            ], _$r && at(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        function pt(t) {
            return pt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function pt(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, pt(t);
        }
        var lt = Object.prototype.toString;
        new globalThis.TextDecoder("utf8"), new globalThis.TextEncoder, Array.from({
            length: 256
        }, function(t, e) {
            return e.toString(16).padStart(2, "0");
        });
        var gt = {
            get: function get(t, e) {
                return 127 & t[e + 3] | (127 & t[e + 2]) << 7 | (127 & t[e + 1]) << 14 | (127 & t[e]) << 21;
            },
            len: 4
        };
        function bt(t) {
            return bt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function bt(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, bt(t);
        }
        function xt() {
            xt = function xt() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == bt(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(bt(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function Pt(t) {
            var _$e = "function" == typeof Map ? new Map : void 0;
            return Pt = function Pt(t) {
                if (null === t || !function(t) {
                    try {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    } catch (e) {
                        return "function" == typeof t;
                    }
                }(t)) return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== _$e) {
                    if (_$e.has(t)) return _$e.get(t);
                    _$e.set(t, r);
                }
                function r() {
                    return At(t, arguments, Lt(this).constructor);
                }
                return r.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: r,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Dt(r, t);
            }, Pt(t);
        }
        function At(t, e, r) {
            return At = Tt() ? Reflect.construct.bind() : function At(t, e, r) {
                var n = [
                    null
                ];
                n.push.apply(n, e);
                var _$o = new (Function.bind.apply(t, n));
                return r && Dt(_$o, r.prototype), _$o;
            }, At.apply(null, arguments);
        }
        function Dt(t, e) {
            return Dt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function Dt(t, e) {
                return t.__proto__ = e, t;
            }, Dt(t, e);
        }
        function Lt(t) {
            return Lt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function Lt(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, Lt(t);
        }
        var Ct = 16777216, It = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && Dt(t, e);
            }(i, t);
            var _$e, _$r, n, _$o = (_$r = i, n = Tt(), function o() {
                var _$t, _$e = Lt(_$r);
                if (n) {
                    var _$o = Lt(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$o);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === bt(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function i() {
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, i), _$o.apply(this, arguments);
            }
            return _$e = i, Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), _$e;
        }(Pt(Error));
        function Rt() {
            return Rt = Ft(xt().mark(function t(e, r) {
                var n, _$o, i, a, c, s = arguments;
                return xt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return _$o = (n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).maximumLength, i = void 0 === _$o ? Ct : _$o, a = n.reason, c = zt(r, i, void 0 === a ? "skip" : a), t.next = 4, e.ignore(c);
                        case 4:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), Rt.apply(this, arguments);
        }
        function Bt() {
            return Bt = Ft(xt().mark(function t(e, r, n) {
                var _$o, i, a, c, s, u, p, l, f = arguments;
                return xt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return a = (i = f.length > 3 && void 0 !== f[3] ? f[3] : {}).maximumLength, c = void 0 === a ? r.length : a, s = i.reason, u = void 0 === s ? "read" : s, p = null !== (_$o = null == n ? void 0 : n.length) && void 0 !== _$o ? _$o : r.length, l = zt(p, c, u), t.abrupt("return", e.readBuffer(r, Ot(Ot({}, n), {}, {
                                length: l
                            })));
                        case 4:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), Bt.apply(this, arguments);
        }
        function $t(t) {
            return $t = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function $t(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, $t(t);
        }
        function Zt() {
            Zt = function Zt() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == $t(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError($t(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        var Kt = 1048576, Qt = Math.pow(2, 31) - 1, Jt = Kt, Xt = new Set([
            "Unexpected signature",
            "Encrypted ZIP",
            "Expected Central-File-Header signature"
        ]), te = [
            "ZIP entry count exceeds ",
            "Unsupported ZIP compression method:",
            "ZIP entry compressed data exceeds ",
            "ZIP entry decompressed data exceeds ",
            "Expected data-descriptor-signature at position "
        ], ee = new Set([
            "Z_BUF_ERROR",
            "Z_DATA_ERROR",
            "ERR_INVALID_STATE"
        ]);
        function ne() {
            return ne = Wt(Zt().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s, u, p, l, f, h, d, m, y, v = arguments;
                return Zt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            _$r = (v.length > 1 && void 0 !== v[1] ? v[1] : {}).maximumLength, n = void 0 === _$r ? Kt : _$r, _$o = new ReadableStream({
                                start: function start(t) {
                                    t.enqueue(e), t.close();
                                }
                            }), i = _$o.pipeThrough(new DecompressionStream("deflate-raw")), a = i.getReader(), c = [], s = 0, t.prev = 6;
                        case 7:
                            return t.next = 9, a.read();
                        case 9:
                            if (u = t.sent, p = u.done, l = u.value, !p) {
                                t.next = 14;
                                break;
                            }
                            return t.abrupt("break", 22);
                        case 14:
                            if (!((s += l.length) > n)) {
                                t.next = 19;
                                break;
                            }
                            return t.next = 18, a.cancel();
                        case 18:
                            throw new Error("ZIP entry decompressed data exceeds ".concat(n, " bytes"));
                        case 19:
                            c.push(l);
                        case 20:
                            t.next = 7;
                            break;
                        case 22:
                            return t.prev = 22, a.releaseLock(), t.finish(22);
                        case 25:
                            for(f = new Uint8Array(s), h = 0, d = 0, m = c; d < m.length; d++)y = m[d], f.set(y, h), h += y.length;
                            return t.abrupt("return", f);
                        case 29:
                        case "end":
                            return t.stop();
                    }
                }, t, null, [
                    [
                        6,
                        ,
                        22,
                        25
                    ]
                ]);
            })), ne.apply(this, arguments);
        }
        var de = 134695760;
        function ve() {
            return ve = Wt(Zt().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s, u, p, l, f, h, d, m = arguments;
                return Zt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            n = (_$r = m.length > 1 && void 0 !== m[1] ? m[1] : {}).shouldBuffer, _$o = _$r.maximumLength, i = void 0 === _$o ? Kt : _$o, a = e.syncBuffer, c = a.length, s = [], u = 0;
                        case 5:
                            return t.next = 7, e.tokenizer.peekBuffer(a, {
                                mayBeLess: !0
                            });
                        case 7:
                            if (p = t.sent, l = me(a.subarray(0, p), u), f = l >= 0 ? 0 : p === c ? Math.min(15, p - 1) : 0, 0 !== (h = l >= 0 ? l : p - f)) {
                                t.next = 13;
                                break;
                            }
                            return t.abrupt("break", 29);
                        case 13:
                            if (!((u += h) > i)) {
                                t.next = 16;
                                break;
                            }
                            throw new Error("ZIP entry compressed data exceeds ".concat(i, " bytes"));
                        case 16:
                            if (!n) {
                                t.next = 23;
                                break;
                            }
                            return d = new Uint8Array(h), t.next = 20, e.tokenizer.readBuffer(d);
                        case 20:
                            s.push(d), t.next = 25;
                            break;
                        case 23:
                            return t.next = 25, e.tokenizer.ignore(h);
                        case 25:
                            if (!(l >= 0)) {
                                t.next = 27;
                                break;
                            }
                            return t.abrupt("break", 29);
                        case 27:
                            t.next = 5;
                            break;
                        case 29:
                            if (qt(e.tokenizer) || (e.knownSizeDescriptorScannedBytes += u), n) {
                                t.next = 32;
                                break;
                            }
                            return t.abrupt("return");
                        case 32:
                            return t.abrupt("return", oe(s, u));
                        case 33:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), ve.apply(this, arguments);
        }
        function be() {
            return be = Wt(Zt().mark(function t(e, r) {
                var n, _$o, i, a, c, s, u = arguments;
                return Zt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            if (_$o = (n = u.length > 2 && void 0 !== u[2] ? u[2] : {}).shouldBuffer, i = n.maximumDescriptorLength, a = void 0 === i ? Kt : i, !r.dataDescriptor || 0 !== r.compressedSize) {
                                t.next = 3;
                                break;
                            }
                            return t.abrupt("return", ye(e, {
                                shouldBuffer: _$o,
                                maximumLength: a
                            }));
                        case 3:
                            if (_$o) {
                                t.next = 7;
                                break;
                            }
                            return t.next = 6, Nt(e.tokenizer, r.compressedSize, {
                                maximumLength: qt(e.tokenizer) ? Kt : e.tokenizer.fileInfo.size,
                                reason: "ZIP entry compressed data"
                            });
                        case 6:
                            return t.abrupt("return");
                        case 7:
                            if (l = (p = e.tokenizer).fileInfo.size, f = Number.isFinite(l) ? Math.max(0, l - p.position) : Number.MAX_SAFE_INTEGER, c = Math.min(f, Qt), !(!Number.isFinite(r.compressedSize) || r.compressedSize < 0 || r.compressedSize > c)) {
                                t.next = 10;
                                break;
                            }
                            throw new Error("ZIP entry compressed data exceeds ".concat(c, " bytes"));
                        case 10:
                            return s = new Uint8Array(r.compressedSize), t.next = 13, e.tokenizer.readBuffer(s);
                        case 13:
                            return t.abrupt("return", s);
                        case 14:
                        case "end":
                            return t.stop();
                    }
                    var p, l, f;
                }, t);
            })), be.apply(this, arguments);
        }
        function we() {
            return (we = Wt(Zt().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s;
                return Zt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return a = {
                                hasContentTypesEntry: !1,
                                hasParsedContentTypesEntry: !1,
                                isParsingContentTypes: !1,
                                hasUnparseableContentTypes: !1,
                                hasWordDirectory: !1,
                                hasPresentationDirectory: !1,
                                hasSpreadsheetDirectory: !1,
                                hasThreeDimensionalModelEntry: !1
                            }, c = {
                                hasDocumentEntry: !1,
                                hasMasterSlideEntry: !1,
                                hasTablesEntry: !1,
                                hasCalculationEngineEntry: !1
                            }, t.prev = 2, t.next = 5, new tt(e).unzip(function(t) {
                                if (pe(a, t.filename), ce(c, t.filename), c.hasDocumentEntry && (c.hasMasterSlideEntry || c.hasTablesEntry)) return i = se(c), {
                                    stop: !0
                                };
                                var _$e = "[Content_Types].xml" === t.filename, _$r = fe(a);
                                if (!_$e && _$r) return i = _$r, {
                                    stop: !0
                                };
                                switch(t.filename){
                                    case "META-INF/mozilla.rsa":
                                        return i = {
                                            ext: "xpi",
                                            mime: "application/x-xpinstall"
                                        }, {
                                            stop: !0
                                        };
                                    case "META-INF/MANIFEST.MF":
                                        return i = {
                                            ext: "jar",
                                            mime: "application/java-archive"
                                        }, {
                                            stop: !0
                                        };
                                    case "mimetype":
                                        return ae(t, Jt) ? {
                                            handler: function handler(t) {
                                                return Wt(Zt().mark(function e() {
                                                    var _$r;
                                                    return Zt().wrap(function(e) {
                                                        for(;;)switch(e.prev = e.next){
                                                            case 0:
                                                                _$r = new TextDecoder("utf-8").decode(t).trim(), i = ue(_$r);
                                                            case 2:
                                                            case "end":
                                                                return e.stop();
                                                        }
                                                    }, e);
                                                }))();
                                            },
                                            stop: !0
                                        } : {};
                                    case "[Content_Types].xml":
                                        return a.hasContentTypesEntry = !0, ae(t, Jt) ? (a.isParsingContentTypes = !0, {
                                            handler: function handler(t) {
                                                return Wt(Zt().mark(function e() {
                                                    var _$r, n;
                                                    return Zt().wrap(function(e) {
                                                        for(;;)switch(e.prev = e.next){
                                                            case 0:
                                                                _$r = new TextDecoder("utf-8").decode(t), (n = he(_$r)) && (i = ue(n)), a.hasParsedContentTypesEntry = !0, a.isParsingContentTypes = !1;
                                                            case 5:
                                                            case "end":
                                                                return e.stop();
                                                        }
                                                    }, e);
                                                }))();
                                            },
                                            stop: !0
                                        }) : (a.hasUnparseableContentTypes = !0, {});
                                    default:
                                        return /classes[0-9]*\.dex/.test(t.filename) ? (i = {
                                            ext: "apk",
                                            mime: "application/vnd.android.package-archive"
                                        }, {
                                            stop: !0
                                        }) : {};
                                }
                            });
                        case 5:
                            t.next = 13;
                            break;
                        case 7:
                            if (t.prev = 7, t.t0 = t["catch"](2), ie(t.t0)) {
                                t.next = 11;
                                break;
                            }
                            throw t.t0;
                        case 11:
                            a.isParsingContentTypes && (a.isParsingContentTypes = !1, a.hasUnparseableContentTypes = !0), !i && t.t0 instanceof D.d1 && !a.hasContentTypesEntry && (i = le(a));
                        case 13:
                            return s = !qt(e) || !c.hasDocumentEntry || c.hasMasterSlideEntry || c.hasTablesEntry || c.hasCalculationEngineEntry ? se(c) : void 0, t.abrupt("return", null !== (_$r = null !== (n = null !== (_$o = i) && void 0 !== _$o ? _$o : fe(a)) && void 0 !== n ? n : s) && void 0 !== _$r ? _$r : {
                                ext: "zip",
                                mime: "application/zip"
                            });
                        case 15:
                        case "end":
                            return t.stop();
                    }
                }, t, null, [
                    [
                        2,
                        7
                    ]
                ]);
            }))).apply(this, arguments);
        }
        function ke(t) {
            return ke = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function ke(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, ke(t);
        }
        function Se() {
            Se = function Se() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == ke(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(ke(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        tt.prototype.inflate = function() {
            var t = Wt(Zt().mark(function t(e, r, n) {
                var _$o;
                return Zt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            if (0 !== e.compressedMethod) {
                                t.next = 2;
                                break;
                            }
                            return t.abrupt("return", n(r));
                        case 2:
                            if (8 === e.compressedMethod) {
                                t.next = 4;
                                break;
                            }
                            throw new Error("Unsupported ZIP compression method: ".concat(e.compressedMethod));
                        case 4:
                            return t.next = 6, re(r, {
                                maximumLength: Kt
                            });
                        case 6:
                            return _$o = t.sent, t.abrupt("return", n(_$o));
                        case 8:
                        case "end":
                            return t.stop();
                    }
                }, t);
            }));
            return function(e, r, n) {
                return t.apply(this, arguments);
            };
        }(), tt.prototype.unzip = function() {
            var t = Wt(Zt().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s;
                return Zt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            _$r = !1, n = 0, _$o = this.tokenizer.position, this.knownSizeDescriptorScannedBytes = 0;
                        case 4:
                            if (!Gt(this.tokenizer, _$o, Ct)) {
                                t.next = 6;
                                break;
                            }
                            throw new It("ZIP stream probing exceeds ".concat(Ct, " bytes"));
                        case 6:
                            return t.next = 8, this.readLocalFileHeader();
                        case 8:
                            if (i = t.sent) {
                                t.next = 11;
                                break;
                            }
                            return t.abrupt("break", 33);
                        case 11:
                            if (!(++n > 1024)) {
                                t.next = 14;
                                break;
                            }
                            throw new Error("ZIP entry count exceeds ".concat(1024));
                        case 14:
                            return a = e(i), _$r = Boolean(a.stop), t.next = 18, this.tokenizer.ignore(i.extraFieldLength);
                        case 18:
                            return t.next = 20, ge(this, i, {
                                shouldBuffer: Boolean(a.handler),
                                maximumDescriptorLength: Math.min(Kt, (u = this, p = _$o, qt(u.tokenizer) ? Math.max(0, Ct - (u.tokenizer.position - p)) : Math.max(0, Kt - u.knownSizeDescriptorScannedBytes)))
                            });
                        case 20:
                            if (c = t.sent, !a.handler) {
                                t.next = 24;
                                break;
                            }
                            return t.next = 24, this.inflate(i, c, a.handler);
                        case 24:
                            if (!i.dataDescriptor) {
                                t.next = 30;
                                break;
                            }
                            return s = new Uint8Array(16), t.next = 28, this.tokenizer.readBuffer(s);
                        case 28:
                            if (F.get(s, 0) === de) {
                                t.next = 30;
                                break;
                            }
                            throw new Error("Expected data-descriptor-signature at position ".concat(this.tokenizer.position - s.length));
                        case 30:
                            if (!Gt(this.tokenizer, _$o, Ct)) {
                                t.next = 32;
                                break;
                            }
                            throw new It("ZIP stream probing exceeds ".concat(Ct, " bytes"));
                        case 32:
                            if (!_$r) {
                                t.next = 4;
                                break;
                            }
                        case 33:
                        case "end":
                            return t.stop();
                    }
                    var u, p;
                }, t, this);
            }));
            return function(e) {
                return t.apply(this, arguments);
            };
        }();
        var je = 1048576;
        function _e() {
            return _e = Oe(Se().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s, u, p;
                return Se().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return c = function() {
                                return (c = Oe(Se().mark(function t(r) {
                                    var n, i, a, c, s;
                                    return Se().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                n = 0;
                                            case 1:
                                                if (!(r > 0)) {
                                                    t.next = 28;
                                                    break;
                                                }
                                                if (!(++n > 256)) {
                                                    t.next = 5;
                                                    break;
                                                }
                                                return t.abrupt("return");
                                            case 5:
                                                if (!Gt(e, u, Ct)) {
                                                    t.next = 7;
                                                    break;
                                                }
                                                return t.abrupt("return");
                                            case 7:
                                                return i = e.position, t.next = 10, _$o();
                                            case 10:
                                                if (17026 !== (a = t.sent).id) {
                                                    t.next = 19;
                                                    break;
                                                }
                                                if (!(a.len > 64)) {
                                                    t.next = 14;
                                                    break;
                                                }
                                                return t.abrupt("return");
                                            case 14:
                                                return c = zt(a.len, 64, "EBML DocType"), t.next = 17, e.readToken(new T(c));
                                            case 17:
                                                return s = t.sent, t.abrupt("return", s.replaceAll(/\0(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF])*$/g, ""));
                                            case 19:
                                                if (!qt(e) || !(!Number.isFinite(a.len) || a.len < 0 || a.len > je)) {
                                                    t.next = 21;
                                                    break;
                                                }
                                                return t.abrupt("return");
                                            case 21:
                                                return t.next = 23, Nt(e, a.len, {
                                                    maximumLength: qt(e) ? je : e.fileInfo.size,
                                                    reason: "EBML payload"
                                                });
                                            case 23:
                                                if (--r, !(e.position <= i)) {
                                                    t.next = 26;
                                                    break;
                                                }
                                                return t.abrupt("return");
                                            case 26:
                                                t.next = 1;
                                                break;
                                            case 28:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))).apply(this, arguments);
                            }, a = function a(t) {
                                return c.apply(this, arguments);
                            }, i = function() {
                                return (i = Oe(Se().mark(function t() {
                                    var _$e, n, _$o, i, a;
                                    return Se().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                return t.next = 2, _$r();
                                            case 2:
                                                return _$e = t.sent, t.next = 5, _$r();
                                            case 5:
                                                return (n = t.sent)[0] ^= 128 >> n.length - 1, _$o = Math.min(6, n.length), i = new DataView(_$e.buffer), a = new DataView(n.buffer, n.length - _$o, _$o), t.abrupt("return", {
                                                    id: mt(i),
                                                    len: mt(a)
                                                });
                                            case 11:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))).apply(this, arguments);
                            }, _$o = function o() {
                                return i.apply(this, arguments);
                            }, n = function() {
                                return (n = Oe(Se().mark(function t() {
                                    var _$r, n, _$o, i;
                                    return Se().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                return t.next = 2, e.peekNumber(E);
                                            case 2:
                                                for(_$r = t.sent, n = 128, _$o = 0; !(_$r & n) && 0 !== n;)++_$o, n >>= 1;
                                                return i = new Uint8Array(_$o + 1), t.next = 9, Mt(e, i, void 0, {
                                                    maximumLength: i.length,
                                                    reason: "EBML field"
                                                });
                                            case 9:
                                                return t.abrupt("return", i);
                                            case 10:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))).apply(this, arguments);
                            }, _$r = function r() {
                                return n.apply(this, arguments);
                            }, t.next = 8, _$o();
                        case 8:
                            return s = t.sent, u = e.position, t.next = 12, a(s.len);
                        case 12:
                            p = t.sent, t.t0 = p, t.next = "webm" === t.t0 ? 16 : "matroska" === t.t0 ? 17 : 18;
                            break;
                        case 16:
                            return t.abrupt("return", {
                                ext: "webm",
                                mime: "video/webm"
                            });
                        case 17:
                            return t.abrupt("return", {
                                ext: "mkv",
                                mime: "video/matroska"
                            });
                        case 18:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), _e.apply(this, arguments);
        }
        function Pe(t) {
            return Pe = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function Pe(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, Pe(t);
        }
        function Ae() {
            Ae = function Ae() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == Pe(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(Pe(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function Ce() {
            return Ce = De(Ae().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s, u, p, l;
                return Ae().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return i = function() {
                                return (i = De(Ae().mark(function t() {
                                    return Ae().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                return t.next = 2, e.readToken(P);
                                            case 2:
                                                return t.t0 = t.sent, t.next = 5, e.readToken(new T(4, "latin1"));
                                            case 5:
                                                return t.t1 = t.sent, t.abrupt("return", {
                                                    length: t.t0,
                                                    type: t.t1
                                                });
                                            case 7:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))).apply(this, arguments);
                            }, _$o = function o() {
                                return i.apply(this, arguments);
                            }, _$r = {
                                ext: "png",
                                mime: "image/png"
                            }, n = {
                                ext: "apng",
                                mime: "image/apng"
                            }, t.next = 6, e.ignore(8);
                        case 6:
                            a = qt(e), c = e.position, s = 0, u = !1;
                        case 10:
                            if (!(++s > 512)) {
                                t.next = 13;
                                break;
                            }
                            return t.abrupt("break", 47);
                        case 13:
                            if (!Gt(e, c, 16777216)) {
                                t.next = 15;
                                break;
                            }
                            return t.abrupt("break", 47);
                        case 15:
                            return p = e.position, t.next = 18, _$o();
                        case 18:
                            if (!((l = t.sent).length < 0)) {
                                t.next = 21;
                                break;
                            }
                            return t.abrupt("return");
                        case 21:
                            if ("IHDR" !== l.type) {
                                t.next = 25;
                                break;
                            }
                            if (13 === l.length) {
                                t.next = 24;
                                break;
                            }
                            return t.abrupt("return");
                        case 24:
                            u = !0;
                        case 25:
                            t.t0 = l.type, t.next = "IDAT" === t.t0 ? 28 : "acTL" === t.t0 ? 29 : 30;
                            break;
                        case 28:
                            return t.abrupt("return", _$r);
                        case 29:
                            return t.abrupt("return", n);
                        case 30:
                            if (u || "CgBI" === l.type) {
                                t.next = 32;
                                break;
                            }
                            return t.abrupt("return");
                        case 32:
                            if (!(a && l.length > 1048576)) {
                                t.next = 34;
                                break;
                            }
                            return t.abrupt("return", u && 32 & l.type.codePointAt(0) ? _$r : void 0);
                        case 34:
                            return t.prev = 34, t.next = 37, Nt(e, l.length + 4, {
                                maximumLength: a ? 1048580 : e.fileInfo.size,
                                reason: "PNG chunk payload"
                            });
                        case 37:
                            t.next = 44;
                            break;
                        case 39:
                            if (t.prev = 39, t.t1 = t["catch"](34), a || !(t.t1 instanceof It || t.t1 instanceof D.d1)) {
                                t.next = 43;
                                break;
                            }
                            return t.abrupt("return", _$r);
                        case 43:
                            throw t.t1;
                        case 44:
                            if (!(e.position <= p)) {
                                t.next = 46;
                                break;
                            }
                            return t.abrupt("break", 47);
                        case 46:
                            if (e.position + 8 < e.fileInfo.size) {
                                t.next = 10;
                                break;
                            }
                        case 47:
                            return t.abrupt("return", _$r);
                        case 48:
                        case "end":
                            return t.stop();
                    }
                }, t, null, [
                    [
                        34,
                        39
                    ]
                ]);
            })), Ce.apply(this, arguments);
        }
        function Ie(t) {
            return Ie = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function Ie(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, Ie(t);
        }
        function ze() {
            ze = function ze() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == Ie(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(Ie(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        var Me, Be = 1048576;
        function qe() {
            return qe = Re(ze().mark(function t(e) {
                var _$r, n, _$o, i, a, c, s, u, p, l;
                return ze().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return _$r = !1, t.prev = 1, _$o = function() {
                                return (_$o = Re(ze().mark(function t() {
                                    var _$r;
                                    return ze().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                return _$r = new Uint8Array(16), t.next = 3, Mt(e, _$r, void 0, {
                                                    maximumLength: _$r.length,
                                                    reason: "ASF header GUID"
                                                });
                                            case 3:
                                                return t.t0 = _$r, t.t1 = Number, t.next = 7, e.readToken(A);
                                            case 7:
                                                return t.t2 = t.sent, t.t3 = (0, t.t1)(t.t2), t.abrupt("return", {
                                                    id: t.t0,
                                                    size: t.t3
                                                });
                                            case 10:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))).apply(this, arguments);
                            }, n = function n() {
                                return _$o.apply(this, arguments);
                            }, t.next = 6, Nt(e, 30, {
                                maximumLength: 30,
                                reason: "ASF header prelude"
                            });
                        case 6:
                            i = qt(e), a = e.position, c = 0;
                        case 9:
                            if (!(e.position + 24 < e.fileInfo.size)) {
                                t.next = 44;
                                break;
                            }
                            if (!(++c > 512)) {
                                t.next = 13;
                                break;
                            }
                            return t.abrupt("break", 44);
                        case 13:
                            if (!Gt(e, a, Ct)) {
                                t.next = 15;
                                break;
                            }
                            return t.abrupt("break", 44);
                        case 15:
                            return s = e.position, t.next = 18, n();
                        case 18:
                            if (u = t.sent, p = u.size - 24, Number.isFinite(p) && !(p < 0)) {
                                t.next = 23;
                                break;
                            }
                            return _$r = !0, t.abrupt("break", 44);
                        case 23:
                            if (!Ut(u.id, [
                                145,
                                7,
                                220,
                                183,
                                183,
                                169,
                                207,
                                17,
                                142,
                                230,
                                0,
                                192,
                                12,
                                32,
                                83,
                                101
                            ])) {
                                t.next = 34;
                                break;
                            }
                            return l = new Uint8Array(16), t.t0 = p, t.next = 28, Mt(e, l, void 0, {
                                maximumLength: l.length,
                                reason: "ASF stream type GUID"
                            });
                        case 28:
                            if (p = t.t0 -= t.sent, !Ut(l, [
                                64,
                                158,
                                105,
                                248,
                                77,
                                91,
                                207,
                                17,
                                168,
                                253,
                                0,
                                128,
                                95,
                                92,
                                68,
                                43
                            ])) {
                                t.next = 31;
                                break;
                            }
                            return t.abrupt("return", {
                                ext: "asf",
                                mime: "audio/x-ms-asf"
                            });
                        case 31:
                            if (!Ut(l, [
                                192,
                                239,
                                25,
                                188,
                                77,
                                91,
                                207,
                                17,
                                168,
                                253,
                                0,
                                128,
                                95,
                                92,
                                68,
                                43
                            ])) {
                                t.next = 33;
                                break;
                            }
                            return t.abrupt("return", {
                                ext: "asf",
                                mime: "video/x-ms-asf"
                            });
                        case 33:
                            return t.abrupt("break", 44);
                        case 34:
                            if (!(i && p > Be)) {
                                t.next = 37;
                                break;
                            }
                            return _$r = !0, t.abrupt("break", 44);
                        case 37:
                            return t.next = 39, Nt(e, p, {
                                maximumLength: i ? Be : e.fileInfo.size,
                                reason: "ASF header payload"
                            });
                        case 39:
                            if (!(e.position <= s)) {
                                t.next = 42;
                                break;
                            }
                            return _$r = !0, t.abrupt("break", 44);
                        case 42:
                            t.next = 9;
                            break;
                        case 44:
                            t.next = 53;
                            break;
                        case 46:
                            if (t.prev = 46, t.t1 = t["catch"](1), !(t.t1 instanceof D.d1 || t.t1 instanceof It)) {
                                t.next = 52;
                                break;
                            }
                            qt(e) && (_$r = !0), t.next = 53;
                            break;
                        case 52:
                            throw t.t1;
                        case 53:
                            if (!_$r) {
                                t.next = 55;
                                break;
                            }
                            return t.abrupt("return");
                        case 55:
                            return t.abrupt("return", {
                                ext: "asf",
                                mime: "application/vnd.ms-asf"
                            });
                        case 56:
                        case "end":
                            return t.stop();
                    }
                }, t, null, [
                    [
                        1,
                        46
                    ]
                ]);
            })), qe.apply(this, arguments);
        }
        function $e(t) {
            return $e = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function $e(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, $e(t);
        }
        function Xe() {
            Xe = function Xe() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == $e(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError($e(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        var rr = 4100, nr = Ct, or = Ct, ir = Ct;
        function lr() {
            return (lr = er(Xe().mark(function t(e, r) {
                return Xe().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return t.abrupt("return", new fr(r).fromBuffer(e));
                        case 1:
                        case "end":
                            return t.stop();
                    }
                }, t);
            }))).apply(this, arguments);
        }
        var fr = function() {
            function t(e) {
                var _$r, n = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Qe(this, "detectConfident", function() {
                    var _$t = er(Xe().mark(function t(e) {
                        var _$r, _$o, i, a, c, s, u, p, l, f, h, d, m;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (n.buffer = new Uint8Array(rr), void 0 === e.fileInfo.size && (e.fileInfo.size = Number.MAX_SAFE_INTEGER), n.tokenizer = e, !qt(e)) {
                                        t.next = 8;
                                        break;
                                    }
                                    return t.next = 6, e.peekBuffer(n.buffer, {
                                        length: 3,
                                        mayBeLess: !0
                                    });
                                case 6:
                                    if (!n.check([
                                        31,
                                        139,
                                        8
                                    ])) {
                                        t.next = 8;
                                        break;
                                    }
                                    return t.abrupt("return", n.detectGzip(e));
                                case 8:
                                    return t.next = 10, e.peekBuffer(n.buffer, {
                                        length: 32,
                                        mayBeLess: !0
                                    });
                                case 10:
                                    if (!n.check([
                                        66,
                                        77
                                    ])) {
                                        t.next = 12;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "bmp",
                                        mime: "image/bmp"
                                    });
                                case 12:
                                    if (!n.check([
                                        11,
                                        119
                                    ])) {
                                        t.next = 14;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ac3",
                                        mime: "audio/vnd.dolby.dd-raw"
                                    });
                                case 14:
                                    if (!n.check([
                                        120,
                                        1
                                    ])) {
                                        t.next = 16;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "dmg",
                                        mime: "application/x-apple-diskimage"
                                    });
                                case 16:
                                    if (!n.check([
                                        77,
                                        90
                                    ])) {
                                        t.next = 18;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "exe",
                                        mime: "application/x-msdownload"
                                    });
                                case 18:
                                    if (!n.check([
                                        37,
                                        33
                                    ])) {
                                        t.next = 24;
                                        break;
                                    }
                                    return t.next = 21, e.peekBuffer(n.buffer, {
                                        length: 24,
                                        mayBeLess: !0
                                    });
                                case 21:
                                    if (!n.checkString("PS-Adobe-", {
                                        offset: 2
                                    }) || !n.checkString(" EPSF-", {
                                        offset: 14
                                    })) {
                                        t.next = 23;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "eps",
                                        mime: "application/eps"
                                    });
                                case 23:
                                    return t.abrupt("return", {
                                        ext: "ps",
                                        mime: "application/postscript"
                                    });
                                case 24:
                                    if (!n.check([
                                        31,
                                        160
                                    ]) && !n.check([
                                        31,
                                        157
                                    ])) {
                                        t.next = 26;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "Z",
                                        mime: "application/x-compress"
                                    });
                                case 26:
                                    if (!n.check([
                                        199,
                                        113
                                    ])) {
                                        t.next = 28;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "cpio",
                                        mime: "application/x-cpio"
                                    });
                                case 28:
                                    if (!n.check([
                                        96,
                                        234
                                    ])) {
                                        t.next = 30;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "arj",
                                        mime: "application/x-arj"
                                    });
                                case 30:
                                    if (!n.check([
                                        239,
                                        187,
                                        191
                                    ])) {
                                        t.next = 37;
                                        break;
                                    }
                                    if (!(n.detectionReentryCount >= 256)) {
                                        t.next = 33;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 33:
                                    return n.detectionReentryCount++, t.next = 36, n.tokenizer.ignore(3);
                                case 36:
                                    return t.abrupt("return", n.detectConfident(e));
                                case 37:
                                    if (!n.check([
                                        71,
                                        73,
                                        70
                                    ])) {
                                        t.next = 39;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "gif",
                                        mime: "image/gif"
                                    });
                                case 39:
                                    if (!n.check([
                                        73,
                                        73,
                                        188
                                    ])) {
                                        t.next = 41;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "jxr",
                                        mime: "image/vnd.ms-photo"
                                    });
                                case 41:
                                    if (!n.check([
                                        31,
                                        139,
                                        8
                                    ])) {
                                        t.next = 43;
                                        break;
                                    }
                                    return t.abrupt("return", n.detectGzip(e));
                                case 43:
                                    if (!n.check([
                                        66,
                                        90,
                                        104
                                    ])) {
                                        t.next = 45;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "bz2",
                                        mime: "application/x-bzip2"
                                    });
                                case 45:
                                    if (!n.checkString("ID3")) {
                                        t.next = 72;
                                        break;
                                    }
                                    return t.next = 48, Nt(e, 6, {
                                        maximumLength: 6,
                                        reason: "ID3 header prefix"
                                    });
                                case 48:
                                    return t.next = 50, e.readToken(gt);
                                case 50:
                                    if (_$r = t.sent, _$o = qt(e), !(!Number.isFinite(_$r) || _$r < 0 || _$o && (_$r > or || e.position + _$r > or))) {
                                        t.next = 54;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 54:
                                    if (!(e.position + _$r > e.fileInfo.size)) {
                                        t.next = 58;
                                        break;
                                    }
                                    if (!_$o) {
                                        t.next = 57;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 57:
                                    return t.abrupt("return", {
                                        ext: "mp3",
                                        mime: "audio/mpeg"
                                    });
                                case 58:
                                    return t.prev = 58, t.next = 61, Nt(e, _$r, {
                                        maximumLength: _$o ? or : e.fileInfo.size,
                                        reason: "ID3 payload"
                                    });
                                case 61:
                                    t.next = 68;
                                    break;
                                case 63:
                                    if (t.prev = 63, t.t0 = t["catch"](58), !(t.t0 instanceof D.d1)) {
                                        t.next = 67;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 67:
                                    throw t.t0;
                                case 68:
                                    if (!(n.detectionReentryCount >= 256)) {
                                        t.next = 70;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 70:
                                    return n.detectionReentryCount++, t.abrupt("return", n.parseTokenizer(e, n.detectionReentryCount));
                                case 72:
                                    if (!n.checkString("MP+")) {
                                        t.next = 74;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mpc",
                                        mime: "audio/x-musepack"
                                    });
                                case 74:
                                    if (67 !== n.buffer[0] && 70 !== n.buffer[0] || !n.check([
                                        87,
                                        83
                                    ], {
                                        offset: 1
                                    })) {
                                        t.next = 76;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "swf",
                                        mime: "application/x-shockwave-flash"
                                    });
                                case 76:
                                    if (!n.check([
                                        255,
                                        216,
                                        255
                                    ])) {
                                        t.next = 80;
                                        break;
                                    }
                                    if (!n.check([
                                        247
                                    ], {
                                        offset: 3
                                    })) {
                                        t.next = 79;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "jls",
                                        mime: "image/jls"
                                    });
                                case 79:
                                    return t.abrupt("return", {
                                        ext: "jpg",
                                        mime: "image/jpeg"
                                    });
                                case 80:
                                    if (!n.check([
                                        79,
                                        98,
                                        106,
                                        1
                                    ])) {
                                        t.next = 82;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "avro",
                                        mime: "application/avro"
                                    });
                                case 82:
                                    if (!n.checkString("FLIF")) {
                                        t.next = 84;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "flif",
                                        mime: "image/flif"
                                    });
                                case 84:
                                    if (!n.checkString("8BPS")) {
                                        t.next = 86;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "psd",
                                        mime: "image/vnd.adobe.photoshop"
                                    });
                                case 86:
                                    if (!n.checkString("MPCK")) {
                                        t.next = 88;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mpc",
                                        mime: "audio/x-musepack"
                                    });
                                case 88:
                                    if (!n.checkString("FORM")) {
                                        t.next = 90;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "aif",
                                        mime: "audio/aiff"
                                    });
                                case 90:
                                    if (!n.checkString("icns", {
                                        offset: 0
                                    })) {
                                        t.next = 92;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "icns",
                                        mime: "image/icns"
                                    });
                                case 92:
                                    if (!n.check([
                                        80,
                                        75,
                                        3,
                                        4
                                    ])) {
                                        t.next = 94;
                                        break;
                                    }
                                    return t.abrupt("return", xe(e));
                                case 94:
                                    if (!n.checkString("OggS")) {
                                        t.next = 113;
                                        break;
                                    }
                                    return t.next = 97, e.ignore(28);
                                case 97:
                                    return i = new Uint8Array(8), t.next = 100, e.readBuffer(i);
                                case 100:
                                    if (!Ut(i, [
                                        79,
                                        112,
                                        117,
                                        115,
                                        72,
                                        101,
                                        97,
                                        100
                                    ])) {
                                        t.next = 102;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "opus",
                                        mime: "audio/ogg; codecs=opus"
                                    });
                                case 102:
                                    if (!Ut(i, [
                                        128,
                                        116,
                                        104,
                                        101,
                                        111,
                                        114,
                                        97
                                    ])) {
                                        t.next = 104;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ogv",
                                        mime: "video/ogg"
                                    });
                                case 104:
                                    if (!Ut(i, [
                                        1,
                                        118,
                                        105,
                                        100,
                                        101,
                                        111,
                                        0
                                    ])) {
                                        t.next = 106;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ogm",
                                        mime: "video/ogg"
                                    });
                                case 106:
                                    if (!Ut(i, [
                                        127,
                                        70,
                                        76,
                                        65,
                                        67
                                    ])) {
                                        t.next = 108;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "oga",
                                        mime: "audio/ogg"
                                    });
                                case 108:
                                    if (!Ut(i, [
                                        83,
                                        112,
                                        101,
                                        101,
                                        120,
                                        32,
                                        32
                                    ])) {
                                        t.next = 110;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "spx",
                                        mime: "audio/ogg"
                                    });
                                case 110:
                                    if (!Ut(i, [
                                        1,
                                        118,
                                        111,
                                        114,
                                        98,
                                        105,
                                        115
                                    ])) {
                                        t.next = 112;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ogg",
                                        mime: "audio/ogg"
                                    });
                                case 112:
                                    return t.abrupt("return", {
                                        ext: "ogx",
                                        mime: "application/ogg"
                                    });
                                case 113:
                                    if (!n.check([
                                        80,
                                        75
                                    ]) || 3 !== n.buffer[2] && 5 !== n.buffer[2] && 7 !== n.buffer[2] || 4 !== n.buffer[3] && 6 !== n.buffer[3] && 8 !== n.buffer[3]) {
                                        t.next = 115;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "zip",
                                        mime: "application/zip"
                                    });
                                case 115:
                                    if (!n.checkString("MThd")) {
                                        t.next = 117;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mid",
                                        mime: "audio/midi"
                                    });
                                case 117:
                                    if (!n.checkString("wOFF") || !n.check([
                                        0,
                                        1,
                                        0,
                                        0
                                    ], {
                                        offset: 4
                                    }) && !n.checkString("OTTO", {
                                        offset: 4
                                    })) {
                                        t.next = 119;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "woff",
                                        mime: "font/woff"
                                    });
                                case 119:
                                    if (!n.checkString("wOF2") || !n.check([
                                        0,
                                        1,
                                        0,
                                        0
                                    ], {
                                        offset: 4
                                    }) && !n.checkString("OTTO", {
                                        offset: 4
                                    })) {
                                        t.next = 121;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "woff2",
                                        mime: "font/woff2"
                                    });
                                case 121:
                                    if (!n.check([
                                        212,
                                        195,
                                        178,
                                        161
                                    ]) && !n.check([
                                        161,
                                        178,
                                        195,
                                        212
                                    ])) {
                                        t.next = 123;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "pcap",
                                        mime: "application/vnd.tcpdump.pcap"
                                    });
                                case 123:
                                    if (!n.checkString("DSD ")) {
                                        t.next = 125;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "dsf",
                                        mime: "audio/x-dsf"
                                    });
                                case 125:
                                    if (!n.checkString("LZIP")) {
                                        t.next = 127;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "lz",
                                        mime: "application/lzip"
                                    });
                                case 127:
                                    if (!n.checkString("fLaC")) {
                                        t.next = 129;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "flac",
                                        mime: "audio/flac"
                                    });
                                case 129:
                                    if (!n.check([
                                        66,
                                        80,
                                        71,
                                        251
                                    ])) {
                                        t.next = 131;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "bpg",
                                        mime: "image/bpg"
                                    });
                                case 131:
                                    if (!n.checkString("wvpk")) {
                                        t.next = 133;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "wv",
                                        mime: "audio/wavpack"
                                    });
                                case 133:
                                    if (!n.checkString("%PDF")) {
                                        t.next = 135;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "pdf",
                                        mime: "application/pdf"
                                    });
                                case 135:
                                    if (!n.check([
                                        0,
                                        97,
                                        115,
                                        109
                                    ])) {
                                        t.next = 137;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "wasm",
                                        mime: "application/wasm"
                                    });
                                case 137:
                                    if (!n.check([
                                        73,
                                        73
                                    ])) {
                                        t.next = 143;
                                        break;
                                    }
                                    return t.next = 140, n.readTiffHeader(!1);
                                case 140:
                                    if (!(a = t.sent)) {
                                        t.next = 143;
                                        break;
                                    }
                                    return t.abrupt("return", a);
                                case 143:
                                    if (!n.check([
                                        77,
                                        77
                                    ])) {
                                        t.next = 149;
                                        break;
                                    }
                                    return t.next = 146, n.readTiffHeader(!0);
                                case 146:
                                    if (!(c = t.sent)) {
                                        t.next = 149;
                                        break;
                                    }
                                    return t.abrupt("return", c);
                                case 149:
                                    if (!n.checkString("MAC ")) {
                                        t.next = 151;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ape",
                                        mime: "audio/ape"
                                    });
                                case 151:
                                    if (!n.check([
                                        26,
                                        69,
                                        223,
                                        163
                                    ])) {
                                        t.next = 153;
                                        break;
                                    }
                                    return t.abrupt("return", Fe(e));
                                case 153:
                                    if (!n.checkString("SQLi")) {
                                        t.next = 155;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "sqlite",
                                        mime: "application/x-sqlite3"
                                    });
                                case 155:
                                    if (!n.check([
                                        78,
                                        69,
                                        83,
                                        26
                                    ])) {
                                        t.next = 157;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "nes",
                                        mime: "application/x-nintendo-nes-rom"
                                    });
                                case 157:
                                    if (!n.checkString("Cr24")) {
                                        t.next = 159;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "crx",
                                        mime: "application/x-google-chrome-extension"
                                    });
                                case 159:
                                    if (!n.checkString("MSCF") && !n.checkString("ISc(")) {
                                        t.next = 161;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "cab",
                                        mime: "application/vnd.ms-cab-compressed"
                                    });
                                case 161:
                                    if (!n.check([
                                        237,
                                        171,
                                        238,
                                        219
                                    ])) {
                                        t.next = 163;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "rpm",
                                        mime: "application/x-rpm"
                                    });
                                case 163:
                                    if (!n.check([
                                        197,
                                        208,
                                        211,
                                        198
                                    ])) {
                                        t.next = 165;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "eps",
                                        mime: "application/eps"
                                    });
                                case 165:
                                    if (!n.check([
                                        40,
                                        181,
                                        47,
                                        253
                                    ])) {
                                        t.next = 167;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "zst",
                                        mime: "application/zstd"
                                    });
                                case 167:
                                    if (!n.check([
                                        127,
                                        69,
                                        76,
                                        70
                                    ])) {
                                        t.next = 169;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "elf",
                                        mime: "application/x-elf"
                                    });
                                case 169:
                                    if (!n.check([
                                        33,
                                        66,
                                        68,
                                        78
                                    ])) {
                                        t.next = 171;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "pst",
                                        mime: "application/vnd.ms-outlook"
                                    });
                                case 171:
                                    if (!n.checkString("PAR1") && !n.checkString("PARE")) {
                                        t.next = 173;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "parquet",
                                        mime: "application/vnd.apache.parquet"
                                    });
                                case 173:
                                    if (!n.checkString("ttcf")) {
                                        t.next = 175;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ttc",
                                        mime: "font/collection"
                                    });
                                case 175:
                                    if (!(n.check([
                                        254,
                                        237,
                                        250,
                                        206
                                    ]) || n.check([
                                        254,
                                        237,
                                        250,
                                        207
                                    ]) || n.check([
                                        206,
                                        250,
                                        237,
                                        254
                                    ]) || n.check([
                                        207,
                                        250,
                                        237,
                                        254
                                    ]))) {
                                        t.next = 177;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "macho",
                                        mime: "application/x-mach-binary"
                                    });
                                case 177:
                                    if (!n.check([
                                        4,
                                        34,
                                        77,
                                        24
                                    ])) {
                                        t.next = 179;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "lz4",
                                        mime: "application/x-lz4"
                                    });
                                case 179:
                                    if (!n.checkString("regf")) {
                                        t.next = 181;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "dat",
                                        mime: "application/x-ft-windows-registry-hive"
                                    });
                                case 181:
                                    if (!n.checkString("$FL2") && !n.checkString("$FL3")) {
                                        t.next = 183;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "sav",
                                        mime: "application/x-spss-sav"
                                    });
                                case 183:
                                    if (!n.check([
                                        79,
                                        84,
                                        84,
                                        79,
                                        0
                                    ])) {
                                        t.next = 185;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "otf",
                                        mime: "font/otf"
                                    });
                                case 185:
                                    if (!n.checkString("#!AMR")) {
                                        t.next = 187;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "amr",
                                        mime: "audio/amr"
                                    });
                                case 187:
                                    if (!n.checkString(String.raw(Me || (y = [
                                        "{\rtf"
                                    ], v = [
                                        "{\\rtf"
                                    ], v || (v = y.slice(0)), Me = Object.freeze(Object.defineProperties(y, {
                                        raw: {
                                            value: Object.freeze(v)
                                        }
                                    })))))) {
                                        t.next = 189;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "rtf",
                                        mime: "application/rtf"
                                    });
                                case 189:
                                    if (!n.check([
                                        70,
                                        76,
                                        86,
                                        1
                                    ])) {
                                        t.next = 191;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "flv",
                                        mime: "video/x-flv"
                                    });
                                case 191:
                                    if (!n.checkString("IMPM")) {
                                        t.next = 193;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "it",
                                        mime: "audio/x-it"
                                    });
                                case 193:
                                    if (!(n.checkString("-lh0-", {
                                        offset: 2
                                    }) || n.checkString("-lh1-", {
                                        offset: 2
                                    }) || n.checkString("-lh2-", {
                                        offset: 2
                                    }) || n.checkString("-lh3-", {
                                        offset: 2
                                    }) || n.checkString("-lh4-", {
                                        offset: 2
                                    }) || n.checkString("-lh5-", {
                                        offset: 2
                                    }) || n.checkString("-lh6-", {
                                        offset: 2
                                    }) || n.checkString("-lh7-", {
                                        offset: 2
                                    }) || n.checkString("-lzs-", {
                                        offset: 2
                                    }) || n.checkString("-lz4-", {
                                        offset: 2
                                    }) || n.checkString("-lz5-", {
                                        offset: 2
                                    }) || n.checkString("-lhd-", {
                                        offset: 2
                                    }))) {
                                        t.next = 195;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "lzh",
                                        mime: "application/x-lzh-compressed"
                                    });
                                case 195:
                                    if (!n.check([
                                        0,
                                        0,
                                        1,
                                        186
                                    ])) {
                                        t.next = 200;
                                        break;
                                    }
                                    if (!n.check([
                                        33
                                    ], {
                                        offset: 4,
                                        mask: [
                                            241
                                        ]
                                    })) {
                                        t.next = 198;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mpg",
                                        mime: "video/MP1S"
                                    });
                                case 198:
                                    if (!n.check([
                                        68
                                    ], {
                                        offset: 4,
                                        mask: [
                                            196
                                        ]
                                    })) {
                                        t.next = 200;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mpg",
                                        mime: "video/MP2P"
                                    });
                                case 200:
                                    if (!n.checkString("ITSF")) {
                                        t.next = 202;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "chm",
                                        mime: "application/vnd.ms-htmlhelp"
                                    });
                                case 202:
                                    if (!n.check([
                                        202,
                                        254,
                                        186,
                                        190
                                    ])) {
                                        t.next = 209;
                                        break;
                                    }
                                    if (s = _.get(n.buffer, 4), u = j.get(n.buffer, 6), !(s > 0 && s <= 30)) {
                                        t.next = 207;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "macho",
                                        mime: "application/x-mach-binary"
                                    });
                                case 207:
                                    if (!(u > 30)) {
                                        t.next = 209;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "class",
                                        mime: "application/java-vm"
                                    });
                                case 209:
                                    if (!n.checkString(".RMF")) {
                                        t.next = 211;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "rm",
                                        mime: "application/vnd.rn-realmedia"
                                    });
                                case 211:
                                    if (!n.checkString("DRACO")) {
                                        t.next = 213;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "drc",
                                        mime: "application/x-ft-draco"
                                    });
                                case 213:
                                    if (!n.check([
                                        253,
                                        55,
                                        122,
                                        88,
                                        90,
                                        0
                                    ])) {
                                        t.next = 215;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "xz",
                                        mime: "application/x-xz"
                                    });
                                case 215:
                                    if (!n.checkString("<?xml ")) {
                                        t.next = 217;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "xml",
                                        mime: "application/xml"
                                    });
                                case 217:
                                    if (!n.check([
                                        55,
                                        122,
                                        188,
                                        175,
                                        39,
                                        28
                                    ])) {
                                        t.next = 219;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "7z",
                                        mime: "application/x-7z-compressed"
                                    });
                                case 219:
                                    if (!n.check([
                                        82,
                                        97,
                                        114,
                                        33,
                                        26,
                                        7
                                    ]) || 0 !== n.buffer[6] && 1 !== n.buffer[6]) {
                                        t.next = 221;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "rar",
                                        mime: "application/x-rar-compressed"
                                    });
                                case 221:
                                    if (!n.checkString("solid ")) {
                                        t.next = 223;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "stl",
                                        mime: "model/stl"
                                    });
                                case 223:
                                    if (!n.checkString("AC")) {
                                        t.next = 227;
                                        break;
                                    }
                                    if (p = new T(4, "latin1").get(n.buffer, 2), !(/^[0-9]+$/.test(p) && p >= 1e3 && p <= 1050)) {
                                        t.next = 227;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "dwg",
                                        mime: "image/vnd.dwg"
                                    });
                                case 227:
                                    if (!n.checkString("070707")) {
                                        t.next = 229;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "cpio",
                                        mime: "application/x-cpio"
                                    });
                                case 229:
                                    if (!n.checkString("BLENDER")) {
                                        t.next = 231;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "blend",
                                        mime: "application/x-blender"
                                    });
                                case 231:
                                    if (!n.checkString("!<arch>")) {
                                        t.next = 240;
                                        break;
                                    }
                                    return t.next = 234, e.ignore(8);
                                case 234:
                                    return t.next = 236, e.readToken(new T(13, "ascii"));
                                case 236:
                                    if ("debian-binary" !== t.sent) {
                                        t.next = 239;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "deb",
                                        mime: "application/x-deb"
                                    });
                                case 239:
                                    return t.abrupt("return", {
                                        ext: "ar",
                                        mime: "application/x-unix-archive"
                                    });
                                case 240:
                                    if (!n.checkString("WEBVTT") || ![
                                        "\n",
                                        "\r",
                                        "\t",
                                        " ",
                                        "\0"
                                    ].some(function(t) {
                                        return n.checkString(t, {
                                            offset: 6
                                        });
                                    })) {
                                        t.next = 242;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "vtt",
                                        mime: "text/vtt"
                                    });
                                case 242:
                                    if (!n.check([
                                        137,
                                        80,
                                        78,
                                        71,
                                        13,
                                        10,
                                        26,
                                        10
                                    ])) {
                                        t.next = 244;
                                        break;
                                    }
                                    return t.abrupt("return", Le(e));
                                case 244:
                                    if (!n.check([
                                        65,
                                        82,
                                        82,
                                        79,
                                        87,
                                        49,
                                        0,
                                        0
                                    ])) {
                                        t.next = 246;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "arrow",
                                        mime: "application/vnd.apache.arrow.file"
                                    });
                                case 246:
                                    if (!n.check([
                                        103,
                                        108,
                                        84,
                                        70,
                                        2,
                                        0,
                                        0,
                                        0
                                    ])) {
                                        t.next = 248;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "glb",
                                        mime: "model/gltf-binary"
                                    });
                                case 248:
                                    if (!(n.check([
                                        102,
                                        114,
                                        101,
                                        101
                                    ], {
                                        offset: 4
                                    }) || n.check([
                                        109,
                                        100,
                                        97,
                                        116
                                    ], {
                                        offset: 4
                                    }) || n.check([
                                        109,
                                        111,
                                        111,
                                        118
                                    ], {
                                        offset: 4
                                    }) || n.check([
                                        119,
                                        105,
                                        100,
                                        101
                                    ], {
                                        offset: 4
                                    }))) {
                                        t.next = 250;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mov",
                                        mime: "video/quicktime"
                                    });
                                case 250:
                                    if (!n.check([
                                        73,
                                        73,
                                        82,
                                        79,
                                        8,
                                        0,
                                        0,
                                        0,
                                        24
                                    ])) {
                                        t.next = 252;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "orf",
                                        mime: "image/x-olympus-orf"
                                    });
                                case 252:
                                    if (!n.checkString("gimp xcf ")) {
                                        t.next = 254;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "xcf",
                                        mime: "image/x-xcf"
                                    });
                                case 254:
                                    if (!(n.checkString("ftyp", {
                                        offset: 4
                                    }) && 96 & n.buffer[8])) {
                                        t.next = 279;
                                        break;
                                    }
                                    l = new T(4, "latin1").get(n.buffer, 8).replace("\0", " ").trim(), t.t1 = l, t.next = "avif" === t.t1 || "avis" === t.t1 ? 259 : "mif1" === t.t1 ? 260 : "msf1" === t.t1 ? 261 : "heic" === t.t1 || "heix" === t.t1 ? 262 : "hevc" === t.t1 || "hevx" === t.t1 ? 263 : "qt" === t.t1 ? 264 : "M4V" === t.t1 || "M4VH" === t.t1 || "M4VP" === t.t1 ? 265 : "M4P" === t.t1 ? 266 : "M4B" === t.t1 ? 267 : "M4A" === t.t1 ? 268 : "F4V" === t.t1 ? 269 : "F4P" === t.t1 ? 270 : "F4A" === t.t1 ? 271 : "F4B" === t.t1 ? 272 : "crx" === t.t1 ? 273 : 274;
                                    break;
                                case 259:
                                    return t.abrupt("return", {
                                        ext: "avif",
                                        mime: "image/avif"
                                    });
                                case 260:
                                    return t.abrupt("return", {
                                        ext: "heic",
                                        mime: "image/heif"
                                    });
                                case 261:
                                    return t.abrupt("return", {
                                        ext: "heic",
                                        mime: "image/heif-sequence"
                                    });
                                case 262:
                                    return t.abrupt("return", {
                                        ext: "heic",
                                        mime: "image/heic"
                                    });
                                case 263:
                                    return t.abrupt("return", {
                                        ext: "heic",
                                        mime: "image/heic-sequence"
                                    });
                                case 264:
                                    return t.abrupt("return", {
                                        ext: "mov",
                                        mime: "video/quicktime"
                                    });
                                case 265:
                                    return t.abrupt("return", {
                                        ext: "m4v",
                                        mime: "video/x-m4v"
                                    });
                                case 266:
                                    return t.abrupt("return", {
                                        ext: "m4p",
                                        mime: "video/mp4"
                                    });
                                case 267:
                                    return t.abrupt("return", {
                                        ext: "m4b",
                                        mime: "audio/mp4"
                                    });
                                case 268:
                                    return t.abrupt("return", {
                                        ext: "m4a",
                                        mime: "audio/x-m4a"
                                    });
                                case 269:
                                    return t.abrupt("return", {
                                        ext: "f4v",
                                        mime: "video/mp4"
                                    });
                                case 270:
                                    return t.abrupt("return", {
                                        ext: "f4p",
                                        mime: "video/mp4"
                                    });
                                case 271:
                                    return t.abrupt("return", {
                                        ext: "f4a",
                                        mime: "audio/mp4"
                                    });
                                case 272:
                                    return t.abrupt("return", {
                                        ext: "f4b",
                                        mime: "audio/mp4"
                                    });
                                case 273:
                                    return t.abrupt("return", {
                                        ext: "cr3",
                                        mime: "image/x-canon-cr3"
                                    });
                                case 274:
                                    if (!l.startsWith("3g")) {
                                        t.next = 278;
                                        break;
                                    }
                                    if (!l.startsWith("3g2")) {
                                        t.next = 277;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "3g2",
                                        mime: "video/3gpp2"
                                    });
                                case 277:
                                    return t.abrupt("return", {
                                        ext: "3gp",
                                        mime: "video/3gpp"
                                    });
                                case 278:
                                    return t.abrupt("return", {
                                        ext: "mp4",
                                        mime: "video/mp4"
                                    });
                                case 279:
                                    if (!n.checkString("REGEDIT4\r\n")) {
                                        t.next = 281;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "reg",
                                        mime: "application/x-ms-regedit"
                                    });
                                case 281:
                                    if (!n.check([
                                        82,
                                        73,
                                        70,
                                        70
                                    ])) {
                                        t.next = 290;
                                        break;
                                    }
                                    if (!n.checkString("WEBP", {
                                        offset: 8
                                    })) {
                                        t.next = 284;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "webp",
                                        mime: "image/webp"
                                    });
                                case 284:
                                    if (!n.check([
                                        65,
                                        86,
                                        73
                                    ], {
                                        offset: 8
                                    })) {
                                        t.next = 286;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "avi",
                                        mime: "video/vnd.avi"
                                    });
                                case 286:
                                    if (!n.check([
                                        87,
                                        65,
                                        86,
                                        69
                                    ], {
                                        offset: 8
                                    })) {
                                        t.next = 288;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "wav",
                                        mime: "audio/wav"
                                    });
                                case 288:
                                    if (!n.check([
                                        81,
                                        76,
                                        67,
                                        77
                                    ], {
                                        offset: 8
                                    })) {
                                        t.next = 290;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "qcp",
                                        mime: "audio/qcelp"
                                    });
                                case 290:
                                    if (!n.check([
                                        73,
                                        73,
                                        85,
                                        0,
                                        24,
                                        0,
                                        0,
                                        0,
                                        136,
                                        231,
                                        116,
                                        216
                                    ])) {
                                        t.next = 292;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "rw2",
                                        mime: "image/x-panasonic-rw2"
                                    });
                                case 292:
                                    if (!n.check([
                                        48,
                                        38,
                                        178,
                                        117,
                                        142,
                                        102,
                                        207,
                                        17,
                                        166,
                                        217
                                    ])) {
                                        t.next = 294;
                                        break;
                                    }
                                    return t.abrupt("return", Ue(e));
                                case 294:
                                    if (!n.check([
                                        171,
                                        75,
                                        84,
                                        88,
                                        32,
                                        49,
                                        49,
                                        187,
                                        13,
                                        10,
                                        26,
                                        10
                                    ])) {
                                        t.next = 296;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ktx",
                                        mime: "image/ktx"
                                    });
                                case 296:
                                    if (!n.check([
                                        126,
                                        16,
                                        4
                                    ]) && !n.check([
                                        126,
                                        24,
                                        4
                                    ]) || !n.check([
                                        48,
                                        77,
                                        73,
                                        69
                                    ], {
                                        offset: 4
                                    })) {
                                        t.next = 298;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mie",
                                        mime: "application/x-mie"
                                    });
                                case 298:
                                    if (!n.check([
                                        39,
                                        10,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ], {
                                        offset: 2
                                    })) {
                                        t.next = 300;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "shp",
                                        mime: "application/x-esri-shape"
                                    });
                                case 300:
                                    if (!n.check([
                                        255,
                                        79,
                                        255,
                                        81
                                    ])) {
                                        t.next = 302;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "j2c",
                                        mime: "image/j2c"
                                    });
                                case 302:
                                    if (!n.check([
                                        0,
                                        0,
                                        0,
                                        12,
                                        106,
                                        80,
                                        32,
                                        32,
                                        13,
                                        10,
                                        135,
                                        10
                                    ])) {
                                        t.next = 316;
                                        break;
                                    }
                                    return t.next = 305, e.ignore(20);
                                case 305:
                                    return t.next = 307, e.readToken(new T(4, "ascii"));
                                case 307:
                                    f = t.sent, t.t2 = f, t.next = "jp2 " === t.t2 ? 311 : "jpx " === t.t2 ? 312 : "jpm " === t.t2 ? 313 : "mjp2" === t.t2 ? 314 : 315;
                                    break;
                                case 311:
                                    return t.abrupt("return", {
                                        ext: "jp2",
                                        mime: "image/jp2"
                                    });
                                case 312:
                                    return t.abrupt("return", {
                                        ext: "jpx",
                                        mime: "image/jpx"
                                    });
                                case 313:
                                    return t.abrupt("return", {
                                        ext: "jpm",
                                        mime: "image/jpm"
                                    });
                                case 314:
                                    return t.abrupt("return", {
                                        ext: "mj2",
                                        mime: "image/mj2"
                                    });
                                case 315:
                                    return t.abrupt("return");
                                case 316:
                                    if (!n.check([
                                        255,
                                        10
                                    ]) && !n.check([
                                        0,
                                        0,
                                        0,
                                        12,
                                        74,
                                        88,
                                        76,
                                        32,
                                        13,
                                        10,
                                        135,
                                        10
                                    ])) {
                                        t.next = 318;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "jxl",
                                        mime: "image/jxl"
                                    });
                                case 318:
                                    if (!n.check([
                                        254,
                                        255
                                    ])) {
                                        t.next = 322;
                                        break;
                                    }
                                    if (!n.checkString("<?xml ", {
                                        offset: 2,
                                        encoding: "utf-16be"
                                    })) {
                                        t.next = 321;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "xml",
                                        mime: "application/xml"
                                    });
                                case 321:
                                    return t.abrupt("return", void 0);
                                case 322:
                                    if (!n.check([
                                        208,
                                        207,
                                        17,
                                        224,
                                        161,
                                        177,
                                        26,
                                        225
                                    ])) {
                                        t.next = 324;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "cfb",
                                        mime: "application/x-cfb"
                                    });
                                case 324:
                                    return t.next = 326, e.peekBuffer(n.buffer, {
                                        length: Math.min(256, e.fileInfo.size),
                                        mayBeLess: !0
                                    });
                                case 326:
                                    if (!n.check([
                                        97,
                                        99,
                                        115,
                                        112
                                    ], {
                                        offset: 36
                                    })) {
                                        t.next = 328;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "icc",
                                        mime: "application/vnd.iccprofile"
                                    });
                                case 328:
                                    if (!n.checkString("**ACE", {
                                        offset: 7
                                    }) || !n.checkString("**", {
                                        offset: 12
                                    })) {
                                        t.next = 330;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ace",
                                        mime: "application/x-ace-compressed"
                                    });
                                case 330:
                                    if (!n.checkString("BEGIN:")) {
                                        t.next = 335;
                                        break;
                                    }
                                    if (!n.checkString("VCARD", {
                                        offset: 6
                                    })) {
                                        t.next = 333;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "vcf",
                                        mime: "text/vcard"
                                    });
                                case 333:
                                    if (!n.checkString("VCALENDAR", {
                                        offset: 6
                                    })) {
                                        t.next = 335;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ics",
                                        mime: "text/calendar"
                                    });
                                case 335:
                                    if (!n.checkString("FUJIFILMCCD-RAW")) {
                                        t.next = 337;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "raf",
                                        mime: "image/x-fujifilm-raf"
                                    });
                                case 337:
                                    if (!n.checkString("Extended Module:")) {
                                        t.next = 339;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "xm",
                                        mime: "audio/x-xm"
                                    });
                                case 339:
                                    if (!n.checkString("Creative Voice File")) {
                                        t.next = 341;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "voc",
                                        mime: "audio/x-voc"
                                    });
                                case 341:
                                    if (!(n.check([
                                        4,
                                        0,
                                        0,
                                        0
                                    ]) && n.buffer.length >= 16)) {
                                        t.next = 353;
                                        break;
                                    }
                                    if (!((h = new DataView(n.buffer.buffer).getUint32(12, !0)) > 12 && n.buffer.length >= h + 16)) {
                                        t.next = 353;
                                        break;
                                    }
                                    if (t.prev = 344, d = (new TextDecoder).decode(n.buffer.subarray(16, h + 16)), !JSON.parse(d).files) {
                                        t.next = 349;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "asar",
                                        mime: "application/x-asar"
                                    });
                                case 349:
                                    t.next = 353;
                                    break;
                                case 351:
                                    t.prev = 351, t.t3 = t["catch"](344);
                                case 353:
                                    if (!n.check([
                                        6,
                                        14,
                                        43,
                                        52,
                                        2,
                                        5,
                                        1,
                                        1,
                                        13,
                                        1,
                                        2,
                                        1,
                                        1,
                                        2
                                    ])) {
                                        t.next = 355;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mxf",
                                        mime: "application/mxf"
                                    });
                                case 355:
                                    if (!n.checkString("SCRM", {
                                        offset: 44
                                    })) {
                                        t.next = 357;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "s3m",
                                        mime: "audio/x-s3m"
                                    });
                                case 357:
                                    if (!n.check([
                                        71
                                    ]) || !n.check([
                                        71
                                    ], {
                                        offset: 188
                                    })) {
                                        t.next = 359;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mts",
                                        mime: "video/mp2t"
                                    });
                                case 359:
                                    if (!n.check([
                                        71
                                    ], {
                                        offset: 4
                                    }) || !n.check([
                                        71
                                    ], {
                                        offset: 196
                                    })) {
                                        t.next = 361;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mts",
                                        mime: "video/mp2t"
                                    });
                                case 361:
                                    if (!n.check([
                                        66,
                                        79,
                                        79,
                                        75,
                                        77,
                                        79,
                                        66,
                                        73
                                    ], {
                                        offset: 60
                                    })) {
                                        t.next = 363;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mobi",
                                        mime: "application/x-mobipocket-ebook"
                                    });
                                case 363:
                                    if (!n.check([
                                        68,
                                        73,
                                        67,
                                        77
                                    ], {
                                        offset: 128
                                    })) {
                                        t.next = 365;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "dcm",
                                        mime: "application/dicom"
                                    });
                                case 365:
                                    if (!n.check([
                                        76,
                                        0,
                                        0,
                                        0,
                                        1,
                                        20,
                                        2,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        192,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        70
                                    ])) {
                                        t.next = 367;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "lnk",
                                        mime: "application/x-ms-shortcut"
                                    });
                                case 367:
                                    if (!n.check([
                                        98,
                                        111,
                                        111,
                                        107,
                                        0,
                                        0,
                                        0,
                                        0,
                                        109,
                                        97,
                                        114,
                                        107,
                                        0,
                                        0,
                                        0,
                                        0
                                    ])) {
                                        t.next = 369;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "alias",
                                        mime: "application/x-ft-apple.alias"
                                    });
                                case 369:
                                    if (!n.checkString("Kaydara FBX Binary  \0")) {
                                        t.next = 371;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "fbx",
                                        mime: "application/x-ft-fbx"
                                    });
                                case 371:
                                    if (!n.check([
                                        76,
                                        80
                                    ], {
                                        offset: 34
                                    }) || !(n.check([
                                        0,
                                        0,
                                        1
                                    ], {
                                        offset: 8
                                    }) || n.check([
                                        1,
                                        0,
                                        2
                                    ], {
                                        offset: 8
                                    }) || n.check([
                                        2,
                                        0,
                                        2
                                    ], {
                                        offset: 8
                                    }))) {
                                        t.next = 373;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "eot",
                                        mime: "application/vnd.ms-fontobject"
                                    });
                                case 373:
                                    if (!n.check([
                                        6,
                                        6,
                                        237,
                                        245,
                                        216,
                                        29,
                                        70,
                                        229,
                                        189,
                                        49,
                                        239,
                                        231,
                                        254,
                                        116,
                                        183,
                                        29
                                    ])) {
                                        t.next = 375;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "indd",
                                        mime: "application/x-indesign"
                                    });
                                case 375:
                                    if (!n.check([
                                        255,
                                        255,
                                        0,
                                        0,
                                        7,
                                        0,
                                        0,
                                        0,
                                        4,
                                        0,
                                        0,
                                        0,
                                        1,
                                        0,
                                        1,
                                        0
                                    ]) && !n.check([
                                        0,
                                        0,
                                        255,
                                        255,
                                        0,
                                        0,
                                        0,
                                        7,
                                        0,
                                        0,
                                        0,
                                        4,
                                        0,
                                        1,
                                        0,
                                        1
                                    ])) {
                                        t.next = 377;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "jmp",
                                        mime: "application/x-jmp-data"
                                    });
                                case 377:
                                    return t.next = 379, e.peekBuffer(n.buffer, {
                                        length: Math.min(512, e.fileInfo.size),
                                        mayBeLess: !0
                                    });
                                case 379:
                                    if (!(n.checkString("ustar", {
                                        offset: 257
                                    }) && (n.checkString("\0", {
                                        offset: 262
                                    }) || n.checkString(" ", {
                                        offset: 262
                                    })) || n.check([
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ], {
                                        offset: 257
                                    }) && vt(n.buffer))) {
                                        t.next = 381;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "tar",
                                        mime: "application/x-tar"
                                    });
                                case 381:
                                    if (!n.check([
                                        255,
                                        254
                                    ])) {
                                        t.next = 390;
                                        break;
                                    }
                                    if (m = "utf-16le", !n.checkString("<?xml ", {
                                        offset: 2,
                                        encoding: m
                                    })) {
                                        t.next = 385;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "xml",
                                        mime: "application/xml"
                                    });
                                case 385:
                                    if (!n.check([
                                        255,
                                        14
                                    ], {
                                        offset: 2
                                    }) || !n.checkString("SketchUp Model", {
                                        offset: 4,
                                        encoding: m
                                    })) {
                                        t.next = 387;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "skp",
                                        mime: "application/vnd.sketchup.skp"
                                    });
                                case 387:
                                    if (!n.checkString("Windows Registry Editor Version 5.00\r\n", {
                                        offset: 2,
                                        encoding: m
                                    })) {
                                        t.next = 389;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "reg",
                                        mime: "application/x-ms-regedit"
                                    });
                                case 389:
                                    return t.abrupt("return", void 0);
                                case 390:
                                    if (!n.checkString("-----BEGIN PGP MESSAGE-----")) {
                                        t.next = 392;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "pgp",
                                        mime: "application/pgp-encrypted"
                                    });
                                case 392:
                                case "end":
                                    return t.stop();
                            }
                            var y, v;
                        }, t, null, [
                            [
                                58,
                                63
                            ],
                            [
                                344,
                                351
                            ]
                        ]);
                    }));
                    return function(e) {
                        return _$t.apply(this, arguments);
                    };
                }()), Qe(this, "detectImprecise", function() {
                    var _$t = er(Xe().mark(function t(e) {
                        var _$r, _$o, i;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return n.buffer = new Uint8Array(rr), _$r = cr(e.fileInfo.size), t.next = 4, e.peekBuffer(n.buffer, {
                                        length: Math.min(8, _$r),
                                        mayBeLess: !0
                                    });
                                case 4:
                                    if (!n.check([
                                        0,
                                        0,
                                        1,
                                        186
                                    ]) && !n.check([
                                        0,
                                        0,
                                        1,
                                        179
                                    ])) {
                                        t.next = 6;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "mpg",
                                        mime: "video/mpeg"
                                    });
                                case 6:
                                    if (!n.check([
                                        0,
                                        1,
                                        0,
                                        0,
                                        0
                                    ])) {
                                        t.next = 8;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ttf",
                                        mime: "font/ttf"
                                    });
                                case 8:
                                    if (!n.check([
                                        0,
                                        0,
                                        1,
                                        0
                                    ])) {
                                        t.next = 10;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "ico",
                                        mime: "image/x-icon"
                                    });
                                case 10:
                                    if (!n.check([
                                        0,
                                        0,
                                        2,
                                        0
                                    ])) {
                                        t.next = 12;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "cur",
                                        mime: "image/x-icon"
                                    });
                                case 12:
                                    return t.next = 14, e.peekBuffer(n.buffer, {
                                        length: Math.min(2 + n.options.mpegOffsetTolerance, _$r),
                                        mayBeLess: !0
                                    });
                                case 14:
                                    if (!(n.buffer.length >= 2 + n.options.mpegOffsetTolerance)) {
                                        t.next = 23;
                                        break;
                                    }
                                    _$o = 0;
                                case 16:
                                    if (!(_$o <= n.options.mpegOffsetTolerance)) {
                                        t.next = 23;
                                        break;
                                    }
                                    if (!(i = n.scanMpeg(_$o))) {
                                        t.next = 20;
                                        break;
                                    }
                                    return t.abrupt("return", i);
                                case 20:
                                    ++_$o, t.next = 16;
                                    break;
                                case 23:
                                case "end":
                                    return t.stop();
                            }
                        }, t);
                    }));
                    return function(e) {
                        return _$t.apply(this, arguments);
                    };
                }());
                var _$o, i = (_$o = null == e ? void 0 : e.mpegOffsetTolerance, Number.isFinite(_$o) ? Math.max(0, Math.min(4098, Math.trunc(_$o))) : 0);
                this.options = We(We({}, e), {}, {
                    mpegOffsetTolerance: i
                }), this.detectors = [].concat(function(t) {
                    return function(t) {
                        if (Array.isArray(t)) return He(t);
                    }(t) || function(t) {
                        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                    }(t) || Ve(t) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(null !== (_$r = this.options.customDetectors) && void 0 !== _$r ? _$r : []), [
                    {
                        id: "core",
                        detect: this.detectConfident
                    },
                    {
                        id: "core.imprecise",
                        detect: this.detectImprecise
                    }
                ]), this.tokenizerOptions = {
                    abortSignal: this.options.signal
                }, this.gzipProbeDepth = 0;
            }
            var _$e, n, _$o, i, a, c, s, u, p, l, f, h, d;
            return _$e = t, n = [
                {
                    key: "getTokenizerOptions",
                    value: function value() {
                        return We({}, this.tokenizerOptions);
                    }
                },
                {
                    key: "createTokenizerFromWebStream",
                    value: function value(t) {
                        return L.fromWebStream(function(t) {
                            return t.pipeThrough(new TransformStream);
                        }(t), this.getTokenizerOptions());
                    }
                },
                {
                    key: "parseTokenizer",
                    value: (d = er(Xe().mark(function t(e) {
                        var _$r, n, _$o, i, a, c, s = arguments;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    _$r = s.length > 1 && void 0 !== s[1] ? s[1] : 0, this.detectionReentryCount = _$r, n = e.position, _$o = Ze(this.detectors), t.prev = 4, _$o.s();
                                case 6:
                                    if ((i = _$o.n()).done) {
                                        t.next = 28;
                                        break;
                                    }
                                    return a = i.value, c = void 0, t.prev = 9, t.next = 12, a.detect(e);
                                case 12:
                                    c = t.sent, t.next = 22;
                                    break;
                                case 15:
                                    if (t.prev = 15, t.t0 = t["catch"](9), !(t.t0 instanceof D.d1)) {
                                        t.next = 19;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 19:
                                    if (!(t.t0 instanceof It)) {
                                        t.next = 21;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 21:
                                    throw t.t0;
                                case 22:
                                    if (!c) {
                                        t.next = 24;
                                        break;
                                    }
                                    return t.abrupt("return", c);
                                case 24:
                                    if (n === e.position) {
                                        t.next = 26;
                                        break;
                                    }
                                    return t.abrupt("return", void 0);
                                case 26:
                                    t.next = 6;
                                    break;
                                case 28:
                                    t.next = 33;
                                    break;
                                case 30:
                                    t.prev = 30, t.t1 = t["catch"](4), _$o.e(t.t1);
                                case 33:
                                    return t.prev = 33, _$o.f(), t.finish(33);
                                case 36:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this, [
                            [
                                4,
                                30,
                                33,
                                36
                            ],
                            [
                                9,
                                15
                            ]
                        ]);
                    })), function(t) {
                        return d.apply(this, arguments);
                    })
                },
                {
                    key: "fromTokenizer",
                    value: (h = er(Xe().mark(function t(e) {
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.prev = 0, t.next = 3, this.parseTokenizer(e);
                                case 3:
                                    return t.abrupt("return", t.sent);
                                case 4:
                                    return t.prev = 4, t.next = 7, e.close();
                                case 7:
                                    return t.finish(4);
                                case 8:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this, [
                            [
                                0,
                                ,
                                4,
                                8
                            ]
                        ]);
                    })), function(t) {
                        return h.apply(this, arguments);
                    })
                },
                {
                    key: "fromBuffer",
                    value: (f = er(Xe().mark(function t(e) {
                        var _$r;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (e instanceof Uint8Array || e instanceof ArrayBuffer) {
                                        t.next = 2;
                                        break;
                                    }
                                    throw new TypeError("Expected the `input` argument to be of type `Uint8Array` or `ArrayBuffer`, got `".concat($e(e), "`"));
                                case 2:
                                    if ((null == (_$r = e instanceof Uint8Array ? e : new Uint8Array(e)) ? void 0 : _$r.length) > 1) {
                                        t.next = 5;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 5:
                                    return t.abrupt("return", this.fromTokenizer(L.fromBuffer(_$r, this.getTokenizerOptions())));
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return f.apply(this, arguments);
                    })
                },
                {
                    key: "fromBlob",
                    value: (l = er(Xe().mark(function t(e) {
                        var _$r, n;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return null === (_$r = this.options.signal) || void 0 === _$r || _$r.throwIfAborted(), n = L.fromBlob(e, this.getTokenizerOptions()), t.abrupt("return", this.fromTokenizer(n));
                                case 3:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return l.apply(this, arguments);
                    })
                },
                {
                    key: "fromStream",
                    value: (p = er(Xe().mark(function t(e) {
                        var _$r, n;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return null === (_$r = this.options.signal) || void 0 === _$r || _$r.throwIfAborted(), n = this.createTokenizerFromWebStream(e), t.abrupt("return", this.fromTokenizer(n));
                                case 3:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return p.apply(this, arguments);
                    })
                },
                {
                    key: "fromFile",
                    value: (u = er(Xe().mark(function t(e) {
                        var n, _$o, i, a, c, s, u, p;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return null === (n = this.options.signal) || void 0 === n || n.throwIfAborted(), t.next = 3, Promise.all([
                                        Promise.resolve().then(r.t.bind(r, 1304, 19)),
                                        Promise.resolve().then(r.bind(r, 9971))
                                    ]);
                                case 3:
                                    return _$o = t.sent, i = Ge(_$o, 2), a = i[0]["default"], c = i[1].FileTokenizer, t.next = 9, a.open(e, a.constants.O_RDONLY | a.constants.O_NONBLOCK);
                                case 9:
                                    return s = t.sent, t.next = 12, s.stat();
                                case 12:
                                    if ((u = t.sent).isFile()) {
                                        t.next = 17;
                                        break;
                                    }
                                    return t.next = 16, s.close();
                                case 16:
                                    return t.abrupt("return");
                                case 17:
                                    return p = new c(s, We(We({}, this.getTokenizerOptions()), {}, {
                                        fileInfo: {
                                            path: e,
                                            size: u.size
                                        }
                                    })), t.abrupt("return", this.fromTokenizer(p));
                                case 19:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return u.apply(this, arguments);
                    })
                },
                {
                    key: "toDetectionStream",
                    value: (s = er(Xe().mark(function t(e, r) {
                        var n, _$o, i, a, c, s, u, p, l, f, h, d, m, y, v, _$g;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    null === (n = this.options.signal) || void 0 === n || n.throwIfAborted(), i = ar(null !== (_$o = null == r ? void 0 : r.sampleSize) && void 0 !== _$o ? _$o : rr), c = !1, s = e.getReader(), u = [], p = 0, t.prev = 6;
                                case 7:
                                    if (!(p < i)) {
                                        t.next = 20;
                                        break;
                                    }
                                    return t.next = 10, sr(s, this.options.signal);
                                case 10:
                                    if (l = t.sent, f = l.value, !l.done && f) {
                                        t.next = 16;
                                        break;
                                    }
                                    return c = !0, t.abrupt("break", 20);
                                case 16:
                                    u.push(f), p += f.length, t.next = 7;
                                    break;
                                case 20:
                                    if (c || p !== i) {
                                        t.next = 27;
                                        break;
                                    }
                                    return t.next = 23, sr(s, this.options.signal);
                                case 23:
                                    h = t.sent, d = h.value, h.done || !d ? c = !0 : (u.push(d), p += d.length);
                                case 27:
                                    return t.prev = 27, s.releaseLock(), t.finish(27);
                                case 30:
                                    if (!(p > 0)) {
                                        t.next = 44;
                                        break;
                                    }
                                    return y = 1 === u.length ? u[0] : dt(u), t.prev = 32, t.next = 35, this.fromBuffer(y.subarray(0, i));
                                case 35:
                                    a = t.sent, t.next = 43;
                                    break;
                                case 38:
                                    if (t.prev = 38, t.t0 = t["catch"](32), t.t0 instanceof D.d1) {
                                        t.next = 42;
                                        break;
                                    }
                                    throw t.t0;
                                case 42:
                                    a = void 0;
                                case 43:
                                    c || "pages" !== (null === (m = a) || void 0 === m ? void 0 : m.ext) || (a = {
                                        ext: "zip",
                                        mime: "application/zip"
                                    });
                                case 44:
                                    return v = new TransformStream({
                                        start: function start(t) {
                                            for(var _$e = 0, _$r = u; _$e < _$r.length; _$e++){
                                                var n = _$r[_$e];
                                                t.enqueue(n);
                                            }
                                        },
                                        transform: function transform(t, e) {
                                            e.enqueue(t);
                                        }
                                    }), (_$g = e.pipeThrough(v)).fileType = a, t.abrupt("return", _$g);
                                case 48:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this, [
                            [
                                6,
                                ,
                                27,
                                30
                            ],
                            [
                                32,
                                38
                            ]
                        ]);
                    })), function(t, e) {
                        return s.apply(this, arguments);
                    })
                },
                {
                    key: "detectGzip",
                    value: (c = er(Xe().mark(function e(r) {
                        var n, _$o, i, a, c, s, u, p, l, f, h;
                        return Xe().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    if (!(this.gzipProbeDepth >= 1)) {
                                        e.next = 2;
                                        break;
                                    }
                                    return e.abrupt("return", {
                                        ext: "gz",
                                        mime: "application/gzip"
                                    });
                                case 2:
                                    return _$o = new st(r), i = ur(_$o.inflate(), nr), (a = qt(r)) ? (l = new AbortController, c = setTimeout(function() {
                                        l.abort(new DOMException("Operation timed out after ".concat(100, " ms"), "TimeoutError"));
                                    }, 100), s = void 0 === this.options.signal ? l.signal : AbortSignal.any([
                                        this.options.signal,
                                        l.signal
                                    ]), (u = new t(We(We({}, this.options), {}, {
                                        signal: s
                                    }))).gzipProbeDepth = this.gzipProbeDepth + 1) : this.gzipProbeDepth++, e.prev = 6, e.next = 9, (null !== (f = u) && void 0 !== f ? f : this).fromStream(i);
                                case 9:
                                    p = e.sent, e.next = 16;
                                    break;
                                case 12:
                                    if (e.prev = 12, e.t0 = e["catch"](6), "AbortError" !== (null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.name) || "TimeoutError" === (null === (h = s) || void 0 === h || null === (h = h.reason) || void 0 === h ? void 0 : h.name)) {
                                        e.next = 16;
                                        break;
                                    }
                                    throw e.t0;
                                case 16:
                                    return e.prev = 16, clearTimeout(c), a || this.gzipProbeDepth--, e.finish(16);
                                case 20:
                                    if ("tar" !== (null === (n = p) || void 0 === n ? void 0 : n.ext)) {
                                        e.next = 22;
                                        break;
                                    }
                                    return e.abrupt("return", {
                                        ext: "tar.gz",
                                        mime: "application/gzip"
                                    });
                                case 22:
                                    return e.abrupt("return", {
                                        ext: "gz",
                                        mime: "application/gzip"
                                    });
                                case 23:
                                case "end":
                                    return e.stop();
                            }
                        }, e, this, [
                            [
                                6,
                                12,
                                16,
                                20
                            ]
                        ]);
                    })), function(t) {
                        return c.apply(this, arguments);
                    })
                },
                {
                    key: "check",
                    value: function value(t, e) {
                        return Ut(this.buffer, t, e);
                    }
                },
                {
                    key: "checkString",
                    value: function value(t, e) {
                        return this.check(function(t, e) {
                            if ("utf-16le" === e) {
                                for(var _$r = [], n = 0; n < t.length; n++){
                                    var _$o = t.charCodeAt(n);
                                    _$r.push(255 & _$o, _$o >> 8 & 255);
                                }
                                return _$r;
                            }
                            if ("utf-16be" === e) {
                                for(var i = [], a = 0; a < t.length; a++){
                                    var c = t.charCodeAt(a);
                                    i.push(c >> 8 & 255, 255 & c);
                                }
                                return i;
                            }
                            return (function(t) {
                                return function(t) {
                                    if (Array.isArray(t)) return yt(t);
                                }(t) || function(t) {
                                    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                                }(t) || function(t, e) {
                                    if (t) {
                                        if ("string" == typeof t) return yt(t, e);
                                        var _$r = Object.prototype.toString.call(t).slice(8, -1);
                                        return "Object" === _$r && t.constructor && (_$r = t.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(t) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? yt(t, e) : void 0;
                                    }
                                }(t) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            })(t).map(function(t) {
                                return t.charCodeAt(0);
                            });
                        }(t, null == e ? void 0 : e.encoding), e);
                    }
                },
                {
                    key: "readTiffTag",
                    value: (a = er(Xe().mark(function t(e) {
                        var _$r;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.tokenizer.readToken(e ? j : O);
                                case 2:
                                    return _$r = t.sent, t.next = 5, this.tokenizer.ignore(10);
                                case 5:
                                    t.t0 = _$r, t.next = 50341 === t.t0 ? 8 : 50706 === t.t0 ? 9 : 10;
                                    break;
                                case 8:
                                    return t.abrupt("return", {
                                        ext: "arw",
                                        mime: "image/x-sony-arw"
                                    });
                                case 9:
                                    return t.abrupt("return", {
                                        ext: "dng",
                                        mime: "image/x-adobe-dng"
                                    });
                                case 10:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return a.apply(this, arguments);
                    })
                },
                {
                    key: "readTiffIFD",
                    value: (i = er(Xe().mark(function t(e) {
                        var _$r, n, _$o;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.tokenizer.readToken(e ? j : O);
                                case 2:
                                    if (!((_$r = t.sent) > 512)) {
                                        t.next = 5;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 5:
                                    if (!(qt(this.tokenizer) && 2 + 12 * _$r > ir)) {
                                        t.next = 7;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 7:
                                    n = 0;
                                case 8:
                                    if (!(n < _$r)) {
                                        t.next = 17;
                                        break;
                                    }
                                    return t.next = 11, this.readTiffTag(e);
                                case 11:
                                    if (!(_$o = t.sent)) {
                                        t.next = 14;
                                        break;
                                    }
                                    return t.abrupt("return", _$o);
                                case 14:
                                    ++n, t.next = 8;
                                    break;
                                case 17:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "readTiffHeader",
                    value: (_$o = er(Xe().mark(function t(e) {
                        var _$r, n, _$o, i, a, c, s, u;
                        return Xe().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (_$r = {
                                        ext: "tif",
                                        mime: "image/tiff"
                                    }, n = (e ? j : O).get(this.buffer, 2), _$o = (e ? _ : F).get(this.buffer, 4), 42 !== n) {
                                        t.next = 37;
                                        break;
                                    }
                                    if (!(_$o >= 6)) {
                                        t.next = 12;
                                        break;
                                    }
                                    if (!this.checkString("CR", {
                                        offset: 8
                                    })) {
                                        t.next = 7;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "cr2",
                                        mime: "image/x-canon-cr2"
                                    });
                                case 7:
                                    if (!(_$o >= 8)) {
                                        t.next = 12;
                                        break;
                                    }
                                    if (a = (e ? j : O).get(this.buffer, 8), c = (e ? j : O).get(this.buffer, 10), !(28 === a && 254 === c || 31 === a && 11 === c)) {
                                        t.next = 12;
                                        break;
                                    }
                                    return t.abrupt("return", {
                                        ext: "nef",
                                        mime: "image/x-nikon-nef"
                                    });
                                case 12:
                                    if (!(qt(this.tokenizer) && _$o > 1048576)) {
                                        t.next = 14;
                                        break;
                                    }
                                    return t.abrupt("return", _$r);
                                case 14:
                                    return s = qt(this.tokenizer) ? ir : this.tokenizer.fileInfo.size, t.prev = 15, t.next = 18, Nt(this.tokenizer, _$o, {
                                        maximumLength: s,
                                        reason: "TIFF IFD offset"
                                    });
                                case 18:
                                    t.next = 25;
                                    break;
                                case 20:
                                    if (t.prev = 20, t.t0 = t["catch"](15), !(t.t0 instanceof D.d1)) {
                                        t.next = 24;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 24:
                                    throw t.t0;
                                case 25:
                                    return t.prev = 25, t.next = 28, this.readTiffIFD(e);
                                case 28:
                                    u = t.sent, t.next = 36;
                                    break;
                                case 31:
                                    if (t.prev = 31, t.t1 = t["catch"](25), !(t.t1 instanceof D.d1)) {
                                        t.next = 35;
                                        break;
                                    }
                                    return t.abrupt("return");
                                case 35:
                                    throw t.t1;
                                case 36:
                                    return t.abrupt("return", null !== (i = u) && void 0 !== i ? i : _$r);
                                case 37:
                                    if (43 !== n) {
                                        t.next = 39;
                                        break;
                                    }
                                    return t.abrupt("return", _$r);
                                case 39:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this, [
                            [
                                15,
                                20
                            ],
                            [
                                25,
                                31
                            ]
                        ]);
                    })), function(t) {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "scanMpeg",
                    value: function value(t) {
                        if (this.check([
                            255,
                            224
                        ], {
                            offset: t,
                            mask: [
                                255,
                                224
                            ]
                        })) {
                            if (this.check([
                                16
                            ], {
                                offset: t + 1,
                                mask: [
                                    22
                                ]
                            })) return this.check([
                                8
                            ], {
                                offset: t + 1,
                                mask: [
                                    8
                                ]
                            }), {
                                ext: "aac",
                                mime: "audio/aac"
                            };
                            if (this.check([
                                2
                            ], {
                                offset: t + 1,
                                mask: [
                                    6
                                ]
                            })) return {
                                ext: "mp3",
                                mime: "audio/mpeg"
                            };
                            if (this.check([
                                4
                            ], {
                                offset: t + 1,
                                mask: [
                                    6
                                ]
                            })) return {
                                ext: "mp2",
                                mime: "audio/mpeg"
                            };
                            if (this.check([
                                6
                            ], {
                                offset: t + 1,
                                mask: [
                                    6
                                ]
                            })) return {
                                ext: "mp1",
                                mime: "audio/mpeg"
                            };
                        }
                    }
                }
            ], n && Ke(_$e.prototype, n), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        new Set([
            "jpg",
            "png",
            "apng",
            "gif",
            "webp",
            "flif",
            "xcf",
            "cr2",
            "cr3",
            "orf",
            "arw",
            "dng",
            "nef",
            "rw2",
            "raf",
            "tif",
            "bmp",
            "icns",
            "jxr",
            "psd",
            "indd",
            "zip",
            "tar",
            "rar",
            "gz",
            "bz2",
            "7z",
            "dmg",
            "mp4",
            "mid",
            "mkv",
            "webm",
            "mov",
            "avi",
            "mpg",
            "mp2",
            "mp3",
            "m4a",
            "oga",
            "ogg",
            "ogv",
            "opus",
            "flac",
            "wav",
            "spx",
            "amr",
            "pdf",
            "epub",
            "elf",
            "macho",
            "exe",
            "swf",
            "rtf",
            "wasm",
            "woff",
            "woff2",
            "eot",
            "ttf",
            "otf",
            "ttc",
            "ico",
            "flv",
            "ps",
            "xz",
            "sqlite",
            "nes",
            "crx",
            "xpi",
            "cab",
            "deb",
            "ar",
            "rpm",
            "Z",
            "lz",
            "cfb",
            "mxf",
            "mts",
            "blend",
            "bpg",
            "docx",
            "pptx",
            "xlsx",
            "3gp",
            "3g2",
            "j2c",
            "jp2",
            "jpm",
            "jpx",
            "mj2",
            "aif",
            "qcp",
            "odt",
            "ods",
            "odp",
            "xml",
            "mobi",
            "heic",
            "cur",
            "ktx",
            "ape",
            "wv",
            "dcm",
            "ics",
            "glb",
            "pcap",
            "dsf",
            "lnk",
            "alias",
            "voc",
            "ac3",
            "m4v",
            "m4p",
            "m4b",
            "f4v",
            "f4p",
            "f4b",
            "f4a",
            "mie",
            "asf",
            "ogm",
            "ogx",
            "mpc",
            "arrow",
            "shp",
            "aac",
            "mp1",
            "it",
            "s3m",
            "xm",
            "skp",
            "avif",
            "eps",
            "lzh",
            "pgp",
            "asar",
            "stl",
            "chm",
            "3mf",
            "zst",
            "jxl",
            "vcf",
            "jls",
            "pst",
            "dwg",
            "parquet",
            "class",
            "arj",
            "cpio",
            "ace",
            "avro",
            "icc",
            "fbx",
            "vsdx",
            "vtt",
            "apk",
            "drc",
            "lz4",
            "potx",
            "xltx",
            "dotx",
            "xltm",
            "ott",
            "ots",
            "otp",
            "odg",
            "otg",
            "xlsm",
            "docm",
            "dotm",
            "potm",
            "pptm",
            "jar",
            "jmp",
            "rm",
            "sav",
            "ppsm",
            "ppsx",
            "tar.gz",
            "reg",
            "dat",
            "key",
            "numbers",
            "pages"
        ]), new Set([
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/flif",
            "image/x-xcf",
            "image/x-canon-cr2",
            "image/x-canon-cr3",
            "image/tiff",
            "image/bmp",
            "image/vnd.ms-photo",
            "image/vnd.adobe.photoshop",
            "application/x-indesign",
            "application/epub+zip",
            "application/x-xpinstall",
            "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
            "application/vnd.oasis.opendocument.text",
            "application/vnd.oasis.opendocument.spreadsheet",
            "application/vnd.oasis.opendocument.presentation",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
            "application/zip",
            "application/x-tar",
            "application/x-rar-compressed",
            "application/gzip",
            "application/x-bzip2",
            "application/x-7z-compressed",
            "application/x-apple-diskimage",
            "application/vnd.apache.arrow.file",
            "video/mp4",
            "audio/midi",
            "video/matroska",
            "video/webm",
            "video/quicktime",
            "video/vnd.avi",
            "audio/wav",
            "audio/qcelp",
            "audio/x-ms-asf",
            "video/x-ms-asf",
            "application/vnd.ms-asf",
            "video/mpeg",
            "video/3gpp",
            "audio/mpeg",
            "audio/mp4",
            "video/ogg",
            "audio/ogg",
            "audio/ogg; codecs=opus",
            "application/ogg",
            "audio/flac",
            "audio/ape",
            "audio/wavpack",
            "audio/amr",
            "application/pdf",
            "application/x-elf",
            "application/x-mach-binary",
            "application/x-msdownload",
            "application/x-shockwave-flash",
            "application/rtf",
            "application/wasm",
            "font/woff",
            "font/woff2",
            "application/vnd.ms-fontobject",
            "font/ttf",
            "font/otf",
            "font/collection",
            "image/x-icon",
            "video/x-flv",
            "application/postscript",
            "application/eps",
            "application/x-xz",
            "application/x-sqlite3",
            "application/x-nintendo-nes-rom",
            "application/x-google-chrome-extension",
            "application/vnd.ms-cab-compressed",
            "application/x-deb",
            "application/x-unix-archive",
            "application/x-rpm",
            "application/x-compress",
            "application/lzip",
            "application/x-cfb",
            "application/x-mie",
            "application/mxf",
            "video/mp2t",
            "application/x-blender",
            "image/bpg",
            "image/j2c",
            "image/jp2",
            "image/jpx",
            "image/jpm",
            "image/mj2",
            "audio/aiff",
            "application/xml",
            "application/x-mobipocket-ebook",
            "image/heif",
            "image/heif-sequence",
            "image/heic",
            "image/heic-sequence",
            "image/icns",
            "image/ktx",
            "application/dicom",
            "audio/x-musepack",
            "text/calendar",
            "text/vcard",
            "text/vtt",
            "model/gltf-binary",
            "application/vnd.tcpdump.pcap",
            "audio/x-dsf",
            "application/x-ms-shortcut",
            "application/x-ft-apple.alias",
            "audio/x-voc",
            "audio/vnd.dolby.dd-raw",
            "audio/x-m4a",
            "image/apng",
            "image/x-olympus-orf",
            "image/x-sony-arw",
            "image/x-adobe-dng",
            "image/x-nikon-nef",
            "image/x-panasonic-rw2",
            "image/x-fujifilm-raf",
            "video/x-m4v",
            "video/3gpp2",
            "application/x-esri-shape",
            "audio/aac",
            "audio/x-it",
            "audio/x-s3m",
            "audio/x-xm",
            "video/MP1S",
            "video/MP2P",
            "application/vnd.sketchup.skp",
            "image/avif",
            "application/x-lzh-compressed",
            "application/pgp-encrypted",
            "application/x-asar",
            "model/stl",
            "application/vnd.ms-htmlhelp",
            "model/3mf",
            "image/jxl",
            "application/zstd",
            "image/jls",
            "application/vnd.ms-outlook",
            "image/vnd.dwg",
            "application/vnd.apache.parquet",
            "application/java-vm",
            "application/x-arj",
            "application/x-cpio",
            "application/x-ace-compressed",
            "application/avro",
            "application/vnd.iccprofile",
            "application/x-ft-fbx",
            "application/vnd.visio",
            "application/vnd.android.package-archive",
            "application/x-ft-draco",
            "application/x-lz4",
            "application/vnd.openxmlformats-officedocument.presentationml.template",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
            "application/vnd.ms-excel.template.macroenabled.12",
            "application/vnd.oasis.opendocument.text-template",
            "application/vnd.oasis.opendocument.spreadsheet-template",
            "application/vnd.oasis.opendocument.presentation-template",
            "application/vnd.oasis.opendocument.graphics",
            "application/vnd.oasis.opendocument.graphics-template",
            "application/vnd.ms-excel.sheet.macroenabled.12",
            "application/vnd.ms-word.document.macroenabled.12",
            "application/vnd.ms-word.template.macroenabled.12",
            "application/vnd.ms-powerpoint.template.macroenabled.12",
            "application/vnd.ms-powerpoint.presentation.macroenabled.12",
            "application/java-archive",
            "application/vnd.rn-realmedia",
            "application/x-spss-sav",
            "application/x-ms-regedit",
            "application/x-ft-windows-registry-hive",
            "application/x-jmp-data",
            "application/vnd.apple.keynote",
            "application/vnd.apple.numbers",
            "application/vnd.apple.pages"
        ]);
        var hr, dr = r(2593), mr = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i, yr = function yr(t) {
            return btoa(dr.ArrayBuffer.hash(t, !0));
        }, vr = function vr(t, e) {
            void 0 === e && (e = !1);
            var _$r = btoa(t);
            return e ? _$r.replace(/\//g, "_").replace(/\+/g, "-") : _$r;
        }, gr = function gr() {
            return "JS-3.51.4";
        }, br = function br() {
            return navigator && navigator.userAgent && mr.test(navigator.userAgent);
        }, xr = function xr() {
            return navigator && navigator.userAgent && /\[FB.*;/i.test(navigator.userAgent);
        }, wr = function wr(t, e) {
            var _$r = t.urls.cdnUrl;
            if (e && (0 === e.indexOf("src:") || 0 === e.indexOf("http"))) {
                if (!t.apikey) throw new Error("Api key is required when storage alias is provided");
                return "".concat(_$r, "/").concat(t.apikey);
            }
            return _$r;
        }, kr = function kr(t, e) {
            if (!e) return t;
            var _$r = /filestackapi.com|filestackcontent.com/i;
            return Object.keys(t).forEach(function(n) {
                t[n] = t[n].replace(_$r, e);
            }), t;
        }, Sr = function Sr(t) {
            var _$e = (0, i.Cl)({}, t);
            return Object.keys(_$e).forEach(function(t) {
                return !_$e[t] && "boolean" != typeof _$e[t] && delete _$e[t];
            }), _$e;
        }, Er = function Er() {
            var t = Date.now();
            return hr = t === hr ? t + 1 : t;
        }, Or = function Or(t) {
            return void 0 === t && (t = 10), new Array(t).join().replace(/(.|$)/g, function() {
                return (36 * Math.random() | 0).toString(36)[Math.random() < .5 ? "toString" : "toUpperCase"]();
            });
        }, jr = function jr(t, e) {
            return (0, i.sH)(void 0, void 0, void 0, function() {
                var _$r, n, _$o, a;
                return (0, i.YH)(this, function(i) {
                    switch(i.label){
                        case 0:
                            return i.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]), [
                                4,
                                pr(t)
                            ];
                        case 1:
                            return _$r = i.sent(), [
                                3,
                                3
                            ];
                        case 2:
                            return n = i.sent(), console.warn("An exception occurred while processing the buffer:", n.message), [
                                3,
                                3
                            ];
                        case 3:
                            if (_$o = [
                                "text/plain",
                                "application/octet-stream",
                                "application/x-ms",
                                "application/x-msi",
                                "application/zip",
                                "audio/x-m4a"
                            ], _$r && -1 === _$o.indexOf(_$r.mime)) return [
                                2,
                                _$r.mime
                            ];
                            if (e && e.indexOf(".") > -1 && (a = Fr(e))) return [
                                2,
                                a
                            ];
                            try {
                                if (function(t) {
                                    if (!t) return !1;
                                    for(var _$e = 0, _$r = t.length; _$e < _$r;)if (t[_$e] <= 127) _$e++;
                                    else {
                                        if (t[_$e] >= 194 && t[_$e] <= 223) {
                                            if (t[_$e + 1] >> 6 == 2) {
                                                _$e += 2;
                                                continue;
                                            }
                                            return !1;
                                        }
                                        if ((224 === t[_$e] && t[_$e + 1] >= 160 && t[_$e + 1] <= 191 || 237 === t[_$e] && t[_$e + 1] >= 128 && t[_$e + 1] <= 159) && t[_$e + 2] >> 6 == 2) _$e += 3;
                                        else if ((t[_$e] >= 225 && t[_$e] <= 236 || t[_$e] >= 238 && t[_$e] <= 239) && t[_$e + 1] >> 6 == 2 && t[_$e + 2] >> 6 == 2) _$e += 3;
                                        else {
                                            if (!(240 === t[_$e] && t[_$e + 1] >= 144 && t[_$e + 1] <= 191 || t[_$e] >= 241 && t[_$e] <= 243 && t[_$e + 1] >> 6 == 2 || 244 === t[_$e] && t[_$e + 1] >= 128 && t[_$e + 1] <= 143) || t[_$e + 2] >> 6 != 2 || t[_$e + 3] >> 6 != 2) return !1;
                                            _$e += 4;
                                        }
                                    }
                                    return !0;
                                }(t)) return [
                                    2,
                                    "text/plain"
                                ];
                            } catch (t) {
                                console.warn("Additional mimetype checks (text/plain) are currently not supported for browsers");
                            }
                            return _$r ? [
                                2,
                                _$r.mime
                            ] : [
                                2,
                                "application/octet-stream"
                            ];
                    }
                });
            });
        }, Fr = function Fr(t) {
            if (t && 0 !== t.length) {
                if (2 === t.split("/").length) return t;
                t.indexOf(".") > -1 && (t = t.split(".").pop()), t = t.toLocaleLowerCase();
                for(var _$e = Object.keys(a), _$r = _$e.length, n = 0; n < _$r; n++)if (a[_$e[n]].indexOf(t) > -1) return _$e[n];
            }
        }, _r = function _r(t, e) {
            if (void 0 === e && (e = !0), "boolean" == typeof e && !e) return t;
            var _$r, n = "boolean" != typeof e && e.replacement ? e.replacement : "-", _$o = "boolean" != typeof e && e.exclude ? e.exclude : [
                "\\",
                "{",
                "}",
                "|",
                "%",
                "`",
                '"',
                "'",
                "~",
                "[",
                "]",
                "#",
                "|",
                "^",
                "<",
                ">"
            ];
            if (!t || 0 === t.length) return "undefined";
            var i = t.split(".");
            return i.length > 1 && (_$r = i.pop()), "".concat(i.join(".").split("").map(function(t) {
                return _$o.indexOf(t) > -1 ? n : t;
            }).join("")).concat(_$r ? "." + _$r : "");
        }, Pr = function Pr(t, e) {
            return e && 0 !== e.length ? 0 === Object.keys(t).length ? t : Object.keys(t).filter(function(t) {
                return e.indexOf(t) > -1;
            }).reduce(function(e, r) {
                var n;
                return (0, i.Cl)((0, i.Cl)({}, e), ((n = {})[r] = t[r], n));
            }, {}) : t;
        }, Ar = function t(e) {
            return e && 0 !== Object.keys(e).length ? (Object.keys(e).forEach(function(r) {
                "function" == typeof e[r] && (e[r] = void 0), e[r] === Object(e[r]) && (e[r] = t(e[r]));
            }), e) : e;
        };
    },
    7047: function(t) {
        t.exports = URIError;
    },
    7052: function(t) {
        t.exports = Function.prototype.apply;
    },
    7548: function(t) {
        t.exports = Math.round;
    },
    7680: function(t, e, r) {
        var _$o = function _$o(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, a(n.key), n);
            }
        };
        var i = function i(t, e, r) {
            return e && _$o(t.prototype, e), r && _$o(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        };
        var a = function a(t) {
            var _$e = function(t) {
                if ("object" != n(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != n(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == n(_$e) ? _$e : String(_$e);
        };
        var c = function c(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        };
        var s = function s(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t, "prototype", {
                writable: !1
            }), e && h(t, e);
        };
        var u = function u(t) {
            var _$e = f();
            return function() {
                var _$r, _$o = d(t);
                if (_$e) {
                    var i = d(this).constructor;
                    _$r = Reflect.construct(_$o, arguments, i);
                } else _$r = _$o.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === n(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$r);
            };
        };
        var f = function f() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        function p(t) {
            var _$e = "function" == typeof Map ? new Map : void 0;
            return p = function p(t) {
                if (null === t || !function(t) {
                    try {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    } catch (e) {
                        return "function" == typeof t;
                    }
                }(t)) return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== _$e) {
                    if (_$e.has(t)) return _$e.get(t);
                    _$e.set(t, r);
                }
                function r() {
                    return l(t, arguments, d(this).constructor);
                }
                return r.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: r,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), h(r, t);
            }, p(t);
        }
        function l(t, e, r) {
            return l = f() ? Reflect.construct.bind() : function l(t, e, r) {
                var n = [
                    null
                ];
                n.push.apply(n, e);
                var _$o = new (Function.bind.apply(t, n));
                return r && h(_$o, r.prototype), _$o;
            }, l.apply(null, arguments);
        }
        function h(t, e) {
            return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function h(t, e) {
                return t.__proto__ = e, t;
            }, h(t, e);
        }
        function d(t) {
            return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function d(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, d(t);
        }
        r.d(e, {
            d1: function() {
                return m;
            },
            lc: function() {
                return y;
            }
        });
        var m = function(t) {
            s(r, t);
            var _$e = u(r);
            function r() {
                var _$t;
                return c(this, r), (_$t = _$e.call(this, "End-Of-Stream")).name = "EndOfStreamError", _$t;
            }
            return i(r);
        }(p(Error)), y = function(t) {
            s(r, t);
            var _$e = u(r);
            function r() {
                var _$t, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "The operation was aborted";
                return c(this, r), (_$t = _$e.call(this, n)).name = "AbortError", _$t;
            }
            return i(r);
        }(p(Error));
    },
    8299: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o, i = r(9142), a = r(157), c = r(15), s = r(2104), u = r(6076), p = r(1226), l = r(1953), f = r(7047), h = r(4940), d = r(4218), m = r(9406), y = r(8624), v = r(6114), _$g = r(7548), b = r(9063), x = Function, w = function w(t) {
            try {
                return x('"use strict"; return (' + t + ").constructor;")();
            } catch (t) {}
        }, k = r(3581), S = r(5049), E = function E() {
            throw new l;
        }, O = k ? function() {
            try {
                return E;
            } catch (t) {
                try {
                    return k(arguments, "callee").get;
                } catch (t) {
                    return E;
                }
            }
        }() : E, j = r(377)(), F = r(5586), _ = r(9302), P = r(1622), A = r(7052), T = r(5118), D = {}, L = "undefined" != typeof Uint8Array && F ? F(Uint8Array) : _$o, C = {
            __proto__: null,
            "%AggregateError%": "undefined" == typeof AggregateError ? _$o : AggregateError,
            "%Array%": Array,
            "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? _$o : ArrayBuffer,
            "%ArrayIteratorPrototype%": j && F ? F([][Symbol.iterator]()) : _$o,
            "%AsyncFromSyncIteratorPrototype%": _$o,
            "%AsyncFunction%": D,
            "%AsyncGenerator%": D,
            "%AsyncGeneratorFunction%": D,
            "%AsyncIteratorPrototype%": D,
            "%Atomics%": "undefined" == typeof Atomics ? _$o : Atomics,
            "%BigInt%": "undefined" == typeof BigInt ? _$o : BigInt,
            "%BigInt64Array%": "undefined" == typeof BigInt64Array ? _$o : BigInt64Array,
            "%BigUint64Array%": "undefined" == typeof BigUint64Array ? _$o : BigUint64Array,
            "%Boolean%": Boolean,
            "%DataView%": "undefined" == typeof DataView ? _$o : DataView,
            "%Date%": Date,
            "%decodeURI%": decodeURI,
            "%decodeURIComponent%": decodeURIComponent,
            "%encodeURI%": encodeURI,
            "%encodeURIComponent%": encodeURIComponent,
            "%Error%": a,
            "%eval%": eval,
            "%EvalError%": c,
            "%Float16Array%": "undefined" == typeof Float16Array ? _$o : Float16Array,
            "%Float32Array%": "undefined" == typeof Float32Array ? _$o : Float32Array,
            "%Float64Array%": "undefined" == typeof Float64Array ? _$o : Float64Array,
            "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? _$o : FinalizationRegistry,
            "%Function%": x,
            "%GeneratorFunction%": D,
            "%Int8Array%": "undefined" == typeof Int8Array ? _$o : Int8Array,
            "%Int16Array%": "undefined" == typeof Int16Array ? _$o : Int16Array,
            "%Int32Array%": "undefined" == typeof Int32Array ? _$o : Int32Array,
            "%isFinite%": isFinite,
            "%isNaN%": isNaN,
            "%IteratorPrototype%": j && F ? F(F([][Symbol.iterator]())) : _$o,
            "%JSON%": "object" === ("undefined" == typeof JSON ? "undefined" : n(JSON)) ? JSON : _$o,
            "%Map%": "undefined" == typeof Map ? _$o : Map,
            "%MapIteratorPrototype%": "undefined" != typeof Map && j && F ? F((new Map)[Symbol.iterator]()) : _$o,
            "%Math%": Math,
            "%Number%": Number,
            "%Object%": i,
            "%Object.getOwnPropertyDescriptor%": k,
            "%parseFloat%": parseFloat,
            "%parseInt%": parseInt,
            "%Promise%": "undefined" == typeof Promise ? _$o : Promise,
            "%Proxy%": "undefined" == typeof Proxy ? _$o : Proxy,
            "%RangeError%": s,
            "%ReferenceError%": u,
            "%Reflect%": "undefined" == typeof Reflect ? _$o : Reflect,
            "%RegExp%": RegExp,
            "%Set%": "undefined" == typeof Set ? _$o : Set,
            "%SetIteratorPrototype%": "undefined" != typeof Set && j && F ? F((new Set)[Symbol.iterator]()) : _$o,
            "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? _$o : SharedArrayBuffer,
            "%String%": String,
            "%StringIteratorPrototype%": j && F ? F(""[Symbol.iterator]()) : _$o,
            "%Symbol%": j ? Symbol : _$o,
            "%SyntaxError%": p,
            "%ThrowTypeError%": O,
            "%TypedArray%": L,
            "%TypeError%": l,
            "%Uint8Array%": "undefined" == typeof Uint8Array ? _$o : Uint8Array,
            "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? _$o : Uint8ClampedArray,
            "%Uint16Array%": "undefined" == typeof Uint16Array ? _$o : Uint16Array,
            "%Uint32Array%": "undefined" == typeof Uint32Array ? _$o : Uint32Array,
            "%URIError%": f,
            "%WeakMap%": "undefined" == typeof WeakMap ? _$o : WeakMap,
            "%WeakRef%": "undefined" == typeof WeakRef ? _$o : WeakRef,
            "%WeakSet%": "undefined" == typeof WeakSet ? _$o : WeakSet,
            "%Function.prototype.call%": T,
            "%Function.prototype.apply%": A,
            "%Object.defineProperty%": S,
            "%Object.getPrototypeOf%": _,
            "%Math.abs%": h,
            "%Math.floor%": d,
            "%Math.max%": m,
            "%Math.min%": y,
            "%Math.pow%": v,
            "%Math.round%": _$g,
            "%Math.sign%": b,
            "%Reflect.getPrototypeOf%": P
        };
        if (F) try {
            null.error;
        } catch (t) {
            var I = F(F(t));
            C["%Error.prototype%"] = I;
        }
        var z = function t(e) {
            var _$r;
            if ("%AsyncFunction%" === e) _$r = w("async function () {}");
            else if ("%GeneratorFunction%" === e) _$r = w("function* () {}");
            else if ("%AsyncGeneratorFunction%" === e) _$r = w("async function* () {}");
            else if ("%AsyncGenerator%" === e) {
                var _$n = t("%AsyncGeneratorFunction%");
                _$n && (_$r = _$n.prototype);
            } else if ("%AsyncIteratorPrototype%" === e) {
                var _$o = t("%AsyncGenerator%");
                _$o && F && (_$r = F(_$o.prototype));
            }
            return C[e] = _$r, _$r;
        }, N = {
            __proto__: null,
            "%ArrayBufferPrototype%": [
                "ArrayBuffer",
                "prototype"
            ],
            "%ArrayPrototype%": [
                "Array",
                "prototype"
            ],
            "%ArrayProto_entries%": [
                "Array",
                "prototype",
                "entries"
            ],
            "%ArrayProto_forEach%": [
                "Array",
                "prototype",
                "forEach"
            ],
            "%ArrayProto_keys%": [
                "Array",
                "prototype",
                "keys"
            ],
            "%ArrayProto_values%": [
                "Array",
                "prototype",
                "values"
            ],
            "%AsyncFunctionPrototype%": [
                "AsyncFunction",
                "prototype"
            ],
            "%AsyncGenerator%": [
                "AsyncGeneratorFunction",
                "prototype"
            ],
            "%AsyncGeneratorPrototype%": [
                "AsyncGeneratorFunction",
                "prototype",
                "prototype"
            ],
            "%BooleanPrototype%": [
                "Boolean",
                "prototype"
            ],
            "%DataViewPrototype%": [
                "DataView",
                "prototype"
            ],
            "%DatePrototype%": [
                "Date",
                "prototype"
            ],
            "%ErrorPrototype%": [
                "Error",
                "prototype"
            ],
            "%EvalErrorPrototype%": [
                "EvalError",
                "prototype"
            ],
            "%Float32ArrayPrototype%": [
                "Float32Array",
                "prototype"
            ],
            "%Float64ArrayPrototype%": [
                "Float64Array",
                "prototype"
            ],
            "%FunctionPrototype%": [
                "Function",
                "prototype"
            ],
            "%Generator%": [
                "GeneratorFunction",
                "prototype"
            ],
            "%GeneratorPrototype%": [
                "GeneratorFunction",
                "prototype",
                "prototype"
            ],
            "%Int8ArrayPrototype%": [
                "Int8Array",
                "prototype"
            ],
            "%Int16ArrayPrototype%": [
                "Int16Array",
                "prototype"
            ],
            "%Int32ArrayPrototype%": [
                "Int32Array",
                "prototype"
            ],
            "%JSONParse%": [
                "JSON",
                "parse"
            ],
            "%JSONStringify%": [
                "JSON",
                "stringify"
            ],
            "%MapPrototype%": [
                "Map",
                "prototype"
            ],
            "%NumberPrototype%": [
                "Number",
                "prototype"
            ],
            "%ObjectPrototype%": [
                "Object",
                "prototype"
            ],
            "%ObjProto_toString%": [
                "Object",
                "prototype",
                "toString"
            ],
            "%ObjProto_valueOf%": [
                "Object",
                "prototype",
                "valueOf"
            ],
            "%PromisePrototype%": [
                "Promise",
                "prototype"
            ],
            "%PromiseProto_then%": [
                "Promise",
                "prototype",
                "then"
            ],
            "%Promise_all%": [
                "Promise",
                "all"
            ],
            "%Promise_reject%": [
                "Promise",
                "reject"
            ],
            "%Promise_resolve%": [
                "Promise",
                "resolve"
            ],
            "%RangeErrorPrototype%": [
                "RangeError",
                "prototype"
            ],
            "%ReferenceErrorPrototype%": [
                "ReferenceError",
                "prototype"
            ],
            "%RegExpPrototype%": [
                "RegExp",
                "prototype"
            ],
            "%SetPrototype%": [
                "Set",
                "prototype"
            ],
            "%SharedArrayBufferPrototype%": [
                "SharedArrayBuffer",
                "prototype"
            ],
            "%StringPrototype%": [
                "String",
                "prototype"
            ],
            "%SymbolPrototype%": [
                "Symbol",
                "prototype"
            ],
            "%SyntaxErrorPrototype%": [
                "SyntaxError",
                "prototype"
            ],
            "%TypedArrayPrototype%": [
                "TypedArray",
                "prototype"
            ],
            "%TypeErrorPrototype%": [
                "TypeError",
                "prototype"
            ],
            "%Uint8ArrayPrototype%": [
                "Uint8Array",
                "prototype"
            ],
            "%Uint8ClampedArrayPrototype%": [
                "Uint8ClampedArray",
                "prototype"
            ],
            "%Uint16ArrayPrototype%": [
                "Uint16Array",
                "prototype"
            ],
            "%Uint32ArrayPrototype%": [
                "Uint32Array",
                "prototype"
            ],
            "%URIErrorPrototype%": [
                "URIError",
                "prototype"
            ],
            "%WeakMapPrototype%": [
                "WeakMap",
                "prototype"
            ],
            "%WeakSetPrototype%": [
                "WeakSet",
                "prototype"
            ]
        }, R = r(5465), M = r(863), B = R.call(T, Array.prototype.concat), U = R.call(A, Array.prototype.splice), q = R.call(T, String.prototype.replace), G = R.call(T, String.prototype.slice), $ = R.call(T, RegExp.prototype.exec), Z = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, V = /\\(\\)?/g, H = function H(t, e) {
            var _$r, _$n = t;
            if (M(N, _$n) && (_$n = "%" + (_$r = N[_$n])[0] + "%"), M(C, _$n)) {
                var _$o = C[_$n];
                if (_$o === D && (_$o = z(_$n)), void 0 === _$o && !e) throw new l("intrinsic " + t + " exists, but is not available. Please file an issue!");
                return {
                    alias: _$r,
                    name: _$n,
                    value: _$o
                };
            }
            throw new p("intrinsic " + t + " does not exist!");
        };
        t.exports = function(t, e) {
            if ("string" != typeof t || 0 === t.length) throw new l("intrinsic name must be a non-empty string");
            if (arguments.length > 1 && "boolean" != typeof e) throw new l('"allowMissing" argument must be a boolean');
            if (null === $(/^%?[^%]*%?$/, t)) throw new p("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
            var _$r = function(t) {
                var _$e = G(t, 0, 1), _$r = G(t, -1);
                if ("%" === _$e && "%" !== _$r) throw new p("invalid intrinsic syntax, expected closing `%`");
                if ("%" === _$r && "%" !== _$e) throw new p("invalid intrinsic syntax, expected opening `%`");
                var _$n = [];
                return q(t, Z, function(t, e, r, o) {
                    _$n[_$n.length] = r ? q(o, V, "$1") : e || t;
                }), _$n;
            }(t), _$n = _$r.length > 0 ? _$r[0] : "", _$o = H("%" + _$n + "%", e), i = _$o.name, a = _$o.value, c = !1, s = _$o.alias;
            s && (_$n = s[0], U(_$r, B([
                0,
                1
            ], s)));
            for(var u = 1, f = !0; u < _$r.length; u += 1){
                var h = _$r[u], d = G(h, 0, 1), m = G(h, -1);
                if (('"' === d || "'" === d || "`" === d || '"' === m || "'" === m || "`" === m) && d !== m) throw new p("property names with quotes must have matching quotes");
                if ("constructor" !== h && f || (c = !0), M(C, i = "%" + (_$n += "." + h) + "%")) a = C[i];
                else if (null != a) {
                    if (!(h in a)) {
                        if (!e) throw new l("base intrinsic for " + t + " exists, but the property is not available.");
                        return;
                    }
                    if (k && u + 1 >= _$r.length) {
                        var y = k(a, h);
                        a = (f = !!y) && "get" in y && !("originalValue" in y.get) ? y.get : a[h];
                    } else f = M(a, h), a = a[h];
                    f && !c && (C[i] = a);
                }
            }
            return a;
        };
    },
    8624: function(t) {
        t.exports = Math.min;
    },
    8630: function(t, e, r) {
        var n = function n(t) {
            return function(t) {
                if (Array.isArray(t)) return a(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || i(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var _$o = function _$o(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = i(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, _$o = function o() {};
                    return {
                        s: _$o,
                        n: function n1() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function e(t) {
                            throw t;
                        },
                        f: _$o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var a, c = !0, s = !1;
            return {
                s: function s() {
                    r = r.call(t);
                },
                n: function n() {
                    var _$t = r.next();
                    return c = _$t.done, _$t;
                },
                e: function e(t) {
                    s = !0, a = t;
                },
                f: function f() {
                    try {
                        c || null == r["return"] || r["return"]();
                    } finally{
                        if (s) throw a;
                    }
                }
            };
        };
        var i = function i(t, e) {
            if (t) {
                if ("string" == typeof t) return a(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(t, e) : void 0;
            }
        };
        var a = function a(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
            return n;
        };
        t.exports = function(t) {
            function e(t) {
                var _$r, n, _$o, a = null;
                function c() {
                    for(var _$t = arguments.length, n = new Array(_$t), _$o = 0; _$o < _$t; _$o++)n[_$o] = arguments[_$o];
                    if (c.enabled) {
                        var _$i = c, a = Number(new Date), s = a - (_$r || a);
                        _$i.diff = s, _$i.prev = _$r, _$i.curr = a, _$r = a, n[0] = e.coerce(n[0]), "string" != typeof n[0] && n.unshift("%O");
                        var u = 0;
                        n[0] = n[0].replace(/%([a-zA-Z%])/g, function(t, r) {
                            if ("%%" === t) return "%";
                            u++;
                            var _$o = e.formatters[r];
                            if ("function" == typeof _$o) {
                                var a = n[u];
                                t = _$o.call(_$i, a), n.splice(u, 1), u--;
                            }
                            return t;
                        }), e.formatArgs.call(_$i, n), (_$i.log || e.log).apply(_$i, n);
                    }
                }
                return c.namespace = t, c.useColors = e.useColors(), c.color = e.selectColor(t), c.extend = i, c.destroy = e.destroy, Object.defineProperty(c, "enabled", {
                    enumerable: !0,
                    configurable: !1,
                    get: function get() {
                        return null !== a ? a : (n !== e.namespaces && (n = e.namespaces, _$o = e.enabled(t)), _$o);
                    },
                    set: function set(t) {
                        a = t;
                    }
                }), "function" == typeof e.init && e.init(c), c;
            }
            function i(t, r) {
                var n = e(this.namespace + (void 0 === r ? ":" : r) + t);
                return n.log = this.log, n;
            }
            function a(t, e) {
                for(var _$r = 0, n = 0, _$o = -1, i = 0; _$r < t.length;)if (n < e.length && (e[n] === t[_$r] || "*" === e[n])) "*" === e[n] ? (_$o = n, i = _$r, n++) : (_$r++, n++);
                else {
                    if (-1 === _$o) return !1;
                    n = _$o + 1, _$r = ++i;
                }
                for(; n < e.length && "*" === e[n];)n++;
                return n === e.length;
            }
            return e.debug = e, e["default"] = e, e.coerce = function(t) {
                return t instanceof Error ? t.stack || t.message : t;
            }, e.disable = function() {
                var _$t = [].concat(n(e.names), n(e.skips.map(function(t) {
                    return "-" + t;
                }))).join(",");
                return e.enable(""), _$t;
            }, e.enable = function(t) {
                e.save(t), e.namespaces = t, e.names = [], e.skips = [];
                var _$r, n = _$o(("string" == typeof t ? t : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean));
                try {
                    for(n.s(); !(_$r = n.n()).done;){
                        var i = _$r.value;
                        "-" === i[0] ? e.skips.push(i.slice(1)) : e.names.push(i);
                    }
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
            }, e.enabled = function(t) {
                var _$r, n = _$o(e.skips);
                try {
                    for(n.s(); !(_$r = n.n()).done;)if (a(t, _$r.value)) return !1;
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
                var i, c = _$o(e.names);
                try {
                    for(c.s(); !(i = c.n()).done;)if (a(t, i.value)) return !0;
                } catch (t) {
                    c.e(t);
                } finally{
                    c.f();
                }
                return !1;
            }, e.humanize = r(9527), e.destroy = function() {
                console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
            }, Object.keys(t).forEach(function(r) {
                e[r] = t[r];
            }), e.names = [], e.skips = [], e.formatters = {}, e.selectColor = function(t) {
                for(var _$r = 0, n = 0; n < t.length; n++)_$r = (_$r << 5) - _$r + t.charCodeAt(n), _$r |= 0;
                return e.colors[Math.abs(_$r) % e.colors.length];
            }, e.enable(e.load()), e;
        };
    },
    8657: function(t, e, r) {
        var I = function I(t, e) {
            if (t === 1 / 0 || t === -1 / 0 || t != t || t && t > -1000 && t < 1e3 || S.call(/e/, e)) return e;
            var _$r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
            if ("number" == typeof t) {
                var _$n = t < 0 ? -F(-t) : F(t);
                if (_$n !== t) {
                    var _$o = String(_$n), i = b.call(e, _$o.length + 1);
                    return x.call(_$o, _$r, "$&_") + "." + x.call(x.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
                }
            }
            return x.call(e, _$r, "$&_");
        };
        var U = function U(t, e, r) {
            var _$n = r.quoteStyle || e, _$o = M[_$n];
            return _$o + t + _$o;
        };
        var q = function q(t) {
            return x.call(String(t), /"/g, "&quot;");
        };
        var G = function G(t) {
            return !D || !("object" === n(t) && (D in t || void 0 !== t[D]));
        };
        var $ = function $(t) {
            return "[object Array]" === W(t) && G(t);
        };
        var Z = function Z(t) {
            return "[object RegExp]" === W(t) && G(t);
        };
        var V = function V(t) {
            if (T) return t && "object" === n(t) && t instanceof Symbol;
            if ("symbol" === n(t)) return !0;
            if (!t || "object" !== n(t) || !A) return !1;
            try {
                return A.call(t), !0;
            } catch (t) {}
            return !1;
        };
        var Y = function Y(t, e) {
            return H.call(t, e);
        };
        var W = function W(t) {
            return y.call(t);
        };
        var K = function K(t, e) {
            if (t.indexOf) return t.indexOf(e);
            for(var _$r = 0, _$n = t.length; _$r < _$n; _$r++)if (t[_$r] === e) return _$r;
            return -1;
        };
        var J = function J(t) {
            var e = t.charCodeAt(0), _$r = {
                8: "b",
                9: "t",
                10: "n",
                12: "f",
                13: "r"
            }[e];
            return _$r ? "\\" + _$r : "\\x" + (e < 16 ? "0" : "") + w.call(e.toString(16));
        };
        var X = function X(t) {
            return "Object(" + t + ")";
        };
        var tt = function tt(t) {
            return t + " { ? }";
        };
        var et = function et(t, e, r, n) {
            return t + " (" + e + ") {" + (n ? rt(r, n) : O.call(r, ", ")) + "}";
        };
        var rt = function rt(t, e) {
            if (0 === t.length) return "";
            var _$r = "\n" + e.prev + e.base;
            return _$r + O.call(t, "," + _$r) + "\n" + e.prev;
        };
        var nt = function nt(t, e) {
            var _$r = $(t), _$n = [];
            if (_$r) {
                _$n.length = t.length;
                for(var _$o = 0; _$o < t.length; _$o++)_$n[_$o] = Y(t, _$o) ? e(t[_$o], t) : "";
            }
            var i, a = "function" == typeof P ? P(t) : [];
            if (T) {
                i = {};
                for(var c = 0; c < a.length; c++)i["$" + a[c]] = a[c];
            }
            for(var s in t)Y(t, s) && (_$r && String(Number(s)) === s && s < t.length || T && i["$" + s] instanceof Symbol || (S.call(/[^\w$]/, s) ? _$n.push(e(s, t) + ": " + e(t[s], t)) : _$n.push(s + ": " + e(t[s], t))));
            if ("function" == typeof P) for(var u = 0; u < a.length; u++)L.call(t, a[u]) && _$n.push("[" + e(a[u]) + "]: " + e(t[a[u]], t));
            return _$n;
        };
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o = "function" == typeof Map && Map.prototype, i = Object.getOwnPropertyDescriptor && _$o ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, a = _$o && i && "function" == typeof i.get ? i.get : null, c = _$o && Map.prototype.forEach, s = "function" == typeof Set && Set.prototype, u = Object.getOwnPropertyDescriptor && s ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, p = s && u && "function" == typeof u.get ? u.get : null, l = s && Set.prototype.forEach, f = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, h = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, d = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, m = Boolean.prototype.valueOf, y = Object.prototype.toString, v = Function.prototype.toString, _$g = String.prototype.match, b = String.prototype.slice, x = String.prototype.replace, w = String.prototype.toUpperCase, k = String.prototype.toLowerCase, S = RegExp.prototype.test, E = Array.prototype.concat, O = Array.prototype.join, j = Array.prototype.slice, F = Math.floor, _ = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, P = Object.getOwnPropertySymbols, A = "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? Symbol.prototype.toString : null, T = "function" == typeof Symbol && "object" === n(Symbol.iterator), D = "function" == typeof Symbol && Symbol.toStringTag && (n(Symbol.toStringTag), 1) ? Symbol.toStringTag : null, L = Object.prototype.propertyIsEnumerable, C = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
            return t.__proto__;
        } : null);
        var z = r(2634), N = z.custom, R = V(N) ? N : null, M = {
            __proto__: null,
            double: '"',
            single: "'"
        }, B = {
            __proto__: null,
            double: /(["\\])/g,
            single: /(['\\])/g
        };
        t.exports = function t(e, o, i, s) {
            var u = o || {};
            if (Y(u, "quoteStyle") && !Y(M, u.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
            if (Y(u, "maxStringLength") && ("number" == typeof u.maxStringLength ? u.maxStringLength < 0 && u.maxStringLength !== 1 / 0 : null !== u.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
            var y = !Y(u, "customInspect") || u.customInspect;
            if ("boolean" != typeof y && "symbol" !== y) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
            if (Y(u, "indent") && null !== u.indent && "\t" !== u.indent && !(parseInt(u.indent, 10) === u.indent && u.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
            if (Y(u, "numericSeparator") && "boolean" != typeof u.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
            var w = u.numericSeparator;
            if (void 0 === e) return "undefined";
            if (null === e) return "null";
            if ("boolean" == typeof e) return e ? "true" : "false";
            if ("string" == typeof e) return Q(e, u);
            if ("number" == typeof e) {
                if (0 === e) return 1 / 0 / e > 0 ? "0" : "-0";
                var S = String(e);
                return w ? I(e, S) : S;
            }
            if ("bigint" == (typeof e === "undefined" ? "undefined" : (0, $2xTNA._)(e))) {
                var F = String(e) + "n";
                return w ? I(e, F) : F;
            }
            var P = void 0 === u.depth ? 5 : u.depth;
            if (void 0 === i && (i = 0), i >= P && P > 0 && "object" === n(e)) return $(e) ? "[Array]" : "[Object]";
            var N, B = function(t, e) {
                var _$r;
                if ("\t" === t.indent) _$r = "\t";
                else {
                    if (!("number" == typeof t.indent && t.indent > 0)) return null;
                    _$r = O.call(Array(t.indent + 1), " ");
                }
                return {
                    base: _$r,
                    prev: O.call(Array(e + 1), _$r)
                };
            }(u, i);
            if (void 0 === s) s = [];
            else if (K(s, e) >= 0) return "[Circular]";
            function H(e, r, n) {
                if (r && (s = j.call(s)).push(r), n) {
                    var _$o = {
                        depth: u.depth
                    };
                    return Y(u, "quoteStyle") && (_$o.quoteStyle = u.quoteStyle), t(e, _$o, i + 1, s);
                }
                return t(e, u, i + 1, s);
            }
            if ("function" == typeof e && !Z(e)) {
                var J = function(t) {
                    if (t.name) return t.name;
                    var _$e = _$g.call(v.call(t), /^function\s*([\w$]+)/);
                    return _$e ? _$e[1] : null;
                }(e), ot = nt(e, H);
                return "[Function" + (J ? ": " + J : " (anonymous)") + "]" + (ot.length > 0 ? " { " + O.call(ot, ", ") + " }" : "");
            }
            if (V(e)) {
                var it = T ? x.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : A.call(e);
                return "object" !== n(e) || T ? it : X(it);
            }
            if ((N = e) && "object" === n(N) && ("undefined" != typeof HTMLElement && N instanceof HTMLElement || "string" == typeof N.nodeName && "function" == typeof N.getAttribute)) {
                for(var at = "<" + k.call(String(e.nodeName)), ct = e.attributes || [], st = 0; st < ct.length; st++)at += " " + ct[st].name + "=" + U(q(ct[st].value), "double", u);
                return at += ">", e.childNodes && e.childNodes.length && (at += "..."), at + "</" + k.call(String(e.nodeName)) + ">";
            }
            if ($(e)) {
                if (0 === e.length) return "[]";
                var ut = nt(e, H);
                return B && !function(t) {
                    for(var _$e = 0; _$e < t.length; _$e++)if (K(t[_$e], "\n") >= 0) return !1;
                    return !0;
                }(ut) ? "[" + rt(ut, B) + "]" : "[ " + O.call(ut, ", ") + " ]";
            }
            if (function(t) {
                return "[object Error]" === W(t) && G(t);
            }(e)) {
                var pt = nt(e, H);
                return "cause" in Error.prototype || !("cause" in e) || L.call(e, "cause") ? 0 === pt.length ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + O.call(pt, ", ") + " }" : "{ [" + String(e) + "] " + O.call(E.call("[cause]: " + H(e.cause), pt), ", ") + " }";
            }
            if ("object" === n(e) && y) {
                if (R && "function" == typeof e[R] && z) return z(e, {
                    depth: P - i
                });
                if ("symbol" !== y && "function" == typeof e.inspect) return e.inspect();
            }
            if (function(t) {
                if (!a || !t || "object" !== n(t)) return !1;
                try {
                    a.call(t);
                    try {
                        p.call(t);
                    } catch (t) {
                        return !0;
                    }
                    return t instanceof Map;
                } catch (t) {}
                return !1;
            }(e)) {
                var lt = [];
                return c && c.call(e, function(t, r) {
                    lt.push(H(r, e, !0) + " => " + H(t, e));
                }), et("Map", a.call(e), lt, B);
            }
            if (function(t) {
                if (!p || !t || "object" !== n(t)) return !1;
                try {
                    p.call(t);
                    try {
                        a.call(t);
                    } catch (t) {
                        return !0;
                    }
                    return t instanceof Set;
                } catch (t) {}
                return !1;
            }(e)) {
                var ft = [];
                return l && l.call(e, function(t) {
                    ft.push(H(t, e));
                }), et("Set", p.call(e), ft, B);
            }
            if (function(t) {
                if (!f || !t || "object" !== n(t)) return !1;
                try {
                    f.call(t, f);
                    try {
                        h.call(t, h);
                    } catch (t) {
                        return !0;
                    }
                    return t instanceof WeakMap;
                } catch (t) {}
                return !1;
            }(e)) return tt("WeakMap");
            if (function(t) {
                if (!h || !t || "object" !== n(t)) return !1;
                try {
                    h.call(t, h);
                    try {
                        f.call(t, f);
                    } catch (t) {
                        return !0;
                    }
                    return t instanceof WeakSet;
                } catch (t) {}
                return !1;
            }(e)) return tt("WeakSet");
            if (function(t) {
                if (!d || !t || "object" !== n(t)) return !1;
                try {
                    return d.call(t), !0;
                } catch (t) {}
                return !1;
            }(e)) return tt("WeakRef");
            if (function(t) {
                return "[object Number]" === W(t) && G(t);
            }(e)) return X(H(Number(e)));
            if (function(t) {
                if (!t || "object" !== n(t) || !_) return !1;
                try {
                    return _.call(t), !0;
                } catch (t) {}
                return !1;
            }(e)) return X(H(_.call(e)));
            if (function(t) {
                return "[object Boolean]" === W(t) && G(t);
            }(e)) return X(m.call(e));
            if (function(t) {
                return "[object String]" === W(t) && G(t);
            }(e)) return X(H(String(e)));
            if ("undefined" != typeof window && e === window) return "{ [object Window] }";
            if ("undefined" != typeof globalThis && e === globalThis || void 0 !== r.g && e === r.g) return "{ [object globalThis] }";
            if (!function(t) {
                return "[object Date]" === W(t) && G(t);
            }(e) && !Z(e)) {
                var ht = nt(e, H), dt = C ? C(e) === Object.prototype : e instanceof Object || e.constructor === Object, mt = e instanceof Object ? "" : "null prototype", yt = !dt && D && Object(e) === e && D in e ? b.call(W(e), 8, -1) : mt ? "Object" : "", vt = (dt || "function" != typeof e.constructor ? "" : e.constructor.name ? e.constructor.name + " " : "") + (yt || mt ? "[" + O.call(E.call([], yt || [], mt || []), ": ") + "] " : "");
                return 0 === ht.length ? vt + "{}" : B ? vt + "{" + rt(ht, B) + "}" : vt + "{ " + O.call(ht, ", ") + " }";
            }
            return String(e);
        };
        var H = Object.prototype.hasOwnProperty || function(t) {
            return t in this;
        };
        function Q(t, e) {
            if (t.length > e.maxStringLength) {
                var _$r = t.length - e.maxStringLength, _$n = "... " + _$r + " more character" + (_$r > 1 ? "s" : "");
                return Q(b.call(t, 0, e.maxStringLength), e) + _$n;
            }
            var _$o = B[e.quoteStyle || "single"];
            return _$o.lastIndex = 0, U(x.call(x.call(t, _$o, "\\$1"), /[\x00-\x1f]/g, J), "single", e);
        }
    },
    8796: function(t, e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e["default"] = function(t, e, r) {
            for(var n = 0, _$o = t.length; _$o > 0;){
                var i = _$o / 2 | 0, a = n + i;
                r(t[a], e) <= 0 ? (n = ++a, _$o -= i + 1) : _$o = i;
            }
            return n;
        };
    },
    8950: function(t, e, r) {
        function n(t) {
            return n = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function n(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, n(t);
        }
        var _$o, i = r(9472), a = r(3581);
        try {
            _$o = [].__proto__ === Array.prototype;
        } catch (t) {
            if (!t || "object" !== n(t) || !("code" in t) || "ERR_PROTO_ACCESS" !== t.code) throw t;
        }
        var c = !!_$o && a && a(Object.prototype, "__proto__"), s = Object, u = s.getPrototypeOf;
        t.exports = c && "function" == typeof c.get ? i([
            c.get
        ]) : "function" == typeof u && function(t) {
            return u(null == t ? t : s(t));
        };
    },
    9063: function(t, e, r) {
        var n = r(6681);
        t.exports = function(t) {
            return n(t) || 0 === t ? t : t < 0 ? -1 : 1;
        };
    },
    9142: function(t) {
        t.exports = Object;
    },
    9292: function(t) {
        var e = String.prototype.replace, r = /%20/g, n = "RFC3986";
        t.exports = {
            "default": n,
            formatters: {
                RFC1738: function RFC1738(t) {
                    return e.call(t, r, "+");
                },
                RFC3986: function RFC3986(t) {
                    return String(t);
                }
            },
            RFC1738: "RFC1738",
            RFC3986: n
        };
    },
    9302: function(t, e, r) {
        var n = r(9142);
        t.exports = n.getPrototypeOf || null;
    },
    9367: function(t, e, r) {
        var n = r(4509), _$o = Object.prototype.hasOwnProperty, i = Array.isArray, a = {
            allowDots: !1,
            allowEmptyArrays: !1,
            allowPrototypes: !1,
            allowSparse: !1,
            arrayLimit: 20,
            charset: "utf-8",
            charsetSentinel: !1,
            comma: !1,
            decodeDotInKeys: !1,
            decoder: n.decode,
            delimiter: "&",
            depth: 5,
            duplicates: "combine",
            ignoreQueryPrefix: !1,
            interpretNumericEntities: !1,
            parameterLimit: 1e3,
            parseArrays: !0,
            plainObjects: !1,
            strictDepth: !1,
            strictNullHandling: !1,
            throwOnLimitExceeded: !1
        }, c = function c(t) {
            return t.replace(/&#(\d+);/g, function(t, e) {
                return String.fromCharCode(parseInt(e, 10));
            });
        }, s = function s(t, e, r) {
            if (t && "string" == typeof t && e.comma && t.indexOf(",") > -1) return t.split(",");
            if (e.throwOnLimitExceeded && r >= e.arrayLimit) throw new RangeError("Array limit exceeded. Only " + e.arrayLimit + " element" + (1 === e.arrayLimit ? "" : "s") + " allowed in an array.");
            return t;
        }, u = function u(t, e, r, i) {
            if (t) {
                var a = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, c = /(\[[^[\]]*])/g, u = r.depth > 0 && /(\[[^[\]]*])/.exec(a), p = u ? a.slice(0, u.index) : a, l = [];
                if (p) {
                    if (!r.plainObjects && _$o.call(Object.prototype, p) && !r.allowPrototypes) return;
                    l.push(p);
                }
                for(var f = 0; r.depth > 0 && null !== (u = c.exec(a)) && f < r.depth;){
                    if (f += 1, !r.plainObjects && _$o.call(Object.prototype, u[1].slice(1, -1)) && !r.allowPrototypes) return;
                    l.push(u[1]);
                }
                if (u) {
                    if (!0 === r.strictDepth) throw new RangeError("Input depth exceeded depth option of " + r.depth + " and strictDepth is true");
                    l.push("[" + a.slice(u.index) + "]");
                }
                return function(t, e, r, o) {
                    var _$i = 0;
                    if (t.length > 0 && "[]" === t[t.length - 1]) {
                        var a = t.slice(0, -1).join("");
                        _$i = Array.isArray(e) && e[a] ? e[a].length : 0;
                    }
                    for(var c = o ? e : s(e, r, _$i), u = t.length - 1; u >= 0; --u){
                        var p, l = t[u];
                        if ("[]" === l && r.parseArrays) p = r.allowEmptyArrays && ("" === c || r.strictNullHandling && null === c) ? [] : n.combine([], c);
                        else {
                            p = r.plainObjects ? {
                                __proto__: null
                            } : {};
                            var f = "[" === l.charAt(0) && "]" === l.charAt(l.length - 1) ? l.slice(1, -1) : l, h = r.decodeDotInKeys ? f.replace(/%2E/g, ".") : f, d = parseInt(h, 10);
                            r.parseArrays || "" !== h ? !isNaN(d) && l !== h && String(d) === h && d >= 0 && r.parseArrays && d <= r.arrayLimit ? (p = [])[d] = c : "__proto__" !== h && (p[h] = c) : p = {
                                0: c
                            };
                        }
                        c = p;
                    }
                    return c;
                }(l, e, r, i);
            }
        };
        t.exports = function(t, e) {
            var _$r = function(t) {
                if (!t) return a;
                if (void 0 !== t.allowEmptyArrays && "boolean" != typeof t.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
                if (void 0 !== t.decodeDotInKeys && "boolean" != typeof t.decodeDotInKeys) throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
                if (null !== t.decoder && void 0 !== t.decoder && "function" != typeof t.decoder) throw new TypeError("Decoder has to be a function.");
                if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                if (void 0 !== t.throwOnLimitExceeded && "boolean" != typeof t.throwOnLimitExceeded) throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
                var _$e = void 0 === t.charset ? a.charset : t.charset, _$r = void 0 === t.duplicates ? a.duplicates : t.duplicates;
                if ("combine" !== _$r && "first" !== _$r && "last" !== _$r) throw new TypeError("The duplicates option must be either combine, first, or last");
                return {
                    allowDots: void 0 === t.allowDots ? !0 === t.decodeDotInKeys || a.allowDots : !!t.allowDots,
                    allowEmptyArrays: "boolean" == typeof t.allowEmptyArrays ? !!t.allowEmptyArrays : a.allowEmptyArrays,
                    allowPrototypes: "boolean" == typeof t.allowPrototypes ? t.allowPrototypes : a.allowPrototypes,
                    allowSparse: "boolean" == typeof t.allowSparse ? t.allowSparse : a.allowSparse,
                    arrayLimit: "number" == typeof t.arrayLimit ? t.arrayLimit : a.arrayLimit,
                    charset: _$e,
                    charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : a.charsetSentinel,
                    comma: "boolean" == typeof t.comma ? t.comma : a.comma,
                    decodeDotInKeys: "boolean" == typeof t.decodeDotInKeys ? t.decodeDotInKeys : a.decodeDotInKeys,
                    decoder: "function" == typeof t.decoder ? t.decoder : a.decoder,
                    delimiter: "string" == typeof t.delimiter || n.isRegExp(t.delimiter) ? t.delimiter : a.delimiter,
                    depth: "number" == typeof t.depth || !1 === t.depth ? +t.depth : a.depth,
                    duplicates: _$r,
                    ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
                    interpretNumericEntities: "boolean" == typeof t.interpretNumericEntities ? t.interpretNumericEntities : a.interpretNumericEntities,
                    parameterLimit: "number" == typeof t.parameterLimit ? t.parameterLimit : a.parameterLimit,
                    parseArrays: !1 !== t.parseArrays,
                    plainObjects: "boolean" == typeof t.plainObjects ? t.plainObjects : a.plainObjects,
                    strictDepth: "boolean" == typeof t.strictDepth ? !!t.strictDepth : a.strictDepth,
                    strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : a.strictNullHandling,
                    throwOnLimitExceeded: "boolean" == typeof t.throwOnLimitExceeded && t.throwOnLimitExceeded
                };
            }(e);
            if ("" === t || null == t) return _$r.plainObjects ? {
                __proto__: null
            } : {};
            for(var p = "string" == typeof t ? function(t, e) {
                var _$r = {
                    __proto__: null
                }, u = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t;
                u = u.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                var p = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit, l = u.split(e.delimiter, e.throwOnLimitExceeded ? p + 1 : p);
                if (e.throwOnLimitExceeded && l.length > p) throw new RangeError("Parameter limit exceeded. Only " + p + " parameter" + (1 === p ? "" : "s") + " allowed.");
                var f, h = -1, d = e.charset;
                if (e.charsetSentinel) for(f = 0; f < l.length; ++f)0 === l[f].indexOf("utf8=") && ("utf8=%E2%9C%93" === l[f] ? d = "utf-8" : "utf8=%26%2310003%3B" === l[f] && (d = "iso-8859-1"), h = f, f = l.length);
                for(f = 0; f < l.length; ++f)if (f !== h) {
                    var m, y, v = l[f], _$g = v.indexOf("]="), b = -1 === _$g ? v.indexOf("=") : _$g + 1;
                    -1 === b ? (m = e.decoder(v, a.decoder, d, "key"), y = e.strictNullHandling ? null : "") : (m = e.decoder(v.slice(0, b), a.decoder, d, "key"), y = n.maybeMap(s(v.slice(b + 1), e, i(_$r[m]) ? _$r[m].length : 0), function(t) {
                        return e.decoder(t, a.decoder, d, "value");
                    })), y && e.interpretNumericEntities && "iso-8859-1" === d && (y = c(String(y))), v.indexOf("[]=") > -1 && (y = i(y) ? [
                        y
                    ] : y);
                    var x = _$o.call(_$r, m);
                    x && "combine" === e.duplicates ? _$r[m] = n.combine(_$r[m], y) : x && "last" !== e.duplicates || (_$r[m] = y);
                }
                return _$r;
            }(t, _$r) : t, l = _$r.plainObjects ? {
                __proto__: null
            } : {}, f = Object.keys(p), h = 0; h < f.length; ++h){
                var d = f[h], m = u(d, p[d], _$r, "string" == typeof t);
                l = n.merge(l, m, _$r);
            }
            return !0 === _$r.allowSparse ? l : n.compact(l);
        };
    },
    9406: function(t) {
        t.exports = Math.max;
    },
    9472: function(t, e, r) {
        var n = r(5465), _$o = r(1953), i = r(5118), a = r(1978);
        t.exports = function(t) {
            if (t.length < 1 || "function" != typeof t[0]) throw new _$o("a function is required");
            return a(n, i, t);
        };
    },
    9527: function(t) {
        var c = function c(t, e, r, n) {
            var _$o = e >= 1.5 * r;
            return Math.round(t / r) + " " + n + (_$o ? "s" : "");
        };
        function e(t) {
            return e = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function e(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, e(t);
        }
        var r = 1e3, n = 60 * r, _$o = 60 * n, i = 24 * _$o, a = 7 * i;
        t.exports = function(t, s) {
            s = s || {};
            var u, p, l = e(t);
            if ("string" === l && t.length > 0) return function(t) {
                if (!((t = String(t)).length > 100)) {
                    var _$e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
                    if (_$e) {
                        var c = parseFloat(_$e[1]);
                        switch((_$e[2] || "ms").toLowerCase()){
                            case "years":
                            case "year":
                            case "yrs":
                            case "yr":
                            case "y":
                                return 315576e5 * c;
                            case "weeks":
                            case "week":
                            case "w":
                                return c * a;
                            case "days":
                            case "day":
                            case "d":
                                return c * i;
                            case "hours":
                            case "hour":
                            case "hrs":
                            case "hr":
                            case "h":
                                return c * _$o;
                            case "minutes":
                            case "minute":
                            case "mins":
                            case "min":
                            case "m":
                                return c * n;
                            case "seconds":
                            case "second":
                            case "secs":
                            case "sec":
                            case "s":
                                return c * r;
                            case "milliseconds":
                            case "millisecond":
                            case "msecs":
                            case "msec":
                            case "ms":
                                return c;
                            default:
                                return;
                        }
                    }
                }
            }(t);
            if ("number" === l && isFinite(t)) return s["long"] ? (u = t, (p = Math.abs(u)) >= i ? c(u, p, i, "day") : p >= _$o ? c(u, p, _$o, "hour") : p >= n ? c(u, p, n, "minute") : p >= r ? c(u, p, r, "second") : u + " ms") : function(t) {
                var _$e = Math.abs(t);
                return _$e >= i ? Math.round(t / i) + "d" : _$e >= _$o ? Math.round(t / _$o) + "h" : _$e >= n ? Math.round(t / n) + "m" : _$e >= r ? Math.round(t / r) + "s" : t + "ms";
            }(t);
            throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
        };
    },
    9653: function(t, e, r) {
        r.d(e, {
            E: function() {
                return n;
            },
            d: function() {
                return i;
            }
        });
        var n, _$o = r(1635);
        !function(t) {
            t.ABORTED = "ABORTED", t.NETWORK = "NETWORK", t.TIMEOUT = "TIMEDOUT", t.SERVER = "SERVER", t.REQUEST = "REQUEST", t.OTHER = "OTHER", t.REDIRECT = "REDIRECT";
        }(n || (n = {}));
        var i = function(t) {
            function e(e, r, n, o) {
                var i, a, c, s = this.constructor, u = t.call(this, e) || this;
                return u.config = r, u.response = n, u.code = o, i = u, a = s.prototype, (c = Object.setPrototypeOf) ? c(i, a) : i.__proto__ = a, u;
            }
            return (0, _$o.C6)(e, t), e;
        }(Error);
    },
    9927: function(t) {
        t.exports = function(t, e) {
            return e = e || function() {}, t.then(function(t) {
                return new Promise(function(t) {
                    t(e());
                }).then(function() {
                    return t;
                });
            }, function(t) {
                return new Promise(function(t) {
                    t(e());
                }).then(function() {
                    throw t;
                });
            });
        };
    },
    9971: function(t, e, r) {
        var i = function i(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, c(n.key), n);
            }
        };
        var a = function a(t, e, r) {
            return e && i(t.prototype, e), r && i(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        };
        var c = function c(t) {
            var _$e = function(t) {
                if ("object" != o(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != o(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == o(_$e) ? _$e : String(_$e);
        };
        var l = function l(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var f = function f(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        l(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        l(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var h = function h(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, d(n.key), n);
            }
        };
        var d = function d(t) {
            var _$e = function(t) {
                if ("object" != u(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != u(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == u(_$e) ? _$e : String(_$e);
        };
        var _$g = function _$g(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var b = function b(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        _$g(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        _$g(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var x = function x(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, w(n.key), n);
            }
        };
        var w = function w(t) {
            var _$e = function(t) {
                if ("object" != y(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != y(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == y(_$e) ? _$e : String(_$e);
        };
        var F = function F(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var _ = function _(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        F(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        F(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var P = function P(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, A(n.key), n);
            }
        };
        var A = function A(t) {
            var _$e = function(t) {
                if ("object" != O(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != O(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == O(_$e) ? _$e : String(_$e);
        };
        var I = function I(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var z = function z(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, N(n.key), n);
            }
        };
        var N = function N(t) {
            var _$e = function(t) {
                if ("object" != L(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != L(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == L(_$e) ? _$e : String(_$e);
        };
        var G = function G(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var $ = function $(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        G(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        G(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var Z = function Z(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, V(n.key), n);
            }
        };
        var V = function V(t) {
            var _$e = function(t) {
                if ("object" != U(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != U(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == U(_$e) ? _$e : String(_$e);
        };
        var Q = function Q(t, e) {
            var _$r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), _$r.push.apply(_$r, n);
            }
            return _$r;
        };
        var J = function J(t) {
            for(var _$e = 1; _$e < arguments.length; _$e++){
                var _$r = null != arguments[_$e] ? arguments[_$e] : {};
                _$e % 2 ? Q(Object(_$r), !0).forEach(function(e) {
                    var n, _$o, i;
                    n = t, _$o = e, i = _$r[e], (_$o = nt(_$o)) in n ? Object.defineProperty(n, _$o, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : n[_$o] = i;
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(_$r)) : Q(Object(_$r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(_$r, e));
                });
            }
            return t;
        };
        var tt = function tt(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var et = function et(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        tt(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        tt(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var rt = function rt(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, nt(n.key), n);
            }
        };
        var nt = function nt(t) {
            var _$e = function(t) {
                if ("object" != K(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != K(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == K(_$e) ? _$e : String(_$e);
        };
        var ct = function ct(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var st = function st(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        ct(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        ct(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var ut = function ut(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, pt(n.key), n);
            }
        };
        var pt = function pt(t) {
            var _$e = function(t) {
                if ("object" != it(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != it(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == it(_$e) ? _$e : String(_$e);
        };
        var yt = function yt(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var vt = function vt(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        yt(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        yt(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var gt = function gt(t, e) {
            var _$r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), _$r.push.apply(_$r, n);
            }
            return _$r;
        };
        var bt = function bt(t) {
            for(var _$e = 1; _$e < arguments.length; _$e++){
                var _$r = null != arguments[_$e] ? arguments[_$e] : {};
                _$e % 2 ? gt(Object(_$r), !0).forEach(function(e) {
                    var n, _$o, i;
                    n = t, _$o = e, i = _$r[e], (_$o = wt(_$o)) in n ? Object.defineProperty(n, _$o, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : n[_$o] = i;
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(_$r)) : gt(Object(_$r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(_$r, e));
                });
            }
            return t;
        };
        var xt = function xt(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, wt(n.key), n);
            }
        };
        var wt = function wt(t) {
            var _$e = function(t) {
                if ("object" != dt(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != dt(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == dt(_$e) ? _$e : String(_$e);
        };
        var _t = function _t(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var Pt = function Pt(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        _t(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        _t(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var At = function At(t, e) {
            var _$r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), _$r.push.apply(_$r, n);
            }
            return _$r;
        };
        var Tt = function Tt(t) {
            for(var _$e = 1; _$e < arguments.length; _$e++){
                var _$r = null != arguments[_$e] ? arguments[_$e] : {};
                _$e % 2 ? At(Object(_$r), !0).forEach(function(e) {
                    var n, _$o, i;
                    n = t, _$o = e, i = _$r[e], (_$o = Lt(_$o)) in n ? Object.defineProperty(n, _$o, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : n[_$o] = i;
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(_$r)) : At(Object(_$r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(_$r, e));
                });
            }
            return t;
        };
        var Dt = function Dt(t, e) {
            for(var _$r = 0; _$r < e.length; _$r++){
                var n = e[_$r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Lt(n.key), n);
            }
        };
        var Lt = function Lt(t) {
            var _$e = function(t) {
                if ("object" != jt(t) || !t) return t;
                var _$e = t[Symbol.toPrimitive];
                if (void 0 !== _$e) {
                    var _$r = _$e.call(t, "string");
                    if ("object" != jt(_$r)) return _$r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == jt(_$e) ? _$e : String(_$e);
        };
        var Bt = function Bt(t, e, r, n, o, i, a) {
            try {
                var c = t[i](a), s = c.value;
            } catch (t) {
                return void r(t);
            }
            c.done ? e(s) : Promise.resolve(s).then(n, o);
        };
        var Ut = function Ut(t) {
            return function() {
                var _$e = this, _$r = arguments;
                return new Promise(function(n, o) {
                    var i = t.apply(_$e, _$r);
                    function a(t) {
                        Bt(i, n, o, a, c, "next", t);
                    }
                    function c(t) {
                        Bt(i, n, o, a, c, "throw", t);
                    }
                    a(void 0);
                });
            };
        };
        var qt = function qt(t, e) {
            var _$r = new E(t), n = null != e ? e : {}, _$o = n.onClose;
            return n.onClose = Ut(Mt().mark(function t() {
                return Mt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return t.next = 2, _$r.close();
                        case 2:
                            if (!_$o) {
                                t.next = 4;
                                break;
                            }
                            return t.abrupt("return", _$o());
                        case 4:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), new ht(_$r, n);
        };
        var Gt = function Gt(t, e) {
            var _$r = function(t) {
                try {
                    var _$e = t.getReader({
                        mode: "byob"
                    });
                    return _$e instanceof ReadableStreamDefaultReader ? new W(_$e) : new B(_$e);
                } catch (e) {
                    if (e instanceof TypeError) return new W(t.getReader());
                    throw e;
                }
            }(t), n = null != e ? e : {}, _$o = n.onClose;
            return n.onClose = Ut(Mt().mark(function t() {
                return Mt().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return t.next = 2, _$r.close();
                        case 2:
                            if (!_$o) {
                                t.next = 4;
                                break;
                            }
                            return t.abrupt("return", _$o());
                        case 4:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), new ht(_$r, n);
        };
        var $t = function $t(t, e) {
            return new Ot(t, e);
        };
        var Zt = function Zt(t, e) {
            return new Nt(t, e);
        };
        r.r(e), r.d(e, {
            AbortError: function() {
                return n.lc;
            },
            AbstractTokenizer: function() {
                return ot;
            },
            EndOfStreamError: function() {
                return n.d1;
            },
            fromBlob: function() {
                return Zt;
            },
            fromBuffer: function() {
                return $t;
            },
            fromStream: function() {
                return qt;
            },
            fromWebStream: function() {
                return Gt;
            }
        });
        var n = r(7680);
        function o(t) {
            return o = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function o(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, o(t);
        }
        var s = a(function t() {
            var _$e = this;
            !function(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.resolve = function() {
                return null;
            }, this.reject = function() {
                return null;
            }, this.promise = new Promise(function(t, r) {
                _$e.reject = r, _$e.resolve = t;
            });
        });
        function u(t) {
            return u = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function u(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, u(t);
        }
        function p() {
            p = function p() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function l(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                l({}, "");
            } catch (t) {
                l = function l(t, e, r) {
                    return t[e] = r;
                };
            }
            function f(t, e, r, n) {
                var i = e && e.prototype instanceof b ? e : b, a = Object.create(i.prototype), c = new D(n || []);
                return _$o(a, "_invoke", {
                    value: _(t, r, c)
                }), a;
            }
            function h(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = f;
            var d = "suspendedStart", m = "suspendedYield", y = "executing", v = "completed", _$g = {};
            function b() {}
            function x() {}
            function w() {}
            var k = {};
            l(k, a, function() {
                return this;
            });
            var S = Object.getPrototypeOf, E = S && S(S(L([])));
            E && E !== _$r && n.call(E, a) && (k = E);
            var O = w.prototype = b.prototype = Object.create(k);
            function j(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    l(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function F(t, e) {
                function r(o, i, a, c) {
                    var s = h(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$p = s.arg, _$l = _$p.value;
                        return _$l && "object" == u(_$l) && n.call(_$l, "__await") ? e.resolve(_$l.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$l).then(function(t) {
                            _$p.value = t, a(_$p);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function _(e, r, n) {
                var _$o = d;
                return function(i, a) {
                    if (_$o === y) throw new Error("Generator is already running");
                    if (_$o === v) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = P(c, n);
                            if (s) {
                                if (s === _$g) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === d) throw _$o = v, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = y;
                        var u = h(e, r, n);
                        if ("normal" === u.type) {
                            if (_$o = n.done ? v : m, u.arg === _$g) continue;
                            return {
                                value: u.arg,
                                done: n.done
                            };
                        }
                        "throw" === u.type && (_$o = v, n.method = "throw", n.arg = u.arg);
                    }
                };
            }
            function P(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), _$g;
                var i = h(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, _$g;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, _$g) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, _$g);
            }
            function A(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function T(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function D(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(A, this), this.reset(!0);
            }
            function L(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(u(e) + " is not iterable");
            }
            return x.prototype = w, _$o(O, "constructor", {
                value: w,
                configurable: !0
            }), _$o(w, "constructor", {
                value: x,
                configurable: !0
            }), x.displayName = l(w, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === x || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, l(t, s, "GeneratorFunction")), t.prototype = Object.create(O), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, j(F.prototype), l(F.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = F, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new F(f(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, j(O), l(O, s, "Generator"), l(O, a, function() {
                return this;
            }), l(O, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = L, D.prototype = {
                constructor: D,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(T), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), u = n.call(a, "finallyLoc");
                            if (s && u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, _$g) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), _$g;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), T(_$r), _$g;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                T(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: L(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), _$g;
                }
            }, _$e;
        }
        var m = function() {
            function t() {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.endOfStream = !1, this.interrupted = !1, this.peekQueue = [];
            }
            var _$e, _$r, _$o, i, a;
            return _$e = t, _$r = [
                {
                    key: "peek",
                    value: (a = f(p().mark(function t(e) {
                        var _$r, n, _$o = arguments;
                        return p().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return _$r = _$o.length > 1 && void 0 !== _$o[1] && _$o[1], t.next = 3, this.read(e, _$r);
                                case 3:
                                    return n = t.sent, this.peekQueue.push(e.subarray(0, n)), t.abrupt("return", n);
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return a.apply(this, arguments);
                    })
                },
                {
                    key: "read",
                    value: (i = f(p().mark(function t(e) {
                        var _$r, _$o, i = arguments;
                        return p().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (_$r = i.length > 1 && void 0 !== i[1] && i[1], 0 !== e.length) {
                                        t.next = 3;
                                        break;
                                    }
                                    return t.abrupt("return", 0);
                                case 3:
                                    if (_$o = this.readFromPeekBuffer(e), this.endOfStream) {
                                        t.next = 9;
                                        break;
                                    }
                                    return t.t0 = _$o, t.next = 8, this.readRemainderFromStream(e.subarray(_$o), _$r);
                                case 8:
                                    _$o = t.t0 += t.sent;
                                case 9:
                                    if (0 !== _$o || _$r) {
                                        t.next = 11;
                                        break;
                                    }
                                    throw new n.d1;
                                case 11:
                                    return t.abrupt("return", _$o);
                                case 12:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "readFromPeekBuffer",
                    value: function value(t) {
                        for(var _$e = t.length, _$r = 0; this.peekQueue.length > 0 && _$e > 0;){
                            var n = this.peekQueue.pop();
                            if (!n) throw new Error("peekData should be defined");
                            var _$o = Math.min(n.length, _$e);
                            t.set(n.subarray(0, _$o), _$r), _$r += _$o, _$e -= _$o, _$o < n.length && this.peekQueue.push(n.subarray(_$o));
                        }
                        return _$r;
                    }
                },
                {
                    key: "readRemainderFromStream",
                    value: (_$o = f(p().mark(function t(e, r) {
                        var _$o, i;
                        return p().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    _$o = 0;
                                case 1:
                                    if (!(_$o < e.length) || this.endOfStream) {
                                        t.next = 12;
                                        break;
                                    }
                                    if (!this.interrupted) {
                                        t.next = 4;
                                        break;
                                    }
                                    throw new n.lc;
                                case 4:
                                    return t.next = 6, this.readFromStream(e.subarray(_$o), r);
                                case 6:
                                    if (0 !== (i = t.sent)) {
                                        t.next = 9;
                                        break;
                                    }
                                    return t.abrupt("break", 12);
                                case 9:
                                    _$o += i, t.next = 1;
                                    break;
                                case 12:
                                    if (r || !(_$o < e.length)) {
                                        t.next = 14;
                                        break;
                                    }
                                    throw new n.d1;
                                case 14:
                                    return t.abrupt("return", _$o);
                                case 15:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return _$o.apply(this, arguments);
                    })
                }
            ], _$r && h(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        function y(t) {
            return y = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function y(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, y(t);
        }
        function v() {
            v = function v() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof b ? e : b, a = Object.create(i.prototype), c = new D(n || []);
                return _$o(a, "_invoke", {
                    value: _(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", _$g = {};
            function b() {}
            function x() {}
            function w() {}
            var k = {};
            u(k, a, function() {
                return this;
            });
            var S = Object.getPrototypeOf, E = S && S(S(L([])));
            E && E !== _$r && n.call(E, a) && (k = E);
            var O = w.prototype = b.prototype = Object.create(k);
            function j(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function F(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == y(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function _(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = P(c, n);
                            if (s) {
                                if (s === _$g) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === _$g) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function P(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), _$g;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, _$g;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, _$g) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, _$g);
            }
            function A(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function T(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function D(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(A, this), this.reset(!0);
            }
            function L(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(y(e) + " is not iterable");
            }
            return x.prototype = w, _$o(O, "constructor", {
                value: w,
                configurable: !0
            }), _$o(w, "constructor", {
                value: x,
                configurable: !0
            }), x.displayName = u(w, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === x || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, u(t, s, "GeneratorFunction")), t.prototype = Object.create(O), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, j(F.prototype), u(F.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = F, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new F(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, j(O), u(O, s, "Generator"), u(O, a, function() {
                return this;
            }), u(O, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = L, D.prototype = {
                constructor: D,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(T), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, _$g) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), _$g;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), T(_$r), _$g;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                T(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: L(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), _$g;
                }
            }, _$e;
        }
        function k(t, e) {
            return k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function k(t, e) {
                return t.__proto__ = e, t;
            }, k(t, e);
        }
        function S(t) {
            return S = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function S(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, S(t);
        }
        var E = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && k(t, e);
            }(l, t);
            var _$e, _$r, _$o, i, a, c, u, p = (c = l, u = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function p() {
                var _$t, _$e = S(c);
                if (u) {
                    var _$r = S(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === y(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function l(t) {
                var _$e;
                if (function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, l), (_$e = p.call(this)).s = t, _$e.deferred = null, !t.read || !t.once) throw new Error("Expected an instance of stream.Readable");
                return _$e.s.once("end", function() {
                    _$e.endOfStream = !0, _$e.deferred && _$e.deferred.resolve(0);
                }), _$e.s.once("error", function(t) {
                    return _$e.reject(t);
                }), _$e.s.once("close", function() {
                    return _$e.abort();
                }), _$e;
            }
            return _$e = l, _$r = [
                {
                    key: "readFromStream",
                    value: (a = b(v().mark(function t(e, r) {
                        var n, _$o, i = this;
                        return v().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (0 !== e.length) {
                                        t.next = 2;
                                        break;
                                    }
                                    return t.abrupt("return", 0);
                                case 2:
                                    if (!(n = this.s.read(e.length))) {
                                        t.next = 6;
                                        break;
                                    }
                                    return e.set(n), t.abrupt("return", n.length);
                                case 6:
                                    return _$o = {
                                        buffer: e,
                                        mayBeLess: r,
                                        deferred: new s
                                    }, this.deferred = _$o.deferred, this.s.once("readable", function() {
                                        i.readDeferred(_$o);
                                    }), t.abrupt("return", _$o.deferred.promise);
                                case 10:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return a.apply(this, arguments);
                    })
                },
                {
                    key: "readDeferred",
                    value: function value(t) {
                        var _$e = this, _$r = this.s.read(t.buffer.length);
                        _$r ? (t.buffer.set(_$r), t.deferred.resolve(_$r.length), this.deferred = null) : this.s.once("readable", function() {
                            _$e.readDeferred(t);
                        });
                    }
                },
                {
                    key: "reject",
                    value: function value(t) {
                        this.interrupted = !0, this.deferred && (this.deferred.reject(t), this.deferred = null);
                    }
                },
                {
                    key: "abort",
                    value: (i = b(v().mark(function t() {
                        return v().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    this.reject(new n.lc);
                                case 1:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "close",
                    value: (_$o = b(v().mark(function t() {
                        return v().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.abrupt("return", this.abort());
                                case 1:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return _$o.apply(this, arguments);
                    })
                }
            ], _$r && x(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), l;
        }(m);
        function O(t) {
            return O = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function O(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, O(t);
        }
        function j() {
            j = function j() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new D(n || []);
                return _$o(a, "_invoke", {
                    value: _(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(L([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function F(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == O(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function _(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = P(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function P(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function A(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function T(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function D(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(A, this), this.reset(!0);
            }
            function L(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(O(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(F.prototype), u(F.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = F, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new F(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = L, D.prototype = {
                constructor: D,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(T), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), T(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                T(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: L(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function T(t, e) {
            return T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function T(t, e) {
                return t.__proto__ = e, t;
            }, T(t, e);
        }
        function D(t) {
            return D = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function D(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, D(t);
        }
        function L(t) {
            return L = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function L(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, L(t);
        }
        function C() {
            C = function C() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == L(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(L(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function R(t, e) {
            return R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function R(t, e) {
                return t.__proto__ = e, t;
            }, R(t, e);
        }
        function M(t) {
            return M = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function M(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, M(t);
        }
        var B = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && R(t, e);
            }(s, t);
            var _$e, _$r, n, _$o, i, a, c = (i = s, a = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function c() {
                var _$t, _$e = M(i);
                if (a) {
                    var _$r = M(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === L(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function s() {
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, s), c.apply(this, arguments);
            }
            return _$e = s, _$r = [
                {
                    key: "readFromStream",
                    value: (n = C().mark(function t(e, r) {
                        var n;
                        return C().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (0 !== e.length) {
                                        t.next = 2;
                                        break;
                                    }
                                    return t.abrupt("return", 0);
                                case 2:
                                    return t.next = 4, this.reader.read(new Uint8Array(e.length), {
                                        min: r ? void 0 : e.length
                                    });
                                case 4:
                                    if ((n = t.sent).done && (this.endOfStream = n.done), !n.value) {
                                        t.next = 9;
                                        break;
                                    }
                                    return e.set(n.value), t.abrupt("return", n.value.length);
                                case 9:
                                    return t.abrupt("return", 0);
                                case 10:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    }), _$o = function o() {
                        var _$t = this, _$e = arguments;
                        return new Promise(function(r, o) {
                            var i = n.apply(_$t, _$e);
                            function a(t) {
                                I(i, r, o, a, c, "next", t);
                            }
                            function c(t) {
                                I(i, r, o, a, c, "throw", t);
                            }
                            a(void 0);
                        });
                    }, function(t, e) {
                        return _$o.apply(this, arguments);
                    })
                }
            ], _$r && z(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), s;
        }(function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && T(t, e);
            }(s, t);
            var _$e, _$r, n, _$o, i, a, c = (i = s, a = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function c() {
                var _$t, _$e = D(i);
                if (a) {
                    var _$r = D(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === O(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function s(t) {
                var _$e;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, s), (_$e = c.call(this)).reader = t, _$e;
            }
            return _$e = s, _$r = [
                {
                    key: "abort",
                    value: (_$o = _(j().mark(function t() {
                        return j().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.abrupt("return", this.close());
                                case 1:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "close",
                    value: (n = _(j().mark(function t() {
                        return j().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    this.reader.releaseLock();
                                case 1:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return n.apply(this, arguments);
                    })
                }
            ], _$r && P(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), s;
        }(m));
        function U(t) {
            return U = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function U(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, U(t);
        }
        function q() {
            q = function q() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == U(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(U(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function H(t, e) {
            return H = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function H(t, e) {
                return t.__proto__ = e, t;
            }, H(t, e);
        }
        function Y(t) {
            return Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function Y(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, Y(t);
        }
        var W = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && H(t, e);
            }(u, t);
            var _$e, _$r, _$o, i, a, c, s = (a = u, c = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function s() {
                var _$t, _$e = Y(a);
                if (c) {
                    var _$r = Y(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === U(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function u(t) {
                var _$e;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (_$e = s.call(this)).reader = t, _$e.buffer = null, _$e;
            }
            return _$e = u, _$r = [
                {
                    key: "writeChunk",
                    value: function value(t, e) {
                        var _$r = Math.min(e.length, t.length);
                        return t.set(e.subarray(0, _$r)), _$r < e.length ? this.buffer = e.subarray(_$r) : this.buffer = null, _$r;
                    }
                },
                {
                    key: "readFromStream",
                    value: (i = $(q().mark(function t(e, r) {
                        var _$o, i;
                        return q().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (0 !== e.length) {
                                        t.next = 2;
                                        break;
                                    }
                                    return t.abrupt("return", 0);
                                case 2:
                                    _$o = 0, this.buffer && (_$o += this.writeChunk(e, this.buffer));
                                case 4:
                                    if (!(_$o < e.length) || this.endOfStream) {
                                        t.next = 14;
                                        break;
                                    }
                                    return t.next = 7, this.reader.read();
                                case 7:
                                    if (!(i = t.sent).done) {
                                        t.next = 11;
                                        break;
                                    }
                                    return this.endOfStream = !0, t.abrupt("break", 14);
                                case 11:
                                    i.value && (_$o += this.writeChunk(e.subarray(_$o), i.value)), t.next = 4;
                                    break;
                                case 14:
                                    if (r || 0 !== _$o || !this.endOfStream) {
                                        t.next = 16;
                                        break;
                                    }
                                    throw new n.d1;
                                case 16:
                                    return t.abrupt("return", _$o);
                                case 17:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "abort",
                    value: function value() {
                        return this.interrupted = !0, this.reader.cancel();
                    }
                },
                {
                    key: "close",
                    value: (_$o = $(q().mark(function t() {
                        return q().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.abort();
                                case 2:
                                    this.reader.releaseLock();
                                case 3:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return _$o.apply(this, arguments);
                    })
                }
            ], _$r && Z(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), u;
        }(m);
        function K(t) {
            return K = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function K(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, K(t);
        }
        function X() {
            X = function X() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == K(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(K(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        var ot = function() {
            function t(e) {
                var _$r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.numBuffer = new Uint8Array(8), this.position = 0, this.onClose = null == e ? void 0 : e.onClose, null != e && e.abortSignal && e.abortSignal.addEventListener("abort", function() {
                    _$r.abort();
                });
            }
            var _$e, _$r, _$o, i, a, c, s, u;
            return _$e = t, _$r = [
                {
                    key: "readToken",
                    value: (u = et(X().mark(function t(e) {
                        var _$r, _$o, i = arguments;
                        return X().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return _$r = i.length > 1 && void 0 !== i[1] ? i[1] : this.position, _$o = new Uint8Array(e.len), t.next = 4, this.readBuffer(_$o, {
                                        position: _$r
                                    });
                                case 4:
                                    if (!(t.sent < e.len)) {
                                        t.next = 7;
                                        break;
                                    }
                                    throw new n.d1;
                                case 7:
                                    return t.abrupt("return", e.get(_$o, 0));
                                case 8:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return u.apply(this, arguments);
                    })
                },
                {
                    key: "peekToken",
                    value: (s = et(X().mark(function t(e) {
                        var _$r, _$o, i = arguments;
                        return X().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return _$r = i.length > 1 && void 0 !== i[1] ? i[1] : this.position, _$o = new Uint8Array(e.len), t.next = 4, this.peekBuffer(_$o, {
                                        position: _$r
                                    });
                                case 4:
                                    if (!(t.sent < e.len)) {
                                        t.next = 7;
                                        break;
                                    }
                                    throw new n.d1;
                                case 7:
                                    return t.abrupt("return", e.get(_$o, 0));
                                case 8:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return s.apply(this, arguments);
                    })
                },
                {
                    key: "readNumber",
                    value: (c = et(X().mark(function t(e) {
                        return X().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.readBuffer(this.numBuffer, {
                                        length: e.len
                                    });
                                case 2:
                                    if (!(t.sent < e.len)) {
                                        t.next = 5;
                                        break;
                                    }
                                    throw new n.d1;
                                case 5:
                                    return t.abrupt("return", e.get(this.numBuffer, 0));
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return c.apply(this, arguments);
                    })
                },
                {
                    key: "peekNumber",
                    value: (a = et(X().mark(function t(e) {
                        return X().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.peekBuffer(this.numBuffer, {
                                        length: e.len
                                    });
                                case 2:
                                    if (!(t.sent < e.len)) {
                                        t.next = 5;
                                        break;
                                    }
                                    throw new n.d1;
                                case 5:
                                    return t.abrupt("return", e.get(this.numBuffer, 0));
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return a.apply(this, arguments);
                    })
                },
                {
                    key: "ignore",
                    value: (i = et(X().mark(function t(e) {
                        var _$r;
                        return X().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (!(e < 0)) {
                                        t.next = 2;
                                        break;
                                    }
                                    throw new RangeError("ignore length must be \u2265 0 bytes");
                                case 2:
                                    if (void 0 === this.fileInfo.size) {
                                        t.next = 7;
                                        break;
                                    }
                                    if (_$r = this.fileInfo.size - this.position, !(e > _$r)) {
                                        t.next = 7;
                                        break;
                                    }
                                    return this.position += _$r, t.abrupt("return", _$r);
                                case 7:
                                    return this.position += e, t.abrupt("return", e);
                                case 9:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "close",
                    value: (_$o = et(X().mark(function t() {
                        var _$e;
                        return X().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.next = 2, this.abort();
                                case 2:
                                    return t.next = 4, null === (_$e = this.onClose) || void 0 === _$e ? void 0 : _$e.call(this);
                                case 4:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "normalizeOptions",
                    value: function value(t, e) {
                        if (!this.supportsRandomAccess() && e && void 0 !== e.position && e.position < this.position) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
                        return J(J({}, {
                            mayBeLess: !1,
                            offset: 0,
                            length: t.length,
                            position: this.position
                        }), e);
                    }
                },
                {
                    key: "abort",
                    value: function value() {
                        return Promise.resolve();
                    }
                }
            ], _$r && rt(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), t;
        }();
        function it(t) {
            return it = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function it(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, it(t);
        }
        function at() {
            at = function at() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == it(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(it(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function lt(t, e) {
            return lt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function lt(t, e) {
                return t.__proto__ = e, t;
            }, lt(t, e);
        }
        function ft(t) {
            return ft = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function ft(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, ft(t);
        }
        var ht = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && lt(t, e);
            }(l, t);
            var _$e, _$r, _$o, i, a, c, s, u, p = (s = l, u = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function p() {
                var _$t, _$e = ft(s);
                if (u) {
                    var _$r = ft(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === it(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function l(t, e) {
                var _$r, n;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, l), (n = p.call(this, e)).streamReader = t, n.fileInfo = null !== (_$r = null == e ? void 0 : e.fileInfo) && void 0 !== _$r ? _$r : {}, n;
            }
            return _$e = l, _$r = [
                {
                    key: "readBuffer",
                    value: (c = st(at().mark(function t(e, r) {
                        var _$o, i, a;
                        return at().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (_$o = this.normalizeOptions(e, r), !((i = _$o.position - this.position) > 0)) {
                                        t.next = 6;
                                        break;
                                    }
                                    return t.next = 5, this.ignore(i);
                                case 5:
                                    return t.abrupt("return", this.readBuffer(e, r));
                                case 6:
                                    if (!(i < 0)) {
                                        t.next = 8;
                                        break;
                                    }
                                    throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
                                case 8:
                                    if (0 !== _$o.length) {
                                        t.next = 10;
                                        break;
                                    }
                                    return t.abrupt("return", 0);
                                case 10:
                                    return t.next = 12, this.streamReader.read(e.subarray(0, _$o.length), _$o.mayBeLess);
                                case 12:
                                    if (a = t.sent, this.position += a, r && r.mayBeLess || !(a < _$o.length)) {
                                        t.next = 16;
                                        break;
                                    }
                                    throw new n.d1;
                                case 16:
                                    return t.abrupt("return", a);
                                case 17:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return c.apply(this, arguments);
                    })
                },
                {
                    key: "peekBuffer",
                    value: (a = st(at().mark(function t(e, r) {
                        var _$o, i, a, c;
                        return at().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (_$o = this.normalizeOptions(e, r), i = 0, !_$o.position) {
                                        t.next = 13;
                                        break;
                                    }
                                    if (!((a = _$o.position - this.position) > 0)) {
                                        t.next = 11;
                                        break;
                                    }
                                    return c = new Uint8Array(_$o.length + a), t.next = 8, this.peekBuffer(c, {
                                        mayBeLess: _$o.mayBeLess
                                    });
                                case 8:
                                    return i = t.sent, e.set(c.subarray(a)), t.abrupt("return", i - a);
                                case 11:
                                    if (!(a < 0)) {
                                        t.next = 13;
                                        break;
                                    }
                                    throw new Error("Cannot peek from a negative offset in a stream");
                                case 13:
                                    if (!(_$o.length > 0)) {
                                        t.next = 27;
                                        break;
                                    }
                                    return t.prev = 14, t.next = 17, this.streamReader.peek(e.subarray(0, _$o.length), _$o.mayBeLess);
                                case 17:
                                    i = t.sent, t.next = 25;
                                    break;
                                case 20:
                                    if (t.prev = 20, t.t0 = t["catch"](14), !(null != r && r.mayBeLess && t.t0 instanceof n.d1)) {
                                        t.next = 24;
                                        break;
                                    }
                                    return t.abrupt("return", 0);
                                case 24:
                                    throw t.t0;
                                case 25:
                                    if (_$o.mayBeLess || !(i < _$o.length)) {
                                        t.next = 27;
                                        break;
                                    }
                                    throw new n.d1;
                                case 27:
                                    return t.abrupt("return", i);
                                case 28:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this, [
                            [
                                14,
                                20
                            ]
                        ]);
                    })), function(t, e) {
                        return a.apply(this, arguments);
                    })
                },
                {
                    key: "ignore",
                    value: (i = st(at().mark(function t(e) {
                        var _$r, n, _$o, i, a;
                        return at().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (!(e < 0)) {
                                        t.next = 2;
                                        break;
                                    }
                                    throw new RangeError("ignore length must be \u2265 0 bytes");
                                case 2:
                                    _$r = Math.min(256e3, e), n = new Uint8Array(_$r), _$o = 0;
                                case 5:
                                    if (!(_$o < e)) {
                                        t.next = 15;
                                        break;
                                    }
                                    return i = e - _$o, t.next = 9, this.readBuffer(n, {
                                        length: Math.min(_$r, i)
                                    });
                                case 9:
                                    if (!((a = t.sent) < 0)) {
                                        t.next = 12;
                                        break;
                                    }
                                    return t.abrupt("return", a);
                                case 12:
                                    _$o += a, t.next = 5;
                                    break;
                                case 15:
                                    return t.abrupt("return", _$o);
                                case 16:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "abort",
                    value: function value() {
                        return this.streamReader.abort();
                    }
                },
                {
                    key: "close",
                    value: (_$o = st(at().mark(function t() {
                        return at().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return t.abrupt("return", this.streamReader.close());
                                case 1:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function() {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "supportsRandomAccess",
                    value: function value() {
                        return !1;
                    }
                }
            ], _$r && ut(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), l;
        }(ot);
        function dt(t) {
            return dt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function dt(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, dt(t);
        }
        function mt() {
            mt = function mt() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == dt(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(dt(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function kt() {
            return kt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function kt(t, e, r) {
                var n = function(t, e) {
                    for(; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Et(t)););
                    return t;
                }(t, e);
                if (n) {
                    var _$o = Object.getOwnPropertyDescriptor(n, e);
                    return _$o.get ? _$o.get.call(arguments.length < 3 ? t : r) : _$o.value;
                }
            }, kt.apply(this, arguments);
        }
        function St(t, e) {
            return St = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function St(t, e) {
                return t.__proto__ = e, t;
            }, St(t, e);
        }
        function Et(t) {
            return Et = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function Et(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, Et(t);
        }
        var Ot = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && St(t, e);
            }(u, t);
            var _$e, _$r, _$o, i, a, c, s = (a = u, c = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function s() {
                var _$t, _$e = Et(a);
                if (c) {
                    var _$r = Et(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === dt(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function u(t, e) {
                var _$r, n;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (n = s.call(this, e)).uint8Array = t, n.fileInfo = bt(bt({}, null !== (_$r = null == e ? void 0 : e.fileInfo) && void 0 !== _$r ? _$r : {}), {
                    size: t.length
                }), n;
            }
            return _$e = u, _$r = [
                {
                    key: "readBuffer",
                    value: (i = vt(mt().mark(function t(e, r) {
                        var n;
                        return mt().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return null != r && r.position && (this.position = r.position), t.next = 3, this.peekBuffer(e, r);
                                case 3:
                                    return n = t.sent, this.position += n, t.abrupt("return", n);
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "peekBuffer",
                    value: (_$o = vt(mt().mark(function t(e, r) {
                        var _$o, i;
                        return mt().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (_$o = this.normalizeOptions(e, r), i = Math.min(this.uint8Array.length - _$o.position, _$o.length), _$o.mayBeLess || !(i < _$o.length)) {
                                        t.next = 4;
                                        break;
                                    }
                                    throw new n.d1;
                                case 4:
                                    return e.set(this.uint8Array.subarray(_$o.position, _$o.position + i)), t.abrupt("return", i);
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "close",
                    value: function value() {
                        return kt(Et(u.prototype), "close", this).call(this);
                    }
                },
                {
                    key: "supportsRandomAccess",
                    value: function value() {
                        return !0;
                    }
                },
                {
                    key: "setPosition",
                    value: function value(t) {
                        this.position = t;
                    }
                }
            ], _$r && xt(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), u;
        }(ot);
        function jt(t) {
            return jt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function jt(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, jt(t);
        }
        function Ft() {
            Ft = function Ft() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == jt(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(jt(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
        function Ct() {
            return Ct = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function Ct(t, e, r) {
                var n = function(t, e) {
                    for(; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = zt(t)););
                    return t;
                }(t, e);
                if (n) {
                    var _$o = Object.getOwnPropertyDescriptor(n, e);
                    return _$o.get ? _$o.get.call(arguments.length < 3 ? t : r) : _$o.value;
                }
            }, Ct.apply(this, arguments);
        }
        function It(t, e) {
            return It = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function It(t, e) {
                return t.__proto__ = e, t;
            }, It(t, e);
        }
        function zt(t) {
            return zt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function zt(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, zt(t);
        }
        var Nt = function(t) {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && It(t, e);
            }(u, t);
            var _$e, _$r, _$o, i, a, c, s = (a = u, c = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function s() {
                var _$t, _$e = zt(a);
                if (c) {
                    var _$r = zt(this).constructor;
                    _$t = Reflect.construct(_$e, arguments, _$r);
                } else _$t = _$e.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === jt(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, _$t);
            });
            function u(t, e) {
                var _$r, n;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (n = s.call(this, e)).blob = t, n.fileInfo = Tt(Tt({}, null !== (_$r = null == e ? void 0 : e.fileInfo) && void 0 !== _$r ? _$r : {}), {
                    size: t.size,
                    mimeType: t.type
                }), n;
            }
            return _$e = u, _$r = [
                {
                    key: "readBuffer",
                    value: (i = Pt(Ft().mark(function t(e, r) {
                        var n;
                        return Ft().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return null != r && r.position && (this.position = r.position), t.next = 3, this.peekBuffer(e, r);
                                case 3:
                                    return n = t.sent, this.position += n, t.abrupt("return", n);
                                case 6:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return i.apply(this, arguments);
                    })
                },
                {
                    key: "peekBuffer",
                    value: (_$o = Pt(Ft().mark(function t(e, r) {
                        var _$o, i, a;
                        return Ft().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    if (_$o = this.normalizeOptions(e, r), i = Math.min(this.blob.size - _$o.position, _$o.length), _$o.mayBeLess || !(i < _$o.length)) {
                                        t.next = 4;
                                        break;
                                    }
                                    throw new n.d1;
                                case 4:
                                    return t.next = 6, this.blob.slice(_$o.position, _$o.position + i).arrayBuffer();
                                case 6:
                                    return a = t.sent, e.set(new Uint8Array(a)), t.abrupt("return", i);
                                case 9:
                                case "end":
                                    return t.stop();
                            }
                        }, t, this);
                    })), function(t, e) {
                        return _$o.apply(this, arguments);
                    })
                },
                {
                    key: "close",
                    value: function value() {
                        return Ct(zt(u.prototype), "close", this).call(this);
                    }
                },
                {
                    key: "supportsRandomAccess",
                    value: function value() {
                        return !0;
                    }
                },
                {
                    key: "setPosition",
                    value: function value(t) {
                        this.position = t;
                    }
                }
            ], _$r && Dt(_$e.prototype, _$r), Object.defineProperty(_$e, "prototype", {
                writable: !1
            }), u;
        }(ot);
        function Rt(t) {
            return Rt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function Rt(t) {
                return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
            }, Rt(t);
        }
        function Mt() {
            Mt = function Mt() {
                return _$e;
            };
            var t, _$e = {}, _$r = Object.prototype, n = _$r.hasOwnProperty, _$o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
            function u(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                u({}, "");
            } catch (t) {
                u = function u(t, e, r) {
                    return t[e] = r;
                };
            }
            function p(t, e, r, n) {
                var i = e && e.prototype instanceof v ? e : v, a = Object.create(i.prototype), c = new A(n || []);
                return _$o(a, "_invoke", {
                    value: j(t, r, c)
                }), a;
            }
            function l(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            _$e.wrap = p;
            var f = "suspendedStart", h = "suspendedYield", d = "executing", m = "completed", y = {};
            function v() {}
            function g() {}
            function b() {}
            var x = {};
            u(x, a, function() {
                return this;
            });
            var w = Object.getPrototypeOf, k = w && w(w(T([])));
            k && k !== _$r && n.call(k, a) && (x = k);
            var S = b.prototype = v.prototype = Object.create(x);
            function E(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    u(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function O(t, e) {
                function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                        var _$u = s.arg, _$p = _$u.value;
                        return _$p && "object" == Rt(_$p) && n.call(_$p, "__await") ? e.resolve(_$p.__await).then(function(t) {
                            r("next", t, a, c);
                        }, function(t) {
                            r("throw", t, a, c);
                        }) : e.resolve(_$p).then(function(t) {
                            _$u.value = t, a(_$u);
                        }, function(t) {
                            return r("throw", t, a, c);
                        });
                    }
                    c(s.arg);
                }
                var i;
                _$o(this, "_invoke", {
                    value: function value(t, n) {
                        function o() {
                            return new e(function(e, o) {
                                r(t, n, e, o);
                            });
                        }
                        return i = i ? i.then(o, o) : o();
                    }
                });
            }
            function j(e, r, n) {
                var _$o = f;
                return function(i, a) {
                    if (_$o === d) throw new Error("Generator is already running");
                    if (_$o === m) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var s = F(c, n);
                            if (s) {
                                if (s === y) continue;
                                return s;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (_$o === f) throw _$o = m, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        _$o = d;
                        var _$u = l(e, r, n);
                        if ("normal" === _$u.type) {
                            if (_$o = n.done ? m : h, _$u.arg === y) continue;
                            return {
                                value: _$u.arg,
                                done: n.done
                            };
                        }
                        "throw" === _$u.type && (_$o = m, n.method = "throw", n.arg = _$u.arg);
                    }
                };
            }
            function F(e, r) {
                var n = r.method, _$o = e.iterator[n];
                if (_$o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, F(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = l(_$o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function _(t) {
                var _$e = {
                    tryLoc: t[0]
                };
                1 in t && (_$e.catchLoc = t[1]), 2 in t && (_$e.finallyLoc = t[2], _$e.afterLoc = t[3]), this.tryEntries.push(_$e);
            }
            function P(t) {
                var _$e = t.completion || {};
                _$e.type = "normal", delete _$e.arg, t.completion = _$e;
            }
            function A(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(_, this), this.reset(!0);
            }
            function T(e) {
                if (e || "" === e) {
                    var _$r = e[a];
                    if (_$r) return _$r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var _$o = -1, i = function r() {
                            for(; ++_$o < e.length;)if (n.call(e, _$o)) return r.value = e[_$o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(Rt(e) + " is not iterable");
            }
            return g.prototype = b, _$o(S, "constructor", {
                value: b,
                configurable: !0
            }), _$o(b, "constructor", {
                value: g,
                configurable: !0
            }), g.displayName = u(b, s, "GeneratorFunction"), _$e.isGeneratorFunction = function(t) {
                var _$e = "function" == typeof t && t.constructor;
                return !!_$e && (_$e === g || "GeneratorFunction" === (_$e.displayName || _$e.name));
            }, _$e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
            }, _$e.awrap = function(t) {
                return {
                    __await: t
                };
            }, E(O.prototype), u(O.prototype, c, function() {
                return this;
            }), _$e.AsyncIterator = O, _$e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new O(p(t, r, n, o), i);
                return _$e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, E(S), u(S, s, "Generator"), u(S, a, function() {
                return this;
            }), u(S, "toString", function() {
                return "[object Generator]";
            }), _$e.keys = function(t) {
                var _$e = Object(t), _$r = [];
                for(var n in _$e)_$r.push(n);
                return _$r.reverse(), function t() {
                    for(; _$r.length;){
                        var n = _$r.pop();
                        if (n in _$e) return t.value = n, t.done = !1, t;
                    }
                    return t.done = !0, t;
                };
            }, _$e.values = T, A.prototype = {
                constructor: A,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(P), !e) for(var _$r in this)"t" === _$r.charAt(0) && n.call(this, _$r) && !isNaN(+_$r.slice(1)) && (this[_$r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var _$r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, _$r.next = n, o && (_$r.method = "next", _$r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var s = n.call(a, "catchLoc"), _$u = n.call(a, "finallyLoc");
                            if (s && _$u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!_$u) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var _$r = this.tryEntries.length - 1; _$r >= 0; --_$r){
                        var _$o = this.tryEntries[_$r];
                        if (_$o.tryLoc <= this.prev && n.call(_$o, "finallyLoc") && this.prev < _$o.finallyLoc) {
                            var i = _$o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.finallyLoc === t) return this.complete(_$r.completion, _$r.afterLoc), P(_$r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var _$e = this.tryEntries.length - 1; _$e >= 0; --_$e){
                        var _$r = this.tryEntries[_$e];
                        if (_$r.tryLoc === t) {
                            var n = _$r.completion;
                            if ("throw" === n.type) {
                                var _$o = n.arg;
                                P(_$r);
                            }
                            return _$o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: T(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, _$e;
        }
    }
}, n = {};
function o(t) {
    var e = n[t];
    if (void 0 !== e) return e.exports;
    var i = n[t] = {
        id: t,
        loaded: !1,
        exports: {}
    };
    return r[t].call(i.exports, i, i.exports, o), i.loaded = !0, i.exports;
}
o.amdO = {}, o.n = function(t) {
    var e = t && t.__esModule ? function() {
        return t["default"];
    } : function() {
        return t;
    };
    return o.d(e, {
        a: e
    }), e;
}, e = Object.getPrototypeOf ? function(t) {
    return Object.getPrototypeOf(t);
} : function(t) {
    return t.__proto__;
}, o.t = function(r, n) {
    if (1 & n && (r = this(r)), 8 & n) return r;
    if ("object" == (typeof r === "undefined" ? "undefined" : (0, $2xTNA._)(r)) && r) {
        if (4 & n && r.__esModule) return r;
        if (16 & n && "function" == typeof r.then) return r;
    }
    var i = Object.create(null);
    o.r(i);
    var a = {};
    t = t || [
        null,
        e({}),
        e([]),
        e(e)
    ];
    for(var c = 2 & n && r; "object" == (typeof c === "undefined" ? "undefined" : (0, $2xTNA._)(c)) && !~t.indexOf(c); c = e(c))Object.getOwnPropertyNames(c).forEach(function(t) {
        return a[t] = function() {
            return r[t];
        };
    });
    return a["default"] = function() {
        return r;
    }, o.d(i, a), i;
}, o.d = function(t, e) {
    for(var r in e)o.o(e, r) && !o.o(t, r) && Object.defineProperty(t, r, {
        enumerable: !0,
        get: e[r]
    });
}, o.g = function() {
    if ("object" == (typeof globalThis === "undefined" ? "undefined" : (0, $2xTNA._)(globalThis))) return globalThis;
    try {
        return this || new Function("return this")();
    } catch (t) {
        if ("object" == (typeof window === "undefined" ? "undefined" : (0, $2xTNA._)(window))) return window;
    }
}(), o.o = function(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
}, o.r = function(t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
    }), Object.defineProperty(t, "__esModule", {
        value: !0
    });
}, o.nmd = function(t) {
    return t.paths = [], t.children || (t.children = []), t;
};
var i = {};
function a(t) {
    return a = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function a(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, a(t);
}
o.d(i, {
    W3: function() {
        return xt;
    },
    Ew: function() {
        return At;
    },
    PK: function() {
        return kt;
    },
    Kj: function() {
        return Je;
    },
    Ay: function() {
        return jt;
    },
    Rl: function() {
        return Ft;
    },
    HD: function() {
        return ie;
    },
    FK: function() {
        return oe;
    },
    lX: function() {
        return me;
    },
    m5: function() {
        return ce;
    },
    Bj: function() {
        return le;
    },
    uK: function() {
        return fe;
    },
    Nx: function() {
        return ae;
    },
    Us: function() {
        return de;
    },
    uZ: function() {
        return ue;
    },
    X5: function() {
        return se;
    },
    wb: function() {
        return he;
    },
    zf: function() {
        return pe;
    },
    QS: function() {
        return ve;
    },
    ar: function() {
        return ge;
    },
    pg: function() {
        return be;
    },
    Pd: function() {
        return we;
    },
    Yq: function() {
        return ke;
    },
    zb: function() {
        return xe;
    },
    sz: function() {
        return ye;
    },
    WT: function() {
        return Rt;
    },
    XM: function() {
        return Ut;
    },
    rv: function() {
        return Xe;
    },
    p_: function() {
        return pt;
    },
    tm: function() {
        return st;
    },
    _7: function() {
        return wt;
    },
    hs: function() {
        return ee;
    },
    jC: function() {
        return Yt.j;
    },
    bK: function() {
        return Xt;
    },
    d1: function() {
        return te.d;
    },
    EK: function() {
        return te.E;
    },
    z: function() {
        return _t;
    },
    Hc: function() {
        return It;
    },
    VA: function() {
        return Et;
    },
    kX: function() {
        return We;
    },
    pv: function() {
        return Ge;
    },
    IO: function() {
        return St;
    },
    HQ: function() {
        return Pt;
    },
    s4: function() {
        return Ot;
    },
    QV: function() {
        return lt;
    },
    Dy: function() {
        return Dt;
    },
    rR: function() {
        return Lt;
    },
    IB: function() {
        return Ct;
    },
    yp: function() {
        return zt;
    },
    Lt: function() {
        return Nt;
    },
    Nu: function() {
        return Tt;
    },
    Ly: function() {
        return yt.b64;
    },
    SC: function() {
        return yt.cleanUpCallbacks;
    },
    Nr: function() {
        return yt.extensionToMime;
    },
    kJ: function() {
        return yt.filterObject;
    },
    vm: function() {
        return yt.getMimetype;
    },
    RK: function() {
        return l;
    },
    HF: function() {
        return yt.getVersion;
    },
    Ts: function() {
        return tr;
    },
    rB: function() {
        return yt.isFacebook;
    },
    Fr: function() {
        return yt.isMobile;
    },
    Fx: function() {
        return yt.md5;
    },
    ef: function() {
        return yt.removeEmpty;
    },
    T0: function() {
        return yt.resolveCdnUrl;
    },
    p0: function() {
        return yt.resolveHost;
    },
    rh: function() {
        return yt.sanitizeName;
    },
    pd: function() {
        return Ee;
    },
    NF: function() {
        return yt.uniqueId;
    },
    tp: function() {
        return yt.uniqueTime;
    },
    qB: function() {
        return f;
    },
    rE: function() {
        return er;
    }
});
var c = function(t) {
    var e = {};
    function r(n) {
        if (e[n]) return e[n].exports;
        var _$o = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(_$o.exports, _$o, _$o.exports, r), _$o.l = !0, _$o.exports;
    }
    return r.m = t, r.c = e, r.d = function(t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, r.t = function(t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == a(t) && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var _$o in t)r.d(n, _$o, (function(e) {
            return t[e];
        }).bind(null, _$o));
        return n;
    }, r.n = function(t) {
        var e = t && t.__esModule ? function e() {
            return t["default"];
        } : function() {
            return t;
        };
        return r.d(e, "a", e), e;
    }, r.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 0);
}([
    function(t, e, r) {
        r.r(e), r.d(e, "loadModules", function() {
            return s;
        }), r.d(e, "loadModule", function() {
            return u;
        }), r.d(e, "registerModule", function() {
            return p;
        }), r.d(e, "loadCss", function() {
            return l;
        }), r.d(e, "FILESTACK_MODULES", function() {
            return n;
        });
        var n, _$o = {}, i = function() {
            var t, _$e = (t = "undefined" == typeof window ? _$o : window).filestackInternals;
            return _$e || (_$e = {
                modules: {}
            }, t.filestackInternals = _$e), _$e.modules || (_$e.modules = {}), _$e;
        }(), a = i && i.modules, c = function c(t, e, r) {
            t.detachEvent ? t.detachEvent("onreadystatechange", e) : t.removeEventListener(r, e, !1);
        }, s = function s(t) {
            return Promise.all(t.map(function(t) {
                var _$e = t.id, _$r = t.url;
                return u(_$e, _$r);
            })).then(function(e) {
                var _$r = {};
                return e.forEach(function(e, n) {
                    var _$o = t[n];
                    _$r[_$o.id] = e;
                }), _$r;
            });
        }, u = function u(t, e) {
            if ("undefined" == typeof window) return Promise.reject(new Error("Load module is working only on browser env"));
            if (!t) throw new Error("Module id is required");
            var _$r = a[t = "fs-loader-" + t];
            return _$r || (a[t] = {}, _$r = a[t]), _$r.instance ? Promise.resolve(_$r.instance) : _$r.promise ? _$r.promise : _$r.promise = new Promise(function(r, n) {
                var _$o = function e(o) {
                    if ("load" === o.type || /^(complete|loaded)$/.test((o.currentTarget || o.srcElement).readyState)) {
                        var i = o.currentTarget || o.srcElement;
                        c(i, e, "load"), c(i, n, "error"), setTimeout(function() {
                            return r(a[t] ? a[t].instance : void 0);
                        }, 10);
                    }
                }, i = document.createElement("script");
                i.id = t, !i.attachEvent || i.attachEvent.toString && i.attachEvent.toString().indexOf("[native code") < 0 ? (i.addEventListener("load", _$o, !1), i.addEventListener("onerror", n, !1)) : i.attachEvent("onreadystatechange", _$o), i.setAttribute("crossorigin", "anonymous"), i.setAttribute("charset", "utf-8"), i.setAttribute("async", "true"), i.src = e, document.body.appendChild(i);
            });
        }, p = function p(t, e, r) {
            if ("undefined" != typeof window) {
                if (!t) throw new Error("Module id is required");
                if (!a) throw new Error("Loader is not initialized");
                a[t = "fs-loader-" + t] && (a[t] = {
                    instance: e,
                    metadata: r
                });
            }
        }, l = function l(t) {
            return null !== document.querySelector('link[href="'.concat(t, '"]')) ? Promise.resolve() : new Promise(function(e) {
                var _$r = document.getElementsByTagName("head")[0], n = document.createElement("link");
                n.rel = "stylesheet", n.href = t, n.addEventListener("load", function t() {
                    e(), n.removeEventListener("load", t);
                }), _$r.appendChild(n);
            });
        };
        !function(t) {
            t.FILESTACK_SDK = "filestack-sdk", t.TRANSFORMS_UI = "transforms-ui", t.PICKER = "picker";
        }(n || (n = {}));
    }
]), s = (c.loadModules, c.loadModule), u = c.registerModule, p = (c.loadCss, c.FILESTACK_MODULES), l = function l(t, e) {
    throw new Error("getSecurity is only supported in nodejs");
}, f = function f(t, e, r) {
    throw new Error("validateWebhookSignature is only supported in nodejs");
}, h = o(1635), d = o(6274);
var m = d;
var y = "8.55.0", v = globalThis;
function g(t, e, r) {
    var n = r || v, _$o = n.__SENTRY__ = n.__SENTRY__ || {}, i = _$o[y] = _$o[y] || {};
    return i[t] || (i[t] = e());
}
function b() {
    return x(v), v;
}
function x(t) {
    var e = t.__SENTRY__ = t.__SENTRY__ || {};
    return e.version = e.version || y, e[y] = e[y] || {};
}
function w() {
    return Date.now() / 1e3;
}
var k = function() {
    var t = v.performance;
    if (!t || !t.now) return w;
    var e = Date.now() - t.now(), r = null == t.timeOrigin ? e : t.timeOrigin;
    return function() {
        return (r + t.now()) / 1e3;
    };
}();
function S() {
    var t = v, e = t.crypto || t.msCrypto, r = function r() {
        return 16 * Math.random();
    };
    try {
        if (e && e.randomUUID) return e.randomUUID().replace(/-/g, "");
        e && e.getRandomValues && (r = function r() {
            var t = new Uint8Array(1);
            return e.getRandomValues(t), t[0];
        });
    } catch (t) {}
    return "10000000100040008000100000000000".replace(/[018]/g, function(t) {
        return (t ^ (15 & r()) >> t / 4).toString(16);
    });
}
!function() {
    var t = v.performance;
    if (t && t.now) {
        var e = 36e5, r = t.now(), n = Date.now(), _$o = t.timeOrigin ? Math.abs(t.timeOrigin + r - n) : e, i = _$o < e, a = t.timing && t.timing.navigationStart, c = "number" == typeof a ? Math.abs(a + r - n) : e;
        (i || c < e) && _$o <= c && t.timeOrigin;
    }
}();
var E = Object.prototype.toString;
function O(t) {
    return function(t, e) {
        return E.call(t) === "[object ".concat(e, "]");
    }(t, "Object");
}
var j = "undefined" == typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__, F = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
], _ = {};
function P(t) {
    if (!("console" in v)) return t();
    var e = v.console, r = {}, n = Object.keys(_);
    n.forEach(function(t) {
        var n = _[t];
        r[t] = e[t], e[t] = n;
    });
    try {
        return t();
    } finally{
        n.forEach(function(t) {
            e[t] = r[t];
        });
    }
}
var A = g("logger", function() {
    var t = !1, e = {
        enable: function enable() {
            t = !0;
        },
        disable: function disable() {
            t = !1;
        },
        isEnabled: function isEnabled() {
            return t;
        }
    };
    return j ? F.forEach(function(r) {
        e[r] = function() {
            for(var e = arguments.length, n = new Array(e), _$o = 0; _$o < e; _$o++)n[_$o] = arguments[_$o];
            t && P(function() {
                var t;
                (t = v.console)[r].apply(t, [
                    "".concat("Sentry Logger ", "[").concat(r, "]:")
                ].concat(n));
            });
        };
    }) : F.forEach(function(t) {
        e[t] = function() {};
    }), e;
});
function T() {
    return S();
}
function D() {
    return S().substring(16);
}
function L(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
    }
    return r;
}
function C(t, e, r) {
    var n;
    return n = function(t) {
        if ("object" != I(t) || !t) return t;
        var _$e = t[Symbol.toPrimitive];
        if (void 0 !== _$e) {
            var _$r = _$e.call(t, "string");
            if ("object" != I(_$r)) return _$r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
    }(e), (e = "symbol" == I(n) ? n : String(n)) in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = r, t;
}
function I(t) {
    return I = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function I(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, I(t);
}
function z(t, e) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
    if (!e || "object" !== I(e) || r <= 0) return e;
    if (t && e && 0 === Object.keys(e).length) return t;
    var n = function(t) {
        for(var _$e = 1; _$e < arguments.length; _$e++){
            var r = null != arguments[_$e] ? arguments[_$e] : {};
            _$e % 2 ? L(Object(r), !0).forEach(function(e) {
                C(t, e, r[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : L(Object(r)).forEach(function(e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
            });
        }
        return t;
    }({}, t);
    for(var _$o in e)Object.prototype.hasOwnProperty.call(e, _$o) && (n[_$o] = z(n[_$o], e[_$o], r - 1));
    return n;
}
var N = "_sentrySpan";
function R(t, e) {
    e ? function(t, e, r) {
        try {
            Object.defineProperty(t, e, {
                value: r,
                writable: !0,
                configurable: !0
            });
        } catch (r) {
            j && A.log('Failed to add non-enumerable property "'.concat(e, '" to object'), t);
        }
    }(t, N, e) : delete t[N];
}
function M(t) {
    return t[N];
}
function B(t) {
    return B = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function B(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, B(t);
}
function U(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
    }
    return r;
}
function q(t) {
    for(var e = 1; e < arguments.length; e++){
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? U(Object(r), !0).forEach(function(e) {
            G(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : U(Object(r)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
    }
    return t;
}
function G(t, e, r) {
    return (e = Y(e)) in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = r, t;
}
function $(t) {
    return function(t) {
        if (Array.isArray(t)) return V(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || Z(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function Z(t, e) {
    if (t) {
        if ("string" == typeof t) return V(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? V(t, e) : void 0;
    }
}
function V(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
    return n;
}
function H(t, e) {
    for(var r = 0; r < e.length; r++){
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Y(n.key), n);
    }
}
function Y(t) {
    var e = function(t) {
        if ("object" != B(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var r = e.call(t, "string");
            if ("object" != B(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
    }(t);
    return "symbol" == B(e) ? e : String(e);
}
var W = function() {
    function t() {
        !function(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
            traceId: T(),
            spanId: D()
        };
    }
    var e, r;
    return e = t, r = [
        {
            key: "clone",
            value: function value() {
                var e = new t;
                return e._breadcrumbs = $(this._breadcrumbs), e._tags = q({}, this._tags), e._extra = q({}, this._extra), e._contexts = q({}, this._contexts), this._contexts.flags && (e._contexts.flags = {
                    values: $(this._contexts.flags.values)
                }), e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = $(this._eventProcessors), e._requestSession = this._requestSession, e._attachments = $(this._attachments), e._sdkProcessingMetadata = q({}, this._sdkProcessingMetadata), e._propagationContext = q({}, this._propagationContext), e._client = this._client, e._lastEventId = this._lastEventId, R(e, M(this)), e;
            }
        },
        {
            key: "setClient",
            value: function value(t) {
                this._client = t;
            }
        },
        {
            key: "setLastEventId",
            value: function value(t) {
                this._lastEventId = t;
            }
        },
        {
            key: "getClient",
            value: function value() {
                return this._client;
            }
        },
        {
            key: "lastEventId",
            value: function value() {
                return this._lastEventId;
            }
        },
        {
            key: "addScopeListener",
            value: function value(t) {
                this._scopeListeners.push(t);
            }
        },
        {
            key: "addEventProcessor",
            value: function value(t) {
                return this._eventProcessors.push(t), this;
            }
        },
        {
            key: "setUser",
            value: function value(t) {
                return this._user = t || {
                    email: void 0,
                    id: void 0,
                    ip_address: void 0,
                    username: void 0
                }, this._session && function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), t.did || e.did || (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || k(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = 32 === e.sid.length ? e.sid : S()), void 0 !== e.init && (t.init = e.init), !t.did && e.did && (t.did = "".concat(e.did)), "number" == typeof e.started && (t.started = e.started), t.ignoreDuration) t.duration = void 0;
                    else if ("number" == typeof e.duration) t.duration = e.duration;
                    else {
                        var r = t.timestamp - t.started;
                        t.duration = r >= 0 ? r : 0;
                    }
                    e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), "number" == typeof e.errors && (t.errors = e.errors), e.status && (t.status = e.status);
                }(this._session, {
                    user: t
                }), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "getUser",
            value: function value() {
                return this._user;
            }
        },
        {
            key: "getRequestSession",
            value: function value() {
                return this._requestSession;
            }
        },
        {
            key: "setRequestSession",
            value: function value(t) {
                return this._requestSession = t, this;
            }
        },
        {
            key: "setTags",
            value: function value(t) {
                return this._tags = q(q({}, this._tags), t), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setTag",
            value: function value(t, e) {
                return this._tags = q(q({}, this._tags), {}, G({}, t, e)), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setExtras",
            value: function value(t) {
                return this._extra = q(q({}, this._extra), t), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setExtra",
            value: function value(t, e) {
                return this._extra = q(q({}, this._extra), {}, G({}, t, e)), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setFingerprint",
            value: function value(t) {
                return this._fingerprint = t, this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setLevel",
            value: function value(t) {
                return this._level = t, this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setTransactionName",
            value: function value(t) {
                return this._transactionName = t, this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setContext",
            value: function value(t, e) {
                return null === e ? delete this._contexts[t] : this._contexts[t] = e, this._notifyScopeListeners(), this;
            }
        },
        {
            key: "setSession",
            value: function value(t) {
                return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
            }
        },
        {
            key: "getSession",
            value: function value() {
                return this._session;
            }
        },
        {
            key: "update",
            value: function value(t) {
                if (!t) return this;
                var e, r, n = "function" == typeof t ? t(this) : t, _$o = (e = n instanceof W ? [
                    n.getScopeData(),
                    n.getRequestSession()
                ] : O(n) ? [
                    t,
                    t.requestSession
                ] : [], r = 2, function(t) {
                    if (Array.isArray(t)) return t;
                }(e) || function(t, e) {
                    var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != r) {
                        var n, _$o, i, a, c = [], s = !0, u = !1;
                        try {
                            if (i = (r = r.call(t)).next, 0 === e) {
                                if (Object(r) !== r) return;
                                s = !1;
                            } else for(; !(s = (n = i.call(r)).done) && (c.push(n.value), c.length !== e); s = !0);
                        } catch (t) {
                            u = !0, _$o = t;
                        } finally{
                            try {
                                if (!s && null != r["return"] && (a = r["return"](), Object(a) !== a)) return;
                            } finally{
                                if (u) throw _$o;
                            }
                        }
                        return c;
                    }
                }(e, r) || Z(e, r) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }()), i = _$o[0], a = _$o[1], c = i || {}, s = c.tags, u = c.extra, p = c.user, l = c.contexts, f = c.level, h = c.fingerprint, d = void 0 === h ? [] : h, m = c.propagationContext;
                return this._tags = q(q({}, this._tags), s), this._extra = q(q({}, this._extra), u), this._contexts = q(q({}, this._contexts), l), p && Object.keys(p).length && (this._user = p), f && (this._level = f), d.length && (this._fingerprint = d), m && (this._propagationContext = m), a && (this._requestSession = a), this;
            }
        },
        {
            key: "clear",
            value: function value() {
                return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, R(this, void 0), this._attachments = [], this.setPropagationContext({
                    traceId: T()
                }), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "addBreadcrumb",
            value: function value(t, e) {
                var r = "number" == typeof e ? e : 100;
                if (r <= 0) return this;
                var n = q({
                    timestamp: w()
                }, t);
                return this._breadcrumbs.push(n), this._breadcrumbs.length > r && (this._breadcrumbs = this._breadcrumbs.slice(-r), this._client && this._client.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
            }
        },
        {
            key: "getLastBreadcrumb",
            value: function value() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            key: "clearBreadcrumbs",
            value: function value() {
                return this._breadcrumbs = [], this._notifyScopeListeners(), this;
            }
        },
        {
            key: "addAttachment",
            value: function value(t) {
                return this._attachments.push(t), this;
            }
        },
        {
            key: "clearAttachments",
            value: function value() {
                return this._attachments = [], this;
            }
        },
        {
            key: "getScopeData",
            value: function value() {
                return {
                    breadcrumbs: this._breadcrumbs,
                    attachments: this._attachments,
                    contexts: this._contexts,
                    tags: this._tags,
                    extra: this._extra,
                    user: this._user,
                    level: this._level,
                    fingerprint: this._fingerprint || [],
                    eventProcessors: this._eventProcessors,
                    propagationContext: this._propagationContext,
                    sdkProcessingMetadata: this._sdkProcessingMetadata,
                    transactionName: this._transactionName,
                    span: M(this)
                };
            }
        },
        {
            key: "setSDKProcessingMetadata",
            value: function value(t) {
                return this._sdkProcessingMetadata = z(this._sdkProcessingMetadata, t, 2), this;
            }
        },
        {
            key: "setPropagationContext",
            value: function value(t) {
                return this._propagationContext = q({
                    spanId: D()
                }, t), this;
            }
        },
        {
            key: "getPropagationContext",
            value: function value() {
                return this._propagationContext;
            }
        },
        {
            key: "captureException",
            value: function value(t, e) {
                var r = e && e.event_id ? e.event_id : S();
                if (!this._client) return A.warn("No client configured on scope - will not capture exception!"), r;
                var n = new Error("Sentry syntheticException");
                return this._client.captureException(t, q(q({
                    originalException: t,
                    syntheticException: n
                }, e), {}, {
                    event_id: r
                }), this), r;
            }
        },
        {
            key: "captureMessage",
            value: function value(t, e, r) {
                var n = r && r.event_id ? r.event_id : S();
                if (!this._client) return A.warn("No client configured on scope - will not capture message!"), n;
                var _$o = new Error(t);
                return this._client.captureMessage(t, e, q(q({
                    originalException: t,
                    syntheticException: _$o
                }, r), {}, {
                    event_id: n
                }), this), n;
            }
        },
        {
            key: "captureEvent",
            value: function value(t, e) {
                var r = e && e.event_id ? e.event_id : S();
                return this._client ? (this._client.captureEvent(t, q(q({}, e), {}, {
                    event_id: r
                }), this), r) : (A.warn("No client configured on scope - will not capture event!"), r);
            }
        },
        {
            key: "_notifyScopeListeners",
            value: function value() {
                var _$t = this;
                this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach(function(e) {
                    e(_$t);
                }), this._notifyingListeners = !1);
            }
        }
    ], H(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t;
}();
function K(t) {
    return K = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function K(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, K(t);
}
function Q(t, e) {
    for(var r = 0; r < e.length; r++){
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, J(n.key), n);
    }
}
function J(t) {
    var e = function(t) {
        if ("object" != K(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var r = e.call(t, "string");
            if ("object" != K(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
    }(t);
    return "symbol" == K(e) ? e : String(e);
}
var X = function() {
    function t(e, r) {
        var n, _$o;
        !function(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), n = e || new W, _$o = r || new W, this._stack = [
            {
                scope: n
            }
        ], this._isolationScope = _$o;
    }
    var e, r;
    return e = t, r = [
        {
            key: "withScope",
            value: function value(t) {
                var e, r, n = this, _$o = this._pushScope();
                try {
                    e = t(_$o);
                } catch (t) {
                    throw this._popScope(), t;
                }
                return r = e, Boolean(r && r.then && "function" == typeof r.then) ? e.then(function(t) {
                    return n._popScope(), t;
                }, function(t) {
                    throw n._popScope(), t;
                }) : (this._popScope(), e);
            }
        },
        {
            key: "getClient",
            value: function value() {
                return this.getStackTop().client;
            }
        },
        {
            key: "getScope",
            value: function value() {
                return this.getStackTop().scope;
            }
        },
        {
            key: "getIsolationScope",
            value: function value() {
                return this._isolationScope;
            }
        },
        {
            key: "getStackTop",
            value: function value() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            key: "_pushScope",
            value: function value() {
                var _$t = this.getScope().clone();
                return this._stack.push({
                    client: this.getClient(),
                    scope: _$t
                }), _$t;
            }
        },
        {
            key: "_popScope",
            value: function value() {
                return !(this._stack.length <= 1 || !this._stack.pop());
            }
        }
    ], Q(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t;
}();
function tt() {
    var t = x(b());
    return t.stack = t.stack || new X(g("defaultCurrentScope", function() {
        return new W;
    }), g("defaultIsolationScope", function() {
        return new W;
    }));
}
function et(t) {
    return tt().withScope(t);
}
function rt(t, e) {
    var r = tt();
    return r.withScope(function() {
        return r.getStackTop().scope = t, e(t);
    });
}
function nt(t) {
    return tt().withScope(function() {
        return t(tt().getIsolationScope());
    });
}
function ot(t) {
    var e = x(t);
    return e.acs ? e.acs : {
        withIsolationScope: nt,
        withScope: et,
        withSetScope: rt,
        withSetIsolationScope: function withSetIsolationScope(t, e) {
            return nt(e);
        },
        getCurrentScope: function getCurrentScope() {
            return tt().getScope();
        },
        getIsolationScope: function getIsolationScope() {
            return tt().getIsolationScope();
        }
    };
}
function it() {
    for(var t = ot(b()), e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
    if (2 === r.length) {
        var _$o = r[0], i = r[1];
        return _$o ? t.withSetScope(_$o, i) : t.withScope(i);
    }
    return t.withScope(r[0]);
}
function at(t) {
    return at = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function at(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, at(t);
}
function ct(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
    }
    return r;
}
var st, ut = {
    urls: {
        processUrl: "https://process.filestackapi.com",
        fileApiUrl: "https://www.filestackapi.com/api/file",
        uploadApiUrl: "https://upload.filestackapi.com",
        cloudApiUrl: "https://cloud.filestackapi.com",
        cdnUrl: "https://cdn.filestackcontent.com",
        pickerUrl: "https://static.filestackapi.com/picker/".concat("1.39.10", "/picker.js")
    }
};
!function(t) {
    t.VALIDATION = "validation", t.REQUEST = "request", t.ABORTED = "aborted", t.OTHER = "other";
}(st || (st = {}));
var pt = function(t) {
    function e(r, n, o) {
        var i = t.call(this, r) || this;
        return Object.setPrototypeOf(i, e.prototype), i.details = n, i.type = o, i;
    }
    return (0, h.C6)(e, t), e;
}(Error), lt = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Transformations",
    description: "Filestack transformations parameters",
    type: "object",
    additionalProperties: !1,
    properties: {
        flip: {
            type: "boolean",
            additionalProperties: !1
        },
        auto_image: {
            type: "boolean",
            additionalProperties: !1
        },
        no_metadata: {
            type: "boolean",
            additionalProperties: !1
        },
        compress: {
            additionalProperties: !1,
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        metadata: {
                            type: "boolean",
                            "default": !1
                        }
                    }
                }
            ]
        },
        flop: {
            type: "boolean",
            additionalProperties: !1
        },
        enhance: {
            "default": !0,
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    additionalProperties: !1,
                    properties: {
                        preset: {
                            type: "string",
                            "enum": [
                                "auto",
                                "vivid",
                                "beautify",
                                "beautify_plus",
                                "fix_dark",
                                "fix_noise",
                                "fix_tint",
                                "outdoor",
                                "fireworks"
                            ]
                        }
                    }
                }
            ]
        },
        redeye: {
            type: "boolean",
            additionalProperties: !1
        },
        monochrome: {
            type: "boolean",
            additionalProperties: !1
        },
        negative: {
            type: "boolean",
            additionalProperties: !1
        },
        tags: {
            type: "boolean",
            additionalProperties: !1
        },
        sfw: {
            type: "boolean",
            additionalProperties: !1
        },
        imagesize: {
            type: "boolean",
            additionalProperties: !1
        },
        smart_crop: {
            width: {
                type: "integer",
                minimum: 0,
                maximum: 1e4
            },
            height: {
                type: "integer",
                minimum: 0,
                maximum: 1e4
            },
            mode: {
                type: "string",
                "default": "auto",
                "enum": [
                    "face",
                    "auto"
                ]
            }
        },
        animate: {
            type: "object",
            properties: {
                delay: {
                    type: "integer",
                    minimum: 0,
                    maximum: 1e4,
                    "default": 1e3
                },
                loop: {
                    type: "integer",
                    minimum: 0,
                    maximum: 1e3,
                    "default": 0
                },
                width: {
                    type: "integer",
                    minimum: 1,
                    maximum: 1800
                },
                height: {
                    type: "integer",
                    minimum: 1,
                    maximum: 1800
                },
                fit: {
                    type: "string",
                    "default": "clip",
                    "enum": [
                        "clip",
                        "scale",
                        "crop"
                    ]
                },
                background: {
                    $ref: "colorDef",
                    "default": "transparent"
                },
                align: {
                    $ref: "positionDef",
                    "default": "center"
                }
            }
        },
        metadata: {
            type: "object",
            params: {
                type: "array",
                items: {
                    type: "string",
                    "enum": [
                        "filename",
                        "mimetype",
                        "size",
                        "width",
                        "height",
                        "writeable",
                        "path",
                        "container",
                        "cloud",
                        "exif",
                        "source_url",
                        "md5",
                        "sha256",
                        "sha1",
                        "sha512"
                    ]
                },
                minItems: 0,
                uniqueItems: !0,
                additionalItems: !1
            },
            additionalProperties: !1
        },
        resize: {
            type: "object",
            properties: {
                width: {
                    type: "number",
                    minimum: 0,
                    maximum: 1e4
                },
                height: {
                    type: "number",
                    minimum: 0,
                    maximum: 1e4
                },
                fit: {
                    type: "string",
                    "enum": [
                        "clip",
                        "crop",
                        "scale",
                        "max"
                    ],
                    "default": "clip"
                },
                align: {
                    $ref: "positionDef",
                    "default": "center"
                }
            },
            additionalProperties: !1,
            anyOf: [
                {
                    required: [
                        "width"
                    ]
                },
                {
                    required: [
                        "height"
                    ]
                }
            ]
        },
        crop: {
            type: "object",
            properties: {
                dim: {
                    type: "array",
                    additionalItems: !1,
                    minItems: 4,
                    items: [
                        {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e5
                        },
                        {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e5
                        },
                        {
                            type: "integer",
                            minimum: 1,
                            maximum: 1e5
                        },
                        {
                            type: "integer",
                            minimum: 1,
                            maximum: 1e5
                        }
                    ]
                }
            },
            required: [
                "dim"
            ]
        },
        rotate: {
            type: "object",
            properties: {
                deg: {
                    oneOf: [
                        {
                            type: "string",
                            "enum": [
                                "exif"
                            ]
                        },
                        {
                            type: "number",
                            minimum: 0,
                            maximum: 359
                        }
                    ]
                },
                exif: {
                    type: "boolean"
                },
                background: {
                    $ref: "colorDef",
                    "default": "FFFFFFFF"
                }
            },
            additionalProperties: !1
        },
        detect_faces: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        maxsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        minsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        "export": {
                            type: "boolean"
                        },
                        color: {
                            $ref: "colorDef",
                            "default": "000000FF"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        crop_faces: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        faces: {
                            "default": 1,
                            $ref: "facesDef"
                        },
                        width: {
                            type: "number",
                            minimum: 1,
                            maximum: 1e4
                        },
                        height: {
                            type: "number",
                            minimum: 1,
                            maximum: 1e4
                        },
                        maxsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        minsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        buffer: {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4
                        },
                        mode: {
                            type: "string",
                            "enum": [
                                "crop",
                                "thumb",
                                "fill"
                            ],
                            "default": "thumb"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        pixelate_faces: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        faces: {
                            $ref: "facesDef",
                            "default": "all"
                        },
                        maxsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        minsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        buffer: {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4
                        },
                        amount: {
                            type: "integer",
                            minimum: 2,
                            maximum: 100,
                            "default": 10
                        },
                        blur: {
                            type: "number",
                            minimum: 0,
                            maximum: 20,
                            "default": 4
                        },
                        type: {
                            type: "string",
                            "enum": [
                                "rect",
                                "oval"
                            ],
                            "default": "rect"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        blur_faces: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        faces: {
                            $ref: "facesDef",
                            "default": "all"
                        },
                        maxsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        minsize: {
                            type: "number",
                            minimum: 0,
                            maximum: 1e4,
                            "default": .35
                        },
                        buffer: {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4
                        },
                        amount: {
                            type: "number",
                            minimum: 0,
                            maximum: 10,
                            "default": 10
                        },
                        blur: {
                            type: "number",
                            minimum: 0,
                            maximum: 20,
                            "default": 4
                        },
                        type: {
                            type: "string",
                            "enum": [
                                "rect",
                                "oval"
                            ],
                            "default": "rect"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        rounded_corners: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        radius: {
                            oneOf: [
                                {
                                    type: "integer",
                                    minimum: 1,
                                    maximum: 1e4
                                },
                                {
                                    type: "string",
                                    "enum": [
                                        "max"
                                    ]
                                }
                            ]
                        },
                        blur: {
                            type: "number",
                            minimum: 0,
                            maximum: 20,
                            "default": .3
                        },
                        background: {
                            $ref: "colorDef"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        vignette: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        amount: {
                            type: "integer",
                            minimum: 0,
                            maximum: 100,
                            "default": 20
                        },
                        blurmode: {
                            type: "string",
                            "enum": [
                                "gaussian",
                                "linear"
                            ],
                            "default": "gaussian"
                        },
                        background: {
                            $ref: "colorDef"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        polaroid: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        rotate: {
                            type: "integer",
                            minimum: 0,
                            maximum: 359
                        },
                        color: {
                            $ref: "colorDef",
                            "default": "snow"
                        },
                        background: {
                            $ref: "colorDef"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        torn_edges: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        spread: {
                            type: "array",
                            additionalItems: !1,
                            minItems: 2,
                            items: [
                                {
                                    type: "integer",
                                    minimum: 1,
                                    maximum: 1e4,
                                    "default": 1
                                },
                                {
                                    type: "integer",
                                    minimum: 1,
                                    maximum: 1e4,
                                    "default": 10
                                }
                            ]
                        },
                        background: {
                            $ref: "colorDef"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        shadow: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        blur: {
                            type: "number",
                            minimum: 0,
                            maximum: 20,
                            "default": 100
                        },
                        opacity: {
                            type: "integer",
                            minimum: 0,
                            maximum: 100,
                            "default": 60
                        },
                        vector: {
                            type: "array",
                            additionalItems: !1,
                            minItems: 2,
                            items: [
                                {
                                    type: "integer",
                                    minimum: -1000,
                                    maximum: 1e3,
                                    "default": 4
                                },
                                {
                                    type: "integer",
                                    minimum: -1000,
                                    maximum: 1e3,
                                    "default": 4
                                }
                            ]
                        },
                        color: {
                            $ref: "colorDef"
                        },
                        background: {
                            $ref: "colorDef"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        circle: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        background: {
                            $ref: "colorDef"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        border: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        color: {
                            $ref: "colorDef"
                        },
                        background: {
                            $ref: "colorDef"
                        },
                        width: {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e3
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        sharpen: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        amount: {
                            type: "integer",
                            minimum: 0,
                            maximum: 20,
                            "default": 2
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        blur: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        amount: {
                            type: "integer",
                            minimum: 0,
                            maximum: 20,
                            "default": 2
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        blackwhite: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        threshold: {
                            type: "integer",
                            minimum: 0,
                            maximum: 100,
                            "default": 50
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        sepia: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        tone: {
                            type: "integer",
                            minimum: 0,
                            maximum: 100,
                            "default": 80
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        pixelate: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        amount: {
                            type: "integer",
                            minimum: 2,
                            maximum: 100,
                            "default": 2
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        oil_paint: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        amount: {
                            type: "integer",
                            minimum: 2,
                            maximum: 100,
                            "default": 2
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        modulate: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        brightness: {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4,
                            "default": 100
                        },
                        saturation: {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4,
                            "default": 100
                        },
                        hue: {
                            type: "integer",
                            minimum: 0,
                            maximum: 359,
                            "default": 0
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        ascii: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        foreground: {
                            $ref: "colorDef",
                            "default": "000000FF"
                        },
                        background: {
                            $ref: "colorDef",
                            "default": "FFFFFFFF"
                        },
                        colored: {
                            type: "boolean",
                            "default": !1
                        },
                        size: {
                            type: "integer",
                            minimum: 10,
                            maximum: 100,
                            "default": 100
                        },
                        reverse: {
                            type: "boolean",
                            "default": !1
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        collage: {
            type: "object",
            properties: {
                files: {
                    type: "array",
                    minItems: 1,
                    items: [
                        {
                            type: "string"
                        }
                    ]
                },
                margin: {
                    type: "integer",
                    minimum: 1,
                    maximum: 100,
                    "default": 10
                },
                width: {
                    type: "integer",
                    minimum: 0,
                    maximum: 1e4
                },
                height: {
                    type: "integer",
                    minimum: 0,
                    maximum: 1e4
                },
                color: {
                    $ref: "colorDef",
                    "default": "FFFFFFFF"
                },
                fit: {
                    type: "string",
                    "enum": [
                        "auto",
                        "crop"
                    ]
                },
                autorotate: {
                    type: "boolean",
                    "default": !1
                }
            },
            required: [
                "width",
                "height",
                "files"
            ],
            additionalProperties: !1
        },
        urlscreenshot: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        agent: {
                            type: "string",
                            "enum": [
                                "desktop",
                                "mobile"
                            ],
                            "default": "desktop"
                        },
                        width: {
                            type: "integer",
                            minimum: 1,
                            maximum: 1920,
                            "default": 1024
                        },
                        height: {
                            type: "integer",
                            minimum: 1,
                            maximum: 8e3,
                            "default": 768
                        },
                        mode: {
                            type: "string",
                            "enum": [
                                "all",
                                "window"
                            ],
                            "default": "all"
                        },
                        delay: {
                            type: "integer",
                            minimum: 0,
                            maximum: 2e4,
                            "default": 1e3
                        },
                        orientation: {
                            type: "string",
                            "enum": [
                                "portrait",
                                "landscape"
                            ],
                            "default": "portrait"
                        },
                        device: {
                            type: "string",
                            "default": ""
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        upscale: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        noise: {
                            type: "string",
                            "enum": [
                                "none",
                                "low",
                                "medium",
                                "high"
                            ],
                            "default": "none"
                        },
                        upscale: {
                            type: "boolean",
                            "default": !0
                        },
                        style: {
                            type: "string",
                            "enum": [
                                "artwork",
                                "photo"
                            ],
                            "default": "photo"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        },
        output: {
            type: "object",
            additionalProperties: !1,
            properties: {
                format: {
                    type: "string",
                    "enum": [
                        "doc",
                        "docx",
                        "html",
                        "jpg",
                        "odp",
                        "ods",
                        "odt",
                        "pjpg",
                        "pdf",
                        "png",
                        "ppt",
                        "pptx",
                        "svg",
                        "txt",
                        "webp",
                        "xls",
                        "xlsx"
                    ]
                },
                page: {
                    type: "integer",
                    minimum: 1,
                    maximum: 99999
                },
                density: {
                    type: "integer",
                    minimum: 1,
                    maximum: 500
                },
                compress: {
                    type: "boolean"
                },
                quality: {
                    oneOf: [
                        {
                            type: "string",
                            "enum": [
                                "input"
                            ]
                        },
                        {
                            type: "integer",
                            minimum: 1,
                            maximum: 100,
                            "default": 95
                        }
                    ]
                },
                secure: {
                    type: "boolean",
                    "default": !1
                },
                docinfo: {
                    type: "boolean",
                    "default": !1
                },
                strip: {
                    type: "boolean",
                    "default": !1
                },
                colorspace: {
                    type: "string",
                    "enum": [
                        "rgb",
                        "cmyk",
                        "input"
                    ],
                    "default": "rgb"
                },
                background: {
                    $ref: "colorDef"
                },
                pageformat: {
                    type: "string",
                    "enum": [
                        "a2",
                        "a3",
                        "a4",
                        "a5",
                        "b4",
                        "b5",
                        "letter",
                        "legal",
                        "tabloid"
                    ]
                },
                pageorientation: {
                    type: "string",
                    "enum": [
                        "landscape",
                        "portrait"
                    ]
                }
            }
        },
        pjpg: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    additionalProperties: !1,
                    properties: {
                        quality: {
                            type: "integer",
                            minimum: 0,
                            maximum: 100
                        },
                        metadata: {
                            type: "boolean",
                            "default": !1
                        }
                    }
                }
            ]
        },
        quality: {
            type: "object",
            additionalProperties: !1,
            properties: {
                value: {
                    type: "integer",
                    minimum: 1,
                    maximum: 100
                }
            }
        },
        cache: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        expiry: {
                            type: "integer"
                        }
                    }
                }
            ]
        },
        video_convert: {
            type: "object",
            additionalProperties: !1,
            properties: {
                width: {
                    type: "integer",
                    minimum: 1,
                    maximum: 4096
                },
                height: {
                    type: "integer",
                    minimum: 1,
                    maximum: 4096
                },
                preset: {
                    type: "string"
                },
                force: {
                    type: "boolean"
                },
                title: {
                    type: "string"
                },
                extname: {
                    type: "string"
                },
                upscale: {
                    type: "boolean"
                },
                aspect_mode: {
                    type: "string",
                    "enum": [
                        "letterbox",
                        "pad",
                        "crop",
                        "preserve",
                        "constrain"
                    ],
                    "default": "letterbox"
                },
                audio_sample_rate: {
                    type: "integer",
                    minimum: 1,
                    maximum: 99999
                },
                two_pass: {
                    type: "boolean"
                },
                video_bitrate: {
                    type: "integer",
                    minimum: 1,
                    maximum: 5e3
                },
                fps: {
                    type: "integer",
                    minimum: 1,
                    maximum: 300
                },
                keyframe_interval: {
                    type: "integer",
                    minimum: 250,
                    maximum: 250
                },
                audio_bitrate: {
                    type: "integer",
                    minimum: 1,
                    maximum: 999
                },
                audio_codec: {
                    type: "string"
                },
                audio_channels: {
                    type: "integer",
                    minimum: 1,
                    maximum: 12
                },
                clip_length: {
                    type: "string",
                    pattern: "^([0-1]?\\d|2[0-3])(?::([0-5]?\\d))?(?::([0-5]?\\d))?$"
                },
                clip_offset: {
                    type: "string",
                    pattern: "^([0-1]?\\d|2[0-3])(?::([0-5]?\\d))?(?::([0-5]?\\d))?$"
                },
                watermark_url: {
                    type: "string"
                },
                watermark_top: {
                    type: "integer",
                    minimum: 0,
                    maximum: 9999
                },
                watermark_right: {
                    type: "integer",
                    minimum: 0,
                    maximum: 9999
                },
                watermark_bottom: {
                    type: "integer",
                    minimum: 0,
                    maximum: 9999
                },
                watermark_left: {
                    type: "integer",
                    minimum: 0,
                    maximum: 9999
                },
                frame_count: {
                    type: "integer",
                    minimum: 1,
                    maximum: 1,
                    "default": 1
                },
                filename: {
                    type: "string"
                },
                location: {
                    $ref: "locationsDef"
                },
                path: {
                    type: "string"
                },
                container: {
                    type: "string"
                },
                access: {
                    type: "string",
                    "enum": [
                        "public",
                        "private"
                    ],
                    "default": "public"
                }
            }
        },
        store: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    additionalProperties: !1,
                    properties: {
                        filename: {
                            type: "string"
                        },
                        location: {
                            $ref: "locationsDef"
                        },
                        path: {
                            type: "string"
                        },
                        container: {
                            type: "string"
                        },
                        region: {
                            $ref: "regionsDef"
                        },
                        access: {
                            type: "string",
                            "enum": [
                                "public",
                                "private"
                            ],
                            "default": "private"
                        },
                        base64decode: {
                            type: "boolean"
                        },
                        workflows: {
                            $ref: "workflowsDef"
                        }
                    }
                }
            ]
        },
        watermark: {
            type: "object",
            properties: {
                file: {
                    type: "string"
                },
                size: {
                    type: "number",
                    minimum: 0,
                    maximum: 500
                },
                position: {
                    $ref: "positionDef"
                }
            },
            required: [
                "file"
            ],
            additionalProperties: !1
        },
        partial_blur: {
            type: "object",
            properties: {
                objects: {
                    $ref: "objectsDef"
                },
                amount: {
                    type: "number",
                    minimum: 0,
                    maximum: 20
                },
                blur: {
                    type: "number",
                    minimum: 0,
                    maximum: 20
                },
                type: {
                    type: "string",
                    "enum": [
                        "rect",
                        "oval"
                    ]
                }
            },
            required: [
                "objects"
            ]
        },
        partial_pixelate: {
            type: "object",
            properties: {
                objects: {
                    $ref: "objectsDef"
                },
                amount: {
                    type: "number",
                    minimum: 2,
                    maximum: 100
                },
                blur: {
                    type: "number",
                    minimum: 0,
                    maximum: 20
                },
                type: {
                    type: "string",
                    "enum": [
                        "rect",
                        "oval"
                    ]
                }
            },
            required: [
                "objects"
            ]
        },
        security: {
            type: "object",
            additionalProperties: !1,
            properties: {
                policy: {
                    type: "string"
                },
                signature: {
                    type: "string"
                }
            },
            required: [
                "policy",
                "signature"
            ]
        },
        pdfinfo: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    properties: {
                        colorinfo: {
                            type: "boolean"
                        }
                    }
                }
            ]
        },
        pdfconvert: {
            type: "object",
            additionalProperties: !1,
            properties: {
                pageorientation: {
                    type: "string",
                    "enum": [
                        "portrait",
                        "landscape"
                    ]
                },
                pageformat: {
                    $ref: "pageFormatDef"
                },
                pages: {
                    $ref: "pageRangeDef"
                }
            },
            anyOf: [
                {
                    required: [
                        "pageorientation"
                    ]
                },
                {
                    required: [
                        "pageformat"
                    ]
                },
                {
                    required: [
                        "pages"
                    ]
                }
            ]
        },
        fallback: {
            type: "object",
            additionalProperties: !1,
            properties: {
                handle: {
                    type: "string"
                },
                cache: {
                    type: "integer",
                    minimum: 1,
                    maximum: 31536e3
                }
            },
            required: [
                "handle"
            ]
        },
        zip: {
            type: "string"
        },
        minify_css: {
            type: "object",
            additionalProperties: !1,
            properties: {
                gzip: {
                    type: "boolean"
                },
                level: {
                    type: "number",
                    "enum": [
                        1,
                        2
                    ]
                }
            }
        },
        minify_js: {
            type: "object",
            additionalProperties: !1,
            properties: {
                gzip: {
                    type: "boolean"
                },
                use_babel_polyfill: {
                    type: "boolean"
                },
                keep_fn_name: {
                    type: "boolean"
                },
                keep_class_name: {
                    type: "boolean"
                },
                mangle: {
                    type: "boolean"
                },
                merge_vars: {
                    type: "boolean"
                },
                remove_console: {
                    type: "boolean"
                },
                remove_undefined: {
                    type: "boolean"
                },
                targets: {
                    type: "string"
                }
            }
        }
    }
}, ft = o(4282), ht = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack",
    description: "Filestack common definitions",
    type: "object",
    additionalProperties: !1,
    definitions: {
        workflowsDef: {
            id: "/workflowsDef",
            type: "array",
            additionalItems: !1,
            minItems: 1,
            maxItems: 20,
            items: [
                {
                    oneOf: [
                        {
                            type: "string"
                        },
                        {
                            type: "object",
                            additionalProperties: !1,
                            properties: {
                                id: {
                                    type: "string"
                                }
                            }
                        }
                    ]
                }
            ]
        },
        securityCallDef: {
            id: "/securityCallDef",
            oneOf: [
                {
                    additionalProperties: !1,
                    type: "string",
                    "enum": [
                        "pick",
                        "read",
                        "stat",
                        "write",
                        "writeUrl",
                        "store",
                        "convert",
                        "remove",
                        "exif",
                        "runWorkflow"
                    ]
                },
                {
                    type: "array",
                    additionalProperties: !1,
                    items: [
                        {
                            minItems: 1,
                            maxItems: 10,
                            type: "string",
                            additionalProperties: !1,
                            "enum": [
                                "pick",
                                "read",
                                "stat",
                                "write",
                                "writeUrl",
                                "store",
                                "convert",
                                "remove",
                                "exif",
                                "runWorkflow"
                            ]
                        }
                    ]
                }
            ]
        },
        regionsDef: {
            id: "/regionsDef",
            type: "string"
        },
        locationsDef: {
            id: "/locationsDef",
            type: "string",
            "enum": [
                "s3",
                "S3",
                "rackspace",
                "gcs",
                "azure",
                "dropbox"
            ]
        },
        colorDef: {
            id: "colorDef",
            oneOf: [
                {
                    type: "string",
                    pattern: "^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$"
                },
                {
                    type: "string",
                    "enum": [
                        "aliceblue",
                        "antiquewhite",
                        "aqua",
                        "aquamarine",
                        "azure",
                        "beige",
                        "bisque",
                        "black",
                        "blanchedalmond",
                        "blue",
                        "blueviolet",
                        "brown",
                        "burlywood",
                        "cadetblue",
                        "chartreuse",
                        "chocolate",
                        "coral",
                        "cornflowerblue",
                        "cornsilk",
                        "crimson",
                        "cyan",
                        "darkblue",
                        "darkcyan",
                        "darkgoldenrod",
                        "darkgray",
                        "darkgreen",
                        "darkgrey",
                        "darkkhaki",
                        "darkmagenta",
                        "darkolivegreen",
                        "darkorange",
                        "darkorchid",
                        "darkred",
                        "darksalmon",
                        "darkseagreen",
                        "darkslateblue",
                        "darkslategray",
                        "darkslategrey",
                        "darkturquoise",
                        "darkviolet",
                        "deeppink",
                        "deepskyblue",
                        "dimgray",
                        "dimgrey",
                        "dodgerblue",
                        "firebrick",
                        "floralwhite",
                        "forestgreen",
                        "fractal",
                        "fuchsia",
                        "gainsboro",
                        "ghostwhite",
                        "gold",
                        "goldenrod",
                        "gray0",
                        "gray1",
                        "gray2",
                        "gray3",
                        "gray4",
                        "gray5",
                        "gray6",
                        "gray7",
                        "gray8",
                        "gray9",
                        "gray10",
                        "gray11",
                        "gray12",
                        "gray13",
                        "gray14",
                        "gray15",
                        "gray16",
                        "gray17",
                        "gray18",
                        "gray19",
                        "gray20",
                        "gray21",
                        "gray22",
                        "gray23",
                        "gray24",
                        "gray25",
                        "gray26",
                        "gray27",
                        "gray28",
                        "gray29",
                        "gray30",
                        "gray31",
                        "gray32",
                        "gray33",
                        "gray34",
                        "gray35",
                        "gray36",
                        "gray37",
                        "gray38",
                        "gray39",
                        "gray40",
                        "gray41",
                        "gray42",
                        "gray43",
                        "gray44",
                        "gray45",
                        "gray46",
                        "gray47",
                        "gray48",
                        "gray49",
                        "gray50",
                        "gray51",
                        "gray52",
                        "gray53",
                        "gray54",
                        "gray55",
                        "gray56",
                        "gray57",
                        "gray58",
                        "gray59",
                        "gray60",
                        "gray61",
                        "gray62",
                        "gray63",
                        "gray64",
                        "gray65",
                        "gray66",
                        "gray67",
                        "gray68",
                        "gray69",
                        "gray70",
                        "gray71",
                        "gray72",
                        "gray73",
                        "gray74",
                        "gray75",
                        "gray76",
                        "gray77",
                        "gray78",
                        "gray79",
                        "gray80",
                        "gray81",
                        "gray82",
                        "gray83",
                        "gray84",
                        "gray85",
                        "gray86",
                        "gray87",
                        "gray88",
                        "gray89",
                        "gray90",
                        "gray91",
                        "gray92",
                        "gray93",
                        "gray94",
                        "gray95",
                        "gray96",
                        "gray97",
                        "gray98",
                        "gray99",
                        "gray100",
                        "gray",
                        "green",
                        "greenyellow",
                        "grey",
                        "honeydew",
                        "hotpink",
                        "indianred",
                        "indigo",
                        "ivory",
                        "khaki",
                        "lavender",
                        "lavenderblush",
                        "lawngreen",
                        "lemonchiffon",
                        "lightblue",
                        "lightcoral",
                        "lightcyan",
                        "lightgoldenrodyellow",
                        "lightgray",
                        "lightgreen",
                        "lightgrey",
                        "lightpink",
                        "lightsalmon",
                        "lightseagreen",
                        "lightskyblue",
                        "lightslategray",
                        "lightslategrey",
                        "lightsteelblue",
                        "lightyellow",
                        "lime",
                        "limegreen",
                        "linen",
                        "magenta",
                        "maroon",
                        "mediumaquamarine",
                        "mediumblue",
                        "mediumorchid",
                        "mediumpurple",
                        "mediumseagreen",
                        "mediumslateblue",
                        "mediumspringgreen",
                        "mediumturquoise",
                        "mediumvioletred",
                        "midnightblue",
                        "mintcream",
                        "mistyrose",
                        "moccasin",
                        "navajowhite",
                        "navy",
                        "none",
                        "oldlace",
                        "olive",
                        "olivedrab",
                        "orange",
                        "orangered",
                        "orchid",
                        "palegoldenrod",
                        "palegreen",
                        "paleturquoise",
                        "palevioletred",
                        "papayawhip",
                        "peachpuff",
                        "peru",
                        "pink",
                        "plum",
                        "powderblue",
                        "purple",
                        "red",
                        "rosybrown",
                        "royalblue",
                        "saddlebrown",
                        "salmon",
                        "sandybrown",
                        "seagreen",
                        "seashell",
                        "sienna",
                        "silver",
                        "skyblue",
                        "slateblue",
                        "slategray",
                        "slategrey",
                        "snow",
                        "springgreen",
                        "steelblue",
                        "tan",
                        "teal",
                        "thistle",
                        "tomato",
                        "turquoise",
                        "violet",
                        "wheat",
                        "white",
                        "whitesmoke",
                        "yellow",
                        "yellowgreen",
                        "transparent"
                    ]
                }
            ]
        },
        pageFormatDef: {
            id: "/pageFormatDef",
            type: "string",
            "enum": [
                "a2",
                "a3",
                "a4",
                "a5",
                "b4",
                "b5",
                "letter",
                "legal",
                "tabloid"
            ]
        },
        pageRangeDef: {
            id: "/pageRangeDef",
            type: "array",
            uniqueItems: !0,
            items: [
                {
                    oneOf: [
                        {
                            type: "integer",
                            minimum: 1
                        },
                        {
                            type: "string",
                            pattern: "^(\\d+(?:-\\d+)?)$|^(-\\d+)$|^(\\d+-)$",
                            errorMessage: 'Param should be provided in one of the following formats: "1,2,3,5", "1-3", "1-", "-2" '
                        }
                    ]
                }
            ]
        },
        facesDef: {
            id: "/facesDef",
            oneOf: [
                {
                    type: "string",
                    "enum": [
                        "all"
                    ]
                },
                {
                    type: "integer",
                    minimum: 1,
                    maximum: 1e3
                },
                {
                    type: "array",
                    uniqueItems: !0,
                    items: [
                        {
                            type: "integer",
                            minimum: 1,
                            maximum: 1e3
                        }
                    ]
                }
            ]
        },
        objectsDef: {
            id: "/objectsDef",
            type: "array",
            minItems: 1,
            maxItems: 50,
            items: [
                {
                    type: "array",
                    additionalItems: !1,
                    minItems: 4,
                    items: [
                        {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4
                        },
                        {
                            type: "integer",
                            minimum: 0,
                            maximum: 1e4
                        },
                        {
                            type: "integer",
                            minimum: 1,
                            maximum: 1e4
                        },
                        {
                            type: "integer",
                            minimum: 1,
                            maximum: 1e4
                        }
                    ]
                }
            ]
        },
        positionDef: {
            id: "/positionDef",
            "default": [
                "middle",
                "center"
            ],
            oneOf: [
                {
                    type: "string",
                    "enum": [
                        "top",
                        "middle",
                        "bottom",
                        "left",
                        "center",
                        "right",
                        "faces"
                    ]
                },
                {
                    type: "array",
                    uniqueItems: !0,
                    additionalItems: !1,
                    minItems: 2,
                    maxItems: 2,
                    "default": [
                        "middle",
                        "center"
                    ],
                    items: [
                        {
                            type: "string",
                            "enum": [
                                "top",
                                "middle",
                                "bottom"
                            ]
                        },
                        {
                            type: "string",
                            "enum": [
                                "left",
                                "center",
                                "right"
                            ]
                        }
                    ]
                }
            ]
        }
    }
}, dt = new ft.Validator;
ft.Validator.prototype.customFormats.callback = function(t) {
    return "function" == typeof t;
}, ft.Validator.prototype.customFormats.HTMLContainer = function(t) {
    return "string" == typeof t || t.toString && t.toString().indexOf("HTML") > -1;
};
var mt = function mt(t) {
    return function(e) {
        return dt.addSchema(ht), dt.validate(e, t);
    };
}, yt = o(6947), vt = o(1227), gt = o.n(vt);
function bt(t) {
    return bt = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function bt(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, bt(t);
}
var xt, wt, kt, St, Et, Ot, jt, Ft, _t, Pt, At, Tt, Dt, Lt, Ct, It, zt, Nt, Rt, Mt = gt()("fs:filelink");
!function(t) {
    t.left = "left", t.right = "right", t.center = "center", t.bottom = "bottom", t.top = "top", t.faces = "faces", t.middle = "middle";
}(xt || (xt = {})), function(t) {
    t.clip = "clip", t.crop = "crop", t.scale = "scale", t.max = "max";
}(wt || (wt = {})), function(t) {
    t.linear = "linear", t.gaussian = "gaussian";
}(kt || (kt = {})), function(t) {
    t.oval = "oval", t.rect = "rect";
}(St || (St = {})), function(t) {
    t.none = "none", t.low = "low", t.medium = "medium", t.high = "high";
}(Et || (Et = {})), function(t) {
    t.artwork = "artwork", t.photo = "photo";
}(Ot || (Ot = {})), function(t) {
    t.RGB = "RGB", t.CMYK = "CMYK", t.Input = "Input";
}(jt || (jt = {})), function(t) {
    t.thumb = "thumb", t.crop = "crop", t.fill = "fill";
}(Ft || (Ft = {})), function(t) {
    t.top = "top", t.middle = "middle", t.bottom = "bottom", t.left = "left", t.center = "center", t.right = "right";
}(_t || (_t = {})), function(t) {
    t.face = "face", t.auto = "auto";
}(Pt || (Pt = {})), function(t) {
    t.libmp3lame = "libmp3lame", t.libvorbis = "libvorbis", t.libfdk_aac = "libfdk_aac", t.dib_ac3 = "dib_ac3", t.pcm_s16le = "pcm_s16le", t.mp2 = "mp2", t.ac3 = "ac3", t.eac3 = "eac3";
}(At || (At = {})), function(t) {
    t.h264 = "h264", t.h264_hi = "h264.hi", t.webm = "webm", t["webm-hi"] = "webm.hi", t.ogg = "ogg", t["ogg-hi"] = "ogg.hi", t["hls-variant"] = "hls.variant", t.mp3 = "mp3", t.oga = "oga", t.m4a = "m4a", t.aac = "aac", t.hls = "hls.variant.audio";
}(Tt || (Tt = {})), function(t) {
    t.desktop = "desktop", t.mobile = "mobile";
}(Dt || (Dt = {})), function(t) {
    t.all = "all", t.window = "window";
}(Lt || (Lt = {})), function(t) {
    t.portrait = "portrait", t.landscape = "landscape";
}(Ct || (Ct = {})), function(t) {
    t.s3 = "s3", t.azure = "azure", t.gcs = "gcs", t.rackspace = "rackspace", t.dropbox = "dropbox";
}(It || (It = {})), function(t) {
    t["private"] = "private", t["public"] = "public";
}(zt || (zt = {})), function(t) {
    t.preserve = "preserve", t.constrain = "constrain", t.letterbox = "letterbox", t.pad = "pad", t.crop = "crop";
}(Nt || (Nt = {})), function(t) {
    t.auto = "auto", t.vivid = "vivid", t.beautify = "beautify", t.beautifyPlus = "beautify_plus", t.fixDark = "fix_dark", t.fixNoise = "fix_noise", t.fixTint = "fix_tint", t.outdor = "outdoor", t.fireworks = "fireworks";
}(Rt || (Rt = {}));
var Bt = /^[\w\-]{20}|wf:\/\/[\w\-\/]{106}$/, Ut = function() {
    function t(t, e) {
        this.transforms = [], this.b64 = !1, this.useValidator = !0, this.arrayToObject = function(t, e, r) {
            return void 0 === t && (t = []), t.reduce(function(t, n) {
                return t[n[e]] = n[r], t;
            }, {});
        }, this.apikey = e, this.setSource(t);
    }
    return t.prototype.setBase64 = function(t) {
        return this.b64 = t, this;
    }, t.prototype.setUseValidator = function(t) {
        return this.useValidator = t, this;
    }, t.prototype.setCname = function(t) {
        return this.cname = t, this;
    }, t.prototype.setCustomDomain = function(t) {
        return this.customDomain = t, this;
    }, t.prototype.setSource = function(t) {
        this.source = t;
        var e = this.isSourceExternal();
        if (Mt("Source ".concat(t, " - isExternal? ").concat(e)), e && !this.apikey) throw new pt("External sources requires apikey to handle transforms");
        if (!e && "string" == typeof this.source && !Bt.test(this.source) && -1 === this.source.indexOf("filestackcontent")) throw new pt("Invalid filestack source provided");
    }, t.prototype.getValidationSchema = function() {
        return lt;
    }, t.prototype.getTransformations = function() {
        return this.useValidator && this.validateTasks(this.transforms), this.transforms;
    }, t.prototype.toString = function() {
        var _$t = [];
        _$t.push(this.getCdnHost()), this.useValidator && this.validateTasks(this.transforms), this.apikey && _$t.push(this.apikey);
        var e = this.generateTransformString(), r = this.source;
        return this.b64 ? (this.transforms.length > 0 && (e = "b64/".concat((0, yt.b64)(JSON.stringify(this.transforms), !0))), Array.isArray(r) && (r = this.arrayToString(r)), r = "b64://".concat((0, yt.b64)(r, !0))) : r = Array.isArray(r) ? this.arrayToString(r) : this.escapeValue(r), e.length && _$t.push(e), _$t.push(r), _$t.join("/");
    }, t.prototype.addTask = function(t, e) {
        if (gt()("Add task  ".concat(t, " with params %O"), e), "cache" !== t && "boolean" == typeof e) {
            if (!e) return this;
            e = void 0;
        } else "object" !== bt(e) || Object.keys(e).length || (e = void 0);
        return this.transforms.push({
            name: t,
            params: e
        }), this;
    }, t.prototype.getTasks = function() {
        return this.transforms;
    }, t.prototype.reset = function() {
        return this.transforms = [], this;
    }, t.prototype.autoImage = function() {
        return this.addTask("auto_image", !0);
    }, t.prototype.flip = function() {
        return this.addTask("flip", !0);
    }, t.prototype.flop = function() {
        return this.addTask("flop", !0);
    }, t.prototype.imagesize = function() {
        return this.addTask("imagesize", !0);
    }, t.prototype.noMetadata = function() {
        return this.addTask("no_metadata", !0);
    }, t.prototype.pjpg = function(t) {
        return this.addTask("pjpg", t);
    }, t.prototype.smartCrop = function(t) {
        return this.addTask("smart_crop", t);
    }, t.prototype.watermark = function(t) {
        return this.addTask("watermark", t);
    }, t.prototype.enhance = function(t) {
        return this.addTask("enhance", t || !0);
    }, t.prototype.redeye = function() {
        return this.addTask("redeye", !0);
    }, t.prototype.monochrome = function() {
        return this.addTask("monochrome", !0);
    }, t.prototype.compress = function(t) {
        return this.addTask("compress", t || !0);
    }, t.prototype.negative = function() {
        return this.addTask("negative", !0);
    }, t.prototype.tags = function() {
        return this.addTask("tags", !0);
    }, t.prototype.sfw = function() {
        return this.addTask("sfw", !0);
    }, t.prototype.animate = function(t) {
        return this.addTask("animate", t);
    }, t.prototype.store = function(t) {
        return this.addTask("store", t);
    }, t.prototype.cache = function(t) {
        return this.addTask("cache", t);
    }, t.prototype.resize = function(t) {
        return this.addTask("resize", t);
    }, t.prototype.crop = function(t) {
        return this.addTask("crop", t);
    }, t.prototype.rotate = function(t) {
        return this.addTask("rotate", t);
    }, t.prototype.detectFaces = function(t) {
        return this.addTask("detect_faces", t);
    }, t.prototype.cropFaces = function(t) {
        return this.addTask("crop_faces", t);
    }, t.prototype.pixelateFaces = function(t) {
        return this.addTask("pixelate_faces", t);
    }, t.prototype.blurFaces = function(t) {
        return this.addTask("blur_faces", t);
    }, t.prototype.roundedCorners = function(t) {
        return this.addTask("rounded_corners", t);
    }, t.prototype.polaroid = function(t) {
        return this.addTask("polaroid", t);
    }, t.prototype.vignette = function(t) {
        return this.addTask("vignette", t);
    }, t.prototype.tornEdges = function(t) {
        return this.addTask("torn_edges", t);
    }, t.prototype.shadow = function(t) {
        return this.addTask("shadow", t);
    }, t.prototype.circle = function(t) {
        return this.addTask("circle", t);
    }, t.prototype.border = function(t) {
        return this.addTask("border", t);
    }, t.prototype.sharpen = function(t) {
        return this.addTask("sharpen", t);
    }, t.prototype.blur = function(t) {
        return this.addTask("blur", t);
    }, t.prototype.blackwhite = function(t) {
        return this.addTask("blackwhite", t);
    }, t.prototype.sepia = function(t) {
        return this.addTask("sepia", t);
    }, t.prototype.pixelate = function(t) {
        return this.addTask("pixelate", t);
    }, t.prototype.oilPaint = function(t) {
        return this.addTask("oil_paint", t);
    }, t.prototype.modulate = function(t) {
        return this.addTask("modulate", t);
    }, t.prototype.partialPixelate = function(t) {
        return this.addTask("partial_pixelate", t);
    }, t.prototype.partialBlur = function(t) {
        return this.addTask("partial_blur", t);
    }, t.prototype.collage = function(t) {
        return this.addTask("collage", t);
    }, t.prototype.upscale = function(t) {
        return this.addTask("upscale", t);
    }, t.prototype.ascii = function(t) {
        return this.addTask("ascii", t);
    }, t.prototype.quality = function(t) {
        return this.addTask("quality", t);
    }, t.prototype.security = function(t) {
        return this.addTask("security", t);
    }, t.prototype.output = function(t) {
        return this.addTask("output", t);
    }, t.prototype.videoConvert = function(t) {
        return this.addTask("video_convert", t);
    }, t.prototype.URLScreenshot = function(t) {
        return this.addTask("urlscreenshot", t);
    }, t.prototype.PDFInfo = function(t) {
        return this.addTask("pdfinfo", t);
    }, t.prototype.PDFConvert = function(t) {
        return this.addTask("pdfconvert", t);
    }, t.prototype.fallback = function(t) {
        return this.addTask("fallback", t);
    }, t.prototype.zip = function() {
        return this.addTask("zip", !0);
    }, t.prototype.minifyCss = function(t) {
        return this.addTask("minify_css", t);
    }, t.prototype.minifyJs = function(t) {
        return this.addTask("minify_js", t);
    }, t.prototype.isSourceExternal = function() {
        if (!this.source) throw new pt("Source not Set");
        var _$t = Array.isArray(this.source) ? this.source : [
            this.source
        ];
        for(var e in _$t)if (_$t.hasOwnProperty(e) && (0 === _$t[e].indexOf("src:") || 0 === _$t[e].indexOf("http") && -1 === _$t[e].indexOf("filestackcontent"))) return !0;
        return !1;
    }, t.prototype.validateTasks = function(e) {
        var r = t.validator(this.arrayToObject(e, "name", "params"));
        if (r.errors.length) throw new pt("Params validation error", r.errors, st.VALIDATION);
    }, t.prototype.getCdnHost = function() {
        var _$t = Object.assign({}, ut.urls);
        return this.customDomain && (_$t.cdnUrl = this.customDomain), (_$t = (0, yt.resolveHost)(_$t, this.cname)).cdnUrl;
    }, t.prototype.generateTransformString = function() {
        var _$t = this, e = [];
        return this.transforms.forEach(function(r) {
            e.push(_$t.optionToString(r.name, r.params));
        }), e.join("/");
    }, t.prototype.optionToString = function(t, e) {
        var r = this, n = [];
        return void 0 === e ? t : "boolean" == typeof e ? e || "cache" !== t ? t : "cache=false" : (Object.keys(e).forEach(function(t) {
            Array.isArray(e[t]) ? n.push("".concat(t, ":").concat(r.arrayToString(e[t]))) : n.push("".concat(t, ":").concat(r.escapeValue(e[t])));
        }), "".concat(t, "=").concat(n.join(",")));
    }, t.prototype.escapeValue = function(t) {
        return "string" != typeof t ? t : t.indexOf("/") > -1 || t.indexOf(",") > -1 ? '"'.concat(t, '"') : t;
    }, t.prototype.arrayToString = function(t) {
        var e = this, r = t.map(function(t) {
            return Array.isArray(t) ? e.arrayToString(t) : e.escapeValue(t);
        });
        return "[".concat(r, "]");
    }, t.validator = mt(lt), t;
}(), qt = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Store",
    description: "Filestack Store Options",
    type: "object",
    additionalProperties: !1,
    properties: {
        filename: {
            oneOf: [
                {
                    type: "string"
                },
                {
                    format: "callback"
                }
            ]
        },
        mimetype: {
            type: [
                "string",
                "null"
            ],
            maxLength: 255
        },
        altText: {
            type: [
                "string",
                "null"
            ],
            maxLength: 125
        },
        location: {
            $ref: "locationsDef"
        },
        path: {
            type: "string"
        },
        container: {
            type: "string"
        },
        region: {
            $ref: "regionsDef"
        },
        access: {
            type: "string",
            "enum": [
                "public",
                "private"
            ],
            "default": "private"
        },
        base64decode: {
            type: "boolean"
        },
        workflows: {
            $ref: "workflowsDef"
        },
        disableStorageKey: {
            type: "boolean"
        },
        tags: {
            type: "object",
            additionalProperties: {
                type: "string"
            }
        },
        sanitizer: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    additionalProperties: !1,
                    properties: {
                        exclude: {
                            type: "array",
                            items: [
                                {
                                    type: "string"
                                }
                            ]
                        },
                        replacement: {
                            type: "string"
                        }
                    }
                }
            ]
        }
    }
}, Gt = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Preview",
    description: "Filestack Preview Options",
    type: "object",
    additionalProperties: !1,
    properties: {
        id: {
            type: "string"
        },
        css: {
            type: "string"
        }
    }
}, $t = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Upload",
    description: "Filestack Upload Options",
    type: "object",
    additionalProperties: !1,
    properties: {
        partSize: {
            type: "integer",
            minimum: 5242880
        },
        concurrency: {
            type: "integer",
            minimum: 1,
            maximum: 20
        },
        progressInterval: {
            type: "integer",
            minimum: 1
        },
        retry: {
            type: "integer",
            minimum: 0,
            maximum: 20
        },
        retryFactor: {
            type: "integer"
        },
        retryMaxTime: {
            type: "integer"
        },
        timeout: {
            type: "integer",
            minimum: 1,
            maximum: 36e5
        },
        intelligent: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "string",
                    "enum": [
                        "fallback"
                    ]
                }
            ]
        },
        intelligentChunkSize: {
            type: "integer"
        },
        onProgress: {
            format: "callback"
        },
        onRetry: {
            format: "callback"
        },
        disableIntegrityCheck: {
            type: "boolean"
        },
        tags: {
            type: "object",
            maxItems: 10,
            additionalProperties: {
                type: "string",
                maxlength: 256
            }
        }
    }
}, Zt = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Picker",
    description: "Filestack Picker Options",
    type: "object",
    additionalProperties: !1,
    properties: {
        allowManualRetry: {
            type: "boolean"
        },
        accept: {
            additionalProperties: !1,
            oneOf: [
                {
                    type: "string"
                },
                {
                    type: "array",
                    minItems: 1,
                    items: [
                        {
                            type: "string"
                        }
                    ]
                }
            ]
        },
        acceptFn: {
            format: "callback"
        },
        websearch: {
            type: "object",
            properties: {
                predefinedText: {
                    type: "string"
                }
            }
        },
        fromSources: {
            type: "array",
            items: {
                anyOf: [
                    {
                        type: "string",
                        "enum": [
                            "local_file_system",
                            "url",
                            "imagesearch",
                            "facebook",
                            "instagram",
                            "googledrive",
                            "picasa",
                            "unsplash",
                            "dropbox",
                            "webcam",
                            "video",
                            "audio",
                            "box",
                            "github",
                            "gmail",
                            "googlephotos",
                            "onedrive",
                            "onedriveforbusiness",
                            "clouddrive",
                            "customsource",
                            "tint"
                        ]
                    },
                    {
                        type: "object"
                    }
                ]
            }
        },
        container: {
            format: "HTMLContainer"
        },
        cleanupImageExif: {
            oneOf: [
                {
                    type: "boolean"
                },
                {
                    type: "object",
                    additionalProperties: !1,
                    properties: {
                        keepOrientation: {
                            type: "boolean"
                        },
                        keepICCandAPP: {
                            type: "boolean"
                        }
                    }
                }
            ]
        },
        displayMode: {
            type: "string",
            "enum": [
                "inline",
                "overlay",
                "dropPane"
            ]
        },
        concurrency: {
            type: "integer",
            minimum: 1,
            maximum: 20
        },
        supportEmail: {
            type: "string"
        },
        customSourceContainer: {
            type: "string"
        },
        customSourcePath: {
            type: "string"
        },
        customSourceName: {
            type: "string"
        },
        disableStorageKey: {
            type: "boolean"
        },
        disableTransformer: {
            type: "boolean"
        },
        disableAltText: {
            type: "boolean"
        },
        disableThumbnails: {
            type: "boolean"
        },
        exposeOriginalFile: {
            type: "boolean"
        },
        globalDropZone: {
            type: "boolean"
        },
        hideModalWhenUploading: {
            type: "boolean"
        },
        imageDim: {
            type: "array",
            minItems: 2,
            maxItems: 2,
            items: [
                {
                    type: "integer",
                    minimum: 1
                }
            ]
        },
        imageMax: {
            type: "array",
            minItems: 2,
            maxItems: 2,
            items: [
                {
                    type: "integer",
                    minimum: 1
                }
            ]
        },
        imageMin: {
            type: "array",
            minItems: 2,
            maxItems: 2,
            items: [
                {
                    type: "integer",
                    minimum: 1
                }
            ]
        },
        imageMinMaxBlock: {
            type: "boolean",
            "default": !1
        },
        lang: {
            type: "string",
            "enum": [
                "ca",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "he",
                "it",
                "ja",
                "ko",
                "nl",
                "no",
                "pl",
                "pt",
                "sv",
                "ru",
                "vi",
                "zh",
                "tr",
                "ar"
            ]
        },
        minFiles: {
            type: "integer",
            minimum: 1,
            maximum: 1e6
        },
        maxFiles: {
            type: "integer",
            minimum: 1,
            maximum: 1e6
        },
        maxSize: {
            type: "integer",
            minimum: 1
        },
        modalSize: {
            type: "array",
            minItems: 2,
            maxItems: 2,
            items: [
                {
                    type: "integer",
                    minimum: 1,
                    maximum: 1e6
                }
            ]
        },
        rootId: {
            type: "string"
        },
        startUploadingWhenMaxFilesReached: {
            type: "boolean"
        },
        uploadInBackground: {
            type: "boolean"
        },
        videoResolution: {
            type: "string"
        },
        onCancel: {
            format: "callback"
        },
        onClose: {
            format: "callback"
        },
        onOpen: {
            format: "callback"
        },
        onFileSelected: {
            format: "callback"
        },
        onFileUploadCancel: {
            format: "callback"
        },
        onFileUploadStarted: {
            format: "callback"
        },
        onFileUploadFinished: {
            format: "callback"
        },
        onFileUploadFailed: {
            format: "callback"
        },
        onFileUploadProgress: {
            format: "callback"
        },
        onUploadStarted: {
            format: "callback"
        },
        onUploadDone: {
            format: "callback"
        },
        onFileCropped: {
            format: "callback"
        },
        storeTo: {
            additionalProperties: !1,
            type: "object",
            properties: {
                filename: {
                    type: "string"
                },
                location: {
                    $ref: "locationsDef"
                },
                container: {
                    type: "string"
                },
                path: {
                    type: "string"
                },
                region: {
                    type: "string"
                },
                access: {
                    type: "string",
                    "enum": [
                        "public",
                        "private"
                    ]
                },
                workflows: {
                    $ref: "workflowsDef"
                }
            }
        },
        viewType: {
            type: "string",
            "enum": [
                "grid",
                "list"
            ]
        },
        transformations: {
            type: "object",
            additionalProperties: !1,
            properties: {
                config: {
                    type: "object"
                },
                circle: {
                    type: "boolean"
                },
                rotate: {
                    type: "boolean"
                },
                force: {
                    type: "boolean"
                },
                crop: {
                    oneOf: [
                        {
                            type: "boolean"
                        },
                        {
                            type: "object",
                            additionalProperties: !1,
                            properties: {
                                force: {
                                    type: "boolean"
                                },
                                aspectRatio: {
                                    type: "number"
                                },
                                autoCropArea: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 1
                                }
                            }
                        }
                    ]
                }
            }
        },
        customText: {
            type: "object",
            patternProperties: {
                ".*": {
                    type: "string"
                }
            }
        },
        cropFiles: {
            type: "array",
            minItems: 1
        },
        loadCss: {
            type: "string"
        },
        failOverMaxFiles: {
            type: "boolean"
        },
        dropPane: {
            type: "object",
            properties: {
                cropFiles: {
                    type: "array",
                    minItems: 1
                },
                customText: {
                    type: "string"
                },
                disableClick: {
                    type: "boolean"
                },
                overlay: {
                    type: "boolean"
                },
                showIcon: {
                    type: "boolean"
                },
                showProgress: {
                    type: "boolean"
                },
                onDragEnter: {
                    format: "callback"
                },
                onProgress: {
                    format: "callback"
                },
                onDragLeave: {
                    format: "callback"
                },
                onDragOver: {
                    format: "callback"
                },
                onDrop: {
                    format: "callback"
                },
                onSuccess: {
                    format: "callback"
                },
                onError: {
                    format: "callback"
                },
                onClick: {
                    format: "callback"
                }
            }
        },
        errorsTimeout: {
            type: "number",
            minimum: 0
        },
        customAuthText: {
            type: "object",
            patternProperties: {
                ".*": {
                    additionalProperties: !1,
                    type: "object",
                    required: [
                        "top",
                        "bottom"
                    ],
                    properties: {
                        top: {
                            type: "string"
                        },
                        bottom: {
                            type: "string"
                        }
                    }
                }
            }
        },
        uploadConfig: {
            type: "object",
            additionalProperties: !1,
            properties: (0, h.Cl)((0, h.Cl)({}, $t.properties), {
                tags: {
                    type: "object",
                    additionalProperties: {
                        anyOf: [
                            {
                                type: "string"
                            },
                            {
                                format: "callback"
                            }
                        ]
                    }
                }
            })
        },
        useSentryBreadcrumbs: {
            type: "boolean"
        },
        transformationsUI: {
            type: "boolean"
        },
        pasteMode: {
            type: "object",
            additionalProperties: !1,
            properties: {
                pasteToFirstInViewPort: {
                    type: "boolean"
                },
                pasteToFirstInstance: {
                    type: "boolean"
                }
            }
        },
        disableDirectoryUpload: {
            type: "boolean"
        },
        miniUploader: {
            type: "boolean"
        },
        multipleFileUpload: {
            type: "boolean"
        },
        googleDriveAppID: {
            type: "string"
        },
        googleAppOrigin: {
            type: "string"
        }
    }
}, Vt = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Metadata",
    description: "Filestack Metadata Options",
    type: "object",
    additionalProperties: !1,
    properties: {
        size: {
            type: "boolean"
        },
        mimetype: {
            type: "boolean"
        },
        filename: {
            type: "boolean"
        },
        width: {
            type: "boolean"
        },
        metadata: {
            type: "boolean"
        },
        height: {
            type: "boolean"
        },
        uploaded: {
            type: "boolean"
        },
        writeable: {
            type: "boolean"
        },
        cloud: {
            type: "boolean"
        },
        sourceUrl: {
            type: "boolean"
        },
        md5: {
            type: "boolean"
        },
        sha1: {
            type: "boolean"
        },
        sha224: {
            type: "boolean"
        },
        sha256: {
            type: "boolean"
        },
        sha384: {
            type: "boolean"
        },
        sha512: {
            type: "boolean"
        },
        location: {
            type: "boolean"
        },
        path: {
            type: "boolean"
        },
        container: {
            type: "boolean"
        },
        exif: {
            type: "boolean"
        }
    }
}, Ht = {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Filestack Retrieve",
    description: "Filestack Retrieve Options",
    type: "object",
    additionalProperties: !1,
    properties: {
        metadata: {
            type: "boolean"
        },
        head: {
            type: "boolean"
        },
        dl: {
            type: "boolean"
        },
        cache: {
            type: "boolean"
        },
        extension: {
            type: "string"
        }
    }
}, Yt = o(5934), Wt = o(6854), Kt = gt()("fs:request:dispatch"), Qt = function() {
    function t(t) {
        this.adapter = t;
    }
    return t.prototype.request = function(t) {
        var e = this;
        return t.headers = t.headers || {}, Kt("Dispatching request %O", t), this.adapter.request(t)["catch"](function(t) {
            return Kt('Request error "%s": %O', t, t.response), e.retry(t);
        });
    }, t.prototype.retry = function(t) {
        var e = this, r = t.config;
        if (!(0, Wt.S)(t)) return Kt("[Retry] Request error is not retriable. Exiting"), Promise.reject(t);
        if (!r.retry) return Kt("[Retry] Retry config not found. Exiting"), Promise.reject(t);
        var n = r.retry, _$o = r.runtime && r.runtime.retryCount ? r.runtime.retryCount : 0;
        if (n.retry && n.retry <= _$o) return Kt("[Retry] Retry attempts reached %d. Exiting", _$o), Promise.reject(t);
        var i = Math.max(Math.min(n.retryMaxTime, 1e3 * Math.pow(n.retryFactor, _$o)), 1);
        return r.runtime = (0, h.Cl)((0, h.Cl)({}, r.runtime), {
            retryCount: _$o + 1
        }), Kt("[Retry] Retrying request to ".concat(r.url, ", count ").concat(_$o, " of ").concat(n.retry, " - Delay: ").concat(i)), new Promise(function(t) {
            setTimeout(function() {
                return t(e.request(r));
            }, i);
        });
    }, t;
}(), Jt = o(3574).U, Xt = function() {
    function t(t) {
        this.defaults = t, this.dispatcher = new Qt(new Jt);
    }
    return t.getInstance = function() {
        return t.instance || (t.instance = new t), t.instance;
    }, t.prototype.dispatch = function(t) {
        return t.method || (t.method = Yt.j.GET), this.dispatcher.request(Object.assign({}, this.defaults, t));
    }, t.dispatch = function(e, r) {
        return t.getInstance().dispatch(Object.assign({}, r || {}, {
            url: e
        }));
    }, t.get = function(e, r) {
        return t.getInstance().dispatch(Object.assign({}, r || {}, {
            method: Yt.j.GET,
            url: e
        }));
    }, t.head = function(e, r) {
        return t.getInstance().dispatch(Object.assign({}, r || {}, {
            method: Yt.j.HEAD,
            url: e
        }));
    }, t.options = function(e, r) {
        return t.getInstance().dispatch(Object.assign({}, r || {}, {
            method: Yt.j.OPTIONS,
            url: e
        }));
    }, t.purge = function(e, r) {
        return t.getInstance().dispatch(Object.assign({}, r || {}, {
            method: Yt.j.PURGE,
            url: e
        }));
    }, t["delete"] = function(e, r) {
        return t.getInstance().dispatch(Object.assign({}, r || {}, {
            method: Yt.j.DELETE,
            url: e
        }));
    }, t.post = function(e, r, n) {
        return t.getInstance().dispatch(Object.assign({}, n || {}, {
            method: Yt.j.POST,
            url: e,
            data: r
        }));
    }, t.put = function(e, r, n) {
        return t.getInstance().dispatch(Object.assign({}, n || {}, {
            method: Yt.j.PUT,
            url: e,
            data: r
        }));
    }, t.path = function(e, r, n) {
        return t.getInstance().dispatch(Object.assign({}, n || {}, {
            method: Yt.j.PATH,
            url: e,
            data: r
        }));
    }, t;
}(), te = o(9653), ee = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return (0, h.C6)(e, t), e.prototype.cancel = function(t) {
        this.emit("cancel", t), this.removeAllListeners();
    }, e;
}(d), re = function re(t, e, r, n) {
    if (!e || "string" != typeof e) throw new pt("A valid Filestack handle is required for remove");
    if (!(t.policy && t.signature || n && n.policy && n.signature)) throw new pt("Security policy and signature are required for remove");
    var _$o = t.urls.fileApiUrl, i = "".concat(_$o, "/").concat(e), a = {
        key: t.apikey,
        policy: n && n.policy || t.policy,
        signature: n && n.signature || t.signature
    };
    return r && (a.skip_storage = !0), Xt["delete"](i, {
        filestackHeaders: !1,
        params: (0, yt.removeEmpty)(a)
    });
};
function ne(t) {
    return ne = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function ne(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, ne(t);
}
var oe, ie, ae, ce, se, ue, pe, le, fe, he, de, me, ye, ve, ge, be, xe, we, ke, Se = function t(e) {
    for(var r = {}, n = Object.keys(e), _$o = 0; _$o < n.length; _$o++){
        var i = n[_$o].split(/(?=[A-Z])/).join("_").toLowerCase();
        "object" !== ne(e[n[_$o]]) || Array.isArray(e[n[_$o]]) ? r[i] = e[n[_$o]] : r[i] = t(e[n[_$o]]);
    }
    return r;
};
!function(t) {
    t.left = "left", t.right = "right", t.center = "center", t.bottom = "bottom", t.top = "top";
}(oe || (oe = {})), function(t) {
    t.left = "left", t.right = "right", t.center = "center", t.bottom = "bottom", t.top = "top", t.faces = "faces";
}(ie || (ie = {})), function(t) {
    t.clip = "clip", t.crop = "crop", t.scale = "scale", t.max = "max";
}(ae || (ae = {})), function(t) {
    t.linear = "linear", t.gaussian = "gaussian";
}(ce || (ce = {})), function(t) {
    t.oval = "oval", t.rect = "rect";
}(se || (se = {})), function(t) {
    t.none = "none", t.low = "low", t.medium = "medium", t.high = "high";
}(ue || (ue = {})), function(t) {
    t.artwork = "artwork", t.photo = "photo";
}(pe || (pe = {})), function(t) {
    t.RGB = "RGB", t.CMYK = "CMYK", t.Input = "Input";
}(le || (le = {})), function(t) {
    t.thumb = "thumb", t.crop = "crop", t.fill = "fill";
}(fe || (fe = {})), function(t) {
    t.fit = "fit", t.auto = "auto";
}(he || (he = {})), function(t) {
    t.top = "top", t.middle = "middle", t.bottom = "bottom", t.left = "left", t.center = "center", t.right = "right";
}(de || (de = {})), function(t) {
    t.libmp3lame = "libmp3lame", t.libvorbis = "libvorbis", t.libfdk_aac = "libfdk_aac", t.dib_ac3 = "dib_ac3", t.pcm_s16le = "pcm_s16le", t.mp2 = "mp2", t.ac3 = "ac3", t.eac3 = "eac3";
}(me || (me = {})), function(t) {
    t.h264 = "h264", t.h264_hi = "h264.hi", t.webm = "webm", t["webm-hi"] = "webm.hi", t.ogg = "ogg", t["ogg-hi"] = "ogg.hi", t["hls-variant"] = "hls.variant", t.mp3 = "mp3", t.oga = "oga", t.m4a = "m4a", t.aac = "aac", t.hls = "hls.variant.audio";
}(ye || (ye = {})), function(t) {
    t.desktop = "desktop", t.mobile = "mobile";
}(ve || (ve = {})), function(t) {
    t.all = "all", t.window = "window";
}(ge || (ge = {})), function(t) {
    t.portrait = "portrait", t.landscape = "landscape";
}(be || (be = {})), function(t) {
    t.s3 = "s3", t.azure = "azure", t.gcs = "gcs", t.rackspace = "rackspace", t.dropbox = "dropbox";
}(xe || (xe = {})), function(t) {
    t["private"] = "private", t["public"] = "public";
}(we || (we = {})), function(t) {
    t.preserve = "preserve", t.constrain = "constrain", t.letterbox = "letterbox", t.pad = "pad", t.crop = "crop";
}(ke || (ke = {}));
var Ee = function Ee(t, e, r, n) {
    void 0 === r && (r = {}), void 0 === n && (n = !1), r = Se(r), t.policy && t.signature && (r.security = {
        policy: t.policy,
        signature: t.signature
    });
    var _$o = new Ut(e, t.apikey);
    return _$o.setCname(t.cname), _$o.setBase64(n), Object.keys(r).forEach(function(t) {
        ("boolean" != typeof r[t] || r[t] || "cache" === t) && _$o.addTask(t, r[t]);
    }), _$o.toString();
};
function Oe(t) {
    return Oe = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function Oe(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, Oe(t);
}
function je(t) {
    return je = "function" == typeof Symbol && "symbol" == (0, $2xTNA._)(Symbol.iterator) ? function je(t) {
        return typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t);
    }, je(t);
}
var Fe, _e = function() {
    function t(t, e) {
        this._file = t, this._sanitizeOptions = e, this._file.name = (0, yt.sanitizeName)(this._file.name, this._sanitizeOptions);
    }
    return Object.defineProperty(t.prototype, "name", {
        get: function get() {
            return this._file.name;
        },
        set: function set(t) {
            this._file.name = (0, yt.sanitizeName)(t, this._sanitizeOptions);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filename", {
        get: function get() {
            return this.name;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "customName", {
        set: function set(t) {
            switch(je(t)){
                case "string":
                    this.name = t;
                    break;
                case "function":
                    if ("string" != typeof t(this)) throw new Error("Name function must return a string. Current return type is ".concat(je(t)));
                    this.name = t(this);
            }
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "type", {
        get: function get() {
            return this._file.type || "application/octet-stream";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mimetype", {
        get: function get() {
            return this.type;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        get: function get() {
            return this._file.size;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.getPartsCount = function(t, e) {
        var r = e ? 84825604096 : 63350767616;
        if (this._file.size >= r) {
            var n = Math.ceil(this._file.size / 1e4);
            return {
                partsCount: Math.ceil(this._file.size / n),
                chunkSize: n
            };
        }
        return {
            partsCount: Math.ceil(this._file.size / t),
            chunkSize: t
        };
    }, t.prototype.getPartMetadata = function(t, e) {
        var r = e * t;
        if (r > this._file.size) throw new Error("Start byte of the part is higher than buffer size");
        var n = Math.min(r + e, this._file.size);
        return {
            partNumber: t,
            startByte: r,
            endByte: n,
            size: n - r
        };
    }, t.prototype.getPartByMetadata = function(t, e) {
        return void 0 === e && (e = !0), (0, h.sH)(this, void 0, void 0, function() {
            var r;
            return (0, h.YH)(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this._file.slice(t.startByte, t.endByte)
                        ];
                    case 1:
                        return r = n.sent(), [
                            2,
                            Promise.resolve((0, h.Cl)((0, h.Cl)({}, t), {
                                buffer: r,
                                md5: e ? (0, yt.md5)(r) : void 0
                            }))
                        ];
                }
            });
        });
    }, t.prototype.getChunkByMetadata = function(t, e, r, n) {
        return void 0 === n && (n = !0), (0, h.sH)(this, void 0, void 0, function() {
            var _$o, i, a;
            return (0, h.YH)(this, function(c) {
                switch(c.label){
                    case 0:
                        return _$o = t.startByte + e, i = Math.min(_$o + r, t.endByte), [
                            4,
                            this._file.slice(_$o, i)
                        ];
                    case 1:
                        return a = c.sent(), [
                            2,
                            Promise.resolve((0, h.Cl)((0, h.Cl)({}, t), {
                                buffer: a,
                                md5: n ? (0, yt.md5)(a) : void 0,
                                size: a.byteLength,
                                startByte: _$o,
                                endByte: i,
                                offset: e
                            }))
                        ];
                }
            });
        });
    }, t.prototype.release = function() {
        this._file.release && this._file.release();
    }, t.prototype.toJSON = function() {
        return {
            name: this.name,
            status: this.status,
            type: this.type,
            size: this.size,
            url: this.url,
            handle: this.handle,
            uploadTags: this.uploadTags
        };
    }, t;
}(), Pe = /data:([a-zA-Z]*\/[a-zA-Z]*);base64,([^\"]*)/i, Ae = function Ae(t, e, r) {
    var n, _$o;
    if (function(t) {
        return t && t.file && t.name;
    }(t) && (n = t.name, t = t.file), function(t) {
        return t instanceof File;
    }(t)) _$o = t, n = t.name;
    else if (function(t) {
        if ("string" != typeof t) return !1;
        t.indexOf("base64") > -1 && (t = t.match(Pe).pop());
        try {
            return btoa(atob(t)) === t;
        } catch (t) {
            return !1;
        }
    }(t)) _$o = function(t, e) {
        void 0 === e && (e = 512);
        var r = "";
        if (t.indexOf("base64") > -1) {
            var n = t.match(Pe);
            t = n.pop(), r = n[1];
        }
        for(var _$o = atob(t), i = [], a = 0; a < _$o.length; a += e){
            for(var c = _$o.slice(a, a + e), s = new Array(c.length), u = 0; u < c.length; u += 1)s[u] = c.charCodeAt(u);
            i.push(new Uint8Array(s));
        }
        return new Blob(i, {
            type: r
        });
    }(t);
    else {
        if (!function(t) {
            return "[object Blob]" === t.toString();
        }(t)) return Promise.reject(new pt("Unsupported input file type"));
        _$o = t;
    }
    return (function(t) {
        return (0, h.sH)(void 0, void 0, void 0, function() {
            return (0, h.YH)(this, function(e) {
                return File && FileReader && Blob ? [
                    2,
                    Promise.resolve({
                        slice: function slice(e, r) {
                            return function(t, e, r) {
                                return new Promise(function(n, o) {
                                    var i = new FileReader, a = r.slice(t, e);
                                    i.onload = function() {
                                        return n(i.result);
                                    }, i.onerror = o, i.readAsArrayBuffer(a);
                                });
                            }(e, r, t);
                        },
                        release: function release() {
                            t = null;
                        }
                    })
                ] : [
                    2,
                    Promise.reject(new pt("The File APIs are not fully supported by your browser"))
                ];
            });
        });
    })(_$o).then(function(t) {
        return (0, h.sH)(void 0, void 0, void 0, function() {
            var i, a;
            return (0, h.YH)(this, function(c) {
                switch(c.label){
                    case 0:
                        return i = _$o.type, _$o.type && 0 !== _$o.type.length && "text/plain" !== _$o.type ? [
                            3,
                            3
                        ] : (a = yt.getMimetype, [
                            4,
                            t.slice(0, 4100)
                        ]);
                    case 1:
                        return [
                            4,
                            a.apply(void 0, [
                                c.sent(),
                                n
                            ])
                        ];
                    case 2:
                        i = c.sent(), c.label = 3;
                    case 3:
                        return [
                            2,
                            new _e({
                                name: n,
                                size: _$o.size,
                                type: r || i,
                                slice: t.slice,
                                release: t.release
                            }, e)
                        ];
                }
            });
        });
    });
}, Te = o(3772), De = o(830), Le = 8388608, Ce = 32768, Ie = gt()("fs:upload:abstract"), ze = function(t) {
    function e(e, r) {
        void 0 === r && (r = 3);
        var n = t.call(this) || this;
        return n.storeOptions = e, n.concurrency = r, n.partSize = 6291456, n.intelligentChunkSize = (0, yt.isMobile)() ? 1048576 : Le, n.timeout = 3e4, n.uploadMode = "default", n.isModeLocked = !1, n.integrityCheck = !0, n.uploadTags = null, n;
    }
    return (0, h.C6)(e, t), e.prototype.setSecurity = function(t) {
        Ie("Set security %O", t), this.security = t;
    }, e.prototype.setApikey = function(t) {
        Ie("Set apikey to ".concat(t)), this.apikey = t;
    }, e.prototype.setTimeout = function(t) {
        Ie("Set request timeout to ".concat(t)), this.timeout = t;
    }, e.prototype.setRetryConfig = function(t) {
        Ie("Set retry config to ".concat(t)), this.retryConfig = t;
    }, e.prototype.setUrl = function(t) {
        Ie("Set upload url to ".concat(t)), this.url = t;
    }, e.prototype.setUploadTags = function(t) {
        Ie("Set tags to %O", t), this.uploadTags = t;
    }, e.prototype.setIntegrityCheck = function(t) {
        this.integrityCheck = t;
    }, e.prototype.setUploadMode = function(t, e) {
        void 0 === e && (e = !1), !0 !== this.isModeLocked ? (this.isModeLocked = e, Ie("Set upload mode to ".concat(t)), this.uploadMode = t) : Ie("Cannot switch mode to ".concat(t, ". Locked! Probably mode is not supported at this apikey"));
    }, e.prototype.setPartSize = function(t) {
        if ("default" === this.uploadMode) {
            if (Ie("Set part size to ".concat(t)), t < 5242880) throw new pt("Minimum part size is 5MB");
            this.partSize = t;
        } else Ie("Cannot set part size because upload mode is other than default. ");
    }, e.prototype.getPartSize = function() {
        return this.partSize;
    }, e.prototype.setIntelligentChunkSize = function(t) {
        if (Ie("Set inteligent chunk size to ".concat(t)), t < Ce) throw new pt("Minimum intelligent chunk size is ".concat(Ce));
        this.intelligentChunkSize = t;
    }, e.prototype.getIntelligentChunkSize = function() {
        return this.intelligentChunkSize;
    }, e.prototype.getUrl = function() {
        if (!this.url) throw new pt("Upload url not set");
        return this.url;
    }, e;
}(m), Ne = gt()("fs:upload:s3"), Re = function(t) {
    function e(e, r) {
        var n = t.call(this, e, r) || this;
        return n.payloads = {}, n.partsQueue = new Te.A({
            autoStart: !1,
            concurrency: n.concurrency
        }), n.cancelToken = new ee, n;
    }
    return (0, h.C6)(e, t), e.prototype.pause = function() {
        this.partsQueue.pause();
    }, e.prototype.resume = function() {
        this.partsQueue.isPaused && this.partsQueue.start();
    }, e.prototype.abort = function(t) {
        this.partsQueue.pause(), this.partsQueue.clear(), this.cancelToken.cancel(t || "Aborted by user");
    }, e.prototype.execute = function() {
        return (0, h.sH)(this, void 0, void 0, function() {
            var _$t, _$e = this;
            return (0, h.YH)(this, function(r) {
                return _$t = Object.keys(this.payloads).map(function(t) {
                    return new Promise(function(r) {
                        return (0, h.sH)(_$e, void 0, void 0, function() {
                            var _$e, n;
                            return (0, h.YH)(this, function(o) {
                                switch(o.label){
                                    case 0:
                                        return o.trys.push([
                                            0,
                                            5,
                                            ,
                                            6
                                        ]), [
                                            4,
                                            this.startRequest(t)
                                        ];
                                    case 1:
                                        return o.sent(), [
                                            4,
                                            this.prepareParts(t)
                                        ];
                                    case 2:
                                        return o.sent(), [
                                            4,
                                            this.startPartsQueue(t)
                                        ];
                                    case 3:
                                        return o.sent(), [
                                            4,
                                            this.completeRequest(t)
                                        ];
                                    case 4:
                                        return o.sent(), [
                                            3,
                                            6
                                        ];
                                    case 5:
                                        return _$e = o.sent(), this.emit("error", _$e), Ne("[".concat(t, "] File upload failed. %O, \nDetails: %O "), _$e.message, _$e.details), [
                                            3,
                                            6
                                        ];
                                    case 6:
                                        return (n = this.getPayloadById(t).file).release(), delete this.payloads[t], r(n), [
                                            2
                                        ];
                                }
                            });
                        });
                    });
                }), [
                    2,
                    Promise.all(_$t)
                ];
            });
        });
    }, e.prototype.addFile = function(t) {
        Ne("Add file to queue: \n %o", t);
        var _$e = "".concat((0, yt.uniqueId)(15), "_").concat((0, yt.uniqueTime)());
        return t.status = "Initialized", this.payloads[_$e] = {
            file: t,
            parts: []
        }, _$e;
    }, e.prototype.getUploadUrl = function(t) {
        var _$e = this.getDefaultFields(t, [
            "location_url"
        ]).location_url;
        return 0 === _$e.indexOf("http") ? _$e : "https://".concat(_$e);
    }, e.prototype.getStoreOptions = function(t) {
        var _$e = (0, h.Cl)({
            location: "s3"
        }, this.storeOptions);
        if (this.storeOptions.disableStorageKey) {
            var r = this.getPayloadById(t);
            _$e.path && "/" !== _$e.path.substr(-1) && (_$e.path = "".concat(_$e.path, "/")), _$e.path = "".concat(_$e.path ? _$e.path : "/").concat(r.file.name), delete _$e.disableStorageKey;
        }
        return _$e;
    }, e.prototype.getDefaultFields = function(t, e, r) {
        void 0 === r && (r = !1);
        var n = this.getPayloadById(t), _$o = (0, h.Cl)((0, h.Cl)({}, this.security), {
            apikey: this.apikey,
            uri: n.uri,
            location_url: n.location_url,
            upload_id: n.upload_id,
            region: n.region,
            alt: n.file.alt
        });
        return ("intelligent" === this.uploadMode || "fallback" === this.uploadMode && r) && (_$o.fii = !0), (0, h.Cl)((0, h.Cl)({}, (0, yt.filterObject)(_$o, e)), {
            store: this.getStoreOptions(t)
        });
    }, e.prototype.getDefaultHeaders = function(t) {
        var _$e = {}, r = this.getPayloadById(t);
        return r.location_region && (_$e["Filestack-Upload-Region"] = r.location_region), _$e;
    }, e.prototype.getPayloadById = function(t) {
        return this.payloads[t];
    }, e.prototype.prepareParts = function(t) {
        var _$e = this.getPayloadById(t).file, r = !1;
        [
            "intelligent",
            "fallback"
        ].indexOf(this.uploadMode) > -1 && (this.partSize = Le, r = !0);
        for(var n = _$e.getPartsCount(this.partSize, r), _$o = n.partsCount, i = n.chunkSize, a = [], c = 0; c < _$o; c++)a[c] = (0, h.Cl)((0, h.Cl)({}, _$e.getPartMetadata(c, i)), {
            offset: 0
        });
        return this.payloads[t].parts = a, Promise.resolve();
    }, e.prototype.startRequest = function(t) {
        var _$e = this, r = this.getPayloadById(t);
        return 0 === r.file.size ? (this.setPayloadStatus(t, "Failed"), Promise.reject(new pt('Invalid file "'.concat(r.file.name, '" size - 0'), {}, st.VALIDATION))) : (Ne("[".concat(t, "] Make start request")), Xt.post("".concat(this.getUrl(), "/multipart/start"), (0, h.Cl)({
            filename: r.file.name,
            mimetype: r.file.type,
            size: r.file.size
        }, this.getDefaultFields(t, [
            "apikey",
            "policy",
            "signature",
            "fii"
        ], !0)), {
            timeout: this.timeout,
            cancelToken: this.cancelToken,
            headers: this.getDefaultHeaders(t),
            retry: this.retryConfig
        }).then(function(r) {
            var n = r.data;
            return n && n.location_url && n.region && n.upload_id && n.uri ? (Ne("[".concat(t, "] Assign payload data: \n%O\n"), n), _$e.updatePayload(t, n), [
                "intelligent",
                "fallback"
            ].indexOf(_$e.uploadMode) > -1 && (!n.upload_type || "intelligent_ingestion" !== n.upload_type) && (Ne("[".concat(t, "] Intelligent Ingestion is not enabled on account, switch back to regular upload and lock mode change")), _$e.setUploadMode("default", !0)), n) : (Ne("[".concat(t, "] Incorrect start response: \n%O\n"), n), _$e.setPayloadStatus(t, "Failed"), Promise.reject(new pt("Incorrect start response", n, st.REQUEST)));
        })["catch"](function(r) {
            return Ne("[".concat(t, "] Start request error %O"), r), _$e.setPayloadStatus(t, "Failed"), _$e.rejectUpload("Cannot upload file. Start request failed", r);
        }));
    }, e.prototype.startPartsQueue = function(t) {
        return (0, h.sH)(this, void 0, void 0, function() {
            var _$e, r, n, _$o = this;
            return (0, h.YH)(this, function(i) {
                return _$e = this.getPayloadById(t), r = _$e.parts, n = r.length, Ne("[".concat(t, "] Create uploading queue from file. parts count - %d"), n), [
                    2,
                    new Promise(function(e, n) {
                        return (0, h.sH)(_$o, void 0, void 0, function() {
                            var _$o, i = this;
                            return (0, h.YH)(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return r.forEach(function(e) {
                                            return i.partsQueue.add(function() {
                                                return i.startPart(t, e.partNumber);
                                            })["catch"](function(e) {
                                                return i.setPayloadStatus(t, "Failed"), Ne("[".concat(t, "] Failed to upload part %s"), e.message), i.partsQueue.pause(), i.partsQueue.clear(), n(e);
                                            });
                                        }), Ne("[".concat(t, "] All tasks for %s enqueued. Start processing main upload queue"), t), this.emit("start"), this.partsQueue.start(), _$o = e, [
                                            4,
                                            this.partsQueue.onIdle()
                                        ];
                                    case 1:
                                        return _$o.apply(void 0, [
                                            a.sent()
                                        ]), [
                                            2
                                        ];
                                }
                            });
                        });
                    })
                ];
            });
        });
    }, e.prototype.startPart = function(t, e) {
        return Ne("[".concat(t, "] Start processing part ").concat(e, " with mode ").concat(this.uploadMode)), this.getPayloadById(t).file.status = "Progress", ("intelligent" !== this.uploadMode ? this.uploadRegular : this.uploadIntelligent).apply(this, [
            t,
            e
        ]);
    }, e.prototype.getS3PartMetadata = function(t, e, r) {
        var n = this, _$o = this.getUploadUrl(t);
        Ne("[".concat(t, "] Get data for part ").concat(e.partNumber, ", url ").concat(_$o, ", Md5: ").concat(e.md5, ", Size: ").concat(e.size));
        var i = (0, h.Cl)((0, h.Cl)({}, this.getDefaultFields(t, [
            "apikey",
            "uri",
            "region",
            "signature",
            "policy",
            "upload_id",
            "fii"
        ])), {
            part: e.partNumber + 1,
            size: e.size,
            offset: r
        });
        return this.integrityCheck && e.md5 && (i.md5 = e.md5), Xt.post("".concat(_$o, "/multipart/upload"), i, {
            headers: this.getDefaultHeaders(t),
            cancelToken: this.cancelToken,
            timeout: this.timeout,
            retry: this.retryConfig
        })["catch"](function(e) {
            return n.setPayloadStatus(t, "Failed"), n.rejectUpload("Cannot get part metadata", e);
        });
    }, e.prototype.uploadRegular = function(t, e) {
        return (0, h.sH)(this, void 0, void 0, function() {
            var r, n, _$o, i, a, c, s = this;
            return (0, h.YH)(this, function(u) {
                switch(u.label){
                    case 0:
                        return r = this.getPayloadById(t), n = r.parts[e], [
                            4,
                            r.file.getPartByMetadata(n, this.integrityCheck)
                        ];
                    case 1:
                        return _$o = u.sent(), [
                            4,
                            this.getS3PartMetadata(t, _$o)
                        ];
                    case 2:
                        return i = u.sent(), a = i.data, c = i.headers, Ne("[".concat(t, "] Received part ").concat(e, " info body: \n%O\n headers: \n%O\n"), a, c), [
                            2,
                            Xt.put(a.url, _$o.buffer, {
                                cancelToken: this.cancelToken,
                                timeout: this.timeout,
                                headers: a.headers,
                                filestackHeaders: !1,
                                onProgress: function onProgress(r) {
                                    return s.onProgressUpdate(t, e, r.loaded);
                                },
                                retry: this.retryConfig && "fallback" !== this.uploadMode ? this.retryConfig : void 0
                            }).then(function(r) {
                                if (!r.headers.etag) throw _$o = null, new pt("Cannot upload file, check S3 bucket settings", "Etag header is not exposed in CORS settings", st.REQUEST);
                                return s.setPartETag(t, e, r.headers.etag), Ne("[".concat(t, "] S3 Upload response headers for ").concat(e, ": \n%O\n"), r.headers), s.onProgressUpdate(t, e, _$o.size), _$o = null, r;
                            })["catch"](function(r) {
                                var n = r && r.response ? r.response : null;
                                if (n && 403 === n.status && n.data && n.data.Error && n.data.Error.code) {
                                    var i = n.data.Error.code;
                                    return Array.isArray(i) && (i = i.pop()), "RequestTimeTooSkewed" === i ? s.startPart(t, e) : Promise.reject(new pt("Cannot upload file", n.data.Error, st.REQUEST));
                                }
                                return _$o = null, r instanceof pt ? Promise.reject(r) : (s.onProgressUpdate(t, e, 0), "fallback" === s.uploadMode && !s.isModeLocked || "intelligent" === s.uploadMode ? (Ne("[".concat(t, "] Regular upload failed. Switching to intelligent ingestion mode")), s.setUploadMode("intelligent"), s.startPart(t, e)) : s.rejectUpload("Cannot upload file part", r));
                            })
                        ];
                }
            });
        });
    }, e.prototype.uploadIntelligent = function(t, e) {
        return (0, h.sH)(this, void 0, void 0, function() {
            var r = this;
            return (0, h.YH)(this, function(n) {
                return [
                    2,
                    this.uploadNextChunk(t, e).then(function() {
                        return r.commitPart(t, e);
                    })
                ];
            });
        });
    }, e.prototype.uploadNextChunk = function(t, e, r) {
        return void 0 === r && (r = this.intelligentChunkSize), (0, h.sH)(this, void 0, void 0, function() {
            var n, _$o, i, a, c = this;
            return (0, h.YH)(this, function(s) {
                switch(s.label){
                    case 0:
                        return n = this.getPayloadById(t), _$o = n.parts[e], r = _$o.size - _$o.offset, [
                            4,
                            n.file.getChunkByMetadata(_$o, _$o.offset, r, this.integrityCheck)
                        ];
                    case 1:
                        return i = s.sent(), Ne("[".concat(t, "] PartNum: ").concat(e, ", PartSize: ").concat(_$o.size, ", StartByte: ").concat(_$o.startByte, ", Offset: ").concat(_$o.offset, ", ChunkSize: ").concat(i.size, ",\n       Left: ").concat(_$o.size - _$o.offset - i.size)), [
                            4,
                            this.getS3PartMetadata(t, i, _$o.offset)["catch"](function(n) {
                                return Ne("[".concat(t, "] Getting chunk data for ii failed %O, Chunk size: ").concat(r, ", offset ").concat(_$o.offset, ", part ").concat(e), n), Promise.reject(n);
                            })
                        ];
                    case 2:
                        return a = s.sent().data, [
                            2,
                            Xt.put(a.url, i.buffer, {
                                cancelToken: this.cancelToken,
                                timeout: this.timeout,
                                headers: a.headers,
                                filestackHeaders: !1,
                                onProgress: function onProgress(r) {
                                    return _$o ? c.onProgressUpdate(t, e, _$o.offset + r.loaded) : null;
                                }
                            }).then(function(n) {
                                c.onProgressUpdate(t, e, _$o.offset + i.size);
                                var a = Math.min(_$o.offset + r, _$o.size);
                                return Ne("[".concat(t, "] S3 Chunk uploaded! offset: ").concat(_$o.offset, ", part ").concat(e, "! response headers for ").concat(e, ": \n%O\n"), n.headers), c.setPartData(t, e, "offset", a), a === _$o.size ? Promise.resolve(n) : (_$o = null, i = null, c.uploadNextChunk(t, e, r));
                            })["catch"](function(n) {
                                var a = n && n.response ? n.response : null;
                                if (a && 403 === a.status && a.data && a.data.Error && a.data.Error.code) {
                                    var _$s = a.data.Error.code;
                                    return Array.isArray(_$s) && (_$s = _$s.pop()), "RequestTimeTooSkewed" === _$s ? c.startPart(t, e) : Promise.reject(new pt("Cannot upload file", a.data.Error, st.REQUEST));
                                }
                                c.onProgressUpdate(t, e, _$o.offset);
                                var u = Math.ceil(r / 2);
                                return u < Ce ? (Ne("[".concat(t, "] Minimal chunk size limit. Upload file failed!")), Promise.reject(new pt("Min chunk size reached", n.data, st.REQUEST))) : (0, De.Sc)(n) ? (Ne("[".concat(t, "] Request network error. Retry with new chunk size: ").concat(u)), c.uploadNextChunk(t, e, u)) : (_$o = null, i = null, c.rejectUpload("Cannot upload file part (FII)", n));
                            })
                        ];
                }
            });
        });
    }, e.prototype.commitPart = function(t, e) {
        var r = this, n = this.getPayloadById(t), _$o = n.parts[e];
        return Xt.post("".concat(this.getUploadUrl(t), "/multipart/commit"), (0, h.Cl)((0, h.Cl)({}, this.getDefaultFields(t, [
            "apikey",
            "region",
            "upload_id",
            "policy",
            "signature",
            "uri"
        ])), {
            size: n.file.size,
            part: _$o.partNumber + 1
        }), {
            cancelToken: this.cancelToken,
            timeout: this.timeout,
            headers: this.getDefaultHeaders(t),
            retry: this.retryConfig
        }).then(function(e) {
            return Ne("[".concat(t, "] Commit Part number ").concat(_$o.partNumber, ". Response: %O"), e.data), e;
        })["catch"](function(t) {
            return r.rejectUpload("Cannot commit file part metadata", t);
        });
    }, e.prototype.completeRequest = function(t) {
        var _$e = this, r = this.getPayloadById(t), n = [];
        Ne("[".concat(t, "] Run complete request"));
        for(var _$o = r.parts, i = _$o.length, a = 0; a < i; a++)_$o[a].etag && n.push({
            part_number: a + 1,
            etag: _$o[a].etag
        });
        return Ne("[".concat(t, "] Etags %O"), n), Xt.post("".concat(this.getUploadUrl(t), "/multipart/complete"), (0, h.Cl)((0, h.Cl)({}, this.getDefaultFields(t, [
            "apikey",
            "policy",
            "signature",
            "uri",
            "region",
            "upload_id",
            "fii",
            "alt"
        ], !0)), {
            filename: r.file.name,
            mimetype: r.file.type,
            size: r.file.size,
            upload_tags: this.uploadTags && Object.keys(this.uploadTags).length ? this.uploadTags : void 0,
            parts: n.length ? n : void 0
        }), {
            timeout: this.timeout,
            cancelToken: this.cancelToken,
            headers: this.getDefaultHeaders(t),
            retry: this.retryConfig
        }).then(function(r) {
            if (202 === r.status) return new Promise(function(r, n) {
                setTimeout(function() {
                    return _$e.completeRequest(t).then(r)["catch"](n);
                }, 1e3);
            });
            var n = _$e.getPayloadById(t).file;
            return n.handle = r.data.handle, n.url = r.data.url, n.container = r.data.container, n.key = r.data.key, n.uploadTags = r.data.upload_tags, n.workflows = r.data.workflows, n.status = r.data.status, n;
        })["catch"](function(r) {
            return _$e.setPayloadStatus(t, "Failed"), _$e.rejectUpload("Cannot complete file", r);
        });
    }, e.prototype.onProgressUpdate = function(t, e, r) {
        this.setPartData(t, e, "progress", r), this.emitProgress();
    }, e.prototype.emitProgress = function() {
        var _$t = 0, _$e = 0, r = {};
        for(var n in this.payloads){
            var _$o = this.payloads[n];
            if ("Failed" !== _$o.file.status) {
                var i = _$o.parts.map(function(t) {
                    return t.progress || 0;
                }).reduce(function(t, e) {
                    return t + e;
                }, 0);
                _$e += i, r[n] = {
                    totalBytes: i,
                    totalPercent: Math.round(100 * i / _$o.file.size) || 0
                }, _$t += _$o.file.size;
            }
        }
        var a = {
            totalBytes: _$e || 0,
            totalPercent: Math.round(100 * _$e / _$t) || 0,
            files: r
        };
        Ne("Upload progress %O", a), this.emit("progress", a);
    }, e.prototype.updatePayload = function(t, e) {
        this.payloads[t] = (0, h.Cl)((0, h.Cl)({}, this.payloads[t]), e);
    }, e.prototype.setPartETag = function(t, e, r) {
        Ne("[".concat(t, "] Set ").concat(r, " etag for part ").concat(e)), this.getPayloadById(t).parts[e].etag = r;
    }, e.prototype.setPartData = function(t, e, r, n) {
        Ne("[".concat(t, "] Set ").concat(r, " = ").concat(n, " for part ").concat(e));
        var _$o = this.getPayloadById(t);
        _$o ? _$o.parts[e][r] = n : Ne("[".concat(t, "] Cannot set ").concat(r, " = ").concat(n, " for part ").concat(e));
    }, e.prototype.setPayloadStatus = function(t, e) {
        Ne("[".concat(t, "] Set payload status to ").concat(e)), this.payloads[t] && (this.payloads[t].file.status = e);
    }, e.prototype.parseError = function(t) {
        return t.response ? {
            code: t.response.status,
            data: t.response.data,
            headers: t.response.headers
        } : {};
    }, e.prototype.rejectUpload = function(t, e) {
        return e instanceof te.d && e.code === te.E.ABORTED ? Promise.reject(new pt(t, {
            reason: e.message
        }, st.ABORTED)) : Promise.reject(new pt(t, this.parseError(e), st.REQUEST));
    }, e;
}(ze), Me = function Me(t, e) {
    return t.totalBytes = Math.max(t.totalBytes, e.totalBytes), t.totalPercent = Math.max(t.totalPercent, e.totalPercent), t;
}, Be = function(t) {
    function e(e, r) {
        void 0 === e && (e = {}), void 0 === r && (r = {});
        var n = t.call(this) || this;
        n.options = e, n.storeOptions = r, n.lastProgress = {
            totalBytes: 0,
            totalPercent: 0
        }, n.storeOptions = Object.assign({}, r);
        var _$o = mt($t)(e);
        if (_$o.errors.length) throw new pt("Invalid upload params", _$o.errors, st.VALIDATION);
        var i = mt(qt)(r);
        if (i.errors.length) throw new pt("Invalid store upload params", i.errors, st.VALIDATION);
        return r.filename && (n.overrideFileName = r.filename, delete n.storeOptions.filename), n.storeOptions.sanitizer && (n.sanitizerOptions = n.storeOptions.sanitizer, delete n.storeOptions.sanitizer), r.altText && (n.altText = r.altText, delete n.storeOptions.altText), r.mimetype && (n.mimetype = r.mimetype, delete n.storeOptions.mimetype), n.uploader = new Re(n.storeOptions, e.concurrency), n.uploader.setRetryConfig({
            retry: e.retry || 10,
            onRetry: e.onRetry,
            retryFactor: e.retryFactor || 2,
            retryMaxTime: e.retryMaxTime || 15e3
        }), n.uploader.setTimeout(e.timeout || 12e4), e.partSize && n.uploader.setPartSize(e.partSize), e.intelligentChunkSize && n.uploader.setIntelligentChunkSize(e.intelligentChunkSize), e.disableIntegrityCheck && n.uploader.setIntegrityCheck(!1), e.intelligent && n.uploader.setUploadMode("fallback" === e.intelligent ? "fallback" : "intelligent"), n.uploader.setUploadTags(e.tags), n.uploader.on("start", function() {
            return n.emit("start");
        }), n.uploader.on("error", function(t) {
            return n.emit("error", t);
        }), n.uploader.on("progress", n.handleProgress.bind(n)), n;
    }
    return (0, h.C6)(e, t), e.prototype.setSession = function(t) {
        this.uploader.setApikey(t.apikey), t.policy && t.signature && this.uploader.setSecurity({
            policy: t.policy,
            signature: t.signature
        }), this.uploader.setUrl(t.urls.uploadApiUrl);
    }, e.prototype.setToken = function(t) {
        var _$e = this;
        if (!t || t !== Object(t)) throw new Error("Incorrect upload token. Must be instance of object");
        return t.pause = function() {
            return _$e.uploader.pause();
        }, t.resume = function() {
            return _$e.uploader.resume();
        }, t.cancel = function() {
            return _$e.uploader.abort();
        }, t;
    }, e.prototype.setSecurity = function(t) {
        this.uploader.setSecurity(t);
    }, e.prototype.setUploadTags = function(t) {
        this.uploader.setUploadTags(t);
    }, e.prototype.upload = function(t) {
        return (0, h.sH)(this, void 0, void 0, function() {
            var _$e, r;
            return (0, h.YH)(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            Ae(t, this.sanitizerOptions, this.mimetype)
                        ];
                    case 1:
                        return (_$e = n.sent()).customName = this.overrideFileName, this.altText && (_$e.alt = this.altText), this.uploader.addFile(_$e), this.startProgressInterval(), [
                            4,
                            this.uploader.execute()
                        ];
                    case 2:
                        return r = n.sent().shift(), this.stopProgressInterval(), this.uploader.removeAllListeners(), "Failed" === r.status ? [
                            2,
                            Promise.reject(r)
                        ] : [
                            2,
                            Promise.resolve(r)
                        ];
                }
            });
        });
    }, e.prototype.multiupload = function(t) {
        return (0, h.sH)(this, void 0, void 0, function() {
            var _$e, r, n, _$o, i, a, c;
            return (0, h.YH)(this, function(s) {
                switch(s.label){
                    case 0:
                        for(n in r = [], _$e = t)r.push(n);
                        _$o = 0, s.label = 1;
                    case 1:
                        return _$o < r.length ? (n = r[_$o]) in _$e ? (i = n, t.hasOwnProperty(i) ? [
                            4,
                            Ae(t[i], this.sanitizerOptions, this.mimetype)
                        ] : [
                            3,
                            3
                        ]) : [
                            3,
                            3
                        ] : [
                            3,
                            4
                        ];
                    case 2:
                        (a = s.sent()).customName = this.overrideFileName, this.altText && (a.alt = this.altText), this.uploader.addFile(a), s.label = 3;
                    case 3:
                        return _$o++, [
                            3,
                            1
                        ];
                    case 4:
                        return this.startProgressInterval(), [
                            4,
                            this.uploader.execute()
                        ];
                    case 5:
                        return c = s.sent(), this.stopProgressInterval(), this.uploader.removeAllListeners(), [
                            2,
                            Promise.resolve(c)
                        ];
                }
            });
        });
    }, e.prototype.startProgressInterval = function() {
        var _$t = this;
        "function" == typeof this.options.onProgress && (this.progressIntervalHandler = setInterval(function() {
            _$t.options.onProgress(_$t.lastProgress);
        }, this.options.progressInterval || 1e3), this.options.onProgress(this.lastProgress));
    }, e.prototype.stopProgressInterval = function() {
        clearInterval(this.progressIntervalHandler);
    }, e.prototype.handleProgress = function(t) {
        if (t = Me(t, this.lastProgress), this.lastProgress.files) for(var _$e in t.files)this.lastProgress.files[_$e] && (t.files[_$e] = Me(t.files[_$e], this.lastProgress.files[_$e]));
        this.lastProgress = t;
    }, e;
}(d), Ue = gt()("fs:storage"), qe = function() {
    function t() {
        this.availableTypes = [], void 0 !== window.localStorage && (this.availableTypes.push(Fe.LOCAL), Ue("Local storage exists")), void 0 !== window.sessionStorage && (this.availableTypes.push(Fe.SESSION), Ue("Session storage exists")), Ue("availableTypes - %O", this.availableTypes);
    }
    return t.prototype.hasAccess = function(t) {
        return Ue("Checking access to storage for %s. Available types: %O", t, this.availableTypes), t ? this.availableTypes.indexOf(t) > -1 : !!this.availableTypes.length;
    }, t.prototype.getItem = function(t, e) {
        var r = this.getStore(e);
        if (Ue("getItem %s from %O", t, r), r) return r.getItem(t);
    }, t.prototype.setItem = function(t, e, r) {
        var n = this.getStore(r);
        if (Ue("setItem %s to %O", t, n), n) return n.setItem(t, e);
    }, t.prototype.removeItem = function(t, e) {
        var r = this.getStore(e);
        if (Ue("removeItem %s from %O", t, r), r) return r.removeItem(t);
    }, t.prototype.getStore = function(t) {
        if (Ue("get store with pref type - %s", t), this.hasAccess(t)) switch(t){
            case Fe.LOCAL:
                return window.localStorage;
            case Fe.SESSION:
                return window.sessionStorage;
            default:
                return window[this.availableTypes[0]];
        }
        else Ue("User dont have access to any storage");
    }, t;
}();
!function(t) {
    t.SESSION = "sessionStorage", t.LOCAL = "localStorage";
}(Fe || (Fe = {}));
var Ge, $e = "__fs_picker_token", Ze = function() {
    function t(t, e) {
        this.cache = !1, this.session = t, this.storeAdapter = new qe, this.cloudApiUrl = t.urls.cloudApiUrl, e && e.sessionCache && (this.cache = e.sessionCache);
    }
    return Object.defineProperty(t.prototype, "token", {
        get: function get() {
            if (this.cache) {
                var _$t = this.storeAdapter.getItem($e, Fe.LOCAL);
                if (_$t) return _$t;
            }
            return this.isInAppBrowser ? this.storeAdapter.getItem($e, Fe.SESSION) : this._token;
        },
        set: function set(t) {
            this.cache && this.storeAdapter.setItem($e, t, Fe.LOCAL), this.isInAppBrowser && this.storeAdapter.setItem($e, t, Fe.SESSION), this._token = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isInAppBrowser", {
        get: function get() {
            return !!(this.session && this.session.prefetch && this.session.prefetch.settings && this.session.prefetch.settings.inapp_browser) && this.session.prefetch.settings.inapp_browser;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.list = function(t, e, r) {
        var n = this, _$o = {
            apikey: this.session.apikey,
            clouds: t,
            flow: "web",
            token: this.token
        };
        r && (Array.isArray(r) || (r = [
            r
        ]), r.includes("application/x-subrip") && !r.includes("application/octet-stream") && r.push("application/octet-stream"), _$o.accept = r), this.isInAppBrowser && (_$o.appurl = this.currentAppUrl()), this.session.policy && this.session.signature && (_$o.policy = this.session.policy, _$o.signature = this.session.signature);
        var i = {};
        if (e) {
            var a = new ee;
            e.cancel = a.cancel.bind(a), i.cancelToken = a;
        }
        return Xt.post("".concat(this.cloudApiUrl, "/folder/list"), _$o, i).then(function(t) {
            return t.data && t.data.token && (n.token = t.data.token), t.data;
        });
    }, t.prototype.store = function(t, e, r, n, o, i, a) {
        var c, s = this;
        void 0 === r && (r = {}), void 0 === n && (n = {}), void 0 === i && (i = null), void 0 === r.location && (r.location = "s3");
        var u = {
            apikey: this.session.apikey,
            token: this.token,
            flow: "web",
            upload_tags: i || void 0,
            clouds: (c = {}, c[t] = {
                path: e,
                picker_session_id: a,
                store: (0, yt.removeEmpty)(r)
            }, c)
        };
        "customsource" === t && n.customSourcePath && (u.clouds.customsource.customSourcePath = n.customSourcePath), "customsource" === t && n.customSourceContainer && (u.clouds.customsource.customSourceContainer = n.customSourceContainer), this.session.policy && this.session.signature && (u.policy = this.session.policy, u.signature = this.session.signature);
        var p = {};
        if (o) {
            var l = new ee;
            o.cancel = l.cancel.bind(l), p.cancelToken = l;
        }
        return Xt.post("".concat(this.cloudApiUrl, "/store/"), u, p).then(function(e) {
            return e.data && e.data.token && (s.token = e.data.token), e.data && e.data[t] ? e.data[t] : e.data;
        });
    }, t.prototype.logout = function(t) {
        var e, r = {
            apikey: this.session.apikey,
            flow: "web",
            token: this.token
        };
        return t ? r.clouds = ((e = {})[t] = {}, e) : (this.cache && this.storeAdapter.removeItem($e, Fe.LOCAL), this.isInAppBrowser && this.storeAdapter.removeItem($e, Fe.SESSION)), Xt.post("".concat(this.cloudApiUrl, "/auth/logout"), r).then(function(e) {
            return e.data && e.data[t] ? e.data[t] : e.data;
        });
    }, t.prototype.metadata = function(t, e) {
        var r = {
            apikey: this.session.apikey,
            url: t,
            headers: e
        };
        return this.session.policy && this.session.signature && (r.policy = this.session.policy, r.signature = this.session.signature), Xt.post("".concat(this.cloudApiUrl, "/metadata"), r).then(function(t) {
            return t.data;
        });
    }, t.prototype.tokInit = function(t) {
        if ("video" !== t && "audio" !== t) throw new pt("Type must be one of video or audio.");
        return Xt.post("".concat(this.cloudApiUrl, "/recording/").concat(t, "/init")).then(function(t) {
            return t.data;
        });
    }, t.prototype.tokStart = function(t, e, r) {
        if ("video" !== t && "audio" !== t) throw new pt("Type must be one of video or audio.");
        var n = {
            apikey: e,
            session_id: r
        };
        return Xt.post("".concat(this.cloudApiUrl, "/recording/").concat(t, "/start"), n).then(function(t) {
            return t.data;
        });
    }, t.prototype.tokStop = function(t, e, r, n) {
        if ("video" !== t && "audio" !== t) throw new pt("Type must be one of video or audio.");
        var _$o = {
            apikey: e,
            session_id: r,
            archive_id: n
        };
        return Xt.post("".concat(this.cloudApiUrl, "/recording/").concat(t, "/stop"), _$o).then(function(t) {
            return t.data;
        });
    }, t.prototype.currentAppUrl = function() {
        if (window.URLSearchParams) {
            var _$t = new URLSearchParams(window.location.search);
            return _$t.set("fs-tab", "init"), "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(_$t.toString());
        }
    }, t;
}(), Ve = o(395), He = o.n(Ve);
!function(t) {
    t.PICKER = "picker", t.TRANSFORM_UI = "transform_ui";
}(Ge || (Ge = {}));
var Ye, We, Ke = function() {
    function t(t) {
        this.session = t instanceof Je ? t.session : t;
    }
    return t.prototype.getConfig = function(t) {
        var e = t.pickerOptions, r = t.settings, n = t.permissions, _$o = t.events;
        return (0, h.sH)(this, void 0, void 0, function() {
            var _$t, i, a = this;
            return (0, h.YH)(this, function(c) {
                return _$t = {
                    apikey: this.session.apikey
                }, this.session.policy && this.session.signature && (_$t.security = {
                    policy: this.session.policy,
                    signature: this.session.signature
                }), r = r ? (r = r.concat([
                    "inapp_browser"
                ])).filter(function(t, e) {
                    return r.indexOf(t) === e;
                }) : [
                    "inapp_browser"
                ], e && Object.keys(e).length && (i = (0, yt.cleanUpCallbacks)(He()((0, h.Cl)({}, e)))), _$t = (0, h.Cl)((0, h.Cl)({}, _$t), {
                    permissions: n,
                    settings: r,
                    picker_config: i,
                    events: _$o
                }), this.session.prefetch = null, [
                    2,
                    Xt.post("".concat(this.session.urls.uploadApiUrl, "/prefetch"), _$t).then(function(t) {
                        if (200 !== t.status) throw new pt("There is a problem with prefetch request");
                        var r = t.data;
                        return r.updated_config ? (r.pickerOptions = a.reassignCallbacks(e, r.updated_config || {}), delete r.updated_config) : r.pickerOptions = e, a.session.prefetch = r, r;
                    })
                ];
            });
        });
    }, t.prototype.reassignCallbacks = function(t, e) {
        if (!t || 0 === Object.keys(t).length) return t;
        for(var r in t)"function" == typeof t[r] && (e[r] = t[r]), t[r] === Object(t[r]) && (e[r] = this.reassignCallbacks(t[r], e[r]));
        return e;
    }, t;
}();
!function(t) {
    t.cw = "CW", t.ccw = "CCW";
}(Ye || (Ye = {})), function(t) {
    t.inline = "inline", t.overlay = "overlay", t.dropPane = "dropPane";
}(We || (We = {}));
var Qe = function() {
    function t(t, e) {
        var r = mt(Zt)(e);
        r.errors.length && (r.errors.forEach(function(t) {
            if (!t.path.includes("fromSources")) throw new pt("Invalid picker params", r.errors, st.VALIDATION);
            console.warn('Warning: Invalid source "'.concat(t.instance, '" found and removed!')), e.fromSources = e.fromSources.filter(function(e) {
                return e !== t.instance;
            });
        }), e.fromSources.length || delete e.fromSources), this._initialized = this.loadModule(t, e);
    }
    return t.prototype.open = function() {
        return (0, h.sH)(this, void 0, void 0, function() {
            return (0, h.YH)(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this._initialized
                        ];
                    case 1:
                        return [
                            4,
                            t.sent().open()
                        ];
                    case 2:
                        return t.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.crop = function(t) {
        return (0, h.sH)(this, void 0, void 0, function() {
            return (0, h.YH)(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this._initialized
                        ];
                    case 1:
                        return [
                            4,
                            e.sent().crop(t)
                        ];
                    case 2:
                        return e.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.close = function() {
        return (0, h.sH)(this, void 0, void 0, function() {
            return (0, h.YH)(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this._initialized
                        ];
                    case 1:
                        return [
                            4,
                            t.sent().close()
                        ];
                    case 2:
                        return t.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.cancel = function() {
        return (0, h.sH)(this, void 0, void 0, function() {
            return (0, h.YH)(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this._initialized
                        ];
                    case 1:
                        return [
                            4,
                            t.sent().cancel()
                        ];
                    case 2:
                        return t.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadModule = function(t, e) {
        return (0, h.sH)(this, void 0, void 0, function() {
            var r;
            return (0, h.YH)(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = t.session.urls.pickerUrl, [
                            4,
                            s(p.PICKER, r)
                        ];
                    case 1:
                        return [
                            2,
                            new (n.sent())(t, e)
                        ];
                }
            });
        });
    }, t;
}();
!function(t, e) {
    var r = ot(b()).getCurrentScope().getClient(), n = ot(b()).getIsolationScope();
    if (r) {
        var _$o = r.getOptions(), i = _$o.beforeBreadcrumb, a = void 0 === i ? null : i, c = _$o.maxBreadcrumbs, s = void 0 === c ? 100 : c;
        if (!(s <= 0)) {
            var u = function(t) {
                for(var _$e = 1; _$e < arguments.length; _$e++){
                    var r = null != arguments[_$e] ? arguments[_$e] : {};
                    _$e % 2 ? ct(Object(r), !0).forEach(function(e) {
                        var n, _$o, i, a;
                        n = t, _$o = e, i = r[e], a = function(t) {
                            if ("object" != at(t) || !t) return t;
                            var _$e = t[Symbol.toPrimitive];
                            if (void 0 !== _$e) {
                                var r = _$e.call(t, "string");
                                if ("object" != at(r)) return r;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(t);
                        }(_$o), (_$o = "symbol" == at(a) ? a : String(a)) in n ? Object.defineProperty(n, _$o, {
                            value: i,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : n[_$o] = i;
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }({
                timestamp: w()
            }, {
                category: "sdk",
                message: "filestack-js-sdk scope"
            }), p = a ? P(function() {
                return a(u, e);
            }) : u;
            null !== p && (r.emit && r.emit("beforeAddBreadcrumb", p, e), n.addBreadcrumb(p, s));
        }
    }
}();
var Je = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        if (n.options = r, n.forwardErrors = !0, r && r.forwardErrors && (n.forwardErrors = r.forwardErrors), !e || "string" != typeof e || 0 === e.length) throw new Error("An apikey is required to initialize the Filestack client");
        var _$o = ut.urls;
        if (n.session = {
            apikey: e,
            urls: _$o
        }, r) {
            var i = r.cname, a = r.security;
            n.setSecurity(a), n.setCname(i);
        }
        return n.prefetchInstance = new Ke(n.session), n.cloud = new Ze(n.session, r), n;
    }
    return (0, h.C6)(e, t), Object.defineProperty(e.prototype, "utils", {
        get: function get() {
            return yt;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.prefetch = function(t) {
        return this.prefetchInstance.getConfig(t);
    }, e.prototype.setSecurity = function(t) {
        if (t && (!t.policy || !t.signature)) throw new pt("Both policy and signature are required for client security");
        t && t.policy && t.signature && (this.session.policy = t.policy, this.session.signature = t.signature);
    }, e.prototype.setCname = function(t) {
        t && 0 !== t.length && (this.session.cname = t, this.session.urls = yt.resolveHost(this.session.urls, t));
    }, e.prototype.logout = function(t) {
        return this.cloud.logout(t);
    }, e.prototype.metadata = function(t, e, r) {
        return function(t, e, r, n) {
            if (!e || "string" != typeof e) throw new pt("A valid Filestack handle is required for metadata");
            var _$o = mt(Vt)(r);
            if (_$o.errors.length) throw new pt("Invalid metadata params", _$o.errors);
            var i = (0, h.Cl)({}, r);
            i.source_url = i.sourceUrl, i.policy = n && n.policy || t.policy, i.signature = n && n.signature || t.signature;
            var a = "".concat(t.urls.fileApiUrl, "/").concat(e, "/metadata");
            return new Promise(function(t, r) {
                Xt.get(a, {
                    params: (0, yt.removeEmpty)(i),
                    filestackHeaders: !1
                }).then(function(r) {
                    return t((0, h.Cl)((0, h.Cl)({}, r.data), {
                        handle: e
                    }));
                })["catch"](r);
            });
        }(this.session, t, e, r);
    }, e.prototype.picker = function(t) {
        return function(t, e) {
            return new Qe(t, e);
        }(this, t);
    }, e.prototype.preview = function(t, e) {
        return function(t, e, r) {
            if (!e || "string" != typeof e) throw new Error("A valid Filestack handle or storage alias is required for preview");
            var n = mt(Gt)(r);
            if (n.errors.length) throw new pt("Invalid preview params", n.errors, st.VALIDATION);
            var _$o = (0, yt.removeEmpty)(r || {}), i = function(t, e, r) {
                var n = (0, h.Cl)({}, r), _$o = t.policy, i = t.signature, a = i && _$o, c = [
                    t.urls.cdnUrl
                ], s = n.css && encodeURIComponent('"'.concat(n.css, '"')), u = s ? "preview=css:".concat(s) : "preview";
                return -1 !== e.indexOf("src:") ? c.push("".concat(t.apikey, "/").concat(u)) : c.push(u), a && c.push("security=policy:".concat(_$o, ",signature:").concat(i)), c.push(e), c.join("/");
            }(t, e, _$o);
            if (_$o && _$o.id) {
                var a = _$o.id, c = document.createElement("iframe"), s = document.getElementById(a);
                if (c.src = i, c.width = "100%", c.height = "100%", !s) throw new Error('DOM Element with id "'.concat(a, '" not found.'));
                return s.appendChild(c);
            }
            return window.open(i, e);
        }(this.session, t, e);
    }, e.prototype.remove = function(t, e) {
        return re(this.session, t, !1, e);
    }, e.prototype.removeMetadata = function(t, e) {
        return re(this.session, t, !0, e);
    }, e.prototype.storeURL = function(t, e, r, n, o, i, a) {
        return function(t) {
            var _$e = t.session, _$r = t.url, _$n = t.storeParams, _$o = t.token, _$i = t.security, _$a = t.uploadTags, c = t.headers, s = t.workflowIds;
            if (!_$r || "string" != typeof _$r) return Promise.reject(new pt("url is required for storeURL"));
            var u = mt(qt)(_$n);
            if (u.errors.length) return Promise.reject(new pt("Invalid store params", u.errors));
            _$e.policy = _$i && _$i.policy || _$e.policy, _$e.signature = _$i && _$i.signature || _$e.signature;
            var p = new Ut(_$r, _$e.apikey);
            _$r && "object" === Oe(_$n) && null !== _$n && (_$n.mimetype && delete _$n.mimetype, _$n.altText && delete _$n.altText), p.store(_$n), _$e.policy && _$e.signature && p.security({
                policy: _$e.policy,
                signature: _$e.signature
            });
            var l = {};
            if (_$o) {
                var f = new ee;
                _$o.cancel = f.cancel.bind(f), l.cancelToken = f;
            }
            var d = [
                _$r
            ];
            return c && (d = [
                {
                    source: _$r,
                    headers: c
                }
            ]), s && s.length > 0 && p.addTask("store", {
                workflows: s
            }), Xt.post("".concat(_$e.urls.processUrl, "/process"), {
                apikey: _$e.apikey,
                sources: d,
                tasks: p.getTasks(),
                upload_tags: _$a
            }, l).then(function(t) {
                if (t.data && t.data.handle) return t.data.upload_tags && (t.data.uploadTags = t.data.upload_tags, delete t.data.upload_tags), (0, h.Cl)((0, h.Cl)({}, t.data), {
                    mimetype: t.data.type
                });
                throw new pt("Invalid store response ".concat(JSON.stringify(t.data)));
            });
        }({
            session: this.session,
            url: t,
            storeParams: e,
            token: r,
            security: n,
            uploadTags: o,
            headers: i,
            workflowIds: a
        });
    }, e.prototype.retrieve = function(t, e, r) {
        return function(t, e, r, n) {
            if (void 0 === r && (r = {}), !e || 0 === e.length || "string" != typeof e) throw new pt("File handle is required");
            console.info("Retrieve method is deprecated and it will be removed. Please use metadata or download");
            var _$o = mt(Ht)(r);
            if (_$o.errors.length) throw new pt("Invalid retrieve params", _$o.errors);
            var i = (0, h.Cl)({}, r);
            i.key = t.apikey, i.policy = n && n.policy || t.policy, i.signature = n && n.signature || t.signature;
            var a, c, s = Yt.j.GET;
            if (i.head && (s = Yt.j.HEAD, delete i.head), i.extension && i.extension.length && (a = i.extension, delete i.extension), i.metadata) {
                if (s === Yt.j.HEAD) throw new pt("Head and metadata options cannot be used together");
                c = i.metadata, delete i.metadata;
            }
            var u = "".concat(t.urls.fileApiUrl, "/").concat(e) + (a ? "+".concat(a) : "") + (c ? "/metadata" : "");
            return new Promise(function(t, e) {
                Xt.dispatch(u, {
                    method: s,
                    filestackHeaders: !1,
                    params: (0, yt.removeEmpty)(i)
                }).then(function(e) {
                    return t(s === Yt.j.HEAD ? e.headers : e.data);
                })["catch"](e);
            });
        }(this.session, t, e, r);
    }, e.prototype.download = function(t, e) {
        return function(t, e, r) {
            var n = new Ut(e, t.apikey), _$o = r && r.policy || t.policy, i = r && r.signature || t.signature;
            return _$o && i && n.security({
                signature: i,
                policy: _$o
            }), Xt.dispatch(n.toString(), {
                method: Yt.j.GET,
                blobResponse: !0
            });
        }(this.session, t, e);
    }, e.prototype.transform = function(t, e, r) {
        return void 0 === r && (r = !1), Ee(this.session, t, e, r);
    }, e.prototype.upload = function(t, e, r, n, o) {
        var i = this, a = new Be(e, r);
        return a.setSession(this.session), n && a.setToken(n), o && a.setSecurity(o), a.on("start", function() {
            return i.emit("upload.start");
        }), a.on("error", function(t) {
            i.forwardErrors && it(function(n) {
                n.setTag("filestack-apikey", i.session.apikey), n.setTag("filestack-version", yt.getVersion()), n.setExtra("filestack-options", i.options), n.setExtras({
                    uploadOptions: e,
                    storeOptions: r,
                    details: t.details
                }), t.message = "FS-".concat(t.message), n.captureException(t);
            }), i.emit("upload.error", t);
        }), a.upload(t);
    }, e.prototype.multiupload = function(t, e, r, n, o) {
        var i = this, a = new Be(e, r);
        return a.setSession(this.session), n && a.setToken(n), o && a.setSecurity(o), a.on("start", function() {
            return i.emit("upload.start");
        }), a.on("error", function(t) {
            it(function(n) {
                n.setTag("filestack-apikey", i.session.apikey), n.setTag("filestack-version", yt.getVersion()), n.setExtra("filestack-options", i.options), n.setExtras(t.details), n.setExtras({
                    uploadOptions: e,
                    storeOptions: r
                }), n.captureException(t);
            }), i.emit("upload.error", t);
        }), a.multiupload(t);
    }, e;
}(d), Xe = function Xe(t, e) {
    return new Je(t, e);
}, tr = Xe, er = "3.51.4";
u(p.FILESTACK_SDK, Xe, {
    version: "3.51.4"
});
var rr = i.W3, nr = i.Ew, or = i.PK, ir = i.Kj, ar = i.Ay, cr = i.Rl, sr = i.HD, ur = i.FK, pr = i.lX, lr = i.m5, fr = i.Bj, hr = i.uK, dr = i.Nx, mr = i.Us, yr = i.uZ, vr = i.X5, gr = i.wb, br = i.zf, xr = i.QS, wr = i.ar, kr = i.pg, Sr = i.Pd, Er = i.Yq, Or = i.zb, jr = i.sz, Fr = i.WT, _r = i.XM, Pr = i.rv, Ar = i.p_, Tr = i.tm, Dr = i._7, Lr = i.hs, Cr = i.jC, Ir = i.bK, zr = i.d1, Nr = i.EK, Rr = i.z, Mr = i.Hc, Br = i.VA, Ur = i.kX, qr = i.pv, Gr = i.IO, $r = i.HQ, Zr = i.s4, Vr = i.QV, Hr = i.Dy, Yr = i.rR, Wr = i.IB, Kr = i.yp, Qr = i.Lt, Jr = i.Nu, Xr = i.Ly, tn = i.SC, en = i.Nr, rn = i.kJ, nn = i.vm, on = i.RK, an = i.HF, cn = i.Ts, sn = i.rB, un = i.Fr, pn = i.Fx, ln = i.ef, fn = i.T0, hn = i.p0, dn = i.rh, mn = i.pd, yn = i.NF, vn = i.tp, gn = i.qB, bn = i.rE;

});

parcelRegister("kTihC", function(module, exports) {

$parcel$export(module.exports, "config", function () { return config; });
$parcel$export(module.exports, "useSpring", function () { return useSpring; });
$parcel$export(module.exports, "useTransition", function () { return useTransition; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("03NY2")).Globals; });
// src/hooks/useChain.ts

var $iNemB = parcelRequire("iNemB");

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8WUf8 = parcelRequire("8WUf8");

var $gBEGf = parcelRequire("gBEGf");

var $3LSeA = parcelRequire("3LSeA");

var $a7G5R = parcelRequire("a7G5R");

var $kppPx = parcelRequire("kppPx");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $2DHfY = parcelRequire("2DHfY");

var $dMrZK = parcelRequire("dMrZK");

var $03NY2 = parcelRequire("03NY2");
var $giUWa = parcelRequire("giUWa");

var $hAGkE = parcelRequire("hAGkE");

var $klJjI = parcelRequire("klJjI");
parcelRequire("fBQnz");
function callProp(value) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $03NY2.is).fun(value) ? value.apply(void 0, (0, $bOqL7._)(args)) : value;
}
var matchProp = function(value, key) {
    return value === true || !!(key && value && ((0, $03NY2.is).fun(value) ? value(key) : (0, $03NY2.toArray)(value).includes(key)));
};
var resolveProp = function(prop, key) {
    return (0, $03NY2.is).obj(prop) ? key && prop[key] : prop;
};
var getDefaultProp = function(props, key) {
    return props["default"] === true ? props[key] : props["default"] ? props["default"][key] : void 0;
};
var noopTransform = function(value) {
    return value;
};
var getDefaultProps = function(props) {
    var transform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noopTransform;
    var keys = DEFAULT_PROPS;
    if (props["default"] && props["default"] !== true) {
        props = props["default"];
        keys = Object.keys(props);
    }
    var defaults2 = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = transform(props[key], key);
            if (!(0, $03NY2.is).und(value)) defaults2[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return defaults2;
};
var DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    "default": 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function getForwardProps(props) {
    var forward = {};
    var count = 0;
    (0, $03NY2.eachProp)(props, function(value, prop) {
        if (!RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function inferTo(props) {
    var to2 = getForwardProps(props);
    if (to2) {
        var out = {
            to: to2
        };
        (0, $03NY2.eachProp)(props, function(val, key) {
            return key in to2 || (out[key] = val);
        });
        return out;
    }
    return (0, $hRCmZ._)({}, props);
}
function computeGoal(value) {
    value = (0, $03NY2.getFluidValue)(value);
    return (0, $03NY2.is).arr(value) ? value.map(computeGoal) : (0, $03NY2.isAnimatedString)(value) ? (0, $03NY2.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function hasProps(props) {
    for(var _ in props)return true;
    return false;
}
function isAsyncTo(to2) {
    return (0, $03NY2.is).fun(to2) || (0, $03NY2.is).arr(to2) && (0, $03NY2.is).obj(to2[0]);
}
function detachRefs(ctrl, ref) {
    var _ctrl_ref;
    (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref["delete"](ctrl);
    ref === null || ref === void 0 ? void 0 : ref["delete"](ctrl);
}
function replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl_ref;
        (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref["delete"](ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function useChain(refs, timeSteps) {
    var timeFrame = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3;
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        if (timeSteps) {
            var prevDelay = 0;
            (0, $03NY2.each)(refs, function(ref, i) {
                var controllers = ref.current;
                if (controllers.length) {
                    var delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $03NY2.each)(controllers, function(ctrl) {
                        (0, $03NY2.each)(ctrl.queue, function(props) {
                            var memoizedDelayProp = props.delay;
                            props.delay = function(key) {
                                return delay + callProp(memoizedDelayProp || 0, key);
                            };
                        });
                    });
                    ref.start();
                }
            });
        } else {
            var p = Promise.resolve();
            (0, $03NY2.each)(refs, function(ref) {
                var controllers = ref.current;
                if (controllers.length) {
                    var queues = controllers.map(function(ctrl) {
                        var q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(function() {
                        (0, $03NY2.each)(controllers, function(ctrl, i) {
                            return (0, $03NY2.each)(queues[i] || [], function(update2) {
                                return ctrl.queue.push(update2);
                            });
                        });
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var config = {
    "default": {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var defaults = (0, $7XD9P._)((0, $hRCmZ._)({}, config["default"]), {
    mass: 1,
    damping: 1,
    easing: (0, $03NY2.easings).linear,
    clamp: false
});
var AnimationConfig = function AnimationConfig() {
    "use strict";
    (0, $6WLcG._)(this, AnimationConfig);
    /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
    Object.assign(this, defaults);
};
function mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = (0, $hRCmZ._)({}, defaultConfig);
        sanitizeConfig(defaultConfig, newConfig);
        newConfig = (0, $hRCmZ._)({}, defaultConfig, newConfig);
    }
    sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(var key in defaults)if (config2[key] == null) config2[key] = defaults[key];
    var frequency = config2.frequency, damping = config2.damping;
    var mass = config2.mass;
    if (!(0, $03NY2.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function sanitizeConfig(config2, props) {
    if (!(0, $03NY2.is).und(props.decay)) config2.duration = void 0;
    else {
        var isTensionConfig = !(0, $03NY2.is).und(props.tension) || !(0, $03NY2.is).und(props.friction);
        if (isTensionConfig || !(0, $03NY2.is).und(props.frequency) || !(0, $03NY2.is).und(props.damping) || !(0, $03NY2.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var emptyArray = [];
var Animation = function Animation() {
    "use strict";
    (0, $6WLcG._)(this, Animation);
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.config = new AnimationConfig();
    this.immediate = false;
};
function scheduleProps(callId, param) {
    var key = param.key, props = param.props, defaultProps = param.defaultProps, state = param.state, actions = param.actions;
    return new Promise(function(resolve, reject) {
        var onPause = function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts["delete"](timeout);
            timeout.cancel();
            delay = timeout.time - (0, $giUWa.raf).now();
        };
        var onResume = function onResume() {
            if (delay > 0 && !(0, $03NY2.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, $giUWa.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        };
        var onStart = function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue["delete"](onPause);
            state.timeouts["delete"](timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start((0, $7XD9P._)((0, $hRCmZ._)({}, props), {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        };
        var delay;
        var timeout;
        var _props_cancel;
        var cancel = matchProp((_props_cancel = props.cancel) !== null && _props_cancel !== void 0 ? _props_cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $03NY2.is).und(props.pause)) state.paused = matchProp(props.pause, key);
            var pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || matchProp(pause, key);
            delay = callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
    });
}
// src/AnimationResult.ts
var getCombinedResult = function(target, results) {
    return results.length == 1 ? results[0] : results.some(function(result) {
        return result.cancelled;
    }) ? getCancelledResult(target.get()) : results.every(function(result) {
        return result.noop;
    }) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(function(result) {
        return result.finished;
    }));
};
var getNoopResult = function(value) {
    return {
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    };
};
var getFinishedResult = function(value, finished) {
    var cancelled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return {
        value: value,
        finished: finished,
        cancelled: cancelled
    };
};
var getCancelledResult = function(value) {
    return {
        value: value,
        cancelled: true,
        finished: false
    };
};
// src/runAsync.ts
function runAsync(to2, props, state, target) {
    var callId = props.callId, parentId = props.parentId, onRest = props.onRest;
    var prevTo = state.asyncTo, prevPromise = state.promise;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var defaultProps, preventBail, bail, bailPromise, bailIfEnded, animate, result, animating, err1;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state.asyncId = callId;
                        state.asyncTo = to2;
                        defaultProps = getDefaultProps(props, function(value, key) {
                            return(// The `onRest` prop is only called when the `runAsync` promise is resolved.
                            key === "onRest" ? void 0 : value);
                        });
                        bailPromise = new Promise(function(resolve, reject) {
                            return preventBail = resolve, bail = reject;
                        });
                        bailIfEnded = function(bailSignal) {
                            var bailResult = // The `cancel` prop or `stop` method was used.
                            callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
                            callId !== state.asyncId && getFinishedResult(target, false);
                            if (bailResult) {
                                bailSignal.result = bailResult;
                                bail(bailSignal);
                                throw bailSignal;
                            }
                        };
                        animate = function(arg1, arg2) {
                            var bailSignal = new BailSignal();
                            var skipAnimationSignal = new SkipAnimationSignal();
                            return function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                                    var props2, result2;
                                    return (0, $dMrZK.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if ((0, $03NY2.Globals).skipAnimation) {
                                                    stopAsync(state);
                                                    skipAnimationSignal.result = getFinishedResult(target, false);
                                                    bail(skipAnimationSignal);
                                                    throw skipAnimationSignal;
                                                }
                                                bailIfEnded(bailSignal);
                                                props2 = (0, $03NY2.is).obj(arg1) ? (0, $hRCmZ._)({}, arg1) : (0, $7XD9P._)((0, $hRCmZ._)({}, arg2), {
                                                    to: arg1
                                                });
                                                props2.parentId = callId;
                                                (0, $03NY2.eachProp)(defaultProps, function(value, key) {
                                                    if ((0, $03NY2.is).und(props2[key])) props2[key] = value;
                                                });
                                                return [
                                                    4,
                                                    target.start(props2)
                                                ];
                                            case 1:
                                                result2 = _state.sent();
                                                bailIfEnded(bailSignal);
                                                if (!state.paused) return [
                                                    3,
                                                    3
                                                ];
                                                return [
                                                    4,
                                                    new Promise(function(resume) {
                                                        state.resumeQueue.add(resume);
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2,
                                                    result2
                                                ];
                                        }
                                    });
                                })();
                            }();
                        };
                        if ((0, $03NY2.Globals).skipAnimation) {
                            stopAsync(state);
                            return [
                                2,
                                getFinishedResult(target, false)
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        if ((0, $03NY2.is).arr(to2)) animating = function(queue) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, props2, err;
                                return (0, $dMrZK.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                6,
                                                7,
                                                8
                                            ]);
                                            _iterator = queue[Symbol.iterator]();
                                            _state.label = 2;
                                        case 2:
                                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                3,
                                                5
                                            ];
                                            props2 = _step.value;
                                            return [
                                                4,
                                                animate(props2)
                                            ];
                                        case 3:
                                            _state.sent();
                                            _state.label = 4;
                                        case 4:
                                            _iteratorNormalCompletion = true;
                                            return [
                                                3,
                                                2
                                            ];
                                        case 5:
                                            return [
                                                3,
                                                8
                                            ];
                                        case 6:
                                            err = _state.sent();
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                            return [
                                                3,
                                                8
                                            ];
                                        case 7:
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                            return [
                                                7
                                            ];
                                        case 8:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }(to2);
                        else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
                        return [
                            4,
                            Promise.all([
                                animating.then(preventBail),
                                bailPromise
                            ])
                        ];
                    case 2:
                        _state.sent();
                        result = getFinishedResult(target.get(), true, false);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err1 = _state.sent();
                        if (err1 instanceof BailSignal) result = err1.result;
                        else if (err1 instanceof SkipAnimationSignal) result = err1.result;
                        else throw err1;
                        return [
                            3,
                            5
                        ];
                    case 4:
                        if (callId == state.asyncId) {
                            state.asyncId = parentId;
                            state.asyncTo = parentId ? prevTo : void 0;
                            state.promise = parentId ? prevPromise : void 0;
                        }
                        return [
                            7
                        ];
                    case 5:
                        if ((0, $03NY2.is).fun(onRest)) (0, $giUWa.raf).batchedUpdates(function() {
                            onRest(result, target, target.item);
                        });
                        return [
                            2,
                            result
                        ];
                }
            });
        })();
    }();
}
function stopAsync(state, cancelId) {
    (0, $03NY2.flush)(state.timeouts, function(t) {
        return t.cancel();
    });
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var BailSignal = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $a7G5R._)(BailSignal, Error1);
    function BailSignal() {
        (0, $6WLcG._)(this, BailSignal);
        return (0, $bQby9._)(this, BailSignal, [
            "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
        ]);
    }
    return BailSignal;
}((0, $2DHfY._)(Error));
var SkipAnimationSignal = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $a7G5R._)(SkipAnimationSignal, Error1);
    function SkipAnimationSignal() {
        (0, $6WLcG._)(this, SkipAnimationSignal);
        return (0, $bQby9._)(this, SkipAnimationSignal, [
            "SkipAnimationSignal"
        ]);
    }
    return SkipAnimationSignal;
}((0, $2DHfY._)(Error));
var isFrameValue = function(value) {
    return value instanceof FrameValue;
};
var nextId = 1;
var FrameValue = /*#__PURE__*/ function(FluidValue2) {
    "use strict";
    (0, $a7G5R._)(FrameValue, FluidValue2);
    function FrameValue() {
        (0, $6WLcG._)(this, FrameValue);
        var _this;
        _this = (0, $bQby9._)(this, FrameValue, arguments);
        _this.id = nextId++;
        _this._priority = 0;
        return _this;
    }
    (0, $dbIwN._)(FrameValue, [
        {
            key: "priority",
            get: function get() {
                return this._priority;
            },
            set: function set(priority) {
                if (this._priority != priority) {
                    this._priority = priority;
                    this._onPriorityChange(priority);
                }
            }
        },
        {
            /** Get the current value */ key: "get",
            value: function get() {
                var node = (0, $klJjI.getAnimated)(this);
                return node && node.getValue();
            }
        },
        {
            /** Create a spring that maps our value to another value */ key: "to",
            value: function to() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (0, $03NY2.Globals).to(this, args);
            }
        },
        {
            /** @deprecated Use the `to` method instead. */ key: "interpolate",
            value: function interpolate() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                (0, $03NY2.deprecateInterpolate)();
                return (0, $03NY2.Globals).to(this, args);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.get();
            }
        },
        {
            key: "observerAdded",
            value: function observerAdded(count) {
                if (count == 1) this._attach();
            }
        },
        {
            key: "observerRemoved",
            value: function observerRemoved(count) {
                if (count == 0) this._detach();
            }
        },
        {
            /** Called when the first child is added. */ key: "_attach",
            value: function _attach() {}
        },
        {
            /** Called when the last child is removed. */ key: "_detach",
            value: function _detach() {}
        },
        {
            /** Tell our children about our new value */ key: "_onChange",
            value: function _onChange(value) {
                var idle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                (0, $03NY2.callFluidObservers)(this, {
                    type: "change",
                    parent: this,
                    value: value,
                    idle: idle
                });
            }
        },
        {
            /** Tell our children about our new priority */ key: "_onPriorityChange",
            value: function _onPriorityChange(priority) {
                if (!this.idle) (0, $03NY2.frameLoop).sort(this);
                (0, $03NY2.callFluidObservers)(this, {
                    type: "priority",
                    parent: this,
                    priority: priority
                });
            }
        }
    ]);
    return FrameValue;
}((0, $03NY2.FluidValue));
// src/SpringPhase.ts
var $P = Symbol["for"]("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = function(target) {
    return (target[$P] & HAS_ANIMATED) > 0;
};
var isAnimating = function(target) {
    return (target[$P] & IS_ANIMATING) > 0;
};
var isPaused = function(target) {
    return (target[$P] & IS_PAUSED) > 0;
};
var setActiveBit = function(target, active) {
    return active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
};
var setPausedBit = function(target, paused) {
    return paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
};
// src/SpringValue.ts
var SpringValue = /*#__PURE__*/ function(FrameValue) {
    "use strict";
    (0, $a7G5R._)(SpringValue, FrameValue);
    function SpringValue(arg1, arg2) {
        (0, $6WLcG._)(this, SpringValue);
        var _this;
        _this = (0, $bQby9._)(this, SpringValue);
        /** The animation state */ _this.animation = new Animation();
        /** Some props have customizable default values */ _this.defaultProps = {};
        /** The state for `runAsync` calls */ _this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ _this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ _this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ _this._lastToId = 0;
        _this._memoizedDuration = 0;
        if (!(0, $03NY2.is).und(arg1) || !(0, $03NY2.is).und(arg2)) {
            var props = (0, $03NY2.is).obj(arg1) ? (0, $hRCmZ._)({}, arg1) : (0, $7XD9P._)((0, $hRCmZ._)({}, arg2), {
                from: arg1
            });
            if ((0, $03NY2.is).und(props["default"])) props["default"] = true;
            _this.start(props);
        }
        return _this;
    }
    (0, $dbIwN._)(SpringValue, [
        {
            key: "idle",
            get: /** Equals true when not advancing on each frame. */ function get() {
                return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
            }
        },
        {
            key: "goal",
            get: function get() {
                return (0, $03NY2.getFluidValue)(this.animation.to);
            }
        },
        {
            key: "velocity",
            get: function get() {
                var node = (0, $klJjI.getAnimated)(this);
                return node instanceof (0, $klJjI.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map(function(node2) {
                    return node2.lastVelocity || 0;
                });
            }
        },
        {
            key: "hasAnimated",
            get: /**
   * When true, this value has been animated at least once.
   */ function get() {
                return hasAnimated(this);
            }
        },
        {
            key: "isAnimating",
            get: /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ function get() {
                return isAnimating(this);
            }
        },
        {
            key: "isPaused",
            get: /**
   * When true, all current and future animations are paused.
   */ function get() {
                return isPaused(this);
            }
        },
        {
            key: "isDelayed",
            get: /**
   *
   *
   */ function get() {
                return this._state.delayed;
            }
        },
        {
            /** Advance the current animation by a number of milliseconds */ key: "advance",
            value: function advance(dt) {
                var _this = this;
                var idle = true;
                var changed = false;
                var anim = this.animation;
                var toValues = anim.toValues;
                var config2 = anim.config;
                var payload = (0, $klJjI.getPayload)(anim.to);
                if (!payload && (0, $03NY2.hasFluidValue)(anim.to)) toValues = (0, $03NY2.toArray)((0, $03NY2.getFluidValue)(anim.to));
                anim.values.forEach(function(node2, i) {
                    if (node2.done) return;
                    var to2 = // Animated strings always go from 0 to 1.
                    node2.constructor == (0, $klJjI.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
                    var finished = anim.immediate;
                    var position = to2;
                    if (!finished) {
                        position = node2.lastPosition;
                        if (config2.tension <= 0) {
                            node2.done = true;
                            return;
                        }
                        var elapsed = node2.elapsedTime += dt;
                        var from = anim.fromValues[i];
                        var v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $03NY2.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                        var velocity;
                        var precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                        if (!(0, $03NY2.is).und(config2.duration)) {
                            var p = 1;
                            if (config2.duration > 0) {
                                if (_this._memoizedDuration !== config2.duration) {
                                    _this._memoizedDuration = config2.duration;
                                    if (node2.durationProgress > 0) {
                                        node2.elapsedTime = config2.duration * node2.durationProgress;
                                        elapsed = node2.elapsedTime += dt;
                                    }
                                }
                                p = (config2.progress || 0) + elapsed / _this._memoizedDuration;
                                p = p > 1 ? 1 : p < 0 ? 0 : p;
                                node2.durationProgress = p;
                            }
                            position = from + config2.easing(p) * (to2 - from);
                            velocity = (position - node2.lastPosition) / dt;
                            finished = p == 1;
                        } else if (config2.decay) {
                            var decay = config2.decay === true ? 0.998 : config2.decay;
                            var e = Math.exp(-(1 - decay) * elapsed);
                            position = from + v0 / (1 - decay) * (1 - e);
                            finished = Math.abs(node2.lastPosition - position) <= precision;
                            velocity = v0 * e;
                        } else {
                            velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                            var restVelocity = config2.restVelocity || precision / 10;
                            var bounceFactor = config2.clamp ? 0 : config2.bounce;
                            var canBounce = !(0, $03NY2.is).und(bounceFactor);
                            var isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                            var isMoving;
                            var isBouncing = false;
                            var step = 1;
                            var numSteps = Math.ceil(dt / step);
                            for(var n = 0; n < numSteps; ++n){
                                isMoving = Math.abs(velocity) > restVelocity;
                                if (!isMoving) {
                                    finished = Math.abs(to2 - position) <= precision;
                                    if (finished) break;
                                }
                                if (canBounce) {
                                    isBouncing = position == to2 || position > to2 == isGrowing;
                                    if (isBouncing) {
                                        velocity = -velocity * bounceFactor;
                                        position = to2;
                                    }
                                }
                                var springForce = -config2.tension * 1e-6 * (position - to2);
                                var dampingForce = -config2.friction * 1e-3 * velocity;
                                var acceleration = (springForce + dampingForce) / config2.mass;
                                velocity = velocity + acceleration * step;
                                position = position + velocity * step;
                            }
                        }
                        node2.lastVelocity = velocity;
                        if (Number.isNaN(position)) {
                            console.warn("Got NaN while animating:", _this);
                            finished = true;
                        }
                    }
                    if (payload && !payload[i].done) finished = false;
                    if (finished) node2.done = true;
                    else idle = false;
                    if (node2.setValue(position, config2.round)) changed = true;
                });
                var node = (0, $klJjI.getAnimated)(this);
                var currVal = node.getValue();
                if (idle) {
                    var finalVal = (0, $03NY2.getFluidValue)(anim.to);
                    if ((currVal !== finalVal || changed) && !config2.decay) {
                        node.setValue(finalVal);
                        this._onChange(finalVal);
                    } else if (changed && config2.decay) this._onChange(currVal);
                    this._stop();
                } else if (changed) this._onChange(currVal);
            }
        },
        {
            /** Set the current value, while stopping the current animation */ key: "set",
            value: function set(value) {
                var _this = this;
                (0, $giUWa.raf).batchedUpdates(function() {
                    _this._stop();
                    _this._focus(value);
                    _this._set(value);
                });
                return this;
            }
        },
        {
            /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ key: "pause",
            value: function pause() {
                this._update({
                    pause: true
                });
            }
        },
        {
            /** Resume the animation if paused. */ key: "resume",
            value: function resume() {
                this._update({
                    pause: false
                });
            }
        },
        {
            /** Skip to the end of the current animation. */ key: "finish",
            value: function finish() {
                var _this = this;
                if (isAnimating(this)) {
                    var _this_animation = this.animation, to2 = _this_animation.to, config2 = _this_animation.config;
                    (0, $giUWa.raf).batchedUpdates(function() {
                        _this._onStart();
                        if (!config2.decay) _this._set(to2, false);
                        _this._stop();
                    });
                }
                return this;
            }
        },
        {
            /** Push props into the pending queue. */ key: "update",
            value: function update(props) {
                var queue = this.queue || (this.queue = []);
                queue.push(props);
                return this;
            }
        },
        {
            key: "start",
            value: function start(to2, arg2) {
                var _this = this;
                var queue;
                if (!(0, $03NY2.is).und(to2)) queue = [
                    (0, $03NY2.is).obj(to2) ? to2 : (0, $7XD9P._)((0, $hRCmZ._)({}, arg2), {
                        to: to2
                    })
                ];
                else {
                    queue = this.queue || [];
                    this.queue = [];
                }
                return Promise.all(queue.map(function(props) {
                    var up = _this._update(props);
                    return up;
                })).then(function(results) {
                    return getCombinedResult(_this, results);
                });
            }
        },
        {
            /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ key: "stop",
            value: function stop(cancel) {
                var _this = this;
                var _this_animation = this.animation, to2 = _this_animation.to;
                this._focus(this.get());
                stopAsync(this._state, cancel && this._lastCallId);
                (0, $giUWa.raf).batchedUpdates(function() {
                    return _this._stop(to2, cancel);
                });
                return this;
            }
        },
        {
            /** Restart the animation. */ key: "reset",
            value: function reset() {
                this._update({
                    reset: true
                });
            }
        },
        {
            /** @internal */ key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") this._start();
                else if (event.type == "priority") this.priority = event.priority + 1;
            }
        },
        {
            /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ key: "_prepareNode",
            value: function _prepareNode(props) {
                var key = this.key || "";
                var to2 = props.to, from = props.from;
                to2 = (0, $03NY2.is).obj(to2) ? to2[key] : to2;
                if (to2 == null || isAsyncTo(to2)) to2 = void 0;
                from = (0, $03NY2.is).obj(from) ? from[key] : from;
                if (from == null) from = void 0;
                var range = {
                    to: to2,
                    from: from
                };
                if (!hasAnimated(this)) {
                    var ref;
                    if (props.reverse) ref = [
                        from,
                        to2
                    ], to2 = ref[0], from = ref[1], ref;
                    from = (0, $03NY2.getFluidValue)(from);
                    if (!(0, $03NY2.is).und(from)) this._set(from);
                    else if (!(0, $klJjI.getAnimated)(this)) this._set(to2);
                }
                return range;
            }
        },
        {
            /** Every update is processed by this method before merging. */ key: "_update",
            value: function _update(_param, isLoop) {
                var _this = this;
                var props = (0, $8WUf8._)({}, (0, $kppPx._)(_param));
                var _this1 = this, key = _this1.key, defaultProps = _this1.defaultProps;
                if (props["default"]) Object.assign(defaultProps, getDefaultProps(props, function(value, prop) {
                    return /^on/.test(prop) ? resolveProp(value, key) : value;
                }));
                mergeActiveFn(this, props, "onProps");
                sendEvent(this, "onProps", props, this);
                var range = this._prepareNode(props);
                if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
                var state = this._state;
                return scheduleProps(++this._lastCallId, {
                    key: key,
                    props: props,
                    defaultProps: defaultProps,
                    state: state,
                    actions: {
                        pause: function() {
                            if (!isPaused(_this)) {
                                setPausedBit(_this, true);
                                (0, $03NY2.flushCalls)(state.pauseQueue);
                                sendEvent(_this, "onPause", getFinishedResult(_this, checkFinished(_this, _this.animation.to)), _this);
                            }
                        },
                        resume: function() {
                            if (isPaused(_this)) {
                                setPausedBit(_this, false);
                                if (isAnimating(_this)) _this._resume();
                                (0, $03NY2.flushCalls)(state.resumeQueue);
                                sendEvent(_this, "onResume", getFinishedResult(_this, checkFinished(_this, _this.animation.to)), _this);
                            }
                        },
                        start: this._merge.bind(this, range)
                    }
                }).then(function(result) {
                    if (props.loop && result.finished && !(isLoop && result.noop)) {
                        var nextProps = createLoopUpdate(props);
                        if (nextProps) return _this._update(nextProps, true);
                    }
                    return result;
                });
            }
        },
        {
            /** Merge props into the current animation */ key: "_merge",
            value: function _merge(range, props, resolve) {
                var _this = this;
                if (props.cancel) {
                    this.stop(true);
                    return resolve(getCancelledResult(this));
                }
                var hasToProp = !(0, $03NY2.is).und(range.to);
                var hasFromProp = !(0, $03NY2.is).und(range.from);
                if (hasToProp || hasFromProp) {
                    if (props.callId > this._lastToId) this._lastToId = props.callId;
                    else return resolve(getCancelledResult(this));
                }
                var _this1 = this, key = _this1.key, defaultProps = _this1.defaultProps, anim = _this1.animation;
                var prevTo = anim.to, prevFrom = anim.from;
                var tmp = range.to, to2 = tmp === void 0 ? prevTo : tmp, _range_from = range.from, from = _range_from === void 0 ? prevFrom : _range_from;
                if (hasFromProp && !hasToProp && (!props["default"] || (0, $03NY2.is).und(to2))) to2 = from;
                var ref;
                if (props.reverse) ref = [
                    from,
                    to2
                ], to2 = ref[0], from = ref[1], ref;
                var hasFromChanged = !(0, $03NY2.isEqual)(from, prevFrom);
                if (hasFromChanged) anim.from = from;
                from = (0, $03NY2.getFluidValue)(from);
                var hasToChanged = !(0, $03NY2.isEqual)(to2, prevTo);
                if (hasToChanged) this._focus(to2);
                var hasAsyncTo = isAsyncTo(props.to);
                var config2 = anim.config;
                var decay = config2.decay, velocity = config2.velocity;
                if (hasToProp || hasFromProp) config2.velocity = 0;
                if (props.config && !hasAsyncTo) mergeConfig(config2, callProp(props.config, key), // Avoid calling the same "config" prop twice.
                props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
                var node = (0, $klJjI.getAnimated)(this);
                if (!node || (0, $03NY2.is).und(to2)) return resolve(getFinishedResult(this, true));
                var reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
                // except for declarative updates. When `reset` is defined, there
                // must exist a value to animate from.
                (0, $03NY2.is).und(props.reset) ? hasFromProp && !props["default"] : !(0, $03NY2.is).und(from) && matchProp(props.reset, key);
                var value = reset ? from : this.get();
                var goal = computeGoal(to2);
                var isAnimatable = (0, $03NY2.is).num(goal) || (0, $03NY2.is).arr(goal) || (0, $03NY2.isAnimatedString)(goal);
                var immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
                if (hasToChanged) {
                    var nodeType = (0, $klJjI.getAnimatedType)(to2);
                    if (nodeType !== node.constructor) {
                        if (immediate) node = this._set(goal);
                        else throw Error("Cannot animate between ".concat(node.constructor.name, " and ").concat(nodeType.name, ', as the "to" prop suggests'));
                    }
                }
                var goalType = node.constructor;
                var started = (0, $03NY2.hasFluidValue)(to2);
                var finished = false;
                if (!started) {
                    var hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
                    if (hasToChanged || hasValueChanged) {
                        finished = (0, $03NY2.isEqual)(computeGoal(value), goal);
                        started = !finished;
                    }
                    if (!(0, $03NY2.isEqual)(anim.immediate, immediate) && !immediate || !(0, $03NY2.isEqual)(config2.decay, decay) || !(0, $03NY2.isEqual)(config2.velocity, velocity)) started = true;
                }
                if (finished && isAnimating(this)) {
                    if (anim.changed && !reset) started = true;
                    else if (!started) this._stop(prevTo);
                }
                if (!hasAsyncTo) {
                    if (started || (0, $03NY2.hasFluidValue)(prevTo)) {
                        anim.values = node.getPayload();
                        anim.toValues = (0, $03NY2.hasFluidValue)(to2) ? null : goalType == (0, $klJjI.AnimatedString) ? [
                            1
                        ] : (0, $03NY2.toArray)(goal);
                    }
                    if (anim.immediate != immediate) {
                        anim.immediate = immediate;
                        if (!immediate && !reset) this._set(prevTo);
                    }
                    if (started) {
                        var onRest = anim.onRest;
                        (0, $03NY2.each)(ACTIVE_EVENTS, function(type) {
                            return mergeActiveFn(_this, props, type);
                        });
                        var result = getFinishedResult(this, checkFinished(this, prevTo));
                        (0, $03NY2.flushCalls)(this._pendingCalls, result);
                        this._pendingCalls.add(resolve);
                        if (anim.changed) (0, $giUWa.raf).batchedUpdates(function() {
                            var _anim_onStart;
                            anim.changed = !reset;
                            onRest === null || onRest === void 0 ? void 0 : onRest(result, _this);
                            if (reset) callProp(defaultProps.onRest, result);
                            else (_anim_onStart = anim.onStart) === null || _anim_onStart === void 0 ? void 0 : _anim_onStart.call(anim, result, _this);
                        });
                    }
                }
                if (reset) this._set(value);
                if (hasAsyncTo) resolve(runAsync(props.to, props, this._state, this));
                else if (started) this._start();
                else if (isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
                else resolve(getNoopResult(value));
            }
        },
        {
            /** Update the `animation.to` value, which might be a `FluidValue` */ key: "_focus",
            value: function _focus(value) {
                var anim = this.animation;
                if (value !== anim.to) {
                    if ((0, $03NY2.getFluidObservers)(this)) this._detach();
                    anim.to = value;
                    if ((0, $03NY2.getFluidObservers)(this)) this._attach();
                }
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var priority = 0;
                var _this_animation = this.animation, to2 = _this_animation.to;
                if ((0, $03NY2.hasFluidValue)(to2)) {
                    (0, $03NY2.addFluidObserver)(to2, this);
                    if (isFrameValue(to2)) priority = to2.priority + 1;
                }
                this.priority = priority;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                var _this_animation = this.animation, to2 = _this_animation.to;
                if ((0, $03NY2.hasFluidValue)(to2)) (0, $03NY2.removeFluidObserver)(to2, this);
            }
        },
        {
            /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ key: "_set",
            value: function _set(arg) {
                var _this = this;
                var idle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var value = (0, $03NY2.getFluidValue)(arg);
                if (!(0, $03NY2.is).und(value)) {
                    var oldNode = (0, $klJjI.getAnimated)(this);
                    if (!oldNode || !(0, $03NY2.isEqual)(value, oldNode.getValue())) {
                        var nodeType = (0, $klJjI.getAnimatedType)(value);
                        if (!oldNode || oldNode.constructor != nodeType) (0, $klJjI.setAnimated)(this, nodeType.create(value));
                        else oldNode.setValue(value);
                        if (oldNode) (0, $giUWa.raf).batchedUpdates(function() {
                            _this._onChange(value, idle);
                        });
                    }
                }
                return (0, $klJjI.getAnimated)(this);
            }
        },
        {
            key: "_onStart",
            value: function _onStart() {
                var anim = this.animation;
                if (!anim.changed) {
                    anim.changed = true;
                    sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
                }
            }
        },
        {
            key: "_onChange",
            value: function _onChange(value, idle) {
                if (!idle) {
                    this._onStart();
                    callProp(this.animation.onChange, value, this);
                }
                callProp(this.defaultProps.onChange, value, this);
                (0, $gBEGf._)((0, $3LSeA._)(SpringValue.prototype), "_onChange", this).call(this, value, idle);
            }
        },
        {
            // This method resets the animation state (even if already animating) to
            // ensure the latest from/to range is used, and it also ensures this spring
            // is added to the frameloop.
            key: "_start",
            value: function _start() {
                var anim = this.animation;
                (0, $klJjI.getAnimated)(this).reset((0, $03NY2.getFluidValue)(anim.to));
                if (!anim.immediate) anim.fromValues = anim.values.map(function(node) {
                    return node.lastPosition;
                });
                if (!isAnimating(this)) {
                    setActiveBit(this, true);
                    if (!isPaused(this)) this._resume();
                }
            }
        },
        {
            key: "_resume",
            value: function _resume() {
                if ((0, $03NY2.Globals).skipAnimation) this.finish();
                else (0, $03NY2.frameLoop).start(this);
            }
        },
        {
            /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ key: "_stop",
            value: function _stop(goal, cancel) {
                if (isAnimating(this)) {
                    setActiveBit(this, false);
                    var anim = this.animation;
                    (0, $03NY2.each)(anim.values, function(node) {
                        node.done = true;
                    });
                    if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
                    (0, $03NY2.callFluidObservers)(this, {
                        type: "idle",
                        parent: this
                    });
                    var result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
                    (0, $03NY2.flushCalls)(this._pendingCalls, result);
                    if (anim.changed) {
                        anim.changed = false;
                        sendEvent(this, "onRest", result, this);
                    }
                }
            }
        }
    ]);
    return SpringValue;
}(FrameValue);
function checkFinished(target, to2) {
    var goal = computeGoal(to2);
    var value = computeGoal(target.get());
    return (0, $03NY2.isEqual)(value, goal);
}
function createLoopUpdate(props) {
    var loop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : props.loop, to2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : props.to;
    var loopRet = callProp(loop);
    if (loopRet) {
        var overrides = loopRet !== true && inferTo(loopRet);
        var reverse = (overrides || props).reverse;
        var reset = !overrides || overrides.reset;
        return createUpdate((0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({}, props), {
            loop: loop,
            // Avoid updating default props when looping.
            "default": false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset
        }), overrides));
    }
}
function createUpdate(props) {
    var _ref = props = inferTo(props), to2 = _ref.to, from = _ref.from;
    var keys = /* @__PURE__ */ new Set();
    if ((0, $03NY2.is).obj(to2)) findDefined(to2, keys);
    if ((0, $03NY2.is).obj(from)) findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function declareUpdate(props) {
    var update2 = createUpdate(props);
    if ((0, $03NY2.is).und(update2["default"])) update2["default"] = getDefaultProps(update2);
    return update2;
}
function findDefined(values, keys) {
    (0, $03NY2.eachProp)(values, function(value, key) {
        return value != null && keys.add(key);
    });
}
var ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _target_animation_type, _target_defaultProps_type;
    var _target_animation_type1, _target_animation, _target_defaultProps_type1, _target_defaultProps;
    (_target_animation_type1 = (_target_animation = target.animation)[type]) === null || _target_animation_type1 === void 0 ? void 0 : (_target_animation_type = _target_animation_type1).call.apply(_target_animation_type, [
        _target_animation
    ].concat((0, $bOqL7._)(args)));
    (_target_defaultProps_type1 = (_target_defaultProps = target.defaultProps)[type]) === null || _target_defaultProps_type1 === void 0 ? void 0 : (_target_defaultProps_type = _target_defaultProps_type1).call.apply(_target_defaultProps_type, [
        _target_defaultProps
    ].concat((0, $bOqL7._)(args)));
}
var BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var nextId2 = 1;
var Controller = /*#__PURE__*/ function() {
    "use strict";
    function Controller(props, flush3) {
        (0, $6WLcG._)(this, Controller);
        this.id = nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start((0, $hRCmZ._)({
            "default": true
        }, props));
    }
    (0, $dbIwN._)(Controller, [
        {
            key: "idle",
            get: /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ function get() {
                return !this._state.asyncTo && Object.values(this.springs).every(function(spring) {
                    return spring.idle && !spring.isDelayed && !spring.isPaused;
                });
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(item) {
                this._item = item;
            }
        },
        {
            /** Get the current values of our springs */ key: "get",
            value: function get() {
                var values = {};
                this.each(function(spring, key) {
                    return values[key] = spring.get();
                });
                return values;
            }
        },
        {
            /** Set the current values without animating. */ key: "set",
            value: function set(values) {
                for(var key in values){
                    var value = values[key];
                    if (!(0, $03NY2.is).und(value)) this.springs[key].set(value);
                }
            }
        },
        {
            /** Push an update onto the queue of each value. */ key: "update",
            value: function update(props) {
                if (props) this.queue.push(createUpdate(props));
                return this;
            }
        },
        {
            /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ key: "start",
            value: function start(props) {
                var queue = this.queue;
                if (props) queue = (0, $03NY2.toArray)(props).map(createUpdate);
                else this.queue = [];
                if (this._flush) return this._flush(this, queue);
                prepareKeys(this, queue);
                return flushUpdateQueue(this, queue);
            }
        },
        {
            /** @internal */ key: "stop",
            value: function stop(arg, keys) {
                if (arg !== !!arg) keys = arg;
                if (keys) {
                    var springs = this.springs;
                    (0, $03NY2.each)((0, $03NY2.toArray)(keys), function(key) {
                        return springs[key].stop(!!arg);
                    });
                } else {
                    stopAsync(this._state, this._lastAsyncId);
                    this.each(function(spring) {
                        return spring.stop(!!arg);
                    });
                }
                return this;
            }
        },
        {
            /** Freeze the active animation in time */ key: "pause",
            value: function pause(keys) {
                if ((0, $03NY2.is).und(keys)) this.start({
                    pause: true
                });
                else {
                    var springs = this.springs;
                    (0, $03NY2.each)((0, $03NY2.toArray)(keys), function(key) {
                        return springs[key].pause();
                    });
                }
                return this;
            }
        },
        {
            /** Resume the animation if paused. */ key: "resume",
            value: function resume(keys) {
                if ((0, $03NY2.is).und(keys)) this.start({
                    pause: false
                });
                else {
                    var springs = this.springs;
                    (0, $03NY2.each)((0, $03NY2.toArray)(keys), function(key) {
                        return springs[key].resume();
                    });
                }
                return this;
            }
        },
        {
            /** Call a function once per spring value */ key: "each",
            value: function each(iterator) {
                (0, $03NY2.eachProp)(this.springs, iterator);
            }
        },
        {
            /** @internal Called at the end of every animation frame */ key: "_onFrame",
            value: function _onFrame() {
                var _this = this;
                var _this__events = this._events, onStart = _this__events.onStart, onChange = _this__events.onChange, onRest = _this__events.onRest;
                var active = this._active.size > 0;
                var changed = this._changed.size > 0;
                if (active && !this._started || changed && !this._started) {
                    this._started = true;
                    (0, $03NY2.flush)(onStart, function(param) {
                        var _param = (0, $6mdMa._)(param, 2), onStart2 = _param[0], result = _param[1];
                        result.value = _this.get();
                        onStart2(result, _this, _this._item);
                    });
                }
                var idle = !active && this._started;
                var values = changed || idle && onRest.size ? this.get() : null;
                if (changed && onChange.size) (0, $03NY2.flush)(onChange, function(param) {
                    var _param = (0, $6mdMa._)(param, 2), onChange2 = _param[0], result = _param[1];
                    result.value = values;
                    onChange2(result, _this, _this._item);
                });
                if (idle) {
                    this._started = false;
                    (0, $03NY2.flush)(onRest, function(param) {
                        var _param = (0, $6mdMa._)(param, 2), onRest2 = _param[0], result = _param[1];
                        result.value = values;
                        onRest2(result, _this, _this._item);
                    });
                }
            }
        },
        {
            /** @internal */ key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") {
                    this._changed.add(event.parent);
                    if (!event.idle) this._active.add(event.parent);
                } else if (event.type == "idle") this._active["delete"](event.parent);
                else return;
                (0, $giUWa.raf).onFrame(this._onFrame);
            }
        }
    ]);
    return Controller;
}();
function flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map(function(props) {
        return flushUpdate(ctrl, props);
    })).then(function(results) {
        return getCombinedResult(ctrl, results);
    });
}
function flushUpdate(ctrl, props, isLoop) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var keys, to2, from, loop, onRest, onResolve, defaults2, asyncTo, state, promises, cancel, result, _tmp, nextProps;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    keys = props.keys, to2 = props.to, from = props.from, loop = props.loop, onRest = props.onRest, onResolve = props.onResolve;
                    defaults2 = (0, $03NY2.is).obj(props["default"]) && props["default"];
                    if (loop) props.loop = false;
                    if (to2 === false) props.to = null;
                    if (from === false) props.from = null;
                    asyncTo = (0, $03NY2.is).arr(to2) || (0, $03NY2.is).fun(to2) ? to2 : void 0;
                    if (asyncTo) {
                        props.to = void 0;
                        props.onRest = void 0;
                        if (defaults2) defaults2.onRest = void 0;
                    } else (0, $03NY2.each)(BATCHED_EVENTS, function(key) {
                        var handler = props[key];
                        if ((0, $03NY2.is).fun(handler)) {
                            var queue = ctrl["_events"][key];
                            props[key] = function(param) {
                                var finished = param.finished, cancelled = param.cancelled;
                                var result2 = queue.get(handler);
                                if (result2) {
                                    if (!finished) result2.finished = false;
                                    if (cancelled) result2.cancelled = true;
                                } else queue.set(handler, {
                                    value: null,
                                    finished: finished || false,
                                    cancelled: cancelled || false
                                });
                            };
                            if (defaults2) defaults2[key] = props[key];
                        }
                    });
                    state = ctrl["_state"];
                    if (props.pause === !state.paused) {
                        state.paused = props.pause;
                        (0, $03NY2.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
                    } else if (state.paused) props.pause = true;
                    promises = (keys || Object.keys(ctrl.springs)).map(function(key) {
                        return ctrl.springs[key].start(props);
                    });
                    cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
                    if (asyncTo || cancel && state.asyncId) promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
                        props: props,
                        state: state,
                        actions: {
                            pause: (0, $03NY2.noop),
                            resume: (0, $03NY2.noop),
                            start: function(props2, resolve) {
                                if (cancel) {
                                    stopAsync(state, ctrl["_lastAsyncId"]);
                                    resolve(getCancelledResult(ctrl));
                                } else {
                                    props2.onRest = onRest;
                                    resolve(runAsync(asyncTo, props2, state, ctrl));
                                }
                            }
                        }
                    }));
                    if (!state.paused) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new Promise(function(resume) {
                            state.resumeQueue.add(resume);
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp = [
                        ctrl
                    ];
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 3:
                    result = getCombinedResult.apply(void 0, _tmp.concat([
                        _state.sent()
                    ]));
                    if (loop && result.finished && !(isLoop && result.noop)) {
                        nextProps = createLoopUpdate(props, loop, to2);
                        if (nextProps) {
                            prepareKeys(ctrl, [
                                nextProps
                            ]);
                            return [
                                2,
                                flushUpdate(ctrl, nextProps, true)
                            ];
                        }
                    }
                    if (onResolve) (0, $giUWa.raf).batchedUpdates(function() {
                        return onResolve(result, ctrl, ctrl.item);
                    });
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function getSprings(ctrl, props) {
    var springs = (0, $hRCmZ._)({}, ctrl.springs);
    if (props) (0, $03NY2.each)((0, $03NY2.toArray)(props), function(props2) {
        if ((0, $03NY2.is).und(props2.keys)) props2 = createUpdate(props2);
        if (!(0, $03NY2.is).obj(props2.to)) props2 = (0, $7XD9P._)((0, $hRCmZ._)({}, props2), {
            to: void 0
        });
        prepareSprings(springs, props2, function(key) {
            return createSpring(key);
        });
    });
    setSprings(ctrl, springs);
    return springs;
}
function setSprings(ctrl, springs) {
    (0, $03NY2.eachProp)(springs, function(spring, key) {
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $03NY2.addFluidObserver)(spring, ctrl);
        }
    });
}
function createSpring(key, observer) {
    var spring = new SpringValue();
    spring.key = key;
    if (observer) (0, $03NY2.addFluidObserver)(spring, observer);
    return spring;
}
function prepareSprings(springs, props, create) {
    if (props.keys) (0, $03NY2.each)(props.keys, function(key) {
        var spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function prepareKeys(ctrl, queue) {
    (0, $03NY2.each)(queue, function(props) {
        prepareSprings(ctrl.springs, props, function(key) {
            return createSpring(key, ctrl);
        });
    });
}
var SpringContext = function(_param) {
    var children = _param.children, props = (0, $c4wKO._)(_param, [
        "children"
    ]);
    var inherited = (0, $hAGkE.useContext)(ctx);
    var pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $03NY2.useMemoOne)(function() {
        return {
            pause: pause,
            immediate: immediate
        };
    }, [
        pause,
        immediate
    ]);
    var Provider = ctx.Provider;
    return /* @__PURE__ */ $hAGkE.createElement(Provider, {
        value: props
    }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
    Object.assign(target, $hAGkE.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var SpringRef = function() {
    var current = [];
    var SpringRef2 = function SpringRef2(props) {
        (0, $03NY2.deprecateDirectCall)();
        var results = [];
        (0, $03NY2.each)(current, function(ctrl, i) {
            if ((0, $03NY2.is).und(props)) results.push(ctrl.start());
            else {
                var update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function SpringRef(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2["delete"] = function(ctrl) {
        var i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        var _arguments = arguments;
        var _ctrl;
        (0, $03NY2.each)(current, function(ctrl) {
            return (_ctrl = ctrl).pause.apply(_ctrl, _arguments);
        });
        return this;
    };
    SpringRef2.resume = function() {
        var _arguments = arguments;
        var _ctrl;
        (0, $03NY2.each)(current, function(ctrl) {
            return (_ctrl = ctrl).resume.apply(_ctrl, _arguments);
        });
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $03NY2.each)(current, function(ctrl, i) {
            var update2 = (0, $03NY2.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        var _this = this;
        var results = [];
        (0, $03NY2.each)(current, function(ctrl, i) {
            if ((0, $03NY2.is).und(props)) results.push(ctrl.start());
            else {
                var update2 = _this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        var _arguments = arguments;
        var _ctrl;
        (0, $03NY2.each)(current, function(ctrl) {
            return (_ctrl = ctrl).stop.apply(_ctrl, _arguments);
        });
        return this;
    };
    SpringRef2.update = function(props) {
        var _this = this;
        (0, $03NY2.each)(current, function(ctrl, i) {
            return ctrl.update(_this._getProps(props, ctrl, i));
        });
        return this;
    };
    var _getProps = function _getProps(arg, ctrl, index) {
        return (0, $03NY2.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
    var _arguments = arguments;
    var propsFn = (0, $03NY2.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    var ref = (0, $hAGkE.useMemo)(function() {
        return propsFn || _arguments.length == 3 ? SpringRef() : void 0;
    }, []);
    var layoutId = (0, $hAGkE.useRef)(0);
    var forceUpdate = (0, $03NY2.useForceUpdate)();
    var state = (0, $hAGkE.useMemo)(function() {
        return {
            ctrls: [],
            queue: [],
            flush: function(ctrl, updates2) {
                var springs2 = getSprings(ctrl, updates2);
                var canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some(function(key) {
                    return !ctrl.springs[key];
                });
                return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise(function(resolve) {
                    setSprings(ctrl, springs2);
                    state.queue.push(function() {
                        resolve(flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        };
    }, []);
    var ctrls = (0, $hAGkE.useRef)((0, $bOqL7._)(state.ctrls));
    var updates = [];
    var prevLength = (0, $03NY2.usePrev)(length) || 0;
    (0, $hAGkE.useMemo)(function() {
        (0, $03NY2.each)(ctrls.current.slice(length, prevLength), function(ctrl) {
            detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $hAGkE.useMemo)(function() {
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(var i = startIndex; i < endIndex; i++){
            var ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
            var update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = declareUpdate(update2);
        }
    }
    var springs = ctrls.current.map(function(ctrl, i) {
        return getSprings(ctrl, updates[i]);
    });
    var context = (0, $hAGkE.useContext)(SpringContext);
    var prevContext = (0, $03NY2.usePrev)(context);
    var hasContext = context !== prevContext && hasProps(context);
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        layoutId.current++;
        state.ctrls = ctrls.current;
        var queue = state.queue;
        if (queue.length) {
            state.queue = [];
            (0, $03NY2.each)(queue, function(cb) {
                return cb();
            });
        }
        (0, $03NY2.each)(ctrls.current, function(ctrl, i) {
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext) ctrl.start({
                "default": context
            });
            var update2 = updates[i];
            if (update2) {
                replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $03NY2.useOnce)(function() {
        return function() {
            (0, $03NY2.each)(state.ctrls, function(ctrl) {
                return ctrl.stop(true);
            });
        };
    });
    var values = springs.map(function(x) {
        return (0, $hRCmZ._)({}, x);
    });
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function useSpring(props, deps) {
    var isFn = (0, $03NY2.is).fun(props);
    var _useSprings = (0, $6mdMa._)(useSprings(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps), 2), _useSprings_ = (0, $6mdMa._)(_useSprings[0], 1), values = _useSprings_[0], ref = _useSprings[1];
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var initSpringRef = function() {
    return SpringRef();
};
var useSpringRef = function() {
    return (0, $hAGkE.useState)(initSpringRef)[0];
};
var useSpringValue = function(initial, props) {
    var springValue = (0, $03NY2.useConstant)(function() {
        return new SpringValue(initial, props);
    });
    (0, $03NY2.useOnce)(function() {
        return function() {
            springValue.stop();
        };
    });
    return springValue;
};
function useTrail(length, propsArg, deps) {
    var propsFn = (0, $03NY2.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    var reverse = true;
    var passedRef = void 0;
    var result = useSprings(length, function(i, ctrl) {
        var props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        (0, $03NY2.each)(result[1].current, function(ctrl, i) {
            var parent = result[1].current[i + (reverse ? 1 : -1)];
            replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        var ref = passedRef !== null && passedRef !== void 0 ? passedRef : result[1];
        ref["_getProps"] = function(propsArg2, ctrl, i) {
            var props = (0, $03NY2.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                var parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function useTransition(data, props, deps) {
    var _arguments = arguments;
    var propsFn = (0, $03NY2.is).fun(props) && props;
    var _ref = propsFn ? propsFn() : props, reset = _ref.reset, sort = _ref.sort, _ref_trail = _ref.trail, trail = _ref_trail === void 0 ? 0 : _ref_trail, _ref_expires = _ref.expires, expires = _ref_expires === void 0 ? true : _ref_expires, _ref_exitBeforeEnter = _ref.exitBeforeEnter, exitBeforeEnter = _ref_exitBeforeEnter === void 0 ? false : _ref_exitBeforeEnter, onDestroyed = _ref.onDestroyed, propsRef = _ref.ref, propsConfig = _ref.config;
    var ref = (0, $hAGkE.useMemo)(function() {
        return propsFn || _arguments.length == 3 ? SpringRef() : void 0;
    }, []);
    var items = (0, $03NY2.toArray)(data);
    var transitions = [];
    var usedTransitions = (0, $hAGkE.useRef)(null);
    var prevTransitions = reset ? null : usedTransitions.current;
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        usedTransitions.current = transitions;
    });
    (0, $03NY2.useOnce)(function() {
        (0, $03NY2.each)(transitions, function(t) {
            ref === null || ref === void 0 ? void 0 : ref.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return function() {
            (0, $03NY2.each)(usedTransitions.current, function(t) {
                if (t.expired) clearTimeout(t.expirationId);
                detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    var keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    var expired = reset && usedTransitions.current || [];
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        return (0, $03NY2.each)(expired, function(param) {
            var ctrl = param.ctrl, item = param.item, key = param.key;
            detachRefs(ctrl, ref);
            callProp(onDestroyed, item, key);
        });
    });
    var reused = [];
    if (prevTransitions) (0, $03NY2.each)(prevTransitions, function(t, i) {
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $03NY2.each)(items, function(item, i) {
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new Controller()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        var i = -1;
        var leave = (propsFn ? propsFn() : props).leave;
        (0, $03NY2.each)(reused, function(keyIndex, prevIndex) {
            var t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = (0, $7XD9P._)((0, $hRCmZ._)({}, t), {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $03NY2.is).fun(sort)) transitions.sort(function(a, b) {
        return sort(a.item, b.item);
    });
    var delay = -trail;
    var forceUpdate = (0, $03NY2.useForceUpdate)();
    var defaultProps = getDefaultProps(props);
    var changes = /* @__PURE__ */ new Map();
    var exitingTransitions = (0, $hAGkE.useRef)(/* @__PURE__ */ new Map());
    var forceChange = (0, $hAGkE.useRef)(false);
    (0, $03NY2.each)(transitions, function(t, i) {
        var key = t.key;
        var prevPhase = t.phase;
        var p = propsFn ? propsFn() : props;
        var to2;
        var phase;
        var propsDelay = callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            var isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = callProp(to2, t.item, i);
        to2 = (0, $03NY2.is).obj(to2) ? inferTo(to2) : {
            to: to2
        };
        if (!to2.config) {
            var config2 = propsConfig || defaultProps.config;
            to2.config = callProp(config2, t.item, i, phase);
        }
        delay += trail;
        var payload = (0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({}, defaultProps), {
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false
        }), to2);
        if (phase == "enter" /* ENTER */  && (0, $03NY2.is).und(payload.from)) {
            var p2 = propsFn ? propsFn() : props;
            var from = (0, $03NY2.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = callProp(from, t.item, i);
        }
        var onResolve = payload.onResolve;
        payload.onResolve = function(result) {
            callProp(onResolve, result);
            var transitions2 = usedTransitions.current;
            var t2 = transitions2.find(function(t3) {
                return t3.key === key;
            });
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                var idle = transitions2.every(function(t3) {
                    return t3.ctrl.idle;
                });
                if (t2.phase == "leave" /* LEAVE */ ) {
                    var expiry = callProp(expires, t2.item);
                    if (expiry !== false) {
                        var expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some(function(t3) {
                    return t3.expired;
                })) {
                    exitingTransitions.current["delete"](t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        var springs = getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    var context = (0, $hAGkE.useContext)(SpringContext);
    var prevContext = (0, $03NY2.usePrev)(context);
    var hasContext = context !== prevContext && hasProps(context);
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        if (hasContext) (0, $03NY2.each)(transitions, function(t) {
            t.ctrl.start({
                "default": context
            });
        });
    }, [
        context
    ]);
    (0, $03NY2.each)(changes, function(_, t) {
        if (exitingTransitions.current.size) {
            var ind = transitions.findIndex(function(state) {
                return state.key === t.key;
            });
            transitions.splice(ind, 1);
        }
    });
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        (0, $03NY2.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, function(param, t) {
            var phase = param.phase, payload = param.payload;
            var ctrl = t.ctrl;
            t.phase = phase;
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                "default": context
            });
            if (payload) {
                replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    var renderTransitions = function(render) {
        return /* @__PURE__ */ $hAGkE.createElement($hAGkE.Fragment, null, transitions.map(function(t, i) {
            var springs = (changes.get(t) || t.ctrl).springs;
            var elem = render((0, $hRCmZ._)({}, springs), t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $hAGkE.createElement(elem.type, (0, $7XD9P._)((0, $hRCmZ._)({}, elem.props), {
                key: (0, $03NY2.is).str(t.key) || (0, $03NY2.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    };
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, param, prevTransitions) {
    var key = param.key, _param_keys = param.keys, keys = _param_keys === void 0 ? key : _param_keys;
    if (keys === null) {
        var reused = /* @__PURE__ */ new Set();
        return items.map(function(item) {
            var t = prevTransitions && prevTransitions.find(function(t2) {
                return t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2);
            });
            if (t) {
                reused.add(t);
                return t.key;
            }
            return nextKey++;
        });
    }
    return (0, $03NY2.is).und(keys) ? items : (0, $03NY2.is).fun(keys) ? items.map(keys) : (0, $03NY2.toArray)(keys);
}
var useScroll = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var container = _param.container, springOptions = (0, $c4wKO._)(_param, [
        "container"
    ]);
    var _useSpring = (0, $6mdMa._)(useSpring(function() {
        return (0, $hRCmZ._)({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0
        }, springOptions);
    }, []), 2), scrollValues = _useSpring[0], api = _useSpring[1];
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        var cleanupScroll = (0, $03NY2.onScroll)(function(param) {
            var x = param.x, y = param.y;
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return function() {
            (0, $03NY2.each)(Object.values(scrollValues), function(value) {
                return value.stop();
            });
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var useResize = function(_param) {
    var container = _param.container, springOptions = (0, $c4wKO._)(_param, [
        "container"
    ]);
    var _useSpring = (0, $6mdMa._)(useSpring(function() {
        return (0, $hRCmZ._)({
            width: 0,
            height: 0
        }, springOptions);
    }, []), 2), sizeValues = _useSpring[0], api = _useSpring[1];
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        var cleanupScroll = (0, $03NY2.onResize)(function(param) {
            var width = param.width, height = param.height;
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return function() {
            (0, $03NY2.each)(Object.values(sizeValues), function(value) {
                return value.stop();
            });
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var defaultThresholdOptions = {
    any: 0,
    all: 1
};
function useInView(props, args) {
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isInView = _useState2[0], setIsInView = _useState2[1];
    var ref = (0, $hAGkE.useRef)();
    var propsFn = (0, $03NY2.is).fun(props) && props;
    var springsProps = propsFn ? propsFn() : {};
    var tmp = springsProps.to, to2 = tmp === void 0 ? {} : tmp, _springsProps_from = springsProps.from, from = _springsProps_from === void 0 ? {} : _springsProps_from, restSpringProps = (0, $c4wKO._)(springsProps, [
        "to",
        "from"
    ]);
    var intersectionArguments = propsFn ? args : props;
    var _useSpring = (0, $6mdMa._)(useSpring(function() {
        return (0, $hRCmZ._)({
            from: from
        }, restSpringProps);
    }, []), 2), springs = _useSpring[0], api = _useSpring[1];
    (0, $03NY2.useIsomorphicLayoutEffect)(function() {
        var element = ref.current;
        var _ref = intersectionArguments !== null && intersectionArguments !== void 0 ? intersectionArguments : {}, root = _ref.root, once = _ref.once, _ref_amount = _ref.amount, amount = _ref_amount === void 0 ? "any" : _ref_amount, restArgs = (0, $c4wKO._)(_ref, [
            "root",
            "once",
            "amount"
        ]);
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        var activeIntersections = /* @__PURE__ */ new WeakMap();
        var onEnter = function() {
            if (to2) api.start(to2);
            setIsInView(true);
            var cleanup = function() {
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        var handleIntersection = function(entries) {
            entries.forEach(function(entry) {
                var onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    var newOnLeave = onEnter();
                    if ((0, $03NY2.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections["delete"](entry.target);
                }
            });
        };
        var observer = new IntersectionObserver(handleIntersection, (0, $hRCmZ._)({
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : defaultThresholdOptions[amount]
        }, restArgs));
        observer.observe(element);
        return function() {
            return observer.unobserve(element);
        };
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function Spring(_param) {
    var children = _param.children, props = (0, $c4wKO._)(_param, [
        "children"
    ]);
    return children(useSpring(props));
}
function Trail(_param) {
    var items = _param.items, children = _param.children, props = (0, $c4wKO._)(_param, [
        "items",
        "children"
    ]);
    var trails = useTrail(items.length, props);
    return items.map(function(item, index) {
        var result = children(item, index);
        return (0, $03NY2.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function Transition(_param) {
    var items = _param.items, children = _param.children, props = (0, $c4wKO._)(_param, [
        "items",
        "children"
    ]);
    return useTransition(items, props)(children);
}
var Interpolation = /*#__PURE__*/ function(FrameValue) {
    "use strict";
    (0, $a7G5R._)(Interpolation, FrameValue);
    function Interpolation(source, args) {
        (0, $6WLcG._)(this, Interpolation);
        var _this;
        _this = (0, $bQby9._)(this, Interpolation);
        _this.source = source;
        /** Equals false when in the frameloop */ _this.idle = true;
        /** The inputs which are currently animating */ _this._active = /* @__PURE__ */ new Set();
        _this.calc = (0, $03NY2.createInterpolator).apply(void 0, (0, $bOqL7._)(args));
        var value = _this._get();
        var nodeType = (0, $klJjI.getAnimatedType)(value);
        (0, $klJjI.setAnimated)(_this, nodeType.create(value));
        return _this;
    }
    (0, $dbIwN._)(Interpolation, [
        {
            key: "advance",
            value: function advance(_dt) {
                var value = this._get();
                var oldValue = this.get();
                if (!(0, $03NY2.isEqual)(value, oldValue)) {
                    (0, $klJjI.getAnimated)(this).setValue(value);
                    this._onChange(value, this.idle);
                }
                if (!this.idle && checkIdle(this._active)) becomeIdle(this);
            }
        },
        {
            key: "_get",
            value: function _get() {
                var inputs = (0, $03NY2.is).arr(this.source) ? this.source.map((0, $03NY2.getFluidValue)) : (0, $03NY2.toArray)((0, $03NY2.getFluidValue)(this.source));
                return this.calc.apply(this, (0, $bOqL7._)(inputs));
            }
        },
        {
            key: "_start",
            value: function _start() {
                var _this = this;
                if (this.idle && !checkIdle(this._active)) {
                    this.idle = false;
                    (0, $03NY2.each)((0, $klJjI.getPayload)(this), function(node) {
                        node.done = false;
                    });
                    if ((0, $03NY2.Globals).skipAnimation) {
                        (0, $giUWa.raf).batchedUpdates(function() {
                            return _this.advance();
                        });
                        becomeIdle(this);
                    } else (0, $03NY2.frameLoop).start(this);
                }
            }
        },
        {
            // Observe our sources only when we're observed.
            key: "_attach",
            value: function _attach() {
                var _this = this;
                var priority = 1;
                (0, $03NY2.each)((0, $03NY2.toArray)(this.source), function(source) {
                    if ((0, $03NY2.hasFluidValue)(source)) (0, $03NY2.addFluidObserver)(source, _this);
                    if (isFrameValue(source)) {
                        if (!source.idle) _this._active.add(source);
                        priority = Math.max(priority, source.priority + 1);
                    }
                });
                this.priority = priority;
                this._start();
            }
        },
        {
            // Stop observing our sources once we have no observers.
            key: "_detach",
            value: function _detach() {
                var _this = this;
                (0, $03NY2.each)((0, $03NY2.toArray)(this.source), function(source) {
                    if ((0, $03NY2.hasFluidValue)(source)) (0, $03NY2.removeFluidObserver)(source, _this);
                });
                this._active.clear();
                becomeIdle(this);
            }
        },
        {
            /** @internal */ key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") {
                    if (event.idle) this.advance();
                    else {
                        this._active.add(event.parent);
                        this._start();
                    }
                } else if (event.type == "idle") this._active["delete"](event.parent);
                else if (event.type == "priority") this.priority = (0, $03NY2.toArray)(this.source).reduce(function(highest, parent) {
                    return Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1);
                }, 0);
            }
        }
    ]);
    return Interpolation;
}(FrameValue);
function isIdle(source) {
    return source.idle !== false;
}
function checkIdle(active) {
    return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $03NY2.each)((0, $klJjI.getPayload)(self), function(node) {
            node.done = true;
        });
        (0, $03NY2.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var to = function(source) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return new Interpolation(source, args);
};
var interpolate = function(source) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $03NY2.deprecateInterpolate)(), new Interpolation(source, args);
};
(0, $03NY2.Globals).assign({
    createStringInterpolator: (0, $03NY2.createStringInterpolator),
    to: function(source, args) {
        return new Interpolation(source, args);
    }
});
var update = (0, $03NY2.frameLoop).advance;

});
parcelRegister("bQby9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89ed82987e1eaeae$export$71511d61b312f219; });

var $3LSeA = parcelRequire("3LSeA");

var $1Q3e6 = parcelRequire("1Q3e6");

var $gZgsq = parcelRequire("gZgsq");
function $89ed82987e1eaeae$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $3LSeA._)(derived);
    return (0, $gZgsq._)(_this, (0, $1Q3e6._)() ? Reflect.construct(derived, args || [], (0, $3LSeA._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("3LSeA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2befd4ac6f1922f0$export$71511d61b312f219; });
function $2befd4ac6f1922f0$export$71511d61b312f219(o) {
    $2befd4ac6f1922f0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2befd4ac6f1922f0$export$71511d61b312f219(o);
}

});

parcelRegister("1Q3e6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $156d2681b3b04fad$export$71511d61b312f219; });
function $156d2681b3b04fad$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($156d2681b3b04fad$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("gZgsq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c5df1bf601bac836$export$71511d61b312f219; });

var $bShYJ = parcelRequire("bShYJ");

var $2xTNA = parcelRequire("2xTNA");
function $c5df1bf601bac836$export$71511d61b312f219(self, call) {
    if (call && ((0, $2xTNA._)(call) === "object" || typeof call === "function")) return call;
    return (0, $bShYJ._)(self);
}

});
parcelRegister("bShYJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8a52af037300757e$export$71511d61b312f219; });
function $8a52af037300757e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("8WUf8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $683f5e33f824dd69$export$71511d61b312f219; });
function $683f5e33f824dd69$export$71511d61b312f219() {
    $683f5e33f824dd69$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $683f5e33f824dd69$export$71511d61b312f219.apply(this, arguments);
}

});

parcelRegister("gBEGf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c16fa85767a35448$export$71511d61b312f219; });

var $bemeU = parcelRequire("bemeU");
function $c16fa85767a35448$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $c16fa85767a35448$export$71511d61b312f219 = Reflect.get;
    else $c16fa85767a35448$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $bemeU._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $c16fa85767a35448$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("bemeU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $82d240ccc6cc7ed0$export$71511d61b312f219; });

var $3LSeA = parcelRequire("3LSeA");
function $82d240ccc6cc7ed0$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $3LSeA._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("a7G5R", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $01e6e3f69f82dcc4$export$71511d61b312f219; });

var $cJkCk = parcelRequire("cJkCk");
function $01e6e3f69f82dcc4$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cJkCk._)(subClass, superClass);
}

});
parcelRegister("cJkCk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9449ae2aa9bdcce0$export$71511d61b312f219; });
function $9449ae2aa9bdcce0$export$71511d61b312f219(o, p) {
    $9449ae2aa9bdcce0$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9449ae2aa9bdcce0$export$71511d61b312f219(o, p);
}

});


parcelRegister("kppPx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $edba2dcbc4136a18$export$71511d61b312f219; });
function $edba2dcbc4136a18$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

});

parcelRegister("c4wKO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c9f440463e32e43$export$71511d61b312f219; });

var $cj3ge = parcelRequire("cj3ge");
function $8c9f440463e32e43$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $cj3ge._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("cj3ge", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8f59c9ed89ec31b3$export$71511d61b312f219; });
function $8f59c9ed89ec31b3$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("2DHfY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ec0c72b284b9fb2$export$71511d61b312f219; });

var $d2roy = parcelRequire("d2roy");

var $3LSeA = parcelRequire("3LSeA");

var $kPnSz = parcelRequire("kPnSz");

var $cJkCk = parcelRequire("cJkCk");
function $1ec0c72b284b9fb2$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $1ec0c72b284b9fb2$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $kPnSz._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $d2roy._)(Class, arguments, (0, $3LSeA._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $cJkCk._)(Wrapper, Class);
    };
    return $1ec0c72b284b9fb2$export$71511d61b312f219(Class);
}

});
parcelRegister("d2roy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $97e0b65c868c9391$export$71511d61b312f219; });

var $1Q3e6 = parcelRequire("1Q3e6");

var $cJkCk = parcelRequire("cJkCk");
function $97e0b65c868c9391$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $1Q3e6._)()) $97e0b65c868c9391$export$71511d61b312f219 = Reflect.construct;
    else $97e0b65c868c9391$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $cJkCk._)(instance, Class.prototype);
        return instance;
    };
    return $97e0b65c868c9391$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("kPnSz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f29b17f3be96160a$export$71511d61b312f219; });
function $f29b17f3be96160a$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("03NY2", function(module, exports) {

$parcel$export(module.exports, "Globals", function () { return $00b70a6da2ab3157$export$cceeabf822b64fc0; });
$parcel$export(module.exports, "noop", function () { return $00b70a6da2ab3157$export$8793edee2d425525; });
$parcel$export(module.exports, "defineHidden", function () { return $00b70a6da2ab3157$export$5c74248ea0e35446; });
$parcel$export(module.exports, "is", function () { return $00b70a6da2ab3157$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isEqual", function () { return $00b70a6da2ab3157$export$248d38f6296296c5; });
$parcel$export(module.exports, "each", function () { return $00b70a6da2ab3157$export$79b2f7037acddd43; });
$parcel$export(module.exports, "eachProp", function () { return $00b70a6da2ab3157$export$f4c6fe153f5a944e; });
$parcel$export(module.exports, "toArray", function () { return $00b70a6da2ab3157$export$45b10814cc054894; });
$parcel$export(module.exports, "flush", function () { return $00b70a6da2ab3157$export$4909b86c8034bf73; });
$parcel$export(module.exports, "flushCalls", function () { return $00b70a6da2ab3157$export$7ba486852759e806; });
$parcel$export(module.exports, "frameLoop", function () { return $00b70a6da2ab3157$export$a57f5080a3bcc90a; });
$parcel$export(module.exports, "colors", function () { return $00b70a6da2ab3157$export$8f45430ccf837300; });
$parcel$export(module.exports, "createInterpolator", function () { return $00b70a6da2ab3157$export$b12af43b97697ef5; });
$parcel$export(module.exports, "easings", function () { return $00b70a6da2ab3157$export$15a0bf1b4bbacad8; });
$parcel$export(module.exports, "hasFluidValue", function () { return $00b70a6da2ab3157$export$57ea7e3a7f6280c7; });
$parcel$export(module.exports, "getFluidValue", function () { return $00b70a6da2ab3157$export$e37b7520edd66839; });
$parcel$export(module.exports, "getFluidObservers", function () { return $00b70a6da2ab3157$export$133f54e9f7cf1796; });
$parcel$export(module.exports, "callFluidObservers", function () { return $00b70a6da2ab3157$export$31752c40a5fab62a; });
$parcel$export(module.exports, "FluidValue", function () { return $00b70a6da2ab3157$export$aff8e1ac1a016a2; });
$parcel$export(module.exports, "addFluidObserver", function () { return $00b70a6da2ab3157$export$72d604e3f8d000a5; });
$parcel$export(module.exports, "removeFluidObserver", function () { return $00b70a6da2ab3157$export$7a0eb830d336339b; });
$parcel$export(module.exports, "createStringInterpolator", function () { return $00b70a6da2ab3157$export$4759a013d387347a; });
$parcel$export(module.exports, "deprecateInterpolate", function () { return $00b70a6da2ab3157$export$2abfcde8ae218ba8; });
$parcel$export(module.exports, "deprecateDirectCall", function () { return $00b70a6da2ab3157$export$d99d974913ad3b12; });
$parcel$export(module.exports, "isAnimatedString", function () { return $00b70a6da2ab3157$export$75bed621f62abfa9; });
$parcel$export(module.exports, "onResize", function () { return $00b70a6da2ab3157$export$45b39e67d4ce4921; });
$parcel$export(module.exports, "onScroll", function () { return $00b70a6da2ab3157$export$d4d89fd61e5416ee; });
$parcel$export(module.exports, "useConstant", function () { return $00b70a6da2ab3157$export$fe4300aa8eebea86; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $00b70a6da2ab3157$export$700979bc83e7db82; });
$parcel$export(module.exports, "useForceUpdate", function () { return $00b70a6da2ab3157$export$91db9bc4f8ac944a; });
$parcel$export(module.exports, "useMemoOne", function () { return $00b70a6da2ab3157$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "useOnce", function () { return $00b70a6da2ab3157$export$392544347a18b6ea; });
$parcel$export(module.exports, "usePrev", function () { return $00b70a6da2ab3157$export$ef7ad0c4e19d7fbf; });
$parcel$export(module.exports, "raf", function () { return (parcelRequire("giUWa")).raf; });

var $6WLcG = parcelRequire("6WLcG");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $giUWa = parcelRequire("giUWa");

var $hAGkE = parcelRequire("hAGkE");
var $00b70a6da2ab3157$var$__defProp = Object.defineProperty;
var $00b70a6da2ab3157$var$__export = function(target, all) {
    for(var name in all)$00b70a6da2ab3157$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $00b70a6da2ab3157$export$cceeabf822b64fc0 = {};
$00b70a6da2ab3157$var$__export($00b70a6da2ab3157$export$cceeabf822b64fc0, {
    assign: function() {
        return $00b70a6da2ab3157$var$assign;
    },
    colors: function() {
        return $00b70a6da2ab3157$var$colors;
    },
    createStringInterpolator: function() {
        return $00b70a6da2ab3157$var$createStringInterpolator;
    },
    skipAnimation: function() {
        return $00b70a6da2ab3157$var$skipAnimation;
    },
    to: function() {
        return $00b70a6da2ab3157$var$to;
    },
    willAdvance: function() {
        return $00b70a6da2ab3157$var$willAdvance;
    }
});
// src/helpers.ts
function $00b70a6da2ab3157$export$8793edee2d425525() {}
var $00b70a6da2ab3157$export$5c74248ea0e35446 = function(obj, key, value) {
    return Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
};
var $00b70a6da2ab3157$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: function(a) {
        return !!a && a.constructor.name === "Object";
    },
    fun: function(a) {
        return typeof a === "function";
    },
    str: function(a) {
        return typeof a === "string";
    },
    num: function(a) {
        return typeof a === "number";
    },
    und: function(a) {
        return a === void 0;
    }
};
function $00b70a6da2ab3157$export$248d38f6296296c5(a, b) {
    if ($00b70a6da2ab3157$export$226b3eccf92c9ed9.arr(a)) {
        if (!$00b70a6da2ab3157$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $00b70a6da2ab3157$export$79b2f7037acddd43 = function(obj, fn) {
    return obj.forEach(fn);
};
function $00b70a6da2ab3157$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($00b70a6da2ab3157$export$226b3eccf92c9ed9.arr(obj)) {
        for(var i = 0; i < obj.length; i++)fn.call(ctx, obj[i], "".concat(i));
        return;
    }
    for(var key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $00b70a6da2ab3157$export$45b10814cc054894 = function(a) {
    return $00b70a6da2ab3157$export$226b3eccf92c9ed9.und(a) ? [] : $00b70a6da2ab3157$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
};
function $00b70a6da2ab3157$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        var items = Array.from(queue);
        queue.clear();
        $00b70a6da2ab3157$export$79b2f7037acddd43(items, iterator);
    }
}
var $00b70a6da2ab3157$export$7ba486852759e806 = function(queue) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return $00b70a6da2ab3157$export$4909b86c8034bf73(queue, function(fn) {
        return fn.apply(void 0, (0, $bOqL7._)(args));
    });
};
var $00b70a6da2ab3157$export$48d7c418edadb60c = function() {
    return typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
};
// src/globals.ts
var $00b70a6da2ab3157$var$createStringInterpolator;
var $00b70a6da2ab3157$var$to;
var $00b70a6da2ab3157$var$colors = null;
var $00b70a6da2ab3157$var$skipAnimation = false;
var $00b70a6da2ab3157$var$willAdvance = $00b70a6da2ab3157$export$8793edee2d425525;
var $00b70a6da2ab3157$var$assign = function(globals) {
    if (globals.to) $00b70a6da2ab3157$var$to = globals.to;
    if (globals.now) (0, $giUWa.raf).now = globals.now;
    if (globals.colors !== void 0) $00b70a6da2ab3157$var$colors = globals.colors;
    if (globals.skipAnimation != null) $00b70a6da2ab3157$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $00b70a6da2ab3157$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $giUWa.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $giUWa.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $00b70a6da2ab3157$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $giUWa.raf).frameLoop = globals.frameLoop;
};
var $00b70a6da2ab3157$var$startQueue = /* @__PURE__ */ new Set();
var $00b70a6da2ab3157$var$currentFrame = [];
var $00b70a6da2ab3157$var$prevFrame = [];
var $00b70a6da2ab3157$var$priority = 0;
var $00b70a6da2ab3157$export$a57f5080a3bcc90a = {
    get idle () {
        return !$00b70a6da2ab3157$var$startQueue.size && !$00b70a6da2ab3157$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start: function(animation) {
        if ($00b70a6da2ab3157$var$priority > animation.priority) {
            $00b70a6da2ab3157$var$startQueue.add(animation);
            (0, $giUWa.raf).onStart($00b70a6da2ab3157$var$flushStartQueue);
        } else {
            $00b70a6da2ab3157$var$startSafely(animation);
            (0, $giUWa.raf)($00b70a6da2ab3157$var$advance);
        }
    },
    /** Advance all animations by the given time. */ advance: $00b70a6da2ab3157$var$advance,
    /** Call this when an animation's priority changes. */ sort: function(animation) {
        if ($00b70a6da2ab3157$var$priority) (0, $giUWa.raf).onFrame(function() {
            return $00b70a6da2ab3157$export$a57f5080a3bcc90a.sort(animation);
        });
        else {
            var prevIndex = $00b70a6da2ab3157$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $00b70a6da2ab3157$var$currentFrame.splice(prevIndex, 1);
                $00b70a6da2ab3157$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear: function() {
        $00b70a6da2ab3157$var$currentFrame = [];
        $00b70a6da2ab3157$var$startQueue.clear();
    }
};
function $00b70a6da2ab3157$var$flushStartQueue() {
    $00b70a6da2ab3157$var$startQueue.forEach($00b70a6da2ab3157$var$startSafely);
    $00b70a6da2ab3157$var$startQueue.clear();
    (0, $giUWa.raf)($00b70a6da2ab3157$var$advance);
}
function $00b70a6da2ab3157$var$startSafely(animation) {
    if (!$00b70a6da2ab3157$var$currentFrame.includes(animation)) $00b70a6da2ab3157$var$startUnsafely(animation);
}
function $00b70a6da2ab3157$var$startUnsafely(animation) {
    $00b70a6da2ab3157$var$currentFrame.splice($00b70a6da2ab3157$var$findIndex($00b70a6da2ab3157$var$currentFrame, function(other) {
        return other.priority > animation.priority;
    }), 0, animation);
}
function $00b70a6da2ab3157$var$advance(dt) {
    var nextFrame = $00b70a6da2ab3157$var$prevFrame;
    for(var i = 0; i < $00b70a6da2ab3157$var$currentFrame.length; i++){
        var animation = $00b70a6da2ab3157$var$currentFrame[i];
        $00b70a6da2ab3157$var$priority = animation.priority;
        if (!animation.idle) {
            $00b70a6da2ab3157$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $00b70a6da2ab3157$var$priority = 0;
    $00b70a6da2ab3157$var$prevFrame = $00b70a6da2ab3157$var$currentFrame;
    $00b70a6da2ab3157$var$prevFrame.length = 0;
    $00b70a6da2ab3157$var$currentFrame = nextFrame;
    return $00b70a6da2ab3157$var$currentFrame.length > 0;
}
function $00b70a6da2ab3157$var$findIndex(arr, test) {
    var index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $00b70a6da2ab3157$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    return Math.min(Math.max(v, min), max);
};
// src/colors.ts
var $00b70a6da2ab3157$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $00b70a6da2ab3157$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $00b70a6da2ab3157$var$PERCENTAGE = $00b70a6da2ab3157$var$NUMBER + "%";
function $00b70a6da2ab3157$var$call() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $00b70a6da2ab3157$export$8972dc0e6ad9238f = new RegExp("rgb" + $00b70a6da2ab3157$var$call($00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$NUMBER));
var $00b70a6da2ab3157$export$4e46ac54fc82cf3b = new RegExp("rgba" + $00b70a6da2ab3157$var$call($00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$NUMBER));
var $00b70a6da2ab3157$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $00b70a6da2ab3157$var$call($00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$PERCENTAGE, $00b70a6da2ab3157$var$PERCENTAGE));
var $00b70a6da2ab3157$export$810b04175080204c = new RegExp("hsla" + $00b70a6da2ab3157$var$call($00b70a6da2ab3157$var$NUMBER, $00b70a6da2ab3157$var$PERCENTAGE, $00b70a6da2ab3157$var$PERCENTAGE, $00b70a6da2ab3157$var$NUMBER));
var $00b70a6da2ab3157$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $00b70a6da2ab3157$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $00b70a6da2ab3157$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $00b70a6da2ab3157$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $00b70a6da2ab3157$var$normalizeColor(color) {
    var match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $00b70a6da2ab3157$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($00b70a6da2ab3157$var$colors && $00b70a6da2ab3157$var$colors[color] !== void 0) return $00b70a6da2ab3157$var$colors[color];
    if (match = $00b70a6da2ab3157$export$8972dc0e6ad9238f.exec(color)) return ($00b70a6da2ab3157$var$parse255(match[1]) << 24 | // r
    $00b70a6da2ab3157$var$parse255(match[2]) << 16 | // g
    $00b70a6da2ab3157$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $00b70a6da2ab3157$export$4e46ac54fc82cf3b.exec(color)) return ($00b70a6da2ab3157$var$parse255(match[1]) << 24 | // r
    $00b70a6da2ab3157$var$parse255(match[2]) << 16 | // g
    $00b70a6da2ab3157$var$parse255(match[3]) << 8 | // b
    $00b70a6da2ab3157$var$parse1(match[4])) >>> // a
    0;
    if (match = $00b70a6da2ab3157$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $00b70a6da2ab3157$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $00b70a6da2ab3157$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $00b70a6da2ab3157$export$8f4a7c0bb78e6ea8.exec(color)) return ($00b70a6da2ab3157$var$hslToRgb($00b70a6da2ab3157$var$parse360(match[1]), // h
    $00b70a6da2ab3157$var$parsePercentage(match[2]), // s
    $00b70a6da2ab3157$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $00b70a6da2ab3157$export$810b04175080204c.exec(color)) return ($00b70a6da2ab3157$var$hslToRgb($00b70a6da2ab3157$var$parse360(match[1]), // h
    $00b70a6da2ab3157$var$parsePercentage(match[2]), // s
    $00b70a6da2ab3157$var$parsePercentage(match[3])) | $00b70a6da2ab3157$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $00b70a6da2ab3157$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $00b70a6da2ab3157$var$hslToRgb(h, s, l) {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    var r = $00b70a6da2ab3157$var$hue2rgb(p, q, h + 1 / 3);
    var g = $00b70a6da2ab3157$var$hue2rgb(p, q, h);
    var b = $00b70a6da2ab3157$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $00b70a6da2ab3157$var$parse255(str) {
    var _int = parseInt(str, 10);
    if (_int < 0) return 0;
    if (_int > 255) return 255;
    return _int;
}
function $00b70a6da2ab3157$var$parse360(str) {
    var _int = parseFloat(str);
    return (_int % 360 + 360) % 360 / 360;
}
function $00b70a6da2ab3157$var$parse1(str) {
    var num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $00b70a6da2ab3157$var$parsePercentage(str) {
    var _int = parseFloat(str);
    if (_int < 0) return 0;
    if (_int > 100) return 1;
    return _int / 100;
}
// src/colorToRgba.ts
function $00b70a6da2ab3157$export$61db176b839af1f(input) {
    var int32Color = $00b70a6da2ab3157$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    var r = (int32Color & 4278190080) >>> 24;
    var g = (int32Color & 16711680) >>> 16;
    var b = (int32Color & 65280) >>> 8;
    var a = (int32Color & 255) / 255;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
// src/createInterpolator.ts
var $00b70a6da2ab3157$export$b12af43b97697ef5 = function(range, output, extrapolate) {
    if ($00b70a6da2ab3157$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($00b70a6da2ab3157$export$226b3eccf92c9ed9.arr(range)) return $00b70a6da2ab3157$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($00b70a6da2ab3157$export$226b3eccf92c9ed9.str(range.output[0])) return $00b70a6da2ab3157$var$createStringInterpolator(range);
    var config = range;
    var outputRange = config.output;
    var inputRange = config.range || [
        0,
        1
    ];
    var extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    var extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    var easing = config.easing || function(t) {
        return t;
    };
    return function(input) {
        var range2 = $00b70a6da2ab3157$var$findRange(input, inputRange);
        return $00b70a6da2ab3157$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $00b70a6da2ab3157$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    var result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $00b70a6da2ab3157$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $00b70a6da2ab3157$var$steps = function(steps2) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "end";
    return function(progress2) {
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        var expanded = progress2 * steps2;
        var rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $00b70a6da2ab3157$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
};
var $00b70a6da2ab3157$var$c1 = 1.70158;
var $00b70a6da2ab3157$var$c2 = $00b70a6da2ab3157$var$c1 * 1.525;
var $00b70a6da2ab3157$var$c3 = $00b70a6da2ab3157$var$c1 + 1;
var $00b70a6da2ab3157$var$c4 = 2 * Math.PI / 3;
var $00b70a6da2ab3157$var$c5 = 2 * Math.PI / 4.5;
var $00b70a6da2ab3157$var$bounceOut = function(x) {
    var n1 = 7.5625;
    var d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $00b70a6da2ab3157$export$15a0bf1b4bbacad8 = {
    linear: function(x) {
        return x;
    },
    easeInQuad: function(x) {
        return x * x;
    },
    easeOutQuad: function(x) {
        return 1 - (1 - x) * (1 - x);
    },
    easeInOutQuad: function(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    },
    easeInCubic: function(x) {
        return x * x * x;
    },
    easeOutCubic: function(x) {
        return 1 - Math.pow(1 - x, 3);
    },
    easeInOutCubic: function(x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    },
    easeInQuart: function(x) {
        return x * x * x * x;
    },
    easeOutQuart: function(x) {
        return 1 - Math.pow(1 - x, 4);
    },
    easeInOutQuart: function(x) {
        return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
    },
    easeInQuint: function(x) {
        return x * x * x * x * x;
    },
    easeOutQuint: function(x) {
        return 1 - Math.pow(1 - x, 5);
    },
    easeInOutQuint: function(x) {
        return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
    },
    easeInSine: function(x) {
        return 1 - Math.cos(x * Math.PI / 2);
    },
    easeOutSine: function(x) {
        return Math.sin(x * Math.PI / 2);
    },
    easeInOutSine: function(x) {
        return -(Math.cos(Math.PI * x) - 1) / 2;
    },
    easeInExpo: function(x) {
        return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
    },
    easeOutExpo: function(x) {
        return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    },
    easeInOutExpo: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
    },
    easeInCirc: function(x) {
        return 1 - Math.sqrt(1 - Math.pow(x, 2));
    },
    easeOutCirc: function(x) {
        return Math.sqrt(1 - Math.pow(x - 1, 2));
    },
    easeInOutCirc: function(x) {
        return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
    },
    easeInBack: function(x) {
        return $00b70a6da2ab3157$var$c3 * x * x * x - $00b70a6da2ab3157$var$c1 * x * x;
    },
    easeOutBack: function(x) {
        return 1 + $00b70a6da2ab3157$var$c3 * Math.pow(x - 1, 3) + $00b70a6da2ab3157$var$c1 * Math.pow(x - 1, 2);
    },
    easeInOutBack: function(x) {
        return x < 0.5 ? Math.pow(2 * x, 2) * (($00b70a6da2ab3157$var$c2 + 1) * 2 * x - $00b70a6da2ab3157$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($00b70a6da2ab3157$var$c2 + 1) * (x * 2 - 2) + $00b70a6da2ab3157$var$c2) + 2) / 2;
    },
    easeInElastic: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $00b70a6da2ab3157$var$c4);
    },
    easeOutElastic: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $00b70a6da2ab3157$var$c4) + 1;
    },
    easeInOutElastic: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $00b70a6da2ab3157$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $00b70a6da2ab3157$var$c5) / 2 + 1;
    },
    easeInBounce: function(x) {
        return 1 - $00b70a6da2ab3157$var$bounceOut(1 - x);
    },
    easeOutBounce: $00b70a6da2ab3157$var$bounceOut,
    easeInOutBounce: function(x) {
        return x < 0.5 ? (1 - $00b70a6da2ab3157$var$bounceOut(1 - 2 * x)) / 2 : (1 + $00b70a6da2ab3157$var$bounceOut(2 * x - 1)) / 2;
    },
    steps: $00b70a6da2ab3157$var$steps
};
// src/fluids.ts
var $00b70a6da2ab3157$var$$get = Symbol["for"]("FluidValue.get");
var $00b70a6da2ab3157$var$$observers = Symbol["for"]("FluidValue.observers");
var $00b70a6da2ab3157$export$57ea7e3a7f6280c7 = function(arg) {
    return Boolean(arg && arg[$00b70a6da2ab3157$var$$get]);
};
var $00b70a6da2ab3157$export$e37b7520edd66839 = function(arg) {
    return arg && arg[$00b70a6da2ab3157$var$$get] ? arg[$00b70a6da2ab3157$var$$get]() : arg;
};
var $00b70a6da2ab3157$export$133f54e9f7cf1796 = function(target) {
    return target[$00b70a6da2ab3157$var$$observers] || null;
};
function $00b70a6da2ab3157$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $00b70a6da2ab3157$export$31752c40a5fab62a(target, event) {
    var observers = target[$00b70a6da2ab3157$var$$observers];
    if (observers) observers.forEach(function(observer2) {
        $00b70a6da2ab3157$export$8cbca1207adce0c0(observer2, event);
    });
}
var $00b70a6da2ab3157$export$aff8e1ac1a016a2 = function FluidValue(get) {
    "use strict";
    (0, $6WLcG._)(this, FluidValue);
    if (!get && !(get = this.get)) throw Error("Unknown getter");
    $00b70a6da2ab3157$export$a3b4618659637aa3(this, get);
};
$00b70a6da2ab3157$var$$get, $00b70a6da2ab3157$var$$observers;
var $00b70a6da2ab3157$export$a3b4618659637aa3 = function(target, get) {
    return $00b70a6da2ab3157$var$setHidden(target, $00b70a6da2ab3157$var$$get, get);
};
function $00b70a6da2ab3157$export$72d604e3f8d000a5(target, observer2) {
    if (target[$00b70a6da2ab3157$var$$get]) {
        var observers = target[$00b70a6da2ab3157$var$$observers];
        if (!observers) $00b70a6da2ab3157$var$setHidden(target, $00b70a6da2ab3157$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $00b70a6da2ab3157$export$7a0eb830d336339b(target, observer2) {
    var observers = target[$00b70a6da2ab3157$var$$observers];
    if (observers && observers.has(observer2)) {
        var count = observers.size - 1;
        if (count) observers["delete"](observer2);
        else target[$00b70a6da2ab3157$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $00b70a6da2ab3157$var$setHidden = function(target, key, value) {
    return Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
};
// src/regexs.ts
var $00b70a6da2ab3157$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $00b70a6da2ab3157$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $00b70a6da2ab3157$var$unitRegex = new RegExp("(".concat($00b70a6da2ab3157$var$numberRegex.source, ")(%|[a-z]+)"), "i");
var $00b70a6da2ab3157$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $00b70a6da2ab3157$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $00b70a6da2ab3157$var$variableToRgba = function(input) {
    var _parseCSSVariable = (0, $6mdMa._)($00b70a6da2ab3157$var$parseCSSVariable(input), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    if (!token || $00b70a6da2ab3157$export$48d7c418edadb60c()) return input;
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        var value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $00b70a6da2ab3157$var$cssVariableRegex.test(fallback)) return $00b70a6da2ab3157$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $00b70a6da2ab3157$var$parseCSSVariable = function(current) {
    var match = $00b70a6da2ab3157$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, $6mdMa._)(match, 3), token = _match[1], fallback = _match[2];
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $00b70a6da2ab3157$var$namedColorRegex;
var $00b70a6da2ab3157$var$rgbaRound = function(_, p1, p2, p3, p4) {
    return "rgba(".concat(Math.round(p1), ", ").concat(Math.round(p2), ", ").concat(Math.round(p3), ", ").concat(p4, ")");
};
var $00b70a6da2ab3157$export$4759a013d387347a = function(config) {
    if (!$00b70a6da2ab3157$var$namedColorRegex) $00b70a6da2ab3157$var$namedColorRegex = $00b70a6da2ab3157$var$colors ? // match color names, ignore partial matches
    new RegExp("(".concat(Object.keys($00b70a6da2ab3157$var$colors).join("|"), ")(?!\\w)"), "g") : // never match
    /^\b$/;
    var output = config.output.map(function(value) {
        return $00b70a6da2ab3157$export$e37b7520edd66839(value).replace($00b70a6da2ab3157$var$cssVariableRegex, $00b70a6da2ab3157$var$variableToRgba).replace($00b70a6da2ab3157$var$colorRegex, $00b70a6da2ab3157$export$61db176b839af1f).replace($00b70a6da2ab3157$var$namedColorRegex, $00b70a6da2ab3157$export$61db176b839af1f);
    });
    var keyframes = output.map(function(value) {
        return value.match($00b70a6da2ab3157$var$numberRegex).map(Number);
    });
    var outputRanges = keyframes[0].map(function(_, i) {
        return keyframes.map(function(values) {
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        });
    });
    var interpolators = outputRanges.map(function(output2) {
        return $00b70a6da2ab3157$export$b12af43b97697ef5((0, $7XD9P._)((0, $hRCmZ._)({}, config), {
            output: output2
        }));
    });
    return function(input) {
        var _output_find;
        var missingUnit = !$00b70a6da2ab3157$var$unitRegex.test(output[0]) && ((_output_find = output.find(function(value) {
            return $00b70a6da2ab3157$var$unitRegex.test(value);
        })) === null || _output_find === void 0 ? void 0 : _output_find.replace($00b70a6da2ab3157$var$numberRegex, ""));
        var i = 0;
        return output[0].replace($00b70a6da2ab3157$var$numberRegex, function() {
            return "".concat(interpolators[i++](input)).concat(missingUnit || "");
        }).replace($00b70a6da2ab3157$var$rgbaRegex, $00b70a6da2ab3157$var$rgbaRound);
    };
};
// src/deprecations.ts
var $00b70a6da2ab3157$export$82e9f45cca5ba907 = "react-spring: ";
var $00b70a6da2ab3157$export$d2de3aaeafa91619 = function(fn) {
    var func = fn;
    var called = false;
    if (typeof func != "function") throw new TypeError("".concat($00b70a6da2ab3157$export$82e9f45cca5ba907, "once requires a function parameter"));
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!called) {
            func.apply(void 0, (0, $bOqL7._)(args));
            called = true;
        }
    };
};
var $00b70a6da2ab3157$var$warnInterpolate = $00b70a6da2ab3157$export$d2de3aaeafa91619(console.warn);
function $00b70a6da2ab3157$export$2abfcde8ae218ba8() {
    $00b70a6da2ab3157$var$warnInterpolate("".concat($00b70a6da2ab3157$export$82e9f45cca5ba907, 'The "interpolate" function is deprecated in v9 (use "to" instead)'));
}
var $00b70a6da2ab3157$var$warnDirectCall = $00b70a6da2ab3157$export$d2de3aaeafa91619(console.warn);
function $00b70a6da2ab3157$export$d99d974913ad3b12() {
    $00b70a6da2ab3157$var$warnDirectCall("".concat($00b70a6da2ab3157$export$82e9f45cca5ba907, 'Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions'));
}
// src/isAnimatedString.ts
function $00b70a6da2ab3157$export$75bed621f62abfa9(value) {
    return $00b70a6da2ab3157$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$00b70a6da2ab3157$export$48d7c418edadb60c() && $00b70a6da2ab3157$var$cssVariableRegex.test(value) || value in ($00b70a6da2ab3157$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $00b70a6da2ab3157$var$observer;
var $00b70a6da2ab3157$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $00b70a6da2ab3157$var$handleObservation = function(entries) {
    return entries.forEach(function(param) {
        var target = param.target, contentRect = param.contentRect;
        var _resizeHandlers_get;
        return (_resizeHandlers_get = $00b70a6da2ab3157$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach(function(handler) {
            return handler(contentRect);
        });
    });
};
function $00b70a6da2ab3157$var$resizeElement(handler, target) {
    if (!$00b70a6da2ab3157$var$observer) {
        if (typeof ResizeObserver !== "undefined") $00b70a6da2ab3157$var$observer = new ResizeObserver($00b70a6da2ab3157$var$handleObservation);
    }
    var elementHandlers = $00b70a6da2ab3157$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $00b70a6da2ab3157$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($00b70a6da2ab3157$var$observer) $00b70a6da2ab3157$var$observer.observe(target);
    return function() {
        var elementHandlers2 = $00b70a6da2ab3157$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2["delete"](handler);
        if (!elementHandlers2.size && $00b70a6da2ab3157$var$observer) $00b70a6da2ab3157$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $00b70a6da2ab3157$var$listeners = /* @__PURE__ */ new Set();
var $00b70a6da2ab3157$var$cleanupWindowResizeHandler;
var $00b70a6da2ab3157$var$createResizeHandler = function() {
    var handleResize = function() {
        $00b70a6da2ab3157$var$listeners.forEach(function(callback) {
            return callback({
                width: window.innerWidth,
                height: window.innerHeight
            });
        });
    };
    window.addEventListener("resize", handleResize);
    return function() {
        window.removeEventListener("resize", handleResize);
    };
};
var $00b70a6da2ab3157$var$resizeWindow = function(callback) {
    $00b70a6da2ab3157$var$listeners.add(callback);
    if (!$00b70a6da2ab3157$var$cleanupWindowResizeHandler) $00b70a6da2ab3157$var$cleanupWindowResizeHandler = $00b70a6da2ab3157$var$createResizeHandler();
    return function() {
        $00b70a6da2ab3157$var$listeners["delete"](callback);
        if (!$00b70a6da2ab3157$var$listeners.size && $00b70a6da2ab3157$var$cleanupWindowResizeHandler) {
            $00b70a6da2ab3157$var$cleanupWindowResizeHandler();
            $00b70a6da2ab3157$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $00b70a6da2ab3157$export$45b39e67d4ce4921 = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_container = _ref.container, container = _ref_container === void 0 ? document.documentElement : _ref_container;
    if (container === document.documentElement) return $00b70a6da2ab3157$var$resizeWindow(callback);
    else return $00b70a6da2ab3157$var$resizeElement(callback, container);
};
// src/progress.ts
var $00b70a6da2ab3157$var$progress = function(min, max, value) {
    return max - min === 0 ? 1 : (value - min) / (max - min);
};
// src/dom-events/scroll/ScrollHandler.ts
var $00b70a6da2ab3157$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $00b70a6da2ab3157$var$ScrollHandler = function ScrollHandler(callback, container) {
    "use strict";
    var _this = this;
    (0, $6WLcG._)(this, ScrollHandler);
    this.createAxis = function() {
        return {
            current: 0,
            progress: 0,
            scrollLength: 0
        };
    };
    this.updateAxis = function(axisName) {
        var axis = _this.info[axisName];
        var _SCROLL_KEYS_axisName = $00b70a6da2ab3157$var$SCROLL_KEYS[axisName], length = _SCROLL_KEYS_axisName.length, position = _SCROLL_KEYS_axisName.position;
        axis.current = _this.container["scroll".concat(position)];
        axis.scrollLength = _this.container["scroll".concat(length)] - _this.container["client".concat(length)];
        axis.progress = $00b70a6da2ab3157$var$progress(0, axis.scrollLength, axis.current);
    };
    this.update = function() {
        _this.updateAxis("x");
        _this.updateAxis("y");
    };
    this.sendEvent = function() {
        _this.callback(_this.info);
    };
    this.advance = function() {
        _this.update();
        _this.sendEvent();
    };
    this.callback = callback;
    this.container = container;
    this.info = {
        time: 0,
        x: this.createAxis(),
        y: this.createAxis()
    };
};
// src/dom-events/scroll/index.ts
var $00b70a6da2ab3157$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $00b70a6da2ab3157$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $00b70a6da2ab3157$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $00b70a6da2ab3157$var$getTarget = function(container) {
    return container === document.documentElement ? window : container;
};
var $00b70a6da2ab3157$export$d4d89fd61e5416ee = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_container = _ref.container, container = _ref_container === void 0 ? document.documentElement : _ref_container;
    var containerHandlers = $00b70a6da2ab3157$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $00b70a6da2ab3157$var$onScrollHandlers.set(container, containerHandlers);
    }
    var containerHandler = new $00b70a6da2ab3157$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$00b70a6da2ab3157$var$scrollListeners.has(container)) {
        var listener = function() {
            containerHandlers === null || containerHandlers === void 0 ? void 0 : containerHandlers.forEach(function(handler) {
                return handler.advance();
            });
            return true;
        };
        $00b70a6da2ab3157$var$scrollListeners.set(container, listener);
        var target = $00b70a6da2ab3157$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $00b70a6da2ab3157$var$resizeListeners.set(container, $00b70a6da2ab3157$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    var animateScroll = $00b70a6da2ab3157$var$scrollListeners.get(container);
    (0, $giUWa.raf)(animateScroll);
    return function() {
        (0, $giUWa.raf).cancel(animateScroll);
        var containerHandlers2 = $00b70a6da2ab3157$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2["delete"](containerHandler);
        if (containerHandlers2.size) return;
        var listener = $00b70a6da2ab3157$var$scrollListeners.get(container);
        $00b70a6da2ab3157$var$scrollListeners["delete"](container);
        if (listener) {
            var _resizeListeners_get;
            $00b70a6da2ab3157$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            (_resizeListeners_get = $00b70a6da2ab3157$var$resizeListeners.get(container)) === null || _resizeListeners_get === void 0 ? void 0 : _resizeListeners_get();
        }
    };
};
function $00b70a6da2ab3157$export$fe4300aa8eebea86(init) {
    var ref = (0, $hAGkE.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $00b70a6da2ab3157$export$700979bc83e7db82 = $00b70a6da2ab3157$export$48d7c418edadb60c() ? (0, $hAGkE.useEffect) : (0, $hAGkE.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $00b70a6da2ab3157$var$useIsMounted = function() {
    var isMounted = (0, $hAGkE.useRef)(false);
    $00b70a6da2ab3157$export$700979bc83e7db82(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $00b70a6da2ab3157$export$91db9bc4f8ac944a() {
    var update = (0, $hAGkE.useState)()[1];
    var isMounted = $00b70a6da2ab3157$var$useIsMounted();
    return function() {
        if (isMounted.current) update(Math.random());
    };
}
function $00b70a6da2ab3157$export$b6feb8998cd9b342(getResult, inputs) {
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    }), 1), initial = _useState2[0];
    var committed = (0, $hAGkE.useRef)();
    var prevCache = committed.current;
    var cache = prevCache;
    if (cache) {
        var useCache = Boolean(inputs && cache.inputs && $00b70a6da2ab3157$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $hAGkE.useEffect)(function() {
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $00b70a6da2ab3157$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(var i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $00b70a6da2ab3157$export$392544347a18b6ea = function(effect) {
    return (0, $hAGkE.useEffect)(effect, $00b70a6da2ab3157$var$emptyDeps);
};
var $00b70a6da2ab3157$var$emptyDeps = [];
function $00b70a6da2ab3157$export$ef7ad0c4e19d7fbf(value) {
    var prevRef = (0, $hAGkE.useRef)();
    (0, $hAGkE.useEffect)(function() {
        prevRef.current = value;
    });
    return prevRef.current;
}
var $00b70a6da2ab3157$export$6a42007cf1e7b6f8 = function() {
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), reducedMotion = _useState3[0], setReducedMotion = _useState3[1];
    $00b70a6da2ab3157$export$700979bc83e7db82(function() {
        var mql = window.matchMedia("(prefers-reduced-motion)");
        var handleMediaChange = function(e) {
            setReducedMotion(e.matches);
            $00b70a6da2ab3157$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return function() {
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

});
parcelRegister("giUWa", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $bdea7e535431efe8$export$27f233d61a9e2fa4; });
// src/index.ts

var $bOqL7 = parcelRequire("bOqL7");
var $bdea7e535431efe8$var$updateQueue = $bdea7e535431efe8$var$makeQueue();
var $bdea7e535431efe8$export$27f233d61a9e2fa4 = function(fn) {
    return $bdea7e535431efe8$var$schedule(fn, $bdea7e535431efe8$var$updateQueue);
};
var $bdea7e535431efe8$var$writeQueue = $bdea7e535431efe8$var$makeQueue();
$bdea7e535431efe8$export$27f233d61a9e2fa4.write = function(fn) {
    return $bdea7e535431efe8$var$schedule(fn, $bdea7e535431efe8$var$writeQueue);
};
var $bdea7e535431efe8$var$onStartQueue = $bdea7e535431efe8$var$makeQueue();
$bdea7e535431efe8$export$27f233d61a9e2fa4.onStart = function(fn) {
    return $bdea7e535431efe8$var$schedule(fn, $bdea7e535431efe8$var$onStartQueue);
};
var $bdea7e535431efe8$var$onFrameQueue = $bdea7e535431efe8$var$makeQueue();
$bdea7e535431efe8$export$27f233d61a9e2fa4.onFrame = function(fn) {
    return $bdea7e535431efe8$var$schedule(fn, $bdea7e535431efe8$var$onFrameQueue);
};
var $bdea7e535431efe8$var$onFinishQueue = $bdea7e535431efe8$var$makeQueue();
$bdea7e535431efe8$export$27f233d61a9e2fa4.onFinish = function(fn) {
    return $bdea7e535431efe8$var$schedule(fn, $bdea7e535431efe8$var$onFinishQueue);
};
var $bdea7e535431efe8$var$timeouts = [];
$bdea7e535431efe8$export$27f233d61a9e2fa4.setTimeout = function(handler, ms) {
    var time = $bdea7e535431efe8$export$27f233d61a9e2fa4.now() + ms;
    var cancel = function() {
        var i = $bdea7e535431efe8$var$timeouts.findIndex(function(t) {
            return t.cancel == cancel;
        });
        if (~i) $bdea7e535431efe8$var$timeouts.splice(i, 1);
        $bdea7e535431efe8$var$pendingCount -= ~i ? 1 : 0;
    };
    var timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $bdea7e535431efe8$var$timeouts.splice($bdea7e535431efe8$var$findTimeout(time), 0, timeout);
    $bdea7e535431efe8$var$pendingCount += 1;
    $bdea7e535431efe8$var$start();
    return timeout;
};
var $bdea7e535431efe8$var$findTimeout = function(time) {
    return ~(~$bdea7e535431efe8$var$timeouts.findIndex(function(t) {
        return t.time > time;
    }) || ~$bdea7e535431efe8$var$timeouts.length);
};
$bdea7e535431efe8$export$27f233d61a9e2fa4.cancel = function(fn) {
    $bdea7e535431efe8$var$onStartQueue["delete"](fn);
    $bdea7e535431efe8$var$onFrameQueue["delete"](fn);
    $bdea7e535431efe8$var$onFinishQueue["delete"](fn);
    $bdea7e535431efe8$var$updateQueue["delete"](fn);
    $bdea7e535431efe8$var$writeQueue["delete"](fn);
};
$bdea7e535431efe8$export$27f233d61a9e2fa4.sync = function(fn) {
    $bdea7e535431efe8$var$sync = true;
    $bdea7e535431efe8$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $bdea7e535431efe8$var$sync = false;
};
$bdea7e535431efe8$export$27f233d61a9e2fa4.throttle = function(fn) {
    var queuedFn = function queuedFn() {
        try {
            fn.apply(void 0, (0, $bOqL7._)(lastArgs));
        } finally{
            lastArgs = null;
        }
    };
    var throttled = function throttled() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        lastArgs = args;
        $bdea7e535431efe8$export$27f233d61a9e2fa4.onStart(queuedFn);
    };
    var lastArgs;
    throttled.handler = fn;
    throttled.cancel = function() {
        $bdea7e535431efe8$var$onStartQueue["delete"](queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $bdea7e535431efe8$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
function() {};
$bdea7e535431efe8$export$27f233d61a9e2fa4.use = function(impl) {
    return $bdea7e535431efe8$var$nativeRaf = impl;
};
$bdea7e535431efe8$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? function() {
    return performance.now();
} : Date.now;
$bdea7e535431efe8$export$27f233d61a9e2fa4.batchedUpdates = function(fn) {
    return fn();
};
$bdea7e535431efe8$export$27f233d61a9e2fa4["catch"] = console.error;
$bdea7e535431efe8$export$27f233d61a9e2fa4.frameLoop = "always";
$bdea7e535431efe8$export$27f233d61a9e2fa4.advance = function() {
    if ($bdea7e535431efe8$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $bdea7e535431efe8$var$update();
};
var $bdea7e535431efe8$var$ts = -1;
var $bdea7e535431efe8$var$pendingCount = 0;
var $bdea7e535431efe8$var$sync = false;
function $bdea7e535431efe8$var$schedule(fn, queue) {
    if ($bdea7e535431efe8$var$sync) {
        queue["delete"](fn);
        fn(0);
    } else {
        queue.add(fn);
        $bdea7e535431efe8$var$start();
    }
}
function $bdea7e535431efe8$var$start() {
    if ($bdea7e535431efe8$var$ts < 0) {
        $bdea7e535431efe8$var$ts = 0;
        if ($bdea7e535431efe8$export$27f233d61a9e2fa4.frameLoop !== "demand") $bdea7e535431efe8$var$nativeRaf($bdea7e535431efe8$var$loop);
    }
}
function $bdea7e535431efe8$var$stop() {
    $bdea7e535431efe8$var$ts = -1;
}
function $bdea7e535431efe8$var$loop() {
    if (~$bdea7e535431efe8$var$ts) {
        $bdea7e535431efe8$var$nativeRaf($bdea7e535431efe8$var$loop);
        $bdea7e535431efe8$export$27f233d61a9e2fa4.batchedUpdates($bdea7e535431efe8$var$update);
    }
}
function $bdea7e535431efe8$var$update() {
    var prevTs = $bdea7e535431efe8$var$ts;
    $bdea7e535431efe8$var$ts = $bdea7e535431efe8$export$27f233d61a9e2fa4.now();
    var count = $bdea7e535431efe8$var$findTimeout($bdea7e535431efe8$var$ts);
    if (count) {
        $bdea7e535431efe8$var$eachSafely($bdea7e535431efe8$var$timeouts.splice(0, count), function(t) {
            return t.handler();
        });
        $bdea7e535431efe8$var$pendingCount -= count;
    }
    if (!$bdea7e535431efe8$var$pendingCount) {
        $bdea7e535431efe8$var$stop();
        return;
    }
    $bdea7e535431efe8$var$onStartQueue.flush();
    $bdea7e535431efe8$var$updateQueue.flush(prevTs ? Math.min(64, $bdea7e535431efe8$var$ts - prevTs) : 16.667);
    $bdea7e535431efe8$var$onFrameQueue.flush();
    $bdea7e535431efe8$var$writeQueue.flush();
    $bdea7e535431efe8$var$onFinishQueue.flush();
}
function $bdea7e535431efe8$var$makeQueue() {
    var next = /* @__PURE__ */ new Set();
    var current = next;
    return {
        add: function(fn) {
            $bdea7e535431efe8$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        "delete": function(fn) {
            $bdea7e535431efe8$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next["delete"](fn);
        },
        flush: function(arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $bdea7e535431efe8$var$pendingCount -= current.size;
                $bdea7e535431efe8$var$eachSafely(current, function(fn) {
                    return fn(arg) && next.add(fn);
                });
                $bdea7e535431efe8$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $bdea7e535431efe8$var$eachSafely(values, each) {
    values.forEach(function(value) {
        try {
            each(value);
        } catch (e) {
            $bdea7e535431efe8$export$27f233d61a9e2fa4["catch"](e);
        }
    });
}
var $bdea7e535431efe8$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count: function() {
        return $bdea7e535431efe8$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning: function() {
        return $bdea7e535431efe8$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear: function() {
        $bdea7e535431efe8$var$ts = -1;
        $bdea7e535431efe8$var$timeouts = [];
        $bdea7e535431efe8$var$onStartQueue = $bdea7e535431efe8$var$makeQueue();
        $bdea7e535431efe8$var$updateQueue = $bdea7e535431efe8$var$makeQueue();
        $bdea7e535431efe8$var$onFrameQueue = $bdea7e535431efe8$var$makeQueue();
        $bdea7e535431efe8$var$writeQueue = $bdea7e535431efe8$var$makeQueue();
        $bdea7e535431efe8$var$onFinishQueue = $bdea7e535431efe8$var$makeQueue();
        $bdea7e535431efe8$var$pendingCount = 0;
    }
};

});


parcelRegister("klJjI", function(module, exports) {

$parcel$export(module.exports, "getAnimated", function () { return getAnimated; });
$parcel$export(module.exports, "setAnimated", function () { return setAnimated; });
$parcel$export(module.exports, "getPayload", function () { return getPayload; });
$parcel$export(module.exports, "AnimatedValue", function () { return AnimatedValue; });
$parcel$export(module.exports, "AnimatedString", function () { return AnimatedString; });
$parcel$export(module.exports, "AnimatedObject", function () { return AnimatedObject; });
$parcel$export(module.exports, "getAnimatedType", function () { return getAnimatedType; });
$parcel$export(module.exports, "createHost", function () { return createHost; });
// src/Animated.ts

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $gBEGf = parcelRequire("gBEGf");

var $3LSeA = parcelRequire("3LSeA");

var $a7G5R = parcelRequire("a7G5R");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $03NY2 = parcelRequire("03NY2");
var $giUWa = parcelRequire("giUWa");

var $hAGkE = parcelRequire("hAGkE");
var $node = Symbol["for"]("Animated:node");
var isAnimated = function(value) {
    return !!value && value[$node] === value;
};
var getAnimated = function(owner) {
    return owner && owner[$node];
};
var setAnimated = function(owner, node) {
    return (0, $03NY2.defineHidden)(owner, $node, node);
};
var getPayload = function(owner) {
    return owner && owner[$node] && owner[$node].getPayload();
};
var Animated = /*#__PURE__*/ function() {
    "use strict";
    function Animated() {
        (0, $6WLcG._)(this, Animated);
        setAnimated(this, this);
    }
    (0, $dbIwN._)(Animated, [
        {
            /** Get every `AnimatedValue` used by this node. */ key: "getPayload",
            value: function getPayload() {
                return this.payload || [];
            }
        }
    ]);
    return Animated;
}();
var AnimatedValue = /*#__PURE__*/ function(Animated) {
    "use strict";
    (0, $a7G5R._)(AnimatedValue1, Animated);
    function AnimatedValue1(_value) {
        (0, $6WLcG._)(this, AnimatedValue1);
        var _this;
        _this = (0, $bQby9._)(this, AnimatedValue1);
        _this._value = _value;
        _this.done = true;
        _this.durationProgress = 0;
        if ((0, $03NY2.is).num(_this._value)) _this.lastPosition = _this._value;
        return _this;
    }
    (0, $dbIwN._)(AnimatedValue1, [
        {
            key: "getPayload",
            value: function getPayload() {
                return [
                    this
                ];
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this._value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value, step) {
                if ((0, $03NY2.is).num(value)) {
                    this.lastPosition = value;
                    if (step) {
                        value = Math.round(value / step) * step;
                        if (this.done) this.lastPosition = value;
                    }
                }
                if (this._value === value) return false;
                this._value = value;
                return true;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var done = this.done;
                this.done = false;
                if ((0, $03NY2.is).num(this._value)) {
                    this.elapsedTime = 0;
                    this.durationProgress = 0;
                    this.lastPosition = this._value;
                    if (done) this.lastVelocity = null;
                    this.v0 = null;
                }
            }
        }
    ], [
        {
            key: "create",
            value: /** @internal */ function create(value) {
                return new AnimatedValue(value);
            }
        }
    ]);
    return AnimatedValue1;
}(Animated);
var AnimatedString = /*#__PURE__*/ function(AnimatedValue) {
    "use strict";
    (0, $a7G5R._)(AnimatedString1, AnimatedValue);
    function AnimatedString1(value) {
        (0, $6WLcG._)(this, AnimatedString1);
        var _this;
        _this = (0, $bQby9._)(this, AnimatedString1, [
            0
        ]);
        _this._string = null;
        _this._toString = (0, $03NY2.createInterpolator)({
            output: [
                value,
                value
            ]
        });
        return _this;
    }
    (0, $dbIwN._)(AnimatedString1, [
        {
            key: "getValue",
            value: function getValue() {
                var value = this._string;
                return value == null ? this._string = this._toString(this._value) : value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                if ((0, $03NY2.is).str(value)) {
                    if (value == this._string) return false;
                    this._string = value;
                    this._value = 1;
                } else if ((0, $gBEGf._)((0, $3LSeA._)(AnimatedString1.prototype), "setValue", this).call(this, value)) this._string = null;
                else return false;
                return true;
            }
        },
        {
            key: "reset",
            value: function reset(goal) {
                if (goal) this._toString = (0, $03NY2.createInterpolator)({
                    output: [
                        this.getValue(),
                        goal
                    ]
                });
                this._value = 0;
                (0, $gBEGf._)((0, $3LSeA._)(AnimatedString1.prototype), "reset", this).call(this);
            }
        }
    ], [
        {
            key: "create",
            value: /** @internal */ function create(value) {
                return new AnimatedString(value);
            }
        }
    ]);
    return AnimatedString1;
}(AnimatedValue);
// src/context.ts
var TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var AnimatedObject = /*#__PURE__*/ function(Animated) {
    "use strict";
    (0, $a7G5R._)(AnimatedObject, Animated);
    function AnimatedObject(source) {
        (0, $6WLcG._)(this, AnimatedObject);
        var _this;
        _this = (0, $bQby9._)(this, AnimatedObject);
        _this.source = source;
        _this.setValue(source);
        return _this;
    }
    (0, $dbIwN._)(AnimatedObject, [
        {
            key: "getValue",
            value: function getValue(animated) {
                var values = {};
                (0, $03NY2.eachProp)(this.source, function(source, key) {
                    if (isAnimated(source)) values[key] = source.getValue(animated);
                    else if ((0, $03NY2.hasFluidValue)(source)) values[key] = (0, $03NY2.getFluidValue)(source);
                    else if (!animated) values[key] = source;
                });
                return values;
            }
        },
        {
            /** Replace the raw object data */ key: "setValue",
            value: function setValue(source) {
                this.source = source;
                this.payload = this._makePayload(source);
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.payload) (0, $03NY2.each)(this.payload, function(node) {
                    return node.reset();
                });
            }
        },
        {
            /** Create a payload set. */ key: "_makePayload",
            value: function _makePayload(source) {
                if (source) {
                    var payload = /* @__PURE__ */ new Set();
                    (0, $03NY2.eachProp)(source, this._addToPayload, payload);
                    return Array.from(payload);
                }
            }
        },
        {
            /** Add to a payload set. */ key: "_addToPayload",
            value: function _addToPayload(source) {
                var _this = this;
                if (TreeContext.dependencies && (0, $03NY2.hasFluidValue)(source)) TreeContext.dependencies.add(source);
                var payload = getPayload(source);
                if (payload) (0, $03NY2.each)(payload, function(node) {
                    return _this.add(node);
                });
            }
        }
    ]);
    return AnimatedObject;
}(Animated);
// src/AnimatedArray.ts
var AnimatedArray = /*#__PURE__*/ function(AnimatedObject) {
    "use strict";
    (0, $a7G5R._)(AnimatedArray1, AnimatedObject);
    function AnimatedArray1(source) {
        (0, $6WLcG._)(this, AnimatedArray1);
        return (0, $bQby9._)(this, AnimatedArray1, [
            source
        ]);
    }
    (0, $dbIwN._)(AnimatedArray1, [
        {
            key: "getValue",
            value: function getValue() {
                return this.source.map(function(node) {
                    return node.getValue();
                });
            }
        },
        {
            key: "setValue",
            value: function setValue(source) {
                var payload = this.getPayload();
                if (source.length == payload.length) return payload.map(function(node, i) {
                    return node.setValue(source[i]);
                }).some(Boolean);
                (0, $gBEGf._)((0, $3LSeA._)(AnimatedArray1.prototype), "setValue", this).call(this, source.map(makeAnimated));
                return true;
            }
        }
    ], [
        {
            key: "create",
            value: /** @internal */ function create(source) {
                return new AnimatedArray(source);
            }
        }
    ]);
    return AnimatedArray1;
}(AnimatedObject);
function makeAnimated(value) {
    var nodeType = (0, $03NY2.isAnimatedString)(value) ? AnimatedString : AnimatedValue;
    return nodeType.create(value);
}
function getAnimatedType(value) {
    var parentNode = getAnimated(value);
    return parentNode ? parentNode.constructor : (0, $03NY2.is).arr(value) ? AnimatedArray : (0, $03NY2.isAnimatedString)(value) ? AnimatedString : AnimatedValue;
}
var withAnimated = function(Component, host) {
    var hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $03NY2.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $hAGkE.forwardRef)(function(givenProps, givenRef) {
        var instanceRef = (0, $hAGkE.useRef)(null);
        var ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $hAGkE.useCallback)(function(value) {
            instanceRef.current = updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        var _getAnimatedState = (0, $6mdMa._)(getAnimatedState(givenProps, host), 2), props = _getAnimatedState[0], deps = _getAnimatedState[1];
        var forceUpdate = (0, $03NY2.useForceUpdate)();
        var callback = function() {
            var instance = instanceRef.current;
            if (hasInstance && !instance) return;
            var didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        var observer = new PropsObserver(callback, deps);
        var observerRef = (0, $hAGkE.useRef)();
        (0, $03NY2.useIsomorphicLayoutEffect)(function() {
            observerRef.current = observer;
            (0, $03NY2.each)(deps, function(dep) {
                return (0, $03NY2.addFluidObserver)(dep, observer);
            });
            return function() {
                if (observerRef.current) {
                    (0, $03NY2.each)(observerRef.current.deps, function(dep) {
                        return (0, $03NY2.removeFluidObserver)(dep, observerRef.current);
                    });
                    (0, $giUWa.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, $hAGkE.useEffect)(callback, []);
        (0, $03NY2.useOnce)(function() {
            return function() {
                var observer2 = observerRef.current;
                (0, $03NY2.each)(observer2.deps, function(dep) {
                    return (0, $03NY2.removeFluidObserver)(dep, observer2);
                });
            };
        });
        var usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $hAGkE.createElement(Component, (0, $7XD9P._)((0, $hRCmZ._)({}, usedProps), {
            ref: ref
        }));
    });
};
var PropsObserver = /*#__PURE__*/ function() {
    "use strict";
    function PropsObserver(update, deps) {
        (0, $6WLcG._)(this, PropsObserver);
        this.update = update;
        this.deps = deps;
    }
    (0, $dbIwN._)(PropsObserver, [
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") (0, $giUWa.raf).write(this.update);
            }
        }
    ]);
    return PropsObserver;
}();
function getAnimatedState(props, host) {
    var dependencies = /* @__PURE__ */ new Set();
    TreeContext.dependencies = dependencies;
    if (props.style) props = (0, $7XD9P._)((0, $hRCmZ._)({}, props), {
        style: host.createAnimatedStyle(props.style)
    });
    props = new AnimatedObject(props);
    TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function updateRef(ref, value) {
    if (ref) {
        if ((0, $03NY2.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var cacheKey = Symbol["for"]("AnimatedComponent");
var createHost = function(components) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_applyAnimatedValues = _ref.applyAnimatedValues, applyAnimatedValues = _ref_applyAnimatedValues === void 0 ? function() {
        return false;
    } : _ref_applyAnimatedValues, _ref_createAnimatedStyle = _ref.createAnimatedStyle, createAnimatedStyle = _ref_createAnimatedStyle === void 0 ? function(style) {
        return new AnimatedObject(style);
    } : _ref_createAnimatedStyle, _ref_getComponentProps = _ref.getComponentProps, getComponentProps = _ref_getComponentProps === void 0 ? function(props) {
        return props;
    } : _ref_getComponentProps;
    var hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    var animated = function(Component) {
        var displayName = getDisplayName(Component) || "Anonymous";
        if ((0, $03NY2.is).str(Component)) Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
        else Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
        Component.displayName = "Animated(".concat(displayName, ")");
        return Component;
    };
    (0, $03NY2.eachProp)(components, function(Component, key) {
        if ((0, $03NY2.is).arr(components)) key = getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var getDisplayName = function(arg) {
    return (0, $03NY2.is).str(arg) ? arg : arg && (0, $03NY2.is).str(arg.displayName) ? arg.displayName : (0, $03NY2.is).fun(arg) && arg.name || null;
};

});

parcelRegister("fBQnz", function(module, exports) {
// src/utils.ts

var $6WLcG = parcelRequire("6WLcG");
var $b5d2f12161be00e6$export$b24b633b1364b94b = function Any() {
    "use strict";
    (0, $6WLcG._)(this, Any);
};

});


parcelRegister("2nPTC", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", function () { return addExtensionMethods; });

var $bOqL7 = parcelRequire("bOqL7");

var $58WN1 = parcelRequire("58WN1");
var $8fOd9 = parcelRequire("8fOd9");

var $4qd5R = parcelRequire("4qd5R");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    var carrier = (0, $8fOd9.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    var packageToIntegrationMapping = {
        mongodb: function() {
            var integration = (0, $4qd5R.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose: function() {
            var integration = (0, $4qd5R.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mysql: function() {
            var integration = (0, $4qd5R.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg: function() {
            var integration = (0, $4qd5R.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping).filter(function(moduleName) {
        return !!(0, $4qd5R.loadModule)(moduleName);
    }).map(function(pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter(function(p) {
        return p;
    });
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = (0, $bOqL7._)(carrier.__SENTRY__.integrations || []).concat((0, $bOqL7._)(mappedPackages));
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $58WN1.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $4qd5R.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("58WN1", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $3beb4d8927e050cf$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $3beb4d8927e050cf$export$653d0ef2bad9cdf9; });

var $hRCmZ = parcelRequire("hRCmZ");

var $gVncj = parcelRequire("gVncj");

var $7Ui5X = parcelRequire("7Ui5X");

var $8fOd9 = parcelRequire("8fOd9");

var $6hfta = parcelRequire("6hfta");

var $lRe3s = parcelRequire("lRe3s");

var $lFTnW = parcelRequire("lFTnW");

var $8HkIr = parcelRequire("8HkIr");

var $lNNKl = parcelRequire("lNNKl");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $3beb4d8927e050cf$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    var scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    var span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $6hfta.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $3beb4d8927e050cf$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    var configInstrumenter = options.instrumenter || 'sentry';
    var transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).error("A transaction was started with instrumenter=`".concat(transactionInstrumenter, "`, but the SDK is configured with the `").concat(configInstrumenter, "` instrumenter.\nThe transaction will not be sampled. Please use the ").concat(configInstrumenter, " instrumentation to start transactions."));
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new (0, $lNNKl.Transaction)(transactionContext, this);
    transaction = (0, $8HkIr.sampleTransaction)(transaction, options, (0, $hRCmZ._)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0, $hRCmZ._)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $3beb4d8927e050cf$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    var delayAutoFinishUntilSignal = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    // eslint-disable-next-line deprecation/deprecation
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new (0, $lFTnW.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $8HkIr.sampleTransaction)(transaction, options, (0, $hRCmZ._)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0, $hRCmZ._)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $3beb4d8927e050cf$export$653d0ef2bad9cdf9() {
    var carrier = (0, $8fOd9.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $3beb4d8927e050cf$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $3beb4d8927e050cf$var$traceHeaders;
    (0, $lRe3s.registerErrorInstrumentation)();
}

});
parcelRegister("lRe3s", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $fe99732c96048bdc$export$637857c1d87b640c; });

var $ijeNb = parcelRequire("ijeNb");
var $2LduO = parcelRequire("2LduO");
var $gVncj = parcelRequire("gVncj");

var $7Ui5X = parcelRequire("7Ui5X");

var $iNMpq = parcelRequire("iNMpq");
var $fe99732c96048bdc$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $fe99732c96048bdc$export$637857c1d87b640c() {
    if ($fe99732c96048bdc$var$errorsInstrumented) return;
    $fe99732c96048bdc$var$errorsInstrumented = true;
    (0, $ijeNb.addGlobalErrorInstrumentationHandler)($fe99732c96048bdc$var$errorCallback);
    (0, $2LduO.addGlobalUnhandledRejectionInstrumentationHandler)($fe99732c96048bdc$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $fe99732c96048bdc$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    var activeTransaction = (0, $iNMpq.getActiveTransaction)();
    if (activeTransaction) {
        var status = 'internal_error';
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("[Tracing] Transaction: ".concat(status, " -> Global error occured"));
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$fe99732c96048bdc$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("ijeNb", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $d54579cc5b034868$export$55b5c3ba2194f0c6; });

var $lVfPx = parcelRequire("lVfPx");

var $3SZNV = parcelRequire("3SZNV");
var $d54579cc5b034868$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d54579cc5b034868$export$55b5c3ba2194f0c6(handler) {
    var type = 'error';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $d54579cc5b034868$var$instrumentError);
}
function $d54579cc5b034868$var$instrumentError() {
    $d54579cc5b034868$var$_oldOnErrorHandler = (0, $lVfPx.GLOBAL_OBJ).onerror;
    (0, $lVfPx.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $3SZNV.triggerHandlers)('error', handlerData);
        if ($d54579cc5b034868$var$_oldOnErrorHandler && !$d54579cc5b034868$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d54579cc5b034868$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $lVfPx.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("3SZNV", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $2d465b425ccd842b$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $2d465b425ccd842b$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $2d465b425ccd842b$export$b18c893e424d3127; });

var $84Gbr = parcelRequire("84Gbr");

var $gVncj = parcelRequire("gVncj");

var $dRvnI = parcelRequire("dRvnI");
// We keep the handlers globally
var $2d465b425ccd842b$var$handlers = {};
var $2d465b425ccd842b$var$instrumented = {};
/** Add a handler function. */ function $2d465b425ccd842b$export$a4e09611e30da72e(type, handler) {
    $2d465b425ccd842b$var$handlers[type] = $2d465b425ccd842b$var$handlers[type] || [];
    $2d465b425ccd842b$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $2d465b425ccd842b$export$b17eab759a1cb5fe() {
    Object.keys($2d465b425ccd842b$var$handlers).forEach(function(key) {
        $2d465b425ccd842b$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $2d465b425ccd842b$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$2d465b425ccd842b$var$instrumented[type]) {
        instrumentFn();
        $2d465b425ccd842b$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $2d465b425ccd842b$export$b18c893e424d3127(type, data) {
    var typeHandlers = type && $2d465b425ccd842b$var$handlers[type];
    if (!typeHandlers) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, $84Gbr.DEBUG_BUILD) && (0, $gVncj.logger).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, $dRvnI.getFunctionName)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});


parcelRegister("2LduO", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $202a70920f12807b$export$8bf4fc6858821a4e; });

var $lVfPx = parcelRequire("lVfPx");

var $3SZNV = parcelRequire("3SZNV");
var $202a70920f12807b$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $202a70920f12807b$export$8bf4fc6858821a4e(handler) {
    var type = 'unhandledrejection';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $202a70920f12807b$var$instrumentUnhandledRejection);
}
function $202a70920f12807b$var$instrumentUnhandledRejection() {
    $202a70920f12807b$var$_oldOnUnhandledRejectionHandler = (0, $lVfPx.GLOBAL_OBJ).onunhandledrejection;
    (0, $lVfPx.GLOBAL_OBJ).onunhandledrejection = function(e) {
        var handlerData = e;
        (0, $3SZNV.triggerHandlers)('unhandledrejection', handlerData);
        if ($202a70920f12807b$var$_oldOnUnhandledRejectionHandler && !$202a70920f12807b$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $202a70920f12807b$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $lVfPx.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("iNMpq", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $db025aa7079c2a27$export$a7feb32fdd923295; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $db025aa7079c2a27$export$8e9a29865c0a1226; });

var $iAzzt = parcelRequire("iAzzt");

var $8fOd9 = parcelRequire("8fOd9");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $db025aa7079c2a27$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = maybeHub || (0, $8fOd9.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    var scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ var $db025aa7079c2a27$export$8e9a29865c0a1226 = (0, $iAzzt.extractTraceparentData);

});


parcelRegister("lFTnW", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $fc7863a5eb83ddc5$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $fc7863a5eb83ddc5$export$b279e6bd7040371f; });

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $gBEGf = parcelRequire("gBEGf");

var $3LSeA = parcelRequire("3LSeA");

var $a7G5R = parcelRequire("a7G5R");

var $gVncj = parcelRequire("gVncj");
var $fzAJT = parcelRequire("fzAJT");

var $7Ui5X = parcelRequire("7Ui5X");

var $6hfta = parcelRequire("6hfta");

var $bCb3d = parcelRequire("bCb3d");

var $lNNKl = parcelRequire("lNNKl");
var $fc7863a5eb83ddc5$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
var $fc7863a5eb83ddc5$var$FINISH_REASON_TAG = 'finishReason';
var $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ var $fc7863a5eb83ddc5$export$370d6113c18ba86c = /*#__PURE__*/ function(SpanRecorder) {
    "use strict";
    (0, $a7G5R._)(IdleTransactionSpanRecorder, SpanRecorder);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        (0, $6WLcG._)(this, IdleTransactionSpanRecorder);
        var _this;
        _this = (0, $bQby9._)(this, IdleTransactionSpanRecorder, [
            maxlen
        ]);
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    (0, $dbIwN._)(IdleTransactionSpanRecorder, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(span) {
                // We should make sure we do not push and pop activities for
                // the transaction that this span recorder belongs to.
                if (span.spanContext().spanId !== this.transactionSpanId) {
                    var _this = this;
                    // We patch span.end() to pop an activity after setting an endTimestamp.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    var originalEnd = span.end;
                    span.end = function() {
                        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
                            rest[_key] = arguments[_key];
                        }
                        _this._popActivity(span.spanContext().spanId);
                        return originalEnd.apply(span, rest);
                    };
                    // We should only push new activities if the span does not have an end timestamp.
                    if ((0, $6hfta.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
                }
                (0, $gBEGf._)((0, $3LSeA._)(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
            }
        }
    ]);
    return IdleTransactionSpanRecorder;
}((0, $bCb3d.SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var $fc7863a5eb83ddc5$export$b279e6bd7040371f = /*#__PURE__*/ function(Transaction) {
    "use strict";
    (0, $a7G5R._)(IdleTransaction, Transaction);
    function IdleTransaction(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub) {
        var /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $fc7863a5eb83ddc5$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $fc7863a5eb83ddc5$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $fc7863a5eb83ddc5$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
        _onScope = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
        (0, $6WLcG._)(this, IdleTransaction);
        var _this;
        _this = (0, $bQby9._)(this, IdleTransaction, [
            transactionContext,
            _idleHub
        ]);
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._finalTimeout = _finalTimeout;
        _this._heartbeatInterval = _heartbeatInterval;
        _this._onScope = _onScope;
        _this.activities = {};
        _this._heartbeatCounter = 0;
        _this._finished = false;
        _this._idleTimeoutCanceledPermanently = false;
        _this._beforeFinishCallbacks = [];
        _this._finishReason = $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        _this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("Setting idle transaction on scope. Span ID: ".concat(_this.spanContext().spanId));
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(_this);
        }
        if (!delayAutoFinishUntilSignal) _this._restartIdleTimeout();
        setTimeout(function() {
            if (!_this._finished) {
                _this.setStatus('deadline_exceeded');
                _this._finishReason = $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                _this.end();
            }
        }, _this._finalTimeout);
        return _this;
    }
    (0, $dbIwN._)(IdleTransaction, [
        {
            /** {@inheritDoc} */ key: "end",
            value: function end(endTimestamp) {
                var _this = this;
                var endTimestampInS = (0, $6hfta.spanTimeInputToSeconds)(endTimestamp);
                this._finished = true;
                this.activities = {};
                // eslint-disable-next-line deprecation/deprecation
                if (this.op === 'ui.action.click') this.setAttribute($fc7863a5eb83ddc5$var$FINISH_REASON_TAG, this._finishReason);
                // eslint-disable-next-line deprecation/deprecation
                if (this.spanRecorder) {
                    (0, $7Ui5X.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
                    (0, $gVncj.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._beforeFinishCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var callback = _step.value;
                            callback(this, endTimestampInS);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                        // If we are dealing with the transaction itself, we just return it
                        if (span.spanContext().spanId === _this.spanContext().spanId) return true;
                        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                        if (!(0, $6hfta.spanToJSON)(span).timestamp) {
                            span.setStatus('cancelled');
                            span.end(endTimestampInS);
                            (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                        }
                        var _spanToJSON = (0, $6hfta.spanToJSON)(span), startTime = _spanToJSON.start_timestamp, endTime = _spanToJSON.timestamp;
                        var spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                        // Add a delta with idle timeout so that we prevent false positives
                        var timeoutWithMarginOfError = (_this._finalTimeout + _this._idleTimeout) / 1000;
                        var spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                        if (0, $7Ui5X.DEBUG_BUILD) {
                            var stringifiedSpan = JSON.stringify(span, undefined, 2);
                            if (!spanStartedBeforeTransactionFinish) (0, $gVncj.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                            else if (!spanEndedBeforeFinalTimeout) (0, $gVncj.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                        }
                        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
                    });
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] flushing IdleTransaction');
                } else (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] No active IdleTransaction');
                // if `this._onScope` is `true`, the transaction put itself on the scope when it started
                if (this._onScope) {
                    // eslint-disable-next-line deprecation/deprecation
                    var scope = this._idleHub.getScope();
                    // eslint-disable-next-line deprecation/deprecation
                    if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
                    scope.setSpan(undefined);
                }
                return (0, $gBEGf._)((0, $3LSeA._)(IdleTransaction.prototype), "end", this).call(this, endTimestamp);
            }
        },
        {
            /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ key: "registerBeforeFinishCallback",
            value: function registerBeforeFinishCallback(callback) {
                this._beforeFinishCallbacks.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "initSpanRecorder",
            value: function initSpanRecorder(maxlen) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) {
                    var pushActivity = function(id) {
                        if (_this._finished) return;
                        _this._pushActivity(id);
                    };
                    var popActivity = function(id) {
                        if (_this._finished) return;
                        _this._popActivity(id);
                    };
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder = new $fc7863a5eb83ddc5$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
                    // Start heartbeat so that transactions do not run forever.
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('Starting heartbeat');
                    this._pingHeartbeat();
                }
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ key: "cancelIdleTimeout",
            value: function cancelIdleTimeout(endTimestamp) {
                var restartOnChildSpanChange = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    restartOnChildSpanChange: true
                }).restartOnChildSpanChange;
                this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
                if (this._idleTimeoutID) {
                    clearTimeout(this._idleTimeoutID);
                    this._idleTimeoutID = undefined;
                    if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                        this._finishReason = $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                        this.end(endTimestamp);
                    }
                }
            }
        },
        {
            /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ key: "setFinishReason",
            value: function setFinishReason(reason) {
                this._finishReason = reason;
            }
        },
        {
            /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ key: "sendAutoFinishSignal",
            value: function sendAutoFinishSignal() {
                if (!this._autoFinishAllowed) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] Received finish signal for idle transaction.');
                    this._restartIdleTimeout();
                    this._autoFinishAllowed = true;
                }
            }
        },
        {
            /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ key: "_restartIdleTimeout",
            value: function _restartIdleTimeout(endTimestamp) {
                var _this = this;
                this.cancelIdleTimeout();
                this._idleTimeoutID = setTimeout(function() {
                    if (!_this._finished && Object.keys(_this.activities).length === 0) {
                        _this._finishReason = $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                        _this.end(endTimestamp);
                    }
                }, this._idleTimeout);
            }
        },
        {
            /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ key: "_pushActivity",
            value: function _pushActivity(spanId) {
                this.cancelIdleTimeout(undefined, {
                    restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
                });
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("[Tracing] pushActivity: ".concat(spanId));
                this.activities[spanId] = true;
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
            }
        },
        {
            /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ key: "_popActivity",
            value: function _popActivity(spanId) {
                if (this.activities[spanId]) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("[Tracing] popActivity ".concat(spanId));
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this.activities[spanId];
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
                }
                if (Object.keys(this.activities).length === 0) {
                    var endTimestamp = (0, $fzAJT.timestampInSeconds)();
                    if (this._idleTimeoutCanceledPermanently) {
                        if (this._autoFinishAllowed) {
                            this._finishReason = $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                            this.end(endTimestamp);
                        }
                    } else // We need to add the timeout here to have the real endtimestamp of the transaction
                    // Remember timestampInSeconds is in seconds, timeout is in ms
                    this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
                }
            }
        },
        {
            /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ key: "_beat",
            value: function _beat() {
                // We should not be running heartbeat if the idle transaction is finished.
                if (this._finished) return;
                var heartbeatString = Object.keys(this.activities).join('');
                if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
                else this._heartbeatCounter = 1;
                this._prevHeartbeatString = heartbeatString;
                if (this._heartbeatCounter >= 3) {
                    if (this._autoFinishAllowed) {
                        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                        this.setStatus('deadline_exceeded');
                        this._finishReason = $fc7863a5eb83ddc5$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                        this.end();
                    }
                } else this._pingHeartbeat();
            }
        },
        {
            /**
   * Pings the heartbeat
   */ key: "_pingHeartbeat",
            value: function _pingHeartbeat() {
                var _this = this;
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));
                setTimeout(function() {
                    _this._beat();
                }, this._heartbeatInterval);
            }
        }
    ]);
    return IdleTransaction;
}((0, $lNNKl.Transaction));

});
parcelRegister("bCb3d", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $874bd0ccaf420b66$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $874bd0ccaf420b66$export$5f1714a13ed34c01; });

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $8yexE = parcelRequire("8yexE");
var $gVncj = parcelRequire("gVncj");
var $fzAJT = parcelRequire("fzAJT");
var $jYvOn = parcelRequire("jYvOn");

var $7Ui5X = parcelRequire("7Ui5X");

var $gFI5g = parcelRequire("gFI5g");

var $fkG29 = parcelRequire("fkG29");

var $lG8Hn = parcelRequire("lG8Hn");

var $6hfta = parcelRequire("6hfta");

var $bpf5e = parcelRequire("bpf5e");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var $874bd0ccaf420b66$export$10c95c129cd0d4fe = /*#__PURE__*/ function() {
    "use strict";
    function SpanRecorder() {
        var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0, $6WLcG._)(this, SpanRecorder);
        this._maxlen = maxlen;
        this.spans = [];
    }
    (0, $dbIwN._)(SpanRecorder, [
        {
            /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ key: "add",
            value: function add(span) {
                if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
                span.spanRecorder = undefined;
                else this.spans.push(span);
            }
        }
    ]);
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var $874bd0ccaf420b66$export$5f1714a13ed34c01 = /*#__PURE__*/ function() {
    "use strict";
    function Span() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $6WLcG._)(this, Span);
        this._traceId = spanContext.traceId || (0, $jYvOn.uuid4)();
        this._spanId = spanContext.spanId || (0, $jYvOn.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $fzAJT.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? (0, $hRCmZ._)({}, spanContext.tags) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? (0, $hRCmZ._)({}, spanContext.data) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        var _obj;
        this.setAttributes((0, $hRCmZ._)((_obj = {}, (0, $8c6ug._)(_obj, (0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanContext.origin || 'manual'), (0, $8c6ug._)(_obj, (0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_OP), spanContext.op), _obj), spanContext.attributes));
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? (0, $hRCmZ._)({}, spanContext.measurements) : {};
    }
    (0, $dbIwN._)(Span, [
        {
            key: "name",
            get: // This rule conflicts with another eslint rule :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name || '';
            },
            set: /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(name) {
                this.updateName(name);
            }
        },
        {
            key: "description",
            get: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(description) {
                this._name = description;
            }
        },
        {
            key: "traceId",
            get: /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ function get() {
                return this._traceId;
            },
            set: /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ function set(traceId) {
                this._traceId = traceId;
            }
        },
        {
            key: "spanId",
            get: /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ function get() {
                return this._spanId;
            },
            set: /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ function set(spanId) {
                this._spanId = spanId;
            }
        },
        {
            key: "parentSpanId",
            get: /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ function get() {
                return this._parentSpanId;
            },
            set: /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ function set(string) {
                this._parentSpanId = string;
            }
        },
        {
            key: "sampled",
            get: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ function get() {
                return this._sampled;
            },
            set: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ function set(sampled) {
                this._sampled = sampled;
            }
        },
        {
            key: "attributes",
            get: /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ function get() {
                return this._attributes;
            },
            set: /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ function set(attributes) {
                this._attributes = attributes;
            }
        },
        {
            key: "startTimestamp",
            get: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._startTime;
            },
            set: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ function set(startTime) {
                this._startTime = startTime;
            }
        },
        {
            key: "endTimestamp",
            get: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._endTime;
            },
            set: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ function set(endTime) {
                this._endTime = endTime;
            }
        },
        {
            key: "status",
            get: /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ function get() {
                return this._status;
            },
            set: /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ function set(status) {
                this._status = status;
            }
        },
        {
            key: "op",
            get: /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ function get() {
                return this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_OP];
            },
            set: /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ function set(op) {
                this.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
            }
        },
        {
            key: "origin",
            get: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ function get() {
                return this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
            },
            set: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ function set(origin) {
                this.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var _this = this, spanId = _this._spanId, traceId = _this._traceId, sampled = _this._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? (0, $6hfta.TRACE_FLAG_SAMPLED) : (0, $6hfta.TRACE_FLAG_NONE)
                };
            }
        },
        {
            /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startChild",
            value: function startChild(spanContext) {
                var childSpan = new Span((0, $7XD9P._)((0, $hRCmZ._)({}, spanContext), {
                    parentSpanId: this._spanId,
                    sampled: this._sampled,
                    traceId: this._traceId
                }));
                // eslint-disable-next-line deprecation/deprecation
                childSpan.spanRecorder = this.spanRecorder;
                // eslint-disable-next-line deprecation/deprecation
                if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
                childSpan.spanRecorder.add(childSpan);
                var rootSpan = (0, $lG8Hn.getRootSpan)(this);
                // TODO: still set span.transaction here until we have a more permanent solution
                // Probably similarly to the weakmap we hold in node-experimental
                // eslint-disable-next-line deprecation/deprecation
                childSpan.transaction = rootSpan;
                if ((0, $7Ui5X.DEBUG_BUILD) && rootSpan) {
                    var opStr = spanContext && spanContext.op || '< unknown op >';
                    var nameStr = (0, $6hfta.spanToJSON)(childSpan).description || '< unknown name >';
                    var idStr = rootSpan.spanContext().spanId;
                    var logMessage = "[Tracing] Starting '".concat(opStr, "' span on transaction '").concat(nameStr, "' (").concat(idStr, ").");
                    (0, $gVncj.logger).log(logMessage);
                    this._logMessage = logMessage;
                }
                return childSpan;
            }
        },
        {
            /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.tags = (0, $7XD9P._)((0, $hRCmZ._)({}, this.tags), (0, $8c6ug._)({}, key, value));
                return this;
            }
        },
        {
            /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setData",
            value: function setData(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = (0, $7XD9P._)((0, $hRCmZ._)({}, this.data), (0, $8c6ug._)({}, key, value));
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._attributes[key];
                else this._attributes[key] = value;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ key: "setHttpStatus",
            value: function setHttpStatus1(httpStatus) {
                (0, $bpf5e.setHttpStatus)(this, httpStatus);
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ key: "setName",
            value: function setName(name) {
                this.updateName(name);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ key: "isSuccess",
            value: function isSuccess() {
                return this._status === 'ok';
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ key: "finish",
            value: function finish(endTimestamp) {
                return this.end(endTimestamp);
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                // If already ended, skip
                if (this._endTime) return;
                var rootSpan = (0, $lG8Hn.getRootSpan)(this);
                if ((0, $7Ui5X.DEBUG_BUILD) && // Don't call this for transactions
                rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
                    var logMessage = this._logMessage;
                    if (logMessage) (0, $gVncj.logger).log(logMessage.replace('Starting', 'Finishing'));
                }
                this._endTime = (0, $6hfta.spanTimeInputToSeconds)(endTimestamp);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "toTraceparent",
            value: function toTraceparent() {
                return (0, $6hfta.spanToTraceHeader)(this);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ key: "toContext",
            value: function toContext() {
                return (0, $8yexE.dropUndefinedKeys)({
                    data: this._getData(),
                    description: this._name,
                    endTimestamp: this._endTime,
                    // eslint-disable-next-line deprecation/deprecation
                    op: this.op,
                    parentSpanId: this._parentSpanId,
                    sampled: this._sampled,
                    spanId: this._spanId,
                    startTimestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    traceId: this._traceId
                });
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ key: "updateWithContext",
            value: function updateWithContext(spanContext) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = spanContext.data || {};
                // eslint-disable-next-line deprecation/deprecation
                this._name = spanContext.name || spanContext.description;
                this._endTime = spanContext.endTimestamp;
                // eslint-disable-next-line deprecation/deprecation
                this.op = spanContext.op;
                this._parentSpanId = spanContext.parentSpanId;
                this._sampled = spanContext.sampled;
                this._spanId = spanContext.spanId || this._spanId;
                this._startTime = spanContext.startTimestamp || this._startTime;
                this._status = spanContext.status;
                // eslint-disable-next-line deprecation/deprecation
                this.tags = spanContext.tags || {};
                this._traceId = spanContext.traceId || this._traceId;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ key: "getTraceContext",
            value: function getTraceContext() {
                return (0, $6hfta.spanToTraceContext)(this);
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return (0, $8yexE.dropUndefinedKeys)({
                    data: this._getData(),
                    description: this._name,
                    op: this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                    _metrics_summary: (0, $gFI5g.getMetricSummaryJsonForSpan)(this),
                    profile_id: this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_PROFILE_ID],
                    exclusive_time: this._exclusiveTime,
                    measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
                });
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ key: "toJSON",
            value: function toJSON() {
                return this.getSpanJSON();
            }
        },
        {
            /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ key: "_getData",
            value: function _getData() {
                // eslint-disable-next-line deprecation/deprecation
                var _this = this, data = _this.data, attributes = _this._attributes;
                var hasData = Object.keys(data).length > 0;
                var hasAttributes = Object.keys(attributes).length > 0;
                if (!hasData && !hasAttributes) return undefined;
                if (hasData && hasAttributes) return (0, $hRCmZ._)({}, data, attributes);
                return hasData ? data : attributes;
            }
        }
    ]);
    return Span;
}();

});
parcelRegister("gFI5g", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $c232abd2c989bc33$export$2e7205e45c58797d; });

var $6mdMa = parcelRequire("6mdMa");

var $8yexE = parcelRequire("8yexE");




var $jWdUe = parcelRequire("jWdUe");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ var $c232abd2c989bc33$var$SPAN_METRIC_SUMMARY;
function $c232abd2c989bc33$var$getMetricStorageForSpan(span) {
    return $c232abd2c989bc33$var$SPAN_METRIC_SUMMARY ? $c232abd2c989bc33$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $c232abd2c989bc33$export$2e7205e45c58797d(span) {
    var storage = $c232abd2c989bc33$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    var output = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = storage[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6mdMa._)(_step.value, 2), _step_value_ = (0, $6mdMa._)(_step_value[1], 2), exportKey = _step_value_[0], summary = _step_value_[1];
            if (!output[exportKey]) output[exportKey] = [];
            output[exportKey].push((0, $8yexE.dropUndefinedKeys)(summary));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $c232abd2c989bc33$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    var span = (0, $jWdUe.getActiveSpan)();
    if (span) {
        var storage = $c232abd2c989bc33$var$getMetricStorageForSpan(span) || new Map();
        var exportKey = "".concat(metricType, ":").concat(sanitizedName, "@").concat(unit);
        var bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            var _bucketItem = (0, $6mdMa._)(bucketItem, 2), summary = _bucketItem[1];
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$c232abd2c989bc33$var$SPAN_METRIC_SUMMARY) $c232abd2c989bc33$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $c232abd2c989bc33$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("jWdUe", function(module, exports) {

$parcel$export(module.exports, "startSpan", function () { return $e83e3889d636e1fc$export$a1bd95187356f372; });
$parcel$export(module.exports, "startInactiveSpan", function () { return $e83e3889d636e1fc$export$63dbba021a6b4047; });
$parcel$export(module.exports, "getActiveSpan", function () { return $e83e3889d636e1fc$export$1be426a8e585c83e; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $e83e3889d636e1fc$export$c08fbc656a245d03; });

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $8yexE = parcelRequire("8yexE");
var $gVncj = parcelRequire("gVncj");
var $iAzzt = parcelRequire("iAzzt");

var $7Ui5X = parcelRequire("7Ui5X");

var $8fOd9 = parcelRequire("8fOd9");

var $6hfta = parcelRequire("6hfta");



var $dYxb4 = parcelRequire("dYxb4");

var $cCIJH = parcelRequire("cCIJH");

var $lFjzX = parcelRequire("lFjzX");

var $98rQ1 = parcelRequire("98rQ1");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $e83e3889d636e1fc$export$357889f174732d38(context, callback) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, // eslint-disable-next-line @typescript-eslint/no-empty-function
    afterFinish = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, $8fOd9.getCurrentHub)();
    var scope = (0, $cCIJH.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    var parentSpan = scope.getSpan();
    var spanContext = $e83e3889d636e1fc$var$normalizeContext(context);
    var activeSpan = $e83e3889d636e1fc$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $lFjzX.handleCallbackErrors)(function() {
        return callback(activeSpan);
    }, function(error) {
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, function() {
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $e83e3889d636e1fc$export$a1bd95187356f372(context, callback) {
    var spanContext = $e83e3889d636e1fc$var$normalizeContext(context);
    return (0, $8fOd9.runWithAsyncContext)(function() {
        return (0, $cCIJH.withScope)(context.scope, function(scope) {
            // eslint-disable-next-line deprecation/deprecation
            var hub = (0, $8fOd9.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : $e83e3889d636e1fc$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $lFjzX.handleCallbackErrors)(function() {
                return callback(activeSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    var status = (0, $6hfta.spanToJSON)(activeSpan).status;
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, function() {
                return activeSpan && activeSpan.end();
            });
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ var $e83e3889d636e1fc$export$cb9e396e6b90b703 = $e83e3889d636e1fc$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $e83e3889d636e1fc$export$c10292ad04b92aea(context, callback) {
    var spanContext = $e83e3889d636e1fc$var$normalizeContext(context);
    return (0, $8fOd9.runWithAsyncContext)(function() {
        return (0, $cCIJH.withScope)(context.scope, function(scope) {
            var finishAndSetSpan = function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            };
            // eslint-disable-next-line deprecation/deprecation
            var hub = (0, $8fOd9.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : $e83e3889d636e1fc$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $lFjzX.handleCallbackErrors)(function() {
                return callback(activeSpan, finishAndSetSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    var status = (0, $6hfta.spanToJSON)(activeSpan).status;
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $e83e3889d636e1fc$export$63dbba021a6b4047(context) {
    if (!(0, $98rQ1.hasTracingEnabled)()) return undefined;
    var spanContext = $e83e3889d636e1fc$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, $8fOd9.getCurrentHub)();
    var parentSpan = context.scope ? context.scope.getSpan() : $e83e3889d636e1fc$export$1be426a8e585c83e();
    var shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    var scope = context.scope || (0, $cCIJH.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    var temporaryScope = scope.clone();
    return $e83e3889d636e1fc$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $e83e3889d636e1fc$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cCIJH.getCurrentScope)().getSpan();
}
var $e83e3889d636e1fc$export$d2ee9b39b25437b3 = function(param, callback) {
    var sentryTrace = param.sentryTrace, baggage = param.baggage;
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ var currentScope = (0, $cCIJH.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    var _tracingContextFromHeaders = (0, $iAzzt.tracingContextFromHeaders)(sentryTrace, baggage), traceparentData = _tracingContextFromHeaders.traceparentData, dynamicSamplingContext = _tracingContextFromHeaders.dynamicSamplingContext, propagationContext = _tracingContextFromHeaders.propagationContext;
    currentScope.setPropagationContext(propagationContext);
    if ((0, $7Ui5X.DEBUG_BUILD) && traceparentData) (0, $gVncj.logger).log("[Tracing] Continuing trace ".concat(traceparentData.traceId, "."));
    var transactionContext = (0, $7XD9P._)((0, $hRCmZ._)({}, traceparentData), {
        metadata: (0, $8yexE.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    });
    if (!callback) return transactionContext;
    return (0, $8fOd9.runWithAsyncContext)(function() {
        return callback(transactionContext);
    });
};
function $e83e3889d636e1fc$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, param) {
    var parentSpan = param.parentSpan, spanContext = param.spanContext, forceTransaction = param.forceTransaction, scope = param.scope;
    if (!(0, $98rQ1.hasTracingEnabled)()) return undefined;
    var isolationScope = (0, $8fOd9.getIsolationScope)();
    var span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        var dsc = (0, $dYxb4.getDynamicSamplingContextFromSpan)(parentSpan);
        var _parentSpan_spanContext = parentSpan.spanContext(), traceId = _parentSpan_spanContext.traceId, parentSpanId = _parentSpan_spanContext.spanId;
        var sampled = (0, $6hfta.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0, $7XD9P._)((0, $hRCmZ._)({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled
        }, spanContext), {
            metadata: (0, $hRCmZ._)({
                dynamicSamplingContext: dsc
            }, spanContext.metadata)
        }));
    } else {
        var _$_object_spread = (0, $hRCmZ._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId1 = _$_object_spread.traceId, dsc1 = _$_object_spread.dsc, parentSpanId1 = _$_object_spread.parentSpanId, sampled1 = _$_object_spread.sampled;
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0, $7XD9P._)((0, $hRCmZ._)({
            traceId: traceId1,
            parentSpanId: parentSpanId1,
            parentSampled: sampled1
        }, spanContext), {
            metadata: (0, $hRCmZ._)({
                dynamicSamplingContext: dsc1
            }, spanContext.metadata)
        }));
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $e83e3889d636e1fc$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $e83e3889d636e1fc$var$normalizeContext(context) {
    if (context.startTime) {
        var ctx = (0, $hRCmZ._)({}, context);
        ctx.startTimestamp = (0, $6hfta.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
var $e83e3889d636e1fc$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
var $e83e3889d636e1fc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $e83e3889d636e1fc$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $8yexE.addNonEnumerableProperty)(span, $e83e3889d636e1fc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $8yexE.addNonEnumerableProperty)(span, $e83e3889d636e1fc$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $e83e3889d636e1fc$export$c08fbc656a245d03(span) {
    return {
        scope: span[$e83e3889d636e1fc$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$e83e3889d636e1fc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("lFjzX", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $fc5c9d4585cf1b7e$export$18ce21a8b7efd7e9; });

var $8lokx = parcelRequire("8lokx");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $fc5c9d4585cf1b7e$export$18ce21a8b7efd7e9(fn, onError) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFinally = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    var maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $fc5c9d4585cf1b7e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $fc5c9d4585cf1b7e$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $8lokx.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(function(res) {
        onFinally();
        return res;
    }, function(e) {
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("98rQ1", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $6a6a747b570f3519$export$5008da00b1b6dee6; });

var $cCIJH = parcelRequire("cCIJH");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $6a6a747b570f3519$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    var client = (0, $cCIJH.getClient)();
    var options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("fkG29", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $b299544cc6efc7c7$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $b299544cc6efc7c7$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $b299544cc6efc7c7$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $b299544cc6efc7c7$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $b299544cc6efc7c7$export$1efec95406bbe327; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var $b299544cc6efc7c7$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ var $b299544cc6efc7c7$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ var $b299544cc6efc7c7$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ var $b299544cc6efc7c7$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ var $b299544cc6efc7c7$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("bpf5e", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", function () { return $84ddbabf5ad48811$export$beb8e6a823e89c5d; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $84ddbabf5ad48811$export$ac65c70d78fcdb55; });
$parcel$export(module.exports, "setHttpStatus", function () { return $84ddbabf5ad48811$export$2ad6630ec8164254; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $84ddbabf5ad48811$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ var Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ var DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ var Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ var PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ var NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ var ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ var InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ var Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ var Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ var InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ var UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ var Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ var AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ var FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ var Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ var OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ var DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($84ddbabf5ad48811$export$beb8e6a823e89c5d || ($84ddbabf5ad48811$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $84ddbabf5ad48811$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ var $84ddbabf5ad48811$export$ac65c70d78fcdb55 = $84ddbabf5ad48811$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $84ddbabf5ad48811$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    var spanStatus = $84ddbabf5ad48811$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("lNNKl", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $fdf4c33226ce92ae$export$febc5573c75cefb0; });

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $gBEGf = parcelRequire("gBEGf");

var $3LSeA = parcelRequire("3LSeA");

var $a7G5R = parcelRequire("a7G5R");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $8yexE = parcelRequire("8yexE");
var $gVncj = parcelRequire("gVncj");

var $7Ui5X = parcelRequire("7Ui5X");

var $8fOd9 = parcelRequire("8fOd9");

var $gFI5g = parcelRequire("gFI5g");

var $fkG29 = parcelRequire("fkG29");

var $6hfta = parcelRequire("6hfta");

var $dYxb4 = parcelRequire("dYxb4");

var $bCb3d = parcelRequire("bCb3d");

var $jWdUe = parcelRequire("jWdUe");
/** JSDoc */ var $fdf4c33226ce92ae$export$febc5573c75cefb0 = /*#__PURE__*/ function(Span) {
    "use strict";
    (0, $a7G5R._)(Transaction, Span);
    function Transaction(transactionContext, hub) {
        (0, $6WLcG._)(this, Transaction);
        var _this;
        _this = (0, $bQby9._)(this, Transaction, [
            transactionContext
        ]);
        _this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        _this._hub = hub || (0, $8fOd9.getCurrentHub)();
        _this._name = transactionContext.name || '';
        _this._metadata = (0, $hRCmZ._)({}, transactionContext.metadata);
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        _this.transaction = _this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        var incomingDynamicSamplingContext = _this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        _this._frozenDynamicSamplingContext = (0, $hRCmZ._)({}, incomingDynamicSamplingContext);
        return _this;
    }
    (0, $dbIwN._)(Transaction, [
        {
            key: "name",
            get: // This sadly conflicts with the getter/setter ordering :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ function set(newName) {
                // eslint-disable-next-line deprecation/deprecation
                this.setName(newName);
            }
        },
        {
            key: "metadata",
            get: /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function get() {
                // We merge attributes in for backwards compatibility
                return (0, $hRCmZ._)({
                    // Defaults
                    // eslint-disable-next-line deprecation/deprecation
                    source: 'custom',
                    spanMetadata: {}
                }, this._metadata, this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                    source: this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
                }, this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                    sampleRate: this._attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
                });
            },
            set: /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function set(metadata) {
                this._metadata = metadata;
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ key: "setName",
            value: function setName(name) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'custom';
                this._name = name;
                this.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ key: "initSpanRecorder",
            value: function initSpanRecorder() {
                var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder = new (0, $bCb3d.SpanRecorder)(maxlen);
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ key: "setMeasurement",
            value: function setMeasurement(name, value) {
                var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                this._measurements[name] = {
                    value: value,
                    unit: unit
                };
            }
        },
        {
            /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ key: "setMetadata",
            value: function setMetadata(newMetadata) {
                this._metadata = (0, $hRCmZ._)({}, this._metadata, newMetadata);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "end",
            value: function end(endTimestamp) {
                var timestampInS = (0, $6hfta.spanTimeInputToSeconds)(endTimestamp);
                var transaction = this._finishTransaction(timestampInS);
                if (!transaction) return undefined;
                // eslint-disable-next-line deprecation/deprecation
                return this._hub.captureEvent(transaction);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toContext",
            value: function toContext() {
                // eslint-disable-next-line deprecation/deprecation
                var spanContext = (0, $gBEGf._)((0, $3LSeA._)(Transaction.prototype), "toContext", this).call(this);
                return (0, $8yexE.dropUndefinedKeys)((0, $7XD9P._)((0, $hRCmZ._)({}, spanContext), {
                    name: this._name,
                    trimEnd: this._trimEnd
                }));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateWithContext",
            value: function updateWithContext(transactionContext) {
                // eslint-disable-next-line deprecation/deprecation
                (0, $gBEGf._)((0, $3LSeA._)(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);
                this._name = transactionContext.name || '';
                this._trimEnd = transactionContext.trimEnd;
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ key: "getDynamicSamplingContext",
            value: function getDynamicSamplingContext() {
                return (0, $dYxb4.getDynamicSamplingContextFromSpan)(this);
            }
        },
        {
            /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setHub",
            value: function setHub(hub) {
                this._hub = hub;
            }
        },
        {
            /**
   * Get the profile id of the transaction.
   */ key: "getProfileId",
            value: function getProfileId() {
                if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
                return undefined;
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_finishTransaction",
            value: function _finishTransaction(endTimestamp) {
                var _this = this;
                // This transaction is already finished, so we should not flush it again.
                if (this._endTime !== undefined) return undefined;
                if (!this._name) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
                    this._name = '<unlabeled transaction>';
                }
                // just sets the end timestamp
                (0, $gBEGf._)((0, $3LSeA._)(Transaction.prototype), "end", this).call(this, endTimestamp);
                // eslint-disable-next-line deprecation/deprecation
                var client = this._hub.getClient();
                if (client && client.emit) client.emit('finishTransaction', this);
                if (this._sampled !== true) {
                    // At this point if `sampled !== true` we want to discard the transaction.
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
                    if (client) client.recordDroppedEvent('sample_rate', 'transaction');
                    return undefined;
                }
                // eslint-disable-next-line deprecation/deprecation
                var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(span) {
                    return span !== _this && (0, $6hfta.spanToJSON)(span).timestamp;
                }) : [];
                if (this._trimEnd && finishedSpans.length > 0) {
                    var endTimes = finishedSpans.map(function(span) {
                        return (0, $6hfta.spanToJSON)(span).timestamp;
                    }).filter(Boolean);
                    this._endTime = endTimes.reduce(function(prev, current) {
                        return prev > current ? prev : current;
                    });
                }
                var _getCapturedScopesOnSpan = (0, $jWdUe.getCapturedScopesOnSpan)(this), capturedSpanScope = _getCapturedScopesOnSpan.scope, capturedSpanIsolationScope = _getCapturedScopesOnSpan.isolationScope;
                // eslint-disable-next-line deprecation/deprecation
                var metadata = this.metadata;
                // eslint-disable-next-line deprecation/deprecation
                var source = metadata.source;
                var transaction = (0, $hRCmZ._)({
                    contexts: (0, $7XD9P._)((0, $hRCmZ._)({}, this._contexts), {
                        // We don't want to override trace context
                        trace: (0, $6hfta.spanToTraceContext)(this)
                    }),
                    // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
                    spans: finishedSpans,
                    start_timestamp: this._startTime,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: 'transaction',
                    sdkProcessingMetadata: (0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({}, metadata), {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope
                    }), (0, $8yexE.dropUndefinedKeys)({
                        dynamicSamplingContext: (0, $dYxb4.getDynamicSamplingContextFromSpan)(this)
                    })),
                    _metrics_summary: (0, $gFI5g.getMetricSummaryJsonForSpan)(this)
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var hasMeasurements = Object.keys(this._measurements).length > 0;
                if (hasMeasurements) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
                    transaction.measurements = this._measurements;
                }
                // eslint-disable-next-line deprecation/deprecation
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this._name, "."));
                return transaction;
            }
        }
    ]);
    return Transaction;
}((0, $bCb3d.Span));

});


parcelRegister("8HkIr", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $655268a202aaf8f7$export$b3258c3993bc9b71; });
$parcel$export(module.exports, "isValidSampleRate", function () { return $655268a202aaf8f7$export$2603c8d332a51c42; });

var $2xTNA = parcelRequire("2xTNA");

var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");

var $7Ui5X = parcelRequire("7Ui5X");

var $fkG29 = parcelRequire("fkG29");

var $98rQ1 = parcelRequire("98rQ1");

var $6hfta = parcelRequire("6hfta");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $655268a202aaf8f7$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $98rQ1.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$655268a202aaf8f7$export$2603c8d332a51c42(sampleRate)) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
        return transaction;
    }
    (0, $7Ui5X.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $gVncj.logger).log("[Tracing] starting ".concat(transaction.op, " transaction - ").concat((0, $6hfta.spanToJSON)(transaction).description));
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $655268a202aaf8f7$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $8lokx.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate), " of type ").concat(JSON.stringify(typeof rate === "undefined" ? "undefined" : (0, $2xTNA._)(rate)), "."));
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ".concat(rate, "."));
        return false;
    }
    return true;
}

});


parcelRegister("4qd5R", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });
$parcel$export(module.exports, "loadModule", function () { return loadModule; });

var $pwbWG = parcelRequire("pwbWG");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $pwbWG.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("pwbWG", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $04cb4e8251a9d8c9$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $04cb4e8251a9d8c9$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $04cb4e8251a9d8c9$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $04cb4e8251a9d8c9$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});



var $10c4577e231d9f16$exports = {};
$parcel$extendImportMap({
    "6WwfZ": "Menu.33ffe8a2.svg",
    fWECs: "powered-by-mojo.12c6aed7.svg",
    ji129: "in-partnership-with-mojo.f5aa5bfb.svg",
    bLUaQ: "Cross.354ea98a.svg",
    jHwYO: "experian.abc1e305.svg",
    h70Oc: "mojo-logo.8fe63dcf.png",
    "5Kq6Y": "Tick.6fa1a552.svg",
    b4NxB: "ArrowDown.322d271a.svg",
    "5ltEv": "ArrowRight.ae34166a.svg",
    b6lNd: "Exclamation.27a336ba.svg",
    "1HIS3": "Back.3cf98b13.svg",
    jqQYZ: "Locked.8c967787.svg",
    fdHSY: "Shield.11e115d7.svg",
    aPrT8: "SmallArrow.d5301b7d.svg",
    j4j9D: "Cross2.fddd4348.svg",
    hfstx: "question-mark.497aa341.svg",
    hzvwF: "ExternalLink.c519c699.svg",
    "1gPlL": "Icon_Tick.20b2cf16.svg",
    "5D7X3": "TickWhite.5fb2f94b.svg",
    "2QK6F": "chevron-down.621dce7b.svg",
    lHR42: "chevron-up.85cdd2c3.svg",
    iPqj5: "chevron-left.9441af62.svg",
    "5lQXm": "chevron-right.b7b9b9d3.svg",
    k6HyH: "Chat.0d060112.png",
    fy8hn: "chairs.8c98bdd8.png",
    l1Ymt: "Paperwork.c106baf7.png",
    dq1DS: "Proud lean.dbb6bb2d.png",
    "72YXr": "Key 1.bf434cc3.png",
    dilgV: "Key 2.032774ac.png",
    eAzTQ: "Boxes.2730dd72.png",
    "8QPvK": "Boxes1.11a2e39c.png",
    "85OXR": "Paperwork 2.e329fbbc.png",
    "6JXSe": "Magic carpet.c6d78ed0.png",
    gQSRa: "Bike.a46a039e.png",
    "71k4v": "Coffee sat down.d06c3dc6.png",
    lt5q0: "Step up 2.9fcb7e65.png",
    aJEnI: "Step up 3.549a30d1.png",
    fPxTW: "Kids.ce7b3d8a.png",
    eeug0: "Mirror.e581e42e.png",
    "7sFys": "Desk.8c5e4a58.png",
    "7OCmJ": "Guitar.b741c7d7.png",
    claKy: "Paperwork-no-shadow.0f557b90.png",
    fyAx7: "house.77c761cb.png",
    ltoAI: "MIP.6d2f0850.png",
    hYUXV: "dog.db1ca15c.svg",
    i37Kq: "mojo-mini-logo-alt.b37bcc3a.svg",
    gC1gX: "conveyancing.bd611631.png",
    "2bDXX": "quotation-mark.cc1507aa.png",
    "8ttXG": "phone-rate-check-notification.ec35a044.svg",
    k3VSs: "mojo-mini-logo.49483dcb.svg",
    kVtAE: "mojo-specialist-logo.c0720b9e.png",
    "2OB9U": "TickBlue.dc1990e4.svg",
    "3wLLW": "dog.db1ca15c.svg",
    dDmHc: "splash.9329963c.png",
    cyZzs: "background-wave.6d471e12.svg",
    iwp2C: "Accord.3350abf5.png",
    "2Qviu": "AIB.733d3717.png",
    fFhxo: "Aldermore Mortgages.8e4dbf66.png",
    "8XVKc": "Atom Bank.c6792604.png",
    "3wsC5": "Bank of Ireland.7d040593.png",
    "9DUOS": "Barclays Bank.8a487661.png",
    kG3wS: "Bath Building Society.e1df0a4c.png",
    "3BcsB": "Beverley Building Society.22e760c2.png",
    c0AjW: "Birmingham Midshires.8cc4802e.png",
    d5lIJ: "Bluestone Mortgages.5bb8c6f1.png",
    dU4fz: "BM Solutions.0ca39752.png",
    gHHSx: "Cambridge Building Society.d2fa83c0.png",
    "1tbEn": "Chorley Building Society.47f55579.png",
    gPjRN: "Clydesdale Bank.cdc8bf47.png",
    "7gYuS": "Coventry Building Society.0dd92810.png",
    "35p9V": "Digital Mortgages.c6792604.png",
    kbP7d: "Foundation Home Loans.c09098d2.png",
    "15vxj": "Furness Building Society.71dbe683.png",
    "134rH": "Generation Home.5f14922d.png",
    gLpYs: "Godiva Mortgages.1987dfd9.png",
    bI2EV: "Halifax.1d4ea366.png",
    "6yn3p": "Hinckley and Rugby Building Society.4831a63d.png",
    bRqhc: "HSBC.583b333f.png",
    "6Yi01": "Kensington Mortgages.0ad562c4.png",
    "1hEwf": "Kent Reliance.f6482e0d.png",
    iUlOc: "Landbay.a5701627.png",
    l2z3D: "Leeds Building Society.19acfe9c.png",
    "1DUP0": "Leek United Building Society.ce4db849.png",
    bvhVK: "Lloyds Bank.5df9dbab.png",
    "7a6gN": "Mansfield Building Society.38df0fe3.png",
    "4OiRP": "Metro Bank.5f972217.png",
    "5u2Rt": "Melton Building Society, The.c6136f56.png",
    fkRve: "Monmouthshire Building Society.5648ea86.png",
    "6Uaqv": "Mortgage Works, The.fdc8982d.png",
    iBOT0: "Nationwide Building Society.9fb59d38.png",
    "2R5dp": "Natwest.6a7a18af.png",
    "6ogJH": "Newcastle Building Society.a74858f3.png",
    "3BePJ": "Newbury Building Society.da2cc2bb.png",
    "24B14": "Nottingham Building Society.aafbe8d6.png",
    "7xI3N": "Paragon Banking Group PLC.f470cbf2.png",
    jMAAg: "Pepper Money.821f2509.png",
    iE8Nx: "Platform.25c5fc64.png",
    "3K3VW": "Post Office.fd34b86f.png",
    "1ltwO": "Precise Mortgages.78514971.png",
    dzls9: "Principality BS.8056f98c.png",
    lgmyQ: "Progressive Building Society.d9d685ce.png",
    "8bBlg": "Royal Bank of Scotland.3332234d.png",
    g5fPN: "Santander UK PLC.93e8bf7a.png",
    aOf4a: "Scottish Widows Bank.0315e7c8.png",
    kuwEJ: "Skipton Building Society.3907eed4.png",
    "3r9Em": "Together.9068b058.png",
    "7SeuN": "TSB.e7396c87.png",
    elgOx: "Vida Homeloans.5dc2f71f.png",
    lyM2L: "Virgin Money.d171a11b.png",
    "1LuZ7": "Accord.bfc47c64.png",
    lKArV: "Aldermore Mortgages.3c5f22e9.png",
    hdk91: "Atom Bank.d4af52be.png",
    "1pOFc": "Bank of Ireland.45a704ab.png",
    mhlct: "Barclays Bank.efc05db4.png",
    "9V0TU": "Bath Building Society.2babf1f7.png",
    "5nIfC": "Beverley Building Society.b770d2d3.png",
    ENcx7: "Birmingham Midshires.ebdef71a.png",
    "4ThAc": "Bluestone Mortgages.eb03ddce.png",
    "6s1bH": "BM Solutions.f91b3704.png",
    "7FnL2": "Cambridge Building Society.32466b3f.png",
    "5yq5g": "Chorley Building Society.ddd70daa.png",
    d4EpH: "Clydesdale Bank.1a3eff0e.png",
    hfz4q: "Coventry Building Society.1b7eb242.png",
    jmC4G: "Digital Mortgages.4cd7336e.png",
    bAiod: "Foundation Home Loans.fa72d6d1.png",
    "2sBLm": "Furness Building Society.71dbe683.png",
    jrAmh: "Generation Home.b1e86143.png",
    glUg3: "Godiva Mortgages.3f4972af.png",
    gYb8q: "Halifax.9de552ba.png",
    hGlm8: "Hinckley and Rugby Building Society.96380c07.png",
    bF95G: "HSBC.bf9ba8b7.png",
    "83WTd": "Kensington Mortgages.9643ed84.png",
    hLI8V: "Kent Reliance.9a3f663c.png",
    "7GhUx": "Landbay.0f1eb4be.png",
    "9NfYy": "Leeds Building Society.39e6c71e.png",
    eOiGk: "Leek United Building Society.801a1de4.png",
    hz1wC: "Lloyds Bank.88a3bc94.png",
    a7w62: "Mansfield Building Society.70c304b5.png",
    jRCIo: "Metro Bank.be23591b.png",
    kviWp: "Melton Building Society, The.73db04a9.png",
    bNS6f: "Monmouthshire Building Society.5ad2a924.png",
    aeHNe: "Mortgage Works, The.c827f9b4.png",
    "6jBZP": "Nationwide Building Society.8392d379.png",
    fyOU8: "Natwest.a4bda949.png",
    "1IluC": "Newcastle Building Society.c64c70d0.png",
    "3WFzo": "Newbury Building Society.296be0ae.png",
    "1VLrg": "Nottingham Building Society.28f77848.png",
    "7FWao": "Paragon Banking Group PLC.ba0b9b59.png",
    "6rhJd": "Pepper Money.74bbc324.png",
    "8269u": "Platform.ac374adf.png",
    iKcMa: "Post Office.271af8c1.png",
    lu2Ug: "Precise Mortgages.12265976.png",
    "4hySQ": "Principality BS.a271382d.png",
    ex2Fd: "Progressive Building Society.cb672b16.png",
    g6lHy: "Royal Bank of Scotland.8cebbadb.png",
    cG1XY: "Santander UK PLC.6c1a2090.png",
    "9nyk7": "Scottish Widows Bank.98c4532d.png",
    e72hx: "Skipton Building Society.43b138e5.png",
    fS3ui: "Together.1dc2b02e.png",
    "1mm1Q": "TSB.e065d21e.png",
    "50NRi": "Vida Homeloans.ab98dced.png",
    "7a9YT": "Virgin Money.a64797fb.png",
    dfJqe: "Refresh.399566d6.svg",
    iDwFM: "BoxesPerson.4a1777e0.png",
    "6dyyr": "BoxesDog.ab6213af.png",
    auxUD: "TickBlack.05607301.svg",
    "5SHvZ": "ListItem.d1faf963.svg",
    "2ia5v": "Logo_Mojo.c8d781a9.svg",
    "5zRIh": "rateChecker-latest.1de7c9b4.png",
    "79key": "select-caret.f97670d1.svg",
    dgDvw: "Pepper.821f2509.png",
    "3zxDs": "ScottishBS.d5cb660d.png",
    khzfZ: "Envelope.a913e3ad.svg",
    "35RJU": "legal-and-general.b8823851.png"
});

var $3d45074523d8f6b3$exports = {};
'use strict';

$3d45074523d8f6b3$exports = (parcelRequire("kyxfS"));


parcelRequire("hAGkE");
var $88d935799dd4b02e$export$882461b6382ed46c;
var $88d935799dd4b02e$export$757ceba2d55c277e;
'use strict';
var $0048b1b41b30e47d$exports = {};
'use strict';
function $0048b1b41b30e47d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0048b1b41b30e47d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0048b1b41b30e47d$var$checkDCE();

$0048b1b41b30e47d$exports = (parcelRequire("aFmG0"));


var $88d935799dd4b02e$var$i;
$88d935799dd4b02e$export$882461b6382ed46c = $0048b1b41b30e47d$exports.createRoot;
$88d935799dd4b02e$export$757ceba2d55c277e = $0048b1b41b30e47d$exports.hydrateRoot;



var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");

var $iNemB = parcelRequire("iNemB");

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8c6ug = parcelRequire("8c6ug");

var $8WUf8 = parcelRequire("8WUf8");

var $a7G5R = parcelRequire("a7G5R");

var $kppPx = parcelRequire("kppPx");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");

var $2DHfY = parcelRequire("2DHfY");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");

var $d825e01bb91c74de$exports = {};
// shim for using process in browser
var $d825e01bb91c74de$var$process = $d825e01bb91c74de$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d825e01bb91c74de$var$cachedSetTimeout;
var $d825e01bb91c74de$var$cachedClearTimeout;
function $d825e01bb91c74de$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d825e01bb91c74de$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d825e01bb91c74de$var$cachedSetTimeout = setTimeout;
        else $d825e01bb91c74de$var$cachedSetTimeout = $d825e01bb91c74de$var$defaultSetTimout;
    } catch (e) {
        $d825e01bb91c74de$var$cachedSetTimeout = $d825e01bb91c74de$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d825e01bb91c74de$var$cachedClearTimeout = clearTimeout;
        else $d825e01bb91c74de$var$cachedClearTimeout = $d825e01bb91c74de$var$defaultClearTimeout;
    } catch (e) {
        $d825e01bb91c74de$var$cachedClearTimeout = $d825e01bb91c74de$var$defaultClearTimeout;
    }
})();
function $d825e01bb91c74de$var$runTimeout(fun) {
    if ($d825e01bb91c74de$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d825e01bb91c74de$var$cachedSetTimeout === $d825e01bb91c74de$var$defaultSetTimout || !$d825e01bb91c74de$var$cachedSetTimeout) && setTimeout) {
        $d825e01bb91c74de$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d825e01bb91c74de$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d825e01bb91c74de$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d825e01bb91c74de$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d825e01bb91c74de$var$runClearTimeout(marker) {
    if ($d825e01bb91c74de$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d825e01bb91c74de$var$cachedClearTimeout === $d825e01bb91c74de$var$defaultClearTimeout || !$d825e01bb91c74de$var$cachedClearTimeout) && clearTimeout) {
        $d825e01bb91c74de$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d825e01bb91c74de$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d825e01bb91c74de$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d825e01bb91c74de$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d825e01bb91c74de$var$queue = [];
var $d825e01bb91c74de$var$draining = false;
var $d825e01bb91c74de$var$currentQueue;
var $d825e01bb91c74de$var$queueIndex = -1;
function $d825e01bb91c74de$var$cleanUpNextTick() {
    if (!$d825e01bb91c74de$var$draining || !$d825e01bb91c74de$var$currentQueue) return;
    $d825e01bb91c74de$var$draining = false;
    if ($d825e01bb91c74de$var$currentQueue.length) $d825e01bb91c74de$var$queue = $d825e01bb91c74de$var$currentQueue.concat($d825e01bb91c74de$var$queue);
    else $d825e01bb91c74de$var$queueIndex = -1;
    if ($d825e01bb91c74de$var$queue.length) $d825e01bb91c74de$var$drainQueue();
}
function $d825e01bb91c74de$var$drainQueue() {
    if ($d825e01bb91c74de$var$draining) return;
    var timeout = $d825e01bb91c74de$var$runTimeout($d825e01bb91c74de$var$cleanUpNextTick);
    $d825e01bb91c74de$var$draining = true;
    var len = $d825e01bb91c74de$var$queue.length;
    while(len){
        $d825e01bb91c74de$var$currentQueue = $d825e01bb91c74de$var$queue;
        $d825e01bb91c74de$var$queue = [];
        while(++$d825e01bb91c74de$var$queueIndex < len)if ($d825e01bb91c74de$var$currentQueue) $d825e01bb91c74de$var$currentQueue[$d825e01bb91c74de$var$queueIndex].run();
        $d825e01bb91c74de$var$queueIndex = -1;
        len = $d825e01bb91c74de$var$queue.length;
    }
    $d825e01bb91c74de$var$currentQueue = null;
    $d825e01bb91c74de$var$draining = false;
    $d825e01bb91c74de$var$runClearTimeout(timeout);
}
$d825e01bb91c74de$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d825e01bb91c74de$var$queue.push(new $d825e01bb91c74de$var$Item(fun, args));
    if ($d825e01bb91c74de$var$queue.length === 1 && !$d825e01bb91c74de$var$draining) $d825e01bb91c74de$var$runTimeout($d825e01bb91c74de$var$drainQueue);
};
// v8 likes predictible objects
function $d825e01bb91c74de$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d825e01bb91c74de$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d825e01bb91c74de$var$process.title = 'browser';
$d825e01bb91c74de$var$process.browser = true;
$d825e01bb91c74de$var$process.env = {};
$d825e01bb91c74de$var$process.argv = [];
$d825e01bb91c74de$var$process.version = ''; // empty string to avoid regexp issues
$d825e01bb91c74de$var$process.versions = {};
function $d825e01bb91c74de$var$noop() {}
$d825e01bb91c74de$var$process.on = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.addListener = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.once = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.off = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.removeListener = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.removeAllListeners = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.emit = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.prependListener = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.prependOnceListener = $d825e01bb91c74de$var$noop;
$d825e01bb91c74de$var$process.listeners = function(name) {
    return [];
};
$d825e01bb91c74de$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d825e01bb91c74de$var$process.cwd = function() {
    return '/';
};
$d825e01bb91c74de$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d825e01bb91c74de$var$process.umask = function() {
    return 0;
};


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$err(message) {
    var error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty
    return error;
}
var $d7ce42c300073b00$var$err_1 = $d7ce42c300073b00$var$err;
// @oss-only
var $d7ce42c300073b00$var$Recoil_err = $d7ce42c300073b00$var$err_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function $d7ce42c300073b00$var$isPromise(p) {
    return !!p && typeof p.then === 'function';
}
var $d7ce42c300073b00$var$Recoil_isPromise = $d7ce42c300073b00$var$isPromise;
function $d7ce42c300073b00$var$nullthrows(x, message) {
    if (x != null) return x;
    throw $d7ce42c300073b00$var$Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}
var $d7ce42c300073b00$var$Recoil_nullthrows = $d7ce42c300073b00$var$nullthrows;
function $d7ce42c300073b00$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d7ce42c300073b00$var$BaseLoadable = /*#__PURE__*/ function() {
    "use strict";
    function BaseLoadable() {
        (0, $6WLcG._)(this, BaseLoadable);
    }
    (0, $dbIwN._)(BaseLoadable, [
        {
            key: "getValue",
            value: function getValue() {
                throw $d7ce42c300073b00$var$Recoil_err('BaseLoadable');
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                throw $d7ce42c300073b00$var$Recoil_err('BaseLoadable');
            }
        },
        {
            key: "valueMaybe",
            value: function valueMaybe() {
                throw $d7ce42c300073b00$var$Recoil_err('BaseLoadable');
            }
        },
        {
            key: "valueOrThrow",
            value: function valueOrThrow() {
                // $FlowFixMe[prop-missing]
                throw $d7ce42c300073b00$var$Recoil_err('Loadable expected value, but in "'.concat(this.state, '" state'));
            }
        },
        {
            key: "promiseMaybe",
            value: function promiseMaybe() {
                throw $d7ce42c300073b00$var$Recoil_err('BaseLoadable');
            }
        },
        {
            key: "promiseOrThrow",
            value: function promiseOrThrow() {
                // $FlowFixMe[prop-missing]
                throw $d7ce42c300073b00$var$Recoil_err('Loadable expected promise, but in "'.concat(this.state, '" state'));
            }
        },
        {
            key: "errorMaybe",
            value: function errorMaybe() {
                throw $d7ce42c300073b00$var$Recoil_err('BaseLoadable');
            }
        },
        {
            key: "errorOrThrow",
            value: function errorOrThrow() {
                // $FlowFixMe[prop-missing]
                throw $d7ce42c300073b00$var$Recoil_err('Loadable expected error, but in "'.concat(this.state, '" state'));
            }
        },
        {
            key: "is",
            value: function is(other) {
                // $FlowFixMe[prop-missing]
                return other.state === this.state && other.contents === this.contents;
            }
        },
        {
            key: "map",
            value: function map(_map) {
                throw $d7ce42c300073b00$var$Recoil_err('BaseLoadable');
            }
        }
    ]);
    return BaseLoadable;
}();
var $d7ce42c300073b00$var$ValueLoadable = /*#__PURE__*/ function(BaseLoadable) {
    "use strict";
    (0, $a7G5R._)(ValueLoadable, BaseLoadable);
    function ValueLoadable(value) {
        (0, $6WLcG._)(this, ValueLoadable);
        var _this;
        _this = (0, $bQby9._)(this, ValueLoadable);
        $d7ce42c300073b00$var$_defineProperty(_this, "state", 'hasValue');
        $d7ce42c300073b00$var$_defineProperty(_this, "contents", void 0);
        _this.contents = value;
        return _this;
    }
    (0, $dbIwN._)(ValueLoadable, [
        {
            key: "getValue",
            value: function getValue() {
                return this.contents;
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                return Promise.resolve(this.contents);
            }
        },
        {
            key: "valueMaybe",
            value: function valueMaybe() {
                return this.contents;
            }
        },
        {
            key: "valueOrThrow",
            value: function valueOrThrow() {
                return this.contents;
            }
        },
        {
            key: "promiseMaybe",
            value: function promiseMaybe() {
                return undefined;
            }
        },
        {
            key: "errorMaybe",
            value: function errorMaybe() {
                return undefined;
            }
        },
        {
            key: "map",
            value: function map(map) {
                var _this = this;
                try {
                    var next = map(this.contents);
                    return $d7ce42c300073b00$var$Recoil_isPromise(next) ? $d7ce42c300073b00$var$loadableWithPromise(next) : $d7ce42c300073b00$var$isLoadable(next) ? next : $d7ce42c300073b00$var$loadableWithValue(next);
                } catch (e) {
                    return $d7ce42c300073b00$var$Recoil_isPromise(e) ? // errors and subsequent retries will be handled in 'loading' case
                    // $FlowFixMe[prop-missing]
                    $d7ce42c300073b00$var$loadableWithPromise(e.next(function() {
                        return _this.map(map);
                    })) : $d7ce42c300073b00$var$loadableWithError(e);
                }
            }
        }
    ]);
    return ValueLoadable;
}($d7ce42c300073b00$var$BaseLoadable);
var $d7ce42c300073b00$var$ErrorLoadable = /*#__PURE__*/ function(BaseLoadable) {
    "use strict";
    (0, $a7G5R._)(ErrorLoadable, BaseLoadable);
    function ErrorLoadable(error) {
        (0, $6WLcG._)(this, ErrorLoadable);
        var _this;
        _this = (0, $bQby9._)(this, ErrorLoadable);
        $d7ce42c300073b00$var$_defineProperty(_this, "state", 'hasError');
        $d7ce42c300073b00$var$_defineProperty(_this, "contents", void 0);
        _this.contents = error;
        return _this;
    }
    (0, $dbIwN._)(ErrorLoadable, [
        {
            key: "getValue",
            value: function getValue() {
                throw this.contents;
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                return Promise.reject(this.contents);
            }
        },
        {
            key: "valueMaybe",
            value: function valueMaybe() {
                return undefined;
            }
        },
        {
            key: "promiseMaybe",
            value: function promiseMaybe() {
                return undefined;
            }
        },
        {
            key: "errorMaybe",
            value: function errorMaybe() {
                return this.contents;
            }
        },
        {
            key: "errorOrThrow",
            value: function errorOrThrow() {
                return this.contents;
            }
        },
        {
            key: "map",
            value: function map(_map) {
                // $FlowIssue[incompatible-return]
                return this;
            }
        }
    ]);
    return ErrorLoadable;
}($d7ce42c300073b00$var$BaseLoadable);
var $d7ce42c300073b00$var$LoadingLoadable = /*#__PURE__*/ function(BaseLoadable) {
    "use strict";
    (0, $a7G5R._)(LoadingLoadable, BaseLoadable);
    function LoadingLoadable(promise) {
        (0, $6WLcG._)(this, LoadingLoadable);
        var _this;
        _this = (0, $bQby9._)(this, LoadingLoadable);
        $d7ce42c300073b00$var$_defineProperty(_this, "state", 'loading');
        $d7ce42c300073b00$var$_defineProperty(_this, "contents", void 0);
        _this.contents = promise;
        return _this;
    }
    (0, $dbIwN._)(LoadingLoadable, [
        {
            key: "getValue",
            value: function getValue() {
                throw this.contents;
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                return this.contents;
            }
        },
        {
            key: "valueMaybe",
            value: function valueMaybe() {
                return undefined;
            }
        },
        {
            key: "promiseMaybe",
            value: function promiseMaybe() {
                return this.contents;
            }
        },
        {
            key: "promiseOrThrow",
            value: function promiseOrThrow() {
                return this.contents;
            }
        },
        {
            key: "errorMaybe",
            value: function errorMaybe() {
                return undefined;
            }
        },
        {
            key: "map",
            value: function map(map) {
                var _this = this;
                return $d7ce42c300073b00$var$loadableWithPromise(this.contents.then(function(value) {
                    var next = map(value);
                    if ($d7ce42c300073b00$var$isLoadable(next)) {
                        var nextLoadable = next;
                        switch(nextLoadable.state){
                            case 'hasValue':
                                return nextLoadable.contents;
                            case 'hasError':
                                throw nextLoadable.contents;
                            case 'loading':
                                return nextLoadable.contents;
                        }
                    } // $FlowIssue[incompatible-return]
                    return next;
                }) // $FlowFixMe[incompatible-call]
                ["catch"](function(e) {
                    if ($d7ce42c300073b00$var$Recoil_isPromise(e)) // we were "suspended," try again
                    return e.then(function() {
                        return _this.map(map).contents;
                    });
                    throw e;
                }));
            }
        }
    ]);
    return LoadingLoadable;
}($d7ce42c300073b00$var$BaseLoadable);
function $d7ce42c300073b00$var$loadableWithValue(value) {
    return Object.freeze(new $d7ce42c300073b00$var$ValueLoadable(value));
}
function $d7ce42c300073b00$var$loadableWithError(error) {
    return Object.freeze(new $d7ce42c300073b00$var$ErrorLoadable(error));
}
function $d7ce42c300073b00$var$loadableWithPromise(promise) {
    return Object.freeze(new $d7ce42c300073b00$var$LoadingLoadable(promise));
}
function $d7ce42c300073b00$var$loadableLoading() {
    return Object.freeze(new $d7ce42c300073b00$var$LoadingLoadable(new Promise(function() {})));
}
function $d7ce42c300073b00$var$loadableAllArray(inputs) {
    return inputs.every(function(i) {
        return i.state === 'hasValue';
    }) ? $d7ce42c300073b00$var$loadableWithValue(inputs.map(function(i) {
        return i.contents;
    })) : inputs.some(function(i) {
        return i.state === 'hasError';
    }) ? $d7ce42c300073b00$var$loadableWithError($d7ce42c300073b00$var$Recoil_nullthrows(inputs.find(function(i) {
        return i.state === 'hasError';
    }), 'Invalid loadable passed to loadableAll').contents) : $d7ce42c300073b00$var$loadableWithPromise(Promise.all(inputs.map(function(i) {
        return i.contents;
    })));
}
function $d7ce42c300073b00$var$loadableAll(inputs) {
    var unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map(function(key) {
        return inputs[key];
    });
    var normalizedInputs = unwrapedInputs.map(function(x) {
        return $d7ce42c300073b00$var$isLoadable(x) ? x : $d7ce42c300073b00$var$Recoil_isPromise(x) ? $d7ce42c300073b00$var$loadableWithPromise(x) : $d7ce42c300073b00$var$loadableWithValue(x);
    });
    var output = $d7ce42c300073b00$var$loadableAllArray(normalizedInputs);
    return Array.isArray(inputs) ? output : // $FlowIssue[incompatible-call]
    output.map(function(outputs) {
        return Object.getOwnPropertyNames(inputs).reduce(function(out, key, idx) {
            return (0, $7XD9P._)((0, $hRCmZ._)({}, out), (0, $8c6ug._)({}, key, outputs[idx]));
        }, {});
    });
}
function $d7ce42c300073b00$var$isLoadable(x) {
    return x instanceof $d7ce42c300073b00$var$BaseLoadable;
}
var $d7ce42c300073b00$var$LoadableStaticInterface = {
    of: function(value) {
        return $d7ce42c300073b00$var$Recoil_isPromise(value) ? $d7ce42c300073b00$var$loadableWithPromise(value) : $d7ce42c300073b00$var$isLoadable(value) ? value : $d7ce42c300073b00$var$loadableWithValue(value);
    },
    error: function(error) {
        return $d7ce42c300073b00$var$loadableWithError(error);
    },
    // $FlowIssue[incompatible-return]
    loading: function() {
        return $d7ce42c300073b00$var$loadableLoading();
    },
    // $FlowIssue[unclear-type]
    all: $d7ce42c300073b00$var$loadableAll,
    isLoadable: $d7ce42c300073b00$var$isLoadable
};
var $d7ce42c300073b00$var$Recoil_Loadable = {
    loadableWithValue: $d7ce42c300073b00$var$loadableWithValue,
    loadableWithError: $d7ce42c300073b00$var$loadableWithError,
    loadableWithPromise: $d7ce42c300073b00$var$loadableWithPromise,
    loadableLoading: $d7ce42c300073b00$var$loadableLoading,
    loadableAll: $d7ce42c300073b00$var$loadableAll,
    isLoadable: $d7ce42c300073b00$var$isLoadable,
    RecoilLoadable: $d7ce42c300073b00$var$LoadableStaticInterface
};
var $d7ce42c300073b00$var$Recoil_Loadable_1 = $d7ce42c300073b00$var$Recoil_Loadable.loadableWithValue;
var $d7ce42c300073b00$var$Recoil_Loadable_2 = $d7ce42c300073b00$var$Recoil_Loadable.loadableWithError;
var $d7ce42c300073b00$var$Recoil_Loadable_3 = $d7ce42c300073b00$var$Recoil_Loadable.loadableWithPromise;
var $d7ce42c300073b00$var$Recoil_Loadable_4 = $d7ce42c300073b00$var$Recoil_Loadable.loadableLoading;
var $d7ce42c300073b00$var$Recoil_Loadable_5 = $d7ce42c300073b00$var$Recoil_Loadable.loadableAll;
var $d7ce42c300073b00$var$Recoil_Loadable_6 = $d7ce42c300073b00$var$Recoil_Loadable.isLoadable;
var $d7ce42c300073b00$var$Recoil_Loadable_7 = $d7ce42c300073b00$var$Recoil_Loadable.RecoilLoadable;
var $d7ce42c300073b00$var$Recoil_Loadable$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    loadableWithValue: $d7ce42c300073b00$var$Recoil_Loadable_1,
    loadableWithError: $d7ce42c300073b00$var$Recoil_Loadable_2,
    loadableWithPromise: $d7ce42c300073b00$var$Recoil_Loadable_3,
    loadableLoading: $d7ce42c300073b00$var$Recoil_Loadable_4,
    loadableAll: $d7ce42c300073b00$var$Recoil_Loadable_5,
    isLoadable: $d7ce42c300073b00$var$Recoil_Loadable_6,
    RecoilLoadable: $d7ce42c300073b00$var$Recoil_Loadable_7
});
var $d7ce42c300073b00$var$env = {
    RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
    // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
    RECOIL_GKS_ENABLED: new Set([
        'recoil_hamt_2020',
        'recoil_sync_external_store',
        'recoil_suppress_rerender_in_callback',
        'recoil_memory_managament_2020'
    ])
};
function $d7ce42c300073b00$var$readProcessEnvBooleanFlag(name, set) {
    var _process$env$name, _process$env$name$toL;
    var sanitizedValue = (_process$env$name = $d825e01bb91c74de$exports.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();
    if (sanitizedValue == null || sanitizedValue === '') return;
    var allowedValues = [
        'true',
        'false'
    ];
    if (!allowedValues.includes(sanitizedValue)) throw $d7ce42c300073b00$var$Recoil_err("process.env.".concat(name, " value must be 'true', 'false', or empty: ").concat(sanitizedValue));
    set(sanitizedValue === 'true');
}
function $d7ce42c300073b00$var$readProcessEnvStringArrayFlag(name, set) {
    var _process$env$name2;
    var sanitizedValue = (_process$env$name2 = $d825e01bb91c74de$exports.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();
    if (sanitizedValue == null || sanitizedValue === '') return;
    set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */ function $d7ce42c300073b00$var$applyProcessEnvFlagOverrides() {
    var _process;
    var value, value1, gk;
    return;
}
$d7ce42c300073b00$var$applyProcessEnvFlagOverrides();
var $d7ce42c300073b00$var$Recoil_RecoilEnv = $d7ce42c300073b00$var$env;
function $d7ce42c300073b00$var$Recoil_gkx_OSS(gk) {
    return $d7ce42c300073b00$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}
$d7ce42c300073b00$var$Recoil_gkx_OSS.setPass = function(gk) {
    $d7ce42c300073b00$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};
$d7ce42c300073b00$var$Recoil_gkx_OSS.setFail = function(gk) {
    $d7ce42c300073b00$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED["delete"](gk);
};
$d7ce42c300073b00$var$Recoil_gkx_OSS.clear = function() {
    $d7ce42c300073b00$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};
var $d7ce42c300073b00$var$Recoil_gkx = $d7ce42c300073b00$var$Recoil_gkx_OSS; // @oss-only
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$recoverableViolation(message, _projectName) {
    var error = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).error;
    return null;
}
var $d7ce42c300073b00$var$recoverableViolation_1 = $d7ce42c300073b00$var$recoverableViolation;
// @oss-only
var $d7ce42c300073b00$var$Recoil_recoverableViolation = $d7ce42c300073b00$var$recoverableViolation_1;
var $d7ce42c300073b00$var$_createMutableSource, $d7ce42c300073b00$var$_useMutableSource, $d7ce42c300073b00$var$_useSyncExternalStore;
var $d7ce42c300073b00$var$createMutableSource = ($d7ce42c300073b00$var$_createMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createMutableSource) !== null && $d7ce42c300073b00$var$_createMutableSource !== void 0 ? $d7ce42c300073b00$var$_createMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).unstable_createMutableSource;
var $d7ce42c300073b00$var$useMutableSource = ($d7ce42c300073b00$var$_useMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useMutableSource) !== null && $d7ce42c300073b00$var$_useMutableSource !== void 0 ? $d7ce42c300073b00$var$_useMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86
var $d7ce42c300073b00$var$useSyncExternalStore = ($d7ce42c300073b00$var$_useSyncExternalStore = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useSyncExternalStore) !== null && $d7ce42c300073b00$var$_useSyncExternalStore !== void 0 ? $d7ce42c300073b00$var$_useSyncExternalStore : (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).unstable_useSyncExternalStore;
var $d7ce42c300073b00$var$ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.
function $d7ce42c300073b00$var$currentRendererSupportsUseSyncExternalStore() {
    var _ReactCurrentDispatch;
    // $FlowFixMe[incompatible-use]
    var /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */ _react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ReactCurrentDispatcher = _react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher, ReactCurrentOwner = _react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;
    var dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
    var isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;
    if ($d7ce42c300073b00$var$useSyncExternalStore && !isUseSyncExternalStoreSupported && !$d7ce42c300073b00$var$ReactRendererVersionMismatchWarnOnce) {
        $d7ce42c300073b00$var$ReactRendererVersionMismatchWarnOnce = true;
        $d7ce42c300073b00$var$Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
    }
    return isUseSyncExternalStoreSupported;
}
/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */ function $d7ce42c300073b00$var$reactMode() {
    // NOTE: This mode is currently broken with some Suspense cases
    // see Recoil_selector-test.js
    if ($d7ce42c300073b00$var$Recoil_gkx('recoil_transition_support')) return {
        mode: 'TRANSITION_SUPPORT',
        early: true,
        concurrent: true
    };
    if ($d7ce42c300073b00$var$Recoil_gkx('recoil_sync_external_store') && $d7ce42c300073b00$var$useSyncExternalStore != null) return {
        mode: 'SYNC_EXTERNAL_STORE',
        early: true,
        concurrent: false
    };
    if ($d7ce42c300073b00$var$Recoil_gkx('recoil_mutable_source') && $d7ce42c300073b00$var$useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) return $d7ce42c300073b00$var$Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
        mode: 'MUTABLE_SOURCE',
        early: true,
        concurrent: true
    } : {
        mode: 'MUTABLE_SOURCE',
        early: false,
        concurrent: false
    };
    return $d7ce42c300073b00$var$Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
        mode: 'LEGACY',
        early: true,
        concurrent: false
    } : {
        mode: 'LEGACY',
        early: false,
        concurrent: false
    };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:
function $d7ce42c300073b00$var$isFastRefreshEnabled() {
    // @fb-only: const {isAcceptingUpdate} = require('__debug');
    // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
    return false; // @oss-only
}
var $d7ce42c300073b00$var$Recoil_ReactMode = {
    createMutableSource: $d7ce42c300073b00$var$createMutableSource,
    useMutableSource: $d7ce42c300073b00$var$useMutableSource,
    useSyncExternalStore: $d7ce42c300073b00$var$useSyncExternalStore,
    currentRendererSupportsUseSyncExternalStore: $d7ce42c300073b00$var$currentRendererSupportsUseSyncExternalStore,
    reactMode: $d7ce42c300073b00$var$reactMode,
    isFastRefreshEnabled: $d7ce42c300073b00$var$isFastRefreshEnabled
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // eslint-disable-next-line no-unused-vars
var $d7ce42c300073b00$var$AbstractRecoilValue = /*#__PURE__*/ function() {
    "use strict";
    function AbstractRecoilValue(newKey) {
        (0, $6WLcG._)(this, AbstractRecoilValue);
        $d7ce42c300073b00$var$_defineProperty(this, "key", void 0);
        this.key = newKey;
    }
    (0, $dbIwN._)(AbstractRecoilValue, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    key: this.key
                };
            }
        }
    ]);
    return AbstractRecoilValue;
}();
var $d7ce42c300073b00$var$RecoilState = /*#__PURE__*/ function(AbstractRecoilValue) {
    "use strict";
    (0, $a7G5R._)(RecoilState, AbstractRecoilValue);
    function RecoilState() {
        (0, $6WLcG._)(this, RecoilState);
        return (0, $bQby9._)(this, RecoilState, arguments);
    }
    return RecoilState;
}($d7ce42c300073b00$var$AbstractRecoilValue);
var $d7ce42c300073b00$var$RecoilValueReadOnly = /*#__PURE__*/ function(AbstractRecoilValue) {
    "use strict";
    (0, $a7G5R._)(RecoilValueReadOnly, AbstractRecoilValue);
    function RecoilValueReadOnly() {
        (0, $6WLcG._)(this, RecoilValueReadOnly);
        return (0, $bQby9._)(this, RecoilValueReadOnly, arguments);
    }
    return RecoilValueReadOnly;
}($d7ce42c300073b00$var$AbstractRecoilValue);
function $d7ce42c300073b00$var$isRecoilValue(x) {
    return x instanceof $d7ce42c300073b00$var$RecoilState || x instanceof $d7ce42c300073b00$var$RecoilValueReadOnly;
}
var $d7ce42c300073b00$var$Recoil_RecoilValue = {
    AbstractRecoilValue: $d7ce42c300073b00$var$AbstractRecoilValue,
    RecoilState: $d7ce42c300073b00$var$RecoilState,
    RecoilValueReadOnly: $d7ce42c300073b00$var$RecoilValueReadOnly,
    isRecoilValue: $d7ce42c300073b00$var$isRecoilValue
};
var $d7ce42c300073b00$var$Recoil_RecoilValue_1 = $d7ce42c300073b00$var$Recoil_RecoilValue.AbstractRecoilValue;
var $d7ce42c300073b00$var$Recoil_RecoilValue_2 = $d7ce42c300073b00$var$Recoil_RecoilValue.RecoilState;
var $d7ce42c300073b00$var$Recoil_RecoilValue_3 = $d7ce42c300073b00$var$Recoil_RecoilValue.RecoilValueReadOnly;
var $d7ce42c300073b00$var$Recoil_RecoilValue_4 = $d7ce42c300073b00$var$Recoil_RecoilValue.isRecoilValue;
var $d7ce42c300073b00$var$Recoil_RecoilValue$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractRecoilValue: $d7ce42c300073b00$var$Recoil_RecoilValue_1,
    RecoilState: $d7ce42c300073b00$var$Recoil_RecoilValue_2,
    RecoilValueReadOnly: $d7ce42c300073b00$var$Recoil_RecoilValue_3,
    isRecoilValue: $d7ce42c300073b00$var$Recoil_RecoilValue_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$sprintf(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var index = 0;
    return format.replace(/%s/g, function() {
        return String(args[index++]);
    });
}
var $d7ce42c300073b00$var$sprintf_1 = $d7ce42c300073b00$var$sprintf;
function $d7ce42c300073b00$var$expectationViolation(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
}
var $d7ce42c300073b00$var$expectationViolation_1 = $d7ce42c300073b00$var$expectationViolation;
// @oss-only
var $d7ce42c300073b00$var$Recoil_expectationViolation = $d7ce42c300073b00$var$expectationViolation_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */ function $d7ce42c300073b00$var$mapIterable(iterable, callback) {
    // Use generator to create iterable/iterator
    return function() {
        var index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, err;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    index = 0;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = iterable[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    value = _step.value;
                    return [
                        4,
                        callback(value, index++)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }();
}
var $d7ce42c300073b00$var$Recoil_mapIterable = $d7ce42c300073b00$var$mapIterable;
var $d7ce42c300073b00$var$isFastRefreshEnabled$1 = $d7ce42c300073b00$var$Recoil_ReactMode.isFastRefreshEnabled;
var $d7ce42c300073b00$var$DefaultValue = function DefaultValue() {
    "use strict";
    (0, $6WLcG._)(this, DefaultValue);
};
var $d7ce42c300073b00$var$DEFAULT_VALUE = new $d7ce42c300073b00$var$DefaultValue();
// flowlint-next-line unclear-type:off
var $d7ce42c300073b00$var$nodes = new Map(); // flowlint-next-line unclear-type:off
var $d7ce42c300073b00$var$recoilValues = new Map();
/* eslint-disable no-redeclare */ function $d7ce42c300073b00$var$recoilValuesForKeys(keys) {
    return $d7ce42c300073b00$var$Recoil_mapIterable(keys, function(key) {
        return $d7ce42c300073b00$var$Recoil_nullthrows($d7ce42c300073b00$var$recoilValues.get(key));
    });
}
function $d7ce42c300073b00$var$checkForDuplicateAtomKey(key) {
    if ($d7ce42c300073b00$var$nodes.has(key)) {
        var message = 'Duplicate atom key "'.concat(key, '". This is a FATAL ERROR in\n      production. But it is safe to ignore this warning if it occurred because of\n      hot module replacement.');
        // @fb-only: recoverableViolation(message, 'recoil');
        console.warn(message); // @oss-only
    }
}
function $d7ce42c300073b00$var$registerNode(node) {
    if ($d7ce42c300073b00$var$Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) $d7ce42c300073b00$var$checkForDuplicateAtomKey(node.key);
    $d7ce42c300073b00$var$nodes.set(node.key, node);
    var recoilValue = node.set == null ? new $d7ce42c300073b00$var$Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new $d7ce42c300073b00$var$Recoil_RecoilValue$1.RecoilState(node.key);
    $d7ce42c300073b00$var$recoilValues.set(node.key, recoilValue);
    return recoilValue;
}
/* eslint-enable no-redeclare */ var $d7ce42c300073b00$var$NodeMissingError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $a7G5R._)(NodeMissingError, Error1);
    function NodeMissingError() {
        (0, $6WLcG._)(this, NodeMissingError);
        return (0, $bQby9._)(this, NodeMissingError, arguments);
    }
    return NodeMissingError;
} // flowlint-next-line unclear-type:off
((0, $2DHfY._)(Error));
function $d7ce42c300073b00$var$getNode(key) {
    var node = $d7ce42c300073b00$var$nodes.get(key);
    if (node == null) throw new $d7ce42c300073b00$var$NodeMissingError('Missing definition for RecoilValue: "'.concat(key, '""'));
    return node;
} // flowlint-next-line unclear-type:off
function $d7ce42c300073b00$var$getNodeMaybe(key) {
    return $d7ce42c300073b00$var$nodes.get(key);
}
var $d7ce42c300073b00$var$configDeletionHandlers = new Map();
function $d7ce42c300073b00$var$deleteNodeConfigIfPossible(key) {
    var _node$shouldDeleteCon;
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    var node = $d7ce42c300073b00$var$nodes.get(key);
    if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
        var _getConfigDeletionHan;
        $d7ce42c300073b00$var$nodes["delete"](key);
        (_getConfigDeletionHan = $d7ce42c300073b00$var$getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 || _getConfigDeletionHan();
        $d7ce42c300073b00$var$configDeletionHandlers["delete"](key);
    }
}
function $d7ce42c300073b00$var$setConfigDeletionHandler(key, fn) {
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    if (fn === undefined) $d7ce42c300073b00$var$configDeletionHandlers["delete"](key);
    else $d7ce42c300073b00$var$configDeletionHandlers.set(key, fn);
}
function $d7ce42c300073b00$var$getConfigDeletionHandler(key) {
    return $d7ce42c300073b00$var$configDeletionHandlers.get(key);
}
var $d7ce42c300073b00$var$Recoil_Node = {
    nodes: $d7ce42c300073b00$var$nodes,
    recoilValues: $d7ce42c300073b00$var$recoilValues,
    registerNode: $d7ce42c300073b00$var$registerNode,
    getNode: $d7ce42c300073b00$var$getNode,
    getNodeMaybe: $d7ce42c300073b00$var$getNodeMaybe,
    deleteNodeConfigIfPossible: $d7ce42c300073b00$var$deleteNodeConfigIfPossible,
    setConfigDeletionHandler: $d7ce42c300073b00$var$setConfigDeletionHandler,
    getConfigDeletionHandler: $d7ce42c300073b00$var$getConfigDeletionHandler,
    recoilValuesForKeys: $d7ce42c300073b00$var$recoilValuesForKeys,
    NodeMissingError: $d7ce42c300073b00$var$NodeMissingError,
    DefaultValue: $d7ce42c300073b00$var$DefaultValue,
    DEFAULT_VALUE: $d7ce42c300073b00$var$DEFAULT_VALUE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$enqueueExecution(s, f) {
    f();
}
var $d7ce42c300073b00$var$Recoil_Queue = {
    enqueueExecution: $d7ce42c300073b00$var$enqueueExecution
};
function $d7ce42c300073b00$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $d7ce42c300073b00$var$hamt_1 = $d7ce42c300073b00$var$createCommonjsModule(function(module) {
    var _typeof = typeof Symbol === "function" && (0, $2xTNA._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj);
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj);
    };
    /**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/ var hamt = {}; // export
    /* Configuration
 ******************************************************************************/ var SIZE = 5;
    var BUCKET_SIZE = Math.pow(2, SIZE);
    var MASK = BUCKET_SIZE - 1;
    var MAX_INDEX_NODE = BUCKET_SIZE / 2;
    var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
    /*
 ******************************************************************************/ var nothing = {};
    var constant = function constant(x) {
        return function() {
            return x;
        };
    };
    /**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/ var hash = hamt.hash = function hash(str) {
        var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
        if (type === 'number') return str;
        if (type !== 'string') str += '';
        var hash = 0;
        for(var i = 0, len = str.length; i < len; ++i){
            var c = str.charCodeAt(i);
            hash = (hash << 5) - hash + c | 0;
        }
        return hash;
    };
    /* Bit Ops
 ******************************************************************************/ /**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/ var popcount = function popcount(x) {
        x -= x >> 1 & 0x55555555;
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x += x >> 8;
        x += x >> 16;
        return x & 0x7f;
    };
    var hashFragment = function hashFragment(shift, h) {
        return h >>> shift & MASK;
    };
    var toBitmap = function toBitmap(x) {
        return 1 << x;
    };
    var fromBitmap = function fromBitmap(bitmap, bit) {
        return popcount(bitmap & bit - 1);
    };
    /* Array Ops
 ******************************************************************************/ /**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/ var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
        var out = arr;
        if (!mutate) {
            var len = arr.length;
            out = new Array(len);
            for(var i = 0; i < len; ++i)out[i] = arr[i];
        }
        out[at] = v;
        return out;
    };
    /**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/ var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
        var newLen = arr.length - 1;
        var i = 0;
        var g = 0;
        var out = arr;
        if (mutate) i = g = at;
        else {
            out = new Array(newLen);
            while(i < at)out[g++] = arr[i++];
        }
        ++i;
        while(i <= newLen)out[g++] = arr[i++];
        if (mutate) out.length = newLen;
        return out;
    };
    /**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/ var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
        var len = arr.length;
        if (mutate) {
            var _i = len;
            while(_i >= at)arr[_i--] = arr[_i];
            arr[at] = v;
            return arr;
        }
        var i = 0, g = 0;
        var out = new Array(len + 1);
        while(i < at)out[g++] = arr[i++];
        out[at] = v;
        while(i < len)out[++g] = arr[i++];
        return out;
    };
    /* Node Structures
 ******************************************************************************/ var LEAF = 1;
    var COLLISION = 2;
    var INDEX = 3;
    var ARRAY = 4;
    /**
    Empty node.
*/ var empty = {
        __hamt_isEmpty: true
    };
    var isEmptyNode = function isEmptyNode(x) {
        return x === empty || x && x.__hamt_isEmpty;
    };
    /**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/ var Leaf = function Leaf(edit, hash, key, value) {
        return {
            type: LEAF,
            edit: edit,
            hash: hash,
            key: key,
            value: value,
            _modify: Leaf__modify
        };
    };
    /**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/ var Collision = function Collision(edit, hash, children) {
        return {
            type: COLLISION,
            edit: edit,
            hash: hash,
            children: children,
            _modify: Collision__modify
        };
    };
    /**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/ var IndexedNode = function IndexedNode(edit, mask, children) {
        return {
            type: INDEX,
            edit: edit,
            mask: mask,
            children: children,
            _modify: IndexedNode__modify
        };
    };
    /**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/ var ArrayNode = function ArrayNode(edit, size, children) {
        return {
            type: ARRAY,
            edit: edit,
            size: size,
            children: children,
            _modify: ArrayNode__modify
        };
    };
    /**
    Is `node` a leaf node?
*/ var isLeaf = function isLeaf(node) {
        return node === empty || node.type === LEAF || node.type === COLLISION;
    };
    /* Internal node operations.
 ******************************************************************************/ /**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/ var expand = function expand(edit, frag, child, bitmap, subNodes) {
        var arr = [];
        var bit = bitmap;
        var count = 0;
        for(var i = 0; bit; ++i){
            if (bit & 1) arr[i] = subNodes[count++];
            bit >>>= 1;
        }
        arr[frag] = child;
        return ArrayNode(edit, count + 1, arr);
    };
    /**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/ var pack = function pack(edit, count, removed, elements) {
        var children = new Array(count - 1);
        var g = 0;
        var bitmap = 0;
        for(var i = 0, len = elements.length; i < len; ++i)if (i !== removed) {
            var elem = elements[i];
            if (elem && !isEmptyNode(elem)) {
                children[g++] = elem;
                bitmap |= 1 << i;
            }
        }
        return IndexedNode(edit, bitmap, children);
    };
    /**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/ var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
        if (h1 === h2) return Collision(edit, h1, [
            n2,
            n1
        ]);
        var subH1 = hashFragment(shift, h1);
        var subH2 = hashFragment(shift, h2);
        return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [
            mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)
        ] : subH1 < subH2 ? [
            n1,
            n2
        ] : [
            n2,
            n1
        ]);
    };
    /**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/ var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
        var len = list.length;
        for(var i = 0; i < len; ++i){
            var child = list[i];
            if (keyEq(k, child.key)) {
                var value = child.value;
                var _newValue = f(value);
                if (_newValue === value) return list;
                if (_newValue === nothing) {
                    --size.value;
                    return arraySpliceOut(mutate, i, list);
                }
                return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
            }
        }
        var newValue = f();
        if (newValue === nothing) return list;
        ++size.value;
        return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
    };
    var canEditNode = function canEditNode(edit, node) {
        return edit === node.edit;
    };
    /* Editing
 ******************************************************************************/ var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
        if (keyEq(k, this.key)) {
            var _v = f(this.value);
            if (_v === this.value) return this;
            else if (_v === nothing) {
                --size.value;
                return empty;
            }
            if (canEditNode(edit, this)) {
                this.value = _v;
                return this;
            }
            return Leaf(edit, h, k, _v);
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
        if (h === this.hash) {
            var canEdit = canEditNode(edit, this);
            var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
            if (list === this.children) return this;
            return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
        var mask = this.mask;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var bit = toBitmap(frag);
        var indx = fromBitmap(mask, bit);
        var exists = mask & bit;
        var current = exists ? children[indx] : empty;
        var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (current === child) return this;
        var canEdit = canEditNode(edit, this);
        var bitmap = mask;
        var newChildren = void 0;
        if (exists && isEmptyNode(child)) {
            // remove
            bitmap &= ~bit;
            if (!bitmap) return empty;
            if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse
            newChildren = arraySpliceOut(canEdit, indx, children);
        } else if (!exists && !isEmptyNode(child)) {
            // add
            if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
            bitmap |= bit;
            newChildren = arraySpliceIn(canEdit, indx, child, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, indx, child, children);
        if (canEdit) {
            this.mask = bitmap;
            this.children = newChildren;
            return this;
        }
        return IndexedNode(edit, bitmap, newChildren);
    };
    var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
        var count = this.size;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var child = children[frag];
        var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (child === newChild) return this;
        var canEdit = canEditNode(edit, this);
        var newChildren = void 0;
        if (isEmptyNode(child) && !isEmptyNode(newChild)) {
            // add
            ++count;
            newChildren = arrayUpdate(canEdit, frag, newChild, children);
        } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
            // remove
            --count;
            if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
            newChildren = arrayUpdate(canEdit, frag, empty, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, frag, newChild, children);
        if (canEdit) {
            this.size = count;
            this.children = newChildren;
            return this;
        }
        return ArrayNode(edit, count, newChildren);
    };
    empty._modify = function(edit, keyEq, shift, f, h, k, size) {
        var v = f();
        if (v === nothing) return empty;
        ++size.value;
        return Leaf(edit, h, k, v);
    };
    /*
 ******************************************************************************/ function Map1(editable, edit, config, root, size) {
        this._editable = editable;
        this._edit = edit;
        this._config = config;
        this._root = root;
        this._size = size;
    }
    Map1.prototype.setTree = function(newRoot, newSize) {
        if (this._editable) {
            this._root = newRoot;
            this._size = newSize;
            return this;
        }
        return newRoot === this._root ? this : new Map1(this._editable, this._edit, this._config, newRoot, newSize);
    };
    /* Queries
 ******************************************************************************/ /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/ var tryGetHash = hamt.tryGetHash = function tryGetHash(alt, hash, key, map) {
        var node = map._root;
        var shift = 0;
        var keyEq = map._config.keyEq;
        while(true)switch(node.type){
            case LEAF:
                return keyEq(key, node.key) ? node.value : alt;
            case COLLISION:
                if (hash === node.hash) {
                    var children = node.children;
                    for(var i = 0, len = children.length; i < len; ++i){
                        var child = children[i];
                        if (keyEq(key, child.key)) return child.value;
                    }
                }
                return alt;
            case INDEX:
                var frag = hashFragment(shift, hash);
                var bit = toBitmap(frag);
                if (node.mask & bit) {
                    node = node.children[fromBitmap(node.mask, bit)];
                    shift += SIZE;
                    break;
                }
                return alt;
            case ARRAY:
                node = node.children[hashFragment(shift, hash)];
                if (node) {
                    shift += SIZE;
                    break;
                }
                return alt;
            default:
                return alt;
        }
    };
    Map1.prototype.tryGetHash = function(alt, hash, key) {
        return tryGetHash(alt, hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/ var tryGet = hamt.tryGet = function tryGet(alt, key, map) {
        return tryGetHash(alt, map._config.hash(key), key, map);
    };
    Map1.prototype.tryGet = function(alt, key) {
        return tryGet(alt, key, this);
    };
    /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/ var getHash = hamt.getHash = function getHash(hash, key, map) {
        return tryGetHash(undefined, hash, key, map);
    };
    Map1.prototype.getHash = function(hash, key) {
        return getHash(hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/ var get = hamt.get = function get(key, map) {
        return tryGetHash(undefined, map._config.hash(key), key, map);
    };
    Map1.prototype.get = function(key, alt) {
        return tryGet(alt, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/ var hasHash = hamt.has = function hasHash(hash, key, map) {
        return tryGetHash(nothing, hash, key, map) !== nothing;
    };
    Map1.prototype.hasHash = function(hash, key) {
        return hasHash(hash, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/ var has = hamt.has = function has(key, map) {
        return hasHash(map._config.hash(key), key, map);
    };
    Map1.prototype.has = function(key) {
        return has(key, this);
    };
    var defKeyCompare = function defKeyCompare(x, y) {
        return x === y;
    };
    /**
    Create an empty map.

    @param config Configuration.
*/ hamt.make = function(config) {
        return new Map1(0, 0, {
            keyEq: config && config.keyEq || defKeyCompare,
            hash: config && config.hash || hash
        }, empty, 0);
    };
    /**
    Empty map.
*/ hamt.empty = hamt.make();
    /**
    Does `map` contain any elements?
*/ var isEmpty = hamt.isEmpty = function isEmpty(map) {
        return map && !!isEmptyNode(map._root);
    };
    Map1.prototype.isEmpty = function() {
        return isEmpty(this);
    };
    /* Updates
 ******************************************************************************/ /**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/ var modifyHash = hamt.modifyHash = function modifyHash(f, hash, key, map) {
        var size = {
            value: map._size
        };
        var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);
        return map.setTree(newRoot, size.value);
    };
    Map1.prototype.modifyHash = function(hash, key, f) {
        return modifyHash(f, hash, key, this);
    };
    /**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/ var modify = hamt.modify = function modify(f, key, map) {
        return modifyHash(f, map._config.hash(key), key, map);
    };
    Map1.prototype.modify = function(key, f) {
        return modify(f, key, this);
    };
    /**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/ var setHash = hamt.setHash = function setHash(hash, key, value, map) {
        return modifyHash(constant(value), hash, key, map);
    };
    Map1.prototype.setHash = function(hash, key, value) {
        return setHash(hash, key, value, this);
    };
    /**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/ var set = hamt.set = function set(key, value, map) {
        return setHash(map._config.hash(key), key, value, map);
    };
    Map1.prototype.set = function(key, value) {
        return set(key, value, this);
    };
    /**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/ var del = constant(nothing);
    var removeHash = hamt.removeHash = function removeHash(hash, key, map) {
        return modifyHash(del, hash, key, map);
    };
    Map1.prototype.removeHash = Map1.prototype.deleteHash = function(hash, key) {
        return removeHash(hash, key, this);
    };
    /**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/ var remove = hamt.remove = function remove(key, map) {
        return removeHash(map._config.hash(key), key, map);
    };
    Map1.prototype.remove = Map1.prototype["delete"] = function(key) {
        return remove(key, this);
    };
    /* Mutation
 ******************************************************************************/ /**
    Mark `map` as mutable.
 */ var beginMutation = hamt.beginMutation = function beginMutation(map) {
        return new Map1(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
    };
    Map1.prototype.beginMutation = function() {
        return beginMutation(this);
    };
    /**
    Mark `map` as immutable.
 */ var endMutation = hamt.endMutation = function endMutation(map) {
        map._editable = map._editable && map._editable - 1;
        return map;
    };
    Map1.prototype.endMutation = function() {
        return endMutation(this);
    };
    /**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/ var mutate = hamt.mutate = function mutate(f, map) {
        var _transient = beginMutation(map);
        f(_transient);
        return endMutation(_transient);
    };
    Map1.prototype.mutate = function(f) {
        return mutate(f, this);
    };
    /* Traversal
 ******************************************************************************/ /**
    Apply a continuation.
*/ var appk = function appk(k) {
        return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
    };
    /**
    Recursively visit all values stored in an array of nodes lazily.
*/ var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
        while(i < len){
            var child = children[i++];
            if (child && !isEmptyNode(child)) return lazyVisit(child, f, [
                len,
                children,
                i,
                f,
                k
            ]);
        }
        return appk(k);
    };
    /**
    Recursively visit all values stored in `node` lazily.
*/ var lazyVisit = function lazyVisit(node, f, k) {
        switch(node.type){
            case LEAF:
                return {
                    value: f(node),
                    rest: k
                };
            case COLLISION:
            case ARRAY:
            case INDEX:
                var children = node.children;
                return lazyVisitChildren(children.length, children, 0, f, k);
            default:
                return appk(k);
        }
    };
    var DONE = {
        done: true
    };
    /**
    Javascript iterator over a map.
*/ function MapIterator(v) {
        this.v = v;
    }
    MapIterator.prototype.next = function() {
        if (!this.v) return DONE;
        var v0 = this.v;
        this.v = appk(v0.rest);
        return v0;
    };
    MapIterator.prototype[Symbol.iterator] = function() {
        return this;
    };
    /**
    Lazily visit each value in map with function `f`.
*/ var visit = function visit(map, f) {
        return new MapIterator(lazyVisit(map._root, f));
    };
    /**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/ var buildPairs = function buildPairs(x) {
        return [
            x.key,
            x.value
        ];
    };
    var entries = hamt.entries = function entries(map) {
        return visit(map, buildPairs);
    };
    Map1.prototype.entries = Map1.prototype[Symbol.iterator] = function() {
        return entries(this);
    };
    /**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/ var buildKeys = function buildKeys(x) {
        return x.key;
    };
    var keys = hamt.keys = function keys(map) {
        return visit(map, buildKeys);
    };
    Map1.prototype.keys = function() {
        return keys(this);
    };
    /**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/ var buildValues = function buildValues(x) {
        return x.value;
    };
    var values = hamt.values = Map1.prototype.values = function values(map) {
        return visit(map, buildValues);
    };
    Map1.prototype.values = function() {
        return values(this);
    };
    /* Fold
 ******************************************************************************/ /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/ var fold = hamt.fold = function fold(f, z, m) {
        var root = m._root;
        if (root.type === LEAF) return f(z, root.value, root.key);
        var toVisit = [
            root.children
        ];
        var children = void 0;
        while(children = toVisit.pop())for(var i = 0, len = children.length; i < len;){
            var child = children[i++];
            if (child && child.type) {
                if (child.type === LEAF) z = f(z, child.value, child.key);
                else toVisit.push(child.children);
            }
        }
        return z;
    };
    Map1.prototype.fold = function(f, z) {
        return fold(f, z, this);
    };
    /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/ var forEach = hamt.forEach = function forEach(f, map) {
        return fold(function(_, value, key) {
            return f(value, key, map);
        }, null, map);
    };
    Map1.prototype.forEach = function(f) {
        return forEach(f, this);
    };
    /* Aggregate
 ******************************************************************************/ /**
    Get the number of entries in `map`.
*/ var count = hamt.count = function count(map) {
        return map._size;
    };
    Map1.prototype.count = function() {
        return count(this);
    };
    Object.defineProperty(Map1.prototype, 'size', {
        get: Map1.prototype.count
    });
    /* Export
 ******************************************************************************/ if (module.exports) module.exports = hamt;
    else undefined.hamt = hamt;
});
var $d7ce42c300073b00$var$BuiltInMap = /*#__PURE__*/ function() {
    "use strict";
    function BuiltInMap(existing) {
        (0, $6WLcG._)(this, BuiltInMap);
        $d7ce42c300073b00$var$_defineProperty(this, "_map", void 0);
        this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
    }
    (0, $dbIwN._)(BuiltInMap, [
        {
            key: "keys",
            value: function keys() {
                return this._map.keys();
            }
        },
        {
            key: "entries",
            value: function entries() {
                return this._map.entries();
            }
        },
        {
            key: "get",
            value: function get(k) {
                return this._map.get(k);
            }
        },
        {
            key: "has",
            value: function has(k) {
                return this._map.has(k);
            }
        },
        {
            key: "set",
            value: function set(k, v) {
                this._map.set(k, v);
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(k) {
                this._map["delete"](k);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return $d7ce42c300073b00$var$persistentMap(this);
            }
        },
        {
            key: "toMap",
            value: function toMap() {
                return new Map(this._map);
            }
        }
    ]);
    return BuiltInMap;
}();
var $d7ce42c300073b00$var$HashArrayMappedTrieMap = /*#__PURE__*/ function() {
    "use strict";
    function HashArrayMappedTrieMap(existing) {
        (0, $6WLcG._)(this, HashArrayMappedTrieMap);
        $d7ce42c300073b00$var$_defineProperty(this, "_hamt", $d7ce42c300073b00$var$hamt_1.empty.beginMutation());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (existing instanceof HashArrayMappedTrieMap) {
            var h = existing._hamt.endMutation();
            existing._hamt = h.beginMutation();
            this._hamt = h.beginMutation();
        } else if (existing) try {
            for(var _iterator = existing.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6mdMa._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                this._hamt.set(k, v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $dbIwN._)(HashArrayMappedTrieMap, [
        {
            key: "keys",
            value: function keys() {
                return this._hamt.keys();
            }
        },
        {
            key: "entries",
            value: function entries() {
                return this._hamt.entries();
            }
        },
        {
            key: "get",
            value: function get(k) {
                return this._hamt.get(k);
            }
        },
        {
            key: "has",
            value: function has(k) {
                return this._hamt.has(k);
            }
        },
        {
            key: "set",
            value: function set(k, v) {
                this._hamt.set(k, v);
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(k) {
                this._hamt["delete"](k);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return $d7ce42c300073b00$var$persistentMap(this);
            }
        },
        {
            key: "toMap",
            value: function toMap() {
                return new Map(this._hamt);
            }
        }
    ]);
    return HashArrayMappedTrieMap;
}();
function $d7ce42c300073b00$var$persistentMap(existing) {
    if ($d7ce42c300073b00$var$Recoil_gkx('recoil_hamt_2020')) return new $d7ce42c300073b00$var$HashArrayMappedTrieMap(existing);
    else return new $d7ce42c300073b00$var$BuiltInMap(existing);
}
var $d7ce42c300073b00$var$Recoil_PersistentMap = {
    persistentMap: $d7ce42c300073b00$var$persistentMap
};
var $d7ce42c300073b00$var$Recoil_PersistentMap_1 = $d7ce42c300073b00$var$Recoil_PersistentMap.persistentMap;
var $d7ce42c300073b00$var$Recoil_PersistentMap$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    persistentMap: $d7ce42c300073b00$var$Recoil_PersistentMap_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */ function $d7ce42c300073b00$var$differenceSets(set) {
    for(var _len = arguments.length, setsWithValuesToRemove = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        setsWithValuesToRemove[_key - 1] = arguments[_key];
    }
    var ret = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        FIRST: for(var _iterator = set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = setsWithValuesToRemove[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var otherSet = _step1.value;
                    if (otherSet.has(value)) continue FIRST;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            ret.add(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ret;
}
var $d7ce42c300073b00$var$Recoil_differenceSets = $d7ce42c300073b00$var$differenceSets;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */ function $d7ce42c300073b00$var$mapMap(map, callback) {
    var result = new Map();
    map.forEach(function(value, key) {
        result.set(key, callback(value, key));
    });
    return result;
}
var $d7ce42c300073b00$var$Recoil_mapMap = $d7ce42c300073b00$var$mapMap;
function $d7ce42c300073b00$var$makeGraph() {
    return {
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map()
    };
}
function $d7ce42c300073b00$var$cloneGraph(graph) {
    return {
        nodeDeps: $d7ce42c300073b00$var$Recoil_mapMap(graph.nodeDeps, function(s) {
            return new Set(s);
        }),
        nodeToNodeSubscriptions: $d7ce42c300073b00$var$Recoil_mapMap(graph.nodeToNodeSubscriptions, function(s) {
            return new Set(s);
        })
    };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.
function $d7ce42c300073b00$var$mergeDepsIntoGraph(key, newDeps, graph, // graph compared with olderGraph:
olderGraph) {
    var nodeDeps = graph.nodeDeps, nodeToNodeSubscriptions = graph.nodeToNodeSubscriptions;
    var oldDeps = nodeDeps.get(key);
    if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) return;
     // Update nodeDeps:
    nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:
    var addedDeps = oldDeps == null ? newDeps : $d7ce42c300073b00$var$Recoil_differenceSets(newDeps, oldDeps);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = addedDeps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dep = _step.value;
            if (!nodeToNodeSubscriptions.has(dep)) nodeToNodeSubscriptions.set(dep, new Set());
            var existing = $d7ce42c300073b00$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
            existing.add(key);
        } // Remove removed deps from nodeToNodeSubscriptions:
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (oldDeps) {
        var removedDeps = $d7ce42c300073b00$var$Recoil_differenceSets(oldDeps, newDeps);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = removedDeps[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var dep1 = _step1.value;
                if (!nodeToNodeSubscriptions.has(dep1)) return;
                var existing1 = $d7ce42c300073b00$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep1));
                existing1["delete"](key);
                if (existing1.size === 0) nodeToNodeSubscriptions["delete"](dep1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
}
function $d7ce42c300073b00$var$saveDepsToStore(key, deps, store, version) {
    var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;
    var storeState = store.getState();
    if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $d7ce42c300073b00$var$Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
     // Merge the dependencies discovered into the store's dependency map
    // for the version that was read:
    var graph = store.getGraph(version);
    $d7ce42c300073b00$var$mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
    // into later versions if they don't already have their own:
    if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
        var currentGraph = store.getGraph(storeState.currentTree.version);
        $d7ce42c300073b00$var$mergeDepsIntoGraph(key, deps, currentGraph, graph);
    }
    if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
        var _storeState$nextTree2;
        var nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;
        if (nextVersion !== undefined) {
            var nextGraph = store.getGraph(nextVersion);
            $d7ce42c300073b00$var$mergeDepsIntoGraph(key, deps, nextGraph, graph);
        }
    }
}
var $d7ce42c300073b00$var$Recoil_Graph = {
    cloneGraph: $d7ce42c300073b00$var$cloneGraph,
    graph: $d7ce42c300073b00$var$makeGraph,
    saveDepsToStore: $d7ce42c300073b00$var$saveDepsToStore
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$nextTreeStateVersion = 0;
var $d7ce42c300073b00$var$getNextTreeStateVersion = function() {
    return $d7ce42c300073b00$var$nextTreeStateVersion++;
};
var $d7ce42c300073b00$var$nextStoreID = 0;
var $d7ce42c300073b00$var$getNextStoreID = function() {
    return $d7ce42c300073b00$var$nextStoreID++;
};
var $d7ce42c300073b00$var$nextComponentID = 0;
var $d7ce42c300073b00$var$getNextComponentID = function() {
    return $d7ce42c300073b00$var$nextComponentID++;
};
var $d7ce42c300073b00$var$Recoil_Keys = {
    getNextTreeStateVersion: $d7ce42c300073b00$var$getNextTreeStateVersion,
    getNextStoreID: $d7ce42c300073b00$var$getNextStoreID,
    getNextComponentID: $d7ce42c300073b00$var$getNextComponentID
};
var $d7ce42c300073b00$var$persistentMap$1 = $d7ce42c300073b00$var$Recoil_PersistentMap$1.persistentMap;
var $d7ce42c300073b00$var$graph = $d7ce42c300073b00$var$Recoil_Graph.graph;
var $d7ce42c300073b00$var$getNextTreeStateVersion$1 = $d7ce42c300073b00$var$Recoil_Keys.getNextTreeStateVersion;
function $d7ce42c300073b00$var$makeEmptyTreeState() {
    var version = $d7ce42c300073b00$var$getNextTreeStateVersion$1();
    return {
        version: version,
        stateID: version,
        transactionMetadata: {},
        dirtyAtoms: new Set(),
        atomValues: $d7ce42c300073b00$var$persistentMap$1(),
        nonvalidatedAtoms: $d7ce42c300073b00$var$persistentMap$1()
    };
}
function $d7ce42c300073b00$var$makeEmptyStoreState() {
    var currentTree = $d7ce42c300073b00$var$makeEmptyTreeState();
    return {
        currentTree: currentTree,
        nextTree: null,
        previousTree: null,
        commitDepth: 0,
        knownAtoms: new Set(),
        knownSelectors: new Set(),
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(currentTree.version, $d7ce42c300073b00$var$graph()),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        nodeCleanupFunctions: new Map()
    };
}
var $d7ce42c300073b00$var$Recoil_State = {
    makeEmptyTreeState: $d7ce42c300073b00$var$makeEmptyTreeState,
    makeEmptyStoreState: $d7ce42c300073b00$var$makeEmptyStoreState,
    getNextTreeStateVersion: $d7ce42c300073b00$var$getNextTreeStateVersion$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$RetentionZone = function RetentionZone() {
    "use strict";
    (0, $6WLcG._)(this, RetentionZone);
};
function $d7ce42c300073b00$var$retentionZone() {
    return new $d7ce42c300073b00$var$RetentionZone();
}
var $d7ce42c300073b00$var$Recoil_RetentionZone = {
    RetentionZone: $d7ce42c300073b00$var$RetentionZone,
    retentionZone: $d7ce42c300073b00$var$retentionZone
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$setByAddingToSet(set, v) {
    var next = new Set(set);
    next.add(v);
    return next;
}
function $d7ce42c300073b00$var$setByDeletingFromSet(set, v) {
    var next = new Set(set);
    next["delete"](v);
    return next;
}
function $d7ce42c300073b00$var$mapBySettingInMap(map, k, v) {
    var next = new Map(map);
    next.set(k, v);
    return next;
}
function $d7ce42c300073b00$var$mapByUpdatingInMap(map, k, updater) {
    var next = new Map(map);
    next.set(k, updater(next.get(k)));
    return next;
}
function $d7ce42c300073b00$var$mapByDeletingFromMap(map, k) {
    var next = new Map(map);
    next["delete"](k);
    return next;
}
function $d7ce42c300073b00$var$mapByDeletingMultipleFromMap(map, ks) {
    var next = new Map(map);
    ks.forEach(function(k) {
        return next["delete"](k);
    });
    return next;
}
var $d7ce42c300073b00$var$Recoil_CopyOnWrite = {
    setByAddingToSet: $d7ce42c300073b00$var$setByAddingToSet,
    setByDeletingFromSet: $d7ce42c300073b00$var$setByDeletingFromSet,
    mapBySettingInMap: $d7ce42c300073b00$var$mapBySettingInMap,
    mapByUpdatingInMap: $d7ce42c300073b00$var$mapByUpdatingInMap,
    mapByDeletingFromMap: $d7ce42c300073b00$var$mapByDeletingFromMap,
    mapByDeletingMultipleFromMap: $d7ce42c300073b00$var$mapByDeletingMultipleFromMap
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */ function $d7ce42c300073b00$var$filterIterable(iterable, predicate) {
    var index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, err;
    return (0, $dMrZK.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                // Use generator to create iterable/iterator
                index = 0;
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = iterable[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                value = _step.value;
                if (!predicate(value, index++)) return [
                    3,
                    4
                ];
                return [
                    4,
                    value
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
var $d7ce42c300073b00$var$Recoil_filterIterable = $d7ce42c300073b00$var$filterIterable;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */ // $FlowIssue[unclear-type]
function $d7ce42c300073b00$var$lazyProxy(base, factories) {
    var proxy = new Proxy(base, {
        // Compute and cache lazy property if not already done.
        get: function(target, prop) {
            if (!(prop in target) && prop in factories) target[prop] = factories[prop]();
            return target[prop];
        },
        // This method allows user to iterate keys as normal
        ownKeys: function(target) {
            return Object.keys(target);
        }
    }); // $FlowIssue[incompatible-return]
    return proxy;
}
var $d7ce42c300073b00$var$Recoil_lazyProxy = $d7ce42c300073b00$var$lazyProxy;
var $d7ce42c300073b00$var$getNode$1 = $d7ce42c300073b00$var$Recoil_Node.getNode, $d7ce42c300073b00$var$getNodeMaybe$1 = $d7ce42c300073b00$var$Recoil_Node.getNodeMaybe, $d7ce42c300073b00$var$recoilValuesForKeys$1 = $d7ce42c300073b00$var$Recoil_Node.recoilValuesForKeys;
var $d7ce42c300073b00$var$RetentionZone$1 = $d7ce42c300073b00$var$Recoil_RetentionZone.RetentionZone;
var $d7ce42c300073b00$var$setByAddingToSet$1 = $d7ce42c300073b00$var$Recoil_CopyOnWrite.setByAddingToSet;
// flowlint-next-line unclear-type:off
var $d7ce42c300073b00$var$emptySet = Object.freeze(new Set());
var $d7ce42c300073b00$var$ReadOnlyRecoilValueError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $a7G5R._)(ReadOnlyRecoilValueError, Error1);
    function ReadOnlyRecoilValueError() {
        (0, $6WLcG._)(this, ReadOnlyRecoilValueError);
        return (0, $bQby9._)(this, ReadOnlyRecoilValueError, arguments);
    }
    return ReadOnlyRecoilValueError;
}((0, $2DHfY._)(Error));
function $d7ce42c300073b00$var$initializeRetentionForNode(store, nodeKey, retainedBy) {
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return function() {
        return undefined;
    };
    var nodesRetainedByZone = store.getState().retention.nodesRetainedByZone;
    function addToZone(zone) {
        var set = nodesRetainedByZone.get(zone);
        if (!set) nodesRetainedByZone.set(zone, set = new Set());
        set.add(nodeKey);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (retainedBy instanceof $d7ce42c300073b00$var$RetentionZone$1) addToZone(retainedBy);
    else if (Array.isArray(retainedBy)) try {
        for(var _iterator = retainedBy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var zone = _step.value;
            addToZone(zone);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function() {
        var deleteFromZone = function deleteFromZone(zone) {
            var set = retention.nodesRetainedByZone.get(zone);
            set === null || set === void 0 || set["delete"](nodeKey);
            if (set && set.size === 0) retention.nodesRetainedByZone["delete"](zone);
        };
        if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
        var retention = store.getState().retention;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (retainedBy instanceof $d7ce42c300073b00$var$RetentionZone$1) deleteFromZone(retainedBy);
        else if (Array.isArray(retainedBy)) try {
            for(var _iterator = retainedBy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var zone = _step.value;
                deleteFromZone(zone);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $d7ce42c300073b00$var$initializeNodeIfNewToStore(store, treeState, key, trigger) {
    var storeState = store.getState();
    if (storeState.nodeCleanupFunctions.has(key)) return;
    var node = $d7ce42c300073b00$var$getNode$1(key);
    var retentionCleanup = $d7ce42c300073b00$var$initializeRetentionForNode(store, key, node.retainedBy);
    var nodeCleanup = node.init(store, treeState, trigger);
    storeState.nodeCleanupFunctions.set(key, function() {
        nodeCleanup();
        retentionCleanup();
    });
}
function $d7ce42c300073b00$var$initializeNode(store, key, trigger) {
    $d7ce42c300073b00$var$initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}
function $d7ce42c300073b00$var$cleanUpNode(store, key) {
    var _state$nodeCleanupFun;
    var state = store.getState();
    (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 || _state$nodeCleanupFun();
    state.nodeCleanupFunctions["delete"](key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.
function $d7ce42c300073b00$var$getNodeLoadable(store, state, key) {
    $d7ce42c300073b00$var$initializeNodeIfNewToStore(store, state, key, 'get');
    return $d7ce42c300073b00$var$getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change
function $d7ce42c300073b00$var$peekNodeLoadable(store, state, key) {
    return $d7ce42c300073b00$var$getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.
function $d7ce42c300073b00$var$setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
    var _node$invalidate;
    var node = $d7ce42c300073b00$var$getNodeMaybe$1(key);
    node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
    return (0, $7XD9P._)((0, $hRCmZ._)({}, state), {
        atomValues: state.atomValues.clone()["delete"](key),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
        dirtyAtoms: $d7ce42c300073b00$var$setByAddingToSet$1(state.dirtyAtoms, key)
    });
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)
function $d7ce42c300073b00$var$setNodeValue(store, state, key, newValue) {
    var node = $d7ce42c300073b00$var$getNode$1(key);
    if (node.set == null) throw new $d7ce42c300073b00$var$ReadOnlyRecoilValueError("Attempt to set read-only RecoilValue: ".concat(key));
    var set = node.set; // so flow doesn't lose the above refinement.
    $d7ce42c300073b00$var$initializeNodeIfNewToStore(store, state, key, 'set');
    return set(store, state, newValue);
}
function $d7ce42c300073b00$var$peekNodeInfo(store, state, key) {
    var storeState = store.getState();
    var graph = store.getGraph(state.version);
    var type = $d7ce42c300073b00$var$getNode$1(key).nodeType;
    return $d7ce42c300073b00$var$Recoil_lazyProxy({
        type: type
    }, {
        // $FlowFixMe[underconstrained-implicit-instantiation]
        loadable: function() {
            return $d7ce42c300073b00$var$peekNodeLoadable(store, state, key);
        },
        isActive: function() {
            return storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key);
        },
        isSet: function() {
            return type === 'selector' ? false : state.atomValues.has(key);
        },
        isModified: function() {
            return state.dirtyAtoms.has(key);
        },
        // Report current dependencies.  If the node hasn't been evaluated, then
        // dependencies may be missing based on the current state.
        deps: function() {
            var _graph$nodeDeps$get;
            return $d7ce42c300073b00$var$recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
        },
        // Reports all "current" subscribers.  Evaluating other nodes or
        // previous in-progress async evaluations may introduce new subscribers.
        subscribers: function() {
            var _storeState$nodeToCom, _storeState$nodeToCom2;
            return {
                nodes: $d7ce42c300073b00$var$recoilValuesForKeys$1($d7ce42c300073b00$var$Recoil_filterIterable($d7ce42c300073b00$var$getDownstreamNodes(store, state, new Set([
                    key
                ])), function(nodeKey) {
                    return nodeKey !== key;
                })),
                components: $d7ce42c300073b00$var$Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], function(param) {
                    var _param = (0, $6mdMa._)(param, 1), name = _param[0];
                    return {
                        name: name
                    };
                })
            };
        }
    });
} // Find all of the recursively dependent nodes
function $d7ce42c300073b00$var$getDownstreamNodes(store, state, keys) {
    var visitedNodes = new Set();
    var visitingNodes = Array.from(keys);
    var graph = store.getGraph(state.version);
    for(var key = visitingNodes.pop(); key; key = visitingNodes.pop()){
        var _graph$nodeToNodeSubs;
        visitedNodes.add(key);
        var subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : $d7ce42c300073b00$var$emptySet;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = subscribedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var downstreamNode = _step.value;
                if (!visitedNodes.has(downstreamNode)) visitingNodes.push(downstreamNode);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return visitedNodes;
}
var $d7ce42c300073b00$var$Recoil_FunctionalCore = {
    getNodeLoadable: $d7ce42c300073b00$var$getNodeLoadable,
    peekNodeLoadable: $d7ce42c300073b00$var$peekNodeLoadable,
    setNodeValue: $d7ce42c300073b00$var$setNodeValue,
    initializeNode: $d7ce42c300073b00$var$initializeNode,
    cleanUpNode: $d7ce42c300073b00$var$cleanUpNode,
    setUnvalidatedAtomValue_DEPRECATED: $d7ce42c300073b00$var$setUnvalidatedAtomValue_DEPRECATED,
    peekNodeInfo: $d7ce42c300073b00$var$peekNodeInfo,
    getDownstreamNodes: $d7ce42c300073b00$var$getDownstreamNodes
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$_invalidateMemoizedSnapshot = null;
function $d7ce42c300073b00$var$setInvalidateMemoizedSnapshot(invalidate) {
    $d7ce42c300073b00$var$_invalidateMemoizedSnapshot = invalidate;
}
function $d7ce42c300073b00$var$invalidateMemoizedSnapshot() {
    var _invalidateMemoizedSn;
    (_invalidateMemoizedSn = $d7ce42c300073b00$var$_invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 || _invalidateMemoizedSn();
}
var $d7ce42c300073b00$var$Recoil_SnapshotCache = {
    setInvalidateMemoizedSnapshot: $d7ce42c300073b00$var$setInvalidateMemoizedSnapshot,
    invalidateMemoizedSnapshot: $d7ce42c300073b00$var$invalidateMemoizedSnapshot
};
var $d7ce42c300073b00$var$getDownstreamNodes$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.getDownstreamNodes, $d7ce42c300073b00$var$getNodeLoadable$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.getNodeLoadable, $d7ce42c300073b00$var$setNodeValue$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.setNodeValue;
var $d7ce42c300073b00$var$getNextComponentID$1 = $d7ce42c300073b00$var$Recoil_Keys.getNextComponentID;
var $d7ce42c300073b00$var$getNode$2 = $d7ce42c300073b00$var$Recoil_Node.getNode, $d7ce42c300073b00$var$getNodeMaybe$2 = $d7ce42c300073b00$var$Recoil_Node.getNodeMaybe;
var $d7ce42c300073b00$var$DefaultValue$1 = $d7ce42c300073b00$var$Recoil_Node.DefaultValue;
var $d7ce42c300073b00$var$reactMode$1 = $d7ce42c300073b00$var$Recoil_ReactMode.reactMode;
var $d7ce42c300073b00$var$AbstractRecoilValue$1 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.AbstractRecoilValue, $d7ce42c300073b00$var$RecoilState$1 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.RecoilState, $d7ce42c300073b00$var$RecoilValueReadOnly$1 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.RecoilValueReadOnly, $d7ce42c300073b00$var$isRecoilValue$1 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.isRecoilValue;
var $d7ce42c300073b00$var$invalidateMemoizedSnapshot$1 = $d7ce42c300073b00$var$Recoil_SnapshotCache.invalidateMemoizedSnapshot;
function $d7ce42c300073b00$var$getRecoilValueAsLoadable(store, param) {
    var key = param.key, treeState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : store.getState().currentTree;
    var _storeState$nextTree, _storeState$previousT;
    // Reading from an older tree can cause bugs because the dependencies that we
    // discover during the read are lost.
    var storeState = store.getState();
    if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $d7ce42c300073b00$var$Recoil_recoverableViolation('Tried to read from a discarded tree');
    var loadable = $d7ce42c300073b00$var$getNodeLoadable$1(store, treeState, key);
    if (loadable.state === 'loading') loadable.contents["catch"](function() {
        /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */ return;
    });
    return loadable;
}
function $d7ce42c300073b00$var$applyAtomValueWrites(atomValues, writes) {
    var result = atomValues.clone();
    writes.forEach(function(v, k) {
        if (v.state === 'hasValue' && v.contents instanceof $d7ce42c300073b00$var$DefaultValue$1) result["delete"](k);
        else result.set(k, v);
    });
    return result;
}
function $d7ce42c300073b00$var$valueFromValueOrUpdater(store, state, param, valueOrUpdater) {
    var key = param.key;
    if (typeof valueOrUpdater === 'function') {
        // Updater form: pass in the current value. Throw if the current value
        // is unavailable (namely when updating an async selector that's
        // pending or errored):
        var current = $d7ce42c300073b00$var$getNodeLoadable$1(store, state, key);
        if (current.state === 'loading') {
            var msg = 'Tried to set atom or selector "'.concat(key, '" using an updater function while the current state is pending, this is not currently supported.');
            $d7ce42c300073b00$var$Recoil_recoverableViolation(msg);
            throw $d7ce42c300073b00$var$Recoil_err(msg);
        } else if (current.state === 'hasError') throw current.contents;
         // T itself may be a function, so our refinement is not sufficient:
        return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
    } else return valueOrUpdater;
}
function $d7ce42c300073b00$var$applyAction(store, state, action) {
    if (action.type === 'set') {
        var recoilValue = action.recoilValue, valueOrUpdater = action.valueOrUpdater;
        var newValue = $d7ce42c300073b00$var$valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
        var writes = $d7ce42c300073b00$var$setNodeValue$1(store, state, recoilValue.key, newValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = writes.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6mdMa._)(_step.value, 2), key = _step_value[0], loadable = _step_value[1];
                $d7ce42c300073b00$var$writeLoadableToTreeState(state, key, loadable);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (action.type === 'setLoadable') {
        var key1 = action.recoilValue.key, loadable1 = action.loadable;
        $d7ce42c300073b00$var$writeLoadableToTreeState(state, key1, loadable1);
    } else if (action.type === 'markModified') {
        var key2 = action.recoilValue.key;
        state.dirtyAtoms.add(key2);
    } else if (action.type === 'setUnvalidated') {
        var _node$invalidate;
        // Write value directly to state bypassing the Node interface as the node
        // definitions may not have been loaded yet when processing the initial snapshot.
        var key3 = action.recoilValue.key, unvalidatedValue = action.unvalidatedValue;
        var node = $d7ce42c300073b00$var$getNodeMaybe$2(key3);
        node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
        state.atomValues["delete"](key3);
        state.nonvalidatedAtoms.set(key3, unvalidatedValue);
        state.dirtyAtoms.add(key3);
    } else $d7ce42c300073b00$var$Recoil_recoverableViolation("Unknown action ".concat(action.type));
}
function $d7ce42c300073b00$var$writeLoadableToTreeState(state, key, loadable) {
    if (loadable.state === 'hasValue' && loadable.contents instanceof $d7ce42c300073b00$var$DefaultValue$1) state.atomValues["delete"](key);
    else state.atomValues.set(key, loadable);
    state.dirtyAtoms.add(key);
    state.nonvalidatedAtoms["delete"](key);
}
function $d7ce42c300073b00$var$applyActionsToStore(store, actions) {
    store.replaceState(function(state) {
        var newState = $d7ce42c300073b00$var$copyTreeState(state);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var action = _step.value;
                $d7ce42c300073b00$var$applyAction(store, newState, action);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        $d7ce42c300073b00$var$invalidateDownstreams(store, newState);
        $d7ce42c300073b00$var$invalidateMemoizedSnapshot$1();
        return newState;
    });
}
function $d7ce42c300073b00$var$queueOrPerformStateUpdate(store, action) {
    if ($d7ce42c300073b00$var$batchStack.length) {
        var actionsByStore = $d7ce42c300073b00$var$batchStack[$d7ce42c300073b00$var$batchStack.length - 1];
        var actions = actionsByStore.get(store);
        if (!actions) actionsByStore.set(store, actions = []);
        actions.push(action);
    } else $d7ce42c300073b00$var$applyActionsToStore(store, [
        action
    ]);
}
var $d7ce42c300073b00$var$batchStack = [];
function $d7ce42c300073b00$var$batchStart() {
    var actionsByStore = new Map();
    $d7ce42c300073b00$var$batchStack.push(actionsByStore);
    return function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = actionsByStore[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6mdMa._)(_step.value, 2), store = _step_value[0], actions = _step_value[1];
                $d7ce42c300073b00$var$applyActionsToStore(store, actions);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var popped = $d7ce42c300073b00$var$batchStack.pop();
        if (popped !== actionsByStore) $d7ce42c300073b00$var$Recoil_recoverableViolation('Incorrect order of batch popping');
    };
}
function $d7ce42c300073b00$var$copyTreeState(state) {
    return (0, $7XD9P._)((0, $hRCmZ._)({}, state), {
        atomValues: state.atomValues.clone(),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
        dirtyAtoms: new Set(state.dirtyAtoms)
    });
}
function $d7ce42c300073b00$var$invalidateDownstreams(store, state) {
    // Inform any nodes that were changed or downstream of changes so that they
    // can clear out any caches as needed due to the update:
    var downstreams = $d7ce42c300073b00$var$getDownstreamNodes$1(store, state, state.dirtyAtoms);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = downstreams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var _getNodeMaybe, _getNodeMaybe$invalid;
            (_getNodeMaybe = $d7ce42c300073b00$var$getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 || (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 || _getNodeMaybe$invalid.call(_getNodeMaybe, state);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $d7ce42c300073b00$var$setRecoilValue(store, recoilValue, valueOrUpdater) {
    $d7ce42c300073b00$var$queueOrPerformStateUpdate(store, {
        type: 'set',
        recoilValue: recoilValue,
        valueOrUpdater: valueOrUpdater
    });
}
function $d7ce42c300073b00$var$setRecoilValueLoadable(store, recoilValue, loadable) {
    if (loadable instanceof $d7ce42c300073b00$var$DefaultValue$1) return $d7ce42c300073b00$var$setRecoilValue(store, recoilValue, loadable);
    $d7ce42c300073b00$var$queueOrPerformStateUpdate(store, {
        type: 'setLoadable',
        recoilValue: recoilValue,
        loadable: loadable
    });
}
function $d7ce42c300073b00$var$markRecoilValueModified(store, recoilValue) {
    $d7ce42c300073b00$var$queueOrPerformStateUpdate(store, {
        type: 'markModified',
        recoilValue: recoilValue
    });
}
function $d7ce42c300073b00$var$setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
    $d7ce42c300073b00$var$queueOrPerformStateUpdate(store, {
        type: 'setUnvalidated',
        recoilValue: recoilValue,
        unvalidatedValue: unvalidatedValue
    });
}
function $d7ce42c300073b00$var$subscribeToRecoilValue(store, param, callback) {
    var key = param.key, componentDebugName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var subID = $d7ce42c300073b00$var$getNextComponentID$1();
    var storeState = store.getState();
    if (!storeState.nodeToComponentSubscriptions.has(key)) storeState.nodeToComponentSubscriptions.set(key, new Map());
    $d7ce42c300073b00$var$Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [
        componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>',
        callback
    ]); // Handle the case that, during the same tick that we are subscribing, an atom
    // has been updated by some effect handler. Otherwise we will miss the update.
    var mode = $d7ce42c300073b00$var$reactMode$1();
    if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
        var nextTree = store.getState().nextTree;
        if (nextTree && nextTree.dirtyAtoms.has(key)) callback(nextTree);
    }
    return {
        release: function() {
            var releaseStoreState = store.getState();
            var subs = releaseStoreState.nodeToComponentSubscriptions.get(key);
            if (subs === undefined || !subs.has(subID)) {
                $d7ce42c300073b00$var$Recoil_recoverableViolation("Subscription missing at release time for atom ".concat(key, ". This is a bug in Recoil."));
                return;
            }
            subs["delete"](subID);
            if (subs.size === 0) releaseStoreState.nodeToComponentSubscriptions["delete"](key);
        }
    };
}
function $d7ce42c300073b00$var$refreshRecoilValue(store, recoilValue) {
    var _node$clearCache;
    var currentTree = store.getState().currentTree;
    var node = $d7ce42c300073b00$var$getNode$2(recoilValue.key);
    (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, currentTree);
}
var $d7ce42c300073b00$var$Recoil_RecoilValueInterface = {
    RecoilValueReadOnly: $d7ce42c300073b00$var$RecoilValueReadOnly$1,
    AbstractRecoilValue: $d7ce42c300073b00$var$AbstractRecoilValue$1,
    RecoilState: $d7ce42c300073b00$var$RecoilState$1,
    getRecoilValueAsLoadable: $d7ce42c300073b00$var$getRecoilValueAsLoadable,
    setRecoilValue: $d7ce42c300073b00$var$setRecoilValue,
    setRecoilValueLoadable: $d7ce42c300073b00$var$setRecoilValueLoadable,
    markRecoilValueModified: $d7ce42c300073b00$var$markRecoilValueModified,
    setUnvalidatedRecoilValue: $d7ce42c300073b00$var$setUnvalidatedRecoilValue,
    subscribeToRecoilValue: $d7ce42c300073b00$var$subscribeToRecoilValue,
    isRecoilValue: $d7ce42c300073b00$var$isRecoilValue$1,
    applyAtomValueWrites: $d7ce42c300073b00$var$applyAtomValueWrites,
    // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
    batchStart: $d7ce42c300073b00$var$batchStart,
    writeLoadableToTreeState: $d7ce42c300073b00$var$writeLoadableToTreeState,
    invalidateDownstreams: $d7ce42c300073b00$var$invalidateDownstreams,
    copyTreeState: $d7ce42c300073b00$var$copyTreeState,
    refreshRecoilValue: $d7ce42c300073b00$var$refreshRecoilValue
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */ function $d7ce42c300073b00$var$someSet(set, callback, context) {
    var iterator = set.entries();
    var current = iterator.next();
    while(!current.done){
        var entry = current.value;
        if (callback.call(context, entry[1], entry[0], set)) return true;
        current = iterator.next();
    }
    return false;
}
var $d7ce42c300073b00$var$Recoil_someSet = $d7ce42c300073b00$var$someSet;
var $d7ce42c300073b00$var$cleanUpNode$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.cleanUpNode;
var $d7ce42c300073b00$var$deleteNodeConfigIfPossible$1 = $d7ce42c300073b00$var$Recoil_Node.deleteNodeConfigIfPossible, $d7ce42c300073b00$var$getNode$3 = $d7ce42c300073b00$var$Recoil_Node.getNode;
var $d7ce42c300073b00$var$RetentionZone$2 = $d7ce42c300073b00$var$Recoil_RetentionZone.RetentionZone;
// Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.
var $d7ce42c300073b00$var$SUSPENSE_TIMEOUT_MS = 120000;
var $d7ce42c300073b00$var$emptySet$1 = new Set();
function $d7ce42c300073b00$var$releaseRetainablesNowOnCurrentTree(store, retainables) {
    var storeState = store.getState();
    var treeState = storeState.currentTree;
    if (storeState.nextTree) {
        $d7ce42c300073b00$var$Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
        return; // leak memory rather than erase something that's about to be used.
    }
    var nodes = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = retainables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (r instanceof $d7ce42c300073b00$var$RetentionZone$2) try {
                for(var _iterator1 = $d7ce42c300073b00$var$nodesRetainedByZone(storeState, r)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var n = _step1.value;
                    nodes.add(n);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            else nodes.add(r);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var releasableNodes = $d7ce42c300073b00$var$findReleasableNodes(store, nodes);
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = releasableNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var node = _step2.value;
            $d7ce42c300073b00$var$releaseNode(store, treeState, node);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
function $d7ce42c300073b00$var$findReleasableNodes(store, searchFromNodes) {
    var storeState = store.getState();
    var treeState = storeState.currentTree;
    var graph = store.getGraph(treeState.version);
    var releasableNodes = new Set(); // mutated to collect answer
    var nonReleasableNodes = new Set();
    findReleasableNodesInner(searchFromNodes);
    return releasableNodes;
    function findReleasableNodesInner(searchFromNodes) {
        var releasableNodesFoundThisIteration = new Set();
        var downstreams = $d7ce42c300073b00$var$getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, nonReleasableNodes // don't descend into these
        ); // Find which of the downstream nodes are releasable and which are not:
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = downstreams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                var _storeState$retention;
                // Not releasable if configured to be retained forever:
                if ($d7ce42c300073b00$var$getNode$3(node).retainedBy === 'recoilRoot') {
                    nonReleasableNodes.add(node);
                    continue;
                } // Not releasable if retained directly by a component:
                if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
                    nonReleasableNodes.add(node);
                    continue;
                } // Not releasable if retained by a zone:
                if ($d7ce42c300073b00$var$zonesThatCouldRetainNode(node).some(function(z) {
                    return storeState.retention.referenceCounts.get(z);
                })) {
                    nonReleasableNodes.add(node);
                    continue;
                } // Not releasable if it has a non-releasable child (which will already be in
                // nonReleasableNodes because we are going in topological order):
                var nodeChildren = graph.nodeToNodeSubscriptions.get(node);
                if (nodeChildren && $d7ce42c300073b00$var$Recoil_someSet(nodeChildren, function(child) {
                    return nonReleasableNodes.has(child);
                })) {
                    nonReleasableNodes.add(node);
                    continue;
                }
                releasableNodes.add(node);
                releasableNodesFoundThisIteration.add(node);
            } // If we found any releasable nodes, we need to walk UP from those nodes to
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // find whether their parents can now be released as well:
        var parents = new Set();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator1 = releasableNodesFoundThisIteration[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                var node1 = _step1.value;
                try {
                    for(var _iterator2 = ((_graph$nodeDeps$get = graph.nodeDeps.get(node1)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : $d7ce42c300073b00$var$emptySet$1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                        var parent = _step2.value;
                        var _graph$nodeDeps$get;
                        if (!releasableNodes.has(parent)) parents.add(parent);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator2["return"] != null) {
                            _iterator2["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        if (parents.size) findReleasableNodesInner(parents);
    }
} // Children before parents
function $d7ce42c300073b00$var$getDownstreamNodesInTopologicalOrder(store, treeState, nodes, doNotDescendInto1, doNotDescendInto2) {
    var graph = store.getGraph(treeState.version);
    var answer = [];
    var visited = new Set();
    while(nodes.size > 0)visit($d7ce42c300073b00$var$Recoil_nullthrows(nodes.values().next().value));
    return answer;
    function visit(node) {
        if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
            nodes["delete"](node);
            return;
        }
        if (visited.has(node)) return;
        var children = graph.nodeToNodeSubscriptions.get(node);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (children) try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                visit(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        visited.add(node);
        nodes["delete"](node);
        answer.push(node);
    }
}
function $d7ce42c300073b00$var$releaseNode(store, treeState, node) {
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
     // Atom effects, in-closure caches, etc.:
    $d7ce42c300073b00$var$cleanUpNode$1(store, node); // Delete from store state:
    var storeState = store.getState();
    storeState.knownAtoms["delete"](node);
    storeState.knownSelectors["delete"](node);
    storeState.nodeTransactionSubscriptions["delete"](node);
    storeState.retention.referenceCounts["delete"](node);
    var zones = $d7ce42c300073b00$var$zonesThatCouldRetainNode(node);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = zones[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var zone = _step.value;
            var _storeState$retention2;
            (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 || _storeState$retention2["delete"](node);
        } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // already happens when the last component that was retaining the node unmounts,
    // and this could happen either before or after that.
    // Delete from TreeState and dep graph:
    treeState.atomValues["delete"](node);
    treeState.dirtyAtoms["delete"](node);
    treeState.nonvalidatedAtoms["delete"](node);
    var graph = storeState.graphsByVersion.get(treeState.version);
    if (graph) {
        var deps = graph.nodeDeps.get(node);
        if (deps !== undefined) {
            graph.nodeDeps["delete"](node);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = deps[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var dep = _step1.value;
                    var _graph$nodeToNodeSubs;
                    (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 || _graph$nodeToNodeSubs["delete"](node);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        } // No need to delete sub's deps as there should be no subs at this point.
        // But an invariant would require deleting nodes in topological order.
        graph.nodeToNodeSubscriptions["delete"](node);
    } // Node config (for family members only as their configs can be recreated, and
    // only if they are not retained within any other Stores):
    $d7ce42c300073b00$var$deleteNodeConfigIfPossible$1(node);
}
function $d7ce42c300073b00$var$nodesRetainedByZone(storeState, zone) {
    var _storeState$retention3;
    return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : $d7ce42c300073b00$var$emptySet$1;
}
function $d7ce42c300073b00$var$zonesThatCouldRetainNode(node) {
    var retainedBy = $d7ce42c300073b00$var$getNode$3(node).retainedBy;
    if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') return [];
    else if (retainedBy instanceof $d7ce42c300073b00$var$RetentionZone$2) return [
        retainedBy
    ];
    else return retainedBy; // it's an array of zones
}
function $d7ce42c300073b00$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
    var state = store.getState();
    if (state.nextTree) state.retention.retainablesToCheckForRelease.add(retainable);
    else $d7ce42c300073b00$var$releaseRetainablesNowOnCurrentTree(store, new Set([
        retainable
    ]));
}
function $d7ce42c300073b00$var$updateRetainCount(store, retainable, delta) {
    var _map$get;
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    var map = store.getState().retention.referenceCounts;
    var newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;
    if (newCount === 0) $d7ce42c300073b00$var$updateRetainCountToZero(store, retainable);
    else map.set(retainable, newCount);
}
function $d7ce42c300073b00$var$updateRetainCountToZero(store, retainable) {
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    var map = store.getState().retention.referenceCounts;
    map["delete"](retainable);
    $d7ce42c300073b00$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}
function $d7ce42c300073b00$var$releaseScheduledRetainablesNow(store) {
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    var state = store.getState();
    $d7ce42c300073b00$var$releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
    state.retention.retainablesToCheckForRelease.clear();
}
function $d7ce42c300073b00$var$retainedByOptionWithDefault(r) {
    // The default will change from 'recoilRoot' to 'components' in the future.
    return r === undefined ? 'recoilRoot' : r;
}
var $d7ce42c300073b00$var$Recoil_Retention = {
    SUSPENSE_TIMEOUT_MS: $d7ce42c300073b00$var$SUSPENSE_TIMEOUT_MS,
    updateRetainCount: $d7ce42c300073b00$var$updateRetainCount,
    updateRetainCountToZero: $d7ce42c300073b00$var$updateRetainCountToZero,
    releaseScheduledRetainablesNow: $d7ce42c300073b00$var$releaseScheduledRetainablesNow,
    retainedByOptionWithDefault: $d7ce42c300073b00$var$retainedByOptionWithDefault
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$unstable_batchedUpdates = (0, (/*@__PURE__*/$parcel$interopDefault($0048b1b41b30e47d$exports))).unstable_batchedUpdates;
var $d7ce42c300073b00$var$ReactBatchedUpdates = {
    unstable_batchedUpdates: $d7ce42c300073b00$var$unstable_batchedUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ // @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
var $d7ce42c300073b00$var$unstable_batchedUpdates$1 = $d7ce42c300073b00$var$ReactBatchedUpdates.unstable_batchedUpdates; // @oss-only
var $d7ce42c300073b00$var$Recoil_ReactBatchedUpdates = {
    unstable_batchedUpdates: $d7ce42c300073b00$var$unstable_batchedUpdates$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$batchStart$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.batchStart;
var $d7ce42c300073b00$var$unstable_batchedUpdates$2 = $d7ce42c300073b00$var$Recoil_ReactBatchedUpdates.unstable_batchedUpdates; // flowlint-next-line unclear-type:off
/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */ var $d7ce42c300073b00$var$batcher = $d7ce42c300073b00$var$unstable_batchedUpdates$2 || function(batchFn) {
    return batchFn();
};
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */ var $d7ce42c300073b00$var$setBatcher = function(newBatcher) {
    $d7ce42c300073b00$var$batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */ var $d7ce42c300073b00$var$getBatcher = function() {
    return $d7ce42c300073b00$var$batcher;
};
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */ var $d7ce42c300073b00$var$batchUpdates = function(callback) {
    $d7ce42c300073b00$var$batcher(function() {
        var batchEnd = function() {
            return undefined;
        };
        try {
            batchEnd = $d7ce42c300073b00$var$batchStart$1();
            callback();
        } finally{
            batchEnd();
        }
    });
};
var $d7ce42c300073b00$var$Recoil_Batching = {
    getBatcher: $d7ce42c300073b00$var$getBatcher,
    setBatcher: $d7ce42c300073b00$var$setBatcher,
    batchUpdates: $d7ce42c300073b00$var$batchUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */ function $d7ce42c300073b00$var$concatIterables(iters) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator, _step, iter, _iterator1, _step1, val, err, err;
    return (0, $dMrZK.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    12,
                    13,
                    14
                ]);
                _iterator = iters[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion1 = (_step = _iterator.next()).done)) return [
                    3,
                    11
                ];
                iter = _step.value;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator1 = iter[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                    3,
                    7
                ];
                val = _step1.value;
                return [
                    4,
                    val
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    2
                ];
            case 11:
                return [
                    3,
                    14
                ];
            case 12:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    14
                ];
            case 13:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
var $d7ce42c300073b00$var$Recoil_concatIterables = $d7ce42c300073b00$var$concatIterables;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /* eslint-disable fb-www/typeof-undefined */ var $d7ce42c300073b00$var$isSSR = typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */ var $d7ce42c300073b00$var$isWindow = function(value) {
    return !$d7ce42c300073b00$var$isSSR && (value === window || value instanceof Window);
};
var $d7ce42c300073b00$var$isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined
var $d7ce42c300073b00$var$Recoil_Environment = {
    isSSR: $d7ce42c300073b00$var$isSSR,
    isReactNative: $d7ce42c300073b00$var$isReactNative,
    isWindow: $d7ce42c300073b00$var$isWindow
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */ function $d7ce42c300073b00$var$memoizeWithArgsHash(fn, hashFunction) {
    var cache;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!cache) cache = {};
        var key = hashFunction.apply(void 0, (0, $bOqL7._)(args));
        if (!Object.hasOwnProperty.call(cache, key)) cache[key] = fn.apply(void 0, (0, $bOqL7._)(args));
        return cache[key];
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $d7ce42c300073b00$var$memoizeOneWithArgsHash(fn, hashFunction) {
    var lastKey;
    var lastResult; // breaking cache when arguments change
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var key = hashFunction.apply(void 0, (0, $bOqL7._)(args));
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn.apply(void 0, (0, $bOqL7._)(args));
        return lastResult;
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $d7ce42c300073b00$var$memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
    var lastKey;
    var lastResult; // breaking cache when arguments change
    var memoizedFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var key = hashFunction.apply(void 0, (0, $bOqL7._)(args));
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn.apply(void 0, (0, $bOqL7._)(args));
        return lastResult;
    };
    var invalidate = function() {
        lastKey = null;
    };
    return [
        memoizedFn,
        invalidate
    ];
}
var $d7ce42c300073b00$var$Recoil_Memoize = {
    memoizeWithArgsHash: $d7ce42c300073b00$var$memoizeWithArgsHash,
    memoizeOneWithArgsHash: $d7ce42c300073b00$var$memoizeOneWithArgsHash,
    memoizeOneWithArgsHashAndInvalidation: $d7ce42c300073b00$var$memoizeOneWithArgsHashAndInvalidation
};
var $d7ce42c300073b00$var$batchUpdates$1 = $d7ce42c300073b00$var$Recoil_Batching.batchUpdates;
var $d7ce42c300073b00$var$initializeNode$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.initializeNode, $d7ce42c300073b00$var$peekNodeInfo$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.peekNodeInfo;
var $d7ce42c300073b00$var$graph$1 = $d7ce42c300073b00$var$Recoil_Graph.graph;
var $d7ce42c300073b00$var$getNextStoreID$1 = $d7ce42c300073b00$var$Recoil_Keys.getNextStoreID;
var $d7ce42c300073b00$var$DEFAULT_VALUE$1 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE, $d7ce42c300073b00$var$recoilValues$1 = $d7ce42c300073b00$var$Recoil_Node.recoilValues, $d7ce42c300073b00$var$recoilValuesForKeys$2 = $d7ce42c300073b00$var$Recoil_Node.recoilValuesForKeys;
var $d7ce42c300073b00$var$AbstractRecoilValue$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.AbstractRecoilValue, $d7ce42c300073b00$var$getRecoilValueAsLoadable$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.getRecoilValueAsLoadable, $d7ce42c300073b00$var$setRecoilValue$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setRecoilValue, $d7ce42c300073b00$var$setUnvalidatedRecoilValue$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setUnvalidatedRecoilValue;
var $d7ce42c300073b00$var$updateRetainCount$1 = $d7ce42c300073b00$var$Recoil_Retention.updateRetainCount;
var $d7ce42c300073b00$var$setInvalidateMemoizedSnapshot$1 = $d7ce42c300073b00$var$Recoil_SnapshotCache.setInvalidateMemoizedSnapshot;
var $d7ce42c300073b00$var$getNextTreeStateVersion$2 = $d7ce42c300073b00$var$Recoil_State.getNextTreeStateVersion, $d7ce42c300073b00$var$makeEmptyStoreState$1 = $d7ce42c300073b00$var$Recoil_State.makeEmptyStoreState;
var $d7ce42c300073b00$var$isSSR$1 = $d7ce42c300073b00$var$Recoil_Environment.isSSR;
var $d7ce42c300073b00$var$memoizeOneWithArgsHashAndInvalidation$1 = $d7ce42c300073b00$var$Recoil_Memoize.memoizeOneWithArgsHashAndInvalidation;
// Opaque at this surface because it's part of the public API from here.
var $d7ce42c300073b00$var$retainWarning = "\nRecoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:\n\n  const release = snapshot.retain();\n  try {\n    await doSomethingWithSnapshot(snapshot);\n  } finally {\n    release();\n  }\n\nThis is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.\n"; // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.
var $d7ce42c300073b00$var$Snapshot = /*#__PURE__*/ function() {
    "use strict";
    function Snapshot(storeState, parentStoreID) {
        var _this = this;
        (0, $6WLcG._)(this, Snapshot);
        $d7ce42c300073b00$var$_defineProperty(this, "_store", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_refCount", 1);
        $d7ce42c300073b00$var$_defineProperty(this, "getLoadable", function(recoilValue) {
            _this.checkRefCount_INTERNAL();
            return $d7ce42c300073b00$var$getRecoilValueAsLoadable$1(_this._store, recoilValue);
        });
        $d7ce42c300073b00$var$_defineProperty(this, "getPromise", function(recoilValue) {
            _this.checkRefCount_INTERNAL();
            return _this.getLoadable(recoilValue).toPromise();
        });
        $d7ce42c300073b00$var$_defineProperty(this, "getNodes_UNSTABLE", function(opt) {
            _this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors
            if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
                if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) return [];
                var state = _this._store.getState().currentTree;
                return $d7ce42c300073b00$var$recoilValuesForKeys$2(state.dirtyAtoms);
            }
            var knownAtoms = _this._store.getState().knownAtoms;
            var knownSelectors = _this._store.getState().knownSelectors;
            return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? $d7ce42c300073b00$var$recoilValues$1.values() : opt.isInitialized === true ? $d7ce42c300073b00$var$recoilValuesForKeys$2($d7ce42c300073b00$var$Recoil_concatIterables([
                knownAtoms,
                knownSelectors
            ])) : $d7ce42c300073b00$var$Recoil_filterIterable($d7ce42c300073b00$var$recoilValues$1.values(), function(param) {
                var key = param.key;
                return !knownAtoms.has(key) && !knownSelectors.has(key);
            });
        });
        $d7ce42c300073b00$var$_defineProperty(this, "getInfo_UNSTABLE", function(param) {
            var key = param.key;
            _this.checkRefCount_INTERNAL();
            return $d7ce42c300073b00$var$peekNodeInfo$1(_this._store, _this._store.getState().currentTree, key);
        });
        $d7ce42c300073b00$var$_defineProperty(this, "map", function(mapper) {
            _this.checkRefCount_INTERNAL();
            var mutableSnapshot = new $d7ce42c300073b00$var$MutableSnapshot(_this, $d7ce42c300073b00$var$batchUpdates$1);
            mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here
            return mutableSnapshot;
        });
        $d7ce42c300073b00$var$_defineProperty(this, "asyncMap", function(mapper) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var mutableSnapshot;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this.checkRefCount_INTERNAL();
                            mutableSnapshot = new $d7ce42c300073b00$var$MutableSnapshot(this, $d7ce42c300073b00$var$batchUpdates$1);
                            mutableSnapshot.retain(); // Retain new snapshot during async mapper
                            return [
                                4,
                                mapper(mutableSnapshot)
                            ];
                        case 1:
                            _state.sent(); // Continue to retain the new snapshot for the user, but auto-release it
                            // after the next tick, the same as a new synchronous snapshot.
                            mutableSnapshot.autoRelease_INTERNAL();
                            return [
                                2,
                                mutableSnapshot
                            ];
                    }
                });
            }).call(_this);
        });
        this._store = {
            storeID: $d7ce42c300073b00$var$getNextStoreID$1(),
            parentStoreID: parentStoreID,
            getState: function() {
                return storeState;
            },
            replaceState: function(replacer) {
                // no batching, so nextTree is never active
                storeState.currentTree = replacer(storeState.currentTree);
            },
            getGraph: function(version) {
                var graphs = storeState.graphsByVersion;
                if (graphs.has(version)) return $d7ce42c300073b00$var$Recoil_nullthrows(graphs.get(version));
                var newGraph = $d7ce42c300073b00$var$graph$1();
                graphs.set(version, newGraph);
                return newGraph;
            },
            subscribeToTransactions: function() {
                return {
                    release: function() {}
                };
            },
            addTransactionMetadata: function() {
                throw $d7ce42c300073b00$var$Recoil_err('Cannot subscribe to Snapshots');
            }
        }; // Initialize any nodes that are live in the parent store (primarily so that
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // this snapshot gets counted towards the node's live stores count).
            // TODO Optimize this when cloning snapshots for callbacks
            for(var _iterator = this._store.getState().knownAtoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var nodeKey = _step.value;
                $d7ce42c300073b00$var$initializeNode$1(this._store, nodeKey, 'get');
                $d7ce42c300073b00$var$updateRetainCount$1(this._store, nodeKey, 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.autoRelease_INTERNAL();
    }
    (0, $dbIwN._)(Snapshot, [
        {
            key: "retain",
            value: function retain() {
                var _this = this;
                if (this._refCount <= 0) $d7ce42c300073b00$var$Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
                this._refCount++;
                var released = false;
                return function() {
                    if (!released) {
                        released = true;
                        _this._release();
                    }
                };
            }
        },
        {
            /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */ key: "autoRelease_INTERNAL",
            value: function autoRelease_INTERNAL() {
                var _this = this;
                if (!$d7ce42c300073b00$var$isSSR$1) // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
                window.setTimeout(function() {
                    return _this._release();
                }, 10);
            }
        },
        {
            key: "_release",
            value: function _release() {
                this._refCount--;
                if (this._refCount === 0) {
                    this._store.getState().nodeCleanupFunctions.forEach(function(cleanup) {
                        return cleanup();
                    });
                    this._store.getState().nodeCleanupFunctions.clear();
                    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
                     // Temporarily nerfing this to allow us to find broken call sites without
                // actually breaking anybody yet.
                // for (const k of this._store.getState().knownAtoms) {
                //   updateRetainCountToZero(this._store, k);
                // }
                } else this._refCount;
            }
        },
        {
            key: "isRetained",
            value: function isRetained() {
                return this._refCount > 0;
            }
        },
        {
            key: "checkRefCount_INTERNAL",
            value: function checkRefCount_INTERNAL() {
                $d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020') && this._refCount;
            }
        },
        {
            key: "getStore_INTERNAL",
            value: function getStore_INTERNAL() {
                this.checkRefCount_INTERNAL();
                return this._store;
            }
        },
        {
            key: "getID",
            value: function getID() {
                this.checkRefCount_INTERNAL();
                return this._store.getState().currentTree.stateID;
            }
        },
        {
            key: "getStoreID",
            value: function getStoreID() {
                this.checkRefCount_INTERNAL();
                return this._store.storeID;
            } // We want to allow the methods to be destructured and used as accessors
        }
    ]);
    return Snapshot;
}();
function $d7ce42c300073b00$var$cloneStoreState(store, treeState) {
    var bumpVersion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var storeState = store.getState();
    var version = bumpVersion ? $d7ce42c300073b00$var$getNextTreeStateVersion$2() : treeState.version;
    return {
        // Always clone the TreeState to isolate stores from accidental mutations.
        // For example, reading a selector from a cloned snapshot shouldn't cache
        // in the original treestate which may cause the original to skip
        // initialization of upstream atoms.
        currentTree: {
            // TODO snapshots shouldn't really have versions because a new version number
            // is always assigned when the snapshot is gone to.
            version: bumpVersion ? version : treeState.version,
            stateID: bumpVersion ? version : treeState.stateID,
            transactionMetadata: (0, $hRCmZ._)({}, treeState.transactionMetadata),
            dirtyAtoms: new Set(treeState.dirtyAtoms),
            atomValues: treeState.atomValues.clone(),
            nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
        },
        commitDepth: 0,
        nextTree: null,
        previousTree: null,
        knownAtoms: new Set(storeState.knownAtoms),
        // FIXME here's a copy
        knownSelectors: new Set(storeState.knownSelectors),
        // FIXME here's a copy
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        // FIXME here's a copy
        // Create blank cleanup handlers for atoms so snapshots don't re-run
        // atom effects.
        nodeCleanupFunctions: new Map($d7ce42c300073b00$var$Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), function(param) {
            var _param = (0, $6mdMa._)(param, 1), key = _param[0];
            return [
                key,
                function() {}
            ];
        }))
    };
} // Factory to build a fresh snapshot
function $d7ce42c300073b00$var$freshSnapshot(initializeState) {
    var snapshot = new $d7ce42c300073b00$var$Snapshot($d7ce42c300073b00$var$makeEmptyStoreState$1());
    return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state
var $d7ce42c300073b00$var$_memoizeOneWithArgsHashAndInvalidation$1 = (0, $6mdMa._)($d7ce42c300073b00$var$memoizeOneWithArgsHashAndInvalidation$1(function(store, version) {
    var _storeState$nextTree;
    var storeState = store.getState();
    var treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : $d7ce42c300073b00$var$Recoil_nullthrows(storeState.previousTree);
    return new $d7ce42c300073b00$var$Snapshot($d7ce42c300073b00$var$cloneStoreState(store, treeState), store.storeID);
}, function(store, version) {
    var _store$getState$nextT, _store$getState$previ;
    return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}), 2), $d7ce42c300073b00$var$memoizedCloneSnapshot = $d7ce42c300073b00$var$_memoizeOneWithArgsHashAndInvalidation$1[0], $d7ce42c300073b00$var$invalidateMemoizedSnapshot$2 = $d7ce42c300073b00$var$_memoizeOneWithArgsHashAndInvalidation$1[1]; // Avoid circular dependencies
$d7ce42c300073b00$var$setInvalidateMemoizedSnapshot$1($d7ce42c300073b00$var$invalidateMemoizedSnapshot$2);
function $d7ce42c300073b00$var$cloneSnapshot(store) {
    var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'latest';
    var snapshot = $d7ce42c300073b00$var$memoizedCloneSnapshot(store, version);
    if (!snapshot.isRetained()) {
        $d7ce42c300073b00$var$invalidateMemoizedSnapshot$2();
        return $d7ce42c300073b00$var$memoizedCloneSnapshot(store, version);
    }
    return snapshot;
}
var $d7ce42c300073b00$var$MutableSnapshot = /*#__PURE__*/ function(Snapshot) {
    "use strict";
    (0, $a7G5R._)(MutableSnapshot, Snapshot);
    function MutableSnapshot(snapshot, batch) {
        (0, $6WLcG._)(this, MutableSnapshot);
        var _this;
        _this = (0, $bQby9._)(this, MutableSnapshot, [
            $d7ce42c300073b00$var$cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true),
            snapshot.getStoreID()
        ]);
        $d7ce42c300073b00$var$_defineProperty(_this, "_batch", void 0);
        $d7ce42c300073b00$var$_defineProperty(_this, "set", function(recoilState, newValueOrUpdater) {
            _this.checkRefCount_INTERNAL();
            var store = _this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
            // read the written value after calling `set`. I would like to remove this
            // behavior and only batch in `Snapshot.map`, but this would be a breaking
            // change potentially.
            _this._batch(function() {
                $d7ce42c300073b00$var$updateRetainCount$1(store, recoilState.key, 1);
                $d7ce42c300073b00$var$setRecoilValue$1(_this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
            });
        });
        $d7ce42c300073b00$var$_defineProperty(_this, "reset", function(recoilState) {
            _this.checkRefCount_INTERNAL();
            var store = _this.getStore_INTERNAL(); // See note at `set` about batched updates.
            _this._batch(function() {
                $d7ce42c300073b00$var$updateRetainCount$1(store, recoilState.key, 1);
                $d7ce42c300073b00$var$setRecoilValue$1(_this.getStore_INTERNAL(), recoilState, $d7ce42c300073b00$var$DEFAULT_VALUE$1);
            });
        });
        $d7ce42c300073b00$var$_defineProperty(_this, "setUnvalidatedAtomValues_DEPRECATED", function(values) {
            _this.checkRefCount_INTERNAL();
            var store = _this.getStore_INTERNAL(); // See note at `set` about batched updates.
            $d7ce42c300073b00$var$batchUpdates$1(function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = values.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6mdMa._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        $d7ce42c300073b00$var$updateRetainCount$1(store, k, 1);
                        $d7ce42c300073b00$var$setUnvalidatedRecoilValue$1(store, new $d7ce42c300073b00$var$AbstractRecoilValue$2(k), v);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        });
        _this._batch = batch;
        return _this;
    }
    return MutableSnapshot;
}($d7ce42c300073b00$var$Snapshot);
var $d7ce42c300073b00$var$Recoil_Snapshot = {
    Snapshot: $d7ce42c300073b00$var$Snapshot,
    MutableSnapshot: $d7ce42c300073b00$var$MutableSnapshot,
    freshSnapshot: $d7ce42c300073b00$var$freshSnapshot,
    cloneSnapshot: $d7ce42c300073b00$var$cloneSnapshot
};
var $d7ce42c300073b00$var$Recoil_Snapshot_1 = $d7ce42c300073b00$var$Recoil_Snapshot.Snapshot;
var $d7ce42c300073b00$var$Recoil_Snapshot_2 = $d7ce42c300073b00$var$Recoil_Snapshot.MutableSnapshot;
var $d7ce42c300073b00$var$Recoil_Snapshot_3 = $d7ce42c300073b00$var$Recoil_Snapshot.freshSnapshot;
var $d7ce42c300073b00$var$Recoil_Snapshot_4 = $d7ce42c300073b00$var$Recoil_Snapshot.cloneSnapshot;
var $d7ce42c300073b00$var$Recoil_Snapshot$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Snapshot: $d7ce42c300073b00$var$Recoil_Snapshot_1,
    MutableSnapshot: $d7ce42c300073b00$var$Recoil_Snapshot_2,
    freshSnapshot: $d7ce42c300073b00$var$Recoil_Snapshot_3,
    cloneSnapshot: $d7ce42c300073b00$var$Recoil_Snapshot_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$unionSets() {
    for(var _len = arguments.length, sets = new Array(_len), _key = 0; _key < _len; _key++){
        sets[_key] = arguments[_key];
    }
    var result = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = sets[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var set = _step.value;
            try {
                for(var _iterator1 = set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var value = _step1.value;
                    result.add(value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return result;
}
var $d7ce42c300073b00$var$Recoil_unionSets = $d7ce42c300073b00$var$unionSets;
var $d7ce42c300073b00$var$useRef = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef;
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */ function $d7ce42c300073b00$var$useRefInitOnce(initialValue) {
    // $FlowExpectedError[incompatible-call]
    var ref = $d7ce42c300073b00$var$useRef(initialValue);
    if (ref.current === initialValue && typeof initialValue === 'function') // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
    return ref;
}
var $d7ce42c300073b00$var$Recoil_useRefInitOnce = $d7ce42c300073b00$var$useRefInitOnce;
// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');
var $d7ce42c300073b00$var$getNextTreeStateVersion$3 = $d7ce42c300073b00$var$Recoil_State.getNextTreeStateVersion, $d7ce42c300073b00$var$makeEmptyStoreState$2 = $d7ce42c300073b00$var$Recoil_State.makeEmptyStoreState;
var $d7ce42c300073b00$var$cleanUpNode$2 = $d7ce42c300073b00$var$Recoil_FunctionalCore.cleanUpNode, $d7ce42c300073b00$var$getDownstreamNodes$2 = $d7ce42c300073b00$var$Recoil_FunctionalCore.getDownstreamNodes, $d7ce42c300073b00$var$initializeNode$2 = $d7ce42c300073b00$var$Recoil_FunctionalCore.initializeNode, $d7ce42c300073b00$var$setNodeValue$2 = $d7ce42c300073b00$var$Recoil_FunctionalCore.setNodeValue, $d7ce42c300073b00$var$setUnvalidatedAtomValue_DEPRECATED$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.setUnvalidatedAtomValue_DEPRECATED;
var $d7ce42c300073b00$var$graph$2 = $d7ce42c300073b00$var$Recoil_Graph.graph;
var $d7ce42c300073b00$var$cloneGraph$1 = $d7ce42c300073b00$var$Recoil_Graph.cloneGraph;
var $d7ce42c300073b00$var$getNextStoreID$2 = $d7ce42c300073b00$var$Recoil_Keys.getNextStoreID;
var $d7ce42c300073b00$var$createMutableSource$1 = $d7ce42c300073b00$var$Recoil_ReactMode.createMutableSource, $d7ce42c300073b00$var$reactMode$2 = $d7ce42c300073b00$var$Recoil_ReactMode.reactMode;
var $d7ce42c300073b00$var$applyAtomValueWrites$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.applyAtomValueWrites;
var $d7ce42c300073b00$var$releaseScheduledRetainablesNow$1 = $d7ce42c300073b00$var$Recoil_Retention.releaseScheduledRetainablesNow;
var $d7ce42c300073b00$var$freshSnapshot$1 = $d7ce42c300073b00$var$Recoil_Snapshot$1.freshSnapshot;
var $d7ce42c300073b00$var$useCallback = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useCallback, $d7ce42c300073b00$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useContext, $d7ce42c300073b00$var$useEffect = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect, $d7ce42c300073b00$var$useMemo = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useMemo, $d7ce42c300073b00$var$useRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef, $d7ce42c300073b00$var$useState = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState;
function $d7ce42c300073b00$var$notInAContext() {
    throw $d7ce42c300073b00$var$Recoil_err('This component must be used inside a <RecoilRoot> component.');
}
var $d7ce42c300073b00$var$defaultStore = Object.freeze({
    storeID: $d7ce42c300073b00$var$getNextStoreID$2(),
    getState: $d7ce42c300073b00$var$notInAContext,
    replaceState: $d7ce42c300073b00$var$notInAContext,
    getGraph: $d7ce42c300073b00$var$notInAContext,
    subscribeToTransactions: $d7ce42c300073b00$var$notInAContext,
    addTransactionMetadata: $d7ce42c300073b00$var$notInAContext
});
var $d7ce42c300073b00$var$stateReplacerIsBeingExecuted = false;
function $d7ce42c300073b00$var$startNextTreeIfNeeded(store) {
    if ($d7ce42c300073b00$var$stateReplacerIsBeingExecuted) throw $d7ce42c300073b00$var$Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
    var storeState = store.getState();
    if (storeState.nextTree === null) {
        if ($d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020') && $d7ce42c300073b00$var$Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) // If this is a cascading update (that is, rendering due to one state change
        // invokes a second state change), we won't have cleaned up retainables yet
        // because this normally happens after notifying components. Do it before
        // proceeding with the cascading update so that it remains predictable:
        {
            if (storeState.commitDepth > 0) $d7ce42c300073b00$var$releaseScheduledRetainablesNow$1(store);
        }
        var version = storeState.currentTree.version;
        var nextVersion = $d7ce42c300073b00$var$getNextTreeStateVersion$3();
        storeState.nextTree = (0, $7XD9P._)((0, $hRCmZ._)({}, storeState.currentTree), {
            version: nextVersion,
            stateID: nextVersion,
            dirtyAtoms: new Set(),
            transactionMetadata: {}
        });
        storeState.graphsByVersion.set(nextVersion, $d7ce42c300073b00$var$cloneGraph$1($d7ce42c300073b00$var$Recoil_nullthrows(storeState.graphsByVersion.get(version))));
    }
}
var $d7ce42c300073b00$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createContext({
    current: $d7ce42c300073b00$var$defaultStore
});
var $d7ce42c300073b00$var$useStoreRef = function() {
    return $d7ce42c300073b00$var$useContext($d7ce42c300073b00$var$AppContext);
}; // $FlowExpectedError[incompatible-call]
var $d7ce42c300073b00$var$MutableSourceContext = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createContext(null);
function $d7ce42c300073b00$var$useRecoilMutableSource() {
    var mutableSource = $d7ce42c300073b00$var$useContext($d7ce42c300073b00$var$MutableSourceContext);
    if (mutableSource == null) $d7ce42c300073b00$var$Recoil_expectationViolation("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.");
    return mutableSource;
}
function $d7ce42c300073b00$var$notifyComponents(store, storeState, treeState) {
    var dependentNodes = $d7ce42c300073b00$var$getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dependentNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var comps = storeState.nodeToComponentSubscriptions.get(key);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (comps) try {
                for(var _iterator1 = comps[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = (0, $6mdMa._)(_step1.value, 2), _subID = _step_value[0], _step_value_ = (0, $6mdMa._)(_step_value[1], 2), _debugName = _step_value_[0], callback = _step_value_[1];
                    callback(treeState);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $d7ce42c300073b00$var$sendEndOfBatchNotifications(store) {
    var storeState = store.getState();
    var treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:
    var dirtyAtoms = treeState.dirtyAtoms;
    if (dirtyAtoms.size) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Execute Node-specific subscribers before global subscribers
            for(var _iterator = storeState.nodeTransactionSubscriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6mdMa._)(_step.value, 2), key = _step_value[0], subscriptions = _step_value[1];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (dirtyAtoms.has(key)) try {
                    for(var _iterator1 = subscriptions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, $6mdMa._)(_step1.value, 2), _ = _step_value1[0], subscription = _step_value1[1];
                        subscription(store);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = storeState.transactionSubscriptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var _step_value2 = (0, $6mdMa._)(_step2.value, 2), _1 = _step_value2[0], subscription1 = _step_value2[1];
                subscription1(store);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                    _iterator2["return"]();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        if (!$d7ce42c300073b00$var$reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
            // Notifying components is needed to wake from suspense, even when using
            // early rendering.
            $d7ce42c300073b00$var$notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
            // We need to wake up components not just when some asynchronous selector
            // resolved, but also when changing synchronous values because this may cause
            // a selector to change from asynchronous to synchronous, in which case there
            // would be no follow-up asynchronous resolution to wake us up.
            // TODO OPTIMIZATION Only wake up related downstream components
            storeState.suspendedComponentResolvers.forEach(function(cb) {
                return cb();
            });
            storeState.suspendedComponentResolvers.clear();
        }
    } // Special behavior ONLY invoked by useInterface.
    // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
    storeState.queuedComponentCallbacks_DEPRECATED.forEach(function(cb) {
        return cb(treeState);
    });
    storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}
function $d7ce42c300073b00$var$endBatch(store) {
    var storeState = store.getState();
    storeState.commitDepth++;
    try {
        var nextTree = storeState.nextTree; // Ignore commits that are not because of Recoil transactions -- namely,
        // because something above RecoilRoot re-rendered:
        if (nextTree == null) return;
         // nextTree is now committed -- note that copying and reset occurs when
        // a transaction begins, in startNextTreeIfNeeded:
        storeState.previousTree = storeState.currentTree;
        storeState.currentTree = nextTree;
        storeState.nextTree = null;
        $d7ce42c300073b00$var$sendEndOfBatchNotifications(store);
        if (storeState.previousTree != null) storeState.graphsByVersion["delete"](storeState.previousTree.version);
        else $d7ce42c300073b00$var$Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
        storeState.previousTree = null;
        if ($d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) // Only release retainables if there were no writes during the end of the
        // batch.  This avoids releasing something we might be about to use.
        {
            if (nextTree == null) $d7ce42c300073b00$var$releaseScheduledRetainablesNow$1(store);
        }
    } finally{
        storeState.commitDepth--;
    }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */ function $d7ce42c300073b00$var$Batcher(param) {
    var setNotifyBatcherOfChange = param.setNotifyBatcherOfChange;
    var storeRef = $d7ce42c300073b00$var$useStoreRef();
    var _useState = (0, $6mdMa._)($d7ce42c300073b00$var$useState([]), 2), setState = _useState[1]; // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(function() {
        return setState({});
    });
    $d7ce42c300073b00$var$useEffect(function() {
        // $FlowFixMe[incompatible-call]
        setNotifyBatcherOfChange(function() {
            return setState({});
        }); // If an asynchronous selector resolves after the Batcher is unmounted,
        // notifyBatcherOfChange will still be called. An error gets thrown whenever
        // setState is called after a component is already unmounted, so this sets
        // notifyBatcherOfChange to be a no-op.
        return function() {
            setNotifyBatcherOfChange(function() {});
        };
    }, [
        setNotifyBatcherOfChange
    ]);
    $d7ce42c300073b00$var$useEffect(function() {
        // enqueueExecution runs this function immediately; it is only used to
        // manipulate the order of useEffects during tests, since React seems to
        // call useEffect in an unpredictable order sometimes.
        $d7ce42c300073b00$var$Recoil_Queue.enqueueExecution('Batcher', function() {
            $d7ce42c300073b00$var$endBatch(storeRef.current);
        });
    });
    return null;
}
// which will no longer be needed.
function $d7ce42c300073b00$var$initialStoreState_DEPRECATED(store, initializeState) {
    var initial = $d7ce42c300073b00$var$makeEmptyStoreState$2();
    initializeState({
        set: function(atom, value) {
            var state = initial.currentTree;
            var writes = $d7ce42c300073b00$var$setNodeValue$2(store, state, atom.key, value);
            var writtenNodes = new Set(writes.keys());
            var nonvalidatedAtoms = state.nonvalidatedAtoms.clone();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = writtenNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    nonvalidatedAtoms["delete"](n);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            initial.currentTree = (0, $7XD9P._)((0, $hRCmZ._)({}, state), {
                dirtyAtoms: $d7ce42c300073b00$var$Recoil_unionSets(state.dirtyAtoms, writtenNodes),
                atomValues: $d7ce42c300073b00$var$applyAtomValueWrites$1(state.atomValues, writes),
                // NB: PLEASE un-export applyAtomValueWrites when deleting this code
                nonvalidatedAtoms: nonvalidatedAtoms
            });
        },
        setUnvalidatedAtomValues: function(atomValues) {
            // FIXME replace this with a mutative loop
            atomValues.forEach(function(v, k) {
                initial.currentTree = $d7ce42c300073b00$var$setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
            });
        }
    });
    return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.
function $d7ce42c300073b00$var$initialStoreState(initializeState) {
    // Initialize a snapshot and get its store
    var snapshot = $d7ce42c300073b00$var$freshSnapshot$1(initializeState);
    var storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release
    snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
    // they will re-initialize if used during rendering.  This allows atom effect
    // initialization to take precedence over initializeState and be compatible
    // with StrictMode semantics.
    storeState.nodeCleanupFunctions.forEach(function(cleanup) {
        return cleanup();
    });
    storeState.nodeCleanupFunctions.clear();
    return storeState;
}
var $d7ce42c300073b00$var$nextID = 0;
function $d7ce42c300073b00$var$RecoilRoot_INTERNAL(param) {
    var initializeState_DEPRECATED = param.initializeState_DEPRECATED, initializeState = param.initializeState, storeProp = param.store_INTERNAL, // For use with React "context bridging"
    children = param.children;
    // prettier-ignore
    // @fb-only: useEffect(() => {
    // @fb-only: if (gkx('recoil_usage_logging')) {
    // @fb-only: try {
    // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
    // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
    // @fb-only: path: URI.getRequestURI().getPath(),
    // @fb-only: }));
    // @fb-only: } catch {
    // @fb-only: recoverableViolation(
    // @fb-only: 'Error when logging Recoil Usage event',
    // @fb-only: 'recoil',
    // @fb-only: );
    // @fb-only: }
    // @fb-only: }
    // @fb-only: }, []);
    var storeStateRef; // eslint-disable-line prefer-const
    var getGraph = function(version) {
        var graphs = storeStateRef.current.graphsByVersion;
        if (graphs.has(version)) return $d7ce42c300073b00$var$Recoil_nullthrows(graphs.get(version));
        var newGraph = $d7ce42c300073b00$var$graph$2();
        graphs.set(version, newGraph);
        return newGraph;
    };
    var subscribeToTransactions = function(callback, key) {
        if (key == null) {
            // Global transaction subscriptions
            var transactionSubscriptions = storeRef.current.getState().transactionSubscriptions;
            var id = $d7ce42c300073b00$var$nextID++;
            transactionSubscriptions.set(id, callback);
            return {
                release: function() {
                    transactionSubscriptions["delete"](id);
                }
            };
        } else {
            // Node-specific transaction subscriptions:
            var nodeTransactionSubscriptions = storeRef.current.getState().nodeTransactionSubscriptions;
            if (!nodeTransactionSubscriptions.has(key)) nodeTransactionSubscriptions.set(key, new Map());
            var id1 = $d7ce42c300073b00$var$nextID++;
            $d7ce42c300073b00$var$Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id1, callback);
            return {
                release: function() {
                    var subs = nodeTransactionSubscriptions.get(key);
                    if (subs) {
                        subs["delete"](id1);
                        if (subs.size === 0) nodeTransactionSubscriptions["delete"](key);
                    }
                }
            };
        }
    };
    var addTransactionMetadata = function(metadata) {
        $d7ce42c300073b00$var$startNextTreeIfNeeded(storeRef.current);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(metadata)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                $d7ce42c300073b00$var$Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var replaceState = function(replacer) {
        $d7ce42c300073b00$var$startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:
        var nextTree = $d7ce42c300073b00$var$Recoil_nullthrows(storeStateRef.current.nextTree);
        var replaced;
        try {
            $d7ce42c300073b00$var$stateReplacerIsBeingExecuted = true;
            replaced = replacer(nextTree);
        } finally{
            $d7ce42c300073b00$var$stateReplacerIsBeingExecuted = false;
        }
        if (replaced === nextTree) return;
        storeStateRef.current.nextTree = replaced;
        if ($d7ce42c300073b00$var$reactMode$2().early) $d7ce42c300073b00$var$notifyComponents(storeRef.current, storeStateRef.current, replaced);
        $d7ce42c300073b00$var$Recoil_nullthrows(notifyBatcherOfChange.current)();
    };
    var notifyBatcherOfChange = $d7ce42c300073b00$var$useRef$1(null);
    var setNotifyBatcherOfChange = $d7ce42c300073b00$var$useCallback(function(x) {
        notifyBatcherOfChange.current = x;
    }, [
        notifyBatcherOfChange
    ]);
    var storeRef = $d7ce42c300073b00$var$Recoil_useRefInitOnce(function() {
        return storeProp !== null && storeProp !== void 0 ? storeProp : {
            storeID: $d7ce42c300073b00$var$getNextStoreID$2(),
            getState: function() {
                return storeStateRef.current;
            },
            replaceState: replaceState,
            getGraph: getGraph,
            subscribeToTransactions: subscribeToTransactions,
            addTransactionMetadata: addTransactionMetadata
        };
    });
    if (storeProp != null) storeRef.current = storeProp;
    storeStateRef = $d7ce42c300073b00$var$Recoil_useRefInitOnce(function() {
        return initializeState_DEPRECATED != null ? $d7ce42c300073b00$var$initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? $d7ce42c300073b00$var$initialStoreState(initializeState) : $d7ce42c300073b00$var$makeEmptyStoreState$2();
    });
    var mutableSource = $d7ce42c300073b00$var$useMemo(function() {
        return $d7ce42c300073b00$var$createMutableSource$1 === null || $d7ce42c300073b00$var$createMutableSource$1 === void 0 ? void 0 : $d7ce42c300073b00$var$createMutableSource$1(storeStateRef, function() {
            return storeStateRef.current.currentTree.version;
        });
    }, [
        storeStateRef
    ]); // Cleanup when the <RecoilRoot> is unmounted
    $d7ce42c300073b00$var$useEffect(function() {
        // React is free to call effect cleanup handlers and effects at will, the
        // deps array is only an optimization.  For example, React strict mode
        // will execute each effect twice for testing.  Therefore, we need symmetry
        // to re-initialize all known atoms after they were cleaned up.
        var store = storeRef.current;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = new Set(store.getState().knownAtoms)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var atomKey = _step.value;
                $d7ce42c300073b00$var$initializeNode$2(store, atomKey, 'get');
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = store.getState().knownAtoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var atomKey = _step.value;
                    $d7ce42c300073b00$var$cleanUpNode$2(store, atomKey);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        storeRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($d7ce42c300073b00$var$AppContext.Provider, {
        value: storeRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($d7ce42c300073b00$var$MutableSourceContext.Provider, {
        value: mutableSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($d7ce42c300073b00$var$Batcher, {
        setNotifyBatcherOfChange: setNotifyBatcherOfChange
    }), children));
}
function $d7ce42c300073b00$var$RecoilRoot(props) {
    var override = props.override, propsExceptOverride = (0, $c4wKO._)(props, [
        "override"
    ]);
    var ancestorStoreRef = $d7ce42c300073b00$var$useStoreRef();
    if (override === false && ancestorStoreRef.current !== $d7ce42c300073b00$var$defaultStore) // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($d7ce42c300073b00$var$RecoilRoot_INTERNAL, propsExceptOverride);
}
function $d7ce42c300073b00$var$useRecoilStoreID() {
    return $d7ce42c300073b00$var$useStoreRef().current.storeID;
}
var $d7ce42c300073b00$var$Recoil_RecoilRoot = {
    RecoilRoot: $d7ce42c300073b00$var$RecoilRoot,
    useStoreRef: $d7ce42c300073b00$var$useStoreRef,
    useRecoilMutableSource: $d7ce42c300073b00$var$useRecoilMutableSource,
    useRecoilStoreID: $d7ce42c300073b00$var$useRecoilStoreID,
    notifyComponents_FOR_TESTING: $d7ce42c300073b00$var$notifyComponents,
    sendEndOfBatchNotifications_FOR_TESTING: $d7ce42c300073b00$var$sendEndOfBatchNotifications
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$shallowArrayEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(var i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
var $d7ce42c300073b00$var$Recoil_shallowArrayEqual = $d7ce42c300073b00$var$shallowArrayEqual;
var $d7ce42c300073b00$var$useEffect$1 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect, $d7ce42c300073b00$var$useRef$2 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef;
function $d7ce42c300073b00$var$usePrevious(value) {
    var ref = $d7ce42c300073b00$var$useRef$2();
    $d7ce42c300073b00$var$useEffect$1(function() {
        // $FlowFixMe[incompatible-type]
        ref.current = value;
    });
    return ref.current;
}
var $d7ce42c300073b00$var$Recoil_usePrevious = $d7ce42c300073b00$var$usePrevious;
var $d7ce42c300073b00$var$useStoreRef$1 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$SUSPENSE_TIMEOUT_MS$1 = $d7ce42c300073b00$var$Recoil_Retention.SUSPENSE_TIMEOUT_MS;
var $d7ce42c300073b00$var$updateRetainCount$2 = $d7ce42c300073b00$var$Recoil_Retention.updateRetainCount;
var $d7ce42c300073b00$var$RetentionZone$3 = $d7ce42c300073b00$var$Recoil_RetentionZone.RetentionZone;
var $d7ce42c300073b00$var$useEffect$2 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect, $d7ce42c300073b00$var$useRef$3 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef;
var $d7ce42c300073b00$var$isSSR$2 = $d7ce42c300073b00$var$Recoil_Environment.isSSR;
// I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.
// flowlint-line unclear-type:off
function $d7ce42c300073b00$var$useRetain(toRetain) {
    if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
     // eslint-disable-next-line fb-www/react-hooks
    return $d7ce42c300073b00$var$useRetain_ACTUAL(toRetain);
}
function $d7ce42c300073b00$var$useRetain_ACTUAL(toRetain) {
    var array = Array.isArray(toRetain) ? toRetain : [
        toRetain
    ];
    var retainables = array.map(function(a) {
        return a instanceof $d7ce42c300073b00$var$RetentionZone$3 ? a : a.key;
    });
    var storeRef = $d7ce42c300073b00$var$useStoreRef$1();
    $d7ce42c300073b00$var$useEffect$2(function() {
        if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) return;
        var store = storeRef.current;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (timeoutID.current && !$d7ce42c300073b00$var$isSSR$2) {
            // Already performed a temporary retain on render, simply cancel the release
            // of that temporary retain.
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
        } else try {
            for(var _iterator = retainables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                $d7ce42c300073b00$var$updateRetainCount$2(store, r, 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = retainables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var r = _step.value;
                    $d7ce42c300073b00$var$updateRetainCount$2(store, r, -1);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }; // eslint-disable-next-line fb-www/react-hooks-deps
    }, [
        storeRef
    ].concat((0, $bOqL7._)(retainables))); // We want to retain if the component suspends. This is terrible but the Suspense
    // API affords us no better option. If we suspend and never commit after some
    // seconds, then release. The 'actual' retain/release in the effect above
    // cancels this.
    var timeoutID = $d7ce42c300073b00$var$useRef$3();
    var previousRetainables = $d7ce42c300073b00$var$Recoil_usePrevious(retainables);
    if (!$d7ce42c300073b00$var$isSSR$2 && (previousRetainables === undefined || !$d7ce42c300073b00$var$Recoil_shallowArrayEqual(previousRetainables, retainables))) {
        var store = storeRef.current;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = retainables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                $d7ce42c300073b00$var$updateRetainCount$2(store, r, 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (previousRetainables) try {
            for(var _iterator1 = previousRetainables[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var r1 = _step1.value;
                $d7ce42c300073b00$var$updateRetainCount$2(store, r1, -1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (timeoutID.current) window.clearTimeout(timeoutID.current);
        timeoutID.current = window.setTimeout(function() {
            timeoutID.current = null;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = retainables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var r = _step.value;
                    $d7ce42c300073b00$var$updateRetainCount$2(store, r, -1);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, $d7ce42c300073b00$var$SUSPENSE_TIMEOUT_MS$1);
    }
}
var $d7ce42c300073b00$var$Recoil_useRetain = $d7ce42c300073b00$var$useRetain;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */ // const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');
function $d7ce42c300073b00$var$useComponentName() {
    // const nameRef = useRef();
    // if (__DEV__) {
    //   if (gkx('recoil_infer_component_names')) {
    //     if (nameRef.current === undefined) {
    //       // There is no blessed way to determine the calling React component from
    //       // within a hook. This hack uses the fact that hooks must start with 'use'
    //       // and that hooks are either called by React Components or other hooks. It
    //       // follows therefore, that to find the calling component, you simply need
    //       // to look down the stack and find the first function which doesn't start
    //       // with 'use'. We are only enabling this in dev for now, since once the
    //       // codebase is minified, the naming assumptions no longer hold true.
    //       // eslint-disable-next-line fb-www/no-new-error
    //       const frames = stackTraceParser(new Error().stack);
    //       for (const {methodName} of frames) {
    //         // I observed cases where the frame was of the form 'Object.useXXX'
    //         // hence why I'm searching for hooks following a word boundary
    //         if (!methodName.match(/\buse[^\b]+$/)) {
    //           return (nameRef.current = methodName);
    //         }
    //       }
    //       nameRef.current = null;
    //     }
    //     return nameRef.current ?? '<unable to determine component name>';
    //   }
    // }
    // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
    return '<component name not available>'; // @oss-only
}
var $d7ce42c300073b00$var$Recoil_useComponentName = $d7ce42c300073b00$var$useComponentName;
var $d7ce42c300073b00$var$batchUpdates$2 = $d7ce42c300073b00$var$Recoil_Batching.batchUpdates;
var $d7ce42c300073b00$var$DEFAULT_VALUE$2 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE;
var $d7ce42c300073b00$var$currentRendererSupportsUseSyncExternalStore$1 = $d7ce42c300073b00$var$Recoil_ReactMode.currentRendererSupportsUseSyncExternalStore, $d7ce42c300073b00$var$reactMode$3 = $d7ce42c300073b00$var$Recoil_ReactMode.reactMode, $d7ce42c300073b00$var$useMutableSource$1 = $d7ce42c300073b00$var$Recoil_ReactMode.useMutableSource, $d7ce42c300073b00$var$useSyncExternalStore$1 = $d7ce42c300073b00$var$Recoil_ReactMode.useSyncExternalStore;
var $d7ce42c300073b00$var$useRecoilMutableSource$1 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useRecoilMutableSource, $d7ce42c300073b00$var$useStoreRef$2 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$isRecoilValue$2 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.isRecoilValue;
var $d7ce42c300073b00$var$AbstractRecoilValue$3 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.AbstractRecoilValue, $d7ce42c300073b00$var$getRecoilValueAsLoadable$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.getRecoilValueAsLoadable, $d7ce42c300073b00$var$setRecoilValue$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setRecoilValue, $d7ce42c300073b00$var$setUnvalidatedRecoilValue$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setUnvalidatedRecoilValue, $d7ce42c300073b00$var$subscribeToRecoilValue$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.subscribeToRecoilValue;
var $d7ce42c300073b00$var$useCallback$1 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useCallback, $d7ce42c300073b00$var$useEffect$3 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect, $d7ce42c300073b00$var$useMemo$1 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useMemo, $d7ce42c300073b00$var$useRef$4 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef, $d7ce42c300073b00$var$useState$1 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState;
var $d7ce42c300073b00$var$setByAddingToSet$2 = $d7ce42c300073b00$var$Recoil_CopyOnWrite.setByAddingToSet;
var $d7ce42c300073b00$var$isSSR$3 = $d7ce42c300073b00$var$Recoil_Environment.isSSR;
function $d7ce42c300073b00$var$handleLoadable(loadable, recoilValue, storeRef) {
    // We can't just throw the promise we are waiting on to Suspense.  If the
    // upstream dependencies change it may produce a state in which the component
    // can render, but it would still be suspended on a Promise that may never resolve.
    if (loadable.state === 'hasValue') return loadable.contents;
    else if (loadable.state === 'loading') {
        var promise = new Promise(function(resolve) {
            var suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
            suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
            // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)
            if ($d7ce42c300073b00$var$isSSR$3 && $d7ce42c300073b00$var$Recoil_isPromise(loadable.contents)) loadable.contents["finally"](function() {
                suspendedComponentResolvers["delete"](resolve);
            });
        }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
        // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;
        throw promise;
    } else if (loadable.state === 'hasError') throw loadable.contents;
    else throw $d7ce42c300073b00$var$Recoil_err('Invalid value of loadable atom "'.concat(recoilValue.key, '"'));
}
function $d7ce42c300073b00$var$validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
    if (!$d7ce42c300073b00$var$isRecoilValue$2(recoilValue)) throw $d7ce42c300073b00$var$Recoil_err("Invalid argument to ".concat(hookName, ": expected an atom or selector but got ").concat(String(recoilValue)));
}
/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */ function $d7ce42c300073b00$var$useRecoilInterface_DEPRECATED() {
    var componentName = $d7ce42c300073b00$var$Recoil_useComponentName();
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    var _useState$1 = (0, $6mdMa._)($d7ce42c300073b00$var$useState$1([]), 2), forceUpdate = _useState$1[1];
    var recoilValuesUsed = $d7ce42c300073b00$var$useRef$4(new Set());
    recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render
    var previousSubscriptions = $d7ce42c300073b00$var$useRef$4(new Set());
    var subscriptions = $d7ce42c300073b00$var$useRef$4(new Map());
    var unsubscribeFrom = $d7ce42c300073b00$var$useCallback$1(function(key) {
        var sub = subscriptions.current.get(key);
        if (sub) {
            sub.release();
            subscriptions.current["delete"](key);
        }
    }, [
        subscriptions
    ]);
    var updateState = $d7ce42c300073b00$var$useCallback$1(function(_state, key) {
        if (subscriptions.current.has(key)) forceUpdate([]);
    }, []); // Effect to add/remove subscriptions as nodes are used
    $d7ce42c300073b00$var$useEffect$3(function() {
        var store = storeRef.current;
        $d7ce42c300073b00$var$Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(function(key) {
            if (subscriptions.current.has(key)) {
                $d7ce42c300073b00$var$Recoil_expectationViolation('Double subscription to RecoilValue "'.concat(key, '"'));
                return;
            }
            var sub = $d7ce42c300073b00$var$subscribeToRecoilValue$1(store, new $d7ce42c300073b00$var$AbstractRecoilValue$3(key), function(state) {
                return updateState(state, key);
            }, componentName);
            subscriptions.current.set(key, sub);
            /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */ // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
            var state = store.getState();
            if (state.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(function() {
                updateState(store.getState(), key);
            });
            else updateState(store.getState(), key);
        });
        $d7ce42c300073b00$var$Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(function(key) {
            unsubscribeFrom(key);
        });
        previousSubscriptions.current = recoilValuesUsed.current;
    }); // Effect to unsubscribe from all when unmounting
    $d7ce42c300073b00$var$useEffect$3(function() {
        var currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice
        $d7ce42c300073b00$var$Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach(function(key) {
            var sub = $d7ce42c300073b00$var$subscribeToRecoilValue$1(storeRef.current, new $d7ce42c300073b00$var$AbstractRecoilValue$3(key), function(state) {
                return updateState(state, key);
            }, componentName);
            currentSubscriptions.set(key, sub);
        });
        return function() {
            return currentSubscriptions.forEach(function(_, key) {
                return unsubscribeFrom(key);
            });
        };
    }, [
        componentName,
        storeRef,
        unsubscribeFrom,
        updateState
    ]);
    return $d7ce42c300073b00$var$useMemo$1(function() {
        var _$useSetRecoilState = // eslint-disable-next-line no-shadow
        function _$useSetRecoilState(recoilState) {
            return function(newValueOrUpdater) {
                $d7ce42c300073b00$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
            };
        } // eslint-disable-next-line no-shadow
        ;
        var _$useResetRecoilState = function _$useResetRecoilState(recoilState) {
            return function() {
                return $d7ce42c300073b00$var$setRecoilValue$2(storeRef.current, recoilState, $d7ce42c300073b00$var$DEFAULT_VALUE$2);
            };
        } // eslint-disable-next-line no-shadow
        ;
        var _$useRecoilValueLoadable = function _$useRecoilValueLoadable(recoilValue) {
            var _storeState$nextTree;
            if (!recoilValuesUsed.current.has(recoilValue.key)) recoilValuesUsed.current = $d7ce42c300073b00$var$setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
             // TODO Restore optimization to memoize lookup
            var storeState = storeRef.current.getState();
            return $d7ce42c300073b00$var$getRecoilValueAsLoadable$2(storeRef.current, recoilValue, $d7ce42c300073b00$var$reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
        } // eslint-disable-next-line no-shadow
        ;
        var _$useRecoilValue = function _$useRecoilValue(recoilValue) {
            var loadable = _$useRecoilValueLoadable(recoilValue);
            return $d7ce42c300073b00$var$handleLoadable(loadable, recoilValue, storeRef);
        } // eslint-disable-next-line no-shadow
        ;
        var _$useRecoilState = function _$useRecoilState(recoilState) {
            return [
                _$useRecoilValue(recoilState),
                _$useSetRecoilState(recoilState)
            ];
        } // eslint-disable-next-line no-shadow
        ;
        var _$useRecoilStateLoadable = function _$useRecoilStateLoadable(recoilState) {
            return [
                _$useRecoilValueLoadable(recoilState),
                _$useSetRecoilState(recoilState)
            ];
        };
        return {
            getRecoilValue: _$useRecoilValue,
            getRecoilValueLoadable: _$useRecoilValueLoadable,
            getRecoilState: _$useRecoilState,
            getRecoilStateLoadable: _$useRecoilStateLoadable,
            getSetRecoilState: _$useSetRecoilState,
            getResetRecoilState: _$useResetRecoilState
        };
    }, [
        recoilValuesUsed,
        storeRef
    ]);
}
var $d7ce42c300073b00$var$recoilComponentGetRecoilValueCount_FOR_TESTING = {
    current: 0
};
function $d7ce42c300073b00$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    var componentName = $d7ce42c300073b00$var$Recoil_useComponentName();
    var getSnapshot = $d7ce42c300073b00$var$useCallback$1(function() {
        var _storeState$nextTree2;
        var store = storeRef.current;
        var storeState = store.getState();
        var treeState = $d7ce42c300073b00$var$reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
        var loadable = $d7ce42c300073b00$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
        return {
            loadable: loadable,
            key: recoilValue.key
        };
    }, [
        storeRef,
        recoilValue
    ]); // Memoize the state to avoid unnecessary rerenders
    var memoizePreviousSnapshot = $d7ce42c300073b00$var$useCallback$1(function(getState) {
        var prevState;
        return function() {
            var _prevState, _prevState2;
            var nextState = getState();
            if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) return prevState;
            prevState = nextState;
            return nextState;
        };
    }, []);
    var getMemoizedSnapshot = $d7ce42c300073b00$var$useMemo$1(function() {
        return memoizePreviousSnapshot(getSnapshot);
    }, [
        getSnapshot,
        memoizePreviousSnapshot
    ]);
    var subscribe = $d7ce42c300073b00$var$useCallback$1(function(notify) {
        var store = storeRef.current;
        var subscription = $d7ce42c300073b00$var$subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName
    ]);
    return $d7ce42c300073b00$var$useSyncExternalStore$1(subscribe, getMemoizedSnapshot, getMemoizedSnapshot // getServerSnapshot() for SSR support
    ).loadable;
}
function $d7ce42c300073b00$var$useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    var getLoadable = $d7ce42c300073b00$var$useCallback$1(function() {
        var _storeState$nextTree3;
        var store = storeRef.current;
        var storeState = store.getState();
        var treeState = $d7ce42c300073b00$var$reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
        return $d7ce42c300073b00$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    var getLoadableWithTesting = $d7ce42c300073b00$var$useCallback$1(function() {
        return getLoadable();
    }, [
        getLoadable
    ]);
    var componentName = $d7ce42c300073b00$var$Recoil_useComponentName();
    var subscribe = $d7ce42c300073b00$var$useCallback$1(function(_storeState, notify) {
        var store = storeRef.current;
        var subscription = $d7ce42c300073b00$var$subscribeToRecoilValue$1(store, recoilValue, function() {
            if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_suppress_rerender_in_callback')) return notify();
             // Only re-render if the value has changed.
            // This will evaluate the atom/selector now as well as when the
            // component renders, but that may help with prefetching.
            var newLoadable = getLoadable();
            if (!prevLoadableRef.current.is(newLoadable)) notify();
             // If the component is suspended then the effect setting prevLoadableRef
            // will not run.  So, set the previous value here when its subscription
            // is fired to wake it up.  We can't just rely on this, though, because
            // this only executes when an atom/selector is dirty and the atom/selector
            // passed to the hook can dynamically change.
            prevLoadableRef.current = newLoadable;
        }, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName,
        getLoadable
    ]);
    var source = $d7ce42c300073b00$var$useRecoilMutableSource$1();
    if (source == null) throw $d7ce42c300073b00$var$Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
    var loadable = $d7ce42c300073b00$var$useMutableSource$1(source, getLoadableWithTesting, subscribe);
    var prevLoadableRef = $d7ce42c300073b00$var$useRef$4(loadable);
    $d7ce42c300073b00$var$useEffect$3(function() {
        prevLoadableRef.current = loadable;
    });
    return loadable;
}
function $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    var componentName = $d7ce42c300073b00$var$Recoil_useComponentName(); // Accessors to get the current state
    var getLoadable = $d7ce42c300073b00$var$useCallback$1(function() {
        var _storeState$nextTree4;
        var store = storeRef.current;
        var storeState = store.getState();
        var treeState = $d7ce42c300073b00$var$reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
        return $d7ce42c300073b00$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    var getState = $d7ce42c300073b00$var$useCallback$1(function() {
        return {
            loadable: getLoadable(),
            key: recoilValue.key
        };
    }, [
        getLoadable,
        recoilValue.key
    ]); // Memoize state snapshots
    var updateState = $d7ce42c300073b00$var$useCallback$1(function(prevState) {
        var nextState = getState();
        return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
    }, [
        getState
    ]); // Subscribe to Recoil state changes
    $d7ce42c300073b00$var$useEffect$3(function() {
        var subscription = $d7ce42c300073b00$var$subscribeToRecoilValue$1(storeRef.current, recoilValue, function(_state) {
            setState(updateState);
        }, componentName); // Update state in case we are using a different key
        setState(updateState);
        return subscription.release;
    }, [
        componentName,
        recoilValue,
        storeRef,
        updateState
    ]); // Get the current state
    var _useState$1 = (0, $6mdMa._)($d7ce42c300073b00$var$useState$1(getState), 2), state = _useState$1[0], setState = _useState$1[1]; // If we changed keys, then return the state for the new key.
    // This is important in case the old key would cause the component to suspend.
    // We don't have to set the new state here since the subscribing effect above
    // will do that.
    return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}
function $d7ce42c300073b00$var$useRecoilValueLoadable_LEGACY(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    var _useState$1 = (0, $6mdMa._)($d7ce42c300073b00$var$useState$1([]), 2), forceUpdate = _useState$1[1];
    var componentName = $d7ce42c300073b00$var$Recoil_useComponentName();
    var getLoadable = $d7ce42c300073b00$var$useCallback$1(function() {
        var _storeState$nextTree5;
        var store = storeRef.current;
        var storeState = store.getState();
        var treeState = $d7ce42c300073b00$var$reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
        return $d7ce42c300073b00$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    var loadable = getLoadable();
    var prevLoadableRef = $d7ce42c300073b00$var$useRef$4(loadable);
    $d7ce42c300073b00$var$useEffect$3(function() {
        prevLoadableRef.current = loadable;
    });
    $d7ce42c300073b00$var$useEffect$3(function() {
        var store = storeRef.current;
        var storeState = store.getState();
        var subscription = $d7ce42c300073b00$var$subscribeToRecoilValue$1(store, recoilValue, function(_state) {
            var _prevLoadableRef$curr;
            if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_suppress_rerender_in_callback')) return forceUpdate([]);
            var newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }, componentName);
        /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */ if (storeState.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(function() {
            // $FlowFixMe[incompatible-type]
            prevLoadableRef.current = null;
            forceUpdate([]);
        });
        else {
            var _prevLoadableRef$curr2;
            if (!$d7ce42c300073b00$var$Recoil_gkx('recoil_suppress_rerender_in_callback')) return forceUpdate([]);
            var newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }
        return subscription.release;
    }, [
        componentName,
        getLoadable,
        recoilValue,
        storeRef
    ]);
    return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/ function $d7ce42c300073b00$var$useRecoilValueLoadable(recoilValue) {
    if ($d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) // eslint-disable-next-line fb-www/react-hooks
    $d7ce42c300073b00$var$Recoil_useRetain(recoilValue);
    return ({
        TRANSITION_SUPPORT: $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
        // `reactMode()` before calling it.  However, sometimes the host React
        // environment supports it but uses additional React renderers (such as with
        // `react-three-fiber`) which do not.  While this is technically a user issue
        // by using a renderer with React 18+ that doesn't fully support React 18 we
        // don't want to break users if it can be avoided. As the current renderer can
        // change at runtime, we need to dynamically check and fallback if necessary.
        SYNC_EXTERNAL_STORE: $d7ce42c300073b00$var$currentRendererSupportsUseSyncExternalStore$1() ? $d7ce42c300073b00$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE : $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        MUTABLE_SOURCE: $d7ce42c300073b00$var$useRecoilValueLoadable_MUTABLE_SOURCE,
        LEGACY: $d7ce42c300073b00$var$useRecoilValueLoadable_LEGACY
    })[$d7ce42c300073b00$var$reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */ function $d7ce42c300073b00$var$useRecoilValue(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    var loadable = $d7ce42c300073b00$var$useRecoilValueLoadable(recoilValue);
    return $d7ce42c300073b00$var$handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/ function $d7ce42c300073b00$var$useSetRecoilState(recoilState) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    return $d7ce42c300073b00$var$useCallback$1(function(newValueOrUpdater) {
        $d7ce42c300073b00$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/ function $d7ce42c300073b00$var$useResetRecoilState(recoilState) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    return $d7ce42c300073b00$var$useCallback$1(function() {
        $d7ce42c300073b00$var$setRecoilValue$2(storeRef.current, recoilState, $d7ce42c300073b00$var$DEFAULT_VALUE$2);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/ function $d7ce42c300073b00$var$useRecoilState(recoilState) {
    return [
        $d7ce42c300073b00$var$useRecoilValue(recoilState),
        $d7ce42c300073b00$var$useSetRecoilState(recoilState)
    ];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/ function $d7ce42c300073b00$var$useRecoilStateLoadable(recoilState) {
    return [
        $d7ce42c300073b00$var$useRecoilValueLoadable(recoilState),
        $d7ce42c300073b00$var$useSetRecoilState(recoilState)
    ];
}
function $d7ce42c300073b00$var$useSetUnvalidatedAtomValues() {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    return function(values) {
        var transactionMetadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        $d7ce42c300073b00$var$batchUpdates$2(function() {
            storeRef.current.addTransactionMetadata(transactionMetadata);
            values.forEach(function(value, key) {
                return $d7ce42c300073b00$var$setUnvalidatedRecoilValue$2(storeRef.current, new $d7ce42c300073b00$var$AbstractRecoilValue$3(key), value);
            });
        });
    };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */ function $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    if ($d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020')) // eslint-disable-next-line fb-www/react-hooks
    $d7ce42c300073b00$var$Recoil_useRetain(recoilValue);
    return $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}
function $d7ce42c300073b00$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$2();
    var loadable = $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
    return $d7ce42c300073b00$var$handleLoadable(loadable, recoilValue, storeRef);
}
function $d7ce42c300073b00$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
    return [
        $d7ce42c300073b00$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState),
        $d7ce42c300073b00$var$useSetRecoilState(recoilState)
    ];
}
var $d7ce42c300073b00$var$Recoil_Hooks = {
    recoilComponentGetRecoilValueCount_FOR_TESTING: $d7ce42c300073b00$var$recoilComponentGetRecoilValueCount_FOR_TESTING,
    useRecoilInterface: $d7ce42c300073b00$var$useRecoilInterface_DEPRECATED,
    useRecoilState: $d7ce42c300073b00$var$useRecoilState,
    useRecoilStateLoadable: $d7ce42c300073b00$var$useRecoilStateLoadable,
    useRecoilValue: $d7ce42c300073b00$var$useRecoilValue,
    useRecoilValueLoadable: $d7ce42c300073b00$var$useRecoilValueLoadable,
    useResetRecoilState: $d7ce42c300073b00$var$useResetRecoilState,
    useSetRecoilState: $d7ce42c300073b00$var$useSetRecoilState,
    useSetUnvalidatedAtomValues: $d7ce42c300073b00$var$useSetUnvalidatedAtomValues,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $d7ce42c300073b00$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $d7ce42c300073b00$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */ function $d7ce42c300073b00$var$filterMap(map, callback) {
    var result = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6mdMa._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (callback(value, key)) result.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
var $d7ce42c300073b00$var$Recoil_filterMap = $d7ce42c300073b00$var$filterMap;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */ function $d7ce42c300073b00$var$filterSet(set, callback) {
    var result = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (callback(value)) result.add(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
var $d7ce42c300073b00$var$Recoil_filterSet = $d7ce42c300073b00$var$filterSet;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$mergeMaps() {
    for(var _len = arguments.length, maps = new Array(_len), _key = 0; _key < _len; _key++){
        maps[_key] = arguments[_key];
    }
    var result = new Map();
    for(var i = 0; i < maps.length; i++){
        var iterator = maps[i].keys();
        var nextKey = void 0;
        while(!(nextKey = iterator.next()).done)// $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
        result.set(nextKey.value, maps[i].get(nextKey.value));
    }
    return result;
}
var $d7ce42c300073b00$var$Recoil_mergeMaps = $d7ce42c300073b00$var$mergeMaps;
var $d7ce42c300073b00$var$batchUpdates$3 = $d7ce42c300073b00$var$Recoil_Batching.batchUpdates;
var $d7ce42c300073b00$var$DEFAULT_VALUE$3 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE, $d7ce42c300073b00$var$getNode$4 = $d7ce42c300073b00$var$Recoil_Node.getNode, $d7ce42c300073b00$var$nodes$1 = $d7ce42c300073b00$var$Recoil_Node.nodes;
var $d7ce42c300073b00$var$useStoreRef$3 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$AbstractRecoilValue$4 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.AbstractRecoilValue, $d7ce42c300073b00$var$setRecoilValueLoadable$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setRecoilValueLoadable;
var $d7ce42c300073b00$var$SUSPENSE_TIMEOUT_MS$2 = $d7ce42c300073b00$var$Recoil_Retention.SUSPENSE_TIMEOUT_MS;
var $d7ce42c300073b00$var$cloneSnapshot$1 = $d7ce42c300073b00$var$Recoil_Snapshot$1.cloneSnapshot;
var $d7ce42c300073b00$var$useCallback$2 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useCallback, $d7ce42c300073b00$var$useEffect$4 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect, $d7ce42c300073b00$var$useRef$5 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef, $d7ce42c300073b00$var$useState$2 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState;
var $d7ce42c300073b00$var$isSSR$4 = $d7ce42c300073b00$var$Recoil_Environment.isSSR;
function $d7ce42c300073b00$var$useTransactionSubscription(callback) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$3();
    $d7ce42c300073b00$var$useEffect$4(function() {
        var sub = storeRef.current.subscribeToTransactions(callback);
        return sub.release;
    }, [
        callback,
        storeRef
    ]);
}
function $d7ce42c300073b00$var$externallyVisibleAtomValuesInState(state) {
    var atomValues = state.atomValues.toMap();
    var persistedAtomContentsValues = $d7ce42c300073b00$var$Recoil_mapMap($d7ce42c300073b00$var$Recoil_filterMap(atomValues, function(v, k) {
        var node = $d7ce42c300073b00$var$getNode$4(k);
        var persistence = node.persistence_UNSTABLE;
        return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
    }), function(v) {
        return v.contents;
    }); // Merge in nonvalidated atoms; we may not have defs for them but they will
    // all have persistence on or they wouldn't be there in the first place.
    return $d7ce42c300073b00$var$Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}
/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/ function $d7ce42c300073b00$var$useTransactionObservation_DEPRECATED(callback) {
    $d7ce42c300073b00$var$useTransactionSubscription($d7ce42c300073b00$var$useCallback$2(function(store) {
        var previousTree = store.getState().previousTree;
        var currentTree = store.getState().currentTree;
        if (!previousTree) {
            $d7ce42c300073b00$var$Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
            previousTree = store.getState().currentTree; // attempt to trundle on
        }
        var atomValues = $d7ce42c300073b00$var$externallyVisibleAtomValuesInState(currentTree);
        var previousAtomValues = $d7ce42c300073b00$var$externallyVisibleAtomValuesInState(previousTree);
        var atomInfo = $d7ce42c300073b00$var$Recoil_mapMap($d7ce42c300073b00$var$nodes$1, function(node) {
            var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;
            return {
                persistence_UNSTABLE: {
                    type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
                    backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
                }
            };
        }); // Filter on existance in atomValues so that externally-visible rules
        // are also applied to modified atoms (specifically exclude selectors):
        var modifiedAtoms = $d7ce42c300073b00$var$Recoil_filterSet(currentTree.dirtyAtoms, function(k) {
            return atomValues.has(k) || previousAtomValues.has(k);
        });
        callback({
            atomValues: atomValues,
            previousAtomValues: previousAtomValues,
            atomInfo: atomInfo,
            modifiedAtoms: modifiedAtoms,
            transactionMetadata: (0, $hRCmZ._)({}, currentTree.transactionMetadata)
        });
    }, [
        callback
    ]));
}
function $d7ce42c300073b00$var$useRecoilTransactionObserver(callback) {
    $d7ce42c300073b00$var$useTransactionSubscription($d7ce42c300073b00$var$useCallback$2(function(store) {
        var snapshot = $d7ce42c300073b00$var$cloneSnapshot$1(store, 'latest');
        var previousSnapshot = $d7ce42c300073b00$var$cloneSnapshot$1(store, 'previous');
        callback({
            snapshot: snapshot,
            previousSnapshot: previousSnapshot
        });
    }, [
        callback
    ]));
} // Return a snapshot of the current state and subscribe to all state changes
function $d7ce42c300073b00$var$useRecoilSnapshot() {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$3();
    var _useState$2 = (0, $6mdMa._)($d7ce42c300073b00$var$useState$2(function() {
        return $d7ce42c300073b00$var$cloneSnapshot$1(storeRef.current);
    }), 2), snapshot = _useState$2[0], setSnapshot = _useState$2[1];
    var previousSnapshot = $d7ce42c300073b00$var$Recoil_usePrevious(snapshot);
    var timeoutID = $d7ce42c300073b00$var$useRef$5();
    var releaseRef = $d7ce42c300073b00$var$useRef$5();
    $d7ce42c300073b00$var$useTransactionSubscription($d7ce42c300073b00$var$useCallback$2(function(store) {
        return setSnapshot($d7ce42c300073b00$var$cloneSnapshot$1(store));
    }, [])); // Retain snapshot for duration component is mounted
    $d7ce42c300073b00$var$useEffect$4(function() {
        var release = snapshot.retain(); // Release the retain from the rendering call
        if (timeoutID.current && !$d7ce42c300073b00$var$isSSR$4) {
            var _releaseRef$current;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 || _releaseRef$current.call(releaseRef);
            releaseRef.current = null;
        }
        return function() {
            // Defer the release.  If "Fast Refresh"" is used then the component may
            // re-render with the same state.  The previous cleanup will then run and
            // then the new effect will run. We don't want the snapshot to be released
            // by that cleanup before the new effect has a chance to retain it again.
            // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
            window.setTimeout(release, 10);
        };
    }, [
        snapshot
    ]); // Retain snapshot until above effect is run.
    // Release after a threshold in case component is suspended.
    if (previousSnapshot !== snapshot && !$d7ce42c300073b00$var$isSSR$4) {
        // Release the previous snapshot
        if (timeoutID.current) {
            var _releaseRef$current2;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 || _releaseRef$current2.call(releaseRef);
            releaseRef.current = null;
        }
        releaseRef.current = snapshot.retain();
        timeoutID.current = window.setTimeout(function() {
            var _releaseRef$current3;
            timeoutID.current = null;
            (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 || _releaseRef$current3.call(releaseRef);
            releaseRef.current = null;
        }, $d7ce42c300073b00$var$SUSPENSE_TIMEOUT_MS$2);
    }
    return snapshot;
}
function $d7ce42c300073b00$var$gotoSnapshot(store, snapshot) {
    var _storeState$nextTree;
    var storeState = store.getState();
    var prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
    var next = snapshot.getStore_INTERNAL().getState().currentTree;
    $d7ce42c300073b00$var$batchUpdates$3(function() {
        var keysToUpdate = new Set();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var _i = 0, _iter = [
            prev.atomValues.keys(),
            next.atomValues.keys()
        ]; _i < _iter.length; _i++){
            var keys = _iter[_i];
            try {
                for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var _prev$atomValues$get, _next$atomValues$get;
                    if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && $d7ce42c300073b00$var$getNode$4(key).shouldRestoreFromSnapshots) keysToUpdate.add(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        keysToUpdate.forEach(function(key) {
            $d7ce42c300073b00$var$setRecoilValueLoadable$1(store, new $d7ce42c300073b00$var$AbstractRecoilValue$4(key), next.atomValues.has(key) ? $d7ce42c300073b00$var$Recoil_nullthrows(next.atomValues.get(key)) : $d7ce42c300073b00$var$DEFAULT_VALUE$3);
        });
        store.replaceState(function(state) {
            return (0, $7XD9P._)((0, $hRCmZ._)({}, state), {
                stateID: snapshot.getID()
            });
        });
    });
}
function $d7ce42c300073b00$var$useGotoRecoilSnapshot() {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$3();
    return $d7ce42c300073b00$var$useCallback$2(function(snapshot) {
        return $d7ce42c300073b00$var$gotoSnapshot(storeRef.current, snapshot);
    }, [
        storeRef
    ]);
}
var $d7ce42c300073b00$var$Recoil_SnapshotHooks = {
    useRecoilSnapshot: $d7ce42c300073b00$var$useRecoilSnapshot,
    gotoSnapshot: $d7ce42c300073b00$var$gotoSnapshot,
    useGotoRecoilSnapshot: $d7ce42c300073b00$var$useGotoRecoilSnapshot,
    useRecoilTransactionObserver: $d7ce42c300073b00$var$useRecoilTransactionObserver,
    useTransactionObservation_DEPRECATED: $d7ce42c300073b00$var$useTransactionObservation_DEPRECATED,
    useTransactionSubscription_DEPRECATED: $d7ce42c300073b00$var$useTransactionSubscription
};
var $d7ce42c300073b00$var$peekNodeInfo$2 = $d7ce42c300073b00$var$Recoil_FunctionalCore.peekNodeInfo;
var $d7ce42c300073b00$var$useStoreRef$4 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
function $d7ce42c300073b00$var$useGetRecoilValueInfo() {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$4(); // $FlowFixMe[incompatible-return]
    return function(param) {
        var key = param.key;
        return $d7ce42c300073b00$var$peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
    };
}
var $d7ce42c300073b00$var$Recoil_useGetRecoilValueInfo = $d7ce42c300073b00$var$useGetRecoilValueInfo;
var $d7ce42c300073b00$var$reactMode$4 = $d7ce42c300073b00$var$Recoil_ReactMode.reactMode;
var $d7ce42c300073b00$var$RecoilRoot$1 = $d7ce42c300073b00$var$Recoil_RecoilRoot.RecoilRoot, $d7ce42c300073b00$var$useStoreRef$5 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$useMemo$2 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useMemo;
function $d7ce42c300073b00$var$useRecoilBridgeAcrossReactRoots() {
    // The test fails when using useMutableSource(), but only if act() is used
    // for the nested root.  So, this may only be a testing environment issue.
    if ($d7ce42c300073b00$var$reactMode$4().mode === 'MUTABLE_SOURCE') // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
    var store = $d7ce42c300073b00$var$useStoreRef$5().current;
    return $d7ce42c300073b00$var$useMemo$2(function() {
        var RecoilBridge = // eslint-disable-next-line no-shadow
        function RecoilBridge(param) {
            var children = param.children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($d7ce42c300073b00$var$RecoilRoot$1, {
                store_INTERNAL: store
            }, children);
        };
        return RecoilBridge;
    }, [
        store
    ]);
}
var $d7ce42c300073b00$var$Recoil_useRecoilBridgeAcrossReactRoots = $d7ce42c300073b00$var$useRecoilBridgeAcrossReactRoots;
var $d7ce42c300073b00$var$loadableWithValue$1 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithValue;
var $d7ce42c300073b00$var$initializeNode$3 = $d7ce42c300073b00$var$Recoil_FunctionalCore.initializeNode;
var $d7ce42c300073b00$var$DEFAULT_VALUE$4 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE, $d7ce42c300073b00$var$getNode$5 = $d7ce42c300073b00$var$Recoil_Node.getNode;
var $d7ce42c300073b00$var$copyTreeState$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.copyTreeState, $d7ce42c300073b00$var$getRecoilValueAsLoadable$3 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.getRecoilValueAsLoadable, $d7ce42c300073b00$var$invalidateDownstreams$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.invalidateDownstreams, $d7ce42c300073b00$var$writeLoadableToTreeState$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.writeLoadableToTreeState;
function $d7ce42c300073b00$var$isAtom(recoilValue) {
    return $d7ce42c300073b00$var$getNode$5(recoilValue.key).nodeType === 'atom';
}
var $d7ce42c300073b00$var$TransactionInterfaceImpl = /*#__PURE__*/ function() {
    "use strict";
    function TransactionInterfaceImpl(store, treeState) {
        var _this = this;
        (0, $6WLcG._)(this, TransactionInterfaceImpl);
        $d7ce42c300073b00$var$_defineProperty(this, "_store", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_treeState", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_changes", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "get", function(recoilValue) {
            if (_this._changes.has(recoilValue.key)) // $FlowIssue[incompatible-return]
            return _this._changes.get(recoilValue.key);
            if (!$d7ce42c300073b00$var$isAtom(recoilValue)) throw $d7ce42c300073b00$var$Recoil_err('Reading selectors within atomicUpdate is not supported');
            var loadable = $d7ce42c300073b00$var$getRecoilValueAsLoadable$3(_this._store, recoilValue, _this._treeState);
            if (loadable.state === 'hasValue') return loadable.contents;
            else if (loadable.state === 'hasError') throw loadable.contents;
            else throw $d7ce42c300073b00$var$Recoil_err("Expected Recoil atom ".concat(recoilValue.key, " to have a value, but it is in a loading state."));
        });
        $d7ce42c300073b00$var$_defineProperty(this, "set", function(recoilState, valueOrUpdater) {
            if (!$d7ce42c300073b00$var$isAtom(recoilState)) throw $d7ce42c300073b00$var$Recoil_err('Setting selectors within atomicUpdate is not supported');
            if (typeof valueOrUpdater === 'function') {
                var current = _this.get(recoilState);
                _this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off
            } else {
                // Initialize atom and run effects if not initialized yet
                $d7ce42c300073b00$var$initializeNode$3(_this._store, recoilState.key, 'set');
                _this._changes.set(recoilState.key, valueOrUpdater);
            }
        });
        $d7ce42c300073b00$var$_defineProperty(this, "reset", function(recoilState) {
            _this.set(recoilState, $d7ce42c300073b00$var$DEFAULT_VALUE$4);
        });
        this._store = store;
        this._treeState = treeState;
        this._changes = new Map();
    }
    (0, $dbIwN._)(TransactionInterfaceImpl, [
        {
            // eslint-disable-next-line fb-www/extra-arrow-initializer
            key: "newTreeState_INTERNAL",
            value: function newTreeState_INTERNAL() {
                if (this._changes.size === 0) return this._treeState;
                var newState = $d7ce42c300073b00$var$copyTreeState$1(this._treeState);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6mdMa._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        $d7ce42c300073b00$var$writeLoadableToTreeState$1(newState, k, $d7ce42c300073b00$var$loadableWithValue$1(v));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                $d7ce42c300073b00$var$invalidateDownstreams$1(this._store, newState);
                return newState;
            }
        }
    ]);
    return TransactionInterfaceImpl;
}();
function $d7ce42c300073b00$var$atomicUpdater(store) {
    return function(fn) {
        store.replaceState(function(treeState) {
            var changeset = new $d7ce42c300073b00$var$TransactionInterfaceImpl(store, treeState);
            fn(changeset);
            return changeset.newTreeState_INTERNAL();
        });
    };
}
var $d7ce42c300073b00$var$Recoil_AtomicUpdates = {
    atomicUpdater: $d7ce42c300073b00$var$atomicUpdater
};
var $d7ce42c300073b00$var$Recoil_AtomicUpdates_1 = $d7ce42c300073b00$var$Recoil_AtomicUpdates.atomicUpdater;
var $d7ce42c300073b00$var$Recoil_AtomicUpdates$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    atomicUpdater: $d7ce42c300073b00$var$Recoil_AtomicUpdates_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$invariant(condition, message) {
    if (!condition) throw new Error(message);
}
var $d7ce42c300073b00$var$invariant_1 = $d7ce42c300073b00$var$invariant;
// @oss-only
var $d7ce42c300073b00$var$Recoil_invariant = $d7ce42c300073b00$var$invariant_1;
var $d7ce42c300073b00$var$atomicUpdater$1 = $d7ce42c300073b00$var$Recoil_AtomicUpdates$1.atomicUpdater;
var $d7ce42c300073b00$var$batchUpdates$4 = $d7ce42c300073b00$var$Recoil_Batching.batchUpdates;
var $d7ce42c300073b00$var$DEFAULT_VALUE$5 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE;
var $d7ce42c300073b00$var$useStoreRef$6 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$refreshRecoilValue$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.refreshRecoilValue, $d7ce42c300073b00$var$setRecoilValue$3 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setRecoilValue;
var $d7ce42c300073b00$var$cloneSnapshot$2 = $d7ce42c300073b00$var$Recoil_Snapshot$1.cloneSnapshot;
var $d7ce42c300073b00$var$gotoSnapshot$1 = $d7ce42c300073b00$var$Recoil_SnapshotHooks.gotoSnapshot;
var $d7ce42c300073b00$var$useCallback$3 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useCallback;
var $d7ce42c300073b00$var$Sentinel = function Sentinel() {
    "use strict";
    (0, $6WLcG._)(this, Sentinel);
};
var $d7ce42c300073b00$var$SENTINEL = new $d7ce42c300073b00$var$Sentinel();
function $d7ce42c300073b00$var$recoilCallback(store, fn, args, extraInterface) {
    var ret = $d7ce42c300073b00$var$SENTINEL;
    var releaseSnapshot;
    $d7ce42c300073b00$var$batchUpdates$4(function() {
        var errMsg = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
        if (typeof fn !== 'function') throw $d7ce42c300073b00$var$Recoil_err(errMsg);
         // Clone the snapshot lazily to avoid overhead if the callback does not use it.
        // Note that this means the snapshot may represent later state from when
        // the callback was called if it first accesses the snapshot asynchronously.
        var callbackInterface = $d7ce42c300073b00$var$Recoil_lazyProxy((0, $7XD9P._)((0, $hRCmZ._)({}, extraInterface !== null && extraInterface !== void 0 ? extraInterface : {}), {
            // flowlint-line unclear-type:off
            // $FlowFixMe[missing-local-annot]
            set: function(node, newValue) {
                return $d7ce42c300073b00$var$setRecoilValue$3(store, node, newValue);
            },
            // $FlowFixMe[missing-local-annot]
            reset: function(node) {
                return $d7ce42c300073b00$var$setRecoilValue$3(store, node, $d7ce42c300073b00$var$DEFAULT_VALUE$5);
            },
            // $FlowFixMe[missing-local-annot]
            refresh: function(node) {
                return $d7ce42c300073b00$var$refreshRecoilValue$1(store, node);
            },
            gotoSnapshot: function(snapshot) {
                return $d7ce42c300073b00$var$gotoSnapshot$1(store, snapshot);
            },
            transact_UNSTABLE: function(transaction) {
                return $d7ce42c300073b00$var$atomicUpdater$1(store)(transaction);
            }
        }), {
            snapshot: function() {
                var snapshot = $d7ce42c300073b00$var$cloneSnapshot$2(store);
                releaseSnapshot = snapshot.retain();
                return snapshot;
            }
        });
        var callback = fn(callbackInterface);
        if (typeof callback !== 'function') throw $d7ce42c300073b00$var$Recoil_err(errMsg);
        ret = callback.apply(void 0, (0, $bOqL7._)(args));
    });
    !!(ret instanceof $d7ce42c300073b00$var$Sentinel) && $d7ce42c300073b00$var$Recoil_invariant(false);
    if ($d7ce42c300073b00$var$Recoil_isPromise(ret)) ret = ret["finally"](function() {
        var _releaseSnapshot;
        (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 || _releaseSnapshot();
    });
    else {
        var _releaseSnapshot2;
        (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 || _releaseSnapshot2();
    }
    return ret;
}
function $d7ce42c300073b00$var$useRecoilCallback(fn, deps) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$6();
    return $d7ce42c300073b00$var$useCallback$3(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $d7ce42c300073b00$var$recoilCallback(storeRef.current, fn, args);
    }, deps != null ? (0, $bOqL7._)(deps).concat([
        storeRef
    ]) : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $d7ce42c300073b00$var$Recoil_useRecoilCallback = {
    recoilCallback: $d7ce42c300073b00$var$recoilCallback,
    useRecoilCallback: $d7ce42c300073b00$var$useRecoilCallback
};
var $d7ce42c300073b00$var$useStoreRef$7 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$refreshRecoilValue$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.refreshRecoilValue;
var $d7ce42c300073b00$var$useCallback$4 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useCallback;
function $d7ce42c300073b00$var$useRecoilRefresher(recoilValue) {
    var storeRef = $d7ce42c300073b00$var$useStoreRef$7();
    return $d7ce42c300073b00$var$useCallback$4(function() {
        var store = storeRef.current;
        $d7ce42c300073b00$var$refreshRecoilValue$2(store, recoilValue);
    }, [
        recoilValue,
        storeRef
    ]);
}
var $d7ce42c300073b00$var$Recoil_useRecoilRefresher = $d7ce42c300073b00$var$useRecoilRefresher;
var $d7ce42c300073b00$var$atomicUpdater$2 = $d7ce42c300073b00$var$Recoil_AtomicUpdates$1.atomicUpdater;
var $d7ce42c300073b00$var$useStoreRef$8 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useStoreRef;
var $d7ce42c300073b00$var$useMemo$3 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useMemo;
function $d7ce42c300073b00$var$useRecoilTransaction(fn, deps) {
    var _this = this;
    var storeRef = $d7ce42c300073b00$var$useStoreRef$8();
    return $d7ce42c300073b00$var$useMemo$3(function() {
        var _this1 = _this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var atomicUpdate = $d7ce42c300073b00$var$atomicUpdater$2(storeRef.current);
            atomicUpdate(function(transactionInterface) {
                fn(transactionInterface).apply(_this1, (0, $bOqL7._)(args));
            });
        };
    }, deps != null ? (0, $bOqL7._)(deps).concat([
        storeRef
    ]) : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $d7ce42c300073b00$var$Recoil_useRecoilTransaction = $d7ce42c300073b00$var$useRecoilTransaction;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$WrappedValue = function WrappedValue(value) {
    "use strict";
    (0, $6WLcG._)(this, WrappedValue);
    $d7ce42c300073b00$var$_defineProperty(this, "value", void 0);
    this.value = value;
};
var $d7ce42c300073b00$var$Recoil_Wrapper = {
    WrappedValue: $d7ce42c300073b00$var$WrappedValue
};
var $d7ce42c300073b00$var$Recoil_Wrapper_1 = $d7ce42c300073b00$var$Recoil_Wrapper.WrappedValue;
var $d7ce42c300073b00$var$Recoil_Wrapper$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WrappedValue: $d7ce42c300073b00$var$Recoil_Wrapper_1
});
var $d7ce42c300073b00$var$isFastRefreshEnabled$2 = $d7ce42c300073b00$var$Recoil_ReactMode.isFastRefreshEnabled;
var $d7ce42c300073b00$var$ChangedPathError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $a7G5R._)(ChangedPathError, Error1);
    function ChangedPathError() {
        (0, $6WLcG._)(this, ChangedPathError);
        return (0, $bQby9._)(this, ChangedPathError, arguments);
    }
    return ChangedPathError;
}((0, $2DHfY._)(Error));
var $d7ce42c300073b00$var$TreeCache = /*#__PURE__*/ function() {
    "use strict";
    function TreeCache(options) {
        (0, $6WLcG._)(this, TreeCache);
        var _options$onHit, _options$onSet, _options$mapNodeValue;
        $d7ce42c300073b00$var$_defineProperty(this, "_name", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_numLeafs", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_root", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_onHit", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_onSet", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_mapNodeValue", void 0);
        this._name = options === null || options === void 0 ? void 0 : options.name;
        this._numLeafs = 0;
        this._root = null;
        this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : function() {};
        this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : function() {};
        this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : function(val) {
            return val;
        };
    }
    (0, $dbIwN._)(TreeCache, [
        {
            key: "size",
            value: function size() {
                return this._numLeafs;
            } // $FlowIssue[unclear-type]
        },
        {
            key: "root",
            value: function root() {
                return this._root;
            }
        },
        {
            key: "get",
            value: function get(getNodeValue, handlers) {
                var _this$getLeafNode;
                return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
            }
        },
        {
            key: "getLeafNode",
            value: function getLeafNode(getNodeValue, handlers) {
                if (this._root == null) return undefined;
                 // Iterate down the tree based on the current node values until we hit a leaf
                // $FlowIssue[unclear-type]
                var node = this._root;
                while(node){
                    handlers === null || handlers === void 0 || handlers.onNodeVisit(node);
                    if (node.type === 'leaf') {
                        this._onHit(node);
                        return node;
                    }
                    var nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));
                    node = node.branches.get(nodeValue);
                }
                return undefined;
            }
        },
        {
            key: "set",
            value: function set(route, value, handlers) {
                var _this = this;
                var addLeaf = function() {
                    var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;
                    // First, setup the branch nodes for the route:
                    // Iterate down the tree to find or add branch nodes following the route
                    var node;
                    var branchKey;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = route[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $6mdMa._)(_step.value, 2), nodeKey = _step_value[0], nodeValue = _step_value[1];
                            var _node, _handlers$onNodeVisit, _this$_root;
                            // If the previous root was a leaf, while we not have a get(), it means
                            // the selector has inconsistent values or implementation changed.
                            var root = _this._root;
                            if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') throw _this.invalidCacheError();
                             // node now refers to the next node down in the tree
                            var parent = node; // $FlowFixMe[prop-missing]
                            // $FlowFixMe[incompatible-type]
                            node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
                            // $FlowFixMe[incompatible-type]
                            node = (_node = node) !== null && _node !== void 0 ? _node : {
                                type: 'branch',
                                nodeKey: nodeKey,
                                parent: parent,
                                branches: new Map(),
                                branchKey: branchKey
                            }; // If we found an existing node, confirm it has a consistent value
                            if (node.type !== 'branch' || node.nodeKey !== nodeKey) throw _this.invalidCacheError();
                             // Add the branch node to the tree
                            parent === null || parent === void 0 || parent.branches.set(branchKey, node);
                            handlers === null || handlers === void 0 || (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 || _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.
                            branchKey = _this._mapNodeValue(nodeValue);
                            _this._root = (_this$_root = _this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
                        } // Second, setup the leaf node:
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // If there is an existing leaf for this route confirm it is consistent
                    var oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : _this._root;
                    if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) throw _this.invalidCacheError();
                     // Create a new or replacement leaf.
                    var leafNode = {
                        type: 'leaf',
                        value: value,
                        parent: node,
                        branchKey: branchKey
                    }; // Install the leaf and call handlers
                    (_node3 = node) === null || _node3 === void 0 || _node3.branches.set(branchKey, leafNode);
                    _this._root = (_this$_root2 = _this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
                    _this._numLeafs++;
                    _this._onSet(leafNode);
                    handlers === null || handlers === void 0 || (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 || _handlers$onNodeVisit2.call(handlers, leafNode);
                };
                try {
                    addLeaf();
                } catch (error) {
                    // If the cache was stale or observed inconsistent values, such as with
                    // Fast Refresh, then clear it and rebuild with the new values.
                    if (error instanceof $d7ce42c300073b00$var$ChangedPathError) {
                        this.clear();
                        addLeaf();
                    } else throw error;
                }
            } // Returns true if leaf was actually deleted from the tree
        },
        {
            key: "delete",
            value: function _delete(leaf) {
                var root = this.root();
                if (!root) return false;
                if (leaf === root) {
                    this._root = null;
                    this._numLeafs = 0;
                    return true;
                } // Iterate up from the leaf deleteing it from it's parent's branches.
                var node = leaf.parent;
                var branchKey = leaf.branchKey;
                while(node){
                    var _node4;
                    node.branches["delete"](branchKey); // Stop iterating if we hit the root.
                    if (node === root) {
                        if (node.branches.size === 0) {
                            this._root = null;
                            this._numLeafs = 0;
                        } else this._numLeafs--;
                        return true;
                    } // Stop iterating if there are other branches since we don't need to
                    // remove any more nodes.
                    if (node.branches.size > 0) break;
                     // Iterate up to our parent
                    branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
                    node = node.parent;
                } // Confirm that the leaf we are deleting is actually attached to our tree
                for(; node !== root; node = node.parent){
                    if (node == null) return false;
                }
                this._numLeafs--;
                return true;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._numLeafs = 0;
                this._root = null;
            }
        },
        {
            key: "invalidCacheError",
            value: function invalidCacheError() {
                var CHANGED_PATH_ERROR_MESSAGE = $d7ce42c300073b00$var$isFastRefreshEnabled$2() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
                $d7ce42c300073b00$var$Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? " - ".concat(this._name) : ''));
                throw new $d7ce42c300073b00$var$ChangedPathError();
            }
        }
    ]);
    return TreeCache;
}();
var $d7ce42c300073b00$var$Recoil_TreeCache = {
    TreeCache: $d7ce42c300073b00$var$TreeCache
};
var $d7ce42c300073b00$var$Recoil_TreeCache_1 = $d7ce42c300073b00$var$Recoil_TreeCache.TreeCache;
var $d7ce42c300073b00$var$Recoil_TreeCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TreeCache: $d7ce42c300073b00$var$Recoil_TreeCache_1
});
var $d7ce42c300073b00$var$LRUCache = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $6WLcG._)(this, LRUCache);
        var _options$mapKey;
        $d7ce42c300073b00$var$_defineProperty(this, "_maxSize", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_size", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_head", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_tail", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_map", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_keyMapper", void 0);
        this._maxSize = options.maxSize;
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : function(v) {
            return v;
        };
    }
    (0, $dbIwN._)(LRUCache, [
        {
            key: "head",
            value: function head() {
                return this._head;
            }
        },
        {
            key: "tail",
            value: function tail() {
                return this._tail;
            }
        },
        {
            key: "size",
            value: function size() {
                return this._size;
            }
        },
        {
            key: "maxSize",
            value: function maxSize() {
                return this._maxSize;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._map.has(this._keyMapper(key));
            }
        },
        {
            key: "get",
            value: function get(key) {
                var mappedKey = this._keyMapper(key);
                var node = this._map.get(mappedKey);
                if (!node) return undefined;
                this.set(key, node.value);
                return node.value;
            }
        },
        {
            key: "set",
            value: function set(key, val) {
                var mappedKey = this._keyMapper(key);
                var existingNode = this._map.get(mappedKey);
                if (existingNode) this["delete"](key);
                var head = this.head();
                var node = {
                    key: key,
                    right: head,
                    left: null,
                    value: val
                };
                if (head) head.left = node;
                else this._tail = node;
                this._map.set(mappedKey, node);
                this._head = node;
                this._size++;
                this._maybeDeleteLRU();
            }
        },
        {
            key: "_maybeDeleteLRU",
            value: function _maybeDeleteLRU() {
                if (this.size() > this.maxSize()) this.deleteLru();
            }
        },
        {
            key: "deleteLru",
            value: function deleteLru() {
                var tail = this.tail();
                if (tail) this["delete"](tail.key);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var mappedKey = this._keyMapper(key);
                if (!this._size || !this._map.has(mappedKey)) return;
                var node = $d7ce42c300073b00$var$Recoil_nullthrows(this._map.get(mappedKey));
                var right = node.right;
                var left = node.left;
                if (right) right.left = node.left;
                if (left) left.right = node.right;
                if (node === this.head()) this._head = right;
                if (node === this.tail()) this._tail = left;
                this._map["delete"](mappedKey);
                this._size--;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._size = 0;
                this._head = null;
                this._tail = null;
                this._map = new Map();
            }
        }
    ]);
    return LRUCache;
}();
var $d7ce42c300073b00$var$Recoil_LRUCache = {
    LRUCache: $d7ce42c300073b00$var$LRUCache
};
var $d7ce42c300073b00$var$Recoil_LRUCache_1 = $d7ce42c300073b00$var$Recoil_LRUCache.LRUCache;
var $d7ce42c300073b00$var$Recoil_LRUCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    LRUCache: $d7ce42c300073b00$var$Recoil_LRUCache_1
});
var $d7ce42c300073b00$var$LRUCache$1 = $d7ce42c300073b00$var$Recoil_LRUCache$1.LRUCache;
var $d7ce42c300073b00$var$TreeCache$1 = $d7ce42c300073b00$var$Recoil_TreeCache$1.TreeCache;
function $d7ce42c300073b00$var$treeCacheLRU(param) {
    var name = param.name, maxSize = param.maxSize, _param_mapNodeValue = param.mapNodeValue, mapNodeValue = _param_mapNodeValue === void 0 ? function(v) {
        return v;
    } : _param_mapNodeValue;
    var lruCache = new $d7ce42c300073b00$var$LRUCache$1({
        maxSize: maxSize
    });
    var cache = new $d7ce42c300073b00$var$TreeCache$1({
        name: name,
        mapNodeValue: mapNodeValue,
        onHit: function(node) {
            lruCache.set(node, true);
        },
        onSet: function(node) {
            var lruNode = lruCache.tail();
            lruCache.set(node, true);
            if (lruNode && cache.size() > maxSize) // $FlowFixMe[incompatible-call]
            cache["delete"](lruNode.key);
        }
    });
    return cache;
}
var $d7ce42c300073b00$var$Recoil_treeCacheLRU = $d7ce42c300073b00$var$treeCacheLRU;
var $d7ce42c300073b00$var$TIME_WARNING_THRESHOLD_MS = 15;
function $d7ce42c300073b00$var$stringify(x, opt, key) {
    // A optimization to avoid the more expensive JSON.stringify() for simple strings
    // This may lose protection for u2028 and u2029, though.
    if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) return '"'.concat(x, '"');
     // Handle primitive types
    switch(typeof x === "undefined" ? "undefined" : (0, $2xTNA._)(x)){
        case 'undefined':
            return '';
        // JSON.stringify(undefined) returns undefined, but we always want to return a string
        case 'boolean':
            return x ? 'true' : 'false';
        case 'number':
        case 'symbol':
            // case 'bigint': // BigInt is not supported in www
            return String(x);
        case 'string':
            // Add surrounding quotes and escape internal quotes
            return JSON.stringify(x);
        case 'function':
            if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) throw $d7ce42c300073b00$var$Recoil_err('Attempt to serialize function in a Recoil cache key');
            return "__FUNCTION(".concat(x.name, ")__");
    }
    if (x === null) return 'null';
     // Fallback case for unknown types
    if ((typeof x === "undefined" ? "undefined" : (0, $2xTNA._)(x)) !== 'object') {
        var _JSON$stringify;
        return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
    } // Deal with all promises as equivalent for now.
    if ($d7ce42c300073b00$var$Recoil_isPromise(x)) return '__PROMISE__';
     // Arrays handle recursive stringification
    if (Array.isArray(x)) // $FlowFixMe[missing-local-annot]
    return "[".concat(x.map(function(v, i) {
        return $d7ce42c300073b00$var$stringify(v, opt, i.toString());
    }), "]");
     // If an object defines a toJSON() method, then use that to override the
    // serialization.  This matches the behavior of JSON.stringify().
    // Pass the key for compatibility.
    // Immutable.js collections define this method to allow us to serialize them.
    if (typeof x.toJSON === 'function') // flowlint-next-line unclear-type: off
    return $d7ce42c300073b00$var$stringify(x.toJSON(key), opt, key);
     // For built-in Maps, sort the keys in a stable order instead of the
    // default insertion order.  Support non-string keys.
    if (x instanceof Map) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = x[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6mdMa._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                // Stringify will escape any nested quotes
                obj[typeof k === 'string' ? k : $d7ce42c300073b00$var$stringify(k, opt)] = v;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return $d7ce42c300073b00$var$stringify(obj, opt, key);
    } // For built-in Sets, sort the keys in a stable order instead of the
    // default insertion order.
    if (x instanceof Set) return $d7ce42c300073b00$var$stringify(Array.from(x).sort(function(a, b) {
        return $d7ce42c300073b00$var$stringify(a, opt).localeCompare($d7ce42c300073b00$var$stringify(b, opt));
    }), opt, key);
     // Anything else that is iterable serialize as an Array.
    if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') // flowlint-next-line unclear-type: off
    return $d7ce42c300073b00$var$stringify(Array.from(x), opt, key);
     // For all other Objects, sort the keys in a stable order.
    return "{".concat(Object.keys(x).filter(function(k) {
        return x[k] !== undefined;
    }).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
    .map(function(k) {
        return "".concat($d7ce42c300073b00$var$stringify(k, opt), ":").concat($d7ce42c300073b00$var$stringify(x[k], opt, k));
    }).join(','), "}");
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples
function $d7ce42c300073b00$var$stableStringify(x) {
    var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        allowFunctions: false
    };
    return $d7ce42c300073b00$var$stringify(x, opt);
}
var $d7ce42c300073b00$var$Recoil_stableStringify = $d7ce42c300073b00$var$stableStringify;
var $d7ce42c300073b00$var$TreeCache$2 = $d7ce42c300073b00$var$Recoil_TreeCache$1.TreeCache;
var $d7ce42c300073b00$var$defaultPolicy = {
    equality: 'reference',
    eviction: 'keep-all',
    maxSize: Infinity
};
function $d7ce42c300073b00$var$treeCacheFromPolicy() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7ce42c300073b00$var$defaultPolicy, _ref_equality = _ref.equality, equality = _ref_equality === void 0 ? $d7ce42c300073b00$var$defaultPolicy.equality : _ref_equality, _ref_eviction = _ref.eviction, eviction = _ref_eviction === void 0 ? $d7ce42c300073b00$var$defaultPolicy.eviction : _ref_eviction, _ref_maxSize = _ref.maxSize, maxSize = _ref_maxSize === void 0 ? $d7ce42c300073b00$var$defaultPolicy.maxSize : _ref_maxSize, name = arguments.length > 1 ? arguments[1] : void 0;
    var valueMapper = $d7ce42c300073b00$var$getValueMapper(equality);
    return $d7ce42c300073b00$var$getTreeCache(eviction, maxSize, valueMapper, name);
}
function $d7ce42c300073b00$var$getValueMapper(equality) {
    switch(equality){
        case 'reference':
            return function(val) {
                return val;
            };
        case 'value':
            return function(val) {
                return $d7ce42c300073b00$var$Recoil_stableStringify(val);
            };
    }
    throw $d7ce42c300073b00$var$Recoil_err("Unrecognized equality policy ".concat(equality));
}
function $d7ce42c300073b00$var$getTreeCache(eviction, maxSize, mapNodeValue, name) {
    switch(eviction){
        case 'keep-all':
            return new $d7ce42c300073b00$var$TreeCache$2({
                name: name,
                mapNodeValue: mapNodeValue
            });
        case 'lru':
            return $d7ce42c300073b00$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: $d7ce42c300073b00$var$Recoil_nullthrows(maxSize),
                mapNodeValue: mapNodeValue
            });
        case 'most-recent':
            return $d7ce42c300073b00$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: 1,
                mapNodeValue: mapNodeValue
            });
    }
    throw $d7ce42c300073b00$var$Recoil_err("Unrecognized eviction policy ".concat(eviction));
}
var $d7ce42c300073b00$var$Recoil_treeCacheFromPolicy = $d7ce42c300073b00$var$treeCacheFromPolicy;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$isNode(object) {
    var _ownerDocument, _doc$defaultView;
    if (typeof window === 'undefined') return false;
    var doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
    var defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
    return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : (typeof object === "undefined" ? "undefined" : (0, $2xTNA._)(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}
var $d7ce42c300073b00$var$Recoil_isNode = $d7ce42c300073b00$var$isNode;
var $d7ce42c300073b00$var$isReactNative$1 = $d7ce42c300073b00$var$Recoil_Environment.isReactNative, $d7ce42c300073b00$var$isWindow$1 = $d7ce42c300073b00$var$Recoil_Environment.isWindow;
function $d7ce42c300073b00$var$shouldNotBeFrozen(value) {
    // Primitives and functions:
    if (value === null || (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) !== 'object') return true;
     // React elements:
    switch((0, $2xTNA._)(value.$$typeof)){
        case 'symbol':
            return true;
        case 'number':
            return true;
    } // Immutable structures:
    if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) return true;
     // DOM nodes:
    if ($d7ce42c300073b00$var$Recoil_isNode(value)) return true;
    if ($d7ce42c300073b00$var$Recoil_isPromise(value)) return true;
    if (value instanceof Error) return true;
    if (ArrayBuffer.isView(value)) return true;
     // Some environments, just as Jest, don't work with the instanceof check
    if (!$d7ce42c300073b00$var$isReactNative$1 && $d7ce42c300073b00$var$isWindow$1(value)) return true;
    return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)
function $d7ce42c300073b00$var$deepFreezeValue(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) !== 'object' || $d7ce42c300073b00$var$shouldNotBeFrozen(value)) return;
    Object.freeze(value); // Make all properties read-only
    for(var key in value)// $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
        var prop = value[key]; // Prevent infinite recurssion for circular references.
        if ((typeof prop === "undefined" ? "undefined" : (0, $2xTNA._)(prop)) === 'object' && prop != null && !Object.isFrozen(prop)) $d7ce42c300073b00$var$deepFreezeValue(prop);
    }
    Object.seal(value); // This also makes existing properties non-configurable.
}
var $d7ce42c300073b00$var$Recoil_deepFreezeValue = $d7ce42c300073b00$var$deepFreezeValue;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$startPerfBlock(_id) {
    return function() {
        return null;
    };
}
var $d7ce42c300073b00$var$Recoil_PerformanceTimings = {
    startPerfBlock: $d7ce42c300073b00$var$startPerfBlock
};
var $d7ce42c300073b00$var$isLoadable$1 = $d7ce42c300073b00$var$Recoil_Loadable$1.isLoadable, $d7ce42c300073b00$var$loadableWithError$1 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithError, $d7ce42c300073b00$var$loadableWithPromise$1 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithPromise, $d7ce42c300073b00$var$loadableWithValue$2 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithValue;
var $d7ce42c300073b00$var$WrappedValue$1 = $d7ce42c300073b00$var$Recoil_Wrapper$1.WrappedValue;
var $d7ce42c300073b00$var$getNodeLoadable$2 = $d7ce42c300073b00$var$Recoil_FunctionalCore.getNodeLoadable, $d7ce42c300073b00$var$peekNodeLoadable$1 = $d7ce42c300073b00$var$Recoil_FunctionalCore.peekNodeLoadable, $d7ce42c300073b00$var$setNodeValue$3 = $d7ce42c300073b00$var$Recoil_FunctionalCore.setNodeValue;
var $d7ce42c300073b00$var$saveDepsToStore$1 = $d7ce42c300073b00$var$Recoil_Graph.saveDepsToStore;
var $d7ce42c300073b00$var$DEFAULT_VALUE$6 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE, $d7ce42c300073b00$var$getConfigDeletionHandler$1 = $d7ce42c300073b00$var$Recoil_Node.getConfigDeletionHandler, $d7ce42c300073b00$var$getNode$6 = $d7ce42c300073b00$var$Recoil_Node.getNode, $d7ce42c300073b00$var$registerNode$1 = $d7ce42c300073b00$var$Recoil_Node.registerNode;
var $d7ce42c300073b00$var$isRecoilValue$3 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.isRecoilValue;
var $d7ce42c300073b00$var$markRecoilValueModified$1 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.markRecoilValueModified;
var $d7ce42c300073b00$var$retainedByOptionWithDefault$1 = $d7ce42c300073b00$var$Recoil_Retention.retainedByOptionWithDefault;
var $d7ce42c300073b00$var$recoilCallback$1 = $d7ce42c300073b00$var$Recoil_useRecoilCallback.recoilCallback;
var $d7ce42c300073b00$var$startPerfBlock$1 = $d7ce42c300073b00$var$Recoil_PerformanceTimings.startPerfBlock;
var $d7ce42c300073b00$var$Canceled = function Canceled() {
    "use strict";
    (0, $6WLcG._)(this, Canceled);
};
var $d7ce42c300073b00$var$CANCELED = new $d7ce42c300073b00$var$Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */ var $d7ce42c300073b00$var$dependencyStack = []; // for detecting circular dependencies.
var $d7ce42c300073b00$var$waitingStores = new Map();
var $d7ce42c300073b00$var$getNewExecutionID = function() {
    var executionID = 0;
    return function() {
        return executionID++;
    };
}();
/* eslint-disable no-redeclare */ function $d7ce42c300073b00$var$selector(options) {
    var recoilValue = null;
    var key = options.key, get = options.get, cachePolicy = options.cachePolicy_UNSTABLE;
    var set = options.set != null ? options.set : undefined; // flow
    var discoveredDependencyNodeKeys = new Set();
    var cache = $d7ce42c300073b00$var$Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
        equality: 'reference',
        eviction: 'keep-all'
    }, key);
    var retainedBy = $d7ce42c300073b00$var$retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
    var executionInfoMap = new Map();
    var liveStoresCount = 0;
    function selectorIsLive() {
        return !$d7ce42c300073b00$var$Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
    }
    function selectorInit(store) {
        store.getState().knownSelectors.add(key);
        liveStoresCount++;
        return function() {
            liveStoresCount--;
        };
    }
    function selectorShouldDeleteConfigOnRelease() {
        return $d7ce42c300073b00$var$getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
    }
    function resolveAsync(store, state, executionID, loadable, depValues) {
        setCache(state, loadable, depValues);
        notifyStoresOfResolvedAsync(store, executionID);
    }
    function notifyStoresOfResolvedAsync(store, executionID) {
        if (isLatestExecution(store, executionID)) clearExecutionInfo(store);
        notifyWaitingStores(executionID, true);
    }
    /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */ function notifyStoresOfNewAsyncDep(store, executionID) {
        if (isLatestExecution(store, executionID)) {
            var executionInfo = $d7ce42c300073b00$var$Recoil_nullthrows(getExecutionInfo(store));
            executionInfo.stateVersions.clear();
            notifyWaitingStores(executionID, false);
        }
    }
    function notifyWaitingStores(executionID, clearWaitlist) {
        var stores = $d7ce42c300073b00$var$waitingStores.get(executionID);
        if (stores != null) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = stores[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var waitingStore = _step.value;
                    $d7ce42c300073b00$var$markRecoilValueModified$1(waitingStore, $d7ce42c300073b00$var$Recoil_nullthrows(recoilValue));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (clearWaitlist) $d7ce42c300073b00$var$waitingStores["delete"](executionID);
        }
    }
    function markStoreWaitingForResolvedAsync(store, executionID) {
        var stores = $d7ce42c300073b00$var$waitingStores.get(executionID);
        if (stores == null) $d7ce42c300073b00$var$waitingStores.set(executionID, stores = new Set());
        stores.add(store);
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */ function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
        return promise.then(function(value) {
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $d7ce42c300073b00$var$CANCELED;
            }
            var loadable = $d7ce42c300073b00$var$loadableWithValue$2(value);
            resolveAsync(store, state, executionID, loadable, depValues);
            return value;
        })["catch"](function(errorOrPromise) {
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $d7ce42c300073b00$var$CANCELED;
            }
            if ($d7ce42c300073b00$var$Recoil_isPromise(errorOrPromise)) return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
            var loadable = $d7ce42c300073b00$var$loadableWithError$1(errorOrPromise);
            resolveAsync(store, state, executionID, loadable, depValues);
            throw errorOrPromise;
        });
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */ function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
        return promise.then(function(resolvedDep) {
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $d7ce42c300073b00$var$CANCELED;
            } // Check if we are handling a pending Recoil dependency or if the user
            // threw their own Promise to "suspend" a selector evaluation.  We need
            // to check that the loadingDepPromise actually matches the promise that
            // we caught in case the selector happened to catch the promise we threw
            // for a pending Recoil dependency from `getRecoilValue()` and threw
            // their own promise instead.
            if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */ state.atomValues.set(loadingDepsState.loadingDepKey, $d7ce42c300073b00$var$loadableWithValue$2(resolvedDep));
            else /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */ store.getState().knownSelectors.forEach(function(nodeKey) {
                state.atomValues["delete"](nodeKey);
            });
            /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */ var cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);
            if (cachedLoadable && cachedLoadable.state !== 'loading') {
                /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */ if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) notifyStoresOfResolvedAsync(store, executionID);
                if (cachedLoadable.state === 'hasValue') return cachedLoadable.contents;
                else throw cachedLoadable.contents;
            }
            /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */ if (!isLatestExecution(store, executionID)) {
                var executionInfo = getInProgressExecutionInfo(store, state);
                if (executionInfo != null) /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */ return executionInfo.loadingLoadable.contents;
            } // Retry the selector evaluation now that the dependency has resolved
            var _evaluateSelectorGetter = (0, $6mdMa._)(evaluateSelectorGetter(store, state, executionID), 2), loadable = _evaluateSelectorGetter[0], depValues = _evaluateSelectorGetter[1];
            if (loadable.state !== 'loading') resolveAsync(store, state, executionID, loadable, depValues);
            if (loadable.state === 'hasError') throw loadable.contents;
            return loadable.contents;
        })["catch"](function(error) {
            // The selector was released since the request began; ignore the response.
            if (error instanceof $d7ce42c300073b00$var$Canceled) throw $d7ce42c300073b00$var$CANCELED;
            if (!selectorIsLive()) {
                clearExecutionInfo(store);
                throw $d7ce42c300073b00$var$CANCELED;
            }
            var loadable = $d7ce42c300073b00$var$loadableWithError$1(error);
            resolveAsync(store, state, executionID, loadable, existingDeps);
            throw error;
        });
    }
    function updateDeps(store, state, deps, executionID) {
        var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;
        if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
            var _store$getState$nextT, _store$getState3, _store$getState3$next;
            $d7ce42c300073b00$var$saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var nodeKey = _step.value;
                discoveredDependencyNodeKeys.add(nodeKey);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function evaluateSelectorGetter(store, state, executionID) {
        var endPerfBlock = $d7ce42c300073b00$var$startPerfBlock$1(key); // TODO T63965866: use execution ID here
        var duringSynchronousExecution = true;
        var duringAsynchronousExecution = true;
        var finishEvaluation = function() {
            endPerfBlock();
            duringAsynchronousExecution = false;
        };
        var result;
        var resultIsError = false;
        var loadable;
        var loadingDepsState = {
            loadingDepKey: null,
            loadingDepPromise: null
        };
        /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */ var depValues = new Map();
        function getRecoilValue(param) {
            var depKey = param.key;
            var depLoadable = $d7ce42c300073b00$var$getNodeLoadable$2(store, state, depKey);
            depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
            // knows if it has to restart evaluation if one of them is updated before
            // the asynchronous selector completely resolves.
            if (!duringSynchronousExecution) {
                updateDeps(store, state, new Set(depValues.keys()), executionID);
                notifyStoresOfNewAsyncDep(store, executionID);
            }
            switch(depLoadable.state){
                case 'hasValue':
                    return depLoadable.contents;
                case 'hasError':
                    throw depLoadable.contents;
                case 'loading':
                    loadingDepsState.loadingDepKey = depKey;
                    loadingDepsState.loadingDepPromise = depLoadable.contents;
                    throw depLoadable.contents;
            }
            throw $d7ce42c300073b00$var$Recoil_err('Invalid Loadable state');
        }
        var getCallback = function(fn) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (duringAsynchronousExecution) throw $d7ce42c300073b00$var$Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
                !(recoilValue != null) && $d7ce42c300073b00$var$Recoil_invariant(false);
                return $d7ce42c300073b00$var$recoilCallback$1(store, fn, args, {
                    node: recoilValue
                } // flowlint-line unclear-type:off
                );
            };
        };
        try {
            result = get({
                get: getRecoilValue,
                getCallback: getCallback
            });
            result = $d7ce42c300073b00$var$isRecoilValue$3(result) ? getRecoilValue(result) : result;
            if ($d7ce42c300073b00$var$isLoadable$1(result)) {
                if (result.state === 'hasError') resultIsError = true;
                result = result.contents;
            }
            if ($d7ce42c300073b00$var$Recoil_isPromise(result)) result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState)["finally"](finishEvaluation);
            else finishEvaluation();
            result = result instanceof $d7ce42c300073b00$var$WrappedValue$1 ? result.value : result;
        } catch (errorOrDepPromise) {
            result = errorOrDepPromise;
            if ($d7ce42c300073b00$var$Recoil_isPromise(result)) result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState)["finally"](finishEvaluation);
            else {
                resultIsError = true;
                finishEvaluation();
            }
        }
        if (resultIsError) loadable = $d7ce42c300073b00$var$loadableWithError$1(result);
        else if ($d7ce42c300073b00$var$Recoil_isPromise(result)) loadable = $d7ce42c300073b00$var$loadableWithPromise$1(result);
        else loadable = $d7ce42c300073b00$var$loadableWithValue$2(result);
        duringSynchronousExecution = false;
        updateExecutionInfoDepValues(store, executionID, depValues);
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        return [
            loadable,
            depValues
        ];
    }
    function getLoadableFromCacheAndUpdateDeps(store, state) {
        // First, look up in the state cache
        // If it's here, then the deps in the store should already be valid.
        var cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
         // Second, look up in the selector cache and update the deps in the store
        var depsAfterCacheLookup = new Set();
        try {
            cachedLoadable = cache.get(function(nodeKey) {
                !(typeof nodeKey === 'string') && $d7ce42c300073b00$var$Recoil_invariant(false);
                return $d7ce42c300073b00$var$getNodeLoadable$2(store, state, nodeKey).contents;
            }, {
                onNodeVisit: function(node) {
                    if (node.type === 'branch' && node.nodeKey !== key) depsAfterCacheLookup.add(node.nodeKey);
                }
            });
        } catch (error) {
            throw $d7ce42c300073b00$var$Recoil_err('Problem with cache lookup for selector "'.concat(key, '": ').concat(error.message));
        }
        if (cachedLoadable) {
            var _getExecutionInfo;
            // Cache the results in the state to allow for cheaper lookup than
            // iterating the tree cache of dependencies.
            state.atomValues.set(key, cachedLoadable);
            /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */ updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
        }
        return cachedLoadable;
    }
    /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */ function getSelectorLoadableAndUpdateDeps(store, state) {
        // First, see if our current state is cached
        var cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);
        if (cachedVal != null) {
            clearExecutionInfo(store);
            return cachedVal;
        } // Second, check if there is already an ongoing execution based on the current state
        var inProgressExecutionInfo = getInProgressExecutionInfo(store, state);
        if (inProgressExecutionInfo != null) {
            var _inProgressExecutionI;
            if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
             // FIXME: check after the fact to see if we made the right choice by waiting
            return inProgressExecutionInfo.loadingLoadable;
        } // Third, start a new evaluation of the selector
        var newExecutionID = $d7ce42c300073b00$var$getNewExecutionID();
        var _evaluateSelectorGetter = (0, $6mdMa._)(evaluateSelectorGetter(store, state, newExecutionID), 2), loadable = _evaluateSelectorGetter[0], newDepValues = _evaluateSelectorGetter[1];
        /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */ if (loadable.state === 'loading') {
            setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
            markStoreWaitingForResolvedAsync(store, newExecutionID);
        } else {
            clearExecutionInfo(store);
            setCache(state, loadable, newDepValues);
        }
        return loadable;
    }
    /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */ function getInProgressExecutionInfo(store, state) {
        // Sort the pending executions so that our current store is checked first.
        var pendingExecutions = $d7ce42c300073b00$var$Recoil_concatIterables([
            executionInfoMap.has(store) ? [
                $d7ce42c300073b00$var$Recoil_nullthrows(executionInfoMap.get(store))
            ] : [],
            $d7ce42c300073b00$var$Recoil_mapIterable($d7ce42c300073b00$var$Recoil_filterIterable(executionInfoMap, function(param) {
                var _param = (0, $6mdMa._)(param, 1), s = _param[0];
                return s !== store;
            }), function(param) {
                var _param = (0, $6mdMa._)(param, 2), execInfo = _param[1];
                return execInfo;
            })
        ]);
        function anyDepChanged(execDepValues) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = execDepValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $6mdMa._)(_step.value, 2), depKey = _step_value[0], execLoadable = _step_value[1];
                    if (!$d7ce42c300073b00$var$getNodeLoadable$2(store, state, depKey).is(execLoadable)) return true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return false;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = pendingExecutions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var execInfo = _step.value;
                if (// of state, then let's use it!
                execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
                !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
                    execInfo.stateVersions.set(state.version, true);
                    return execInfo;
                } else execInfo.stateVersions.set(state.version, false);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    }
    function getExecutionInfo(store) {
        return executionInfoMap.get(store);
    }
    /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */ function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
        executionInfoMap.set(store, {
            depValuesDiscoveredSoFarDuringAsyncWork: depValues,
            executionID: newExecutionID,
            loadingLoadable: loadable,
            stateVersions: new Map([
                [
                    state.version,
                    true
                ]
            ])
        });
    }
    function updateExecutionInfoDepValues(store, executionID, depValues) {
        // We only need to bother updating the deps for the latest execution because
        // that's all getInProgressExecutionInfo() will be looking for.
        if (isLatestExecution(store, executionID)) {
            var executionInfo = getExecutionInfo(store);
            if (executionInfo != null) executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
        }
    }
    function clearExecutionInfo(store) {
        executionInfoMap["delete"](store);
    }
    function isLatestExecution(store, executionID) {
        var _getExecutionInfo2;
        return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
    }
    /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */ function depValuesToDepRoute(depValues) {
        return Array.from(depValues.entries()).map(function(param) {
            var _param = (0, $6mdMa._)(param, 2), depKey = _param[0], valLoadable = _param[1];
            return [
                depKey,
                valLoadable.contents
            ];
        });
    }
    function setCache(state, loadable, depValues) {
        state.atomValues.set(key, loadable);
        try {
            cache.set(depValuesToDepRoute(depValues), loadable);
        } catch (error) {
            throw $d7ce42c300073b00$var$Recoil_err('Problem with setting cache for selector "'.concat(key, '": ').concat(error.message));
        }
    }
    function detectCircularDependencies(fn) {
        if ($d7ce42c300073b00$var$dependencyStack.includes(key)) {
            var message = "Recoil selector has circular dependencies: ".concat($d7ce42c300073b00$var$dependencyStack.slice($d7ce42c300073b00$var$dependencyStack.indexOf(key)).join(' \u2192 '));
            return $d7ce42c300073b00$var$loadableWithError$1($d7ce42c300073b00$var$Recoil_err(message));
        }
        $d7ce42c300073b00$var$dependencyStack.push(key);
        try {
            return fn();
        } finally{
            $d7ce42c300073b00$var$dependencyStack.pop();
        }
    }
    function selectorPeek(store, state) {
        var cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
        return cache.get(function(nodeKey) {
            var _peekNodeLoadable;
            !(typeof nodeKey === 'string') && $d7ce42c300073b00$var$Recoil_invariant(false);
            return (_peekNodeLoadable = $d7ce42c300073b00$var$peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
        });
    }
    function selectorGet(store, state) {
        return detectCircularDependencies(function() {
            return getSelectorLoadableAndUpdateDeps(store, state);
        });
    }
    function invalidateSelector(state) {
        state.atomValues["delete"](key);
    }
    function clearSelectorCache(store, treeState) {
        !(recoilValue != null) && $d7ce42c300073b00$var$Recoil_invariant(false);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = discoveredDependencyNodeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var nodeKey = _step.value;
                var _node$clearCache;
                var node = $d7ce42c300073b00$var$getNode$6(nodeKey);
                (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, treeState);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        discoveredDependencyNodeKeys.clear();
        invalidateSelector(treeState);
        cache.clear();
        $d7ce42c300073b00$var$markRecoilValueModified$1(store, recoilValue);
    }
    if (set != null) {
        /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */ var selectorSet = function(store, state, newValue) {
            var getRecoilValue = function getRecoilValue(param) {
                var depKey = param.key;
                if (syncSelectorSetFinished) throw $d7ce42c300073b00$var$Recoil_err('Recoil: Async selector sets are not currently supported.');
                var loadable = $d7ce42c300073b00$var$getNodeLoadable$2(store, state, depKey);
                if (loadable.state === 'hasValue') return loadable.contents;
                else if (loadable.state === 'loading') {
                    var msg = 'Getting value of asynchronous atom or selector "'.concat(depKey, '" in a pending state while setting selector "').concat(key, '" is not yet supported.');
                    $d7ce42c300073b00$var$Recoil_recoverableViolation(msg);
                    throw $d7ce42c300073b00$var$Recoil_err(msg);
                } else throw loadable.contents;
            };
            var setRecoilState = function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
            ) {
                if (syncSelectorSetFinished) {
                    var msg = 'Recoil: Async selector sets are not currently supported.';
                    $d7ce42c300073b00$var$Recoil_recoverableViolation(msg);
                    throw $d7ce42c300073b00$var$Recoil_err(msg);
                }
                var setValue = typeof valueOrUpdater === 'function' ? // flowlint-next-line unclear-type:off
                valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
                var upstreamWrites = $d7ce42c300073b00$var$setNodeValue$3(store, state, recoilState.key, setValue);
                upstreamWrites.forEach(function(v, k) {
                    return writes.set(k, v);
                });
            };
            var resetRecoilState = function resetRecoilState(recoilState) {
                setRecoilState(recoilState, $d7ce42c300073b00$var$DEFAULT_VALUE$6);
            };
            var syncSelectorSetFinished = false;
            var writes = new Map();
            var ret = set({
                set: setRecoilState,
                get: getRecoilValue,
                reset: resetRecoilState
            }, newValue); // set should be a void method, but if the user makes it `async`, then it
            // will return a Promise, which we don't currently support.
            if (ret !== undefined) throw $d7ce42c300073b00$var$Recoil_isPromise(ret) ? $d7ce42c300073b00$var$Recoil_err('Recoil: Async selector sets are not currently supported.') : $d7ce42c300073b00$var$Recoil_err('Recoil: selector set should be a void function.');
            syncSelectorSetFinished = true;
            return writes;
        };
        return recoilValue = $d7ce42c300073b00$var$registerNode$1({
            key: key,
            nodeType: 'selector',
            peek: selectorPeek,
            get: selectorGet,
            set: selectorSet,
            init: selectorInit,
            invalidate: invalidateSelector,
            clearCache: clearSelectorCache,
            shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            shouldRestoreFromSnapshots: false,
            retainedBy: retainedBy
        });
    } else return recoilValue = $d7ce42c300073b00$var$registerNode$1({
        key: key,
        nodeType: 'selector',
        peek: selectorPeek,
        get: selectorGet,
        init: selectorInit,
        invalidate: invalidateSelector,
        clearCache: clearSelectorCache,
        shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: false,
        retainedBy: retainedBy
    });
}
/* eslint-enable no-redeclare */ // $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]
$d7ce42c300073b00$var$selector.value = function(value) {
    return new $d7ce42c300073b00$var$WrappedValue$1(value);
};
var $d7ce42c300073b00$var$Recoil_selector = $d7ce42c300073b00$var$selector;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
var $d7ce42c300073b00$var$isLoadable$2 = $d7ce42c300073b00$var$Recoil_Loadable$1.isLoadable, $d7ce42c300073b00$var$loadableWithError$2 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithError, $d7ce42c300073b00$var$loadableWithPromise$2 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithPromise, $d7ce42c300073b00$var$loadableWithValue$3 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithValue;
var $d7ce42c300073b00$var$WrappedValue$2 = $d7ce42c300073b00$var$Recoil_Wrapper$1.WrappedValue;
var $d7ce42c300073b00$var$peekNodeInfo$3 = $d7ce42c300073b00$var$Recoil_FunctionalCore.peekNodeInfo;
var $d7ce42c300073b00$var$DEFAULT_VALUE$7 = $d7ce42c300073b00$var$Recoil_Node.DEFAULT_VALUE, $d7ce42c300073b00$var$DefaultValue$2 = $d7ce42c300073b00$var$Recoil_Node.DefaultValue, $d7ce42c300073b00$var$getConfigDeletionHandler$2 = $d7ce42c300073b00$var$Recoil_Node.getConfigDeletionHandler, $d7ce42c300073b00$var$registerNode$2 = $d7ce42c300073b00$var$Recoil_Node.registerNode, $d7ce42c300073b00$var$setConfigDeletionHandler$1 = $d7ce42c300073b00$var$Recoil_Node.setConfigDeletionHandler;
var $d7ce42c300073b00$var$isRecoilValue$4 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.isRecoilValue;
var $d7ce42c300073b00$var$getRecoilValueAsLoadable$4 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.getRecoilValueAsLoadable, $d7ce42c300073b00$var$markRecoilValueModified$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.markRecoilValueModified, $d7ce42c300073b00$var$setRecoilValue$4 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setRecoilValue, $d7ce42c300073b00$var$setRecoilValueLoadable$2 = $d7ce42c300073b00$var$Recoil_RecoilValueInterface.setRecoilValueLoadable;
var $d7ce42c300073b00$var$retainedByOptionWithDefault$2 = $d7ce42c300073b00$var$Recoil_Retention.retainedByOptionWithDefault;
var $d7ce42c300073b00$var$unwrap = function(x) {
    return x instanceof $d7ce42c300073b00$var$WrappedValue$2 ? x.value : x;
};
function $d7ce42c300073b00$var$baseAtom(options) {
    var key = options.key, persistence = options.persistence_UNSTABLE;
    var retainedBy = $d7ce42c300073b00$var$retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
    var liveStoresCount = 0;
    function unwrapPromise(promise) {
        return $d7ce42c300073b00$var$loadableWithPromise$2(promise.then(function(value) {
            defaultLoadable = $d7ce42c300073b00$var$loadableWithValue$3(value);
            return value;
        })["catch"](function(error) {
            defaultLoadable = $d7ce42c300073b00$var$loadableWithError$2(error);
            throw error;
        }));
    }
    var defaultLoadable = $d7ce42c300073b00$var$Recoil_isPromise(options["default"]) ? unwrapPromise(options["default"]) : $d7ce42c300073b00$var$isLoadable$2(options["default"]) ? options["default"].state === 'loading' ? unwrapPromise(options["default"].contents) : options["default"] : $d7ce42c300073b00$var$loadableWithValue$3($d7ce42c300073b00$var$unwrap(options["default"]));
    maybeFreezeValueOrPromise(defaultLoadable.contents);
    var cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
    // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>
    var cleanupEffectsByStore = new Map();
    function maybeFreezeValueOrPromise(valueOrPromise) {
        var value;
        return valueOrPromise;
    }
    function wrapPendingPromise(store, promise) {
        var wrappedPromise = promise.then(function(value) {
            var _store$getState$nextT, _state$atomValues$get;
            var state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;
            if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) $d7ce42c300073b00$var$setRecoilValue$4(store, node, value);
            return value;
        })["catch"](function(error) {
            var _store$getState$nextT2, _state$atomValues$get2;
            var state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;
            if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) $d7ce42c300073b00$var$setRecoilValueLoadable$2(store, node, $d7ce42c300073b00$var$loadableWithError$2(error));
            throw error;
        });
        return wrappedPromise;
    }
    function initAtom(store, initState, trigger) {
        var _options$effects;
        liveStoresCount++;
        var cleanupAtom = function() {
            var _cleanupEffectsByStor;
            liveStoresCount--;
            (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 || _cleanupEffectsByStor.forEach(function(cleanup) {
                return cleanup();
            });
            cleanupEffectsByStore["delete"](store);
        };
        store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve
        if (defaultLoadable.state === 'loading') {
            var notifyDefaultSubscribers = function() {
                var _store$getState$nextT3;
                var state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;
                if (!state.atomValues.has(key)) $d7ce42c300073b00$var$markRecoilValueModified$2(store, node);
            };
            defaultLoadable.contents["finally"](notifyDefaultSubscribers);
        } ///////////////////
        // Run Atom Effects
        ///////////////////
        var effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;
        if (effects != null) {
            var getLoadable = function getLoadable(recoilValue) {
                // Normally we can just get the current value of another atom.
                // But for our own value we need to check if there is a pending
                // initialized value or get the fallback default value.
                if (isDuringInit && recoilValue.key === key) {
                    // Cast T to S
                    var retValue = initValue; // flowlint-line unclear-type:off
                    return retValue instanceof $d7ce42c300073b00$var$DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
                     : $d7ce42c300073b00$var$Recoil_isPromise(retValue) ? $d7ce42c300073b00$var$loadableWithPromise$2(retValue.then(function(v) {
                        return v instanceof $d7ce42c300073b00$var$DefaultValue$2 ? defaultLoadable.toPromise() // flowlint-line unclear-type:off
                         : v;
                    })) : $d7ce42c300073b00$var$loadableWithValue$3(retValue);
                }
                return $d7ce42c300073b00$var$getRecoilValueAsLoadable$4(store, recoilValue);
            };
            var getPromise = function getPromise(recoilValue) {
                return getLoadable(recoilValue).toPromise();
            };
            var getInfo_UNSTABLE = function getInfo_UNSTABLE(recoilValue) {
                var _store$getState$nextT4;
                var info = $d7ce42c300073b00$var$peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
                return isDuringInit && recoilValue.key === key && !(initValue instanceof $d7ce42c300073b00$var$DefaultValue$2) ? (0, $7XD9P._)((0, $hRCmZ._)({}, info), {
                    isSet: true,
                    loadable: getLoadable(recoilValue)
                }) : info;
            };
            // This state is scoped by Store, since this is in the initAtom() closure
            var initValue = $d7ce42c300073b00$var$DEFAULT_VALUE$7;
            var isDuringInit = true;
            var isInitError = false;
            var pendingSetSelf = null;
            var setSelf = function(effect) {
                return function(valueOrUpdater) {
                    if (isDuringInit) {
                        var currentLoadable = getLoadable(node);
                        var currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : $d7ce42c300073b00$var$DEFAULT_VALUE$7;
                        initValue = typeof valueOrUpdater === 'function' ? valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                         : valueOrUpdater;
                        if ($d7ce42c300073b00$var$Recoil_isPromise(initValue)) initValue = initValue.then(function(value) {
                            // Avoid calling onSet() when setSelf() initializes with a Promise
                            pendingSetSelf = {
                                effect: effect,
                                value: value
                            };
                            return value;
                        });
                    } else {
                        if ($d7ce42c300073b00$var$Recoil_isPromise(valueOrUpdater)) throw $d7ce42c300073b00$var$Recoil_err('Setting atoms to async values is not implemented.');
                        if (typeof valueOrUpdater !== 'function') pendingSetSelf = {
                            effect: effect,
                            value: $d7ce42c300073b00$var$unwrap(valueOrUpdater)
                        };
                        $d7ce42c300073b00$var$setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? function(currentValue) {
                            var newValue = $d7ce42c300073b00$var$unwrap(valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                            ); // $FlowFixMe[incompatible-type]
                            pendingSetSelf = {
                                effect: effect,
                                value: newValue
                            };
                            return newValue;
                        } : $d7ce42c300073b00$var$unwrap(valueOrUpdater));
                    }
                };
            };
            var resetSelf = function(effect) {
                return function() {
                    return setSelf(effect)($d7ce42c300073b00$var$DEFAULT_VALUE$7);
                };
            };
            var onSet = function(effect) {
                return function(handler) {
                    var _cleanupEffectsByStor2;
                    var release = store.subscribeToTransactions(function(currentStore) {
                        var _currentTree$atomValu;
                        // eslint-disable-next-line prefer-const
                        var _currentStore_getState = currentStore.getState(), currentTree = _currentStore_getState.currentTree, previousTree = _currentStore_getState.previousTree;
                        if (!previousTree) {
                            $d7ce42c300073b00$var$Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
                            previousTree = currentTree; // attempt to trundle on
                        }
                        var newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;
                        if (newLoadable.state === 'hasValue') {
                            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;
                            var newValue = newLoadable.contents;
                            var oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
                            var oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : $d7ce42c300073b00$var$DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
                            // Ignore atom value changes that were set via setSelf() in the same effect.
                            // We will still properly call the handler if there was a subsequent
                            // set from something other than an atom effect which was batched
                            // with the `setSelf()` call.  However, we may incorrectly ignore
                            // the handler if the subsequent batched call happens to set the
                            // atom to the exact same value as the `setSelf()`.   But, in that
                            // case, it was kind of a noop, so the semantics are debatable..
                            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) handler(newValue, oldValue, !currentTree.atomValues.has(key));
                            else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) pendingSetSelf = null;
                        }
                    }, key).release;
                    cleanupEffectsByStore.set(store, (0, $bOqL7._)((_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : []).concat([
                        release
                    ]));
                };
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var effect = _step.value;
                    try {
                        var cleanup = effect({
                            node: node,
                            storeID: store.storeID,
                            parentStoreID_UNSTABLE: store.parentStoreID,
                            trigger: trigger,
                            setSelf: setSelf(effect),
                            resetSelf: resetSelf(effect),
                            onSet: onSet(effect),
                            getPromise: getPromise,
                            getLoadable: getLoadable,
                            getInfo_UNSTABLE: getInfo_UNSTABLE
                        });
                        if (cleanup != null) {
                            var _cleanupEffectsByStor3;
                            cleanupEffectsByStore.set(store, (0, $bOqL7._)((_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : []).concat([
                                cleanup
                            ]));
                        }
                    } catch (error) {
                        initValue = error;
                        isInitError = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
            // since we are the ones initializing on first use.
            if (!(initValue instanceof $d7ce42c300073b00$var$DefaultValue$2)) {
                var _store$getState$nextT5;
                var initLoadable = isInitError ? $d7ce42c300073b00$var$loadableWithError$2(initValue) : $d7ce42c300073b00$var$Recoil_isPromise(initValue) ? $d7ce42c300073b00$var$loadableWithPromise$2(wrapPendingPromise(store, initValue)) : $d7ce42c300073b00$var$loadableWithValue$3($d7ce42c300073b00$var$unwrap(initValue));
                maybeFreezeValueOrPromise(initLoadable.contents);
                initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
                // This could happen if the atom was first initialized in an action that
                // also updated some other atom's state.
                (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 || _store$getState$nextT5.atomValues.set(key, initLoadable);
            }
        }
        return cleanupAtom;
    }
    function peekAtom(_store, state) {
        var _ref, _state$atomValues$get3;
        return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
    }
    function getAtom(_store, state) {
        if (state.atomValues.has(key)) // Atom value is stored in state:
        return $d7ce42c300073b00$var$Recoil_nullthrows(state.atomValues.get(key));
        else if (state.nonvalidatedAtoms.has(key)) {
            // Atom value is stored but needs validation before use.
            // We might have already validated it and have a cached validated value:
            if (cachedAnswerForUnvalidatedValue != null) return cachedAnswerForUnvalidatedValue;
            if (persistence == null) {
                $d7ce42c300073b00$var$Recoil_expectationViolation("Tried to restore a persisted value for atom ".concat(key, " but it has no persistence settings."));
                return defaultLoadable;
            }
            var nonvalidatedValue = state.nonvalidatedAtoms.get(key);
            var validatorResult = persistence.validator(nonvalidatedValue, $d7ce42c300073b00$var$DEFAULT_VALUE$7);
            var validatedValueLoadable = validatorResult instanceof $d7ce42c300073b00$var$DefaultValue$2 ? defaultLoadable : $d7ce42c300073b00$var$loadableWithValue$3(validatorResult);
            cachedAnswerForUnvalidatedValue = validatedValueLoadable;
            return cachedAnswerForUnvalidatedValue;
        } else return defaultLoadable;
    }
    function invalidateAtom() {
        cachedAnswerForUnvalidatedValue = undefined;
    }
    function setAtom(_store, state, newValue) {
        // Bail out if we're being set to the existing value, or if we're being
        // reset but have no stored value (validated or unvalidated) to reset from:
        if (state.atomValues.has(key)) {
            var existing = $d7ce42c300073b00$var$Recoil_nullthrows(state.atomValues.get(key));
            if (existing.state === 'hasValue' && newValue === existing.contents) return new Map();
        } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof $d7ce42c300073b00$var$DefaultValue$2) return new Map();
        maybeFreezeValueOrPromise(newValue);
        cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use
        return new Map().set(key, $d7ce42c300073b00$var$loadableWithValue$3(newValue));
    }
    function shouldDeleteConfigOnReleaseAtom() {
        return $d7ce42c300073b00$var$getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
    }
    var node = $d7ce42c300073b00$var$registerNode$2({
        key: key,
        nodeType: 'atom',
        peek: peekAtom,
        get: getAtom,
        set: setAtom,
        init: initAtom,
        invalidate: invalidateAtom,
        shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        persistence_UNSTABLE: options.persistence_UNSTABLE ? {
            type: options.persistence_UNSTABLE.type,
            backButton: options.persistence_UNSTABLE.backButton
        } : undefined,
        shouldRestoreFromSnapshots: true,
        retainedBy: retainedBy
    });
    return node;
} // prettier-ignore
function $d7ce42c300073b00$var$atom(options) {
    var restOptions = (0, $8WUf8._)({}, (0, $kppPx._)(options));
    var optionsDefault = 'default' in options ? options["default"] : new Promise(function() {});
    if ($d7ce42c300073b00$var$isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
    ) return $d7ce42c300073b00$var$atomWithFallback((0, $7XD9P._)((0, $hRCmZ._)({}, restOptions), {
        "default": optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    })); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    else return $d7ce42c300073b00$var$baseAtom((0, $7XD9P._)((0, $hRCmZ._)({}, restOptions), {
        "default": optionsDefault
    }));
}
function $d7ce42c300073b00$var$atomWithFallback(options) {
    var base = $d7ce42c300073b00$var$atom((0, $7XD9P._)((0, $hRCmZ._)({}, options), {
        "default": $d7ce42c300073b00$var$DEFAULT_VALUE$7,
        persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : (0, $7XD9P._)((0, $hRCmZ._)({}, options.persistence_UNSTABLE), {
            validator: function(storedValue) {
                return storedValue instanceof $d7ce42c300073b00$var$DefaultValue$2 ? storedValue : $d7ce42c300073b00$var$Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, $d7ce42c300073b00$var$DEFAULT_VALUE$7);
            }
        }),
        // TODO Hack for now.
        effects: options.effects,
        // flowlint-line unclear-type: off
        effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off
    })); // $FlowFixMe[incompatible-call]
    var sel = $d7ce42c300073b00$var$Recoil_selector({
        key: "".concat(options.key, "__withFallback"),
        get: function(param) {
            var get = param.get;
            var baseValue = get(base);
            return baseValue instanceof $d7ce42c300073b00$var$DefaultValue$2 ? options["default"] : baseValue;
        },
        // $FlowFixMe[incompatible-call]
        set: function(param, newValue) {
            var set = param.set;
            return set(base, newValue);
        },
        // This selector does not need to cache as it is a wrapper selector
        // and the selector within the wrapper selector will have a cache
        // option by default
        cachePolicy_UNSTABLE: {
            eviction: 'most-recent'
        },
        dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
    $d7ce42c300073b00$var$setConfigDeletionHandler$1(sel.key, $d7ce42c300073b00$var$getConfigDeletionHandler$2(options.key));
    return sel;
} // $FlowFixMe[missing-local-annot]
$d7ce42c300073b00$var$atom.value = function(value) {
    return new $d7ce42c300073b00$var$WrappedValue$2(value);
};
var $d7ce42c300073b00$var$Recoil_atom = $d7ce42c300073b00$var$atom;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ var $d7ce42c300073b00$var$MapCache = /*#__PURE__*/ function() {
    "use strict";
    function MapCache(options) {
        (0, $6WLcG._)(this, MapCache);
        var _options$mapKey;
        $d7ce42c300073b00$var$_defineProperty(this, "_map", void 0);
        $d7ce42c300073b00$var$_defineProperty(this, "_keyMapper", void 0);
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : function(v) {
            return v;
        };
    }
    (0, $dbIwN._)(MapCache, [
        {
            key: "size",
            value: function size() {
                return this._map.size;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._map.has(this._keyMapper(key));
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this._map.get(this._keyMapper(key));
            }
        },
        {
            key: "set",
            value: function set(key, val) {
                this._map.set(this._keyMapper(key), val);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this._map["delete"](this._keyMapper(key));
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._map.clear();
            }
        }
    ]);
    return MapCache;
}();
var $d7ce42c300073b00$var$Recoil_MapCache = {
    MapCache: $d7ce42c300073b00$var$MapCache
};
var $d7ce42c300073b00$var$Recoil_MapCache_1 = $d7ce42c300073b00$var$Recoil_MapCache.MapCache;
var $d7ce42c300073b00$var$Recoil_MapCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MapCache: $d7ce42c300073b00$var$Recoil_MapCache_1
});
var $d7ce42c300073b00$var$LRUCache$2 = $d7ce42c300073b00$var$Recoil_LRUCache$1.LRUCache;
var $d7ce42c300073b00$var$MapCache$1 = $d7ce42c300073b00$var$Recoil_MapCache$1.MapCache;
var $d7ce42c300073b00$var$defaultPolicy$1 = {
    equality: 'reference',
    eviction: 'none',
    maxSize: Infinity
};
function $d7ce42c300073b00$var$cacheFromPolicy() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7ce42c300073b00$var$defaultPolicy$1, _ref_equality = _ref.equality, equality = _ref_equality === void 0 ? $d7ce42c300073b00$var$defaultPolicy$1.equality : _ref_equality, _ref_eviction = _ref.eviction, eviction = _ref_eviction === void 0 ? $d7ce42c300073b00$var$defaultPolicy$1.eviction : _ref_eviction, _ref_maxSize = _ref.maxSize, maxSize = _ref_maxSize === void 0 ? $d7ce42c300073b00$var$defaultPolicy$1.maxSize : _ref_maxSize;
    var valueMapper = $d7ce42c300073b00$var$getValueMapper$1(equality);
    var cache = $d7ce42c300073b00$var$getCache(eviction, maxSize, valueMapper);
    return cache;
}
function $d7ce42c300073b00$var$getValueMapper$1(equality) {
    switch(equality){
        case 'reference':
            return function(val) {
                return val;
            };
        case 'value':
            return function(val) {
                return $d7ce42c300073b00$var$Recoil_stableStringify(val);
            };
    }
    throw $d7ce42c300073b00$var$Recoil_err("Unrecognized equality policy ".concat(equality));
}
function $d7ce42c300073b00$var$getCache(eviction, maxSize, mapKey) {
    switch(eviction){
        case 'keep-all':
            return new $d7ce42c300073b00$var$MapCache$1({
                mapKey: mapKey
            });
        case 'lru':
            return new $d7ce42c300073b00$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: $d7ce42c300073b00$var$Recoil_nullthrows(maxSize)
            });
        case 'most-recent':
            return new $d7ce42c300073b00$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: 1
            });
    }
    throw $d7ce42c300073b00$var$Recoil_err("Unrecognized eviction policy ".concat(eviction));
}
var $d7ce42c300073b00$var$Recoil_cacheFromPolicy = $d7ce42c300073b00$var$cacheFromPolicy;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
var $d7ce42c300073b00$var$setConfigDeletionHandler$2 = $d7ce42c300073b00$var$Recoil_Node.setConfigDeletionHandler;
// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }
/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/ function $d7ce42c300073b00$var$atomFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    var atomCache = $d7ce42c300073b00$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
        eviction: 'keep-all'
    }); // Simple atomFamily implementation to cache individual atoms based
    // on the parameter value equality.
    return function(params) {
        var _stableStringify, _options$effects;
        var cachedAtom = atomCache.get(params);
        if (cachedAtom != null) return cachedAtom;
        var cachePolicyForParams_UNSTABLE = options.cachePolicyForParams_UNSTABLE, atomOptions = (0, $c4wKO._)(options, [
            "cachePolicyForParams_UNSTABLE"
        ]);
        var optionsDefault = 'default' in options ? options["default"] : new Promise(function() {});
        var newAtom = $d7ce42c300073b00$var$Recoil_atom((0, $7XD9P._)((0, $hRCmZ._)({}, atomOptions), {
            key: "".concat(options.key, "__").concat((_stableStringify = $d7ce42c300073b00$var$Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'),
            "default": typeof optionsDefault === 'function' ? // Flow doesn't know that T isn't a function, so we need to case to any
            // $FlowIssue[incompatible-use]
            optionsDefault(params) : optionsDefault,
            retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
            effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
        }));
        atomCache.set(params, newAtom);
        $d7ce42c300073b00$var$setConfigDeletionHandler$2(newAtom.key, function() {
            atomCache["delete"](params);
        });
        return newAtom;
    };
}
var $d7ce42c300073b00$var$Recoil_atomFamily = $d7ce42c300073b00$var$atomFamily;
var $d7ce42c300073b00$var$setConfigDeletionHandler$3 = $d7ce42c300073b00$var$Recoil_Node.setConfigDeletionHandler;
// Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify
// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
var $d7ce42c300073b00$var$nextIndex = 0;
/* eslint-disable no-redeclare */ // Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function $d7ce42c300073b00$var$selectorFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    var selectorCache = $d7ce42c300073b00$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
        eviction: 'keep-all'
    });
    return function(params) {
        var _stableStringify;
        // Throw an error with selector key so that it is clear which
        // selector is causing an error
        var cachedSelector;
        try {
            cachedSelector = selectorCache.get(params);
        } catch (error) {
            throw $d7ce42c300073b00$var$Recoil_err("Problem with cache lookup for selector ".concat(options.key, ": ").concat(error.message));
        }
        if (cachedSelector != null) return cachedSelector;
        var myKey = "".concat(options.key, "__selectorFamily/").concat((_stableStringify = $d7ce42c300073b00$var$Recoil_stableStringify(params, {
            // It is possible to use functions in parameters if the user uses
            // a cache with reference equality thanks to the incrementing index.
            allowFunctions: true
        })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void', "/").concat($d7ce42c300073b00$var$nextIndex++); // Append index in case values serialize to the same key string
        var myGet = function(callbacks) {
            return options.get(params)(callbacks);
        };
        var myCachePolicy = options.cachePolicy_UNSTABLE;
        var retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
        var newSelector;
        if (options.set != null) {
            var set = options.set;
            var mySet = function(callbacks, newValue) {
                return set(params)(callbacks, newValue);
            };
            newSelector = $d7ce42c300073b00$var$Recoil_selector({
                key: myKey,
                get: myGet,
                set: mySet,
                cachePolicy_UNSTABLE: myCachePolicy,
                dangerouslyAllowMutability: options.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: retainedBy
            });
        } else newSelector = $d7ce42c300073b00$var$Recoil_selector({
            key: myKey,
            get: myGet,
            cachePolicy_UNSTABLE: myCachePolicy,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            retainedBy_UNSTABLE: retainedBy
        });
        selectorCache.set(params, newSelector);
        $d7ce42c300073b00$var$setConfigDeletionHandler$3(newSelector.key, function() {
            selectorCache["delete"](params);
        });
        return newSelector;
    };
}
/* eslint-enable no-redeclare */ var $d7ce42c300073b00$var$Recoil_selectorFamily = $d7ce42c300073b00$var$selectorFamily;
// flowlint-next-line unclear-type:off
var $d7ce42c300073b00$var$constantSelector = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__constant',
    get: function(constant) {
        return function() {
            return constant;
        };
    },
    cachePolicyForParams_UNSTABLE: {
        equality: 'reference'
    }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.
function $d7ce42c300073b00$var$constSelector(constant) {
    return $d7ce42c300073b00$var$constantSelector(constant);
}
var $d7ce42c300073b00$var$Recoil_constSelector = $d7ce42c300073b00$var$constSelector;
// flowlint-next-line unclear-type:off
var $d7ce42c300073b00$var$throwingSelector = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__error',
    get: function(message) {
        return function() {
            throw $d7ce42c300073b00$var$Recoil_err(message);
        };
    },
    // TODO Why?
    cachePolicyForParams_UNSTABLE: {
        equality: 'reference'
    }
}); // Function that returns a selector which always throws an error
// with the provided message.
function $d7ce42c300073b00$var$errorSelector(message) {
    return $d7ce42c300073b00$var$throwingSelector(message);
}
var $d7ce42c300073b00$var$Recoil_errorSelector = $d7ce42c300073b00$var$errorSelector;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */ function $d7ce42c300073b00$var$readOnlySelector(atom) {
    // flowlint-next-line unclear-type: off
    return atom;
}
var $d7ce42c300073b00$var$Recoil_readOnlySelector = $d7ce42c300073b00$var$readOnlySelector;
var $d7ce42c300073b00$var$loadableWithError$3 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithError, $d7ce42c300073b00$var$loadableWithPromise$3 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithPromise, $d7ce42c300073b00$var$loadableWithValue$4 = $d7ce42c300073b00$var$Recoil_Loadable$1.loadableWithValue;
/////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.
function $d7ce42c300073b00$var$concurrentRequests(getRecoilValue, deps) {
    var results = Array(deps.length).fill(undefined);
    var exceptions = Array(deps.length).fill(undefined);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = deps.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6mdMa._)(_step.value, 2), i = _step_value[0], dep = _step_value[1];
            try {
                results[i] = getRecoilValue(dep);
            } catch (e) {
                // exceptions can either be Promises of pending results or real errors
                exceptions[i] = e;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        results,
        exceptions
    ];
}
function $d7ce42c300073b00$var$isError(exp) {
    return exp != null && !$d7ce42c300073b00$var$Recoil_isPromise(exp);
}
function $d7ce42c300073b00$var$unwrapDependencies(dependencies) {
    return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(function(key) {
        return dependencies[key];
    });
}
function $d7ce42c300073b00$var$wrapResults(dependencies, /* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */ results) {
    return Array.isArray(dependencies) ? results : Object.getOwnPropertyNames(dependencies).reduce(function(out, key, idx) {
        return (0, $7XD9P._)((0, $hRCmZ._)({}, out), (0, $8c6ug._)({}, key, results[idx]));
    }, {});
}
function $d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions) {
    var output = exceptions.map(function(exception, idx) {
        return exception == null ? $d7ce42c300073b00$var$loadableWithValue$4(results[idx]) : $d7ce42c300073b00$var$Recoil_isPromise(exception) ? $d7ce42c300073b00$var$loadableWithPromise$3(exception) : $d7ce42c300073b00$var$loadableWithError$3(exception);
    });
    return $d7ce42c300073b00$var$wrapResults(dependencies, output);
}
function $d7ce42c300073b00$var$combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
    return asyncResults.map(function(result, idx) {
        return(/**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */ result === undefined ? syncResults[idx] : result);
    });
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.
var $d7ce42c300073b00$var$waitForNone = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__waitForNone',
    get: function(dependencies) {
        return function(param) {
            var get = param.get;
            // Issue requests for all dependencies in parallel.
            var deps = $d7ce42c300073b00$var$unwrapDependencies(dependencies);
            var _concurrentRequests = (0, $6mdMa._)($d7ce42c300073b00$var$concurrentRequests(get, deps), 2), results = _concurrentRequests[0], exceptions = _concurrentRequests[1]; // Always return the current status of the results; never block.
            return $d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions);
        };
    },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.
var $d7ce42c300073b00$var$waitForAny = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__waitForAny',
    get: function(dependencies) {
        return function(param) {
            var get = param.get;
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            var deps = $d7ce42c300073b00$var$unwrapDependencies(dependencies);
            var _concurrentRequests = (0, $6mdMa._)($d7ce42c300073b00$var$concurrentRequests(get, deps), 2), results = _concurrentRequests[0], exceptions = _concurrentRequests[1]; // If any results are available, value or error, return the current status
            if (exceptions.some(function(exp) {
                return !$d7ce42c300073b00$var$Recoil_isPromise(exp);
            })) return $d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions);
             // Otherwise, return a promise that will resolve when the next result is
            // available, whichever one happens to be next.  But, if all pending
            // dependencies end up with errors, then reject the promise.
            return new Promise(function(resolve) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var _step_value = (0, $6mdMa._)(_step.value, 2), i = _step_value[0], exp = _step_value[1];
                        if ($d7ce42c300073b00$var$Recoil_isPromise(exp)) exp.then(function(result) {
                            results[i] = result;
                            exceptions[i] = undefined;
                            resolve($d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions));
                        })["catch"](function(error) {
                            exceptions[i] = error;
                            resolve($d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions));
                        });
                    };
                    for(var _iterator = exceptions.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        };
    },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.
var $d7ce42c300073b00$var$waitForAll = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__waitForAll',
    get: function(dependencies) {
        return function(param) {
            var get = param.get;
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            var deps = $d7ce42c300073b00$var$unwrapDependencies(dependencies);
            var _concurrentRequests = (0, $6mdMa._)($d7ce42c300073b00$var$concurrentRequests(get, deps), 2), results = _concurrentRequests[0], exceptions = _concurrentRequests[1]; // If all results are available, return the results
            if (exceptions.every(function(exp) {
                return exp == null;
            })) return $d7ce42c300073b00$var$wrapResults(dependencies, results);
             // If we have any errors, throw the first error
            var error = exceptions.find($d7ce42c300073b00$var$isError);
            if (error != null) throw error;
             // Otherwise, return a promise that will resolve when all results are available
            return Promise.all(exceptions).then(function(exceptionResults) {
                return $d7ce42c300073b00$var$wrapResults(dependencies, $d7ce42c300073b00$var$combineAsyncResultsWithSyncResults(results, exceptionResults));
            });
        };
    },
    dangerouslyAllowMutability: true
});
var $d7ce42c300073b00$var$waitForAllSettled = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__waitForAllSettled',
    get: function(dependencies) {
        return function(param) {
            var get = param.get;
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            var deps = $d7ce42c300073b00$var$unwrapDependencies(dependencies);
            var _concurrentRequests = (0, $6mdMa._)($d7ce42c300073b00$var$concurrentRequests(get, deps), 2), results = _concurrentRequests[0], exceptions = _concurrentRequests[1]; // If all results are available, return the results
            if (exceptions.every(function(exp) {
                return !$d7ce42c300073b00$var$Recoil_isPromise(exp);
            })) return $d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions);
             // Wait for all results to settle
            return Promise.all(exceptions.map(function(exp, i) {
                return $d7ce42c300073b00$var$Recoil_isPromise(exp) ? exp.then(function(result) {
                    results[i] = result;
                    exceptions[i] = undefined;
                })["catch"](function(error) {
                    results[i] = undefined;
                    exceptions[i] = error;
                }) : null;
            })) // Then wrap them as loadables
            .then(function() {
                return $d7ce42c300073b00$var$wrapLoadables(dependencies, results, exceptions);
            });
        };
    },
    dangerouslyAllowMutability: true
});
var $d7ce42c300073b00$var$noWait = $d7ce42c300073b00$var$Recoil_selectorFamily({
    key: '__noWait',
    get: function(dependency) {
        return function(param) {
            var get = param.get;
            try {
                return $d7ce42c300073b00$var$Recoil_selector.value($d7ce42c300073b00$var$loadableWithValue$4(get(dependency)));
            } catch (exception) {
                return $d7ce42c300073b00$var$Recoil_selector.value($d7ce42c300073b00$var$Recoil_isPromise(exception) ? $d7ce42c300073b00$var$loadableWithPromise$3(exception) : $d7ce42c300073b00$var$loadableWithError$3(exception));
            }
        };
    },
    dangerouslyAllowMutability: true
});
var $d7ce42c300073b00$var$Recoil_WaitFor = {
    waitForNone: $d7ce42c300073b00$var$waitForNone,
    waitForAny: $d7ce42c300073b00$var$waitForAny,
    waitForAll: $d7ce42c300073b00$var$waitForAll,
    waitForAllSettled: $d7ce42c300073b00$var$waitForAllSettled,
    noWait: $d7ce42c300073b00$var$noWait
};
var $d7ce42c300073b00$var$RecoilLoadable = $d7ce42c300073b00$var$Recoil_Loadable$1.RecoilLoadable;
var $d7ce42c300073b00$var$DefaultValue$3 = $d7ce42c300073b00$var$Recoil_Node.DefaultValue;
var $d7ce42c300073b00$var$RecoilRoot$2 = $d7ce42c300073b00$var$Recoil_RecoilRoot.RecoilRoot, $d7ce42c300073b00$var$useRecoilStoreID$1 = $d7ce42c300073b00$var$Recoil_RecoilRoot.useRecoilStoreID;
var $d7ce42c300073b00$var$isRecoilValue$5 = $d7ce42c300073b00$var$Recoil_RecoilValue$1.isRecoilValue;
var $d7ce42c300073b00$var$retentionZone$1 = $d7ce42c300073b00$var$Recoil_RetentionZone.retentionZone;
var $d7ce42c300073b00$var$freshSnapshot$2 = $d7ce42c300073b00$var$Recoil_Snapshot$1.freshSnapshot;
var $d7ce42c300073b00$var$useRecoilState$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilState, $d7ce42c300073b00$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilState_TRANSITION_SUPPORT_UNSTABLE, $d7ce42c300073b00$var$useRecoilStateLoadable$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilStateLoadable, $d7ce42c300073b00$var$useRecoilValue$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilValue, $d7ce42c300073b00$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE, $d7ce42c300073b00$var$useRecoilValueLoadable$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilValueLoadable, $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1 = $d7ce42c300073b00$var$Recoil_Hooks.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE, $d7ce42c300073b00$var$useResetRecoilState$1 = $d7ce42c300073b00$var$Recoil_Hooks.useResetRecoilState, $d7ce42c300073b00$var$useSetRecoilState$1 = $d7ce42c300073b00$var$Recoil_Hooks.useSetRecoilState;
var $d7ce42c300073b00$var$useGotoRecoilSnapshot$1 = $d7ce42c300073b00$var$Recoil_SnapshotHooks.useGotoRecoilSnapshot, $d7ce42c300073b00$var$useRecoilSnapshot$1 = $d7ce42c300073b00$var$Recoil_SnapshotHooks.useRecoilSnapshot, $d7ce42c300073b00$var$useRecoilTransactionObserver$1 = $d7ce42c300073b00$var$Recoil_SnapshotHooks.useRecoilTransactionObserver;
var $d7ce42c300073b00$var$useRecoilCallback$1 = $d7ce42c300073b00$var$Recoil_useRecoilCallback.useRecoilCallback;
var $d7ce42c300073b00$var$noWait$1 = $d7ce42c300073b00$var$Recoil_WaitFor.noWait, $d7ce42c300073b00$var$waitForAll$1 = $d7ce42c300073b00$var$Recoil_WaitFor.waitForAll, $d7ce42c300073b00$var$waitForAllSettled$1 = $d7ce42c300073b00$var$Recoil_WaitFor.waitForAllSettled, $d7ce42c300073b00$var$waitForAny$1 = $d7ce42c300073b00$var$Recoil_WaitFor.waitForAny, $d7ce42c300073b00$var$waitForNone$1 = $d7ce42c300073b00$var$Recoil_WaitFor.waitForNone;
var $d7ce42c300073b00$var$Recoil_index = {
    // Types
    DefaultValue: $d7ce42c300073b00$var$DefaultValue$3,
    isRecoilValue: $d7ce42c300073b00$var$isRecoilValue$5,
    RecoilLoadable: $d7ce42c300073b00$var$RecoilLoadable,
    // Global Recoil environment settiongs
    RecoilEnv: $d7ce42c300073b00$var$Recoil_RecoilEnv,
    // Recoil Root
    RecoilRoot: $d7ce42c300073b00$var$RecoilRoot$2,
    useRecoilStoreID: $d7ce42c300073b00$var$useRecoilStoreID$1,
    useRecoilBridgeAcrossReactRoots_UNSTABLE: $d7ce42c300073b00$var$Recoil_useRecoilBridgeAcrossReactRoots,
    // Atoms/Selectors
    atom: $d7ce42c300073b00$var$Recoil_atom,
    selector: $d7ce42c300073b00$var$Recoil_selector,
    // Convenience Atoms/Selectors
    atomFamily: $d7ce42c300073b00$var$Recoil_atomFamily,
    selectorFamily: $d7ce42c300073b00$var$Recoil_selectorFamily,
    constSelector: $d7ce42c300073b00$var$Recoil_constSelector,
    errorSelector: $d7ce42c300073b00$var$Recoil_errorSelector,
    readOnlySelector: $d7ce42c300073b00$var$Recoil_readOnlySelector,
    // Concurrency Helpers for Atoms/Selectors
    noWait: $d7ce42c300073b00$var$noWait$1,
    waitForNone: $d7ce42c300073b00$var$waitForNone$1,
    waitForAny: $d7ce42c300073b00$var$waitForAny$1,
    waitForAll: $d7ce42c300073b00$var$waitForAll$1,
    waitForAllSettled: $d7ce42c300073b00$var$waitForAllSettled$1,
    // Hooks for Atoms/Selectors
    useRecoilValue: $d7ce42c300073b00$var$useRecoilValue$1,
    useRecoilValueLoadable: $d7ce42c300073b00$var$useRecoilValueLoadable$1,
    useRecoilState: $d7ce42c300073b00$var$useRecoilState$1,
    useRecoilStateLoadable: $d7ce42c300073b00$var$useRecoilStateLoadable$1,
    useSetRecoilState: $d7ce42c300073b00$var$useSetRecoilState$1,
    useResetRecoilState: $d7ce42c300073b00$var$useResetRecoilState$1,
    useGetRecoilValueInfo_UNSTABLE: $d7ce42c300073b00$var$Recoil_useGetRecoilValueInfo,
    useRecoilRefresher_UNSTABLE: $d7ce42c300073b00$var$Recoil_useRecoilRefresher,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $d7ce42c300073b00$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $d7ce42c300073b00$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $d7ce42c300073b00$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
    // Hooks for complex operations
    useRecoilCallback: $d7ce42c300073b00$var$useRecoilCallback$1,
    useRecoilTransaction_UNSTABLE: $d7ce42c300073b00$var$Recoil_useRecoilTransaction,
    // Snapshots
    useGotoRecoilSnapshot: $d7ce42c300073b00$var$useGotoRecoilSnapshot$1,
    useRecoilSnapshot: $d7ce42c300073b00$var$useRecoilSnapshot$1,
    useRecoilTransactionObserver_UNSTABLE: $d7ce42c300073b00$var$useRecoilTransactionObserver$1,
    snapshot_UNSTABLE: $d7ce42c300073b00$var$freshSnapshot$2,
    // Memory Management
    useRetain: $d7ce42c300073b00$var$Recoil_useRetain,
    retentionZone: $d7ce42c300073b00$var$retentionZone$1
};
var $d7ce42c300073b00$export$a4e369a19907695d = $d7ce42c300073b00$var$Recoil_index.DefaultValue;
var $d7ce42c300073b00$export$8e2120adc095590f = $d7ce42c300073b00$var$Recoil_index.isRecoilValue;
var $d7ce42c300073b00$export$b04cb8d38132ba6e = $d7ce42c300073b00$var$Recoil_index.RecoilLoadable;
var $d7ce42c300073b00$export$b6bd5219181c222b = $d7ce42c300073b00$var$Recoil_index.RecoilEnv;
var $d7ce42c300073b00$export$f72b9f9819639629 = $d7ce42c300073b00$var$Recoil_index.RecoilRoot;
var $d7ce42c300073b00$export$cb8baa5ebbbeec81 = $d7ce42c300073b00$var$Recoil_index.useRecoilStoreID;
var $d7ce42c300073b00$export$a42d8cff2ac8d9e5 = $d7ce42c300073b00$var$Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var $d7ce42c300073b00$export$5fb5cc0d078610b = $d7ce42c300073b00$var$Recoil_index.atom;
var $d7ce42c300073b00$export$aea217a45095ce11 = $d7ce42c300073b00$var$Recoil_index.selector;
var $d7ce42c300073b00$export$98dc87c59e005bfc = $d7ce42c300073b00$var$Recoil_index.atomFamily;
var $d7ce42c300073b00$export$62317b671b80c71d = $d7ce42c300073b00$var$Recoil_index.selectorFamily;
var $d7ce42c300073b00$export$18e41ac5fdf5533e = $d7ce42c300073b00$var$Recoil_index.constSelector;
var $d7ce42c300073b00$export$47aec13333381be0 = $d7ce42c300073b00$var$Recoil_index.errorSelector;
var $d7ce42c300073b00$export$11880e5adc5def9 = $d7ce42c300073b00$var$Recoil_index.readOnlySelector;
var $d7ce42c300073b00$export$ab07e6aa23cd7e90 = $d7ce42c300073b00$var$Recoil_index.noWait;
var $d7ce42c300073b00$export$5c93b0ea2ae8f20b = $d7ce42c300073b00$var$Recoil_index.waitForNone;
var $d7ce42c300073b00$export$9ee161e2f87911b5 = $d7ce42c300073b00$var$Recoil_index.waitForAny;
var $d7ce42c300073b00$export$4dcf1964c6471cb6 = $d7ce42c300073b00$var$Recoil_index.waitForAll;
var $d7ce42c300073b00$export$a82851251af05082 = $d7ce42c300073b00$var$Recoil_index.waitForAllSettled;
var $d7ce42c300073b00$export$8b71bf98365f8042 = $d7ce42c300073b00$var$Recoil_index.useRecoilValue;
var $d7ce42c300073b00$export$23331814aa7f2650 = $d7ce42c300073b00$var$Recoil_index.useRecoilValueLoadable;
var $d7ce42c300073b00$export$12012bbeae92bfa2 = $d7ce42c300073b00$var$Recoil_index.useRecoilState;
var $d7ce42c300073b00$export$223ac8c28103fd98 = $d7ce42c300073b00$var$Recoil_index.useRecoilStateLoadable;
var $d7ce42c300073b00$export$4102102216e95cfa = $d7ce42c300073b00$var$Recoil_index.useSetRecoilState;
var $d7ce42c300073b00$export$75b418d01f19b2e = $d7ce42c300073b00$var$Recoil_index.useResetRecoilState;
var $d7ce42c300073b00$export$24dc7ee2767b2f1c = $d7ce42c300073b00$var$Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var $d7ce42c300073b00$export$3726f445fa0ad4a7 = $d7ce42c300073b00$var$Recoil_index.useRecoilRefresher_UNSTABLE;
var $d7ce42c300073b00$export$c6e9c47eec22eb86 = $d7ce42c300073b00$var$Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var $d7ce42c300073b00$export$435b1bf0f9f79a38 = $d7ce42c300073b00$var$Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var $d7ce42c300073b00$export$2df379f232d6fe77 = $d7ce42c300073b00$var$Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var $d7ce42c300073b00$export$6ef5088871c318c5 = $d7ce42c300073b00$var$Recoil_index.useRecoilCallback;
var $d7ce42c300073b00$export$4a76cc788f949bc4 = $d7ce42c300073b00$var$Recoil_index.useRecoilTransaction_UNSTABLE;
var $d7ce42c300073b00$export$a7cf2c8ce398f17a = $d7ce42c300073b00$var$Recoil_index.useGotoRecoilSnapshot;
var $d7ce42c300073b00$export$7cc4a4decba383e9 = $d7ce42c300073b00$var$Recoil_index.useRecoilSnapshot;
var $d7ce42c300073b00$export$924c13ee4d1c0013 = $d7ce42c300073b00$var$Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var $d7ce42c300073b00$export$fe4c07befea3edfb = $d7ce42c300073b00$var$Recoil_index.snapshot_UNSTABLE;
var $d7ce42c300073b00$export$f9d5dc8f5133b7e8 = $d7ce42c300073b00$var$Recoil_index.useRetain;
var $d7ce42c300073b00$export$33ebb0dc02dfd75d = $d7ce42c300073b00$var$Recoil_index.retentionZone;
var $d7ce42c300073b00$export$2e2bcd8739ae039 = $d7ce42c300073b00$var$Recoil_index;


function $2e14efed1ccff3b0$export$2e2bcd8739ae039(t, e) {
    return $2e14efed1ccff3b0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $2e14efed1ccff3b0$export$2e2bcd8739ae039(t, e);
}


function $c698bcd5625a6a85$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $2e14efed1ccff3b0$export$2e2bcd8739ae039)(t, o);
}



var $hAGkE = parcelRequire("hAGkE");
var $c12eb6708ebe6a4a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c12eb6708ebe6a4a$var$ReactIs, $c12eb6708ebe6a4a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c12eb6708ebe6a4a$exports = (parcelRequire("2ppU9"))();


function $5ba05e461df8a53f$export$2e2bcd8739ae039() {
    return $5ba05e461df8a53f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5ba05e461df8a53f$export$2e2bcd8739ae039.apply(null, arguments);
}


function $5acd38ed32a4b9b3$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $5acd38ed32a4b9b3$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $5acd38ed32a4b9b3$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $5acd38ed32a4b9b3$var$isAbsolute(to);
    var isFromAbs = from && $5acd38ed32a4b9b3$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $5acd38ed32a4b9b3$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $5acd38ed32a4b9b3$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $5acd38ed32a4b9b3$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $5acd38ed32a4b9b3$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$5acd38ed32a4b9b3$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $5acd38ed32a4b9b3$export$2e2bcd8739ae039 = $5acd38ed32a4b9b3$var$resolvePathname;



var $2xTNA = parcelRequire("2xTNA");
function $98c8286a23cdd071$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $98c8286a23cdd071$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $98c8286a23cdd071$var$valueEqual(item, b[index]);
    });
    if ((typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) === 'object' || (typeof b === "undefined" ? "undefined" : (0, $2xTNA._)(b)) === 'object') {
        var aValue = $98c8286a23cdd071$var$valueOf(a);
        var bValue = $98c8286a23cdd071$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $98c8286a23cdd071$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $98c8286a23cdd071$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $98c8286a23cdd071$export$2e2bcd8739ae039 = $98c8286a23cdd071$var$valueEqual;



var $f6d1c079684e6ade$var$isProduction = true;
var $f6d1c079684e6ade$var$prefix = 'Invariant failed';
function $f6d1c079684e6ade$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($f6d1c079684e6ade$var$isProduction) throw new Error($f6d1c079684e6ade$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($f6d1c079684e6ade$var$prefix, ": ").concat(provided) : $f6d1c079684e6ade$var$prefix;
    throw new Error(value);
}


function $7532da4b02f95725$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $7532da4b02f95725$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $7532da4b02f95725$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $7532da4b02f95725$var$stripBasename(path, prefix) {
    return $7532da4b02f95725$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $7532da4b02f95725$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $7532da4b02f95725$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $7532da4b02f95725$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $7532da4b02f95725$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $7532da4b02f95725$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5acd38ed32a4b9b3$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $7532da4b02f95725$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $98c8286a23cdd071$export$2e2bcd8739ae039)(a.state, b.state);
}
function $7532da4b02f95725$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $7532da4b02f95725$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $7532da4b02f95725$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $7532da4b02f95725$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $7532da4b02f95725$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $7532da4b02f95725$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $7532da4b02f95725$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $7532da4b02f95725$var$PopStateEvent = 'popstate';
var $7532da4b02f95725$var$HashChangeEvent = 'hashchange';
function $7532da4b02f95725$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $7532da4b02f95725$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$7532da4b02f95725$var$canUseDOM && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $7532da4b02f95725$var$supportsHistory();
    var needsHashChangeListener = !$7532da4b02f95725$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $7532da4b02f95725$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $7532da4b02f95725$var$stripTrailingSlash($7532da4b02f95725$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $7532da4b02f95725$var$stripBasename(path, basename);
        return $7532da4b02f95725$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $7532da4b02f95725$var$createTransitionManager();
    function setState(nextState) {
        (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($7532da4b02f95725$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($7532da4b02f95725$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($7532da4b02f95725$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $7532da4b02f95725$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $7532da4b02f95725$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $7532da4b02f95725$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($7532da4b02f95725$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($7532da4b02f95725$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($7532da4b02f95725$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($7532da4b02f95725$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $7532da4b02f95725$var$HashChangeEvent$1 = 'hashchange';
var $7532da4b02f95725$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $7532da4b02f95725$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $7532da4b02f95725$var$stripLeadingSlash,
        decodePath: $7532da4b02f95725$var$addLeadingSlash
    },
    slash: {
        encodePath: $7532da4b02f95725$var$addLeadingSlash,
        decodePath: $7532da4b02f95725$var$addLeadingSlash
    }
};
function $7532da4b02f95725$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $7532da4b02f95725$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $7532da4b02f95725$var$pushHashPath(path) {
    window.location.hash = path;
}
function $7532da4b02f95725$var$replaceHashPath(path) {
    window.location.replace($7532da4b02f95725$var$stripHash(window.location.href) + '#' + path);
}
function $7532da4b02f95725$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$7532da4b02f95725$var$canUseDOM && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $7532da4b02f95725$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $7532da4b02f95725$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $7532da4b02f95725$var$stripTrailingSlash($7532da4b02f95725$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $7532da4b02f95725$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($7532da4b02f95725$var$getHashPath());
        if (basename) path = $7532da4b02f95725$var$stripBasename(path, basename);
        return $7532da4b02f95725$export$90c043f1c57770b8(path);
    }
    var transitionManager = $7532da4b02f95725$var$createTransitionManager();
    function setState(nextState) {
        (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $7532da4b02f95725$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $7532da4b02f95725$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $7532da4b02f95725$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($7532da4b02f95725$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($7532da4b02f95725$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $7532da4b02f95725$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $7532da4b02f95725$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $7532da4b02f95725$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $7532da4b02f95725$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $7532da4b02f95725$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $7532da4b02f95725$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = $7532da4b02f95725$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = $7532da4b02f95725$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                $7532da4b02f95725$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($7532da4b02f95725$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(_$path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $7532da4b02f95725$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = $7532da4b02f95725$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = $7532da4b02f95725$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                $7532da4b02f95725$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($7532da4b02f95725$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = _$path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($7532da4b02f95725$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($7532da4b02f95725$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $7532da4b02f95725$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $7532da4b02f95725$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $7532da4b02f95725$var$createTransitionManager();
    function setState(nextState) {
        (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $7532da4b02f95725$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $7532da4b02f95725$export$90c043f1c57770b8(entry, undefined, createKey()) : $7532da4b02f95725$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $7532da4b02f95725$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $7532da4b02f95725$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $7532da4b02f95725$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $7532da4b02f95725$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $a20d06c951300d92$exports = {};

var $2xTNA = parcelRequire("2xTNA");
var $90cafbf19a2a0dc4$exports = {};
$90cafbf19a2a0dc4$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $a20d06c951300d92$exports = $a20d06c951300d92$var$pathToRegexp;
$a20d06c951300d92$exports.parse = $a20d06c951300d92$var$parse;
$a20d06c951300d92$exports.compile = $a20d06c951300d92$var$compile;
$a20d06c951300d92$exports.tokensToFunction = $a20d06c951300d92$var$tokensToFunction;
$a20d06c951300d92$exports.tokensToRegExp = $a20d06c951300d92$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $a20d06c951300d92$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $a20d06c951300d92$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $a20d06c951300d92$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $a20d06c951300d92$var$escapeGroup(pattern) : asterisk ? '.*' : $a20d06c951300d92$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $a20d06c951300d92$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $a20d06c951300d92$var$escapeString(delimiter) + ']+?';
    return $a20d06c951300d92$var$escapeString(prevText) + '|(?:(?!' + $a20d06c951300d92$var$escapeString(prevText) + ')[^' + $a20d06c951300d92$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $a20d06c951300d92$var$compile(str, options) {
    return $a20d06c951300d92$var$tokensToFunction($a20d06c951300d92$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $a20d06c951300d92$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $a20d06c951300d92$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $a20d06c951300d92$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if ((0, $2xTNA._)(tokens[i]) === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $a20d06c951300d92$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var _$options = opts || {};
        var encode = _$options.pretty ? $a20d06c951300d92$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($90cafbf19a2a0dc4$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $a20d06c951300d92$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $a20d06c951300d92$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $a20d06c951300d92$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $a20d06c951300d92$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $a20d06c951300d92$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $a20d06c951300d92$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $a20d06c951300d92$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $a20d06c951300d92$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($a20d06c951300d92$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $a20d06c951300d92$var$flags(options));
    return $a20d06c951300d92$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $a20d06c951300d92$var$stringToRegexp(path, keys, options) {
    return $a20d06c951300d92$var$tokensToRegExp($a20d06c951300d92$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $a20d06c951300d92$var$tokensToRegExp(tokens, keys, options) {
    if (!$90cafbf19a2a0dc4$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $a20d06c951300d92$var$escapeString(token);
        else {
            var prefix = $a20d06c951300d92$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $a20d06c951300d92$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $a20d06c951300d92$var$attachKeys(new RegExp('^' + route, $a20d06c951300d92$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $a20d06c951300d92$var$pathToRegexp(path, keys, options) {
    if (!$90cafbf19a2a0dc4$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $a20d06c951300d92$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($90cafbf19a2a0dc4$exports(path)) return $a20d06c951300d92$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $a20d06c951300d92$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $413fe78b8be94961$exports = {};
'use strict';

$413fe78b8be94961$exports = (parcelRequire("8uHhA"));


function $191b95e3c74fd64f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $4a48ac78e5d6a269$exports = {};
'use strict';
var $fdf7e2a3eedec082$exports = {};
'use strict';

$fdf7e2a3eedec082$exports = (parcelRequire("b9uOG"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4a48ac78e5d6a269$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4a48ac78e5d6a269$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4a48ac78e5d6a269$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4a48ac78e5d6a269$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4a48ac78e5d6a269$var$TYPE_STATICS = {};
$4a48ac78e5d6a269$var$TYPE_STATICS[$fdf7e2a3eedec082$exports.ForwardRef] = $4a48ac78e5d6a269$var$FORWARD_REF_STATICS;
$4a48ac78e5d6a269$var$TYPE_STATICS[$fdf7e2a3eedec082$exports.Memo] = $4a48ac78e5d6a269$var$MEMO_STATICS;
function $4a48ac78e5d6a269$var$getStatics(component) {
    // React v16.11 and below
    if ($fdf7e2a3eedec082$exports.isMemo(component)) return $4a48ac78e5d6a269$var$MEMO_STATICS;
     // React v16.12 and above
    return $4a48ac78e5d6a269$var$TYPE_STATICS[component['$$typeof']] || $4a48ac78e5d6a269$var$REACT_STATICS;
}
var $4a48ac78e5d6a269$var$defineProperty = Object.defineProperty;
var $4a48ac78e5d6a269$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4a48ac78e5d6a269$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4a48ac78e5d6a269$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4a48ac78e5d6a269$var$getPrototypeOf = Object.getPrototypeOf;
var $4a48ac78e5d6a269$var$objectPrototype = Object.prototype;
function $4a48ac78e5d6a269$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4a48ac78e5d6a269$var$objectPrototype) {
            var inheritedComponent = $4a48ac78e5d6a269$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4a48ac78e5d6a269$var$objectPrototype) $4a48ac78e5d6a269$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4a48ac78e5d6a269$var$getOwnPropertyNames(sourceComponent);
        if ($4a48ac78e5d6a269$var$getOwnPropertySymbols) keys = keys.concat($4a48ac78e5d6a269$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4a48ac78e5d6a269$var$getStatics(targetComponent);
        var sourceStatics = $4a48ac78e5d6a269$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4a48ac78e5d6a269$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4a48ac78e5d6a269$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4a48ac78e5d6a269$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$4a48ac78e5d6a269$exports = $4a48ac78e5d6a269$var$hoistNonReactStatics;


var $f4f5613f4156d471$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $f4f5613f4156d471$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $f4f5613f4156d471$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $f4f5613f4156d471$var$commonjsGlobal[key] = ($f4f5613f4156d471$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $f4f5613f4156d471$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $f4f5613f4156d471$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $f4f5613f4156d471$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $f4f5613f4156d471$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $f4f5613f4156d471$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $f4f5613f4156d471$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($f4f5613f4156d471$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $f4f5613f4156d471$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $f4f5613f4156d471$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $f4f5613f4156d471$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $f4f5613f4156d471$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $f4f5613f4156d471$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createContext || $f4f5613f4156d471$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $f4f5613f4156d471$var$createNamedContext = function createNamedContext(name) {
    var context = $f4f5613f4156d471$var$createContext();
    context.displayName = name;
    return context;
};
var $f4f5613f4156d471$export$c213558b66925821 = /*#__PURE__*/ $f4f5613f4156d471$var$createNamedContext("Router-History");
var $f4f5613f4156d471$export$63baa8ccbe60bb07 = /*#__PURE__*/ $f4f5613f4156d471$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $f4f5613f4156d471$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $f4f5613f4156d471$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $7532da4b02f95725$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
var $f4f5613f4156d471$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $f4f5613f4156d471$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $f4f5613f4156d471$var$messageType;
var $f4f5613f4156d471$var$cache = {};
var $f4f5613f4156d471$var$cacheLimit = 10000;
var $f4f5613f4156d471$var$cacheCount = 0;
function $f4f5613f4156d471$var$compilePath(path) {
    if ($f4f5613f4156d471$var$cache[path]) return $f4f5613f4156d471$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($a20d06c951300d92$exports))).compile(path);
    if ($f4f5613f4156d471$var$cacheCount < $f4f5613f4156d471$var$cacheLimit) {
        $f4f5613f4156d471$var$cache[path] = generator;
        $f4f5613f4156d471$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $f4f5613f4156d471$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $f4f5613f4156d471$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $f4f5613f4156d471$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $7532da4b02f95725$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $f4f5613f4156d471$export$82476f982757e71e(to, computedMatch.params) : (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, to, {
            pathname: $f4f5613f4156d471$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $7532da4b02f95725$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $7532da4b02f95725$export$c3e8bb440bd55b18)(prevLocation, (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $f4f5613f4156d471$var$cache$1 = {};
var $f4f5613f4156d471$var$cacheLimit$1 = 10000;
var $f4f5613f4156d471$var$cacheCount$1 = 0;
function $f4f5613f4156d471$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $f4f5613f4156d471$var$cache$1[cacheKey] || ($f4f5613f4156d471$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($a20d06c951300d92$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($f4f5613f4156d471$var$cacheCount$1 < $f4f5613f4156d471$var$cacheLimit$1) {
        pathCache[path] = result;
        $f4f5613f4156d471$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $f4f5613f4156d471$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $f4f5613f4156d471$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $f4f5613f4156d471$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Children.count(children) === 0;
}
function $f4f5613f4156d471$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $f4f5613f4156d471$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $f4f5613f4156d471$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $f4f5613f4156d471$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
function $f4f5613f4156d471$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $f4f5613f4156d471$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, location, {
        pathname: $f4f5613f4156d471$var$addLeadingSlash(basename) + location.pathname
    });
}
function $f4f5613f4156d471$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $f4f5613f4156d471$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $f4f5613f4156d471$var$createURL(location) {
    return typeof location === "string" ? location : (0, $7532da4b02f95725$export$fe53371bee54353d)(location);
}
function $f4f5613f4156d471$var$staticHandler(methodName) {
    return function() {
        (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
    };
}
function $f4f5613f4156d471$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $f4f5613f4156d471$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $f4f5613f4156d471$var$noop;
        };
        _this.handleBlock = function() {
            return $f4f5613f4156d471$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $f4f5613f4156d471$var$addBasename(basename, (0, $7532da4b02f95725$export$90c043f1c57770b8)(location));
        context.url = $f4f5613f4156d471$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $191b95e3c74fd64f$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $f4f5613f4156d471$var$addLeadingSlash(basename + $f4f5613f4156d471$var$createURL(path));
            },
            action: "POP",
            location: $f4f5613f4156d471$var$stripBasename(basename, (0, $7532da4b02f95725$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $f4f5613f4156d471$var$staticHandler("go"),
            goBack: $f4f5613f4156d471$var$staticHandler("goBack"),
            goForward: $f4f5613f4156d471$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$55185c17a0fcbe46, (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $f4f5613f4156d471$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $f4f5613f4156d471$export$81336c211d5ff295(location.pathname, (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $f4f5613f4156d471$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $191b95e3c74fd64f$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($f4f5613f4156d471$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(Component, (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4a48ac78e5d6a269$exports)))(C, Component);
}
var $f4f5613f4156d471$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useContext;
function $f4f5613f4156d471$export$3420e1dc2c4a518c() {
    return $f4f5613f4156d471$var$useContext($f4f5613f4156d471$export$c213558b66925821);
}
function $f4f5613f4156d471$export$45d76561a5302f2b() {
    return $f4f5613f4156d471$var$useContext($f4f5613f4156d471$export$63baa8ccbe60bb07).location;
}
function $f4f5613f4156d471$export$99eaa27ddbbb95ef() {
    var match = $f4f5613f4156d471$var$useContext($f4f5613f4156d471$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $f4f5613f4156d471$export$632be4bb944c1bc7(path) {
    var location = $f4f5613f4156d471$export$45d76561a5302f2b();
    var match = $f4f5613f4156d471$var$useContext($f4f5613f4156d471$export$63baa8ccbe60bb07).match;
    return path ? $f4f5613f4156d471$export$81336c211d5ff295(location.pathname, path) : match;
}
var $f4f5613f4156d471$var$global$1, $f4f5613f4156d471$var$key, $f4f5613f4156d471$var$buildNames, $f4f5613f4156d471$var$initialBuildName, $f4f5613f4156d471$var$secondaryBuildName;




var $hAGkE = parcelRequire("hAGkE");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $97394a501a830081$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $7532da4b02f95725$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement((0, $f4f5613f4156d471$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $97394a501a830081$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $7532da4b02f95725$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement((0, $f4f5613f4156d471$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component);
var $97394a501a830081$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $97394a501a830081$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $7532da4b02f95725$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $97394a501a830081$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $97394a501a830081$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).forwardRef;
if (typeof $97394a501a830081$var$forwardRef === "undefined") $97394a501a830081$var$forwardRef = $97394a501a830081$var$forwardRefShim;
function $97394a501a830081$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $97394a501a830081$var$LinkAnchor = $97394a501a830081$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $191b95e3c74fd64f$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$97394a501a830081$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($97394a501a830081$var$forwardRefShim !== $97394a501a830081$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $97394a501a830081$export$a6c7ac8248d6e38a = $97394a501a830081$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $97394a501a830081$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $191b95e3c74fd64f$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement((0, $f4f5613f4156d471$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $97394a501a830081$var$normalizeToLocation($97394a501a830081$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $97394a501a830081$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $7532da4b02f95725$export$fe53371bee54353d)(context.location) === (0, $7532da4b02f95725$export$fe53371bee54353d)($97394a501a830081$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($97394a501a830081$var$forwardRefShim !== $97394a501a830081$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(component, props);
    });
});
var $97394a501a830081$var$toType, $97394a501a830081$var$refType;
var $97394a501a830081$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $97394a501a830081$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).forwardRef;
if (typeof $97394a501a830081$var$forwardRef$1 === "undefined") $97394a501a830081$var$forwardRef$1 = $97394a501a830081$var$forwardRefShim$1;
function $97394a501a830081$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $97394a501a830081$export$b0d92dbee9b5b60d = $97394a501a830081$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $191b95e3c74fd64f$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement((0, $f4f5613f4156d471$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $f6d1c079684e6ade$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $97394a501a830081$var$normalizeToLocation($97394a501a830081$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $f4f5613f4156d471$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $97394a501a830081$var$joinClassnames(className, activeClassName);
            style = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($97394a501a830081$var$forwardRefShim$1 !== $97394a501a830081$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($97394a501a830081$export$a6c7ac8248d6e38a, props);
    });
});
var $97394a501a830081$var$ariaCurrentType;


var $10b47c5a212e87a0$export$5b6c28c7dca07ad7 = "my.mojo.ui";
var $10b47c5a212e87a0$export$565b9862d8bb2cf9 = "https://my-mojo-api.mojomortgages.com";
var $10b47c5a212e87a0$export$5be0b31130ab4ac0 = "mojomortgages.com";
var $10b47c5a212e87a0$export$2116b5277b180cfe = "eyJleHBpcnkiOjE5MjQ5MDU2MDAsImNhbGwiOlsicGljayIsInJlYWQiLCJ3cml0ZSIsInN0b3JlIl19";
var $10b47c5a212e87a0$export$b16da5735cf077a8 = "14157de29d8fa1d0c1acb749e3c609251d36d7d08d6e233b250f8029c22a8c50";
var $10b47c5a212e87a0$export$7aca6a4ab3bc1322 = "ApS7Dt4WhTsq4BHlRa7aAz";
var $10b47c5a212e87a0$export$d0fea2c8ddbe4d95 = "mojo-customer-docs-filestack-upload-prod";
var $10b47c5a212e87a0$export$dff5e35862191ad4 = "eu-west-1";
var $10b47c5a212e87a0$export$3fce19fdf0c5de73 = false;
var $10b47c5a212e87a0$export$7eaa56945d1970dc = "zxc8uzc8";
var $10b47c5a212e87a0$export$7bdc003124064e32 = "UA-109672417-1";
var $10b47c5a212e87a0$export$7828cda48901e9b7 = "G-FDVJNC5NH7";
var $10b47c5a212e87a0$export$f9f9a6c285beff09 = "https://products.mojomortgages.com/product-table";
var $10b47c5a212e87a0$export$6faa4a850bc4d0ce = "https://cb8390339fa64f11807558e4289a13e1@o16345.ingest.sentry.io/6502133";
var $10b47c5a212e87a0$export$6377864d12f7eeb3 = "production";
var $10b47c5a212e87a0$export$2779e7d7b88a7290 = "https://drj1s7leu0309.cloudfront.net";
var $10b47c5a212e87a0$export$ebf5b5d131af837 = "https://property-report.mojomortgages.com";
var $10b47c5a212e87a0$export$7570faec158c06ad = "tmd1wk7ean";


var $bcccde1f2f42f600$exports = {};

(function(global, factory) {
    factory($bcccde1f2f42f600$exports, (parcelRequire("hAGkE")));
})($bcccde1f2f42f600$exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



var $2xTNA = parcelRequire("2xTNA");

var $cCIJH = parcelRequire("cCIJH");
function $411b073b3fd49a19$export$7ae44b2cf814df3d(log) {
    console.debug(log);
    $cCIJH.captureMessage($411b073b3fd49a19$var$ParseLog(log), "debug");
}
function $411b073b3fd49a19$export$9a463299e7c50ce7(log) {
    console.info(log);
    $cCIJH.captureMessage($411b073b3fd49a19$var$ParseLog(log), "info");
}
function $411b073b3fd49a19$export$f680f98a13cb9c83(log) {
    console.warn(log);
    $cCIJH.captureMessage($411b073b3fd49a19$var$ParseLog(log), "warning");
}
function $411b073b3fd49a19$export$5c9af0966a1ac889(log) {
    if (log && log.stack && log.message && typeof log.stack === "string") $cCIJH.captureException(log);
    else if (typeof log === "string") $cCIJH.captureMessage($411b073b3fd49a19$var$ParseLog(log), "error");
    else $cCIJH.captureMessage($411b073b3fd49a19$var$ParseLog(log));
    console.error(log);
}
function $411b073b3fd49a19$export$4ac826e4ad745f1(log) {
    console.error(log);
    $cCIJH.captureException(log);
}
/**
 * Could be circular, so we'll catch it just to be sure.
 */ function $411b073b3fd49a19$var$ParseLog(log) {
    try {
        if ((typeof log === "undefined" ? "undefined" : (0, $2xTNA._)(log)) === "object") return JSON.stringify(log);
        return log;
    } catch (err) {
        $411b073b3fd49a19$export$5c9af0966a1ac889(err);
    }
}



var $e686c778565af949$export$2969e4c65c6cdaa0 = (0, $d7ce42c300073b00$export$5fb5cc0d078610b)({
    key: "hasApplicationError",
    "default": null
});
var $e686c778565af949$export$5ccb3488dc14f2bc = (0, $d7ce42c300073b00$export$5fb5cc0d078610b)({
    key: "hasFetchedInitialApplications",
    "default": false
});
var $e686c778565af949$export$1c603332822bee55 = (0, $d7ce42c300073b00$export$5fb5cc0d078610b)({
    key: "applicationSummariesState",
    "default": []
});
var $e686c778565af949$export$190069addebb2e61 = (0, $d7ce42c300073b00$export$98dc87c59e005bfc)({
    key: "fullApplicationsState",
    "default": {}
});
var $e686c778565af949$export$f9c5c0cfb25f2011 = (0, $d7ce42c300073b00$export$62317b671b80c71d)({
    key: "full-applications-access",
    get: function(id) {
        return function(param) {
            var get = param.get;
            return get($e686c778565af949$export$190069addebb2e61(id));
        };
    },
    set: function(id) {
        return function(param, application) {
            var set = param.set, reset = param.reset;
            if (application instanceof (0, $d7ce42c300073b00$export$a4e369a19907695d)) {
                reset($e686c778565af949$export$190069addebb2e61(id));
                return;
            }
            set($e686c778565af949$export$190069addebb2e61(id), application);
        };
    }
});
var $e686c778565af949$export$45f73d4be7eea1d1 = (0, $d7ce42c300073b00$export$98dc87c59e005bfc)({
    key: "application-load-state",
    "default": false
});
var $e686c778565af949$export$6f28534ae09173b9 = (0, $d7ce42c300073b00$export$62317b671b80c71d)({
    key: "application-load-state-access",
    get: function(id) {
        return function(param) {
            var get = param.get;
            return get($e686c778565af949$export$45f73d4be7eea1d1(id));
        };
    },
    set: function(id) {
        return function(param, value) {
            var set = param.set, reset = param.reset;
            set($e686c778565af949$export$45f73d4be7eea1d1(id), value);
        };
    }
});
var $e686c778565af949$export$a8e432ea130e3750 = (0, $d7ce42c300073b00$export$5fb5cc0d078610b)({
    key: "tooltipState",
    "default": []
});



var $hAGkE = parcelRequire("hAGkE");

var $337a4240dba910e9$var$ScrollToTop = function() {
    var pathname = (0, $f4f5613f4156d471$export$45d76561a5302f2b)().pathname;
    (0, $hAGkE.useEffect)(function() {
        document.querySelector("#root").scrollTop = 0;
    }, [
        pathname
    ]);
    return null;
};
var $337a4240dba910e9$export$2e2bcd8739ae039 = $337a4240dba910e9$var$ScrollToTop;



parcelRequire("hAGkE");
function $a50e02d455b7efe5$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



parcelRequire("hAGkE");
var $62d655c53090e8a3$exports = {};

$parcel$defineInteropFlag($62d655c53090e8a3$exports);

$parcel$export($62d655c53090e8a3$exports, "isStyledComponent", function () { return $62d655c53090e8a3$export$7ba318d8d2f06c76; });
$parcel$export($62d655c53090e8a3$exports, "version", function () { return $62d655c53090e8a3$export$83d89fbfd8236492; });
$parcel$export($62d655c53090e8a3$exports, "StyleSheetContext", function () { return $62d655c53090e8a3$export$8c190ef828af4c86; });
$parcel$export($62d655c53090e8a3$exports, "StyleSheetConsumer", function () { return $62d655c53090e8a3$export$91317688fc694efa; });
$parcel$export($62d655c53090e8a3$exports, "StyleSheetManager", function () { return $62d655c53090e8a3$export$a473771da2f0ff7c; });
$parcel$export($62d655c53090e8a3$exports, "css", function () { return $62d655c53090e8a3$export$dbf350e5966cf602; });
$parcel$export($62d655c53090e8a3$exports, "ThemeContext", function () { return $62d655c53090e8a3$export$2c657da244d00bd6; });
$parcel$export($62d655c53090e8a3$exports, "ThemeConsumer", function () { return $62d655c53090e8a3$export$b631efc24e9d5e2f; });
$parcel$export($62d655c53090e8a3$exports, "ThemeProvider", function () { return $62d655c53090e8a3$export$d8964aec282183a3; });
$parcel$export($62d655c53090e8a3$exports, "createGlobalStyle", function () { return $62d655c53090e8a3$export$f0f03736edb61697; });
$parcel$export($62d655c53090e8a3$exports, "keyframes", function () { return $62d655c53090e8a3$export$d25ddfdf17c3ad3e; });
$parcel$export($62d655c53090e8a3$exports, "ServerStyleSheet", function () { return $62d655c53090e8a3$export$ae8c7d15c8b89a20; });
$parcel$export($62d655c53090e8a3$exports, "withTheme", function () { return $62d655c53090e8a3$export$e8748c6a27b910dc; });
$parcel$export($62d655c53090e8a3$exports, "useTheme", function () { return $62d655c53090e8a3$export$93d4e7f90805808f; });
$parcel$export($62d655c53090e8a3$exports, "__PRIVATE__", function () { return $62d655c53090e8a3$export$5c87cfe6c475f500; });
$parcel$export($62d655c53090e8a3$exports, "default", function () { return $62d655c53090e8a3$export$2e2bcd8739ae039; });

var $2xTNA = parcelRequire("2xTNA");
var $c13a927bf342f167$exports = {};
'use strict';

$c13a927bf342f167$exports = (parcelRequire("1SuQJ"));



var $hAGkE = parcelRequire("hAGkE");
var $96637ddbcefe0e04$exports = {};
//

var $2xTNA = parcelRequire("2xTNA");
$96637ddbcefe0e04$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $2xTNA._)(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : (0, $2xTNA._)(objB)) !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};



var $2xTNA = parcelRequire("2xTNA");
function $858ca8570e671394$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, _$B = e.length, J = _$B - 1, y, f = '', p = '', F = '', G = '', C; l < _$B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, _$B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < _$B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === (typeof d === "undefined" ? "undefined" : (0, $2xTNA._)(d))) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $858ca8570e671394$export$2e2bcd8739ae039 = $858ca8570e671394$var$stylis_min;


var $635f68e94e52c164$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $635f68e94e52c164$export$2e2bcd8739ae039 = $635f68e94e52c164$var$unitlessKeys;


function $122972943347b47c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $539e05827a2c6840$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $539e05827a2c6840$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $122972943347b47c$export$2e2bcd8739ae039)(function(prop) {
    return $539e05827a2c6840$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



function $62d655c53090e8a3$var$y() {
    return ($62d655c53090e8a3$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var _$r in n)Object.prototype.hasOwnProperty.call(n, _$r) && (e[_$r] = n[_$r]);
        }
        return e;
    }).apply(this, arguments);
}
var $62d655c53090e8a3$var$v = function v(e, t) {
    for(var n = [
        e[0]
    ], _$r = 0, o = t.length; _$r < o; _$r += 1)n.push(t[_$r], e[_$r + 1]);
    return n;
}, $62d655c53090e8a3$var$g = function g(t) {
    return null !== t && "object" == (typeof t === "undefined" ? "undefined" : (0, $2xTNA._)(t)) && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $c13a927bf342f167$exports.typeOf)(t);
}, $62d655c53090e8a3$var$S = Object.freeze([]), $62d655c53090e8a3$var$w = Object.freeze({});
function $62d655c53090e8a3$var$E(e) {
    return "function" == typeof e;
}
function $62d655c53090e8a3$var$b(e) {
    return e.displayName || e.name || "Component";
}
function $62d655c53090e8a3$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $62d655c53090e8a3$var$N = "data-styled", $62d655c53090e8a3$export$83d89fbfd8236492 = "5.3.11", $62d655c53090e8a3$var$C = "undefined" != typeof window && "HTMLElement" in window, $62d655c53090e8a3$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $62d655c53090e8a3$var$P = {}, $62d655c53090e8a3$var$O = {};
function $62d655c53090e8a3$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, _$r = arguments.length; n < _$r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $62d655c53090e8a3$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $62d655c53090e8a3$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$r = n.length, o = _$r; e >= o;)(o <<= 1) < 0 && $62d655c53090e8a3$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = _$r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < _$r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$r = this.indexOfGroup(e), o = _$r + n, s = _$r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $62d655c53090e8a3$var$T = new Map, $62d655c53090e8a3$var$x = new Map, $62d655c53090e8a3$var$k = 1, $62d655c53090e8a3$var$V = function V(e) {
    if ($62d655c53090e8a3$var$T.has(e)) return $62d655c53090e8a3$var$T.get(e);
    for(; $62d655c53090e8a3$var$x.has($62d655c53090e8a3$var$k);)$62d655c53090e8a3$var$k++;
    var t = $62d655c53090e8a3$var$k++;
    return $62d655c53090e8a3$var$T.set(e, t), $62d655c53090e8a3$var$x.set(t, e), t;
}, $62d655c53090e8a3$var$B = function B(e) {
    return $62d655c53090e8a3$var$x.get(e);
}, $62d655c53090e8a3$var$z = function z(e, t) {
    t >= $62d655c53090e8a3$var$k && ($62d655c53090e8a3$var$k = t + 1), $62d655c53090e8a3$var$T.set(e, t), $62d655c53090e8a3$var$x.set(t, e);
}, $62d655c53090e8a3$var$M = "style[" + $62d655c53090e8a3$var$N + '][data-styled-version="5.3.11"]', $62d655c53090e8a3$var$G = new RegExp("^" + $62d655c53090e8a3$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $62d655c53090e8a3$var$L = function L(e, t, n) {
    for(var _$r, o = n.split(","), s = 0, i = o.length; s < i; s++)(_$r = o[s]) && e.registerName(t, _$r);
}, $62d655c53090e8a3$var$F = function F(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), _$r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($62d655c53090e8a3$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($62d655c53090e8a3$var$z(u, c), $62d655c53090e8a3$var$L(e, u, a[3]), e.getTag().insertRules(c, _$r)), _$r.length = 0;
            } else _$r.push(i);
        }
    }
}, $62d655c53090e8a3$var$Y = function Y() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $62d655c53090e8a3$var$q = function q(e) {
    var t = document.head, n = e || t, _$r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var _$r = t[n];
            if (_$r && 1 === _$r.nodeType && _$r.hasAttribute($62d655c53090e8a3$var$N)) return _$r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    _$r.setAttribute($62d655c53090e8a3$var$N, "active"), _$r.setAttribute("data-styled-version", "5.3.11");
    var i = $62d655c53090e8a3$var$Y();
    return i && _$r.setAttribute("nonce", i), n.insertBefore(_$r, s), _$r;
}, $62d655c53090e8a3$var$H = function() {
    function e(e) {
        var t = this.element = $62d655c53090e8a3$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$r = t.length; n < _$r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $62d655c53090e8a3$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $62d655c53090e8a3$var$$ = function() {
    function e(e) {
        var t = this.element = $62d655c53090e8a3$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), _$r = this.nodes[e];
            return this.element.insertBefore(n, _$r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $62d655c53090e8a3$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $62d655c53090e8a3$var$U = $62d655c53090e8a3$var$C, $62d655c53090e8a3$var$J = {
    isServer: !$62d655c53090e8a3$var$C,
    useCSSOMInjection: !$62d655c53090e8a3$var$I
}, $62d655c53090e8a3$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $62d655c53090e8a3$var$w), void 0 === t && (t = {}), this.options = $62d655c53090e8a3$var$y({}, $62d655c53090e8a3$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $62d655c53090e8a3$var$C && $62d655c53090e8a3$var$U && ($62d655c53090e8a3$var$U = !1, function(e) {
            for(var _$t = document.querySelectorAll($62d655c53090e8a3$var$M), _$n = 0, _$r = _$t.length; _$n < _$r; _$n++){
                var o = _$t[_$n];
                o && "active" !== o.getAttribute($62d655c53090e8a3$var$N) && ($62d655c53090e8a3$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $62d655c53090e8a3$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($62d655c53090e8a3$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var _$e, t, n, _$r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, _$r = t.useCSSOMInjection, o = t.target, _$e = n ? new $62d655c53090e8a3$var$W(o) : _$r ? new $62d655c53090e8a3$var$H(o) : new $62d655c53090e8a3$var$$(o), new $62d655c53090e8a3$var$j(_$e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($62d655c53090e8a3$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($62d655c53090e8a3$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($62d655c53090e8a3$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, _$r = "", o = 0; o < n; o++){
                var s = $62d655c53090e8a3$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $62d655c53090e8a3$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), _$r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return _$r;
        }(this);
    }, e;
}(), $62d655c53090e8a3$var$Z = /(a)(d)/gi, $62d655c53090e8a3$var$K = function K(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $62d655c53090e8a3$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $62d655c53090e8a3$var$K(t % 52) + n;
    return ($62d655c53090e8a3$var$K(t % 52) + n).replace($62d655c53090e8a3$var$Z, "$1-$2");
}
var $62d655c53090e8a3$var$ee = function ee(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $62d655c53090e8a3$var$te = function te(e) {
    return $62d655c53090e8a3$var$ee(5381, e);
};
function $62d655c53090e8a3$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($62d655c53090e8a3$var$E(n) && !$62d655c53090e8a3$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $62d655c53090e8a3$var$re = $62d655c53090e8a3$var$te("5.3.11"), $62d655c53090e8a3$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $62d655c53090e8a3$var$ne(e), this.componentId = t, this.baseHash = $62d655c53090e8a3$var$ee($62d655c53090e8a3$var$re, t), this.baseStyle = n, $62d655c53090e8a3$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(_$r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $62d655c53090e8a3$var$_e(this.rules, e, t, n).join(""), i = $62d655c53090e8a3$var$Q($62d655c53090e8a3$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(_$r, i)) {
                    var a = n(s, "." + i, void 0, _$r);
                    t.insertRules(_$r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $62d655c53090e8a3$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $62d655c53090e8a3$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $62d655c53090e8a3$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $62d655c53090e8a3$var$Q(u >>> 0);
                if (!t.hasNameForId(_$r, m)) {
                    var y = n(l, "." + m, void 0, _$r);
                    t.insertRules(_$r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $62d655c53090e8a3$var$se = /^\s*\/\/.*$/gm, $62d655c53090e8a3$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $62d655c53090e8a3$var$ae(e) {
    var t, n, _$r, o, s = void 0 === e ? $62d655c53090e8a3$var$w : e, i = s.options, a = void 0 === i ? $62d655c53090e8a3$var$w : i, c = s.plugins, u = void 0 === c ? $62d655c53090e8a3$var$S : c, l = new (0, $858ca8570e671394$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function f(e, r, s) {
        return 0 === r && -1 !== $62d655c53090e8a3$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($62d655c53090e8a3$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, _$r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(_$r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $62d655c53090e8a3$var$D(15), $62d655c53090e8a3$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $62d655c53090e8a3$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createContext(), $62d655c53090e8a3$export$91317688fc694efa = $62d655c53090e8a3$export$8c190ef828af4c86.Consumer, $62d655c53090e8a3$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createContext(), $62d655c53090e8a3$var$de = ($62d655c53090e8a3$var$le.Consumer, new $62d655c53090e8a3$var$X), $62d655c53090e8a3$var$he = $62d655c53090e8a3$var$ae();
function $62d655c53090e8a3$var$pe() {
    return (0, $hAGkE.useContext)($62d655c53090e8a3$export$8c190ef828af4c86) || $62d655c53090e8a3$var$de;
}
function $62d655c53090e8a3$var$fe() {
    return (0, $hAGkE.useContext)($62d655c53090e8a3$var$le) || $62d655c53090e8a3$var$he;
}
function $62d655c53090e8a3$export$a473771da2f0ff7c(e) {
    var t = (0, $hAGkE.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $62d655c53090e8a3$var$pe(), u = (0, $hAGkE.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $hAGkE.useMemo)(function() {
        return $62d655c53090e8a3$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $hAGkE.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($96637ddbcefe0e04$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($62d655c53090e8a3$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($62d655c53090e8a3$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $62d655c53090e8a3$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $62d655c53090e8a3$var$he);
            var _$r = n.name + t.hash;
            e.hasNameForId(n.id, _$r) || e.insertRules(n.id, _$r, t(n.rules, _$r, "@keyframes"));
        }, this.toString = function() {
            return $62d655c53090e8a3$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $62d655c53090e8a3$var$he), this.name + e.hash;
    }, e;
}(), $62d655c53090e8a3$var$ve = /([A-Z])/, $62d655c53090e8a3$var$ge = /([A-Z])/g, $62d655c53090e8a3$var$Se = /^ms-/, $62d655c53090e8a3$var$we = function we(e) {
    return "-" + e.toLowerCase();
};
function $62d655c53090e8a3$var$Ee(e) {
    return $62d655c53090e8a3$var$ve.test(e) ? e.replace($62d655c53090e8a3$var$ge, $62d655c53090e8a3$var$we).replace($62d655c53090e8a3$var$Se, "-ms-") : e;
}
var $62d655c53090e8a3$var$be = function be(e) {
    return null == e || !1 === e || "" === e;
};
function $62d655c53090e8a3$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $62d655c53090e8a3$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($62d655c53090e8a3$var$be(e)) return "";
    if ($62d655c53090e8a3$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($62d655c53090e8a3$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $62d655c53090e8a3$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $62d655c53090e8a3$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $62d655c53090e8a3$var$g(e) ? function e(t, n) {
        var _$r, _$o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$62d655c53090e8a3$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $62d655c53090e8a3$var$E(t[i]) ? s.push($62d655c53090e8a3$var$Ee(i) + ":", t[i], ";") : $62d655c53090e8a3$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($62d655c53090e8a3$var$Ee(i) + ": " + (_$r = i, null == (_$o = t[i]) || "boolean" == typeof _$o || "" === _$o ? "" : "number" != typeof _$o || 0 === _$o || _$r in (0, $635f68e94e52c164$export$2e2bcd8739ae039) || _$r.startsWith("--") ? String(_$o).trim() : _$o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $62d655c53090e8a3$var$Ne = function Ne(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $62d655c53090e8a3$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    return $62d655c53090e8a3$var$E(e) || $62d655c53090e8a3$var$g(e) ? $62d655c53090e8a3$var$Ne($62d655c53090e8a3$var$_e($62d655c53090e8a3$var$v($62d655c53090e8a3$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $62d655c53090e8a3$var$Ne($62d655c53090e8a3$var$_e($62d655c53090e8a3$var$v(e, n)));
}
var $62d655c53090e8a3$var$Ce = /invalid hook call/i, $62d655c53090e8a3$var$Ie = new Set, $62d655c53090e8a3$var$Pe = function Pe(e, t) {
    var n, _$r, o, e1;
}, $62d655c53090e8a3$var$Oe = function Oe(e, t, n) {
    return void 0 === n && (n = $62d655c53090e8a3$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $62d655c53090e8a3$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $62d655c53090e8a3$var$De = /(^-|-$)/g;
function $62d655c53090e8a3$var$je(e) {
    return e.replace($62d655c53090e8a3$var$Re, "-").replace($62d655c53090e8a3$var$De, "");
}
var $62d655c53090e8a3$var$Te = function Te(e) {
    return $62d655c53090e8a3$var$Q($62d655c53090e8a3$var$te(e) >>> 0);
};
function $62d655c53090e8a3$var$xe(e) {
    return "string" == typeof e && true;
}
var $62d655c53090e8a3$var$ke = function ke(e) {
    return "function" == typeof e || "object" == (typeof e === "undefined" ? "undefined" : (0, $2xTNA._)(e)) && null !== e && !Array.isArray(e);
}, $62d655c53090e8a3$var$Ve = function Ve(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $62d655c53090e8a3$var$Be(e, t, n) {
    var _$r = e[n];
    $62d655c53090e8a3$var$ke(t) && $62d655c53090e8a3$var$ke(_$r) ? $62d655c53090e8a3$var$ze(_$r, t) : e[n] = t;
}
function $62d655c53090e8a3$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($62d655c53090e8a3$var$ke(i)) for(var a in i)$62d655c53090e8a3$var$Ve(a) && $62d655c53090e8a3$var$Be(e, i[a], a);
    }
    return e;
}
var $62d655c53090e8a3$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createContext(), $62d655c53090e8a3$export$b631efc24e9d5e2f = $62d655c53090e8a3$export$2c657da244d00bd6.Consumer;
function $62d655c53090e8a3$export$d8964aec282183a3(e) {
    var t = (0, $hAGkE.useContext)($62d655c53090e8a3$export$2c657da244d00bd6), n = (0, $hAGkE.useMemo)(function() {
        return function(e, t) {
            if (!e) return $62d655c53090e8a3$var$D(14);
            if ($62d655c53090e8a3$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != (typeof e === "undefined" ? "undefined" : (0, $2xTNA._)(e)) ? $62d655c53090e8a3$var$D(8) : t ? $62d655c53090e8a3$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($62d655c53090e8a3$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $62d655c53090e8a3$var$Fe = {};
function $62d655c53090e8a3$var$Ye(e, t, n) {
    var o = $62d655c53090e8a3$export$7ba318d8d2f06c76(e), i = !$62d655c53090e8a3$var$xe(e), a = t.attrs, c = void 0 === a ? $62d655c53090e8a3$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var _$n = "string" != typeof e ? "sc" : $62d655c53090e8a3$var$je(e);
        $62d655c53090e8a3$var$Fe[_$n] = ($62d655c53090e8a3$var$Fe[_$n] || 0) + 1;
        var _$r = _$n + "-" + $62d655c53090e8a3$var$Te("5.3.11" + _$n + $62d655c53090e8a3$var$Fe[_$n]);
        return t ? t + "-" + _$r : _$r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $62d655c53090e8a3$var$xe(e) ? "styled." + e : "Styled(" + $62d655c53090e8a3$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $62d655c53090e8a3$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function N(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $62d655c53090e8a3$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function P(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $62d655c53090e8a3$var$w);
                var _$r = $62d655c53090e8a3$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var _$t, _$n, _$s, i = e;
                    for(_$t in $62d655c53090e8a3$var$E(i) && (i = i(_$r)), i)_$r[_$t] = o[_$t] = "className" === _$t ? (_$n = o[_$t], _$s = i[_$t], _$n && _$s ? _$n + " " + _$s : _$n || _$s) : i[_$t];
                }), [
                    _$r,
                    o
                ];
            }($62d655c53090e8a3$var$Oe(t, (0, $hAGkE.useContext)($62d655c53090e8a3$export$2c657da244d00bd6), a) || $62d655c53090e8a3$var$w, t, o), _$m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $62d655c53090e8a3$var$pe(), _$s = $62d655c53090e8a3$var$fe(), i = t ? e.generateAndInjectStyles($62d655c53090e8a3$var$w, o, _$s) : e.generateAndInjectStyles(n, o, _$s);
                return i;
            }(i, r, _$m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _$_ = $62d655c53090e8a3$var$xe(b), N = v !== t ? $62d655c53090e8a3$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $539e05827a2c6840$export$2e2bcd8739ae039), b) : !_$_ || (0, $539e05827a2c6840$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $62d655c53090e8a3$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $hAGkE.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $62d655c53090e8a3$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var _$r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var _$n, _$r, o = {}, s = Object.keys(e);
            for(_$r = 0; _$r < s.length; _$r++)_$n = s[_$r], t.indexOf(_$n) >= 0 || (o[_$n] = e[_$n]);
            return o;
        }(t, [
            "componentId"
        ]), s = _$r && _$r + "-" + ($62d655c53090e8a3$var$xe(e) ? e : $62d655c53090e8a3$var$je($62d655c53090e8a3$var$b(e)));
        return $62d655c53090e8a3$var$Ye(e, $62d655c53090e8a3$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(t) {
            this._foldedDefaultProps = o ? $62d655c53090e8a3$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function value() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($4a48ac78e5d6a269$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $62d655c53090e8a3$var$qe = function qe(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $62d655c53090e8a3$var$w), !(0, $c13a927bf342f167$exports.isValidElementType)(r)) return $62d655c53090e8a3$var$D(1, String(r));
        var s = function s() {
            return t(r, o, $62d655c53090e8a3$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $62d655c53090e8a3$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $62d655c53090e8a3$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($62d655c53090e8a3$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $62d655c53090e8a3$var$qe[e] = $62d655c53090e8a3$var$qe(e);
});
var $62d655c53090e8a3$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $62d655c53090e8a3$var$ne(e), $62d655c53090e8a3$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($62d655c53090e8a3$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $62d655c53090e8a3$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $62d655c53090e8a3$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $62d655c53090e8a3$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $62d655c53090e8a3$var$Te(JSON.stringify(i)), u = new $62d655c53090e8a3$var$He(i, a);
    function d(e) {
        var t = $62d655c53090e8a3$var$pe(), n = $62d655c53090e8a3$var$fe(), o = (0, $hAGkE.useContext)($62d655c53090e8a3$export$2c657da244d00bd6), _$d = (0, $hAGkE.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(_$d, e, t, o, n), (0, $hAGkE.useLayoutEffect)(function() {
            if (!t.server) return h(_$d, e, t, o, n), function() {
                return u.removeStyles(_$d, t);
            };
        }, [
            _$d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $62d655c53090e8a3$var$P, n, o);
        else {
            var s = $62d655c53090e8a3$var$y({}, t, {
                theme: $62d655c53090e8a3$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).memo(d);
}
function $62d655c53090e8a3$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    var o = $62d655c53090e8a3$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $62d655c53090e8a3$var$Te(o);
    return new $62d655c53090e8a3$var$ye(s, o);
}
var $62d655c53090e8a3$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var _$e = this;
        this._emitSheetCSS = function() {
            var t = _$e.instance.toString();
            if (!t) return "";
            var n = $62d655c53090e8a3$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $62d655c53090e8a3$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return _$e.sealed ? $62d655c53090e8a3$var$D(2) : _$e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (_$e.sealed) return $62d655c53090e8a3$var$D(2);
            var n = ((t = {})[$62d655c53090e8a3$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: _$e.instance.toString()
            }, t), o = $62d655c53090e8a3$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("style", $62d655c53090e8a3$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            _$e.sealed = !0;
        }, this.instance = new $62d655c53090e8a3$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $62d655c53090e8a3$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($62d655c53090e8a3$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $62d655c53090e8a3$var$D(3);
    }, e;
}(), $62d655c53090e8a3$export$e8748c6a27b910dc = function Je(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).forwardRef(function(t, n) {
        var o = (0, $hAGkE.useContext)($62d655c53090e8a3$export$2c657da244d00bd6), i = e.defaultProps, a = $62d655c53090e8a3$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(e, $62d655c53090e8a3$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($4a48ac78e5d6a269$exports)))(t, e), t.displayName = "WithTheme(" + $62d655c53090e8a3$var$b(e) + ")", t;
}, $62d655c53090e8a3$export$93d4e7f90805808f = function Xe() {
    return (0, $hAGkE.useContext)($62d655c53090e8a3$export$2c657da244d00bd6);
}, $62d655c53090e8a3$export$5c87cfe6c475f500 = {
    StyleSheet: $62d655c53090e8a3$var$X,
    masterSheet: $62d655c53090e8a3$var$de
};
var $62d655c53090e8a3$export$2e2bcd8739ae039 = $62d655c53090e8a3$var$qe;



var $2xTNA = parcelRequire("2xTNA");

function $cd44f06e04080a42$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}



function $e875dafab9289948$export$2e2bcd8739ae039(t) {
    return $e875dafab9289948$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e875dafab9289948$export$2e2bcd8739ae039(t);
}



function $ca83b86ab334acba$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $caee410a32646336$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($caee410a32646336$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $1a3c8752dd613842$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $caee410a32646336$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $2e14efed1ccff3b0$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $e7ffc62a91f9ca4d$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $e7ffc62a91f9ca4d$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $ca83b86ab334acba$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $1a3c8752dd613842$export$2e2bcd8739ae039)(t, arguments, (0, $e875dafab9289948$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $2e14efed1ccff3b0$export$2e2bcd8739ae039)(Wrapper, t);
    }, $e7ffc62a91f9ca4d$export$2e2bcd8739ae039(t);
}


function $8da66882b07075b2$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}


function $6650ffc144de4082$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $6650ffc144de4082$var$negation(a) {
    return -a;
}
function $6650ffc144de4082$var$addition(a, b) {
    return a + b;
}
function $6650ffc144de4082$var$subtraction(a, b) {
    return a - b;
}
function $6650ffc144de4082$var$multiplication(a, b) {
    return a * b;
}
function $6650ffc144de4082$var$division(a, b) {
    return a / b;
}
function $6650ffc144de4082$var$max() {
    return Math.max.apply(Math, arguments);
}
function $6650ffc144de4082$var$min() {
    return Math.min.apply(Math, arguments);
}
function $6650ffc144de4082$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $6650ffc144de4082$var$defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: $6650ffc144de4082$var$multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: $6650ffc144de4082$var$division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: $6650ffc144de4082$var$addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: $6650ffc144de4082$var$last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: $6650ffc144de4082$var$subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: $6650ffc144de4082$var$negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: $6650ffc144de4082$var$comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: $6650ffc144de4082$var$last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: $6650ffc144de4082$var$min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: $6650ffc144de4082$var$max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var $6650ffc144de4082$var$defaultSymbolMap = $6650ffc144de4082$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $6650ffc144de4082$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function $6650ffc144de4082$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $6650ffc144de4082$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $c698bcd5625a6a85$export$2e2bcd8739ae039)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $cd44f06e04080a42$export$2e2bcd8739ae039)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $e7ffc62a91f9ca4d$export$2e2bcd8739ae039)(Error));
var $6650ffc144de4082$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $6650ffc144de4082$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $6650ffc144de4082$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $6650ffc144de4082$var$calculate(expression, additionalSymbols) {
    var symbolMap = $6650ffc144de4082$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $6650ffc144de4082$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($6650ffc144de4082$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $6650ffc144de4082$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new $6650ffc144de4082$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $6650ffc144de4082$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $6650ffc144de4082$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $6650ffc144de4082$var$reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $6650ffc144de4082$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $6650ffc144de4082$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($6650ffc144de4082$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $6650ffc144de4082$var$PolishedError(41);
    var cleanFormula = $6650ffc144de4082$var$reverseString(reversedFormula.replace($6650ffc144de4082$var$unitRegExp, ''));
    return "" + $6650ffc144de4082$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $6650ffc144de4082$var$reverseString(formulaMatch[0]) : '');
}
var $6650ffc144de4082$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $6650ffc144de4082$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($6650ffc144de4082$var$cssVariableRegex)) throw new $6650ffc144de4082$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $6650ffc144de4082$var$PolishedError(74);
}
// @private
function $6650ffc144de4082$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $6650ffc144de4082$var$positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $6650ffc144de4082$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $6650ffc144de4082$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $6650ffc144de4082$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$6650ffc144de4082$var$generateProperty(property, $6650ffc144de4082$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $6650ffc144de4082$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $6650ffc144de4082$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $6650ffc144de4082$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $6650ffc144de4082$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $6650ffc144de4082$export$ef04e38dc423904(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match($6650ffc144de4082$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $6650ffc144de4082$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$6650ffc144de4082$var$endsWith(pxval, 'px')) throw new $6650ffc144de4082$var$PolishedError(69, to, pxval);
            newPxval = $6650ffc144de4082$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$6650ffc144de4082$var$endsWith(base, 'px')) throw new $6650ffc144de4082$var$PolishedError(70, to, base);
            newBase = $6650ffc144de4082$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new $6650ffc144de4082$var$PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new $6650ffc144de4082$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $6650ffc144de4082$var$pixelsto = $6650ffc144de4082$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $6650ffc144de4082$var$em = $6650ffc144de4082$var$pixelsto('em');
var $6650ffc144de4082$export$c63c6f932822f543 = $6650ffc144de4082$var$em;
var $6650ffc144de4082$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $6650ffc144de4082$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($6650ffc144de4082$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $6650ffc144de4082$export$929888ab0c9f043c(styleBlock, rules) {
    if ((typeof styleBlock === "undefined" ? "undefined" : (0, $2xTNA._)(styleBlock)) !== 'object' || styleBlock === null) throw new $6650ffc144de4082$var$PolishedError(75, typeof styleBlock === "undefined" ? "undefined" : (0, $2xTNA._)(styleBlock));
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if ((0, $2xTNA._)(styleBlock[key]) === 'object' && styleBlock[key] !== null) newStyleBlock[key] = $6650ffc144de4082$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $6650ffc144de4082$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $6650ffc144de4082$var$getRatio(ratioName) {
    return $6650ffc144de4082$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $6650ffc144de4082$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new $6650ffc144de4082$var$PolishedError(42);
    if (typeof ratio === 'string' && !$6650ffc144de4082$var$ratioNames[ratio]) throw new $6650ffc144de4082$var$PolishedError(43);
    var _ref = typeof base === 'string' ? $6650ffc144de4082$export$feec6b849ef388ab(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? $6650ffc144de4082$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new $6650ffc144de4082$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $6650ffc144de4082$var$rem = $6650ffc144de4082$var$pixelsto('rem');
var $6650ffc144de4082$export$fb1897a40d146f7f = $6650ffc144de4082$var$rem;
var $6650ffc144de4082$var$defaultFontSize = 16;
function $6650ffc144de4082$var$convertBase(base) {
    var deconstructedValue = $6650ffc144de4082$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * $6650ffc144de4082$var$defaultFontSize;
    throw new $6650ffc144de4082$var$PolishedError(78, deconstructedValue[1]);
}
function $6650ffc144de4082$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $6650ffc144de4082$var$convertBase(rootFontSize) : $6650ffc144de4082$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $6650ffc144de4082$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $6650ffc144de4082$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $6650ffc144de4082$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new $6650ffc144de4082$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $6650ffc144de4082$var$convertBase(base) : $6650ffc144de4082$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $6650ffc144de4082$var$functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $6650ffc144de4082$export$929e5a82286172a6(functionName) {
    return $6650ffc144de4082$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $6650ffc144de4082$var$functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $6650ffc144de4082$export$c07234257a03d5e9(functionName) {
    return $6650ffc144de4082$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $6650ffc144de4082$var$functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $6650ffc144de4082$export$57636bb43b1ccbb0(functionName) {
    return $6650ffc144de4082$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $6650ffc144de4082$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $6650ffc144de4082$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $6650ffc144de4082$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $6650ffc144de4082$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $6650ffc144de4082$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $6650ffc144de4082$var$PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new $6650ffc144de4082$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $6650ffc144de4082$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $6650ffc144de4082$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $6650ffc144de4082$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $6650ffc144de4082$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function $6650ffc144de4082$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6650ffc144de4082$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6650ffc144de4082$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6650ffc144de4082$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6650ffc144de4082$var$_arrayLikeToArray(o, minLen);
}
function $6650ffc144de4082$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $6650ffc144de4082$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && (typeof cssProp === "undefined" ? "undefined" : (0, $2xTNA._)(cssProp)) !== 'object' || cssProp === null) throw new $6650ffc144de4082$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $6650ffc144de4082$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $6650ffc144de4082$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $6650ffc144de4082$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $6650ffc144de4082$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $6650ffc144de4082$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $6650ffc144de4082$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $6650ffc144de4082$var$formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function $6650ffc144de4082$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + $6650ffc144de4082$var$formatHintMap[format] + "\")";
}
function $6650ffc144de4082$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match($6650ffc144de4082$var$dataURIRegex);
}
function $6650ffc144de4082$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($6650ffc144de4082$var$isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + $6650ffc144de4082$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + $6650ffc144de4082$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function $6650ffc144de4082$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $6650ffc144de4082$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($6650ffc144de4082$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($6650ffc144de4082$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $6650ffc144de4082$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $6650ffc144de4082$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $6650ffc144de4082$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $6650ffc144de4082$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $6650ffc144de4082$var$PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $6650ffc144de4082$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $6650ffc144de4082$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $6650ffc144de4082$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $6650ffc144de4082$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $6650ffc144de4082$var$constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $6650ffc144de4082$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $6650ffc144de4082$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $6650ffc144de4082$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: $6650ffc144de4082$var$constructGradientValue($6650ffc144de4082$var$_templateObject$1 || ($6650ffc144de4082$var$_templateObject$1 = (0, $8da66882b07075b2$export$2e2bcd8739ae039)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $6650ffc144de4082$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var $6650ffc144de4082$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $6650ffc144de4082$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $6650ffc144de4082$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: $6650ffc144de4082$var$constructGradientValue($6650ffc144de4082$var$_templateObject || ($6650ffc144de4082$var$_templateObject = (0, $8da66882b07075b2$export$2e2bcd8739ae039)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $6650ffc144de4082$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new $6650ffc144de4082$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$6650ffc144de4082$export$e79006618d7c6cc3()] = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $6650ffc144de4082$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function $6650ffc144de4082$var$getTimingFunction(functionName) {
    return $6650ffc144de4082$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $6650ffc144de4082$export$61210fa83792a81(timingFunction) {
    return $6650ffc144de4082$var$getTimingFunction(timingFunction);
}
var $6650ffc144de4082$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $6650ffc144de4082$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $6650ffc144de4082$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $6650ffc144de4082$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = $6650ffc144de4082$export$feec6b849ef388ab(width);
    var heightAndUnit = $6650ffc144de4082$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $6650ffc144de4082$var$PolishedError(60);
    return (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, $6650ffc144de4082$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: $6650ffc144de4082$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $6650ffc144de4082$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $6650ffc144de4082$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $6650ffc144de4082$var$convertToInt(red, green, blue) {
    return $6650ffc144de4082$var$colorToInt(red) + "," + $6650ffc144de4082$var$colorToInt(green) + "," + $6650ffc144de4082$var$colorToInt(blue);
}
function $6650ffc144de4082$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $6650ffc144de4082$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $6650ffc144de4082$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $6650ffc144de4082$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $6650ffc144de4082$var$namedColorMap[normalizedColorName] ? "#" + $6650ffc144de4082$var$namedColorMap[normalizedColorName] : color;
}
var $6650ffc144de4082$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $6650ffc144de4082$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $6650ffc144de4082$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $6650ffc144de4082$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $6650ffc144de4082$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $6650ffc144de4082$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $6650ffc144de4082$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $6650ffc144de4082$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $6650ffc144de4082$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new $6650ffc144de4082$var$PolishedError(3);
    var normalizedColor = $6650ffc144de4082$var$nameToHex(color);
    if (normalizedColor.match($6650ffc144de4082$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($6650ffc144de4082$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($6650ffc144de4082$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($6650ffc144de4082$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $6650ffc144de4082$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $6650ffc144de4082$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $6650ffc144de4082$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $6650ffc144de4082$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $6650ffc144de4082$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $6650ffc144de4082$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $6650ffc144de4082$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $6650ffc144de4082$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $6650ffc144de4082$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $6650ffc144de4082$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $6650ffc144de4082$var$PolishedError(5);
}
function $6650ffc144de4082$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var _$max = Math.max(red, green, blue);
    var _$min = Math.min(red, green, blue);
    var lightness = (_$max + _$min) / 2;
    if (_$max === _$min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = _$max - _$min;
    var saturation = lightness > 0.5 ? delta / (2 - _$max - _$min) : delta / (_$max + _$min);
    switch(_$max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $6650ffc144de4082$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $6650ffc144de4082$var$rgbToHsl($6650ffc144de4082$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $6650ffc144de4082$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $6650ffc144de4082$var$reduceHexValue$1 = $6650ffc144de4082$var$reduceHexValue;
function $6650ffc144de4082$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $6650ffc144de4082$var$colorToHex(color) {
    return $6650ffc144de4082$var$numberToHex(Math.round(color * 255));
}
function $6650ffc144de4082$var$convertToHex(red, green, blue) {
    return $6650ffc144de4082$var$reduceHexValue$1("#" + $6650ffc144de4082$var$colorToHex(red) + $6650ffc144de4082$var$colorToHex(green) + $6650ffc144de4082$var$colorToHex(blue));
}
function $6650ffc144de4082$var$hslToHex(hue, saturation, lightness) {
    return $6650ffc144de4082$var$hslToRgb(hue, saturation, lightness, $6650ffc144de4082$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $6650ffc144de4082$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $6650ffc144de4082$var$hslToHex(value, saturation, lightness);
    else if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'object' && saturation === undefined && lightness === undefined) return $6650ffc144de4082$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $6650ffc144de4082$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $6650ffc144de4082$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $6650ffc144de4082$var$hslToHex(value, saturation, lightness) : "rgba(" + $6650ffc144de4082$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $6650ffc144de4082$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $6650ffc144de4082$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $6650ffc144de4082$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $6650ffc144de4082$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $6650ffc144de4082$var$reduceHexValue$1("#" + $6650ffc144de4082$var$numberToHex(value) + $6650ffc144de4082$var$numberToHex(green) + $6650ffc144de4082$var$numberToHex(blue));
    else if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'object' && green === undefined && blue === undefined) return $6650ffc144de4082$var$reduceHexValue$1("#" + $6650ffc144de4082$var$numberToHex(value.red) + $6650ffc144de4082$var$numberToHex(value.green) + $6650ffc144de4082$var$numberToHex(value.blue));
    throw new $6650ffc144de4082$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $6650ffc144de4082$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $6650ffc144de4082$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $6650ffc144de4082$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if ((typeof firstValue === "undefined" ? "undefined" : (0, $2xTNA._)(firstValue)) === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $6650ffc144de4082$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $6650ffc144de4082$var$PolishedError(7);
}
var $6650ffc144de4082$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $6650ffc144de4082$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $6650ffc144de4082$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $6650ffc144de4082$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $6650ffc144de4082$export$42fe740cdf79b2df(color) {
    if ((typeof color === "undefined" ? "undefined" : (0, $2xTNA._)(color)) !== 'object') throw new $6650ffc144de4082$var$PolishedError(8);
    if ($6650ffc144de4082$var$isRgba(color)) return $6650ffc144de4082$export$4e46ac54fc82cf3b(color);
    if ($6650ffc144de4082$var$isRgb(color)) return $6650ffc144de4082$export$8972dc0e6ad9238f(color);
    if ($6650ffc144de4082$var$isHsla(color)) return $6650ffc144de4082$export$810b04175080204c(color);
    if ($6650ffc144de4082$var$isHsl(color)) return $6650ffc144de4082$export$8f4a7c0bb78e6ea8(color);
    throw new $6650ffc144de4082$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $6650ffc144de4082$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $6650ffc144de4082$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $6650ffc144de4082$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $6650ffc144de4082$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $6650ffc144de4082$var$adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = $6650ffc144de4082$export$1286688e1b3fde9c(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedAdjustHue = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$adjustHue);
var $6650ffc144de4082$export$2b372a09365374d6 = $6650ffc144de4082$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $6650ffc144de4082$export$bd4f6f7e1823bc9e(color) {
    if (color === 'transparent') return color;
    var hslColor = $6650ffc144de4082$export$1286688e1b3fde9c(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $6650ffc144de4082$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $6650ffc144de4082$var$darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $6650ffc144de4082$export$1286688e1b3fde9c(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $6650ffc144de4082$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedDarken = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$darken);
var $6650ffc144de4082$export$4b073707ff63303 = $6650ffc144de4082$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $6650ffc144de4082$var$desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $6650ffc144de4082$export$1286688e1b3fde9c(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $6650ffc144de4082$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedDesaturate = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$desaturate);
var $6650ffc144de4082$export$fb75607d98509d9 = $6650ffc144de4082$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $6650ffc144de4082$export$c852d90bf7403b62(color) {
    if (color === 'transparent') return 0;
    var rgbColor = $6650ffc144de4082$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $6650ffc144de4082$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $6650ffc144de4082$export$c852d90bf7403b62(color1);
    var luminance2 = $6650ffc144de4082$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $6650ffc144de4082$export$6f416a6db2dfcd5c(color) {
    if (color === 'transparent') return color;
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $6650ffc144de4082$export$97fc773b219a4ae(color) {
    if ((typeof color === "undefined" ? "undefined" : (0, $2xTNA._)(color)) === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return $6650ffc144de4082$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $6650ffc144de4082$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $6650ffc144de4082$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $6650ffc144de4082$export$6897c284b6f9f4dc(color) {
    if (color === 'transparent') return color;
    // parse color string to rgb
    var value = $6650ffc144de4082$export$2f48baff6995707a(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $6650ffc144de4082$var$lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $6650ffc144de4082$export$1286688e1b3fde9c(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $6650ffc144de4082$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedLighten = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$lighten);
var $6650ffc144de4082$export$c0816ed86df316af = $6650ffc144de4082$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $6650ffc144de4082$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $6650ffc144de4082$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $6650ffc144de4082$var$mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $6650ffc144de4082$export$2f48baff6995707a(color);
    var color1 = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $6650ffc144de4082$export$2f48baff6995707a(otherColor);
    var color2 = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $6650ffc144de4082$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $6650ffc144de4082$var$curriedMix = $6650ffc144de4082$var$curry /* ::<number | string, string, string, string> */ ($6650ffc144de4082$var$mix);
var $6650ffc144de4082$export$2c9e8a9632a706b2 = $6650ffc144de4082$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $6650ffc144de4082$var$opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $6650ffc144de4082$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $6650ffc144de4082$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $6650ffc144de4082$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $6650ffc144de4082$var$curriedOpacify = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$opacify);
var $6650ffc144de4082$export$f4f50e3877dd0530 = $6650ffc144de4082$var$curriedOpacify;
var $6650ffc144de4082$var$defaultReturnIfLightColor = '#000';
var $6650ffc144de4082$var$defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $6650ffc144de4082$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $6650ffc144de4082$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $6650ffc144de4082$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $6650ffc144de4082$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $6650ffc144de4082$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $6650ffc144de4082$var$defaultReturnIfLightColor : $6650ffc144de4082$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $6650ffc144de4082$export$34b0917fcca19deb(color) {
    if ((typeof color === "undefined" ? "undefined" : (0, $2xTNA._)(color)) === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return $6650ffc144de4082$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $6650ffc144de4082$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $6650ffc144de4082$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $6650ffc144de4082$var$saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $6650ffc144de4082$export$1286688e1b3fde9c(color);
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $6650ffc144de4082$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedSaturate = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$saturate);
var $6650ffc144de4082$export$5fcac96f5a87e3db = $6650ffc144de4082$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $6650ffc144de4082$var$setHue(hue, color) {
    if (color === 'transparent') return color;
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedSetHue = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$setHue);
var $6650ffc144de4082$export$3bf58ce3e497a846 = $6650ffc144de4082$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $6650ffc144de4082$var$setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedSetLightness = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$setLightness);
var $6650ffc144de4082$export$7ef5d725337b805d = $6650ffc144de4082$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $6650ffc144de4082$var$setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return $6650ffc144de4082$export$42fe740cdf79b2df((0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $6650ffc144de4082$var$curriedSetSaturation = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$setSaturation);
var $6650ffc144de4082$export$b40fe421ea7a4f7e = $6650ffc144de4082$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $6650ffc144de4082$var$shade(percentage, color) {
    if (color === 'transparent') return color;
    return $6650ffc144de4082$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}
// prettier-ignore
var $6650ffc144de4082$var$curriedShade = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$shade);
var $6650ffc144de4082$export$3e32adda0df4ef5d = $6650ffc144de4082$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $6650ffc144de4082$var$tint(percentage, color) {
    if (color === 'transparent') return color;
    return $6650ffc144de4082$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}
// prettier-ignore
var $6650ffc144de4082$var$curriedTint = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$tint);
var $6650ffc144de4082$export$fc176dd65a27d98b = $6650ffc144de4082$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $6650ffc144de4082$var$transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $6650ffc144de4082$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $6650ffc144de4082$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $6650ffc144de4082$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $6650ffc144de4082$var$curriedTransparentize = $6650ffc144de4082$var$curry /* ::<number | string, string, string> */ ($6650ffc144de4082$var$transparentize);
var $6650ffc144de4082$export$d11da87e55cc498f = $6650ffc144de4082$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $6650ffc144de4082$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $6650ffc144de4082$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $6650ffc144de4082$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $6650ffc144de4082$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $6650ffc144de4082$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $6650ffc144de4082$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $6650ffc144de4082$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $6650ffc144de4082$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $6650ffc144de4082$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $6650ffc144de4082$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $6650ffc144de4082$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $6650ffc144de4082$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $6650ffc144de4082$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $6650ffc144de4082$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $6650ffc144de4082$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $6650ffc144de4082$var$PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $6650ffc144de4082$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $6650ffc144de4082$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $6650ffc144de4082$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $6650ffc144de4082$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $6650ffc144de4082$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $6650ffc144de4082$var$PolishedError(67);
    if (states.length === 0) return $6650ffc144de4082$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $6650ffc144de4082$var$PolishedError(68);
        selectors.push($6650ffc144de4082$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $6650ffc144de4082$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $6650ffc144de4082$var$template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $6650ffc144de4082$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $6650ffc144de4082$var$statefulSelectors(states, $6650ffc144de4082$var$template$1, $6650ffc144de4082$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $6650ffc144de4082$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $6650ffc144de4082$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $6650ffc144de4082$var$positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $6650ffc144de4082$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($6650ffc144de4082$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $5ba05e461df8a53f$export$2e2bcd8739ae039)({}, $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return $6650ffc144de4082$export$4fc00c04dd60af95.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $6650ffc144de4082$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $6650ffc144de4082$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $6650ffc144de4082$var$template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $6650ffc144de4082$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $6650ffc144de4082$var$statefulSelectors(states, $6650ffc144de4082$var$template, $6650ffc144de4082$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $6650ffc144de4082$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new $6650ffc144de4082$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}


function $08c81b9de2a7884d$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: block;\n\n  // Loader themes\n  &.solid {\n    &::before {\n      border-top-color: ",
        ";\n      border-right-color: ",
        ";\n    }\n\n    ::after {\n      border-bottom-color: ",
        ";\n      border-left-color: ",
        ";\n    }\n  }\n\n  &.outline {\n    &::before {\n      border-top-color: ",
        ";\n      border-right-color: ",
        ';\n    }\n\n    ::after {\n      border-bottom-color: black;\n      border-left-color: black;\n    }\n  }\n\n  ::before {\n    content: "";\n    position: absolute;\n    width: ',
        "px;\n    height: ",
        "px;\n    border: ",
        "px solid transparent;\n    border-radius: 50%;\n    animation: rotate ",
        's infinite linear;\n  }\n\n  ::after {\n    content: "";\n    position: absolute;\n    width: ',
        "px;\n    height: ",
        "px;\n    border: ",
        "px solid transparent;\n    border-radius: 50%;\n    animation: rotate ",
        "s infinite linear;\n  }\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    $08c81b9de2a7884d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $08c81b9de2a7884d$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    $08c81b9de2a7884d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $08c81b9de2a7884d$var$Circle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($08c81b9de2a7884d$var$_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var theme = param.theme, transparencyAmount = param.transparencyAmount;
    return (0, $6650ffc144de4082$export$d11da87e55cc498f)(transparencyAmount, theme.primaryFour);
}, function(param) {
    var theme = param.theme, transparencyAmount = param.transparencyAmount;
    return (0, $6650ffc144de4082$export$d11da87e55cc498f)(transparencyAmount, theme.primaryFour);
}, function(props) {
    return props.theme.primaryFour;
}, function(props) {
    return props.theme.primaryFour;
}, function(param) {
    var transparencyAmount = param.transparencyAmount;
    return (0, $6650ffc144de4082$export$d11da87e55cc498f)(transparencyAmount, "black");
}, function(param) {
    var transparencyAmount = param.transparencyAmount;
    return (0, $6650ffc144de4082$export$d11da87e55cc498f)(transparencyAmount, "black");
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var loaderThickness = param.loaderThickness;
    return loaderThickness;
}, function(param) {
    var animationSeconds = param.animationSeconds;
    return animationSeconds;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var loaderThickness = param.loaderThickness;
    return loaderThickness;
}, function(param) {
    var animationSeconds = param.animationSeconds;
    return animationSeconds;
});
function $08c81b9de2a7884d$export$3b0d6d7590275603(param) {
    var _param_theme = param.theme, theme = _param_theme === void 0 ? 1 : _param_theme, _param_size = param.size, size = _param_size === void 0 ? 29 : _param_size;
    var LoaderThickness = 0.5 * size / 3;
    var TransparencyAmount = 0.88;
    var AnimationSeconds = 1.3;
    var classes = [];
    switch(theme){
        case 1:
            classes.push("solid");
            break;
        case 2:
            classes.push("outline");
            break;
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($08c81b9de2a7884d$var$Circle, {
        size: size,
        loaderThickness: LoaderThickness,
        animationSeconds: AnimationSeconds,
        transparencyAmount: TransparencyAmount,
        className: classes.join(" "),
        role: "loader"
    });
}
var $08c81b9de2a7884d$export$8dc49548733a6fce = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($08c81b9de2a7884d$var$_templateObject1());
var $08c81b9de2a7884d$export$9c2866a4c6ffee = /*#__PURE__*/ function(LoaderTheme) {
    LoaderTheme[LoaderTheme["Solid"] = 1] = "Solid";
    LoaderTheme[LoaderTheme["Outline"] = 2] = "Outline";
    return LoaderTheme;
}({});



var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");
var $3b6a58c3d209bf99$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
var $3b6a58c3d209bf99$var$isMergeableObject = function isMergeableObject(value) {
    return $3b6a58c3d209bf99$var$isNonNullObject(value) && !$3b6a58c3d209bf99$var$isSpecial(value);
};
function $3b6a58c3d209bf99$var$isNonNullObject(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === 'object';
}
function $3b6a58c3d209bf99$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $3b6a58c3d209bf99$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $3b6a58c3d209bf99$var$canUseSymbol = typeof Symbol === 'function' && Symbol["for"];
var $3b6a58c3d209bf99$var$REACT_ELEMENT_TYPE = $3b6a58c3d209bf99$var$canUseSymbol ? Symbol["for"]('react.element') : 0xeac7;
function $3b6a58c3d209bf99$var$isReactElement(value) {
    return value.$$typeof === $3b6a58c3d209bf99$var$REACT_ELEMENT_TYPE;
}
function $3b6a58c3d209bf99$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $3b6a58c3d209bf99$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $3b6a58c3d209bf99$var$deepmerge($3b6a58c3d209bf99$var$emptyTarget(value), value, options) : value;
}
function $3b6a58c3d209bf99$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $3b6a58c3d209bf99$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $3b6a58c3d209bf99$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $3b6a58c3d209bf99$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $3b6a58c3d209bf99$var$deepmerge;
}
function $3b6a58c3d209bf99$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $3b6a58c3d209bf99$var$getKeys(target) {
    return Object.keys(target).concat($3b6a58c3d209bf99$var$getEnumerableOwnPropertySymbols(target));
}
function $3b6a58c3d209bf99$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $3b6a58c3d209bf99$var$propertyIsUnsafe(target, key) {
    return $3b6a58c3d209bf99$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $3b6a58c3d209bf99$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $3b6a58c3d209bf99$var$getKeys(target).forEach(function(key) {
        destination[key] = $3b6a58c3d209bf99$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $3b6a58c3d209bf99$var$getKeys(source).forEach(function(key) {
        if ($3b6a58c3d209bf99$var$propertyIsUnsafe(target, key)) return;
        if ($3b6a58c3d209bf99$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $3b6a58c3d209bf99$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $3b6a58c3d209bf99$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $3b6a58c3d209bf99$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $3b6a58c3d209bf99$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $3b6a58c3d209bf99$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $3b6a58c3d209bf99$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $3b6a58c3d209bf99$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $3b6a58c3d209bf99$var$mergeObject(target, source, options);
}
$3b6a58c3d209bf99$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $3b6a58c3d209bf99$var$deepmerge(prev, next, options);
    }, {});
};
var $3b6a58c3d209bf99$var$deepmerge_1 = $3b6a58c3d209bf99$var$deepmerge;
$3b6a58c3d209bf99$exports = $3b6a58c3d209bf99$var$deepmerge_1;



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");
var $b0a59b9452bb5152$export$8f45430ccf837300 = {
    white: "#fff",
    black: "#000",
    vivid: {
        0: "#F0F4FF",
        50: "#D1DDFC",
        100: "#B2C7FA",
        200: "#7C9FF5",
        300: "#4C7AEE",
        400: "#255AE5",
        500: "#073ED9",
        600: "#0A287D",
        700: "#001BBE",
        800: "#000CAB",
        900: "#010616"
    },
    neutral: {
        0: "#F8F9FC",
        50: "#F8F9FC",
        100: "#EEF0F8",
        200: "#B5BEDC",
        300: "#A1AAC7",
        400: "#8E95AD",
        500: "#7C7F8B",
        600: "#5A6075",
        700: "#3B4258",
        800: "#1C243F",
        900: "#000928"
    },
    peach: {
        0: "#FDF4ED",
        50: "#FBE8D7",
        100: "#FAE4D1",
        200: "#FBE8D6",
        300: "#FADFC8",
        400: "#F9D8BD",
        500: "#F8D3B4",
        600: "#F7CFAE",
        700: "#F7CCA8",
        800: "#F7CAA6",
        900: "#EBB990"
    },
    yellow: {
        0: "#fff7eb",
        50: "#feeed6",
        100: "#fee6c2",
        200: "#fddeaf",
        300: "#fcd59b",
        400: "#fcc778",
        500: "#fbbb5b",
        600: "#fcb141",
        700: "#fcaa2d",
        800: "#fda41e",
        900: "#E18801"
    },
    success: {
        0: "#edf5f3",
        50: "#cdf0ee",
        100: "#92e9d7",
        200: "#56d0ac",
        300: "#1db37c",
        400: "#149a52",
        500: "#038352",
        600: "#12853d",
        700: "#126732",
        800: "#0e4627",
        900: "#0a2b1f"
    },
    error: {
        0: "#fdfcfb",
        50: "#fcf1ee",
        100: "#f9cedc",
        200: "#f0a0b8",
        300: "#ee6e8f",
        400: "#e34a6e",
        500: "#D0070D",
        600: "#BA0C12",
        700: "#a72538",
        800: "#7a1a24",
        900: "#4a1013"
    }
};


var $3d5d014cc8c5368b$export$164de7ab8df77ef0 = {
    name: "Default",
    pageTitle: "My Mojo",
    faviconURL: "https://hosted-assets.mojomortgages.com/favicons/mojo.ico",
    mainLogoURL: "https://hosted-assets.mojomortgages.com/images/mojo/mojo-logo.svg",
    colors: (0, $7XD9P._)((0, $hRCmZ._)({}, (0, $b0a59b9452bb5152$export$8f45430ccf837300)), {
        primary: {
            one: (0, $b0a59b9452bb5152$export$8f45430ccf837300).vivid[500],
            two: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[900],
            three: (0, $b0a59b9452bb5152$export$8f45430ccf837300).white
        },
        secondary: {
            one: (0, $b0a59b9452bb5152$export$8f45430ccf837300).vivid[0],
            two: (0, $b0a59b9452bb5152$export$8f45430ccf837300).peach[100],
            three: (0, $b0a59b9452bb5152$export$8f45430ccf837300).yellow[500]
        },
        // Semantic design tokens
        text: {
            primary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[900],
            // #000928 - Dark text for headings
            secondary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[700],
            // #3b4258 - Secondary text
            inverse: (0, $b0a59b9452bb5152$export$8f45430ccf837300).white // #ffffff - White text on dark backgrounds
        },
        brand: {
            primary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).vivid[500] // #073ed9 - Primary blue for links/actions
        },
        background: {
            primary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).white,
            // #ffffff - White backgrounds
            secondary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).vivid[0],
            // #F0F4FF - Light blue backgrounds (use existing instead of #f8faff)
            tertiary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[0] // #f8f9fc - Very light backgrounds
        },
        border: {
            light: (0, $b0a59b9452bb5152$export$8f45430ccf837300).vivid[50] // #d1ddfc - Light borders
        },
        status: {
            warning: (0, $b0a59b9452bb5152$export$8f45430ccf837300).yellow[500],
            // #fbbb5b - Warning/badge colors
            success: (0, $b0a59b9452bb5152$export$8f45430ccf837300).success[50],
            // Use existing success light color instead of #cefedb
            successBorder: (0, $b0a59b9452bb5152$export$8f45430ccf837300).success[500],
            // Use existing success color instead of #00c237
            successText: (0, $b0a59b9452bb5152$export$8f45430ccf837300).success[500],
            // #038352 - Success text
            error: (0, $b0a59b9452bb5152$export$8f45430ccf837300).error[400] // Use existing error color instead of #ed5a5a
        }
    }),
    primary: (0, $b0a59b9452bb5152$export$8f45430ccf837300).vivid[500],
    primaryThree: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[900],
    primaryFour: "#FFFFFF",
    primaryTwo: (0, $b0a59b9452bb5152$export$8f45430ccf837300).yellow[900],
    secondaryOne: (0, $b0a59b9452bb5152$export$8f45430ccf837300).yellow[0],
    secondaryThree: (0, $b0a59b9452bb5152$export$8f45430ccf837300).error[500],
    backgroundColour: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[0],
    shade: {
        100: "#ffffff",
        90: "#f5f7fb",
        80: "#e9edf5",
        70: "#dbe1eb",
        60: "#cad1dd",
        50: "#b6becb",
        40: "#9ea7b2",
        30: "#828a93",
        20: "#61676e",
        10: "#3c4044",
        0: "#16181a"
    },
    secondary: "#BEE3FF",
    tertiary: "#000928",
    cta: "#00A0FF",
    ctaButton: "#073ED9",
    error: "#ED5A5A",
    footerBackground: "#000928",
    footerText: "#FFFFFF",
    maxWidth: "1216px",
    border: {
        "default": "2px"
    },
    radius: {
        "default": "4px",
        large: "8px"
    },
    opacity: {
        "default": 0.4
    },
    primaryOne: "#073ED9",
    secondaryTwo: "#F5F7FB",
    shade100: "#FFFFFF",
    shade90: "#F5F7FB",
    shade80: "#e7ebf4",
    shade70: "#d8dce7",
    shade60: "#bfc3d0",
    shade50: "#7f8394",
    shade40: "#656a7e",
    shade30: "#4c5269",
    shade20: "#333a53",
    shade10: "#1a223f",
    grey: "#b5b5b5",
    grey_dark: "#434344",
    blue: "#073ed8",
    buttonShadow: "#052ea3",
    background: "#F5F7FB",
    activeNavItemBackground: "#e7ebf4",
    borderColor: "#e0e0e0",
    infoColor: "#fbbb5b",
    lightInfoColour: "#fde9db",
    navColour: "white",
    navItemColour: "#444444",
    starColour: "#0045FF",
    landerHeader: function(isRemo) {
        return "Let\u2019s get a ".concat(isRemo ? "remortgage" : "mortgage", " that\u2019s perfect for you.");
    },
    landerBodyText: "",
    landerLeadText: "All we need to do is ask a few questions and do a soft credit check. Don\u2019t worry, it won\u2019t affect your credit score.",
    landerBullet1: "Free eligibility and affordability review",
    landerBullet2: "Thousands of mortgage deals",
    landerBullet3: "60+ mortgage lenders",
    landerBullet4: "",
    landerBullet5: "",
    landerSecondaryText: "",
    landerComplianceText: undefined,
    landerCTA: "Get Started",
    illustrations: {
        lander: "https://static.mojomortgages.com/partner-illustrations/bankrate/bbq.svg",
        routing: null
    },
    privacyPolicy: "",
    showPoweredBy: false,
    poweredByVariant: "partnership",
    mojoBlurb: "",
    fontFamily: "'TT Wellingtons', Arial, sans-serif"
};


function $81ead65346fb6783$export$3f4e072470a85305() {
    var partner = window.location.host.split(".")[0];
    if (!partner || partner === "mymojo" || partner.includes("localhost")) return null;
    return partner;
}


var $c5eb37b3ff2d3344$export$8bd2a2dc51b8b9d0 = {
    uswitch: {
        name: "uswitch",
        primary: "#141424",
        secondary: "#A3BCFF",
        tertiary: "#141424",
        cta: "#141424",
        ctaButton: "#141424",
        buttonShadow: "#141424",
        error: "#D64226",
        backgroundColour: "#F5F7FB",
        infoColor: "#dbe1eb",
        shade: {
            "0": "#3F4148",
            "10": "#3c4044",
            "20": "#61676e",
            "30": "#828a93",
            "40": "#9ea7b2",
            "50": "#b6becb",
            "60": "#cad1dd",
            "70": "#dbe1eb",
            "80": "#F2F2F7",
            "90": "#F2F2F7",
            "100": "#ffffff"
        },
        fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, sans-serif",
        pageTitle: "Uswitch | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/uswitch-favicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/uswitch-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/bankrate/bbq.svg",
            routing: null
        },
        privacyPolicy: "https://www.uswitch.com/about-us/privacy-policy/",
        showPoweredBy: true,
        footerCopy: [
            "Uswitch makes introductions to Mojo Mortgages to provide mortgage solutions.",
            "Uswitch and Mojo Mortgages are part of the same group of companies. Uswitch Limited is authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 312850. You can check this on the Financial Services Register by visiting the FCA website.",
            "Uswitch Limited is registered in England and Wales (Company No 03612689) The Cooperage, 5 Copper Row, London SE1 2LH.",
            "Mojo Mortgages is a trading style of Life\u2019s Great Limited which is registered in England and Wales (06246376). Mojo are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215).",
            "Mojo\u2019s registered office is The Cooperage, 5 Copper Row, London, SE1 2LH. To contact Mojo by phone, please call 0333 123 0012."
        ]
    },
    monzo: {
        name: "monzo",
        pageTitle: "Monzo | Mortgages",
        showPoweredBy: true,
        poweredByVariant: "partnership",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/monzo.svg",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/monzo-logo-on-light.svg",
        primary: "#016B83",
        primaryOne: "#FF4B44",
        backgroundColour: "#FFFFFF",
        infoColor: "#F2F8F3",
        secondary: "limegreen",
        tertiary: "#112231",
        cta: "#016B83",
        ctaButton: "#016B83",
        buttonShadow: "#016B83",
        borderRadius: "6.75px",
        navItemColour: "#EEF0F8",
        activeNavItemBackground: "#F5F7FB",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/monzo/lander.png"
        }
    },
    "uswitch-test": {
        name: "uswitch-test",
        primary: "#141424",
        secondary: "#A3BCFF",
        tertiary: "#141424",
        cta: "#141424",
        ctaButton: "#141424",
        buttonShadow: "#141424",
        error: "#D64226",
        backgroundColour: "#F5F7FB",
        infoColor: "#dbe1eb",
        shade: {
            "0": "#3F4148",
            "10": "#3c4044",
            "20": "#61676e",
            "30": "#828a93",
            "40": "#9ea7b2",
            "50": "#b6becb",
            "60": "#cad1dd",
            "70": "#dbe1eb",
            "80": "#F2F2F7",
            "90": "#F2F2F7",
            "100": "#ffffff"
        },
        pageTitle: "Uswitch | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/uswitch-favicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/uswitch-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/bankrate/bbq.svg",
            routing: null
        },
        privacyPolicy: "https://www.uswitch.com/about-us/privacy-policy/"
    },
    "gocompare-test": {
        name: "gocompare-test",
        primary: "#0045FF",
        secondary: "#BEE3FF",
        tertiary: "#00C893",
        cta: "#00A0FF",
        ctaButton: "#00A0FF",
        buttonShadow: "#00A0FF",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Mojo Mortgages | Your free online mortgage broker",
        faviconURL: "https://static.mojomortgages.com/mojofavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/mojologo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    "money-test": {
        name: "money-test",
        primary: "#FAA740",
        secondary: "#924A8B",
        tertiary: "#34454E",
        cta: "linear-gradient(45deg, rgb(219, 77, 117) 0%, rgb(146, 74, 139) 100%);",
        ctaButton: "linear-gradient(45deg, rgb(219, 77, 117) 0%, rgb(146, 74, 139) 100%);",
        buttonShadow: "#924A8B",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Money | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/moneyfavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/money-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        },
        privacyPolicy: "https://www.money.co.uk/privacy-policy.htm"
    },
    money: {
        name: "money",
        primary: "#FAA740",
        secondary: "#924A8B",
        tertiary: "#34454E",
        cta: "linear-gradient(45deg, rgb(219, 77, 117) 0%, rgb(146, 74, 139) 100%);",
        ctaButton: "linear-gradient(45deg, rgb(219, 77, 117) 0%, rgb(146, 74, 139) 100%);",
        buttonShadow: "#924A8B",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Money | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/moneyfavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/money-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        },
        privacyPolicy: "https://www.money.co.uk/privacy-policy.htm",
        showPoweredBy: true,
        footerCopy: [
            "money.co.uk makes introductions to Mojo Mortgages to provide mortgage solutions.",
            "money.co.uk and Mojo Mortgages are part of the same group of companies. money.co.uk is a trading name of Dot Zinc Limited and is authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 415689. You can check this on the Financial Services Register by visiting the FCA website.",
            "money.co.uk is registered in England (Company No 4093922) The Cooperage, 5 Copper Row, London SE1 2LH.",
            "Mojo Mortgages is a trading style of Life\u2019s Great Limited which is registered in England and Wales (06246376). Mojo are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215).",
            "Mojo\u2019s registered office is The Cooperage, 5 Copper Row, London, SE1 2LH. To contact Mojo by phone, please call 0333 123 0012."
        ],
        fontFamily: '"Open Sans", -apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Segoe WP", Ubuntu, sans-serif'
    },
    snoop: {
        name: "snoop",
        showPoweredBy: true,
        poweredByVariant: "partnership",
        primary: "#231A4F",
        secondary: "#E4F1F5",
        tertiary: "#00dbeb",
        cta: "#ff4f00",
        ctaButton: "#ff4f00",
        buttonShadow: "#ff4f00",
        error: "#fb5050",
        backgroundColour: "#E4F1F5",
        infoColor: "#dbe1eb",
        shade: {
            "100": "#ffffff",
            "90": "#F2F2F7",
            "80": "#F2F2F7",
            "70": "#dbe1eb",
            "60": "#cad1dd",
            "50": "#b6becb",
            "40": "#9ea7b2",
            "30": "#828a93",
            "20": "#61676e",
            "10": "#3c4044",
            "0": "#3F4148"
        },
        pageTitle: "Snoop | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/snoopfavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/snooplogo.svg",
        landerHeader: "Okay, let\u2019s get things set up for you.",
        landerBodyText: "I just need to ask you a few questions and pass your info to Mojo. It\u2019ll only take about 8 mins. Mojo will do a soft credit check (don\u2019t worry, it won\u2019t affect your credit score) and show you your mortgage results",
        landerCTA: "Let\u2019s do this",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/snoop/Bike.svg",
            routing: null
        }
    },
    creditladder: {
        name: "creditladder",
        primary: "#FDEE01",
        secondary: "#22DFBC",
        tertiary: "#FDEE01",
        cta: "#FDEE01",
        ctaButton: "#FDEE01",
        buttonShadow: "#FDEE01",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "CreditLadder | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/creditladderfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/credit-ladder-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    together: {
        name: "together",
        primary: "#402B55",
        secondary: "#00837F",
        tertiary: "#00837F",
        cta: "#F7B12C",
        ctaButton: "#F7B12C",
        buttonShadow: "#F7B12C",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        backgroundColour: "#ffffff",
        pageTitle: "Together | Your free online mortgage broker",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/together-favicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/together-logo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    rmq: {
        name: "rmq",
        primary: "#2457DD",
        secondary: "#E5388F",
        tertiary: "#2457DD",
        cta: "#2457DD",
        ctaButton: "#2457DD",
        buttonShadow: "#2457DD",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Remortgage Quotes Online | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/rmqfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/rmq-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    nerdwallet: {
        name: "nerdwallet",
        primary: "#008255",
        secondary: "#008255",
        tertiary: "#008255",
        cta: "#008255",
        ctaButton: "#008255",
        buttonShadow: "#008255",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "NerdWallet | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/nerdwallet-favicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/nerdwallet-logo.jpg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    thinkmoney: {
        name: "thinkmoney",
        primary: "#00577A",
        secondary: "#24ABE0",
        tertiary: "#7060EB",
        cta: "linear-gradient(45deg, rgb(36, 171, 224) 0%, rgb(112, 96, 235) 100%);",
        ctaButton: "linear-gradient(45deg, rgb(36, 171, 224) 0%, rgb(112, 96, 235) 100%);",
        buttonShadow: "rgb(36, 171, 224)",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "thinkmoney | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/thinkmoneyfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/thinkmoney-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/thinkmoney-1.png",
            routing: null
        }
    },
    citibank: {
        name: "citibank",
        primary: "#164883",
        secondary: "#164883",
        tertiary: "#164883",
        cta: "#164883",
        ctaButton: "#164883",
        buttonShadow: "#164883",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Citibank | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/citibankfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/citibank-logo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    zoopla: {
        name: "zoopla",
        primary: "#7F46F1",
        primaryOne: "#7F46F1",
        secondary: "#FF6009",
        tertiary: "#322744",
        cta: "#7F46F1",
        ctaButton: "#7F46F1",
        buttonShadow: "#7F46F1",
        infoColor: "#DBE1EB",
        error: "#E91640",
        backgroundColour: "#fff",
        shade: {
            "0": "#3F4148",
            "10": "#3c4044",
            "20": "#61676e",
            "30": "#828a93",
            "40": "#9ea7b2",
            "50": "#b6becb",
            "60": "#cad1dd",
            "70": "#dbe1eb",
            "80": "#F2F2F7",
            "90": "#F2F2F7",
            "100": "#ffffff"
        },
        pageTitle: "Zoopla | Mortgages",
        landerHeader: "Get mortgage experts to find a great deal for you \u2026and your home\u2019s value",
        landerLeadText: "Mojo\u2019s mortgage experts answer your questions about LTV bands, your current equity, additional borrowing, fixed vs variable and anything else.",
        landerBullet1: "Tell us what you want",
        landerBullet2: "There\u2019s a soft credit check \u2014 it won\u2019t impact your score",
        landerBullet3: "Your expert compares 1,000s of deals",
        landerBullet4: "You get a time and money-saving recommendation from them",
        landerSecondaryText: "Swap confusion and comparison for a clear and certain expert mortgage recommendation.",
        landerCTA: "Get your expert recommendation",
        landerComplianceText: "Zoopla may receive a fee of up to \xa3300 should you complete a mortgage through Mojo Mortgages.",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/zooplafavicon_v2.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/zoopla_v2_logo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/zoopla/keys.png",
            routing: "https://static.mojomortgages.com/partner-illustrations/zoopla/bike.svg"
        },
        showPoweredBy: true,
        poweredByVariant: "partnership",
        mojoBlurb: true,
        privacyPolicy: "https://mojomortgages.com/privacy-policy",
        fontFamily: "'Zoopla Sans', Arial, sans",
        footerCopy: [
            "Zoopla makes introductions to Mojo Mortgages to provide mortgage solutions.",
            "Zoopla Limited and Mojo Mortgages are part of the same group of companies. Zoopla Limited is an appointed representative of Uswitch Limited with is authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 312850. You can check this on the Financial Services Register by visiting the FCA website.",
            "Zoopla Limited is registered in England and Wales (Company No 06074771) The Cooperage, 5 Copper Row, London SE1 2LH.",
            "Zoopla may receive an introduction fee from Mojo Mortgages on completion of a successful mortgage application. The fee is based on a percentage of your loan amount.",
            "Mojo Mortgages is a trading style of Life\u2019s Great Limited which is registered in England and Wales (06246376). Mojo are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215).",
            "Mojo\u2019s registered office is The Cooperage, 5 Copper Row, London, SE1 2LH. To contact Mojo by phone, please call 0333 123 0012."
        ]
    },
    metro: {
        name: "metro",
        primary: "#000000",
        secondary: "#262626",
        tertiary: "#FF0044",
        cta: "#EA6300",
        ctaButton: "#EA6300",
        buttonShadow: "#EA6300",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Metro | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/metrofavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/metrologo.jpg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    barratthomes: {
        name: "barratthomes",
        primary: "#A3CA36",
        secondary: "#313539",
        tertiary: "#EFF0F2",
        cta: "#CE3116",
        ctaButton: "#CE3116",
        buttonShadow: "#CE3116",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Barratt Homes | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/barretthomesfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/barrathomeslogo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    yolt: {
        name: "yolt",
        primary: "#09C081",
        secondary: "#043173",
        tertiary: "#762AA6",
        cta: "#EE286E",
        ctaButton: "#EE286E",
        buttonShadow: "#EE286E",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Yolt | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/yoltfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/yoltlogo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    restless: {
        name: "restless",
        primary: "#F07860",
        secondary: "#00445D",
        tertiary: "#222B38",
        cta: "#41AB8B",
        ctaButton: "#41AB8B",
        buttonShadow: "#41AB8B",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Rest Less | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/restlessfavicon.webp",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/restless-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    finder: {
        name: "finder",
        primary: "#0271e1",
        secondary: "#0271e1",
        tertiary: "#00ba9c",
        cta: "#fa8643",
        ctaButton: "#fa8643",
        buttonShadow: "#fa8643",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Finder | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/finder.ico",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/finder-logo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    oma: {
        name: "oma",
        primary: "#420859",
        secondary: "#722FA2",
        tertiary: "#FD9C27",
        cta: "#26AD5F",
        ctaButton: "#26AD5F",
        buttonShadow: "#26AD5F",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Online Mortgage Advisor | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/omafavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/oma-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    multiply: {
        name: "multiply",
        primary: "#1D1D1E",
        secondary: "#F144C2",
        tertiary: "#1D1D1E",
        cta: "#F8654E",
        ctaButton: "#F8654E",
        buttonShadow: "#F8654E",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Multiply | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/multiplyfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/multiplylogo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    strike: {
        name: "strike",
        primary: "#000000",
        secondary: "#F5F5F5",
        tertiary: "#2AFD80",
        cta: "#2AFD80",
        ctaButton: "#2AFD80",
        buttonShadow: "#2AFD80",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Strike | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/strikefavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/strikelogo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    thorntonrobson: {
        name: "thorntonrobson",
        primary: "#0045FF",
        secondary: "#BEE3FF",
        tertiary: "#00C893",
        cta: "#00A0FF",
        ctaButton: "#00A0FF",
        buttonShadow: "#00A0FF",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Mojo Mortgages | Your free online mortgage broker",
        faviconURL: "https://static.mojomortgages.com/mojofavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/mojologo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    gocompare: {
        name: "gocompare",
        primary: "#0045FF",
        secondary: "#BEE3FF",
        tertiary: "#00C893",
        cta: "#00A0FF",
        ctaButton: "#00A0FF",
        buttonShadow: "#00A0FF",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "Mojo Mortgages | Your free online mortgage broker",
        faviconURL: "https://static.mojomortgages.com/mojofavicon.ico",
        mainLogoURL: "https://static.mojomortgages.com/mojologo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    bankrate: {
        name: "bankrate",
        primary: "#0157FF",
        secondary: "#0157FF",
        tertiary: "#0157FF",
        cta: "#0157FF",
        ctaButton: "#0157FF",
        buttonShadow: "#0157FF",
        infoColor: "#dbe1eb",
        error: "#F62745",
        backgroundColour: "#ffffff",
        shade: {
            "0": "#3F4148",
            "10": "#3c4044",
            "20": "#61676e",
            "30": "#828a93",
            "40": "#9ea7b2",
            "50": "#b6becb",
            "60": "#cad1dd",
            "70": "#dbe1eb",
            "80": "#F2F2F7",
            "90": "#F2F2F7",
            "100": "#ffffff"
        },
        pageTitle: "Bankrate | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/bankrate.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/bankrate-logo.svg",
        illustrations: {
            lander: "https://static.mojomortgages.com/partner-illustrations/bankrate/bbq.svg",
            routing: null
        },
        privacyPolicy: "https://www.bankrate.com/uk/privacy-policy/"
    },
    thisismoney: {
        name: "thisismoney",
        primary: "#451344",
        secondary: "#004db3",
        tertiary: "#9a3334",
        cta: "#05A9D2",
        ctaButton: "#05A9D2",
        buttonShadow: "#05A9D2",
        infoColor: "#dbe1eb",
        error: "#ED5A5A",
        pageTitle: "This is Money | Mortgages",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/thisismoneyfavicon.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/thisismoneylogo.png",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/coffee.svg",
            routing: null
        }
    },
    confused: {
        name: "confused",
        pageTitle: "Confused | Mortgages",
        showPoweredBy: true,
        poweredByVariant: "partnership",
        faviconURL: "https://static.mojomortgages.com/partner-favicons/confused.png",
        mainLogoURL: "https://static.mojomortgages.com/partner-logos/confused-logo.svg",
        fontFamily: "Poppins, Arial, sans",
        // https://zeroheight.com/784b13be8/p/793051-design-language/b/345143
        // https://zeroheight.com/784b13be8/p/328c9e-colours
        primary: "#EA9665",
        primaryOne: "#EA9665",
        secondary: "#F0B693",
        tertiary: "#3C3C3C",
        infoColor: "#EFEFEF",
        cta: "#EA9665",
        ctaButton: "#1F1F1F",
        borderRadius: 0,
        buttonShadow: "#1F1F1F",
        error: "#E61414",
        illustrations: {
            lander: "https://static.mojomortgages.com/illustrations/confused.svg",
            routing: "https://static.mojomortgages.com/illustrations/meditate.svg"
        },
        footerCopy: [
            "Confused.com makes introductions to Mojo Mortgages to provide mortgage solutions.",
            "Confused.com and Mojo Mortgages are part of the same group of companies. Confused.com is a trading name of Inspop.com Limited and is authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 310635. You can check this on the Financial Services Register by visiting the FCA website.",
            "Confused.com is registered in England and Wales (Company No 03881924) 2nd Floor, Greyfriars House, Greyfriars Road, Cardiff, South Wales, CF10 3AL.",
            "Mojo Mortgages is a trading style of Life\u2019s Great Limited which is registered in England and Wales (06246376). Mojo are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215).",
            "Mojo\u2019s registered office is The Cooperage, 5 Copper Row, London, SE1 2LH. To contact Mojo by phone, please call 0333 123 0012."
        ]
    }
};


var $7e7d633c88171aa1$export$b3611e87cd5ba6ce = function() {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)((0, $3d5d014cc8c5368b$export$164de7ab8df77ef0)), 2), theme = _useState[0], setTheme = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isPartner = _useState1[0], setIsPartner = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isLoaded = _useState2[0], setIsLoaded = _useState2[1];
    (0, $hAGkE.useEffect)(function() {
        var partnerString = (0, $81ead65346fb6783$export$3f4e072470a85305)();
        var theme = (0, $c5eb37b3ff2d3344$export$8bd2a2dc51b8b9d0)[partnerString];
        setIsPartner(!!theme);
        var currentTheme = (0, $3d5d014cc8c5368b$export$164de7ab8df77ef0);
        if (theme) currentTheme = (0, (/*@__PURE__*/$parcel$interopDefault($3b6a58c3d209bf99$exports)))((0, $3d5d014cc8c5368b$export$164de7ab8df77ef0), theme);
        setTheme(currentTheme);
        setIsLoaded(true);
    }, [
        isLoaded
    ]);
    return {
        theme: theme,
        isPartner: isPartner,
        isLoaded: isLoaded
    };
};




var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $a7G5R = parcelRequire("a7G5R");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $2xTNA = parcelRequire("2xTNA");
var $1f66261ea4106665$exports = {};
"use strict";
function $1f66261ea4106665$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1f66261ea4106665$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1f66261ea4106665$var$_typeof(obj);
}
Object.defineProperty($1f66261ea4106665$exports, "__esModule", {
    value: true
});
$1f66261ea4106665$exports["default"] = $1f66261ea4106665$exports.ReactGAImplementation = void 0;

var $1f66261ea4106665$var$_ga = $1f66261ea4106665$var$_interopRequireWildcard((parcelRequire("9eJQB")));
function $1f66261ea4106665$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1f66261ea4106665$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1f66261ea4106665$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $1f66261ea4106665$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $1f66261ea4106665$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $1f66261ea4106665$var$ReactGAImplementation = $1f66261ea4106665$var$_ga.GA4;
$1f66261ea4106665$exports.ReactGAImplementation = $1f66261ea4106665$var$ReactGAImplementation;
var $1f66261ea4106665$var$_default = $1f66261ea4106665$var$_ga["default"];
$1f66261ea4106665$exports["default"] = $1f66261ea4106665$var$_default;




var $hRCmZ = parcelRequire("hRCmZ");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");
// Marketing/attribution params safe to forward to GA4. Everything else (auth
// tokens, email, unknown PII) is stripped from URLs before they leave the app.
// Prefix rules also allow `utm_*` and `sfmc_*` (Salesforce email) keys.
var $61519547b19ed463$var$ALLOWED_QUERY_PARAMS = new Set([
    // Google / Microsoft paid + cross-domain
    "gclid",
    "gbraid",
    "wbraid",
    "gclsrc",
    "dclid",
    "gad_source",
    "gad_campaignid",
    "msclkid",
    "_gl",
    // Google auto-tagging cluster (non-PII, only appear alongside gclid)
    "matchtype",
    "network",
    "adposition",
    "device",
    // Social ad-click
    "fbclid",
    "ttclid",
    "twclid",
    "li_fat_id"
]);
var $61519547b19ed463$export$af873d6033166861 = function(value) {
    try {
        var decodedString = decodeURIComponent(value);
        var url = new URL(decodedString);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Snapshot keys first: deleting while iterating searchParams skips entries.
            for(var _iterator = Array.from(url.searchParams.keys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var isAllowed = $61519547b19ed463$var$ALLOWED_QUERY_PARAMS.has(key) || key.startsWith("utm_") || key.startsWith("sfmc_");
                if (!isAllowed) url.searchParams["delete"](key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return url.href;
    } catch (_) {
        return value; // Don't stop GA from sending data, just carry on as normal
    }
};
var $61519547b19ed463$export$35bc0d9ea9e316f2 = function(reactGA4) {
    var originalGtag = reactGA4._gtag.bind(reactGA4);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var isPlainObject = function(value) {
        return (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === "object" && value !== null && !Array.isArray(value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var cleanPayload = function(params) {
        // Shallow copy so we don't mutate the original object by reference
        var cleaned = (0, $hRCmZ._)({}, params);
        if ("page_location" in cleaned) cleaned.page_location = $61519547b19ed463$export$af873d6033166861(cleaned.page_location);
        if ("page_referrer" in cleaned) cleaned.page_referrer = $61519547b19ed463$export$af873d6033166861(cleaned.page_referrer);
        if ("full_page_url" in cleaned) cleaned.full_page_url = $61519547b19ed463$export$af873d6033166861(cleaned.full_page_url);
        if ("dimension12" in cleaned) cleaned.dimension12 = $61519547b19ed463$export$af873d6033166861(cleaned.dimension12);
        return cleaned;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactGA4._gtag = function(command, action) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        // react-ga4 passes the PII-bearing payload as the 2nd arg for `set`
        // (gtag("set", fields)) but as the 3rd for event/config. Clean whichever holds it.
        if (command === "set" && isPlainObject(action)) action = cleanPayload(action);
        else if (isPlainObject(args[0])) args[0] = cleanPayload(args[0]);
        originalGtag.apply(void 0, [
            command,
            action
        ].concat((0, $bOqL7._)(args)));
    };
    // For `page_location` we need access to `window`. In NextJS we don't have
    // access to `window` at build time
    if (typeof window !== "undefined") {
        var cleanLocation = $61519547b19ed463$export$af873d6033166861(window.location.href);
        var cleanReferrer = $61519547b19ed463$export$af873d6033166861(document.referrer);
        reactGA4.set({
            page_location: cleanLocation,
            page_referrer: cleanReferrer
        });
    }
    return reactGA4;
};


var $175ce91c71cebc6b$var$initialised = false;
var $175ce91c71cebc6b$var$queue = [];
var $175ce91c71cebc6b$var$pageViews = [];
// Global authentication status cache
var $175ce91c71cebc6b$var$cachedAuthenticationStatus = "Logged Out";
var $175ce91c71cebc6b$export$570cb92f1dba3f65 = function(sessionData) {
    $175ce91c71cebc6b$var$cachedAuthenticationStatus = sessionData ? "Logged In" : "Logged Out";
};
/**
 * We extend the main `react-ga4` class to implement the `user_properties` scope.
 */ var $175ce91c71cebc6b$var$CustomGAImplementation = /*#__PURE__*/ function(ReactGAImplementation) {
    "use strict";
    (0, $a7G5R._)(CustomGAImplementation, ReactGAImplementation);
    function CustomGAImplementation() {
        (0, $6WLcG._)(this, CustomGAImplementation);
        var _this;
        _this = (0, $bQby9._)(this, CustomGAImplementation, arguments), _this.user = function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ((typeof fieldsObject === "undefined" ? "undefined" : (0, $2xTNA._)(fieldsObject)) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gtag("set", "user_properties", fieldsObject);
        };
        return _this;
    }
    return CustomGAImplementation;
}((0, $1f66261ea4106665$exports.ReactGAImplementation));
var $175ce91c71cebc6b$export$2067fbd3b1924af4 = (0, $61519547b19ed463$export$35bc0d9ea9e316f2)(new $175ce91c71cebc6b$var$CustomGAImplementation());
/**
 * Gets the current authentication status from cache
 * No longer attempts to access HttpOnly cookies
 */ var $175ce91c71cebc6b$var$getAuthenticationStatus = function() {
    return $175ce91c71cebc6b$var$cachedAuthenticationStatus;
};
var $175ce91c71cebc6b$export$ceef5923485458fc = function() {
    if (!(0, $10b47c5a212e87a0$export$7bdc003124064e32) || !(0, $10b47c5a212e87a0$export$7828cda48901e9b7)) throw new Error("GoogleAnalytics: GOOGLE_ANALYTICS_TRACKING_ID and GA4_MEASUREMENT_ID must be set");
    (0, (/*@__PURE__*/$parcel$interopDefault($1f66261ea4106665$exports))).initialize([
        {
            trackingId: (0, $10b47c5a212e87a0$export$7bdc003124064e32),
            gtagOptions: {
                send_page_view: false
            }
        },
        {
            trackingId: (0, $10b47c5a212e87a0$export$7828cda48901e9b7),
            gtagOptions: {
                send_page_view: false
            }
        }
    ]);
    $175ce91c71cebc6b$var$initialised = true;
    // Send any events that were called before GA was properly initialised.
    // TODO: this is a bit of a hack, this should probably go in React state
    $175ce91c71cebc6b$var$queue.forEach(function(args) {
        return $175ce91c71cebc6b$var$Event(args.action, args);
    });
    $175ce91c71cebc6b$var$pageViews.forEach($175ce91c71cebc6b$var$sendPageView);
};
var $175ce91c71cebc6b$export$be82e1134c98fcf5 = function(args) {
    // Auto-inject authentication status for all events
    var enhancedArgs = (0, $7XD9P._)((0, $hRCmZ._)({}, args), {
        authentication_status: $175ce91c71cebc6b$var$getAuthenticationStatus()
    });
    // For now, duplicate GA4 custom parameters as UA custom dimensions
    if ("field_value" in enhancedArgs) {
        if ((0, $2xTNA._)(enhancedArgs.field_value) === "object") enhancedArgs.field_value = JSON.stringify(enhancedArgs.field_value);
        enhancedArgs.dimension7 = enhancedArgs.field_value;
    }
    if ("mortgage_type" in enhancedArgs) enhancedArgs.dimension8 = enhancedArgs.mortgage_type;
    if ("user_stage" in enhancedArgs) enhancedArgs.dimension9 = enhancedArgs.user_stage;
    if ("traffic_light_definition" in enhancedArgs) enhancedArgs.dimension10 = enhancedArgs.traffic_light_definition;
    if ("full_page_url" in enhancedArgs) enhancedArgs.dimension12 = enhancedArgs.full_page_url;
    if ("ltv_band" in enhancedArgs) enhancedArgs.dimension13 = enhancedArgs.ltv_band;
    if ("internal_user" in enhancedArgs) enhancedArgs.dimension14 = enhancedArgs.internal_user;
    if ("appointment_type" in enhancedArgs) enhancedArgs.dimension15 = enhancedArgs.appointment_type;
    if ("eligibility_tier" in enhancedArgs) enhancedArgs.dimension16 = enhancedArgs.eligibility_tier;
    if ("total_documents_uploaded" in enhancedArgs) enhancedArgs.dimension17 = enhancedArgs.total_documents_uploaded;
    if ("product_comparison_status" in enhancedArgs) enhancedArgs.dimension18 = enhancedArgs.product_comparison_status;
    if ("mortgage_coach_status" in enhancedArgs) enhancedArgs.dimension19 = enhancedArgs.mortgage_coach_status;
    if ("friendlyId" in enhancedArgs) enhancedArgs.dimension20 = enhancedArgs.friendlyId;
    if ("lender_name" in enhancedArgs) enhancedArgs.dimension21 = enhancedArgs.lender_name;
    if ("product_name" in enhancedArgs) enhancedArgs.dimension22 = enhancedArgs.product_name;
    if ("monthly_cost" in enhancedArgs) enhancedArgs.dimension23 = enhancedArgs.monthly_cost;
    if ("initial_rate" in enhancedArgs) enhancedArgs.dimension24 = enhancedArgs.initial_rate;
    if ("mortgage_product_type" in enhancedArgs) enhancedArgs.dimension25 = enhancedArgs.mortgage_product_type;
    if ("initial_period_end_date" in enhancedArgs) enhancedArgs.dimension26 = enhancedArgs.initial_period_end_date;
    if ("initial_fixed_period" in enhancedArgs) enhancedArgs.dimension27 = enhancedArgs.initial_fixed_period;
    if ("arrangement_fee" in enhancedArgs) enhancedArgs.dimension28 = enhancedArgs.arrangement_fee;
    if ("mortgage_payment_type" in enhancedArgs) enhancedArgs.dimension29 = enhancedArgs.mortgage_payment_type;
    if ("offset" in enhancedArgs) enhancedArgs.dimension30 = enhancedArgs.offset;
    if ("portable" in enhancedArgs) enhancedArgs.dimension31 = enhancedArgs.portable;
    if ("overpayments_allowed" in enhancedArgs) enhancedArgs.dimension32 = enhancedArgs.overpayments_allowed;
    if ("free_legals" in enhancedArgs) enhancedArgs.dimension33 = enhancedArgs.free_legals;
    if ("free_valuation" in enhancedArgs) enhancedArgs.dimension34 = enhancedArgs.free_valuation;
    if ("cashback" in enhancedArgs) enhancedArgs.dimension35 = enhancedArgs.cashback;
    if (!$175ce91c71cebc6b$var$initialised) {
        $175ce91c71cebc6b$var$queue.push(enhancedArgs);
        return;
    }
    $175ce91c71cebc6b$var$Event(enhancedArgs.action, enhancedArgs);
};
/**
 * Send an event to the analytics
 * @param eventName The name of the event
 * @param params An object of any parameters
 */ var $175ce91c71cebc6b$var$Event = function(eventName, params) {
    $175ce91c71cebc6b$export$2067fbd3b1924af4.event(eventName, params);
};
var $175ce91c71cebc6b$var$sendPageView = function(param) {
    var path = param.path, location = param.location;
    $175ce91c71cebc6b$export$2067fbd3b1924af4.set({
        page_location: location,
        full_page_url: location
    });
    $175ce91c71cebc6b$export$2067fbd3b1924af4.send({
        hitType: "pageview",
        page: path
    });
};
var $175ce91c71cebc6b$export$12c0fdede1c6bc6c = function(path) {
    // Pure client SPA: window is always defined.
    var location = window.location.href;
    if (!$175ce91c71cebc6b$var$initialised) {
        $175ce91c71cebc6b$var$pageViews.push({
            path: path,
            location: location
        });
        return;
    }
    $175ce91c71cebc6b$var$sendPageView({
        path: path,
        location: location
    });
};
function $175ce91c71cebc6b$export$1417196ef70025f8(args) {
    // For now, duplicate GA4 custom parameters as UA custom dimensions
    if ("field_value" in args) args.dimension7 = args.field_value;
    if ("mortgage_type" in args) args.dimension8 = args.mortgage_type;
    if ("user_stage" in args) args.dimension9 = args.user_stage;
    if ("traffic_light_definition" in args) args.dimension10 = args.traffic_light_definition;
    if ("ltv_band" in args) args.dimension13 = args.ltv_band;
    if ("appointment_type" in args) args.dimension15 = args.appointment_type;
    if ("eligibility_tier" in args) args.dimension16 = args.eligibility_tier;
    if ("product_comparison_status" in args) args.dimension18 = args.product_comparison_status;
    if ("mortgage_coach_status" in args) args.dimension19 = args.mortgage_coach_status;
    (0, (/*@__PURE__*/$parcel$interopDefault($1f66261ea4106665$exports))).set(args);
}



function $ca040ad62e5c49d0$export$6566876928b9008d(page) {
    var location = (0, $f4f5613f4156d471$export$45d76561a5302f2b)();
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasSet = _useState[0], setHasSet = _useState[1];
    (0, $hAGkE.useEffect)(function() {
        setHasSet(false);
    }, [
        location
    ]);
    (0, $hAGkE.useLayoutEffect)(function() {
        if (hasSet) return;
        (0, $175ce91c71cebc6b$export$12c0fdede1c6bc6c)(page);
        setHasSet(true);
    }, [
        hasSet
    ]);
    return {
        hasSet: hasSet
    };
}


function $abdb2fb264b19dc5$export$b779055c9d482128() {
    var _this;
    var seedData = (_this = new URLSearchParams(window.location.search)) === null || _this === void 0 ? void 0 : _this.get("seedData");
    if (!seedData) return null;
    var data = JSON.parse(atob(seedData));
    return {
        mortgageType: GetMortgageType(data.mortgageType),
        purchaseType: data.purchaseType,
        occupancy: data["basicPropertyDetails"] ? GetOccupancy(data["basicPropertyDetails.Occupancy"]) : null
    };
    function GetOccupancy(occupancyType) {
        switch(occupancyType){
            case "Rent_it_out":
                return "Rent_it_out";
            case "Live_in_property":
                return "Live_in_property";
            default:
                return null;
        }
    }
    function GetMortgageType(mortgageType) {
        switch(mortgageType){
            case "purchase":
                return "purchase";
            case "remo":
            case "remortgage":
                return "remo";
            default:
                return null;
        }
    }
}



var $8c6ug = parcelRequire("8c6ug");


parcelRequire("hAGkE");


var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");


var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");

var $5d550af05e29e2a1$exports = {};
$5d550af05e29e2a1$exports = $parcel$resolve("6WwfZ");


var $7eb15b9996c76009$exports = {};
$7eb15b9996c76009$exports = $parcel$resolve("fWECs");


var $b79b8e3f05c87951$exports = {};
$b79b8e3f05c87951$exports = $parcel$resolve("ji129");


var $f0318dc2ecd419e3$exports = {};
$f0318dc2ecd419e3$exports = $parcel$resolve("bLUaQ");



var $hAGkE = parcelRequire("hAGkE");
function $a891435b0919ce63$export$71b2224f1ce5e08e(ref) {
    var handler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    (0, $hAGkE.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) handler();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
}


var $e7f5b961b2d85f88$export$2e2bcd8739ae039 = {
    bp_xs: "(min-width: 400px)",
    bp_sm: "(min-width: 768px)",
    bp_md: "(min-width: 992px)",
    bp_lg: "(min-width: 1024px)",
    bp_xl: "(min-width: 1200px)"
};



var $529f76fb6e0b38ff$export$49b69d753a55f8a1 = "60px";
var $529f76fb6e0b38ff$export$6963211b0a85a7e5 = "8rem";




var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");

var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");
var $0f548ebe76884fc5$exports = {};
'use strict';

$0f548ebe76884fc5$exports = (parcelRequire("eBpJ9"));



var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $2xTNA = parcelRequire("2xTNA");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");
var $6d53db81be755382$exports = {};

$parcel$export($6d53db81be755382$exports, "FOCUS_EVENT", function () { return $6d53db81be755382$export$831c820ad60f9d12; });
$parcel$export($6d53db81be755382$exports, "RECONNECT_EVENT", function () { return $6d53db81be755382$export$24e9454cb99a11dc; });
$parcel$export($6d53db81be755382$exports, "MUTATE_EVENT", function () { return $6d53db81be755382$export$75ea288459391154; });
$parcel$export($6d53db81be755382$exports, "ERROR_REVALIDATE_EVENT", function () { return $6d53db81be755382$export$b019c3839228f243; });
var $6d53db81be755382$export$831c820ad60f9d12 = 0;
var $6d53db81be755382$export$24e9454cb99a11dc = 1;
var $6d53db81be755382$export$75ea288459391154 = 2;
var $6d53db81be755382$export$b019c3839228f243 = 3;



var $2xTNA = parcelRequire("2xTNA");
var $7aee9d1e128f145e$var$has = Object.prototype.hasOwnProperty;
function $7aee9d1e128f145e$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $7aee9d1e128f145e$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || (typeof foo === "undefined" ? "undefined" : (0, $2xTNA._)(foo)) === 'object') {
            len = 0;
            for(ctor in foo){
                if ($7aee9d1e128f145e$var$has.call(foo, ctor) && ++len && !$7aee9d1e128f145e$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$7aee9d1e128f145e$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


'use client';
// Global state used to deduplicate requests and store listeners
var $37eafe68c80273b4$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
var $37eafe68c80273b4$export$ebd11618f299a286 = function() {};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var $37eafe68c80273b4$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $37eafe68c80273b4$export$ebd11618f299a286();
var $37eafe68c80273b4$export$c4ce752e73470fba = Object;
var $37eafe68c80273b4$export$f1e1789686576879 = function(v) {
    return v === $37eafe68c80273b4$export$3a6d5c9ae78a2c08;
};
var $37eafe68c80273b4$export$407448d2b89b1813 = function(v) {
    return typeof v == 'function';
};
var $37eafe68c80273b4$export$953cecd6e717a553 = function(a, b) {
    return (0, $hRCmZ._)({}, a, b);
};
var $37eafe68c80273b4$export$ef35774e6d314e91 = function(x) {
    return $37eafe68c80273b4$export$407448d2b89b1813(x.then);
};
var $37eafe68c80273b4$var$EMPTY_CACHE = {};
var $37eafe68c80273b4$var$INITIAL_CACHE = {};
var $37eafe68c80273b4$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var $37eafe68c80273b4$export$23f2a1d2818174ef = (typeof window === "undefined" ? "undefined" : (0, $2xTNA._)(window)) != $37eafe68c80273b4$var$STR_UNDEFINED;
var $37eafe68c80273b4$export$efccba1c4a2ef57b = (typeof document === "undefined" ? "undefined" : (0, $2xTNA._)(document)) != $37eafe68c80273b4$var$STR_UNDEFINED;
var $37eafe68c80273b4$export$d141bba7fdc215a3 = $37eafe68c80273b4$export$23f2a1d2818174ef && 'Deno' in window;
var $37eafe68c80273b4$export$4a5767248b18ef41 = function() {
    return $37eafe68c80273b4$export$23f2a1d2818174ef && (0, $2xTNA._)(window['requestAnimationFrame']) != $37eafe68c80273b4$var$STR_UNDEFINED;
};
var $37eafe68c80273b4$export$df995fae86a55f06 = function(cache, key) {
    var state = $37eafe68c80273b4$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        function() {
            return !$37eafe68c80273b4$export$f1e1789686576879(key) && cache.get(key) || $37eafe68c80273b4$var$EMPTY_CACHE;
        },
        // Setter
        function(info) {
            if (!$37eafe68c80273b4$export$f1e1789686576879(key)) {
                var prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $37eafe68c80273b4$var$INITIAL_CACHE)) $37eafe68c80273b4$var$INITIAL_CACHE[key] = prev;
                state[5](key, $37eafe68c80273b4$export$953cecd6e717a553(prev, info), prev || $37eafe68c80273b4$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        function() {
            if (!$37eafe68c80273b4$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $37eafe68c80273b4$var$INITIAL_CACHE) return $37eafe68c80273b4$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$37eafe68c80273b4$export$f1e1789686576879(key) && cache.get(key) || $37eafe68c80273b4$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ var $37eafe68c80273b4$var$online = true;
var $37eafe68c80273b4$var$isOnline = function() {
    return $37eafe68c80273b4$var$online;
};
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var $37eafe68c80273b4$var$_ref = (0, $6mdMa._)($37eafe68c80273b4$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $37eafe68c80273b4$export$ebd11618f299a286,
    $37eafe68c80273b4$export$ebd11618f299a286
], 2), $37eafe68c80273b4$var$onWindowEvent = $37eafe68c80273b4$var$_ref[0], $37eafe68c80273b4$var$offWindowEvent = $37eafe68c80273b4$var$_ref[1];
var $37eafe68c80273b4$var$isVisible = function() {
    var visibilityState = $37eafe68c80273b4$export$efccba1c4a2ef57b && document.visibilityState;
    return $37eafe68c80273b4$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
var $37eafe68c80273b4$var$initFocus = function(callback) {
    // focus revalidate
    if ($37eafe68c80273b4$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $37eafe68c80273b4$var$onWindowEvent('focus', callback);
    return function() {
        if ($37eafe68c80273b4$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $37eafe68c80273b4$var$offWindowEvent('focus', callback);
    };
};
var $37eafe68c80273b4$var$initReconnect = function(callback) {
    // revalidate on reconnected
    var onOnline = function() {
        $37eafe68c80273b4$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function() {
        $37eafe68c80273b4$var$online = false;
    };
    $37eafe68c80273b4$var$onWindowEvent('online', onOnline);
    $37eafe68c80273b4$var$onWindowEvent('offline', onOffline);
    return function() {
        $37eafe68c80273b4$var$offWindowEvent('online', onOnline);
        $37eafe68c80273b4$var$offWindowEvent('offline', onOffline);
    };
};
var $37eafe68c80273b4$export$ffb5f4729a158638 = {
    isOnline: $37eafe68c80273b4$var$isOnline,
    isVisible: $37eafe68c80273b4$var$isVisible
};
var $37eafe68c80273b4$export$9e5f44173e64f162 = {
    initFocus: $37eafe68c80273b4$var$initFocus,
    initReconnect: $37eafe68c80273b4$var$initReconnect
};
var $37eafe68c80273b4$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useId;
var $37eafe68c80273b4$export$43caf9889c228507 = !$37eafe68c80273b4$export$23f2a1d2818174ef || $37eafe68c80273b4$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
var $37eafe68c80273b4$export$625550452a3fa3ec = function(f) {
    return $37eafe68c80273b4$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var $37eafe68c80273b4$export$3b14a55fb2447963 = $37eafe68c80273b4$export$43caf9889c228507 ? (0, $hAGkE.useEffect) : (0, $hAGkE.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
var $37eafe68c80273b4$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var $37eafe68c80273b4$export$90a7f3efeed30595 = !$37eafe68c80273b4$export$43caf9889c228507 && $37eafe68c80273b4$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($37eafe68c80273b4$var$navigatorConnection.effectiveType) || $37eafe68c80273b4$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $37eafe68c80273b4$var$table = new WeakMap();
var $37eafe68c80273b4$var$getTypeName = function(value) {
    return $37eafe68c80273b4$export$c4ce752e73470fba.prototype.toString.call(value);
};
var $37eafe68c80273b4$var$isObjectTypeName = function(typeName, type) {
    return typeName === "[object ".concat(type, "]");
};
// counter of the key
var $37eafe68c80273b4$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
var $37eafe68c80273b4$export$882b5998b3b9117c = function(arg) {
    var type = typeof arg === "undefined" ? "undefined" : (0, $2xTNA._)(arg);
    var typeName = $37eafe68c80273b4$var$getTypeName(arg);
    var isDate = $37eafe68c80273b4$var$isObjectTypeName(typeName, 'Date');
    var isRegex = $37eafe68c80273b4$var$isObjectTypeName(typeName, 'RegExp');
    var isPlainObject = $37eafe68c80273b4$var$isObjectTypeName(typeName, 'Object');
    var result;
    var index;
    if ($37eafe68c80273b4$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $37eafe68c80273b4$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$37eafe68c80273b4$var$counter + '~';
        $37eafe68c80273b4$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $37eafe68c80273b4$export$882b5998b3b9117c(arg[index]) + ',';
            $37eafe68c80273b4$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            var keys = $37eafe68c80273b4$export$c4ce752e73470fba.keys(arg).sort();
            while(!$37eafe68c80273b4$export$f1e1789686576879(index = keys.pop()))if (!$37eafe68c80273b4$export$f1e1789686576879(arg[index])) result += index + ':' + $37eafe68c80273b4$export$882b5998b3b9117c(arg[index]) + ',';
            $37eafe68c80273b4$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
var $37eafe68c80273b4$export$2408f22a0fab9ae5 = function(key) {
    if ($37eafe68c80273b4$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    var args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $37eafe68c80273b4$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
var $37eafe68c80273b4$var$__timestamp = 0;
var $37eafe68c80273b4$export$ae1af26003f05816 = function() {
    return ++$37eafe68c80273b4$var$__timestamp;
};
function $37eafe68c80273b4$export$7ccc53e8f1e7dfc5() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var _args, cache, _key, _data, _opts, options, populateCache, rollbackOnErrorOption, optimisticData, rollbackOnError, throwOnError, keyFilter, matchedKeys, it, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
        function mutateByKey(_k) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var _serialize, key, _createCacheHelper, get, set, _SWRGlobalState_get, EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD, startRevalidate, data, error, isError, beforeMutationTs, hasOptimisticData, state, displayedData, currentData, committedData, populateCachedData;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Serialize key
                            _serialize = (0, $6mdMa._)($37eafe68c80273b4$export$2408f22a0fab9ae5(_k), 1), key = _serialize[0];
                            if (!key) return [
                                2
                            ];
                            _createCacheHelper = (0, $6mdMa._)($37eafe68c80273b4$export$df995fae86a55f06(cache, key), 2), get = _createCacheHelper[0], set = _createCacheHelper[1];
                            _SWRGlobalState_get = (0, $6mdMa._)($37eafe68c80273b4$export$8b22cf2602fb60ce.get(cache), 4), EVENT_REVALIDATORS = _SWRGlobalState_get[0], MUTATION = _SWRGlobalState_get[1], FETCH = _SWRGlobalState_get[2], PRELOAD = _SWRGlobalState_get[3];
                            startRevalidate = function() {
                                var revalidators = EVENT_REVALIDATORS[key];
                                var revalidate = $37eafe68c80273b4$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
                                if (revalidate) {
                                    // Invalidate the key by deleting the concurrent request markers so new
                                    // requests will not be deduped.
                                    delete FETCH[key];
                                    delete PRELOAD[key];
                                    if (revalidators && revalidators[0]) return revalidators[0]($6d53db81be755382$export$75ea288459391154).then(function() {
                                        return get().data;
                                    });
                                }
                                return get().data;
                            };
                            // If there is no new data provided, revalidate the key with current state.
                            if (args.length < 3) // Revalidate and broadcast state.
                            return [
                                2,
                                startRevalidate()
                            ];
                            data = _data;
                            isError = false;
                            // Update global timestamps.
                            beforeMutationTs = $37eafe68c80273b4$export$ae1af26003f05816();
                            MUTATION[key] = [
                                beforeMutationTs,
                                0
                            ];
                            hasOptimisticData = !$37eafe68c80273b4$export$f1e1789686576879(optimisticData);
                            state = get();
                            // `displayedData` is the current value on screen. It could be the optimistic value
                            // that is going to be overridden by a `committedData`, or get reverted back.
                            // `committedData` is the validated value that comes from a fetch or mutation.
                            displayedData = state.data;
                            currentData = state._c;
                            committedData = $37eafe68c80273b4$export$f1e1789686576879(currentData) ? displayedData : currentData;
                            // Do optimistic data update.
                            if (hasOptimisticData) {
                                optimisticData = $37eafe68c80273b4$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
                                // When we set optimistic data, backup the current committedData data in `_c`.
                                set({
                                    data: optimisticData,
                                    _c: committedData
                                });
                            }
                            if ($37eafe68c80273b4$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
                            try {
                                data = data(committedData);
                            } catch (err) {
                                // If it throws an error synchronously, we shouldn't update the cache.
                                error = err;
                                isError = true;
                            }
                            if (!(data && $37eafe68c80273b4$export$ef35774e6d314e91(data))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                data["catch"](function(err) {
                                    error = err;
                                    isError = true;
                                })
                            ];
                        case 1:
                            // This means that the mutation is async, we need to check timestamps to
                            // avoid race conditions.
                            data = _state.sent();
                            // Check if other mutations have occurred since we've started this mutation.
                            // If there's a race we don't update cache or broadcast the change,
                            // just return the data.
                            if (beforeMutationTs !== MUTATION[key][0]) {
                                if (isError) throw error;
                                return [
                                    2,
                                    data
                                ];
                            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                                // Rollback. Always populate the cache in this case but without
                                // transforming the data.
                                populateCache = true;
                                // Reset data to be the latest committed data, and clear the `_c` value.
                                set({
                                    data: committedData,
                                    _c: $37eafe68c80273b4$export$3a6d5c9ae78a2c08
                                });
                            }
                            _state.label = 2;
                        case 2:
                            // If we should write back the cache after request.
                            if (populateCache) {
                                if (!isError) {
                                    // Transform the result into data.
                                    if ($37eafe68c80273b4$export$407448d2b89b1813(populateCache)) {
                                        populateCachedData = populateCache(data, committedData);
                                        set({
                                            data: populateCachedData,
                                            error: $37eafe68c80273b4$export$3a6d5c9ae78a2c08,
                                            _c: $37eafe68c80273b4$export$3a6d5c9ae78a2c08
                                        });
                                    } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                                    set({
                                        data: data,
                                        error: $37eafe68c80273b4$export$3a6d5c9ae78a2c08,
                                        _c: $37eafe68c80273b4$export$3a6d5c9ae78a2c08
                                    });
                                }
                            }
                            // Reset the timestamp to mark the mutation has ended.
                            MUTATION[key][1] = $37eafe68c80273b4$export$ae1af26003f05816();
                            // Update existing SWR Hooks' internal states:
                            Promise.resolve(startRevalidate()).then(function() {
                                // The mutation and revalidation are ended, we can clear it since the data is
                                // not an optimistic value anymore.
                                set({
                                    _c: $37eafe68c80273b4$export$3a6d5c9ae78a2c08
                                });
                            });
                            // Throw error or return data
                            if (isError) {
                                if (throwOnError) throw error;
                                return [
                                    2
                                ];
                            }
                            return [
                                2,
                                data
                            ];
                    }
                });
            })();
        }
        return (0, $dMrZK.__generator)(this, function(_state) {
            _args = (0, $6mdMa._)(args, 4), cache = _args[0], _key = _args[1], _data = _args[2], _opts = _args[3];
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            options = $37eafe68c80273b4$export$953cecd6e717a553({
                populateCache: true,
                throwOnError: true
            }, typeof _opts === 'boolean' ? {
                revalidate: _opts
            } : _opts || {});
            populateCache = options.populateCache;
            rollbackOnErrorOption = options.rollbackOnError;
            optimisticData = options.optimisticData;
            rollbackOnError = function(error) {
                return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
            };
            throwOnError = options.throwOnError;
            // If the second argument is a key filter, return the mutation results for all
            // filtered keys.
            if ($37eafe68c80273b4$export$407448d2b89b1813(_key)) {
                keyFilter = _key;
                matchedKeys = [];
                it = cache.keys();
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(_iterator = it[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        key = _step.value;
                        if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2,
                    Promise.all(matchedKeys.map(mutateByKey))
                ];
            }
            return [
                2,
                mutateByKey(_key)
            ];
        });
    })();
}
var $37eafe68c80273b4$var$revalidateAllKeys = function(revalidators, type) {
    for(var key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
var $37eafe68c80273b4$export$dda1d9f60106f0e9 = function(provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$37eafe68c80273b4$export$8b22cf2602fb60ce.has(provider)) {
        var opts = $37eafe68c80273b4$export$953cecd6e717a553($37eafe68c80273b4$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = Object.create(null);
        var mutate = $37eafe68c80273b4$export$7ccc53e8f1e7dfc5.bind($37eafe68c80273b4$export$3a6d5c9ae78a2c08, provider);
        var unmount = $37eafe68c80273b4$export$ebd11618f299a286;
        var subscriptions = Object.create(null);
        var subscribe = function(key, callback) {
            var subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return function() {
                return subs.splice(subs.indexOf(callback), 1);
            };
        };
        var setter = function(key, value, prev) {
            provider.set(key, value);
            var subs = subscriptions[key];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (subs) try {
                for(var _iterator = subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var fn = _step.value;
                    fn(value, prev);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var initProvider = function() {
            if (!$37eafe68c80273b4$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $37eafe68c80273b4$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$37eafe68c80273b4$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    var releaseFocus = opts.initFocus(setTimeout.bind($37eafe68c80273b4$export$3a6d5c9ae78a2c08, $37eafe68c80273b4$var$revalidateAllKeys.bind($37eafe68c80273b4$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $6d53db81be755382$export$831c820ad60f9d12)));
                    var releaseReconnect = opts.initReconnect(setTimeout.bind($37eafe68c80273b4$export$3a6d5c9ae78a2c08, $37eafe68c80273b4$var$revalidateAllKeys.bind($37eafe68c80273b4$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $6d53db81be755382$export$24e9454cb99a11dc)));
                    unmount = function() {
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $37eafe68c80273b4$export$8b22cf2602fb60ce["delete"](provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $37eafe68c80273b4$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
var $37eafe68c80273b4$var$onErrorRetry = function(_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$37eafe68c80273b4$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
var $37eafe68c80273b4$export$342063e11d6c3cad = (0, $7aee9d1e128f145e$export$de8294bb3be0322f);
// Default cache provider
var $37eafe68c80273b4$var$_initCache = (0, $6mdMa._)($37eafe68c80273b4$export$dda1d9f60106f0e9(new Map()), 2), $37eafe68c80273b4$export$db3b6bfb95261072 = $37eafe68c80273b4$var$_initCache[0], $37eafe68c80273b4$export$35e795649ee09318 = $37eafe68c80273b4$var$_initCache[1];
// Default config
var $37eafe68c80273b4$export$4368d992c4eafac0 = $37eafe68c80273b4$export$953cecd6e717a553({
    // events
    onLoadingSlow: $37eafe68c80273b4$export$ebd11618f299a286,
    onSuccess: $37eafe68c80273b4$export$ebd11618f299a286,
    onError: $37eafe68c80273b4$export$ebd11618f299a286,
    onErrorRetry: $37eafe68c80273b4$var$onErrorRetry,
    onDiscarded: $37eafe68c80273b4$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $37eafe68c80273b4$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $37eafe68c80273b4$export$90a7f3efeed30595 ? 5000 : 3000,
    // providers
    compare: $37eafe68c80273b4$export$342063e11d6c3cad,
    isPaused: function() {
        return false;
    },
    cache: $37eafe68c80273b4$export$db3b6bfb95261072,
    mutate: $37eafe68c80273b4$export$35e795649ee09318,
    fallback: {}
}, $37eafe68c80273b4$export$ffb5f4729a158638);
var $37eafe68c80273b4$export$2d1720544b23b823 = function(a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = $37eafe68c80273b4$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $37eafe68c80273b4$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
var $37eafe68c80273b4$export$25ce5a424b770e84 = (0, $hAGkE.createContext)({});
var $37eafe68c80273b4$export$39b482c5e57630a8 = function(props) {
    var value = props.value;
    var parentConfig = (0, $hAGkE.useContext)($37eafe68c80273b4$export$25ce5a424b770e84);
    var isFunctionalConfig = $37eafe68c80273b4$export$407448d2b89b1813(value);
    var config = (0, $hAGkE.useMemo)(function() {
        return isFunctionalConfig ? value(parentConfig) : value;
    }, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    var extendedConfig = (0, $hAGkE.useMemo)(function() {
        return isFunctionalConfig ? config : $37eafe68c80273b4$export$2d1720544b23b823(parentConfig, config);
    }, [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    var provider = config && config.provider;
    // initialize the cache only on first access.
    var cacheContextRef = (0, $hAGkE.useRef)($37eafe68c80273b4$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $37eafe68c80273b4$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $37eafe68c80273b4$export$db3b6bfb95261072), config);
    var cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $37eafe68c80273b4$export$3b14a55fb2447963(function() {
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $hAGkE.createElement)($37eafe68c80273b4$export$25ce5a424b770e84.Provider, $37eafe68c80273b4$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};


var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");


var $d87922f2571f8f7d$export$8667f065faedc62c = '$inf$';



var $hAGkE = parcelRequire("hAGkE");

// @ts-expect-error
var $64c9f769e8c4aed4$var$enableDevtools = (0, $37eafe68c80273b4$export$23f2a1d2818174ef) && window.__SWR_DEVTOOLS_USE__;
var $64c9f769e8c4aed4$var$use = $64c9f769e8c4aed4$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
var $64c9f769e8c4aed4$var$setupDevTools = function() {
    if ($64c9f769e8c4aed4$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE)));
};
var $64c9f769e8c4aed4$export$a3295358bff77e = function(args) {
    return (0, $37eafe68c80273b4$export$407448d2b89b1813)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
var $64c9f769e8c4aed4$export$f1dc0e282d4c1c0 = function() {
    var parentConfig = (0, $hAGkE.useContext)((0, $37eafe68c80273b4$export$25ce5a424b770e84));
    var mergedConfig = (0, $hAGkE.useMemo)(function() {
        return (0, $37eafe68c80273b4$export$953cecd6e717a553)((0, $37eafe68c80273b4$export$4368d992c4eafac0), parentConfig);
    }, [
        parentConfig
    ]);
    return mergedConfig;
};
var $64c9f769e8c4aed4$export$513ccb98c53b8039 = function(key_, fetcher) {
    var _serialize = (0, $6mdMa._)((0, $37eafe68c80273b4$export$2408f22a0fab9ae5)(key_), 2), key = _serialize[0], fnArg = _serialize[1];
    var _SWRGlobalState_get = (0, $6mdMa._)((0, $37eafe68c80273b4$export$8b22cf2602fb60ce).get((0, $37eafe68c80273b4$export$db3b6bfb95261072)), 4), PRELOAD = _SWRGlobalState_get[3];
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    var req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
var $64c9f769e8c4aed4$var$middleware = function(useSWRNext) {
    return function(key_, fetcher_, config) {
        // fetcher might be a sync function, so this should not be an async function
        var fetcher = fetcher_ && function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _serialize = (0, $6mdMa._)((0, $37eafe68c80273b4$export$2408f22a0fab9ae5)(key_), 1), key = _serialize[0];
            var _SWRGlobalState_get = (0, $6mdMa._)((0, $37eafe68c80273b4$export$8b22cf2602fb60ce).get((0, $37eafe68c80273b4$export$db3b6bfb95261072)), 4), PRELOAD = _SWRGlobalState_get[3];
            if (key.startsWith((0, $d87922f2571f8f7d$export$8667f065faedc62c))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_.apply(void 0, (0, $bOqL7._)(args));
            var req = PRELOAD[key];
            if ((0, $37eafe68c80273b4$export$f1e1789686576879)(req)) return fetcher_.apply(void 0, (0, $bOqL7._)(args));
            delete PRELOAD[key];
            return req;
        };
        return useSWRNext(key_, fetcher, config);
    };
};
var $64c9f769e8c4aed4$var$BUILT_IN_MIDDLEWARE = $64c9f769e8c4aed4$var$use.concat($64c9f769e8c4aed4$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var $64c9f769e8c4aed4$export$84d44e54e14b0133 = function(hook) {
    return function useSWRArgs() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = $64c9f769e8c4aed4$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        var _normalize = (0, $6mdMa._)($64c9f769e8c4aed4$export$a3295358bff77e(args), 3), key = _normalize[0], fn = _normalize[1], _config = _normalize[2];
        // Merge configurations.
        var config = (0, $37eafe68c80273b4$export$2d1720544b23b823)(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        var middleware = (use || []).concat($64c9f769e8c4aed4$var$BUILT_IN_MIDDLEWARE);
        for(var i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var $64c9f769e8c4aed4$export$e005210ed621746 = function(key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function() {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
var $64c9f769e8c4aed4$export$525ea7fc6ba00096 = function(useSWR, middleware) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _normalize = (0, $6mdMa._)($64c9f769e8c4aed4$export$a3295358bff77e(args), 3), key = _normalize[0], fn = _normalize[1], config = _normalize[2];
        var uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, (0, $7XD9P._)((0, $hRCmZ._)({}, config), {
            use: uses
        }));
    };
};
$64c9f769e8c4aed4$var$setupDevTools();


// Shared state between server components and client components
var $69b91e38b962ffe6$var$noop = function() {};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var $69b91e38b962ffe6$var$UNDEFINED = /*#__NOINLINE__*/ $69b91e38b962ffe6$var$noop();
var $69b91e38b962ffe6$var$OBJECT = Object;
var $69b91e38b962ffe6$var$isUndefined = function(v) {
    return v === $69b91e38b962ffe6$var$UNDEFINED;
};
var $69b91e38b962ffe6$var$isFunction = function(v) {
    return typeof v == 'function';
};
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $69b91e38b962ffe6$var$table = new WeakMap();
var $69b91e38b962ffe6$var$getTypeName = function(value) {
    return $69b91e38b962ffe6$var$OBJECT.prototype.toString.call(value);
};
var $69b91e38b962ffe6$var$isObjectTypeName = function(typeName, type) {
    return typeName === "[object ".concat(type, "]");
};
// counter of the key
var $69b91e38b962ffe6$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
var $69b91e38b962ffe6$var$stableHash = function(arg) {
    var type = typeof arg === "undefined" ? "undefined" : (0, $2xTNA._)(arg);
    var typeName = $69b91e38b962ffe6$var$getTypeName(arg);
    var isDate = $69b91e38b962ffe6$var$isObjectTypeName(typeName, 'Date');
    var isRegex = $69b91e38b962ffe6$var$isObjectTypeName(typeName, 'RegExp');
    var isPlainObject = $69b91e38b962ffe6$var$isObjectTypeName(typeName, 'Object');
    var result;
    var index;
    if ($69b91e38b962ffe6$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $69b91e38b962ffe6$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$69b91e38b962ffe6$var$counter + '~';
        $69b91e38b962ffe6$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $69b91e38b962ffe6$var$stableHash(arg[index]) + ',';
            $69b91e38b962ffe6$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            var keys = $69b91e38b962ffe6$var$OBJECT.keys(arg).sort();
            while(!$69b91e38b962ffe6$var$isUndefined(index = keys.pop()))if (!$69b91e38b962ffe6$var$isUndefined(arg[index])) result += index + ':' + $69b91e38b962ffe6$var$stableHash(arg[index]) + ',';
            $69b91e38b962ffe6$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
var $69b91e38b962ffe6$var$serialize = function(key) {
    if ($69b91e38b962ffe6$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    var args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $69b91e38b962ffe6$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
var $69b91e38b962ffe6$export$dbab534a48e651ef = function(key) {
    return $69b91e38b962ffe6$var$serialize(key)[0];
};
/// <reference types="react/experimental" />
var $69b91e38b962ffe6$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
function(thenable) {
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then(function(v) {
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, function(e) {
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
};
var $69b91e38b962ffe6$var$WITH_DEDUPE = {
    dedupe: true
};
var $69b91e38b962ffe6$var$resolvedUndef = Promise.resolve((0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08));
var $69b91e38b962ffe6$var$useSWRHandler = function(_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, suspense = config.suspense, fallbackData = config.fallbackData, revalidateOnMount = config.revalidateOnMount, revalidateIfStale = config.revalidateIfStale, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline, keepPreviousData = config.keepPreviousData;
    var _SWRGlobalState_get = (0, $6mdMa._)((0, $37eafe68c80273b4$export$8b22cf2602fb60ce).get(cache), 4), EVENT_REVALIDATORS = _SWRGlobalState_get[0], MUTATION = _SWRGlobalState_get[1], FETCH = _SWRGlobalState_get[2], PRELOAD = _SWRGlobalState_get[3];
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    var _serialize$1 = (0, $6mdMa._)((0, $37eafe68c80273b4$export$2408f22a0fab9ae5)(_key), 2), key = _serialize$1[0], fnArg = _serialize$1[1];
    // If it's the initial render of this hook.
    var initialMountedRef = (0, $hAGkE.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0, $hAGkE.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0, $hAGkE.useRef)(key);
    var fetcherRef = (0, $hAGkE.useRef)(fetcher);
    var configRef = (0, $hAGkE.useRef)(config);
    var getConfig = function() {
        return configRef.current;
    };
    var isActive = function() {
        return getConfig().isVisible() && getConfig().isOnline();
    };
    var _createCacheHelper = (0, $6mdMa._)((0, $37eafe68c80273b4$export$df995fae86a55f06)(cache, key), 4), getCache = _createCacheHelper[0], setCache = _createCacheHelper[1], subscribeCache = _createCacheHelper[2], getInitialCache = _createCacheHelper[3];
    var stateDependencies = (0, $hAGkE.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    var fallback = (0, $37eafe68c80273b4$export$f1e1789686576879)(fallbackData) ? (0, $37eafe68c80273b4$export$f1e1789686576879)(config.fallback) ? (0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08) : config.fallback[key] : fallbackData;
    var isEqual = function(prev, current) {
        for(var _ in stateDependencies){
            var t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $37eafe68c80273b4$export$f1e1789686576879)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    var getSnapshot = (0, $hAGkE.useMemo)(function() {
        var shouldStartRequest = function() {
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $37eafe68c80273b4$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        }();
        // Get the cache and merge it with expected states.
        var getSelectedCache = function(state) {
            // We only select the needed fields from the state.
            var snapshot = (0, $37eafe68c80273b4$export$953cecd6e717a553)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return (0, $hRCmZ._)({
                isValidating: true,
                isLoading: true
            }, snapshot);
        };
        var cachedData = getCache();
        var initialData = getInitialCache();
        var clientSnapshot = getSelectedCache(cachedData);
        var serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        var memorizedSnapshot = clientSnapshot;
        return [
            function() {
                var newSnapshot = getSelectedCache(getCache());
                var compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            function() {
                return serverSnapshot;
            }
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    var cached = (0, $0f548ebe76884fc5$exports.useSyncExternalStore)((0, $hAGkE.useCallback)(function(callback) {
        return subscribeCache(key, function(current, prev) {
            if (!isEqual(prev, current)) callback();
        });
    }, [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    var isInitialMount = !initialMountedRef.current;
    var hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    var cachedData = cached.data;
    var data = (0, $37eafe68c80273b4$export$f1e1789686576879)(cachedData) ? fallback && (0, $37eafe68c80273b4$export$ef35774e6d314e91)(fallback) ? $69b91e38b962ffe6$var$use(fallback) : fallback : cachedData;
    var error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    var laggyDataRef = (0, $hAGkE.useRef)(data);
    var returnedData = keepPreviousData ? (0, $37eafe68c80273b4$export$f1e1789686576879)(cachedData) ? (0, $37eafe68c80273b4$export$f1e1789686576879)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldDoInitialRevalidation = function() {
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $37eafe68c80273b4$export$f1e1789686576879)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $37eafe68c80273b4$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $37eafe68c80273b4$export$f1e1789686576879)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $37eafe68c80273b4$export$f1e1789686576879)(data) || revalidateIfStale;
    }();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    var defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    var isValidating = (0, $37eafe68c80273b4$export$f1e1789686576879)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    var isLoading = (0, $37eafe68c80273b4$export$f1e1789686576879)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0, $hAGkE.useCallback)(function(revalidateOpts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, callbackSafeguard, finalState, finishRequestAndUpdateState, cleanupState, initialState, ref, mutationInfo, cacheData, err, currentConfig, shouldRetryOnError;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentFetcher = fetcherRef.current;
                        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return [
                            2,
                            false
                        ];
                        loading = true;
                        opts = revalidateOpts || {};
                        // If there is no ongoing concurrent request, or `dedupe` is not set, a
                        // new request should be initiated.
                        shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ callbackSafeguard = function() {
                            if (0, $37eafe68c80273b4$export$9bb611d729802a56) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
                            return key === keyRef.current;
                        };
                        // The final state object when the request finishes.
                        finalState = {
                            isValidating: false,
                            isLoading: false
                        };
                        finishRequestAndUpdateState = function() {
                            setCache(finalState);
                        };
                        cleanupState = function() {
                            // Check if it's still the same request before deleting it.
                            var requestInfo = FETCH[key];
                            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
                        };
                        // Start fetching. Change the `isValidating` state, update the cache.
                        initialState = {
                            isValidating: true
                        };
                        // It is in the `isLoading` state, if and only if there is no cached data.
                        // This bypasses fallback data and laggy data.
                        if ((0, $37eafe68c80273b4$export$f1e1789686576879)(getCache().data)) initialState.isLoading = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (shouldStartNewRequest) {
                            setCache(initialState);
                            // If no cache is being rendered currently (it shows a blank page),
                            // we trigger the loading slow event.
                            if (config.loadingTimeout && (0, $37eafe68c80273b4$export$f1e1789686576879)(getCache().data)) setTimeout(function() {
                                if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                            }, config.loadingTimeout);
                            // Start the request and save the timestamp.
                            // Key must be truthy if entering here.
                            FETCH[key] = [
                                currentFetcher(fnArg),
                                (0, $37eafe68c80273b4$export$ae1af26003f05816)()
                            ];
                        }
                        ref = (0, $6mdMa._)(FETCH[key], 2), newData = ref[0], startAt = ref[1], ref;
                        return [
                            4,
                            newData
                        ];
                    case 2:
                        newData = _state.sent();
                        if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                        // If there're other ongoing request(s), started after the current one,
                        // we need to ignore the current one to avoid possible race conditions:
                        //   req1------------------>res1        (current one)
                        //        req2---------------->res2
                        // the request that fired later will always be kept.
                        // The timestamp maybe be `undefined` or a number
                        if (!FETCH[key] || FETCH[key][1] !== startAt) {
                            if (shouldStartNewRequest) {
                                if (callbackSafeguard()) getConfig().onDiscarded(key);
                            }
                            return [
                                2,
                                false
                            ];
                        }
                        // Clear error.
                        finalState.error = (0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08);
                        // If there're other mutations(s), that overlapped with the current revalidation:
                        // case 1:
                        //   req------------------>res
                        //       mutate------>end
                        // case 2:
                        //         req------------>res
                        //   mutate------>end
                        // case 3:
                        //   req------------------>res
                        //       mutate-------...---------->
                        // we have to ignore the revalidation result (res) because it's no longer fresh.
                        // meanwhile, a new revalidation should be triggered when the mutation ends.
                        mutationInfo = MUTATION[key];
                        if (!(0, $37eafe68c80273b4$export$f1e1789686576879)(mutationInfo) && // case 1
                        (startAt <= mutationInfo[0] || // case 2
                        startAt <= mutationInfo[1] || // case 3
                        mutationInfo[1] === 0)) {
                            finishRequestAndUpdateState();
                            if (shouldStartNewRequest) {
                                if (callbackSafeguard()) getConfig().onDiscarded(key);
                            }
                            return [
                                2,
                                false
                            ];
                        }
                        // Deep compare with the latest state to avoid extra re-renders.
                        // For local state, compare and assign.
                        cacheData = getCache().data;
                        // Since the compare fn could be custom fn
                        // cacheData might be different from newData even when compare fn returns True
                        finalState.data = compare(cacheData, newData) ? cacheData : newData;
                        // Trigger the successful callback if it's the original request.
                        if (shouldStartNewRequest) {
                            if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        cleanupState();
                        currentConfig = getConfig();
                        shouldRetryOnError = currentConfig.shouldRetryOnError;
                        // Not paused, we continue handling the error. Otherwise, discard it.
                        if (!currentConfig.isPaused()) {
                            // Get a new error, don't use deep comparison for errors.
                            finalState.error = err;
                            // Error event and retry logic. Only for the actual request, not
                            // deduped ones.
                            if (shouldStartNewRequest && callbackSafeguard()) {
                                currentConfig.onError(err, key, currentConfig);
                                if (shouldRetryOnError === true || (0, $37eafe68c80273b4$export$407448d2b89b1813)(shouldRetryOnError) && shouldRetryOnError(err)) {
                                    if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                                    // refocusing or reconnecting.
                                    // When retrying, deduplication is always enabled.
                                    currentConfig.onErrorRetry(err, key, currentConfig, function(_opts) {
                                        var revalidators = EVENT_REVALIDATORS[key];
                                        if (revalidators && revalidators[0]) revalidators[0]((0, $6d53db81be755382$exports).ERROR_REVALIDATE_EVENT, _opts);
                                    }, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        // Mark loading as stopped.
                        loading = false;
                        // Update the current hook's state.
                        finishRequestAndUpdateState();
                        return [
                            2,
                            true
                        ];
                }
            });
        })();
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    var boundMutate = (0, $hAGkE.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _$_key = 0; _$_key < _len; _$_key++){
            args[_$_key] = arguments[_$_key];
        }
        return (0, $37eafe68c80273b4$export$7ccc53e8f1e7dfc5).apply(void 0, [
            cache,
            keyRef.current
        ].concat((0, $bOqL7._)(args)));
    }, []);
    // The logic for updating refs.
    (0, $37eafe68c80273b4$export$3b14a55fb2447963)(function() {
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $37eafe68c80273b4$export$f1e1789686576879)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $37eafe68c80273b4$export$3b14a55fb2447963)(function() {
        if (!key) return;
        var softRevalidate = revalidate.bind((0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08), $69b91e38b962ffe6$var$WITH_DEDUPE);
        var nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            var initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var onRevalidate = function(type) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (type == (0, $6d53db81be755382$exports).FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $6d53db81be755382$exports).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $6d53db81be755382$exports).MUTATE_EVENT) return revalidate();
            else if (type == (0, $6d53db81be755382$exports).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        var unsubEvents = (0, $64c9f769e8c4aed4$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $37eafe68c80273b4$export$f1e1789686576879)(data) || (0, $37eafe68c80273b4$export$43caf9889c228507)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $37eafe68c80273b4$export$625550452a3fa3ec)(softRevalidate);
            }
        }
        return function() {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $37eafe68c80273b4$export$3b14a55fb2447963)(function() {
        var next = function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = (0, $37eafe68c80273b4$export$407448d2b89b1813)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        };
        var execute = function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($69b91e38b962ffe6$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        };
        var timer;
        next();
        return function() {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $hAGkE.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        var hasKeyButNoData = key && (0, $37eafe68c80273b4$export$f1e1789686576879)(data);
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $37eafe68c80273b4$export$9bb611d729802a56) && (0, $37eafe68c80273b4$export$43caf9889c228507) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        var req = PRELOAD[key];
        var mutateReq = !(0, $37eafe68c80273b4$export$f1e1789686576879)(req) && hasKeyButNoData ? boundMutate(req) : $69b91e38b962ffe6$var$resolvedUndef;
        $69b91e38b962ffe6$var$use(mutateReq);
        if (!(0, $37eafe68c80273b4$export$f1e1789686576879)(error) && hasKeyButNoData) throw error;
        var revalidation = hasKeyButNoData ? revalidate($69b91e38b962ffe6$var$WITH_DEDUPE) : $69b91e38b962ffe6$var$resolvedUndef;
        if (!(0, $37eafe68c80273b4$export$f1e1789686576879)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $69b91e38b962ffe6$var$use(revalidation);
    }
    var swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
var $69b91e38b962ffe6$export$4c7bbecdacc3ca2c = (0, $37eafe68c80273b4$export$c4ce752e73470fba).defineProperty((0, $37eafe68c80273b4$export$39b482c5e57630a8), 'defaultValue', {
    value: (0, $37eafe68c80273b4$export$4368d992c4eafac0)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ var $69b91e38b962ffe6$export$2e2bcd8739ae039 = (0, $64c9f769e8c4aed4$export$84d44e54e14b0133)($69b91e38b962ffe6$var$useSWRHandler);



var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");
var $0e691535434e3142$exports = {};

$0e691535434e3142$exports = (parcelRequire("eo1P1"));


var $7bc94308ccec6ce9$export$a0973bcfe11b05c9 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports)))("https://public-auth.mojomortgages.com/logout", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            withCredentials: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    })();
};



var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");


var $cCIJH = parcelRequire("cCIJH");
var $e71f3e34eeaf82ee$export$12151e9ef3722552 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var err, _err_response, _err_response_status;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://public-auth.mojomortgages.com/session", {
                            withCredentials: true
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    err = _state.sent();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).isAxiosError(err) || ![
                        401,
                        403
                    ].includes((_err_response_status = (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status) !== null && _err_response_status !== void 0 ? _err_response_status : 0)) // 401/403 responses here are normal errors occuring when a session naturally expires
                    // but all other errors are unusual, and we need o11y of them
                    $cCIJH.captureException(err, {
                        tags: {
                            area: "auth",
                            operation: "getSession"
                        }
                    });
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $e71f3e34eeaf82ee$export$df40ba287143dd44 = function() {
    var redirect = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).redirect;
    return (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://public-auth.mojomortgages.com/session/share?redirect=".concat(encodeURIComponent(redirect)), {
        withCredentials: true
    });
};





var $01653cfe8f3c67b0$export$ad0a340bf97d63d5 = function() {
    return (0, $69b91e38b962ffe6$export$2e2bcd8739ae039)("session", function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var session, err;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $e71f3e34eeaf82ee$export$12151e9ef3722552)()
                        ];
                    case 1:
                        session = _state.sent();
                        (0, $175ce91c71cebc6b$export$570cb92f1dba3f65)(session.data);
                        return [
                            2,
                            session.data
                        ];
                    case 2:
                        err = _state.sent();
                        (0, $175ce91c71cebc6b$export$570cb92f1dba3f65)(null);
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, {
        // self explanatory
        shouldRetryOnError: false,
        // revalidates when window or tab is re-focused
        revalidateOnFocus: false,
        // revalidates if hook is re-rendered and the data is stale
        revalidateIfStale: false,
        // revalidate data after reconnecting to the network
        revalidateOnReconnect: false
    });
};
var $01653cfe8f3c67b0$export$fe214daa53b0a716 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $69b91e38b962ffe6$export$2e2bcd8739ae039)("session-qr", function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var sessionQr, err;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $e71f3e34eeaf82ee$export$df40ba287143dd44)(options)
                        ];
                    case 1:
                        sessionQr = _state.sent();
                        return [
                            2,
                            sessionQr.data
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, {
        // self explanatory
        shouldRetryOnError: false,
        // revalidates when window or tab is re-focused
        revalidateOnFocus: false,
        // revalidate data after reconnecting to the network
        revalidateOnReconnect: false
    });
};



var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");

var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");


var $ebc335901f45247a$var$startTransition = (0, $37eafe68c80273b4$export$9bb611d729802a56) ? function(cb) {
    cb();
} : (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).startTransition;
/**
 * An implementation of state with dependency-tracking.
 * @param initialState - The initial state object.
 */ var $ebc335901f45247a$var$useStateWithDeps = function(initialState) {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)({}), 2), rerender = _useState[1];
    var unmountedRef = (0, $hAGkE.useRef)(false);
    var stateRef = (0, $hAGkE.useRef)(initialState);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0, $hAGkE.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * Updates state and triggers re-render if necessary.
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ var setState = (0, $hAGkE.useCallback)(function(payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for(var key in payload)if (Object.prototype.hasOwnProperty.call(payload, key)) {
            var k = key;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) rerender({});
    }, []);
    (0, $37eafe68c80273b4$export$3b14a55fb2447963)(function() {
        unmountedRef.current = false;
        return function() {
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
var $ebc335901f45247a$var$mutation = function() {
    return function(key, fetcher) {
        var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var mutate = (0, $64c9f769e8c4aed4$export$f1dc0e282d4c1c0)().mutate;
        var keyRef = (0, $hAGkE.useRef)(key);
        var fetcherRef = (0, $hAGkE.useRef)(fetcher);
        var configRef = (0, $hAGkE.useRef)(config);
        // Ditch all mutation results that happened earlier than this timestamp.
        var ditchMutationsUntilRef = (0, $hAGkE.useRef)(0);
        var _useStateWithDeps = (0, $6mdMa._)($ebc335901f45247a$var$useStateWithDeps({
            data: (0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08),
            error: (0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08),
            isMutating: false
        }), 3), stateRef = _useStateWithDeps[0], stateDependencies = _useStateWithDeps[1], setState = _useStateWithDeps[2];
        var currentState = stateRef.current;
        var trigger = (0, $hAGkE.useCallback)(function(arg, opts) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var _serialize, serializedKey, resolvedKey, options, mutationStartedAt, data, error;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _serialize = (0, $6mdMa._)((0, $37eafe68c80273b4$export$2408f22a0fab9ae5)(keyRef.current), 2), serializedKey = _serialize[0], resolvedKey = _serialize[1];
                            if (!fetcherRef.current) throw new Error("Can\u2019t trigger the mutation: missing fetcher.");
                            if (!serializedKey) throw new Error("Can\u2019t trigger the mutation: missing key.");
                            // Disable cache population by default.
                            options = (0, $37eafe68c80273b4$export$953cecd6e717a553)((0, $37eafe68c80273b4$export$953cecd6e717a553)({
                                populateCache: false,
                                throwOnError: true
                            }, configRef.current), opts);
                            // Trigger a mutation, and also track the timestamp. Any mutation that happened
                            // earlier this timestamp should be ignored.
                            mutationStartedAt = (0, $37eafe68c80273b4$export$ae1af26003f05816)();
                            ditchMutationsUntilRef.current = mutationStartedAt;
                            setState({
                                isMutating: true
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                mutate(serializedKey, fetcherRef.current(resolvedKey, {
                                    arg: arg
                                }), (0, $37eafe68c80273b4$export$953cecd6e717a553)(options, {
                                    throwOnError: true
                                }))
                            ];
                        case 2:
                            data = _state.sent();
                            // If it's reset after the mutation, we don't broadcast any state change.
                            if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                                $ebc335901f45247a$var$startTransition(function() {
                                    return setState({
                                        data: data,
                                        isMutating: false,
                                        error: undefined
                                    });
                                });
                                options.onSuccess == null || options.onSuccess.call(options, data, serializedKey, options);
                            }
                            return [
                                2,
                                data
                            ];
                        case 3:
                            error = _state.sent();
                            // If it's reset after the mutation, we don't broadcast any state change
                            // or throw because it's discarded.
                            if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                                $ebc335901f45247a$var$startTransition(function() {
                                    return setState({
                                        error: error,
                                        isMutating: false
                                    });
                                });
                                options.onError == null ? undefined : options.onError.call(options, error, serializedKey, options);
                                if (options.throwOnError) throw error;
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }, []);
        var reset = (0, $hAGkE.useCallback)(function() {
            ditchMutationsUntilRef.current = (0, $37eafe68c80273b4$export$ae1af26003f05816)();
            setState({
                data: (0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08),
                error: (0, $37eafe68c80273b4$export$3a6d5c9ae78a2c08),
                isMutating: false
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        (0, $37eafe68c80273b4$export$3b14a55fb2447963)(function() {
            keyRef.current = key;
            fetcherRef.current = fetcher;
            configRef.current = config;
        });
        // We don't return `mutate` here as it can be pretty confusing (e.g. people
        // calling `mutate` but they actually mean `trigger`).
        // And also, `mutate` relies on the useSWR hook to exist too.
        return {
            trigger: trigger,
            reset: reset,
            get data () {
                stateDependencies.data = true;
                return currentState.data;
            },
            get error () {
                stateDependencies.error = true;
                return currentState.error;
            },
            get isMutating () {
                stateDependencies.isMutating = true;
                return currentState.isMutating;
            }
        };
    };
};
/**
 * A hook to define and manually trigger remote mutations like POST, PUT, DELETE and PATCH use cases.
 *
 * @link https://swr.vercel.app/docs/mutation
 * @example
 * ```jsx
 * import useSWRMutation from 'swr/mutation'
 *
 * const {
 *   data,
 *   error,
 *   trigger,
 *   reset,
 *   isMutating
 * } = useSWRMutation(key, fetcher, options?)
 * ```
 */ var $ebc335901f45247a$export$2e2bcd8739ae039 = (0, $64c9f769e8c4aed4$export$525ea7fc6ba00096)((0, $69b91e38b962ffe6$export$2e2bcd8739ae039), $ebc335901f45247a$var$mutation);




var $992ab7ffc1cec8b9$export$9a5b97a7aba1a585 = function() {
    var onSuccess = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).onSuccess;
    var mutate = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)().mutate;
    var _useSWRMutation = (0, $ebc335901f45247a$export$2e2bcd8739ae039)("logout", function() {
        return (0, $7bc94308ccec6ce9$export$a0973bcfe11b05c9)();
    }, {
        onSuccess: function(data) {
            mutate(null, {
                revalidate: false
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
        }
    }), trigger = _useSWRMutation.trigger, data = _useSWRMutation.data, error = _useSWRMutation.error;
    var mutation = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            trigger()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return {
        logout: mutation,
        data: data,
        error: error
    };
};




function $8c4ce8c143193527$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 7px 15px;\n  align-items: center;\n  grid-gap: 5px;\n  height: ",
        ";\n\n  @media ",
        " {\n    padding: 7px 35px;\n  }\n"
    ]);
    $8c4ce8c143193527$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $8c4ce8c143193527$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  width: 90px;\n  pointer-events: ",
        ";\n  cursor: ",
        ";\n\n  @media ",
        " {\n    width: 110px;\n  }\n"
    ]);
    $8c4ce8c143193527$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $8c4ce8c143193527$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  justify-self: left;\n  grid-column: 1;\n"
    ]);
    $8c4ce8c143193527$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $8c4ce8c143193527$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: ",
        ";\n  grid-column: ",
        ";\n  justify-self: ",
        ";\n  height: 100%;\n\n  @media (min-width: 600px) {\n    display: ",
        ";\n  }\n"
    ]);
    $8c4ce8c143193527$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $8c4ce8c143193527$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: inline-flex;\n  grid-column: 3;\n  align-items: center;\n  min-width: 240px;\n  justify-self: flex-end;\n\n  .hamburgerContainer {\n    width: ",
        ";\n    height: ",
        ";\n    position: relative;\n    margin-left: 15px;\n  }\n"
    ]);
    $8c4ce8c143193527$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $8c4ce8c143193527$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  display: block;\n  cursor: pointer;\n\n  img {\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    $8c4ce8c143193527$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $8c4ce8c143193527$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  background: ",
        ";\n  width: 150px;\n  right: 0;\n  top: 60px;\n  border-radius: 4px;\n  border: 1px solid #ebedf3;\n  box-shadow: 0 10px 10px -5px rgba(128, 128, 128, 0.2);\n\n  .action {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n\n    &:hover {\n      cursor: pointer;\n      background: #dfe1e6;\n    }\n  }\n"
    ]);
    $8c4ce8c143193527$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $8c4ce8c143193527$var$HamburgerSize = "33px";
var $8c4ce8c143193527$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8c4ce8c143193527$var$_templateObject(), (0, $529f76fb6e0b38ff$export$49b69d753a55f8a1), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $8c4ce8c143193527$var$Logo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($8c4ce8c143193527$var$_templateObject1(), function(props) {
    return props.clickable ? "all" : "none";
}, function(props) {
    return props.clickable ? "pointer" : "default";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $8c4ce8c143193527$var$LogoContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8c4ce8c143193527$var$_templateObject2());
var $8c4ce8c143193527$var$PoweredByMojo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($8c4ce8c143193527$var$_templateObject3(), function(props) {
    return props.isLoggedIn ? "none" : "initial";
}, function(props) {
    return props.isLoggedIn ? 2 : 3;
}, function(props) {
    return props.isLoggedIn ? "center" : "flex-end";
}, function(props) {
    return props.isLoggedIn ? "initial" : "initial";
});
var $8c4ce8c143193527$var$User = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8c4ce8c143193527$var$_templateObject4(), $8c4ce8c143193527$var$HamburgerSize, $8c4ce8c143193527$var$HamburgerSize);
function $8c4ce8c143193527$export$41d0d88a6b0e456f(param) {
    var _param_showPoweredBy = param.showPoweredBy, showPoweredBy = _param_showPoweredBy === void 0 ? false : _param_showPoweredBy, _param_clickableLogo = param.clickableLogo, clickableLogo = _param_clickableLogo === void 0 ? false : _param_clickableLogo, _param_logoVariant = param.logoVariant, logoVariant = _param_logoVariant === void 0 ? "partnership" : _param_logoVariant, _param_showUser = param.showUser, showUser = _param_showUser === void 0 ? true : _param_showUser;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), showActions = _useState[0], setShowActions = _useState[1];
    var logout = (0, $992ab7ffc1cec8b9$export$9a5b97a7aba1a585)().logout;
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), data = _useSession.data, isLoading = _useSession.isLoading;
    var loggedIn = isLoading ? true : Boolean(data);
    var theme = (0, $7e7d633c88171aa1$export$b3611e87cd5ba6ce)().theme;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var menuRef = (0, $hAGkE.useRef)(null);
    (0, $a891435b0919ce63$export$71b2224f1ce5e08e)(menuRef, function() {
        return setShowActions(false);
    });
    function handleLogout() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            logout()
                        ];
                    case 1:
                        _state.sent();
                        window.location.reload();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var cornerLogo = {
        image: logoVariant == "partnership" ? (0, (/*@__PURE__*/$parcel$interopDefault($b79b8e3f05c87951$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($7eb15b9996c76009$exports))),
        alt: logoVariant == "partnership" ? "In Partnership With Mojo" : "Powered By Mojo"
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8c4ce8c143193527$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$LogoContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$Logo, {
                    clickable: clickableLogo,
                    onClick: function() {
                        return clickableLogo && history.push("/");
                    },
                    src: theme.mainLogoURL,
                    alt: "logo"
                }, "logo-img")
            }),
            showPoweredBy && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$PoweredByMojo, {
                isLoggedIn: loggedIn,
                src: cornerLogo.image,
                alt: cornerLogo.alt
            }),
            showUser && loggedIn && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8c4ce8c143193527$var$User, {
                children: [
                    isLoading ? "" : data.Email,
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                        ref: menuRef,
                        className: "hamburgerContainer",
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$Hamburger, {
                                toggled: showActions,
                                onToggle: function(value) {
                                    return setShowActions(value);
                                }
                            }),
                            showActions && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$UserActions, {
                                logout: handleLogout
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $8c4ce8c143193527$var$HamburgerContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8c4ce8c143193527$var$_templateObject5(), $8c4ce8c143193527$var$HamburgerSize, $8c4ce8c143193527$var$HamburgerSize, $8c4ce8c143193527$var$HamburgerSize, $8c4ce8c143193527$var$HamburgerSize);
function $8c4ce8c143193527$var$Hamburger(param) {
    var toggled = param.toggled, onToggle = param.onToggle;
    var iconComponent = toggled ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f0318dc2ecd419e3$exports))),
        alt: "Close menu"
    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5d550af05e29e2a1$exports))),
        alt: "Open menu"
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$HamburgerContainer, {
        onClick: function() {
            return onToggle(!toggled);
        },
        children: iconComponent
    });
}
var $8c4ce8c143193527$var$UserActionsContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8c4ce8c143193527$var$_templateObject6(), function(props) {
    return props.theme.navColour;
});
function $8c4ce8c143193527$var$UserActions(param) {
    var logout = param.logout;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8c4ce8c143193527$var$UserActionsContainer, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
            className: "action",
            onClick: logout,
            children: "Logout"
        })
    });
}


// @create-index
var $e83a7d56fa11beee$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($e83a7d56fa11beee$exports, '__esModule', {
    value: true
});
function $e83a7d56fa11beee$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $e83a7d56fa11beee$var$styled__default = $e83a7d56fa11beee$var$_interopDefault($62d655c53090e8a3$exports);

var $2xTNA = parcelRequire("2xTNA");
var $bbed19cb57db80bc$export$c42d3009eb5af660;
var $bbed19cb57db80bc$export$1d1d1fc204d4f0cc;
var $bbed19cb57db80bc$export$a5d0f9b6cdbee927;
var $bbed19cb57db80bc$export$c90d7ca213038c72;
var $bbed19cb57db80bc$export$7e4530ad35d3bb8;
var $bbed19cb57db80bc$export$8f274c941f3300d0;
var $bbed19cb57db80bc$export$2a63e85cae65c7c7;
'use strict';
function $bbed19cb57db80bc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bbed19cb57db80bc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bbed19cb57db80bc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bbed19cb57db80bc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bbed19cb57db80bc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bbed19cb57db80bc$var$_extends() {
    $bbed19cb57db80bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bbed19cb57db80bc$var$_extends.apply(this, arguments);
}
function $bbed19cb57db80bc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bbed19cb57db80bc$var$_setPrototypeOf(subClass, superClass);
}
function $bbed19cb57db80bc$var$_getPrototypeOf(o) {
    $bbed19cb57db80bc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bbed19cb57db80bc$var$_getPrototypeOf(o);
}
function $bbed19cb57db80bc$var$_setPrototypeOf(o, p) {
    $bbed19cb57db80bc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bbed19cb57db80bc$var$_setPrototypeOf(o, p);
}
function $bbed19cb57db80bc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bbed19cb57db80bc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bbed19cb57db80bc$var$_possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, $2xTNA._)(call)) === "object" || typeof call === "function")) return call;
    return $bbed19cb57db80bc$var$_assertThisInitialized(self);
}
function $bbed19cb57db80bc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bbed19cb57db80bc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bbed19cb57db80bc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bbed19cb57db80bc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bbed19cb57db80bc$var$_possibleConstructorReturn(this, result);
    };
}
function $bbed19cb57db80bc$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function $bbed19cb57db80bc$var$_slicedToArray(arr, i) {
    return $bbed19cb57db80bc$var$_arrayWithHoles(arr) || $bbed19cb57db80bc$var$_iterableToArrayLimit(arr, i) || $bbed19cb57db80bc$var$_unsupportedIterableToArray(arr, i) || $bbed19cb57db80bc$var$_nonIterableRest();
}
function $bbed19cb57db80bc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bbed19cb57db80bc$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bbed19cb57db80bc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bbed19cb57db80bc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bbed19cb57db80bc$var$_arrayLikeToArray(o, minLen);
}
function $bbed19cb57db80bc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bbed19cb57db80bc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$bbed19cb57db80bc$export$c42d3009eb5af660 = $bbed19cb57db80bc$var$_classCallCheck;
$bbed19cb57db80bc$export$1d1d1fc204d4f0cc = $bbed19cb57db80bc$var$_createClass;
$bbed19cb57db80bc$export$a5d0f9b6cdbee927 = $bbed19cb57db80bc$var$_createSuper;
$bbed19cb57db80bc$export$c90d7ca213038c72 = $bbed19cb57db80bc$var$_extends;
$bbed19cb57db80bc$export$7e4530ad35d3bb8 = $bbed19cb57db80bc$var$_inherits;
$bbed19cb57db80bc$export$8f274c941f3300d0 = $bbed19cb57db80bc$var$_slicedToArray;
$bbed19cb57db80bc$export$2a63e85cae65c7c7 = $bbed19cb57db80bc$var$_taggedTemplateLiteral;



var $hAGkE = parcelRequire("hAGkE");
var $e83a7d56fa11beee$var$React__default = $e83a7d56fa11beee$var$_interopDefault($hAGkE);

var $2xTNA = parcelRequire("2xTNA");
var $837e86388abc9533$export$e0c95a451cd220b7;
var $837e86388abc9533$export$b5e3f462a46347c5;
var $837e86388abc9533$export$513805011eaa4892;
var $837e86388abc9533$export$a26b9784e8699f82;
'use strict';
function $837e86388abc9533$var$unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function $837e86388abc9533$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $837e86388abc9533$var$b = "function" === typeof Symbol && Symbol["for"], $837e86388abc9533$var$c = $837e86388abc9533$var$b ? Symbol["for"]("react.element") : 60103, $837e86388abc9533$var$d = $837e86388abc9533$var$b ? Symbol["for"]("react.portal") : 60106, $837e86388abc9533$var$e = $837e86388abc9533$var$b ? Symbol["for"]("react.fragment") : 60107, $837e86388abc9533$var$f = $837e86388abc9533$var$b ? Symbol["for"]("react.strict_mode") : 60108, $837e86388abc9533$var$g = $837e86388abc9533$var$b ? Symbol["for"]("react.profiler") : 60114, $837e86388abc9533$var$h = $837e86388abc9533$var$b ? Symbol["for"]("react.provider") : 60109, $837e86388abc9533$var$k = $837e86388abc9533$var$b ? Symbol["for"]("react.context") : 60110, $837e86388abc9533$var$l = $837e86388abc9533$var$b ? Symbol["for"]("react.async_mode") : 60111, $837e86388abc9533$var$m = $837e86388abc9533$var$b ? Symbol["for"]("react.concurrent_mode") : 60111, $837e86388abc9533$var$n = $837e86388abc9533$var$b ? Symbol["for"]("react.forward_ref") : 60112, $837e86388abc9533$var$p = $837e86388abc9533$var$b ? Symbol["for"]("react.suspense") : 60113, $837e86388abc9533$var$q = $837e86388abc9533$var$b ? Symbol["for"]("react.suspense_list") : 60120, $837e86388abc9533$var$r = $837e86388abc9533$var$b ? Symbol["for"]("react.memo") : 60115, $837e86388abc9533$var$t = $837e86388abc9533$var$b ? Symbol["for"]("react.lazy") : 60116, $837e86388abc9533$var$v = $837e86388abc9533$var$b ? Symbol["for"]("react.block") : 60121, $837e86388abc9533$var$w = $837e86388abc9533$var$b ? Symbol["for"]("react.fundamental") : 60117, $837e86388abc9533$var$x = $837e86388abc9533$var$b ? Symbol["for"]("react.responder") : 60118, $837e86388abc9533$var$y = $837e86388abc9533$var$b ? Symbol["for"]("react.scope") : 60119;
function $837e86388abc9533$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $837e86388abc9533$var$c:
                switch(a = a.type, a){
                    case $837e86388abc9533$var$l:
                    case $837e86388abc9533$var$m:
                    case $837e86388abc9533$var$e:
                    case $837e86388abc9533$var$g:
                    case $837e86388abc9533$var$f:
                    case $837e86388abc9533$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $837e86388abc9533$var$k:
                            case $837e86388abc9533$var$n:
                            case $837e86388abc9533$var$t:
                            case $837e86388abc9533$var$r:
                            case $837e86388abc9533$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $837e86388abc9533$var$d:
                return u;
        }
    }
}
function $837e86388abc9533$var$A(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$m;
}
var $837e86388abc9533$var$AsyncMode = $837e86388abc9533$var$l;
var $837e86388abc9533$var$ConcurrentMode = $837e86388abc9533$var$m;
var $837e86388abc9533$var$ContextConsumer = $837e86388abc9533$var$k;
var $837e86388abc9533$var$ContextProvider = $837e86388abc9533$var$h;
var $837e86388abc9533$var$Element = $837e86388abc9533$var$c;
var $837e86388abc9533$var$ForwardRef = $837e86388abc9533$var$n;
var $837e86388abc9533$var$Fragment = $837e86388abc9533$var$e;
var $837e86388abc9533$var$Lazy = $837e86388abc9533$var$t;
var $837e86388abc9533$var$Memo = $837e86388abc9533$var$r;
var $837e86388abc9533$var$Portal = $837e86388abc9533$var$d;
var $837e86388abc9533$var$Profiler = $837e86388abc9533$var$g;
var $837e86388abc9533$var$StrictMode = $837e86388abc9533$var$f;
var $837e86388abc9533$var$Suspense = $837e86388abc9533$var$p;
var $837e86388abc9533$var$isAsyncMode = function isAsyncMode(a) {
    return $837e86388abc9533$var$A(a) || $837e86388abc9533$var$z(a) === $837e86388abc9533$var$l;
};
var $837e86388abc9533$var$isConcurrentMode = $837e86388abc9533$var$A;
var $837e86388abc9533$var$isContextConsumer = function isContextConsumer(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$k;
};
var $837e86388abc9533$var$isContextProvider = function isContextProvider(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$h;
};
var $837e86388abc9533$var$isElement = function isElement(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && a.$$typeof === $837e86388abc9533$var$c;
};
var $837e86388abc9533$var$isForwardRef = function isForwardRef(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$n;
};
var $837e86388abc9533$var$isFragment = function isFragment(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$e;
};
var $837e86388abc9533$var$isLazy = function isLazy(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$t;
};
var $837e86388abc9533$var$isMemo = function isMemo(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$r;
};
var $837e86388abc9533$var$isPortal = function isPortal(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$d;
};
var $837e86388abc9533$var$isProfiler = function isProfiler(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$g;
};
var $837e86388abc9533$var$isStrictMode = function isStrictMode(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$f;
};
var $837e86388abc9533$var$isSuspense = function isSuspense(a) {
    return $837e86388abc9533$var$z(a) === $837e86388abc9533$var$p;
};
var $837e86388abc9533$var$isValidElementType = function isValidElementType(a) {
    return "string" === typeof a || "function" === typeof a || a === $837e86388abc9533$var$e || a === $837e86388abc9533$var$m || a === $837e86388abc9533$var$g || a === $837e86388abc9533$var$f || a === $837e86388abc9533$var$p || a === $837e86388abc9533$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && (a.$$typeof === $837e86388abc9533$var$t || a.$$typeof === $837e86388abc9533$var$r || a.$$typeof === $837e86388abc9533$var$h || a.$$typeof === $837e86388abc9533$var$k || a.$$typeof === $837e86388abc9533$var$n || a.$$typeof === $837e86388abc9533$var$w || a.$$typeof === $837e86388abc9533$var$x || a.$$typeof === $837e86388abc9533$var$y || a.$$typeof === $837e86388abc9533$var$v);
};
var $837e86388abc9533$var$typeOf = $837e86388abc9533$var$z;
var $837e86388abc9533$var$reactIs_production_min = {
    AsyncMode: $837e86388abc9533$var$AsyncMode,
    ConcurrentMode: $837e86388abc9533$var$ConcurrentMode,
    ContextConsumer: $837e86388abc9533$var$ContextConsumer,
    ContextProvider: $837e86388abc9533$var$ContextProvider,
    Element: $837e86388abc9533$var$Element,
    ForwardRef: $837e86388abc9533$var$ForwardRef,
    Fragment: $837e86388abc9533$var$Fragment,
    Lazy: $837e86388abc9533$var$Lazy,
    Memo: $837e86388abc9533$var$Memo,
    Portal: $837e86388abc9533$var$Portal,
    Profiler: $837e86388abc9533$var$Profiler,
    StrictMode: $837e86388abc9533$var$StrictMode,
    Suspense: $837e86388abc9533$var$Suspense,
    isAsyncMode: $837e86388abc9533$var$isAsyncMode,
    isConcurrentMode: $837e86388abc9533$var$isConcurrentMode,
    isContextConsumer: $837e86388abc9533$var$isContextConsumer,
    isContextProvider: $837e86388abc9533$var$isContextProvider,
    isElement: $837e86388abc9533$var$isElement,
    isForwardRef: $837e86388abc9533$var$isForwardRef,
    isFragment: $837e86388abc9533$var$isFragment,
    isLazy: $837e86388abc9533$var$isLazy,
    isMemo: $837e86388abc9533$var$isMemo,
    isPortal: $837e86388abc9533$var$isPortal,
    isProfiler: $837e86388abc9533$var$isProfiler,
    isStrictMode: $837e86388abc9533$var$isStrictMode,
    isSuspense: $837e86388abc9533$var$isSuspense,
    isValidElementType: $837e86388abc9533$var$isValidElementType,
    typeOf: $837e86388abc9533$var$typeOf
};
var $837e86388abc9533$var$reactIs_development = $837e86388abc9533$var$createCommonjsModule(function(module, exports1) {});
var $837e86388abc9533$var$reactIs_development_1 = $837e86388abc9533$var$reactIs_development.AsyncMode;
var $837e86388abc9533$var$reactIs_development_2 = $837e86388abc9533$var$reactIs_development.ConcurrentMode;
var $837e86388abc9533$var$reactIs_development_3 = $837e86388abc9533$var$reactIs_development.ContextConsumer;
var $837e86388abc9533$var$reactIs_development_4 = $837e86388abc9533$var$reactIs_development.ContextProvider;
var $837e86388abc9533$var$reactIs_development_5 = $837e86388abc9533$var$reactIs_development.Element;
var $837e86388abc9533$var$reactIs_development_6 = $837e86388abc9533$var$reactIs_development.ForwardRef;
var $837e86388abc9533$var$reactIs_development_7 = $837e86388abc9533$var$reactIs_development.Fragment;
var $837e86388abc9533$var$reactIs_development_8 = $837e86388abc9533$var$reactIs_development.Lazy;
var $837e86388abc9533$var$reactIs_development_9 = $837e86388abc9533$var$reactIs_development.Memo;
var $837e86388abc9533$var$reactIs_development_10 = $837e86388abc9533$var$reactIs_development.Portal;
var $837e86388abc9533$var$reactIs_development_11 = $837e86388abc9533$var$reactIs_development.Profiler;
var $837e86388abc9533$var$reactIs_development_12 = $837e86388abc9533$var$reactIs_development.StrictMode;
var $837e86388abc9533$var$reactIs_development_13 = $837e86388abc9533$var$reactIs_development.Suspense;
var $837e86388abc9533$var$reactIs_development_14 = $837e86388abc9533$var$reactIs_development.isAsyncMode;
var $837e86388abc9533$var$reactIs_development_15 = $837e86388abc9533$var$reactIs_development.isConcurrentMode;
var $837e86388abc9533$var$reactIs_development_16 = $837e86388abc9533$var$reactIs_development.isContextConsumer;
var $837e86388abc9533$var$reactIs_development_17 = $837e86388abc9533$var$reactIs_development.isContextProvider;
var $837e86388abc9533$var$reactIs_development_18 = $837e86388abc9533$var$reactIs_development.isElement;
var $837e86388abc9533$var$reactIs_development_19 = $837e86388abc9533$var$reactIs_development.isForwardRef;
var $837e86388abc9533$var$reactIs_development_20 = $837e86388abc9533$var$reactIs_development.isFragment;
var $837e86388abc9533$var$reactIs_development_21 = $837e86388abc9533$var$reactIs_development.isLazy;
var $837e86388abc9533$var$reactIs_development_22 = $837e86388abc9533$var$reactIs_development.isMemo;
var $837e86388abc9533$var$reactIs_development_23 = $837e86388abc9533$var$reactIs_development.isPortal;
var $837e86388abc9533$var$reactIs_development_24 = $837e86388abc9533$var$reactIs_development.isProfiler;
var $837e86388abc9533$var$reactIs_development_25 = $837e86388abc9533$var$reactIs_development.isStrictMode;
var $837e86388abc9533$var$reactIs_development_26 = $837e86388abc9533$var$reactIs_development.isSuspense;
var $837e86388abc9533$var$reactIs_development_27 = $837e86388abc9533$var$reactIs_development.isValidElementType;
var $837e86388abc9533$var$reactIs_development_28 = $837e86388abc9533$var$reactIs_development.typeOf;
var $837e86388abc9533$var$reactIs = $837e86388abc9533$var$createCommonjsModule(function(module) {
    module.exports = $837e86388abc9533$var$reactIs_production_min;
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var $837e86388abc9533$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $837e86388abc9533$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $837e86388abc9533$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $837e86388abc9533$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $837e86388abc9533$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var $837e86388abc9533$var$objectAssign = $837e86388abc9533$var$shouldUseNative() ? Object.assign : function objectAssign(target, source) {
    var from;
    var to = $837e86388abc9533$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($837e86388abc9533$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($837e86388abc9533$var$getOwnPropertySymbols) {
            symbols = $837e86388abc9533$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($837e86388abc9533$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $837e86388abc9533$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var $837e86388abc9533$var$ReactPropTypesSecret_1 = $837e86388abc9533$var$ReactPropTypesSecret;
var $837e86388abc9533$var$printWarning = function printWarning() {};
var $837e86388abc9533$var$ReactPropTypesSecret$1, $837e86388abc9533$var$loggedTypeFailures, $837e86388abc9533$var$has;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $837e86388abc9533$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, err, ex, stack;
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $837e86388abc9533$var$checkPropTypes.resetWarningCache = function() {};
var $837e86388abc9533$var$checkPropTypes_1 = $837e86388abc9533$var$checkPropTypes;
var $837e86388abc9533$var$has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var $837e86388abc9533$var$printWarning$1 = function printWarning$1() {};
function $837e86388abc9533$var$emptyFunctionThatReturnsNull() {
    return null;
}
var $837e86388abc9533$var$factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message) {
        this.message = message;
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $837e86388abc9533$var$ReactPropTypesSecret_1) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($837e86388abc9533$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $837e86388abc9533$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$837e86388abc9533$var$reactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return $837e86388abc9533$var$emptyFunctionThatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($837e86388abc9533$var$has$1(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $837e86388abc9533$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return $837e86388abc9533$var$emptyFunctionThatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $837e86388abc9533$var$printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $837e86388abc9533$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (checker(props, propName, componentName, location, propFullName, $837e86388abc9533$var$ReactPropTypesSecret_1) == null) return null;
            }
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (!checker) continue;
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $837e86388abc9533$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from
            // props.
            var allKeys = $837e86388abc9533$var$objectAssign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $837e86388abc9533$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue === "undefined" ? "undefined" : (0, $2xTNA._)(propValue)){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue === "undefined" ? "undefined" : (0, $2xTNA._)(propValue);
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $837e86388abc9533$var$checkPropTypes_1;
    ReactPropTypes.resetWarningCache = $837e86388abc9533$var$checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
function $837e86388abc9533$var$emptyFunction() {}
function $837e86388abc9533$var$emptyFunctionWithReset() {}
$837e86388abc9533$var$emptyFunctionWithReset.resetWarningCache = $837e86388abc9533$var$emptyFunction;
var $837e86388abc9533$var$factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $837e86388abc9533$var$ReactPropTypesSecret_1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $837e86388abc9533$var$emptyFunctionWithReset,
        resetWarningCache: $837e86388abc9533$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $837e86388abc9533$var$propTypes = $837e86388abc9533$var$createCommonjsModule(function(module) {
    var ReactIs, throwOnDirectAccess;
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = $837e86388abc9533$var$factoryWithThrowingShims();
});
$837e86388abc9533$export$e0c95a451cd220b7 = $837e86388abc9533$var$propTypes;
$837e86388abc9533$export$b5e3f462a46347c5 = $837e86388abc9533$var$createCommonjsModule;
$837e86388abc9533$export$513805011eaa4892 = $837e86388abc9533$var$propTypes;
$837e86388abc9533$export$a26b9784e8699f82 = $837e86388abc9533$var$unwrapExports;


function $e83a7d56fa11beee$var$shallowEqualArrays(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
var $e83a7d56fa11beee$var$arrays = $e83a7d56fa11beee$var$shallowEqualArrays;
var $e83a7d56fa11beee$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $e83a7d56fa11beee$var$dist = function dist(_ref) {
    var data = _ref.data;
    var multiSection = _ref.multiSection;
    function nextNonEmptySectionIndex(sectionIndex) {
        if (sectionIndex === null) sectionIndex = 0;
        else sectionIndex++;
        while(sectionIndex < data.length && data[sectionIndex] === 0)sectionIndex++;
        return sectionIndex === data.length ? null : sectionIndex;
    }
    function prevNonEmptySectionIndex(sectionIndex) {
        if (sectionIndex === null) sectionIndex = data.length - 1;
        else sectionIndex--;
        while(sectionIndex >= 0 && data[sectionIndex] === 0)sectionIndex--;
        return sectionIndex === -1 ? null : sectionIndex;
    }
    function next(position) {
        var _position = $e83a7d56fa11beee$var$_slicedToArray(position, 2);
        var sectionIndex = _position[0];
        var itemIndex = _position[1];
        if (multiSection) {
            if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
                sectionIndex = nextNonEmptySectionIndex(sectionIndex);
                if (sectionIndex === null) return [
                    null,
                    null
                ];
                return [
                    sectionIndex,
                    0
                ];
            }
            return [
                sectionIndex,
                itemIndex + 1
            ];
        }
        if (data === 0 || itemIndex === data - 1) return [
            null,
            null
        ];
        if (itemIndex === null) return [
            null,
            0
        ];
        return [
            null,
            itemIndex + 1
        ];
    }
    function prev(position) {
        var _position2 = $e83a7d56fa11beee$var$_slicedToArray(position, 2);
        var sectionIndex = _position2[0];
        var itemIndex = _position2[1];
        if (multiSection) {
            if (itemIndex === null || itemIndex === 0) {
                sectionIndex = prevNonEmptySectionIndex(sectionIndex);
                if (sectionIndex === null) return [
                    null,
                    null
                ];
                return [
                    sectionIndex,
                    data[sectionIndex] - 1
                ];
            }
            return [
                sectionIndex,
                itemIndex - 1
            ];
        }
        if (data === 0 || itemIndex === 0) return [
            null,
            null
        ];
        if (itemIndex === null) return [
            null,
            data - 1
        ];
        return [
            null,
            itemIndex - 1
        ];
    }
    function isLast(position) {
        return next(position)[1] === null;
    }
    return {
        next: next,
        prev: prev,
        isLast: isLast
    };
};
var $e83a7d56fa11beee$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $e83a7d56fa11beee$var$ToObject(val) {
    if (val == null) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $e83a7d56fa11beee$var$ownEnumerableKeys(obj) {
    var keys = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) keys = keys.concat(Object.getOwnPropertySymbols(obj));
    return keys.filter(function(key) {
        return $e83a7d56fa11beee$var$propIsEnumerable.call(obj, key);
    });
}
var $e83a7d56fa11beee$var$objectAssign = Object.assign || function(target, source) {
    var from;
    var keys;
    var to = $e83a7d56fa11beee$var$ToObject(target);
    for(var s = 1; s < arguments.length; s++){
        from = arguments[s];
        keys = $e83a7d56fa11beee$var$ownEnumerableKeys(Object(from));
        for(var i = 0; i < keys.length; i++)to[keys[i]] = from[keys[i]];
    }
    return to;
};
var $e83a7d56fa11beee$var$dist$1 = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
    var _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i['return']) _i['return']();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError('Invalid attempt to destructure non-iterable instance');
        };
    }();
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            'default': obj
        };
    }
    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    var _objectAssign2 = _interopRequireDefault($e83a7d56fa11beee$var$objectAssign);
    var truthy = function truthy(x) {
        return x;
    };
    exports1['default'] = function(input) {
        var _ref = Array.isArray(input) && input.length === 2 ? input : [
            input,
            null
        ];
        var _ref2 = _slicedToArray(_ref, 2);
        var theme = _ref2[0];
        var classNameDecorator = _ref2[1];
        return function(key) {
            for(var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)names[_key - 1] = arguments[_key];
            var styles = names.map(function(name) {
                return theme[name];
            }).filter(truthy);
            return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? {
                key: key,
                className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ')
            } : {
                key: key,
                style: _objectAssign2['default'].apply(undefined, [
                    {}
                ].concat(_toConsumableArray(styles)))
            };
        };
    };
    module.exports = exports1['default'];
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$dist$1);
var $e83a7d56fa11beee$var$compareObjects_1 = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = compareObjects;
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function compareObjects(objA, objB) {
        var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        if (objA === objB) return false;
        var aKeys = Object.keys(objA);
        var bKeys = Object.keys(objB);
        if (aKeys.length !== bKeys.length) return true;
        var keysMap = {};
        var i, len;
        for(i = 0, len = keys.length; i < len; i++)keysMap[keys[i]] = true;
        for(i = 0, len = aKeys.length; i < len; i++){
            var key = aKeys[i];
            var aValue = objA[key];
            var bValue = objB[key];
            if (aValue === bValue) continue;
            if (!keysMap[key] || aValue === null || bValue === null || _typeof(aValue) !== 'object' || _typeof(bValue) !== 'object') return true;
            var aValueKeys = Object.keys(aValue);
            var bValueKeys = Object.keys(bValue);
            if (aValueKeys.length !== bValueKeys.length) return true;
            for(var n = 0, length = aValueKeys.length; n < length; n++){
                var aValueKey = aValueKeys[n];
                if (aValue[aValueKey] !== bValue[aValueKey]) return true;
            }
        }
        return false;
    }
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$compareObjects_1);
var $e83a7d56fa11beee$var$SectionTitle_1 = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _react = _interopRequireWildcard($e83a7d56fa11beee$var$React__default);
    var _propTypes = _interopRequireDefault($837e86388abc9533$export$513805011eaa4892);
    var _compareObjects = _interopRequireDefault($e83a7d56fa11beee$var$compareObjects_1);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _createSuper(Derived) {
        return function() {
            var Super = _getPrototypeOf(Derived), result;
            if (_isNativeReflectConstruct()) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var SectionTitle = /*#__PURE__*/ function(_Component) {
        _inherits(SectionTitle, _Component);
        var _super = _createSuper(SectionTitle);
        function SectionTitle() {
            _classCallCheck(this, SectionTitle);
            return _super.apply(this, arguments);
        }
        _createClass(SectionTitle, [
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps) {
                    return (0, _compareObjects["default"])(nextProps, this.props);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, section = _this$props.section, renderSectionTitle = _this$props.renderSectionTitle, theme = _this$props.theme, sectionKeyPrefix = _this$props.sectionKeyPrefix;
                    var sectionTitle = renderSectionTitle(section);
                    if (!sectionTitle) return null;
                    return /*#__PURE__*/ _react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "title"), 'sectionTitle'), sectionTitle);
                }
            }
        ]);
        return SectionTitle;
    }(_react.Component);
    exports1["default"] = SectionTitle;
    _defineProperty(SectionTitle, "propTypes", {
        section: _propTypes["default"].any.isRequired,
        renderSectionTitle: _propTypes["default"].func.isRequired,
        theme: _propTypes["default"].func.isRequired,
        sectionKeyPrefix: _propTypes["default"].string.isRequired
    });
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$SectionTitle_1);
var $e83a7d56fa11beee$var$Item_1 = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _react = _interopRequireWildcard($e83a7d56fa11beee$var$React__default);
    var _propTypes = _interopRequireDefault($837e86388abc9533$export$513805011eaa4892);
    var _compareObjects = _interopRequireDefault($e83a7d56fa11beee$var$compareObjects_1);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _createSuper(Derived) {
        return function() {
            var Super = _getPrototypeOf(Derived), result;
            if (_isNativeReflectConstruct()) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var Item = /*#__PURE__*/ function(_Component) {
        _inherits(Item, _Component);
        var _super = _createSuper(Item);
        function Item() {
            var _this;
            _classCallCheck(this, Item);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _defineProperty(_assertThisInitialized(_this), "storeItemReference", function(item) {
                if (item !== null) _this.item = item;
            });
            _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function(event) {
                var _this$props = _this.props, sectionIndex = _this$props.sectionIndex, itemIndex = _this$props.itemIndex;
                _this.props.onMouseEnter(event, {
                    sectionIndex: sectionIndex,
                    itemIndex: itemIndex
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function(event) {
                var _this$props2 = _this.props, sectionIndex = _this$props2.sectionIndex, itemIndex = _this$props2.itemIndex;
                _this.props.onMouseLeave(event, {
                    sectionIndex: sectionIndex,
                    itemIndex: itemIndex
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onMouseDown", function(event) {
                var _this$props3 = _this.props, sectionIndex = _this$props3.sectionIndex, itemIndex = _this$props3.itemIndex;
                _this.props.onMouseDown(event, {
                    sectionIndex: sectionIndex,
                    itemIndex: itemIndex
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onClick", function(event) {
                var _this$props4 = _this.props, sectionIndex = _this$props4.sectionIndex, itemIndex = _this$props4.itemIndex;
                _this.props.onClick(event, {
                    sectionIndex: sectionIndex,
                    itemIndex: itemIndex
                });
            });
            return _this;
        }
        _createClass(Item, [
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps) {
                    return (0, _compareObjects["default"])(nextProps, this.props, [
                        'renderItemData'
                    ]);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props5 = this.props, isHighlighted = _this$props5.isHighlighted, item = _this$props5.item, renderItem = _this$props5.renderItem, renderItemData = _this$props5.renderItemData, restProps = _objectWithoutProperties(_this$props5, [
                        "isHighlighted",
                        "item",
                        "renderItem",
                        "renderItemData"
                    ]);
                    delete restProps.sectionIndex;
                    delete restProps.itemIndex;
                    if (typeof restProps.onMouseEnter === 'function') restProps.onMouseEnter = this.onMouseEnter;
                    if (typeof restProps.onMouseLeave === 'function') restProps.onMouseLeave = this.onMouseLeave;
                    if (typeof restProps.onMouseDown === 'function') restProps.onMouseDown = this.onMouseDown;
                    if (typeof restProps.onClick === 'function') restProps.onClick = this.onClick;
                    return /*#__PURE__*/ _react["default"].createElement("li", _extends({
                        role: "option"
                    }, restProps, {
                        ref: this.storeItemReference
                    }), renderItem(item, _objectSpread({
                        isHighlighted: isHighlighted
                    }, renderItemData)));
                }
            }
        ]);
        return Item;
    }(_react.Component);
    exports1["default"] = Item;
    _defineProperty(Item, "propTypes", {
        sectionIndex: _propTypes["default"].number,
        isHighlighted: _propTypes["default"].bool.isRequired,
        itemIndex: _propTypes["default"].number.isRequired,
        item: _propTypes["default"].any.isRequired,
        renderItem: _propTypes["default"].func.isRequired,
        renderItemData: _propTypes["default"].object.isRequired,
        onMouseEnter: _propTypes["default"].func,
        onMouseLeave: _propTypes["default"].func,
        onMouseDown: _propTypes["default"].func,
        onClick: _propTypes["default"].func
    });
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$Item_1);
var $e83a7d56fa11beee$var$ItemList = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _react = _interopRequireWildcard($e83a7d56fa11beee$var$React__default);
    var _propTypes = _interopRequireDefault($837e86388abc9533$export$513805011eaa4892);
    var _Item = _interopRequireDefault($e83a7d56fa11beee$var$Item_1);
    var _compareObjects = _interopRequireDefault($e83a7d56fa11beee$var$compareObjects_1);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _createSuper(Derived) {
        return function() {
            var Super = _getPrototypeOf(Derived), result;
            if (_isNativeReflectConstruct()) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var ItemsList = /*#__PURE__*/ function(_Component) {
        _inherits(ItemsList, _Component);
        var _super = _createSuper(ItemsList);
        function ItemsList() {
            var _this;
            _classCallCheck(this, ItemsList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _defineProperty(_assertThisInitialized(_this), "storeHighlightedItemReference", function(highlightedItem) {
                _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
            });
            return _this;
        }
        _createClass(ItemsList, [
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps) {
                    return (0, _compareObjects["default"])(nextProps, this.props, [
                        'itemProps'
                    ]);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props = this.props, items = _this$props.items, itemProps = _this$props.itemProps, renderItem = _this$props.renderItem, renderItemData = _this$props.renderItemData, sectionIndex = _this$props.sectionIndex, highlightedItemIndex = _this$props.highlightedItemIndex, getItemId = _this$props.getItemId, theme = _this$props.theme, keyPrefix = _this$props.keyPrefix;
                    var sectionPrefix = sectionIndex === null ? keyPrefix : "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
                    var isItemPropsFunction = typeof itemProps === 'function';
                    return /*#__PURE__*/ _react["default"].createElement("ul", _extends({
                        role: "listbox"
                    }, theme("".concat(sectionPrefix, "items-list"), 'itemsList')), items.map(function(item, itemIndex) {
                        var isFirst = itemIndex === 0;
                        var isHighlighted = itemIndex === highlightedItemIndex;
                        var itemKey = "".concat(sectionPrefix, "item-").concat(itemIndex);
                        var itemPropsObj = isItemPropsFunction ? itemProps({
                            sectionIndex: sectionIndex,
                            itemIndex: itemIndex
                        }) : itemProps;
                        var allItemProps = _objectSpread({
                            id: getItemId(sectionIndex, itemIndex),
                            'aria-selected': isHighlighted
                        }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), {}, itemPropsObj);
                        if (isHighlighted) allItemProps.ref = _this2.storeHighlightedItemReference;
                         // `key` is provided by theme()
                        /* eslint-disable react/jsx-key */ return /*#__PURE__*/ _react["default"].createElement(_Item["default"], _extends({}, allItemProps, {
                            sectionIndex: sectionIndex,
                            isHighlighted: isHighlighted,
                            itemIndex: itemIndex,
                            item: item,
                            renderItem: renderItem,
                            renderItemData: renderItemData
                        }));
                    /* eslint-enable react/jsx-key */ }));
                }
            }
        ]);
        return ItemsList;
    }(_react.Component);
    exports1["default"] = ItemsList;
    _defineProperty(ItemsList, "propTypes", {
        items: _propTypes["default"].array.isRequired,
        itemProps: _propTypes["default"].oneOfType([
            _propTypes["default"].object,
            _propTypes["default"].func
        ]),
        renderItem: _propTypes["default"].func.isRequired,
        renderItemData: _propTypes["default"].object.isRequired,
        sectionIndex: _propTypes["default"].number,
        highlightedItemIndex: _propTypes["default"].number,
        onHighlightedItemChange: _propTypes["default"].func.isRequired,
        getItemId: _propTypes["default"].func.isRequired,
        theme: _propTypes["default"].func.isRequired,
        keyPrefix: _propTypes["default"].string.isRequired
    });
    _defineProperty(ItemsList, "defaultProps", {
        sectionIndex: null
    });
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$ItemList);
var $e83a7d56fa11beee$var$Autowhatever_1 = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _react = _interopRequireWildcard($e83a7d56fa11beee$var$React__default);
    var _propTypes = _interopRequireDefault($837e86388abc9533$export$513805011eaa4892);
    var _sectionIterator = _interopRequireDefault($e83a7d56fa11beee$var$dist);
    var _reactThemeable = _interopRequireDefault($e83a7d56fa11beee$var$dist$1);
    var _SectionTitle = _interopRequireDefault($e83a7d56fa11beee$var$SectionTitle_1);
    var _ItemList = _interopRequireDefault($e83a7d56fa11beee$var$ItemList);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(n);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _iterableToArrayLimit(arr, i) {
        if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _createSuper(Derived) {
        return function() {
            var Super = _getPrototypeOf(Derived), result;
            if (_isNativeReflectConstruct()) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var emptyObject = {};
    var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
        return /*#__PURE__*/ _react["default"].createElement("input", props);
    };
    var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
        var containerProps = _ref.containerProps, children = _ref.children;
        return /*#__PURE__*/ _react["default"].createElement("div", containerProps, children);
    };
    var defaultTheme = {
        container: 'react-autowhatever__container',
        containerOpen: 'react-autowhatever__container--open',
        input: 'react-autowhatever__input',
        inputOpen: 'react-autowhatever__input--open',
        inputFocused: 'react-autowhatever__input--focused',
        itemsContainer: 'react-autowhatever__items-container',
        itemsContainerOpen: 'react-autowhatever__items-container--open',
        itemsList: 'react-autowhatever__items-list',
        item: 'react-autowhatever__item',
        itemFirst: 'react-autowhatever__item--first',
        itemHighlighted: 'react-autowhatever__item--highlighted',
        sectionContainer: 'react-autowhatever__section-container',
        sectionContainerFirst: 'react-autowhatever__section-container--first',
        sectionTitle: 'react-autowhatever__section-title'
    };
    var Autowhatever = /*#__PURE__*/ function(_Component) {
        _inherits(Autowhatever, _Component);
        var _super = _createSuper(Autowhatever);
        function Autowhatever(props) {
            var _this;
            _classCallCheck(this, Autowhatever);
            _this = _super.call(this, props);
            _defineProperty(_assertThisInitialized(_this), "storeInputReference", function(input) {
                if (input !== null) _this.input = input;
                var userRef = _this.props.inputProps.ref;
                if (userRef) {
                    if (typeof userRef === 'function') userRef(input);
                    else if (_typeof(userRef) === 'object' && Object.prototype.hasOwnProperty.call(userRef, 'current')) userRef.current = input;
                }
            });
            _defineProperty(_assertThisInitialized(_this), "storeItemsContainerReference", function(itemsContainer) {
                if (itemsContainer !== null) _this.itemsContainer = itemsContainer;
            });
            _defineProperty(_assertThisInitialized(_this), "onHighlightedItemChange", function(highlightedItem) {
                _this.highlightedItem = highlightedItem;
            });
            _defineProperty(_assertThisInitialized(_this), "getItemId", function(sectionIndex, itemIndex) {
                if (itemIndex === null) return null;
                var id = _this.props.id;
                var section = sectionIndex === null ? '' : "section-".concat(sectionIndex);
                return "react-autowhatever-".concat(id, "-").concat(section, "-item-").concat(itemIndex);
            });
            _defineProperty(_assertThisInitialized(_this), "onFocus", function(event) {
                var inputProps = _this.props.inputProps;
                _this.setState({
                    isInputFocused: true
                });
                inputProps.onFocus && inputProps.onFocus(event);
            });
            _defineProperty(_assertThisInitialized(_this), "onBlur", function(event) {
                var inputProps = _this.props.inputProps;
                _this.setState({
                    isInputFocused: false
                });
                inputProps.onBlur && inputProps.onBlur(event);
            });
            _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(event) {
                var _this$props = _this.props, inputProps = _this$props.inputProps, highlightedSectionIndex = _this$props.highlightedSectionIndex, highlightedItemIndex = _this$props.highlightedItemIndex;
                switch(event.key){
                    case 'ArrowDown':
                    case 'ArrowUp':
                        var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';
                        var _this$sectionIterator = _this.sectionIterator[nextPrev]([
                            highlightedSectionIndex,
                            highlightedItemIndex
                        ]), _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2), newHighlightedSectionIndex = _this$sectionIterator2[0], newHighlightedItemIndex = _this$sectionIterator2[1];
                        inputProps.onKeyDown(event, {
                            newHighlightedSectionIndex: newHighlightedSectionIndex,
                            newHighlightedItemIndex: newHighlightedItemIndex
                        });
                        break;
                    default:
                        inputProps.onKeyDown(event, {
                            highlightedSectionIndex: highlightedSectionIndex,
                            highlightedItemIndex: highlightedItemIndex
                        });
                }
            });
            _this.highlightedItem = null;
            _this.state = {
                isInputFocused: false
            };
            _this.setSectionsItems(props);
            _this.setSectionIterator(props);
            _this.setTheme(props);
            return _this;
        }
        _createClass(Autowhatever, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.ensureHighlightedItemIsVisible();
                } // eslint-disable-next-line camelcase, react/sort-comp
            },
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    if (nextProps.items !== this.props.items) this.setSectionsItems(nextProps);
                    if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) this.setSectionIterator(nextProps);
                    if (nextProps.theme !== this.props.theme) this.setTheme(nextProps);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    this.ensureHighlightedItemIsVisible();
                }
            },
            {
                key: "setSectionsItems",
                value: function setSectionsItems(props) {
                    if (props.multiSection) {
                        this.sectionsItems = props.items.map(function(section) {
                            return props.getSectionItems(section);
                        });
                        this.sectionsLengths = this.sectionsItems.map(function(items) {
                            return items.length;
                        });
                        this.allSectionsAreEmpty = this.sectionsLengths.every(function(itemsCount) {
                            return itemsCount === 0;
                        });
                    }
                }
            },
            {
                key: "setSectionIterator",
                value: function setSectionIterator(props) {
                    this.sectionIterator = (0, _sectionIterator["default"])({
                        multiSection: props.multiSection,
                        data: props.multiSection ? this.sectionsLengths : props.items.length
                    });
                }
            },
            {
                key: "setTheme",
                value: function setTheme(props) {
                    this.theme = (0, _reactThemeable["default"])(props.theme);
                }
            },
            {
                key: "renderSections",
                value: function renderSections() {
                    var _this2 = this;
                    if (this.allSectionsAreEmpty) return null;
                    var theme = this.theme;
                    var _this$props2 = this.props, id = _this$props2.id, items = _this$props2.items, renderItem = _this$props2.renderItem, renderItemData = _this$props2.renderItemData, renderSectionTitle = _this$props2.renderSectionTitle, highlightedSectionIndex = _this$props2.highlightedSectionIndex, highlightedItemIndex = _this$props2.highlightedItemIndex, itemProps = _this$props2.itemProps;
                    return items.map(function(section, sectionIndex) {
                        var keyPrefix = "react-autowhatever-".concat(id, "-");
                        var sectionKeyPrefix = "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
                        var isFirstSection = sectionIndex === 0; // `key` is provided by theme()
                        /* eslint-disable react/jsx-key */ return /*#__PURE__*/ _react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "container"), 'sectionContainer', isFirstSection && 'sectionContainerFirst'), /*#__PURE__*/ _react["default"].createElement(_SectionTitle["default"], {
                            section: section,
                            renderSectionTitle: renderSectionTitle,
                            theme: theme,
                            sectionKeyPrefix: sectionKeyPrefix
                        }), /*#__PURE__*/ _react["default"].createElement(_ItemList["default"], {
                            items: _this2.sectionsItems[sectionIndex],
                            itemProps: itemProps,
                            renderItem: renderItem,
                            renderItemData: renderItemData,
                            sectionIndex: sectionIndex,
                            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
                            onHighlightedItemChange: _this2.onHighlightedItemChange,
                            getItemId: _this2.getItemId,
                            theme: theme,
                            keyPrefix: keyPrefix,
                            ref: _this2.storeItemsListReference
                        }));
                    /* eslint-enable react/jsx-key */ });
                }
            },
            {
                key: "renderItems",
                value: function renderItems() {
                    var items = this.props.items;
                    if (items.length === 0) return null;
                    var theme = this.theme;
                    var _this$props3 = this.props, id = _this$props3.id, renderItem = _this$props3.renderItem, renderItemData = _this$props3.renderItemData, highlightedSectionIndex = _this$props3.highlightedSectionIndex, highlightedItemIndex = _this$props3.highlightedItemIndex, itemProps = _this$props3.itemProps;
                    return /*#__PURE__*/ _react["default"].createElement(_ItemList["default"], {
                        items: items,
                        itemProps: itemProps,
                        renderItem: renderItem,
                        renderItemData: renderItemData,
                        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
                        onHighlightedItemChange: this.onHighlightedItemChange,
                        getItemId: this.getItemId,
                        theme: theme,
                        keyPrefix: "react-autowhatever-".concat(id, "-")
                    });
                }
            },
            {
                key: "ensureHighlightedItemIsVisible",
                value: function ensureHighlightedItemIsVisible() {
                    var highlightedItem = this.highlightedItem;
                    if (!highlightedItem) return;
                    var itemsContainer = this.itemsContainer;
                    var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
                    var scrollTop = itemsContainer.scrollTop; // Top of the visible area
                    if (itemOffsetRelativeToContainer < scrollTop) // Item is off the top of the visible area
                    scrollTop = itemOffsetRelativeToContainer;
                    else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) // Item is off the bottom of the visible area
                    scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
                    if (scrollTop !== itemsContainer.scrollTop) itemsContainer.scrollTop = scrollTop;
                }
            },
            {
                key: "render",
                value: function render() {
                    var theme = this.theme;
                    var _this$props4 = this.props, id = _this$props4.id, multiSection = _this$props4.multiSection, renderInputComponent = _this$props4.renderInputComponent, renderItemsContainer = _this$props4.renderItemsContainer, highlightedSectionIndex = _this$props4.highlightedSectionIndex, highlightedItemIndex = _this$props4.highlightedItemIndex;
                    var isInputFocused = this.state.isInputFocused;
                    var renderedItems = multiSection ? this.renderSections() : this.renderItems();
                    var isOpen = renderedItems !== null;
                    var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
                    var itemsContainerId = "react-autowhatever-".concat(id);
                    var containerProps = _objectSpread({
                        role: 'combobox',
                        'aria-haspopup': 'listbox',
                        'aria-owns': itemsContainerId,
                        'aria-expanded': isOpen
                    }, theme("react-autowhatever-".concat(id, "-container"), 'container', isOpen && 'containerOpen'), {}, this.props.containerProps);
                    var inputComponent = renderInputComponent(_objectSpread({
                        type: 'text',
                        value: '',
                        autoComplete: 'off',
                        'aria-autocomplete': 'list',
                        'aria-controls': itemsContainerId,
                        'aria-activedescendant': ariaActivedescendant
                    }, theme("react-autowhatever-".concat(id, "-input"), 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), {}, this.props.inputProps, {
                        onFocus: this.onFocus,
                        onBlur: this.onBlur,
                        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
                        ref: this.storeInputReference
                    }));
                    var itemsContainer = renderItemsContainer({
                        containerProps: _objectSpread({
                            id: itemsContainerId,
                            role: 'listbox'
                        }, theme("react-autowhatever-".concat(id, "-items-container"), 'itemsContainer', isOpen && 'itemsContainerOpen'), {
                            ref: this.storeItemsContainerReference
                        }),
                        children: renderedItems
                    });
                    return /*#__PURE__*/ _react["default"].createElement("div", containerProps, inputComponent, itemsContainer);
                }
            }
        ]);
        return Autowhatever;
    }(_react.Component);
    exports1["default"] = Autowhatever;
    _defineProperty(Autowhatever, "propTypes", {
        id: _propTypes["default"].string,
        // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
        multiSection: _propTypes["default"].bool,
        // Indicates whether a multi section layout should be rendered.
        renderInputComponent: _propTypes["default"].func,
        // When specified, it is used to render the input element.
        renderItemsContainer: _propTypes["default"].func,
        // Renders the items container.
        items: _propTypes["default"].array.isRequired,
        // Array of items or sections to render.
        renderItem: _propTypes["default"].func,
        // This function renders a single item.
        renderItemData: _propTypes["default"].object,
        // Arbitrary data that will be passed to renderItem()
        renderSectionTitle: _propTypes["default"].func,
        // This function gets a section and renders its title.
        getSectionItems: _propTypes["default"].func,
        // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
        containerProps: _propTypes["default"].object,
        // Arbitrary container props
        inputProps: _propTypes["default"].object,
        // Arbitrary input props
        itemProps: _propTypes["default"].oneOfType([
            _propTypes["default"].object,
            _propTypes["default"].func
        ]),
        highlightedSectionIndex: _propTypes["default"].number,
        // Section index of the highlighted item
        highlightedItemIndex: _propTypes["default"].number,
        // Highlighted item index (within a section)
        theme: _propTypes["default"].oneOfType([
            _propTypes["default"].object,
            _propTypes["default"].array
        ])
    });
    _defineProperty(Autowhatever, "defaultProps", {
        id: '1',
        multiSection: false,
        renderInputComponent: defaultRenderInputComponent,
        renderItemsContainer: defaultRenderItemsContainer,
        renderItem: function renderItem() {
            throw new Error('`renderItem` must be provided');
        },
        renderItemData: emptyObject,
        renderSectionTitle: function renderSectionTitle() {
            throw new Error('`renderSectionTitle` must be provided');
        },
        getSectionItems: function getSectionItems() {
            throw new Error('`getSectionItems` must be provided');
        },
        containerProps: emptyObject,
        inputProps: emptyObject,
        itemProps: emptyObject,
        highlightedSectionIndex: null,
        highlightedItemIndex: null,
        theme: defaultTheme
    });
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$Autowhatever_1);
var $e83a7d56fa11beee$var$theme = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.mapToAutowhateverTheme = exports1.defaultTheme = void 0;
    var defaultTheme = {
        container: 'react-autosuggest__container',
        containerOpen: 'react-autosuggest__container--open',
        input: 'react-autosuggest__input',
        inputOpen: 'react-autosuggest__input--open',
        inputFocused: 'react-autosuggest__input--focused',
        suggestionsContainer: 'react-autosuggest__suggestions-container',
        suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
        suggestionsList: 'react-autosuggest__suggestions-list',
        suggestion: 'react-autosuggest__suggestion',
        suggestionFirst: 'react-autosuggest__suggestion--first',
        suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
        sectionContainer: 'react-autosuggest__section-container',
        sectionContainerFirst: 'react-autosuggest__section-container--first',
        sectionTitle: 'react-autosuggest__section-title'
    };
    exports1.defaultTheme = defaultTheme;
    var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
        var result = {};
        for(var key in theme)switch(key){
            case 'suggestionsContainer':
                result['itemsContainer'] = theme[key];
                break;
            case 'suggestionsContainerOpen':
                result['itemsContainerOpen'] = theme[key];
                break;
            case 'suggestion':
                result['item'] = theme[key];
                break;
            case 'suggestionFirst':
                result['itemFirst'] = theme[key];
                break;
            case 'suggestionHighlighted':
                result['itemHighlighted'] = theme[key];
                break;
            case 'suggestionsList':
                result['itemsList'] = theme[key];
                break;
            default:
                result[key] = theme[key];
        }
        return result;
    };
    exports1.mapToAutowhateverTheme = mapToAutowhateverTheme;
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$theme);
var $e83a7d56fa11beee$var$theme_1 = $e83a7d56fa11beee$var$theme.mapToAutowhateverTheme;
var $e83a7d56fa11beee$var$theme_2 = $e83a7d56fa11beee$var$theme.defaultTheme;
var $e83a7d56fa11beee$var$Autosuggest_1 = $837e86388abc9533$export$b5e3f462a46347c5(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _react = _interopRequireWildcard($e83a7d56fa11beee$var$React__default);
    var _propTypes = _interopRequireDefault($837e86388abc9533$export$513805011eaa4892);
    var _arrays = _interopRequireDefault($e83a7d56fa11beee$var$arrays);
    var _Autowhatever = _interopRequireDefault($e83a7d56fa11beee$var$Autowhatever_1);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _createSuper(Derived) {
        return function() {
            var Super = _getPrototypeOf(Derived), result;
            if (_isNativeReflectConstruct()) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var alwaysTrue = function alwaysTrue() {
        return true;
    };
    var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
        return value.trim().length > 0;
    };
    var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
        var containerProps = _ref.containerProps, children = _ref.children;
        return /*#__PURE__*/ _react["default"].createElement("div", containerProps, children);
    };
    var Autosuggest = /*#__PURE__*/ function(_Component) {
        _inherits(Autosuggest, _Component);
        var _super = _createSuper(Autosuggest);
        function Autosuggest(_ref2) {
            var _this;
            var _alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
            _classCallCheck(this, Autosuggest);
            _this = _super.call(this);
            _defineProperty(_assertThisInitialized(_this), "onDocumentMouseDown", function(event) {
                _this.justClickedOnSuggestionsContainer = false;
                var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
                event.target;
                while(node !== null && node !== document){
                    if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) // Suggestion was clicked
                    return;
                    if (node === _this.suggestionsContainer) {
                        // Something else inside suggestions container was clicked
                        _this.justClickedOnSuggestionsContainer = true;
                        return;
                    }
                    node = node.parentNode;
                }
            });
            _defineProperty(_assertThisInitialized(_this), "storeAutowhateverRef", function(autowhatever) {
                if (autowhatever !== null) _this.autowhatever = autowhatever;
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseEnter", function(event, _ref3) {
                var sectionIndex = _ref3.sectionIndex, itemIndex = _ref3.itemIndex;
                _this.updateHighlightedSuggestion(sectionIndex, itemIndex);
                if (event.target === _this.pressedSuggestion) _this.justSelectedSuggestion = true;
                _this.justMouseEntered = true;
                setTimeout(function() {
                    _this.justMouseEntered = false;
                });
            });
            _defineProperty(_assertThisInitialized(_this), "highlightFirstSuggestion", function() {
                _this.updateHighlightedSuggestion(_this.props.multiSection ? 0 : null, 0);
            });
            _defineProperty(_assertThisInitialized(_this), "onDocumentMouseUp", function() {
                if (_this.pressedSuggestion && !_this.justSelectedSuggestion) _this.input.focus();
                _this.pressedSuggestion = null;
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseDown", function(event) {
                // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
                // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
                if (!_this.justSelectedSuggestion) {
                    _this.justSelectedSuggestion = true;
                    _this.pressedSuggestion = event.target;
                }
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function() {
                var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
                onSuggestionsClearRequested && onSuggestionsClearRequested();
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function(event, data) {
                var _this$props = _this.props, alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions, onSuggestionSelected = _this$props.onSuggestionSelected, onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
                onSuggestionSelected && onSuggestionSelected(event, data);
                if (alwaysRenderSuggestions) onSuggestionsFetchRequested({
                    value: data.suggestionValue,
                    reason: 'suggestion-selected'
                });
                else _this.onSuggestionsClearRequested();
                _this.resetHighlightedSuggestion();
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionClick", function(event) {
                var _this$props2 = _this.props, alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions, focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;
                var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)), sectionIndex = _this$getSuggestionIn.sectionIndex, suggestionIndex = _this$getSuggestionIn.suggestionIndex;
                var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);
                var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);
                _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');
                _this.onSuggestionSelected(event, {
                    suggestion: clickedSuggestion,
                    suggestionValue: clickedSuggestionValue,
                    suggestionIndex: suggestionIndex,
                    sectionIndex: sectionIndex,
                    method: 'click'
                });
                if (!alwaysRenderSuggestions) _this.closeSuggestions();
                if (focusInputOnSuggestionClick === true) _this.input.focus();
                else _this.onBlur();
                setTimeout(function() {
                    _this.justSelectedSuggestion = false;
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onBlur", function() {
                var _this$props3 = _this.props, inputProps = _this$props3.inputProps, shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
                var value = inputProps.value, onBlur = inputProps.onBlur;
                var highlightedSuggestion = _this.getHighlightedSuggestion();
                var shouldRender = shouldRenderSuggestions(value);
                _this.setState({
                    isFocused: false,
                    highlightedSectionIndex: null,
                    highlightedSuggestionIndex: null,
                    highlightedSuggestion: null,
                    valueBeforeUpDown: null,
                    isCollapsed: !shouldRender
                });
                onBlur && onBlur(_this.blurEvent, {
                    highlightedSuggestion: highlightedSuggestion
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseLeave", function(event) {
                _this.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
                if (_this.justSelectedSuggestion && event.target === _this.pressedSuggestion) _this.justSelectedSuggestion = false;
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchStart", function() {
                _this.justSelectedSuggestion = true; // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
            // todo: gets released so onSuggestionMouseDown won't fire in chrome
            });
            _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchMove", function() {
                _this.justSelectedSuggestion = false;
                _this.pressedSuggestion = null;
                _this.input.focus();
            });
            _defineProperty(_assertThisInitialized(_this), "itemProps", function(_ref4) {
                var sectionIndex = _ref4.sectionIndex, itemIndex = _ref4.itemIndex;
                return {
                    'data-section-index': sectionIndex,
                    'data-suggestion-index': itemIndex,
                    onMouseEnter: _this.onSuggestionMouseEnter,
                    onMouseLeave: _this.onSuggestionMouseLeave,
                    onMouseDown: _this.onSuggestionMouseDown,
                    onTouchStart: _this.onSuggestionTouchStart,
                    onTouchMove: _this.onSuggestionTouchMove,
                    onClick: _this.onSuggestionClick
                };
            });
            _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function(_ref5) {
                var containerProps = _ref5.containerProps, children = _ref5.children;
                var renderSuggestionsContainer = _this.props.renderSuggestionsContainer;
                return renderSuggestionsContainer({
                    containerProps: containerProps,
                    children: children,
                    query: _this.getQuery()
                });
            });
            _this.state = {
                isFocused: false,
                isCollapsed: !_alwaysRenderSuggestions,
                highlightedSectionIndex: null,
                highlightedSuggestionIndex: null,
                highlightedSuggestion: null,
                valueBeforeUpDown: null
            };
            _this.justPressedUpDown = false;
            _this.justMouseEntered = false;
            _this.pressedSuggestion = null;
            return _this;
        }
        _createClass(Autosuggest, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    document.addEventListener('mousedown', this.onDocumentMouseDown);
                    document.addEventListener('mouseup', this.onDocumentMouseUp);
                    this.input = this.autowhatever.input;
                    this.suggestionsContainer = this.autowhatever.itemsContainer;
                } // eslint-disable-next-line camelcase, react/sort-comp
            },
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    if ((0, _arrays["default"])(nextProps.suggestions, this.props.suggestions)) {
                        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) this.highlightFirstSuggestion();
                    } else {
                        if (this.willRenderSuggestions(nextProps)) {
                            if (this.state.isCollapsed && !this.justSelectedSuggestion) this.revealSuggestions();
                        } else this.resetHighlightedSuggestion();
                    }
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState) {
                    var _this$props4 = this.props, suggestions = _this$props4.suggestions, onSuggestionHighlighted = _this$props4.onSuggestionHighlighted, highlightFirstSuggestion = _this$props4.highlightFirstSuggestion;
                    if (!(0, _arrays["default"])(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
                        this.highlightFirstSuggestion();
                        return;
                    }
                    if (onSuggestionHighlighted) {
                        var highlightedSuggestion = this.getHighlightedSuggestion();
                        var prevHighlightedSuggestion = prevState.highlightedSuggestion;
                        if (highlightedSuggestion != prevHighlightedSuggestion) onSuggestionHighlighted({
                            suggestion: highlightedSuggestion
                        });
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    document.removeEventListener('mousedown', this.onDocumentMouseDown);
                    document.removeEventListener('mouseup', this.onDocumentMouseUp);
                }
            },
            {
                key: "updateHighlightedSuggestion",
                value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
                    var _this2 = this;
                    this.setState(function(state) {
                        var valueBeforeUpDown = state.valueBeforeUpDown;
                        if (suggestionIndex === null) valueBeforeUpDown = null;
                        else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') valueBeforeUpDown = prevValue;
                        return {
                            highlightedSectionIndex: sectionIndex,
                            highlightedSuggestionIndex: suggestionIndex,
                            highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
                            valueBeforeUpDown: valueBeforeUpDown
                        };
                    });
                }
            },
            {
                key: "resetHighlightedSuggestion",
                value: function resetHighlightedSuggestion() {
                    var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                    this.setState(function(state) {
                        var valueBeforeUpDown = state.valueBeforeUpDown;
                        return {
                            highlightedSectionIndex: null,
                            highlightedSuggestionIndex: null,
                            highlightedSuggestion: null,
                            valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
                        };
                    });
                }
            },
            {
                key: "revealSuggestions",
                value: function revealSuggestions() {
                    this.setState({
                        isCollapsed: false
                    });
                }
            },
            {
                key: "closeSuggestions",
                value: function closeSuggestions() {
                    this.setState({
                        highlightedSectionIndex: null,
                        highlightedSuggestionIndex: null,
                        highlightedSuggestion: null,
                        valueBeforeUpDown: null,
                        isCollapsed: true
                    });
                }
            },
            {
                key: "getSuggestion",
                value: function getSuggestion(sectionIndex, suggestionIndex) {
                    var _this$props5 = this.props, suggestions = _this$props5.suggestions, multiSection = _this$props5.multiSection, getSectionSuggestions = _this$props5.getSectionSuggestions;
                    if (multiSection) return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
                    return suggestions[suggestionIndex];
                }
            },
            {
                key: "getHighlightedSuggestion",
                value: function getHighlightedSuggestion() {
                    var _this$state = this.state, highlightedSectionIndex = _this$state.highlightedSectionIndex, highlightedSuggestionIndex = _this$state.highlightedSuggestionIndex;
                    if (highlightedSuggestionIndex === null) return null;
                    return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
                }
            },
            {
                key: "getSuggestionValueByIndex",
                value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
                    var getSuggestionValue = this.props.getSuggestionValue;
                    return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
                }
            },
            {
                key: "getSuggestionIndices",
                value: function getSuggestionIndices(suggestionElement) {
                    var sectionIndex = suggestionElement.getAttribute('data-section-index');
                    var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
                    return {
                        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
                        suggestionIndex: parseInt(suggestionIndex, 10)
                    };
                }
            },
            {
                key: "findSuggestionElement",
                value: function findSuggestionElement(startNode) {
                    var node = startNode;
                    do {
                        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) return node;
                        node = node.parentNode;
                    }while (node !== null);
                    console.error('Clicked element:', startNode); // eslint-disable-line no-console
                    throw new Error("Couldn't find suggestion element");
                }
            },
            {
                key: "maybeCallOnChange",
                value: function maybeCallOnChange(event, newValue, method) {
                    var _this$props$inputProp = this.props.inputProps, value = _this$props$inputProp.value, onChange = _this$props$inputProp.onChange;
                    if (newValue !== value) onChange(event, {
                        newValue: newValue,
                        method: method
                    });
                }
            },
            {
                key: "willRenderSuggestions",
                value: function willRenderSuggestions(props) {
                    var suggestions = props.suggestions, inputProps = props.inputProps, shouldRenderSuggestions = props.shouldRenderSuggestions;
                    var value = inputProps.value;
                    return suggestions.length > 0 && shouldRenderSuggestions(value);
                }
            },
            {
                key: "getQuery",
                value: function getQuery() {
                    var inputProps = this.props.inputProps;
                    var value = inputProps.value;
                    var valueBeforeUpDown = this.state.valueBeforeUpDown;
                    return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    var _this$props6 = this.props, suggestions = _this$props6.suggestions, renderInputComponent = _this$props6.renderInputComponent, onSuggestionsFetchRequested = _this$props6.onSuggestionsFetchRequested, renderSuggestion = _this$props6.renderSuggestion, inputProps = _this$props6.inputProps, multiSection = _this$props6.multiSection, renderSectionTitle = _this$props6.renderSectionTitle, id = _this$props6.id, getSectionSuggestions = _this$props6.getSectionSuggestions, theme$1 = _this$props6.theme, getSuggestionValue = _this$props6.getSuggestionValue, alwaysRenderSuggestions = _this$props6.alwaysRenderSuggestions, highlightFirstSuggestion = _this$props6.highlightFirstSuggestion;
                    var _this$state2 = this.state, isFocused = _this$state2.isFocused, isCollapsed = _this$state2.isCollapsed, highlightedSectionIndex = _this$state2.highlightedSectionIndex, highlightedSuggestionIndex = _this$state2.highlightedSuggestionIndex, valueBeforeUpDown = _this$state2.valueBeforeUpDown;
                    var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
                    var value = inputProps.value, _onFocus = inputProps.onFocus, _onKeyDown = inputProps.onKeyDown;
                    var willRenderSuggestions = this.willRenderSuggestions(this.props);
                    var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
                    var items = isOpen ? suggestions : [];
                    var autowhateverInputProps = _objectSpread({}, inputProps, {
                        onFocus: function onFocus(event) {
                            if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
                                var shouldRender = shouldRenderSuggestions(value);
                                _this3.setState({
                                    isFocused: true,
                                    isCollapsed: !shouldRender
                                });
                                _onFocus && _onFocus(event);
                                if (shouldRender) onSuggestionsFetchRequested({
                                    value: value,
                                    reason: 'input-focused'
                                });
                            }
                        },
                        onBlur: function onBlur(event) {
                            if (_this3.justClickedOnSuggestionsContainer) {
                                _this3.input.focus();
                                return;
                            }
                            _this3.blurEvent = event;
                            if (!_this3.justSelectedSuggestion) {
                                _this3.onBlur();
                                _this3.onSuggestionsClearRequested();
                            }
                        },
                        onChange: function onChange(event) {
                            var value = event.target.value;
                            var shouldRender = shouldRenderSuggestions(value);
                            _this3.maybeCallOnChange(event, value, 'type');
                            if (_this3.suggestionsContainer) _this3.suggestionsContainer.scrollTop = 0;
                            _this3.setState(_objectSpread({}, highlightFirstSuggestion ? {} : {
                                highlightedSectionIndex: null,
                                highlightedSuggestionIndex: null,
                                highlightedSuggestion: null
                            }, {
                                valueBeforeUpDown: null,
                                isCollapsed: !shouldRender
                            }));
                            if (shouldRender) onSuggestionsFetchRequested({
                                value: value,
                                reason: 'input-changed'
                            });
                            else _this3.onSuggestionsClearRequested();
                        },
                        onKeyDown: function onKeyDown(event, data) {
                            var keyCode = event.keyCode;
                            switch(keyCode){
                                case 40:
                                case 38:
                                    // ArrowUp
                                    if (isCollapsed) {
                                        if (shouldRenderSuggestions(value)) {
                                            onSuggestionsFetchRequested({
                                                value: value,
                                                reason: 'suggestions-revealed'
                                            });
                                            _this3.revealSuggestions();
                                        }
                                    } else if (suggestions.length > 0) {
                                        var newHighlightedSectionIndex = data.newHighlightedSectionIndex, newHighlightedItemIndex = data.newHighlightedItemIndex;
                                        var newValue;
                                        if (newHighlightedItemIndex === null) // valueBeforeUpDown can be null if, for example, user
                                        // hovers on the first suggestion and then pressed Up.
                                        // If that happens, use the original input value.
                                        newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                                        else newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                                        _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                                        _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
                                    }
                                    event.preventDefault(); // Prevents the cursor from moving
                                    _this3.justPressedUpDown = true;
                                    setTimeout(function() {
                                        _this3.justPressedUpDown = false;
                                    });
                                    break;
                                // Enter
                                case 13:
                                    // See #388
                                    if (event.keyCode === 229) break;
                                    var highlightedSuggestion = _this3.getHighlightedSuggestion();
                                    if (isOpen && !alwaysRenderSuggestions) _this3.closeSuggestions();
                                    if (highlightedSuggestion != null) {
                                        var _newValue = getSuggestionValue(highlightedSuggestion);
                                        _this3.maybeCallOnChange(event, _newValue, 'enter');
                                        _this3.onSuggestionSelected(event, {
                                            suggestion: highlightedSuggestion,
                                            suggestionValue: _newValue,
                                            suggestionIndex: highlightedSuggestionIndex,
                                            sectionIndex: highlightedSectionIndex,
                                            method: 'enter'
                                        });
                                        _this3.justSelectedSuggestion = true;
                                        setTimeout(function() {
                                            _this3.justSelectedSuggestion = false;
                                        });
                                    }
                                    break;
                                // Escape
                                case 27:
                                    if (isOpen) // If input.type === 'search', the browser clears the input
                                    // when Escape is pressed. We want to disable this default
                                    // behaviour so that, when suggestions are shown, we just hide
                                    // them, without clearing the input.
                                    event.preventDefault();
                                    var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
                                    if (valueBeforeUpDown === null) // Didn't interact with Up/Down
                                    {
                                        if (!willCloseSuggestions) {
                                            var _newValue2 = '';
                                            _this3.maybeCallOnChange(event, _newValue2, 'escape');
                                            if (shouldRenderSuggestions(_newValue2)) onSuggestionsFetchRequested({
                                                value: _newValue2,
                                                reason: 'escape-pressed'
                                            });
                                            else _this3.onSuggestionsClearRequested();
                                        }
                                    } else // Interacted with Up/Down
                                    _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                                    if (willCloseSuggestions) {
                                        _this3.onSuggestionsClearRequested();
                                        _this3.closeSuggestions();
                                    } else _this3.resetHighlightedSuggestion();
                                    break;
                            }
                            _onKeyDown && _onKeyDown(event);
                        }
                    });
                    var renderSuggestionData = {
                        query: this.getQuery()
                    };
                    return /*#__PURE__*/ _react["default"].createElement(_Autowhatever["default"], {
                        multiSection: multiSection,
                        items: items,
                        renderInputComponent: renderInputComponent,
                        renderItemsContainer: this.renderSuggestionsContainer,
                        renderItem: renderSuggestion,
                        renderItemData: renderSuggestionData,
                        renderSectionTitle: renderSectionTitle,
                        getSectionItems: getSectionSuggestions,
                        highlightedSectionIndex: highlightedSectionIndex,
                        highlightedItemIndex: highlightedSuggestionIndex,
                        inputProps: autowhateverInputProps,
                        itemProps: this.itemProps,
                        theme: (0, $e83a7d56fa11beee$var$theme.mapToAutowhateverTheme)(theme$1),
                        id: id,
                        ref: this.storeAutowhateverRef
                    });
                }
            }
        ]);
        return Autosuggest;
    }(_react.Component);
    exports1["default"] = Autosuggest;
    _defineProperty(Autosuggest, "propTypes", {
        suggestions: _propTypes["default"].array.isRequired,
        onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
            var onSuggestionsFetchRequested = props[propName];
            if (typeof onSuggestionsFetchRequested !== 'function') throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
        },
        onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
            var onSuggestionsClearRequested = props[propName];
            if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
        },
        onSuggestionSelected: _propTypes["default"].func,
        onSuggestionHighlighted: _propTypes["default"].func,
        renderInputComponent: _propTypes["default"].func,
        renderSuggestionsContainer: _propTypes["default"].func,
        getSuggestionValue: _propTypes["default"].func.isRequired,
        renderSuggestion: _propTypes["default"].func.isRequired,
        inputProps: function inputProps(props, propName) {
            var inputProps = props[propName];
            if (!Object.prototype.hasOwnProperty.call(inputProps, 'value')) throw new Error("'inputProps' must have 'value'.");
            if (!Object.prototype.hasOwnProperty.call(inputProps, 'onChange')) throw new Error("'inputProps' must have 'onChange'.");
        },
        shouldRenderSuggestions: _propTypes["default"].func,
        alwaysRenderSuggestions: _propTypes["default"].bool,
        multiSection: _propTypes["default"].bool,
        renderSectionTitle: function renderSectionTitle(props, propName) {
            var renderSectionTitle = props[propName];
            if (props.multiSection === true && typeof renderSectionTitle !== 'function') throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
        },
        getSectionSuggestions: function getSectionSuggestions(props, propName) {
            var getSectionSuggestions = props[propName];
            if (props.multiSection === true && typeof getSectionSuggestions !== 'function') throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
        },
        focusInputOnSuggestionClick: _propTypes["default"].bool,
        highlightFirstSuggestion: _propTypes["default"].bool,
        theme: _propTypes["default"].object,
        id: _propTypes["default"].string
    });
    _defineProperty(Autosuggest, "defaultProps", {
        renderSuggestionsContainer: defaultRenderSuggestionsContainer,
        shouldRenderSuggestions: defaultShouldRenderSuggestions,
        alwaysRenderSuggestions: false,
        multiSection: false,
        focusInputOnSuggestionClick: true,
        highlightFirstSuggestion: false,
        theme: $e83a7d56fa11beee$var$theme.defaultTheme,
        id: '1'
    });
});
$837e86388abc9533$export$a26b9784e8699f82($e83a7d56fa11beee$var$Autosuggest_1);
var $e83a7d56fa11beee$var$dist$2 = $e83a7d56fa11beee$var$Autosuggest_1["default"];
function $e83a7d56fa11beee$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  .suggestionHighlighted {\n    background: red;\n  }\n"
    ]);
    $e83a7d56fa11beee$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $e83a7d56fa11beee$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  input {\n    display: block;\n    border: none;\n    background: transparent;\n    width: 100%;\n    height: 100%;\n    padding: 12px 16px;\n    font-size: 16px;\n    color: ",
        ";\n    box-sizing: border-box;\n    outline: none;\n  }\n"
    ]);
    $e83a7d56fa11beee$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $e83a7d56fa11beee$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  border: 1px solid #cad1dd;\n  background: ",
        ";\n  position: relative;\n  border-radius: ",
        ";\n  padding: 1px;\n  &:focus-within {\n    padding: 0;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    $e83a7d56fa11beee$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e83a7d56fa11beee$var$Container = $e83a7d56fa11beee$var$styled__default.div($e83a7d56fa11beee$var$_templateObject(), function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.cta;
});
var $e83a7d56fa11beee$var$InnerInput = $e83a7d56fa11beee$var$styled__default.div($e83a7d56fa11beee$var$_templateObject2(), function(props) {
    return props.theme.shade[0];
});
var $e83a7d56fa11beee$var$SuggestionContainer = $e83a7d56fa11beee$var$styled__default.div($e83a7d56fa11beee$var$_templateObject3()); // Imagine you have a list of languages that you'd like to autosuggest.
var $e83a7d56fa11beee$var$suggestions = [
    {
        title: "A",
        suggestions: [
            {
                id: "100",
                text: "Apple"
            },
            {
                id: "101",
                text: "Apricot"
            }
        ]
    },
    {
        title: "B",
        suggestions: [
            {
                id: "102",
                text: "Banana"
            }
        ]
    },
    {
        title: "C",
        suggestions: [
            {
                id: "103",
                text: "Cherry"
            }
        ]
    }
]; // Teach Autosuggest how to calculate suggestions for any given input value.
var $e83a7d56fa11beee$var$getSuggestions = function getSuggestions(value) {
    var inputValue = value.trim().toLowerCase();
    var inputLength = inputValue.length;
    return inputLength === 0 ? [] : $e83a7d56fa11beee$var$suggestions.filter(function(lang) {
        return lang.name.toLowerCase().slice(0, inputLength) === inputValue;
    });
}; // When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
var $e83a7d56fa11beee$var$getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.name;
}; // Use your imagination to render suggestions.
var $e83a7d56fa11beee$var$renderSuggestion = function renderSuggestion(suggestion) {
    return /*#__PURE__*/ $e83a7d56fa11beee$var$React__default.createElement($e83a7d56fa11beee$var$SuggestionContainer, null, suggestion.name);
};
var $e83a7d56fa11beee$var$AutoSuggest = /*#__PURE__*/ function(_Component) {
    $bbed19cb57db80bc$export$7e4530ad35d3bb8(AutoSuggest, _Component);
    var _super = $bbed19cb57db80bc$export$a5d0f9b6cdbee927(AutoSuggest);
    function AutoSuggest(props) {
        var _this;
        $bbed19cb57db80bc$export$c42d3009eb5af660(this, AutoSuggest);
        _this = _super.call(this, props); // Autosuggest is a controlled component.
        // This means that you need to provide an input value
        // and an onChange handler that updates this value (see below).
        // Suggestions also need to be provided to the Autosuggest,
        // and they are initially empty because the Autosuggest is closed.
        _this.onChange = function(event, _ref) {
            var newValue = _ref.newValue;
            _this.setState({
                value: newValue
            });
        };
        _this.onSuggestionsFetchRequested = function(_ref2) {
            var value = _ref2.value;
            _this.setState({
                suggestions: $e83a7d56fa11beee$var$getSuggestions(value)
            });
        };
        _this.onSuggestionsClearRequested = function() {
            _this.setState({
                suggestions: []
            });
        };
        _this.state = {
            value: "",
            suggestions: []
        };
        return _this;
    }
    $bbed19cb57db80bc$export$1d1d1fc204d4f0cc(AutoSuggest, [
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, value = _this$state.value, suggestions = _this$state.suggestions; // Autosuggest will pass through all these props to the input.
                var inputProps = {
                    placeholder: this.props.placeholder,
                    value: value,
                    onChange: this.onChange
                }; // Finally, render it!
                return /*#__PURE__*/ $e83a7d56fa11beee$var$React__default.createElement($e83a7d56fa11beee$var$Container, null, /*#__PURE__*/ $e83a7d56fa11beee$var$React__default.createElement($e83a7d56fa11beee$var$InnerInput, null, /*#__PURE__*/ $e83a7d56fa11beee$var$React__default.createElement($e83a7d56fa11beee$var$dist$2, {
                    suggestions: suggestions,
                    onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
                    onSuggestionsClearRequested: this.onSuggestionsClearRequested,
                    getSuggestionValue: $e83a7d56fa11beee$var$getSuggestionValue,
                    renderSuggestion: $e83a7d56fa11beee$var$renderSuggestion,
                    inputProps: inputProps
                })));
            }
        }
    ]);
    return AutoSuggest;
}($hAGkE.Component);
var $e83a7d56fa11beee$var$AutoSuggest$1 = $62d655c53090e8a3$exports.withTheme($e83a7d56fa11beee$var$AutoSuggest);
$e83a7d56fa11beee$exports["default"] = $e83a7d56fa11beee$var$AutoSuggest$1;


var $82d3309c0d3a619a$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($82d3309c0d3a619a$exports, '__esModule', {
    value: true
});
function $82d3309c0d3a619a$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $82d3309c0d3a619a$var$styled__default = $82d3309c0d3a619a$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $82d3309c0d3a619a$var$React__default = $82d3309c0d3a619a$var$_interopDefault($hAGkE);
var $82d3309c0d3a619a$var$img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M21.018 12.4347C21.2023 12.4252 21.3473 12.2741 21.3493 12.0896C21.3513 11.9052 21.2095 11.751 21.0255 11.7375L10.5516 10.9705C9.96889 10.9278 9.47258 11.3891 9.47258 11.9734C9.47258 12.5492 9.95514 13.0074 10.5302 12.9777L21.018 12.4347Z' fill='%2361676E' stroke='%2361676E' stroke-width='0.698631' stroke-linejoin='round'/%3e%3cpath d='M4.29138 11.3838L10.3246 6.55726C10.9966 6.01967 11.9672 6.64249 11.7585 7.47736L10.6608 11.8678C10.6251 12.011 10.6251 12.1608 10.6608 12.3039L11.7585 16.6944C11.9672 17.5293 10.9966 18.1521 10.3246 17.6145L4.29138 12.7879C3.84148 12.428 3.84148 11.7438 4.29138 11.3838Z' fill='%2361676E'/%3e%3c/svg%3e";
function $82d3309c0d3a619a$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: relative;\n  background: transparent;\n  border: none;\n  font-size: 1rem;\n  outline: none;\n  padding-left: 32px;\n  color: ",
        ";\n  text-align: left;\n  cursor: pointer;\n  &:hover {\n    ",
        " {\n      transform: translate(-4px, 0);\n    }\n  }\n"
    ]);
    $82d3309c0d3a619a$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $82d3309c0d3a619a$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  width: 24px;\n  height: 24px;\n  background-image: url(\"",
        "\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  transition: 0.2s;\n  opacity: ",
        ";\n"
    ]);
    $82d3309c0d3a619a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $82d3309c0d3a619a$var$ArrowImg = $82d3309c0d3a619a$var$styled__default.div($82d3309c0d3a619a$var$_templateObject(), $82d3309c0d3a619a$var$img, function(props) {
    return props.disabled ? "0.5" : "1";
});
var $82d3309c0d3a619a$var$Container = $82d3309c0d3a619a$var$styled__default.button($82d3309c0d3a619a$var$_templateObject2(), function(props) {
    return props.theme.shade[0];
}, $82d3309c0d3a619a$var$ArrowImg);
function $82d3309c0d3a619a$var$BackButton(props) {
    return /*#__PURE__*/ $82d3309c0d3a619a$var$React__default.createElement($82d3309c0d3a619a$var$Container, {
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        id: props.id
    }, /*#__PURE__*/ $82d3309c0d3a619a$var$React__default.createElement($82d3309c0d3a619a$var$ArrowImg, {
        disabled: props.disabled
    }), props.children);
}
$82d3309c0d3a619a$exports["default"] = $82d3309c0d3a619a$var$BackButton;


var $22c37c661d939756$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($22c37c661d939756$exports, '__esModule', {
    value: true
});
function $22c37c661d939756$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $22c37c661d939756$var$styled__default = $22c37c661d939756$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $22c37c661d939756$var$React__default = $22c37c661d939756$var$_interopDefault($hAGkE);
var $e038a8088f6f058c$export$4a587b3eb8320aaf;
'use strict';
function $e038a8088f6f058c$var$LightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    var b = (num >> 8 & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    var g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
}
$e038a8088f6f058c$export$4a587b3eb8320aaf = $e038a8088f6f058c$var$LightenDarkenColor;


function $22c37c661d939756$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  p {\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    $22c37c661d939756$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $22c37c661d939756$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  padding: 12px 16px;\n  color: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        "\n    ",
        "\n    ",
        " 0;\n  display: inline-block;\n"
    ]);
    $22c37c661d939756$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $22c37c661d939756$var$Container = $22c37c661d939756$var$styled__default.div($22c37c661d939756$var$_templateObject(), function(props) {
    return props.theme.primary;
}, function(props) {
    return props.theme.primary + 20;
}, function(props) {
    return props.theme.radius.large;
}, function(props) {
    return props.theme.radius.large;
}, function(props) {
    return props.theme.radius.large;
});
var $22c37c661d939756$var$Content = $22c37c661d939756$var$styled__default.div($22c37c661d939756$var$_templateObject2());
function $22c37c661d939756$var$Bubble(props) {
    return /*#__PURE__*/ $22c37c661d939756$var$React__default.createElement($22c37c661d939756$var$Container, null, /*#__PURE__*/ $22c37c661d939756$var$React__default.createElement($22c37c661d939756$var$Content, null, props.children));
}
$22c37c661d939756$exports["default"] = $22c37c661d939756$var$Bubble;


var $83909883869ef5d9$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($83909883869ef5d9$exports, '__esModule', {
    value: true
});
function $83909883869ef5d9$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $83909883869ef5d9$var$styled__default = $83909883869ef5d9$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $83909883869ef5d9$var$React__default = $83909883869ef5d9$var$_interopDefault($hAGkE);

function $83909883869ef5d9$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  background: ",
        ";\n  padding: 16px 32px;\n  border-radius: ",
        ";\n  border: none;\n  font-size: 1rem;\n  color: ",
        ";\n  transition: background 0.2s;\n  cursor: pointer;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    $83909883869ef5d9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $83909883869ef5d9$var$Container = $83909883869ef5d9$var$styled__default.button($83909883869ef5d9$var$_templateObject(), function(props) {
    return props.disabled ? props.theme.cta + "80" : props.color ? props.color : props.theme.cta;
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.text ? props.text : props.theme.text ? props.theme.text : "white";
}, function(props) {
    return props.disabled ? props.theme.cta + "80" : props.color ? $e038a8088f6f058c$export$4a587b3eb8320aaf(props.color, 25) : $e038a8088f6f058c$export$4a587b3eb8320aaf(props.theme.cta, 25);
});
function $83909883869ef5d9$var$Button(props) {
    return /*#__PURE__*/ $83909883869ef5d9$var$React__default.createElement($83909883869ef5d9$var$Container, {
        className: props.className,
        id: props.id,
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        color: props.color,
        text: props.text
    }, props.children);
}
$83909883869ef5d9$exports["default"] = $83909883869ef5d9$var$Button;


var $4ef6dfd5f7ad8c04$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($4ef6dfd5f7ad8c04$exports, '__esModule', {
    value: true
});
function $4ef6dfd5f7ad8c04$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $4ef6dfd5f7ad8c04$var$styled__default = $4ef6dfd5f7ad8c04$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $4ef6dfd5f7ad8c04$var$React__default = $4ef6dfd5f7ad8c04$var$_interopDefault($hAGkE);

var $9904a760b970af47$export$60bffc6e2a50e7f9;
'use strict';
parcelRequire("hAGkE");
var $9904a760b970af47$var$img = "data:image/svg+xml,%3csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 4.17647L3.56 7L9 1' stroke='white' stroke-width='1.69231'/%3e%3c/svg%3e";
$9904a760b970af47$export$60bffc6e2a50e7f9 = $9904a760b970af47$var$img;


function $4ef6dfd5f7ad8c04$var$_templateObject5() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  &:focus {\n    + ",
        " {\n      background: ",
        ";\n    }\n  }\n  &:checked {\n    + ",
        " {\n      background: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n      color: ",
        ";\n      font-weight: 500;\n      ",
        " {\n        background: ",
        ";\n        box-shadow: 0 0 0 2px ",
        ";\n        &:after {\n          transform: scale(1);\n        }\n      }\n    }\n    &:focus {\n      + ",
        " {\n        background: ",
        ";\n      }\n    }\n  }\n"
    ]);
    $4ef6dfd5f7ad8c04$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $4ef6dfd5f7ad8c04$var$_templateObject4() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  width: 24px;\n  height: 24px;\n  background: ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";\n  margin-right: 16px;\n  border-radius: 4px;\n  position: relative;\n  transition: 0.2s;\n  flex-shrink: 0;\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 12px;\n    height: 12px;\n    transform: scale(0) rotate(45deg);\n    transform-origin: center;\n    transition: 0.2s;\n    background-image: url(\"",
        "\");\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n"
    ]);
    $4ef6dfd5f7ad8c04$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $4ef6dfd5f7ad8c04$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: flex;\n  position: relative;\n  padding: 16px;\n  background: ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";\n  border-radius: ",
        ";\n  align-items: center;\n  transition: 0.2s;\n  cursor: pointer;\n  color: ",
        ";\n  height: 100%;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    $4ef6dfd5f7ad8c04$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $4ef6dfd5f7ad8c04$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8em;\n"
    ]);
    $4ef6dfd5f7ad8c04$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $4ef6dfd5f7ad8c04$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: relative;\n"
    ]);
    $4ef6dfd5f7ad8c04$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4ef6dfd5f7ad8c04$var$Outer = $4ef6dfd5f7ad8c04$var$styled__default.div($4ef6dfd5f7ad8c04$var$_templateObject());
var $4ef6dfd5f7ad8c04$var$Text = $4ef6dfd5f7ad8c04$var$styled__default.div($4ef6dfd5f7ad8c04$var$_templateObject2());
var $4ef6dfd5f7ad8c04$var$Container = $4ef6dfd5f7ad8c04$var$styled__default.label($4ef6dfd5f7ad8c04$var$_templateObject3(), function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.shade[10];
}, function(props) {
    return props.theme.shade[80];
});
var $4ef6dfd5f7ad8c04$var$Checkmark = $4ef6dfd5f7ad8c04$var$styled__default.span($4ef6dfd5f7ad8c04$var$_templateObject4(), function(props) {
    return props.theme.shade[80];
}, function(props) {
    return props.theme.shade[60];
}, $9904a760b970af47$export$60bffc6e2a50e7f9);
var $4ef6dfd5f7ad8c04$var$Input = $4ef6dfd5f7ad8c04$var$styled__default.input($4ef6dfd5f7ad8c04$var$_templateObject5(), $4ef6dfd5f7ad8c04$var$Container, function(props) {
    return props.theme.shade[70];
}, $4ef6dfd5f7ad8c04$var$Container, function(props) {
    return props.theme.tertiary;
}, function(props) {
    return props.theme.tertiary;
}, function(props) {
    return props.theme.shade[100];
}, $4ef6dfd5f7ad8c04$var$Checkmark, function(props) {
    return props.theme.tertiary;
}, function(props) {
    return props.theme.shade[100];
}, $4ef6dfd5f7ad8c04$var$Container, function(props) {
    return $e038a8088f6f058c$export$4a587b3eb8320aaf(props.theme.tertiary, 20);
});
function $4ef6dfd5f7ad8c04$var$CheckButton(props) {
    return /*#__PURE__*/ $4ef6dfd5f7ad8c04$var$React__default.createElement($4ef6dfd5f7ad8c04$var$Outer, null, /*#__PURE__*/ $4ef6dfd5f7ad8c04$var$React__default.createElement($4ef6dfd5f7ad8c04$var$Input, {
        type: "checkbox",
        id: props.id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        checked: props.checked
    }), /*#__PURE__*/ $4ef6dfd5f7ad8c04$var$React__default.createElement($4ef6dfd5f7ad8c04$var$Container, {
        id: "".concat(props.id, "-container"),
        htmlFor: props.id
    }, /*#__PURE__*/ $4ef6dfd5f7ad8c04$var$React__default.createElement($4ef6dfd5f7ad8c04$var$Checkmark, {
        id: "".concat(props.id, "-checkmark")
    }), /*#__PURE__*/ $4ef6dfd5f7ad8c04$var$React__default.createElement($4ef6dfd5f7ad8c04$var$Text, {
        id: "".concat(props.id, "-text")
    }, props.children)));
}
$4ef6dfd5f7ad8c04$exports["default"] = $4ef6dfd5f7ad8c04$var$CheckButton;


var $c97bce8de62d6821$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($c97bce8de62d6821$exports, '__esModule', {
    value: true
});
function $c97bce8de62d6821$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $c97bce8de62d6821$var$styled__default = $c97bce8de62d6821$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $c97bce8de62d6821$var$React__default = $c97bce8de62d6821$var$_interopDefault($hAGkE);

var $5d7e095253493ce8$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($5d7e095253493ce8$exports, '__esModule', {
    value: true
});
function $5d7e095253493ce8$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5d7e095253493ce8$var$styled__default = $5d7e095253493ce8$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $5d7e095253493ce8$var$React__default = $5d7e095253493ce8$var$_interopDefault($hAGkE);

function $5d7e095253493ce8$var$_templateObject5() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ",
        ";\n  width: 32px;\n  height: 32px;\n  margin: auto;\n  border-radius: 50%;\n  transform-origin: center;\n  animation: ",
        " 1s infinite alternate;\n  user-select: none;\n  pointer-events: none;\n  display: ",
        ";\n"
    ]);
    $5d7e095253493ce8$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $5d7e095253493ce8$var$_templateObject4() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  0% {\n    opacity: 0;\n    transform: scale(0)\n  }\n\n  100 {\n    opacity: 1;\n    transform: scale(1)\n  }\n"
    ]);
    $5d7e095253493ce8$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $5d7e095253493ce8$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: block;\n  border: none;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  padding: 12px ",
        " 12px 16px;\n  font-size: 16px;\n  color: ",
        ";\n  box-sizing: border-box;\n  outline: none;\n  &:empty {\n    + ",
        " {\n      width: 0;\n    }\n  }\n  &:focus,\n  &:not(:placeholder-shown) {\n    + ",
        " {\n      width: 100%;\n      p {\n        transform-origin: right;\n        transform: scale(0.8);\n      }\n      /* The 0.5 is to fix a bug with overflow */\n    }\n  }\n"
    ]);
    $5d7e095253493ce8$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $5d7e095253493ce8$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  position: relative;\n  border-radius: ",
        ";\n  padding: 1px;\n  &:focus-within {\n    padding: 0;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    $5d7e095253493ce8$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $5d7e095253493ce8$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  width: 100%;\n  display: block;\n  transition: 0.4s;\n  padding-left: 16px;\n  padding-right: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  line-height: 44px;\n  pointer-events: none;\n  user-select: none;\n  color: ",
        ";\n  z-index: 1;\n  white-space: nowrap;\n  text-align: right;\n  p {\n    display: inline-block;\n  }\n"
    ]);
    $5d7e095253493ce8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5d7e095253493ce8$var$Label = $5d7e095253493ce8$var$styled__default.label($5d7e095253493ce8$var$_templateObject(), function(props) {
    return props.theme.shade[20];
});
var $5d7e095253493ce8$var$Container = $5d7e095253493ce8$var$styled__default.div($5d7e095253493ce8$var$_templateObject2(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.cta;
});
var $5d7e095253493ce8$var$InnerInput = $5d7e095253493ce8$var$styled__default.input($5d7e095253493ce8$var$_templateObject3(), function(props) {
    return props.labelOffset * 0.9 + 32 + "px";
}, function(props) {
    return props.disabled ? props.theme.shade[40] : props.theme.shade[0];
}, $5d7e095253493ce8$var$Label, $5d7e095253493ce8$var$Label);
var $5d7e095253493ce8$var$animation = $62d655c53090e8a3$exports.keyframes($5d7e095253493ce8$var$_templateObject4());
var $5d7e095253493ce8$var$Loader = $5d7e095253493ce8$var$styled__default.div($5d7e095253493ce8$var$_templateObject5(), function(props) {
    return props.theme.shade[60];
}, $5d7e095253493ce8$var$animation, function(props) {
    return props.isLoading ? "block" : "none";
});
function $5d7e095253493ce8$var$Input(props) {
    var _React$useState = $5d7e095253493ce8$var$React__default.useState({
        labelWidth: 0
    }), _React$useState2 = $bbed19cb57db80bc$export$8f274c941f3300d0(_React$useState, 2), dimensions = _React$useState2[0], setDimensions = _React$useState2[1];
    var labelRef = $hAGkE.useRef(null);
    $hAGkE.useEffect(function() {
        setDimensions({
            labelWidth: labelRef.current.clientWidth
        });
    }, []);
    return /*#__PURE__*/ $5d7e095253493ce8$var$React__default.createElement($5d7e095253493ce8$var$Container, {
        disabled: props.disabled
    }, /*#__PURE__*/ $5d7e095253493ce8$var$React__default.createElement($5d7e095253493ce8$var$Loader, {
        isLoading: props.isLoading
    }), /*#__PURE__*/ $5d7e095253493ce8$var$React__default.createElement($5d7e095253493ce8$var$InnerInput, $bbed19cb57db80bc$export$c90d7ca213038c72({
        type: "text",
        id: props.id,
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        placeholder: " ",
        autoComplete: "off",
        labelOffset: dimensions.labelWidth
    }, props)), /*#__PURE__*/ $5d7e095253493ce8$var$React__default.createElement($5d7e095253493ce8$var$Label, {
        htmlFor: props.id,
        disabled: props.disabled
    }, /*#__PURE__*/ $5d7e095253493ce8$var$React__default.createElement("p", {
        ref: labelRef
    }, props.label)));
}
$5d7e095253493ce8$var$Input.propTypes = {
    placeholder: $837e86388abc9533$export$e0c95a451cd220b7.string
};
$5d7e095253493ce8$exports["default"] = $5d7e095253493ce8$var$Input;


function $c97bce8de62d6821$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  padding: 16px;\n  cursor: pointer;\n  border-top: 1px solid ",
        ";\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    $c97bce8de62d6821$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $c97bce8de62d6821$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  overflow: auto;\n  border: 1px solid ",
        ";\n  max-height: 240px;\n  :empty {\n    display: none;\n  }\n"
    ]);
    $c97bce8de62d6821$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c97bce8de62d6821$var$List = $c97bce8de62d6821$var$styled__default.div($c97bce8de62d6821$var$_templateObject(), function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.shade[60];
});
var $c97bce8de62d6821$var$ListItem = $c97bce8de62d6821$var$styled__default.div($c97bce8de62d6821$var$_templateObject2(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.theme.shade[80];
});
function $c97bce8de62d6821$var$ComboBox(_ref) {
    var label = _ref.label, value = _ref.value, onInputChanged = _ref.onInputChanged, comboSelections = _ref.comboSelections, onSelectionMade = _ref.onSelectionMade, isLoading = _ref.isLoading, disabled = _ref.disabled, id = _ref.id;
    return /*#__PURE__*/ $c97bce8de62d6821$var$React__default.createElement($c97bce8de62d6821$var$React__default.Fragment, null, /*#__PURE__*/ $c97bce8de62d6821$var$React__default.createElement($5d7e095253493ce8$exports.default, {
        value: value,
        onChange: onInputChanged,
        label: label,
        isLoading: isLoading,
        disabled: disabled,
        id: "".concat(id, "-input")
    }), /*#__PURE__*/ $c97bce8de62d6821$var$React__default.createElement($c97bce8de62d6821$var$List, {
        id: "".concat(id, "-list")
    }, comboSelections && comboSelections.map(function(selection) {
        return /*#__PURE__*/ $c97bce8de62d6821$var$React__default.createElement($c97bce8de62d6821$var$ListItem, {
            key: selection.text,
            onClick: function onClick() {
                return onSelectionMade(selection);
            }
        }, selection.text);
    })));
}
$c97bce8de62d6821$exports["default"] = $c97bce8de62d6821$var$ComboBox;


var $1722b077bf42693a$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($1722b077bf42693a$exports, '__esModule', {
    value: true
});
function $1722b077bf42693a$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $1722b077bf42693a$var$styled__default = $1722b077bf42693a$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $1722b077bf42693a$var$React__default = $1722b077bf42693a$var$_interopDefault($hAGkE);

/**
 * react-number-format - 4.4.1
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2020 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ function $1722b077bf42693a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1722b077bf42693a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1722b077bf42693a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1722b077bf42693a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1722b077bf42693a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1722b077bf42693a$var$_extends() {
    $1722b077bf42693a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1722b077bf42693a$var$_extends.apply(this, arguments);
}
function $1722b077bf42693a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1722b077bf42693a$var$_setPrototypeOf(subClass, superClass);
}
function $1722b077bf42693a$var$_getPrototypeOf(o) {
    $1722b077bf42693a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1722b077bf42693a$var$_getPrototypeOf(o);
}
function $1722b077bf42693a$var$_setPrototypeOf(o, p) {
    $1722b077bf42693a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1722b077bf42693a$var$_setPrototypeOf(o, p);
}
function $1722b077bf42693a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1722b077bf42693a$var$_possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, $2xTNA._)(call)) === "object" || typeof call === "function")) return call;
    return $1722b077bf42693a$var$_assertThisInitialized(self);
}
function $1722b077bf42693a$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1722b077bf42693a$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var $1722b077bf42693a$var$ReactPropTypesSecret_1 = $1722b077bf42693a$var$ReactPropTypesSecret;
function $1722b077bf42693a$var$emptyFunction() {}
function $1722b077bf42693a$var$emptyFunctionWithReset() {}
$1722b077bf42693a$var$emptyFunctionWithReset.resetWarningCache = $1722b077bf42693a$var$emptyFunction;
var $1722b077bf42693a$var$factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1722b077bf42693a$var$ReactPropTypesSecret_1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1722b077bf42693a$var$emptyFunctionWithReset,
        resetWarningCache: $1722b077bf42693a$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $1722b077bf42693a$var$propTypes = $1722b077bf42693a$var$createCommonjsModule(function(module) {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = $1722b077bf42693a$var$factoryWithThrowingShims();
});
// basic noop function
function $1722b077bf42693a$var$noop() {}
function $1722b077bf42693a$var$returnTrue() {
    return true;
}
function $1722b077bf42693a$var$charIsNumber(_char) {
    return !!(_char || '').match(/\d/);
}
function $1722b077bf42693a$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function $1722b077bf42693a$var$getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case 'lakh':
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case 'wan':
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case 'thousand':
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $1722b077bf42693a$var$applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = $1722b077bf42693a$var$getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator);
} //spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function $1722b077bf42693a$var$splitDecimal(numStr) {
    var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var hasNagation = numStr[0] === '-';
    var addNegation = hasNagation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNagation: hasNagation,
        addNegation: addNegation
    };
}
function $1722b077bf42693a$var$fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === '-';
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return "".concat(isNegative ? '-' : '').concat(beforeDecimal).concat(afterDecimal ? ".".concat(afterDecimal) : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function $1722b077bf42693a$var$limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function $1722b077bf42693a$var$roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        '',
        '-'
    ].indexOf(numStr) !== -1) return numStr;
    var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
    var _splitDecimal = $1722b077bf42693a$var$splitDecimal(numStr), beforeDecimal = _splitDecimal.beforeDecimal, afterDecimal = _splitDecimal.afterDecimal, hasNagation = _splitDecimal.hasNagation;
    var roundedDecimalParts = parseFloat("0.".concat(afterDecimal || '0')).toFixed(scale).split('.');
    var intPart = beforeDecimal.split('').reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = $1722b077bf42693a$var$limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
    var negation = hasNagation ? '-' : '';
    var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
    return "".concat(negation).concat(intPart).concat(decimalSeparator).concat(decimalPart);
}
function $1722b077bf42693a$var$omit(obj, keyMaps) {
    var filteredObj = {};
    Object.keys(obj).forEach(function(key) {
        if (!keyMaps[key]) filteredObj[key] = obj[key];
    });
    return filteredObj;
}
/** set the caret positon in an input field **/ function $1722b077bf42693a$var$setCaretPosition(el, caretPos) {
    el.value = el.value; // ^ this is used to not only get "focus", but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        if (el.createTextRange) {
            var range = el.createTextRange();
            range.move('character', caretPos);
            range.select();
            return true;
        } // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        } // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/ function $1722b077bf42693a$var$findChangedIndex(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
     //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        start: i,
        end: prevLength - j
    };
}
/*
  Returns a number whose value is limited to the given range
*/ function $1722b077bf42693a$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $1722b077bf42693a$var$getCurrentCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
var $1722b077bf42693a$var$propTypes$1 = {
    thousandSeparator: $1722b077bf42693a$var$propTypes.oneOfType([
        $1722b077bf42693a$var$propTypes.string,
        $1722b077bf42693a$var$propTypes.oneOf([
            true
        ])
    ]),
    decimalSeparator: $1722b077bf42693a$var$propTypes.string,
    allowedDecimalSeparators: $1722b077bf42693a$var$propTypes.arrayOf($1722b077bf42693a$var$propTypes.string),
    thousandsGroupStyle: $1722b077bf42693a$var$propTypes.oneOf([
        'thousand',
        'lakh',
        'wan'
    ]),
    decimalScale: $1722b077bf42693a$var$propTypes.number,
    fixedDecimalScale: $1722b077bf42693a$var$propTypes.bool,
    displayType: $1722b077bf42693a$var$propTypes.oneOf([
        'input',
        'text'
    ]),
    prefix: $1722b077bf42693a$var$propTypes.string,
    suffix: $1722b077bf42693a$var$propTypes.string,
    format: $1722b077bf42693a$var$propTypes.oneOfType([
        $1722b077bf42693a$var$propTypes.string,
        $1722b077bf42693a$var$propTypes.func
    ]),
    removeFormatting: $1722b077bf42693a$var$propTypes.func,
    mask: $1722b077bf42693a$var$propTypes.oneOfType([
        $1722b077bf42693a$var$propTypes.string,
        $1722b077bf42693a$var$propTypes.arrayOf($1722b077bf42693a$var$propTypes.string)
    ]),
    value: $1722b077bf42693a$var$propTypes.oneOfType([
        $1722b077bf42693a$var$propTypes.number,
        $1722b077bf42693a$var$propTypes.string
    ]),
    defaultValue: $1722b077bf42693a$var$propTypes.oneOfType([
        $1722b077bf42693a$var$propTypes.number,
        $1722b077bf42693a$var$propTypes.string
    ]),
    isNumericString: $1722b077bf42693a$var$propTypes.bool,
    customInput: $1722b077bf42693a$var$propTypes.elementType,
    allowNegative: $1722b077bf42693a$var$propTypes.bool,
    allowEmptyFormatting: $1722b077bf42693a$var$propTypes.bool,
    allowLeadingZeros: $1722b077bf42693a$var$propTypes.bool,
    onValueChange: $1722b077bf42693a$var$propTypes.func,
    onKeyDown: $1722b077bf42693a$var$propTypes.func,
    onMouseUp: $1722b077bf42693a$var$propTypes.func,
    onChange: $1722b077bf42693a$var$propTypes.func,
    onFocus: $1722b077bf42693a$var$propTypes.func,
    onBlur: $1722b077bf42693a$var$propTypes.func,
    type: $1722b077bf42693a$var$propTypes.oneOf([
        'text',
        'tel',
        'password'
    ]),
    isAllowed: $1722b077bf42693a$var$propTypes.func,
    renderText: $1722b077bf42693a$var$propTypes.func,
    getInputRef: $1722b077bf42693a$var$propTypes.oneOfType([
        $1722b077bf42693a$var$propTypes.func,
        $1722b077bf42693a$var$propTypes.shape({
            current: $1722b077bf42693a$var$propTypes.any
        })
    ])
};
var $1722b077bf42693a$var$defaultProps = {
    displayType: 'input',
    decimalSeparator: '.',
    thousandsGroupStyle: 'thousand',
    fixedDecimalScale: false,
    prefix: '',
    suffix: '',
    allowNegative: true,
    allowEmptyFormatting: false,
    allowLeadingZeros: false,
    isNumericString: false,
    type: 'text',
    onValueChange: $1722b077bf42693a$var$noop,
    onChange: $1722b077bf42693a$var$noop,
    onKeyDown: $1722b077bf42693a$var$noop,
    onMouseUp: $1722b077bf42693a$var$noop,
    onFocus: $1722b077bf42693a$var$noop,
    onBlur: $1722b077bf42693a$var$noop,
    isAllowed: $1722b077bf42693a$var$returnTrue
};
var $1722b077bf42693a$var$NumberFormat = /*#__PURE__*/ function(_React$Component) {
    $1722b077bf42693a$var$_inherits(NumberFormat, _React$Component);
    function NumberFormat(props) {
        var _this;
        $1722b077bf42693a$var$_classCallCheck(this, NumberFormat);
        _this = $1722b077bf42693a$var$_possibleConstructorReturn(this, $1722b077bf42693a$var$_getPrototypeOf(NumberFormat).call(this, props));
        var defaultValue = props.defaultValue; //validate props
        _this.validateProps();
        var formattedValue = _this.formatValueProp(defaultValue);
        _this.state = {
            value: formattedValue,
            numAsString: _this.removeFormatting(formattedValue)
        };
        _this.selectionBeforeInput = {
            selectionStart: 0,
            selectionEnd: 0
        };
        _this.onChange = _this.onChange.bind($1722b077bf42693a$var$_assertThisInitialized(_this));
        _this.onKeyDown = _this.onKeyDown.bind($1722b077bf42693a$var$_assertThisInitialized(_this));
        _this.onMouseUp = _this.onMouseUp.bind($1722b077bf42693a$var$_assertThisInitialized(_this));
        _this.onFocus = _this.onFocus.bind($1722b077bf42693a$var$_assertThisInitialized(_this));
        _this.onBlur = _this.onBlur.bind($1722b077bf42693a$var$_assertThisInitialized(_this));
        return _this;
    }
    $1722b077bf42693a$var$_createClass(NumberFormat, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                this.updateValueIfRequired(prevProps);
            }
        },
        {
            key: "updateValueIfRequired",
            value: function updateValueIfRequired(prevProps) {
                var props = this.props, state = this.state, focusedElm = this.focusedElm;
                var stateValue = state.value, _state$numAsString = state.numAsString, lastNumStr = _state$numAsString === void 0 ? '' : _state$numAsString; // If only state changed no need to do any thing
                if (prevProps !== props) {
                    //validate props
                    this.validateProps();
                    var lastValueWithNewFormat = this.formatNumString(lastNumStr);
                    var formattedValue = props.value === undefined ? lastValueWithNewFormat : this.formatValueProp();
                    var numAsString = this.removeFormatting(formattedValue);
                    var floatValue = parseFloat(numAsString);
                    var lastFloatValue = parseFloat(lastNumStr);
                    if ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || //can also set state when float value is same and the format props changes
                    lastValueWithNewFormat !== stateValue || //set state always when not in focus and formatted value is changed
                    focusedElm === null && formattedValue !== stateValue) this.updateValue({
                        formattedValue: formattedValue,
                        numAsString: numAsString,
                        input: focusedElm
                    });
                }
            }
        },
        {
            key: "getFloatString",
            value: function getFloatString() {
                var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var decimalScale = this.props.decimalScale;
                var _this$getSeparators = this.getSeparators(), decimalSeparator = _this$getSeparators.decimalSeparator;
                var numRegex = this.getNumberRegex(true); //remove negation for regex check
                var hasNegation = num[0] === '-';
                if (hasNegation) num = num.replace('-', ''); //if decimal scale is zero remove decimal and number after decimalSeparator
                if (decimalSeparator && decimalScale === 0) num = num.split(decimalSeparator)[0];
                num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals
                var firstDecimalIndex = num.indexOf('.');
                if (firstDecimalIndex !== -1) num = "".concat(num.substring(0, firstDecimalIndex), ".").concat(num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp($1722b077bf42693a$var$escapeRegExp(decimalSeparator), 'g'), ''));
                 //add negation back
                if (hasNegation) num = '-' + num;
                return num;
            } //returned regex assumes decimalSeparator is as per prop
        },
        {
            key: "getNumberRegex",
            value: function getNumberRegex(g, ignoreDecimalSeparator) {
                var _this$props = this.props, format = _this$props.format, decimalScale = _this$props.decimalScale;
                var _this$getSeparators2 = this.getSeparators(), decimalSeparator = _this$getSeparators2.decimalSeparator;
                return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + $1722b077bf42693a$var$escapeRegExp(decimalSeparator) : ''), g ? 'g' : undefined);
            }
        },
        {
            key: "getSeparators",
            value: function getSeparators() {
                var decimalSeparator = this.props.decimalSeparator;
                var _this$props2 = this.props, thousandSeparator = _this$props2.thousandSeparator, allowedDecimalSeparators = _this$props2.allowedDecimalSeparators;
                if (thousandSeparator === true) thousandSeparator = ',';
                if (!allowedDecimalSeparators) allowedDecimalSeparators = [
                    decimalSeparator,
                    '.'
                ];
                return {
                    decimalSeparator: decimalSeparator,
                    thousandSeparator: thousandSeparator,
                    allowedDecimalSeparators: allowedDecimalSeparators
                };
            }
        },
        {
            key: "getMaskAtIndex",
            value: function getMaskAtIndex(index) {
                var _this$props$mask = this.props.mask, mask = _this$props$mask === void 0 ? ' ' : _this$props$mask;
                if (typeof mask === 'string') return mask;
                return mask[index] || ' ';
            }
        },
        {
            key: "getValueObject",
            value: function getValueObject(formattedValue, numAsString) {
                var floatValue = parseFloat(numAsString);
                return {
                    formattedValue: formattedValue,
                    value: numAsString,
                    floatValue: isNaN(floatValue) ? undefined : floatValue
                };
            }
        },
        {
            key: "validateProps",
            value: function validateProps() {
                var mask = this.props.mask; //validate decimalSeparator and thousandSeparator
                var _this$getSeparators3 = this.getSeparators(), decimalSeparator = _this$getSeparators3.decimalSeparator, thousandSeparator = _this$getSeparators3.thousandSeparator;
                if (decimalSeparator === thousandSeparator) throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: ".concat(thousandSeparator, " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: ").concat(decimalSeparator, " (default value for decimalSeparator is .)\n       "));
                 //validate mask
                if (mask) {
                    var maskAsStr = mask === 'string' ? mask : mask.toString();
                    if (maskAsStr.match(/\d/g)) throw new Error("\n          Mask ".concat(mask, " should not contain numeric character;\n        "));
                }
            }
        },
        {
            key: "setPatchedCaretPosition",
            value: function setPatchedCaretPosition(el, caretPos, currentValue) {
                /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */ $1722b077bf42693a$var$setCaretPosition(el, caretPos);
                setTimeout(function() {
                    if (el.value === currentValue) $1722b077bf42693a$var$setCaretPosition(el, caretPos);
                }, 0);
            }
        },
        {
            key: "correctCaretPosition",
            value: function correctCaretPosition(value, caretPos, direction) {
                var _this$props3 = this.props, prefix = _this$props3.prefix, suffix = _this$props3.suffix, format = _this$props3.format; //if value is empty return 0
                if (value === '') return 0; //caret position should be between 0 and value length
                caretPos = $1722b077bf42693a$var$clamp(caretPos, 0, value.length); //in case of format as number limit between prefix and suffix
                if (!format) {
                    var hasNegation = value[0] === '-';
                    return $1722b077bf42693a$var$clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
                } //in case if custom format method don't do anything
                if (typeof format === 'function') return caretPos;
                /* in case format is string find the closest # position from the caret position */ //in case the caretPos have input value on it don't do anything
                if (format[caretPos] === '#' && $1722b077bf42693a$var$charIsNumber(value[caretPos])) return caretPos; //if caretPos is just after input value don't do anything
                if (format[caretPos - 1] === '#' && $1722b077bf42693a$var$charIsNumber(value[caretPos - 1])) return caretPos; //find the nearest caret position
                var firstHashPosition = format.indexOf('#');
                var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position
                caretPos = $1722b077bf42693a$var$clamp(caretPos, firstHashPosition, lastHashPosition + 1);
                var nextPos = format.substring(caretPos, format.length).indexOf('#');
                var caretLeftBound = caretPos;
                var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present
                while(caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !$1722b077bf42693a$var$charIsNumber(value[caretLeftBound])))caretLeftBound -= 1;
                var goToLeft = !$1722b077bf42693a$var$charIsNumber(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;
                if (goToLeft) //check if number should be taken after the bound or after it
                //if number preceding a valid number keep it after
                return $1722b077bf42693a$var$charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
                return caretRightBound;
            }
        },
        {
            key: "getCaretPosition",
            value: function getCaretPosition(inputValue, formattedValue, caretPos) {
                var format = this.props.format;
                var stateValue = this.state.value;
                var numRegex = this.getNumberRegex(true);
                var inputNumber = (inputValue.match(numRegex) || []).join('');
                var formattedNumber = (formattedValue.match(numRegex) || []).join('');
                var j, i;
                j = 0;
                for(i = 0; i < caretPos; i++){
                    var currentInputChar = inputValue[i] || '';
                    var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
                    //case inputValue = 1a23 and formattedValue =  123
                    if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue; //When we are striping out leading zeros maintain the new cursor position
                    //Case inputValue = 00023 and formattedValue = 23;
                    if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue; //we are not using currentFormatChar because j can change here
                    while(currentInputChar !== formattedValue[j] && j < formattedValue.length)j++;
                    j++;
                }
                if (typeof format === 'string' && !stateValue) //set it to the maximum value so it goes after the last number
                j = formattedValue.length;
                 //correct caret position if its outside of editable area
                j = this.correctCaretPosition(formattedValue, j);
                return j;
            }
        },
        {
            key: "removePrefixAndSuffix",
            value: function removePrefixAndSuffix(val) {
                var _this$props4 = this.props, format = _this$props4.format, prefix = _this$props4.prefix, suffix = _this$props4.suffix; //remove prefix and suffix
                if (!format && val) {
                    var isNegative = val[0] === '-'; //remove negation sign
                    if (isNegative) val = val.substring(1, val.length); //remove prefix
                    val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix
                    var suffixLastIndex = val.lastIndexOf(suffix);
                    val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back
                    if (isNegative) val = '-' + val;
                }
                return val;
            }
        },
        {
            key: "removePatternFormatting",
            value: function removePatternFormatting(val) {
                var format = this.props.format;
                var formatArray = format.split('#').filter(function(str) {
                    return str !== '';
                });
                var start = 0;
                var numStr = '';
                for(var i = 0, ln = formatArray.length; i <= ln; i++){
                    var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
                    //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
                    var index = i === ln ? val.length : val.indexOf(part, start);
                    /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */ if (index === -1) {
                        numStr = val;
                        break;
                    } else {
                        numStr += val.substring(start, index);
                        start = index + part.length;
                    }
                }
                return (numStr.match(/\d/g) || []).join('');
            }
        },
        {
            key: "removeFormatting",
            value: function removeFormatting(val) {
                var _this$props5 = this.props, format = _this$props5.format, removeFormatting = _this$props5.removeFormatting;
                if (!val) return val;
                if (!format) {
                    val = this.removePrefixAndSuffix(val);
                    val = this.getFloatString(val);
                } else if (typeof format === 'string') val = this.removePatternFormatting(val);
                else if (typeof removeFormatting === 'function') //condition need to be handled if format method is provide,
                val = removeFormatting(val);
                else val = (val.match(/\d/g) || []).join('');
                return val;
            }
        },
        {
            key: "formatWithPattern",
            value: function formatWithPattern(numStr) {
                var format = this.props.format;
                var hashCount = 0;
                var formattedNumberAry = format.split('');
                for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === '#') {
                    formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
                    hashCount += 1;
                }
                return formattedNumberAry.join('');
            }
        },
        {
            key: "formatAsNumber",
            value: function formatAsNumber(numStr) {
                var _this$props6 = this.props, decimalScale = _this$props6.decimalScale, fixedDecimalScale = _this$props6.fixedDecimalScale, prefix = _this$props6.prefix, suffix = _this$props6.suffix, allowNegative = _this$props6.allowNegative, thousandsGroupStyle = _this$props6.thousandsGroupStyle;
                var _this$getSeparators4 = this.getSeparators(), thousandSeparator = _this$getSeparators4.thousandSeparator, decimalSeparator = _this$getSeparators4.decimalSeparator;
                var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
                var _splitDecimal = $1722b077bf42693a$var$splitDecimal(numStr, allowNegative), beforeDecimal = _splitDecimal.beforeDecimal, afterDecimal = _splitDecimal.afterDecimal, addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
                //apply decimal precision if its defined
                if (decimalScale !== undefined) afterDecimal = $1722b077bf42693a$var$limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
                if (thousandSeparator) beforeDecimal = $1722b077bf42693a$var$applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
                 //add prefix and suffix
                if (prefix) beforeDecimal = prefix + beforeDecimal;
                if (suffix) afterDecimal = afterDecimal + suffix; //restore negation sign
                if (addNegation) beforeDecimal = '-' + beforeDecimal;
                numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
                return numStr;
            }
        },
        {
            key: "formatNumString",
            value: function formatNumString() {
                var numStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var _this$props7 = this.props, format = _this$props7.format, allowEmptyFormatting = _this$props7.allowEmptyFormatting;
                var formattedValue = numStr;
                if (numStr === '' && !allowEmptyFormatting) formattedValue = '';
                else if (numStr === '-' && !format) formattedValue = '-';
                else if (typeof format === 'string') formattedValue = this.formatWithPattern(formattedValue);
                else if (typeof format === 'function') formattedValue = format(formattedValue);
                else formattedValue = this.formatAsNumber(formattedValue);
                return formattedValue;
            }
        },
        {
            key: "formatValueProp",
            value: function formatValueProp(defaultValue) {
                var _this$props8 = this.props, format = _this$props8.format, decimalScale = _this$props8.decimalScale, fixedDecimalScale = _this$props8.fixedDecimalScale, allowEmptyFormatting = _this$props8.allowEmptyFormatting;
                var _this$props9 = this.props, _this$props9$value = _this$props9.value, value = _this$props9$value === void 0 ? defaultValue : _this$props9$value, isNumericString = _this$props9.isNumericString;
                var isNonNumericFalsy = !value && value !== 0;
                if (isNonNumericFalsy && allowEmptyFormatting) value = '';
                 // if value is not defined return empty string
                if (isNonNumericFalsy && !allowEmptyFormatting) return '';
                if (typeof value === 'number') {
                    value = value.toString();
                    isNumericString = true;
                } //change infinity value to empty string
                if (value === 'Infinity' && isNumericString) value = '';
                 //round the number based on decimalScale
                //format only if non formatted value is provided
                if (isNumericString && !format && typeof decimalScale === 'number') value = $1722b077bf42693a$var$roundToPrecision(value, decimalScale, fixedDecimalScale);
                var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
                return formattedValue;
            }
        },
        {
            key: "formatNegation",
            value: function formatNegation() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var allowNegative = this.props.allowNegative;
                var negationRegex = new RegExp('(-)');
                var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value
                var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values
                var removeNegation = doubleNegationRegex.test(value); //remove negation
                value = value.replace(/-/g, '');
                if (hasNegation && !removeNegation && allowNegative) value = '-' + value;
                return value;
            }
        },
        {
            key: "formatInput",
            value: function formatInput() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var format = this.props.format; //format negation only if we are formatting as number
                if (!format) {
                    value = this.removePrefixAndSuffix(value);
                    value = this.formatNegation(value);
                } //remove formatting from number
                value = this.removeFormatting(value);
                return this.formatNumString(value);
            }
        },
        {
            key: "isCharacterAFormat",
            value: function isCharacterAFormat(caretPos, value) {
                var _this$props10 = this.props, format = _this$props10.format, prefix = _this$props10.prefix, suffix = _this$props10.suffix, decimalScale = _this$props10.decimalScale, fixedDecimalScale = _this$props10.fixedDecimalScale;
                var _this$getSeparators5 = this.getSeparators(), decimalSeparator = _this$getSeparators5.decimalSeparator; //check within format pattern
                if (typeof format === 'string' && format[caretPos] !== '#') return true; //check in number format
                if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) return true;
                return false;
            }
        },
        {
            key: "checkIfFormatGotDeleted",
            value: function checkIfFormatGotDeleted(start, end, value) {
                for(var i = start; i < end; i++){
                    if (this.isCharacterAFormat(i, value)) return true;
                }
                return false;
            }
        },
        {
            key: "correctInputValue",
            value: function correctInputValue(caretPos, lastValue, value) {
                var _this$props11 = this.props, format = _this$props11.format, allowNegative = _this$props11.allowNegative, prefix = _this$props11.prefix, suffix = _this$props11.suffix, decimalScale = _this$props11.decimalScale;
                var _this$getSeparators6 = this.getSeparators(), allowedDecimalSeparators = _this$getSeparators6.allowedDecimalSeparators, decimalSeparator = _this$getSeparators6.decimalSeparator;
                var lastNumStr = this.state.numAsString || '';
                var _this$selectionBefore = this.selectionBeforeInput, selectionStart = _this$selectionBefore.selectionStart, selectionEnd = _this$selectionBefore.selectionEnd;
                var _findChangedIndex = $1722b077bf42693a$var$findChangedIndex(lastValue, value), start = _findChangedIndex.start, end = _findChangedIndex.end;
                /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (!format && start === end && allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1) {
                    var separator = decimalScale === 0 ? '' : decimalSeparator;
                    return value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length);
                }
                /* don't do anyhting if something got added,
       or if value is empty string (when whole input is cleared)
       or whole input is replace with a number
      */ var leftBound = !!format ? 0 : prefix.length;
                var rightBound = lastValue.length - (!!format ? 0 : suffix.length);
                if (value.length > lastValue.length || !value.length || start === end || selectionStart === 0 && selectionEnd === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) return value;
                 //if format got deleted reset the value to last value
                if (this.checkIfFormatGotDeleted(start, end, lastValue)) value = lastValue;
                 //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
                //clear all numbers in such case while keeping the - sign
                if (!format) {
                    var numericString = this.removeFormatting(value);
                    var _splitDecimal2 = $1722b077bf42693a$var$splitDecimal(numericString, allowNegative), beforeDecimal = _splitDecimal2.beforeDecimal, afterDecimal = _splitDecimal2.afterDecimal, addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
                    //clear only if something got deleted
                    var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
                    if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) return addNegation ? '-' : '';
                }
                return value;
            }
        },
        {
            key: "updateValue",
            value: function updateValue(params) {
                var formattedValue = params.formattedValue, input = params.input, _params$setCaretPosit = params.setCaretPosition, setCaretPosition = _params$setCaretPosit === void 0 ? true : _params$setCaretPosit;
                var numAsString = params.numAsString, caretPos = params.caretPos;
                var onValueChange = this.props.onValueChange;
                var lastValue = this.state.value;
                if (input) {
                    //set caret position, and value imperatively when element is provided
                    if (setCaretPosition) {
                        //calculate caret position if not defined
                        if (!caretPos) {
                            var inputValue = params.inputValue || input.value;
                            var currentCaretPosition = $1722b077bf42693a$var$getCurrentCaretPosition(input);
                            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */ input.value = formattedValue; //get the caret position
                            caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
                        } //set caret position
                        this.setPatchedCaretPosition(input, caretPos, formattedValue);
                    } else /**
           * if we are not setting caret position set the value imperatively.
           * This is required on onBlur method
           */ input.value = formattedValue;
                } //calculate numeric string if not passed
                if (numAsString === undefined) numAsString = this.removeFormatting(formattedValue);
                 //update state if value is changed
                if (formattedValue !== lastValue) {
                    this.setState({
                        value: formattedValue,
                        numAsString: numAsString
                    }); // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
                    onValueChange(this.getValueObject(formattedValue, numAsString));
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(e) {
                var el = e.target;
                var inputValue = el.value;
                var state = this.state, props = this.props;
                var isAllowed = props.isAllowed;
                var lastValue = state.value || '';
                var currentCaretPosition = $1722b077bf42693a$var$getCurrentCaretPosition(el);
                inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
                var formattedValue = this.formatInput(inputValue) || '';
                var numAsString = this.removeFormatting(formattedValue);
                var valueObj = this.getValueObject(formattedValue, numAsString);
                if (!isAllowed(valueObj)) formattedValue = lastValue;
                this.updateValue({
                    formattedValue: formattedValue,
                    numAsString: numAsString,
                    inputValue: inputValue,
                    input: el
                });
                props.onChange(e);
            }
        },
        {
            key: "onBlur",
            value: function onBlur(e) {
                var props = this.props, state = this.state;
                var format = props.format, onBlur = props.onBlur, allowLeadingZeros = props.allowLeadingZeros;
                var numAsString = state.numAsString;
                var lastValue = state.value;
                this.focusedElm = null;
                if (this.focusTimeout) clearTimeout(this.focusTimeout);
                if (!format) {
                    // if the numAsString is not a valid number reset it to empty
                    if (isNaN(parseFloat(numAsString))) numAsString = '';
                    if (!allowLeadingZeros) numAsString = $1722b077bf42693a$var$fixLeadingZero(numAsString);
                    var formattedValue = this.formatNumString(numAsString); //change the state
                    if (formattedValue !== lastValue) {
                        // the event needs to be persisted because its properties can be accessed in an asynchronous way
                        this.updateValue({
                            formattedValue: formattedValue,
                            numAsString: numAsString,
                            input: e.target,
                            setCaretPosition: false
                        });
                        onBlur(e);
                        return;
                    }
                }
                onBlur(e);
            }
        },
        {
            key: "onKeyDown",
            value: function onKeyDown(e) {
                var el = e.target;
                var key = e.key;
                var selectionStart = el.selectionStart, selectionEnd = el.selectionEnd, _el$value = el.value, value = _el$value === void 0 ? '' : _el$value;
                var expectedCaretPosition;
                var _this$props12 = this.props, decimalScale = _this$props12.decimalScale, fixedDecimalScale = _this$props12.fixedDecimalScale, prefix = _this$props12.prefix, suffix = _this$props12.suffix, format = _this$props12.format, onKeyDown = _this$props12.onKeyDown;
                var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
                var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
                var negativeRegex = new RegExp('-');
                var isPatternFormat = typeof format === 'string';
                this.selectionBeforeInput = {
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                }; //Handle backspace and delete against non numerical/decimal characters or arrow keys
                if (key === 'ArrowLeft' || key === 'Backspace') expectedCaretPosition = selectionStart - 1;
                else if (key === 'ArrowRight') expectedCaretPosition = selectionStart + 1;
                else if (key === 'Delete') expectedCaretPosition = selectionStart;
                 //if expectedCaretPosition is not set it means we don't want to Handle keyDown
                //also if multiple characters are selected don't handle
                if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
                    onKeyDown(e);
                    return;
                }
                var newCaretPosition = expectedCaretPosition;
                var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
                var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;
                if (key === 'ArrowLeft' || key === 'ArrowRight') {
                    var direction = key === 'ArrowLeft' ? 'left' : 'right';
                    newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
                } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) while(!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound)newCaretPosition++;
                else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
                    /* NOTE: This is special case when backspace is pressed on a
        negative value while the cursor position is after prefix. We can't handle it on onChange because
        we will not have any information of keyPress
        */ if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
                        var newValue = value.substring(1);
                        this.updateValue({
                            formattedValue: newValue,
                            caretPos: newCaretPosition,
                            input: el
                        });
                    } else if (!negativeRegex.test(value[expectedCaretPosition])) {
                        while(!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound)newCaretPosition--;
                        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
                    }
                }
                if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
                    e.preventDefault();
                    this.setPatchedCaretPosition(el, newCaretPosition, value);
                }
                /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
              Remove this when you find different solution */ if (e.isUnitTestRun) this.setPatchedCaretPosition(el, newCaretPosition, value);
                onKeyDown(e);
            }
        },
        {
            key: "onMouseUp",
            value: function onMouseUp(e) {
                var el = e.target;
                /**
       * NOTE: we have to give default value for value as in case when custom input is provided
       * value can come as undefined when nothing is provided on value prop.
      */ var selectionStart = el.selectionStart, selectionEnd = el.selectionEnd, _el$value2 = el.value, value = _el$value2 === void 0 ? '' : _el$value2;
                if (selectionStart === selectionEnd) {
                    var caretPosition = this.correctCaretPosition(value, selectionStart);
                    if (caretPosition !== selectionStart) this.setPatchedCaretPosition(el, caretPosition, value);
                }
                this.props.onMouseUp(e);
            }
        },
        {
            key: "onFocus",
            value: function onFocus(e) {
                var _this2 = this;
                // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
                // (onFocus event target selectionStart is always 0 before setTimeout)
                e.persist();
                this.focusedElm = e.target;
                this.focusTimeout = setTimeout(function() {
                    var el = e.target;
                    var selectionStart = el.selectionStart, selectionEnd = el.selectionEnd, _el$value3 = el.value, value = _el$value3 === void 0 ? '' : _el$value3;
                    var caretPosition = _this2.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
                    if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) _this2.setPatchedCaretPosition(el, caretPosition, value);
                    _this2.props.onFocus(e);
                }, 0);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props13 = this.props, type = _this$props13.type, displayType = _this$props13.displayType, customInput = _this$props13.customInput, renderText = _this$props13.renderText, getInputRef = _this$props13.getInputRef;
                var value = this.state.value;
                var otherProps = $1722b077bf42693a$var$omit(this.props, $1722b077bf42693a$var$propTypes$1);
                var inputProps = $1722b077bf42693a$var$_extends({
                    inputMode: 'numeric'
                }, otherProps, {
                    type: type,
                    value: value,
                    onChange: this.onChange,
                    onKeyDown: this.onKeyDown,
                    onMouseUp: this.onMouseUp,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur
                });
                if (displayType === 'text') return renderText ? renderText(value) || null : $1722b077bf42693a$var$React__default.createElement("span", $1722b077bf42693a$var$_extends({}, otherProps, {
                    ref: getInputRef
                }), value);
                else if (customInput) {
                    var CustomInput = customInput;
                    return $1722b077bf42693a$var$React__default.createElement(CustomInput, $1722b077bf42693a$var$_extends({}, inputProps, {
                        ref: getInputRef
                    }));
                }
                return $1722b077bf42693a$var$React__default.createElement("input", $1722b077bf42693a$var$_extends({}, inputProps, {
                    ref: getInputRef
                }));
            }
        }
    ]);
    return NumberFormat;
}($1722b077bf42693a$var$React__default.Component);
$1722b077bf42693a$var$NumberFormat.propTypes = $1722b077bf42693a$var$propTypes$1;
$1722b077bf42693a$var$NumberFormat.defaultProps = $1722b077bf42693a$var$defaultProps;
function $1722b077bf42693a$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: block;\n  border: none;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  padding: 12px 16px;\n  font-size: 16px;\n  box-sizing: border-box;\n  outline: none;\n  color: ",
        ";\n  transition: 0.4s;\n  &:empty {\n    + ",
        " {\n      width: 0;\n    }\n  }\n  &:focus,\n  &:not(:placeholder-shown) {\n    color: ",
        ";\n    + ",
        " {\n      width: 100%;\n      p {\n        transform-origin: right;\n        transform: scale(0.8);\n      }\n      /* The 0.5 is to fix a bug with overflow */\n    }\n  }\n"
    ]);
    $1722b077bf42693a$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $1722b077bf42693a$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  width: 100%;\n  display: block;\n  transition: 0.4s;\n  padding-left: 16px;\n  padding-right: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  line-height: 44px;\n  pointer-events: none;\n  user-select: none;\n  color: ",
        ";\n  z-index: 1;\n  white-space: nowrap;\n  text-align: right;\n  p {\n    display: inline-block;\n    transition: 0.4s;\n  }\n"
    ]);
    $1722b077bf42693a$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $1722b077bf42693a$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  position: relative;\n  border-radius: ",
        ";\n  padding: 1px;\n  :focus-within {\n    border: 2px solid ",
        ";\n    padding: 0;\n  }\n"
    ]);
    $1722b077bf42693a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1722b077bf42693a$var$Container = $1722b077bf42693a$var$styled__default.div($1722b077bf42693a$var$_templateObject(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.cta;
});
var $1722b077bf42693a$var$Label = $1722b077bf42693a$var$styled__default.label($1722b077bf42693a$var$_templateObject2(), function(props) {
    return props.theme.shade[20];
});
var $1722b077bf42693a$var$InnerInput = $1722b077bf42693a$var$styled__default($1722b077bf42693a$var$NumberFormat)($1722b077bf42693a$var$_templateObject3(), function(props) {
    return props.label == undefined ? props.theme.shade[0] : props.theme.shade[100];
}, $1722b077bf42693a$var$Label, function(props) {
    return props.theme.shade[0];
}, $1722b077bf42693a$var$Label);
function $1722b077bf42693a$var$FormatInput(props) {
    var _React$useState = $1722b077bf42693a$var$React__default.useState({
        labelWidth: 0
    }), _React$useState2 = $bbed19cb57db80bc$export$8f274c941f3300d0(_React$useState, 2), dimensions = _React$useState2[0], setDimensions = _React$useState2[1];
    var labelRef = $hAGkE.useRef(null);
    $hAGkE.useEffect(function() {
        setDimensions({
            labelWidth: labelRef.current.clientWidth
        });
    }, []);
    return /*#__PURE__*/ $1722b077bf42693a$var$React__default.createElement($1722b077bf42693a$var$Container, {
        disabled: props.disabled
    }, /*#__PURE__*/ $1722b077bf42693a$var$React__default.createElement($1722b077bf42693a$var$InnerInput, $bbed19cb57db80bc$export$c90d7ca213038c72({
        type: "text",
        id: props.id,
        disabled: props.disabled,
        placeholder: props.placeholder,
        value: props.value,
        formattedValue: props.formattedValue,
        floatValue: props.floatValue,
        onChange: props.onChange,
        onClick: props.onClick,
        labelOffset: dimensions.labelWidth
    }, props)), /*#__PURE__*/ $1722b077bf42693a$var$React__default.createElement($1722b077bf42693a$var$Label, {
        "for": props.id,
        disabled: props.disabled
    }, /*#__PURE__*/ $1722b077bf42693a$var$React__default.createElement("p", {
        ref: labelRef
    }, props.label)));
}
$1722b077bf42693a$var$FormatInput.PropTypes = {
    placeholder: $837e86388abc9533$export$e0c95a451cd220b7.string
};
$1722b077bf42693a$exports["default"] = $1722b077bf42693a$var$FormatInput;


var $26d660a69ddcb7bc$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($26d660a69ddcb7bc$exports, '__esModule', {
    value: true
});
function $26d660a69ddcb7bc$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $26d660a69ddcb7bc$var$styled__default = $26d660a69ddcb7bc$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $26d660a69ddcb7bc$var$React__default = $26d660a69ddcb7bc$var$_interopDefault($hAGkE);


function $26d660a69ddcb7bc$var$_templateObject5() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  &:checked {\n    + ",
        " {\n      ",
        " {\n        background: ",
        ";\n        &:after {\n          transform: scale(1);\n        }\n      }\n    }\n  }\n"
    ]);
    $26d660a69ddcb7bc$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $26d660a69ddcb7bc$var$_templateObject4() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  width: 24px;\n  height: 24px;\n  background: ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";;\n  margin-right: 16px;\n  border-radius: 4px;\n  position: relative;\n  transition: 0.2s;\n  flex-shrink: 0;\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 12px;\n    height: 12px;\n    transform: scale(0) rotate(45deg);\n    transform-origin: center;\n    transition: 0.2s;\n    background-image: url(\"",
        "\");\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n"
    ]);
    $26d660a69ddcb7bc$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $26d660a69ddcb7bc$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: flex;\n  position: relative;\n  padding: 16px;\n  align-items: flex-start;\n  transition: 0.2s;\n  cursor: pointer;\n  color: ",
        ";\n"
    ]);
    $26d660a69ddcb7bc$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $26d660a69ddcb7bc$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  font-family: \"Inter\", sans-serif;\n"
    ]);
    $26d660a69ddcb7bc$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $26d660a69ddcb7bc$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: relative;\n"
    ]);
    $26d660a69ddcb7bc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $26d660a69ddcb7bc$var$Outer = $26d660a69ddcb7bc$var$styled__default.div($26d660a69ddcb7bc$var$_templateObject());
var $26d660a69ddcb7bc$var$Text = $26d660a69ddcb7bc$var$styled__default.div($26d660a69ddcb7bc$var$_templateObject2());
var $26d660a69ddcb7bc$var$Container = $26d660a69ddcb7bc$var$styled__default.label($26d660a69ddcb7bc$var$_templateObject3(), function(props) {
    return props.theme.shade[0];
});
var $26d660a69ddcb7bc$var$Checkmark = $26d660a69ddcb7bc$var$styled__default.span($26d660a69ddcb7bc$var$_templateObject4(), function(props) {
    return props.theme.shade[80];
}, function(props) {
    return props.theme.shade[60];
}, $9904a760b970af47$export$60bffc6e2a50e7f9);
var $26d660a69ddcb7bc$var$Input = $26d660a69ddcb7bc$var$styled__default.input($26d660a69ddcb7bc$var$_templateObject5(), $26d660a69ddcb7bc$var$Container, $26d660a69ddcb7bc$var$Checkmark, function(props) {
    return props.theme.tertiary;
});
function $26d660a69ddcb7bc$var$InlineCheck(props) {
    return /*#__PURE__*/ $26d660a69ddcb7bc$var$React__default.createElement($26d660a69ddcb7bc$var$Outer, null, /*#__PURE__*/ $26d660a69ddcb7bc$var$React__default.createElement($26d660a69ddcb7bc$var$Input, {
        type: "checkbox",
        id: props.id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        checked: props.checked
    }), /*#__PURE__*/ $26d660a69ddcb7bc$var$React__default.createElement($26d660a69ddcb7bc$var$Container, {
        id: "".concat(props.id, "-container"),
        htmlFor: props.id
    }, /*#__PURE__*/ $26d660a69ddcb7bc$var$React__default.createElement($26d660a69ddcb7bc$var$Checkmark, {
        id: "".concat(props.id, "-checkmark")
    }), /*#__PURE__*/ $26d660a69ddcb7bc$var$React__default.createElement($26d660a69ddcb7bc$var$Text, {
        id: "".concat(props.id, "-label")
    }, props.children)));
}
$26d660a69ddcb7bc$exports["default"] = $26d660a69ddcb7bc$var$InlineCheck;



var $abf6dfc02b035944$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($abf6dfc02b035944$exports, '__esModule', {
    value: true
});
function $abf6dfc02b035944$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $abf6dfc02b035944$var$styled__default = $abf6dfc02b035944$var$_interopDefault($62d655c53090e8a3$exports);
$abf6dfc02b035944$exports["default"] = $62d655c53090e8a3$exports.ThemeProvider;


var $d99e11b6f4d5f775$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($d99e11b6f4d5f775$exports, '__esModule', {
    value: true
});
function $d99e11b6f4d5f775$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $d99e11b6f4d5f775$var$styled__default = $d99e11b6f4d5f775$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $d99e11b6f4d5f775$var$React__default = $d99e11b6f4d5f775$var$_interopDefault($hAGkE);
var $d99e11b6f4d5f775$var$img = "data:image/svg+xml,%3csvg width='57' height='36' viewBox='0 0 57 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.56037 10H2.44105V7.34375H4.03196C5.72585 7.34375 6.48935 6.31392 6.48935 5.02841C6.48935 3.7429 5.72585 2.72727 4.01776 2.72727H1.56037V10ZM2.44105 6.5625V3.50852H3.98935C5.17188 3.50852 5.62287 4.15483 5.62287 5.02841C5.62287 5.90199 5.17188 6.5625 4.00355 6.5625H2.44105ZM9.9517 10.1136C11.429 10.1136 12.4233 8.99148 12.4233 7.30114C12.4233 5.59659 11.429 4.47443 9.9517 4.47443C8.47443 4.47443 7.48011 5.59659 7.48011 7.30114C7.48011 8.99148 8.47443 10.1136 9.9517 10.1136ZM9.9517 9.3608C8.82955 9.3608 8.31818 8.39489 8.31818 7.30114C8.31818 6.20739 8.82955 5.22727 9.9517 5.22727C11.0739 5.22727 11.5852 6.20739 11.5852 7.30114C11.5852 8.39489 11.0739 9.3608 9.9517 9.3608ZM14.7528 10H15.5767L16.7699 5.80966H16.8551L18.0483 10H18.8722L20.5341 4.54545H19.6534L18.4744 8.70739H18.4176L17.267 4.54545H16.3722L15.2074 8.72159H15.1506L13.9716 4.54545H13.0909L14.7528 10ZM23.7434 10.1136C24.8514 10.1136 25.661 9.55966 25.9167 8.7358L25.1071 8.50852C24.894 9.0767 24.4004 9.3608 23.7434 9.3608C22.7598 9.3608 22.0815 8.72514 22.0424 7.55682H26.002V7.2017C26.002 5.17045 24.7946 4.47443 23.6582 4.47443C22.1809 4.47443 21.2008 5.6392 21.2008 7.31534C21.2008 8.99148 22.1667 10.1136 23.7434 10.1136ZM22.0424 6.83239C22.0993 5.98366 22.6994 5.22727 23.6582 5.22727C24.5673 5.22727 25.1497 5.90909 25.1497 6.83239H22.0424ZM27.2768 10H28.1149V6.5483C28.1149 5.80966 28.6973 5.26989 29.4927 5.26989C29.7164 5.26989 29.9473 5.3125 30.0041 5.3267V4.47443C29.9082 4.46733 29.688 4.46023 29.5637 4.46023C28.9103 4.46023 28.3422 4.82955 28.1433 5.36932H28.0865V4.54545H27.2768V10ZM33.1184 10.1136C34.2264 10.1136 35.036 9.55966 35.2917 8.7358L34.4821 8.50852C34.269 9.0767 33.7754 9.3608 33.1184 9.3608C32.1348 9.3608 31.4565 8.72514 31.4174 7.55682H35.377V7.2017C35.377 5.17045 34.1696 4.47443 33.0332 4.47443C31.5559 4.47443 30.5758 5.6392 30.5758 7.31534C30.5758 8.99148 31.5417 10.1136 33.1184 10.1136ZM31.4174 6.83239C31.4743 5.98366 32.0744 5.22727 33.0332 5.22727C33.9423 5.22727 34.5247 5.90909 34.5247 6.83239H31.4174ZM38.7115 10.1136C39.7626 10.1136 40.1177 9.46023 40.3024 9.16193H40.4018V10H41.2115V2.72727H40.3734V5.41193H40.3024C40.1177 5.12784 39.791 4.47443 38.7257 4.47443C37.3478 4.47443 36.3961 5.56818 36.3961 7.28693C36.3961 9.01989 37.3478 10.1136 38.7115 10.1136ZM38.8251 9.3608C37.774 9.3608 37.2342 8.4375 37.2342 7.27273C37.2342 6.12216 37.7598 5.22727 38.8251 5.22727C39.8478 5.22727 40.3876 6.05114 40.3876 7.27273C40.3876 8.50852 39.8336 9.3608 38.8251 9.3608ZM45.7889 10H46.5985V9.16193H46.698C46.8826 9.46023 47.2377 10.1136 48.2889 10.1136C49.6525 10.1136 50.6042 9.01989 50.6042 7.28693C50.6042 5.56818 49.6525 4.47443 48.2747 4.47443C47.2093 4.47443 46.8826 5.12784 46.698 5.41193H46.627V2.72727H45.7889V10ZM46.6127 7.27273C46.6127 6.05114 47.1525 5.22727 48.1752 5.22727C49.2406 5.22727 49.7662 6.12216 49.7662 7.27273C49.7662 8.4375 49.2264 9.3608 48.1752 9.3608C47.1667 9.3608 46.6127 8.50852 46.6127 7.27273ZM52.2306 12.0312C52.987 12.0312 53.5233 11.63 53.8358 10.7955L56.1582 4.55966L55.242 4.54545L53.7363 8.89205H53.6795L52.1738 4.54545H51.2647L53.2818 10.0284L53.1255 10.4545C52.8272 11.2713 52.4437 11.3494 51.8329 11.1932L51.6199 11.9318C51.7051 11.9744 51.9466 12.0312 52.2306 12.0312Z' fill='%239ea7b2'/%3e%3cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='18' width='22' height='18'%3e%3cpath d='M0 18H21.6232V36H0V18Z' fill='black'/%3e%3c/mask%3e%3cg mask='url(%23mask0)'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.8882 22.4831C11.2434 20.7941 9.89735 20.0162 8.73611 20.0971C6.11108 20.2821 4.49323 23.59 3.59818 26.3324C2.55445 29.5312 2.24591 32.7121 2.24261 32.7439L2.14431 33.5887L-0.000366211 33.5937L0.0977291 32.5539C0.110946 32.415 0.431253 29.1143 1.54458 25.7028C3.13868 20.8182 5.50557 18.2313 8.57978 18.0147C10.5508 17.8768 12.1637 18.712 13.2489 20.4322C13.4507 20.7521 13.6301 21.0992 13.7879 21.4684C14.6953 21.1134 15.6356 21.026 16.5742 21.23C19.6885 21.9064 21.6229 25.5683 21.6229 30.7868V32.1363H19.469V30.7868C19.469 27.4078 18.4281 23.7724 16.1034 23.2675C15.5551 23.1484 14.9826 23.2293 14.4108 23.4901C15.2182 27.3147 14.5066 32.1762 13.2134 34.2415C12.5085 35.367 11.4225 36 10.3509 36C9.92874 36 9.5091 35.9019 9.11569 35.6969C7.37 34.7872 6.43531 31.9035 9.04692 26.538C9.68133 25.2346 11.0369 23.1912 11.8882 22.4831ZM12.4713 24.9835L12.4647 24.9294C12.1632 25.3755 11.2605 26.8835 10.9949 27.429C8.97769 31.5737 9.54479 33.55 10.1354 33.8577C10.4784 34.0373 11.0102 33.736 11.372 33.1583C12.3007 31.6748 12.841 28.1061 12.4889 25.0738C12.4891 25.0732 12.4713 24.9835 12.4713 24.9835Z' fill='black'/%3e%3c/g%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M24.5441 23.5218H26.3081L26.355 24.324C26.4486 24.2231 26.5553 24.1148 26.6751 23.9985C26.7945 23.8828 26.9405 23.7791 27.1121 23.6884C27.2839 23.5975 27.4814 23.5218 27.7054 23.4614C27.9291 23.4009 28.1866 23.3707 28.4782 23.3707C29.4461 23.3707 30.1799 23.7136 30.6793 24.3996C31.0539 24.0265 31.4366 23.7616 31.8271 23.6051C32.217 23.4489 32.6721 23.3707 33.1928 23.3707C34.119 23.3707 34.8294 23.6353 35.3238 24.165C35.818 24.6947 36.0654 25.4086 36.0654 26.3065V30.6196H34.2231V26.3215C34.2231 25.8674 34.1062 25.5171 33.8718 25.2697C33.6376 25.0226 33.3177 24.8989 32.9119 24.8989C32.662 24.8989 32.433 24.947 32.2248 25.0429C32.0167 25.1387 31.837 25.2725 31.6864 25.4438C31.5355 25.6154 31.4209 25.8146 31.343 26.0414C31.2647 26.2686 31.2257 26.5133 31.2257 26.7755V30.6196H29.3836V26.3215C29.3836 25.8674 29.2665 25.5171 29.0323 25.2697C28.7983 25.0226 28.4782 24.8989 28.0722 24.8989C27.8225 24.8989 27.5935 24.947 27.3853 25.0429C27.1772 25.1387 26.9975 25.2725 26.8467 25.4438C26.6958 25.6154 26.5814 25.8146 26.5033 26.0414C26.4252 26.2686 26.3862 26.5133 26.3862 26.7755V30.6196H24.5441V23.5218Z' fill='black'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M41.0455 29.3179C41.399 29.3179 41.7063 29.2498 41.9665 29.1135C42.2265 28.9775 42.4428 28.7984 42.6144 28.5766C42.7862 28.3546 42.9134 28.1125 42.9968 27.8499C43.0803 27.5876 43.1218 27.3256 43.1218 27.0631C43.1218 26.8111 43.0803 26.551 42.9968 26.2838C42.9134 26.0165 42.7862 25.7743 42.6144 25.5573C42.4428 25.3405 42.2265 25.1639 41.9665 25.0276C41.7063 24.8915 41.399 24.8234 41.0455 24.8234C40.6915 24.8234 40.3844 24.8915 40.1244 25.0276C39.864 25.1639 39.6482 25.3405 39.4766 25.5573C39.3047 25.7743 39.1771 26.0165 39.0941 26.2838C39.0105 26.551 38.9692 26.8111 38.9692 27.0631C38.9692 27.3256 39.0105 27.5876 39.0941 27.8499C39.1771 28.1125 39.3047 28.3546 39.4766 28.5766C39.6482 28.7984 39.864 28.9775 40.1244 29.1135C40.3844 29.2498 40.6915 29.3179 41.0455 29.3179ZM37.1113 27.0631C37.1113 26.5486 37.2074 26.062 37.4002 25.6027C37.5925 25.1437 37.8606 24.7427 38.204 24.3996C38.5477 24.0567 38.9613 23.7844 39.4452 23.5824C39.9292 23.3808 40.4625 23.2797 41.0455 23.2797C41.6283 23.2797 42.1617 23.3808 42.6458 23.5824C43.1298 23.7844 43.5433 24.0567 43.8867 24.3996C44.2304 24.7427 44.498 25.1437 44.6907 25.6027C44.8832 26.062 44.9796 26.5486 44.9796 27.0631C44.9796 27.5778 44.8832 28.0645 44.6907 28.5233C44.498 28.9825 44.2304 29.3859 43.8867 29.7341C43.5433 30.082 43.1298 30.3573 42.6458 30.5588C42.1617 30.7606 41.6283 30.8615 41.0455 30.8615C40.4625 30.8615 39.9292 30.7606 39.4452 30.5588C38.9613 30.3573 38.5477 30.082 38.204 29.7341C37.8606 29.3859 37.5925 28.9825 37.4002 28.5233C37.2074 28.0645 37.1113 27.5778 37.1113 27.0631Z' fill='black'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M44.4795 31.8756C44.5733 31.9258 44.6881 31.9789 44.8232 32.0345C44.9584 32.0896 45.1251 32.1176 45.3225 32.1176C45.5619 32.1176 45.7572 32.0215 45.9082 31.8302C46.0587 31.6384 46.1345 31.3557 46.1345 30.9825V23.5219H47.9767V30.6346C47.9767 30.9876 47.9478 31.3407 47.891 31.694C47.8335 32.047 47.7191 32.3699 47.5473 32.6623C47.3757 32.955 47.1337 33.192 46.8214 33.3736C46.5092 33.5554 46.0928 33.6461 45.5724 33.6461C45.1354 33.6461 44.774 33.583 44.4876 33.4569C44.2013 33.3308 43.9698 33.2073 43.7928 33.0861L44.4795 31.8756Z' fill='black'/%3e%3cmask id='mask1' mask-type='alpha' maskUnits='userSpaceOnUse' x='49' y='23' width='8' height='8'%3e%3cpath d='M49.1318 23.2797H57V30.8615H49.1318V23.2797Z' fill='black'/%3e%3c/mask%3e%3cg mask='url(%23mask1)'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M53.066 29.3179C53.4195 29.3179 53.7266 29.2498 53.987 29.1135C54.247 28.9775 54.4633 28.7984 54.6349 28.5766C54.8067 28.3546 54.9339 28.1125 55.0174 27.8499C55.1006 27.5876 55.1423 27.3256 55.1423 27.0631C55.1423 26.8111 55.1006 26.551 55.0174 26.2838C54.9339 26.0165 54.8067 25.7743 54.6349 25.5573C54.4633 25.3405 54.247 25.1639 53.987 25.0276C53.7266 24.8915 53.4195 24.8234 53.066 24.8234C52.7118 24.8234 52.4049 24.8915 52.1449 25.0276C51.8845 25.1639 51.6687 25.3405 51.4971 25.5573C51.325 25.7743 51.1976 26.0165 51.1144 26.2838C51.031 26.551 50.9897 26.8111 50.9897 27.0631C50.9897 27.3256 51.031 27.5876 51.1144 27.8499C51.1976 28.1125 51.325 28.3546 51.4971 28.5766C51.6687 28.7984 51.8845 28.9775 52.1449 29.1135C52.4049 29.2498 52.7118 29.3179 53.066 29.3179ZM49.1318 27.0631C49.1318 26.5486 49.2279 26.062 49.4208 25.6027C49.613 25.1437 49.8811 24.7427 50.2245 24.3996C50.5682 24.0567 50.9818 23.7844 51.4657 23.5824C51.9498 23.3808 52.483 23.2797 53.066 23.2797C53.6488 23.2797 54.1822 23.3808 54.6663 23.5824C55.1501 23.7844 55.5638 24.0567 55.9072 24.3996C56.2509 24.7427 56.5185 25.1437 56.7112 25.6027C56.9037 26.062 57.0001 26.5486 57.0001 27.0631C57.0001 27.5778 56.9037 28.0645 56.7112 28.5233C56.5185 28.9825 56.2509 29.3859 55.9072 29.7341C55.5638 30.082 55.1501 30.3573 54.6663 30.5588C54.1822 30.7606 53.6488 30.8615 53.066 30.8615C52.483 30.8615 51.9498 30.7606 51.4657 30.5588C50.9818 30.3573 50.5682 30.082 50.2245 29.7341C49.8811 29.3859 49.613 28.9825 49.4208 28.5233C49.2279 28.0645 49.1318 27.5778 49.1318 27.0631Z' fill='black'/%3e%3c/g%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M48.2085 21.4956C48.2085 22.126 47.6813 22.6371 47.031 22.6371C46.3804 22.6371 45.8534 22.126 45.8534 21.4956C45.8534 20.8652 46.3804 20.3539 47.031 20.3539C47.6813 20.3539 48.2085 20.8652 48.2085 21.4956Z' fill='black'/%3e%3c/svg%3e";
function $d99e11b6f4d5f775$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  grid-area: powered;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  img {\n    margin-bottom: 0;\n  }\n"
    ]);
    $d99e11b6f4d5f775$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $d99e11b6f4d5f775$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  grid-area: logo;\n  width: 100%;\n  margin-bottom: 0;\n"
    ]);
    $d99e11b6f4d5f775$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $d99e11b6f4d5f775$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: grid;\n  grid-template-columns: minmax(auto, 120px) auto minmax(auto, 120px);\n  padding: 0 32px;\n  grid-template-areas: \"logo spacer powered\";\n  background: ",
        ";\n  height: 64px;\n  width: 100%;\n  align-items: center;\n  box-sizing: border-box;\n"
    ]);
    $d99e11b6f4d5f775$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d99e11b6f4d5f775$var$Nav = $d99e11b6f4d5f775$var$styled__default.nav($d99e11b6f4d5f775$var$_templateObject(), function(props) {
    return props.theme.shade[100];
});
var $d99e11b6f4d5f775$var$Logo = $d99e11b6f4d5f775$var$styled__default.img($d99e11b6f4d5f775$var$_templateObject2());
var $d99e11b6f4d5f775$var$PoweredBy = $d99e11b6f4d5f775$var$styled__default.div($d99e11b6f4d5f775$var$_templateObject3());
function $d99e11b6f4d5f775$var$OnboardingNav(props) {
    return /*#__PURE__*/ $d99e11b6f4d5f775$var$React__default.createElement($d99e11b6f4d5f775$var$Nav, null, /*#__PURE__*/ $d99e11b6f4d5f775$var$React__default.createElement($d99e11b6f4d5f775$var$Logo, {
        src: props.logo
    }), /*#__PURE__*/ $d99e11b6f4d5f775$var$React__default.createElement($d99e11b6f4d5f775$var$PoweredBy, null, /*#__PURE__*/ $d99e11b6f4d5f775$var$React__default.createElement("img", {
        src: $d99e11b6f4d5f775$var$img,
        alt: "Powered By Mojo"
    })));
}
$d99e11b6f4d5f775$exports["default"] = $d99e11b6f4d5f775$var$OnboardingNav;


var $fc9384b078e9685c$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($fc9384b078e9685c$exports, '__esModule', {
    value: true
});
function $fc9384b078e9685c$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $fc9384b078e9685c$var$styled__default = $fc9384b078e9685c$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $fc9384b078e9685c$var$React__default = $fc9384b078e9685c$var$_interopDefault($hAGkE);

function $fc9384b078e9685c$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  border: ",
        "\n    2px solid;\n  padding: 16px 24px;\n  border-radius: ",
        ";\n  font-size: 1rem;\n  color: ",
        ";\n  background: transparent;\n  cursor: pointer;\n  &:hover {\n    color: ",
        ";\n    border: ",
        "\n      2px solid;\n  }\n"
    ]);
    $fc9384b078e9685c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fc9384b078e9685c$var$Container = $fc9384b078e9685c$var$styled__default.button($fc9384b078e9685c$var$_templateObject(), function(props) {
    return props.disabled ? props.theme.cta + "80" : props.color ? props.color : props.theme.cta;
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.disabled ? props.theme.cta + "80" : props.color ? props.color : props.theme.cta;
}, function(props) {
    return props.disabled ? props.theme.cta + "80" : props.color ? $e038a8088f6f058c$export$4a587b3eb8320aaf(props.color, 25) : $e038a8088f6f058c$export$4a587b3eb8320aaf(props.theme.cta, 25);
}, function(props) {
    return props.disabled ? props.theme.cta + "80" : props.color ? $e038a8088f6f058c$export$4a587b3eb8320aaf(props.color, 25) : $e038a8088f6f058c$export$4a587b3eb8320aaf(props.theme.cta, 25);
});
function $fc9384b078e9685c$var$Button(props) {
    return /*#__PURE__*/ $fc9384b078e9685c$var$React__default.createElement($fc9384b078e9685c$var$Container, {
        className: props.className,
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        color: props.color
    }, props.children);
}
$fc9384b078e9685c$exports["default"] = $fc9384b078e9685c$var$Button;


var $59151198711fc588$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($59151198711fc588$exports, '__esModule', {
    value: true
});
function $59151198711fc588$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $59151198711fc588$var$styled__default = $59151198711fc588$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $59151198711fc588$var$React__default = $59151198711fc588$var$_interopDefault($hAGkE);
function $59151198711fc588$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: ",
        "%;\n  background: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  transition: width 0.8s cubic-bezier(0.1, 0.9, 0.9, 0.1);\n"
    ]);
    $59151198711fc588$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $59151198711fc588$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  width: 100%;\n  height: 4px;\n  background: ",
        ";\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n  &:before {\n  }\n"
    ]);
    $59151198711fc588$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $59151198711fc588$var$Bar = $59151198711fc588$var$styled__default.div($59151198711fc588$var$_templateObject(), function(props) {
    return props.theme.shade[90];
});
var $59151198711fc588$var$Meter = $59151198711fc588$var$styled__default.div($59151198711fc588$var$_templateObject2(), function(props) {
    return props.progress;
}, function(props) {
    return props.theme.primary;
}, function(props) {
    return props.theme.shade[100];
});
function $59151198711fc588$var$ProgressBar(props) {
    return /*#__PURE__*/ $59151198711fc588$var$React__default.createElement($59151198711fc588$var$Bar, null, /*#__PURE__*/ $59151198711fc588$var$React__default.createElement($59151198711fc588$var$Meter, {
        progress: props.progress
    }));
}
$59151198711fc588$exports["default"] = $59151198711fc588$var$ProgressBar;


var $93b051a40f5b8495$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($93b051a40f5b8495$exports, '__esModule', {
    value: true
});
function $93b051a40f5b8495$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $93b051a40f5b8495$var$styled__default = $93b051a40f5b8495$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $93b051a40f5b8495$var$React__default = $93b051a40f5b8495$var$_interopDefault($hAGkE);

function $93b051a40f5b8495$var$_templateObject5() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  width: 12px;\n  height: 12px;\n  transform: scale(0) rotate(45deg);\n  transform-origin: center;\n  transition: 0.2s;\n  background-image: url(",
        ");\n  background-position: center;\n  background-repeat: no-repeat;\n"
    ]);
    $93b051a40f5b8495$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $93b051a40f5b8495$var$_templateObject4() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n        border: 5px solid ",
        ";\n      "
    ]);
    $93b051a40f5b8495$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $93b051a40f5b8495$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n        border: 5px solid ",
        ";\n      "
    ]);
    $93b051a40f5b8495$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $93b051a40f5b8495$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n        background: ",
        ";\n        ",
        " {\n          opacity: 1;\n          transform: scale(1);\n        }\n      "
    ]);
    $93b051a40f5b8495$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $93b051a40f5b8495$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  width: 18px;\n  height: 18px;\n  border-radius: 18px;\n  position: relative;\n  transition: 0.2s;\n  box-sizing: border-box;\n    ",
        "\n    ",
        "\n    ",
        ";\n"
    ]);
    $93b051a40f5b8495$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $93b051a40f5b8495$var$Container = $93b051a40f5b8495$var$styled__default.div($93b051a40f5b8495$var$_templateObject(), function(props) {
    return props.status == "complete" && $62d655c53090e8a3$exports.css($93b051a40f5b8495$var$_templateObject2(), function(props) {
        return props.theme.primary;
    }, $93b051a40f5b8495$var$Indicator);
}, function(props) {
    return props.status == "active" && $62d655c53090e8a3$exports.css($93b051a40f5b8495$var$_templateObject3(), function(props) {
        return props.theme.primary;
    });
}, function(props) {
    return props.status == "incomplete" && $62d655c53090e8a3$exports.css($93b051a40f5b8495$var$_templateObject4(), function(props) {
        return props.theme.shade[70];
    });
});
var $93b051a40f5b8495$var$Indicator = $93b051a40f5b8495$var$styled__default.div($93b051a40f5b8495$var$_templateObject5(), $9904a760b970af47$export$60bffc6e2a50e7f9);
function $93b051a40f5b8495$var$ProgressIndicator(props) {
    return /*#__PURE__*/ $93b051a40f5b8495$var$React__default.createElement($93b051a40f5b8495$var$Container, {
        status: props.status
    }, /*#__PURE__*/ $93b051a40f5b8495$var$React__default.createElement($93b051a40f5b8495$var$Indicator, {
        status: props.status
    }));
}
$93b051a40f5b8495$exports["default"] = $93b051a40f5b8495$var$ProgressIndicator;


var $ed0de207f622e949$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($ed0de207f622e949$exports, '__esModule', {
    value: true
});
function $ed0de207f622e949$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $ed0de207f622e949$var$styled__default = $ed0de207f622e949$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $ed0de207f622e949$var$React__default = $ed0de207f622e949$var$_interopDefault($hAGkE);

function $ed0de207f622e949$var$_templateObject5() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  &:focus {\n    + ",
        " {\n      background: ",
        ";\n    }\n  }\n\n  &:checked {\n    + ",
        " {\n      background: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n      color: ",
        ";\n      font-weight: 500;\n      ",
        " {\n        background: ",
        ";\n        box-shadow: 0 0 0 2px ",
        ";\n        &:after {\n          transform: scale(1);\n        }\n      }\n    }\n    &:focus {\n      + ",
        " {\n        background: ",
        ";\n      }\n    }\n  }\n"
    ]);
    $ed0de207f622e949$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $ed0de207f622e949$var$_templateObject4() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  width: 24px;\n  height: 24px;\n  background: ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";\n  margin-right: 16px;\n  border-radius: 100%;\n  position: relative;\n  transition: 0.2s;\n  flex-shrink: 0;\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: ",
        ";\n    transform: scale(0);\n    transform-origin: center;\n    transition: 0.2s;\n  }\n"
    ]);
    $ed0de207f622e949$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $ed0de207f622e949$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: flex;\n  position: relative;\n  padding: 16px;\n  background: ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";\n  border-radius: ",
        ";\n  align-items: center;\n  transition: 0.2s;\n  cursor: pointer;\n  color: ",
        ";\n  height: 100%;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    $ed0de207f622e949$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $ed0de207f622e949$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n"
    ]);
    $ed0de207f622e949$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $ed0de207f622e949$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: relative;\n"
    ]);
    $ed0de207f622e949$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ed0de207f622e949$var$Outer = $ed0de207f622e949$var$styled__default.div($ed0de207f622e949$var$_templateObject());
var $ed0de207f622e949$var$Text = $ed0de207f622e949$var$styled__default.div($ed0de207f622e949$var$_templateObject2());
var $ed0de207f622e949$var$Container = $ed0de207f622e949$var$styled__default.label($ed0de207f622e949$var$_templateObject3(), function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.shade[10];
}, function(props) {
    return props.theme.shade[80];
});
var $ed0de207f622e949$var$Checkmark = $ed0de207f622e949$var$styled__default.span($ed0de207f622e949$var$_templateObject4(), function(props) {
    return props.theme.shade[80];
}, function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.theme.shade[100];
});
var $ed0de207f622e949$var$Input = $ed0de207f622e949$var$styled__default.input($ed0de207f622e949$var$_templateObject5(), $ed0de207f622e949$var$Container, function(props) {
    return props.theme.shade[70];
}, $ed0de207f622e949$var$Container, function(props) {
    return props.theme.tertiary;
}, function(props) {
    return props.theme.tertiary;
}, function(props) {
    return props.theme.shade[100];
}, $ed0de207f622e949$var$Checkmark, function(props) {
    return props.theme.tertiary;
}, function(props) {
    return props.theme.shade[100];
}, $ed0de207f622e949$var$Container, function(props) {
    return $e038a8088f6f058c$export$4a587b3eb8320aaf(props.theme.tertiary, 20);
});
function $ed0de207f622e949$var$RadioButton(props) {
    return /*#__PURE__*/ $ed0de207f622e949$var$React__default.createElement($ed0de207f622e949$var$Outer, null, /*#__PURE__*/ $ed0de207f622e949$var$React__default.createElement($ed0de207f622e949$var$Input, {
        type: "radio",
        id: props.id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick,
        checked: props.checked
    }), /*#__PURE__*/ $ed0de207f622e949$var$React__default.createElement($ed0de207f622e949$var$Container, {
        htmlFor: props.id,
        id: "lbl-".concat(props.id)
    }, /*#__PURE__*/ $ed0de207f622e949$var$React__default.createElement($ed0de207f622e949$var$Checkmark, null), /*#__PURE__*/ $ed0de207f622e949$var$React__default.createElement($ed0de207f622e949$var$Text, null, props.children)));
}
$ed0de207f622e949$exports["default"] = $ed0de207f622e949$var$RadioButton;


var $f813cb4ca48d6f66$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($f813cb4ca48d6f66$exports, '__esModule', {
    value: true
});
function $f813cb4ca48d6f66$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $f813cb4ca48d6f66$var$styled__default = $f813cb4ca48d6f66$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $f813cb4ca48d6f66$var$React__default = $f813cb4ca48d6f66$var$_interopDefault($hAGkE);
var $f813cb4ca48d6f66$var$img = "data:image/svg+xml,%3csvg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7.8489 11.5361L11.3817 5.86201C11.7965 5.1959 11.3175 4.33346 10.5328 4.33346L3.46717 4.33346C2.6825 4.33346 2.20353 5.1959 2.61827 5.86201L6.1511 11.5361C6.54248 12.1647 7.45752 12.1647 7.8489 11.5361Z' fill='%2361676E'/%3e%3c/svg%3e";
function $f813cb4ca48d6f66$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 13px 17px;\n  font-size: 16px;\n  box-sizing: border-box;\n  outline: none;\n  background-color: ",
        ";\n  background-image: url(\"",
        "\");\n  background-position: right 20px top calc(50% - 2px);\n  background-repeat: no-repeat;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 1px;\n  text-overflow: \"\";\n  &:focus {\n    padding: 12px 16px;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    $f813cb4ca48d6f66$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f813cb4ca48d6f66$var$Select = $f813cb4ca48d6f66$var$styled__default.select($f813cb4ca48d6f66$var$_templateObject(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.theme.shade[0];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, $f813cb4ca48d6f66$var$img, function(props) {
    return props.theme.cta;
});
function $f813cb4ca48d6f66$var$SelectInput(props) {
    return /*#__PURE__*/ $f813cb4ca48d6f66$var$React__default.createElement($f813cb4ca48d6f66$var$Select, $bbed19cb57db80bc$export$c90d7ca213038c72({
        id: props.id,
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onClick: props.onClick
    }, props), props.children);
}
$f813cb4ca48d6f66$exports["default"] = $f813cb4ca48d6f66$var$SelectInput;


var $66d2f0ea1eebf12a$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($66d2f0ea1eebf12a$exports, '__esModule', {
    value: true
});
function $66d2f0ea1eebf12a$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $66d2f0ea1eebf12a$var$styled__default = $66d2f0ea1eebf12a$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $66d2f0ea1eebf12a$var$React__default = $66d2f0ea1eebf12a$var$_interopDefault($hAGkE);
function $66d2f0ea1eebf12a$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  p {\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    $66d2f0ea1eebf12a$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $66d2f0ea1eebf12a$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  padding: 24px 32px 24px 32px;\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n"
    ]);
    $66d2f0ea1eebf12a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $66d2f0ea1eebf12a$var$Container = $66d2f0ea1eebf12a$var$styled__default.div($66d2f0ea1eebf12a$var$_templateObject(), function(props) {
    return props.theme.shade[80];
}, function(props) {
    return props.theme.radius.large;
}, function(props) {
    return props.theme.shade[0];
});
var $66d2f0ea1eebf12a$var$Content = $66d2f0ea1eebf12a$var$styled__default.div($66d2f0ea1eebf12a$var$_templateObject2());
function $66d2f0ea1eebf12a$var$Tooltip(props) {
    return /*#__PURE__*/ $66d2f0ea1eebf12a$var$React__default.createElement($66d2f0ea1eebf12a$var$Container, null, /*#__PURE__*/ $66d2f0ea1eebf12a$var$React__default.createElement($66d2f0ea1eebf12a$var$Content, null, props.children));
}
$66d2f0ea1eebf12a$exports["default"] = $66d2f0ea1eebf12a$var$Tooltip;


var $5bb9afc27231a888$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
Object.defineProperty($5bb9afc27231a888$exports, '__esModule', {
    value: true
});
function $5bb9afc27231a888$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5bb9afc27231a888$var$styled__default = $5bb9afc27231a888$var$_interopDefault($62d655c53090e8a3$exports);


var $hAGkE = parcelRequire("hAGkE");
var $5bb9afc27231a888$var$React__default = $5bb9afc27231a888$var$_interopDefault($hAGkE);

function $5bb9afc27231a888$var$_templateObject5() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n      color: ",
        ";\n    "
    ]);
    $5bb9afc27231a888$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $5bb9afc27231a888$var$_templateObject4() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  margin: 0;\n  ",
        "\n"
    ]);
    $5bb9afc27231a888$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $5bb9afc27231a888$var$_templateObject3() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n      background: ",
        ";\n      &:before,\n      &:after {\n        content: \"\";\n        width: 2px;\n        height: 9px;\n        position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n        margin: auto;\n        background: ",
        ";\n      }\n      &:before {\n        transform: rotate(45deg);\n      }\n      &:after {\n        transform: rotate(-45deg);\n      }\n    "
    ]);
    $5bb9afc27231a888$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $5bb9afc27231a888$var$_templateObject2() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  position: relative;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  ",
        "\n"
    ]);
    $5bb9afc27231a888$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $5bb9afc27231a888$var$_templateObject() {
    var data = $bbed19cb57db80bc$export$2a63e85cae65c7c7([
        "\n  display: grid;\n  grid-template-columns: 16px auto;\n  grid-gap: 8px;\n  align-items: center;\n"
    ]);
    $5bb9afc27231a888$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5bb9afc27231a888$var$Container = $5bb9afc27231a888$var$styled__default.div($5bb9afc27231a888$var$_templateObject());
var $5bb9afc27231a888$var$Icon = $5bb9afc27231a888$var$styled__default.div($5bb9afc27231a888$var$_templateObject2(), function(props) {
    return props.status == "error" && $62d655c53090e8a3$exports.css($5bb9afc27231a888$var$_templateObject3(), function(props) {
        return props.theme.error;
    }, function(props) {
        return props.theme.shade[100];
    });
});
var $5bb9afc27231a888$var$Text = $5bb9afc27231a888$var$styled__default.p($5bb9afc27231a888$var$_templateObject4(), function(props) {
    return props.status == "error" && $62d655c53090e8a3$exports.css($5bb9afc27231a888$var$_templateObject5(), function(props) {
        return props.theme.error;
    });
});
function $5bb9afc27231a888$var$Validation(props) {
    return /*#__PURE__*/ $5bb9afc27231a888$var$React__default.createElement($5bb9afc27231a888$var$Container, null, /*#__PURE__*/ $5bb9afc27231a888$var$React__default.createElement($5bb9afc27231a888$var$Icon, {
        status: props.status
    }), /*#__PURE__*/ $5bb9afc27231a888$var$React__default.createElement($5bb9afc27231a888$var$Text, {
        status: props.status
    }, props.children));
}
$5bb9afc27231a888$var$Validation.propTypes = {
    status: $837e86388abc9533$export$e0c95a451cd220b7.string
};
$5bb9afc27231a888$exports["default"] = $5bb9afc27231a888$var$Validation;






parcelRequire("hAGkE");

var $fcd58f40ae8be7dc$exports = {};
$fcd58f40ae8be7dc$exports = $parcel$resolve("jHwYO");


function $bed5580ec6db47f9$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    $bed5580ec6db47f9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $bed5580ec6db47f9$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 80px;\n  height: 26px;\n  margin-left: 16px;\n"
    ]);
    $bed5580ec6db47f9$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $bed5580ec6db47f9$var$ExperianSig = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($bed5580ec6db47f9$var$_templateObject());
var $bed5580ec6db47f9$var$ExperianCustom = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($bed5580ec6db47f9$var$_templateObject1());
function $bed5580ec6db47f9$export$b99182a6e5147c88() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($bed5580ec6db47f9$var$ExperianSig, {
        children: [
            "Eligibility check by",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($bed5580ec6db47f9$var$ExperianCustom, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($fcd58f40ae8be7dc$exports)))
            })
        ]
    });
}



var $8c6ug = parcelRequire("8c6ug");

var $1ca2cdaa0912b6ea$export$9768d224bb15a400 = 60;
var $1ca2cdaa0912b6ea$export$a941ed4b947d12f8 = 16;
var $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071 = "@media (max-width: 767px)";
var $1ca2cdaa0912b6ea$export$74c1bba07084d12b = "@media (min-width: 768px) and (max-width: 1023px)";
var $1ca2cdaa0912b6ea$export$4239d699c596afd = "@media (min-width: 1024px)";
var $1ca2cdaa0912b6ea$export$37f9892f86b4e685 = 24;
var $1ca2cdaa0912b6ea$export$d64d6fd6f0527437 = 40;
var $1ca2cdaa0912b6ea$export$8e0eba2c322344f3 = 104;
var $1ca2cdaa0912b6ea$export$29a79847e2ebd805 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var background = param.background;
    var _obj;
    return _obj = {
        display: "grid",
        gridTemplateRows: "[body] 1fr [footer]",
        minHeight: "calc(100vh - ".concat($1ca2cdaa0912b6ea$export$9768d224bb15a400, "px)"),
        background: background
    }, (0, $8c6ug._)(_obj, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071, {
        gridTemplateColumns: "[left] 1fr [content] minmax(256px, 703px) [right] 1fr"
    }), (0, $8c6ug._)(_obj, $1ca2cdaa0912b6ea$export$74c1bba07084d12b, {
        gridTemplateColumns: "[left] 1fr [content] minmax(688px, 943px) [right] 1fr"
    }), (0, $8c6ug._)(_obj, $1ca2cdaa0912b6ea$export$4239d699c596afd, {
        gridTemplateColumns: "[left] 1fr [content] minmax(816px, 1232px) [right] 1fr"
    }), _obj;
});
var $1ca2cdaa0912b6ea$var$_obj;
var $1ca2cdaa0912b6ea$export$db98531fba779596 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($1ca2cdaa0912b6ea$var$_obj = {
    display: "grid",
    gridColumnStart: 2,
    gridRowStart: 1,
    columnGap: $1ca2cdaa0912b6ea$export$a941ed4b947d12f8
}, (0, $8c6ug._)($1ca2cdaa0912b6ea$var$_obj, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071, {
    gridTemplateColumns: "repeat(3, 1fr)",
    padding: $1ca2cdaa0912b6ea$export$37f9892f86b4e685
}), (0, $8c6ug._)($1ca2cdaa0912b6ea$var$_obj, $1ca2cdaa0912b6ea$export$74c1bba07084d12b, {
    gridTemplateColumns: "repeat(6, 1fr)",
    padding: $1ca2cdaa0912b6ea$export$d64d6fd6f0527437
}), (0, $8c6ug._)($1ca2cdaa0912b6ea$var$_obj, $1ca2cdaa0912b6ea$export$4239d699c596afd, {
    gridTemplateColumns: "repeat(12, 1fr)",
    padding: "".concat($1ca2cdaa0912b6ea$export$8e0eba2c322344f3, "px ", 40, "px")
}), $1ca2cdaa0912b6ea$var$_obj));
var $1ca2cdaa0912b6ea$var$_obj1;
var $1ca2cdaa0912b6ea$export$9d2b4227a95687cc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($1ca2cdaa0912b6ea$var$_obj1 = {
    gridColumnStart: 1
}, (0, $8c6ug._)($1ca2cdaa0912b6ea$var$_obj1, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071, {
    gridColumnEnd: "span 3"
}), (0, $8c6ug._)($1ca2cdaa0912b6ea$var$_obj1, $1ca2cdaa0912b6ea$export$74c1bba07084d12b, {
    gridColumnEnd: "span 6"
}), (0, $8c6ug._)($1ca2cdaa0912b6ea$var$_obj1, $1ca2cdaa0912b6ea$export$4239d699c596afd, {
    gridColumnEnd: "span 8"
}), $1ca2cdaa0912b6ea$var$_obj1));
var $1ca2cdaa0912b6ea$export$34247eb21a462114 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(props) {
    return {
        backgroundColor: props.theme.footerBackground,
        gridColumnEnd: "span 3",
        gridColumnStart: 1,
        gridRowStart: 2
    };
});
var $1ca2cdaa0912b6ea$export$e031496191a50201 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(props) {
    return {
        height: props.x * $1ca2cdaa0912b6ea$export$a941ed4b947d12f8
    };
});



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


var $9744ffaea6c7854e$export$b797a92f6ef09007 = function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1ca2cdaa0912b6ea$export$34247eb21a462114), {}),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9744ffaea6c7854e$var$Footer, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9744ffaea6c7854e$var$FooterStrong, {
                        children: "Your home/property may be repossessed if you do not keep up repayments on your mortgage. You may have to pay a charge to exit an existing mortgage deal early. Think carefully before securing other debts against your property."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1ca2cdaa0912b6ea$export$e031496191a50201), {
                        x: 1
                    }),
                    theme.footerCopy ? theme.footerCopy.map(function(str, idx) {
                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9744ffaea6c7854e$var$FooterText, {
                            children: str
                        }, idx);
                    }) : $9744ffaea6c7854e$var$defaultFooterCopy(theme).map(function(str, idx) {
                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9744ffaea6c7854e$var$FooterText, {
                            children: str
                        }, idx);
                    })
                ]
            })
        ]
    });
};
// This can't go in DefaultTheme.ts, otherwise it'll get merged in at the beginning of the array.
var $9744ffaea6c7854e$var$defaultFooterCopy = function(theme) {
    var partner = theme.name === "Default" ? [] : [
        "".concat($9744ffaea6c7854e$var$capitalise(theme.name), " makes introductions to Mojo Mortgages to provide mortgage solutions.")
    ];
    return partner.concat([
        "Mojo Mortgages is a trading style of Life\u2019s Great Limited which is registered in England and Wales (06246376). Mojo are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215).",
        "Mojo\u2019s registered office is The Cooperage, 5 Copper Row, London, SE1 2LH. To contact Mojo by phone, please call 0333 123 0012."
    ]);
};
var $9744ffaea6c7854e$var$capitalise = function(s) {
    return s[0].toUpperCase() + s.slice(1);
};
var $9744ffaea6c7854e$var$_obj;
var $9744ffaea6c7854e$var$Footer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).footer(($9744ffaea6c7854e$var$_obj = {
    alignItems: "center",
    display: "grid",
    gap: "1rem",
    gridColumnStart: 2,
    gridRowStart: 2,
    padding: "4rem 0"
}, (0, $8c6ug._)($9744ffaea6c7854e$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "2rem"
}), (0, $8c6ug._)($9744ffaea6c7854e$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    padding: "3rem"
}), $9744ffaea6c7854e$var$_obj));
var $9744ffaea6c7854e$var$FooterStrong = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).strong(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        color: theme.footerText,
        fontSize: "0.875em",
        margin: 0
    }, (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
        textAlign: "center"
    }), (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
        textAlign: "left"
    }), (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        textAlign: "left",
        paddingLeft: 40
    }), _obj;
});
var $9744ffaea6c7854e$var$FooterText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        color: theme.footerText,
        fontSize: "0.875em",
        margin: 0
    }, (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
        textAlign: "center"
    }), (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
        textAlign: "left"
    }), (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        textAlign: "left",
        paddingLeft: 40
    }), _obj;
});



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


var $6825640ebefa1fff$var$_obj;
var $6825640ebefa1fff$export$5f1af8db9871e1d6 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($6825640ebefa1fff$var$_obj = {
    gridColumnStart: 1
}, (0, $8c6ug._)($6825640ebefa1fff$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    gridColumnEnd: "span 3"
}), (0, $8c6ug._)($6825640ebefa1fff$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    gridColumnEnd: "span 3"
}), (0, $8c6ug._)($6825640ebefa1fff$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gridColumnEnd: "span 6"
}), $6825640ebefa1fff$var$_obj));
var $6825640ebefa1fff$export$56c0d5a1e737357d = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontWeight: 500,
    margin: 0
});
var $6825640ebefa1fff$var$MojoPrivacyPolicyLink = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a(function(param) {
    var theme = param.theme;
    return {
        color: theme.primary
    };
});
var $6825640ebefa1fff$export$9ce5373cfda0847e = function(param) {
    var complianceText = param.complianceText;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("small", {
        children: [
            complianceText !== null && complianceText !== void 0 ? complianceText : "",
            " Read Mojo\u2019s",
            " ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($6825640ebefa1fff$var$MojoPrivacyPolicyLink, {
                href: $6825640ebefa1fff$var$mojoPrivacyPolicyUrl,
                target: "_blank",
                children: "privacy notice"
            }),
            " ",
            "and terms of",
            " ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($6825640ebefa1fff$var$MojoPrivacyPolicyLink, {
                href: $6825640ebefa1fff$var$advisoryServicesUrl,
                target: "_blank",
                children: "advisory services"
            }),
            " ",
            "for more information."
        ]
    });
};
var $6825640ebefa1fff$var$advisoryServicesUrl = "https://hosted-assets.mojomortgages.com/documents/Terms%20of%20our%20Advisory%20Services.pdf";
var $6825640ebefa1fff$var$mojoPrivacyPolicyUrl = "https://mojomortgages.com/privacy-policy";


function $caddf48704753d55$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: ",
        ";\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 0.5rem;\n"
    ]);
    $caddf48704753d55$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $caddf48704753d55$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  text-align: left;\n  margin-bottom: 0;\n\n  &:after {\n    border-left: ",
        " 2px solid;\n    border-bottom: ",
        ' 2px solid;\n    left: -30px;\n    top: 9px;\n    width: 8px;\n    height: 4px;\n    margin: auto;\n    position: absolute;\n    content: "";\n    transform: rotate(-45deg);\n  }\n\n  &:before {\n    background: ',
        ';\n    left: -34px;\n    top: 4px;\n    margin: auto;\n    position: absolute;\n    content: "";\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n  }\n'
    ]);
    $caddf48704753d55$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $caddf48704753d55$var$BoldLink = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($caddf48704753d55$var$_templateObject(), function(props) {
    return props.theme.primary;
});
var $caddf48704753d55$export$9bb7aa4ed561a393 = function(param) {
    var getStarted = param.getStarted, isRemo = param.isRemo, theme = param.theme;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8c4ce8c143193527$export$41d0d88a6b0e456f), {
                showPoweredBy: theme.showPoweredBy,
                logoVariant: theme.poweredByVariant
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $1ca2cdaa0912b6ea$export$29a79847e2ebd805), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $1ca2cdaa0912b6ea$export$db98531fba779596), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$Copy, {
                                getStarted: getStarted,
                                isRemo: isRemo,
                                theme: theme
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$Img, {
                                src: theme.illustrations.lander
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9744ffaea6c7854e$export$b797a92f6ef09007), {
                        theme: theme
                    })
                ]
            })
        ]
    });
};
var $caddf48704753d55$var$Copy = function(param) {
    var getStarted = param.getStarted, isRemo = param.isRemo, theme = param.theme;
    var _theme_landerCTA;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6825640ebefa1fff$export$5f1af8db9871e1d6), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($caddf48704753d55$var$WideStack, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h1", {
                    children: typeof theme.landerHeader === "function" && theme.landerHeader(isRemo) || theme.landerHeader
                }),
                theme.landerLeadText && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6825640ebefa1fff$export$56c0d5a1e737357d), {
                    children: theme.landerLeadText
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($caddf48704753d55$var$CustomList, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$CustomListItem, {
                            children: theme.landerBullet1
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$CustomListItem, {
                            children: theme.landerBullet2
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$CustomListItem, {
                            children: theme.landerBullet3
                        }),
                        theme.landerBullet4 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$CustomListItem, {
                            children: theme.landerBullet4
                        }),
                        theme.landerBullet5 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$CustomListItem, {
                            children: theme.landerBullet5
                        })
                    ]
                }),
                theme.landerSecondaryText && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6825640ebefa1fff$export$56c0d5a1e737357d), {
                    children: theme.landerSecondaryText
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$ButtonRow, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($83909883869ef5d9$exports))), {
                        onClick: getStarted,
                        color: theme === null || theme === void 0 ? void 0 : theme.primary,
                        id: "btn-get-started",
                        children: (_theme_landerCTA = theme.landerCTA) !== null && _theme_landerCTA !== void 0 ? _theme_landerCTA : "Get Started"
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($caddf48704753d55$var$BoldLink, {
                    href: "/login",
                    children: "Returning user? Log in here"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6825640ebefa1fff$export$9ce5373cfda0847e), {
                    complianceText: theme.landerComplianceText
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bed5580ec6db47f9$export$b99182a6e5147c88), {})
            ]
        })
    });
};
var $caddf48704753d55$var$WideStack = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "grid",
    gap: "2rem"
});
var $caddf48704753d55$var$CustomList = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul({
    listStyle: "none",
    display: "grid",
    gap: 24,
    margin: 0
});
var $caddf48704753d55$var$CustomListItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($caddf48704753d55$var$_templateObject1(), function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.primary;
});
var $caddf48704753d55$var$_obj;
var $caddf48704753d55$var$Img = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img(($caddf48704753d55$var$_obj = {
    maxWidth: "90%",
    alignSelf: "center"
}, (0, $8c6ug._)($caddf48704753d55$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    display: "none"
}), (0, $8c6ug._)($caddf48704753d55$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    gridColumnEnd: "span 3",
    gridColumnStart: 4
}), (0, $8c6ug._)($caddf48704753d55$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gridColumnEnd: "span 6",
    gridColumnStart: 7
}), $caddf48704753d55$var$_obj));
var $caddf48704753d55$var$_obj1;
var $caddf48704753d55$var$ButtonRow = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($caddf48704753d55$var$_obj1 = {}, (0, $8c6ug._)($caddf48704753d55$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    "& button": {
        width: "100%"
    }
}), (0, $8c6ug._)($caddf48704753d55$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    "& button": {
        width: "max-content"
    }
}), (0, $8c6ug._)($caddf48704753d55$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    "& button": {
        width: "max-content"
    }
}), $caddf48704753d55$var$_obj1));


var $3216fe7bc1e1c300$export$3ca1530a76305b39 = function() {
    if (location.hostname.endsWith("localhost")) {
        window.location.assign("http://".concat(location.hostname, ":3000/discovery") + location.search);
        return;
    }
    window.location.assign("/discovery" + location.search);
};


var $acea317de969142c$export$ed13bb07514c5437 = function() {
    var _useConfig = (0, $7e7d633c88171aa1$export$b3611e87cd5ba6ce)(), theme = _useConfig.theme, themeLoaded = _useConfig.isLoaded;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/get-started");
    var seedData = (0, $abdb2fb264b19dc5$export$b779055c9d482128)();
    var isRemo = (seedData === null || seedData === void 0 ? void 0 : seedData.mortgageType) === "remo";
    if (!themeLoaded) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$8dc49548733a6fce), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
            theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline,
            size: 80
        })
    });
    var getStarted = function() {
        (0, $3216fe7bc1e1c300$export$3ca1530a76305b39)();
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $caddf48704753d55$export$9bb7aa4ed561a393), {
        getStarted: getStarted,
        isRemo: isRemo,
        theme: theme
    });
};



var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");
function $e1144b754c96ee3b$var$e(e) {
    this.message = e;
}
$e1144b754c96ee3b$var$e.prototype = new Error, $e1144b754c96ee3b$var$e.prototype.name = "InvalidCharacterError";
var $e1144b754c96ee3b$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $e1144b754c96ee3b$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var _$n, _$o, a = 0, i = 0, c = ""; _$o = t.charAt(i++); ~_$o && (_$n = a % 4 ? 64 * _$n + _$o : _$o, a++ % 4) && (c += String.fromCharCode(255 & _$n >> (-2 * a & 6))))_$o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(_$o);
    return c;
};
function $e1144b754c96ee3b$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($e1144b754c96ee3b$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $e1144b754c96ee3b$var$r(t);
    }
}
function $e1144b754c96ee3b$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $e1144b754c96ee3b$var$o(e, r) {
    if ("string" != typeof e) throw new $e1144b754c96ee3b$export$b9721ef022f71a68("Invalid token specified");
    var _$o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($e1144b754c96ee3b$var$t(e.split(".")[_$o]));
    } catch (e) {
        throw new $e1144b754c96ee3b$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$e1144b754c96ee3b$export$b9721ef022f71a68.prototype = new Error, $e1144b754c96ee3b$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $e1144b754c96ee3b$export$2e2bcd8739ae039 = $e1144b754c96ee3b$var$o;


function $3f7593b3cb7ae70f$export$33120bfebc0e7c15(jwt) {
    return (0, $e1144b754c96ee3b$export$2e2bcd8739ae039)(jwt);
}


var $9bd1cc5e5a2d6a54$exports = {};
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    $9bd1cc5e5a2d6a54$exports = factory();
})($9bd1cc5e5a2d6a54$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function read(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function remove(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function withAttributes(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function withConverter(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});



var $cda636b84ca95de8$export$bead674655ff515d = function(key) {
    var _document_cookie_split_find;
    return (_document_cookie_split_find = document.cookie.split("; ").find(function(row) {
        return row.startsWith("".concat(key, "="));
    })) === null || _document_cookie_split_find === void 0 ? void 0 : _document_cookie_split_find.split("=")[1];
};
var $cda636b84ca95de8$export$110700823644f4a6 = function(key, value) {
    var expirySeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 31556926 // one year
    ;
    var now = new Date();
    var ms = expirySeconds * 1000;
    var expireTime = new Date(now.getTime() + ms);
    document.cookie = "".concat(key, "=").concat(value, "; expires=").concat(expireTime.toUTCString(), "; domain=").concat((0, $10b47c5a212e87a0$export$5be0b31130ab4ac0));
};
function $cda636b84ca95de8$export$4eb4d455efe88c2f(cookieName) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9bd1cc5e5a2d6a54$exports))).get(cookieName);
}
var $cda636b84ca95de8$export$fda6c4795731a594 = /*#__PURE__*/ function(DevModeScenario) {
    DevModeScenario["Advise"] = "Advise";
    DevModeScenario["Booked"] = "Booked";
    DevModeScenario["Offer"] = "Offer";
    DevModeScenario["RecommendationPending"] = "RecommendationPending";
    DevModeScenario["RecommendationReady"] = "RecommendationReady";
    DevModeScenario["RecommendationAccepted"] = "RecommendationAccepted";
    DevModeScenario["RecommendationAcceptedDocsRequired"] = "RecommendationAcceptedDocsRequired";
    DevModeScenario["Application"] = "Application";
    DevModeScenario["Won"] = "Won";
    DevModeScenario["CompletionSet"] = "CompletionSet";
    DevModeScenario["Dip"] = "Dip";
    DevModeScenario["Lost"] = "Lost";
    DevModeScenario["Wip"] = "Wip";
    DevModeScenario["OfferAccepted"] = "OfferAccepted";
    DevModeScenario["OfferAcceptedBooked"] = "OfferAcceptedBooked";
    DevModeScenario["Core"] = "Core";
    DevModeScenario["BTLSpecialistPayment"] = "BTLSpecialistPayment";
    DevModeScenario["PrepareForAppointment"] = "PrepareForAppointment";
    DevModeScenario["PrepareForAppointmentDocsOnly"] = "PrepareForAppointmentDocsOnly";
    return DevModeScenario;
}({});
function $cda636b84ca95de8$export$1e0775a4561f3738() {
    var cookieValue = $cda636b84ca95de8$export$4eb4d455efe88c2f("dev-mode");
    return cookieValue !== null && Object.values($cda636b84ca95de8$export$fda6c4795731a594).includes(cookieValue);
}
function $cda636b84ca95de8$export$229888be98753136() {
    var cookieValue = $cda636b84ca95de8$export$4eb4d455efe88c2f("dev-mode");
    if (!cookieValue) return null;
    if (Object.values($cda636b84ca95de8$export$fda6c4795731a594).includes(cookieValue)) return cookieValue;
    var validOptions = Object.values($cda636b84ca95de8$export$fda6c4795731a594).join(", ");
    console.error("Invalid dev-mode value: '".concat(cookieValue, "'. Valid options: ").concat(validOptions));
    return null;
}
function $cda636b84ca95de8$export$c2c6e6e1802026c7() {
    var scenario = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Advise";
    $cda636b84ca95de8$export$f1e6a600abe18947("dev-mode", scenario);
    console.log("\uD83D\uDD27 Dev mode: Enabled with scenario '".concat(scenario, "'"));
}
function $cda636b84ca95de8$export$2e475df6033fd225() {
    $cda636b84ca95de8$export$ad5482944e3323db("dev-mode");
    console.log("\uD83D\uDD27 Dev mode: Disabled");
}
function $cda636b84ca95de8$export$f1e6a600abe18947(cookieName, value) {
    var lifetimeSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var cookieConf = {
        expires: null,
        domain: null
    };
    if (lifetimeSeconds) cookieConf.expires = lifetimeSeconds / 86400;
    cookieConf.domain = (0, $10b47c5a212e87a0$export$5be0b31130ab4ac0);
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($9bd1cc5e5a2d6a54$exports))).set(cookieName, value, cookieConf);
    } catch (e) {
        console.log(e);
    }
}
function $cda636b84ca95de8$export$ad5482944e3323db(cookieName) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9bd1cc5e5a2d6a54$exports))).remove(cookieName, {
        path: "",
        domain: (0, $10b47c5a212e87a0$export$5be0b31130ab4ac0)
    });
}



var $58a1e979b444b1d1$export$3f8e781259784e8f = "SessionJwt";
function $58a1e979b444b1d1$export$f13b97e1f1a8fd9() {
    (0, $cda636b84ca95de8$export$ad5482944e3323db)($58a1e979b444b1d1$export$3f8e781259784e8f);
}
function $58a1e979b444b1d1$export$187448bde0bf1012(value) {
    if (!value) {
        (0, $cda636b84ca95de8$export$ad5482944e3323db)($58a1e979b444b1d1$export$3f8e781259784e8f);
        return;
    }
    (0, $cda636b84ca95de8$export$f1e6a600abe18947)($58a1e979b444b1d1$export$3f8e781259784e8f, value);
}
function $58a1e979b444b1d1$export$fca3e8387ec9b03d() {
    var jwt = (0, $cda636b84ca95de8$export$4eb4d455efe88c2f)($58a1e979b444b1d1$export$3f8e781259784e8f);
    if (!jwt) {
        $58a1e979b444b1d1$export$f13b97e1f1a8fd9();
        return null;
    }
    var token = (0, $3f7593b3cb7ae70f$export$33120bfebc0e7c15)(jwt);
    if (token.exp < Math.floor(Date.now() / 1000)) {
        $58a1e979b444b1d1$export$f13b97e1f1a8fd9();
        return null;
    }
    return jwt;
}
function $58a1e979b444b1d1$export$62c14d26d1527c22(password, passwordConfirm, setStatusValues) {
    var hasUppercase = !!password.match(/[A-Z]/);
    var hasLowercase = !!password.match(/[a-z]/);
    var hasNumber = !!password.match(/[0-9]/);
    var hasMinimum = password.length >= 8;
    var hasSpecialChar = !!password.match(/[^a-zA-Z0-9]/);
    var hasBigAmount = password.length >= 14;
    var doPasswordsMatch = password === passwordConfirm;
    var isValid = hasUppercase && hasLowercase && hasNumber && hasMinimum && doPasswordsMatch;
    var validation = {
        hasUppercase: hasUppercase,
        hasLowercase: hasLowercase,
        hasNumber: hasNumber,
        hasMinimum: hasMinimum,
        hasSpecialChar: hasSpecialChar,
        hasBigAmount: hasBigAmount,
        isValid: isValid
    };
    var validationValues = [
        hasUppercase,
        hasLowercase,
        hasNumber,
        hasMinimum,
        hasSpecialChar,
        hasBigAmount
    ];
    // Score the strength out of 100
    var passwordScore = validationValues.reduce(function(total, val) {
        return total + (val ? 20 : 0);
    }, -20);
    passwordScore = hasMinimum ? passwordScore : 0;
    var strengthStatus = $58a1e979b444b1d1$var$getStrengthStatus(passwordScore);
    setStatusValues(validation, strengthStatus);
}
var $58a1e979b444b1d1$var$getStrengthStatus = function(score) {
    switch(true){
        case score > 80:
            return "Excellent";
        case score > 60:
            return "Strong";
        case score > 40:
            return "Good";
        case score > 20:
            return "Fair";
        default:
            return "Poor";
    }
};





parcelRequire("hAGkE");

var $cdee53f79ccf0fe3$exports = {};
$cdee53f79ccf0fe3$exports = $parcel$resolve("h70Oc");



function $3213aa537536876b$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  align-self: center;\n  width: 200px;\n"
    ]);
    $3213aa537536876b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3213aa537536876b$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 45vh;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3em;\n"
    ]);
    $3213aa537536876b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $3213aa537536876b$var$MojoLogoImage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($3213aa537536876b$var$_templateObject());
var $3213aa537536876b$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3213aa537536876b$var$_templateObject1());
function $3213aa537536876b$export$f308e52f683c112f(param) {
    var message = param.message, isLoading = param.isLoading;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3213aa537536876b$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3213aa537536876b$var$MojoLogoImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cdee53f79ccf0fe3$exports))),
                alt: "mojo logo"
            }),
            message && message,
            isLoading && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                size: 70,
                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
            })
        ]
    });
}





var $d69541b5bf83152a$export$8e849b4340a2cb43 = /*#__PURE__*/ function(EventCategory) {
    EventCategory["siteInteraction"] = "Site Interaction";
    EventCategory["formInteraction"] = "Form Interaction";
    EventCategory["functionalInteraction"] = "Functional Interaction";
    EventCategory["accountInteraction"] = "Account Authentication";
    EventCategory["customEvent"] = "Custom Event";
    return EventCategory;
}({});
var $d69541b5bf83152a$export$4f3bc3f0d9ac9da2 = /*#__PURE__*/ function(EventAction) {
    EventAction["componentDisplay"] = "Component Display";
    EventAction["componentViewed"] = "Component Viewed";
    EventAction["buttonClicked"] = "Button Clicked";
    EventAction["tooltipClicked"] = "Tooltip Clicked";
    EventAction["sectionLenderLookup"] = "Section Lender Lookup";
    EventAction["sectionCurrentDealEndDate"] = "Section Current Deal End Date";
    EventAction["addressLookupSuccessful"] = "Address Lookup - Successful";
    EventAction["addressLookupUnsuccessful"] = "Address Lookup - Unsuccessful";
    EventAction["addressSelected"] = "Address Selected";
    EventAction["fieldFocus"] = "Field Focus";
    EventAction["fieldBlur"] = "Field Blur";
    EventAction["validationMessageShown"] = "Validation Message Shown";
    EventAction["nextSectionCTAClick"] = "Next Section CTA Clicked";
    EventAction["appointmentBooked"] = "Appointment Booked";
    EventAction["page"] = "Page";
    EventAction["sectionSummaryShown"] = "Section Summary Shown";
    EventAction["experienceTLS"] = "ExperienceTLS";
    EventAction["apptDatesShown"] = "Appt Dates Shown";
    EventAction["apptDatesShownAmount"] = "Appt Dates Shown Amount";
    EventAction["apptDatesNoneAvailable"] = "Appt Dates None Available";
    EventAction["apptTimeslotsShown"] = "Appt Timeslots Shown";
    EventAction["apptTimeslotsShownAmount"] = "Appt Timeslots Shown Amount";
    EventAction["apptTimeConfirmed"] = "Appt Time Confirmed";
    EventAction["apptEarlyContactPref"] = "Appt Early Contact Preference";
    EventAction["apptTimeSelected"] = "Appt Time Selected";
    EventAction["calendarDateSelected"] = "Calendar Date Selected";
    EventAction["l4lNoQuotesFallback"] = "L4L No Quotes Fallback View";
    EventAction["closeAccordion"] = "Close Accordion";
    EventAction["openAccordion"] = "Open Accordion";
    EventAction["status"] = "Status";
    EventAction["pageViewed"] = "Page Viewed";
    EventAction["dashboardOpps"] = "Dashboard Opps";
    EventAction["questionShown"] = "Question Shown";
    EventAction["questionAnswered"] = "Question Answered";
    EventAction["inputShown"] = "Input Shown";
    EventAction["inputComplete"] = "Input Complete";
    EventAction["login"] = "Login";
    EventAction["loginRedirect"] = "Login Redirect";
    EventAction["loginSuccess"] = "Login Success";
    EventAction["loginSurveyComplete"] = "Login Survey Complete";
    EventAction["loginTlsStatus"] = "Login TLS Status";
    EventAction["magicLink"] = "Magic Link";
    EventAction["newPassword"] = "New Password";
    EventAction["resetPassword"] = "Reset Password";
    EventAction["forgotPassword"] = "Forgotten Password";
    EventAction["journeyStarted"] = "Journey Started";
    EventAction["sectionStarted"] = "Section Started";
    EventAction["sectionCompleted"] = "Section Completed";
    EventAction["ltvCalculated"] = "LTV Calculated";
    EventAction["navigation"] = "Navigation";
    EventAction["caseStatus"] = "Case Status";
    EventAction["docsApplicantDDL"] = "Docs - Applicant DDL";
    EventAction["docsAdded"] = "Docs added";
    EventAction["numberOfProductsShown"] = "Number of Products Shown";
    EventAction["accordionInView"] = "Accordion in View";
    EventAction["documentUploaded"] = "Document Uploaded";
    EventAction["arrivedFromComparison"] = "Arrived From Comparison";
    EventAction["checkboxSelected"] = "Checkbox Selected";
    EventAction["checkboxUnselected"] = "Checkbox Unselected";
    EventAction["opportunityStage"] = "Opportunity Stage";
    EventAction["mortgageType"] = "Mortgage Type";
    EventAction["choiceTimeslotSeleced"] = "Choice Timeslot Selected";
    EventAction["trueTimeslotSelected"] = "True Timeslot Selected";
    EventAction["bucketedIntoExperiment"] = "Bucketed Into Experiment";
    EventAction["documentDownload"] = "Document Download";
    EventAction["recommendationShown"] = "Recommendation Shown";
    EventAction["recommendationNotShown"] = "Recommendation Not Shown";
    EventAction["rateCheckEsisDownloadClicked"] = "Rate Check ESIS Download Clicked";
    EventAction["rateCheckEsisDownloadResult"] = "Rate Check ESIS Download Result";
    EventAction["splitFfEntrySource"] = "Split FF Entry Source";
    return EventAction;
}({});
var $d69541b5bf83152a$export$e9fd5b7d060c5aca = /*#__PURE__*/ function(EventLabel) {
    EventLabel["startApplication"] = "Start a new application";
    EventLabel["unknownCheckbox"] = "Unknown Checkbox";
    EventLabel["notShownCheckbox"] = "Not Shown Checkbox";
    EventLabel["thankYouForBooking"] = "Thank you for booking";
    EventLabel["callbackrequested"] = "Callback requested";
    EventLabel["appointmentBooked"] = "Appointment Booked";
    EventLabel["contactSooner"] = "Contact me sooner if possible";
    EventLabel["confirm"] = "Confirm";
    EventLabel["bookAnAppointment"] = "Book an Appointment";
    EventLabel["bookAnAppointmentPaidTest"] = "Book an Appointment - Paid Test";
    EventLabel["featureTest"] = "Feature is being tested";
    EventLabel["backToMortgageCoach"] = "Back to MortgageCoach";
    EventLabel["restartApplication"] = "Restart application";
    EventLabel["downloadMip"] = "Download my Mortgage in Principle";
    EventLabel["scheduleCall"] = "Schedule a Call";
    EventLabel["requestCallback"] = "Request a callback";
    EventLabel["callMeNow"] = "Call me now";
    EventLabel["close"] = "Close";
    EventLabel["closeError"] = "Close (Error)";
    EventLabel["noCtasDisplayed"] = "No CTAs Displayed";
    EventLabel["bookFreeReview"] = "Book your free review";
    EventLabel["eligibilityLoader"] = "EligibilityLoader";
    EventLabel["oops"] = "Oops";
    EventLabel["cancelBooking"] = "Cancel Booking";
    EventLabel["l4lNoQuotesFallback"] = "L4L No Quotes Fallback View";
    EventLabel["uploadDocs"] = "Upload Documents";
    EventLabel["endOfJourneyEmailAddress"] = "endOfJourneyEmailAddress";
    EventLabel["back"] = "Back";
    EventLabel["appType"] = "appType";
    EventLabel["mortgageScoreMaintenance"] = "MortgageScore is undergoing some maintenance";
    EventLabel["checkEligibility"] = "Check my eligibility";
    EventLabel["login"] = "Login";
    EventLabel["productComparisonStatus"] = "Product Comparison Status";
    EventLabel["appointmentCard"] = "Appointment Card";
    EventLabel["callbackConsent"] = "Callback consent";
    EventLabel["coachPropertyDetails"] = "Mortgage Coach - Property Details";
    EventLabel["coachDeposit"] = "Mortgage Coach - Deposit Details";
    EventLabel["coachSaved"] = "Save Info - Mortgage Coach";
    EventLabel["coachConfirm"] = "Confirm - Mortgage Coach";
    EventLabel["coachCancel"] = "Cancel - Mortgage Coach";
    EventLabel["tls"] = "TLS";
    EventLabel["personalisedMessagingPost"] = "Personalised Messaging - Post Offer";
    EventLabel["personalisedMessagingPre"] = "Personalised Messaging - Pre Offer";
    EventLabel["number"] = "number";
    EventLabel["hadOfferAccepted"] = "Had Offer Accepted";
    EventLabel["foundPropertyValue"] = "Found Property Value";
    EventLabel["continue"] = "Continue";
    EventLabel["propertyAddress"] = "Property Address";
    EventLabel["willCallYouSoon"] = "Will call you soon";
    EventLabel["willCallYouNow"] = "Will call you now";
    EventLabel["whyNoRatesTable"] = "Why no rates table";
    EventLabel["chooseTime"] = "Choose a time";
    EventLabel["startChat"] = "start a chat";
    EventLabel["startOnlineChat"] = "start an online chat";
    EventLabel["selectDeal"] = "Select this deal";
    EventLabel["getStarted"] = "Get started";
    EventLabel["goPro"] = "Go Pro";
    EventLabel["viewDeals"] = "View mortgage deals";
    EventLabel["digiRec"] = "Recommendation Shown";
    EventLabel["digiRecEsis"] = "Recommendation ESIS";
    EventLabel["digiRecNotReady"] = "Recommendation Not Ready Shown";
    EventLabel["digiRecAccepted"] = "Accept Recommendation";
    EventLabel["digiRecDocUpload"] = "DigiRec Doc Upload";
    EventLabel["autoRateAccept"] = "Identified Lower Rate Accepted";
    EventLabel["autoRateDecline"] = "Identified Lower Rate Declined";
    EventLabel["requestRateCheck"] = "Request rate check";
    EventLabel["makePayment"] = "make_payment";
    EventLabel["recAcceptedPaid"] = "digi_rec_accepted_what_to_expect";
    EventLabel["completeYourPayment"] = "complete_your_payment";
    EventLabel["finishMortgageProfile"] = "Finish Mortgage Profile";
    EventLabel["prepareForAppointment"] = "Prepare For Appointment";
    EventLabel["prepareForAppointmentDocsOnly"] = "Prepare For Appointment - Docs Only";
    return EventLabel;
}({});



var $4jtOI = parcelRequire("4jtOI");
var $5fbf271b50477ab1$require$Buffer = $4jtOI.Buffer;
function $5fbf271b50477ab1$export$790b2e2a77fa417() {
    var params = new URLSearchParams(window.location.search);
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), hasToken = _useState[0], setHasToken = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasExpired = _useState1[0], setHasExpired = _useState1[1];
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/magic-login");
    (0, $hAGkE.useEffect)(function() {
        var init = function init() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var magicLoginToken, decoded, authToken, redirect, _;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            if (!params.has("token")) {
                                setHasToken(false);
                                return [
                                    2
                                ];
                            }
                            magicLoginToken = params.get("token");
                            decoded = (0, $3f7593b3cb7ae70f$export$33120bfebc0e7c15)(magicLoginToken);
                            if (decoded.exp < Math.floor(Date.now() / 1000)) {
                                setHasExpired(true);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                $5fbf271b50477ab1$var$GenerateJwtFromMagicToken(magicLoginToken)
                            ];
                        case 1:
                            authToken = _state.sent();
                            (0, $58a1e979b444b1d1$export$187448bde0bf1012)(authToken);
                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).loginSuccess,
                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                event_label: "Magic Login"
                            });
                            if (params.has("redirect")) {
                                redirect = $5fbf271b50477ab1$require$Buffer.from(params.get("redirect"), "base64").toString();
                                (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                    action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).loginRedirect,
                                    event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                    event_label: redirect
                                });
                                history.push(redirect);
                            } else history.push("/dashboard");
                            return [
                                3,
                                3
                            ];
                        case 2:
                            _ = _state.sent();
                            // This specifically redirects to login without a redirect query param
                            // because if the token failed it means the token didn't expire, but was invalid
                            window.location.href = "/login";
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        init();
    }, []);
    var loginLink = (0, $hAGkE.useMemo)(function() {
        var redirect = params.has("redirect") ? "".concat($5fbf271b50477ab1$require$Buffer.from(params.get("redirect"), "base64").toString()) : "/dashboard";
        return "/login?redirect=".concat(encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.hostname + redirect)));
    }, []);
    var message = null;
    var isLoading = true;
    if (hasExpired) {
        message = /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("strong", {
            children: [
                "Your login token has expired. ",
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                    href: loginLink,
                    children: "Click here"
                }),
                " to go to the login page and try again."
            ]
        });
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Your login token has expired"
        });
        isLoading = false;
    } else if (!hasToken) {
        message = /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("strong", {
            children: [
                "Looks like you've got here by mistake. ",
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                    href: loginLink,
                    children: "Click here"
                }),
                " to go to the login page."
            ]
        });
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Looks like you've got here by mistake"
        });
        isLoading = false;
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3213aa537536876b$export$f308e52f683c112f), {
        message: message,
        isLoading: isLoading
    });
}
function $5fbf271b50477ab1$var$GenerateJwtFromMagicToken(magicToken) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var err, response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://public-auth.mojomortgages.com/magic-login?magicToken=".concat(magicToken), {
                            withCredentials: true
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.log(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("https://my-mojo-api.mojomortgages.com/auth/magic-token", {
                            magicToken: magicToken
                        })
                    ];
                case 4:
                    response = _state.sent();
                    return [
                        2,
                        response.data.token
                    ];
            }
        });
    })();
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");

parcelRequire("hAGkE");


parcelRequire("hAGkE");




parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");



function $52cc9c2de18dc6b5$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 10px 0;\n  height: ",
        "px;\n  width: ",
        ";\n"
    ]);
    $52cc9c2de18dc6b5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $52cc9c2de18dc6b5$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  border-radius: ",
        ";\n  padding: 10px 30px;\n  width: ",
        ";\n  box-sizing: border-box;\n  text-align: center;\n  height: 56px;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  transition: width 0.7s;\n  pointer-events: ",
        ";\n  cursor: ",
        ";\n  user-select: none;\n  border: 0;\n  outline: 0;\n\n  &.solid {\n    background: ",
        ";\n    color: white;\n    font-weight: 550;\n    box-shadow: inset 0 -",
        "px 0px ",
        ";\n\n    &:hover {\n      &.isPressed {\n        box-shadow: unset;\n        height: ",
        "px;\n        top: 6px;\n      }\n    }\n    &.disabled {\n      background: ",
        " !important;\n      color: ",
        ";\n      pointer-events: none;\n      box-shadow: none !important;\n    }\n\n    &:hover {\n      background: ",
        ";\n      box-shadow: inset 0 -",
        "px 0px ",
        ";\n    }\n  }\n\n  &.dark {\n    background: ",
        ";\n    color: white;\n    font-weight: 550;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n\n  &.danger {\n    background: ",
        ";\n    color: white;\n    font-weight: 550;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n\n  &.outline {\n    background: transparent;\n    color: black;\n    border: 2px solid black;\n    font-weight: 550;\n\n    &:hover {\n      background: #f5f5f5;\n\n      &.disabled {\n        background: inherit;\n        cursor: default;\n      }\n    }\n\n    &.disabled {\n      color: #969696;\n      border: 2px solid #969696;\n    }\n  }\n"
    ]);
    $52cc9c2de18dc6b5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $52cc9c2de18dc6b5$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  transition: 0.7s;\n  text-align: center;\n  width: ",
        ";\n"
    ]);
    $52cc9c2de18dc6b5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $52cc9c2de18dc6b5$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        ""
    ]);
    $52cc9c2de18dc6b5$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $52cc9c2de18dc6b5$var$ButtonShadowOffset = 6;
var $52cc9c2de18dc6b5$var$height = 56;
var $52cc9c2de18dc6b5$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($52cc9c2de18dc6b5$var$_templateObject(), $52cc9c2de18dc6b5$var$height + 20, function(props) {
    return props.width;
});
var $52cc9c2de18dc6b5$var$ButtonSpan = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($52cc9c2de18dc6b5$var$_templateObject1(), function(props) {
    var _props_theme_borderRadius;
    return (_props_theme_borderRadius = props.theme.borderRadius) !== null && _props_theme_borderRadius !== void 0 ? _props_theme_borderRadius : "10px";
}, function(props) {
    return props.width;
}, function(props) {
    return props.isLoading ? "none" : "all";
}, function(props) {
    return props.isLoading ? "default" : "pointer";
}, function(props) {
    return props.theme.ctaButton;
}, $52cc9c2de18dc6b5$var$ButtonShadowOffset, function(props) {
    return props.theme.buttonShadow;
}, $52cc9c2de18dc6b5$var$height - 6, function(props) {
    return props.theme.shade80;
}, function(props) {
    return props.theme.shade50;
}, function(props) {
    if (props.theme.ctaButton[0] === "#") return (0, $6650ffc144de4082$export$c0816ed86df316af)(0.1, props.theme.ctaButton);
    else return props.theme.ctaButton;
}, $52cc9c2de18dc6b5$var$ButtonShadowOffset, function(props) {
    if (props.theme.ctaButton[0] === "#") return (0, $6650ffc144de4082$export$c0816ed86df316af)(0.1, props.theme.buttonShadow);
    else return props.theme.buttonShadow;
}, function(props) {
    return props.theme.primaryThree;
}, function(props) {
    return (0, $6650ffc144de4082$export$c0816ed86df316af)(0.08, props.theme.primaryThree);
}, function(props) {
    return props.theme.secondaryThree;
}, function(props) {
    return (0, $6650ffc144de4082$export$c0816ed86df316af)(0.08, props.theme.secondaryThree);
});
var $52cc9c2de18dc6b5$var$LoaderWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($52cc9c2de18dc6b5$var$_templateObject2(), function(props) {
    return props.show ? "30px" : "0";
});
var $52cc9c2de18dc6b5$var$TextWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($52cc9c2de18dc6b5$var$_templateObject3());
var $52cc9c2de18dc6b5$export$d3d950cd69e1ac66 = /*#__PURE__*/ function(ButtonType) {
    ButtonType[ButtonType["Solid"] = 0] = "Solid";
    ButtonType[ButtonType["Outline"] = 1] = "Outline";
    ButtonType[ButtonType["Dark"] = 2] = "Dark";
    ButtonType[ButtonType["Danger"] = 3] = "Danger";
    return ButtonType;
}({});
function $52cc9c2de18dc6b5$export$353f5b6fc5456de1(_param) {
    var _param_tabIndex = _param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, _param_text = _param.text, text = _param_text === void 0 ? "" : _param_text, _param_type = _param.type, type = _param_type === void 0 ? 0 : _param_type, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_onClick = _param.onClick, onClick = _param_onClick === void 0 ? function() {} : _param_onClick, _param_showLoader = _param.showLoader, showLoader = _param_showLoader === void 0 ? false : _param_showLoader, _param_id = _param.id, id = _param_id === void 0 ? "" : _param_id, _param_width = _param.width, width = _param_width === void 0 ? "100%" : _param_width, _param_testId = _param.testId, testId = _param_testId === void 0 ? "" : _param_testId, _param_buttonType = _param.buttonType, buttonType = _param_buttonType === void 0 ? "button" : _param_buttonType, props = (0, $c4wKO._)(_param, [
        "tabIndex",
        "text",
        "type",
        "disabled",
        "onClick",
        "showLoader",
        "id",
        "width",
        "testId",
        "buttonType"
    ]);
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isPressed = _useState[0], setIsPressed = _useState[1];
    function handleOnClick() {
        if (!onClick || showLoader) return;
        onClick();
    }
    var classNames = [];
    if (disabled) classNames.push("disabled");
    switch(type){
        case 0:
            classNames.push("solid");
            break;
        case 1:
            classNames.push("outline");
            break;
        case 2:
            classNames.push("dark");
            break;
        case 3:
            classNames.push("danger");
            break;
    }
    var loaderTheme;
    switch(type){
        case 0:
        case 2:
        case 3:
            loaderTheme = (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Solid;
            break;
        case 1:
        default:
            loaderTheme = (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline;
            break;
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52cc9c2de18dc6b5$var$Container, {
        "data-text": text,
        width: width,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($52cc9c2de18dc6b5$var$ButtonSpan, (0, $7XD9P._)((0, $hRCmZ._)({
            type: buttonType,
            tabIndex: tabIndex,
            id: id,
            "data-testid": testId,
            className: "".concat(classNames.join(" "), " ").concat(isPressed && "isPressed"),
            onClick: handleOnClick,
            width: width,
            isLoading: showLoader,
            onKeyDown: function(e) {
                if (e.key === "Enter") handleOnClick();
            },
            onMouseDownCapture: function() {
                return setIsPressed(true);
            },
            onMouseUp: function() {
                return setIsPressed(false);
            },
            onMouseLeave: function() {
                return setIsPressed(false);
            },
            disabled: disabled
        }, props), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52cc9c2de18dc6b5$var$TextWrapper, {
                    children: text
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52cc9c2de18dc6b5$var$LoaderWrapper, {
                    show: showLoader,
                    children: showLoader && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                        size: 30,
                        theme: loaderTheme
                    })
                })
            ]
        }))
    });
}



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");

var $b6e4dbc26fc7a91d$export$3b4e64e77073e307 = function(param) {
    var children = param.children, leftIcon = param.leftIcon, variant = param.variant, colour = param.colour, fullWidth = param.fullWidth;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b6e4dbc26fc7a91d$var$BannerContainer, {
        $variant: variant,
        $colour: colour,
        $fullWidth: fullWidth,
        children: [
            leftIcon && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                className: "banner__leftIcon",
                children: leftIcon
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                className: "banner__content",
                children: children
            })
        ]
    });
};
var $b6e4dbc26fc7a91d$var$getBackgroundColour = function(colour) {
    switch(colour){
        case "warning":
            return "#ffffff";
        // unknown for now
        case "success":
            return "#EDF5F3";
    }
};
var $b6e4dbc26fc7a91d$var$getBorder = function(colour, variant) {
    if (variant === "filled") return {};
    switch(colour){
        case "success":
            return {
                border: "3px solid #FB7123",
                borderLeft: "9px solid #FB7123"
            };
        case "warning":
            return {
                border: "3px solid #FB7123",
                borderLeft: "9px solid #FB7123"
            };
    }
};
var $b6e4dbc26fc7a91d$var$BannerContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var _param_$colour = param.$colour, $colour = _param_$colour === void 0 ? "warning" : _param_$colour, _param_$variant = param.$variant, $variant = _param_$variant === void 0 ? "outlined" : _param_$variant, $fullWidth = param.$fullWidth;
    return (0, $7XD9P._)((0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({
        background: $b6e4dbc26fc7a91d$var$getBackgroundColour($colour),
        padding: "1.5rem 1.5rem 1.5rem 1rem",
        borderRadius: "1rem"
    }, $b6e4dbc26fc7a91d$var$getBorder($colour, $variant)), {
        display: "flex",
        gap: "12px"
    }), !$fullWidth ? {
        maxWidth: 1200,
        width: "90%"
    } : {}), {
        color: $colour === "success" ? "#126732" : "initial",
        ".banner__content": {
            "> *": {
                width: "100%",
                margin: $variant === "filled" ? "0" : "0 0 8px"
            }
        }
    });
});




parcelRequire("hAGkE");

var $0607cc7c08c03916$exports = {};
$0607cc7c08c03916$exports = $parcel$resolve("5Kq6Y");


function $f32ecb0aa12839a5$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n  background: #d8dce7;\n\n  &.enabled {\n    background: ",
        ";\n  }\n\n  &.disabled {\n    background: ",
        ';\n  }\n\n  &.circle {\n    ::after {\n      content: "";\n      background: white;\n      display: block;\n      width: calc(',
        " / 2 - 1px);\n      height: calc(",
        " / 2 - 1px);\n      border-radius: 50%;\n    }\n  }\n\n  &.tick {\n    ::after {\n      content: url(",
        ");\n      color: white;\n      transform: scale(1);\n    }\n  }\n"
    ]);
    $f32ecb0aa12839a5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f32ecb0aa12839a5$var$CircleRadius = "22px";
var $f32ecb0aa12839a5$var$Circle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($f32ecb0aa12839a5$var$_templateObject(), $f32ecb0aa12839a5$var$CircleRadius, $f32ecb0aa12839a5$var$CircleRadius, function(props) {
    return props.theme.primary;
}, function(props) {
    return props.theme.shade[60];
}, $f32ecb0aa12839a5$var$CircleRadius, $f32ecb0aa12839a5$var$CircleRadius, (0, (/*@__PURE__*/$parcel$interopDefault($0607cc7c08c03916$exports))));
function $f32ecb0aa12839a5$export$32f2095185c4c126(param) {
    var _param_enabled = param.enabled, enabled = _param_enabled === void 0 ? false : _param_enabled, _param_type = param.type, type = _param_type === void 0 ? "circle" : _param_type, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var classNames = [];
    classNames.push(type);
    if (enabled) classNames.push("enabled");
    if (disabled) classNames.push("disabled");
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f32ecb0aa12839a5$var$Circle, {
        className: classNames.join(" ")
    });
}




parcelRequire("hAGkE");


function $37d2494f62bb4b07$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  &.",
        ", &.",
        ' {\n    ::before {\n      content: "\u2605";\n    }\n  }\n\n  &.',
        ' {\n    ::before {\n      content: "\u2606";\n    }\n  }\n\n  color: ',
        ";\n"
    ]);
    $37d2494f62bb4b07$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $37d2494f62bb4b07$export$4e24cdfa30bb8ed4 = /*#__PURE__*/ function(StarStatus) {
    StarStatus["Filled"] = "Filled";
    StarStatus["FilledDisabled"] = "FilledDisabled";
    StarStatus["Outline"] = "Outline";
    StarStatus["None"] = "None";
    return StarStatus;
}({});
var $37d2494f62bb4b07$var$StarElement = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)("div")($37d2494f62bb4b07$var$_templateObject(), "Filled", "FilledDisabled", "Outline", function(props) {
    return props.theme.starColour;
});
var $37d2494f62bb4b07$export$1644ba17714857f1 = function(param) {
    var _param_color = param.color, color = _param_color === void 0 ? "".concat(function(props) {
        return props.theme.starColour;
    }) : _param_color, _param_status = param.status, status = _param_status === void 0 ? "Filled" : _param_status;
    var classes = [
        status
    ];
    if (status === "FilledDisabled") color = (0, $6650ffc144de4082$export$c0816ed86df316af)(0.4, color);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37d2494f62bb4b07$var$StarElement, {
        color: color,
        status: status,
        className: classes.join(" ")
    });
};




parcelRequire("hAGkE");

function $f294cc4c227dd6d2$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 8px;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n"
    ]);
    $f294cc4c227dd6d2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f294cc4c227dd6d2$var$CheckBoxLabelContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($f294cc4c227dd6d2$var$_templateObject());
function $f294cc4c227dd6d2$export$48513f6b9f8ce62d(param) {
    var checked = param.checked, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("input", {
        id: id,
        checked: checked,
        onChange: onChange,
        style: {
            cursor: "pointer",
            minWidth: "15px"
        },
        type: "checkbox",
        autoComplete: "off"
    });
}
var $f294cc4c227dd6d2$export$6cb1578e30bfa58d = function(param) {
    var checked = param.checked, onChange = param.onChange, id = param.id, children = param.children;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($f294cc4c227dd6d2$var$CheckBoxLabelContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f294cc4c227dd6d2$export$48513f6b9f8ce62d, {
                id: id,
                checked: checked,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("label", {
                htmlFor: id,
                children: children
            })
        ]
    });
};


// @ts-nocheck


var $hAGkE = parcelRequire("hAGkE");
function $d064dfd92ce74522$export$f63de433e1787c6d(param) {
    var _param_height = param.height, height = _param_height === void 0 ? "140px`" : _param_height, _param_width = param.width, width = _param_width === void 0 ? "130px" : _param_width, _param_templateId = param.templateId, templateId = _param_templateId === void 0 ? "5419b732fbfb950b10de65e5" : _param_templateId, _param_theme = param.theme, theme = _param_theme === void 0 ? "light" : _param_theme;
    var trustpilotRef = (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useRef(null);
    (0, $hAGkE.useEffect)(function() {
        if (trustpilotRef && window.Trustpilot) {
            window.Trustpilot.loadFromElement(trustpilotRef.current, true);
            return;
        }
        var interval = setInterval(function() {
            if (trustpilotRef && window.Trustpilot) {
                window.Trustpilot.loadFromElement(trustpilotRef.current, true);
                clearInterval(interval);
            }
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
        ref: trustpilotRef,
        className: "trustpilot-widget",
        "data-locale": "en-GB",
        "data-template-id": templateId,
        "data-businessunit-id": "573992ca0000ff00058cec06",
        "data-style-height": height,
        "data-style-width": width,
        "data-theme": theme,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
            href: "https://uk.trustpilot.com/review/mojomortgages.com",
            target: "_blank",
            rel: "noreferrer",
            children: "Trustpilot"
        })
    });
}




parcelRequire("hAGkE");

var $7feb06a480b4e75d$exports = {};
$7feb06a480b4e75d$exports = $parcel$resolve("b4NxB");


var $eb18b1ee0ab1ae4a$exports = {};
$eb18b1ee0ab1ae4a$exports = $parcel$resolve("5ltEv");


var $99df7d350ab11fa5$exports = {};
$99df7d350ab11fa5$exports = $parcel$resolve("b6lNd");


var $eccb9591e36cd353$exports = {};
$eccb9591e36cd353$exports = $parcel$resolve("1HIS3");



var $99702f8e501e48d9$exports = {};
$99702f8e501e48d9$exports = $parcel$resolve("jqQYZ");



var $4d646f4b46e53c53$exports = {};
$4d646f4b46e53c53$exports = $parcel$resolve("fdHSY");


var $a2fba79ce7cd0df4$exports = {};
$a2fba79ce7cd0df4$exports = $parcel$resolve("aPrT8");


var $1e840f971475eea8$exports = {};
$1e840f971475eea8$exports = $parcel$resolve("j4j9D");


var $04f26c3eff767b25$exports = {};
$04f26c3eff767b25$exports = $parcel$resolve("hfstx");


var $8841f353321808e7$exports = {};
$8841f353321808e7$exports = $parcel$resolve("hzvwF");


var $548f2127bbf04648$exports = {};
$548f2127bbf04648$exports = $parcel$resolve("1gPlL");


var $ce001d6eb57ec5db$exports = {};
$ce001d6eb57ec5db$exports = $parcel$resolve("5D7X3");


var $58b21fb306177fe1$exports = {};
$58b21fb306177fe1$exports = $parcel$resolve("2QK6F");


var $0ca43293f8b98e7b$exports = {};
$0ca43293f8b98e7b$exports = $parcel$resolve("lHR42");


var $986f1e5c078be8bb$exports = {};
$986f1e5c078be8bb$exports = $parcel$resolve("iPqj5");


var $87569f29ba822892$exports = {};
$87569f29ba822892$exports = $parcel$resolve("5lQXm");


function $abfded16bdabae7a$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: inline-block;\n  width: ",
        "px;\n  height: ",
        "px;\n  mask: url(",
        ") no-repeat center / contain;\n  -webkit-mask: url(",
        ") no-repeat center / contain;\n  background-color: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    $abfded16bdabae7a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $abfded16bdabae7a$var$images = {
    ArrowDown: (0, (/*@__PURE__*/$parcel$interopDefault($7feb06a480b4e75d$exports))),
    ArrowRight: (0, (/*@__PURE__*/$parcel$interopDefault($eb18b1ee0ab1ae4a$exports))),
    Back: (0, (/*@__PURE__*/$parcel$interopDefault($eccb9591e36cd353$exports))),
    Cross: (0, (/*@__PURE__*/$parcel$interopDefault($f0318dc2ecd419e3$exports))),
    Exclamation: (0, (/*@__PURE__*/$parcel$interopDefault($99df7d350ab11fa5$exports))),
    Locked: (0, (/*@__PURE__*/$parcel$interopDefault($99702f8e501e48d9$exports))),
    Menu: (0, (/*@__PURE__*/$parcel$interopDefault($5d550af05e29e2a1$exports))),
    Shield: (0, (/*@__PURE__*/$parcel$interopDefault($4d646f4b46e53c53$exports))),
    SmallArrow: (0, (/*@__PURE__*/$parcel$interopDefault($a2fba79ce7cd0df4$exports))),
    Cross2: (0, (/*@__PURE__*/$parcel$interopDefault($1e840f971475eea8$exports))),
    QuestionMark: (0, (/*@__PURE__*/$parcel$interopDefault($04f26c3eff767b25$exports))),
    ChevronDown: (0, (/*@__PURE__*/$parcel$interopDefault($58b21fb306177fe1$exports))),
    ChevronLeft: (0, (/*@__PURE__*/$parcel$interopDefault($986f1e5c078be8bb$exports))),
    ChevronRight: (0, (/*@__PURE__*/$parcel$interopDefault($87569f29ba822892$exports))),
    ChevronUp: (0, (/*@__PURE__*/$parcel$interopDefault($0ca43293f8b98e7b$exports))),
    ExternalLink: (0, (/*@__PURE__*/$parcel$interopDefault($8841f353321808e7$exports))),
    IconTick: (0, (/*@__PURE__*/$parcel$interopDefault($548f2127bbf04648$exports))),
    WhiteTick: (0, (/*@__PURE__*/$parcel$interopDefault($ce001d6eb57ec5db$exports)))
};
var $abfded16bdabae7a$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType[IconType["ArrowDown"] = 0] = "ArrowDown";
    IconType[IconType["ArrowRight"] = 1] = "ArrowRight";
    IconType[IconType["Back"] = 2] = "Back";
    IconType[IconType["Cross"] = 3] = "Cross";
    IconType[IconType["Exclamation"] = 4] = "Exclamation";
    IconType[IconType["Locked"] = 5] = "Locked";
    IconType[IconType["Menu"] = 6] = "Menu";
    IconType[IconType["Shield"] = 7] = "Shield";
    IconType[IconType["SmallArrow"] = 8] = "SmallArrow";
    IconType[IconType["Cross2"] = 9] = "Cross2";
    IconType[IconType["QuestionMark"] = 10] = "QuestionMark";
    IconType[IconType["ChevronDown"] = 11] = "ChevronDown";
    IconType[IconType["ChevronLeft"] = 12] = "ChevronLeft";
    IconType[IconType["ChevronRight"] = 13] = "ChevronRight";
    IconType[IconType["ChevronUp"] = 14] = "ChevronUp";
    IconType[IconType["ExternalLink"] = 15] = "ExternalLink";
    IconType[IconType["IconTick"] = 16] = "IconTick";
    IconType[IconType["WhiteTick"] = 17] = "WhiteTick";
    return IconType;
}({});
var $abfded16bdabae7a$var$IconComponent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($abfded16bdabae7a$var$_templateObject(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var icon = param.icon;
    return icon;
}, function(param) {
    var icon = param.icon;
    return icon;
}, function(param) {
    var fillDefault = param.fillDefault, active = param.active, fillHover = param.fillHover;
    return active ? fillHover : fillDefault;
}, function(param) {
    var fillHover = param.fillHover;
    return fillHover;
});
function $abfded16bdabae7a$export$962ee6b89e324472(param) {
    var type = param.type, onClick = param.onClick, fillDefault = param.fillDefault, fillHover = param.fillHover, width = param.width, height = param.height, active = param.active;
    var icon = $abfded16bdabae7a$export$13ff1290a9e22e77[type];
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($abfded16bdabae7a$var$IconComponent, {
        onClick: onClick && onClick,
        active: active,
        icon: $abfded16bdabae7a$var$images[icon],
        fillDefault: fillDefault,
        fillHover: fillHover,
        width: width,
        height: height
    });
}
function $abfded16bdabae7a$export$f04a61298a47a40f(param) {
    var type = param.type, onClick = param.onClick;
    var icon = $abfded16bdabae7a$export$13ff1290a9e22e77[type];
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
        src: $abfded16bdabae7a$var$images[icon],
        alt: "icon",
        onClick: onClick
    });
}






var $kppPx = parcelRequire("kppPx");

parcelRequire("hAGkE");

function $1354f7165575d3eb$export$ba4392fc901e403b(param) {
    var ref = (0, $kppPx._)(param);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eccb9591e36cd353$exports)))
    });
}



function $210da79c235d3a06$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 75px;\n"
    ]);
    $210da79c235d3a06$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $210da79c235d3a06$var$ButtonTextLayout = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($210da79c235d3a06$var$_templateObject());
function $210da79c235d3a06$export$e0d897ee21382f67(param) {
    var id = param.id, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {} : _param_onClick, customText = param.customText;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
        id: id,
        type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
        onClick: onClick,
        text: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($210da79c235d3a06$var$ButtonTextLayout, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1354f7165575d3eb$export$ba4392fc901e403b), {}),
                customText ? customText : "Back"
            ]
        })
    });
}



function $410d513faacc046e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    $410d513faacc046e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $410d513faacc046e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  height: fit-content;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    $410d513faacc046e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $410d513faacc046e$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 120px;\n  margin: 20px 0 0 20px;\n"
    ]);
    $410d513faacc046e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $410d513faacc046e$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: auto;\n"
    ]);
    $410d513faacc046e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $410d513faacc046e$var$Root = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($410d513faacc046e$var$_templateObject());
var $410d513faacc046e$var$TopNavContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($410d513faacc046e$var$_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.navColour;
}, function(param) {
    var theme = param.theme;
    return theme.borderColor;
});
var $410d513faacc046e$var$BackButtonContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($410d513faacc046e$var$_templateObject2());
var $410d513faacc046e$var$FooterContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($410d513faacc046e$var$_templateObject3());
function $410d513faacc046e$export$3a51ad0132508a84(param) {
    var content = param.content, _param_backButtonAction = param.backButtonAction, backButtonAction = _param_backButtonAction === void 0 ? null : _param_backButtonAction, _param_miniNav = param.miniNav, miniNav = _param_miniNav === void 0 ? false : _param_miniNav, _param_footer = param.footer, footer = _param_footer === void 0 ? null : _param_footer;
    var theme = (0, $7e7d633c88171aa1$export$b3611e87cd5ba6ce)().theme;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($410d513faacc046e$var$Root, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($410d513faacc046e$var$TopNavContainer, {
                miniNav: miniNav,
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8c4ce8c143193527$export$41d0d88a6b0e456f), {
                    showPoweredBy: theme.showPoweredBy,
                    logoVariant: theme.poweredByVariant
                })
            }),
            backButtonAction && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($410d513faacc046e$var$BackButtonContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $210da79c235d3a06$export$e0d897ee21382f67), {
                    id: "button-go-back",
                    onClick: backButtonAction
                })
            }),
            content,
            footer && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($410d513faacc046e$var$FooterContainer, {
                children: footer
            })
        ]
    });
}





function $acad1866a3f9fc3b$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  max-width: ",
        "px;\n  padding: 3.2rem 30px;\n  margin: 0 auto;\n  margin-bottom: 8rem;\n  width: 100%;\n  height: fit-content;\n  align-self: ",
        ";\n\n  @media ",
        " {\n    align-self: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 2.4rem;\n  }\n\n  @media ",
        " {\n    padding: 5rem 7rem 7rem;\n  }\n"
    ]);
    $acad1866a3f9fc3b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $acad1866a3f9fc3b$export$fceb9665be86d56e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($acad1866a3f9fc3b$var$_templateObject(), function(props) {
    var _props_maxWidth;
    return (_props_maxWidth = props.maxWidth) !== null && _props_maxWidth !== void 0 ? _props_maxWidth : 1500;
}, function(props) {
    var _props_verticalAlignmentMobile;
    return (_props_verticalAlignmentMobile = props.verticalAlignmentMobile) !== null && _props_verticalAlignmentMobile !== void 0 ? _props_verticalAlignmentMobile : "initial";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, function(props) {
    var _props_verticalAlignment;
    return (_props_verticalAlignment = props.verticalAlignment) !== null && _props_verticalAlignment !== void 0 ? _props_verticalAlignment : "initial";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);


function $75494c4702aed368$export$78d6b2773a1d5dd8(param) {
    var content = param.content, _param_backButtonAction = param.backButtonAction, backButtonAction = _param_backButtonAction === void 0 ? null : _param_backButtonAction, _param_miniNav = param.miniNav, miniNav = _param_miniNav === void 0 ? false : _param_miniNav, _param_footer = param.footer, footer = _param_footer === void 0 ? null : _param_footer;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $410d513faacc046e$export$3a51ad0132508a84), {
        miniNav: miniNav,
        backButtonAction: backButtonAction,
        footer: footer,
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $acad1866a3f9fc3b$export$fceb9665be86d56e), {
            children: content
        })
    });
}





parcelRequire("hAGkE");


parcelRequire("hAGkE");


function $bc0b65a7f396a0a1$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 16px 16px;\n  box-sizing: border-box;\n  height: fit-content;\n  position: relative;\n\n  @media ",
        " {\n    padding: 35px 35px;\n  }\n\n  &.default {\n    background: white;\n    color: black;\n  }\n\n  &.highlight {\n    background: #f9ba5b;\n    color: #444444;\n  }\n"
    ]);
    $bc0b65a7f396a0a1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $bc0b65a7f396a0a1$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: -16px;\n\n  > * {\n    border-bottom-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n  }\n\n  @media ",
        " {\n    margin: -35px;\n  }\n"
    ]);
    $bc0b65a7f396a0a1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $bc0b65a7f396a0a1$export$41808410d1eaf88a = "12px";
var $bc0b65a7f396a0a1$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($bc0b65a7f396a0a1$var$_templateObject(), $bc0b65a7f396a0a1$export$41808410d1eaf88a, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $bc0b65a7f396a0a1$var$FooterWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($bc0b65a7f396a0a1$var$_templateObject1(), $bc0b65a7f396a0a1$export$41808410d1eaf88a, $bc0b65a7f396a0a1$export$41808410d1eaf88a, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
function $bc0b65a7f396a0a1$export$60332b2344f7fe41(param) {
    var _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme, content = param.content, _param_style = param.style, style = _param_style === void 0 ? null : _param_style, _param_footer = param.footer, footer = _param_footer === void 0 ? null : _param_footer;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($bc0b65a7f396a0a1$var$Container, {
        style: style,
        className: theme,
        children: [
            content,
            footer && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($bc0b65a7f396a0a1$var$FooterWrapper, {
                children: footer
            })
        ]
    });
}




var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");



var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");
var $6e6e522132305404$export$f9895884a211c2e5 = /*#__PURE__*/ function(ApplicationInProgress) {
    ApplicationInProgress["No"] = "No";
    ApplicationInProgress["YesBroker"] = "YesBroker";
    ApplicationInProgress["YesLender"] = "YesLender";
    return ApplicationInProgress;
}({});
var $6e6e522132305404$export$6b809219ca7a0a61 = /*#__PURE__*/ function(SalarySupplementType) {
    SalarySupplementType["Unknown"] = "Unknown";
    SalarySupplementType["Bonus"] = "Bonus";
    SalarySupplementType["CarAllowance"] = "CarAllowance";
    SalarySupplementType["Commission"] = "Commission";
    SalarySupplementType["Overtime"] = "Overtime";
    SalarySupplementType["RegionalAllowance"] = "RegionalAllowance";
    SalarySupplementType["EmployerHousingAllowance"] = "EmployerHousingAllowance";
    SalarySupplementType["Other"] = "Other";
    SalarySupplementType["None"] = "None";
    return SalarySupplementType;
}({});
var $6e6e522132305404$export$7eacfa883e85e233 = /*#__PURE__*/ function(SalaryDeductionType) {
    SalaryDeductionType["Unknown"] = "Unknown";
    SalaryDeductionType["StudentLoan"] = "StudentLoan";
    SalaryDeductionType["Pension"] = "Pension";
    SalaryDeductionType["SalarySacrifice"] = "SalarySacrifice";
    SalaryDeductionType["GiftAidOrCharity"] = "GiftAidOrCharity";
    SalaryDeductionType["Other"] = "Other";
    SalaryDeductionType["None"] = "None";
    return SalaryDeductionType;
}({});
var $6e6e522132305404$export$b800d0990f6fc366 = /*#__PURE__*/ function(IncomeBenefitType) {
    IncomeBenefitType["Unknown"] = "Unknown";
    IncomeBenefitType["CarersAllowance"] = "CarersAllowance";
    IncomeBenefitType["DisabilityLivingAllowance"] = "DisabilityLivingAllowance";
    IncomeBenefitType["FosterCarerAllowance"] = "FosterCarerAllowance";
    IncomeBenefitType["PersonalIndependencePayment"] = "PersonalIndependencePayment";
    IncomeBenefitType["StatePension"] = "StatePension";
    IncomeBenefitType["WarWidowPension"] = "WarWidowPension";
    IncomeBenefitType["AdoptionAllowance"] = "AdoptionAllowance";
    IncomeBenefitType["ChildBenefit"] = "ChildBenefit";
    IncomeBenefitType["ChildTaxCredit"] = "ChildTaxCredit";
    IncomeBenefitType["ConstantAttendanceAllowance"] = "ConstantAttendanceAllowance";
    IncomeBenefitType["GuardiansAllowance"] = "GuardiansAllowance";
    IncomeBenefitType["IndustrialInjuriesDisablementBenefit"] = "IndustrialInjuriesDisablementBenefit";
    IncomeBenefitType["PensionCredit"] = "PensionCredit";
    IncomeBenefitType["ReducedEarningsAllowance"] = "ReducedEarningsAllowance";
    IncomeBenefitType["WidowedParentAllowance"] = "WidowedParentAllowance";
    IncomeBenefitType["WidowsPension"] = "WidowsPension";
    IncomeBenefitType["WorkingTaxCredit"] = "WorkingTaxCredit";
    IncomeBenefitType["Other"] = "Other";
    IncomeBenefitType["None"] = "None";
    return IncomeBenefitType;
}({});
var $6e6e522132305404$export$61c8615c65336016 = /*#__PURE__*/ function(AdditionalIncomeType) {
    AdditionalIncomeType["Unknown"] = "Unknown";
    AdditionalIncomeType["SecondJob"] = "SecondJob";
    AdditionalIncomeType["CsaChildMaintenance"] = "CsaChildMaintenance";
    AdditionalIncomeType["RentalIncomeSurplus"] = "RentalIncomeSurplus";
    AdditionalIncomeType["Other"] = "Other";
    AdditionalIncomeType["None"] = "None";
    return AdditionalIncomeType;
}({});
var $6e6e522132305404$export$c905772e9b4a415e = /*#__PURE__*/ function(FurloughStatus) {
    FurloughStatus["Unknown"] = "Unknown";
    FurloughStatus["No"] = "No";
    FurloughStatus["Last18Months"] = "Last18Months";
    return FurloughStatus;
}({});
var $6e6e522132305404$export$88682f2b8e54aec9 = /*#__PURE__*/ function(PayFrequency) {
    PayFrequency["unknown"] = "unknown";
    PayFrequency["hourly"] = "hourly";
    PayFrequency["daily"] = "daily";
    PayFrequency["weekly"] = "weekly";
    PayFrequency["bi_weekly"] = "bi_weekly";
    PayFrequency["monthly"] = "monthly";
    PayFrequency["quarterly"] = "quarterly";
    PayFrequency["annually"] = "annually";
    return PayFrequency;
}({});
var $6e6e522132305404$export$978d240f447d4ef2 = /*#__PURE__*/ function(EmploymentStatus) {
    EmploymentStatus["Unknown"] = "Unknown";
    EmploymentStatus["PermanentEmployment"] = "PermanentEmployment";
    EmploymentStatus["TemporaryEmployment"] = "TemporaryEmployment";
    EmploymentStatus["Contractor"] = "Contractor";
    EmploymentStatus["SoleTrader"] = "SoleTrader";
    EmploymentStatus["DirectorLimitedCompany"] = "DirectorLimitedCompany";
    EmploymentStatus["PartnerLlp"] = "PartnerLlp";
    EmploymentStatus["Retired"] = "Retired";
    EmploymentStatus["NotWorking"] = "NotWorking";
    EmploymentStatus["Agency"] = "Agency";
    return EmploymentStatus;
}({});
var $6e6e522132305404$export$e7c8bf3272d8c154 = /*#__PURE__*/ function(FeePaymentPreference) {
    FeePaymentPreference["unknown"] = "unknown";
    FeePaymentPreference["pay_up_front"] = "pay_up_front";
    FeePaymentPreference["add_to_loan"] = "add_to_loan";
    FeePaymentPreference["not_sure"] = "not_sure";
    return FeePaymentPreference;
}({});
var $6e6e522132305404$export$4fd25ece7b4b8ec9 = /*#__PURE__*/ function(UnderBudgetPreference) {
    UnderBudgetPreference["unknown"] = "unknown";
    UnderBudgetPreference["ReduceTerm"] = "ReduceTerm";
    UnderBudgetPreference["PayLess"] = "PayLess";
    return UnderBudgetPreference;
}({});
var $6e6e522132305404$export$5dda879bfd416fd3 = /*#__PURE__*/ function(MortgageTypePreference) {
    MortgageTypePreference["unknown"] = "unknown";
    MortgageTypePreference["fixed_rate"] = "fixed_rate";
    MortgageTypePreference["tracker"] = "tracker";
    MortgageTypePreference["no_preference"] = "no_preference";
    return MortgageTypePreference;
}({});
var $6e6e522132305404$export$a3e2f90018137d93 = /*#__PURE__*/ function(RepaymentMethod) {
    RepaymentMethod["unknown"] = "unknown";
    RepaymentMethod["repayment"] = "repayment";
    RepaymentMethod["interest_only"] = "interest_only";
    RepaymentMethod["repayment_vehicle"] = "repayment_vehicle";
    RepaymentMethod["part_and_part"] = "part_and_part";
    return RepaymentMethod;
}({});
var $6e6e522132305404$export$6424a9ad9819de26 = /*#__PURE__*/ function(RepaymentMethodPreference) {
    RepaymentMethodPreference["unknown"] = "unknown";
    RepaymentMethodPreference["capital_repayment"] = "capital_repayment";
    RepaymentMethodPreference["interest_only"] = "interest_only";
    RepaymentMethodPreference["not_sure"] = "not_sure";
    return RepaymentMethodPreference;
}({});
var $6e6e522132305404$export$e090c4717379d1ec = /*#__PURE__*/ function(InitialPeriodPreference) {
    InitialPeriodPreference["unknown"] = "unknown";
    InitialPeriodPreference["no_preference"] = "no_preference";
    InitialPeriodPreference["two_years"] = "two_years";
    InitialPeriodPreference["three_years"] = "three_years";
    InitialPeriodPreference["five_years"] = "five_years";
    InitialPeriodPreference["ten_years"] = "ten_years";
    InitialPeriodPreference["over_ten_years"] = "over_ten_years";
    InitialPeriodPreference["term"] = "term";
    InitialPeriodPreference["tracker"] = "tracker";
    return InitialPeriodPreference;
}({});
var $6e6e522132305404$export$93e53e35c8b9612f = /*#__PURE__*/ function(PropertyTenure) {
    PropertyTenure["Unknown"] = "Unknown";
    PropertyTenure["Freehold"] = "Freehold";
    PropertyTenure["Leasehold"] = "Leasehold";
    return PropertyTenure;
}({});
var $6e6e522132305404$export$c3861dfdbadb8c2 = /*#__PURE__*/ function(PropertyType) {
    PropertyType["house"] = "house";
    PropertyType["flat"] = "flat";
    PropertyType["other"] = "other";
    return PropertyType;
}({});
var $6e6e522132305404$export$379de9fa197ff43a = /*#__PURE__*/ function(Persona) {
    Persona["StartedLooking"] = "StartedLooking";
    Persona["ActivelyLooking"] = "ActivelyLooking";
    Persona["FoundProperty"] = "FoundProperty";
    Persona["OfferAccepted"] = "OfferAccepted";
    return Persona;
}({});
var $6e6e522132305404$export$8c4eccffb3add90d = /*#__PURE__*/ function(FlatType) {
    FlatType["unknown"] = "unknown";
    FlatType["purpose_built"] = "purpose_built";
    FlatType["converted"] = "converted";
    FlatType["studio"] = "studio";
    FlatType["sitting_tenant"] = "sitting_tenant";
    FlatType["over_commercial_premises"] = "over_commercial_premises";
    FlatType["four_storeys_or_less"] = "four_storeys_or_less";
    FlatType["over_four_storeys"] = "over_four_storeys";
    FlatType["over_seven_storeys"] = "over_seven_storeys";
    FlatType["over_ten_storeys"] = "over_ten_storeys";
    return FlatType;
}({});
var $6e6e522132305404$export$630c321840a99aed = /*#__PURE__*/ function(ConstructionType) {
    ConstructionType["unknown"] = "unknown";
    ConstructionType["standard"] = "standard";
    ConstructionType["thatched"] = "thatched";
    ConstructionType["concrete"] = "concrete";
    ConstructionType["timber_framed"] = "timber_framed";
    ConstructionType["brick"] = "brick";
    ConstructionType["pre_fabricated"] = "pre_fabricated";
    ConstructionType["steel_frames"] = "steel_frames";
    ConstructionType["other"] = "other";
    ConstructionType["stone"] = "stone";
    return ConstructionType;
}({});
var $6e6e522132305404$export$9bb0813ba67e6d9 = /*#__PURE__*/ function(HouseType) {
    HouseType["Unknown"] = "Unknown";
    HouseType["DetachedHouse"] = "DetachedHouse";
    HouseType["SemiDetachedHouse"] = "SemiDetachedHouse";
    HouseType["TerracedHouse"] = "TerracedHouse";
    HouseType["EndOfTerraceHouse"] = "EndOfTerraceHouse";
    HouseType["Cottage"] = "Cottage";
    HouseType["Bungalow"] = "Bungalow";
    HouseType["Flat"] = "Flat";
    HouseType["Other"] = "Other";
    return HouseType;
}({});
var $6e6e522132305404$export$75ba30bf67661d20 = /*#__PURE__*/ function(MaritalStatus) {
    MaritalStatus["unknown"] = "unknown";
    MaritalStatus["single"] = "single";
    MaritalStatus["married_civil_partnership"] = "married_civil_partnership";
    MaritalStatus["cohabiting"] = "cohabiting";
    MaritalStatus["divorced_ex_civil_partnership"] = "divorced_ex_civil_partnership";
    MaritalStatus["engaged"] = "engaged";
    MaritalStatus["separated"] = "separated";
    MaritalStatus["widowed"] = "widowed";
    return MaritalStatus;
}({});
var $6e6e522132305404$export$e743037aea74f514 = /*#__PURE__*/ function(TriState) {
    TriState["unknown"] = "unknown";
    TriState["yes"] = "yes";
    TriState["no"] = "no";
    TriState["not_sure"] = "not_sure";
    return TriState;
}({});
var $6e6e522132305404$export$18a71b5777893e1a = /*#__PURE__*/ function(LandlordType) {
    LandlordType["Unknown"] = "Unknown";
    LandlordType["Private"] = "Private";
    LandlordType["Limited_company"] = "Limited_company";
    return LandlordType;
}({});
var $6e6e522132305404$export$42f771d468e9b56a = /*#__PURE__*/ function(PurchaseScheme) {
    PurchaseScheme["unknown"] = "unknown";
    PurchaseScheme["mortgage_guarantee"] = "mortgage_guarantee";
    PurchaseScheme["shared_equity"] = "shared_equity";
    PurchaseScheme["shared_ownership"] = "shared_ownership";
    PurchaseScheme["help_to_buy"] = "help_to_buy";
    PurchaseScheme["right_to_buy"] = "right_to_buy";
    PurchaseScheme["starter_homes"] = "starter_homes";
    return PurchaseScheme;
}({});
var $6e6e522132305404$export$abb947fd85a72005 = /*#__PURE__*/ function(DesiredTermChange) {
    DesiredTermChange["unknown"] = "unknown";
    DesiredTermChange["Keep_The_Same"] = "Keep_The_Same";
    DesiredTermChange["Decrease"] = "Decrease";
    DesiredTermChange["Increase"] = "Increase";
    return DesiredTermChange;
}({});
var $6e6e522132305404$export$1d754f70af7fac9d = /*#__PURE__*/ function(PurchaseType) {
    PurchaseType["Unknown"] = "Unknown";
    PurchaseType["FirstTimeBuyer"] = "FirstTimeBuyer";
    PurchaseType["HomeMove"] = "HomeMove";
    PurchaseType["SecondHome"] = "SecondHome";
    return PurchaseType;
}({});
var $6e6e522132305404$export$c69e63fcaab9c4c1 = /*#__PURE__*/ function(CurrentPropertyStatus) {
    CurrentPropertyStatus["Unknown"] = "Unknown";
    CurrentPropertyStatus["ListedForSale"] = "ListedForSale";
    CurrentPropertyStatus["NotListedForSale"] = "NotListedForSale";
    return CurrentPropertyStatus;
}({});
var $6e6e522132305404$export$add3817567d2de5d = /*#__PURE__*/ function(ListedPropertyOfferStatus) {
    ListedPropertyOfferStatus["Unknown"] = "Unknown";
    ListedPropertyOfferStatus["AcceptedOffer"] = "AcceptedOffer";
    ListedPropertyOfferStatus["ReceivedOffer"] = "ReceivedOffer";
    ListedPropertyOfferStatus["NoOffer"] = "NoOffer";
    return ListedPropertyOfferStatus;
}({});
var $6e6e522132305404$export$ad75ab313c6f1a6e = /*#__PURE__*/ function(DesiredTimeToProceed) {
    DesiredTimeToProceed["Unknown"] = "Unknown";
    DesiredTimeToProceed["AsSoonAsPossible"] = "AsSoonAsPossible";
    DesiredTimeToProceed["ThreeToSixMonths"] = "ThreeToSixMonths";
    DesiredTimeToProceed["TwelveToEighteenMonths"] = "TwelveToEighteenMonths";
    DesiredTimeToProceed["NotSure"] = "NotSure";
    DesiredTimeToProceed["SixToTwelveMonths"] = "SixToTwelveMonths";
    DesiredTimeToProceed["NextThreeMonths"] = "NextThreeMonths";
    DesiredTimeToProceed["NextSixMonths"] = "NextSixMonths";
    DesiredTimeToProceed["NextTwelveMonths"] = "NextTwelveMonths";
    DesiredTimeToProceed["MoreThanTwelveMonths"] = "MoreThanTwelveMonths";
    return DesiredTimeToProceed;
}({});
var $6e6e522132305404$export$8bd1656dab26b046 = /*#__PURE__*/ function(PurchaseReason) {
    PurchaseReason["Unknown"] = "Unknown";
    PurchaseReason["NeedMoreSpace"] = "NeedMoreSpace";
    PurchaseReason["Downsizing"] = "Downsizing";
    PurchaseReason["Relocating"] = "Relocating";
    PurchaseReason["MovingInWithPartner"] = "MovingInWithPartner";
    PurchaseReason["Other"] = "Other";
    return PurchaseReason;
}({});
var $6e6e522132305404$export$8f15a9875acf08a4 = /*#__PURE__*/ function(RemortgageReason) {
    RemortgageReason["Unknown"] = "Unknown";
    RemortgageReason["Better_rate"] = "Better_rate";
    RemortgageReason["Additional_borrowing"] = "Additional_borrowing";
    RemortgageReason["Divorce_or_relationship_split"] = "Divorce_or_relationship_split";
    RemortgageReason["Release_money"] = "Release_money";
    RemortgageReason["Other"] = "Other";
    RemortgageReason["New_fixed_term"] = "New_fixed_term";
    return RemortgageReason;
}({});
var $6e6e522132305404$export$61015e78fc5b5fae = /*#__PURE__*/ function(AdditionalBorrowingReason) {
    AdditionalBorrowingReason["Unknown"] = "Unknown";
    AdditionalBorrowingReason["Home_improvements"] = "Home_improvements";
    AdditionalBorrowingReason["Debt_consolidation"] = "Debt_consolidation";
    AdditionalBorrowingReason["School_fees"] = "School_fees";
    AdditionalBorrowingReason["Holiday"] = "Holiday";
    AdditionalBorrowingReason["Car"] = "Car";
    AdditionalBorrowingReason["Buy_another_property"] = "Buy_another_property";
    AdditionalBorrowingReason["Business_purposes"] = "Business_purposes";
    AdditionalBorrowingReason["Divorce_settlement"] = "Divorce_settlement";
    AdditionalBorrowingReason["Wedding"] = "Wedding";
    AdditionalBorrowingReason["Other"] = "Other";
    return AdditionalBorrowingReason;
}({});
var $6e6e522132305404$export$76afec25c076d535 = /*#__PURE__*/ function(Occupancy) {
    Occupancy[Occupancy["Unknown"] = 0] = "Unknown";
    Occupancy["LiveInProperty"] = "Live_in_property";
    Occupancy["RentItOut"] = "Rent_it_out";
    Occupancy["AdditionalProperty"] = "Additional_property";
    return Occupancy;
}({});
var $6e6e522132305404$export$18a2be9195644f38 = /*#__PURE__*/ function(Location) {
    Location[Location["unknown"] = 0] = "unknown";
    Location["England"] = "England";
    Location["Scotland"] = "Scotland";
    Location["Wales"] = "Wales";
    Location["Northern_Ireland"] = "Northern_Ireland";
    return Location;
}({});
var $6e6e522132305404$export$9542f959509ad58 = /*#__PURE__*/ function(OpportunityStage) {
    OpportunityStage["online"] = "Online";
    OpportunityStage["factfind"] = "Fact Find";
    OpportunityStage["quoted"] = "Quoted";
    OpportunityStage["returned"] = "Returned to Adviser";
    OpportunityStage["dip"] = "DIP";
    OpportunityStage["awaiting"] = "Awaiting Handover";
    OpportunityStage["presub"] = "Pre Submission";
    OpportunityStage["submitted"] = "Submitted";
    OpportunityStage["packaged"] = "Fully Packaged";
    OpportunityStage["offer"] = "Offer Received";
    OpportunityStage["exchanged"] = "Exchanged";
    OpportunityStage["closedwon"] = "Closed Won";
    OpportunityStage["closedlost"] = "Closed Lost";
    OpportunityStage["completionSet"] = "Completion Set";
    OpportunityStage["ineligable"] = "Ineligible";
    OpportunityStage["mortgageready"] = "Mortgage Ready";
    OpportunityStage["specialist"] = "Specialist Help";
    OpportunityStage["coach"] = "MortgageCoach";
    return OpportunityStage;
}({});
var $6e6e522132305404$export$48ea269755562084 = /*#__PURE__*/ function(Flag) {
    Flag["Unknown"] = "Unknown";
    Flag["CompletedDiscovery"] = "CompletedDiscovery";
    Flag["CompletedFactFindAssumptions"] = "CompletedFactFindAssumptions";
    Flag["CompletedFactFindMortgage"] = "CompletedFactFindMortgage";
    Flag["CompletedFactFindProperty"] = "CompletedFactFindProperty";
    Flag["CompletedFactFindPersonal"] = "CompletedFactFindPersonal";
    Flag["CompletedFactFindIncome"] = "CompletedFactFindIncome";
    Flag["CompletedFactFindPreferences"] = "CompletedFactFindPreferences";
    Flag["EligibilityResultApproved"] = "EligibilityResultApproved";
    Flag["EligibilityResultUnaffordable"] = "EligibilityResultUnaffordable";
    Flag["EligibilityResultReferred"] = "EligibilityResultReferred";
    Flag["EligibilityResultCoach"] = "EligibilityResultCoach";
    Flag["EligibilityResultNoHelp"] = "EligibilityResultNoHelp";
    Flag["HasQuote"] = "HasQuote";
    Flag["SubmittedForDip"] = "SubmittedForDip";
    Flag["ClosedWon"] = "ClosedWon";
    Flag["ClosedLost"] = "ClosedLost";
    Flag["RequestedCallback"] = "RequestedCallback";
    Flag["HasSeenComparisonTable"] = "HasSeenComparisonTable";
    Flag["IsInSecondaryRatesExperiment"] = "IsInSecondaryRatesExperiment";
    return Flag;
}({});
var $6e6e522132305404$export$de764382d0a0fb75 = /*#__PURE__*/ function(ExpenditureFrequency) {
    ExpenditureFrequency[ExpenditureFrequency["Unknown"] = 0] = "Unknown";
    ExpenditureFrequency[ExpenditureFrequency["Daily"] = 1] = "Daily";
    ExpenditureFrequency[ExpenditureFrequency["Weekly"] = 2] = "Weekly";
    ExpenditureFrequency[ExpenditureFrequency["Monthly"] = 3] = "Monthly";
    ExpenditureFrequency[ExpenditureFrequency["Yearly"] = 4] = "Yearly";
    return ExpenditureFrequency;
}({});
var $6e6e522132305404$export$c3bf039b082ba363 = /*#__PURE__*/ function(RemoPersona) {
    RemoPersona["Unknown"] = "Unknown";
    RemoPersona["SeeCurrentInterestRate"] = "SeeCurrentInterestRate";
    RemoPersona["CompareRemortgageDeals"] = "CompareRemortgageDeals";
    RemoPersona["GetRemortgageAdvice"] = "GetRemortgageAdvice";
    RemoPersona["ApplyForRemortgage"] = "ApplyForRemortgage";
    return RemoPersona;
}({});
var $6e6e522132305404$export$5a89875fe93746bb = /*#__PURE__*/ function(ProtectionTypes) {
    ProtectionTypes["LifeInsurance"] = "LifeInsurance";
    ProtectionTypes["CriticalIllness"] = "CriticalIllness";
    ProtectionTypes["IncomeProtection"] = "IncomeProtection";
    ProtectionTypes["FamilyIncome"] = "FamilyIncome";
    ProtectionTypes["DeathInService"] = "DeathInService";
    ProtectionTypes["None"] = "none";
    ProtectionTypes["Unknown"] = "unknown";
    return ProtectionTypes;
}({});


var $92da6ce0a9463af6$export$f5805e4abe6a2ac5 = /*#__PURE__*/ function(ApplicationReason) {
    ApplicationReason["Unknown"] = "Unknown";
    ApplicationReason["FoundProperty"] = "Found_a_Property";
    ApplicationReason["LookingForProperty"] = "Looking_for_a_Property";
    ApplicationReason["Remortgage"] = "Remortgage";
    return ApplicationReason;
}({});


var $46bdcc345e36a539$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["NotFoundAProperty"] = "NotFoundAProperty";
    Cohort["FoundAProperty"] = "FoundAProperty";
    Cohort["Purchase"] = "Purchase";
    Cohort["Remortgage"] = "Remortgage";
    Cohort["StuckInERC"] = "StuckInERC";
    Cohort["FirstTimeBuyer"] = "FirstTimeBuyer";
    Cohort["MovingHome"] = "MovingHome";
    Cohort["SecondHome"] = "SecondHome";
    Cohort["BuyToLet"] = "BuyToLet";
    Cohort["LikeForLike"] = "LikeForLike";
    Cohort["AdditionalBorrowing"] = "AdditionalBorrowing";
    Cohort["ReleaseMoney"] = "ReleaseMoney";
    Cohort["PostOffer"] = "PostOffer";
    Cohort["PreOffer"] = "PreOffer";
    return Cohort;
}({});


var $ddb542feed52691a$exports = {};

var $2xTNA = parcelRequire("2xTNA");
!function(t, e) {
    $ddb542feed52691a$exports = e();
}(undefined, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function m(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function z(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function a(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function p(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function u(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function S(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function O(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == (typeof e === "undefined" ? "undefined" : (0, $2xTNA._)(e)) ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function l(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function $(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, _$M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, _$M) : l(0, _$M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), _$M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function y(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var _$M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * _$M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function h(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function d(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, _$M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function D() {
                return b.m(y, m);
            };
            switch(_$M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $2c7ec95712fb279f$exports = {};
!function(e, t) {
    $2c7ec95712fb279f$exports = t();
}($2c7ec95712fb279f$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var _$t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((_$t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(_$t.$D);
                    case "gggg":
                        return _$t.weekYear();
                    case "GGGG":
                        return _$t.isoWeekYear();
                    case "wo":
                        return r.ordinal(_$t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(_$t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(_$t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === _$t.$H ? 24 : _$t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(_$t.$d.getTime() / 1e3);
                    case "x":
                        return _$t.$d.getTime();
                    case "z":
                        return "[" + _$t.offsetName() + "]";
                    case "zzz":
                        return "[" + _$t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});


var $8f00a1e4b1061768$exports = {};
!function(e, t) {
    $8f00a1e4b1061768$exports = t();
}($8f00a1e4b1061768$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function a(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function f(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function u(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function d(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, _$n = 0, r = 0; _$n < a; _$n += 1){
                var i = o[_$n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var _$n = e.hours;
                    t ? _$n < 12 && (e.hours += 12) : 12 === _$n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var _$t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(_$t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && _$t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $b94cb29750562f31$exports = {};
!function(t, i) {
    $b94cb29750562f31$exports = i();
}($b94cb29750562f31$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var _$n = this.$utils().u;
            if (_$n(s)) return this.$u ? 0 : _$n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var _$s = t.match(i);
                if (!_$s) return null;
                var _$f = ("" + _$s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], _$n = _$f[0], u = 60 * +_$f[1] + +_$f[2];
                return 0 === u ? 0 : "+" === _$n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), _$f = n(t).local();
            return c.call(s, _$f, i, e);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($2c7ec95712fb279f$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($8f00a1e4b1061768$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($b94cb29750562f31$exports))));
function $45f64f2ccb2647eb$export$4e8e665eb8b06bae(dateOne, dateTwo, unit) {
    var d1 = (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(dateOne);
    var d2 = (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(dateTwo);
    return d2.diff(d1, unit);
}
function $45f64f2ccb2647eb$export$10a49f7c1caf843e(date) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(date).toDate();
}
function $45f64f2ccb2647eb$export$b00030cc143c3fde(date, format) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(date, format).toDate();
}
function $45f64f2ccb2647eb$export$68962dbd27cd2e36(date, format) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(date).format(format);
}
function $45f64f2ccb2647eb$export$8bc67ae85ef4b74f(date, amount, unit) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(date).subtract(amount, unit).toDate();
}
function $45f64f2ccb2647eb$export$90468357bd30a7ec(input) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "DD/MM/YYYY", strict = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports))).utc(input, format, strict).isValid();
}
function $45f64f2ccb2647eb$export$aa8f560924d03ba0(months) {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setMonth(date.getMonth() - months);
    return date;
}
function $45f64f2ccb2647eb$export$d38050b0611a784b(decimalYears) {
    // Extract the whole number part for years
    var years = Math.floor(decimalYears);
    // Extract the decimal part and convert it to months
    // Assuming .1 year is equivalent to 1 month
    var monthsDecimal = decimalYears - years;
    var months = Math.round(monthsDecimal * 12);
    return {
        years: years,
        months: months
    };
}
function $45f64f2ccb2647eb$export$c6388e33355c3eca(totalMonths) {
    var years = Math.floor(totalMonths / 12);
    var months = totalMonths % 12;
    if (months === 0) {
        var yearStr = years === 1 ? "year" : "years";
        return "".concat(years, " ").concat(yearStr);
    }
    var yearStr1 = years === 1 ? "year" : "years";
    var monthStr = months === 1 ? "month" : "months";
    return "".concat(years, " ").concat(yearStr1, " and ").concat(months, " ").concat(monthStr);
}
function $45f64f2ccb2647eb$export$fb9f91b434a357bf(dateString) {
    var inputDate = new Date(dateString);
    var today = new Date();
    // Reset time to midnight for accurate date comparison
    var inputDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    var todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var yesterdayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    // Compare dates
    if (inputDay.getTime() === todayDay.getTime()) return "Today";
    else if (inputDay.getTime() === yesterdayDay.getTime()) return "Yesterday";
    else {
        // Format as DD/MM-YY
        var day = String(inputDate.getDate()).padStart(2, "0");
        var month = String(inputDate.getMonth() + 1).padStart(2, "0");
        var year = String(inputDate.getFullYear()).slice(-2);
        return "".concat(day, "/").concat(month, "/").concat(year);
    }
}





var $cCIJH = parcelRequire("cCIJH");
var $d48d778937567d64$export$155ec85c4e3b5e85 = (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).create();
$d48d778937567d64$export$155ec85c4e3b5e85.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    // Log the error to Sentry
    $cCIJH.captureException(error);
    // Re-throw the error so the promise is rejected
    throw error;
});




var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $dMrZK = parcelRequire("dMrZK");


var $aeef918cf5f64561$exports = {};
$aeef918cf5f64561$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $2739329a1f6293e9$exports = {};
$2739329a1f6293e9$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $34764d5ecd07c190$exports = {};
$34764d5ecd07c190$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2026-06-20T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $6cc361a30cac7c0f$exports = {};
$6cc361a30cac7c0f$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $b8bf0e18d5a2674a$exports = {};
$b8bf0e18d5a2674a$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Offer Received\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Halifax\"},\"edeFlag\":\"Offer Received\"}}");


var $ab343dab118a7ad9$exports = {};
$ab343dab118a7ad9$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $258ff8317b470781$exports = {};
$258ff8317b470781$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Quoted\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Quoted\"}}");


var $4641594f0cc6f71e$exports = {};
$4641594f0cc6f71e$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $3a4e916bd69de311$exports = {};
$3a4e916bd69de311$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Quoted\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Quoted\"}}");


var $ab15d04df7c0f10c$exports = {};
$ab15d04df7c0f10c$exports = JSON.parse("{\"recommendationAccepted\":false,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $30f597ced04b169b$exports = {};
$30f597ced04b169b$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Quoted\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Quoted\"}}");


var $69291d77200652ba$exports = {};
$69291d77200652ba$exports = JSON.parse("{\"recommendationAccepted\":true,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $1bbe374bac14cdc1$exports = {};
$1bbe374bac14cdc1$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Quoted\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Quoted\"}}");


var $eb26e7076e89f15b$exports = {};
$eb26e7076e89f15b$exports = JSON.parse("{\"recommendationAccepted\":true,\"numberOfDocumentsRequested\":2,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $5fe31ac0baf2005e$exports = {};
$5fe31ac0baf2005e$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2026-06-20T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Submitted\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Submitted\"}}");


var $958e1e0e5a29eecd$exports = {};
$958e1e0e5a29eecd$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Closed Won\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Halifax\"},\"edeFlag\":\"Closed Won\"}}");


var $7d939ed6e2842cfe$exports = {};
$7d939ed6e2842cfe$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Completion Set\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Halifax\"},\"edeFlag\":\"Completion Set\"}}");


var $a8d8dfe4ca685883$exports = {};
$a8d8dfe4ca685883$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"DIP\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Halifax\"},\"edeFlag\":\"DIP\"}}");


var $eeb78505b2a0df2d$exports = {};
$eeb78505b2a0df2d$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Closed Lost\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Halifax\"},\"edeFlag\":\"Closed Lost\"}}");


var $05d3d2218c29b9f3$exports = {};
$05d3d2218c29b9f3$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Pre Submission\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Halifax\"},\"edeFlag\":\"Pre Submission\"}}");


var $7bac3e058c1aeb1d$exports = {};
$7bac3e058c1aeb1d$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $e7d421f1e8300114$exports = {};
$e7d421f1e8300114$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-07-19T15:30:00.000Z\",\"createdOn\":\"2025-06-18T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $bdb1e0e338aa9f48$exports = {};
$bdb1e0e338aa9f48$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $96d6aadba8e155ec$exports = {};
$96d6aadba8e155ec$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $376fc228c3d95576$exports = {};
$376fc228c3d95576$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $a613b4ef18216407$exports = {};
$a613b4ef18216407$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"2026-06-23T12:30:01.492Z\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $3774c4f1e28e6175$exports = {};
$3774c4f1e28e6175$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $67bd00c08b6cab33$exports = {};
$67bd00c08b6cab33$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"John Woah\",\"ownerEmailAddress\":\"johnwoah@mojomortgages.com\"}");


var $9e5d318c0d381b16$exports = {};
$9e5d318c0d381b16$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Mojo Mortgages Dev Mode\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\"}");


var $71c1d3b97e3b1467$exports = {};
$71c1d3b97e3b1467$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"John Smith\",\"ownerEmailAddress\":\"john.smith@mojomortgages.com\",\"mipIssuedToCustomer\":true,\"amount\":null,\"stageName\":\"Nurture\",\"opportunityRecordType1\":\"PurchaseOpportunity\",\"currentExperiments\":\"foobar1;quubar2;zuubaz3\",\"property\":{\"firstLineAddress\":\"45 Sample Street\",\"value\":285000}}");


var $b4df87e9a451b1aa$exports = {};
$b4df87e9a451b1aa$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Lewis Kinsella\",\"ownerEmailAddress\":\"lewis.kinsella@mojomortgages.com\",\"flexRoles2\":\"Mortgage Expert\",\"mipIssuedToCustomer\":true,\"amount\":null,\"stageName\":\"Nurture\",\"opportunityRecordType1\":\"PurchaseOpportunity\",\"property\":{\"firstLineAddress\":\"123 Fake Street\",\"value\":375000}}");


var $3106fef3c2313ab0$exports = {};
$3106fef3c2313ab0$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"John Smith\",\"ownerEmailAddress\":\"john.smith@mojomortgages.com\",\"mipIssuedToCustomer\":false,\"amount\":null,\"stageName\":\"Online\",\"opportunityRecordType1\":\"RemortgageOpportunity\"}");


var $9a52a0ec2cb3eb95$exports = {};
$9a52a0ec2cb3eb95$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"BTLSpecialist\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"BTLSpecialist\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Rent it out\",\"propertyValue\":500000},\"occupancy\":\"Rent it out\",\"service\":{\"level\":\"Specialist\",\"status\":\"Payment required\",\"checkoutSessionUrl\":\"https://checkout.stripe.com/test-session\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"BTL Purchase\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Quoted\",\"applicationManager\":null,\"advisor\":null,\"lender\":\"Barclays\"},\"edeFlag\":\"Quoted\"}}");


var $896cf5ca36dcf5b9$exports = {};
$896cf5ca36dcf5b9$exports = JSON.parse("{\"recommendationAccepted\":true,\"documentsRequested\":false,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"Sarah Johnson\",\"ownerEmailAddress\":\"devmode@mojomortgages.com\",\"flexRoles2\":\"BTL Specialist Mortgage Expert\",\"amount\":499,\"stageName\":\"Quoted\",\"opportunityRecordType1\":\"BTL Purchase\",\"mipIssuedToCustomer\":false}");


var $0842770b94fba015$exports = {};
$0842770b94fba015$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $4d1619018cb6e81b$exports = {};
$4d1619018cb6e81b$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"John Smith\",\"ownerEmailAddress\":\"john.smith@mojomortgages.com\",\"mipIssuedToCustomer\":false,\"amount\":null,\"stageName\":\"Online\",\"opportunityRecordType1\":\"RemortgageOpportunity\",\"currentExperiments\":\"split-ff-next-steps-variant-v4\"}");


var $760f5263886bd4fd$exports = {};
$760f5263886bd4fd$exports = JSON.parse("{\"income\":[{\"salaryDeductions\":[],\"limitedCompanyDirector\":{\"grossSalary\":77000},\"firstApplicant\":true,\"incomeBenefits\":[],\"salarySuppliments\":[],\"additionalIncomes\":[{\"payFrequency\":\"annually\",\"payPerPeriod\":100,\"isProven\":true,\"id\":\"ddbf112a5f5237bfdfb26801e4992645\",\"type\":\"Other\"}],\"id\":\"fefb2688cb952c772ef3d4dfa98fd96d\",\"employmentStatus\":\"DirectorLimitedCompany\"}],\"preferences\":{\"marketingPreferences\":\"email;phone;sms\",\"feePaymentPreference\":\"add_to_loan\",\"initialPeriodPreference\":\"two_years\",\"repaymentMethodPreference\":\"capital_repayment\",\"mortgageTypePreference\":\"fixed_rate\"},\"appointments\":[{\"calendlyEventName\":\"Mojo Mortgage Appointment\",\"utmSource\":\"Online\",\"acuityAppointmentId\":1490553758,\"calendlyEventDuration\":30,\"utmMedium\":\"Results Page\",\"assignee\":\"Alan Smithee\",\"category\":\"CoreInitial\",\"appointmentDate\":\"2025-06-19T15:30:00.000Z\",\"createdOn\":\"2025-06-19T14:23:16.692Z\",\"utmCampaign\":\"NewBooking\"}],\"applicationInProgress\":\"No\",\"remortgageReason\":\"New_fixed_term\",\"applicants\":[{\"forename\":\"Mortgages\",\"insuranceBenefits\":\"none\",\"intercomUserExternalId\":\"57af31fe-a3a7-4b9c-852f-7cc73c6a25a6\",\"surname\":\"EngageScore1\",\"firstApplicant\":true,\"applicantAddressHistories\":[{\"postcode\":\"NG1 6DQ\",\"from\":\"2001-08-01T00:00:00.000Z\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\",\"currentAddress\":true}],\"dateOfBirth\":\"1980-01-31T00:00:00.000Z\",\"telephone\":\"07971123456\",\"employmentBenefits\":\"IncomeProtection\",\"id\":\"66d3afc3a9f9394366c3a42cfc729dac\",\"title\":\"Dr\",\"email\":\"mymojotest1@mojo.com\"}],\"borrowingDetails\":{\"firstTimeBuyer\":false,\"desiredTimeToProceed\":\"AsSoonAsPossible\",\"desiredMonthlyRepayment\":2500,\"additionalBorrowing\":0},\"createdOn\":\"2025-06-19T14:22:53.733Z\",\"userId\":41565,\"completePropertyDetails\":{\"typeOfProperty\":\"flat\",\"propertyAddress\":{\"postcode\":\"NG1 6DQ\",\"nameNumber\":\"18\",\"city\":\"Nottingham\",\"street\":\"Friar Lane\"},\"numberOfBedrooms\":2},\"friendlyId\":\"KV25225185\",\"basicPropertyDetails\":{\"occupancy\":\"Live_in_property\",\"propertyValue\":500000},\"currentMortgage\":{\"monthlyPayment\":2000,\"yearsRemaining\":15,\"mortgageBalance\":200000,\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\",\"currentLender\":\"Santander UK Plc\",\"currentLenderCode\":\"CAN\",\"sixMonthsOrMoreRemaining\":\"no\"},\"term\":15,\"tls\":{\"ptLikelyCategory\":\"BigQuery\",\"isPtLikely\":true,\"appointmentTypeId\":26973384,\"color\":\"GREEN\",\"tier\":\"B\",\"isLocoCustomer\":true},\"remortgageDetails\":{\"remoPersona\":\"ApplyForRemortgage\",\"existingLenderCode\":\"CAN\",\"existingLender\":\"Santander UK Plc\",\"initialPeriodEndDate\":\"2025-07-31T00:00:00.000Z\"},\"applicationId\":\"be81e264598e1ac19c71e68bab0426af\",\"applicationReason\":\"Remortgage\",\"brand\":\"mojo\",\"metadata\":{\"flags\":[\"CompletedDiscovery\",\"CompletedFactFindAssumptions\",\"CompletedFactFindProperty\",\"CompletedFactFindMortgage\",\"CompletedFactFindPersonal\",\"CompletedFactFindProtection\",\"CompletedFactFindPreferences\",\"EligibilityResultApproved\"],\"documents\":[],\"opportunity\":{\"status\":\"Mortgage Ready\",\"applicationManager\":null,\"advisor\":null,\"lender\":null},\"edeFlag\":\"Mortgage Ready\"}}");


var $8316628e3eae250d$exports = {};
$8316628e3eae250d$exports = JSON.parse("{\"recommendationAccepted\":null,\"numberOfDocumentsRequested\":0,\"setCompletionDateForEmail\":\"\",\"opportunityOwnerTextForEmail\":\"John Smith\",\"ownerEmailAddress\":\"john.smith@mojomortgages.com\",\"mipIssuedToCustomer\":false,\"amount\":null,\"stageName\":\"Online\",\"opportunityRecordType1\":\"RemortgageOpportunity\",\"currentExperiments\":\"split-ff-next-steps-variant-v4\"}");


var $3d0cae146af65a6b$exports = {};
$3d0cae146af65a6b$exports = JSON.parse("{\"records\":{\"Opportunity\":[{\"Id\":\"006Qz0000c2d0b8AAA\",\"External_ID__c\":\"Opportunity_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610\",\"Customer_ID__c\":\"VR23200808\",\"Deposit_Deposit__c\":65000,\"interested_in_conveyancing__c\":null,\"Current_Property_Status__c\":null,\"Current_Property_Offer_Status__c\":null,\"Sale_price__c\":null,\"Mortgage_on_current_property__c\":null}],\"Deposit_source__c\":[],\"Applicant__c\":[{\"Id\":\"a0AQz0000a25bf6AAA\",\"External_ID__c\":\"Applicant_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b\",\"Marital_Status1_Applicant__c\":null,\"Occupancy_status__c\":null,\"Relationship_to_second_applicant__c\":null}],\"Dependants__c\":[],\"Expenditure__c\":[],\"Income_Employment__c\":[],\"Property__c\":[],\"PropertyFlag__c\":[],\"PropertyFieldConfirmation__c\":[]},\"failed\":[]}");


var $030964e4c30216bd$exports = {};
$030964e4c30216bd$exports = JSON.parse("{\"records\":{\"Opportunity\":[{\"Id\":\"006Qz0000c2d0b8AAA\",\"External_ID__c\":\"Opportunity_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610\",\"Customer_ID__c\":\"VR23200808\",\"Deposit_Deposit__c\":65000,\"interested_in_conveyancing__c\":false,\"Current_Property_Status__c\":\"Listed for sale\",\"Current_Property_Offer_Status__c\":\"Accepted offer\",\"Sale_price__c\":285000,\"Mortgage_on_current_property__c\":\"Yes\"}],\"Deposit_source__c\":[{\"Id\":\"a0DQz000017abb7AAA\",\"External_ID__c\":\"DepositSource_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610_Saleofproperty\",\"Opportunity__c\":\"006Qz0000c2d0b8AAA\",\"Deposit_source_type__c\":\"Sale of property\",\"Deposit_amount__c\":55000,\"Deposit_location__c\":\"UK Bank Account\"},{\"Id\":\"a0DQz0000816cc8AAA\",\"External_ID__c\":\"DepositSource_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610_Savings\",\"Opportunity__c\":\"006Qz0000c2d0b8AAA\",\"Deposit_source_type__c\":\"Savings\",\"Deposit_amount__c\":10000,\"Deposit_location__c\":\"UK Bank Account\"}],\"Applicant__c\":[{\"Id\":\"a0AQz0000a25bf6AAA\",\"External_ID__c\":\"Applicant_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b\",\"Marital_Status1_Applicant__c\":\"Single\",\"Occupancy_status__c\":\"Owner\",\"Relationship_to_second_applicant__c\":null}],\"Dependants__c\":[{\"Id\":\"a0BQz0000944f83AAA\",\"External_ID__c\":\"Dependants_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b_0\",\"Applicant__c\":\"a0AQz0000a25bf6AAA\",\"Lead_applicant__c\":\"a0AQz0000a25bf6AAA\",\"Second_applicant__c\":null,\"Name\":\"Dependent 1\",\"Age__c\":6,\"Age_period__c\":\"Years\",\"Relationship__c\":\"Child\"},{\"Id\":\"a0BQz0000279294AAA\",\"External_ID__c\":\"Dependants_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b_1\",\"Applicant__c\":\"a0AQz0000a25bf6AAA\",\"Lead_applicant__c\":\"a0AQz0000a25bf6AAA\",\"Second_applicant__c\":null,\"Name\":\"Dependent 2\",\"Age__c\":18,\"Age_period__c\":\"Months\",\"Relationship__c\":\"Child\"}],\"Expenditure__c\":[{\"Id\":\"a0CQz0000616b17AAA\",\"External_ID__c\":\"Expenditure__c_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610\",\"Applicant__c\":\"a0AQz0000a25bf6AAA\",\"Childcare__c\":420,\"Childcare_2__c\":\"Monthly\",\"Child_Maintanence_Payments__c\":0,\"Child_Maintenance_Payments_2__c\":\"Monthly\"}],\"Income_Employment__c\":[{\"Id\":\"a0EQz0000125b2cAAA\",\"External_ID__c\":\"IncomeEmployment_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b\",\"Applicant__c\":\"a0AQz0000a25bf6AAA\",\"Job_Title__c\":\"Software Engineer\",\"Income_Changes_2_Years__c\":\"Stay about the same\",\"Employer_Name__c\":\"Brightwell Analytics Ltd\",\"On_Probation__c\":\"No\",\"st_nametradedunder__c\":null,\"director_companyname__c\":null,\"llp_name__c\":null}],\"Property__c\":[{\"Id\":\"a0PQz000068ca36AAA\",\"External_ID__c\":\"Property_VR23200808\",\"Opportunity__c\":\"006Qz0000c2d0b8AAA\",\"Source__c\":\"Online\",\"Postcode__c\":\"BS6 7QR\",\"FirstLineOfAddress__c\":\"14, Cotham Road\",\"Town__c\":\"Bristol\",\"Region__c\":\"South West\",\"Country__c\":\"England\",\"YearBuilt__c\":1934,\"Tenure__c\":\"Freehold\",\"TenureLeaseRemaining__c\":null,\"IsServiceCharge__c\":false,\"ServiceChargeAmount__c\":null,\"GroundRentAmount__c\":null,\"IsStandardConstruction__c\":true,\"ConstructionType__c\":\"Brick\",\"RoofType__c\":\"Pitched Tiled\",\"PropertyType__c\":\"House\",\"HouseOrFlatType__c\":\"Semi-Detached House\",\"FlatType__c\":null,\"IsNewBuild__c\":false,\"IsPropertyOverTenYears__c\":true,\"IsSelfBuildProject__c\":false,\"NumberOfFloorsInBuilding__c\":null,\"WhatFloorIsFlatOn__c\":null,\"IsTopFloor__c\":null,\"IsExLocalAuthority__c\":false,\"Bedrooms__c\":3,\"Kitchens__c\":1,\"HasMoreThanOneKitchen__c\":false,\"ReceptionRooms__c\":2,\"EpcRating__c\":\"D\",\"HasValidEpc__c\":true,\"CouncilTaxBand__c\":\"D\",\"CouncilTaxPaymentFrequency__c\":\"Monthly\",\"CouncilTaxCost__c\":192}],\"PropertyFlag__c\":[{\"Id\":\"a0FQz0000405c9cAAA\",\"External_ID__c\":\"PropertyFlag_VR23200808_LargePlot\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FlagKey__c\":\"LargePlot\",\"Source__c\":\"Online\",\"IsActive__c\":true},{\"Id\":\"a0FQz00007cea42AAA\",\"External_ID__c\":\"PropertyFlag_VR23200808_AirbnbProperty\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FlagKey__c\":\"AirbnbProperty\",\"Source__c\":\"Online\",\"IsActive__c\":false}],\"PropertyFieldConfirmation__c\":[{\"Id\":\"a0GQz000056356cAAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_YearBuilt__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"YearBuilt__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz0000687053AAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_Tenure__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"Tenure__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz0000d7a017AAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_IsServiceCharge__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"IsServiceCharge__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz000070af5eAAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_IsStandardConstruction__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"IsStandardConstruction__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz000025ee77AAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_RoofType__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"RoofType__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz00001f5dcfAAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_Bedrooms__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"Bedrooms__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz0000180b7aAAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_Kitchens__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"Kitchens__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"},{\"Id\":\"a0GQz000076e7b3AAA\",\"External_ID__c\":\"PropertyFieldConfirmation_VR23200808_ReceptionRooms__c\",\"Property__c\":\"a0PQz000068ca36AAA\",\"FieldApiName__c\":\"ReceptionRooms__c\",\"ConfirmationStatus__c\":\"ConfirmedByCustomerViaStreetDataApi\"}]},\"failed\":[]}");


function $e1865584d8948220$export$eb412cb11d91b25c(summaries) {
    var scenario = (0, $cda636b84ca95de8$export$229888be98753136)();
    if (scenario !== (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointment && scenario !== (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointmentDocsOnly) return summaries;
    var appointmentDate = new Date();
    appointmentDate.setDate(appointmentDate.getDate() + 7);
    appointmentDate.setHours(10, 0, 0, 0);
    return summaries.map(function(summary) {
        return (0, $7XD9P._)((0, $hRCmZ._)({}, summary), {
            stage: (0, $6e6e522132305404$export$9542f959509ad58).mortgageready,
            tls: (0, $7XD9P._)((0, $hRCmZ._)({}, summary.tls), {
                colour: "Green",
                tier: "A"
            }),
            hasAppointments: true,
            appointments: [
                {
                    acuityAppointmentId: 1,
                    appointmentTypeId: 1,
                    appointmentDate: appointmentDate.toISOString(),
                    assignee: "Jane Expert",
                    calendlyEventDuration: 30,
                    calendlyEventName: "Mojo Mortgage Appointment",
                    createdOn: new Date().toISOString(),
                    isCancelled: false
                }
            ]
        });
    });
}
function $e1865584d8948220$export$205bc258834dc08() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var scenario, applicationData;
        return (0, $dMrZK.__generator)(this, function(_state) {
            scenario = (0, $cda636b84ca95de8$export$229888be98753136)();
            if (!scenario) throw new Error("Dev mode enabled but no valid scenario found");
            switch(scenario){
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Advise:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($aeef918cf5f64561$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Booked:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($34764d5ecd07c190$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Offer:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($b8bf0e18d5a2674a$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationPending:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($258ff8317b470781$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationReady:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($3a4e916bd69de311$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationAccepted:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($30f597ced04b169b$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationAcceptedDocsRequired:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($1bbe374bac14cdc1$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Application:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($5fe31ac0baf2005e$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Won:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($958e1e0e5a29eecd$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).CompletionSet:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($7d939ed6e2842cfe$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Dip:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($a8d8dfe4ca685883$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Lost:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($eeb78505b2a0df2d$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Wip:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($05d3d2218c29b9f3$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).OfferAccepted:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($7bac3e058c1aeb1d$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).OfferAcceptedBooked:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($e7d421f1e8300114$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Core:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($bdb1e0e338aa9f48$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).BTLSpecialistPayment:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($9a52a0ec2cb3eb95$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointment:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($0842770b94fba015$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointmentDocsOnly:
                    applicationData = (0, (/*@__PURE__*/$parcel$interopDefault($760f5263886bd4fd$exports)));
                    break;
                default:
                    throw new Error("Unknown scenario: ".concat(scenario));
            }
            console.log("\uD83D\uDD27 Dev mode active: Using application data from ".concat(scenario, ".json"));
            return [
                2,
                applicationData
            ];
        });
    })();
}
function $e1865584d8948220$export$b70265791d2079d4() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var scenario, statusData;
        return (0, $dMrZK.__generator)(this, function(_state) {
            scenario = (0, $cda636b84ca95de8$export$229888be98753136)();
            if (!scenario) throw new Error("Dev mode enabled but no valid scenario found");
            switch(scenario){
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Advise:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($2739329a1f6293e9$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Booked:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($6cc361a30cac7c0f$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Offer:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($ab343dab118a7ad9$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationPending:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($4641594f0cc6f71e$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationReady:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($ab15d04df7c0f10c$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationAccepted:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($69291d77200652ba$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).RecommendationAcceptedDocsRequired:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($eb26e7076e89f15b$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Application:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($96d6aadba8e155ec$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Won:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($376fc228c3d95576$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).CompletionSet:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($a613b4ef18216407$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Dip:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($3774c4f1e28e6175$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Lost:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($67bd00c08b6cab33$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Wip:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($9e5d318c0d381b16$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).OfferAccepted:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($71c1d3b97e3b1467$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).OfferAcceptedBooked:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($b4df87e9a451b1aa$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).Core:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($3106fef3c2313ab0$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).BTLSpecialistPayment:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($896cf5ca36dcf5b9$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointment:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($4d1619018cb6e81b$exports)));
                    break;
                case (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointmentDocsOnly:
                    statusData = (0, (/*@__PURE__*/$parcel$interopDefault($8316628e3eae250d$exports)));
                    break;
                default:
                    statusData = {
                        recommendationAccepted: null,
                        numberOfDocumentsRequested: 0,
                        setCompletionDateForEmail: "",
                        opportunityOwnerTextForEmail: "Mojo Mortgages Dev Mode",
                        ownerEmailAddress: "devmode@mojomortgages.com"
                    };
                    break;
            }
            console.log("\uD83D\uDD27 Dev mode active: Using status data from ".concat(scenario, ".json"));
            return [
                2,
                statusData
            ];
        });
    })();
}
function $e1865584d8948220$export$3ea131bc8086db69() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var scenario;
        return (0, $dMrZK.__generator)(this, function(_state) {
            scenario = (0, $cda636b84ca95de8$export$229888be98753136)();
            if (!scenario) throw new Error("Dev mode enabled but no valid scenario found");
            console.log("\uD83D\uDD27 Dev mode active: Using split fact find data from ".concat(scenario, ".json"));
            return [
                2,
                scenario === (0, $cda636b84ca95de8$export$fda6c4795731a594).PrepareForAppointmentDocsOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($030964e4c30216bd$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3d0cae146af65a6b$exports)))
            ];
        });
    })();
}


function $1fc51b1dc9a30698$export$9017821597e95bc1() {
    var invalidateCache = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $d48d778937567d64$export$155ec85c4e3b5e85).get("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/applications/sf"), {
                            headers: {
                                "Cache-Control": invalidateCache ? "no-store, max-age=0" : null
                            },
                            withCredentials: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        (0, $cda636b84ca95de8$export$1e0775a4561f3738)() ? $e1865584d8948220$export$eb412cb11d91b25c(response.data) : response.data
                    ];
            }
        });
    })();
}
function $1fc51b1dc9a30698$export$7c85f84b8e8b0590(applicationId) {
    var invalidateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $cda636b84ca95de8$export$1e0775a4561f3738)()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $e1865584d8948220$export$205bc258834dc08()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        4,
                        (0, $d48d778937567d64$export$155ec85c4e3b5e85).get("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/applications/").concat(applicationId), {
                            headers: {
                                "Cache-Control": invalidateCache ? "no-store, max-age=0" : null
                            },
                            withCredentials: true
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    })();
}
function $1fc51b1dc9a30698$export$a5500ac065605891(application) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $d48d778937567d64$export$155ec85c4e3b5e85).put("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/applications/").concat(application.applicationId), {
                            application: application
                        }, {
                            headers: {},
                            withCredentials: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    })();
}
function $1fc51b1dc9a30698$export$257d85ee34dc751e(application, flags) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var result;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $d48d778937567d64$export$155ec85c4e3b5e85).put("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/applications/").concat(application.applicationId, "/flags?flags=").concat(flags.join(",")), null, {
                            headers: {},
                            withCredentials: true
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    })();
}
function $1fc51b1dc9a30698$export$cc3f566967fa6dc(application, flag) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var _application_metadata, flagsToSet, _application_metadata_flags, existingFlags, result;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    flagsToSet = [];
                    existingFlags = (_application_metadata_flags = application === null || application === void 0 ? void 0 : (_application_metadata = application.metadata) === null || _application_metadata === void 0 ? void 0 : _application_metadata.flags) !== null && _application_metadata_flags !== void 0 ? _application_metadata_flags : [];
                    if (existingFlags.includes(flag)) return [
                        2,
                        application
                    ];
                    if ((existingFlags === null || existingFlags === void 0 ? void 0 : existingFlags.length) > 0) flagsToSet.push(existingFlags);
                    flagsToSet.push(flag);
                    return [
                        4,
                        (0, $d48d778937567d64$export$155ec85c4e3b5e85).put("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/applications/").concat(application.applicationId, "/flags?flags=").concat(flagsToSet.join(",")), null, {
                            headers: {},
                            withCredentials: true
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    })();
}
function $1fc51b1dc9a30698$export$2eaab7771557c29d(application) {
    var _application_lastModifiedDate;
    var referenceDate = (_application_lastModifiedDate = application === null || application === void 0 ? void 0 : application.lastModifiedDate) !== null && _application_lastModifiedDate !== void 0 ? _application_lastModifiedDate : application === null || application === void 0 ? void 0 : application.createdOn;
    return (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(new Date(), referenceDate, "month") > 6;
}
function $1fc51b1dc9a30698$export$3952bb99e24bb0fa(application) {
    var _application_borrowingDetails, _application_basicPropertyDetails;
    if (!application) return [];
    var cohorts = [];
    var isFirstTimeBuyer = ((application === null || application === void 0 ? void 0 : (_application_borrowingDetails = application.borrowingDetails) === null || _application_borrowingDetails === void 0 ? void 0 : _application_borrowingDetails.firstTimeBuyer) || (application === null || application === void 0 ? void 0 : application.purchaseType)) === (0, $6e6e522132305404$export$1d754f70af7fac9d).FirstTimeBuyer;
    if (isFirstTimeBuyer) addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).FirstTimeBuyer);
    if (application.applicationReason === (0, $92da6ce0a9463af6$export$f5805e4abe6a2ac5).LookingForProperty) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).NotFoundAProperty);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).Purchase);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).PreOffer);
    }
    if (application.applicationReason === (0, $92da6ce0a9463af6$export$f5805e4abe6a2ac5).FoundProperty) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).FoundAProperty);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).Purchase);
    }
    if (application.persona === (0, $6e6e522132305404$export$379de9fa197ff43a).OfferAccepted) addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).PostOffer);
    if (application.persona === (0, $6e6e522132305404$export$379de9fa197ff43a).FoundProperty) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).FoundAProperty);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).PreOffer);
    }
    if ([
        (0, $6e6e522132305404$export$379de9fa197ff43a).StartedLooking,
        (0, $6e6e522132305404$export$379de9fa197ff43a).ActivelyLooking
    ].includes(application.persona)) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).NotFoundAProperty);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).PreOffer);
    }
    if ((application === null || application === void 0 ? void 0 : application.purchaseType) === (0, $6e6e522132305404$export$1d754f70af7fac9d).HomeMove) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).MovingHome);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).Purchase);
    }
    if ((application === null || application === void 0 ? void 0 : application.purchaseType) === (0, $6e6e522132305404$export$1d754f70af7fac9d).SecondHome) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).SecondHome);
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).Purchase);
    }
    if (application.applicationReason === (0, $92da6ce0a9463af6$export$f5805e4abe6a2ac5).Remortgage) {
        addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).Remortgage);
        if ($1fc51b1dc9a30698$export$6574a6177033a2ef(application) > 1) addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).StuckInERC);
        switch(application.remortgageReason){
            case (0, $6e6e522132305404$export$8f15a9875acf08a4).Additional_borrowing:
                addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).AdditionalBorrowing);
                break;
            case (0, $6e6e522132305404$export$8f15a9875acf08a4).Release_money:
                addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).ReleaseMoney);
                break;
            default:
                addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).LikeForLike);
                break;
        }
    }
    var isBuyToLet = ((application === null || application === void 0 ? void 0 : (_application_basicPropertyDetails = application.basicPropertyDetails) === null || _application_basicPropertyDetails === void 0 ? void 0 : _application_basicPropertyDetails.occupancy) || (application === null || application === void 0 ? void 0 : application.occupancy)) === (0, $6e6e522132305404$export$76afec25c076d535).RentItOut;
    if (isBuyToLet) addUnique((0, $46bdcc345e36a539$export$b76685d1b5a37732).BuyToLet);
    return cohorts;
    function addUnique(cohort) {
        if (cohorts.indexOf(cohort) < 0) cohorts.push(cohort);
    }
}
function $1fc51b1dc9a30698$export$67008a335dcf6aae(application) {
    var cohorts = $1fc51b1dc9a30698$export$3952bb99e24bb0fa(application);
    return cohorts.includes((0, $46bdcc345e36a539$export$b76685d1b5a37732).Remortgage);
}
function $1fc51b1dc9a30698$export$504181ff37b514da(application) {
    return application.applicationReason === (0, $92da6ce0a9463af6$export$f5805e4abe6a2ac5).Remortgage;
}
function $1fc51b1dc9a30698$export$8d1a25f3669dbecb(application) {
    var cohorts = $1fc51b1dc9a30698$export$3952bb99e24bb0fa(application);
    return !!cohorts.includes((0, $46bdcc345e36a539$export$b76685d1b5a37732).PreOffer);
}
function $1fc51b1dc9a30698$export$4e61365a021b7cad(application) {
    var _application_remortgageDetails;
    var ercDate = application === null || application === void 0 ? void 0 : (_application_remortgageDetails = application.remortgageDetails) === null || _application_remortgageDetails === void 0 ? void 0 : _application_remortgageDetails.initialPeriodEndDate;
    var months = (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(new Date(), ercDate, "month");
    return months > 6;
}
function $1fc51b1dc9a30698$export$6574a6177033a2ef(application) {
    var _application_remortgageDetails;
    var _application_remortgageDetails_initialPeriodEndDate;
    var endDate = (_application_remortgageDetails_initialPeriodEndDate = application === null || application === void 0 ? void 0 : (_application_remortgageDetails = application.remortgageDetails) === null || _application_remortgageDetails === void 0 ? void 0 : _application_remortgageDetails.initialPeriodEndDate) !== null && _application_remortgageDetails_initialPeriodEndDate !== void 0 ? _application_remortgageDetails_initialPeriodEndDate : application === null || application === void 0 ? void 0 : application.initialPeriodEndDate;
    if (!endDate) return null;
    return (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(new Date(), endDate, "day");
}
function $1fc51b1dc9a30698$export$a979498511243634(application) {
    if (application.mipUrl) return true;
    return false;
}
function $1fc51b1dc9a30698$export$e77de659f33713d8(application) {
    var _application_metadata_flags, _application_metadata;
    if ("firstTimeBuyer" in application) return application.firstTimeBuyer;
    var _application_metadata_flags_includes;
    return (_application_metadata_flags_includes = application === null || application === void 0 ? void 0 : (_application_metadata = application.metadata) === null || _application_metadata === void 0 ? void 0 : (_application_metadata_flags = _application_metadata.flags) === null || _application_metadata_flags === void 0 ? void 0 : _application_metadata_flags.includes((0, $6e6e522132305404$export$48ea269755562084).CompletedFactFindPreferences)) !== null && _application_metadata_flags_includes !== void 0 ? _application_metadata_flags_includes : false;
}
function $1fc51b1dc9a30698$export$8d975e3dfbd44cd9(application) {
    var _application_borrowingDetails;
    if ("firstTimeBuyer" in application && application.firstTimeBuyer) return "First time buyer application";
    if ("borrowingDetails" in application && ((_application_borrowingDetails = application.borrowingDetails) === null || _application_borrowingDetails === void 0 ? void 0 : _application_borrowingDetails.firstTimeBuyer)) return "First time buyer application";
    if ("purchaseType" in application && application.purchaseType) return "Purchase application";
    if (application.applicationReason === (0, $92da6ce0a9463af6$export$f5805e4abe6a2ac5).Remortgage) return "Remortgage application";
    return "Application";
}
function $1fc51b1dc9a30698$export$f8aaded588a1da0(application) {
    if (!application) return false;
    var createdDate = application.createdOn ? new Date(application.createdOn) : null;
    var ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
    var isCreatedWithinLast90Days = createdDate && createdDate >= ninetyDaysAgo;
    var hasPreviousOwner = application.previousOpportunityOwner !== null && application.previousOpportunityOwner !== undefined;
    var isNotMojoOwned = application.previousOpportunityOwner !== "Mojo Mortgages";
    var isNotClosedLost = application.stage !== "Closed Lost";
    var isNotClosedWon = application.stage !== "Closed Won";
    return isCreatedWithinLast90Days && hasPreviousOwner && isNotMojoOwned && isNotClosedLost && isNotClosedWon;
}
function $1fc51b1dc9a30698$export$e3b5788aad6d3db6(applications) {
    return applications.filter($1fc51b1dc9a30698$export$f8aaded588a1da0);
}


var $4f114b88f9cf2d7b$export$d4e71bc0b80dc0fb = /*#__PURE__*/ function(ErrorCode) {
    ErrorCode[ErrorCode["Unknown"] = 0] = "Unknown";
    ErrorCode[ErrorCode["FetchingAllApplications"] = 1] = "FetchingAllApplications";
    ErrorCode[ErrorCode["FetchingExperienceTLS"] = 2] = "FetchingExperienceTLS";
    return ErrorCode;
}({});



var $6mdMa = parcelRequire("6mdMa");



function $8df6899e99420dc7$export$7ab84fea33af0d21() {
    var _useRecoilState = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$2969e4c65c6cdaa0)), 2), applicationError = _useRecoilState[0], setApplicationError = _useRecoilState[1];
    function HandleError(errorCode) {
        var errorData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, showErrorPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $411b073b3fd49a19$export$5c9af0966a1ac889)(errorData);
        if (showErrorPage) setApplicationError({
            data: errorCode,
            code: errorCode
        });
    }
    return {
        HandleError: HandleError
    };
}



function $1c92825e7588cbce$export$b17f9dfb16ad8a1d() {
    var data = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)().data;
    var _useRecoilState = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$5ccb3488dc14f2bc)), 2), hasFetchedSummaries = _useRecoilState[0], setHasFetchedSummaries = _useRecoilState[1];
    var _useRecoilState1 = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$1c603332822bee55)), 2), applicationSummaries = _useRecoilState1[0], setApplications = _useRecoilState1[1];
    var HandleError = (0, $8df6899e99420dc7$export$7ab84fea33af0d21)().HandleError;
    function refreshApplications() {
        var invalidateCache = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var allApplications, err;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ($1c92825e7588cbce$var$isFetchingSummaries) return [
                            2
                        ];
                        $1c92825e7588cbce$var$isFetchingSummaries = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0, $1fc51b1dc9a30698$export$9017821597e95bc1)(invalidateCache)
                        ];
                    case 2:
                        allApplications = _state.sent();
                        setApplications(allApplications);
                        setHasFetchedSummaries(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        HandleError((0, $4f114b88f9cf2d7b$export$d4e71bc0b80dc0fb).FetchingAllApplications, err, false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        $1c92825e7588cbce$var$isFetchingSummaries = false;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    (0, $hAGkE.useEffect)(function() {
        if (!hasFetchedSummaries && data) refreshApplications(true);
    }, [
        hasFetchedSummaries,
        data
    ]);
    return {
        applicationSummaries: applicationSummaries,
        hasFetchedSummaries: hasFetchedSummaries,
        refreshApplications: refreshApplications
    };
}
// Blocks parallel requests to fetch all application summaries
var $1c92825e7588cbce$var$isFetchingSummaries = false;





// @ts-ignore
var $81ae6e47d49f1eea$exports = {};
$81ae6e47d49f1eea$exports = $parcel$resolve("k6HyH");


var $9006f4a3e4450b29$exports = {};
$9006f4a3e4450b29$exports = $parcel$resolve("fy8hn");


var $caa4151b580acc41$exports = {};
$caa4151b580acc41$exports = $parcel$resolve("l1Ymt");


var $f1112d1fb6e694ac$exports = {};
$f1112d1fb6e694ac$exports = $parcel$resolve("dq1DS");


var $b9f9a65bc1278693$exports = {};
$b9f9a65bc1278693$exports = $parcel$resolve("72YXr");


var $c0f3303543545f03$exports = {};
$c0f3303543545f03$exports = $parcel$resolve("dilgV");


var $90d38562b5113c74$exports = {};
$90d38562b5113c74$exports = $parcel$resolve("eAzTQ");


var $a9a9d248d65d3d00$exports = {};
$a9a9d248d65d3d00$exports = $parcel$resolve("8QPvK");


var $32b9b3f19ab38e09$exports = {};
$32b9b3f19ab38e09$exports = $parcel$resolve("85OXR");


var $857a840088c6fec0$exports = {};
$857a840088c6fec0$exports = $parcel$resolve("6JXSe");


var $3becd907d1093213$exports = {};
$3becd907d1093213$exports = $parcel$resolve("gQSRa");


var $8c2cfb0ca00469f9$exports = {};
$8c2cfb0ca00469f9$exports = $parcel$resolve("71k4v");


var $1a2d425ee990dca9$exports = {};
$1a2d425ee990dca9$exports = $parcel$resolve("lt5q0");


var $d094dd4c8de82fe9$exports = {};
$d094dd4c8de82fe9$exports = $parcel$resolve("aJEnI");


var $16f0378959a5b284$exports = {};
$16f0378959a5b284$exports = $parcel$resolve("fPxTW");


var $76d6114e197b693e$exports = {};
$76d6114e197b693e$exports = $parcel$resolve("eeug0");


var $90e1906ffa8a5f4b$exports = {};
$90e1906ffa8a5f4b$exports = $parcel$resolve("7sFys");


var $d2ebd71da6576dcd$exports = {};
$d2ebd71da6576dcd$exports = $parcel$resolve("7OCmJ");


var $e7e305ea8b810faf$exports = {};
$e7e305ea8b810faf$exports = $parcel$resolve("claKy");








function $15a25c72ef0a04de$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 270px;\n  margin-top: 40px;\n  justify-content: center;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 800;\n  font-size: 32px;\n  text-align: center;\n  color: #444444;\n  margin: 0;\n  padding: 0;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  grid-column-gap: 10px;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  height: 47px;\n  width: 130px;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  align-self: center;\n  font-size: 0.83em;\n  padding: 0 0 0 10px;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 200px;\n  position: absolute;\n  top: -135px;\n  right: 10px;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $15a25c72ef0a04de$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    $15a25c72ef0a04de$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
var $15a25c72ef0a04de$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($15a25c72ef0a04de$var$_templateObject());
var $15a25c72ef0a04de$var$WelcomeBack = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($15a25c72ef0a04de$var$_templateObject1());
var $15a25c72ef0a04de$var$ActiveApplications = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($15a25c72ef0a04de$var$_templateObject2());
var $15a25c72ef0a04de$var$FooterContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($15a25c72ef0a04de$var$_templateObject3());
var $15a25c72ef0a04de$var$TrustpilotWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($15a25c72ef0a04de$var$_templateObject4());
var $15a25c72ef0a04de$var$TrustpilotSideText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($15a25c72ef0a04de$var$_templateObject5());
var $15a25c72ef0a04de$var$SittingPeopleImage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($15a25c72ef0a04de$var$_templateObject6());
var $15a25c72ef0a04de$var$LoaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($15a25c72ef0a04de$var$_templateObject7());
function $15a25c72ef0a04de$export$6823e0582b8de248(param) {
    var onStartNewApplication = param.onStartNewApplication;
    var _useApplicationSummaries = (0, $1c92825e7588cbce$export$b17f9dfb16ad8a1d)(), applicationSummaries = _useApplicationSummaries.applicationSummaries, hasFetchedSummaries = _useApplicationSummaries.hasFetchedSummaries;
    var activeCount = applicationSummaries.reduce(function(total, summary) {
        return (0, $1fc51b1dc9a30698$export$2eaab7771557c29d)(summary) ? total : total + 1;
    }, 0);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($15a25c72ef0a04de$var$Container, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($15a25c72ef0a04de$var$SittingPeopleImage, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($81ae6e47d49f1eea$exports))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($15a25c72ef0a04de$var$WelcomeBack, {
                    children: "Welcome back"
                }),
                hasFetchedSummaries ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($15a25c72ef0a04de$var$ActiveApplications, {
                    children: [
                        "You've got ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: activeCount
                        }),
                        " active application",
                        applicationSummaries.length === 1 ? "" : "s",
                        "."
                    ]
                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($15a25c72ef0a04de$var$LoaderContainer, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                        size: 30,
                        theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                    id: "button-new-application",
                    type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                    onClick: function() {
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).startApplication
                        });
                        onStartNewApplication();
                    },
                    text: "Start a new application"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($15a25c72ef0a04de$var$FooterContainer, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($15a25c72ef0a04de$var$TrustpilotWrapper, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d064dfd92ce74522$export$f63de433e1787c6d), {
                                height: "47px"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($15a25c72ef0a04de$var$TrustpilotSideText, {
                            children: "Join the other 67,000 happy mojo'ers"
                        })
                    ]
                })
            ]
        })
    });
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");



function $cec0b06d7f24d7cd$export$d883155132f626a2(param) {
    var applicationData = param.applicationData, friendlyId = param.friendlyId;
    var applicationSummaries = (0, $d7ce42c300073b00$export$8b71bf98365f8042)((0, $e686c778565af949$export$1c603332822bee55));
    var hasFetchedSummaries = (0, $d7ce42c300073b00$export$8b71bf98365f8042)((0, $e686c778565af949$export$5ccb3488dc14f2bc));
    var applicationId = applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationId;
    var application = (applicationId ? applicationSummaries.find(function(app) {
        return app.applicationId === applicationId;
    }) : friendlyId ? applicationSummaries.find(function(app) {
        return app.friendlyId === friendlyId;
    }) : null) || null;
    return {
        application: application,
        hasLoaded: hasFetchedSummaries
    };
}







parcelRequire("hAGkE");



parcelRequire("hAGkE");

function $b6bcbe1f51208b5c$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  background: #f3f5fa;\n  border-radius: 5px;\n  padding: 17px;\n  font-size: 1em;\n  font-weight: bold;\n  height: 20px;\n  align-items: center;\n  font-family: Helvetica, Arial, sans-serif;\n  box-sizing: border-box;\n"
    ]);
    $b6bcbe1f51208b5c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b6bcbe1f51208b5c$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    $b6bcbe1f51208b5c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $b6bcbe1f51208b5c$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b6bcbe1f51208b5c$var$_templateObject());
var $b6bcbe1f51208b5c$var$TextWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b6bcbe1f51208b5c$var$_templateObject1());
function $b6bcbe1f51208b5c$export$f280c82e6b0a59c7(param) {
    var value = param.value;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b6bcbe1f51208b5c$var$Container, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b6bcbe1f51208b5c$var$TextWrapper, {
            children: value
        })
    });
}



function $9c2a0e19555f553e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  width: 100%;\n  color: ",
        ";\n  font-size: 0.9em;\n"
    ]);
    $9c2a0e19555f553e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9c2a0e19555f553e$var$AppStageText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9c2a0e19555f553e$var$_templateObject(), function(props) {
    return props.theme.primary;
});
function $9c2a0e19555f553e$export$d5158ae0a04469da(param) {
    var application = param.application;
    var getStatusText = function() {
        var tls = application.tls, offeredAppointment = application.offeredAppointment, stage = application.stage, hasAppointments = application.hasAppointments;
        if (tls.team === "Specialist") return "Specialist Help";
        if (!tls.appointmentOffered && !offeredAppointment && !hasAppointments) return "Can\u2018t Help";
        switch(stage){
            case (0, $6e6e522132305404$export$9542f959509ad58).dip:
                return "Decision in Principle";
            case (0, $6e6e522132305404$export$9542f959509ad58).quoted:
                return "Recommendation";
            case (0, $6e6e522132305404$export$9542f959509ad58).online:
            case (0, $6e6e522132305404$export$9542f959509ad58).factfind:
                return "Mortgage Ready";
            default:
                return stage;
        }
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b6bcbe1f51208b5c$export$f280c82e6b0a59c7), {
        value: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9c2a0e19555f553e$var$AppStageText, {
            children: getStatusText()
        })
    });
}




function $fdc0ca88d14704de$export$2bd90eee99af25a7(value, defaultValue) {
    var decimalPlaces = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!value && defaultValue !== undefined) return defaultValue;
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(value);
}
var $fdc0ca88d14704de$export$4670d0ed237a9270 = function(num) {
    var formattedNum = num === null || num === void 0 ? void 0 : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // If number after decimal point is single, add a 0 to it.
    return formattedNum === null || formattedNum === void 0 ? void 0 : formattedNum.replace(/(\.\d)$/, "$10");
};




parcelRequire("hAGkE");


function $6c941e32e487743c$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 6px;\n"
    ]);
    $6c941e32e487743c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6c941e32e487743c$var$Label = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($6c941e32e487743c$var$_templateObject());
function $6c941e32e487743c$export$c1f3e76587714683(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($6c941e32e487743c$var$Label, {
                children: label
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b6bcbe1f51208b5c$export$f280c82e6b0a59c7), {
                value: value
            })
        ]
    });
}





var $4b9b034003e75bda$exports = {};

var $6mdMa = parcelRequire("6mdMa");

!function(e, t) {
    t($4b9b034003e75bda$exports, (parcelRequire("hAGkE")));
}(undefined, function(e, t) {
    "use strict";
    function r() {
        return (r = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var _$r = arguments[t];
                for(var n in _$r)Object.prototype.hasOwnProperty.call(_$r, n) && (e[n] = _$r[n]);
            }
            return e;
        }).apply(this, arguments);
    }
    var n = {
        root: null,
        rootMargin: "0px",
        threshold: Array.from({
            length: 100
        }, function(e, t) {
            return .01 * t;
        })
    };
    e.useVisible = function(e) {
        var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var u = t.useRef(null), c = t.useRef(null), _t_useState = (0, $6mdMa._)(t.useState(0), 2), s = _t_useState[0], i = _t_useState[1], f = "function" == typeof e ? e(s) : s, a = t.useCallback(function(e) {
            e.forEach(function(e) {
                i(e.intersectionRatio);
            });
        }, []);
        return t.useEffect(function() {
            c.current || u.current && (c.current = new IntersectionObserver(a, r({}, n, {}, o)), c.current.observe(u.current));
        }), [
            u,
            f
        ];
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});




var $f7851462328073bd$export$dfdeed3815fe8e53 = function(address) {
    var formatted = [
        address === null || address === void 0 ? void 0 : address.nameNumber,
        address === null || address === void 0 ? void 0 : address.street
    ].filter(Boolean).join(" ");
    return formatted || "TBC";
};


function $3c2eb4b929cc742c$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  &.expired {\n    opacity: 0.4;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  display: grid;\n  grid-row-gap: 1rem;\n  grid-template-areas:\n    "apptype apptype"\n    "appbadge friendlyid";\n  @media ',
        ' {\n    grid-template-areas:\n      "apptype appbadge"\n      "friendlyid .";\n    align-items: center;\n  }\n'
    ]);
    $3c2eb4b929cc742c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  grid-area: apptype;\n  justify-self: left;\n  font-weight: bold;\n  color: ",
        ";\n  font-size: 1.2em;\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  grid-area: friendlyid;\n  text-align: right;\n  font-weight: bold;\n  color: ",
        ";\n  font-family: Helvetica, Arial, sans-serif;\n  @media ",
        " {\n    text-align: left;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 150px 1fr;\n  grid-column-gap: 1em;\n  padding-top: 35px;\n\n  @media ",
        " {\n    grid-template-columns: 1fr 1fr 1fr 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: none;\n  margin: 30px 0;\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-column-gap: 20px;\n  grid-row-gap: 1.5rem;\n  @media ",
        " {\n    grid-template-columns: 3fr 1fr;\n    grid-row-gap: 0;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  grid-area: appbadge;\n  display: flex;\n  justify-content: flex-start;\n  @media ",
        " {\n    justify-content: flex-end;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  div {\n    margin: 0;\n    padding: 0;\n    font-size: 1.4em;\n    font-weight: bold;\n    color: ",
        ";\n    max-width: 100%;\n    display: flex;\n    align-items: center;\n    height: 100%;\n\n    @media ",
        " {\n      max-width: 100%;\n    }\n\n    @media ",
        " {\n      max-width: 90%;\n    }\n\n    .expired {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  align-items: center;\n  font-size: 0.9em;\n  justify-self: right;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  flex-direction: column;\n  grid-gap: 1rem;\n\n  .dateCreated {\n    margin-top: 0;\n  }\n\n  @media ",
        " {\n    min-height: 90px;\n    width: 180px;\n    grid-template-columns: 1fr;\n    justify-content: center;\n    text-align: center;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $3c2eb4b929cc742c$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n  @media ",
        " {\n    display: initial;\n  }\n"
    ]);
    $3c2eb4b929cc742c$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
var $3c2eb4b929cc742c$var$SummaryCardHeaderLayout = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject());
var $3c2eb4b929cc742c$var$SummaryCardHeaderMainInfo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $3c2eb4b929cc742c$var$AppType = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.grey_dark;
});
var $3c2eb4b929cc742c$var$FriendlyId = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.blue;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $3c2eb4b929cc742c$var$AppDataContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $3c2eb4b929cc742c$var$SummarySeparator = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).hr($3c2eb4b929cc742c$var$_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.grey;
});
var $3c2eb4b929cc742c$var$SummaryCardFooterLayout = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject6(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $3c2eb4b929cc742c$var$AppStageBadgeContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject7(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $3c2eb4b929cc742c$var$NextSteps = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.grey_dark;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl, function(param) {
    var theme = param.theme;
    return theme.error;
});
var $3c2eb4b929cc742c$var$NextActionContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject9(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $3c2eb4b929cc742c$var$LabeledValueViewDesktop = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3c2eb4b929cc742c$var$_templateObject10(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
function $3c2eb4b929cc742c$export$1a548e958d112fd5(param) {
    var friendlyId = param.friendlyId;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasBeenSeen = _useState[0], setHasBeenSeen = _useState[1];
    var _useVisible = (0, $6mdMa._)((0, $4b9b034003e75bda$exports.useVisible)(), 2), targetRef = _useVisible[0], visible = _useVisible[1];
    (0, $hAGkE.useEffect)(function() {
        if (!hasBeenSeen && visible > 0.5) setHasBeenSeen(true);
    }, [
        visible
    ]);
    if (!hasBeenSeen) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
            ref: targetRef,
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$LoadedApplicationSummaryCard, {
        friendlyId: friendlyId
    });
}
function $3c2eb4b929cc742c$var$LoadedApplicationSummaryCard(param) {
    var friendlyId = param.friendlyId;
    var _useApplicationSummaryEnhanced = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }), application = _useApplicationSummaryEnhanced.application, hasLoaded = _useApplicationSummaryEnhanced.hasLoaded;
    var _application_offeredAppointment;
    var offeredAppointment = (_application_offeredAppointment = application === null || application === void 0 ? void 0 : application.offeredAppointment) !== null && _application_offeredAppointment !== void 0 ? _application_offeredAppointment : false;
    var nextUrl = offeredAppointment || (application === null || application === void 0 ? void 0 : application.hasAppointments) ? "/application/".concat(friendlyId, "/status") : null;
    var hasExpired = (0, $1fc51b1dc9a30698$export$2eaab7771557c29d)(application);
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var _application_mipUrl;
    var mipUrl = (_application_mipUrl = application === null || application === void 0 ? void 0 : application.mipUrl) !== null && _application_mipUrl !== void 0 ? _application_mipUrl : null;
    var nextStepButtonText = (application === null || application === void 0 ? void 0 : application.hasAppointments) ? "View Status" : "Speak to an expert";
    var _application_propertyAddress;
    var cardAddress = (_application_propertyAddress = application === null || application === void 0 ? void 0 : application.propertyAddress) !== null && _application_propertyAddress !== void 0 ? _application_propertyAddress : null;
    if (!hasLoaded || !application) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$Loading, {});
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3c2eb4b929cc742c$var$SummaryCardHeaderLayout, {
                    className: hasExpired ? "expired" : "",
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3c2eb4b929cc742c$var$SummaryCardHeaderMainInfo, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$AppType, {
                                    children: (0, $1fc51b1dc9a30698$export$8d975e3dfbd44cd9)(application)
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$AppStageBadgeContainer, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9c2a0e19555f553e$export$d5158ae0a04469da), {
                                        application: application
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$FriendlyId, {
                                    children: friendlyId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3c2eb4b929cc742c$var$AppDataContainer, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6c941e32e487743c$export$c1f3e76587714683), {
                                    label: "Value",
                                    value: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(application === null || application === void 0 ? void 0 : application.purchasePrice, "TBC")
                                }),
                                application && (0, $1fc51b1dc9a30698$export$504181ff37b514da)(application) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$LabeledValueViewDesktop, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6c941e32e487743c$export$c1f3e76587714683), {
                                        label: "Balance",
                                        value: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(application === null || application === void 0 ? void 0 : application.mortgageBalance, "TBC")
                                    })
                                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$LabeledValueViewDesktop, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6c941e32e487743c$export$c1f3e76587714683), {
                                        label: "Deposit",
                                        value: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(application === null || application === void 0 ? void 0 : application.deposit, "TBC")
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$LabeledValueViewDesktop, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6c941e32e487743c$export$c1f3e76587714683), {
                                        label: "Term",
                                        value: (application === null || application === void 0 ? void 0 : application.term) ? "".concat(application.term, " years") : "TBC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6c941e32e487743c$export$c1f3e76587714683), {
                                    label: "Address",
                                    value: (0, $f7851462328073bd$export$dfdeed3815fe8e53)(cardAddress)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$SummarySeparator, {
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3c2eb4b929cc742c$var$SummaryCardFooterLayout, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3c2eb4b929cc742c$var$NextSteps, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                children: NextStepText()
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3c2eb4b929cc742c$var$NextActionContainer, {
                            children: [
                                nextUrl && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                    disabled: hasExpired,
                                    onClick: function() {
                                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                            event_label: nextStepButtonText
                                        });
                                        history.push(nextUrl);
                                    },
                                    text: nextStepButtonText
                                }),
                                mipUrl && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                    disabled: hasExpired,
                                    onClick: function() {
                                        return window.open(mipUrl, "_blank");
                                    },
                                    text: "Download MIP"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                    className: "dateCreated",
                                    children: (0, $45f64f2ccb2647eb$export$68962dbd27cd2e36)(application === null || application === void 0 ? void 0 : application.createdOn, "Do MMMM YYYY")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    function NextStepText() {
        if ((0, $1fc51b1dc9a30698$export$2eaab7771557c29d)(application)) return "Application expired";
        var appointment = application.tls.appointmentOffered || application.offeredAppointment || application.hasAppointments;
        if (!appointment) return "We can\u2019t help with this one.";
        var stage = application.stage;
        var awaitingAppointment = offeredAppointment && (stage === (0, $6e6e522132305404$export$9542f959509ad58).online || stage === (0, $6e6e522132305404$export$9542f959509ad58).factfind);
        if (awaitingAppointment && (0, $1fc51b1dc9a30698$export$a979498511243634)(application)) return "Speak to an expert and grab your MIP";
        if (awaitingAppointment) return "Speak to an expert and get your mortgage recommendation";
        if (stage === (0, $6e6e522132305404$export$9542f959509ad58).quoted) return "Your personal mortgage recommendation is ready";
        if (application === null || application === void 0 ? void 0 : application.hasAppointments) return "Your personal mortgage recommendation is ready";
        return "";
    }
}
function $3c2eb4b929cc742c$var$Loading() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
            style: {
                display: "flex",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline,
                size: 50
            })
        })
    });
}



var $hAGkE = parcelRequire("hAGkE");



function $178ced39e8a813d0$export$9d605c4ba42beec3() {
    var /**
 * We define a "partialLogin" as when a user has started a fact find and has been
 * given a {guid}@@mojowhitelabel.com email. They are logged in, but technically don't have an account
 */ allowPartialLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), data = _useSession.data, isLoading = _useSession.isLoading;
    (0, $hAGkE.useEffect)(function() {
        if (!isLoading) {
            // If GetPartnerFromUrl is null we're not in a partner site
            var isFromPartner = !!(0, $81ead65346fb6783$export$3f4e072470a85305)();
            // special logic if user comes from a partner domain
            if (isFromPartner) {
                if (!data) history.replace("/get-started".concat(window.location.search));
            } else // if they have a full account and their token is expired/invalid
            // send them to the login with the correct redirect value
            if (!data) window.location.href = "/login?redirect=".concat(encodeURIComponent("".concat(window.location.href)));
        }
    }, [
        isLoading
    ]);
}











var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");



var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");




var $8901c9c795210f00$var$Background = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(props) {
    return {
        alignItems: "center",
        backgroundColor: props.darkerOverlay ? "#000000CC" : "#00000033",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        transform: "translateZ(0)",
        width: "100%",
        zIndex: 1002
    };
});
var $8901c9c795210f00$var$Box = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(props) {
    var _obj;
    return _obj = {
        backgroundColor: props.variant === "light" ? "#ffffff" : "#000928",
        color: props.variant === "light" ? "#000000" : "#ffffff",
        overflowY: "auto",
        overscrollBehavior: "none",
        padding: 2 * (0, $1ca2cdaa0912b6ea$export$a941ed4b947d12f8),
        position: "relative"
    }, (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
        borderRadius: props.slideUpOnMobile ? "16px 16px 0 0" : 10,
        maxHeight: "90%",
        width: props.slideUpOnMobile ? "100%" : "90%",
        position: props.slideUpOnMobile ? "fixed" : "relative",
        bottom: props.slideUpOnMobile ? 0 : "auto",
        animation: props.slideUpOnMobile ? "slideUp 0.3s ease-out" : "none",
        "@keyframes slideUp": {
            from: {
                transform: "translateY(100%)"
            },
            to: {
                transform: "translateY(0)"
            }
        }
    }), (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
        borderRadius: props.theme.borderRadius || 10,
        maxHeight: "75%",
        maxWidth: "85%",
        position: "relative",
        bottom: "auto"
    }), (0, $8c6ug._)(_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        borderRadius: props.theme.borderRadius || 10,
        maxHeight: "95%",
        maxWidth: 1000,
        minWidth: 600,
        position: "relative",
        bottom: "auto"
    }), _obj;
});
var $8901c9c795210f00$var$CloseButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button(function(props) {
    return {
        background: "transparent",
        border: "1px solid transparent",
        cursor: "pointer",
        lineHeight: 1,
        padding: (0, $1ca2cdaa0912b6ea$export$a941ed4b947d12f8),
        position: "absolute",
        right: 0,
        top: 0,
        filter: props.variant === "light" ? "invert(1)" : "none",
        "&:focus": {
            border: props.variant === "light" ? "1px solid black" : "1px solid white"
        }
    };
});
var $8901c9c795210f00$export$8948f78d83984c69 = function(param) {
    var ariaLabel = param.ariaLabel, children = param.children, onClose = param.onClose, _param_variant = param.variant, variant = _param_variant === void 0 ? "dark" : _param_variant, _param_darkerOverlay = param.darkerOverlay, darkerOverlay = _param_darkerOverlay === void 0 ? false : _param_darkerOverlay, _param_slideUpOnMobile = param.slideUpOnMobile, slideUpOnMobile = _param_slideUpOnMobile === void 0 ? false : _param_slideUpOnMobile;
    var mouseDownTargetRef = $hAGkE.useRef(null);
    var mouseUpTargetRef = $hAGkE.useRef(null);
    var backgroundRef = $hAGkE.useRef(null);
    var closeButton = $hAGkE.useRef(null);
    $hAGkE.useEffect(function() {
        closeButton.current.focus();
    }, [
        closeButton
    ]);
    var onBackgroundMouseDown = function(event) {
        if (event.target instanceof Node) mouseDownTargetRef.current = event.target;
    };
    var onBackgroundMouseUp = function(event) {
        if (event.target instanceof Node) mouseUpTargetRef.current = event.target;
    };
    var onBackgroundClick = function() {
        if (mouseDownTargetRef.current === backgroundRef.current && mouseUpTargetRef.current === backgroundRef.current) onClose();
    };
    var onKeyDown = function(event) {
        if (event.key.startsWith("Esc")) onClose();
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $0048b1b41b30e47d$exports.createPortal)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8901c9c795210f00$var$Background, {
        "aria-label": ariaLabel,
        "aria-modal": "true",
        onMouseDown: onBackgroundMouseDown,
        onMouseUp: onBackgroundMouseUp,
        onClick: onBackgroundClick,
        onKeyDown: onKeyDown,
        ref: backgroundRef,
        role: "dialog",
        tabIndex: -1,
        darkerOverlay: darkerOverlay,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8901c9c795210f00$var$Box, {
            variant: variant,
            slideUpOnMobile: slideUpOnMobile,
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8901c9c795210f00$var$CloseButton, {
                    "aria-label": "Close Modal",
                    onClick: onClose,
                    ref: closeButton,
                    variant: variant,
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                        alt: "Close Modal",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1e840f971475eea8$exports)))
                    })
                }),
                children
            ]
        })
    }), document.body);
};
var $8901c9c795210f00$export$2b77a92f1a5ad772 = function(param) {
    var children = param.children, description = param.description, triggerElement = param.triggerElement, _param_variant = param.variant, variant = _param_variant === void 0 ? "dark" : _param_variant;
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(false), 2), isOpen = _React_useState[0], setIsOpen = _React_useState[1];
    var trigger = /*#__PURE__*/ $hAGkE.cloneElement(triggerElement, {
        onClick: function(event) {
            event.preventDefault();
            document.querySelector("html").style.overflow = "hidden";
            setIsOpen(true);
        }
    });
    var onClose = function() {
        document.querySelector("html").style.overflow = "auto";
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            trigger,
            isOpen && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8901c9c795210f00$export$8948f78d83984c69, {
                ariaLabel: description,
                onClose: onClose,
                variant: variant,
                children: children
            })
        ]
    });
};



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");


parcelRequire("hAGkE");

function $d8bf44dc56d11f69$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    $d8bf44dc56d11f69$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 2em;\n        line-height: 120%;\n        font-weight: 700;\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1.75em;\n        line-height: 200%;\n        font-weight: 600;\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1.625em;\n        line-height: 135%;\n        font-weight: 600;\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1.4375em;\n        line-height: 135%;\n        font-weight: 600;\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1.25em;\n        line-height: 150%;\n        font-weight: 600;\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1.125em;\n        line-height: 150%;\n        font-weight: 600;\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $d8bf44dc56d11f69$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        color: ",
        ";\n      }\n    "
    ]);
    $d8bf44dc56d11f69$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
var $d8bf44dc56d11f69$var$StyledHeading = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($d8bf44dc56d11f69$var$_templateObject(), function(param) {
    var $margin = param.$margin;
    return $margin !== null && $margin !== void 0 ? $margin : "0px 0px 16px 0px";
}, function(param) {
    var theme = param.theme, $headingType = param.$headingType;
    return $d8bf44dc56d11f69$var$TypeVariantStyles(theme, $headingType);
}, function(param) {
    var theme = param.theme, $color = param.$color;
    return $d8bf44dc56d11f69$export$e9020453bfab6a98(theme, $color);
});
var $d8bf44dc56d11f69$export$a8a3e93435678ff9 = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? "h1" : _param_size, _param_as = _param.as, as = _param_as === void 0 ? "h1" : _param_as, _param_color = _param.color, color = _param_color === void 0 ? "secondary" : _param_color, children = _param.children, margin = _param.margin, props = (0, $c4wKO._)(_param, [
        "size",
        "as",
        "color",
        "children",
        "margin"
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d8bf44dc56d11f69$var$StyledHeading, (0, $7XD9P._)((0, $hRCmZ._)({
        $headingType: size,
        as: as,
        $color: color
    }, props), {
        $margin: margin,
        children: children
    }));
};
var $d8bf44dc56d11f69$var$TypeVariantStyles = function(theme, variant) {
    return ({
        h1: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject1()),
        h2: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject2()),
        h3: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject3()),
        h4: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject4()),
        h5: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject5()),
        h6: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject6())
    })[variant];
};
var $d8bf44dc56d11f69$export$e9020453bfab6a98 = function(theme, variant) {
    return ({
        secondary: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject7(), function(param) {
            var theme = param.theme;
            return theme.colors.primary.two;
        }),
        primary: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject8(), function(param) {
            var theme = param.theme;
            return theme.colors.primary.one;
        }),
        neutral: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject9(), function(param) {
            var theme = param.theme;
            return theme.colors.neutral[500];
        }),
        tertiary: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject10(), function(param) {
            var theme = param.theme;
            return theme.colors.yellow[500];
        }),
        error: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject11(), function(param) {
            var theme = param.theme;
            return theme.colors.error[500];
        }),
        white: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject12(), function(param) {
            var theme = param.theme;
            return theme.colors.white;
        }),
        success: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($d8bf44dc56d11f69$var$_templateObject13(), function(param) {
            var theme = param.theme;
            return theme.colors.success["700"];
        })
    })[variant];
};



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");


parcelRequire("hAGkE");


function $fe95aeefc35bd5ae$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: ",
        ";\n  font-style: ",
        ";\n  margin: ",
        ";\n\n  ",
        "\n  ",
        ";\n"
    ]);
    $fe95aeefc35bd5ae$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $fe95aeefc35bd5ae$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1.125em;\n        line-height: 180%;\n      }\n    "
    ]);
    $fe95aeefc35bd5ae$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $fe95aeefc35bd5ae$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 1em;\n        line-height: 180%;\n      }\n    "
    ]);
    $fe95aeefc35bd5ae$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $fe95aeefc35bd5ae$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 0.875em;\n        line-height: 180%;\n      }\n    "
    ]);
    $fe95aeefc35bd5ae$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $fe95aeefc35bd5ae$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n      & {\n        font-size: 0.75em;\n        line-height: 150%;\n      }\n    "
    ]);
    $fe95aeefc35bd5ae$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * Renders a paragraph element. Its weight, italization, color can be customised.
 */ var $fe95aeefc35bd5ae$var$StyledParagraph = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($fe95aeefc35bd5ae$var$_templateObject(), function(param) {
    var $weight = param.$weight;
    return $weight;
}, function(param) {
    var $italic = param.$italic;
    return $italic ? "italic" : "normal";
}, function(param) {
    var $as = param.$as, $margin = param.$margin;
    return $margin !== null && $margin !== void 0 ? $margin : $as === "p" ? "0px 0px 16px 0px" : 0;
}, function(param) {
    var theme = param.theme, $paragraphType = param.$paragraphType, $weight = param.$weight;
    return $fe95aeefc35bd5ae$var$variantStyles(theme, $paragraphType);
}, function(param) {
    var theme = param.theme, $color = param.$color;
    return (0, $d8bf44dc56d11f69$export$e9020453bfab6a98)(theme, $color);
});
$fe95aeefc35bd5ae$var$StyledParagraph.defaultProps = {
    $weight: 500
};
var $fe95aeefc35bd5ae$var$variantStyles = function(theme, variant) {
    return ({
        large: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($fe95aeefc35bd5ae$var$_templateObject1()),
        "default": (0, $62d655c53090e8a3$export$dbf350e5966cf602)($fe95aeefc35bd5ae$var$_templateObject2()),
        small: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($fe95aeefc35bd5ae$var$_templateObject3()),
        caption: (0, $62d655c53090e8a3$export$dbf350e5966cf602)($fe95aeefc35bd5ae$var$_templateObject4())
    })[variant];
};
var $fe95aeefc35bd5ae$export$358a232cca1ab2ac = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? "default" : _param_size, _param_as = _param.as, as = _param_as === void 0 ? "p" : _param_as, _param_italic = _param.italic, italic = _param_italic === void 0 ? false : _param_italic, weight = _param.weight, _param_color = _param.color, color = _param_color === void 0 ? "secondary" : _param_color, children = _param.children, margin = _param.margin, props = (0, $c4wKO._)(_param, [
        "size",
        "as",
        "italic",
        "weight",
        "color",
        "children",
        "margin"
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($fe95aeefc35bd5ae$var$StyledParagraph, (0, $7XD9P._)((0, $hRCmZ._)({
        $paragraphType: size,
        as: "span",
        $as: as,
        $italic: italic,
        $color: color,
        $margin: margin,
        $weight: weight
    }, props), {
        children: children
    }));
};


var $f430003687c9abea$var$Typography = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {});
};
/**
 * A 32px H1.
 */ $f430003687c9abea$var$Typography.H1 = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), (0, $hRCmZ._)({
        size: "h1",
        as: "h1"
    }, props));
};
/**
 * A 28px H2.
 */ $f430003687c9abea$var$Typography.H2 = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), (0, $hRCmZ._)({
        size: "h2",
        as: "h2"
    }, props));
};
/**
 * A 26px H3.
 */ $f430003687c9abea$var$Typography.H3 = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), (0, $hRCmZ._)({
        size: "h3",
        as: "h3"
    }, props));
};
/**
 * A 23px H4.
 */ $f430003687c9abea$var$Typography.H4 = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), (0, $hRCmZ._)({
        size: "h4",
        as: "h4"
    }, props));
};
/**
 * A 20px H5.
 */ $f430003687c9abea$var$Typography.H5 = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), (0, $hRCmZ._)({
        size: "h5",
        as: "h5"
    }, props));
};
/**
 * A 26px H6.
 */ $f430003687c9abea$var$Typography.H6 = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), (0, $hRCmZ._)({
        size: "h6",
        as: "h6"
    }, props));
};
/**
 * An 18px Paragraph.
 */ $f430003687c9abea$var$Typography.LargeBody = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), (0, $hRCmZ._)({
        size: "large"
    }, props));
};
/**
 * A 16px Paragraph.
 */ $f430003687c9abea$var$Typography.Body = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), (0, $hRCmZ._)({
        size: "default"
    }, props));
};
/**
 * An 14px Paragraph.
 */ $f430003687c9abea$var$Typography.SmallBody = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), (0, $hRCmZ._)({
        size: "small"
    }, props));
};
/**
 * An 12px Paragraph.
 */ $f430003687c9abea$var$Typography.Caption = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), (0, $hRCmZ._)({
        size: "caption"
    }, props));
};
/**
 * Text wrapped in a span, weight and size can be customised.
 */ $f430003687c9abea$var$Typography.Text = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), (0, $7XD9P._)((0, $hRCmZ._)({
        size: "default"
    }, props), {
        as: "span"
    }));
};
var $f430003687c9abea$export$2e2bcd8739ae039 = $f430003687c9abea$var$Typography;







var $9394149be221a7b2$export$4209eccf50c0f416 = /*#__PURE__*/ function(MortgageType) {
    MortgageType["FixedRateMortgage"] = "Fixed Rate mortgage";
    MortgageType["TrackerMortgage"] = "Tracker Mortgage";
    return MortgageType;
}({});
var $9394149be221a7b2$export$efdb592ec75b1a1b = /*#__PURE__*/ function(InitialPeriod) {
    InitialPeriod["OneYear"] = "1 year";
    InitialPeriod["TwoYears"] = "2 years";
    InitialPeriod["ThreeYears"] = "3 years";
    InitialPeriod["FiveYears"] = "5 years";
    InitialPeriod["SevenYears"] = "7 years";
    InitialPeriod["TenYears"] = "10 years";
    InitialPeriod["OverTenYears"] = "Over 10 years";
    InitialPeriod["ERCFree"] = "ERC-free";
    return InitialPeriod;
}({});
var $9394149be221a7b2$export$a3e2f90018137d93 = /*#__PURE__*/ function(RepaymentMethod) {
    RepaymentMethod["Repayment"] = "Repayment";
    RepaymentMethod["InterestOnly"] = "Interest only";
    RepaymentMethod["PartAndPart"] = "Part and part";
    return RepaymentMethod;
}({});
var $9394149be221a7b2$export$7e00024f63cae4dc = /*#__PURE__*/ function(Fees) {
    Fees["PayUpFront"] = "Pay up front";
    Fees["AddToTheLoan"] = "Add to the loan";
    Fees["NoFees"] = "No fees";
    return Fees;
}({});
var $9394149be221a7b2$export$aa49752c2e5363cd = /*#__PURE__*/ function(ConsolidationReasoning) {
    ConsolidationReasoning["ReducesMonthlyOutgoings"] = "it reduces monthly outgoings, improving disposable income and quality of life";
    ConsolidationReasoning["ReducesMonthlyCommitments"] = "the reduction in monthly commitments is essential for ongoing affordability and stability";
    ConsolidationReasoning["ReducesCostOfBorrowing"] = "it reduces the total cost of borrowing, and interest payable, compared to your current arrangements";
    ConsolidationReasoning["Other"] = "Other";
    return ConsolidationReasoning;
}({});
var $9394149be221a7b2$export$999f810846f9d31d = /*#__PURE__*/ function(PaymentStatus) {
    PaymentStatus["NotNeededYet"] = "Not needed yet";
    PaymentStatus["PaymentRequired"] = "Payment required";
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["RefundedInPart"] = "Refunded in part";
    PaymentStatus["RefundedInFull"] = "Refunded in full";
    PaymentStatus["FeeRemoved"] = "Fee removed";
    return PaymentStatus;
}({});
var $9394149be221a7b2$export$72edb249c13607f9 = /*#__PURE__*/ function(SfPurchaseType) {
    SfPurchaseType["FirstTimeBuyer"] = "First time buyer";
    SfPurchaseType["MovingHome"] = "Moving home";
    SfPurchaseType["SecondHome"] = "Second home";
    SfPurchaseType["NextTimeBuyer"] = "Next time buyer";
    return SfPurchaseType;
}({});







var $ac6e1d2c0dc15aba$export$3df9978529e1fa2a = function(param) {
    var application = param.application, onClose = param.onClose, config = param.config;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var handleButtonClick = function() {
        if (config.buttonAction === "view-application") {
            if (application) {
                onClose();
                history.push("/application/".concat(application.friendlyId, "/status"));
            } else onClose();
        } else if (config.buttonAction === "start-new-application") {
            onClose();
            (0, $3216fe7bc1e1c300$export$3ca1530a76305b39)();
        }
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8901c9c795210f00$export$8948f78d83984c69), {
        ariaLabel: config.heading,
        onClose: onClose,
        variant: "light",
        darkerOverlay: true,
        slideUpOnMobile: true,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ac6e1d2c0dc15aba$var$ModalContent, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                    as: "h4",
                    size: "h4",
                    children: config.heading
                }),
                config.paragraphs.map(function(paragraph, index) {
                    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        children: paragraph
                    }, index);
                }),
                config.showApplicationCard && application && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ac6e1d2c0dc15aba$var$ApplicationSummaryCard, {
                    application: application
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                    text: config.buttonText,
                    onClick: handleButtonClick
                }),
                config.subtext && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ac6e1d2c0dc15aba$var$Subtext, {
                    children: config.subtext
                })
            ]
        })
    });
};
var $ac6e1d2c0dc15aba$var$ApplicationSummaryCard = function(param) {
    var application = param.application;
    var _application_owner, _application_appointments_, _application_appointments, _application_owner1, _application_propertyAddress;
    var getApplicationSubtype = function() {
        var applicationReason = application.applicationReason, occupancy = application.occupancy, purchaseType = application.purchaseType;
        var type;
        if (occupancy === "Rent_it_out") type = "Buy to Let";
        else if (occupancy === "Live_in_property") {
            if (purchaseType === (0, $9394149be221a7b2$export$72edb249c13607f9).FirstTimeBuyer) type = "First Time Buyer";
            if (purchaseType === (0, $9394149be221a7b2$export$72edb249c13607f9).MovingHome) type = "Home Mover";
            if (purchaseType === (0, $9394149be221a7b2$export$72edb249c13607f9).SecondHome) type = "Second Home";
        }
        if (!type && purchaseType) {
            if (purchaseType === (0, $9394149be221a7b2$export$72edb249c13607f9).FirstTimeBuyer) type = "First Time Buyer";
            if (purchaseType === (0, $9394149be221a7b2$export$72edb249c13607f9).MovingHome) type = "Home Mover";
            if (purchaseType === (0, $9394149be221a7b2$export$72edb249c13607f9).SecondHome) type = "Second Home";
        }
        if (applicationReason === "Remortgage") return "Remortgage";
        return type ? "Purchase \u2022 ".concat(type) : "Purchase";
    };
    var getSpecialistInitials = function(name) {
        if (!name) return "";
        var parts = name.split(" ");
        if (parts.length >= 2) return "".concat(parts[0][0]).concat(parts[1][0]).toUpperCase();
        return name.substring(0, 2).toUpperCase();
    };
    var specialistName = ((_application_owner = application.owner) === null || _application_owner === void 0 ? void 0 : _application_owner.name) || ((_application_appointments = application.appointments) === null || _application_appointments === void 0 ? void 0 : (_application_appointments_ = _application_appointments[0]) === null || _application_appointments_ === void 0 ? void 0 : _application_appointments_.assignee);
    var mortgageExpertImage = (_application_owner1 = application.owner) === null || _application_owner1 === void 0 ? void 0 : _application_owner1.mortgageExpertImage;
    var amount = application.purchasePrice ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(application.purchasePrice, "TBC") : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(application.mortgageBalance, "TBC");
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ac6e1d2c0dc15aba$var$ApplicationCard, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ac6e1d2c0dc15aba$var$CardHeader, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ac6e1d2c0dc15aba$var$FriendlyId, {
                        children: application.friendlyId
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9c2a0e19555f553e$export$d5158ae0a04469da), {
                        application: application
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                as: "h5",
                size: "h5",
                children: getApplicationSubtype()
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ac6e1d2c0dc15aba$var$PropertyDetails, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        margin: 0,
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: "Property: "
                            }),
                            " ",
                            ((_application_propertyAddress = application.propertyAddress) === null || _application_propertyAddress === void 0 ? void 0 : _application_propertyAddress.nameNumber) ? "".concat(application.propertyAddress.nameNumber).trim() : "TBC"
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        margin: 0,
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: "Amount: "
                            }),
                            " ",
                            amount
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        margin: 0,
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: "Term: "
                            }),
                            " ",
                            application.term ? "".concat(application.term, " years") : "TBC"
                        ]
                    })
                ]
            }),
            specialistName && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ac6e1d2c0dc15aba$var$SpecialistContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ac6e1d2c0dc15aba$var$SpecialistInfo, {
                    children: [
                        mortgageExpertImage ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                            src: mortgageExpertImage,
                            alt: "your mortgage expert",
                            "aria-label": "your mortgage expert"
                        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ac6e1d2c0dc15aba$var$SpecialistAvatar, {
                            children: getSpecialistInitials(specialistName)
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ac6e1d2c0dc15aba$var$SpecialistName, {
                            children: specialistName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ac6e1d2c0dc15aba$var$CreatedDate, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "Created:"
                    }),
                    " ",
                    (0, $45f64f2ccb2647eb$export$68962dbd27cd2e36)(application.createdOn, "Do MMMM YYYY")
                ]
            })
        ]
    });
};
var $ac6e1d2c0dc15aba$var$ModalContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    maxWidth: "600px",
    margin: "0 auto"
});
var $ac6e1d2c0dc15aba$var$ApplicationCard = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return (0, $8c6ug._)({
        borderRadius: "16px",
        padding: "24px",
        margin: "24px 0",
        border: "1px solid ".concat(theme.colors.border.light)
    }, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md, {
        padding: "32px"
    });
});
var $ac6e1d2c0dc15aba$var$CardHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
    flexWrap: "wrap"
});
var $ac6e1d2c0dc15aba$var$FriendlyId = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        background: theme.colors.text.primary,
        color: "white",
        padding: "8px 16px",
        borderRadius: "6px",
        fontWeight: 600,
        fontSize: "14px"
    };
});
var $ac6e1d2c0dc15aba$var$PropertyDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    gap: "16px"
});
var $ac6e1d2c0dc15aba$var$SpecialistContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    paddingTop: "16px"
});
var $ac6e1d2c0dc15aba$var$SpecialistInfo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width: "fit-content",
        borderRadius: "32px",
        padding: "8px 16px",
        background: theme.colors.neutral[100]
    };
});
var $ac6e1d2c0dc15aba$var$SpecialistAvatar = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        background: theme.colors.vivid[100],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        color: theme.colors.primary.one
    };
});
var $ac6e1d2c0dc15aba$var$SpecialistName = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span(function(param) {
    var theme = param.theme;
    return {
        fontSize: "14px",
        color: theme.colors.text.primary,
        fontWeight: 500
    };
});
var $ac6e1d2c0dc15aba$var$CreatedDate = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        fontSize: "12px",
        color: theme.colors.text.secondary,
        marginTop: "16px",
        paddingTop: "16px"
    };
});
var $ac6e1d2c0dc15aba$var$Subtext = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(function(param) {
    var theme = param.theme;
    return {
        fontSize: "14px",
        color: theme.colors.text.secondary,
        margin: "12px 0 0 0",
        lineHeight: "1.5"
    };
});




function $a827c6bc3eda7a57$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  height: 100%;\n  grid-gap: 1.6rem;\n  margin-top: -110px;\n\n  @media ",
        " {\n    grid-template-columns: 340px 1fr;\n    grid-column-gap: 1.75rem;\n    margin-top: 0;\n  }\n\n  @media ",
        " {\n    grid-template-columns: 340px minmax(auto, 650px);\n    grid-column-gap: 3.1875rem;\n    margin-top: 0;\n  }\n"
    ]);
    $a827c6bc3eda7a57$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $a827c6bc3eda7a57$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  display: block;\n  margin-top: 8rem;\n  @media ",
        " {\n    position: sticky;\n    top: 190px;\n    margin-top: 0;\n    height: 280px;\n  }\n"
    ]);
    $a827c6bc3eda7a57$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $a827c6bc3eda7a57$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        ""
    ]);
    $a827c6bc3eda7a57$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $a827c6bc3eda7a57$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 20px;\n"
    ]);
    $a827c6bc3eda7a57$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $a827c6bc3eda7a57$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  margin-top: 2rem;\n  color: #434344;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    $a827c6bc3eda7a57$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $a827c6bc3eda7a57$var$Layout = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($a827c6bc3eda7a57$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $a827c6bc3eda7a57$var$WelcomeBackStickyArea = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($a827c6bc3eda7a57$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $a827c6bc3eda7a57$var$ApplicationsList = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($a827c6bc3eda7a57$var$_templateObject2());
var $a827c6bc3eda7a57$var$AppCardWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($a827c6bc3eda7a57$var$_templateObject3());
var $a827c6bc3eda7a57$var$MobileTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($a827c6bc3eda7a57$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
function $a827c6bc3eda7a57$export$2e2bcd8739ae039() {
    (0, $178ced39e8a813d0$export$9d605c4ba42beec3)(false);
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/dashboard");
    var _useApplicationSummaries = (0, $1c92825e7588cbce$export$b17f9dfb16ad8a1d)(), applicationSummaries = _useApplicationSummaries.applicationSummaries, hasFetchedSummaries = _useApplicationSummaries.hasFetchedSummaries;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), loggedOpps = _useState[0], setLoggedOpps = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), showReturningUserModal = _useState1[0], setShowReturningUserModal = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), showStartNewAppModal = _useState2[0], setShowStartNewAppModal = _useState2[1];
    var query = new URLSearchParams((0, $f4f5613f4156d471$export$45d76561a5302f2b)().search);
    var isReturningUser = query.get("returningUser") === "true";
    (0, $hAGkE.useEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).pageViewed,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).formInteraction,
            event_label: "MyMojo - Dashboard"
        });
    }, []);
    (0, $hAGkE.useEffect)(function() {
        if (hasFetchedSummaries && !loggedOpps) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).dashboardOpps,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).customEvent,
                event_label: "".concat(applicationSummaries.length)
            });
            setLoggedOpps(true);
        }
    }, [
        hasFetchedSummaries
    ]);
    var activeApplications = (0, $hAGkE.useMemo)(function() {
        return (0, $1fc51b1dc9a30698$export$e3b5788aad6d3db6)(applicationSummaries !== null && applicationSummaries !== void 0 ? applicationSummaries : []);
    }, [
        applicationSummaries
    ]);
    var activeCount = activeApplications.length;
    var isReturningUserFlow = isReturningUser && activeCount > 0 && showReturningUserModal;
    var onCloseModal = function() {
        document.querySelector("html").style.overflow = "auto";
        setShowReturningUserModal(false);
        setShowStartNewAppModal(false);
    };
    var handleStartNewApplication = function() {
        if (!isReturningUser && activeCount > 0) setShowStartNewAppModal(true);
        else (0, $3216fe7bc1e1c300$export$3ca1530a76305b39)();
    };
    var getModalConfig = function() {
        var hasSingleApp = activeCount === 1;
        var isStartNewFlow = showStartNewAppModal;
        if (isReturningUserFlow) return {
            heading: "Welcome back",
            paragraphs: [
                "Let's pick up from where you left off."
            ],
            buttonText: hasSingleApp ? "View application" : "View applications",
            buttonAction: "view-application",
            showApplicationCard: hasSingleApp,
            application: hasSingleApp ? activeApplications[0] : undefined
        };
        if (isStartNewFlow) return {
            heading: "Start a new application",
            paragraphs: [
                hasSingleApp ? "You have an active application. To make changes, discuss or proceed with this application, close this window and return to your account." : "You have active applications. To make changes, discuss or proceed with an application, close this window and return to your account.",
                "Otherwise, start a new application below."
            ],
            buttonText: "Start new application",
            buttonAction: "start-new-application",
            subtext: "If you start a brand new application this will not be linked to any active case, you will need to provide your details again and you may be allocated to a different expert should you look to get advice and apply.",
            showApplicationCard: hasSingleApp,
            application: hasSingleApp ? activeApplications[0] : undefined
        };
        return null;
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $75494c4702aed368$export$78d6b2773a1d5dd8), {
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($a827c6bc3eda7a57$var$Layout, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a827c6bc3eda7a57$var$WelcomeBackStickyArea, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $15a25c72ef0a04de$export$6823e0582b8de248), {
                        onStartNewApplication: handleStartNewApplication
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($a827c6bc3eda7a57$var$ApplicationsList, {
                    children: [
                        (applicationSummaries === null || applicationSummaries === void 0 ? void 0 : applicationSummaries.length) > 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a827c6bc3eda7a57$var$MobileTitle, {
                            children: "Your applications"
                        }),
                        applicationSummaries === null || applicationSummaries === void 0 ? void 0 : applicationSummaries.map(function(summary) {
                            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a827c6bc3eda7a57$var$AppCardWrapper, {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3c2eb4b929cc742c$export$1a548e958d112fd5), {
                                    friendlyId: summary.friendlyId
                                })
                            }, summary.friendlyId);
                        })
                    ]
                }),
                (showReturningUserModal || showStartNewAppModal) && function() {
                    var config = getModalConfig();
                    return config ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ac6e1d2c0dc15aba$export$3df9978529e1fa2a), {
                        application: config.application,
                        onClose: onCloseModal,
                        config: config
                    }) : null;
                }()
            ]
        })
    });
}




var $hAGkE = parcelRequire("hAGkE");



var // For now (2024-05-15) in case there are any extant links to /new-application
// keep this component, but just redirect to discovery.
$11c4ed1fd466dc20$export$2e2bcd8739ae039 = function() {
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/new-application");
    (0, $hAGkE.useEffect)(function() {
        (0, $3216fe7bc1e1c300$export$3ca1530a76305b39)();
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$8dc49548733a6fce), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
            theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline,
            size: 80
        })
    });
};




var $hAGkE = parcelRequire("hAGkE");





parcelRequire("hAGkE");


function $c67218ac7986ea8b$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  width: 100%;\n  display: inherit;\n"
    ]);
    $c67218ac7986ea8b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/* May need better styling */ var $c67218ac7986ea8b$var$ErrorContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($c67218ac7986ea8b$var$_templateObject());
function $c67218ac7986ea8b$export$d56b0569bceb92ae(param) {
    var children = param.children, resetError = param.resetError;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($c67218ac7986ea8b$var$ErrorContainer, {
        children: [
            (0, $10b47c5a212e87a0$export$3fce19fdf0c5de73) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                children: children
            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                children: "Something went wrong"
            }),
            resetError && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("button", {
                onClick: function() {
                    history.back();
                    resetError();
                },
                children: "Go Back"
            })
        ]
    });
}





var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");




var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");
var $bb552e4db890ef97$export$2013e195d08f4102 = /*#__PURE__*/ function(StatusContentKey) {
    StatusContentKey["advise"] = "advise";
    StatusContentKey["postRec"] = "postRec";
    StatusContentKey["booked"] = "booked";
    StatusContentKey["recommendation"] = "recommendation";
    StatusContentKey["application"] = "application";
    StatusContentKey["dip"] = "dip";
    StatusContentKey["successfulApplicaton"] = "successfulApplication";
    StatusContentKey["completionSet"] = "completionSet";
    StatusContentKey["offer"] = "offer";
    StatusContentKey["wip"] = "wip";
    StatusContentKey["won"] = "won";
    StatusContentKey["lost"] = "lost";
    StatusContentKey["offerAccepted"] = "offerAccepted";
    StatusContentKey["offerAcceptedBooked"] = "offerAcceptedBooked";
    StatusContentKey["core"] = "core";
    StatusContentKey["prepareForAppointment"] = "prepareForAppointment";
    return StatusContentKey;
}({});



var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");


var $1c3a765b38e25bd5$export$efe00b6aae04e54d = function(param) {
    var children = param.children, _param_category = param.category, category = _param_category === void 0 ? (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction : _param_category, _param_action = param.action, action = _param_action === void 0 ? (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentViewed : _param_action, label = param.label, value = param.value, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? 0 : _param_threshold;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasFired = _useState[0], setHasFired = _useState[1];
    var containerRef = (0, $hAGkE.useRef)();
    var triggerEvent = function(entries) {
        var _entries = (0, $6mdMa._)(entries, 1), entry = _entries[0];
        if (entry.isIntersecting && !hasFired) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: action,
                event_category: category,
                event_label: label,
                value: value
            });
            setHasFired(true);
        }
    };
    // Threshold is used to dictate how much of your element is inview before the event fires, 0 means as soon as it comes into view, and 1.0 means when the end of the element comes into view
    var options = {
        root: null,
        rootMargin: "0px",
        threshold: threshold
    };
    (0, $hAGkE.useEffect)(function() {
        var observer = new IntersectionObserver(triggerEvent, options);
        var el = containerRef.current;
        if (el) observer.observe(el);
        return function() {
            if (el) observer.unobserve(el);
        };
    }, [
        containerRef,
        options
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
        ref: containerRef,
        children: children
    });
};





parcelRequire("hAGkE");



function $a22b483e81f4f3c1$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  list-style: none;\n"
    ]);
    $a22b483e81f4f3c1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $a22b483e81f4f3c1$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  &:after {\n    border-left: ",
        " 2px solid;\n    border-bottom: ",
        ' 2px solid;\n    left: -30px;\n    top: 6px;\n    width: 12px;\n    height: 6px;\n    margin: auto;\n    position: absolute;\n    content: "";\n    transform: rotate(-45deg);\n  }\n\n  &:before {\n    background: ',
        ';\n    left: -36px;\n    top: -2px;\n    margin: auto;\n    position: absolute;\n    content: "";\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n  }\n'
    ]);
    $a22b483e81f4f3c1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $a22b483e81f4f3c1$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  border: 8px solid #c1c5d1;\n  position: absolute;\n  left: -36px;\n"
    ]);
    $a22b483e81f4f3c1$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $a22b483e81f4f3c1$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  position: relative;\n  text-align: left;\n  margin-bottom: 0;\n\n  &:before {\n    display: block;\n    content: "";\n    width: 4px;\n    height: 3em;\n    background: ',
        ";\n    position: absolute;\n    left: -28px;\n    top: 30px;\n    border-radius: 20px;\n  }\n\n  &:last-child:before {\n    display: none;\n  }\n  @media screen and ",
        " {\n    &:before {\n      height: 4em;\n    }\n  }\n"
    ]);
    $a22b483e81f4f3c1$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $a22b483e81f4f3c1$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  line-height: 18px;\n  margin: 0.5em 0 1.5em;\n  min-height: 3em;\n"
    ]);
    $a22b483e81f4f3c1$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $a22b483e81f4f3c1$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 16px;\n  font-weight: 550;\n  line-height: 24px;\n"
    ]);
    $a22b483e81f4f3c1$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $a22b483e81f4f3c1$var$List = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($a22b483e81f4f3c1$var$_templateObject());
var $a22b483e81f4f3c1$var$Completed = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($a22b483e81f4f3c1$var$_templateObject1(), function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.primary;
});
var $a22b483e81f4f3c1$var$NotCompleted = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($a22b483e81f4f3c1$var$_templateObject2());
var $a22b483e81f4f3c1$var$ListItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($a22b483e81f4f3c1$var$_templateObject3(), function(param) {
    var color = param.color;
    return color;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $a22b483e81f4f3c1$var$Text = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($a22b483e81f4f3c1$var$_templateObject4(), function(props) {
    return props.theme.shade50;
});
var $a22b483e81f4f3c1$var$Title = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($a22b483e81f4f3c1$var$_templateObject5());
var $a22b483e81f4f3c1$var$checklistData = [
    {
        id: [
            (0, $bb552e4db890ef97$export$2013e195d08f4102).advise,
            (0, $bb552e4db890ef97$export$2013e195d08f4102).booked
        ],
        title: "Mortgage Advice",
        description: "Speak to an expert about what you want and need from a mortgage."
    },
    {
        id: [
            (0, $bb552e4db890ef97$export$2013e195d08f4102).recommendation
        ],
        title: "Recommendation",
        description: "Your expert recommended deal from over 10,000 options with over 60 lenders."
    },
    {
        id: [
            (0, $bb552e4db890ef97$export$2013e195d08f4102).application
        ],
        title: "Application",
        description: "Mojo handle your application with the lender for your preferred deal."
    },
    {
        id: [
            (0, $bb552e4db890ef97$export$2013e195d08f4102).offer,
            (0, $bb552e4db890ef97$export$2013e195d08f4102).completionSet
        ],
        title: "Offer",
        description: "The mortgage lender is prepared to offer you a mortgage."
    },
    {
        id: [
            (0, $bb552e4db890ef97$export$2013e195d08f4102).won
        ],
        title: "Completed",
        description: "Your mortgage is in place."
    }
];
var $a22b483e81f4f3c1$export$d347637cd596c7c2 = function(param) {
    var stage = param.stage;
    var applicationIndex = $a22b483e81f4f3c1$var$checklistData.findIndex(function(x) {
        return x.id.includes(stage);
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a22b483e81f4f3c1$var$List, {
        children: $a22b483e81f4f3c1$var$checklistData.map(function(param, i) {
            var title = param.title, description = param.description;
            var color = i < applicationIndex ? "#073ED9" : "#C1C5D1";
            var isComplete = i <= applicationIndex;
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($a22b483e81f4f3c1$var$ListItem, {
                color: color,
                children: [
                    isComplete ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a22b483e81f4f3c1$var$Completed, {}) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a22b483e81f4f3c1$var$NotCompleted, {}),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a22b483e81f4f3c1$var$Title, {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a22b483e81f4f3c1$var$Text, {
                                children: description
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
};


var $3774b92b86ee5532$export$4f37f5a2d452f4cd = function(config) {
    return function(arg) {
        if (config[arg]) return config[arg];
        if (!config[arg] && config["default"]) return config["default"];
        return null;
    };
};










var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");






var $2e5bb04a36299074$exports = {};
$2e5bb04a36299074$exports = $parcel$resolve("fyAx7");


var $2e76d81fbcfdbca5$exports = {};
$2e76d81fbcfdbca5$exports = $parcel$resolve("ltoAI");


var $d81420aa240e348d$exports = {};
$d81420aa240e348d$exports = $parcel$resolve("hYUXV");


var $175870872636a4b6$exports = {};
$175870872636a4b6$exports = $parcel$resolve("i37Kq");







parcelRequire("hAGkE");


function $59f3439255a74e88$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n"
    ]);
    $59f3439255a74e88$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $59f3439255a74e88$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n\n  @media screen and ",
        " {\n    width: 82px;\n    height: 82px;\n  }\n"
    ]);
    $59f3439255a74e88$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $59f3439255a74e88$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n"
    ]);
    $59f3439255a74e88$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $59f3439255a74e88$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 28px;\n  color: ",
        ";\n  margin: 0;\n  white-space: nowrap;\n"
    ]);
    $59f3439255a74e88$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $59f3439255a74e88$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.8;\n  color: ",
        ";\n  margin: 0;\n  white-space: nowrap;\n"
    ]);
    $59f3439255a74e88$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $59f3439255a74e88$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.8;\n  color: ",
        ";\n  text-decoration: underline;\n  text-decoration-skip-ink: none;\n  text-decoration-style: solid;\n  text-underline-position: from-font;\n  margin: 0;\n  width: min-content;\n  min-width: 100%;\n  @media screen and ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    $59f3439255a74e88$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $59f3439255a74e88$var$MortgageExpertCard = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($59f3439255a74e88$var$_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.border.light;
});
var $59f3439255a74e88$var$ExpertAvatar = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($59f3439255a74e88$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $59f3439255a74e88$var$ExpertInfo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($59f3439255a74e88$var$_templateObject2());
var $59f3439255a74e88$var$ExpertName = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($59f3439255a74e88$var$_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $59f3439255a74e88$var$ExpertTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($59f3439255a74e88$var$_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.text.secondary;
});
var $59f3439255a74e88$var$ExpertEmail = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($59f3439255a74e88$var$_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.brand.primary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $59f3439255a74e88$export$d2a3c4d05e125f83 = function(param) {
    var mortgageExpert = param.mortgageExpert;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($59f3439255a74e88$var$MortgageExpertCard, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($59f3439255a74e88$var$ExpertAvatar, {
                src: mortgageExpert.avatar,
                alt: mortgageExpert.name
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($59f3439255a74e88$var$ExpertInfo, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($59f3439255a74e88$var$ExpertName, {
                        children: mortgageExpert.name
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($59f3439255a74e88$var$ExpertTitle, {
                        children: mortgageExpert.title
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($59f3439255a74e88$var$ExpertEmail, {
                        href: "mailto:".concat(mortgageExpert.email),
                        children: mortgageExpert.email
                    })
                ]
            })
        ]
    });
};




parcelRequire("hAGkE");






var $f0d226df099d0c4c$exports = {};
$f0d226df099d0c4c$exports = $parcel$resolve("gC1gX");


function $40881c25d3dc0071$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n  padding: 5px;\n\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $40881c25d3dc0071$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $40881c25d3dc0071$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  @media screen and ",
        " {\n    width: 60%;\n  }\n"
    ]);
    $40881c25d3dc0071$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $40881c25d3dc0071$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n  flex: 1;\n  background-image: url(",
        ");\n  background-size: cover;\n  background-position: center;\n  min-height: 240px;\n  border-radius: 16px;\n\n  @media screen and ",
        " {\n    display: block;\n  }\n"
    ]);
    $40881c25d3dc0071$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $40881c25d3dc0071$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  width: 100%;\n\n  @media screen and ",
        " {\n    display: none;\n  }\n"
    ]);
    $40881c25d3dc0071$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $40881c25d3dc0071$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    $40881c25d3dc0071$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $40881c25d3dc0071$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 24px;\n"
    ]);
    $40881c25d3dc0071$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $40881c25d3dc0071$var$ConveyancingContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($40881c25d3dc0071$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $40881c25d3dc0071$var$ConveyancingContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($40881c25d3dc0071$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $40881c25d3dc0071$var$ConveyancingIllustration = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($40881c25d3dc0071$var$_templateObject2(), (0, (/*@__PURE__*/$parcel$interopDefault($f0d226df099d0c4c$exports))), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $40881c25d3dc0071$var$ConveyancingIllustrationMobile = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($40881c25d3dc0071$var$ConveyancingIllustration)($40881c25d3dc0071$var$_templateObject3(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $40881c25d3dc0071$var$TextContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($40881c25d3dc0071$var$_templateObject4());
var $40881c25d3dc0071$var$StyledConveyancingCard = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41))($40881c25d3dc0071$var$_templateObject5());
var $40881c25d3dc0071$export$8a498ed11591c94b = function(param) {
    var friendlyId = param.friendlyId, onViewQuotes = param.onViewQuotes;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var handleViewQuotes = function() {
        if (onViewQuotes) onViewQuotes();
        else history.push("/application/".concat(friendlyId, "/conveyancing"));
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($40881c25d3dc0071$var$StyledConveyancingCard, {
        theme: "default",
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($40881c25d3dc0071$var$ConveyancingContainer, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($40881c25d3dc0071$var$ConveyancingIllustrationMobile, {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($40881c25d3dc0071$var$ConveyancingContent, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($40881c25d3dc0071$var$TextContent, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                    children: "Secure your property's legal work"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                    color: "secondary",
                                    margin: "0",
                                    children: "Conveyancing is a vital part of securing your property. It's important to instruct your chosen solicitor as soon as you're ready. Your Mortgage Expert has provided a number of quotes for you to compare and review."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                            text: "View conveyancing quotes",
                            onClick: handleViewQuotes
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($40881c25d3dc0071$var$ConveyancingIllustration, {})
            ]
        })
    });
};






var $d355d692f99dba4f$exports = {};
$d355d692f99dba4f$exports = $parcel$resolve("2bDXX");


function $77da52963b5ae877$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  max-width: 978px;\n  margin: 0 auto 32px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  @media screen and ",
        " {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  max-width: 1500px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  font-family: ",
        ";\n  position: relative;\n\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  @media screen and ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 2em 2em 2em 1em;\n  strong {\n    font-weight: 550;\n  }\n  @media screen and ",
        " {\n    width: 100%;\n    margin: 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 24px;\n  margin-bottom: 24px;\n  margin-top: 36px;\n  word-break: break-word;\n  line-height: 38px;\n  font-weight: 550;\n\n  @media screen and ",
        " {\n    font-size: 28px;\n    margin-bottom: 48px;\n    margin-top: 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #333a53;\n  line-height: 180%;\n  margin: 16px 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  line-height: 24px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    $77da52963b5ae877$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject14() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: 2em;\n  margin-bottom: 6em;\n  p {\n    margin: 0 0 1em 0;\n    line-height: 18px;\n    font-size: 12px;\n    color: ",
        ";\n  }\n  @media screen and ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject15() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 5em;\n  text-align: center;\n"
    ]);
    $77da52963b5ae877$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject16() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  position: relative;\n  top: 200px;\n  left: -250px;\n  right: 0;\n  display: none;\n\n  > img {\n    width: 100%;\n    height: auto;\n  }\n\n  @media screen and ",
        " {\n    width: 600px;\n    display: block;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject17() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  height: auto;\n  position: relative;\n  top: 100px;\n  left: -150px;\n  right: 0;\n  display: none;\n\n  > img {\n    width: 100%;\n    height: auto;\n  }\n\n  @media screen and ",
        " {\n    width: auto;\n    height: 587px;\n    display: block;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject18() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  height: auto;\n  position: relative;\n  top: -30px;\n  left: -150px;\n  right: 0;\n  display: none;\n\n  > img {\n    width: 100%;\n    height: auto;\n  }\n\n  @media screen and ",
        " {\n    width: auto;\n    height: 650px;\n    display: block;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject19() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n"
    ]);
    $77da52963b5ae877$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject20() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: white;\n  border-radius: 16px;\n  padding: 1.5em;\n  margin: 1em;\n  bottom: 5em;\n\n  @media screen and ",
        " {\n    margin: 7em 2em 0 0;\n    padding: 4em 4em 1.5em;\n    width: 22.5em;\n    bottom: 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject21() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 26px;\n  margin: 0;\n  font-weight: 550;\n  line-height: 32px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject22() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  @media screen and ",
        " {\n    display: inline-block;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject23() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: bold;\n"
    ]);
    $77da52963b5ae877$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject24() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: rgb(7, 62, 217);\n  margin: 10px 0;\n  display: block;\n  text-decoration: underline;\n"
    ]);
    $77da52963b5ae877$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject25() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 16px;\n  margin-top: 36px;\n  margin-bottom: 1em;\n  line-height: 38px;\n  font-weight: bold;\n"
    ]);
    $77da52963b5ae877$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject26() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n  margin-top: 16px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject27() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 50px;\n  height: 50px;\n  margin-right: 20px;\n  background-image: url(",
        ");\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  border-radius: ",
        ";\n"
    ]);
    $77da52963b5ae877$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject28() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 2em 2em 2em 1em;\n  strong {\n    font-weight: 550;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject29() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n  margin: 2em auto;\n  position: relative;\n  z-index: 1;\n  max-width: 1100px;\n  width: 100%;\n  padding: 0 2em;\n\n  @media screen and ",
        " {\n    margin: 0 auto 4em auto;\n    padding: 0 3em;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject30() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n  padding: 24px 0 32px 0;\n  align-items: center;\n\n  @media screen and ",
        " {\n    grid-template-columns: 1fr 1fr;\n    gap: 64px;\n    padding: 48px 0 12px 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject31() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n\n  @media screen and ",
        " {\n    width: 574px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject32() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 28px;\n  font-weight: 600;\n  color: #000928;\n  line-height: 1.3;\n  margin: 0;\n\n  @media screen and ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject33() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-family: TT Wellingtons;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 180%;\n  letter-spacing: 0%;\n  font-variant-numeric: lining-nums proportional-nums;\n  color: #000928;\n  margin: 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject34() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n  padding-left: 20px;\n  color: #000928;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 180%;\n  letter-spacing: 0%;\n  font-variant-numeric: lining-nums proportional-nums;\n\n  li {\n    margin-bottom: 8px;\n  }\n\n  b {\n    font-weight: 600;\n    font-style: Bold;\n    font-size: 16px;\n    line-height: 180%;\n    letter-spacing: 0%;\n    font-variant-numeric: lining-nums proportional-nums;\n    color: #000928;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject35() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media screen and ",
        " {\n    display: flex;\n    justify-content: start;\n    align-items: flex-start;\n    height: 100%;\n    width: 100%;\n\n    img {\n      width: 320px;\n      mix-blend-mode: darken;\n      object-fit: contain;\n      align-self: flex-end;\n    }\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject36() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  background: #073ed9;\n  color: #f8f9fc;\n  padding: 16px 32px;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  border-bottom: 8px #001bbe solid;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #0056b3;\n  }\n\n  @media screen and ",
        " {\n    width: 100%;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject37() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-family: TT Wellingtons;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 180%;\n  letter-spacing: 0%;\n  font-variant-numeric: lining-nums proportional-nums;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject38() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: white;\n  width: 100%;\n  max-width: 1100px;\n  border-radius: 24px;\n  padding: 24px;\n  margin: 32px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  @media screen and ",
        " {\n    height: 348px;\n    padding: 40px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n    gap: 32px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject39() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @media screen and ",
        " {\n    width: 534px;\n    height: 268px;\n    justify-content: center;\n    gap: 10px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject40() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 20px;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n\n  @media screen and ",
        " {\n    font-size: 24px;\n    margin: 0 0 16px 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject41() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  line-height: 1.7;\n  font-weight: 500;\n  margin: 0 0 20px 0;\n\n  @media screen and ",
        " {\n    font-size: 15px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject42() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  order: -1;\n\n  img {\n    width: 100%;\n    height: 200px;\n    border-radius: 8px;\n    object-fit: cover;\n  }\n\n  @media screen and ",
        " {\n    order: 0;\n\n    img {\n      width: -webkit-fill-available;\n      height: 250px;\n    }\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject43() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  background: transparent;\n  border: 2px solid black;\n  border-radius: 8px;\n  padding: 15px 20px;\n  color: black;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: black;\n    color: white;\n  }\n\n  @media screen and ",
        " {\n    font-size: 16px;\n    padding: 12px 24px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject44() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 24px;\n  padding: 0;\n  margin: 64px 0 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  align-items: center;\n\n  @media screen and ",
        " {\n    padding: 32px 32px 0 32px;\n    flex-direction: row;\n    gap: 64px;\n    justify-content: center;\n    align-items: flex-start;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject45() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 20px;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0 0 24px 0;\n\n  @media screen and ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject46() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  position: relative;\n\n  @media screen and ",
        ' {\n    width: 574px;\n    height: 336px;\n    flex-shrink: 0;\n\n    &::before {\n      content: "";\n      position: absolute;\n      top: -70px;\n      left: -100px;\n      width: calc(100% + 80px);\n      height: calc(100% + 40px);\n      background-image: url(',
        ");\n      background-repeat: no-repeat;\n      background-position: 0 0;\n      background-size: auto;\n      z-index: -1;\n      pointer-events: none;\n    }\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject47() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject48() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 18px;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0;\n  line-height: 1.3;\n"
    ]);
    $77da52963b5ae877$var$_templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject49() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 16px;\n  color: ",
        ";\n  line-height: 1.6;\n  margin: 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject50() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject51() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject52() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #00b67a;\n  font-size: 18px;\n  line-height: 1;\n"
    ]);
    $77da52963b5ae877$var$_templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject53() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #6e717c;\n  font-size: 16px;\n  font-weight: 500;\n"
    ]);
    $77da52963b5ae877$var$_templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject54() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #6e717c;\n  font-size: 16px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject55() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  max-width: 370px;\n  height: 300px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media screen and ",
        " {\n    width: 370px;\n    flex-shrink: 0;\n  }\n"
    ]);
    $77da52963b5ae877$var$_templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject56() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #6e717c;\n  margin-top: 32px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject57() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 110px;\n  height: 32px;\n  margin-bottom: 16px;\n"
    ]);
    $77da52963b5ae877$var$_templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function $77da52963b5ae877$var$_templateObject58() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-family: TT Wellingtons;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 180%;\n  margin: 0;\n"
    ]);
    $77da52963b5ae877$var$_templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
var $77da52963b5ae877$export$15529022dcaf3eec = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject());
var $77da52963b5ae877$export$b600c6a5fff6759c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$1b51c6466e79404f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject2());
var $77da52963b5ae877$export$42a852a2b6b56249 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject3(), function(props) {
    return props.theme.fontFamily;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$f2f1d4539d04d991 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg, function(param) {
    var wider = param.wider;
    return wider ? "8.5em 5em 0 6.25em" : "8.5em 12.5em 0 6.25em";
});
var $77da52963b5ae877$export$b0f9968eae5a4e21 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject5(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$f99233281efd08a0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($77da52963b5ae877$var$_templateObject6(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$5babecc773473a0f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($77da52963b5ae877$export$f99233281efd08a0)($77da52963b5ae877$var$_templateObject7());
var $77da52963b5ae877$export$319968649324fdc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h4($77da52963b5ae877$var$_templateObject8());
var $77da52963b5ae877$export$5f1af8db9871e1d6 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($77da52963b5ae877$var$_templateObject9());
var $77da52963b5ae877$export$7df180f992c386e3 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($77da52963b5ae877$export$5f1af8db9871e1d6)($77da52963b5ae877$var$_templateObject10());
var $77da52963b5ae877$export$210dc657affc8afd = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h3($77da52963b5ae877$var$_templateObject11());
var $77da52963b5ae877$export$9e9b0fbce46496e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject12());
var $77da52963b5ae877$export$f51f4c4ede09e011 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject13());
var $77da52963b5ae877$export$55891959d410fe99 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject14(), function(props) {
    return props.theme.shade20;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$8f67d857ad88efa0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject15());
var $77da52963b5ae877$export$394ccf9c46e8b2f1 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($77da52963b5ae877$var$_templateObject16(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$543ea1a8bdefb69e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($77da52963b5ae877$var$_templateObject17(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$fa8dc7a2d61a4615 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($77da52963b5ae877$var$_templateObject18(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$42b8d7f57a240e1c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject19());
var $77da52963b5ae877$export$bc861d1d309c6919 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject20(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$814adccc4676adf9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($77da52963b5ae877$var$_templateObject21());
var $77da52963b5ae877$export$31c0018d451d3b19 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject22(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$d8a8e2cd87eed68c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($77da52963b5ae877$export$5f1af8db9871e1d6)($77da52963b5ae877$var$_templateObject23());
var $77da52963b5ae877$export$d730efcde27c09 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($77da52963b5ae877$var$_templateObject24());
var $77da52963b5ae877$export$d5c56664638992a4 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h6($77da52963b5ae877$var$_templateObject25());
var $77da52963b5ae877$export$474db65c3c394e1c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($77da52963b5ae877$export$d5c56664638992a4)($77da52963b5ae877$var$_templateObject26());
var $77da52963b5ae877$export$455d94988878c142 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject27(), function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius ? "50%" : "0%";
});
var $77da52963b5ae877$export$9d2b4227a95687cc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject28());
var $77da52963b5ae877$export$5c0547b091a4b556 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).main($77da52963b5ae877$var$_templateObject29(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$4489c2ed11909944 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).section($77da52963b5ae877$var$_templateObject30(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$f32ccc8e9f794271 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject31(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$815fb821483d8e08 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($77da52963b5ae877$var$_templateObject32(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$4cf7f029fe6b7159 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($77da52963b5ae877$var$_templateObject33());
var $77da52963b5ae877$export$e3d1d549dcb7d53c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($77da52963b5ae877$var$_templateObject34());
var $77da52963b5ae877$export$9b9920498925f0fb = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject35(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$bd36621ef7814117 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1))($77da52963b5ae877$var$_templateObject36(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$cfb5c3caabe20d65 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($77da52963b5ae877$var$_templateObject37(), function(props) {
    var _props_theme_shade;
    return ((_props_theme_shade = props.theme.shade) === null || _props_theme_shade === void 0 ? void 0 : _props_theme_shade["20"]) || "#3B4258";
});
var $77da52963b5ae877$export$69ed894a7932b604 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).section($77da52963b5ae877$var$_templateObject38(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$51a9c37cab91cff6 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject39(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$69bc41ee738923ec = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($77da52963b5ae877$var$_templateObject40(), function(props) {
    var _props_theme_shade;
    return ((_props_theme_shade = props.theme.shade) === null || _props_theme_shade === void 0 ? void 0 : _props_theme_shade["0"]) || "#3F4148";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$171d1744501983 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($77da52963b5ae877$var$_templateObject41(), function(props) {
    var _props_theme_shade;
    return ((_props_theme_shade = props.theme.shade) === null || _props_theme_shade === void 0 ? void 0 : _props_theme_shade["20"]) || "#3B4258";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$b3711e4d32776a29 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject42(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$176492db868efc7f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($77da52963b5ae877$var$_templateObject43(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$74f29a5c5ac28ae1 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontStyle: "italic",
    marginTop: "2em",
    marginBottom: "2em"
});
var $77da52963b5ae877$export$30d95fb206f2716 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).section($77da52963b5ae877$var$_templateObject44(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$b6570f987931fbcb = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($77da52963b5ae877$var$_templateObject45(), function(props) {
    var _props_theme_shade;
    return ((_props_theme_shade = props.theme.shade) === null || _props_theme_shade === void 0 ? void 0 : _props_theme_shade["0"]) || "#3F4148";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$b94f30aa31093782 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject46(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg, (0, (/*@__PURE__*/$parcel$interopDefault($d355d692f99dba4f$exports))));
var $77da52963b5ae877$export$5902fbf547f0ef82 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject47());
var $77da52963b5ae877$export$ce6f6d5239a986c9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h4($77da52963b5ae877$var$_templateObject48(), function(props) {
    var _props_theme_shade;
    return ((_props_theme_shade = props.theme.shade) === null || _props_theme_shade === void 0 ? void 0 : _props_theme_shade["0"]) || "#3F4148";
});
var $77da52963b5ae877$export$ececb5740e139a0b = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($77da52963b5ae877$var$_templateObject49(), function(props) {
    var _props_theme_shade;
    return ((_props_theme_shade = props.theme.shade) === null || _props_theme_shade === void 0 ? void 0 : _props_theme_shade["10"]) || "#61676e";
});
var $77da52963b5ae877$export$caa563a408e1927 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject50());
var $77da52963b5ae877$export$4447f1e7c9a89e1b = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject51());
var $77da52963b5ae877$export$5e19b9354e495cb9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject52());
var $77da52963b5ae877$export$4236a1dce8bed981 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($77da52963b5ae877$var$_templateObject53());
var $77da52963b5ae877$export$441cb28ce0dfeb0f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($77da52963b5ae877$var$_templateObject54());
var $77da52963b5ae877$export$a598707cfcbe391f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($77da52963b5ae877$var$_templateObject55(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $77da52963b5ae877$export$a06f1c675e846f6f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).footer($77da52963b5ae877$var$_templateObject56());
var $77da52963b5ae877$export$7b4485b886e9117a = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($77da52963b5ae877$var$_templateObject57());
var $77da52963b5ae877$export$9c55d0bdacc50a98 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($77da52963b5ae877$var$_templateObject58());


function $b2f5a410765a2426$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 14px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 5px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background-color: ",
        ";\n  border-radius: 8px;\n  padding: 8px 12px;\n  width: fit-content;\n\n  p {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 1.8;\n    color: ",
        ";\n    margin: 0;\n    white-space: nowrap;\n  }\n"
    ]);
    $b2f5a410765a2426$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  color: ",
        ";\n"
    ]);
    $b2f5a410765a2426$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.8;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n\n  @media screen and ",
        " {\n    grid-template-columns: 574px 372px;\n    align-items: stretch;\n  }\n\n  /* Ensure cards stretch to full height */\n  > * {\n    @media screen and ",
        " {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n"
    ]);
    $b2f5a410765a2426$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  background-image: url(",
        ");\n  background-size: cover;\n  background-position: left;\n  background-repeat: no-repeat;\n  height: 277px;\n  border-radius: 16px;\n  margin: 0 0 32px 0;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  background-color: ",
        ";\n  border-radius: 182px;\n  padding: 7px 16px;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n\n  span {\n    font-weight: 500;\n    font-size: 11px;\n    line-height: 20px;\n    color: ",
        ";\n  }\n"
    ]);
    $b2f5a410765a2426$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  top: 15px;\n  left: 12px;\n  background-color: #cefedb;\n  border-radius: 262px;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);\n\n  .dot {\n    width: 16px;\n    height: 16px;\n    background-color: #00c237;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  span {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 12px;\n    color: ",
        ";\n  }\n"
    ]);
    $b2f5a410765a2426$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background-color: #8dce46;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 14px;\n  color: ",
        ";\n"
    ]);
    $b2f5a410765a2426$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  gap: 1px;\n  align-items: end;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject14() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 4px;\n  height: ",
        "px;\n  background-color: ",
        ";\n  border-radius: 14px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject15() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background-image: url(",
        ");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 292px;\n  border-radius: 16px;\n  margin-bottom: 32px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject16() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 100%;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject17() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 100%;\n  gap: 32px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject18() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.4;\n  margin-top: 8px;\n  text-align: left;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject19() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 32px;\n  padding: 5px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject20() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 0;\n  min-width: 535px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    $b2f5a410765a2426$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2f5a410765a2426$var$_templateObject21() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-position-x: 28px;\n  min-height: 240px;\n  border-radius: 16px;\n\n  @media screen and (max-width: 1023px) {\n    display: none;\n  }\n"
    ]);
    $b2f5a410765a2426$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
var $b2f5a410765a2426$var$SmallFontButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject());
var $b2f5a410765a2426$var$HeaderSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject1());
var $b2f5a410765a2426$var$SectionContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject2());
var $b2f5a410765a2426$var$BannerSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject3());
var $b2f5a410765a2426$var$OfferAcceptedBanner = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.status.warning;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $b2f5a410765a2426$var$TextContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject5());
var $b2f5a410765a2426$var$OfferAcceptedHeading = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h4($b2f5a410765a2426$var$_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $b2f5a410765a2426$var$OfferAcceptedBody = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($b2f5a410765a2426$var$_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.text.secondary;
});
var $b2f5a410765a2426$var$TwoColumnContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject8(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $b2f5a410765a2426$var$PropertyImageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject9(), (0, (/*@__PURE__*/$parcel$interopDefault($2e5bb04a36299074$exports))));
var $b2f5a410765a2426$var$PropertyBadge = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject10(), function(props) {
    return props.position.top !== undefined && "top: ".concat(props.position.top, "px;");
}, function(props) {
    return props.position.bottom !== undefined && "bottom: ".concat(props.position.bottom, "px;");
}, function(props) {
    return props.position.left !== undefined && "left: ".concat(props.position.left, "px;");
}, function(props) {
    return props.position.right !== undefined && "right: ".concat(props.position.right, "px;");
}, function(param) {
    var theme = param.theme;
    return theme.colors.background.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $b2f5a410765a2426$var$GreenBadge = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $b2f5a410765a2426$var$EPCRating = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $b2f5a410765a2426$var$SignalBars = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject13());
var $b2f5a410765a2426$var$SignalBar = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject14(), function(props) {
    return props.height;
}, function(props) {
    return props.active ? "#5bfb88" : "#d1ddfc";
});
var $b2f5a410765a2426$var$MIPImageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject15(), (0, (/*@__PURE__*/$parcel$interopDefault($2e76d81fbcfdbca5$exports))));
var $b2f5a410765a2426$var$PropertyCardContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject16());
var $b2f5a410765a2426$var$MIPCardContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject17());
var $b2f5a410765a2426$var$ErrorMessage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.colors.status.error;
});
var $b2f5a410765a2426$var$HadAnOfferAcceptedContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject19());
var $b2f5a410765a2426$var$HadAnOfferAcceptedContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject20());
var $b2f5a410765a2426$var$HadAnOfferAcceptedIllustration = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b2f5a410765a2426$var$_templateObject21(), (0, (/*@__PURE__*/$parcel$interopDefault($d81420aa240e348d$exports))));
var $b2f5a410765a2426$var$CardStyleOverrides = {
    borderRadius: "24px"
};
var $b2f5a410765a2426$export$166e2582d31d4ca0 = function(param) {
    var fetchedStatus = param.fetchedStatus, friendlyId = param.friendlyId;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    // Set UTMs for Offer Accepted (aka. pnf-returns) experiment if none are present
    (0, $hAGkE.useEffect)(function() {
        var searchParams = new URLSearchParams(window.location.search);
        // Taken from: https://www.figma.com/board/JPCNDj3YrxK4bERQ6Jsa1N/PNF-Experience---Implementation-Support-Info?node-id=39-2592&t=Vbu5YvGoUdaI4q9y-0
        if (!searchParams.has("utm_source")) searchParams.set("utm_source", "Online");
        if (!searchParams.has("utm_medium")) searchParams.set("utm_medium", "MyMojo");
        history.replace({
            search: searchParams.toString()
        });
    }, [
        history
    ]);
    // Create mortgageExpert object from API data with fallbacks
    var mortgageExpert = {
        name: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.opportunityOwnerTextForEmail) || "Mojo Mortgages",
        title: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.flexRoles2) || "Mortgage Expert",
        email: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress) || "",
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($175870872636a4b6$exports)))
    };
    // State for managing MIP URL error display
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), showMipError = _useState[0], setShowMipError = _useState[1];
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$15529022dcaf3eec), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$HeaderSection, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H1, {
                        margin: "0 0 16px 0",
                        children: "Your house hunting toolkit"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).LargeBody, {
                        color: "secondary",
                        margin: "0",
                        children: "Everything you need to find your new home with confidence."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                theme: "default",
                style: $b2f5a410765a2426$var$CardStyleOverrides,
                content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$HadAnOfferAcceptedContainer, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$HadAnOfferAcceptedContent, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$OfferAcceptedBanner, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                        children: "Had an offer accepted on a property?"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$TextContent, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$OfferAcceptedHeading, {
                                            children: "Let's get your mortgage sorted \uD83C\uDF89"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$OfferAcceptedBody, {
                                            children: "To move quickly and secure your mortgage deal, please contact your Mortgage Expert. They're ready to discuss your accepted offer and guide you through the next steps."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$SmallFontButton, {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                                type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                                                text: "Get a mortgage offer",
                                                onClick: function() {
                                                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                                        event_label: "CTA Clicked - Offer Accepted - Status Page"
                                                    });
                                                    // Add appointment ID if it doesn't exist
                                                    var searchParams = new URLSearchParams(location.search);
                                                    if (!searchParams.has("appointmentTypeId")) searchParams.set("appointmentTypeId", "79489776"); // PNF Return (Property Found)
                                                    // Navigate the user to the 'get-a-mortgage-offer' booking page
                                                    window.location.href = "/results/".concat(friendlyId, "/get-a-mortgage-offer/book?").concat(searchParams.toString());
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$HadAnOfferAcceptedIllustration, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$TwoColumnContainer, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                        theme: "default",
                        style: $b2f5a410765a2426$var$CardStyleOverrides,
                        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$PropertyCardContent, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$PropertyImageContainer, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$GreenBadge, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                                            className: "dot",
                                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
                                                                width: "8",
                                                                height: "6",
                                                                viewBox: "0 0 8 6",
                                                                fill: "none",
                                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
                                                                    d: "M7 1L3 5L1 3",
                                                                    stroke: "white",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                            children: "No known restrictions"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$PropertyBadge, {
                                                    position: {
                                                        bottom: 98,
                                                        right: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                            children: "Mobile coverage"
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$SignalBars, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$SignalBar, {
                                                                    height: 12,
                                                                    active: true
                                                                }),
                                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$SignalBar, {
                                                                    height: 15,
                                                                    active: true
                                                                }),
                                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$SignalBar, {
                                                                    height: 18,
                                                                    active: true
                                                                }),
                                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$SignalBar, {
                                                                    height: 20,
                                                                    active: false
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$PropertyBadge, {
                                                    position: {
                                                        bottom: 47,
                                                        left: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                            children: "EPC"
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$EPCRating, {
                                                            children: "71 C"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$TextContent, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                                    margin: "0 0 8px 0",
                                                    children: "View & research properties"
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                                    color: "secondary",
                                                    margin: "0 0 16px 0",
                                                    children: "Run a free Property Report to understand a home's details and avoid any surprises"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$SmallFontButton, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                        type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                                        text: "Create a property report",
                                        onClick: function() {
                                            window.open("".concat((0, $10b47c5a212e87a0$export$ebf5b5d131af837), "/application/").concat(friendlyId, "/property-report/"), "_blank");
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                        theme: "default",
                        style: $b2f5a410765a2426$var$CardStyleOverrides,
                        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$MIPCardContent, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$MIPImageContainer, {}),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$TextContent, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                                    margin: "0 0 8px 0",
                                                    children: "Mortgage in Principle"
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                                    color: "secondary",
                                                    margin: "0",
                                                    children: "Your affordability has been verified by a Mortgage Expert, so you're good to start viewing properties."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$SmallFontButton, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                                            text: "View your Mortgage in Principle",
                                            onClick: function() {
                                                if (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.mipUrl) {
                                                    setShowMipError(false); // Clear any existing error
                                                    window.open(fetchedStatus.mipUrl, "_blank");
                                                } else setShowMipError(true); // Show error when no URL available
                                            }
                                        }),
                                        showMipError && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b2f5a410765a2426$var$ErrorMessage, {
                                            children: "Sorry, we could not locate your document. Please try again later or contact your Mortgage Expert."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                theme: "default",
                style: $b2f5a410765a2426$var$CardStyleOverrides,
                content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$SectionContent, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b2f5a410765a2426$var$TextContent, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                    children: "Got a question for your expert?"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                    children: "For any other questions or updates about your mortgage journey, your dedicated Mortgage Expert, is here to help guide you through the mortgage process."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $59f3439255a74e88$export$d2a3c4d05e125f83), {
                            mortgageExpert: mortgageExpert
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $40881c25d3dc0071$export$8a498ed11591c94b), {
                friendlyId: friendlyId
            })
        ]
    });
};



parcelRequire("hAGkE");




parcelRequire("hAGkE");




function $0f2ec52df0fc99e9$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  @media screen and ",
        " {\n    width: 610px;\n    flex: unset;\n  }\n"
    ]);
    $0f2ec52df0fc99e9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0f2ec52df0fc99e9$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media screen and ",
        " {\n    display: block;\n    width: 375px;\n    height: 337px;\n    background-image: url(",
        ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    flex-shrink: 0;\n    position: absolute;\n    right: 0;\n    z-index: 1;\n  }\n"
    ]);
    $0f2ec52df0fc99e9$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0f2ec52df0fc99e9$var$HeaderContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0f2ec52df0fc99e9$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $0f2ec52df0fc99e9$var$GuitarIllustration = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0f2ec52df0fc99e9$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg, (0, (/*@__PURE__*/$parcel$interopDefault($d2ebd71da6576dcd$exports))));
var $0f2ec52df0fc99e9$export$38ea4201dc9a7b0b = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0f2ec52df0fc99e9$var$HeaderContent, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H1, {
                        children: "Congratulations!"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H1, {
                        children: "Let's lock in your mortgage."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).LargeBody, {
                        color: "secondary",
                        margin: "0",
                        children: "Your recommendation call is booked - the final step before we submit an application."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0f2ec52df0fc99e9$var$GuitarIllustration, {})
        ]
    });
};




parcelRequire("hAGkE");


// see MDN docs for further options: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat

var $2xTNA = parcelRequire("2xTNA");
var $f8c373eb33718aa4$export$3ae94a2503e890a1 = function(date) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        dateStyle: "medium",
        timeStyle: "short"
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
};
var $f8c373eb33718aa4$export$105f2a30b5069e01 = function(date) {
    if (date === null || (typeof date === "undefined" ? "undefined" : (0, $2xTNA._)(date)) !== "object") return "";
    var dayOfMonth = date.getDate();
    var day = dayOfMonth + $f8c373eb33718aa4$export$6f6258299a22298a(dayOfMonth);
    var month = date.toLocaleString("default", {
        month: "long"
    });
    var time = date.toLocaleString("default", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
    return "".concat(day, " ").concat(month, ", ").concat(time.replace("00:", "12:").replace(" ", ""));
};
var $f8c373eb33718aa4$export$326be129b2e4eb85 = function(date) {
    if (date === null) return "";
    var dayOfMonth = date.getDate();
    var day = dayOfMonth + $f8c373eb33718aa4$export$6f6258299a22298a(dayOfMonth);
    var month = date.toLocaleString("default", {
        month: "long"
    });
    var year = date.getFullYear();
    return "".concat(day, " ").concat(month, " ").concat(year);
};
var $f8c373eb33718aa4$export$4a944a2e75ad2a38 = function(date) {
    if (date === null) return "";
    var time = date.toLocaleString("default", {
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h12"
    });
    return "".concat(time.replace(" ", ""));
};
var $f8c373eb33718aa4$export$6f67f902847d308f = function(date) {
    if (date === null || (typeof date === "undefined" ? "undefined" : (0, $2xTNA._)(date)) !== "object") return "";
    var dayOfWeek = date.toLocaleString("default", {
        weekday: "long"
    });
    var dayOfMonth = date.getDate();
    var day = dayOfMonth + $f8c373eb33718aa4$export$6f6258299a22298a(dayOfMonth);
    var month = date.toLocaleString("default", {
        month: "long"
    });
    var time = date.toLocaleString("default", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
    return "".concat(dayOfWeek, " ").concat(day, " ").concat(month, " at ").concat(time.replace("00:", "12:").replace(" ", ""));
};
var $f8c373eb33718aa4$export$6f6258299a22298a = function(d) {
    if (d > 3 && d < 21) return "th";
    switch(d % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};



function $356625735729666e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  border-radius: 24px;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  position: relative;\n"
    ]);
    $356625735729666e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    $356625735729666e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    $356625735729666e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.8;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    $356625735729666e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  background: ",
        ";\n  border-radius: 16px;\n  gap: 16px;\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  margin: 16px 0;\n"
    ]);
    $356625735729666e$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 82px;\n  height: 120px;\n  background: ",
        ";\n  border-radius: 8px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 4px 0px rgba(0, 9, 40, 0.08);\n  @media screen and ",
        " {\n    height: unset;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 26px;\n  color: ",
        ";\n  text-transform: uppercase;\n  font-variant-numeric: lining-nums tabular-nums;\n"
    ]);
    $356625735729666e$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 36px;\n  color: ",
        ";\n  font-variant-numeric: lining-nums proportional-nums;\n"
    ]);
    $356625735729666e$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n"
    ]);
    $356625735729666e$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 28px;\n  color: ",
        ";\n  justify-self: center;\n  align-content: center;\n  margin: 16px;\n\n  @media screen and ",
        " {\n    display: none;\n    margin: 0;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media screen and ",
        " {\n    display: inline;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n\n  @media screen and ",
        " {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  @media screen and ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject14() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.5;\n  color: ",
        ";\n"
    ]);
    $356625735729666e$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $356625735729666e$var$_templateObject15() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.5;\n  color: ",
        ";\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n  @media screen and ",
        " {\n    display: inline;\n  }\n"
    ]);
    $356625735729666e$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
var $356625735729666e$var$CallbackCard = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background.primary;
});
var $356625735729666e$var$CallbackHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject1());
var $356625735729666e$var$CallbackTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h3($356625735729666e$var$_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $356625735729666e$var$CallbackDescription = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($356625735729666e$var$_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text.secondary;
});
var $356625735729666e$var$AppointmentDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background.secondary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$var$DetailsColumn = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject5());
var $356625735729666e$var$DateBox = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.background.primary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$var$DateMonth = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($356625735729666e$var$_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $356625735729666e$var$DateDay = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($356625735729666e$var$_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $356625735729666e$var$AppointmentDetailsDateContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject9());
var $356625735729666e$var$AppointmentTimeMobile = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($356625735729666e$var$_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$var$AppointmentTime = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($356625735729666e$var$AppointmentTimeMobile)($356625735729666e$var$_templateObject11(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$var$AppointmentDetailsGrid = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject12(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$var$DetailItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($356625735729666e$var$_templateObject13(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$var$DetailLabel = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($356625735729666e$var$_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $356625735729666e$var$DetailValue = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($356625735729666e$var$_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $356625735729666e$export$c888512da00abb40 = function(param) {
    var mortgageExpert = param.mortgageExpert, appointmentDate = param.appointmentDate, fetchedStatus = param.fetchedStatus;
    var formatPropertyAddress = function() {
        return (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.propertyAddress) || "N/A";
    };
    var formatOfferAmount = function() {
        // Handle null, undefined, and zero cases properly
        if (!(fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.offerAmount) && (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.offerAmount) !== 0) return "N/A";
        // Format numeric value as currency
        return "\xa3".concat(fetchedStatus.offerAmount.toLocaleString());
    };
    var getDateElements = function() {
        if (!appointmentDate) return {
            month: "",
            day: ""
        };
        var month = appointmentDate.toLocaleDateString("en-GB", {
            month: "short"
        });
        var day = appointmentDate.getDate().toString();
        return {
            month: month,
            day: day
        };
    };
    var getFormattedDateTime = function() {
        if (!appointmentDate) return "Appointment details pending";
        return (0, $f8c373eb33718aa4$export$6f67f902847d308f)(appointmentDate);
    };
    var _getDateElements = getDateElements(), month = _getDateElements.month, day = _getDateElements.day;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$CallbackCard, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$CallbackHeader, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$CallbackTitle, {
                        children: "Callback confirmed"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$CallbackDescription, {
                        children: [
                            "We've passed your availability on to ",
                            mortgageExpert.name,
                            ". In the meantime, they will review your information to prepare for your call and will be in touch shortly."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $59f3439255a74e88$export$d2a3c4d05e125f83), {
                mortgageExpert: mortgageExpert
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$AppointmentDetails, {
                children: [
                    appointmentDate && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$AppointmentDetailsDateContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$DateBox, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$DateDay, {
                                        children: day
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$DateMonth, {
                                        children: month
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$AppointmentTimeMobile, {
                                children: getFormattedDateTime()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$DetailsColumn, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$AppointmentTime, {
                                children: getFormattedDateTime()
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$AppointmentDetailsGrid, {
                                children: [
                                    (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.propertyAddress) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$DetailItem, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$DetailLabel, {
                                                children: "Property"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$DetailValue, {
                                                children: formatPropertyAddress()
                                            })
                                        ]
                                    }),
                                    (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.offerAmount) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($356625735729666e$var$DetailItem, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$DetailLabel, {
                                                children: "Offer amount"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($356625735729666e$var$DetailValue, {
                                                children: formatOfferAmount()
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




parcelRequire("hAGkE");





function $0ab4c512d90d668e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  border-radius: 24px;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  @media screen and ",
        " {\n    flex-direction: row;\n    gap: 32px;\n  }\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab4c512d90d668e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  border-radius: 8px;\n  padding: 8px 12px;\n  width: fit-content;\n  margin-bottom: 16px;\n\n  span {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 1.8;\n    color: ",
        ";\n    white-space: nowrap;\n  }\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab4c512d90d668e$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab4c512d90d668e$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-end;\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab4c512d90d668e$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 32px;\n  padding: 24px;\n  background: ",
        ";\n  @media screen and ",
        " {\n    width: 600px;\n  }\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab4c512d90d668e$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  li {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 1.8;\n    color: ",
        ";\n  }\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab4c512d90d668e$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  margin: 0 0 16px 0;\n"
    ]);
    $0ab4c512d90d668e$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $0ab4c512d90d668e$var$SpeedUpCard = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0ab4c512d90d668e$var$_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background.primary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $0ab4c512d90d668e$var$NextStepBadge = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0ab4c512d90d668e$var$_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.status.warning;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $0ab4c512d90d668e$var$DocumentsDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0ab4c512d90d668e$var$_templateObject2());
var $0ab4c512d90d668e$var$DocumentsDetailsButtonWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0ab4c512d90d668e$var$_templateObject3());
var $0ab4c512d90d668e$var$CallDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0ab4c512d90d668e$var$_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background.tertiary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $0ab4c512d90d668e$var$BenefitsList = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($0ab4c512d90d668e$var$_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.text.secondary;
});
var $0ab4c512d90d668e$var$StyledLargeBody = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).LargeBody)($0ab4c512d90d668e$var$_templateObject6());
var $0ab4c512d90d668e$export$659384a22c0d96b6 = function(param) {
    var friendlyId = param.friendlyId;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var handleViewDocuments = function() {
        history.push("/application/".concat(friendlyId, "/documents"));
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0ab4c512d90d668e$var$SpeedUpCard, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0ab4c512d90d668e$var$DocumentsDetails, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0ab4c512d90d668e$var$NextStepBadge, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Next step"
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                        margin: "8px 0",
                        children: "Speed up your application"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                        color: "secondary",
                        margin: "0",
                        children: "Your expert may have asked for some documents. You can view the list and upload them securely here before your call to get things moving quicker."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0ab4c512d90d668e$var$DocumentsDetailsButtonWrapper, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                            text: "View & upload documents",
                            onClick: handleViewDocuments
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0ab4c512d90d668e$var$CallDetails, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0ab4c512d90d668e$var$StyledLargeBody, {
                        children: "What you'll get from this call"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0ab4c512d90d668e$var$BenefitsList, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                children: "Choose the best mortgage product for you"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                children: "Begin your application with your expert"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                children: "Get one step closer to getting the keys"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $71365288cfed287b$export$e4ce450c319a3f7a = function(param) {
    var fetchedStatus = param.fetchedStatus, friendlyId = param.friendlyId, appointmentDate = param.appointmentDate;
    var mortgageExpert = {
        name: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.opportunityOwnerTextForEmail) || "Mojo Mortgages",
        title: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.flexRoles2) || "Mortgage Expert",
        email: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress) || "",
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($175870872636a4b6$exports)))
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$15529022dcaf3eec), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$b600c6a5fff6759c), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0f2ec52df0fc99e9$export$38ea4201dc9a7b0b), {})
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $356625735729666e$export$c888512da00abb40), {
                mortgageExpert: mortgageExpert,
                appointmentDate: appointmentDate,
                fetchedStatus: fetchedStatus
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0ab4c512d90d668e$export$659384a22c0d96b6), {
                friendlyId: friendlyId
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $40881c25d3dc0071$export$8a498ed11591c94b), {
                friendlyId: friendlyId
            })
        ]
    });
};




parcelRequire("hAGkE");








parcelRequire("hAGkE");






var $ff419e2b02580b2c$exports = {};
$ff419e2b02580b2c$exports = $parcel$resolve("8ttXG");


function $3df5b69bd533317e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: linear-gradient(135deg, #f8faff 0%, #e8f1ff 100%);\n  border-radius: 16px;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $3df5b69bd533317e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3df5b69bd533317e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    $3df5b69bd533317e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3df5b69bd533317e$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  flex-shrink: 0;\n  align-self: center;\n\n  @media screen and ",
        " {\n    align-self: auto;\n  }\n"
    ]);
    $3df5b69bd533317e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3df5b69bd533317e$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    $3df5b69bd533317e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $3df5b69bd533317e$var$RateCheckContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3df5b69bd533317e$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3df5b69bd533317e$var$RateCheckContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3df5b69bd533317e$var$_templateObject1());
var $3df5b69bd533317e$var$RateCheckIllustration = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3df5b69bd533317e$var$_templateObject2(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3df5b69bd533317e$var$PhoneImage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($3df5b69bd533317e$var$_templateObject3());
var $3df5b69bd533317e$var$CardStyleOverrides = {
    borderRadius: "24px"
};
var $3df5b69bd533317e$export$529610e36488c39e = function(param) {
    var friendlyId = param.friendlyId;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
        theme: "default",
        style: $3df5b69bd533317e$var$CardStyleOverrides,
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3df5b69bd533317e$var$RateCheckContainer, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3df5b69bd533317e$var$RateCheckIllustration, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3df5b69bd533317e$var$PhoneImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff419e2b02580b2c$exports))),
                        alt: "Phone showing rate check notification"
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3df5b69bd533317e$var$RateCheckContent, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                            margin: "0 0 8px 0",
                            children: "Our Rate Check Promise"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                            color: "secondary",
                            margin: "0 0 16px 0",
                            children: "After your offer is accepted, we continue to check for a better rate on your deal. If one becomes available before you complete, we'll help you switch."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                            text: "Learn more",
                            onClick: function() {
                                history.push("/application/".concat(friendlyId, "/rate-check-promise"));
                            }
                        })
                    ]
                })
            ]
        })
    });
};




parcelRequire("hAGkE");




function $23d370b922ebfb16$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 5px;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $23d370b922ebfb16$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $23d370b922ebfb16$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $23d370b922ebfb16$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: ",
        ";\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $23d370b922ebfb16$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $23d370b922ebfb16$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ",
        ";\n  margin: 0 0 4px 0;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $23d370b922ebfb16$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.6;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    $23d370b922ebfb16$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $23d370b922ebfb16$var$SectionContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($23d370b922ebfb16$var$_templateObject());
var $23d370b922ebfb16$var$StepsContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($23d370b922ebfb16$var$_templateObject1());
var $23d370b922ebfb16$var$StepItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($23d370b922ebfb16$var$_templateObject2());
var $23d370b922ebfb16$var$StepNumber = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($23d370b922ebfb16$var$_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.brand.primary;
});
var $23d370b922ebfb16$var$StepContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($23d370b922ebfb16$var$_templateObject4());
var $23d370b922ebfb16$var$StepTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h5($23d370b922ebfb16$var$_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $23d370b922ebfb16$var$StepDescription = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($23d370b922ebfb16$var$_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text.secondary;
});
var $23d370b922ebfb16$var$CardStyleOverrides = {
    borderRadius: "24px"
};
var $23d370b922ebfb16$var$steps = [
    {
        title: "Recommendation call",
        description: "Your expert will present the best mortgage deals for you."
    },
    {
        title: "Application",
        description: "We'll help you submit your application to the chosen lender."
    },
    {
        title: "Lender process",
        description: "The lender will conduct their checks and property valuation."
    },
    {
        title: "Completion",
        description: "Once approved, we'll guide you to completion and moving day."
    }
];
var $23d370b922ebfb16$export$8a97f20c8952d7e0 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
        theme: "default",
        style: $23d370b922ebfb16$var$CardStyleOverrides,
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($23d370b922ebfb16$var$SectionContent, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$1b51c6466e79404f), {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                        margin: "0 0 16px 0",
                        children: "What to expect next"
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($23d370b922ebfb16$var$StepsContainer, {
                    children: $23d370b922ebfb16$var$steps.map(function(param, index) {
                        var title = param.title, description = param.description;
                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($23d370b922ebfb16$var$StepItem, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($23d370b922ebfb16$var$StepNumber, {
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($23d370b922ebfb16$var$StepContent, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($23d370b922ebfb16$var$StepTitle, {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($23d370b922ebfb16$var$StepDescription, {
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        }, title);
                    })
                })
            ]
        })
    });
};



function $d04829dc2ebccc64$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    $d04829dc2ebccc64$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d04829dc2ebccc64$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 5px;\n"
    ]);
    $d04829dc2ebccc64$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d04829dc2ebccc64$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    $d04829dc2ebccc64$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $d04829dc2ebccc64$var$HeaderSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d04829dc2ebccc64$var$_templateObject());
var $d04829dc2ebccc64$var$SectionContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d04829dc2ebccc64$var$_templateObject1());
var $d04829dc2ebccc64$var$TextContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d04829dc2ebccc64$var$_templateObject2());
var $d04829dc2ebccc64$var$CardStyleOverrides = {
    borderRadius: "24px"
};
var $d04829dc2ebccc64$export$fbeece5ce4e1b82c = function(param) {
    var fetchedStatus = param.fetchedStatus, friendlyId = param.friendlyId;
    // Create mortgageExpert object from API data with fallbacks
    var mortgageExpert = {
        name: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.opportunityOwnerTextForEmail) || "Mojo Mortgages",
        title: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.flexRoles2) || "Mortgage Expert",
        email: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress) || "",
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($175870872636a4b6$exports)))
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$15529022dcaf3eec), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d04829dc2ebccc64$var$HeaderSection, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H1, {
                        margin: "0 0 16px 0",
                        children: "Let's get you ready for your mortgage recommendation."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).LargeBody, {
                        color: "secondary",
                        margin: "0",
                        children: "Your expert is preparing tailored options for you."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                theme: "default",
                style: $d04829dc2ebccc64$var$CardStyleOverrides,
                content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d04829dc2ebccc64$var$SectionContent, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d04829dc2ebccc64$var$TextContent, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                    margin: "0 0 8px 0",
                                    children: "Your Mortgage Expert"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                    color: "secondary",
                                    margin: "0 0 16px 0",
                                    children: "Your dedicated expert is working on your mortgage recommendation. They'll be in touch soon with your personalized options."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $59f3439255a74e88$export$d2a3c4d05e125f83), {
                            mortgageExpert: mortgageExpert
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $23d370b922ebfb16$export$8a97f20c8952d7e0), {}),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $40881c25d3dc0071$export$8a498ed11591c94b), {
                friendlyId: friendlyId
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3df5b69bd533317e$export$529610e36488c39e), {
                friendlyId: friendlyId
            })
        ]
    });
};




parcelRequire("hAGkE");


/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var $72947875341bbd79$export$82e9f45cca5ba907 = "fas";
var $72947875341bbd79$export$7af266c3465b1ff2 = {
    prefix: 'fas',
    iconName: 'ad',
    icon: [
        512,
        512,
        [],
        "f641",
        "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
    ]
};
var $72947875341bbd79$export$853fd1561789e3bb = {
    prefix: 'fas',
    iconName: 'address-book',
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $72947875341bbd79$export$6ea408c7266ed557 = {
    prefix: 'fas',
    iconName: 'address-card',
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $72947875341bbd79$export$cfa06e4b68edca2d = {
    prefix: 'fas',
    iconName: 'adjust',
    icon: [
        512,
        512,
        [],
        "f042",
        "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
    ]
};
var $72947875341bbd79$export$a5e63e89b5ccee83 = {
    prefix: 'fas',
    iconName: 'air-freshener',
    icon: [
        512,
        512,
        [],
        "f5d0",
        "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
    ]
};
var $72947875341bbd79$export$70e29dd05344623e = {
    prefix: 'fas',
    iconName: 'align-center',
    icon: [
        448,
        512,
        [],
        "f037",
        "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
    ]
};
var $72947875341bbd79$export$97c42b56d462df72 = {
    prefix: 'fas',
    iconName: 'align-justify',
    icon: [
        448,
        512,
        [],
        "f039",
        "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$e490f662af4d1c78 = {
    prefix: 'fas',
    iconName: 'align-left',
    icon: [
        448,
        512,
        [],
        "f036",
        "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$7370f36a39a38737 = {
    prefix: 'fas',
    iconName: 'align-right',
    icon: [
        448,
        512,
        [],
        "f038",
        "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
    ]
};
var $72947875341bbd79$export$dcae2101babbffff = {
    prefix: 'fas',
    iconName: 'allergies',
    icon: [
        448,
        512,
        [],
        "f461",
        "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $72947875341bbd79$export$f5c7042778b51765 = {
    prefix: 'fas',
    iconName: 'ambulance',
    icon: [
        640,
        512,
        [],
        "f0f9",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $72947875341bbd79$export$23a7517099ab1b86 = {
    prefix: 'fas',
    iconName: 'american-sign-language-interpreting',
    icon: [
        640,
        512,
        [],
        "f2a3",
        "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
    ]
};
var $72947875341bbd79$export$12a35719f889cd1 = {
    prefix: 'fas',
    iconName: 'anchor',
    icon: [
        576,
        512,
        [],
        "f13d",
        "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
    ]
};
var $72947875341bbd79$export$fd504117f273ca92 = {
    prefix: 'fas',
    iconName: 'angle-double-down',
    icon: [
        320,
        512,
        [],
        "f103",
        "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
    ]
};
var $72947875341bbd79$export$21b0833b3cf929a7 = {
    prefix: 'fas',
    iconName: 'angle-double-left',
    icon: [
        448,
        512,
        [],
        "f100",
        "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
    ]
};
var $72947875341bbd79$export$792931403404faf0 = {
    prefix: 'fas',
    iconName: 'angle-double-right',
    icon: [
        448,
        512,
        [],
        "f101",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
    ]
};
var $72947875341bbd79$export$9bb51e1a2c07db7c = {
    prefix: 'fas',
    iconName: 'angle-double-up',
    icon: [
        320,
        512,
        [],
        "f102",
        "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
    ]
};
var $72947875341bbd79$export$4b5be0142d10f342 = {
    prefix: 'fas',
    iconName: 'angle-down',
    icon: [
        320,
        512,
        [],
        "f107",
        "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    ]
};
var $72947875341bbd79$export$3cbcd1b7e35945d2 = {
    prefix: 'fas',
    iconName: 'angle-left',
    icon: [
        256,
        512,
        [],
        "f104",
        "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
    ]
};
var $72947875341bbd79$export$6bce1afb61f2eb66 = {
    prefix: 'fas',
    iconName: 'angle-right',
    icon: [
        256,
        512,
        [],
        "f105",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    ]
};
var $72947875341bbd79$export$887340269e6d6cac = {
    prefix: 'fas',
    iconName: 'angle-up',
    icon: [
        320,
        512,
        [],
        "f106",
        "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    ]
};
var $72947875341bbd79$export$3c96c08e234498c5 = {
    prefix: 'fas',
    iconName: 'angry',
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
    ]
};
var $72947875341bbd79$export$8736909014b15ca9 = {
    prefix: 'fas',
    iconName: 'ankh',
    icon: [
        320,
        512,
        [],
        "f644",
        "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
    ]
};
var $72947875341bbd79$export$bcdd94f3977a0884 = {
    prefix: 'fas',
    iconName: 'apple-alt',
    icon: [
        448,
        512,
        [],
        "f5d1",
        "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
    ]
};
var $72947875341bbd79$export$26b3e1c454273f34 = {
    prefix: 'fas',
    iconName: 'archive',
    icon: [
        512,
        512,
        [],
        "f187",
        "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
    ]
};
var $72947875341bbd79$export$d56753dd2eb5c323 = {
    prefix: 'fas',
    iconName: 'archway',
    icon: [
        576,
        512,
        [],
        "f557",
        "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$ff3afbc8c0bc5d59 = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-down',
    icon: [
        512,
        512,
        [],
        "f358",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
    ]
};
var $72947875341bbd79$export$5460a5b11a24996f = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-left',
    icon: [
        512,
        512,
        [],
        "f359",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
    ]
};
var $72947875341bbd79$export$88962ffdad8b856d = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-right',
    icon: [
        512,
        512,
        [],
        "f35a",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
    ]
};
var $72947875341bbd79$export$3747a8ef0995eadf = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-up',
    icon: [
        512,
        512,
        [],
        "f35b",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
    ]
};
var $72947875341bbd79$export$6cfa36bbb3a057 = {
    prefix: 'fas',
    iconName: 'arrow-circle-down',
    icon: [
        512,
        512,
        [],
        "f0ab",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
    ]
};
var $72947875341bbd79$export$728262abb9f58d0a = {
    prefix: 'fas',
    iconName: 'arrow-circle-left',
    icon: [
        512,
        512,
        [],
        "f0a8",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
    ]
};
var $72947875341bbd79$export$7d3d828103aa3be7 = {
    prefix: 'fas',
    iconName: 'arrow-circle-right',
    icon: [
        512,
        512,
        [],
        "f0a9",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
    ]
};
var $72947875341bbd79$export$a2f6f3baa50af0b1 = {
    prefix: 'fas',
    iconName: 'arrow-circle-up',
    icon: [
        512,
        512,
        [],
        "f0aa",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
    ]
};
var $72947875341bbd79$export$9686eff8d817f770 = {
    prefix: 'fas',
    iconName: 'arrow-down',
    icon: [
        448,
        512,
        [],
        "f063",
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    ]
};
var $72947875341bbd79$export$b7fac681e7d09400 = {
    prefix: 'fas',
    iconName: 'arrow-left',
    icon: [
        448,
        512,
        [],
        "f060",
        "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ]
};
var $72947875341bbd79$export$b4da69a0247f3620 = {
    prefix: 'fas',
    iconName: 'arrow-right',
    icon: [
        448,
        512,
        [],
        "f061",
        "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    ]
};
var $72947875341bbd79$export$8e144ed4d52eef49 = {
    prefix: 'fas',
    iconName: 'arrow-up',
    icon: [
        448,
        512,
        [],
        "f062",
        "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    ]
};
var $72947875341bbd79$export$3cdabfff52cfc73a = {
    prefix: 'fas',
    iconName: 'arrows-alt',
    icon: [
        512,
        512,
        [],
        "f0b2",
        "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
    ]
};
var $72947875341bbd79$export$7937ea574fb1389 = {
    prefix: 'fas',
    iconName: 'arrows-alt-h',
    icon: [
        512,
        512,
        [],
        "f337",
        "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
    ]
};
var $72947875341bbd79$export$138cb56a3f8f7040 = {
    prefix: 'fas',
    iconName: 'arrows-alt-v',
    icon: [
        256,
        512,
        [],
        "f338",
        "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
    ]
};
var $72947875341bbd79$export$8eeef3dc0035b165 = {
    prefix: 'fas',
    iconName: 'assistive-listening-systems',
    icon: [
        512,
        512,
        [],
        "f2a2",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
    ]
};
var $72947875341bbd79$export$19eff32c0fd4f99f = {
    prefix: 'fas',
    iconName: 'asterisk',
    icon: [
        512,
        512,
        [],
        "f069",
        "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
    ]
};
var $72947875341bbd79$export$c115e8063ee02632 = {
    prefix: 'fas',
    iconName: 'at',
    icon: [
        512,
        512,
        [],
        "f1fa",
        "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
    ]
};
var $72947875341bbd79$export$380a9050e42fe5d7 = {
    prefix: 'fas',
    iconName: 'atlas',
    icon: [
        448,
        512,
        [],
        "f558",
        "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
    ]
};
var $72947875341bbd79$export$b5bb295e8ad4ab31 = {
    prefix: 'fas',
    iconName: 'atom',
    icon: [
        448,
        512,
        [],
        "f5d2",
        "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
    ]
};
var $72947875341bbd79$export$b6b464c98c009494 = {
    prefix: 'fas',
    iconName: 'audio-description',
    icon: [
        512,
        512,
        [],
        "f29e",
        "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
    ]
};
var $72947875341bbd79$export$f8db2747dadd48f7 = {
    prefix: 'fas',
    iconName: 'award',
    icon: [
        384,
        512,
        [],
        "f559",
        "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
    ]
};
var $72947875341bbd79$export$8afab767536f59ad = {
    prefix: 'fas',
    iconName: 'baby',
    icon: [
        384,
        512,
        [],
        "f77c",
        "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
    ]
};
var $72947875341bbd79$export$3b3ab4d86bad7d26 = {
    prefix: 'fas',
    iconName: 'baby-carriage',
    icon: [
        512,
        512,
        [],
        "f77d",
        "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
    ]
};
var $72947875341bbd79$export$e43e3f67102fc526 = {
    prefix: 'fas',
    iconName: 'backspace',
    icon: [
        640,
        512,
        [],
        "f55a",
        "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
    ]
};
var $72947875341bbd79$export$ae65f96ea7a4078d = {
    prefix: 'fas',
    iconName: 'backward',
    icon: [
        512,
        512,
        [],
        "f04a",
        "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
    ]
};
var $72947875341bbd79$export$ab07061fe21a3a8e = {
    prefix: 'fas',
    iconName: 'bacon',
    icon: [
        576,
        512,
        [],
        "f7e5",
        "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
    ]
};
var $72947875341bbd79$export$7fc18cf2d526c341 = {
    prefix: 'fas',
    iconName: 'bacteria',
    icon: [
        640,
        512,
        [],
        "e059",
        "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
    ]
};
var $72947875341bbd79$export$b0babe4230e35ebe = {
    prefix: 'fas',
    iconName: 'bacterium',
    icon: [
        512,
        512,
        [],
        "e05a",
        "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
    ]
};
var $72947875341bbd79$export$6d636565b3ec36b4 = {
    prefix: 'fas',
    iconName: 'bahai',
    icon: [
        512,
        512,
        [],
        "f666",
        "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
    ]
};
var $72947875341bbd79$export$fec323dcfd81d750 = {
    prefix: 'fas',
    iconName: 'balance-scale',
    icon: [
        640,
        512,
        [],
        "f24e",
        "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$786cb0c775487f19 = {
    prefix: 'fas',
    iconName: 'balance-scale-left',
    icon: [
        640,
        512,
        [],
        "f515",
        "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
    ]
};
var $72947875341bbd79$export$2238e05f8920005a = {
    prefix: 'fas',
    iconName: 'balance-scale-right',
    icon: [
        640,
        512,
        [],
        "f516",
        "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
    ]
};
var $72947875341bbd79$export$76f704d256def3c7 = {
    prefix: 'fas',
    iconName: 'ban',
    icon: [
        512,
        512,
        [],
        "f05e",
        "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
    ]
};
var $72947875341bbd79$export$b14a1014df2fdf46 = {
    prefix: 'fas',
    iconName: 'band-aid',
    icon: [
        640,
        512,
        [],
        "f462",
        "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var $72947875341bbd79$export$3825a842b5afc5aa = {
    prefix: 'fas',
    iconName: 'barcode',
    icon: [
        512,
        512,
        [],
        "f02a",
        "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
    ]
};
var $72947875341bbd79$export$36e9cf7887265da2 = {
    prefix: 'fas',
    iconName: 'bars',
    icon: [
        448,
        512,
        [],
        "f0c9",
        "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ]
};
var $72947875341bbd79$export$63a3f8ceae07c7f3 = {
    prefix: 'fas',
    iconName: 'baseball-ball',
    icon: [
        496,
        512,
        [],
        "f433",
        "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
    ]
};
var $72947875341bbd79$export$36550ab8ffcc5b28 = {
    prefix: 'fas',
    iconName: 'basketball-ball',
    icon: [
        496,
        512,
        [],
        "f434",
        "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
    ]
};
var $72947875341bbd79$export$1ea66a88b8f620c9 = {
    prefix: 'fas',
    iconName: 'bath',
    icon: [
        512,
        512,
        [],
        "f2cd",
        "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
    ]
};
var $72947875341bbd79$export$1344b64f6e922e12 = {
    prefix: 'fas',
    iconName: 'battery-empty',
    icon: [
        640,
        512,
        [],
        "f244",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
    ]
};
var $72947875341bbd79$export$9338fc4614cfc0cf = {
    prefix: 'fas',
    iconName: 'battery-full',
    icon: [
        640,
        512,
        [],
        "f240",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
    ]
};
var $72947875341bbd79$export$e6dadc1155c4ee48 = {
    prefix: 'fas',
    iconName: 'battery-half',
    icon: [
        640,
        512,
        [],
        "f242",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
    ]
};
var $72947875341bbd79$export$acec92052ac2183 = {
    prefix: 'fas',
    iconName: 'battery-quarter',
    icon: [
        640,
        512,
        [],
        "f243",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
    ]
};
var $72947875341bbd79$export$cfb37069d38f379e = {
    prefix: 'fas',
    iconName: 'battery-three-quarters',
    icon: [
        640,
        512,
        [],
        "f241",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
    ]
};
var $72947875341bbd79$export$f24e0fce77994d4d = {
    prefix: 'fas',
    iconName: 'bed',
    icon: [
        640,
        512,
        [],
        "f236",
        "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
    ]
};
var $72947875341bbd79$export$f74725691538983b = {
    prefix: 'fas',
    iconName: 'beer',
    icon: [
        448,
        512,
        [],
        "f0fc",
        "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
    ]
};
var $72947875341bbd79$export$9b6162797ab1b255 = {
    prefix: 'fas',
    iconName: 'bell',
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    ]
};
var $72947875341bbd79$export$6b31a1e5968b2378 = {
    prefix: 'fas',
    iconName: 'bell-slash',
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var $72947875341bbd79$export$a527a6267c55a54c = {
    prefix: 'fas',
    iconName: 'bezier-curve',
    icon: [
        640,
        512,
        [],
        "f55b",
        "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$2eac809b0670d139 = {
    prefix: 'fas',
    iconName: 'bible',
    icon: [
        448,
        512,
        [],
        "f647",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $72947875341bbd79$export$36cb1885ad7a570f = {
    prefix: 'fas',
    iconName: 'bicycle',
    icon: [
        640,
        512,
        [],
        "f206",
        "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
    ]
};
var $72947875341bbd79$export$a5bcf835dbf9c0b = {
    prefix: 'fas',
    iconName: 'biking',
    icon: [
        640,
        512,
        [],
        "f84a",
        "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
    ]
};
var $72947875341bbd79$export$8a910017964bb8c2 = {
    prefix: 'fas',
    iconName: 'binoculars',
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
    ]
};
var $72947875341bbd79$export$ae3a453550dec95 = {
    prefix: 'fas',
    iconName: 'biohazard',
    icon: [
        576,
        512,
        [],
        "f780",
        "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $72947875341bbd79$export$bdcf98f725a7241a = {
    prefix: 'fas',
    iconName: 'birthday-cake',
    icon: [
        448,
        512,
        [],
        "f1fd",
        "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
    ]
};
var $72947875341bbd79$export$db34f7a6de38784f = {
    prefix: 'fas',
    iconName: 'blender',
    icon: [
        512,
        512,
        [],
        "f517",
        "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
    ]
};
var $72947875341bbd79$export$f35a116a762ef8fc = {
    prefix: 'fas',
    iconName: 'blender-phone',
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$923de21def6ea9b6 = {
    prefix: 'fas',
    iconName: 'blind',
    icon: [
        384,
        512,
        [],
        "f29d",
        "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
    ]
};
var $72947875341bbd79$export$890d5e011054935a = {
    prefix: 'fas',
    iconName: 'blog',
    icon: [
        512,
        512,
        [],
        "f781",
        "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
    ]
};
var $72947875341bbd79$export$7e0c7fd2a2e88823 = {
    prefix: 'fas',
    iconName: 'bold',
    icon: [
        384,
        512,
        [],
        "f032",
        "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
    ]
};
var $72947875341bbd79$export$6869964aa308dd31 = {
    prefix: 'fas',
    iconName: 'bolt',
    icon: [
        320,
        512,
        [],
        "f0e7",
        "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    ]
};
var $72947875341bbd79$export$d59078f6e80b4a67 = {
    prefix: 'fas',
    iconName: 'bomb',
    icon: [
        512,
        512,
        [],
        "f1e2",
        "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $72947875341bbd79$export$5902c007d5703f2d = {
    prefix: 'fas',
    iconName: 'bone',
    icon: [
        640,
        512,
        [],
        "f5d7",
        "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
    ]
};
var $72947875341bbd79$export$e74974fac77c468e = {
    prefix: 'fas',
    iconName: 'bong',
    icon: [
        448,
        512,
        [],
        "f55c",
        "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
    ]
};
var $72947875341bbd79$export$c9d7ef726d1a8742 = {
    prefix: 'fas',
    iconName: 'book',
    icon: [
        448,
        512,
        [],
        "f02d",
        "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    ]
};
var $72947875341bbd79$export$b98a3f8c3941a74a = {
    prefix: 'fas',
    iconName: 'book-dead',
    icon: [
        448,
        512,
        [],
        "f6b7",
        "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
    ]
};
var $72947875341bbd79$export$6feb44fec53ba30d = {
    prefix: 'fas',
    iconName: 'book-medical',
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
    ]
};
var $72947875341bbd79$export$8a3071811b2b7979 = {
    prefix: 'fas',
    iconName: 'book-open',
    icon: [
        576,
        512,
        [],
        "f518",
        "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
    ]
};
var $72947875341bbd79$export$cee14fe33262fa7d = {
    prefix: 'fas',
    iconName: 'book-reader',
    icon: [
        512,
        512,
        [],
        "f5da",
        "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
    ]
};
var $72947875341bbd79$export$4ed9da5c3cca0ef1 = {
    prefix: 'fas',
    iconName: 'bookmark',
    icon: [
        384,
        512,
        [],
        "f02e",
        "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
    ]
};
var $72947875341bbd79$export$93a5eb721c9c0d25 = {
    prefix: 'fas',
    iconName: 'border-all',
    icon: [
        448,
        512,
        [],
        "f84c",
        "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
    ]
};
var $72947875341bbd79$export$2b488402ec335d97 = {
    prefix: 'fas',
    iconName: 'border-none',
    icon: [
        448,
        512,
        [],
        "f850",
        "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$c2867ca78120d644 = {
    prefix: 'fas',
    iconName: 'border-style',
    icon: [
        448,
        512,
        [],
        "f853",
        "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$5ee2640fe105312d = {
    prefix: 'fas',
    iconName: 'bowling-ball',
    icon: [
        496,
        512,
        [],
        "f436",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$6e7cf270cda52323 = {
    prefix: 'fas',
    iconName: 'box',
    icon: [
        512,
        512,
        [],
        "f466",
        "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
    ]
};
var $72947875341bbd79$export$9010ed816a8b9c97 = {
    prefix: 'fas',
    iconName: 'box-open',
    icon: [
        640,
        512,
        [],
        "f49e",
        "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
    ]
};
var $72947875341bbd79$export$f2adc06617bc0c7 = {
    prefix: 'fas',
    iconName: 'box-tissue',
    icon: [
        512,
        512,
        [],
        "e05b",
        "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
    ]
};
var $72947875341bbd79$export$2007320dd6cde6db = {
    prefix: 'fas',
    iconName: 'boxes',
    icon: [
        576,
        512,
        [],
        "f468",
        "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$983e9c27cac7ed1c = {
    prefix: 'fas',
    iconName: 'braille',
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $72947875341bbd79$export$97fa4f4c1006ab1 = {
    prefix: 'fas',
    iconName: 'brain',
    icon: [
        576,
        512,
        [],
        "f5dc",
        "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
    ]
};
var $72947875341bbd79$export$d78e8b0681279167 = {
    prefix: 'fas',
    iconName: 'bread-slice',
    icon: [
        576,
        512,
        [],
        "f7ec",
        "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
    ]
};
var $72947875341bbd79$export$8da450d063b0eb37 = {
    prefix: 'fas',
    iconName: 'briefcase',
    icon: [
        512,
        512,
        [],
        "f0b1",
        "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    ]
};
var $72947875341bbd79$export$5000f52ca9819bf5 = {
    prefix: 'fas',
    iconName: 'briefcase-medical',
    icon: [
        512,
        512,
        [],
        "f469",
        "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
    ]
};
var $72947875341bbd79$export$f68b38d51f5c0ed = {
    prefix: 'fas',
    iconName: 'broadcast-tower',
    icon: [
        640,
        512,
        [],
        "f519",
        "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
    ]
};
var $72947875341bbd79$export$2a533051418ff4ca = {
    prefix: 'fas',
    iconName: 'broom',
    icon: [
        640,
        512,
        [],
        "f51a",
        "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
    ]
};
var $72947875341bbd79$export$5824ffe6f8983c83 = {
    prefix: 'fas',
    iconName: 'brush',
    icon: [
        384,
        512,
        [],
        "f55d",
        "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
    ]
};
var $72947875341bbd79$export$a18cfac400116d9f = {
    prefix: 'fas',
    iconName: 'bug',
    icon: [
        512,
        512,
        [],
        "f188",
        "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
    ]
};
var $72947875341bbd79$export$f26673f8b10c3d46 = {
    prefix: 'fas',
    iconName: 'building',
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
    ]
};
var $72947875341bbd79$export$dacae2b4ec565333 = {
    prefix: 'fas',
    iconName: 'bullhorn',
    icon: [
        576,
        512,
        [],
        "f0a1",
        "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
    ]
};
var $72947875341bbd79$export$554720e3bf74fe90 = {
    prefix: 'fas',
    iconName: 'bullseye',
    icon: [
        496,
        512,
        [],
        "f140",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ]
};
var $72947875341bbd79$export$80ed4535efc60402 = {
    prefix: 'fas',
    iconName: 'burn',
    icon: [
        384,
        512,
        [],
        "f46a",
        "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
    ]
};
var $72947875341bbd79$export$ce69441578ff2fdb = {
    prefix: 'fas',
    iconName: 'bus',
    icon: [
        512,
        512,
        [],
        "f207",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$40616edfab6d332a = {
    prefix: 'fas',
    iconName: 'bus-alt',
    icon: [
        512,
        512,
        [],
        "f55e",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$694b7e88782dec12 = {
    prefix: 'fas',
    iconName: 'business-time',
    icon: [
        640,
        512,
        [],
        "f64a",
        "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
    ]
};
var $72947875341bbd79$export$693bd40950ed2c3a = {
    prefix: 'fas',
    iconName: 'calculator',
    icon: [
        448,
        512,
        [],
        "f1ec",
        "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
    ]
};
var $72947875341bbd79$export$34f5c36a3e80efa2 = {
    prefix: 'fas',
    iconName: 'calendar',
    icon: [
        448,
        512,
        [],
        "f133",
        "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
    ]
};
var $72947875341bbd79$export$cbc139f33cff356 = {
    prefix: 'fas',
    iconName: 'calendar-alt',
    icon: [
        448,
        512,
        [],
        "f073",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$5655108e1162ba45 = {
    prefix: 'fas',
    iconName: 'calendar-check',
    icon: [
        448,
        512,
        [],
        "f274",
        "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
    ]
};
var $72947875341bbd79$export$80968bcfef6481ca = {
    prefix: 'fas',
    iconName: 'calendar-day',
    icon: [
        448,
        512,
        [],
        "f783",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$23e8b4955c2d951b = {
    prefix: 'fas',
    iconName: 'calendar-minus',
    icon: [
        448,
        512,
        [],
        "f272",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
    ]
};
var $72947875341bbd79$export$16768a660ae3ca9d = {
    prefix: 'fas',
    iconName: 'calendar-plus',
    icon: [
        448,
        512,
        [],
        "f271",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
    ]
};
var $72947875341bbd79$export$99b20d7352fbcf08 = {
    prefix: 'fas',
    iconName: 'calendar-times',
    icon: [
        448,
        512,
        [],
        "f273",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
    ]
};
var $72947875341bbd79$export$39be5cb4aed5a521 = {
    prefix: 'fas',
    iconName: 'calendar-week',
    icon: [
        448,
        512,
        [],
        "f784",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$84ffbd7161ca2008 = {
    prefix: 'fas',
    iconName: 'camera',
    icon: [
        512,
        512,
        [],
        "f030",
        "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
    ]
};
var $72947875341bbd79$export$41dbdadc07a89b05 = {
    prefix: 'fas',
    iconName: 'camera-retro',
    icon: [
        512,
        512,
        [],
        "f083",
        "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
    ]
};
var $72947875341bbd79$export$295287303c0e9c7c = {
    prefix: 'fas',
    iconName: 'campground',
    icon: [
        640,
        512,
        [],
        "f6bb",
        "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
    ]
};
var $72947875341bbd79$export$14d66ba7571ae0b9 = {
    prefix: 'fas',
    iconName: 'candy-cane',
    icon: [
        512,
        512,
        [],
        "f786",
        "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
    ]
};
var $72947875341bbd79$export$8ec2f752344b69bd = {
    prefix: 'fas',
    iconName: 'cannabis',
    icon: [
        512,
        512,
        [],
        "f55f",
        "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
    ]
};
var $72947875341bbd79$export$ba6fd4a436804a48 = {
    prefix: 'fas',
    iconName: 'capsules',
    icon: [
        576,
        512,
        [],
        "f46b",
        "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
    ]
};
var $72947875341bbd79$export$9eefe7fcdf123b76 = {
    prefix: 'fas',
    iconName: 'car',
    icon: [
        512,
        512,
        [],
        "f1b9",
        "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $72947875341bbd79$export$7937ed2462a665c0 = {
    prefix: 'fas',
    iconName: 'car-alt',
    icon: [
        480,
        512,
        [],
        "f5de",
        "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $72947875341bbd79$export$a44d0c11093d9c1e = {
    prefix: 'fas',
    iconName: 'car-battery',
    icon: [
        512,
        512,
        [],
        "f5df",
        "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
    ]
};
var $72947875341bbd79$export$8ff55566398404cd = {
    prefix: 'fas',
    iconName: 'car-crash',
    icon: [
        640,
        512,
        [],
        "f5e1",
        "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
    ]
};
var $72947875341bbd79$export$6f7218565b1b8d0e = {
    prefix: 'fas',
    iconName: 'car-side',
    icon: [
        640,
        512,
        [],
        "f5e4",
        "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $72947875341bbd79$export$afb5d0eee7c1bdb = {
    prefix: 'fas',
    iconName: 'caravan',
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
    ]
};
var $72947875341bbd79$export$f9395ef707603e40 = {
    prefix: 'fas',
    iconName: 'caret-down',
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    ]
};
var $72947875341bbd79$export$85a918a11b7643c2 = {
    prefix: 'fas',
    iconName: 'caret-left',
    icon: [
        192,
        512,
        [],
        "f0d9",
        "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
    ]
};
var $72947875341bbd79$export$f1011352b01c1c0 = {
    prefix: 'fas',
    iconName: 'caret-right',
    icon: [
        192,
        512,
        [],
        "f0da",
        "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    ]
};
var $72947875341bbd79$export$61aea18df1c84401 = {
    prefix: 'fas',
    iconName: 'caret-square-down',
    icon: [
        448,
        512,
        [],
        "f150",
        "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
    ]
};
var $72947875341bbd79$export$d0c8ba444f1f9581 = {
    prefix: 'fas',
    iconName: 'caret-square-left',
    icon: [
        448,
        512,
        [],
        "f191",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
    ]
};
var $72947875341bbd79$export$ae86c9de7e0f62fa = {
    prefix: 'fas',
    iconName: 'caret-square-right',
    icon: [
        448,
        512,
        [],
        "f152",
        "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
    ]
};
var $72947875341bbd79$export$307ae80b26533ce5 = {
    prefix: 'fas',
    iconName: 'caret-square-up',
    icon: [
        448,
        512,
        [],
        "f151",
        "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
    ]
};
var $72947875341bbd79$export$7de776bdab4e536d = {
    prefix: 'fas',
    iconName: 'caret-up',
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    ]
};
var $72947875341bbd79$export$28e93ec9f5e2ddf3 = {
    prefix: 'fas',
    iconName: 'carrot',
    icon: [
        512,
        512,
        [],
        "f787",
        "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
    ]
};
var $72947875341bbd79$export$9206260ff0c0c616 = {
    prefix: 'fas',
    iconName: 'cart-arrow-down',
    icon: [
        576,
        512,
        [],
        "f218",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
    ]
};
var $72947875341bbd79$export$6675e2bf21fdb87e = {
    prefix: 'fas',
    iconName: 'cart-plus',
    icon: [
        576,
        512,
        [],
        "f217",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
    ]
};
var $72947875341bbd79$export$6357093f67788b33 = {
    prefix: 'fas',
    iconName: 'cash-register',
    icon: [
        512,
        512,
        [],
        "f788",
        "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
    ]
};
var $72947875341bbd79$export$ab927dada03be4b3 = {
    prefix: 'fas',
    iconName: 'cat',
    icon: [
        512,
        512,
        [],
        "f6be",
        "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $72947875341bbd79$export$a881f37164b11fbf = {
    prefix: 'fas',
    iconName: 'certificate',
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
    ]
};
var $72947875341bbd79$export$a339864ee3df7e9a = {
    prefix: 'fas',
    iconName: 'chair',
    icon: [
        448,
        512,
        [],
        "f6c0",
        "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
    ]
};
var $72947875341bbd79$export$49a36efd66df775 = {
    prefix: 'fas',
    iconName: 'chalkboard',
    icon: [
        640,
        512,
        [],
        "f51b",
        "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$443fcf69b0155291 = {
    prefix: 'fas',
    iconName: 'chalkboard-teacher',
    icon: [
        640,
        512,
        [],
        "f51c",
        "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
    ]
};
var $72947875341bbd79$export$bab2cd86f8c65657 = {
    prefix: 'fas',
    iconName: 'charging-station',
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
    ]
};
var $72947875341bbd79$export$2acab8312b7a999b = {
    prefix: 'fas',
    iconName: 'chart-area',
    icon: [
        512,
        512,
        [],
        "f1fe",
        "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
    ]
};
var $72947875341bbd79$export$b532f5d25de97633 = {
    prefix: 'fas',
    iconName: 'chart-bar',
    icon: [
        512,
        512,
        [],
        "f080",
        "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$e022f62a119e1d93 = {
    prefix: 'fas',
    iconName: 'chart-line',
    icon: [
        512,
        512,
        [],
        "f201",
        "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
    ]
};
var $72947875341bbd79$export$1de7b9cf7d1b153b = {
    prefix: 'fas',
    iconName: 'chart-pie',
    icon: [
        544,
        512,
        [],
        "f200",
        "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
    ]
};
var $72947875341bbd79$export$62b2c752fccc6a9c = {
    prefix: 'fas',
    iconName: 'check',
    icon: [
        512,
        512,
        [],
        "f00c",
        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    ]
};
var $72947875341bbd79$export$be9e388158c74f29 = {
    prefix: 'fas',
    iconName: 'check-circle',
    icon: [
        512,
        512,
        [],
        "f058",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    ]
};
var $72947875341bbd79$export$f178c8c2ad3cc861 = {
    prefix: 'fas',
    iconName: 'check-double',
    icon: [
        512,
        512,
        [],
        "f560",
        "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
    ]
};
var $72947875341bbd79$export$f0c8040f596df7fe = {
    prefix: 'fas',
    iconName: 'check-square',
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
    ]
};
var $72947875341bbd79$export$549b99473b7201e6 = {
    prefix: 'fas',
    iconName: 'cheese',
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
    ]
};
var $72947875341bbd79$export$442fddbbd741c590 = {
    prefix: 'fas',
    iconName: 'chess',
    icon: [
        512,
        512,
        [],
        "f439",
        "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
    ]
};
var $72947875341bbd79$export$a831eedd2f59c62f = {
    prefix: 'fas',
    iconName: 'chess-bishop',
    icon: [
        320,
        512,
        [],
        "f43a",
        "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$bd301515df6246af = {
    prefix: 'fas',
    iconName: 'chess-board',
    icon: [
        512,
        512,
        [],
        "f43c",
        "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
    ]
};
var $72947875341bbd79$export$d5713874f8fefe1b = {
    prefix: 'fas',
    iconName: 'chess-king',
    icon: [
        448,
        512,
        [],
        "f43f",
        "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
    ]
};
var $72947875341bbd79$export$861b1f13085cf122 = {
    prefix: 'fas',
    iconName: 'chess-knight',
    icon: [
        384,
        512,
        [],
        "f441",
        "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$3db75d5ac9e98468 = {
    prefix: 'fas',
    iconName: 'chess-pawn',
    icon: [
        320,
        512,
        [],
        "f443",
        "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$7b8ce73615739d30 = {
    prefix: 'fas',
    iconName: 'chess-queen',
    icon: [
        512,
        512,
        [],
        "f445",
        "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
    ]
};
var $72947875341bbd79$export$5d65c40a109eb09c = {
    prefix: 'fas',
    iconName: 'chess-rook',
    icon: [
        384,
        512,
        [],
        "f447",
        "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$9926124d75b2ecab = {
    prefix: 'fas',
    iconName: 'chevron-circle-down',
    icon: [
        512,
        512,
        [],
        "f13a",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
    ]
};
var $72947875341bbd79$export$4a42c8c2451a33fd = {
    prefix: 'fas',
    iconName: 'chevron-circle-left',
    icon: [
        512,
        512,
        [],
        "f137",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
    ]
};
var $72947875341bbd79$export$2a5db4f6eba6f2b = {
    prefix: 'fas',
    iconName: 'chevron-circle-right',
    icon: [
        512,
        512,
        [],
        "f138",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
    ]
};
var $72947875341bbd79$export$b786cf5db03f2c36 = {
    prefix: 'fas',
    iconName: 'chevron-circle-up',
    icon: [
        512,
        512,
        [],
        "f139",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    ]
};
var $72947875341bbd79$export$8db9bc521720fccd = {
    prefix: 'fas',
    iconName: 'chevron-down',
    icon: [
        448,
        512,
        [],
        "f078",
        "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    ]
};
var $72947875341bbd79$export$75702e3e3dd44a44 = {
    prefix: 'fas',
    iconName: 'chevron-left',
    icon: [
        320,
        512,
        [],
        "f053",
        "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
    ]
};
var $72947875341bbd79$export$930de8c26eb20490 = {
    prefix: 'fas',
    iconName: 'chevron-right',
    icon: [
        320,
        512,
        [],
        "f054",
        "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
    ]
};
var $72947875341bbd79$export$877e5ae47a854215 = {
    prefix: 'fas',
    iconName: 'chevron-up',
    icon: [
        448,
        512,
        [],
        "f077",
        "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
    ]
};
var $72947875341bbd79$export$60b41e3581d1739a = {
    prefix: 'fas',
    iconName: 'child',
    icon: [
        384,
        512,
        [],
        "f1ae",
        "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
    ]
};
var $72947875341bbd79$export$16a3f12c6ae9650 = {
    prefix: 'fas',
    iconName: 'church',
    icon: [
        640,
        512,
        [],
        "f51d",
        "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
    ]
};
var $72947875341bbd79$export$4280b2387fbdad12 = {
    prefix: 'fas',
    iconName: 'circle',
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
    ]
};
var $72947875341bbd79$export$9429fd8df55155d = {
    prefix: 'fas',
    iconName: 'circle-notch',
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    ]
};
var $72947875341bbd79$export$a9947c2888b3c8fd = {
    prefix: 'fas',
    iconName: 'city',
    icon: [
        640,
        512,
        [],
        "f64f",
        "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
    ]
};
var $72947875341bbd79$export$20d8a680febc7434 = {
    prefix: 'fas',
    iconName: 'clinic-medical',
    icon: [
        576,
        512,
        [],
        "f7f2",
        "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
    ]
};
var $72947875341bbd79$export$97d84347d71ba297 = {
    prefix: 'fas',
    iconName: 'clipboard',
    icon: [
        384,
        512,
        [],
        "f328",
        "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
    ]
};
var $72947875341bbd79$export$7babcb2c90eb609a = {
    prefix: 'fas',
    iconName: 'clipboard-check',
    icon: [
        384,
        512,
        [],
        "f46c",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
    ]
};
var $72947875341bbd79$export$2c5a9d8548d8810e = {
    prefix: 'fas',
    iconName: 'clipboard-list',
    icon: [
        384,
        512,
        [],
        "f46d",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $72947875341bbd79$export$95b9968e7fceb821 = {
    prefix: 'fas',
    iconName: 'clock',
    icon: [
        512,
        512,
        [],
        "f017",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
    ]
};
var $72947875341bbd79$export$76c1aa4bf9a39458 = {
    prefix: 'fas',
    iconName: 'clone',
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    ]
};
var $72947875341bbd79$export$8e047801a8603af7 = {
    prefix: 'fas',
    iconName: 'closed-captioning',
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
    ]
};
var $72947875341bbd79$export$8bb3c4d5c2f50243 = {
    prefix: 'fas',
    iconName: 'cloud',
    icon: [
        640,
        512,
        [],
        "f0c2",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
    ]
};
var $72947875341bbd79$export$351357a14c41f824 = {
    prefix: 'fas',
    iconName: 'cloud-download-alt',
    icon: [
        640,
        512,
        [],
        "f381",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    ]
};
var $72947875341bbd79$export$5d120e8b87ad33f4 = {
    prefix: 'fas',
    iconName: 'cloud-meatball',
    icon: [
        512,
        512,
        [],
        "f73b",
        "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
    ]
};
var $72947875341bbd79$export$482eb125aaf0fbc2 = {
    prefix: 'fas',
    iconName: 'cloud-moon',
    icon: [
        576,
        512,
        [],
        "f6c3",
        "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
    ]
};
var $72947875341bbd79$export$301c3fab0c4545bd = {
    prefix: 'fas',
    iconName: 'cloud-moon-rain',
    icon: [
        576,
        512,
        [],
        "f73c",
        "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $72947875341bbd79$export$a6c308ee087b4ded = {
    prefix: 'fas',
    iconName: 'cloud-rain',
    icon: [
        512,
        512,
        [],
        "f73d",
        "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
    ]
};
var $72947875341bbd79$export$af51c741ee9cc090 = {
    prefix: 'fas',
    iconName: 'cloud-showers-heavy',
    icon: [
        512,
        512,
        [],
        "f740",
        "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
    ]
};
var $72947875341bbd79$export$dcaadfd9c98e42a1 = {
    prefix: 'fas',
    iconName: 'cloud-sun',
    icon: [
        640,
        512,
        [],
        "f6c4",
        "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
    ]
};
var $72947875341bbd79$export$dd9dc9b4227dbe94 = {
    prefix: 'fas',
    iconName: 'cloud-sun-rain',
    icon: [
        576,
        512,
        [],
        "f743",
        "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $72947875341bbd79$export$e73b3e819b9d14a5 = {
    prefix: 'fas',
    iconName: 'cloud-upload-alt',
    icon: [
        640,
        512,
        [],
        "f382",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
    ]
};
var $72947875341bbd79$export$4be708f1e41d387b = {
    prefix: 'fas',
    iconName: 'cocktail',
    icon: [
        576,
        512,
        [],
        "f561",
        "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
    ]
};
var $72947875341bbd79$export$eba095993e51cc97 = {
    prefix: 'fas',
    iconName: 'code',
    icon: [
        640,
        512,
        [],
        "f121",
        "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
    ]
};
var $72947875341bbd79$export$aa054a78ab078db3 = {
    prefix: 'fas',
    iconName: 'code-branch',
    icon: [
        384,
        512,
        [],
        "f126",
        "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
    ]
};
var $72947875341bbd79$export$1d24a9e457278011 = {
    prefix: 'fas',
    iconName: 'coffee',
    icon: [
        640,
        512,
        [],
        "f0f4",
        "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
    ]
};
var $72947875341bbd79$export$d6298bbfd1912a78 = {
    prefix: 'fas',
    iconName: 'cog',
    icon: [
        512,
        512,
        [],
        "f013",
        "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$af1575770afc9559 = {
    prefix: 'fas',
    iconName: 'cogs',
    icon: [
        640,
        512,
        [],
        "f085",
        "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
    ]
};
var $72947875341bbd79$export$bc5da164799a0e = {
    prefix: 'fas',
    iconName: 'coins',
    icon: [
        512,
        512,
        [],
        "f51e",
        "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
    ]
};
var $72947875341bbd79$export$bb861166644ac28a = {
    prefix: 'fas',
    iconName: 'columns',
    icon: [
        512,
        512,
        [],
        "f0db",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
    ]
};
var $72947875341bbd79$export$805cd88398a70581 = {
    prefix: 'fas',
    iconName: 'comment',
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
    ]
};
var $72947875341bbd79$export$6e96904d9af0ec4a = {
    prefix: 'fas',
    iconName: 'comment-alt',
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
    ]
};
var $72947875341bbd79$export$7a088030853df12c = {
    prefix: 'fas',
    iconName: 'comment-dollar',
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
    ]
};
var $72947875341bbd79$export$63ffcb3d4e94cb92 = {
    prefix: 'fas',
    iconName: 'comment-dots',
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$101422b773924276 = {
    prefix: 'fas',
    iconName: 'comment-medical',
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
    ]
};
var $72947875341bbd79$export$3786a0422a3f33ea = {
    prefix: 'fas',
    iconName: 'comment-slash',
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $72947875341bbd79$export$932912e74adb8939 = {
    prefix: 'fas',
    iconName: 'comments',
    icon: [
        576,
        512,
        [],
        "f086",
        "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
    ]
};
var $72947875341bbd79$export$d477129b070e5ac4 = {
    prefix: 'fas',
    iconName: 'comments-dollar',
    icon: [
        576,
        512,
        [],
        "f653",
        "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
    ]
};
var $72947875341bbd79$export$84021631df0f831b = {
    prefix: 'fas',
    iconName: 'compact-disc',
    icon: [
        496,
        512,
        [],
        "f51f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $72947875341bbd79$export$b4d344633433e50e = {
    prefix: 'fas',
    iconName: 'compass',
    icon: [
        496,
        512,
        [],
        "f14e",
        "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
    ]
};
var $72947875341bbd79$export$83632d1150d3541f = {
    prefix: 'fas',
    iconName: 'compress',
    icon: [
        448,
        512,
        [],
        "f066",
        "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $72947875341bbd79$export$a05650ebe54bede = {
    prefix: 'fas',
    iconName: 'compress-alt',
    icon: [
        448,
        512,
        [],
        "f422",
        "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
    ]
};
var $72947875341bbd79$export$39205db0ea980efd = {
    prefix: 'fas',
    iconName: 'compress-arrows-alt',
    icon: [
        512,
        512,
        [],
        "f78c",
        "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
    ]
};
var $72947875341bbd79$export$ad92ffbbfbc0fcf3 = {
    prefix: 'fas',
    iconName: 'concierge-bell',
    icon: [
        512,
        512,
        [],
        "f562",
        "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$b3e64f5f68c6623f = {
    prefix: 'fas',
    iconName: 'cookie',
    icon: [
        512,
        512,
        [],
        "f563",
        "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$317dde8664f7de71 = {
    prefix: 'fas',
    iconName: 'cookie-bite',
    icon: [
        512,
        512,
        [],
        "f564",
        "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$e9bd786d30cb716c = {
    prefix: 'fas',
    iconName: 'copy',
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
    ]
};
var $72947875341bbd79$export$da61665fff8aebfe = {
    prefix: 'fas',
    iconName: 'copyright',
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
    ]
};
var $72947875341bbd79$export$ce96e32767a7dd51 = {
    prefix: 'fas',
    iconName: 'couch',
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
    ]
};
var $72947875341bbd79$export$3e7437bf6535bef0 = {
    prefix: 'fas',
    iconName: 'credit-card',
    icon: [
        576,
        512,
        [],
        "f09d",
        "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
    ]
};
var $72947875341bbd79$export$afa58590dfb6fca2 = {
    prefix: 'fas',
    iconName: 'crop',
    icon: [
        512,
        512,
        [],
        "f125",
        "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $72947875341bbd79$export$d932915fde4f1010 = {
    prefix: 'fas',
    iconName: 'crop-alt',
    icon: [
        512,
        512,
        [],
        "f565",
        "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
    ]
};
var $72947875341bbd79$export$9d0a89fcd084abb = {
    prefix: 'fas',
    iconName: 'cross',
    icon: [
        384,
        512,
        [],
        "f654",
        "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$721c101130c40043 = {
    prefix: 'fas',
    iconName: 'crosshairs',
    icon: [
        512,
        512,
        [],
        "f05b",
        "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ]
};
var $72947875341bbd79$export$bfa312207b788ed9 = {
    prefix: 'fas',
    iconName: 'crow',
    icon: [
        640,
        512,
        [],
        "f520",
        "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$dc1083dcd1d7b9d6 = {
    prefix: 'fas',
    iconName: 'crown',
    icon: [
        640,
        512,
        [],
        "f521",
        "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$e94134641c0e2 = {
    prefix: 'fas',
    iconName: 'crutch',
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
    ]
};
var $72947875341bbd79$export$973ae4f1e4d2ce78 = {
    prefix: 'fas',
    iconName: 'cube',
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
    ]
};
var $72947875341bbd79$export$30523a9441a31e97 = {
    prefix: 'fas',
    iconName: 'cubes',
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
    ]
};
var $72947875341bbd79$export$66847f2a71b260e7 = {
    prefix: 'fas',
    iconName: 'cut',
    icon: [
        448,
        512,
        [],
        "f0c4",
        "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $72947875341bbd79$export$24680dede86b1883 = {
    prefix: 'fas',
    iconName: 'database',
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    ]
};
var $72947875341bbd79$export$4b666adf83f0de01 = {
    prefix: 'fas',
    iconName: 'deaf',
    icon: [
        512,
        512,
        [],
        "f2a4",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
    ]
};
var $72947875341bbd79$export$a1672d808fbed0bd = {
    prefix: 'fas',
    iconName: 'democrat',
    icon: [
        640,
        512,
        [],
        "f747",
        "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
    ]
};
var $72947875341bbd79$export$6e6ddc253102e596 = {
    prefix: 'fas',
    iconName: 'desktop',
    icon: [
        576,
        512,
        [],
        "f108",
        "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
    ]
};
var $72947875341bbd79$export$45cbd92c28deb2c7 = {
    prefix: 'fas',
    iconName: 'dharmachakra',
    icon: [
        512,
        512,
        [],
        "f655",
        "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
    ]
};
var $72947875341bbd79$export$68bad2b52a90d1fa = {
    prefix: 'fas',
    iconName: 'diagnoses',
    icon: [
        640,
        512,
        [],
        "f470",
        "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$4ed8206e6619cc8f = {
    prefix: 'fas',
    iconName: 'dice',
    icon: [
        640,
        512,
        [],
        "f522",
        "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$b06003a02c9055bd = {
    prefix: 'fas',
    iconName: 'dice-d20',
    icon: [
        480,
        512,
        [],
        "f6cf",
        "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
    ]
};
var $72947875341bbd79$export$64bfd48ed353c031 = {
    prefix: 'fas',
    iconName: 'dice-d6',
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
    ]
};
var $72947875341bbd79$export$d9769fb795c2db82 = {
    prefix: 'fas',
    iconName: 'dice-five',
    icon: [
        448,
        512,
        [],
        "f523",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$2df6451abf70a6ff = {
    prefix: 'fas',
    iconName: 'dice-four',
    icon: [
        448,
        512,
        [],
        "f524",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$d91800b7be5303b0 = {
    prefix: 'fas',
    iconName: 'dice-one',
    icon: [
        448,
        512,
        [],
        "f525",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$3397c7b4679acccc = {
    prefix: 'fas',
    iconName: 'dice-six',
    icon: [
        448,
        512,
        [],
        "f526",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$221059e0d5fd8958 = {
    prefix: 'fas',
    iconName: 'dice-three',
    icon: [
        448,
        512,
        [],
        "f527",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$4d85df590065572f = {
    prefix: 'fas',
    iconName: 'dice-two',
    icon: [
        448,
        512,
        [],
        "f528",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$b3bf1994f0fefe98 = {
    prefix: 'fas',
    iconName: 'digital-tachograph',
    icon: [
        640,
        512,
        [],
        "f566",
        "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
    ]
};
var $72947875341bbd79$export$6a6973de44442fe5 = {
    prefix: 'fas',
    iconName: 'directions',
    icon: [
        512,
        512,
        [],
        "f5eb",
        "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
    ]
};
var $72947875341bbd79$export$c7675a37487adc45 = {
    prefix: 'fas',
    iconName: 'disease',
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
    ]
};
var $72947875341bbd79$export$89fa217ec5503ac9 = {
    prefix: 'fas',
    iconName: 'divide',
    icon: [
        448,
        512,
        [],
        "f529",
        "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$89a2b10dabc487e8 = {
    prefix: 'fas',
    iconName: 'dizzy',
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
    ]
};
var $72947875341bbd79$export$c062100d54a2da00 = {
    prefix: 'fas',
    iconName: 'dna',
    icon: [
        448,
        512,
        [],
        "f471",
        "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
    ]
};
var $72947875341bbd79$export$c6406747800cf702 = {
    prefix: 'fas',
    iconName: 'dog',
    icon: [
        576,
        512,
        [],
        "f6d3",
        "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
    ]
};
var $72947875341bbd79$export$fb420d3e4d8c6a18 = {
    prefix: 'fas',
    iconName: 'dollar-sign',
    icon: [
        288,
        512,
        [],
        "f155",
        "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
    ]
};
var $72947875341bbd79$export$5879d0bca1aa497b = {
    prefix: 'fas',
    iconName: 'dolly',
    icon: [
        576,
        512,
        [],
        "f472",
        "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $72947875341bbd79$export$f7c6efb60c53b285 = {
    prefix: 'fas',
    iconName: 'dolly-flatbed',
    icon: [
        640,
        512,
        [],
        "f474",
        "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$40050ae52860cde7 = {
    prefix: 'fas',
    iconName: 'donate',
    icon: [
        512,
        512,
        [],
        "f4b9",
        "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
    ]
};
var $72947875341bbd79$export$2c79e1a422528bba = {
    prefix: 'fas',
    iconName: 'door-closed',
    icon: [
        640,
        512,
        [],
        "f52a",
        "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
    ]
};
var $72947875341bbd79$export$41821b9a6fd703de = {
    prefix: 'fas',
    iconName: 'door-open',
    icon: [
        640,
        512,
        [],
        "f52b",
        "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
    ]
};
var $72947875341bbd79$export$92bc269cb244d66a = {
    prefix: 'fas',
    iconName: 'dot-circle',
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
    ]
};
var $72947875341bbd79$export$a1ab1e69a300089f = {
    prefix: 'fas',
    iconName: 'dove',
    icon: [
        512,
        512,
        [],
        "f4ba",
        "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $72947875341bbd79$export$8f734e51d72ca13a = {
    prefix: 'fas',
    iconName: 'download',
    icon: [
        512,
        512,
        [],
        "f019",
        "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $72947875341bbd79$export$c8c2b127d13b9d79 = {
    prefix: 'fas',
    iconName: 'drafting-compass',
    icon: [
        512,
        512,
        [],
        "f568",
        "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
    ]
};
var $72947875341bbd79$export$ae1875ba975aa0e9 = {
    prefix: 'fas',
    iconName: 'dragon',
    icon: [
        640,
        512,
        [],
        "f6d5",
        "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
    ]
};
var $72947875341bbd79$export$df9bd3777d1154d2 = {
    prefix: 'fas',
    iconName: 'draw-polygon',
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
    ]
};
var $72947875341bbd79$export$5b9205e1042594b7 = {
    prefix: 'fas',
    iconName: 'drum',
    icon: [
        512,
        512,
        [],
        "f569",
        "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
    ]
};
var $72947875341bbd79$export$48d1206500db2e9d = {
    prefix: 'fas',
    iconName: 'drum-steelpan',
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
    ]
};
var $72947875341bbd79$export$482976e9a4ab10f3 = {
    prefix: 'fas',
    iconName: 'drumstick-bite',
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
    ]
};
var $72947875341bbd79$export$56700074cf37be5c = {
    prefix: 'fas',
    iconName: 'dumbbell',
    icon: [
        640,
        512,
        [],
        "f44b",
        "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
    ]
};
var $72947875341bbd79$export$3b934e22d1851a3b = {
    prefix: 'fas',
    iconName: 'dumpster',
    icon: [
        576,
        512,
        [],
        "f793",
        "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$25e9b29b3f2230b5 = {
    prefix: 'fas',
    iconName: 'dumpster-fire',
    icon: [
        640,
        512,
        [],
        "f794",
        "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
    ]
};
var $72947875341bbd79$export$1156dc6acb0058bd = {
    prefix: 'fas',
    iconName: 'dungeon',
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    ]
};
var $72947875341bbd79$export$7be713e57d023733 = {
    prefix: 'fas',
    iconName: 'edit',
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
    ]
};
var $72947875341bbd79$export$1199a8ce85311ab5 = {
    prefix: 'fas',
    iconName: 'egg',
    icon: [
        384,
        512,
        [],
        "f7fb",
        "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
    ]
};
var $72947875341bbd79$export$8484041d5b209494 = {
    prefix: 'fas',
    iconName: 'eject',
    icon: [
        448,
        512,
        [],
        "f052",
        "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
    ]
};
var $72947875341bbd79$export$c9f2fedd4489a2ee = {
    prefix: 'fas',
    iconName: 'ellipsis-h',
    icon: [
        512,
        512,
        [],
        "f141",
        "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
    ]
};
var $72947875341bbd79$export$e58494c7fcb5380 = {
    prefix: 'fas',
    iconName: 'ellipsis-v',
    icon: [
        192,
        512,
        [],
        "f142",
        "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
    ]
};
var $72947875341bbd79$export$6f095630677adc = {
    prefix: 'fas',
    iconName: 'envelope',
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ]
};
var $72947875341bbd79$export$c6c3bd5f7d9b8bf2 = {
    prefix: 'fas',
    iconName: 'envelope-open',
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
    ]
};
var $72947875341bbd79$export$f5c53ce8ec380d11 = {
    prefix: 'fas',
    iconName: 'envelope-open-text',
    icon: [
        512,
        512,
        [],
        "f658",
        "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
    ]
};
var $72947875341bbd79$export$354e159473e73552 = {
    prefix: 'fas',
    iconName: 'envelope-square',
    icon: [
        448,
        512,
        [],
        "f199",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
    ]
};
var $72947875341bbd79$export$a7c5f5e4805fdab = {
    prefix: 'fas',
    iconName: 'equals',
    icon: [
        448,
        512,
        [],
        "f52c",
        "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$e7fc4fe34e767f28 = {
    prefix: 'fas',
    iconName: 'eraser',
    icon: [
        512,
        512,
        [],
        "f12d",
        "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
    ]
};
var $72947875341bbd79$export$6bad2c9f317b52e5 = {
    prefix: 'fas',
    iconName: 'ethernet',
    icon: [
        512,
        512,
        [],
        "f796",
        "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$902a3969bb113dff = {
    prefix: 'fas',
    iconName: 'euro-sign',
    icon: [
        320,
        512,
        [],
        "f153",
        "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
    ]
};
var $72947875341bbd79$export$f6c6fb20d374b128 = {
    prefix: 'fas',
    iconName: 'exchange-alt',
    icon: [
        512,
        512,
        [],
        "f362",
        "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
    ]
};
var $72947875341bbd79$export$de6218b649cbb6a9 = {
    prefix: 'fas',
    iconName: 'exclamation',
    icon: [
        192,
        512,
        [],
        "f12a",
        "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    ]
};
var $72947875341bbd79$export$220e07e14c5d7e5d = {
    prefix: 'fas',
    iconName: 'exclamation-circle',
    icon: [
        512,
        512,
        [],
        "f06a",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $72947875341bbd79$export$3d249b63b52cce7c = {
    prefix: 'fas',
    iconName: 'exclamation-triangle',
    icon: [
        576,
        512,
        [],
        "f071",
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $72947875341bbd79$export$1fe4a9976a241685 = {
    prefix: 'fas',
    iconName: 'expand',
    icon: [
        448,
        512,
        [],
        "f065",
        "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
    ]
};
var $72947875341bbd79$export$bcb8d86a3a1d6eb6 = {
    prefix: 'fas',
    iconName: 'expand-alt',
    icon: [
        448,
        512,
        [],
        "f424",
        "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
    ]
};
var $72947875341bbd79$export$6219dcd88b5fa6c2 = {
    prefix: 'fas',
    iconName: 'expand-arrows-alt',
    icon: [
        448,
        512,
        [],
        "f31e",
        "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
    ]
};
var $72947875341bbd79$export$d7f107e456ab0306 = {
    prefix: 'fas',
    iconName: 'external-link-alt',
    icon: [
        512,
        512,
        [],
        "f35d",
        "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    ]
};
var $72947875341bbd79$export$e4cdf2977151ee26 = {
    prefix: 'fas',
    iconName: 'external-link-square-alt',
    icon: [
        448,
        512,
        [],
        "f360",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    ]
};
var $72947875341bbd79$export$b8c3e79e8c99c95b = {
    prefix: 'fas',
    iconName: 'eye',
    icon: [
        576,
        512,
        [],
        "f06e",
        "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    ]
};
var $72947875341bbd79$export$1bc3e0ad56dc9eb0 = {
    prefix: 'fas',
    iconName: 'eye-dropper',
    icon: [
        512,
        512,
        [],
        "f1fb",
        "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
    ]
};
var $72947875341bbd79$export$ed3f2918429d029a = {
    prefix: 'fas',
    iconName: 'eye-slash',
    icon: [
        640,
        512,
        [],
        "f070",
        "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    ]
};
var $72947875341bbd79$export$55145a3dae4f984a = {
    prefix: 'fas',
    iconName: 'fan',
    icon: [
        512,
        512,
        [],
        "f863",
        "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $72947875341bbd79$export$e6246a3279a379b8 = {
    prefix: 'fas',
    iconName: 'fast-backward',
    icon: [
        512,
        512,
        [],
        "f049",
        "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
    ]
};
var $72947875341bbd79$export$61a8cdc53c2e078d = {
    prefix: 'fas',
    iconName: 'fast-forward',
    icon: [
        512,
        512,
        [],
        "f050",
        "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
    ]
};
var $72947875341bbd79$export$a0856b225f3b0614 = {
    prefix: 'fas',
    iconName: 'faucet',
    icon: [
        512,
        512,
        [],
        "e005",
        "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
    ]
};
var $72947875341bbd79$export$b5698497901d7197 = {
    prefix: 'fas',
    iconName: 'fax',
    icon: [
        512,
        512,
        [],
        "f1ac",
        "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
    ]
};
var $72947875341bbd79$export$5e19aea195b31816 = {
    prefix: 'fas',
    iconName: 'feather',
    icon: [
        512,
        512,
        [],
        "f52d",
        "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
    ]
};
var $72947875341bbd79$export$68cf766c786bcd78 = {
    prefix: 'fas',
    iconName: 'feather-alt',
    icon: [
        512,
        512,
        [],
        "f56b",
        "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
    ]
};
var $72947875341bbd79$export$70e8e75e61dd7169 = {
    prefix: 'fas',
    iconName: 'female',
    icon: [
        256,
        512,
        [],
        "f182",
        "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
    ]
};
var $72947875341bbd79$export$102b809faf56e033 = {
    prefix: 'fas',
    iconName: 'fighter-jet',
    icon: [
        640,
        512,
        [],
        "f0fb",
        "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
    ]
};
var $72947875341bbd79$export$cad54bead856a678 = {
    prefix: 'fas',
    iconName: 'file',
    icon: [
        384,
        512,
        [],
        "f15b",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $72947875341bbd79$export$243b47dca32bf0b8 = {
    prefix: 'fas',
    iconName: 'file-alt',
    icon: [
        384,
        512,
        [],
        "f15c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $72947875341bbd79$export$bf2047a9946b5c3f = {
    prefix: 'fas',
    iconName: 'file-archive',
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
    ]
};
var $72947875341bbd79$export$b8d24c57c9e64933 = {
    prefix: 'fas',
    iconName: 'file-audio',
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $72947875341bbd79$export$143d0ca7d2200f20 = {
    prefix: 'fas',
    iconName: 'file-code',
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
    ]
};
var $72947875341bbd79$export$70fde3f3fdaa6a6a = {
    prefix: 'fas',
    iconName: 'file-contract',
    icon: [
        384,
        512,
        [],
        "f56c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $72947875341bbd79$export$82cea4f586f6ec9 = {
    prefix: 'fas',
    iconName: 'file-csv',
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $72947875341bbd79$export$1013b9966d758343 = {
    prefix: 'fas',
    iconName: 'file-download',
    icon: [
        384,
        512,
        [],
        "f56d",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $72947875341bbd79$export$77cb1a465c4fe84 = {
    prefix: 'fas',
    iconName: 'file-excel',
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $72947875341bbd79$export$364f19abcfac1b0a = {
    prefix: 'fas',
    iconName: 'file-export',
    icon: [
        576,
        512,
        [],
        "f56e",
        "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
    ]
};
var $72947875341bbd79$export$6440b286d3cbac9b = {
    prefix: 'fas',
    iconName: 'file-image',
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
    ]
};
var $72947875341bbd79$export$d796c05153b1255c = {
    prefix: 'fas',
    iconName: 'file-import',
    icon: [
        512,
        512,
        [],
        "f56f",
        "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
    ]
};
var $72947875341bbd79$export$bef39294aed2281a = {
    prefix: 'fas',
    iconName: 'file-invoice',
    icon: [
        384,
        512,
        [],
        "f570",
        "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
    ]
};
var $72947875341bbd79$export$a3dced32d48cb1ea = {
    prefix: 'fas',
    iconName: 'file-invoice-dollar',
    icon: [
        384,
        512,
        [],
        "f571",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
    ]
};
var $72947875341bbd79$export$56cbcd962389b090 = {
    prefix: 'fas',
    iconName: 'file-medical',
    icon: [
        384,
        512,
        [],
        "f477",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
    ]
};
var $72947875341bbd79$export$ef02a0f5b39aa61f = {
    prefix: 'fas',
    iconName: 'file-medical-alt',
    icon: [
        448,
        512,
        [],
        "f478",
        "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $72947875341bbd79$export$38611f1c776aba73 = {
    prefix: 'fas',
    iconName: 'file-pdf',
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    ]
};
var $72947875341bbd79$export$c341daeecdea449a = {
    prefix: 'fas',
    iconName: 'file-powerpoint',
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
    ]
};
var $72947875341bbd79$export$a20cb90865b6beb8 = {
    prefix: 'fas',
    iconName: 'file-prescription',
    icon: [
        384,
        512,
        [],
        "f572",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $72947875341bbd79$export$d0de575ac166712b = {
    prefix: 'fas',
    iconName: 'file-signature',
    icon: [
        576,
        512,
        [],
        "f573",
        "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
    ]
};
var $72947875341bbd79$export$dd55ded1264643d2 = {
    prefix: 'fas',
    iconName: 'file-upload',
    icon: [
        384,
        512,
        [],
        "f574",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $72947875341bbd79$export$b44eb38345c6a964 = {
    prefix: 'fas',
    iconName: 'file-video',
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
    ]
};
var $72947875341bbd79$export$f0858dff6e769cf6 = {
    prefix: 'fas',
    iconName: 'file-word',
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $72947875341bbd79$export$d3c2bcfd3b861e4a = {
    prefix: 'fas',
    iconName: 'fill',
    icon: [
        512,
        512,
        [],
        "f575",
        "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
    ]
};
var $72947875341bbd79$export$38320138fc0262d0 = {
    prefix: 'fas',
    iconName: 'fill-drip',
    icon: [
        576,
        512,
        [],
        "f576",
        "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
    ]
};
var $72947875341bbd79$export$c03de0cc616e77bb = {
    prefix: 'fas',
    iconName: 'film',
    icon: [
        512,
        512,
        [],
        "f008",
        "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $72947875341bbd79$export$f253a38d7142e29f = {
    prefix: 'fas',
    iconName: 'filter',
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    ]
};
var $72947875341bbd79$export$614dc068d88655af = {
    prefix: 'fas',
    iconName: 'fingerprint',
    icon: [
        512,
        512,
        [],
        "f577",
        "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
    ]
};
var $72947875341bbd79$export$7b24b34ef6cc130c = {
    prefix: 'fas',
    iconName: 'fire',
    icon: [
        384,
        512,
        [],
        "f06d",
        "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
    ]
};
var $72947875341bbd79$export$70dc26b4926d0b1b = {
    prefix: 'fas',
    iconName: 'fire-alt',
    icon: [
        448,
        512,
        [],
        "f7e4",
        "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
    ]
};
var $72947875341bbd79$export$d75fb6743634a0a = {
    prefix: 'fas',
    iconName: 'fire-extinguisher',
    icon: [
        448,
        512,
        [],
        "f134",
        "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
    ]
};
var $72947875341bbd79$export$5b01ccb2da4c4387 = {
    prefix: 'fas',
    iconName: 'first-aid',
    icon: [
        576,
        512,
        [],
        "f479",
        "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$24228a855c5f6812 = {
    prefix: 'fas',
    iconName: 'fish',
    icon: [
        576,
        512,
        [],
        "f578",
        "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$fa0323a4d7489a8d = {
    prefix: 'fas',
    iconName: 'fist-raised',
    icon: [
        384,
        512,
        [],
        "f6de",
        "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
    ]
};
var $72947875341bbd79$export$6591b1ea509be9da = {
    prefix: 'fas',
    iconName: 'flag',
    icon: [
        512,
        512,
        [],
        "f024",
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    ]
};
var $72947875341bbd79$export$92fad97e19a9fea = {
    prefix: 'fas',
    iconName: 'flag-checkered',
    icon: [
        512,
        512,
        [],
        "f11e",
        "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
    ]
};
var $72947875341bbd79$export$19357abad396e723 = {
    prefix: 'fas',
    iconName: 'flag-usa',
    icon: [
        512,
        512,
        [],
        "f74d",
        "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
    ]
};
var $72947875341bbd79$export$f9b579ba06048af = {
    prefix: 'fas',
    iconName: 'flask',
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
    ]
};
var $72947875341bbd79$export$dfd2bd012685aeac = {
    prefix: 'fas',
    iconName: 'flushed',
    icon: [
        496,
        512,
        [],
        "f579",
        "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
    ]
};
var $72947875341bbd79$export$72b780186370e953 = {
    prefix: 'fas',
    iconName: 'folder',
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ]
};
var $72947875341bbd79$export$758f1fb3784e4080 = {
    prefix: 'fas',
    iconName: 'folder-minus',
    icon: [
        512,
        512,
        [],
        "f65d",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
    ]
};
var $72947875341bbd79$export$ff7e93418af88b78 = {
    prefix: 'fas',
    iconName: 'folder-open',
    icon: [
        576,
        512,
        [],
        "f07c",
        "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
    ]
};
var $72947875341bbd79$export$e18e05ffa2045d3b = {
    prefix: 'fas',
    iconName: 'folder-plus',
    icon: [
        512,
        512,
        [],
        "f65e",
        "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
    ]
};
var $72947875341bbd79$export$a5dc297d3f60936 = {
    prefix: 'fas',
    iconName: 'font',
    icon: [
        448,
        512,
        [],
        "f031",
        "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
    ]
};
var $72947875341bbd79$export$6e20d421a2e0f320 = {
    prefix: 'fas',
    iconName: 'font-awesome-logo-full',
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var $72947875341bbd79$export$e8fd664711e31704 = {
    prefix: 'fas',
    iconName: 'football-ball',
    icon: [
        496,
        512,
        [],
        "f44e",
        "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
    ]
};
var $72947875341bbd79$export$a8710cdb23198d53 = {
    prefix: 'fas',
    iconName: 'forward',
    icon: [
        512,
        512,
        [],
        "f04e",
        "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
    ]
};
var $72947875341bbd79$export$fe2358263efac504 = {
    prefix: 'fas',
    iconName: 'frog',
    icon: [
        576,
        512,
        [],
        "f52e",
        "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$43b7108508aecc5f = {
    prefix: 'fas',
    iconName: 'frown',
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
    ]
};
var $72947875341bbd79$export$c4775e66bed5d96 = {
    prefix: 'fas',
    iconName: 'frown-open',
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$cebe38ad8f0a143d = {
    prefix: 'fas',
    iconName: 'funnel-dollar',
    icon: [
        640,
        512,
        [],
        "f662",
        "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
    ]
};
var $72947875341bbd79$export$65a345b33858a655 = {
    prefix: 'fas',
    iconName: 'futbol',
    icon: [
        512,
        512,
        [],
        "f1e3",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
    ]
};
var $72947875341bbd79$export$6a66b1b639455bef = {
    prefix: 'fas',
    iconName: 'gamepad',
    icon: [
        640,
        512,
        [],
        "f11b",
        "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
    ]
};
var $72947875341bbd79$export$84666c793cb2a347 = {
    prefix: 'fas',
    iconName: 'gas-pump',
    icon: [
        512,
        512,
        [],
        "f52f",
        "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
    ]
};
var $72947875341bbd79$export$c36fb40057e2c3aa = {
    prefix: 'fas',
    iconName: 'gavel',
    icon: [
        512,
        512,
        [],
        "f0e3",
        "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
    ]
};
var $72947875341bbd79$export$31ee86ac717db552 = {
    prefix: 'fas',
    iconName: 'gem',
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
    ]
};
var $72947875341bbd79$export$c093cc22e88981c2 = {
    prefix: 'fas',
    iconName: 'genderless',
    icon: [
        288,
        512,
        [],
        "f22d",
        "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    ]
};
var $72947875341bbd79$export$1a989eb1919c64c1 = {
    prefix: 'fas',
    iconName: 'ghost',
    icon: [
        384,
        512,
        [],
        "f6e2",
        "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$b2727de8ccdbb5ec = {
    prefix: 'fas',
    iconName: 'gift',
    icon: [
        512,
        512,
        [],
        "f06b",
        "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $72947875341bbd79$export$de9a67b55dbe819a = {
    prefix: 'fas',
    iconName: 'gifts',
    icon: [
        640,
        512,
        [],
        "f79c",
        "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
    ]
};
var $72947875341bbd79$export$20007d7d74cb98fe = {
    prefix: 'fas',
    iconName: 'glass-cheers',
    icon: [
        640,
        512,
        [],
        "f79f",
        "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
    ]
};
var $72947875341bbd79$export$e96f280e39af4a91 = {
    prefix: 'fas',
    iconName: 'glass-martini',
    icon: [
        512,
        512,
        [],
        "f000",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
    ]
};
var $72947875341bbd79$export$2258439b8f4e7acb = {
    prefix: 'fas',
    iconName: 'glass-martini-alt',
    icon: [
        512,
        512,
        [],
        "f57b",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
    ]
};
var $72947875341bbd79$export$fdec0f5f1a169419 = {
    prefix: 'fas',
    iconName: 'glass-whiskey',
    icon: [
        512,
        512,
        [],
        "f7a0",
        "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
    ]
};
var $72947875341bbd79$export$58d7d709c0a8ca5f = {
    prefix: 'fas',
    iconName: 'glasses',
    icon: [
        576,
        512,
        [],
        "f530",
        "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
    ]
};
var $72947875341bbd79$export$b1b1cdce4a19c682 = {
    prefix: 'fas',
    iconName: 'globe',
    icon: [
        496,
        512,
        [],
        "f0ac",
        "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
    ]
};
var $72947875341bbd79$export$64af36f3b403a57c = {
    prefix: 'fas',
    iconName: 'globe-africa',
    icon: [
        496,
        512,
        [],
        "f57c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
    ]
};
var $72947875341bbd79$export$e96bcc7bde9498db = {
    prefix: 'fas',
    iconName: 'globe-americas',
    icon: [
        496,
        512,
        [],
        "f57d",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
    ]
};
var $72947875341bbd79$export$796fdfc909e603f4 = {
    prefix: 'fas',
    iconName: 'globe-asia',
    icon: [
        496,
        512,
        [],
        "f57e",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
    ]
};
var $72947875341bbd79$export$5318b8ede86cc96b = {
    prefix: 'fas',
    iconName: 'globe-europe',
    icon: [
        496,
        512,
        [],
        "f7a2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
    ]
};
var $72947875341bbd79$export$2251487a9a33c682 = {
    prefix: 'fas',
    iconName: 'golf-ball',
    icon: [
        416,
        512,
        [],
        "f450",
        "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
    ]
};
var $72947875341bbd79$export$31f89d8ac1d14ed6 = {
    prefix: 'fas',
    iconName: 'gopuram',
    icon: [
        512,
        512,
        [],
        "f664",
        "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $72947875341bbd79$export$874e305fd7920cce = {
    prefix: 'fas',
    iconName: 'graduation-cap',
    icon: [
        640,
        512,
        [],
        "f19d",
        "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
    ]
};
var $72947875341bbd79$export$da07b6bc24a496ca = {
    prefix: 'fas',
    iconName: 'greater-than',
    icon: [
        384,
        512,
        [],
        "f531",
        "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
    ]
};
var $72947875341bbd79$export$7bf8dfe2e6661a54 = {
    prefix: 'fas',
    iconName: 'greater-than-equal',
    icon: [
        448,
        512,
        [],
        "f532",
        "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $72947875341bbd79$export$3d08cd36ac1ef231 = {
    prefix: 'fas',
    iconName: 'grimace',
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
    ]
};
var $72947875341bbd79$export$37e1f10b6de76621 = {
    prefix: 'fas',
    iconName: 'grin',
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $72947875341bbd79$export$b4abebfe416d36ba = {
    prefix: 'fas',
    iconName: 'grin-alt',
    icon: [
        496,
        512,
        [],
        "f581",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $72947875341bbd79$export$734da5249381ec7e = {
    prefix: 'fas',
    iconName: 'grin-beam',
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $72947875341bbd79$export$14d0ccc54c5b6826 = {
    prefix: 'fas',
    iconName: 'grin-beam-sweat',
    icon: [
        504,
        512,
        [],
        "f583",
        "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $72947875341bbd79$export$c56cf0e0c3bc5ed2 = {
    prefix: 'fas',
    iconName: 'grin-hearts',
    icon: [
        496,
        512,
        [],
        "f584",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
    ]
};
var $72947875341bbd79$export$243ae757907b1580 = {
    prefix: 'fas',
    iconName: 'grin-squint',
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $72947875341bbd79$export$542206d6a85f3b42 = {
    prefix: 'fas',
    iconName: 'grin-squint-tears',
    icon: [
        512,
        512,
        [],
        "f586",
        "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
    ]
};
var $72947875341bbd79$export$64347a5c8c402ef4 = {
    prefix: 'fas',
    iconName: 'grin-stars',
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
    ]
};
var $72947875341bbd79$export$b2f7512221512b5b = {
    prefix: 'fas',
    iconName: 'grin-tears',
    icon: [
        640,
        512,
        [],
        "f588",
        "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $72947875341bbd79$export$ef222816a43a4b3a = {
    prefix: 'fas',
    iconName: 'grin-tongue',
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $72947875341bbd79$export$4edf34c3def09a31 = {
    prefix: 'fas',
    iconName: 'grin-tongue-squint',
    icon: [
        496,
        512,
        [],
        "f58a",
        "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
    ]
};
var $72947875341bbd79$export$58099903d50aefb3 = {
    prefix: 'fas',
    iconName: 'grin-tongue-wink',
    icon: [
        496,
        512,
        [],
        "f58b",
        "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $72947875341bbd79$export$2397fcd34eb12177 = {
    prefix: 'fas',
    iconName: 'grin-wink',
    icon: [
        496,
        512,
        [],
        "f58c",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
    ]
};
var $72947875341bbd79$export$4a45308d6c8decc1 = {
    prefix: 'fas',
    iconName: 'grip-horizontal',
    icon: [
        448,
        512,
        [],
        "f58d",
        "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$1412f35381064d7d = {
    prefix: 'fas',
    iconName: 'grip-lines',
    icon: [
        512,
        512,
        [],
        "f7a4",
        "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$523960de087f5198 = {
    prefix: 'fas',
    iconName: 'grip-lines-vertical',
    icon: [
        256,
        512,
        [],
        "f7a5",
        "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
    ]
};
var $72947875341bbd79$export$cacbd95c283996ec = {
    prefix: 'fas',
    iconName: 'grip-vertical',
    icon: [
        320,
        512,
        [],
        "f58e",
        "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$790dd5b32282b6fb = {
    prefix: 'fas',
    iconName: 'guitar',
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
    ]
};
var $72947875341bbd79$export$f08bbcf8f59eafc2 = {
    prefix: 'fas',
    iconName: 'h-square',
    icon: [
        448,
        512,
        [],
        "f0fd",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
    ]
};
var $72947875341bbd79$export$bab3bb9f4f59363 = {
    prefix: 'fas',
    iconName: 'hamburger',
    icon: [
        512,
        512,
        [],
        "f805",
        "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
    ]
};
var $72947875341bbd79$export$6310f315e1ebbca5 = {
    prefix: 'fas',
    iconName: 'hammer',
    icon: [
        576,
        512,
        [],
        "f6e3",
        "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
    ]
};
var $72947875341bbd79$export$38d20d399463edf9 = {
    prefix: 'fas',
    iconName: 'hamsa',
    icon: [
        512,
        512,
        [],
        "f665",
        "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$e6094d25274088ab = {
    prefix: 'fas',
    iconName: 'hand-holding',
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $72947875341bbd79$export$97e5ef3e80a0fbef = {
    prefix: 'fas',
    iconName: 'hand-holding-heart',
    icon: [
        576,
        512,
        [],
        "f4be",
        "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $72947875341bbd79$export$bb2a6b1b5e852300 = {
    prefix: 'fas',
    iconName: 'hand-holding-medical',
    icon: [
        576,
        512,
        [],
        "e05c",
        "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
    ]
};
var $72947875341bbd79$export$47d27bc305b59690 = {
    prefix: 'fas',
    iconName: 'hand-holding-usd',
    icon: [
        576,
        512,
        [],
        "f4c0",
        "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
    ]
};
var $72947875341bbd79$export$4265371b99d38b95 = {
    prefix: 'fas',
    iconName: 'hand-holding-water',
    icon: [
        576,
        512,
        [],
        "f4c1",
        "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $72947875341bbd79$export$54608d0a883fea4d = {
    prefix: 'fas',
    iconName: 'hand-lizard',
    icon: [
        576,
        512,
        [],
        "f258",
        "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
    ]
};
var $72947875341bbd79$export$bd40d3a3a16fb147 = {
    prefix: 'fas',
    iconName: 'hand-middle-finger',
    icon: [
        512,
        512,
        [],
        "f806",
        "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
    ]
};
var $72947875341bbd79$export$6e6216c8b50471bb = {
    prefix: 'fas',
    iconName: 'hand-paper',
    icon: [
        448,
        512,
        [],
        "f256",
        "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
    ]
};
var $72947875341bbd79$export$e49e3cfceea441cc = {
    prefix: 'fas',
    iconName: 'hand-peace',
    icon: [
        448,
        512,
        [],
        "f25b",
        "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
    ]
};
var $72947875341bbd79$export$f6dcbf0a940428f4 = {
    prefix: 'fas',
    iconName: 'hand-point-down',
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $72947875341bbd79$export$b276ec3dc9760d39 = {
    prefix: 'fas',
    iconName: 'hand-point-left',
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
    ]
};
var $72947875341bbd79$export$f7bc8714c970afa4 = {
    prefix: 'fas',
    iconName: 'hand-point-right',
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $72947875341bbd79$export$cdc9f5e7e94e76da = {
    prefix: 'fas',
    iconName: 'hand-point-up',
    icon: [
        384,
        512,
        [],
        "f0a6",
        "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
    ]
};
var $72947875341bbd79$export$d97ff927c450c87f = {
    prefix: 'fas',
    iconName: 'hand-pointer',
    icon: [
        448,
        512,
        [],
        "f25a",
        "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
    ]
};
var $72947875341bbd79$export$97a81eba394c8c44 = {
    prefix: 'fas',
    iconName: 'hand-rock',
    icon: [
        512,
        512,
        [],
        "f255",
        "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
    ]
};
var $72947875341bbd79$export$c578e919f2c5c135 = {
    prefix: 'fas',
    iconName: 'hand-scissors',
    icon: [
        512,
        512,
        [],
        "f257",
        "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
    ]
};
var $72947875341bbd79$export$72e2d874a963de0c = {
    prefix: 'fas',
    iconName: 'hand-sparkles',
    icon: [
        640,
        512,
        [],
        "e05d",
        "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
    ]
};
var $72947875341bbd79$export$2262d6b626de1120 = {
    prefix: 'fas',
    iconName: 'hand-spock',
    icon: [
        512,
        512,
        [],
        "f259",
        "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
    ]
};
var $72947875341bbd79$export$f9712d0cf5150f0c = {
    prefix: 'fas',
    iconName: 'hands',
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
    ]
};
var $72947875341bbd79$export$287dbb1632da0d44 = {
    prefix: 'fas',
    iconName: 'hands-helping',
    icon: [
        640,
        512,
        [],
        "f4c4",
        "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
    ]
};
var $72947875341bbd79$export$996b5dea53b124e3 = {
    prefix: 'fas',
    iconName: 'hands-wash',
    icon: [
        576,
        512,
        [],
        "e05e",
        "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
    ]
};
var $72947875341bbd79$export$b4c63e9bfc7906f1 = {
    prefix: 'fas',
    iconName: 'handshake',
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
    ]
};
var $72947875341bbd79$export$ca302f956ae9f1bf = {
    prefix: 'fas',
    iconName: 'handshake-alt-slash',
    icon: [
        640,
        512,
        [],
        "e05f",
        "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
    ]
};
var $72947875341bbd79$export$2cef3f81ad90fb76 = {
    prefix: 'fas',
    iconName: 'handshake-slash',
    icon: [
        640,
        512,
        [],
        "e060",
        "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
    ]
};
var $72947875341bbd79$export$3dcd4ca3f7108a82 = {
    prefix: 'fas',
    iconName: 'hanukiah',
    icon: [
        640,
        512,
        [],
        "f6e6",
        "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
    ]
};
var $72947875341bbd79$export$7b72177558a98b6f = {
    prefix: 'fas',
    iconName: 'hard-hat',
    icon: [
        512,
        512,
        [],
        "f807",
        "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$c92c903bade56844 = {
    prefix: 'fas',
    iconName: 'hashtag',
    icon: [
        448,
        512,
        [],
        "f292",
        "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
    ]
};
var $72947875341bbd79$export$37672611144b857b = {
    prefix: 'fas',
    iconName: 'hat-cowboy',
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
    ]
};
var $72947875341bbd79$export$ab6f71fd6878da90 = {
    prefix: 'fas',
    iconName: 'hat-cowboy-side',
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
    ]
};
var $72947875341bbd79$export$7daa48199dcb2ad1 = {
    prefix: 'fas',
    iconName: 'hat-wizard',
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
    ]
};
var $72947875341bbd79$export$62551e9c5ba7093f = {
    prefix: 'fas',
    iconName: 'hdd',
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $72947875341bbd79$export$3cd04b7c1624f598 = {
    prefix: 'fas',
    iconName: 'head-side-cough',
    icon: [
        640,
        512,
        [],
        "e061",
        "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
    ]
};
var $72947875341bbd79$export$b293ee8fb8e6b0c4 = {
    prefix: 'fas',
    iconName: 'head-side-cough-slash',
    icon: [
        640,
        512,
        [],
        "e062",
        "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
    ]
};
var $72947875341bbd79$export$280300af4baa1a3e = {
    prefix: 'fas',
    iconName: 'head-side-mask',
    icon: [
        512,
        512,
        [],
        "e063",
        "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
    ]
};
var $72947875341bbd79$export$5b64b916710da7c7 = {
    prefix: 'fas',
    iconName: 'head-side-virus',
    icon: [
        512,
        512,
        [],
        "e064",
        "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
    ]
};
var $72947875341bbd79$export$4805b8d175aeb9fb = {
    prefix: 'fas',
    iconName: 'heading',
    icon: [
        512,
        512,
        [],
        "f1dc",
        "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
    ]
};
var $72947875341bbd79$export$ad02dd8ca5816958 = {
    prefix: 'fas',
    iconName: 'headphones',
    icon: [
        512,
        512,
        [],
        "f025",
        "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
    ]
};
var $72947875341bbd79$export$6f0433fa527dd5be = {
    prefix: 'fas',
    iconName: 'headphones-alt',
    icon: [
        512,
        512,
        [],
        "f58f",
        "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
    ]
};
var $72947875341bbd79$export$23b086400a31acfe = {
    prefix: 'fas',
    iconName: 'headset',
    icon: [
        512,
        512,
        [],
        "f590",
        "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
    ]
};
var $72947875341bbd79$export$e4b51a47a2f8b9db = {
    prefix: 'fas',
    iconName: 'heart',
    icon: [
        512,
        512,
        [],
        "f004",
        "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
    ]
};
var $72947875341bbd79$export$4a565395cb65b282 = {
    prefix: 'fas',
    iconName: 'heart-broken',
    icon: [
        512,
        512,
        [],
        "f7a9",
        "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $72947875341bbd79$export$ca880e19206e80aa = {
    prefix: 'fas',
    iconName: 'heartbeat',
    icon: [
        512,
        512,
        [],
        "f21e",
        "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $72947875341bbd79$export$612d3e1afaf45fa5 = {
    prefix: 'fas',
    iconName: 'helicopter',
    icon: [
        640,
        512,
        [],
        "f533",
        "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
    ]
};
var $72947875341bbd79$export$73801ed54b42fabe = {
    prefix: 'fas',
    iconName: 'highlighter',
    icon: [
        544,
        512,
        [],
        "f591",
        "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
    ]
};
var $72947875341bbd79$export$b2ab0105a901499e = {
    prefix: 'fas',
    iconName: 'hiking',
    icon: [
        384,
        512,
        [],
        "f6ec",
        "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
    ]
};
var $72947875341bbd79$export$d4c909619093de2d = {
    prefix: 'fas',
    iconName: 'hippo',
    icon: [
        640,
        512,
        [],
        "f6ed",
        "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $72947875341bbd79$export$76d1986559ca7b7a = {
    prefix: 'fas',
    iconName: 'history',
    icon: [
        512,
        512,
        [],
        "f1da",
        "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
    ]
};
var $72947875341bbd79$export$a274b02dc75663dc = {
    prefix: 'fas',
    iconName: 'hockey-puck',
    icon: [
        512,
        512,
        [],
        "f453",
        "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
    ]
};
var $72947875341bbd79$export$273296afacf93991 = {
    prefix: 'fas',
    iconName: 'holly-berry',
    icon: [
        448,
        512,
        [],
        "f7aa",
        "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
    ]
};
var $72947875341bbd79$export$48f10d71ec526479 = {
    prefix: 'fas',
    iconName: 'home',
    icon: [
        576,
        512,
        [],
        "f015",
        "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    ]
};
var $72947875341bbd79$export$5b05f097fa38352a = {
    prefix: 'fas',
    iconName: 'horse',
    icon: [
        576,
        512,
        [],
        "f6f0",
        "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $72947875341bbd79$export$5bcca85203ebd1e8 = {
    prefix: 'fas',
    iconName: 'horse-head',
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
    ]
};
var $72947875341bbd79$export$7a76c9d35b42d691 = {
    prefix: 'fas',
    iconName: 'hospital',
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
    ]
};
var $72947875341bbd79$export$cea7736417b94a3b = {
    prefix: 'fas',
    iconName: 'hospital-alt',
    icon: [
        576,
        512,
        [],
        "f47d",
        "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $72947875341bbd79$export$c8a3c78d99c23fed = {
    prefix: 'fas',
    iconName: 'hospital-symbol',
    icon: [
        512,
        512,
        [],
        "f47e",
        "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
    ]
};
var $72947875341bbd79$export$684703c93d630cc5 = {
    prefix: 'fas',
    iconName: 'hospital-user',
    icon: [
        640,
        512,
        [],
        "f80d",
        "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
    ]
};
var $72947875341bbd79$export$4842af92b516c40b = {
    prefix: 'fas',
    iconName: 'hot-tub',
    icon: [
        512,
        512,
        [],
        "f593",
        "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
    ]
};
var $72947875341bbd79$export$9fae219b4d3ce0be = {
    prefix: 'fas',
    iconName: 'hotdog',
    icon: [
        512,
        512,
        [],
        "f80f",
        "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
    ]
};
var $72947875341bbd79$export$c402efcf01d5ca07 = {
    prefix: 'fas',
    iconName: 'hotel',
    icon: [
        576,
        512,
        [],
        "f594",
        "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $72947875341bbd79$export$b9098a890f61e022 = {
    prefix: 'fas',
    iconName: 'hourglass',
    icon: [
        384,
        512,
        [],
        "f254",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    ]
};
var $72947875341bbd79$export$52757ecc5b1e25b9 = {
    prefix: 'fas',
    iconName: 'hourglass-end',
    icon: [
        384,
        512,
        [],
        "f253",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    ]
};
var $72947875341bbd79$export$703272eebf5e3eea = {
    prefix: 'fas',
    iconName: 'hourglass-half',
    icon: [
        384,
        512,
        [],
        "f252",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
    ]
};
var $72947875341bbd79$export$f0c28584caa8f4b = {
    prefix: 'fas',
    iconName: 'hourglass-start',
    icon: [
        384,
        512,
        [],
        "f251",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
    ]
};
var $72947875341bbd79$export$8d7e943005ce0b49 = {
    prefix: 'fas',
    iconName: 'house-damage',
    icon: [
        576,
        512,
        [],
        "f6f1",
        "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
    ]
};
var $72947875341bbd79$export$9a513ee921e8e885 = {
    prefix: 'fas',
    iconName: 'house-user',
    icon: [
        576,
        512,
        [],
        "e065",
        "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
    ]
};
var $72947875341bbd79$export$33d5f94bd6f75f59 = {
    prefix: 'fas',
    iconName: 'hryvnia',
    icon: [
        384,
        512,
        [],
        "f6f2",
        "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
    ]
};
var $72947875341bbd79$export$7fddf76ec23943d8 = {
    prefix: 'fas',
    iconName: 'i-cursor',
    icon: [
        256,
        512,
        [],
        "f246",
        "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
    ]
};
var $72947875341bbd79$export$dd52741c60cc638f = {
    prefix: 'fas',
    iconName: 'ice-cream',
    icon: [
        448,
        512,
        [],
        "f810",
        "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
    ]
};
var $72947875341bbd79$export$78792ed87d92a3ad = {
    prefix: 'fas',
    iconName: 'icicles',
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
    ]
};
var $72947875341bbd79$export$7fe2894454d8eb8a = {
    prefix: 'fas',
    iconName: 'icons',
    icon: [
        512,
        512,
        [],
        "f86d",
        "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
    ]
};
var $72947875341bbd79$export$a75288855ea05282 = {
    prefix: 'fas',
    iconName: 'id-badge',
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $72947875341bbd79$export$782ac893fc22249b = {
    prefix: 'fas',
    iconName: 'id-card',
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
    ]
};
var $72947875341bbd79$export$dc37ebbac31f6c6c = {
    prefix: 'fas',
    iconName: 'id-card-alt',
    icon: [
        576,
        512,
        [],
        "f47f",
        "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
    ]
};
var $72947875341bbd79$export$4a284575edd6f1af = {
    prefix: 'fas',
    iconName: 'igloo',
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
    ]
};
var $72947875341bbd79$export$7e9f0928967e03b = {
    prefix: 'fas',
    iconName: 'image',
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    ]
};
var $72947875341bbd79$export$74f06b41ed2ca28a = {
    prefix: 'fas',
    iconName: 'images',
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    ]
};
var $72947875341bbd79$export$366b69cbdce46334 = {
    prefix: 'fas',
    iconName: 'inbox',
    icon: [
        576,
        512,
        [],
        "f01c",
        "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
    ]
};
var $72947875341bbd79$export$318208bc30aeebcc = {
    prefix: 'fas',
    iconName: 'indent',
    icon: [
        448,
        512,
        [],
        "f03c",
        "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$5548c3eb51060fa8 = {
    prefix: 'fas',
    iconName: 'industry',
    icon: [
        512,
        512,
        [],
        "f275",
        "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
    ]
};
var $72947875341bbd79$export$a590003279d671b8 = {
    prefix: 'fas',
    iconName: 'infinity',
    icon: [
        640,
        512,
        [],
        "f534",
        "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
    ]
};
var $72947875341bbd79$export$d469b770895f47ac = {
    prefix: 'fas',
    iconName: 'info',
    icon: [
        192,
        512,
        [],
        "f129",
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    ]
};
var $72947875341bbd79$export$aa9288aeadf882fa = {
    prefix: 'fas',
    iconName: 'info-circle',
    icon: [
        512,
        512,
        [],
        "f05a",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    ]
};
var $72947875341bbd79$export$16e344bae4d495ed = {
    prefix: 'fas',
    iconName: 'italic',
    icon: [
        320,
        512,
        [],
        "f033",
        "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
    ]
};
var $72947875341bbd79$export$859f204e59641ca4 = {
    prefix: 'fas',
    iconName: 'jedi',
    icon: [
        576,
        512,
        [],
        "f669",
        "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
    ]
};
var $72947875341bbd79$export$e5a289fb22ffb8cb = {
    prefix: 'fas',
    iconName: 'joint',
    icon: [
        640,
        512,
        [],
        "f595",
        "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
    ]
};
var $72947875341bbd79$export$66a0d8d45aab6631 = {
    prefix: 'fas',
    iconName: 'journal-whills',
    icon: [
        448,
        512,
        [],
        "f66a",
        "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
    ]
};
var $72947875341bbd79$export$ab1408bfbe914cc9 = {
    prefix: 'fas',
    iconName: 'kaaba',
    icon: [
        576,
        512,
        [],
        "f66b",
        "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
    ]
};
var $72947875341bbd79$export$fa6ecc35e7315db = {
    prefix: 'fas',
    iconName: 'key',
    icon: [
        512,
        512,
        [],
        "f084",
        "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
    ]
};
var $72947875341bbd79$export$fb61df5d98785fa8 = {
    prefix: 'fas',
    iconName: 'keyboard',
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $72947875341bbd79$export$8d41d1f1ba3f9217 = {
    prefix: 'fas',
    iconName: 'khanda',
    icon: [
        512,
        512,
        [],
        "f66d",
        "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
    ]
};
var $72947875341bbd79$export$c762a77aabf64fd0 = {
    prefix: 'fas',
    iconName: 'kiss',
    icon: [
        496,
        512,
        [],
        "f596",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$d6ff8a73c0812e63 = {
    prefix: 'fas',
    iconName: 'kiss-beam',
    icon: [
        496,
        512,
        [],
        "f597",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
    ]
};
var $72947875341bbd79$export$ebba617701dfb917 = {
    prefix: 'fas',
    iconName: 'kiss-wink-heart',
    icon: [
        504,
        512,
        [],
        "f598",
        "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
    ]
};
var $72947875341bbd79$export$d9933d91e1314d02 = {
    prefix: 'fas',
    iconName: 'kiwi-bird',
    icon: [
        576,
        512,
        [],
        "f535",
        "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
    ]
};
var $72947875341bbd79$export$2bebc54c51db6505 = {
    prefix: 'fas',
    iconName: 'landmark',
    icon: [
        512,
        512,
        [],
        "f66f",
        "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$8a7bee49fdf8c954 = {
    prefix: 'fas',
    iconName: 'language',
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
    ]
};
var $72947875341bbd79$export$c2dee3bd177275a2 = {
    prefix: 'fas',
    iconName: 'laptop',
    icon: [
        640,
        512,
        [],
        "f109",
        "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $72947875341bbd79$export$94100f4c6ee29932 = {
    prefix: 'fas',
    iconName: 'laptop-code',
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $72947875341bbd79$export$efd983de5e4d6ad3 = {
    prefix: 'fas',
    iconName: 'laptop-house',
    icon: [
        640,
        512,
        [],
        "e066",
        "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
    ]
};
var $72947875341bbd79$export$ba2fa38f7bcc6930 = {
    prefix: 'fas',
    iconName: 'laptop-medical',
    icon: [
        640,
        512,
        [],
        "f812",
        "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$6c74e314e801a4fe = {
    prefix: 'fas',
    iconName: 'laugh',
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
    ]
};
var $72947875341bbd79$export$a88d1f4073ea9369 = {
    prefix: 'fas',
    iconName: 'laugh-beam',
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $72947875341bbd79$export$b206e700cf7084e1 = {
    prefix: 'fas',
    iconName: 'laugh-squint',
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $72947875341bbd79$export$77ac40095f39933e = {
    prefix: 'fas',
    iconName: 'laugh-wink',
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $72947875341bbd79$export$a137712e11e257dd = {
    prefix: 'fas',
    iconName: 'layer-group',
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
    ]
};
var $72947875341bbd79$export$7c497bae2754a087 = {
    prefix: 'fas',
    iconName: 'leaf',
    icon: [
        576,
        512,
        [],
        "f06c",
        "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
    ]
};
var $72947875341bbd79$export$4fbda8f64648f3b5 = {
    prefix: 'fas',
    iconName: 'lemon',
    icon: [
        512,
        512,
        [],
        "f094",
        "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
    ]
};
var $72947875341bbd79$export$7f24f1bf98af5411 = {
    prefix: 'fas',
    iconName: 'less-than',
    icon: [
        384,
        512,
        [],
        "f536",
        "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
    ]
};
var $72947875341bbd79$export$b2c723344cff0d8 = {
    prefix: 'fas',
    iconName: 'less-than-equal',
    icon: [
        448,
        512,
        [],
        "f537",
        "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $72947875341bbd79$export$c07eb6ff5a382cbd = {
    prefix: 'fas',
    iconName: 'level-down-alt',
    icon: [
        320,
        512,
        [],
        "f3be",
        "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
    ]
};
var $72947875341bbd79$export$d6f21a309b179c3d = {
    prefix: 'fas',
    iconName: 'level-up-alt',
    icon: [
        320,
        512,
        [],
        "f3bf",
        "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
    ]
};
var $72947875341bbd79$export$53dd2cacf674142a = {
    prefix: 'fas',
    iconName: 'life-ring',
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
    ]
};
var $72947875341bbd79$export$1e80f89fe84a215b = {
    prefix: 'fas',
    iconName: 'lightbulb',
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $72947875341bbd79$export$88bc01ff8dbecc55 = {
    prefix: 'fas',
    iconName: 'link',
    icon: [
        512,
        512,
        [],
        "f0c1",
        "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    ]
};
var $72947875341bbd79$export$f0f37dbc60110b10 = {
    prefix: 'fas',
    iconName: 'lira-sign',
    icon: [
        384,
        512,
        [],
        "f195",
        "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
    ]
};
var $72947875341bbd79$export$6cfc59842fedbc16 = {
    prefix: 'fas',
    iconName: 'list',
    icon: [
        512,
        512,
        [],
        "f03a",
        "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$c6327a203ffc65a3 = {
    prefix: 'fas',
    iconName: 'list-alt',
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
    ]
};
var $72947875341bbd79$export$3db8f67cd0fc963b = {
    prefix: 'fas',
    iconName: 'list-ol',
    icon: [
        512,
        512,
        [],
        "f0cb",
        "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
    ]
};
var $72947875341bbd79$export$f8a219cf4f516384 = {
    prefix: 'fas',
    iconName: 'list-ul',
    icon: [
        512,
        512,
        [],
        "f0ca",
        "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$4ac9c4c370f7b157 = {
    prefix: 'fas',
    iconName: 'location-arrow',
    icon: [
        512,
        512,
        [],
        "f124",
        "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    ]
};
var $72947875341bbd79$export$7aa08ad5d562578a = {
    prefix: 'fas',
    iconName: 'lock',
    icon: [
        448,
        512,
        [],
        "f023",
        "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    ]
};
var $72947875341bbd79$export$84b5acad4436d02a = {
    prefix: 'fas',
    iconName: 'lock-open',
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    ]
};
var $72947875341bbd79$export$8b92530ca6418c2f = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-down',
    icon: [
        256,
        512,
        [],
        "f309",
        "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
    ]
};
var $72947875341bbd79$export$a8b3226b2bf323d = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-left',
    icon: [
        448,
        512,
        [],
        "f30a",
        "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
    ]
};
var $72947875341bbd79$export$533e1f578f74c066 = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-right',
    icon: [
        448,
        512,
        [],
        "f30b",
        "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
    ]
};
var $72947875341bbd79$export$43c8f2a46326c55f = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-up',
    icon: [
        256,
        512,
        [],
        "f30c",
        "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
    ]
};
var $72947875341bbd79$export$7a65d2aa54cb4e93 = {
    prefix: 'fas',
    iconName: 'low-vision',
    icon: [
        576,
        512,
        [],
        "f2a8",
        "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
    ]
};
var $72947875341bbd79$export$bd1e24dd3cde8514 = {
    prefix: 'fas',
    iconName: 'luggage-cart',
    icon: [
        640,
        512,
        [],
        "f59d",
        "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
    ]
};
var $72947875341bbd79$export$ba9b387e84727819 = {
    prefix: 'fas',
    iconName: 'lungs',
    icon: [
        640,
        512,
        [],
        "f604",
        "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
    ]
};
var $72947875341bbd79$export$895159d10626af74 = {
    prefix: 'fas',
    iconName: 'lungs-virus',
    icon: [
        640,
        512,
        [],
        "e067",
        "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
    ]
};
var $72947875341bbd79$export$e58f9b502d4dd52d = {
    prefix: 'fas',
    iconName: 'magic',
    icon: [
        512,
        512,
        [],
        "f0d0",
        "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
    ]
};
var $72947875341bbd79$export$78932e9c9abea6b7 = {
    prefix: 'fas',
    iconName: 'magnet',
    icon: [
        512,
        512,
        [],
        "f076",
        "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
    ]
};
var $72947875341bbd79$export$dd24f40c5337e2e1 = {
    prefix: 'fas',
    iconName: 'mail-bulk',
    icon: [
        576,
        512,
        [],
        "f674",
        "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
    ]
};
var $72947875341bbd79$export$2e21f9dba1630651 = {
    prefix: 'fas',
    iconName: 'male',
    icon: [
        192,
        512,
        [],
        "f183",
        "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
    ]
};
var $72947875341bbd79$export$fc82fb79180cd17c = {
    prefix: 'fas',
    iconName: 'map',
    icon: [
        576,
        512,
        [],
        "f279",
        "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $72947875341bbd79$export$df04458e7e32352c = {
    prefix: 'fas',
    iconName: 'map-marked',
    icon: [
        576,
        512,
        [],
        "f59f",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $72947875341bbd79$export$a977d47c74d8e86c = {
    prefix: 'fas',
    iconName: 'map-marked-alt',
    icon: [
        576,
        512,
        [],
        "f5a0",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $72947875341bbd79$export$10d360e4f1a554dd = {
    prefix: 'fas',
    iconName: 'map-marker',
    icon: [
        384,
        512,
        [],
        "f041",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
    ]
};
var $72947875341bbd79$export$4be92fa780613f93 = {
    prefix: 'fas',
    iconName: 'map-marker-alt',
    icon: [
        384,
        512,
        [],
        "f3c5",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ]
};
var $72947875341bbd79$export$184725965b3402dc = {
    prefix: 'fas',
    iconName: 'map-pin',
    icon: [
        288,
        512,
        [],
        "f276",
        "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
    ]
};
var $72947875341bbd79$export$743f4b1071b3333a = {
    prefix: 'fas',
    iconName: 'map-signs',
    icon: [
        512,
        512,
        [],
        "f277",
        "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
    ]
};
var $72947875341bbd79$export$e6789173649caa25 = {
    prefix: 'fas',
    iconName: 'marker',
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
    ]
};
var $72947875341bbd79$export$a9f5c0b9c1e77a6f = {
    prefix: 'fas',
    iconName: 'mars',
    icon: [
        384,
        512,
        [],
        "f222",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$2f8a28204bb4b86f = {
    prefix: 'fas',
    iconName: 'mars-double',
    icon: [
        512,
        512,
        [],
        "f227",
        "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
    ]
};
var $72947875341bbd79$export$aa05fce255a5d269 = {
    prefix: 'fas',
    iconName: 'mars-stroke',
    icon: [
        384,
        512,
        [],
        "f229",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$5cb0daeafbcdabe3 = {
    prefix: 'fas',
    iconName: 'mars-stroke-h',
    icon: [
        480,
        512,
        [],
        "f22b",
        "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $72947875341bbd79$export$ed7aa1c25104f333 = {
    prefix: 'fas',
    iconName: 'mars-stroke-v',
    icon: [
        288,
        512,
        [],
        "f22a",
        "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $72947875341bbd79$export$7b028758c03b9655 = {
    prefix: 'fas',
    iconName: 'mask',
    icon: [
        640,
        512,
        [],
        "f6fa",
        "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
    ]
};
var $72947875341bbd79$export$b48a5be96314835a = {
    prefix: 'fas',
    iconName: 'medal',
    icon: [
        512,
        512,
        [],
        "f5a2",
        "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
    ]
};
var $72947875341bbd79$export$e75f02bae5b7d34b = {
    prefix: 'fas',
    iconName: 'medkit',
    icon: [
        512,
        512,
        [],
        "f0fa",
        "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
    ]
};
var $72947875341bbd79$export$6d2db489aaeeecd2 = {
    prefix: 'fas',
    iconName: 'meh',
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$e945435725f71e88 = {
    prefix: 'fas',
    iconName: 'meh-blank',
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$fdc62a1bea767cc2 = {
    prefix: 'fas',
    iconName: 'meh-rolling-eyes',
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
    ]
};
var $72947875341bbd79$export$5f9bd9f6df021f93 = {
    prefix: 'fas',
    iconName: 'memory',
    icon: [
        640,
        512,
        [],
        "f538",
        "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
    ]
};
var $72947875341bbd79$export$232452c59d77c56e = {
    prefix: 'fas',
    iconName: 'menorah',
    icon: [
        640,
        512,
        [],
        "f676",
        "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
    ]
};
var $72947875341bbd79$export$e134ecd00b622a47 = {
    prefix: 'fas',
    iconName: 'mercury',
    icon: [
        288,
        512,
        [],
        "f223",
        "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $72947875341bbd79$export$1439f0d6365138da = {
    prefix: 'fas',
    iconName: 'meteor',
    icon: [
        512,
        512,
        [],
        "f753",
        "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
    ]
};
var $72947875341bbd79$export$4a7bb4be15f35178 = {
    prefix: 'fas',
    iconName: 'microchip',
    icon: [
        512,
        512,
        [],
        "f2db",
        "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
    ]
};
var $72947875341bbd79$export$eed3c491effe6d12 = {
    prefix: 'fas',
    iconName: 'microphone',
    icon: [
        352,
        512,
        [],
        "f130",
        "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$f08ef94fea14f5ac = {
    prefix: 'fas',
    iconName: 'microphone-alt',
    icon: [
        352,
        512,
        [],
        "f3c9",
        "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
    ]
};
var $72947875341bbd79$export$d2a53a388f30780 = {
    prefix: 'fas',
    iconName: 'microphone-alt-slash',
    icon: [
        640,
        512,
        [],
        "f539",
        "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$843f63d64e6f7951 = {
    prefix: 'fas',
    iconName: 'microphone-slash',
    icon: [
        640,
        512,
        [],
        "f131",
        "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$6a99139787bf9967 = {
    prefix: 'fas',
    iconName: 'microscope',
    icon: [
        512,
        512,
        [],
        "f610",
        "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
    ]
};
var $72947875341bbd79$export$fee0376c250cdef = {
    prefix: 'fas',
    iconName: 'minus',
    icon: [
        448,
        512,
        [],
        "f068",
        "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$f3979b49bf57313c = {
    prefix: 'fas',
    iconName: 'minus-circle',
    icon: [
        512,
        512,
        [],
        "f056",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
    ]
};
var $72947875341bbd79$export$ffe9387966b3e681 = {
    prefix: 'fas',
    iconName: 'minus-square',
    icon: [
        448,
        512,
        [],
        "f146",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
    ]
};
var $72947875341bbd79$export$5030322c5fc886d7 = {
    prefix: 'fas',
    iconName: 'mitten',
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
    ]
};
var $72947875341bbd79$export$59edacfad04cd121 = {
    prefix: 'fas',
    iconName: 'mobile',
    icon: [
        320,
        512,
        [],
        "f10b",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$e9599bc6cd92234d = {
    prefix: 'fas',
    iconName: 'mobile-alt',
    icon: [
        320,
        512,
        [],
        "f3cd",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
    ]
};
var $72947875341bbd79$export$608138a7337b5d1a = {
    prefix: 'fas',
    iconName: 'money-bill',
    icon: [
        640,
        512,
        [],
        "f0d6",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $72947875341bbd79$export$a35d573395884c3d = {
    prefix: 'fas',
    iconName: 'money-bill-alt',
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $72947875341bbd79$export$53e23123cc9a6796 = {
    prefix: 'fas',
    iconName: 'money-bill-wave',
    icon: [
        640,
        512,
        [],
        "f53a",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
    ]
};
var $72947875341bbd79$export$1613858e873cbb3e = {
    prefix: 'fas',
    iconName: 'money-bill-wave-alt',
    icon: [
        640,
        512,
        [],
        "f53b",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
    ]
};
var $72947875341bbd79$export$be069f641c85d0b3 = {
    prefix: 'fas',
    iconName: 'money-check',
    icon: [
        640,
        512,
        [],
        "f53c",
        "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$8c6ccc9745897cb2 = {
    prefix: 'fas',
    iconName: 'money-check-alt',
    icon: [
        640,
        512,
        [],
        "f53d",
        "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
    ]
};
var $72947875341bbd79$export$6f9b0bfc012deb25 = {
    prefix: 'fas',
    iconName: 'monument',
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $72947875341bbd79$export$c4c2f69a53bab720 = {
    prefix: 'fas',
    iconName: 'moon',
    icon: [
        512,
        512,
        [],
        "f186",
        "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    ]
};
var $72947875341bbd79$export$55ceb5d0c144580a = {
    prefix: 'fas',
    iconName: 'mortar-pestle',
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$4999586d7e1087fb = {
    prefix: 'fas',
    iconName: 'mosque',
    icon: [
        640,
        512,
        [],
        "f678",
        "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
    ]
};
var $72947875341bbd79$export$f26017bdca99338d = {
    prefix: 'fas',
    iconName: 'motorcycle',
    icon: [
        640,
        512,
        [],
        "f21c",
        "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
    ]
};
var $72947875341bbd79$export$64f9eb99c9749cce = {
    prefix: 'fas',
    iconName: 'mountain',
    icon: [
        640,
        512,
        [],
        "f6fc",
        "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
    ]
};
var $72947875341bbd79$export$198b96b894c66074 = {
    prefix: 'fas',
    iconName: 'mouse',
    icon: [
        384,
        512,
        [],
        "f8cc",
        "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
    ]
};
var $72947875341bbd79$export$2e19a69cc26b147 = {
    prefix: 'fas',
    iconName: 'mouse-pointer',
    icon: [
        320,
        512,
        [],
        "f245",
        "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
    ]
};
var $72947875341bbd79$export$47a822c30184e8af = {
    prefix: 'fas',
    iconName: 'mug-hot',
    icon: [
        512,
        512,
        [],
        "f7b6",
        "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $72947875341bbd79$export$fcb0647a5340b5b8 = {
    prefix: 'fas',
    iconName: 'music',
    icon: [
        512,
        512,
        [],
        "f001",
        "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
    ]
};
var $72947875341bbd79$export$882cabd11f4943b8 = {
    prefix: 'fas',
    iconName: 'network-wired',
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
    ]
};
var $72947875341bbd79$export$771cf879fba0cf93 = {
    prefix: 'fas',
    iconName: 'neuter',
    icon: [
        288,
        512,
        [],
        "f22c",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$d91b374112d4f8c1 = {
    prefix: 'fas',
    iconName: 'newspaper',
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
    ]
};
var $72947875341bbd79$export$6a15ccae09bbaf93 = {
    prefix: 'fas',
    iconName: 'not-equal',
    icon: [
        448,
        512,
        [],
        "f53e",
        "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
    ]
};
var $72947875341bbd79$export$b2d79133c81d6697 = {
    prefix: 'fas',
    iconName: 'notes-medical',
    icon: [
        384,
        512,
        [],
        "f481",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
    ]
};
var $72947875341bbd79$export$40cdac24aa94a57a = {
    prefix: 'fas',
    iconName: 'object-group',
    icon: [
        512,
        512,
        [],
        "f247",
        "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
    ]
};
var $72947875341bbd79$export$887f6345573abcac = {
    prefix: 'fas',
    iconName: 'object-ungroup',
    icon: [
        576,
        512,
        [],
        "f248",
        "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
    ]
};
var $72947875341bbd79$export$2599126c3a57f727 = {
    prefix: 'fas',
    iconName: 'oil-can',
    icon: [
        640,
        512,
        [],
        "f613",
        "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
    ]
};
var $72947875341bbd79$export$8de8eb94230028a5 = {
    prefix: 'fas',
    iconName: 'om',
    icon: [
        512,
        512,
        [],
        "f679",
        "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
    ]
};
var $72947875341bbd79$export$743cce3ca4eb1d7d = {
    prefix: 'fas',
    iconName: 'otter',
    icon: [
        640,
        512,
        [],
        "f700",
        "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
    ]
};
var $72947875341bbd79$export$e21cfc4f23776bff = {
    prefix: 'fas',
    iconName: 'outdent',
    icon: [
        448,
        512,
        [],
        "f03b",
        "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$e1611f373a10a98c = {
    prefix: 'fas',
    iconName: 'pager',
    icon: [
        512,
        512,
        [],
        "f815",
        "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
    ]
};
var $72947875341bbd79$export$594db3339e212bc9 = {
    prefix: 'fas',
    iconName: 'paint-brush',
    icon: [
        512,
        512,
        [],
        "f1fc",
        "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
    ]
};
var $72947875341bbd79$export$d1de8d1b815d6a5 = {
    prefix: 'fas',
    iconName: 'paint-roller',
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
    ]
};
var $72947875341bbd79$export$5c390baea5db4f77 = {
    prefix: 'fas',
    iconName: 'palette',
    icon: [
        512,
        512,
        [],
        "f53f",
        "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$d7ff2047dbc34562 = {
    prefix: 'fas',
    iconName: 'pallet',
    icon: [
        640,
        512,
        [],
        "f482",
        "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
    ]
};
var $72947875341bbd79$export$b5378818301da1be = {
    prefix: 'fas',
    iconName: 'paper-plane',
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    ]
};
var $72947875341bbd79$export$4b24ca1552f410af = {
    prefix: 'fas',
    iconName: 'paperclip',
    icon: [
        448,
        512,
        [],
        "f0c6",
        "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    ]
};
var $72947875341bbd79$export$ca9e3368f1d9500a = {
    prefix: 'fas',
    iconName: 'parachute-box',
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
    ]
};
var $72947875341bbd79$export$dec46f8df1860e0 = {
    prefix: 'fas',
    iconName: 'paragraph',
    icon: [
        448,
        512,
        [],
        "f1dd",
        "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
    ]
};
var $72947875341bbd79$export$fda29c8f99573a4e = {
    prefix: 'fas',
    iconName: 'parking',
    icon: [
        448,
        512,
        [],
        "f540",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ]
};
var $72947875341bbd79$export$2c31ca0d9bee400f = {
    prefix: 'fas',
    iconName: 'passport',
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
    ]
};
var $72947875341bbd79$export$733efdaec97447be = {
    prefix: 'fas',
    iconName: 'pastafarianism',
    icon: [
        640,
        512,
        [],
        "f67b",
        "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
    ]
};
var $72947875341bbd79$export$6f95f90dd1f6d86b = {
    prefix: 'fas',
    iconName: 'paste',
    icon: [
        448,
        512,
        [],
        "f0ea",
        "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
    ]
};
var $72947875341bbd79$export$da79f048408b1722 = {
    prefix: 'fas',
    iconName: 'pause',
    icon: [
        448,
        512,
        [],
        "f04c",
        "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    ]
};
var $72947875341bbd79$export$d8cf08a0362da8db = {
    prefix: 'fas',
    iconName: 'pause-circle',
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
    ]
};
var $72947875341bbd79$export$7bc6e4d977673e69 = {
    prefix: 'fas',
    iconName: 'paw',
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
    ]
};
var $72947875341bbd79$export$8614cb1326eacd7a = {
    prefix: 'fas',
    iconName: 'peace',
    icon: [
        496,
        512,
        [],
        "f67c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
    ]
};
var $72947875341bbd79$export$8f4567331fb0d3bc = {
    prefix: 'fas',
    iconName: 'pen',
    icon: [
        512,
        512,
        [],
        "f304",
        "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    ]
};
var $72947875341bbd79$export$a3d3e92e430d3beb = {
    prefix: 'fas',
    iconName: 'pen-alt',
    icon: [
        512,
        512,
        [],
        "f305",
        "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
    ]
};
var $72947875341bbd79$export$8bdfe14ac72a8b17 = {
    prefix: 'fas',
    iconName: 'pen-fancy',
    icon: [
        512,
        512,
        [],
        "f5ac",
        "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
    ]
};
var $72947875341bbd79$export$a82594dcc75a49f5 = {
    prefix: 'fas',
    iconName: 'pen-nib',
    icon: [
        512,
        512,
        [],
        "f5ad",
        "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
    ]
};
var $72947875341bbd79$export$fbb231ccb3d960bc = {
    prefix: 'fas',
    iconName: 'pen-square',
    icon: [
        448,
        512,
        [],
        "f14b",
        "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
    ]
};
var $72947875341bbd79$export$8210adc172262df = {
    prefix: 'fas',
    iconName: 'pencil-alt',
    icon: [
        512,
        512,
        [],
        "f303",
        "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ]
};
var $72947875341bbd79$export$e3a7a1affea005f5 = {
    prefix: 'fas',
    iconName: 'pencil-ruler',
    icon: [
        512,
        512,
        [],
        "f5ae",
        "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
    ]
};
var $72947875341bbd79$export$804bfc5c390e1a2a = {
    prefix: 'fas',
    iconName: 'people-arrows',
    icon: [
        576,
        512,
        [],
        "e068",
        "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
    ]
};
var $72947875341bbd79$export$35fbd4ff1265acd5 = {
    prefix: 'fas',
    iconName: 'people-carry',
    icon: [
        640,
        512,
        [],
        "f4ce",
        "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
    ]
};
var $72947875341bbd79$export$4894bf28f771e1f3 = {
    prefix: 'fas',
    iconName: 'pepper-hot',
    icon: [
        512,
        512,
        [],
        "f816",
        "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
    ]
};
var $72947875341bbd79$export$89a1764fbb7ad2cb = {
    prefix: 'fas',
    iconName: 'percent',
    icon: [
        448,
        512,
        [],
        "f295",
        "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
    ]
};
var $72947875341bbd79$export$89333857fc063a2e = {
    prefix: 'fas',
    iconName: 'percentage',
    icon: [
        384,
        512,
        [],
        "f541",
        "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
    ]
};
var $72947875341bbd79$export$2337c975289bdd84 = {
    prefix: 'fas',
    iconName: 'person-booth',
    icon: [
        576,
        512,
        [],
        "f756",
        "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
    ]
};
var $72947875341bbd79$export$ddab067855cf34cb = {
    prefix: 'fas',
    iconName: 'phone',
    icon: [
        512,
        512,
        [],
        "f095",
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ]
};
var $72947875341bbd79$export$a07a9b305deebf32 = {
    prefix: 'fas',
    iconName: 'phone-alt',
    icon: [
        512,
        512,
        [],
        "f879",
        "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
    ]
};
var $72947875341bbd79$export$4c60a3aade08b6c2 = {
    prefix: 'fas',
    iconName: 'phone-slash',
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $72947875341bbd79$export$8ba22605a641ebdf = {
    prefix: 'fas',
    iconName: 'phone-square',
    icon: [
        448,
        512,
        [],
        "f098",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
    ]
};
var $72947875341bbd79$export$a41e77f0de98bba7 = {
    prefix: 'fas',
    iconName: 'phone-square-alt',
    icon: [
        448,
        512,
        [],
        "f87b",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
    ]
};
var $72947875341bbd79$export$c377f240bb8b5d74 = {
    prefix: 'fas',
    iconName: 'phone-volume',
    icon: [
        384,
        512,
        [],
        "f2a0",
        "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
    ]
};
var $72947875341bbd79$export$739f6a6a12dfb6ed = {
    prefix: 'fas',
    iconName: 'photo-video',
    icon: [
        640,
        512,
        [],
        "f87c",
        "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    ]
};
var $72947875341bbd79$export$46d49a6734c4872a = {
    prefix: 'fas',
    iconName: 'piggy-bank',
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
    ]
};
var $72947875341bbd79$export$6380e2ed6e69d350 = {
    prefix: 'fas',
    iconName: 'pills',
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
    ]
};
var $72947875341bbd79$export$c9f93c4667edc585 = {
    prefix: 'fas',
    iconName: 'pizza-slice',
    icon: [
        512,
        512,
        [],
        "f818",
        "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $72947875341bbd79$export$c5a9302c8c13c79a = {
    prefix: 'fas',
    iconName: 'place-of-worship',
    icon: [
        640,
        512,
        [],
        "f67f",
        "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
    ]
};
var $72947875341bbd79$export$f654c69e66b466c0 = {
    prefix: 'fas',
    iconName: 'plane',
    icon: [
        576,
        512,
        [],
        "f072",
        "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
    ]
};
var $72947875341bbd79$export$9b2dbe133273f284 = {
    prefix: 'fas',
    iconName: 'plane-arrival',
    icon: [
        640,
        512,
        [],
        "f5af",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
    ]
};
var $72947875341bbd79$export$6ccbeeccfea6dc8a = {
    prefix: 'fas',
    iconName: 'plane-departure',
    icon: [
        640,
        512,
        [],
        "f5b0",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
    ]
};
var $72947875341bbd79$export$cfee4df0d5df6d21 = {
    prefix: 'fas',
    iconName: 'plane-slash',
    icon: [
        640,
        512,
        [],
        "e069",
        "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
    ]
};
var $72947875341bbd79$export$436587205947bca5 = {
    prefix: 'fas',
    iconName: 'play',
    icon: [
        448,
        512,
        [],
        "f04b",
        "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    ]
};
var $72947875341bbd79$export$cf04333781061c5e = {
    prefix: 'fas',
    iconName: 'play-circle',
    icon: [
        512,
        512,
        [],
        "f144",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
    ]
};
var $72947875341bbd79$export$cae5752c3e3b6545 = {
    prefix: 'fas',
    iconName: 'plug',
    icon: [
        384,
        512,
        [],
        "f1e6",
        "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
    ]
};
var $72947875341bbd79$export$a105e7b44ca0eb9e = {
    prefix: 'fas',
    iconName: 'plus',
    icon: [
        448,
        512,
        [],
        "f067",
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$d9cc3a81499af48c = {
    prefix: 'fas',
    iconName: 'plus-circle',
    icon: [
        512,
        512,
        [],
        "f055",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $72947875341bbd79$export$b6359eebfe900c35 = {
    prefix: 'fas',
    iconName: 'plus-square',
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $72947875341bbd79$export$5c0b4709125e92f8 = {
    prefix: 'fas',
    iconName: 'podcast',
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
    ]
};
var $72947875341bbd79$export$bc8ca14ab51f93db = {
    prefix: 'fas',
    iconName: 'poll',
    icon: [
        448,
        512,
        [],
        "f681",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
    ]
};
var $72947875341bbd79$export$456a238f0144d430 = {
    prefix: 'fas',
    iconName: 'poll-h',
    icon: [
        448,
        512,
        [],
        "f682",
        "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
    ]
};
var $72947875341bbd79$export$dd0ede1713d2d2f9 = {
    prefix: 'fas',
    iconName: 'poo',
    icon: [
        512,
        512,
        [],
        "f2fe",
        "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$48a38da471b097a2 = {
    prefix: 'fas',
    iconName: 'poo-storm',
    icon: [
        448,
        512,
        [],
        "f75a",
        "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
    ]
};
var $72947875341bbd79$export$bb45b6b87d1adf27 = {
    prefix: 'fas',
    iconName: 'poop',
    icon: [
        512,
        512,
        [],
        "f619",
        "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
    ]
};
var $72947875341bbd79$export$e3d25f819c7ee7d7 = {
    prefix: 'fas',
    iconName: 'portrait',
    icon: [
        384,
        512,
        [],
        "f3e0",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $72947875341bbd79$export$9ce041dfec8319b = {
    prefix: 'fas',
    iconName: 'pound-sign',
    icon: [
        320,
        512,
        [],
        "f154",
        "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ]
};
var $72947875341bbd79$export$a1cca9928dcf9798 = {
    prefix: 'fas',
    iconName: 'power-off',
    icon: [
        512,
        512,
        [],
        "f011",
        "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
    ]
};
var $72947875341bbd79$export$3b32c982141cad51 = {
    prefix: 'fas',
    iconName: 'pray',
    icon: [
        384,
        512,
        [],
        "f683",
        "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
    ]
};
var $72947875341bbd79$export$95e08e91b0929943 = {
    prefix: 'fas',
    iconName: 'praying-hands',
    icon: [
        640,
        512,
        [],
        "f684",
        "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
    ]
};
var $72947875341bbd79$export$8767bafb19515ee4 = {
    prefix: 'fas',
    iconName: 'prescription',
    icon: [
        384,
        512,
        [],
        "f5b1",
        "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
    ]
};
var $72947875341bbd79$export$214f9ce665590486 = {
    prefix: 'fas',
    iconName: 'prescription-bottle',
    icon: [
        384,
        512,
        [],
        "f485",
        "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
    ]
};
var $72947875341bbd79$export$65d1c884b8581d1a = {
    prefix: 'fas',
    iconName: 'prescription-bottle-alt',
    icon: [
        384,
        512,
        [],
        "f486",
        "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
    ]
};
var $72947875341bbd79$export$ae64371e02ee8e56 = {
    prefix: 'fas',
    iconName: 'print',
    icon: [
        512,
        512,
        [],
        "f02f",
        "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$5f9e1870e1866dde = {
    prefix: 'fas',
    iconName: 'procedures',
    icon: [
        640,
        512,
        [],
        "f487",
        "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var $72947875341bbd79$export$30bf9f5b96509df1 = {
    prefix: 'fas',
    iconName: 'project-diagram',
    icon: [
        640,
        512,
        [],
        "f542",
        "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$f1b881c73328720c = {
    prefix: 'fas',
    iconName: 'pump-medical',
    icon: [
        384,
        512,
        [],
        "e06a",
        "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
    ]
};
var $72947875341bbd79$export$821aeede187f23c9 = {
    prefix: 'fas',
    iconName: 'pump-soap',
    icon: [
        384,
        512,
        [],
        "e06b",
        "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
    ]
};
var $72947875341bbd79$export$7ee0dbd1e92e2859 = {
    prefix: 'fas',
    iconName: 'puzzle-piece',
    icon: [
        576,
        512,
        [],
        "f12e",
        "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
    ]
};
var $72947875341bbd79$export$fc19ca0fe15e73bc = {
    prefix: 'fas',
    iconName: 'qrcode',
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
    ]
};
var $72947875341bbd79$export$d96973f90e8f6e47 = {
    prefix: 'fas',
    iconName: 'question',
    icon: [
        384,
        512,
        [],
        "f128",
        "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
    ]
};
var $72947875341bbd79$export$5ba67d7f2265c1a5 = {
    prefix: 'fas',
    iconName: 'question-circle',
    icon: [
        512,
        512,
        [],
        "f059",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
    ]
};
var $72947875341bbd79$export$c00c446e6db1605f = {
    prefix: 'fas',
    iconName: 'quidditch',
    icon: [
        640,
        512,
        [],
        "f458",
        "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
    ]
};
var $72947875341bbd79$export$932a67a1b1a7a724 = {
    prefix: 'fas',
    iconName: 'quote-left',
    icon: [
        512,
        512,
        [],
        "f10d",
        "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$54e3a80c9875b74c = {
    prefix: 'fas',
    iconName: 'quote-right',
    icon: [
        512,
        512,
        [],
        "f10e",
        "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$46f29ea84ed4c5f1 = {
    prefix: 'fas',
    iconName: 'quran',
    icon: [
        448,
        512,
        [],
        "f687",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $72947875341bbd79$export$4c4e509518093d6d = {
    prefix: 'fas',
    iconName: 'radiation',
    icon: [
        496,
        512,
        [],
        "f7b9",
        "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
    ]
};
var $72947875341bbd79$export$2f048fa82bbddf6f = {
    prefix: 'fas',
    iconName: 'radiation-alt',
    icon: [
        496,
        512,
        [],
        "f7ba",
        "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $72947875341bbd79$export$92ab27739d3a91b2 = {
    prefix: 'fas',
    iconName: 'rainbow',
    icon: [
        576,
        512,
        [],
        "f75b",
        "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
    ]
};
var $72947875341bbd79$export$8357bf8cc666d5f0 = {
    prefix: 'fas',
    iconName: 'random',
    icon: [
        512,
        512,
        [],
        "f074",
        "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
    ]
};
var $72947875341bbd79$export$32b0cd6133c2742 = {
    prefix: 'fas',
    iconName: 'receipt',
    icon: [
        384,
        512,
        [],
        "f543",
        "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
    ]
};
var $72947875341bbd79$export$fe2d5012d9982673 = {
    prefix: 'fas',
    iconName: 'record-vinyl',
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
    ]
};
var $72947875341bbd79$export$a65c441f12cb6bd = {
    prefix: 'fas',
    iconName: 'recycle',
    icon: [
        512,
        512,
        [],
        "f1b8",
        "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
    ]
};
var $72947875341bbd79$export$3d9f98aa1c24c776 = {
    prefix: 'fas',
    iconName: 'redo',
    icon: [
        512,
        512,
        [],
        "f01e",
        "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
    ]
};
var $72947875341bbd79$export$50c037520c6cfdc1 = {
    prefix: 'fas',
    iconName: 'redo-alt',
    icon: [
        512,
        512,
        [],
        "f2f9",
        "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
    ]
};
var $72947875341bbd79$export$5f519e9ac15ab8c3 = {
    prefix: 'fas',
    iconName: 'registered',
    icon: [
        512,
        512,
        [],
        "f25d",
        "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
    ]
};
var $72947875341bbd79$export$d91179f327329532 = {
    prefix: 'fas',
    iconName: 'remove-format',
    icon: [
        640,
        512,
        [],
        "f87d",
        "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
    ]
};
var $72947875341bbd79$export$bb06d4a7bb6736fe = {
    prefix: 'fas',
    iconName: 'reply',
    icon: [
        512,
        512,
        [],
        "f3e5",
        "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
    ]
};
var $72947875341bbd79$export$ca6fd367f31ecbc5 = {
    prefix: 'fas',
    iconName: 'reply-all',
    icon: [
        576,
        512,
        [],
        "f122",
        "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
    ]
};
var $72947875341bbd79$export$929518bb4b66a588 = {
    prefix: 'fas',
    iconName: 'republican',
    icon: [
        640,
        512,
        [],
        "f75e",
        "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$5fbcef35138741a5 = {
    prefix: 'fas',
    iconName: 'restroom',
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
    ]
};
var $72947875341bbd79$export$cebc76f79478e40e = {
    prefix: 'fas',
    iconName: 'retweet',
    icon: [
        640,
        512,
        [],
        "f079",
        "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
    ]
};
var $72947875341bbd79$export$838459d11f3971df = {
    prefix: 'fas',
    iconName: 'ribbon',
    icon: [
        448,
        512,
        [],
        "f4d6",
        "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
    ]
};
var $72947875341bbd79$export$a95486586631edc7 = {
    prefix: 'fas',
    iconName: 'ring',
    icon: [
        512,
        512,
        [],
        "f70b",
        "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
    ]
};
var $72947875341bbd79$export$f224567a4851a5e9 = {
    prefix: 'fas',
    iconName: 'road',
    icon: [
        576,
        512,
        [],
        "f018",
        "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
    ]
};
var $72947875341bbd79$export$30a5bb4ad3fa716c = {
    prefix: 'fas',
    iconName: 'robot',
    icon: [
        640,
        512,
        [],
        "f544",
        "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
    ]
};
var $72947875341bbd79$export$b24d84ed5657d89a = {
    prefix: 'fas',
    iconName: 'rocket',
    icon: [
        512,
        512,
        [],
        "f135",
        "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
    ]
};
var $72947875341bbd79$export$806c0a45a7ecd6e8 = {
    prefix: 'fas',
    iconName: 'route',
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$7329a1ca27b90c5b = {
    prefix: 'fas',
    iconName: 'rss',
    icon: [
        448,
        512,
        [],
        "f09e",
        "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
    ]
};
var $72947875341bbd79$export$89c9b1cca2c11484 = {
    prefix: 'fas',
    iconName: 'rss-square',
    icon: [
        448,
        512,
        [],
        "f143",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
    ]
};
var $72947875341bbd79$export$1ae0a94c8ba4131a = {
    prefix: 'fas',
    iconName: 'ruble-sign',
    icon: [
        384,
        512,
        [],
        "f158",
        "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
    ]
};
var $72947875341bbd79$export$8e90575265a56cfc = {
    prefix: 'fas',
    iconName: 'ruler',
    icon: [
        640,
        512,
        [],
        "f545",
        "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
    ]
};
var $72947875341bbd79$export$613f406c1b5802a8 = {
    prefix: 'fas',
    iconName: 'ruler-combined',
    icon: [
        512,
        512,
        [],
        "f546",
        "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$46c6347bff3e04a = {
    prefix: 'fas',
    iconName: 'ruler-horizontal',
    icon: [
        576,
        512,
        [],
        "f547",
        "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$a6ad5df9d9f29553 = {
    prefix: 'fas',
    iconName: 'ruler-vertical',
    icon: [
        256,
        512,
        [],
        "f548",
        "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
    ]
};
var $72947875341bbd79$export$5dfd1cb43dc9eadb = {
    prefix: 'fas',
    iconName: 'running',
    icon: [
        416,
        512,
        [],
        "f70c",
        "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
    ]
};
var $72947875341bbd79$export$8bf9e3f7f57d486a = {
    prefix: 'fas',
    iconName: 'rupee-sign',
    icon: [
        320,
        512,
        [],
        "f156",
        "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
    ]
};
var $72947875341bbd79$export$8e924e6bd422cef9 = {
    prefix: 'fas',
    iconName: 'sad-cry',
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
    ]
};
var $72947875341bbd79$export$4b5241926f692f91 = {
    prefix: 'fas',
    iconName: 'sad-tear',
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
    ]
};
var $72947875341bbd79$export$da3f1730d013e224 = {
    prefix: 'fas',
    iconName: 'satellite',
    icon: [
        512,
        512,
        [],
        "f7bf",
        "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
    ]
};
var $72947875341bbd79$export$219ccae0e4da3c92 = {
    prefix: 'fas',
    iconName: 'satellite-dish',
    icon: [
        512,
        512,
        [],
        "f7c0",
        "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
    ]
};
var $72947875341bbd79$export$1aaa83ff70706e1e = {
    prefix: 'fas',
    iconName: 'save',
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
    ]
};
var $72947875341bbd79$export$51e9b8434982947d = {
    prefix: 'fas',
    iconName: 'school',
    icon: [
        640,
        512,
        [],
        "f549",
        "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$7484ff654cd6474f = {
    prefix: 'fas',
    iconName: 'screwdriver',
    icon: [
        512,
        512,
        [],
        "f54a",
        "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
    ]
};
var $72947875341bbd79$export$7c265716d4399676 = {
    prefix: 'fas',
    iconName: 'scroll',
    icon: [
        640,
        512,
        [],
        "f70e",
        "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
    ]
};
var $72947875341bbd79$export$303efb6031da122 = {
    prefix: 'fas',
    iconName: 'sd-card',
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
    ]
};
var $72947875341bbd79$export$871a78837687ffe8 = {
    prefix: 'fas',
    iconName: 'search',
    icon: [
        512,
        512,
        [],
        "f002",
        "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    ]
};
var $72947875341bbd79$export$65b49a6767630708 = {
    prefix: 'fas',
    iconName: 'search-dollar',
    icon: [
        512,
        512,
        [],
        "f688",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
    ]
};
var $72947875341bbd79$export$c33aba6c251a898a = {
    prefix: 'fas',
    iconName: 'search-location',
    icon: [
        512,
        512,
        [],
        "f689",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$efca97eef6a7a17d = {
    prefix: 'fas',
    iconName: 'search-minus',
    icon: [
        512,
        512,
        [],
        "f010",
        "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $72947875341bbd79$export$378f00e6b1a8185 = {
    prefix: 'fas',
    iconName: 'search-plus',
    icon: [
        512,
        512,
        [],
        "f00e",
        "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $72947875341bbd79$export$d7b60b8dbd03cfe4 = {
    prefix: 'fas',
    iconName: 'seedling',
    icon: [
        512,
        512,
        [],
        "f4d8",
        "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
    ]
};
var $72947875341bbd79$export$1bf820d499b6202e = {
    prefix: 'fas',
    iconName: 'server',
    icon: [
        512,
        512,
        [],
        "f233",
        "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
    ]
};
var $72947875341bbd79$export$b17d50542d1fc340 = {
    prefix: 'fas',
    iconName: 'shapes',
    icon: [
        512,
        512,
        [],
        "f61f",
        "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
    ]
};
var $72947875341bbd79$export$c08b4b0e2b0dc027 = {
    prefix: 'fas',
    iconName: 'share',
    icon: [
        512,
        512,
        [],
        "f064",
        "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
    ]
};
var $72947875341bbd79$export$f8e8bb0b3aa8c658 = {
    prefix: 'fas',
    iconName: 'share-alt',
    icon: [
        448,
        512,
        [],
        "f1e0",
        "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    ]
};
var $72947875341bbd79$export$3799c2d8fd7e493b = {
    prefix: 'fas',
    iconName: 'share-alt-square',
    icon: [
        448,
        512,
        [],
        "f1e1",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
    ]
};
var $72947875341bbd79$export$ae9e1434571f373c = {
    prefix: 'fas',
    iconName: 'share-square',
    icon: [
        576,
        512,
        [],
        "f14d",
        "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
    ]
};
var $72947875341bbd79$export$3570be7b68efb8db = {
    prefix: 'fas',
    iconName: 'shekel-sign',
    icon: [
        448,
        512,
        [],
        "f20b",
        "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$d6508d18a824f291 = {
    prefix: 'fas',
    iconName: 'shield-alt',
    icon: [
        512,
        512,
        [],
        "f3ed",
        "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    ]
};
var $72947875341bbd79$export$bea811bbf570f05a = {
    prefix: 'fas',
    iconName: 'shield-virus',
    icon: [
        512,
        512,
        [],
        "e06c",
        "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
    ]
};
var $72947875341bbd79$export$6c645741140616af = {
    prefix: 'fas',
    iconName: 'ship',
    icon: [
        640,
        512,
        [],
        "f21a",
        "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
    ]
};
var $72947875341bbd79$export$5e419f47aaeb3c05 = {
    prefix: 'fas',
    iconName: 'shipping-fast',
    icon: [
        640,
        512,
        [],
        "f48b",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $72947875341bbd79$export$cdbdd2118099ae07 = {
    prefix: 'fas',
    iconName: 'shoe-prints',
    icon: [
        640,
        512,
        [],
        "f54b",
        "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
    ]
};
var $72947875341bbd79$export$5745f8adbc11eb01 = {
    prefix: 'fas',
    iconName: 'shopping-bag',
    icon: [
        448,
        512,
        [],
        "f290",
        "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
    ]
};
var $72947875341bbd79$export$ca6d443595a6578f = {
    prefix: 'fas',
    iconName: 'shopping-basket',
    icon: [
        576,
        512,
        [],
        "f291",
        "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
    ]
};
var $72947875341bbd79$export$51da406e5aa1388c = {
    prefix: 'fas',
    iconName: 'shopping-cart',
    icon: [
        576,
        512,
        [],
        "f07a",
        "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
    ]
};
var $72947875341bbd79$export$f7f7c15f18cc19a1 = {
    prefix: 'fas',
    iconName: 'shower',
    icon: [
        512,
        512,
        [],
        "f2cc",
        "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
    ]
};
var $72947875341bbd79$export$9d63d851db698c09 = {
    prefix: 'fas',
    iconName: 'shuttle-van',
    icon: [
        640,
        512,
        [],
        "f5b6",
        "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
    ]
};
var $72947875341bbd79$export$d21d0d6c8e9e8bf9 = {
    prefix: 'fas',
    iconName: 'sign',
    icon: [
        512,
        512,
        [],
        "f4d9",
        "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
    ]
};
var $72947875341bbd79$export$e6709746115bd2ea = {
    prefix: 'fas',
    iconName: 'sign-in-alt',
    icon: [
        512,
        512,
        [],
        "f2f6",
        "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
    ]
};
var $72947875341bbd79$export$20993813350f9671 = {
    prefix: 'fas',
    iconName: 'sign-language',
    icon: [
        448,
        512,
        [],
        "f2a7",
        "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
    ]
};
var $72947875341bbd79$export$c844d6923b7096c2 = {
    prefix: 'fas',
    iconName: 'sign-out-alt',
    icon: [
        512,
        512,
        [],
        "f2f5",
        "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    ]
};
var $72947875341bbd79$export$79046b073b6c584d = {
    prefix: 'fas',
    iconName: 'signal',
    icon: [
        640,
        512,
        [],
        "f012",
        "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$afa7b53ac8ebcb5d = {
    prefix: 'fas',
    iconName: 'signature',
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
    ]
};
var $72947875341bbd79$export$3bee83bf278fddbe = {
    prefix: 'fas',
    iconName: 'sim-card',
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
    ]
};
var $72947875341bbd79$export$2a9dda2096ce792e = {
    prefix: 'fas',
    iconName: 'sink',
    icon: [
        512,
        512,
        [],
        "e06d",
        "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
    ]
};
var $72947875341bbd79$export$b2ce5e79d0eccaf8 = {
    prefix: 'fas',
    iconName: 'sitemap',
    icon: [
        640,
        512,
        [],
        "f0e8",
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$21bd1d54bd4f2c5a = {
    prefix: 'fas',
    iconName: 'skating',
    icon: [
        448,
        512,
        [],
        "f7c5",
        "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $72947875341bbd79$export$eae1acab6fb96708 = {
    prefix: 'fas',
    iconName: 'skiing',
    icon: [
        512,
        512,
        [],
        "f7c9",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
    ]
};
var $72947875341bbd79$export$6ea48260d7d09b1b = {
    prefix: 'fas',
    iconName: 'skiing-nordic',
    icon: [
        576,
        512,
        [],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
    ]
};
var $72947875341bbd79$export$138b45e2afb1dfa4 = {
    prefix: 'fas',
    iconName: 'skull',
    icon: [
        512,
        512,
        [],
        "f54c",
        "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
    ]
};
var $72947875341bbd79$export$8717352b90217272 = {
    prefix: 'fas',
    iconName: 'skull-crossbones',
    icon: [
        448,
        512,
        [],
        "f714",
        "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
    ]
};
var $72947875341bbd79$export$f54d004dd5f1cb5e = {
    prefix: 'fas',
    iconName: 'slash',
    icon: [
        640,
        512,
        [],
        "f715",
        "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
    ]
};
var $72947875341bbd79$export$26a8fd1143d2d6c0 = {
    prefix: 'fas',
    iconName: 'sleigh',
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
    ]
};
var $72947875341bbd79$export$94d4dcb523f95563 = {
    prefix: 'fas',
    iconName: 'sliders-h',
    icon: [
        512,
        512,
        [],
        "f1de",
        "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$c632b2334f0913bc = {
    prefix: 'fas',
    iconName: 'smile',
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
    ]
};
var $72947875341bbd79$export$54ada6dc9690e0ca = {
    prefix: 'fas',
    iconName: 'smile-beam',
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
    ]
};
var $72947875341bbd79$export$f5dbb37f6801ee3f = {
    prefix: 'fas',
    iconName: 'smile-wink',
    icon: [
        496,
        512,
        [],
        "f4da",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
    ]
};
var $72947875341bbd79$export$aa11b8edb09fed14 = {
    prefix: 'fas',
    iconName: 'smog',
    icon: [
        640,
        512,
        [],
        "f75f",
        "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
    ]
};
var $72947875341bbd79$export$c4ab83701fc591a5 = {
    prefix: 'fas',
    iconName: 'smoking',
    icon: [
        640,
        512,
        [],
        "f48d",
        "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
    ]
};
var $72947875341bbd79$export$e50452a49dec29f = {
    prefix: 'fas',
    iconName: 'smoking-ban',
    icon: [
        512,
        512,
        [],
        "f54d",
        "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
    ]
};
var $72947875341bbd79$export$9dbcc3443daa7323 = {
    prefix: 'fas',
    iconName: 'sms',
    icon: [
        512,
        512,
        [],
        "f7cd",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
    ]
};
var $72947875341bbd79$export$72683772d587302a = {
    prefix: 'fas',
    iconName: 'snowboarding',
    icon: [
        512,
        512,
        [],
        "f7ce",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
    ]
};
var $72947875341bbd79$export$bab8f3647c394f48 = {
    prefix: 'fas',
    iconName: 'snowflake',
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
    ]
};
var $72947875341bbd79$export$b23df6bafb174693 = {
    prefix: 'fas',
    iconName: 'snowman',
    icon: [
        512,
        512,
        [],
        "f7d0",
        "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $72947875341bbd79$export$695fae58f55c3a87 = {
    prefix: 'fas',
    iconName: 'snowplow',
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $72947875341bbd79$export$64f1c53b21f310ac = {
    prefix: 'fas',
    iconName: 'soap',
    icon: [
        512,
        512,
        [],
        "e06e",
        "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
    ]
};
var $72947875341bbd79$export$8d36a54dbf1e6bce = {
    prefix: 'fas',
    iconName: 'socks',
    icon: [
        512,
        512,
        [],
        "f696",
        "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
    ]
};
var $72947875341bbd79$export$b9c649c5e37017f3 = {
    prefix: 'fas',
    iconName: 'solar-panel',
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
    ]
};
var $72947875341bbd79$export$4941c5969d5399b = {
    prefix: 'fas',
    iconName: 'sort',
    icon: [
        320,
        512,
        [],
        "f0dc",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    ]
};
var $72947875341bbd79$export$7658045270aafde3 = {
    prefix: 'fas',
    iconName: 'sort-alpha-down',
    icon: [
        448,
        512,
        [],
        "f15d",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $72947875341bbd79$export$e12d23d82d5c8a89 = {
    prefix: 'fas',
    iconName: 'sort-alpha-down-alt',
    icon: [
        448,
        512,
        [],
        "f881",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $72947875341bbd79$export$3c4115b156be730d = {
    prefix: 'fas',
    iconName: 'sort-alpha-up',
    icon: [
        448,
        512,
        [],
        "f15e",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $72947875341bbd79$export$95ef20828693fb0f = {
    prefix: 'fas',
    iconName: 'sort-alpha-up-alt',
    icon: [
        448,
        512,
        [],
        "f882",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $72947875341bbd79$export$4b2a02d50e417b5f = {
    prefix: 'fas',
    iconName: 'sort-amount-down',
    icon: [
        512,
        512,
        [],
        "f160",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$e7d80d8c226cb77 = {
    prefix: 'fas',
    iconName: 'sort-amount-down-alt',
    icon: [
        512,
        512,
        [],
        "f884",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $72947875341bbd79$export$28ef3e933e4b5364 = {
    prefix: 'fas',
    iconName: 'sort-amount-up',
    icon: [
        512,
        512,
        [],
        "f161",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$6e87844b0f151b6a = {
    prefix: 'fas',
    iconName: 'sort-amount-up-alt',
    icon: [
        512,
        512,
        [],
        "f885",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
    ]
};
var $72947875341bbd79$export$58e2577a373e7d4 = {
    prefix: 'fas',
    iconName: 'sort-down',
    icon: [
        320,
        512,
        [],
        "f0dd",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    ]
};
var $72947875341bbd79$export$835db7eb35b3c29b = {
    prefix: 'fas',
    iconName: 'sort-numeric-down',
    icon: [
        448,
        512,
        [],
        "f162",
        "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $72947875341bbd79$export$857385fda7a5a98e = {
    prefix: 'fas',
    iconName: 'sort-numeric-down-alt',
    icon: [
        448,
        512,
        [],
        "f886",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $72947875341bbd79$export$d213a3ba3cabed48 = {
    prefix: 'fas',
    iconName: 'sort-numeric-up',
    icon: [
        448,
        512,
        [],
        "f163",
        "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
    ]
};
var $72947875341bbd79$export$d41859f1bbb9e086 = {
    prefix: 'fas',
    iconName: 'sort-numeric-up-alt',
    icon: [
        448,
        512,
        [],
        "f887",
        "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $72947875341bbd79$export$f9dd5b1410e95035 = {
    prefix: 'fas',
    iconName: 'sort-up',
    icon: [
        320,
        512,
        [],
        "f0de",
        "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    ]
};
var $72947875341bbd79$export$f9a38ef7b046ab51 = {
    prefix: 'fas',
    iconName: 'spa',
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
    ]
};
var $72947875341bbd79$export$4d1c12ba2b4ca565 = {
    prefix: 'fas',
    iconName: 'space-shuttle',
    icon: [
        640,
        512,
        [],
        "f197",
        "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
    ]
};
var $72947875341bbd79$export$761e747b06ed2e1f = {
    prefix: 'fas',
    iconName: 'spell-check',
    icon: [
        576,
        512,
        [],
        "f891",
        "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
    ]
};
var $72947875341bbd79$export$6daa96b1986e2ef0 = {
    prefix: 'fas',
    iconName: 'spider',
    icon: [
        576,
        512,
        [],
        "f717",
        "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
    ]
};
var $72947875341bbd79$export$1025ad641edb49c2 = {
    prefix: 'fas',
    iconName: 'spinner',
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ]
};
var $72947875341bbd79$export$d6f21e17ea797702 = {
    prefix: 'fas',
    iconName: 'splotch',
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
    ]
};
var $72947875341bbd79$export$4952c502f544cf85 = {
    prefix: 'fas',
    iconName: 'spray-can',
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$90b4406457aae8cc = {
    prefix: 'fas',
    iconName: 'square',
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$7ec6541fee081990 = {
    prefix: 'fas',
    iconName: 'square-full',
    icon: [
        512,
        512,
        [],
        "f45c",
        "M512 512H0V0h512v512z"
    ]
};
var $72947875341bbd79$export$28e4b96627e00057 = {
    prefix: 'fas',
    iconName: 'square-root-alt',
    icon: [
        576,
        512,
        [],
        "f698",
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
    ]
};
var $72947875341bbd79$export$722e92d2d93ffc68 = {
    prefix: 'fas',
    iconName: 'stamp',
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
    ]
};
var $72947875341bbd79$export$a3b0eb2cd7942125 = {
    prefix: 'fas',
    iconName: 'star',
    icon: [
        576,
        512,
        [],
        "f005",
        "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    ]
};
var $72947875341bbd79$export$cafa834c96ebcb1a = {
    prefix: 'fas',
    iconName: 'star-and-crescent',
    icon: [
        512,
        512,
        [],
        "f699",
        "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
    ]
};
var $72947875341bbd79$export$228008b5e11032fa = {
    prefix: 'fas',
    iconName: 'star-half',
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
    ]
};
var $72947875341bbd79$export$c13575f42532efb3 = {
    prefix: 'fas',
    iconName: 'star-half-alt',
    icon: [
        536,
        512,
        [],
        "f5c0",
        "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
    ]
};
var $72947875341bbd79$export$f823fee3712b2601 = {
    prefix: 'fas',
    iconName: 'star-of-david',
    icon: [
        464,
        512,
        [],
        "f69a",
        "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
    ]
};
var $72947875341bbd79$export$aa3c4c1c5a47bf98 = {
    prefix: 'fas',
    iconName: 'star-of-life',
    icon: [
        480,
        512,
        [],
        "f621",
        "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
    ]
};
var $72947875341bbd79$export$2884e379aed297d4 = {
    prefix: 'fas',
    iconName: 'step-backward',
    icon: [
        448,
        512,
        [],
        "f048",
        "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    ]
};
var $72947875341bbd79$export$b303329afce5de18 = {
    prefix: 'fas',
    iconName: 'step-forward',
    icon: [
        448,
        512,
        [],
        "f051",
        "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    ]
};
var $72947875341bbd79$export$acb2d72d28cd92d9 = {
    prefix: 'fas',
    iconName: 'stethoscope',
    icon: [
        512,
        512,
        [],
        "f0f1",
        "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $72947875341bbd79$export$80889adc5d98bf4a = {
    prefix: 'fas',
    iconName: 'sticky-note',
    icon: [
        448,
        512,
        [],
        "f249",
        "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
    ]
};
var $72947875341bbd79$export$51577929c676143b = {
    prefix: 'fas',
    iconName: 'stop',
    icon: [
        448,
        512,
        [],
        "f04d",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$47af2aad60ab3e7c = {
    prefix: 'fas',
    iconName: 'stop-circle',
    icon: [
        512,
        512,
        [],
        "f28d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
    ]
};
var $72947875341bbd79$export$b85a7300fc7960b6 = {
    prefix: 'fas',
    iconName: 'stopwatch',
    icon: [
        448,
        512,
        [],
        "f2f2",
        "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $72947875341bbd79$export$df6244b0501f2112 = {
    prefix: 'fas',
    iconName: 'stopwatch-20',
    icon: [
        448,
        512,
        [],
        "e06f",
        "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
    ]
};
var $72947875341bbd79$export$de59c2657a8ace67 = {
    prefix: 'fas',
    iconName: 'store',
    icon: [
        616,
        512,
        [],
        "f54e",
        "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
    ]
};
var $72947875341bbd79$export$1f1871dab9cec9d8 = {
    prefix: 'fas',
    iconName: 'store-alt',
    icon: [
        640,
        512,
        [],
        "f54f",
        "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
    ]
};
var $72947875341bbd79$export$b932a586f6ff48b4 = {
    prefix: 'fas',
    iconName: 'store-alt-slash',
    icon: [
        640,
        512,
        [],
        "e070",
        "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
    ]
};
var $72947875341bbd79$export$4ab2f33219630bad = {
    prefix: 'fas',
    iconName: 'store-slash',
    icon: [
        640,
        512,
        [],
        "e071",
        "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
    ]
};
var $72947875341bbd79$export$ed81ab40fc4e904 = {
    prefix: 'fas',
    iconName: 'stream',
    icon: [
        512,
        512,
        [],
        "f550",
        "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$6aab6c3359c2554c = {
    prefix: 'fas',
    iconName: 'street-view',
    icon: [
        512,
        512,
        [],
        "f21d",
        "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
    ]
};
var $72947875341bbd79$export$eff51ea25b4de135 = {
    prefix: 'fas',
    iconName: 'strikethrough',
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
    ]
};
var $72947875341bbd79$export$195780ddabd8e0c6 = {
    prefix: 'fas',
    iconName: 'stroopwafel',
    icon: [
        512,
        512,
        [],
        "f551",
        "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
    ]
};
var $72947875341bbd79$export$34c1e678c32ed646 = {
    prefix: 'fas',
    iconName: 'subscript',
    icon: [
        512,
        512,
        [],
        "f12c",
        "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$4cabc8a12d4e2f9 = {
    prefix: 'fas',
    iconName: 'subway',
    icon: [
        448,
        512,
        [],
        "f239",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $72947875341bbd79$export$60710f3921019268 = {
    prefix: 'fas',
    iconName: 'suitcase',
    icon: [
        512,
        512,
        [],
        "f0f2",
        "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
    ]
};
var $72947875341bbd79$export$957e62a9b80ff4e3 = {
    prefix: 'fas',
    iconName: 'suitcase-rolling',
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
    ]
};
var $72947875341bbd79$export$2fa35dcbc038dbe9 = {
    prefix: 'fas',
    iconName: 'sun',
    icon: [
        512,
        512,
        [],
        "f185",
        "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    ]
};
var $72947875341bbd79$export$4fa56a54e822dd25 = {
    prefix: 'fas',
    iconName: 'superscript',
    icon: [
        512,
        512,
        [],
        "f12b",
        "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$46647c72213f53ba = {
    prefix: 'fas',
    iconName: 'surprise',
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$c74a20c81b957b6a = {
    prefix: 'fas',
    iconName: 'swatchbook',
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
    ]
};
var $72947875341bbd79$export$67daf2e2f88c1365 = {
    prefix: 'fas',
    iconName: 'swimmer',
    icon: [
        640,
        512,
        [],
        "f5c4",
        "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
    ]
};
var $72947875341bbd79$export$4dee691631c67d5c = {
    prefix: 'fas',
    iconName: 'swimming-pool',
    icon: [
        640,
        512,
        [],
        "f5c5",
        "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
    ]
};
var $72947875341bbd79$export$20d991385719b5b4 = {
    prefix: 'fas',
    iconName: 'synagogue',
    icon: [
        640,
        512,
        [],
        "f69b",
        "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
    ]
};
var $72947875341bbd79$export$ff87319002e3dae9 = {
    prefix: 'fas',
    iconName: 'sync',
    icon: [
        512,
        512,
        [],
        "f021",
        "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
    ]
};
var $72947875341bbd79$export$2ff2056be8c281e4 = {
    prefix: 'fas',
    iconName: 'sync-alt',
    icon: [
        512,
        512,
        [],
        "f2f1",
        "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    ]
};
var $72947875341bbd79$export$1aa9423ec6b1d609 = {
    prefix: 'fas',
    iconName: 'syringe',
    icon: [
        512,
        512,
        [],
        "f48e",
        "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
    ]
};
var $72947875341bbd79$export$36583f5d3d5a971f = {
    prefix: 'fas',
    iconName: 'table',
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
    ]
};
var $72947875341bbd79$export$f378fbb4e0ef7edf = {
    prefix: 'fas',
    iconName: 'table-tennis',
    icon: [
        512,
        512,
        [],
        "f45d",
        "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
    ]
};
var $72947875341bbd79$export$1c92b67c45a4b4fc = {
    prefix: 'fas',
    iconName: 'tablet',
    icon: [
        448,
        512,
        [],
        "f10a",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $72947875341bbd79$export$db0cac088255eacc = {
    prefix: 'fas',
    iconName: 'tablet-alt',
    icon: [
        448,
        512,
        [],
        "f3fa",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
    ]
};
var $72947875341bbd79$export$bed2b0ed4ae45e0d = {
    prefix: 'fas',
    iconName: 'tablets',
    icon: [
        640,
        512,
        [],
        "f490",
        "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
    ]
};
var $72947875341bbd79$export$38dd17b9f064c10f = {
    prefix: 'fas',
    iconName: 'tachometer-alt',
    icon: [
        576,
        512,
        [],
        "f3fd",
        "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$cb61f447f29887e = {
    prefix: 'fas',
    iconName: 'tag',
    icon: [
        512,
        512,
        [],
        "f02b",
        "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $72947875341bbd79$export$d55778e3ab6c933f = {
    prefix: 'fas',
    iconName: 'tags',
    icon: [
        640,
        512,
        [],
        "f02c",
        "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
    ]
};
var $72947875341bbd79$export$b88ed5e1e0eac4c6 = {
    prefix: 'fas',
    iconName: 'tape',
    icon: [
        640,
        512,
        [],
        "f4db",
        "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ]
};
var $72947875341bbd79$export$2f6d5b2fec286d63 = {
    prefix: 'fas',
    iconName: 'tasks',
    icon: [
        512,
        512,
        [],
        "f0ae",
        "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$9958afcdfece1b58 = {
    prefix: 'fas',
    iconName: 'taxi',
    icon: [
        512,
        512,
        [],
        "f1ba",
        "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$b4619aeaf0b9d18e = {
    prefix: 'fas',
    iconName: 'teeth',
    icon: [
        640,
        512,
        [],
        "f62e",
        "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
    ]
};
var $72947875341bbd79$export$c88ac21fe7c88ae6 = {
    prefix: 'fas',
    iconName: 'teeth-open',
    icon: [
        640,
        512,
        [],
        "f62f",
        "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
    ]
};
var $72947875341bbd79$export$15d012277c3ecf9a = {
    prefix: 'fas',
    iconName: 'temperature-high',
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $72947875341bbd79$export$9e9af12b90a1abd2 = {
    prefix: 'fas',
    iconName: 'temperature-low',
    icon: [
        512,
        512,
        [],
        "f76b",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $72947875341bbd79$export$af6ebee83047b793 = {
    prefix: 'fas',
    iconName: 'tenge',
    icon: [
        384,
        512,
        [],
        "f7d7",
        "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
    ]
};
var $72947875341bbd79$export$5e63e8b85b5f119c = {
    prefix: 'fas',
    iconName: 'terminal',
    icon: [
        640,
        512,
        [],
        "f120",
        "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
    ]
};
var $72947875341bbd79$export$3313bce3924ea7da = {
    prefix: 'fas',
    iconName: 'text-height',
    icon: [
        576,
        512,
        [],
        "f034",
        "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
    ]
};
var $72947875341bbd79$export$d8724cf433389700 = {
    prefix: 'fas',
    iconName: 'text-width',
    icon: [
        448,
        512,
        [],
        "f035",
        "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
    ]
};
var $72947875341bbd79$export$4d383c83efc0c819 = {
    prefix: 'fas',
    iconName: 'th',
    icon: [
        512,
        512,
        [],
        "f00a",
        "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
    ]
};
var $72947875341bbd79$export$69782f333e90cdc6 = {
    prefix: 'fas',
    iconName: 'th-large',
    icon: [
        512,
        512,
        [],
        "f009",
        "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
    ]
};
var $72947875341bbd79$export$daf2614a457122c0 = {
    prefix: 'fas',
    iconName: 'th-list',
    icon: [
        512,
        512,
        [],
        "f00b",
        "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
    ]
};
var $72947875341bbd79$export$3dbedc487b0159ac = {
    prefix: 'fas',
    iconName: 'theater-masks',
    icon: [
        640,
        512,
        [],
        "f630",
        "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
    ]
};
var $72947875341bbd79$export$f576739e9b18ea4f = {
    prefix: 'fas',
    iconName: 'thermometer',
    icon: [
        512,
        512,
        [],
        "f491",
        "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
    ]
};
var $72947875341bbd79$export$81a2f8298cf523f9 = {
    prefix: 'fas',
    iconName: 'thermometer-empty',
    icon: [
        256,
        512,
        [],
        "f2cb",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $72947875341bbd79$export$74e07083cef79a6f = {
    prefix: 'fas',
    iconName: 'thermometer-full',
    icon: [
        256,
        512,
        [],
        "f2c7",
        "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
    ]
};
var $72947875341bbd79$export$2090f040324b4449 = {
    prefix: 'fas',
    iconName: 'thermometer-half',
    icon: [
        256,
        512,
        [],
        "f2c9",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $72947875341bbd79$export$ed05754fcbec6e46 = {
    prefix: 'fas',
    iconName: 'thermometer-quarter',
    icon: [
        256,
        512,
        [],
        "f2ca",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $72947875341bbd79$export$6c632d1dc30d4a77 = {
    prefix: 'fas',
    iconName: 'thermometer-three-quarters',
    icon: [
        256,
        512,
        [],
        "f2c8",
        "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $72947875341bbd79$export$aba24ca305bbe8c1 = {
    prefix: 'fas',
    iconName: 'thumbs-down',
    icon: [
        512,
        512,
        [],
        "f165",
        "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
    ]
};
var $72947875341bbd79$export$47e4e0d519d33497 = {
    prefix: 'fas',
    iconName: 'thumbs-up',
    icon: [
        512,
        512,
        [],
        "f164",
        "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
    ]
};
var $72947875341bbd79$export$b6314cdc01bb5c43 = {
    prefix: 'fas',
    iconName: 'thumbtack',
    icon: [
        384,
        512,
        [],
        "f08d",
        "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
    ]
};
var $72947875341bbd79$export$75e38ba471fd89c4 = {
    prefix: 'fas',
    iconName: 'ticket-alt',
    icon: [
        576,
        512,
        [],
        "f3ff",
        "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
    ]
};
var $72947875341bbd79$export$174bd7f477b115b4 = {
    prefix: 'fas',
    iconName: 'times',
    icon: [
        352,
        512,
        [],
        "f00d",
        "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    ]
};
var $72947875341bbd79$export$ab0ec50720a747eb = {
    prefix: 'fas',
    iconName: 'times-circle',
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
    ]
};
var $72947875341bbd79$export$60dd975bd5938c15 = {
    prefix: 'fas',
    iconName: 'tint',
    icon: [
        352,
        512,
        [],
        "f043",
        "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $72947875341bbd79$export$5d6f0943039b898f = {
    prefix: 'fas',
    iconName: 'tint-slash',
    icon: [
        640,
        512,
        [],
        "f5c7",
        "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
    ]
};
var $72947875341bbd79$export$3d016d62cda18371 = {
    prefix: 'fas',
    iconName: 'tired',
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
    ]
};
var $72947875341bbd79$export$d20aaceb882ca545 = {
    prefix: 'fas',
    iconName: 'toggle-off',
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
    ]
};
var $72947875341bbd79$export$5cffc34afa81e517 = {
    prefix: 'fas',
    iconName: 'toggle-on',
    icon: [
        576,
        512,
        [],
        "f205",
        "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
    ]
};
var $72947875341bbd79$export$505476859b9691c0 = {
    prefix: 'fas',
    iconName: 'toilet',
    icon: [
        384,
        512,
        [],
        "f7d8",
        "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
    ]
};
var $72947875341bbd79$export$c8cc083ccc72b17 = {
    prefix: 'fas',
    iconName: 'toilet-paper',
    icon: [
        576,
        512,
        [],
        "f71e",
        "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
    ]
};
var $72947875341bbd79$export$7a494edbf9b65575 = {
    prefix: 'fas',
    iconName: 'toilet-paper-slash',
    icon: [
        640,
        512,
        [],
        "e072",
        "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
    ]
};
var $72947875341bbd79$export$b34d64c205c732a9 = {
    prefix: 'fas',
    iconName: 'toolbox',
    icon: [
        512,
        512,
        [],
        "f552",
        "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
    ]
};
var $72947875341bbd79$export$646e4e7a8c6172aa = {
    prefix: 'fas',
    iconName: 'tools',
    icon: [
        512,
        512,
        [],
        "f7d9",
        "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
    ]
};
var $72947875341bbd79$export$3a1fa2d16f90d635 = {
    prefix: 'fas',
    iconName: 'tooth',
    icon: [
        448,
        512,
        [],
        "f5c9",
        "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
    ]
};
var $72947875341bbd79$export$54d07baabd8c2acb = {
    prefix: 'fas',
    iconName: 'torah',
    icon: [
        640,
        512,
        [],
        "f6a0",
        "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
    ]
};
var $72947875341bbd79$export$75825a4c2b3375e = {
    prefix: 'fas',
    iconName: 'torii-gate',
    icon: [
        512,
        512,
        [],
        "f6a1",
        "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
    ]
};
var $72947875341bbd79$export$e87e41787bbedc98 = {
    prefix: 'fas',
    iconName: 'tractor',
    icon: [
        640,
        512,
        [],
        "f722",
        "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
    ]
};
var $72947875341bbd79$export$9c9b2fbddd59047d = {
    prefix: 'fas',
    iconName: 'trademark',
    icon: [
        640,
        512,
        [],
        "f25c",
        "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
    ]
};
var $72947875341bbd79$export$bf0b19daceaec9c2 = {
    prefix: 'fas',
    iconName: 'traffic-light',
    icon: [
        384,
        512,
        [],
        "f637",
        "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $72947875341bbd79$export$3a48b9820e92f5ab = {
    prefix: 'fas',
    iconName: 'trailer',
    icon: [
        640,
        512,
        [],
        "e041",
        "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
    ]
};
var $72947875341bbd79$export$17cde74bf6f1ee89 = {
    prefix: 'fas',
    iconName: 'train',
    icon: [
        448,
        512,
        [],
        "f238",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
    ]
};
var $72947875341bbd79$export$a7a36674c079f293 = {
    prefix: 'fas',
    iconName: 'tram',
    icon: [
        512,
        512,
        [],
        "f7da",
        "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $72947875341bbd79$export$7e3f1701aa95ef01 = {
    prefix: 'fas',
    iconName: 'transgender',
    icon: [
        384,
        512,
        [],
        "f224",
        "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$9c36cf9334c052f = {
    prefix: 'fas',
    iconName: 'transgender-alt',
    icon: [
        480,
        512,
        [],
        "f225",
        "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$ed8c149a0ea54bb4 = {
    prefix: 'fas',
    iconName: 'trash',
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
    ]
};
var $72947875341bbd79$export$88df7ff7eb32f9dc = {
    prefix: 'fas',
    iconName: 'trash-alt',
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$d32f45a64ed40e8d = {
    prefix: 'fas',
    iconName: 'trash-restore',
    icon: [
        448,
        512,
        [],
        "f829",
        "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$d075b19b21cb9856 = {
    prefix: 'fas',
    iconName: 'trash-restore-alt',
    icon: [
        448,
        512,
        [],
        "f82a",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$1744430f718caf6b = {
    prefix: 'fas',
    iconName: 'tree',
    icon: [
        384,
        512,
        [],
        "f1bb",
        "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
    ]
};
var $72947875341bbd79$export$29c432d69ccf85a5 = {
    prefix: 'fas',
    iconName: 'trophy',
    icon: [
        576,
        512,
        [],
        "f091",
        "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    ]
};
var $72947875341bbd79$export$d7895f386f8bd8b8 = {
    prefix: 'fas',
    iconName: 'truck',
    icon: [
        640,
        512,
        [],
        "f0d1",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $72947875341bbd79$export$f00c152db7d44638 = {
    prefix: 'fas',
    iconName: 'truck-loading',
    icon: [
        640,
        512,
        [],
        "f4de",
        "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $72947875341bbd79$export$24b8a0147653649a = {
    prefix: 'fas',
    iconName: 'truck-monster',
    icon: [
        640,
        512,
        [],
        "f63b",
        "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $72947875341bbd79$export$a06617a1a4ccea67 = {
    prefix: 'fas',
    iconName: 'truck-moving',
    icon: [
        640,
        512,
        [],
        "f4df",
        "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ]
};
var $72947875341bbd79$export$f846b848b3ba3064 = {
    prefix: 'fas',
    iconName: 'truck-pickup',
    icon: [
        640,
        512,
        [],
        "f63c",
        "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $72947875341bbd79$export$36edce3ba87c2b17 = {
    prefix: 'fas',
    iconName: 'tshirt',
    icon: [
        640,
        512,
        [],
        "f553",
        "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
    ]
};
var $72947875341bbd79$export$7c85aba0f9624b29 = {
    prefix: 'fas',
    iconName: 'tty',
    icon: [
        512,
        512,
        [],
        "f1e4",
        "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $72947875341bbd79$export$e0cfed4ba2fe562c = {
    prefix: 'fas',
    iconName: 'tv',
    icon: [
        640,
        512,
        [],
        "f26c",
        "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
    ]
};
var $72947875341bbd79$export$9ff64ffae70e08c0 = {
    prefix: 'fas',
    iconName: 'umbrella',
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
    ]
};
var $72947875341bbd79$export$20932e4d438e4e4c = {
    prefix: 'fas',
    iconName: 'umbrella-beach',
    icon: [
        640,
        512,
        [],
        "f5ca",
        "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
    ]
};
var $72947875341bbd79$export$22346afd6a3cddf8 = {
    prefix: 'fas',
    iconName: 'underline',
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $72947875341bbd79$export$a5e5ba60b1dfe2b2 = {
    prefix: 'fas',
    iconName: 'undo',
    icon: [
        512,
        512,
        [],
        "f0e2",
        "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    ]
};
var $72947875341bbd79$export$c8197b992c46c4a6 = {
    prefix: 'fas',
    iconName: 'undo-alt',
    icon: [
        512,
        512,
        [],
        "f2ea",
        "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
    ]
};
var $72947875341bbd79$export$e119aada7f690d05 = {
    prefix: 'fas',
    iconName: 'universal-access',
    icon: [
        512,
        512,
        [],
        "f29a",
        "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
    ]
};
var $72947875341bbd79$export$f2e1460ebe1a8cb0 = {
    prefix: 'fas',
    iconName: 'university',
    icon: [
        512,
        512,
        [],
        "f19c",
        "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
    ]
};
var $72947875341bbd79$export$2f546f7d8ba01e18 = {
    prefix: 'fas',
    iconName: 'unlink',
    icon: [
        512,
        512,
        [],
        "f127",
        "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
    ]
};
var $72947875341bbd79$export$db1382cd406cc506 = {
    prefix: 'fas',
    iconName: 'unlock',
    icon: [
        448,
        512,
        [],
        "f09c",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$b19f508797f3d9c3 = {
    prefix: 'fas',
    iconName: 'unlock-alt',
    icon: [
        448,
        512,
        [],
        "f13e",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    ]
};
var $72947875341bbd79$export$a9578350255b2b79 = {
    prefix: 'fas',
    iconName: 'upload',
    icon: [
        512,
        512,
        [],
        "f093",
        "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $72947875341bbd79$export$f5699fa0844e0188 = {
    prefix: 'fas',
    iconName: 'user',
    icon: [
        448,
        512,
        [],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $72947875341bbd79$export$ae9b19c2ac726cfc = {
    prefix: 'fas',
    iconName: 'user-alt',
    icon: [
        512,
        512,
        [],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
    ]
};
var $72947875341bbd79$export$46185fab4772ada6 = {
    prefix: 'fas',
    iconName: 'user-alt-slash',
    icon: [
        640,
        512,
        [],
        "f4fa",
        "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
    ]
};
var $72947875341bbd79$export$94363e983c225a04 = {
    prefix: 'fas',
    iconName: 'user-astronaut',
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
    ]
};
var $72947875341bbd79$export$76de2a120043c9f8 = {
    prefix: 'fas',
    iconName: 'user-check',
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
    ]
};
var $72947875341bbd79$export$be7d974e9e0dba1a = {
    prefix: 'fas',
    iconName: 'user-circle',
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    ]
};
var $72947875341bbd79$export$b00596a09aa07311 = {
    prefix: 'fas',
    iconName: 'user-clock',
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
    ]
};
var $72947875341bbd79$export$474108c2b86e730e = {
    prefix: 'fas',
    iconName: 'user-cog',
    icon: [
        640,
        512,
        [],
        "f4fe",
        "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    ]
};
var $72947875341bbd79$export$a68a6960fc8eef82 = {
    prefix: 'fas',
    iconName: 'user-edit',
    icon: [
        640,
        512,
        [],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
    ]
};
var $72947875341bbd79$export$46073bec205635d9 = {
    prefix: 'fas',
    iconName: 'user-friends',
    icon: [
        640,
        512,
        [],
        "f500",
        "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
    ]
};
var $72947875341bbd79$export$10f5839059d22f7e = {
    prefix: 'fas',
    iconName: 'user-graduate',
    icon: [
        448,
        512,
        [],
        "f501",
        "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
    ]
};
var $72947875341bbd79$export$c950c1ba7f227d5b = {
    prefix: 'fas',
    iconName: 'user-injured',
    icon: [
        448,
        512,
        [],
        "f728",
        "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
    ]
};
var $72947875341bbd79$export$d9b89b5872b67a4f = {
    prefix: 'fas',
    iconName: 'user-lock',
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
    ]
};
var $72947875341bbd79$export$ab0d33a2c03f1794 = {
    prefix: 'fas',
    iconName: 'user-md',
    icon: [
        448,
        512,
        [],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
    ]
};
var $72947875341bbd79$export$d6e17c0df8ed1bf7 = {
    prefix: 'fas',
    iconName: 'user-minus',
    icon: [
        640,
        512,
        [],
        "f503",
        "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $72947875341bbd79$export$a9174995732e03c5 = {
    prefix: 'fas',
    iconName: 'user-ninja',
    icon: [
        448,
        512,
        [],
        "f504",
        "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
    ]
};
var $72947875341bbd79$export$ab9af5aa013d2162 = {
    prefix: 'fas',
    iconName: 'user-nurse',
    icon: [
        448,
        512,
        [],
        "f82f",
        "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
    ]
};
var $72947875341bbd79$export$4c17261776a709f2 = {
    prefix: 'fas',
    iconName: 'user-plus',
    icon: [
        640,
        512,
        [],
        "f234",
        "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $72947875341bbd79$export$597826232327559b = {
    prefix: 'fas',
    iconName: 'user-secret',
    icon: [
        448,
        512,
        [],
        "f21b",
        "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
    ]
};
var $72947875341bbd79$export$d1886bc596424e6c = {
    prefix: 'fas',
    iconName: 'user-shield',
    icon: [
        640,
        512,
        [],
        "f505",
        "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
    ]
};
var $72947875341bbd79$export$3924ab4d3ef9b5ef = {
    prefix: 'fas',
    iconName: 'user-slash',
    icon: [
        640,
        512,
        [],
        "f506",
        "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
    ]
};
var $72947875341bbd79$export$9eec597148166b36 = {
    prefix: 'fas',
    iconName: 'user-tag',
    icon: [
        640,
        512,
        [],
        "f507",
        "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
    ]
};
var $72947875341bbd79$export$48c51dda34e9f04c = {
    prefix: 'fas',
    iconName: 'user-tie',
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
    ]
};
var $72947875341bbd79$export$45b996d071667753 = {
    prefix: 'fas',
    iconName: 'user-times',
    icon: [
        640,
        512,
        [],
        "f235",
        "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $72947875341bbd79$export$e5a8f011aef571ac = {
    prefix: 'fas',
    iconName: 'users',
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $72947875341bbd79$export$5e0b06753fc69b81 = {
    prefix: 'fas',
    iconName: 'users-cog',
    icon: [
        640,
        512,
        [],
        "f509",
        "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $72947875341bbd79$export$b71a093b86e3da1f = {
    prefix: 'fas',
    iconName: 'users-slash',
    icon: [
        640,
        512,
        [],
        "e073",
        "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
    ]
};
var $72947875341bbd79$export$fb7af5d245fb9053 = {
    prefix: 'fas',
    iconName: 'utensil-spoon',
    icon: [
        512,
        512,
        [],
        "f2e5",
        "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
    ]
};
var $72947875341bbd79$export$750d52edc1dafc7 = {
    prefix: 'fas',
    iconName: 'utensils',
    icon: [
        416,
        512,
        [],
        "f2e7",
        "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
    ]
};
var $72947875341bbd79$export$567d5631a7b0599f = {
    prefix: 'fas',
    iconName: 'vector-square',
    icon: [
        512,
        512,
        [],
        "f5cb",
        "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
    ]
};
var $72947875341bbd79$export$f89d028573ffc0a6 = {
    prefix: 'fas',
    iconName: 'venus',
    icon: [
        288,
        512,
        [],
        "f221",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $72947875341bbd79$export$6a6f9cba7a1e5fe4 = {
    prefix: 'fas',
    iconName: 'venus-double',
    icon: [
        512,
        512,
        [],
        "f226",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
    ]
};
var $72947875341bbd79$export$63f2d9e5f4689aa8 = {
    prefix: 'fas',
    iconName: 'venus-mars',
    icon: [
        576,
        512,
        [],
        "f228",
        "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $72947875341bbd79$export$c8370e53051a657 = {
    prefix: 'fas',
    iconName: 'vest',
    icon: [
        448,
        512,
        [],
        "e085",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
    ]
};
var $72947875341bbd79$export$750a64470c2e0f3f = {
    prefix: 'fas',
    iconName: 'vest-patches',
    icon: [
        448,
        512,
        [],
        "e086",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
    ]
};
var $72947875341bbd79$export$aa014b06d2d70598 = {
    prefix: 'fas',
    iconName: 'vial',
    icon: [
        480,
        512,
        [],
        "f492",
        "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
    ]
};
var $72947875341bbd79$export$507e8edd7676b2e9 = {
    prefix: 'fas',
    iconName: 'vials',
    icon: [
        640,
        512,
        [],
        "f493",
        "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
    ]
};
var $72947875341bbd79$export$5c6bd8729527871b = {
    prefix: 'fas',
    iconName: 'video',
    icon: [
        576,
        512,
        [],
        "f03d",
        "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
    ]
};
var $72947875341bbd79$export$a714fc79f58cc9ef = {
    prefix: 'fas',
    iconName: 'video-slash',
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
    ]
};
var $72947875341bbd79$export$ee4b92e89fe0dfaf = {
    prefix: 'fas',
    iconName: 'vihara',
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
    ]
};
var $72947875341bbd79$export$37c67e0b3dc6bd1b = {
    prefix: 'fas',
    iconName: 'virus',
    icon: [
        512,
        512,
        [],
        "e074",
        "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
    ]
};
var $72947875341bbd79$export$c4ff5306c5470939 = {
    prefix: 'fas',
    iconName: 'virus-slash',
    icon: [
        640,
        512,
        [],
        "e075",
        "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
    ]
};
var $72947875341bbd79$export$ee194b18f5c6f6b6 = {
    prefix: 'fas',
    iconName: 'viruses',
    icon: [
        640,
        512,
        [],
        "e076",
        "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
    ]
};
var $72947875341bbd79$export$4f1ce88b2b4cd5cd = {
    prefix: 'fas',
    iconName: 'voicemail',
    icon: [
        640,
        512,
        [],
        "f897",
        "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
    ]
};
var $72947875341bbd79$export$a15e6fc8e68a76b0 = {
    prefix: 'fas',
    iconName: 'volleyball-ball',
    icon: [
        512,
        512,
        [],
        "f45f",
        "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
    ]
};
var $72947875341bbd79$export$69fdf57632b6cc29 = {
    prefix: 'fas',
    iconName: 'volume-down',
    icon: [
        384,
        512,
        [],
        "f027",
        "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
    ]
};
var $72947875341bbd79$export$aa8decd057dfd29b = {
    prefix: 'fas',
    iconName: 'volume-mute',
    icon: [
        512,
        512,
        [],
        "f6a9",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
    ]
};
var $72947875341bbd79$export$d94ba52e980ea0f1 = {
    prefix: 'fas',
    iconName: 'volume-off',
    icon: [
        256,
        512,
        [],
        "f026",
        "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
    ]
};
var $72947875341bbd79$export$5940d3e475d90cc4 = {
    prefix: 'fas',
    iconName: 'volume-up',
    icon: [
        576,
        512,
        [],
        "f028",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
    ]
};
var $72947875341bbd79$export$e87bb3db1608b850 = {
    prefix: 'fas',
    iconName: 'vote-yea',
    icon: [
        640,
        512,
        [],
        "f772",
        "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
    ]
};
var $72947875341bbd79$export$248171cb6dad4307 = {
    prefix: 'fas',
    iconName: 'vr-cardboard',
    icon: [
        640,
        512,
        [],
        "f729",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
    ]
};
var $72947875341bbd79$export$4886811b7174ec35 = {
    prefix: 'fas',
    iconName: 'walking',
    icon: [
        320,
        512,
        [],
        "f554",
        "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
    ]
};
var $72947875341bbd79$export$79204db8777905c8 = {
    prefix: 'fas',
    iconName: 'wallet',
    icon: [
        512,
        512,
        [],
        "f555",
        "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $72947875341bbd79$export$e3a174a50618c208 = {
    prefix: 'fas',
    iconName: 'warehouse',
    icon: [
        640,
        512,
        [],
        "f494",
        "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
    ]
};
var $72947875341bbd79$export$efaeddad0a6e901b = {
    prefix: 'fas',
    iconName: 'water',
    icon: [
        576,
        512,
        [],
        "f773",
        "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
    ]
};
var $72947875341bbd79$export$c38cf504b3bc58a2 = {
    prefix: 'fas',
    iconName: 'wave-square',
    icon: [
        640,
        512,
        [],
        "f83e",
        "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
    ]
};
var $72947875341bbd79$export$cf3bafa68a60bae4 = {
    prefix: 'fas',
    iconName: 'weight',
    icon: [
        512,
        512,
        [],
        "f496",
        "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
    ]
};
var $72947875341bbd79$export$43d1fa6671908715 = {
    prefix: 'fas',
    iconName: 'weight-hanging',
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $72947875341bbd79$export$76a9413fbe130a53 = {
    prefix: 'fas',
    iconName: 'wheelchair',
    icon: [
        512,
        512,
        [],
        "f193",
        "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
    ]
};
var $72947875341bbd79$export$1642419fe3db2857 = {
    prefix: 'fas',
    iconName: 'wifi',
    icon: [
        640,
        512,
        [],
        "f1eb",
        "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
    ]
};
var $72947875341bbd79$export$cc58cb0f2257a6a9 = {
    prefix: 'fas',
    iconName: 'wind',
    icon: [
        512,
        512,
        [],
        "f72e",
        "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
    ]
};
var $72947875341bbd79$export$18b7775f78a3e16 = {
    prefix: 'fas',
    iconName: 'window-close',
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
    ]
};
var $72947875341bbd79$export$703cd98be31ec905 = {
    prefix: 'fas',
    iconName: 'window-maximize',
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
    ]
};
var $72947875341bbd79$export$26a3f9d2784b90d8 = {
    prefix: 'fas',
    iconName: 'window-minimize',
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
    ]
};
var $72947875341bbd79$export$eccfff9bfd585652 = {
    prefix: 'fas',
    iconName: 'window-restore',
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
    ]
};
var $72947875341bbd79$export$770be8b3d5776043 = {
    prefix: 'fas',
    iconName: 'wine-bottle',
    icon: [
        512,
        512,
        [],
        "f72f",
        "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
    ]
};
var $72947875341bbd79$export$e06d6607d3577d6e = {
    prefix: 'fas',
    iconName: 'wine-glass',
    icon: [
        288,
        512,
        [],
        "f4e3",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
    ]
};
var $72947875341bbd79$export$b8ff3fe2b78aef2f = {
    prefix: 'fas',
    iconName: 'wine-glass-alt',
    icon: [
        288,
        512,
        [],
        "f5ce",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
    ]
};
var $72947875341bbd79$export$51790ddd26e431bc = {
    prefix: 'fas',
    iconName: 'won-sign',
    icon: [
        576,
        512,
        [],
        "f159",
        "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
    ]
};
var $72947875341bbd79$export$3c6c0c8185296ac5 = {
    prefix: 'fas',
    iconName: 'wrench',
    icon: [
        512,
        512,
        [],
        "f0ad",
        "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $72947875341bbd79$export$8cf137aceaaf4de0 = {
    prefix: 'fas',
    iconName: 'x-ray',
    icon: [
        640,
        512,
        [],
        "f497",
        "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
    ]
};
var $72947875341bbd79$export$30f1437f5a4e991d = {
    prefix: 'fas',
    iconName: 'yen-sign',
    icon: [
        384,
        512,
        [],
        "f157",
        "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
    ]
};
var $72947875341bbd79$export$6ec1acbf3f610b8f = {
    prefix: 'fas',
    iconName: 'yin-yang',
    icon: [
        496,
        512,
        [],
        "f6ad",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $72947875341bbd79$export$da048c47c8dcd50a = {
    faAd: $72947875341bbd79$export$7af266c3465b1ff2,
    faAddressBook: $72947875341bbd79$export$853fd1561789e3bb,
    faAddressCard: $72947875341bbd79$export$6ea408c7266ed557,
    faAdjust: $72947875341bbd79$export$cfa06e4b68edca2d,
    faAirFreshener: $72947875341bbd79$export$a5e63e89b5ccee83,
    faAlignCenter: $72947875341bbd79$export$70e29dd05344623e,
    faAlignJustify: $72947875341bbd79$export$97c42b56d462df72,
    faAlignLeft: $72947875341bbd79$export$e490f662af4d1c78,
    faAlignRight: $72947875341bbd79$export$7370f36a39a38737,
    faAllergies: $72947875341bbd79$export$dcae2101babbffff,
    faAmbulance: $72947875341bbd79$export$f5c7042778b51765,
    faAmericanSignLanguageInterpreting: $72947875341bbd79$export$23a7517099ab1b86,
    faAnchor: $72947875341bbd79$export$12a35719f889cd1,
    faAngleDoubleDown: $72947875341bbd79$export$fd504117f273ca92,
    faAngleDoubleLeft: $72947875341bbd79$export$21b0833b3cf929a7,
    faAngleDoubleRight: $72947875341bbd79$export$792931403404faf0,
    faAngleDoubleUp: $72947875341bbd79$export$9bb51e1a2c07db7c,
    faAngleDown: $72947875341bbd79$export$4b5be0142d10f342,
    faAngleLeft: $72947875341bbd79$export$3cbcd1b7e35945d2,
    faAngleRight: $72947875341bbd79$export$6bce1afb61f2eb66,
    faAngleUp: $72947875341bbd79$export$887340269e6d6cac,
    faAngry: $72947875341bbd79$export$3c96c08e234498c5,
    faAnkh: $72947875341bbd79$export$8736909014b15ca9,
    faAppleAlt: $72947875341bbd79$export$bcdd94f3977a0884,
    faArchive: $72947875341bbd79$export$26b3e1c454273f34,
    faArchway: $72947875341bbd79$export$d56753dd2eb5c323,
    faArrowAltCircleDown: $72947875341bbd79$export$ff3afbc8c0bc5d59,
    faArrowAltCircleLeft: $72947875341bbd79$export$5460a5b11a24996f,
    faArrowAltCircleRight: $72947875341bbd79$export$88962ffdad8b856d,
    faArrowAltCircleUp: $72947875341bbd79$export$3747a8ef0995eadf,
    faArrowCircleDown: $72947875341bbd79$export$6cfa36bbb3a057,
    faArrowCircleLeft: $72947875341bbd79$export$728262abb9f58d0a,
    faArrowCircleRight: $72947875341bbd79$export$7d3d828103aa3be7,
    faArrowCircleUp: $72947875341bbd79$export$a2f6f3baa50af0b1,
    faArrowDown: $72947875341bbd79$export$9686eff8d817f770,
    faArrowLeft: $72947875341bbd79$export$b7fac681e7d09400,
    faArrowRight: $72947875341bbd79$export$b4da69a0247f3620,
    faArrowUp: $72947875341bbd79$export$8e144ed4d52eef49,
    faArrowsAlt: $72947875341bbd79$export$3cdabfff52cfc73a,
    faArrowsAltH: $72947875341bbd79$export$7937ea574fb1389,
    faArrowsAltV: $72947875341bbd79$export$138cb56a3f8f7040,
    faAssistiveListeningSystems: $72947875341bbd79$export$8eeef3dc0035b165,
    faAsterisk: $72947875341bbd79$export$19eff32c0fd4f99f,
    faAt: $72947875341bbd79$export$c115e8063ee02632,
    faAtlas: $72947875341bbd79$export$380a9050e42fe5d7,
    faAtom: $72947875341bbd79$export$b5bb295e8ad4ab31,
    faAudioDescription: $72947875341bbd79$export$b6b464c98c009494,
    faAward: $72947875341bbd79$export$f8db2747dadd48f7,
    faBaby: $72947875341bbd79$export$8afab767536f59ad,
    faBabyCarriage: $72947875341bbd79$export$3b3ab4d86bad7d26,
    faBackspace: $72947875341bbd79$export$e43e3f67102fc526,
    faBackward: $72947875341bbd79$export$ae65f96ea7a4078d,
    faBacon: $72947875341bbd79$export$ab07061fe21a3a8e,
    faBacteria: $72947875341bbd79$export$7fc18cf2d526c341,
    faBacterium: $72947875341bbd79$export$b0babe4230e35ebe,
    faBahai: $72947875341bbd79$export$6d636565b3ec36b4,
    faBalanceScale: $72947875341bbd79$export$fec323dcfd81d750,
    faBalanceScaleLeft: $72947875341bbd79$export$786cb0c775487f19,
    faBalanceScaleRight: $72947875341bbd79$export$2238e05f8920005a,
    faBan: $72947875341bbd79$export$76f704d256def3c7,
    faBandAid: $72947875341bbd79$export$b14a1014df2fdf46,
    faBarcode: $72947875341bbd79$export$3825a842b5afc5aa,
    faBars: $72947875341bbd79$export$36e9cf7887265da2,
    faBaseballBall: $72947875341bbd79$export$63a3f8ceae07c7f3,
    faBasketballBall: $72947875341bbd79$export$36550ab8ffcc5b28,
    faBath: $72947875341bbd79$export$1ea66a88b8f620c9,
    faBatteryEmpty: $72947875341bbd79$export$1344b64f6e922e12,
    faBatteryFull: $72947875341bbd79$export$9338fc4614cfc0cf,
    faBatteryHalf: $72947875341bbd79$export$e6dadc1155c4ee48,
    faBatteryQuarter: $72947875341bbd79$export$acec92052ac2183,
    faBatteryThreeQuarters: $72947875341bbd79$export$cfb37069d38f379e,
    faBed: $72947875341bbd79$export$f24e0fce77994d4d,
    faBeer: $72947875341bbd79$export$f74725691538983b,
    faBell: $72947875341bbd79$export$9b6162797ab1b255,
    faBellSlash: $72947875341bbd79$export$6b31a1e5968b2378,
    faBezierCurve: $72947875341bbd79$export$a527a6267c55a54c,
    faBible: $72947875341bbd79$export$2eac809b0670d139,
    faBicycle: $72947875341bbd79$export$36cb1885ad7a570f,
    faBiking: $72947875341bbd79$export$a5bcf835dbf9c0b,
    faBinoculars: $72947875341bbd79$export$8a910017964bb8c2,
    faBiohazard: $72947875341bbd79$export$ae3a453550dec95,
    faBirthdayCake: $72947875341bbd79$export$bdcf98f725a7241a,
    faBlender: $72947875341bbd79$export$db34f7a6de38784f,
    faBlenderPhone: $72947875341bbd79$export$f35a116a762ef8fc,
    faBlind: $72947875341bbd79$export$923de21def6ea9b6,
    faBlog: $72947875341bbd79$export$890d5e011054935a,
    faBold: $72947875341bbd79$export$7e0c7fd2a2e88823,
    faBolt: $72947875341bbd79$export$6869964aa308dd31,
    faBomb: $72947875341bbd79$export$d59078f6e80b4a67,
    faBone: $72947875341bbd79$export$5902c007d5703f2d,
    faBong: $72947875341bbd79$export$e74974fac77c468e,
    faBook: $72947875341bbd79$export$c9d7ef726d1a8742,
    faBookDead: $72947875341bbd79$export$b98a3f8c3941a74a,
    faBookMedical: $72947875341bbd79$export$6feb44fec53ba30d,
    faBookOpen: $72947875341bbd79$export$8a3071811b2b7979,
    faBookReader: $72947875341bbd79$export$cee14fe33262fa7d,
    faBookmark: $72947875341bbd79$export$4ed9da5c3cca0ef1,
    faBorderAll: $72947875341bbd79$export$93a5eb721c9c0d25,
    faBorderNone: $72947875341bbd79$export$2b488402ec335d97,
    faBorderStyle: $72947875341bbd79$export$c2867ca78120d644,
    faBowlingBall: $72947875341bbd79$export$5ee2640fe105312d,
    faBox: $72947875341bbd79$export$6e7cf270cda52323,
    faBoxOpen: $72947875341bbd79$export$9010ed816a8b9c97,
    faBoxTissue: $72947875341bbd79$export$f2adc06617bc0c7,
    faBoxes: $72947875341bbd79$export$2007320dd6cde6db,
    faBraille: $72947875341bbd79$export$983e9c27cac7ed1c,
    faBrain: $72947875341bbd79$export$97fa4f4c1006ab1,
    faBreadSlice: $72947875341bbd79$export$d78e8b0681279167,
    faBriefcase: $72947875341bbd79$export$8da450d063b0eb37,
    faBriefcaseMedical: $72947875341bbd79$export$5000f52ca9819bf5,
    faBroadcastTower: $72947875341bbd79$export$f68b38d51f5c0ed,
    faBroom: $72947875341bbd79$export$2a533051418ff4ca,
    faBrush: $72947875341bbd79$export$5824ffe6f8983c83,
    faBug: $72947875341bbd79$export$a18cfac400116d9f,
    faBuilding: $72947875341bbd79$export$f26673f8b10c3d46,
    faBullhorn: $72947875341bbd79$export$dacae2b4ec565333,
    faBullseye: $72947875341bbd79$export$554720e3bf74fe90,
    faBurn: $72947875341bbd79$export$80ed4535efc60402,
    faBus: $72947875341bbd79$export$ce69441578ff2fdb,
    faBusAlt: $72947875341bbd79$export$40616edfab6d332a,
    faBusinessTime: $72947875341bbd79$export$694b7e88782dec12,
    faCalculator: $72947875341bbd79$export$693bd40950ed2c3a,
    faCalendar: $72947875341bbd79$export$34f5c36a3e80efa2,
    faCalendarAlt: $72947875341bbd79$export$cbc139f33cff356,
    faCalendarCheck: $72947875341bbd79$export$5655108e1162ba45,
    faCalendarDay: $72947875341bbd79$export$80968bcfef6481ca,
    faCalendarMinus: $72947875341bbd79$export$23e8b4955c2d951b,
    faCalendarPlus: $72947875341bbd79$export$16768a660ae3ca9d,
    faCalendarTimes: $72947875341bbd79$export$99b20d7352fbcf08,
    faCalendarWeek: $72947875341bbd79$export$39be5cb4aed5a521,
    faCamera: $72947875341bbd79$export$84ffbd7161ca2008,
    faCameraRetro: $72947875341bbd79$export$41dbdadc07a89b05,
    faCampground: $72947875341bbd79$export$295287303c0e9c7c,
    faCandyCane: $72947875341bbd79$export$14d66ba7571ae0b9,
    faCannabis: $72947875341bbd79$export$8ec2f752344b69bd,
    faCapsules: $72947875341bbd79$export$ba6fd4a436804a48,
    faCar: $72947875341bbd79$export$9eefe7fcdf123b76,
    faCarAlt: $72947875341bbd79$export$7937ed2462a665c0,
    faCarBattery: $72947875341bbd79$export$a44d0c11093d9c1e,
    faCarCrash: $72947875341bbd79$export$8ff55566398404cd,
    faCarSide: $72947875341bbd79$export$6f7218565b1b8d0e,
    faCaravan: $72947875341bbd79$export$afb5d0eee7c1bdb,
    faCaretDown: $72947875341bbd79$export$f9395ef707603e40,
    faCaretLeft: $72947875341bbd79$export$85a918a11b7643c2,
    faCaretRight: $72947875341bbd79$export$f1011352b01c1c0,
    faCaretSquareDown: $72947875341bbd79$export$61aea18df1c84401,
    faCaretSquareLeft: $72947875341bbd79$export$d0c8ba444f1f9581,
    faCaretSquareRight: $72947875341bbd79$export$ae86c9de7e0f62fa,
    faCaretSquareUp: $72947875341bbd79$export$307ae80b26533ce5,
    faCaretUp: $72947875341bbd79$export$7de776bdab4e536d,
    faCarrot: $72947875341bbd79$export$28e93ec9f5e2ddf3,
    faCartArrowDown: $72947875341bbd79$export$9206260ff0c0c616,
    faCartPlus: $72947875341bbd79$export$6675e2bf21fdb87e,
    faCashRegister: $72947875341bbd79$export$6357093f67788b33,
    faCat: $72947875341bbd79$export$ab927dada03be4b3,
    faCertificate: $72947875341bbd79$export$a881f37164b11fbf,
    faChair: $72947875341bbd79$export$a339864ee3df7e9a,
    faChalkboard: $72947875341bbd79$export$49a36efd66df775,
    faChalkboardTeacher: $72947875341bbd79$export$443fcf69b0155291,
    faChargingStation: $72947875341bbd79$export$bab2cd86f8c65657,
    faChartArea: $72947875341bbd79$export$2acab8312b7a999b,
    faChartBar: $72947875341bbd79$export$b532f5d25de97633,
    faChartLine: $72947875341bbd79$export$e022f62a119e1d93,
    faChartPie: $72947875341bbd79$export$1de7b9cf7d1b153b,
    faCheck: $72947875341bbd79$export$62b2c752fccc6a9c,
    faCheckCircle: $72947875341bbd79$export$be9e388158c74f29,
    faCheckDouble: $72947875341bbd79$export$f178c8c2ad3cc861,
    faCheckSquare: $72947875341bbd79$export$f0c8040f596df7fe,
    faCheese: $72947875341bbd79$export$549b99473b7201e6,
    faChess: $72947875341bbd79$export$442fddbbd741c590,
    faChessBishop: $72947875341bbd79$export$a831eedd2f59c62f,
    faChessBoard: $72947875341bbd79$export$bd301515df6246af,
    faChessKing: $72947875341bbd79$export$d5713874f8fefe1b,
    faChessKnight: $72947875341bbd79$export$861b1f13085cf122,
    faChessPawn: $72947875341bbd79$export$3db75d5ac9e98468,
    faChessQueen: $72947875341bbd79$export$7b8ce73615739d30,
    faChessRook: $72947875341bbd79$export$5d65c40a109eb09c,
    faChevronCircleDown: $72947875341bbd79$export$9926124d75b2ecab,
    faChevronCircleLeft: $72947875341bbd79$export$4a42c8c2451a33fd,
    faChevronCircleRight: $72947875341bbd79$export$2a5db4f6eba6f2b,
    faChevronCircleUp: $72947875341bbd79$export$b786cf5db03f2c36,
    faChevronDown: $72947875341bbd79$export$8db9bc521720fccd,
    faChevronLeft: $72947875341bbd79$export$75702e3e3dd44a44,
    faChevronRight: $72947875341bbd79$export$930de8c26eb20490,
    faChevronUp: $72947875341bbd79$export$877e5ae47a854215,
    faChild: $72947875341bbd79$export$60b41e3581d1739a,
    faChurch: $72947875341bbd79$export$16a3f12c6ae9650,
    faCircle: $72947875341bbd79$export$4280b2387fbdad12,
    faCircleNotch: $72947875341bbd79$export$9429fd8df55155d,
    faCity: $72947875341bbd79$export$a9947c2888b3c8fd,
    faClinicMedical: $72947875341bbd79$export$20d8a680febc7434,
    faClipboard: $72947875341bbd79$export$97d84347d71ba297,
    faClipboardCheck: $72947875341bbd79$export$7babcb2c90eb609a,
    faClipboardList: $72947875341bbd79$export$2c5a9d8548d8810e,
    faClock: $72947875341bbd79$export$95b9968e7fceb821,
    faClone: $72947875341bbd79$export$76c1aa4bf9a39458,
    faClosedCaptioning: $72947875341bbd79$export$8e047801a8603af7,
    faCloud: $72947875341bbd79$export$8bb3c4d5c2f50243,
    faCloudDownloadAlt: $72947875341bbd79$export$351357a14c41f824,
    faCloudMeatball: $72947875341bbd79$export$5d120e8b87ad33f4,
    faCloudMoon: $72947875341bbd79$export$482eb125aaf0fbc2,
    faCloudMoonRain: $72947875341bbd79$export$301c3fab0c4545bd,
    faCloudRain: $72947875341bbd79$export$a6c308ee087b4ded,
    faCloudShowersHeavy: $72947875341bbd79$export$af51c741ee9cc090,
    faCloudSun: $72947875341bbd79$export$dcaadfd9c98e42a1,
    faCloudSunRain: $72947875341bbd79$export$dd9dc9b4227dbe94,
    faCloudUploadAlt: $72947875341bbd79$export$e73b3e819b9d14a5,
    faCocktail: $72947875341bbd79$export$4be708f1e41d387b,
    faCode: $72947875341bbd79$export$eba095993e51cc97,
    faCodeBranch: $72947875341bbd79$export$aa054a78ab078db3,
    faCoffee: $72947875341bbd79$export$1d24a9e457278011,
    faCog: $72947875341bbd79$export$d6298bbfd1912a78,
    faCogs: $72947875341bbd79$export$af1575770afc9559,
    faCoins: $72947875341bbd79$export$bc5da164799a0e,
    faColumns: $72947875341bbd79$export$bb861166644ac28a,
    faComment: $72947875341bbd79$export$805cd88398a70581,
    faCommentAlt: $72947875341bbd79$export$6e96904d9af0ec4a,
    faCommentDollar: $72947875341bbd79$export$7a088030853df12c,
    faCommentDots: $72947875341bbd79$export$63ffcb3d4e94cb92,
    faCommentMedical: $72947875341bbd79$export$101422b773924276,
    faCommentSlash: $72947875341bbd79$export$3786a0422a3f33ea,
    faComments: $72947875341bbd79$export$932912e74adb8939,
    faCommentsDollar: $72947875341bbd79$export$d477129b070e5ac4,
    faCompactDisc: $72947875341bbd79$export$84021631df0f831b,
    faCompass: $72947875341bbd79$export$b4d344633433e50e,
    faCompress: $72947875341bbd79$export$83632d1150d3541f,
    faCompressAlt: $72947875341bbd79$export$a05650ebe54bede,
    faCompressArrowsAlt: $72947875341bbd79$export$39205db0ea980efd,
    faConciergeBell: $72947875341bbd79$export$ad92ffbbfbc0fcf3,
    faCookie: $72947875341bbd79$export$b3e64f5f68c6623f,
    faCookieBite: $72947875341bbd79$export$317dde8664f7de71,
    faCopy: $72947875341bbd79$export$e9bd786d30cb716c,
    faCopyright: $72947875341bbd79$export$da61665fff8aebfe,
    faCouch: $72947875341bbd79$export$ce96e32767a7dd51,
    faCreditCard: $72947875341bbd79$export$3e7437bf6535bef0,
    faCrop: $72947875341bbd79$export$afa58590dfb6fca2,
    faCropAlt: $72947875341bbd79$export$d932915fde4f1010,
    faCross: $72947875341bbd79$export$9d0a89fcd084abb,
    faCrosshairs: $72947875341bbd79$export$721c101130c40043,
    faCrow: $72947875341bbd79$export$bfa312207b788ed9,
    faCrown: $72947875341bbd79$export$dc1083dcd1d7b9d6,
    faCrutch: $72947875341bbd79$export$e94134641c0e2,
    faCube: $72947875341bbd79$export$973ae4f1e4d2ce78,
    faCubes: $72947875341bbd79$export$30523a9441a31e97,
    faCut: $72947875341bbd79$export$66847f2a71b260e7,
    faDatabase: $72947875341bbd79$export$24680dede86b1883,
    faDeaf: $72947875341bbd79$export$4b666adf83f0de01,
    faDemocrat: $72947875341bbd79$export$a1672d808fbed0bd,
    faDesktop: $72947875341bbd79$export$6e6ddc253102e596,
    faDharmachakra: $72947875341bbd79$export$45cbd92c28deb2c7,
    faDiagnoses: $72947875341bbd79$export$68bad2b52a90d1fa,
    faDice: $72947875341bbd79$export$4ed8206e6619cc8f,
    faDiceD20: $72947875341bbd79$export$b06003a02c9055bd,
    faDiceD6: $72947875341bbd79$export$64bfd48ed353c031,
    faDiceFive: $72947875341bbd79$export$d9769fb795c2db82,
    faDiceFour: $72947875341bbd79$export$2df6451abf70a6ff,
    faDiceOne: $72947875341bbd79$export$d91800b7be5303b0,
    faDiceSix: $72947875341bbd79$export$3397c7b4679acccc,
    faDiceThree: $72947875341bbd79$export$221059e0d5fd8958,
    faDiceTwo: $72947875341bbd79$export$4d85df590065572f,
    faDigitalTachograph: $72947875341bbd79$export$b3bf1994f0fefe98,
    faDirections: $72947875341bbd79$export$6a6973de44442fe5,
    faDisease: $72947875341bbd79$export$c7675a37487adc45,
    faDivide: $72947875341bbd79$export$89fa217ec5503ac9,
    faDizzy: $72947875341bbd79$export$89a2b10dabc487e8,
    faDna: $72947875341bbd79$export$c062100d54a2da00,
    faDog: $72947875341bbd79$export$c6406747800cf702,
    faDollarSign: $72947875341bbd79$export$fb420d3e4d8c6a18,
    faDolly: $72947875341bbd79$export$5879d0bca1aa497b,
    faDollyFlatbed: $72947875341bbd79$export$f7c6efb60c53b285,
    faDonate: $72947875341bbd79$export$40050ae52860cde7,
    faDoorClosed: $72947875341bbd79$export$2c79e1a422528bba,
    faDoorOpen: $72947875341bbd79$export$41821b9a6fd703de,
    faDotCircle: $72947875341bbd79$export$92bc269cb244d66a,
    faDove: $72947875341bbd79$export$a1ab1e69a300089f,
    faDownload: $72947875341bbd79$export$8f734e51d72ca13a,
    faDraftingCompass: $72947875341bbd79$export$c8c2b127d13b9d79,
    faDragon: $72947875341bbd79$export$ae1875ba975aa0e9,
    faDrawPolygon: $72947875341bbd79$export$df9bd3777d1154d2,
    faDrum: $72947875341bbd79$export$5b9205e1042594b7,
    faDrumSteelpan: $72947875341bbd79$export$48d1206500db2e9d,
    faDrumstickBite: $72947875341bbd79$export$482976e9a4ab10f3,
    faDumbbell: $72947875341bbd79$export$56700074cf37be5c,
    faDumpster: $72947875341bbd79$export$3b934e22d1851a3b,
    faDumpsterFire: $72947875341bbd79$export$25e9b29b3f2230b5,
    faDungeon: $72947875341bbd79$export$1156dc6acb0058bd,
    faEdit: $72947875341bbd79$export$7be713e57d023733,
    faEgg: $72947875341bbd79$export$1199a8ce85311ab5,
    faEject: $72947875341bbd79$export$8484041d5b209494,
    faEllipsisH: $72947875341bbd79$export$c9f2fedd4489a2ee,
    faEllipsisV: $72947875341bbd79$export$e58494c7fcb5380,
    faEnvelope: $72947875341bbd79$export$6f095630677adc,
    faEnvelopeOpen: $72947875341bbd79$export$c6c3bd5f7d9b8bf2,
    faEnvelopeOpenText: $72947875341bbd79$export$f5c53ce8ec380d11,
    faEnvelopeSquare: $72947875341bbd79$export$354e159473e73552,
    faEquals: $72947875341bbd79$export$a7c5f5e4805fdab,
    faEraser: $72947875341bbd79$export$e7fc4fe34e767f28,
    faEthernet: $72947875341bbd79$export$6bad2c9f317b52e5,
    faEuroSign: $72947875341bbd79$export$902a3969bb113dff,
    faExchangeAlt: $72947875341bbd79$export$f6c6fb20d374b128,
    faExclamation: $72947875341bbd79$export$de6218b649cbb6a9,
    faExclamationCircle: $72947875341bbd79$export$220e07e14c5d7e5d,
    faExclamationTriangle: $72947875341bbd79$export$3d249b63b52cce7c,
    faExpand: $72947875341bbd79$export$1fe4a9976a241685,
    faExpandAlt: $72947875341bbd79$export$bcb8d86a3a1d6eb6,
    faExpandArrowsAlt: $72947875341bbd79$export$6219dcd88b5fa6c2,
    faExternalLinkAlt: $72947875341bbd79$export$d7f107e456ab0306,
    faExternalLinkSquareAlt: $72947875341bbd79$export$e4cdf2977151ee26,
    faEye: $72947875341bbd79$export$b8c3e79e8c99c95b,
    faEyeDropper: $72947875341bbd79$export$1bc3e0ad56dc9eb0,
    faEyeSlash: $72947875341bbd79$export$ed3f2918429d029a,
    faFan: $72947875341bbd79$export$55145a3dae4f984a,
    faFastBackward: $72947875341bbd79$export$e6246a3279a379b8,
    faFastForward: $72947875341bbd79$export$61a8cdc53c2e078d,
    faFaucet: $72947875341bbd79$export$a0856b225f3b0614,
    faFax: $72947875341bbd79$export$b5698497901d7197,
    faFeather: $72947875341bbd79$export$5e19aea195b31816,
    faFeatherAlt: $72947875341bbd79$export$68cf766c786bcd78,
    faFemale: $72947875341bbd79$export$70e8e75e61dd7169,
    faFighterJet: $72947875341bbd79$export$102b809faf56e033,
    faFile: $72947875341bbd79$export$cad54bead856a678,
    faFileAlt: $72947875341bbd79$export$243b47dca32bf0b8,
    faFileArchive: $72947875341bbd79$export$bf2047a9946b5c3f,
    faFileAudio: $72947875341bbd79$export$b8d24c57c9e64933,
    faFileCode: $72947875341bbd79$export$143d0ca7d2200f20,
    faFileContract: $72947875341bbd79$export$70fde3f3fdaa6a6a,
    faFileCsv: $72947875341bbd79$export$82cea4f586f6ec9,
    faFileDownload: $72947875341bbd79$export$1013b9966d758343,
    faFileExcel: $72947875341bbd79$export$77cb1a465c4fe84,
    faFileExport: $72947875341bbd79$export$364f19abcfac1b0a,
    faFileImage: $72947875341bbd79$export$6440b286d3cbac9b,
    faFileImport: $72947875341bbd79$export$d796c05153b1255c,
    faFileInvoice: $72947875341bbd79$export$bef39294aed2281a,
    faFileInvoiceDollar: $72947875341bbd79$export$a3dced32d48cb1ea,
    faFileMedical: $72947875341bbd79$export$56cbcd962389b090,
    faFileMedicalAlt: $72947875341bbd79$export$ef02a0f5b39aa61f,
    faFilePdf: $72947875341bbd79$export$38611f1c776aba73,
    faFilePowerpoint: $72947875341bbd79$export$c341daeecdea449a,
    faFilePrescription: $72947875341bbd79$export$a20cb90865b6beb8,
    faFileSignature: $72947875341bbd79$export$d0de575ac166712b,
    faFileUpload: $72947875341bbd79$export$dd55ded1264643d2,
    faFileVideo: $72947875341bbd79$export$b44eb38345c6a964,
    faFileWord: $72947875341bbd79$export$f0858dff6e769cf6,
    faFill: $72947875341bbd79$export$d3c2bcfd3b861e4a,
    faFillDrip: $72947875341bbd79$export$38320138fc0262d0,
    faFilm: $72947875341bbd79$export$c03de0cc616e77bb,
    faFilter: $72947875341bbd79$export$f253a38d7142e29f,
    faFingerprint: $72947875341bbd79$export$614dc068d88655af,
    faFire: $72947875341bbd79$export$7b24b34ef6cc130c,
    faFireAlt: $72947875341bbd79$export$70dc26b4926d0b1b,
    faFireExtinguisher: $72947875341bbd79$export$d75fb6743634a0a,
    faFirstAid: $72947875341bbd79$export$5b01ccb2da4c4387,
    faFish: $72947875341bbd79$export$24228a855c5f6812,
    faFistRaised: $72947875341bbd79$export$fa0323a4d7489a8d,
    faFlag: $72947875341bbd79$export$6591b1ea509be9da,
    faFlagCheckered: $72947875341bbd79$export$92fad97e19a9fea,
    faFlagUsa: $72947875341bbd79$export$19357abad396e723,
    faFlask: $72947875341bbd79$export$f9b579ba06048af,
    faFlushed: $72947875341bbd79$export$dfd2bd012685aeac,
    faFolder: $72947875341bbd79$export$72b780186370e953,
    faFolderMinus: $72947875341bbd79$export$758f1fb3784e4080,
    faFolderOpen: $72947875341bbd79$export$ff7e93418af88b78,
    faFolderPlus: $72947875341bbd79$export$e18e05ffa2045d3b,
    faFont: $72947875341bbd79$export$a5dc297d3f60936,
    faFontAwesomeLogoFull: $72947875341bbd79$export$6e20d421a2e0f320,
    faFootballBall: $72947875341bbd79$export$e8fd664711e31704,
    faForward: $72947875341bbd79$export$a8710cdb23198d53,
    faFrog: $72947875341bbd79$export$fe2358263efac504,
    faFrown: $72947875341bbd79$export$43b7108508aecc5f,
    faFrownOpen: $72947875341bbd79$export$c4775e66bed5d96,
    faFunnelDollar: $72947875341bbd79$export$cebe38ad8f0a143d,
    faFutbol: $72947875341bbd79$export$65a345b33858a655,
    faGamepad: $72947875341bbd79$export$6a66b1b639455bef,
    faGasPump: $72947875341bbd79$export$84666c793cb2a347,
    faGavel: $72947875341bbd79$export$c36fb40057e2c3aa,
    faGem: $72947875341bbd79$export$31ee86ac717db552,
    faGenderless: $72947875341bbd79$export$c093cc22e88981c2,
    faGhost: $72947875341bbd79$export$1a989eb1919c64c1,
    faGift: $72947875341bbd79$export$b2727de8ccdbb5ec,
    faGifts: $72947875341bbd79$export$de9a67b55dbe819a,
    faGlassCheers: $72947875341bbd79$export$20007d7d74cb98fe,
    faGlassMartini: $72947875341bbd79$export$e96f280e39af4a91,
    faGlassMartiniAlt: $72947875341bbd79$export$2258439b8f4e7acb,
    faGlassWhiskey: $72947875341bbd79$export$fdec0f5f1a169419,
    faGlasses: $72947875341bbd79$export$58d7d709c0a8ca5f,
    faGlobe: $72947875341bbd79$export$b1b1cdce4a19c682,
    faGlobeAfrica: $72947875341bbd79$export$64af36f3b403a57c,
    faGlobeAmericas: $72947875341bbd79$export$e96bcc7bde9498db,
    faGlobeAsia: $72947875341bbd79$export$796fdfc909e603f4,
    faGlobeEurope: $72947875341bbd79$export$5318b8ede86cc96b,
    faGolfBall: $72947875341bbd79$export$2251487a9a33c682,
    faGopuram: $72947875341bbd79$export$31f89d8ac1d14ed6,
    faGraduationCap: $72947875341bbd79$export$874e305fd7920cce,
    faGreaterThan: $72947875341bbd79$export$da07b6bc24a496ca,
    faGreaterThanEqual: $72947875341bbd79$export$7bf8dfe2e6661a54,
    faGrimace: $72947875341bbd79$export$3d08cd36ac1ef231,
    faGrin: $72947875341bbd79$export$37e1f10b6de76621,
    faGrinAlt: $72947875341bbd79$export$b4abebfe416d36ba,
    faGrinBeam: $72947875341bbd79$export$734da5249381ec7e,
    faGrinBeamSweat: $72947875341bbd79$export$14d0ccc54c5b6826,
    faGrinHearts: $72947875341bbd79$export$c56cf0e0c3bc5ed2,
    faGrinSquint: $72947875341bbd79$export$243ae757907b1580,
    faGrinSquintTears: $72947875341bbd79$export$542206d6a85f3b42,
    faGrinStars: $72947875341bbd79$export$64347a5c8c402ef4,
    faGrinTears: $72947875341bbd79$export$b2f7512221512b5b,
    faGrinTongue: $72947875341bbd79$export$ef222816a43a4b3a,
    faGrinTongueSquint: $72947875341bbd79$export$4edf34c3def09a31,
    faGrinTongueWink: $72947875341bbd79$export$58099903d50aefb3,
    faGrinWink: $72947875341bbd79$export$2397fcd34eb12177,
    faGripHorizontal: $72947875341bbd79$export$4a45308d6c8decc1,
    faGripLines: $72947875341bbd79$export$1412f35381064d7d,
    faGripLinesVertical: $72947875341bbd79$export$523960de087f5198,
    faGripVertical: $72947875341bbd79$export$cacbd95c283996ec,
    faGuitar: $72947875341bbd79$export$790dd5b32282b6fb,
    faHSquare: $72947875341bbd79$export$f08bbcf8f59eafc2,
    faHamburger: $72947875341bbd79$export$bab3bb9f4f59363,
    faHammer: $72947875341bbd79$export$6310f315e1ebbca5,
    faHamsa: $72947875341bbd79$export$38d20d399463edf9,
    faHandHolding: $72947875341bbd79$export$e6094d25274088ab,
    faHandHoldingHeart: $72947875341bbd79$export$97e5ef3e80a0fbef,
    faHandHoldingMedical: $72947875341bbd79$export$bb2a6b1b5e852300,
    faHandHoldingUsd: $72947875341bbd79$export$47d27bc305b59690,
    faHandHoldingWater: $72947875341bbd79$export$4265371b99d38b95,
    faHandLizard: $72947875341bbd79$export$54608d0a883fea4d,
    faHandMiddleFinger: $72947875341bbd79$export$bd40d3a3a16fb147,
    faHandPaper: $72947875341bbd79$export$6e6216c8b50471bb,
    faHandPeace: $72947875341bbd79$export$e49e3cfceea441cc,
    faHandPointDown: $72947875341bbd79$export$f6dcbf0a940428f4,
    faHandPointLeft: $72947875341bbd79$export$b276ec3dc9760d39,
    faHandPointRight: $72947875341bbd79$export$f7bc8714c970afa4,
    faHandPointUp: $72947875341bbd79$export$cdc9f5e7e94e76da,
    faHandPointer: $72947875341bbd79$export$d97ff927c450c87f,
    faHandRock: $72947875341bbd79$export$97a81eba394c8c44,
    faHandScissors: $72947875341bbd79$export$c578e919f2c5c135,
    faHandSparkles: $72947875341bbd79$export$72e2d874a963de0c,
    faHandSpock: $72947875341bbd79$export$2262d6b626de1120,
    faHands: $72947875341bbd79$export$f9712d0cf5150f0c,
    faHandsHelping: $72947875341bbd79$export$287dbb1632da0d44,
    faHandsWash: $72947875341bbd79$export$996b5dea53b124e3,
    faHandshake: $72947875341bbd79$export$b4c63e9bfc7906f1,
    faHandshakeAltSlash: $72947875341bbd79$export$ca302f956ae9f1bf,
    faHandshakeSlash: $72947875341bbd79$export$2cef3f81ad90fb76,
    faHanukiah: $72947875341bbd79$export$3dcd4ca3f7108a82,
    faHardHat: $72947875341bbd79$export$7b72177558a98b6f,
    faHashtag: $72947875341bbd79$export$c92c903bade56844,
    faHatCowboy: $72947875341bbd79$export$37672611144b857b,
    faHatCowboySide: $72947875341bbd79$export$ab6f71fd6878da90,
    faHatWizard: $72947875341bbd79$export$7daa48199dcb2ad1,
    faHdd: $72947875341bbd79$export$62551e9c5ba7093f,
    faHeadSideCough: $72947875341bbd79$export$3cd04b7c1624f598,
    faHeadSideCoughSlash: $72947875341bbd79$export$b293ee8fb8e6b0c4,
    faHeadSideMask: $72947875341bbd79$export$280300af4baa1a3e,
    faHeadSideVirus: $72947875341bbd79$export$5b64b916710da7c7,
    faHeading: $72947875341bbd79$export$4805b8d175aeb9fb,
    faHeadphones: $72947875341bbd79$export$ad02dd8ca5816958,
    faHeadphonesAlt: $72947875341bbd79$export$6f0433fa527dd5be,
    faHeadset: $72947875341bbd79$export$23b086400a31acfe,
    faHeart: $72947875341bbd79$export$e4b51a47a2f8b9db,
    faHeartBroken: $72947875341bbd79$export$4a565395cb65b282,
    faHeartbeat: $72947875341bbd79$export$ca880e19206e80aa,
    faHelicopter: $72947875341bbd79$export$612d3e1afaf45fa5,
    faHighlighter: $72947875341bbd79$export$73801ed54b42fabe,
    faHiking: $72947875341bbd79$export$b2ab0105a901499e,
    faHippo: $72947875341bbd79$export$d4c909619093de2d,
    faHistory: $72947875341bbd79$export$76d1986559ca7b7a,
    faHockeyPuck: $72947875341bbd79$export$a274b02dc75663dc,
    faHollyBerry: $72947875341bbd79$export$273296afacf93991,
    faHome: $72947875341bbd79$export$48f10d71ec526479,
    faHorse: $72947875341bbd79$export$5b05f097fa38352a,
    faHorseHead: $72947875341bbd79$export$5bcca85203ebd1e8,
    faHospital: $72947875341bbd79$export$7a76c9d35b42d691,
    faHospitalAlt: $72947875341bbd79$export$cea7736417b94a3b,
    faHospitalSymbol: $72947875341bbd79$export$c8a3c78d99c23fed,
    faHospitalUser: $72947875341bbd79$export$684703c93d630cc5,
    faHotTub: $72947875341bbd79$export$4842af92b516c40b,
    faHotdog: $72947875341bbd79$export$9fae219b4d3ce0be,
    faHotel: $72947875341bbd79$export$c402efcf01d5ca07,
    faHourglass: $72947875341bbd79$export$b9098a890f61e022,
    faHourglassEnd: $72947875341bbd79$export$52757ecc5b1e25b9,
    faHourglassHalf: $72947875341bbd79$export$703272eebf5e3eea,
    faHourglassStart: $72947875341bbd79$export$f0c28584caa8f4b,
    faHouseDamage: $72947875341bbd79$export$8d7e943005ce0b49,
    faHouseUser: $72947875341bbd79$export$9a513ee921e8e885,
    faHryvnia: $72947875341bbd79$export$33d5f94bd6f75f59,
    faICursor: $72947875341bbd79$export$7fddf76ec23943d8,
    faIceCream: $72947875341bbd79$export$dd52741c60cc638f,
    faIcicles: $72947875341bbd79$export$78792ed87d92a3ad,
    faIcons: $72947875341bbd79$export$7fe2894454d8eb8a,
    faIdBadge: $72947875341bbd79$export$a75288855ea05282,
    faIdCard: $72947875341bbd79$export$782ac893fc22249b,
    faIdCardAlt: $72947875341bbd79$export$dc37ebbac31f6c6c,
    faIgloo: $72947875341bbd79$export$4a284575edd6f1af,
    faImage: $72947875341bbd79$export$7e9f0928967e03b,
    faImages: $72947875341bbd79$export$74f06b41ed2ca28a,
    faInbox: $72947875341bbd79$export$366b69cbdce46334,
    faIndent: $72947875341bbd79$export$318208bc30aeebcc,
    faIndustry: $72947875341bbd79$export$5548c3eb51060fa8,
    faInfinity: $72947875341bbd79$export$a590003279d671b8,
    faInfo: $72947875341bbd79$export$d469b770895f47ac,
    faInfoCircle: $72947875341bbd79$export$aa9288aeadf882fa,
    faItalic: $72947875341bbd79$export$16e344bae4d495ed,
    faJedi: $72947875341bbd79$export$859f204e59641ca4,
    faJoint: $72947875341bbd79$export$e5a289fb22ffb8cb,
    faJournalWhills: $72947875341bbd79$export$66a0d8d45aab6631,
    faKaaba: $72947875341bbd79$export$ab1408bfbe914cc9,
    faKey: $72947875341bbd79$export$fa6ecc35e7315db,
    faKeyboard: $72947875341bbd79$export$fb61df5d98785fa8,
    faKhanda: $72947875341bbd79$export$8d41d1f1ba3f9217,
    faKiss: $72947875341bbd79$export$c762a77aabf64fd0,
    faKissBeam: $72947875341bbd79$export$d6ff8a73c0812e63,
    faKissWinkHeart: $72947875341bbd79$export$ebba617701dfb917,
    faKiwiBird: $72947875341bbd79$export$d9933d91e1314d02,
    faLandmark: $72947875341bbd79$export$2bebc54c51db6505,
    faLanguage: $72947875341bbd79$export$8a7bee49fdf8c954,
    faLaptop: $72947875341bbd79$export$c2dee3bd177275a2,
    faLaptopCode: $72947875341bbd79$export$94100f4c6ee29932,
    faLaptopHouse: $72947875341bbd79$export$efd983de5e4d6ad3,
    faLaptopMedical: $72947875341bbd79$export$ba2fa38f7bcc6930,
    faLaugh: $72947875341bbd79$export$6c74e314e801a4fe,
    faLaughBeam: $72947875341bbd79$export$a88d1f4073ea9369,
    faLaughSquint: $72947875341bbd79$export$b206e700cf7084e1,
    faLaughWink: $72947875341bbd79$export$77ac40095f39933e,
    faLayerGroup: $72947875341bbd79$export$a137712e11e257dd,
    faLeaf: $72947875341bbd79$export$7c497bae2754a087,
    faLemon: $72947875341bbd79$export$4fbda8f64648f3b5,
    faLessThan: $72947875341bbd79$export$7f24f1bf98af5411,
    faLessThanEqual: $72947875341bbd79$export$b2c723344cff0d8,
    faLevelDownAlt: $72947875341bbd79$export$c07eb6ff5a382cbd,
    faLevelUpAlt: $72947875341bbd79$export$d6f21a309b179c3d,
    faLifeRing: $72947875341bbd79$export$53dd2cacf674142a,
    faLightbulb: $72947875341bbd79$export$1e80f89fe84a215b,
    faLink: $72947875341bbd79$export$88bc01ff8dbecc55,
    faLiraSign: $72947875341bbd79$export$f0f37dbc60110b10,
    faList: $72947875341bbd79$export$6cfc59842fedbc16,
    faListAlt: $72947875341bbd79$export$c6327a203ffc65a3,
    faListOl: $72947875341bbd79$export$3db8f67cd0fc963b,
    faListUl: $72947875341bbd79$export$f8a219cf4f516384,
    faLocationArrow: $72947875341bbd79$export$4ac9c4c370f7b157,
    faLock: $72947875341bbd79$export$7aa08ad5d562578a,
    faLockOpen: $72947875341bbd79$export$84b5acad4436d02a,
    faLongArrowAltDown: $72947875341bbd79$export$8b92530ca6418c2f,
    faLongArrowAltLeft: $72947875341bbd79$export$a8b3226b2bf323d,
    faLongArrowAltRight: $72947875341bbd79$export$533e1f578f74c066,
    faLongArrowAltUp: $72947875341bbd79$export$43c8f2a46326c55f,
    faLowVision: $72947875341bbd79$export$7a65d2aa54cb4e93,
    faLuggageCart: $72947875341bbd79$export$bd1e24dd3cde8514,
    faLungs: $72947875341bbd79$export$ba9b387e84727819,
    faLungsVirus: $72947875341bbd79$export$895159d10626af74,
    faMagic: $72947875341bbd79$export$e58f9b502d4dd52d,
    faMagnet: $72947875341bbd79$export$78932e9c9abea6b7,
    faMailBulk: $72947875341bbd79$export$dd24f40c5337e2e1,
    faMale: $72947875341bbd79$export$2e21f9dba1630651,
    faMap: $72947875341bbd79$export$fc82fb79180cd17c,
    faMapMarked: $72947875341bbd79$export$df04458e7e32352c,
    faMapMarkedAlt: $72947875341bbd79$export$a977d47c74d8e86c,
    faMapMarker: $72947875341bbd79$export$10d360e4f1a554dd,
    faMapMarkerAlt: $72947875341bbd79$export$4be92fa780613f93,
    faMapPin: $72947875341bbd79$export$184725965b3402dc,
    faMapSigns: $72947875341bbd79$export$743f4b1071b3333a,
    faMarker: $72947875341bbd79$export$e6789173649caa25,
    faMars: $72947875341bbd79$export$a9f5c0b9c1e77a6f,
    faMarsDouble: $72947875341bbd79$export$2f8a28204bb4b86f,
    faMarsStroke: $72947875341bbd79$export$aa05fce255a5d269,
    faMarsStrokeH: $72947875341bbd79$export$5cb0daeafbcdabe3,
    faMarsStrokeV: $72947875341bbd79$export$ed7aa1c25104f333,
    faMask: $72947875341bbd79$export$7b028758c03b9655,
    faMedal: $72947875341bbd79$export$b48a5be96314835a,
    faMedkit: $72947875341bbd79$export$e75f02bae5b7d34b,
    faMeh: $72947875341bbd79$export$6d2db489aaeeecd2,
    faMehBlank: $72947875341bbd79$export$e945435725f71e88,
    faMehRollingEyes: $72947875341bbd79$export$fdc62a1bea767cc2,
    faMemory: $72947875341bbd79$export$5f9bd9f6df021f93,
    faMenorah: $72947875341bbd79$export$232452c59d77c56e,
    faMercury: $72947875341bbd79$export$e134ecd00b622a47,
    faMeteor: $72947875341bbd79$export$1439f0d6365138da,
    faMicrochip: $72947875341bbd79$export$4a7bb4be15f35178,
    faMicrophone: $72947875341bbd79$export$eed3c491effe6d12,
    faMicrophoneAlt: $72947875341bbd79$export$f08ef94fea14f5ac,
    faMicrophoneAltSlash: $72947875341bbd79$export$d2a53a388f30780,
    faMicrophoneSlash: $72947875341bbd79$export$843f63d64e6f7951,
    faMicroscope: $72947875341bbd79$export$6a99139787bf9967,
    faMinus: $72947875341bbd79$export$fee0376c250cdef,
    faMinusCircle: $72947875341bbd79$export$f3979b49bf57313c,
    faMinusSquare: $72947875341bbd79$export$ffe9387966b3e681,
    faMitten: $72947875341bbd79$export$5030322c5fc886d7,
    faMobile: $72947875341bbd79$export$59edacfad04cd121,
    faMobileAlt: $72947875341bbd79$export$e9599bc6cd92234d,
    faMoneyBill: $72947875341bbd79$export$608138a7337b5d1a,
    faMoneyBillAlt: $72947875341bbd79$export$a35d573395884c3d,
    faMoneyBillWave: $72947875341bbd79$export$53e23123cc9a6796,
    faMoneyBillWaveAlt: $72947875341bbd79$export$1613858e873cbb3e,
    faMoneyCheck: $72947875341bbd79$export$be069f641c85d0b3,
    faMoneyCheckAlt: $72947875341bbd79$export$8c6ccc9745897cb2,
    faMonument: $72947875341bbd79$export$6f9b0bfc012deb25,
    faMoon: $72947875341bbd79$export$c4c2f69a53bab720,
    faMortarPestle: $72947875341bbd79$export$55ceb5d0c144580a,
    faMosque: $72947875341bbd79$export$4999586d7e1087fb,
    faMotorcycle: $72947875341bbd79$export$f26017bdca99338d,
    faMountain: $72947875341bbd79$export$64f9eb99c9749cce,
    faMouse: $72947875341bbd79$export$198b96b894c66074,
    faMousePointer: $72947875341bbd79$export$2e19a69cc26b147,
    faMugHot: $72947875341bbd79$export$47a822c30184e8af,
    faMusic: $72947875341bbd79$export$fcb0647a5340b5b8,
    faNetworkWired: $72947875341bbd79$export$882cabd11f4943b8,
    faNeuter: $72947875341bbd79$export$771cf879fba0cf93,
    faNewspaper: $72947875341bbd79$export$d91b374112d4f8c1,
    faNotEqual: $72947875341bbd79$export$6a15ccae09bbaf93,
    faNotesMedical: $72947875341bbd79$export$b2d79133c81d6697,
    faObjectGroup: $72947875341bbd79$export$40cdac24aa94a57a,
    faObjectUngroup: $72947875341bbd79$export$887f6345573abcac,
    faOilCan: $72947875341bbd79$export$2599126c3a57f727,
    faOm: $72947875341bbd79$export$8de8eb94230028a5,
    faOtter: $72947875341bbd79$export$743cce3ca4eb1d7d,
    faOutdent: $72947875341bbd79$export$e21cfc4f23776bff,
    faPager: $72947875341bbd79$export$e1611f373a10a98c,
    faPaintBrush: $72947875341bbd79$export$594db3339e212bc9,
    faPaintRoller: $72947875341bbd79$export$d1de8d1b815d6a5,
    faPalette: $72947875341bbd79$export$5c390baea5db4f77,
    faPallet: $72947875341bbd79$export$d7ff2047dbc34562,
    faPaperPlane: $72947875341bbd79$export$b5378818301da1be,
    faPaperclip: $72947875341bbd79$export$4b24ca1552f410af,
    faParachuteBox: $72947875341bbd79$export$ca9e3368f1d9500a,
    faParagraph: $72947875341bbd79$export$dec46f8df1860e0,
    faParking: $72947875341bbd79$export$fda29c8f99573a4e,
    faPassport: $72947875341bbd79$export$2c31ca0d9bee400f,
    faPastafarianism: $72947875341bbd79$export$733efdaec97447be,
    faPaste: $72947875341bbd79$export$6f95f90dd1f6d86b,
    faPause: $72947875341bbd79$export$da79f048408b1722,
    faPauseCircle: $72947875341bbd79$export$d8cf08a0362da8db,
    faPaw: $72947875341bbd79$export$7bc6e4d977673e69,
    faPeace: $72947875341bbd79$export$8614cb1326eacd7a,
    faPen: $72947875341bbd79$export$8f4567331fb0d3bc,
    faPenAlt: $72947875341bbd79$export$a3d3e92e430d3beb,
    faPenFancy: $72947875341bbd79$export$8bdfe14ac72a8b17,
    faPenNib: $72947875341bbd79$export$a82594dcc75a49f5,
    faPenSquare: $72947875341bbd79$export$fbb231ccb3d960bc,
    faPencilAlt: $72947875341bbd79$export$8210adc172262df,
    faPencilRuler: $72947875341bbd79$export$e3a7a1affea005f5,
    faPeopleArrows: $72947875341bbd79$export$804bfc5c390e1a2a,
    faPeopleCarry: $72947875341bbd79$export$35fbd4ff1265acd5,
    faPepperHot: $72947875341bbd79$export$4894bf28f771e1f3,
    faPercent: $72947875341bbd79$export$89a1764fbb7ad2cb,
    faPercentage: $72947875341bbd79$export$89333857fc063a2e,
    faPersonBooth: $72947875341bbd79$export$2337c975289bdd84,
    faPhone: $72947875341bbd79$export$ddab067855cf34cb,
    faPhoneAlt: $72947875341bbd79$export$a07a9b305deebf32,
    faPhoneSlash: $72947875341bbd79$export$4c60a3aade08b6c2,
    faPhoneSquare: $72947875341bbd79$export$8ba22605a641ebdf,
    faPhoneSquareAlt: $72947875341bbd79$export$a41e77f0de98bba7,
    faPhoneVolume: $72947875341bbd79$export$c377f240bb8b5d74,
    faPhotoVideo: $72947875341bbd79$export$739f6a6a12dfb6ed,
    faPiggyBank: $72947875341bbd79$export$46d49a6734c4872a,
    faPills: $72947875341bbd79$export$6380e2ed6e69d350,
    faPizzaSlice: $72947875341bbd79$export$c9f93c4667edc585,
    faPlaceOfWorship: $72947875341bbd79$export$c5a9302c8c13c79a,
    faPlane: $72947875341bbd79$export$f654c69e66b466c0,
    faPlaneArrival: $72947875341bbd79$export$9b2dbe133273f284,
    faPlaneDeparture: $72947875341bbd79$export$6ccbeeccfea6dc8a,
    faPlaneSlash: $72947875341bbd79$export$cfee4df0d5df6d21,
    faPlay: $72947875341bbd79$export$436587205947bca5,
    faPlayCircle: $72947875341bbd79$export$cf04333781061c5e,
    faPlug: $72947875341bbd79$export$cae5752c3e3b6545,
    faPlus: $72947875341bbd79$export$a105e7b44ca0eb9e,
    faPlusCircle: $72947875341bbd79$export$d9cc3a81499af48c,
    faPlusSquare: $72947875341bbd79$export$b6359eebfe900c35,
    faPodcast: $72947875341bbd79$export$5c0b4709125e92f8,
    faPoll: $72947875341bbd79$export$bc8ca14ab51f93db,
    faPollH: $72947875341bbd79$export$456a238f0144d430,
    faPoo: $72947875341bbd79$export$dd0ede1713d2d2f9,
    faPooStorm: $72947875341bbd79$export$48a38da471b097a2,
    faPoop: $72947875341bbd79$export$bb45b6b87d1adf27,
    faPortrait: $72947875341bbd79$export$e3d25f819c7ee7d7,
    faPoundSign: $72947875341bbd79$export$9ce041dfec8319b,
    faPowerOff: $72947875341bbd79$export$a1cca9928dcf9798,
    faPray: $72947875341bbd79$export$3b32c982141cad51,
    faPrayingHands: $72947875341bbd79$export$95e08e91b0929943,
    faPrescription: $72947875341bbd79$export$8767bafb19515ee4,
    faPrescriptionBottle: $72947875341bbd79$export$214f9ce665590486,
    faPrescriptionBottleAlt: $72947875341bbd79$export$65d1c884b8581d1a,
    faPrint: $72947875341bbd79$export$ae64371e02ee8e56,
    faProcedures: $72947875341bbd79$export$5f9e1870e1866dde,
    faProjectDiagram: $72947875341bbd79$export$30bf9f5b96509df1,
    faPumpMedical: $72947875341bbd79$export$f1b881c73328720c,
    faPumpSoap: $72947875341bbd79$export$821aeede187f23c9,
    faPuzzlePiece: $72947875341bbd79$export$7ee0dbd1e92e2859,
    faQrcode: $72947875341bbd79$export$fc19ca0fe15e73bc,
    faQuestion: $72947875341bbd79$export$d96973f90e8f6e47,
    faQuestionCircle: $72947875341bbd79$export$5ba67d7f2265c1a5,
    faQuidditch: $72947875341bbd79$export$c00c446e6db1605f,
    faQuoteLeft: $72947875341bbd79$export$932a67a1b1a7a724,
    faQuoteRight: $72947875341bbd79$export$54e3a80c9875b74c,
    faQuran: $72947875341bbd79$export$46f29ea84ed4c5f1,
    faRadiation: $72947875341bbd79$export$4c4e509518093d6d,
    faRadiationAlt: $72947875341bbd79$export$2f048fa82bbddf6f,
    faRainbow: $72947875341bbd79$export$92ab27739d3a91b2,
    faRandom: $72947875341bbd79$export$8357bf8cc666d5f0,
    faReceipt: $72947875341bbd79$export$32b0cd6133c2742,
    faRecordVinyl: $72947875341bbd79$export$fe2d5012d9982673,
    faRecycle: $72947875341bbd79$export$a65c441f12cb6bd,
    faRedo: $72947875341bbd79$export$3d9f98aa1c24c776,
    faRedoAlt: $72947875341bbd79$export$50c037520c6cfdc1,
    faRegistered: $72947875341bbd79$export$5f519e9ac15ab8c3,
    faRemoveFormat: $72947875341bbd79$export$d91179f327329532,
    faReply: $72947875341bbd79$export$bb06d4a7bb6736fe,
    faReplyAll: $72947875341bbd79$export$ca6fd367f31ecbc5,
    faRepublican: $72947875341bbd79$export$929518bb4b66a588,
    faRestroom: $72947875341bbd79$export$5fbcef35138741a5,
    faRetweet: $72947875341bbd79$export$cebc76f79478e40e,
    faRibbon: $72947875341bbd79$export$838459d11f3971df,
    faRing: $72947875341bbd79$export$a95486586631edc7,
    faRoad: $72947875341bbd79$export$f224567a4851a5e9,
    faRobot: $72947875341bbd79$export$30a5bb4ad3fa716c,
    faRocket: $72947875341bbd79$export$b24d84ed5657d89a,
    faRoute: $72947875341bbd79$export$806c0a45a7ecd6e8,
    faRss: $72947875341bbd79$export$7329a1ca27b90c5b,
    faRssSquare: $72947875341bbd79$export$89c9b1cca2c11484,
    faRubleSign: $72947875341bbd79$export$1ae0a94c8ba4131a,
    faRuler: $72947875341bbd79$export$8e90575265a56cfc,
    faRulerCombined: $72947875341bbd79$export$613f406c1b5802a8,
    faRulerHorizontal: $72947875341bbd79$export$46c6347bff3e04a,
    faRulerVertical: $72947875341bbd79$export$a6ad5df9d9f29553,
    faRunning: $72947875341bbd79$export$5dfd1cb43dc9eadb,
    faRupeeSign: $72947875341bbd79$export$8bf9e3f7f57d486a,
    faSadCry: $72947875341bbd79$export$8e924e6bd422cef9,
    faSadTear: $72947875341bbd79$export$4b5241926f692f91,
    faSatellite: $72947875341bbd79$export$da3f1730d013e224,
    faSatelliteDish: $72947875341bbd79$export$219ccae0e4da3c92,
    faSave: $72947875341bbd79$export$1aaa83ff70706e1e,
    faSchool: $72947875341bbd79$export$51e9b8434982947d,
    faScrewdriver: $72947875341bbd79$export$7484ff654cd6474f,
    faScroll: $72947875341bbd79$export$7c265716d4399676,
    faSdCard: $72947875341bbd79$export$303efb6031da122,
    faSearch: $72947875341bbd79$export$871a78837687ffe8,
    faSearchDollar: $72947875341bbd79$export$65b49a6767630708,
    faSearchLocation: $72947875341bbd79$export$c33aba6c251a898a,
    faSearchMinus: $72947875341bbd79$export$efca97eef6a7a17d,
    faSearchPlus: $72947875341bbd79$export$378f00e6b1a8185,
    faSeedling: $72947875341bbd79$export$d7b60b8dbd03cfe4,
    faServer: $72947875341bbd79$export$1bf820d499b6202e,
    faShapes: $72947875341bbd79$export$b17d50542d1fc340,
    faShare: $72947875341bbd79$export$c08b4b0e2b0dc027,
    faShareAlt: $72947875341bbd79$export$f8e8bb0b3aa8c658,
    faShareAltSquare: $72947875341bbd79$export$3799c2d8fd7e493b,
    faShareSquare: $72947875341bbd79$export$ae9e1434571f373c,
    faShekelSign: $72947875341bbd79$export$3570be7b68efb8db,
    faShieldAlt: $72947875341bbd79$export$d6508d18a824f291,
    faShieldVirus: $72947875341bbd79$export$bea811bbf570f05a,
    faShip: $72947875341bbd79$export$6c645741140616af,
    faShippingFast: $72947875341bbd79$export$5e419f47aaeb3c05,
    faShoePrints: $72947875341bbd79$export$cdbdd2118099ae07,
    faShoppingBag: $72947875341bbd79$export$5745f8adbc11eb01,
    faShoppingBasket: $72947875341bbd79$export$ca6d443595a6578f,
    faShoppingCart: $72947875341bbd79$export$51da406e5aa1388c,
    faShower: $72947875341bbd79$export$f7f7c15f18cc19a1,
    faShuttleVan: $72947875341bbd79$export$9d63d851db698c09,
    faSign: $72947875341bbd79$export$d21d0d6c8e9e8bf9,
    faSignInAlt: $72947875341bbd79$export$e6709746115bd2ea,
    faSignLanguage: $72947875341bbd79$export$20993813350f9671,
    faSignOutAlt: $72947875341bbd79$export$c844d6923b7096c2,
    faSignal: $72947875341bbd79$export$79046b073b6c584d,
    faSignature: $72947875341bbd79$export$afa7b53ac8ebcb5d,
    faSimCard: $72947875341bbd79$export$3bee83bf278fddbe,
    faSink: $72947875341bbd79$export$2a9dda2096ce792e,
    faSitemap: $72947875341bbd79$export$b2ce5e79d0eccaf8,
    faSkating: $72947875341bbd79$export$21bd1d54bd4f2c5a,
    faSkiing: $72947875341bbd79$export$eae1acab6fb96708,
    faSkiingNordic: $72947875341bbd79$export$6ea48260d7d09b1b,
    faSkull: $72947875341bbd79$export$138b45e2afb1dfa4,
    faSkullCrossbones: $72947875341bbd79$export$8717352b90217272,
    faSlash: $72947875341bbd79$export$f54d004dd5f1cb5e,
    faSleigh: $72947875341bbd79$export$26a8fd1143d2d6c0,
    faSlidersH: $72947875341bbd79$export$94d4dcb523f95563,
    faSmile: $72947875341bbd79$export$c632b2334f0913bc,
    faSmileBeam: $72947875341bbd79$export$54ada6dc9690e0ca,
    faSmileWink: $72947875341bbd79$export$f5dbb37f6801ee3f,
    faSmog: $72947875341bbd79$export$aa11b8edb09fed14,
    faSmoking: $72947875341bbd79$export$c4ab83701fc591a5,
    faSmokingBan: $72947875341bbd79$export$e50452a49dec29f,
    faSms: $72947875341bbd79$export$9dbcc3443daa7323,
    faSnowboarding: $72947875341bbd79$export$72683772d587302a,
    faSnowflake: $72947875341bbd79$export$bab8f3647c394f48,
    faSnowman: $72947875341bbd79$export$b23df6bafb174693,
    faSnowplow: $72947875341bbd79$export$695fae58f55c3a87,
    faSoap: $72947875341bbd79$export$64f1c53b21f310ac,
    faSocks: $72947875341bbd79$export$8d36a54dbf1e6bce,
    faSolarPanel: $72947875341bbd79$export$b9c649c5e37017f3,
    faSort: $72947875341bbd79$export$4941c5969d5399b,
    faSortAlphaDown: $72947875341bbd79$export$7658045270aafde3,
    faSortAlphaDownAlt: $72947875341bbd79$export$e12d23d82d5c8a89,
    faSortAlphaUp: $72947875341bbd79$export$3c4115b156be730d,
    faSortAlphaUpAlt: $72947875341bbd79$export$95ef20828693fb0f,
    faSortAmountDown: $72947875341bbd79$export$4b2a02d50e417b5f,
    faSortAmountDownAlt: $72947875341bbd79$export$e7d80d8c226cb77,
    faSortAmountUp: $72947875341bbd79$export$28ef3e933e4b5364,
    faSortAmountUpAlt: $72947875341bbd79$export$6e87844b0f151b6a,
    faSortDown: $72947875341bbd79$export$58e2577a373e7d4,
    faSortNumericDown: $72947875341bbd79$export$835db7eb35b3c29b,
    faSortNumericDownAlt: $72947875341bbd79$export$857385fda7a5a98e,
    faSortNumericUp: $72947875341bbd79$export$d213a3ba3cabed48,
    faSortNumericUpAlt: $72947875341bbd79$export$d41859f1bbb9e086,
    faSortUp: $72947875341bbd79$export$f9dd5b1410e95035,
    faSpa: $72947875341bbd79$export$f9a38ef7b046ab51,
    faSpaceShuttle: $72947875341bbd79$export$4d1c12ba2b4ca565,
    faSpellCheck: $72947875341bbd79$export$761e747b06ed2e1f,
    faSpider: $72947875341bbd79$export$6daa96b1986e2ef0,
    faSpinner: $72947875341bbd79$export$1025ad641edb49c2,
    faSplotch: $72947875341bbd79$export$d6f21e17ea797702,
    faSprayCan: $72947875341bbd79$export$4952c502f544cf85,
    faSquare: $72947875341bbd79$export$90b4406457aae8cc,
    faSquareFull: $72947875341bbd79$export$7ec6541fee081990,
    faSquareRootAlt: $72947875341bbd79$export$28e4b96627e00057,
    faStamp: $72947875341bbd79$export$722e92d2d93ffc68,
    faStar: $72947875341bbd79$export$a3b0eb2cd7942125,
    faStarAndCrescent: $72947875341bbd79$export$cafa834c96ebcb1a,
    faStarHalf: $72947875341bbd79$export$228008b5e11032fa,
    faStarHalfAlt: $72947875341bbd79$export$c13575f42532efb3,
    faStarOfDavid: $72947875341bbd79$export$f823fee3712b2601,
    faStarOfLife: $72947875341bbd79$export$aa3c4c1c5a47bf98,
    faStepBackward: $72947875341bbd79$export$2884e379aed297d4,
    faStepForward: $72947875341bbd79$export$b303329afce5de18,
    faStethoscope: $72947875341bbd79$export$acb2d72d28cd92d9,
    faStickyNote: $72947875341bbd79$export$80889adc5d98bf4a,
    faStop: $72947875341bbd79$export$51577929c676143b,
    faStopCircle: $72947875341bbd79$export$47af2aad60ab3e7c,
    faStopwatch: $72947875341bbd79$export$b85a7300fc7960b6,
    faStopwatch20: $72947875341bbd79$export$df6244b0501f2112,
    faStore: $72947875341bbd79$export$de59c2657a8ace67,
    faStoreAlt: $72947875341bbd79$export$1f1871dab9cec9d8,
    faStoreAltSlash: $72947875341bbd79$export$b932a586f6ff48b4,
    faStoreSlash: $72947875341bbd79$export$4ab2f33219630bad,
    faStream: $72947875341bbd79$export$ed81ab40fc4e904,
    faStreetView: $72947875341bbd79$export$6aab6c3359c2554c,
    faStrikethrough: $72947875341bbd79$export$eff51ea25b4de135,
    faStroopwafel: $72947875341bbd79$export$195780ddabd8e0c6,
    faSubscript: $72947875341bbd79$export$34c1e678c32ed646,
    faSubway: $72947875341bbd79$export$4cabc8a12d4e2f9,
    faSuitcase: $72947875341bbd79$export$60710f3921019268,
    faSuitcaseRolling: $72947875341bbd79$export$957e62a9b80ff4e3,
    faSun: $72947875341bbd79$export$2fa35dcbc038dbe9,
    faSuperscript: $72947875341bbd79$export$4fa56a54e822dd25,
    faSurprise: $72947875341bbd79$export$46647c72213f53ba,
    faSwatchbook: $72947875341bbd79$export$c74a20c81b957b6a,
    faSwimmer: $72947875341bbd79$export$67daf2e2f88c1365,
    faSwimmingPool: $72947875341bbd79$export$4dee691631c67d5c,
    faSynagogue: $72947875341bbd79$export$20d991385719b5b4,
    faSync: $72947875341bbd79$export$ff87319002e3dae9,
    faSyncAlt: $72947875341bbd79$export$2ff2056be8c281e4,
    faSyringe: $72947875341bbd79$export$1aa9423ec6b1d609,
    faTable: $72947875341bbd79$export$36583f5d3d5a971f,
    faTableTennis: $72947875341bbd79$export$f378fbb4e0ef7edf,
    faTablet: $72947875341bbd79$export$1c92b67c45a4b4fc,
    faTabletAlt: $72947875341bbd79$export$db0cac088255eacc,
    faTablets: $72947875341bbd79$export$bed2b0ed4ae45e0d,
    faTachometerAlt: $72947875341bbd79$export$38dd17b9f064c10f,
    faTag: $72947875341bbd79$export$cb61f447f29887e,
    faTags: $72947875341bbd79$export$d55778e3ab6c933f,
    faTape: $72947875341bbd79$export$b88ed5e1e0eac4c6,
    faTasks: $72947875341bbd79$export$2f6d5b2fec286d63,
    faTaxi: $72947875341bbd79$export$9958afcdfece1b58,
    faTeeth: $72947875341bbd79$export$b4619aeaf0b9d18e,
    faTeethOpen: $72947875341bbd79$export$c88ac21fe7c88ae6,
    faTemperatureHigh: $72947875341bbd79$export$15d012277c3ecf9a,
    faTemperatureLow: $72947875341bbd79$export$9e9af12b90a1abd2,
    faTenge: $72947875341bbd79$export$af6ebee83047b793,
    faTerminal: $72947875341bbd79$export$5e63e8b85b5f119c,
    faTextHeight: $72947875341bbd79$export$3313bce3924ea7da,
    faTextWidth: $72947875341bbd79$export$d8724cf433389700,
    faTh: $72947875341bbd79$export$4d383c83efc0c819,
    faThLarge: $72947875341bbd79$export$69782f333e90cdc6,
    faThList: $72947875341bbd79$export$daf2614a457122c0,
    faTheaterMasks: $72947875341bbd79$export$3dbedc487b0159ac,
    faThermometer: $72947875341bbd79$export$f576739e9b18ea4f,
    faThermometerEmpty: $72947875341bbd79$export$81a2f8298cf523f9,
    faThermometerFull: $72947875341bbd79$export$74e07083cef79a6f,
    faThermometerHalf: $72947875341bbd79$export$2090f040324b4449,
    faThermometerQuarter: $72947875341bbd79$export$ed05754fcbec6e46,
    faThermometerThreeQuarters: $72947875341bbd79$export$6c632d1dc30d4a77,
    faThumbsDown: $72947875341bbd79$export$aba24ca305bbe8c1,
    faThumbsUp: $72947875341bbd79$export$47e4e0d519d33497,
    faThumbtack: $72947875341bbd79$export$b6314cdc01bb5c43,
    faTicketAlt: $72947875341bbd79$export$75e38ba471fd89c4,
    faTimes: $72947875341bbd79$export$174bd7f477b115b4,
    faTimesCircle: $72947875341bbd79$export$ab0ec50720a747eb,
    faTint: $72947875341bbd79$export$60dd975bd5938c15,
    faTintSlash: $72947875341bbd79$export$5d6f0943039b898f,
    faTired: $72947875341bbd79$export$3d016d62cda18371,
    faToggleOff: $72947875341bbd79$export$d20aaceb882ca545,
    faToggleOn: $72947875341bbd79$export$5cffc34afa81e517,
    faToilet: $72947875341bbd79$export$505476859b9691c0,
    faToiletPaper: $72947875341bbd79$export$c8cc083ccc72b17,
    faToiletPaperSlash: $72947875341bbd79$export$7a494edbf9b65575,
    faToolbox: $72947875341bbd79$export$b34d64c205c732a9,
    faTools: $72947875341bbd79$export$646e4e7a8c6172aa,
    faTooth: $72947875341bbd79$export$3a1fa2d16f90d635,
    faTorah: $72947875341bbd79$export$54d07baabd8c2acb,
    faToriiGate: $72947875341bbd79$export$75825a4c2b3375e,
    faTractor: $72947875341bbd79$export$e87e41787bbedc98,
    faTrademark: $72947875341bbd79$export$9c9b2fbddd59047d,
    faTrafficLight: $72947875341bbd79$export$bf0b19daceaec9c2,
    faTrailer: $72947875341bbd79$export$3a48b9820e92f5ab,
    faTrain: $72947875341bbd79$export$17cde74bf6f1ee89,
    faTram: $72947875341bbd79$export$a7a36674c079f293,
    faTransgender: $72947875341bbd79$export$7e3f1701aa95ef01,
    faTransgenderAlt: $72947875341bbd79$export$9c36cf9334c052f,
    faTrash: $72947875341bbd79$export$ed8c149a0ea54bb4,
    faTrashAlt: $72947875341bbd79$export$88df7ff7eb32f9dc,
    faTrashRestore: $72947875341bbd79$export$d32f45a64ed40e8d,
    faTrashRestoreAlt: $72947875341bbd79$export$d075b19b21cb9856,
    faTree: $72947875341bbd79$export$1744430f718caf6b,
    faTrophy: $72947875341bbd79$export$29c432d69ccf85a5,
    faTruck: $72947875341bbd79$export$d7895f386f8bd8b8,
    faTruckLoading: $72947875341bbd79$export$f00c152db7d44638,
    faTruckMonster: $72947875341bbd79$export$24b8a0147653649a,
    faTruckMoving: $72947875341bbd79$export$a06617a1a4ccea67,
    faTruckPickup: $72947875341bbd79$export$f846b848b3ba3064,
    faTshirt: $72947875341bbd79$export$36edce3ba87c2b17,
    faTty: $72947875341bbd79$export$7c85aba0f9624b29,
    faTv: $72947875341bbd79$export$e0cfed4ba2fe562c,
    faUmbrella: $72947875341bbd79$export$9ff64ffae70e08c0,
    faUmbrellaBeach: $72947875341bbd79$export$20932e4d438e4e4c,
    faUnderline: $72947875341bbd79$export$22346afd6a3cddf8,
    faUndo: $72947875341bbd79$export$a5e5ba60b1dfe2b2,
    faUndoAlt: $72947875341bbd79$export$c8197b992c46c4a6,
    faUniversalAccess: $72947875341bbd79$export$e119aada7f690d05,
    faUniversity: $72947875341bbd79$export$f2e1460ebe1a8cb0,
    faUnlink: $72947875341bbd79$export$2f546f7d8ba01e18,
    faUnlock: $72947875341bbd79$export$db1382cd406cc506,
    faUnlockAlt: $72947875341bbd79$export$b19f508797f3d9c3,
    faUpload: $72947875341bbd79$export$a9578350255b2b79,
    faUser: $72947875341bbd79$export$f5699fa0844e0188,
    faUserAlt: $72947875341bbd79$export$ae9b19c2ac726cfc,
    faUserAltSlash: $72947875341bbd79$export$46185fab4772ada6,
    faUserAstronaut: $72947875341bbd79$export$94363e983c225a04,
    faUserCheck: $72947875341bbd79$export$76de2a120043c9f8,
    faUserCircle: $72947875341bbd79$export$be7d974e9e0dba1a,
    faUserClock: $72947875341bbd79$export$b00596a09aa07311,
    faUserCog: $72947875341bbd79$export$474108c2b86e730e,
    faUserEdit: $72947875341bbd79$export$a68a6960fc8eef82,
    faUserFriends: $72947875341bbd79$export$46073bec205635d9,
    faUserGraduate: $72947875341bbd79$export$10f5839059d22f7e,
    faUserInjured: $72947875341bbd79$export$c950c1ba7f227d5b,
    faUserLock: $72947875341bbd79$export$d9b89b5872b67a4f,
    faUserMd: $72947875341bbd79$export$ab0d33a2c03f1794,
    faUserMinus: $72947875341bbd79$export$d6e17c0df8ed1bf7,
    faUserNinja: $72947875341bbd79$export$a9174995732e03c5,
    faUserNurse: $72947875341bbd79$export$ab9af5aa013d2162,
    faUserPlus: $72947875341bbd79$export$4c17261776a709f2,
    faUserSecret: $72947875341bbd79$export$597826232327559b,
    faUserShield: $72947875341bbd79$export$d1886bc596424e6c,
    faUserSlash: $72947875341bbd79$export$3924ab4d3ef9b5ef,
    faUserTag: $72947875341bbd79$export$9eec597148166b36,
    faUserTie: $72947875341bbd79$export$48c51dda34e9f04c,
    faUserTimes: $72947875341bbd79$export$45b996d071667753,
    faUsers: $72947875341bbd79$export$e5a8f011aef571ac,
    faUsersCog: $72947875341bbd79$export$5e0b06753fc69b81,
    faUsersSlash: $72947875341bbd79$export$b71a093b86e3da1f,
    faUtensilSpoon: $72947875341bbd79$export$fb7af5d245fb9053,
    faUtensils: $72947875341bbd79$export$750d52edc1dafc7,
    faVectorSquare: $72947875341bbd79$export$567d5631a7b0599f,
    faVenus: $72947875341bbd79$export$f89d028573ffc0a6,
    faVenusDouble: $72947875341bbd79$export$6a6f9cba7a1e5fe4,
    faVenusMars: $72947875341bbd79$export$63f2d9e5f4689aa8,
    faVest: $72947875341bbd79$export$c8370e53051a657,
    faVestPatches: $72947875341bbd79$export$750a64470c2e0f3f,
    faVial: $72947875341bbd79$export$aa014b06d2d70598,
    faVials: $72947875341bbd79$export$507e8edd7676b2e9,
    faVideo: $72947875341bbd79$export$5c6bd8729527871b,
    faVideoSlash: $72947875341bbd79$export$a714fc79f58cc9ef,
    faVihara: $72947875341bbd79$export$ee4b92e89fe0dfaf,
    faVirus: $72947875341bbd79$export$37c67e0b3dc6bd1b,
    faVirusSlash: $72947875341bbd79$export$c4ff5306c5470939,
    faViruses: $72947875341bbd79$export$ee194b18f5c6f6b6,
    faVoicemail: $72947875341bbd79$export$4f1ce88b2b4cd5cd,
    faVolleyballBall: $72947875341bbd79$export$a15e6fc8e68a76b0,
    faVolumeDown: $72947875341bbd79$export$69fdf57632b6cc29,
    faVolumeMute: $72947875341bbd79$export$aa8decd057dfd29b,
    faVolumeOff: $72947875341bbd79$export$d94ba52e980ea0f1,
    faVolumeUp: $72947875341bbd79$export$5940d3e475d90cc4,
    faVoteYea: $72947875341bbd79$export$e87bb3db1608b850,
    faVrCardboard: $72947875341bbd79$export$248171cb6dad4307,
    faWalking: $72947875341bbd79$export$4886811b7174ec35,
    faWallet: $72947875341bbd79$export$79204db8777905c8,
    faWarehouse: $72947875341bbd79$export$e3a174a50618c208,
    faWater: $72947875341bbd79$export$efaeddad0a6e901b,
    faWaveSquare: $72947875341bbd79$export$c38cf504b3bc58a2,
    faWeight: $72947875341bbd79$export$cf3bafa68a60bae4,
    faWeightHanging: $72947875341bbd79$export$43d1fa6671908715,
    faWheelchair: $72947875341bbd79$export$76a9413fbe130a53,
    faWifi: $72947875341bbd79$export$1642419fe3db2857,
    faWind: $72947875341bbd79$export$cc58cb0f2257a6a9,
    faWindowClose: $72947875341bbd79$export$18b7775f78a3e16,
    faWindowMaximize: $72947875341bbd79$export$703cd98be31ec905,
    faWindowMinimize: $72947875341bbd79$export$26a3f9d2784b90d8,
    faWindowRestore: $72947875341bbd79$export$eccfff9bfd585652,
    faWineBottle: $72947875341bbd79$export$770be8b3d5776043,
    faWineGlass: $72947875341bbd79$export$e06d6607d3577d6e,
    faWineGlassAlt: $72947875341bbd79$export$b8ff3fe2b78aef2f,
    faWonSign: $72947875341bbd79$export$51790ddd26e431bc,
    faWrench: $72947875341bbd79$export$3c6c0c8185296ac5,
    faXRay: $72947875341bbd79$export$8cf137aceaaf4de0,
    faYenSign: $72947875341bbd79$export$30f1437f5a4e991d,
    faYinYang: $72947875341bbd79$export$6ec1acbf3f610b8f
};












var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");

var $b3168c9972e6d762$export$ce3c11559268ddac = "mojo-journey-handoff";
// The handoff only has to survive one page load, so anything older than this is stale.
var $b3168c9972e6d762$var$MAX_AGE_MS = 600000;
var $b3168c9972e6d762$var$MAX_APPLICANTS = 2;
var $b3168c9972e6d762$var$MAX_DEPENDENTS = 20;
var $b3168c9972e6d762$var$MAX_ADDRESS_LENGTH = 300;
// Well above any realistic deposit. Only here to reject nonsense coming back out of storage.
var $b3168c9972e6d762$var$MAX_DEPOSIT = 100000000;
var $b3168c9972e6d762$export$89690aeca43f6930 = [
    "permanent-employment",
    "temporary-employment",
    "agency",
    "sole-trader",
    "director-of-a-ltd-company",
    "partner-in-an-llp",
    "contractor",
    "retired",
    "not-working"
];
var $b3168c9972e6d762$export$51c14fd8df7771d6 = [
    "savings",
    "property-sale",
    "family-gift",
    "inheritance",
    "other"
];
var $b3168c9972e6d762$var$MAX_DEPOSIT_SOURCES = $b3168c9972e6d762$export$51c14fd8df7771d6.length;
var $b3168c9972e6d762$var$_obj;
// The application keeps employment as its own enum, and the main fact find's values (which is what
// the split fact find reads) as kebab-case. Anything not listed, such as `Unknown`, is left out.
var $b3168c9972e6d762$var$EMPLOYMENT_STATUS = ($b3168c9972e6d762$var$_obj = {}, (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).PermanentEmployment, "permanent-employment"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).TemporaryEmployment, "temporary-employment"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).Agency, "agency"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).SoleTrader, "sole-trader"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).DirectorLimitedCompany, "director-of-a-ltd-company"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).PartnerLlp, "partner-in-an-llp"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).Contractor, "contractor"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).Retired, "retired"), (0, $8c6ug._)($b3168c9972e6d762$var$_obj, (0, $6e6e522132305404$export$978d240f447d4ef2).NotWorking, "not-working"), $b3168c9972e6d762$var$_obj);
/**
 * How the applicant is employed, in the vocabulary the split fact find reads.
 *
 * Income is matched to the applicant by `firstApplicant`, which the application marks on both.
 * That mark is optional on an income row, though, and a strict match would then hand over nothing
 * and have the split fact find ask again. So when nothing matches and there is only one applicant,
 * the first row is used: there is nobody else it could belong to. With more than one applicant an
 * unmarked row is left alone instead, as giving someone the other applicant's employment would be
 * worse than asking.
 */ var $b3168c9972e6d762$var$employmentStatusOf = function(applicant, incomes, soleApplicant) {
    var _this;
    var matched = incomes.find(function(income) {
        return income.firstApplicant === applicant.firstApplicant;
    });
    var status = (_this = matched !== null && matched !== void 0 ? matched : soleApplicant ? incomes[0] : undefined) === null || _this === void 0 ? void 0 : _this.employmentStatus;
    return status ? $b3168c9972e6d762$var$EMPLOYMENT_STATUS[status] : undefined;
};
var $b3168c9972e6d762$export$c1d2671e65196d1 = function(application) {
    var _application_applicants, _application_borrowingDetails;
    var _application_applicants1;
    // The lead applicant is first, as the split fact find reads the first one as the lead
    var applicantsLeadFirst = (0, $bOqL7._)((_application_applicants1 = application === null || application === void 0 ? void 0 : application.applicants) !== null && _application_applicants1 !== void 0 ? _application_applicants1 : []).sort(function(a, b) {
        return Number(!!b.firstApplicant) - Number(!!a.firstApplicant);
    }).slice(0, $b3168c9972e6d762$var$MAX_APPLICANTS);
    var _application_income;
    var incomes = (_application_income = application === null || application === void 0 ? void 0 : application.income) !== null && _application_income !== void 0 ? _application_income : [];
    var _application_applicants_length;
    var soleApplicant = ((_application_applicants_length = application === null || application === void 0 ? void 0 : (_application_applicants = application.applicants) === null || _application_applicants === void 0 ? void 0 : _application_applicants.length) !== null && _application_applicants_length !== void 0 ? _application_applicants_length : 0) === 1;
    var applicants = applicantsLeadFirst.flatMap(function(applicant) {
        var _applicant_forename, _applicant_surname;
        var firstName = (_applicant_forename = applicant.forename) === null || _applicant_forename === void 0 ? void 0 : _applicant_forename.trim();
        if (!firstName) return [];
        var employmentStatus = $b3168c9972e6d762$var$employmentStatusOf(applicant, incomes, soleApplicant);
        var _applicant_surname_trim;
        return [
            (0, $hRCmZ._)({
                firstName: firstName,
                lastName: (_applicant_surname_trim = (_applicant_surname = applicant.surname) === null || _applicant_surname === void 0 ? void 0 : _applicant_surname.trim()) !== null && _applicant_surname_trim !== void 0 ? _applicant_surname_trim : ""
            }, employmentStatus && {
                employmentStatus: employmentStatus
            })
        ];
    });
    var dependents = application === null || application === void 0 ? void 0 : application.dependentsNumber;
    var deposit = application === null || application === void 0 ? void 0 : (_application_borrowingDetails = application.borrowingDetails) === null || _application_borrowingDetails === void 0 ? void 0 : _application_borrowingDetails.deposit;
    return (0, $hRCmZ._)({}, applicants.length > 0 && {
        applicants: applicants
    }, dependents !== undefined && Number.isInteger(dependents) && dependents > 0 && dependents <= $b3168c9972e6d762$var$MAX_DEPENDENTS && {
        numberOfDependents: dependents
    }, deposit && deposit > 0 && deposit <= $b3168c9972e6d762$var$MAX_DEPOSIT && {
        deposit: deposit
    });
};
var $b3168c9972e6d762$var$isOneOf = function(options, value) {
    return options.includes(value);
};
// Storage is untrusted on the way back in, so rebuild each applicant from known keys rather than
// passing through whatever was stored. Anything malformed discards the whole handoff.
var $b3168c9972e6d762$var$parseApplicant = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) !== "object" || value === null) return null;
    var firstName = value.firstName, lastName = value.lastName, employmentStatus = value.employmentStatus;
    if (typeof firstName !== "string" || typeof lastName !== "string") return null;
    if (employmentStatus === undefined) return {
        firstName: firstName,
        lastName: lastName
    };
    return $b3168c9972e6d762$var$isOneOf($b3168c9972e6d762$export$89690aeca43f6930, employmentStatus) ? {
        firstName: firstName,
        lastName: lastName,
        employmentStatus: employmentStatus
    } : null;
};
var $b3168c9972e6d762$var$parseFields = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) !== "object" || value === null) return null;
    var applicants = value.applicants, numberOfDependents = value.numberOfDependents, depositSources = value.depositSources, sellingCurrentHome = value.sellingCurrentHome, currentAddress = value.currentAddress, deposit = value.deposit;
    var fields = {};
    if (applicants !== undefined) {
        if (!Array.isArray(applicants) || applicants.length > $b3168c9972e6d762$var$MAX_APPLICANTS) return null;
        var parsed = applicants.map($b3168c9972e6d762$var$parseApplicant);
        if (!parsed.every(function(a) {
            return a !== null;
        })) return null;
        fields.applicants = parsed;
    }
    if (numberOfDependents !== undefined) {
        if (typeof numberOfDependents !== "number" || !Number.isInteger(numberOfDependents) || numberOfDependents < 0 || numberOfDependents > $b3168c9972e6d762$var$MAX_DEPENDENTS) return null;
        fields.numberOfDependents = numberOfDependents;
    }
    if (depositSources !== undefined) {
        if (!Array.isArray(depositSources) || depositSources.length > $b3168c9972e6d762$var$MAX_DEPOSIT_SOURCES) return null;
        if (!depositSources.every(function(source) {
            return $b3168c9972e6d762$var$isOneOf($b3168c9972e6d762$export$51c14fd8df7771d6, source);
        })) return null;
        fields.depositSources = depositSources;
    }
    if (sellingCurrentHome !== undefined) {
        if (typeof sellingCurrentHome !== "boolean") return null;
        fields.sellingCurrentHome = sellingCurrentHome;
    }
    if (currentAddress !== undefined) {
        if (typeof currentAddress !== "string" || currentAddress.length > $b3168c9972e6d762$var$MAX_ADDRESS_LENGTH) return null;
        fields.currentAddress = currentAddress;
    }
    if (deposit !== undefined) {
        if (typeof deposit !== "number" || !Number.isFinite(deposit) || deposit < 0 || deposit > $b3168c9972e6d762$var$MAX_DEPOSIT) return null;
        fields.deposit = deposit;
    }
    return fields;
};
var $b3168c9972e6d762$export$a4921ad43f2acce4 = function() {
    try {
        sessionStorage.removeItem($b3168c9972e6d762$export$ce3c11559268ddac);
    } catch (e) {
    // Storage can be unavailable (e.g. blocked by the browser), and there's nothing to clear then.
    }
};
var $b3168c9972e6d762$export$8e409ea8959fa7ce = function(friendlyId, fields) {
    try {
        // Don't leave an empty entry (or a stale one from an earlier application) lying around.
        if (Object.keys(fields).length === 0) {
            $b3168c9972e6d762$export$a4921ad43f2acce4();
            return;
        }
        var stored = {
            friendlyId: friendlyId,
            savedAt: Date.now(),
            fields: fields
        };
        sessionStorage.setItem($b3168c9972e6d762$export$ce3c11559268ddac, JSON.stringify(stored));
    } catch (e) {
    // Storage can be unavailable or full. The split fact find works without the handoff.
    }
};
var $b3168c9972e6d762$export$724155ae6f8ece3e = function(friendlyId) {
    try {
        var raw = sessionStorage.getItem($b3168c9972e6d762$export$ce3c11559268ddac);
        if (!raw) return null;
        var stored = JSON.parse(raw);
        // Belongs to a different application than the one in this url.
        if ((stored === null || stored === void 0 ? void 0 : stored.friendlyId) !== friendlyId) return null;
        if (typeof stored.savedAt !== "number" || Date.now() - stored.savedAt > $b3168c9972e6d762$var$MAX_AGE_MS) return null;
        return $b3168c9972e6d762$var$parseFields(stored.fields);
    } catch (e) {
        return null;
    }
};


var $d6513fe6413a13cd$export$e622665da78eb867 = "/discovery/mortgage-profile";
var $d6513fe6413a13cd$export$ef2f7f59de072c5b = /*#__PURE__*/ function(SplitFfEntrySource) {
    SplitFfEntrySource["myMojo"] = "MyMojo";
    SplitFfEntrySource["onboarding"] = "Onboarding";
    return SplitFfEntrySource;
}({});
var $d6513fe6413a13cd$export$a1825ddae6b4c50f = [
    "split-ff-next-steps-variant-v4",
    "split-ff-next-steps-variant-v5"
];
var $d6513fe6413a13cd$export$5b4b3360c22f7582 = function(currentExperiments) {
    return (currentExperiments !== null && currentExperiments !== void 0 ? currentExperiments : "").split(";").some(function(experiment) {
        return $d6513fe6413a13cd$export$a1825ddae6b4c50f.includes(experiment.trim());
    });
};
var $d6513fe6413a13cd$var$ELIGIBLE_TLS_COLOUR = "green";
var $d6513fe6413a13cd$var$ELIGIBLE_TLS_TIERS = [
    "a",
    "b",
    "c"
];
var $d6513fe6413a13cd$export$d1cc53970eedcf3b = function(tls) {
    var _tls_colour, _tls_tier;
    var _tls_tier_trim_toLowerCase;
    return (tls === null || tls === void 0 ? void 0 : (_tls_colour = tls.colour) === null || _tls_colour === void 0 ? void 0 : _tls_colour.trim().toLowerCase()) === $d6513fe6413a13cd$var$ELIGIBLE_TLS_COLOUR && $d6513fe6413a13cd$var$ELIGIBLE_TLS_TIERS.includes((_tls_tier_trim_toLowerCase = tls === null || tls === void 0 ? void 0 : (_tls_tier = tls.tier) === null || _tls_tier === void 0 ? void 0 : _tls_tier.trim().toLowerCase()) !== null && _tls_tier_trim_toLowerCase !== void 0 ? _tls_tier_trim_toLowerCase : "");
};
var $d6513fe6413a13cd$export$b5f6c933b4ce1892 = function(appointments) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var _filter_map_filter_sort_;
    return (_filter_map_filter_sort_ = (appointments !== null && appointments !== void 0 ? appointments : []).filter(function(appointment) {
        return !!appointment.appointmentDate && !appointment.isCancelled;
    })// An invalid date is NaN, which is never after now
    .map(function(appointment) {
        return {
            appointment: appointment,
            time: new Date(appointment.appointmentDate).getTime()
        };
    }).filter(function(param) {
        var time = param.time;
        return time > now.getTime();
    }).sort(function(a, b) {
        return a.time - b.time;
    })[0]) === null || _filter_map_filter_sort_ === void 0 ? void 0 : _filter_map_filter_sort_.appointment;
};
var $d6513fe6413a13cd$export$f6f83c7cdc74a37e = function(summaryAppointments, applicationAppointments) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Date();
    return (summaryAppointments === null || summaryAppointments === void 0 ? void 0 : summaryAppointments.length) ? $d6513fe6413a13cd$export$b5f6c933b4ce1892(summaryAppointments, now) : $d6513fe6413a13cd$export$b5f6c933b4ce1892(applicationAppointments, now);
};
var $d6513fe6413a13cd$export$9fec2874cef7b215 = function(assignee) {
    return assignee && !assignee.includes("@") ? assignee : undefined;
};
/** The objects progress is read from. An empty list for either only counts if it was read. */ var $d6513fe6413a13cd$var$PROGRESS_OBJECTS = [
    "Property__c",
    "Applicant__c"
];
var $d6513fe6413a13cd$export$283add77a35cd24 = function(data) {
    var _data_records_Property__c;
    if (!(data === null || data === void 0 ? void 0 : data.records)) return null;
    if ($d6513fe6413a13cd$var$PROGRESS_OBJECTS.some(function(object) {
        var _data_failed;
        return (_data_failed = data.failed) === null || _data_failed === void 0 ? void 0 : _data_failed.includes(object);
    })) return null;
    var _data_records_Property__c_length;
    var property = ((_data_records_Property__c_length = (_data_records_Property__c = data.records.Property__c) === null || _data_records_Property__c === void 0 ? void 0 : _data_records_Property__c.length) !== null && _data_records_Property__c_length !== void 0 ? _data_records_Property__c_length : 0) > 0;
    var _data_records_Applicant__c;
    // The main fact find never writes marital status, so an applicant having one means they got to
    // the end of the personal section
    var personal = ((_data_records_Applicant__c = data.records.Applicant__c) !== null && _data_records_Applicant__c !== void 0 ? _data_records_Applicant__c : []).some(function(applicant) {
        return !!applicant.Marital_Status1_Applicant__c;
    });
    return {
        property: property,
        personal: personal,
        complete: property && personal
    };
};
var $d6513fe6413a13cd$export$17b54cf753f0444b = function(progress, application) {
    var _application_metadata_flags, _application_metadata;
    if (!(application === null || application === void 0 ? void 0 : application.applicationId)) return undefined;
    if (progress) return progress.complete;
    var _application_metadata_flags_includes;
    return (_application_metadata_flags_includes = (_application_metadata = application.metadata) === null || _application_metadata === void 0 ? void 0 : (_application_metadata_flags = _application_metadata.flags) === null || _application_metadata_flags === void 0 ? void 0 : _application_metadata_flags.includes((0, $6e6e522132305404$export$48ea269755562084).CompletedFactFindProperty)) !== null && _application_metadata_flags_includes !== void 0 ? _application_metadata_flags_includes : false;
};
var $d6513fe6413a13cd$export$736eadacbca10d45 = function(application, summary) {
    var _application_completePropertyDetails_propertyAddress, _application_completePropertyDetails, _summary_propertyAddress;
    return (application === null || application === void 0 ? void 0 : (_application_completePropertyDetails = application.completePropertyDetails) === null || _application_completePropertyDetails === void 0 ? void 0 : (_application_completePropertyDetails_propertyAddress = _application_completePropertyDetails.propertyAddress) === null || _application_completePropertyDetails_propertyAddress === void 0 ? void 0 : _application_completePropertyDetails_propertyAddress.postcode) || (summary === null || summary === void 0 ? void 0 : (_summary_propertyAddress = summary.propertyAddress) === null || _summary_propertyAddress === void 0 ? void 0 : _summary_propertyAddress.postcode) || undefined;
};
// The split fact find reads which application to open, and the postcode to validate it with, from
// a session it keeps in sessionStorage, rather than from the url (see `startSession` in the
// monorepo's apps/discovery/src/pages/split-factfind-pages/shared/session.ts). So that session has
// to be written before sending the user in. The key and version must match theirs: if they bump
// the version, an entry written here is ignored and the user lands on the split fact find's error
// page. Their `VERSION` was 3 when this was first written and had moved to 5 by 2026-10-30, so
// check it against theirs whenever the split fact find changes.
var $d6513fe6413a13cd$var$SPLIT_FF_SESSION_KEY = "mojo-split-factfind-session";
var $d6513fe6413a13cd$var$SPLIT_FF_SESSION_VERSION = 5;
var $d6513fe6413a13cd$var$startSplitFactFindSession = function(friendlyId, postcode) {
    try {
        sessionStorage.setItem($d6513fe6413a13cd$var$SPLIT_FF_SESSION_KEY, JSON.stringify({
            friendlyId: friendlyId,
            postcode: postcode,
            handoff: null,
            progress: null,
            version: $d6513fe6413a13cd$var$SPLIT_FF_SESSION_VERSION,
            savedAt: Date.now()
        }));
    } catch (e) {
    // Storage can be unavailable. The split fact find will then show its own error page.
    }
};
var $d6513fe6413a13cd$export$107ecb3da67f3216 = function(source) {
    return (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).splitFfEntrySource,
        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
        event_label: source
    });
};
var $d6513fe6413a13cd$export$3c77cd016036c269 = function(param) {
    var friendlyId = param.friendlyId, postcode = param.postcode, source = param.source, _param_handoff = param.handoff, handoff = _param_handoff === void 0 ? {} : _param_handoff;
    $d6513fe6413a13cd$export$107ecb3da67f3216(source);
    $d6513fe6413a13cd$var$startSplitFactFindSession(friendlyId, postcode);
    // Always written, even when empty, so that an entry left by another application is cleared
    (0, $b3168c9972e6d762$export$8e409ea8959fa7ce)(friendlyId, handoff);
    window.location.assign($d6513fe6413a13cd$export$e622665da78eb867);
};






parcelRequire("hAGkE");



function $95ef7631d9f6dafc$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  width: 64px;\n  height: 64px;\n  flex-shrink: 0;\n\n  @media screen and ",
        " {\n    width: 120px;\n    height: 120px;\n  }\n\n  @media screen and ",
        " {\n    width: 168px;\n    height: 168px;\n  }\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $95ef7631d9f6dafc$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $95ef7631d9f6dafc$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  stroke: ",
        ";\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $95ef7631d9f6dafc$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $95ef7631d9f6dafc$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n\n  @media screen and ",
        " {\n    font-size: 32px;\n  }\n\n  @media screen and ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $95ef7631d9f6dafc$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-left: 1px;\n  font-weight: 500;\n  font-size: 10px;\n\n  @media screen and ",
        " {\n    margin-left: 2px;\n    font-size: 16px;\n  }\n\n  @media screen and ",
        " {\n    font-size: 20px;\n  }\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $95ef7631d9f6dafc$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n  margin-top: 4px;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 1.2;\n  color: ",
        ";\n\n  @media screen and ",
        " {\n    display: block;\n  }\n\n  @media screen and ",
        " {\n    font-size: 13px;\n  }\n"
    ]);
    $95ef7631d9f6dafc$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
// The ring is drawn in a fixed 120 unit box and scaled with css, so the stroke scales with it.
var $95ef7631d9f6dafc$var$RADIUS = 52;
var $95ef7631d9f6dafc$var$STROKE_WIDTH = 12;
var $95ef7631d9f6dafc$var$CIRCUMFERENCE = 2 * Math.PI * $95ef7631d9f6dafc$var$RADIUS;
var $95ef7631d9f6dafc$var$Wrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($95ef7631d9f6dafc$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $95ef7631d9f6dafc$var$Svg = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).svg($95ef7631d9f6dafc$var$_templateObject1());
var $95ef7631d9f6dafc$var$Arc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).circle($95ef7631d9f6dafc$var$_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.status.warning;
});
var $95ef7631d9f6dafc$var$Label = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($95ef7631d9f6dafc$var$_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $95ef7631d9f6dafc$var$Value = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($95ef7631d9f6dafc$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $95ef7631d9f6dafc$var$Unit = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($95ef7631d9f6dafc$var$_templateObject5(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $95ef7631d9f6dafc$var$Caption = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($95ef7631d9f6dafc$var$_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text.secondary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $95ef7631d9f6dafc$export$700b56b69d412585 = function(param) {
    var percent = param.percent, caption = param.caption;
    var value = Math.min(100, Math.max(0, Math.round(percent)));
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($95ef7631d9f6dafc$var$Wrapper, {
        role: "progressbar",
        "aria-valuenow": value,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": caption ? "".concat(caption, ": ").concat(value, "%") : "".concat(value, "%"),
        "data-testid": "progress-ring",
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($95ef7631d9f6dafc$var$Svg, {
                viewBox: "0 0 120 120",
                "aria-hidden": "true",
                focusable: "false",
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("circle", {
                        cx: "60",
                        cy: "60",
                        r: $95ef7631d9f6dafc$var$RADIUS,
                        fill: "none",
                        stroke: (0, $b0a59b9452bb5152$export$8f45430ccf837300).neutral[100],
                        strokeWidth: $95ef7631d9f6dafc$var$STROKE_WIDTH
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($95ef7631d9f6dafc$var$Arc, {
                        cx: "60",
                        cy: "60",
                        r: $95ef7631d9f6dafc$var$RADIUS,
                        fill: "none",
                        strokeWidth: $95ef7631d9f6dafc$var$STROKE_WIDTH,
                        strokeLinecap: "round",
                        strokeDasharray: $95ef7631d9f6dafc$var$CIRCUMFERENCE,
                        strokeDashoffset: $95ef7631d9f6dafc$var$CIRCUMFERENCE * (1 - value / 100)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($95ef7631d9f6dafc$var$Label, {
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($95ef7631d9f6dafc$var$Value, {
                                children: value
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($95ef7631d9f6dafc$var$Unit, {
                                children: "%"
                            })
                        ]
                    }),
                    caption && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($95ef7631d9f6dafc$var$Caption, {
                        children: caption
                    })
                ]
            })
        ]
    });
};




var $6mdMa = parcelRequire("6mdMa");

parcelRequire("hAGkE");
var $aae174bf2f78d798$export$56aa7e40251bf296 = function(param) {
    var _param_icon = param.icon, _param_icon_icon = (0, $6mdMa._)(_param_icon.icon, 5), width = _param_icon_icon[0], height = _param_icon_icon[1], path = _param_icon_icon[4];
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
        viewBox: "0 0 ".concat(width, " ").concat(height),
        width: "".concat(width / height, "em"),
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            d: Array.isArray(path) ? path.join(" ") : path
        })
    });
};




function $3e3945459b9dacde$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-areas:\n    "heading ring"\n    "text text";\n  align-items: start;\n  column-gap: 16px;\n  row-gap: 12px;\n\n  @media screen and ',
        ' {\n    grid-template-areas:\n      "heading ring"\n      "text ring";\n    align-items: center;\n    row-gap: 8px;\n  }\n'
    ]);
    $3e3945459b9dacde$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  grid-area: heading;\n"
    ]);
    $3e3945459b9dacde$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  grid-area: text;\n"
    ]);
    $3e3945459b9dacde$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  grid-area: ring;\n"
    ]);
    $3e3945459b9dacde$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.4;\n  color: ",
        ";\n\n  @media screen and ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    $3e3945459b9dacde$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-top: 24px;\n\n  @media screen and ",
        " {\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n  }\n"
    ]);
    $3e3945459b9dacde$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 24px;\n  border-radius: 16px;\n  background: ",
        ";\n\n  &:only-child {\n    grid-column: 1 / -1;\n  }\n"
    ]);
    $3e3945459b9dacde$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    $3e3945459b9dacde$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  flex-shrink: 0;\n  color: ",
        ";\n"
    ]);
    $3e3945459b9dacde$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ",
        ";\n"
    ]);
    $3e3945459b9dacde$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: auto;\n  padding-top: 8px;\n\n  /*\n   * White against the tile, rather than see-through (the button's own hover style still applies),\n   * and less side padding so the longer labels stay on one line on a phone.\n   */\n  button.outline {\n    padding: 10px 16px;\n    background: ",
        ";\n  }\n"
    ]);
    $3e3945459b9dacde$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $3e3945459b9dacde$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 56px;\n  border-radius: 8px;\n  background: ",
        ";\n  color: ",
        ";\n  font-weight: 600;\n  font-size: 14px;\n"
    ]);
    $3e3945459b9dacde$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
// The fact find and the booking are done by the time this is shown, which is where the ring
// starts. What is left is the things this page asks for, which share the rest of it equally.
var $3e3945459b9dacde$var$PROGRESS_AFTER_BOOKING = 80;
var $3e3945459b9dacde$var$PROGRESS_REMAINING = 20;
var $3e3945459b9dacde$var$CardStyleOverrides = {
    borderRadius: "24px"
};
var $3e3945459b9dacde$var$CardHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3e3945459b9dacde$var$HeadingBlock = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject1());
var $3e3945459b9dacde$var$IntroText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject2());
var $3e3945459b9dacde$var$RingSlot = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject3());
var $3e3945459b9dacde$var$CardHeading = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($3e3945459b9dacde$var$_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3e3945459b9dacde$var$Tiles = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject5(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3e3945459b9dacde$var$Tile = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.background.secondary;
});
var $3e3945459b9dacde$var$TileHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject7());
var $3e3945459b9dacde$var$IconSlot = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($3e3945459b9dacde$var$_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $3e3945459b9dacde$var$TileTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h3($3e3945459b9dacde$var$_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $3e3945459b9dacde$var$TileAction = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.background.primary;
});
var $3e3945459b9dacde$var$CompleteBar = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3e3945459b9dacde$var$_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.colors.status.success;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text.primary;
});
var $3e3945459b9dacde$var$firstNameOf = function(name) {
    return (name === null || name === void 0 ? void 0 : name.trim().split(/\s+/)[0]) || undefined;
};
var $3e3945459b9dacde$export$5c81928116bc0fa3 = function(param) {
    var friendlyId = param.friendlyId, appointmentDate = param.appointmentDate, expertName = param.expertName, profileComplete = param.profileComplete, documentsComplete = param.documentsComplete, postcode = param.postcode, handoff = param.handoff;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var expertFirstName = $3e3945459b9dacde$var$firstNameOf(expertName);
    var appointmentHeading = "".concat((0, $f8c373eb33718aa4$export$105f2a30b5069e01)(appointmentDate)).concat(expertName ? " with ".concat(expertName) : "");
    var showProfileTile = profileComplete || !!postcode;
    // A profile that can't be offered at all (no postcode) isn't something they can tick off, so it
    // isn't counted and the ring can still fill.
    var outstanding = showProfileTile ? [
        profileComplete,
        documentsComplete
    ] : [
        documentsComplete
    ];
    var percentComplete = $3e3945459b9dacde$var$PROGRESS_AFTER_BOOKING + Math.round($3e3945459b9dacde$var$PROGRESS_REMAINING * outstanding.filter(Boolean).length / outstanding.length);
    var handleFinishProfile = function() {
        // The button is only shown with a postcode, and the split fact find can't be opened without one
        if (!postcode) return;
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).finishMortgageProfile
        });
        (0, $d6513fe6413a13cd$export$3c77cd016036c269)({
            friendlyId: friendlyId,
            postcode: postcode,
            source: (0, $d6513fe6413a13cd$export$ef2f7f59de072c5b).myMojo,
            handoff: handoff
        });
    };
    var handleUploadDocuments = function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).uploadDocs
        });
        history.push("/application/".concat(friendlyId, "/documents"));
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$15529022dcaf3eec), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                        weight: 500,
                        margin: "0 0 4px 0",
                        children: "You\u2019re all booked in"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H3, {
                        as: "h1",
                        margin: "0 0 8px 0",
                        children: appointmentHeading
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                        color: "secondary",
                        margin: "0",
                        children: "You\u2019ll soon be getting free expert advice on the best mortgage option for your specific circumstances."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                theme: "default",
                style: $3e3945459b9dacde$var$CardStyleOverrides,
                content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$CardHeader, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$HeadingBlock, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$CardHeading, {
                                            children: "You\u2019re one step closer\u2026"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$CardHeading, {
                                            as: "h2",
                                            children: "Prepare for your upcoming appointment"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$IntroText, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                        color: "secondary",
                                        margin: "0",
                                        children: [
                                            "To ensure ",
                                            expertFirstName !== null && expertFirstName !== void 0 ? expertFirstName : "your expert",
                                            " can provide you with accurate advice, there are a couple of quick things you can do prior to the appointment."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$RingSlot, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $95ef7631d9f6dafc$export$700b56b69d412585), {
                                        percent: percentComplete,
                                        caption: "Mortgage Profile"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$Tiles, {
                            children: [
                                showProfileTile && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$Tile, {
                                    "data-testid": "profile-tile",
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$TileHeader, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$IconSlot, {
                                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $aae174bf2f78d798$export$56aa7e40251bf296), {
                                                        icon: (0, $72947875341bbd79$export$8f4567331fb0d3bc)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$TileTitle, {
                                                    children: profileComplete ? "Extra questions answered" : "Complete your mortgage profile"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).SmallBody, {
                                            color: "secondary",
                                            margin: "0",
                                            children: profileComplete ? "Thank you. This helps your Mortgage Expert spend more time discussing the stuff that matters." : "Completing your mortgage profile helps to save time on your call and get the most accurate advice."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$TileAction, {
                                            children: profileComplete ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$CompleteBar, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $aae174bf2f78d798$export$56aa7e40251bf296), {
                                                        icon: (0, $72947875341bbd79$export$62b2c752fccc6a9c)
                                                    }),
                                                    "Complete"
                                                ]
                                            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                                type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                                                width: "100%",
                                                text: "Finish Mortgage Profile",
                                                onClick: handleFinishProfile
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$Tile, {
                                    "data-testid": "documents-tile",
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$TileHeader, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$IconSlot, {
                                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $aae174bf2f78d798$export$56aa7e40251bf296), {
                                                        icon: (0, $72947875341bbd79$export$243b47dca32bf0b8)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$TileTitle, {
                                                    children: documentsComplete ? "Documents uploaded" : "Upload your documents"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).SmallBody, {
                                            color: "secondary",
                                            margin: "0",
                                            children: documentsComplete ? "Thank you. Your Expert has what they need to research eligible deals." : "These essential documents help your Expert to research eligible deals and are used for any future application."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3e3945459b9dacde$var$TileAction, {
                                            children: documentsComplete ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3e3945459b9dacde$var$CompleteBar, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $aae174bf2f78d798$export$56aa7e40251bf296), {
                                                        icon: (0, $72947875341bbd79$export$62b2c752fccc6a9c)
                                                    }),
                                                    "Complete"
                                                ]
                                            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                                type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                                                width: "100%",
                                                text: "Upload documents",
                                                onClick: handleUploadDocuments
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $23d370b922ebfb16$export$8a97f20c8952d7e0), {}),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $40881c25d3dc0071$export$8a498ed11591c94b), {
                friendlyId: friendlyId
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3df5b69bd533317e$export$529610e36488c39e), {
                friendlyId: friendlyId
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$55891959d410fe99), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "If for any reason you need to amend or cancel your appointment, contact your expert directly via email."
                })
            })
        ]
    });
};




var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");



/**
 * Says what went wrong in words, with the api's own answer if it gave one. An axios error logs as
 * an empty object in the dev error overlay, which leaves out the part that says why.
 */ var $9eec1d6a6aa2d58f$var$describeError = function(e) {
    var _ref = e !== null && e !== void 0 ? e : {}, message = _ref.message, response = _ref.response;
    if (!response) return message !== null && message !== void 0 ? message : String(e);
    var _response_data;
    return "HTTP ".concat(response.status, ": ").concat(JSON.stringify((_response_data = response.data) !== null && _response_data !== void 0 ? _response_data : message));
};
var $9eec1d6a6aa2d58f$export$eb27b88392076c19 = function(friendlyId, enabled) {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), splitFactFind = _useState[0], setSplitFactFind = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), error = _useState1[0], setError = _useState1[1];
    (0, $hAGkE.useEffect)(function() {
        if (!friendlyId || !enabled) return;
        // A response that arrives after the page has moved on mustn't update it
        var isStale = false;
        var request = (0, $cda636b84ca95de8$export$1e0775a4561f3738)() ? $e1865584d8948220$export$3ea131bc8086db69() : (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/split-fact-find/".concat(friendlyId), {
            withCredentials: true
        }).then(function(param) {
            var data = param.data;
            return data;
        });
        request.then(function(data) {
            if (isStale) return;
            setError(null);
            setSplitFactFind(data);
        })["catch"](function(e) {
            if (isStale) return;
            // One string: the dev error overlay only shows the first argument
            console.error("Error fetching the split fact find: ".concat($9eec1d6a6aa2d58f$var$describeError(e)));
            setError("Failed to fetch the split fact find");
        });
        return function() {
            isStale = true;
        };
    }, [
        friendlyId,
        enabled
    ]);
    return {
        splitFactFind: splitFactFind,
        error: error
    };
};
var $9eec1d6a6aa2d58f$export$2e2bcd8739ae039 = $9eec1d6a6aa2d58f$export$eb27b88392076c19;




var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");



var $cCIJH = parcelRequire("cCIJH");
var $254afdf4bfa2446b$export$f2975041514eee5a = [
    "ID",
    "Income",
    "BankStatements"
];
var $254afdf4bfa2446b$export$4858f4fef50e8b12 = function(application) {
    var _application_metadata;
    if (!(application === null || application === void 0 ? void 0 : application.applicationId)) return undefined;
    var _application_applicants;
    var applicants = (_application_applicants = application.applicants) !== null && _application_applicants !== void 0 ? _application_applicants : [];
    if (applicants.length === 0) return undefined;
    var _application_metadata_documents;
    var documents = (_application_metadata_documents = (_application_metadata = application.metadata) === null || _application_metadata === void 0 ? void 0 : _application_metadata.documents) !== null && _application_metadata_documents !== void 0 ? _application_metadata_documents : [];
    return applicants.every(function(applicant) {
        return $254afdf4bfa2446b$export$f2975041514eee5a.every(function(docType) {
            return documents.some(function(document) {
                return document.applicantId === applicant.id && document.docType === docType;
            });
        });
    });
};
function $254afdf4bfa2446b$export$792769bf76d010a9(filesUploaded, applicationId, applicantId, docType) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, currentFilename, originalFilename, err, data;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // TODO: change the update document metadata endpoint to be a single batch POST
                    if (filesUploaded.length < 1) throw Error("Unreachable: UploadDocumentMetaData called without files.");
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = filesUploaded[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    file = _step.value;
                    currentFilename = file.key.split("/")[1];
                    originalFilename = file.originalFile.name;
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).put("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/applications/").concat(applicationId, "/document?applicantId=").concat(applicantId, "&currentFilename=").concat(currentFilename, "&originalFilename=").concat(originalFilename, "&docType=").concat(docType), null, {
                            withCredentials: true
                        })
                    ];
                case 3:
                    res = _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    data = res.data;
                    return [
                        2,
                        data.metadata.documents
                    ];
            }
        });
    })();
}
function $254afdf4bfa2446b$export$8e0779374e7083bc(applicationId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response, error;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/documents/").concat(applicationId, "/offer"), {
                            withCredentials: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 2:
                    error = _state.sent();
                    (0, $cCIJH.captureMessage)("Failed to fetch offer documents for applicationId: ".concat(applicationId));
                    console.error("Failed to fetch offer documents:", error);
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}



var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");



var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $dMrZK = parcelRequire("dMrZK");




var $ec64207fbc0381b0$export$88cb9786d4b92a1d = function() {
    return [
        (0, $6e6e522132305404$export$9542f959509ad58).quoted,
        (0, $6e6e522132305404$export$9542f959509ad58).closedlost,
        (0, $6e6e522132305404$export$9542f959509ad58).completionSet,
        (0, $6e6e522132305404$export$9542f959509ad58).mortgageready,
        (0, $6e6e522132305404$export$9542f959509ad58).online,
        (0, $6e6e522132305404$export$9542f959509ad58).coach
    ];
};
var $ec64207fbc0381b0$export$fe9f1db9eea5d949 = function(applicationStatus) {
    return $ec64207fbc0381b0$export$88cb9786d4b92a1d().includes(applicationStatus);
};
var $ec64207fbc0381b0$export$857b476969052b12 = function(applicationId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $cda636b84ca95de8$export$1e0775a4561f3738)()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $e1865584d8948220$export$b70265791d2079d4()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/status/".concat(applicationId), {
                            withCredentials: true
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $ec64207fbc0381b0$export$c6c484c00f474b94 = function(apiResponse) {
    var _apiResponse_property, _apiResponse_property1;
    var documentsRequested = apiResponse.numberOfDocumentsRequested > 0 && apiResponse.numberOfDocumentsRequested;
    return (0, $7XD9P._)((0, $hRCmZ._)({}, apiResponse), {
        documentsRequested: documentsRequested,
        propertyAddress: ((_apiResponse_property = apiResponse.property) === null || _apiResponse_property === void 0 ? void 0 : _apiResponse_property.firstLineAddress) || null,
        offerAmount: ((_apiResponse_property1 = apiResponse.property) === null || _apiResponse_property1 === void 0 ? void 0 : _apiResponse_property1.value) || null
    });
};


var $5498f4b77f32d3cf$export$b70265791d2079d4 = function(applicationId, setFetchedStatus, setIsLoading, setError) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var data, status, e;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    setIsLoading(true);
                    setError(null);
                    return [
                        4,
                        (0, $ec64207fbc0381b0$export$857b476969052b12)(applicationId)
                    ];
                case 1:
                    data = _state.sent();
                    status = (0, $ec64207fbc0381b0$export$c6c484c00f474b94)(data);
                    setFetchedStatus(status);
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).caseStatus,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).customEvent,
                        event_label: "Recommendation accepted ".concat(JSON.stringify(status.recommendationAccepted), ", documents requested: ").concat(JSON.stringify(status.documentsRequested), "}")
                    });
                    return [
                        3,
                        4
                    ];
                case 2:
                    e = _state.sent();
                    console.log(e);
                    setError("Failed to fetch status data");
                    return [
                        3,
                        4
                    ];
                case 3:
                    setIsLoading(false);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $5498f4b77f32d3cf$export$3a0f928068aeb826 = function(param) {
    var applicationId = param.applicationId, opportunityStage = param.opportunityStage;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), fetchedStatus = _useState[0], setFetchedStatus = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), error = _useState2[0], setError = _useState2[1];
    (0, $hAGkE.useEffect)(function() {
        if (!applicationId) return;
        if ((0, $ec64207fbc0381b0$export$fe9f1db9eea5d949)(opportunityStage)) $5498f4b77f32d3cf$export$b70265791d2079d4(applicationId, setFetchedStatus, setIsLoading, setError);
    }, [
        applicationId,
        opportunityStage
    ]);
    return {
        fetchedStatus: fetchedStatus,
        isLoading: isLoading,
        error: error
    };
};



var $8e324a08c1756686$exports = {};
$8e324a08c1756686$exports = $parcel$resolve("k3VSs");



var $hRCmZ = parcelRequire("hRCmZ");


var $c62e2d678980b6c6$exports = {};
$c62e2d678980b6c6$exports = $parcel$resolve("kVtAE");


var $cba09c37978e7e74$var$BTL_SPECIALIST_COST = 499;
var $cba09c37978e7e74$export$c99b893d464ee8dd = /*#__PURE__*/ function(MojoServiceTypes) {
    MojoServiceTypes["BTL_SPECIALIST"] = "BTL_SPECIALIST";
    MojoServiceTypes["DEFAULT"] = "DEFAULT";
    return MojoServiceTypes;
}({});
var $cba09c37978e7e74$var$CONFIG_PRESETS = {
    DEFAULT: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($cdee53f79ccf0fe3$exports))),
        fee: 0,
        serviceType: "DEFAULT",
        recommendation: {
            title: "Mojo's broker fee",
            description: "We don't charge you a penny, all our costs are covered by the lender, these fees never affect our advice. Our reputation and livelihood depend on us always giving our customers the best possible advice.",
            accept: {
                text: "If you're happy with your recommendation then click to accept and we'll get the wheels in motion to secure your rate",
                subText: null
            }
        }
    },
    BTL_SPECIALIST: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c62e2d678980b6c6$exports))),
        fee: $cba09c37978e7e74$var$BTL_SPECIALIST_COST,
        serviceType: "BTL_SPECIALIST",
        recommendation: {
            title: "Mojo Specialist's application fee",
            description: "A single \xa3".concat($cba09c37978e7e74$var$BTL_SPECIALIST_COST, " fee is charged for application. This covers the preparation and packaging of your application, plus our dedicated case management service."),
            accept: {
                text: "If you're happy with your recommendation, click 'Accept' to proceed",
                subText: "Our team will then begin preparing your application for submission to [Lender]. The \xa3".concat($cba09c37978e7e74$var$BTL_SPECIALIST_COST, " application fee for our Mojo Specialist service is payable once your application is ready. Your Case Manager will be in touch soon to guide you through the next steps")
            }
        }
    }
};
function $cba09c37978e7e74$export$be448bb5a420a5ee(serviceType, feeRemoved) {
    if (feeRemoved) return $cba09c37978e7e74$var$CONFIG_PRESETS["DEFAULT"];
    var _CONFIG_PRESETS_serviceType;
    return (_CONFIG_PRESETS_serviceType = $cba09c37978e7e74$var$CONFIG_PRESETS[serviceType]) !== null && _CONFIG_PRESETS_serviceType !== void 0 ? _CONFIG_PRESETS_serviceType : $cba09c37978e7e74$var$CONFIG_PRESETS["DEFAULT"];
}
function $cba09c37978e7e74$export$3fa1247579fc9c96(serviceType, paymentStatus) {
    var isFeeRemoved = paymentStatus === (0, $9394149be221a7b2$export$999f810846f9d31d).FeeRemoved;
    return $cba09c37978e7e74$export$be448bb5a420a5ee(serviceType, isFeeRemoved);
}
function $cba09c37978e7e74$export$d181027f47bfa9e4(serviceType, application) {
    var _application_service;
    var paymentStatus = application === null || application === void 0 ? void 0 : (_application_service = application.service) === null || _application_service === void 0 ? void 0 : _application_service.status;
    return serviceType === "BTL_SPECIALIST" && paymentStatus !== (0, $9394149be221a7b2$export$999f810846f9d31d).FeeRemoved;
}
function $cba09c37978e7e74$export$2a93b82c132dbea4(serviceType, application) {
    var _application_service;
    var paymentStatus = application === null || application === void 0 ? void 0 : (_application_service = application.service) === null || _application_service === void 0 ? void 0 : _application_service.status;
    return serviceType === "BTL_SPECIALIST" && paymentStatus === (0, $9394149be221a7b2$export$999f810846f9d31d).PaymentRequired;
}
function $cba09c37978e7e74$export$a9d55f450893c799(application) {
    var _application_service;
    var paymentStatus = application === null || application === void 0 ? void 0 : (_application_service = application.service) === null || _application_service === void 0 ? void 0 : _application_service.status;
    return ![
        (0, $9394149be221a7b2$export$999f810846f9d31d).FeeRemoved,
        (0, $9394149be221a7b2$export$999f810846f9d31d).Paid
    ].includes(paymentStatus);
}
function $cba09c37978e7e74$export$1f1126ea06a9f8cd(application) {
    var configKey = $cba09c37978e7e74$export$39503da8d789c993(application);
    return (0, $hRCmZ._)({}, $cba09c37978e7e74$var$CONFIG_PRESETS[configKey]);
}
function $cba09c37978e7e74$export$39503da8d789c993(application) {
    var service = application.service, occupancy = application.occupancy;
    var _occupancy_toLowerCase_trim_includes;
    var isBTL = (_occupancy_toLowerCase_trim_includes = occupancy === null || occupancy === void 0 ? void 0 : occupancy.toLowerCase().trim().includes("rent it out")) !== null && _occupancy_toLowerCase_trim_includes !== void 0 ? _occupancy_toLowerCase_trim_includes : false;
    if (isBTL && (service === null || service === void 0 ? void 0 : service.level) === "Specialist") return "BTL_SPECIALIST";
    return "DEFAULT";
}



parcelRequire("hAGkE");










parcelRequire("hAGkE");


var $8c6ug = parcelRequire("8c6ug");


var $9202359a700e044a$export$69ed894a7932b604 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).section(function(param) {
    var _param_columns = param.columns, columns = _param_columns === void 0 ? 2 : _param_columns;
    return (0, $8c6ug._)({
        background: "white",
        width: "100%",
        maxWidth: "1100px",
        borderRadius: "24px",
        padding: "24px",
        margin: "32px 0",
        display: "flex",
        flexDirection: "column",
        gap: "24px"
    }, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        padding: "40px",
        display: "grid",
        gridTemplateColumns: columns === 2 ? "1.4fr 1fr" : "none",
        alignItems: "center",
        gap: "32px"
    });
});
var $9202359a700e044a$export$d2cf3038149dd1b5 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        padding: "8px 12px",
        alignItems: "flex-start",
        gap: "8px",
        borderRadius: "8px",
        background: theme.colors.yellow[500],
        width: "fit-content",
        fontSize: "14px",
        fontWeight: 600,
        color: theme.colors.neutral[900]
    };
});
var $9202359a700e044a$export$51a9c37cab91cff6 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    flexDirection: "column",
    gap: "16px"
}, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    width: "100%",
    justifyContent: "center",
    gap: "10px"
}));
var $9202359a700e044a$export$69bc41ee738923ec = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2(function(param) {
    var theme = param.theme;
    var _theme_shade;
    return (0, $8c6ug._)({
        fontSize: "20px",
        fontWeight: 600,
        color: (theme === null || theme === void 0 ? void 0 : (_theme_shade = theme.shade) === null || _theme_shade === void 0 ? void 0 : _theme_shade["0"]) || "#3F4148",
        margin: "12px 0",
        lineHeight: 1.3
    }, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        fontSize: "24px",
        margin: "16px 0"
    });
});
var $9202359a700e044a$export$171d1744501983 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(function(param) {
    var theme = param.theme;
    var _theme_shade;
    return (0, $8c6ug._)({
        fontSize: "14px",
        color: (theme === null || theme === void 0 ? void 0 : (_theme_shade = theme.shade) === null || _theme_shade === void 0 ? void 0 : _theme_shade["20"]) || "#3B4258",
        lineHeight: 1.7,
        fontWeight: 500,
        margin: "0"
    }, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        fontSize: "15px"
    });
});
var $9202359a700e044a$export$b3711e4d32776a29 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    order: -1,
    img: {
        width: "100%",
        height: "200px",
        borderRadius: "8px",
        objectFit: "cover"
    }
}, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    order: 0,
    img: {
        height: "250px"
    }
}));


var $d9ca7e7d30cb7494$export$10d1107d105c9668 = function(param) {
    var title = param.title, paragraphs = param.paragraphs, buttonText = param.buttonText, _param_buttonType = param.buttonType, buttonType = _param_buttonType === void 0 ? (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid : _param_buttonType, onButtonClick = param.onButtonClick, imageSrc = param.imageSrc, imageAlt = param.imageAlt, pillText = param.pillText;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $9202359a700e044a$export$69ed894a7932b604), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $9202359a700e044a$export$51a9c37cab91cff6), {
                children: [
                    pillText && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9202359a700e044a$export$d2cf3038149dd1b5), {
                        children: pillText
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9202359a700e044a$export$69bc41ee738923ec), {
                        children: title
                    }),
                    paragraphs.map(function(paragraph, index) {
                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9202359a700e044a$export$171d1744501983), {
                            children: paragraph
                        }, index);
                    }),
                    buttonText && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                        type: buttonType,
                        text: buttonText,
                        onClick: onButtonClick
                    })
                ]
            }),
            imageSrc && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9202359a700e044a$export$b3711e4d32776a29), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                    src: imageSrc,
                    alt: imageAlt || title
                })
            })
        ]
    });
};


var $47dccc38fdb0030e$export$55a85b01207fe878 = function(param) {
    var friendlyId = param.friendlyId;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var handleBookAppointment = function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: "Book Appointment - Specialist"
        });
        window.location.href = "https://results.mojomortgages.com/".concat(friendlyId, "/nurture");
    };
    var handleLearnMore = function(section, uri) {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: "Learn More - ".concat(section)
        });
        history.push(uri);
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5c0547b091a4b556), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$4489c2ed11909944), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$f32ccc8e9f794271), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$815fb821483d8e08), {
                                    children: "Secure the right mortgage for your property"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$4cf7f029fe6b7159), {
                                    children: "With Mojo Specialist, your Mortgage Expert will help you navigate the market to provide you with a clear, personal recommendation."
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$4cf7f029fe6b7159), {
                                    children: [
                                        "Should you apply, a ",
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                                            children: "\xa3499"
                                        }),
                                        " non-refundable fee covers expert application and packaging from a dedicated Case Manager."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$4cf7f029fe6b7159), {
                                    children: "You also get our Rate Check Promise (if eligible), which automatically scans for better rates from your chosen lender, which has provided our customers with an average saving of \xa3748*."
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$bd36621ef7814117), {
                                    type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                                    onClick: handleBookAppointment,
                                    text: "Book your Buy-to-Let Specialist Advice"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9b9920498925f0fb), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c0f3303543545f03$exports))),
                                alt: "Property illustration"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d9ca7e7d30cb7494$export$10d1107d105c9668), {
                    title: "Our Rate Check Promise",
                    paragraphs: [
                        "Secure your mortgage with the confidence that you're on the best possible rate. The mortgage market moves fast, and rates can change frequently.",
                        "Our Rate Check Promise is a high-level service designed to ensure you don't miss out on a better deal that you've applied with us or a lender."
                    ],
                    buttonText: "Learn more",
                    buttonType: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                    onButtonClick: function() {
                        return handleLearnMore("Rate Check", "/application/".concat(friendlyId, "/rate-check-promise"));
                    },
                    imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($ff419e2b02580b2c$exports))),
                    imageAlt: "Rate check illustration",
                    pillText: "Included service"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d9ca7e7d30cb7494$export$10d1107d105c9668), {
                    title: "Secure your property's legal work",
                    paragraphs: [
                        "Conveyancing is a vital part of securing your property. It's important to instruct your chosen solicitor as soon as you're ready.",
                        "Your Mortgage Expert has provided a number of quotes for you to compare and review."
                    ],
                    buttonText: "View conveyancing quotes",
                    buttonType: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                    onButtonClick: function() {
                        return handleLearnMore("Conveyancing", "/application/".concat(friendlyId, "/conveyancing"));
                    },
                    imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($f0d226df099d0c4c$exports))),
                    imageAlt: "Legal conveyancing illustration"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$30d95fb206f2716), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$b94f30aa31093782), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$b6570f987931fbcb), {
                                    children: "What our customers say"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5902fbf547f0ef82), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$ce6f6d5239a986c9), {
                                            children: "After so many struggles with my actual\u2026"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$ececb5740e139a0b), {
                                            children: "After so many struggles with my actual mortgage lender, a well known bank, it was a pleasure to talk with the advisor from Mojo. They explained everything really clearly and offered me advice on which lender to go with. Would absolutely recommend."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$caa563a408e1927), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$4447f1e7c9a89e1b), {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5e19b9354e495cb9), {
                                                    children: "\u2605\u2605\u2605\u2605\u2605"
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$4236a1dce8bed981), {
                                                    children: "Jenna"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$441cb28ce0dfeb0f), {
                                            children: "17 July 2024"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$a598707cfcbe391f), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d064dfd92ce74522$export$f63de433e1787c6d), {
                                height: "240px",
                                width: "100%",
                                templateId: "54d0e1d8764ea9078c79e6ee",
                                theme: "light"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$74f29a5c5ac28ae1), {
                    children: "*Data taken using Mojo\u2019s internal records, covering the period from 18 February 2025 to 30 September 2025. Average savings over the initial term based on the difference between the customer\u2019s initial pay rate and their new, lower rate discovered through our Rate Check Promise service.*"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$a06f1c675e846f6f), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$7b4485b886e9117a), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cdee53f79ccf0fe3$exports))),
                            alt: "Mojo"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9c55d0bdacc50a98), {
                            children: "Mojo is a trading style of Life's Great Limited which is registered in England and Wales (06246376). We are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215) Our registered office is The Cooperage, 5 Copper Row, London, SE1 2LH, and head office is Mojo Mortgages, WeWork No. 1 Spinningfields, Quay Street, Manchester, M3 3JE."
                        })
                    ]
                })
            ]
        })
    });
};





var $hAGkE = parcelRequire("hAGkE");













var $c5a78040eca99640$export$5a3632b84085f63b = function(param) {
    var friendlyId = param.friendlyId, fetchedStatus = param.fetchedStatus;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var application = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }).application;
    (0, $hAGkE.useEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentViewed,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).completeYourPayment
        });
    }, []);
    var mortgageExpert = {
        name: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.opportunityOwnerTextForEmail) || "Mojo Mortgages",
        title: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.flexRoles2) || "Mortgage Expert",
        email: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress) || "",
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($175870872636a4b6$exports)))
    };
    var handleLearnMore = function(section, uri) {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: "Learn More - ".concat(section)
        });
        history.push(uri);
    };
    var handlePayment = function() {
        var _application_service;
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: "Pay Now - Specialist Fee"
        });
        if (application === null || application === void 0 ? void 0 : (_application_service = application.service) === null || _application_service === void 0 ? void 0 : _application_service.checkoutSessionUrl) window.location.href = application.service.checkoutSessionUrl;
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5c0547b091a4b556), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$4489c2ed11909944), {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$f32ccc8e9f794271), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$815fb821483d8e08), {
                                children: "Your buy-to-let mortgage application is underway"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$4cf7f029fe6b7159), {
                                children: [
                                    "Your Mortgage Expert ",
                                    mortgageExpert === null || mortgageExpert === void 0 ? void 0 : mortgageExpert.name,
                                    ", is now reviewing your documents and packaging your application. We're working to ensure it meets all the lender's requirements for a smooth approval."
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$4cf7f029fe6b7159), {
                                children: "If you haven't already, please upload all requested documents via your secure link to avoid any delays."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d9ca7e7d30cb7494$export$10d1107d105c9668), {
                    title: "Complete your payment",
                    paragraphs: [
                        "Before we can submit your application, the \xa3499 application fee for your Mojo Specialist service needs to be paid. This fee covers the expert management of your BTL application. This fee is non-refundable.",
                        "You can complete this step now to ensure a speedy submission."
                    ],
                    buttonText: "Pay now",
                    buttonType: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                    onButtonClick: handlePayment,
                    imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($b9f9a65bc1278693$exports))),
                    imageAlt: "Family carrying a giant key",
                    pillText: "Action required"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d9ca7e7d30cb7494$export$10d1107d105c9668), {
                    title: "Secure your property's legal work",
                    paragraphs: [
                        "Conveyancing is a vital part of securing your property. It's important to instruct your chosen solicitor as soon as you're ready.",
                        "Your Mortgage Expert has provided a number of quotes for you to compare and review."
                    ],
                    buttonText: "View conveyancing quotes",
                    buttonType: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                    onButtonClick: function() {
                        return handleLearnMore("Conveyancing", "/application/".concat(friendlyId, "/conveyancing"));
                    },
                    imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($f0d226df099d0c4c$exports))),
                    imageAlt: "Legal conveyancing illustration"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9202359a700e044a$export$69ed894a7932b604), {
                    columns: 1,
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $9202359a700e044a$export$51a9c37cab91cff6), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9202359a700e044a$export$69bc41ee738923ec), {
                                children: "Your Mortgage Expert"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $9202359a700e044a$export$171d1744501983), {
                                children: [
                                    mortgageExpert === null || mortgageExpert === void 0 ? void 0 : mortgageExpert.name,
                                    " is on hand to help you finalise everything for your application."
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $59f3439255a74e88$export$d2a3c4d05e125f83), {
                                mortgageExpert: mortgageExpert
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$74f29a5c5ac28ae1), {
                    children: "*Data taken using Mojo\u2019s internal records, covering the period from 18 February 2025 to 30 September 2025. Average savings over the initial term based on the difference between the customer\u2019s initial pay rate and their new, lower rate discovered through our Rate Check Promise service.*"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$a06f1c675e846f6f), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$7b4485b886e9117a), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cdee53f79ccf0fe3$exports))),
                            alt: "Mojo"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9c55d0bdacc50a98), {
                            children: "Mojo is a trading style of Life's Great Limited which is registered in England and Wales (06246376). We are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215) Our registered office is The Cooperage, 5 Copper Row, London, SE1 2LH, and head office is Mojo Mortgages, WeWork No. 1 Spinningfields, Quay Street, Manchester, M3 3JE."
                        })
                    ]
                })
            ]
        })
    });
};


var $2b2cb2b780ecb0b2$export$96e9906d6d93a972 = function(param) {
    var serviceType = param.serviceType, friendlyId = param.friendlyId, refreshApplications = param.refreshApplications, salesforceApplication = param.salesforceApplication, application = param.application, _param_opportunityStage = param.opportunityStage, opportunityStage = _param_opportunityStage === void 0 ? null : _param_opportunityStage;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), appointmentDate = _useState[0], setAppointmentDate = _useState[1];
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var _salesforceApplication_lender;
    var lender = (_salesforceApplication_lender = salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.lender) !== null && _salesforceApplication_lender !== void 0 ? _salesforceApplication_lender : "your lender";
    var _useStatusData = (0, $5498f4b77f32d3cf$export$3a0f928068aeb826)({
        applicationId: salesforceApplication.applicationId,
        opportunityStage: opportunityStage
    }), fetchedStatus = _useStatusData.fetchedStatus, isLoading = _useStatusData.isLoading;
    (0, $hAGkE.useEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).pageViewed,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).formInteraction,
            event_label: "MyMojo - Status"
        });
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).caseStatus,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).customEvent,
            event_label: opportunityStage
        });
    }, []);
    (0, $hAGkE.useEffect)(function() {
        if (!salesforceApplication) return;
        if (salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.hasAppointments) {
            var _salesforceApplication_appointments = salesforceApplication.appointments, appointments = _salesforceApplication_appointments === void 0 ? [] : _salesforceApplication_appointments;
            if (appointments.length) {
                var _appointments = (0, $6mdMa._)(appointments, 1), appointment = _appointments[0];
                var appointmentDate = appointment.appointmentDate;
                var apptDate = new Date(appointmentDate);
                setAppointmentDate(apptDate);
            }
        }
    }, [
        salesforceApplication
    ]);
    var _obj;
    var contentStage = (_obj = {}, (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).mortgageready, (0, $bb552e4db890ef97$export$2013e195d08f4102).advise), // Made it through fact find
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).online, (0, $bb552e4db890ef97$export$2013e195d08f4102).advise), // Fact find and pre-appointment / appointment pending
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).coach, (0, $bb552e4db890ef97$export$2013e195d08f4102).advise), // Mortgage coach flow
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).quoted, (0, $bb552e4db890ef97$export$2013e195d08f4102).recommendation), // Had a recommentation from the ME
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).submitted, (0, $bb552e4db890ef97$export$2013e195d08f4102).application), // After fact find and recommendation has been submittd. The application is with the lender
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).offer, (0, $bb552e4db890ef97$export$2013e195d08f4102).offer), // Lender has come back with an offer for the customer to review
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).exchanged, (0, $bb552e4db890ef97$export$2013e195d08f4102).offer), // Exchanged contracts & documents through soliciors & the process can go through to completed
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).closedwon, (0, $bb552e4db890ef97$export$2013e195d08f4102).won), // We have completed and they have finished their mortgage process
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).dip, (0, $bb552e4db890ef97$export$2013e195d08f4102).dip), // CMT are on the lender portal and manually keying in salesforce
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).completionSet, (0, $bb552e4db890ef97$export$2013e195d08f4102).completionSet), // Completion date has been set
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).presub, (0, $bb552e4db890ef97$export$2013e195d08f4102).wip), // Pre-submission (it is dipped and waiting feeback from lender)
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).awaiting, (0, $bb552e4db890ef97$export$2013e195d08f4102).wip), // Awaiting to go over to the case management team
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).returned, (0, $bb552e4db890ef97$export$2013e195d08f4102).wip), // Returned to advisor, its been DIPed but lender has questions or application is delcined from lender
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).packaged, (0, $bb552e4db890ef97$export$2013e195d08f4102).dip), // Fully ME packaged, everything we need to DIP
    (0, $8c6ug._)(_obj, (0, $6e6e522132305404$export$9542f959509ad58).closedlost, (0, $bb552e4db890ef97$export$2013e195d08f4102).lost // We have lost the client, they are not mortgage ready or chosen a different lender
    ), _obj)[opportunityStage];
    // Check for core conditions
    var isCoreScenario = contentStage === (0, $bb552e4db890ef97$export$2013e195d08f4102).advise && fetchedStatus && fetchedStatus.amount === null && fetchedStatus.stageName === "Online" && (fetchedStatus.opportunityRecordType1 === "PurchaseOpportunity" || fetchedStatus.opportunityRecordType1 === "RemortgageOpportunity") && fetchedStatus.opportunityOwnerTextForEmail !== "Mojo Mortgages";
    // Check for offer accepted conditions
    var isOfferAcceptedScenario = contentStage === (0, $bb552e4db890ef97$export$2013e195d08f4102).advise && fetchedStatus && fetchedStatus.mipIssuedToCustomer === true && fetchedStatus.amount === null && fetchedStatus.stageName === "Nurture" && fetchedStatus.opportunityRecordType1 === "PurchaseOpportunity" && fetchedStatus.opportunityOwnerTextForEmail !== "Mojo Mortgages";
    // Check for offer accepted booked conditions
    var isAppointmentInFuture = appointmentDate && new Date(appointmentDate) > new Date();
    var isOfferAcceptedBookedScenario = isOfferAcceptedScenario && (salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.hasAppointments) && isAppointmentInFuture;
    var isBTLSpecialist = function(page) {
        return page === (0, $bb552e4db890ef97$export$2013e195d08f4102).advise && (0, $cba09c37978e7e74$export$d181027f47bfa9e4)(serviceType, salesforceApplication);
    };
    var isBTLSpecialistPayment = function(page) {
        return page === (0, $bb552e4db890ef97$export$2013e195d08f4102).recommendation && (0, $cba09c37978e7e74$export$2a93b82c132dbea4)(serviceType, salesforceApplication);
    };
    // Green A/B/C with an appointment still to come: the booking confirmation, with routes into the
    // split fact find and the documents. It takes over from the core view, which is what these
    // users would otherwise get once their expert has been assigned.
    var upcomingAppointment = (0, $d6513fe6413a13cd$export$f6f83c7cdc74a37e)(salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.appointments, application === null || application === void 0 ? void 0 : application.appointments);
    // Only for the experiment's variant arm, which needs `/status`: until that is back, or if it
    // failed, we don't know the arm and this stays false, so the usual advise content is shown rather
    // than the new page being given to someone who may be in the control arm.
    var isPrepareForAppointmentScenario = contentStage === (0, $bb552e4db890ef97$export$2013e195d08f4102).advise && !isBTLSpecialist((0, $bb552e4db890ef97$export$2013e195d08f4102).advise) && !isOfferAcceptedScenario && (0, $d6513fe6413a13cd$export$d1cc53970eedcf3b)(salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.tls) && !!upcomingAppointment && (0, $d6513fe6413a13cd$export$5b4b3360c22f7582)(fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.currentExperiments);
    // What Salesforce holds of the split fact find is a read of nine objects, so it is only made for
    // someone who is going to see the view (which already means `/status` has come back).
    var _useSplitFactFind = (0, $9eec1d6a6aa2d58f$export$eb27b88392076c19)(friendlyId, isPrepareForAppointmentScenario), splitFactFind = _useSplitFactFind.splitFactFind, splitFactFindError = _useSplitFactFind.error;
    // `undefined` until the full application and Salesforce's side have both come back, so the
    // profile step doesn't show as outstanding and then flip. A read that failed counts as back: the
    // application's flag then decides on its own.
    var splitFfSettled = !!splitFactFind || !!splitFactFindError;
    var splitFfComplete = splitFfSettled ? (0, $d6513fe6413a13cd$export$17b54cf753f0444b)((0, $d6513fe6413a13cd$export$283add77a35cd24)(splitFactFind), application) : undefined;
    // From the application this page already has, so it needs nothing waiting for
    var documentsComplete = (0, $254afdf4bfa2446b$export$4858f4fef50e8b12)(application);
    var getPageContent = function() {
        if (isPrepareForAppointmentScenario) return (0, $bb552e4db890ef97$export$2013e195d08f4102).prepareForAppointment;
        if (isCoreScenario) return (0, $bb552e4db890ef97$export$2013e195d08f4102).core;
        if (isOfferAcceptedBookedScenario) return (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAcceptedBooked;
        if (isOfferAcceptedScenario) return (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAccepted;
        return contentStage;
    };
    var pageContent = getPageContent();
    var _obj1;
    var content = (0, $3774b92b86ee5532$export$4f37f5a2d452f4cd)((_obj1 = {}, (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).advise, isBTLSpecialist((0, $bb552e4db890ef97$export$2013e195d08f4102).advise) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $47dccc38fdb0030e$export$55a85b01207fe878), {
            friendlyId: friendlyId
        })
    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).bookAnAppointment,
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Your personal Mojo expert is ready to make your mortgage recommendation"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Mortgages can be complicated things, and here at Mojo we want to get it perfect. Your expert wants to review and approve everything, and it's far easier for you if we have a quick call."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f51f4c4ede09e011), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                    style: {
                        margin: "0 auto"
                    },
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d064dfd92ce74522$export$f63de433e1787c6d), {})
                })
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).successfulApplicaton, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Successful Application",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5babecc773473a0f), {
                    children: "You mortgage application has been successful!"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "Congratulations. ",
                    lender,
                    " is prepared to offer you a mortgage. \uD83C\uDF89"
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d8a8e2cd87eed68c), {
                children: "What happens next?"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "You\u2019ll be sent the details of the offer directly from the lender and will need to accept the offer through your Case Manager.",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "Your Case Manager will now see the offer through to completion and keep you updated.",
                    " "
                ]
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).recommendation, isBTLSpecialistPayment((0, $bb552e4db890ef97$export$2013e195d08f4102).recommendation) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $c5a78040eca99640$export$5a3632b84085f63b), {
        friendlyId: friendlyId,
        fetchedStatus: fetchedStatus
    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$RecommendationSteps, {
            friendlyId: friendlyId,
            fetchedStatus: fetchedStatus,
            deal: {
                lender: lender
            }
        })
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).dip, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$DIPView, {})
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).offer, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Offer received",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Application approved"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "Congratulations. ",
                    lender,
                    " is prepared to offer you a mortgage. \uD83C\uDF89"
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d5c56664638992a4), {
                children: "What happens next?"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Your Case Manager will now work with you until your mortgage completes and they will keep you updated throughout the process."
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).application, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Submitted Application",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "We've submitted your application."
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "All paperwork for your mortgage has been completed, packaged and sent to ",
                    lender,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "It can take a week or two for ",
                    lender,
                    " to process your application but we'll be in touch the moment we hear anything."
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Sometimes lenders ask for extra paperwork too, but you will hear from your case manager if that happens."
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).won, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Complete",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Congratulations on the new mortgage!"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "We hope its all smooth sailing, but we are always here to help if you need us."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "We'll be back in touch in 6 months before your current deal ends so we can help you find your new one."
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).lost, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Closed case",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Had a change of heart?"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "If you'd like to pick up where you left off, drop us a call, your Mortgage Expert will be more than happy to help."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$MortgageExpertAvatar, {
                            advisorEmail: fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$474db65c3c394e1c), {
                            children: "Contact your Mortgage Expert"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$7df180f992c386e3), {
                            children: (fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.opportunityOwnerTextForEmail) || "Mojo Mortgages"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d730efcde27c09), {
                            href: "tel:0333 123 0012",
                            children: "0333 123 0012"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d730efcde27c09), {
                            href: "mailto:".concat(fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress),
                            children: fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.ownerEmailAddress
                        })
                    ]
                })
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).completionSet, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Post Rec",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "A completion date has been set"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "Great news! Your completion date has been set for",
                    " ",
                    fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.setCompletionDateForEmail,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d5c56664638992a4), {
                children: "What happens next?"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "There shouldn't be much left to do, but depending on your situation there might be a couple of things to keep an eye on."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Staying with your existing lender, your lender will continue to keep you updated."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Moving to a new lender, it may be worth a quick call to your solicitors to make sure they have all they need."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "If moving to a new home, it's worth checking in with your estate agent to find out when you can collect your keys."
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).postRec, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Post Rec",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5babecc773473a0f), {
                    children: "Your mortgage application is almost ready"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "You\u2019ve chosen your next deal and one step closer to mortgage joy."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d8a8e2cd87eed68c), {
                children: "We need some documents"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "To complete your application to ",
                    lender,
                    ", we need you to upload some additional documents."
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).uploadDocs
                    });
                    history.push("/application/".concat(friendlyId, "/documents"));
                },
                text: "Upload documents"
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).wip, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Work in progress",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "We're working on things... sit tight.."
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "We're in the process of completing some work on your application, please contact us for further details or drop back in later and things should be updated"
            })
        ]
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).core, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$b0f9968eae5a4e21), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
            category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            label: "Core Status",
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d04829dc2ebccc64$export$fbeece5ce4e1b82c), {
                fetchedStatus: fetchedStatus,
                friendlyId: friendlyId
            })
        })
    })), // Waits for what says whether the profile is done, so it doesn't show as outstanding and then flip
    (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).prepareForAppointment, !upcomingAppointment || splitFfComplete === undefined ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$LoadingStateView, {}) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$b0f9968eae5a4e21), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
            category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            label: splitFfComplete ? (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).prepareForAppointmentDocsOnly : (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).prepareForAppointment,
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3e3945459b9dacde$export$5c81928116bc0fa3), {
                friendlyId: friendlyId,
                appointmentDate: new Date(upcomingAppointment.appointmentDate),
                expertName: (0, $d6513fe6413a13cd$export$9fec2874cef7b215)(upcomingAppointment.assignee),
                profileComplete: splitFfComplete,
                documentsComplete: documentsComplete,
                postcode: (0, $d6513fe6413a13cd$export$736eadacbca10d45)(application, salesforceApplication),
                handoff: (0, $b3168c9972e6d762$export$c1d2671e65196d1)(application)
            })
        })
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAcceptedBooked, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$b0f9968eae5a4e21), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
            category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            label: "Offer Accepted Booked Status",
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $71365288cfed287b$export$e4ce450c319a3f7a), {
                fetchedStatus: fetchedStatus,
                friendlyId: friendlyId,
                appointmentDate: appointmentDate
            })
        })
    })), (0, $8c6ug._)(_obj1, (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAccepted, /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$b0f9968eae5a4e21), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
            category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            label: "Offer Accepted Status",
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b2f5a410765a2426$export$166e2582d31d4ca0), {
                fetchedStatus: fetchedStatus,
                friendlyId: friendlyId
            })
        })
    })), (0, $8c6ug._)(_obj1, "default", /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$LoadingStateView, {})
    })), _obj1))(pageContent);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$42a852a2b6b56249), {
        "data-testid": "status-container",
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f2f1d4539d04d991), {
                wider: pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).booked || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAccepted || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAcceptedBooked || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).core || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).prepareForAppointment,
                children: !isLoading && content || /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$LoadingStateView, {})
            }),
            isBTLSpecialist(pageContent) || isBTLSpecialistPayment(pageContent) || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAccepted || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).offerAcceptedBooked || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).core || pageContent === (0, $bb552e4db890ef97$export$2013e195d08f4102).prepareForAppointment ? null : [
                (0, $bb552e4db890ef97$export$2013e195d08f4102).won
            ].includes(// No sidebar for offer accepted, offer accepted booked, core or prepare for appointment
            contentStage) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$543ea1a8bdefb69e), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($32b9b3f19ab38e09$exports))),
                alt: "mirror"
            }) : [
                (0, $bb552e4db890ef97$export$2013e195d08f4102).wip,
                (0, $bb552e4db890ef97$export$2013e195d08f4102).lost
            ].includes(contentStage) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$394ccf9c46e8b2f1), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($76d6114e197b693e$exports))),
                    alt: "mirror"
                })
            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Case Stage",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$42b8d7f57a240e1c), {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$bc861d1d309c6919), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$814adccc4676adf9), {
                                children: "Here\u2019s where you\u2019re at right now..."
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $a22b483e81f4f3c1$export$d347637cd596c7c2), {
                                stage: contentStage
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $2b2cb2b780ecb0b2$var$RecommendationSteps = function(param) {
    var fetchedStatus = param.fetchedStatus, deal = param.deal, friendlyId = param.friendlyId;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    if ((fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.recommendationAccepted) && !fetchedStatus.documentsRequested) // Complete: Accepted and no documents required
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$DIPView, {});
    if ((fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.recommendationAccepted) && fetchedStatus.documentsRequested) // Ready: Accepted and documents are required
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Recommendation accepted, docs required",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Great news, you've accepted our mortgage recommendation!"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d5c56664638992a4), {
                children: "What\u2019s next"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: [
                    "To submit your application to ",
                    deal.lender,
                    ", we just need you to upload some additional documents"
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                width: "auto",
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).uploadDocs
                    });
                    history.push("/application/".concat(friendlyId, "/documents"));
                },
                text: "Upload documents"
            })
        ]
    });
    if ((fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.recommendationAccepted) === false) // Recommendation has been made to the client yet
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Recommendation ready",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Your mortgage recommendation is ready"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d5c56664638992a4), {
                children: "What\u2019s next"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Your Mortgage Expert has reviewed your circumstances and preferences and has sourced their recommended deal for you to view."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRec
                    });
                    history.push("/application/".concat(friendlyId, "/recommendation"));
                },
                width: "auto",
                text: "Review recommendation"
            })
        ]
    });
    if ((fetchedStatus === null || fetchedStatus === void 0 ? void 0 : fetchedStatus.recommendationAccepted) === null) // Recommendation has not been made to the client yet
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Recommendation unsent",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Your recommendation is on its way"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "Your Mortgage Expert will be in contact with you within the next working day to provide the official recommendation and begin the application process."
            })
        ]
    });
    return(// Error state
    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Recommendation failure",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "..."
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2b2cb2b780ecb0b2$var$LoadingStateView, {})
        ]
    }));
};
var $2b2cb2b780ecb0b2$var$DIPView = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                label: "Recommendation is ready",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                    children: "Recommendation accepted"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "You\u2019ve chosen your next mortgage deal and you\u2019re now one step closer."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$d5c56664638992a4), {
                children: "What happens next?"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "As mentioned on your call, there's no need to provide any additional documents."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                children: "We have everything we need from you right now, we'll be in touch as soon as your application has been submitted"
            })
        ]
    });
};
var $2b2cb2b780ecb0b2$var$LoadingStateView = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$8f67d857ad88efa0), {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                size: 100,
                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
            })
        })
    });
};
var $2b2cb2b780ecb0b2$var$checkImageURLisValid = function(url) {
    return new Promise(function(resolve) {
        var image = document.createElement("img");
        image.src = url;
        image.onload = function() {
            return resolve(true);
        };
        image.onerror = function() {
            return resolve(false);
        };
    });
};
var $2b2cb2b780ecb0b2$var$MortgageExpertAvatar = function(param) {
    var advisorEmail = param.advisorEmail;
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState((0, (/*@__PURE__*/$parcel$interopDefault($8e324a08c1756686$exports)))), 2), adviserAvatar = _React_useState[0], setAdviserAvatar = _React_useState[1];
    (0, $hAGkE.useEffect)(function() {
        var req = "".concat((0, $10b47c5a212e87a0$export$2779e7d7b88a7290), "/").concat(advisorEmail, ".jpg");
        $2b2cb2b780ecb0b2$var$checkImageURLisValid(req).then(function(valid) {
            return valid ? setAdviserAvatar(req) : null;
        });
    }, [
        setAdviserAvatar,
        advisorEmail
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$455d94988878c142), {
        backgroundImage: adviserAvatar,
        borderRadius: adviserAvatar !== (0, (/*@__PURE__*/$parcel$interopDefault($8e324a08c1756686$exports)))
    });
};



var $hAGkE = parcelRequire("hAGkE");




parcelRequire("hAGkE");








parcelRequire("hAGkE");


function $37948b8335a89c50$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 0;\n  list-style: none;\n"
    ]);
    $37948b8335a89c50$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $37948b8335a89c50$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  margin: 0 -32px;\n\n  cursor: pointer;\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    $37948b8335a89c50$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $37948b8335a89c50$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #e9edf5;\n  margin: 0 32px;\n"
    ]);
    $37948b8335a89c50$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $37948b8335a89c50$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 50%;\n  height: 1.5em;\n  width: 1.5em;\n  border: 8px solid ",
        ";\n  margin-right: 18px;\n"
    ]);
    $37948b8335a89c50$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $37948b8335a89c50$var$List = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($37948b8335a89c50$var$_templateObject());
var $37948b8335a89c50$var$ListItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($37948b8335a89c50$var$_templateObject1(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#F5F7FB" : "white";
}, function(param) {
    var isActive = param.isActive;
    return !isActive ? "rgba(245, 247, 251, 0.5)" : "#F5F7FB";
});
var $37948b8335a89c50$var$Border = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($37948b8335a89c50$var$_templateObject2());
var $37948b8335a89c50$var$BulletPoint = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($37948b8335a89c50$var$_templateObject3(), function(param) {
    var active = param.active;
    return active ? "#073ed9" : "#c1c5d1";
});
var $37948b8335a89c50$export$6c4845e528748967 = function(param) {
    var friendlyId = param.friendlyId, selected = param.selected, setIsOpen = param.setIsOpen;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($37948b8335a89c50$var$List, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$ListItem, {
                isActive: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Status,
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).navigation,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: "Status"
                    });
                    setIsOpen(false);
                    history.push("/application/".concat(friendlyId, "/status"));
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($37948b8335a89c50$var$Border, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$BulletPoint, {
                            active: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Status
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Status"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$ListItem, {
                isActive: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Recommendation,
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).navigation,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: "Recommendation"
                    });
                    setIsOpen(false);
                    history.push("/application/".concat(friendlyId, "/recommendation"));
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($37948b8335a89c50$var$Border, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$BulletPoint, {
                            active: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Recommendation
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Recommendation"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$ListItem, {
                isActive: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).RateChecker,
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).navigation,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: "Rate Checker"
                    });
                    setIsOpen(false);
                    history.push("/application/".concat(friendlyId, "/rate-check-promise"));
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($37948b8335a89c50$var$Border, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$BulletPoint, {
                            active: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).RateChecker
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Rate Check Promise"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$ListItem, {
                isActive: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Conveyancing,
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).navigation,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: "Conveyancing"
                    });
                    setIsOpen(false);
                    history.push("/application/".concat(friendlyId, "/conveyancing"));
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($37948b8335a89c50$var$Border, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$BulletPoint, {
                            active: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Conveyancing
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Conveyancing"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$ListItem, {
                isActive: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Documents,
                onClick: function() {
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).navigation,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                        event_label: "Documents"
                    });
                    setIsOpen(false);
                    history.push("/application/".concat(friendlyId, "/documents"));
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($37948b8335a89c50$var$Border, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($37948b8335a89c50$var$BulletPoint, {
                            active: selected === (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Documents
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Documents"
                        })
                    ]
                })
            })
        ]
    });
};







function $8b5fa07cb739b107$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  max-height: ",
        ";\n  position: ",
        ";\n  width: 100vw;\n  overflow: hidden;\n  transition: max-height ease-in 250ms;\n  height: 100vh;\n  z-index: 999;\n  top: 56px;\n  display: flex;\n  @media screen and ",
        " {\n    position: static;\n    overflow: unset;\n    top: 0;\n    width: 18em;\n    max-height: unset;\n    height: unset;\n  }\n"
    ]);
    $8b5fa07cb739b107$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $8b5fa07cb739b107$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media screen and ",
        " {\n    display: block;\n    margin-bottom: 32px;\n  }\n"
    ]);
    $8b5fa07cb739b107$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $8b5fa07cb739b107$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  background: white;\n  padding: 0 32px;\n  min-height: 100vh;\n  width: 100%;\n  @media screen and ",
        " {\n    padding: 32px;\n    width: 18em;\n    margin-right: 16px;\n    height: unset;\n    flex: 1;\n  }\n"
    ]);
    $8b5fa07cb739b107$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $8b5fa07cb739b107$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  max-width: 350px;\n"
    ]);
    $8b5fa07cb739b107$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $8b5fa07cb739b107$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: 16px;\n  display: flex;\n  margin-bottom: 56px;\n\n  @media screen and ",
        " {\n    justify-content: center;\n    margin-bottom: 0;\n  }\n"
    ]);
    $8b5fa07cb739b107$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $8b5fa07cb739b107$var$SideBar = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8b5fa07cb739b107$var$_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "100vh" : "0";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "fixed" : "static";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $8b5fa07cb739b107$var$MojoIconWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8b5fa07cb739b107$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $8b5fa07cb739b107$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8b5fa07cb739b107$var$_templateObject2(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $8b5fa07cb739b107$var$ButtonMaxWidth = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8b5fa07cb739b107$var$_templateObject3());
var $8b5fa07cb739b107$var$TrustpilotWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($8b5fa07cb739b107$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $8b5fa07cb739b107$export$1ba59dacbcbf90fe = function(param) {
    var _param_friendlyId = param.friendlyId, friendlyId = _param_friendlyId === void 0 ? "" : _param_friendlyId, _param_address = param.address, address = _param_address === void 0 ? "" : _param_address, isOpen = param.isOpen, setIsOpen = param.setIsOpen, _param_selected = param.selected, selected = _param_selected === void 0 ? (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Status : _param_selected, mojoLogo = param.mojoLogo;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var logout = (0, $992ab7ffc1cec8b9$export$9a5b97a7aba1a585)({
        onSuccess: function() {
            window.location.reload();
        }
    }).logout;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b5fa07cb739b107$var$SideBar, {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8b5fa07cb739b107$var$Container, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b5fa07cb739b107$var$MojoIconWrapper, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                        src: mojoLogo,
                        alt: "mojo logo",
                        style: {
                            height: "30px"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b5fa07cb739b107$var$ButtonMaxWidth, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                        type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                        onClick: function() {
                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                event_label: "mymojo"
                            });
                            history.push("/dashboard");
                        },
                        text: "mymojo"
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                    style: {
                        marginTop: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: friendlyId
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: address
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $37948b8335a89c50$export$6c4845e528748967), {
                    friendlyId: friendlyId,
                    selected: selected,
                    setIsOpen: setIsOpen
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                    style: {
                        marginTop: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b5fa07cb739b107$var$ButtonMaxWidth, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                                onClick: function() {
                                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                        event_label: "Logout"
                                    });
                                    logout();
                                },
                                text: "Logout"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b5fa07cb739b107$var$TrustpilotWrapper, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d064dfd92ce74522$export$f63de433e1787c6d), {
                                height: "100px"
                            })
                        })
                    ]
                })
            ]
        })
    });
};





var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");




function $8c553d9068484641$export$cba093767fbd948f(friendlyId) {
    var invalidateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _useApplicationSummaries = (0, $1c92825e7588cbce$export$b17f9dfb16ad8a1d)(), applicationSummaries = _useApplicationSummaries.applicationSummaries, hasFetchedSummaries = _useApplicationSummaries.hasFetchedSummaries;
    var _useRecoilState = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$f9c5c0cfb25f2011)(friendlyId)), 2), application = _useRecoilState[0], setApplicationState = _useRecoilState[1];
    var _useRecoilState1 = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$6f28534ae09173b9)(friendlyId)), 2), hasLoaded = _useRecoilState1[0], setHasLoaded = _useRecoilState1[1];
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(invalidateCache), 2), shouldInvalidateCache = _useState[0], setShouldInvalidateCache = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), applicationNotFound = _useState1[0], setApplicationNotFound = _useState1[1];
    function refreshApplication() {
        var applicationToUpdate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, silent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var applicationUpdated;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShouldInvalidateCache(true);
                        if (applicationToUpdate) {
                            setApplication(applicationToUpdate);
                            return [
                                2
                            ];
                        }
                        if (!silent) setHasLoaded(false);
                        return [
                            4,
                            (0, $1fc51b1dc9a30698$export$7c85f84b8e8b0590)(application.applicationId, true)
                        ];
                    case 1:
                        applicationUpdated = _state.sent();
                        setApplication(applicationUpdated);
                        setHasLoaded(true);
                        return [
                            2
                        ];
                }
            });
        })();
    }
    (0, $hAGkE.useEffect)(function() {
        init(shouldInvalidateCache);
        if (hasFetchedSummaries) {
            var matchedSummary = applicationSummaries.find(function(x) {
                return x.friendlyId === friendlyId;
            });
            if (!matchedSummary) setApplicationNotFound(true);
        }
    }, [
        hasFetchedSummaries
    ]);
    function init() {
        var refreshCache = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var app, applicationData;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        app = applicationSummaries === null || applicationSummaries === void 0 ? void 0 : applicationSummaries.find(function(app) {
                            return app.friendlyId === friendlyId;
                        });
                        if (!app) return [
                            2
                        ];
                        if (application === null || application === void 0 ? void 0 : application.applicationId) return [
                            2
                        ];
                        if ($8c553d9068484641$var$fetchingApplications.includes(friendlyId)) return [
                            2
                        ];
                        $8c553d9068484641$var$LockFetch(friendlyId);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            (0, $1fc51b1dc9a30698$export$7c85f84b8e8b0590)(app.applicationId, refreshCache)
                        ];
                    case 2:
                        applicationData = _state.sent();
                        setApplication(applicationData);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        $8c553d9068484641$var$UnlockFetch(friendlyId);
                        if (shouldInvalidateCache) setShouldInvalidateCache(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function setApplication(application) {
        if (!application) return;
        setHasLoaded(true);
        setApplicationState(application);
    }
    return {
        application: application,
        hasLoaded: hasLoaded,
        applicationNotFound: applicationNotFound,
        refreshApplication: refreshApplication
    };
}
// Used to block concurrent requests to fetch the same application by
// multiple instances of the useApplicationFriendlyId hook
var $8c553d9068484641$var$fetchingApplications = [];
function $8c553d9068484641$var$LockFetch(friendlyId) {
    if ($8c553d9068484641$var$fetchingApplications.includes(friendlyId)) return;
    $8c553d9068484641$var$fetchingApplications.push(friendlyId);
}
function $8c553d9068484641$var$UnlockFetch(friendlyId) {
    var index = $8c553d9068484641$var$fetchingApplications.indexOf(friendlyId);
    if (index > -1) $8c553d9068484641$var$fetchingApplications.splice(index, 1);
}




var $iNemB = parcelRequire("iNemB");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");
var $6c6d4c58ba02802b$var$SvgShield = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("svg", (0, $7XD9P._)((0, $hRCmZ._)({
        width: 22,
        height: 28,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
                d: "M21 14.315V5l-1.901-.905a20 20 0 0 0-17.198 0L0 5v9.315A12 12 0 0 0 5.684 24.52L10.5 27.5l4.816-2.982A12 12 0 0 0 21 14.316Z",
                fill: "#FBBB5B"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("g", {
                filter: "url(#Shield_svg__a)",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
                    d: "m6 13 3 3 7-7",
                    stroke: "#fff",
                    strokeWidth: 2
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("filter", {
                    id: "Shield_svg__a",
                    x: 0.293,
                    y: 4.293,
                    width: 21.414,
                    height: 19.121,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feColorMatrix", {
                            "in": "SourceAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feGaussianBlur", {
                            stdDeviation: 2.5
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feBlend", {
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("feBlend", {
                            "in": "SourceGraphic",
                            in2: "effect1_dropShadow",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    }));
};
var $6c6d4c58ba02802b$export$2e2bcd8739ae039 = $6c6d4c58ba02802b$var$SvgShield;



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");
var $a71e7fd27cfc35fb$var$SvgDownload = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", (0, $7XD9P._)((0, $hRCmZ._)({
        width: 16,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            d: "M3.155 7.772c-.416-.522.067-1.276.715-1.114l3.428.858V1.5H8.85v6.016l3.428-.858c.647-.162 1.131.592.714 1.114L8.62 13.238a.698.698 0 0 1-1.09 0L3.155 7.772ZM0 15.5h16v2H0z",
            fill: "#000928"
        })
    }));
};
var $a71e7fd27cfc35fb$export$2e2bcd8739ae039 = $a71e7fd27cfc35fb$var$SvgDownload;



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");
var $ea7abe027ee89394$var$SvgInfo = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", (0, $7XD9P._)((0, $hRCmZ._)({
        width: 21,
        height: 21,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            d: "M10.5.5c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm.88 8.231a3.487 3.487 0 0 1-1.002.138c-.57 0-.98-.134-.99-.138v6.579h1.993V8.73ZM10.379 5.5c-.646 0-1.128.412-1.128 1.1 0 .687.482 1.1 1.128 1.1.66 0 1.14-.413 1.14-1.1 0-.688-.48-1.1-1.14-1.1Z",
            fill: "#000928"
        })
    }));
};
var $ea7abe027ee89394$export$2e2bcd8739ae039 = $ea7abe027ee89394$var$SvgInfo;



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");
var $68e386558564a06c$var$SvgFile = function(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", (0, $7XD9P._)((0, $hRCmZ._)({
        width: 19,
        height: 23,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            d: "M10.542 1.083H3.25a2.083 2.083 0 0 0-2.083 2.084v16.666a2.084 2.084 0 0 0 2.083 2.084h12.5a2.083 2.083 0 0 0 2.083-2.084V8.375m-7.291-7.292 7.291 7.292m-7.291-7.292v7.292h7.291",
            stroke: "#1E1E1E",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
var $68e386558564a06c$export$2e2bcd8739ae039 = $68e386558564a06c$var$SvgFile;



var $6mdMa = parcelRequire("6mdMa");




var $hAGkE = parcelRequire("hAGkE");



function $d729aeb9aca595bc$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: none;\n  border: none;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: 0.2s;\n  padding: 15px 0;\n  cursor: pointer;\n\n  .arrow-icon {\n    margin-left: 10px;\n    transform: ",
        ";\n    ::after {\n      content: url(",
        ");\n    }\n  }\n"
    ]);
    $d729aeb9aca595bc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d729aeb9aca595bc$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n\n  p {\n    font-size: 18px;\n    font-weight: 550;\n    margin: 0;\n    text-align: start;\n  }\n"
    ]);
    $d729aeb9aca595bc$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d729aeb9aca595bc$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  margin-right: 10px;\n  &.Poor {\n    color: red;\n  }\n  &.Fair {\n    color: orange;\n  }\n  &.Good {\n    color: blue;\n  }\n  &.Great {\n    color: blue;\n  }\n  &.Unknown {\n    color: gray;\n  }\n"
    ]);
    $d729aeb9aca595bc$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $d729aeb9aca595bc$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  max-height: ",
        ";\n  overflow: hidden;\n  transition: 0.8s;\n  border-bottom: 1px solid ",
        ";\n  :last-child {\n    border-bottom: none;\n  }\n"
    ]);
    $d729aeb9aca595bc$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $d729aeb9aca595bc$var$AccordionButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($d729aeb9aca595bc$var$_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "rotate(180deg)" : "rotate(0deg)";
}, (0, (/*@__PURE__*/$parcel$interopDefault($7feb06a480b4e75d$exports))));
var $d729aeb9aca595bc$var$ButtonName = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d729aeb9aca595bc$var$_templateObject1());
var $d729aeb9aca595bc$var$Status = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d729aeb9aca595bc$var$_templateObject2());
var $d729aeb9aca595bc$export$7cad6f17fd6e117b = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d729aeb9aca595bc$var$_templateObject3(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "fit-content" : "0";
}, function(param) {
    var theme = param.theme;
    return theme.colors.neutral[300];
});
var $d729aeb9aca595bc$export$a766cd26d0d69044 = function(param) {
    var data = param.data;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)([]), 2), openState = _useState[0], setOpenState = _useState[1];
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: data.map(function(param, idx) {
            var name = param.name, status = param.status, id = param.id, page = param.page, statusComponent = param.statusComponent, trackingLabelPrefix = param.trackingLabelPrefix, _param_titleState = param.titleState, titleState = _param_titleState === void 0 ? "" : _param_titleState;
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d729aeb9aca595bc$var$AccordionButton, {
                        className: id + "-button",
                        onClick: function() {
                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                action: openState[idx] ? (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).closeAccordion : (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).openAccordion,
                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                event_label: "".concat(trackingLabelPrefix ? trackingLabelPrefix + " - " : "").concat(name)
                            });
                            setOpenState(data.map(function(_, i) {
                                return idx === i && !openState[i];
                            }));
                        },
                        isOpen: openState[idx],
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d729aeb9aca595bc$var$ButtonName, {
                                children: [
                                    status && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                        className: "icon " + status
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                        className: "name",
                                        children: name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d729aeb9aca595bc$var$Status, {
                                children: [
                                    statusComponent,
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                        className: "arrow-icon"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d729aeb9aca595bc$export$7cad6f17fd6e117b, {
                        isOpen: openState[idx],
                        children: page
                    })
                ]
            }, id + "-tab");
        })
    });
};




parcelRequire("hAGkE");




parcelRequire("hAGkE");

function $84d560838d81249a$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  color: white;\n  font-size: 12px;\n  line-height: 18px;\n  border-radius: 8px;\n  padding: 1.333em;\n  display: flex;\n  flex: 1;\n"
    ]);
    $84d560838d81249a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $84d560838d81249a$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 15em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    $84d560838d81249a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $84d560838d81249a$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-end;\n  & > img {\n    height: 0.833em;\n  }\n"
    ]);
    $84d560838d81249a$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $84d560838d81249a$var$Item = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($84d560838d81249a$var$_templateObject(), function(props) {
    return props.theme.primaryThree;
});
var $84d560838d81249a$var$Name = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($84d560838d81249a$var$_templateObject1());
var $84d560838d81249a$var$IconContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($84d560838d81249a$var$_templateObject2());
var $84d560838d81249a$export$2e3d85dbc7dbc91f = function(param) {
    var name = param.name, onClickDelete = param.onClickDelete;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($84d560838d81249a$var$Item, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($84d560838d81249a$var$Name, {
                title: name,
                children: name
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($84d560838d81249a$var$IconContainer, {})
        ]
    });
};




function $0a92664b9837f58c$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  border-radius: 12px;\n  height: ",
        ";\n  padding: 1em;\n"
    ]);
    $0a92664b9837f58c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0a92664b9837f58c$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed #f3b88b;\n  border-radius: 12px;\n"
    ]);
    $0a92664b9837f58c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0a92664b9837f58c$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 0 1.5em;\n  width: 100%;\n  margin-bottom: 0.5em;\n  &:first-child {\n    margin-top: 1.5em;\n  }\n"
    ]);
    $0a92664b9837f58c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $0a92664b9837f58c$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 7.5em;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: ",
        ";\n  margin-bottom: ",
        ";\n  // override the button styles\n  & > div {\n    height: unset;\n    padding: 0;\n    & > div {\n      padding: 0;\n      height: unset;\n      border-radius: 8px;\n      font-size: 14px;\n    }\n  }\n"
    ]);
    $0a92664b9837f58c$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $0a92664b9837f58c$var$Root = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0a92664b9837f58c$var$_templateObject(), function(props) {
    return props.theme.secondaryOne;
}, function(props) {
    return props.overHeightThreshold ? "unset" : "18.75em;";
});
var $0a92664b9837f58c$var$UploadBoxInnerBorder = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0a92664b9837f58c$var$_templateObject1());
var $0a92664b9837f58c$var$UploadedItemContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0a92664b9837f58c$var$_templateObject2());
var $0a92664b9837f58c$var$ButtonContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0a92664b9837f58c$var$_templateObject3(), function(props) {
    return props.hasUploadedItems ? 1 : "unset";
}, function(props) {
    return props.hasUploadedItems ? "1.5em" : 0;
});
var $0a92664b9837f58c$export$2633c22b7a1b7cb = function(param) {
    var buttonText = param.buttonText, applicantNumber = param.applicantNumber, docType = param.docType, onClick = param.onClick, _param_uploadedItems = param.uploadedItems, uploadedItems = _param_uploadedItems === void 0 ? [] : _param_uploadedItems;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0a92664b9837f58c$var$Root, {
        overHeightThreshold: uploadedItems.length >= 3,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0a92664b9837f58c$var$UploadBoxInnerBorder, {
            hasUploadedItems: !!uploadedItems.length,
            children: [
                uploadedItems.map(function(param, idx) {
                    var originalFilename = param.originalFilename;
                    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0a92664b9837f58c$var$UploadedItemContainer, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $84d560838d81249a$export$2e3d85dbc7dbc91f), {
                            name: originalFilename,
                            onClickDelete: function() {}
                        })
                    }, idx);
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0a92664b9837f58c$var$ButtonContainer, {
                    hasUploadedItems: !!uploadedItems.length,
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                        type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                        onClick: function() {
                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                event_label: "Choose files - ".concat(docType, " - applicant").concat(applicantNumber)
                            });
                            onClick();
                        },
                        text: buttonText
                    })
                })
            ]
        })
    });
};




parcelRequire("hAGkE");


function $01eea66b91c29115$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 40px auto;\n  height: 100%;\n"
    ]);
    $01eea66b91c29115$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $01eea66b91c29115$var$ListItemContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($01eea66b91c29115$var$_templateObject());
function $01eea66b91c29115$export$a2d033d90173e318(param) {
    var _param_showTick = param.showTick, showTick = _param_showTick === void 0 ? true : _param_showTick, children = param.children;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($01eea66b91c29115$var$ListItemContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f32ecb0aa12839a5$export$32f2095185c4c126), {
                enabled: true,
                type: showTick ? "tick" : "circle"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                children: children
            })
        ]
    });
}




var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

parcelRequire("hAGkE");

var $2xTNA = parcelRequire("2xTNA");

var $hAGkE = parcelRequire("hAGkE");

var $fqT2i = parcelRequire("fqT2i");
function $6d5dea3f33a28c0f$var$_extends() {
    $6d5dea3f33a28c0f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d5dea3f33a28c0f$var$_extends.apply(this, arguments);
}
function $6d5dea3f33a28c0f$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d5dea3f33a28c0f$var$b = "function" === typeof Symbol && Symbol["for"], $6d5dea3f33a28c0f$var$c = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.element") : 60103, $6d5dea3f33a28c0f$var$d = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.portal") : 60106, $6d5dea3f33a28c0f$var$e = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.fragment") : 60107, $6d5dea3f33a28c0f$var$f = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.strict_mode") : 60108, $6d5dea3f33a28c0f$var$g = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.profiler") : 60114, $6d5dea3f33a28c0f$var$h = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.provider") : 60109, $6d5dea3f33a28c0f$var$k = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.context") : 60110, $6d5dea3f33a28c0f$var$l = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.async_mode") : 60111, $6d5dea3f33a28c0f$var$m = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.concurrent_mode") : 60111, $6d5dea3f33a28c0f$var$n = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.forward_ref") : 60112, $6d5dea3f33a28c0f$var$p = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.suspense") : 60113, $6d5dea3f33a28c0f$var$q = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.suspense_list") : 60120, $6d5dea3f33a28c0f$var$r = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.memo") : 60115, $6d5dea3f33a28c0f$var$t = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.lazy") : 60116, $6d5dea3f33a28c0f$var$v = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.block") : 60121, $6d5dea3f33a28c0f$var$w = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.fundamental") : 60117, $6d5dea3f33a28c0f$var$x = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.responder") : 60118, $6d5dea3f33a28c0f$var$y = $6d5dea3f33a28c0f$var$b ? Symbol["for"]("react.scope") : 60119;
function $6d5dea3f33a28c0f$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6d5dea3f33a28c0f$var$c:
                switch(a = a.type, a){
                    case $6d5dea3f33a28c0f$var$l:
                    case $6d5dea3f33a28c0f$var$m:
                    case $6d5dea3f33a28c0f$var$e:
                    case $6d5dea3f33a28c0f$var$g:
                    case $6d5dea3f33a28c0f$var$f:
                    case $6d5dea3f33a28c0f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6d5dea3f33a28c0f$var$k:
                            case $6d5dea3f33a28c0f$var$n:
                            case $6d5dea3f33a28c0f$var$t:
                            case $6d5dea3f33a28c0f$var$r:
                            case $6d5dea3f33a28c0f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6d5dea3f33a28c0f$var$d:
                return u;
        }
    }
}
function $6d5dea3f33a28c0f$var$A(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$m;
}
var $6d5dea3f33a28c0f$var$AsyncMode = $6d5dea3f33a28c0f$var$l;
var $6d5dea3f33a28c0f$var$ConcurrentMode = $6d5dea3f33a28c0f$var$m;
var $6d5dea3f33a28c0f$var$ContextConsumer = $6d5dea3f33a28c0f$var$k;
var $6d5dea3f33a28c0f$var$ContextProvider = $6d5dea3f33a28c0f$var$h;
var $6d5dea3f33a28c0f$var$Element = $6d5dea3f33a28c0f$var$c;
var $6d5dea3f33a28c0f$var$ForwardRef = $6d5dea3f33a28c0f$var$n;
var $6d5dea3f33a28c0f$var$Fragment = $6d5dea3f33a28c0f$var$e;
var $6d5dea3f33a28c0f$var$Lazy = $6d5dea3f33a28c0f$var$t;
var $6d5dea3f33a28c0f$var$Memo = $6d5dea3f33a28c0f$var$r;
var $6d5dea3f33a28c0f$var$Portal = $6d5dea3f33a28c0f$var$d;
var $6d5dea3f33a28c0f$var$Profiler = $6d5dea3f33a28c0f$var$g;
var $6d5dea3f33a28c0f$var$StrictMode = $6d5dea3f33a28c0f$var$f;
var $6d5dea3f33a28c0f$var$Suspense = $6d5dea3f33a28c0f$var$p;
var $6d5dea3f33a28c0f$var$isAsyncMode = function isAsyncMode(a) {
    return $6d5dea3f33a28c0f$var$A(a) || $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$l;
};
var $6d5dea3f33a28c0f$var$isConcurrentMode = $6d5dea3f33a28c0f$var$A;
var $6d5dea3f33a28c0f$var$isContextConsumer = function isContextConsumer(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$k;
};
var $6d5dea3f33a28c0f$var$isContextProvider = function isContextProvider(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$h;
};
var $6d5dea3f33a28c0f$var$isElement = function isElement(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && a.$$typeof === $6d5dea3f33a28c0f$var$c;
};
var $6d5dea3f33a28c0f$var$isForwardRef = function isForwardRef(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$n;
};
var $6d5dea3f33a28c0f$var$isFragment = function isFragment(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$e;
};
var $6d5dea3f33a28c0f$var$isLazy = function isLazy(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$t;
};
var $6d5dea3f33a28c0f$var$isMemo = function isMemo(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$r;
};
var $6d5dea3f33a28c0f$var$isPortal = function isPortal(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$d;
};
var $6d5dea3f33a28c0f$var$isProfiler = function isProfiler(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$g;
};
var $6d5dea3f33a28c0f$var$isStrictMode = function isStrictMode(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$f;
};
var $6d5dea3f33a28c0f$var$isSuspense = function isSuspense(a) {
    return $6d5dea3f33a28c0f$var$z(a) === $6d5dea3f33a28c0f$var$p;
};
var $6d5dea3f33a28c0f$var$isValidElementType = function isValidElementType(a) {
    return "string" === typeof a || "function" === typeof a || a === $6d5dea3f33a28c0f$var$e || a === $6d5dea3f33a28c0f$var$m || a === $6d5dea3f33a28c0f$var$g || a === $6d5dea3f33a28c0f$var$f || a === $6d5dea3f33a28c0f$var$p || a === $6d5dea3f33a28c0f$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) && null !== a && (a.$$typeof === $6d5dea3f33a28c0f$var$t || a.$$typeof === $6d5dea3f33a28c0f$var$r || a.$$typeof === $6d5dea3f33a28c0f$var$h || a.$$typeof === $6d5dea3f33a28c0f$var$k || a.$$typeof === $6d5dea3f33a28c0f$var$n || a.$$typeof === $6d5dea3f33a28c0f$var$w || a.$$typeof === $6d5dea3f33a28c0f$var$x || a.$$typeof === $6d5dea3f33a28c0f$var$y || a.$$typeof === $6d5dea3f33a28c0f$var$v);
};
var $6d5dea3f33a28c0f$var$typeOf = $6d5dea3f33a28c0f$var$z;
var $6d5dea3f33a28c0f$var$reactIs_production_min = {
    AsyncMode: $6d5dea3f33a28c0f$var$AsyncMode,
    ConcurrentMode: $6d5dea3f33a28c0f$var$ConcurrentMode,
    ContextConsumer: $6d5dea3f33a28c0f$var$ContextConsumer,
    ContextProvider: $6d5dea3f33a28c0f$var$ContextProvider,
    Element: $6d5dea3f33a28c0f$var$Element,
    ForwardRef: $6d5dea3f33a28c0f$var$ForwardRef,
    Fragment: $6d5dea3f33a28c0f$var$Fragment,
    Lazy: $6d5dea3f33a28c0f$var$Lazy,
    Memo: $6d5dea3f33a28c0f$var$Memo,
    Portal: $6d5dea3f33a28c0f$var$Portal,
    Profiler: $6d5dea3f33a28c0f$var$Profiler,
    StrictMode: $6d5dea3f33a28c0f$var$StrictMode,
    Suspense: $6d5dea3f33a28c0f$var$Suspense,
    isAsyncMode: $6d5dea3f33a28c0f$var$isAsyncMode,
    isConcurrentMode: $6d5dea3f33a28c0f$var$isConcurrentMode,
    isContextConsumer: $6d5dea3f33a28c0f$var$isContextConsumer,
    isContextProvider: $6d5dea3f33a28c0f$var$isContextProvider,
    isElement: $6d5dea3f33a28c0f$var$isElement,
    isForwardRef: $6d5dea3f33a28c0f$var$isForwardRef,
    isFragment: $6d5dea3f33a28c0f$var$isFragment,
    isLazy: $6d5dea3f33a28c0f$var$isLazy,
    isMemo: $6d5dea3f33a28c0f$var$isMemo,
    isPortal: $6d5dea3f33a28c0f$var$isPortal,
    isProfiler: $6d5dea3f33a28c0f$var$isProfiler,
    isStrictMode: $6d5dea3f33a28c0f$var$isStrictMode,
    isSuspense: $6d5dea3f33a28c0f$var$isSuspense,
    isValidElementType: $6d5dea3f33a28c0f$var$isValidElementType,
    typeOf: $6d5dea3f33a28c0f$var$typeOf
};
var $6d5dea3f33a28c0f$var$reactIs_development = $6d5dea3f33a28c0f$var$createCommonjsModule(function(module, exports) {});
var $6d5dea3f33a28c0f$var$reactIs = $6d5dea3f33a28c0f$var$createCommonjsModule(function(module) {
    module.exports = $6d5dea3f33a28c0f$var$reactIs_production_min;
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var $6d5dea3f33a28c0f$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6d5dea3f33a28c0f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6d5dea3f33a28c0f$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $6d5dea3f33a28c0f$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $6d5dea3f33a28c0f$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var $6d5dea3f33a28c0f$var$objectAssign = $6d5dea3f33a28c0f$var$shouldUseNative() ? Object.assign : function objectAssign(target, source) {
    var from;
    var to = $6d5dea3f33a28c0f$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($6d5dea3f33a28c0f$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($6d5dea3f33a28c0f$var$getOwnPropertySymbols) {
            symbols = $6d5dea3f33a28c0f$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($6d5dea3f33a28c0f$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d5dea3f33a28c0f$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1 = $6d5dea3f33a28c0f$var$ReactPropTypesSecret;
var $6d5dea3f33a28c0f$var$has = Function.call.bind(Object.prototype.hasOwnProperty);
var $6d5dea3f33a28c0f$var$printWarning = function printWarning() {};
var $6d5dea3f33a28c0f$var$ReactPropTypesSecret$1, $6d5dea3f33a28c0f$var$loggedTypeFailures, $6d5dea3f33a28c0f$var$has$1;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $6d5dea3f33a28c0f$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, err, ex, stack;
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $6d5dea3f33a28c0f$var$checkPropTypes.resetWarningCache = function() {};
var $6d5dea3f33a28c0f$var$checkPropTypes_1 = $6d5dea3f33a28c0f$var$checkPropTypes;
var $6d5dea3f33a28c0f$var$printWarning$1 = function printWarning$1() {};
function $6d5dea3f33a28c0f$var$emptyFunctionThatReturnsNull() {
    return null;
}
var $6d5dea3f33a28c0f$var$factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && (typeof data === "undefined" ? "undefined" : (0, $2xTNA._)(data)) === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($6d5dea3f33a28c0f$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$6d5dea3f33a28c0f$var$reactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return $6d5dea3f33a28c0f$var$emptyFunctionThatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($6d5dea3f33a28c0f$var$has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return $6d5dea3f33a28c0f$var$emptyFunctionThatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $6d5dea3f33a28c0f$var$printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $6d5dea3f33a28c0f$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1);
                if (checkerResult == null) return null;
                if (checkerResult.data && $6d5dea3f33a28c0f$var$has(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $6d5dea3f33a28c0f$var$objectAssign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($6d5dea3f33a28c0f$var$has(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue === "undefined" ? "undefined" : (0, $2xTNA._)(propValue)){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue === "undefined" ? "undefined" : (0, $2xTNA._)(propValue);
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $6d5dea3f33a28c0f$var$checkPropTypes_1;
    ReactPropTypes.resetWarningCache = $6d5dea3f33a28c0f$var$checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
function $6d5dea3f33a28c0f$var$emptyFunction() {}
function $6d5dea3f33a28c0f$var$emptyFunctionWithReset() {}
$6d5dea3f33a28c0f$var$emptyFunctionWithReset.resetWarningCache = $6d5dea3f33a28c0f$var$emptyFunction;
var $6d5dea3f33a28c0f$var$factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $6d5dea3f33a28c0f$var$ReactPropTypesSecret_1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6d5dea3f33a28c0f$var$emptyFunctionWithReset,
        resetWarningCache: $6d5dea3f33a28c0f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $6d5dea3f33a28c0f$var$propTypes = $6d5dea3f33a28c0f$var$createCommonjsModule(function(module) {
    var ReactIs, throwOnDirectAccess;
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = $6d5dea3f33a28c0f$var$factoryWithThrowingShims();
});
var $6d5dea3f33a28c0f$var$pickerPropTypes = {
    apikey: $6d5dea3f33a28c0f$var$propTypes.string,
    pickerOptions: $6d5dea3f33a28c0f$var$propTypes.object,
    clientOptions: $6d5dea3f33a28c0f$var$propTypes.object,
    onSuccess: $6d5dea3f33a28c0f$var$propTypes.func,
    onUploadDone: $6d5dea3f33a28c0f$var$propTypes.func,
    onError: $6d5dea3f33a28c0f$var$propTypes.func
};
var $6d5dea3f33a28c0f$var$_generateRandomId = function _generateRandomId() {
    return 'x' + Math.random().toString(36).substr(2, 5);
};
var $6d5dea3f33a28c0f$var$usePicker = function usePicker(_ref) {
    var apikey = _ref.apikey, _ref$pickerOptions = _ref.pickerOptions, pickerOptions = _ref$pickerOptions === void 0 ? {} : _ref$pickerOptions, _ref$clientOptions = _ref.clientOptions, clientOptions = _ref$clientOptions === void 0 ? {} : _ref$clientOptions, _ref$onSuccess = _ref.onSuccess, onSuccess = _ref$onSuccess === void 0 ? console.log : _ref$onSuccess, _ref$onUploadDone = _ref.onUploadDone, onUploadDone = _ref$onUploadDone === void 0 ? console.log : _ref$onUploadDone, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? console.error : _ref$onError;
    var _onError = function _onError(error) {
        onError(error);
    };
    var _onUploadDone = function _onUploadDone(result) {
        onSuccess(result);
        onUploadDone(result);
    };
    var rootId = $6d5dea3f33a28c0f$var$_generateRandomId();
    var containerId = $6d5dea3f33a28c0f$var$_generateRandomId();
    (0, $hAGkE.useEffect)(function() {
        var picker = (0, $fqT2i.Filestack)(apikey, clientOptions).picker($6d5dea3f33a28c0f$var$_extends({
            rootId: rootId,
            container: "#" + containerId,
            onUploadDone: _onUploadDone
        }, pickerOptions));
        picker.open().then()["catch"](_onError);
        return function() {
            if (picker) picker.close();
        };
    }, [
        rootId,
        containerId,
        apikey,
        clientOptions,
        pickerOptions,
        _onUploadDone
    ]);
    return {
        containerId: containerId
    };
};
var $6d5dea3f33a28c0f$export$1511f21c36b4be23 = function PickerOverlay(_ref) {
    var apikey = _ref.apikey, pickerOptions = _ref.pickerOptions, clientOptions = _ref.clientOptions, onSuccess = _ref.onSuccess, onUploadDone = _ref.onUploadDone, onError = _ref.onError, children = _ref.children;
    var _usePicker = $6d5dea3f33a28c0f$var$usePicker({
        apikey: apikey,
        pickerOptions: $6d5dea3f33a28c0f$var$_extends({
            displayMode: (0, $fqT2i.PickerDisplayMode).overlay
        }, pickerOptions),
        clientOptions: clientOptions,
        onSuccess: onSuccess,
        onUploadDone: onUploadDone,
        onError: onError
    }), containerId = _usePicker.containerId;
    var render = function render() {
        if (children) return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).cloneElement(children, {
            id: containerId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("div", {
            id: containerId
        });
    };
    return render();
};
$6d5dea3f33a28c0f$export$1511f21c36b4be23.propTypes = $6d5dea3f33a28c0f$var$pickerPropTypes;
var $6d5dea3f33a28c0f$export$a72e45c44c8d6905 = function PickerInline(_ref) {
    var apikey = _ref.apikey, pickerOptions = _ref.pickerOptions, clientOptions = _ref.clientOptions, onSuccess = _ref.onSuccess, onUploadDone = _ref.onUploadDone, onError = _ref.onError, children = _ref.children;
    var _usePicker = $6d5dea3f33a28c0f$var$usePicker({
        apikey: apikey,
        pickerOptions: $6d5dea3f33a28c0f$var$_extends({
            displayMode: (0, $fqT2i.PickerDisplayMode).inline
        }, pickerOptions),
        clientOptions: clientOptions,
        onSuccess: onSuccess,
        onUploadDone: onUploadDone,
        onError: onError
    }), containerId = _usePicker.containerId;
    var render = function render() {
        if (children) return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).cloneElement(children, {
            id: containerId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("div", {
            "data-testid": "picker-inline",
            style: {
                height: '500px'
            },
            id: containerId
        });
    };
    return render();
};
$6d5dea3f33a28c0f$export$a72e45c44c8d6905.propTypes = $6d5dea3f33a28c0f$var$pickerPropTypes;
var $6d5dea3f33a28c0f$export$84309f966bbed0e7 = function PickerDropPane(_ref) {
    var apikey = _ref.apikey, pickerOptions = _ref.pickerOptions, clientOptions = _ref.clientOptions, onSuccess = _ref.onSuccess, onUploadDone = _ref.onUploadDone, onError = _ref.onError, children = _ref.children;
    var _usePicker = $6d5dea3f33a28c0f$var$usePicker({
        apikey: apikey,
        pickerOptions: $6d5dea3f33a28c0f$var$_extends({
            displayMode: (0, $fqT2i.PickerDisplayMode).dropPane
        }, pickerOptions),
        clientOptions: clientOptions,
        onSuccess: onSuccess,
        onUploadDone: onUploadDone,
        onError: onError
    }), containerId = _usePicker.containerId;
    var render = function render() {
        if (children) return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).cloneElement(children, {
            id: containerId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("div", {
            id: containerId
        });
    };
    return render();
};
$6d5dea3f33a28c0f$export$84309f966bbed0e7.propTypes = $6d5dea3f33a28c0f$var$pickerPropTypes;



function $bd0371ce0c24b8ad$export$cc82a6d2ed7645ba(param) {
    var close = param.close, _param_container = param.container, container = _param_container === void 0 ? "mojo-customer-docs-filestack-upload-test" : _param_container, filename = param.filename, uploadedFilePath = param.uploadedFilePath, onSuccessFunction = param.onSuccessFunction, customOptions = param.customOptions;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6d5dea3f33a28c0f$export$1511f21c36b4be23), {
        apikey: (0, $10b47c5a212e87a0$export$7aca6a4ab3bc1322),
        clientOptions: {
            security: {
                policy: (0, $10b47c5a212e87a0$export$2116b5277b180cfe),
                signature: (0, $10b47c5a212e87a0$export$b16da5735cf077a8)
            }
        },
        pickerOptions: (0, $hRCmZ._)({
            onFileSelected: function(file) {
                if (filename) {
                    var fileExtension = file.originalPath.split(".").pop();
                    return (0, $7XD9P._)((0, $hRCmZ._)({}, file), {
                        name: "".concat(filename, ".").concat(fileExtension)
                    });
                } else return file;
            },
            accept: [
                "application/pdf",
                "image/*"
            ],
            exposeOriginalFile: true,
            fromSources: [
                "local_file_system"
            ],
            maxFiles: 10,
            storeTo: {
                location: "s3",
                container: container,
                region: (0, $10b47c5a212e87a0$export$dff5e35862191ad4),
                path: uploadedFilePath
            },
            onClose: function() {
                close();
            }
        }, customOptions),
        onSuccess: function(result) {
            var filesUploaded = result.filesUploaded;
            if (onSuccessFunction) onSuccessFunction(filesUploaded);
        }
    });
}



/**
 * Sniffs the first 12 bytes of a File to infer its extension from magic bytes.
 *
 * Returns the detected extension (without dot), or null if the format is
 * unrecognised. Only binary formats with reliable magic bytes are covered —
 * PDF, JPEG, PNG, HEIC, HEIF. Text-based formats (HTML, CSV, etc.) have no
 * magic bytes and cannot be reliably detected this way.
 */ 
var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");
function $f6aa406a7c6ae811$export$42a33cfe1d0655e9(file) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var buffer, bytes, brand;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        file.slice(0, 12).arrayBuffer()
                    ];
                case 1:
                    buffer = _state.sent();
                    bytes = new Uint8Array(buffer);
                    // PDF: %PDF (25 50 44 46)
                    if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) return [
                        2,
                        "pdf"
                    ];
                    // PNG (89 50 4E 47 0D 0A 1A 0A)
                    if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) return [
                        2,
                        "png"
                    ];
                    // JPEG: starts FF D8
                    if (bytes[0] === 0xff && bytes[1] === 0xd8) return [
                        2,
                        "jpg"
                    ];
                    // HEIC / HEIF: ISO Base Media File Format — 'ftyp' box sits at byte offset 4,
                    // followed by a 4-byte brand that identifies the codec variant.
                    if (bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 && bytes[7] === 0x70) {
                        brand = String.fromCharCode(bytes[8], bytes[9], bytes[10], bytes[11]).toLowerCase();
                        if ([
                            "heic",
                            "heix",
                            "hevc",
                            "hevx"
                        ].includes(brand)) return [
                            2,
                            "heic"
                        ];
                        if ([
                            "mif1",
                            "msf1"
                        ].includes(brand)) return [
                            2,
                            "heif"
                        ];
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    })();
}





parcelRequire("hAGkE");

var $3a718fcc49c474a5$exports = {};
$3a718fcc49c474a5$exports = $parcel$resolve("2OB9U");



function $26127b8c5619a3f4$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 550;\n  font-size: 14px;\n  background: ",
        ";\n  color: ",
        ";\n  padding: 0.5em;\n  border-radius: 4px;\n  @media screen and ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    $26127b8c5619a3f4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $26127b8c5619a3f4$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-left: 0.2em;\n  ::after {\n    content: url(",
        ");\n  }\n"
    ]);
    $26127b8c5619a3f4$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $26127b8c5619a3f4$var$Root = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($26127b8c5619a3f4$var$_templateObject(), function(props) {
    return props.hasAddedDocs ? "rgba(0, 69, 255, 0.05)" : props.theme.colors.yellow[400];
}, function(props) {
    return props.hasAddedDocs ? props.theme.primary : "#000";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xs);
var $26127b8c5619a3f4$var$Tick = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($26127b8c5619a3f4$var$_templateObject1(), (0, (/*@__PURE__*/$parcel$interopDefault($3a718fcc49c474a5$exports))));
var $26127b8c5619a3f4$export$994e57f9ba01697f = function(param) {
    var documents = param.documents;
    var hasAddedDocs = documents.length > 0;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($26127b8c5619a3f4$var$Root, {
        hasAddedDocs: hasAddedDocs,
        children: hasAddedDocs ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: [
                documents.length,
                " added ",
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($26127b8c5619a3f4$var$Tick, {})
            ]
        }) : "None added"
    });
};







parcelRequire("hAGkE");

function $0f47e0ab4ea5f939$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  --bold: 550;\n  line-height: 1.5em;\n  h4 {\n    font-size: 18px;\n    margin: 0 0 1.5em;\n    font-weight: var(--bold);\n  }\n  p {\n    margin: 0 0 1.5em;\n    a {\n      font-weight: var(--bold);\n      color: ",
        ";\n    }\n  }\n  strong {\n    font-weight: var(--bold);\n  }\n"
    ]);
    $0f47e0ab4ea5f939$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $0f47e0ab4ea5f939$var$FaqSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0f47e0ab4ea5f939$var$_templateObject(), function(props) {
    return props.theme.primaryOne;
});
var $0f47e0ab4ea5f939$export$85c980ec82aeb21b = [
    {
        name: "How do I upload documents?",
        id: "faq-1",
        trackingLabelPrefix: "Doc Upload-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0f47e0ab4ea5f939$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "You will find the option to upload documents in your mymojo account. Just",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                            href: "https://mymojo.mojomortgages.com/login",
                            rel: "nofollow noopener noreferrer",
                            target: "_blank",
                            children: "login"
                        }),
                        " ",
                        "to your account and check for the Documents option in the navigation."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "And of course, your can be certain that your documents will be",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "securely stored"
                        }),
                        "."
                    ]
                })
            ]
        })
    },
    {
        name: "What documents do I need for a mortgage recommendation?",
        id: "faq-2",
        trackingLabelPrefix: "Doc Upload-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0f47e0ab4ea5f939$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "We\u2019d like to see ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "proof of ID"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "proof of income"
                        }),
                        " and",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "bank statements"
                        }),
                        " for all applicants so your expert can validate these against both the information you have already provided and the mortgage lender\u2019s borrowing criteria. It means you\u2019re more likely to get a",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "recommendation that\u2019s right first time"
                        }),
                        " as it\u2019s the best possible fit to your exact circumstances."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "Where we can, ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "we\u2019ll use these documents for your application too"
                        }),
                        ", saving you time and effort down the line."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "Note:"
                        }),
                        " You'll find full details of what we need and what\u2019s acceptable on the Document upload page in your mymojo account."
                    ]
                })
            ]
        })
    },
    {
        name: "What documents do I need to apply for a mortgage?",
        id: "faq-3",
        trackingLabelPrefix: "Doc Upload-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0f47e0ab4ea5f939$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "We need to ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "satisfy the requirements"
                        }),
                        " of the mortgage provider your application is going with, as well as meeting our own regulatory requirements with the FCA, so ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "we absolutely must collect documents"
                        }),
                        "from you for all applicants when you apply for a mortgage. Basically, you will not be able to proceed with a mortgage application without providing documents."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "It\u2019s generally a ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "form of ID, proof of income"
                        }),
                        " and",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "bank statements as a minimum so we can verify your identity and income/outgoings"
                        }),
                        ". We may need the original copies if the lender asks for them but don\u2019t worry, if electronic copies are acceptable, you\u2019ll be able to add them on here."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "Note:"
                        }),
                        " Your ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "application may be cancelled"
                        }),
                        " if you do not provide these and any delays in providing these may result in you",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "losing access to the product"
                        }),
                        " originally recommended by your expert (so we\u2019ll have to go through your recommendation again)."
                    ]
                })
            ]
        })
    },
    {
        name: "What documents are acceptable?",
        id: "faq-4",
        trackingLabelPrefix: "Doc Upload-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0f47e0ab4ea5f939$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Form of ID"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "A ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "Passport"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "Driving Licence"
                        }),
                        " which meet the following criteria:"
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("li", {
                            children: [
                                "Must be a current, ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "valid"
                                }),
                                " document"
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("li", {
                            children: [
                                "Must show your ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "name"
                                }),
                                " and ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "date of birth"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("li", {
                            children: [
                                "A ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "clear, high quality colour scan or photo*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "All four corners visible"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "* In some circumstances we may need a physical copy, but a clear, high quality photo or scan will usually do."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Proof of income"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("li", {
                            children: [
                                "Provide the ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "last 3 months\u2019 payslips"
                                }),
                                " showing your name, current address and income ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "OR"
                                }),
                                " If self-employed, provide instead",
                                " ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "2 years\u2019 SA302s"
                                }),
                                " and either the",
                                " ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "corresponding self-employed tax year overviews"
                                }),
                                "or ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "company accounts"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "PDF document preferred"
                                }),
                                " from your employer or HMRC , or a",
                                " ",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "clear photo/scan of a paper copy"
                                }),
                                " with all four corners visible*"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "*If you\u2019re getting an initial recommendation from us, a clear, high quality photo or scan will do for now"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Other documents"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "Once we start putting together your mortgage application, we may need more from you. Additional documents could include:"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Proof of deposit for your purchase"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Evidence of other sources of income or supplements to your basic income like bonuses or regular overtime"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Proof of right to reside in the UK"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Additional proof of address such as a council tax statement or a utility bill"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "Your mortgage expert or case manager will keep you informed of what else is needed."
                })
            ]
        })
    },
    {
        name: "Where can I get documents from if I don\u2019t have them?",
        id: "faq-5",
        trackingLabelPrefix: "Doc Upload-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0f47e0ab4ea5f939$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Driving Licence or Passport"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "You can obtain a",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                            href: "https://www.gov.uk/renew-driving-licence",
                            target: "_blank",
                            children: "driving licence"
                        }),
                        " ",
                        "or",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                            href: "https://www.gov.uk/apply-renew-passport",
                            target: "_blank",
                            children: "passport"
                        }),
                        " ",
                        "through the relevant government application portals for each. Speak to your Mortgage Expert if you do not have either of these forms of ID to discuss your alternative options."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Payslips"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "Please obtain these directly from your employer - a PDF copy is preferred. Alternatively, a scan or photo of an original paper copy, with all four corners visible and content legible is acceptable as an alternative."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Self Employed SA302 document"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "These can be requested directly from",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                            href: "https://www.gov.uk/sa302-tax-calculation",
                            target: "_blank",
                            children: "HMRC"
                        }),
                        " ",
                        "- a PDF copy is preferred. Alternatively, a scan or photo of an original paper copy, with all four corners visible and content legible is acceptable as an alternative."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Bank Statements"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "If you use online banking with your account provider, you can download copies from your bank or building society\u2019s online portal in PDF format. Alternatively, a scan or photo of an original paper copy, with all four corners visible and content legible is acceptable as an alternative."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                    children: "Other"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "Any other documents should be obtained from the relevant issuing provider and provided in the most accessible format available to you and ideally, a scan or photo of an original paper copy, with all four corners visible and content legible is required."
                })
            ]
        })
    },
    {
        name: "I don\u2019t have a scanner, how can I scan my documents?",
        id: "faq-6",
        trackingLabelPrefix: "Doc Upload-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0f47e0ab4ea5f939$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                children: [
                    "Don\u2019t worry if you don\u2019t have a scanner. You can use a scanning app on your mobile device instead. We recommend the Adobe Scan mobile app available on both",
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                        href: "https://apps.apple.com/gb/app/adobe-scan-pdf-card-scanner/id1199564834",
                        target: "_blank",
                        children: "iPhone"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                        href: "https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=en_GB",
                        target: "_blank",
                        children: "Android"
                    }),
                    "."
                ]
            })
        })
    }
];


var $ed56f34cee1a73be$exports = {};
"use strict";
Object.defineProperty($ed56f34cee1a73be$exports, "__esModule", {
    value: true
});
var $ed56f34cee1a73be$var$SL_NOT_INITIALIZED = 'Smartlook client is not initialized.';
$ed56f34cee1a73be$exports["default"] = {
    init: function init(key, params) {
        var w = window;
        if (w.smartlook) {
            console.warn('Smartlook client is already initialized.');
            return false;
        }
        w.smartlook = function() {
            w.smartlook.api.push(arguments);
        };
        var _a = params !== null && params !== void 0 ? params : {}, _b = _a.region, region = _b === void 0 ? 'eu' : _b, _c = _a.version, version = _c === void 0 ? 'nextgen' : _c;
        w.smartlook.api = [];
        w.smartlook('init', key, {
            region: region
        });
        var head = window.document.getElementsByTagName('head')[0];
        var script = window.document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous';
        script.src = version === 'nextgen' ? 'https://web-sdk.smartlook.com/recorder.js' : 'https://rec.smartlook.com/recorder.js';
        head.appendChild(script);
        return true;
    },
    identify: function identify(userId, props) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        if (!userId) {
            console.warn('Smartlook - User ID must be provided');
            return false;
        }
        w.smartlook('identify', userId, props);
        return true;
    },
    anonymize: function anonymize() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('anonymize');
        return true;
    },
    track: function track(eventName, props) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('track', eventName, props);
        return true;
    },
    disable: function disable() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('disable');
        return true;
    },
    consentForms: function consentForms(consent) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('consentForms', consent);
        return true;
    },
    consentIP: function consentIP(consent) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('consentIP', consent);
        return true;
    },
    consentAPI: function consentAPI(consent) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('consentAPI', consent);
        return true;
    },
    getData: function getData(callback) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook(callback);
        return true;
    },
    restart: function restart() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('restart');
        return true;
    },
    pause: function pause() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('pause');
        return true;
    },
    resume: function resume() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('resume');
        return true;
    },
    error: function error(_error) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('error', _error);
        return true;
    },
    navigation: function navigation(locationOrPath) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('navigation', locationOrPath);
        return true;
    },
    properties: function properties(_properties) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ed56f34cee1a73be$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('properties', _properties);
        return true;
    },
    initialized: function initialized() {
        var w = window;
        return !!w.smartlook;
    },
    get playUrl () {
        var w = window;
        return w.smartlook.playUrl;
    },
    get sessionId () {
        var w1 = window;
        return w1.smartlook.sessionId;
    },
    get visitorId () {
        var w2 = window;
        return w2.smartlook.visitorId;
    },
    get recordId () {
        var w3 = window;
        return w3.smartlook.recordId;
    },
    get key () {
        var w4 = window;
        return w4.smartlook.key;
    },
    get version () {
        var w5 = window;
        return w5.smartlook.version;
    }
};


var $5c342e2d7b9523c9$var$isInitialised = false;
var $5c342e2d7b9523c9$var$logs = [];
function $5c342e2d7b9523c9$export$d050db8f6426404e() {
    if ($5c342e2d7b9523c9$var$isInitialised) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($ed56f34cee1a73be$exports))).init("9dd660b0387cb118e4187684c2b743401e0ec8f0");
    setTimeout(function() {
        $5c342e2d7b9523c9$var$isInitialised = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $5c342e2d7b9523c9$var$logs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var log = _step.value;
                log((0, (/*@__PURE__*/$parcel$interopDefault($ed56f34cee1a73be$exports))));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, 1000);
}
function $5c342e2d7b9523c9$export$2e2bcd8739ae039(event) {
    if (!$5c342e2d7b9523c9$var$isInitialised) {
        $5c342e2d7b9523c9$var$logs.push(function(slc) {
            return event(slc);
        });
        return;
    }
    event((0, (/*@__PURE__*/$parcel$interopDefault($ed56f34cee1a73be$exports))));
}






function $36f3258aa26cbafa$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 32px;\n  font-weight: 550;\n  margin: 1.5em 0 0 0.625em;\n  @media screen and ",
        " {\n    margin-top: 3em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  line-height: 1.5em;\n  margin: 1.5em 1.25em;\n  & button {\n    font-weight: 550;\n    text-decoration: underline;\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n  @media screen and ",
        " {\n    width: 34em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0 1.25em 6em;\n  & > div {\n    background: ",
        ";\n    padding: 1em;\n    display: flex;\n    align-items: center;\n    border-radius: 8px;\n  }\n  @media screen and ",
        " {\n    width: 34em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  & svg {\n    margin-right: 1em;\n    & > path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  & p {\n    margin: 0;\n  }\n  & strong {\n    font-weight: 550;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: auto 1rem auto 0;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: inline-flex;\n  font-weight: 600;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: auto 0.5rem;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 1em 2em;\n  border-radius: 1em;\n  margin-top: 1em;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #d1ddfc;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject14() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #fff;\n  margin: auto;\n  border-radius: 16px;\n  padding: 1rem;\n  & h3 {\n    margin: 2rem;\n    font-weight: 550;\n    font-size: 26px;\n    line-height: 34px;\n  }\n  & h4 {\n    margin: 1rem 0;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 34px;\n  }\n  // override the accordion styles\n  & .name {\n    font-size: 16px;\n    font-weight: 600;\n  }\n  @media screen and ",
        " {\n    width: 64em;\n    margin-bottom: 4.5em;\n    & .name {\n      font-weight: 600;\n    }\n  }\n  @media screen and ",
        " {\n    margin-bottom: 32px;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject15() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 1em 0;\n  line-height: 1.5em;\n  @media screen and ",
        " {\n    display: flex;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject16() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  & h4 {\n    font-weight: 550;\n    font-size: 16px;\n    margin: 1.5em 0;\n  }\n  & > ul {\n    padding-inline-start: 0;\n    margin: 0;\n    & li {\n      list-style-type: none;\n      margin-bottom: 1.25em;\n      & strong {\n        font-weight: 550;\n      }\n      & .tick {\n        margin-right: 0.875em;\n      }\n    }\n  }\n  @media screen and ",
        " {\n    flex: 1;\n    margin-right: 3.375em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject17() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  @media screen and ",
        " {\n    flex: 1;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject18() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  & p {\n    margin: 0 0 1em 0;\n  }\n  & ul {\n    padding-inline-start: 1em;\n    & li::marker {\n      font-size: 0.75em;\n    }\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject19() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  @media screen and ",
        " {\n    width: 34em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject20() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: auto;\n  h3 {\n    font-weight: 700;\n    display: inline-block;\n    font-size: 22px;\n    padding-bottom: 0.2em;\n    border-bottom: 4px solid blue;\n    margin-bottom: 1.4em;\n  }\n  ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n  @media screen and ",
        " {\n    width: 64em;\n    margin-bottom: 2em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject21() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  margin: auto;\n  @media screen and ",
        " {\n    width: 65em;\n  }\n  @media screen and ",
        " {\n    width: unset;\n  }\n  @media screen and (min-width: 1360px) {\n    width: 65em;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject22() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject23() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  @media screen and ",
        " {\n    margin-right: 8em;\n  }\n  @media screen and (min-width: 1360px) {\n    margin-right: 0;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject24() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n  padding: 1.5em;\n  background: #fff;\n  border-radius: 8px;\n  margin-top: 5.25em;\n  p {\n    line-height: 18px;\n    font-size: 12px;\n    width: 10.7em;\n    margin: 1.3em 0 0 0;\n  }\n  @media screen and ",
        " {\n    display: inline-block;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject25() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        ""
    ]);
    $36f3258aa26cbafa$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject26() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject27() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        ""
    ]);
    $36f3258aa26cbafa$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject28() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  p {\n    color: #3b4258;\n    margin: 0 0 24px 0;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject29() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n\n  ",
        "\n\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 1rem 0;\n    gap: 0;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject30() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 24px 0 0 0;\n  flex: 1;\n  min-width: 0;\n\n  a {\n    word-break: break-word;\n    overflow-wrap: break-word;\n  }\n\n  div {\n    margin: 1rem 0;\n  }\n\n  @media screen and (max-width: 767px) {\n    margin: 16px 0 0 0;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject31() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: auto 0 auto auto;\n  flex-shrink: 0;\n\n  span {\n    margin-left: 0.5rem;\n  }\n\n  @media screen and (max-width: 767px) {\n    margin: 0;\n    align-self: flex-start;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $36f3258aa26cbafa$var$_templateObject32() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #3b4258;\n\n  @media screen and (max-width: 767px) {\n    margin: 16px 0 24px 0;\n  }\n"
    ]);
    $36f3258aa26cbafa$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
var $36f3258aa26cbafa$export$be92b6f5f03c0fe9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject());
var $36f3258aa26cbafa$export$8b251419efc915eb = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($36f3258aa26cbafa$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$3c0420c1ab00970c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($36f3258aa26cbafa$var$_templateObject2(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$8357c5faf8e6d223 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject3(), function(props) {
    return props.theme.secondaryOne;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$c6053492850b21c8 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject4(), function(props) {
    return props.theme.primaryOne;
});
var $36f3258aa26cbafa$export$6428f445461dfd39 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject5());
var $36f3258aa26cbafa$export$acc2347200b634b7 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject6());
var $36f3258aa26cbafa$export$210ea85e49c56827 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject7());
var $36f3258aa26cbafa$export$2954fc50f7526484 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject8(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$681b28c099b8dbad = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject9());
var $36f3258aa26cbafa$export$48423cf6a25b5248 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject10());
var $36f3258aa26cbafa$export$c23bc51a8dfffc08 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject11());
var $36f3258aa26cbafa$export$e6dfd72ab29f8598 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject12());
var $36f3258aa26cbafa$export$9e191cf2548357c0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($36f3258aa26cbafa$export$e6dfd72ab29f8598)($36f3258aa26cbafa$var$_templateObject13());
var $36f3258aa26cbafa$export$c5db0d123d7c6491 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject14(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xs);
var $36f3258aa26cbafa$export$985b9a77379b54a0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject15(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$983f4969bff6d3da = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject16(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$d92143cdba9da814 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject17(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$aaad1f4c926ba136 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject18());
var $36f3258aa26cbafa$export$8f67d857ad88efa0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject19(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$67adadd82ebacf66 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject20(), (0, $d729aeb9aca595bc$export$7cad6f17fd6e117b), function(props) {
    return props.theme.shade60;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$78a558edcc066ec2 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject21(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $36f3258aa26cbafa$export$65d3f68547d1c1e9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject22());
var $36f3258aa26cbafa$export$d5ba735c94778627 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject23(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $36f3258aa26cbafa$export$d9736db17dce3652 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject24(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $36f3258aa26cbafa$export$d6e4feef2e258e3f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject25());
var $36f3258aa26cbafa$export$359056e99a96016d = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject26());
var $36f3258aa26cbafa$export$e1c772239a520574 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h4($36f3258aa26cbafa$var$_templateObject27());
var $36f3258aa26cbafa$export$71766ca0aafaa57a = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject28());
var $36f3258aa26cbafa$export$7bd0e708b28ee1ca = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject29(), function(props) {
    return props.isNotLast && "border-bottom: 1px solid #A1AAC7;";
});
var $36f3258aa26cbafa$export$faa653f45b908153 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject30());
var $36f3258aa26cbafa$export$81e2500ca26f0805 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject31());
var $36f3258aa26cbafa$export$72a38e9075b980c5 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($36f3258aa26cbafa$var$_templateObject32());





var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


var $63b3a3d2a761d8f8$exports = {};
$63b3a3d2a761d8f8$exports = $parcel$resolve("3wLLW");





parcelRequire("hAGkE");



var $3905fbe9c03e450a$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    margin: "2rem 0"
});
var $3905fbe9c03e450a$export$13a65b1ced09763c = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$Container, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d729aeb9aca595bc$export$a766cd26d0d69044), {
            data: $3905fbe9c03e450a$var$FaqData
        })
    });
};
var $3905fbe9c03e450a$var$FaqSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    lineHeight: "1.5em"
});
var $3905fbe9c03e450a$var$FaqP = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac))({
    fontSize: "16px"
});
var $3905fbe9c03e450a$var$FaqData = [
    {
        name: "Why is the overall initial cost higher in the new deal?",
        id: "faq-7",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqP, {
                children: "Sometimes, a lower rate can show a higher overall initial cost. This is because the lender has set the end date later, so your total cost over that period is higher, even though your monthly payments are lower. But don't worry, your agreed deal length (like 2 or 5 years) remains the same."
            })
        })
    },
    {
        name: "Why have interest rates gone down?",
        id: "faq-1",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqP, {
                children: "Lenders will often change their rates based on a number of factors. Sometimes it\u2019s to attract or retain customers in a competitive market. Other times it\u2019s in response to Government policies or changes to the Bank of England base rate."
            })
        })
    },
    {
        name: "Will it cost me money to change?",
        id: "faq-2",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqP, {
                children: "No. Our Rate Check Promise is part of our free service. When we monitor your lender for lower rates we make sure that we\u2019re searching for a like-for-like deal, so the only thing that changes is the interest rate. If you\u2019ve paid any product fees upfront, you may need to request a refund manually from the lender \u2014 but we\u2019ll let you know if this is the case."
            })
        })
    },
    {
        name: "Will it delay my completion date?",
        id: "faq-3",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqP, {
                children: "No, it shouldn\u2019t. Our Rate Check Promise keeps you updated all the way until completion. Lenders have different restrictions on how long it takes to move rates, so if it\u2019s too close to completion, we might not be able to move you in order to ensure there are no delays."
            })
        })
    },
    {
        name: "Will my rate go up?",
        id: "faq-4",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqP, {
                children: "No. Once we\u2019ve locked in a rate it won\u2019t go up, unless your mortgage type is a variable rate. We\u2019ll only ever notify you of a new rate when we think it could save you money."
            })
        })
    },
    {
        name: "Will I be accepted for the new rate?",
        id: "faq-5",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqP, {
                children: "As the lender has already checked your affordability and eligibility, you\u2019re highly likely to be accepted for the new rate. In our experience it is very rare that a lender won\u2019t move a customer onto the lower rate, but it can happen, most notably if your circumstances have changed. Occasionally, a lender will run a hard credit check before moving you onto the new rate. If you have any concerns about not being accepted, please speak to your Mortgage Expert."
            })
        })
    },
    {
        name: "Do you check other lenders?",
        id: "faq-6",
        trackingLabelPrefix: "Rate-Check-Promise-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3905fbe9c03e450a$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3905fbe9c03e450a$var$FaqP, {
                children: [
                    "Due to the complexity of the mortgage market and differences with how each lender manages their interest rates, we don\u2019t run automatic checks for other lenders. However, you can request a manual check via",
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                        href: "https://mymojo.mojomortgages.com/rate-check-request",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "this form"
                    }),
                    " ",
                    "and your Mortgage Expert will check the whole market for a lower rate."
                ]
            })
        })
    }
];







var $2a02f2af2c31510c$export$d229165431aa1069 = function() {
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/rate-check-promise-opted-out");
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $acad1866a3f9fc3b$export$fceb9665be86d56e), {
        maxWidth: 1200,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$export$f769c1adb859387d, {}),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3905fbe9c03e450a$export$13a65b1ced09763c), {}),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$export$87d98f83bd85698, {})
        ]
    });
};
var $2a02f2af2c31510c$export$f769c1adb859387d = function() {
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2a02f2af2c31510c$var$PromiseContainer, {
            style: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2a02f2af2c31510c$var$PromiseText, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                            children: "Rate Check Promise"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                                children: "We can't automatically track rates for your deal - but we're still here to help!"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: "Our Rate Check Promise is designed to keep an eye on the interest rate of your recommended deal and let you know if it drops."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: "However, we're still developing this technology and there are certain types of deals we can't automatically check, unfortunately this includes yours."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: "That doesn't mean you'll miss out! If you'd like us to manually check for a better rate, just let us know via the form below."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                            width: "250px",
                            text: "Request rate check",
                            onClick: function() {
                                (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                    action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                    event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                    event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).requestRateCheck
                                });
                                history.push("/rate-check-request");
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$var$PromiseImageContainer, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$var$PromiseImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($63b3a3d2a761d8f8$exports))),
                        alt: "Dog"
                    })
                })
            ]
        })
    });
};
var $2a02f2af2c31510c$export$87d98f83bd85698 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2a02f2af2c31510c$var$Disclaimer, {
                size: "caption",
                children: [
                    "You can read about our Rate Check Promise terms and conditions within our",
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$export$b2bf131c9f9cce5d, {
                        title: "Terms of Advisory Services",
                        target: "_blank",
                        href: "https://hosted-assets.mojomortgages.com/documents/Terms%20of%20our%20Advisory%20Services.pdf",
                        children: "Terms of Advisory Service."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$var$Disclaimer, {
                size: "caption",
                children: "Mojo is a trading style of Life's Great Limited which is registered in England and Wales (06246376). We are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215)"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2a02f2af2c31510c$var$Disclaimer, {
                size: "caption",
                children: [
                    "Our registered office is The Cooperage, 5 Copper Row, London, SE1 2LH,",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$var$Disclaimer, {
                size: "caption",
                children: "To contact us by phone, please call 0333 123 0012."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2a02f2af2c31510c$var$Disclaimer, {
                size: "caption",
                children: "YOUR HOME/PROPERTY MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE"
            })
        ]
    });
};
var $2a02f2af2c31510c$export$b2bf131c9f9cce5d = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a({
    textDecoration: "none",
    color: "blue"
});
var $2a02f2af2c31510c$var$Disclaimer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac))({
    textAlign: "center"
});
var $2a02f2af2c31510c$var$_obj;
var $2a02f2af2c31510c$var$PromiseContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($2a02f2af2c31510c$var$_obj = {
    display: "flex"
}, (0, $8c6ug._)($2a02f2af2c31510c$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column"
}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "column"
}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row"
}), $2a02f2af2c31510c$var$_obj));
var $2a02f2af2c31510c$var$_obj1;
var $2a02f2af2c31510c$var$PromiseText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($2a02f2af2c31510c$var$_obj1 = {}, (0, $8c6ug._)($2a02f2af2c31510c$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flex: 7
}), $2a02f2af2c31510c$var$_obj1));
var $2a02f2af2c31510c$var$_obj2;
var $2a02f2af2c31510c$var$PromiseImageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($2a02f2af2c31510c$var$_obj2 = {}, (0, $8c6ug._)($2a02f2af2c31510c$var$_obj2, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    textAlign: "center",
    padding: "2rem"
}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj2, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    textAlign: "center",
    padding: "2rem"
}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj2, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flex: 1,
    width: 250
}), $2a02f2af2c31510c$var$_obj2));
var $2a02f2af2c31510c$var$_obj3;
var $2a02f2af2c31510c$var$PromiseImage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img(($2a02f2af2c31510c$var$_obj3 = {}, (0, $8c6ug._)($2a02f2af2c31510c$var$_obj3, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    // shrink image if there's not enough width
    maxWidth: "100%",
    height: "auto"
}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj3, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    // shrink image if there's not enough width
    maxWidth: "100%",
    height: "auto"
}), (0, $8c6ug._)($2a02f2af2c31510c$var$_obj3, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {}), $2a02f2af2c31510c$var$_obj3));






var $4jtOI = parcelRequire("4jtOI");
var $3e16eba31040bbf0$require$Buffer = $4jtOI.Buffer;
var $3e16eba31040bbf0$var$emptyDocsByType = {
    BankStatements: [],
    ID: [],
    Income: [],
    Other: []
};
var $3e16eba31040bbf0$var$sortByType = function(docs) {
    return docs.reduce(function(acc, doc) {
        return (0, $7XD9P._)((0, $hRCmZ._)({}, acc), (0, $8c6ug._)({}, doc.docType, acc[doc.docType].concat(doc)));
    }, $3e16eba31040bbf0$var$emptyDocsByType);
};
var $3e16eba31040bbf0$export$22c59631e6c46e5a = function(param) {
    var friendlyId = param.friendlyId, application = param.application;
    var _application_applicants;
    var _useSessionQR = (0, $01653cfe8f3c67b0$export$fe214daa53b0a716)({
        redirect: window.location.href
    }), qrData = _useSessionQR.data, qrIsLoading = _useSessionQR.isLoading;
    var faqRef = (0, $hAGkE.useRef)(null);
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), payNow = _useState1[0], setPayNow = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), offerDocuments = _useState2[0], setOfferDocuments = _useState2[1];
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), pickerState = _useState3[0], setPickerState = _useState3[1];
    var _useState4 = (0, $6mdMa._)((0, $hAGkE.useState)([]), 2), applicantDocuments = _useState4[0], setApplicantDocuments = _useState4[1];
    var _useApplicationSummaryEnhanced = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }), applicationSummary = _useApplicationSummaryEnhanced.application;
    console.log("applicationSummary :", applicationSummary);
    var documentsPathQrCode = $3e16eba31040bbf0$require$Buffer.from("/application/".concat(friendlyId, "/documents")).toString("base64");
    (0, $hAGkE.useEffect)(function() {
        if (applicationSummary) {
            var pay = (0, $cba09c37978e7e74$export$2a93b82c132dbea4)((0, $cba09c37978e7e74$export$c99b893d464ee8dd).BTL_SPECIALIST, applicationSummary);
            setPayNow(pay);
        }
    }, [
        applicationSummary
    ]);
    (0, $hAGkE.useEffect)(function() {
        var _application_metadata;
        if (!application.applicants) return;
        var _application_metadata_documents;
        setApplicantDocuments((_application_metadata_documents = (_application_metadata = application.metadata) === null || _application_metadata === void 0 ? void 0 : _application_metadata.documents) !== null && _application_metadata_documents !== void 0 ? _application_metadata_documents : []);
        var fetchDocuments = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var documents;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(application === null || application === void 0 ? void 0 : application.applicationId)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $254afdf4bfa2446b$export$8e0779374e7083bc)(application.applicationId)
                            ];
                        case 1:
                            documents = _state.sent();
                            setOfferDocuments(documents);
                            setIsLoading(false);
                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                                event_label: "Mortgage Offer Document"
                            });
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        fetchDocuments();
    }, [
        application
    ]);
    (0, $hAGkE.useEffect)(function() {
        (0, $5c342e2d7b9523c9$export$2e2bcd8739ae039)(function(smartLook) {
            smartLook.track("upload-docs", {
                friendlyId: friendlyId
            });
        });
    }, [
        friendlyId
    ]);
    var accordionData = function(applicant) {
        var applicantNumber = applicant.firstApplicant ? 1 : 2;
        var docs = $3e16eba31040bbf0$var$sortByType(applicantDocuments.filter(function(param) {
            var applicantId = param.applicantId;
            return applicantId === applicant.id;
        }));
        return [
            {
                name: "Proof of ID",
                id: "proof-of-id",
                trackingLabelPrefix: "Applicant".concat(applicantNumber),
                statusComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $26127b8c5619a3f4$export$994e57f9ba01697f), {
                    documents: docs.ID
                }),
                page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$985b9a77379b54a0), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$983f4969bff6d3da), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                                    children: "Provide either your Passport or Driving Licence"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "Must be a current, ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "valid"
                                                    }),
                                                    " document"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "Must show your ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "name"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "and date of birth"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "A clear, high quality ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "colour scan"
                                                    }),
                                                    " or ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "photo*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: "All four corners visible"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                    children: "*In some circumstances we may need a physical copy, but a clear, high quality photo or scan will usually do."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$d92143cdba9da814), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0a92664b9837f58c$export$2633c22b7a1b7cb), {
                                buttonText: "Choose files",
                                applicantNumber: applicantNumber,
                                docType: "ID",
                                onClick: function() {
                                    setPickerState({
                                        applicant: applicant,
                                        documentType: "ID"
                                    });
                                },
                                uploadedItems: docs.ID.map(function(param) {
                                    var originalFilename = param.originalFilename;
                                    return {
                                        originalFilename: originalFilename
                                    };
                                })
                            })
                        })
                    ]
                })
            },
            {
                name: "Proof of income",
                id: "proof-of-income",
                trackingLabelPrefix: "Applicant".concat(applicantNumber),
                page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$985b9a77379b54a0), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$983f4969bff6d3da), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                                    children: "Provide the last 3 months\u2019 payslips"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "Must show your ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "name"
                                                    }),
                                                    ", ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "current address"
                                                    }),
                                                    " and",
                                                    " ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "income"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "Upload a ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "PDF document"
                                                    }),
                                                    " from your employer or HMRC, preferably an original document or a clear photo/scan of a paper copy with all four corners visible"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "If ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "self-employed"
                                                    }),
                                                    ", provide instead",
                                                    " ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "2 years\u2019 SA302s"
                                                    }),
                                                    " and either the corresponding",
                                                    " ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "self-employed tax year overviews or company accounts"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$d92143cdba9da814), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0a92664b9837f58c$export$2633c22b7a1b7cb), {
                                buttonText: "Choose files",
                                applicantNumber: applicantNumber,
                                docType: "Income",
                                onClick: function() {
                                    setPickerState({
                                        applicant: applicant,
                                        documentType: "Income"
                                    });
                                },
                                uploadedItems: docs.Income.map(function(param) {
                                    var originalFilename = param.originalFilename;
                                    return {
                                        originalFilename: originalFilename
                                    };
                                })
                            })
                        })
                    ]
                }),
                statusComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $26127b8c5619a3f4$export$994e57f9ba01697f), {
                    documents: docs.Income
                })
            },
            {
                name: "Bank statements",
                id: "bank-statements",
                trackingLabelPrefix: "Applicant".concat(applicantNumber),
                page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$985b9a77379b54a0), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$983f4969bff6d3da), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h4", {
                                    children: "Provide the last 3 months\u2019 bank statements"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "Must show your ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "name, current address, income being credited"
                                                    }),
                                                    ", and ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "regular outgoings"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    "Upload a ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "PDF document"
                                                    }),
                                                    " from your employer or HMRC, preferably an original document or a clear photo/scan of a paper copy with all four corners visible"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $01eea66b91c29115$export$a2d033d90173e318), {
                                            showTick: true,
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "Every page"
                                                    }),
                                                    " of all statements included"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$d92143cdba9da814), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0a92664b9837f58c$export$2633c22b7a1b7cb), {
                                buttonText: "Choose files",
                                applicantNumber: applicantNumber,
                                docType: "BankStatements",
                                onClick: function() {
                                    setPickerState({
                                        applicant: applicant,
                                        documentType: "BankStatements"
                                    });
                                },
                                uploadedItems: docs.BankStatements.map(function(param) {
                                    var originalFilename = param.originalFilename;
                                    return {
                                        originalFilename: originalFilename
                                    };
                                })
                            })
                        })
                    ]
                }),
                statusComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $26127b8c5619a3f4$export$994e57f9ba01697f), {
                    documents: docs.BankStatements
                })
            },
            {
                name: "Other documents",
                id: "other-documents",
                trackingLabelPrefix: "Applicant".concat(applicantNumber),
                page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$985b9a77379b54a0), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$983f4969bff6d3da), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$aaad1f4c926ba136), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                        children: "Once we start putting together your mortgage application, we may need more from you."
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                        children: "Additional documents could include:"
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                children: "Proof of deposit for your purchase"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                children: "Evidence of other sources of income or supplements to your basic income like bonuses or regular overtime"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                children: "Proof of right to reside in the UK"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                children: "Additional proof of address such as a council tax statement or a utility bill"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                        children: "Your mortgage expert or case manager will keep you informed of what else is needed."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$d92143cdba9da814), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0a92664b9837f58c$export$2633c22b7a1b7cb), {
                                buttonText: "Choose files",
                                applicantNumber: applicantNumber,
                                docType: "Other",
                                onClick: function() {
                                    setPickerState({
                                        applicant: applicant,
                                        documentType: "Other"
                                    });
                                },
                                uploadedItems: docs.Other.map(function(param) {
                                    var originalFilename = param.originalFilename;
                                    return {
                                        originalFilename: originalFilename
                                    };
                                })
                            })
                        })
                    ]
                }),
                statusComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $26127b8c5619a3f4$export$994e57f9ba01697f), {
                    documents: docs.Other
                })
            }
        ];
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$be92b6f5f03c0fe9), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$78a558edcc066ec2), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$65d3f68547d1c1e9), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$8b251419efc915eb), {
                                children: "Documents"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$3c0420c1ab00970c), {
                                children: [
                                    "Adding documents is quick and easy and helps to make sure everything goes as smoothly as possible with your mortgage recommendation and application.",
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("br", {}),
                                    " Need help? Check out our",
                                    " ",
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("button", {
                                        onClick: function() {
                                            return faqRef.current.scrollIntoView();
                                        },
                                        children: "FAQs."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$8357c5faf8e6d223), {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$c6053492850b21c8), {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $6c6d4c58ba02802b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$6428f445461dfd39), {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                                children: [
                                                    "All your documents are ",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                        children: "securely stored"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$d5ba735c94778627), {
                        children: !qrIsLoading && qrData && documentsPathQrCode && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$d9736db17dce3652), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                                    src: qrData,
                                    height: 150,
                                    width: 150
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                    children: "Scan the QR to upload files & photos from your phone"
                                })
                            ]
                        })
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$8f67d857ad88efa0), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                    size: 150,
                    theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
                })
            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$c5db0d123d7c6491), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                                children: "Mortgage documents"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$9e191cf2548357c0), {
                                children: offerDocuments && offerDocuments.length ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$d6e4feef2e258e3f), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$359056e99a96016d), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$acc2347200b634b7), {
                                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $68e386558564a06c$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$e1c772239a520574), {
                                                            children: "Mortgage Offer"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$71766ca0aafaa57a), {
                                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                                        children: "This is where any mortgage offers from your lender will show. Please ensure you read through all the information and make sure it is accurate."
                                                    })
                                                })
                                            ]
                                        }),
                                        offerDocuments === null || offerDocuments === void 0 ? void 0 : offerDocuments.map(function(offer, idx) {
                                            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$7bd0e708b28ee1ca), {
                                                isNotLast: idx < offerDocuments.length - 1,
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$faa653f45b908153), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $2a02f2af2c31510c$export$b2bf131c9f9cce5d), {
                                                                target: "_blank",
                                                                href: offer.downloadUrl,
                                                                style: {
                                                                    fontWeight: 600
                                                                },
                                                                children: offer.filename
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$72a38e9075b980c5), {
                                                                children: [
                                                                    "Added ",
                                                                    (0, $45f64f2ccb2647eb$export$fb9f91b434a357bf)(offer.updatedAt)
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$81e2500ca26f0805), {
                                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                                                            width: "158px",
                                                            onClick: function() {
                                                                (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                                                    action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                                                    event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                                                                    event_label: "Download Mortgage Offer Document"
                                                                });
                                                                window.open(offer.downloadUrl, "_blank");
                                                            },
                                                            text: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$210ea85e49c56827), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $a71e7fd27cfc35fb$export$2e2bcd8739ae039), {}),
                                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                                        children: "Download"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$681b28c099b8dbad), {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$48423cf6a25b5248), {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$c23bc51a8dfffc08), {
                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ea7abe027ee89394$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                                children: "You'll see documents relating to your mortgage in this section"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$c5db0d123d7c6491), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                                children: "Your documents"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$9e191cf2548357c0), {
                                children: (_application_applicants = application.applicants) === null || _application_applicants === void 0 ? void 0 : _application_applicants.map(function(applicant) {
                                    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("h4", {
                                                children: [
                                                    applicant.forename,
                                                    "'s documents"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d729aeb9aca595bc$export$a766cd26d0d69044), {
                                                data: accordionData(applicant)
                                            })
                                        ]
                                    }, applicant.id);
                                })
                            })
                        ]
                    }),
                    payNow && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$c5db0d123d7c6491), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                                children: "Next step: complete payment"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $36f3258aa26cbafa$export$e6dfd72ab29f8598), {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$2954fc50f7526484), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                            children: "Once you\u2019ve uploaded your documents and we have everything we need, you can pay the \xa3499, non-refundable application fee."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                                            width: "180px",
                                            onClick: function() {
                                                (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                                    action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                                    event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                                    event_label: "Pay now - Documents"
                                                });
                                                window.location.href = applicationSummary.service.checkoutSessionUrl;
                                            },
                                            text: "Pay now"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $36f3258aa26cbafa$export$67adadd82ebacf66), {
                        ref: faqRef,
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                    children: "All documents provided to us will be thoroughly assessed for authenticity to ensure compliance and security, any suspicion of fraudulent activity will be reported."
                                })
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                                children: "Document FAQs"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d729aeb9aca595bc$export$a766cd26d0d69044), {
                                data: (0, $0f47e0ab4ea5f939$export$85c980ec82aeb21b)
                            })
                        ]
                    })
                ]
            }),
            pickerState && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bd0371ce0c24b8ad$export$cc82a6d2ed7645ba), {
                close: function() {
                    setPickerState(null);
                },
                container: (0, $10b47c5a212e87a0$export$d0fea2c8ddbe4d95),
                uploadedFilePath: "/".concat(pickerState.applicant.id, "-").concat(friendlyId, "/"),
                customOptions: {
                    accept: pickerState.documentType === "BankStatements" || pickerState.documentType === "Income" ? [
                        "application/pdf"
                    ] : [
                        "application/pdf",
                        "image/*"
                    ],
                    onClose: function() {
                        setPickerState(null);
                    },
                    onFileSelected: function(file) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                            var _pickerState_applicant, forename, surname, originalName, hasExtension, detected;
                            return (0, $dMrZK.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _pickerState_applicant = pickerState.applicant, forename = _pickerState_applicant.forename, surname = _pickerState_applicant.surname;
                                        originalName = file.originalFile.name;
                                        hasExtension = originalName.includes(".");
                                        if (!!hasExtension) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            (0, $f6aa406a7c6ae811$export$42a33cfe1d0655e9)(file.originalFile)
                                        ];
                                    case 1:
                                        detected = _state.sent();
                                        if (!detected) throw new Error("Unrecognised file type. Please upload a PDF or image (JPG, PNG).");
                                        return [
                                            2,
                                            (0, $7XD9P._)((0, $hRCmZ._)({}, file), {
                                                name: "".concat(forename).concat(surname, "-").concat(pickerState.documentType, ".").concat(originalName, ".").concat(detected)
                                            })
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            (0, $7XD9P._)((0, $hRCmZ._)({}, file), {
                                                name: "".concat(forename).concat(surname, "-").concat(pickerState.documentType, ".").concat(originalName)
                                            })
                                        ];
                                }
                            });
                        })();
                    },
                    disableStorageKey: true
                },
                onSuccessFunction: function(filesUploaded) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                        var nextDocuments, ex;
                        return (0, $dMrZK.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filesUploaded = filesUploaded.map(function(file) {
                                        var _pickerState_applicant = pickerState.applicant, forename = _pickerState_applicant.forename, surname = _pickerState_applicant.surname;
                                        var directoryName = file.key.split("/")[0];
                                        var fileName = "".concat(forename).concat(surname, "-").concat(pickerState.documentType, ".").concat(file.key.split("/")[1]);
                                        return (0, $7XD9P._)((0, $hRCmZ._)({}, file), {
                                            key: "".concat(directoryName, "/").concat(fileName)
                                        });
                                    });
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    // It's possible for onSuccessFunction to be called with an empty
                                    // array. Not sure how, it seems to be an error in the FileStack
                                    // picker. But if we don't have filesUploaded, do nothing.
                                    if (filesUploaded.length < 1) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        (0, $254afdf4bfa2446b$export$792769bf76d010a9)(filesUploaded, application.applicationId, pickerState.applicant.id, pickerState.documentType)
                                    ];
                                case 2:
                                    nextDocuments = _state.sent();
                                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).documentUploaded,
                                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                        event_label: "Applicant".concat(pickerState.applicant.firstApplicant ? 1 : 2, " - ").concat(pickerState.documentType)
                                    });
                                    setApplicantDocuments(nextDocuments);
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    ex = _state.sent();
                                    (0, $411b073b3fd49a19$export$5c9af0966a1ac889)(ex);
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        ]
    });
};



var $iNemB = parcelRequire("iNemB");

var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");


var $dMrZK = parcelRequire("dMrZK");







var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");



var $hAGkE = parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");

var $hAGkE = parcelRequire("hAGkE");
var $fdd55589ea724e5e$var$N = function(e) {
    return typeof e == "function";
}, $fdd55589ea724e5e$export$d812c8e1906863d0 = function(e, t) {
    return $fdd55589ea724e5e$var$N(e) ? e(t) : e;
};
var $fdd55589ea724e5e$var$V = function() {
    var e = 0;
    return function() {
        return (++e).toString();
    };
}(), $fdd55589ea724e5e$var$J = function() {
    var e;
    return function() {
        if (e === void 0 && (typeof window === "undefined" ? "undefined" : (0, $2xTNA._)(window)) < "u") {
            var t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
}();
var $fdd55589ea724e5e$var$j = 20, $fdd55589ea724e5e$var$h = "default";
var $fdd55589ea724e5e$var$v = function(e, t) {
    var _e_settings = e.settings, s = _e_settings.toastLimit;
    switch(t.type){
        case 0:
            return (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                toasts: [
                    t.toast
                ].concat((0, $bOqL7._)(e.toasts)).slice(0, s)
            });
        case 1:
            return (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                toasts: e.toasts.map(function(o) {
                    return o.id === t.toast.id ? (0, $hRCmZ._)({}, o, t.toast) : o;
                })
            });
        case 2:
            var r = t.toast;
            return $fdd55589ea724e5e$var$v(e, {
                type: e.toasts.find(function(o) {
                    return o.id === r.id;
                }) ? 1 : 0,
                toast: r
            });
        case 3:
            var a = t.toastId;
            return (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                toasts: e.toasts.map(function(o) {
                    return o.id === a || a === void 0 ? (0, $7XD9P._)((0, $hRCmZ._)({}, o), {
                        dismissed: !0,
                        visible: !1
                    }) : o;
                })
            });
        case 4:
            return t.toastId === void 0 ? (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                toasts: []
            }) : (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                toasts: e.toasts.filter(function(o) {
                    return o.id !== t.toastId;
                })
            });
        case 5:
            return (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                pausedAt: t.time
            });
        case 6:
            var T = t.time - (e.pausedAt || 0);
            return (0, $7XD9P._)((0, $hRCmZ._)({}, e), {
                pausedAt: void 0,
                toasts: e.toasts.map(function(o) {
                    return (0, $7XD9P._)((0, $hRCmZ._)({}, o), {
                        pauseDuration: o.pauseDuration + T
                    });
                })
            });
    }
}, $fdd55589ea724e5e$var$O = [], $fdd55589ea724e5e$var$I = {
    toasts: [],
    pausedAt: void 0,
    settings: {
        toastLimit: $fdd55589ea724e5e$var$j
    }
}, $fdd55589ea724e5e$var$l = {}, $fdd55589ea724e5e$var$M = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fdd55589ea724e5e$var$h;
    $fdd55589ea724e5e$var$l[t] = $fdd55589ea724e5e$var$v($fdd55589ea724e5e$var$l[t] || $fdd55589ea724e5e$var$I, e), $fdd55589ea724e5e$var$O.forEach(function(param) {
        var _param = (0, $6mdMa._)(param, 2), s = _param[0], r = _param[1];
        s === t && r($fdd55589ea724e5e$var$l[t]);
    });
}, $fdd55589ea724e5e$var$P = function(e) {
    return Object.keys($fdd55589ea724e5e$var$l).forEach(function(t) {
        return $fdd55589ea724e5e$var$M(e, t);
    });
}, $fdd55589ea724e5e$var$U = function(e) {
    return Object.keys($fdd55589ea724e5e$var$l).find(function(t) {
        return $fdd55589ea724e5e$var$l[t].toasts.some(function(s) {
            return s.id === e;
        });
    });
}, $fdd55589ea724e5e$var$f = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $fdd55589ea724e5e$var$h;
    return function(t) {
        $fdd55589ea724e5e$var$M(t, e);
    };
}, $fdd55589ea724e5e$var$Q = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $fdd55589ea724e5e$export$3960353ab538dc47 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fdd55589ea724e5e$var$h;
    var _C = (0, $6mdMa._)((0, $hAGkE.useState)($fdd55589ea724e5e$var$l[t] || $fdd55589ea724e5e$var$I), 2), s = _C[0], r = _C[1], a = (0, $hAGkE.useRef)($fdd55589ea724e5e$var$l[t]);
    (0, $hAGkE.useEffect)(function() {
        return a.current !== $fdd55589ea724e5e$var$l[t] && r($fdd55589ea724e5e$var$l[t]), $fdd55589ea724e5e$var$O.push([
            t,
            r
        ]), function() {
            var o = $fdd55589ea724e5e$var$O.findIndex(function(param) {
                var _param = (0, $6mdMa._)(param, 1), p = _param[0];
                return p === t;
            });
            o > -1 && $fdd55589ea724e5e$var$O.splice(o, 1);
        };
    }, [
        t
    ]);
    var T = s.toasts.map(function(o) {
        var p, A, y;
        return (0, $7XD9P._)((0, $hRCmZ._)({}, e, e[o.type], o), {
            removeDelay: o.removeDelay || ((p = e[o.type]) == null ? void 0 : p.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: o.duration || ((A = e[o.type]) == null ? void 0 : A.duration) || (e == null ? void 0 : e.duration) || $fdd55589ea724e5e$var$Q[o.type],
            style: (0, $hRCmZ._)({}, e.style, (y = e[o.type]) == null ? void 0 : y.style, o.style)
        });
    });
    return (0, $7XD9P._)((0, $hRCmZ._)({}, s), {
        toasts: T
    });
};
var $fdd55589ea724e5e$var$B = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "blank", s = arguments.length > 2 ? arguments[2] : void 0;
    return (0, $7XD9P._)((0, $hRCmZ._)({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0
    }, s), {
        id: (s == null ? void 0 : s.id) || $fdd55589ea724e5e$var$V()
    });
}, $fdd55589ea724e5e$var$S = function(e) {
    return function(t, s) {
        var r = $fdd55589ea724e5e$var$B(t, e, s);
        return $fdd55589ea724e5e$var$f(r.toasterId || $fdd55589ea724e5e$var$U(r.id))({
            type: 2,
            toast: r
        }), r.id;
    };
}, $fdd55589ea724e5e$export$b410431fab84fa58 = function(e, t) {
    return $fdd55589ea724e5e$var$S("blank")(e, t);
};
$fdd55589ea724e5e$export$b410431fab84fa58.error = $fdd55589ea724e5e$var$S("error");
$fdd55589ea724e5e$export$b410431fab84fa58.success = $fdd55589ea724e5e$var$S("success");
$fdd55589ea724e5e$export$b410431fab84fa58.loading = $fdd55589ea724e5e$var$S("loading");
$fdd55589ea724e5e$export$b410431fab84fa58.custom = $fdd55589ea724e5e$var$S("custom");
$fdd55589ea724e5e$export$b410431fab84fa58.dismiss = function(e, t) {
    var s = {
        type: 3,
        toastId: e
    };
    t ? $fdd55589ea724e5e$var$f(t)(s) : $fdd55589ea724e5e$var$P(s);
};
$fdd55589ea724e5e$export$b410431fab84fa58.dismissAll = function(e) {
    return $fdd55589ea724e5e$export$b410431fab84fa58.dismiss(void 0, e);
};
$fdd55589ea724e5e$export$b410431fab84fa58.remove = function(e, t) {
    var s = {
        type: 4,
        toastId: e
    };
    t ? $fdd55589ea724e5e$var$f(t)(s) : $fdd55589ea724e5e$var$P(s);
};
$fdd55589ea724e5e$export$b410431fab84fa58.removeAll = function(e) {
    return $fdd55589ea724e5e$export$b410431fab84fa58.remove(void 0, e);
};
$fdd55589ea724e5e$export$b410431fab84fa58.promise = function(e, t, s) {
    var r = $fdd55589ea724e5e$export$b410431fab84fa58.loading(t.loading, (0, $hRCmZ._)({}, s, s == null ? void 0 : s.loading));
    return typeof e == "function" && (e = e()), e.then(function(a) {
        var T = t.success ? $fdd55589ea724e5e$export$d812c8e1906863d0(t.success, a) : void 0;
        return T ? $fdd55589ea724e5e$export$b410431fab84fa58.success(T, (0, $hRCmZ._)({
            id: r
        }, s, s == null ? void 0 : s.success)) : $fdd55589ea724e5e$export$b410431fab84fa58.dismiss(r), a;
    })["catch"](function(a) {
        var T = t.error ? $fdd55589ea724e5e$export$d812c8e1906863d0(t.error, a) : void 0;
        T ? $fdd55589ea724e5e$export$b410431fab84fa58.error(T, (0, $hRCmZ._)({
            id: r
        }, s, s == null ? void 0 : s.error)) : $fdd55589ea724e5e$export$b410431fab84fa58.dismiss(r);
    }), e;
};
var $fdd55589ea724e5e$var$X = 1e3, $fdd55589ea724e5e$export$f46171b59bb094f9 = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    var _x = $fdd55589ea724e5e$export$3960353ab538dc47(e, t), s = _x.toasts, r = _x.pausedAt, a = (0, $hAGkE.useRef)(new Map).current, T = (0, $hAGkE.useCallback)(function(i) {
        var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fdd55589ea724e5e$var$X;
        if (a.has(i)) return;
        var u = setTimeout(function() {
            a["delete"](i), o({
                type: 4,
                toastId: i
            });
        }, c);
        a.set(i, u);
    }, []);
    (0, $hAGkE.useEffect)(function() {
        if (r) return;
        var i = Date.now(), c = s.map(function(u) {
            if (u.duration === 1 / 0) return;
            var g = (u.duration || 0) + u.pauseDuration - (i - u.createdAt);
            if (g < 0) {
                u.visible && $fdd55589ea724e5e$export$b410431fab84fa58.dismiss(u.id);
                return;
            }
            return setTimeout(function() {
                return $fdd55589ea724e5e$export$b410431fab84fa58.dismiss(u.id, t);
            }, g);
        });
        return function() {
            c.forEach(function(u) {
                return u && clearTimeout(u);
            });
        };
    }, [
        s,
        r,
        t
    ]);
    var o = (0, $hAGkE.useCallback)($fdd55589ea724e5e$var$f(t), [
        t
    ]), p = (0, $hAGkE.useCallback)(function() {
        o({
            type: 5,
            time: Date.now()
        });
    }, [
        o
    ]), A = (0, $hAGkE.useCallback)(function(i, c) {
        o({
            type: 1,
            toast: {
                id: i,
                height: c
            }
        });
    }, [
        o
    ]), y = (0, $hAGkE.useCallback)(function() {
        r && o({
            type: 6,
            time: Date.now()
        });
    }, [
        r,
        o
    ]), k = (0, $hAGkE.useCallback)(function(i, c) {
        var _E_filter;
        var _ref = c || {}, tmp = _ref.reverseOrder, u = tmp === void 0 ? !1 : tmp, tmp1 = _ref.gutter, g = tmp1 === void 0 ? 8 : tmp1, R = _ref.defaultPosition, E = s.filter(function(d) {
            return (d.position || R) === (i.position || R) && d.height;
        }), w = E.findIndex(function(d) {
            return d.id === i.id;
        }), _ = E.filter(function(d, b) {
            return b < w && d.visible;
        }).length;
        return (_E_filter = E.filter(function(d) {
            return d.visible;
        })).slice.apply(_E_filter, (0, $bOqL7._)(u ? [
            _ + 1
        ] : [
            0,
            _
        ])).reduce(function(d, b) {
            return d + (b.height || 0) + g;
        }, 0);
    }, [
        s
    ]);
    return (0, $hAGkE.useEffect)(function() {
        s.forEach(function(i) {
            if (i.dismissed) T(i.id, i.removeDelay);
            else {
                var c = a.get(i.id);
                c && (clearTimeout(c), a["delete"](i.id));
            }
        });
    }, [
        s,
        T
    ]), {
        toasts: s,
        handlers: {
            updateHeight: A,
            startPause: p,
            endPause: y,
            calculateOffset: k
        }
    };
};
var $fdd55589ea724e5e$export$2e2bcd8739ae039 = $fdd55589ea724e5e$export$b410431fab84fa58;




// src/index.ts

var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $a7G5R = parcelRequire("a7G5R");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");
parcelRequire("kTihC");
var $03NY2 = parcelRequire("03NY2");


var $03NY2 = parcelRequire("03NY2");

var $klJjI = parcelRequire("klJjI");
// src/applyAnimatedValues.ts
var $29d7fd5e78a14c9b$var$isCustomPropRE = /^--/;
function $29d7fd5e78a14c9b$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$29d7fd5e78a14c9b$var$isCustomPropRE.test(name) && !($29d7fd5e78a14c9b$var$isUnitlessNumber.hasOwnProperty(name) && $29d7fd5e78a14c9b$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $29d7fd5e78a14c9b$var$attributeCache = {};
function $29d7fd5e78a14c9b$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    var isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    var className = props.className, style = props.style, children = props.children, scrollTop = props.scrollTop, scrollLeft = props.scrollLeft, viewBox = props.viewBox, attributes = (0, $c4wKO._)(props, [
        "className",
        "style",
        "children",
        "scrollTop",
        "scrollLeft",
        "viewBox"
    ]);
    var values = Object.values(attributes);
    var names = Object.keys(attributes).map(function(name) {
        return isFilterElement || instance.hasAttribute(name) ? name : $29d7fd5e78a14c9b$var$attributeCache[name] || ($29d7fd5e78a14c9b$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        function(n) {
            return "-" + n.toLowerCase();
        }));
    });
    if (children !== void 0) instance.textContent = children;
    for(var name in style)if (style.hasOwnProperty(name)) {
        var value = $29d7fd5e78a14c9b$var$dangerousStyleValue(name, style[name]);
        if ($29d7fd5e78a14c9b$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach(function(name, i) {
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $29d7fd5e78a14c9b$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $29d7fd5e78a14c9b$var$prefixKey = function(prefix, key) {
    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};
var $29d7fd5e78a14c9b$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$29d7fd5e78a14c9b$var$isUnitlessNumber = Object.keys($29d7fd5e78a14c9b$var$isUnitlessNumber).reduce(function(acc, prop) {
    $29d7fd5e78a14c9b$var$prefixes.forEach(function(prefix) {
        return acc[$29d7fd5e78a14c9b$var$prefixKey(prefix, prop)] = acc[prop];
    });
    return acc;
}, $29d7fd5e78a14c9b$var$isUnitlessNumber);
var $29d7fd5e78a14c9b$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $29d7fd5e78a14c9b$var$pxTransforms = /^(translate)/;
var $29d7fd5e78a14c9b$var$degTransforms = /^(rotate|skew)/;
var $29d7fd5e78a14c9b$var$addUnit = function(value, unit) {
    return (0, $03NY2.is).num(value) && value !== 0 ? value + unit : value;
};
var $29d7fd5e78a14c9b$var$isValueIdentity = function(value, id) {
    return (0, $03NY2.is).arr(value) ? value.every(function(v) {
        return $29d7fd5e78a14c9b$var$isValueIdentity(v, id);
    }) : (0, $03NY2.is).num(value) ? value === id : parseFloat(value) === id;
};
var $29d7fd5e78a14c9b$var$AnimatedStyle = /*#__PURE__*/ function(AnimatedObject) {
    "use strict";
    (0, $a7G5R._)(AnimatedStyle, AnimatedObject);
    function AnimatedStyle(_param) {
        (0, $6WLcG._)(this, AnimatedStyle);
        var x = _param.x, y = _param.y, z = _param.z, style = (0, $c4wKO._)(_param, [
            "x",
            "y",
            "z"
        ]);
        var inputs = [];
        var transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push(function(xyz) {
                return [
                    "translate3d(".concat(xyz.map(function(v) {
                        return $29d7fd5e78a14c9b$var$addUnit(v, "px");
                    }).join(","), ")"),
                    // prettier-ignore
                    $29d7fd5e78a14c9b$var$isValueIdentity(xyz, 0)
                ];
            });
        }
        (0, $03NY2.eachProp)(style, function(value, key) {
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push(function(transform) {
                    return [
                        transform,
                        transform === ""
                    ];
                });
            } else if ($29d7fd5e78a14c9b$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $03NY2.is).und(value)) return;
                var unit = $29d7fd5e78a14c9b$var$pxTransforms.test(key) ? "px" : $29d7fd5e78a14c9b$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $03NY2.toArray)(value));
                transforms.push(key === "rotate3d" ? function(param) {
                    var _$_param = (0, $6mdMa._)(param, 4), x2 = _$_param[0], y2 = _$_param[1], z2 = _$_param[2], deg = _$_param[3];
                    return [
                        "rotate3d(".concat(x2, ",").concat(y2, ",").concat(z2, ",").concat($29d7fd5e78a14c9b$var$addUnit(deg, unit), ")"),
                        $29d7fd5e78a14c9b$var$isValueIdentity(deg, 0)
                    ];
                } : function(input) {
                    return [
                        "".concat(key, "(").concat(input.map(function(v) {
                            return $29d7fd5e78a14c9b$var$addUnit(v, unit);
                        }).join(","), ")"),
                        $29d7fd5e78a14c9b$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ];
                });
            }
        });
        if (inputs.length) style.transform = new $29d7fd5e78a14c9b$var$FluidTransform(inputs, transforms);
        return (0, $bQby9._)(this, AnimatedStyle, [
            style
        ]);
    }
    return AnimatedStyle;
}((0, $klJjI.AnimatedObject));
var $29d7fd5e78a14c9b$var$FluidTransform = /*#__PURE__*/ function(FluidValue) {
    "use strict";
    (0, $a7G5R._)(FluidTransform, FluidValue);
    function FluidTransform(inputs, transforms) {
        (0, $6WLcG._)(this, FluidTransform);
        var _this;
        _this = (0, $bQby9._)(this, FluidTransform);
        _this.inputs = inputs;
        _this.transforms = transforms;
        _this._value = null;
        return _this;
    }
    (0, $dbIwN._)(FluidTransform, [
        {
            key: "get",
            value: function get() {
                return this._value || (this._value = this._get());
            }
        },
        {
            key: "_get",
            value: function _get() {
                var _this = this;
                var transform = "";
                var identity = true;
                (0, $03NY2.each)(this.inputs, function(input, i) {
                    var arg1 = (0, $03NY2.getFluidValue)(input[0]);
                    var _this_transforms_i = (0, $6mdMa._)(_this.transforms[i]((0, $03NY2.is).arr(arg1) ? arg1 : input.map((0, $03NY2.getFluidValue))), 2), t = _this_transforms_i[0], id = _this_transforms_i[1];
                    transform += " " + t;
                    identity = identity && id;
                });
                return identity ? "none" : transform;
            }
        },
        {
            // Start observing our inputs once we have an observer.
            key: "observerAdded",
            value: function observerAdded(count) {
                var _this = this;
                if (count == 1) (0, $03NY2.each)(this.inputs, function(input) {
                    return (0, $03NY2.each)(input, function(value) {
                        return (0, $03NY2.hasFluidValue)(value) && (0, $03NY2.addFluidObserver)(value, _this);
                    });
                });
            }
        },
        {
            // Stop observing our inputs once we have no observers.
            key: "observerRemoved",
            value: function observerRemoved(count) {
                var _this = this;
                if (count == 0) (0, $03NY2.each)(this.inputs, function(input) {
                    return (0, $03NY2.each)(input, function(value) {
                        return (0, $03NY2.hasFluidValue)(value) && (0, $03NY2.removeFluidObserver)(value, _this);
                    });
                });
            }
        },
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") this._value = null;
                (0, $03NY2.callFluidObservers)(this, event);
            }
        }
    ]);
    return FluidTransform;
}((0, $03NY2.FluidValue));
// src/primitives.ts
var $29d7fd5e78a14c9b$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $03NY2.Globals).assign({
    batchedUpdates: (0, $0048b1b41b30e47d$exports.unstable_batchedUpdates),
    createStringInterpolator: (0, $03NY2.createStringInterpolator),
    colors: (0, $03NY2.colors)
});
var $29d7fd5e78a14c9b$var$host = (0, $klJjI.createHost)($29d7fd5e78a14c9b$var$primitives, {
    applyAnimatedValues: $29d7fd5e78a14c9b$var$applyAnimatedValues,
    createAnimatedStyle: function(style) {
        return new $29d7fd5e78a14c9b$var$AnimatedStyle(style);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: function(_param) {
        var scrollTop = _param.scrollTop, scrollLeft = _param.scrollLeft, props = (0, $c4wKO._)(_param, [
            "scrollTop",
            "scrollLeft"
        ]);
        return props;
    }
});
var $29d7fd5e78a14c9b$export$407448d2b89b1813 = $29d7fd5e78a14c9b$var$host.animated;


var $kTihC = parcelRequire("kTihC");

function $a159116cb4326250$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: fixed;\n  pointer-events: none;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: end;\n  justify-content: center;\n  background: ",
        ";\n  transition: background 0.3s;\n  z-index: 999;\n  & > * {\n    pointer-events: all;\n  }\n"
    ]);
    $a159116cb4326250$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $a159116cb4326250$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #ffffff;\n  box-shadow: 0px 16px 16px rgba(0, 9, 40, 0.08);\n  border-radius: 16px;\n  padding: 20px 24px;\n  margin: 40px 0;\n  font-size: 18px;\n  gap: 32px;\n  line-height: 1.5;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n\n  @media screen and ",
        " {\n    display: flex;\n  }\n"
    ]);
    $a159116cb4326250$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $a159116cb4326250$var$SelectedDealToastContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($a159116cb4326250$var$_templateObject(), function(param) {
    var active = param.active;
    return active ? "rgba(0, 0, 0, 0.2)" : "transparent";
});
var $a159116cb4326250$var$Toast = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $29d7fd5e78a14c9b$export$407448d2b89b1813).div)($a159116cb4326250$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $a159116cb4326250$var$Notification = function(param) {
    var component = param.component, toast = param.toast, handlers = param.handlers;
    var styles = (0, $kTihC.useSpring)({
        from: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        to: {
            opacity: 1,
            transform: "translateY(0%)"
        },
        config: (0, $kTihC.config).gentle,
        delay: 100,
        reverse: !toast.visible
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a159116cb4326250$var$Toast, {
        onMouseEnter: handlers.startPause,
        onMouseLeave: handlers.endPause,
        style: (0, $7XD9P._)((0, $hRCmZ._)({}, styles), {
            animation: "none"
        }),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).cloneElement(component, toast)
    });
};
var $a159116cb4326250$export$36ba2f559d49a8f6 = function(param) {
    var notificationComponent = param.notificationComponent;
    var _useToaster = (0, $fdd55589ea724e5e$export$f46171b59bb094f9)({
        duration: Infinity
    }), toasts = _useToaster.toasts, handlers = _useToaster.handlers;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a159116cb4326250$var$SelectedDealToastContainer, {
        active: toasts.filter(function(t) {
            return t.visible;
        }).length,
        onMouseEnter: handlers.startPause,
        onMouseLeave: handlers.endPause,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $acad1866a3f9fc3b$export$fceb9665be86d56e), {
            style: {
                margin: 0,
                paddingBottom: 0
            },
            children: toasts.map(function(toast) {
                return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($a159116cb4326250$var$Notification, {
                    component: notificationComponent,
                    toast: toast,
                    handlers: handlers
                }, toast.id);
            })
        })
    });
};











var $hAGkE = parcelRequire("hAGkE");






var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


parcelRequire("hAGkE");





var $e23e3ba289ce01db$exports = {};
$e23e3ba289ce01db$exports = $parcel$resolve("cyZzs");


function $68164826edc95436$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  z-index: -1;\n  display: grid;\n  grid-template-rows: ",
        ";\n  min-height: 100vh;\n\n  &.primary {\n    background: ",
        ";\n  }\n\n  &.alternate {\n    background: ",
        ';\n  }\n\n  &.peach {\n    background: #ffebdc;\n  }\n\n  &::before {\n    display: none;\n\n    @media (min-width: 500px) {\n      content: "&nbsp;";\n      display: ',
        ";\n      position: fixed;\n      background: ",
        ";\n      mask-image: url(",
        ");\n      mask-size: cover;\n      background-size: 140vw;\n      z-index: 0;\n      bottom: 0;\n      left: -80vw;\n      right: 0vw;\n      top: 25%;\n    }\n  }\n"
    ]);
    $68164826edc95436$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $68164826edc95436$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: ",
        ";\n  visibility: ",
        ";\n  background: ",
        ";\n  position: ",
        ";\n  width: 100%;\n  height: fit-content;\n  top: 0;\n  z-index: 999;\n  border-bottom: ",
        ";\n"
    ]);
    $68164826edc95436$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $68164826edc95436$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  z-index: 100;\n  height: 100%;\n  display: flex;\n  position: relative;\n"
    ]);
    $68164826edc95436$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $68164826edc95436$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  z-index: 100;\n  height: fit-content;\n"
    ]);
    $68164826edc95436$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $68164826edc95436$var$Root = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($68164826edc95436$var$_templateObject(), function(param) {
    var headerStyle = param.headerStyle;
    return "".concat(headerStyle === 3 ? "" : (0, $529f76fb6e0b38ff$export$49b69d753a55f8a1), " 1fr auto");
}, function(props) {
    return props.theme.backgroundColour;
}, function(props) {
    return "linear-gradient(137.52deg, ".concat(props.theme.secondaryOne, " 19.57%, ").concat((0, $6650ffc144de4082$export$4b073707ff63303)(0.05, props.theme.secondaryOne), " 79.66%)");
}, function(param) {
    var backgroundWave = param.backgroundWave;
    return backgroundWave ? "block" : "none";
}, function(param) {
    var theme = param.theme, colourTheme = param.colourTheme;
    switch(colourTheme){
        case "primary":
            return (0, $6650ffc144de4082$export$4b073707ff63303)(0.05, theme.backgroundColour);
        case "alternate":
            return (0, $6650ffc144de4082$export$4b073707ff63303)(0.08, theme.secondaryOne);
        case "peach":
            return "#ffdcc4";
    }
}, (0, (/*@__PURE__*/$parcel$interopDefault($e23e3ba289ce01db$exports))));
var $68164826edc95436$var$TopNavContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($68164826edc95436$var$_templateObject1(), function(param) {
    var headerStyle = param.headerStyle;
    return headerStyle === 3 && "none" || "block";
}, function(param) {
    var headerStyle = param.headerStyle;
    return headerStyle === 2 && "hidden" || "initial";
}, function(param) {
    var headerStyle = param.headerStyle, theme = param.theme;
    return headerStyle === 0 ? theme.navColour : (0, $6650ffc144de4082$export$4e46ac54fc82cf3b)(0, 0, 0, 0);
}, function(param) {
    var stickyHeader = param.stickyHeader;
    return stickyHeader ? "sticky" : "relative";
}, function(param) {
    var headerStyle = param.headerStyle, theme = param.theme;
    return headerStyle === 0 ? "1px solid ".concat(theme.borderColor) : 0;
});
var $68164826edc95436$var$ContentContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($68164826edc95436$var$_templateObject2());
var $68164826edc95436$var$FooterContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($68164826edc95436$var$_templateObject3());
var $68164826edc95436$export$54a719cd6595ff5c = /*#__PURE__*/ function(HeaderStyle) {
    HeaderStyle[HeaderStyle["Default"] = 0] = "Default";
    HeaderStyle[HeaderStyle["Transparent"] = 1] = "Transparent";
    HeaderStyle[HeaderStyle["Hidden"] = 2] = "Hidden";
    HeaderStyle[HeaderStyle["None"] = 3] = "None";
    HeaderStyle[HeaderStyle["NoUser"] = 4] = "NoUser";
    return HeaderStyle;
}({});
var $68164826edc95436$export$50462b76f8e9e7fc = /*#__PURE__*/ function(PageTheme) {
    PageTheme["Primary"] = "primary";
    PageTheme["Alternate"] = "alternate";
    PageTheme["Peach"] = "peach";
    return PageTheme;
}({});
function $68164826edc95436$export$c3bb089bd80cbef5(param) {
    var content = param.content, _param_footer = param.footer, footer = _param_footer === void 0 ? null : _param_footer, _param_headerStyle = param.headerStyle, headerStyle = _param_headerStyle === void 0 ? 0 : _param_headerStyle, _param_backgroundWave = param.backgroundWave, backgroundWave = _param_backgroundWave === void 0 ? false : _param_backgroundWave, _param_colourTheme = param.colourTheme, colourTheme = _param_colourTheme === void 0 ? "primary" : _param_colourTheme, _param_stickyHeader = param.stickyHeader, stickyHeader = _param_stickyHeader === void 0 ? true : _param_stickyHeader;
    var theme = (0, $7e7d633c88171aa1$export$b3611e87cd5ba6ce)().theme;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($68164826edc95436$var$Root, {
        className: colourTheme,
        backgroundWave: backgroundWave,
        colourTheme: colourTheme,
        headerStyle: headerStyle,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($68164826edc95436$var$TopNavContainer, {
                stickyHeader: stickyHeader,
                headerStyle: headerStyle,
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8c4ce8c143193527$export$41d0d88a6b0e456f), {
                    showPoweredBy: theme.showPoweredBy,
                    showUser: headerStyle !== 4
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($68164826edc95436$var$ContentContainer, {
                headerStyle: headerStyle,
                children: content
            }),
            footer && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($68164826edc95436$var$FooterContainer, {
                children: footer
            })
        ]
    });
}









var $8c6ug = parcelRequire("8c6ug");


parcelRequire("hAGkE");


parcelRequire("hAGkE");


function $1af82bf7ed558127$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-left: 35px;\n"
    ]);
    $1af82bf7ed558127$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1af82bf7ed558127$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n"
    ]);
    $1af82bf7ed558127$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $1af82bf7ed558127$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  position: relative;\n  text-align: left;\n  margin-bottom: 0;\n\n  &:before {\n    display: block;\n    content: "";\n    width: 2px;\n    height: calc(100% + 20px);\n    position: absolute;\n    left: 8px;\n    top: 20px;\n    border-radius: 20px;\n    background-color: #073ed9;\n  }\n\n  &:last-child:before {\n    display: none;\n  }\n'
    ]);
    $1af82bf7ed558127$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $1af82bf7ed558127$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 18px;\n  font-weight: 550;\n  line-height: 24px;\n  margin: 0;\n"
    ]);
    $1af82bf7ed558127$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $1af82bf7ed558127$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 14px;\n  line-height: 18px;\n  margin: 0.75rem 0 2rem;\n  min-height: 3em;\n"
    ]);
    $1af82bf7ed558127$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $1af82bf7ed558127$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 14px;\n  line-height: 18px;\n  margin: 0.75rem 0 2rem;\n  min-height: 3em;\n"
    ]);
    $1af82bf7ed558127$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $1af82bf7ed558127$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  position: relative;\n\n  &:before {\n    content: "";\n    position: absolute;\n    left: -4px;\n    top: -2px;\n    margin: auto;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background-color: #073ed9;\n  }\n\n  &:after {\n    content: attr(data-bullet);\n    position: absolute;\n    left: -4px;\n    top: -2px;\n    margin: auto;\n    width: 24px;\n    height: 24px;\n    text-align: center;\n    line-height: 27px;\n    font-weight: 600;\n    color: #fff;\n    border-radius: 50%;\n  }\n'
    ]);
    $1af82bf7ed558127$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $1af82bf7ed558127$export$9d2b4227a95687cc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($1af82bf7ed558127$var$_templateObject());
var $1af82bf7ed558127$export$23da619f1611dd3e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($1af82bf7ed558127$var$_templateObject1());
var $1af82bf7ed558127$export$a7b06bfba60a8a78 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($1af82bf7ed558127$var$_templateObject2());
var $1af82bf7ed558127$export$f99233281efd08a0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($1af82bf7ed558127$var$_templateObject3());
var $1af82bf7ed558127$export$5f1af8db9871e1d6 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($1af82bf7ed558127$var$_templateObject4());
var $1af82bf7ed558127$export$ef32732e50ea31c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($1af82bf7ed558127$var$_templateObject5());
var $1af82bf7ed558127$export$f90411c24f6aebf8 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($1af82bf7ed558127$var$_templateObject6());


var $ea0c6528de4ea340$export$a4d3a3d15e62ab91 = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1af82bf7ed558127$export$23da619f1611dd3e), {
        children: data.map(function(param, index) {
            var title = param.title, description = param.description;
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $1af82bf7ed558127$export$a7b06bfba60a8a78), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1af82bf7ed558127$export$f90411c24f6aebf8), {
                        "data-bullet": index + 1
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $1af82bf7ed558127$export$9d2b4227a95687cc), {
                        children: [
                            title && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1af82bf7ed558127$export$f99233281efd08a0), {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1af82bf7ed558127$export$ef32732e50ea31c), {
                                children: description
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
var $ea0c6528de4ea340$export$2e2bcd8739ae039 = $ea0c6528de4ea340$export$a4d3a3d15e62ab91;








function $903dc05d89ea817d$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media ",
        " {\n    z-index: 1000;\n    display: block;\n    width: 277px;\n    right: 0;\n    top: 0;\n    margin-top: 1rem;\n    position: absolute;\n  }\n"
    ]);
    $903dc05d89ea817d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $903dc05d89ea817d$export$243b414de1b76ea4 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($903dc05d89ea817d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($903dc05d89ea817d$var$Box, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                        size: "h3",
                        as: "h2",
                        children: "How it works"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1ca2cdaa0912b6ea$export$e031496191a50201), {
                        x: 2
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ea0c6528de4ea340$export$2e2bcd8739ae039), {
                        data: [
                            {
                                title: "We\u2019ll notify you of lower rates",
                                description: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                            children: "Once you\u2019ve had an offer accepted by a lender, we\u2019ll check every day to see if they have reduced rates for your deal."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                            children: "You\u2019ll hear from us via text message and email when a lower rate is found."
                                        })
                                    ]
                                })
                            },
                            {
                                title: "Request new deal ",
                                description: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                    children: "If you\u2019d like to move onto the new deal with the lower rate, let us know quickly by selecting \u2018Request this rate\u2019. We\u2019ll submit the request to your chosen lender. Occasionally, the lender might run a hard credit check."
                                })
                            },
                            {
                                title: "Move onto new rate & save \xa3\xa3",
                                description: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                    children: "You\u2019ll complete as usual. This change won\u2019t cost you anything. You\u2019ll just pay less for your mortgage."
                                })
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: "If rates drop again, we\u2019ll let you know. We\u2019ll make every effort to move you onto your new rate, unless it will cause delays to completion."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($903dc05d89ea817d$var$Image, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d2ebd71da6576dcd$exports))),
                alt: "person playing guitar"
            })
        ]
    });
};
var $903dc05d89ea817d$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    position: "relative"
});
var $903dc05d89ea817d$var$Box = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    padding: "2rem 1rem"
}, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    marginRight: 250
}));
var $903dc05d89ea817d$var$Image = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($903dc05d89ea817d$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);



var $8b9aba2ed88130ce$export$4e80a4010ef1396c = function() {
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/rate-check-promise");
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $68164826edc95436$export$c3bb089bd80cbef5), {
        backgroundWave: true,
        headerStyle: (0, $68164826edc95436$export$54a719cd6595ff5c).None,
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $acad1866a3f9fc3b$export$fceb9665be86d56e), {
            maxWidth: 1000,
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$export$f769c1adb859387d, {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $903dc05d89ea817d$export$243b414de1b76ea4), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3905fbe9c03e450a$export$13a65b1ced09763c), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$export$87d98f83bd85698, {})
            ]
        })
    });
};
var $8b9aba2ed88130ce$export$f769c1adb859387d = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8b9aba2ed88130ce$var$PromiseContainer, {
            style: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8b9aba2ed88130ce$var$PromiseText, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                            children: "Rate Check Promise"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                                children: "Giving you peace of mind"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: "Once you have had an offer accepted by a lender, we\u2019ll continue to check that you\u2019re still on the lowest rate for the mortgage deal you\u2019ve chosen and will let you know of changes all the way until you complete."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                            children: "If we find a lower rate for your deal, we\u2019ll let you know."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$var$PromiseImageContainer, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$var$PromiseImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff419e2b02580b2c$exports))),
                        alt: "Example of a Rate Check Promise"
                    })
                })
            ]
        })
    });
};
var $8b9aba2ed88130ce$export$87d98f83bd85698 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8b9aba2ed88130ce$var$Disclaimer, {
                size: "caption",
                children: [
                    "You can read about our Rate Check Promise terms and conditions within our",
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$var$ExternalLink, {
                        title: "Terms of Advisory Services",
                        target: "_blank",
                        href: "https://hosted-assets.mojomortgages.com/documents/Terms%20of%20our%20Advisory%20Services.pdf",
                        children: "Terms of Advisory Service."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$var$Disclaimer, {
                size: "caption",
                children: "Mojo is a trading style of Life's Great Limited which is registered in England and Wales (06246376). We are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215)"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($8b9aba2ed88130ce$var$Disclaimer, {
                size: "caption",
                children: [
                    "Our registered office is The Cooperage, 5 Copper Row, London, SE1 2LH,",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$var$Disclaimer, {
                size: "caption",
                children: "To contact us by phone, please call 0333 123 0012."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($8b9aba2ed88130ce$var$Disclaimer, {
                size: "caption",
                children: "YOUR HOME/PROPERTY MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE"
            })
        ]
    });
};
var $8b9aba2ed88130ce$var$ExternalLink = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a({
    textDecoration: "none",
    color: "blue"
});
var $8b9aba2ed88130ce$var$Disclaimer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac))({
    textAlign: "center"
});
var $8b9aba2ed88130ce$var$_obj;
var $8b9aba2ed88130ce$var$PromiseContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($8b9aba2ed88130ce$var$_obj = {
    display: "flex"
}, (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column"
}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "column"
}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row"
}), $8b9aba2ed88130ce$var$_obj));
var $8b9aba2ed88130ce$var$_obj1;
var $8b9aba2ed88130ce$var$PromiseText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($8b9aba2ed88130ce$var$_obj1 = {}, (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flex: 7
}), $8b9aba2ed88130ce$var$_obj1));
var $8b9aba2ed88130ce$var$_obj2;
var $8b9aba2ed88130ce$var$PromiseImageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($8b9aba2ed88130ce$var$_obj2 = {}, (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj2, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    textAlign: "center",
    padding: "2rem"
}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj2, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    textAlign: "center",
    padding: "2rem"
}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj2, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flex: 1,
    width: 250
}), $8b9aba2ed88130ce$var$_obj2));
var $8b9aba2ed88130ce$var$_obj3;
var $8b9aba2ed88130ce$var$PromiseImage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img(($8b9aba2ed88130ce$var$_obj3 = {}, (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj3, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    // shrink image if there's not enough width
    maxWidth: "100%",
    height: "auto"
}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj3, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    // shrink image if there's not enough width
    maxWidth: "100%",
    height: "auto"
}), (0, $8c6ug._)($8b9aba2ed88130ce$var$_obj3, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {}), $8b9aba2ed88130ce$var$_obj3));






var $da8977d24f633871$export$ba10d77b5bfec263 = /*#__PURE__*/ function(ILRState) {
    ILRState["Found"] = "found";
    ILRState["Expired"] = "expired";
    ILRState["Declined"] = "declined";
    ILRState["Progressing"] = "progressing";
    ILRState["Completed"] = "completed";
    ILRState["Cancelled"] = "cancelled";
    return ILRState;
}({});



var $6mdMa = parcelRequire("6mdMa");










parcelRequire("hAGkE");

function $773258ddbd55ac8e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #fbbb5b;\n  border-radius: 16px;\n  padding: 16px;\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  label {\n    cursor: pointer;\n  }\n"
    ]);
    $773258ddbd55ac8e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $773258ddbd55ac8e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 8px;\n  border: 1px solid #000928;\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px;\n  align-self: stretch;\n\n  :has(input:checked) {\n    background: #000928;\n    color: white;\n  }\n"
    ]);
    $773258ddbd55ac8e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $773258ddbd55ac8e$var$CompletionDateCard = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($773258ddbd55ac8e$var$_templateObject());
var $773258ddbd55ac8e$var$CheckboxContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($773258ddbd55ac8e$var$_templateObject1());
var $773258ddbd55ac8e$export$b6e9cf2c5033f2e8 = function(param) {
    var children = param.children, showWarning = param.showWarning, onChange = param.onChange, checked = param.checked;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: showWarning ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($773258ddbd55ac8e$var$CompletionDateWarningWrapper, {
            checked: checked,
            onChange: onChange,
            children: children
        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: children
        })
    });
};
var $773258ddbd55ac8e$var$StrongText = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
        weight: 600,
        children: children
    });
};
var $773258ddbd55ac8e$var$CompletionDateWarningWrapper = function(param) {
    var children = param.children, checked = param.checked, onChange = param.onChange;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($773258ddbd55ac8e$var$CompletionDateCard, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                weight: 600,
                children: "What to consider before proceeding:"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($773258ddbd55ac8e$var$StrongText, {
                        children: "Exchange:"
                    }),
                    " Switching is not possible if you have already exchanged contracts"
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($773258ddbd55ac8e$var$StrongText, {
                        children: "Withdrawal:"
                    }),
                    " Your current Mortgage Offer may be withdrawn to process this"
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($773258ddbd55ac8e$var$StrongText, {
                        children: "Credit:"
                    }),
                    " A new credit search may be required"
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($773258ddbd55ac8e$var$CheckboxContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f294cc4c227dd6d2$export$6cb1578e30bfa58d), {
                    onChange: onChange,
                    checked: checked,
                    id: "checkbox-completion-date-warning",
                    children: "I understand these risks and wish to proceed"
                })
            }),
            children
        ]
    });
};



var $hAGkE = parcelRequire("hAGkE");





parcelRequire("hAGkE");


var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");
// src/primitive.tsx
var $346a57b4a559cf1e$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $346a57b4a559cf1e$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_checkForDefaultPrevented = _ref.checkForDefaultPrevented, checkForDefaultPrevented = _ref_checkForDefaultPrevented === void 0 ? true : _ref_checkForDefaultPrevented;
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}
function $346a57b4a559cf1e$export$f21a1ffae260145a(element) {
    var _element_ownerDocument;
    if (!$346a57b4a559cf1e$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    var _element_ownerDocument_defaultView;
    return (_element_ownerDocument_defaultView = element === null || element === void 0 ? void 0 : (_element_ownerDocument = element.ownerDocument) === null || _element_ownerDocument === void 0 ? void 0 : _element_ownerDocument.defaultView) !== null && _element_ownerDocument_defaultView !== void 0 ? _element_ownerDocument_defaultView : window;
}
function $346a57b4a559cf1e$export$b204af158042fbac(element) {
    if (!$346a57b4a559cf1e$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    var _element_ownerDocument;
    return (_element_ownerDocument = element === null || element === void 0 ? void 0 : element.ownerDocument) !== null && _element_ownerDocument !== void 0 ? _element_ownerDocument : document;
}
function $346a57b4a559cf1e$export$cd4e5573fbe2b576(node) {
    var activeDescendant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var activeElement = $346a57b4a559cf1e$export$b204af158042fbac(node).activeElement;
    if (!(activeElement === null || activeElement === void 0 ? void 0 : activeElement.nodeName)) return null;
    if ($346a57b4a559cf1e$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $346a57b4a559cf1e$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        var id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            var element = $346a57b4a559cf1e$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $346a57b4a559cf1e$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}


// packages/react/compose-refs/src/compose-refs.tsx

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");
function $ce403a1eed6e1cd1$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $ce403a1eed6e1cd1$export$43e446d32b3d21af() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        var hasCleanup = false;
        var cleanups = refs.map(function(ref) {
            var cleanup = $ce403a1eed6e1cd1$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return function() {
            for(var i = 0; i < cleanups.length; i++){
                var cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $ce403a1eed6e1cd1$var$setRef(refs[i], null);
            }
        };
    };
}
function $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return $hAGkE.useCallback($ce403a1eed6e1cd1$export$43e446d32b3d21af.apply(void 0, (0, $bOqL7._)(refs)), refs);
}


// packages/react/context/src/create-context.tsx

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");

function $4670a5dc969b533a$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    var Context = $hAGkE.createContext(defaultContext);
    var Provider = function(props) {
        var children = props.children, context = (0, $c4wKO._)(props, [
            "children"
        ]);
        var value = $hAGkE.useMemo(function() {
            return context;
        }, Object.values(context));
        return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        var context = $hAGkE.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }
    return [
        Provider,
        useContext2
    ];
}
function $4670a5dc969b533a$export$50c7b4e9d9f19c1(scopeName) {
    var createContextScopeDeps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        var BaseContext = $hAGkE.createContext(defaultContext);
        var index = defaultContexts.length;
        defaultContexts = (0, $bOqL7._)(defaultContexts).concat([
            defaultContext
        ]);
        var Provider = function(props) {
            var _scope_scopeName;
            var scope = props.scope, children = props.children, context = (0, $c4wKO._)(props, [
                "scope",
                "children"
            ]);
            var Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            var value = $hAGkE.useMemo(function() {
                return context;
            }, Object.values(context));
            return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            var _scope_scopeName;
            var Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            var context = $hAGkE.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
        }
        return [
            Provider,
            useContext2
        ];
    }
    var createScope = function() {
        var scopeContexts = defaultContexts.map(function(defaultContext) {
            return $hAGkE.createContext(defaultContext);
        });
        return function useScope(scope) {
            var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $hAGkE.useMemo(function() {
                return (0, $8c6ug._)({}, "__scope".concat(scopeName), (0, $7XD9P._)((0, $hRCmZ._)({}, scope), (0, $8c6ug._)({}, scopeName, contexts)));
            }, [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $4670a5dc969b533a$var$composeContextScopes.apply(void 0, [
            createScope
        ].concat((0, $bOqL7._)(createContextScopeDeps)))
    ];
}
function $4670a5dc969b533a$var$composeContextScopes() {
    for(var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++){
        scopes[_key] = arguments[_key];
    }
    var baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    var createScope = function() {
        var scopeHooks = scopes.map(function(createScope2) {
            return {
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            };
        });
        return function useComposedScopes(overrideScopes) {
            var nextScopes = scopeHooks.reduce(function(nextScopes2, param) {
                var useScope = param.useScope, scopeName = param.scopeName;
                var scopeProps = useScope(overrideScopes);
                var currentScope = scopeProps["__scope".concat(scopeName)];
                return (0, $hRCmZ._)({}, nextScopes2, currentScope);
            }, {});
            return $hAGkE.useMemo(function() {
                return (0, $8c6ug._)({}, "__scope".concat(baseScope.scopeName), nextScopes);
            }, [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");

// src/primitive.tsx

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $hAGkE = parcelRequire("hAGkE");

// src/slot.tsx

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");


// @__NO_SIDE_EFFECTS__
function $d0a99442aed2f3a2$export$e88b45bda5c13eb9(ownerName) {
    var SlotClone = /* @__PURE__ */ $d0a99442aed2f3a2$var$createSlotClone(ownerName);
    var Slot2 = $hAGkE.forwardRef(function(props, forwardedRef) {
        var children = props.children, slotProps = (0, $c4wKO._)(props, [
            "children"
        ]);
        var childrenArray = $hAGkE.Children.toArray(children);
        var slottable = childrenArray.find($d0a99442aed2f3a2$var$isSlottable);
        if (slottable) {
            var newElement = slottable.props.children;
            var newChildren = childrenArray.map(function(child) {
                if (child === slottable) {
                    if ($hAGkE.Children.count(newElement) > 1) return $hAGkE.Children.only(null);
                    return $hAGkE.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)(SlotClone, (0, $7XD9P._)((0, $hRCmZ._)({}, slotProps), {
                ref: forwardedRef,
                children: $hAGkE.isValidElement(newElement) ? $hAGkE.cloneElement(newElement, void 0, newChildren) : null
            }));
        }
        return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)(SlotClone, (0, $7XD9P._)((0, $hRCmZ._)({}, slotProps), {
            ref: forwardedRef,
            children: children
        }));
    });
    Slot2.displayName = "".concat(ownerName, ".Slot");
    return Slot2;
}
var $d0a99442aed2f3a2$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $d0a99442aed2f3a2$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $d0a99442aed2f3a2$var$createSlotClone(ownerName) {
    var SlotClone = $hAGkE.forwardRef(function(props, forwardedRef) {
        var children = props.children, slotProps = (0, $c4wKO._)(props, [
            "children"
        ]);
        if ($hAGkE.isValidElement(children)) {
            var childrenRef = $d0a99442aed2f3a2$var$getElementRef(children);
            var props2 = $d0a99442aed2f3a2$var$mergeProps(slotProps, children.props);
            if (children.type !== $hAGkE.Fragment) props2.ref = forwardedRef ? (0, $ce403a1eed6e1cd1$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $hAGkE.cloneElement(children, props2);
        }
        return $hAGkE.Children.count(children) > 1 ? $hAGkE.Children.only(null) : null;
    });
    SlotClone.displayName = "".concat(ownerName, ".SlotClone");
    return SlotClone;
}
var $d0a99442aed2f3a2$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $d0a99442aed2f3a2$export$bf68c29d8281d0f7(ownerName) {
    var Slottable2 = function(param) {
        var children = param.children;
        return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = "".concat(ownerName, ".Slottable");
    Slottable2.__radixId = $d0a99442aed2f3a2$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $d0a99442aed2f3a2$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $d0a99442aed2f3a2$export$bf68c29d8281d0f7("Slottable");
function $d0a99442aed2f3a2$var$isSlottable(child) {
    return $hAGkE.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $d0a99442aed2f3a2$var$SLOTTABLE_IDENTIFIER;
}
function $d0a99442aed2f3a2$var$mergeProps(slotProps, childProps) {
    var _loop = function(propName) {
        var slotPropValue = slotProps[propName];
        var childPropValue = childProps[propName];
        var isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var result = childPropValue.apply(void 0, (0, $bOqL7._)(args));
                slotPropValue.apply(void 0, (0, $bOqL7._)(args));
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = (0, $hRCmZ._)({}, slotPropValue, childPropValue);
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    };
    var overrideProps = (0, $hRCmZ._)({}, childProps);
    for(var propName in childProps)_loop(propName);
    return (0, $hRCmZ._)({}, slotProps, overrideProps);
}
function $d0a99442aed2f3a2$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    var getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    var mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



var $96f2b5598960bdee$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $96f2b5598960bdee$export$250ffa63cdc0d034 = $96f2b5598960bdee$var$NODES.reduce(function(primitive, node) {
    var Slot = (0, $d0a99442aed2f3a2$export$e88b45bda5c13eb9)("Primitive.".concat(node));
    var Node = $hAGkE.forwardRef(function(props, forwardedRef) {
        var asChild = props.asChild, primitiveProps = (0, $c4wKO._)(props, [
            "asChild"
        ]);
        var Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol["for"]("radix-ui")] = true;
        return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)(Comp, (0, $7XD9P._)((0, $hRCmZ._)({}, primitiveProps), {
            ref: forwardedRef
        }));
    });
    Node.displayName = "Primitive.".concat(node);
    return (0, $7XD9P._)((0, $hRCmZ._)({}, primitive), (0, $8c6ug._)({}, node, Node));
}, {});
function $96f2b5598960bdee$export$6d1a0317bde7de7f(target, event) {
    if (target) $0048b1b41b30e47d$exports.flushSync(function() {
        return target.dispatchEvent(event);
    });
}
var $96f2b5598960bdee$export$be92b6f5f03c0fe9 = $96f2b5598960bdee$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/use-callback-ref.tsx

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");
function $f773fadc836f6bf2$export$25bec8c6f54ee79a(callback) {
    var callbackRef = $hAGkE.useRef(callback);
    $hAGkE.useEffect(function() {
        callbackRef.current = callback;
    });
    return $hAGkE.useMemo(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _callbackRef_current;
            var _callbackRef_current1;
            return (_callbackRef_current1 = callbackRef.current) === null || _callbackRef_current1 === void 0 ? void 0 : (_callbackRef_current = _callbackRef_current1).call.apply(_callbackRef_current, [
                callbackRef
            ].concat((0, $bOqL7._)(args)));
        };
    }, []);
}


// packages/react/use-escape-keydown/src/use-escape-keydown.tsx

var $hAGkE = parcelRequire("hAGkE");

function $c1beb00a7ecd13b8$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        var _globalThis;
        return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    }();
    var onEscapeKeyDown = (0, $f773fadc836f6bf2$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $hAGkE.useEffect(function() {
        var handleKeyDown = function(event) {
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return function() {
            return ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
        };
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $42e76fd3f2bde910$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $42e76fd3f2bde910$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $42e76fd3f2bde910$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $42e76fd3f2bde910$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $42e76fd3f2bde910$var$originalBodyPointerEvents;
var $42e76fd3f2bde910$var$DismissableLayerContext = $hAGkE.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $42e76fd3f2bde910$export$177fb62ff3ec1f22 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var _globalThis;
    var _props_disableOutsidePointerEvents = props.disableOutsidePointerEvents, disableOutsidePointerEvents = _props_disableOutsidePointerEvents === void 0 ? false : _props_disableOutsidePointerEvents, onEscapeKeyDown = props.onEscapeKeyDown, onPointerDownOutside = props.onPointerDownOutside, onFocusOutside = props.onFocusOutside, onInteractOutside = props.onInteractOutside, onDismiss = props.onDismiss, layerProps = (0, $c4wKO._)(props, [
        "disableOutsidePointerEvents",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside",
        "onDismiss"
    ]);
    var context = $hAGkE.useContext($42e76fd3f2bde910$var$DismissableLayerContext);
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(null), 2), node = _React_useState[0], setNode = _React_useState[1];
    var _node_ownerDocument;
    var ownerDocument = (_node_ownerDocument = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _node_ownerDocument !== void 0 ? _node_ownerDocument : (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    var _React_useState1 = (0, $6mdMa._)($hAGkE.useState({}), 2), force = _React_useState1[1];
    var composedRefs = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, function(node2) {
        return setNode(node2);
    });
    var layers = Array.from(context.layers);
    var _to_consumable_array_slice = (0, $6mdMa._)((0, $bOqL7._)(context.layersWithOutsidePointerEventsDisabled).slice(-1), 1), highestLayerWithOutsidePointerEventsDisabled = _to_consumable_array_slice[0];
    var highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    var index = node ? layers.indexOf(node) : -1;
    var isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    var isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    var pointerDownOutside = $42e76fd3f2bde910$var$usePointerDownOutside(function(event) {
        var target = event.target;
        var isPointerDownOnBranch = (0, $bOqL7._)(context.branches).some(function(branch) {
            return branch.contains(target);
        });
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 ? void 0 : onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    var focusOutside = $42e76fd3f2bde910$var$useFocusOutside(function(event) {
        var target = event.target;
        var isFocusInBranch = (0, $bOqL7._)(context.branches).some(function(branch) {
            return branch.contains(target);
        });
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 ? void 0 : onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    (0, $c1beb00a7ecd13b8$export$3a72a57244d6e765)(function(event) {
        var isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 ? void 0 : onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $hAGkE.useEffect(function() {
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $42e76fd3f2bde910$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $42e76fd3f2bde910$var$dispatchUpdate();
        return function() {
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $42e76fd3f2bde910$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $hAGkE.useEffect(function() {
        return function() {
            if (!node) return;
            context.layers["delete"](node);
            context.layersWithOutsidePointerEventsDisabled["delete"](node);
            $42e76fd3f2bde910$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $hAGkE.useEffect(function() {
        var handleUpdate = function() {
            return force({});
        };
        document.addEventListener($42e76fd3f2bde910$var$CONTEXT_UPDATE, handleUpdate);
        return function() {
            return document.removeEventListener($42e76fd3f2bde910$var$CONTEXT_UPDATE, handleUpdate);
        };
    }, []);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).div, (0, $7XD9P._)((0, $hRCmZ._)({}, layerProps), {
        ref: composedRefs,
        style: (0, $hRCmZ._)({
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0
        }, props.style),
        onFocusCapture: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
$42e76fd3f2bde910$export$177fb62ff3ec1f22.displayName = $42e76fd3f2bde910$var$DISMISSABLE_LAYER_NAME;
var $42e76fd3f2bde910$var$BRANCH_NAME = "DismissableLayerBranch";
var $42e76fd3f2bde910$export$4d5eb2109db14228 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var context = $hAGkE.useContext($42e76fd3f2bde910$var$DismissableLayerContext);
    var ref = $hAGkE.useRef(null);
    var composedRefs = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $hAGkE.useEffect(function() {
        var node = ref.current;
        if (node) {
            context.branches.add(node);
            return function() {
                context.branches["delete"](node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).div, (0, $7XD9P._)((0, $hRCmZ._)({}, props), {
        ref: composedRefs
    }));
});
$42e76fd3f2bde910$export$4d5eb2109db14228.displayName = $42e76fd3f2bde910$var$BRANCH_NAME;
function $42e76fd3f2bde910$var$usePointerDownOutside(onPointerDownOutside) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        var _globalThis;
        return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    }();
    var handlePointerDownOutside = (0, $f773fadc836f6bf2$export$25bec8c6f54ee79a)(onPointerDownOutside);
    var isPointerInsideReactTreeRef = $hAGkE.useRef(false);
    var handleClickRef = $hAGkE.useRef(function() {});
    $hAGkE.useEffect(function() {
        var handlePointerDown = function(event) {
            if (event.target && !isPointerInsideReactTreeRef.current) {
                var handleAndDispatchPointerDownOutsideEvent2 = function handleAndDispatchPointerDownOutsideEvent2() {
                    $42e76fd3f2bde910$var$handleAndDispatchCustomEvent($42e76fd3f2bde910$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                var eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        var timerId = window.setTimeout(function() {
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return function() {
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: function() {
            return isPointerInsideReactTreeRef.current = true;
        }
    };
}
function $42e76fd3f2bde910$var$useFocusOutside(onFocusOutside) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        var _globalThis;
        return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    }();
    var handleFocusOutside = (0, $f773fadc836f6bf2$export$25bec8c6f54ee79a)(onFocusOutside);
    var isFocusInsideReactTreeRef = $hAGkE.useRef(false);
    $hAGkE.useEffect(function() {
        var handleFocus = function(event) {
            if (event.target && !isFocusInsideReactTreeRef.current) {
                var eventDetail = {
                    originalEvent: event
                };
                $42e76fd3f2bde910$var$handleAndDispatchCustomEvent($42e76fd3f2bde910$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return function() {
            return ownerDocument.removeEventListener("focusin", handleFocus);
        };
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: function() {
            return isFocusInsideReactTreeRef.current = true;
        },
        onBlurCapture: function() {
            return isFocusInsideReactTreeRef.current = false;
        }
    };
}
function $42e76fd3f2bde910$var$dispatchUpdate() {
    var event = new CustomEvent($42e76fd3f2bde910$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $42e76fd3f2bde910$var$handleAndDispatchCustomEvent(name, handler, detail, param) {
    var discrete = param.discrete;
    var target = detail.originalEvent.target;
    var event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $96f2b5598960bdee$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $42e76fd3f2bde910$export$be92b6f5f03c0fe9 = $42e76fd3f2bde910$export$177fb62ff3ec1f22;
var $42e76fd3f2bde910$export$aecb2ddcb55c95be = $42e76fd3f2bde910$export$4d5eb2109db14228;



var $hAGkE = parcelRequire("hAGkE");
"use client";
var $a395a5f75d924d0a$var$count = 0;
function $a395a5f75d924d0a$export$ac5b58043b79449b(props) {
    $a395a5f75d924d0a$export$b7ece24a22aeda8c();
    return props.children;
}
function $a395a5f75d924d0a$export$b7ece24a22aeda8c() {
    $hAGkE.useEffect(function() {
        var edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        var _edgeGuards_;
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards_ = edgeGuards[0]) !== null && _edgeGuards_ !== void 0 ? _edgeGuards_ : $a395a5f75d924d0a$var$createFocusGuard());
        var _edgeGuards_1;
        document.body.insertAdjacentElement("beforeend", (_edgeGuards_1 = edgeGuards[1]) !== null && _edgeGuards_1 !== void 0 ? _edgeGuards_1 : $a395a5f75d924d0a$var$createFocusGuard());
        $a395a5f75d924d0a$var$count++;
        return function() {
            if ($a395a5f75d924d0a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(function(node) {
                return node.remove();
            });
            $a395a5f75d924d0a$var$count--;
        };
    }, []);
}
function $a395a5f75d924d0a$var$createFocusGuard() {
    var element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");




"use client";
var $b193f55f2ffa347d$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $b193f55f2ffa347d$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $b193f55f2ffa347d$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $b193f55f2ffa347d$var$FOCUS_SCOPE_NAME = "FocusScope";
var $b193f55f2ffa347d$export$20e40289641fbbb6 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var _props_loop = props.loop, loop = _props_loop === void 0 ? false : _props_loop, _props_trapped = props.trapped, trapped = _props_trapped === void 0 ? false : _props_trapped, onMountAutoFocusProp = props.onMountAutoFocus, onUnmountAutoFocusProp = props.onUnmountAutoFocus, scopeProps = (0, $c4wKO._)(props, [
        "loop",
        "trapped",
        "onMountAutoFocus",
        "onUnmountAutoFocus"
    ]);
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(null), 2), container = _React_useState[0], setContainer = _React_useState[1];
    var onMountAutoFocus = (0, $f773fadc836f6bf2$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    var onUnmountAutoFocus = (0, $f773fadc836f6bf2$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    var lastFocusedElementRef = $hAGkE.useRef(null);
    var composedRefs = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setContainer(node);
    });
    var focusScope = $hAGkE.useRef({
        paused: false,
        pause: function() {
            this.paused = true;
        },
        resume: function() {
            this.paused = false;
        }
    }).current;
    $hAGkE.useEffect(function() {
        if (trapped) {
            var handleFocusIn2 = function handleFocusIn2(event) {
                if (focusScope.paused || !container) return;
                var target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $b193f55f2ffa347d$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function handleFocusOut2(event) {
                if (focusScope.paused || !container) return;
                var relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $b193f55f2ffa347d$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function handleMutations2(mutations) {
                var focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        if (mutation.removedNodes.length > 0) $b193f55f2ffa347d$var$focus(container);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            var mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return function() {
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $hAGkE.useEffect(function() {
        if (container) {
            $b193f55f2ffa347d$var$focusScopesStack.add(focusScope);
            var previouslyFocusedElement = document.activeElement;
            var hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                var mountEvent = new CustomEvent($b193f55f2ffa347d$var$AUTOFOCUS_ON_MOUNT, $b193f55f2ffa347d$var$EVENT_OPTIONS);
                container.addEventListener($b193f55f2ffa347d$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $b193f55f2ffa347d$var$focusFirst($b193f55f2ffa347d$var$removeLinks($b193f55f2ffa347d$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $b193f55f2ffa347d$var$focus(container);
                }
            }
            return function() {
                container.removeEventListener($b193f55f2ffa347d$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(function() {
                    var unmountEvent = new CustomEvent($b193f55f2ffa347d$var$AUTOFOCUS_ON_UNMOUNT, $b193f55f2ffa347d$var$EVENT_OPTIONS);
                    container.addEventListener($b193f55f2ffa347d$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $b193f55f2ffa347d$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    container.removeEventListener($b193f55f2ffa347d$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $b193f55f2ffa347d$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    var handleKeyDown = $hAGkE.useCallback(function(event) {
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        var isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        var focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            var container2 = event.currentTarget;
            var _getTabbableEdges = (0, $6mdMa._)($b193f55f2ffa347d$var$getTabbableEdges(container2), 2), first = _getTabbableEdges[0], last = _getTabbableEdges[1];
            var hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $b193f55f2ffa347d$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $b193f55f2ffa347d$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).div, (0, $7XD9P._)((0, $hRCmZ._)({
        tabIndex: -1
    }, scopeProps), {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
$b193f55f2ffa347d$export$20e40289641fbbb6.displayName = $b193f55f2ffa347d$var$FOCUS_SCOPE_NAME;
function $b193f55f2ffa347d$var$focusFirst(candidates) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_select = _ref.select, select = _ref_select === void 0 ? false : _ref_select;
    var previouslyFocusedElement = document.activeElement;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            $b193f55f2ffa347d$var$focus(candidate, {
                select: select
            });
            if (document.activeElement !== previouslyFocusedElement) return;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $b193f55f2ffa347d$var$getTabbableEdges(container) {
    var candidates = $b193f55f2ffa347d$var$getTabbableCandidates(container);
    var first = $b193f55f2ffa347d$var$findVisible(candidates, container);
    var last = $b193f55f2ffa347d$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $b193f55f2ffa347d$var$getTabbableCandidates(container) {
    var nodes = [];
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $b193f55f2ffa347d$var$findVisible(elements, container) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (!$b193f55f2ffa347d$var$isHidden(element, {
                upTo: container
            })) return element;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $b193f55f2ffa347d$var$isHidden(node, param) {
    var upTo = param.upTo;
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $b193f55f2ffa347d$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $b193f55f2ffa347d$var$focus(element) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_select = _ref.select, select = _ref_select === void 0 ? false : _ref_select;
    if (element && element.focus) {
        var previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $b193f55f2ffa347d$var$isSelectableInput(element) && select) element.select();
    }
}
var $b193f55f2ffa347d$var$focusScopesStack = $b193f55f2ffa347d$var$createFocusScopesStack();
function $b193f55f2ffa347d$var$createFocusScopesStack() {
    var stack = [];
    return {
        add: function(focusScope) {
            var activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
            stack = $b193f55f2ffa347d$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove: function(focusScope) {
            var _stack_;
            stack = $b193f55f2ffa347d$var$arrayRemove(stack, focusScope);
            (_stack_ = stack[0]) === null || _stack_ === void 0 ? void 0 : _stack_.resume();
        }
    };
}
function $b193f55f2ffa347d$var$arrayRemove(array, item) {
    var updatedArray = (0, $bOqL7._)(array);
    var index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $b193f55f2ffa347d$var$removeLinks(items) {
    return items.filter(function(item) {
        return item.tagName !== "A";
    });
}
var $b193f55f2ffa347d$export$be92b6f5f03c0fe9 = $b193f55f2ffa347d$export$20e40289641fbbb6;


// packages/react/id/src/id.tsx

var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var $hAGkE = parcelRequire("hAGkE");
var $0a23b28cec99f7f5$var$_globalThis;
var $0a23b28cec99f7f5$export$e5c5a5f917a5871c = (($0a23b28cec99f7f5$var$_globalThis = globalThis) === null || $0a23b28cec99f7f5$var$_globalThis === void 0 ? void 0 : $0a23b28cec99f7f5$var$_globalThis.document) ? $hAGkE.useLayoutEffect : function() {};


var $814d0d49706f1163$var$useReactId = $hAGkE[" useId ".trim().toString()] || function() {
    return void 0;
};
var $814d0d49706f1163$var$count = 0;
function $814d0d49706f1163$export$f680877a34711e37(deterministicId) {
    var _React_useState = (0, $6mdMa._)($hAGkE.useState($814d0d49706f1163$var$useReactId()), 2), id = _React_useState[0], setId = _React_useState[1];
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        if (!deterministicId) setId(function(reactId) {
            return reactId !== null && reactId !== void 0 ? reactId : String($814d0d49706f1163$var$count++);
        });
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? "radix-".concat(id) : "");
}



var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $2xTNA = parcelRequire("2xTNA");

var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $dMrZK = parcelRequire("dMrZK");

var $iNemB = parcelRequire("iNemB");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");

var $dMrZK = parcelRequire("dMrZK");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var $6b1126e8f7895c6a$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
var $6b1126e8f7895c6a$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
var $6b1126e8f7895c6a$export$803cd8101b6c182b = /*#__PURE__*/ $6b1126e8f7895c6a$export$832b6fa47fa053d2.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + $6b1126e8f7895c6a$export$27b07d8a310ed8b5[0], side + "-" + $6b1126e8f7895c6a$export$27b07d8a310ed8b5[1]);
}, []);
var $6b1126e8f7895c6a$export$96ec731ed4dcb222 = Math.min;
var $6b1126e8f7895c6a$export$8960430cfd85939f = Math.max;
var $6b1126e8f7895c6a$export$2077e0241d6afd3c = Math.round;
var $6b1126e8f7895c6a$export$a3fe094919f356fd = Math.floor;
var $6b1126e8f7895c6a$export$a397704b5e280835 = function(v) {
    return {
        x: v,
        y: v
    };
};
var $6b1126e8f7895c6a$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $6b1126e8f7895c6a$export$7d15b64cf5a3a4c4(start, value, end) {
    return $6b1126e8f7895c6a$export$8960430cfd85939f(start, $6b1126e8f7895c6a$export$96ec731ed4dcb222(value, end));
}
function $6b1126e8f7895c6a$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $6b1126e8f7895c6a$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $6b1126e8f7895c6a$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $6b1126e8f7895c6a$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $6b1126e8f7895c6a$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $6b1126e8f7895c6a$export$f28e8f882010718a(placement) {
    var firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $6b1126e8f7895c6a$export$2b57e0052a6d6d4c(placement) {
    return $6b1126e8f7895c6a$export$8a000a963141ac32($6b1126e8f7895c6a$export$f28e8f882010718a(placement));
}
function $6b1126e8f7895c6a$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = $6b1126e8f7895c6a$export$f0989780f32bfcda(placement);
    var alignmentAxis = $6b1126e8f7895c6a$export$2b57e0052a6d6d4c(placement);
    var length = $6b1126e8f7895c6a$export$320bd9d53520c68a(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $6b1126e8f7895c6a$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $6b1126e8f7895c6a$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $6b1126e8f7895c6a$export$496432a3699e50b1(placement) {
    var oppositePlacement = $6b1126e8f7895c6a$export$9c5e28bad23365fa(placement);
    return [
        $6b1126e8f7895c6a$export$2b182c584985588b(placement),
        oppositePlacement,
        $6b1126e8f7895c6a$export$2b182c584985588b(oppositePlacement)
    ];
}
function $6b1126e8f7895c6a$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
var $6b1126e8f7895c6a$var$lrPlacement = [
    'left',
    'right'
];
var $6b1126e8f7895c6a$var$rlPlacement = [
    'right',
    'left'
];
var $6b1126e8f7895c6a$var$tbPlacement = [
    'top',
    'bottom'
];
var $6b1126e8f7895c6a$var$btPlacement = [
    'bottom',
    'top'
];
function $6b1126e8f7895c6a$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $6b1126e8f7895c6a$var$rlPlacement : $6b1126e8f7895c6a$var$lrPlacement;
            return isStart ? $6b1126e8f7895c6a$var$lrPlacement : $6b1126e8f7895c6a$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $6b1126e8f7895c6a$var$tbPlacement : $6b1126e8f7895c6a$var$btPlacement;
        default:
            return [];
    }
}
function $6b1126e8f7895c6a$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    var alignment = $6b1126e8f7895c6a$export$f0989780f32bfcda(placement);
    var list = $6b1126e8f7895c6a$var$getSideList($6b1126e8f7895c6a$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map($6b1126e8f7895c6a$export$2b182c584985588b));
    }
    return list;
}
function $6b1126e8f7895c6a$export$9c5e28bad23365fa(placement) {
    var side = $6b1126e8f7895c6a$export$3c915306cb7fc97a(placement);
    return $6b1126e8f7895c6a$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $6b1126e8f7895c6a$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $6b1126e8f7895c6a$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $6b1126e8f7895c6a$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $6b1126e8f7895c6a$export$ee05aea0aeecbad4(rect) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $01098fb7723b8226$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(placement);
    var alignmentAxis = (0, $6b1126e8f7895c6a$export$2b57e0052a6d6d4c)(placement);
    var alignLength = (0, $6b1126e8f7895c6a$export$320bd9d53520c68a)(alignmentAxis);
    var side = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement);
    var isVertical = sideAxis === 'y';
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    var alignment = (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ function $01098fb7723b8226$export$37b6bde19b108ecc(state, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? 'clippingAncestors' : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? 'viewport' : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? 'floating' : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, $6b1126e8f7895c6a$export$598c291c29bc2e71)(padding);
                    altContext = elementContext === 'floating' ? 'reference' : 'floating';
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === 'floating' ? {
                        x: x,
                        y: y,
                        width: rects.floating.width,
                        height: rects.floating.height
                    } : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    _tmp3 = _state.sent();
                    if (!_tmp3) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent();
                    _state.label = 10;
                case 10:
                    offsetScale = _tmp3 || {
                        x: 1,
                        y: 1
                    };
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements: elements,
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 11:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 12:
                    _tmp4 = rect;
                    _state.label = 13;
                case 13:
                    elementClientRect = (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    })();
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
var $01098fb7723b8226$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var $01098fb7723b8226$export$48a53dcb22e581d0 = function(reference, floating, config) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, platformWithDetectOverflow, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, resetCount, middlewareData, i, currentMiddleware, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? 'bottom' : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? 'absolute' : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    platformWithDetectOverflow = platform.detectOverflow ? platform : (0, $7XD9P._)((0, $hRCmZ._)({}, platform), {
                        detectOverflow: $01098fb7723b8226$export$37b6bde19b108ecc
                    });
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = $01098fb7723b8226$var$computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    resetCount = 0;
                    middlewareData = {};
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < middleware.length)) return [
                        3,
                        11
                    ];
                    currentMiddleware = middleware[i];
                    if (!currentMiddleware) return [
                        3,
                        10
                    ];
                    name = currentMiddleware.name, fn = currentMiddleware.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platformWithDetectOverflow,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData[name] = (0, $hRCmZ._)({}, middlewareData[name], data);
                    if (!(reset && resetCount < $01098fb7723b8226$var$MAX_RESET_COUNT)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!((typeof reset === "undefined" ? "undefined" : (0, $2xTNA._)(reset)) === 'object')) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = $01098fb7723b8226$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    })();
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var $01098fb7723b8226$export$f2120bbfa5450bd2 = function(options) {
    return {
        name: 'arrow',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, $6b1126e8f7895c6a$export$598c291c29bc2e71)(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = (0, $6b1126e8f7895c6a$export$2b57e0052a6d6d4c)(placement);
                            length = (0, $6b1126e8f7895c6a$export$320bd9d53520c68a)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === 'y';
                            minProp = isYAxis ? 'top' : 'left';
                            maxProp = isYAxis ? 'bottom' : 'right';
                            clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, $6b1126e8f7895c6a$export$7d15b64cf5a3a4c4)(minPadding, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, $8c6ug._)(_obj1, axis, coords[axis] + alignmentOffset), (0, $8c6ug._)(_obj1, "data", (0, $hRCmZ._)((_obj = {}, (0, $8c6ug._)(_obj, axis, offset), (0, $8c6ug._)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0, $8c6ug._)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
function $01098fb7723b8226$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, $bOqL7._)(allowedPlacements.filter(function(placement) {
        return (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement) === alignment;
    })).concat((0, $bOqL7._)(allowedPlacements.filter(function(placement) {
        return (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $6b1126e8f7895c6a$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $01098fb7723b8226$export$91fb6ecbd551914 = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, currentIndex, currentPlacement, overflow, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, $6b1126e8f7895c6a$export$803cd8101b6c182b) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, $c4wKO._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, $6b1126e8f7895c6a$export$803cd8101b6c182b) ? $01098fb7723b8226$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, $6b1126e8f7895c6a$export$be42861551f17911).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            currentOverflows = [
                                overflow[(0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, $bOqL7._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $01098fb7723b8226$export$8a83211c878a3f1f = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, ignoreCrossAxisOverflow, resetPlacement, _overflowsData$filter2, placement1;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? 'bestFit' : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? 'none' : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, $c4wKO._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement);
                            initialSideAxis = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(initialPlacement);
                            isBasePlacement = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, $6b1126e8f7895c6a$export$9c5e28bad23365fa)(initialPlacement)
                            ] : (0, $6b1126e8f7895c6a$export$496432a3699e50b1)(initialPlacement));
                            hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, $bOqL7._)((0, $6b1126e8f7895c6a$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, $bOqL7._)(fallbackPlacements));
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, $6b1126e8f7895c6a$export$be42861551f17911)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, $bOqL7._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) {
                                    ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(nextPlacement) : false;
                                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                                    // overflows the main axis.
                                    overflowsData.every(function(d) {
                                        return (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true;
                                    })) // Try next placement and re-run the lifecycle.
                                    return [
                                        2,
                                        {
                                            data: {
                                                index: nextIndex,
                                                overflows: overflowsData
                                            },
                                            reset: {
                                                placement: nextPlacement
                                            }
                                        }
                                    ];
                                }
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case 'bestFit':
                                        {
                                            ;
                                            placement1 = (_overflowsData$filter2 = overflowsData.filter(function(d) {
                                                if (hasFallbackAxisSideDirection) {
                                                    var currentSideAxis = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(d.placement);
                                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                                    // reading directions favoring greater width.
                                                    currentSideAxis === 'y';
                                                }
                                                return true;
                                            }).map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$filter2[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case 'initialPlacement':
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $01098fb7723b8226$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $01098fb7723b8226$var$isAnySideFullyClipped(overflow) {
    return (0, $6b1126e8f7895c6a$export$832b6fa47fa053d2).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $01098fb7723b8226$export$fe8985bb6374093c = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var rects, platform, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, platform = state.platform;
                            _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? 'referenceHidden' : _evaluate_strategy, detectOverflowOptions = (0, $c4wKO._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case 'referenceHidden':
                                    return [
                                        3,
                                        1
                                    ];
                                case 'escaped':
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                platform.detectOverflow(state, (0, $7XD9P._)((0, $hRCmZ._)({}, detectOverflowOptions), {
                                    elementContext: 'reference'
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = $01098fb7723b8226$var$getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: $01098fb7723b8226$var$isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                platform.detectOverflow(state, (0, $7XD9P._)((0, $hRCmZ._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = $01098fb7723b8226$var$getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: $01098fb7723b8226$var$isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function $01098fb7723b8226$var$getBoundingRect(rects) {
    var minX = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222).apply(void 0, (0, $bOqL7._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222).apply(void 0, (0, $bOqL7._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, $6b1126e8f7895c6a$export$8960430cfd85939f).apply(void 0, (0, $bOqL7._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, $6b1126e8f7895c6a$export$8960430cfd85939f).apply(void 0, (0, $bOqL7._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $01098fb7723b8226$var$getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4)($01098fb7723b8226$var$getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $01098fb7723b8226$export$18c8ad048e32c7d5 = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, $6b1126e8f7895c6a$export$f28e8f882010718a)(placement) === 'y') {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement) === 'top';
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            return (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4)({
                                x: left,
                                y: top,
                                width: right - left,
                                height: bottom - top
                            });
                        }
                        var isLeftSide = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement) === 'left';
                        var maxRight = (0, $6b1126e8f7895c6a$export$8960430cfd85939f).apply(void 0, (0, $bOqL7._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222).apply(void 0, (0, $bOqL7._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        return (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4)({
                            x: minLeft,
                            y: top1,
                            width: maxRight - minLeft,
                            height: bottom1 - top1
                        });
                    }
                    return fallback;
                }
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
                            // keep the existing reference rect rather than resetting to an invalid
                            // one with non-finite values.
                            if (!nativeClientRects.length) return [
                                2,
                                {}
                            ];
                            clientRects = $01098fb7723b8226$var$getRectsByLine(nativeClientRects);
                            fallback = (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4)($01098fb7723b8226$var$getBoundingRect(nativeClientRects));
                            paddingObject = (0, $6b1126e8f7895c6a$export$598c291c29bc2e71)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
var $01098fb7723b8226$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
function $01098fb7723b8226$var$convertValueToCoords(state, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement);
                    alignment = (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement);
                    isVertical = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(placement) === 'y';
                    mainAxisMulti = $01098fb7723b8226$var$originSides.has(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state);
                    // eslint-disable-next-line prefer-const
                    _ref = typeof rawValue === 'number' ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : {
                        mainAxis: rawValue.mainAxis || 0,
                        crossAxis: rawValue.crossAxis || 0,
                        alignmentAxis: rawValue.alignmentAxis
                    }, mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    })();
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $01098fb7723b8226$export$cc800923e997bb8 = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                $01098fb7723b8226$var$convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            // If the placement is the same and the arrow caused an alignment offset
                            // then we don't need to change the positioning coordinates.
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0, $7XD9P._)((0, $hRCmZ._)({}, diffCoords), {
                                        placement: placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $01098fb7723b8226$export$fba63a578e423eb = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var x, y, placement, platform, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, clampCoord, _obj, limitedCoords, _obj1;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, platform = state.platform;
                            _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, $c4wKO._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(placement);
                            mainAxis = (0, $6b1126e8f7895c6a$export$8a000a963141ac32)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            clampCoord = function(axis, coord) {
                                return (0, $6b1126e8f7895c6a$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
                            };
                            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
                            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
                            limitedCoords = limiter.fn((0, $7XD9P._)((0, $hRCmZ._)({}, state), (_obj = {}, (0, $8c6ug._)(_obj, mainAxis, mainAxisCoord), (0, $8c6ug._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, $7XD9P._)((0, $hRCmZ._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y,
                                        enabled: (_obj1 = {}, (0, $8c6ug._)(_obj1, mainAxis, checkMainAxis), (0, $8c6ug._)(_obj1, crossAxis, checkCrossAxis), _obj1)
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $01098fb7723b8226$export$7bf07e38f3dc4b69 = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function(state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(placement);
            var mainAxis = (0, $6b1126e8f7895c6a$export$8a000a963141ac32)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(offset, state);
            var computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                var len = mainAxis === 'y' ? 'height' : 'width';
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === 'y' ? 'width' : 'height';
                var isOriginSide = $01098fb7723b8226$var$originSides.has((0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return _obj = {}, (0, $8c6ug._)(_obj, mainAxis, mainAxisCoord), (0, $8c6ug._)(_obj, crossAxis, crossAxisCoord), _obj;
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $01098fb7723b8226$export$346677f925de839c = function size(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, shiftData, noShift, availableHeight, availableWidth, nextDimensions;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $6b1126e8f7895c6a$export$fef61f332f2c0afc)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, $c4wKO._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, $6b1126e8f7895c6a$export$3c915306cb7fc97a)(placement);
                            alignment = (0, $6b1126e8f7895c6a$export$f0989780f32bfcda)(placement);
                            isYAxis = (0, $6b1126e8f7895c6a$export$f28e8f882010718a)(placement) === 'y';
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === 'top' || side === 'bottom')) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? 'start' : 'end') ? 'left' : 'right';
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === 'end' ? 'top' : 'bottom';
                            _state.label = 4;
                        case 4:
                            maximumClippingHeight = height - overflow.top - overflow.bottom;
                            maximumClippingWidth = width - overflow.left - overflow.right;
                            overflowAvailableHeight = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
                            overflowAvailableWidth = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
                            shiftData = state.middlewareData.shift;
                            noShift = !shiftData;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
                            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
                            if (noShift && !alignment) {
                                if (isYAxis) availableWidth = width - 2 * (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(overflow.left, overflow.right);
                                else availableHeight = height - 2 * (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(overflow.top, overflow.bottom);
                            }
                            return [
                                4,
                                apply((0, $7XD9P._)((0, $hRCmZ._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};



function $17f88b67153eebb9$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $17f88b67153eebb9$export$651544f548703224(node) {
    if ($17f88b67153eebb9$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $17f88b67153eebb9$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $17f88b67153eebb9$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($17f88b67153eebb9$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $17f88b67153eebb9$export$8ee0fc9ee280b4ee(value) {
    if (!$17f88b67153eebb9$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $17f88b67153eebb9$export$38b2d434cce3ea22(value).Node;
}
function $17f88b67153eebb9$export$45a5e7f76e0caa8d(value) {
    if (!$17f88b67153eebb9$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $17f88b67153eebb9$export$38b2d434cce3ea22(value).Element;
}
function $17f88b67153eebb9$export$1b3bfaa9684536aa(value) {
    if (!$17f88b67153eebb9$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $17f88b67153eebb9$export$38b2d434cce3ea22(value).HTMLElement;
}
function $17f88b67153eebb9$export$af51f0f06c0f328a(value) {
    if (!$17f88b67153eebb9$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $17f88b67153eebb9$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $17f88b67153eebb9$export$989e911fa9af580a(element) {
    var _getComputedStyle = $17f88b67153eebb9$export$3735103072e4a80(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $17f88b67153eebb9$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($17f88b67153eebb9$export$651544f548703224(element));
}
function $17f88b67153eebb9$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
var $17f88b67153eebb9$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var $17f88b67153eebb9$var$containRe = /paint|layout|strict|content/;
var $17f88b67153eebb9$var$isNotNone = function(value) {
    return !!value && value !== 'none';
};
var $17f88b67153eebb9$var$isWebKitValue;
function $17f88b67153eebb9$export$d6c4e8150c35fed1(elementOrCss) {
    var css = $17f88b67153eebb9$export$45a5e7f76e0caa8d(elementOrCss) ? $17f88b67153eebb9$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $17f88b67153eebb9$var$isNotNone(css.transform) || $17f88b67153eebb9$var$isNotNone(css.translate) || $17f88b67153eebb9$var$isNotNone(css.scale) || $17f88b67153eebb9$var$isNotNone(css.rotate) || $17f88b67153eebb9$var$isNotNone(css.perspective) || !$17f88b67153eebb9$export$78551043582a6a98() && ($17f88b67153eebb9$var$isNotNone(css.backdropFilter) || $17f88b67153eebb9$var$isNotNone(css.filter)) || $17f88b67153eebb9$var$willChangeRe.test(css.willChange || '') || $17f88b67153eebb9$var$containRe.test(css.contain || '');
}
function $17f88b67153eebb9$export$940d8225183e1404(element) {
    var currentNode = $17f88b67153eebb9$export$4e12058fc4d51d56(element);
    while($17f88b67153eebb9$export$1b3bfaa9684536aa(currentNode) && !$17f88b67153eebb9$export$d1162fb0b6d4cd51(currentNode)){
        if ($17f88b67153eebb9$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($17f88b67153eebb9$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $17f88b67153eebb9$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $17f88b67153eebb9$export$78551043582a6a98() {
    if ($17f88b67153eebb9$var$isWebKitValue == null) $17f88b67153eebb9$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $17f88b67153eebb9$var$isWebKitValue;
}
function $17f88b67153eebb9$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($17f88b67153eebb9$export$651544f548703224(node));
}
function $17f88b67153eebb9$export$3735103072e4a80(element) {
    return $17f88b67153eebb9$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $17f88b67153eebb9$export$dc8fc79fa2800137(element) {
    if ($17f88b67153eebb9$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $17f88b67153eebb9$export$4e12058fc4d51d56(node) {
    if ($17f88b67153eebb9$export$651544f548703224(node) === 'html') return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $17f88b67153eebb9$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $17f88b67153eebb9$export$e495491855dc5418(node);
    return $17f88b67153eebb9$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $17f88b67153eebb9$export$7cd01a57c8ca906c(node) {
    var parentNode = $17f88b67153eebb9$export$4e12058fc4d51d56(node);
    if ($17f88b67153eebb9$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($17f88b67153eebb9$export$1b3bfaa9684536aa(parentNode) && $17f88b67153eebb9$export$989e911fa9af580a(parentNode)) return parentNode;
    return $17f88b67153eebb9$export$7cd01a57c8ca906c(parentNode);
}
function $17f88b67153eebb9$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = $17f88b67153eebb9$export$7cd01a57c8ca906c(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = $17f88b67153eebb9$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        var frameElement = $17f88b67153eebb9$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $17f88b67153eebb9$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $17f88b67153eebb9$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $17f88b67153eebb9$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $17f88b67153eebb9$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $4def4ab9f32a2d89$var$getCssDimensions(element) {
    var css = (0, $17f88b67153eebb9$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, $17f88b67153eebb9$export$1b3bfaa9684536aa)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, $6b1126e8f7895c6a$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $6b1126e8f7895c6a$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $4def4ab9f32a2d89$var$unwrapElement(element) {
    return !(0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $4def4ab9f32a2d89$var$getScale(element) {
    var domElement = $4def4ab9f32a2d89$var$unwrapElement(element);
    if (!(0, $17f88b67153eebb9$export$1b3bfaa9684536aa)(domElement)) return (0, $6b1126e8f7895c6a$export$a397704b5e280835)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = $4def4ab9f32a2d89$var$getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, $6b1126e8f7895c6a$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    var y = ($ ? (0, $6b1126e8f7895c6a$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var $4def4ab9f32a2d89$var$noOffsets = /*#__PURE__*/ (0, $6b1126e8f7895c6a$export$a397704b5e280835)(0);
function $4def4ab9f32a2d89$var$getVisualOffsets(element) {
    var win = (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(element);
    if (!(0, $17f88b67153eebb9$export$78551043582a6a98)() || !win.visualViewport) return $4def4ab9f32a2d89$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $4def4ab9f32a2d89$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(element);
}
function $4def4ab9f32a2d89$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = $4def4ab9f32a2d89$var$unwrapElement(element);
    var scale = (0, $6b1126e8f7895c6a$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(offsetParent)) scale = $4def4ab9f32a2d89$var$getScale(offsetParent);
        } else scale = $4def4ab9f32a2d89$var$getScale(element);
    }
    var visualOffsets = $4def4ab9f32a2d89$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $4def4ab9f32a2d89$var$getVisualOffsets(domElement) : (0, $6b1126e8f7895c6a$export$a397704b5e280835)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        var win = (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(domElement);
        var offsetWin = (0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = (0, $17f88b67153eebb9$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            var iframeScale = $4def4ab9f32a2d89$var$getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, $17f88b67153eebb9$export$3735103072e4a80)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $17f88b67153eebb9$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $4def4ab9f32a2d89$var$getWindowScrollBarX(element, rect) {
    var leftScroll = (0, $17f88b67153eebb9$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $4def4ab9f32a2d89$var$getBoundingClientRect((0, $17f88b67153eebb9$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $4def4ab9f32a2d89$var$getHTMLOffset(documentElement, scroll) {
    var htmlRect = documentElement.getBoundingClientRect();
    var x = htmlRect.left + scroll.scrollLeft - $4def4ab9f32a2d89$var$getWindowScrollBarX(documentElement, htmlRect);
    var y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $4def4ab9f32a2d89$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === 'fixed';
    var documentElement = (0, $17f88b67153eebb9$export$e495491855dc5418)(offsetParent);
    var topLayer = elements ? (0, $17f88b67153eebb9$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, $6b1126e8f7895c6a$export$a397704b5e280835)(1);
    var offsets = (0, $6b1126e8f7895c6a$export$a397704b5e280835)(0);
    var isOffsetParentAnElement = (0, $17f88b67153eebb9$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $17f88b67153eebb9$export$651544f548703224)(offsetParent) !== 'body' || (0, $17f88b67153eebb9$export$989e911fa9af580a)(documentElement)) scroll = (0, $17f88b67153eebb9$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = $4def4ab9f32a2d89$var$getBoundingClientRect(offsetParent);
            scale = $4def4ab9f32a2d89$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4def4ab9f32a2d89$var$getHTMLOffset(documentElement, scroll) : (0, $6b1126e8f7895c6a$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $4def4ab9f32a2d89$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $4def4ab9f32a2d89$var$getDocumentRect(html) {
    var scroll = (0, $17f88b67153eebb9$export$dc8fc79fa2800137)(html);
    var body = html.ownerDocument.body;
    var width = (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + $4def4ab9f32a2d89$var$getWindowScrollBarX(html);
    var y = -scroll.scrollTop;
    if ((0, $17f88b67153eebb9$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
var $4def4ab9f32a2d89$var$SCROLLBAR_MAX = 25;
function $4def4ab9f32a2d89$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    var isLayoutViewport = rootBoundary === 'layoutViewport';
    var win = (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(element);
    var html = (0, $17f88b67153eebb9$export$e495491855dc5418)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        var layoutRelativeClientCoords = !(0, $17f88b67153eebb9$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    var windowScrollbarX = $4def4ab9f32a2d89$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        var doc = html.ownerDocument;
        var body = doc.body;
        var bodyStyles = getComputedStyle(body);
        var bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        var reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        var gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $4def4ab9f32a2d89$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $4def4ab9f32a2d89$var$getInnerBoundingClientRect(element, strategy) {
    var clientRect = $4def4ab9f32a2d89$var$getBoundingClientRect(element, true, strategy === 'fixed');
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = $4def4ab9f32a2d89$var$getScale(element);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4def4ab9f32a2d89$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $4def4ab9f32a2d89$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $4def4ab9f32a2d89$var$getDocumentRect((0, $17f88b67153eebb9$export$e495491855dc5418)(element));
    else if ((0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $4def4ab9f32a2d89$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = $4def4ab9f32a2d89$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $6b1126e8f7895c6a$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $4def4ab9f32a2d89$var$getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, $17f88b67153eebb9$export$3b57c1601291186b)(element, [], false).filter(function(el) {
        return (0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(el) && (0, $17f88b67153eebb9$export$651544f548703224)(el) !== 'body';
    });
    var lastKeptComputedStyle = null;
    var elementIsFixed = (0, $17f88b67153eebb9$export$3735103072e4a80)(element).position === 'fixed';
    var currentNode = elementIsFixed ? (0, $17f88b67153eebb9$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(currentNode) && !(0, $17f88b67153eebb9$export$d1162fb0b6d4cd51)(currentNode)){
        var computedStyle = (0, $17f88b67153eebb9$export$3735103072e4a80)(currentNode);
        var currentNodeIsContaining = (0, $17f88b67153eebb9$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        var lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        var shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $17f88b67153eebb9$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $4def4ab9f32a2d89$var$getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $17f88b67153eebb9$export$89e651af02346cd4)(element) ? [] : $4def4ab9f32a2d89$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, $bOqL7._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstRect = $4def4ab9f32a2d89$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    var top = firstRect.top;
    var right = firstRect.right;
    var bottom = firstRect.bottom;
    var left = firstRect.left;
    for(var i = 1; i < clippingAncestors.length; i++){
        var rect = $4def4ab9f32a2d89$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(rect.top, top);
        right = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $4def4ab9f32a2d89$var$getDimensions(element) {
    var _getCssDimensions = $4def4ab9f32a2d89$var$getCssDimensions(element), width = _getCssDimensions.width, height = _getCssDimensions.height;
    return {
        width: width,
        height: height
    };
}
function $4def4ab9f32a2d89$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, $17f88b67153eebb9$export$1b3bfaa9684536aa)(offsetParent);
    var documentElement = (0, $17f88b67153eebb9$export$e495491855dc5418)(offsetParent);
    var isFixed = strategy === 'fixed';
    var rect = $4def4ab9f32a2d89$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, $6b1126e8f7895c6a$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $17f88b67153eebb9$export$651544f548703224)(offsetParent) !== 'body' || (0, $17f88b67153eebb9$export$989e911fa9af580a)(documentElement)) scroll = (0, $17f88b67153eebb9$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = $4def4ab9f32a2d89$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $4def4ab9f32a2d89$var$getWindowScrollBarX(documentElement);
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4def4ab9f32a2d89$var$getHTMLOffset(documentElement, scroll) : (0, $6b1126e8f7895c6a$export$a397704b5e280835)(0);
    var x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    var y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $4def4ab9f32a2d89$var$isStaticPositioned(element) {
    return (0, $17f88b67153eebb9$export$3735103072e4a80)(element).position === 'static';
}
function $4def4ab9f32a2d89$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $17f88b67153eebb9$export$1b3bfaa9684536aa)(element) || (0, $17f88b67153eebb9$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    var rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $17f88b67153eebb9$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $4def4ab9f32a2d89$var$getOffsetParent(element, polyfill) {
    var win = (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(element);
    if ((0, $17f88b67153eebb9$export$89e651af02346cd4)(element)) return win;
    if (!(0, $17f88b67153eebb9$export$1b3bfaa9684536aa)(element)) {
        var svgOffsetParent = (0, $17f88b67153eebb9$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $17f88b67153eebb9$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $17f88b67153eebb9$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$4def4ab9f32a2d89$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $17f88b67153eebb9$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    var offsetParent = $4def4ab9f32a2d89$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $17f88b67153eebb9$export$71535ffaa902797f)(offsetParent) && $4def4ab9f32a2d89$var$isStaticPositioned(offsetParent))offsetParent = $4def4ab9f32a2d89$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $17f88b67153eebb9$export$d1162fb0b6d4cd51)(offsetParent) && $4def4ab9f32a2d89$var$isStaticPositioned(offsetParent) && !(0, $17f88b67153eebb9$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $17f88b67153eebb9$export$940d8225183e1404)(element) || win;
}
var $4def4ab9f32a2d89$var$getElementRects = function getElementRects(data) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var getOffsetParentFn, getDimensionsFn, floatingDimensions, _tmp, _tmp1;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || $4def4ab9f32a2d89$var$getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 1:
                    floatingDimensions = _state.sent();
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.reference = $4def4ab9f32a2d89$var$getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                            _state.sent(),
                            data.strategy
                        ])), _tmp.floating = {
                            x: 0,
                            y: 0,
                            width: floatingDimensions.width,
                            height: floatingDimensions.height
                        }, _tmp)
                    ];
            }
        });
    }).call(this);
};
function $4def4ab9f32a2d89$var$isRTL(element) {
    return (0, $17f88b67153eebb9$export$3735103072e4a80)(element).direction === 'rtl';
}
var $4def4ab9f32a2d89$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $4def4ab9f32a2d89$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, $17f88b67153eebb9$export$e495491855dc5418),
    getClippingRect: $4def4ab9f32a2d89$var$getClippingRect,
    getOffsetParent: $4def4ab9f32a2d89$var$getOffsetParent,
    getElementRects: $4def4ab9f32a2d89$var$getElementRects,
    getClientRects: $4def4ab9f32a2d89$var$getClientRects,
    getDimensions: $4def4ab9f32a2d89$var$getDimensions,
    getScale: $4def4ab9f32a2d89$var$getScale,
    isElement: (0, $17f88b67153eebb9$export$45a5e7f76e0caa8d),
    isRTL: $4def4ab9f32a2d89$var$isRTL
};
function $4def4ab9f32a2d89$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $4def4ab9f32a2d89$var$observeMove(element, onMove, ancestorResize) {
    var io = null;
    var timeoutId;
    var root = (0, $17f88b67153eebb9$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var elementRectForRootMargin = element.getBoundingClientRect();
        var left = elementRectForRootMargin.left, top = elementRectForRootMargin.top, width = elementRectForRootMargin.width, height = elementRectForRootMargin.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, $6b1126e8f7895c6a$export$a3fe094919f356fd)(top);
        var insetRight = (0, $6b1126e8f7895c6a$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        var insetBottom = (0, $6b1126e8f7895c6a$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        var insetLeft = (0, $6b1126e8f7895c6a$export$a3fe094919f356fd)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: (0, $6b1126e8f7895c6a$export$8960430cfd85939f)(0, (0, $6b1126e8f7895c6a$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$4def4ab9f32a2d89$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $7XD9P._)((0, $hRCmZ._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    var win = (0, $17f88b67153eebb9$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    var handleResize = function() {
        return refresh(ancestorResize);
    };
    win.addEventListener('resize', handleResize);
    refresh(true);
    return function() {
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $4def4ab9f32a2d89$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === 'function' : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === 'function' : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = $4def4ab9f32a2d89$var$unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, $bOqL7._)(referenceEl ? (0, $17f88b67153eebb9$export$3b57c1601291186b)(referenceEl) : []).concat((0, $bOqL7._)(floating ? (0, $17f88b67153eebb9$export$3b57c1601291186b)(floating) : [])) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    var cleanupIo = referenceEl && layoutShift ? $4def4ab9f32a2d89$var$observeMove(referenceEl, update, ancestorResize) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, $6mdMa._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? $4def4ab9f32a2d89$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = $4def4ab9f32a2d89$var$getBoundingClientRect(reference);
        if (prevRefRect && !$4def4ab9f32a2d89$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ var $4def4ab9f32a2d89$export$37b6bde19b108ecc = (0, $01098fb7723b8226$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $4def4ab9f32a2d89$export$cc800923e997bb8 = (0, $01098fb7723b8226$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $4def4ab9f32a2d89$export$91fb6ecbd551914 = (0, $01098fb7723b8226$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $4def4ab9f32a2d89$export$fba63a578e423eb = (0, $01098fb7723b8226$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $4def4ab9f32a2d89$export$8a83211c878a3f1f = (0, $01098fb7723b8226$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $4def4ab9f32a2d89$export$346677f925de839c = (0, $01098fb7723b8226$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $4def4ab9f32a2d89$export$fe8985bb6374093c = (0, $01098fb7723b8226$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var $4def4ab9f32a2d89$export$f2120bbfa5450bd2 = (0, $01098fb7723b8226$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $4def4ab9f32a2d89$export$18c8ad048e32c7d5 = (0, $01098fb7723b8226$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $4def4ab9f32a2d89$export$7bf07e38f3dc4b69 = (0, $01098fb7723b8226$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ var $4def4ab9f32a2d89$export$48a53dcb22e581d0 = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = options != null ? options : {};
    var platformWithCache = (0, $7XD9P._)((0, $hRCmZ._)({}, $4def4ab9f32a2d89$export$722a64dea1b767dc, mergedOptions.platform), {
        _c: cache
    });
    return (0, $01098fb7723b8226$export$48a53dcb22e581d0)(reference, floating, (0, $7XD9P._)((0, $hRCmZ._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};



var $hAGkE = parcelRequire("hAGkE");

var $168ead04a77aa140$var$isClient = typeof document !== 'undefined';
var $168ead04a77aa140$var$noop = function noop() {};
var $168ead04a77aa140$var$index = $168ead04a77aa140$var$isClient ? (0, $hAGkE.useLayoutEffect) : $168ead04a77aa140$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $168ead04a77aa140$var$deepEqual(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, $2xTNA._)(b))) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    var length;
    var i;
    var keys;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$168ead04a77aa140$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$168ead04a77aa140$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $168ead04a77aa140$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    var win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $168ead04a77aa140$var$roundByDPR(element, value) {
    var dpr = $168ead04a77aa140$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $168ead04a77aa140$var$useLatestRef(value) {
    var ref = $hAGkE.useRef(value);
    $168ead04a77aa140$var$index(function() {
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $168ead04a77aa140$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    var _options_placement = options.placement, placement = _options_placement === void 0 ? 'bottom' : _options_placement, _options_strategy = options.strategy, strategy = _options_strategy === void 0 ? 'absolute' : _options_strategy, _options_middleware = options.middleware, middleware = _options_middleware === void 0 ? [] : _options_middleware, platform = options.platform, tmp = options.elements, _ref = tmp === void 0 ? {} : tmp, externalReference = _ref.reference, externalFloating = _ref.floating, _options_transform = options.transform, transform = _options_transform === void 0 ? true : _options_transform, whileElementsMounted = options.whileElementsMounted, open = options.open;
    var _React_useState = (0, $6mdMa._)($hAGkE.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    }), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, $6mdMa._)($hAGkE.useState(middleware), 2), latestMiddleware = _React_useState1[0], setLatestMiddleware = _React_useState1[1];
    if (!$168ead04a77aa140$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    var _React_useState2 = (0, $6mdMa._)($hAGkE.useState(null), 2), _reference = _React_useState2[0], _setReference = _React_useState2[1];
    var _React_useState3 = (0, $6mdMa._)($hAGkE.useState(null), 2), _floating = _React_useState3[0], _setFloating = _React_useState3[1];
    var setReference = $hAGkE.useCallback(function(node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    var setFloating = $hAGkE.useCallback(function(node) {
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    var referenceEl = externalReference || _reference;
    var floatingEl = externalFloating || _floating;
    var referenceRef = $hAGkE.useRef(null);
    var floatingRef = $hAGkE.useRef(null);
    var dataRef = $hAGkE.useRef(data);
    var hasWhileElementsMounted = whileElementsMounted != null;
    var whileElementsMountedRef = $168ead04a77aa140$var$useLatestRef(whileElementsMounted);
    var platformRef = $168ead04a77aa140$var$useLatestRef(platform);
    var openRef = $168ead04a77aa140$var$useLatestRef(open);
    var update = $hAGkE.useCallback(function() {
        if (!referenceRef.current || !floatingRef.current) return;
        var config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $4def4ab9f32a2d89$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then(function(data) {
            var fullData = (0, $7XD9P._)((0, $hRCmZ._)({}, data), {
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            });
            if (isMountedRef.current && !$168ead04a77aa140$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $0048b1b41b30e47d$exports.flushSync(function() {
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $168ead04a77aa140$var$index(function() {
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData(function(data) {
                return (0, $7XD9P._)((0, $hRCmZ._)({}, data), {
                    isPositioned: false
                });
            });
        }
    }, [
        open
    ]);
    var isMountedRef = $hAGkE.useRef(false);
    $168ead04a77aa140$var$index(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    $168ead04a77aa140$var$index(function() {
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    var refs = $hAGkE.useMemo(function() {
        return {
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        };
    }, [
        setReference,
        setFloating
    ]);
    var elements = $hAGkE.useMemo(function() {
        return {
            reference: referenceEl,
            floating: floatingEl
        };
    }, [
        referenceEl,
        floatingEl
    ]);
    var floatingStyles = $hAGkE.useMemo(function() {
        var initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        var x = $168ead04a77aa140$var$roundByDPR(elements.floating, data.x);
        var y = $168ead04a77aa140$var$roundByDPR(elements.floating, data.y);
        if (transform) return (0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), $168ead04a77aa140$var$getDPR(elements.floating) >= 1.5 && {
            willChange: 'transform'
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $hAGkE.useMemo(function() {
        return (0, $7XD9P._)((0, $hRCmZ._)({}, data), {
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        });
    }, [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var $168ead04a77aa140$var$arrow$1 = function(options) {
    var isRef = function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    };
    return {
        name: 'arrow',
        options: options,
        fn: function(state) {
            var _ref = typeof options === 'function' ? options(state) : options, element = _ref.element, padding = _ref.padding;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $4def4ab9f32a2d89$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $4def4ab9f32a2d89$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $168ead04a77aa140$export$cc800923e997bb8 = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $168ead04a77aa140$export$fba63a578e423eb = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $168ead04a77aa140$export$7bf07e38f3dc4b69 = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $168ead04a77aa140$export$8a83211c878a3f1f = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $168ead04a77aa140$export$346677f925de839c = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $168ead04a77aa140$export$91fb6ecbd551914 = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $168ead04a77aa140$export$fe8985bb6374093c = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $168ead04a77aa140$export$18c8ad048e32c7d5 = function(options, deps) {
    var result = (0, $4def4ab9f32a2d89$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var $168ead04a77aa140$export$f2120bbfa5450bd2 = function(options, deps) {
    var result = $168ead04a77aa140$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


// src/arrow.tsx

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $hAGkE = parcelRequire("hAGkE");


var $4a91d68948b58ce5$var$NAME = "Arrow";
var $4a91d68948b58ce5$export$21b07c8f274aebd5 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var children = props.children, _props_width = props.width, width = _props_width === void 0 ? 10 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 5 : _props_height, arrowProps = (0, $c4wKO._)(props, [
        "children",
        "width",
        "height"
    ]);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).svg, (0, $7XD9P._)((0, $hRCmZ._)({}, arrowProps), {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    }));
});
$4a91d68948b58ce5$export$21b07c8f274aebd5.displayName = $4a91d68948b58ce5$var$NAME;
var $4a91d68948b58ce5$export$be92b6f5f03c0fe9 = $4a91d68948b58ce5$export$21b07c8f274aebd5;







// packages/react/use-size/src/use-size.tsx

var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");

function $6db870d90092e604$export$1ab7ae714698c4b8(element) {
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(void 0), 2), size = _React_useState[0], setSize = _React_useState[1];
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            var resizeObserver = new ResizeObserver(function(entries) {
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                var entry = entries[0];
                var width;
                var height;
                if ("borderBoxSize" in entry) {
                    var borderSizeEntry = entry["borderBoxSize"];
                    var borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return function() {
                return resizeObserver.unobserve(element);
            };
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $8056bb4a49581f07$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $8056bb4a49581f07$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $8056bb4a49581f07$var$POPPER_NAME = "Popper";
var $8056bb4a49581f07$var$_createContextScope = (0, $6mdMa._)((0, $4670a5dc969b533a$export$50c7b4e9d9f19c1)($8056bb4a49581f07$var$POPPER_NAME), 2), $8056bb4a49581f07$var$createPopperContext = $8056bb4a49581f07$var$_createContextScope[0], $8056bb4a49581f07$export$722aac194ae923 = $8056bb4a49581f07$var$_createContextScope[1];
var $8056bb4a49581f07$var$_createPopperContext = (0, $6mdMa._)($8056bb4a49581f07$var$createPopperContext($8056bb4a49581f07$var$POPPER_NAME), 2), $8056bb4a49581f07$var$PopperProvider = $8056bb4a49581f07$var$_createPopperContext[0], $8056bb4a49581f07$var$usePopperContext = $8056bb4a49581f07$var$_createPopperContext[1];
var $8056bb4a49581f07$export$badac9ada3a0bdf9 = function(props) {
    var __scopePopper = props.__scopePopper, children = props.children;
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(null), 2), anchor = _React_useState[0], setAnchor = _React_useState[1];
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$8056bb4a49581f07$export$badac9ada3a0bdf9.displayName = $8056bb4a49581f07$var$POPPER_NAME;
var $8056bb4a49581f07$var$ANCHOR_NAME = "PopperAnchor";
var $8056bb4a49581f07$export$ecd4e1ccab6ed6d = $hAGkE.forwardRef(function(props, forwardedRef) {
    var __scopePopper = props.__scopePopper, virtualRef = props.virtualRef, anchorProps = (0, $c4wKO._)(props, [
        "__scopePopper",
        "virtualRef"
    ]);
    var context = $8056bb4a49581f07$var$usePopperContext($8056bb4a49581f07$var$ANCHOR_NAME, __scopePopper);
    var ref = $hAGkE.useRef(null);
    var composedRefs = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    var anchorRef = $hAGkE.useRef(null);
    $hAGkE.useEffect(function() {
        var previousAnchor = anchorRef.current;
        anchorRef.current = (virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current;
        if (previousAnchor !== anchorRef.current) context.onAnchorChange(anchorRef.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).div, (0, $7XD9P._)((0, $hRCmZ._)({}, anchorProps), {
        ref: composedRefs
    }));
});
$8056bb4a49581f07$export$ecd4e1ccab6ed6d.displayName = $8056bb4a49581f07$var$ANCHOR_NAME;
var $8056bb4a49581f07$var$CONTENT_NAME = "PopperContent";
var $8056bb4a49581f07$var$_createPopperContext1 = (0, $6mdMa._)($8056bb4a49581f07$var$createPopperContext($8056bb4a49581f07$var$CONTENT_NAME), 2), $8056bb4a49581f07$var$PopperContentProvider = $8056bb4a49581f07$var$_createPopperContext1[0], $8056bb4a49581f07$var$useContentContext = $8056bb4a49581f07$var$_createPopperContext1[1];
var $8056bb4a49581f07$export$bc4ae5855d3c4fc = $hAGkE.forwardRef(function(props, forwardedRef) {
    var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2, _middlewareData_transformOrigin, _middlewareData_transformOrigin1, _middlewareData_hide;
    var __scopePopper = props.__scopePopper, _props_side = props.side, side = _props_side === void 0 ? "bottom" : _props_side, _props_sideOffset = props.sideOffset, sideOffset = _props_sideOffset === void 0 ? 0 : _props_sideOffset, _props_align = props.align, align = _props_align === void 0 ? "center" : _props_align, _props_alignOffset = props.alignOffset, alignOffset = _props_alignOffset === void 0 ? 0 : _props_alignOffset, _props_arrowPadding = props.arrowPadding, arrowPadding = _props_arrowPadding === void 0 ? 0 : _props_arrowPadding, _props_avoidCollisions = props.avoidCollisions, avoidCollisions = _props_avoidCollisions === void 0 ? true : _props_avoidCollisions, _props_collisionBoundary = props.collisionBoundary, collisionBoundary = _props_collisionBoundary === void 0 ? [] : _props_collisionBoundary, tmp = props.collisionPadding, collisionPaddingProp = tmp === void 0 ? 0 : tmp, _props_sticky = props.sticky, sticky = _props_sticky === void 0 ? "partial" : _props_sticky, _props_hideWhenDetached = props.hideWhenDetached, hideWhenDetached = _props_hideWhenDetached === void 0 ? false : _props_hideWhenDetached, _props_updatePositionStrategy = props.updatePositionStrategy, updatePositionStrategy = _props_updatePositionStrategy === void 0 ? "optimized" : _props_updatePositionStrategy, onPlaced = props.onPlaced, contentProps = (0, $c4wKO._)(props, [
        "__scopePopper",
        "side",
        "sideOffset",
        "align",
        "alignOffset",
        "arrowPadding",
        "avoidCollisions",
        "collisionBoundary",
        "collisionPadding",
        "sticky",
        "hideWhenDetached",
        "updatePositionStrategy",
        "onPlaced"
    ]);
    var context = $8056bb4a49581f07$var$usePopperContext($8056bb4a49581f07$var$CONTENT_NAME, __scopePopper);
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(null), 2), content = _React_useState[0], setContent = _React_useState[1];
    var composedRefs = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setContent(node);
    });
    var _React_useState1 = (0, $6mdMa._)($hAGkE.useState(null), 2), arrow = _React_useState1[0], setArrow = _React_useState1[1];
    var arrowSize = (0, $6db870d90092e604$export$1ab7ae714698c4b8)(arrow);
    var _arrowSize_width;
    var arrowWidth = (_arrowSize_width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize_width !== void 0 ? _arrowSize_width : 0;
    var _arrowSize_height;
    var arrowHeight = (_arrowSize_height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize_height !== void 0 ? _arrowSize_height : 0;
    var desiredPlacement = side + (align !== "center" ? "-" + align : "");
    var collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : (0, $hRCmZ._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, collisionPaddingProp);
    var boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    var hasExplicitBoundaries = boundary.length > 0;
    var detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($8056bb4a49581f07$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    var _useFloating = (0, $168ead04a77aa140$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var cleanup = (0, $4def4ab9f32a2d89$export$deee3a793edee05f).apply(void 0, (0, $bOqL7._)(args).concat([
                {
                    animationFrame: updatePositionStrategy === "always"
                }
            ]));
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $168ead04a77aa140$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $168ead04a77aa140$export$fba63a578e423eb)((0, $hRCmZ._)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $168ead04a77aa140$export$7bf07e38f3dc4b69)() : void 0
            }, detectOverflowOptions)),
            avoidCollisions && (0, $168ead04a77aa140$export$8a83211c878a3f1f)((0, $hRCmZ._)({}, detectOverflowOptions)),
            (0, $168ead04a77aa140$export$346677f925de839c)((0, $7XD9P._)((0, $hRCmZ._)({}, detectOverflowOptions), {
                apply: function(param) {
                    var elements = param.elements, rects = param.rects, availableWidth = param.availableWidth, availableHeight = param.availableHeight;
                    var _rects_reference = rects.reference, anchorWidth = _rects_reference.width, anchorHeight = _rects_reference.height;
                    var contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", "".concat(availableWidth, "px"));
                    contentStyle.setProperty("--radix-popper-available-height", "".concat(availableHeight, "px"));
                    contentStyle.setProperty("--radix-popper-anchor-width", "".concat(anchorWidth, "px"));
                    contentStyle.setProperty("--radix-popper-anchor-height", "".concat(anchorHeight, "px"));
                }
            })),
            arrow && (0, $168ead04a77aa140$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $8056bb4a49581f07$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $168ead04a77aa140$export$fe8985bb6374093c)((0, $hRCmZ._)({
                strategy: "referenceHidden"
            }, detectOverflowOptions))
        ]
    }), refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, placement = _useFloating.placement, isPositioned = _useFloating.isPositioned, middlewareData = _useFloating.middlewareData;
    var _getSideAndAlignFromPlacement = (0, $6mdMa._)($8056bb4a49581f07$var$getSideAndAlignFromPlacement(placement), 2), placedSide = _getSideAndAlignFromPlacement[0], placedAlign = _getSideAndAlignFromPlacement[1];
    var handlePlaced = (0, $f773fadc836f6bf2$export$25bec8c6f54ee79a)(onPlaced);
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 ? void 0 : handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    var arrowX = (_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.x;
    var arrowY = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.y;
    var cannotCenterArrow = ((_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.centerOffset) !== 0;
    var _React_useState2 = (0, $6mdMa._)($hAGkE.useState(), 2), contentZIndex = _React_useState2[0], setContentZIndex = _React_useState2[1];
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: (0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({}, floatingStyles), (0, $8c6ug._)({
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex
        }, "--radix-popper-transform-origin", [
            (_middlewareData_transformOrigin = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin === void 0 ? void 0 : _middlewareData_transformOrigin.x,
            (_middlewareData_transformOrigin1 = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin1 === void 0 ? void 0 : _middlewareData_transformOrigin1.y
        ].join(" "))), ((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
        }),
        dir: props.dir,
        children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).div, (0, $7XD9P._)((0, $hRCmZ._)({
                "data-side": placedSide,
                "data-align": placedAlign
            }, contentProps), {
                ref: composedRefs,
                style: (0, $7XD9P._)((0, $hRCmZ._)({}, contentProps.style), {
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                })
            }))
        })
    });
});
$8056bb4a49581f07$export$bc4ae5855d3c4fc.displayName = $8056bb4a49581f07$var$CONTENT_NAME;
var $8056bb4a49581f07$var$ARROW_NAME = "PopperArrow";
var $8056bb4a49581f07$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $8056bb4a49581f07$export$79d62cd4e10a3fd0 = $hAGkE.forwardRef(function PopperArrow2(props, forwardedRef) {
    var __scopePopper = props.__scopePopper, arrowProps = (0, $c4wKO._)(props, [
        "__scopePopper"
    ]);
    var contentContext = $8056bb4a49581f07$var$useContentContext($8056bb4a49581f07$var$ARROW_NAME, __scopePopper);
    var baseSide = $8056bb4a49581f07$var$OPPOSITE_SIDE[contentContext.placedSide];
    var _obj;
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: (_obj = {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY
        }, (0, $8c6ug._)(_obj, baseSide, 0), (0, $8c6ug._)(_obj, "transformOrigin", {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
        }[contentContext.placedSide]), (0, $8c6ug._)(_obj, "transform", {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[contentContext.placedSide]), (0, $8c6ug._)(_obj, "visibility", contentContext.shouldHideArrow ? "hidden" : void 0), _obj),
        children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($4a91d68948b58ce5$export$be92b6f5f03c0fe9, (0, $7XD9P._)((0, $hRCmZ._)({}, arrowProps), {
            ref: forwardedRef,
            style: (0, $7XD9P._)((0, $hRCmZ._)({}, arrowProps.style), {
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            })
        }))
    }));
});
$8056bb4a49581f07$export$79d62cd4e10a3fd0.displayName = $8056bb4a49581f07$var$ARROW_NAME;
function $8056bb4a49581f07$var$isNotNull(value) {
    return value !== null;
}
var $8056bb4a49581f07$var$transformOrigin = function(options) {
    return {
        name: "transformOrigin",
        options: options,
        fn: function(data) {
            var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2;
            var placement = data.placement, rects = data.rects, middlewareData = data.middlewareData;
            var cannotCenterArrow = ((_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.centerOffset) !== 0;
            var isArrowHidden = cannotCenterArrow;
            var arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            var arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            var _getSideAndAlignFromPlacement = (0, $6mdMa._)($8056bb4a49581f07$var$getSideAndAlignFromPlacement(placement), 2), placedSide = _getSideAndAlignFromPlacement[0], placedAlign = _getSideAndAlignFromPlacement[1];
            var noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            var _middlewareData_arrow_x;
            var arrowXCenter = ((_middlewareData_arrow_x = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.x) !== null && _middlewareData_arrow_x !== void 0 ? _middlewareData_arrow_x : 0) + arrowWidth / 2;
            var _middlewareData_arrow_y;
            var arrowYCenter = ((_middlewareData_arrow_y = (_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.y) !== null && _middlewareData_arrow_y !== void 0 ? _middlewareData_arrow_y : 0) + arrowHeight / 2;
            var x = "";
            var y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
                y = "".concat(-arrowHeight, "px");
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
                y = "".concat(rects.floating.height + arrowHeight, "px");
            } else if (placedSide === "right") {
                x = "".concat(-arrowHeight, "px");
                y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
            } else if (placedSide === "left") {
                x = "".concat(rects.floating.width + arrowHeight, "px");
                y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    };
};
function $8056bb4a49581f07$var$getSideAndAlignFromPlacement(placement) {
    var _placement_split = (0, $6mdMa._)(placement.split("-"), 2), side = _placement_split[0], tmp = _placement_split[1], align = tmp === void 0 ? "center" : tmp;
    return [
        side,
        align
    ];
}
var $8056bb4a49581f07$export$be92b6f5f03c0fe9 = $8056bb4a49581f07$export$badac9ada3a0bdf9;
var $8056bb4a49581f07$export$b688253958b8dfe7 = $8056bb4a49581f07$export$ecd4e1ccab6ed6d;
var $8056bb4a49581f07$export$7c6e2c02157bb7d2 = $8056bb4a49581f07$export$bc4ae5855d3c4fc;
var $8056bb4a49581f07$export$21b07c8f274aebd5 = $8056bb4a49581f07$export$79d62cd4e10a3fd0;



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");




"use client";
var $96130256fc929973$var$PORTAL_NAME = "Portal";
var $96130256fc929973$export$602eac185826482c = $hAGkE.forwardRef(function(props, forwardedRef) {
    var _globalThis_document, _globalThis;
    var containerProp = props.container, portalProps = (0, $c4wKO._)(props, [
        "container"
    ]);
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        return setMounted(true);
    }, []);
    var container = containerProp || mounted && ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.body);
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($0048b1b41b30e47d$exports))).createPortal(/* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).div, (0, $7XD9P._)((0, $hRCmZ._)({}, portalProps), {
        ref: forwardedRef
    })), container) : null;
});
$96130256fc929973$export$602eac185826482c.displayName = $96130256fc929973$var$PORTAL_NAME;
var $96130256fc929973$export$be92b6f5f03c0fe9 = $96130256fc929973$export$602eac185826482c;



var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");


"use client";
function $9b0c4fe9163a6cef$var$useStateMachine(initialState, machine) {
    return $hAGkE.useReducer(function(state, event) {
        var nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
// src/presence.tsx
var $9b0c4fe9163a6cef$export$99c2b779aa4e8b8b = function(props) {
    var present = props.present, children = props.children;
    var presence = $9b0c4fe9163a6cef$var$usePresence(present);
    var child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $hAGkE.Children.only(children);
    var ref = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(presence.ref, $9b0c4fe9163a6cef$var$getElementRef(child));
    var forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $hAGkE.cloneElement(child, {
        ref: ref
    }) : null;
};
$9b0c4fe9163a6cef$export$99c2b779aa4e8b8b.displayName = "Presence";
function $9b0c4fe9163a6cef$var$usePresence(present) {
    var _React2_useState = (0, $6mdMa._)($hAGkE.useState(), 2), node = _React2_useState[0], setNode = _React2_useState[1];
    var stylesRef = $hAGkE.useRef(null);
    var prevPresentRef = $hAGkE.useRef(present);
    var prevAnimationNameRef = $hAGkE.useRef("none");
    var initialState = present ? "mounted" : "unmounted";
    var _useStateMachine = (0, $6mdMa._)($9b0c4fe9163a6cef$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    }), 2), state = _useStateMachine[0], send = _useStateMachine[1];
    $hAGkE.useEffect(function() {
        var currentAnimationName = $9b0c4fe9163a6cef$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        var styles = stylesRef.current;
        var wasPresent = prevPresentRef.current;
        var hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            var prevAnimationName = prevAnimationNameRef.current;
            var currentAnimationName = $9b0c4fe9163a6cef$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") send("UNMOUNT");
            else {
                var isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        if (node) {
            var timeoutId;
            var _node_ownerDocument_defaultView;
            var ownerWindow = (_node_ownerDocument_defaultView = node.ownerDocument.defaultView) !== null && _node_ownerDocument_defaultView !== void 0 ? _node_ownerDocument_defaultView : window;
            var handleAnimationEnd = function(event) {
                var currentAnimationName = $9b0c4fe9163a6cef$var$getAnimationName(stylesRef.current);
                var isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        var currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(function() {
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            var handleAnimationStart = function(event) {
                if (event.target === node) prevAnimationNameRef.current = $9b0c4fe9163a6cef$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return function() {
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $hAGkE.useCallback(function(node2) {
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $9b0c4fe9163a6cef$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
function $9b0c4fe9163a6cef$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    var getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    var mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $9b0c4fe9163a6cef$export$be92b6f5f03c0fe9 = $9b0c4fe9163a6cef$export$99c2b779aa4e8b8b;




// src/use-controllable-state.tsx

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $hAGkE = parcelRequire("hAGkE");

// src/use-effect-event.tsx

var $bOqL7 = parcelRequire("bOqL7");


var $hAGkE = parcelRequire("hAGkE");
var $1f6835ecbb7db660$var$useReactEffectEvent = $hAGkE[" useEffectEvent ".trim().toString()];
var $1f6835ecbb7db660$var$useReactInsertionEffect = $hAGkE[" useInsertionEffect ".trim().toString()];
function $1f6835ecbb7db660$export$7f54fc3180508a52(callback) {
    if (typeof $1f6835ecbb7db660$var$useReactEffectEvent === "function") return $1f6835ecbb7db660$var$useReactEffectEvent(callback);
    var ref = $hAGkE.useRef(function() {
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $1f6835ecbb7db660$var$useReactInsertionEffect === "function") $1f6835ecbb7db660$var$useReactInsertionEffect(function() {
        ref.current = callback;
    });
    else (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c)(function() {
        ref.current = callback;
    });
    return $hAGkE.useMemo(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _ref_current;
            var _ref_current1;
            return (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : (_ref_current = _ref_current1).call.apply(_ref_current, [
                ref
            ].concat((0, $bOqL7._)(args)));
        };
    }, []);
}


var $6db463947fe97dab$var$useInsertionEffect = $hAGkE[" useInsertionEffect ".trim().toString()] || (0, $0a23b28cec99f7f5$export$e5c5a5f917a5871c);
function $6db463947fe97dab$export$6f32135080cb4c3(param) {
    var prop = param.prop, defaultProp = param.defaultProp, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange, caller = param.caller;
    var _useUncontrolledState = (0, $6mdMa._)($6db463947fe97dab$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    }), 3), uncontrolledProp = _useUncontrolledState[0], setUncontrolledProp = _useUncontrolledState[1], onChangeRef = _useUncontrolledState[2];
    var isControlled = prop !== void 0;
    var value = isControlled ? prop : uncontrolledProp;
    {
        var isControlledRef = $hAGkE.useRef(prop !== void 0);
        $hAGkE.useEffect(function() {
            var wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                var from = wasControlled ? "controlled" : "uncontrolled";
                var to = isControlled ? "controlled" : "uncontrolled";
                console.warn("".concat(caller, " is changing from ").concat(from, " to ").concat(to, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    var setValue = $hAGkE.useCallback(function(nextValue) {
        if (isControlled) {
            var _onChangeRef_current;
            var value2 = $6db463947fe97dab$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) (_onChangeRef_current = onChangeRef.current) === null || _onChangeRef_current === void 0 ? void 0 : _onChangeRef_current.call(onChangeRef, value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $6db463947fe97dab$var$useUncontrolledState(param) {
    var defaultProp = param.defaultProp, onChange = param.onChange;
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(defaultProp), 2), value = _React_useState[0], setValue = _React_useState[1];
    var prevValueRef = $hAGkE.useRef(value);
    var onChangeRef = $hAGkE.useRef(onChange);
    $6db463947fe97dab$var$useInsertionEffect(function() {
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $hAGkE.useEffect(function() {
        if (prevValueRef.current !== value) {
            var _onChangeRef_current;
            (_onChangeRef_current = onChangeRef.current) === null || _onChangeRef_current === void 0 ? void 0 : _onChangeRef_current.call(onChangeRef, value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $6db463947fe97dab$var$isFunction(value) {
    return typeof value === "function";
}
var $6db463947fe97dab$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $6db463947fe97dab$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    var _React2;
    var controlledState = userArgs.prop, defaultProp = userArgs.defaultProp, onChangeProp = userArgs.onChange, caller = userArgs.caller;
    var isControlled = controlledState !== void 0;
    var onChange = (0, $1f6835ecbb7db660$export$7f54fc3180508a52)(onChangeProp);
    {
        var isControlledRef = $hAGkE.useRef(controlledState !== void 0);
        $hAGkE.useEffect(function() {
            var wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                var from = wasControlled ? "controlled" : "uncontrolled";
                var to = isControlled ? "controlled" : "uncontrolled";
                console.warn("".concat(caller, " is changing from ").concat(from, " to ").concat(to, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    var args = [
        (0, $7XD9P._)((0, $hRCmZ._)({}, initialArg), {
            state: defaultProp
        })
    ];
    if (init) args.push(init);
    var _useReducer_apply = (0, $6mdMa._)((_React2 = $hAGkE).useReducer.apply(_React2, [
        function(state2, action) {
            if (action.type === $6db463947fe97dab$var$SYNC_STATE) return (0, $7XD9P._)((0, $hRCmZ._)({}, state2), {
                state: action.state
            });
            var next = reducer(state2, action);
            if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
            return next;
        }
    ].concat((0, $bOqL7._)(args))), 2), internalState = _useReducer_apply[0], dispatch = _useReducer_apply[1];
    var uncontrolledState = internalState.state;
    var prevValueRef = $hAGkE.useRef(uncontrolledState);
    $hAGkE.useEffect(function() {
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    var state = $hAGkE.useMemo(function() {
        var isControlled2 = controlledState !== void 0;
        if (isControlled2) return (0, $7XD9P._)((0, $hRCmZ._)({}, internalState), {
            state: controlledState
        });
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $hAGkE.useEffect(function() {
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $6db463947fe97dab$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}


var $3faaa119be18126f$var$getDefaultParent = function getDefaultParent(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $3faaa119be18126f$var$counterMap = new WeakMap();
var $3faaa119be18126f$var$uncontrolledNodes = new WeakMap();
var $3faaa119be18126f$var$markerMap = {};
var $3faaa119be18126f$var$lockCount = 0;
var $3faaa119be18126f$var$unwrapHost = function unwrapHost1(node) {
    return node && (node.host || $3faaa119be18126f$var$unwrapHost(node.parentNode));
};
var $3faaa119be18126f$var$correctTargets = function correctTargets(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $3faaa119be18126f$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $3faaa119be18126f$var$applyAttributeToOthers = function applyAttributeToOthers(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $3faaa119be18126f$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$3faaa119be18126f$var$markerMap[markerName]) $3faaa119be18126f$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $3faaa119be18126f$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function keep1(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function deep1(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($3faaa119be18126f$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $3faaa119be18126f$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $3faaa119be18126f$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $3faaa119be18126f$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $3faaa119be18126f$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $3faaa119be18126f$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$3faaa119be18126f$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $3faaa119be18126f$var$uncontrolledNodes["delete"](node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $3faaa119be18126f$var$lockCount--;
        if (!$3faaa119be18126f$var$lockCount) {
            // clear
            $3faaa119be18126f$var$counterMap = new WeakMap();
            $3faaa119be18126f$var$counterMap = new WeakMap();
            $3faaa119be18126f$var$uncontrolledNodes = new WeakMap();
            $3faaa119be18126f$var$markerMap = {};
        }
    };
};
var $3faaa119be18126f$export$6e33d16126ed003c = function hideOthers(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $3faaa119be18126f$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $3faaa119be18126f$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $3faaa119be18126f$export$59151cc8db999a24 = function inertOthers(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $3faaa119be18126f$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $3faaa119be18126f$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $3faaa119be18126f$export$cc95fea82d705fca = function supportsInert() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $3faaa119be18126f$export$9845d4b6bdad192b = function suppressOthers(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($3faaa119be18126f$export$cc95fea82d705fca() ? $3faaa119be18126f$export$59151cc8db999a24 : $3faaa119be18126f$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");

var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");
var $8c2db902dd530699$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $8c2db902dd530699$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $8c2db902dd530699$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $8c2db902dd530699$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $hAGkE = parcelRequire("hAGkE");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $0200a73fd9157025$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $hAGkE = parcelRequire("hAGkE");
function $b199e9e9f173ee9c$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $hAGkE.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $2ae8430f855f7e45$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $hAGkE.useLayoutEffect : $hAGkE.useEffect;
var $2ae8430f855f7e45$var$currentValues = new WeakMap();
function $2ae8430f855f7e45$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $b199e9e9f173ee9c$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $0200a73fd9157025$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $2ae8430f855f7e45$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $2ae8430f855f7e45$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $0200a73fd9157025$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $0200a73fd9157025$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $2ae8430f855f7e45$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $dMrZK = parcelRequire("dMrZK");
function $1cf399a015ebbf3e$var$ItoI(a) {
    return a;
}
function $1cf399a015ebbf3e$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $1cf399a015ebbf3e$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function read() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function useMedium(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function assignSyncMedium(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function push(x) {
                    return cb(x);
                },
                filter: function filter() {
                    return buffer;
                }
            };
        },
        assignMedium: function assignMedium(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function executeQueue() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function cycle() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function push(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function filter(_filter) {
                    pendingQueue = pendingQueue.filter(_filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $1cf399a015ebbf3e$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $1cf399a015ebbf3e$var$ItoI;
    return $1cf399a015ebbf3e$var$innerCreateMedium(defaults, middleware);
}
function $1cf399a015ebbf3e$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $1cf399a015ebbf3e$var$innerCreateMedium(null);
    medium.options = (0, $dMrZK.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $83a00554e4c537b7$export$e27363444bedfeac = (0, $1cf399a015ebbf3e$export$e13ec7dd7a14088d)();


var $2109d2067ca9a77b$var$nothing = function nothing() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $2109d2067ca9a77b$export$22940b497e769dee = $hAGkE.forwardRef(function(props, parentRef) {
    var ref = $hAGkE.useRef(null);
    var _a = $hAGkE.useState({
        onScrollCapture: $2109d2067ca9a77b$var$nothing,
        onWheelCapture: $2109d2067ca9a77b$var$nothing,
        onTouchMoveCapture: $2109d2067ca9a77b$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $dMrZK.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2ae8430f855f7e45$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $dMrZK.__assign)((0, $dMrZK.__assign)({}, rest), callbacks);
    return $hAGkE.createElement($hAGkE.Fragment, null, enabled && $hAGkE.createElement(SideCar, {
        sideCar: (0, $83a00554e4c537b7$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $hAGkE.cloneElement($hAGkE.Children.only(children), (0, $dMrZK.__assign)((0, $dMrZK.__assign)({}, containerProps), {
        ref: containerRef
    })) : $hAGkE.createElement(Container, (0, $dMrZK.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$2109d2067ca9a77b$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$2109d2067ca9a77b$export$22940b497e769dee.classNames = {
    fullWidth: (0, $8c2db902dd530699$export$898e37bbd2a0ae4e),
    zeroRight: (0, $8c2db902dd530699$export$1da7500147d4bc3)
};



var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");
var $4c7aba29b6c1b4fb$var$SideCar = function SideCar(_a) {
    var sideCar = _a.sideCar, rest = (0, $dMrZK.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $hAGkE.createElement(Target, (0, $dMrZK.__assign)({}, rest));
};
$4c7aba29b6c1b4fb$var$SideCar.isSideCarExport = true;
function $4c7aba29b6c1b4fb$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $4c7aba29b6c1b4fb$var$SideCar;
}



var $dMrZK = parcelRequire("dMrZK");

var $hAGkE = parcelRequire("hAGkE");

var $hAGkE = parcelRequire("hAGkE");

var $hAGkE = parcelRequire("hAGkE");
var $d5afb79fd6aeb969$var$currentNonce;
var $d5afb79fd6aeb969$export$c5f670b24c0ae95a = function setNonce(nonce) {
    $d5afb79fd6aeb969$var$currentNonce = nonce;
};
var $d5afb79fd6aeb969$export$2b85b721e524d74b = function getNonce() {
    if ($d5afb79fd6aeb969$var$currentNonce) return $d5afb79fd6aeb969$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $4d07f72ab85ce0a7$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $d5afb79fd6aeb969$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $4d07f72ab85ce0a7$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $4d07f72ab85ce0a7$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $4d07f72ab85ce0a7$export$7c74eec858d5d226 = function stylesheetSingleton() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function add(style) {
            if (counter == 0) {
                if (stylesheet = $4d07f72ab85ce0a7$var$makeStyleTag()) {
                    $4d07f72ab85ce0a7$var$injectStyles(stylesheet, style);
                    $4d07f72ab85ce0a7$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function remove() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $aa3d267b4a3c0c76$export$7d7b35c2d250e94c = function styleHookSingleton() {
    var sheet = (0, $4d07f72ab85ce0a7$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $hAGkE.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $67c3d85261daef70$export$c1248ee86ba532c8 = function styleSingleton() {
    var useStyle = (0, $aa3d267b4a3c0c76$export$7d7b35c2d250e94c)();
    var Sheet = function Sheet(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $d97cf31e0a441ac3$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $d97cf31e0a441ac3$var$parse = function parse(x) {
    return parseInt(x || '', 10) || 0;
};
var $d97cf31e0a441ac3$var$getOffset = function getOffset(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $d97cf31e0a441ac3$var$parse(left),
        $d97cf31e0a441ac3$var$parse(top),
        $d97cf31e0a441ac3$var$parse(right)
    ];
};
var $d97cf31e0a441ac3$export$75f2ca8f029c77f4 = function getGapWidth(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $d97cf31e0a441ac3$export$efed13b5d0ca3386;
    var offsets = $d97cf31e0a441ac3$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $2dc52bad413c2906$var$Style = (0, $67c3d85261daef70$export$c1248ee86ba532c8)();
var $2dc52bad413c2906$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $2dc52bad413c2906$var$getStyles = function getStyles(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $8c2db902dd530699$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($2dc52bad413c2906$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $8c2db902dd530699$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $8c2db902dd530699$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $8c2db902dd530699$export$1da7500147d4bc3), " .").concat((0, $8c2db902dd530699$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $8c2db902dd530699$export$898e37bbd2a0ae4e), " .").concat((0, $8c2db902dd530699$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($2dc52bad413c2906$export$65254d5f26cb9564, "] {\n    ").concat((0, $8c2db902dd530699$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $2dc52bad413c2906$var$getCurrentUseCounter = function getCurrentUseCounter() {
    var counter = parseInt(document.body.getAttribute($2dc52bad413c2906$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $2dc52bad413c2906$export$a1939b1f9f9b02dc = function useLockAttribute() {
    $hAGkE.useEffect(function() {
        document.body.setAttribute($2dc52bad413c2906$export$65254d5f26cb9564, ($2dc52bad413c2906$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $2dc52bad413c2906$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($2dc52bad413c2906$export$65254d5f26cb9564);
            else document.body.setAttribute($2dc52bad413c2906$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $2dc52bad413c2906$export$9aa43b459c5ae9b9 = function RemoveScrollBar(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $2dc52bad413c2906$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $hAGkE.useMemo(function() {
        return (0, $d97cf31e0a441ac3$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $hAGkE.createElement($2dc52bad413c2906$var$Style, {
        styles: $2dc52bad413c2906$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $c753e1b27d09321d$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $c753e1b27d09321d$var$options = Object.defineProperty({}, 'passive', {
        get: function get() {
            $c753e1b27d09321d$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $c753e1b27d09321d$var$options, $c753e1b27d09321d$var$options);
    // @ts-ignore
    window.removeEventListener('test', $c753e1b27d09321d$var$options, $c753e1b27d09321d$var$options);
} catch (err) {
    $c753e1b27d09321d$var$passiveSupported = false;
}
var $c753e1b27d09321d$export$10a6e88623fa9454 = $c753e1b27d09321d$var$passiveSupported ? {
    passive: false
} : false;


var $31ec8c4ce669bdc5$var$alwaysContainsScroll = function alwaysContainsScroll(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $31ec8c4ce669bdc5$var$elementCanBeScrolled = function elementCanBeScrolled(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$31ec8c4ce669bdc5$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $31ec8c4ce669bdc5$var$elementCouldBeVScrolled = function elementCouldBeVScrolled(node) {
    return $31ec8c4ce669bdc5$var$elementCanBeScrolled(node, 'overflowY');
};
var $31ec8c4ce669bdc5$var$elementCouldBeHScrolled = function elementCouldBeHScrolled(node) {
    return $31ec8c4ce669bdc5$var$elementCanBeScrolled(node, 'overflowX');
};
var $31ec8c4ce669bdc5$export$9ec64480cae49817 = function locationCouldBeScrolled(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $31ec8c4ce669bdc5$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $31ec8c4ce669bdc5$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $31ec8c4ce669bdc5$var$getVScrollVariables = function getVScrollVariables(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $31ec8c4ce669bdc5$var$getHScrollVariables = function getHScrollVariables(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $31ec8c4ce669bdc5$var$elementCouldBeScrolled = function elementCouldBeScrolled(axis, node) {
    return axis === 'v' ? $31ec8c4ce669bdc5$var$elementCouldBeVScrolled(node) : $31ec8c4ce669bdc5$var$elementCouldBeHScrolled(node);
};
var $31ec8c4ce669bdc5$var$getScrollVariables = function getScrollVariables(axis, node) {
    return axis === 'v' ? $31ec8c4ce669bdc5$var$getVScrollVariables(node) : $31ec8c4ce669bdc5$var$getHScrollVariables(node);
};
var $31ec8c4ce669bdc5$var$getDirectionFactor = function getDirectionFactor(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $31ec8c4ce669bdc5$export$dde0441bd4a6ded8 = function handleScroll(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $31ec8c4ce669bdc5$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $31ec8c4ce669bdc5$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($31ec8c4ce669bdc5$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $75632c5b778f2f04$export$6e085704a79f4f56 = function getTouchXY(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $75632c5b778f2f04$export$39efaa2ca254a28d = function getDeltaXY(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $75632c5b778f2f04$var$extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $75632c5b778f2f04$var$deltaCompare = function deltaCompare(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $75632c5b778f2f04$var$generateStyle = function generateStyle(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $75632c5b778f2f04$var$idCounter = 0;
var $75632c5b778f2f04$var$lockStack = [];
function $75632c5b778f2f04$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $hAGkE.useRef([]);
    var touchStartRef = $hAGkE.useRef([
        0,
        0
    ]);
    var activeAxis = $hAGkE.useRef();
    var id = $hAGkE.useState($75632c5b778f2f04$var$idCounter++)[0];
    var Style = $hAGkE.useState((0, $67c3d85261daef70$export$c1248ee86ba532c8))[0];
    var lastProps = $hAGkE.useRef(props);
    $hAGkE.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $hAGkE.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $dMrZK.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($75632c5b778f2f04$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $hAGkE.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $75632c5b778f2f04$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        var canBeScrolledInMainDirection = (0, $31ec8c4ce669bdc5$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $31ec8c4ce669bdc5$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $31ec8c4ce669bdc5$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $hAGkE.useCallback(function(_event) {
        var event = _event;
        if (!$75632c5b778f2f04$var$lockStack.length || $75632c5b778f2f04$var$lockStack[$75632c5b778f2f04$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $75632c5b778f2f04$export$39efaa2ca254a28d(event) : $75632c5b778f2f04$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $75632c5b778f2f04$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($75632c5b778f2f04$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $hAGkE.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $75632c5b778f2f04$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $hAGkE.useCallback(function(event) {
        touchStartRef.current = $75632c5b778f2f04$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $hAGkE.useCallback(function(event) {
        shouldCancel(event.type, $75632c5b778f2f04$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $hAGkE.useCallback(function(event) {
        shouldCancel(event.type, $75632c5b778f2f04$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $hAGkE.useEffect(function() {
        $75632c5b778f2f04$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $c753e1b27d09321d$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $c753e1b27d09321d$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $c753e1b27d09321d$export$10a6e88623fa9454));
        return function() {
            $75632c5b778f2f04$var$lockStack = $75632c5b778f2f04$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $c753e1b27d09321d$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $c753e1b27d09321d$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $c753e1b27d09321d$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $hAGkE.createElement($hAGkE.Fragment, null, inert ? $hAGkE.createElement(Style, {
        styles: $75632c5b778f2f04$var$generateStyle(id)
    }) : null, removeScrollBar ? $hAGkE.createElement((0, $2dc52bad413c2906$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $75632c5b778f2f04$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $f488c7eb9699c8e8$export$2e2bcd8739ae039 = (0, $4c7aba29b6c1b4fb$export$6cacc8fb0a9b94ce)((0, $83a00554e4c537b7$export$e27363444bedfeac), (0, $75632c5b778f2f04$export$a09dbff87b5da2d));


var $55e44f072f8d3f51$var$ReactRemoveScroll = $hAGkE.forwardRef(function(props, ref) {
    return $hAGkE.createElement((0, $2109d2067ca9a77b$export$22940b497e769dee), (0, $dMrZK.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $f488c7eb9699c8e8$export$2e2bcd8739ae039)
    }));
});
$55e44f072f8d3f51$var$ReactRemoveScroll.classNames = (0, $2109d2067ca9a77b$export$22940b497e769dee).classNames;
var $55e44f072f8d3f51$export$2e2bcd8739ae039 = $55e44f072f8d3f51$var$ReactRemoveScroll;



"use client";
var $f726544b068465b0$var$POPOVER_NAME = "Popover";
var $f726544b068465b0$var$_createContextScope = (0, $6mdMa._)((0, $4670a5dc969b533a$export$50c7b4e9d9f19c1)($f726544b068465b0$var$POPOVER_NAME, [
    (0, $8056bb4a49581f07$export$722aac194ae923)
]), 2), $f726544b068465b0$var$createPopoverContext = $f726544b068465b0$var$_createContextScope[0], $f726544b068465b0$export$c8393c9e73286932 = $f726544b068465b0$var$_createContextScope[1];
var $f726544b068465b0$var$usePopperScope = (0, $8056bb4a49581f07$export$722aac194ae923)();
var $f726544b068465b0$var$_createPopoverContext = (0, $6mdMa._)($f726544b068465b0$var$createPopoverContext($f726544b068465b0$var$POPOVER_NAME), 2), $f726544b068465b0$var$PopoverProvider = $f726544b068465b0$var$_createPopoverContext[0], $f726544b068465b0$var$usePopoverContext = $f726544b068465b0$var$_createPopoverContext[1];
var $f726544b068465b0$export$5b6b19405a83ff9d = function(props) {
    var __scopePopover = props.__scopePopover, children = props.children, openProp = props.open, defaultOpen = props.defaultOpen, onOpenChange = props.onOpenChange, _props_modal = props.modal, modal = _props_modal === void 0 ? false : _props_modal;
    var popperScope = $f726544b068465b0$var$usePopperScope(__scopePopover);
    var triggerRef = $hAGkE.useRef(null);
    var _React_useState = (0, $6mdMa._)($hAGkE.useState(false), 2), hasCustomAnchor = _React_useState[0], setHasCustomAnchor = _React_useState[1];
    var _useControllableState = (0, $6mdMa._)((0, $6db463947fe97dab$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
        onChange: onOpenChange,
        caller: $f726544b068465b0$var$POPOVER_NAME
    }), 2), open = _useControllableState[0], setOpen = _useControllableState[1];
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$export$be92b6f5f03c0fe9, (0, $7XD9P._)((0, $hRCmZ._)({}, popperScope), {
        children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $814d0d49706f1163$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $hAGkE.useCallback(function() {
                return setOpen(function(prevOpen) {
                    return !prevOpen;
                });
            }, [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $hAGkE.useCallback(function() {
                return setHasCustomAnchor(true);
            }, []),
            onCustomAnchorRemove: $hAGkE.useCallback(function() {
                return setHasCustomAnchor(false);
            }, []),
            modal: modal,
            children: children
        })
    }));
};
$f726544b068465b0$export$5b6b19405a83ff9d.displayName = $f726544b068465b0$var$POPOVER_NAME;
var $f726544b068465b0$var$ANCHOR_NAME = "PopoverAnchor";
var $f726544b068465b0$export$96e5381f42521a79 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, anchorProps = (0, $c4wKO._)(props, [
        "__scopePopover"
    ]);
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$ANCHOR_NAME, __scopePopover);
    var popperScope = $f726544b068465b0$var$usePopperScope(__scopePopover);
    var onCustomAnchorAdd = context.onCustomAnchorAdd, onCustomAnchorRemove = context.onCustomAnchorRemove;
    $hAGkE.useEffect(function() {
        onCustomAnchorAdd();
        return function() {
            return onCustomAnchorRemove();
        };
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$export$b688253958b8dfe7, (0, $7XD9P._)((0, $hRCmZ._)({}, popperScope, anchorProps), {
        ref: forwardedRef
    }));
});
$f726544b068465b0$export$96e5381f42521a79.displayName = $f726544b068465b0$var$ANCHOR_NAME;
var $f726544b068465b0$var$TRIGGER_NAME = "PopoverTrigger";
var $f726544b068465b0$export$7dacb05d26466c3 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, triggerProps = (0, $c4wKO._)(props, [
        "__scopePopover"
    ]);
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$TRIGGER_NAME, __scopePopover);
    var popperScope = $f726544b068465b0$var$usePopperScope(__scopePopover);
    var composedTriggerRef = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    var trigger = /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).button, (0, $7XD9P._)((0, $hRCmZ._)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $f726544b068465b0$var$getState(context.open)
    }, triggerProps), {
        ref: composedTriggerRef,
        onClick: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$export$b688253958b8dfe7, (0, $7XD9P._)((0, $hRCmZ._)({
        asChild: true
    }, popperScope), {
        children: trigger
    }));
});
$f726544b068465b0$export$7dacb05d26466c3.displayName = $f726544b068465b0$var$TRIGGER_NAME;
var $f726544b068465b0$var$PORTAL_NAME = "PopoverPortal";
var $f726544b068465b0$var$_createPopoverContext1 = (0, $6mdMa._)($f726544b068465b0$var$createPopoverContext($f726544b068465b0$var$PORTAL_NAME, {
    forceMount: void 0
}), 2), $f726544b068465b0$var$PortalProvider = $f726544b068465b0$var$_createPopoverContext1[0], $f726544b068465b0$var$usePortalContext = $f726544b068465b0$var$_createPopoverContext1[1];
var $f726544b068465b0$export$dd679ffb4362d2d4 = function(props) {
    var __scopePopover = props.__scopePopover, forceMount = props.forceMount, children = props.children, container = props.container;
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $9b0c4fe9163a6cef$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96130256fc929973$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$f726544b068465b0$export$dd679ffb4362d2d4.displayName = $f726544b068465b0$var$PORTAL_NAME;
var $f726544b068465b0$var$CONTENT_NAME = "PopoverContent";
var $f726544b068465b0$export$d7e1f420b25549ff = $hAGkE.forwardRef(function(props, forwardedRef) {
    var portalContext = $f726544b068465b0$var$usePortalContext($f726544b068465b0$var$CONTENT_NAME, props.__scopePopover);
    var _props_forceMount = props.forceMount, forceMount = _props_forceMount === void 0 ? portalContext.forceMount : _props_forceMount, contentProps = (0, $c4wKO._)(props, [
        "forceMount"
    ]);
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $9b0c4fe9163a6cef$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$var$PopoverContentModal, (0, $7XD9P._)((0, $hRCmZ._)({}, contentProps), {
            ref: forwardedRef
        })) : /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$var$PopoverContentNonModal, (0, $7XD9P._)((0, $hRCmZ._)({}, contentProps), {
            ref: forwardedRef
        }))
    });
});
$f726544b068465b0$export$d7e1f420b25549ff.displayName = $f726544b068465b0$var$CONTENT_NAME;
var $f726544b068465b0$var$Slot = (0, $d0a99442aed2f3a2$export$e88b45bda5c13eb9)("PopoverContent.RemoveScroll");
var $f726544b068465b0$var$PopoverContentModal = $hAGkE.forwardRef(function(props, forwardedRef) {
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$CONTENT_NAME, props.__scopePopover);
    var contentRef = $hAGkE.useRef(null);
    var composedRefs = (0, $ce403a1eed6e1cd1$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    var isRightClickOutsideRef = $hAGkE.useRef(false);
    $hAGkE.useEffect(function() {
        var content = contentRef.current;
        if (content) return (0, $3faaa119be18126f$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $55e44f072f8d3f51$export$2e2bcd8739ae039), {
        as: $f726544b068465b0$var$Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$var$PopoverContentImpl, (0, $7XD9P._)((0, $hRCmZ._)({}, props), {
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onCloseAutoFocus, function(event) {
                var _context_triggerRef_current;
                event.preventDefault();
                if (!isRightClickOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
            }),
            onPointerDownOutside: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onPointerDownOutside, function(event) {
                var originalEvent = event.detail.originalEvent;
                var ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                var isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onFocusOutside, function(event) {
                return event.preventDefault();
            }, {
                checkForDefaultPrevented: false
            })
        }))
    });
});
var $f726544b068465b0$var$PopoverContentNonModal = $hAGkE.forwardRef(function(props, forwardedRef) {
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$CONTENT_NAME, props.__scopePopover);
    var hasInteractedOutsideRef = $hAGkE.useRef(false);
    var hasPointerDownOutsideRef = $hAGkE.useRef(false);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$var$PopoverContentImpl, (0, $7XD9P._)((0, $hRCmZ._)({}, props), {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: function(event) {
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented) {
                var _context_triggerRef_current;
                if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: function(event) {
            var _props_onInteractOutside, _context_triggerRef_current;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            var target = event.target;
            var targetIsTrigger = (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
var $f726544b068465b0$var$PopoverContentImpl = $hAGkE.forwardRef(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, trapFocus = props.trapFocus, onOpenAutoFocus = props.onOpenAutoFocus, onCloseAutoFocus = props.onCloseAutoFocus, disableOutsidePointerEvents = props.disableOutsidePointerEvents, onEscapeKeyDown = props.onEscapeKeyDown, onPointerDownOutside = props.onPointerDownOutside, onFocusOutside = props.onFocusOutside, onInteractOutside = props.onInteractOutside, contentProps = (0, $c4wKO._)(props, [
        "__scopePopover",
        "trapFocus",
        "onOpenAutoFocus",
        "onCloseAutoFocus",
        "disableOutsidePointerEvents",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside"
    ]);
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$CONTENT_NAME, __scopePopover);
    var popperScope = $f726544b068465b0$var$usePopperScope(__scopePopover);
    (0, $a395a5f75d924d0a$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $b193f55f2ffa347d$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $42e76fd3f2bde910$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: function() {
                return context.onOpenChange(false);
            },
            children: /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$export$7c6e2c02157bb7d2, (0, $7XD9P._)((0, $hRCmZ._)({
                "data-state": $f726544b068465b0$var$getState(context.open),
                role: "dialog",
                id: context.contentId
            }, popperScope, contentProps), {
                ref: forwardedRef,
                style: (0, $7XD9P._)((0, $hRCmZ._)({}, contentProps.style), {
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                })
            }))
        })
    });
});
var $f726544b068465b0$var$CLOSE_NAME = "PopoverClose";
var $f726544b068465b0$export$d6ac43ebaa40d53e = $hAGkE.forwardRef(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, closeProps = (0, $c4wKO._)(props, [
        "__scopePopover"
    ]);
    var context = $f726544b068465b0$var$usePopoverContext($f726544b068465b0$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)((0, $96f2b5598960bdee$export$250ffa63cdc0d034).button, (0, $7XD9P._)((0, $hRCmZ._)({
        type: "button"
    }, closeProps), {
        ref: forwardedRef,
        onClick: (0, $346a57b4a559cf1e$export$b9ecd428b558ff10)(props.onClick, function() {
            return context.onOpenChange(false);
        })
    }));
});
$f726544b068465b0$export$d6ac43ebaa40d53e.displayName = $f726544b068465b0$var$CLOSE_NAME;
var $f726544b068465b0$var$ARROW_NAME = "PopoverArrow";
var $f726544b068465b0$export$3152841115e061b2 = $hAGkE.forwardRef(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, arrowProps = (0, $c4wKO._)(props, [
        "__scopePopover"
    ]);
    var popperScope = $f726544b068465b0$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $3d45074523d8f6b3$exports.jsx)($8056bb4a49581f07$export$21b07c8f274aebd5, (0, $7XD9P._)((0, $hRCmZ._)({}, popperScope, arrowProps), {
        ref: forwardedRef
    }));
});
$f726544b068465b0$export$3152841115e061b2.displayName = $f726544b068465b0$var$ARROW_NAME;
function $f726544b068465b0$var$getState(open) {
    return open ? "open" : "closed";
}
var $f726544b068465b0$export$be92b6f5f03c0fe9 = $f726544b068465b0$export$5b6b19405a83ff9d;
var $f726544b068465b0$export$b688253958b8dfe7 = $f726544b068465b0$export$96e5381f42521a79;
var $f726544b068465b0$export$41fb9f06171c75f4 = $f726544b068465b0$export$7dacb05d26466c3;
var $f726544b068465b0$export$602eac185826482c = $f726544b068465b0$export$dd679ffb4362d2d4;
var $f726544b068465b0$export$7c6e2c02157bb7d2 = $f726544b068465b0$export$d7e1f420b25549ff;
var $f726544b068465b0$export$f39c2d165cd861fe = $f726544b068465b0$export$d6ac43ebaa40d53e;
var $f726544b068465b0$export$21b07c8f274aebd5 = $f726544b068465b0$export$3152841115e061b2;







function $d6148961055ac8c8$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  z-index: 1000;\n\n  background-color: #000928;\n  color: white;\n\n  font-family: ",
        ';\n  font-style: normal;\n  line-height: 150%;\n  font-feature-settings: "pnum" on, "lnum" on;\n\n  max-width: 100vw;\n\n  h2 {\n    font-weight: bold;\n    font-size: 1.1em;\n    margin: 0;\n    margin-top: 8px;\n    margin-bottom: 16px;\n  }\n\n  p {\n    font-weight: 500;\n    font-size: 0.9rem;\n    margin: 0;\n  }\n\n  box-shadow: 0px 16.25px 97.5px rgba(0, 0, 0, 0.12);\n  padding: 1.5rem;\n\n  border-top-left-radius: ',
        ";\n  border-top-right-radius: ",
        ";\n\n  @media ",
        " {\n    margin: initial;\n    border-radius: ",
        ";\n    max-width: 440px;\n  }\n"
    ]);
    $d6148961055ac8c8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d6148961055ac8c8$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  cursor: pointer;\n\n  color: #fff;\n  background-color: transparent;\n  border: 0px;\n  padding: 0.5rem;\n"
    ]);
    $d6148961055ac8c8$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d6148961055ac8c8$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  ",
        "\n"
    ]);
    $d6148961055ac8c8$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $d6148961055ac8c8$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  cursor: pointer;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  background: transparent;\n  border: 0;\n"
    ]);
    $d6148961055ac8c8$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $d6148961055ac8c8$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 24px;\n  height: 24px;\n"
    ]);
    $d6148961055ac8c8$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $d6148961055ac8c8$export$7a7c7a2506c3719d = {
    WHITE: "white",
    NAVY: "#666B7E"
};
var $d6148961055ac8c8$var$TooltipContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($f726544b068465b0$export$7c6e2c02157bb7d2)($d6148961055ac8c8$var$_templateObject(), function(props) {
    return props.theme.fontFamily;
}, function(props) {
    return props.theme.radius.large;
}, function(props) {
    return props.theme.radius.large;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, function(props) {
    return props.theme.radius.large;
});
var $d6148961055ac8c8$var$TooltipClose = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($f726544b068465b0$export$f39c2d165cd861fe)($d6148961055ac8c8$var$_templateObject1());
var $d6148961055ac8c8$var$TooltipContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d6148961055ac8c8$var$_templateObject2(), function(props) {
    return props.$displayAsMobile ? "& div[data-radix-popper-content-wrapper] {\n            transform: translate3d(0px, 0, 0px)!important;\n            width: 100%;\n            bottom: 0;\n            top: auto !important;\n            max-width: 768px;\n        }" : "";
});
/**
 * Button used in case popover children aren't provided
 */ var $d6148961055ac8c8$var$DefaultButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($d6148961055ac8c8$var$_templateObject3());
/**
 * Wrapper for the default question mark icon
 */ var $d6148961055ac8c8$var$QuestionMarkWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d6148961055ac8c8$var$_templateObject4());
/**
 * A reusable, accessible tooltip component built with Radix UI.
 * For documentation, read Radix docs https://www.radix-ui.com/docs/primitives/components/popover.
 *
 * Technically more of a popover, but internally referred as Tooltip.
 */ var $d6148961055ac8c8$var$Tooltip = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        eventLabel: null,
        content: null,
        side: "top"
    };
    var content = _param.content, questionMarkColor = _param.questionMarkColor, children = _param.children, eventLabel = _param.eventLabel, props = (0, $c4wKO._)(_param, [
        "content",
        "questionMarkColor",
        "children",
        "eventLabel"
    ]);
    var width = $d6148961055ac8c8$var$useWindowSize().width;
    /**
   * We display a fixed tooltip only if the window width is between 0 and 768px.
   */ var displayAsMobile = width > 0 && width < 768;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($f726544b068465b0$export$be92b6f5f03c0fe9, {
        // this will lock scrolling if we're displaying the tooltip as a modal on mobile, it lookes better
        modal: displayAsMobile,
        onOpenChange: function() {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).tooltipClicked,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: eventLabel
            });
        },
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$export$41fb9f06171c75f4, {
                asChild: true,
                children: children || /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d6148961055ac8c8$var$DefaultButton, {
                    "data-testid": "default-icon-button",
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d6148961055ac8c8$var$QuestionMarkWrapper, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $abfded16bdabae7a$export$962ee6b89e324472), {
                            active: false,
                            fillDefault: questionMarkColor || "#666B7E",
                            fillHover: questionMarkColor === $d6148961055ac8c8$export$7a7c7a2506c3719d.WHITE ? "#ffffff" : "#073ED9",
                            width: 20,
                            height: 20,
                            type: (0, $abfded16bdabae7a$export$13ff1290a9e22e77).QuestionMark
                        })
                    })
                })
            }),
            content !== null && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d6148961055ac8c8$var$TooltipContainer, {
                    $displayAsMobile: displayAsMobile,
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d6148961055ac8c8$var$TooltipContent, (0, $7XD9P._)((0, $hRCmZ._)({}, props), {
                        children: [
                            content,
                            !displayAsMobile && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f726544b068465b0$export$21b07c8f274aebd5, {
                                offset: 20
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d6148961055ac8c8$var$TooltipClose, {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $abfded16bdabae7a$export$962ee6b89e324472), {
                                    fillDefault: "#ffffff",
                                    width: 24,
                                    height: 24,
                                    type: (0, $abfded16bdabae7a$export$13ff1290a9e22e77).Cross
                                })
                            })
                        ]
                    }))
                })
            })
        ]
    });
};
/**
 * Calculates browser's window size to decide whether to display a mobile version of the tooltip.
 *
 * Code from https://usehooks.com/useWindowSize/
 */ var $d6148961055ac8c8$var$useWindowSize = function() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState({
        width: undefined,
        height: undefined
    }), 2), windowSize = _React_useState[0], setWindowSize = _React_useState[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect(function() {
        var handleResize = // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
};
var $d6148961055ac8c8$export$2e2bcd8739ae039 = $d6148961055ac8c8$var$Tooltip;





function $d5657baa9a763129$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: start;\n  flex-direction: column-reverse;\n  gap: 8px;\n  flex: 50%;\n  margin-bottom: 8px;\n  padding: 8px 0;\n\n  & > div:last-of-type {\n    font-size: 20px;\n    font-weight: 600;\n  }\n"
    ]);
    $d5657baa9a763129$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d5657baa9a763129$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    $d5657baa9a763129$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $d5657baa9a763129$export$5f24ef162146d86f = /*#__PURE__*/ function(RateDetailEnum) {
    RateDetailEnum["MONTHLY_PAYMENT"] = "Monthly payment";
    RateDetailEnum["OVERALL_INITIAL_COST"] = "Overall initial cost";
    RateDetailEnum["APRC"] = "APRC";
    RateDetailEnum["PRODUCT_FEE"] = "Product fee";
    RateDetailEnum["END_DATE"] = "End date";
    return RateDetailEnum;
}({});
var $d5657baa9a763129$export$9bf04cbcc5641a40 = function(param) {
    var type = param.type, data = param.data, currentRate = param.currentRate, arrow = param.arrow, disable = param.disable, children = param.children;
    var selectTooltipContent = function(type) {
        switch(type){
            case "Overall initial cost":
                return "This is the total amount you\u2019ll pay over your initial period including interest and any fees you add to the loan.";
            case "APRC":
                return "APRC is a figure that shows the total yearly cost of a UK mortgage, including interest and fees, expressed as a percentage. It is intended to helps you compare different mortgage offers.";
            case "Product fee":
                return "This is a fee you\u2019ll pay to secure this interest rate. It is set by the lender, and might also be referred to as a mortgage booking fee, arrangement fee, or reservation fee.";
            case "End date":
                return "The is the date your next mortgage will end. The date may move later if you move onto a lower rate as you are moving onto it at a later date. This however, won\u2019t impact your anticipated completion date.";
            default:
                return null;
        }
    };
    var content = selectTooltipContent(type);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d5657baa9a763129$var$RateDetailContainer, {
        children: [
            children && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($d5657baa9a763129$var$RateDetailItem, {
                children: children
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d5657baa9a763129$var$RateDetailItem, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                        children: type
                    }),
                    content && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d6148961055ac8c8$export$2e2bcd8739ae039), {
                        content: content
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d5657baa9a763129$var$RateDetailItem, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                        children: data
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $20d975e5e7058386$export$21b07c8f274aebd5), {
                        currentRate: currentRate,
                        colour: arrow,
                        disable: disable
                    })
                ]
            })
        ]
    });
};
var $d5657baa9a763129$var$RateDetailContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($d5657baa9a763129$var$_templateObject());
var $d5657baa9a763129$var$RateDetailItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d5657baa9a763129$var$_templateObject1());



parcelRequire("hAGkE");

var $2088a9771a1d9c03$export$1fa4cea1d9a79ae = function(param) {
    var formattedBorrowing = param.formattedBorrowing, formattedTrueCosts = param.formattedTrueCosts, AprLenders = param.AprLenders, formattedArrangementFee = param.formattedArrangementFee, feesOther = param.feesOther, formattedFeesOther = param.formattedFeesOther, InitialPayRate = param.InitialPayRate, InitialRatePeriodMonths = param.InitialRatePeriodMonths, formattedMonthlyPayment = param.formattedMonthlyPayment, formattedInterest = param.formattedInterest, formatMonthlyPaymentAfterInitialPeriod = param.formatMonthlyPaymentAfterInitialPeriod, StandardVariableRate = param.StandardVariableRate, termMonths = param.termMonths;
    var displayYearsAndMonths = function(months) {
        var years = Math.floor(months / 12);
        var remainingMonths = months % 12;
        var yearStr = years ? "".concat(years, " ").concat(years === 1 ? "year" : "years") : "";
        var monthStr = remainingMonths ? "".concat(remainingMonths, " ").concat(remainingMonths === 1 ? "month" : "months") : "";
        return [
            yearStr,
            monthStr
        ].filter(Boolean).join(" and ");
    };
    var remainingMonths = termMonths - InitialRatePeriodMonths;
    var totalDuration = displayYearsAndMonths(termMonths);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2088a9771a1d9c03$var$RepresentativeExample, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                children: "Representative example:"
            }),
            " a repayment mortgage amount of ",
            formattedBorrowing,
            " over",
            " ",
            totalDuration,
            ", representative APRC ",
            AprLenders,
            "%. Total amount payable ",
            formattedTrueCosts,
            " ",
            "includes interest of ",
            formattedInterest,
            ", product fees of ",
            formattedArrangementFee,
            feesOther > 0 ? "and other fees of ".concat(formattedFeesOther, ".") : ".",
            " Repayments:",
            " ",
            InitialRatePeriodMonths,
            " months of ",
            formattedMonthlyPayment,
            " at ",
            InitialPayRate,
            "% (fixed), then ",
            remainingMonths,
            " months of ",
            formatMonthlyPaymentAfterInitialPeriod,
            " at",
            " ",
            StandardVariableRate,
            "% (variable). Early repayment charges apply."
        ]
    });
};
var $2088a9771a1d9c03$var$RepresentativeExample = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    fontSize: "12px"
});


function $20d975e5e7058386$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  background: #fff;\n  padding: 24px;\n  gap: 16px;\n  flex: 1;\n  border: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    $20d975e5e7058386$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $20d975e5e7058386$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 8px;\n"
    ]);
    $20d975e5e7058386$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $20d975e5e7058386$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  margin: 10px 0;\n  padding: 10px 30px;\n  border-radius: 8px;\n  background: #eef5f3;\n  font-size: 18px;\n  font-weight: 600;\n\n  & > div {\n    display: flex;\n    align-items: center;\n    color: #398156;\n\n    justify-content: center;\n    text-align: center;\n    ::before {\n      content: url(",
        ");\n    }\n  }\n"
    ]);
    $20d975e5e7058386$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $20d975e5e7058386$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  border-radius: 8px;\n  padding: 8px;\n  background: #f3f5fc;\n"
    ]);
    $20d975e5e7058386$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $20d975e5e7058386$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  justify-items: center;\n  align-items: center;\n  padding: 16px;\n  text-align: center;\n  width: 100%;\n\n  background: #dde3f7;\n  border-radius: 4px;\n\n  & > div:first-of-type {\n    font-size: 20px;\n    font-weight: 600;\n  }\n"
    ]);
    $20d975e5e7058386$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $20d975e5e7058386$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0 16px;\n"
    ]);
    $20d975e5e7058386$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $20d975e5e7058386$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  gap: 16px;\n"
    ]);
    $20d975e5e7058386$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $20d975e5e7058386$var$formatProductEndDate = function(date) {
    return date.toLocaleString("default", {
        month: "short",
        year: "numeric"
    });
};
/** @param {ILRState} status if a better rate has been identified, this is its state
 * @param {undefined} status if no better rate has been identified
 */ var $20d975e5e7058386$var$mapStatusToFlags = function(status) {
    var declined = status === (0, $da8977d24f633871$export$ba10d77b5bfec263).Declined;
    var expired = status === (0, $da8977d24f633871$export$ba10d77b5bfec263).Expired;
    var completed = status === (0, $da8977d24f633871$export$ba10d77b5bfec263).Completed;
    var progressing = status === (0, $da8977d24f633871$export$ba10d77b5bfec263).Progressing;
    var cancelled = status === (0, $da8977d24f633871$export$ba10d77b5bfec263).Cancelled;
    // Found exists. FYI :p
    var currentRateSelected = expired || declined || cancelled || status == undefined;
    var otherRateSelected = progressing || completed;
    var active = !expired && !completed && !cancelled;
    return {
        declined: declined,
        expired: expired,
        completed: completed,
        progressing: progressing,
        cancelled: cancelled,
        currentRateSelected: currentRateSelected,
        otherRateSelected: otherRateSelected,
        active: active
    };
};
var $20d975e5e7058386$export$a64162838dbd1966 = function(param) {
    var productDetails = param.productDetails, arrows = param.arrows, _param_productInput = param.productInput, loanAmount = _param_productInput.loanAmount, termMonths = _param_productInput.termMonths, addFeesToLoan = _param_productInput.addFeesToLoan, identifiedLowerRateStatus = param.identifiedLowerRateStatus, identifiedLowerRateId = param.identifiedLowerRateId, actionClicked = param.actionClicked, handleClick = param.handleClick, isError = param.isError, currentRate = param.currentRate, currentInitialCost = param.currentInitialCost, handleEsisDownload = param.handleEsisDownload, showCompletionDateWarning = param.showCompletionDateWarning, warningChecked = param.warningChecked, handleWarningCheckboxChange = param.handleWarningCheckboxChange;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), buttonClicked = _useState[0], setButtonClicked = _useState[1];
    var _mapStatusToFlags = $20d975e5e7058386$var$mapStatusToFlags(identifiedLowerRateStatus), currentRateSelected = _mapStatusToFlags.currentRateSelected, otherRateSelected = _mapStatusToFlags.otherRateSelected, active = _mapStatusToFlags.active, expired = _mapStatusToFlags.expired, completed = _mapStatusToFlags.completed, progressing = _mapStatusToFlags.progressing, cancelled = _mapStatusToFlags.cancelled, declined = _mapStatusToFlags.declined;
    var AprLenders = productDetails.AprLenders, ArrangementFee = productDetails.ArrangementFee, BookingFee = productDetails.BookingFee, FeesTotal = productDetails.FeesTotal, InitialMonthlyPayment = productDetails.InitialMonthlyPayment, InitialPayRate = productDetails.InitialPayRate, InitialRatePeriodPrecise = productDetails.InitialRatePeriodPrecise, InitialRatePeriodMonths = productDetails.InitialRatePeriodMonths, MonthlyPaymentAfterInitialPeriod = productDetails.MonthlyPaymentAfterInitialPeriod, StandardVariableRate = productDetails.StandardVariableRate, TotalInterestPayable = productDetails.TotalInterestPayable, TrueCost = productDetails.TrueCost, TrueCostOverInitialPeriod = productDetails.TrueCostOverInitialPeriod, InitialMonthlyPaymentIncludingFees = productDetails.InitialMonthlyPaymentIncludingFees;
    var formattedMonthlyPayment = addFeesToLoan ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPaymentIncludingFees) : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPayment);
    var formattedInitialCosts = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(TrueCostOverInitialPeriod);
    var formattedEndDate = $20d975e5e7058386$var$formatProductEndDate(new Date(InitialRatePeriodPrecise));
    var formattedBorrowing = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(loanAmount);
    var formattedTrueCosts = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(TrueCost);
    var formattedArrangementFee = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(ArrangementFee);
    var feesOther = FeesTotal - BookingFee;
    var formattedFeesOther = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(feesOther);
    var formattedInterest = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(TotalInterestPayable);
    var formatMonthlyPaymentAfterInitialPeriod = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(MonthlyPaymentAfterInitialPeriod);
    var selected = currentRate && currentRateSelected && active || !currentRate && otherRateSelected && active;
    var thisRateSelected = buttonClicked && !isError;
    var isOverallInitialCostHigher = currentInitialCost && TrueCostOverInitialPeriod > currentInitialCost;
    var overallSelected = selected || thisRateSelected;
    var warningNotChecked = !!showCompletionDateWarning && !warningChecked;
    var disable = currentRate && (actionClicked === "new" || otherRateSelected || warningNotChecked) || !currentRate && (actionClicked === "current" || currentRateSelected);
    var cardTitle = currentRate ? "Your current rate" : expired ? "Expired rate" : declined ? "Declined rate" : "New rate";
    var handleRateClick = function() {
        handleClick();
        setButtonClicked(true);
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: currentRate ? (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).autoRateDecline : (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).autoRateAccept
        });
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateWrapper, {
        selected: overallSelected,
        disable: disable,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$RateCardTitle, {
                children: cardTitle
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateHighlight, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$export$4dc9f58ad9a1a000, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                                children: [
                                                    InitialPayRate,
                                                    " %"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$export$21b07c8f274aebd5, {
                                                currentRate: currentRate,
                                                colour: arrows.initialRate,
                                                disable: disable
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                        children: "Initial interest rate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateDetails, {
                                "aria-label": "".concat(cardTitle, " details"),
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).MONTHLY_PAYMENT,
                                        data: formattedMonthlyPayment,
                                        currentRate: currentRate,
                                        arrow: arrows.monthlyPayment,
                                        disable: disable
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).OVERALL_INITIAL_COST,
                                        data: formattedInitialCosts,
                                        currentRate: currentRate,
                                        arrow: arrows.overallCost,
                                        disable: disable,
                                        children: !currentRate && isOverallInitialCostHigher && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                                            href: "#faq-7",
                                            style: {
                                                color: "blue"
                                            },
                                            onClick: function(e) {
                                                e.preventDefault();
                                                var faqButtons = document.getElementsByClassName("faq-7-button");
                                                if (faqButtons.length > 0) {
                                                    var _faqButtons_, _faqButtons_1;
                                                    (_faqButtons_ = faqButtons[0]) === null || _faqButtons_ === void 0 ? void 0 : _faqButtons_.click();
                                                    (_faqButtons_1 = faqButtons[0]) === null || _faqButtons_1 === void 0 ? void 0 : _faqButtons_1.scrollIntoView({
                                                        behavior: "smooth",
                                                        block: "center"
                                                    });
                                                }
                                            },
                                            children: "Why is this higher?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).APRC,
                                        data: "".concat(AprLenders, " %"),
                                        currentRate: currentRate,
                                        arrow: arrows.aprc,
                                        disable: disable
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).PRODUCT_FEE,
                                        data: "\xa3".concat(ArrangementFee),
                                        currentRate: currentRate,
                                        arrow: arrows.productFee,
                                        disable: disable
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).END_DATE,
                                        data: "".concat(formattedEndDate),
                                        currentRate: currentRate,
                                        arrow: arrows.endDate,
                                        disable: disable
                                    })
                                ]
                            })
                        ]
                    }),
                    active && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$RateCTAs, {
                        children: overallSelected ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$RateActionContainer, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                children: currentRate ? "Your current rate selected" : "New rate selected"
                            })
                        }) : currentRate ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$CurrentRateCTA, {
                            disabled: disable || !identifiedLowerRateId,
                            handleRateClick: handleRateClick
                        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$NewRateCTA, {
                            disabled: disable || !identifiedLowerRateId || warningNotChecked,
                            handleRateClick: handleRateClick,
                            showWarning: !!showCompletionDateWarning,
                            handleWarningCheckboxChange: handleWarningCheckboxChange,
                            warningChecked: warningChecked
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $2088a9771a1d9c03$export$1fa4cea1d9a79ae), {
                        formattedBorrowing: formattedBorrowing,
                        formattedTrueCosts: formattedTrueCosts,
                        AprLenders: AprLenders,
                        formattedArrangementFee: formattedArrangementFee,
                        feesOther: feesOther,
                        formattedFeesOther: formattedFeesOther,
                        InitialPayRate: InitialPayRate,
                        InitialRatePeriodMonths: InitialRatePeriodMonths,
                        formattedMonthlyPayment: formattedMonthlyPayment,
                        formattedInterest: formattedInterest,
                        formatMonthlyPaymentAfterInitialPeriod: formatMonthlyPaymentAfterInitialPeriod,
                        StandardVariableRate: StandardVariableRate,
                        termMonths: termMonths
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$DownloadEsis, {
                        handleClick: handleEsisDownload,
                        disabled: currentRate && (progressing || completed) || !currentRate && (expired || declined || cancelled)
                    })
                ]
            })
        ]
    });
};
var $20d975e5e7058386$var$CurrentRateCTA = function(param) {
    var disabled = param.disabled, handleRateClick = param.handleRateClick;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
        id: "button-select-current-rate",
        disabled: disabled,
        type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
        onClick: handleRateClick,
        text: "Stay with this rate"
    });
};
var $20d975e5e7058386$var$NewRateCTA = function(param) {
    var disabled = param.disabled, handleRateClick = param.handleRateClick, showWarning = param.showWarning, handleWarningCheckboxChange = param.handleWarningCheckboxChange, warningChecked = param.warningChecked;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $773258ddbd55ac8e$export$b6e9cf2c5033f2e8), {
        checked: warningChecked,
        showWarning: showWarning,
        onChange: handleWarningCheckboxChange,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
            id: "button-select-this-rate",
            disabled: disabled,
            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
            onClick: handleRateClick,
            text: "Request this rate"
        })
    });
};
var $20d975e5e7058386$export$4ef2ed81e604cf5 = function(param) {
    var _param_productDetails = param.productDetails, AprLenders = _param_productDetails.AprLenders, ArrangementFee = _param_productDetails.ArrangementFee, BookingFee = _param_productDetails.BookingFee, FeesTotal = _param_productDetails.FeesTotal, InitialMonthlyPayment = _param_productDetails.InitialMonthlyPayment, InitialPayRate = _param_productDetails.InitialPayRate, InitialRatePeriodPrecise = _param_productDetails.InitialRatePeriodPrecise, InitialRatePeriodMonths = _param_productDetails.InitialRatePeriodMonths, MonthlyPaymentAfterInitialPeriod = _param_productDetails.MonthlyPaymentAfterInitialPeriod, StandardVariableRate = _param_productDetails.StandardVariableRate, TotalInterestPayable = _param_productDetails.TotalInterestPayable, TrueCost = _param_productDetails.TrueCost, TrueCostOverInitialPeriod = _param_productDetails.TrueCostOverInitialPeriod, InitialMonthlyPaymentIncludingFees = _param_productDetails.InitialMonthlyPaymentIncludingFees, _param_productInput = param.productInput, loanAmount = _param_productInput.loanAmount, termMonths = _param_productInput.termMonths, addFeesToLoan = _param_productInput.addFeesToLoan;
    var formattedMonthlyPayment = addFeesToLoan ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPaymentIncludingFees) : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPayment);
    var formattedInitialCosts = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(TrueCostOverInitialPeriod);
    var formattedEndDate = $20d975e5e7058386$var$formatProductEndDate(new Date(InitialRatePeriodPrecise));
    var formattedBorrowing = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(loanAmount);
    var formattedTrueCosts = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(TrueCost);
    var formattedArrangementFee = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(ArrangementFee);
    var feesOther = FeesTotal - BookingFee;
    var formattedFeesOther = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(feesOther);
    var formattedInterest = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(TotalInterestPayable);
    var formatMonthlyPaymentAfterInitialPeriod = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(MonthlyPaymentAfterInitialPeriod);
    var currentRate = true;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateWrapper, {
        selected: false,
        disable: false,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$RateCardTitle, {
                children: "Your final rate"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                children: "This is the rate you\u2019ll move onto when you complete"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateHighlight, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$export$4dc9f58ad9a1a000, {
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                            children: [
                                                InitialPayRate,
                                                " %"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                        children: "Initial interest rate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($20d975e5e7058386$var$RateDetails, {
                                "aria-label": "Final rate details",
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).MONTHLY_PAYMENT,
                                        data: formattedMonthlyPayment,
                                        currentRate: currentRate
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).OVERALL_INITIAL_COST,
                                        data: formattedInitialCosts,
                                        currentRate: currentRate
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).APRC,
                                        data: "".concat(AprLenders, " %"),
                                        currentRate: currentRate
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).PRODUCT_FEE,
                                        data: "\xa3".concat(ArrangementFee),
                                        currentRate: currentRate
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d5657baa9a763129$export$9bf04cbcc5641a40), {
                                        type: (0, $d5657baa9a763129$export$5f24ef162146d86f).END_DATE,
                                        data: "".concat(formattedEndDate),
                                        currentRate: currentRate
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $2088a9771a1d9c03$export$1fa4cea1d9a79ae), {
                        formattedBorrowing: formattedBorrowing,
                        formattedTrueCosts: formattedTrueCosts,
                        AprLenders: AprLenders,
                        formattedArrangementFee: formattedArrangementFee,
                        feesOther: feesOther,
                        formattedFeesOther: formattedFeesOther,
                        InitialPayRate: InitialPayRate,
                        InitialRatePeriodMonths: InitialRatePeriodMonths,
                        formattedMonthlyPayment: formattedMonthlyPayment,
                        formattedInterest: formattedInterest,
                        formatMonthlyPaymentAfterInitialPeriod: formatMonthlyPaymentAfterInitialPeriod,
                        StandardVariableRate: StandardVariableRate,
                        termMonths: termMonths
                    })
                ]
            })
        ]
    });
};
var $20d975e5e7058386$var$DownloadEsis = function(param) {
    var handleClick = param.handleClick, disabled = param.disabled;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$DownloadEsisContainer, {
        children: disabled ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$DownloadEsisLinkDisabled, {
            children: "Download Mortgage Illustration"
        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($20d975e5e7058386$var$DownloadEsisLink, {
            target: "_blank",
            onClick: handleClick,
            children: "Download Mortgage Illustration"
        })
    });
};
var $20d975e5e7058386$export$21b07c8f274aebd5 = function(param) {
    var currentRate = param.currentRate, colour = param.colour, disable = param.disable;
    if (currentRate) return null;
    if (colour === "green") return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.93406 8.34949L7.56812 15.3921C7.92804 15.842 8.6123 15.842 8.97222 15.3921L14.6063 8.34949C15.1439 7.6775 14.521 6.70691 13.6862 6.91563L9.27017 8.01963L9.27017 0.269632L7.27017 0.269632L7.27017 8.01963L2.85416 6.91563C2.01929 6.70691 1.39647 7.6775 1.93406 8.34949Z",
            fill: disable ? "#B5BEDC" : "#038352"
        })
    });
    else if (colour === "orange") return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6079 7.65051L8.97387 0.607931C8.61395 0.158033 7.92969 0.158033 7.56977 0.607931L1.93571 7.65051C1.39812 8.32249 2.02094 9.29309 2.85581 9.08437L7.27182 7.98037L7.27182 15.7304L9.27182 15.7304L9.27182 7.98037L13.6878 9.08437C14.5227 9.29309 15.1455 8.3225 14.6079 7.65051Z",
            fill: disable ? "#B5BEDC" : "#FCC778"
        })
    });
    else return null;
};
var $20d975e5e7058386$export$4dc9f58ad9a1a000 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    alignItems: "baseline",
    gap: 8
});
var $20d975e5e7058386$var$DownloadEsisContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    justifyContent: "center"
});
var $20d975e5e7058386$var$DownloadEsisLink = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a({
    fontWeight: 600,
    fontSize: 20,
    margin: "16px 0",
    color: "#073ED9"
});
var $20d975e5e7058386$var$DownloadEsisLinkDisabled = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontWeight: 600,
    fontSize: 20,
    margin: "16px 0",
    color: "#6E717C"
});
var $20d975e5e7058386$var$RateWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($20d975e5e7058386$var$_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "2px solid orange" : "none";
}, function(param) {
    var disable = param.disable;
    return disable ? "0.7" : "1";
});
var $20d975e5e7058386$var$RateCardTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($20d975e5e7058386$var$_templateObject1());
var $20d975e5e7058386$var$RateActionContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($20d975e5e7058386$var$_templateObject2(), (0, (/*@__PURE__*/$parcel$interopDefault($548f2127bbf04648$exports))));
var $20d975e5e7058386$var$RateContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($20d975e5e7058386$var$_templateObject3());
var $20d975e5e7058386$var$RateHighlight = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($20d975e5e7058386$var$_templateObject4());
var $20d975e5e7058386$var$RateDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($20d975e5e7058386$var$_templateObject5());
var $20d975e5e7058386$var$RateCTAs = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($20d975e5e7058386$var$_templateObject6());



var $8c6ug = parcelRequire("8c6ug");


parcelRequire("hAGkE");



var $8c6ug = parcelRequire("8c6ug");



parcelRequire("hAGkE");

function $084442de9a197978$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  gap: 8px;\n\n  & > span {\n    font-weight: 600;\n  }\n"
    ]);
    $084442de9a197978$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $084442de9a197978$export$9811fe609657ae14 = function(param) {
    var formattedTotalLoanAmount = param.formattedTotalLoanAmount, termYears = param.termYears, formattedPropertyValue = param.formattedPropertyValue, productLTV = param.productLTV;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($084442de9a197978$var$SummaryDetailsContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($084442de9a197978$var$SummaryDetail, {
                children: [
                    "Borrowing ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: formattedTotalLoanAmount
                    }),
                    " over ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("b", {
                        children: [
                            termYears,
                            " years"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($084442de9a197978$var$SummaryDetail, {
                children: [
                    "Property value ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: formattedPropertyValue
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($084442de9a197978$var$SummaryDetail, {
                children: [
                    "Loan to value ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                        children: [
                            productLTV,
                            " %"
                        ]
                    })
                ]
            })
        ]
    });
};
var $084442de9a197978$var$SummaryDetailsContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    margin: "0 0 2rem 0"
}, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    gap: "24px",
    padding: "1rem 0",
    borderBottom: "1px solid #B5BEDC",
    borderTop: "1px solid #B5BEDC"
}));
var $084442de9a197978$var$SummaryDetail = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($084442de9a197978$var$_templateObject());





function $4bc1cd0150abdd07$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & > p {\n    margin: 0;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n  }\n"
    ]);
    $4bc1cd0150abdd07$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc1cd0150abdd07$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 39px;\n  font-weight: 550;\n  min-width: 60%;\n"
    ]);
    $4bc1cd0150abdd07$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc1cd0150abdd07$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 18px;\n  font-weight: 600;\n"
    ]);
    $4bc1cd0150abdd07$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $4bc1cd0150abdd07$export$7426c9de2f0518ee = function(param) {
    var identifiedLowerRate = param.identifiedLowerRate, rateCheck = param.rateCheck;
    var _rateCheck_customerProductDetails;
    var _ref = (rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.customerProductDetails) || {}, LenderName = _ref.LenderName, TrueCostOverInitialPeriod = _ref.TrueCostOverInitialPeriod;
    var _ref1 = (rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.productInput) || {}, loanAmount = _ref1.loanAmount, propertyValue = _ref1.propertyValue, termMonths = _ref1.termMonths;
    var formattedRateCheckDate = (0, $f8c373eb33718aa4$export$326be129b2e4eb85)(new Date(rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.lastChecked));
    var formattedTotalLoanAmount = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(loanAmount);
    var formattedPropertyValue = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(propertyValue);
    var termYears = Math.floor(termMonths / 12);
    var productLTV = Math.floor(loanAmount / propertyValue * 100);
    var totalSavingsOverCurrRate = (rateCheck === null || rateCheck === void 0 ? void 0 : (_rateCheck_customerProductDetails = rateCheck.customerProductDetails) === null || _rateCheck_customerProductDetails === void 0 ? void 0 : _rateCheck_customerProductDetails.TrueCostOverInitialPeriod) - TrueCostOverInitialPeriod;
    var completionCutoff = (rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.status) === "stopped-completion-cutoff";
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($4bc1cd0150abdd07$var$HeaderContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($4bc1cd0150abdd07$var$TitleContainer, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Header, {
                        children: "Rate Check Promise"
                    }),
                    rateCheck.lastChecked && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($4bc1cd0150abdd07$var$SummaryCheckDateDesktop, {
                        children: [
                            "Last rate check:",
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                children: formattedRateCheckDate
                            })
                        ]
                    })
                ]
            }),
            completionCutoff ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($4bc1cd0150abdd07$var$TextContainer, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                            children: "Your final rate is confirmed"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "You\u2018re nearly at completion! Here\u2018s confirmation of your final rate."
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Found && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($4bc1cd0150abdd07$var$TextContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                                children: "We\u2019ve found you a lower rate"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                children: [
                                    "Great news! Your chosen lender ",
                                    LenderName,
                                    " has lowered their interest rates. You can review the new rate below and if you\u2019d like to switch, simply request it below. We\u2019ll begin the process as long as there\u2019s time before your completion date."
                                ]
                            })
                        ]
                    }),
                    (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Progressing && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                                children: "We\u2019re requesting your new interest rate"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                children: [
                                    "Thanks! We\u2019ll contact ",
                                    LenderName,
                                    " to request the switch to your new rate. Please note, lenders have varying timescales and if you are too close to completion, it may not be approved. We\u2019ll update you once it\u2019s confirmed."
                                ]
                            })
                        ]
                    }),
                    (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Declined && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($4bc1cd0150abdd07$var$TextContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                                children: "You\u2019re staying with your current rate"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                children: [
                                    "Thank you for confirming your choice. We\u2019ll keep you on your current rate. We\u2019ll continue to monitor the market and update you again if there is a lower rate with",
                                    " ",
                                    LenderName,
                                    " available."
                                ]
                            })
                        ]
                    }),
                    ((identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Cancelled || (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Expired) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                                children: "We\u2019re monitoring for lower rates"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                children: [
                                    "We\u2019re still keeping any eye on the ",
                                    LenderName,
                                    "\u2019s rates, and will update you if they lower. Right now, you\u2019re still on the lowest rate for your chosen deal with",
                                    " ",
                                    LenderName,
                                    "."
                                ]
                            })
                        ]
                    }),
                    (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Completed && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                                children: "You\u2019ve moved onto a lower rate"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                children: [
                                    "Great news! ",
                                    LenderName,
                                    " have approved the move onto the lower rate, meaning you\u2019ve just saved ",
                                    (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(totalSavingsOverCurrRate),
                                    " in interest over the initial period of your mortgage."
                                ]
                            })
                        ]
                    }),
                    !identifiedLowerRate && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($4bc1cd0150abdd07$var$Subheader, {
                                children: "Monitoring for lower rates"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                children: "Our Rate Check Promise technology reviews the market daily for lower rates with the lender you have applied with. If we find a lower rate, and can switch you before your completion date, we\u2019ll notify you immediately."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $084442de9a197978$export$9811fe609657ae14), {
                formattedTotalLoanAmount: formattedTotalLoanAmount,
                termYears: termYears,
                formattedPropertyValue: formattedPropertyValue,
                productLTV: productLTV
            })
        ]
    });
};
var $4bc1cd0150abdd07$var$TextContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    margin: "1rem 0"
});
var $4bc1cd0150abdd07$var$HeaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($4bc1cd0150abdd07$var$_templateObject());
var $4bc1cd0150abdd07$var$Header = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($4bc1cd0150abdd07$var$_templateObject1());
var $4bc1cd0150abdd07$var$TitleContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    justifyContent: "space-between"
}, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column",
    justifyContent: "start"
}));
var $4bc1cd0150abdd07$var$Subheader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($4bc1cd0150abdd07$var$_templateObject2());
var $4bc1cd0150abdd07$var$_obj;
var $4bc1cd0150abdd07$var$SummaryCheckDateDesktop = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($4bc1cd0150abdd07$var$_obj = {
    display: "flex",
    alignSelf: "top"
}, (0, $8c6ug._)($4bc1cd0150abdd07$var$_obj, "& > span", {
    marginLeft: "1rem"
}), (0, $8c6ug._)($4bc1cd0150abdd07$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    display: "none"
}), (0, $8c6ug._)($4bc1cd0150abdd07$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    display: "none"
}), $4bc1cd0150abdd07$var$_obj));



var $8c6ug = parcelRequire("8c6ug");


parcelRequire("hAGkE");






parcelRequire("hAGkE");
var $0efc45c7287da52c$exports = {};
$0efc45c7287da52c$exports = $parcel$resolve("iwp2C");


var $92ddd88ffae7b8ff$exports = {};
$92ddd88ffae7b8ff$exports = $parcel$resolve("2Qviu");


var $c60b1adf36c6d8a9$exports = {};
$c60b1adf36c6d8a9$exports = $parcel$resolve("fFhxo");


var $f1eedf3aa587317c$exports = {};
$f1eedf3aa587317c$exports = $parcel$resolve("8XVKc");


var $0509d2c540bd3462$exports = {};
$0509d2c540bd3462$exports = $parcel$resolve("3wsC5");


var $e38755461bbba06f$exports = {};
$e38755461bbba06f$exports = $parcel$resolve("9DUOS");


var $30ebfd813e7fe927$exports = {};
$30ebfd813e7fe927$exports = $parcel$resolve("kG3wS");


var $3d3e5baacb863116$exports = {};
$3d3e5baacb863116$exports = $parcel$resolve("3BcsB");


var $d65625cac9f4ce5a$exports = {};
$d65625cac9f4ce5a$exports = $parcel$resolve("c0AjW");


var $e96a4c5b4e99e02b$exports = {};
$e96a4c5b4e99e02b$exports = $parcel$resolve("d5lIJ");


var $1dcf217bfdd2b676$exports = {};
$1dcf217bfdd2b676$exports = $parcel$resolve("dU4fz");


var $e5f2dbcdcf43b7c3$exports = {};
$e5f2dbcdcf43b7c3$exports = $parcel$resolve("gHHSx");


var $33cb71f69d3fd199$exports = {};
$33cb71f69d3fd199$exports = $parcel$resolve("1tbEn");


var $9212f2e5d7320264$exports = {};
$9212f2e5d7320264$exports = $parcel$resolve("gPjRN");


var $f37d84284fbb7f10$exports = {};
$f37d84284fbb7f10$exports = $parcel$resolve("7gYuS");


var $1556f56548b87c60$exports = {};
$1556f56548b87c60$exports = $parcel$resolve("35p9V");


var $99e6071f03d7c894$exports = {};
$99e6071f03d7c894$exports = $parcel$resolve("kbP7d");


var $fbcfd64ca95b2260$exports = {};
$fbcfd64ca95b2260$exports = $parcel$resolve("15vxj");


var $7f98f3c52f4cc10f$exports = {};
$7f98f3c52f4cc10f$exports = $parcel$resolve("134rH");


var $e39daa38cf196181$exports = {};
$e39daa38cf196181$exports = $parcel$resolve("gLpYs");


var $7e134591de1923c5$exports = {};
$7e134591de1923c5$exports = $parcel$resolve("bI2EV");


var $1d58b588e6153f0e$exports = {};
$1d58b588e6153f0e$exports = $parcel$resolve("6yn3p");


var $a5b12f987bfeca92$exports = {};
$a5b12f987bfeca92$exports = $parcel$resolve("bRqhc");


var $0c09f1df53f7d209$exports = {};
$0c09f1df53f7d209$exports = $parcel$resolve("6Yi01");


var $19d003764ed254c5$exports = {};
$19d003764ed254c5$exports = $parcel$resolve("1hEwf");


var $ac968029ec22cd4e$exports = {};
$ac968029ec22cd4e$exports = $parcel$resolve("iUlOc");


var $408baacee6c217af$exports = {};
$408baacee6c217af$exports = $parcel$resolve("l2z3D");


var $16063fb73c70fe08$exports = {};
$16063fb73c70fe08$exports = $parcel$resolve("1DUP0");


var $3890881a1590f661$exports = {};
$3890881a1590f661$exports = $parcel$resolve("bvhVK");


var $5e5b7677872fd52c$exports = {};
$5e5b7677872fd52c$exports = $parcel$resolve("7a6gN");


var $098ad9e5d87660fe$exports = {};
$098ad9e5d87660fe$exports = $parcel$resolve("4OiRP");


var $cd3430d55d0566c5$exports = {};
$cd3430d55d0566c5$exports = $parcel$resolve("5u2Rt");


var $9777123119c99085$exports = {};
$9777123119c99085$exports = $parcel$resolve("fkRve");


var $f1b82724c15eb9d2$exports = {};
$f1b82724c15eb9d2$exports = $parcel$resolve("6Uaqv");


var $ea215c24df23aa3a$exports = {};
$ea215c24df23aa3a$exports = $parcel$resolve("iBOT0");


var $96bb9dfe48f7fb4d$exports = {};
$96bb9dfe48f7fb4d$exports = $parcel$resolve("2R5dp");


var $1a400656bd0267b9$exports = {};
$1a400656bd0267b9$exports = $parcel$resolve("6ogJH");


var $f45860d3394fd441$exports = {};
$f45860d3394fd441$exports = $parcel$resolve("3BePJ");


var $2e17472ad3c44731$exports = {};
$2e17472ad3c44731$exports = $parcel$resolve("24B14");


var $e0e2fd6c82bfe480$exports = {};
$e0e2fd6c82bfe480$exports = $parcel$resolve("7xI3N");


var $2f0d74224b4af5bd$exports = {};
$2f0d74224b4af5bd$exports = $parcel$resolve("jMAAg");


var $69a429b4469297de$exports = {};
$69a429b4469297de$exports = $parcel$resolve("iE8Nx");


var $4eb268d52f7970e3$exports = {};
$4eb268d52f7970e3$exports = $parcel$resolve("3K3VW");


var $cb32c6b952445412$exports = {};
$cb32c6b952445412$exports = $parcel$resolve("1ltwO");


var $74183225e644af0a$exports = {};
$74183225e644af0a$exports = $parcel$resolve("dzls9");


var $97c899a48244fd96$exports = {};
$97c899a48244fd96$exports = $parcel$resolve("lgmyQ");


var $00aeff662d3a4647$exports = {};
$00aeff662d3a4647$exports = $parcel$resolve("8bBlg");


var $8a631646da94dc2b$exports = {};
$8a631646da94dc2b$exports = $parcel$resolve("g5fPN");


var $e033c316123822c6$exports = {};
$e033c316123822c6$exports = $parcel$resolve("aOf4a");


var $9bf8d4480545e9fb$exports = {};
$9bf8d4480545e9fb$exports = $parcel$resolve("kuwEJ");


var $7754041a26a7018f$exports = {};
$7754041a26a7018f$exports = $parcel$resolve("3r9Em");


var $c44bb67f0b329ece$exports = {};
$c44bb67f0b329ece$exports = $parcel$resolve("7SeuN");


var $46b7d2c709acd676$exports = {};
$46b7d2c709acd676$exports = $parcel$resolve("elgOx");


var $f0748c286b41b270$exports = {};
$f0748c286b41b270$exports = $parcel$resolve("lyM2L");


var $617a6d5ba66b131c$exports = {};
$617a6d5ba66b131c$exports = $parcel$resolve("1LuZ7");


var $71075b95b6ae209e$exports = {};
$71075b95b6ae209e$exports = $parcel$resolve("lKArV");


var $82dbd9a6269cfa16$exports = {};
$82dbd9a6269cfa16$exports = $parcel$resolve("hdk91");


var $e2de1413b75802d8$exports = {};
$e2de1413b75802d8$exports = $parcel$resolve("1pOFc");


var $d95cfea568482685$exports = {};
$d95cfea568482685$exports = $parcel$resolve("mhlct");


var $3d939ac7c894947b$exports = {};
$3d939ac7c894947b$exports = $parcel$resolve("9V0TU");


var $4b2871f9f05d6774$exports = {};
$4b2871f9f05d6774$exports = $parcel$resolve("5nIfC");


var $e5e179f27fb8cfcc$exports = {};
$e5e179f27fb8cfcc$exports = $parcel$resolve("ENcx7");


var $d46e6a00c3beaef0$exports = {};
$d46e6a00c3beaef0$exports = $parcel$resolve("4ThAc");


var $d156f2160e91900f$exports = {};
$d156f2160e91900f$exports = $parcel$resolve("6s1bH");


var $21b90213b1633c89$exports = {};
$21b90213b1633c89$exports = $parcel$resolve("7FnL2");


var $c722ddbd7936665d$exports = {};
$c722ddbd7936665d$exports = $parcel$resolve("5yq5g");


var $78a3608c9fc695b3$exports = {};
$78a3608c9fc695b3$exports = $parcel$resolve("d4EpH");


var $26e1faf58b0084da$exports = {};
$26e1faf58b0084da$exports = $parcel$resolve("hfz4q");


var $2afb44d2a30ae90b$exports = {};
$2afb44d2a30ae90b$exports = $parcel$resolve("jmC4G");


var $80725c859c9bbc9b$exports = {};
$80725c859c9bbc9b$exports = $parcel$resolve("bAiod");


var $103a7ca2f6541450$exports = {};
$103a7ca2f6541450$exports = $parcel$resolve("2sBLm");


var $5b6eb54be2c03e28$exports = {};
$5b6eb54be2c03e28$exports = $parcel$resolve("jrAmh");


var $d1f3c0de49d3679a$exports = {};
$d1f3c0de49d3679a$exports = $parcel$resolve("glUg3");


var $e9969e58d85127f3$exports = {};
$e9969e58d85127f3$exports = $parcel$resolve("gYb8q");


var $349b25b3c09a921f$exports = {};
$349b25b3c09a921f$exports = $parcel$resolve("hGlm8");


var $e6dcd7d83ccd71d1$exports = {};
$e6dcd7d83ccd71d1$exports = $parcel$resolve("bF95G");


var $8214382a6a9bc906$exports = {};
$8214382a6a9bc906$exports = $parcel$resolve("83WTd");


var $bbe4ed016d2bce72$exports = {};
$bbe4ed016d2bce72$exports = $parcel$resolve("hLI8V");


var $2399e9620e113ea9$exports = {};
$2399e9620e113ea9$exports = $parcel$resolve("7GhUx");


var $4448e81f9123ec09$exports = {};
$4448e81f9123ec09$exports = $parcel$resolve("9NfYy");


var $4eb5cf53c8d21ad0$exports = {};
$4eb5cf53c8d21ad0$exports = $parcel$resolve("eOiGk");


var $9a0d626b04603339$exports = {};
$9a0d626b04603339$exports = $parcel$resolve("hz1wC");


var $83ad95fa4f0a2e63$exports = {};
$83ad95fa4f0a2e63$exports = $parcel$resolve("a7w62");


var $87e2e620f997f7d1$exports = {};
$87e2e620f997f7d1$exports = $parcel$resolve("jRCIo");


var $3d735b9a4f327f87$exports = {};
$3d735b9a4f327f87$exports = $parcel$resolve("kviWp");


var $5d982a39d1e76cab$exports = {};
$5d982a39d1e76cab$exports = $parcel$resolve("bNS6f");


var $e894489f7453e8c7$exports = {};
$e894489f7453e8c7$exports = $parcel$resolve("aeHNe");


var $b986c37843b609f1$exports = {};
$b986c37843b609f1$exports = $parcel$resolve("6jBZP");


var $8b8343f357045e44$exports = {};
$8b8343f357045e44$exports = $parcel$resolve("fyOU8");


var $ab42dfc80b066c27$exports = {};
$ab42dfc80b066c27$exports = $parcel$resolve("1IluC");


var $ca82a8a138fecd9b$exports = {};
$ca82a8a138fecd9b$exports = $parcel$resolve("3WFzo");


var $c9343150af68b70c$exports = {};
$c9343150af68b70c$exports = $parcel$resolve("1VLrg");


var $4a6c534c182bdf78$exports = {};
$4a6c534c182bdf78$exports = $parcel$resolve("7FWao");


var $17145d4248e07845$exports = {};
$17145d4248e07845$exports = $parcel$resolve("6rhJd");


var $b62badfae448be7b$exports = {};
$b62badfae448be7b$exports = $parcel$resolve("8269u");


var $12a0948544eb30aa$exports = {};
$12a0948544eb30aa$exports = $parcel$resolve("iKcMa");


var $9aa8d238bfd4efd8$exports = {};
$9aa8d238bfd4efd8$exports = $parcel$resolve("lu2Ug");


var $3296c95d35f0e0e7$exports = {};
$3296c95d35f0e0e7$exports = $parcel$resolve("4hySQ");


var $57a7492db9d7ce1f$exports = {};
$57a7492db9d7ce1f$exports = $parcel$resolve("ex2Fd");


var $bc412b6d47b8b023$exports = {};
$bc412b6d47b8b023$exports = $parcel$resolve("g6lHy");


var $72293d42f2127b38$exports = {};
$72293d42f2127b38$exports = $parcel$resolve("cG1XY");


var $d4cbf8679f065539$exports = {};
$d4cbf8679f065539$exports = $parcel$resolve("9nyk7");


var $dec3b61260b9e604$exports = {};
$dec3b61260b9e604$exports = $parcel$resolve("e72hx");


var $615974ed3c5e28b8$exports = {};
$615974ed3c5e28b8$exports = $parcel$resolve("fS3ui");


var $ac9e8dea13dff8f6$exports = {};
$ac9e8dea13dff8f6$exports = $parcel$resolve("1mm1Q");


var $a2814df677ff1051$exports = {};
$a2814df677ff1051$exports = $parcel$resolve("50NRi");


var $bac91e368b1f50cd$exports = {};
$bac91e368b1f50cd$exports = $parcel$resolve("7a9YT");


var $12dced1c1d115545$export$55b7fc09712f8edd = function(param) {
    var white = param.white, lenderName = param.lenderName;
    var lenderImagesRegular = {
        Accord: (0, (/*@__PURE__*/$parcel$interopDefault($0efc45c7287da52c$exports))),
        AIB: (0, (/*@__PURE__*/$parcel$interopDefault($92ddd88ffae7b8ff$exports))),
        "Aldermore Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($c60b1adf36c6d8a9$exports))),
        "Atom Bank": (0, (/*@__PURE__*/$parcel$interopDefault($f1eedf3aa587317c$exports))),
        "Bank of Ireland": (0, (/*@__PURE__*/$parcel$interopDefault($0509d2c540bd3462$exports))),
        "Barclays Bank": (0, (/*@__PURE__*/$parcel$interopDefault($e38755461bbba06f$exports))),
        "Bath Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($30ebfd813e7fe927$exports))),
        "Beverley Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($3d3e5baacb863116$exports))),
        "Birmingham Midshires": (0, (/*@__PURE__*/$parcel$interopDefault($d65625cac9f4ce5a$exports))),
        "Bluestone Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($e96a4c5b4e99e02b$exports))),
        "BM Solutions": (0, (/*@__PURE__*/$parcel$interopDefault($1dcf217bfdd2b676$exports))),
        "Cambridge Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($e5f2dbcdcf43b7c3$exports))),
        "Chorley Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($33cb71f69d3fd199$exports))),
        "Clydesdale Bank": (0, (/*@__PURE__*/$parcel$interopDefault($9212f2e5d7320264$exports))),
        "Coventry Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($f37d84284fbb7f10$exports))),
        "Digital Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($1556f56548b87c60$exports))),
        "Foundation Home Loans": (0, (/*@__PURE__*/$parcel$interopDefault($99e6071f03d7c894$exports))),
        "Furness Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($fbcfd64ca95b2260$exports))),
        "Generation Home": (0, (/*@__PURE__*/$parcel$interopDefault($7f98f3c52f4cc10f$exports))),
        "Godiva Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($e39daa38cf196181$exports))),
        Halifax: (0, (/*@__PURE__*/$parcel$interopDefault($7e134591de1923c5$exports))),
        "Hinckley and Rugby Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($1d58b588e6153f0e$exports))),
        HSBC: (0, (/*@__PURE__*/$parcel$interopDefault($a5b12f987bfeca92$exports))),
        "Kensington Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($0c09f1df53f7d209$exports))),
        "Kent Reliance": (0, (/*@__PURE__*/$parcel$interopDefault($19d003764ed254c5$exports))),
        Landbay: (0, (/*@__PURE__*/$parcel$interopDefault($ac968029ec22cd4e$exports))),
        "Leeds Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($408baacee6c217af$exports))),
        "Leek United Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($16063fb73c70fe08$exports))),
        "Lloyds Bank": (0, (/*@__PURE__*/$parcel$interopDefault($3890881a1590f661$exports))),
        "Mansfield Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($5e5b7677872fd52c$exports))),
        "Metro Bank": (0, (/*@__PURE__*/$parcel$interopDefault($098ad9e5d87660fe$exports))),
        "Melton Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($cd3430d55d0566c5$exports))),
        "Monmouthshire Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($9777123119c99085$exports))),
        "Mortgage Works": (0, (/*@__PURE__*/$parcel$interopDefault($f1b82724c15eb9d2$exports))),
        "Nationwide Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($ea215c24df23aa3a$exports))),
        Natwest: (0, (/*@__PURE__*/$parcel$interopDefault($96bb9dfe48f7fb4d$exports))),
        "Newcastle Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($1a400656bd0267b9$exports))),
        "Newbury Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($f45860d3394fd441$exports))),
        "Nottingham Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($2e17472ad3c44731$exports))),
        "Paragon Bank": (0, (/*@__PURE__*/$parcel$interopDefault($e0e2fd6c82bfe480$exports))),
        "Pepper Money": (0, (/*@__PURE__*/$parcel$interopDefault($2f0d74224b4af5bd$exports))),
        Platform: (0, (/*@__PURE__*/$parcel$interopDefault($69a429b4469297de$exports))),
        "Post Office": (0, (/*@__PURE__*/$parcel$interopDefault($4eb268d52f7970e3$exports))),
        "Precise Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($cb32c6b952445412$exports))),
        Principality: (0, (/*@__PURE__*/$parcel$interopDefault($74183225e644af0a$exports))),
        "Progressive Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($97c899a48244fd96$exports))),
        "Royal Bank of Scotland": (0, (/*@__PURE__*/$parcel$interopDefault($00aeff662d3a4647$exports))),
        "Santander UK Plc": (0, (/*@__PURE__*/$parcel$interopDefault($8a631646da94dc2b$exports))),
        "Scottish Widows Bank": (0, (/*@__PURE__*/$parcel$interopDefault($e033c316123822c6$exports))),
        "Skipton Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($9bf8d4480545e9fb$exports))),
        Together: (0, (/*@__PURE__*/$parcel$interopDefault($7754041a26a7018f$exports))),
        TSB: (0, (/*@__PURE__*/$parcel$interopDefault($c44bb67f0b329ece$exports))),
        "Vida Homeloans": (0, (/*@__PURE__*/$parcel$interopDefault($46b7d2c709acd676$exports))),
        "Virgin Money": (0, (/*@__PURE__*/$parcel$interopDefault($f0748c286b41b270$exports)))
    };
    var lenderImagesWhite = {
        Accord: (0, (/*@__PURE__*/$parcel$interopDefault($617a6d5ba66b131c$exports))),
        AIB: (0, (/*@__PURE__*/$parcel$interopDefault($92ddd88ffae7b8ff$exports))),
        "Aldermore Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($71075b95b6ae209e$exports))),
        "Atom Bank": (0, (/*@__PURE__*/$parcel$interopDefault($82dbd9a6269cfa16$exports))),
        "Bank of Ireland": (0, (/*@__PURE__*/$parcel$interopDefault($e2de1413b75802d8$exports))),
        "Barclays Bank": (0, (/*@__PURE__*/$parcel$interopDefault($d95cfea568482685$exports))),
        "Bath Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($3d939ac7c894947b$exports))),
        "Beverley Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($4b2871f9f05d6774$exports))),
        "Birmingham Midshires": (0, (/*@__PURE__*/$parcel$interopDefault($e5e179f27fb8cfcc$exports))),
        "Bluestone Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($d46e6a00c3beaef0$exports))),
        "BM Solutions": (0, (/*@__PURE__*/$parcel$interopDefault($d156f2160e91900f$exports))),
        "Cambridge Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($21b90213b1633c89$exports))),
        "Chorley Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($c722ddbd7936665d$exports))),
        "Clydesdale Bank": (0, (/*@__PURE__*/$parcel$interopDefault($78a3608c9fc695b3$exports))),
        "Coventry Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($26e1faf58b0084da$exports))),
        "Digital Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($2afb44d2a30ae90b$exports))),
        "Foundation Home Loans": (0, (/*@__PURE__*/$parcel$interopDefault($80725c859c9bbc9b$exports))),
        "Furness Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($103a7ca2f6541450$exports))),
        "Generation Home": (0, (/*@__PURE__*/$parcel$interopDefault($5b6eb54be2c03e28$exports))),
        "Godiva Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($d1f3c0de49d3679a$exports))),
        Halifax: (0, (/*@__PURE__*/$parcel$interopDefault($e9969e58d85127f3$exports))),
        "Hinckley and Rugby Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($349b25b3c09a921f$exports))),
        HSBC: (0, (/*@__PURE__*/$parcel$interopDefault($e6dcd7d83ccd71d1$exports))),
        "Kensington Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($8214382a6a9bc906$exports))),
        "Kent Reliance": (0, (/*@__PURE__*/$parcel$interopDefault($bbe4ed016d2bce72$exports))),
        Landbay: (0, (/*@__PURE__*/$parcel$interopDefault($2399e9620e113ea9$exports))),
        "Leeds Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($4448e81f9123ec09$exports))),
        "Leek United Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($4eb5cf53c8d21ad0$exports))),
        "Lloyds Bank": (0, (/*@__PURE__*/$parcel$interopDefault($9a0d626b04603339$exports))),
        "Mansfield Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($83ad95fa4f0a2e63$exports))),
        "Metro Bank": (0, (/*@__PURE__*/$parcel$interopDefault($87e2e620f997f7d1$exports))),
        "Melton Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($3d735b9a4f327f87$exports))),
        "Monmouthshire Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($5d982a39d1e76cab$exports))),
        "Mortgage Works": (0, (/*@__PURE__*/$parcel$interopDefault($e894489f7453e8c7$exports))),
        "Nationwide Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($b986c37843b609f1$exports))),
        Natwest: (0, (/*@__PURE__*/$parcel$interopDefault($8b8343f357045e44$exports))),
        "Newcastle Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($ab42dfc80b066c27$exports))),
        "Newbury Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($ca82a8a138fecd9b$exports))),
        "Nottingham Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($c9343150af68b70c$exports))),
        "Paragon Bank": (0, (/*@__PURE__*/$parcel$interopDefault($4a6c534c182bdf78$exports))),
        "Pepper Money": (0, (/*@__PURE__*/$parcel$interopDefault($17145d4248e07845$exports))),
        Platform: (0, (/*@__PURE__*/$parcel$interopDefault($b62badfae448be7b$exports))),
        "Post Office": (0, (/*@__PURE__*/$parcel$interopDefault($12a0948544eb30aa$exports))),
        "Precise Mortgages": (0, (/*@__PURE__*/$parcel$interopDefault($9aa8d238bfd4efd8$exports))),
        Principality: (0, (/*@__PURE__*/$parcel$interopDefault($3296c95d35f0e0e7$exports))),
        "Progressive Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($57a7492db9d7ce1f$exports))),
        "Royal Bank of Scotland": (0, (/*@__PURE__*/$parcel$interopDefault($bc412b6d47b8b023$exports))),
        "Santander UK Plc": (0, (/*@__PURE__*/$parcel$interopDefault($72293d42f2127b38$exports))),
        "Scottish Widows Bank": (0, (/*@__PURE__*/$parcel$interopDefault($d4cbf8679f065539$exports))),
        "Skipton Building Society": (0, (/*@__PURE__*/$parcel$interopDefault($dec3b61260b9e604$exports))),
        Together: (0, (/*@__PURE__*/$parcel$interopDefault($615974ed3c5e28b8$exports))),
        TSB: (0, (/*@__PURE__*/$parcel$interopDefault($ac9e8dea13dff8f6$exports))),
        "Vida Homeloans": (0, (/*@__PURE__*/$parcel$interopDefault($a2814df677ff1051$exports))),
        "Virgin Money": (0, (/*@__PURE__*/$parcel$interopDefault($bac91e368b1f50cd$exports)))
    };
    var lenderImages = white ? lenderImagesWhite : lenderImagesRegular;
    var imageSrc = lenderImages[lenderName];
    if (imageSrc) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
        src: imageSrc,
        alt: "Mortgage lender ".concat(lenderName),
        style: {
            width: "100px"
        }
    });
    else return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {});
};
var $12dced1c1d115545$export$2e2bcd8739ae039 = $12dced1c1d115545$export$55b7fc09712f8edd;


function $e14805868db04869$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  /* flex: 100%; */\n  flex-wrap: wrap;\n  overflow: hidden;\n  justify-content: end;\n"
    ]);
    $e14805868db04869$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e14805868db04869$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 24px;\n  padding: 12px 8px;\n  background: #d3ddf9;\n\n  & > span {\n    font-size: 12px;\n  }\n"
    ]);
    $e14805868db04869$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $e14805868db04869$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #eef5f3;\n  border-radius: 16px;\n  padding: 32px;\n  border: 1px solid #d4efee;\n\n  & > span {\n    font-weight: 600;\n  }\n"
    ]);
    $e14805868db04869$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $e14805868db04869$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #faf1ee;\n  border-radius: 16px;\n  padding: 32px;\n  border: 1px solid #f2d0dc;\n\n  & > span {\n    font-weight: 600;\n  }\n"
    ]);
    $e14805868db04869$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $e14805868db04869$export$dfb9a928b0e68c9f = function(param) {
    var identifiedLowerRate = param.identifiedLowerRate, rateCheck = param.rateCheck;
    var _identifiedLowerRate_productDetails, _identifiedLowerRate_productDetails1, _identifiedLowerRate_productDetails2;
    var _ref = (rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.customerProductDetails) || {}, LenderName = _ref.LenderName, Cashback = _ref.Cashback, FreeLegalFees = _ref.FreeLegalFees, ValuationFee = _ref.ValuationFee, TrueCostOverInitialPeriod = _ref.TrueCostOverInitialPeriod, InitialMonthlyPayment = _ref.InitialMonthlyPayment, InitialMonthlyPaymentIncludingFees = _ref.InitialMonthlyPaymentIncludingFees;
    var _ref1 = (rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.productInput) || {}, mortgageClass = _ref1.mortgageClass, addFeesToLoan = _ref1.addFeesToLoan;
    var ilrMonthlyPayment = addFeesToLoan ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : (_identifiedLowerRate_productDetails = identifiedLowerRate.productDetails) === null || _identifiedLowerRate_productDetails === void 0 ? void 0 : _identifiedLowerRate_productDetails.InitialMonthlyPaymentIncludingFees) : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : (_identifiedLowerRate_productDetails1 = identifiedLowerRate.productDetails) === null || _identifiedLowerRate_productDetails1 === void 0 ? void 0 : _identifiedLowerRate_productDetails1.InitialMonthlyPayment);
    var monthlyPayment = addFeesToLoan ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPaymentIncludingFees) : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPayment);
    var formattedCashback = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(Cashback);
    var totalSavings = TrueCostOverInitialPeriod - (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : (_identifiedLowerRate_productDetails2 = identifiedLowerRate.productDetails) === null || _identifiedLowerRate_productDetails2 === void 0 ? void 0 : _identifiedLowerRate_productDetails2.TrueCostOverInitialPeriod);
    var formattedRateCheckDate = (0, $f8c373eb33718aa4$export$326be129b2e4eb85)(new Date(rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.lastChecked));
    var totalMonthlySavings = monthlyPayment - ilrMonthlyPayment;
    var formattedTotalSavings = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(totalSavings);
    var formattedTotalMonthlySavings = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(totalMonthlySavings);
    var completionCutoff = (rateCheck === null || rateCheck === void 0 ? void 0 : rateCheck.status) === "stopped-completion-cutoff";
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$SummaryWrapper, {
        bg: completionCutoff,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$SummaryProductDetails, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$ProductDetailsWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$SummaryIcon, {
                            bg: completionCutoff,
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $12dced1c1d115545$export$2e2bcd8739ae039), {
                                lenderName: LenderName
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$ProductExtrasWrapper, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$ProductExtras, {
                                bg: completionCutoff,
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$ExtrasList, {
                                    "aria-label": "Extras",
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$ExtraPill, {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                children: mortgageClass
                                            })
                                        }),
                                        Cashback > 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$ExtraPill, {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                                                children: [
                                                    formattedCashback,
                                                    " Cashback"
                                                ]
                                            })
                                        }),
                                        FreeLegalFees && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$ExtraPill, {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                children: "Free standard legal costs"
                                            })
                                        }),
                                        ValuationFee === 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e14805868db04869$var$ExtraPill, {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                children: "Free valuation"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            rateCheck.lastChecked && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$SummaryCheckDateMobile, {
                children: [
                    "Last rate check:",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: formattedRateCheckDate
                    })
                ]
            }),
            (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Progressing && totalMonthlySavings > 0 && totalSavings > 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$SummaryMessage, {
                children: [
                    "This new deal would ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                        children: [
                            "save you ",
                            formattedTotalMonthlySavings
                        ]
                    }),
                    " a month. You\u2019d",
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                        children: [
                            "save ",
                            formattedTotalSavings,
                            " in interest"
                        ]
                    }),
                    " over the fixed period, compared to your current rate."
                ]
            }),
            (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Expired && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$AlertSummaryMessage, {
                children: [
                    "Unfortunately this new rate is no longer available. We will continue monitoring the rates from ",
                    LenderName,
                    " and will notify you by email and SMS if rates lower again."
                ]
            }),
            (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Cancelled && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e14805868db04869$var$AlertSummaryMessage, {
                children: [
                    "Unfortunately your application for the new rate with ",
                    LenderName,
                    " has been declined. Your Case Manager will be in contact with you to provide you with more detail."
                ]
            })
        ]
    });
};
var $e14805868db04869$var$SummaryWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var bg = param.bg;
    return (0, $8c6ug._)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        gap: "8px"
    }, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
        backgroundColor: bg ? "white" : "transparent",
        padding: bg ? "0.5rem" : 0,
        borderRadius: bg ? "8px" : 0
    });
});
var $e14805868db04869$var$SummaryProductDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    gap: "32px",
    flex: 5
}, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    justifyContent: "end",
    alignItems: "end"
}));
var $e14805868db04869$var$ProductDetailsWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
});
var $e14805868db04869$var$ProductExtrasWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($e14805868db04869$var$_templateObject());
var $e14805868db04869$var$SummaryIcon = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var bg = param.bg;
    return {
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        backgroundColor: bg ? "white" : "transparent",
        padding: bg ? "0.5rem" : 0,
        borderRadius: bg ? "8px" : 0,
        marginRight: "10px"
    };
});
var $e14805868db04869$var$ProductExtras = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var bg = param.bg;
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "end",
        width: "fit-content",
        backgroundColor: bg ? "white" : "transparent",
        padding: bg ? "0.5rem" : 0,
        borderRadius: bg ? "8px" : 0,
        marginRight: "10px"
    };
});
var $e14805868db04869$var$ExtrasList = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul((0, $8c6ug._)({
    display: "flex",
    borderRadius: "16px",
    flexWrap: "wrap",
    padding: 0,
    gap: "8px"
}, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "8px"
}));
var $e14805868db04869$var$ExtraPill = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($e14805868db04869$var$_templateObject1());
var $e14805868db04869$var$_obj;
var $e14805868db04869$var$SummaryCheckDateMobile = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($e14805868db04869$var$_obj = {
    display: "flex",
    marginTop: "1rem",
    justifyContent: "start"
}, (0, $8c6ug._)($e14805868db04869$var$_obj, "& > span", {
    marginLeft: "1rem"
}), (0, $8c6ug._)($e14805868db04869$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    display: "none"
}), $e14805868db04869$var$_obj));
var $e14805868db04869$var$SummaryMessage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($e14805868db04869$var$_templateObject2());
var $e14805868db04869$var$AlertSummaryMessage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($e14805868db04869$var$_templateObject3());



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");



var $e4c3a56b5e374926$var$ToastButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1))((0, $8c6ug._)({
    width: "100%",
    background: "#1a3dd1",
    color: "#fff",
    textAlign: "center",
    boxShadow: "inset 0 -6px 0px #052ea3"
}, "@media screen and ".concat((0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm), {
    width: "auto"
}));
var $e4c3a56b5e374926$var$CheckSvg = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
        width: "31",
        height: "30",
        viewBox: "0 0 31 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.9856 6.91546L10.8429 27.1L1.01465 16.7369L3.73559 14.1564L10.8429 21.6505L27.2647 4.33496L29.9856 6.91546Z",
            fill: "#038352"
        })
    });
};
var $e4c3a56b5e374926$var$ModalContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backgroundColor: "rgba(0, 0, 0, 0.5)"
});
var $e4c3a56b5e374926$var$RateRequestedContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "white",
    borderRadius: "32px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    overflow: "hidden"
});
var $e4c3a56b5e374926$var$RateRequestedHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem 2rem",
    backgroundColor: "#EDF5F3",
    color: "#3B4258",
    fontWeight: 600,
    fontSize: "1.5rem"
});
var $e4c3a56b5e374926$var$CheckIcon = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "12px"
});
var $e4c3a56b5e374926$var$RateRequestedContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    padding: "2rem",
    gap: "0.5rem",
    display: "flex",
    flexDirection: "column"
});
var $e4c3a56b5e374926$var$RateRequestedNote = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    backgroundColor: "#FFF5F5",
    borderRadius: "32px",
    padding: "1.5rem",
    margin: "1rem 0"
});
var $e4c3a56b5e374926$var$ButtonContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    justifyContent: "center",
    padding: "0 1rem"
});
var $e4c3a56b5e374926$export$4eb75d93115a3d90 = function(param) {
    var onClose = param.onClose;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e4c3a56b5e374926$var$ModalContainer, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e4c3a56b5e374926$var$RateRequestedContainer, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e4c3a56b5e374926$var$RateRequestedHeader, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e4c3a56b5e374926$var$CheckIcon, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e4c3a56b5e374926$var$CheckSvg, {})
                        }),
                        "Rate Requested"
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e4c3a56b5e374926$var$RateRequestedContent, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                            children: "Great! Your request will now go to your Mortgage Expert for review."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e4c3a56b5e374926$var$RateRequestedNote, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: "Note:"
                                }),
                                " If you're too close to completion, the lender might not allow us to switch you to the new rate"
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e4c3a56b5e374926$var$ButtonContainer, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e4c3a56b5e374926$var$ToastButton, {
                                onClick: onClose,
                                width: "auto",
                                type: 2,
                                text: "OK",
                                style: {
                                    alignSelf: "center"
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};


var $899d3ee31a55aa5b$exports = {};
$899d3ee31a55aa5b$exports = $parcel$resolve("dfJqe");


function $3d0fda5c3a8cdefd$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  gap: 12px;\n  background: #f3f5fc;\n  padding: 24px;\n  text-align: center;\n"
    ]);
    $3d0fda5c3a8cdefd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3d0fda5c3a8cdefd$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 16px;\n"
    ]);
    $3d0fda5c3a8cdefd$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3d0fda5c3a8cdefd$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  ::before {\n    content: url(",
        ");\n  }\n"
    ]);
    $3d0fda5c3a8cdefd$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3d0fda5c3a8cdefd$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n\n  @media screen and ",
        " {\n    max-width: 70%;\n  }\n"
    ]);
    $3d0fda5c3a8cdefd$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $3d0fda5c3a8cdefd$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  background: #1a3dd1;\n  color: #fff;\n  text-align: center;\n  box-shadow: inset 0 -6px 0px #052ea3;\n\n  @media screen and ",
        " {\n    width: auto;\n  }\n"
    ]);
    $3d0fda5c3a8cdefd$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $3d0fda5c3a8cdefd$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  @media screen and ",
        " {\n    width: 34em;\n  }\n"
    ]);
    $3d0fda5c3a8cdefd$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $3d0fda5c3a8cdefd$var$shouldShowCompletionWarning = function(param) {
    var cohort = param.cohort, completionDate = param.completionDate;
    // Only show the warning to purchase customers who are less than 4 weeks away from their completion date, if one is set
    return cohort === "Purchase" && !!completionDate && (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(completionDate, new Date(), "week") < 4;
};
var $3d0fda5c3a8cdefd$var$RateMissingContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3d0fda5c3a8cdefd$var$_templateObject());
var $3d0fda5c3a8cdefd$var$RateMissingTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3d0fda5c3a8cdefd$var$_templateObject1());
var $3d0fda5c3a8cdefd$var$RefreshIcon = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3d0fda5c3a8cdefd$var$_templateObject2(), (0, (/*@__PURE__*/$parcel$interopDefault($899d3ee31a55aa5b$exports))));
var $3d0fda5c3a8cdefd$export$d078e30e1a0a6124 = function(param) {
    var applicationId = param.applicationId;
    var friendlyId = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().friendlyId;
    var application = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }).application;
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), sessionLoading = _useSession.isLoading;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), rateCheckerData = _useState[0], setRateCheckerData = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), actionClicked = _useState1[0], setActionClicked = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isError = _useState2[0], setIsError = _useState2[1];
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isLoading = _useState3[0], setIsLoading = _useState3[1];
    var _useState4 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), showNewRateModal = _useState4[0], setShowNewRateModal = _useState4[1];
    var _useState5 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), warningChecked = _useState5[0], setWarningChecked = _useState5[1];
    var showCompletionWarning = !!application && $3d0fda5c3a8cdefd$var$shouldShowCompletionWarning(application);
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/application/rate-check-promise");
    (0, $hAGkE.useEffect)(function() {
        if (applicationId && !sessionLoading) (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/rate-check/".concat(applicationId, "/v2"), {
            withCredentials: true
        }).then(function(param) {
            var data = param.data;
            setRateCheckerData(data.data);
            setIsError(false);
            setIsLoading(false);
        })["catch"](function(error) {
            console.error(error);
            setIsError(true);
            setIsLoading(false);
        });
    }, [
        applicationId,
        sessionLoading
    ]);
    if (isLoading || !rateCheckerData) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ContentGrid, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ContentContainer, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$LoaderContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                    size: 150,
                    theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
                })
            })
        })
    });
    var rateCheck = rateCheckerData.rateCheck, identifiedLowerRate = rateCheckerData.identifiedLowerRate;
    if (!rateCheck) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ContentGrid, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3d0fda5c3a8cdefd$var$ContentContainer, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8b9aba2ed88130ce$export$f769c1adb859387d), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $903dc05d89ea817d$export$243b414de1b76ea4), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3905fbe9c03e450a$export$13a65b1ced09763c), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8b9aba2ed88130ce$export$87d98f83bd85698), {})
            ]
        })
    });
    var arrows = $3d0fda5c3a8cdefd$var$fetchArrows(rateCheck, identifiedLowerRate);
    var handleCheckboxClick = function() {
        return setWarningChecked(function(val) {
            return !val;
        });
    };
    var handleRateClick = function(rateClicked) {
        return function() {
            var currentRate = rateClicked === "current";
            setActionClicked(rateClicked);
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                event_label: currentRate ? (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).autoRateDecline : (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).autoRateAccept
            });
            if (identifiedLowerRate) (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("https://my-mojo-api.mojomortgages.com/rate-check/update", {
                id: identifiedLowerRate.id,
                status: currentRate ? (0, $da8977d24f633871$export$ba10d77b5bfec263).Declined : (0, $da8977d24f633871$export$ba10d77b5bfec263).Progressing
            }, {
                withCredentials: true
            })["catch"](function(error) {
                console.error(error);
                setIsError(true);
            });
            if (rateClicked === "current") (0, $fdd55589ea724e5e$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                            children: "Thanks for letting us know"
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                        children: "You\u2019ll stay on your current rate and we\u2019ll keep you updated if the rate goes down again"
                    })
                ]
            }), {
                id: "confirmed"
            });
            if (rateClicked === "new") setShowNewRateModal(true);
        };
    };
    var completionCutoff = rateCheck.status === "stopped-completion-cutoff";
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ContentGrid, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ContentContainer, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $4bc1cd0150abdd07$export$7426c9de2f0518ee), {
                        rateCheck: rateCheck,
                        identifiedLowerRate: identifiedLowerRate
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3d0fda5c3a8cdefd$var$RatesWrapper, {
                        bg: completionCutoff,
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $e14805868db04869$export$dfb9a928b0e68c9f), {
                                rateCheck: rateCheck,
                                identifiedLowerRate: identifiedLowerRate
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$RatesContainer, {
                                finalRate: completionCutoff,
                                children: completionCutoff ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $20d975e5e7058386$export$4ef2ed81e604cf5), {
                                    productDetails: rateCheckerData.rateCheck.customerProductDetails,
                                    productInput: rateCheckerData.rateCheck.productInput
                                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $20d975e5e7058386$export$a64162838dbd1966), {
                                            actionClicked: actionClicked,
                                            currentRate: true,
                                            currentInitialCost: rateCheck.customerProductDetails.TrueCostOverInitialPeriod,
                                            identifiedLowerRateId: identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.id,
                                            identifiedLowerRateStatus: identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status,
                                            isError: isError,
                                            productDetails: (identifiedLowerRate === null || identifiedLowerRate === void 0 ? void 0 : identifiedLowerRate.status) === (0, $da8977d24f633871$export$ba10d77b5bfec263).Completed ? identifiedLowerRate.productDetails // if the ILR was successfully completed, show the new rate as the current rate
                                             : rateCheckerData.rateCheck.customerProductDetails // if the ILR was successfully completed, show the new rate as the current rate
                                            ,
                                            productInput: rateCheckerData.rateCheck.productInput,
                                            setIsError: setIsError,
                                            setActionClicked: setActionClicked,
                                            handleEsisDownload: function() {
                                                $3d0fda5c3a8cdefd$var$handleEsisDownloadCurrRate(applicationId);
                                            },
                                            arrows: arrows,
                                            handleClick: handleRateClick("current"),
                                            warningChecked: false,
                                            handleWarningCheckboxChange: function() {
                                                return {};
                                            }
                                        }),
                                        identifiedLowerRate ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $20d975e5e7058386$export$a64162838dbd1966), {
                                            actionClicked: actionClicked,
                                            currentRate: false,
                                            currentInitialCost: rateCheck.customerProductDetails.TrueCostOverInitialPeriod,
                                            identifiedLowerRateId: identifiedLowerRate.id,
                                            identifiedLowerRateStatus: identifiedLowerRate.status,
                                            isError: isError,
                                            productDetails: identifiedLowerRate.productDetails,
                                            productInput: rateCheckerData.rateCheck.productInput,
                                            setActionClicked: setActionClicked,
                                            setIsError: setIsError,
                                            handleEsisDownload: function() {
                                                $3d0fda5c3a8cdefd$var$handleEsisDownloadNewRate(applicationId, friendlyId, identifiedLowerRate.id);
                                            },
                                            arrows: arrows,
                                            handleClick: handleRateClick("new"),
                                            showCompletionDateWarning: showCompletionWarning,
                                            warningChecked: warningChecked,
                                            handleWarningCheckboxChange: handleCheckboxClick
                                        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3d0fda5c3a8cdefd$var$RateMissingContainer, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$RefreshIcon, {}),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3d0fda5c3a8cdefd$var$RateMissingTitle, {
                                                    children: [
                                                        "When we find a lower rate with ",
                                                        rateCheck.customerProductDetails.LenderName,
                                                        ", it\u2019ll appear here"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                                    children: "Don\u2019t worry, we\u2019ll email to let you know"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $903dc05d89ea817d$export$243b414de1b76ea4), {}),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3905fbe9c03e450a$export$13a65b1ced09763c), {}),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8b9aba2ed88130ce$export$87d98f83bd85698), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $a159116cb4326250$export$36ba2f559d49a8f6), {
                        notificationComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$RateSelectedToast, {})
                    }),
                    showNewRateModal && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $e4c3a56b5e374926$export$4eb75d93115a3d90), {
                        onClose: function() {
                            return setShowNewRateModal(false);
                        }
                    })
                ]
            })
        })
    });
};
var $3d0fda5c3a8cdefd$var$ToastText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3d0fda5c3a8cdefd$var$_templateObject3(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3d0fda5c3a8cdefd$var$ToastButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1))($3d0fda5c3a8cdefd$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $3d0fda5c3a8cdefd$var$RateSelectedToast = function(param) {
    var id = param.id, message = param.message;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($hAGkE.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ToastText, {
                children: message
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3d0fda5c3a8cdefd$var$ToastButton, {
                onClick: function() {
                    return (0, $fdd55589ea724e5e$export$2e2bcd8739ae039).dismiss(id);
                },
                width: "auto",
                type: 2,
                text: "Got it",
                style: {
                    alignSelf: "end"
                }
            })
        ]
    });
};
var $3d0fda5c3a8cdefd$var$handleEsisDownloadCurrRate = function(applicationId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        return (0, $dMrZK.__generator)(this, function(_state) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).rateCheckEsisDownloadClicked,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: "Rate check download current rate ESIS clicked"
            });
            return [
                2,
                (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/recommendation/".concat(applicationId), {
                    withCredentials: true
                }).then(function(param) {
                    var data = param.data;
                    return data.esisS3Key;
                }).then(function(esisS3Key) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/documents/download-url"), {
                        applicationId: applicationId,
                        s3Key: esisS3Key
                    }, {
                        withCredentials: true
                    });
                }).then(function(response) {
                    if (response.status !== 200) throw Error("Failed to download ILR current rate ESIS document");
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).rateCheckEsisDownloadResult,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).customEvent,
                        event_label: "Download current rate ESIS success"
                    });
                    window.location.assign(response.data.downloadUrl);
                })["catch"](function(err) {
                    (0, $411b073b3fd49a19$export$5c9af0966a1ac889)(err);
                })
            ];
        });
    })();
};
var $3d0fda5c3a8cdefd$var$handleEsisDownloadNewRate = function(applicationId, friendlyId, ilrRateId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        return (0, $dMrZK.__generator)(this, function(_state) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).rateCheckEsisDownloadClicked,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: "Rate check download new rate ESIS clicked"
            });
            return [
                2,
                (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/documents/download-url"), {
                    applicationId: applicationId,
                    s3Key: "Opportunities/".concat(friendlyId, "/rate-check/ilr/").concat(ilrRateId, ".pdf")
                }, {
                    withCredentials: true
                }).then(function(response) {
                    if (response.status !== 200) throw Error("Failed to download ILR new rate ESIS document");
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).rateCheckEsisDownloadResult,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).customEvent,
                        event_label: "Download new rate ESIS success"
                    });
                    window.open(response.data.downloadUrl);
                })["catch"](function(err) {
                    (0, $411b073b3fd49a19$export$5c9af0966a1ac889)(err);
                })
            ];
        });
    })();
};
function $3d0fda5c3a8cdefd$var$fetchArrows(rateCheck, identifiedLowerRate) {
    if (!identifiedLowerRate) return {
        initialRate: null,
        monthlyPayment: null,
        overallCost: null,
        aprc: null,
        productFee: null,
        endDate: null
    };
    var _ref = rateCheck.customerProductDetails || {}, InitialMonthlyPayment = _ref.InitialMonthlyPayment, InitialMonthlyPaymentIncludingFees = _ref.InitialMonthlyPaymentIncludingFees;
    var addFeesToLoan = (rateCheck.productInput || {}).addFeesToLoan;
    var ilrMonthlyPayment = addFeesToLoan ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(identifiedLowerRate.productDetails.InitialMonthlyPaymentIncludingFees) : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(identifiedLowerRate.productDetails.InitialMonthlyPayment);
    var monthlyPayment = addFeesToLoan ? (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPaymentIncludingFees) : (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(InitialMonthlyPayment);
    var compareValues = function(currentValue, newValue) {
        return newValue < currentValue ? "green" : newValue > currentValue ? "orange" : null;
    };
    var compareDates = function(currentValue, newValue) {
        var currentValueMs = new Date(currentValue).getTime();
        var valueMs = new Date(newValue).getTime();
        return valueMs > currentValueMs ? "orange" : null;
    };
    return {
        initialRate: compareValues(rateCheck.customerProductDetails.InitialPayRate, identifiedLowerRate.productDetails.InitialPayRate),
        monthlyPayment: compareValues(monthlyPayment, ilrMonthlyPayment),
        overallCost: compareValues(rateCheck.customerProductDetails.TrueCostOverInitialPeriod, identifiedLowerRate.productDetails.TrueCostOverInitialPeriod),
        aprc: compareValues(rateCheck.customerProductDetails.AprLenders, identifiedLowerRate.productDetails.AprLenders),
        productFee: compareValues(rateCheck.customerProductDetails.ArrangementFee, identifiedLowerRate.productDetails.ArrangementFee),
        endDate: compareDates(rateCheck.customerProductDetails.InitialRatePeriodPrecise, identifiedLowerRate.productDetails.InitialRatePeriodPrecise)
    };
}
var $3d0fda5c3a8cdefd$var$_obj;
var $3d0fda5c3a8cdefd$var$ContentGrid = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($3d0fda5c3a8cdefd$var$_obj = {
    display: "grid",
    gridColumnStart: 2,
    gridRowStart: 1,
    columnGap: (0, $1ca2cdaa0912b6ea$export$a941ed4b947d12f8)
}, (0, $8c6ug._)($3d0fda5c3a8cdefd$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    gridTemplateColumns: "repeat(3, 1fr)",
    padding: "1rem"
}), (0, $8c6ug._)($3d0fda5c3a8cdefd$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    gridTemplateColumns: "repeat(6, 1fr)",
    padding: (0, $1ca2cdaa0912b6ea$export$d64d6fd6f0527437)
}), (0, $8c6ug._)($3d0fda5c3a8cdefd$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gridTemplateColumns: "repeat(12, 1fr)",
    padding: "".concat((0, $1ca2cdaa0912b6ea$export$8e0eba2c322344f3), "px ", 40, "px")
}), $3d0fda5c3a8cdefd$var$_obj));
var $3d0fda5c3a8cdefd$var$_obj1;
var $3d0fda5c3a8cdefd$var$ContentContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($3d0fda5c3a8cdefd$var$_obj1 = {
    gridColumnStart: 1
}, (0, $8c6ug._)($3d0fda5c3a8cdefd$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    gridColumnEnd: "span 3"
}), (0, $8c6ug._)($3d0fda5c3a8cdefd$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    gridColumnEnd: "span 6"
}), (0, $8c6ug._)($3d0fda5c3a8cdefd$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gridColumnStart: 2,
    gridColumnEnd: "span 10"
}), $3d0fda5c3a8cdefd$var$_obj1));
var $3d0fda5c3a8cdefd$var$LoaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3d0fda5c3a8cdefd$var$_templateObject5(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $3d0fda5c3a8cdefd$var$RatesWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var bg = param.bg;
    return {
        display: "flex",
        flexDirection: "column",
        background: "#f1f4fe",
        padding: "16px",
        borderRadius: "32px",
        gap: "16px",
        backgroundImage: bg ? "linear-gradient(rgba(241,244,254,0.8), rgba(241,244,254,0.8)), url(".concat((0, {}), ")") : "none",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        alignItems: "center"
    };
});
var $3d0fda5c3a8cdefd$var$RatesContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var finalRate = param.finalRate;
    return (0, $8c6ug._)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "16px"
    }, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
        flexDirection: "row",
        width: finalRate ? "70%" : "100%"
    });
});



var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");



var $a0045f08bd0b50f3$exports = {};
$a0045f08bd0b50f3$exports = $parcel$resolve("iDwFM");


var $80b3310d6349223d$exports = {};
$80b3310d6349223d$exports = $parcel$resolve("6dyyr");







// An explicit {} body is required; with no body at all, axios sends no
// Content-Type header, so the Zod schema rejects is
var $0a07376615e5483e$var$fetcher = function(url) {
    return (0, $d48d778937567d64$export$155ec85c4e3b5e85).post(url, {}).then(function(res) {
        return res.data;
    });
};
var $0a07376615e5483e$export$64dfd82cd19c3904 = function(applicationId) {
    var _useSWR = (0, $69b91e38b962ffe6$export$2e2bcd8739ae039)(applicationId ? "https://ede-api.mojomortgages.com/experiments/acceptRecommendation/resolve/".concat(applicationId) : null, $0a07376615e5483e$var$fetcher, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = _useSWR.data, error = _useSWR.error, isLoading = _useSWR.isLoading;
    return {
        recommendationAcceptActive: data ? data.arm === "enabled" : undefined,
        isLoading: isLoading,
        isError: error
    };
};





var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");


var $56699a9beb99e1c1$export$32dd3be32095816a = function(friendlyId) {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), isInRateCheckExperiment = _useState[0], setIsInRateCheckExperiment = _useState[1];
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), sessionLoading = _useSession.isLoading;
    (0, $hAGkE.useEffect)(function() {
        if (!friendlyId || sessionLoading) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/rate-check-bucket/".concat(friendlyId), {
            withCredentials: true
        }).then(function(param) {
            var data = param.data;
            setIsInRateCheckExperiment((data === null || data === void 0 ? void 0 : data.rateCheckPromise) || false);
        })["catch"](function(error) {
            console.error("Error fetching rate check data:", error);
            setIsInRateCheckExperiment(false);
        });
    }, [
        friendlyId,
        sessionLoading
    ]);
    return isInRateCheckExperiment;
};
var $56699a9beb99e1c1$export$2e2bcd8739ae039 = $56699a9beb99e1c1$export$32dd3be32095816a;







var $6007c3b8c118528f$exports = {};
$6007c3b8c118528f$exports = $parcel$resolve("auxUD");



var $40a1fc5995dd6979$exports = {};
$40a1fc5995dd6979$exports = $parcel$resolve("5SHvZ");


function $16f64ef9d03de52b$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 848px;\n  margin-top: 16px;\n\n  @media screen and ",
        " {\n    margin: 16px 16px 0 16px;\n    gap: 16px;\n  }\n\n  @media screen and ",
        " {\n    min-width: 768px;\n    margin: 8.5em 12.5em 0 6.25em;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #ffebdc;\n  text-align: center;\n  border-radius: 24px;\n  padding: 32px 24px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 32px;\n  font-weight: 700;\n  max-width: 380px;\n  @media screen and ",
        " {\n    margin-top: 3em;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  line-height: 1.5em;\n  z-index: 1000;\n  margin: 16px 0;\n  text-align: center;\n  font-size: 14px;\n  max-width: 380px;\n  padding: 0 32px;\n  @media screen and ",
        " {\n    &:last-of-type {\n      margin-bottom: 128px;\n    }\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  line-height: 25.2px;\n  z-index: 1000;\n  margin: 32px 0;\n  text-align: center;\n  font-size: 14px;\n  max-width: 380px;\n  padding: 0 32px;\n  display: flex;\n  font-weight: 500;\n  flex-direction: column;\n  gap: 48px;\n  @media screen and ",
        " {\n    margin-bottom: 128px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media ",
        " {\n    width: 256px;\n    display: block;\n    position: absolute;\n    top: -221px;\n    left: 0;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: none;\n\n  @media ",
        " {\n    width: 196px;\n    display: block;\n    position: absolute;\n    top: -171px;\n    right: 0;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  display: none;\n  flex-direction: column;\n  width: 100%;\n  justify-content: left;\n  background: #000928;\n  border-radius: 16px;\n  text-align: left;\n  padding: 32px;\n  color: #fff;\n  gap: 48px;\n\n  @media screen and ",
        " {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n  bottom: -8px;\n  width: 100%;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  flex: 5;\n\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 16px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 20px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: space-between;\n  color: #eef0f8;\n  gap: 24px;\n  flex: 3;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  gap: 8px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject14() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 14px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject15() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 24px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject16() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  @media screen and ",
        " {\n    width: 34em;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject17() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #fff;\n  border-radius: 24px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject18() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject19() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 24px 32px 8px 32px;\n\n  & > h2 {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  & > span {\n    font-weight: 600;\n    font-size: 24px;\n  }\n\n  & > p {\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n  }\n\n  @media screen and ",
        " {\n    padding: 24px 32px 8px 32px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject20() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 24px;\n  background: rgba(7, 62, 217, 0.05);\n  background-opacity: 5%;\n  border-radius: 16px;\n  margin: 8px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject21() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 8px 32px 24px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 24px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject22() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: space-between;\n  list-style-type: none;\n  border-bottom: 1px solid rgba(181, 190, 220, 1);\n  padding-bottom: 16px;\n  margin-top: 16px;\n\n  &:first-of-type {\n    margin-top: 0;\n  }\n\n  &:last-of-type {\n    border-bottom: none;\n    padding-bottom: 0px;\n  }\n\n  & > span:first-of-type {\n    font-weight: 500;\n    font-size: 16px;\n    flex: 1;\n    text-align: left;\n    line-height: 28px;\n  }\n\n  & > span {\n    font-weight: 600;\n    font-size: 16px;\n    text-align: right;\n    flex: 1;\n    line-height: 28px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject23() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n  align-self: center;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject24() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  line-height: 18px;\n  margin-bottom: 0px;\n  color: #000928;\n\n  @media screen and ",
        " {\n    margin-top: 8px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject25() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  margin-top: 8px;\n  font-size: 12px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject26() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: normal;\n  margin-top: 12px;\n  font-size: 16px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject27() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  gap: 16px;\n\n  & > span:first-of-type {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 28px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject28() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  & > div:first-of-type {\n    ",
        "\n    justify-content: space-between;\n  }\n\n  & > div:last-of-type {\n    ",
        "\n    justify-content: ",
        ";\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject29() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n\n  & > div {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    font-weight: 600;\n    font-size: 16px;\n    flex: 1;\n    text-align: left;\n    line-height: 28px;\n\n    & > span:first-of-type {\n      font-weight: 500;\n    }\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject30() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #073ed9;\n  border-radius: 16px;\n  color: white;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  padding: 24px;\n\n  & > div {\n    display: flex;\n    justify-content: space-between;\n\n    & > h3 {\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 28.8px;\n    }\n  }\n  & > p {\n    padding: 0;\n    margin: 0;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject31() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 24px;\n  padding: 12px 8px;\n\n  & > span:first-of-type {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(251, 187, 91, 1);\n    border-radius: 100%;\n    width: 24px;\n    height: 24px;\n\n    ::after {\n      content: url(",
        ");\n      stroke: black;\n      transform: scale(1);\n      position: relative;\n      top: 2px;\n    }\n  }\n\n  & > span {\n    font-weight: 600;\n    font-size: 16px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject32() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  background: rgba(255, 247, 235, 1);\n  border-radius: 16px;\n  margin: 8px;\n\n  @media screen and ",
        " {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 32px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject33() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 8px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject34() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  background: rgba(7, 62, 217, 0.05);\n  border-radius: 16px;\n  list-style-type: none;\n  padding: 24px;\n\n  @media screen and ",
        " {\n    align-items: initial;\n  }\n\n  @media screen and ",
        " {\n    align-items: end;\n    flex-direction: row;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject35() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > span {\n    font-weight: 600;\n    font-size: 18px;\n  }\n\n  & > p {\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n    flex: 1;\n    margin: 16px 0 0 0;\n\n    @media screen and ",
        " {\n      align-items: center;\n      flex: 8;\n    }\n  }\n\n  @media screen and ",
        " {\n    margin-right: 64px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject36() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 8px 8px 0;\n  margin-top: 16px;\n  width: 100%;\n  font-weight: 600;\n  font-size: 16px;\n  flex: 1;\n\n  @media screen and ",
        " {\n    flex: 2;\n    margin-top: 0px;\n    padding: 0 64px;\n    height: 56px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject37() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  cursor: pointer;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 8px 8px 0;\n  margin-top: 16px;\n  width: 100%;\n  border-radius: 8px;\n  border: 2px solid black;\n  font-weight: 600;\n  font-size: 16px;\n  flex: 1;\n\n  @media screen and ",
        " {\n    flex: 2;\n    margin-top: 0px;\n    padding: 0 24px 0 16px;\n    height: 56px;\n  }\n\n  ::before {\n    content: url(",
        ");\n    fill: black;\n    color: black;\n    transform: scale(1);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    padding: 4px 2px 0px 0px;\n    margin: 8px;\n    border-right: 2px solid black;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject38() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  cursor: pointer;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 8px 8px 0;\n  margin-top: 16px;\n  width: 100%;\n  border-radius: 8px;\n  border: 2px solid black;\n  font-weight: 600;\n  font-size: 16px;\n  flex: 1;\n\n  @media screen and ",
        " {\n    flex: 2;\n    margin-top: 0px;\n    padding: 0 24px 0 16px;\n    height: 56px;\n  }\n\n  ::before {\n    content: url(",
        ");\n    fill: black;\n    color: black;\n    transform: scale(1);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    padding: 4px 2px 0px 0px;\n    margin: 8px;\n    border-right: 2px solid black;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject39() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #ffebdc;\n  border-radius: 24px;\n  padding: 8px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject40() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 24px;\n\n  & > span {\n    font-weight: 600;\n    font-size: 24px;\n  }\n\n  & > p {\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject41() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n\n  & > div {\n    color: #3b4258;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject42() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 16px;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    min-width: 300px;\n    gap: 8px;\n\n    @media screen and ",
        " {\n      width: auto;\n    }\n  }\n\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject43() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(59, 66, 88, 1);\n  line-height: 24px;\n  flex: 1;\n  margin: 0;\n\n  @media screen and ",
        " {\n    align-items: center;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject44() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 32px;\n  border-radius: 16px;\n  background: #fff;\n\n  & > span {\n    font-weight: 600;\n    font-size: 18px;\n    text-align: center;\n  }\n\n  & > div {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    & > span {\n      flex: 8;\n    }\n\n    @media screen and ",
        " {\n      flex-direction: row;\n    }\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject45() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #fff;\n  padding: 8px 16px 0 16px;\n  width: 100%;\n  height: 54px;\n  border: none;\n  background: rgba(7, 62, 217, 1);\n  box-shadow: 0px 8px 0px 0px rgba(0, 27, 190, 1);\n  min-width: 234px;\n  text-decoration: none;\n\n  @media screen and ",
        " {\n    width: auto;\n  }\n\n  &:hover {\n    opacity: 90%;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject46() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  text-align: center;\n  padding: 32px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject47() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #398056;\n  background: #eef5f3;\n  padding: 8px 16px 0px 16px;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 54px;\n  border-radius: 8px;\n\n  ::before {\n    content: url(",
        ");\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject48() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 8px;\n  cursor: pointer;\n  color: #fff;\n  padding: 8px 16px 0 16px;\n  width: 100%;\n  height: 54px;\n  border: none;\n  background: rgba(7, 62, 217, 1);\n  box-shadow: 0px 8px 0px 0px rgba(0, 27, 190, 1);\n\n  &:hover {\n    opacity: 90%;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject49() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  & > h2 {\n    padding: 16px 32px 8px 32px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject50() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #fff;\n  border-radius: 24px;\n\n  & > p {\n    padding: 24px 32px 24px 8px;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n    margin: 0;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject51() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: normal;\n  color: #000928;\n  width: 100%;\n  text-align: right;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject52() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  background: #fff;\n  border-radius: 24px;\n  padding: 32px;\n\n  & > img {\n    display: none;\n    width: 56px;\n    height: 56px;\n    margin-right: 16px;\n\n    @media screen and ",
        " {\n      display: block;\n    }\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject53() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > p {\n    font-weight: 400;\n    font-size: 16px;\n    margin: 8px 0;\n  }\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    @media screen and ",
        " {\n      flex-direction: row;\n      gap: 32px;\n    }\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject54() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 24px;\n  margin-top: 16px;\n  padding: 8px;\n  @media screen and ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject55() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 32px 32px 32px 24px;\n  gap: 16px;\n  & > span {\n    font-weight: 600;\n    font-size: 18px;\n  }\n  & > p {\n    margin: 0;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n  }\n  @media screen and ",
        " {\n    padding: 32px 32px 8px 24px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject56() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  height: 24px;\n  width: 84px;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject57() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: end;\n  margin-bottom: 16px;\n  & > span {\n    font-size: 16px;\n    margin-left: 16px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject58() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  @media screen and ",
        " {\n    max-width: 280px;\n    max-height: 280px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject59() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  @media screen and ",
        " {\n    max-width: 360px;\n    max-height: 360px;\n  }\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function $16f64ef9d03de52b$var$_templateObject60() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #073ed9;\n"
    ]);
    $16f64ef9d03de52b$var$_templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
var $16f64ef9d03de52b$export$be92b6f5f03c0fe9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xs, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$78a558edcc066ec2 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject1());
var $16f64ef9d03de52b$export$8b251419efc915eb = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($16f64ef9d03de52b$var$_templateObject2(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$3c0420c1ab00970c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($16f64ef9d03de52b$var$_templateObject3(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$6a1e9fe31522a9e1 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject4(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$dcc61bba56651550 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($16f64ef9d03de52b$var$_templateObject5(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$89cf17dfa018bf1f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($16f64ef9d03de52b$var$_templateObject6(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$bd55427d3650a1b0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject7(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$95b3756aa4faa94c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject8());
var $16f64ef9d03de52b$export$851053b8635f3e9c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject9(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$ced6452f422b797e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject10());
var $16f64ef9d03de52b$export$465da4d139238e2d = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject11());
var $16f64ef9d03de52b$export$ed85ed9fa966b254 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject12());
var $16f64ef9d03de52b$export$9811fe609657ae14 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject13());
var $16f64ef9d03de52b$export$2c5e784e9d9f08d8 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject14());
var $16f64ef9d03de52b$export$d3a7678ae0ddbeb9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject15());
var $16f64ef9d03de52b$export$8f67d857ad88efa0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject16(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$cdc9f1a6e273987f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject17());
var $16f64ef9d03de52b$export$8528d0ddb1828281 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h2($16f64ef9d03de52b$var$_templateObject18());
var $16f64ef9d03de52b$export$69bc41ee738923ec = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject19(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$8f239afcee4d6cc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($16f64ef9d03de52b$var$_templateObject20());
var $16f64ef9d03de52b$export$96a93d5933d552bc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($16f64ef9d03de52b$var$_templateObject21());
var $16f64ef9d03de52b$export$a0671ff06a087bc = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($16f64ef9d03de52b$var$_templateObject22());
var $16f64ef9d03de52b$export$b51735ea2e95cf99 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($16f64ef9d03de52b$var$_templateObject23());
var $16f64ef9d03de52b$var$SubText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($16f64ef9d03de52b$var$_templateObject24(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$27c2eb85af0f2a3 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($16f64ef9d03de52b$var$SubText)($16f64ef9d03de52b$var$_templateObject25());
var $16f64ef9d03de52b$export$ae479c4985576dff = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($16f64ef9d03de52b$var$SubText)($16f64ef9d03de52b$var$_templateObject26());
var $16f64ef9d03de52b$export$678e0ebdc2ddf1bd = (0, $62d655c53090e8a3$export$dbf350e5966cf602)($16f64ef9d03de52b$var$_templateObject27());
var $16f64ef9d03de52b$export$baa4df250058c4a0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($16f64ef9d03de52b$var$_templateObject28(), $16f64ef9d03de52b$export$678e0ebdc2ddf1bd, $16f64ef9d03de52b$export$678e0ebdc2ddf1bd, function(param) {
    var direction = param.direction;
    return direction === "right" ? "flex-end" : "space-between";
});
var $16f64ef9d03de52b$export$f741b11b5cf521b = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject29());
var $16f64ef9d03de52b$export$2a9d479a61a53f9 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject30());
var $16f64ef9d03de52b$export$bbb93379fdcec643 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($16f64ef9d03de52b$var$_templateObject31(), (0, (/*@__PURE__*/$parcel$interopDefault($6007c3b8c118528f$exports))));
var $16f64ef9d03de52b$export$946a4e1031ba824 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($16f64ef9d03de52b$var$_templateObject32(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$970e2635e476ff74 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($16f64ef9d03de52b$var$_templateObject33());
var $16f64ef9d03de52b$export$b34a105447964f9f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($16f64ef9d03de52b$var$_templateObject34(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$c09bc12f7cb7646b = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject35(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$e0b917bfa1ce5156 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject36(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$2c4ef4153bb78178 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($16f64ef9d03de52b$var$_templateObject37(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl, (0, (/*@__PURE__*/$parcel$interopDefault($40a1fc5995dd6979$exports))));
var $16f64ef9d03de52b$export$6b8158edecc933bf = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($16f64ef9d03de52b$var$_templateObject38(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl, (0, (/*@__PURE__*/$parcel$interopDefault($40a1fc5995dd6979$exports))));
var $16f64ef9d03de52b$export$7a3e25fda9bd3f90 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject39());
var $16f64ef9d03de52b$export$6ad60e10b36e0cc5 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject40());
var $16f64ef9d03de52b$export$11143fb7c1944d42 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject41());
var $16f64ef9d03de52b$export$1775942900a3c06c = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject42(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$71eff207453c5873 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($16f64ef9d03de52b$var$_templateObject43(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$2df59151ffc61c31 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject44(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$dc755699165ff19e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($16f64ef9d03de52b$var$_templateObject45(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$74f29a5c5ac28ae1 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject46());
var $16f64ef9d03de52b$export$3e6977b478c02b14 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject47(), (0, (/*@__PURE__*/$parcel$interopDefault($548f2127bbf04648$exports))));
var $16f64ef9d03de52b$export$64ebbd04a8748684 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($16f64ef9d03de52b$var$_templateObject48());
var $16f64ef9d03de52b$export$18a785182e0ab9b0 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject49());
var $16f64ef9d03de52b$export$bc5c19970cafbf73 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject50());
var $16f64ef9d03de52b$export$bb778bbe30d14b97 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($16f64ef9d03de52b$var$_templateObject51());
var $16f64ef9d03de52b$export$534d7624dcadf1a7 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject52(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xs);
var $16f64ef9d03de52b$export$664de34ea9c7e71f = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject53(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$5360ff2533d8ca65 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject54(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$f8574db33bc0265e = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject55(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $16f64ef9d03de52b$export$9393272ffc956161 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($16f64ef9d03de52b$var$_templateObject56());
var $16f64ef9d03de52b$export$9003ac83d962f699 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($16f64ef9d03de52b$var$_templateObject57());
var $16f64ef9d03de52b$export$396ff1b3e2be0ec4 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($16f64ef9d03de52b$var$_templateObject58(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$41a8f75448821445 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($16f64ef9d03de52b$var$_templateObject59(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $16f64ef9d03de52b$export$deae54d360d340f1 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($16f64ef9d03de52b$var$_templateObject60());


parcelRequire("hAGkE");
var $33771e3525c8c58c$export$d658961c5acadf9b = function(param) {
    var image = param.image, name = param.name, phone = param.phone, email = param.email;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$534d7624dcadf1a7), {
        children: [
            image && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                src: image,
                alt: "your mortgage expert",
                "aria-label": "your mortgage expert"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$664de34ea9c7e71f), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                        children: [
                            "This recommendation was created by your Mortgage Expert ",
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                children: phone
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                                href: "mailto:".concat(email),
                                children: email
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





parcelRequire("hAGkE");

function $c0db56e5077cf928$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: #3b4258;\n"
    ]);
    $c0db56e5077cf928$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c0db56e5077cf928$var$Grey = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($c0db56e5077cf928$var$_templateObject());
var $c0db56e5077cf928$export$1f0d174bce7a72bb = function(param) {
    var _param_freeLegals = param.freeLegals, freeLegals = _param_freeLegals === void 0 ? false : _param_freeLegals;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$74f29a5c5ac28ae1), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($c0db56e5077cf928$var$Grey, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                        children: "Representative example:"
                    }),
                    " a repayment mortgage amount of \xa3325,000 over 25 years, representative APRC 7%. Total amount payable \xa3691,363.52 includes interest of \xa3365,264.52 product fees of \xa3999 and other fees of \xa3100. Repayments: 26 months of \xa31,757.01 at 4.23% (fixed), then 274 months of \xa32,352.49 at 7.49% (variable). Early repayment charges apply."
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c0db56e5077cf928$var$Grey, {
                children: "* Data taken using Mojo\u2019s internal records, covering the period from 18 February 2025 to 30 September 2025. Average savings over the initial term based on the difference between the customer\u2019s initial pay rate and their new, lower rate discovered through our Rate Check Promise service."
            }),
            freeLegals && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                children: "*There may additional charges for non-standard transaction."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                children: [
                    "Mojo is a trading style of Life's Great Limited which is registered in England and Wales (06246376). We are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215)",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                children: "Our registered office is The Cooperage, 5 Copper Row, London, SE1 2LH."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                children: "To contact us by phone, please call 0333 123 0012."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                    children: "YOUR HOME/PROPERTY MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE"
                })
            })
        ]
    });
};





parcelRequire("hAGkE");
var $805ba460e9540eb1$export$8933a0fcb5352bc6 = function(param) {
    var downloading = param.downloading, preview = param.preview, href = param.href, onClick = param.onClick;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$970e2635e476ff74), {
        "aria-label": "Documents",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b34a105447964f9f), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$c09bc12f7cb7646b), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Mortgage Illustration"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "This document outlines the full details and risks of the mortgage product being recommended, please ensure you take the time to read through."
                        })
                    ]
                }),
                downloading ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$e0b917bfa1ce5156), {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                        size: 32,
                        theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
                    })
                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
                    children: preview ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$6b8158edecc933bf), {
                        href: href,
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Download"
                        })
                    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$2c4ef4153bb78178), {
                        onClick: onClick,
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Download"
                        })
                    })
                })
            ]
        })
    });
};





parcelRequire("hAGkE");
var $122d329bce1db699$export$d7c0be5787dd034 = function(param) {
    var acceptedDateTime = param.acceptedDateTime, acceptedVia = param.acceptedVia;
    var _this, _this1;
    var recommendationAcceptedDateTime = acceptedDateTime ? (_this = new Date(acceptedDateTime)) === null || _this === void 0 ? void 0 : _this.toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    }).replace(/,/g, "") : null;
    var acceptedViaEnum = {
        MY_MOJO: "My Mojo",
        VERBALLY: "Verbally",
        SMS: "SMS",
        EMAIL: "Email"
    };
    // acceptance requires salesforce data via a page refresh or another query setup
    var clientsideDate = (_this1 = new Date()) === null || _this1 === void 0 ? void 0 : _this1.toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    });
    var formattedVia = acceptedVia ? acceptedVia === null || acceptedVia === void 0 ? void 0 : acceptedVia.toLowerCase() : null;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "Accepted",
                    " ",
                    (acceptedVia === acceptedViaEnum.SMS || acceptedVia === acceptedViaEnum.EMAIL) && "via ".concat(formattedVia, " "),
                    acceptedVia === acceptedViaEnum.VERBALLY && "over the phone ",
                    !recommendationAcceptedDateTime && clientsideDate
                ]
            }),
            !!recommendationAcceptedDateTime && recommendationAcceptedDateTime
        ]
    });
};




parcelRequire("hAGkE");
var $d292bdbd1d57ec81$export$4cba1f13ada9c24e = function(param) {
    var productTransfer = param.productTransfer, recommendation = param.recommendation, accepting = param.accepting, accepted = param.accepted, hasAccepted = param.hasAccepted, onAcceptRecommendation = param.onAcceptRecommendation, lenderName = param.lenderName, onUploadDocuments = param.onUploadDocuments, friendlyId = param.friendlyId, acceptedVia = param.acceptedVia, acceptedDateTime = param.acceptedDateTime;
    var _recommendation_accept;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$7a3e25fda9bd3f90), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$6ad60e10b36e0cc5), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: "Ready to go?"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$11143fb7c1944d42), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$1775942900a3c06c), {
                                children: [
                                    !productTransfer ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$71eff207453c5873), {
                                        children: "Great news, that's everything we need right now we'll confirm when your application has been submitted."
                                    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$f51f4c4ede09e011), {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$71eff207453c5873), {
                                                children: recommendation.accept.text
                                            }),
                                            ((_recommendation_accept = recommendation.accept) === null || _recommendation_accept === void 0 ? void 0 : _recommendation_accept.subText) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$71eff207453c5873), {
                                                children: recommendation.accept.subText.replace(/\[Lender\]/g, lenderName)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                        children: [
                                            accepting ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                                                size: 32,
                                                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
                                            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                children: accepted || hasAccepted ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$3e6977b478c02b14), {
                                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                                        children: "Accepted"
                                                    })
                                                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$64ebbd04a8748684), {
                                                        type: "button",
                                                        onClick: onAcceptRecommendation,
                                                        children: "Accept Recommendation"
                                                    })
                                                })
                                            }),
                                            (accepted || hasAccepted) && !accepting && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $122d329bce1db699$export$d7c0be5787dd034), {
                                                acceptedDateTime: acceptedDateTime,
                                                acceptedVia: acceptedVia
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                children: "By accepting, you are giving consent for your selected lender to conduct a hard credit check (this does not apply if you are transferring to a new product with your existing lender)"
                            })
                        ]
                    })
                ]
            }),
            hasAccepted && !accepting && !productTransfer && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$2df59151ffc61c31), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: "Great! You\u2019re now one step closer"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                children: "Please check we have all the correct documents for you and we'll get the wheels in motion."
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$dc755699165ff19e), {
                                href: "/application/".concat(friendlyId, "/documents"),
                                onClick: onUploadDocuments,
                                children: "Upload Documents"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





parcelRequire("hAGkE");
var $38054749b83a550b$export$a37b17312f35d066 = function(param) {
    var propertyValue = param.propertyValue, purchasePrice = param.purchasePrice, currentMortgageBalance = param.currentMortgageBalance, additionalBorrowingAmount = param.additionalBorrowingAmount, totalLoanAmount = param.totalLoanAmount, borrowingAmountFormatted = param.borrowingAmountFormatted, addArrangementFeeToLoan = param.addArrangementFeeToLoan, formattedArrangementFee = param.formattedArrangementFee, ltv = param.ltv, termYears = param.termYears, years = param.years, months = param.months;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$8f239afcee4d6cc), {
        "aria-label": "Your mortgage",
        children: [
            !!propertyValue && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: "Property value"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(propertyValue)
                    })
                ]
            }),
            !!purchasePrice && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: "Purchase price"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(purchasePrice)
                    })
                ]
            }),
            !!currentMortgageBalance && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: "Balance"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(currentMortgageBalance)
                    })
                ]
            }),
            !!additionalBorrowingAmount && !purchasePrice && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: "Additional borrowing"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(additionalBorrowingAmount)
                    })
                ]
            }),
            !!totalLoanAmount && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                    children: "Borrowing total"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                    children: borrowingAmountFormatted
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {}),
                                addArrangementFeeToLoan && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bb778bbe30d14b97), {
                                        children: [
                                            "Includes \xa3",
                                            formattedArrangementFee,
                                            " arrangement fee"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            !!ltv && typeof ltv === "number" && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: "Loan to value"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: [
                            Math.floor(ltv),
                            "%"
                        ]
                    })
                ]
            }),
            !!termYears && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: "Term"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                        children: [
                            years ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                                children: [
                                    years,
                                    " years"
                                ]
                            }) : null,
                            months ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                                children: [
                                    " ",
                                    months,
                                    " months"
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};




parcelRequire("hAGkE");
var $450616c2bdbe03b8$var$formatProductEndDate = function(date) {
    var month = date.toLocaleString("default", {
        month: "short"
    });
    var year = date.getFullYear();
    return "".concat(month, " ").concat(year);
};
var $450616c2bdbe03b8$export$d25b4fe381df2a90 = function(param) {
    var mortgageEndsBeforeProduct = param.mortgageEndsBeforeProduct, productEndDate = param.productEndDate, followOnMonthlyRate = param.followOnMonthlyRate, formattedFollowOnMonthlyPayment = param.formattedFollowOnMonthlyPayment;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$bc5c19970cafbf73), {
        children: mortgageEndsBeforeProduct ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$8f239afcee4d6cc), {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                children: "You'll have repaid the whole of your mortgage"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                            children: "Congratulations! Your mortgage will be repaid by the time this deal ends."
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$8f239afcee4d6cc), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                            children: "Deal end date"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                            children: $450616c2bdbe03b8$var$formatProductEndDate(new Date(productEndDate))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                    children: "At this point you will be moved onto the standard variable rate."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                children: "Standard variable rate (SVR)"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                                children: [
                                    followOnMonthlyRate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                children: "Monthly payments after initial period"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                                children: [
                                    "\xa3",
                                    formattedFollowOnMonthlyPayment
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};




parcelRequire("hAGkE");
var $e46986e581cd9329$export$caa2319371f98fb5 = function(param) {
    var offset = param.offset, portable = param.portable, cashback = param.cashback, formattedCashback = param.formattedCashback, freeLegals = param.freeLegals, freeValuation = param.freeValuation;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$946a4e1031ba824), {
            "aria-label": "Extras",
            children: [
                offset && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bbb93379fdcec643), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Offset"
                        })
                    ]
                }),
                portable && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bbb93379fdcec643), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Portable"
                        })
                    ]
                }),
                (cashback && cashback > 0) === true && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bbb93379fdcec643), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                            children: [
                                "\xa3",
                                formattedCashback,
                                " Cashback"
                            ]
                        })
                    ]
                }),
                freeLegals && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bbb93379fdcec643), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Free standard legal costs*"
                        })
                    ]
                }),
                freeValuation && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bbb93379fdcec643), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Free valuation"
                        })
                    ]
                })
            ]
        })
    });
};




var $c1f6901f9690afd1$exports = {};
$c1f6901f9690afd1$exports = $parcel$resolve("2ia5v");


var $c07d948393f62e9e$exports = {};
$c07d948393f62e9e$exports = $parcel$resolve("5zRIh");



parcelRequire("hAGkE");
var $ab92a5761ee82cb5$export$591586ecb65b68fc = function(param) {
    var inRateCheckExperiment = param.inRateCheckExperiment;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$5360ff2533d8ca65), {
        children: inRateCheckExperiment ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$f8574db33bc0265e), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$8528d0ddb1828281), {
                            children: "Rate Check Promise"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Once you have had an offer accepted by a lender, we\u2019ll check you\u2019re still on the lowest rate for the mortgage deal you\u2019ve chosen and will let you know of changes all the way until you complete. If we find a lower rate for your deal, we\u2019ll let you know."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$396ff1b3e2be0ec4), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ff419e2b02580b2c$exports))),
                    alt: "Example of a Rate Check Promise"
                })
            ]
        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$f8574db33bc0265e), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$9003ac83d962f699), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$9393272ffc956161), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c1f6901f9690afd1$exports)))
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                    children: "Rate Checker"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                            children: "Waiting for rates to fall?"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Applying now secures today\u2019s recommended rate. If rates drop later, ask us to re-check 60+ lenders and we\u2019ll help you reapply for a lower rate\u2014anytime between the offer and 30 days before completion"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$deae54d360d340f1), {
                            href: "https://mojomortgages.com/mojo-rate-checker",
                            children: "View the FAQs"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$41a8f75448821445), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c07d948393f62e9e$exports)))
                }),
                " "
            ]
        })
    });
};






parcelRequire("hAGkE");
var $0ac117d47bddb410$export$600c5c03939a270c = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$2a9d479a61a53f9), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: "Mojo's Broker Fee"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("span", {
                        children: [
                            "\xa3",
                            0
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                children: "We don't charge you a penny, all our costs are covered by the lender, these fees never affect our advice. Our reputation and livelihood depend on us always giving our customers the best possible advice."
            })
        ]
    });
};



parcelRequire("hAGkE");

var $0f894325b33bfe5f$export$aceb049150e4b47b = function(param) {
    var lenderName = param.lenderName, formattedMonthlyPayment = param.formattedMonthlyPayment, initialRate = param.initialRate, aprc = param.aprc, formattedArrangementFee = param.formattedArrangementFee, addArrangementFeeToLoan = param.addArrangementFeeToLoan, totalMonths = param.totalMonths, productType = param.productType, paymentType = param.paymentType, interestOnlyAmount = param.interestOnlyAmount, repaymentAmount = param.repaymentAmount, productCondition = param.productCondition, overpayments = param.overpayments, earlyRepaymentChargesApply = param.earlyRepaymentChargesApply, earlyRepaymentCharge = param.earlyRepaymentCharge;
    var formattedPaymentType = paymentType.charAt(0).toUpperCase() + paymentType.slice(1);
    var formattedInterestOnlyAmount = (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(interestOnlyAmount);
    var formattedRepaymentAmount = (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(repaymentAmount);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$8f239afcee4d6cc), {
                "aria-label": "Key details",
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: "Lender"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: lenderName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: "Monthly payment"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: [
                                    "\xa3",
                                    formattedMonthlyPayment
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: "Initial rate"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: [
                                    initialRate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                            children: "Annual Percentage Rate of Charge (APRC)"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                            children: [
                                                aprc,
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                        children: "APRC assumes the total cost of a mortgage, including fees, over the entire term of the loan."
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                            children: "Arrangement fee"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                            children: [
                                                "\xa3",
                                                formattedArrangementFee
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                            children: "Please refer to your mortgage illustration for a full breakdown of fees"
                                        }),
                                        addArrangementFeeToLoan && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                            children: "Added to loan"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$f741b11b5cf521b), {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                        children: "Initial period"
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                        children: (0, $45f64f2ccb2647eb$export$c6388e33355c3eca)(totalMonths)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: "Product type"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                children: productType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: formattedPaymentType === "Part and part" ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                            direction: "right",
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                            children: "Payment type"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                            children: formattedPaymentType
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                        children: [
                                            "(\xa3",
                                            formattedInterestOnlyAmount,
                                            " interest-only, \xa3",
                                            formattedRepaymentAmount,
                                            " capital & interest)"
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                    children: "Payment type"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                    children: formattedPaymentType
                                })
                            ]
                        })
                    }),
                    productCondition && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                        children: "Lender specific conditions"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$ae479c4985576dff), {
                                        children: productCondition
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$18a785182e0ab9b0), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h2", {
                        children: "Over and early repayments"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$8f239afcee4d6cc), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                        children: "Overpayments"
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                        children: overpayments ? "Yes" : "No"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$a0671ff06a087bc), {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$baa4df250058c4a0), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                                    children: "Early repayment charge (ERC)"
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$b51735ea2e95cf99), {
                                                    children: earlyRepaymentChargesApply ? "Yes" : "No"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$27c2eb85af0f2a3), {
                                            children: earlyRepaymentCharge
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0ac117d47bddb410$export$600c5c03939a270c), {})
        ]
    });
};






var $49e9097092df9547$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $49e9097092df9547$export$2c14ff85d6318973 = function(token, count, options) {
    var result;
    var tokenValue = $49e9097092df9547$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $03387bfb79c075bd$export$38e44e97ce4dbb7d(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $d5fdc51b5de4596d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $d5fdc51b5de4596d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d5fdc51b5de4596d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d5fdc51b5de4596d$export$cbf60ecb96cbb82f = {
    date: (0, $03387bfb79c075bd$export$38e44e97ce4dbb7d)({
        formats: $d5fdc51b5de4596d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $03387bfb79c075bd$export$38e44e97ce4dbb7d)({
        formats: $d5fdc51b5de4596d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $03387bfb79c075bd$export$38e44e97ce4dbb7d)({
        formats: $d5fdc51b5de4596d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $f281e6a6f3530362$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $f281e6a6f3530362$export$8fbbfd65594f46a0 = function(token, _date, _baseDate, _options) {
    return $f281e6a6f3530362$var$formatRelativeLocale[token];
};


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $519ca8f4fc224aa5$export$63596d6ee8878b25(args) {
    return function(value, options) {
        var context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var defaultWidth1 = args.defaultWidth;
            var width1 = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width1] || args.values[defaultWidth1];
        }
        var index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $b3841b4e37dac5f6$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $b3841b4e37dac5f6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $b3841b4e37dac5f6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $b3841b4e37dac5f6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $b3841b4e37dac5f6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $b3841b4e37dac5f6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $b3841b4e37dac5f6$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $b3841b4e37dac5f6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b3841b4e37dac5f6$var$ordinalNumber,
    era: (0, $519ca8f4fc224aa5$export$63596d6ee8878b25)({
        values: $b3841b4e37dac5f6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $519ca8f4fc224aa5$export$63596d6ee8878b25)({
        values: $b3841b4e37dac5f6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $519ca8f4fc224aa5$export$63596d6ee8878b25)({
        values: $b3841b4e37dac5f6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $519ca8f4fc224aa5$export$63596d6ee8878b25)({
        values: $b3841b4e37dac5f6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $519ca8f4fc224aa5$export$63596d6ee8878b25)({
        values: $b3841b4e37dac5f6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b3841b4e37dac5f6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $918ff36e1c9917e8$export$1430a0f35710914d(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $918ff36e1c9917e8$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $918ff36e1c9917e8$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $918ff36e1c9917e8$var$findKey(object, predicate) {
    for(var key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $918ff36e1c9917e8$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $5adf5384dc6e1802$export$fdaf2fd6d7edde95(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $77a6bb4552403dd6$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $77a6bb4552403dd6$var$parseOrdinalNumberPattern = /\d+/i;
var $77a6bb4552403dd6$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $77a6bb4552403dd6$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $77a6bb4552403dd6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $77a6bb4552403dd6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $77a6bb4552403dd6$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $77a6bb4552403dd6$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $77a6bb4552403dd6$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $77a6bb4552403dd6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $77a6bb4552403dd6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $77a6bb4552403dd6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $77a6bb4552403dd6$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $5adf5384dc6e1802$export$fdaf2fd6d7edde95)({
        matchPattern: $77a6bb4552403dd6$var$matchOrdinalNumberPattern,
        parsePattern: $77a6bb4552403dd6$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $918ff36e1c9917e8$export$1430a0f35710914d)({
        matchPatterns: $77a6bb4552403dd6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77a6bb4552403dd6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $918ff36e1c9917e8$export$1430a0f35710914d)({
        matchPatterns: $77a6bb4552403dd6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77a6bb4552403dd6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $918ff36e1c9917e8$export$1430a0f35710914d)({
        matchPatterns: $77a6bb4552403dd6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77a6bb4552403dd6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $918ff36e1c9917e8$export$1430a0f35710914d)({
        matchPatterns: $77a6bb4552403dd6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $77a6bb4552403dd6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $918ff36e1c9917e8$export$1430a0f35710914d)({
        matchPatterns: $77a6bb4552403dd6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $77a6bb4552403dd6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


var $d9ec3fa15f33323e$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $49e9097092df9547$export$2c14ff85d6318973),
    formatLong: (0, $d5fdc51b5de4596d$export$cbf60ecb96cbb82f),
    formatRelative: (0, $f281e6a6f3530362$export$8fbbfd65594f46a0),
    localize: (0, $b3841b4e37dac5f6$export$b3bd0bc58e36cd63),
    match: (0, $77a6bb4552403dd6$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$d9ec3fa15f33323e$export$2e2bcd8739ae039 = $d9ec3fa15f33323e$export$137380d9ce54f7f;


var $fa1b6aadafc7f2fa$var$defaultOptions = {};
function $fa1b6aadafc7f2fa$export$430a3269e24b912e() {
    return $fa1b6aadafc7f2fa$var$defaultOptions;
}
function $fa1b6aadafc7f2fa$export$95365be1b0704abc(newOptions) {
    $fa1b6aadafc7f2fa$var$defaultOptions = newOptions;
}



var $6mdMa = parcelRequire("6mdMa");

var $2xTNA = parcelRequire("2xTNA");
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var $c5bc847069758385$export$dfd9b671c89acc8e = 7;
var $c5bc847069758385$export$3913210603d8e9ae = 365.2425;
var $c5bc847069758385$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $c5bc847069758385$export$4dec998e48f9c246 = -$c5bc847069758385$export$81caae6e1cc7a622;
var $c5bc847069758385$export$4fad13613e88edc8 = 604800000;
var $c5bc847069758385$export$b76b1809a2898f9a = 86400000;
var $c5bc847069758385$export$91246f0b9bd9beff = 60000;
var $c5bc847069758385$export$7f72910d6dfd237a = 3600000;
var $c5bc847069758385$export$397c2d5776aa9055 = 1000;
var $c5bc847069758385$export$3633035e63cee86a = 525600;
var $c5bc847069758385$export$ab7da2ccd1075c38 = 43200;
var $c5bc847069758385$export$2423174df8cd3cd2 = 1440;
var $c5bc847069758385$export$f2f5ae5a8e2d8f9f = 60;
var $c5bc847069758385$export$3c58128db900d44e = 3;
var $c5bc847069758385$export$80d7e435f744f319 = 12;
var $c5bc847069758385$export$4db7641526e3241f = 4;
var $c5bc847069758385$export$698aec755e92c695 = 3600;
var $c5bc847069758385$export$a77c1a7ebebe2a5a = 60;
var $c5bc847069758385$export$815a9362476d2fe3 = $c5bc847069758385$export$698aec755e92c695 * 24;
var $c5bc847069758385$export$34804a017b31e2fe = $c5bc847069758385$export$815a9362476d2fe3 * 7;
var $c5bc847069758385$export$7271e9e3478110d1 = $c5bc847069758385$export$815a9362476d2fe3 * $c5bc847069758385$export$3913210603d8e9ae;
var $c5bc847069758385$export$8e6600bbdee7dabb = $c5bc847069758385$export$7271e9e3478110d1 / 12;
var $c5bc847069758385$export$be1dccf2de902d31 = $c5bc847069758385$export$8e6600bbdee7dabb * 3;
var $c5bc847069758385$export$2a7b97929c48d47d = Symbol["for"]("constructDateFrom");


function $e5db6a7cf86305a4$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && (typeof date === "undefined" ? "undefined" : (0, $2xTNA._)(date)) === "object" && (0, $c5bc847069758385$export$2a7b97929c48d47d) in date) return date[0, $c5bc847069758385$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$e5db6a7cf86305a4$export$2e2bcd8739ae039 = $e5db6a7cf86305a4$export$ead8a1812b171991;


function $c3a71636660878e5$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $e5db6a7cf86305a4$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$c3a71636660878e5$export$2e2bcd8739ae039 = $c3a71636660878e5$export$e67a095c620b86fe;


function $b8873a3cd0e70386$export$113002b5eff6e430(date) {
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date);
    var utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



var $2xTNA = parcelRequire("2xTNA");

function $bcfbcec24d48ea04$export$9f53b88e82f64d8d(context) {
    for(var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        dates[_key - 1] = arguments[_key];
    }
    var normalize = (0, $e5db6a7cf86305a4$export$ead8a1812b171991).bind(null, context || dates.find(function(date) {
        return (typeof date === "undefined" ? "undefined" : (0, $2xTNA._)(date)) === "object";
    }));
    return dates.map(normalize);
}




function $97724e1f611af8ca$export$63fa379ae8a9ba2(date, options) {
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$97724e1f611af8ca$export$2e2bcd8739ae039 = $97724e1f611af8ca$export$63fa379ae8a9ba2;


function $12c642805e47de91$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6mdMa._)((0, $bcfbcec24d48ea04$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options["in"], laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    var laterStartOfDay = (0, $97724e1f611af8ca$export$63fa379ae8a9ba2)(laterDate_);
    var earlierStartOfDay = (0, $97724e1f611af8ca$export$63fa379ae8a9ba2)(earlierDate_);
    var laterTimestamp = +laterStartOfDay - (0, $b8873a3cd0e70386$export$113002b5eff6e430)(laterStartOfDay);
    var earlierTimestamp = +earlierStartOfDay - (0, $b8873a3cd0e70386$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $c5bc847069758385$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$12c642805e47de91$export$2e2bcd8739ae039 = $12c642805e47de91$export$4a02e9c37dab4871;



function $829bdb0d78954762$export$f91e89d3d0406102(date, options) {
    var date_ = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$829bdb0d78954762$export$2e2bcd8739ae039 = $829bdb0d78954762$export$f91e89d3d0406102;



function $81e30af3a5c311c4$export$d3b42cd8452deec(date, options) {
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    var diff = (0, $12c642805e47de91$export$4a02e9c37dab4871)(_date, (0, $829bdb0d78954762$export$f91e89d3d0406102)(_date));
    var dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$81e30af3a5c311c4$export$2e2bcd8739ae039 = $81e30af3a5c311c4$export$d3b42cd8452deec;




var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");


function $ed7dbf134dc46bf8$export$42c81a444fbfb5d4(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $fa1b6aadafc7f2fa$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$ed7dbf134dc46bf8$export$2e2bcd8739ae039 = $ed7dbf134dc46bf8$export$42c81a444fbfb5d4;


function $f26fde1615c8095c$export$6173213f95a4431e(date, options) {
    return (0, $ed7dbf134dc46bf8$export$42c81a444fbfb5d4)(date, (0, $7XD9P._)((0, $hRCmZ._)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$f26fde1615c8095c$export$2e2bcd8739ae039 = $f26fde1615c8095c$export$6173213f95a4431e;






function $8acb12d3a27d2082$export$3dbc52535f6f8fcc(date, options) {
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    var year = _date.getFullYear();
    var fourthOfJanuaryOfNextYear = (0, $e5db6a7cf86305a4$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f26fde1615c8095c$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = (0, $e5db6a7cf86305a4$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f26fde1615c8095c$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$8acb12d3a27d2082$export$2e2bcd8739ae039 = $8acb12d3a27d2082$export$3dbc52535f6f8fcc;



function $10b8f0c2c0989c27$export$236bdfa374eb69a9(date, options) {
    var year = (0, $8acb12d3a27d2082$export$3dbc52535f6f8fcc)(date, options);
    var fourthOfJanuary = (0, $e5db6a7cf86305a4$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options["in"]) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $f26fde1615c8095c$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$10b8f0c2c0989c27$export$2e2bcd8739ae039 = $10b8f0c2c0989c27$export$236bdfa374eb69a9;



function $0d0cfab54760433d$export$7cabdc5698b63e2f(date, options) {
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    var diff = +(0, $f26fde1615c8095c$export$6173213f95a4431e)(_date) - +(0, $10b8f0c2c0989c27$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $c5bc847069758385$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$0d0cfab54760433d$export$2e2bcd8739ae039 = $0d0cfab54760433d$export$7cabdc5698b63e2f;











function $ca7c83cab0c170b0$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    var year = _date.getFullYear();
    var defaultOptions = (0, $fa1b6aadafc7f2fa$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var firstWeekOfNextYear = (0, $e5db6a7cf86305a4$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options["in"]) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ed7dbf134dc46bf8$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = (0, $e5db6a7cf86305a4$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options["in"]) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ed7dbf134dc46bf8$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$ca7c83cab0c170b0$export$2e2bcd8739ae039 = $ca7c83cab0c170b0$export$12d572480ceb6e58;



function $4c47cb677b1f8b34$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $fa1b6aadafc7f2fa$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var year = (0, $ca7c83cab0c170b0$export$12d572480ceb6e58)(date, options);
    var firstWeek = (0, $e5db6a7cf86305a4$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options["in"]) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var _date = (0, $ed7dbf134dc46bf8$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$4c47cb677b1f8b34$export$2e2bcd8739ae039 = $4c47cb677b1f8b34$export$bb7b45bb8e74da0f;



function $9eaff8057fb5f174$export$efe19b760242b2fc(date, options) {
    var _date = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    var diff = +(0, $ed7dbf134dc46bf8$export$42c81a444fbfb5d4)(_date, options) - +(0, $4c47cb677b1f8b34$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $c5bc847069758385$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$9eaff8057fb5f174$export$2e2bcd8739ae039 = $9eaff8057fb5f174$export$efe19b760242b2fc;



function $64d8695b7a17b585$export$c8306e720e213c0f(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



var $7914e25e0a1f59a4$export$b0d4b338e1516f13 = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $64d8695b7a17b585$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


var $c191f6e3144c6657$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var $c191f6e3144c6657$export$fe98a034cfb96d55 = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $ca7c83cab0c170b0$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $8acb12d3a27d2082$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getFullYear();
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $9eaff8057fb5f174$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $0d0cfab54760433d$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $81e30af3a5c311c4$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $c191f6e3144c6657$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $c191f6e3144c6657$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $c191f6e3144c6657$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $c191f6e3144c6657$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $c191f6e3144c6657$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $c191f6e3144c6657$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $7914e25e0a1f59a4$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $c191f6e3144c6657$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $c191f6e3144c6657$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $c191f6e3144c6657$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $c191f6e3144c6657$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $c191f6e3144c6657$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $c191f6e3144c6657$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $c191f6e3144c6657$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $c191f6e3144c6657$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $c191f6e3144c6657$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $c191f6e3144c6657$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize) {
        var timestamp = Math.trunc(+date / 1000);
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize) {
        return (0, $64d8695b7a17b585$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $c191f6e3144c6657$var$formatTimezoneShort(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.trunc(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $64d8695b7a17b585$export$c8306e720e213c0f)(minutes, 2);
}
function $c191f6e3144c6657$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $64d8695b7a17b585$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $c191f6e3144c6657$var$formatTimezone(offset, delimiter);
}
function $c191f6e3144c6657$var$formatTimezone(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $64d8695b7a17b585$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    var minutes = (0, $64d8695b7a17b585$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $076ae4d62c0a48c1$var$dateLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $076ae4d62c0a48c1$var$timeLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $076ae4d62c0a48c1$var$dateTimeLongFormatter = function(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $076ae4d62c0a48c1$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $076ae4d62c0a48c1$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $076ae4d62c0a48c1$var$timeLongFormatter(timePattern, formatLong));
};
var $076ae4d62c0a48c1$export$70cc8fd02856fd58 = {
    p: $076ae4d62c0a48c1$var$timeLongFormatter,
    P: $076ae4d62c0a48c1$var$dateTimeLongFormatter
};


var $a15147401a1a9b89$var$dayOfYearTokenRE = /^D+$/;
var $a15147401a1a9b89$var$weekYearTokenRE = /^Y+$/;
var $a15147401a1a9b89$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $a15147401a1a9b89$export$c6cc36aa33304772(token) {
    return $a15147401a1a9b89$var$dayOfYearTokenRE.test(token);
}
function $a15147401a1a9b89$export$c6b49d6dceb604a1(token) {
    return $a15147401a1a9b89$var$weekYearTokenRE.test(token);
}
function $a15147401a1a9b89$export$f5f38f90ecaaf879(token, format, input) {
    var _message = $a15147401a1a9b89$var$message(token, format, input);
    console.warn(_message);
    if ($a15147401a1a9b89$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $a15147401a1a9b89$var$message(token, format, input) {
    var subject = token[0] === "Y" ? "years" : "days of the month";
    return "Use `".concat(token.toLowerCase(), "` instead of `").concat(token, "` (in `").concat(format, "`) for formatting ").concat(subject, " to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
var $2xTNA = parcelRequire("2xTNA");
function $7b1be019ea9e2b7f$export$871608497c498473(value) {
    return value instanceof Date || (typeof value === "undefined" ? "undefined" : (0, $2xTNA._)(value)) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$7b1be019ea9e2b7f$export$2e2bcd8739ae039 = $7b1be019ea9e2b7f$export$871608497c498473;



function $21fbb8a0445d8500$export$1ea939691cdc45b8(date) {
    return !(!(0, $7b1be019ea9e2b7f$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $c3a71636660878e5$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$21fbb8a0445d8500$export$2e2bcd8739ae039 = $21fbb8a0445d8500$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $c88d7a58c9cb7299$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $c88d7a58c9cb7299$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $c88d7a58c9cb7299$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $c88d7a58c9cb7299$var$doubleQuoteRegExp = /''/g;
var $c88d7a58c9cb7299$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $c88d7a58c9cb7299$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, $fa1b6aadafc7f2fa$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d9ec3fa15f33323e$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    var originalDate = (0, $c3a71636660878e5$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options["in"]);
    if (!(0, $21fbb8a0445d8500$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    var parts = formatStr.match($c88d7a58c9cb7299$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $076ae4d62c0a48c1$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($c88d7a58c9cb7299$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $c88d7a58c9cb7299$var$cleanEscapedString(substring)
        };
        if ((0, $c191f6e3144c6657$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($c88d7a58c9cb7299$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map(function(part) {
        if (!part.isToken) return part.value;
        var token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $a15147401a1a9b89$export$c6b49d6dceb604a1)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $a15147401a1a9b89$export$c6cc36aa33304772)(token)) (0, $a15147401a1a9b89$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        var formatter = (0, $c191f6e3144c6657$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $c88d7a58c9cb7299$var$cleanEscapedString(input) {
    var matched = input.match($c88d7a58c9cb7299$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($c88d7a58c9cb7299$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$c88d7a58c9cb7299$export$2e2bcd8739ae039 = $c88d7a58c9cb7299$export$d9468344d3651243;


function $c14f24c260cd88e5$export$3664df8597731ed4(unixTime, options) {
    return (0, $c3a71636660878e5$export$e67a095c620b86fe)(unixTime * 1000, options === null || options === void 0 ? void 0 : options["in"]);
}
var // Fallback for modularized imports:
$c14f24c260cd88e5$export$2e2bcd8739ae039 = $c14f24c260cd88e5$export$3664df8597731ed4;




var $hAGkE = parcelRequire("hAGkE");
var $26c7d44b0bcf24fd$export$ba2f44035effd9c1 = (0, $hAGkE.createContext)({
    serviceType: (0, $cba09c37978e7e74$export$c99b893d464ee8dd).DEFAULT,
    paymentStatus: undefined,
    setPaymentStatus: function() {
        return {};
    },
    isBtlSpecialist: false,
    friendlyId: ""
});
var $26c7d44b0bcf24fd$export$3321c0b02f750bcc = function() {
    return (0, $hAGkE.useContext)($26c7d44b0bcf24fd$export$ba2f44035effd9c1);
};






parcelRequire("hAGkE");
function $48ad76595d8deb80$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 24px 32px 8px 32px;\n\n  & > h2 {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 28px;\n  }\n  & > span {\n    font-weight: 600;\n    font-size: 18px;\n  }\n\n  @media screen and ",
        " {\n    padding: 24px 32px 8px 32px;\n  }\n"
    ]);
    $48ad76595d8deb80$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $48ad76595d8deb80$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #fff;\n  border-radius: 24px;\n"
    ]);
    $48ad76595d8deb80$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $48ad76595d8deb80$var$SectionTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($48ad76595d8deb80$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $48ad76595d8deb80$var$DetailsSectionContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($48ad76595d8deb80$var$_templateObject1());
var $48ad76595d8deb80$export$cdc9f1a6e273987f = function(param) {
    var title = param.title, children = param.children, smallTitle = param.smallTitle;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($48ad76595d8deb80$var$DetailsSectionContainer, {
        children: [
            title && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($48ad76595d8deb80$var$SectionTitle, {
                children: smallTitle ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                    children: title
                }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h2", {
                    children: title
                })
            }),
            children
        ]
    });
};




parcelRequire("hAGkE");








parcelRequire("hAGkE");
var $541beb5045c50ae1$var$WithinBudgetCopy = function(param) {
    var budget = param.budget;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "The monthly cost for this mortgage is",
            " ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("strong", {
                children: [
                    "within your stated budget of \xa3",
                    (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(budget)
                ]
            }),
            ", ensuring the ongoing cost remains at a level you are comfortable with."
        ]
    });
};
var $541beb5045c50ae1$var$ExceededBudgetCopy = function(param) {
    var budget = param.budget;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "Although the monthly payment is",
            " ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("strong", {
                children: [
                    "higher than your original budget of \xa3",
                    (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(budget)
                ]
            }),
            ", I\u2019ve reviewed your income and outgoings and am satisfied it\u2019s affordable, and you\u2019re comfortable it fits within your finances."
        ]
    });
};
var $541beb5045c50ae1$export$31a0f43d283b8625 = function(param) {
    var budget = param.budget, monthlyPayment = param.monthlyPayment;
    return monthlyPayment > budget ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($541beb5045c50ae1$var$ExceededBudgetCopy, {
        budget: budget
    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($541beb5045c50ae1$var$WithinBudgetCopy, {
        budget: budget
    });
};



parcelRequire("hAGkE");
var $434a5e61eba0019b$var$lendingIntoRetirementCopy = " You\u2019re aware that this extends into your planned retirement age and have an appropriate plan in place to cover your monthly payments.";
var $434a5e61eba0019b$export$c011cbfb2e714a59 = function(param) {
    var preference = param.preference, isLendingIntoRetirement = param.isLendingIntoRetirement;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "A term of",
            " ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("strong", {
                children: [
                    preference.years,
                    " years",
                    preference.months ? ", ".concat(preference.months, " months") : ""
                ]
            }),
            " ",
            "has been recommended because ",
            preference.customReason,
            isLendingIntoRetirement ? $434a5e61eba0019b$var$lendingIntoRetirementCopy : ""
        ]
    });
};




parcelRequire("hAGkE");
var $1b46e4319ab659bc$var$NoFeesCopy = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "You have chosen a mortgage product with ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                children: "no arrangement fees"
            }),
            ". This option ensures you do not have to pay an application fee upfront or incur additional interest by adding fees to your total loan amount."
        ]
    });
};
var $1b46e4319ab659bc$var$AddToTheLoanCopy = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "You chose to ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                children: "add the fees to your mortgage"
            }),
            " to avoid a large upfront cost. You understand this will increase the total interest you pay over the life of the loan."
        ]
    });
};
var $1b46e4319ab659bc$var$PayUpFrontCopy = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "You chose to ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                children: "pay the fees up front"
            }),
            " to keep your total loan amount as low as possible and avoid paying any extra interest."
        ]
    });
};
var $1b46e4319ab659bc$export$bca638a4600cdf0c = function(param) {
    var preference = param.preference, feeAmount = param.feeAmount;
    switch(preference.type){
        case (0, $9394149be221a7b2$export$7e00024f63cae4dc).NoFees:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($1b46e4319ab659bc$var$NoFeesCopy, {});
        case (0, $9394149be221a7b2$export$7e00024f63cae4dc).AddToTheLoan:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($1b46e4319ab659bc$var$AddToTheLoanCopy, {});
        case (0, $9394149be221a7b2$export$7e00024f63cae4dc).PayUpFront:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($1b46e4319ab659bc$var$PayUpFrontCopy, {});
        default:
            return null;
    }
};




parcelRequire("hAGkE");
var $e486e9b5c054e1a9$export$7c16f47ab9d38f77 = function(param) {
    var preference = param.preference;
    switch(preference.method){
        case (0, $9394149be221a7b2$export$a3e2f90018137d93).Repayment:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "repayment mortgage"
                    }),
                    " has been recommended because",
                    " ",
                    preference.customReason
                ]
            });
        case (0, $9394149be221a7b2$export$a3e2f90018137d93).InterestOnly:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "An ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "interest-only mortgage"
                    }),
                    " has been recommended because",
                    " ",
                    preference.customReason
                ]
            });
        case (0, $9394149be221a7b2$export$a3e2f90018137d93).PartAndPart:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "part and part mortgage"
                    }),
                    " has been recommended because",
                    " ",
                    preference.customReason
                ]
            });
        default:
            return null;
    }
};




parcelRequire("hAGkE");
var $bc9f104e245c0692$export$3d6358813a7f4e4b = function(param) {
    var preference = param.preference;
    switch(preference.type){
        case (0, $9394149be221a7b2$export$4209eccf50c0f416).TrackerMortgage:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "tracker rate"
                    }),
                    " has been recommended because ",
                    preference.customReason
                ]
            });
        case (0, $9394149be221a7b2$export$4209eccf50c0f416).FixedRateMortgage:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "fixed rate mortgage"
                    }),
                    " has been recommended because",
                    " ",
                    preference.customReason
                ]
            });
        default:
            return null;
    }
};




parcelRequire("hAGkE");
var $16648123f6e5fa4c$export$f426b25a282176cf = function(param) {
    var _param_preference = param.preference, reason = _param_preference.customReason, period = _param_preference.period;
    switch(period){
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).OneYear:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "1-year deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).TwoYears:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "2-year deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).ThreeYears:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "3-year deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).FiveYears:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "5-year deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).SevenYears:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "7-year deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).TenYears:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "10-year deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).OverTenYears:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "A ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "deal over 10 years"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        case (0, $9394149be221a7b2$export$efdb592ec75b1a1b).ERCFree:
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    "An ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                        children: "ERC free deal"
                    }),
                    " has been recommended because ",
                    reason
                ]
            });
        default:
            return null;
    }
};




function $ff39308d8d173bc1$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 8px;\n  div:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"
    ]);
    $ff39308d8d173bc1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ff39308d8d173bc1$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background-color: #038352;\n  height: 24px;\n  width: 24px;\n  border-radius: 260px;\n  gap: 8px;\n  padding: 6px;\n  display: flex;\n  align-items: flex-start;\n"
    ]);
    $ff39308d8d173bc1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $ff39308d8d173bc1$var$mapMortgagePreferences = function(param, param1, param2) {
    var initialPeriod = param.initialPeriod, mortgageType = param.mortgageType, repaymentMethod = param.repaymentMethod, term = param.term, fees = param.fees, budget = param.budget, initialMonthlyPayment = param1.initialMonthlyPayment, arrangementFee = param1.arrangementFee, isLendingIntoRetirement = param2.isLendingIntoRetirement;
    return [
        initialPeriod && initialPeriod.period && initialPeriod.customReason ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16648123f6e5fa4c$export$f426b25a282176cf), {
            preference: initialPeriod
        }) : null,
        budget && budget.amount ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $541beb5045c50ae1$export$31a0f43d283b8625), {
            budget: budget.amount,
            monthlyPayment: initialMonthlyPayment
        }) : null,
        mortgageType && mortgageType.type && mortgageType.customReason ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc9f104e245c0692$export$3d6358813a7f4e4b), {
            preference: mortgageType
        }) : null,
        repaymentMethod && repaymentMethod.method && repaymentMethod.customReason ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $e486e9b5c054e1a9$export$7c16f47ab9d38f77), {
            preference: repaymentMethod
        }) : null,
        term && term.years && term.customReason ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $434a5e61eba0019b$export$c011cbfb2e714a59), {
            preference: term,
            isLendingIntoRetirement: isLendingIntoRetirement
        }) : null,
        // Don't want to display fees if the arrangementFee is 0 and the preference for fees is either PayUpFront or AddToTheLoan
        fees && fees.type && !(arrangementFee === 0 && fees.type !== (0, $9394149be221a7b2$export$7e00024f63cae4dc).NoFees) ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1b46e4319ab659bc$export$bca638a4600cdf0c), {
            preference: fees,
            feeAmount: arrangementFee
        }) : null
    ];
};
var $ff39308d8d173bc1$var$mapDebtConsolidation = function(param) {
    var customReason = param.customReason, debtConsolidationAppropriate = param.debtConsolidationAppropriate;
    return debtConsolidationAppropriate ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            "We\u2019ve determined that ",
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                children: "consolidating your debts"
            }),
            " is an appropriate path forward because ",
            customReason
        ]
    }) : null;
};
var $ff39308d8d173bc1$var$RecommendationContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ff39308d8d173bc1$var$_templateObject());
var $ff39308d8d173bc1$var$GreenTickContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ff39308d8d173bc1$var$_templateObject1());
var $ff39308d8d173bc1$var$GreenTick = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ff39308d8d173bc1$var$GreenTickContainer, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $abfded16bdabae7a$export$962ee6b89e324472), {
            fillDefault: "#FFFFFF",
            height: 12,
            width: 12,
            type: (0, $abfded16bdabae7a$export$13ff1290a9e22e77).WhiteTick
        })
    });
};
var $ff39308d8d173bc1$var$RecommendationReason = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b6e4dbc26fc7a91d$export$3b4e64e77073e307), {
        fullWidth: true,
        variant: "filled",
        colour: "success",
        leftIcon: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ff39308d8d173bc1$var$GreenTick, {}),
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).SmallBody, {
            "data-testid": "reason-for-recommendation",
            color: "success",
            children: children
        })
    });
};
var $ff39308d8d173bc1$export$8fde054b862aea5d = function(param) {
    var mortgagePreferences = param.mortgagePreferences, debtConsolidation = param.debtConsolidation, caseComplexities = param.caseComplexities, productDetails = param.productDetails;
    var mappedReasonings = $ff39308d8d173bc1$var$mapMortgagePreferences(mortgagePreferences, productDetails, caseComplexities);
    if (debtConsolidation) mappedReasonings.push($ff39308d8d173bc1$var$mapDebtConsolidation(debtConsolidation));
    if (productDetails === null || productDetails === void 0 ? void 0 : productDetails.reasonForRecommendation) mappedReasonings.unshift(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: productDetails.reasonForRecommendation
    }));
    var reasonings = mappedReasonings.filter(function(reason) {
        return reason;
    });
    if (reasonings.length === 0) return null;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
        title: "Why we've recommended this deal",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ff39308d8d173bc1$var$RecommendationContainer, {
            children: reasonings.map(function(reason, index) {
                return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ff39308d8d173bc1$var$RecommendationReason, {
                    children: reason
                }, index);
            })
        })
    });
};


var $b5d29700c7bfc058$export$4cd2d28dc2e93486 = function(friendlyId, data) {
    var _data_initialMonthlyPayment, _data_initialRate, _data_initialFixedPeriod, _data_arrangementFee, _data_extras, _data_extras1, _data_extras2, _data_extras3, _data_extras4, _data_extras_cashback, _data_extras5;
    var _data_productCondition;
    return {
        friendlyId: friendlyId,
        lender_name: data.lenderName,
        product_name: data.productName,
        monthly_cost: (_data_initialMonthlyPayment = data.initialMonthlyPayment) === null || _data_initialMonthlyPayment === void 0 ? void 0 : _data_initialMonthlyPayment.toString(),
        initial_rate: (_data_initialRate = data.initialRate) === null || _data_initialRate === void 0 ? void 0 : _data_initialRate.toString(),
        mortgage_product_type: data.productType,
        initial_period_end_date: data.productEndDate,
        initial_fixed_period: (_data_initialFixedPeriod = data.initialFixedPeriod) === null || _data_initialFixedPeriod === void 0 ? void 0 : _data_initialFixedPeriod.toString(),
        arrangement_fee: (_data_arrangementFee = data.arrangementFee) === null || _data_arrangementFee === void 0 ? void 0 : _data_arrangementFee.toString(),
        mortgage_payment_type: data.paymentType,
        offset: ((_data_extras = data.extras) === null || _data_extras === void 0 ? void 0 : _data_extras.offset) ? "Yes" : "No",
        portable: ((_data_extras1 = data.extras) === null || _data_extras1 === void 0 ? void 0 : _data_extras1.portable) ? "Yes" : "No",
        overpayments_allowed: ((_data_extras2 = data.extras) === null || _data_extras2 === void 0 ? void 0 : _data_extras2.overpayments) ? "Yes" : "No",
        free_legals: ((_data_extras3 = data.extras) === null || _data_extras3 === void 0 ? void 0 : _data_extras3.freeLegals) ? "Yes" : "No",
        free_valuation: ((_data_extras4 = data.extras) === null || _data_extras4 === void 0 ? void 0 : _data_extras4.freeValuation) ? "Yes" : "No",
        cashback: (_data_extras5 = data.extras) === null || _data_extras5 === void 0 ? void 0 : (_data_extras_cashback = _data_extras5.cashback) === null || _data_extras_cashback === void 0 ? void 0 : _data_extras_cashback.toString(),
        full_page_url: "/application/".concat(friendlyId, "/recommendation"),
        productCondition: (_data_productCondition = data.productCondition) !== null && _data_productCondition !== void 0 ? _data_productCondition : ""
    };
};
var $b5d29700c7bfc058$export$406db2478840415b = function(param) {
    var applicationId = param.applicationId, friendlyId = param.friendlyId, serviceType = param.serviceType;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isError = _useState1[0], setIsError = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isDownloading = _useState2[0], setIsDownloading = _useState2[1];
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), applicationData = _useState3[0], setApplicationData = _useState3[1];
    var _useState4 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isAccepting = _useState4[0], setIsAccepting = _useState4[1];
    var isBtlSpecialist = serviceType === (0, $cba09c37978e7e74$export$c99b893d464ee8dd).BTL_SPECIALIST;
    (0, $hAGkE.useEffect)(function() {
        if (applicationId) (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/recommendation/".concat(applicationId), {
            withCredentials: true
        }).then(function(param) {
            var data = param.data;
            setApplicationData(data);
            setIsError(false);
            return setupScrollListener(loadCustomerFeedbackForm);
        })["catch"](function(error) {
            console.error("Recommendation not available:", error.message);
            setIsError(true);
            setIsLoading(false);
        });
    }, [
        applicationId
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (isError) (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).recommendationNotShown,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRecNotReady,
            friendlyId: friendlyId,
            full_page_url: "/application/".concat(friendlyId, "/recommendation")
        });
    }, [
        isError
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (applicationData) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)((0, $hRCmZ._)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).recommendationShown,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRec
            }, $b5d29700c7bfc058$export$4cd2d28dc2e93486(friendlyId, applicationData)));
            setIsLoading(false);
        }
    }, [
        applicationData
    ]);
    var downloadEsisDocument = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var body, response, url, error;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        body = {
                            s3Key: applicationData.esisS3Key,
                            applicationId: applicationId
                        };
                        setIsDownloading(true);
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)((0, $hRCmZ._)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).documentDownload,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRecEsis
                        }, $b5d29700c7bfc058$export$4cd2d28dc2e93486(friendlyId, applicationData)));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/documents/download-url"), body, {
                                withCredentials: true
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status !== 200) {
                            setIsDownloading(false);
                            throw new Error("Error downloading Mortgage Illustration");
                        }
                        url = response.data.downloadUrl;
                        setIsDownloading(false);
                        window.location.assign(url);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        setIsDownloading(false);
                        alert("Error downloading Mortgage Illustration");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var acceptRecommendationOpportunity = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)((0, $hRCmZ._)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRecAccepted
                        }, $b5d29700c7bfc058$export$4cd2d28dc2e93486(friendlyId, applicationData)));
                        setIsAccepting(true);
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).put("https://my-mojo-api.mojomortgages.com/recommendation/update-recommendation-accepted", {
                                applicationId: applicationId,
                                friendlyId: friendlyId
                            }, {
                                withCredentials: true
                            })["catch"](function(error) {
                                console.error(error);
                            })["finally"](function() {
                                setIsAccepting(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var acceptRecommendationQuote = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var quoteId;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)((0, $hRCmZ._)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRecAccepted
                        }, $b5d29700c7bfc058$export$4cd2d28dc2e93486(friendlyId, applicationData)));
                        quoteId = applicationData === null || applicationData === void 0 ? void 0 : applicationData.quoteId;
                        setIsAccepting(true);
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).put("https://my-mojo-api.mojomortgages.com/recommendation/update-recommendation-quote-accepted", {
                                applicationId: applicationId,
                                quoteId: quoteId
                            }, {
                                withCredentials: true
                            })["catch"](function(error) {
                                console.error(error);
                            })["finally"](function() {
                                setIsAccepting(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var loadCustomerFeedbackForm = function() {
        var scriptTag = document.createElement("script");
        scriptTag.src = "//l.getsitecontrol.com/y79nm31w.js";
        scriptTag.type = "text/javascript";
        scriptTag.async = true;
        document.body.appendChild(scriptTag);
        return function() {
            document.body.removeChild(scriptTag);
        };
    };
    var setupScrollListener = function(callback) {
        var handleScroll = function() {
            var scrollPosition = window.scrollY + window.innerHeight;
            var totalHeight = document.documentElement.scrollHeight;
            if (scrollPosition >= totalHeight / 2) {
                // Check if scrolled more than 50%
                callback();
                // Remove the event listener once the condition is met to prevent it from triggering multiple times
                window.removeEventListener("scroll", handleScroll);
            }
        };
        window.addEventListener("scroll", handleScroll);
        // Return a cleanup function to remove the event listener
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$be92b6f5f03c0fe9), {
        children: isLoading ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$8f67d857ad88efa0), {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                size: 150,
                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
            })
        }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: isError ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$78a558edcc066ec2), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$8b251419efc915eb), {
                                children: "Your recommendation isn\u2019t ready just yet"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$6a1e9fe31522a9e1), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                        children: "Your Mortgage Expert will provide a recommendation after they have spoken to you and have gained a better understanding of your situation and needs."
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                        children: "You\u2019ll be notified when your recommendation is ready."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$95b3756aa4faa94c), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$dcc61bba56651550), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a0045f08bd0b50f3$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$89cf17dfa018bf1f), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($80b3310d6349223d$exports)))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $c0db56e5077cf928$export$1f0d174bce7a72bb), {})
                ]
            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $26c7d44b0bcf24fd$export$ba2f44035effd9c1).Provider, {
                value: {
                    serviceType: serviceType,
                    isBtlSpecialist: isBtlSpecialist,
                    friendlyId: friendlyId
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b5d29700c7bfc058$export$4199a33c3dd48123, {
                    serviceType: serviceType,
                    applicationData: applicationData,
                    downloadEsisDocument: downloadEsisDocument,
                    acceptRecommendationOpportunity: acceptRecommendationOpportunity,
                    acceptRecommendationQuote: acceptRecommendationQuote,
                    isDownloading: isDownloading,
                    isPreview: false,
                    isAccepting: isAccepting,
                    friendlyId: friendlyId
                })
            })
        })
    });
};
var $b5d29700c7bfc058$var$IsPreviewReasonsForRecommendation = function(param) {
    var isPreview = param.isPreview, applicationData = param.applicationData, previewData = param.previewData, salesforceApplication = param.salesforceApplication;
    return isPreview ? previewData && applicationData ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ff39308d8d173bc1$export$8fde054b862aea5d), {
        debtConsolidation: previewData.debtConsolidation,
        mortgagePreferences: previewData.mortgagePreferences,
        caseComplexities: previewData.caseComplexities,
        productDetails: {
            arrangementFee: applicationData.arrangementFee,
            initialMonthlyPayment: applicationData.initialMonthlyPayment,
            reasonForRecommendation: applicationData === null || applicationData === void 0 ? void 0 : applicationData.reasonForRecommendation
        }
    }) : null : salesforceApplication && applicationData ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ff39308d8d173bc1$export$8fde054b862aea5d), {
        debtConsolidation: salesforceApplication.debtConsolidation,
        mortgagePreferences: salesforceApplication.mortgagePreferences,
        caseComplexities: salesforceApplication.caseComplexities,
        productDetails: {
            arrangementFee: applicationData.arrangementFee,
            initialMonthlyPayment: applicationData.initialMonthlyPayment,
            reasonForRecommendation: applicationData === null || applicationData === void 0 ? void 0 : applicationData.reasonForRecommendation
        }
    }) : null;
};
var $b5d29700c7bfc058$export$4199a33c3dd48123 = function(param) {
    var applicationData = param.applicationData, downloadEsisDocument = param.downloadEsisDocument, acceptRecommendationOpportunity = param.acceptRecommendationOpportunity, acceptRecommendationQuote = param.acceptRecommendationQuote, isDownloading = param.isDownloading, isAccepting = param.isAccepting, _param_isPreview = param.isPreview, isPreview = _param_isPreview === void 0 ? false : _param_isPreview, friendlyId = param.friendlyId, previewData = param.previewData;
    var _salesforceApplication_service, _additionalNotes_replace;
    var leadApplicantFirstName = applicationData.leadApplicantFirstName, secondaryApplicantFirstName = applicationData.secondaryApplicantFirstName, lenderName = applicationData.lenderName, productName = applicationData.productName, initialMonthlyPayment = applicationData.initialMonthlyPayment, initialRate = applicationData.initialRate, productType = applicationData.productType, productEndDate = applicationData.productEndDate, _applicationData_mortgageEndsBeforeProduct = applicationData.mortgageEndsBeforeProduct, mortgageEndsBeforeProduct = _applicationData_mortgageEndsBeforeProduct === void 0 ? false : _applicationData_mortgageEndsBeforeProduct, mortgageExpertName = applicationData.mortgageExpertName, mortgageExpertImage = applicationData.mortgageExpertImage, mortgageExpertPhone = applicationData.mortgageExpertPhone, mortgageExpertEmail = applicationData.mortgageExpertEmail, initialFixedPeriod = applicationData.initialFixedPeriod, arrangementFee = applicationData.arrangementFee, quoteId = applicationData.quoteId, paymentType = applicationData.paymentType, previewEsisURL = applicationData.previewEsisURL, accepted = applicationData.accepted, acceptedVia = applicationData.acceptedVia, acceptedDateTime = applicationData.acceptedDateTime, earlyRepaymentChargesApply = applicationData.earlyRepaymentChargesApply, earlyRepaymentCharge = applicationData.earlyRepaymentCharge, followOnMonthlyRate = applicationData.followOnMonthlyRate, followOnMonthlyPayment = applicationData.followOnMonthlyPayment, aprc = applicationData.aprc, _applicationData_ltv = applicationData.ltv, ltv = _applicationData_ltv === void 0 ? null : _applicationData_ltv, _applicationData_termYears = applicationData.termYears, termYears = _applicationData_termYears === void 0 ? null : _applicationData_termYears, _applicationData_totalLoanAmount = applicationData.totalLoanAmount, totalLoanAmount = _applicationData_totalLoanAmount === void 0 ? null : _applicationData_totalLoanAmount, _applicationData_currentMortgageBalance = applicationData.currentMortgageBalance, currentMortgageBalance = _applicationData_currentMortgageBalance === void 0 ? null : _applicationData_currentMortgageBalance, _applicationData_additionalBorrowingAmount = applicationData.additionalBorrowingAmount, additionalBorrowingAmount = _applicationData_additionalBorrowingAmount === void 0 ? null : _applicationData_additionalBorrowingAmount, _applicationData_propertyValue = applicationData.propertyValue, propertyValue = _applicationData_propertyValue === void 0 ? null : _applicationData_propertyValue, _applicationData_purchasePrice = applicationData.purchasePrice, purchasePrice = _applicationData_purchasePrice === void 0 ? null : _applicationData_purchasePrice, productTransfer = applicationData.productTransfer, _applicationData_addArrangementFeeToLoan = applicationData.addArrangementFeeToLoan, addArrangementFeeToLoan = _applicationData_addArrangementFeeToLoan === void 0 ? false : _applicationData_addArrangementFeeToLoan, additionalNotes = applicationData.additionalNotes, interestOnlyAmount = applicationData.interestOnlyAmount, repaymentAmount = applicationData.repaymentAmount, productCondition = applicationData.productCondition, _applicationData_extras = applicationData.extras, offset = _applicationData_extras.offset, portable = _applicationData_extras.portable, overpayments = _applicationData_extras.overpayments, freeLegals = _applicationData_extras.freeLegals, freeValuation = _applicationData_extras.freeValuation, cashback = _applicationData_extras.cashback, createdDate = applicationData.createdDate;
    var _useRecommendationContext = (0, $26c7d44b0bcf24fd$export$3321c0b02f750bcc)(), isBtlSpecialist = _useRecommendationContext.isBtlSpecialist, serviceType = _useRecommendationContext.serviceType;
    var formattedArrangementFee = (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(arrangementFee);
    var formattedMonthlyPayment = (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(initialMonthlyPayment);
    var formattedCashback = (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(cashback);
    var formattedFollowOnMonthlyPayment = (0, $fdc0ca88d14704de$export$4670d0ed237a9270)(followOnMonthlyPayment);
    var recommendationAcceptActive = (0, $0a07376615e5483e$export$64dfd82cd19c3904)(applicationData.applicationId).recommendationAcceptActive;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), showRecommendationAccept = _useState[0], setShowRecommendationAccept = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasAccepted = _useState1[0], setHasAccepted = _useState1[1];
    var _useApplicationSummaryEnhanced = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }), salesforceApplication = _useApplicationSummaryEnhanced.application;
    (0, $hAGkE.useEffect)(function() {
        setShowRecommendationAccept(!!recommendationAcceptActive && !!acceptRecommendationOpportunity && !!acceptRecommendationQuote);
    }, [
        recommendationAcceptActive,
        acceptRecommendationOpportunity,
        acceptRecommendationQuote
    ]);
    var newFieldsNumber = [
        ltv,
        termYears,
        totalLoanAmount,
        currentMortgageBalance,
        additionalBorrowingAmount,
        propertyValue
    ].filter(function(item) {
        return item;
    }).length;
    var isInRateCheckExperiment = (0, $56699a9beb99e1c1$export$2e2bcd8739ae039)(friendlyId);
    var _convertDecimalToYearsMonths = (0, $45f64f2ccb2647eb$export$d38050b0611a784b)(termYears), years = _convertDecimalToYearsMonths.years, months = _convertDecimalToYearsMonths.months;
    var borrowingAmount = addArrangementFeeToLoan ? totalLoanAmount + arrangementFee : totalLoanAmount;
    var borrowingAmountFormatted = (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(borrowingAmount);
    var _getClientConfig = (0, $cba09c37978e7e74$export$3fa1247579fc9c96)(serviceType, salesforceApplication === null || salesforceApplication === void 0 ? void 0 : (_salesforceApplication_service = salesforceApplication.service) === null || _salesforceApplication_service === void 0 ? void 0 : _salesforceApplication_service.status), recommendation = _getClientConfig.recommendation, fee = _getClientConfig.fee;
    var onAcceptRecommendation = function() {
        setHasAccepted(true);
        if (quoteId) acceptRecommendationQuote();
        else acceptRecommendationOpportunity();
    };
    var onUploadDocuments = function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)((0, $hRCmZ._)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).digiRecDocUpload
        }, $b5d29700c7bfc058$export$4cd2d28dc2e93486(friendlyId, applicationData)));
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$78a558edcc066ec2), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$8b251419efc915eb), {
                        children: [
                            "Hey ",
                            leadApplicantFirstName && leadApplicantFirstName,
                            secondaryApplicantFirstName && " & ".concat(secondaryApplicantFirstName),
                            ", here\u2019s your mortgage recommendation"
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$3c0420c1ab00970c), {
                        children: "This deal has been selected based on your needs and preferences as discussed with your Mortgage Expert at Mojo Mortgages."
                    }),
                    isBtlSpecialist && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$3c0420c1ab00970c), {
                        children: "It is a dedicated buy-to-let deal and qualifies for Mojo Specialist."
                    }),
                    !isPreview && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$3c0420c1ab00970c), {
                        style: {
                            textWrap: "nowrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                                children: "Recommendation created: "
                            }),
                            (0, $c88d7a58c9cb7299$export$d9468344d3651243)((0, $c14f24c260cd88e5$export$3664df8597731ed4)(createdDate), "dd MMMM yyyy")
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$bd55427d3650a1b0), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$dcc61bba56651550), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a0045f08bd0b50f3$exports))),
                                role: "presentation"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$89cf17dfa018bf1f), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($80b3310d6349223d$exports))),
                                role: "presentation"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$851053b8635f3e9c), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$ced6452f422b797e), {
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $12dced1c1d115545$export$55b7fc09712f8edd), {
                                            white: true,
                                            lenderName: lenderName
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$465da4d139238e2d), {
                                        children: productName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$ed85ed9fa966b254), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$9811fe609657ae14), {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$2c5e784e9d9f08d8), {
                                                children: "Initial Rate"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$d3a7678ae0ddbeb9), {
                                                children: [
                                                    initialRate,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$9811fe609657ae14), {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$2c5e784e9d9f08d8), {
                                                children: "Monthly Payment"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $16f64ef9d03de52b$export$d3a7678ae0ddbeb9), {
                                                children: [
                                                    "\xa3",
                                                    formattedMonthlyPayment
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                title: "Key deal details",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $0f894325b33bfe5f$export$aceb049150e4b47b), {
                    lenderName: lenderName,
                    formattedMonthlyPayment: formattedMonthlyPayment,
                    initialRate: initialRate,
                    aprc: aprc,
                    formattedArrangementFee: formattedArrangementFee,
                    addArrangementFeeToLoan: addArrangementFeeToLoan,
                    totalMonths: initialFixedPeriod,
                    productType: productType,
                    paymentType: paymentType,
                    interestOnlyAmount: interestOnlyAmount,
                    repaymentAmount: repaymentAmount,
                    productCondition: productCondition,
                    overpayments: overpayments,
                    earlyRepaymentChargesApply: earlyRepaymentChargesApply,
                    earlyRepaymentCharge: earlyRepaymentCharge,
                    fee: fee
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ab92a5761ee82cb5$export$591586ecb65b68fc), {
                    inRateCheckExperiment: isInRateCheckExperiment
                })
            }),
            (cashback || freeLegals || freeValuation || offset || portable) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                title: "Extras",
                smallTitle: true,
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $e46986e581cd9329$export$caa2319371f98fb5), {
                    offset: offset,
                    portable: portable,
                    cashback: cashback,
                    formattedCashback: formattedCashback,
                    freeLegals: freeLegals,
                    freeValuation: freeValuation
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                title: "When this deal ends",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $450616c2bdbe03b8$export$d25b4fe381df2a90), {
                    mortgageEndsBeforeProduct: mortgageEndsBeforeProduct,
                    productEndDate: productEndDate,
                    followOnMonthlyRate: followOnMonthlyRate,
                    formattedFollowOnMonthlyPayment: formattedFollowOnMonthlyPayment
                })
            }),
            newFieldsNumber > 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                title: "Your mortgage",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $38054749b83a550b$export$a37b17312f35d066), {
                    propertyValue: propertyValue,
                    purchasePrice: purchasePrice,
                    currentMortgageBalance: currentMortgageBalance,
                    additionalBorrowingAmount: additionalBorrowingAmount,
                    totalLoanAmount: totalLoanAmount,
                    borrowingAmountFormatted: borrowingAmountFormatted,
                    addArrangementFeeToLoan: addArrangementFeeToLoan,
                    formattedArrangementFee: formattedArrangementFee,
                    ltv: ltv,
                    termYears: termYears,
                    years: years,
                    months: months
                })
            }),
            additionalNotes && (additionalNotes === null || additionalNotes === void 0 ? void 0 : (_additionalNotes_replace = additionalNotes.replace(/\s/g, "")) === null || _additionalNotes_replace === void 0 ? void 0 : _additionalNotes_replace.length) > 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                title: "Additional information",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $16f64ef9d03de52b$export$96a93d5933d552bc), {
                    children: additionalNotes
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b5d29700c7bfc058$var$IsPreviewReasonsForRecommendation, {
                isPreview: isPreview,
                previewData: previewData,
                salesforceApplication: salesforceApplication,
                applicationData: applicationData
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $48ad76595d8deb80$export$cdc9f1a6e273987f), {
                title: "Documents",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $805ba460e9540eb1$export$8933a0fcb5352bc6), {
                    downloading: isDownloading,
                    preview: isPreview,
                    href: previewEsisURL,
                    onClick: downloadEsisDocument
                })
            }),
            showRecommendationAccept && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d292bdbd1d57ec81$export$4cba1f13ada9c24e), {
                productTransfer: productTransfer,
                recommendation: recommendation,
                lenderName: applicationData.lenderName,
                accepting: isAccepting,
                accepted: accepted,
                hasAccepted: hasAccepted,
                acceptedVia: acceptedVia,
                acceptedDateTime: acceptedDateTime,
                onAcceptRecommendation: onAcceptRecommendation,
                friendlyId: friendlyId,
                onUploadDocuments: onUploadDocuments
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $33771e3525c8c58c$export$d658961c5acadf9b), {
                image: mortgageExpertImage,
                name: mortgageExpertName,
                phone: mortgageExpertPhone,
                email: mortgageExpertEmail
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $c0db56e5077cf928$export$1f0d174bce7a72bb), {
                freeLegals: freeLegals
            })
        ]
    });
};





function $1949fda065b6ea6a$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  background: url(",
        ") no-repeat top center;\n  background-size: cover;\n  z-index: -999;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 30%;\n"
    ]);
    $1949fda065b6ea6a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1949fda065b6ea6a$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  -webkit-mask-image: url(",
        ");\n  mask-image: url(",
        ');\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  mask-size: cover;\n  -webkit-mask-size: cover;\n  background: "initial";\n  z-index: -1;\n'
    ]);
    $1949fda065b6ea6a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $1949fda065b6ea6a$var$BackgroundWave = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($1949fda065b6ea6a$var$_templateObject(), (0, (/*@__PURE__*/$parcel$interopDefault($e23e3ba289ce01db$exports))));
var $1949fda065b6ea6a$export$20f51c20c43fb0d1 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($1949fda065b6ea6a$var$BackgroundWave)($1949fda065b6ea6a$var$_templateObject1(), (0, (/*@__PURE__*/$parcel$interopDefault($e23e3ba289ce01db$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($e23e3ba289ce01db$exports))));
var $1949fda065b6ea6a$export$2e2bcd8739ae039 = $1949fda065b6ea6a$var$BackgroundWave;



var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");










var $hAGkE = parcelRequire("hAGkE");






parcelRequire("hAGkE");



function $aa1bd11b52b5008f$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  margin: "2rem 0";\n  h3 {\n    font-weight: 700;\n    display: inline-block;\n    font-size: 22px;\n    padding-bottom: 0.2em;\n    border-bottom: 4px solid blue;\n    margin-bottom: 1.4em;\n  }\n'
    ]);
    $aa1bd11b52b5008f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $aa1bd11b52b5008f$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($aa1bd11b52b5008f$var$_templateObject());
var $aa1bd11b52b5008f$export$e16f491277c68230 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                children: "Conveyancing FAQs"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d729aeb9aca595bc$export$a766cd26d0d69044), {
                data: $aa1bd11b52b5008f$var$FaqData
            })
        ]
    });
};
var $aa1bd11b52b5008f$var$FaqSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    lineHeight: "1.5em"
});
var $aa1bd11b52b5008f$var$FaqP = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac))({
    fontSize: "16px"
});
var $aa1bd11b52b5008f$var$FaqData = [
    {
        name: "What even is conveyancing, and is it necessary?",
        id: "faq-1",
        trackingLabelPrefix: "Conveyancing-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Conveyancing is the legal side of buying or selling a house (or remortgaging to another lender)."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "The main role of a conveyancer is to legally transfer the ownership of a property from one person to another. The exact nature of the work they do changes from case to case, but generally they look at:"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "Checking the Land Registry to find any boundary issues and what land and buildings are included in the sale"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "Creating contracts for the transfer of ownership and checking clauses included by other parties in the transaction"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "Guarding against potential fraud issues if the property is used as part of an illegal transaction"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "Checking the property has all the right certificates and approvals and they have been properly registered"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "Transferring money at exchange and completion"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Lenders will often change their rates based on a number of factors. Sometimes it\u2019s to attract or retain customers in a competitive market. Other times it\u2019s in response to Government policies or changes to the Bank of England base rate."
                })
            ]
        })
    },
    {
        name: "Free legals vs using Mojo",
        id: "faq-2",
        trackingLabelPrefix: "Conveyancing-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Many mortgage deals offer free legal fees \u2013 particularly if you are remortgaging."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Obviously, this may help you save money and can be a good option."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "However, many people like to believe that their conveyancer is working for them and not their lender."
                })
            ]
        })
    },
    {
        name: "Do you get commission for recommending a conveyancer",
        id: "faq-3",
        trackingLabelPrefix: "Conveyancing-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Mojo doesn't recommend any conveyancer."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "We work with a company called Smoove to bring you a selection of conveyancing quotes. It is your choice to choose any conveyancer you wish. If you do opt for a conveyance via a quote provided to you by Mojo, Smoove will pay Mojo a referral fee."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Mojo doesn't charge any broker fees and we are bringing you the conveyancing quotes in an effort to make the mortgage process easier and more transparent for you."
                })
            ]
        })
    },
    {
        name: "How long does conveyancing take?",
        id: "faq-4",
        trackingLabelPrefix: "Conveyancing-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Conveyancing ends once the new ownership of a property is registered at the Land Registry. It starts as soon as you have an official offer accepted."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$FaqP, {
                    children: [
                        "There are two major parts of conveyancing: exchange and completion \u2013 and these can occur on the same day. However, typically you'll find there are 2 weeks between the exchange and completion.",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "In reality, lots of work is done prior to these stages and the whole process usually takes 2 to 3 months depending on the size of your chain."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Always make your conveyancer aware of any completion date you have in mind at the start of the process."
                })
            ]
        })
    },
    {
        name: "How much are conveyancing fees?",
        id: "faq-5",
        trackingLabelPrefix: "Conveyancing-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($aa1bd11b52b5008f$var$FaqSection, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "There are 2 types of costs you have to pay with conveyancing:"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ol", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "The legal fees \u2013 paying the conveyancer for the work they do"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "The disbursement \u2013 these are extra costs that the conveyancer has to charge to do their job, namely 3rd parties charges for certain services like searches and registering your property. Stamp duty can also be listed as a disbursement"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Some conveyancing fees only apply to sellers and some only apply to buyers. It can be tough to understand what is good value, which is why Mojo has sourced a selection of quotes based on your specific circumstances and conveyancing needs."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                    children: "Quotes are based on a number of factors including:"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "Whether your property is leasehold or freehold"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "The price of your property"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "If you\u2019re buying a Shared Ownership, Help to Buy or Right to Buy property"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                                children: "The number of additional searches needed"
                            })
                        })
                    ]
                })
            ]
        })
    },
    {
        name: "When do you pay conveyancing fees?",
        id: "faq-6",
        trackingLabelPrefix: "Conveyancing-FAQs",
        page: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqSection, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($aa1bd11b52b5008f$var$FaqP, {
                children: "Normally, conveyancing fees are paid at the completion of the purchase or remortgaging process."
            })
        })
    }
];



var $0fdfd7b23a626fe7$var$EMPTY = {
    quotes: [],
    expired: false,
    isIndicative: false,
    expirationDate: new Date(),
    aditionalQuotes: []
};
var $0fdfd7b23a626fe7$export$23cab8baea12f053 = {
    EMPTY: $0fdfd7b23a626fe7$var$EMPTY
};
var $0fdfd7b23a626fe7$export$3fbc8d4e849d3878 = function(conveyancingBody) {
    var quoteList = conveyancingBody[0];
    var preferredQuotes = quoteList.quotes.filter(function(q) {
        return q.isPreferred;
    });
    if (preferredQuotes.length > 0) return {
        quotes: preferredQuotes,
        expired: quoteList.expired,
        isIndicative: quoteList.isIndicative,
        expirationDate: (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports)))(quoteList.expirationDate).toDate(),
        aditionalQuotes: quoteList.quotes.filter(function(q) {
            return !q.isPreferred;
        })
    };
    else return {
        quotes: quoteList.quotes.filter(function(q) {
            return q.isShortlisted;
        }),
        expired: quoteList.expired,
        isIndicative: quoteList.isIndicative,
        expirationDate: (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports)))(quoteList.expirationDate).toDate(),
        aditionalQuotes: quoteList.quotes.filter(function(q) {
            return !q.isShortlisted;
        })
    };
};



var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");


var $bOqL7 = parcelRequire("bOqL7");



var $hAGkE = parcelRequire("hAGkE");


var $cf60f6606af14482$export$9ab766ce7f4c1f3c = function(address) {
    return [
        address.line1,
        address.line2,
        address.town,
        address.postcode
    ].filter(Boolean).join(", ");
};



var $8c6ug = parcelRequire("8c6ug");




parcelRequire("hAGkE");

function $082614ddc6496ea8$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    $082614ddc6496ea8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $082614ddc6496ea8$export$7adc24e0c5b25102 = /*#__PURE__*/ function(QuoteDetailEnum) {
    QuoteDetailEnum["DISTANCE"] = "Distance";
    QuoteDetailEnum["RATING"] = "Rating";
    QuoteDetailEnum["COMMUNICATION"] = "Communication";
    QuoteDetailEnum["LEGAL_FEES"] = "Legal fee";
    QuoteDetailEnum["TOTAL"] = "Total";
    return QuoteDetailEnum;
}({});
var $082614ddc6496ea8$export$bdcdd73fe4044245 = function(param) {
    var type = param.type, data = param.data;
    var selectTooltipContent = function(type) {
        switch(type){
            case "Distance":
                return "This is how far from the property the solicitor is based. Some people prefer a solicitor close by, while for others it doesn\u2019t matter.";
            case "Rating":
                return "This rating is made up from feedback from other users. Where no rating is shown, it simply means we don't have enough feedback to give a fair rating. If a provider has less than 20 ratings, we'll show the number of ratings to help you make an informed decision.";
            case "Communication":
                return "This measures how effectively a conveyancing firm uses their online portal to provide proactive and responsive communication.";
            case "Legal fee":
                return "This is the provider's charge for doing their conveyancing work based on the information provided (excluding VAT).";
            case "Total":
                return "This is the total cost, including the legal work and disbursements (including VAT). Disbursements are costs paid by a provider on behalf of the client, such as Stamp Duty and Land Registry fees.";
            default:
                return null;
        }
    };
    var content = selectTooltipContent(type);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($082614ddc6496ea8$var$QuoteDetailContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($082614ddc6496ea8$var$QuoteDetailItem, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                        children: type
                    }),
                    content && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d6148961055ac8c8$export$2e2bcd8739ae039), {
                        content: content
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($082614ddc6496ea8$var$QuoteDetailItem, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                    children: data
                })
            })
        ]
    });
};
var $082614ddc6496ea8$var$_obj, $082614ddc6496ea8$var$_obj1;
var $082614ddc6496ea8$var$QuoteDetailContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li(($082614ddc6496ea8$var$_obj1 = {
    fontSize: "12px",
    display: "flex",
    justifyContent: "start",
    gap: "8px",
    padding: "8px 0px",
    flexDirection: "column"
}, (0, $8c6ug._)($082614ddc6496ea8$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "8px 8px",
    justifyContent: "space-between",
    flexDirection: "row"
}), (0, $8c6ug._)($082614ddc6496ea8$var$_obj1, "&:last-of-type", ($082614ddc6496ea8$var$_obj = {
    borderRadius: "4px",
    background: "#073ed910",
    padding: "8px 24px"
}, (0, $8c6ug._)($082614ddc6496ea8$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "8px"
}), (0, $8c6ug._)($082614ddc6496ea8$var$_obj, "& > div", {
    justifyContent: "center"
}), $082614ddc6496ea8$var$_obj)), (0, $8c6ug._)($082614ddc6496ea8$var$_obj1, "& > div:last-of-type", {
    fontSize: "20px",
    fontWeight: 600
}), $082614ddc6496ea8$var$_obj1));
var $082614ddc6496ea8$var$QuoteDetailItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($082614ddc6496ea8$var$_templateObject());



var $kTihC = parcelRequire("kTihC");








function $511711f200f86a9d$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n\n  border-radius: 16px;\n  background: #fff;\n  padding: 24px;\n  opacity: ",
        ";\n"
    ]);
    $511711f200f86a9d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    $511711f200f86a9d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  flex: 1;\n  font-weight: 600;\n  font-size: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    $511711f200f86a9d$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  line-height: 21.6px;\n  font-weight: 600;\n  font-size: 12px;\n  background: #fbbb5b;\n  color: #000;\n  padding: 4px 16px;\n  border-radius: 360px;\n"
    ]);
    $511711f200f86a9d$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    $511711f200f86a9d$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  color: #073ed9;\n  font-weight: 600;\n"
    ]);
    $511711f200f86a9d$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background-color: ",
        ";\n  opacity: 0.4;\n  position: fixed;\n  inset: 0px;\n  z-index: 1001;\n"
    ]);
    $511711f200f86a9d$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        " 0 0 ",
        ";\n  padding: 48px 48px 80px 24px;\n  max-width: 590px;\n  width: 100%;\n\n  position: fixed;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 1002;\n\n  overflow-y: auto;\n"
    ]);
    $511711f200f86a9d$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  gap: 1rem;\n\n  background-color: ",
        ";\n  border-radius: 8px;\n  padding: 32px 24px;\n"
    ]);
    $511711f200f86a9d$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    $511711f200f86a9d$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  font-size: 14px;\n  padding: 0 24px;\n"
    ]);
    $511711f200f86a9d$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $511711f200f86a9d$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n	body {\n		overflow-y: hidden !important;;\n	}\n"
    ]);
    $511711f200f86a9d$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
var $511711f200f86a9d$var$formatCustomerRating = function(n) {
    var rating = Math.round(n);
    return rating > 0 ? "".concat(rating, "%") : "Not yet rated";
};
var $511711f200f86a9d$export$76f4293bf493e6fc = function(param) {
    var quote = param.quote, expirationDate = param.expirationDate, isIndicative = param.isIndicative, idx = param.idx;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), detailsOpen = _useState[0], setDetailsOpen = _useState[1];
    var _quote_instructionStatus;
    var instructionStatus = (_quote_instructionStatus = quote.instructionStatus) !== null && _quote_instructionStatus !== void 0 ? _quote_instructionStatus : "NOT_INSTRUCTED";
    var showPill = quote.isPreferred && (instructionStatus === "NOT_INSTRUCTED" || instructionStatus === "QUOTED");
    var transitions = (0, $kTihC.useTransition)(detailsOpen, {
        from: {
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        }
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$QuoteWrapper, {
                disable: false,
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$QuoteHeader, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$QuoteCardTitle, {
                                children: quote.solicitor
                            }),
                            showPill && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$PreferredPill, {
                                children: "Preferred"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$QuoteContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$QuoteDetails, {
                                "aria-label": "".concat(quote.solicitor, " details"),
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $082614ddc6496ea8$export$bdcdd73fe4044245), {
                                        type: (0, $082614ddc6496ea8$export$7adc24e0c5b25102).DISTANCE,
                                        data: "".concat(Math.round(quote.distance), " miles")
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $082614ddc6496ea8$export$bdcdd73fe4044245), {
                                        type: (0, $082614ddc6496ea8$export$7adc24e0c5b25102).RATING,
                                        data: $511711f200f86a9d$var$formatCustomerRating(quote.rating)
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $082614ddc6496ea8$export$bdcdd73fe4044245), {
                                        type: (0, $082614ddc6496ea8$export$7adc24e0c5b25102).LEGAL_FEES,
                                        data: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(quote.legalFees, "\xa30.00", 2)
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $082614ddc6496ea8$export$bdcdd73fe4044245), {
                                        type: (0, $082614ddc6496ea8$export$7adc24e0c5b25102).TOTAL,
                                        data: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(quote.total, "\xa30.00", 2)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$ActionContainer, {
                                children: [
                                    $511711f200f86a9d$var$renderStatusInfo(instructionStatus),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$Link, {
                                        href: "#",
                                        onClick: function() {
                                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                                                event_label: "Conveyancing details ".concat(idx)
                                            });
                                            setDetailsOpen(true);
                                        },
                                        children: "View details"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            transitions(function(style, active) {
                return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                    children: [
                        active && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$Portal, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$PanelOverlay, {
                                    "data-state": "open",
                                    style: {
                                        pointerEvents: "auto",
                                        opacity: style.opacity.to([
                                            0,
                                            1
                                        ], [
                                            0,
                                            0.4
                                        ])
                                    },
                                    "data-aria-hidden": "true",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$Panel, {
                                    role: "dialog",
                                    id: "radix-:r0:",
                                    "aria-describedby": "mojo-:r2:",
                                    "aria-labelledby": "mojo-:r1:",
                                    "data-state": "open",
                                    tabIndex: -1,
                                    style: {
                                        pointerEvents: "auto",
                                        opacity: style.opacity.to([
                                            0,
                                            1
                                        ], [
                                            0,
                                            1
                                        ]),
                                        transform: style.opacity.to([
                                            0,
                                            1
                                        ], [
                                            100,
                                            0
                                        ]).to(function(value) {
                                            return "translateX(".concat(value, "px)");
                                        })
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("button", {
                                            style: {
                                                color: (0, $3d5d014cc8c5368b$export$164de7ab8df77ef0).colors.primary.one,
                                                display: "flex",
                                                alignItems: "center",
                                                background: "none",
                                                border: "none",
                                                outline: "none",
                                                cursor: "pointer",
                                                padding: 0
                                            },
                                            onClick: function() {
                                                setDetailsOpen(false);
                                            },
                                            "aria-label": "Close",
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $abfded16bdabae7a$export$962ee6b89e324472), {
                                                    fillDefault: (0, $3d5d014cc8c5368b$export$164de7ab8df77ef0).colors.primary.one,
                                                    width: 24,
                                                    height: 24,
                                                    type: (0, $abfded16bdabae7a$export$13ff1290a9e22e77).Cross
                                                }),
                                                "Close"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H5, {
                                            id: "mojo-:r1:",
                                            style: {
                                                marginTop: "2rem"
                                            },
                                            children: quote.solicitor
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "24px"
                                            },
                                            children: [
                                                quote.cases.length == 1 ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$dd04c3ce09220f9f, {
                                                    quoteCase: quote.cases[0],
                                                    title: isIndicative ? "Purchase Address to be Confirmed" : "Purchase of ".concat((0, $cf60f6606af14482$export$9ab766ce7f4c1f3c)(quote.cases[0].address))
                                                }) : quote.cases.length > 1 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$dd04c3ce09220f9f, {
                                                            quoteCase: quote.cases[0],
                                                            title: "Sale of ".concat((0, $cf60f6606af14482$export$9ab766ce7f4c1f3c)(quote.cases[0].address))
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$dd04c3ce09220f9f, {
                                                            quoteCase: quote.cases[1],
                                                            title: isIndicative ? "Purchase Address to be Confirmed" : "Purchase of ".concat((0, $cf60f6606af14482$export$9ab766ce7f4c1f3c)(quote.cases[1].address))
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$QuoteTotalPanel, {
                                                            total: quote.total
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$RatingPanel, {
                                                    label: "Customer rating",
                                                    value: $511711f200f86a9d$var$formatCustomerRating(quote.rating)
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$Disclaimers, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                            children: [
                                                                "This quote is valid until ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports)))(expirationDate).format("MMMM D, YYYY")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$fc21a04a622ec81e, {
                                                            title: "Notes",
                                                            lines: quote.notes
                                                        }),
                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$fc21a04a622ec81e, {
                                                            title: "Terms & Conditions",
                                                            lines: quote.smallPrint
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        detailsOpen && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$HideBodyOverflow, {})
                    ]
                });
            })
        ]
    });
};
// this portal is required to render the modal outside of the current DOM flow
// or it will clash with z-index of the main body content
var $511711f200f86a9d$var$Portal = function(param) {
    var children = param.children, _param_className = param.className, className = _param_className === void 0 ? "root-portal" : _param_className, _param_el = param.el, el = _param_el === void 0 ? "div" : _param_el;
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState(function() {
        // This will be executed only on the initial render
        // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
        return document.createElement(el);
    }), 1), container = _React_useState[0];
    (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect(function() {
        container.classList.add(className);
        document.body.appendChild(container);
        return function() {
            document.body.removeChild(container);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0048b1b41b30e47d$exports))).createPortal(children, container);
};
var $511711f200f86a9d$export$4dc9f58ad9a1a000 = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    alignItems: "baseline",
    gap: 8
});
var $511711f200f86a9d$var$QuoteWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject(), function(param) {
    var disable = param.disable;
    return disable ? "0.7" : "1";
});
var $511711f200f86a9d$var$QuoteHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject1());
var $511711f200f86a9d$var$QuoteCardTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject2());
var $511711f200f86a9d$var$PreferredPill = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject3());
var $511711f200f86a9d$var$SelectedContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var _param_colour = param.colour, colour = _param_colour === void 0 ? "green" : _param_colour;
    var _colorMap_colour, _colorMap_colour1;
    var colorMap = {
        red: {
            background: "#FCF1EE",
            text: "#A72538"
        },
        green: {
            background: "#EDF5F3",
            text: "#038352"
        }
    };
    return {
        display: "flex",
        padding: "1rem",
        borderRadius: "8px",
        gap: "8px",
        marginBottom: "1rem",
        backgroundColor: ((_colorMap_colour = colorMap[colour]) === null || _colorMap_colour === void 0 ? void 0 : _colorMap_colour.background) || colorMap.green.background,
        color: ((_colorMap_colour1 = colorMap[colour]) === null || _colorMap_colour1 === void 0 ? void 0 : _colorMap_colour1.text) || colorMap.green.text,
        fontWeight: 600
    };
});
var $511711f200f86a9d$var$QuoteContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    gap: "16px"
}, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column"
}));
var $511711f200f86a9d$var$QuoteDetails = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul((0, $8c6ug._)({
    flex: "1",
    display: "flex",
    borderRadius: "8px",
    padding: "12px 12px 12px 24px",
    background: "#f3f5fc",
    justifyContent: "space-between",
    margin: 0
}, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "12px",
    flexDirection: "column"
}));
var $511711f200f86a9d$var$ActionContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject4());
var $511711f200f86a9d$var$Link = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($511711f200f86a9d$var$_templateObject5());
var $511711f200f86a9d$export$dd04c3ce09220f9f = function(param) {
    var quoteCase = param.quoteCase, title = param.title;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$PanelContainers, {
        children: [
            title && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                weight: 600,
                size: "large",
                children: title
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                weight: 600,
                children: "Fee breakdown"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px"
                },
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$451cc27eff6400bb, {
                        title: "Legal work",
                        items: [
                            {
                                displayName: "Core conveyancing",
                                amount: quoteCase.coreAmount
                            }
                        ].concat((0, $bOqL7._)(quoteCase.legalSupplements)),
                        total: quoteCase.legalWorkSubTotal
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$451cc27eff6400bb, {
                        title: "Other fees",
                        items: quoteCase.otherSupplements,
                        total: quoteCase.otherFeesTotal
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$451cc27eff6400bb, {
                        title: "VAT",
                        items: [
                            {
                                displayName: "Applied at 20%",
                                amount: quoteCase.vatTotal
                            }
                        ],
                        total: quoteCase.vatTotal
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$export$451cc27eff6400bb, {
                        title: "Disbursements (No VAT/VAT inc.)",
                        items: quoteCase.disbursements,
                        total: quoteCase.disbursementsTotal
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$SpacedContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                size: "large",
                                weight: 700,
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                size: "large",
                                weight: 700,
                                children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(quoteCase.grandTotal, "\xa30.00", 2)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $511711f200f86a9d$export$451cc27eff6400bb = function(param) {
    var title = param.title, items = param.items, total = param.total;
    return items.length > 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: "16px"
        },
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px"
                },
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                        size: "small",
                        weight: 700,
                        children: title
                    }),
                    items.map(function(item, i) {
                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$SpacedContainer, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                    size: "small",
                                    children: item.displayName || "Other"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                    size: "small",
                                    children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(item.amount, "\xa30.00", 2)
                                })
                            ]
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$SpacedContainer, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                        size: "small",
                        weight: 600,
                        children: "Sub Total"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                        size: "small",
                        weight: 600,
                        children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(total, "\xa30.00", 2)
                    })
                ]
            })
        ]
    });
};
var $511711f200f86a9d$export$fc21a04a622ec81e = function(param) {
    var title = param.title, lines = param.lines;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                size: "large",
                weight: 600,
                children: title
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("ol", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px",
                    marginTop: "0",
                    marginBottom: "0"
                },
                children: lines.map(function(n, i) {
                    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: n.replace(/^\d+\s*[-\\.)]?\s+/i, "")
                                }
                            })
                        })
                    }, i);
                })
            })
        ]
    });
};
var $511711f200f86a9d$var$QuoteTotalPanel = function(param) {
    var total = param.total;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$PanelContainers, {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                size: "large",
                weight: 600,
                style: {
                    flex: "1 1 0px"
                },
                children: "Sale & purchase conveyancing total"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                weight: 600,
                size: "large",
                style: {
                    textAlign: "right",
                    alignSelf: "flex-end",
                    flex: "1 1 0px",
                    whiteSpace: "nowrap"
                },
                children: (0, $fdc0ca88d14704de$export$2bd90eee99af25a7)(total, "\xa30.00", 2)
            })
        ]
    });
};
var $511711f200f86a9d$var$RatingPanel = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$PanelContainers, {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                weight: 600,
                children: label
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                size: "small",
                style: {
                    whiteSpace: "nowrap"
                },
                children: value
            })
        ]
    });
};
var $511711f200f86a9d$var$PanelOverlay = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $29d7fd5e78a14c9b$export$407448d2b89b1813).div)($511711f200f86a9d$var$_templateObject6(), function(props) {
    return props.theme.primaryThree;
});
var $511711f200f86a9d$var$Panel = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $29d7fd5e78a14c9b$export$407448d2b89b1813).div)($511711f200f86a9d$var$_templateObject7(), function(props) {
    return props.theme.primaryFour;
}, function(props) {
    return props.theme.radius.large;
}, function(props) {
    return props.theme.radius.large;
});
var $511711f200f86a9d$var$PanelContainers = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject8(), function(props) {
    return (0, $6650ffc144de4082$export$fc176dd65a27d98b)(0.95, props.theme.colors.primary.one);
});
var $511711f200f86a9d$var$SpacedContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject9());
var $511711f200f86a9d$var$Disclaimers = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($511711f200f86a9d$var$_templateObject10());
var $511711f200f86a9d$var$HideBodyOverflow = (0, $62d655c53090e8a3$export$f0f03736edb61697)($511711f200f86a9d$var$_templateObject11());
var $511711f200f86a9d$var$renderStatusInfo = function(status) {
    switch(status){
        case "APPROVED":
        case "INSTRUCTED":
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$SelectedContainer, {
                colour: "green",
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$GreenTick, {}),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: "Selected"
                    })
                ]
            });
        case "INSTRUCTION_CANCELLED":
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($511711f200f86a9d$var$SelectedContainer, {
                colour: "red",
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($511711f200f86a9d$var$RedCross, {}),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("span", {
                        children: "Cancelled"
                    })
                ]
            });
        default:
            return null;
    }
};
var $511711f200f86a9d$var$GreenTick = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2256 4.18877L6.01613 14.9538L0.774414 9.42686L2.22558 8.0506L6.01613 12.0474L14.7744 2.8125L16.2256 4.18877Z",
            fill: "#038352"
        })
    });
};
var $511711f200f86a9d$var$RedCross = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.5 9.91429L13.2929 14.7072L14.7071 13.293L9.91421 8.50008L14.7071 3.70718L13.2929 2.29297L8.5 7.08586L3.70711 2.29297L2.29289 3.70718L7.08579 8.50008L2.29289 13.293L3.70711 14.7072L8.5 9.91429Z",
            fill: "#A72538"
        })
    });
};





function $ca40c11c699e879b$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n\n  @media screen and ",
        " {\n    max-width: 70%;\n  }\n"
    ]);
    $ca40c11c699e879b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n  background: #1a3dd1;\n  color: #fff;\n  text-align: center;\n  box-shadow: inset 0 -6px 0px #052ea3;\n\n  @media screen and ",
        " {\n    width: auto;\n  }\n"
    ]);
    $ca40c11c699e879b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  @media screen and ",
        " {\n    width: 34em;\n  }\n"
    ]);
    $ca40c11c699e879b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & > p {\n    margin: 0;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(59, 66, 88, 1);\n    line-height: 24px;\n  }\n"
    ]);
    $ca40c11c699e879b$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 39px;\n  font-weight: 550;\n  min-width: 60%;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 18px;\n  font-weight: 600;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 32px;\n  margin-bottom: 24px;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #fcc778;\n  padding: 24px;\n  border-radius: 8px;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 16px;\n  gap: 8px;\n  border-radius: 16px;\n  border: 1px;\n  color: #6d1b22;\n  background: #fcf1ee;\n  border: 1px solid #d0070d;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 2em;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: 16px;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 2rem 0 2rem 0;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0;\n  line-height: 1.5;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $ca40c11c699e879b$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 72px;\n"
    ]);
    $ca40c11c699e879b$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
var $ca40c11c699e879b$export$5ecf1162e870f85f = function() {
    var friendlyId = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().friendlyId;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)((0, $0fdfd7b23a626fe7$export$23cab8baea12f053).EMPTY), 2), quoteList = _useState[0], setQuoteList = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isError = _useState1[0], setIsError = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), sessionLoading = _useSession.isLoading;
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/application/conveyancing");
    (0, $hAGkE.useEffect)(function() {
        if (friendlyId && !sessionLoading) (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/conveyancing/quote-list/".concat(friendlyId), {
            withCredentials: true
        }).then(function(param) {
            var data = param.data;
            setQuoteList((0, $0fdfd7b23a626fe7$export$3fbc8d4e849d3878)(data));
            setIsError(false);
            setIsLoading(false);
        })["catch"](function(error) {
            console.error("Error:", error);
            setIsError(true);
            setIsLoading(false);
        });
    }, [
        friendlyId,
        sessionLoading
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (quoteList.quotes.length == 0) (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "No quotes returned"
        });
    }, [
        quoteList
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (quoteList.expired) (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Quotes expired"
        });
    }, [
        quoteList.expired
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (quoteList.isIndicative) (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Quotes indicative"
        });
    }, [
        quoteList.isIndicative
    ]);
    // A list of quotes may have one approved or instructed and many cancelled
    // so we want to decide which to show in order of importance
    var instructionStatusPrecedence = {
        INSTRUCTED: 3,
        APPROVED: 2,
        INSTRUCTION_CANCELLED: 1
    };
    var getInstructionStatus = function() {
        var instructedQuotes = quoteList.quotes.filter(function(quote) {
            return quote.instructionStatus === "INSTRUCTED" || quote.instructionStatus === "APPROVED" || quote.instructionStatus === "INSTRUCTION_CANCELLED";
        });
        if (instructedQuotes.length === 0) return null;
        instructedQuotes.sort(function(a, b) {
            return instructionStatusPrecedence[b.instructionStatus] - instructionStatusPrecedence[a.instructionStatus];
        });
        return instructedQuotes[0].instructionStatus;
    };
    var instructionStatus = getInstructionStatus();
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1ca2cdaa0912b6ea$export$db98531fba779596), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$ContentContainer, {
            children: isLoading ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$LoaderContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                    size: 150,
                    theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
                })
            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$HeaderContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$TitleContainer, {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$Header, {
                                    children: "Conveyancing"
                                })
                            }),
                            isError || quoteList.quotes.length == 0 ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$TextContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$SubHeader, {
                                        children: "If you\u2019re buying a property or remortgaging with a new lender, then we can help you find solicitors for conveyancing."
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                        children: "Get in touch with your Mortgage Expert, who will be able to provide you with a number of options from our panel of solicitors."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$TextContainer, {
                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                    children: "Easily compare conveyancing quotes, track your case progress, and get real-time updates - all in one place. Whether you\u2019re buying, selling, or remortgaging, we\u2019ll keep you informed every step of the way."
                                })
                            }),
                            instructionStatus && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$StatusContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$SubHeader, {
                                        children: "Current instruction"
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$StatusRow, {
                                        children: $ca40c11c699e879b$var$renderInstructionStatus(instructionStatus)
                                    })
                                ]
                            })
                        ]
                    }),
                    quoteList.quotes.length != 0 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$QuotesContainer, {
                                children: [
                                    quoteList.expired && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$ExpiredBanner, {
                                        children: "These conveyancing quotes have expired. If you would like an up to date list of quotes, please contact your Mortgage Expert"
                                    }),
                                    quoteList.isIndicative && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$IndicativeBanner, {
                                        children: [
                                            "As you do not have an offer accepted on a property, we generated these quotes using a generic post code in the country you are buying in. As such,",
                                            " ",
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                                                children: "prices quoted here are indicative"
                                            }),
                                            ", and may change based on the property you eventually purchase.",
                                            " "
                                        ]
                                    }),
                                    quoteList.quotes.map(function(quote, idx) {
                                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $511711f200f86a9d$export$76f4293bf493e6fc), {
                                            quote: quote,
                                            expirationDate: quoteList.expirationDate,
                                            isIndicative: quoteList.isIndicative,
                                            idx: idx
                                        }, idx);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$export$87d98f83bd85698, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $aa1bd11b52b5008f$export$e16f491277c68230), {}),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $a159116cb4326250$export$36ba2f559d49a8f6), {
                        notificationComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$RateSelectedToast, {})
                    })
                ]
            })
        })
    });
};
var $ca40c11c699e879b$var$ToastText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $ca40c11c699e879b$var$ToastButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1))($ca40c11c699e879b$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $ca40c11c699e879b$var$RateSelectedToast = function(param) {
    var id = param.id, message = param.message;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($hAGkE.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$ToastText, {
                children: message
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$ToastButton, {
                onClick: function() {
                    return (0, $fdd55589ea724e5e$export$2e2bcd8739ae039).dismiss(id);
                },
                width: "auto",
                type: 2,
                text: "Got it",
                style: {
                    alignSelf: "end"
                }
            })
        ]
    });
};
var $ca40c11c699e879b$var$ContentContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $1ca2cdaa0912b6ea$export$9d2b4227a95687cc))((0, $8c6ug._)({}, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gridColumnStart: 2,
    gridColumnEnd: "span 9"
}));
var $ca40c11c699e879b$var$TextContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    maxWidth: "584px"
});
var $ca40c11c699e879b$var$LoaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject2(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $ca40c11c699e879b$var$HeaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject3());
var $ca40c11c699e879b$var$Header = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($ca40c11c699e879b$var$_templateObject4());
var $ca40c11c699e879b$var$TitleContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    justifyContent: "space-between"
}, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column",
    justifyContent: "start"
}));
var $ca40c11c699e879b$var$SubHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($ca40c11c699e879b$var$_templateObject5());
var $ca40c11c699e879b$var$QuotesContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject6());
var $ca40c11c699e879b$var$IndicativeBanner = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject7());
var $ca40c11c699e879b$var$ExpiredBanner = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject8());
var $ca40c11c699e879b$var$StatusContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($ca40c11c699e879b$var$TextContainer)($ca40c11c699e879b$var$_templateObject9());
var $ca40c11c699e879b$var$StatusRow = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject10());
var $ca40c11c699e879b$var$StatusText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($ca40c11c699e879b$var$_templateObject11());
var $ca40c11c699e879b$export$87d98f83bd85698 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$DisclaimerContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$Disclaimer, {
                size: "caption",
                children: "Mojo do not offer advice on which conveyancer to use, we act as an introducer to Smoove Conveyancing Services only."
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$Disclaimer, {
                size: "caption",
                children: "Smoove are responsible for vetting and approving their panel of qualified and licensed solicitors, please review the quotes carefully before committing to a preferred option. All enquiries post-instruction will need to be taken up with the chosen conveyancer directly"
            })
        ]
    });
};
var $ca40c11c699e879b$var$DisclaimerContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca40c11c699e879b$var$_templateObject12());
var $ca40c11c699e879b$var$Disclaimer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac))({
    textAlign: "left"
});
var $ca40c11c699e879b$var$renderInstructionStatus = function(status) {
    switch(status){
        case "APPROVED":
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$IconContainer, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$TickIcon, {})
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$StatusText, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: "Confirmed:"
                            }),
                            " You\u2019re happy for us to proceed with this solicitor"
                        ]
                    })
                ]
            });
        case "INSTRUCTION_CANCELLED":
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$IconContainer, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$CrossIcon, {})
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$StatusText, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: "Instruction cancelled:"
                            }),
                            " Conveyancing with this solicitor has been cancelled and won\u2019t be instructed"
                        ]
                    })
                ]
            });
        case "INSTRUCTED":
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$IconContainer, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ca40c11c699e879b$var$TickIcon, {})
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca40c11c699e879b$var$StatusText, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                children: "Instructed:"
                            }),
                            " Now that you\u2019re case has been submitted, we have sent instruction to the solicitors to begin conveyancing"
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};
var $ca40c11c699e879b$var$IconContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    minWidth: "32px",
    minHeight: "32px",
    width: "32px",
    height: "32px",
    flexShrink: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $ca40c11c699e879b$var$TickIcon = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#038352"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7256 11.6888L13.5161 22.4538L8.27441 16.9269L9.72558 15.5506L13.5161 19.5474L22.2744 10.3125L23.7256 11.6888Z",
                fill: "#EDF5F3"
            })
        ]
    });
};
var $ca40c11c699e879b$var$CrossIcon = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#D0070D"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 17.4143L20.7929 22.2072L22.2071 20.793L17.4142 16.0001L22.2071 11.2072L20.7929 9.79297L16 14.5859L11.2071 9.79297L9.79291 11.2072L14.5858 16.0001L9.79291 20.793L11.2071 22.2072L16 17.4143Z",
                fill: "#FCF1EE"
            })
        ]
    });
};








parcelRequire("hAGkE");





var $7b909f6f76af9853$export$a3a928c5b89f97ea = function() {
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/application/status/payment-confirmed");
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $77da52963b5ae877$export$f2f1d4539d04d991), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1c3a765b38e25bd5$export$efe00b6aae04e54d), {
                        category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
                        label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).bookAnAppointment,
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$f99233281efd08a0), {
                            children: "Payment confirmed: We're now submitting your application"
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                        children: "Thank you for completing the payment for your Mojo Specialist service. Your dedicated specialist team will now conduct a final review and submit your application."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: "What Happens Next?"
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$5f1af8db9871e1d6), {
                        children: "Your Case Manager will be in touch to confirm as soon as the submission is complete. They\u2019ll be your single point of contact from here and will keep you updated every step of the way."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $77da52963b5ae877$export$fa8dc7a2d61a4615), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($32b9b3f19ab38e09$exports))),
                alt: "Paperwork"
            })
        ]
    });
};


var $bf05a0c7dfc52c38$var$Page = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    position: "relative",
    flexDirection: "column"
}, "@media screen and ".concat((0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl), {
    flexDirection: "row"
}));
var $bf05a0c7dfc52c38$var$MobileNav = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    height: "56px",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 16px"
}, "@media screen and ".concat((0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl), {
    display: "none"
}));
var $bf05a0c7dfc52c38$var$Hamburger = function(param) {
    var isOpen = param.isOpen, onClick = param.onClick;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
        onClick: onClick,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
            src: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($f0318dc2ecd419e3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($5d550af05e29e2a1$exports))),
            alt: "nav icon"
        })
    });
};
var $bf05a0c7dfc52c38$export$c685627fd4eca96 = /*#__PURE__*/ function(StatusPageNavSelected) {
    StatusPageNavSelected["Status"] = "Status";
    StatusPageNavSelected["Recommendation"] = "Recommendation";
    StatusPageNavSelected["RateChecker"] = "Rate Checker";
    StatusPageNavSelected["Conveyancing"] = "Conveyancing";
    StatusPageNavSelected["Documents"] = "Documents";
    return StatusPageNavSelected;
}({});
var $bf05a0c7dfc52c38$var$CenteredLoader = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
            size: 100,
            theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
        })
    });
};
var $bf05a0c7dfc52c38$export$ea64be20ec62f334 = function(param) {
    var friendlyId = param.friendlyId, opportunityStage = param.opportunityStage, _param_address = param.address, address = _param_address === void 0 ? "" : _param_address, _param_selected = param.selected, selected = _param_selected === void 0 ? "Status" : _param_selected, _param_servicePaid = param.servicePaid, servicePaid = _param_servicePaid === void 0 ? false : _param_servicePaid;
    var _useApplicationSummaryEnhanced = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }), salesforceApplication = _useApplicationSummaryEnhanced.application;
    var refreshApplications = (0, $1c92825e7588cbce$export$b17f9dfb16ad8a1d)().refreshApplications;
    var _useApplicationFriendlyId = (0, $8c553d9068484641$export$cba093767fbd948f)(friendlyId), dynamoApplication = _useApplicationFriendlyId.application;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var isOptedIntoRateCheckPromise = (0, $56699a9beb99e1c1$export$2e2bcd8739ae039)(friendlyId);
    var _getConfigFromApplication = (0, $cba09c37978e7e74$export$1f1126ea06a9f8cd)(salesforceApplication), logo = _getConfigFromApplication.logo, serviceType = _getConfigFromApplication.serviceType;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($bf05a0c7dfc52c38$var$Page, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1949fda065b6ea6a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($bf05a0c7dfc52c38$var$MobileNav, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                        src: logo,
                        alt: "mojo logo",
                        style: {
                            height: "28px"
                        }
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($bf05a0c7dfc52c38$var$Hamburger, {
                        isOpen: isOpen,
                        onClick: function() {
                            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).navigation,
                                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                                event_label: isOpen ? "Close" : "Open"
                            });
                            setIsOpen(!isOpen);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8b5fa07cb739b107$export$1ba59dacbcbf90fe), {
                friendlyId: friendlyId,
                address: address,
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                selected: selected,
                mojoLogo: logo
            }),
            servicePaid ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $7b909f6f76af9853$export$a3a928c5b89f97ea), {}) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                children: [
                    selected === "Status" && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $2b2cb2b780ecb0b2$export$96e9906d6d93a972), {
                        serviceType: serviceType,
                        friendlyId: friendlyId,
                        opportunityStage: opportunityStage,
                        salesforceApplication: salesforceApplication,
                        application: dynamoApplication,
                        refreshApplications: refreshApplications
                    }),
                    selected === "Recommendation" && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b5d29700c7bfc058$export$406db2478840415b), {
                        serviceType: serviceType,
                        applicationId: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.applicationId,
                        friendlyId: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.friendlyId
                    }),
                    selected === "Rate Checker" && (isOptedIntoRateCheckPromise === null ? // null means it hasn't been fetched yet
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($bf05a0c7dfc52c38$var$CenteredLoader, {}) : isOptedIntoRateCheckPromise ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d0fda5c3a8cdefd$export$d078e30e1a0a6124), {
                        applicationId: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.applicationId
                    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $2a02f2af2c31510c$export$d229165431aa1069), {})),
                    selected === "Conveyancing" && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ca40c11c699e879b$export$5ecf1162e870f85f), {}),
                    selected === "Documents" && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3e16eba31040bbf0$export$22c59631e6c46e5a), {
                        friendlyId: friendlyId,
                        application: dynamoApplication
                    })
                ]
            })
        ]
    });
};




parcelRequire("hAGkE");


var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");


var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");





var $hAGkE = parcelRequire("hAGkE");





var $1b3aef86c81c2996$export$c5b2cd2068ed0aed = function(applicationId) {
    return $1b3aef86c81c2996$var$fetcher("https://my-mojo-api.mojomortgages.com/experience/".concat(applicationId));
};
var $1b3aef86c81c2996$export$ce0523ab8bb2b8e9 = function(friendlyId) {
    var /**
 * Whether the cached result should be invalidated and refetched
 * @default false
 */ invalidateRedis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, onSuccess = arguments.length > 2 ? arguments[2] : void 0;
    var _useApplicationFriendlyId = (0, $8c553d9068484641$export$cba093767fbd948f)(friendlyId), application = _useApplicationFriendlyId.application, applicationHasLoaded = _useApplicationFriendlyId.hasLoaded;
    var _useSWR = (0, $69b91e38b962ffe6$export$2e2bcd8739ae039)(function() {
        return applicationHasLoaded && application.applicationId ? "https://my-mojo-api.mojomortgages.com/experience/".concat(application.applicationId, "?isUpdate=").concat(invalidateRedis, "&withSwr=true") : null;
    }, $1b3aef86c81c2996$var$fetcher, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = _useSWR.data, error = _useSWR.error, isLoading = _useSWR.isLoading, mutate = _useSWR.mutate;
    /**
   * Invalidate cache and refetch experience
   */ var refresh = function() {
        mutate();
    };
    (0, $hAGkE.useEffect)(function() {
        var experienceTLS = data;
        if (experienceTLS) {
            var _experienceTLS_eligibility;
            (0, $175ce91c71cebc6b$export$1417196ef70025f8)({
                eligibility_tier: "".concat((_experienceTLS_eligibility = experienceTLS.eligibility) === null || _experienceTLS_eligibility === void 0 ? void 0 : _experienceTLS_eligibility.tier),
                traffic_light_definition: "".concat(experienceTLS.rule.color, " ").concat(experienceTLS.rule.tier)
            });
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).experienceTLS,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: "".concat(experienceTLS.rule.color, "-").concat(experienceTLS.rule.tier)
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    }, [
        data
    ]);
    return {
        experienceTLS: data,
        hasFetchedExperienceTLS: !isLoading && applicationHasLoaded,
        // only false if both queries aren't loading
        isLoading: isLoading || !applicationHasLoaded,
        isError: error,
        refresh: refresh
    };
};
var $1b3aef86c81c2996$var$fetcher = function(url) {
    return (0, $d48d778937567d64$export$155ec85c4e3b5e85).get(url, {
        withCredentials: true
    }).then(function(res) {
        var experienceTLS = res.data;
        return experienceTLS;
    });
};


var $831af630f644aede$export$2b06c2bd596f1e13 = /*#__PURE__*/ function(ResultPage) {
    ResultPage["AdviceAppt"] = "ADVICE_APPT";
    ResultPage["AdviceCallback"] = "ADVICE_CALLBACK";
    ResultPage["DefaultApprovedPostOffer"] = "DEFAULT_APPROVED_POSTOFFER";
    ResultPage["CSEAppt"] = "CSE_APPT";
    ResultPage["CSEFutureAppt"] = "CSE_FUTURE_APPT";
    ResultPage["ERC"] = "ERC";
    ResultPage["Rates"] = "RATES";
    ResultPage["Together"] = "TOGETHER";
    ResultPage["BadCredit"] = "BAD_CREDIT";
    ResultPage["Coach"] = "COACH";
    ResultPage["Unaffordable"] = "UNAFFORDABLE";
    ResultPage["Nurture"] = "NURTURE";
    ResultPage["TableNoClickout"] = "TABLE_NO_CLICKOUT";
    ResultPage["TableBrokerOnly"] = "TABLE_BROKER_ONLY";
    return ResultPage;
}({});
var $831af630f644aede$export$e031b897fa92493d = /*#__PURE__*/ function(BooleanEnum) {
    BooleanEnum["true"] = "TRUE";
    BooleanEnum["false"] = "FALSE";
    return BooleanEnum;
}({});




function $5faa8c175a7d9f81$export$2e2bcd8739ae039(obj) {
    var keyValues = [];
    for(var key in obj)if (obj[key] !== null) keyValues.push("".concat(key, "=").concat(obj[key]));
    return "?".concat(keyValues.join("&"));
}


function $19c24bb3e8462f65$export$61d6c01afd38b7d1(fullApplication) {
    var hideClickouts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var _fullApplication_basicPropertyDetails, _fullApplication_borrowingDetails, _fullApplication_borrowingDetails1, _fullApplication_borrowingDetails2, _fullApplication_borrowingDetails3, _ref, _ref_rule, tlColor, tlTier, resultPage, isAdviceRatesExperiment, queryParams;
        function ShouldHideLenderClickouts() {
            return isAdviceRatesExperiment;
        }
        function ShouldHideAllClickouts(hideClickouts) {
            return resultPage === (0, $831af630f644aede$export$2b06c2bd596f1e13).TableNoClickout || hideClickouts;
        }
        function BrandPascalCase() {
            var urlPartner = (0, $81ead65346fb6783$export$3f4e072470a85305)();
            switch(urlPartner){
                case "mojo":
                    return "Mojo";
                case "uswitch":
                    return "Uswitch";
                case "money":
                    return "Money";
                case "confused":
                    return "Confused";
                default:
                    return "Mojo";
            }
        }
        function MortgageAmount() {
            var _fullApplication_currentMortgage;
            var _fullApplication_currentMortgage_mortgageBalance;
            if (fullApplication.applicationReason === "Remortgage") return (_fullApplication_currentMortgage_mortgageBalance = (_fullApplication_currentMortgage = fullApplication.currentMortgage) === null || _fullApplication_currentMortgage === void 0 ? void 0 : _fullApplication_currentMortgage.mortgageBalance) !== null && _fullApplication_currentMortgage_mortgageBalance !== void 0 ? _fullApplication_currentMortgage_mortgageBalance : 0;
            else return 0;
        }
        function initialPeriod() {
            var _fullApplication_preferences;
            var value = (_fullApplication_preferences = fullApplication.preferences) === null || _fullApplication_preferences === void 0 ? void 0 : _fullApplication_preferences.initialPeriodPreference;
            var productTermPeriodFromMonths = 24;
            var productTermPeriodToMonths = 29;
            switch(value){
                case "two_years":
                    productTermPeriodFromMonths = 24;
                    productTermPeriodToMonths = 29;
                    break;
                case "three_years":
                    productTermPeriodFromMonths = 36;
                    productTermPeriodToMonths = 39;
                    break;
                case "five_years":
                case "ten_years":
                    productTermPeriodFromMonths = 60;
                    productTermPeriodToMonths = 69;
                    break;
            }
            return {
                productTermPeriodFromMonths: productTermPeriodFromMonths,
                productTermPeriodToMonths: productTermPeriodToMonths
            };
        }
        function mortgageType() {
            var _fullApplication_basicPropertyDetails;
            var value = (_fullApplication_basicPropertyDetails = fullApplication.basicPropertyDetails) === null || _fullApplication_basicPropertyDetails === void 0 ? void 0 : _fullApplication_basicPropertyDetails.occupancy;
            switch(value){
                case "Rent_it_out":
                    return "Buy_To_Let";
                case "Live_in_property":
                    return "Standard";
                default:
                    return "Standard";
            }
        }
        function rateType() {
            var _fullApplication_preferences;
            var value = (_fullApplication_preferences = fullApplication.preferences) === null || _fullApplication_preferences === void 0 ? void 0 : _fullApplication_preferences.mortgageTypePreference;
            switch(value){
                case "tracker":
                    return "tracker";
                case "fixed_rate":
                    return "fixed";
                default:
                    return "fixed";
            }
        }
        function mojoUswitchRepaymentType() {
            var _fullApplication_preferences;
            var value = (_fullApplication_preferences = fullApplication.preferences) === null || _fullApplication_preferences === void 0 ? void 0 : _fullApplication_preferences.repaymentMethodPreference;
            switch(value){
                case "interest_only":
                    return "interestOnly";
                default:
                    return "repayment";
            }
        }
        function mojoUswitchTimeframeMortgage() {
            var _fullApplication_remortgageDetails;
            var now = (0, $45f64f2ccb2647eb$export$10a49f7c1caf843e)(new Date().toISOString());
            var endDate = (_fullApplication_remortgageDetails = fullApplication.remortgageDetails) === null || _fullApplication_remortgageDetails === void 0 ? void 0 : _fullApplication_remortgageDetails.initialPeriodEndDate;
            var months = (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(now, endDate, "month");
            if (!endDate) return null;
            else {
                if (months >= 7) return 6;
                else if (months >= 4) return 2;
                return 0;
            }
        }
        function mojoUswitchCurrentProvider() {
            var _fullApplication_remortgageDetails;
            var currentLender = (_fullApplication_remortgageDetails = fullApplication.remortgageDetails) === null || _fullApplication_remortgageDetails === void 0 ? void 0 : _fullApplication_remortgageDetails.existingLender;
            switch(currentLender){
                case "Barclays Bank":
                    return "barclays";
                case "Halifax":
                    return "halifax";
                case "HSBC":
                    return "hsbc";
                case "Lloyds Bank":
                    return "lloydsBank";
                case "Nationwide BS":
                    return "nationwide";
                case "Leeds BS":
                    return "leedsbuildingsociety";
                case "Santander UK Plc":
                    return "santander";
                case "NatWest":
                    return "natwest";
                default:
                    return "other";
            }
        }
        function mojoLocation() {
            var _fullApplication_completePropertyDetails_propertyAddress, _fullApplication_completePropertyDetails, _fullApplication_basicPropertyDetails;
            var postcode = (_fullApplication_completePropertyDetails = fullApplication.completePropertyDetails) === null || _fullApplication_completePropertyDetails === void 0 ? void 0 : (_fullApplication_completePropertyDetails_propertyAddress = _fullApplication_completePropertyDetails.propertyAddress) === null || _fullApplication_completePropertyDetails_propertyAddress === void 0 ? void 0 : _fullApplication_completePropertyDetails_propertyAddress.postcode;
            var location = (_fullApplication_basicPropertyDetails = fullApplication.basicPropertyDetails) === null || _fullApplication_basicPropertyDetails === void 0 ? void 0 : _fullApplication_basicPropertyDetails.location;
            if (location !== (0, $6e6e522132305404$export$18a2be9195644f38).unknown) return location;
            if (postcode && postcode.substring(0, 2) === "BT") return (0, $6e6e522132305404$export$18a2be9195644f38).Northern_Ireland;
            else return (0, $6e6e522132305404$export$18a2be9195644f38).England;
        }
        function mojoUswitchRemortgageReason() {
            var remortgageReason = fullApplication === null || fullApplication === void 0 ? void 0 : fullApplication.remortgageReason;
            switch(remortgageReason){
                case "New_fixed_term":
                    return "endingSoon";
                case "Better_rate":
                    return "saveMoney";
                default:
                    return "endingSoon";
            }
        }
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $1b3aef86c81c2996$export$c5b2cd2068ed0aed)(fullApplication.applicationId)
                    ];
                case 1:
                    _ref = _state.sent(), _ref_rule = _ref.rule, tlColor = _ref_rule.color, tlTier = _ref_rule.tier, resultPage = _ref.resultPage;
                    isAdviceRatesExperiment = $19c24bb3e8462f65$var$GetIsInAdviceRatesExperiment(fullApplication);
                    queryParams = {
                        style: BrandPascalCase(),
                        friendlyId: fullApplication === null || fullApplication === void 0 ? void 0 : fullApplication.friendlyId,
                        propertyValue: Math.floor((_fullApplication_basicPropertyDetails = fullApplication.basicPropertyDetails) === null || _fullApplication_basicPropertyDetails === void 0 ? void 0 : _fullApplication_basicPropertyDetails.propertyValue),
                        repaymentPeriod: fullApplication.term,
                        mortgageAmount: Math.floor(MortgageAmount()),
                        rateType: rateType(),
                        paymentType: mojoUswitchRepaymentType(),
                        journeyCompleted: true,
                        mortgageType: mortgageType(),
                        timeframeForMortgage: mojoUswitchTimeframeMortgage(),
                        currentProvider: mojoUswitchCurrentProvider(),
                        remortgageReason: mojoUswitchRemortgageReason(),
                        reasonForMortgage: fullApplication.applicationReason === "Remortgage" ? "Remortgage" : "Purchase",
                        borrowMore: ((_fullApplication_borrowingDetails = fullApplication.borrowingDetails) === null || _fullApplication_borrowingDetails === void 0 ? void 0 : _fullApplication_borrowingDetails.additionalBorrowing) ? "yes" : "no",
                        additionalBorrowing: ((_fullApplication_borrowingDetails1 = fullApplication.borrowingDetails) === null || _fullApplication_borrowingDetails1 === void 0 ? void 0 : _fullApplication_borrowingDetails1.additionalBorrowing) ? Math.floor((_fullApplication_borrowingDetails2 = fullApplication.borrowingDetails) === null || _fullApplication_borrowingDetails2 === void 0 ? void 0 : _fullApplication_borrowingDetails2.additionalBorrowing) : null,
                        financialDifficulty: "no",
                        location: mojoLocation(),
                        brand: (0, $81ead65346fb6783$export$3f4e072470a85305)() === "uswitch" ? "uswitch" : "mojo",
                        shouldBookAppointment: (0, $1fc51b1dc9a30698$export$e77de659f33713d8)(fullApplication),
                        fullApplicationId: fullApplication.applicationId,
                        currentLenderCode: fullApplication.remortgageDetails ? fullApplication.remortgageDetails.existingLenderCode : "",
                        productTermPeriodFromMonths: initialPeriod().productTermPeriodFromMonths,
                        productTermPeriodToMonths: initialPeriod().productTermPeriodToMonths,
                        deposit: Math.floor(fullApplication === null || fullApplication === void 0 ? void 0 : (_fullApplication_borrowingDetails3 = fullApplication.borrowingDetails) === null || _fullApplication_borrowingDetails3 === void 0 ? void 0 : _fullApplication_borrowingDetails3.deposit),
                        tlColor: tlColor,
                        tlTier: tlTier,
                        hideLenderClickouts: ShouldHideLenderClickouts(),
                        hideAllClickouts: ShouldHideAllClickouts(hideClickouts)
                    };
                    return [
                        2,
                        "".concat((0, $10b47c5a212e87a0$export$f9f9a6c285beff09)).concat((0, $5faa8c175a7d9f81$export$2e2bcd8739ae039)(queryParams))
                    ];
            }
        });
    })();
}
function $19c24bb3e8462f65$var$GetIsInAdviceRatesExperiment(application) {
    var _application_metadata;
    if ((_application_metadata = application.metadata) === null || _application_metadata === void 0 ? void 0 : _application_metadata.flags.includes((0, $6e6e522132305404$export$48ea269755562084).IsInSecondaryRatesExperiment)) return true;
    // Check Optimize Cookies
    var experimentsCookie = (0, $cda636b84ca95de8$export$4eb4d455efe88c2f)("_gaexp");
    if (!experimentsCookie) return false;
    var regex = /8LF9TFXeTP2QL0NGFtvy2Q\.\d+.1$/;
    return regex.test(experimentsCookie);
}







/**
 * This page will generate a redirect link to the product table and then navigate to it.
 * It's different from the redirect page under /eligibility because it doesn't check if the
 * user has been shown pages before.
 *
 * This means that the user can use this link as many times as they want to go to their comparison table.
 */ var $61b088f4ac65ae95$var$TableRedirectPage = function() {
    var friendlyId = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().friendlyId;
    var _useApplicationFriendlyId = (0, $8c553d9068484641$export$cba093767fbd948f)(friendlyId), application = _useApplicationFriendlyId.application, hasLoaded = _useApplicationFriendlyId.hasLoaded;
    // we want to make sure that any query parameters (like UTMs)
    // get sent to the link we're redirecting to as well
    var queryParams = new URLSearchParams(window.location.search).toString();
    (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect(function() {
        var getUrlObject = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                var tableUrl;
                return (0, $dMrZK.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!hasLoaded) return [
                                3,
                                3
                            ];
                            // this flag is used by the /eligibility route so that the user
                            // won't be shown a table again, and can instead book an appointment
                            //
                            // users will be redirected to their application when clicking on a clickout
                            // within the table, so this logic prevents them going in a loop.
                            return [
                                4,
                                (0, $1fc51b1dc9a30698$export$cc3f566967fa6dc)(application, (0, $6e6e522132305404$export$48ea269755562084).HasSeenComparisonTable)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                (0, $19c24bb3e8462f65$export$61d6c01afd38b7d1)(application)
                            ];
                        case 2:
                            tableUrl = _state.sent();
                            window.location.assign("".concat(tableUrl, "&").concat(queryParams));
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        getUrlObject();
    }, [
        hasLoaded
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100vh",
                alignItems: "center",
                gap: "0.5rem"
            },
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                    theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline,
                    size: 28
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).SmallBody, {
                    children: "Generating your products..."
                })
            ]
        })
    });
};
var $61b088f4ac65ae95$export$2e2bcd8739ae039 = $61b088f4ac65ae95$var$TableRedirectPage;




/**
 * The /redirect route contains any number of routes that only exist to send the user to an
 * outside resource that require information from our internal applications.
 *
 * The CRM team can send out a magic link that logs the user in, sends them to one of these pages,
 * fetches their personal info, and then sends them wherever they need to go.
 */ var $8019623cd8514115$var$RedirectPage = function() {
    var match = (0, $f4f5613f4156d471$export$632be4bb944c1bc7)();
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$b5d5cf8927ab7262), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
            path: "".concat(match.path, "/products"),
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $61b088f4ac65ae95$export$2e2bcd8739ae039), {})
        })
    });
};
var $8019623cd8514115$export$2e2bcd8739ae039 = $8019623cd8514115$var$RedirectPage;









var $hAGkE = parcelRequire("hAGkE");







parcelRequire("hAGkE");



parcelRequire("hAGkE");

function $18baf6f2a825e7ca$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  to {\n    stroke-dashoffset: 0;\n  }\n"
    ]);
    $18baf6f2a825e7ca$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $18baf6f2a825e7ca$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  to {\n    fill: ",
        ";\n    stroke: ",
        ";\n  }\n"
    ]);
    $18baf6f2a825e7ca$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $18baf6f2a825e7ca$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  animation-name: ",
        ", ",
        ";\n"
    ]);
    $18baf6f2a825e7ca$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $18baf6f2a825e7ca$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  to {\n    stroke-dashoffset: 0;\n  }\n"
    ]);
    $18baf6f2a825e7ca$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $18baf6f2a825e7ca$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  animation-name: ",
        ";\n"
    ]);
    $18baf6f2a825e7ca$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $18baf6f2a825e7ca$var$radius = 50;
var $18baf6f2a825e7ca$var$diameter = 2 * $18baf6f2a825e7ca$var$radius * Math.PI;
var $18baf6f2a825e7ca$export$13493d9c871a0b13 = 2;
var $18baf6f2a825e7ca$var$fadeDuration = 0.5;
var $18baf6f2a825e7ca$var$drawDuration = 0.5;
var $18baf6f2a825e7ca$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    height: 24,
    width: 24
});
var $18baf6f2a825e7ca$var$fill = (0, $62d655c53090e8a3$export$d25ddfdf17c3ad3e)($18baf6f2a825e7ca$var$_templateObject());
var $18baf6f2a825e7ca$var$fadeOut = function(color) {
    return (0, $62d655c53090e8a3$export$d25ddfdf17c3ad3e)($18baf6f2a825e7ca$var$_templateObject1(), color, color);
};
// I can't get the keyframe interpolation to work with the object notation. If
// you can get it to work, these can be combined.
var $18baf6f2a825e7ca$var$FillAnimationName = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).svg($18baf6f2a825e7ca$var$_templateObject2(), $18baf6f2a825e7ca$var$fill, function(param) {
    var theme = param.theme;
    return $18baf6f2a825e7ca$var$fadeOut(theme.colors.success[0]);
});
var $18baf6f2a825e7ca$var$Fill = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($18baf6f2a825e7ca$var$FillAnimationName)(function(param) {
    var initialDelay = param.initialDelay, theme = param.theme;
    return {
        animationDelay: "".concat(initialDelay, "s, ").concat(initialDelay + ($18baf6f2a825e7ca$export$13493d9c871a0b13 - $18baf6f2a825e7ca$var$fadeDuration), "s"),
        animationDuration: "".concat($18baf6f2a825e7ca$export$13493d9c871a0b13, "s, ").concat($18baf6f2a825e7ca$var$fadeDuration, "s"),
        animationFillMode: "forwards",
        animationTimingFunction: "ease, linear",
        fill: "transparent",
        gridColumnStart: 1,
        gridRowStart: 1,
        height: "100%",
        stroke: theme.name === "mojo" ? theme.colors.secondary.three : theme.name === "uswitch" ? "#84A6FF" : theme.primary,
        strokeDasharray: $18baf6f2a825e7ca$var$diameter,
        strokeDashoffset: $18baf6f2a825e7ca$var$diameter,
        transform: "rotate(-90deg)",
        width: "100%"
    };
});
var $18baf6f2a825e7ca$var$Track = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).svg(function(param) {
    var theme = param.theme;
    return {
        fill: "none",
        gridColumnStart: 1,
        gridRowStart: 1,
        height: "100%",
        stroke: theme.name === "uswitch" ? "#E3E3E3" : theme.colors.neutral[200],
        width: "100%"
    };
});
var $18baf6f2a825e7ca$var$draw = (0, $62d655c53090e8a3$export$d25ddfdf17c3ad3e)($18baf6f2a825e7ca$var$_templateObject3());
var $18baf6f2a825e7ca$var$DrawAnimation = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).svg($18baf6f2a825e7ca$var$_templateObject4(), $18baf6f2a825e7ca$var$draw);
var $18baf6f2a825e7ca$var$Check = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($18baf6f2a825e7ca$var$DrawAnimation)(function(param) {
    var initialDelay = param.initialDelay, theme = param.theme;
    return {
        animationDelay: "".concat(initialDelay + ($18baf6f2a825e7ca$export$13493d9c871a0b13 - $18baf6f2a825e7ca$var$drawDuration), "s"),
        animationDuration: "".concat($18baf6f2a825e7ca$var$drawDuration, "s"),
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        strokeDasharray: 125,
        strokeDashoffset: 125,
        gridColumnStart: 1,
        gridRowStart: 1,
        height: "100%",
        width: "100%",
        stroke: theme.colors.success[500],
        zIndex: 1 // hack, not sure why it's hidden by the fill
    };
});
var $18baf6f2a825e7ca$export$ee0c0a8f584f6f12 = function(param) {
    var initialDelay = param.initialDelay;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($18baf6f2a825e7ca$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($18baf6f2a825e7ca$var$Track, {
                viewBox: "0 0 120 120",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("circle", {
                    cx: "60",
                    cy: "60",
                    r: $18baf6f2a825e7ca$var$radius,
                    strokeWidth: "14"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($18baf6f2a825e7ca$var$Fill, {
                initialDelay: initialDelay,
                viewBox: "0 0 120 120",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("circle", {
                    cx: "60",
                    cy: "60",
                    r: $18baf6f2a825e7ca$var$radius,
                    strokeWidth: "16"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($18baf6f2a825e7ca$var$Check, {
                initialDelay: initialDelay,
                viewBox: "0 0 120 120",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("path", {
                    d: "M 27.983657,58.181695 50.552212,79.138212 90.853205,35.61314",
                    strokeWidth: "16"
                })
            })
        ]
    });
};




parcelRequire("hAGkE");


function $be3dfc65f5e8cfc6$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  to {\n    width: 100%;\n  }\n"
    ]);
    $be3dfc65f5e8cfc6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $be3dfc65f5e8cfc6$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  animation-name: ",
        ";\n"
    ]);
    $be3dfc65f5e8cfc6$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $be3dfc65f5e8cfc6$var$Track = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.name === "uswitch" ? "#E3E3E3" : theme.colors.neutral[200],
        borderRadius: theme.name === "uswitch" ? 0 : 200,
        height: 8,
        width: "100%"
    };
});
var $be3dfc65f5e8cfc6$var$Fill = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.name === "mojo" ? theme.colors.secondary.three : theme.name === "uswitch" ? "#84A6FF" : theme.primary,
        borderRadius: theme.name === "uswitch" ? 0 : 200,
        height: 8,
        width: 0
    };
});
var $be3dfc65f5e8cfc6$var$fill = (0, $62d655c53090e8a3$export$d25ddfdf17c3ad3e)($be3dfc65f5e8cfc6$var$_templateObject());
// I can't get the keyframe interpolation to work with the object notation. If
// you can get it to work, these can be combined.
var $be3dfc65f5e8cfc6$var$FillAnimationName = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($be3dfc65f5e8cfc6$var$Fill)($be3dfc65f5e8cfc6$var$_templateObject1(), $be3dfc65f5e8cfc6$var$fill);
var $be3dfc65f5e8cfc6$var$AnimatedInner = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($be3dfc65f5e8cfc6$var$FillAnimationName)(function(param) {
    var initialDelay = param.initialDelay;
    return {
        animationDelay: "".concat(initialDelay, "s"),
        animationDuration: "".concat((0, $18baf6f2a825e7ca$export$13493d9c871a0b13), "s"),
        animationFillMode: "forwards",
        animationTimingFunction: "ease"
    };
});
var $be3dfc65f5e8cfc6$export$2dcc6279784e9b4c = function(param) {
    var initialDelay = param.initialDelay;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($be3dfc65f5e8cfc6$var$Track, {
        role: "progressbar",
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($be3dfc65f5e8cfc6$var$AnimatedInner, {
            initialDelay: initialDelay
        })
    });
};


var $2f2907617d8d8afd$var$rows = [
    "Calculating equity",
    "Checking your credit score",
    "Running affordability checks",
    "Evaluating options"
];
var $2f2907617d8d8afd$export$f6f8bfda0b772c10 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($2f2907617d8d8afd$var$WhiteBox, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2f2907617d8d8afd$var$WideStack, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H1, {
                    children: "Crunching your numbers"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {}),
                $2f2907617d8d8afd$var$rows.map(function(row, idx) {
                    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                                margin: 0,
                                children: row
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($2f2907617d8d8afd$var$Row, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $be3dfc65f5e8cfc6$export$2dcc6279784e9b4c), {
                                        initialDelay: idx * 2
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $18baf6f2a825e7ca$export$ee0c0a8f584f6f12), {
                                        initialDelay: idx * 2
                                    })
                                ]
                            })
                        ]
                    }, row);
                })
            ]
        })
    });
};
var $2f2907617d8d8afd$var$WhiteBox = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.colors.white,
        borderRadius: theme.radius["default"],
        padding: 2 * (0, $1ca2cdaa0912b6ea$export$a941ed4b947d12f8)
    };
});
var $2f2907617d8d8afd$var$WideStack = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ca2cdaa0912b6ea$export$a941ed4b947d12f8)
});
var $2f2907617d8d8afd$var$Row = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    alignItems: "center",
    display: "flex",
    gap: "1rem"
});


function $5cdbcc96d07c9a53$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  padding: 2rem;\n  flex-direction: column;\n"
    ]);
    $5cdbcc96d07c9a53$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5cdbcc96d07c9a53$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 3rem;\n"
    ]);
    $5cdbcc96d07c9a53$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $5cdbcc96d07c9a53$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($5cdbcc96d07c9a53$var$_templateObject());
var $5cdbcc96d07c9a53$var$LoaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($5cdbcc96d07c9a53$var$_templateObject1());
function $5cdbcc96d07c9a53$export$b08b517936747730() {
    (0, $hAGkE.useEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).eligibilityLoader
        });
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($5cdbcc96d07c9a53$var$Container, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($5cdbcc96d07c9a53$var$LoaderContainer, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline,
                size: 120
            })
        })
    });
}
function $5cdbcc96d07c9a53$export$65adac1193fada0b() {
    (0, $hAGkE.useEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).eligibilityLoader
        });
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($5cdbcc96d07c9a53$var$Container, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $2f2907617d8d8afd$export$f6f8bfda0b772c10), {})
    });
}


function $de59818823b3a69a$export$2e2bcd8739ae039() {
    (0, $178ced39e8a813d0$export$9d605c4ba42beec3)();
    var friendlyId = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().friendlyId;
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    var hasFetchedSummaries = (0, $1c92825e7588cbce$export$b17f9dfb16ad8a1d)().hasFetchedSummaries;
    var _useApplicationSummaryEnhanced = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        friendlyId: friendlyId
    }), salesforceApplication = _useApplicationSummaryEnhanced.application;
    (0, $hAGkE.useEffect)(function() {
        if (salesforceApplication) (0, $cda636b84ca95de8$export$f1e6a600abe18947)("CohortsCookie", (0, $1fc51b1dc9a30698$export$3952bb99e24bb0fa)(salesforceApplication).join("."));
    }, [
        hasFetchedSummaries,
        salesforceApplication
    ]);
    (0, $hAGkE.useEffect)(function() {
        (0, $5c342e2d7b9523c9$export$2e2bcd8739ae039)(function(smartLook) {
            smartLook.track("properties", {
                friendlyId: friendlyId
            });
        });
    }, [
        friendlyId
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (hasFetchedSummaries && !salesforceApplication) history.push("/dashboard");
    }, [
        hasFetchedSummaries,
        salesforceApplication
    ]);
    if (!hasFetchedSummaries) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $5cdbcc96d07c9a53$export$b08b517936747730), {});
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bcccde1f2f42f600$exports.ErrorBoundary), {
            FallbackComponent: function(param) {
                var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
                return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $c67218ac7986ea8b$export$d56b0569bceb92ae), {
                    resetError: resetErrorBoundary,
                    children: error.message
                });
            },
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f4f5613f4156d471$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/application/:friendlyId/",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$2d8d895a0a0f636e), {
                            to: "/application/".concat(friendlyId, "/eligibility")
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        path: "/application/:friendlyId/eligibility",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$2d8d895a0a0f636e), {
                            to: "/application/".concat(friendlyId, "/status")
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/application/:friendlyId/payment-confirmed",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bf05a0c7dfc52c38$export$ea64be20ec62f334), {
                            friendlyId: friendlyId,
                            opportunityStage: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.stage,
                            selected: (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Status,
                            servicePaid: true
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/application/:friendlyId/status",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bf05a0c7dfc52c38$export$ea64be20ec62f334), {
                            friendlyId: friendlyId,
                            opportunityStage: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.stage,
                            selected: (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Status
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/application/:friendlyId/recommendation",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bf05a0c7dfc52c38$export$ea64be20ec62f334), {
                            friendlyId: friendlyId,
                            opportunityStage: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.stage,
                            selected: (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Recommendation
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/application/:friendlyId/rate-check-promise",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bf05a0c7dfc52c38$export$ea64be20ec62f334), {
                            friendlyId: friendlyId,
                            opportunityStage: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.stage,
                            selected: (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).RateChecker
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/application/:friendlyId/documents",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bf05a0c7dfc52c38$export$ea64be20ec62f334), {
                            friendlyId: friendlyId,
                            opportunityStage: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.stage,
                            selected: (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Documents
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        path: "/application/:friendlyId/conveyancing",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/application/:friendlyId/conveyancing",
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bf05a0c7dfc52c38$export$ea64be20ec62f334), {
                                friendlyId: friendlyId,
                                opportunityStage: salesforceApplication === null || salesforceApplication === void 0 ? void 0 : salesforceApplication.stage,
                                selected: (0, $bf05a0c7dfc52c38$export$c685627fd4eca96).Conveyancing
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                        path: "/application/:friendlyId/redirect",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8019623cd8514115$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$2d8d895a0a0f636e), {
                        to: "/application/".concat(friendlyId)
                    })
                ]
            })
        })
    });
}



var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");


var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");


function $93b74858bca4b458$export$601241e3cce50c9e(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
}
function $93b74858bca4b458$export$1e1d235314148489() {
    var qs = window.location.search;
    if (!qs) return "";
    if (qs.startsWith("?")) qs = qs.substr(1);
    return qs;
}







var $hAGkE = parcelRequire("hAGkE");



function $166e000819392ce8$export$85eb2f6ac013e6f4(param) {
    var application = param.application, tls = param.tls, journeyCohort = param.journeyCohort;
    var subdomain = location.hostname.includes("local") ? null : window.location.host.split(".")[0];
    (0, $hAGkE.useEffect)(function() {
        // @ts-ignore
        if (!window.Intercom) return;
        // @ts-ignore
        window.Intercom("boot", {
            app_id: "zxc8uzc8",
            liveChatAppointment: false
        });
        window.Intercom && window.Intercom("update", {
            hide_default_launcher: false
        });
        if (application) {
            var _application_basicPropertyDetails;
            var applicant = getFirstApplicant(application);
            var isRemo = application.applicationReason === (0, $92da6ce0a9463af6$export$f5805e4abe6a2ac5).Remortgage;
            var _applicant_email, _application_friendlyId, _application_applicationReason, _application_applicationReason1, _application_remortgageReason, _getLoanAmount, _application_purchaseType;
            var options = {
                app_id: "zxc8uzc8",
                liveChatAppointment: false,
                email: (_applicant_email = applicant === null || applicant === void 0 ? void 0 : applicant.email) !== null && _applicant_email !== void 0 ? _applicant_email : null,
                name: (applicant === null || applicant === void 0 ? void 0 : applicant.forename) ? "".concat(applicant.forename, " ").concat(applicant.surname) : null,
                user_id: (_application_friendlyId = application.friendlyId) !== null && _application_friendlyId !== void 0 ? _application_friendlyId : null,
                ede: null,
                hide_default_lecauncher: true,
                // not my spelling mistake
                cohort: (_application_applicationReason = application.applicationReason) !== null && _application_applicationReason !== void 0 ? _application_applicationReason : null,
                eligibility_tier: null,
                isBuyToLet: ((_application_basicPropertyDetails = application.basicPropertyDetails) === null || _application_basicPropertyDetails === void 0 ? void 0 : _application_basicPropertyDetails.occupancy) === (0, $6e6e522132305404$export$76afec25c076d535).RentItOut,
                journey_intention: (_application_applicationReason1 = application.applicationReason) !== null && _application_applicationReason1 !== void 0 ? _application_applicationReason1 : null,
                remoType: (_application_remortgageReason = application.remortgageReason) !== null && _application_remortgageReason !== void 0 ? _application_remortgageReason : null,
                partnerName: subdomain !== null && subdomain !== void 0 ? subdomain : null,
                journey_cohort: journeyCohort !== null && journeyCohort !== void 0 ? journeyCohort : null,
                loanAmount: (_getLoanAmount = getLoanAmount(application, isRemo)) !== null && _getLoanAmount !== void 0 ? _getLoanAmount : null,
                purchaseType: (_application_purchaseType = application.purchaseType) !== null && _application_purchaseType !== void 0 ? _application_purchaseType : null
            };
            if (tls) {
                var _ref;
                options.ede = (_ref = tls.rule.offerAppointment === (0, $831af630f644aede$export$e031b897fa92493d)["true"]) !== null && _ref !== void 0 ? _ref : null;
                options.liveChatAppointment = true;
                var _tls_eligibility_tier;
                options.eligibility_tier = (_tls_eligibility_tier = tls.eligibility.tier) !== null && _tls_eligibility_tier !== void 0 ? _tls_eligibility_tier : null;
            }
            // @ts-ignore
            window.Intercom("update", options);
        }
    });
    function getFirstApplicant(app) {
        var _app_applicants;
        var first;
        if ((_app_applicants = app.applicants) === null || _app_applicants === void 0 ? void 0 : _app_applicants.length) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = app.applicants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var applicant = _step.value;
                    if (applicant.firstApplicant) first = applicant;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return first;
    }
    function getLoanAmount(app, isRemo) {
        var loanAmount;
        if (app) {
            var _app_currentMortgage, _app_borrowingDetails, _app_basicPropertyDetails, _app_borrowingDetails1;
            var _app_currentMortgage_mortgageBalance;
            if (isRemo === true) loanAmount = ((_app_currentMortgage_mortgageBalance = (_app_currentMortgage = app.currentMortgage) === null || _app_currentMortgage === void 0 ? void 0 : _app_currentMortgage.mortgageBalance) !== null && _app_currentMortgage_mortgageBalance !== void 0 ? _app_currentMortgage_mortgageBalance : 0) + ((_app_borrowingDetails = app.borrowingDetails) === null || _app_borrowingDetails === void 0 ? void 0 : _app_borrowingDetails.additionalBorrowing);
            if (isRemo === false) loanAmount = ((_app_basicPropertyDetails = app.basicPropertyDetails) === null || _app_basicPropertyDetails === void 0 ? void 0 : _app_basicPropertyDetails.propertyValue) - ((_app_borrowingDetails1 = app.borrowingDetails) === null || _app_borrowingDetails1 === void 0 ? void 0 : _app_borrowingDetails1.deposit);
        }
        return loanAmount;
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {});
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");



parcelRequire("hAGkE");



parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");


function $ecac119a7e094d08$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  width: 100%;\n  display: block;\n  transition: 0.4s;\n  padding-left: 16px;\n  padding-right: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  line-height: 44px;\n  pointer-events: none;\n  user-select: none;\n  color: ",
        ";\n  z-index: 1;\n  white-space: nowrap;\n  text-align: right;\n  p {\n    display: inline-block;\n  }\n"
    ]);
    $ecac119a7e094d08$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ecac119a7e094d08$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  position: relative;\n  border-radius: ",
        ";\n  &:focus-within {\n    border: 1px solid ",
        ";\n    box-shadow: 0 0 0 1px ",
        ";\n  }\n"
    ]);
    $ecac119a7e094d08$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $ecac119a7e094d08$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  border: none;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  padding: 12px ",
        " 12px 16px;\n  font-size: 16px;\n  color: ",
        ";\n  box-sizing: border-box;\n  outline: none;\n  &:empty {\n    + ",
        " {\n      width: 0;\n    }\n  }\n  &:focus,\n  &:not(:placeholder-shown) {\n    + ",
        " {\n      width: 100%;\n      p {\n        transform-origin: right;\n        transform: scale(0.8);\n      }\n      /* The 0.5 is to fix a bug with overflow */\n    }\n  }\n"
    ]);
    $ecac119a7e094d08$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $ecac119a7e094d08$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  0% {\n    opacity: 0;\n    transform: scale(0)\n  }\n\n  100 {\n    opacity: 1;\n    transform: scale(1)\n  }\n"
    ]);
    $ecac119a7e094d08$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $ecac119a7e094d08$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ",
        ";\n  width: 32px;\n  height: 32px;\n  margin: auto;\n  border-radius: 50%;\n  transform-origin: center;\n  animation: ",
        " 1s infinite alternate;\n  user-select: none;\n  pointer-events: none;\n  display: ",
        ";\n"
    ]);
    $ecac119a7e094d08$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $ecac119a7e094d08$var$Label = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).label($ecac119a7e094d08$var$_templateObject(), function(props) {
    return props.theme.shade[20];
});
var $ecac119a7e094d08$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ecac119a7e094d08$var$_templateObject1(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.cta;
}, function(props) {
    return props.theme.cta;
});
var $ecac119a7e094d08$var$InnerInput = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).input($ecac119a7e094d08$var$_templateObject2(), function(props) {
    return props.labelOffset * 0.9 + 32 + "px";
}, function(props) {
    return props.disabled ? props.theme.shade[40] : props.theme.shade[0];
}, $ecac119a7e094d08$var$Label, $ecac119a7e094d08$var$Label);
var $ecac119a7e094d08$var$animation = (0, $62d655c53090e8a3$export$d25ddfdf17c3ad3e)($ecac119a7e094d08$var$_templateObject3());
var $ecac119a7e094d08$var$Loader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ecac119a7e094d08$var$_templateObject4(), function(props) {
    return props.theme.shade[60];
}, $ecac119a7e094d08$var$animation, function(props) {
    return props.isLoading ? "block" : "none";
});
function $ecac119a7e094d08$export$f5b8910cec6cf069(props) {
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState({
        labelWidth: 0
    }), 2), dimensions = _React_useState[0], setDimensions = _React_useState[1];
    var labelRef = (0, $hAGkE.useRef)(null);
    (0, $hAGkE.useEffect)(function() {
        setDimensions({
            labelWidth: labelRef.current.clientWidth
        });
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ecac119a7e094d08$var$Container, {
        disabled: props.disabled,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ecac119a7e094d08$var$Loader, {
                isLoading: props.isLoading
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ecac119a7e094d08$var$InnerInput, (0, $hRCmZ._)({
                type: "text",
                id: props.id,
                disabled: props.disabled,
                value: props.value,
                onChange: props.onChange,
                onClick: props.onClick,
                placeholder: " ",
                autoComplete: "off",
                labelOffset: dimensions.labelWidth
            }, props)),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($ecac119a7e094d08$var$Label, {
                htmlFor: props.id,
                disabled: props.disabled,
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    ref: labelRef,
                    children: props.label
                })
            })
        ]
    });
}
$ecac119a7e094d08$export$f5b8910cec6cf069.propTypes = {
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string
};



function $340cdb16aa3c2340$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-family: Arial, sans-serif;\n"
    ]);
    $340cdb16aa3c2340$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $340cdb16aa3c2340$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($340cdb16aa3c2340$var$_templateObject());
function $340cdb16aa3c2340$export$c86715117507e8e5(param) {
    var value = param.value, placeholder = param.placeholder, _param_suffix = param.suffix, suffix = _param_suffix === void 0 ? null : _param_suffix, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {} : _param_onBlur, _param_onFocus = param.onFocus, onFocus = _param_onFocus === void 0 ? function() {} : _param_onFocus, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function(value) {} : _param_onChange, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function(key) {} : _param_onKeyDown, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($340cdb16aa3c2340$var$Container, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ecac119a7e094d08$export$f5b8910cec6cf069), {
            id: id,
            value: value,
            onBlur: onBlur,
            onFocus: onFocus,
            autoComplete: "off",
            placeholder: placeholder,
            suffix: suffix,
            onChange: function(e) {
                return onChange(e.target.value);
            },
            onKeyDown: onKeyDown
        })
    });
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");




var $hAGkE = parcelRequire("hAGkE");
function $e7b15d37613b87c9$export$2e2bcd8739ae039() {
    var didMount = (0, $hAGkE.useRef)(false);
    (0, $hAGkE.useEffect)(function() {
        didMount.current = true;
    }, []);
    return didMount.current;
}


function $748cfd09b8876110$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-family: Arial, sans-serif;\n  position: relative;\n\n  div {\n    border-radius: 8px;\n    border: 1px solid black !important;\n    padding: 5px 5px !important;\n  }\n"
    ]);
    $748cfd09b8876110$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $748cfd09b8876110$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #f6f6f6;\n  color: #97989e;\n  height: 100%;\n  width: 22%;\n  text-align: center;\n  padding-top: 18px;\n  border: 1px solid black;\n  border-left: none;\n  border-radius: 0 8px 8px 0;\n  cursor: pointer;\n  user-select: none;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    $748cfd09b8876110$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $748cfd09b8876110$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($748cfd09b8876110$var$_templateObject());
var $748cfd09b8876110$var$PasswordMaskToggle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($748cfd09b8876110$var$_templateObject1(), (0, $6650ffc144de4082$export$4b073707ff63303)(0.03, "#f6f6f6"));
function $748cfd09b8876110$export$b28585a458fee016(param) {
    var value = param.value, placeholder = param.placeholder, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {} : _param_onBlur, _param_onFocus = param.onFocus, onFocus = _param_onFocus === void 0 ? function() {} : _param_onFocus, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function(value) {} : _param_onChange, _param_onLoaded = param.onLoaded, onLoaded = _param_onLoaded === void 0 ? function() {} : _param_onLoaded, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isMasked = _useState[0], setIsMasked = _useState[1];
    var didMount = (0, $e7b15d37613b87c9$export$2e2bcd8739ae039)();
    (0, $hAGkE.useEffect)(function() {
        !didMount && onLoaded();
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($748cfd09b8876110$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ecac119a7e094d08$export$f5b8910cec6cf069), {
                id: id,
                value: value,
                type: isMasked ? "password" : "text",
                onBlur: onBlur,
                onFocus: onFocus,
                placeholder: placeholder,
                onChange: function(e) {
                    return onChange(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($748cfd09b8876110$var$PasswordMaskToggle, {
                onClick: function() {
                    return setIsMasked(!isMasked);
                },
                children: isMasked ? "Show" : "Hide"
            })
        ]
    });
}


function $3ca7b74ed6d47882$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        ""
    ]);
    $3ca7b74ed6d47882$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3ca7b74ed6d47882$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 0.5em;\n  font-size: 1.3em;\n"
    ]);
    $3ca7b74ed6d47882$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3ca7b74ed6d47882$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding-top: 15px;\n  color: ",
        ";\n  font-weight: 450;\n"
    ]);
    $3ca7b74ed6d47882$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $3ca7b74ed6d47882$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3ca7b74ed6d47882$var$_templateObject());
var $3ca7b74ed6d47882$var$Label = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3ca7b74ed6d47882$var$_templateObject1());
var $3ca7b74ed6d47882$var$Error = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($3ca7b74ed6d47882$var$_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.error;
});
function $3ca7b74ed6d47882$export$a72bf6dea519b1d(param) {
    var label = param.label, placeholder = param.placeholder, value = param.value, _param_isValid = param.isValid, isValid = _param_isValid === void 0 ? true : _param_isValid, _param_errorMessage = param.errorMessage, errorMessage = _param_errorMessage === void 0 ? "" : _param_errorMessage, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {} : _param_onBlur, _param_onEnter = param.onEnter, onEnter = _param_onEnter === void 0 ? function() {} : _param_onEnter, _param_onFocus = param.onFocus, onFocus = _param_onFocus === void 0 ? function() {} : _param_onFocus, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function(value) {} : _param_onChange, type = param.type, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    var component = componentFactory();
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($3ca7b74ed6d47882$var$Container, {
        children: [
            label && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3ca7b74ed6d47882$var$Label, {
                children: label
            }),
            component,
            !isValid && errorMessage && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($3ca7b74ed6d47882$var$Error, {
                children: errorMessage
            })
        ]
    });
    function componentFactory() {
        switch(type){
            case "text":
                return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                    id: id,
                    placeholder: placeholder,
                    onBlur: onBlur,
                    value: value,
                    onChange: onChange,
                    onFocus: onFocus,
                    onKeyDown: function(e) {
                        if (e.key === "Enter") onEnter();
                    }
                });
            case "password":
                return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $748cfd09b8876110$export$b28585a458fee016), {
                    id: id,
                    placeholder: placeholder,
                    onBlur: onBlur,
                    value: value,
                    onChange: onChange,
                    onFocus: onFocus
                });
        }
    }
}


// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
var $375b311c5bf23bd7$export$a22775fa5e2eebd9;
"use strict";
var $375b311c5bf23bd7$var$tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
$375b311c5bf23bd7$export$a22775fa5e2eebd9 = function(email) {
    if (!email) return false;
    if (email.length > 254) return false;
    var valid = $375b311c5bf23bd7$var$tester.test(email);
    if (!valid) return false;
    // Further checking of some things regex can't handle
    var parts = email.split("@");
    if (parts[0].length > 64) return false;
    var domainParts = parts[1].split(".");
    if (domainParts.some(function(part) {
        return part.length > 63;
    })) return false;
    return true;
};


function $b144b381fed01ccc$export$a1b2cbbeb63805f3(emailAddress) {
    return $375b311c5bf23bd7$export$a22775fa5e2eebd9(emailAddress);
}



function $55ca0a6bc334de70$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-family: Arial, sans-serif;\n\n  div > div > div {\n    border-radius: 8px;\n    border: 1px solid black !important;\n    padding: 5px 5px !important;\n  }\n"
    ]);
    $55ca0a6bc334de70$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $55ca0a6bc334de70$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($55ca0a6bc334de70$var$_templateObject());
function $55ca0a6bc334de70$export$20b1d7061d50817f(param) {
    var _param_label = param.label, label = _param_label === void 0 ? "" : _param_label, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "" : _param_placeholder, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {} : _param_onBlur, _param_onEnter = param.onEnter, onEnter = _param_onEnter === void 0 ? function() {} : _param_onEnter, _param_onFocus = param.onFocus, onFocus = _param_onFocus === void 0 ? function() {} : _param_onFocus, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function(value) {} : _param_onChange, _param_onIsValidChange = param.onIsValidChange, onIsValidChange = _param_onIsValidChange === void 0 ? function(isValid) {} : _param_onIsValidChange, _param_onLoaded = param.onLoaded, onLoaded = _param_onLoaded === void 0 ? function() {} : _param_onLoaded, _param_allowBlank = param.allowBlank, allowBlank = _param_allowBlank === void 0 ? false : _param_allowBlank, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasTouched = _useState[0], setHasTouched = _useState[1];
    var isValid = (0, $b144b381fed01ccc$export$a1b2cbbeb63805f3)(value);
    var didMount = (0, $e7b15d37613b87c9$export$2e2bcd8739ae039)();
    (0, $hAGkE.useEffect)(function() {
        onIsValidChange((0, $b144b381fed01ccc$export$a1b2cbbeb63805f3)(value));
        !didMount && onLoaded();
    }, [
        value
    ]);
    function handleOnBlur() {
        setHasTouched(true);
        onBlur();
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($55ca0a6bc334de70$var$Container, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3ca7b74ed6d47882$export$a72bf6dea519b1d), {
            id: id,
            type: "text",
            label: label,
            value: value !== null && value !== void 0 ? value : "",
            isValid: isValid,
            placeholder: placeholder,
            onBlur: handleOnBlur,
            onFocus: onFocus,
            errorMessage: hasTouched && !allowBlank && "Email address is invalid",
            onChange: onChange,
            onEnter: onEnter
        })
    });
}








/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ 
var $2xTNA = parcelRequire("2xTNA");
function $beaa24d3f75cb816$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $2xTNA._)(Symbol.iterator) === "symbol") $beaa24d3f75cb816$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj);
    };
    else $beaa24d3f75cb816$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj);
    };
    return $beaa24d3f75cb816$var$_typeof(obj);
}
function $beaa24d3f75cb816$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $beaa24d3f75cb816$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $beaa24d3f75cb816$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $beaa24d3f75cb816$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $beaa24d3f75cb816$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $beaa24d3f75cb816$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $beaa24d3f75cb816$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $beaa24d3f75cb816$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $beaa24d3f75cb816$var$_slicedToArray(arr, i) {
    return $beaa24d3f75cb816$var$_arrayWithHoles(arr) || $beaa24d3f75cb816$var$_iterableToArrayLimit(arr, i) || $beaa24d3f75cb816$var$_nonIterableRest();
}
function $beaa24d3f75cb816$var$_toConsumableArray(arr) {
    return $beaa24d3f75cb816$var$_arrayWithoutHoles(arr) || $beaa24d3f75cb816$var$_iterableToArray(arr) || $beaa24d3f75cb816$var$_nonIterableSpread();
}
function $beaa24d3f75cb816$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $beaa24d3f75cb816$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $beaa24d3f75cb816$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $beaa24d3f75cb816$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $beaa24d3f75cb816$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $beaa24d3f75cb816$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var $beaa24d3f75cb816$var$noop = function noop() {};
var $beaa24d3f75cb816$var$_WINDOW = {};
var $beaa24d3f75cb816$var$_DOCUMENT = {};
var $beaa24d3f75cb816$var$_MUTATION_OBSERVER = null;
var $beaa24d3f75cb816$var$_PERFORMANCE = {
    mark: $beaa24d3f75cb816$var$noop,
    measure: $beaa24d3f75cb816$var$noop
};
try {
    if (typeof window !== 'undefined') $beaa24d3f75cb816$var$_WINDOW = window;
    if (typeof document !== 'undefined') $beaa24d3f75cb816$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $beaa24d3f75cb816$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $beaa24d3f75cb816$var$_PERFORMANCE = performance;
} catch (e) {}
var $beaa24d3f75cb816$var$_ref = $beaa24d3f75cb816$var$_WINDOW.navigator || {}, $beaa24d3f75cb816$var$_ref$userAgent = $beaa24d3f75cb816$var$_ref.userAgent, $beaa24d3f75cb816$var$userAgent = $beaa24d3f75cb816$var$_ref$userAgent === void 0 ? '' : $beaa24d3f75cb816$var$_ref$userAgent;
var $beaa24d3f75cb816$var$WINDOW = $beaa24d3f75cb816$var$_WINDOW;
var $beaa24d3f75cb816$var$DOCUMENT = $beaa24d3f75cb816$var$_DOCUMENT;
var $beaa24d3f75cb816$var$MUTATION_OBSERVER = $beaa24d3f75cb816$var$_MUTATION_OBSERVER;
var $beaa24d3f75cb816$var$PERFORMANCE = $beaa24d3f75cb816$var$_PERFORMANCE;
var $beaa24d3f75cb816$var$IS_BROWSER = !!$beaa24d3f75cb816$var$WINDOW.document;
var $beaa24d3f75cb816$var$IS_DOM = !!$beaa24d3f75cb816$var$DOCUMENT.documentElement && !!$beaa24d3f75cb816$var$DOCUMENT.head && typeof $beaa24d3f75cb816$var$DOCUMENT.addEventListener === 'function' && typeof $beaa24d3f75cb816$var$DOCUMENT.createElement === 'function';
var $beaa24d3f75cb816$var$IS_IE = ~$beaa24d3f75cb816$var$userAgent.indexOf('MSIE') || ~$beaa24d3f75cb816$var$userAgent.indexOf('Trident/');
var $beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $beaa24d3f75cb816$var$UNITS_IN_GRID = 16;
var $beaa24d3f75cb816$var$DEFAULT_FAMILY_PREFIX = 'fa';
var $beaa24d3f75cb816$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $beaa24d3f75cb816$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $beaa24d3f75cb816$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $beaa24d3f75cb816$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $beaa24d3f75cb816$var$DATA_PREFIX = 'data-prefix';
var $beaa24d3f75cb816$var$DATA_ICON = 'data-icon';
var $beaa24d3f75cb816$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $beaa24d3f75cb816$var$MUTATION_APPROACH_ASYNC = 'async';
var $beaa24d3f75cb816$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $beaa24d3f75cb816$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $beaa24d3f75cb816$var$PREFIX_TO_STYLE = {
    fas: 'solid',
    far: 'regular',
    fal: 'light',
    fad: 'duotone',
    fab: 'brands',
    fak: 'kit',
    fa: 'solid'
};
var $beaa24d3f75cb816$var$STYLE_TO_PREFIX = {
    solid: 'fas',
    regular: 'far',
    light: 'fal',
    duotone: 'fad',
    brands: 'fab',
    kit: 'fak'
};
var $beaa24d3f75cb816$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $beaa24d3f75cb816$var$FONT_FAMILY_PATTERN = /Font Awesome ([5 ]*)(Solid|Regular|Light|Duotone|Brands|Free|Pro|Kit).*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $beaa24d3f75cb816$var$FONT_WEIGHT_TO_PREFIX = {
    '900': 'fas',
    '400': 'far',
    normal: 'far',
    '300': 'fal'
};
var $beaa24d3f75cb816$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $beaa24d3f75cb816$var$oneToTwenty = $beaa24d3f75cb816$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $beaa24d3f75cb816$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $beaa24d3f75cb816$var$DUOTONE_CLASSES = {
    GROUP: 'group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var $beaa24d3f75cb816$var$RESERVED_CLASSES = [
    'xs',
    'sm',
    'lg',
    'fw',
    'ul',
    'li',
    'border',
    'pull-left',
    'pull-right',
    'spin',
    'pulse',
    'rotate-90',
    'rotate-180',
    'rotate-270',
    'flip-horizontal',
    'flip-vertical',
    'flip-both',
    'stack',
    'stack-1x',
    'stack-2x',
    'inverse',
    'layers',
    'layers-text',
    'layers-counter',
    $beaa24d3f75cb816$var$DUOTONE_CLASSES.GROUP,
    $beaa24d3f75cb816$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $beaa24d3f75cb816$var$DUOTONE_CLASSES.PRIMARY,
    $beaa24d3f75cb816$var$DUOTONE_CLASSES.SECONDARY
].concat($beaa24d3f75cb816$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($beaa24d3f75cb816$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $beaa24d3f75cb816$var$initial = $beaa24d3f75cb816$var$WINDOW.FontAwesomeConfig || {};
function $beaa24d3f75cb816$var$getAttrConfig(attr) {
    var element = $beaa24d3f75cb816$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $beaa24d3f75cb816$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($beaa24d3f75cb816$var$DOCUMENT && typeof $beaa24d3f75cb816$var$DOCUMENT.querySelector === 'function') {
    var $beaa24d3f75cb816$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $beaa24d3f75cb816$var$attrs.forEach(function(_ref) {
        var _ref2 = $beaa24d3f75cb816$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $beaa24d3f75cb816$var$coerce($beaa24d3f75cb816$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $beaa24d3f75cb816$var$initial[key] = val;
    });
}
var $beaa24d3f75cb816$var$_default = {
    familyPrefix: $beaa24d3f75cb816$var$DEFAULT_FAMILY_PREFIX,
    replacementClass: $beaa24d3f75cb816$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var $beaa24d3f75cb816$var$_config = $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$_default, $beaa24d3f75cb816$var$initial);
if (!$beaa24d3f75cb816$var$_config.autoReplaceSvg) $beaa24d3f75cb816$var$_config.observeMutations = false;
var $beaa24d3f75cb816$export$e506a1d27d1eaa20 = $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$_config);
$beaa24d3f75cb816$var$WINDOW.FontAwesomeConfig = $beaa24d3f75cb816$export$e506a1d27d1eaa20;
var $beaa24d3f75cb816$var$w = $beaa24d3f75cb816$var$WINDOW || {};
if (!$beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER]) $beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER] = {};
if (!$beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER].styles) $beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER].hooks) $beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER].shims) $beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER].shims = [];
var $beaa24d3f75cb816$var$namespace = $beaa24d3f75cb816$var$w[$beaa24d3f75cb816$var$NAMESPACE_IDENTIFIER];
var $beaa24d3f75cb816$var$functions = [];
var $beaa24d3f75cb816$var$listener = function listener() {
    $beaa24d3f75cb816$var$DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    $beaa24d3f75cb816$var$loaded = 1;
    $beaa24d3f75cb816$var$functions.map(function(fn) {
        return fn();
    });
};
var $beaa24d3f75cb816$var$loaded = false;
if ($beaa24d3f75cb816$var$IS_DOM) {
    $beaa24d3f75cb816$var$loaded = ($beaa24d3f75cb816$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($beaa24d3f75cb816$var$DOCUMENT.readyState);
    if (!$beaa24d3f75cb816$var$loaded) $beaa24d3f75cb816$var$DOCUMENT.addEventListener('DOMContentLoaded', $beaa24d3f75cb816$var$listener);
}
function $beaa24d3f75cb816$var$domready(fn) {
    if (!$beaa24d3f75cb816$var$IS_DOM) return;
    $beaa24d3f75cb816$var$loaded ? setTimeout(fn, 0) : $beaa24d3f75cb816$var$functions.push(fn);
}
var $beaa24d3f75cb816$var$PENDING = 'pending';
var $beaa24d3f75cb816$var$SETTLED = 'settled';
var $beaa24d3f75cb816$var$FULFILLED = 'fulfilled';
var $beaa24d3f75cb816$var$REJECTED = 'rejected';
var $beaa24d3f75cb816$var$NOOP = function NOOP() {};
var $beaa24d3f75cb816$var$isNode = typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && typeof $parcel$global.process.emit === 'function';
var $beaa24d3f75cb816$var$asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var $beaa24d3f75cb816$var$asyncQueue = [];
var $beaa24d3f75cb816$var$asyncTimer;
function $beaa24d3f75cb816$var$asyncFlush() {
    // run promise callbacks
    for(var i = 0; i < $beaa24d3f75cb816$var$asyncQueue.length; i++)$beaa24d3f75cb816$var$asyncQueue[i][0]($beaa24d3f75cb816$var$asyncQueue[i][1]);
     // reset async asyncQueue
    $beaa24d3f75cb816$var$asyncQueue = [];
    $beaa24d3f75cb816$var$asyncTimer = false;
}
function $beaa24d3f75cb816$var$asyncCall(callback, arg) {
    $beaa24d3f75cb816$var$asyncQueue.push([
        callback,
        arg
    ]);
    if (!$beaa24d3f75cb816$var$asyncTimer) {
        $beaa24d3f75cb816$var$asyncTimer = true;
        $beaa24d3f75cb816$var$asyncSetTimer($beaa24d3f75cb816$var$asyncFlush, 0);
    }
}
function $beaa24d3f75cb816$var$invokeResolver(resolver, promise) {
    function resolvePromise(value) {
        $beaa24d3f75cb816$var$resolve(promise, value);
    }
    function rejectPromise(reason) {
        $beaa24d3f75cb816$var$reject(promise, reason);
    }
    try {
        resolver(resolvePromise, rejectPromise);
    } catch (e) {
        rejectPromise(e);
    }
}
function $beaa24d3f75cb816$var$invokeCallback(subscriber) {
    var owner = subscriber.owner;
    var settled = owner._state;
    var value = owner._data;
    var callback = subscriber[settled];
    var promise = subscriber.then;
    if (typeof callback === 'function') {
        settled = $beaa24d3f75cb816$var$FULFILLED;
        try {
            value = callback(value);
        } catch (e) {
            $beaa24d3f75cb816$var$reject(promise, e);
        }
    }
    if (!$beaa24d3f75cb816$var$handleThenable(promise, value)) {
        if (settled === $beaa24d3f75cb816$var$FULFILLED) $beaa24d3f75cb816$var$resolve(promise, value);
        if (settled === $beaa24d3f75cb816$var$REJECTED) $beaa24d3f75cb816$var$reject(promise, value);
    }
}
function $beaa24d3f75cb816$var$handleThenable(promise, value) {
    var resolved;
    try {
        if (promise === value) throw new TypeError('A promises callback cannot return that same promise.');
        if (value && (typeof value === 'function' || $beaa24d3f75cb816$var$_typeof(value) === 'object')) {
            // then should be retrieved only once
            var then = value.then;
            if (typeof then === 'function') {
                then.call(value, function(val) {
                    if (!resolved) {
                        resolved = true;
                        if (value === val) $beaa24d3f75cb816$var$fulfill(promise, val);
                        else $beaa24d3f75cb816$var$resolve(promise, val);
                    }
                }, function(reason) {
                    if (!resolved) {
                        resolved = true;
                        $beaa24d3f75cb816$var$reject(promise, reason);
                    }
                });
                return true;
            }
        }
    } catch (e) {
        if (!resolved) $beaa24d3f75cb816$var$reject(promise, e);
        return true;
    }
    return false;
}
function $beaa24d3f75cb816$var$resolve(promise, value) {
    if (promise === value || !$beaa24d3f75cb816$var$handleThenable(promise, value)) $beaa24d3f75cb816$var$fulfill(promise, value);
}
function $beaa24d3f75cb816$var$fulfill(promise, value) {
    if (promise._state === $beaa24d3f75cb816$var$PENDING) {
        promise._state = $beaa24d3f75cb816$var$SETTLED;
        promise._data = value;
        $beaa24d3f75cb816$var$asyncCall($beaa24d3f75cb816$var$publishFulfillment, promise);
    }
}
function $beaa24d3f75cb816$var$reject(promise, reason) {
    if (promise._state === $beaa24d3f75cb816$var$PENDING) {
        promise._state = $beaa24d3f75cb816$var$SETTLED;
        promise._data = reason;
        $beaa24d3f75cb816$var$asyncCall($beaa24d3f75cb816$var$publishRejection, promise);
    }
}
function $beaa24d3f75cb816$var$publish(promise) {
    promise._then = promise._then.forEach($beaa24d3f75cb816$var$invokeCallback);
}
function $beaa24d3f75cb816$var$publishFulfillment(promise) {
    promise._state = $beaa24d3f75cb816$var$FULFILLED;
    $beaa24d3f75cb816$var$publish(promise);
}
function $beaa24d3f75cb816$var$publishRejection(promise) {
    promise._state = $beaa24d3f75cb816$var$REJECTED;
    $beaa24d3f75cb816$var$publish(promise);
    if (!promise._handled && $beaa24d3f75cb816$var$isNode) $parcel$global.process.emit('unhandledRejection', promise._data, promise);
}
function $beaa24d3f75cb816$var$notifyRejectionHandled(promise) {
    $parcel$global.process.emit('rejectionHandled', promise);
}
/**
 * @class
 */ function $beaa24d3f75cb816$var$P(resolver) {
    if (typeof resolver !== 'function') throw new TypeError('Promise resolver ' + resolver + ' is not a function');
    if (this instanceof $beaa24d3f75cb816$var$P === false) throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
    this._then = [];
    $beaa24d3f75cb816$var$invokeResolver(resolver, this);
}
$beaa24d3f75cb816$var$P.prototype = {
    constructor: $beaa24d3f75cb816$var$P,
    _state: $beaa24d3f75cb816$var$PENDING,
    _then: null,
    _data: undefined,
    _handled: false,
    then: function then(onFulfillment, onRejection) {
        var subscriber = {
            owner: this,
            then: new this.constructor($beaa24d3f75cb816$var$NOOP),
            fulfilled: onFulfillment,
            rejected: onRejection
        };
        if ((onRejection || onFulfillment) && !this._handled) {
            this._handled = true;
            if (this._state === $beaa24d3f75cb816$var$REJECTED && $beaa24d3f75cb816$var$isNode) $beaa24d3f75cb816$var$asyncCall($beaa24d3f75cb816$var$notifyRejectionHandled, this);
        }
        if (this._state === $beaa24d3f75cb816$var$FULFILLED || this._state === $beaa24d3f75cb816$var$REJECTED) // already resolved, call callback async
        $beaa24d3f75cb816$var$asyncCall($beaa24d3f75cb816$var$invokeCallback, subscriber);
        else // subscribe
        this._then.push(subscriber);
        return subscriber.then;
    },
    "catch": function _catch(onRejection) {
        return this.then(null, onRejection);
    }
};
$beaa24d3f75cb816$var$P.all = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError('You must pass an array to Promise.all().');
    return new $beaa24d3f75cb816$var$P(function(resolve, reject) {
        var results = [];
        var remaining = 0;
        function resolver(index) {
            remaining++;
            return function(value) {
                results[index] = value;
                if (!--remaining) resolve(results);
            };
        }
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === 'function') promise.then(resolver(i), reject);
            else results[i] = promise;
        }
        if (!remaining) resolve(results);
    });
};
$beaa24d3f75cb816$var$P.race = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError('You must pass an array to Promise.race().');
    return new $beaa24d3f75cb816$var$P(function(resolve, reject) {
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === 'function') promise.then(resolve, reject);
            else resolve(promise);
        }
    });
};
$beaa24d3f75cb816$var$P.resolve = function(value) {
    if (value && $beaa24d3f75cb816$var$_typeof(value) === 'object' && value.constructor === $beaa24d3f75cb816$var$P) return value;
    return new $beaa24d3f75cb816$var$P(function(resolve) {
        resolve(value);
    });
};
$beaa24d3f75cb816$var$P.reject = function(reason) {
    return new $beaa24d3f75cb816$var$P(function(resolve, reject) {
        reject(reason);
    });
};
var $beaa24d3f75cb816$var$picked = typeof Promise === 'function' ? Promise : $beaa24d3f75cb816$var$P;
var $beaa24d3f75cb816$var$d = $beaa24d3f75cb816$var$UNITS_IN_GRID;
var $beaa24d3f75cb816$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $beaa24d3f75cb816$var$isReserved(name) {
    return ~$beaa24d3f75cb816$var$RESERVED_CLASSES.indexOf(name);
}
function $beaa24d3f75cb816$var$insertCss(css) {
    if (!css || !$beaa24d3f75cb816$var$IS_DOM) return;
    var style = $beaa24d3f75cb816$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $beaa24d3f75cb816$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $beaa24d3f75cb816$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $beaa24d3f75cb816$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $beaa24d3f75cb816$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $beaa24d3f75cb816$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $beaa24d3f75cb816$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $beaa24d3f75cb816$var$classArray(node) {
    if (node.classList) return $beaa24d3f75cb816$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $beaa24d3f75cb816$var$getIconName(familyPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === familyPrefix && iconName !== '' && !$beaa24d3f75cb816$var$isReserved(iconName)) return iconName;
    else return null;
}
function $beaa24d3f75cb816$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $beaa24d3f75cb816$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($beaa24d3f75cb816$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $beaa24d3f75cb816$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
    }, '');
}
function $beaa24d3f75cb816$var$transformIsMeaningful(transform) {
    return transform.size !== $beaa24d3f75cb816$var$meaninglessTransform.size || transform.x !== $beaa24d3f75cb816$var$meaninglessTransform.x || transform.y !== $beaa24d3f75cb816$var$meaninglessTransform.y || transform.rotate !== $beaa24d3f75cb816$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $beaa24d3f75cb816$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $beaa24d3f75cb816$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $beaa24d3f75cb816$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $beaa24d3f75cb816$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $beaa24d3f75cb816$var$IS_IE) val += "translate(".concat(transform.x / $beaa24d3f75cb816$var$d - width / 2, "em, ").concat(transform.y / $beaa24d3f75cb816$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $beaa24d3f75cb816$var$d, "em), calc(-50% + ").concat(transform.y / $beaa24d3f75cb816$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $beaa24d3f75cb816$var$d, "em, ").concat(transform.y / $beaa24d3f75cb816$var$d, "em) ");
    val += "scale(".concat(transform.size / $beaa24d3f75cb816$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $beaa24d3f75cb816$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $beaa24d3f75cb816$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $beaa24d3f75cb816$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = 'black';
    return _abstract;
}
function $beaa24d3f75cb816$var$deGroup(_abstract) {
    if (_abstract.tag === 'g') return _abstract.children;
    else return [
        _abstract
    ];
}
function $beaa24d3f75cb816$var$makeIconMasking(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
    var mainWidth = main.width, mainPath = main.icon;
    var maskWidth = mask.width, maskPath = mask.icon;
    var trans = $beaa24d3f75cb816$var$transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
    });
    var maskRect = {
        tag: 'rect',
        attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$ALL_SPACE, {
            fill: 'white'
        })
    };
    var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map($beaa24d3f75cb816$var$fillBlack)
    } : {};
    var maskInnerGroup = {
        tag: 'g',
        attributes: $beaa24d3f75cb816$var$_objectSpread({}, trans.inner),
        children: [
            $beaa24d3f75cb816$var$fillBlack($beaa24d3f75cb816$var$_objectSpread({
                tag: mainPath.tag,
                attributes: $beaa24d3f75cb816$var$_objectSpread({}, mainPath.attributes, trans.path)
            }, maskInnerGroupChildrenMixin))
        ]
    };
    var maskOuterGroup = {
        tag: 'g',
        attributes: $beaa24d3f75cb816$var$_objectSpread({}, trans.outer),
        children: [
            maskInnerGroup
        ]
    };
    var maskId = "mask-".concat(explicitMaskId || $beaa24d3f75cb816$var$nextUniqueId());
    var clipId = "clip-".concat(explicitMaskId || $beaa24d3f75cb816$var$nextUniqueId());
    var maskTag = {
        tag: 'mask',
        attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$ALL_SPACE, {
            id: maskId,
            maskUnits: 'userSpaceOnUse',
            maskContentUnits: 'userSpaceOnUse'
        }),
        children: [
            maskRect,
            maskOuterGroup
        ]
    };
    var defs = {
        tag: 'defs',
        children: [
            {
                tag: 'clipPath',
                attributes: {
                    id: clipId
                },
                children: $beaa24d3f75cb816$var$deGroup(maskPath)
            },
            maskTag
        ]
    };
    children.push(defs, {
        tag: 'rect',
        attributes: $beaa24d3f75cb816$var$_objectSpread({
            fill: 'currentColor',
            'clip-path': "url(#".concat(clipId, ")"),
            mask: "url(#".concat(maskId, ")")
        }, $beaa24d3f75cb816$var$ALL_SPACE)
    });
    return {
        children: children,
        attributes: attributes
    };
}
function $beaa24d3f75cb816$var$makeIconStandard(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, transform = _ref.transform, styles = _ref.styles;
    var styleString = $beaa24d3f75cb816$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    if ($beaa24d3f75cb816$var$transformIsMeaningful(transform)) {
        var trans = $beaa24d3f75cb816$var$transformForSvg({
            transform: transform,
            containerWidth: main.width,
            iconWidth: main.width
        });
        children.push({
            tag: 'g',
            attributes: $beaa24d3f75cb816$var$_objectSpread({}, trans.outer),
            children: [
                {
                    tag: 'g',
                    attributes: $beaa24d3f75cb816$var$_objectSpread({}, trans.inner),
                    children: [
                        {
                            tag: main.icon.tag,
                            children: main.icon.children,
                            attributes: $beaa24d3f75cb816$var$_objectSpread({}, main.icon.attributes, trans.path)
                        }
                    ]
                }
            ]
        });
    } else children.push(main.icon);
    return {
        children: children,
        attributes: attributes
    };
}
function $beaa24d3f75cb816$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($beaa24d3f75cb816$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $beaa24d3f75cb816$var$joinStyles($beaa24d3f75cb816$var$_objectSpread({}, styles, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $beaa24d3f75cb816$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $beaa24d3f75cb816$var$_objectSpread({}, attributes, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $beaa24d3f75cb816$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === 'fak';
    var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
    var attrClass = [
        $beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass,
        iconName ? "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : '',
        widthClass
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $beaa24d3f75cb816$var$_objectSpread({}, extra.attributes, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            role: extra.attributes.role || 'img',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$beaa24d3f75cb816$var$DATA_FA_I2SVG] = '';
    if (title) content.children.push({
        tag: 'title',
        attributes: {
            id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $beaa24d3f75cb816$var$nextUniqueId())
        },
        children: [
            title
        ]
    });
    var args = $beaa24d3f75cb816$var$_objectSpread({}, content, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $beaa24d3f75cb816$var$_objectSpread({}, uploadedIconWidthStyle, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $beaa24d3f75cb816$var$makeIconMasking(args) : $beaa24d3f75cb816$var$makeIconStandard(args), children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $beaa24d3f75cb816$var$asSymbol(args);
    else return $beaa24d3f75cb816$var$asIcon(args);
}
function $beaa24d3f75cb816$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $beaa24d3f75cb816$var$_objectSpread({}, extra.attributes, title ? {
        title: title
    } : {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$beaa24d3f75cb816$var$DATA_FA_I2SVG] = '';
    var styles = $beaa24d3f75cb816$var$_objectSpread({}, extra.styles);
    if ($beaa24d3f75cb816$var$transformIsMeaningful(transform)) {
        styles['transform'] = $beaa24d3f75cb816$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $beaa24d3f75cb816$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            "class": 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $beaa24d3f75cb816$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $beaa24d3f75cb816$var$_objectSpread({}, extra.attributes, title ? {
        title: title
    } : {}, {
        'class': extra.classes.join(' ')
    });
    var styleString = $beaa24d3f75cb816$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            "class": 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
var $beaa24d3f75cb816$var$noop$1 = function noop() {};
var $beaa24d3f75cb816$var$p = $beaa24d3f75cb816$export$e506a1d27d1eaa20.measurePerformance && $beaa24d3f75cb816$var$PERFORMANCE && $beaa24d3f75cb816$var$PERFORMANCE.mark && $beaa24d3f75cb816$var$PERFORMANCE.measure ? $beaa24d3f75cb816$var$PERFORMANCE : {
    mark: $beaa24d3f75cb816$var$noop$1,
    measure: $beaa24d3f75cb816$var$noop$1
};
var $beaa24d3f75cb816$var$preamble = "FA \"5.15.4\"";
var $beaa24d3f75cb816$var$begin = function begin(name) {
    $beaa24d3f75cb816$var$p.mark("".concat($beaa24d3f75cb816$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $beaa24d3f75cb816$var$end(name);
    };
};
var $beaa24d3f75cb816$var$end = function end(name) {
    $beaa24d3f75cb816$var$p.mark("".concat($beaa24d3f75cb816$var$preamble, " ").concat(name, " ends"));
    $beaa24d3f75cb816$var$p.measure("".concat($beaa24d3f75cb816$var$preamble, " ").concat(name), "".concat($beaa24d3f75cb816$var$preamble, " ").concat(name, " begins"), "".concat($beaa24d3f75cb816$var$preamble, " ").concat(name, " ends"));
};
var $beaa24d3f75cb816$var$perf = {
    begin: $beaa24d3f75cb816$var$begin,
    end: $beaa24d3f75cb816$var$end
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $beaa24d3f75cb816$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $beaa24d3f75cb816$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $beaa24d3f75cb816$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
function $beaa24d3f75cb816$var$toHex(unicode) {
    var result = '';
    for(var i = 0; i < unicode.length; i++){
        var hex = unicode.charCodeAt(i).toString(16);
        result += ('000' + hex).slice(-4);
    }
    return result;
}
function $beaa24d3f75cb816$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
    if (typeof $beaa24d3f75cb816$var$namespace.hooks.addPack === 'function' && !skipHooks) $beaa24d3f75cb816$var$namespace.hooks.addPack(prefix, normalized);
    else $beaa24d3f75cb816$var$namespace.styles[prefix] = $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$namespace.styles[prefix] || {}, normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $beaa24d3f75cb816$var$defineIcons('fa', icons);
}
var $beaa24d3f75cb816$var$styles = $beaa24d3f75cb816$var$namespace.styles, $beaa24d3f75cb816$var$shims = $beaa24d3f75cb816$var$namespace.shims;
var $beaa24d3f75cb816$var$_byUnicode = {};
var $beaa24d3f75cb816$var$_byLigature = {};
var $beaa24d3f75cb816$var$_byOldName = {};
var $beaa24d3f75cb816$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $beaa24d3f75cb816$var$reduce($beaa24d3f75cb816$var$styles, function(o, style, prefix) {
            o[prefix] = $beaa24d3f75cb816$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $beaa24d3f75cb816$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        return acc;
    });
    $beaa24d3f75cb816$var$_byLigature = lookup(function(acc, icon, iconName) {
        var ligatures = icon[2];
        acc[iconName] = iconName;
        ligatures.forEach(function(ligature) {
            acc[ligature] = iconName;
        });
        return acc;
    });
    var hasRegular = 'far' in $beaa24d3f75cb816$var$styles;
    $beaa24d3f75cb816$var$_byOldName = $beaa24d3f75cb816$var$reduce($beaa24d3f75cb816$var$shims, function(acc, shim) {
        var oldName = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        acc[oldName] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {});
};
$beaa24d3f75cb816$var$build();
function $beaa24d3f75cb816$var$byUnicode(prefix, unicode) {
    return ($beaa24d3f75cb816$var$_byUnicode[prefix] || {})[unicode];
}
function $beaa24d3f75cb816$var$byLigature(prefix, ligature) {
    return ($beaa24d3f75cb816$var$_byLigature[prefix] || {})[ligature];
}
function $beaa24d3f75cb816$var$byOldName(name) {
    return $beaa24d3f75cb816$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
var $beaa24d3f75cb816$var$styles$1 = $beaa24d3f75cb816$var$namespace.styles;
var $beaa24d3f75cb816$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $beaa24d3f75cb816$var$getCanonicalIcon(values) {
    return values.reduce(function(acc, cls) {
        var iconName = $beaa24d3f75cb816$var$getIconName($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, cls);
        if ($beaa24d3f75cb816$var$styles$1[cls]) acc.prefix = cls;
        else if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoFetchSvg && Object.keys($beaa24d3f75cb816$var$PREFIX_TO_STYLE).indexOf(cls) > -1) acc.prefix = cls;
        else if (iconName) {
            var shim = acc.prefix === 'fa' ? $beaa24d3f75cb816$var$byOldName(iconName) : {};
            acc.iconName = shim.iconName || iconName;
            acc.prefix = shim.prefix || acc.prefix;
        } else if (cls !== $beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass && cls.indexOf('fa-w-') !== 0) acc.rest.push(cls);
        return acc;
    }, $beaa24d3f75cb816$var$emptyCanonicalIcon());
}
function $beaa24d3f75cb816$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
function $beaa24d3f75cb816$export$a10125c086a4df16(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $beaa24d3f75cb816$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($beaa24d3f75cb816$var$joinAttributes(attributes), ">").concat(children.map($beaa24d3f75cb816$export$a10125c086a4df16).join(''), "</").concat(tag, ">");
}
var $beaa24d3f75cb816$var$noop$2 = function noop() {};
function $beaa24d3f75cb816$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($beaa24d3f75cb816$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $beaa24d3f75cb816$var$getMutator() {
    if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoReplaceSvg === true) return $beaa24d3f75cb816$var$mutators.replace;
    var mutator = $beaa24d3f75cb816$var$mutators[$beaa24d3f75cb816$export$e506a1d27d1eaa20.autoReplaceSvg];
    return mutator || $beaa24d3f75cb816$var$mutators.replace;
}
var $beaa24d3f75cb816$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        var _abstract = mutation[1];
        var newOuterHTML = _abstract.map(function(a) {
            return $beaa24d3f75cb816$export$a10125c086a4df16(a);
        }).join('\n');
        if (node.parentNode && node.outerHTML) node.outerHTML = newOuterHTML + ($beaa24d3f75cb816$export$e506a1d27d1eaa20.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? "<!-- ".concat(node.outerHTML, " Font Awesome fontawesome.com -->") : '');
        else if (node.parentNode) {
            var newNode = document.createElement('span');
            node.parentNode.replaceChild(newNode, node);
            newNode.outerHTML = newOuterHTML;
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$beaa24d3f75cb816$var$classArray(node).indexOf($beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass)) return $beaa24d3f75cb816$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-.*"));
        delete _abstract[0].attributes.style;
        delete _abstract[0].attributes.id;
        var splitClasses = _abstract[0].attributes["class"].split(' ').reduce(function(acc, cls) {
            if (cls === $beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
            else acc.toNode.push(cls);
            return acc;
        }, {
            toNode: [],
            toSvg: []
        });
        _abstract[0].attributes["class"] = splitClasses.toSvg.join(' ');
        var newInnerHTML = _abstract.map(function(a) {
            return $beaa24d3f75cb816$export$a10125c086a4df16(a);
        }).join('\n');
        node.setAttribute('class', splitClasses.toNode.join(' '));
        node.setAttribute($beaa24d3f75cb816$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $beaa24d3f75cb816$var$performOperationSync(op) {
    op();
}
function $beaa24d3f75cb816$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $beaa24d3f75cb816$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $beaa24d3f75cb816$var$performOperationSync;
        if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.mutateApproach === $beaa24d3f75cb816$var$MUTATION_APPROACH_ASYNC) frame = $beaa24d3f75cb816$var$WINDOW.requestAnimationFrame || $beaa24d3f75cb816$var$performOperationSync;
        frame(function() {
            var mutator = $beaa24d3f75cb816$var$getMutator();
            var mark = $beaa24d3f75cb816$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $beaa24d3f75cb816$var$disabled = false;
function $beaa24d3f75cb816$var$disableObservation() {
    $beaa24d3f75cb816$var$disabled = true;
}
function $beaa24d3f75cb816$var$enableObservation() {
    $beaa24d3f75cb816$var$disabled = false;
}
var $beaa24d3f75cb816$var$mo = null;
function $beaa24d3f75cb816$var$observe(options) {
    if (!$beaa24d3f75cb816$var$MUTATION_OBSERVER) return;
    if (!$beaa24d3f75cb816$export$e506a1d27d1eaa20.observeMutations) return;
    var treeCallback = options.treeCallback, nodeCallback = options.nodeCallback, pseudoElementsCallback = options.pseudoElementsCallback, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $beaa24d3f75cb816$var$DOCUMENT : _options$observeMutat;
    $beaa24d3f75cb816$var$mo = new $beaa24d3f75cb816$var$MUTATION_OBSERVER(function(objects) {
        if ($beaa24d3f75cb816$var$disabled) return;
        $beaa24d3f75cb816$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$beaa24d3f75cb816$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $beaa24d3f75cb816$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $beaa24d3f75cb816$var$isWatched(mutationRecord.target) && ~$beaa24d3f75cb816$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class') {
                    var _getCanonicalIcon = $beaa24d3f75cb816$var$getCanonicalIcon($beaa24d3f75cb816$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
                    if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
                } else nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$beaa24d3f75cb816$var$IS_DOM) return;
    $beaa24d3f75cb816$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $beaa24d3f75cb816$var$disconnect() {
    if (!$beaa24d3f75cb816$var$mo) return;
    $beaa24d3f75cb816$var$mo.disconnect();
}
function $beaa24d3f75cb816$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $beaa24d3f75cb816$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $beaa24d3f75cb816$var$getCanonicalIcon($beaa24d3f75cb816$var$classArray(node));
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.prefix && innerText.length > 1) val.iconName = $beaa24d3f75cb816$var$byLigature(val.prefix, node.innerText);
    else if (val.prefix && innerText.length === 1) val.iconName = $beaa24d3f75cb816$var$byUnicode(val.prefix, $beaa24d3f75cb816$var$toHex(node.innerText));
    return val;
}
var $beaa24d3f75cb816$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    if (!transformString) return transform;
    else return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
function $beaa24d3f75cb816$var$transformParser(node) {
    return $beaa24d3f75cb816$var$parseTransformString(node.getAttribute('data-fa-transform'));
}
function $beaa24d3f75cb816$var$symbolParser(node) {
    var symbol = node.getAttribute('data-fa-symbol');
    return symbol === null ? false : symbol === '' ? true : symbol;
}
function $beaa24d3f75cb816$var$attributesParser(node) {
    var extraAttributes = $beaa24d3f75cb816$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');
    if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $beaa24d3f75cb816$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $beaa24d3f75cb816$var$maskParser(node) {
    var mask = node.getAttribute('data-fa-mask');
    if (!mask) return $beaa24d3f75cb816$var$emptyCanonicalIcon();
    else return $beaa24d3f75cb816$var$getCanonicalIcon(mask.split(' ').map(function(i) {
        return i.trim();
    }));
}
function $beaa24d3f75cb816$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $beaa24d3f75cb816$var$meaninglessTransform,
        symbol: false,
        mask: null,
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $beaa24d3f75cb816$var$parseMeta(node) {
    var _classParser = $beaa24d3f75cb816$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraStyles = $beaa24d3f75cb816$var$styleParser(node);
    var transform = $beaa24d3f75cb816$var$transformParser(node);
    var symbol = $beaa24d3f75cb816$var$symbolParser(node);
    var extraAttributes = $beaa24d3f75cb816$var$attributesParser(node);
    var mask = $beaa24d3f75cb816$var$maskParser(node);
    return {
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: transform,
        symbol: symbol,
        mask: mask,
        maskId: node.getAttribute('data-fa-mask-id'),
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    };
}
function $beaa24d3f75cb816$var$MissingIcon(error) {
    this.name = 'MissingIcon';
    this.message = error || 'Icon unavailable';
    this.stack = new Error().stack;
}
$beaa24d3f75cb816$var$MissingIcon.prototype = Object.create(Error.prototype);
$beaa24d3f75cb816$var$MissingIcon.prototype.constructor = $beaa24d3f75cb816$var$MissingIcon;
var $beaa24d3f75cb816$var$FILL = {
    fill: 'currentColor'
};
var $beaa24d3f75cb816$var$ANIMATION_BASE = {
    attributeType: 'XML',
    repeatCount: 'indefinite',
    dur: '2s'
};
var $beaa24d3f75cb816$var$RING = {
    tag: 'path',
    attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$FILL, {
        d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
    })
};
var $beaa24d3f75cb816$var$OPACITY_ANIMATE = $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$ANIMATION_BASE, {
    attributeName: 'opacity'
});
var $beaa24d3f75cb816$var$DOT = {
    tag: 'circle',
    attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$FILL, {
        cx: '256',
        cy: '364',
        r: '28'
    }),
    children: [
        {
            tag: 'animate',
            attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$ANIMATION_BASE, {
                attributeName: 'r',
                values: '28;14;28;28;14;28;'
            })
        },
        {
            tag: 'animate',
            attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$OPACITY_ANIMATE, {
                values: '1;0;1;1;0;1;'
            })
        }
    ]
};
var $beaa24d3f75cb816$var$QUESTION = {
    tag: 'path',
    attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$FILL, {
        opacity: '1',
        d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
    }),
    children: [
        {
            tag: 'animate',
            attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$OPACITY_ANIMATE, {
                values: '1;0;0;0;0;1;'
            })
        }
    ]
};
var $beaa24d3f75cb816$var$EXCLAMATION = {
    tag: 'path',
    attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$FILL, {
        opacity: '0',
        d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
    }),
    children: [
        {
            tag: 'animate',
            attributes: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$OPACITY_ANIMATE, {
                values: '0;0;1;1;0;0;'
            })
        }
    ]
};
var $beaa24d3f75cb816$var$missing = {
    tag: 'g',
    children: [
        $beaa24d3f75cb816$var$RING,
        $beaa24d3f75cb816$var$DOT,
        $beaa24d3f75cb816$var$QUESTION,
        $beaa24d3f75cb816$var$EXCLAMATION
    ]
};
var $beaa24d3f75cb816$var$styles$2 = $beaa24d3f75cb816$var$namespace.styles;
function $beaa24d3f75cb816$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $beaa24d3f75cb816$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            "class": "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-").concat($beaa24d3f75cb816$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    "class": "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-").concat($beaa24d3f75cb816$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    "class": "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-").concat($beaa24d3f75cb816$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
function $beaa24d3f75cb816$var$findIcon(iconName, prefix) {
    return new $beaa24d3f75cb816$var$picked(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $beaa24d3f75cb816$var$missing
        };
        if (iconName && prefix && $beaa24d3f75cb816$var$styles$2[prefix] && $beaa24d3f75cb816$var$styles$2[prefix][iconName]) {
            var icon = $beaa24d3f75cb816$var$styles$2[prefix][iconName];
            return resolve($beaa24d3f75cb816$var$asFoundIcon(icon));
        }
        if (iconName && prefix && !$beaa24d3f75cb816$export$e506a1d27d1eaa20.showMissingIcons) reject(new $beaa24d3f75cb816$var$MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
        else resolve(val);
    });
}
var $beaa24d3f75cb816$var$styles$3 = $beaa24d3f75cb816$var$namespace.styles;
function $beaa24d3f75cb816$var$generateSvgReplacementMutation(node, nodeMeta) {
    var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
    return new $beaa24d3f75cb816$var$picked(function(resolve, reject) {
        $beaa24d3f75cb816$var$picked.all([
            $beaa24d3f75cb816$var$findIcon(iconName, prefix),
            $beaa24d3f75cb816$var$findIcon(mask.iconName, mask.prefix)
        ]).then(function(_ref) {
            var _ref2 = $beaa24d3f75cb816$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
            resolve([
                node,
                $beaa24d3f75cb816$var$makeInlineSvgAbstract({
                    icons: {
                        main: main,
                        mask: mask
                    },
                    prefix: prefix,
                    iconName: iconName,
                    transform: transform,
                    symbol: symbol,
                    mask: mask,
                    maskId: maskId,
                    title: title,
                    titleId: titleId,
                    extra: extra,
                    watchable: true
                })
            ]);
        });
    });
}
function $beaa24d3f75cb816$var$generateLayersText(node, nodeMeta) {
    var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
    var width = null;
    var height = null;
    if ($beaa24d3f75cb816$var$IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
    }
    if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
    return $beaa24d3f75cb816$var$picked.resolve([
        node,
        $beaa24d3f75cb816$var$makeLayersTextAbstract({
            content: node.innerHTML,
            width: width,
            height: height,
            transform: transform,
            title: title,
            extra: extra,
            watchable: true
        })
    ]);
}
function $beaa24d3f75cb816$var$generateMutation(node) {
    var nodeMeta = $beaa24d3f75cb816$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($beaa24d3f75cb816$var$LAYERS_TEXT_CLASSNAME)) return $beaa24d3f75cb816$var$generateLayersText(node, nodeMeta);
    else return $beaa24d3f75cb816$var$generateSvgReplacementMutation(node, nodeMeta);
}
function $beaa24d3f75cb816$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$beaa24d3f75cb816$var$IS_DOM) return;
    var htmlClassList = $beaa24d3f75cb816$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($beaa24d3f75cb816$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($beaa24d3f75cb816$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $beaa24d3f75cb816$export$e506a1d27d1eaa20.autoFetchSvg ? Object.keys($beaa24d3f75cb816$var$PREFIX_TO_STYLE) : Object.keys($beaa24d3f75cb816$var$styles$3);
    var prefixesDomQuery = [
        ".".concat($beaa24d3f75cb816$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($beaa24d3f75cb816$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($beaa24d3f75cb816$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return;
    var candidates = [];
    try {
        candidates = $beaa24d3f75cb816$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return;
    var mark = $beaa24d3f75cb816$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $beaa24d3f75cb816$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$beaa24d3f75cb816$var$PRODUCTION) {
                if (e instanceof $beaa24d3f75cb816$var$MissingIcon) console.error(e);
            }
        }
        return acc;
    }, []);
    return new $beaa24d3f75cb816$var$picked(function(resolve, reject) {
        $beaa24d3f75cb816$var$picked.all(mutations).then(function(resolvedMutations) {
            $beaa24d3f75cb816$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        })["catch"](function() {
            mark();
            reject();
        });
    });
}
function $beaa24d3f75cb816$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $beaa24d3f75cb816$var$generateMutation(node).then(function(mutation) {
        if (mutation) $beaa24d3f75cb816$var$perform([
            mutation
        ], callback);
    });
}
function $beaa24d3f75cb816$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($beaa24d3f75cb816$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new $beaa24d3f75cb816$var$picked(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $beaa24d3f75cb816$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($beaa24d3f75cb816$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $beaa24d3f75cb816$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family').match($beaa24d3f75cb816$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = ~[
                'Solid',
                'Regular',
                'Light',
                'Duotone',
                'Brands',
                'Kit'
            ].indexOf(fontFamily[2]) ? $beaa24d3f75cb816$var$STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : $beaa24d3f75cb816$var$FONT_WEIGHT_TO_PREFIX[fontWeight];
            var hexValue = $beaa24d3f75cb816$var$toHex(_content.length === 3 ? _content.substr(1, 1) : _content);
            var iconName = $beaa24d3f75cb816$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($beaa24d3f75cb816$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($beaa24d3f75cb816$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $beaa24d3f75cb816$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$beaa24d3f75cb816$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $beaa24d3f75cb816$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $beaa24d3f75cb816$var$makeInlineSvgAbstract($beaa24d3f75cb816$var$_objectSpread({}, meta, {
                        icons: {
                            main: main,
                            mask: $beaa24d3f75cb816$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $beaa24d3f75cb816$var$DOCUMENT.createElement('svg');
                    if (position === ':before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $beaa24d3f75cb816$export$a10125c086a4df16(a);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                })["catch"](reject);
            } else resolve();
        } else resolve();
    });
}
function $beaa24d3f75cb816$var$replace(node) {
    return $beaa24d3f75cb816$var$picked.all([
        $beaa24d3f75cb816$var$replaceForPosition(node, ':before'),
        $beaa24d3f75cb816$var$replaceForPosition(node, ':after')
    ]);
}
function $beaa24d3f75cb816$var$processable(node) {
    return node.parentNode !== document.head && !~$beaa24d3f75cb816$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($beaa24d3f75cb816$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $beaa24d3f75cb816$var$searchPseudoElements(root) {
    if (!$beaa24d3f75cb816$var$IS_DOM) return;
    return new $beaa24d3f75cb816$var$picked(function(resolve, reject) {
        var operations = $beaa24d3f75cb816$var$toArray(root.querySelectorAll('*')).filter($beaa24d3f75cb816$var$processable).map($beaa24d3f75cb816$var$replace);
        var end = $beaa24d3f75cb816$var$perf.begin('searchPseudoElements');
        $beaa24d3f75cb816$var$disableObservation();
        $beaa24d3f75cb816$var$picked.all(operations).then(function() {
            end();
            $beaa24d3f75cb816$var$enableObservation();
            resolve();
        })["catch"](function() {
            end();
            $beaa24d3f75cb816$var$enableObservation();
            reject();
        });
    });
}
var $beaa24d3f75cb816$var$baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";
function $beaa24d3f75cb816$var$css() {
    var dfp = $beaa24d3f75cb816$var$DEFAULT_FAMILY_PREFIX;
    var drc = $beaa24d3f75cb816$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix;
    var rc = $beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass;
    var s = $beaa24d3f75cb816$var$baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $beaa24d3f75cb816$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $beaa24d3f75cb816$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $beaa24d3f75cb816$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $beaa24d3f75cb816$var$_objectSpread({}, _this.definitions[key] || {}, additions[key]);
                    $beaa24d3f75cb816$var$defineIcons(key, additions[key]);
                    $beaa24d3f75cb816$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    if (!additions[prefix]) additions[prefix] = {};
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
function $beaa24d3f75cb816$var$ensureCss() {
    if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoAddCss && !$beaa24d3f75cb816$var$_cssInserted) {
        $beaa24d3f75cb816$var$insertCss($beaa24d3f75cb816$var$css());
        $beaa24d3f75cb816$var$_cssInserted = true;
    }
}
function $beaa24d3f75cb816$var$apiObject(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val["abstract"].map(function(a) {
                return $beaa24d3f75cb816$export$a10125c086a4df16(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$beaa24d3f75cb816$var$IS_DOM) return;
            var container = $beaa24d3f75cb816$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $beaa24d3f75cb816$export$221fed4a47f597a5(iconLookup) {
    var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix, iconName = iconLookup.iconName;
    if (!iconName) return;
    return $beaa24d3f75cb816$var$iconFromMapping($beaa24d3f75cb816$export$b839f963c7dc0e34.definitions, prefix, iconName) || $beaa24d3f75cb816$var$iconFromMapping($beaa24d3f75cb816$var$namespace.styles, prefix, iconName);
}
function $beaa24d3f75cb816$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $beaa24d3f75cb816$export$221fed4a47f597a5(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $beaa24d3f75cb816$export$221fed4a47f597a5(mask || {});
        return next(iconDefinition, $beaa24d3f75cb816$var$_objectSpread({}, params, {
            mask: mask
        }));
    };
}
var $beaa24d3f75cb816$export$b839f963c7dc0e34 = new $beaa24d3f75cb816$var$Library();
var $beaa24d3f75cb816$export$4f8e844b2782642c = function noAuto() {
    $beaa24d3f75cb816$export$e506a1d27d1eaa20.autoReplaceSvg = false;
    $beaa24d3f75cb816$export$e506a1d27d1eaa20.observeMutations = false;
    $beaa24d3f75cb816$var$disconnect();
};
var $beaa24d3f75cb816$var$_cssInserted = false;
var $beaa24d3f75cb816$export$df3a06d6289f983e = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($beaa24d3f75cb816$var$IS_DOM) {
            $beaa24d3f75cb816$var$ensureCss();
            var _params$node = params.node, node = _params$node === void 0 ? $beaa24d3f75cb816$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.searchPseudoElements) $beaa24d3f75cb816$var$searchPseudoElements(node);
            return $beaa24d3f75cb816$var$onTree(node, callback);
        } else return $beaa24d3f75cb816$var$picked.reject('Operation requires a DOM of some kind.');
    },
    css: $beaa24d3f75cb816$var$css,
    insertCss: function insertCss$$1() {
        if (!$beaa24d3f75cb816$var$_cssInserted) {
            $beaa24d3f75cb816$var$insertCss($beaa24d3f75cb816$var$css());
            $beaa24d3f75cb816$var$_cssInserted = true;
        }
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot, observeMutationsRoot = params.observeMutationsRoot;
        if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoReplaceSvg === false) $beaa24d3f75cb816$export$e506a1d27d1eaa20.autoReplaceSvg = true;
        $beaa24d3f75cb816$export$e506a1d27d1eaa20.observeMutations = true;
        $beaa24d3f75cb816$var$domready(function() {
            $beaa24d3f75cb816$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $beaa24d3f75cb816$var$observe({
                treeCallback: $beaa24d3f75cb816$var$onTree,
                nodeCallback: $beaa24d3f75cb816$var$onNode,
                pseudoElementsCallback: $beaa24d3f75cb816$var$searchPseudoElements,
                observeMutationsRoot: observeMutationsRoot
            });
        });
    }
};
var $beaa24d3f75cb816$export$98e6a39c04603d36 = {
    transform: function transform(transformString) {
        return $beaa24d3f75cb816$var$parseTransformString(transformString);
    }
};
var $beaa24d3f75cb816$export$1ca1ec8b29a4ce27 = $beaa24d3f75cb816$var$resolveIcons(function(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $beaa24d3f75cb816$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $beaa24d3f75cb816$var$apiObject($beaa24d3f75cb816$var$_objectSpread({
        type: 'icon'
    }, iconDefinition), function() {
        $beaa24d3f75cb816$var$ensureCss();
        if ($beaa24d3f75cb816$export$e506a1d27d1eaa20.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $beaa24d3f75cb816$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $beaa24d3f75cb816$var$makeInlineSvgAbstract({
            icons: {
                main: $beaa24d3f75cb816$var$asFoundIcon(icon),
                mask: mask ? $beaa24d3f75cb816$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$meaninglessTransform, transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
});
var $beaa24d3f75cb816$export$6f093cfa640b7166 = function text(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform2 = params.transform, transform = _params$transform2 === void 0 ? $beaa24d3f75cb816$var$meaninglessTransform : _params$transform2, _params$title2 = params.title, title = _params$title2 === void 0 ? null : _params$title2, _params$classes2 = params.classes, classes = _params$classes2 === void 0 ? [] : _params$classes2, _params$attributes2 = params.attributes, attributes = _params$attributes2 === void 0 ? {} : _params$attributes2, _params$styles2 = params.styles, styles = _params$styles2 === void 0 ? {} : _params$styles2;
    return $beaa24d3f75cb816$var$apiObject({
        type: 'text',
        content: content
    }, function() {
        $beaa24d3f75cb816$var$ensureCss();
        return $beaa24d3f75cb816$var$makeLayersTextAbstract({
            content: content,
            transform: $beaa24d3f75cb816$var$_objectSpread({}, $beaa24d3f75cb816$var$meaninglessTransform, transform),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-layers-text")
                ].concat($beaa24d3f75cb816$var$_toConsumableArray(classes))
            }
        });
    });
};
var $beaa24d3f75cb816$export$e575061ef2a070eb = function counter(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$title3 = params.title, title = _params$title3 === void 0 ? null : _params$title3, _params$classes3 = params.classes, classes = _params$classes3 === void 0 ? [] : _params$classes3, _params$attributes3 = params.attributes, attributes = _params$attributes3 === void 0 ? {} : _params$attributes3, _params$styles3 = params.styles, styles = _params$styles3 === void 0 ? {} : _params$styles3;
    return $beaa24d3f75cb816$var$apiObject({
        type: 'counter',
        content: content
    }, function() {
        $beaa24d3f75cb816$var$ensureCss();
        return $beaa24d3f75cb816$var$makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-layers-counter")
                ].concat($beaa24d3f75cb816$var$_toConsumableArray(classes))
            }
        });
    });
};
var $beaa24d3f75cb816$export$50a222d9023da98b = function layer(assembler) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$classes4 = params.classes, classes = _params$classes4 === void 0 ? [] : _params$classes4;
    return $beaa24d3f75cb816$var$apiObject({
        type: 'layer'
    }, function() {
        $beaa24d3f75cb816$var$ensureCss();
        var children = [];
        assembler(function(args) {
            Array.isArray(args) ? args.map(function(a) {
                children = children.concat(a["abstract"]);
            }) : children = children.concat(args["abstract"]);
        });
        return [
            {
                tag: 'span',
                attributes: {
                    "class": [
                        "".concat($beaa24d3f75cb816$export$e506a1d27d1eaa20.familyPrefix, "-layers")
                    ].concat($beaa24d3f75cb816$var$_toConsumableArray(classes)).join(' ')
                },
                children: children
            }
        ];
    });
};
var $beaa24d3f75cb816$var$api = {
    noAuto: $beaa24d3f75cb816$export$4f8e844b2782642c,
    config: $beaa24d3f75cb816$export$e506a1d27d1eaa20,
    dom: $beaa24d3f75cb816$export$df3a06d6289f983e,
    library: $beaa24d3f75cb816$export$b839f963c7dc0e34,
    parse: $beaa24d3f75cb816$export$98e6a39c04603d36,
    findIconDefinition: $beaa24d3f75cb816$export$221fed4a47f597a5,
    icon: $beaa24d3f75cb816$export$1ca1ec8b29a4ce27,
    text: $beaa24d3f75cb816$export$6f093cfa640b7166,
    counter: $beaa24d3f75cb816$export$e575061ef2a070eb,
    layer: $beaa24d3f75cb816$export$50a222d9023da98b,
    toHtml: $beaa24d3f75cb816$export$a10125c086a4df16
};
var $beaa24d3f75cb816$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $beaa24d3f75cb816$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($beaa24d3f75cb816$var$namespace.styles).length > 0 || $beaa24d3f75cb816$export$e506a1d27d1eaa20.autoFetchSvg) && $beaa24d3f75cb816$var$IS_DOM && $beaa24d3f75cb816$export$e506a1d27d1eaa20.autoReplaceSvg) $beaa24d3f75cb816$var$api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};




var $hAGkE = parcelRequire("hAGkE");
function $33fbd4d6d0180c34$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $33fbd4d6d0180c34$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $33fbd4d6d0180c34$var$ownKeys(Object(source), !0).forEach(function(key) {
            $33fbd4d6d0180c34$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $33fbd4d6d0180c34$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $33fbd4d6d0180c34$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $33fbd4d6d0180c34$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $33fbd4d6d0180c34$var$_typeof(obj);
}
function $33fbd4d6d0180c34$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $33fbd4d6d0180c34$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $33fbd4d6d0180c34$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $33fbd4d6d0180c34$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $33fbd4d6d0180c34$var$_toConsumableArray(arr) {
    return $33fbd4d6d0180c34$var$_arrayWithoutHoles(arr) || $33fbd4d6d0180c34$var$_iterableToArray(arr) || $33fbd4d6d0180c34$var$_unsupportedIterableToArray(arr) || $33fbd4d6d0180c34$var$_nonIterableSpread();
}
function $33fbd4d6d0180c34$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $33fbd4d6d0180c34$var$_arrayLikeToArray(arr);
}
function $33fbd4d6d0180c34$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $33fbd4d6d0180c34$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $33fbd4d6d0180c34$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $33fbd4d6d0180c34$var$_arrayLikeToArray(o, minLen);
}
function $33fbd4d6d0180c34$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $33fbd4d6d0180c34$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $33fbd4d6d0180c34$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        'fa-beat': beat,
        'fa-fade': fade,
        'fa-beat-fade': beatFade,
        'fa-bounce': bounce,
        'fa-shake': shake,
        'fa-flash': flash,
        'fa-spin': spin,
        'fa-spin-reverse': spinReverse,
        'fa-spin-pulse': spinPulse,
        'fa-pulse': pulse,
        'fa-fw': fixedWidth,
        'fa-inverse': inverse,
        'fa-border': border,
        'fa-li': listItem,
        'fa-flip': flip === true,
        'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
        'fa-flip-vertical': flip === 'vertical' || flip === 'both'
    }, $33fbd4d6d0180c34$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), $33fbd4d6d0180c34$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), $33fbd4d6d0180c34$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), $33fbd4d6d0180c34$var$_defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $33fbd4d6d0180c34$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $33fbd4d6d0180c34$var$camelize(string) {
    if ($33fbd4d6d0180c34$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : '';
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $33fbd4d6d0180c34$var$_excluded$1 = [
    "style"
];
function $33fbd4d6d0180c34$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $33fbd4d6d0180c34$var$styleToObject(style) {
    return style.split(';').map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(':');
        var prop = $33fbd4d6d0180c34$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith('webkit') ? acc[$33fbd4d6d0180c34$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $33fbd4d6d0180c34$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === 'string') return element;
    var children = (element.children || []).map(function(child) {
        return $33fbd4d6d0180c34$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case 'class':
                acc.attrs['className'] = val;
                delete element.attributes['class'];
                break;
            case 'style':
                acc.attrs['style'] = $33fbd4d6d0180c34$var$styleToObject(val);
                break;
            default:
                if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$33fbd4d6d0180c34$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $33fbd4d6d0180c34$var$_objectWithoutProperties(extraProps, $33fbd4d6d0180c34$var$_excluded$1);
    mixins.attrs['style'] = $33fbd4d6d0180c34$var$_objectSpread2($33fbd4d6d0180c34$var$_objectSpread2({}, mixins.attrs['style']), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $33fbd4d6d0180c34$var$_objectSpread2($33fbd4d6d0180c34$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($33fbd4d6d0180c34$var$_toConsumableArray(children)));
}
var $33fbd4d6d0180c34$var$PRODUCTION = false;
try {
    $33fbd4d6d0180c34$var$PRODUCTION = true;
} catch (e) {}
function $33fbd4d6d0180c34$var$log() {
    if (!$33fbd4d6d0180c34$var$PRODUCTION && console && typeof console.error === 'function') {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $33fbd4d6d0180c34$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $33fbd4d6d0180c34$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $beaa24d3f75cb816$export$98e6a39c04603d36).icon) return (0, $beaa24d3f75cb816$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $33fbd4d6d0180c34$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === 'string') return {
        prefix: 'fas',
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $33fbd4d6d0180c34$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $33fbd4d6d0180c34$var$_defineProperty({}, key, value) : {};
}
var $33fbd4d6d0180c34$var$_excluded = [
    "forwardedRef"
];
function $33fbd4d6d0180c34$export$2b9260d4a45c8710(_ref) {
    var forwardedRef = _ref.forwardedRef, props = $33fbd4d6d0180c34$var$_objectWithoutProperties(_ref, $33fbd4d6d0180c34$var$_excluded);
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $33fbd4d6d0180c34$var$normalizeIconArgs(iconArgs);
    var classes = $33fbd4d6d0180c34$var$objectWithKey('classes', [].concat($33fbd4d6d0180c34$var$_toConsumableArray($33fbd4d6d0180c34$var$classList(props)), $33fbd4d6d0180c34$var$_toConsumableArray(className.split(' '))));
    var transform = $33fbd4d6d0180c34$var$objectWithKey('transform', typeof props.transform === 'string' ? (0, $beaa24d3f75cb816$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $33fbd4d6d0180c34$var$objectWithKey('mask', $33fbd4d6d0180c34$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $beaa24d3f75cb816$export$1ca1ec8b29a4ce27)(iconLookup, $33fbd4d6d0180c34$var$_objectSpread2($33fbd4d6d0180c34$var$_objectSpread2($33fbd4d6d0180c34$var$_objectSpread2($33fbd4d6d0180c34$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $33fbd4d6d0180c34$var$log('Could not find icon', iconLookup);
        return null;
    }
    var _abstract = renderedIcon["abstract"];
    var extraProps = {
        ref: forwardedRef
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$33fbd4d6d0180c34$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $33fbd4d6d0180c34$var$convertCurry(_abstract[0], extraProps);
}
$33fbd4d6d0180c34$export$2b9260d4a45c8710.displayName = 'FontAwesomeIcon';
$33fbd4d6d0180c34$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOf([
        true,
        false,
        'horizontal',
        'vertical',
        'both'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOf([
        'right',
        'left'
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOf([
        '2xs',
        'xs',
        'sm',
        'lg',
        'xl',
        '2xl',
        '1x',
        '2x',
        '3x',
        '4x',
        '5x',
        '6x',
        '7x',
        '8x',
        '9x',
        '10x'
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool
};
$33fbd4d6d0180c34$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: '',
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: '',
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $33fbd4d6d0180c34$var$convertCurry = $33fbd4d6d0180c34$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement);



function $67c42ed412895136$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border-radius: 12px;\n  background: white;\n  padding: 56px 25px;\n  width: 85%;\n  margin: 0 auto;\n\n  @media ",
        " {\n    width: 550px;\n    padding: 56px 66px;\n    margin-top: calc(20vh - 100px);\n  }\n\n  h1 {\n    margin-bottom: 30px;\n  }\n\n  h4 {\n    font-size: 20px;\n  }\n\n  p {\n    margin-top: 10px;\n    line-height: 1.6em;\n  }\n"
    ]);
    $67c42ed412895136$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $67c42ed412895136$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n"
    ]);
    $67c42ed412895136$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $67c42ed412895136$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: bold;\n  margin: 20px 0 10px 0;\n"
    ]);
    $67c42ed412895136$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $67c42ed412895136$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-decoration: underline;\n  text-align: center;\n  font-weight: 550;\n  text-underline-offset: 2px;\n"
    ]);
    $67c42ed412895136$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $67c42ed412895136$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding-right: 7px;\n"
    ]);
    $67c42ed412895136$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $67c42ed412895136$var$ContentBox = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($67c42ed412895136$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $67c42ed412895136$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($67c42ed412895136$var$_templateObject1());
var $67c42ed412895136$var$MessageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($67c42ed412895136$var$_templateObject2());
var $67c42ed412895136$var$HrefLink = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($67c42ed412895136$var$_templateObject3());
var $67c42ed412895136$export$b62eb5ea790b4398 = function() {
    var SendMagicEmail = function SendMagicEmail() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                            event_label: "Request Magic Link"
                        });
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).magicLink,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).accountInteraction,
                            event_label: "Request"
                        });
                        setIsBusy(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $67c42ed412895136$var$LoginRequest(email)
                        ];
                    case 2:
                        _state.sent();
                        setHasSentEmail(true);
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).magicLink,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).accountInteraction,
                            event_label: "Success"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsBusy(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var DeveloperLogin = function DeveloperLogin() {
        // Mints a fresh magic-login redirect for the fixed test user server-side on every
        // call, rather than baking any credential (password or long-lived token) into the
        // client bundle. The endpoint 303s to /magic-login, which sets the session cookie and
        // redirects on to /dashboard (never available in prod - see
        // mojomortgages/my.mojo.monorepo#5185).
        var redirect = "".concat(location.protocol, "//").concat(location.host, "/dashboard");
        var params = new URLSearchParams({
            redirect: redirect
        });
        location.assign("https://public-auth.mojomortgages.com/dev-login?".concat(params));
    };
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(), 2), emailIsValid = _useState1[0], setEmailIsValid = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasSentEmail = _useState2[0], setHasSentEmail = _useState2[1];
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isBusy = _useState3[0], setIsBusy = _useState3[1];
    var queryParams = new URLSearchParams(location.search);
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/login");
    (0, $hAGkE.useEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Magic Link"
        });
    }, []);
    var disabled = !emailIsValid || hasSentEmail;
    var wasExpired = queryParams.get("expired") === "true";
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $75494c4702aed368$export$78d6b2773a1d5dd8), {
        miniNav: true,
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1949fda065b6ea6a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($67c42ed412895136$var$Container, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $166e000819392ce8$export$85eb2f6ac013e6f4), {
                            style: {
                                zIndex: "100"
                            }
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($67c42ed412895136$var$ContentBox, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h1", {
                                    children: "Log in"
                                }),
                                wasExpired && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($67c42ed412895136$var$ExpiredWarning, {
                                    children: "The link you followed has expired."
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                                    children: "Enter your email and we\u2019ll send you a link to log in"
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $55ca0a6bc334de70$export$20b1d7061d50817f), {
                                    placeholder: "Email address",
                                    value: email,
                                    onChange: function(value) {
                                        return setEmail(value);
                                    },
                                    onIsValidChange: function(isValid) {
                                        return setEmailIsValid(isValid);
                                    },
                                    onEnter: function() {
                                        if (!disabled) SendMagicEmail();
                                    },
                                    onLoaded: function() {
                                        return (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).inputShown,
                                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                                            event_label: "Email Address"
                                        });
                                    },
                                    onFocus: function() {
                                        return (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).fieldFocus,
                                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).formInteraction,
                                            event_label: "Email Address"
                                        });
                                    },
                                    onBlur: function() {
                                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).fieldBlur,
                                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).formInteraction,
                                            event_label: "Email Address"
                                        });
                                        !emailIsValid && (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).validationMessageShown,
                                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                                            event_label: "Email Address - Email address is invalid"
                                        });
                                    }
                                }),
                                hasSentEmail && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($67c42ed412895136$var$MessageContainer, {
                                    children: "Done! Check your inbox for a login link."
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1ca2cdaa0912b6ea$export$e031496191a50201), {
                                    x: 0.5
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                    disabled: disabled,
                                    text: hasSentEmail ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($67c42ed412895136$var$ButtonIconWrapper, {
                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $33fbd4d6d0180c34$export$2b9260d4a45c8710), {
                                                    icon: (0, $72947875341bbd79$export$6f095630677adc)
                                                })
                                            }),
                                            "Sent"
                                        ]
                                    }) : "Send login link",
                                    onClick: SendMagicEmail,
                                    showLoader: isBusy
                                }),
                                hasSentEmail && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                                    children: [
                                        "Can\u2019t see it? ",
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($67c42ed412895136$var$HrefLink, {
                                            onClick: SendMagicEmail,
                                            children: "Send it again"
                                        })
                                    ]
                                }),
                                (0, $10b47c5a212e87a0$export$3fce19fdf0c5de73) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($67c42ed412895136$var$MessageContainer, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($67c42ed412895136$var$HrefLink, {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        onClick: DeveloperLogin,
                                        children: "\uD83D\uDCBB I am devloper"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
function $67c42ed412895136$var$LoginRequest(emailAddress) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var appToCreate, redirect, result, e;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appToCreate = (0, $93b74858bca4b458$export$601241e3cce50c9e)("appData");
                    redirect = null;
                    if (appToCreate) redirect = "/routing-summary?".concat((0, $93b74858bca4b458$export$1e1d235314148489)());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/auth/send-magic-login"), {
                            emailAddress: emailAddress,
                            redirect: redirect
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data.token
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $67c42ed412895136$var$ButtonIconWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span($67c42ed412895136$var$_templateObject4());
var $67c42ed412895136$var$ExpiredWarning = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(function(param) {
    var theme = param.theme;
    return {
        color: theme.colors.error[500]
    };
});



var $8c6ug = parcelRequire("8c6ug");

var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");








var $8e833da7287434a6$export$a49f9937fd206a70 = function() {
    (function() {
        for(var _len = arguments.length, xs = new Array(_len), _key = 0; _key < _len; _key++){
            xs[_key] = arguments[_key];
        }
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            // @ts-ignore
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            var d = document;
            var i = function i1() {
                i.c(xs);
            };
            i.q = [];
            i.c = function(args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function l() {
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://widget.intercom.io/widget/" + (0, $10b47c5a212e87a0$export$7eaa56945d1970dc);
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === "complete") l();
            else if (w.attachEvent) w.attachEvent("onload", l);
            else w.addEventListener("load", l, false);
        }
    })();
    window.Intercom && window.Intercom("update", {
        hide_default_launcher: true
    });
};


function $dcbb90c0f48be4ec$export$99edb48b31c60fa0(projectId) {
    try {
        (function(c, l, a, r, i, t, y) {
            if (l.getElementById("clarity-script")) return;
            c[a] = c[a] || function() {
                (c[a].q = c[a].q || []).push(arguments);
            };
            t = l.createElement(r);
            t.async = 1;
            t.src = "https://www.clarity.ms/tag/" + i + "?ref=npm";
            t.id = "clarity-script";
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", projectId);
        return;
    } catch (error) {
        return;
    }
}


var $780cdf6be3225998$var$Clarity = {
    init: function(projectId) {
        (0, $dcbb90c0f48be4ec$export$99edb48b31c60fa0)(projectId, 'clarity-script');
    },
    setTag: function(key, value) {
        window.clarity('set', key, value);
    },
    identify: function(customerId, customSessionId, customPageId, friendlyName) {
        window.clarity('identify', customerId, customSessionId, customPageId, friendlyName);
    },
    consent: function() {
        var consent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        window.clarity('consent', consent);
    },
    upgrade: function(reason) {
        window.clarity('upgrade', reason);
    },
    event: function(eventName) {
        window.clarity('event', eventName);
    }
};
var $780cdf6be3225998$export$2e2bcd8739ae039 = $780cdf6be3225998$var$Clarity;


var $598b3ff84e134333$export$44fbea0b26cea290 = function() {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var initEssential = function() {
        (0, $175ce91c71cebc6b$export$ceef5923485458fc)();
    };
    var initNonessential = function() {
        (0, $8e833da7287434a6$export$a49f9937fd206a70)();
        $5c342e2d7b9523c9$export$d050db8f6426404e();
        (0, $780cdf6be3225998$export$2e2bcd8739ae039).consent();
    };
    var acceptEssential = function() {
        initEssential();
        (0, $cda636b84ca95de8$export$110700823644f4a6)("allow-cookies", "essential-only");
        setIsOpen(false);
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: "Essential cookies only"
        });
    };
    var acceptAll = function() {
        initEssential();
        initNonessential();
        (0, $cda636b84ca95de8$export$110700823644f4a6)("allow-cookies", "all");
        setIsOpen(false);
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
            event_label: "Accept all cookies"
        });
    };
    (0, $hAGkE.useEffect)(function() {
        var preferences = (0, $cda636b84ca95de8$export$bead674655ff515d)("allow-cookies");
        switch(preferences){
            case "all":
                initEssential();
                initNonessential();
                break;
            case "essential-only":
                initEssential();
                break;
            default:
                setIsOpen(true);
                break;
        }
    }, []);
    (0, $hAGkE.useEffect)(function() {
        var cookieBanner = document.querySelector("#cookieBanner");
        if (cookieBanner) cookieBanner.focus();
    }, [
        isOpen
    ]);
    return isOpen ? /*#__PURE__*/ (0, $0048b1b41b30e47d$exports.createPortal)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($598b3ff84e134333$var$Overlay, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($598b3ff84e134333$var$Banner, {
            id: "cookieBanner",
            role: "region",
            "aria-label": "Cookie banner",
            tabIndex: 0,
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($598b3ff84e134333$var$Text, {
                    role: "dialog",
                    "aria-label": "Cookie disclaimer",
                    children: [
                        "By clicking \u2018Accept all cookies\u2019, you agree to the storing of cookies on your device to support your user experience, personalisation of ads and our analysis of site usage. Read more on our",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($598b3ff84e134333$var$Link, {
                            href: "https://mojomortgages.com/cookies/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Cookie Policy page"
                        }),
                        " ",
                        "and on",
                        " ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                            href: "https://business.safety.google/privacy/",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: "Google's Privacy & Terms site"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($598b3ff84e134333$var$Buttons, {
                    role: "group",
                    "aria-label": "Cookie buttons",
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Outline,
                            onClick: acceptEssential,
                            text: "Essential cookies only"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                            type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                            onClick: acceptAll,
                            text: "Accept all cookies"
                        })
                    ]
                })
            ]
        })
    }), document.body) : null;
};
var $598b3ff84e134333$var$Overlay = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    backgroundColor: "hsl(0deg 0% 0% / 30%)",
    position: "fixed",
    inset: 0,
    zIndex: 9998
});
var $598b3ff84e134333$var$Banner = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    background: "white",
    borderRadius: "1.5rem 1.5rem 0 0",
    bottom: 0,
    display: "flex",
    flexWrap: "nowrap",
    gap: "1.5rem",
    justifyContent: "space-between",
    left: "50%",
    maxWidth: 1280,
    padding: "1.5rem",
    position: "fixed",
    transform: "translateX(-50%)",
    width: "calc(100% - 16px)",
    zIndex: 9999,
    "&:focus": {
        outline: "none"
    }
}, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column"
}));
var $598b3ff84e134333$var$Text = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    alignSelf: "center",
    maxWidth: 576
});
var $598b3ff84e134333$var$_obj;
var $598b3ff84e134333$var$Buttons = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($598b3ff84e134333$var$_obj = {
    display: "flex"
}, (0, $8c6ug._)($598b3ff84e134333$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column"
}), (0, $8c6ug._)($598b3ff84e134333$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "column"
}), (0, $8c6ug._)($598b3ff84e134333$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    gap: "1rem"
}), $598b3ff84e134333$var$_obj));
var $598b3ff84e134333$var$Link = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a(function(param) {
    var theme = param.theme;
    return {
        color: theme.primary
    };
});






parcelRequire("hAGkE");


function $f794e7d0ae102ab8$export$f71c5f546123a947(input, target, replace) {
    var regex = new RegExp("".concat(target), "g");
    return input.replace(regex, replace);
}



var $6mdMa = parcelRequire("6mdMa");


var $bOqL7 = parcelRequire("bOqL7");


var $hAGkE = parcelRequire("hAGkE");







function $84617fd3a377d5e1$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background-color: #000928;\n  z-index: 100000000;\n  color: white;\n\n  font-family: ",
        ';\n  font-style: normal;\n  line-height: 150%;\n  font-feature-settings: "pnum" on, "lnum" on;\n\n  h2 {\n    font-weight: bold;\n    font-size: 1.1em;\n    margin: 0;\n    margin-top: 8px;\n    margin-bottom: 16px;\n  }\n\n  p {\n    font-weight: 500;\n    font-size: 0.9rem;\n    margin: 0;\n  }\n\n  box-shadow: 0px 16.25px 97.5px rgba(0, 0, 0, 0.12);\n  padding: 20px;\n\n  border-top-left-radius: 9.75px;\n  border-top-right-radius: 9.75px;\n\n  .cross-icon {\n    position: absolute;\n    top: 22px;\n    right: 19px;\n    cursor: pointer;\n  }\n\n  @media ',
        ' {\n    position: absolute;\n\n    bottom: initial;\n    margin: initial;\n\n    top: 100%;\n    margin-top: 5px;\n    margin-left: 293px;\n\n    border-radius: 9.75px;\n\n    &:after {\n      content: "";\n      position: absolute;\n\n      right: 100%;\n      margin-right: -40px;\n\n      bottom: 100%;\n      transform: translateY(-50%);\n      transform: rotate(90deg);\n\n      border: 10px solid #000;\n      border-color: transparent black transparent transparent;\n    }\n  }\n\n  @media (min-width: 768px) and (max-width: 800px) {\n    margin-left: 281px;\n  }\n\n  @media ',
        " {\n    margin-left: 281px;\n  }\n\n  @media ",
        " {\n    margin-left: 293px;\n  }\n"
    ]);
    $84617fd3a377d5e1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $84617fd3a377d5e1$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 24px;\n  height: 24px;\n  padding-right: 32px;\n"
    ]);
    $84617fd3a377d5e1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $84617fd3a377d5e1$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  cursor: pointer;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  bottom: 1px;\n  margin: auto;\n  right: 6px;\n  background: transparent;\n  border: 0;\n"
    ]);
    $84617fd3a377d5e1$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $84617fd3a377d5e1$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: inline-block;\n  border: #ffffff 2px solid;\n  border-radius: 10px;\n  color: white;\n  margin-top: 20px;\n\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1em;\n  line-height: 150%;\n  text-decoration: none;\n\n  padding: 8px 10px 7px 10px;\n\n  &:visited,\n  &:link,\n  &:hover,\n  &:active {\n    text-decoration: none;\n  }\n"
    ]);
    $84617fd3a377d5e1$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $84617fd3a377d5e1$var$TooltipWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($84617fd3a377d5e1$var$_templateObject(), function(props) {
    return props.theme.fontFamily;
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $84617fd3a377d5e1$var$QuestionMarkWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($84617fd3a377d5e1$var$_templateObject1());
var $84617fd3a377d5e1$var$Button = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).button($84617fd3a377d5e1$var$_templateObject2());
var $84617fd3a377d5e1$var$TooltipButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($84617fd3a377d5e1$var$_templateObject3(), function(props) {
    return props.theme.fontFamily;
});
var $84617fd3a377d5e1$export$7a7c7a2506c3719d = {
    WHITE: "white",
    NAVY: "#666B7E"
};
var $84617fd3a377d5e1$export$28c660c63b792dea = function(param) {
    var id = param.id, option = param.option, questionMarkColor = param.questionMarkColor;
    // Id is needed so the tooltip disables all other tooltips when you click it.
    if (!id) throw new Error("id property has to be set on Tooltip components!");
    var _useRecoilState = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$a8e432ea130e3750)), 2), tooltips = _useRecoilState[0], setTooltipState = _useRecoilState[1];
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), show = _useState[0], setShow = _useState[1];
    (0, $hAGkE.useEffect)(function() {
        if (tooltips.find(function(state) {
            return state.id === id;
        })) return;
        setTooltipState(function(oldTooltipState) {
            return (0, $bOqL7._)(oldTooltipState).concat([
                {
                    id: id,
                    closeFn: function() {
                        return setShow(false);
                    }
                }
            ]);
        });
    });
    (0, $hAGkE.useEffect)(function() {
        if (!window) return;
        var hideOnClick = function() {
            if (!show) return;
            setShow(false);
        };
        // hide the tooltip when you click anywhere.
        window.addEventListener("click", hideOnClick);
        // remove the eventlistener when we unmount component.
        return function cleanup() {
            window.removeEventListener("click", hideOnClick);
        };
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($84617fd3a377d5e1$var$Button, {
                onClick: function(e) {
                    e.stopPropagation();
                    tooltips.forEach(function(param) {
                        var closeFn = param.closeFn;
                        return closeFn();
                    });
                    (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                        action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).tooltipClicked,
                        event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                        event_label: option.tooltip.title
                    });
                    setShow(!show);
                },
                style: {
                    padding: 0
                },
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($84617fd3a377d5e1$var$QuestionMarkWrapper, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $abfded16bdabae7a$export$962ee6b89e324472), {
                        active: show,
                        fillDefault: questionMarkColor || "#666B7E",
                        fillHover: questionMarkColor === $84617fd3a377d5e1$export$7a7c7a2506c3719d.WHITE ? "#ffffff" : "#073ED9",
                        width: 24,
                        height: 24,
                        type: (0, $abfded16bdabae7a$export$13ff1290a9e22e77).QuestionMark
                    })
                })
            }),
            show && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($84617fd3a377d5e1$var$TooltipWrapper, {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                        className: "cross-icon",
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $abfded16bdabae7a$export$962ee6b89e324472), {
                            active: show,
                            fillDefault: "#ffffff",
                            fillHover: "#ffffff",
                            width: 32,
                            height: 32,
                            type: (0, $abfded16bdabae7a$export$13ff1290a9e22e77).Cross,
                            onClick: function() {
                                return setShow(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h2", {
                        children: option.tooltip.title
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                        children: option.tooltip.content
                    }),
                    option.tooltip.button && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($84617fd3a377d5e1$var$TooltipButton, {
                        href: option.tooltip.button.link,
                        children: option.tooltip.button.text
                    })
                ]
            })
        ]
    });
};


function $b4b1b65eabae43fb$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0.5rem 0;\n  position: relative;\n  ",
        "\n"
    ]);
    $b4b1b65eabae43fb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b4b1b65eabae43fb$var$ButtonWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b4b1b65eabae43fb$var$_templateObject(), function(param) {
    var hasTooltip = param.hasTooltip;
    return hasTooltip && "\n		label {\n			padding-right: 40px;\n		}";
});
function $b4b1b65eabae43fb$export$2e2bcd8739ae039(param) {
    var id = param.id, options = param.options, value = param.value, onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: options.map(function(option, index) {
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b4b1b65eabae43fb$var$ButtonWrapper, {
                hasTooltip: !!option.tooltip,
                className: className,
                children: [
                    option.tooltip && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $84617fd3a377d5e1$export$28c660c63b792dea), {
                        questionMarkColor: value === option.value ? (0, $84617fd3a377d5e1$export$7a7c7a2506c3719d).WHITE : (0, $84617fd3a377d5e1$export$7a7c7a2506c3719d).NAVY,
                        id: id + "tooltip",
                        option: option
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ed0de207f622e949$exports))), {
                        name: id,
                        value: option.value,
                        checked: option.value === value,
                        onChange: function(e) {
                            return onClick(e.target.value);
                        },
                        id: "radio-".concat(id, "-").concat((0, $f794e7d0ae102ab8$export$f71c5f546123a947)(option.value, "/ /", "-")),
                        children: option.text
                    })
                ]
            }, id + option.text);
        })
    });
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");


/**
 * react-number-format - 5.4.5
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2026 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ 
var $hAGkE = parcelRequire("hAGkE");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $ab7866b2c4bd0902$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $ab7866b2c4bd0902$var$SourceType;
(function(SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})($ab7866b2c4bd0902$var$SourceType || ($ab7866b2c4bd0902$var$SourceType = {}));
// basic noop function
function $ab7866b2c4bd0902$var$noop() {}
function $ab7866b2c4bd0902$var$memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        if (lastArgs && args.length === lastArgs.length && args.every(function(value, index) {
            return value === lastArgs[index];
        })) return lastValue;
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function $ab7866b2c4bd0902$var$charIsNumber(_char) {
    return !!(_char || '').match(/\d/);
}
function $ab7866b2c4bd0902$var$isNil(val) {
    return val === null || val === undefined;
}
function $ab7866b2c4bd0902$var$isNanValue(val) {
    return typeof val === 'number' && isNaN(val);
}
function $ab7866b2c4bd0902$var$isNotValidValue(val) {
    return $ab7866b2c4bd0902$var$isNil(val) || $ab7866b2c4bd0902$var$isNanValue(val) || typeof val === 'number' && !isFinite(val);
}
function $ab7866b2c4bd0902$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
function $ab7866b2c4bd0902$var$getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case 'lakh':
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case 'wan':
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case 'thousand':
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $ab7866b2c4bd0902$var$applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = $ab7866b2c4bd0902$var$getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator);
}
function $ab7866b2c4bd0902$var$usePersistentCallback(cb) {
    var callbackRef = (0, $hAGkE.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */ var persistentCbRef = (0, $hAGkE.useRef)(function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function $ab7866b2c4bd0902$var$splitDecimal(numStr, allowNegative) {
    if (allowNegative === void 0) allowNegative = true;
    var hasNegation = numStr[0] === '-';
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation
    };
}
function $ab7866b2c4bd0902$var$fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === '-';
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return "" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? "." + afterDecimal : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function $ab7866b2c4bd0902$var$limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
function $ab7866b2c4bd0902$var$repeat(str, count) {
    return Array(count + 1).join(str);
}
function $ab7866b2c4bd0902$var$toNumericString(num) {
    var _num = num + ''; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === '-' ? '-' : '';
    if (sign) _num = _num.substring(1);
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) return sign + coefficient;
    coefficient = coefficient.replace('.', '');
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */ var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + $ab7866b2c4bd0902$var$repeat('0', Math.abs(decimalIndex)) + coefficient;
    else if (decimalIndex >= coffiecientLn) // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + $ab7866b2c4bd0902$var$repeat('0', decimalIndex - coffiecientLn);
    else // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function $ab7866b2c4bd0902$var$roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        '',
        '-'
    ].indexOf(numStr) !== -1) return numStr;
    var shouldHaveDecimalSeparator = (numStr.indexOf('.') !== -1 || fixedDecimalScale) && scale;
    var ref = $ab7866b2c4bd0902$var$splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat("0." + (afterDecimal || '0'));
    var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split('.');
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) intPart = beforeDecimal.split('').reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = $ab7866b2c4bd0902$var$limitToScale(roundedDecimalParts[1] || '', scale, fixedDecimalScale);
    var negation = hasNegation ? '-' : '';
    var decimalSeparator = shouldHaveDecimalSeparator ? '.' : '';
    return "" + negation + intPart + decimalSeparator + decimalPart;
}
/** set the caret positon in an input field **/ function $ab7866b2c4bd0902$var$setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */ if (el.createTextRange) {
            /* @ts-ignore */ var range = el.createTextRange();
            range.move('character', caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
 * TODO: remove dependency of findChangeRange, findChangedRangeFromCaretPositions is better way to find what is changed
 * currently this is mostly required by test and isCharacterSame util
 * Given previous value and newValue it returns the index
 * start - end to which values have changed.
 * This function makes assumption about only consecutive
 * characters are changed which is correct assumption for caret input.
 */ var $ab7866b2c4bd0902$var$findChangeRange = $ab7866b2c4bd0902$var$memoizeOnce(function(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
    //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        from: {
            start: i,
            end: prevLength - j
        },
        to: {
            start: i,
            end: newLength - j
        }
    };
});
var $ab7866b2c4bd0902$var$findChangedRangeFromCaretPositions = function findChangedRangeFromCaretPositions(lastCaretPositions, currentCaretPosition) {
    var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
    return {
        from: {
            start: startPosition,
            end: lastCaretPositions.selectionEnd
        },
        to: {
            start: startPosition,
            end: currentCaretPosition
        }
    };
};
/*
  Returns a number whose value is limited to the given range
*/ function $ab7866b2c4bd0902$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $ab7866b2c4bd0902$var$geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
function $ab7866b2c4bd0902$var$addInputMode() {
    return typeof navigator !== 'undefined' && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $ab7866b2c4bd0902$var$getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: value.length
        },
        lastValue: ''
    };
}
function $ab7866b2c4bd0902$var$getMaskAtIndex(mask, index) {
    if (mask === void 0) mask = ' ';
    if (typeof mask === 'string') return mask;
    return mask[index] || ' ';
}
function $ab7866b2c4bd0902$var$defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;
    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function $ab7866b2c4bd0902$var$getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, /**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */ isCharacterSame) {
    if (isCharacterSame === void 0) isCharacterSame = $ab7866b2c4bd0902$var$defaultIsCharacterSame;
    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */ var firstAllowedPosition = boundary.findIndex(function(b) {
        return b;
    });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for(var i = 0; i < curValLn; i++){
        indexMap[i] = -1;
        for(var j = 0, jLn = formattedValueLn; j < jLn; j++){
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */ var pos = curCaretPos;
    while(pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos])))pos++;
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while(pos > 0 && indexMap[pos] === -1)pos--;
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */ if (startIndex > endIndex) return endIndex;
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */ return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */ function $ab7866b2c4bd0902$var$getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = $ab7866b2c4bd0902$var$clamp(caretPos, 0, valLn);
    if (direction === 'left') {
        while(caretPos >= 0 && !boundary[caretPos])caretPos--;
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1) caretPos = boundary.indexOf(true);
    } else {
        while(caretPos <= valLn && !boundary[caretPos])caretPos++;
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn) caretPos = boundary.lastIndexOf(true);
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1) caretPos = valLn;
    return caretPos;
}
function $ab7866b2c4bd0902$var$caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    boundaryAry[i] = Boolean($ab7866b2c4bd0902$var$charIsNumber(formattedValue[i]) || $ab7866b2c4bd0902$var$charIsNumber(formattedValue[i - 1]));
    return boundaryAry;
}
function $ab7866b2c4bd0902$var$useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if (onValueChange === void 0) onValueChange = $ab7866b2c4bd0902$var$noop;
    var getValues = $ab7866b2c4bd0902$var$usePersistentCallback(function(value, valueIsNumericString) {
        var formattedValue, numAsString;
        if ($ab7866b2c4bd0902$var$isNotValidValue(value)) {
            numAsString = '';
            formattedValue = '';
        } else if (typeof value === 'number' || valueIsNumericString) {
            numAsString = typeof value === 'number' ? $ab7866b2c4bd0902$var$toNumericString(value) : value;
            formattedValue = format(numAsString);
        } else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return {
            formattedValue: formattedValue,
            numAsString: numAsString
        };
    });
    var ref = (0, $hAGkE.useState)(function() {
        return getValues($ab7866b2c4bd0902$var$isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = $ab7866b2c4bd0902$var$usePersistentCallback(function(newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) setValues({
            formattedValue: newValues.formattedValue,
            numAsString: newValues.value
        });
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    });
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if ($ab7866b2c4bd0902$var$isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0, $hAGkE.useMemo)(function() {
        setValues(newValues);
    }, [
        newValues.formattedValue
    ]);
    /**
     * When only a defaultValue is provided (value prop is nil), the initial formatted value is
     * derived by the library — the parent has not yet been informed of this formatted result.
     * Fire onValueChange once on mount so the parent can sync to the formatted value.
     */ (0, $hAGkE.useEffect)(function() {
        if (!$ab7866b2c4bd0902$var$isNil(defaultValue) && $ab7866b2c4bd0902$var$isNil(value) && values.formattedValue !== '') {
            var floatValue = parseFloat(values.numAsString);
            _onValueChange({
                formattedValue: values.formattedValue,
                value: values.numAsString,
                floatValue: isNaN(floatValue) ? undefined : floatValue
            }, {
                event: undefined,
                source: $ab7866b2c4bd0902$var$SourceType.props
            });
        }
    }, []);
    return [
        values,
        _onValueChange
    ];
}
function $ab7866b2c4bd0902$var$defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, '');
}
function $ab7866b2c4bd0902$var$defaultFormat(value) {
    return value;
}
function $ab7866b2c4bd0902$export$dd1caf9b8ccbc158(props) {
    var type = props.type;
    if (type === void 0) type = 'text';
    var displayType = props.displayType;
    if (displayType === void 0) displayType = 'input';
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format;
    if (format === void 0) format = $ab7866b2c4bd0902$var$defaultFormat;
    var removeFormatting = props.removeFormatting;
    if (removeFormatting === void 0) removeFormatting = $ab7866b2c4bd0902$var$defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange;
    if (onChange === void 0) onChange = $ab7866b2c4bd0902$var$noop;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $ab7866b2c4bd0902$var$noop;
    var onMouseUp = props.onMouseUp;
    if (onMouseUp === void 0) onMouseUp = $ab7866b2c4bd0902$var$noop;
    var onFocus = props.onFocus;
    if (onFocus === void 0) onFocus = $ab7866b2c4bd0902$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $ab7866b2c4bd0902$var$noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary;
    if (getCaretBoundary === void 0) getCaretBoundary = $ab7866b2c4bd0902$var$caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter;
    if (isValidInputCharacter === void 0) isValidInputCharacter = $ab7866b2c4bd0902$var$charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = $ab7866b2c4bd0902$var$__rest(props, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]);
    var ref = $ab7866b2c4bd0902$var$useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var caretPositionBeforeChange = (0, $hAGkE.useRef)();
    var lastUpdatedValue = (0, $hAGkE.useRef)({
        formattedValue: formattedValue,
        numAsString: numAsString
    });
    var _onValueChange = function _onValueChange(values, source) {
        lastUpdatedValue.current = {
            formattedValue: values.formattedValue,
            numAsString: values.value
        };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0, $hAGkE.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0, $hAGkE.useRef)(null);
    var timeout = (0, $hAGkE.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $hAGkE.useEffect)(function() {
        setMounted(true);
        return function() {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function getValueObject(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue
        };
    };
    var setPatchedCaretPosition = function setPatchedCaretPosition(el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length) return;
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */ $ab7866b2c4bd0902$var$setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function() {
            if (el.value === currentValue && el.selectionStart !== caretPos) $ab7866b2c4bd0902$var$setCaretPosition(el, caretPos);
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */ var correctCaretPosition = function correctCaretPosition(value, caretPos, direction) {
        return $ab7866b2c4bd0902$var$getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function getNewCaretPosition(inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = $ab7866b2c4bd0902$var$getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = $ab7866b2c4bd0902$var$getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function updateValueAndCaretPosition(params) {
        var newFormattedValue = params.formattedValue;
        if (newFormattedValue === void 0) newFormattedValue = '';
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = $ab7866b2c4bd0902$var$geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */ input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) setPatchedCaretPosition(input, caretPos, newFormattedValue);
        }
        if (newFormattedValue !== formattedValue) // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
        _onValueChange(getValueObject(newFormattedValue, numAsString), {
            event: event,
            source: source
        });
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */ (0, $hAGkE.useEffect)(function() {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) _onValueChange(getValueObject(formattedValue, numAsString), {
            event: undefined,
            source: $ab7866b2c4bd0902$var$SourceType.props
        });
    }, [
        formattedValue,
        numAsString
    ]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current ? $ab7866b2c4bd0902$var$geInputCaretPosition(focusedElm.current) : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $hAGkE.useLayoutEffect) : (0, $hAGkE.useEffect);
    useIsomorphicLayoutEffect(function() {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */ input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [
        formattedValue
    ]);
    var formatInputValue = function formatInputValue(inputValue, event, source) {
        var input = event.target;
        var changeRange = caretPositionBeforeChange.current ? $ab7866b2c4bd0902$var$findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd) : $ab7866b2c4bd0902$var$findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), {
            lastValue: formattedValue
        });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input$1 = event.target;
            var currentCaretPosition = $ab7866b2c4bd0902$var$geInputCaretPosition(input$1);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input$1.value = formattedValue;
            setPatchedCaretPosition(input$1, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target
        });
        return true;
    };
    var setCaretPositionInfoBeforeChange = function setCaretPositionInfoBeforeChange(el, endOffset) {
        if (endOffset === void 0) endOffset = 0;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        caretPositionBeforeChange.current = {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd + endOffset
        };
    };
    var _onChange = function _onChange(e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, $ab7866b2c4bd0902$var$SourceType.event);
        if (changed) onChange(e);
        // reset the position, as we have already handled the caret position
        caretPositionBeforeChange.current = undefined;
    };
    var _onKeyDown = function _onKeyDown(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = '';
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === 'ArrowLeft' || key === 'Backspace') expectedCaretPosition = Math.max(selectionStart - 1, 0);
        else if (key === 'ArrowRight') expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        else if (key === 'Delete') expectedCaretPosition = selectionStart;
        // if key is delete and text is not selected keep the end offset to 1, as it deletes one character
        // this is required as selection is not changed on delete case, which changes the change range calculation
        var endOffset = 0;
        if (key === 'Delete' && selectionStart === selectionEnd) endOffset = 1;
        var isArrowKey = key === 'ArrowLeft' || key === 'ArrowRight';
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd && !isArrowKey) {
            onKeyDown(e);
            // keep information of what was the caret position before keyDown
            // set it after onKeyDown, in case parent updates the position manually
            setCaretPositionInfoBeforeChange(el, endOffset);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (isArrowKey) {
            var direction = key === 'ArrowLeft' ? 'left' : 'right';
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) e.preventDefault();
        } else if (key === 'Delete' && !isValidInputCharacter(value[expectedCaretPosition])) // in case of delete go to closest caret boundary on the right side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'right');
        else if (key === 'Backspace' && !isValidInputCharacter(value[expectedCaretPosition])) // in case of backspace go to closest caret boundary on the left side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'left');
        if (newCaretPosition !== expectedCaretPosition) setPatchedCaretPosition(el, newCaretPosition, value);
        onKeyDown(e);
        setCaretPositionInfoBeforeChange(el, endOffset);
    };
    /** required to handle the caret position when click anywhere within the input **/ var _onMouseUp = function _onMouseUp(e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */ var correctCaretPositionIfRequired = function correctCaretPositionIfRequired() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = '';
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) setPatchedCaretPosition(el, caretPosition, value);
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function() {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
        setCaretPositionInfoBeforeChange(el);
    };
    var _onFocus = function _onFocus(e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist) e.persist();
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = '';
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) setPatchedCaretPosition(el, caretPosition, value);
            onFocus(Object.assign(Object.assign({}, e), {
                currentTarget: currentTarget
            }));
        }, 0);
    };
    var _onBlur = function _onBlur(e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && $ab7866b2c4bd0902$var$addInputMode() ? 'numeric' : undefined;
    var inputProps = Object.assign({
        inputMode: inputMode
    }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur
    });
    if (displayType === 'text') return renderText ? (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Fragment, null, renderText(formattedValue, otherProps) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("span", Object.assign({}, otherProps, {
        ref: getInputRef
    }), formattedValue);
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */ return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(CustomInput, Object.assign({}, inputProps, {
            ref: getInputRef
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement("input", Object.assign({}, inputProps, {
        ref: getInputRef
    }));
}
function $ab7866b2c4bd0902$export$8afdc6404de1eded(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    if (thousandsGroupStyle === void 0) thousandsGroupStyle = 'thousand';
    // don't apply formatting on empty string or '-'
    if (numStr === '' || numStr === '-') return numStr;
    var ref = $ab7866b2c4bd0902$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */ var hasDecimalSeparator = decimalScale !== 0 && numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
    var ref$1 = $ab7866b2c4bd0902$var$splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) afterDecimal = $ab7866b2c4bd0902$var$limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    if (thousandSeparator) beforeDecimal = $ab7866b2c4bd0902$var$applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    //add prefix and suffix when there is a number present
    if (prefix) beforeDecimal = prefix + beforeDecimal;
    if (suffix) afterDecimal = afterDecimal + suffix;
    //restore negation sign
    if (addNegation) beforeDecimal = '-' + beforeDecimal;
    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
    return numStr;
}
function $ab7866b2c4bd0902$var$getSeparators(props) {
    var decimalSeparator = props.decimalSeparator;
    if (decimalSeparator === void 0) decimalSeparator = '.';
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) thousandSeparator = ',';
    if (!allowedDecimalSeparators) allowedDecimalSeparators = [
        decimalSeparator,
        '.'
    ];
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators
    };
}
function $ab7866b2c4bd0902$var$handleNegation(value, allowNegative) {
    if (value === void 0) value = '';
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, '');
    if (hasNegation && !removeNegation && allowNegative) value = '-' + value;
    return value;
}
function $ab7866b2c4bd0902$var$getNumberRegex(decimalSeparator, global) {
    return new RegExp("(^-)|[0-9]|" + $ab7866b2c4bd0902$var$escapeRegExp(decimalSeparator), global ? 'g' : undefined);
}
function $ab7866b2c4bd0902$var$isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === '') return true;
    return !(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === 'string' && !isNaN(Number(val));
}
function $ab7866b2c4bd0902$export$bd06c53c8882f574(value, changeMeta, props) {
    var assign;
    if (changeMeta === void 0) changeMeta = $ab7866b2c4bd0902$var$getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = $ab7866b2c4bd0902$var$getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */ if ($ab7866b2c4bd0902$var$charIsNumber(value) && (value === prefix || value === suffix) && changeMeta.lastValue === '') return value;
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? '' : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function stripNegation(value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */ var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith('-')) hasNegation = false;
        else if (value.startsWith('--')) {
            hasNegation = false;
            hasDoubleNegation = true;
        } else if (suffix.startsWith('-') && value.length === suffix.length) hasNegation = false;
        else if (value[0] === '-') hasNegation = true;
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation) charsToRemove = 2;
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return {
            value: value,
            start: start,
            end: end,
            hasNegation: hasNegation
        };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    assign = toMetadata, value = assign.value, start = assign.start, end = assign.end;
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length && lastValue.length && (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) && !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) value = lastValue;
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */ var startIndex = 0;
    if (value.startsWith(prefix)) startIndex += prefix.length;
    else if (start < prefix.length) startIndex = start;
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */ var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix)) endIndex = suffixStartIndex;
    else if (end > suffixStartIndex) endIndex = end;
    else if (end > value.length - suffix.length) endIndex = end;
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = $ab7866b2c4bd0902$var$handleNegation(hasNegation ? "-" + value : value, allowNegative);
    // remove non numeric characters
    value = (value.match($ab7866b2c4bd0902$var$getNumberRegex(decimalSeparator, true)) || []).join('');
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp($ab7866b2c4bd0902$var$escapeRegExp(decimalSeparator), 'g'), function(match, index) {
        return index === firstIndex ? '.' : '';
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = $ab7866b2c4bd0902$var$splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start && beforeDecimal === '' && isBeforeDecimalSeparator && !parseFloat(afterDecimal)) value = addNegation ? '-' : '';
    return value;
}
function $ab7866b2c4bd0902$export$ce26457d42b8fa52(formattedValue, props) {
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hasNegation = formattedValue[0] === '-';
    // fill for prefix and negation
    // Cap the fill range so we never exceed the array length when the formatted value
    // is just '-' (negation only, e.g. during intermediate typing with a multi-char prefix)
    boundaryAry.fill(false, 0, Math.min(prefix.length + (hasNegation ? 1 : 0), formattedValue.length));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function $ab7866b2c4bd0902$var$validateAndUpdateProps(props) {
    var ref = $ab7866b2c4bd0902$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var allowNegative = props.allowNegative;
    if (allowNegative === void 0) allowNegative = true;
    if (thousandSeparator === decimalSeparator) throw new Error("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n        decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n     ");
    if (prefix.startsWith('-') && allowNegative) {
        // TODO: throw error in next major version
        console.error("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    ");
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), {
        allowNegative: allowNegative
    });
}
function $ab7866b2c4bd0902$export$2fb051e8b03d5d2d(props) {
    // validate props
    props = $ab7866b2c4bd0902$var$validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $ab7866b2c4bd0902$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $ab7866b2c4bd0902$var$noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = $ab7866b2c4bd0902$var$__rest(props, [
        "decimalSeparator",
        "allowedDecimalSeparators",
        "thousandsGroupStyle",
        "suffix",
        "allowNegative",
        "allowLeadingZeros",
        "onKeyDown",
        "onBlur",
        "thousandSeparator",
        "decimalScale",
        "fixedDecimalScale",
        "prefix",
        "defaultValue",
        "value",
        "valueIsNumericString",
        "onValueChange"
    ]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = $ab7866b2c4bd0902$var$getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function _format(numStr) {
        return $ab7866b2c4bd0902$export$8afdc6404de1eded(numStr, props);
    };
    var _removeFormatting = function _removeFormatting(inputValue, changeMeta) {
        return $ab7866b2c4bd0902$export$bd06c53c8882f574(inputValue, changeMeta, props);
    };
    var _value = $ab7866b2c4bd0902$var$isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $ab7866b2c4bd0902$var$isNumericString(_value, prefix, suffix);
    if (!$ab7866b2c4bd0902$var$isNil(value)) _valueIsNumericString = _valueIsNumericString || typeof value === 'number';
    else if (!$ab7866b2c4bd0902$var$isNil(defaultValue)) _valueIsNumericString = _valueIsNumericString || typeof defaultValue === 'number';
    var roundIncomingValueToPrecision = function roundIncomingValueToPrecision(value) {
        if ($ab7866b2c4bd0902$var$isNotValidValue(value)) return value;
        if (typeof value === 'number') value = $ab7866b2c4bd0902$var$toNumericString(value);
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */ if (_valueIsNumericString && typeof decimalScale === 'number') return $ab7866b2c4bd0902$var$roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        return value;
    };
    var ref$1 = $ab7866b2c4bd0902$var$useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function _onKeyDown(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = '';
        // if user tries to delete partial prefix then ignore it
        // Exception: when value is just '-' (negation-only, no prefix shown yet), the cursor
        // is at position 1 which is < prefix.length for multi-char prefixes — we must allow
        // backspace to delete the lone negation sign in this state
        if ((key === 'Backspace' || key === 'Delete') && selectionEnd < prefix.length && value !== '-') {
            e.preventDefault();
            return;
        }
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === 'Backspace' && value[0] === '-' && selectionStart === prefix.length + 1 && allowNegative) // bring the cursor to after negation
        $ab7866b2c4bd0902$var$setCaretPosition(el, 1);
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === 'Backspace' && value[selectionStart - 1] === decimalSeparator) {
                $ab7866b2c4bd0902$var$setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            } else if (key === 'Delete' && value[selectionStart] === decimalSeparator) e.preventDefault();
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) $ab7866b2c4bd0902$var$setCaretPosition(el, selectionStart + 1);
        var _thousandSeparator = thousandSeparator === true ? ',' : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === 'Backspace' && value[selectionStart - 1] === _thousandSeparator) $ab7866b2c4bd0902$var$setCaretPosition(el, selectionStart - 1);
        if (key === 'Delete' && value[selectionStart] === _thousandSeparator) $ab7866b2c4bd0902$var$setCaretPosition(el, selectionStart + 1);
        onKeyDown(e);
    };
    var _onBlur = function _onBlur(e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) _value = '';
        // clear leading 0s
        if (!allowLeadingZeros) _value = $ab7866b2c4bd0902$var$fixLeadingZero(_value);
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) _value = $ab7866b2c4bd0902$var$roundToPrecision(_value, decimalScale, fixedDecimalScale);
        if (_value !== numAsString) {
            var formattedValue = $ab7866b2c4bd0902$export$8afdc6404de1eded(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value)
            }, {
                event: e,
                source: $ab7866b2c4bd0902$var$SourceType.event
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function isValidInputCharacter(inputChar) {
        if (inputChar === decimalSeparator) return true;
        return $ab7866b2c4bd0902$var$charIsNumber(inputChar);
    };
    var isCharacterSame = function isCharacterSame(ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;
        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */ var typedRange = $ab7866b2c4bd0902$var$findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        // handle corner case where if we user types a decimal separator with fixedDecimalScale
        // and pass back float value the cursor jumps. #851
        var getDecimalSeparatorIndex = function getDecimalSeparatorIndex(value) {
            return _removeFormatting(value).indexOf('.') + prefix.length;
        };
        if (value === 0 && fixedDecimalScale && decimalScale && currentValue[to.start] === decimalSeparator && getDecimalSeparatorIndex(currentValue) < currentValueIndex && getDecimalSeparatorIndex(formattedValue) > formattedValueIndex) return false;
        if (currentValueIndex >= to.start && currentValueIndex < to.end && allowedDecimalSeparators && allowedDecimalSeparators.includes(curChar) && newChar === decimalSeparator) return true;
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), {
        value: formattedValue,
        valueIsNumericString: false,
        isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame,
        onValueChange: _onValueChange,
        format: _format,
        removeFormatting: _removeFormatting,
        getCaretBoundary: function getCaretBoundary1(formattedValue) {
            return $ab7866b2c4bd0902$export$ce26457d42b8fa52(formattedValue, props);
        },
        onKeyDown: _onKeyDown,
        onBlur: _onBlur
    });
}
function $ab7866b2c4bd0902$export$3437cf0602f97db7(props) {
    var numericFormatProps = $ab7866b2c4bd0902$export$2fb051e8b03d5d2d(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($ab7866b2c4bd0902$export$dd1caf9b8ccbc158, Object.assign({}, numericFormatProps));
}
function $ab7866b2c4bd0902$export$4b8d05d749baae10(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    if (numStr === '' && !allowEmptyFormatting) return '';
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === patternChar) {
        formattedNumberAry[i] = numStr[hashCount] || $ab7866b2c4bd0902$var$getMaskAtIndex(mask, hashCount);
        hashCount += 1;
    }
    return formattedNumberAry.join('');
}
function $ab7866b2c4bd0902$export$63600a84c223a8ea(value, changeMeta, props) {
    if (changeMeta === void 0) changeMeta = $ab7866b2c4bd0902$var$getDefaultChangeMeta(value);
    var format = props.format;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue;
    if (lastValue === void 0) lastValue = '';
    var isNumericSlot = function isNumericSlot(caretPos) {
        return format[caretPos] === patternChar;
    };
    var removeFormatChar = function removeFormatChar(string, startIndex) {
        var str = '';
        for(var i = 0; i < string.length; i++)if (isNumericSlot(startIndex + i) && $ab7866b2c4bd0902$var$charIsNumber(string[i])) str += string[i];
        return str;
    };
    var extractNumbers = function extractNumbers(str) {
        return str.replace(/[^0-9]/g, '');
    };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) return extractNumbers(value);
    /**
     * if user paste the whole formatted text in an empty input or doing select all and paste, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */ if ((lastValue === '' || from.end - from.start === lastValue.length) && value.length === format.length) {
        var str = '';
        for(var i = 0; i < value.length; i++){
            if (isNumericSlot(i)) {
                if ($ab7866b2c4bd0902$var$charIsNumber(value[i])) str += value[i];
            } else if (value[i] !== format[i]) // if there is a mismatch on the pattern, do plane number extract
            return extractNumbers(value);
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */ var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return "" + removeFormatChar(firstSection, 0) + extractNumbers(middleSection) + removeFormatChar(lastSection, from.end);
}
function $ab7866b2c4bd0902$export$cbab503a3360c264(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split('').forEach(function(_char, index) {
        var maskAtIndex = undefined;
        if (_char === patternChar) {
            hashCount++;
            maskAtIndex = $ab7866b2c4bd0902$var$getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) firstEmptySlot = index;
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function isPosAllowed(pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    // Note: on pattern based format its denoted by patternCharacter
    // we should also allow user to put cursor on first empty slot
    boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function $ab7866b2c4bd0902$var$validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) throw new Error("Mask " + mask + " should not contain numeric character;");
    }
}
function $ab7866b2c4bd0902$var$isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === '') return true;
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === 'string' && (!!val.match(/^\d+$/) || val === '');
}
function $ab7866b2c4bd0902$export$1290cfe2185b28c0(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode;
    if (inputMode === void 0) inputMode = 'numeric';
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $ab7866b2c4bd0902$var$noop;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = $ab7866b2c4bd0902$var$__rest(props, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    // validate props
    $ab7866b2c4bd0902$var$validateProps(props);
    var _getCaretBoundary = function _getCaretBoundary(formattedValue) {
        return $ab7866b2c4bd0902$export$cbab503a3360c264(formattedValue, props);
    };
    var _onKeyDown = function _onKeyDown(e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === 'Backspace' || key === 'Delete') {
            var direction = 'right';
            if (key === 'Backspace') {
                while(caretPos > 0 && formatProp[caretPos - 1] !== patternChar)caretPos--;
                direction = 'left';
            } else {
                var formatLn = formatProp.length;
                while(caretPos < formatLn && formatProp[caretPos] !== patternChar)caretPos++;
                direction = 'right';
            }
            caretPos = $ab7866b2c4bd0902$var$getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        } else if (formatProp[caretPos] !== patternChar && key !== 'ArrowLeft' && key !== 'ArrowRight') // if user is typing on format character position, bring user to next allowed caret position
        caretPos = $ab7866b2c4bd0902$var$getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), 'right');
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) $ab7866b2c4bd0902$var$setCaretPosition(el, caretPos);
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = $ab7866b2c4bd0902$var$isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $ab7866b2c4bd0902$var$isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), {
        valueIsNumericString: isValueNumericString
    });
    return Object.assign(Object.assign({}, restProps), {
        value: value,
        defaultValue: defaultValue,
        valueIsNumericString: isValueNumericString,
        inputMode: inputMode,
        format: function format(numStr) {
            return $ab7866b2c4bd0902$export$4b8d05d749baae10(numStr, _props);
        },
        removeFormatting: function removeFormatting(inputValue, changeMeta) {
            return $ab7866b2c4bd0902$export$63600a84c223a8ea(inputValue, changeMeta, _props);
        },
        getCaretBoundary: _getCaretBoundary,
        onKeyDown: _onKeyDown
    });
}
function $ab7866b2c4bd0902$export$9e8c774149e1782b(props) {
    var patternFormatProps = $ab7866b2c4bd0902$export$1290cfe2185b28c0(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($ab7866b2c4bd0902$export$dd1caf9b8ccbc158, Object.assign({}, patternFormatProps));
}


function $5d0a0df2d7bead94$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  position: relative;\n  border-radius: ",
        ";\n  :focus-within {\n    border: 1px solid ",
        ";\n    box-shadow: 0 0 0 1px ",
        ";\n  }\n"
    ]);
    $5d0a0df2d7bead94$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5d0a0df2d7bead94$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  width: 100%;\n  display: block;\n  transition: 0.4s;\n  padding-left: 16px;\n  padding-right: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  line-height: 44px;\n  pointer-events: none;\n  user-select: none;\n  color: ",
        ";\n  z-index: 1;\n  white-space: nowrap;\n  text-align: right;\n  p {\n    display: inline-block;\n    transition: 0.4s;\n  }\n"
    ]);
    $5d0a0df2d7bead94$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $5d0a0df2d7bead94$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  border: none;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  padding: 12px 16px;\n  font-size: 16px;\n  box-sizing: border-box;\n  outline: none;\n  color: ",
        ";\n  transition: 0.4s;\n  &:empty {\n    + ",
        " {\n      width: 0;\n    }\n  }\n  &:focus,\n  &:not(:placeholder-shown) {\n    color: ",
        ";\n    + ",
        " {\n      width: 100%;\n      p {\n        transform-origin: right;\n        transform: scale(0.8);\n      }\n      /* The 0.5 is to fix a bug with overflow */\n    }\n  }\n"
    ]);
    $5d0a0df2d7bead94$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $5d0a0df2d7bead94$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($5d0a0df2d7bead94$var$_templateObject(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.theme.cta;
}, function(props) {
    return props.theme.cta;
});
var $5d0a0df2d7bead94$var$Label = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).label($5d0a0df2d7bead94$var$_templateObject1(), function(props) {
    return props.theme.shade[20];
});
var $5d0a0df2d7bead94$var$InnerInput = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $ab7866b2c4bd0902$export$3437cf0602f97db7))($5d0a0df2d7bead94$var$_templateObject2(), function(props) {
    return props.label == undefined ? props.theme.shade[0] : props.theme.shade[100];
}, $5d0a0df2d7bead94$var$Label, function(props) {
    return props.theme.shade[0];
}, $5d0a0df2d7bead94$var$Label);
function $5d0a0df2d7bead94$export$fa30d7d8e94ad780(props) {
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState({
        labelWidth: 0
    }), 2), dimensions = _React_useState[0], setDimensions = _React_useState[1];
    var labelRef = (0, $hAGkE.useRef)(null);
    (0, $hAGkE.useEffect)(function() {
        setDimensions({
            labelWidth: labelRef.current.clientWidth
        });
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($5d0a0df2d7bead94$var$Container, {
        disabled: props.disabled,
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($5d0a0df2d7bead94$var$InnerInput, (0, $hRCmZ._)({
                type: "text",
                id: props.id,
                disabled: props.disabled,
                placeholder: props.placeholder,
                value: props.value,
                formattedValue: props.formattedValue,
                floatValue: props.floatValue,
                onChange: props.onChange,
                onClick: props.onClick,
                labelOffset: dimensions.labelWidth
            }, props)),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($5d0a0df2d7bead94$var$Label, {
                htmlFor: props.id,
                disabled: props.disabled,
                ref: labelRef,
                children: props.label
            })
        ]
    });
}
$5d0a0df2d7bead94$export$fa30d7d8e94ad780.PropTypes = {
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string
};



function $0d32b05aa08bb0a5$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: ",
        ";\n  margin-bottom: 1rem;\n"
    ]);
    $0d32b05aa08bb0a5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0d32b05aa08bb0a5$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: #000928;\n  position: relative;\n  height: 50px;\n  width: 50px;\n  background: #000928;\n  position: relative;\n  top: 50px;\n  left: -45px;\n  z-index: 10;\n  border-radius: 8px 0px 0px 8px;\n  margin-top: -50px;\n\n  p {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    color: white;\n  }\n"
    ]);
    $0d32b05aa08bb0a5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0d32b05aa08bb0a5$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n"
    ]);
    $0d32b05aa08bb0a5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $0d32b05aa08bb0a5$var$ErrorStyles = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0d32b05aa08bb0a5$var$_templateObject(), function(param) {
    var theme = param.theme;
    return theme.error;
});
var $0d32b05aa08bb0a5$var$CurrencyPrefix = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0d32b05aa08bb0a5$var$_templateObject1());
var $0d32b05aa08bb0a5$var$InputWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($0d32b05aa08bb0a5$var$_templateObject2());
function $0d32b05aa08bb0a5$export$2e2bcd8739ae039(param) {
    var value = param.value, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {} : _param_onBlur, _param_onDone = param.onDone, onDone = _param_onDone === void 0 ? function(value, errors) {} : _param_onDone, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange, id = param.id, label = param.label, error = param.error, _param_min = param.min, min = _param_min === void 0 ? null : _param_min, _param_max = param.max, max = _param_max === void 0 ? null : _param_max, _param_allowEmpty = param.allowEmpty, allowEmpty = _param_allowEmpty === void 0 ? true : _param_allowEmpty, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function(e) {} : _param_onKeyDown, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "" : _param_placeholder, _param_currencyPrefix = param.currencyPrefix, currencyPrefix = _param_currencyPrefix === void 0 ? false : _param_currencyPrefix, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var _value_toString, _value_toString1;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)((value === null || value === void 0 ? void 0 : (_value_toString1 = value.toString) === null || _value_toString1 === void 0 ? void 0 : (_value_toString = _value_toString1.call(value)) === null || _value_toString === void 0 ? void 0 : _value_toString.length) > 0 ? value : ""), 2), input = _useState[0], setInput = _useState[1];
    (0, $hAGkE.useEffect)(function() {
        var clamped = input;
        if (allowEmpty === false && !input) clamped = 0;
        if (min !== null && input < min) clamped = min;
        if (max !== null && input > max) clamped = max;
        if (clamped !== input) setInput(clamped);
        handleDone(false);
    }, [
        input
    ]);
    function handleDone(submit) {
        if (input === null || isNaN(parseFloat(input === null || input === void 0 ? void 0 : input.toString()))) {
            onDone(null, null, false);
            return;
        }
        onDone(input, null, submit);
    }
    function handleInput(numeric) {
        setInput(numeric);
        onChange(numeric);
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($0d32b05aa08bb0a5$var$InputWrapper, {
        children: [
            error && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0d32b05aa08bb0a5$var$ErrorStyles, {
                children: error
            }),
            currencyPrefix && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($0d32b05aa08bb0a5$var$CurrencyPrefix, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "\xa3"
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $5d0a0df2d7bead94$export$fa30d7d8e94ad780), {
                disabled: disabled,
                prefix: "\xa3",
                placeholder: placeholder,
                value: input,
                onBlur: onBlur,
                label: label,
                autoComplete: "off",
                onKeyDown: function(e) {
                    return onKeyDown(e);
                },
                onValueChange: function(e) {
                    return handleInput(e.floatValue);
                },
                thousandSeparator: true,
                id: id !== null && id !== void 0 ? id : "currency-".concat(id)
            })
        ]
    });
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");


parcelRequire("hAGkE");


function $12028740a794908e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  overflow: auto;\n  border: 1px solid ",
        ";\n  max-height: 240px;\n  :empty {\n    display: none;\n  }\n"
    ]);
    $12028740a794908e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $12028740a794908e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 16px;\n  cursor: pointer;\n  border-top: 1px solid ",
        ";\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    $12028740a794908e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $12028740a794908e$var$List = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($12028740a794908e$var$_templateObject(), function(props) {
    return props.theme.shade[100];
}, function(props) {
    return props.theme.shade[60];
});
var $12028740a794908e$var$ListItem = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($12028740a794908e$var$_templateObject1(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.theme.shade[80];
});
function $12028740a794908e$export$72b9695b8216309a(param) {
    var label = param.label, value = param.value, onInputChanged = param.onInputChanged, comboSelections = param.comboSelections, onSelectionMade = param.onSelectionMade, isLoading = param.isLoading, disabled = param.disabled, id = param.id;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d7e095253493ce8$exports))), {
                value: value,
                onChange: onInputChanged,
                label: label,
                isLoading: isLoading,
                disabled: disabled,
                id: "".concat(id, "-input")
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($12028740a794908e$var$List, {
                id: "".concat(id, "-list"),
                children: comboSelections && comboSelections.map(function(selection, i) {
                    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($12028740a794908e$var$ListItem, {
                        id: "".concat(id, "-list-item-").concat(selection.id || i),
                        onClick: function() {
                            return onSelectionMade(selection);
                        },
                        children: selection.text
                    }, selection.text);
                })
            })
        ]
    });
}






function $92b2cf0d7a14dc4e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  display: flex;\n  align-items: center;\n  margin: 12px 0;\n  font-size: 1.1em;\n\n  label {\n    cursor: pointer;\n  }\n\n  input[type="checkbox"] {\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    margin-bottom: 3px;\n  }\n'
    ]);
    $92b2cf0d7a14dc4e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $92b2cf0d7a14dc4e$export$addcfd1845ef33fe = [
    {
        code: "ACC",
        name: "Accord"
    },
    {
        code: "FTB",
        name: "AIB"
    },
    {
        code: "ALD",
        name: "Aldermore Mortgages"
    },
    {
        code: "ABC",
        name: "Alternative Bridging Corporation"
    },
    {
        code: "BOC",
        name: "Bank Of China (UK)"
    },
    {
        code: "BOI",
        name: "Bank Of Ireland"
    },
    {
        code: "BWO",
        name: "Barclays Bank"
    },
    {
        code: "BBB",
        name: "Bath BS"
    },
    {
        code: "BPK",
        name: "Bespoke by BOI"
    },
    {
        code: "BBV",
        name: "Beverley BS"
    },
    {
        code: "BST",
        name: "Bluestone Mortgages"
    },
    {
        code: "CHY",
        name: "BM Solutions"
    },
    {
        code: "BBU",
        name: "Buckinghamshire BS"
    },
    {
        code: "CAM",
        name: "Cambridge BS"
    },
    {
        code: "CNT",
        name: "Central Trust Limited"
    },
    {
        code: "BCH",
        name: "Chelsea BS"
    },
    {
        code: "BCO",
        name: "Chorley BS"
    },
    {
        code: "CLY",
        name: "Clydesdale Bank"
    },
    {
        code: "BCV",
        name: "Coventry BS"
    },
    {
        code: "DAN",
        name: "Danske Bank"
    },
    {
        code: "BDA",
        name: "Darlington BS"
    },
    {
        code: "ATM",
        name: "Digital Mortgages"
    },
    {
        code: "DUD",
        name: "Dudley BS"
    },
    {
        code: "EOS",
        name: "Earl Shilton BS"
    },
    {
        code: "EQF",
        name: "Equifinance"
    },
    {
        code: "FAM",
        name: "Family Building Society (NCBS)"
    },
    {
        code: "FLE",
        name: "Fleet Mortgages"
    },
    {
        code: "FHL",
        name: "Foundation Home Loans"
    },
    {
        code: "BFU",
        name: "Furness BS"
    },
    {
        code: "GHB",
        name: "Gatehouse Bank"
    },
    {
        code: "GLH",
        name: "Glenhawk"
    },
    {
        code: "GOD",
        name: "Godiva Mortgages"
    },
    {
        code: "HBO",
        name: "Habito"
    },
    {
        code: "BHX",
        name: "Halifax"
    },
    {
        code: "HTB",
        name: "Hampshire Trust Bank"
    },
    {
        code: "HEC",
        name: "Hanley Economic BS"
    },
    {
        code: "BHP",
        name: "Harpenden BS"
    },
    {
        code: "BHI",
        name: "Hinckley & Rugby BS"
    },
    {
        code: "HLT",
        name: "Hodge"
    },
    {
        code: "HSB",
        name: "HSBC"
    },
    {
        code: "ITB",
        name: "Interbay"
    },
    {
        code: "BIP",
        name: "Ipswich BS"
    },
    {
        code: "JUS",
        name: "Just"
    },
    {
        code: "KMC",
        name: "Kensington Mortgages"
    },
    {
        code: "KBS",
        name: "Kent Reliance"
    },
    {
        code: "KEY",
        name: "Keystone"
    },
    {
        code: "LDB",
        name: "Landbay"
    },
    {
        code: "BLH",
        name: "Leeds BS"
    },
    {
        code: "LEE",
        name: "Leek United BS"
    },
    {
        code: "LAG",
        name: "Legal & General Home Finance"
    },
    {
        code: "LIV",
        name: "LendInvest"
    },
    {
        code: "LIM",
        name: "LiveMore"
    },
    {
        code: "CTE",
        name: "Lloyds Bank"
    },
    {
        code: "BLF",
        name: "Loughborough BS"
    },
    {
        code: "BMN",
        name: "Mansfield BS"
    },
    {
        code: "BMH",
        name: "Market Harborough BS"
    },
    {
        code: "BMS",
        name: "Marsden BS"
    },
    {
        code: "MSV",
        name: "Masthaven"
    },
    {
        code: "MBS",
        name: "MBS Lending Ltd"
    },
    {
        code: "MET",
        name: "Metro Bank"
    },
    {
        code: "MOL",
        name: "Molo Finance"
    },
    {
        code: "BMO",
        name: "Monmouthshire BS"
    },
    {
        code: "MQU",
        name: "MPowered Mortgages"
    },
    {
        code: "BNW",
        name: "Nationwide BS"
    },
    {
        code: "CNW",
        name: "NatWest"
    },
    {
        code: "BNE",
        name: "Newbury BS"
    },
    {
        code: "NBS",
        name: "Newcastle BS"
    },
    {
        code: "NTN",
        name: "Norton Home Loans"
    },
    {
        code: "BNT",
        name: "Nottingham BS"
    },
    {
        code: "OCT",
        name: "Octane Capital"
    },
    {
        code: "DGF",
        name: "Octopus Property"
    },
    {
        code: "FSH",
        name: "Oplo"
    },
    {
        code: "PPF",
        name: "Paragon Bank Plc"
    },
    {
        code: "PAR",
        name: "Paragon Banking Group PLC"
    },
    {
        code: "PET",
        name: "Penrith BS"
    },
    {
        code: "PEP",
        name: "Pepper Money"
    },
    {
        code: "CTS",
        name: "Platform"
    },
    {
        code: "POS",
        name: "Post Office"
    },
    {
        code: "PRE",
        name: "Precise Mortgages"
    },
    {
        code: "BPR",
        name: "Principality BS"
    },
    {
        code: "BPG",
        name: "Progressive BS"
    },
    {
        code: "REB",
        name: "Reliance Bank"
    },
    {
        code: "BSA",
        name: "Saffron BS"
    },
    {
        code: "CAN",
        name: "Santander UK Plc"
    },
    {
        code: "BSO",
        name: "Scottish BS"
    },
    {
        code: "BAA",
        name: "Scottish Widows Bank"
    },
    {
        code: "SEL",
        name: "Selina Finance"
    },
    {
        code: "SHB",
        name: "Shawbrook Bank"
    },
    {
        code: "SBS",
        name: "Skipton BS"
    },
    {
        code: "SKI",
        name: "Skipton International"
    },
    {
        code: "SRB",
        name: "Stafford Railway BS"
    },
    {
        code: "SBI",
        name: "State Bank of India UK"
    },
    {
        code: "SWA",
        name: "Swansea BS"
    },
    {
        code: "TBS",
        name: "Teachers BS"
    },
    {
        code: "BME",
        name: "The Melton BS"
    },
    {
        code: "TML",
        name: "The Mortgage Lender"
    },
    {
        code: "CCN",
        name: "The Mortgage Works"
    },
    {
        code: "TIP",
        name: "Tipton & Coseley BS"
    },
    {
        code: "TSB",
        name: "TSB"
    },
    {
        code: "UTB",
        name: "United Trust Bank"
    },
    {
        code: "VBS",
        name: "Vernon BS"
    },
    {
        code: "VDA",
        name: "Vida Homeloans"
    },
    {
        code: "BNR",
        name: "Virgin Money"
    },
    {
        code: "WBB",
        name: "West Bromwich Building Society"
    },
    {
        code: "WBC",
        name: "West Bromwich Commercial Limited"
    },
    {
        code: "WTO",
        name: "West One Secured Loans Ltd"
    },
    {
        code: "YOR",
        name: "Yorkshire Bank"
    },
    {
        code: "YBS",
        name: "Yorkshire Building Society"
    },
    {
        code: "ZPR",
        name: "Zephyr Homeloans"
    }
];
var $92b2cf0d7a14dc4e$var$LenderNotShown = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($92b2cf0d7a14dc4e$var$_templateObject());
function $92b2cf0d7a14dc4e$export$2e2bcd8739ae039(param) {
    var question = param.question, value = param.value, onDone = param.onDone;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)((value === null || value === void 0 ? void 0 : value.name) || ""), 2), input = _useState[0], setInput = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)([]), 2), lenderList = _useState1[0], setLenderList = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), notShown = _useState2[0], setNotShown = _useState2[1];
    (0, $hAGkE.useEffect)(function() {
        setLenderList([]);
        if (notShown) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).sectionLenderLookup,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).notShownCheckbox
            });
            onDone("NONE");
        } else HandleInput(input);
    }, [
        notShown
    ]);
    (0, $hAGkE.useEffect)(function() {
        HandleInput(input);
    }, [
        input
    ]);
    function HandleInput(input) {
        var lender = $92b2cf0d7a14dc4e$export$addcfd1845ef33fe.find(function(x) {
            return x.name === input;
        });
        if (!lender) {
            onDone(null);
            return;
        }
        onDone({
            name: lender.name,
            code: lender.code
        });
    }
    function filterLenders(text) {
        setInput(text);
        if (text) setLenderList($92b2cf0d7a14dc4e$export$addcfd1845ef33fe.filter(function(x) {
            return x.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
        }));
        else setLenderList([]);
    }
    function HandleSelected(selection) {
        if (!selection) {
            onDone(null);
            return;
        }
        setInput(selection.text);
        setLenderList([]);
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $12028740a794908e$export$72b9695b8216309a), {
                value: input,
                disabled: notShown,
                onInputChanged: function(e) {
                    return filterLenders(e.target.value);
                },
                comboSelections: lenderList.map(function(x) {
                    var id = x.code;
                    var text = x.name;
                    return {
                        id: id,
                        text: text
                    };
                }),
                onSelectionMade: function(selection) {
                    return HandleSelected(selection);
                },
                id: "lookup-lender"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($92b2cf0d7a14dc4e$var$LenderNotShown, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f294cc4c227dd6d2$export$48513f6b9f8ce62d), {
                        id: "checkbox-lender-lookup-".concat(question.id),
                        checked: notShown,
                        onChange: function() {
                            return setNotShown(!notShown);
                        }
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("label", {
                        htmlFor: "checkbox-lender-lookup-".concat(question.id),
                        children: "My lender is not shown here"
                    })
                ]
            })
        ]
    });
}



var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");


var $hAGkE = parcelRequire("hAGkE");

function $195ca2e59ead2d82$export$2e2bcd8739ae039(fn, inputs) {
    var didMount = (0, $e7b15d37613b87c9$export$2e2bcd8739ae039)();
    (0, $hAGkE.useEffect)(function() {
        if (didMount) fn();
    }, inputs);
}



var $1976908833cc852a$export$8b9486222b0d2995 = /*#__PURE__*/ function(DateFlag) {
    DateFlag[DateFlag["DateOfBirth"] = 0] = "DateOfBirth";
    DateFlag[DateFlag["FutureDate"] = 1] = "FutureDate";
    DateFlag[DateFlag["PastDate"] = 2] = "PastDate";
    return DateFlag;
}({});
var $1976908833cc852a$export$50a48c78a350e041 = /*#__PURE__*/ function(DateFormat) {
    DateFormat["Normal"] = "DD/MM/YYYY";
    DateFormat["Short"] = "MM/YYYY";
    return DateFormat;
}({});
function $1976908833cc852a$export$7edc06cf1783b30f(param) {
    var value = param.value, onDone = param.onDone, _param_format = param.format, format = _param_format === void 0 ? "DD/MM/YYYY" : _param_format, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id, _param_dateFlags = param.dateFlags, dateFlags = _param_dateFlags === void 0 ? [] : _param_dateFlags, onKeyDown = param.onKeyDown, disabled = param.disabled;
    var _format_replace;
    var placeholder = format;
    var inputFormat = format.replace(new RegExp("[A-Za-z]", "g"), "#");
    var inputMask = new Array((_format_replace = format.replace("/", "")) === null || _format_replace === void 0 ? void 0 : _format_replace.length).fill("_");
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(value || null), 2), date = _useState[0], setDate = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(value ? parseDateObject(value) : ""), 2), friendlyDate = _useState1[0], setFriendlyDate = _useState1[1];
    (0, $195ca2e59ead2d82$export$2e2bcd8739ae039)(function() {
        var parsedDate = parseFriendlyString(friendlyDate);
        saveDate(parsedDate);
    }, [
        friendlyDate
    ]);
    function saveDate(saveDate) {
        var foundErrors = [];
        if (friendlyDate.length < 1 || friendlyDate.includes("_")) {
            setDate(null);
            onDone(null, []);
            return;
        } else if (!(0, $45f64f2ccb2647eb$export$90468357bd30a7ec)(friendlyDate, format, true)) foundErrors.push("Please enter a valid date");
        else {
            var yearDiff = (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(new Date(), saveDate, "year");
            var dayDiff = (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(new Date(), saveDate, "day");
            if (yearDiff < -100) foundErrors.push("Please enter a date within the last 100 years");
            if (dateFlags.includes(0)) {
                var age = (0, $45f64f2ccb2647eb$export$4e8e665eb8b06bae)(saveDate, new Date(), "year");
                if (age < 18 || age > 75) foundErrors.push("Applicants must be aged between 18 and 75 years old");
            }
            if (dateFlags.includes(2)) {
                if (dayDiff > 0) foundErrors.push("Please enter a date in the past");
            }
            if (dateFlags.includes(1)) {
                if (dayDiff < 0) foundErrors.push("Please enter a date in the future");
                if (dayDiff > 36500) foundErrors.push("Please enter a date within the next 100 years");
            }
        }
        if (foundErrors.length > 0 && !friendlyDate.includes("_") && friendlyDate.length) {
            setDate(null);
            onDone(null, [
                foundErrors[0]
            ]);
            return;
        }
        setDate(saveDate);
        onDone(saveDate);
    }
    function parseDateObject(date) {
        return (0, $45f64f2ccb2647eb$export$68962dbd27cd2e36)(date, placeholder);
    }
    function parseFriendlyString(friendly) {
        return (0, $45f64f2ccb2647eb$export$b00030cc143c3fde)(friendly, format);
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $5d0a0df2d7bead94$export$fa30d7d8e94ad780), {
        disabled: disabled,
        format: inputFormat,
        placeholder: placeholder,
        mask: inputMask,
        autoComplete: "off",
        onChange: function(e) {
            return setFriendlyDate(e.target.value);
        },
        onKeyDown: function(e) {
            return onKeyDown && onKeyDown(e);
        },
        value: friendlyDate,
        id: id
    });
}



var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");

function $8d5e54a8878ad406$export$2e2bcd8739ae039(param) {
    var value = param.value, onDone = param.onDone, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function(e) {} : _param_onKeyDown, placeholder = param.placeholder;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(value), 2), input = _useState[0], setInput = _useState[1];
    var mounted = (0, $hAGkE.useRef)(false);
    (0, $hAGkE.useEffect)(function() {
        var errors = [];
        if (mounted.current) onDone(+input, errors);
        else mounted.current = true;
    }, [
        input
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $ecac119a7e094d08$export$f5b8910cec6cf069), {
        value: input,
        inputMode: "decimal",
        onKeyDown: function(e) {
            return onKeyDown(e);
        },
        onChange: function(e) {
            return handleChange(e.target.value);
        },
        id: "number-".concat(id.toLowerCase()),
        autoComplete: "off",
        placeholder: placeholder
    });
    function handleChange(newValue) {
        var numberRegex = /^[0-9]*$/;
        if (numberRegex.test(newValue.toString())) setInput(newValue);
    }
}




parcelRequire("hAGkE");



function $ca912bece0a2d39e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0.5rem 0;\n  position: relative;\n\n  ",
        "\n\n  > * * {\n    font-size: 14px;\n  }\n"
    ]);
    $ca912bece0a2d39e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ca912bece0a2d39e$var$ButtonWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($ca912bece0a2d39e$var$_templateObject(), function(param) {
    var hasTooltip = param.hasTooltip;
    return hasTooltip && "\n	label {\n		padding-right: 45px;\n	}";
});
function $ca912bece0a2d39e$export$1e7dfd31545b5809(param) {
    var id = param.id, options = param.options, _param_value = param.value, value = _param_value === void 0 ? [] : _param_value, onClick = param.onClick;
    var handleClick = function(e) {
        var val = e.target.value;
        var values = new Set(value);
        if (values.has(val)) values["delete"](val);
        else {
            val === "unknown" ? values.clear() : values["delete"]("unknown");
            val === "none" ? values.clear() : values["delete"]("none");
            values.add(val);
        }
        onClick(Array.from(values));
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: options.map(function(option, index) {
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($ca912bece0a2d39e$var$ButtonWrapper, {
                hasTooltip: !!option.tooltip,
                children: [
                    option.tooltip && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $84617fd3a377d5e1$export$28c660c63b792dea), {
                        id: id + "tooltip",
                        questionMarkColor: value.includes(option.value) ? (0, $84617fd3a377d5e1$export$7a7c7a2506c3719d).WHITE : (0, $84617fd3a377d5e1$export$7a7c7a2506c3719d).NAVY,
                        option: option
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ef6dfd5f7ad8c04$exports))), {
                        name: "".concat(id).concat(index),
                        value: option.value,
                        checked: value === null || value === void 0 ? void 0 : value.includes(option.value),
                        onClick: handleClick,
                        id: "radio-".concat(id, "-").concat(index, "-").concat(option.value),
                        children: option.text
                    })
                ]
            }, id + option.text + index);
        })
    });
}



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");



parcelRequire("hAGkE");
var $5ca4a85b84674076$exports = {};
$5ca4a85b84674076$exports = $parcel$resolve("79key");



function $93bac05c73e3f6ac$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  font-weight: 500;\n  margin: 16px 0 0 0;\n"
    ]);
    $93bac05c73e3f6ac$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $93bac05c73e3f6ac$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  display: block;\n  width: 100%;\n  padding: 13px 35px 13px 17px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  box-sizing: border-box;\n  outline: none;\n  background-color: ",
        ';\n  background-image: url("',
        '");\n  background-position: right 20px top calc(50% - 2px);\n  background-repeat: no-repeat;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 1px;\n  text-overflow: ellipsis;\n  &:focus {\n    border: 1px solid ',
        ";\n    box-shadow: 0 0 0 1px ",
        ";\n  }\n"
    ]);
    $93bac05c73e3f6ac$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $93bac05c73e3f6ac$var$Label = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).label($93bac05c73e3f6ac$var$_templateObject());
var $93bac05c73e3f6ac$var$Select = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).select($93bac05c73e3f6ac$var$_templateObject1(), function(props) {
    return props.theme.shade[60];
}, function(props) {
    return props.value === "" ? props.theme.shade[20] : props.theme.shade[0];
}, function(props) {
    return props.theme.radius["default"];
}, function(props) {
    return props.disabled ? props.theme.shade[80] : props.theme.shade[100];
}, (0, (/*@__PURE__*/$parcel$interopDefault($5ca4a85b84674076$exports))), function(props) {
    return props.theme.cta;
}, function(props) {
    return props.theme.cta;
});
var $93bac05c73e3f6ac$export$d6701e98ab1a6725 = function(param) {
    var defaultOptionText = param.defaultOptionText, label = param.label, id = param.id, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {} : _param_onBlur, onChange = param.onChange, options = param.options, value = param.value;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($93bac05c73e3f6ac$var$Label, {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($93bac05c73e3f6ac$var$Select, {
                id: id,
                value: value,
                onBlur: onBlur,
                onChange: function(e) {
                    return onChange(e.target.value);
                },
                style: {
                    height: null
                },
                children: [
                    defaultOptionText && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("option", {
                        value: "",
                        disabled: true,
                        children: defaultOptionText
                    }),
                    options.map(function(param) {
                        var text = param.text, value = param.value;
                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("option", {
                            value: value,
                            children: text
                        }, value);
                    })
                ]
            })
        ]
    });
};



function $f04be037e2a741aa$export$2e2bcd8739ae039(event, callback) {
    if (event.key === "Enter") callback();
}


function $d2f620250b0be24b$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-gap: 8px;\n"
    ]);
    $d2f620250b0be24b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d2f620250b0be24b$var$Layout = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($d2f620250b0be24b$var$_templateObject());
var $d2f620250b0be24b$var$Title = /*#__PURE__*/ function(Title) {
    Title["Mr"] = "Mr";
    Title["Mrs"] = "Mrs";
    Title["Miss"] = "Miss";
    Title["Ms"] = "Ms";
    Title["Mx"] = "Mx";
    Title["Dr"] = "Dr";
    Title["Professor"] = "Professor";
    Title["Reverend"] = "Reverend";
    Title["Sir"] = "Sir";
    Title["Lord"] = "Lord";
    Title["Other"] = "Other";
    return Title;
}($d2f620250b0be24b$var$Title || {});
var $d2f620250b0be24b$var$titleOptions = Object.values($d2f620250b0be24b$var$Title).map(function(value) {
    return {
        text: value,
        value: value
    };
});
function $d2f620250b0be24b$export$2e2bcd8739ae039(param) {
    var value = param.value, onDone = param.onDone, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)((value === null || value === void 0 ? void 0 : value.firstName) || ""), 2), firstName = _useState[0], setFirstName = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)((value === null || value === void 0 ? void 0 : value.lastName) || ""), 2), lastName = _useState1[0], setLastName = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)((value === null || value === void 0 ? void 0 : value.title) || ""), 2), title = _useState2[0], setTitle = _useState2[1];
    (0, $hAGkE.useEffect)(function() {
        handleComplete();
    }, [
        title,
        firstName,
        lastName
    ]);
    function handleComplete() {
        if ((firstName === null || firstName === void 0 ? void 0 : firstName.trim().length) > 0 && (lastName === null || lastName === void 0 ? void 0 : lastName.trim().length) > 0 && (title === null || title === void 0 ? void 0 : title.trim().length) > 0) onDone({
            firstName: firstName,
            lastName: lastName,
            title: title
        });
        else onDone(null);
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($d2f620250b0be24b$var$Layout, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $93bac05c73e3f6ac$export$d6701e98ab1a6725), {
                defaultOptionText: "Select title",
                id: id + "-title-select",
                options: $d2f620250b0be24b$var$titleOptions,
                value: title,
                onChange: setTitle
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                id: "firstName-" + id,
                value: firstName,
                onKeyDown: function(e) {
                    return (0, $f04be037e2a741aa$export$2e2bcd8739ae039)(e, handleComplete);
                },
                onChange: setFirstName,
                suffix: "First Name",
                placeholder: "First Name"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                id: "lastName-" + id,
                value: lastName,
                onKeyDown: function(e) {
                    return (0, $f04be037e2a741aa$export$2e2bcd8739ae039)(e, handleComplete);
                },
                onChange: setLastName,
                suffix: "Last Name",
                placeholder: "Last Name"
            })
        ]
    });
}





parcelRequire("hAGkE");


function $319b8b72477c1e47$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  font-size: 35px;\n  justify-content: space-evenly;\n"
    ]);
    $319b8b72477c1e47$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $319b8b72477c1e47$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($319b8b72477c1e47$var$_templateObject());
var $319b8b72477c1e47$var$test = "".concat(function(props) {
    return props.theme.primaryOne;
});
var $319b8b72477c1e47$export$fc62ba923d2898ab = function(param) {
    var currentStars = param.currentStars;
    var getStars = function() {
        var stars = [];
        for(var i = 0; i < 5; i++)if (i <= 5) stars.push(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $37d2494f62bb4b07$export$1644ba17714857f1), {
            color: "#0045FF",
            status: i < currentStars ? (0, $37d2494f62bb4b07$export$4e24cdfa30bb8ed4).Filled : (0, $37d2494f62bb4b07$export$4e24cdfa30bb8ed4).Outline
        }));
        return stars;
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($319b8b72477c1e47$var$Container, {
        children: getStars()
    });
};



var $6mdMa = parcelRequire("6mdMa");



var $hAGkE = parcelRequire("hAGkE");






function $877c8ed18ef88a13$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  display: flex;\n  align-items: center;\n  margin: 12px 0;\n  font-size: 1.1em;\n\n  label {\n    cursor: pointer;\n  }\n\n  input[type="checkbox"] {\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    margin-bottom: 3px;\n  }\n'
    ]);
    $877c8ed18ef88a13$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $877c8ed18ef88a13$var$DateNotKnown = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($877c8ed18ef88a13$var$_templateObject());
function $877c8ed18ef88a13$export$2e2bcd8739ae039(param) {
    var id = param.id, question = param.question, value = param.value, onKeyDown = param.onKeyDown, onDone = param.onDone;
    var mappedQuestion = question;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), notKnown = _useState[0], setNotKnown = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(value), 2), dateValue = _useState1[0], setDateValue = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)([]), 2), errors = _useState2[0], setErrors = _useState2[1];
    (0, $hAGkE.useEffect)(function() {
        if (notKnown) {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).sectionCurrentDealEndDate,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
                event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).unknownCheckbox
            });
            onDone("NONE", []);
        } else onDone(dateValue, errors);
    }, [
        notKnown
    ]);
    (0, $hAGkE.useEffect)(function() {
        onDone(dateValue, errors);
    }, [
        dateValue,
        errors
    ]);
    function HandleOnDateChange(value, errors) {
        var lastDayOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($ddb542feed52691a$exports)))(value).endOf("month").set("hour", 14).toDate().toString();
        setDateValue(lastDayOfMonth);
        setErrors(errors);
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1976908833cc852a$export$7edc06cf1783b30f), {
                id: id,
                value: dateValue,
                dateFlags: [
                    (0, $1976908833cc852a$export$8b9486222b0d2995).FutureDate
                ],
                format: (0, $1976908833cc852a$export$50a48c78a350e041).Short,
                onKeyDown: onKeyDown,
                onDone: HandleOnDateChange,
                disabled: notKnown
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($877c8ed18ef88a13$var$DateNotKnown, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f294cc4c227dd6d2$export$48513f6b9f8ce62d), {
                        id: "checkbox-dateUnknown-lookup-".concat(question.id),
                        checked: notKnown,
                        onChange: function() {
                            return setNotKnown(!notKnown);
                        }
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("label", {
                        htmlFor: "checkbox-dateUnknown-lookup-".concat(question.id),
                        children: "I'm not sure"
                    })
                ]
            })
        ]
    });
}






parcelRequire("hAGkE");


function $9a66e4f46705a007$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  max-width: 90%;\n  margin: 0 auto;\n  @media screen and ",
        " {\n    max-width: 30em;\n  }\n"
    ]);
    $9a66e4f46705a007$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9a66e4f46705a007$var$ErrorPageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9a66e4f46705a007$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $9a66e4f46705a007$export$7d465be8efa67280 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $410d513faacc046e$export$3a51ad0132508a84), {
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9a66e4f46705a007$var$ErrorPageContainer, {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $c67218ac7986ea8b$export$d56b0569bceb92ae), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h2", {
                        children: "Something went wrong"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                        children: "Sorry, the page you were looking for could not be found. Please try again later."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                        onClick: function() {
                            window.location.href = "/";
                        },
                        text: "Go to homepage"
                    })
                ]
            })
        })
    });
};



var $iNemB = parcelRequire("iNemB");

var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");



var $b31167eef17b2c22$export$399e0cde635d2d6c = function() {
    var code = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().code;
    (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect(function() {
        var sendTo404 = function() {
            return window.location.href = "".concat(window.location.origin, "/500");
        };
        (function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
                return (0, $dMrZK.__generator)(this, function(_state) {
                    (0, $d48d778937567d64$export$155ec85c4e3b5e85).get("https://my-mojo-api.mojomortgages.com/short-url/get/".concat(code)).then(function(res) {
                        if (res.status === 200) {
                            var url = new URL(res.data.url);
                            var queryString = url.searchParams;
                            queryString.append("code", code);
                            return window.location.href = url.toString();
                        }
                        return sendTo404();
                    })["catch"](function() {
                        return sendTo404();
                    });
                    return [
                        2
                    ];
                });
            })();
        })();
    }, [
        code
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
        style: {
            display: "flex",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
            theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline,
            size: 50
        })
    });
};



var $iNemB = parcelRequire("iNemB");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $c4wKO = parcelRequire("c4wKO");

var $6mdMa = parcelRequire("6mdMa");


var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");







parcelRequire("hAGkE");




function $b8c735a9a8a17611$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 64px 0 0 0;\n  text-align: center;\n  width: 100%;\n\n  border-radius: 24px;\n\n  & > img {\n    max-width: 300px;\n    @media screen and ",
        " {\n      max-width: 100%;\n    }\n  }\n"
    ]);
    $b8c735a9a8a17611$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b8c735a9a8a17611$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 600;\n  font-size: 22px;\n\n  @media screen and ",
        " {\n    font-size: 1.66em;\n  }\n"
    ]);
    $b8c735a9a8a17611$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $b8c735a9a8a17611$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($b8c735a9a8a17611$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $b8c735a9a8a17611$var$Heading = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h5($b8c735a9a8a17611$var$_templateObject1(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
function $b8c735a9a8a17611$export$38a5f55ff6d8d994(props) {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($b8c735a9a8a17611$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9006f4a3e4450b29$exports))),
                alt: "chairs",
                style: props.imageStyle
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b8c735a9a8a17611$var$Heading, {
                style: props.headingStyle,
                children: "\u201CGreat service as always. My new purchase was done and dusted in a few days and one call.\u201D"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d064dfd92ce74522$export$f63de433e1787c6d), {})
        ]
    });
}





































var $f33ef091ff8f5c31$exports = {};
$f33ef091ff8f5c31$exports = $parcel$resolve("dgDvw");








var $de3feac646893814$exports = {};
$de3feac646893814$exports = $parcel$resolve("3zxDs");







var // "ACC" === Accord
// "ALD" === Aldermore Mortgages
// "BOI" === Bank Of Ireland
// "BWO" === Barclays Bank
// "BBB" === Bath BS
// "BPK" === Bespoke by BOI
// "BBV" === Beverley BS
// "BST" === Bluestone Mortgages
// "CHY" === BM Solutions
// "BBU" === Buckinghamshire BS
// "CAM" === Cambridge BS
// "CNT" === Central Trust Limited
// "BCO" === Chorley BS
// "CLY" === Clydesdale Bank
// "BCV" === Coventry BS
// "BDA" === Darlington BS
// "ATM" === Digital Mortgages
// "DUD" === Dudley BS
// "FAM" === Family Building Society (NCBS)
// "FLE" === Fleet Mortgages
// "FHL" === Foundation Home Loans
// "BFU" === Furness BS
// "GRH" === Generation Home
// "GOD" === Godiva Mortgages
// "BHX" === Halifax
// "HEC" === Hanley Economic BS
// "BHI" === Hinckley &amp; Rugby BS
// "HSB" === HSBC
// "KMC" === Kensington Mortgages
// "KBS" === Kent Reliance
// "LDB" === Landbay
// "BLH" === Leeds BS
// "LEE" === Leek Building Society
// "BLF" === Loughborough BS
// "BMN" === Mansfield BS
// "BMH" === Market Harborough BS
// "BMS" === Marsden BS
// "MBS" === MBS Lending Ltd
// "BME" === Melton Building Society
// "MET" === Metro Bank
// "BMO" === Monmouthshire BS
// "BNW" === Nationwide BS
// "CNW" === NatWest
// "BNE" === Newbury BS
// "NBS" === Newcastle BS
// "NTN" === Norton Home Loans
// "BNT" === Nottingham BS
// "PAR" === Paragon Banking Group PLC
// "PEP" === Pepper Money
// "CTS" === Platform
// "POS" === Post Office
// "PRE" === Precise Mortgages
// "BPR" === Principality BS
// "BPG" === Progressive BS
// "BSA" === Saffron BS
// "CAN" === Santander UK Plc
// "BSO" === Scottish BS
// "BAA" === Scottish Widows Bank
// "SHB" === Shawbrook Bank
// "SBS" === Skipton BS
// "SRB" === Stafford Railway BS
// "BIP" === Suffolk Building Society
// "TBS" === Teachers BS
// "TML" === The Mortgage Lender
// "CCN" === The Mortgage Works
// "TIP" === Tipton &amp; Coseley BS
// "BMF" === Together
// "TSB" === TSB
// "VBS" === Vernon BS
// "VDA" === Vida Homeloans
// "BNR" === Virgin Money
// "YBS" === Yorkshire Building Society
$533f43526bdcc4d8$export$2e2bcd8739ae039 = {
    ACC: (0, (/*@__PURE__*/$parcel$interopDefault($0efc45c7287da52c$exports))),
    ALD: (0, (/*@__PURE__*/$parcel$interopDefault($c60b1adf36c6d8a9$exports))),
    BOI: (0, (/*@__PURE__*/$parcel$interopDefault($0509d2c540bd3462$exports))),
    BWO: (0, (/*@__PURE__*/$parcel$interopDefault($e38755461bbba06f$exports))),
    BBB: (0, (/*@__PURE__*/$parcel$interopDefault($30ebfd813e7fe927$exports))),
    BPK: null,
    BBV: null,
    BST: (0, (/*@__PURE__*/$parcel$interopDefault($e96a4c5b4e99e02b$exports))),
    CHY: (0, (/*@__PURE__*/$parcel$interopDefault($1dcf217bfdd2b676$exports))),
    BBU: null,
    CAM: (0, (/*@__PURE__*/$parcel$interopDefault($e5f2dbcdcf43b7c3$exports))),
    CNT: null,
    BCO: null,
    CLY: (0, (/*@__PURE__*/$parcel$interopDefault($9212f2e5d7320264$exports))),
    BCV: (0, (/*@__PURE__*/$parcel$interopDefault($f37d84284fbb7f10$exports))),
    BDA: null,
    ATM: (0, (/*@__PURE__*/$parcel$interopDefault($1556f56548b87c60$exports))),
    DUD: null,
    FAM: null,
    FLE: null,
    FHL: null,
    BFU: null,
    GOD: null,
    GRH: (0, (/*@__PURE__*/$parcel$interopDefault($7f98f3c52f4cc10f$exports))),
    BHX: (0, (/*@__PURE__*/$parcel$interopDefault($7e134591de1923c5$exports))),
    HEC: null,
    BHI: (0, (/*@__PURE__*/$parcel$interopDefault($1d58b588e6153f0e$exports))),
    HSB: (0, (/*@__PURE__*/$parcel$interopDefault($a5b12f987bfeca92$exports))),
    KMC: (0, (/*@__PURE__*/$parcel$interopDefault($0c09f1df53f7d209$exports))),
    KBS: (0, (/*@__PURE__*/$parcel$interopDefault($19d003764ed254c5$exports))),
    LDB: (0, (/*@__PURE__*/$parcel$interopDefault($ac968029ec22cd4e$exports))),
    BLH: (0, (/*@__PURE__*/$parcel$interopDefault($408baacee6c217af$exports))),
    LEE: (0, (/*@__PURE__*/$parcel$interopDefault($16063fb73c70fe08$exports))),
    BLF: null,
    BMN: (0, (/*@__PURE__*/$parcel$interopDefault($5e5b7677872fd52c$exports))),
    BMH: null,
    BMS: null,
    MBS: null,
    BME: null,
    MET: (0, (/*@__PURE__*/$parcel$interopDefault($098ad9e5d87660fe$exports))),
    BMO: (0, (/*@__PURE__*/$parcel$interopDefault($9777123119c99085$exports))),
    BNW: (0, (/*@__PURE__*/$parcel$interopDefault($ea215c24df23aa3a$exports))),
    CNW: (0, (/*@__PURE__*/$parcel$interopDefault($96bb9dfe48f7fb4d$exports))),
    BNE: null,
    NBS: (0, (/*@__PURE__*/$parcel$interopDefault($1a400656bd0267b9$exports))),
    NTN: null,
    BNT: (0, (/*@__PURE__*/$parcel$interopDefault($2e17472ad3c44731$exports))),
    PAR: (0, (/*@__PURE__*/$parcel$interopDefault($e0e2fd6c82bfe480$exports))),
    PEP: (0, (/*@__PURE__*/$parcel$interopDefault($f33ef091ff8f5c31$exports))),
    CTS: (0, (/*@__PURE__*/$parcel$interopDefault($69a429b4469297de$exports))),
    POS: null,
    PRE: (0, (/*@__PURE__*/$parcel$interopDefault($cb32c6b952445412$exports))),
    BPR: (0, (/*@__PURE__*/$parcel$interopDefault($74183225e644af0a$exports))),
    BPG: (0, (/*@__PURE__*/$parcel$interopDefault($97c899a48244fd96$exports))),
    BSA: null,
    CAN: (0, (/*@__PURE__*/$parcel$interopDefault($8a631646da94dc2b$exports))),
    BSO: (0, (/*@__PURE__*/$parcel$interopDefault($de3feac646893814$exports))),
    BAA: (0, (/*@__PURE__*/$parcel$interopDefault($e033c316123822c6$exports))),
    SHB: null,
    SBS: (0, (/*@__PURE__*/$parcel$interopDefault($9bf8d4480545e9fb$exports))),
    SRB: null,
    BIP: null,
    TBS: null,
    TML: null,
    CCN: (0, (/*@__PURE__*/$parcel$interopDefault($f1b82724c15eb9d2$exports))),
    TIP: null,
    BMF: (0, (/*@__PURE__*/$parcel$interopDefault($7754041a26a7018f$exports))),
    TSB: (0, (/*@__PURE__*/$parcel$interopDefault($c44bb67f0b329ece$exports))),
    VBS: null,
    VDA: (0, (/*@__PURE__*/$parcel$interopDefault($46b7d2c709acd676$exports))),
    BNR: (0, (/*@__PURE__*/$parcel$interopDefault($f0748c286b41b270$exports))),
    YBS: null
};








var $38fcea7af5042917$exports = {};
$38fcea7af5042917$exports = $parcel$resolve("khzfZ");


function $9d529d00c983eb8e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 24px;\n  border-radius: 24px 24px 24px 0;\n  margin-top: 16px;\n  background: ",
        ";\n  p {\n    margin: 0;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  p {\n    margin: 0;\n    &:nth-child(2) {\n      font-size: 12px;\n    }\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  margin-top: 1em;\n  margin-bottom: 1em;\n\n  align-items: center;\n  img {\n    margin-right: 16px;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 144px;\n  margin: 20px;\n\n  @media screen and (min-width: 1700px) {\n    position: fixed;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 50px;\n  height: 50px;\n  margin-right: 20px;\n  background-image: url(",
        ");\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  border-radius: ",
        ";\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject5() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: relative;\n\n  p,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5 {\n    line-height: 180%;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject6() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject7() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 0;\n  display: ",
        ";\n  list-style: none;\n  justify-items: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject8() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: rgba(0, 176, 113, 0.1);\n  margin: 0 6px;\n  padding: 10px 12px 6px;\n  border-radius: 24px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject9() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex-direction: column;\n  min-height: 111px;\n  padding-top: 5px;\n  margin: 2px 0;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject10() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  margin-top: 24px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  font-size: 12px;\n  position: relative;\n\n  &::before {\n    content: "";\n    position: absolute;\n    border: solid thin ',
        ";\n    top: 0;\n    bottom: -1px;\n    left: -1px;\n    right: 0;\n    pointer-events: none;\n  }\n\n  > div {\n    border: 1px solid ",
        ";\n    margin-left: -1px;\n    margin-bottom: -1px;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject11() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-style: normal;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 120%;\n  margin: 8px 0;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject12() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 10px 18px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject13() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 150%;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject14() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  margin-top: 20px;\n  align-items: end;\n  grid-column-gap: 15px;\n\n  @media screen and ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media screen and ",
        " {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject15() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  font-size: 23px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject16() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-bottom: 40px;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n\n  @media screen and ",
        " {\n    margin-bottom: 0;\n  }\n\n  @media screen and ",
        " {\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject17() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  align-items: center;\n  height: 80px;\n  margin-bottom: 10px;\n\n  & > img {\n    max-height: 64px;\n    max-width: 80%;\n    margin: auto;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject18() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 12px;\n  text-align: left;\n  width: 100%;\n  color: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject19() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  border: solid\n    ",
        ";\n  max-width: 350px;\n  border-radius: 15px;\n  background: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject20() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: inline-block;\n  background: ",
        ";\n  text-align: center;\n  padding: 10px 15px;\n  border-radius: 0 0 10px 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.15rem;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject21() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n\n  @media screen and ",
        " {\n    max-width: 70%;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject22() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 100%;\n\n  @media screen and ",
        " {\n    width: auto;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject23() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  width: 100%;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject24() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  padding: 15px 0;\n  border-radius: 4px 4px 0 0;\n  background: ",
        ";\n  font-size: 12px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject25() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  justify-content: space-between;\n  border-radius: 0 0 4px 4px;\n  overflow: hidden;\n  > div {\n    padding: 15px 0;\n    width: calc(50% - 1px);\n    background: ",
        ";\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject26() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-shrink: 0;\n\n  p {\n    line-height: 180%;\n  }\n\n  @media screen and ",
        " {\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 50px;\n  }\n\n  @media screen and ",
        " {\n    grid-template-columns: 2fr 1fr;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject27() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject28() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: block;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject29() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  margin-top: 20px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject30() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 12px;\n  text-align: center;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject31() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  margin-top: -80px;\n  line-height: 180%;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject32() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-weight: 500;\n  font-size: 16px;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject33() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fee2cd;\n  z-index: -9999;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject34() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  @media screen and ",
        " {\n    margin-top: 20px;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject35() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  margin: 50px auto;\n\n  @media screen and ",
        " {\n    padding-right: 80px;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject36() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding: 15px;\n\n  @media screen and ",
        " {\n    padding: 0;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject37() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  text-align: center;\n  text-transform: uppercase;\n  margin: 80px 0;\n  font-size: 16px;\n  line-height: 300%;\n\n  & * > strong {\n    font-weight: 600;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject38() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  @media screen and ",
        " {\n    background: #ffebdc;\n    border-radius: 16px;\n    padding: 50px;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject39() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        '\n  line-height: 180%;\n  padding-left: 0;\n\n  & > li {\n    &::before {\n      content: "";\n      min-width: 16px;\n      min-height: 16px;\n      background: url(',
        ");\n      background-position: center center;\n      background-repeat: no-repeat;\n      display: block;\n      margin-right: 24px;\n    }\n\n    display: flex;\n    align-items: center;\n    padding-left: 16px;\n    margin-bottom: 24px;\n  }\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d529d00c983eb8e$var$_templateObject40() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  background: rgba(7, 62, 217, 0.05);\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    $9d529d00c983eb8e$var$_templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
var $9d529d00c983eb8e$var$DEFAULT_VALUE = "Unknown";
var $9d529d00c983eb8e$var$CHROME_EXTENSION_ID = "foffhdpjjnmidkaimgganegilhoanmog";
var $9d529d00c983eb8e$var$ORANGE_COLOUR = "#FBBB5B";
var $9d529d00c983eb8e$var$TextBox = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject(), $9d529d00c983eb8e$var$ORANGE_COLOUR);
var $9d529d00c983eb8e$var$ChatText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject1());
var $9d529d00c983eb8e$var$CoachWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject2());
var $9d529d00c983eb8e$var$Logo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($9d529d00c983eb8e$var$_templateObject3());
var $9d529d00c983eb8e$var$MiniLogo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject4(), function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius ? "50%" : "0%";
});
var $9d529d00c983eb8e$var$Coach = function(param) {
    var adviserName = param.adviserName, _param_adviserRole = param.adviserRole, adviserRole = _param_adviserRole === void 0 ? "Mojo Mortgages" : _param_adviserRole, adviserEmail = param.adviserEmail;
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState((0, (/*@__PURE__*/$parcel$interopDefault($8e324a08c1756686$exports)))), 2), adviserAvatar = _React_useState[0], setAdviserAvatar = _React_useState[1];
    (0, $hAGkE.useEffect)(function() {
        var req = "".concat((0, $10b47c5a212e87a0$export$2779e7d7b88a7290), "/").concat(adviserEmail, ".jpg");
        $9d529d00c983eb8e$var$doesAdviserHaveAvatar(req).then(function(valid) {
            return valid ? setAdviserAvatar(req) : null;
        });
    }, [
        setAdviserAvatar,
        adviserEmail
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$CoachWrapper, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$MiniLogo, {
                backgroundImage: adviserAvatar,
                borderRadius: adviserAvatar !== (0, (/*@__PURE__*/$parcel$interopDefault($8e324a08c1756686$exports)))
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$ChatText, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                            children: adviserName || "Your adviser"
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                        children: [
                            adviserRole,
                            " \u2013 here to help you get a mortgage "
                        ]
                    })
                ]
            })
        ]
    });
};
var $9d529d00c983eb8e$var$AdviserView = function(param) {
    var text = param.text, adviserName = param.adviserName, adviserRole = param.adviserRole, adviserEmail = param.adviserEmail;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$TextBox, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                    children: text
                })
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Coach, {
                adviserName: adviserName,
                adviserRole: adviserRole,
                adviserEmail: adviserEmail
            })
        ]
    });
};
var $9d529d00c983eb8e$var$Main = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).main($9d529d00c983eb8e$var$_templateObject5());
var $9d529d00c983eb8e$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject6());
var $9d529d00c983eb8e$var$Benefits = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($9d529d00c983eb8e$var$_templateObject7(), function(param) {
    var display = param.display;
    return display ? "flex" : "none";
});
var $9d529d00c983eb8e$var$Benefit = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).li($9d529d00c983eb8e$var$_templateObject8());
var $9d529d00c983eb8e$var$MonthlyPayment = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject9(), function(props) {
    return props.theme.shade[80];
});
var $9d529d00c983eb8e$var$GridInfo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.shade100;
}, function(param) {
    var theme = param.theme;
    return theme.shade80;
});
var $9d529d00c983eb8e$var$Cost = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject11());
var $9d529d00c983eb8e$var$GridSquareContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject12());
var $9d529d00c983eb8e$var$Value = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject13());
var $9d529d00c983eb8e$var$Deals = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).section($9d529d00c983eb8e$var$_templateObject14(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $9d529d00c983eb8e$var$GridSquare = function(param) {
    var title = param.title, value = param.value;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$GridSquareContainer, {
        children: [
            title,
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Value, {
                children: value
            })
        ]
    });
};
var $9d529d00c983eb8e$var$DealTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).H3)($9d529d00c983eb8e$var$_templateObject15());
var $9d529d00c983eb8e$var$DealCardContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject16(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $9d529d00c983eb8e$var$DealLogoArea = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject17());
var $9d529d00c983eb8e$var$SmallPrint = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($9d529d00c983eb8e$var$_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.shade40;
});
var $9d529d00c983eb8e$var$Recommended = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject19(), function(param) {
    var active = param.active;
    return active ? "3px ".concat($9d529d00c983eb8e$var$ORANGE_COLOUR) : "0 transparent";
}, function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.shade100 : "transparent";
});
var $9d529d00c983eb8e$var$RecommendedTitle = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text)($9d529d00c983eb8e$var$_templateObject20(), $9d529d00c983eb8e$var$ORANGE_COLOUR);
var $9d529d00c983eb8e$var$ToastText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject21(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $9d529d00c983eb8e$var$ToastButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1))($9d529d00c983eb8e$var$_templateObject22(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm);
var $9d529d00c983eb8e$var$DealSelectedToast = function(param) {
    var id = param.id, message = param.message;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$ToastText, {
                children: message
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$ToastButton, {
                onClick: function() {
                    return (0, $fdd55589ea724e5e$export$2e2bcd8739ae039).dismiss(id);
                },
                width: "auto",
                type: 2,
                text: "close",
                style: {
                    background: "#D1DDFC",
                    color: "#073ED9",
                    alignSelf: "end"
                }
            })
        ]
    });
};
var $9d529d00c983eb8e$var$SUCCESS_GREEN = "#038352";
var $9d529d00c983eb8e$var$ChooseDealButton = function(param) {
    var handleDealSelection = param.handleDealSelection, isChosen = param.isChosen, complete = param.complete, loading = param.loading;
    var active = isChosen && !loading;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
        type: active ? 2 : 0,
        text: active ? "Selected deal" : "I want this deal",
        style: {
            marginTop: 10,
            width: "100%",
            background: active && "#E3FDF3",
            color: active && $9d529d00c983eb8e$var$SUCCESS_GREEN,
            cursor: active ? "default" : "pointer"
        },
        onClick: handleDealSelection,
        disabled: complete,
        showLoader: isChosen && loading
    });
};
var $9d529d00c983eb8e$var$AlignedContent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject23());
var $9d529d00c983eb8e$var$BorrowingOverYears = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($9d529d00c983eb8e$var$AlignedContent)($9d529d00c983eb8e$var$_templateObject24(), function(props) {
    return props.theme.shade[80];
});
var $9d529d00c983eb8e$var$DealTypeLength = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($9d529d00c983eb8e$var$AlignedContent)($9d529d00c983eb8e$var$_templateObject25(), function(props) {
    return props.theme.shade[80];
});
var $9d529d00c983eb8e$var$DealCard = function(_param) {
    var handleDealSelection = _param.handleDealSelection, isChosen = _param.isChosen, complete = _param.complete, loading = _param.loading, dealProps = (0, $c4wKO._)(_param, [
        "handleDealSelection",
        "isChosen",
        "complete",
        "loading"
    ]);
    var _dealProps_benefits, _dealProps_benefits1;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$DealCardContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$DealTitle, {
                children: dealProps.title
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$Recommended, {
                active: dealProps.recommended,
                children: [
                    dealProps.recommended && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$RecommendedTitle, {
                        children: "Mortgage Expert's Top Pick"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                        style: {
                            paddingTop: dealProps.recommended && 15,
                            maxWidth: 350,
                            boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.05)"
                        },
                        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$Container, {
                            style: {
                                paddingTop: !dealProps.recommended ? "20px" : 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$DealLogoArea, {
                                    children: dealProps.lenderCode && (0, $533f43526bdcc4d8$export$2e2bcd8739ae039)[dealProps.lenderCode] ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                                        src: (0, $533f43526bdcc4d8$export$2e2bcd8739ae039)[dealProps.lenderCode],
                                        alt: dealProps.title
                                    }) : dealProps.lender ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                        children: dealProps.lender
                                    }) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                        children: $9d529d00c983eb8e$var$DEFAULT_VALUE
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Benefits, {
                                    display: !!((_dealProps_benefits = dealProps.benefits) === null || _dealProps_benefits === void 0 ? void 0 : _dealProps_benefits.length) || false,
                                    children: (_dealProps_benefits1 = dealProps.benefits) === null || _dealProps_benefits1 === void 0 ? void 0 : _dealProps_benefits1.map(function(benefit) {
                                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Benefit, {
                                            children: benefit
                                        });
                                    })
                                }),
                                (dealProps === null || dealProps === void 0 ? void 0 : dealProps.loanAmount) && (dealProps === null || dealProps === void 0 ? void 0 : dealProps.mortgageTerm) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$BorrowingOverYears, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                        children: [
                                            "Borrowing ",
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                children: $9d529d00c983eb8e$var$currencyFormat(dealProps.loanAmount)
                                            }),
                                            " over",
                                            " ",
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                children: dealProps.mortgageTerm
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$MonthlyPayment, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                            children: "Monthly payment"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Cost, {
                                            children: $9d529d00c983eb8e$var$currencyFormat(dealProps.monthlyPayment)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$DealTypeLength, {
                                    children: [
                                        (dealProps === null || dealProps === void 0 ? void 0 : dealProps.mortgageClass) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                children: dealProps.mortgageClass
                                            })
                                        }),
                                        (dealProps === null || dealProps === void 0 ? void 0 : dealProps.duration) && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                children: dealProps.duration
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$GridInfo, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$GridSquare, {
                                            title: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                children: [
                                                    "Initial",
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("br", {}),
                                                    " rate"
                                                ]
                                            }),
                                            value: String($9d529d00c983eb8e$var$percentageFormat(dealProps.initialRate))
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$GridSquare, {
                                            title: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                children: "Overall initial cost (incl fees)*"
                                            }),
                                            value: String($9d529d00c983eb8e$var$currencyFormat(dealProps.initialCostsAndFees))
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$GridSquare, {
                                            title: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                children: "Standard Variable Rate"
                                            }),
                                            value: String($9d529d00c983eb8e$var$percentageFormat(dealProps.standardVariableRate))
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$GridSquare, {
                                            title: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                children: "Arrangement fees"
                                            }),
                                            value: String($9d529d00c983eb8e$var$currencyFormat(dealProps.upFrontFees))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$ChooseDealButton, {
                                    loading: loading,
                                    complete: complete,
                                    isChosen: isChosen,
                                    handleDealSelection: function() {
                                        return handleDealSelection(dealProps);
                                    }
                                }),
                                dealProps.initialPeriodMonths && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$SmallPrint, {
                                    style: {
                                        textAlign: "center",
                                        marginBottom: -15,
                                        marginTop: 15
                                    },
                                    children: [
                                        "*over an initial period of ",
                                        dealProps.initialPeriodMonths,
                                        " months."
                                    ]
                                }),
                                dealProps.notes && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                    children: dealProps.notes
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $9d529d00c983eb8e$var$BigSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject26(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl);
var $9d529d00c983eb8e$var$Title = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text)($9d529d00c983eb8e$var$_templateObject27());
var $9d529d00c983eb8e$var$Data = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text)($9d529d00c983eb8e$var$_templateObject28());
var $9d529d00c983eb8e$var$DetailsContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject29());
var $9d529d00c983eb8e$var$SmallText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body)($9d529d00c983eb8e$var$_templateObject30());
var $9d529d00c983eb8e$var$Footer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject31());
var $9d529d00c983eb8e$var$FooterText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body)($9d529d00c983eb8e$var$_templateObject32());
var $9d529d00c983eb8e$var$BackgroundsWrapper = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject33());
var $9d529d00c983eb8e$var$Trust = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject34(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $9d529d00c983eb8e$var$RatesContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject35(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $9d529d00c983eb8e$var$CardContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject36(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $9d529d00c983eb8e$var$PayAttention = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject37());
var $9d529d00c983eb8e$var$Attention = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($9d529d00c983eb8e$var$_templateObject38(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);
var $9d529d00c983eb8e$var$List = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).ul($9d529d00c983eb8e$var$_templateObject39(), (0, (/*@__PURE__*/$parcel$interopDefault($40a1fc5995dd6979$exports))));
var $9d529d00c983eb8e$var$QuestionsButton = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1))($9d529d00c983eb8e$var$_templateObject40(), function(param) {
    var theme = param.theme;
    return theme.ctaButton;
});
var $9d529d00c983eb8e$var$UserDetail = function(param) {
    var data = param.data, title = param.title;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
        style: {
            marginBottom: 28
        },
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Data, {
                children: data
            })
        ]
    });
};
var $9d529d00c983eb8e$var$preparePageData = function(base64) {
    try {
        var InitialValues = {
            adviserName: "Your adviser",
            adviserEmail: "hello@mojomortgages.com",
            adviserRole: "Team Mojo"
        };
        return (0, $hRCmZ._)({}, InitialValues, JSON.parse(decodeURIComponent(window.atob(base64))));
    } catch (e) {
        console.log(e);
        return {};
    }
};
var $9d529d00c983eb8e$var$checkImageURLisValid = function(url) {
    return new Promise(function(resolve) {
        var image = document.createElement("img");
        image.src = url;
        image.onload = function() {
            return resolve(true);
        };
        image.onerror = function() {
            return resolve(false);
        };
    });
};
var $9d529d00c983eb8e$var$isChromeExtensionInstalled = function(id) {
    return $9d529d00c983eb8e$var$checkImageURLisValid("chrome-extension://".concat(id, "/icon-128.png"));
};
var $9d529d00c983eb8e$var$doesAdviserHaveAvatar = function(url) {
    return $9d529d00c983eb8e$var$checkImageURLisValid(url);
};
var $9d529d00c983eb8e$var$sendDataToSalesforce = function(sfData) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var UPDATE_RECORD, error;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    UPDATE_RECORD = "b06ogeu";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $d48d778937567d64$export$155ec85c4e3b5e85).post("https://my-mojo-api.mojomortgages.com/request/zapier-webhook-mop-tracking", {
                            data: sfData,
                            webhookId: UPDATE_RECORD
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.log("error", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $9d529d00c983eb8e$var$sendDataToSalesforceIfCustomer = function(salesForceData) {
    if (0, $10b47c5a212e87a0$export$3fce19fdf0c5de73) return;
    $9d529d00c983eb8e$var$isChromeExtensionInstalled($9d529d00c983eb8e$var$CHROME_EXTENSION_ID).then(function(isInstalled) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!isInstalled) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            $9d529d00c983eb8e$var$sendDataToSalesforce(salesForceData)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    });
};
var $9d529d00c983eb8e$var$currencyFormat = function(v) {
    var noCurrency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, minDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2, maxDigits = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2;
    var formatted = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits
    }).format(v);
    return noCurrency ? formatted : "\xa3".concat(formatted);
};
var $9d529d00c983eb8e$var$percentageFormat = function(v) {
    return "".concat(v, "%");
};
var $9d529d00c983eb8e$export$ee6c7041db7d70a3 = function() {
    var _pageData_deals;
    (0, $ca040ad62e5c49d0$export$6566876928b9008d)("/recommended");
    var id = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().id;
    var queryStrings = new URLSearchParams(window.location.search);
    var pageData = $9d529d00c983eb8e$var$preparePageData(id);
    var _React_useState = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState(pageData === null || pageData === void 0 ? void 0 : pageData.selectedDeal), 2), selectedDeal = _React_useState[0], setSelectedDeal = _React_useState[1];
    var _React_useState1 = (0, $6mdMa._)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useState(false), 2), loading = _React_useState1[0], setLoading = _React_useState1[1];
    (0, $hAGkE.useEffect)(function() {
        if (selectedDeal && !loading) (0, $fdd55589ea724e5e$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
            children: "Great! Your Mortgage Expert will be in touch, as soon as they can, to discuss your selected deal."
        }), {
            id: "confirmed"
        });
    }, [
        selectedDeal,
        loading
    ]);
    var handleDealSelection = function(deal) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var _res_data, res, _res_data1, _deal_id_split, _deal_id, nextURL, nextTitle, nextState, error;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!queryStrings.get("code")) return [
                            2,
                            (0, $fdd55589ea724e5e$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                children: [
                                    "Sorry we could not handle your request at this time.",
                                    " ",
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                        children: "Try again using the short url."
                                    })
                                ]
                            }))
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        setLoading(true);
                        return [
                            4,
                            (0, $d48d778937567d64$export$155ec85c4e3b5e85).put("https://my-mojo-api.mojomortgages.com/short-url/update", {
                                shortCode: queryStrings.get("code"),
                                newUrl: "".concat(window.location.origin, "/recommended/").concat(btoa(encodeURIComponent(JSON.stringify((0, $7XD9P._)((0, $hRCmZ._)({}, pageData), {
                                    selectedDeal: deal
                                })))), "?code=").concat(queryStrings.get("code"))
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (!(res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.url)) return [
                            3,
                            4
                        ];
                        nextURL = res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : _res_data1.url;
                        nextTitle = "Deal chosen! ".concat(document.title);
                        nextState = {};
                        return [
                            4,
                            $9d529d00c983eb8e$var$sendDataToSalesforceIfCustomer({
                                Opp_Id__c: pageData.opportunityId,
                                Lender__c: deal.lender,
                                Product_Code__c: ((_deal_id = deal.id) === null || _deal_id === void 0 ? void 0 : (_deal_id_split = _deal_id.split("-")) === null || _deal_id_split === void 0 ? void 0 : _deal_id_split[0]) || "no-product-code",
                                Initial_Monthly_Cost__c: deal.monthlyPayment,
                                Total_Initial_Cost__c: deal.initialCostsAndFees,
                                Arrangement_Fees__c: deal.upFrontFees,
                                Initial_Rate__c: deal.initialRate,
                                Deal_Selected_DateTime__c: new Date().toISOString(),
                                Loan_Amount__c: deal.loanAmount,
                                Overall_Mortgage_Term__c: deal.mortgageTerm,
                                Applicant_Names__c: pageData === null || pageData === void 0 ? void 0 : pageData.applicantName
                            })
                        ];
                    case 3:
                        _state.sent();
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).selectDeal
                        });
                        setLoading(false);
                        window.history.replaceState(nextState, nextTitle, nextURL);
                        setSelectedDeal(deal);
                        return [
                            2
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        setLoading(false);
                        setSelectedDeal(null);
                        if (!error) return [
                            2
                        ];
                        (0, $fdd55589ea724e5e$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                            children: [
                                "Sorry, we could not handle your request at this time. (",
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                    children: error.message
                                }),
                                ")"
                            ]
                        }));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    (0, $hAGkE.useEffect)(function() {
        var _pageData_deals;
        if (!(pageData === null || pageData === void 0 ? void 0 : (_pageData_deals = pageData.deals) === null || _pageData_deals === void 0 ? void 0 : _pageData_deals.length)) return;
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).numberOfProductsShown,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: (0, $d69541b5bf83152a$export$e9fd5b7d060c5aca).number,
            value: pageData.deals.length
        });
    }, [
        pageData
    ]);
    (0, $hAGkE.useEffect)(function() {
        var scriptTag = document.createElement("script");
        scriptTag.src = "//l.getsitecontrol.com/y79nm31w.js";
        scriptTag.type = "text/javascript";
        scriptTag.async = true;
        document.body.appendChild(scriptTag);
        return function() {
            document.body.removeChild(scriptTag);
        };
    }, []);
    (0, $hAGkE.useEffect)(function() {
        $9d529d00c983eb8e$var$sendDataToSalesforceIfCustomer({
            Opp_Id__c: pageData.opportunityId,
            Viewed_Date_Time__c: new Date().toISOString()
        });
    }, []);
    var handleClick = function() {
        navigator.clipboard.writeText(pageData === null || pageData === void 0 ? void 0 : pageData.adviserEmail);
        (0, $fdd55589ea724e5e$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
            children: [
                'Copied "',
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                    children: pageData === null || pageData === void 0 ? void 0 : pageData.adviserEmail
                }),
                '" to your clipboard'
            ]
        }), {
            id: "clipboard"
        });
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$Main, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Logo, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cdee53f79ccf0fe3$exports))),
                alt: "Mojo Mortgages"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $acad1866a3f9fc3b$export$fceb9665be86d56e), {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$BackgroundsWrapper, {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).H1, {
                                    style: {
                                        marginBottom: 20,
                                        display: "block",
                                        fontWeight: 600,
                                        fontSize: 28
                                    },
                                    children: [
                                        "Hey ",
                                        (pageData === null || pageData === void 0 ? void 0 : pageData.applicantName) ? pageData === null || pageData === void 0 ? void 0 : pageData.applicantName.split(" ")[0] : "",
                                        ", here are some mortgages"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$BigSection, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$AdviserView, {
                                            text: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Fragment, {
                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                                    children: [
                                                        "I\u2019ve assessed your circumstances and searched thousands of deals across the market to find the best options for you.",
                                                        " "
                                                    ]
                                                })
                                            }),
                                            adviserName: (pageData === null || pageData === void 0 ? void 0 : pageData.adviserName) || "Your adviser",
                                            adviserRole: pageData === null || pageData === void 0 ? void 0 : pageData.adviserRole,
                                            adviserEmail: pageData === null || pageData === void 0 ? void 0 : pageData.adviserEmail
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$DetailsContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$UserDetail, {
                                                        data: (pageData === null || pageData === void 0 ? void 0 : pageData.applicantName) || $9d529d00c983eb8e$var$DEFAULT_VALUE,
                                                        title: "Applicant name"
                                                    }),
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$UserDetail, {
                                                        data: (pageData === null || pageData === void 0 ? void 0 : pageData.propertyValue) ? $9d529d00c983eb8e$var$currencyFormat(pageData === null || pageData === void 0 ? void 0 : pageData.propertyValue) : $9d529d00c983eb8e$var$DEFAULT_VALUE,
                                                        title: "Property value"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Deals, {
                                    children: pageData === null || pageData === void 0 ? void 0 : (_pageData_deals = pageData.deals) === null || _pageData_deals === void 0 ? void 0 : _pageData_deals.map(function(deal) {
                                        return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$DealCard, (0, $7XD9P._)((0, $hRCmZ._)({}, deal), {
                                            loading: loading,
                                            handleDealSelection: handleDealSelection,
                                            isChosen: JSON.stringify(deal) === JSON.stringify(pageData.selectedDeal || selectedDeal),
                                            complete: !!pageData.selectedDeal || !!selectedDeal
                                        }), deal.monthlyPayment);
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$RatesContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$SmallText, {
                                            children: "We will need to confirm your full suitability before confirming your personal mortgage recommendation."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$SmallText, {
                                            children: "These rates are subject to change. Lenders may withdraw product rates at short notice."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Attention, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$BigSection, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                                        style: {
                                                            fontWeight: 600,
                                                            fontSize: 26,
                                                            lineHeight: "135%",
                                                            marginBottom: 30
                                                        },
                                                        children: "What happens once you select a deal?"
                                                    }),
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                                        children: "Your Mortgage Expert will get in touch to confirm your suitability for this deal and make your official personalised mortgage recommendation. Once this is sorted, it\u2019ll go like this:"
                                                    }),
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$List, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                                    children: "You get a copy of the recommendation to check through and accept"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                                    children: "Accept the recommendation and we\u2019ll get you a Decision in Principle from the mortgage lender to confirm pre-approval for the deal"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                                    children: "With a Decision in Principle in place, your Case Manager will package your mortgage application, including any documents"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                                    children: "Your application and documents will be submitted to the lender"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Body, {
                                                        children: "Please note: We may recommend an alternative deal following your full suitability review. Also, please be aware that selecting a deal does not guarantee you\u2019ll get it, or that the lender will accept your application."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bc0b65a7f396a0a1$export$60332b2344f7fe41), {
                                                    style: {
                                                        boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.05)"
                                                    },
                                                    content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$CardContainer, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).H4, {
                                                                children: "Questions?"
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                                children: "If you have questions or you\u2019re unsure about these deals, please get in touch."
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Coach, {
                                                                adviserName: pageData === null || pageData === void 0 ? void 0 : pageData.adviserName,
                                                                adviserRole: pageData === null || pageData === void 0 ? void 0 : pageData.adviserRole,
                                                                adviserEmail: pageData === null || pageData === void 0 ? void 0 : pageData.adviserEmail
                                                            }),
                                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$QuestionsButton, {
                                                                type: 2,
                                                                text: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("img", {
                                                                            style: {
                                                                                marginRight: 8
                                                                            },
                                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($38fcea7af5042917$exports))),
                                                                            alt: "Email"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                                                            children: "Copy email address"
                                                                        })
                                                                    ]
                                                                }),
                                                                onClick: handleClick
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$Trust, {
                                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b8c735a9a8a17611$export$38a5f55ff6d8d994), {
                                        headingStyle: {
                                            fontSize: 20,
                                            width: "100%"
                                        },
                                        imageStyle: {
                                            width: 275
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$Footer, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($9d529d00c983eb8e$var$PayAttention, {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                            children: [
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                    children: "THINK CAREFULLY BEFORE SECURING OTHER DEBTS AGAINST YOUR HOME/PROPERTY."
                                                }),
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f430003687c9abea$export$2e2bcd8739ae039).Text, {
                                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("strong", {
                                                children: "YOUR HOME/PROPERTY MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$FooterText, {
                                    children: "Mojo is a trading style of Life\u2019s Great Limited which is registered in England and Wales (06246376)."
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$FooterText, {
                                    children: "Our registered office is The Cooperage, 5 Copper Row, London SE1 2LH. We are authorised and regulated by the Financial Conduct Authority and are on the Financial Services Register (478215)."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $a159116cb4326250$export$36ba2f559d49a8f6), {
                            notificationComponent: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($9d529d00c983eb8e$var$DealSelectedToast, {})
                        })
                    ]
                })
            })
        ]
    });
};



var $iNemB = parcelRequire("iNemB");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");










var $cCIJH = parcelRequire("cCIJH");
var $b9d4462c5c09d1e0$var$Root = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    flexDirection: "column",
    gap: 16,
    margin: "64px 16px 0 16px",
    maxWidth: 848
}, "@media screen and ".concat((0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl), {
    minWidth: 768,
    margin: "8.5em auto 0"
}));
var $b9d4462c5c09d1e0$var$LoaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div((0, $8c6ug._)({
    display: "flex",
    justifyContent: "center"
}, "@media screen and ".concat((0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_xl), {
    width: "34em"
}));
var $b9d4462c5c09d1e0$var$ErrorContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    marginTop: 100
});
var $b9d4462c5c09d1e0$var$RenderError = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b9d4462c5c09d1e0$var$ErrorContainer, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $c67218ac7986ea8b$export$d56b0569bceb92ae), {
            children: "Could not find preview token"
        })
    });
};
var $b9d4462c5c09d1e0$var$RenderLoading = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b9d4462c5c09d1e0$var$LoaderContainer, {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
            size: 150,
            theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
        })
    });
};
var $b9d4462c5c09d1e0$export$77cbc0bc8180ab32 = function() {
    var _useParams = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)(), token = _useParams.token, timestamp = _useParams.timestamp;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), applicationData = _useState1[0], setApplicationData = _useState1[1];
    var _useApplicationSummaryEnhanced = (0, $cec0b06d7f24d7cd$export$d883155132f626a2)({
        applicationData: applicationData
    }), application = _useApplicationSummaryEnhanced.application, hasLoaded = _useApplicationSummaryEnhanced.hasLoaded;
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isError = _useState2[0], setIsError = _useState2[1];
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isDownloading = _useState3[0], setIsDownloading = _useState3[1];
    (0, $hAGkE.useEffect)(function() {
        $b9d4462c5c09d1e0$var$getApplicationData(token, timestamp).then(function(data) {
            setApplicationData(data);
        })["catch"](function(error) {
            setIsError(true);
            $cCIJH.captureException("An error occurred while loading application data in RecommendationPreview", {
                extra: (0, $7XD9P._)((0, $hRCmZ._)({}, (error === null || error === void 0 ? void 0 : error.message) && {
                    error: error.message
                }), {
                    token: token,
                    timestamp: timestamp
                })
            });
        })["finally"](function() {
            return setIsLoading(false);
        });
    }, [
        application,
        hasLoaded
    ]);
    var downloadEsisDocument = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var body, response, url, error;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!applicationData) return [
                            2
                        ];
                        body = {
                            s3Key: applicationData.esisS3Key
                        };
                        setIsDownloading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/documents/download-url"), body)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status !== 200) {
                            setIsDownloading(false);
                            throw new Error("Error downloading Mortgage Illustration");
                        }
                        url = response.data.downloadUrl;
                        setIsDownloading(false);
                        window.open(url);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        setIsDownloading(false);
                        alert("Error downloading Mortgage Illustration");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b9d4462c5c09d1e0$var$Root, {
        children: isError ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b9d4462c5c09d1e0$var$RenderError, {}) : isLoading ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($b9d4462c5c09d1e0$var$RenderLoading, {}) : /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b5d29700c7bfc058$export$4199a33c3dd48123), {
            applicationData: applicationData,
            downloadEsisDocument: downloadEsisDocument,
            isDownloading: isDownloading,
            isPreview: true,
            acceptRecommendationOpportunity: function() {
                return undefined;
            },
            acceptRecommendationQuote: function() {
                return undefined;
            },
            previewData: applicationData.previewData
        })
    });
};
var $b9d4462c5c09d1e0$var$getApplicationData = function(token, timestamp) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
        var response;
        return (0, $dMrZK.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!timestamp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/specific-recommendation/".concat(token, "/").concat(timestamp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($0e691535434e3142$exports))).get("https://my-mojo-api.mojomortgages.com/rec-preview/".concat(token))
                    ];
                case 3:
                    response = _state.sent();
                    _state.label = 4;
                case 4:
                    if (response.status !== 200) throw new Error("Could not find preview token");
                    return [
                        2,
                        response.data
                    ];
            }
        });
    })();
};



var $iNemB = parcelRequire("iNemB");

var $6mdMa = parcelRequire("6mdMa");


var $dMrZK = parcelRequire("dMrZK");


var $hAGkE = parcelRequire("hAGkE");













function $c56619601916f4f7$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 0.9rem;\n  margin-top: 2rem;\n\n  > * + * {\n    margin-top: 2.3rem;\n  }\n"
    ]);
    $c56619601916f4f7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c56619601916f4f7$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  font-size: 1.1rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  display: block;\n"
    ]);
    $c56619601916f4f7$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c56619601916f4f7$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  padding-top: 0.1rem;\n  padding-bottom: 0.3rem;\n  margin-top: 0;\n  color: #6c6f7a;\n  font-weight: 450;\n"
    ]);
    $c56619601916f4f7$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $c56619601916f4f7$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  margin-top: 0.4rem;\n  color: #ef1717;\n"
    ]);
    $c56619601916f4f7$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $c56619601916f4f7$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  a {\n    color: #0a48f7;\n  }\n"
    ]);
    $c56619601916f4f7$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $c56619601916f4f7$var$FormContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).form($c56619601916f4f7$var$_templateObject());
var $c56619601916f4f7$var$InputLabel = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).label($c56619601916f4f7$var$_templateObject1());
var $c56619601916f4f7$var$Hint = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($c56619601916f4f7$var$_templateObject2());
var $c56619601916f4f7$var$Error = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($c56619601916f4f7$var$_templateObject3());
var $c56619601916f4f7$var$Tos = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($c56619601916f4f7$var$_templateObject4());
function $c56619601916f4f7$export$308ac02cf1b46d1() {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), firstName = _useState[0], setFirstName = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), lastName = _useState1[0], setLastName = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), emailAddress = _useState2[0], setEmailAddress = _useState2[1];
    var _useState3 = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), phoneNumber = _useState3[0], setPhoneNumber = _useState3[1];
    var _useState4 = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), postcode = _useState4[0], setPostcode = _useState4[1];
    var _useState5 = (0, $6mdMa._)((0, $hAGkE.useState)(""), 2), completionDate = _useState5[0], setCompletionDate = _useState5[1];
    var _useState6 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), isFirstNameValid = _useState6[0], setIsFirstNameValid = _useState6[1];
    var _useState7 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), isLastNameValid = _useState7[0], setIsLastNameValid = _useState7[1];
    var _useState8 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), isEmailValid = _useState8[0], setIsEmailValid = _useState8[1];
    var _useState9 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), isPostcodeValid = _useState9[0], setIsPostcodeValid = _useState9[1];
    var _useState10 = (0, $6mdMa._)((0, $hAGkE.useState)(null), 2), isPhoneNumberValid = _useState10[0], setIsPhoneNumberValid = _useState10[1];
    var _useState11 = (0, $6mdMa._)((0, $hAGkE.useState)([]), 2), dateErrors = _useState11[0], setDateErrors = _useState11[1];
    var _useState12 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isBusy = _useState12[0], setIsBusy = _useState12[1];
    var _useState13 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), error = _useState13[0], setError = _useState13[1];
    var _useState14 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), isDone = _useState14[0], setIsDone = _useState14[1];
    var _useState15 = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasNotFoundError = _useState15[0], setHasNotFoundError = _useState15[1];
    // GA Events
    (0, $hAGkE.useLayoutEffect)(function() {
        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Rate Check Request Form"
        });
    }, []);
    (0, $hAGkE.useEffect)(function() {
        if (error) (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Rate Check Request Error"
        });
    }, [
        error
    ]);
    (0, $hAGkE.useEffect)(function() {
        if (hasNotFoundError) (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).componentDisplay,
            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).siteInteraction,
            event_label: "Error Matching Rate Check Application"
        });
    }, [
        hasNotFoundError
    ]);
    function ValidateFirstName() {
        if (firstName && firstName.length > 0) {
            setIsFirstNameValid(true);
            return;
        }
        setIsFirstNameValid(false);
    }
    function ValidateLastName() {
        if (firstName && firstName.length > 0) {
            setIsLastNameValid(true);
            return;
        }
        setIsLastNameValid(false);
    }
    function ValidateEmail() {
        if (!emailAddress) {
            setIsEmailValid(false);
            return;
        }
        if (emailAddress) {
            var isValid = (0, $b144b381fed01ccc$export$a1b2cbbeb63805f3)(emailAddress);
            setIsEmailValid(isValid);
            return;
        }
        setIsEmailValid(false);
    }
    function ValidatePostcode() {
        if (!postcode) {
            setIsPostcodeValid(false);
            return;
        }
        if (postcode) {
            var regex = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i;
            setIsPostcodeValid(regex.test(postcode));
            return;
        }
        setIsPostcodeValid(false);
    }
    function ValidatePhoneNumber() {
        if (!phoneNumber) setIsPhoneNumberValid(false);
        var regex = /^(?:0|\+?44)(?:\d\s?){9,10}$/;
        setIsPhoneNumberValid(regex.test(phoneNumber));
    }
    function HandleSubmit() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $iNemB._)(function() {
            var err, err1;
            return (0, $dMrZK.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isFirstNameValid) setIsFirstNameValid(false);
                        if (!isLastNameValid) setIsLastNameValid(false);
                        if (!isEmailValid) setIsEmailValid(false);
                        if (!isPostcodeValid) setIsPostcodeValid(false);
                        if (!isPhoneNumberValid) setIsPhoneNumberValid(false);
                        if (!completionDate) setDateErrors(dateErrors.length > 0 ? dateErrors : [
                            "Required"
                        ]);
                        if (hasNotFoundError) setHasNotFoundError(false);
                        if (!isFirstNameValid || !isLastNameValid || !isEmailValid || !isPostcodeValid || !isPhoneNumberValid || (dateErrors === null || dateErrors === void 0 ? void 0 : dateErrors.length) > 0) return [
                            2
                        ];
                        (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                            action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).buttonClicked,
                            event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).functionalInteraction,
                            event_label: "Rate Check Request Submitted"
                        });
                        setIsBusy(true);
                        setError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $d48d778937567d64$export$155ec85c4e3b5e85).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/rate-check-request/has-match"), {
                                fullName: "".concat(firstName, " ").concat(lastName),
                                emailAddress: emailAddress,
                                phoneNumber: phoneNumber,
                                postcode: postcode,
                                completionDate: (0, $45f64f2ccb2647eb$export$68962dbd27cd2e36)(completionDate, "YYYY-MM-DD")
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setIsBusy(false);
                        setHasNotFoundError(true);
                        return [
                            2
                        ];
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4,
                            (0, $d48d778937567d64$export$155ec85c4e3b5e85).post("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/rate-check-request"), {
                                fullName: "".concat(firstName, " ").concat(lastName),
                                emailAddress: emailAddress,
                                phoneNumber: phoneNumber,
                                postcode: postcode,
                                completionDate: (0, $45f64f2ccb2647eb$export$68962dbd27cd2e36)(completionDate, "YYYY-MM-DD")
                            })
                        ];
                    case 5:
                        _state.sent();
                        setIsDone(true);
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err1 = _state.sent();
                        setError(true);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setIsBusy(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $68164826edc95436$export$c3bb089bd80cbef5), {
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $acad1866a3f9fc3b$export$fceb9665be86d56e), {
            maxWidth: 900,
            children: [
                !isDone && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                            children: "Request a Rate Check"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Fill out this form to request a Rate Check and find out if you're still on the best rate."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "After completing the form, your Mortgage Expert will review the whole of market and let you know if a cheaper rate is available."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Rate Check requests received during normal business hours (Monday to Friday, 9 AM to 5 PM) will be responded to within two business days. For example, if a request is submitted on a Monday, you can expect a response by the close of business on Wednesday."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            children: "Please note that the ability to change your rate will depend on the lender and how close you are to your completion date. Your Mortgage Expert will advise you on this."
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($c56619601916f4f7$var$FormContainer, {
                            children: [
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$InputLabel, {
                                            htmlFor: "firstname",
                                            children: "First Name"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                                            id: "firstname",
                                            value: firstName,
                                            onChange: function(value) {
                                                return setFirstName(value);
                                            },
                                            onBlur: ValidateFirstName
                                        }),
                                        isFirstNameValid === false && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "Please enter a valid first name"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$InputLabel, {
                                            htmlFor: "lastname",
                                            children: "Last Name"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                                            id: "lastname",
                                            value: lastName,
                                            onChange: function(value) {
                                                return setLastName(value);
                                            },
                                            onBlur: ValidateLastName
                                        }),
                                        isLastNameValid === false && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "Please enter a valid last name"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$InputLabel, {
                                            htmlFor: "emailAddress",
                                            children: "Email Address"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Hint, {
                                            children: "The email address associated with your application"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                                            id: "emailAddress",
                                            value: emailAddress,
                                            onChange: function(value) {
                                                return setEmailAddress(value);
                                            },
                                            onBlur: ValidateEmail
                                        }),
                                        isEmailValid === false && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "Please enter a valid email"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$InputLabel, {
                                            htmlFor: "postcode",
                                            onBlur: ValidatePostcode,
                                            children: "Postcode"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Hint, {
                                            children: "The postcode of the property your application is for"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                                            id: "postcode",
                                            value: postcode,
                                            onChange: function(value) {
                                                return setPostcode(value);
                                            },
                                            onBlur: ValidatePostcode
                                        }),
                                        isPostcodeValid === false && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "Please enter a valid postcode"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$InputLabel, {
                                            htmlFor: "phoneNumber",
                                            children: "Phone Number"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Hint, {
                                            children: "So we can get in touch if there's any problems with your request"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $340cdb16aa3c2340$export$c86715117507e8e5), {
                                            id: "phoneNumber",
                                            value: phoneNumber,
                                            onChange: function(value) {
                                                return setPhoneNumber(value);
                                            },
                                            onBlur: ValidatePhoneNumber
                                        }),
                                        isPhoneNumberValid === false && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "Please enter a valid phone number"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$InputLabel, {
                                            htmlFor: "completionDate",
                                            children: "Completion Date"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Hint, {
                                            children: "You can estimate if you're unsure"
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $1976908833cc852a$export$7edc06cf1783b30f), {
                                            dateFlags: [
                                                (0, $1976908833cc852a$export$8b9486222b0d2995).FutureDate
                                            ],
                                            id: "completionDate",
                                            value: completionDate,
                                            onDone: function(value, errors) {
                                                var _value_toString;
                                                setCompletionDate((_value_toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value_toString !== void 0 ? _value_toString : "");
                                                setDateErrors(errors);
                                            }
                                        }),
                                        dateErrors && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: dateErrors.join(". ")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52cc9c2de18dc6b5$export$353f5b6fc5456de1), {
                                    onClick: HandleSubmit,
                                    showLoader: isBusy,
                                    type: (0, $52cc9c2de18dc6b5$export$d3d950cd69e1ac66).Solid,
                                    text: "Submit"
                                }),
                                hasNotFoundError && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "We were unable to find your application based on these details."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "Please check again, ensuring you're using the same details as you provided for your application with us."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($c56619601916f4f7$var$Error, {
                                            children: [
                                                "Alternatively, please contact your Case Manager for further assistance, ",
                                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("br", {}),
                                                " ",
                                                "or contact us on 0333 123 0012."
                                            ]
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $3d45074523d8f6b3$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "It looks like something went wrong submitting your request. Please try again, or let us know."
                                        }),
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($c56619601916f4f7$var$Error, {
                                            children: "You can email us at hello@mojomortgages.com or ring us on 0333 123 0012"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($c56619601916f4f7$var$Tos, {
                                    children: [
                                        "By submitting this form, I confirm I've read and accepted Mojo's",
                                        " ",
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                                            title: "Terms of Advisory Services",
                                            target: "_blank",
                                            href: "https://hosted-assets.mojomortgages.com/documents/Terms%20of%20our%20Advisory%20Services.pdf",
                                            children: "Terms of Advisory Services"
                                        }),
                                        " ",
                                        "and",
                                        " ",
                                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("a", {
                                            title: "Privacy Policy",
                                            target: "_blank",
                                            href: "https://mojomortgages.com/privacy-policy/",
                                            children: "Privacy Notice"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isDone && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("h3", {
                            children: "Your Rate Check request has been submitted"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                            style: {
                                fontWeight: "500"
                            },
                            children: "Your Mortgage Expert will be in touch within two working days to let you know if a cheaper rate is available."
                        })
                    ]
                })
            ]
        })
    });
}




var $hAGkE = parcelRequire("hAGkE");

var $cCIJH = parcelRequire("cCIJH");

var $cf845e9a134f5eb5$export$3cbd42d8a7a14292 = function(param) {
    var path = param.path, _param_redirect = param.redirect, redirect = _param_redirect === void 0 ? "/dashboard" : _param_redirect, doRedirect = param.doRedirect;
    (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).useEffect(function() {
        console.log(window);
        $cCIJH.captureException(new Error("User tried accessing ".concat(path)));
        if (doRedirect) doRedirect();
    }, []);
    if (doRedirect) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {});
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$2d8d895a0a0f636e), {
        to: redirect
    });
};




parcelRequire("hAGkE");



function $689a13ea7d1dc764$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n    flex-direction: column;\n    margin: 16px 40px;\n    line-height: 24px;\n    max-width: 1024px;\n\n    @media ",
        " {\n        margin: 16px auto;\n    }\n"
    ]);
    $689a13ea7d1dc764$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $689a13ea7d1dc764$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n    margin-bottom: 1em;\n"
    ]);
    $689a13ea7d1dc764$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $689a13ea7d1dc764$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n    margin: 1em 0;\n"
    ]);
    $689a13ea7d1dc764$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $689a13ea7d1dc764$var$_templateObject3() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n    background: ",
        ";\n    border-radius: 8px;\n    padding: 0.5em 1.5em;\n    margin-top: 1em;\n"
    ]);
    $689a13ea7d1dc764$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $689a13ea7d1dc764$var$_templateObject4() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n    color: ",
        ";\n"
    ]);
    $689a13ea7d1dc764$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $689a13ea7d1dc764$var$Root = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($689a13ea7d1dc764$var$_templateObject(), (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_lg);
var $689a13ea7d1dc764$var$Header = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h1($689a13ea7d1dc764$var$_templateObject1());
var $689a13ea7d1dc764$var$Subheader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).h4($689a13ea7d1dc764$var$_templateObject2());
var $689a13ea7d1dc764$var$UnavailableMessageContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($689a13ea7d1dc764$var$_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.peach[100];
});
var $689a13ea7d1dc764$var$Anchor = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).a($689a13ea7d1dc764$var$_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.vivid[400];
});
var $689a13ea7d1dc764$export$6733eeac9e628250 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $68164826edc95436$export$c3bb089bd80cbef5), {
        stickyHeader: false,
        colourTheme: (0, $68164826edc95436$export$50462b76f8e9e7fc).Primary,
        headerStyle: (0, $68164826edc95436$export$54a719cd6595ff5c).Transparent,
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($689a13ea7d1dc764$var$Root, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$Header, {
                    children: "Your Mojo mortgage protection appointment"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$Subheader, {
                    children: "Thanks for coming to complete your pre-appointment protection questions."
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$UnavailableMessageContainer, {
                    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                        children: "Our online form is currently unavailable, but don\u2019t worry, your protection expert will go over these questions in your protection appointment to make sure you get appropriate and accurate advice."
                    })
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "Don\u2019t forget to complete your remaining pre-appointment actions:"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$Subheader, {
                    children: "Gather details of any existing cover"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
                    children: "Gather and bring information about any existing insurance policies and work benefits you may have to the appointment, including:"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Life cover"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Critical illness cover"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Income protection"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Paid sick leave"
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("li", {
                            children: "Death in service"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$Subheader, {
                    children: "Watch our short protection explainer"
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)("p", {
                    children: [
                        "Take a few minutes to watch this ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$Anchor, {
                                href: "https://vimeo.com/user14855064/review/449332786/6aa3a4fbb0",
                                children: "short video"
                            })
                        }),
                        " from one of our protection insurance partners on what protection might mean for you and your family."
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($689a13ea7d1dc764$var$Subheader, {
                    children: [
                        "Team Mojo ",
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($689a13ea7d1dc764$var$Anchor, {
                            href: "mailto:advice@mojomortgages.com",
                            children: "advice@mojomortgages.com"
                        })
                    ]
                })
            ]
        })
    });
};





var $hAGkE = parcelRequire("hAGkE");



var $0fdb4bda9b5ecf04$export$3d71a527ba323bde = function(param) {
    var children = param.children;
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), session = _useSession.data, sessionError = _useSession.error;
    (0, $hAGkE.useEffect)(function() {
        // Check if this is a login success redirect
        var urlParams = new URLSearchParams(window.location.search);
        var isLoginSuccess = urlParams.get("login_success") === "true";
        if (!isLoginSuccess) return;
        // Wait for session to load
        if (session === undefined) // Still loading
        return;
        if (sessionError || !session) {
            // No valid session - this shouldn't happen with login_success=true
            // but clean up the parameter anyway
            $0fdb4bda9b5ecf04$var$cleanupUrlParameters();
            return;
        }
        // We have both login_success=true and a valid session - fire GA event
        try {
            (0, $175ce91c71cebc6b$export$be82e1134c98fcf5)({
                action: (0, $d69541b5bf83152a$export$4f3bc3f0d9ac9da2).loginSuccess,
                event_category: (0, $d69541b5bf83152a$export$8e849b4340a2cb43).accountInteraction,
                event_label: "Magic Link Login Complete"
            });
        } catch (error) {
            // GA event failed, but don't break the app
            console.warn("Failed to send login success GA event:", error);
        }
        // Clean up URL parameters after event is sent
        $0fdb4bda9b5ecf04$var$cleanupUrlParameters();
    }, [
        session,
        sessionError
    ]);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: children
    });
};
/**
 * Removes login_success parameter from URL without causing a page reload
 */ function $0fdb4bda9b5ecf04$var$cleanupUrlParameters() {
    var url = new URL(window.location.href);
    url.searchParams["delete"]("login_success");
    // Use replaceState to update URL without reload
    window.history.replaceState({}, "", url.toString());
}



parcelRequire("hAGkE");



parcelRequire("hAGkE");



function $e2e5f15af62efc2e$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background-color: ",
        ";\n"
    ]);
    $e2e5f15af62efc2e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e2e5f15af62efc2e$var$_templateObject1() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  width: 160px;\n  margin-bottom: 2rem;\n"
    ]);
    $e2e5f15af62efc2e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $e2e5f15af62efc2e$var$_templateObject2() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  color: ",
        ";\n  font-size: 1.1rem;\n  margin: 1.5rem 0 0 0;\n  text-align: center;\n"
    ]);
    $e2e5f15af62efc2e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $e2e5f15af62efc2e$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div($e2e5f15af62efc2e$var$_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.neutral[0];
});
var $e2e5f15af62efc2e$var$MojoLogoImage = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img($e2e5f15af62efc2e$var$_templateObject1());
var $e2e5f15af62efc2e$var$LoadingText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p($e2e5f15af62efc2e$var$_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.neutral[900];
});
var $e2e5f15af62efc2e$export$89deb18a2a678874 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e2e5f15af62efc2e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e2e5f15af62efc2e$var$MojoLogoImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cdee53f79ccf0fe3$exports))),
                alt: "Mojo"
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $08c81b9de2a7884d$export$3b0d6d7590275603), {
                size: 50,
                theme: (0, $08c81b9de2a7884d$export$9c2866a4c6ffee).Outline
            })
        ]
    });
};


var $5b21716e72347dde$export$15061808233f1766 = function(param) {
    var children = param.children, _param_fallback = param.fallback, fallback = _param_fallback === void 0 ? /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $e2e5f15af62efc2e$export$89deb18a2a678874), {}) : _param_fallback;
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), sessionData = _useSession.data, isLoading = _useSession.isLoading, error = _useSession.error;
    // Session is still loading - show fallback
    if (isLoading) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: fallback
    });
    // Session loaded (whether successful or failed) - render app
    // Auth status cache is now correctly set by useSession
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: children
    });
};



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


var $6mdMa = parcelRequire("6mdMa");

var $hAGkE = parcelRequire("hAGkE");



var $6efc334165c86458$export$add278f196a9dbdf = function(friendlyId) {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(), 2), riskReport = _useState[0], setRiskReport = _useState[1];
    var _useState1 = (0, $6mdMa._)((0, $hAGkE.useState)(true), 2), isLoading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, $6mdMa._)((0, $hAGkE.useState)(), 2), error = _useState2[0], setError = _useState2[1];
    // make sure the user session is available before calling an auth'd endpoint
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), sessionLoading = _useSession.isLoading;
    (0, $hAGkE.useEffect)(function() {
        if (sessionLoading) return;
        fetch("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/risk-report/").concat(friendlyId), {
            credentials: "include"
        }).then(function(res) {
            if (res.ok) return res.json();
            throw Error("Failed to fetch risk report: ".concat(res.status, " ").concat(res.statusText));
        }).then(function(json) {
            setRiskReport(json);
            setLoading(false);
        })["catch"](function(err) {
            console.error(err);
            setError(err);
            setLoading(false);
        });
    }, [
        friendlyId,
        sessionLoading
    ]);
    return {
        riskReport: riskReport,
        isLoading: isLoading,
        error: error
    };
};
var $6efc334165c86458$export$8321eca889f4503c = function(friendlyId, isLoading, error) {
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), hasUpdated = _useState[0], setUpdated = _useState[1];
    // make sure the user session is available before calling an auth'd endpoint
    var _useSession = (0, $01653cfe8f3c67b0$export$ad0a340bf97d63d5)(), sessionLoading = _useSession.isLoading;
    (0, $hAGkE.useEffect)(function() {
        var isComingFromSf = document.referrer.includes("salesforce.com"); // Advisors and Mojo'ers will come via Salesforce, so don't update then. Not perfect, but better than nothing
        var isReady = !sessionLoading && !isLoading && !error && !hasUpdated && !isComingFromSf;
        if (!isReady) return;
        fetch("".concat((0, $10b47c5a212e87a0$export$565b9862d8bb2cf9), "/risk-report/").concat(friendlyId, "/viewed"), {
            credentials: "include",
            method: "PUT"
        }).then(function(res) {
            if (!res.ok) throw Error("Failed to mark risk report as viewed: ".concat(res.status, " ").concat(res.statusText));
            setUpdated(true);
        })["catch"](function(err) {
            console.error(err);
            // Don't stop the user from viewing the report, just log a Sentry error
            (0, $411b073b3fd49a19$export$5c9af0966a1ac889)(err.message);
        });
    }, [
        sessionLoading,
        isLoading,
        error
    ]);
};






var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");






var $738e2b107ba32cce$export$8b251419efc915eb = function(param) {
    var riskReport = param.riskReport;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($738e2b107ba32cce$var$HeaderContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($738e2b107ba32cce$var$HeadingCopyContainer, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$MojoLogo, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c1f6901f9690afd1$exports)))
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                        children: "Risk Reality Report"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("b", {
                            children: "Protection is about love, not just loss"
                        })
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        weight: 400,
                        children: "If something did happen, are you confident you or your loved ones could pay the bills each month, including your mortgage? The reality is, it could happen to any one of us, at any time."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        weight: 600,
                        children: "This is not a prediction of your future health and doesn't account for your full medical history or lifestyle."
                    }),
                    riskReport.advisor && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$Advisor, {
                        advisor: riskReport.advisor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$HeadingImgContainer, {
                children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$KidsIllustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($16f0378959a5b284$exports)))
                })
            })
        ]
    });
};
var $738e2b107ba32cce$var$Advisor = function(param) {
    var advisor = param.advisor;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($738e2b107ba32cce$var$AdvisorSection, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$AdvisorImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($175870872636a4b6$exports)))
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($738e2b107ba32cce$var$AdvisorText, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$AdvisorName, {
                        children: advisor.name
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($738e2b107ba32cce$var$AdvisorRole, {
                        children: advisor.role
                    })
                ]
            })
        ]
    });
};
var $738e2b107ba32cce$var$HeaderContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    maxWidth: 1200,
    margin: "0 auto",
    padding: "2rem",
    display: "flex",
    gap: "40px"
});
var $738e2b107ba32cce$var$HeadingCopyContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
});
var $738e2b107ba32cce$var$_obj;
var $738e2b107ba32cce$var$HeadingImgContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($738e2b107ba32cce$var$_obj = {
    flex: 1,
    padding: "0 32px"
}, (0, $8c6ug._)($738e2b107ba32cce$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    display: "none"
}), (0, $8c6ug._)($738e2b107ba32cce$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    display: "none"
}), (0, $8c6ug._)($738e2b107ba32cce$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    display: "block"
}), $738e2b107ba32cce$var$_obj));
var $738e2b107ba32cce$var$MojoLogo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img({
    maxWidth: "128px",
    margin: "0 0 32px"
});
var $738e2b107ba32cce$var$KidsIllustration = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img({
    position: "relative",
    maxWidth: "390px"
});
var $738e2b107ba32cce$var$AdvisorSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    gap: "16px"
});
var $738e2b107ba32cce$var$AdvisorImg = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img({
    width: 72,
    height: 72
});
var $738e2b107ba32cce$var$AdvisorText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
});
var $738e2b107ba32cce$var$AdvisorName = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    margin: 0
});
var $738e2b107ba32cce$var$AdvisorRole = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    margin: 0,
    fontWeight: 600
});



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


var $52ab70f9c7f90d6e$export$bfd46b96653838bc = function(param) {
    var riskReport = param.riskReport;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52ab70f9c7f90d6e$var$Container, {
        children: riskReport.riskIndividual.map(function(ri, index) {
            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($52ab70f9c7f90d6e$var$Pill, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52ab70f9c7f90d6e$var$TextStrong, {
                        children: ri.name
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52ab70f9c7f90d6e$var$TextLight, {
                        children: ri.sex
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($52ab70f9c7f90d6e$var$TextLight, {
                        children: [
                            "Aged ",
                            ri.age
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($52ab70f9c7f90d6e$var$TextLight, {
                        children: [
                            "Retiring ",
                            ri.retirementAge
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($52ab70f9c7f90d6e$var$TextLight, {
                        children: ri.smokerStatus === "Yes" ? "Does Smoke" : "Doesn't Smoke"
                    })
                ]
            }, index);
        })
    });
};
var $52ab70f9c7f90d6e$var$_obj;
var $52ab70f9c7f90d6e$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($52ab70f9c7f90d6e$var$_obj = {
    display: "flex",
    justifyContent: "center",
    margin: "0 auto"
}, (0, $8c6ug._)($52ab70f9c7f90d6e$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "row",
    gap: "16px",
    padding: "16px 0"
}), (0, $8c6ug._)($52ab70f9c7f90d6e$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "column",
    gap: "24px",
    padding: "24px 0"
}), (0, $8c6ug._)($52ab70f9c7f90d6e$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    gap: "48px",
    padding: "48px 0"
}), $52ab70f9c7f90d6e$var$_obj));
var $52ab70f9c7f90d6e$var$_obj1;
var $52ab70f9c7f90d6e$var$Pill = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($52ab70f9c7f90d6e$var$_obj1 = {
    display: "flex",
    gap: "32px",
    padding: "16px 32px",
    background: "#F8F9FC",
    justifyContent: "space-between",
    textAlign: "center"
}, (0, $8c6ug._)($52ab70f9c7f90d6e$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column",
    borderRadius: "50px"
}), (0, $8c6ug._)($52ab70f9c7f90d6e$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "row",
    borderRadius: "25px"
}), (0, $8c6ug._)($52ab70f9c7f90d6e$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    borderRadius: "25px"
}), $52ab70f9c7f90d6e$var$_obj1));
var $52ab70f9c7f90d6e$var$TextStrong = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span({
    margin: "auto",
    fontWeight: 600,
    lineHeight: "180%"
});
var $52ab70f9c7f90d6e$var$TextLight = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span({
    margin: "auto",
    lineHeight: "180%",
    color: "#6E717C"
});



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");


var $41dbf29e199601ee$exports = {};
$41dbf29e199601ee$exports = $parcel$resolve("35RJU");



var $23e20e31ca84aa26$export$c03bac8b345e7784 = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($23e20e31ca84aa26$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($23e20e31ca84aa26$var$BigTextBlock, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($23e20e31ca84aa26$var$BigText, {
                        children: "What are the chances... you could die, get a critical illness or be unable to work for 4 weeks or more before reaching retirement age?"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($23e20e31ca84aa26$var$LegalAndGeneralLogo, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($41dbf29e199601ee$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                weight: 400,
                children: "With the help of Legal & General, one of the UK's best known and leading mortgage and life protection providers, we have compared your information against UK population and insurer claims statistics to estimate the likelihood of these life events."
            })
        ]
    });
};
var $23e20e31ca84aa26$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    maxWidth: 1400,
    margin: "0 auto",
    padding: "16px"
});
var $23e20e31ca84aa26$var$_obj;
var $23e20e31ca84aa26$var$BigTextBlock = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($23e20e31ca84aa26$var$_obj = {
    display: "flex",
    padding: "0 0 32px"
}, (0, $8c6ug._)($23e20e31ca84aa26$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column-reverse",
    gap: "40px"
}), (0, $8c6ug._)($23e20e31ca84aa26$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "row",
    gap: "40px"
}), (0, $8c6ug._)($23e20e31ca84aa26$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    gap: "40px"
}), $23e20e31ca84aa26$var$_obj));
var $23e20e31ca84aa26$var$_obj1;
var $23e20e31ca84aa26$var$BigText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(($23e20e31ca84aa26$var$_obj1 = {
    maxWidth: 900,
    fontSize: "36px",
    fontWeight: 700,
    flex: 1,
    margin: 0
}, (0, $8c6ug._)($23e20e31ca84aa26$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    fontSize: "24px"
}), (0, $8c6ug._)($23e20e31ca84aa26$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    fontSize: "24px"
}), (0, $8c6ug._)($23e20e31ca84aa26$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    fontSize: "36px"
}), $23e20e31ca84aa26$var$_obj1));
var $23e20e31ca84aa26$var$_obj2;
var $23e20e31ca84aa26$var$LegalAndGeneralLogo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img(($23e20e31ca84aa26$var$_obj2 = {
    width: "125px",
    height: "93px"
}, (0, $8c6ug._)($23e20e31ca84aa26$var$_obj2, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    margin: "0 auto"
}), (0, $8c6ug._)($23e20e31ca84aa26$var$_obj2, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    margin: "0 0 0 auto"
}), (0, $8c6ug._)($23e20e31ca84aa26$var$_obj2, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    margin: "0 0 0 auto"
}), $23e20e31ca84aa26$var$_obj2));



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");



var $74f30cba1e5de872$export$3b94e05644e5c575 = function(param) {
    var riskReport = param.riskReport;
    // Assert the first applicant's data. We that at least
    if (riskReport.riskIndividual.length < 1) throw new Error("Individual risk report data unavailable");
    var leadApplicant = riskReport.riskIndividual[0];
    // If it's a joint applicant report, use the combined calculations
    // If it's a single applicant report, use the individual calculations
    var combinedRisk = riskReport.riskJoint ? riskReport.riskJoint.combinedRisk : leadApplicant.combinedRisk;
    var deathRisk = riskReport.riskJoint ? riskReport.riskJoint.deathRisk : leadApplicant.deathRisk;
    var illnessRisk = riskReport.riskJoint ? riskReport.riskJoint.illnessRisk : leadApplicant.illnessRisk;
    var incomeRisk = riskReport.riskJoint ? riskReport.riskJoint.incomeRisk : leadApplicant.incomeRisk;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$RoundedBorder, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$DataSection, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$CombinedRiskSection, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$CombinedRiskVal, {
                                children: [
                                    Math.floor(combinedRisk),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Percent, {
                                        children: "%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$CombinedRiskText, {
                                children: "chance of death, serious illness or being unable to work before reaching retirement age"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskSection, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskRow, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskVal, {
                                                children: [
                                                    Math.floor(deathRisk),
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$BreakdownRiskText, {
                                                children: "Chance"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescSm, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescContext, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Death"
                                                    }),
                                                    " - You die before reaching retirement"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescPayout, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Life insurance"
                                                    }),
                                                    " - could pay a lump sum in the event of death"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescLg, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$SmallRiskDescLabel, {
                                                children: "Death"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$BreakdownRiskDescContext, {
                                                children: "You die before reaching retirement"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescPayout, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Life insurance"
                                                    }),
                                                    " could pay a lump sum in the event of death"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskRow, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskVal, {
                                                children: [
                                                    Math.floor(illnessRisk),
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$BreakdownRiskText, {
                                                children: "Chance"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescSm, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescContext, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Serious Illness"
                                                    }),
                                                    " - A serious illness stops you from working before retirement"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescPayout, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Critical illness cover"
                                                    }),
                                                    " - could pay a lump sum in the event of a serious illness"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescLg, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$SmallRiskDescLabel, {
                                                children: "Serious Illness"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$BreakdownRiskDescContext, {
                                                children: "A serious illness stops you from working before reaching retirement"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescPayout, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Critical illness cover"
                                                    }),
                                                    " could pay a lump sum in the event of serious illness diagnosis"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskRow, {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskVal, {
                                                children: [
                                                    Math.floor(incomeRisk),
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$BreakdownRiskText, {
                                                children: "Chance"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescSm, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescContext, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Unable to work"
                                                    }),
                                                    " - Illness or injury stops you working for 4 weeks or more before retirement"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescPayout, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Income protection"
                                                    }),
                                                    " - pays you a regular amount if you're unable to work"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescLg, {
                                        children: [
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$SmallRiskDescLabel, {
                                                children: "Unable to work"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$BreakdownRiskDescContext, {
                                                children: "Illness or injury stops you working for 4 weeks or more before reaching retirement"
                                            }),
                                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$BreakdownRiskDescPayout, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                                        children: "Income protection"
                                                    }),
                                                    " could pay you a regular amount if unable to work"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($74f30cba1e5de872$var$ExplainerSection, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$ExplainerHeader, {
                        children: "How your results are calculated"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        weight: 400,
                        children: "We review insurer claim rates to assess the risk of being unable to work and UK population statistics for serious illness and death rates, in combination with personal details about applicants such as age, intended retirement age, sex and smoker status to estimate the likelihood of a serious life event occurring between an applicant's current age and anticipated retirement age. It is a statistical guide based on the personal details provided, and where we don t hold every detail about you, we calculate averages to fill in the gaps. The longer the time from current age to retirement, the higher the statistical risk. Discuss the risks with a Mojo Protection Expert to understand how they apply to you."
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$ExplainerHeader, {
                        children: "Data sources"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        weight: 400,
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                children: "Inability to Work"
                            }),
                            " is based on on Income Protection claim rates (Institute of Actuaries IP06' series) and is indicative only for ages above 70 (adjusted for smoker status). ",
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                children: "Serious Illness"
                            }),
                            " is based on critical illness and death rates (Institute of Actuaries AC16' series). ",
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($74f30cba1e5de872$var$Bold, {
                                children: "Death"
                            }),
                            " is based on Based on mortality tables (Institute of Actuaries AM16' series)."
                        ]
                    })
                ]
            })
        ]
    });
};
var $74f30cba1e5de872$var$RoundedBorder = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    border: "1px solid #D1DDFC",
    borderRadius: "25px",
    marginBottom: "32px"
});
var $74f30cba1e5de872$var$_obj;
var $74f30cba1e5de872$var$DataSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj = {
    maxWidth: 1400,
    display: "flex"
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column",
    padding: "16px",
    gap: "12px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "column",
    padding: "29px",
    gap: "12px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    padding: "58px",
    gap: "24px"
}), $74f30cba1e5de872$var$_obj));
var $74f30cba1e5de872$var$_obj1;
var $74f30cba1e5de872$var$CombinedRiskSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj1 = {
    background: "#D1DDFC",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center"
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "24px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    width: "100%",
    height: "180px",
    padding: "24px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    width: "383px",
    height: "383px",
    margin: "0",
    padding: "48px"
}), $74f30cba1e5de872$var$_obj1));
var $74f30cba1e5de872$var$_obj2;
var $74f30cba1e5de872$var$CombinedRiskVal = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(($74f30cba1e5de872$var$_obj2 = {
    fontWeight: 700,
    margin: 0
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj2, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    fontSize: "80px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj2, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    fontSize: "80px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj2, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    fontSize: "160px"
}), $74f30cba1e5de872$var$_obj2));
var $74f30cba1e5de872$var$CombinedRiskText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    maxWidth: "372px",
    margin: "0 auto"
});
var $74f30cba1e5de872$var$_obj3;
var $74f30cba1e5de872$var$Percent = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span(($74f30cba1e5de872$var$_obj3 = {}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj3, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    fontSize: "40px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj3, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    fontSize: "40px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj3, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    fontSize: "80px"
}), $74f30cba1e5de872$var$_obj3));
var $74f30cba1e5de872$var$_obj4;
var $74f30cba1e5de872$var$BreakdownRiskSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj4 = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj4, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    gap: "12px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj4, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    gap: "12px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj4, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gap: "24px"
}), $74f30cba1e5de872$var$_obj4));
var $74f30cba1e5de872$var$_obj5;
var $74f30cba1e5de872$var$BreakdownRiskRow = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj5 = {
    display: "flex"
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj5, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    gap: "12px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj5, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    gap: "12px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj5, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    gap: "24px"
}), $74f30cba1e5de872$var$_obj5));
var $74f30cba1e5de872$var$_obj6;
var $74f30cba1e5de872$var$BreakdownRiskBox = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj6 = {
    background: "#D1DDFC",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    width: 100
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj6, "@media (max-width: 458px)", {
    height: "atuo"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj6, "@media (min-width: 459px)", {
    height: 100
}), $74f30cba1e5de872$var$_obj6));
var $74f30cba1e5de872$var$BreakdownRiskVal = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    fontSize: "1.5rem",
    fontWeight: 700,
    margin: 0
});
var $74f30cba1e5de872$var$BreakdownRiskText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    margin: 0
});
/*
 * Why are we using custom breakpoint here?
 *
 * Dealing with text wrapping in the breakdown section is very tricky. We cam't
 * use the normal `mobile`, `desktop`, etc. breakpoints without the UI looking
 * awful. We need more granular control.
 *
 * Why do we use `BreakdownRiskDescSm` and `BreakdownRiskDescLg` ?
 *
 * Using a dedicated title for each breakdown doesn't work on specific widths.
 * You end up with squashed text, and a lot of unused space. To make things
 * look pretty, I've inlined the breakdown title on some of these dimensions
 */ var $74f30cba1e5de872$var$sm = "@media (max-width: 767px)";
var $74f30cba1e5de872$var$md = "@media (min-width: 768px) and (max-width: 1023px)";
var $74f30cba1e5de872$var$lg = "@media (min-width: 1024px) and (max-width: 1259px)";
var $74f30cba1e5de872$var$xl = "@media (min-width: 1260px)";
var $74f30cba1e5de872$var$_obj7;
var $74f30cba1e5de872$var$BreakdownRiskDescSm = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj7 = {}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj7, $74f30cba1e5de872$var$sm, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    flex: 1,
    gap: "8px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj7, $74f30cba1e5de872$var$md, {
    display: "none"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj7, $74f30cba1e5de872$var$lg, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj7, $74f30cba1e5de872$var$xl, {
    display: "none"
}), $74f30cba1e5de872$var$_obj7));
var $74f30cba1e5de872$var$_obj8;
var $74f30cba1e5de872$var$BreakdownRiskDescLg = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj8 = {}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj8, $74f30cba1e5de872$var$sm, {
    display: "none"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj8, $74f30cba1e5de872$var$md, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj8, $74f30cba1e5de872$var$lg, {
    display: "none"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj8, $74f30cba1e5de872$var$xl, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1
}), $74f30cba1e5de872$var$_obj8));
var $74f30cba1e5de872$var$SmallRiskDescLabel = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontSize: "1.125rem",
    fontWeight: 600,
    margin: 0,
    padding: "0 12px"
});
var $74f30cba1e5de872$var$BreakdownRiskDescContext = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontSize: "0.875rem",
    color: "#3B4258",
    margin: 0,
    padding: "0 12px"
});
var $74f30cba1e5de872$var$BreakdownRiskDescPayout = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontSize: "0.875rem",
    background: "#FFEBDC",
    borderRadius: "12px",
    padding: "12px",
    margin: 0,
    width: "fit-content"
});
var $74f30cba1e5de872$var$Bold = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span({
    color: "black",
    fontWeight: 600
});
var $74f30cba1e5de872$var$_obj9;
var $74f30cba1e5de872$var$ExplainerSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($74f30cba1e5de872$var$_obj9 = {
    background: "#F8F9FC",
    borderRadius: "0 0 25px 25px"
}, (0, $8c6ug._)($74f30cba1e5de872$var$_obj9, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "24px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj9, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    padding: "36px"
}), (0, $8c6ug._)($74f30cba1e5de872$var$_obj9, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    padding: "48px"
}), $74f30cba1e5de872$var$_obj9));
var $74f30cba1e5de872$var$ExplainerHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    margin: "0 0 16px",
    fontSize: "1.5rem",
    fontWeight: 600
});



var $8c6ug = parcelRequire("8c6ug");

parcelRequire("hAGkE");




var $e97abc9664befcb5$var$smokerText = function(smokerStatus) {
    return smokerStatus === "Yes" ? "Smoker" : "Non-Smoker";
};
var $e97abc9664befcb5$export$e4404cf6f3445659 = function(param) {
    var riskReport = param.riskReport;
    if (riskReport.riskIndividual.length === 0) throw new Error("No individual data found in risk report");
    var isRiskJoint = riskReport.riskIndividual.length > 1;
    var applicant1 = riskReport.riskIndividual[0];
    var applicant2 = isRiskJoint ? riskReport.riskIndividual[1] : null;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$Copy, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d8bf44dc56d11f69$export$a8a3e93435678ff9), {
                        size: "h4",
                        children: "Individual applicant risks"
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $fe95aeefc35bd5ae$export$358a232cca1ab2ac), {
                        weight: 400,
                        children: "The risks above are a combined view of all applicants in this protection review. The individual applicant risks are as follows:"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardSection, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCard, {
                        applicant: applicant1
                    }),
                    applicant2 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCard, {
                        applicant: applicant2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$PoweredBy, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$PoweredByText, {
                        children: "Powered with data from "
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$PoweredByLogo, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($41dbf29e199601ee$exports)))
                    })
                ]
            })
        ]
    });
};
var $e97abc9664befcb5$var$RiskCard = function(param) {
    var applicant = param.applicant;
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardContainer, {
        children: [
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardHeader, {
                children: applicant.name
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardSummary, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardSummaryData, {
                        children: "Age ".concat(applicant.age, ", ")
                    }),
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardSummaryData, {
                        children: "".concat(applicant.sex, ", ")
                    }),
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardSummaryData, {
                        children: "".concat($e97abc9664befcb5$var$smokerText(applicant.smokerStatus), ", ")
                    }),
                    " ",
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardSummaryData, {
                        children: "Retire at ".concat(applicant.retirementAge)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardBody, {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRow, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardRowText, {
                                children: "Death"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRowVal, {
                                children: [
                                    applicant.deathRisk,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRow, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardRowText, {
                                children: "Serious Illness"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRowVal, {
                                children: [
                                    applicant.illnessRisk,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRow, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardRowText, {
                                children: "Unable to Work"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRowVal, {
                                children: [
                                    applicant.incomeRisk,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRowHighlighted, {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($e97abc9664befcb5$var$RiskCardRowTextBold, {
                                children: "Combined Risk"
                            }),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($e97abc9664befcb5$var$RiskCardRowVal, {
                                children: [
                                    applicant.combinedRisk,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e97abc9664befcb5$var$_obj;
var $e97abc9664befcb5$var$Container = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($e97abc9664befcb5$var$_obj = {
    maxWidth: 1400,
    margin: "0 auto 32px",
    display: "flex",
    flexDirection: "column",
    gap: "16px"
}, (0, $8c6ug._)($e97abc9664befcb5$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "4px",
    gap: "4px"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    padding: "8px",
    gap: "8px"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    padding: "16px",
    gap: "16px"
}), $e97abc9664befcb5$var$_obj));
var $e97abc9664befcb5$var$Copy = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    textAlign: "center",
    maxWidth: "600px",
    margin: "0 auto"
});
var $e97abc9664befcb5$var$_obj1;
var $e97abc9664befcb5$var$RiskCardSection = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($e97abc9664befcb5$var$_obj1 = {
    display: "flex",
    justifyContent: "center"
}, (0, $8c6ug._)($e97abc9664befcb5$var$_obj1, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj1, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    flexDirection: "column",
    alignItems: "center",
    gap: "1.5rem"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj1, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    flexDirection: "row",
    gap: "2rem"
}), $e97abc9664befcb5$var$_obj1));
var $e97abc9664befcb5$var$_obj2;
var $e97abc9664befcb5$var$RiskCardContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($e97abc9664befcb5$var$_obj2 = {
    border: "1px solid #D1DDFC",
    borderRadius: "25px",
    padding: "2rem 1.5rem 1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: "16px"
}, (0, $8c6ug._)($e97abc9664befcb5$var$_obj2, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    width: "100%"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj2, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    width: "100%"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj2, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    width: "400px"
}), $e97abc9664befcb5$var$_obj2));
var $e97abc9664befcb5$var$RiskCardHeader = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontWeight: 600,
    textAlign: "center",
    fontSize: "1.5rem",
    margin: 0
});
var $e97abc9664befcb5$var$RiskCardSummary = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    fontWeight: 400,
    textAlign: "center",
    fontSize: "0.9rem",
    color: "#3B4258",
    margin: 0
});
var $e97abc9664befcb5$var$RiskCardSummaryData = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).span({
    textWrap: "nowrap"
});
var $e97abc9664befcb5$var$RiskCardBody = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    flexDirection: "column"
});
var $e97abc9664befcb5$var$RiskCardRow = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 16px"
});
var $e97abc9664befcb5$var$RiskCardRowHighlighted = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($e97abc9664befcb5$var$RiskCardRow)({
    background: "#F8F9FC",
    padding: "16px",
    margin: "16px 0 0",
    borderRadius: "8px"
});
var $e97abc9664befcb5$var$_obj3;
var $e97abc9664befcb5$var$RiskCardRowText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(($e97abc9664befcb5$var$_obj3 = {
    fontWeight: 400,
    margin: "auto 0"
}, (0, $8c6ug._)($e97abc9664befcb5$var$_obj3, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    fontSize: "0.8rem"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj3, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    fontSize: "1rem"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj3, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    fontSize: "1rem"
}), $e97abc9664befcb5$var$_obj3));
var $e97abc9664befcb5$var$RiskCardRowTextBold = (0, $62d655c53090e8a3$export$2e2bcd8739ae039)($e97abc9664befcb5$var$RiskCardRowText)({
    fontWeight: 500
});
var $e97abc9664befcb5$var$_obj4;
var $e97abc9664befcb5$var$RiskCardRowVal = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p(($e97abc9664befcb5$var$_obj4 = {
    fontWeight: 600,
    background: "#D1DDFC",
    padding: "16px",
    borderRadius: "8px",
    margin: 0,
    textAlign: "center"
}, (0, $8c6ug._)($e97abc9664befcb5$var$_obj4, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    fontSize: "0.8rem",
    width: "70px"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj4, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    fontSize: "1rem",
    width: "80px"
}), (0, $8c6ug._)($e97abc9664befcb5$var$_obj4, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    fontSize: "1rem",
    width: "80px"
}), $e97abc9664befcb5$var$_obj4));
var $e97abc9664befcb5$var$PoweredBy = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    maxWidth: 1400,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    marginTop: "24px"
});
var $e97abc9664befcb5$var$PoweredByText = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).p({
    color: "#3B4258",
    fontSize: "0.675rem",
    margin: "16px 8px 0 0"
});
var $e97abc9664befcb5$var$PoweredByLogo = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).img({
    width: 40,
    height: 30
});


var $244a570423ba478c$export$a7fcdbab4403685 = function() {
    var friendlyId = (0, $f4f5613f4156d471$export$99eaa27ddbbb95ef)().friendlyId;
    var _useRiskReport = (0, $6efc334165c86458$export$add278f196a9dbdf)(friendlyId), riskReport = _useRiskReport.riskReport, isLoading = _useRiskReport.isLoading, error = _useRiskReport.error;
    (0, $6efc334165c86458$export$8321eca889f4503c)(friendlyId, isLoading, error);
    if (isLoading) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
        children: "Loading . . ."
    });
    if (error) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("p", {
        children: error
    });
    if (!riskReport) throw Error("Risk report data unavailable");
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $68164826edc95436$export$c3bb089bd80cbef5), {
        backgroundWave: true,
        headerStyle: (0, $68164826edc95436$export$54a719cd6595ff5c).None,
        footer: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($244a570423ba478c$var$Footer, {}),
        content: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($244a570423ba478c$var$Page, {
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $738e2b107ba32cce$export$8b251419efc915eb), {
                    riskReport: riskReport
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)($244a570423ba478c$var$Body, {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $52ab70f9c7f90d6e$export$bfd46b96653838bc), {
                            riskReport: riskReport
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $23e20e31ca84aa26$export$c03bac8b345e7784), {}),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $74f30cba1e5de872$export$3b94e05644e5c575), {
                            riskReport: riskReport
                        }),
                        riskReport.riskIndividual.length > 1 && /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $e97abc9664befcb5$export$e4404cf6f3445659), {
                            riskReport: riskReport
                        })
                    ]
                })
            ]
        })
    });
};
var $244a570423ba478c$var$Page = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    margin: 0
});
var $244a570423ba478c$var$_obj;
var $244a570423ba478c$var$Body = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div(($244a570423ba478c$var$_obj = {
    background: "white",
    borderRadius: "50px 50px 0 0",
    maxWidth: 1400,
    margin: "0 auto"
}, (0, $8c6ug._)($244a570423ba478c$var$_obj, (0, $1ca2cdaa0912b6ea$export$1c4e7a9c31a6c071), {
    padding: "0 8px"
}), (0, $8c6ug._)($244a570423ba478c$var$_obj, (0, $1ca2cdaa0912b6ea$export$74c1bba07084d12b), {
    padding: "0 16px"
}), (0, $8c6ug._)($244a570423ba478c$var$_obj, (0, $1ca2cdaa0912b6ea$export$4239d699c596afd), {
    padding: "0 32px"
}), $244a570423ba478c$var$_obj));
var $244a570423ba478c$var$Footer = function() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($244a570423ba478c$var$FooterContainer, {
        children: "Mojo is a trading style of Life's Great Limited (06246376). Regulated by the FCA (478215). Registered office: The Cooperage, 5 Copper Row, London, SE1 2LH."
    });
};
var $244a570423ba478c$var$FooterContainer = (0, $62d655c53090e8a3$export$2e2bcd8739ae039).div({
    background: "#000928",
    color: "white",
    textAlign: "center",
    padding: "32px"
});



(0, $780cdf6be3225998$export$2e2bcd8739ae039).init((0, $10b47c5a212e87a0$export$7570faec158c06ad));
function $f5ee9e9c2ddafab3$export$2e2bcd8739ae039() {
    var _useRecoilState = (0, $6mdMa._)((0, $d7ce42c300073b00$export$12012bbeae92bfa2)((0, $e686c778565af949$export$2969e4c65c6cdaa0)), 1), applicationError = _useRecoilState[0];
    if (applicationError) return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f5ee9e9c2ddafab3$var$ErrorFallback, {});
    window.Intercom && window.Intercom("update", {
        hide_default_launcher: true
    });
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $bcccde1f2f42f600$exports.ErrorBoundary), {
        onError: (0, $411b073b3fd49a19$export$5c9af0966a1ac889),
        FallbackComponent: $f5ee9e9c2ddafab3$var$ErrorFallback,
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $5b21716e72347dde$export$15061808233f1766), {
            children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $0fdb4bda9b5ecf04$export$3d71a527ba323bde), {
                children: [
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $97394a501a830081$export$9ba4e89fdfa1fc54), {
                        children: [
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $337a4240dba910e9$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $f4f5613f4156d471$export$b5d5cf8927ab7262), {
                                children: [
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/application/:friendlyId/fact-find/",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$2d8d895a0a0f636e), {
                                            to: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/dashboard",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $a827c6bc3eda7a57$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/new-application",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $11c4ed1fd466dc20$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/login",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $67c42ed412895136$export$b62eb5ea790b4398), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/get-started",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $acea317de969142c$export$ed13bb07514c5437), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/routing-summary",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/routing-summary",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/application/:friendlyId",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $de59818823b3a69a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/magic-login",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $5fbf271b50477ab1$export$790b2e2a77fa417), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/request-magic-link",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $67c42ed412895136$export$b62eb5ea790b4398), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/mortgagescore",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/mortgagescore",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/survey-login",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/survey-login",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/confirmation",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/confirmation",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/callbackrequested",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/callbackrequested",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/schedule/:applicationId",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/schedule/:applicationId",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/book/:applicationId",
                                        render: function(props) {
                                            return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                                path: "/book/:applicationId",
                                                doRedirect: function() {
                                                    window.location.href = "/results/".concat(props.match.params.applicationId, "/crm").concat(window.location.search);
                                                }
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/book-from-table/:applicationId",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/book-from-table/:applicationId",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/reschedule/:applicationId/",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cf845e9a134f5eb5$export$3cbd42d8a7a14292), {
                                            path: "/reschedule/:applicationId",
                                            redirect: "/dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/recommended/:id",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9d529d00c983eb8e$export$ee6c7041db7d70a3), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/specific-rec/:token/:timestamp",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b9d4462c5c09d1e0$export$77cbc0bc8180ab32), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/rec-preview/:token",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b9d4462c5c09d1e0$export$77cbc0bc8180ab32), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/s/:code",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $b31167eef17b2c22$export$399e0cde635d2d6c), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/rate-check-request",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $c56619601916f4f7$export$308ac02cf1b46d1), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/protection-review",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $689a13ea7d1dc764$export$6733eeac9e628250), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/rate-check-promise",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $8b9aba2ed88130ce$export$4e80a4010ef1396c), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/risk-report/:friendlyId",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $244a570423ba478c$export$a7fcdbab4403685), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f4f5613f4156d471$export$e7b0ac011bb776c6), {
                                        path: "/500",
                                        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9a66e4f46705a007$export$7d465be8efa67280), {})
                                    }),
                                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)($f5ee9e9c2ddafab3$var$RedirectToDash, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $598b3ff84e134333$export$44fbea0b26cea290), {})
                ]
            })
        })
    });
}
function $f5ee9e9c2ddafab3$var$RedirectToDash() {
    var history = (0, $f4f5613f4156d471$export$3420e1dc2c4a518c)();
    (0, $hAGkE.useEffect)(function() {
        history.replace("/dashboard".concat(window.location.search));
    }, []);
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {});
}
// TODO: Make this useful for a user
function $f5ee9e9c2ddafab3$var$ErrorFallback() {
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $3d45074523d8f6b3$exports.Fragment), {
        children: "An error has occurred"
    });
}



var $6mdMa = parcelRequire("6mdMa");


var $hAGkE = parcelRequire("hAGkE");

var $cfdc442cb44972a6$exports = {};
"use strict";
Object.defineProperty($cfdc442cb44972a6$exports, "__esModule", {
    value: true
});
$cfdc442cb44972a6$exports["default"] = $cfdc442cb44972a6$exports.Normalize = $cfdc442cb44972a6$exports.normalize = void 0;

var $cfdc442cb44972a6$var$normalize = (0, $62d655c53090e8a3$export$dbf350e5966cf602)([
    "html{line-height:1.15;-webkit-text-size-adjust:100%;}body{margin:0;}main{display:block;}h1{font-size:2em;margin:0.67em 0;}hr{box-sizing:content-box;height:0;overflow:visible;}pre{font-family:monospace,monospace;font-size:1em;}a{background-color:transparent;}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted;}b,strong{font-weight:bolder;}code,kbd,samp{font-family:monospace,monospace;font-size:1em;}small{font-size:80%;}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}sub{bottom:-0.25em;}sup{top:-0.5em;}img{border-style:none;}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0;}button,input{overflow:visible;}button,select{text-transform:none;}button,[type=\"button\"],[type=\"reset\"],[type=\"submit\"]{-webkit-appearance:button;}button::-moz-focus-inner,[type=\"button\"]::-moz-focus-inner,[type=\"reset\"]::-moz-focus-inner,[type=\"submit\"]::-moz-focus-inner{border-style:none;padding:0;}button:-moz-focusring,[type=\"button\"]:-moz-focusring,[type=\"reset\"]:-moz-focusring,[type=\"submit\"]:-moz-focusring{outline:1px dotted ButtonText;}fieldset{padding:0.35em 0.75em 0.625em;}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal;}progress{vertical-align:baseline;}textarea{overflow:auto;}[type=\"checkbox\"],[type=\"radio\"]{box-sizing:border-box;padding:0;}[type=\"number\"]::-webkit-inner-spin-button,[type=\"number\"]::-webkit-outer-spin-button{height:auto;}[type=\"search\"]{-webkit-appearance:textfield;outline-offset:-2px;}[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit;}details{display:block;}summary{display:list-item;}template{display:none;}[hidden]{display:none;}"
]);
$cfdc442cb44972a6$exports.normalize = $cfdc442cb44972a6$var$normalize;
var $cfdc442cb44972a6$var$Normalize = (0, $62d655c53090e8a3$export$f0f03736edb61697)($cfdc442cb44972a6$var$normalize);
$cfdc442cb44972a6$exports.Normalize = $cfdc442cb44972a6$var$Normalize;
$cfdc442cb44972a6$var$Normalize.displayName = 'Normalize';
var $cfdc442cb44972a6$var$_default = $cfdc442cb44972a6$var$normalize;
$cfdc442cb44972a6$exports["default"] = $cfdc442cb44972a6$var$_default;


// @ts-nocheck



function $95b069ba013ad327$var$_templateObject() {
    var data = (0, $a50e02d455b7efe5$export$71511d61b312f219)([
        "\n  html, body, #root {\n    margin: 0;\n    height: 100%;\n  }\n\n  html {\n    scroll-behavior: smooth;\n  }\n\n  body {\n    background: ",
        ";\n    font-family: ",
        ";\n    overflow: ",
        ";\n    font-variant-numeric: lining-nums;\n  }\n\n  a {\n    color: black;\n    cursor: pointer;\n  }\n\n  *, *::before, *::after {\n    box-sizing: border-box;\n  }\n\n  h1 {\n\n    font-size: 1.6em;\n    font-weight: bold;\n    margin: 0;\n    @media ",
        " {\n      font-size: 2.27em;\n    }\n  }\n\n  h2 {\n    font-size: 1.5em;\n    font-weight: bold;\n    margin: 0;\n    @media ",
        " {\n      font-size: 1.802em;\n    }\n  }\n\n  h3 {\n    font-size: 1.45em;\n    margin: 0;\n    @media ",
        " {\n      font-size: 1.602em;\n    }\n  }\n\n  h4 {\n    font-size: 1.2em;\n    margin: 0;\n    @media ",
        " {\n      font-size: 1.424em;\n    }\n  }\n\n  h5 {\n    font-size: 1.66em;\n  }\n\n  p {\n    margin: 25px 0;\n  }\n\n  @media ",
        " {\n    #root::-webkit-scrollbar {\n      width: 15px;\n    }\n\n    #root::-webkit-scrollbar-track {\n      background: white;\n    }\n\n    #root::-webkit-scrollbar-thumb {\n      background-color: #c3c3c3;\n      border-radius: 7.5px;\n      box-shadow: inset 0px 0 0 3px white;\n    }\n  }\n"
    ]);
    $95b069ba013ad327$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $95b069ba013ad327$export$2e2bcd8739ae039 = (0, $62d655c53090e8a3$export$f0f03736edb61697)($95b069ba013ad327$var$_templateObject(), function(props) {
    return props.theme.backgroundColour;
}, function(props) {
    return props.theme.fontFamily;
}, function(props) {
    return props.blockScroll ? "hidden" : "visible";
}, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_sm, (0, $e7f5b961b2d85f88$export$2e2bcd8739ae039).bp_md);



var $2xTNA = parcelRequire("2xTNA");

var $0047932fb68f9dcb$exports = {};

var $2xTNA = parcelRequire("2xTNA");
'use strict';
function $0047932fb68f9dcb$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $2xTNA._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $hAGkE = parcelRequire("hAGkE");
var $0047932fb68f9dcb$var$React__default = $0047932fb68f9dcb$var$_interopDefault($hAGkE);
function $0047932fb68f9dcb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0047932fb68f9dcb$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $0047932fb68f9dcb$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $0047932fb68f9dcb$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $0047932fb68f9dcb$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $0047932fb68f9dcb$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($hAGkE.PureComponent);
        $0047932fb68f9dcb$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $0047932fb68f9dcb$var$_defineProperty(SideEffect, "canUseDOM", $0047932fb68f9dcb$var$canUseDOM);
        return SideEffect;
    };
}
$0047932fb68f9dcb$exports = $0047932fb68f9dcb$var$withSideEffect;


var $6712644de485be2f$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ 
var $2xTNA = parcelRequire("2xTNA");
var $6712644de485be2f$var$hasElementType = typeof Element !== 'undefined';
var $6712644de485be2f$var$hasMap = typeof Map === 'function';
var $6712644de485be2f$var$hasSet = typeof Set === 'function';
var $6712644de485be2f$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $6712644de485be2f$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $2xTNA._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $2xTNA._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$6712644de485be2f$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($6712644de485be2f$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$6712644de485be2f$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($6712644de485be2f$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($6712644de485be2f$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($6712644de485be2f$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$6712644de485be2f$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$6712644de485be2f$exports = function isEqual(a, b) {
    try {
        return $6712644de485be2f$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $hAGkE = parcelRequire("hAGkE");
var $12f93ab5c1b25103$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $12f93ab5c1b25103$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $12f93ab5c1b25103$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $12f93ab5c1b25103$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $12f93ab5c1b25103$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $12f93ab5c1b25103$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$12f93ab5c1b25103$exports = $12f93ab5c1b25103$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $12f93ab5c1b25103$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($12f93ab5c1b25103$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($12f93ab5c1b25103$var$getOwnPropertySymbols) {
            symbols = $12f93ab5c1b25103$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($12f93ab5c1b25103$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $76c44ed9aa628753$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $76c44ed9aa628753$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $76c44ed9aa628753$var$VALID_TAG_NAMES = Object.keys($76c44ed9aa628753$var$TAG_NAMES).map(function(name) {
    return $76c44ed9aa628753$var$TAG_NAMES[name];
});
var $76c44ed9aa628753$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $76c44ed9aa628753$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    "class": "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $76c44ed9aa628753$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $76c44ed9aa628753$var$HTML_TAG_MAP = Object.keys($76c44ed9aa628753$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$76c44ed9aa628753$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $76c44ed9aa628753$var$SELF_CLOSING_TAGS = [
    $76c44ed9aa628753$var$TAG_NAMES.NOSCRIPT,
    $76c44ed9aa628753$var$TAG_NAMES.SCRIPT,
    $76c44ed9aa628753$var$TAG_NAMES.STYLE
];
var $76c44ed9aa628753$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $76c44ed9aa628753$var$_typeof = typeof Symbol === "function" && (0, $2xTNA._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj);
};
var $76c44ed9aa628753$var$classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $76c44ed9aa628753$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $76c44ed9aa628753$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $76c44ed9aa628753$var$inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $2xTNA._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $76c44ed9aa628753$var$objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $76c44ed9aa628753$var$possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $2xTNA._)(call)) === "object" || typeof call === "function") ? call : self;
};
var $76c44ed9aa628753$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $76c44ed9aa628753$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $76c44ed9aa628753$var$getInnermostProperty(propsList, $76c44ed9aa628753$var$TAG_NAMES.TITLE);
    var innermostTemplate = $76c44ed9aa628753$var$getInnermostProperty(propsList, $76c44ed9aa628753$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $76c44ed9aa628753$var$getInnermostProperty(propsList, $76c44ed9aa628753$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $76c44ed9aa628753$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $76c44ed9aa628753$var$getInnermostProperty(propsList, $76c44ed9aa628753$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $76c44ed9aa628753$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $76c44ed9aa628753$var$_extends({}, tagAttrs, current);
    }, {});
};
var $76c44ed9aa628753$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$76c44ed9aa628753$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$76c44ed9aa628753$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $76c44ed9aa628753$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $76c44ed9aa628753$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $76c44ed9aa628753$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $76c44ed9aa628753$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $76c44ed9aa628753$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $76c44ed9aa628753$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $76c44ed9aa628753$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $76c44ed9aa628753$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($12f93ab5c1b25103$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $76c44ed9aa628753$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $76c44ed9aa628753$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $76c44ed9aa628753$var$getBaseTagFromPropsList([
            $76c44ed9aa628753$var$TAG_PROPERTIES.HREF,
            $76c44ed9aa628753$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $76c44ed9aa628753$var$getAttributesFromPropsList($76c44ed9aa628753$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $76c44ed9aa628753$var$getInnermostProperty(propsList, $76c44ed9aa628753$var$HELMET_PROPS.DEFER),
        encode: $76c44ed9aa628753$var$getInnermostProperty(propsList, $76c44ed9aa628753$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $76c44ed9aa628753$var$getAttributesFromPropsList($76c44ed9aa628753$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $76c44ed9aa628753$var$getTagsFromPropsList($76c44ed9aa628753$var$TAG_NAMES.LINK, [
            $76c44ed9aa628753$var$TAG_PROPERTIES.REL,
            $76c44ed9aa628753$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $76c44ed9aa628753$var$getTagsFromPropsList($76c44ed9aa628753$var$TAG_NAMES.META, [
            $76c44ed9aa628753$var$TAG_PROPERTIES.NAME,
            $76c44ed9aa628753$var$TAG_PROPERTIES.CHARSET,
            $76c44ed9aa628753$var$TAG_PROPERTIES.HTTPEQUIV,
            $76c44ed9aa628753$var$TAG_PROPERTIES.PROPERTY,
            $76c44ed9aa628753$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $76c44ed9aa628753$var$getTagsFromPropsList($76c44ed9aa628753$var$TAG_NAMES.NOSCRIPT, [
            $76c44ed9aa628753$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $76c44ed9aa628753$var$getOnChangeClientState(propsList),
        scriptTags: $76c44ed9aa628753$var$getTagsFromPropsList($76c44ed9aa628753$var$TAG_NAMES.SCRIPT, [
            $76c44ed9aa628753$var$TAG_PROPERTIES.SRC,
            $76c44ed9aa628753$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $76c44ed9aa628753$var$getTagsFromPropsList($76c44ed9aa628753$var$TAG_NAMES.STYLE, [
            $76c44ed9aa628753$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $76c44ed9aa628753$var$getTitleFromPropsList(propsList),
        titleAttributes: $76c44ed9aa628753$var$getAttributesFromPropsList($76c44ed9aa628753$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $76c44ed9aa628753$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $76c44ed9aa628753$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $76c44ed9aa628753$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $76c44ed9aa628753$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $76c44ed9aa628753$var$rafPolyfill : $parcel$global.requestAnimationFrame || $76c44ed9aa628753$var$rafPolyfill;
var $76c44ed9aa628753$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $76c44ed9aa628753$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $76c44ed9aa628753$var$cafPolyfill;
var $76c44ed9aa628753$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $76c44ed9aa628753$var$_helmetCallback = null;
var $76c44ed9aa628753$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($76c44ed9aa628753$var$_helmetCallback) $76c44ed9aa628753$var$cancelAnimationFrame($76c44ed9aa628753$var$_helmetCallback);
    if (newState.defer) $76c44ed9aa628753$var$_helmetCallback = $76c44ed9aa628753$var$requestAnimationFrame(function() {
        $76c44ed9aa628753$var$commitTagChanges(newState, function() {
            $76c44ed9aa628753$var$_helmetCallback = null;
        });
    });
    else {
        $76c44ed9aa628753$var$commitTagChanges(newState);
        $76c44ed9aa628753$var$_helmetCallback = null;
    }
};
var $76c44ed9aa628753$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $76c44ed9aa628753$var$updateAttributes($76c44ed9aa628753$var$TAG_NAMES.BODY, bodyAttributes);
    $76c44ed9aa628753$var$updateAttributes($76c44ed9aa628753$var$TAG_NAMES.HTML, htmlAttributes);
    $76c44ed9aa628753$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $76c44ed9aa628753$var$updateTags($76c44ed9aa628753$var$TAG_NAMES.BASE, baseTag),
        linkTags: $76c44ed9aa628753$var$updateTags($76c44ed9aa628753$var$TAG_NAMES.LINK, linkTags),
        metaTags: $76c44ed9aa628753$var$updateTags($76c44ed9aa628753$var$TAG_NAMES.META, metaTags),
        noscriptTags: $76c44ed9aa628753$var$updateTags($76c44ed9aa628753$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $76c44ed9aa628753$var$updateTags($76c44ed9aa628753$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $76c44ed9aa628753$var$updateTags($76c44ed9aa628753$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $76c44ed9aa628753$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $76c44ed9aa628753$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $76c44ed9aa628753$var$flattenArray(title);
    $76c44ed9aa628753$var$updateAttributes($76c44ed9aa628753$var$TAG_NAMES.TITLE, attributes);
};
var $76c44ed9aa628753$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($76c44ed9aa628753$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($76c44ed9aa628753$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($76c44ed9aa628753$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($76c44ed9aa628753$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $76c44ed9aa628753$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($76c44ed9aa628753$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $76c44ed9aa628753$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $76c44ed9aa628753$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $76c44ed9aa628753$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($76c44ed9aa628753$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $76c44ed9aa628753$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $76c44ed9aa628753$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $76c44ed9aa628753$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $76c44ed9aa628753$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $76c44ed9aa628753$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $76c44ed9aa628753$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $76c44ed9aa628753$var$HELMET_ATTRIBUTE + "=\"true\">" + $76c44ed9aa628753$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $76c44ed9aa628753$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $76c44ed9aa628753$var$TAG_PROPERTIES.INNER_HTML || attribute === $76c44ed9aa628753$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $76c44ed9aa628753$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $76c44ed9aa628753$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $76c44ed9aa628753$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $76c44ed9aa628753$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$76c44ed9aa628753$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $76c44ed9aa628753$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$76c44ed9aa628753$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $76c44ed9aa628753$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$76c44ed9aa628753$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $76c44ed9aa628753$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement($76c44ed9aa628753$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $76c44ed9aa628753$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$76c44ed9aa628753$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $76c44ed9aa628753$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $76c44ed9aa628753$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $76c44ed9aa628753$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(type, mappedTag);
    });
};
var $76c44ed9aa628753$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $76c44ed9aa628753$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $76c44ed9aa628753$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $76c44ed9aa628753$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $76c44ed9aa628753$var$ATTRIBUTE_NAMES.BODY:
        case $76c44ed9aa628753$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $76c44ed9aa628753$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $76c44ed9aa628753$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $76c44ed9aa628753$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $76c44ed9aa628753$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $76c44ed9aa628753$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.META, metaTags, encode),
        noscript: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $76c44ed9aa628753$var$getMethodsForTag($76c44ed9aa628753$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $76c44ed9aa628753$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $76c44ed9aa628753$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $76c44ed9aa628753$var$classCallCheck(this, HelmetWrapper);
            return $76c44ed9aa628753$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($6712644de485be2f$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $76c44ed9aa628753$var$TAG_NAMES.SCRIPT:
                case $76c44ed9aa628753$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $76c44ed9aa628753$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $76c44ed9aa628753$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $76c44ed9aa628753$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $76c44ed9aa628753$var$TAG_NAMES.TITLE:
                    return $76c44ed9aa628753$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $76c44ed9aa628753$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $76c44ed9aa628753$var$TAG_NAMES.BODY:
                    return $76c44ed9aa628753$var$_extends({}, newProps, {
                        bodyAttributes: $76c44ed9aa628753$var$_extends({}, newChildProps)
                    });
                case $76c44ed9aa628753$var$TAG_NAMES.HTML:
                    return $76c44ed9aa628753$var$_extends({}, newProps, {
                        htmlAttributes: $76c44ed9aa628753$var$_extends({}, newChildProps)
                    });
            }
            return $76c44ed9aa628753$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $76c44ed9aa628753$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $76c44ed9aa628753$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $76c44ed9aa628753$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $76c44ed9aa628753$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $76c44ed9aa628753$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $76c44ed9aa628753$var$TAG_NAMES.LINK:
                    case $76c44ed9aa628753$var$TAG_NAMES.META:
                    case $76c44ed9aa628753$var$TAG_NAMES.NOSCRIPT:
                    case $76c44ed9aa628753$var$TAG_NAMES.SCRIPT:
                    case $76c44ed9aa628753$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $76c44ed9aa628753$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $76c44ed9aa628753$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).createElement(Component, newProps);
        };
        $76c44ed9aa628753$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($hAGkE))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c12eb6708ebe6a4a$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $76c44ed9aa628753$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $76c44ed9aa628753$var$NullComponent = function NullComponent() {
    return null;
};
var $76c44ed9aa628753$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($0047932fb68f9dcb$exports)))($76c44ed9aa628753$var$reducePropsToState, $76c44ed9aa628753$var$handleClientStateChange, $76c44ed9aa628753$var$mapStateOnServer)($76c44ed9aa628753$var$NullComponent);
var $76c44ed9aa628753$export$dcef8f9bb9a41431 = $76c44ed9aa628753$var$Helmet($76c44ed9aa628753$var$HelmetSideEffects);
$76c44ed9aa628753$export$dcef8f9bb9a41431.renderStatic = $76c44ed9aa628753$export$dcef8f9bb9a41431.rewind;
var $76c44ed9aa628753$export$2e2bcd8739ae039 = $76c44ed9aa628753$export$dcef8f9bb9a41431;




var $hAGkE = parcelRequire("hAGkE");
var $9b51938d0c585bba$export$903a1028504c7340 = (0, $hAGkE.createContext)({
    setBlockScroll: function() {}
});


function $5f1303bfb7cae0ef$export$2e2bcd8739ae039(param) {
    var children = param.children;
    var theme = (0, $7e7d633c88171aa1$export$b3611e87cd5ba6ce)().theme;
    var _useState = (0, $6mdMa._)((0, $hAGkE.useState)(false), 2), blockScroll = _useState[0], setBlockScroll = _useState[1];
    return /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $9b51938d0c585bba$export$903a1028504c7340).Provider, {
        value: {
            setBlockScroll: setBlockScroll
        },
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $62d655c53090e8a3$export$d8964aec282183a3), {
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsxs)((0, $76c44ed9aa628753$export$dcef8f9bb9a41431), {
                    children: [
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("title", {
                            children: theme.pageTitle
                        }),
                        /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)("link", {
                            rel: "icon",
                            type: "image/png",
                            href: theme.faviconURL,
                            sizes: "16x16"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $cfdc442cb44972a6$exports.Normalize), {}),
                /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $95b069ba013ad327$export$2e2bcd8739ae039), {
                    blockScroll: blockScroll
                }),
                children
            ]
        })
    });
}




var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $bOqL7 = parcelRequire("bOqL7");

var $cCIJH = parcelRequire("cCIJH");
var $8yexE = parcelRequire("8yexE");

var $cCIJH = parcelRequire("cCIJH");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $jYvOn = parcelRequire("jYvOn");
var $gVncj = parcelRequire("gVncj");

var $7Ui5X = parcelRequire("7Ui5X");

var $1DzcS = parcelRequire("1DzcS");

var $cCIJH = parcelRequire("cCIJH");

var $8fOd9 = parcelRequire("8fOd9");
var $465ec00b3bbedb49$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $465ec00b3bbedb49$var$filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map(function(k) {
        return integrationsByName[k];
    });
}
/** Gets integrations to install */ function $465ec00b3bbedb49$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) integrations = (0, $bOqL7._)(defaultIntegrations).concat((0, $bOqL7._)(userIntegrations));
    else if (typeof userIntegrations === 'function') integrations = (0, $jYvOn.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    var finalIntegrations = $465ec00b3bbedb49$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    var debugIndex = $465ec00b3bbedb49$var$findIndex(finalIntegrations, function(integration) {
        return integration.name === 'Debug';
    });
    if (debugIndex !== -1) {
        var _finalIntegrations_splice = (0, $6mdMa._)(finalIntegrations.splice(debugIndex, 1), 1), debugInstance = _finalIntegrations_splice[0];
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $465ec00b3bbedb49$export$51abed9797baa598(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        // guard against empty provided integrations
        if (integration) $465ec00b3bbedb49$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $465ec00b3bbedb49$export$35abcfd71227c6ca(client, integrations) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = integrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var integration = _step.value;
            // guard against empty provided integrations
            if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/** Setup a single integration.  */ function $465ec00b3bbedb49$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("Integration skipped because it was already installed: ".concat(integration.name));
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($465ec00b3bbedb49$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $1DzcS.addGlobalEventProcessor), (0, $8fOd9.getCurrentHub));
        $465ec00b3bbedb49$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        var callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        var callback1 = integration.processEvent.bind(integration);
        var processor = function(event, hint) {
            return callback1(event, hint, client);
        };
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("Integration installed: ".concat(integration.name));
}
/** Add an integration to the current hub's client. */ function $465ec00b3bbedb49$export$2d8f5188773bcddd(integration) {
    var client = (0, $cCIJH.getClient)();
    if (!client || !client.addIntegration) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Cannot add integration "'.concat(integration.name, '" because no SDK Client is available.'));
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $465ec00b3bbedb49$var$findIndex(arr, callback) {
    for(var i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $465ec00b3bbedb49$export$afa219bf23651160(name, fn) {
    var ConvertedIntegration = function ConvertedIntegration() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return fn.apply(void 0, (0, $bOqL7._)(args));
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $465ec00b3bbedb49$export$2323046b9414659f(fn) {
    return fn;
}


var $29cbee80d38de484$var$originalFunctionToString;
var $29cbee80d38de484$var$INTEGRATION_NAME = 'FunctionToString';
var $29cbee80d38de484$var$SETUP_CLIENTS = new WeakMap();
var $29cbee80d38de484$var$_functionToStringIntegration = function() {
    return {
        name: $29cbee80d38de484$var$INTEGRATION_NAME,
        setupOnce: function() {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $29cbee80d38de484$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = (0, $8yexE.getOriginalFunction)(this);
                    var context = $29cbee80d38de484$var$SETUP_CLIENTS.has((0, $cCIJH.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $29cbee80d38de484$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup: function(client) {
            $29cbee80d38de484$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ var $29cbee80d38de484$export$7918117e9202e4fb = (0, $465ec00b3bbedb49$export$2323046b9414659f)($29cbee80d38de484$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $29cbee80d38de484$export$da4704525c20ae79 = (0, $465ec00b3bbedb49$export$afa219bf23651160)($29cbee80d38de484$var$INTEGRATION_NAME, $29cbee80d38de484$export$7918117e9202e4fb);


var $8fOd9 = parcelRequire("8fOd9");
var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $84Gbr = parcelRequire("84Gbr");

var $gVncj = parcelRequire("gVncj");
/** Regular expression used to parse a Dsn. */ var $166ca73332398b10$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $166ca73332398b10$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $166ca73332398b10$export$44d472fbb931a776(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : '') + "@".concat(host).concat(port ? ":".concat(port) : '', "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $166ca73332398b10$export$b892860177f70a30(str) {
    var match = $166ca73332398b10$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $gVncj.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return undefined;
    }
    var _match_slice = (0, $6mdMa._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? '' : tmp, host = _match_slice[3], tmp1 = _match_slice[4], port = tmp1 === void 0 ? '' : tmp1, lastPath = _match_slice[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $166ca73332398b10$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $166ca73332398b10$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $166ca73332398b10$var$validateDsn(dsn) {
    if (!(0, $84Gbr.DEBUG_BUILD)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, $gVncj.logger).error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $gVncj.logger).error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!$166ca73332398b10$var$isValidProtocol(protocol)) {
        (0, $gVncj.logger).error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $gVncj.logger).error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $166ca73332398b10$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $166ca73332398b10$export$b892860177f70a30(from) : $166ca73332398b10$var$dsnFromComponents(from);
    if (!components || !$166ca73332398b10$var$validateDsn(components)) return undefined;
    return components;
}


var $8yexE = parcelRequire("8yexE");
var $8aa085f524a012cf$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $8aa085f524a012cf$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : '';
    var port = dsn.port ? ":".concat(dsn.port) : '';
    return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : '', "/api/");
}
/** Returns the ingest API endpoint for target. */ function $8aa085f524a012cf$var$_getIngestEndpoint(dsn) {
    return "".concat($8aa085f524a012cf$var$getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $8aa085f524a012cf$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $8yexE.urlEncode)((0, $hRCmZ._)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $8aa085f524a012cf$var$SENTRY_API_VERSION
    }, sdkInfo && {
        sentry_client: "".concat(sdkInfo.name, "/").concat(sdkInfo.version)
    }));
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $8aa085f524a012cf$export$9964600bfe84e6a3(dsn) {
    var // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
    // options: ClientOptions = {} as ClientOptions,
    tunnelOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    var tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    var sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : "".concat($8aa085f524a012cf$var$_getIngestEndpoint(dsn), "?").concat($8aa085f524a012cf$var$_encodedAuth(dsn, sdkInfo));
}
/** Returns the url to the report dialog endpoint. */ function $8aa085f524a012cf$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $166ca73332398b10$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    var endpoint = "".concat($8aa085f524a012cf$var$getBaseApiEndpoint(dsn), "embed/error-page/");
    var encodedOptions = "dsn=".concat((0, $166ca73332398b10$export$44d472fbb931a776)(dsn));
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            var user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += "&name=".concat(encodeURIComponent(user.name));
            if (user.email) encodedOptions += "&email=".concat(encodeURIComponent(user.email));
        } else encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
    }
    return "".concat(endpoint, "?").concat(encodedOptions);
}


var $bOqL7 = parcelRequire("bOqL7");

var $jYvOn = parcelRequire("jYvOn");
var $gVncj = parcelRequire("gVncj");
var $gj3Le = parcelRequire("gj3Le");

var $7Ui5X = parcelRequire("7Ui5X");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $5d0455182d3a3fff$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
var $5d0455182d3a3fff$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ var $5d0455182d3a3fff$var$INTEGRATION_NAME = 'InboundFilters';
var $5d0455182d3a3fff$var$_inboundFiltersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        name: $5d0455182d3a3fff$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(event, _hint, client) {
            var clientOptions = client.getOptions();
            var mergedOptions = $5d0455182d3a3fff$var$_mergeOptions(options, clientOptions);
            return $5d0455182d3a3fff$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
var $5d0455182d3a3fff$export$cb3c5c2ceb9818ba = (0, $465ec00b3bbedb49$export$2323046b9414659f)($5d0455182d3a3fff$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $5d0455182d3a3fff$export$2ffbb5359dcc6be4 = (0, $465ec00b3bbedb49$export$afa219bf23651160)($5d0455182d3a3fff$var$INTEGRATION_NAME, $5d0455182d3a3fff$export$cb3c5c2ceb9818ba);
function $5d0455182d3a3fff$var$_mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0, $bOqL7._)(internalOptions.allowUrls || []).concat((0, $bOqL7._)(clientOptions.allowUrls || [])),
        denyUrls: (0, $bOqL7._)(internalOptions.denyUrls || []).concat((0, $bOqL7._)(clientOptions.denyUrls || [])),
        ignoreErrors: (0, $bOqL7._)(internalOptions.ignoreErrors || []).concat((0, $bOqL7._)(clientOptions.ignoreErrors || []), (0, $bOqL7._)(internalOptions.disableErrorDefaults ? [] : $5d0455182d3a3fff$var$DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0, $bOqL7._)(internalOptions.ignoreTransactions || []).concat((0, $bOqL7._)(clientOptions.ignoreTransactions || []), (0, $bOqL7._)(internalOptions.disableTransactionDefaults ? [] : $5d0455182d3a3fff$var$DEFAULT_IGNORE_TRANSACTIONS)),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5d0455182d3a3fff$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $5d0455182d3a3fff$var$_isSentryError(event)) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat((0, $jYvOn.getEventDescription)(event)));
        return true;
    }
    if ($5d0455182d3a3fff$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat((0, $jYvOn.getEventDescription)(event)));
        return true;
    }
    if ($5d0455182d3a3fff$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat((0, $jYvOn.getEventDescription)(event)));
        return true;
    }
    if ($5d0455182d3a3fff$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat((0, $jYvOn.getEventDescription)(event), ".\nUrl: ").concat($5d0455182d3a3fff$var$_getEventFilterUrl(event)));
        return true;
    }
    if (!$5d0455182d3a3fff$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat((0, $jYvOn.getEventDescription)(event), ".\nUrl: ").concat($5d0455182d3a3fff$var$_getEventFilterUrl(event)));
        return true;
    }
    return false;
}
function $5d0455182d3a3fff$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $5d0455182d3a3fff$var$_getPossibleEventMessages(event).some(function(message) {
        return (0, $gj3Le.stringMatchesSomePattern)(message, ignoreErrors);
    });
}
function $5d0455182d3a3fff$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    var name = event.transaction;
    return name ? (0, $gj3Le.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $5d0455182d3a3fff$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $5d0455182d3a3fff$var$_getEventFilterUrl(event);
    return !url ? false : (0, $gj3Le.stringMatchesSomePattern)(url, denyUrls);
}
function $5d0455182d3a3fff$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $5d0455182d3a3fff$var$_getEventFilterUrl(event);
    return !url ? true : (0, $gj3Le.stringMatchesSomePattern)(url, allowUrls);
}
function $5d0455182d3a3fff$var$_getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    var lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
        }
    }
    if ((0, $7Ui5X.DEBUG_BUILD) && possibleMessages.length === 0) (0, $gVncj.logger).error("Could not extract message for event ".concat((0, $jYvOn.getEventDescription)(event)));
    return possibleMessages;
}
function $5d0455182d3a3fff$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5d0455182d3a3fff$var$_getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5d0455182d3a3fff$var$_getEventFilterUrl(event) {
    try {
        var frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $5d0455182d3a3fff$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).error("Cannot extract url for event ".concat((0, $jYvOn.getEventDescription)(event)));
        return null;
    }
}


var $gVncj = parcelRequire("gVncj");

var $7Ui5X = parcelRequire("7Ui5X");

var $cCIJH = parcelRequire("cCIJH");

var $8fOd9 = parcelRequire("8fOd9");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $b78b4fb34736de6b$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $7Ui5X.DEBUG_BUILD) (0, $gVncj.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $gVncj.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    var scope = (0, $cCIJH.getCurrentScope)();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    $b78b4fb34736de6b$export$ecb76f41d43c0e43(client);
    $b78b4fb34736de6b$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $b78b4fb34736de6b$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, $8fOd9.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    var top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $b78b4fb34736de6b$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}



var $8yexE = parcelRequire("8yexE");



var $lVfPx = parcelRequire("lVfPx");

var $lVfPx = parcelRequire("lVfPx");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
var $27abb86427247702$var$WINDOW = (0, $lVfPx.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $27abb86427247702$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chromeVar = $27abb86427247702$var$WINDOW.chrome;
    var isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in $27abb86427247702$var$WINDOW && !!$27abb86427247702$var$WINDOW.history.pushState && !!$27abb86427247702$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $3SZNV = parcelRequire("3SZNV");
var $98deba007e94a00d$var$WINDOW = (0, $lVfPx.GLOBAL_OBJ);
var $98deba007e94a00d$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $98deba007e94a00d$export$3f18c56c58114e75(handler) {
    var type = 'history';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $98deba007e94a00d$var$instrumentHistory);
}
function $98deba007e94a00d$var$instrumentHistory() {
    if (!(0, $27abb86427247702$export$67fc34576016d6ec)()) return;
    var oldOnPopState = $98deba007e94a00d$var$WINDOW.onpopstate;
    $98deba007e94a00d$var$WINDOW.onpopstate = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = $98deba007e94a00d$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $98deba007e94a00d$var$lastHref;
        $98deba007e94a00d$var$lastHref = to;
        var handlerData = {
            from: from,
            to: to
        };
        (0, $3SZNV.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $98deba007e94a00d$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $98deba007e94a00d$var$lastHref = to;
                var handlerData = {
                    from: from,
                    to: to
                };
                (0, $3SZNV.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $8yexE.fill)($98deba007e94a00d$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $8yexE.fill)($98deba007e94a00d$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}


var $gVncj = parcelRequire("gVncj");
var $dRvnI = parcelRequire("dRvnI");
var $84Gbr = parcelRequire("84Gbr");

var $gVncj = parcelRequire("gVncj");

var $lVfPx = parcelRequire("lVfPx");
// eslint-disable-next-line deprecation/deprecation
var $51d1e3cc284b3a5e$var$WINDOW = (0, $lVfPx.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $51d1e3cc284b3a5e$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $51d1e3cc284b3a5e$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $51d1e3cc284b3a5e$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $51d1e3cc284b3a5e$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $51d1e3cc284b3a5e$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $51d1e3cc284b3a5e$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $51d1e3cc284b3a5e$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$51d1e3cc284b3a5e$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($51d1e3cc284b3a5e$export$18cf36ed71d733e7($51d1e3cc284b3a5e$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = $51d1e3cc284b3a5e$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $51d1e3cc284b3a5e$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $84Gbr.DEBUG_BUILD) && (0, $gVncj.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $51d1e3cc284b3a5e$export$531055a6c684a70a() {
    return 'ReportingObserver' in $51d1e3cc284b3a5e$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $51d1e3cc284b3a5e$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$51d1e3cc284b3a5e$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $gBEGf = parcelRequire("gBEGf");

var $3LSeA = parcelRequire("3LSeA");

var $a7G5R = parcelRequire("a7G5R");

var $kyZym = parcelRequire("kyZym");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $41e9d6181be2d4c6$export$b9f95b027256052c(options, name) {
    var names = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        name
    ], source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'npm';
    var metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: "sentry.javascript.".concat(name),
        packages: names.map(function(name) {
            return {
                name: "".concat(source, ":@sentry/").concat(name),
                version: (0, $kyZym.SDK_VERSION)
            };
        }),
        version: (0, $kyZym.SDK_VERSION)
    };
    options._metadata = metadata;
}


var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");


var $gCPnr = parcelRequire("gCPnr");

var $8yexE = parcelRequire("8yexE");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $05db56156fa7707f$export$f93f7f385160c44e(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $05db56156fa7707f$export$d650323442802f6f(envelope, newItem) {
    var _envelope = (0, $6mdMa._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, $bOqL7._)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $05db56156fa7707f$export$c56c55acf0136fd3(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $05db56156fa7707f$export$604a45d95a155e2b(envelope, types) {
    return $05db56156fa7707f$export$c56c55acf0136fd3(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8.
 */ function $05db56156fa7707f$var$encodeUTF8(input, textEncoder) {
    var utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $05db56156fa7707f$export$32f9b428425aac85(envelope, textEncoder) {
    var _envelope = (0, $6mdMa._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $05db56156fa7707f$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $05db56156fa7707f$var$encodeUTF8(next, textEncoder) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, $6mdMa._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0, $gCPnr.normalize)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === 'string' ? parts : $05db56156fa7707f$var$concatBuffers(parts);
}
function $05db56156fa7707f$var$concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $05db56156fa7707f$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    var buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $05db56156fa7707f$export$d8fc80952cc31fa4(attachment, textEncoder) {
    var buffer = typeof attachment.data === 'string' ? $05db56156fa7707f$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $8yexE.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
var $05db56156fa7707f$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $05db56156fa7707f$export$b11169581eeaf237(type) {
    return $05db56156fa7707f$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $05db56156fa7707f$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $05db56156fa7707f$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $hRCmZ._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $166ca73332398b10$export$44d472fbb931a776)(dsn)
    }, dynamicSamplingContext && {
        trace: (0, $8yexE.dropUndefinedKeys)((0, $hRCmZ._)({}, dynamicSamplingContext))
    });
}


var $jYvOn = parcelRequire("jYvOn");
var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");
var $gXCgb = parcelRequire("gXCgb");/** An error emitted by Sentry SDKs and related utilities. */ 
var $bQby9 = parcelRequire("bQby9");

var $6WLcG = parcelRequire("6WLcG");

var $a7G5R = parcelRequire("a7G5R");

var $2DHfY = parcelRequire("2DHfY");
var $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2 = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $a7G5R._)(SentryError, Error1);
    function SentryError(message) {
        var logLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'warn';
        (0, $6WLcG._)(this, SentryError);
        var _this;
        _this = (0, $bQby9._)(this, SentryError, [
            message
        ]);
        _this.message = message;
        _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(_this, (this instanceof SentryError ? this.constructor : void 0).prototype);
        _this.logLevel = logLevel;
        return _this;
    }
    return SentryError;
}((0, $2DHfY._)(Error));




var $7Ui5X = parcelRequire("7Ui5X");

var $hRCmZ = parcelRequire("hRCmZ");

var $bOqL7 = parcelRequire("bOqL7");

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $7f0941d4c6dd1236$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $bOqL7._)(event.sdk.integrations || []).concat((0, $bOqL7._)(sdkInfo.integrations || []));
    event.sdk.packages = (0, $bOqL7._)(event.sdk.packages || []).concat((0, $bOqL7._)(sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */ function $7f0941d4c6dd1236$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    var sdkInfo = (0, $05db56156fa7707f$export$d369f3b2758f6743)(metadata);
    var envelopeHeaders = (0, $hRCmZ._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $166ca73332398b10$export$44d472fbb931a776)(dsn)
    });
    var envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $05db56156fa7707f$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $7f0941d4c6dd1236$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    var sdkInfo = (0, $05db56156fa7707f$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $7f0941d4c6dd1236$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    var envelopeHeaders = (0, $05db56156fa7707f$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $05db56156fa7707f$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}



var $cCIJH = parcelRequire("cCIJH");

var $8fOd9 = parcelRequire("8fOd9");



var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $8yexE = parcelRequire("8yexE");
/**
 * Generate bucket key from metric properties.
 */ function $6d13f1dad2a7f982$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    var stringifiedTags = Object.entries((0, $8yexE.dropUndefinedKeys)(tags)).sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    });
    return "".concat(metricType).concat(name).concat(unit).concat(stringifiedTags);
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $6d13f1dad2a7f982$export$b211ce59c0ea1cfb(s) {
    var rv = 0;
    for(var i = 0; i < s.length; i++){
        var c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $6d13f1dad2a7f982$export$66decd709db01dc8(metricBucketItems) {
    var out = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = metricBucketItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var tagEntries = Object.entries(item.tags);
            var maybeTags = tagEntries.length > 0 ? "|#".concat(tagEntries.map(function(param) {
                var _param = (0, $6mdMa._)(param, 2), key = _param[0], value = _param[1];
                return "".concat(key, ":").concat(value);
            }).join(',')) : '';
            out += "".concat(item.name, "@").concat(item.unit, ":").concat(item.metric, "|").concat(item.metricType).concat(maybeTags, "|T").concat(item.timestamp, "\n");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
/** Sanitizes units */ function $6d13f1dad2a7f982$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $6d13f1dad2a7f982$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $6d13f1dad2a7f982$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
var $6d13f1dad2a7f982$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $6d13f1dad2a7f982$var$getCharOrReplacement(input) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $6d13f1dad2a7f982$var$tagValueReplacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6mdMa._)(_step.value, 2), search = _step_value[0], replacement = _step_value[1];
            if (input === search) return replacement;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return input;
}
function $6d13f1dad2a7f982$var$sanitizeTagValue(value) {
    return (0, $bOqL7._)(value).reduce(function(acc, _char) {
        return acc + $6d13f1dad2a7f982$var$getCharOrReplacement(_char);
    }, '');
}
/**
 * Sanitizes tags.
 */ function $6d13f1dad2a7f982$export$ae49af12dbdf2477(unsanitizedTags) {
    var tags = {};
    for(var key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        var sanitizedKey = $6d13f1dad2a7f982$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $6d13f1dad2a7f982$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $019894fe2f5e6575$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $166ca73332398b10$export$44d472fbb931a776)(dsn);
    var item = $019894fe2f5e6575$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $05db56156fa7707f$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $019894fe2f5e6575$var$createMetricEnvelopeItem(metricBucketItems) {
    var payload = (0, $6d13f1dad2a7f982$export$66decd709db01dc8)(metricBucketItems);
    var metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}



var $6TUUw = parcelRequire("6TUUw");

var $dYxb4 = parcelRequire("dYxb4");

var $1wdOb = parcelRequire("1wdOb");
var $24ed5a20d81241a9$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ var $24ed5a20d81241a9$export$4f22f74eddb7716a = /*#__PURE__*/ function() {
    "use strict";
    function BaseClient(options) {
        (0, $6WLcG._)(this, BaseClient);
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $166ca73332398b10$export$128827c3562ec0cb)(options.dsn);
        else (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            var url = (0, $8aa085f524a012cf$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport((0, $7XD9P._)((0, $hRCmZ._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
    (0, $dbIwN._)(BaseClient, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                // ensure we haven't captured this very object before
                if ((0, $jYvOn.checkOrSetAlreadyCaught)(exception)) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log($24ed5a20d81241a9$var$ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                this._process(this.eventFromException(exception, hint).then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint, scope) {
                var _this = this;
                var eventId = hint && hint.event_id;
                var eventMessage = (0, $8lokx.isParameterizedString)(message) ? message : String(message);
                var promisedEvent = (0, $8lokx.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
                this._process(promisedEvent.then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                // ensure we haven't captured this very object before
                if (hint && hint.originalException && (0, $jYvOn.checkOrSetAlreadyCaught)(hint.originalException)) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log($24ed5a20d81241a9$var$ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
                this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession(session) {
                if (!(typeof session.release === 'string')) (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn('Discarded session because of missing or non-string release');
                else {
                    this.sendSession(session);
                    // After sending, we set init false to indicate it's not the first occurrence
                    (0, $6TUUw.updateSession)(session, {
                        init: false
                    });
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush(timeout) {
                var transport = this._transport;
                if (transport) {
                    if (this.metricsAggregator) this.metricsAggregator.flush();
                    return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                        return transport.flush(timeout).then(function(transportFlushed) {
                            return clientFinished && transportFlushed;
                        });
                    });
                } else return (0, $gXCgb.resolvedSyncPromise)(true);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close(timeout) {
                var _this = this;
                return this.flush(timeout).then(function(result) {
                    _this.getOptions().enabled = false;
                    if (_this.metricsAggregator) _this.metricsAggregator.close();
                    return result;
                });
            }
        },
        {
            /** Get all installed event processors. */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /** @inheritDoc */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ key: "setupIntegrations",
            value: function setupIntegrations(forceInitialize) {
                if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
            }
        },
        {
            /** @inheritdoc */ key: "init",
            value: function init() {
                if (this._isEnabled()) this._setupIntegrations();
            }
        },
        {
            /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegrationById",
            value: function getIntegrationById(integrationId) {
                return this.getIntegrationByName(integrationId);
            }
        },
        {
            /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ key: "getIntegrationByName",
            value: function getIntegrationByName(integrationName) {
                return this._integrations[integrationName];
            }
        },
        {
            /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                try {
                    return this._integrations[integration.id] || null;
                } catch (_oO) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Cannot retrieve integration ".concat(integration.id, " from the current Client"));
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                var isAlreadyInstalled = this._integrations[integration.name];
                // This hook takes care of only installing if not already installed
                (0, $465ec00b3bbedb49$export$e7390a03b70a6f2f)(this, integration, this._integrations);
                // Here we need to check manually to make sure to not run this multiple times
                if (!isAlreadyInstalled) (0, $465ec00b3bbedb49$export$35abcfd71227c6ca)(this, [
                    integration
                ]);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var _this = this;
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.emit('beforeSendEvent', event, hint);
                var env = (0, $7f0941d4c6dd1236$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = (0, $05db56156fa7707f$export$d650323442802f6f)(env, (0, $05db56156fa7707f$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var promise = this._sendEnvelope(env);
                if (promise) promise.then(function(sendResponse) {
                    return _this.emit('afterSendEvent', event, sendResponse);
                }, null);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendSession",
            value: function sendSession(session) {
                var env = (0, $7f0941d4c6dd1236$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(env);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category, eventOrCount) {
                if (this._options.sendClientReports) {
                    // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
                    // If event is passed as third argument, we assume this is a count of 1
                    var count = typeof eventOrCount === 'number' ? eventOrCount : 1;
                    // We want to track each category (error, transaction, session, replay_event) separately
                    // but still keep the distinction between different type of outcomes.
                    // We could use nested maps, but it's much easier to read and type this way.
                    // A correct type for map-based implementation if we want to go that route
                    // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
                    // With typescript 4.1 we could even use template literal types
                    var key = "".concat(reason, ":").concat(category);
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log('Recording outcome: "'.concat(key, '"').concat(count > 1 ? " (".concat(count, " times)") : ''));
                    this._outcomes[key] = (this._outcomes[key] || 0) + count;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureAggregateMetrics",
            value: function captureAggregateMetrics(metricBucketItems) {
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).log("Flushing aggregated metrics, number of metrics: ".concat(metricBucketItems.length));
                var metricsEnvelope = (0, $019894fe2f5e6575$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(metricsEnvelope);
            }
        },
        {
            // Keep on() & emit() signatures in sync with types' client.ts interface
            /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ key: "on",
            value: function on(hook, callback) {
                if (!this._hooks[hook]) this._hooks[hook] = [];
                // @ts-expect-error We assue the types are correct
                this._hooks[hook].push(callback);
            }
        },
        {
            /** @inheritdoc */ /** @inheritdoc */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (this._hooks[hook]) this._hooks[hook].forEach(function(callback) {
                    return callback.apply(void 0, (0, $bOqL7._)(rest));
                });
            }
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ key: "_setupIntegrations",
            value: function _setupIntegrations() {
                var integrations = this._options.integrations;
                this._integrations = (0, $465ec00b3bbedb49$export$51abed9797baa598)(this, integrations);
                (0, $465ec00b3bbedb49$export$35abcfd71227c6ca)(this, integrations);
                // TODO v8: We don't need this flag anymore
                this._integrationsInitialized = true;
            }
        },
        {
            /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var crashed = false;
                var errored = false;
                var exceptions = event.exception && event.exception.values;
                if (exceptions) {
                    errored = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            var mechanism = ex.mechanism;
                            if (mechanism && mechanism.handled === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // A session is updated and that session update is sent in only one of the two following scenarios:
                // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
                // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
                var sessionNonTerminal = session.status === 'ok';
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0, $6TUUw.updateSession)(session, (0, $7XD9P._)((0, $hRCmZ._)({}, crashed && {
                        status: 'crashed'
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ key: "_isClientDoneProcessing",
            value: function _isClientDoneProcessing(timeout) {
                var _this = this;
                return new (0, $gXCgb.SyncPromise)(function(resolve) {
                    var ticked = 0;
                    var tick = 1;
                    var interval = setInterval(function() {
                        if (_this._numProcessing == 0) {
                            clearInterval(interval);
                            resolve(true);
                        } else {
                            ticked += tick;
                            if (timeout && ticked >= timeout) {
                                clearInterval(interval);
                                resolve(false);
                            }
                        }
                    }, tick);
                });
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== undefined;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                var _this = this;
                var isolationScope = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $8fOd9.getIsolationScope)();
                var options = this.getOptions();
                var integrations = Object.keys(this._integrations);
                if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
                this.emit('preprocessEvent', event, hint);
                return (0, $1wdOb.prepareEvent)(options, event, hint, scope, this, isolationScope).then(function(evt) {
                    if (evt === null) return evt;
                    var propagationContext = (0, $hRCmZ._)({}, isolationScope.getPropagationContext(), scope ? scope.getPropagationContext() : undefined);
                    var trace = evt.contexts && evt.contexts.trace;
                    if (!trace && propagationContext) {
                        var trace_id = propagationContext.traceId, spanId = propagationContext.spanId, parentSpanId = propagationContext.parentSpanId, dsc = propagationContext.dsc;
                        evt.contexts = (0, $hRCmZ._)({
                            trace: {
                                trace_id: trace_id,
                                span_id: spanId,
                                parent_span_id: parentSpanId
                            }
                        }, evt.contexts);
                        var dynamicSamplingContext = dsc ? dsc : (0, $dYxb4.getDynamicSamplingContextFromClient)(trace_id, _this, scope);
                        evt.sdkProcessingMetadata = (0, $hRCmZ._)({
                            dynamicSamplingContext: dynamicSamplingContext
                        }, evt.sdkProcessingMetadata);
                    }
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0;
                return this._processEvent(event, hint, scope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (0, $7Ui5X.DEBUG_BUILD) {
                        // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                        // control flow, log just the message (no stack) as a log-level log.
                        var sentryError = reason;
                        if (sentryError.logLevel === 'log') (0, $gVncj.logger).log(sentryError.message);
                        else (0, $gVncj.logger).warn(sentryError);
                    }
                    return undefined;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, scope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = $24ed5a20d81241a9$var$isTransactionEvent(event);
                var isError = $24ed5a20d81241a9$var$isErrorEvent(event);
                var eventType = event.type || 'error';
                var beforeSendLabel = "before send for type `".concat(eventType, "`");
                // 1.0 === 100% events are sent
                // 0.0 === 0% events are sent
                // Sampling for transaction happens somewhere else
                if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
                    this.recordDroppedEvent('sample_rate', 'error', event);
                    return (0, $gXCgb.rejectedSyncPromise)(new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"), 'log'));
                }
                var dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
                return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then(function(prepared) {
                    if (prepared === null) {
                        _this.recordDroppedEvent('event_processor', dataCategory, event);
                        throw new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
                    }
                    var isInternalException = hint.data && hint.data.__sentry__ === true;
                    if (isInternalException) return prepared;
                    var result = $24ed5a20d81241a9$var$processBeforeSend(options, prepared, hint);
                    return $24ed5a20d81241a9$var$_validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent('before_send', dataCategory, event);
                        if (isTransaction) {
                            var spans = event.spans || [];
                            // the transaction itself counts as one span, plus all the child spans that are added
                            var spanCount = 1 + spans.length;
                            _this.recordDroppedEvent('before_send', 'span', spanCount);
                        }
                        throw new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)("".concat(beforeSendLabel, " returned `null`, will not send event."), 'log');
                    }
                    var session = scope && scope.getSession();
                    if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
                    if (isTransaction) {
                        var spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                        var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                        var droppedSpanCount = spanCountBefore - spanCountAfter;
                        if (droppedSpanCount > 0) _this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
                    }
                    // None of the Sentry built event processor will update transaction name,
                    // so if the transaction name has been changed by an event processor, we know
                    // it has to come from custom event processor added by a user
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = 'custom';
                        processedEvent.transaction_info = (0, $7XD9P._)((0, $hRCmZ._)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if (reason instanceof (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)) throw reason;
                    _this.captureException(reason, {
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(promise) {
                var _this = this;
                this._numProcessing++;
                promise.then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    return reason;
                });
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "_sendEnvelope",
            value: function _sendEnvelope(envelope) {
                this.emit('beforeEnvelope', envelope);
                if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, function(reason) {
                    (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).error('Error while sending event:', reason);
                });
                else (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).error('Transport disabled');
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.keys(outcomes).map(function(key) {
                    var _key_split = (0, $6mdMa._)(key.split(':'), 2), reason = _key_split[0], category = _key_split[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: outcomes[key]
                    };
                });
            }
        }
    ]);
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $24ed5a20d81241a9$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
    if ((0, $8lokx.isThenable)(beforeSendResult)) return beforeSendResult.then(function(event) {
        if (!(0, $8lokx.isPlainObject)(event) && event !== null) throw new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, function(e) {
        throw new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
    else if (!(0, $8lokx.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $24ed5a20d81241a9$var$processBeforeSend(options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction;
    if ($24ed5a20d81241a9$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($24ed5a20d81241a9$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            var spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = (0, $7XD9P._)((0, $hRCmZ._)({}, event.sdkProcessingMetadata), {
                spanCountBeforeProcessing: spanCountBefore
            });
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $24ed5a20d81241a9$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $24ed5a20d81241a9$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $24ed5a20d81241a9$export$9aac0b9f77928fbf(callback) {
    var client = (0, $cCIJH.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




var $fzAJT = parcelRequire("fzAJT");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $a062bcde5d5948a1$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $fzAJT.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $05db56156fa7707f$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $pwbWG = parcelRequire("pwbWG");
var $gVncj = parcelRequire("gVncj");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var $f062c7a5ed5d9f7e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $cCIJH = parcelRequire("cCIJH");

var $jYvOn = parcelRequire("jYvOn");
var $8yexE = parcelRequire("8yexE");
var $8lokx = parcelRequire("8lokx");
var $gCPnr = parcelRequire("gCPnr");
var $gXCgb = parcelRequire("gXCgb");
/**
 * This function creates an exception from a JavaScript Error
 */ function $cb5e003253ebf691$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $cb5e003253ebf691$export$d478b2c12fbcfdda(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: $cb5e003253ebf691$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $cb5e003253ebf691$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = (0, $cCIJH.getClient)();
    var normalizeDepth = client && client.getOptions().normalizeDepth;
    var event = {
        exception: {
            values: [
                {
                    type: (0, $8lokx.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $cb5e003253ebf691$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $gCPnr.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        var frames = $cb5e003253ebf691$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $cb5e003253ebf691$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $cb5e003253ebf691$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $cb5e003253ebf691$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $cb5e003253ebf691$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $cb5e003253ebf691$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $cb5e003253ebf691$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($cb5e003253ebf691$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $cb5e003253ebf691$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $cb5e003253ebf691$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $cb5e003253ebf691$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $jYvOn.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gXCgb.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $cb5e003253ebf691$export$5425b53185d13d6c(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'info', hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $cb5e003253ebf691$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gXCgb.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $cb5e003253ebf691$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $8lokx.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $cb5e003253ebf691$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $8lokx.isDOMError)(exception) || (0, $8lokx.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $cb5e003253ebf691$export$73fbea5a0a5234af(stackParser, exception);
        else {
            var name = domException.name || ((0, $8lokx.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = $cb5e003253ebf691$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $jYvOn.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, $7XD9P._)((0, $hRCmZ._)({}, event.tags), {
            'DOMException.code': "".concat(domException.code)
        });
        return event;
    }
    if ((0, $8lokx.isError)(exception)) // we have a real Error object, do nothing
    return $cb5e003253ebf691$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $8lokx.isPlainObject)(exception) || (0, $8lokx.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $cb5e003253ebf691$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $jYvOn.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $cb5e003253ebf691$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $jYvOn.addExceptionTypeValue)(event, "".concat(exception), undefined);
    (0, $jYvOn.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $cb5e003253ebf691$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = $cb5e003253ebf691$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $8lokx.isParameterizedString)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $cb5e003253ebf691$var$getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0, $8yexE.extractExceptionKeysForMessage)(exception);
    var captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $8lokx.isErrorEvent)(exception)) return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    if ((0, $8lokx.isEvent)(exception)) {
        var className = $cb5e003253ebf691$var$getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function $cb5e003253ebf691$var$getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");


var $cCIJH = parcelRequire("cCIJH");

var $jYvOn = parcelRequire("jYvOn");
var $8yexE = parcelRequire("8yexE");
var $lVfPx = parcelRequire("lVfPx");
var $bcc0f59b9db1f078$export$56d8a8a25bd48b81 = (0, $lVfPx.GLOBAL_OBJ);
var $bcc0f59b9db1f078$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $bcc0f59b9db1f078$export$b79738ab10c590b2() {
    return $bcc0f59b9db1f078$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $bcc0f59b9db1f078$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $bcc0f59b9db1f078$var$ignoreOnError++;
    setTimeout(function() {
        $bcc0f59b9db1f078$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $bcc0f59b9db1f078$export$4997ffc0176396a6(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, before = arguments.length > 2 ? arguments[2] : void 0;
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $8yexE.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $bcc0f59b9db1f078$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $bcc0f59b9db1f078$export$1265a142ff5ba165();
            (0, $cCIJH.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $jYvOn.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $jYvOn.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $7XD9P._)((0, $hRCmZ._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $cCIJH.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $8yexE.markFunctionWrapped)(sentryWrapped, fn);
    (0, $8yexE.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



var $hRCmZ = parcelRequire("hRCmZ");

/**
 * Creates an envelope from a user feedback.
 */ function $a0eb0d621c452e43$export$24a4dfcb686ee5bf(feedback, param) {
    var metadata = param.metadata, tunnel = param.tunnel, dsn = param.dsn;
    var headers = (0, $hRCmZ._)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, metadata && metadata.sdk && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: (0, $166ca73332398b10$export$44d472fbb931a776)(dsn)
    });
    var item = $a0eb0d621c452e43$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $05db56156fa7707f$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $a0eb0d621c452e43$var$createUserFeedbackEnvelopeItem(feedback) {
    var feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $08f619096a140143$export$1df9218a526d318d = /*#__PURE__*/ function(BaseClient) {
    "use strict";
    (0, $a7G5R._)(BrowserClient, BaseClient);
    function BrowserClient(options) {
        (0, $6WLcG._)(this, BrowserClient);
        var _this;
        var sdkSource = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $pwbWG.getSDKSource)();
        (0, $41e9d6181be2d4c6$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        _this = (0, $bQby9._)(this, BrowserClient, [
            options
        ]);
        if (options.sendClientReports && (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document) (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', function() {
            if ((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') _this._flushOutcomes();
        });
        return _this;
    }
    (0, $dbIwN._)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException1(exception, hint) {
                return (0, $cb5e003253ebf691$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage1(message) {
                var // eslint-disable-next-line deprecation/deprecation
                level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, $cb5e003253ebf691$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * Sends user feedback to Sentry.
   */ key: "captureUserFeedback",
            value: function captureUserFeedback(feedback) {
                if (!this._isEnabled()) {
                    (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).warn('SDK not enabled, will not capture user feedback.');
                    return;
                }
                var envelope = (0, $a0eb0d621c452e43$export$24a4dfcb686ee5bf)(feedback, {
                    metadata: this.getSdkMetadata(),
                    dsn: this.getDsn(),
                    tunnel: this.getOptions().tunnel
                });
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                event.platform = event.platform || 'javascript';
                return (0, $gBEGf._)((0, $3LSeA._)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).log('No outcomes to send');
                    return;
                }
                // This is really the only place where we want to check for a DSN and only send outcomes then
                if (!this._dsn) {
                    (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).log('No dsn provided, will not send outcomes');
                    return;
                }
                (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).log('Sending outcomes:', outcomes);
                var envelope = (0, $a062bcde5d5948a1$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $166ca73332398b10$export$44d472fbb931a776)(this._dsn));
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        }
    ]);
    return BrowserClient;
}((0, $24ed5a20d81241a9$export$4f22f74eddb7716a));





var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $2xTNA = parcelRequire("2xTNA");

var $cCIJH = parcelRequire("cCIJH");

var $jYvOn = parcelRequire("jYvOn");

var $8yexE = parcelRequire("8yexE");

var $lVfPx = parcelRequire("lVfPx");

var $3SZNV = parcelRequire("3SZNV");
var $913a36a080309682$var$WINDOW = (0, $lVfPx.GLOBAL_OBJ);
var $913a36a080309682$var$DEBOUNCE_DURATION = 1000;
var $913a36a080309682$var$debounceTimerID;
var $913a36a080309682$var$lastCapturedEventType;
var $913a36a080309682$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $913a36a080309682$export$5aeffd3db2cf9df7(handler) {
    var type = 'dom';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $913a36a080309682$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $913a36a080309682$export$3014bbf0af0e1d4a() {
    if (!$913a36a080309682$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = (0, $3SZNV.triggerHandlers).bind(null, 'dom');
    var globalDOMEventHandler = $913a36a080309682$var$makeDOMEventHandler(triggerDOMHandler, true);
    $913a36a080309682$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $913a36a080309682$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $913a36a080309682$var$WINDOW[target] && $913a36a080309682$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $8yexE.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $913a36a080309682$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $8yexE.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $913a36a080309682$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $913a36a080309682$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $913a36a080309682$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $913a36a080309682$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $913a36a080309682$var$makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        var target = $913a36a080309682$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($913a36a080309682$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $8yexE.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $8yexE.addNonEnumerableProperty)(target, '_sentryId', (0, $jYvOn.uuid4)());
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$913a36a080309682$var$isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $913a36a080309682$var$lastCapturedEventType = event.type;
            $913a36a080309682$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($913a36a080309682$var$debounceTimerID);
        $913a36a080309682$var$debounceTimerID = $913a36a080309682$var$WINDOW.setTimeout(function() {
            $913a36a080309682$var$lastCapturedEventTargetId = undefined;
            $913a36a080309682$var$lastCapturedEventType = undefined;
        }, $913a36a080309682$var$DEBOUNCE_DURATION);
    };
}
function $913a36a080309682$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


var $gVncj = parcelRequire("gVncj");

var $8yexE = parcelRequire("8yexE");

var $lVfPx = parcelRequire("lVfPx");

var $3SZNV = parcelRequire("3SZNV");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7e9d78d1291f18c7$export$1d6e0d073f9e6723(handler) {
    var type = 'console';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $7e9d78d1291f18c7$var$instrumentConsole);
}
function $7e9d78d1291f18c7$var$instrumentConsole() {
    if (!('console' in (0, $lVfPx.GLOBAL_OBJ))) return;
    (0, $gVncj.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $lVfPx.GLOBAL_OBJ).console)) return;
        (0, $8yexE.fill)((0, $lVfPx.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $gVncj.originalConsoleMethods)[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var handlerData = {
                    args: args,
                    level: level
                };
                (0, $3SZNV.triggerHandlers)('console', handlerData);
                var log = (0, $gVncj.originalConsoleMethods)[level];
                log && log.apply((0, $lVfPx.GLOBAL_OBJ).console, args);
            };
        });
    });
}


var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");

var $2xTNA = parcelRequire("2xTNA");

var $8yexE = parcelRequire("8yexE");


var $lVfPx = parcelRequire("lVfPx");

var $3SZNV = parcelRequire("3SZNV");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ca1785e99fcb0e3e$export$f75d3c772c923df0(handler) {
    var type = 'fetch';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $ca1785e99fcb0e3e$var$instrumentFetch);
}
function $ca1785e99fcb0e3e$var$instrumentFetch() {
    if (!(0, $51d1e3cc284b3a5e$export$c82d238e23c40b21)()) return;
    (0, $8yexE.fill)((0, $lVfPx.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _parseFetchArgs = $ca1785e99fcb0e3e$export$f7a71163cc309d9a(args), method = _parseFetchArgs.method, url = _parseFetchArgs.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $3SZNV.triggerHandlers)('fetch', (0, $hRCmZ._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $lVfPx.GLOBAL_OBJ), args).then(function(response) {
                var finishedHandlerData = (0, $7XD9P._)((0, $hRCmZ._)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                });
                (0, $3SZNV.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, function(error) {
                var erroredHandlerData = (0, $7XD9P._)((0, $hRCmZ._)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                });
                (0, $3SZNV.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $ca1785e99fcb0e3e$var$hasProp(obj, prop) {
    return !!obj && (typeof obj === "undefined" ? "undefined" : (0, $2xTNA._)(obj)) === 'object' && !!obj[prop];
}
function $ca1785e99fcb0e3e$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($ca1785e99fcb0e3e$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $ca1785e99fcb0e3e$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0, $6mdMa._)(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: $ca1785e99fcb0e3e$var$getUrlFromResource(url),
            method: $ca1785e99fcb0e3e$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    var arg = fetchArgs[0];
    return {
        url: $ca1785e99fcb0e3e$var$getUrlFromResource(arg),
        method: $ca1785e99fcb0e3e$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}


var $6mdMa = parcelRequire("6mdMa");

var $8lokx = parcelRequire("8lokx");

var $8yexE = parcelRequire("8yexE");

var $lVfPx = parcelRequire("lVfPx");

var $3SZNV = parcelRequire("3SZNV");
var $17e4d6ff5e828079$var$WINDOW = (0, $lVfPx.GLOBAL_OBJ);
var $17e4d6ff5e828079$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $17e4d6ff5e828079$export$26ace48dd54c9aea(handler) {
    var type = 'xhr';
    (0, $3SZNV.addHandler)(type, handler);
    (0, $3SZNV.maybeInstrument)(type, $17e4d6ff5e828079$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $17e4d6ff5e828079$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$17e4d6ff5e828079$var$WINDOW.XMLHttpRequest) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $8yexE.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var _this = this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            var method = (0, $8lokx.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            var url = $17e4d6ff5e828079$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$17e4d6ff5e828079$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                // For whatever reason, this is not the same instance here as from the outer method
                var xhrInfo = _this[$17e4d6ff5e828079$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (_this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = _this.status;
                    } catch (e) {
                    /* do nothing */ }
                    var handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: _this
                    };
                    (0, $3SZNV.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $8yexE.fill)(this, 'onreadystatechange', function(original) {
                return function() {
                    for(var _len = arguments.length, readyStateArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        readyStateArgs[_key] = arguments[_key];
                    }
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $8yexE.fill)(this, 'setRequestHeader', function(original) {
                return function() {
                    for(var _len = arguments.length, setRequestHeaderArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setRequestHeaderArgs[_key] = arguments[_key];
                    }
                    var _setRequestHeaderArgs = (0, $6mdMa._)(setRequestHeaderArgs, 2), header = _setRequestHeaderArgs[0], value = _setRequestHeaderArgs[1];
                    var xhrInfo = this[$17e4d6ff5e828079$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $8lokx.isString)(header) && (0, $8lokx.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $8yexE.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sentryXhrData = this[$17e4d6ff5e828079$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            var handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $3SZNV.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $17e4d6ff5e828079$var$parseUrl(url) {
    if ((0, $8lokx.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}


var $dHjQX = parcelRequire("dHjQX");
var $jYvOn = parcelRequire("jYvOn");
var $gVncj = parcelRequire("gVncj");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $0affd2066e6dc1d7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $0affd2066e6dc1d7$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $0affd2066e6dc1d7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter(function(s) {
        return s.length > 0 && s !== ',';
    }).length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $0affd2066e6dc1d7$export$e0ba26c9e23e1fe0(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return "".concat(protocol ? "".concat(protocol, "://") : '').concat(filteredHost).concat(path);
}


var $gj3Le = parcelRequire("gj3Le");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var $53f19b336be3b6c0$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $53f19b336be3b6c0$export$e01cef29b4327697(level) {
    return $53f19b336be3b6c0$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $53f19b336be3b6c0$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $53f19b336be3b6c0$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ var $6da61daee5e6b46d$var$MAX_ALLOWED_STRING_LENGTH = 1024;
var $6da61daee5e6b46d$var$INTEGRATION_NAME = 'Breadcrumbs';
var $6da61daee5e6b46d$var$_breadcrumbsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $hRCmZ._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $6da61daee5e6b46d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            if (_options.console) (0, $7e9d78d1291f18c7$export$1d6e0d073f9e6723)($6da61daee5e6b46d$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $913a36a080309682$export$5aeffd3db2cf9df7)($6da61daee5e6b46d$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $17e4d6ff5e828079$export$26ace48dd54c9aea)($6da61daee5e6b46d$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $ca1785e99fcb0e3e$export$f75d3c772c923df0)($6da61daee5e6b46d$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $98deba007e94a00d$export$3f18c56c58114e75)($6da61daee5e6b46d$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $6da61daee5e6b46d$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
var $6da61daee5e6b46d$export$c079d904b326663a = (0, $465ec00b3bbedb49$export$2323046b9414659f)($6da61daee5e6b46d$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $6da61daee5e6b46d$export$2dc68d50d56fbbd = (0, $465ec00b3bbedb49$export$afa219bf23651160)($6da61daee5e6b46d$var$INTEGRATION_NAME, $6da61daee5e6b46d$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $6da61daee5e6b46d$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $cCIJH.getClient)() !== client) return;
        (0, $cCIJH.addBreadcrumb)({
            category: "sentry.".concat(event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $jYvOn.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $6da61daee5e6b46d$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $cCIJH.getClient)() !== client) return;
        var target;
        var componentName;
        var keyAttrs = (typeof dom === "undefined" ? "undefined" : (0, $2xTNA._)(dom)) === 'object' ? dom.serializeAttribute : undefined;
        var maxStringLength = (typeof dom === "undefined" ? "undefined" : (0, $2xTNA._)(dom)) === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $6da61daee5e6b46d$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).warn("`dom.maxStringLength` cannot exceed ".concat($6da61daee5e6b46d$var$MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat($6da61daee5e6b46d$var$MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = $6da61daee5e6b46d$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            var event = handlerData.event;
            var element = $6da61daee5e6b46d$var$_isEvent(event) ? event.target : event;
            target = (0, $dHjQX.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $dHjQX.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        var breadcrumb = {
            category: "ui.".concat(handlerData.name),
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $cCIJH.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $6da61daee5e6b46d$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $cCIJH.getClient)() !== client) return;
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $53f19b336be3b6c0$export$d771ef054122c30a)(handlerData.level),
            message: (0, $gj3Le.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: ".concat((0, $gj3Le.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data["arguments"] = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $cCIJH.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $6da61daee5e6b46d$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $cCIJH.getClient)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[0, $17e4d6ff5e828079$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $cCIJH.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $6da61daee5e6b46d$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $cCIJH.getClient)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            var data = handlerData.fetchData;
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $cCIJH.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            var response = handlerData.response;
            var data1 = (0, $7XD9P._)((0, $hRCmZ._)({}, handlerData.fetchData), {
                status_code: response && response.status
            });
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $cCIJH.addBreadcrumb)({
                category: 'fetch',
                data: data1,
                type: 'http'
            }, hint1);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $6da61daee5e6b46d$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $cCIJH.getClient)() !== client) return;
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).location.href);
        var parsedFrom = from ? (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)(from) : undefined;
        var parsedTo = (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $cCIJH.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $6da61daee5e6b46d$var$_isEvent(event) {
    return !!event && !!event.target;
}




var $gVncj = parcelRequire("gVncj");

var $ead1c49f9aa3b382$var$INTEGRATION_NAME = 'Dedupe';
var $ead1c49f9aa3b382$var$_dedupeIntegration = function() {
    var previousEvent;
    return {
        name: $ead1c49f9aa3b382$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($ead1c49f9aa3b382$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
var $ead1c49f9aa3b382$export$6d39aa44cd0c7567 = (0, $465ec00b3bbedb49$export$2323046b9414659f)($ead1c49f9aa3b382$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $ead1c49f9aa3b382$export$688d98c249d31ad3 = (0, $465ec00b3bbedb49$export$afa219bf23651160)($ead1c49f9aa3b382$var$INTEGRATION_NAME, $ead1c49f9aa3b382$export$6d39aa44cd0c7567);
function $ead1c49f9aa3b382$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($ead1c49f9aa3b382$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($ead1c49f9aa3b382$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $ead1c49f9aa3b382$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$ead1c49f9aa3b382$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ead1c49f9aa3b382$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ead1c49f9aa3b382$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $ead1c49f9aa3b382$var$_getExceptionFromEvent(previousEvent);
    var currentException = $ead1c49f9aa3b382$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$ead1c49f9aa3b382$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ead1c49f9aa3b382$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ead1c49f9aa3b382$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $ead1c49f9aa3b382$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $ead1c49f9aa3b382$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA["function"] !== frameB["function"]) return false;
    }
    return true;
}
function $ead1c49f9aa3b382$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $ead1c49f9aa3b382$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $ead1c49f9aa3b382$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $hRCmZ = parcelRequire("hRCmZ");

var $cCIJH = parcelRequire("cCIJH");

var $ijeNb = parcelRequire("ijeNb");
var $2LduO = parcelRequire("2LduO");
var $dHjQX = parcelRequire("dHjQX");
var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ var $1b87f4f94847fbfa$var$INTEGRATION_NAME = 'GlobalHandlers';
var $1b87f4f94847fbfa$var$_globalHandlersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $hRCmZ._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $1b87f4f94847fbfa$var$INTEGRATION_NAME,
        setupOnce: function() {
            Error.stackTraceLimit = 50;
        },
        setup: function(client) {
            if (_options.onerror) {
                $1b87f4f94847fbfa$var$_installGlobalOnErrorHandler(client);
                $1b87f4f94847fbfa$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $1b87f4f94847fbfa$var$_installGlobalOnUnhandledRejectionHandler(client);
                $1b87f4f94847fbfa$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
var $1b87f4f94847fbfa$export$66acc70e8cf2b71a = (0, $465ec00b3bbedb49$export$2323046b9414659f)($1b87f4f94847fbfa$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $1b87f4f94847fbfa$export$204155decbc90e5a = (0, $465ec00b3bbedb49$export$afa219bf23651160)($1b87f4f94847fbfa$var$INTEGRATION_NAME, $1b87f4f94847fbfa$export$66acc70e8cf2b71a);
function $1b87f4f94847fbfa$var$_installGlobalOnErrorHandler(client) {
    (0, $ijeNb.addGlobalErrorInstrumentationHandler)(function(data) {
        var _getOptions = $1b87f4f94847fbfa$var$getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, $cCIJH.getClient)() !== client || (0, $bcc0f59b9db1f078$export$b79738ab10c590b2)()) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = error === undefined && (0, $8lokx.isString)(msg) ? $1b87f4f94847fbfa$var$_eventFromIncompleteOnError(msg, url, line, column) : $1b87f4f94847fbfa$var$_enhanceEventWithInitialFrame((0, $cb5e003253ebf691$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $cCIJH.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $1b87f4f94847fbfa$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $2LduO.addGlobalUnhandledRejectionInstrumentationHandler)(function(e) {
        var _getOptions = $1b87f4f94847fbfa$var$getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, $cCIJH.getClient)() !== client || (0, $bcc0f59b9db1f078$export$b79738ab10c590b2)()) return;
        var error = $1b87f4f94847fbfa$var$_getUnhandledRejectionError(e);
        var event = (0, $8lokx.isPrimitive)(error) ? $1b87f4f94847fbfa$var$_eventFromRejectionWithPrimitive(error) : (0, $cb5e003253ebf691$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $cCIJH.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $1b87f4f94847fbfa$var$_getUnhandledRejectionError(error) {
    if ((0, $8lokx.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $1b87f4f94847fbfa$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1b87f4f94847fbfa$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $8lokx.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $1b87f4f94847fbfa$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1b87f4f94847fbfa$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $8lokx.isString)(url) && url.length > 0 ? url : (0, $dHjQX.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        "function": '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $1b87f4f94847fbfa$var$globalHandlerLog(type) {
    (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).log("Global Handler attached: ".concat(type));
}
function $1b87f4f94847fbfa$var$getOptions() {
    var client = (0, $cCIJH.getClient)();
    var options = client && client.getOptions() || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}



var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");


var $f45cbdba0f29ca44$var$INTEGRATION_NAME = 'HttpContext';
var $f45cbdba0f29ca44$var$_httpContextIntegration = function() {
    return {
        name: $f45cbdba0f29ca44$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        preprocessEvent: function(event) {
            // if none of the information we want exists, don't bother
            if (!(0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).navigator && !(0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).location && !(0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            var url = event.request && event.request.url || (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).location && (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).location.href;
            var referrer = ((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document || {}).referrer;
            var userAgent = ((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).navigator || {}).userAgent;
            var headers = (0, $hRCmZ._)({}, event.request && event.request.headers, referrer && {
                Referer: referrer
            }, userAgent && {
                'User-Agent': userAgent
            });
            var request = (0, $7XD9P._)((0, $hRCmZ._)({}, event.request, url && {
                url: url
            }), {
                headers: headers
            });
            event.request = request;
        }
    };
};
var $f45cbdba0f29ca44$export$1378794447170364 = (0, $465ec00b3bbedb49$export$2323046b9414659f)($f45cbdba0f29ca44$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $f45cbdba0f29ca44$export$5d2ee9a544b09a94 = (0, $465ec00b3bbedb49$export$afa219bf23651160)($f45cbdba0f29ca44$var$INTEGRATION_NAME, $f45cbdba0f29ca44$export$1378794447170364);




var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $bOqL7 = parcelRequire("bOqL7");

var $8lokx = parcelRequire("8lokx");

var $gj3Le = parcelRequire("gj3Le");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $c417680d6de75ceb$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser) {
    var maxValueLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 250, key = arguments.length > 3 ? arguments[3] : void 0, limit = arguments.length > 4 ? arguments[4] : void 0, event = arguments.length > 5 ? arguments[5] : void 0, hint = arguments.length > 6 ? arguments[6] : void 0;
    if (!event.exception || !event.exception.values || !hint || !(0, $8lokx.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $c417680d6de75ceb$var$truncateAggregateExceptions($c417680d6de75ceb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $c417680d6de75ceb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    var newExceptions = (0, $bOqL7._)(prevExceptions);
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $8lokx.isInstanceOf)(error[key], Error)) {
        $c417680d6de75ceb$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        $c417680d6de75ceb$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $c417680d6de75ceb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0, $bOqL7._)(newExceptions)), newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach(function(childError, i) {
        if ((0, $8lokx.isInstanceOf)(childError, Error)) {
            $c417680d6de75ceb$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            var newException = exceptionFromErrorImplementation(parser, childError);
            var newExceptionId = newExceptions.length;
            $c417680d6de75ceb$var$applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
            newExceptions = $c417680d6de75ceb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException
            ].concat((0, $bOqL7._)(newExceptions)), newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $c417680d6de75ceb$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $7XD9P._)((0, $hRCmZ._)({}, exception.mechanism, exception.type === 'AggregateError' && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function $c417680d6de75ceb$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $7XD9P._)((0, $hRCmZ._)({}, exception.mechanism), {
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $c417680d6de75ceb$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map(function(exception) {
        if (exception.value) exception.value = (0, $gj3Le.truncate)(exception.value, maxValueLength);
        return exception;
    });
}



var $6336be14c46c312f$var$DEFAULT_KEY = 'cause';
var $6336be14c46c312f$var$DEFAULT_LIMIT = 5;
var $6336be14c46c312f$var$INTEGRATION_NAME = 'LinkedErrors';
var $6336be14c46c312f$var$_linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || $6336be14c46c312f$var$DEFAULT_LIMIT;
    var key = options.key || $6336be14c46c312f$var$DEFAULT_KEY;
    return {
        name: $6336be14c46c312f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        preprocessEvent: function(event, hint, client) {
            var options = client.getOptions();
            (0, $c417680d6de75ceb$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $cb5e003253ebf691$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var $6336be14c46c312f$export$ebabb00eb7f3a395 = (0, $465ec00b3bbedb49$export$2323046b9414659f)($6336be14c46c312f$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $6336be14c46c312f$export$8d1e60aaf616fb4f = (0, $465ec00b3bbedb49$export$afa219bf23651160)($6336be14c46c312f$var$INTEGRATION_NAME, $6336be14c46c312f$export$ebabb00eb7f3a395);



var $hRCmZ = parcelRequire("hRCmZ");


var $8yexE = parcelRequire("8yexE");
var $dRvnI = parcelRequire("dRvnI");

var $f1180dbebe34907c$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
var $f1180dbebe34907c$var$INTEGRATION_NAME = 'TryCatch';
var $f1180dbebe34907c$var$_browserApiErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $hRCmZ._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true
    }, options);
    return {
        name: $f1180dbebe34907c$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function() {
            if (_options.setTimeout) (0, $8yexE.fill)((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81), 'setTimeout', $f1180dbebe34907c$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $8yexE.fill)((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81), 'setInterval', $f1180dbebe34907c$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $8yexE.fill)((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81), 'requestAnimationFrame', $f1180dbebe34907c$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81)) (0, $8yexE.fill)(XMLHttpRequest.prototype, 'send', $f1180dbebe34907c$var$_wrapXHR);
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f1180dbebe34907c$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($f1180dbebe34907c$var$_wrapEventTarget);
            }
        }
    };
};
var $f1180dbebe34907c$export$59bfe9f1c76150e = (0, $465ec00b3bbedb49$export$2323046b9414659f)($f1180dbebe34907c$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var $f1180dbebe34907c$export$f1a018517668e6d3 = (0, $465ec00b3bbedb49$export$afa219bf23651160)($f1180dbebe34907c$var$INTEGRATION_NAME, $f1180dbebe34907c$export$59bfe9f1c76150e);
function $f1180dbebe34907c$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = (0, $bcc0f59b9db1f078$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    "function": (0, $dRvnI.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f1180dbebe34907c$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $bcc0f59b9db1f078$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        "function": 'requestAnimationFrame',
                        handler: (0, $dRvnI.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $f1180dbebe34907c$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $8yexE.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            "function": prop,
                            handler: (0, $dRvnI.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $8yexE.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $dRvnI.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $bcc0f59b9db1f078$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f1180dbebe34907c$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObject = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $8yexE.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $bcc0f59b9db1f078$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            "function": 'handleEvent',
                            handler: (0, $dRvnI.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $bcc0f59b9db1f078$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            "function": 'addEventListener',
                            handler: (0, $dRvnI.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $8yexE.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $dRvnI = parcelRequire("dRvnI");
// global reference to slice
var $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION = '?';
var $8e8b4fa19ad5dc8d$var$OPERA10_PRIORITY = 10;
var $8e8b4fa19ad5dc8d$var$OPERA11_PRIORITY = 20;
var $8e8b4fa19ad5dc8d$var$CHROME_PRIORITY = 30;
var $8e8b4fa19ad5dc8d$var$WINJS_PRIORITY = 40;
var $8e8b4fa19ad5dc8d$var$GECKO_PRIORITY = 50;
function $8e8b4fa19ad5dc8d$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        "function": func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $8e8b4fa19ad5dc8d$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $8e8b4fa19ad5dc8d$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
var $8e8b4fa19ad5dc8d$var$chromeStackParserFn = function(line) {
    var parts = $8e8b4fa19ad5dc8d$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $8e8b4fa19ad5dc8d$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _extractSafariExtensionDetails = (0, $6mdMa._)($8e8b4fa19ad5dc8d$var$extractSafariExtensionDetails(parts[1] || $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _extractSafariExtensionDetails[0], filename = _extractSafariExtensionDetails[1];
        return $8e8b4fa19ad5dc8d$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $8e8b4fa19ad5dc8d$export$263a749fff749872 = [
    $8e8b4fa19ad5dc8d$var$CHROME_PRIORITY,
    $8e8b4fa19ad5dc8d$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $8e8b4fa19ad5dc8d$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $8e8b4fa19ad5dc8d$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $8e8b4fa19ad5dc8d$var$gecko = function(line) {
    var parts = $8e8b4fa19ad5dc8d$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $8e8b4fa19ad5dc8d$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION;
        var ref;
        ref = (0, $6mdMa._)($8e8b4fa19ad5dc8d$var$extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return $8e8b4fa19ad5dc8d$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $8e8b4fa19ad5dc8d$export$cdba47a5dd2804d = [
    $8e8b4fa19ad5dc8d$var$GECKO_PRIORITY,
    $8e8b4fa19ad5dc8d$var$gecko
];
var $8e8b4fa19ad5dc8d$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $8e8b4fa19ad5dc8d$var$winjs = function(line) {
    var parts = $8e8b4fa19ad5dc8d$var$winjsRegex.exec(line);
    return parts ? $8e8b4fa19ad5dc8d$var$createFrame(parts[2], parts[1] || $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $8e8b4fa19ad5dc8d$export$179460296da408e8 = [
    $8e8b4fa19ad5dc8d$var$WINJS_PRIORITY,
    $8e8b4fa19ad5dc8d$var$winjs
];
var $8e8b4fa19ad5dc8d$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $8e8b4fa19ad5dc8d$var$opera10 = function(line) {
    var parts = $8e8b4fa19ad5dc8d$var$opera10Regex.exec(line);
    return parts ? $8e8b4fa19ad5dc8d$var$createFrame(parts[2], parts[3] || $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $8e8b4fa19ad5dc8d$export$f892b52c880ffc7a = [
    $8e8b4fa19ad5dc8d$var$OPERA10_PRIORITY,
    $8e8b4fa19ad5dc8d$var$opera10
];
var $8e8b4fa19ad5dc8d$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $8e8b4fa19ad5dc8d$var$opera11 = function(line) {
    var parts = $8e8b4fa19ad5dc8d$var$opera11Regex.exec(line);
    return parts ? $8e8b4fa19ad5dc8d$var$createFrame(parts[5], parts[3] || parts[4] || $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $8e8b4fa19ad5dc8d$export$af11af13f09fb0dc = [
    $8e8b4fa19ad5dc8d$var$OPERA11_PRIORITY,
    $8e8b4fa19ad5dc8d$var$opera11
];
var $8e8b4fa19ad5dc8d$export$7197c0fe6554c079 = [
    $8e8b4fa19ad5dc8d$export$263a749fff749872,
    $8e8b4fa19ad5dc8d$export$cdba47a5dd2804d,
    $8e8b4fa19ad5dc8d$export$179460296da408e8
];
var $8e8b4fa19ad5dc8d$export$2b2b997d81bf3907 = (0, $dRvnI.createStackParser).apply(void 0, (0, $bOqL7._)($8e8b4fa19ad5dc8d$export$7197c0fe6554c079));
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $8e8b4fa19ad5dc8d$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $8e8b4fa19ad5dc8d$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:".concat(filename) : "safari-web-extension:".concat(filename)
    ] : [
        func,
        filename
    ];
};



var $hRCmZ = parcelRequire("hRCmZ");
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");
var $c6287d06c9e95b84$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $c6287d06c9e95b84$export$615352e17ed7741(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) return headerDate - now;
    return $c6287d06c9e95b84$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $c6287d06c9e95b84$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $c6287d06c9e95b84$export$6c91fec22056810a(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return $c6287d06c9e95b84$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $c6287d06c9e95b84$export$699aff705e0d49d4(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0, $hRCmZ._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers && headers['retry-after'];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (rateLimitHeader) try {
        /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for(var _iterator = rateLimitHeader.trim().split(',')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var limit = _step.value;
            var _limit_split = (0, $6mdMa._)(limit.split(':', 5), 5), retryAfter = _limit_split[0], categories = _limit_split[1], namespaces = _limit_split[4];
            var headerDelay = parseInt(retryAfter, 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!categories) updatedRateLimits.all = now + delay;
            else try {
                for(var _iterator1 = categories.split(';')[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
                    {
                        if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
                    } else updatedRateLimits[category] = now + delay;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $c6287d06c9e95b84$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $gVncj = parcelRequire("gVncj");

var $gXCgb = parcelRequire("gXCgb");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $abda01fb65ec1a10$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $gXCgb.rejectedSyncPromise)(new (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $gXCgb.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $gXCgb.resolvedSyncPromise)(item).then(function() {
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $gXCgb = parcelRequire("gXCgb");

var $7Ui5X = parcelRequire("7Ui5X");
var $5cd35d92315d479b$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $5cd35d92315d479b$export$d09f50d9ab7f7b69(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $abda01fb65ec1a10$export$85a4f67f852183e6)(options.bufferSize || $5cd35d92315d479b$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $05db56156fa7707f$export$c56c55acf0136fd3)(envelope, function(item, type) {
            var dataCategory = (0, $05db56156fa7707f$export$b11169581eeaf237)(type);
            if ((0, $c6287d06c9e95b84$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                var event = $5cd35d92315d479b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $gXCgb.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var filteredEnvelope = (0, $05db56156fa7707f$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = function(reason) {
            (0, $05db56156fa7707f$export$c56c55acf0136fd3)(filteredEnvelope, function(item, type) {
                var event = $5cd35d92315d479b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $05db56156fa7707f$export$b11169581eeaf237)(type), event);
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: (0, $05db56156fa7707f$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then(function(response) {
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).warn("Sentry responded with status code ".concat(response.statusCode, " to sent event."));
                rateLimits = (0, $c6287d06c9e95b84$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss('network_error');
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if (error instanceof (0, $2e2ddd71c1cda6f9$export$5949942ba2a7c0e2)) {
                (0, $7Ui5X.DEBUG_BUILD) && (0, $gVncj.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $gXCgb.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $5cd35d92315d479b$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $gXCgb = parcelRequire("gXCgb");

var $gVncj = parcelRequire("gVncj");


var $04da17e8bca49c6e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $04da17e8bca49c6e$export$8be2119ce08e3379() {
    if ($04da17e8bca49c6e$var$cachedFetchImpl) return $04da17e8bca49c6e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $51d1e3cc284b3a5e$export$18cf36ed71d733e7)((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).fetch)) return $04da17e8bca49c6e$var$cachedFetchImpl = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).fetch.bind((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81));
    var document = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document;
    var fetchImpl = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $04da17e8bca49c6e$var$cachedFetchImpl = fetchImpl.bind((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $04da17e8bca49c6e$export$d499686d2dd738c6() {
    $04da17e8bca49c6e$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $267da1b074fc8bc0$export$b2311068c46d7cc8(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $04da17e8bca49c6e$export$8be2119ce08e3379)();
    var pendingBodySize = 0;
    var pendingCount = 0;
    function makeRequest(request) {
        var requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        var requestOptions = (0, $hRCmZ._)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        try {
            return nativeFetch(options.url, requestOptions).then(function(response) {
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $04da17e8bca49c6e$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $gXCgb.rejectedSyncPromise)(e);
        }
    }
    return (0, $5cd35d92315d479b$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $gXCgb = parcelRequire("gXCgb");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $c0b06540d5ec462e$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $c0b06540d5ec462e$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $gXCgb.SyncPromise)(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $c0b06540d5ec462e$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $5cd35d92315d479b$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ var $890d7aa8a748a82b$export$5ef831fccfce35e5 = [
    (0, $5d0455182d3a3fff$export$cb3c5c2ceb9818ba)(),
    (0, $29cbee80d38de484$export$7918117e9202e4fb)(),
    (0, $f1180dbebe34907c$export$59bfe9f1c76150e)(),
    (0, $6da61daee5e6b46d$export$c079d904b326663a)(),
    (0, $1b87f4f94847fbfa$export$66acc70e8cf2b71a)(),
    (0, $6336be14c46c312f$export$ebabb00eb7f3a395)(),
    (0, $ead1c49f9aa3b382$export$6d39aa44cd0c7567)(),
    (0, $f45cbdba0f29ca44$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $890d7aa8a748a82b$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return(// eslint-disable-next-line deprecation/deprecation
    (0, $bOqL7._)($890d7aa8a748a82b$export$5ef831fccfce35e5));
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $890d7aa8a748a82b$export$2cd8252107eb640b() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $890d7aa8a748a82b$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    var clientOptions = (0, $7XD9P._)((0, $hRCmZ._)({}, options), {
        stackParser: (0, $dRvnI.stackParserFromStackParserOptions)(options.stackParser || (0, $8e8b4fa19ad5dc8d$export$2b2b997d81bf3907)),
        integrations: (0, $465ec00b3bbedb49$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $51d1e3cc284b3a5e$export$edf3cb81fd7d2a3e)() ? (0, $267da1b074fc8bc0$export$b2311068c46d7cc8) : (0, $c0b06540d5ec462e$export$5e1441cee30d5a39))
    });
    (0, $b78b4fb34736de6b$export$5333c3f1c58d9bc1)((0, $08f619096a140143$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $890d7aa8a748a82b$var$startSessionTracking();
}
var $890d7aa8a748a82b$export$3a8fd680da42627b = function() {
    var // eslint-disable-next-line deprecation/deprecation
    options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, // eslint-disable-next-line deprecation/deprecation
    hub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $8fOd9.getCurrentHub)();
    // doesn't work without a document (React Native)
    if (!(0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document) {
        (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    var _hub_getStackTop = hub.getStackTop(), client = _hub_getStackTop.client, scope = _hub_getStackTop.scope;
    var dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = (0, $hRCmZ._)({}, scope.getUser(), options.user);
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    var script = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $8aa085f524a012cf$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    var onClose = options.onClose;
    if (onClose) {
        var reportDialogClosedMessageHandler = function(event) {
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    var injectionPoint = (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document.head || (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $890d7aa8a748a82b$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $890d7aa8a748a82b$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $890d7aa8a748a82b$export$4997ffc0176396a6(fn) {
    return (0, $bcc0f59b9db1f078$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $890d7aa8a748a82b$var$startSessionTracking() {
    if (typeof (0, $bcc0f59b9db1f078$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $f062c7a5ed5d9f7e$export$16a28057038b10ef) && (0, $gVncj.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $cCIJH.startSession)({
        ignoreDuration: true
    });
    (0, $cCIJH.captureSession)();
    // We want to create a session for every navigation as well
    (0, $98deba007e94a00d$export$3f18c56c58114e75)(function(param) {
        var from = param.from, to = param.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $cCIJH.startSession)({
                ignoreDuration: true
            });
            (0, $cCIJH.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $890d7aa8a748a82b$export$88cefaf72d1e58a3(feedback) {
    var client = (0, $cCIJH.getClient)();
    if (client) client.captureUserFeedback(feedback);
}



var $2nPTC = parcelRequire("2nPTC");
var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $bOqL7 = parcelRequire("bOqL7");
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ 
var $bOqL7 = parcelRequire("bOqL7");
function $48d0b7bcf46634af$export$3cc482e6b02f32f7(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, $bOqL7._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $jYvOn = parcelRequire("jYvOn");
var $8yexE = parcelRequire("8yexE");
var $8lokx = parcelRequire("8lokx");
var $4qd5R = parcelRequire("4qd5R");
var $gVncj = parcelRequire("gVncj");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var $e222f13986d11a38$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function $6807e3fed073e703$export$34db76d03eb96b7e(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    var clientOptions = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        getCurrentHub,
        'call',
        function(_) {
            return _();
        },
        'access',
        function(_2) {
            return _2.getClient;
        },
        'call',
        function(_3) {
            return _3();
        },
        'optionalAccess',
        function(_4) {
            return _4.getOptions;
        },
        'call',
        function(_5) {
            return _5();
        }
    ]);
    var instrumenter = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        clientOptions,
        'optionalAccess',
        function(_6) {
            return _6.instrumenter;
        }
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}


/** Tracing integration for Apollo */ var $d0bef5af7f0d161a$export$3db3e396472fda8d = /*#__PURE__*/ function() {
    "use strict";
    function Apollo() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            useNestjs: false
        };
        (0, $6WLcG._)(this, Apollo);
        this.name = Apollo.id;
        this._useNest = !!options.useNestjs;
    }
    (0, $dbIwN._)(Apollo, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                if (this._useNest) this._module = this._module || (0, $4qd5R.loadModule)('@nestjs/graphql');
                else this._module = this._module || (0, $4qd5R.loadModule)('apollo-server-core');
                return this._module;
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)(getCurrentHub)) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
                    return;
                }
                if (this._useNest) {
                    var pkg = this.loadDependency();
                    if (!pkg) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                        return;
                    }
                    /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $8yexE.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                        return function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            var _orig;
                            (0, $8yexE.fill)(this.resolversExplorerService, 'explore', function(orig) {
                                return function() {
                                    var resolvers = (0, $jYvOn.arrayify)(orig.call(this));
                                    var instrumentedResolvers = $d0bef5af7f0d161a$var$instrumentResolvers(resolvers, getCurrentHub);
                                    return instrumentedResolvers;
                                };
                            });
                            return (_orig = orig).call.apply(_orig, [
                                this
                            ].concat((0, $bOqL7._)(args)));
                        };
                    });
                } else {
                    var pkg1 = this.loadDependency();
                    if (!pkg1) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                        return;
                    }
                    /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $8yexE.fill)(pkg1.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                        return function() {
                            if (!this.config.resolvers) {
                                if (0, $e222f13986d11a38$export$16a28057038b10ef) {
                                    if (this.config.schema) {
                                        (0, $gVncj.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                        (0, $gVncj.logger).warn();
                                    } else if (this.config.modules) (0, $gVncj.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                                    (0, $gVncj.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                                }
                                return orig.call(this);
                            }
                            var resolvers = (0, $jYvOn.arrayify)(this.config.resolvers);
                            this.config.resolvers = $d0bef5af7f0d161a$var$instrumentResolvers(resolvers, getCurrentHub);
                            return orig.call(this);
                        };
                    });
                }
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Apollo';
            }
        }
    ]);
    return Apollo;
}();
$d0bef5af7f0d161a$export$3db3e396472fda8d.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function $d0bef5af7f0d161a$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map(function(model) {
        Object.keys(model).forEach(function(resolverGroupName) {
            Object.keys(model[resolverGroupName]).forEach(function(resolverName) {
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                $d0bef5af7f0d161a$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $d0bef5af7f0d161a$var$wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, $8yexE.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _orig;
            // eslint-disable-next-line deprecation/deprecation
            var scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                parentSpan,
                'optionalAccess',
                function(_2) {
                    return _2.startChild;
                },
                'call',
                function(_3) {
                    return _3({
                        description: "".concat(resolverGroupName, ".").concat(resolverName),
                        op: 'graphql.resolve',
                        origin: 'auto.graphql.apollo'
                    });
                }
            ]);
            var rv = (_orig = orig).call.apply(_orig, [
                this
            ].concat((0, $bOqL7._)(args)));
            if ((0, $8lokx.isThenable)(rv)) return rv.then(function(res) {
                (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    function(_4) {
                        return _4.end;
                    },
                    'call',
                    function(_5) {
                        return _5();
                    }
                ]);
                return res;
            });
            (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                span,
                'optionalAccess',
                function(_6) {
                    return _6.end;
                },
                'call',
                function(_7) {
                    return _7();
                }
            ]);
            return rv;
        };
    });
}


var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $58WN1 = parcelRequire("58WN1");
var $iNMpq = parcelRequire("iNMpq");
var $cCIJH = parcelRequire("cCIJH");
var $fkG29 = parcelRequire("fkG29");
var $lFTnW = parcelRequire("lFTnW");

var $dHjQX = parcelRequire("dHjQX");
var $gVncj = parcelRequire("gVncj");
var $iAzzt = parcelRequire("iAzzt");


var $iNMpq = parcelRequire("iNMpq");
var $6hfta = parcelRequire("6hfta");

var $gVncj = parcelRequire("gVncj");


var $lVfPx = parcelRequire("lVfPx");
var $d466216041ad39ba$export$56d8a8a25bd48b81 = (0, $lVfPx.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $a21dec1cee20e6ce$export$6f18f55521af71a1() {
    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document) (0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', function() {
        // eslint-disable-next-line deprecation/deprecation
        var activeTransaction = (0, $iNMpq.getActiveTransaction)();
        if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            var statusType = 'cancelled';
            var _spanToJSON = (0, $6hfta.spanToJSON)(activeTransaction), op = _spanToJSON.op, status = _spanToJSON.status;
            (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log("[Tracing] Transaction: ".concat(statusType, " -> since tab moved to the background, op: ").concat(op));
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}



var $dRvnI = parcelRequire("dRvnI");
var $gVncj = parcelRequire("gVncj");

var $c999a6d5615d95b5$export$17679dccdd551979 = function(callback, metric, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var $4b744ba3483c0ea7$export$407ea409d1f3b539 = function() {
    return "v3-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e6ef42dbce0580f2$var$getNavigationEntryFromPerformanceTiming = function() {
    // eslint-disable-next-line deprecation/deprecation
    var timing = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    var type = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance.navigation.type;
    var navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(var key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
var $e6ef42dbce0580f2$export$6431553786c94949 = function() {
    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $e6ef42dbce0580f2$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $13d657e28f89d668$export$d3e828b3c7b5b845 = function() {
    var navEntry = (0, $e6ef42dbce0580f2$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $76c2dbb4f86cf062$export$3c29b44508a0612b = function(name, value) {
    var navEntry = (0, $e6ef42dbce0580f2$export$6431553786c94949)();
    var navigationType = 'navigate';
    if (navEntry) {
        if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document && (0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.prerendering || (0, $13d657e28f89d668$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $4b744ba3483c0ea7$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ 
var $hRCmZ = parcelRequire("hRCmZ");
var $f63aa6301f7f741a$export$d1203567a167490e = function(type, callback, opts) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                callback(list.getEntries());
            });
            po.observe((0, $hRCmZ._)({
                type: type,
                buffered: true
            }, opts));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $91ad2fd81dbe6660$export$91ec2be6fdd8f1b4 = function(cb, once) {
    var onHiddenOrPageHide = function(event) {
        if (event.type === 'pagehide' || (0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var $17c4c6ea791f3f2a$export$a7873055838e5ad8 = function(onReport) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var metric = (0, $76c2dbb4f86cf062$export$3c29b44508a0612b)('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                var firstSessionEntry = sessionEntries[0];
                var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    var po = (0, $f63aa6301f7f741a$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $c999a6d5615d95b5$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        var stopListening = function() {
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $91ad2fd81dbe6660$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $3c64c5d74d86c77e$var$firstHiddenTime = -1;
var $3c64c5d74d86c77e$var$initHiddenTime = function() {
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document && (0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.visibilityState) $3c64c5d74d86c77e$var$firstHiddenTime = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
var $3c64c5d74d86c77e$var$trackChanges = function() {
    // Update the time if/when the document becomes hidden.
    (0, $91ad2fd81dbe6660$export$91ec2be6fdd8f1b4)(function(param) {
        var timeStamp = param.timeStamp;
        $3c64c5d74d86c77e$var$firstHiddenTime = timeStamp;
    }, true);
};
var $3c64c5d74d86c77e$export$443f86b2c77012c4 = function() {
    if ($3c64c5d74d86c77e$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $3c64c5d74d86c77e$var$initHiddenTime();
        $3c64c5d74d86c77e$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $3c64c5d74d86c77e$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ var $33d1c9106c18d757$export$39705a25c49af873 = function(onReport) {
    var visibilityWatcher = (0, $3c64c5d74d86c77e$export$443f86b2c77012c4)();
    var metric = (0, $76c2dbb4f86cf062$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntry = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var handleEntries = function(entries) {
        entries.forEach(handleEntry);
    };
    var po = (0, $f63aa6301f7f741a$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $c999a6d5615d95b5$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $91ad2fd81dbe6660$export$91ec2be6fdd8f1b4)(function() {
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







var $bf059267f4767777$var$interactionCountEstimate = 0;
var $bf059267f4767777$var$minKnownInteractionId = Infinity;
var $bf059267f4767777$var$maxKnownInteractionId = 0;
var $bf059267f4767777$var$updateEstimate = function(entries) {
    entries.forEach(function(e) {
        if (e.interactionId) {
            $bf059267f4767777$var$minKnownInteractionId = Math.min($bf059267f4767777$var$minKnownInteractionId, e.interactionId);
            $bf059267f4767777$var$maxKnownInteractionId = Math.max($bf059267f4767777$var$maxKnownInteractionId, e.interactionId);
            $bf059267f4767777$var$interactionCountEstimate = $bf059267f4767777$var$maxKnownInteractionId ? ($bf059267f4767777$var$maxKnownInteractionId - $bf059267f4767777$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
var $bf059267f4767777$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ var $bf059267f4767777$export$8a962f2683a476d1 = function() {
    return $bf059267f4767777$var$po ? $bf059267f4767777$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ var $bf059267f4767777$export$67d90cda6b78a2eb = function() {
    if ('interactionCount' in performance || $bf059267f4767777$var$po) return;
    $bf059267f4767777$var$po = (0, $f63aa6301f7f741a$export$d1203567a167490e)('event', $bf059267f4767777$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ var $637b1112247bc509$var$getInteractionCountForNavigation = function() {
    return (0, $bf059267f4767777$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var $637b1112247bc509$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
var $637b1112247bc509$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
var $637b1112247bc509$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ var $637b1112247bc509$var$processEntry = function(entry) {
    // The least-long of the 10 longest interactions.
    var minLongestInteraction = $637b1112247bc509$var$longestInteractionList[$637b1112247bc509$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var existingInteraction = $637b1112247bc509$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $637b1112247bc509$var$longestInteractionList.length < $637b1112247bc509$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            var interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $637b1112247bc509$var$longestInteractionMap[interaction.id] = interaction;
            $637b1112247bc509$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $637b1112247bc509$var$longestInteractionList.sort(function(a, b) {
            return b.latency - a.latency;
        });
        $637b1112247bc509$var$longestInteractionList.splice($637b1112247bc509$var$MAX_INTERACTIONS_TO_CONSIDER).forEach(function(i) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $637b1112247bc509$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ var $637b1112247bc509$var$estimateP98LongestInteraction = function() {
    var candidateInteractionIndex = Math.min($637b1112247bc509$var$longestInteractionList.length - 1, Math.floor($637b1112247bc509$var$getInteractionCountForNavigation() / 50));
    return $637b1112247bc509$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var $637b1112247bc509$export$7df4b36ecaed99e1 = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $bf059267f4767777$export$67d90cda6b78a2eb)();
    var metric = (0, $76c2dbb4f86cf062$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            if (entry.interactionId) $637b1112247bc509$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                var noMatchingEntry = !$637b1112247bc509$var$longestInteractionList.some(function(interaction) {
                    return interaction.entries.some(function(prevEntry) {
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $637b1112247bc509$var$processEntry(entry);
            }
        });
        var inp = $637b1112247bc509$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    var po = (0, $f63aa6301f7f741a$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $c999a6d5615d95b5$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $91ad2fd81dbe6660$export$91ec2be6fdd8f1b4)(function() {
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $637b1112247bc509$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9b802183a425048a$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ var $9b802183a425048a$export$947b1626ab8d5632 = function(onReport) {
    var visibilityWatcher = (0, $3c64c5d74d86c77e$export$443f86b2c77012c4)();
    var metric = (0, $76c2dbb4f86cf062$export$3c29b44508a0612b)('LCP');
    var report;
    var handleEntries = function(entries) {
        var lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            var value = Math.max(lastEntry.startTime - (0, $13d657e28f89d668$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    var po = (0, $f63aa6301f7f741a$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $c999a6d5615d95b5$export$17679dccdd551979)(onReport, metric);
        var stopListening = function() {
            if (!$9b802183a425048a$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $9b802183a425048a$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach(function(type) {
            if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $91ad2fd81dbe6660$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ var $6dd9ddc83779a1b4$var$whenReady = function(callback) {
    if (!(0, $d466216041ad39ba$export$56d8a8a25bd48b81).document) return;
    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', function() {
        return $6dd9ddc83779a1b4$var$whenReady(callback);
    }, true);
    else if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', function() {
        return $6dd9ddc83779a1b4$var$whenReady(callback);
    }, true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ var $6dd9ddc83779a1b4$export$33a01e6c5f2c7e33 = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    var metric = (0, $76c2dbb4f86cf062$export$3c29b44508a0612b)('TTFB');
    var report = (0, $c999a6d5615d95b5$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $6dd9ddc83779a1b4$var$whenReady(function() {
        var navEntry = (0, $e6ef42dbce0580f2$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $13d657e28f89d668$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


var $2e7c6ca3baba0c3b$var$handlers = {};
var $2e7c6ca3baba0c3b$var$instrumented = {};
var $2e7c6ca3baba0c3b$var$_previousCls;
var $2e7c6ca3baba0c3b$var$_previousFid;
var $2e7c6ca3baba0c3b$var$_previousLcp;
var $2e7c6ca3baba0c3b$var$_previousTtfb;
var $2e7c6ca3baba0c3b$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $2e7c6ca3baba0c3b$export$861b82818b37ba5b(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $2e7c6ca3baba0c3b$var$addMetricObserver('cls', callback, $2e7c6ca3baba0c3b$var$instrumentCls, $2e7c6ca3baba0c3b$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $2e7c6ca3baba0c3b$export$3fd4b53331200102(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $2e7c6ca3baba0c3b$var$addMetricObserver('lcp', callback, $2e7c6ca3baba0c3b$var$instrumentLcp, $2e7c6ca3baba0c3b$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $2e7c6ca3baba0c3b$export$699d9529c099a797(callback) {
    return $2e7c6ca3baba0c3b$var$addMetricObserver('ttfb', callback, $2e7c6ca3baba0c3b$var$instrumentTtfb, $2e7c6ca3baba0c3b$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $2e7c6ca3baba0c3b$export$2707d7471c0b918f(callback) {
    return $2e7c6ca3baba0c3b$var$addMetricObserver('fid', callback, $2e7c6ca3baba0c3b$var$instrumentFid, $2e7c6ca3baba0c3b$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $2e7c6ca3baba0c3b$export$da3b76aa2022cbd7(callback) {
    return $2e7c6ca3baba0c3b$var$addMetricObserver('inp', callback, $2e7c6ca3baba0c3b$var$instrumentInp, $2e7c6ca3baba0c3b$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $2e7c6ca3baba0c3b$export$69816c1a049f8db6(type, callback) {
    $2e7c6ca3baba0c3b$var$addHandler(type, callback);
    if (!$2e7c6ca3baba0c3b$var$instrumented[type]) {
        $2e7c6ca3baba0c3b$var$instrumentPerformanceObserver(type);
        $2e7c6ca3baba0c3b$var$instrumented[type] = true;
    }
    return $2e7c6ca3baba0c3b$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $2e7c6ca3baba0c3b$var$triggerHandlers(type, data) {
    var typeHandlers = $2e7c6ca3baba0c3b$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, $dRvnI.getFunctionName)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $2e7c6ca3baba0c3b$var$instrumentCls() {
    return (0, $17c4c6ea791f3f2a$export$a7873055838e5ad8)(function(metric) {
        $2e7c6ca3baba0c3b$var$triggerHandlers('cls', {
            metric: metric
        });
        $2e7c6ca3baba0c3b$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $2e7c6ca3baba0c3b$var$instrumentFid() {
    return (0, $33d1c9106c18d757$export$39705a25c49af873)(function(metric) {
        $2e7c6ca3baba0c3b$var$triggerHandlers('fid', {
            metric: metric
        });
        $2e7c6ca3baba0c3b$var$_previousFid = metric;
    });
}
function $2e7c6ca3baba0c3b$var$instrumentLcp() {
    return (0, $9b802183a425048a$export$947b1626ab8d5632)(function(metric) {
        $2e7c6ca3baba0c3b$var$triggerHandlers('lcp', {
            metric: metric
        });
        $2e7c6ca3baba0c3b$var$_previousLcp = metric;
    });
}
function $2e7c6ca3baba0c3b$var$instrumentTtfb() {
    return (0, $6dd9ddc83779a1b4$export$33a01e6c5f2c7e33)(function(metric) {
        $2e7c6ca3baba0c3b$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $2e7c6ca3baba0c3b$var$_previousTtfb = metric;
    });
}
function $2e7c6ca3baba0c3b$var$instrumentInp() {
    return (0, $637b1112247bc509$export$7df4b36ecaed99e1)(function(metric) {
        $2e7c6ca3baba0c3b$var$triggerHandlers('inp', {
            metric: metric
        });
        $2e7c6ca3baba0c3b$var$_previousInp = metric;
    });
}
function $2e7c6ca3baba0c3b$var$addMetricObserver(type, callback, instrumentFn, previousValue) {
    var stopOnCallback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    $2e7c6ca3baba0c3b$var$addHandler(type, callback);
    var stopListening;
    if (!$2e7c6ca3baba0c3b$var$instrumented[type]) {
        stopListening = instrumentFn();
        $2e7c6ca3baba0c3b$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $2e7c6ca3baba0c3b$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $2e7c6ca3baba0c3b$var$instrumentPerformanceObserver(type) {
    var options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $f63aa6301f7f741a$export$d1203567a167490e)(type, function(entries) {
        $2e7c6ca3baba0c3b$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $2e7c6ca3baba0c3b$var$addHandler(type, handler) {
    $2e7c6ca3baba0c3b$var$handlers[type] = $2e7c6ca3baba0c3b$var$handlers[type] || [];
    $2e7c6ca3baba0c3b$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $2e7c6ca3baba0c3b$var$getCleanupCallback(type, callback, stopListening) {
    return function() {
        if (stopListening) stopListening();
        var typeHandlers = $2e7c6ca3baba0c3b$var$handlers[type];
        if (!typeHandlers) return;
        var index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



var $hRCmZ = parcelRequire("hRCmZ");

/**
 * Create envelope from Span item.
 */ function $e9908c78f9591e46$export$19a0081d4b39d77(spans, dsn) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $166ca73332398b10$export$44d472fbb931a776)(dsn);
    var items = spans.map($e9908c78f9591e46$var$createSpanItem);
    return (0, $05db56156fa7707f$export$f93f7f385160c44e)(headers, items);
}
function $e9908c78f9591e46$var$createSpanItem(span) {
    var spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


var $iNMpq = parcelRequire("iNMpq");
var $cCIJH = parcelRequire("cCIJH");
var $98rQ1 = parcelRequire("98rQ1");
var $8HkIr = parcelRequire("8HkIr");
var $iNMpq = parcelRequire("iNMpq");
/**
 * Adds a measurement to the current active transaction.
 */ function $7d19e3e29435414c$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    var transaction = (0, $iNMpq.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


var $bCb3d = parcelRequire("bCb3d");
var $6hfta = parcelRequire("6hfta");

var $fzAJT = parcelRequire("fzAJT");
var $dHjQX = parcelRequire("dHjQX");
var $gVncj = parcelRequire("gVncj");




/**
 * Checks if a given value is a valid measurement value.
 */ 
var $hRCmZ = parcelRequire("hRCmZ");

var $c4wKO = parcelRequire("c4wKO");
function $f886f672708867dc$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $f886f672708867dc$export$8bd469e1f37aa721(transaction, _param) {
    var startTimestamp = _param.startTimestamp, ctx = (0, $c4wKO._)(_param, [
        "startTimestamp"
    ]);
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild((0, $hRCmZ._)({
        startTimestamp: startTimestamp
    }, ctx));
}



var $75a5e811aa85f3b2$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $75a5e811aa85f3b2$var$msToSec(time) {
    return time / 1000;
}
function $75a5e811aa85f3b2$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $d466216041ad39ba$export$56d8a8a25bd48b81) && (0, $d466216041ad39ba$export$56d8a8a25bd48b81).addEventListener && (0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance;
}
var $75a5e811aa85f3b2$var$_performanceCursor = 0;
var $75a5e811aa85f3b2$var$_measurements = {};
var $75a5e811aa85f3b2$var$_lcpEntry;
var $75a5e811aa85f3b2$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $75a5e811aa85f3b2$export$7c69f0412d101b88() {
    var performance = $75a5e811aa85f3b2$var$getBrowserPerformanceAPI();
    if (performance && (0, $fzAJT.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        var fidCallback = $75a5e811aa85f3b2$var$_trackFID();
        var clsCallback = $75a5e811aa85f3b2$var$_trackCLS();
        var lcpCallback = $75a5e811aa85f3b2$var$_trackLCP();
        var ttfbCallback = $75a5e811aa85f3b2$var$_trackTtfb();
        return function() {
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/**
 * Start tracking long tasks.
 */ function $75a5e811aa85f3b2$export$f396d19077034ad2() {
    (0, $2e7c6ca3baba0c3b$export$69816c1a049f8db6)('longtask', function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = (0, $iNMpq.getActiveTransaction)();
                if (!transaction) return;
                var startTime = $75a5e811aa85f3b2$var$msToSec((0, $fzAJT.browserPerformanceTimeOrigin) + entry.startTime);
                var duration = $75a5e811aa85f3b2$var$msToSec(entry.duration);
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild({
                    description: 'Main UI thread blocked',
                    op: 'ui.long-task',
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $75a5e811aa85f3b2$export$e27543e0976315e4() {
    (0, $2e7c6ca3baba0c3b$export$69816c1a049f8db6)('event', function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = (0, $iNMpq.getActiveTransaction)();
                if (!transaction) return;
                if (entry.name === 'click') {
                    var startTime = $75a5e811aa85f3b2$var$msToSec((0, $fzAJT.browserPerformanceTimeOrigin) + entry.startTime);
                    var duration = $75a5e811aa85f3b2$var$msToSec(entry.duration);
                    var span = {
                        description: (0, $dHjQX.htmlTreeAsString)(entry.target),
                        op: "ui.interaction.".concat(entry.name),
                        origin: 'auto.ui.browser.metrics',
                        startTimestamp: startTime,
                        endTimestamp: startTime + duration
                    };
                    var componentName = (0, $dHjQX.getComponentName)(entry.target);
                    if (componentName) span.attributes = {
                        'ui.component_name': componentName
                    };
                    // eslint-disable-next-line deprecation/deprecation
                    transaction.startChild(span);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $75a5e811aa85f3b2$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    var performance = $75a5e811aa85f3b2$var$getBrowserPerformanceAPI();
    if (performance && (0, $fzAJT.browserPerformanceTimeOrigin)) {
        var inpCallback = $75a5e811aa85f3b2$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return function() {
            inpCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $75a5e811aa85f3b2$var$_trackCLS() {
    return (0, $2e7c6ca3baba0c3b$export$861b82818b37ba5b)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding CLS');
        $75a5e811aa85f3b2$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $75a5e811aa85f3b2$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $75a5e811aa85f3b2$var$_trackLCP() {
    return (0, $2e7c6ca3baba0c3b$export$3fd4b53331200102)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding LCP');
        $75a5e811aa85f3b2$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $75a5e811aa85f3b2$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $75a5e811aa85f3b2$var$_trackFID() {
    return (0, $2e7c6ca3baba0c3b$export$2707d7471c0b918f)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        var timeOrigin = $75a5e811aa85f3b2$var$msToSec((0, $fzAJT.browserPerformanceTimeOrigin));
        var startTime = $75a5e811aa85f3b2$var$msToSec(entry.startTime);
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding FID');
        $75a5e811aa85f3b2$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $75a5e811aa85f3b2$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $75a5e811aa85f3b2$var$_trackTtfb() {
    return (0, $2e7c6ca3baba0c3b$export$699d9529c099a797)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding TTFB');
        $75a5e811aa85f3b2$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
var $75a5e811aa85f3b2$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $75a5e811aa85f3b2$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $2e7c6ca3baba0c3b$export$da3b76aa2022cbd7)(function(param) {
        var metric = param.metric;
        if (metric.value === undefined) return;
        var entry = metric.entries.find(function(entry) {
            return entry.duration === metric.value && $75a5e811aa85f3b2$var$INP_ENTRY_MAP[entry.name] !== undefined;
        });
        var client = (0, $cCIJH.getClient)();
        if (!entry || !client) return;
        var interactionType = $75a5e811aa85f3b2$var$INP_ENTRY_MAP[entry.name];
        var options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ var startTime = $75a5e811aa85f3b2$var$msToSec((0, $fzAJT.browserPerformanceTimeOrigin) + entry.startTime);
        var duration = $75a5e811aa85f3b2$var$msToSec(metric.value);
        var interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        var routeName = interaction.routeName, parentContext = interaction.parentContext, activeTransaction = interaction.activeTransaction, user = interaction.user, replayId = interaction.replayId;
        var userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        var span = new (0, $bCb3d.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: "ui.interaction.".concat(interactionType),
            name: (0, $dHjQX.htmlTreeAsString)(entry.target),
            attributes: (0, $hRCmZ._)({
                release: options.release,
                environment: options.environment,
                transaction: routeName
            }, userDisplay !== undefined && userDisplay !== '' ? {
                user: userDisplay
            } : {}, profileId !== undefined ? {
                profile_id: profileId
            } : {}, replayId !== undefined ? {
                replay_id: replayId
            } : {}),
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ var sampleRate = $75a5e811aa85f3b2$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            var envelope = span ? (0, $e9908c78f9591e46$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            var transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, function(reason) {
                (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $75a5e811aa85f3b2$export$5f8fa6b3467a7443(transaction) {
    var performance = $75a5e811aa85f3b2$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $d466216041ad39ba$export$56d8a8a25bd48b81).performance.getEntries || !(0, $fzAJT.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    var timeOrigin = $75a5e811aa85f3b2$var$msToSec((0, $fzAJT.browserPerformanceTimeOrigin));
    var performanceEntries = performance.getEntries();
    var _spanToJSON = (0, $6hfta.spanToJSON)(transaction), op = _spanToJSON.op, transactionStartTime = _spanToJSON.start_timestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($75a5e811aa85f3b2$var$_performanceCursor).forEach(function(entry) {
        var startTime = $75a5e811aa85f3b2$var$msToSec(entry.startTime);
        var duration = $75a5e811aa85f3b2$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $75a5e811aa85f3b2$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $75a5e811aa85f3b2$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = (0, $3c64c5d74d86c77e$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding FP');
                        $75a5e811aa85f3b2$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding FCP');
                        $75a5e811aa85f3b2$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $75a5e811aa85f3b2$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $75a5e811aa85f3b2$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $75a5e811aa85f3b2$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $75a5e811aa85f3b2$var$_addTtfbRequestTimeToMeasurements($75a5e811aa85f3b2$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach(function(name) {
            if (!$75a5e811aa85f3b2$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            var oldValue = $75a5e811aa85f3b2$var$_measurements[name].value;
            var measurementTimestamp = timeOrigin + $75a5e811aa85f3b2$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            var normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            var delta = normalizedValue - oldValue;
            (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log("[Measurements] Normalized ".concat(name, " from ").concat(oldValue, " to ").concat(normalizedValue, " (").concat(delta, ")"));
            $75a5e811aa85f3b2$var$_measurements[name].value = normalizedValue;
        });
        var fidMark = $75a5e811aa85f3b2$var$_measurements['mark.fid'];
        if (fidMark && $75a5e811aa85f3b2$var$_measurements['fid']) {
            // create span for FID
            (0, $f886f672708867dc$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $75a5e811aa85f3b2$var$msToSec($75a5e811aa85f3b2$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $75a5e811aa85f3b2$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $75a5e811aa85f3b2$var$_measurements)) delete $75a5e811aa85f3b2$var$_measurements.cls;
        Object.keys($75a5e811aa85f3b2$var$_measurements).forEach(function(measurementName) {
            (0, $7d19e3e29435414c$export$7cc31b475d33a706)(measurementName, $75a5e811aa85f3b2$var$_measurements[measurementName].value, $75a5e811aa85f3b2$var$_measurements[measurementName].unit);
        });
        $75a5e811aa85f3b2$var$_tagMetricInfo(transaction);
    }
    $75a5e811aa85f3b2$var$_lcpEntry = undefined;
    $75a5e811aa85f3b2$var$_clsEntry = undefined;
    $75a5e811aa85f3b2$var$_measurements = {};
}
/** Create measure related spans */ function $75a5e811aa85f3b2$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    (0, $f886f672708867dc$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75a5e811aa85f3b2$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach(function(event) {
        $75a5e811aa85f3b2$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $75a5e811aa85f3b2$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $75a5e811aa85f3b2$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $75a5e811aa85f3b2$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $75a5e811aa85f3b2$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $75a5e811aa85f3b2$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry["".concat(event, "End")];
    var start = entry["".concat(event, "Start")];
    if (!start || !end) return;
    (0, $f886f672708867dc$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $75a5e811aa85f3b2$var$msToSec(start),
        endTimestamp: timeOrigin + $75a5e811aa85f3b2$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75a5e811aa85f3b2$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $f886f672708867dc$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $75a5e811aa85f3b2$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $75a5e811aa85f3b2$var$msToSec(entry.responseEnd)
        });
        (0, $f886f672708867dc$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $75a5e811aa85f3b2$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $75a5e811aa85f3b2$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $75a5e811aa85f3b2$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    var parsedUrl = (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var data = {};
    $75a5e811aa85f3b2$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $75a5e811aa85f3b2$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $75a5e811aa85f3b2$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $d466216041ad39ba$export$56d8a8a25bd48b81).location.origin);
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    (0, $f886f672708867dc$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $d466216041ad39ba$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource.".concat(entry.initiatorType) : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $75a5e811aa85f3b2$var$_trackNavigator(transaction) {
    var navigator = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $f886f672708867dc$export$27169ccae1b439e3)(connection.rtt)) $75a5e811aa85f3b2$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $f886f672708867dc$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', "".concat(navigator.deviceMemory, " GB"));
    if ((0, $f886f672708867dc$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $75a5e811aa85f3b2$var$_tagMetricInfo(transaction) {
    if ($75a5e811aa85f3b2$var$_lcpEntry) {
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($75a5e811aa85f3b2$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $dHjQX.htmlTreeAsString)($75a5e811aa85f3b2$var$_lcpEntry.element));
        if ($75a5e811aa85f3b2$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $75a5e811aa85f3b2$var$_lcpEntry.id);
        if ($75a5e811aa85f3b2$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $75a5e811aa85f3b2$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $75a5e811aa85f3b2$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($75a5e811aa85f3b2$var$_clsEntry && $75a5e811aa85f3b2$var$_clsEntry.sources) {
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding CLS Data');
        $75a5e811aa85f3b2$var$_clsEntry.sources.forEach(function(source, index) {
            return(// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("cls.source.".concat(index + 1), (0, $dHjQX.htmlTreeAsString)(source.node)));
        });
    }
}
function $75a5e811aa85f3b2$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    var entryVal = entry[key];
    if (entryVal != null && entryVal < $75a5e811aa85f3b2$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $75a5e811aa85f3b2$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    var navEntry = (0, $e6ef42dbce0580f2$export$6431553786c94949)();
    if (!navEntry) return;
    var responseStart = navEntry.responseStart, requestStart = navEntry.requestStart;
    if (requestStart <= responseStart) {
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $75a5e811aa85f3b2$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $98rQ1.hasTracingEnabled)(options)) return false;
    var sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: (0, $hRCmZ._)({}, transactionContext.data, transactionContext.attributes),
        location: (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $8HkIr.isValidSampleRate)(sampleRate)) {
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}



var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $cCIJH = parcelRequire("cCIJH");
var $dYxb4 = parcelRequire("dYxb4");
var $8fOd9 = parcelRequire("8fOd9");
var $98rQ1 = parcelRequire("98rQ1");
var $fkG29 = parcelRequire("fkG29");
var $bpf5e = parcelRequire("bpf5e");
var $6hfta = parcelRequire("6hfta");
var $jWdUe = parcelRequire("jWdUe");

var $6xWsf = parcelRequire("6xWsf");
var $fzAJT = parcelRequire("fzAJT");
var $iAzzt = parcelRequire("iAzzt");
var $gj3Le = parcelRequire("gj3Le");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $bOqL7 = parcelRequire("bOqL7");

var $cCIJH = parcelRequire("cCIJH");
var $dYxb4 = parcelRequire("dYxb4");
var $8fOd9 = parcelRequire("8fOd9");
var $98rQ1 = parcelRequire("98rQ1");
var $fkG29 = parcelRequire("fkG29");
var $bpf5e = parcelRequire("bpf5e");
var $6hfta = parcelRequire("6hfta");
var $jWdUe = parcelRequire("jWdUe");

var $6xWsf = parcelRequire("6xWsf");
var $iAzzt = parcelRequire("iAzzt");
var $8lokx = parcelRequire("8lokx");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $9e7eed1a9e9e7bb9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var spanOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 'auto.http.browser';
    if (!(0, $98rQ1.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    var shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            $9e7eed1a9e9e7bb9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0, $cCIJH.getCurrentScope)();
    var client = (0, $cCIJH.getClient)();
    var _handlerData_fetchData = handlerData.fetchData, method = _handlerData_fetchData.method, url = _handlerData_fetchData.url;
    var fullUrl = $9e7eed1a9e9e7bb9$var$getFullURL(url);
    var host = fullUrl ? (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? (0, $jWdUe.startInactiveSpan)({
        name: "".concat(method, " ").concat(url),
        onlyIfParent: true,
        attributes: (0, $8c6ug._)({
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host
        }, (0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanOrigin),
        op: 'http.client'
    }) : undefined;
    if (span1) {
        handlerData.fetchData.__span = span1.spanContext().spanId;
        spans[span1.spanContext().spanId] = span1;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        var request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $9e7eed1a9e9e7bb9$export$6717acf674206871(request, client, scope, options, span1);
    }
    return span1;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $9e7eed1a9e9e7bb9$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    var span = requestSpan || scope.getSpan();
    var isolationScope = (0, $8fOd9.getIsolationScope)();
    var _$_object_spread = (0, $hRCmZ._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = _$_object_spread.traceId, spanId = _$_object_spread.spanId, sampled = _$_object_spread.sampled, dsc = _$_object_spread.dsc;
    var sentryTraceHeader = span ? (0, $6hfta.spanToTraceHeader)(span) : (0, $iAzzt.generateSentryTraceHeader)(traceId, spanId, sampled);
    var sentryBaggageHeader = (0, $6xWsf.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $dYxb4.getDynamicSamplingContextFromSpan)(span) : (0, $dYxb4.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    var headers = options.headers || (typeof Request !== 'undefined' && (0, $8lokx.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $8lokx.isInstanceOf)(headers, Headers)) {
        var newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $6xWsf.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        var newHeaders1 = (0, $bOqL7._)(headers).concat([
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ]);
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders1.push([
            (0, $6xWsf.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders1;
    } else {
        var _newBaggageHeaders;
        var existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        var newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) (_newBaggageHeaders = newBaggageHeaders).push.apply(_newBaggageHeaders, (0, $bOqL7._)(existingBaggageHeader));
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return (0, $7XD9P._)((0, $hRCmZ._)({}, headers), {
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        });
    }
}
function $9e7eed1a9e9e7bb9$var$getFullURL(url) {
    try {
        var parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $9e7eed1a9e9e7bb9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $bpf5e.setHttpStatus)(span, handlerData.response.status);
        var contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            var contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ var $fd5c2379c07d88a5$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ var $fd5c2379c07d88a5$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $fd5c2379c07d88a5$export$15bd0305d05ad07b,
    tracePropagationTargets: $fd5c2379c07d88a5$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $fd5c2379c07d88a5$export$864489cb3478db3e(_options) {
    var _$_object_spread = (0, $hRCmZ._)({
        traceFetch: $fd5c2379c07d88a5$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $fd5c2379c07d88a5$export$cc17fb3c0bc95cd7.traceXHR
    }, _options), traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets = _$_object_spread.tracePropagationTargets, // eslint-disable-next-line deprecation/deprecation
    tracingOrigins = _$_object_spread.tracingOrigins, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    var shouldAttachHeadersWithTargets = function(url) {
        return $fd5c2379c07d88a5$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    };
    var spans = {};
    if (traceFetch) (0, $ca1785e99fcb0e3e$export$f75d3c772c923df0)(function(handlerData) {
        var createdSpan = (0, $9e7eed1a9e9e7bb9$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            var fullUrl = $fd5c2379c07d88a5$var$getFullURL(handlerData.fetchData.url);
            var host = fullUrl ? (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $fd5c2379c07d88a5$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $17e4d6ff5e828079$export$26ace48dd54c9aea)(function(handlerData) {
        var createdSpan = $fd5c2379c07d88a5$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $fd5c2379c07d88a5$var$addHTTPTimings(createdSpan);
    });
}
function $fd5c2379c07d88a5$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $fd5c2379c07d88a5$var$addHTTPTimings(span) {
    var url = ((0, $6hfta.spanToJSON)(span).data || {}).url;
    if (!url || typeof url !== 'string') return;
    var cleanup = (0, $2e7c6ca3baba0c3b$export$69816c1a049f8db6)('resource', function(param) {
        var entries = param.entries;
        entries.forEach(function(entry) {
            if ($fd5c2379c07d88a5$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                var _span;
                var spanData = $fd5c2379c07d88a5$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach(function(data) {
                    return (_span = span).setAttribute.apply(_span, (0, $bOqL7._)(data));
                });
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $fd5c2379c07d88a5$export$57c6f824442f9fe1(nextHopProtocol) {
    var name = 'unknown';
    var version = 'unknown';
    var _name = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _char = _step.value;
            // http/1.1 etc.
            if (_char === '/') {
                var ref;
                ref = (0, $6mdMa._)(nextHopProtocol.split('/'), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            // h2, h3 etc.
            if (!isNaN(Number(_char))) {
                name = _name === 'h' ? 'http' : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += _char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $fd5c2379c07d88a5$var$getAbsoluteTime() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (((0, $fzAJT.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $fd5c2379c07d88a5$var$resourceTimingEntryToSpanData(resourceTiming) {
    var _extractNetworkProtocol = $fd5c2379c07d88a5$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol), name = _extractNetworkProtocol.name, version = _extractNetworkProtocol.version;
    var timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $fzAJT.browserPerformanceTimeOrigin)) return timingSpanData;
    return (0, $bOqL7._)(timingSpanData).concat([
        [
            'http.request.redirect_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $fd5c2379c07d88a5$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ]);
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $fd5c2379c07d88a5$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $gj3Le.stringMatchesSomePattern)(url, tracePropagationTargets || $fd5c2379c07d88a5$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $fd5c2379c07d88a5$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr && xhr[0, $17e4d6ff5e828079$export$55b6bb1e45c6cf59];
    if (!(0, $98rQ1.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    var shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $bpf5e.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0, $cCIJH.getCurrentScope)();
    var isolationScope = (0, $8fOd9.getIsolationScope)();
    var fullUrl = $fd5c2379c07d88a5$var$getFullURL(sentryXhrData.url);
    var host = fullUrl ? (0, $0affd2066e6dc1d7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? (0, $jWdUe.startInactiveSpan)({
        name: "".concat(sentryXhrData.method, " ").concat(sentryXhrData.url),
        onlyIfParent: true,
        attributes: (0, $8c6ug._)({
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host
        }, (0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.http.browser'),
        op: 'http.client'
    }) : undefined;
    if (span1) {
        xhr.__sentry_xhr_span_id__ = span1.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span1;
    }
    var client = (0, $cCIJH.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        var _$_object_spread = (0, $hRCmZ._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = _$_object_spread.traceId, spanId1 = _$_object_spread.spanId, sampled = _$_object_spread.sampled, dsc = _$_object_spread.dsc;
        var sentryTraceHeader = span1 ? (0, $6hfta.spanToTraceHeader)(span1) : (0, $iAzzt.generateSentryTraceHeader)(traceId, spanId1, sampled);
        var sentryBaggageHeader = (0, $6xWsf.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span1 ? (0, $dYxb4.getDynamicSamplingContextFromSpan)(span1) : (0, $dYxb4.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $fd5c2379c07d88a5$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span1;
}
function $fd5c2379c07d88a5$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $6xWsf.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $fd5c2379c07d88a5$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        var parsed = new URL(url, (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



var $fzAJT = parcelRequire("fzAJT");
var $gVncj = parcelRequire("gVncj");


/**
 * Default function implementing pageload and navigation transactions
 */ function $0e11b546be55c2ee$export$86649cc09fe75143(customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!(0, $d466216041ad39ba$export$56d8a8a25bd48b81) || !(0, $d466216041ad39ba$export$56d8a8a25bd48b81).location) {
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $fzAJT.browserPerformanceTimeOrigin) ? (0, $fzAJT.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $98deba007e94a00d$export$3f18c56c58114e75)(function(param) {
        var to = param.to, from = param.from;
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log("[Tracing] Finishing current transaction with op: ".concat(activeTransaction.op));
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



var $9407b60e82efdc8d$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ var $9407b60e82efdc8d$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $hRCmZ._)((0, $7XD9P._)((0, $hRCmZ._)({}, (0, $lFTnW.TRACING_DEFAULTS)), {
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $0e11b546be55c2ee$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), (0, $fd5c2379c07d88a5$export$cc17fb3c0bc95cd7));
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var $9407b60e82efdc8d$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ var $9407b60e82efdc8d$export$46d3bbd0375f5fa4 = /*#__PURE__*/ function() {
    "use strict";
    function BrowserTracing(_options) {
        (0, $6WLcG._)(this, BrowserTracing);
        this.name = $9407b60e82efdc8d$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $58WN1.addTracingExtensions)();
        if (0, $e222f13986d11a38$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = (0, $hRCmZ._)({}, $9407b60e82efdc8d$var$DEFAULT_BROWSER_TRACING_OPTIONS, _options);
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $75a5e811aa85f3b2$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $75a5e811aa85f3b2$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $75a5e811aa85f3b2$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $75a5e811aa85f3b2$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    (0, $dbIwN._)(BrowserTracing, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                var _this = this;
                this._getCurrentHub = getCurrentHub;
                var hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                var client = hub.getClient();
                var clientOptions = client && client.getOptions();
                var _this_options = this.options, instrumentRouting = _this_options.routingInstrumentation, startTransactionOnLocationChange = _this_options.startTransactionOnLocationChange, startTransactionOnPageLoad = _this_options.startTransactionOnPageLoad, markBackgroundTransactions = _this_options.markBackgroundTransactions, traceFetch = _this_options.traceFetch, traceXHR = _this_options.traceXHR, shouldCreateSpanForRequest = _this_options.shouldCreateSpanForRequest, enableHTTPTimings = _this_options.enableHTTPTimings, _experiments = _this_options._experiments;
                var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
                // There are three ways to configure tracePropagationTargets:
                // 1. via top level client option `tracePropagationTargets`
                // 2. via BrowserTracing option `tracePropagationTargets`
                // 3. via BrowserTracing option `tracingOrigins` (deprecated)
                //
                // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
                // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
                // This is done as it minimizes bundle size (we don't have to have undefined checks).
                //
                // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
                // eslint-disable-next-line deprecation/deprecation
                var tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
                if ((0, $e222f13986d11a38$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $gVncj.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
                instrumentRouting(function(context) {
                    var transaction = _this._createRouteTransaction(context);
                    _this.options._experiments.onStartRouteTransaction && _this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
                    return transaction;
                }, startTransactionOnPageLoad, startTransactionOnLocationChange);
                if (markBackgroundTransactions) (0, $a21dec1cee20e6ce$export$6f18f55521af71a1)();
                if (_experiments.enableInteractions) this._registerInteractionListener();
                if (this.options.enableInp) this._registerInpInteractionListener();
                (0, $fd5c2379c07d88a5$export$864489cb3478db3e)({
                    traceFetch: traceFetch,
                    traceXHR: traceXHR,
                    tracePropagationTargets: tracePropagationTargets,
                    shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                    enableHTTPTimings: enableHTTPTimings
                });
            }
        },
        {
            /** Create routing idle transaction. */ key: "_createRouteTransaction",
            value: function _createRouteTransaction(context) {
                var _this = this;
                if (!this._getCurrentHub) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn("[Tracing] Did not create ".concat(context.op, " transaction because _getCurrentHub is invalid."));
                    return undefined;
                }
                var hub = this._getCurrentHub();
                var _this_options = this.options, beforeNavigate = _this_options.beforeNavigate, idleTimeout = _this_options.idleTimeout, finalTimeout = _this_options.finalTimeout, heartbeatInterval = _this_options.heartbeatInterval;
                var isPageloadTransaction = context.op === 'pageload';
                var expandedContext;
                if (isPageloadTransaction) {
                    var sentryTrace = isPageloadTransaction ? $9407b60e82efdc8d$export$f147b32b03c9cf11('sentry-trace') : '';
                    var baggage = isPageloadTransaction ? $9407b60e82efdc8d$export$f147b32b03c9cf11('baggage') : undefined;
                    var _propagationContextFromHeaders = (0, $iAzzt.propagationContextFromHeaders)(sentryTrace, baggage), traceId = _propagationContextFromHeaders.traceId, dsc = _propagationContextFromHeaders.dsc, parentSpanId = _propagationContextFromHeaders.parentSpanId, sampled = _propagationContextFromHeaders.sampled;
                    expandedContext = (0, $7XD9P._)((0, $hRCmZ._)({
                        traceId: traceId,
                        parentSpanId: parentSpanId,
                        parentSampled: sampled
                    }, context), {
                        metadata: (0, $7XD9P._)((0, $hRCmZ._)({}, context.metadata), {
                            dynamicSamplingContext: dsc
                        }),
                        trimEnd: true
                    });
                } else expandedContext = (0, $hRCmZ._)({
                    trimEnd: true
                }, context);
                var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
                // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
                // from being sent to Sentry).
                var finalContext = modifiedContext === undefined ? (0, $7XD9P._)((0, $hRCmZ._)({}, expandedContext), {
                    sampled: false
                }) : modifiedContext;
                // If `beforeNavigate` set a custom name, record that fact
                // eslint-disable-next-line deprecation/deprecation
                finalContext.metadata = finalContext.name !== expandedContext.name ? (0, $7XD9P._)((0, $hRCmZ._)({}, finalContext.metadata), {
                    source: 'custom'
                }) : finalContext.metadata;
                this._latestRoute.name = finalContext.name;
                this._latestRoute.context = finalContext;
                // eslint-disable-next-line deprecation/deprecation
                if (finalContext.sampled === false) (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
                (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
                var location = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location;
                var idleTransaction = (0, $58WN1.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
                    location: location
                }, heartbeatInterval, isPageloadTransaction);
                if (isPageloadTransaction) {
                    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document) {
                        (0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', function() {
                            if ([
                                'interactive',
                                'complete'
                            ].includes((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                        });
                        if ([
                            'interactive',
                            'complete'
                        ].includes((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                    }
                }
                idleTransaction.registerBeforeFinishCallback(function(transaction) {
                    _this._collectWebVitals();
                    (0, $75a5e811aa85f3b2$export$5f8fa6b3467a7443)(transaction);
                });
                return idleTransaction;
            }
        },
        {
            /** Start listener for interaction transactions */ key: "_registerInteractionListener",
            value: function _registerInteractionListener() {
                var _this = this;
                var inflightInteractionTransaction;
                var registerInteractionTransaction = function() {
                    var _this_options = _this.options, idleTimeout = _this_options.idleTimeout, finalTimeout = _this_options.finalTimeout, heartbeatInterval = _this_options.heartbeatInterval;
                    var op = 'ui.action.click';
                    // eslint-disable-next-line deprecation/deprecation
                    var currentTransaction = (0, $iNMpq.getActiveTransaction)();
                    if (currentTransaction && currentTransaction.op && [
                        'navigation',
                        'pageload'
                    ].includes(currentTransaction.op)) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
                        return undefined;
                    }
                    if (inflightInteractionTransaction) {
                        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                        inflightInteractionTransaction.end();
                        inflightInteractionTransaction = undefined;
                    }
                    if (!_this._getCurrentHub) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn("[Tracing] Did not create ".concat(op, " transaction because _getCurrentHub is invalid."));
                        return undefined;
                    }
                    if (!_this._latestRoute.name) {
                        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
                        return undefined;
                    }
                    var hub = _this._getCurrentHub();
                    var location = (0, $d466216041ad39ba$export$56d8a8a25bd48b81).location;
                    var context = {
                        name: _this._latestRoute.name,
                        op: op,
                        trimEnd: true,
                        data: (0, $8c6ug._)({}, (0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), _this._latestRoute.context ? $9407b60e82efdc8d$var$getSource(_this._latestRoute.context) : 'url')
                    };
                    inflightInteractionTransaction = (0, $58WN1.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                        location: location
                    }, heartbeatInterval);
                };
                [
                    'click'
                ].forEach(function(type) {
                    if ((0, $d466216041ad39ba$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                        once: false,
                        capture: true
                    });
                });
            }
        },
        {
            /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ key: "_registerInpInteractionListener",
            value: function _registerInpInteractionListener() {
                var _this = this;
                var handleEntries = function(param) {
                    var entries = param.entries;
                    var client = (0, $cCIJH.getClient)();
                    // We need to get the replay, user, and activeTransaction from the current scope
                    // so that we can associate replay id, profile id, and a user display to the span
                    var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
                    var replayId = replay !== undefined ? replay.getReplayId() : undefined;
                    // eslint-disable-next-line deprecation/deprecation
                    var activeTransaction = (0, $iNMpq.getActiveTransaction)();
                    var currentScope = (0, $cCIJH.getCurrentScope)();
                    var user = currentScope !== undefined ? currentScope.getUser() : undefined;
                    entries.forEach(function(entry) {
                        if ($9407b60e82efdc8d$var$isPerformanceEventTiming(entry)) {
                            var interactionId = entry.interactionId;
                            if (interactionId === undefined) return;
                            var existingInteraction = _this._interactionIdToRouteNameMapping[interactionId];
                            var duration = entry.duration;
                            var startTime = entry.startTime;
                            var keys = Object.keys(_this._interactionIdToRouteNameMapping);
                            var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                                return _this._interactionIdToRouteNameMapping[a].duration < _this._interactionIdToRouteNameMapping[b].duration ? a : b;
                            }) : undefined;
                            // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                            // This is also checked in the web-vitals library.
                            if (entry.entryType === 'first-input') {
                                var matchingEntry = keys.map(function(key) {
                                    return _this._interactionIdToRouteNameMapping[key];
                                }).some(function(interaction) {
                                    return interaction.duration === duration && interaction.startTime === startTime;
                                });
                                if (matchingEntry) return;
                            }
                            // Interactions with an id of 0 and are not first-input are not valid.
                            if (!interactionId) return;
                            // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                            if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                            else if (keys.length < $9407b60e82efdc8d$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > _this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                                // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                                var routeName = _this._latestRoute.name;
                                var parentContext = _this._latestRoute.context;
                                if (routeName && parentContext) {
                                    if (minInteractionId && Object.keys(_this._interactionIdToRouteNameMapping).length >= $9407b60e82efdc8d$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                                    delete _this._interactionIdToRouteNameMapping[minInteractionId];
                                    _this._interactionIdToRouteNameMapping[interactionId] = {
                                        routeName: routeName,
                                        duration: duration,
                                        parentContext: parentContext,
                                        user: user,
                                        activeTransaction: activeTransaction,
                                        replayId: replayId,
                                        startTime: startTime
                                    };
                                }
                            }
                        }
                    });
                };
                (0, $2e7c6ca3baba0c3b$export$69816c1a049f8db6)('event', handleEntries);
                (0, $2e7c6ca3baba0c3b$export$69816c1a049f8db6)('first-input', handleEntries);
            }
        }
    ]);
    return BrowserTracing;
}();
/** Returns the value of a meta tag */ function $9407b60e82efdc8d$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0, $dHjQX.getDomElement)("meta[name=".concat(metaName, "]"));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $9407b60e82efdc8d$var$getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $9407b60e82efdc8d$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}


var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $6mdMa = parcelRequire("6mdMa");

var $dsRPj = parcelRequire("dsRPj");

var $7f9QD = parcelRequire("7f9QD");

var $3pJb0 = parcelRequire("3pJb0");

var $dFREI = parcelRequire("dFREI");
function $8467c8bb08e2e11e$export$71511d61b312f219(arr) {
    return (0, $dsRPj._)(arr) || (0, $7f9QD._)(arr) || (0, $dFREI._)(arr) || (0, $3pJb0._)();
}



var $bOqL7 = parcelRequire("bOqL7");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $6mdMa = parcelRequire("6mdMa");
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $b26e332cc6a6ce23$export$d0eaf3e94be578f6(str) {
    var obj = {};
    var index = 0;
    while(index < str.length){
        var eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        var endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        var key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            var val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}



var $84Gbr = parcelRequire("84Gbr");

var $8lokx = parcelRequire("8lokx");

var $gVncj = parcelRequire("gVncj");

var $gCPnr = parcelRequire("gCPnr");

var $e6ab72bf44164694$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
var $e6ab72bf44164694$var$DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
var $e6ab72bf44164694$export$33c1c602a3538e5e = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function $e6ab72bf44164694$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === 'url') {
        // Attempt to grab a parameterized route off of the request
        var _extractPathForTransaction = (0, $6mdMa._)($e6ab72bf44164694$export$8c5ebee2e5bb9575(req, {
            path: true,
            method: true
        }), 2), name = _extractPathForTransaction[0], source = _extractPathForTransaction[1];
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute('baseUrl', req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData('query', $e6ab72bf44164694$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $e6ab72bf44164694$export$8c5ebee2e5bb9575(req) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var method = req.method && req.method.toUpperCase();
    var path = '';
    var source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || "".concat(req.baseUrl || '').concat(req.route && req.route.path);
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, $0affd2066e6dc1d7$export$ce084c78234bd35)(req.originalUrl || req.url || '');
    var name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $e6ab72bf44164694$var$extractTransaction(req, type) {
    switch(type){
        case 'path':
            return $e6ab72bf44164694$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                var customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return $e6ab72bf44164694$export$8c5ebee2e5bb9575(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function $e6ab72bf44164694$var$extractUserData(user, keys) {
    var extractedUser = {};
    var attributes = Array.isArray(keys) ? keys : $e6ab72bf44164694$export$33c1c602a3538e5e;
    attributes.forEach(function(key) {
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $e6ab72bf44164694$export$b5c5d78255f11c84(req, options) {
    var _ref = options || {}, _ref_include = _ref.include, include = _ref_include === void 0 ? $e6ab72bf44164694$var$DEFAULT_REQUEST_INCLUDES : _ref_include, deps = _ref.deps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    var headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    var host = headers.host || req.hostname || req.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    var originalUrl = req.originalUrl || req.url || '';
    // absolute url
    var absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : "".concat(protocol, "://").concat(host).concat(originalUrl);
    include.forEach(function(key) {
        switch(key){
            case 'headers':
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes('cookies')) delete requestData.headers.cookie;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, $b26e332cc6a6ce23$export$d0eaf3e94be578f6)(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $e6ab72bf44164694$var$extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $8lokx.isString)(req.body) ? req.body : JSON.stringify((0, $gCPnr.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function $e6ab72bf44164694$export$e560aeb323d2791d(event, req, options) {
    var include = (0, $hRCmZ._)({}, $e6ab72bf44164694$var$DEFAULT_INCLUDES, options && options.include);
    if (include.request) {
        var extractedRequestData = Array.isArray(include.request) ? $e6ab72bf44164694$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $e6ab72bf44164694$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = (0, $hRCmZ._)({}, event.request, extractedRequestData);
    }
    if (include.user) {
        var extractedUser = req.user && (0, $8lokx.isPlainObject)(req.user) ? $e6ab72bf44164694$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = (0, $hRCmZ._)({}, event.user, extractedUser);
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        var ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = (0, $7XD9P._)((0, $hRCmZ._)({}, event.user), {
            ip_address: ip
        });
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $e6ab72bf44164694$var$extractTransaction(req, include.transaction);
    return event;
}
function $e6ab72bf44164694$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    var originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = "http://dogs.are.great".concat(originalUrl);
    try {
        return req.query || typeof URL !== 'undefined' && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function $e6ab72bf44164694$export$fee0927b05379c23(winterCGHeaders) {
    var headers = {};
    try {
        winterCGHeaders.forEach(function(value, key) {
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, $84Gbr.DEBUG_BUILD) && (0, $gVncj.logger).warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $e6ab72bf44164694$export$49a11ed11911fd29(req) {
    var headers = $e6ab72bf44164694$export$fee0927b05379c23(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}


var $lVfPx = parcelRequire("lVfPx");
var $8lokx = parcelRequire("8lokx");
var $gVncj = parcelRequire("gVncj");

var $fkG29 = parcelRequire("fkG29");
var $6hfta = parcelRequire("6hfta");


/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ var $e85b14c45548e103$export$6dafdd8fec05099d = /*#__PURE__*/ function() {
    "use strict";
    function Express() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $6WLcG._)(this, Express);
        this.name = Express.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    (0, $dbIwN._)(Express, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if (!this._router) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('ExpressIntegration is missing an Express instance');
                    return;
                }
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)(getCurrentHub)) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('Express Integration is skipped because of instrumenter configuration.');
                    return;
                }
                $e85b14c45548e103$var$instrumentMiddlewares(this._router, this._methods);
                $e85b14c45548e103$var$instrumentRouter(this._router);
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Express';
            }
        }
    ]);
    return Express;
}();
$e85b14c45548e103$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $e85b14c45548e103$var$wrap(fn, method) {
    var arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                var transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    var span = transaction.startChild({
                        description: fn.name,
                        op: "middleware.express.".concat(method),
                        origin: 'auto.middleware.express'
                    });
                    res.once('finish', function() {
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                var transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    function(_2) {
                        return _2.startChild;
                    },
                    'call',
                    function(_3) {
                        return _3({
                            description: fn.name,
                            op: "middleware.express.".concat(method),
                            origin: 'auto.middleware.express'
                        });
                    }
                ]);
                fn.call(this, req, res, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _next;
                    (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        function(_4) {
                            return _4.end;
                        },
                        'call',
                        function(_5) {
                            return _5();
                        }
                    ]);
                    (_next = next).call.apply(_next, [
                        this
                    ].concat((0, $bOqL7._)(args)));
                });
            };
        case 4:
            return function(err, req, res, next) {
                var transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    function(_6) {
                        return _6.startChild;
                    },
                    'call',
                    function(_7) {
                        return _7({
                            description: fn.name,
                            op: "middleware.express.".concat(method),
                            origin: 'auto.middleware.express'
                        });
                    }
                ]);
                fn.call(this, err, req, res, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _next;
                    (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        function(_8) {
                            return _8.end;
                        },
                        'call',
                        function(_9) {
                            return _9();
                        }
                    ]);
                    (_next = next).call.apply(_next, [
                        this
                    ].concat((0, $bOqL7._)(args)));
                });
            };
        default:
            throw new Error("Express middleware takes 2-4 arguments. Got: ".concat(arity));
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $e85b14c45548e103$var$wrapMiddlewareArgs(args, method) {
    return args.map(function(arg) {
        if (typeof arg === 'function') return $e85b14c45548e103$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map(function(a) {
            if (typeof a === 'function') return $e85b14c45548e103$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $e85b14c45548e103$var$patchMiddleware(router, method) {
    var originalCallback = router[method];
    router[method] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _originalCallback;
        return (_originalCallback = originalCallback).call.apply(_originalCallback, [
            this
        ].concat((0, $bOqL7._)($e85b14c45548e103$var$wrapMiddlewareArgs(args, method))));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $e85b14c45548e103$var$instrumentMiddlewares(router) {
    var methods = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    methods.forEach(function(method) {
        return $e85b14c45548e103$var$patchMiddleware(router, method);
    });
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $e85b14c45548e103$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    var isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    var router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    var routerProto = Object.getPrototypeOf(router);
    var originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        var _getLayerRoutePathInfo = $e85b14c45548e103$var$getLayerRoutePathInfo(layer), layerRoutePath = _getLayerRoutePathInfo.layerRoutePath, isRegex = _getLayerRoutePathInfo.isRegex, isArray = _getLayerRoutePathInfo.isArray, numExtraSegments = _getLayerRoutePathInfo.numExtraSegments;
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        var partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = $e85b14c45548e103$export$ea5dbbfd8423c1fa(req.originalUrl, req._reconstructedRoute, layer.path) || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        var finalPartialRoute = partialRoute.split('/').filter(function(segment) {
            return segment.length > 0 && (isRegex || isArray || !segment.includes('*'));
        }).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += "/".concat(finalPartialRoute).concat(isRegex ? '/' : '');
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        var urlLength = (0, $0affd2066e6dc1d7$export$69dd85280a8d374c)((0, $0affd2066e6dc1d7$export$ce084c78234bd35)(req.originalUrl || '')) + numExtraSegments;
        var routeLength = (0, $0affd2066e6dc1d7$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $0affd2066e6dc1d7$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            var transaction = res.__sentry_transaction;
            var attributes = transaction && (0, $6hfta.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                var finalRoute = req._reconstructedRoute || '/';
                var _extractPathForTransaction = (0, $6mdMa._)((0, $e6ab72bf44164694$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }), 2), name = _extractPathForTransaction[0], source = _extractPathForTransaction[1];
                transaction.updateName(name);
                transaction.setAttribute((0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ var $e85b14c45548e103$export$bde9c19304d7dbd3 = function(path, regexp, keys) {
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        keys,
        'access',
        function(_10) {
            return _10[0];
        },
        'optionalAccess',
        function(_11) {
            return _11.offset;
        }
    ]) === undefined || (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        keys,
        'access',
        function(_12) {
            return _12[0];
        },
        'optionalAccess',
        function(_13) {
            return _13.offset;
        }
    ]) === null) return undefined;
    var orderedKeys = keys.sort(function(a, b) {
        return a.offset - b.offset;
    });
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    var pathRegex = new RegExp(regexp, "".concat(regexp.flags, "d"));
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ var execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ var _execResult_indices = (0, $8467c8bb08e2e11e$export$71511d61b312f219)(execResult.indices), paramIndices = _execResult_indices.slice(1);
    if (paramIndices.length !== orderedKeys.length) return undefined;
    var resultPath = path;
    var indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach(function(item, index) {
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            var _item = (0, $6mdMa._)(item, 2), startOffset = _item[0], endOffset = _item[1];
            /**
       * isolate part before param
       */ var substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ var replacement = ":".concat(orderedKeys[index].name);
            /**
       * isolate part after param
       */ var substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $e85b14c45548e103$var$getLayerRoutePathInfo(layer) {
    var lrp = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        layer,
        'access',
        function(_14) {
            return _14.route;
        },
        'optionalAccess',
        function(_15) {
            return _15.path;
        }
    ]);
    var isRegex = (0, $8lokx.isRegExp)(lrp);
    var isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        var _GLOBAL_OBJ_process_versions_node_split_map = (0, $6mdMa._)((0, $lVfPx.GLOBAL_OBJ).process.versions.node.split('.').map(Number), 1), major = _GLOBAL_OBJ_process_versions_node_split_map[0];
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = $e85b14c45548e103$export$bde9c19304d7dbd3(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    var numExtraSegments = isArray ? Math.max($e85b14c45548e103$var$getNumberOfArrayUrlSegments(lrp) - (0, $0affd2066e6dc1d7$export$69dd85280a8d374c)(layer.path || ''), 0) : 0;
    var layerRoutePath = $e85b14c45548e103$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $e85b14c45548e103$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce(function(accNumSegments, currentRoute) {
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $0affd2066e6dc1d7$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $e85b14c45548e103$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map(function(r) {
        return r.toString();
    }).join(',');
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function $e85b14c45548e103$export$ea5dbbfd8423c1fa(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    var normalizeURL = (0, $0affd2066e6dc1d7$export$ce084c78234bd35)(originalUrl || '');
    var originalUrlSplit = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        normalizeURL,
        'optionalAccess',
        function(_16) {
            return _16.split;
        },
        'call',
        function(_17) {
            return _17('/');
        },
        'access',
        function(_18) {
            return _18.filter;
        },
        'call',
        function(_19) {
            return _19(function(v) {
                return !!v;
            });
        }
    ]);
    var tempCounter = 0;
    var currentOffset = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        reconstructedRoute,
        'optionalAccess',
        function(_20) {
            return _20.split;
        },
        'call',
        function(_21) {
            return _21('/');
        },
        'access',
        function(_22) {
            return _22.filter;
        },
        'call',
        function(_23) {
            return _23(function(v) {
                return !!v;
            });
        },
        'access',
        function(_24) {
            return _24.length;
        }
    ]) || 0;
    var result = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
        layerPath,
        'optionalAccess',
        function(_25) {
            return _25.split;
        },
        'call',
        function(_26) {
            return _26('/');
        },
        'access',
        function(_27) {
            return _27.filter;
        },
        'call',
        function(_28) {
            return _28(function(segment) {
                if ((0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                    originalUrlSplit,
                    'optionalAccess',
                    function(_29) {
                        return _29[currentOffset + tempCounter];
                    }
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            });
        },
        'access',
        function(_30) {
            return _30.join;
        },
        'call',
        function(_31) {
            return _31('/');
        }
    ]);
    return result;
}


var $iNMpq = parcelRequire("iNMpq");
var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $bOqL7 = parcelRequire("bOqL7");

var $8yexE = parcelRequire("8yexE");
var $8lokx = parcelRequire("8lokx");
var $4qd5R = parcelRequire("4qd5R");
var $gVncj = parcelRequire("gVncj");


/** Tracing integration for graphql package */ var $f5d5ac6d09d14a43$export$b735d011553f1049 = /*#__PURE__*/ function() {
    "use strict";
    function GraphQL() {
        (0, $6WLcG._)(this, GraphQL);
        this.name = GraphQL.id;
    }
    (0, $dbIwN._)(GraphQL, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                return this._module = this._module || (0, $4qd5R.loadModule)('graphql/execution/execute.js');
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)(getCurrentHub)) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('GraphQL Integration was unable to require graphql/execution package.');
                    return;
                }
                (0, $8yexE.fill)(pkg, 'execute', function(orig) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _orig;
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = getCurrentHub().getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        // eslint-disable-next-line deprecation/deprecation
                        var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            parentSpan,
                            'optionalAccess',
                            function(_2) {
                                return _2.startChild;
                            },
                            'call',
                            function(_3) {
                                return _3({
                                    description: 'execute',
                                    op: 'graphql.execute',
                                    origin: 'auto.graphql.graphql'
                                });
                            }
                        ]);
                        // eslint-disable-next-line deprecation/deprecation
                        (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            scope,
                            'optionalAccess',
                            function(_4) {
                                return _4.setSpan;
                            },
                            'call',
                            function(_5) {
                                return _5(span);
                            }
                        ]);
                        var rv = (_orig = orig).call.apply(_orig, [
                            this
                        ].concat((0, $bOqL7._)(args)));
                        if ((0, $8lokx.isThenable)(rv)) return rv.then(function(res) {
                            (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                function(_6) {
                                    return _6.end;
                                },
                                'call',
                                function(_7) {
                                    return _7();
                                }
                            ]);
                            // eslint-disable-next-line deprecation/deprecation
                            (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                scope,
                                'optionalAccess',
                                function(_8) {
                                    return _8.setSpan;
                                },
                                'call',
                                function(_9) {
                                    return _9(parentSpan);
                                }
                            ]);
                            return res;
                        });
                        (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            function(_10) {
                                return _10.end;
                            },
                            'call',
                            function(_11) {
                                return _11();
                            }
                        ]);
                        // eslint-disable-next-line deprecation/deprecation
                        (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            scope,
                            'optionalAccess',
                            function(_12) {
                                return _12.setSpan;
                            },
                            'call',
                            function(_13) {
                                return _13(parentSpan);
                            }
                        ]);
                        return rv;
                    };
                });
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'GraphQL';
            }
        }
    ]);
    return GraphQL;
}();
$f5d5ac6d09d14a43$export$b735d011553f1049.__initStatic();


var $98rQ1 = parcelRequire("98rQ1");
var $lFTnW = parcelRequire("lFTnW");
var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $6mdMa = parcelRequire("6mdMa");

var $bOqL7 = parcelRequire("bOqL7");

var $2xTNA = parcelRequire("2xTNA");

var $8yexE = parcelRequire("8yexE");
var $8lokx = parcelRequire("8lokx");
var $4qd5R = parcelRequire("4qd5R");
var $gVncj = parcelRequire("gVncj");


// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
var $e0e24ec9ad6dfed2$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
var $e0e24ec9ad6dfed2$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function $e0e24ec9ad6dfed2$var$isCursor(maybeCursor) {
    return maybeCursor && (typeof maybeCursor === "undefined" ? "undefined" : (0, $2xTNA._)(maybeCursor)) === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ var $e0e24ec9ad6dfed2$export$968aa4360b02a334 = /*#__PURE__*/ function() {
    "use strict";
    function Mongo() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $6WLcG._)(this, Mongo);
        this.name = Mongo.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $e0e24ec9ad6dfed2$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    (0, $dbIwN._)(Mongo, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
                return this._module = this._module || (0, $4qd5R.loadModule)(moduleName);
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)(getCurrentHub)) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error("Mongo Integration was unable to require `".concat(moduleName, "` package."));
                    return;
                }
                this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
            }
        },
        {
            /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
            key: "_instrumentOperations",
            value: function _instrumentOperations(collection, operations, getCurrentHub) {
                var _this = this;
                operations.forEach(function(operation) {
                    return _this._patchOperation(collection, operation, getCurrentHub);
                });
            }
        },
        {
            /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
            key: "_patchOperation",
            value: function _patchOperation(collection, operation, getCurrentHub) {
                if (!(operation in collection.prototype)) return;
                var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
                (0, $8yexE.fill)(collection.prototype, operation, function(orig) {
                    return function() {
                        var _this = this;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _orig;
                        var lastArg = args[args.length - 1];
                        // eslint-disable-next-line deprecation/deprecation
                        var hub = getCurrentHub();
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = hub.getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var client = hub.getClient();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        var sendDefaultPii = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            client,
                            'optionalAccess',
                            function(_2) {
                                return _2.getOptions;
                            },
                            'call',
                            function(_3) {
                                return _3();
                            },
                            'access',
                            function(_4) {
                                return _4.sendDefaultPii;
                            }
                        ]);
                        // Check if the operation was passed a callback. (mapReduce requires a different check, as
                        // its (non-callback) arguments can also be functions.)
                        if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                            var _orig1;
                            // eslint-disable-next-line deprecation/deprecation
                            var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                parentSpan,
                                'optionalAccess',
                                function(_5) {
                                    return _5.startChild;
                                },
                                'call',
                                function(_6) {
                                    return _6(getSpanContext(_this, operation, args, sendDefaultPii));
                                }
                            ]);
                            var maybePromiseOrCursor = (_orig1 = orig).call.apply(_orig1, [
                                this
                            ].concat((0, $bOqL7._)(args)));
                            if ((0, $8lokx.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then(function(res) {
                                (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                    span,
                                    'optionalAccess',
                                    function(_7) {
                                        return _7.end;
                                    },
                                    'call',
                                    function(_8) {
                                        return _8();
                                    }
                                ]);
                                return res;
                            });
                            else if ($e0e24ec9ad6dfed2$var$isCursor(maybePromiseOrCursor)) {
                                var cursor = maybePromiseOrCursor;
                                try {
                                    cursor.once('close', function() {
                                        (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                            span,
                                            'optionalAccess',
                                            function(_9) {
                                                return _9.end;
                                            },
                                            'call',
                                            function(_10) {
                                                return _10();
                                            }
                                        ]);
                                    });
                                } catch (e) {
                                    // If the cursor is already closed, `once` will throw an error. In that case, we can
                                    // finish the span immediately.
                                    (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                        span,
                                        'optionalAccess',
                                        function(_11) {
                                            return _11.end;
                                        },
                                        'call',
                                        function(_12) {
                                            return _12();
                                        }
                                    ]);
                                }
                                return cursor;
                            } else {
                                (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                    span,
                                    'optionalAccess',
                                    function(_13) {
                                        return _13.end;
                                    },
                                    'call',
                                    function(_14) {
                                        return _14();
                                    }
                                ]);
                                return maybePromiseOrCursor;
                            }
                        }
                        // eslint-disable-next-line deprecation/deprecation
                        var span1 = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            parentSpan,
                            'optionalAccess',
                            function(_15) {
                                return _15.startChild;
                            },
                            'call',
                            function(_16) {
                                return _16(getSpanContext(_this, operation, args.slice(0, -1)));
                            }
                        ]);
                        return (_orig = orig).call.apply(_orig, [
                            this
                        ].concat((0, $bOqL7._)(args.slice(0, -1)), [
                            function(err, result) {
                                (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                    span1,
                                    'optionalAccess',
                                    function(_17) {
                                        return _17.end;
                                    },
                                    'call',
                                    function(_18) {
                                        return _18();
                                    }
                                ]);
                                lastArg(err, result);
                            }
                        ]));
                    };
                });
            }
        },
        {
            /**
   * Form a SpanContext based on the user input to a given operation.
   */ key: "_getSpanContextFromOperationArguments",
            value: function _getSpanContextFromOperationArguments(collection, operation, args) {
                var sendDefaultPii = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var data = {
                    'db.system': 'mongodb',
                    'db.name': collection.dbName,
                    'db.operation': operation,
                    'db.mongodb.collection': collection.collectionName
                };
                var spanContext = {
                    op: 'db',
                    // TODO v8: Use `${collection.collectionName}.${operation}`
                    origin: 'auto.db.mongo',
                    description: operation,
                    data: data
                };
                // If the operation takes no arguments besides `options` and `callback`, or if argument
                // collection is disabled for this operation, just return early.
                var signature = $e0e24ec9ad6dfed2$var$OPERATION_SIGNATURES[operation];
                var shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
                if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
                try {
                    // Special case for `mapReduce`, as the only one accepting functions as arguments.
                    if (operation === 'mapReduce') {
                        var _args = (0, $6mdMa._)(args, 2), map = _args[0], reduce = _args[1];
                        data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                        data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
                    } else for(var i = 0; i < signature.length; i++)data["db.mongodb.".concat(signature[i])] = JSON.stringify(args[i]);
                } catch (_oO) {
                // no-empty
                }
                return spanContext;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Mongo';
            }
        }
    ]);
    return Mongo;
}();
$e0e24ec9ad6dfed2$export$968aa4360b02a334.__initStatic();


var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8yexE = parcelRequire("8yexE");
var $4qd5R = parcelRequire("4qd5R");
var $gVncj = parcelRequire("gVncj");


/** Tracing integration for node-mysql package */ var $d833ce166a837fc1$export$a2cc26ff91a3f8ad = /*#__PURE__*/ function() {
    "use strict";
    function Mysql() {
        (0, $6WLcG._)(this, Mysql);
        this.name = Mysql.id;
    }
    (0, $dbIwN._)(Mysql, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                return this._module = this._module || (0, $4qd5R.loadModule)('mysql/lib/Connection.js');
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)(getCurrentHub)) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('Mysql Integration was unable to require `mysql` package.');
                    return;
                }
                var mySqlConfig = undefined;
                try {
                    pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                        apply: function(wrappingTarget, thisArg, args) {
                            if (!mySqlConfig) mySqlConfig = thisArg.config;
                            return wrappingTarget.apply(thisArg, args);
                        }
                    });
                } catch (e) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('Mysql Integration was unable to instrument `mysql` config.');
                }
                function spanDataFromConfig() {
                    if (!mySqlConfig) return {};
                    return {
                        'server.address': mySqlConfig.host,
                        'server.port': mySqlConfig.port,
                        'db.user': mySqlConfig.user
                    };
                }
                function finishSpan(span) {
                    if (!span) return;
                    var data = spanDataFromConfig();
                    Object.keys(data).forEach(function(key) {
                        span.setAttribute(key, data[key]);
                    });
                    span.end();
                }
                // The original function will have one of these signatures:
                //    function (callback) => void
                //    function (options, callback) => void
                //    function (options, values, callback) => void
                (0, $8yexE.fill)(pkg, 'createQuery', function(orig) {
                    return function(options, values, callback) {
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = getCurrentHub().getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        // eslint-disable-next-line deprecation/deprecation
                        var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            parentSpan,
                            'optionalAccess',
                            function(_2) {
                                return _2.startChild;
                            },
                            'call',
                            function(_3) {
                                return _3({
                                    description: typeof options === 'string' ? options : options.sql,
                                    op: 'db',
                                    origin: 'auto.db.mysql',
                                    data: {
                                        'db.system': 'mysql'
                                    }
                                });
                            }
                        ]);
                        if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                            finishSpan(span);
                            callback(err, result, fields);
                        });
                        if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                            finishSpan(span);
                            values(err, result, fields);
                        });
                        // streaming, no callback!
                        var query = orig.call(this, options, values);
                        query.on('end', function() {
                            finishSpan(span);
                        });
                        return query;
                    };
                });
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Mysql';
            }
        }
    ]);
    return Mysql;
}();
$d833ce166a837fc1$export$a2cc26ff91a3f8ad.__initStatic();


var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8yexE = parcelRequire("8yexE");
var $8lokx = parcelRequire("8lokx");
var $4qd5R = parcelRequire("4qd5R");
var $gVncj = parcelRequire("gVncj");


/** Tracing integration for node-postgres package */ var $90687bd56e3590e3$export$806ddb599177abc4 = /*#__PURE__*/ function() {
    "use strict";
    function Postgres() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $6WLcG._)(this, Postgres);
        this.name = Postgres.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    (0, $dbIwN._)(Postgres, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                return this._module = this._module || (0, $4qd5R.loadModule)('pg');
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)(getCurrentHub)) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error('Postgres Integration was unable to require `pg` package.');
                    return;
                }
                var Client = this._usePgNative ? (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                    pkg,
                    'access',
                    function(_2) {
                        return _2["native"];
                    },
                    'optionalAccess',
                    function(_3) {
                        return _3.Client;
                    }
                ]) : pkg.Client;
                if (!Client) {
                    (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
                    return;
                }
                /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $8yexE.fill)(Client.prototype, 'query', function(orig) {
                    return function(config, values, callback) {
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = getCurrentHub().getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        var data = {
                            'db.system': 'postgresql'
                        };
                        try {
                            if (this.database) data['db.name'] = this.database;
                            if (this.host) data['server.address'] = this.host;
                            if (this.port) data['server.port'] = this.port;
                            if (this.user) data['db.user'] = this.user;
                        } catch (e) {
                        // ignore
                        }
                        // eslint-disable-next-line deprecation/deprecation
                        var span = (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            parentSpan,
                            'optionalAccess',
                            function(_4) {
                                return _4.startChild;
                            },
                            'call',
                            function(_5) {
                                return _5({
                                    description: typeof config === 'string' ? config : config.text,
                                    op: 'db',
                                    origin: 'auto.db.postgres',
                                    data: data
                                });
                            }
                        ]);
                        if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                            (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                function(_6) {
                                    return _6.end;
                                },
                                'call',
                                function(_7) {
                                    return _7();
                                }
                            ]);
                            callback(err, result);
                        });
                        if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                            (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                function(_8) {
                                    return _8.end;
                                },
                                'call',
                                function(_9) {
                                    return _9();
                                }
                            ]);
                            values(err, result);
                        });
                        var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                        if ((0, $8lokx.isThenable)(rv)) return rv.then(function(res) {
                            (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                function(_10) {
                                    return _10.end;
                                },
                                'call',
                                function(_11) {
                                    return _11();
                                }
                            ]);
                            return res;
                        });
                        (0, $48d0b7bcf46634af$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            function(_12) {
                                return _12.end;
                            },
                            'call',
                            function(_13) {
                                return _13();
                            }
                        ]);
                        return rv;
                    };
                });
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Postgres';
            }
        }
    ]);
    return Postgres;
}();
$90687bd56e3590e3$export$806ddb599177abc4.__initStatic();


var $6WLcG = parcelRequire("6WLcG");

var $dbIwN = parcelRequire("dbIwN");

var $8c6ug = parcelRequire("8c6ug");

var $hRCmZ = parcelRequire("hRCmZ");

var $7XD9P = parcelRequire("7XD9P");

var $8fOd9 = parcelRequire("8fOd9");
var $fkG29 = parcelRequire("fkG29");
var $jWdUe = parcelRequire("jWdUe");

var $8yexE = parcelRequire("8yexE");
var $gVncj = parcelRequire("gVncj");


function $f5ad22c7de4f9a9c$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ var $f5ad22c7de4f9a9c$export$e300e6f4779d55c2 = /*#__PURE__*/ function() {
    "use strict";
    function Prisma() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $6WLcG._)(this, Prisma);
        this.name = Prisma.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($f5ad22c7de4f9a9c$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $8yexE.addNonEnumerableProperty)(options.client, '_sentryInstrumented', true);
            var clientData = {};
            try {
                var engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    var activeProvider = engineConfig.activeProvider, clientVersion = engineConfig.clientVersion;
                    if (activeProvider) clientData['db.system'] = activeProvider;
                    if (clientVersion) clientData['db.prisma.version'] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use(function(params, next) {
                // eslint-disable-next-line deprecation/deprecation
                if ((0, $6807e3fed073e703$export$34db76d03eb96b7e)((0, $8fOd9.getCurrentHub))) return next(params);
                var action = params.action;
                var model = params.model;
                return (0, $jWdUe.startSpan)({
                    name: model ? "".concat(model, " ").concat(action) : action,
                    onlyIfParent: true,
                    op: 'db.prisma',
                    attributes: (0, $8c6ug._)({}, (0, $fkG29.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.db.prisma'),
                    data: (0, $7XD9P._)((0, $hRCmZ._)({}, clientData), {
                        'db.operation': action
                    })
                }, function() {
                    return next(params);
                });
            });
        } else (0, $e222f13986d11a38$export$16a28057038b10ef) && (0, $gVncj.logger).warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:', options.client);
    }
    (0, $dbIwN._)(Prisma, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce() {
            // Noop - here for backwards compatibility
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Prisma';
            }
        }
    ]);
    return Prisma;
}();
$f5ad22c7de4f9a9c$export$e300e6f4779d55c2.__initStatic();


var $bCb3d = parcelRequire("bCb3d");
var $bpf5e = parcelRequire("bpf5e");
var $58WN1 = parcelRequire("58WN1");
var $iAzzt = parcelRequire("iAzzt");
var $lNNKl = parcelRequire("lNNKl");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
var $9f74ec7c3c1c449b$export$46d3bbd0375f5fa4 = (0, $9407b60e82efdc8d$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ var $9f74ec7c3c1c449b$export$5a20b45239a3c0a6 = (0, $2nPTC.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
var $9f74ec7c3c1c449b$export$a7feb32fdd923295 = (0, $iNMpq.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
var $9f74ec7c3c1c449b$export$8e9a29865c0a1226 = (0, $iNMpq.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
var $9f74ec7c3c1c449b$export$ac65c70d78fcdb55 = (0, $bpf5e.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ var $9f74ec7c3c1c449b$export$febc5573c75cefb0 = (0, $lNNKl.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ var $9f74ec7c3c1c449b$export$5f1714a13ed34c01 = (0, $bCb3d.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ var $9f74ec7c3c1c449b$export$bbd2089f30bd3708 = (0, $9407b60e82efdc8d$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ var $9f74ec7c3c1c449b$export$cc17fb3c0bc95cd7 = (0, $fd5c2379c07d88a5$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ var $9f74ec7c3c1c449b$export$5008da00b1b6dee6 = (0, $98rQ1.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ var $9f74ec7c3c1c449b$export$ce084c78234bd35 = (0, $0affd2066e6dc1d7$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ var $9f74ec7c3c1c449b$export$394a210812ba3012 = (0, $iAzzt.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ var $9f74ec7c3c1c449b$export$b279e6bd7040371f = (0, $lFTnW.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ var $9f74ec7c3c1c449b$export$864489cb3478db3e = (0, $fd5c2379c07d88a5$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ var $9f74ec7c3c1c449b$export$479dbd817e392a4f = (0, $58WN1.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
var $9f74ec7c3c1c449b$export$beb8e6a823e89c5d = (0, $bpf5e.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
var $9f74ec7c3c1c449b$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $9f74ec7c3c1c449b$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $d0bef5af7f0d161a$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $e85b14c45548e103$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $f5d5ac6d09d14a43$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $e0e24ec9ad6dfed2$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $d833ce166a837fc1$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $90687bd56e3590e3$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $f5ad22c7de4f9a9c$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $2nPTC.addExtensionMethods)();



var $96fb62867752e538$exports = {};
$96fb62867752e538$exports = JSON.parse("{\"name\":\"my.mojo.ui\",\"version\":\"1.0.0\",\"scripts\":{\"start\":\"npm run dev\",\"start:ci\":\"cross-env NODE_ENV=development parcel serve ./src/index.html --no-cache &\",\"dev\":\"cross-env NODE_ENV=development parcel serve ./src/index.html\",\"dev-no-cache\":\"cross-env NODE_ENV=development parcel serve ./src/index.html --no-cache\",\"local-no-cache\":\"cross-env NODE_ENV=local parcel serve ./src/index.html --no-cache\",\"build-test\":\"cross-env NODE_ENV=test-env parcel build ./src/index.html\",\"build-prod\":\"cross-env NODE_ENV=production parcel build ./src/index.html\",\"test\":\"vitest\",\"eslint:check\":\"eslint --max-warnings 260\",\"eslint:fix\":\"eslint --fix\",\"prettier:check\":\"prettier --check \\\"./**/*.{ts,tsx}\\\" --ignore-path .gitignore\",\"prettier:fix\":\"prettier --write \\\"./**/*.{js,jsx,ts,tsx}\\\" --ignore-path .gitignore\",\"knip\":\"knip\",\"prepare\":\"husky install\"},\"dependencies\":{\"@fortawesome/fontawesome-svg-core\":\"^1.2.35\",\"@fortawesome/free-solid-svg-icons\":\"^5.15.3\",\"@fortawesome/react-fontawesome\":\"^0.1.14\",\"@microsoft/clarity\":\"^1.0.0\",\"@radix-ui/react-popover\":\"^1.0.2\",\"@react-spring/web\":\"^9.6.1\",\"@sentry/browser\":\"^7.1.1\",\"@sentry/tracing\":\"^7.1.1\",\"axios\":\"^0.34.0\",\"date-fns\":\"^4.1.0\",\"dayjs\":\"^1.10.4\",\"deepmerge\":\"^4.2.2\",\"email-validator\":\"^2.0.4\",\"fast-clone\":\"^1.5.13\",\"filestack-react\":\"5.0.0\",\"js-cookie\":\"^3.0.7\",\"jwt-decode\":\"^3.1.2\",\"keyboardjs\":\"^2.6.4\",\"mojo-storybook-v2-library\":\"git@github.com:mojomortgages/mojo.storybook.v2.library.git\",\"polished\":\"^4.1.2\",\"prop-types\":\"^15.8.1\",\"pure-react-carousel\":\"^1.35.0\",\"react\":\"^18.3.1\",\"react-device-detect\":\"^2.1.2\",\"react-dom\":\"^18.3.1\",\"react-error-boundary\":\"^3.1.3\",\"react-ga4\":\"^2.1.0\",\"react-helmet\":\"^6.1.0\",\"react-hooks-visible\":\"^1.1.1\",\"react-hot-toast\":\"^2.4.0\",\"react-is\":\"^17.0.2\",\"react-number-format\":\"5.4.5\",\"react-router-dom\":\"^5.2.0\",\"recoil\":\"^0.7.7\",\"smartlook-client\":\"^6.0.0\",\"smooth-scroll-into-view-if-needed\":\"^1.1.32\",\"styled-components\":\"^5.3.11\",\"styled-normalize\":\"^8.1.1\",\"swr\":\"^2.0.0\",\"uuid\":\"^11.1.1\"},\"devDependencies\":{\"@babel/preset-env\":\"^7.16.11\",\"@babel/preset-react\":\"^7.16.7\",\"@babel/preset-typescript\":\"^7.16.7\",\"@eslint/eslintrc\":\"^3.3.4\",\"@eslint/js\":\"9.39.3\",\"@parcel/transformer-babel\":\"^2.8.3\",\"@parcel/transformer-image\":\"^2.0.0\",\"@parcel/transformer-svg-react\":\"^2.5.0\",\"@testing-library/jest-dom\":\"^5.16.5\",\"@testing-library/react\":\"^13.4.0\",\"@testing-library/user-event\":\"^14.4.3\",\"@types/deepmerge\":\"^2.2.0\",\"@types/intercom-web\":\"^2.8.13\",\"@types/keyboardjs\":\"^2.5.0\",\"@types/mixpanel-browser\":\"^2.35.7\",\"@types/node\":\"^20.14.11\",\"@types/react\":\"^18.3.31\",\"@types/react-dom\":\"^18.3.7\",\"@types/react-router-dom\":\"^5.1.7\",\"@types/sinon\":\"^21.0.0\",\"@types/styled-components\":\"^5.1.35\",\"@types/uuid\":\"^10.0.0\",\"@typescript-eslint/eslint-plugin\":\"^8.56.1\",\"@typescript-eslint/parser\":\"^8.56.1\",\"babel-loader\":\"^8.2.5\",\"babel-plugin-styled-components\":\"^2.3.0\",\"buffer\":\"^5.7.1\",\"cross-env\":\"^7.0.3\",\"eslint\":\"9.26.0\",\"husky\":\"^8.0.1\",\"jest-transform-stub\":\"^2.0.0\",\"jsdom\":\"^26.1.0\",\"knip\":\"^5.26.0\",\"lint-staged\":\"^13.0.3\",\"msw\":\"^2.12.2\",\"parcel\":\"^2.5.0\",\"prettier\":\"^2.8.4\",\"process\":\"^0.11.10\",\"react-test-renderer\":\"^18.3.1\",\"svgo\":\"2.5.0\",\"tsconfig-paths-webpack-plugin\":\"^4.0.0\",\"typescript\":\"^5.5.3\",\"vite\":\"^6.3.5\",\"vitest\":\"^3.2.4\"},\"alias\":{\"state\":\"./src/State.ts\",\"logging\":\"./src/Logging.tsx\",\"hooks\":\"./src/hooks\",\"lib\":\"./src/lib\",\"models\":\"./src/models\",\"components\":\"./src/components\",\"styles\":\"./src/styles\",\"reducers\":\"./src/reducers\",\"templates\":\"./src/templates\",\"pages\":\"./src/pages\",\"assets\":\"./src/assets\",\"experiments\":\"./src/experiments\",\"contexts\":\"./src/contexts\",\"testing\":\"./src/testing\"},\"browserslist\":[\"last 4 versions\"],\"lint-staged\":{\"*.{ts,tsx,js,jsx}\":[\"eslint --fix\",\"prettier --write\"]},\"overrides\":{\"react-refresh\":\"0.9.0\"},\"prettier\":{\"endOfLine\":\"lf\",\"semi\":false,\"printWidth\":100},\"engines\":{\"node\":\"24\"}}");


var $875f5b2bfff8bc0b$export$2e2bcd8739ae039 = function() {
    if (0, $10b47c5a212e87a0$export$3fce19fdf0c5de73) {
        console.log("Sentry is disabled because you're in development.");
        return;
    }
    $890d7aa8a748a82b$export$2cd8252107eb640b({
        dsn: (0, $10b47c5a212e87a0$export$6faa4a850bc4d0ce),
        release: "".concat((0, $10b47c5a212e87a0$export$5b6c28c7dca07ad7), "@").concat((0, $96fb62867752e538$exports.version)),
        integrations: [
            new (0, $9f74ec7c3c1c449b$export$46d3bbd0375f5fa4)()
        ],
        tracesSampleRate: 0.01,
        debug: (0, $10b47c5a212e87a0$export$3fce19fdf0c5de73),
        environment: (0, $10b47c5a212e87a0$export$6377864d12f7eeb3)
    });
};


(0, $875f5b2bfff8bc0b$export$2e2bcd8739ae039)();
var $59aadbd806e4c33b$var$root = (0, $88d935799dd4b02e$export$882461b6382ed46c)(document.getElementById("root"));
$59aadbd806e4c33b$var$root.render(/*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $5f1303bfb7cae0ef$export$2e2bcd8739ae039), {
    children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $d7ce42c300073b00$export$f72b9f9819639629), {
        children: /*#__PURE__*/ (0, $3d45074523d8f6b3$exports.jsx)((0, $f5ee9e9c2ddafab3$export$2e2bcd8739ae039), {})
    })
}));

})();
//# sourceMappingURL=my.mojo.ui.85f00e0d.js.map
